(function(){var d;window.AmCharts?d=window.AmCharts:(d={},window.AmCharts=d,d.themes={},d.maps={},d.inheriting={},d.charts=[],d.onReadyArray=[],d.useUTC=!1,d.updateRate=60,d.uid=0,d.lang={},d.translations={},d.mapTranslations={},d.windows={},d.initHandlers=[],d.amString="am",d.pmString="pm");d.Class=function(a){var b=function(){arguments[0]!==d.inheriting&&(this.events={},this.construct.apply(this,arguments))};a.inherits?(b.prototype=new a.inherits(d.inheriting),b.base=a.inherits.prototype,delete a.inherits):
(b.prototype.createEvents=function(){for(var a=0;a<arguments.length;a++)this.events[arguments[a]]=[]},b.prototype.listenTo=function(a,b,c){this.removeListener(a,b,c);a.events[b].push({handler:c,scope:this})},b.prototype.addListener=function(a,b,c){this.removeListener(this,a,b);a&&this.events[a]&&this.events[a].push({handler:b,scope:c})},b.prototype.removeListener=function(a,b,c){if(a&&a.events&&(a=a.events[b]))for(b=a.length-1;0<=b;b--)a[b].handler===c&&a.splice(b,1)},b.prototype.fire=function(a){for(var b=
this.events[a.type],c=0;c<b.length;c++){var d=b[c];d.handler.call(d.scope,a)}});for(var c in a)b.prototype[c]=a[c];return b};d.addChart=function(a){window.requestAnimationFrame?d.animationRequested||(d.animationRequested=!0,window.requestAnimationFrame(d.update)):d.updateInt||(d.updateInt=setInterval(function(){d.update()},Math.round(1E3/d.updateRate)));d.charts.push(a)};d.removeChart=function(a){for(var b=d.charts,c=b.length-1;0<=c;c--)b[c]==a&&b.splice(c,1);0===b.length&&(d.requestAnimation&&(window.cancelAnimationFrame(d.requestAnimation),
d.animationRequested=!1),d.updateInt&&(clearInterval(d.updateInt),d.updateInt=NaN))};d.isModern=!0;d.getIEVersion=function(){var a=0,b,c;"Microsoft Internet Explorer"==navigator.appName&&(b=navigator.userAgent,c=/MSIE ([0-9]{1,}[.0-9]{0,})/,null!==c.exec(b)&&(a=parseFloat(RegExp.$1)));return a};d.applyLang=function(a,b){var c=d.translations;b.dayNames=d.extend({},d.dayNames);b.shortDayNames=d.extend({},d.shortDayNames);b.monthNames=d.extend({},d.monthNames);b.shortMonthNames=d.extend({},d.shortMonthNames);
b.amString="am";b.pmString="pm";c&&(c=c[a])&&(d.lang=c,b.langObj=c,c.monthNames&&(b.dayNames=d.extend({},c.dayNames),b.shortDayNames=d.extend({},c.shortDayNames),b.monthNames=d.extend({},c.monthNames),b.shortMonthNames=d.extend({},c.shortMonthNames)),c.am&&(b.amString=c.am),c.pm&&(b.pmString=c.pm));d.amString=b.amString;d.pmString=b.pmString};d.IEversion=d.getIEVersion();9>d.IEversion&&0<d.IEversion&&(d.isModern=!1,d.isIE=!0);d.dx=0;d.dy=0;if(document.addEventListener||window.opera)d.isNN=!0,d.isIE=
!1,d.dx=.5,d.dy=.5;document.attachEvent&&(d.isNN=!1,d.isIE=!0,d.isModern||(d.dx=0,d.dy=0));window.chrome&&(d.chrome=!0);d.handleMouseUp=function(a){for(var b=d.charts,c=0;c<b.length;c++){var e=b[c];e&&e.handleReleaseOutside&&e.handleReleaseOutside(a)}};d.handleMouseMove=function(a){for(var b=d.charts,c=0;c<b.length;c++){var e=b[c];e&&e.handleMouseMove&&e.handleMouseMove(a)}};d.handleWheel=function(a){for(var b=d.charts,c=0;c<b.length;c++){var e=b[c];if(e&&e.mouseIsOver){(e.mouseWheelScrollEnabled||
e.mouseWheelZoomEnabled)&&e.handleWheel&&e.handleWheel(a);break}}};d.resetMouseOver=function(){for(var a=d.charts,b=0;b<a.length;b++){var c=a[b];c&&(c.mouseIsOver=!1)}};d.ready=function(a){d.onReadyArray.push(a)};d.handleLoad=function(){d.isReady=!0;for(var a=d.onReadyArray,b=0;b<a.length;b++){var c=a[b];isNaN(d.processDelay)?c():setTimeout(c,d.processDelay*b)}d.onReadyArray=[]};d.addInitHandler=function(a,b){d.initHandlers.push({method:a,types:b})};d.callInitHandler=function(a){var b=d.initHandlers;
if(d.initHandlers)for(var c=0;c<b.length;c++){var e=b[c];e.types?d.isInArray(e.types,a.type)&&e.method(a):e.method(a)}};d.getUniqueId=function(){d.uid++;return"AmChartsEl-"+d.uid};d.isNN&&(document.addEventListener("mousemove",d.handleMouseMove),document.addEventListener("mouseup",d.handleMouseUp,!0),window.addEventListener("load",d.handleLoad,!0));d.isIE&&(document.attachEvent("onmousemove",d.handleMouseMove),document.attachEvent("onmouseup",d.handleMouseUp),window.attachEvent("onload",d.handleLoad));
d.addWheelListeners=function(){d.wheelIsListened||(d.isNN&&(window.addEventListener("DOMMouseScroll",d.handleWheel,!0),document.addEventListener("mousewheel",d.handleWheel,!0)),d.isIE&&document.attachEvent("onmousewheel",d.handleWheel));d.wheelIsListened=!0};d.clear=function(){var a=d.charts;if(a)for(var b=a.length-1;0<=b;b--)a[b].clear();d.updateInt&&clearInterval(d.updateInt);d.requestAnimation&&window.cancelAnimationFrame(d.requestAnimation);d.charts=[];d.isNN&&(document.removeEventListener("mousemove",
d.handleMouseMove,!0),document.removeEventListener("mouseup",d.handleMouseUp,!0),window.removeEventListener("load",d.handleLoad,!0),window.removeEventListener("DOMMouseScroll",d.handleWheel,!0),document.removeEventListener("mousewheel",d.handleWheel,!0));d.isIE&&(document.detachEvent("onmousemove",d.handleMouseMove),document.detachEvent("onmouseup",d.handleMouseUp),window.detachEvent("onload",d.handleLoad))};d.makeChart=function(a,b,c){var e=b.type,h=b.theme;d.isString(h)&&(h=d.themes[h],b.theme=
h);var f;switch(e){case "serial":f=new d.AmSerialChart(h);break;case "xy":f=new d.AmXYChart(h);break;case "pie":f=new d.AmPieChart(h);break;case "radar":f=new d.AmRadarChart(h);break;case "gauge":f=new d.AmAngularGauge(h);break;case "funnel":f=new d.AmFunnelChart(h);break;case "map":f=new d.AmMap(h);break;case "stock":f=new d.AmStockChart(h);break;case "gantt":f=new d.AmGanttChart(h)}d.extend(f,b);d.isReady?isNaN(c)?f.write(a):setTimeout(function(){d.realWrite(f,a)},c):d.ready(function(){isNaN(c)?
f.write(a):setTimeout(function(){d.realWrite(f,a)},c)});return f};d.realWrite=function(a,b){a.write(b)};d.updateCount=0;d.validateAt=Math.round(d.updateRate/10);d.update=function(){var a=d.charts;d.updateCount++;var b=!1;d.updateCount==d.validateAt&&(b=!0,d.updateCount=0);if(a)for(var c=a.length-1;0<=c;c--)a[c].update&&a[c].update(),b&&(a[c].autoResize?a[c].validateSize&&a[c].validateSize():a[c].premeasure&&a[c].premeasure());window.requestAnimationFrame&&(d.requestAnimation=window.requestAnimationFrame(d.update))};
"complete"==document.readyState&&d.handleLoad()})();(function(){var d=window.AmCharts;d.toBoolean=function(a,b){if(void 0===a)return b;switch(String(a).toLowerCase()){case "true":case "yes":case "1":return!0;case "false":case "no":case "0":case null:return!1;default:return!!a}};d.removeFromArray=function(a,b){var c;if(void 0!==b&&void 0!==a)for(c=a.length-1;0<=c;c--)a[c]==b&&a.splice(c,1)};d.getPath=function(){var a=document.getElementsByTagName("script");if(a)for(var b=0;b<a.length;b++){var c=a[b].src;if(-1!==c.search(/\/(amcharts|ammap)\.js/))return c.replace(/\/(amcharts|ammap)\.js.*/,
"/")}};d.normalizeUrl=function(a){return""!==a&&-1===a.search(/\/$/)?a+"/":a};d.isAbsolute=function(a){return 0===a.search(/^http[s]?:|^\//)};d.isInArray=function(a,b){for(var c=0;c<a.length;c++)if(a[c]==b)return!0;return!1};d.getDecimals=function(a){var b=0;isNaN(a)||(a=String(a),-1!=a.indexOf("e-")?b=Number(a.split("-")[1]):-1!=a.indexOf(".")&&(b=a.split(".")[1].length));return b};d.wordwrap=function(a,b,c,e){var h,f,g,k;a+="";if(1>b)return a;h=-1;for(a=(k=a.split(/\r\n|\n|\r/)).length;++h<a;k[h]+=
g){g=k[h];for(k[h]="";g.length>b;k[h]+=d.trim(g.slice(0,f))+((g=g.slice(f)).length?c:""))f=2==e||(f=g.slice(0,b+1).match(/\S*(\s)?$/))[1]?b:f.input.length-f[0].length||1==e&&b||f.input.length+(f=g.slice(b).match(/^\S*/))[0].length;g=d.trim(g)}return k.join(c)};d.trim=function(a){return a.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g,"")};d.wrappedText=function(a,b,c,e,h,f,g,k){var l=d.text(a,b,c,e,h,f,g);if(l){var m=l.getBBox();if(m.width>k){var p="\n";d.isModern||(p="<br>");k=Math.floor(k/(m.width/
b.length));2<k&&(k-=2);b=d.wordwrap(b,k,p,!0);l.remove();l=d.text(a,b,c,e,h,f,g)}}return l};d.getStyle=function(a,b){var c="";if(document.defaultView&&document.defaultView.getComputedStyle)try{c=document.defaultView.getComputedStyle(a,"").getPropertyValue(b)}catch(e){}else a.currentStyle&&(b=b.replace(/\-(\w)/g,function(a,b){return b.toUpperCase()}),c=a.currentStyle[b]);return c};d.removePx=function(a){if(void 0!==a)return Number(a.substring(0,a.length-2))};d.getURL=function(a,b){if(a)if("_self"!=
b&&b)if("_top"==b&&window.top)window.top.location.href=a;else if("_parent"==b&&window.parent)window.parent.location.href=a;else if("_blank"==b)window.open(a);else{var c=document.getElementsByName(b)[0];c?c.src=a:(c=d.windows[b])?c.opener&&!c.opener.closed?c.location.href=a:d.windows[b]=window.open(a):d.windows[b]=window.open(a)}else window.location.href=a};d.ifArray=function(a){return a&&"object"==typeof a&&0<a.length?!0:!1};d.callMethod=function(a,b){var c;for(c=0;c<b.length;c++){var e=b[c];if(e){if(e[a])e[a]();
var d=e.length;if(0<d){var f;for(f=0;f<d;f++){var g=e[f];if(g&&g[a])g[a]()}}}}};d.toNumber=function(a){return"number"==typeof a?a:Number(String(a).replace(/[^0-9\-.]+/g,""))};d.toColor=function(a){if(""!==a&&void 0!==a)if(-1!=a.indexOf(",")){a=a.split(",");var b;for(b=0;b<a.length;b++){var c=a[b].substring(a[b].length-6,a[b].length);a[b]="#"+c}}else a=a.substring(a.length-6,a.length),a="#"+a;return a};d.toCoordinate=function(a,b,c){var e;void 0!==a&&(a=String(a),c&&c<b&&(b=c),e=Number(a),-1!=a.indexOf("!")&&
(e=b-Number(a.substr(1))),-1!=a.indexOf("%")&&(e=b*Number(a.substr(0,a.length-1))/100));return e};d.fitToBounds=function(a,b,c){a<b&&(a=b);a>c&&(a=c);return a};d.isDefined=function(a){return void 0===a?!1:!0};d.stripNumbers=function(a){return a.replace(/[0-9]+/g,"")};d.roundTo=function(a,b){if(0>b)return a;var c=Math.pow(10,b);return Math.round(a*c)/c};d.toFixed=function(a,b){var c=!1;0>a&&(c=!0,a=Math.abs(a));var e=String(Math.round(a*Math.pow(10,b)));if(0<b){var d=e.length;if(d<b){var f;for(f=0;f<
b-d;f++)e="0"+e}d=e.substring(0,e.length-b);""===d&&(d=0);e=d+"."+e.substring(e.length-b,e.length);return c?"-"+e:e}return String(e)};d.formatDuration=function(a,b,c,e,h,f){var g=d.intervals,k=f.decimalSeparator;if(a>=g[b].contains){var l=a-Math.floor(a/g[b].contains)*g[b].contains;"ss"==b?(l=d.formatNumber(l,f),1==l.split(k)[0].length&&(l="0"+l)):l=d.roundTo(l,f.precision);("mm"==b||"hh"==b)&&10>l&&(l="0"+l);c=l+""+e[b]+""+c;a=Math.floor(a/g[b].contains);b=g[b].nextInterval;return d.formatDuration(a,
b,c,e,h,f)}"ss"==b&&(a=d.formatNumber(a,f),1==a.split(k)[0].length&&(a="0"+a));"mm"==b&&(a=d.roundTo(a,f.precision));("mm"==b||"hh"==b)&&10>a&&(a="0"+a);c=a+""+e[b]+""+c;if(g[h].count>g[b].count)for(a=g[b].count;a<g[h].count;a++)b=g[b].nextInterval,"ss"==b||"mm"==b||"hh"==b?c="00"+e[b]+""+c:"DD"==b&&(c="0"+e[b]+""+c);":"==c.charAt(c.length-1)&&(c=c.substring(0,c.length-1));return c};d.formatNumber=function(a,b,c,e,h){a=d.roundTo(a,b.precision);isNaN(c)&&(c=b.precision);var f=b.decimalSeparator;b=
b.thousandsSeparator;var g;g=0>a?"-":"";a=Math.abs(a);var k=String(a),l=!1;-1!=k.indexOf("e")&&(l=!0);0<=c&&!l&&(k=d.toFixed(a,c));var m="";if(l)m=k;else{var k=k.split("."),l=String(k[0]),p;for(p=l.length;0<=p;p-=3)m=p!=l.length?0!==p?l.substring(p-3,p)+b+m:l.substring(p-3,p)+m:l.substring(p-3,p);void 0!==k[1]&&(m=m+f+k[1]);void 0!==c&&0<c&&"0"!=m&&(m=d.addZeroes(m,f,c))}m=g+m;""===g&&!0===e&&0!==a&&(m="+"+m);!0===h&&(m+="%");return m};d.addZeroes=function(a,b,c){a=a.split(b);void 0===a[1]&&0<c&&
(a[1]="0");return a[1].length<c?(a[1]+="0",d.addZeroes(a[0]+b+a[1],b,c)):void 0!==a[1]?a[0]+b+a[1]:a[0]};d.scientificToNormal=function(a){var b;a=String(a).split("e");var c;if("-"==a[1].substr(0,1)){b="0.";for(c=0;c<Math.abs(Number(a[1]))-1;c++)b+="0";b+=a[0].split(".").join("")}else{var e=0;b=a[0].split(".");b[1]&&(e=b[1].length);b=a[0].split(".").join("");for(c=0;c<Math.abs(Number(a[1]))-e;c++)b+="0"}return b};d.toScientific=function(a,b){if(0===a)return"0";var c=Math.floor(Math.log(Math.abs(a))*
Math.LOG10E),e=String(e).split(".").join(b);return String(e)+"e"+c};d.randomColor=function(){return"#"+("00000"+(16777216*Math.random()<<0).toString(16)).substr(-6)};d.hitTest=function(a,b,c){var e=!1,h=a.x,f=a.x+a.width,g=a.y,k=a.y+a.height,l=d.isInRectangle;e||(e=l(h,g,b));e||(e=l(h,k,b));e||(e=l(f,g,b));e||(e=l(f,k,b));e||!0===c||(e=d.hitTest(b,a,!0));return e};d.isInRectangle=function(a,b,c){return a>=c.x-5&&a<=c.x+c.width+5&&b>=c.y-5&&b<=c.y+c.height+5?!0:!1};d.isPercents=function(a){if(-1!=
String(a).indexOf("%"))return!0};d.formatValue=function(a,b,c,e,h,f,g,k){if(b){void 0===h&&(h="");var l;for(l=0;l<c.length;l++){var m=c[l],p=b[m];void 0!==p&&(p=f?d.addPrefix(p,k,g,e):d.formatNumber(p,e),a=a.replace(new RegExp("\\[\\["+h+""+m+"\\]\\]","g"),p))}}return a};d.formatDataContextValue=function(a,b){if(a){var c=a.match(/\[\[.*?\]\]/g),e;for(e=0;e<c.length;e++){var d=c[e],d=d.substr(2,d.length-4);void 0!==b[d]&&(a=a.replace(new RegExp("\\[\\["+d+"\\]\\]","g"),b[d]))}}return a};d.massReplace=
function(a,b){for(var c in b)if(b.hasOwnProperty(c)){var e=b[c];void 0===e&&(e="");a=a.replace(c,e)}return a};d.cleanFromEmpty=function(a){return a.replace(/\[\[[^\]]*\]\]/g,"")};d.addPrefix=function(a,b,c,e,h){var f=d.formatNumber(a,e),g="",k,l,m;if(0===a)return"0";0>a&&(g="-");a=Math.abs(a);if(1<a)for(k=b.length-1;-1<k;k--){if(a>=b[k].number&&(l=a/b[k].number,m=Number(e.precision),1>m&&(m=1),c=d.roundTo(l,m),m=d.formatNumber(c,{precision:-1,decimalSeparator:e.decimalSeparator,thousandsSeparator:e.thousandsSeparator}),
!h||l==c)){f=g+""+m+""+b[k].prefix;break}}else for(k=0;k<c.length;k++)if(a<=c[k].number){l=a/c[k].number;m=Math.abs(Math.floor(Math.log(l)*Math.LOG10E));l=d.roundTo(l,m);f=g+""+l+""+c[k].prefix;break}return f};d.remove=function(a){a&&a.remove()};d.getEffect=function(a){">"==a&&(a="easeOutSine");"<"==a&&(a="easeInSine");"elastic"==a&&(a="easeOutElastic");return a};d.getObjById=function(a,b){var c,e;for(e=0;e<a.length;e++){var d=a[e];if(d.id==b){c=d;break}}return c};d.applyTheme=function(a,b,c){b||
(b=d.theme);try{b=JSON.parse(JSON.stringify(b))}catch(e){}b&&b[c]&&d.extend(a,b[c])};d.isString=function(a){return"string"==typeof a?!0:!1};d.extend=function(a,b,c){var e;a||(a={});for(e in b)c?a.hasOwnProperty(e)||(a[e]=b[e]):a[e]=b[e];return a};d.copyProperties=function(a,b){for(var c in a)a.hasOwnProperty(c)&&"events"!=c&&void 0!==a[c]&&"function"!=typeof a[c]&&"cname"!=c&&(b[c]=a[c])};d.processObject=function(a,b,c,e){if(!1===a instanceof b&&(a=e?d.extend(new b(c),a):d.extend(a,new b(c),!0),a.listeners))for(var h in a.listeners)b=
a.listeners[h],a.addListener(b.event,b.method);return a};d.fixNewLines=function(a){var b=RegExp("\\n","g");a&&(a=a.replace(b,"<br />"));return a};d.fixBrakes=function(a){if(d.isModern){var b=RegExp("<br>","g");a&&(a=a.replace(b,"\n"))}else a=d.fixNewLines(a);return a};d.deleteObject=function(a,b){if(a){if(void 0===b||null===b)b=20;if(0!==b)if("[object Array]"===Object.prototype.toString.call(a))for(var c=0;c<a.length;c++)d.deleteObject(a[c],b-1),a[c]=null;else if(a&&!a.tagName)try{for(c in a.theme=
null,a)a[c]&&("object"==typeof a[c]&&d.deleteObject(a[c],b-1),"function"!=typeof a[c]&&(a[c]=null))}catch(e){}}};d.bounce=function(a,b,c,e,d){return(b/=d)<1/2.75?7.5625*e*b*b+c:b<2/2.75?e*(7.5625*(b-=1.5/2.75)*b+.75)+c:b<2.5/2.75?e*(7.5625*(b-=2.25/2.75)*b+.9375)+c:e*(7.5625*(b-=2.625/2.75)*b+.984375)+c};d.easeInOutQuad=function(a,b,c,e,d){b/=d/2;if(1>b)return e/2*b*b+c;b--;return-e/2*(b*(b-2)-1)+c};d.easeInSine=function(a,b,c,e,d){return-e*Math.cos(b/d*(Math.PI/2))+e+c};d.easeOutSine=function(a,
b,c,e,d){return e*Math.sin(b/d*(Math.PI/2))+c};d.easeOutElastic=function(a,b,c,e,d){a=1.70158;var f=0,g=e;if(0===b)return c;if(1==(b/=d))return c+e;f||(f=.3*d);g<Math.abs(e)?(g=e,a=f/4):a=f/(2*Math.PI)*Math.asin(e/g);return g*Math.pow(2,-10*b)*Math.sin(2*(b*d-a)*Math.PI/f)+e+c};d.fixStepE=function(a){a=a.toExponential(0).split("e");var b=Number(a[1]);9==Number(a[0])&&b++;return d.generateNumber(1,b)};d.generateNumber=function(a,b){var c="",e;e=0>b?Math.abs(b)-1:Math.abs(b);var d;for(d=0;d<e;d++)c+=
"0";return 0>b?Number("0."+c+String(a)):Number(String(a)+c)};d.setCN=function(a,b,c,e){if(a.addClassNames&&b&&(b=b.node)&&c){var d=b.getAttribute("class");a=a.classNamePrefix+"-";e&&(a="");d?b.setAttribute("class",d+" "+a+c):b.setAttribute("class",a+c)}};d.removeCN=function(a,b,c){b&&(b=b.node)&&c&&(b=b.classList)&&b.remove(a.classNamePrefix+"-"+c)};d.parseDefs=function(a,b){for(var c in a){var e=typeof a[c];if(0<a[c].length&&"object"==e)for(var h=0;h<a[c].length;h++)e=document.createElementNS(d.SVG_NS,
c),b.appendChild(e),d.parseDefs(a[c][h],e);else"object"==e?(e=document.createElementNS(d.SVG_NS,c),b.appendChild(e),d.parseDefs(a[c],e)):b.setAttribute(c,a[c])}}})();(function(){var d=window.AmCharts;d.AxisBase=d.Class({construct:function(a){this.createEvents("clickItem","rollOverItem","rollOutItem","rollOverGuide","rollOutGuide","clickGuide");this.titleDY=this.y=this.x=this.dy=this.dx=0;this.axisThickness=1;this.axisColor="#000000";this.axisAlpha=1;this.gridCount=this.tickLength=5;this.gridAlpha=.15;this.gridThickness=1;this.gridColor="#000000";this.dashLength=0;this.labelFrequency=1;this.showLastLabel=this.showFirstLabel=!0;this.fillColor="#FFFFFF";this.fillAlpha=
0;this.labelsEnabled=!0;this.labelRotation=0;this.autoGridCount=!0;this.offset=0;this.guides=[];this.visible=!0;this.counter=0;this.guides=[];this.ignoreAxisWidth=this.inside=!1;this.minHorizontalGap=75;this.minVerticalGap=35;this.titleBold=!0;this.minorGridEnabled=!1;this.minorGridAlpha=.07;this.autoWrap=!1;this.titleAlign="middle";this.labelOffset=0;this.bcn="axis-";this.centerLabels=!1;this.firstDayOfWeek=1;this.centerLabelOnFullPeriod=this.markPeriodChange=this.boldPeriodBeginning=!0;this.titleWidth=
0;this.periods=[{period:"fff",count:1},{period:"fff",count:5},{period:"fff",count:10},{period:"fff",count:50},{period:"fff",count:100},{period:"fff",count:500},{period:"ss",count:1},{period:"ss",count:5},{period:"ss",count:10},{period:"ss",count:30},{period:"mm",count:1},{period:"mm",count:5},{period:"mm",count:10},{period:"mm",count:30},{period:"hh",count:1},{period:"hh",count:3},{period:"hh",count:6},{period:"hh",count:12},{period:"DD",count:1},{period:"DD",count:2},{period:"DD",count:3},{period:"DD",
count:4},{period:"DD",count:5},{period:"WW",count:1},{period:"MM",count:1},{period:"MM",count:2},{period:"MM",count:3},{period:"MM",count:6},{period:"YYYY",count:1},{period:"YYYY",count:2},{period:"YYYY",count:5},{period:"YYYY",count:10},{period:"YYYY",count:50},{period:"YYYY",count:100}];this.dateFormats=[{period:"fff",format:"NN:SS.QQQ"},{period:"ss",format:"JJ:NN:SS"},{period:"mm",format:"JJ:NN"},{period:"hh",format:"JJ:NN"},{period:"DD",format:"MMM DD"},{period:"WW",format:"MMM DD"},{period:"MM",
format:"MMM"},{period:"YYYY",format:"YYYY"}];this.nextPeriod={fff:"ss",ss:"mm",mm:"hh",hh:"DD",DD:"MM",MM:"YYYY"};d.applyTheme(this,a,"AxisBase")},zoom:function(a,b){this.start=a;this.end=b;this.dataChanged=!0;this.draw()},fixAxisPosition:function(){var a=this.position;"H"==this.orientation?("left"==a&&(a="bottom"),"right"==a&&(a="top")):("bottom"==a&&(a="left"),"top"==a&&(a="right"));this.position=a},init:function(){this.createBalloon()},draw:function(){var a=this.chart;this.prevBY=this.prevBX=NaN;
this.allLabels=[];this.counter=0;this.destroy();this.fixAxisPosition();this.setBalloonBounds();this.labels=[];var b=a.container,c=b.set();a.gridSet.push(c);this.set=c;b=b.set();a.axesLabelsSet.push(b);this.labelsSet=b;this.axisLine=new this.axisRenderer(this);this.autoGridCount?("V"==this.orientation?(a=this.height/this.minVerticalGap,3>a&&(a=3)):a=this.width/this.minHorizontalGap,this.gridCountR=Math.max(a,1)):this.gridCountR=this.gridCount;this.axisWidth=this.axisLine.axisWidth;this.addTitle()},
setOrientation:function(a){this.orientation=a?"H":"V"},addTitle:function(){var a=this.title;this.titleLabel=null;if(a){var b=this.chart,c=this.titleColor;void 0===c&&(c=b.color);var e=this.titleFontSize;isNaN(e)&&(e=b.fontSize+1);a=d.text(b.container,a,c,b.fontFamily,e,this.titleAlign,this.titleBold);d.setCN(b,a,this.bcn+"title");this.titleLabel=a}},positionTitle:function(){var a=this.titleLabel;if(a){var b,c,e=this.labelsSet,h={};0<e.length()?h=e.getBBox():(h.x=0,h.y=0,h.width=this.width,h.height=
this.height,d.VML&&(h.y+=this.y,h.x+=this.x));e.push(a);var e=h.x,f=h.y;d.VML&&(f-=this.y,e-=this.x);var g=h.width,h=h.height,k=this.width,l=this.height,m=0,p=a.getBBox().height/2,q=this.inside,n=this.titleAlign;switch(this.position){case "top":b="left"==n?-1:"right"==n?k:k/2;c=f-10-p;break;case "bottom":b="left"==n?-1:"right"==n?k:k/2;c=f+h+10+p;break;case "left":b=e-10-p;q&&(b-=5);m=-90;c=("left"==n?l+1:"right"==n?-1:l/2)+this.titleDY;this.titleWidth=p+10;break;case "right":b=e+g+10+p,q&&(b+=7),
c=("left"==n?l+2:"right"==n?-2:l/2)+this.titleDY,this.titleWidth=p+10,m=-90}this.marginsChanged?(a.translate(b,c),this.tx=b,this.ty=c):a.translate(this.tx,this.ty);this.marginsChanged=!1;isNaN(this.titleRotation)||(m=this.titleRotation);0!==m&&a.rotate(m)}},pushAxisItem:function(a,b){var c=this,e=a.graphics();0<e.length()&&(b?c.labelsSet.push(e):c.set.push(e));if(e=a.getLabel())c.labelsSet.push(e),e.click(function(b){c.handleMouse(b,a,"clickItem")}).touchend(function(b){c.handleMouse(b,a,"clickItem")}).mouseover(function(b){c.handleMouse(b,
a,"rollOverItem")}).mouseout(function(b){c.handleMouse(b,a,"rollOutItem")})},handleMouse:function(a,b,c){this.fire({type:c,value:b.value,serialDataItem:b.serialDataItem,axis:this,target:b.label,chart:this.chart,event:a})},addGuide:function(a){for(var b=this.guides,c=!1,e=b.length,h=0;h<b.length;h++)b[h]==a&&(c=!0,e=h);a=d.processObject(a,d.Guide,this.theme);a.id||(a.id="guideAuto"+e+"_"+(new Date).getTime());c||b.push(a)},removeGuide:function(a){var b=this.guides,c;for(c=0;c<b.length;c++)b[c]==a&&
b.splice(c,1)},handleGuideOver:function(a){clearTimeout(this.chart.hoverInt);var b=a.graphics.getBBox(),c=this.x+b.x+b.width/2,b=this.y+b.y+b.height/2,e=a.fillColor;void 0===e&&(e=a.lineColor);this.chart.showBalloon(a.balloonText,e,!0,c,b);this.fire({type:"rollOverGuide",guide:a,chart:this.chart})},handleGuideOut:function(a){this.chart.hideBalloon();this.fire({type:"rollOutGuide",guide:a,chart:this.chart})},handleGuideClick:function(a){this.chart.hideBalloon();this.fire({type:"clickGuide",guide:a,
chart:this.chart})},addEventListeners:function(a,b){var c=this;a.mouseover(function(){c.handleGuideOver(b)});a.mouseup(function(){c.handleGuideClick(b)});a.touchstart(function(){c.handleGuideOver(b)});a.mouseout(function(){c.handleGuideOut(b)})},getBBox:function(){var a;this.labelsSet&&(a=this.labelsSet.getBBox());a?d.VML||(a={x:a.x+this.x,y:a.y+this.y,width:a.width,height:a.height}):a={x:0,y:0,width:0,height:0};return a},destroy:function(){d.remove(this.set);d.remove(this.labelsSet);var a=this.axisLine;
a&&d.remove(a.axisSet);d.remove(this.grid0)},chooseMinorFrequency:function(a){for(var b=10;0<b;b--)if(a/b==Math.round(a/b))return a/b},parseDatesDraw:function(){var a,b=this.chart,c=this.showFirstLabel,e=this.showLastLabel,h,f="",g=d.extractPeriod(this.minPeriod),k=d.getPeriodDuration(g.period,g.count),l,m,p,q,n,t=this.firstDayOfWeek,r=this.boldPeriodBeginning;a=this.minorGridEnabled;var w,z=this.gridAlpha,x,u=this.choosePeriod(0),A=u.period,u=u.count,y=d.getPeriodDuration(A,u);y<k&&(A=g.period,u=
g.count,y=k);g=A;"WW"==g&&(g="DD");this.stepWidth=this.getStepWidth(this.timeDifference);var B=Math.ceil(this.timeDifference/y)+5,D=l=d.resetDateToMin(new Date(this.startTime-y),A,u,t).getTime();if(g==A&&1==u&&this.centerLabelOnFullPeriod||this.autoWrap||this.centerLabels)p=y*this.stepWidth,this.autoWrap&&!this.centerLabels&&(p=-p);this.cellWidth=k*this.stepWidth;q=Math.round(l/y);k=-1;q/2==Math.round(q/2)&&(k=-2,l-=y);q=this.firstTime;var C=0,I=0;a&&1<u&&(w=this.chooseMinorFrequency(u),x=d.getPeriodDuration(A,
w),"DD"==A&&(x+=d.getPeriodDuration("hh")),"fff"==A&&(x=1));if(0<this.gridCountR)for(B-5-k>this.autoRotateCount&&!isNaN(this.autoRotateAngle)&&(this.labelRotationR=this.autoRotateAngle),a=k;a<=B;a++){n=q+y*(a+Math.floor((D-q)/y))-C;"DD"==A&&(n+=36E5);n=d.resetDateToMin(new Date(n),A,u,t).getTime();"MM"==A&&(h=(n-l)/y,1.5<=(n-l)/y&&(n=n-(h-1)*y+d.getPeriodDuration("DD",3),n=d.resetDateToMin(new Date(n),A,1).getTime(),C+=y));h=(n-this.startTime)*this.stepWidth;if("radar"==b.type){if(h=this.axisWidth-
h,0>h||h>this.axisWidth)continue}else this.rotate?"date"==this.type&&"middle"==this.gridPosition&&(I=-y*this.stepWidth/2):"date"==this.type&&(h=this.axisWidth-h);f=!1;this.nextPeriod[g]&&(f=this.checkPeriodChange(this.nextPeriod[g],1,n,l,g));l=!1;f&&this.markPeriodChange?(f=this.dateFormatsObject[this.nextPeriod[g]],this.twoLineMode&&(f=this.dateFormatsObject[g]+"\n"+f,f=d.fixBrakes(f)),l=!0):f=this.dateFormatsObject[g];r||(l=!1);this.currentDateFormat=f;f=d.formatDate(new Date(n),f,b);if(a==k&&!c||
a==B&&!e)f=" ";this.labelFunction&&(f=this.labelFunction(f,new Date(n),this,A,u,m).toString());this.boldLabels&&(l=!0);m=new this.axisItemRenderer(this,h,f,!1,p,I,!1,l);this.pushAxisItem(m);m=l=n;if(!isNaN(w))for(h=1;h<u;h+=w)this.gridAlpha=this.minorGridAlpha,f=n+x*h,f=d.resetDateToMin(new Date(f),A,w,t).getTime(),f=new this.axisItemRenderer(this,(f-this.startTime)*this.stepWidth,void 0,void 0,void 0,void 0,void 0,void 0,void 0,!0),this.pushAxisItem(f);this.gridAlpha=z}},choosePeriod:function(a){var b=
d.getPeriodDuration(this.periods[a].period,this.periods[a].count),c=this.periods;return this.timeDifference<b&&0<a?c[a-1]:Math.ceil(this.timeDifference/b)<=this.gridCountR?c[a]:a+1<c.length?this.choosePeriod(a+1):c[a]},getStepWidth:function(a){var b;this.startOnAxis?(b=this.axisWidth/(a-1),1==a&&(b=this.axisWidth)):b=this.axisWidth/a;return b},timeZoom:function(a,b){this.startTime=a;this.endTime=b},minDuration:function(){var a=d.extractPeriod(this.minPeriod);return d.getPeriodDuration(a.period,a.count)},
checkPeriodChange:function(a,b,c,e,h){c=new Date(c);var f=new Date(e),g=this.firstDayOfWeek;e=b;"DD"==a&&(b=1);c=d.resetDateToMin(c,a,b,g).getTime();b=d.resetDateToMin(f,a,b,g).getTime();return"DD"==a&&"hh"!=h&&c-b<d.getPeriodDuration(a,e)-d.getPeriodDuration("hh",1)?!1:c!=b?!0:!1},generateDFObject:function(){this.dateFormatsObject={};var a;for(a=0;a<this.dateFormats.length;a++){var b=this.dateFormats[a];this.dateFormatsObject[b.period]=b.format}},hideBalloon:function(){this.balloon&&this.balloon.hide&&
this.balloon.hide();this.prevBY=this.prevBX=NaN},formatBalloonText:function(a){return a},showBalloon:function(a,b,c,e){var d=this.offset;switch(this.position){case "bottom":b=this.height+d;break;case "top":b=-d;break;case "left":a=-d;break;case "right":a=this.width+d}c||(c=this.currentDateFormat);if("V"==this.orientation){if(0>b||b>this.height)return;if(isNaN(b)){this.hideBalloon();return}b=this.adjustBalloonCoordinate(b,e);e=this.coordinateToValue(b)}else{if(0>a||a>this.width)return;if(isNaN(a)){this.hideBalloon();
return}a=this.adjustBalloonCoordinate(a,e);e=this.coordinateToValue(a)}var f;if(d=this.chart.chartCursor)f=d.index;if(this.balloon&&void 0!==e&&this.balloon.enabled){if(this.balloonTextFunction){if("date"==this.type||!0===this.parseDates)e=new Date(e);e=this.balloonTextFunction(e)}else this.balloonText?e=this.formatBalloonText(this.balloonText,f,c):isNaN(e)||(e=this.formatValue(e,c));if(a!=this.prevBX||b!=this.prevBY)this.balloon.setPosition(a,b),this.prevBX=a,this.prevBY=b,e&&this.balloon.showBalloon(e)}},
adjustBalloonCoordinate:function(a){return a},createBalloon:function(){var a=this.chart,b=a.chartCursor;b&&(b=b.cursorPosition,"mouse"!=b&&(this.stickBalloonToCategory=!0),"start"==b&&(this.stickBalloonToStart=!0),"ValueAxis"==this.cname&&(this.stickBalloonToCategory=!1));this.balloon&&(this.balloon.destroy&&this.balloon.destroy(),d.extend(this.balloon,a.balloon,!0))},setBalloonBounds:function(){var a=this.balloon;if(a){var b=this.chart;a.cornerRadius=0;a.shadowAlpha=0;a.borderThickness=1;a.borderAlpha=
1;a.adjustBorderColor=!1;a.showBullet=!1;this.balloon=a;a.chart=b;a.mainSet=b.plotBalloonsSet;a.pointerWidth=this.tickLength;if(this.parseDates||"date"==this.type)a.pointerWidth=0;a.className=this.id;b="V";"V"==this.orientation&&(b="H");this.stickBalloonToCategory||(a.animationDuration=0);var c,e,d,f,g=this.inside,k=this.width,l=this.height;switch(this.position){case "bottom":c=0;e=k;g?(d=0,f=l):(d=l,f=l+1E3);break;case "top":c=0;e=k;g?(d=0,f=l):(d=-1E3,f=0);break;case "left":d=0;f=l;g?(c=0,e=k):
(c=-1E3,e=0);break;case "right":d=0,f=l,g?(c=0,e=k):(c=k,e=k+1E3)}a.drop||(a.pointerOrientation=b);a.setBounds(c,d,e,f)}}})})();(function(){var d=window.AmCharts;d.ValueAxis=d.Class({inherits:d.AxisBase,construct:function(a){this.cname="ValueAxis";this.createEvents("axisChanged","logarithmicAxisFailed","axisZoomed","axisIntZoomed");d.ValueAxis.base.construct.call(this,a);this.dataChanged=!0;this.stackType="none";this.position="left";this.unitPosition="right";this.includeAllValues=this.recalculateToPercents=this.includeHidden=this.includeGuidesInMinMax=this.integersOnly=!1;this.durationUnits={DD:"d. ",hh:":",mm:":",ss:""};
this.scrollbar=!1;this.baseValue=0;this.radarCategoriesEnabled=!0;this.axisFrequency=1;this.gridType="polygons";this.useScientificNotation=!1;this.axisTitleOffset=10;this.pointPosition="axis";this.minMaxMultiplier=1;this.logGridLimit=2;this.totalTextOffset=this.treatZeroAs=0;this.minPeriod="ss";this.relativeStart=0;this.relativeEnd=1;d.applyTheme(this,a,this.cname)},updateData:function(){0>=this.gridCountR&&(this.gridCountR=1);this.totals=[];this.data=this.chart.chartData;var a=this.chart;"xy"!=a.type&&
(this.stackGraphs("smoothedLine"),this.stackGraphs("line"),this.stackGraphs("column"),this.stackGraphs("step"));this.recalculateToPercents&&this.recalculate();if(this.synchronizationMultiplier&&this.synchronizeWith)d.isString(this.synchronizeWith)&&(this.synchronizeWith=a.getValueAxisById(this.synchronizeWith)),this.synchronizeWith&&(this.synchronizeWithAxis(this.synchronizeWith),this.foundGraphs=!0);else if(this.foundGraphs=!1,this.getMinMax(),0===this.start&&this.end==this.data.length-1&&isNaN(this.minZoom)&&
isNaN(this.maxZoom)||isNaN(this.fullMin)&&isNaN(this.fullMax))this.fullMin=this.min,this.fullMax=this.max,"date"!=this.type&&this.strictMinMax&&(isNaN(this.minimum)||(this.fullMin=this.minimum),isNaN(this.maximum)||(this.fullMax=this.maximum)),this.logarithmic&&(this.fullMin=this.logMin,0===this.fullMin&&(this.fullMin=this.treatZeroAs)),"date"==this.type&&(this.minimumDate||(this.fullMin=this.minRR),this.maximumDate||(this.fullMax=this.maxRR),this.strictMinMax&&(this.minimumDate&&(this.fullMin=this.minimumDate.getTime()),
this.maximumDate&&(this.fullMax=this.maximumDate.getTime())))},draw:function(){d.ValueAxis.base.draw.call(this);var a=this.chart,b=this.set;this.labelRotationR=this.labelRotation;d.setCN(a,this.set,"value-axis value-axis-"+this.id);d.setCN(a,this.labelsSet,"value-axis value-axis-"+this.id);d.setCN(a,this.axisLine.axisSet,"value-axis value-axis-"+this.id);var c=this.type;"duration"==c&&(this.duration="ss");!0===this.dataChanged&&(this.updateData(),this.dataChanged=!1);"date"==c&&(this.logarithmic=
!1,this.min=this.minRR,this.max=this.maxRR,this.reversed=!1,this.getDateMinMax());if(this.logarithmic){var e=this.treatZeroAs,h=this.getExtremes(0,this.data.length-1).min;!isNaN(this.minimum)&&this.minimum<h&&(h=this.minimum);this.logMin=h;this.minReal<h&&(this.minReal=h);isNaN(this.minReal)&&(this.minReal=h);0<e&&0===h&&(this.minReal=h=e);if(0>=h||0>=this.minimum){this.fire({type:"logarithmicAxisFailed",chart:a});return}}this.grid0=null;var f,g,k=a.dx,l=a.dy,e=!1,h=this.logarithmic;if(isNaN(this.min)||
isNaN(this.max)||!this.foundGraphs||Infinity==this.min||-Infinity==this.max)e=!0;else{"date"==this.type&&this.min==this.max&&(this.max+=this.minDuration(),this.min-=this.minDuration());var m=this.labelFrequency,p=this.showFirstLabel,q=this.showLastLabel,n=1,t=0;this.minCalc=this.min;this.maxCalc=this.max;if(this.strictMinMax&&(isNaN(this.minimum)||(this.min=this.minimum),isNaN(this.maximum)||(this.max=this.maximum),this.min==this.max))return;isNaN(this.minZoom)||(this.minReal=this.min=this.minZoom);
isNaN(this.maxZoom)||(this.max=this.maxZoom);if(this.logarithmic){g=this.fullMin;var r=this.fullMax;isNaN(this.minimum)||(g=this.minimum);isNaN(this.maximum)||(r=this.maximum);var r=Math.log(r)*Math.LOG10E-Math.log(g)*Math.LOG10E,w=Math.log(this.max)/Math.LN10-Math.log(g)*Math.LOG10E;this.relativeStart=d.roundTo((Math.log(this.minReal)/Math.LN10-Math.log(g)*Math.LOG10E)/r,5);this.relativeEnd=d.roundTo(w/r,5)}else this.relativeStart=d.roundTo(d.fitToBounds((this.min-this.fullMin)/(this.fullMax-this.fullMin),
0,1),5),this.relativeEnd=d.roundTo(d.fitToBounds((this.max-this.fullMin)/(this.fullMax-this.fullMin),0,1),5);var r=Math.round((this.maxCalc-this.minCalc)/this.step)+1,z;!0===h?(z=Math.log(this.max)*Math.LOG10E-Math.log(this.minReal)*Math.LOG10E,this.stepWidth=this.axisWidth/z,z>this.logGridLimit&&(r=Math.ceil(Math.log(this.max)*Math.LOG10E)+1,t=Math.round(Math.log(this.minReal)*Math.LOG10E),r>this.gridCountR&&(n=Math.ceil(r/this.gridCountR)))):this.stepWidth=this.axisWidth/(this.max-this.min);var x=
0;1>this.step&&-1<this.step&&(x=d.getDecimals(this.step));this.integersOnly&&(x=0);x>this.maxDecCount&&(x=this.maxDecCount);w=this.precision;isNaN(w)||(x=w);isNaN(this.maxZoom)&&(this.max=d.roundTo(this.max,this.maxDecCount),this.min=d.roundTo(this.min,this.maxDecCount));g={};g.precision=x;g.decimalSeparator=a.nf.decimalSeparator;g.thousandsSeparator=a.nf.thousandsSeparator;this.numberFormatter=g;var u;this.exponential=!1;for(g=t;g<r;g+=n){var A=d.roundTo(this.step*g+this.min,x);-1!=String(A).indexOf("e")&&
(this.exponential=!0)}this.duration&&(this.maxInterval=d.getMaxInterval(this.max,this.duration));var x=this.step,y,A=this.minorGridAlpha;this.minorGridEnabled&&(y=this.getMinorGridStep(x,this.stepWidth*x));if(this.autoGridCount||0!==this.gridCount)if("date"==c)this.generateDFObject(),this.timeDifference=this.max-this.min,this.maxTime=this.lastTime=this.max,this.startTime=this.firstTime=this.min,this.parseDatesDraw();else for(r>=this.autoRotateCount&&!isNaN(this.autoRotateAngle)&&(this.labelRotationR=
this.autoRotateAngle),c=this.minCalc,h&&(r++,c=this.maxCalc-r*x),this.gridCountReal=r,g=this.startCount=t;g<r;g+=n)if(t=x*g+c,t=d.roundTo(t,this.maxDecCount+1),!this.integersOnly||Math.round(t)==t)if(isNaN(w)||Number(d.toFixed(t,w))==t){if(!0===h)if(z>this.logGridLimit)t=Math.pow(10,g);else if(0>=t&&(t=c+x*g+x/2,0>=t))continue;u=this.formatValue(t,!1,g);Math.round(g/m)!=g/m&&(u=void 0);if(0===g&&!p||g==r-1&&!q)u=" ";f=this.getCoordinate(t);var B;this.rotate&&this.autoWrap&&(B=this.stepWidth*x-10);
u=new this.axisItemRenderer(this,f,u,void 0,B,void 0,void 0,this.boldLabels);this.pushAxisItem(u);if(t==this.baseValue&&"radar"!=a.type){var D,C,I=this.width,H=this.height;"H"==this.orientation?0<=f&&f<=I+1&&(D=[f,f,f+k],C=[H,0,l]):0<=f&&f<=H+1&&(D=[0,I,I+k],C=[f,f,f+l]);D&&(f=d.fitToBounds(2*this.gridAlpha,0,1),isNaN(this.zeroGridAlpha)||(f=this.zeroGridAlpha),f=d.line(a.container,D,C,this.gridColor,f,1,this.dashLength),f.translate(this.x,this.y),this.grid0=f,a.axesSet.push(f),f.toBack(),d.setCN(a,
f,this.bcn+"zero-grid-"+this.id),d.setCN(a,f,this.bcn+"zero-grid"))}if(!isNaN(y)&&0<A&&g<r-1){f=x/y;h&&(y=x*(g+n)+this.minCalc,y=d.roundTo(y,this.maxDecCount+1),z>this.logGridLimit&&(y=Math.pow(10,g+n)),f=9,y=(y-t)/f);I=this.gridAlpha;this.gridAlpha=this.minorGridAlpha;for(H=1;H<f;H++){var Q=this.getCoordinate(t+y*H),Q=new this.axisItemRenderer(this,Q,"",!1,0,0,!1,!1,0,!0);this.pushAxisItem(Q)}this.gridAlpha=I}}z=this.guides;B=z.length;if(0<B){D=this.fillAlpha;for(g=this.fillAlpha=0;g<B;g++)C=z[g],
k=NaN,y=C.above,isNaN(C.toValue)||(k=this.getCoordinate(C.toValue),u=new this.axisItemRenderer(this,k,"",!0,NaN,NaN,C),this.pushAxisItem(u,y)),l=NaN,isNaN(C.value)||(l=this.getCoordinate(C.value),u=new this.axisItemRenderer(this,l,C.label,!0,NaN,(k-l)/2,C),this.pushAxisItem(u,y)),isNaN(k)&&(l-=3,k=l+3),u&&(m=u.label)&&this.addEventListeners(m,C),isNaN(k-l)||0>l&&0>k||(k=new this.guideFillRenderer(this,l,k,C),this.pushAxisItem(k,y),y=k.graphics(),C.graphics=y,this.addEventListeners(y,C));this.fillAlpha=
D}u=this.baseValue;this.min>this.baseValue&&this.max>this.baseValue&&(u=this.min);this.min<this.baseValue&&this.max<this.baseValue&&(u=this.max);h&&u<this.minReal&&(u=this.minReal);this.baseCoord=this.getCoordinate(u,!0);u={type:"axisChanged",target:this,chart:a};u.min=h?this.minReal:this.min;u.max=this.max;this.fire(u);this.axisCreated=!0}h=this.axisLine.set;u=this.labelsSet;b.translate(this.x,this.y);u.translate(this.x,this.y);this.positionTitle();"radar"!=a.type&&h.toFront();!this.visible||e?(b.hide(),
h.hide(),u.hide()):(b.show(),h.show(),u.show());this.axisY=this.y;this.axisX=this.x},getDateMinMax:function(){this.minimumDate&&(this.minimumDate instanceof Date||(this.minimumDate=d.getDate(this.minimumDate,this.chart.dataDateFormat,"fff")),this.min=this.minimumDate.getTime());this.maximumDate&&(this.maximumDate instanceof Date||(this.maximumDate=d.getDate(this.maximumDate,this.chart.dataDateFormat,"fff")),this.max=this.maximumDate.getTime())},formatValue:function(a,b,c){var e=this.exponential,h=
this.logarithmic,f=this.numberFormatter,g=this.chart;if(f)return!0===this.logarithmic&&(e=-1!=String(a).indexOf("e")?!0:!1),this.useScientificNotation&&(e=!0),this.usePrefixes&&(e=!1),e?(c=-1==String(a).indexOf("e")?a.toExponential(15):String(a),e=c.split("e"),c=Number(e[0]),e=Number(e[1]),c=d.roundTo(c,14),b||isNaN(this.precision)||(c=d.roundTo(c,this.precision)),10==c&&(c=1,e+=1),c=c+"e"+e,0===a&&(c="0"),1==a&&(c="1")):(h&&(e=String(a).split("."),e[1]?(f.precision=e[1].length,0>c&&(f.precision=
Math.abs(c)),b&&1<a&&(f.precision=0),b||isNaN(this.precision)||(f.precision=this.precision)):f.precision=-1),c=this.usePrefixes?d.addPrefix(a,g.prefixesOfBigNumbers,g.prefixesOfSmallNumbers,f,!b):d.formatNumber(a,f,f.precision)),this.duration&&(b&&(f.precision=0),c=d.formatDuration(a,this.duration,"",this.durationUnits,this.maxInterval,f)),"date"==this.type&&(c=d.formatDate(new Date(a),this.currentDateFormat,g)),this.recalculateToPercents?c+="%":(b=this.unit)&&(c="left"==this.unitPosition?b+c:c+b),
this.labelFunction&&(c="date"==this.type?this.labelFunction(c,new Date(a),this).toString():this.labelFunction(a,c,this).toString()),c},getMinorGridStep:function(a,b){var c=[5,4,2];60>b&&c.shift();for(var e=Math.floor(Math.log(Math.abs(a))*Math.LOG10E),d=0;d<c.length;d++){var f=a/c[d],g=Math.floor(Math.log(Math.abs(f))*Math.LOG10E);if(!(1<Math.abs(e-g)))if(1>a){if(g=Math.pow(10,-g)*f,g==Math.round(g))return f}else if(f==Math.round(f))return f}},stackGraphs:function(a){var b=this.stackType;"stacked"==
b&&(b="regular");"line"==b&&(b="none");"100% stacked"==b&&(b="100%");this.stackType=b;var c=[],e=[],h=[],f=[],g,k=this.chart.graphs,l,m,p,q,n,t=this.baseValue,r=!1;if("line"==a||"step"==a||"smoothedLine"==a)r=!0;if(r&&("regular"==b||"100%"==b))for(q=0;q<k.length;q++)p=k[q],p.stackGraph=null,p.hidden||(m=p.type,p.chart==this.chart&&p.valueAxis==this&&a==m&&p.stackable&&(l&&(p.stackGraph=l),l=p));p=this.start-10;l=this.end+10;q=this.data.length-1;p=d.fitToBounds(p,0,q);l=d.fitToBounds(l,0,q);for(n=
p;n<=l;n++){var w=0;for(q=0;q<k.length;q++)if(p=k[q],p.hidden)p.newStack&&(h[n]=NaN,e[n]=NaN);else if(m=p.type,p.chart==this.chart&&p.valueAxis==this&&a==m&&p.stackable)if(m=this.data[n].axes[this.id].graphs[p.id],g=m.values.value,isNaN(g))p.newStack&&(h[n]=NaN,e[n]=NaN);else{var z=d.getDecimals(g);w<z&&(w=z);isNaN(f[n])?f[n]=Math.abs(g):f[n]+=Math.abs(g);f[n]=d.roundTo(f[n],w);z=p.fillToGraph;r&&z&&(z=this.data[n].axes[this.id].graphs[z.id])&&(m.values.open=z.values.value);"regular"==b&&(r&&(isNaN(c[n])?
(c[n]=g,m.values.close=g,m.values.open=this.baseValue):(isNaN(g)?m.values.close=c[n]:m.values.close=g+c[n],m.values.open=c[n],c[n]=m.values.close)),"column"==a&&(p.newStack&&(h[n]=NaN,e[n]=NaN),m.values.close=g,0>g?(m.values.close=g,isNaN(e[n])?m.values.open=t:(m.values.close+=e[n],m.values.open=e[n]),e[n]=m.values.close):(m.values.close=g,isNaN(h[n])?m.values.open=t:(m.values.close+=h[n],m.values.open=h[n]),h[n]=m.values.close)))}}for(n=this.start;n<=this.end;n++)for(q=0;q<k.length;q++)(p=k[q],p.hidden)?
p.newStack&&(h[n]=NaN,e[n]=NaN):(m=p.type,p.chart==this.chart&&p.valueAxis==this&&a==m&&p.stackable&&(m=this.data[n].axes[this.id].graphs[p.id],g=m.values.value,isNaN(g)||(c=g/f[n]*100,m.values.percents=c,m.values.total=f[n],p.newStack&&(h[n]=NaN,e[n]=NaN),"100%"==b&&(isNaN(e[n])&&(e[n]=0),isNaN(h[n])&&(h[n]=0),0>c?(m.values.close=d.fitToBounds(c+e[n],-100,100),m.values.open=e[n],e[n]=m.values.close):(m.values.close=d.fitToBounds(c+h[n],-100,100),m.values.open=h[n],h[n]=m.values.close)))))},recalculate:function(){var a=
this.chart,b=a.graphs,c;for(c=0;c<b.length;c++){var e=b[c];if(e.valueAxis==this){var h="value";if("candlestick"==e.type||"ohlc"==e.type)h="open";var f,g,k=this.end+2,k=d.fitToBounds(this.end+1,0,this.data.length-1),l=this.start;0<l&&l--;var m;g=this.start;e.compareFromStart&&(g=0);if(!isNaN(a.startTime)&&(m=a.categoryAxis)){var p=m.minDuration(),p=new Date(a.startTime+p/2),q=d.resetDateToMin(new Date(a.startTime),m.minPeriod).getTime();d.resetDateToMin(new Date(p),m.minPeriod).getTime()>q&&g++}if(m=
a.recalculateFromDate)m=d.getDate(m,a.dataDateFormat,"fff"),g=a.getClosestIndex(a.chartData,"time",m.getTime(),!0,0,a.chartData.length),k=a.chartData.length-1;for(m=g;m<=k&&(g=this.data[m].axes[this.id].graphs[e.id],f=g.values[h],e.recalculateValue&&(f=g.dataContext[e.valueField+e.recalculateValue]),isNaN(f));m++);this.recBaseValue=f;for(h=l;h<=k;h++){g=this.data[h].axes[this.id].graphs[e.id];g.percents={};var l=g.values,n;for(n in l)g.percents[n]="percents"!=n?l[n]/f*100-100:l[n]}}}},getMinMax:function(){var a=
!1,b=this.chart,c=b.graphs,e;for(e=0;e<c.length;e++){var h=c[e].type;("line"==h||"step"==h||"smoothedLine"==h)&&this.expandMinMax&&(a=!0)}a&&(0<this.start&&this.start--,this.end<this.data.length-1&&this.end++);"serial"==b.type&&(!0!==b.categoryAxis.parseDates||a||this.end<this.data.length-1&&this.end++);this.includeAllValues&&(this.start=0,this.end=this.data.length-1);a=this.minMaxMultiplier;b=this.getExtremes(this.start,this.end);this.min=b.min;this.max=b.max;this.minRR=this.min;this.maxRR=this.max;
a=(this.max-this.min)*(a-1);this.min-=a;this.max+=a;a=this.guides.length;if(this.includeGuidesInMinMax&&0<a)for(b=0;b<a;b++)c=this.guides[b],c.toValue<this.min&&(this.min=c.toValue),c.value<this.min&&(this.min=c.value),c.toValue>this.max&&(this.max=c.toValue),c.value>this.max&&(this.max=c.value);isNaN(this.minimum)||(this.min=this.minimum);isNaN(this.maximum)||(this.max=this.maximum);"date"==this.type&&this.getDateMinMax();this.min>this.max&&(a=this.max,this.max=this.min,this.min=a);isNaN(this.minZoom)||
(this.min=this.minZoom);isNaN(this.maxZoom)||(this.max=this.maxZoom);this.minCalc=this.min;this.maxCalc=this.max;this.minReal=this.min;this.maxReal=this.max;0===this.min&&0===this.max&&(this.max=9);this.min>this.max&&(this.min=this.max-1);a=this.min;b=this.max;c=this.max-this.min;e=0===c?Math.pow(10,Math.floor(Math.log(Math.abs(this.max))*Math.LOG10E))/10:Math.pow(10,Math.floor(Math.log(Math.abs(c))*Math.LOG10E))/10;isNaN(this.maximum)&&(this.max=Math.ceil(this.max/e)*e+e);isNaN(this.minimum)&&(this.min=
Math.floor(this.min/e)*e-e);0>this.min&&0<=a&&(this.min=0);0<this.max&&0>=b&&(this.max=0);"100%"==this.stackType&&(this.min=0>this.min?-100:0,this.max=0>this.max?0:100);c=this.max-this.min;e=Math.pow(10,Math.floor(Math.log(Math.abs(c))*Math.LOG10E))/10;this.step=Math.ceil(c/this.gridCountR/e)*e;c=Math.pow(10,Math.floor(Math.log(Math.abs(this.step))*Math.LOG10E));c=d.fixStepE(c);e=Math.ceil(this.step/c);5<e&&(e=10);5>=e&&2<e&&(e=5);this.step=Math.ceil(this.step/(c*e))*c*e;isNaN(this.setStep)||(this.step=
this.setStep);1>c?(this.maxDecCount=Math.abs(Math.log(Math.abs(c))*Math.LOG10E),this.maxDecCount=Math.round(this.maxDecCount),this.step=d.roundTo(this.step,this.maxDecCount+1)):this.maxDecCount=0;this.min=this.step*Math.floor(this.min/this.step);this.max=this.step*Math.ceil(this.max/this.step);0>this.min&&0<=a&&(this.min=0);0<this.max&&0>=b&&(this.max=0);1<this.minReal&&1<this.max-this.minReal&&(this.minReal=Math.floor(this.minReal));c=Math.pow(10,Math.floor(Math.log(Math.abs(this.minReal))*Math.LOG10E));
0===this.min&&(this.minReal=c);0===this.min&&1<this.minReal&&(this.minReal=1);0<this.min&&0<this.minReal-this.step&&(this.minReal=this.min+this.step<this.minReal?this.min+this.step:this.min);this.logarithmic&&(2<Math.log(b)*Math.LOG10E-Math.log(a)*Math.LOG10E?(this.minReal=this.min=Math.pow(10,Math.floor(Math.log(Math.abs(a))*Math.LOG10E)),this.maxReal=this.max=Math.pow(10,Math.ceil(Math.log(Math.abs(b))*Math.LOG10E))):(a=Math.pow(10,Math.floor(Math.log(Math.abs(a))*Math.LOG10E))/10,Math.pow(10,Math.floor(Math.log(Math.abs(this.min))*
Math.LOG10E))/10<a&&(this.minReal=this.min=10*a)))},getExtremes:function(a,b){var c,e,d;for(d=a;d<=b;d++){var f=this.data[d].axes[this.id].graphs,g;for(g in f)if(f.hasOwnProperty(g)){var k=this.chart.graphsById[g];if(k.includeInMinMax&&(!k.hidden||this.includeHidden)){isNaN(c)&&(c=Infinity);isNaN(e)&&(e=-Infinity);this.foundGraphs=!0;k=f[g].values;this.recalculateToPercents&&(k=f[g].percents);var l;if(this.minMaxField)l=k[this.minMaxField],l<c&&(c=l),l>e&&(e=l);else for(var m in k)k.hasOwnProperty(m)&&
"percents"!=m&&"total"!=m&&"error"!=m&&(l=k[m],l<c&&(c=l),l>e&&(e=l))}}}return{min:c,max:e}},zoomOut:function(a){this.maxZoom=this.minZoom=NaN;this.zoomToRelativeValues(0,1,a)},zoomToRelativeValues:function(a,b,c){if(this.reversed){var e=a;a=1-b;b=1-e}var d=this.fullMax,e=this.fullMin,f=e+(d-e)*a,g=e+(d-e)*b;0<=this.minimum&&0>f&&(f=0);this.logarithmic&&(isNaN(this.minimum)||(e=this.minimum),isNaN(this.maximum)||(d=this.maximum),d=Math.log(d)*Math.LOG10E-Math.log(e)*Math.LOG10E,f=Math.pow(10,d*a+
Math.log(e)*Math.LOG10E),g=Math.pow(10,d*b+Math.log(e)*Math.LOG10E));return this.zoomToValues(f,g,c)},zoomToValues:function(a,b,c){if(b<a){var e=b;b=a;a=e}var h=this.fullMax,e=this.fullMin;this.relativeStart=d.roundTo((a-e)/(h-e),9);this.relativeEnd=d.roundTo((b-e)/(h-e),9);if(this.logarithmic){isNaN(this.minimum)||(e=this.minimum);isNaN(this.maximum)||(h=this.maximum);var h=Math.log(h)*Math.LOG10E-Math.log(e)*Math.LOG10E,f=Math.log(b)/Math.LN10-Math.log(e)*Math.LOG10E;this.relativeStart=d.roundTo((Math.log(a)/
Math.LN10-Math.log(e)*Math.LOG10E)/h,9);this.relativeEnd=d.roundTo(f/h,9)}if(this.minZoom!=a||this.maxZoom!=b)return this.minZoom=a,this.maxZoom=b,e={type:"axisZoomed"},e.chart=this.chart,e.valueAxis=this,e.startValue=a,e.endValue=b,e.relativeStart=this.relativeStart,e.relativeEnd=this.relativeEnd,this.prevStartValue==a&&this.prevEndValue==b||this.fire(e),this.prevStartValue=a,this.prevEndValue=b,c||(a={},d.copyProperties(e,a),a.type="axisIntZoomed",this.fire(a)),0===this.relativeStart&&1==this.relativeEnd&&
(this.maxZoom=this.minZoom=NaN),!0},coordinateToValue:function(a){if(isNaN(a))return NaN;var b=this.axisWidth,c=this.stepWidth,e=this.reversed,d=this.rotate,f=this.min,g=this.minReal;return!0===this.logarithmic?Math.pow(10,(d?!0===e?(b-a)/c:a/c:!0===e?a/c:(b-a)/c)+Math.log(g)*Math.LOG10E):!0===e?d?f-(a-b)/c:a/c+f:d?a/c+f:f-(a-b)/c},getCoordinate:function(a,b){if(isNaN(a))return NaN;var c=this.rotate,e=this.reversed,d=this.axisWidth,f=this.stepWidth,g=this.min,k=this.minReal;!0===this.logarithmic?
(0===a&&(a=this.treatZeroAs),g=Math.log(a)*Math.LOG10E-Math.log(k)*Math.LOG10E,c=c?!0===e?d-f*g:f*g:!0===e?f*g:d-f*g):c=!0===e?c?d-f*(a-g):f*(a-g):c?f*(a-g):d-f*(a-g);1E7<Math.abs(c)&&(c=c/Math.abs(c)*1E7);b||(c=Math.round(c));return c},synchronizeWithAxis:function(a){this.synchronizeWith=a;this.listenTo(this.synchronizeWith,"axisChanged",this.handleSynchronization)},handleSynchronization:function(){if(this.synchronizeWith){d.isString(this.synchronizeWith)&&(this.synchronizeWith=this.chart.getValueAxisById(this.synchronizeWith));
var a=this.synchronizeWith,b=a.min,c=a.max,a=a.step,e=this.synchronizationMultiplier;e&&(this.min=b*e,this.max=c*e,this.step=a*e,b=Math.abs(Math.log(Math.abs(Math.pow(10,Math.floor(Math.log(Math.abs(this.step))*Math.LOG10E))))*Math.LOG10E),this.maxDecCount=b=Math.round(b),this.draw())}}})})();(function(){var d=window.AmCharts;d.RecAxis=d.Class({construct:function(a){var b=a.chart,c=a.axisThickness,e=a.axisColor,h=a.axisAlpha,f=a.offset,g=a.dx,k=a.dy,l=a.x,m=a.y,p=a.height,q=a.width,n=b.container;"H"==a.orientation?(e=d.line(n,[0,q],[0,0],e,h,c),this.axisWidth=a.width,"bottom"==a.position?(k=c/2+f+p+m-1,c=l):(k=-c/2-f+m+k,c=g+l)):(this.axisWidth=a.height,"right"==a.position?(e=d.line(n,[0,0,-g],[0,p,p-k],e,h,c),k=m+k,c=c/2+f+g+q+l-1):(e=d.line(n,[0,0],[0,p],e,h,c),k=m,c=-c/2-f+l));e.translate(c,
k);c=b.container.set();c.push(e);b.axesSet.push(c);d.setCN(b,e,a.bcn+"line");this.axisSet=c;this.set=e}})})();(function(){var d=window.AmCharts;d.RecItem=d.Class({construct:function(a,b,c,e,h,f,g,k,l,m,p,q){b=Math.round(b);var n=a.chart;this.value=c;void 0==c&&(c="");l||(l=0);void 0==e&&(e=!0);var t=n.fontFamily,r=a.fontSize;void 0==r&&(r=n.fontSize);var w=a.color;void 0==w&&(w=n.color);void 0!==p&&(w=p);var z=a.chart.container,x=z.set();this.set=x;var u=a.axisThickness,A=a.axisColor,y=a.axisAlpha,B=a.tickLength,D=a.gridAlpha,C=a.gridThickness,I=a.gridColor,H=a.dashLength,Q=a.fillColor,M=a.fillAlpha,P=a.labelsEnabled;
p=a.labelRotationR;var ia=a.counter,J=a.inside,aa=a.labelOffset,ma=a.dx,na=a.dy,Pa=a.orientation,Z=a.position,da=a.previousCoord,X=a.height,xa=a.width,ea=a.offset,fa,Ba;g?(void 0!==g.id&&(q=n.classNamePrefix+"-guide-"+g.id),P=!0,isNaN(g.tickLength)||(B=g.tickLength),void 0!=g.lineColor&&(I=g.lineColor),void 0!=g.color&&(w=g.color),isNaN(g.lineAlpha)||(D=g.lineAlpha),isNaN(g.dashLength)||(H=g.dashLength),isNaN(g.lineThickness)||(C=g.lineThickness),!0===g.inside&&(J=!0,0<ea&&(ea=0)),isNaN(g.labelRotation)||
(p=g.labelRotation),isNaN(g.fontSize)||(r=g.fontSize),g.position&&(Z=g.position),void 0!==g.boldLabel&&(k=g.boldLabel),isNaN(g.labelOffset)||(aa=g.labelOffset)):""===c&&(B=0);m&&!isNaN(a.minorTickLength)&&(B=a.minorTickLength);var ga="start";0<h&&(ga="middle");a.centerLabels&&(ga="middle");var V=p*Math.PI/180,Y,Da,G=0,v=0,oa=0,ha=Y=0,Qa=0;"V"==Pa&&(p=0);var ca;P&&""!==c&&(ca=a.autoWrap&&0===p?d.wrappedText(z,c,w,t,r,ga,k,Math.abs(h),0):d.text(z,c,w,t,r,ga,k),ga=ca.getBBox(),ha=ga.width,Qa=ga.height);
if("H"==Pa){if(0<=b&&b<=xa+1&&(0<B&&0<y&&b+l<=xa+1&&(fa=d.line(z,[b+l,b+l],[0,B],A,y,C),x.push(fa)),0<D&&(Ba=d.line(z,[b,b+ma,b+ma],[X,X+na,na],I,D,C,H),x.push(Ba))),v=0,G=b,g&&90==p&&J&&(G-=r),!1===e?(ga="start",v="bottom"==Z?J?v+B:v-B:J?v-B:v+B,G+=3,0<h&&(G+=h/2-3,ga="middle"),0<p&&(ga="middle")):ga="middle",1==ia&&0<M&&!g&&!m&&da<xa&&(e=d.fitToBounds(b,0,xa),da=d.fitToBounds(da,0,xa),Y=e-da,0<Y&&(Da=d.rect(z,Y,a.height,Q,M),Da.translate(e-Y+ma,na),x.push(Da))),"bottom"==Z?(v+=X+r/2+ea,J?(0<p?(v=
X-ha/2*Math.sin(V)-B-3,a.centerRotatedLabels||(G+=ha/2*Math.cos(V)-4+2)):0>p?(v=X+ha*Math.sin(V)-B-3+2,G+=-ha*Math.cos(V)-Qa*Math.sin(V)-4):v-=B+r+3+3,v-=aa):(0<p?(v=X+ha/2*Math.sin(V)+B+3,a.centerRotatedLabels||(G-=ha/2*Math.cos(V))):0>p?(v=X+B+3-ha/2*Math.sin(V)+2,G+=ha/2*Math.cos(V)):v+=B+u+3+3,v+=aa)):(v+=na+r/2-ea,G+=ma,J?(0<p?(v=ha/2*Math.sin(V)+B+3,a.centerRotatedLabels||(G-=ha/2*Math.cos(V))):v+=B+3,v+=aa):(0<p?(v=-(ha/2)*Math.sin(V)-B-6,a.centerRotatedLabels||(G+=ha/2*Math.cos(V))):v-=B+
r+3+u+3,v-=aa)),"bottom"==Z?Y=(J?X-B-1:X+u-1)+ea:(oa=ma,Y=(J?na:na-B-u+1)-ea),f&&(G+=f),r=G,0<p&&(r+=ha/2*Math.cos(V)),ca&&(f=0,J&&(f=ha/2*Math.cos(V)),r+f>xa+2||0>r))ca.remove(),ca=null}else{0<=b&&b<=X+1&&(0<B&&0<y&&b+l<=X+1&&(fa=d.line(z,[0,B+1],[b+l,b+l],A,y,C),x.push(fa)),0<D&&(Ba=d.line(z,[0,ma,xa+ma],[b,b+na,b+na],I,D,C,H),x.push(Ba)));ga="end";if(!0===J&&"left"==Z||!1===J&&"right"==Z)ga="start";v=b-Qa/2+2;1==ia&&0<M&&!g&&!m&&(e=d.fitToBounds(b,0,X),da=d.fitToBounds(da,0,X),V=e-da,Da=d.polygon(z,
[0,a.width,a.width,0],[0,0,V,V],Q,M),Da.translate(ma,e-V+na),x.push(Da));v+=r/2;"right"==Z?(G+=ma+xa+ea,v+=na,J?(f||(v-=r/2+3),G=G-(B+4)-aa):(G+=B+4+u,v-=2,G+=aa)):J?(G+=B+4-ea,f||(v-=r/2+3),g&&(G+=ma,v+=na),G+=aa):(G+=-B-u-4-2-ea,v-=2,G-=aa);fa&&("right"==Z?(oa+=ma+ea+xa-1,Y+=na,oa=J?oa-u:oa+u):(oa-=ea,J||(oa-=B+u)));f&&(v+=f);J=-3;"right"==Z&&(J+=na);ca&&(v>X+1||v<J-r/10)&&(ca.remove(),ca=null)}fa&&(fa.translate(oa,Y),d.setCN(n,fa,a.bcn+"tick"),d.setCN(n,fa,q,!0),g&&d.setCN(n,fa,"guide"));!1===
a.visible&&(fa&&fa.remove(),ca&&(ca.remove(),ca=null));ca&&(ca.attr({"text-anchor":ga}),ca.translate(G,v,NaN,!0),0!==p&&ca.rotate(-p,a.chart.backgroundColor),a.allLabels.push(ca),this.label=ca,d.setCN(n,ca,a.bcn+"label"),d.setCN(n,ca,q,!0),g&&d.setCN(n,ca,"guide"));Ba&&(d.setCN(n,Ba,a.bcn+"grid"),d.setCN(n,Ba,q,!0),g&&d.setCN(n,Ba,"guide"));Da&&(d.setCN(n,Da,a.bcn+"fill"),d.setCN(n,Da,q,!0));m?Ba&&d.setCN(n,Ba,a.bcn+"grid-minor"):(a.counter=0===ia?1:0,a.previousCoord=b);0===this.set.node.childNodes.length&&
this.set.remove()},graphics:function(){return this.set},getLabel:function(){return this.label}})})();(function(){var d=window.AmCharts;d.RecFill=d.Class({construct:function(a,b,c,e){var h=a.dx,f=a.dy,g=a.orientation,k=0;if(c<b){var l=b;b=c;c=l}var m=e.fillAlpha;isNaN(m)&&(m=0);var l=a.chart.container,p=e.fillColor;"V"==g?(b=d.fitToBounds(b,0,a.height),c=d.fitToBounds(c,0,a.height)):(b=d.fitToBounds(b,0,a.width),c=d.fitToBounds(c,0,a.width));c-=b;isNaN(c)&&(c=4,k=2,m=0);0>c&&"object"==typeof p&&(p=p.join(",").split(",").reverse());"V"==g?(g=d.rect(l,a.width,c,p,m),g.translate(h,b-k+f)):(g=d.rect(l,
c,a.height,p,m),g.translate(b-k+h,f));d.setCN(a.chart,g,"guide-fill");e.id&&d.setCN(a.chart,g,"guide-fill-"+e.id);this.set=l.set([g])},graphics:function(){return this.set},getLabel:function(){}})})();(function(){var d=window.AmCharts;d.AmChart=d.Class({construct:function(a){this.svgIcons=this.tapToActivate=!0;this.theme=a;this.classNamePrefix="amcharts";this.addClassNames=!1;this.version="3.21.6";d.addChart(this);this.createEvents("buildStarted","dataUpdated","init","rendered","drawn","failed","resized","animationFinished");this.height=this.width="100%";this.dataChanged=!0;this.chartCreated=!1;this.previousWidth=this.previousHeight=0;this.backgroundColor="#FFFFFF";this.borderAlpha=this.backgroundAlpha=
0;this.color=this.borderColor="#000000";this.fontFamily="Verdana";this.fontSize=11;this.usePrefixes=!1;this.autoResize=!0;this.autoDisplay=!1;this.addCodeCredits=this.accessible=!0;this.touchStartTime=this.touchClickDuration=0;this.precision=-1;this.percentPrecision=2;this.decimalSeparator=".";this.thousandsSeparator=",";this.labels=[];this.allLabels=[];this.titles=[];this.marginRight=this.marginLeft=this.autoMarginOffset=0;this.timeOuts=[];this.creditsPosition="top-left";var b=document.createElement("div"),
c=b.style;c.overflow="hidden";c.position="relative";c.textAlign="left";this.chartDiv=b;b=document.createElement("div");c=b.style;c.overflow="hidden";c.position="relative";c.textAlign="left";this.legendDiv=b;this.titleHeight=0;this.hideBalloonTime=150;this.handDrawScatter=2;this.cssScale=this.handDrawThickness=1;this.cssAngle=0;this.prefixesOfBigNumbers=[{number:1E3,prefix:"k"},{number:1E6,prefix:"M"},{number:1E9,prefix:"G"},{number:1E12,prefix:"T"},{number:1E15,prefix:"P"},{number:1E18,prefix:"E"},
{number:1E21,prefix:"Z"},{number:1E24,prefix:"Y"}];this.prefixesOfSmallNumbers=[{number:1E-24,prefix:"y"},{number:1E-21,prefix:"z"},{number:1E-18,prefix:"a"},{number:1E-15,prefix:"f"},{number:1E-12,prefix:"p"},{number:1E-9,prefix:"n"},{number:1E-6,prefix:"\u03bc"},{number:.001,prefix:"m"}];this.panEventsEnabled=!0;this.product="amcharts";this.animations=[];this.balloon=new d.AmBalloon(this.theme);this.balloon.chart=this;this.processTimeout=0;this.processCount=1E3;this.animatable=[];this.langObj={};
d.applyTheme(this,a,"AmChart")},drawChart:function(){0<this.realWidth&&0<this.realHeight&&(this.drawBackground(),this.redrawLabels(),this.drawTitles(),this.brr(),this.renderFix(),this.chartDiv&&(this.boundingRect=this.chartDiv.getBoundingClientRect()))},makeAccessible:function(a,b,c){this.accessible&&a&&(c&&a.setAttr("role",c),a.setAttr("aria-label",b))},drawBackground:function(){d.remove(this.background);var a=this.container,b=this.backgroundColor,c=this.backgroundAlpha,e=this.set;d.isModern||0!==
c||(c=.001);var h=this.updateWidth();this.realWidth=h;var f=this.updateHeight();this.realHeight=f;b=d.polygon(a,[0,h-1,h-1,0],[0,0,f-1,f-1],b,c,1,this.borderColor,this.borderAlpha);d.setCN(this,b,"bg");this.background=b;e.push(b);if(b=this.backgroundImage)a=a.image(b,0,0,h,f),d.setCN(this,b,"bg-image"),this.bgImg=a,e.push(a)},drawTitles:function(a){var b=this.titles;this.titleHeight=0;if(d.ifArray(b)){var c=20,e;for(e=0;e<b.length;e++){var h=b[e],h=d.processObject(h,d.Title,this.theme);if(!1!==h.enabled){var f=
h.color;void 0===f&&(f=this.color);var g=h.size;isNaN(g)&&(g=this.fontSize+2);isNaN(h.alpha);var k=this.marginLeft,l=!0;void 0!==h.bold&&(l=h.bold);f=d.wrappedText(this.container,h.text,f,this.fontFamily,g,"middle",l,this.realWidth-35-this.marginRight-k);f.translate(k+(this.realWidth-this.marginRight-k)/2,c);f.node.style.pointerEvents="none";h.sprite=f;void 0!==h.tabIndex&&f.setAttr("tabindex",h.tabIndex);d.setCN(this,f,"title");h.id&&d.setCN(this,f,"title-"+h.id);f.attr({opacity:h.alpha});c+=f.getBBox().height+
5;a?f.remove():this.freeLabelsSet.push(f)}}this.titleHeight=c-10}},write:function(a){var b=this;if(b.listeners)for(var c=0;c<b.listeners.length;c++){var e=b.listeners[c];b.addListener(e.event,e.method)}b.fire({type:"buildStarted",chart:b});b.afterWriteTO&&clearTimeout(b.afterWriteTO);0<b.processTimeout?b.afterWriteTO=setTimeout(function(){b.afterWrite.call(b,a)},b.processTimeout):b.afterWrite(a)},afterWrite:function(a){var b;if(b="object"!=typeof a?document.getElementById(a):a){for(;b.firstChild;)b.removeChild(b.firstChild);
this.div=b;b.style.overflow="hidden";b.style.textAlign="left";a=this.chartDiv;var c=this.legendDiv,e=this.legend,h=c.style,f=a.style;this.measure();this.previousHeight=this.divRealHeight;this.previousWidth=this.divRealWidth;var g,k=document.createElement("div");g=k.style;g.position="relative";this.containerDiv=k;k.className=this.classNamePrefix+"-main-div";a.className=this.classNamePrefix+"-chart-div";b.appendChild(k);(b=this.exportConfig)&&d.AmExport&&!this.AmExport&&(this.AmExport=new d.AmExport(this,
b));this.amExport&&d.AmExport&&(this.AmExport=d.extend(this.amExport,new d.AmExport(this),!0));this.AmExport&&this.AmExport.init&&this.AmExport.init();if(e){e=this.addLegend(e,e.divId);if(e.enabled)switch(h.left=null,h.top=null,h.right=null,f.left=null,f.right=null,f.top=null,h.position="relative",f.position="relative",g.width="100%",g.height="100%",e.position){case "bottom":k.appendChild(a);k.appendChild(c);break;case "top":k.appendChild(c);k.appendChild(a);break;case "absolute":h.position="absolute";
f.position="absolute";void 0!==e.left&&(h.left=e.left+"px");void 0!==e.right&&(h.right=e.right+"px");void 0!==e.top&&(h.top=e.top+"px");void 0!==e.bottom&&(h.bottom=e.bottom+"px");e.marginLeft=0;e.marginRight=0;k.appendChild(a);k.appendChild(c);break;case "right":h.position="relative";f.position="absolute";k.appendChild(a);k.appendChild(c);break;case "left":h.position="absolute";f.position="relative";k.appendChild(a);k.appendChild(c);break;case "outside":k.appendChild(a)}else k.appendChild(a);this.prevLegendPosition=
e.position}else k.appendChild(a);this.listenersAdded||(this.addListeners(),this.listenersAdded=!0);(this.mouseWheelScrollEnabled||this.mouseWheelZoomEnabled)&&d.addWheelListeners();this.initChart()}},createLabelsSet:function(){d.remove(this.labelsSet);this.labelsSet=this.container.set();this.freeLabelsSet.push(this.labelsSet)},initChart:function(){this.balloon=d.processObject(this.balloon,d.AmBalloon,this.theme);window.AmCharts_path&&(this.path=window.AmCharts_path);void 0===this.path&&(this.path=
d.getPath());void 0===this.path&&(this.path="amcharts/");this.path=d.normalizeUrl(this.path);void 0===this.pathToImages&&(this.pathToImages=this.path+"images/");this.initHC||(d.callInitHandler(this),this.initHC=!0);d.applyLang(this.language,this);var a=this.numberFormatter;a&&(isNaN(a.precision)||(this.precision=a.precision),void 0!==a.thousandsSeparator&&(this.thousandsSeparator=a.thousandsSeparator),void 0!==a.decimalSeparator&&(this.decimalSeparator=a.decimalSeparator));(a=this.percentFormatter)&&
!isNaN(a.precision)&&(this.percentPrecision=a.precision);this.nf={precision:this.precision,thousandsSeparator:this.thousandsSeparator,decimalSeparator:this.decimalSeparator};this.pf={precision:this.percentPrecision,thousandsSeparator:this.thousandsSeparator,decimalSeparator:this.decimalSeparator};this.destroy();(a=this.container)?(a.container.innerHTML="",a.width=this.realWidth,a.height=this.realHeight,a.addDefs(this),this.chartDiv.appendChild(a.container)):a=new d.AmDraw(this.chartDiv,this.realWidth,
this.realHeight,this);this.container=a;this.extension=".png";this.svgIcons&&d.SVG&&(this.extension=".svg");this.checkDisplay();this.checkTransform(this.div);a.chart=this;d.VML||d.SVG?(a.handDrawn=this.handDrawn,a.handDrawScatter=this.handDrawScatter,a.handDrawThickness=this.handDrawThickness,d.remove(this.set),this.set=a.set(),d.remove(this.gridSet),this.gridSet=a.set(),d.remove(this.cursorLineSet),this.cursorLineSet=a.set(),d.remove(this.graphsBehindSet),this.graphsBehindSet=a.set(),d.remove(this.bulletBehindSet),
this.bulletBehindSet=a.set(),d.remove(this.columnSet),this.columnSet=a.set(),d.remove(this.graphsSet),this.graphsSet=a.set(),d.remove(this.trendLinesSet),this.trendLinesSet=a.set(),d.remove(this.axesSet),this.axesSet=a.set(),d.remove(this.cursorSet),this.cursorSet=a.set(),d.remove(this.scrollbarsSet),this.scrollbarsSet=a.set(),d.remove(this.bulletSet),this.bulletSet=a.set(),d.remove(this.freeLabelsSet),this.freeLabelsSet=a.set(),d.remove(this.axesLabelsSet),this.axesLabelsSet=a.set(),d.remove(this.balloonsSet),
this.balloonsSet=a.set(),d.remove(this.plotBalloonsSet),this.plotBalloonsSet=a.set(),d.remove(this.zoomButtonSet),this.zoomButtonSet=a.set(),d.remove(this.zbSet),this.zbSet=null,d.remove(this.linkSet),this.linkSet=a.set()):this.fire({type:"failed",chart:this})},premeasure:function(){var a=this.div;if(a){try{this.boundingRect=this.chartDiv.getBoundingClientRect()}catch(e){}var b=a.offsetWidth,c=a.offsetHeight;a.clientHeight&&(b=a.clientWidth,c=a.clientHeight);if(b!=this.mw||c!=this.mh)this.mw=b,this.mh=
c,this.measure()}},measure:function(){var a=this.div;if(a){var b=this.chartDiv,c=a.offsetWidth,e=a.offsetHeight,h=this.container;a.clientHeight&&(c=a.clientWidth,e=a.clientHeight);var e=Math.round(e),c=Math.round(c),a=Math.round(d.toCoordinate(this.width,c)),f=Math.round(d.toCoordinate(this.height,e));(c!=this.previousWidth||e!=this.previousHeight)&&0<a&&0<f&&(b.style.width=a+"px",b.style.height=f+"px",b.style.padding=0,h&&h.setSize(a,f),this.balloon=d.processObject(this.balloon,d.AmBalloon,this.theme));
this.balloon&&this.balloon.setBounds&&this.balloon.setBounds(2,2,a-2,f);this.updateWidth();this.balloon.chart=this;this.realWidth=a;this.realHeight=f;this.divRealWidth=c;this.divRealHeight=e}},checkDisplay:function(){if(this.autoDisplay&&this.container){var a=d.rect(this.container,10,10),b=a.getBBox();0===b.width&&0===b.height&&(this.divRealHeight=this.divRealWidth=this.realHeight=this.realWidth=0,this.previousWidth=this.previousHeight=NaN);a.remove()}},checkTransform:function(a){if(this.autoTransform&&
window.getComputedStyle&&a){if(a.style){var b=window.getComputedStyle(a,null);if(b&&(b=b.getPropertyValue("-webkit-transform")||b.getPropertyValue("-moz-transform")||b.getPropertyValue("-ms-transform")||b.getPropertyValue("-o-transform")||b.getPropertyValue("transform"))&&"none"!==b){var c=b.split("(")[1].split(")")[0].split(","),b=c[0],c=c[1],b=Math.sqrt(b*b+c*c);isNaN(b)||(this.cssScale*=b)}}a.parentNode&&this.checkTransform(a.parentNode)}},destroy:function(){this.chartDiv.innerHTML="";this.clearTimeOuts();
this.legend&&this.legend.destroy()},clearTimeOuts:function(){var a=this.timeOuts;if(a){var b;for(b=0;b<a.length;b++)clearTimeout(a[b])}this.timeOuts=[]},clear:function(a){try{document.removeEventListener("touchstart",this.docfn1,!0),document.removeEventListener("touchend",this.docfn2,!0)}catch(b){}d.callMethod("clear",[this.chartScrollbar,this.scrollbarV,this.scrollbarH,this.chartCursor]);this.chartCursor=this.scrollbarH=this.scrollbarV=this.chartScrollbar=null;this.clearTimeOuts();this.container&&
(this.container.remove(this.chartDiv),this.container.remove(this.legendDiv));a||d.removeChart(this);if(a=this.div)for(;a.firstChild;)a.removeChild(a.firstChild);this.legend&&this.legend.destroy();this.AmExport&&this.AmExport.clear&&this.AmExport.clear()},setMouseCursor:function(a){"auto"==a&&d.isNN&&(a="default");this.chartDiv.style.cursor=a;this.legendDiv.style.cursor=a},redrawLabels:function(){this.labels=[];var a=this.allLabels;this.createLabelsSet();var b;for(b=0;b<a.length;b++)this.drawLabel(a[b])},
drawLabel:function(a){var b=this;if(b.container&&!1!==a.enabled){a=d.processObject(a,d.Label,b.theme);var c=a.y,e=a.text,h=a.align,f=a.size,g=a.color,k=a.rotation,l=a.alpha,m=a.bold,p=d.toCoordinate(a.x,b.realWidth),c=d.toCoordinate(c,b.realHeight);p||(p=0);c||(c=0);void 0===g&&(g=b.color);isNaN(f)&&(f=b.fontSize);h||(h="start");"left"==h&&(h="start");"right"==h&&(h="end");"center"==h&&(h="middle",k?c=b.realHeight-c+c/2:p=b.realWidth/2-p);void 0===l&&(l=1);void 0===k&&(k=0);c+=f/2;e=d.text(b.container,
e,g,b.fontFamily,f,h,m,l);e.translate(p,c);void 0!==a.tabIndex&&e.setAttr("tabindex",a.tabIndex);d.setCN(b,e,"label");a.id&&d.setCN(b,e,"label-"+a.id);0!==k&&e.rotate(k);a.url?(e.setAttr("cursor","pointer"),e.click(function(){d.getURL(a.url,b.urlTarget)})):e.node.style.pointerEvents="none";b.labelsSet.push(e);b.labels.push(e)}},addLabel:function(a,b,c,e,d,f,g,k,l,m){a={x:a,y:b,text:c,align:e,size:d,color:f,alpha:k,rotation:g,bold:l,url:m,enabled:!0};this.container&&this.drawLabel(a);this.allLabels.push(a)},
clearLabels:function(){var a=this.labels,b;for(b=a.length-1;0<=b;b--)a[b].remove();this.labels=[];this.allLabels=[]},updateHeight:function(){var a=this.divRealHeight,b=this.legend;if(b){var c=this.legendDiv.offsetHeight,b=b.position;if("top"==b||"bottom"==b){a-=c;if(0>a||isNaN(a))a=0;this.chartDiv.style.height=a+"px"}}return a},updateWidth:function(){var a=this.divRealWidth,b=this.divRealHeight,c=this.legend;if(c){var e=this.legendDiv,d=e.offsetWidth;isNaN(c.width)||(d=c.width);c.ieW&&(d=c.ieW);var f=
e.offsetHeight,e=e.style,g=this.chartDiv.style,k=c.position;if(("right"==k||"left"==k)&&void 0===c.divId){a-=d;if(0>a||isNaN(a))a=0;g.width=a+"px";this.balloon&&this.balloon.setBounds&&this.balloon.setBounds(2,2,a-2,this.realHeight);"left"==k?(g.left=d+"px",e.left="0px"):(g.left="0px",e.left=a+"px");b>f&&(e.top=(b-f)/2+"px")}}return a},getTitleHeight:function(){this.drawTitles(!0);return this.titleHeight},addTitle:function(a,b,c,e,d){isNaN(b)&&(b=this.fontSize+2);a={text:a,size:b,color:c,alpha:e,
bold:d,enabled:!0};this.titles.push(a);return a},handleWheel:function(a){var b=0;a||(a=window.event);a.wheelDelta?b=a.wheelDelta/120:a.detail&&(b=-a.detail/3);b&&this.handleWheelReal(b,a.shiftKey);a.preventDefault&&a.preventDefault()},handleWheelReal:function(){},handleDocTouchStart:function(){this.handleMouseMove();this.tmx=this.mouseX;this.tmy=this.mouseY;this.touchStartTime=(new Date).getTime()},handleDocTouchEnd:function(){-.5<this.tmx&&this.tmx<this.divRealWidth+1&&0<this.tmy&&this.tmy<this.divRealHeight?
(this.handleMouseMove(),4>Math.abs(this.mouseX-this.tmx)&&4>Math.abs(this.mouseY-this.tmy)?(this.tapped=!0,this.panRequired&&this.panEventsEnabled&&this.chartDiv&&(this.chartDiv.style.msTouchAction="none",this.chartDiv.style.touchAction="none")):this.mouseIsOver||this.resetTouchStyle()):(this.tapped=!1,this.resetTouchStyle())},resetTouchStyle:function(){this.panEventsEnabled&&this.chartDiv&&(this.chartDiv.style.msTouchAction="auto",this.chartDiv.style.touchAction="auto")},checkTouchDuration:function(a){var b=
this,c=(new Date).getTime();if(a)if(a.touches)b.isTouchEvent=!0;else if(!b.isTouchEvent)return!0;if(c-b.touchStartTime>b.touchClickDuration)return!0;setTimeout(function(){b.resetTouchDuration()},300)},resetTouchDuration:function(){this.isTouchEvent=!1},checkTouchMoved:function(){if(4<Math.abs(this.mouseX-this.tmx)||4<Math.abs(this.mouseY-this.tmy))return!0},addListeners:function(){var a=this,b=a.chartDiv;document.addEventListener?("ontouchstart"in document.documentElement&&(b.addEventListener("touchstart",
function(b){a.handleTouchStart.call(a,b)},!0),b.addEventListener("touchmove",function(b){a.handleMouseMove.call(a,b)},!0),b.addEventListener("touchend",function(b){a.handleTouchEnd.call(a,b)},!0),a.docfn1=function(b){a.handleDocTouchStart.call(a,b)},a.docfn2=function(b){a.handleDocTouchEnd.call(a,b)},document.addEventListener("touchstart",a.docfn1,!0),document.addEventListener("touchend",a.docfn2,!0)),b.addEventListener("mousedown",function(b){a.mouseIsOver=!0;a.handleMouseMove.call(a,b);a.handleMouseDown.call(a,
b);a.handleDocTouchStart.call(a,b)},!0),b.addEventListener("mouseover",function(b){a.handleMouseOver.call(a,b)},!0),b.addEventListener("mouseout",function(b){a.handleMouseOut.call(a,b)},!0),b.addEventListener("mouseup",function(b){a.handleDocTouchEnd.call(a,b)},!0)):(b.attachEvent("onmousedown",function(b){a.handleMouseDown.call(a,b)}),b.attachEvent("onmouseover",function(b){a.handleMouseOver.call(a,b)}),b.attachEvent("onmouseout",function(b){a.handleMouseOut.call(a,b)}))},dispDUpd:function(){this.skipEvents||
(this.dispatchDataUpdated&&(this.dispatchDataUpdated=!1,this.fire({type:"dataUpdated",chart:this})),this.chartCreated||(this.chartCreated=!0,this.fire({type:"init",chart:this})),this.chartRendered||(this.fire({type:"rendered",chart:this}),this.chartRendered=!0),this.fire({type:"drawn",chart:this}));this.skipEvents=!1},validateSize:function(){var a=this;a.premeasure();a.checkDisplay();a.cssScale=1;a.cssAngle=0;a.checkTransform(a.div);if(a.divRealWidth!=a.previousWidth||a.divRealHeight!=a.previousHeight){var b=
a.legend;if(0<a.realWidth&&0<a.realHeight){a.sizeChanged=!0;if(b){a.legendInitTO&&clearTimeout(a.legendInitTO);var c=setTimeout(function(){b.invalidateSize()},10);a.timeOuts.push(c);a.legendInitTO=c}a.marginsUpdated=!1;clearTimeout(a.initTO);c=setTimeout(function(){a.initChart()},10);a.timeOuts.push(c);a.initTO=c}a.renderFix();b&&b.renderFix&&b.renderFix();clearTimeout(a.resizedTO);a.resizedTO=setTimeout(function(){a.fire({type:"resized",chart:a})},10);a.previousHeight=a.divRealHeight;a.previousWidth=
a.divRealWidth}},invalidateSize:function(){this.previousHeight=this.previousWidth=NaN;this.invalidateSizeReal()},invalidateSizeReal:function(){var a=this;a.marginsUpdated=!1;clearTimeout(a.validateTO);var b=setTimeout(function(){a.validateSize()},5);a.timeOuts.push(b);a.validateTO=b},validateData:function(a){this.chartCreated&&(this.dataChanged=!0,this.marginsUpdated=!1,this.initChart(a))},validateNow:function(a,b){this.initTO&&clearTimeout(this.initTO);a&&(this.dataChanged=!0,this.marginsUpdated=
!1);this.skipEvents=b;this.chartRendered=!1;var c=this.legend;c&&c.position!=this.prevLegendPosition&&(this.previousWidth=this.mw=0,c.invalidateSize&&(c.invalidateSize(),this.validateSize()));this.write(this.div)},showItem:function(a){a.hidden=!1;this.initChart()},hideItem:function(a){a.hidden=!0;this.initChart()},hideBalloon:function(){var a=this;clearTimeout(a.hoverInt);clearTimeout(a.balloonTO);a.hoverInt=setTimeout(function(){a.hideBalloonReal.call(a)},a.hideBalloonTime)},cleanChart:function(){},
hideBalloonReal:function(){var a=this.balloon;a&&a.hide&&a.hide()},showBalloon:function(a,b,c,e,d){var f=this;clearTimeout(f.balloonTO);clearTimeout(f.hoverInt);f.balloonTO=setTimeout(function(){f.showBalloonReal.call(f,a,b,c,e,d)},1)},showBalloonReal:function(a,b,c,e,d){this.handleMouseMove();var f=this.balloon;f.enabled&&(f.followCursor(!1),f.changeColor(b),!c||f.fixedPosition?(f.setPosition(e,d),isNaN(e)||isNaN(d)?f.followCursor(!0):f.followCursor(!1)):f.followCursor(!0),a&&f.showBalloon(a))},
handleMouseOver:function(){this.outTO&&clearTimeout(this.outTO);d.resetMouseOver();this.mouseIsOver=!0},handleMouseOut:function(){var a=this;d.resetMouseOver();a.outTO&&clearTimeout(a.outTO);a.outTO=setTimeout(function(){a.handleMouseOutReal()},10)},handleMouseOutReal:function(){this.mouseIsOver=!1},handleMouseMove:function(a){a||(a=window.event);this.mouse2Y=this.mouse2X=NaN;var b,c,e,d;if(a){if(a.touches){var f=a.touches.item(1);f&&this.panEventsEnabled&&this.boundingRect&&(e=f.clientX-this.boundingRect.left,
d=f.clientY-this.boundingRect.top);a=a.touches.item(0);if(!a)return}else this.wasTouched=!1;this.boundingRect&&a.clientX&&(b=a.clientX-this.boundingRect.left,c=a.clientY-this.boundingRect.top);isNaN(e)?this.mouseX=b:(this.mouseX=Math.min(b,e),this.mouse2X=Math.max(b,e));isNaN(d)?this.mouseY=c:(this.mouseY=Math.min(c,d),this.mouse2Y=Math.max(c,d));this.autoTransform&&(this.mouseX/=this.cssScale,this.mouseY/=this.cssScale)}},handleTouchStart:function(a){this.hideBalloonReal();a&&(a.touches&&this.tapToActivate&&
!this.tapped||!this.panRequired)||(this.handleMouseMove(a),this.handleMouseDown(a))},handleTouchEnd:function(a){this.wasTouched=!0;this.handleMouseMove(a);d.resetMouseOver();this.handleReleaseOutside(a)},handleReleaseOutside:function(){this.handleDocTouchEnd.call(this)},handleMouseDown:function(a){d.resetMouseOver();this.mouseIsOver=!0;a&&a.preventDefault&&(this.panEventsEnabled?a.preventDefault():a.touches||a.preventDefault())},addLegend:function(a,b){a=d.processObject(a,d.AmLegend,this.theme);a.divId=
b;a.ieW=0;var c;c="object"!=typeof b&&b?document.getElementById(b):b;this.legend=a;a.chart=this;c?(a.div=c,a.position="outside",a.autoMargins=!1):a.div=this.legendDiv;return a},removeLegend:function(){this.legend=void 0;this.previousWidth=0;this.legendDiv.innerHTML=""},handleResize:function(){(d.isPercents(this.width)||d.isPercents(this.height))&&this.invalidateSizeReal();this.renderFix()},renderFix:function(){if(!d.VML){var a=this.container;a&&a.renderFix()}},getSVG:function(){if(d.hasSVG)return this.container},
animate:function(a,b,c,e,h,f,g){a["an_"+b]&&d.removeFromArray(this.animations,a["an_"+b]);c={obj:a,frame:0,attribute:b,from:c,to:e,time:h,effect:f,suffix:g};a["an_"+b]=c;this.animations.push(c);return c},setLegendData:function(a){var b=this.legend;b&&b.setData(a)},stopAnim:function(a){d.removeFromArray(this.animations,a)},updateAnimations:function(){var a;this.container&&this.container.update();if(this.animations)for(a=this.animations.length-1;0<=a;a--){var b=this.animations[a],c=d.updateRate*b.time,
e=b.frame+1,h=b.obj,f=b.attribute;if(e<=c){b.frame++;var g=Number(b.from),k=Number(b.to)-g,c=d[b.effect](0,e,g,k,c);0===k?(this.animations.splice(a,1),h.node.style[f]=Number(b.to)+b.suffix):h.node.style[f]=c+b.suffix}else h.node.style[f]=Number(b.to)+b.suffix,h.animationFinished=!0,this.animations.splice(a,1)}},update:function(){this.updateAnimations();var a=this.animatable;if(0<a.length){for(var b=!0,c=a.length-1;0<=c;c--){var e=a[c];e&&(e.animationFinished?a.splice(c,1):b=!1)}b&&(this.fire({type:"animationFinished",
chart:this}),this.animatable=[])}},inIframe:function(){try{return window.self!==window.top}catch(a){return!0}},brr:function(){if(!this.hideCredits){var a="amcharts.com",b=window.location.hostname.split("."),c;2<=b.length&&(c=b[b.length-2]+"."+b[b.length-1]);this.amLink&&(b=this.amLink.parentNode)&&b.removeChild(this.amLink);b=this.creditsPosition;if(c!=a||!0===this.inIframe()){var a="http://www."+a,e=c=0,d=this.realWidth,f=this.realHeight,g=this.type;if("serial"==g||"xy"==g||"gantt"==g)c=this.marginLeftReal,
e=this.marginTopReal,d=c+this.plotAreaWidth,f=e+this.plotAreaHeight;var g=a+"/javascript-charts/",k="JavaScript charts",l="JS chart by amCharts";"ammap"==this.product&&(g=a+"/javascript-maps/",k="Interactive JavaScript maps",l="JS map by amCharts");a=document.createElement("a");l=document.createTextNode(l);a.setAttribute("href",g);a.setAttribute("title",k);this.urlTarget&&a.setAttribute("target",this.urlTarget);a.appendChild(l);this.chartDiv.appendChild(a);this.amLink=a;g=a.style;g.position="absolute";
g.textDecoration="none";g.color=this.color;g.fontFamily=this.fontFamily;g.fontSize="11px";g.opacity=.7;g.display="block";var k=a.offsetWidth,a=a.offsetHeight,l=5+c,m=e+5;"bottom-left"==b&&(l=5+c,m=f-a-3);"bottom-right"==b&&(l=d-k-5,m=f-a-3);"top-right"==b&&(l=d-k-5,m=e+5);g.left=l+"px";g.top=m+"px"}}}});d.Slice=d.Class({construct:function(){}});d.SerialDataItem=d.Class({construct:function(){}});d.GraphDataItem=d.Class({construct:function(){}});d.Guide=d.Class({construct:function(a){this.cname="Guide";
d.applyTheme(this,a,this.cname)}});d.Title=d.Class({construct:function(a){this.cname="Title";d.applyTheme(this,a,this.cname)}});d.Label=d.Class({construct:function(a){this.cname="Label";d.applyTheme(this,a,this.cname)}})})();(function(){var d=window.AmCharts;d.AmGraph=d.Class({construct:function(a){this.cname="AmGraph";this.createEvents("rollOverGraphItem","rollOutGraphItem","clickGraphItem","doubleClickGraphItem","rightClickGraphItem","clickGraph","rollOverGraph","rollOutGraph");this.type="line";this.stackable=!0;this.columnCount=1;this.columnIndex=0;this.centerCustomBullets=this.showBalloon=!0;this.maxBulletSize=50;this.minBulletSize=4;this.balloonText="[[value]]";this.hidden=this.scrollbar=this.animationPlayed=!1;
this.pointPosition="middle";this.depthCount=1;this.includeInMinMax=!0;this.negativeBase=0;this.visibleInLegend=!0;this.showAllValueLabels=!1;this.showBulletsAt=this.showBalloonAt="close";this.lineThickness=1;this.dashLength=0;this.connect=!0;this.lineAlpha=1;this.bullet="none";this.bulletBorderThickness=2;this.bulletBorderAlpha=0;this.bulletAlpha=1;this.bulletSize=8;this.cornerRadiusTop=this.hideBulletsCount=this.bulletOffset=0;this.cursorBulletAlpha=1;this.gradientOrientation="vertical";this.dy=
this.dx=0;this.periodValue="";this.clustered=!0;this.periodSpan=1;this.accessibleLabel="[[title]] [[category]] [[value]]";this.accessibleSkipText="Press enter to skip [[title]]";this.y=this.x=0;this.switchable=!0;this.minDistance=.8;this.tcc=1;this.labelRotation=0;this.labelAnchor="auto";this.labelOffset=3;this.bcn="graph-";this.dateFormat="MMM DD, YYYY";this.noRounding=!0;d.applyTheme(this,a,this.cname)},init:function(){this.createBalloon()},draw:function(){var a=this.chart;a.isRolledOverBullet=
!1;var b=a.type;if(a.drawGraphs){isNaN(this.precision)||(this.numberFormatter?this.numberFormatter.precision=this.precision:this.numberFormatter={precision:this.precision,decimalSeparator:a.decimalSeparator,thousandsSeparator:a.thousandsSeparator});var c=a.container;this.container=c;this.destroy();var e=c.set();this.set=e;e.translate(this.x,this.y);var h=c.set();this.bulletSet=h;h.translate(this.x,this.y);this.behindColumns?(a.graphsBehindSet.push(e),a.bulletBehindSet.push(h)):(a.graphsSet.push(e),
a.bulletSet.push(h));var f=this.bulletAxis;d.isString(f)&&(this.bulletAxis=a.getValueAxisById(f));c=c.set();d.remove(this.columnsSet);this.columnsSet=c;d.setCN(a,e,"graph-"+this.type);d.setCN(a,e,"graph-"+this.id);d.setCN(a,h,"graph-"+this.type);d.setCN(a,h,"graph-"+this.id);this.columnsArray=[];this.ownColumns=[];this.allBullets=[];this.animationArray=[];h=this.labelPosition;h||(f=this.valueAxis.stackType,h="top","column"==this.type&&(a.rotate&&(h="right"),"100%"==f||"regular"==f)&&(h="middle"),
this.labelPosition=h);d.ifArray(this.data)&&(a=!1,"xy"==b?this.xAxis.axisCreated&&this.yAxis.axisCreated&&(a=!0):this.valueAxis.axisCreated&&(a=!0),!this.hidden&&a&&this.createGraph());e.push(c)}},createGraph:function(){var a=this,b=a.chart;a.startAlpha=b.startAlpha;a.seqAn=b.sequencedAnimation;a.baseCoord=a.valueAxis.baseCoord;void 0===a.fillAlphas&&(a.fillAlphas=0);a.bulletColorR=a.bulletColor;void 0===a.bulletColorR&&(a.bulletColorR=a.lineColorR,a.bulletColorNegative=a.negativeLineColor);void 0===
a.bulletAlpha&&(a.bulletAlpha=a.lineAlpha);if("step"==c||d.VML)a.noRounding=!1;var c=b.type;"gantt"==c&&(c="serial");clearTimeout(a.playedTO);if(!isNaN(a.valueAxis.min)&&!isNaN(a.valueAxis.max)){switch(c){case "serial":a.categoryAxis&&(a.createSerialGraph(),"candlestick"==a.type&&1>a.valueAxis.minMaxMultiplier&&a.positiveClip(a.set));break;case "radar":a.createRadarGraph();break;case "xy":a.createXYGraph()}a.playedTO=setTimeout(function(){a.setAnimationPlayed.call(a)},500*a.chart.startDuration)}},
setAnimationPlayed:function(){this.animationPlayed=!0},createXYGraph:function(){var a=[],b=[],c=this.xAxis,e=this.yAxis;this.pmh=e.height;this.pmw=c.width;this.pmy=this.pmx=0;var d;for(d=this.start;d<=this.end;d++){var f=this.data[d].axes[c.id].graphs[this.id],g=f.values,k=g.x,l=g.y,g=c.getCoordinate(k,this.noRounding),m=e.getCoordinate(l,this.noRounding);if(!isNaN(k)&&!isNaN(l)&&(a.push(g),b.push(m),f.x=g,f.y=m,k=this.createBullet(f,g,m,d),l=this.labelText)){var l=this.createLabel(f,l),p=0;k&&(p=
k.size);this.positionLabel(f,g,m,l,p)}}this.drawLineGraph(a,b);this.launchAnimation()},createRadarGraph:function(){var a=this.valueAxis.stackType,b=[],c=[],e=[],d=[],f,g,k,l,m;for(m=this.start;m<=this.end;m++){var p=this.data[m].axes[this.valueAxis.id].graphs[this.id],q,n;"none"==a||"3d"==a?q=p.values.value:(q=p.values.close,n=p.values.open);if(isNaN(q))this.connect||(this.drawLineGraph(b,c,e,d),b=[],c=[],e=[],d=[]);else{var t=this.valueAxis.getCoordinate(q,this.noRounding)-this.height,t=t*this.valueAxis.rMultiplier,
r=-360/(this.end-this.start+1)*m;"middle"==this.valueAxis.pointPosition&&(r-=180/(this.end-this.start+1));q=t*Math.sin(r/180*Math.PI);t*=Math.cos(r/180*Math.PI);b.push(q);c.push(t);if(!isNaN(n)){var w=this.valueAxis.getCoordinate(n,this.noRounding)-this.height,w=w*this.valueAxis.rMultiplier,z=w*Math.sin(r/180*Math.PI),r=w*Math.cos(r/180*Math.PI);e.push(z);d.push(r);isNaN(k)&&(k=z);isNaN(l)&&(l=r)}r=this.createBullet(p,q,t,m);p.x=q;p.y=t;if(z=this.labelText)z=this.createLabel(p,z),w=0,r&&(w=r.size),
this.positionLabel(p,q,t,z,w);isNaN(f)&&(f=q);isNaN(g)&&(g=t)}}b.push(f);c.push(g);isNaN(k)||(e.push(k),d.push(l));this.drawLineGraph(b,c,e,d);this.launchAnimation()},positionLabel:function(a,b,c,e,d){if(e){var f=this.chart,g=this.valueAxis,k="middle",l=!1,m=this.labelPosition,p=e.getBBox(),q=this.chart.rotate,n=a.isNegative,t=this.fontSize;void 0===t&&(t=this.chart.fontSize);c-=p.height/2-t/2-1;void 0!==a.labelIsNegative&&(n=a.labelIsNegative);switch(m){case "right":m=q?n?"left":"right":"right";
break;case "top":m=q?"top":n?"bottom":"top";break;case "bottom":m=q?"bottom":n?"top":"bottom";break;case "left":m=q?n?"right":"left":"left"}var t=a.columnGraphics,r=0,w=0;t&&(r=t.x,w=t.y);var z=this.labelOffset;switch(m){case "right":k="start";b+=d/2+z;break;case "top":c=g.reversed?c+(d/2+p.height/2+z):c-(d/2+p.height/2+z);break;case "bottom":c=g.reversed?c-(d/2+p.height/2+z):c+(d/2+p.height/2+z);break;case "left":k="end";b-=d/2+z;break;case "inside":"column"==this.type&&(l=!0,q?n?(k="end",b=r-3-
z):(k="start",b=r+3+z):c=n?w+7+z:w-10-z);break;case "middle":"column"==this.type&&(l=!0,q?b-=(b-r)/2+z-3:c-=(c-w)/2+z-3)}"auto"!=this.labelAnchor&&(k=this.labelAnchor);e.attr({"text-anchor":k});this.labelRotation&&e.rotate(this.labelRotation);e.translate(b,c);!this.showAllValueLabels&&t&&l&&(p=e.getBBox(),p.height>a.columnHeight||p.width>a.columnWidth)&&(e.remove(),e=null);if(e&&"radar"!=f.type)if(q){if(0>c||c>this.height)e.remove(),e=null;!this.showAllValueLabels&&e&&(0>b||b>this.width)&&(e.remove(),
e=null)}else{if(0>b||b>this.width)e.remove(),e=null;!this.showAllValueLabels&&e&&(0>c||c>this.height)&&(e.remove(),e=null)}e&&this.allBullets.push(e);return e}},getGradRotation:function(){var a=270;"horizontal"==this.gradientOrientation&&(a=0);return this.gradientRotation=a},createSerialGraph:function(){this.dashLengthSwitched=this.fillColorsSwitched=this.lineColorSwitched=void 0;var a=this.chart,b=this.id,c=this.index,e=this.data,h=this.chart.container,f=this.valueAxis,g=this.type,k=this.columnWidthReal,
l=this.showBulletsAt;isNaN(this.columnWidth)||(k=this.columnWidth);isNaN(k)&&(k=.8);var m=this.useNegativeColorIfDown,p=this.width,q=this.height,n=this.y,t=this.rotate,r=this.columnCount,w=d.toCoordinate(this.cornerRadiusTop,k/2),z=this.connect,x=[],u=[],A,y,B,D,C=this.chart.graphs.length,I,H=this.dx/this.tcc,Q=this.dy/this.tcc,M=f.stackType,P=this.start,ia=this.end,J=this.scrollbar,aa="graph-column-";J&&(aa="scrollbar-graph-column-");var ma=this.categoryAxis,na=this.baseCoord,Pa=this.negativeBase,
Z=this.columnIndex,da=this.lineThickness,X=this.lineAlpha,xa=this.lineColorR,ea=this.dashLength,fa=this.set,Ba,ga=this.getGradRotation(),V=this.chart.columnSpacing,Y=ma.cellWidth,Da=(Y*k-r)/r;V>Da&&(V=Da);var G,v,oa,ha=q,Qa=p,ca=0,tb=0,ub=0,vb=0,gb=0,hb=0,wb=this.fillColorsR,Ra=this.negativeFillColors,Ja=this.negativeLineColor,Ya=this.fillAlphas,Za=this.negativeFillAlphas;"object"==typeof Ya&&(Ya=Ya[0]);"object"==typeof Za&&(Za=Za[0]);var xb=this.noRounding;"step"==g&&(xb=!1);var ib=f.getCoordinate(f.min);
f.logarithmic&&(ib=f.getCoordinate(f.minReal));this.minCoord=ib;this.resetBullet&&(this.bullet="none");if(!(J||"line"!=g&&"smoothedLine"!=g&&"step"!=g||(1==e.length&&"step"!=g&&"none"==this.bullet&&(this.bullet="round",this.resetBullet=!0),!Ra&&void 0==Ja||m))){var Ua=Pa;Ua>f.max&&(Ua=f.max);Ua<f.min&&(Ua=f.min);f.logarithmic&&(Ua=f.minReal);var Ka=f.getCoordinate(Ua),Mb=f.getCoordinate(f.max);t?(ha=q,Qa=Math.abs(Mb-Ka),ub=q,vb=Math.abs(ib-Ka),hb=tb=0,f.reversed?(ca=0,gb=Ka):(ca=Ka,gb=0)):(Qa=p,ha=
Math.abs(Mb-Ka),vb=p,ub=Math.abs(ib-Ka),gb=ca=0,f.reversed?(hb=n,tb=Ka):hb=Ka)}var La=Math.round;this.pmx=La(ca);this.pmy=La(tb);this.pmh=La(ha);this.pmw=La(Qa);this.nmx=La(gb);this.nmy=La(hb);this.nmh=La(ub);this.nmw=La(vb);d.isModern||(this.nmy=this.nmx=0,this.nmh=this.height);this.clustered||(r=1);k="column"==g?(Y*k-V*(r-1))/r:Y*k;1>k&&(k=1);var Nb=this.fixedColumnWidth;isNaN(Nb)||(k=Nb);var L;if("line"==g||"step"==g||"smoothedLine"==g){if(0<P){for(L=P-1;-1<L;L--)if(G=e[L],v=G.axes[f.id].graphs[b],
oa=v.values.value,!isNaN(oa)){P=L;break}if(this.lineColorField)for(L=P;-1<L;L--)if(G=e[L],v=G.axes[f.id].graphs[b],v.lineColor){this.lineColorSwitched=v.lineColor;void 0===this.bulletColor&&(this.bulletColorSwitched=this.lineColorSwitched);break}if(this.fillColorsField)for(L=P;-1<L;L--)if(G=e[L],v=G.axes[f.id].graphs[b],v.fillColors){this.fillColorsSwitched=v.fillColors;break}if(this.dashLengthField)for(L=P;-1<L;L--)if(G=e[L],v=G.axes[f.id].graphs[b],!isNaN(v.dashLength)){this.dashLengthSwitched=
v.dashLength;break}}if(ia<e.length-1)for(L=ia+1;L<e.length;L++)if(G=e[L],v=G.axes[f.id].graphs[b],oa=v.values.value,!isNaN(oa)){ia=L;break}}ia<e.length-1&&ia++;var T=[],U=[],Ma=!1;if("line"==g||"step"==g||"smoothedLine"==g)if(this.stackable&&"regular"==M||"100%"==M||this.fillToGraph)Ma=!0;var Ob=this.noStepRisers,jb=-1E3,kb=-1E3,lb=this.minDistance,Sa=!0,$a=!1;for(L=P;L<=ia;L++){G=e[L];v=G.axes[f.id].graphs[b];v.index=L;var ab,Ta=NaN;if(m&&void 0==this.openField)for(var yb=L+1;yb<e.length&&(!e[yb]||
!(ab=e[L+1].axes[f.id].graphs[b])||!ab.values||(Ta=ab.values.value,isNaN(Ta)));yb++);var S,R,K,ba,ja=NaN,E=NaN,F=NaN,O=NaN,N=NaN,qa=NaN,ra=NaN,sa=NaN,ta=NaN,ya=NaN,Ea=NaN,ka=NaN,la=NaN,W=NaN,zb=NaN,Ab=NaN,ua=NaN,va=void 0,Na=wb,Va=Ya,Ha=xa,Ca,za,Bb=this.proCandlesticks,mb=this.topRadius,Fa=q-1,pa=p-1,bb=this.pattern;void 0!=v.pattern&&(bb=v.pattern);isNaN(v.alpha)||(Va=v.alpha);isNaN(v.dashLength)||(ea=v.dashLength);var Ia=v.values;f.recalculateToPercents&&(Ia=v.percents);"none"==M&&(Z=isNaN(v.columnIndex)?
this.columnIndex:v.columnIndex);if(Ia){W=this.stackable&&"none"!=M&&"3d"!=M?Ia.close:Ia.value;if("candlestick"==g||"ohlc"==g)W=Ia.close,Ab=Ia.low,ra=f.getCoordinate(Ab),zb=Ia.high,ta=f.getCoordinate(zb);ua=Ia.open;F=f.getCoordinate(W,xb);isNaN(ua)||(N=f.getCoordinate(ua,xb),m&&"regular"!=M&&"100%"!=M&&(Ta=ua,ua=N=NaN));m&&(void 0==this.openField?ab&&(ab.isNegative=Ta<W?!0:!1,isNaN(Ta)&&(v.isNegative=!Sa)):v.isNegative=Ta>W?!0:!1);if(!J)switch(this.showBalloonAt){case "close":v.y=F;break;case "open":v.y=
N;break;case "high":v.y=ta;break;case "low":v.y=ra}var ja=G.x[ma.id],Wa=this.periodSpan-1;"step"!=g||isNaN(G.cellWidth)||(Y=G.cellWidth);var wa=Math.floor(Y/2)+Math.floor(Wa*Y/2),Ga=wa,nb=0;"left"==this.stepDirection&&(nb=(2*Y+Wa*Y)/2,ja-=nb);"center"==this.stepDirection&&(nb=Y/2,ja-=nb);"start"==this.pointPosition&&(ja-=Y/2+Math.floor(Wa*Y/2),wa=0,Ga=Math.floor(Y)+Math.floor(Wa*Y));"end"==this.pointPosition&&(ja+=Y/2+Math.floor(Wa*Y/2),wa=Math.floor(Y)+Math.floor(Wa*Y),Ga=0);if(Ob){var Cb=this.columnWidth;
isNaN(Cb)||(wa*=Cb,Ga*=Cb)}J||(v.x=ja);-1E5>ja&&(ja=-1E5);ja>p+1E5&&(ja=p+1E5);t?(E=F,O=N,N=F=ja,isNaN(ua)&&!this.fillToGraph&&(O=na),qa=ra,sa=ta):(O=E=ja,isNaN(ua)&&!this.fillToGraph&&(N=na));if(!Bb&&W<ua||Bb&&W<Ba)v.isNegative=!0,Ra&&(Na=Ra),Za&&(Va=Za),void 0!=Ja&&(Ha=Ja);$a=!1;isNaN(W)||(m?W>Ta?(Sa&&($a=!0),Sa=!1):(Sa||($a=!0),Sa=!0):v.isNegative=W<Pa?!0:!1,Ba=W);var Pb=!1;J&&a.chartScrollbar.ignoreCustomColors&&(Pb=!0);Pb||(void 0!=v.color&&(Na=v.color),v.fillColors&&(Na=v.fillColors));F=d.fitToBounds(F,
-3E4,3E4);switch(g){case "line":if(isNaN(W))z||(this.drawLineGraph(x,u,T,U),x=[],u=[],T=[],U=[]);else{if(Math.abs(E-jb)>=lb||Math.abs(F-kb)>=lb)x.push(E),u.push(F),jb=E,kb=F;ya=E;Ea=F;ka=E;la=F;!Ma||isNaN(N)||isNaN(O)||(T.push(O),U.push(N));if($a||void 0!=v.lineColor&&v.lineColor!=this.lineColorSwitched||void 0!=v.fillColors&&v.fillColors!=this.fillColorsSwitched||!isNaN(v.dashLength))this.drawLineGraph(x,u,T,U),x=[E],u=[F],T=[],U=[],!Ma||isNaN(N)||isNaN(O)||(T.push(O),U.push(N)),m?(Sa?(this.lineColorSwitched=
xa,this.fillColorsSwitched=wb):(this.lineColorSwitched=Ja,this.fillColorsSwitched=Ra),void 0===this.bulletColor&&(this.bulletColorSwitched=xa)):(this.lineColorSwitched=v.lineColor,this.fillColorsSwitched=v.fillColors,void 0===this.bulletColor&&(this.bulletColorSwitched=this.lineColorSwitched)),this.dashLengthSwitched=v.dashLength;v.gap&&(this.drawLineGraph(x,u,T,U),x=[],u=[],T=[],U=[])}break;case "smoothedLine":if(isNaN(W))z||(this.drawSmoothedGraph(x,u,T,U),x=[],u=[],T=[],U=[]);else{if(Math.abs(E-
jb)>=lb||Math.abs(F-kb)>=lb)x.push(E),u.push(F),jb=E,kb=F;ya=E;Ea=F;ka=E;la=F;!Ma||isNaN(N)||isNaN(O)||(T.push(O),U.push(N));void 0==v.lineColor&&void 0==v.fillColors&&isNaN(v.dashLength)||(this.drawSmoothedGraph(x,u,T,U),x=[E],u=[F],T=[],U=[],!Ma||isNaN(N)||isNaN(O)||(T.push(O),U.push(N)),this.lineColorSwitched=v.lineColor,this.fillColorsSwitched=v.fillColors,this.dashLengthSwitched=v.dashLength);v.gap&&(this.drawSmoothedGraph(x,u,T,U),x=[],u=[],T=[],U=[])}break;case "step":if(!isNaN(W)){t?(isNaN(A)||
(x.push(A),u.push(F-wa)),u.push(F-wa),x.push(E),u.push(F+Ga),x.push(E),!Ma||isNaN(N)||isNaN(O)||(isNaN(B)||(T.push(B),U.push(N-wa)),T.push(O),U.push(N-wa),T.push(O),U.push(N+Ga))):(isNaN(y)||(u.push(y),x.push(E-wa)),x.push(E-wa),u.push(F),x.push(E+Ga),u.push(F),!Ma||isNaN(N)||isNaN(O)||(isNaN(D)||(T.push(O-wa),U.push(D)),T.push(O-wa),U.push(N),T.push(O+Ga),U.push(N)));A=E;y=F;B=O;D=N;ya=E;Ea=F;ka=E;la=F;if($a||void 0!=v.lineColor||void 0!=v.fillColors||!isNaN(v.dashLength)){var Db=x[x.length-2],dc=
u[u.length-2];x.pop();u.pop();T.pop();U.pop();this.drawLineGraph(x,u,T,U);x=[Db];u=[dc];T=[];U=[];Ma&&(T=[Db,Db+wa+Ga],U=[D,D]);t?(u.push(F+Ga),x.push(E)):(x.push(E+Ga),u.push(F));this.lineColorSwitched=v.lineColor;this.fillColorsSwitched=v.fillColors;this.dashLengthSwitched=v.dashLength;m&&(Sa?(this.lineColorSwitched=xa,this.fillColorsSwitched=wb):(this.lineColorSwitched=Ja,this.fillColorsSwitched=Ra))}if(Ob||v.gap)A=y=NaN,this.drawLineGraph(x,u,T,U),x=[],u=[],T=[],U=[]}else if(!z){if(1>=this.periodSpan||
1<this.periodSpan&&E-A>wa+Ga)A=y=NaN;this.drawLineGraph(x,u,T,U);x=[];u=[];T=[];U=[]}break;case "column":Ca=Ha;void 0!=v.lineColor&&(Ca=v.lineColor);if(!isNaN(W)){m||(v.isNegative=W<Pa?!0:!1);v.isNegative&&(Ra&&(Na=Ra),void 0!=Ja&&(Ca=Ja));var Qb=f.min,Rb=f.max,ob=ua;isNaN(ob)&&(ob=Pa);if(!(W<Qb&&ob<Qb||W>Rb&&ob>Rb)){var Aa;if(t){"3d"==M?(R=F-(r/2-this.depthCount+1)*(k+V)+V/2+Q*Z,S=O+H*Z,Aa=Z):(R=Math.floor(F-(r/2-Z)*(k+V)+V/2),S=O,Aa=0);K=k;ya=E;Ea=R+k/2;ka=E;la=R+k/2;R+K>q+Aa*Q&&(K=q-R+Aa*Q);R<
Aa*Q&&(K+=R,R=Aa*Q);ba=E-O;var ec=S;S=d.fitToBounds(S,0,p);ba+=ec-S;ba=d.fitToBounds(ba,-S,p-S+H*Z);v.labelIsNegative=0>ba?!0:!1;0===ba&&1/W===1/-0&&(v.labelIsNegative=!0);isNaN(G.percentWidthValue)||(K=this.height*G.percentWidthValue/100,R=ja-K/2,Ea=R+K/2);K=d.roundTo(K,2);ba=d.roundTo(ba,2);R<q&&0<K&&(va=new d.Cuboid(h,ba,K,H-a.d3x,Q-a.d3y,Na,Va,da,Ca,X,ga,w,t,ea,bb,mb,aa),v.columnWidth=Math.abs(ba),v.columnHeight=Math.abs(K))}else{"3d"==M?(S=E-(r/2-this.depthCount+1)*(k+V)+V/2+H*Z,R=N+Q*Z,Aa=Z):
(S=E-(r/2-Z)*(k+V)+V/2,R=N,Aa=0);K=k;ya=S+k/2;Ea=F;ka=S+k/2;la=F;S+K>p+Aa*H&&(K=p-S+Aa*H);S<Aa*H&&(K+=S-Aa*H,S=Aa*H);ba=F-N;v.labelIsNegative=0<ba?!0:!1;0===ba&&1/W!==1/Math.abs(W)&&(v.labelIsNegative=!0);var fc=R;R=d.fitToBounds(R,this.dy,q);ba+=fc-R;ba=d.fitToBounds(ba,-R+Q*Aa,q-R);isNaN(G.percentWidthValue)||(K=this.width*G.percentWidthValue/100,S=ja-K/2,ya=S+K/2);K=d.roundTo(K,2);ba=d.roundTo(ba,2);S<p+Z*H&&0<K&&(this.showOnAxis&&(R-=Q/2),va=new d.Cuboid(h,K,ba,H-a.d3x,Q-a.d3y,Na,Va,da,Ca,this.lineAlpha,
ga,w,t,ea,bb,mb,aa),v.columnHeight=Math.abs(ba),v.columnWidth=Math.abs(K))}}if(va){za=va.set;d.setCN(a,va.set,"graph-"+this.type);d.setCN(a,va.set,"graph-"+this.id);v.className&&d.setCN(a,va.set,v.className,!0);v.columnGraphics=za;S=d.roundTo(S,2);R=d.roundTo(R,2);za.translate(S,R);(v.url||this.showHandOnHover)&&za.setAttr("cursor","pointer");if(!J){"none"==M&&(I=t?(this.end+1-L)*C-c:C*L+c);"3d"==M&&(t?(I=(this.end+1-L)*C-c-1E3*this.depthCount,ya+=H*Z,ka+=H*Z,v.y+=H*Z):(I=(C-c)*(L+1)+1E3*this.depthCount,
Ea+=Q*Z,la+=Q*Z,v.y+=Q*Z));if("regular"==M||"100%"==M)I=t?0<Ia.value?(this.end+1-L)*C+c:(this.end+1-L)*C-c:0<Ia.value?C*L+c:C*L-c;this.columnsArray.push({column:va,depth:I});v.x=t?R+K/2:S+K/2;this.ownColumns.push(va);this.animateColumns(va,L,E,O,F,N);this.addListeners(za,v);void 0!==this.tabIndex&&za.setAttr("tabindex",this.tabIndex)}this.columnsSet.push(za)}}break;case "candlestick":if(!isNaN(ua)&&!isNaN(W)){var Xa,cb;Ca=Ha;void 0!=v.lineColor&&(Ca=v.lineColor);ya=E;la=Ea=F;ka=E;if(t){"open"==l&&
(ka=O);"high"==l&&(ka=sa);"low"==l&&(ka=qa);E=d.fitToBounds(E,0,pa);O=d.fitToBounds(O,0,pa);qa=d.fitToBounds(qa,0,pa);sa=d.fitToBounds(sa,0,pa);if(0===E&&0===O&&0===qa&&0===sa)continue;if(E==pa&&O==pa&&qa==pa&&sa==pa)continue;R=F-k/2;S=O;K=k;R+K>q&&(K=q-R);0>R&&(K+=R,R=0);if(R<q&&0<K){var Eb,Fb;W>ua?(Eb=[E,sa],Fb=[O,qa]):(Eb=[O,sa],Fb=[E,qa]);!isNaN(sa)&&!isNaN(qa)&&F<q&&0<F&&(Xa=d.line(h,Eb,[F,F],Ca,X,da),cb=d.line(h,Fb,[F,F],Ca,X,da));ba=E-O;va=new d.Cuboid(h,ba,K,H,Q,Na,Ya,da,Ca,X,ga,w,t,ea,bb,
mb,aa)}}else{"open"==l&&(la=N);"high"==l&&(la=ta);"low"==l&&(la=ra);F=d.fitToBounds(F,0,Fa);N=d.fitToBounds(N,0,Fa);ra=d.fitToBounds(ra,0,Fa);ta=d.fitToBounds(ta,0,Fa);if(0===F&&0===N&&0===ra&&0===ta)continue;if(F==Fa&&N==Fa&&ra==Fa&&ta==Fa)continue;S=E-k/2;R=N+da/2;K=k;S+K>p&&(K=p-S);0>S&&(K+=S,S=0);ba=F-N;if(S<p&&0<K){Bb&&W>=ua&&(Va=0);var va=new d.Cuboid(h,K,ba,H,Q,Na,Va,da,Ca,X,ga,w,t,ea,bb,mb,aa),Gb,Hb;W>ua?(Gb=[F,ta],Hb=[N,ra]):(Gb=[N,ta],Hb=[F,ra]);!isNaN(ta)&&!isNaN(ra)&&E<p&&0<E&&(Xa=d.line(h,
[E,E],Gb,Ca,X,da),cb=d.line(h,[E,E],Hb,Ca,X,da),d.setCN(a,Xa,this.bcn+"line-high"),v.className&&d.setCN(a,Xa,v.className,!0),d.setCN(a,cb,this.bcn+"line-low"),v.className&&d.setCN(a,cb,v.className,!0))}}va&&(za=va.set,v.columnGraphics=za,fa.push(za),za.translate(S,R-da/2),(v.url||this.showHandOnHover)&&za.setAttr("cursor","pointer"),Xa&&(fa.push(Xa),fa.push(cb)),J||(v.x=t?R+K/2:S+K/2,this.animateColumns(va,L,E,O,F,N),this.addListeners(za,v),void 0!==this.tabIndex&&za.setAttr("tabindex",this.tabIndex)))}break;
case "ohlc":if(!(isNaN(ua)||isNaN(zb)||isNaN(Ab)||isNaN(W))){var Sb=h.set();fa.push(Sb);W<ua&&(v.isNegative=!0,void 0!=Ja&&(Ha=Ja));void 0!=v.lineColor&&(Ha=v.lineColor);var pb,qb,rb;if(t){la=F;ka=E;"open"==l&&(ka=O);"high"==l&&(ka=sa);"low"==l&&(ka=qa);qa=d.fitToBounds(qa,0,pa);sa=d.fitToBounds(sa,0,pa);if(0===E&&0===O&&0===qa&&0===sa)continue;if(E==pa&&O==pa&&qa==pa&&sa==pa)continue;var Ib=F-k/2,Ib=d.fitToBounds(Ib,0,q),Tb=d.fitToBounds(F,0,q),Jb=F+k/2,Jb=d.fitToBounds(Jb,0,q);0<=O&&O<=pa&&(qb=
d.line(h,[O,O],[Ib,Tb],Ha,X,da,ea));0<F&&F<q&&(pb=d.line(h,[qa,sa],[F,F],Ha,X,da,ea));0<=E&&E<=pa&&(rb=d.line(h,[E,E],[Tb,Jb],Ha,X,da,ea))}else{la=F;"open"==l&&(la=N);"high"==l&&(la=ta);"low"==l&&(la=ra);var ka=E,ra=d.fitToBounds(ra,0,Fa),ta=d.fitToBounds(ta,0,Fa),Kb=E-k/2,Kb=d.fitToBounds(Kb,0,p),Ub=d.fitToBounds(E,0,p),Lb=E+k/2,Lb=d.fitToBounds(Lb,0,p);0<=N&&N<=Fa&&(qb=d.line(h,[Kb,Ub],[N,N],Ha,X,da,ea));0<E&&E<p&&(pb=d.line(h,[E,E],[ra,ta],Ha,X,da,ea));0<=F&&F<=Fa&&(rb=d.line(h,[Ub,Lb],[F,F],Ha,
X,da,ea))}fa.push(qb);fa.push(pb);fa.push(rb);d.setCN(a,qb,this.bcn+"stroke-open");d.setCN(a,rb,this.bcn+"stroke-close");d.setCN(a,pb,this.bcn+"stroke");v.className&&d.setCN(a,Sb,v.className,!0);ya=E;Ea=F}}if(!J&&!isNaN(W)){var Vb=this.hideBulletsCount;if(this.end-this.start<=Vb||0===Vb){var Wb=this.createBullet(v,ka,la,L),Xb=this.labelText;if(Xb&&!isNaN(ya)&&!isNaN(ya)){var gc=this.createLabel(v,Xb),Yb=0;Wb&&(Yb=Wb.size);this.positionLabel(v,ya,Ea,gc,Yb)}if("regular"==M||"100%"==M){var Zb=f.totalText;
if(Zb){var Oa=this.createLabel(v,Zb,f.totalTextColor);d.setCN(a,Oa,this.bcn+"label-total");this.allBullets.push(Oa);if(Oa){var $b=Oa.getBBox(),ac=$b.width,bc=$b.height,db,eb,sb=f.totalTextOffset,cc=f.totals[L];cc&&cc.remove();var fb=0;"column"!=g&&(fb=this.bulletSize);t?(eb=Ea,db=0>W?E-ac/2-2-fb-sb:E+ac/2+3+fb+sb):(db=ya,eb=0>W?F+bc/2+fb+sb:F-bc/2-3-fb-sb);Oa.translate(db,eb);f.totals[L]=Oa;t?(0>eb||eb>q)&&Oa.remove():(0>db||db>p)&&Oa.remove()}}}}}}}this.lastDataItem=v;if("line"==g||"step"==g||"smoothedLine"==
g)"smoothedLine"==g?this.drawSmoothedGraph(x,u,T,U):this.drawLineGraph(x,u,T,U),J||this.launchAnimation();this.bulletsHidden&&this.hideBullets();this.customBulletsHidden&&this.hideCustomBullets()},animateColumns:function(a,b){var c=this,e=c.chart.startDuration;0<e&&!c.animationPlayed&&(c.seqAn?(a.set.hide(),c.animationArray.push(a),e=setTimeout(function(){c.animate.call(c)},e/(c.end-c.start+1)*(b-c.start)*1E3),c.timeOuts.push(e)):c.animate(a),c.chart.animatable.push(a))},createLabel:function(a,b,
c){var e=this.chart,h=a.labelColor;h||(h=this.color);h||(h=e.color);c&&(h=c);c=this.fontSize;void 0===c&&(this.fontSize=c=e.fontSize);var f=this.labelFunction;b=e.formatString(b,a);b=d.cleanFromEmpty(b);f&&(b=f(a,b));if(void 0!==b&&""!==b)return a=d.text(this.container,b,h,e.fontFamily,c),a.node.style.pointerEvents="none",d.setCN(e,a,this.bcn+"label"),this.bulletSet.push(a),a},positiveClip:function(a){a.clipRect(this.pmx,this.pmy,this.pmw,this.pmh)},negativeClip:function(a){a.clipRect(this.nmx,this.nmy,
this.nmw,this.nmh)},drawLineGraph:function(a,b,c,e){var h=this;if(1<a.length){var f=h.noRounding,g=h.set,k=h.chart,l=h.container,m=l.set(),p=l.set();g.push(p);g.push(m);var q=h.lineAlpha,n=h.lineThickness,g=h.fillAlphas,t=h.lineColorR,r=h.negativeLineAlpha;isNaN(r)&&(r=q);var w=h.lineColorSwitched;w&&(t=w);var w=h.fillColorsR,z=h.fillColorsSwitched;z&&(w=z);var x=h.dashLength;(z=h.dashLengthSwitched)&&(x=z);var z=h.negativeLineColor,u=h.negativeFillColors,A=h.negativeFillAlphas,y=h.baseCoord;0!==
h.negativeBase&&(y=h.valueAxis.getCoordinate(h.negativeBase,f),y>h.height&&(y=h.height),0>y&&(y=0));q=d.line(l,a,b,t,q,n,x,!1,!0,f);q.node.setAttribute("stroke-linejoin","round");d.setCN(k,q,h.bcn+"stroke");m.push(q);m.click(function(a){h.handleGraphEvent(a,"clickGraph")}).mouseover(function(a){h.handleGraphEvent(a,"rollOverGraph")}).mouseout(function(a){h.handleGraphEvent(a,"rollOutGraph")}).touchmove(function(a){h.chart.handleMouseMove(a)}).touchend(function(a){h.chart.handleTouchEnd(a)});void 0===
z||h.useNegativeColorIfDown||(n=d.line(l,a,b,z,r,n,x,!1,!0,f),n.node.setAttribute("stroke-linejoin","round"),d.setCN(k,n,h.bcn+"stroke"),d.setCN(k,n,h.bcn+"stroke-negative"),p.push(n));if(0<g||0<A)if(n=a.join(";").split(";"),r=b.join(";").split(";"),q=k.type,"serial"==q||"radar"==q?0<c.length?(c.reverse(),e.reverse(),n=a.concat(c),r=b.concat(e)):"radar"==q?(r.push(0),n.push(0)):h.rotate?(r.push(r[r.length-1]),n.push(y),r.push(r[0]),n.push(y),r.push(r[0]),n.push(n[0])):(n.push(n[n.length-1]),r.push(y),
n.push(n[0]),r.push(y),n.push(a[0]),r.push(r[0])):"xy"==q&&(b=h.fillToAxis)&&(d.isString(b)&&(b=k.getValueAxisById(b)),"H"==b.orientation?(y="top"==b.position?0:b.height,n.push(n[n.length-1]),r.push(y),n.push(n[0]),r.push(y),n.push(a[0]),r.push(r[0])):(y="left"==b.position?0:b.width,r.push(r[r.length-1]),n.push(y),r.push(r[0]),n.push(y),r.push(r[0]),n.push(n[0]))),a=h.gradientRotation,0<g&&(b=d.polygon(l,n,r,w,g,1,"#000",0,a,f),b.pattern(h.pattern,NaN,k.path),d.setCN(k,b,h.bcn+"fill"),m.push(b)),
u||void 0!==z)isNaN(A)&&(A=g),u||(u=z),f=d.polygon(l,n,r,u,A,1,"#000",0,a,f),d.setCN(k,f,h.bcn+"fill"),d.setCN(k,f,h.bcn+"fill-negative"),f.pattern(h.pattern,NaN,k.path),p.push(f),p.click(function(a){h.handleGraphEvent(a,"clickGraph")}).mouseover(function(a){h.handleGraphEvent(a,"rollOverGraph")}).mouseout(function(a){h.handleGraphEvent(a,"rollOutGraph")}).touchmove(function(a){h.chart.handleMouseMove(a)}).touchend(function(a){h.chart.handleTouchEnd(a)});h.applyMask(p,m)}},applyMask:function(a,b){var c=
a.length();"serial"!=this.chart.type||this.scrollbar||(this.positiveClip(b),0<c&&this.negativeClip(a))},drawSmoothedGraph:function(a,b,c,e){if(1<a.length){var h=this.set,f=this.chart,g=this.container,k=g.set(),l=g.set();h.push(l);h.push(k);var m=this.lineAlpha,p=this.lineThickness,h=this.dashLength,q=this.fillAlphas,n=this.lineColorR,t=this.fillColorsR,r=this.negativeLineColor,w=this.negativeFillColors,z=this.negativeFillAlphas,x=this.baseCoord,u=this.lineColorSwitched;u&&(n=u);(u=this.fillColorsSwitched)&&
(t=u);var A=this.negativeLineAlpha;isNaN(A)&&(A=m);u=this.getGradRotation();m=new d.Bezier(g,a,b,n,m,p,t,0,h,void 0,u);d.setCN(f,m,this.bcn+"stroke");k.push(m.path);void 0!==r&&(p=new d.Bezier(g,a,b,r,A,p,t,0,h,void 0,u),d.setCN(f,p,this.bcn+"stroke"),d.setCN(f,p,this.bcn+"stroke-negative"),l.push(p.path));0<q&&(p=a.join(";").split(";"),m=b.join(";").split(";"),n="",0<c.length?(c.push("M"),e.push("M"),c.reverse(),e.reverse(),p=a.concat(c),m=b.concat(e)):(this.rotate?(n+=" L"+x+","+b[b.length-1],n+=
" L"+x+","+b[0]):(n+=" L"+a[a.length-1]+","+x,n+=" L"+a[0]+","+x),n+=" L"+a[0]+","+b[0]),a=new d.Bezier(g,p,m,NaN,0,0,t,q,h,n,u),d.setCN(f,a,this.bcn+"fill"),a.path.pattern(this.pattern,NaN,f.path),k.push(a.path),w||void 0!==r)&&(z||(z=q),w||(w=r),g=new d.Bezier(g,p,m,NaN,0,0,w,z,h,n,u),g.path.pattern(this.pattern,NaN,f.path),d.setCN(f,g,this.bcn+"fill"),d.setCN(f,g,this.bcn+"fill-negative"),l.push(g.path));this.applyMask(l,k)}},launchAnimation:function(){var a=this,b=a.chart.startDuration;if(0<b&&
!a.animationPlayed){var c=a.set,e=a.bulletSet;d.VML||(c.attr({opacity:a.startAlpha}),e.attr({opacity:a.startAlpha}));c.hide();e.hide();a.seqAn?(b=setTimeout(function(){a.animateGraphs.call(a)},a.index*b*1E3),a.timeOuts.push(b)):a.animateGraphs()}},animateGraphs:function(){var a=this.chart,b=this.set,c=this.bulletSet,e=this.x,d=this.y;b.show();c.show();var f=a.startDuration,g=a.startEffect;b&&(this.rotate?(b.translate(-1E3,d),c.translate(-1E3,d)):(b.translate(e,-1E3),c.translate(e,-1E3)),b.animate({opacity:1,
translate:e+","+d},f,g),c.animate({opacity:1,translate:e+","+d},f,g),a.animatable.push(b))},animate:function(a){var b=this.chart,c=this.animationArray;!a&&0<c.length&&(a=c[0],c.shift());c=d[d.getEffect(b.startEffect)];b=b.startDuration;a&&(this.rotate?a.animateWidth(b,c):a.animateHeight(b,c),a.set.show())},legendKeyColor:function(){var a=this.legendColor,b=this.lineAlpha;void 0===a&&(a=this.lineColorR,0===b&&(b=this.fillColorsR)&&(a="object"==typeof b?b[0]:b));return a},legendKeyAlpha:function(){var a=
this.legendAlpha;void 0===a&&(a=this.lineAlpha,this.fillAlphas>a&&(a=this.fillAlphas),0===a&&(a=this.bulletAlpha),0===a&&(a=1));return a},createBullet:function(a,b,c){if(!isNaN(b)&&!isNaN(c)&&("none"!=this.bullet||this.customBullet||a.bullet||a.customBullet)){var e=this.chart,h=this.container,f=this.bulletOffset,g=this.bulletSize;isNaN(a.bulletSize)||(g=a.bulletSize);var k=a.values.value,l=this.maxValue,m=this.minValue,p=this.maxBulletSize,q=this.minBulletSize;isNaN(l)||(isNaN(k)||(g=(k-m)/(l-m)*
(p-q)+q),m==l&&(g=p));l=g;this.bulletAxis&&(g=a.values.error,isNaN(g)||(k=g),g=this.bulletAxis.stepWidth*k);g<this.minBulletSize&&(g=this.minBulletSize);this.rotate?b=a.isNegative?b-f:b+f:c=a.isNegative?c+f:c-f;q=this.bulletColorR;a.lineColor&&void 0===this.bulletColor&&(this.bulletColorSwitched=a.lineColor);this.bulletColorSwitched&&(q=this.bulletColorSwitched);a.isNegative&&void 0!==this.bulletColorNegative&&(q=this.bulletColorNegative);void 0!==a.color&&(q=a.color);var n;"xy"==e.type&&this.valueField&&
(n=this.pattern,a.pattern&&(n=a.pattern));f=this.bullet;a.bullet&&(f=a.bullet);var k=this.bulletBorderThickness,m=this.bulletBorderColorR,p=this.bulletBorderAlpha,t=this.bulletAlpha;m||(m=q);this.useLineColorForBulletBorder&&(m=this.lineColorR,a.isNegative&&this.negativeLineColor&&(m=this.negativeLineColor),this.lineColorSwitched&&(m=this.lineColorSwitched));var r=a.alpha;isNaN(r)||(t=r);n=d.bullet(h,f,g,q,t,k,m,p,l,0,n,e.path);l=this.customBullet;a.customBullet&&(l=a.customBullet);l&&(n&&n.remove(),
"function"==typeof l?(l=new l,l.chart=e,a.bulletConfig&&(l.availableSpace=c,l.graph=this,l.graphDataItem=a,l.bulletY=c,a.bulletConfig.minCoord=this.minCoord-c,l.bulletConfig=a.bulletConfig),l.write(h),n&&l.showBullet&&l.set.push(n),a.customBulletGraphics=l.cset,n=l.set):(n=h.set(),l=h.image(l,0,0,g,g),n.push(l),this.centerCustomBullets&&l.translate(-g/2,-g/2)));if(n){(a.url||this.showHandOnHover)&&n.setAttr("cursor","pointer");if("serial"==e.type||"gantt"==e.type)if(-.5>b||b>this.width||c<-g/2||c>
this.height)n.remove(),n=null;n&&(this.bulletSet.push(n),n.translate(b,c),this.addListeners(n,a),this.allBullets.push(n));a.bx=b;a.by=c;d.setCN(e,n,this.bcn+"bullet");a.className&&d.setCN(e,n,a.className,!0)}if(n){n.size=g||0;if(e=this.bulletHitAreaSize)h=d.circle(h,e,"#FFFFFF",.001,0),h.translate(b,c),a.hitBullet=h,this.bulletSet.push(h),this.addListeners(h,a);a.bulletGraphics=n;void 0!==this.tabIndex&&n.setAttr("tabindex",this.tabIndex)}else n={size:0};n.graphDataItem=a;return n}},showBullets:function(){var a=
this.allBullets,b;this.bulletsHidden=!1;for(b=0;b<a.length;b++)a[b].show()},hideBullets:function(){var a=this.allBullets,b;this.bulletsHidden=!0;for(b=0;b<a.length;b++)a[b].hide()},showCustomBullets:function(){var a=this.allBullets,b;this.customBulletsHidden=!1;for(b=0;b<a.length;b++){var c=a[b].graphDataItem;c&&c.customBulletGraphics&&c.customBulletGraphics.show()}},hideCustomBullets:function(){var a=this.allBullets,b;this.customBulletsHidden=!0;for(b=0;b<a.length;b++){var c=a[b].graphDataItem;c&&
c.customBulletGraphics&&c.customBulletGraphics.hide()}},addListeners:function(a,b){var c=this;a.mouseover(function(a){c.handleRollOver(b,a)}).mouseout(function(a){c.handleRollOut(b,a)}).touchend(function(a){c.handleRollOver(b,a);c.chart.panEventsEnabled&&c.handleClick(b,a)}).touchstart(function(a){c.handleRollOver(b,a)}).click(function(a){c.handleClick(b,a)}).dblclick(function(a){c.handleDoubleClick(b,a)}).contextmenu(function(a){c.handleRightClick(b,a)});var e=c.chart;if(e.accessible&&c.accessibleLabel){var d=
e.formatString(c.accessibleLabel,b);e.makeAccessible(a,d)}},handleRollOver:function(a,b){this.handleGraphEvent(b,"rollOverGraph");if(a){var c=this.chart;a.bulletConfig&&(c.isRolledOverBullet=!0);var e={type:"rollOverGraphItem",item:a,index:a.index,graph:this,target:this,chart:this.chart,event:b};this.fire(e);c.fire(e);clearTimeout(c.hoverInt);(c=c.chartCursor)&&c.valueBalloonsEnabled||this.showGraphBalloon(a,"V",!0)}},handleRollOut:function(a,b){var c=this.chart;if(a){var e={type:"rollOutGraphItem",
item:a,index:a.index,graph:this,target:this,chart:this.chart,event:b};this.fire(e);c.fire(e);c.isRolledOverBullet=!1}this.handleGraphEvent(b,"rollOutGraph");(c=c.chartCursor)&&c.valueBalloonsEnabled||this.hideBalloon()},handleClick:function(a,b){if(!this.chart.checkTouchMoved()&&this.chart.checkTouchDuration(b)){if(a){var c={type:"clickGraphItem",item:a,index:a.index,graph:this,target:this,chart:this.chart,event:b};this.fire(c);this.chart.fire(c);d.getURL(a.url,this.urlTarget)}this.handleGraphEvent(b,
"clickGraph")}},handleGraphEvent:function(a,b){var c={type:b,graph:this,target:this,chart:this.chart,event:a};this.fire(c);this.chart.fire(c)},handleRightClick:function(a,b){if(a){var c={type:"rightClickGraphItem",item:a,index:a.index,graph:this,target:this,chart:this.chart,event:b};this.fire(c);this.chart.fire(c)}},handleDoubleClick:function(a,b){if(a){var c={type:"doubleClickGraphItem",item:a,index:a.index,graph:this,target:this,chart:this.chart,event:b};this.fire(c);this.chart.fire(c)}},zoom:function(a,
b){this.start=a;this.end=b;this.draw()},changeOpacity:function(a){var b=this.set;b&&b.setAttr("opacity",a);if(b=this.ownColumns){var c;for(c=0;c<b.length;c++){var e=b[c].set;e&&e.setAttr("opacity",a)}}(b=this.bulletSet)&&b.setAttr("opacity",a)},destroy:function(){d.remove(this.set);d.remove(this.bulletSet);var a=this.timeOuts;if(a){var b;for(b=0;b<a.length;b++)clearTimeout(a[b])}this.timeOuts=[]},createBalloon:function(){var a=this.chart;this.balloon?this.balloon.destroy&&this.balloon.destroy():this.balloon=
{};var b=this.balloon;d.extend(b,a.balloon,!0);b.chart=a;b.mainSet=a.plotBalloonsSet;b.className=this.id},hideBalloon:function(){var a=this,b=a.chart;b.chartCursor?b.chartCursor.valueBalloonsEnabled||b.hideBalloon():b.hideBalloon();clearTimeout(a.hoverInt);a.hoverInt=setTimeout(function(){a.hideBalloonReal.call(a)},b.hideBalloonTime)},hideBalloonReal:function(){this.balloon&&this.balloon.hide();this.fixBulletSize()},fixBulletSize:function(){if(d.isModern){var a=this.resizedDItem;if(a){var b=a.bulletGraphics;
if(b&&!b.doNotScale){b.translate(a.bx,a.by,1);var c=this.bulletAlpha;isNaN(a.alpha)||(c=a.alpha);b.setAttr("fill-opacity",c);b.setAttr("stroke-opacity",this.bulletBorderAlpha)}}this.resizedDItem=null}},showGraphBalloon:function(a,b,c,e,h){if(a){var f=this.chart,g=this.balloon,k=0,l=0,m=f.chartCursor,p=!0;m?m.valueBalloonsEnabled||(g=f.balloon,k=this.x,l=this.y,p=!1):(g=f.balloon,k=this.x,l=this.y,p=!1);clearTimeout(this.hoverInt);if(f.chartCursor&&(this.currentDataItem=a,"serial"==f.type&&f.isRolledOverBullet&&
f.chartCursor.valueBalloonsEnabled)){this.hideBalloonReal();return}this.resizeBullet(a,e,h);if(g&&g.enabled&&this.showBalloon&&!this.hidden){var m=f.formatString(this.balloonText,a,!0),q=this.balloonFunction;q&&(m=q(a,a.graph));m&&(m=d.cleanFromEmpty(m));m&&""!==m?(e=f.getBalloonColor(this,a),g.drop||(g.pointerOrientation=b),b=a.x,h=a.y,f.rotate&&(b=a.y,h=a.x),b+=k,h+=l,isNaN(b)||isNaN(h)?this.hideBalloonReal():(a=this.width,q=this.height,p&&g.setBounds(k,l,a+k,q+l),g.changeColor(e),g.setPosition(b,
h),g.fixPrevious(),g.fixedPosition&&(c=!1),!c&&"radar"!=f.type&&(b<k-.5||b>a+k||h<l-.5||h>q+l)?(g.showBalloon(m),g.hide(0)):(g.followCursor(c),g.showBalloon(m)))):(this.hideBalloonReal(),g.hide(),this.resizeBullet(a,e,h))}else this.hideBalloonReal()}},resizeBullet:function(a,b,c){this.fixBulletSize();if(a&&d.isModern&&(1!=b||!isNaN(c))){var e=a.bulletGraphics;e&&!e.doNotScale&&(e.translate(a.bx,a.by,b),isNaN(c)||(e.setAttr("fill-opacity",c),e.setAttr("stroke-opacity",c)),this.resizedDItem=a)}}})})();(function(){var d=window.AmCharts;d.ChartCursor=d.Class({construct:function(a){this.cname="ChartCursor";this.createEvents("changed","zoomed","onHideCursor","onShowCursor","draw","selected","moved","panning","zoomStarted");this.enabled=!0;this.cursorAlpha=1;this.selectionAlpha=.2;this.cursorColor="#CC0000";this.categoryBalloonAlpha=1;this.color="#FFFFFF";this.type="cursor";this.zoomed=!1;this.zoomable=!0;this.pan=!1;this.categoryBalloonDateFormat="MMM DD, YYYY";this.categoryBalloonText="[[category]]";
this.categoryBalloonEnabled=this.valueBalloonsEnabled=!0;this.rolledOver=!1;this.cursorPosition="middle";this.bulletsEnabled=this.skipZoomDispatch=!1;this.bulletSize=8;this.selectWithoutZooming=this.oneBalloonOnly=!1;this.graphBulletSize=1.7;this.animationDuration=.3;this.zooming=!1;this.adjustment=0;this.avoidBalloonOverlapping=!0;this.leaveCursor=!1;this.leaveAfterTouch=!0;this.valueZoomable=!1;this.balloonPointerOrientation="horizontal";this.hLineEnabled=this.vLineEnabled=!0;this.vZoomEnabled=
this.hZoomEnabled=!1;d.applyTheme(this,a,this.cname)},draw:function(){this.destroy();var a=this.chart;a.panRequired=!0;var b=a.container;this.rotate=a.rotate;this.container=b;this.prevLineHeight=this.prevLineWidth=NaN;b=b.set();b.translate(this.x,this.y);this.set=b;a.cursorSet.push(b);this.createElements();d.isString(this.limitToGraph)&&(this.limitToGraph=d.getObjById(a.graphs,this.limitToGraph),this.fullWidth=!1,this.cursorPosition="middle");this.pointer=this.balloonPointerOrientation.substr(0,1).toUpperCase();
this.isHidden=!1;this.hideLines();this.valueLineAxis||(this.valueLineAxis=a.valueAxes[0])},createElements:function(){var a=this,b=a.chart,c=b.dx,e=b.dy,h=a.width,f=a.height,g,k,l=a.cursorAlpha,m=a.valueLineAlpha;a.rotate?(g=m,k=l):(k=m,g=l);"xy"==b.type&&(k=l,void 0!==m&&(k=m),g=l);a.vvLine=d.line(a.container,[c,0,0],[e,0,f],a.cursorColor,g,1);d.setCN(b,a.vvLine,"cursor-line");d.setCN(b,a.vvLine,"cursor-line-vertical");a.hhLine=d.line(a.container,[0,h,h+c],[0,0,e],a.cursorColor,k,1);d.setCN(b,a.hhLine,
"cursor-line");d.setCN(b,a.hhLine,"cursor-line-horizontal");a.vLine=a.rotate?a.vvLine:a.hhLine;a.set.push(a.vvLine);a.set.push(a.hhLine);a.set.node.style.pointerEvents="none";a.fullLines=a.container.set();b=b.cursorLineSet;b.push(a.fullLines);b.translate(a.x,a.y);b.clipRect(-1,-1,h+2,f+2);void 0!==a.tabIndex&&(b.setAttr("tabindex",a.tabIndex),b.keyup(function(b){a.handleKeys(b)}).focus(function(b){a.showCursor()}).blur(function(b){a.hideCursor()}));a.set.clipRect(0,0,h,f)},handleKeys:function(a){var b=
this.prevIndex,c=this.chart;if(c){var e=c.chartData;e&&(isNaN(b)&&(b=e.length-1),37!=a.keyCode&&40!=a.keyCode||b--,39!=a.keyCode&&38!=a.keyCode||b++,b=d.fitToBounds(b,c.startIndex,c.endIndex),(a=this.chart.chartData[b])&&this.setPosition(a.x.categoryAxis),this.prevIndex=b)}},update:function(){var a=this.chart;if(a){var b=a.mouseX-this.x,c=a.mouseY-this.y;this.mouseX=b;this.mouseY=c;this.mouse2X=a.mouse2X-this.x;this.mouse2Y=a.mouse2Y-this.y;var e;if(a.chartData&&0<a.chartData.length){this.mouseIsOver()?
(this.hideGraphBalloons=!1,this.rolledOver=e=!0,this.updateDrawing(),this.vvLine&&isNaN(this.fx)&&(a.rotate||!this.limitToGraph)&&this.vvLine.translate(b,0),!this.hhLine||!isNaN(this.fy)||a.rotate&&this.limitToGraph||this.hhLine.translate(0,c),isNaN(this.mouse2X)?this.dispatchMovedEvent(b,c):e=!1):this.forceShow||this.hideCursor();if(this.zooming){if(!isNaN(this.mouse2X)){isNaN(this.mouse2X0)||this.dispatchPanEvent();return}if(this.pan){this.dispatchPanEvent();return}(this.hZoomEnabled||this.vZoomEnabled)&&
this.zooming&&this.updateSelection()}e&&this.showCursor()}}},updateDrawing:function(){this.drawing&&this.chart.setMouseCursor("crosshair");if(this.drawingNow&&(d.remove(this.drawingLine),1<Math.abs(this.drawStartX-this.mouseX)||1<Math.abs(this.drawStartY-this.mouseY))){var a=this.chart,b=a.marginTop,a=a.marginLeft;this.drawingLine=d.line(this.container,[this.drawStartX+a,this.mouseX+a],[this.drawStartY+b,this.mouseY+b],this.cursorColor,1,1)}},fixWidth:function(a){if(this.fullWidth&&this.prevLineWidth!=
a){var b=this.vvLine,c=0;b&&(b.remove(),c=b.x);b=this.container.set();b.translate(c,0);c=d.rect(this.container,a,this.height,this.cursorColor,this.cursorAlpha,this.cursorAlpha,this.cursorColor);d.setCN(this.chart,c,"cursor-fill");c.translate(-a/2-1,0);b.push(c);this.vvLine=b;this.fullLines.push(b);this.prevLineWidth=a}},fixHeight:function(a){if(this.fullWidth&&this.prevLineHeight!=a){var b=this.hhLine,c=0;b&&(b.remove(),c=b.y);b=this.container.set();b.translate(0,c);c=d.rect(this.container,this.width,
a,this.cursorColor,this.cursorAlpha);c.translate(0,-a/2);b.push(c);this.fullLines.push(b);this.hhLine=b;this.prevLineHeight=a}},fixVLine:function(a,b){if(!isNaN(a)){if(isNaN(this.prevLineX)){var c=0,e=this.mouseX;if(this.limitToGraph){var d=this.chart.categoryAxis;d&&(this.chart.rotate||(c="bottom"==d.position?this.height:-this.height),e=a)}this.vvLine.translate(e,c)}else this.prevLineX!=a&&this.vvLine.translate(this.prevLineX,this.prevLineY);this.fx=a;this.prevLineX!=a&&(c=this.animationDuration,
this.zooming&&(c=0),this.vvLine.stop(),this.vvLine.animate({translate:a+","+b},c,"easeOutSine"),this.prevLineX=a,this.prevLineY=b)}},fixHLine:function(a,b){if(!isNaN(a)){if(isNaN(this.prevLineY)){var c=0,e=this.mouseY;if(this.limitToGraph){var d=this.chart.categoryAxis;d&&(this.chart.rotate&&(c="right"==d.position?this.width:-this.width),e=a)}this.hhLine.translate(c,e)}else this.prevLineY!=a&&this.hhLine.translate(this.prevLineX,this.prevLineY);this.fy=a;this.prevLineY!=a&&(c=this.animationDuration,
this.zooming&&(c=0),this.hhLine.stop(),this.hhLine.animate({translate:b+","+a},c,"easeOutSine"),this.prevLineY=a,this.prevLineX=b)}},hideCursor:function(a){this.forceShow=!1;this.chart.wasTouched&&this.leaveAfterTouch||this.isHidden||this.leaveCursor||(this.hideCursorReal(),a?this.chart.handleCursorHide():this.fire({target:this,chart:this.chart,type:"onHideCursor"}),this.chart.setMouseCursor("auto"))},hideCursorReal:function(){this.hideLines();this.isHidden=!0;this.index=this.prevLineY=this.prevLineX=
this.mouseY0=this.mouseX0=this.fy=this.fx=NaN},hideLines:function(){this.vvLine&&this.vvLine.hide();this.hhLine&&this.hhLine.hide();this.fullLines&&this.fullLines.hide();this.isHidden=!0;this.chart.handleCursorHide()},showCursor:function(a){!this.drawing&&this.enabled&&(this.vLineEnabled&&this.vvLine&&this.vvLine.show(),this.hLineEnabled&&this.hhLine&&this.hhLine.show(),this.isHidden=!1,this.updateFullLine(),a||this.fire({target:this,chart:this.chart,type:"onShowCursor"}),this.pan&&this.chart.setMouseCursor("move"))},
updateFullLine:function(){this.zooming&&this.fullWidth&&this.selection&&(this.rotate?0<this.selection.height&&this.hhLine.hide():0<this.selection.width&&this.vvLine.hide())},updateSelection:function(){if(!this.pan&&this.enabled){var a=this.mouseX,b=this.mouseY;isNaN(this.fx)||(a=this.fx);isNaN(this.fy)||(b=this.fy);this.clearSelection();var c=this.mouseX0,e=this.mouseY0,h=this.width,f=this.height,a=d.fitToBounds(a,0,h),b=d.fitToBounds(b,0,f),g;a<c&&(g=a,a=c,c=g);b<e&&(g=b,b=e,e=g);this.hZoomEnabled?
h=a-c:c=0;this.vZoomEnabled?f=b-e:e=0;isNaN(this.mouse2X)&&0<Math.abs(h)&&0<Math.abs(f)&&(a=this.chart,b=d.rect(this.container,h,f,this.cursorColor,this.selectionAlpha),d.setCN(a,b,"cursor-selection"),b.width=h,b.height=f,b.translate(c,e),this.set.push(b),this.selection=b);this.updateFullLine()}},mouseIsOver:function(){var a=this.mouseX,b=this.mouseY;if(this.justReleased)return this.justReleased=!1,!0;if(this.mouseIsDown)return!0;if(!this.chart.mouseIsOver)return this.handleMouseOut(),!1;if(0<a&&
a<this.width&&0<b&&b<this.height)return!0;this.handleMouseOut()},fixPosition:function(){this.prevY=this.prevX=NaN},handleMouseDown:function(){this.update();if(this.mouseIsOver())if(this.mouseIsDown=!0,this.mouseX0=this.mouseX,this.mouseY0=this.mouseY,this.mouse2X0=this.mouse2X,this.mouse2Y0=this.mouse2Y,this.drawing)this.drawStartY=this.mouseY,this.drawStartX=this.mouseX,this.drawingNow=!0;else if(this.dispatchMovedEvent(this.mouseX,this.mouseY),!this.pan&&isNaN(this.mouse2X0)&&(isNaN(this.fx)||(this.mouseX0=
this.fx),isNaN(this.fy)||(this.mouseY0=this.fy)),this.hZoomEnabled||this.vZoomEnabled){this.zooming=!0;var a={chart:this.chart,target:this,type:"zoomStarted"};a.x=this.mouseX/this.width;a.y=this.mouseY/this.height;this.index0=a.index=this.index;this.timestamp0=this.timestamp;this.fire(a)}},registerInitialMouse:function(){},handleReleaseOutside:function(){this.mouseIsDown=!1;if(this.drawingNow){this.drawingNow=!1;d.remove(this.drawingLine);var a=this.drawStartX,b=this.drawStartY,c=this.mouseX,e=this.mouseY,
h=this.chart;(2<Math.abs(a-c)||2<Math.abs(b-e))&&this.fire({type:"draw",target:this,chart:h,initialX:a,initialY:b,finalX:c,finalY:e})}this.zooming&&(this.zooming=!1,this.selectWithoutZooming?this.dispatchZoomEvent("selected"):(this.hZoomEnabled||this.vZoomEnabled)&&this.dispatchZoomEvent("zoomed"),this.rolledOver&&this.dispatchMovedEvent(this.mouseX,this.mouseY));this.mouse2Y0=this.mouse2X0=this.mouseY0=this.mouseX0=NaN},dispatchZoomEvent:function(a){if(!this.pan){var b=this.selection;if(b&&3<Math.abs(b.width)&&
3<Math.abs(b.height)){var c=Math.min(this.index,this.index0),e=Math.max(this.index,this.index0),d=c,f=e,g=this.chart,k=g.chartData,l=g.categoryAxis;l&&l.parseDates&&!l.equalSpacing&&(d=k[c]?k[c].time:Math.min(this.timestamp0,this.timestamp),f=k[e]?g.getEndTime(k[e].time):Math.max(this.timestamp0,this.timestamp));var b={type:a,chart:this.chart,target:this,end:f,start:d,startIndex:c,endIndex:e,selectionHeight:b.height,selectionWidth:b.width,selectionY:b.y,selectionX:b.x},m;this.hZoomEnabled&&4<Math.abs(this.mouseX0-
this.mouseX)&&(b.startX=this.mouseX0/this.width,b.endX=this.mouseX/this.width,m=!0);this.vZoomEnabled&&4<Math.abs(this.mouseY0-this.mouseY)&&(b.startY=1-this.mouseY0/this.height,b.endY=1-this.mouseY/this.height,m=!0);m&&(this.prevY=this.prevX=NaN,this.fire(b),"selected"!=a&&this.clearSelection());this.hideCursor()}}},dispatchMovedEvent:function(a,b,c,e){a=Math.round(a);b=Math.round(b);if(!this.isHidden&&(a!=this.prevX||b!=this.prevY||"changed"==c)){c||(c="moved");var d=this.fx,f=this.fy;isNaN(d)&&
(d=a);isNaN(f)&&(f=b);var g=!1;this.zooming&&this.pan&&(g=!0);g={hidden:this.isHidden,type:c,chart:this.chart,target:this,x:a,y:b,finalX:d,finalY:f,zooming:this.zooming,panning:g,mostCloseGraph:this.mostCloseGraph,index:this.index,skip:e,hideBalloons:this.hideGraphBalloons};this.prevIndex=this.index;this.rotate?(g.position=b,g.finalPosition=f):(g.position=a,g.finalPosition=d);this.prevX=a;this.prevY=b;e?this.chart.handleCursorMove(g):(this.fire(g),"changed"==c&&this.chart.fire(g))}},dispatchPanEvent:function(){if(this.mouseIsDown){var a=
d.roundTo((this.mouseX-this.mouseX0)/this.width,3),b=d.roundTo((this.mouseY-this.mouseY0)/this.height,3),c=d.roundTo((this.mouse2X-this.mouse2X0)/this.width,3),e=d.roundTo((this.mouse2Y-this.mouse2Y0)/this.height,2),h=!1;0!==Math.abs(a)&&0!==Math.abs(b)&&(h=!0);if(this.prevDeltaX==a||this.prevDeltaY==b)h=!1;isNaN(c)||isNaN(e)||(0!==Math.abs(c)&&0!==Math.abs(e)&&(h=!0),this.prevDelta2X!=c&&this.prevDelta2Y!=e)||(h=!1);h&&(this.hideLines(),this.fire({type:"panning",chart:this.chart,target:this,deltaX:a,
deltaY:b,delta2X:c,delta2Y:e,index:this.index}),this.prevDeltaX=a,this.prevDeltaY=b,this.prevDelta2X=c,this.prevDelta2Y=e)}},clearSelection:function(){var a=this.selection;a&&(a.width=0,a.height=0,a.remove())},destroy:function(){this.clear();d.remove(this.selection);this.selection=null;clearTimeout(this.syncTO);d.remove(this.set)},clear:function(){},setTimestamp:function(a){this.timestamp=a},setIndex:function(a,b){a!=this.index&&(this.index=a,b||this.isHidden||this.dispatchMovedEvent(this.mouseX,
this.mouseY,"changed"))},handleMouseOut:function(){this.enabled&&this.rolledOver&&(this.leaveCursor||this.setIndex(void 0),this.forceShow=!1,this.hideCursor(),this.rolledOver=!1)},showCursorAt:function(a){var b=this.chart.categoryAxis;b&&this.setPosition(b.categoryToCoordinate(a),a)},setPosition:function(a,b){var c=this.chart,e=c.categoryAxis;if(e){var d,f;void 0===b&&(b=e.coordinateToValue(a));e.showBalloonAt(b,a);this.forceShow=!0;e.stickBalloonToCategory?c.rotate?this.fixHLine(a,0):this.fixVLine(a,
0):(this.showCursor(),c.rotate?this.hhLine.translate(0,a):this.vvLine.translate(a,0));c.rotate?d=a:f=a;c.rotate?(this.vvLine&&this.vvLine.hide(),this.hhLine&&this.hhLine.show()):(this.hhLine&&this.hhLine.hide(),this.vvLine&&this.vvLine.show());this.updateFullLine();this.isHidden=!1;this.dispatchMovedEvent(f,d,"moved",!0)}},enableDrawing:function(a){this.enabled=!a;this.hideCursor();this.drawing=a},syncWithCursor:function(a,b){clearTimeout(this.syncTO);a&&(a.isHidden?this.hideCursor(!0):this.syncWithCursorReal(a,
b))},isZooming:function(a){this.zooming=a},syncWithCursorReal:function(a,b){var c=a.vvLine,e=a.hhLine;this.index=a.index;this.forceShow=!0;this.zooming&&this.pan||this.showCursor(!0);this.hideGraphBalloons=b;this.justReleased=a.justReleased;this.zooming=a.zooming;this.index0=a.index0;this.mouseX0=a.mouseX0;this.mouseY0=a.mouseY0;this.mouse2X0=a.mouse2X0;this.mouse2Y0=a.mouse2Y0;this.timestamp0=a.timestamp0;this.prevDeltaX=a.prevDeltaX;this.prevDeltaY=a.prevDeltaY;this.prevDelta2X=a.prevDelta2X;this.prevDelta2Y=
a.prevDelta2Y;this.fx=a.fx;this.fy=a.fy;a.zooming&&this.updateSelection();var d=a.mouseX,f=a.mouseY;this.rotate?(d=NaN,this.vvLine&&this.vvLine.hide(),this.hhLine&&e&&(isNaN(a.fy)?this.hhLine.translate(0,a.mouseY):this.fixHLine(a.fy,0))):(f=NaN,this.hhLine&&this.hhLine.hide(),this.vvLine&&c&&(isNaN(a.fx)?this.vvLine.translate(a.mouseX,0):this.fixVLine(a.fx,0)));this.dispatchMovedEvent(d,f,"moved",!0)}})})();(function(){var d=window.AmCharts;d.SimpleChartScrollbar=d.Class({construct:function(a){this.createEvents("zoomed","zoomStarted","zoomEnded");this.backgroundColor="#D4D4D4";this.backgroundAlpha=1;this.selectedBackgroundColor="#EFEFEF";this.scrollDuration=this.selectedBackgroundAlpha=1;this.resizeEnabled=!0;this.hideResizeGrips=!1;this.scrollbarHeight=20;this.updateOnReleaseOnly=!1;9>document.documentMode&&(this.updateOnReleaseOnly=!0);this.dragIconHeight=this.dragIconWidth=35;this.dragIcon="dragIconRoundBig";
this.dragCursorHover="cursor: move; cursor: grab; cursor: -moz-grab; cursor: -webkit-grab;";this.dragCursorDown="cursor: move; cursor: grab; cursor: -moz-grabbing; cursor: -webkit-grabbing;";this.vResizeCursor="ns-resize";this.hResizeCursor="ew-resize";this.enabled=!0;this.percentStart=this.offset=0;this.percentEnd=1;d.applyTheme(this,a,"SimpleChartScrollbar")},getPercents:function(){var a=this.getDBox(),b=a.x,c=a.y,e=a.width,a=a.height;this.rotate?(b=1-c/this.height,c=1-(c+a)/this.height):(c=b/this.width,
b=(b+e)/this.width);this.percentStart=c;this.percentEnd=b},draw:function(){var a=this;a.destroy();if(a.enabled){var b=a.chart.container,c=a.rotate,e=a.chart;e.panRequired=!0;var h=b.set();a.set=h;c?d.setCN(e,h,"scrollbar-vertical"):d.setCN(e,h,"scrollbar-horizontal");e.scrollbarsSet.push(h);var f,g;c?(f=a.scrollbarHeight,g=e.plotAreaHeight):(g=a.scrollbarHeight,f=e.plotAreaWidth);a.width=f;if((a.height=g)&&f){var k=d.rect(b,f,g,a.backgroundColor,a.backgroundAlpha,1,a.backgroundColor,a.backgroundAlpha);
d.setCN(e,k,"scrollbar-bg");a.bg=k;h.push(k);k=d.rect(b,f,g,"#000",.005);h.push(k);a.invisibleBg=k;k.click(function(){a.handleBgClick()}).mouseover(function(){a.handleMouseOver()}).mouseout(function(){a.handleMouseOut()}).touchend(function(){a.handleBgClick()});k=d.rect(b,f,g,a.selectedBackgroundColor,a.selectedBackgroundAlpha);d.setCN(e,k,"scrollbar-bg-selected");a.selectedBG=k;h.push(k);f=d.rect(b,f,g,"#000",.005);a.dragger=f;h.push(f);f.mousedown(function(b){a.handleDragStart(b)}).mouseup(function(){a.handleDragStop()}).mouseover(function(){a.handleDraggerOver()}).mouseout(function(){a.handleMouseOut()}).touchstart(function(b){a.handleDragStart(b)}).touchend(function(){a.handleDragStop()});
g=e.pathToImages;var l,k=a.dragIcon.replace(/\.[a-z]*$/i,"");d.isAbsolute(k)&&(g="");c?(l=g+k+"H"+e.extension,g=a.dragIconWidth,c=a.dragIconHeight):(l=g+k+e.extension,c=a.dragIconWidth,g=a.dragIconHeight);k=b.image(l,0,0,c,g);d.setCN(e,k,"scrollbar-grip-left");l=b.image(l,0,0,c,g);d.setCN(e,l,"scrollbar-grip-right");var m=10,p=20;e.panEventsEnabled&&(m=25,p=a.scrollbarHeight);var q=d.rect(b,m,p,"#000",.005),n=d.rect(b,m,p,"#000",.005);n.translate(-(m-c)/2,-(p-g)/2);q.translate(-(m-c)/2,-(p-g)/2);
c=b.set([k,n]);b=b.set([l,q]);a.iconLeft=c;h.push(a.iconLeft);a.iconRight=b;h.push(b);a.updateGripCursor(!1);e.makeAccessible(c,a.accessibleLabel);e.makeAccessible(b,a.accessibleLabel);e.makeAccessible(f,a.accessibleLabel);c.setAttr("role","menuitem");b.setAttr("role","menuitem");f.setAttr("role","menuitem");void 0!==a.tabIndex&&(c.setAttr("tabindex",a.tabIndex),c.keyup(function(b){a.handleKeys(b,1,0)}));void 0!==a.tabIndex&&(f.setAttr("tabindex",a.tabIndex),f.keyup(function(b){a.handleKeys(b,1,1)}));
void 0!==a.tabIndex&&(b.setAttr("tabindex",a.tabIndex),b.keyup(function(b){a.handleKeys(b,0,1)}));c.mousedown(function(){a.leftDragStart()}).mouseup(function(){a.leftDragStop()}).mouseover(function(){a.iconRollOver()}).mouseout(function(){a.iconRollOut()}).touchstart(function(){a.leftDragStart()}).touchend(function(){a.leftDragStop()});b.mousedown(function(){a.rightDragStart()}).mouseup(function(){a.rightDragStop()}).mouseover(function(){a.iconRollOver()}).mouseout(function(){a.iconRollOut()}).touchstart(function(){a.rightDragStart()}).touchend(function(){a.rightDragStop()});
d.ifArray(e.chartData)?h.show():h.hide();a.hideDragIcons();a.clipDragger(!1)}h.translate(a.x,a.y);h.node.style.msTouchAction="none";h.node.style.touchAction="none"}},handleKeys:function(a,b,c){this.getPercents();var e=this.percentStart,d=this.percentEnd;if(this.rotate)var f=d,d=e,e=f;if(37==a.keyCode||40==a.keyCode)e-=.02*b,d-=.02*c;if(39==a.keyCode||38==a.keyCode)e+=.02*b,d+=.02*c;this.rotate&&(a=d,d=e,e=a);isNaN(d)||isNaN(e)||this.percentZoom(e,d,!0)},updateScrollbarSize:function(a,b){if(!isNaN(a)&&
!isNaN(b)){a=Math.round(a);b=Math.round(b);var c=this.dragger,e,d,f,g,k;this.rotate?(e=0,d=a,f=this.width+1,g=b-a,c.setAttr("height",b-a),c.setAttr("y",d)):(e=a,d=0,f=b-a,g=this.height+1,k=b-a,c.setAttr("x",e),c.setAttr("width",k));this.clipAndUpdate(e,d,f,g)}},update:function(){var a,b=!1,c,e,d=this.x,f=this.y,g=this.dragger,k=this.getDBox();if(k){c=k.x+d;e=k.y+f;var l=k.width,k=k.height,m=this.rotate,p=this.chart,q=this.width,n=this.height,t=p.mouseX,p=p.mouseY;a=this.initialMouse;this.forceClip&&
this.clipDragger(!0);if(this.dragging){var r=this.initialCoord;m?(a=r+(p-a),0>a&&(a=0),r=n-k,a>r&&(a=r),g.setAttr("y",a)):(a=r+(t-a),0>a&&(a=0),r=q-l,a>r&&(a=r),g.setAttr("x",a));this.clipDragger(!0)}if(this.resizingRight){if(m)if(a=p-e,!isNaN(this.maxHeight)&&a>this.maxHeight&&(a=this.maxHeight),a+e>n+f&&(a=n-e+f),0>a)this.resizingRight=!1,b=this.resizingLeft=!0;else{if(0===a||isNaN(a))a=.1;g.setAttr("height",a)}else if(a=t-c,!isNaN(this.maxWidth)&&a>this.maxWidth&&(a=this.maxWidth),a+c>q+d&&(a=
q-c+d),0>a)this.resizingRight=!1,b=this.resizingLeft=!0;else{if(0===a||isNaN(a))a=.1;g.setAttr("width",a)}this.clipDragger(!0)}if(this.resizingLeft){if(m)if(c=e,e=p,e<f&&(e=f),isNaN(e)&&(e=f),e>n+f&&(e=n+f),a=!0===b?c-e:k+c-e,!isNaN(this.maxHeight)&&a>this.maxHeight&&(a=this.maxHeight,e=c),0>a)this.resizingRight=!0,this.resizingLeft=!1,g.setAttr("y",c+k-f);else{if(0===a||isNaN(a))a=.1;g.setAttr("y",e-f);g.setAttr("height",a)}else if(e=t,e<d&&(e=d),isNaN(e)&&(e=d),e>q+d&&(e=q+d),a=!0===b?c-e:l+c-e,
!isNaN(this.maxWidth)&&a>this.maxWidth&&(a=this.maxWidth,e=c),0>a)this.resizingRight=!0,this.resizingLeft=!1,g.setAttr("x",c+l-d);else{if(0===a||isNaN(a))a=.1;g.setAttr("x",e-d);g.setAttr("width",a)}this.clipDragger(!0)}}},stopForceClip:function(){this.animating=this.forceClip=!1},clipDragger:function(a){var b=this.getDBox();if(b){var c=b.x,e=b.y,d=b.width,b=b.height,f=!1;if(this.rotate){if(c=0,d=this.width+1,this.clipY!=e||this.clipH!=b)f=!0}else if(e=0,b=this.height+1,this.clipX!=c||this.clipW!=
d)f=!0;f&&(this.clipAndUpdate(c,e,d,b),a&&(this.updateOnReleaseOnly||this.dispatchScrollbarEvent()))}},maskGraphs:function(){},clipAndUpdate:function(a,b,c,d){this.clipX=a;this.clipY=b;this.clipW=c;this.clipH=d;this.selectedBG.setAttr("width",c);this.selectedBG.setAttr("height",d);this.selectedBG.translate(a,b);this.updateDragIconPositions();this.maskGraphs(a,b,c,d)},dispatchScrollbarEvent:function(){if(this.skipEvent)this.skipEvent=!1;else{var a=this.chart;a.hideBalloon();var b=this.getDBox(),c=
b.x,d=b.y,h=b.width,b=b.height;this.getPercents();this.rotate?(c=d,h=this.height/b):h=this.width/h;this.fire({type:"zoomed",position:c,chart:a,target:this,multiplier:h,relativeStart:this.percentStart,relativeEnd:this.percentEnd})}},updateDragIconPositions:function(){var a=this.getDBox(),b=a.x,c=a.y,d=this.iconLeft,h=this.iconRight,f,g,k=this.scrollbarHeight;this.rotate?(f=this.dragIconWidth,g=this.dragIconHeight,d.translate((k-g)/2,c-f/2),h.translate((k-g)/2,c+a.height-f/2)):(f=this.dragIconHeight,
g=this.dragIconWidth,d.translate(b-g/2,(k-f)/2),h.translate(b-g/2+a.width,(k-f)/2))},showDragIcons:function(){this.resizeEnabled&&(this.iconLeft.show(),this.iconRight.show())},hideDragIcons:function(){if(!this.resizingLeft&&!this.resizingRight&&!this.dragging){if(this.hideResizeGrips||!this.resizeEnabled)this.iconLeft.hide(),this.iconRight.hide();this.removeCursors()}},removeCursors:function(){this.chart.setMouseCursor("auto")},fireZoomEvent:function(a){this.fire({type:a,chart:this.chart,target:this})},
percentZoom:function(a,b,c){a=d.fitToBounds(a,0,b);b=d.fitToBounds(b,a,1);if(this.dragger&&this.enabled){this.dragger.stop();isNaN(a)&&(a=0);isNaN(b)&&(b=1);var e,h;this.rotate?(e=this.height,b=e-e*b,h=e-e*a):(e=this.width,h=e*b,b=e*a);this.updateScrollbarSize(b,h);this.clipDragger(!1);this.getPercents();c&&this.dispatchScrollbarEvent()}},destroy:function(){this.clear();d.remove(this.set);d.remove(this.iconRight);d.remove(this.iconLeft)},clear:function(){},handleDragStart:function(){if(this.enabled){this.fireZoomEvent("zoomStarted");
var a=this.chart;this.dragger.stop();this.removeCursors();d.isModern&&(this.dragger.node.style.cssText=this.dragCursorDown);this.dragging=!0;var b=this.getDBox();this.rotate?(this.initialCoord=b.y,this.initialMouse=a.mouseY):(this.initialCoord=b.x,this.initialMouse=a.mouseX)}},handleDragStop:function(){this.updateOnReleaseOnly&&(this.update(),this.skipEvent=!1,this.dispatchScrollbarEvent());this.dragging=!1;this.mouseIsOver&&this.removeCursors();d.isModern&&(this.dragger.node.style.cssText=this.dragCursorHover);
this.update();this.fireZoomEvent("zoomEnded")},handleDraggerOver:function(){this.handleMouseOver();d.isModern&&(this.dragger.node.style.cssText=this.dragCursorHover)},leftDragStart:function(){this.fireZoomEvent("zoomStarted");this.dragger.stop();this.resizingLeft=!0;this.updateGripCursor(!0)},updateGripCursor:function(a){d.isModern&&(a=this.rotate?a?this.vResizeCursorDown:this.vResizeCursorHover:a?this.hResizeCursorDown:this.hResizeCursorHover)&&(this.iconRight&&(this.iconRight.node.style.cssText=
a),this.iconLeft&&(this.iconLeft.node.style.cssText=a))},leftDragStop:function(){this.resizingLeft&&(this.resizingLeft=!1,this.mouseIsOver||this.removeCursors(),this.updateOnRelease(),this.fireZoomEvent("zoomEnded"));this.updateGripCursor(!1)},rightDragStart:function(){this.fireZoomEvent("zoomStarted");this.dragger.stop();this.resizingRight=!0;this.updateGripCursor(!0)},rightDragStop:function(){this.resizingRight&&(this.resizingRight=!1,this.mouseIsOver||this.removeCursors(),this.updateOnRelease(),
this.fireZoomEvent("zoomEnded"));this.updateGripCursor(!1)},iconRollOut:function(){this.removeCursors()},iconRollOver:function(){this.rotate?this.vResizeCursor&&this.chart.setMouseCursor(this.vResizeCursor):this.hResizeCursor&&this.chart.setMouseCursor(this.hResizeCursor);this.handleMouseOver()},getDBox:function(){if(this.dragger)return this.dragger.getBBox()},handleBgClick:function(){var a=this;if(!a.resizingRight&&!a.resizingLeft){a.zooming=!0;var b,c,e=a.scrollDuration,h=a.dragger;b=a.getDBox();
var f=b.height,g=b.width;c=a.chart;var k=a.y,l=a.x,m=a.rotate;m?(b="y",c=c.mouseY-f/2-k,c=d.fitToBounds(c,0,a.height-f)):(b="x",c=c.mouseX-g/2-l,c=d.fitToBounds(c,0,a.width-g));a.updateOnReleaseOnly?(a.skipEvent=!1,h.setAttr(b,c),a.dispatchScrollbarEvent(),a.clipDragger()):(a.animating=!0,c=Math.round(c),m?h.animate({y:c},e,">"):h.animate({x:c},e,">"),a.forceClip=!0,clearTimeout(a.forceTO),a.forceTO=setTimeout(function(){a.stopForceClip.call(a)},5E3*e))}},updateOnRelease:function(){this.updateOnReleaseOnly&&
(this.update(),this.skipEvent=!1,this.dispatchScrollbarEvent())},handleReleaseOutside:function(){if(this.set){if(this.resizingLeft||this.resizingRight||this.dragging)this.dragging=this.resizingRight=this.resizingLeft=!1,this.updateOnRelease(),this.removeCursors();this.animating=this.mouseIsOver=!1;this.hideDragIcons();this.update()}},handleMouseOver:function(){this.mouseIsOver=!0;this.showDragIcons()},handleMouseOut:function(){this.mouseIsOver=!1;this.hideDragIcons();this.removeCursors()}})})();(function(){var d=window.AmCharts;d.ChartScrollbar=d.Class({inherits:d.SimpleChartScrollbar,construct:function(a){this.cname="ChartScrollbar";d.ChartScrollbar.base.construct.call(this,a);this.graphLineColor="#BBBBBB";this.graphLineAlpha=0;this.graphFillColor="#BBBBBB";this.graphFillAlpha=1;this.selectedGraphLineColor="#888888";this.selectedGraphLineAlpha=0;this.selectedGraphFillColor="#888888";this.selectedGraphFillAlpha=1;this.gridCount=0;this.gridColor="#FFFFFF";this.gridAlpha=.7;this.skipEvent=
this.autoGridCount=!1;this.color="#FFFFFF";this.scrollbarCreated=!1;this.oppositeAxis=!0;this.accessibleLabel="Zoom chart using cursor arrows";d.applyTheme(this,a,this.cname)},init:function(){var a=this.categoryAxis,b=this.chart,c=this.gridAxis;a||("CategoryAxis"==this.gridAxis.cname?(this.catScrollbar=!0,a=new d.CategoryAxis,a.id="scrollbar"):(a=new d.ValueAxis,a.data=b.chartData,a.id=c.id,a.type=c.type,a.maximumDate=c.maximumDate,a.minimumDate=c.minimumDate,a.minPeriod=c.minPeriod,a.minMaxField=
c.minMaxField),this.categoryAxis=a);a.chart=b;var e=b.categoryAxis;e&&(a.firstDayOfWeek=e.firstDayOfWeek);a.dateFormats=c.dateFormats;a.markPeriodChange=c.markPeriodChange;a.boldPeriodBeginning=c.boldPeriodBeginning;a.labelFunction=c.labelFunction;a.axisItemRenderer=d.RecItem;a.axisRenderer=d.RecAxis;a.guideFillRenderer=d.RecFill;a.inside=!0;a.fontSize=this.fontSize;a.tickLength=0;a.axisAlpha=0;d.isString(this.graph)&&(this.graph=d.getObjById(b.graphs,this.graph));(a=this.graph)&&this.catScrollbar&&
(c=this.valueAxis,c||(this.valueAxis=c=new d.ValueAxis,c.visible=!1,c.scrollbar=!0,c.axisItemRenderer=d.RecItem,c.axisRenderer=d.RecAxis,c.guideFillRenderer=d.RecFill,c.labelsEnabled=!1,c.chart=b),b=this.unselectedGraph,b||(b=new d.AmGraph,b.scrollbar=!0,this.unselectedGraph=b,b.negativeBase=a.negativeBase,b.noStepRisers=a.noStepRisers),b=this.selectedGraph,b||(b=new d.AmGraph,b.scrollbar=!0,this.selectedGraph=b,b.negativeBase=a.negativeBase,b.noStepRisers=a.noStepRisers));this.scrollbarCreated=!0},
draw:function(){var a=this;d.ChartScrollbar.base.draw.call(a);if(a.enabled){a.scrollbarCreated||a.init();var b=a.chart,c=b.chartData,e=a.categoryAxis,h=a.rotate,f=a.x,g=a.y,k=a.width,l=a.height,m=a.gridAxis,p=a.set;e.setOrientation(!h);e.parseDates=m.parseDates;"ValueAxis"==a.categoryAxis.cname&&(e.rotate=!h);e.equalSpacing=m.equalSpacing;e.minPeriod=m.minPeriod;e.startOnAxis=m.startOnAxis;e.width=k-1;e.height=l;e.gridCount=a.gridCount;e.gridColor=a.gridColor;e.gridAlpha=a.gridAlpha;e.color=a.color;
e.tickLength=0;e.axisAlpha=0;e.autoGridCount=a.autoGridCount;e.parseDates&&!e.equalSpacing&&e.timeZoom(b.firstTime,b.lastTime);e.minimum=a.gridAxis.fullMin;e.maximum=a.gridAxis.fullMax;e.strictMinMax=!0;e.zoom(0,c.length-1);if((m=a.graph)&&a.catScrollbar){var q=a.valueAxis,n=m.valueAxis;q.id=n.id;q.rotate=h;q.setOrientation(h);q.width=k;q.height=l;q.dataProvider=c;q.reversed=n.reversed;q.logarithmic=n.logarithmic;q.gridAlpha=0;q.axisAlpha=0;p.push(q.set);h?(q.y=g,q.x=0):(q.x=f,q.y=0);var f=Infinity,
g=-Infinity,t;for(t=0;t<c.length;t++){var r=c[t].axes[n.id].graphs[m.id].values,w;for(w in r)if(r.hasOwnProperty(w)&&"percents"!=w&&"total"!=w){var z=r[w];z<f&&(f=z);z>g&&(g=z)}}Infinity!=f&&(q.minimum=f);-Infinity!=g&&(q.maximum=g+.1*(g-f));f==g&&(--q.minimum,q.maximum+=1);void 0!==a.minimum&&(q.minimum=a.minimum);void 0!==a.maximum&&(q.maximum=a.maximum);q.zoom(0,c.length-1);w=a.unselectedGraph;w.id=m.id;w.bcn="scrollbar-graph-";w.rotate=h;w.chart=b;w.data=c;w.valueAxis=q;w.chart=m.chart;w.categoryAxis=
a.categoryAxis;w.periodSpan=m.periodSpan;w.valueField=m.valueField;w.openField=m.openField;w.closeField=m.closeField;w.highField=m.highField;w.lowField=m.lowField;w.lineAlpha=a.graphLineAlpha;w.lineColorR=a.graphLineColor;w.fillAlphas=a.graphFillAlpha;w.fillColorsR=a.graphFillColor;w.connect=m.connect;w.hidden=m.hidden;w.width=k;w.height=l;w.pointPosition=m.pointPosition;w.stepDirection=m.stepDirection;w.periodSpan=m.periodSpan;n=a.selectedGraph;n.id=m.id;n.bcn=w.bcn+"selected-";n.rotate=h;n.chart=
b;n.data=c;n.valueAxis=q;n.chart=m.chart;n.categoryAxis=e;n.periodSpan=m.periodSpan;n.valueField=m.valueField;n.openField=m.openField;n.closeField=m.closeField;n.highField=m.highField;n.lowField=m.lowField;n.lineAlpha=a.selectedGraphLineAlpha;n.lineColorR=a.selectedGraphLineColor;n.fillAlphas=a.selectedGraphFillAlpha;n.fillColorsR=a.selectedGraphFillColor;n.connect=m.connect;n.hidden=m.hidden;n.width=k;n.height=l;n.pointPosition=m.pointPosition;n.stepDirection=m.stepDirection;n.periodSpan=m.periodSpan;
b=a.graphType;b||(b=m.type);w.type=b;n.type=b;c=c.length-1;w.zoom(0,c);n.zoom(0,c);n.set.click(function(){a.handleBackgroundClick()}).mouseover(function(){a.handleMouseOver()}).mouseout(function(){a.handleMouseOut()});w.set.click(function(){a.handleBackgroundClick()}).mouseover(function(){a.handleMouseOver()}).mouseout(function(){a.handleMouseOut()});p.push(w.set);p.push(n.set)}p.push(e.set);p.push(e.labelsSet);a.bg.toBack();a.invisibleBg.toFront();a.dragger.toFront();a.iconLeft.toFront();a.iconRight.toFront()}},
timeZoom:function(a,b,c){this.startTime=a;this.endTime=b;this.timeDifference=b-a;this.skipEvent=!d.toBoolean(c);this.zoomScrollbar();this.dispatchScrollbarEvent()},zoom:function(a,b){this.start=a;this.end=b;this.skipEvent=!0;this.zoomScrollbar()},dispatchScrollbarEvent:function(){if(this.categoryAxis&&"ValueAxis"==this.categoryAxis.cname)d.ChartScrollbar.base.dispatchScrollbarEvent.call(this);else if(this.skipEvent)this.skipEvent=!1;else{var a=this.chart.chartData,b,c,e=this.dragger.getBBox();b=e.x;
var h=e.y,f=e.width,e=e.height,g=this.chart;this.rotate?(b=h,c=e):c=f;f={type:"zoomed",target:this};f.chart=g;var k=this.categoryAxis,l=this.stepWidth,h=g.minSelectedTime,e=g.maxSelectedTime,m=!1;if(k.parseDates&&!k.equalSpacing){if(a=g.lastTime,g=g.firstTime,k=Math.round(b/l)+g,b=this.dragging?k+this.timeDifference:Math.round((b+c)/l)+g,k>b&&(k=b),0<h&&b-k<h&&(b=Math.round(k+(b-k)/2),m=Math.round(h/2),k=b-m,b+=m,m=!0),0<e&&b-k>e&&(b=Math.round(k+(b-k)/2),m=Math.round(e/2),k=b-m,b+=m,m=!0),b>a&&(b=
a),b-h<k&&(k=b-h),k<g&&(k=g),k+h>b&&(b=k+h),k!=this.startTime||b!=this.endTime)this.startTime=k,this.endTime=b,f.start=k,f.end=b,f.startDate=new Date(k),f.endDate=new Date(b),this.fire(f)}else{k.startOnAxis||(b+=l/2);c-=this.stepWidth/2;h=k.xToIndex(b);b=k.getCoordinate(h)-this.stepWidth/2;b=k.xToIndex(b+c);if(h!=this.start||this.end!=b)k.startOnAxis&&(this.resizingRight&&h==b&&b++,this.resizingLeft&&h==b&&(0<h?h--:b=1)),this.start=h,this.end=this.dragging?this.start+this.difference:b,f.start=this.start,
f.end=this.end,k.parseDates&&(a[this.start]&&(f.startDate=new Date(a[this.start].time)),a[this.end]&&(f.endDate=new Date(a[this.end].time))),this.fire(f);this.percentStart=h;this.percentEnd=b}m&&this.zoomScrollbar(!0)}},zoomScrollbar:function(a){if((!(this.dragging||this.resizingLeft||this.resizingRight||this.animating)||a)&&this.dragger&&this.enabled){var b,c,d=this.chart;a=d.chartData;var h=this.categoryAxis;h.parseDates&&!h.equalSpacing?(a=h.stepWidth,c=d.firstTime,b=a*(this.startTime-c),c=a*(this.endTime-
c)):(a[this.start]&&(b=a[this.start].x[h.id]),a[this.end]&&(c=a[this.end].x[h.id]),a=h.stepWidth,h.startOnAxis||(d=a/2,b-=d,c+=d));this.stepWidth=a;isNaN(b)||isNaN(c)||this.updateScrollbarSize(b,c)}},maskGraphs:function(a,b,c,d){var h=this.selectedGraph;h&&h.set.clipRect(a,b,c,d)},handleDragStart:function(){d.ChartScrollbar.base.handleDragStart.call(this);this.difference=this.end-this.start;this.timeDifference=this.endTime-this.startTime;0>this.timeDifference&&(this.timeDifference=0)},handleBackgroundClick:function(){d.ChartScrollbar.base.handleBackgroundClick.call(this);
this.dragging||(this.difference=this.end-this.start,this.timeDifference=this.endTime-this.startTime,0>this.timeDifference&&(this.timeDifference=0))}})})();(function(){var d=window.AmCharts;d.AmBalloon=d.Class({construct:function(a){this.cname="AmBalloon";this.enabled=!0;this.fillColor="#FFFFFF";this.fillAlpha=.8;this.borderThickness=2;this.borderColor="#FFFFFF";this.borderAlpha=1;this.cornerRadius=0;this.maxWidth=220;this.horizontalPadding=8;this.verticalPadding=4;this.pointerWidth=6;this.pointerOrientation="V";this.color="#000000";this.adjustBorderColor=!0;this.show=this.follow=this.showBullet=!1;this.bulletSize=3;this.shadowAlpha=.4;this.shadowColor=
"#000000";this.fadeOutDuration=this.animationDuration=.3;this.fixedPosition=!0;this.offsetY=6;this.offsetX=1;this.textAlign="center";this.disableMouseEvents=!0;this.deltaSignX=this.deltaSignY=1;d.isModern||(this.offsetY*=1.5);this.sdy=this.sdx=0;d.applyTheme(this,a,this.cname)},draw:function(){var a=this.pointToX,b=this.pointToY;d.isModern||(this.drop=!1);var c=this.chart;d.VML&&(this.fadeOutDuration=0);this.xAnim&&c.stopAnim(this.xAnim);this.yAnim&&c.stopAnim(this.yAnim);this.sdy=this.sdx=0;if(!isNaN(a)){var e=
this.follow,h=c.container,f=this.set;d.remove(f);this.removeDiv();f=h.set();f.node.style.pointerEvents="none";this.set=f;this.mainSet?(this.mainSet.push(this.set),this.sdx=this.mainSet.x,this.sdy=this.mainSet.y):c.balloonsSet.push(f);if(this.show){var g=this.l,k=this.t,l=this.r,m=this.b,p=this.balloonColor,q=this.fillColor,n=this.borderColor,t=q;void 0!=p&&(this.adjustBorderColor?t=n=p:q=p);var r=this.horizontalPadding,w=this.verticalPadding,z=this.pointerWidth,x=this.pointerOrientation,u=this.cornerRadius,
A=c.fontFamily,y=this.fontSize;void 0==y&&(y=c.fontSize);var p=document.createElement("div"),B=c.classNamePrefix;p.className=B+"-balloon-div";this.className&&(p.className=p.className+" "+B+"-balloon-div-"+this.className);B=p.style;this.disableMouseEvents&&(B.pointerEvents="none");B.position="absolute";var D=this.minWidth,C=document.createElement("div");p.appendChild(C);var I=C.style;isNaN(D)||(I.minWidth=D-2*r+"px");I.textAlign=this.textAlign;I.maxWidth=this.maxWidth+"px";I.fontSize=y+"px";I.color=
this.color;I.fontFamily=A;C.innerHTML=this.text;c.chartDiv.appendChild(p);this.textDiv=p;var I=p.offsetWidth,H=p.offsetHeight;p.clientHeight&&(I=p.clientWidth,H=p.clientHeight);A=H+2*w;C=I+2*r;!isNaN(D)&&C<D&&(C=D);window.opera&&(A+=2);var Q=!1,y=this.offsetY;c.handDrawn&&(y+=c.handDrawScatter+2);"H"!=x?(D=a-C/2,b<k+A+10&&"down"!=x?(Q=!0,e&&(b+=y),y=b+z,this.deltaSignY=-1):(e&&(b-=y),y=b-A-z,this.deltaSignY=1)):(2*z>A&&(z=A/2),y=b-A/2,a<g+(l-g)/2?(D=a+z,this.deltaSignX=-1):(D=a-C-z,this.deltaSignX=
1));y+A>=m&&(y=m-A);y<k&&(y=k);D<g&&(D=g);D+C>l&&(D=l-C);var k=y+w,m=D+r,M=this.shadowAlpha,P=this.shadowColor,r=this.borderThickness,ia=this.bulletSize,J,w=this.fillAlpha,aa=this.borderAlpha;this.showBullet&&(J=d.circle(h,ia,t,w),f.push(J));this.drop?(g=C/1.6,l=0,"V"==x&&(x="down"),"H"==x&&(x="left"),"down"==x&&(D=a+1,y=b-g-g/3),"up"==x&&(l=180,D=a+1,y=b+g+g/3),"left"==x&&(l=270,D=a+g+g/3+2,y=b),"right"==x&&(l=90,D=a-g-g/3+2,y=b),k=y-H/2+1,m=D-I/2-1,q=d.drop(h,g,l,q,w,r,n,aa)):0<u||0===z?(0<M&&(a=
d.rect(h,C,A,q,0,r+1,P,M,u),d.isModern?a.translate(1,1):a.translate(4,4),f.push(a)),q=d.rect(h,C,A,q,w,r,n,aa,u)):(t=[],u=[],"H"!=x?(g=a-D,g>C-z&&(g=C-z),g<z&&(g=z),t=[0,g-z,a-D,g+z,C,C,0,0],u=Q?[0,0,b-y,0,0,A,A,0]:[A,A,b-y,A,A,0,0,A]):(x=b-y,x>A-z&&(x=A-z),x<z&&(x=z),u=[0,x-z,b-y,x+z,A,A,0,0],t=a<g+(l-g)/2?[0,0,D<a?0:a-D,0,0,C,C,0]:[C,C,D+C>a?C:a-D,C,C,0,0,C]),0<M&&(a=d.polygon(h,t,u,q,0,r,P,M),a.translate(1,1),f.push(a)),q=d.polygon(h,t,u,q,w,r,n,aa));this.bg=q;f.push(q);q.toFront();d.setCN(c,q,
"balloon-bg");this.className&&d.setCN(c,q,"balloon-bg-"+this.className);h=1*this.deltaSignX;m+=this.sdx;k+=this.sdy;B.left=m+"px";B.top=k+"px";f.translate(D-h,y,1,!0);q=q.getBBox();this.bottom=y+A+1;this.yPos=q.y+y;J&&J.translate(this.pointToX-D+h,b-y);b=this.animationDuration;0<this.animationDuration&&!e&&!isNaN(this.prevX)&&(f.translate(this.prevX,this.prevY,NaN,!0),f.animate({translate:D-h+","+y},b,"easeOutSine"),p&&(B.left=this.prevTX+"px",B.top=this.prevTY+"px",this.xAnim=c.animate({node:p},
"left",this.prevTX,m,b,"easeOutSine","px"),this.yAnim=c.animate({node:p},"top",this.prevTY,k,b,"easeOutSine","px")));this.prevX=D-h;this.prevY=y;this.prevTX=m;this.prevTY=k}}},fixPrevious:function(){this.rPrevX=this.prevX;this.rPrevY=this.prevY;this.rPrevTX=this.prevTX;this.rPrevTY=this.prevTY},restorePrevious:function(){this.prevX=this.rPrevX;this.prevY=this.rPrevY;this.prevTX=this.rPrevTX;this.prevTY=this.rPrevTY},followMouse:function(){if(this.follow&&this.show){var a=this.chart.mouseX-this.offsetX*
this.deltaSignX-this.sdx,b=this.chart.mouseY-this.sdy;this.pointToX=a;this.pointToY=b;if(a!=this.previousX||b!=this.previousY)if(this.previousX=a,this.previousY=b,0===this.cornerRadius)this.draw();else{var c=this.set;if(c){var d=c.getBBox(),a=a-d.width/2,h=b-d.height-10;a<this.l&&(a=this.l);a>this.r-d.width&&(a=this.r-d.width);h<this.t&&(h=b+10);c.translate(a,h);b=this.textDiv.style;b.left=a+this.horizontalPadding+"px";b.top=h+this.verticalPadding+"px"}}}},changeColor:function(a){this.balloonColor=
a},setBounds:function(a,b,c,d){this.l=a;this.t=b;this.r=c;this.b=d;this.destroyTO&&clearTimeout(this.destroyTO)},showBalloon:function(a){if(this.text!=a||this.positionChanged)this.text=a,this.isHiding=!1,this.show=!0,this.destroyTO&&clearTimeout(this.destroyTO),a=this.chart,this.fadeAnim1&&a.stopAnim(this.fadeAnim1),this.fadeAnim2&&a.stopAnim(this.fadeAnim2),this.draw(),this.positionChanged=!1},hide:function(a){var b=this;b.text=void 0;isNaN(a)&&(a=b.fadeOutDuration);var c=b.chart;if(0<a&&!b.isHiding){b.isHiding=
!0;b.destroyTO&&clearTimeout(b.destroyTO);b.destroyTO=setTimeout(function(){b.destroy.call(b)},1E3*a);b.follow=!1;b.show=!1;var d=b.set;d&&(d.setAttr("opacity",b.fillAlpha),b.fadeAnim1=d.animate({opacity:0},a,"easeInSine"));b.textDiv&&(b.fadeAnim2=c.animate({node:b.textDiv},"opacity",1,0,a,"easeInSine",""))}else b.show=!1,b.follow=!1,b.destroy()},setPosition:function(a,b){if(a!=this.pointToX||b!=this.pointToY)this.previousX=this.pointToX,this.previousY=this.pointToY,this.pointToX=a,this.pointToY=
b,this.positionChanged=!0},followCursor:function(a){var b=this;b.follow=a;clearInterval(b.interval);var c=b.chart.mouseX-b.sdx,d=b.chart.mouseY-b.sdy;!isNaN(c)&&a&&(b.pointToX=c-b.offsetX*b.deltaSignX,b.pointToY=d,b.followMouse(),b.interval=setInterval(function(){b.followMouse.call(b)},40))},removeDiv:function(){if(this.textDiv){var a=this.textDiv.parentNode;a&&a.removeChild(this.textDiv)}},destroy:function(){clearInterval(this.interval);d.remove(this.set);this.removeDiv();this.set=null}})})();(function(){var d=window.AmCharts;d.AmCoordinateChart=d.Class({inherits:d.AmChart,construct:function(a){d.AmCoordinateChart.base.construct.call(this,a);this.theme=a;this.createEvents("rollOverGraphItem","rollOutGraphItem","clickGraphItem","doubleClickGraphItem","rightClickGraphItem","clickGraph","rollOverGraph","rollOutGraph");this.startAlpha=1;this.startDuration=0;this.startEffect="elastic";this.sequencedAnimation=!0;this.colors="#FF6600 #FCD202 #B0DE09 #0D8ECF #2A0CD0 #CD0D74 #CC0000 #00CC00 #0000CC #DDDDDD #999999 #333333 #990000".split(" ");
this.balloonDateFormat="MMM DD, YYYY";this.valueAxes=[];this.graphs=[];this.guides=[];this.gridAboveGraphs=!1;d.applyTheme(this,a,"AmCoordinateChart")},initChart:function(){d.AmCoordinateChart.base.initChart.call(this);this.drawGraphs=!0;var a=this.categoryAxis;a&&(this.categoryAxis=d.processObject(a,d.CategoryAxis,this.theme));this.processValueAxes();this.createValueAxes();this.processGraphs();this.processGuides();d.VML&&(this.startAlpha=1);this.setLegendData(this.graphs);this.gridAboveGraphs&&(this.gridSet.toFront(),
this.bulletSet.toFront(),this.balloonsSet.toFront())},createValueAxes:function(){if(0===this.valueAxes.length){var a=new d.ValueAxis;this.addValueAxis(a)}},parseData:function(){this.processValueAxes();this.processGraphs()},parseSerialData:function(a){this.chartData=[];if(a)if(0<this.processTimeout){1>this.processCount&&(this.processCount=1);var b=a.length/this.processCount;this.parseCount=Math.ceil(b)-1;for(var c=0;c<b;c++)this.delayParseSerialData(a,c)}else this.parseCount=0,this.parsePartSerialData(a,
0,a.length,0);else this.onDataUpdated()},delayParseSerialData:function(a,b){var c=this,d=c.processCount;setTimeout(function(){c.parsePartSerialData.call(c,a,b*d,(b+1)*d,b)},c.processTimeout)},parsePartSerialData:function(a,b,c,e){c>a.length&&(c=a.length);var h=this.graphs,f={},g=this.seriesIdField;g||(g=this.categoryField);var k=!1,l,m=this.categoryAxis,p,q,n;m&&(k=m.parseDates,p=m.forceShowField,n=m.classNameField,q=m.labelColorField,l=m.categoryFunction);var t,r,w={},z;k&&(t=d.extractPeriod(m.minPeriod),
r=t.period,t=t.count,z=d.getPeriodDuration(r,t));var x={};this.lookupTable=x;var u,A=this.dataDateFormat,y={};for(u=b;u<c;u++){var B={},D=a[u];b=D[this.categoryField];B.dataContext=D;B.category=l?l(b,D,m):String(b);p&&(B.forceShow=D[p]);n&&(B.className=D[n]);q&&(B.labelColor=D[q]);x[D[g]]=B;if(k&&(m.categoryFunction?b=m.categoryFunction(b,D,m):(!A||b instanceof Date||(b=b.toString()+" |"),b=d.getDate(b,A,m.minPeriod)),b=d.resetDateToMin(b,r,t,m.firstDayOfWeek),B.category=b,B.time=b.getTime(),isNaN(B.time)))continue;
var C=this.valueAxes;B.axes={};B.x={};var I;for(I=0;I<C.length;I++){var H=C[I].id;B.axes[H]={};B.axes[H].graphs={};var Q;for(Q=0;Q<h.length;Q++){b=h[Q];var M=b.id,P=1.1;isNaN(b.gapPeriod)||(P=b.gapPeriod);var ia=b.periodValue;if(b.valueAxis.id==H){B.axes[H].graphs[M]={};var J={};J.index=u;var aa=D;b.dataProvider&&(aa=f);J.values=this.processValues(aa,b,ia);if(!b.connect||b.forceGap&&!isNaN(b.gapPeriod))if(y&&y[M]&&0<P&&B.time-w[M]>=z*P&&(y[M].gap=!0),b.forceGap){var P=0,ma;for(ma in J.values)P++;
0<P&&(w[M]=B.time,y[M]=J)}else w[M]=B.time,y[M]=J;this.processFields(b,J,aa);J.category=B.category;J.serialDataItem=B;J.graph=b;B.axes[H].graphs[M]=J}}}this.chartData[u]=B}if(this.parseCount==e){for(a=0;a<h.length;a++)b=h[a],b.dataProvider&&this.parseGraphData(b);this.dataChanged=!1;this.dispatchDataUpdated=!0;this.onDataUpdated()}},processValues:function(a,b,c){var e={},h,f=!1;"candlestick"!=b.type&&"ohlc"!=b.type||""===c||(f=!0);for(var g="value error open close low high".split(" "),k=0;k<g.length;k++){var l=
g[k];"value"!=l&&"error"!=l&&f&&(c=l.charAt(0).toUpperCase()+l.slice(1));var m=a[b[l+"Field"]+c];null!==m&&(h=Number(m),isNaN(h)||(e[l]=h),"date"==b.valueAxis.type&&void 0!==m&&(h=d.getDate(m,b.chart.dataDateFormat),e[l]=h.getTime()))}return e},parseGraphData:function(a){var b=a.dataProvider,c=a.seriesIdField;c||(c=this.seriesIdField);c||(c=this.categoryField);var d;for(d=0;d<b.length;d++){var h=b[d],f=this.lookupTable[String(h[c])],g=a.valueAxis.id;f&&(g=f.axes[g].graphs[a.id],g.serialDataItem=f,
g.values=this.processValues(h,a,a.periodValue),this.processFields(a,g,h))}},addValueAxis:function(a){a.chart=this;this.valueAxes.push(a);this.validateData()},removeValueAxesAndGraphs:function(){var a=this.valueAxes,b;for(b=a.length-1;-1<b;b--)this.removeValueAxis(a[b])},removeValueAxis:function(a){var b=this.graphs,c;for(c=b.length-1;0<=c;c--){var d=b[c];d&&d.valueAxis==a&&this.removeGraph(d)}b=this.valueAxes;for(c=b.length-1;0<=c;c--)b[c]==a&&b.splice(c,1);this.validateData()},addGraph:function(a){this.graphs.push(a);
this.chooseGraphColor(a,this.graphs.length-1);this.validateData()},removeGraph:function(a){var b=this.graphs,c;for(c=b.length-1;0<=c;c--)b[c]==a&&(b.splice(c,1),a.destroy());this.validateData()},handleValueAxisZoom:function(){},processValueAxes:function(){var a=this.valueAxes,b;for(b=0;b<a.length;b++){var c=a[b],c=d.processObject(c,d.ValueAxis,this.theme);a[b]=c;c.chart=this;c.init();this.listenTo(c,"axisIntZoomed",this.handleValueAxisZoom);c.id||(c.id="valueAxisAuto"+b+"_"+(new Date).getTime());
void 0===c.usePrefixes&&(c.usePrefixes=this.usePrefixes)}},processGuides:function(){var a=this.guides,b=this.categoryAxis;if(a)for(var c=0;c<a.length;c++){var e=a[c];(void 0!==e.category||void 0!==e.date)&&b&&b.addGuide(e);e.id||(e.id="guideAuto"+c+"_"+(new Date).getTime());var h=e.valueAxis;h?(d.isString(h)&&(h=this.getValueAxisById(h)),h?h.addGuide(e):this.valueAxes[0].addGuide(e)):isNaN(e.value)||this.valueAxes[0].addGuide(e)}},processGraphs:function(){var a=this.graphs,b;this.graphsById={};for(b=
0;b<a.length;b++){var c=a[b],c=d.processObject(c,d.AmGraph,this.theme);a[b]=c;this.chooseGraphColor(c,b);c.chart=this;c.init();d.isString(c.valueAxis)&&(c.valueAxis=this.getValueAxisById(c.valueAxis));c.valueAxis||(c.valueAxis=this.valueAxes[0]);c.id||(c.id="graphAuto"+b+"_"+(new Date).getTime());this.graphsById[c.id]=c}},formatString:function(a,b,c){var e=b.graph,h=e.valueAxis;h.duration&&b.values.value&&(h=d.formatDuration(b.values.value,h.duration,"",h.durationUnits,h.maxInterval,h.numberFormatter),
a=a.split("[[value]]").join(h));a=d.massReplace(a,{"[[title]]":e.title,"[[description]]":b.description});a=c?d.fixNewLines(a):d.fixBrakes(a);return a=d.cleanFromEmpty(a)},getBalloonColor:function(a,b,c){var e=a.lineColor,h=a.balloonColor;c&&(h=e);c=a.fillColorsR;"object"==typeof c?e=c[0]:void 0!==c&&(e=c);b.isNegative&&(c=a.negativeLineColor,a=a.negativeFillColors,"object"==typeof a?c=a[0]:void 0!==a&&(c=a),void 0!==c&&(e=c));void 0!==b.color&&(e=b.color);void 0!==b.lineColor&&(e=b.lineColor);b=b.fillColors;
void 0!==b&&(e=b,d.ifArray(b)&&(e=b[0]));void 0===h&&(h=e);return h},getGraphById:function(a){return d.getObjById(this.graphs,a)},getValueAxisById:function(a){return d.getObjById(this.valueAxes,a)},processFields:function(a,b,c){if(a.itemColors){var e=a.itemColors,h=b.index;b.color=h<e.length?e[h]:d.randomColor()}e="lineColor color alpha fillColors description bullet customBullet bulletSize bulletConfig url labelColor dashLength pattern gap className columnIndex".split(" ");for(h=0;h<e.length;h++){var f=
e[h],g=a[f+"Field"];g&&(g=c[g],d.isDefined(g)&&(b[f]=g))}b.dataContext=c},chooseGraphColor:function(a,b){if(a.lineColor)a.lineColorR=a.lineColor;else{var c;c=this.colors.length>b?this.colors[b]:a.lineColorR?a.lineColorR:d.randomColor();a.lineColorR=c}a.fillColorsR=a.fillColors?a.fillColors:a.lineColorR;a.bulletBorderColorR=a.bulletBorderColor?a.bulletBorderColor:a.useLineColorForBulletBorder?a.lineColorR:a.bulletColor;a.bulletColorR=a.bulletColor?a.bulletColor:a.lineColorR;if(c=this.patterns)a.pattern=
c[b]},handleLegendEvent:function(a){var b=a.type;if(a=a.dataItem){var c=a.hidden,d=a.showBalloon;switch(b){case "clickMarker":this.textClickEnabled&&(d?this.hideGraphsBalloon(a):this.showGraphsBalloon(a));break;case "clickLabel":d?this.hideGraphsBalloon(a):this.showGraphsBalloon(a);break;case "rollOverItem":c||this.highlightGraph(a);break;case "rollOutItem":c||this.unhighlightGraph();break;case "hideItem":this.hideGraph(a);break;case "showItem":this.showGraph(a)}}},highlightGraph:function(a){var b=
this.graphs;if(b){var c,d=.2;this.legend&&(d=this.legend.rollOverGraphAlpha);if(1!=d)for(c=0;c<b.length;c++){var h=b[c];h!=a&&h.changeOpacity(d)}}},unhighlightGraph:function(){var a;this.legend&&(a=this.legend.rollOverGraphAlpha);if(1!=a){a=this.graphs;var b;for(b=0;b<a.length;b++)a[b].changeOpacity(1)}},showGraph:function(a){a.switchable&&(a.hidden=!1,this.dataChanged=!0,"xy"!=this.type&&(this.marginsUpdated=!1),this.chartCreated&&this.initChart())},hideGraph:function(a){a.switchable&&(this.dataChanged=
!0,"xy"!=this.type&&(this.marginsUpdated=!1),a.hidden=!0,this.chartCreated&&this.initChart())},hideGraphsBalloon:function(a){a.showBalloon=!1;this.updateLegend()},showGraphsBalloon:function(a){a.showBalloon=!0;this.updateLegend()},updateLegend:function(){this.legend&&this.legend.invalidateSize()},resetAnimation:function(){var a=this.graphs;if(a){var b;for(b=0;b<a.length;b++)a[b].animationPlayed=!1}},animateAgain:function(){this.resetAnimation();this.validateNow()}})})();(function(){var d=window.AmCharts;d.TrendLine=d.Class({construct:function(a){this.cname="TrendLine";this.createEvents("click","rollOver","rollOut");this.isProtected=!1;this.dashLength=0;this.lineColor="#00CC00";this.lineThickness=this.lineAlpha=1;d.applyTheme(this,a,this.cname)},draw:function(){var a=this;a.destroy();var b=a.chart,c=b.container,e,h,f,g,k=a.categoryAxis,l=a.initialDate,m=a.initialCategory,p=a.finalDate,q=a.finalCategory,n=a.valueAxis,t=a.valueAxisX,r=a.initialXValue,w=a.finalXValue,
z=a.initialValue,x=a.finalValue,u=n.recalculateToPercents,A=b.dataDateFormat;k&&(l&&(l=d.getDate(l,A,"fff"),a.initialDate=l,e=k.dateToCoordinate(l)),m&&(e=k.categoryToCoordinate(m)),p&&(p=d.getDate(p,A,"fff"),a.finalDate=p,h=k.dateToCoordinate(p)),q&&(h=k.categoryToCoordinate(q)));t&&!u&&(isNaN(r)||(e=t.getCoordinate(r)),isNaN(w)||(h=t.getCoordinate(w)));n&&!u&&(isNaN(z)||(f=n.getCoordinate(z)),isNaN(x)||(g=n.getCoordinate(x)));if(!(isNaN(e)||isNaN(h)||isNaN(f)||isNaN(f))){b.rotate?(k=[f,g],g=[e,
h]):(k=[e,h],g=[f,g]);l=a.lineColor;f=d.line(c,k,g,l,a.lineAlpha,a.lineThickness,a.dashLength);e=k;h=g;q=k[1]-k[0];n=g[1]-g[0];0===q&&(q=.01);0===n&&(n=.01);m=q/Math.abs(q);p=n/Math.abs(n);n=90*Math.PI/180-Math.asin(q/(q*n/Math.abs(q*n)*Math.sqrt(Math.pow(q,2)+Math.pow(n,2))));q=Math.abs(5*Math.cos(n));n=Math.abs(5*Math.sin(n));e.push(k[1]-m*n,k[0]-m*n);h.push(g[1]+p*q,g[0]+p*q);g=d.polygon(c,e,h,l,.005,0);c=c.set([g,f]);c.translate(b.marginLeftReal,b.marginTopReal);b.trendLinesSet.push(c);d.setCN(b,
f,"trend-line");d.setCN(b,f,"trend-line-"+a.id);a.line=f;a.set=c;if(f=a.initialImage)f=d.processObject(f,d.Image,a.theme),f.chart=b,f.draw(),f.translate(e[0]+f.offsetX,h[0]+f.offsetY),c.push(f.set);if(f=a.finalImage)f=d.processObject(f,d.Image,a.theme),f.chart=b,f.draw(),f.translate(e[1]+f.offsetX,h[1]+f.offsetY),c.push(f.set);g.mouseup(function(){a.handleLineClick()}).mouseover(function(){a.handleLineOver()}).mouseout(function(){a.handleLineOut()});g.touchend&&g.touchend(function(){a.handleLineClick()});
c.clipRect(0,0,b.plotAreaWidth,b.plotAreaHeight)}},handleLineClick:function(){this.fire({type:"click",trendLine:this,chart:this.chart})},handleLineOver:function(){var a=this.rollOverColor;void 0!==a&&this.line.attr({stroke:a});this.balloonText&&(clearTimeout(this.chart.hoverInt),a=this.line.getBBox(),this.chart.showBalloon(this.balloonText,this.lineColor,!0,this.x+a.x+a.width/2,this.y+a.y+a.height/2));this.fire({type:"rollOver",trendLine:this,chart:this.chart})},handleLineOut:function(){this.line.attr({stroke:this.lineColor});
this.balloonText&&this.chart.hideBalloon();this.fire({type:"rollOut",trendLine:this,chart:this.chart})},destroy:function(){d.remove(this.set)}})})();(function(){var d=window.AmCharts;d.Image=d.Class({construct:function(a){this.cname="Image";this.height=this.width=20;this.rotation=this.offsetY=this.offsetX=0;this.balloonColor=this.color="#000000";this.opacity=1;d.applyTheme(this,a,this.cname)},draw:function(){var a=this;a.set&&a.set.remove();var b=a.chart.container;a.set=b.set();var c,d;a.url?(c=b.image(a.url,0,0,a.width,a.height),d=1):a.svgPath&&(c=b.path(a.svgPath),c.setAttr("fill",a.color),c.setAttr("stroke",a.outlineColor),b=c.getBBox(),d=
Math.min(a.width/b.width,a.height/b.height));c&&(c.setAttr("opacity",a.opacity),a.set.rotate(a.rotation),c.translate(-a.width/2,-a.height/2,d),a.balloonText&&c.mouseover(function(){a.chart.showBalloon(a.balloonText,a.balloonColor,!0)}).mouseout(function(){a.chart.hideBalloon()}).touchend(function(){a.chart.hideBalloon()}).touchstart(function(){a.chart.showBalloon(a.balloonText,a.balloonColor,!0)}),a.set.push(c))},translate:function(a,b){this.set&&this.set.translate(a,b)}})})();(function(){var d=window.AmCharts;d.circle=function(a,b,c,e,h,f,g,k,l){0>=b&&(b=.001);if(void 0==h||0===h)h=.01;void 0===f&&(f="#000000");void 0===g&&(g=0);e={fill:c,stroke:f,"fill-opacity":e,"stroke-width":h,"stroke-opacity":g};a=isNaN(l)?a.circle(0,0,b).attr(e):a.ellipse(0,0,b,l).attr(e);k&&a.gradient("radialGradient",[c,d.adjustLuminosity(c,-.6)]);return a};d.text=function(a,b,c,e,h,f,g,k){f||(f="middle");"right"==f&&(f="end");"left"==f&&(f="start");isNaN(k)&&(k=1);void 0!==b&&(b=String(b),d.isIE&&
!d.isModern&&(b=b.replace("&amp;","&"),b=b.replace("&","&amp;")));c={fill:c,"font-family":e,"font-size":h+"px",opacity:k};!0===g&&(c["font-weight"]="bold");c["text-anchor"]=f;return a.text(b,c)};d.polygon=function(a,b,c,e,h,f,g,k,l,m,p){isNaN(f)&&(f=.01);isNaN(k)&&(k=h);var q=e,n=!1;"object"==typeof q&&1<q.length&&(n=!0,q=q[0]);void 0===g&&(g=q);h={fill:q,stroke:g,"fill-opacity":h,"stroke-width":f,"stroke-opacity":k};void 0!==p&&0<p&&(h["stroke-dasharray"]=p);p=d.dx;f=d.dy;a.handDrawn&&(c=d.makeHD(b,
c,a.handDrawScatter),b=c[0],c=c[1]);g=Math.round;m&&(g=Number);k="M"+(g(b[0])+p)+","+(g(c[0])+f);for(q=1;q<b.length;q++)m&&(b[q]=d.roundTo(b[q],5),c[q]=d.roundTo(c[q],5)),k+=" L"+(g(b[q])+p)+","+(g(c[q])+f);a=a.path(k+" Z").attr(h);n&&a.gradient("linearGradient",e,l);return a};d.rect=function(a,b,c,e,h,f,g,k,l,m,p){if(isNaN(b)||isNaN(c))return a.set();isNaN(f)&&(f=0);void 0===l&&(l=0);void 0===m&&(m=270);isNaN(h)&&(h=0);var q=e,n=!1;"object"==typeof q&&(q=q[0],n=!0);void 0===g&&(g=q);void 0===k&&
(k=h);b=Math.round(b);c=Math.round(c);var t=0,r=0;0>b&&(b=Math.abs(b),t=-b);0>c&&(c=Math.abs(c),r=-c);t+=d.dx;r+=d.dy;h={fill:q,stroke:g,"fill-opacity":h,"stroke-opacity":k};void 0!==p&&0<p&&(h["stroke-dasharray"]=p);a=a.rect(t,r,b,c,l,f).attr(h);n&&a.gradient("linearGradient",e,m);return a};d.bullet=function(a,b,c,e,h,f,g,k,l,m,p,q,n){var t;"circle"==b&&(b="round");switch(b){case "round":t=d.circle(a,c/2,e,h,f,g,k);break;case "square":t=d.polygon(a,[-c/2,c/2,c/2,-c/2],[c/2,c/2,-c/2,-c/2],e,h,f,g,
k,m-180,void 0,n);break;case "rectangle":t=d.polygon(a,[-c,c,c,-c],[c/2,c/2,-c/2,-c/2],e,h,f,g,k,m-180,void 0,n);break;case "diamond":t=d.polygon(a,[-c/2,0,c/2,0],[0,-c/2,0,c/2],e,h,f,g,k);break;case "triangleUp":t=d.triangle(a,c,0,e,h,f,g,k);break;case "triangleDown":t=d.triangle(a,c,180,e,h,f,g,k);break;case "triangleLeft":t=d.triangle(a,c,270,e,h,f,g,k);break;case "triangleRight":t=d.triangle(a,c,90,e,h,f,g,k);break;case "bubble":t=d.circle(a,c/2,e,h,f,g,k,!0);break;case "line":t=d.line(a,[-c/
2,c/2],[0,0],e,h,f,g,k);break;case "yError":t=a.set();t.push(d.line(a,[0,0],[-c/2,c/2],e,h,f));t.push(d.line(a,[-l,l],[-c/2,-c/2],e,h,f));t.push(d.line(a,[-l,l],[c/2,c/2],e,h,f));break;case "xError":t=a.set(),t.push(d.line(a,[-c/2,c/2],[0,0],e,h,f)),t.push(d.line(a,[-c/2,-c/2],[-l,l],e,h,f)),t.push(d.line(a,[c/2,c/2],[-l,l],e,h,f))}t&&t.pattern(p,NaN,q);return t};d.triangle=function(a,b,c,d,h,f,g,k){if(void 0===f||0===f)f=1;void 0===g&&(g="#000");void 0===k&&(k=0);d={fill:d,stroke:g,"fill-opacity":h,
"stroke-width":f,"stroke-opacity":k};b/=2;var l;0===c&&(l=" M"+-b+","+b+" L0,"+-b+" L"+b+","+b+" Z");180==c&&(l=" M"+-b+","+-b+" L0,"+b+" L"+b+","+-b+" Z");90==c&&(l=" M"+-b+","+-b+" L"+b+",0 L"+-b+","+b+" Z");270==c&&(l=" M"+-b+",0 L"+b+","+b+" L"+b+","+-b+" Z");return a.path(l).attr(d)};d.line=function(a,b,c,e,h,f,g,k,l,m,p){if(a.handDrawn&&!p)return d.handDrawnLine(a,b,c,e,h,f,g,k,l,m,p);f={fill:"none","stroke-width":f};void 0!==g&&0<g&&(f["stroke-dasharray"]=g);isNaN(h)||(f["stroke-opacity"]=
h);e&&(f.stroke=e);e=Math.round;m&&(e=Number,b[0]=d.roundTo(b[0],5),c[0]=d.roundTo(c[0],5));m=d.dx;h=d.dy;g="M"+(e(b[0])+m)+","+(e(c[0])+h);for(k=1;k<b.length;k++)b[k]=d.roundTo(b[k],5),c[k]=d.roundTo(c[k],5),g+=" L"+(e(b[k])+m)+","+(e(c[k])+h);if(d.VML)return a.path(g,void 0,!0).attr(f);l&&(g+=" M0,0 L0,0");return a.path(g).attr(f)};d.makeHD=function(a,b,c){for(var d=[],h=[],f=1;f<a.length;f++)for(var g=Number(a[f-1]),k=Number(b[f-1]),l=Number(a[f]),m=Number(b[f]),p=Math.round(Math.sqrt(Math.pow(l-
g,2)+Math.pow(m-k,2))/50)+1,l=(l-g)/p,m=(m-k)/p,q=0;q<=p;q++){var n=k+q*m+Math.random()*c;d.push(g+q*l+Math.random()*c);h.push(n)}return[d,h]};d.handDrawnLine=function(a,b,c,e,h,f,g,k,l,m){var p,q=a.set();for(p=1;p<b.length;p++)for(var n=[b[p-1],b[p]],t=[c[p-1],c[p]],t=d.makeHD(n,t,a.handDrawScatter),n=t[0],t=t[1],r=1;r<n.length;r++)q.push(d.line(a,[n[r-1],n[r]],[t[r-1],t[r]],e,h,f+Math.random()*a.handDrawThickness-a.handDrawThickness/2,g,k,l,m,!0));return q};d.doNothing=function(a){return a};d.drop=
function(a,b,c,d,h,f,g,k){var l=1/180*Math.PI,m=c-20,p=Math.sin(m*l)*b,q=Math.cos(m*l)*b,n=Math.sin((m+40)*l)*b,t=Math.cos((m+40)*l)*b,r=.8*b,w=-b/3,z=b/3;0===c&&(w=-w,z=0);180==c&&(z=0);90==c&&(w=0);270==c&&(w=0,z=-z);c={fill:d,stroke:g,"stroke-width":f,"stroke-opacity":k,"fill-opacity":h};b="M"+p+","+q+" A"+b+","+b+",0,1,1,"+n+","+t+(" A"+r+","+r+",0,0,0,"+(Math.sin((m+20)*l)*b+z)+","+(Math.cos((m+20)*l)*b+w));b+=" A"+r+","+r+",0,0,0,"+p+","+q;return a.path(b,void 0,void 0,"1000,1000").attr(c)};
d.wedge=function(a,b,c,e,h,f,g,k,l,m,p,q,n,t){var r=Math.round;f=r(f);g=r(g);k=r(k);var w=r(g/f*k),z=d.VML,x=359.5+f/100;359.94<x&&(x=359.94);h>=x&&(h=x);var u=1/180*Math.PI,x=b+Math.sin(e*u)*k,A=c-Math.cos(e*u)*w,y=b+Math.sin(e*u)*f,B=c-Math.cos(e*u)*g,D=b+Math.sin((e+h)*u)*f,C=c-Math.cos((e+h)*u)*g,I=b+Math.sin((e+h)*u)*k,u=c-Math.cos((e+h)*u)*w,H={fill:d.adjustLuminosity(m.fill,-.2),"stroke-opacity":0,"fill-opacity":m["fill-opacity"]},Q=0;180<Math.abs(h)&&(Q=1);e=a.set();var M;z&&(x=r(10*x),y=
r(10*y),D=r(10*D),I=r(10*I),A=r(10*A),B=r(10*B),C=r(10*C),u=r(10*u),b=r(10*b),l=r(10*l),c=r(10*c),f*=10,g*=10,k*=10,w*=10,1>Math.abs(h)&&1>=Math.abs(D-y)&&1>=Math.abs(C-B)&&(M=!0));h="";var P;q&&(H["fill-opacity"]=0,H["stroke-opacity"]=m["stroke-opacity"]/2,H.stroke=m.stroke);if(0<l){P=" M"+x+","+(A+l)+" L"+y+","+(B+l);z?(M||(P+=" A"+(b-f)+","+(l+c-g)+","+(b+f)+","+(l+c+g)+","+y+","+(B+l)+","+D+","+(C+l)),P+=" L"+I+","+(u+l),0<k&&(M||(P+=" B"+(b-k)+","+(l+c-w)+","+(b+k)+","+(l+c+w)+","+I+","+(l+u)+
","+x+","+(l+A)))):(P+=" A"+f+","+g+",0,"+Q+",1,"+D+","+(C+l)+" L"+I+","+(u+l),0<k&&(P+=" A"+k+","+w+",0,"+Q+",0,"+x+","+(A+l)));P+=" Z";var ia=l;z&&(ia/=10);for(var J=0;J<ia;J+=10){var aa=a.path(P,void 0,void 0,"1000,1000").attr(H);e.push(aa);aa.translate(0,-J)}P=a.path(" M"+x+","+A+" L"+x+","+(A+l)+" L"+y+","+(B+l)+" L"+y+","+B+" L"+x+","+A+" Z",void 0,void 0,"1000,1000").attr(H);l=a.path(" M"+D+","+C+" L"+D+","+(C+l)+" L"+I+","+(u+l)+" L"+I+","+u+" L"+D+","+C+" Z",void 0,void 0,"1000,1000").attr(H);
e.push(P);e.push(l)}z?(M||(h=" A"+r(b-f)+","+r(c-g)+","+r(b+f)+","+r(c+g)+","+r(y)+","+r(B)+","+r(D)+","+r(C)),g=" M"+r(x)+","+r(A)+" L"+r(y)+","+r(B)+h+" L"+r(I)+","+r(u)):g=" M"+x+","+A+" L"+y+","+B+(" A"+f+","+g+",0,"+Q+",1,"+D+","+C)+" L"+I+","+u;0<k&&(z?M||(g+=" B"+(b-k)+","+(c-w)+","+(b+k)+","+(c+w)+","+I+","+u+","+x+","+A):g+=" A"+k+","+w+",0,"+Q+",0,"+x+","+A);a.handDrawn&&(k=d.line(a,[x,y],[A,B],m.stroke,m.thickness*Math.random()*a.handDrawThickness,m["stroke-opacity"]),e.push(k));a=a.path(g+
" Z",void 0,void 0,"1000,1000").attr(m);if(p){k=[];for(w=0;w<p.length;w++)k.push(d.adjustLuminosity(m.fill,p[w]));"radial"!=t||d.isModern||(k=[]);0<k.length&&a.gradient(t+"Gradient",k)}d.isModern&&"radial"==t&&a.grad&&(a.grad.setAttribute("gradientUnits","userSpaceOnUse"),a.grad.setAttribute("r",f),a.grad.setAttribute("cx",b),a.grad.setAttribute("cy",c));a.pattern(q,NaN,n);e.wedge=a;e.push(a);return e};d.rgb2hex=function(a){return(a=a.match(/^rgba?[\s+]?\([\s+]?(\d+)[\s+]?,[\s+]?(\d+)[\s+]?,[\s+]?(\d+)[\s+]?/i))&&
4===a.length?"#"+("0"+parseInt(a[1],10).toString(16)).slice(-2)+("0"+parseInt(a[2],10).toString(16)).slice(-2)+("0"+parseInt(a[3],10).toString(16)).slice(-2):""};d.adjustLuminosity=function(a,b){a&&-1!=a.indexOf("rgb")&&(a=d.rgb2hex(a));a=String(a).replace(/[^0-9a-f]/gi,"");6>a.length&&(a=String(a[0])+String(a[0])+String(a[1])+String(a[1])+String(a[2])+String(a[2]));b=b||0;var c="#",e,h;for(h=0;3>h;h++)e=parseInt(a.substr(2*h,2),16),e=Math.round(Math.min(Math.max(0,e+e*b),255)).toString(16),c+=("00"+
e).substr(e.length);return c}})();(function(){var d=window.AmCharts;d.Bezier=d.Class({construct:function(a,b,c,e,h,f,g,k,l,m,p){var q=a.chart,n=d.bezierX,t=d.bezierY;isNaN(q.bezierX)||(n=q.bezierX);isNaN(q.bezierY)||(t=q.bezierY);isNaN(n)&&(q.rotate?(n=20,t=4):(t=20,n=4));var r,w;"object"==typeof g&&1<g.length&&(w=!0,r=g,g=g[0]);"object"==typeof k&&(k=k[0]);0===k&&(g="none");f={fill:g,"fill-opacity":k,"stroke-width":f};void 0!==l&&0<l&&(f["stroke-dasharray"]=l);isNaN(h)||(f["stroke-opacity"]=h);e&&(f.stroke=e);e="M"+Math.round(b[0])+
","+Math.round(c[0])+" ";h=[];for(l=0;l<b.length;l++)isNaN(b[l])||isNaN(c[l])?(e+=this.drawSegment(h,n,t),l<b.length-1&&(e+="L"+b[l+1]+","+c[l+1]+" "),h=[]):h.push({x:Number(b[l]),y:Number(c[l])});e+=this.drawSegment(h,n,t);m?e+=m:d.VML||(e+="M0,0 L0,0");this.path=a.path(e).attr(f);this.node=this.path.node;w&&this.path.gradient("linearGradient",r,p)},drawSegment:function(a,b,c){var d="";if(2<a.length)for(var h=0;h<a.length-1;h++){var f=[],g=a[h-1],k=a[h],l=a[h+1],m=a[h+2];0===h?(f.push({x:k.x,y:k.y}),
f.push({x:k.x,y:k.y}),f.push({x:l.x,y:l.y}),f.push({x:m.x,y:m.y})):h>=a.length-2?(f.push({x:g.x,y:g.y}),f.push({x:k.x,y:k.y}),f.push({x:l.x,y:l.y}),f.push({x:l.x,y:l.y})):(f.push({x:g.x,y:g.y}),f.push({x:k.x,y:k.y}),f.push({x:l.x,y:l.y}),f.push({x:m.x,y:m.y}));g=[];k=Math.round;g.push({x:k(f[1].x),y:k(f[1].y)});g.push({x:k((-f[0].x+b*f[1].x+f[2].x)/b),y:k((-f[0].y+c*f[1].y+f[2].y)/c)});g.push({x:k((f[1].x+b*f[2].x-f[3].x)/b),y:k((f[1].y+c*f[2].y-f[3].y)/c)});g.push({x:k(f[2].x),y:k(f[2].y)});d+="C"+
g[1].x+","+g[1].y+","+g[2].x+","+g[2].y+","+g[3].x+","+g[3].y+" "}else 1<a.length&&(d+="L"+a[1].x+","+a[1].y);return d}})})();(function(){var d=window.AmCharts;d.AmDraw=d.Class({construct:function(a,b,c,e){d.SVG_NS="http://www.w3.org/2000/svg";d.SVG_XLINK="http://www.w3.org/1999/xlink";d.hasSVG=!!document.createElementNS&&!!document.createElementNS(d.SVG_NS,"svg").createSVGRect;1>b&&(b=10);1>c&&(c=10);this.div=a;this.width=b;this.height=c;this.rBin=document.createElement("div");d.hasSVG?(d.SVG=!0,b=this.createSvgElement("svg"),a.appendChild(b),this.container=b,this.addDefs(e),this.R=new d.SVGRenderer(this)):d.isIE&&d.VMLRenderer&&
(d.VML=!0,d.vmlStyleSheet||(document.namespaces.add("amvml","urn:schemas-microsoft-com:vml"),31>document.styleSheets.length?(b=document.createStyleSheet(),b.addRule(".amvml","behavior:url(#default#VML); display:inline-block; antialias:true"),d.vmlStyleSheet=b):document.styleSheets[0].addRule(".amvml","behavior:url(#default#VML); display:inline-block; antialias:true")),this.container=a,this.R=new d.VMLRenderer(this,e),this.R.disableSelection(a))},createSvgElement:function(a){return document.createElementNS(d.SVG_NS,
a)},circle:function(a,b,c,e){var h=new d.AmDObject("circle",this);h.attr({r:c,cx:a,cy:b});this.addToContainer(h.node,e);return h},ellipse:function(a,b,c,e,h){var f=new d.AmDObject("ellipse",this);f.attr({rx:c,ry:e,cx:a,cy:b});this.addToContainer(f.node,h);return f},setSize:function(a,b){0<a&&0<b&&(this.container.style.width=a+"px",this.container.style.height=b+"px")},rect:function(a,b,c,e,h,f,g){var k=new d.AmDObject("rect",this);d.VML&&(h=Math.round(100*h/Math.min(c,e)),c+=2*f,e+=2*f,k.bw=f,k.node.style.marginLeft=
-f,k.node.style.marginTop=-f);1>c&&(c=1);1>e&&(e=1);k.attr({x:a,y:b,width:c,height:e,rx:h,ry:h,"stroke-width":f});this.addToContainer(k.node,g);return k},image:function(a,b,c,e,h,f){var g=new d.AmDObject("image",this);g.attr({x:b,y:c,width:e,height:h});this.R.path(g,a);this.addToContainer(g.node,f);return g},addToContainer:function(a,b){b||(b=this.container);b.appendChild(a)},text:function(a,b,c){return this.R.text(a,b,c)},path:function(a,b,c,e){var h=new d.AmDObject("path",this);e||(e="100,100");
h.attr({cs:e});c?h.attr({dd:a}):h.attr({d:a});this.addToContainer(h.node,b);return h},set:function(a){return this.R.set(a)},remove:function(a){if(a){var b=this.rBin;b.appendChild(a);b.innerHTML=""}},renderFix:function(){var a=this.container,b=a.style;b.top="0px";b.left="0px";try{var c=a.getBoundingClientRect(),d=c.left-Math.round(c.left),h=c.top-Math.round(c.top);d&&(b.left=d+"px");h&&(b.top=h+"px")}catch(f){}},update:function(){this.R.update()},addDefs:function(a){if(d.hasSVG){var b=this.createSvgElement("desc"),
c=this.container;c.setAttribute("version","1.1");c.style.position="absolute";this.setSize(this.width,this.height);if(a.accessibleTitle){var e=this.createSvgElement("text");c.appendChild(e);e.innerHTML=a.accessibleTitle;e.style.opacity=0}d.rtl&&(c.setAttribute("direction","rtl"),c.style.left="auto",c.style.right="0px");a&&(a.addCodeCredits&&b.appendChild(document.createTextNode("JavaScript chart by amCharts "+a.version)),c.appendChild(b),a.defs&&(b=this.createSvgElement("defs"),c.appendChild(b),d.parseDefs(a.defs,
b),this.defs=b))}}})})();(function(){var d=window.AmCharts;d.AmDObject=d.Class({construct:function(a,b){this.D=b;this.R=b.R;this.node=this.R.create(this,a);this.y=this.x=0;this.scale=1},attr:function(a){this.R.attr(this,a);return this},getAttr:function(a){return this.node.getAttribute(a)},setAttr:function(a,b){this.R.setAttr(this,a,b);return this},clipRect:function(a,b,c,d){this.R.clipRect(this,a,b,c,d)},translate:function(a,b,c,d){d||(a=Math.round(a),b=Math.round(b));this.R.move(this,a,b,c);this.x=a;this.y=b;this.scale=
c;this.angle&&this.rotate(this.angle)},rotate:function(a,b){this.R.rotate(this,a,b);this.angle=a},animate:function(a,b,c){for(var e in a)if(a.hasOwnProperty(e)){var h=e,f=a[e];c=d.getEffect(c);this.R.animate(this,h,f,b,c)}},push:function(a){if(a){var b=this.node;b.appendChild(a.node);var c=a.clipPath;c&&b.appendChild(c);(a=a.grad)&&b.appendChild(a)}},text:function(a){this.R.setText(this,a)},remove:function(){this.stop();this.R.remove(this)},clear:function(){var a=this.node;if(a.hasChildNodes())for(;1<=
a.childNodes.length;)a.removeChild(a.firstChild)},hide:function(){this.setAttr("visibility","hidden")},show:function(){this.setAttr("visibility","visible")},getBBox:function(){return this.R.getBBox(this)},toFront:function(){var a=this.node;if(a){this.prevNextNode=a.nextSibling;var b=a.parentNode;b&&b.appendChild(a)}},toPrevious:function(){var a=this.node;a&&this.prevNextNode&&(a=a.parentNode)&&a.insertBefore(this.prevNextNode,null)},toBack:function(){var a=this.node;if(a){this.prevNextNode=a.nextSibling;
var b=a.parentNode;if(b){var c=b.firstChild;c&&b.insertBefore(a,c)}}},mouseover:function(a){this.R.addListener(this,"mouseover",a);return this},mouseout:function(a){this.R.addListener(this,"mouseout",a);return this},click:function(a){this.R.addListener(this,"click",a);return this},dblclick:function(a){this.R.addListener(this,"dblclick",a);return this},mousedown:function(a){this.R.addListener(this,"mousedown",a);return this},mouseup:function(a){this.R.addListener(this,"mouseup",a);return this},touchmove:function(a){this.R.addListener(this,
"touchmove",a);return this},touchstart:function(a){this.R.addListener(this,"touchstart",a);return this},touchend:function(a){this.R.addListener(this,"touchend",a);return this},keyup:function(a){this.R.addListener(this,"keyup",a);return this},focus:function(a){this.R.addListener(this,"focus",a);return this},blur:function(a){this.R.addListener(this,"blur",a);return this},contextmenu:function(a){this.node.addEventListener?this.node.addEventListener("contextmenu",a,!0):this.R.addListener(this,"contextmenu",
a);return this},stop:function(){d.removeFromArray(this.R.animations,this.an_translate);d.removeFromArray(this.R.animations,this.an_y);d.removeFromArray(this.R.animations,this.an_x)},length:function(){return this.node.childNodes.length},gradient:function(a,b,c){this.R.gradient(this,a,b,c)},pattern:function(a,b,c){a&&this.R.pattern(this,a,b,c)}})})();(function(){var d=window.AmCharts;d.VMLRenderer=d.Class({construct:function(a,b){this.chart=b;this.D=a;this.cNames={circle:"oval",ellipse:"oval",rect:"roundrect",path:"shape"};this.styleMap={x:"left",y:"top",width:"width",height:"height","font-family":"fontFamily","font-size":"fontSize",visibility:"visibility"}},create:function(a,b){var c;if("group"==b)c=document.createElement("div"),a.type="div";else if("text"==b)c=document.createElement("div"),a.type="text";else if("image"==b)c=document.createElement("img"),
a.type="image";else{a.type="shape";a.shapeType=this.cNames[b];c=document.createElement("amvml:"+this.cNames[b]);var d=document.createElement("amvml:stroke");c.appendChild(d);a.stroke=d;var h=document.createElement("amvml:fill");c.appendChild(h);a.fill=h;h.className="amvml";d.className="amvml";c.className="amvml"}c.style.position="absolute";c.style.top=0;c.style.left=0;return c},path:function(a,b){a.node.setAttribute("src",b)},setAttr:function(a,b,c){if(void 0!==c){var e;8===document.documentMode&&
(e=!0);var h=a.node,f=a.type,g=h.style;"r"==b&&(g.width=2*c,g.height=2*c);"oval"==a.shapeType&&("rx"==b&&(g.width=2*c),"ry"==b&&(g.height=2*c));"roundrect"==a.shapeType&&("width"!=b&&"height"!=b||--c);"cursor"==b&&(g.cursor=c);"cx"==b&&(g.left=c-d.removePx(g.width)/2);"cy"==b&&(g.top=c-d.removePx(g.height)/2);var k=this.styleMap[b];"width"==k&&0>c&&(c=0);void 0!==k&&(g[k]=c);"text"==f&&("text-anchor"==b&&(a.anchor=c,k=h.clientWidth,"end"==c&&(g.marginLeft=-k+"px"),"middle"==c&&(g.marginLeft=-(k/2)+
"px",g.textAlign="center"),"start"==c&&(g.marginLeft="0px")),"fill"==b&&(g.color=c),"font-weight"==b&&(g.fontWeight=c));if(g=a.children)for(k=0;k<g.length;k++)g[k].setAttr(b,c);if("shape"==f){"cs"==b&&(h.style.width="100px",h.style.height="100px",h.setAttribute("coordsize",c));"d"==b&&h.setAttribute("path",this.svgPathToVml(c));"dd"==b&&h.setAttribute("path",c);f=a.stroke;a=a.fill;"stroke"==b&&(e?f.color=c:f.setAttribute("color",c));"stroke-width"==b&&(e?f.weight=c:f.setAttribute("weight",c));"stroke-opacity"==
b&&(e?f.opacity=c:f.setAttribute("opacity",c));"stroke-dasharray"==b&&(g="solid",0<c&&3>c&&(g="dot"),3<=c&&6>=c&&(g="dash"),6<c&&(g="longdash"),e?f.dashstyle=g:f.setAttribute("dashstyle",g));if("fill-opacity"==b||"opacity"==b)0===c?e?a.on=!1:a.setAttribute("on",!1):e?a.opacity=c:a.setAttribute("opacity",c);"fill"==b&&(e?a.color=c:a.setAttribute("color",c));"rx"==b&&(e?h.arcSize=c+"%":h.setAttribute("arcsize",c+"%"))}}},attr:function(a,b){for(var c in b)b.hasOwnProperty(c)&&this.setAttr(a,c,b[c])},
text:function(a,b,c){var e=new d.AmDObject("text",this.D),h=e.node;h.style.whiteSpace="pre";h.innerHTML=a;this.D.addToContainer(h,c);this.attr(e,b);return e},getBBox:function(a){return this.getBox(a.node)},getBox:function(a){var b=a.offsetLeft,c=a.offsetTop,d=a.offsetWidth,h=a.offsetHeight,f;if(a.hasChildNodes()){var g,k,l;for(l=0;l<a.childNodes.length;l++){f=this.getBox(a.childNodes[l]);var m=f.x;isNaN(m)||(isNaN(g)?g=m:m<g&&(g=m));var p=f.y;isNaN(p)||(isNaN(k)?k=p:p<k&&(k=p));m=f.width+m;isNaN(m)||
(d=Math.max(d,m));f=f.height+p;isNaN(f)||(h=Math.max(h,f))}0>g&&(b+=g);0>k&&(c+=k)}return{x:b,y:c,width:d,height:h}},setText:function(a,b){var c=a.node;c&&(c.innerHTML=b);this.setAttr(a,"text-anchor",a.anchor)},addListener:function(a,b,c){a.node["on"+b]=c},move:function(a,b,c){var e=a.node,h=e.style;"text"==a.type&&(c-=d.removePx(h.fontSize)/2-1);"oval"==a.shapeType&&(b-=d.removePx(h.width)/2,c-=d.removePx(h.height)/2);a=a.bw;isNaN(a)||(b-=a,c-=a);isNaN(b)||isNaN(c)||(e.style.left=b+"px",e.style.top=
c+"px")},svgPathToVml:function(a){var b=a.split(" ");a="";var c,d=Math.round,h;for(h=0;h<b.length;h++){var f=b[h],g=f.substring(0,1),f=f.substring(1),k=f.split(","),l=d(k[0])+","+d(k[1]);"M"==g&&(a+=" m "+l);"L"==g&&(a+=" l "+l);"Z"==g&&(a+=" x e");if("Q"==g){var m=c.length,p=c[m-1],q=k[0],n=k[1],l=k[2],t=k[3];c=d(c[m-2]/3+2/3*q);p=d(p/3+2/3*n);q=d(2/3*q+l/3);n=d(2/3*n+t/3);a+=" c "+c+","+p+","+q+","+n+","+l+","+t}"C"==g&&(a+=" c "+k[0]+","+k[1]+","+k[2]+","+k[3]+","+k[4]+","+k[5]);"A"==g&&(a+=" wa "+
f);"B"==g&&(a+=" at "+f);c=k}return a},animate:function(a,b,c,d,h){var f=a.node,g=this.chart;a.animationFinished=!1;if("translate"==b){b=c.split(",");c=b[1];var k=f.offsetTop;g.animate(a,"left",f.offsetLeft,b[0],d,h,"px");g.animate(a,"top",k,c,d,h,"px")}},clipRect:function(a,b,c,d,h){a=a.node;0===b&&0===c?(a.style.width=d+"px",a.style.height=h+"px",a.style.overflow="hidden"):a.style.clip="rect("+c+"px "+(b+d)+"px "+(c+h)+"px "+b+"px)"},rotate:function(a,b,c){if(0!==Number(b)){var e=a.node;a=e.style;
c||(c=this.getBGColor(e.parentNode));a.backgroundColor=c;a.paddingLeft=1;c=b*Math.PI/180;var h=Math.cos(c),f=Math.sin(c),g=d.removePx(a.left),k=d.removePx(a.top),l=e.offsetWidth,e=e.offsetHeight;b/=Math.abs(b);a.left=g+l/2-l/2*Math.cos(c)-b*e/2*Math.sin(c)+3;a.top=k-b*l/2*Math.sin(c)+b*e/2*Math.sin(c);a.cssText=a.cssText+"; filter:progid:DXImageTransform.Microsoft.Matrix(M11='"+h+"', M12='"+-f+"', M21='"+f+"', M22='"+h+"', sizingmethod='auto expand');"}},getBGColor:function(a){var b="#FFFFFF";if(a.style){var c=
a.style.backgroundColor;""!==c?b=c:a.parentNode&&(b=this.getBGColor(a.parentNode))}return b},set:function(a){var b=new d.AmDObject("group",this.D);this.D.container.appendChild(b.node);if(a){var c;for(c=0;c<a.length;c++)b.push(a[c])}return b},gradient:function(a,b,c,d){var h="";"radialGradient"==b&&(b="gradientradial",c.reverse());"linearGradient"==b&&(b="gradient");var f;for(f=0;f<c.length;f++)h+=Math.round(100*f/(c.length-1))+"% "+c[f],f<c.length-1&&(h+=",");a=a.fill;90==d?d=0:270==d?d=180:180==
d?d=90:0===d&&(d=270);8===document.documentMode?(a.type=b,a.angle=d):(a.setAttribute("type",b),a.setAttribute("angle",d));h&&(a.colors.value=h)},remove:function(a){a.clipPath&&this.D.remove(a.clipPath);this.D.remove(a.node)},disableSelection:function(a){a.onselectstart=function(){return!1};a.style.cursor="default"},pattern:function(a,b,c,e){c=a.node;a=a.fill;var h="none";b.color&&(h=b.color);c.fillColor=h;b=b.url;d.isAbsolute(b)||(b=e+b);8===document.documentMode?(a.type="tile",a.src=b):(a.setAttribute("type",
"tile"),a.setAttribute("src",b))},update:function(){}})})();(function(){var d=window.AmCharts;d.SVGRenderer=d.Class({construct:function(a){this.D=a;this.animations=[]},create:function(a,b){return document.createElementNS(d.SVG_NS,b)},attr:function(a,b){for(var c in b)b.hasOwnProperty(c)&&this.setAttr(a,c,b[c])},setAttr:function(a,b,c){void 0!==c&&a.node.setAttribute(b,c)},animate:function(a,b,c,e,h){a.animationFinished=!1;var f=a.node;a["an_"+b]&&d.removeFromArray(this.animations,a["an_"+b]);"translate"==b?(f=(f=f.getAttribute("transform"))?String(f).substring(10,
f.length-1):"0,0",f=f.split(", ").join(" "),f=f.split(" ").join(","),0===f&&(f="0,0")):f=Number(f.getAttribute(b));c={obj:a,frame:0,attribute:b,from:f,to:c,time:e,effect:h};this.animations.push(c);a["an_"+b]=c},update:function(){var a,b=this.animations;for(a=b.length-1;0<=a;a--){var c=b[a],e=c.time*d.updateRate,h=c.frame+1,f=c.obj,g=c.attribute,k,l,m;if(h<=e){c.frame++;if("translate"==g){k=c.from.split(",");g=Number(k[0]);k=Number(k[1]);isNaN(k)&&(k=0);l=c.to.split(",");m=Number(l[0]);l=Number(l[1]);
m=0===m-g?m:Math.round(d[c.effect](0,h,g,m-g,e));c=0===l-k?l:Math.round(d[c.effect](0,h,k,l-k,e));g="transform";if(isNaN(m)||isNaN(c))continue;c="translate("+m+","+c+")"}else l=Number(c.from),k=Number(c.to),m=k-l,c=d[c.effect](0,h,l,m,e),isNaN(c)&&(c=k),0===m&&this.animations.splice(a,1);this.setAttr(f,g,c)}else"translate"==g?(l=c.to.split(","),m=Number(l[0]),l=Number(l[1]),f.translate(m,l)):(k=Number(c.to),this.setAttr(f,g,k)),f.animationFinished=!0,this.animations.splice(a,1)}},getBBox:function(a){if(a=
a.node)try{return a.getBBox()}catch(b){}return{width:0,height:0,x:0,y:0}},path:function(a,b){a.node.setAttributeNS(d.SVG_XLINK,"xlink:href",b)},clipRect:function(a,b,c,e,h){var f=a.node,g=a.clipPath;g&&this.D.remove(g);var k=f.parentNode;k&&(f=document.createElementNS(d.SVG_NS,"clipPath"),g=d.getUniqueId(),f.setAttribute("id",g),this.D.rect(b,c,e,h,0,0,f),k.appendChild(f),b="#",d.baseHref&&!d.isIE&&(b=this.removeTarget(window.location.href)+b),this.setAttr(a,"clip-path","url("+b+g+")"),this.clipPathC++,
a.clipPath=f)},text:function(a,b,c){var e=new d.AmDObject("text",this.D);a=String(a).split("\n");var h=d.removePx(b["font-size"]),f;for(f=0;f<a.length;f++){var g=this.create(null,"tspan");g.appendChild(document.createTextNode(a[f]));g.setAttribute("y",(h+2)*f+Math.round(h/2));g.setAttribute("x",0);e.node.appendChild(g)}e.node.setAttribute("y",Math.round(h/2));this.attr(e,b);this.D.addToContainer(e.node,c);return e},setText:function(a,b){var c=a.node;c&&(c.removeChild(c.firstChild),c.appendChild(document.createTextNode(b)))},
move:function(a,b,c,d){isNaN(b)&&(b=0);isNaN(c)&&(c=0);b="translate("+b+","+c+")";d&&(b=b+" scale("+d+")");this.setAttr(a,"transform",b)},rotate:function(a,b){var c=a.node.getAttribute("transform"),d="rotate("+b+")";c&&(d=c+" "+d);this.setAttr(a,"transform",d)},set:function(a){var b=new d.AmDObject("g",this.D);this.D.container.appendChild(b.node);if(a){var c;for(c=0;c<a.length;c++)b.push(a[c])}return b},addListener:function(a,b,c){a.node["on"+b]=c},gradient:function(a,b,c,e){var h=a.node,f=a.grad;
f&&this.D.remove(f);b=document.createElementNS(d.SVG_NS,b);f=d.getUniqueId();b.setAttribute("id",f);if(!isNaN(e)){var g=0,k=0,l=0,m=0;90==e?l=100:270==e?m=100:180==e?g=100:0===e&&(k=100);b.setAttribute("x1",g+"%");b.setAttribute("x2",k+"%");b.setAttribute("y1",l+"%");b.setAttribute("y2",m+"%")}for(e=0;e<c.length;e++)g=document.createElementNS(d.SVG_NS,"stop"),k=100*e/(c.length-1),0===e&&(k=0),g.setAttribute("offset",k+"%"),g.setAttribute("stop-color",c[e]),b.appendChild(g);h.parentNode.appendChild(b);
c="#";d.baseHref&&!d.isIE&&(c=this.removeTarget(window.location.href)+c);h.setAttribute("fill","url("+c+f+")");a.grad=b},removeTarget:function(a){return a.split("#")[0]},pattern:function(a,b,c,e){var h=a.node;isNaN(c)&&(c=1);var f=a.patternNode;f&&this.D.remove(f);var f=document.createElementNS(d.SVG_NS,"pattern"),g=d.getUniqueId(),k=b;b.url&&(k=b.url);d.isAbsolute(k)||-1!=k.indexOf("data:image")||(k=e+k);e=Number(b.width);isNaN(e)&&(e=4);var l=Number(b.height);isNaN(l)&&(l=4);e/=c;l/=c;c=b.x;isNaN(c)&&
(c=0);var m=-Math.random()*Number(b.randomX);isNaN(m)||(c=m);m=b.y;isNaN(m)&&(m=0);var p=-Math.random()*Number(b.randomY);isNaN(p)||(m=p);f.setAttribute("id",g);f.setAttribute("width",e);f.setAttribute("height",l);f.setAttribute("patternUnits","userSpaceOnUse");f.setAttribute("xlink:href",k);b.color&&(p=document.createElementNS(d.SVG_NS,"rect"),p.setAttributeNS(null,"height",e),p.setAttributeNS(null,"width",l),p.setAttributeNS(null,"fill",b.color),f.appendChild(p));this.D.image(k,0,0,e,l,f).translate(c,
m);k="#";d.baseHref&&!d.isIE&&(k=this.removeTarget(window.location.href)+k);h.setAttribute("fill","url("+k+g+")");a.patternNode=f;h.parentNode.appendChild(f)},remove:function(a){a.clipPath&&this.D.remove(a.clipPath);a.grad&&this.D.remove(a.grad);a.patternNode&&this.D.remove(a.patternNode);this.D.remove(a.node)}})})();(function(){var d=window.AmCharts;d.AmLegend=d.Class({construct:function(a){this.enabled=!0;this.cname="AmLegend";this.createEvents("rollOverMarker","rollOverItem","rollOutMarker","rollOutItem","showItem","hideItem","clickMarker","clickLabel");this.position="bottom";this.borderColor=this.color="#000000";this.borderAlpha=0;this.markerLabelGap=5;this.verticalGap=10;this.align="left";this.horizontalGap=0;this.spacing=10;this.markerDisabledColor="#AAB3B3";this.markerType="square";this.markerSize=16;this.markerBorderThickness=
this.markerBorderAlpha=1;this.marginBottom=this.marginTop=0;this.marginLeft=this.marginRight=20;this.autoMargins=!0;this.valueWidth=50;this.switchable=!0;this.switchType="x";this.switchColor="#FFFFFF";this.rollOverColor="#CC0000";this.reversedOrder=!1;this.labelText="[[title]]";this.valueText="[[value]]";this.accessibleLabel="[[title]]";this.useMarkerColorForLabels=!1;this.rollOverGraphAlpha=1;this.textClickEnabled=!1;this.equalWidths=!0;this.backgroundColor="#FFFFFF";this.backgroundAlpha=0;this.useGraphSettings=
!1;this.showEntries=!0;this.labelDx=0;d.applyTheme(this,a,this.cname)},setData:function(a){this.legendData=a;this.invalidateSize()},invalidateSize:function(){this.destroy();this.entries=[];this.valueLabels=[];var a=this.legendData;this.enabled&&(d.ifArray(a)||d.ifArray(this.data))&&this.drawLegend()},drawLegend:function(){var a=this.chart,b=this.position,c=this.width,e=a.divRealWidth,h=a.divRealHeight,f=this.div,g=this.legendData;this.data&&(g=this.combineLegend?this.legendData.concat(this.data):
this.data);isNaN(this.fontSize)&&(this.fontSize=a.fontSize);this.maxColumnsReal=this.maxColumns;if("right"==b||"left"==b)this.maxColumnsReal=1,this.autoMargins&&(this.marginLeft=this.marginRight=10);else if(this.autoMargins){this.marginRight=a.marginRight;this.marginLeft=a.marginLeft;var k=a.autoMarginOffset;"bottom"==b?(this.marginBottom=k,this.marginTop=0):(this.marginTop=k,this.marginBottom=0)}c=void 0!==c?d.toCoordinate(c,e):"right"!=b&&"left"!=b?a.realWidth:0<this.ieW?this.ieW:a.realWidth;"outside"==
b?(c=f.offsetWidth,h=f.offsetHeight,f.clientHeight&&(c=f.clientWidth,h=f.clientHeight)):(isNaN(c)||(f.style.width=c+"px"),f.className="amChartsLegend "+a.classNamePrefix+"-legend-div");this.divWidth=c;(b=this.container)?(b.container.innerHTML="",f.appendChild(b.container),b.width=c,b.height=h,b.setSize(c,h),b.addDefs(a)):b=new d.AmDraw(f,c,h,a);this.container=b;this.lx=0;this.ly=8;h=this.markerSize;h>this.fontSize&&(this.ly=h/2-1);0<h&&(this.lx+=h+this.markerLabelGap);this.titleWidth=0;if(h=this.title)h=
d.text(this.container,h,this.color,a.fontFamily,this.fontSize,"start",!0),d.setCN(a,h,"legend-title"),h.translate(this.marginLeft,this.marginTop+this.verticalGap+this.ly+1),a=h.getBBox(),this.titleWidth=a.width+15,this.titleHeight=a.height+6;this.index=this.maxLabelWidth=0;if(this.showEntries){for(a=0;a<g.length;a++)this.createEntry(g[a]);for(a=this.index=0;a<g.length;a++)this.createValue(g[a])}this.arrangeEntries();this.updateValues()},arrangeEntries:function(){var a=this.position,b=this.marginLeft+
this.titleWidth,c=this.marginRight,e=this.marginTop,h=this.marginBottom,f=this.horizontalGap,g=this.div,k=this.divWidth,l=this.maxColumnsReal,m=this.verticalGap,p=this.spacing,q=k-c-b,n=0,t=0,r=this.container;this.set&&this.set.remove();var w=r.set();this.set=w;var z=r.set();w.push(z);var x=this.entries,u,A;for(A=0;A<x.length;A++){u=x[A].getBBox();var y=u.width;y>n&&(n=y);u=u.height;u>t&&(t=u)}var y=t=0,B=f,D=0,C=0;for(A=0;A<x.length;A++){var I=x[A];this.reversedOrder&&(I=x[x.length-A-1]);u=I.getBBox();
var H;this.equalWidths?H=y*(n+p+this.markerLabelGap):(H=B,B=B+u.width+f+p);H+u.width>q&&0<A&&0!==y&&(t++,H=y=0,B=H+u.width+f+p,D=D+C+m,C=0);u.height>C&&(C=u.height);I.translate(H,D);y++;!isNaN(l)&&y>=l&&(y=0,t++,D=D+C+m,B=f,C=0);z.push(I)}u=z.getBBox();l=u.height+2*m-1;"left"==a||"right"==a?(p=u.width+2*f,k=p+b+c,g.style.width=k+"px",this.ieW=k):p=k-b-c-1;c=d.polygon(this.container,[0,p,p,0],[0,0,l,l],this.backgroundColor,this.backgroundAlpha,1,this.borderColor,this.borderAlpha);d.setCN(this.chart,
c,"legend-bg");w.push(c);w.translate(b,e);c.toBack();b=f;if("top"==a||"bottom"==a||"absolute"==a||"outside"==a)"center"==this.align?b=f+(p-u.width)/2:"right"==this.align&&(b=f+p-u.width);z.translate(b,m+1);this.titleHeight>l&&(l=this.titleHeight);e=l+e+h+1;0>e&&(e=0);"absolute"!=a&&"outside"!=a&&e>this.chart.divRealHeight&&(g.style.top="0px");g.style.height=Math.round(e)+"px";r.setSize(this.divWidth,e)},createEntry:function(a){if(!1!==a.visibleInLegend&&!a.hideFromLegend){var b=this,c=b.chart,e=b.useGraphSettings,
h=a.markerType;h&&(e=!1);a.legendEntryWidth=b.markerSize;h||(h=b.markerType);var f=a.color,g=a.alpha;a.legendKeyColor&&(f=a.legendKeyColor());a.legendKeyAlpha&&(g=a.legendKeyAlpha());var k;!0===a.hidden&&(k=f=b.markerDisabledColor);var l=a.pattern,m,p=a.customMarker;p||(p=b.customMarker);var q=b.container,n=b.markerSize,t=0,r=0,w=n/2;if(e){e=a.type;b.switchType=void 0;if("line"==e||"step"==e||"smoothedLine"==e||"ohlc"==e)m=q.set(),a.hidden||(f=a.lineColorR,k=a.bulletBorderColorR),t=d.line(q,[0,2*
n],[n/2,n/2],f,a.lineAlpha,a.lineThickness,a.dashLength),d.setCN(c,t,"graph-stroke"),m.push(t),a.bullet&&(a.hidden||(f=a.bulletColorR),t=d.bullet(q,a.bullet,a.bulletSize,f,a.bulletAlpha,a.bulletBorderThickness,k,a.bulletBorderAlpha))&&(d.setCN(c,t,"graph-bullet"),t.translate(n+1,n/2),m.push(t)),w=0,t=n,r=n/3;else{a.getGradRotation&&(m=a.getGradRotation(),0===m&&(m=180));t=a.fillColorsR;!0===a.hidden&&(t=f);if(m=b.createMarker("rectangle",t,a.fillAlphas,a.lineThickness,f,a.lineAlpha,m,l,a.dashLength))w=
n,m.translate(w,n/2);t=n}d.setCN(c,m,"graph-"+e);d.setCN(c,m,"graph-"+a.id)}else if(p)m=q.image(p,0,0,n,n);else{var z;isNaN(b.gradientRotation)||(z=180+b.gradientRotation);(m=b.createMarker(h,f,g,void 0,void 0,void 0,z,l))&&m.translate(n/2,n/2)}d.setCN(c,m,"legend-marker");b.addListeners(m,a);q=q.set([m]);b.switchable&&a.switchable&&q.setAttr("cursor","pointer");void 0!==a.id&&d.setCN(c,q,"legend-item-"+a.id);d.setCN(c,q,a.className,!0);k=b.switchType;var x;k&&"none"!=k&&0<n&&("x"==k?(x=b.createX(),
x.translate(n/2,n/2)):x=b.createV(),x.dItem=a,!0!==a.hidden?"x"==k?x.hide():x.show():"x"!=k&&x.hide(),b.switchable||x.hide(),b.addListeners(x,a),a.legendSwitch=x,q.push(x),d.setCN(c,x,"legend-switch"));k=b.color;a.showBalloon&&b.textClickEnabled&&void 0!==b.selectedColor&&(k=b.selectedColor);b.useMarkerColorForLabels&&!l&&(k=f);!0===a.hidden&&(k=b.markerDisabledColor);f=d.massReplace(b.labelText,{"[[title]]":a.title});void 0!==b.tabIndex&&(q.setAttr("tabindex",b.tabIndex),q.setAttr("role","menuitem"),
q.keyup(function(c){13==c.keyCode&&b.clickMarker(a,c)}));c.accessible&&b.accessibleLabel&&(l=d.massReplace(b.accessibleLabel,{"[[title]]":a.title}),c.makeAccessible(q,l));l=b.fontSize;m&&(n<=l&&(n=n/2+b.ly-l/2+(l+2-n)/2-r,m.translate(w,n),x&&x.translate(x.x,n)),a.legendEntryWidth=m.getBBox().width);var u;f&&(f=d.fixBrakes(f),a.legendTextReal=f,u=b.labelWidth,u=isNaN(u)?d.text(b.container,f,k,c.fontFamily,l,"start"):d.wrappedText(b.container,f,k,c.fontFamily,l,"start",!1,u,0),d.setCN(c,u,"legend-label"),
u.translate(b.lx+t,b.ly),q.push(u),b.labelDx=t,c=u.getBBox().width,b.maxLabelWidth<c&&(b.maxLabelWidth=c));b.entries[b.index]=q;a.legendEntry=b.entries[b.index];a.legendMarker=m;a.legendLabel=u;b.index++}},addListeners:function(a,b){var c=this;a&&a.mouseover(function(a){c.rollOverMarker(b,a)}).mouseout(function(a){c.rollOutMarker(b,a)}).click(function(a){c.clickMarker(b,a)})},rollOverMarker:function(a,b){this.switchable&&this.dispatch("rollOverMarker",a,b);this.dispatch("rollOverItem",a,b)},rollOutMarker:function(a,
b){this.switchable&&this.dispatch("rollOutMarker",a,b);this.dispatch("rollOutItem",a,b)},clickMarker:function(a,b){this.switchable&&(!0===a.hidden?this.dispatch("showItem",a,b):this.dispatch("hideItem",a,b));this.dispatch("clickMarker",a,b)},rollOverLabel:function(a,b){a.hidden||this.textClickEnabled&&a.legendLabel&&a.legendLabel.attr({fill:this.rollOverColor});this.dispatch("rollOverItem",a,b)},rollOutLabel:function(a,b){if(!a.hidden&&this.textClickEnabled&&a.legendLabel){var c=this.color;void 0!==
this.selectedColor&&a.showBalloon&&(c=this.selectedColor);this.useMarkerColorForLabels&&(c=a.lineColor,void 0===c&&(c=a.color));a.legendLabel.attr({fill:c})}this.dispatch("rollOutItem",a,b)},clickLabel:function(a,b){this.textClickEnabled?a.hidden||this.dispatch("clickLabel",a,b):this.switchable&&(!0===a.hidden?this.dispatch("showItem",a,b):this.dispatch("hideItem",a,b))},dispatch:function(a,b,c){a={type:a,dataItem:b,target:this,event:c,chart:this.chart};this.chart&&this.chart.handleLegendEvent(a);
this.fire(a)},createValue:function(a){var b=this,c=b.fontSize,e=b.chart;if(!1!==a.visibleInLegend&&!a.hideFromLegend){var h=b.maxLabelWidth;b.forceWidth&&(h=b.labelWidth);b.equalWidths||(b.valueAlign="left");"left"==b.valueAlign&&a.legendLabel&&(h=a.legendLabel.getBBox().width);var f=h;if(b.valueText&&0<b.valueWidth){var g=b.color;b.useMarkerColorForValues&&(g=a.color,a.legendKeyColor&&(g=a.legendKeyColor()));!0===a.hidden&&(g=b.markerDisabledColor);var k=b.valueText,h=h+b.lx+b.labelDx+b.markerLabelGap+
b.valueWidth,l="end";"left"==b.valueAlign&&(h-=b.valueWidth,l="start");g=d.text(b.container,k,g,b.chart.fontFamily,c,l);d.setCN(e,g,"legend-value");g.translate(h,b.ly);b.entries[b.index].push(g);f+=b.valueWidth+2*b.markerLabelGap;g.dItem=a;b.valueLabels.push(g)}b.index++;e=b.markerSize;e<c+7&&(e=c+7,d.VML&&(e+=3));c=b.container.rect(a.legendEntryWidth,0,f,e,0,0).attr({stroke:"none",fill:"#fff","fill-opacity":.005});c.dItem=a;b.entries[b.index-1].push(c);c.mouseover(function(c){b.rollOverLabel(a,c)}).mouseout(function(c){b.rollOutLabel(a,
c)}).click(function(c){b.clickLabel(a,c)})}},createV:function(){var a=this.markerSize;return d.polygon(this.container,[a/5,a/2,a-a/5,a/2],[a/3,a-a/5,a/5,a/1.7],this.switchColor)},createX:function(){var a=(this.markerSize-4)/2,b={stroke:this.switchColor,"stroke-width":3},c=this.container,e=d.line(c,[-a,a],[-a,a]).attr(b),a=d.line(c,[-a,a],[a,-a]).attr(b);return this.container.set([e,a])},createMarker:function(a,b,c,e,h,f,g,k,l){var m=this.markerSize,p=this.container;h||(h=this.markerBorderColor);h||
(h=b);isNaN(e)&&(e=this.markerBorderThickness);isNaN(f)&&(f=this.markerBorderAlpha);return d.bullet(p,a,m,b,c,e,h,f,m,g,k,this.chart.path,l)},validateNow:function(){this.invalidateSize()},updateValues:function(){var a=this.valueLabels,b=this.chart,c,e=this.data;if(a)for(c=0;c<a.length;c++){var h=a[c],f=h.dItem;f.periodDataItem=void 0;f.periodPercentDataItem=void 0;var g=" ";if(e)f.value?h.text(f.value):h.text("");else{var k=null;if(void 0!==f.type){var k=f.currentDataItem,l=this.periodValueText;f.legendPeriodValueText&&
(l=f.legendPeriodValueText);f.legendPeriodValueTextR&&(l=f.legendPeriodValueTextR);k?(g=this.valueText,f.legendValueText&&(g=f.legendValueText),f.legendValueTextR&&(g=f.legendValueTextR),g=b.formatString(g,k)):l&&b.formatPeriodString&&(l=d.massReplace(l,{"[[title]]":f.title}),g=b.formatPeriodString(l,f))}else g=b.formatString(this.valueText,f);l=f;k&&(l=k);var m=this.valueFunction;m&&(g=m(l,g,b.periodDataItem));var p;this.useMarkerColorForLabels&&!k&&f.lastDataItem&&(k=f.lastDataItem);k?p=b.getBalloonColor(f,
k):f.legendKeyColor&&(p=f.legendKeyColor());f.legendColorFunction&&(p=f.legendColorFunction(l,g,f.periodDataItem,f.periodPercentDataItem));h.text(g);if(!f.pattern&&(this.useMarkerColorForValues&&h.setAttr("fill",p),this.useMarkerColorForLabels)){if(h=f.legendMarker)h.setAttr("fill",p),h.setAttr("stroke",p);(h=f.legendLabel)&&(f.hidden?h.setAttr("fill",this.markerDisabledColor):h.setAttr("fill",p))}}}},renderFix:function(){if(!d.VML&&this.enabled){var a=this.container;a&&a.renderFix()}},destroy:function(){this.div.innerHTML=
"";d.remove(this.set)}})})();(function(){var d=window.AmCharts;d.formatMilliseconds=function(a,b){if(-1!=a.indexOf("fff")){var c=b.getMilliseconds(),d=String(c);10>c&&(d="00"+c);10<=c&&100>c&&(d="0"+c);a=a.replace(/fff/g,d)}return a};d.extractPeriod=function(a){var b=d.stripNumbers(a),c=1;b!=a&&(c=Number(a.slice(0,a.indexOf(b))));return{period:b,count:c}};d.getDate=function(a,b,c){return a instanceof Date?d.newDate(a,c):b&&isNaN(a)?d.stringToDate(a,b):new Date(a)};d.daysInMonth=function(a){return(new Date(a.getYear(),a.getMonth()+
1,0)).getDate()};d.newDate=function(a,b){return b&&-1==b.indexOf("fff")?new Date(a):new Date(a.getFullYear(),a.getMonth(),a.getDate(),a.getHours(),a.getMinutes(),a.getSeconds(),a.getMilliseconds())};d.resetDateToMin=function(a,b,c,e){void 0===e&&(e=1);var h,f,g,k,l,m,p;d.useUTC?(h=a.getUTCFullYear(),f=a.getUTCMonth(),g=a.getUTCDate(),k=a.getUTCHours(),l=a.getUTCMinutes(),m=a.getUTCSeconds(),p=a.getUTCMilliseconds(),a=a.getUTCDay()):(h=a.getFullYear(),f=a.getMonth(),g=a.getDate(),k=a.getHours(),l=
a.getMinutes(),m=a.getSeconds(),p=a.getMilliseconds(),a=a.getDay());switch(b){case "YYYY":h=Math.floor(h/c)*c;f=0;g=1;p=m=l=k=0;break;case "MM":f=Math.floor(f/c)*c;g=1;p=m=l=k=0;break;case "WW":g=a>=e?g-a+e:g-(7+a)+e;p=m=l=k=0;break;case "DD":p=m=l=k=0;break;case "hh":k=Math.floor(k/c)*c;p=m=l=0;break;case "mm":l=Math.floor(l/c)*c;p=m=0;break;case "ss":m=Math.floor(m/c)*c;p=0;break;case "fff":p=Math.floor(p/c)*c}d.useUTC?(a=new Date,a.setUTCFullYear(h,f,g),a.setUTCHours(k,l,m,p)):a=new Date(h,f,g,
k,l,m,p);return a};d.getPeriodDuration=function(a,b){void 0===b&&(b=1);var c;switch(a){case "YYYY":c=316224E5;break;case "MM":c=26784E5;break;case "WW":c=6048E5;break;case "DD":c=864E5;break;case "hh":c=36E5;break;case "mm":c=6E4;break;case "ss":c=1E3;break;case "fff":c=1}return c*b};d.intervals={s:{nextInterval:"ss",contains:1E3},ss:{nextInterval:"mm",contains:60,count:0},mm:{nextInterval:"hh",contains:60,count:1},hh:{nextInterval:"DD",contains:24,count:2},DD:{nextInterval:"",contains:Infinity,count:3}};
d.getMaxInterval=function(a,b){var c=d.intervals;return a>=c[b].contains?(a=Math.round(a/c[b].contains),b=c[b].nextInterval,d.getMaxInterval(a,b)):"ss"==b?c[b].nextInterval:b};d.dayNames="Sunday Monday Tuesday Wednesday Thursday Friday Saturday".split(" ");d.shortDayNames="Sun Mon Tue Wed Thu Fri Sat".split(" ");d.monthNames="January February March April May June July August September October November December".split(" ");d.shortMonthNames="Jan Feb Mar Apr May Jun Jul Aug Sep Oct Nov Dec".split(" ");
d.getWeekNumber=function(a){a=new Date(a);a.setHours(0,0,0);a.setDate(a.getDate()+4-(a.getDay()||7));var b=new Date(a.getFullYear(),0,1);return Math.ceil(((a-b)/864E5+1)/7)};d.stringToDate=function(a,b){var c={},e=[{pattern:"YYYY",period:"year"},{pattern:"YY",period:"year"},{pattern:"MM",period:"month"},{pattern:"M",period:"month"},{pattern:"DD",period:"date"},{pattern:"D",period:"date"},{pattern:"JJ",period:"hours"},{pattern:"J",period:"hours"},{pattern:"HH",period:"hours"},{pattern:"H",period:"hours"},
{pattern:"KK",period:"hours"},{pattern:"K",period:"hours"},{pattern:"LL",period:"hours"},{pattern:"L",period:"hours"},{pattern:"NN",period:"minutes"},{pattern:"N",period:"minutes"},{pattern:"SS",period:"seconds"},{pattern:"S",period:"seconds"},{pattern:"QQQ",period:"milliseconds"},{pattern:"QQ",period:"milliseconds"},{pattern:"Q",period:"milliseconds"}],h=!0,f=b.indexOf("AA");-1!=f&&(a.substr(f,2),"pm"==a.toLowerCase&&(h=!1));var f=b,g,k,l;for(l=0;l<e.length;l++)k=e[l].period,c[k]=0,"date"==k&&(c[k]=
1);for(l=0;l<e.length;l++)if(g=e[l].pattern,k=e[l].period,-1!=b.indexOf(g)){var m=d.getFromDateString(g,a,f);b=b.replace(g,"");if("KK"==g||"K"==g||"LL"==g||"L"==g)h||(m+=12);c[k]=m}d.useUTC?(e=new Date,e.setUTCFullYear(c.year,c.month,c.date),e.setUTCHours(c.hours,c.minutes,c.seconds,c.milliseconds)):e=new Date(c.year,c.month,c.date,c.hours,c.minutes,c.seconds,c.milliseconds);return e};d.getFromDateString=function(a,b,c){if(void 0!==b)return c=c.indexOf(a),b=String(b),b=b.substr(c,a.length),"0"==b.charAt(0)&&
(b=b.substr(1,b.length-1)),b=Number(b),isNaN(b)&&(b=0),-1!=a.indexOf("M")&&b--,b};d.formatDate=function(a,b,c){c||(c=d);var e,h,f,g,k,l,m,p,q=d.getWeekNumber(a);d.useUTC?(e=a.getUTCFullYear(),h=a.getUTCMonth(),f=a.getUTCDate(),g=a.getUTCDay(),k=a.getUTCHours(),l=a.getUTCMinutes(),m=a.getUTCSeconds(),p=a.getUTCMilliseconds()):(e=a.getFullYear(),h=a.getMonth(),f=a.getDate(),g=a.getDay(),k=a.getHours(),l=a.getMinutes(),m=a.getSeconds(),p=a.getMilliseconds());var n=String(e).substr(2,2),t="0"+g;b=b.replace(/W/g,
q);q=k;24==q&&(q=0);var r=q;10>r&&(r="0"+r);b=b.replace(/JJ/g,r);b=b.replace(/J/g,q);r=k;0===r&&(r=24,-1!=b.indexOf("H")&&(f--,0===f&&(e=new Date(a),e.setDate(e.getDate()-1),h=e.getMonth(),f=e.getDate(),e=e.getFullYear())));a=h+1;9>h&&(a="0"+a);q=f;10>f&&(q="0"+f);var w=r;10>w&&(w="0"+w);b=b.replace(/HH/g,w);b=b.replace(/H/g,r);r=k;11<r&&(r-=12);w=r;10>w&&(w="0"+w);b=b.replace(/KK/g,w);b=b.replace(/K/g,r);r=k;0===r&&(r=12);12<r&&(r-=12);w=r;10>w&&(w="0"+w);b=b.replace(/LL/g,w);b=b.replace(/L/g,r);
r=l;10>r&&(r="0"+r);b=b.replace(/NN/g,r);b=b.replace(/N/g,l);l=m;10>l&&(l="0"+l);b=b.replace(/SS/g,l);b=b.replace(/S/g,m);m=p;10>m?m="00"+m:100>m&&(m="0"+m);l=p;10>l&&(l="00"+l);b=b.replace(/A/g,"@A@");b=b.replace(/QQQ/g,m);b=b.replace(/QQ/g,l);b=b.replace(/Q/g,p);b=b.replace(/YYYY/g,"@IIII@");b=b.replace(/YY/g,"@II@");b=b.replace(/MMMM/g,"@XXXX@");b=b.replace(/MMM/g,"@XXX@");b=b.replace(/MM/g,"@XX@");b=b.replace(/M/g,"@X@");b=b.replace(/DD/g,"@RR@");b=b.replace(/D/g,"@R@");b=b.replace(/EEEE/g,"@PPPP@");
b=b.replace(/EEE/g,"@PPP@");b=b.replace(/EE/g,"@PP@");b=b.replace(/E/g,"@P@");b=b.replace(/@IIII@/g,e);b=b.replace(/@II@/g,n);b=b.replace(/@XXXX@/g,c.monthNames[h]);b=b.replace(/@XXX@/g,c.shortMonthNames[h]);b=b.replace(/@XX@/g,a);b=b.replace(/@X@/g,h+1);b=b.replace(/@RR@/g,q);b=b.replace(/@R@/g,f);b=b.replace(/@PPPP@/g,c.dayNames[g]);b=b.replace(/@PPP@/g,c.shortDayNames[g]);b=b.replace(/@PP@/g,t);b=b.replace(/@P@/g,g);return b=12>k?b.replace(/@A@/g,c.amString):b.replace(/@A@/g,c.pmString)};d.changeDate=
function(a,b,c,e,h){if(d.useUTC)return d.changeUTCDate(a,b,c,e,h);var f=-1;void 0===e&&(e=!0);void 0===h&&(h=!1);!0===e&&(f=1);switch(b){case "YYYY":a.setFullYear(a.getFullYear()+c*f);e||h||a.setDate(a.getDate()+1);break;case "MM":b=a.getMonth();a.setMonth(a.getMonth()+c*f);a.getMonth()>b+c*f&&a.setDate(a.getDate()-1);e||h||a.setDate(a.getDate()+1);break;case "DD":a.setDate(a.getDate()+c*f);break;case "WW":a.setDate(a.getDate()+c*f*7);break;case "hh":a.setHours(a.getHours()+c*f);break;case "mm":a.setMinutes(a.getMinutes()+
c*f);break;case "ss":a.setSeconds(a.getSeconds()+c*f);break;case "fff":a.setMilliseconds(a.getMilliseconds()+c*f)}return a};d.changeUTCDate=function(a,b,c,d,h){var f=-1;void 0===d&&(d=!0);void 0===h&&(h=!1);!0===d&&(f=1);switch(b){case "YYYY":a.setUTCFullYear(a.getUTCFullYear()+c*f);d||h||a.setUTCDate(a.getUTCDate()+1);break;case "MM":b=a.getUTCMonth();a.setUTCMonth(a.getUTCMonth()+c*f);a.getUTCMonth()>b+c*f&&a.setUTCDate(a.getUTCDate()-1);d||h||a.setUTCDate(a.getUTCDate()+1);break;case "DD":a.setUTCDate(a.getUTCDate()+
c*f);break;case "WW":a.setUTCDate(a.getUTCDate()+c*f*7);break;case "hh":a.setUTCHours(a.getUTCHours()+c*f);break;case "mm":a.setUTCMinutes(a.getUTCMinutes()+c*f);break;case "ss":a.setUTCSeconds(a.getUTCSeconds()+c*f);break;case "fff":a.setUTCMilliseconds(a.getUTCMilliseconds()+c*f)}return a}})();

(function(){var e=window.AmCharts;e.AmSlicedChart=e.Class({inherits:e.AmChart,construct:function(a){this.createEvents("rollOverSlice","rollOutSlice","clickSlice","pullOutSlice","pullInSlice","rightClickSlice");e.AmSlicedChart.base.construct.call(this,a);this.colors="#FF0F00 #FF6600 #FF9E01 #FCD202 #F8FF01 #B0DE09 #04D215 #0D8ECF #0D52D1 #2A0CD0 #8A0CCF #CD0D74 #754DEB #DDDDDD #999999 #333333 #000000 #57032A #CA9726 #990000 #4B0C25".split(" ");this.alpha=1;this.groupPercent=0;this.groupedTitle="Other";
this.groupedPulled=!1;this.groupedAlpha=1;this.marginLeft=0;this.marginBottom=this.marginTop=10;this.marginRight=0;this.hoverAlpha=1;this.outlineColor="#FFFFFF";this.outlineAlpha=0;this.outlineThickness=1;this.startAlpha=0;this.startDuration=1;this.startEffect="bounce";this.sequencedAnimation=!0;this.pullOutDuration=1;this.pullOutEffect="bounce";this.pullOnHover=this.pullOutOnlyOne=!1;this.labelsEnabled=!0;this.labelTickColor="#000000";this.labelTickAlpha=.2;this.hideLabelsPercent=0;this.urlTarget=
"_self";this.autoMarginOffset=10;this.gradientRatio=[];this.maxLabelWidth=200;this.accessibleLabel="[[title]]: [[percents]]% [[value]] [[description]]";e.applyTheme(this,a,"AmSlicedChart")},initChart:function(){e.AmSlicedChart.base.initChart.call(this);this.dataChanged&&(this.parseData(),this.dispatchDataUpdated=!0,this.dataChanged=!1,this.setLegendData(this.chartData));this.drawChart()},handleLegendEvent:function(a){var b=a.type,c=a.dataItem,d=this.legend;if(c.wedge&&c){var f=c.hidden;a=a.event;
switch(b){case "clickMarker":f||d.switchable||this.clickSlice(c,a);break;case "clickLabel":f||this.clickSlice(c,a,!1);break;case "rollOverItem":f||this.rollOverSlice(c,!1,a);break;case "rollOutItem":f||this.rollOutSlice(c,a);break;case "hideItem":this.hideSlice(c,a);break;case "showItem":this.showSlice(c,a)}}},invalidateVisibility:function(){this.recalculatePercents();this.initChart();var a=this.legend;a&&a.invalidateSize()},addEventListeners:function(a,b){var c=this;a.mouseover(function(a){c.rollOverSlice(b,
!0,a)}).mouseout(function(a){c.rollOutSlice(b,a)}).touchend(function(a){c.rollOverSlice(b,a)}).mouseup(function(a){c.clickSlice(b,a)}).contextmenu(function(a){c.handleRightClick(b,a)})},formatString:function(a,b,c){a=e.formatValue(a,b,["value"],this.nf,"",this.usePrefixes,this.prefixesOfSmallNumbers,this.prefixesOfBigNumbers);var d=this.pf.precision;isNaN(this.tempPrec)||(this.pf.precision=this.tempPrec);a=e.formatValue(a,b,["percents"],this.pf);a=e.massReplace(a,{"[[title]]":b.title,"[[description]]":b.description});
this.pf.precision=d;-1!=a.indexOf("[[")&&(a=e.formatDataContextValue(a,b.dataContext));a=c?e.fixNewLines(a):e.fixBrakes(a);return a=e.cleanFromEmpty(a)},startSlices:function(){var a;for(a=0;a<this.chartData.length;a++)0<this.startDuration&&this.sequencedAnimation?this.setStartTO(a):this.startSlice(this.chartData[a])},setStartTO:function(a){var b=this;a=setTimeout(function(){b.startSequenced.call(b)},b.startDuration/b.chartData.length*500*a);b.timeOuts.push(a)},pullSlices:function(a){var b=this.chartData,
c;for(c=0;c<b.length;c++){var d=b[c];d.pulled&&this.pullSlice(d,1,a)}},startSequenced:function(){var a=this.chartData,b;for(b=0;b<a.length;b++)if(!a[b].started){this.startSlice(this.chartData[b]);break}},startSlice:function(a){a.started=!0;var b=a.wedge,c=this.startDuration,d=a.labelSet;b&&0<c&&(0<a.alpha&&b.show(),b.translate(a.startX,a.startY),this.animatable.push(b),b.animate({opacity:1,translate:"0,0"},c,this.startEffect));d&&0<c&&(0<a.alpha&&d.show(),d.translate(a.startX,a.startY),d.animate({opacity:1,
translate:"0,0"},c,this.startEffect))},showLabels:function(){var a=this.chartData,b;for(b=0;b<a.length;b++){var c=a[b];if(0<c.alpha){var d=c.label;d&&d.show();(c=c.tick)&&c.show()}}},showSlice:function(a){isNaN(a)?a.hidden=!1:this.chartData[a].hidden=!1;this.invalidateVisibility()},hideSlice:function(a){isNaN(a)?a.hidden=!0:this.chartData[a].hidden=!0;this.hideBalloon();this.invalidateVisibility()},rollOverSlice:function(a,b,c){isNaN(a)||(a=this.chartData[a]);clearTimeout(this.hoverInt);if(!a.hidden){this.pullOnHover&&
this.pullSlice(a,1);1>this.hoverAlpha&&a.wedge&&a.wedge.attr({opacity:this.hoverAlpha});var d=a.balloonX,f=a.balloonY;a.pulled&&(d+=a.pullX,f+=a.pullY);var h=this.formatString(this.balloonText,a,!0),k=this.balloonFunction;k&&(h=k(a,h));k=e.adjustLuminosity(a.color,-.15);h?this.showBalloon(h,k,b,d,f):this.hideBalloon();0===a.value&&this.hideBalloon();this.fire({type:"rollOverSlice",dataItem:a,chart:this,event:c})}},rollOutSlice:function(a,b){isNaN(a)||(a=this.chartData[a]);a.wedge&&a.wedge.attr({opacity:1});
this.hideBalloon();this.fire({type:"rollOutSlice",dataItem:a,chart:this,event:b})},clickSlice:function(a,b,c){this.checkTouchDuration(b)&&(isNaN(a)||(a=this.chartData[a]),a.pulled?this.pullSlice(a,0):this.pullSlice(a,1),e.getURL(a.url,this.urlTarget),c||this.fire({type:"clickSlice",dataItem:a,chart:this,event:b}))},handleRightClick:function(a,b){isNaN(a)||(a=this.chartData[a]);this.fire({type:"rightClickSlice",dataItem:a,chart:this,event:b})},drawTicks:function(){var a=this.chartData,b;for(b=0;b<
a.length;b++){var c=a[b];if(c.label&&!c.skipTick){var d=c.ty,d=e.line(this.container,[c.tx0,c.tx,c.tx2],[c.ty0,d,d],this.labelTickColor,this.labelTickAlpha);e.setCN(this,d,this.type+"-tick");e.setCN(this,d,c.className,!0);c.tick=d;c.wedge.push(d);"AmFunnelChart"==this.cname&&d.toBack()}}},initialStart:function(){var a=this,b=a.startDuration,c=setTimeout(function(){a.showLabels.call(a)},1E3*b);a.timeOuts.push(c);a.chartCreated?a.pullSlices(!0):(a.startSlices(),0<b?(b=setTimeout(function(){a.pullSlices.call(a)},
1200*b),a.timeOuts.push(b)):a.pullSlices(!0))},pullSlice:function(a,b,c){var d=this.pullOutDuration;!0===c&&(d=0);if(c=a.wedge)0<d?(c.animate({translate:b*a.pullX+","+b*a.pullY},d,this.pullOutEffect),a.labelSet&&a.labelSet.animate({translate:b*a.pullX+","+b*a.pullY},d,this.pullOutEffect)):(a.labelSet&&a.labelSet.translate(b*a.pullX,b*a.pullY),c.translate(b*a.pullX,b*a.pullY));1==b?(a.pulled=!0,this.pullOutOnlyOne&&this.pullInAll(a.index),a={type:"pullOutSlice",dataItem:a,chart:this}):(a.pulled=!1,
a={type:"pullInSlice",dataItem:a,chart:this});this.fire(a)},pullInAll:function(a){var b=this.chartData,c;for(c=0;c<this.chartData.length;c++)c!=a&&b[c].pulled&&this.pullSlice(b[c],0)},pullOutAll:function(){var a=this.chartData,b;for(b=0;b<a.length;b++)a[b].pulled||this.pullSlice(a[b],1)},parseData:function(){var a=[];this.chartData=a;var b=this.dataProvider;isNaN(this.pieAlpha)||(this.alpha=this.pieAlpha);if(void 0!==b){var c=b.length,d=0,f,h,k;for(f=0;f<c;f++){h={};var n=b[f];h.dataContext=n;null!==
n[this.valueField]&&(h.value=Number(n[this.valueField]));(k=n[this.titleField])||(k="");h.title=k;h.pulled=e.toBoolean(n[this.pulledField],!1);(k=n[this.descriptionField])||(k="");h.description=k;h.labelRadius=Number(n[this.labelRadiusField]);h.switchable=!0;h.className=n[this.classNameField];h.url=n[this.urlField];k=n[this.patternField];!k&&this.patterns&&(k=this.patterns[f]);h.pattern=k;h.visibleInLegend=e.toBoolean(n[this.visibleInLegendField],!0);k=n[this.alphaField];h.alpha=void 0!==k?Number(k):
this.alpha;k=n[this.colorField];void 0!==k&&(h.color=k);h.labelColor=e.toColor(n[this.labelColorField]);d+=h.value;h.hidden=!1;a[f]=h}for(f=b=0;f<c;f++)h=a[f],h.percents=h.value/d*100,h.percents<this.groupPercent&&b++;1<b&&(this.groupValue=0,this.removeSmallSlices(),a.push({title:this.groupedTitle,value:this.groupValue,percents:this.groupValue/d*100,pulled:this.groupedPulled,color:this.groupedColor,url:this.groupedUrl,description:this.groupedDescription,alpha:this.groupedAlpha,pattern:this.groupedPattern,
className:this.groupedClassName,dataContext:{}}));c=this.baseColor;c||(c=this.pieBaseColor);d=this.brightnessStep;d||(d=this.pieBrightnessStep);for(f=0;f<a.length;f++)c?k=e.adjustLuminosity(c,f*d/100):(k=this.colors[f],void 0===k&&(k=e.randomColor())),void 0===a[f].color&&(a[f].color=k);this.recalculatePercents()}},recalculatePercents:function(){var a=this.chartData,b=0,c,d;for(c=0;c<a.length;c++)d=a[c],!d.hidden&&0<d.value&&(b+=d.value);for(c=0;c<a.length;c++)d=this.chartData[c],d.percents=!d.hidden&&
0<d.value?100*d.value/b:0},removeSmallSlices:function(){var a=this.chartData,b;for(b=a.length-1;0<=b;b--)a[b].percents<this.groupPercent&&(this.groupValue+=a[b].value,a.splice(b,1))},animateAgain:function(){var a=this;a.startSlices();for(var b=0;b<a.chartData.length;b++){var c=a.chartData[b];c.started=!1;var d=c.wedge;d&&(d.setAttr("opacity",a.startAlpha),d.translate(c.startX,c.startY));if(d=c.labelSet)d.setAttr("opacity",a.startAlpha),d.translate(c.startX,c.startY)}b=a.startDuration;0<b?(b=setTimeout(function(){a.pullSlices.call(a)},
1200*b),a.timeOuts.push(b)):a.pullSlices()},measureMaxLabel:function(){var a=this.chartData,b=0,c;for(c=0;c<a.length;c++){var d=a[c],f=this.formatString(this.labelText,d),h=this.labelFunction;h&&(f=h(d,f));d=e.text(this.container,f,this.color,this.fontFamily,this.fontSize);f=d.getBBox().width;f>b&&(b=f);d.remove()}return b}})})();(function(){var e=window.AmCharts;e.AmFunnelChart=e.Class({inherits:e.AmSlicedChart,construct:function(a){this.type="funnel";e.AmFunnelChart.base.construct.call(this,a);this.cname="AmFunnelChart";this.startX=this.startY=0;this.baseWidth="100%";this.neckHeight=this.neckWidth=0;this.rotate=!1;this.valueRepresents="height";this.pullDistance=30;this.labelPosition="center";this.labelText="[[title]]: [[value]]";this.balloonText="[[title]]: [[value]]\n[[description]]";e.applyTheme(this,a,this.cname)},drawChart:function(){e.AmFunnelChart.base.drawChart.call(this);
var a=this.chartData;if(e.ifArray(a))if(0<this.realWidth&&0<this.realHeight){var b=Math.round(this.depth3D*Math.cos(this.angle*Math.PI/180)),c=Math.round(-this.depth3D*Math.sin(this.angle*Math.PI/180)),d=this.container,f=this.startDuration,h=this.rotate,k=this.updateWidth();this.realWidth=k;var n=this.updateHeight();this.realHeight=n;var l=e.toCoordinate,t=l(this.marginLeft,k),u=l(this.marginRight,k),g=l(this.marginTop,n)+this.getTitleHeight(),l=l(this.marginBottom,n);0<b&&0>c&&(this.neckHeight=this.neckWidth=
0,h?l-=c/2:g-=c/2);var u=k-t-u,E=e.toCoordinate(this.baseWidth,u),I=e.toCoordinate(this.neckWidth,u),D=n-l-g,F=e.toCoordinate(this.neckHeight,D),y=g+D-F;h&&(g=n-l,y=g-D+F);this.firstSliceY=g;e.VML&&(this.startAlpha=1);for(var z=u/2+t,G=(D-F)/((E-I)/2),C=1,v=E/2,E=(D-F)*(E+I)/2+I*F,H=g,M=0,F=0;F<a.length;F++){var m=a[F],w;if(!0!==m.hidden&&(this.showZeroSlices||0!==m.percents)){var A=[],q=[],p;if("height"==this.valueRepresents)p=D*m.percents/100;else{var B=-E*m.percents/100/2,K=v;p=-1/(2*G);var r=
Math.pow(K,2)-4*p*B;0>r&&(r=0);p=(Math.sqrt(r)-K)/(2*p);if(!h&&g>=y||h&&g<=y)p=2*-B/I;else if(!h&&g+p>y||h&&g-p<y)w=h?Math.round(p+(g-p-y)):Math.round(p-(g+p-y)),r=w/G,B=2*(-B-(K-r/2)*w)/I,Infinity!=B&&(p=w+B)}B=v-p/G;K=!1;!h&&g+p>y||h&&g-p<y?(B=I/2,A.push(z-v,z+v,z+B,z+B,z-B,z-B),h?(w=p+(g-p-y),g<y&&(w=0),q.push(g,g,g-w,g-p,g-p,g-w,g)):(w=p-(g+p-y),g>y&&(w=0),q.push(g,g,g+w,g+p,g+p,g+w,g)),K=!0):(A.push(z-v,z+v,z+B,z-B),h?q.push(g,g,g-p,g-p):q.push(g,g,g+p,g+p));w=d.set();0<b&&0>c?(q=B/v,A=-1,h||
(A=1),isNaN(C)&&(C=0),A=(new e.Cuboid(d,2*v,A*p,b,c*C,m.color,m.alpha,this.outlineThickness,this.outlineColor,this.outlineAlpha,90,0,!1,0,m.pattern,q)).set,A.translate(z-v,g-c/2*C),C*=q):A=e.polygon(d,A,q,m.color,m.alpha,this.outlineThickness,this.outlineColor,this.outlineAlpha);e.setCN(this,w,"funnel-item");e.setCN(this,A,"funnel-slice");e.setCN(this,w,m.className,!0);w.push(A);this.graphsSet.push(w);h||w.toBack();m.wedge=w;m.index=F;if(q=this.gradientRatio){var r=[],x;for(x=0;x<q.length;x++)r.push(e.adjustLuminosity(m.color,
q[x]));0<r.length&&A.gradient("linearGradient",r);m.pattern&&A.pattern(m.pattern,NaN,this.path)}0<f&&(this.chartCreated||w.setAttr("opacity",this.startAlpha));this.addEventListeners(w,m);m.ty0=h?g-p/2:g+p/2;this.labelsEnabled&&this.labelText&&m.percents>=this.hideLabelsPercent&&(q=this.formatString(this.labelText,m),(A=this.labelFunction)&&(q=A(m,q)),r=m.labelColor,r||(r=this.color),A=this.labelPosition,x="left","center"==A&&(x="middle"),"left"==A&&(x="right"),""!==q&&(q=e.wrappedText(d,q,r,this.fontFamily,
this.fontSize,x,!1,this.maxLabelWidth),e.setCN(this,q,"funnel-label"),e.setCN(this,q,m.className,!0),q.node.style.pointerEvents="none",w.push(q),r=z,h?(x=g-p/2,m.ty0=x):(x=g+p/2,m.ty0=x,x<H+M+5&&(x=H+M+5),x>n-l&&(x=n-l)),"right"==A&&(r=u+10+t,m.tx0=z+(v-p/2/G),K&&(m.tx0=z+B)),"left"==A&&(m.tx0=z-(v-p/2/G),K&&(m.tx0=z-B),r=t),m.label=q,m.labelX=r,m.labelY=x,m.labelHeight=q.getBBox().height,q.translate(r,x),v=q.getBBox(),H=e.rect(d,v.width+5,v.height+5,"#ffffff",.005),H.translate(r+v.x,x+v.y),w.push(H),
m.hitRect=H,M=q.getBBox().height,H=x));(0===m.alpha||0<f&&!this.chartCreated)&&w.hide();g=h?g-p:g+p;v=B;m.startX=e.toCoordinate(this.startX,k);m.startY=e.toCoordinate(this.startY,n);m.pullX=e.toCoordinate(this.pullDistance,k);m.pullY=0;m.balloonX=z;m.balloonY=m.ty0;this.accessible&&this.accessibleLabel&&(m=this.formatString(this.accessibleLabel,m),this.makeAccessible(w,m));void 0!==this.tabIndex&&w.setAttr("tabindex",this.tabIndex)}}this.arrangeLabels();this.initialStart();(a=this.legend)&&a.invalidateSize()}else this.cleanChart();
this.dispDUpd()},arrangeLabels:function(){var a=this.rotate,b;b=a?0:this.realHeight;for(var c=0,d=this.chartData,f=d.length,e,k=0;k<f;k++){e=d[f-k-1];var n=e.label,l=e.labelY,t=e.labelX,u=e.labelHeight,g=l;a?b+c+5>l&&(g=b+c+5):l+u+5>b&&(g=b-5-u);b=g;c=u;n&&(n.translate(t,g),n=n.getBBox(),e.hitRect&&e.hitRect.translate(t+n.x,g+n.y));e.labelY=g;e.tx=t;e.ty=g;e.tx2=t}"center"!=this.labelPosition&&this.drawTicks()}})})();(function(){var e=window.AmCharts;e.Cuboid=e.Class({construct:function(a,b,c,d,e,h,k,n,l,t,u,g,E,I,D,F,y){this.set=a.set();this.container=a;this.h=Math.round(c);this.w=Math.round(b);this.dx=d;this.dy=e;this.colors=h;this.alpha=k;this.bwidth=n;this.bcolor=l;this.balpha=t;this.dashLength=I;this.topRadius=F;this.pattern=D;this.rotate=E;this.bcn=y;E?0>b&&0===u&&(u=180):0>c&&270==u&&(u=90);this.gradientRotation=u;0===d&&0===e&&(this.cornerRadius=g);this.draw()},draw:function(){var a=this.set;a.clear();
var b=this.container,c=b.chart,d=this.w,f=this.h,h=this.dx,k=this.dy,n=this.colors,l=this.alpha,t=this.bwidth,u=this.bcolor,g=this.balpha,E=this.gradientRotation,I=this.cornerRadius,D=this.dashLength,F=this.pattern,y=this.topRadius,z=this.bcn,G=n,C=n;"object"==typeof n&&(G=n[0],C=n[n.length-1]);var v,H,M,m,w,A,q,p,B,K=l;F&&(l=0);var r,x,J,L,N=this.rotate;if(0<Math.abs(h)||0<Math.abs(k))if(isNaN(y))q=C,C=e.adjustLuminosity(G,-.2),C=e.adjustLuminosity(G,-.2),v=e.polygon(b,[0,h,d+h,d,0],[0,k,k,0,0],
C,l,1,u,0,E),0<g&&(B=e.line(b,[0,h,d+h],[0,k,k],u,g,t,D)),H=e.polygon(b,[0,0,d,d,0],[0,f,f,0,0],C,l,1,u,0,E),H.translate(h,k),0<g&&(M=e.line(b,[h,h],[k,k+f],u,g,t,D)),m=e.polygon(b,[0,0,h,h,0],[0,f,f+k,k,0],C,l,1,u,0,E),w=e.polygon(b,[d,d,d+h,d+h,d],[0,f,f+k,k,0],C,l,1,u,0,E),0<g&&(A=e.line(b,[d,d+h,d+h,d],[0,k,f+k,f],u,g,t,D)),C=e.adjustLuminosity(q,.2),q=e.polygon(b,[0,h,d+h,d,0],[f,f+k,f+k,f,f],C,l,1,u,0,E),0<g&&(p=e.line(b,[0,h,d+h],[f,f+k,f+k],u,g,t,D));else{var O,P,Q;N?(O=f/2,C=h/2,Q=f/2,P=
d+h/2,x=Math.abs(f/2),r=Math.abs(h/2)):(C=d/2,O=k/2,P=d/2,Q=f+k/2+1,r=Math.abs(d/2),x=Math.abs(k/2));J=r*y;L=x*y;.1<r&&.1<r&&(v=e.circle(b,r,G,l,t,u,g,!1,x),v.translate(C,O));.1<J&&.1<J&&(q=e.circle(b,J,e.adjustLuminosity(G,.5),l,t,u,g,!1,L),q.translate(P,Q))}l=K;1>Math.abs(f)&&(f=0);1>Math.abs(d)&&(d=0);!isNaN(y)&&(0<Math.abs(h)||0<Math.abs(k))?(n=[G],n={fill:n,stroke:u,"stroke-width":t,"stroke-opacity":g,"fill-opacity":l},N?(l="M0,0 L"+d+","+(f/2-f/2*y),t=" B",0<d&&(t=" A"),e.VML?(l+=t+Math.round(d-
J)+","+Math.round(f/2-L)+","+Math.round(d+J)+","+Math.round(f/2+L)+","+d+",0,"+d+","+f,l=l+(" L0,"+f)+(t+Math.round(-r)+","+Math.round(f/2-x)+","+Math.round(r)+","+Math.round(f/2+x)+",0,"+f+",0,0")):(l+="A"+J+","+L+",0,0,0,"+d+","+(f-f/2*(1-y))+"L0,"+f,l+="A"+r+","+x+",0,0,1,0,0"),r=90):(t=d/2-d/2*y,l="M0,0 L"+t+","+f,e.VML?(l="M0,0 L"+t+","+f,t=" B",0>f&&(t=" A"),l+=t+Math.round(d/2-J)+","+Math.round(f-L)+","+Math.round(d/2+J)+","+Math.round(f+L)+",0,"+f+","+d+","+f,l+=" L"+d+",0",l+=t+Math.round(d/
2+r)+","+Math.round(x)+","+Math.round(d/2-r)+","+Math.round(-x)+","+d+",0,0,0"):(l+="A"+J+","+L+",0,0,0,"+(d-d/2*(1-y))+","+f+"L"+d+",0",l+="A"+r+","+x+",0,0,1,0,0"),r=180),b=b.path(l).attr(n),b.gradient("linearGradient",[G,e.adjustLuminosity(G,-.3),e.adjustLuminosity(G,-.3),G],r),N?b.translate(h/2,0):b.translate(0,k/2)):b=0===f?e.line(b,[0,d],[0,0],u,g,t,D):0===d?e.line(b,[0,0],[0,f],u,g,t,D):0<I?e.rect(b,d,f,n,l,t,u,g,I,E,D):e.polygon(b,[0,0,d,d,0],[0,f,f,0,0],n,l,t,u,g,E,!1,D);d=isNaN(y)?0>f?[v,
B,H,M,m,w,A,q,p,b]:[q,p,H,M,m,w,v,B,A,b]:N?0<d?[v,b,q]:[q,b,v]:0>f?[v,b,q]:[q,b,v];e.setCN(c,b,z+"front");e.setCN(c,H,z+"back");e.setCN(c,q,z+"top");e.setCN(c,v,z+"bottom");e.setCN(c,m,z+"left");e.setCN(c,w,z+"right");for(v=0;v<d.length;v++)if(H=d[v])a.push(H),e.setCN(c,H,z+"element");F&&b.pattern(F,NaN,c.path)},width:function(a){isNaN(a)&&(a=0);this.w=Math.round(a);this.draw()},height:function(a){isNaN(a)&&(a=0);this.h=Math.round(a);this.draw()},animateHeight:function(a,b){var c=this;c.animationFinished=
!1;c.easing=b;c.totalFrames=a*e.updateRate;c.rh=c.h;c.frame=0;c.height(1);setTimeout(function(){c.updateHeight.call(c)},1E3/e.updateRate)},updateHeight:function(){var a=this;a.frame++;var b=a.totalFrames;a.frame<=b?(b=a.easing(0,a.frame,1,a.rh-1,b),a.height(b),window.requestAnimationFrame?window.requestAnimationFrame(function(){a.updateHeight.call(a)}):setTimeout(function(){a.updateHeight.call(a)},1E3/e.updateRate)):(a.height(a.rh),a.animationFinished=!0)},animateWidth:function(a,b){var c=this;c.animationFinished=
!1;c.easing=b;c.totalFrames=a*e.updateRate;c.rw=c.w;c.frame=0;c.width(1);setTimeout(function(){c.updateWidth.call(c)},1E3/e.updateRate)},updateWidth:function(){var a=this;a.frame++;var b=a.totalFrames;a.frame<=b?(b=a.easing(0,a.frame,1,a.rw-1,b),a.width(b),window.requestAnimationFrame?window.requestAnimationFrame(function(){a.updateWidth.call(a)}):setTimeout(function(){a.updateWidth.call(a)},1E3/e.updateRate)):(a.width(a.rw),a.animationFinished=!0)}})})();

AmCharts.themes.light = {

	themeName:"light",

	AmChart: {
		color: "#000000", backgroundColor: "#FFFFFF"
	},

	AmCoordinateChart: {
		colors: ["#67b7dc", "#fdd400", "#84b761", "#cc4748", "#cd82ad", "#2f4074", "#448e4d", "#b7b83f", "#b9783f", "#b93e3d", "#913167"]
	},

	AmStockChart: {
		colors: ["#67b7dc", "#fdd400", "#84b761", "#cc4748", "#cd82ad", "#2f4074", "#448e4d", "#b7b83f", "#b9783f", "#b93e3d", "#913167"]
	},

	AmSlicedChart: {
		colors: ["#67b7dc", "#fdd400", "#84b761", "#cc4748", "#cd82ad", "#2f4074", "#448e4d", "#b7b83f", "#b9783f", "#b93e3d", "#913167"],
		outlineAlpha: 1,
		outlineThickness: 2,
		labelTickColor: "#000000",
		labelTickAlpha: 0.3
	},

	AmRectangularChart: {
		zoomOutButtonColor: '#000000',
		zoomOutButtonRollOverAlpha: 0.15,
		zoomOutButtonImage: "lens"
	},

	AxisBase: {
		axisColor: "#000000",
		axisAlpha: 0.3,
		gridAlpha: 0.1,
		gridColor: "#000000"
	},

	ChartScrollbar: {
		backgroundColor: "#000000",
		backgroundAlpha: 0.12,
		graphFillAlpha: 0.5,
		graphLineAlpha: 0,
		selectedBackgroundColor: "#FFFFFF",
		selectedBackgroundAlpha: 0.4,
		gridAlpha: 0.15
	},

	ChartCursor: {
		cursorColor: "#000000",
		color: "#FFFFFF",
		cursorAlpha: 0.5
	},

	AmLegend: {
		color: "#000000"
	},

	AmGraph: {
		lineAlpha: 0.9
	},
	GaugeArrow: {
		color: "#000000",
		alpha: 0.8,
		nailAlpha: 0,
		innerRadius: "40%",
		nailRadius: 15,
		startWidth: 15,
		borderAlpha: 0.8,
		nailBorderAlpha: 0
	},

	GaugeAxis: {
		tickColor: "#000000",
		tickAlpha: 1,
		tickLength: 15,
		minorTickLength: 8,
		axisThickness: 3,
		axisColor: '#000000',
		axisAlpha: 1,
		bandAlpha: 0.8
	},

	TrendLine: {
		lineColor: "#c03246",
		lineAlpha: 0.8
	},

	// ammap
	AreasSettings: {
		alpha: 0.8,
		color: "#67b7dc",
		colorSolid: "#003767",
		unlistedAreasAlpha: 0.4,
		unlistedAreasColor: "#000000",
		outlineColor: "#FFFFFF",
		outlineAlpha: 0.5,
		outlineThickness: 0.5,
		rollOverColor: "#3c5bdc",
		rollOverOutlineColor: "#FFFFFF",
		selectedOutlineColor: "#FFFFFF",
		selectedColor: "#f15135",
		unlistedAreasOutlineColor: "#FFFFFF",
		unlistedAreasOutlineAlpha: 0.5
	},

	LinesSettings: {
		color: "#000000",
		alpha: 0.8
	},

	ImagesSettings: {
		alpha: 0.8,
		labelColor: "#000000",
		color: "#000000",
		labelRollOverColor: "#3c5bdc"
	},

	ZoomControl: {
		buttonFillAlpha:0.7,
		buttonIconColor:"#a7a7a7"
	},

	SmallMap: {
		mapColor: "#000000",
		rectangleColor: "#f15135",
		backgroundColor: "#FFFFFF",
		backgroundAlpha: 0.7,
		borderThickness: 1,
		borderAlpha: 0.8
	},

	// the defaults below are set using CSS syntax, you can use any existing css property
	// if you don't use Stock chart, you can delete lines below
	PeriodSelector: {
		color: "#000000"
	},

	PeriodButton: {
		color: "#000000",
		background: "transparent",
		opacity: 0.7,
		border: "1px solid rgba(0, 0, 0, .3)",
		MozBorderRadius: "5px",
		borderRadius: "5px",
		margin: "1px",
		outline: "none",
		boxSizing: "border-box"
	},

	PeriodButtonSelected: {
		color: "#000000",
		backgroundColor: "#b9cdf5",
		border: "1px solid rgba(0, 0, 0, .3)",
		MozBorderRadius: "5px",
		borderRadius: "5px",
		margin: "1px",
		outline: "none",
		opacity: 1,
		boxSizing: "border-box"
	},

	PeriodInputField: {
		color: "#000000",
		background: "transparent",
		border: "1px solid rgba(0, 0, 0, .3)",
		outline: "none"
	},

	DataSetSelector: {

		color: "#000000",
		selectedBackgroundColor: "#b9cdf5",
		rollOverBackgroundColor: "#a8b0e4"
	},

	DataSetCompareList: {
		color: "#000000",
		lineHeight: "100%",
		boxSizing: "initial",
		webkitBoxSizing: "initial",
		border: "1px solid rgba(0, 0, 0, .3)"
	},

	DataSetSelect: {
		border: "1px solid rgba(0, 0, 0, .3)",
		outline: "none"
	}

};
(function () {
    "use strict";

    angular
        .module("app.planejamentoScrum.processamento.sprint", ["nvd3"])
        .config(Config);

    function Config($stateProvider, RotasHtml) {
        var rotasHtmlSprint = RotasHtml.sprint;
        var rotasHtmlEstoria = RotasHtml.estoria;
        $stateProvider.state("app.planejamento_processamento_sprint", {
            url: "/planejamento/processamento/sprint",
            module: "privado",
            views: {
                "content@app": {
                    templateUrl: rotasHtmlSprint.templateUrl,
                    controller: "SprintController as vm"
                },
                "sprint-form@app.planejamento_processamento_sprint": {
                    templateUrl: rotasHtmlSprint.form
                },
                "sprints-tabela@app.planejamento_processamento_sprint": {
                    templateUrl: rotasHtmlSprint.tabela
                }
            },
            resolve: {
                ListarUsuarioPorDetalhe: function (Api, RequisicaoGenericaService, LoginUsuarioService) {
                    return RequisicaoGenericaService.listarSemParams(Api.usuario.detalhes_usuario.listarDetalhesUsuario
                        + LoginUsuarioService.usuarioArmazenado().codigo);
                },
                ListarSprintCorrente: function (Api, RequisicaoGenericaService, ListarUsuarioPorDetalhe, PgToolbarFactory) {
                    var objetoCodigoSquads = {
                        codigoSquads: ListarUsuarioPorDetalhe.data.codigoSquads,
                    }
                    var entidadeEnvio = PgToolbarFactory.construirEntidadeDeEnvioPadrao(
                        objetoCodigoSquads);
                    return RequisicaoGenericaService.listarComObjetoComplexo(
                        Api.sprint.listarSprintCorrente, entidadeEnvio
                    );
                },
                ListarTodosUsuarios: function (Api, RequisicaoGenericaService) {
                    return RequisicaoGenericaService.listarSemParams(
                        Api.usuario.detalhes_usuario.listarUsuariosAtivos
                    );
                },
                RegistrosSituacoes: function (Api, RequisicaoGenericaService) {
                    return RequisicaoGenericaService.listarSemParams(
                        Api.sprint.registro_situacao.listarTodos
                    );
                },
                ListarTodasCerimonias: function (Api, RequisicaoGenericaService) {
                    return RequisicaoGenericaService.listarSemParams(
                        Api.sprint.cerimonia_detalhe.listarCerimonias
                    );
                },
                ListarTodasSituacoes: function (Api, RequisicaoGenericaService) {
                    return RequisicaoGenericaService.listarSemParams(
                        Api.situacao.listarTodos
                    );
                },
                ListarTodasSolucoes: function (Api, RequisicaoGenericaService) {
                    return RequisicaoGenericaService.listarSemParams(
                        Api.solucao_rotinas_tarefas.solucao.listarCodigoDescricao
                    );
                },
            }
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('app.planejamentoScrum.processamento.sprint')
        .controller('PontosDesenvolvedorDialogController', PontosDesenvolvedorDialogController);

    function PontosDesenvolvedorDialogController(
        $mdDialog,        
        TotalizadoresPontosDesenvolvedor,
        SprintFactory
        ) {
            var vm = this;
            
            vm.dtOptions = SprintFactory.setDtOptionsPontosDesenvolvedor();
            vm.dtOptions.columnDefs = SprintFactory.setColumnsDefsDtOptionsSprintPontosDesenvolvedor();

            vm.totalizadoresPontosDesenvolvedor = TotalizadoresPontosDesenvolvedor;
            vm.metodosDialog = {                
                fecharDialog: fecharDialog,
            };
            
            function fecharDialog() {
                $mdDialog.hide();
            };
    }
})();
(function () {
    'use strict';

    angular
        .module('app.pesquisa.processamento.pesquisa', [])
        .config(config);

    function config($stateProvider, RotasHtml) {
        var rotasHtmlPesquisa = RotasHtml.pesquisa.pesquisa;
        $stateProvider
            .state('app.pesquisa_processamento_pesquisa', {
                url: '/pesquisa/processamento/pesquisa',
                module: 'privado',
                views: {
                    'content@app': {
                        templateUrl: rotasHtmlPesquisa.templateUrl,
                        controller: 'PesquisaController as vm'
                    },
                    'pesquisa-form@app.pesquisa_processamento_pesquisa': {
                        templateUrl: rotasHtmlPesquisa.form
                    },
                    'pesquisa-tabela@app.pesquisa_processamento_pesquisa': {
                        templateUrl: rotasHtmlPesquisa.tabela
                    }
                },
                resolve: {
                    ListarProdutosAtivos: function (Api, RequisicaoGenericaService) {
                        return RequisicaoGenericaService.listarSemParams(Api.contrato.listarProdutosAtivos);
                    },
                    ListarTiposPequisa: function (Api, RequisicaoGenericaService) {
                        return RequisicaoGenericaService.listarSemParams(Api.pesquisa.tipoPesquisa.listarTodos);
                    },
                    ListarTodosProdutos: function (Api, RequisicaoGenericaService) {
                        return RequisicaoGenericaService.listarSemParams(Api.produto.listarTodosProdutos);
                    }
                }
            });
    }

}());
(function () {
    'use strict';
    angular
        .module('app.pesquisa.processamento.pesquisa')
        .controller('RepostasClientesDialogController', RepostasClientesDialogController);

    function RepostasClientesDialogController(
        $mdDialog, Cliente, Respostas) {
        var vm = this;
        vm.repostas = Respostas.map(function (item) {
            return {
                pergunta: item.pergunta.pergunta,
                perguntaAberta: item.pergunta.perguntaAberta,
                usuarios: item.pergunta.usuario.map(function (u) {
                    return {
                        usuario: u.nome,
                        codigo: u.codigo,
                        respostaAberta: u.respostaAberta,
                        respostaFechada: u.respostaFechada
                    }
                })
            }
        });
        vm.cliente = Cliente;
        vm.perguntaAtual = 0;
        vm.perguntaAtualData = vm.repostas[vm.perguntaAtual];

        vm.metodos = {
            fecharDialog: fecharDialog,
            proximaPergunta: proximaPergunta,
            perguntaAnterior: perguntaAnterior
        };

        function fecharDialog() {
            $mdDialog.hide();
        }

        function proximaPergunta() {
            if (vm.perguntaAtual < vm.repostas.length - 1) {
                vm.perguntaAtual++;
                vm.perguntaAtualData = vm.repostas[vm.perguntaAtual];
            }
        }

        function perguntaAnterior() {
            if (vm.perguntaAtual > 0) {
                vm.perguntaAtual--;
                vm.perguntaAtualData = vm.repostas[vm.perguntaAtual];
            }
        }
    }
})();
(function () {
    'use strict';
    angular
        .module('app.pesquisa.processamento.pesquisa')
        .controller('RepostasClientesGraficoDialogController', RepostasClientesGraficoDialogController);

    function RepostasClientesGraficoDialogController(
        $mdDialog,
        ListaPerguntas,
        CodigoPergunta,
        CodigoPesquisa,
        PerguntaRepostas,
        RequisicaoGenericaService,
        Api
    ) {
        var vm = this;
        vm.emProgresso = false;
        vm.codigoPesquisa = CodigoPesquisa;

        // Apenas perguntas fechadas
        vm.perguntasFechadas = ListaPerguntas.filter(function (pergunta) {
            return !pergunta.perguntaAberta;
        });

        // Descobre o índice da pergunta atual
        vm.perguntaAtual = 0;
        for (var i = 0; i < vm.perguntasFechadas.length; i++) {
            if (vm.perguntasFechadas[i].codigoPergunta === CodigoPergunta) {
                vm.perguntaAtual = i;
                break;
            }
        }

        vm.perguntaAtualData = null;
        vm.controleForm = {};
        vm.controlePreloader = {};

        vm.metodos = {
            fecharDialog: fecharDialog,
            perguntaAnterior: perguntaAnterior,
            proximaPergunta: proximaPergunta
        };

        function fecharDialog() {
            $mdDialog.hide();
        }

        function perguntaAnterior() {
            if (vm.perguntaAtual > 0) {
                vm.perguntaAtual--;
                var perguntaSelecionada = vm.perguntasFechadas[vm.perguntaAtual];
                _carregarRespostasPergunta(perguntaSelecionada.codigoPergunta);
            }
        }

        function proximaPergunta() {
            if (vm.perguntaAtual < vm.perguntasFechadas.length - 1) {
                vm.perguntaAtual++;
                var perguntaSelecionada = vm.perguntasFechadas[vm.perguntaAtual];
                _carregarRespostasPergunta(perguntaSelecionada.codigoPergunta);
            }
        }

        function _carregarRespostasPergunta(codigoPergunta) {
            vm.emProgresso = true;
            var rota = Api.pesquisa.pesquisa.listarRespostasClientesGraficos + "/" + vm.codigoPesquisa + "/" + codigoPergunta;
            RequisicaoGenericaService.listarSemParams(rota)
                .then(function (success) {
                    // Suporte ao retorno real do backend
                    vm.perguntaAtualData = {
                        pergunta: success.data.pergunta,
                        clientes: (success.data.repostas || success.data.clientesRespostas || []).map(function (resposta) {
                            return {
                                codigo: resposta.codigo,
                                nome: resposta.nome,
                                nota: resposta.nota !== undefined ? resposta.nota : resposta.notaMedia
                            };
                        })
                    };
                })
                .catch(function (error) {
                    console.error('Erro ao carregar respostas da pergunta:', error);
                })
                .finally(function () {
                    vm.emProgresso = false;
                });
        }

        // Inicialização: trata mock ou retorno real
        if (PerguntaRepostas && (PerguntaRepostas.repostas || PerguntaRepostas.clientesRespostas)) {
            vm.perguntaAtualData = {
                pergunta: PerguntaRepostas.pergunta,
                clientes: (PerguntaRepostas.repostas || PerguntaRepostas.clientesRespostas || []).map(function (resposta) {
                    return {
                        codigo: resposta.codigo,
                        nome: resposta.nome,
                        nota: resposta.nota !== undefined ? resposta.nota : resposta.notaMedia
                    };
                })
            };
        } else {
            _carregarRespostasPergunta(CodigoPergunta);
        }
    }
})();
//<!-- Ultima mudança 28/03/2017.-->
(function () {
    'use strict';

    angular
        .module('app.financeiro.processamento.contratos', [])
        .config(config);

    function config($stateProvider, RotasHtml) {
        var rotas = RotasHtml.contratos;
        $stateProvider
            .state('app.financeiro_processamento_contratos', {
                url: '/financeiro/processamento/contratos',
                module: 'privado',
                views: {
                    'content@app': {
                        templateUrl: rotas.templateUrl,
                        controller: "ContratosController as vm"
                    },
                    'contratos-form@app.financeiro_processamento_contratos': {
                        templateUrl: rotas.form
                    },
                    'contratos-tabela@app.financeiro_processamento_contratos': {
                        templateUrl: rotas.tabela
                    }
                },
                resolve: {
                    ListarUsuariosSetorComercial: function (Api, RequisicaoGenericaService) {
                        return RequisicaoGenericaService.listarSemParams(Api.usuario.listarUsuariosSetorComercial);
                    },
                    Cliente: function () {
                        return null;
                    },
                    DesabilitarBotoes: function () {
                        return false;
                    }
                }
            });
    }

})();

(function () {
    'use strict';

    angular
        .module('app.financeiro.processamento.contratos')
        .controller('DialogDetalhesEquipamentosController', DialogDetalhesEquipamentosController);

    function DialogDetalhesEquipamentosController(
        $mdDialog,
        Equipamentos,
        DatatableFactory
    ) {
        var vm = this;
        vm.equipamentos = Equipamentos;

        vm.metodos = {
            fecharDialog: fecharDialog
        }

        init();

        function init() {

            vm.dtOptions = DatatableFactory.construirDtOptionsResponsivoSemPaginacaoPadraoComPesquisaHeaderPadrao([
                {
                    targets: [0, 1, 2, 3, 4, 5, 6],
                    orderable: true
                }
            ]);
        }

        function fecharDialog() {
            $mdDialog.hide();
        }
    }

})();

(function () {
    'use strict';

    angular
        .module('app.financeiro.processamento.contratos')
        .controller('DialogObservacaoEDataInicialContrato', DialogObservacaoEDataInicialContrato);

    function DialogObservacaoEDataInicialContrato(
        $mdDialog,
        ContratoItem,
        DataInicioContrato,
        MdDialogService
    ) {

        var vm = this;
        vm.dataMinimaContrato = new Date(DataInicioContrato);
        vm.contratoItem = ContratoItem;
        vm.contratoItem.dataContratoHistorico = vm.dataMinimaContrato;

        vm.metodos = {
            salvar: salvar,
        };

        function salvar() {
            if (vm.contratoItem.dataContratoHistorico != vm.dataMinimaContrato) {
                _abrirDiaglogConfirmacaoCadastroItem();
            } else {
                $mdDialog.hide(vm.contratoItem);
            }
        }

        function _abrirDiaglogConfirmacaoCadastroItem() {
            MdDialogService.confirmPadraoComEvento("Atenção!",
                "A data selecionada é diferente da data inicial do contrato. Deseja continuar?",
                null,
                function () {
                    $mdDialog.hide(vm.contratoItem);
                }, function () {
                    vm.contratoItem.dataContratoHistorico = vm.dataMinimaContrato;
                });
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.financeiro.processamento.contratos')
        .controller('DialogObservacaoSubitemController', DialogObservacaoSubitemController);

    function DialogObservacaoSubitemController(
        $mdDialog,
        Subitem,
        ApenasVisualizacao,
        DescricaoProduto
    ) {
        var vm = this;

        vm.subitem = angular.copy(Subitem);
        vm.apenasVisualizacao = ApenasVisualizacao;
        vm.descricaoProduto = DescricaoProduto;

        vm.titulo = vm.descricaoProduto
            ? 'Observação do subitem ' + vm.descricaoProduto
            : 'Observação do subitem';

        vm.metodos = {
            fecharDialog: fecharDialog,
            salvar: salvar
        };

        function fecharDialog() {
            $mdDialog.cancel();
        }

        function salvar() {
            $mdDialog.hide(vm.subitem.observacao);
        }
    }
})();

/**
 * Created by nova on 18/07/2016.
 */
(function () {
    'use strict';

    angular
        .module('app.geral.cadastro.cliente.cliente', [])
        .config(config);

    function config($stateProvider, RotasHtml) {
        var rotasHtml = RotasHtml;
        $stateProvider
            .state('app.geral_cadastro_cliente_cliente', {
                url: '/geral/cadastro/cliente/cliente',
                module: 'privado',
                params: {
                    navegacaoDeRelatorioAtendimento: null,
                    parametros: null
                },
                views: {
                    'content@app': {
                        templateUrl: rotasHtml.cliente.templateUrl,
                        controller: "ClienteController as vm"
                    },
                    'cliente-form@app.geral_cadastro_cliente_cliente': {
                        templateUrl: rotasHtml.cliente.form
                    },
                    'clientes-tabela@app.geral_cadastro_cliente_cliente': {
                        templateUrl: rotasHtml.cliente.tabela
                    },
                    'pessoa@app.geral_cadastro_cliente_cliente': {
                        templateUrl: rotasHtml.pessoa.templateUrl
                    },
                    'pessoa-form@app.geral_cadastro_cliente_cliente': {
                        templateUrl: rotasHtml.pessoa.form
                    },
                    'pessoas-tabela@app.geral_cadastro_cliente_cliente': {
                        templateUrl: rotasHtml.pessoa.tabela
                    },
                    'contratos@app.geral_cadastro_cliente_cliente': {
                        templateUrl: rotasHtml.contratos.templateUrl
                    },
                    'contratos-form@app.geral_cadastro_cliente_cliente': {
                        templateUrl: rotasHtml.contratos.form
                    },
                    'contratos-tabela@app.geral_cadastro_cliente_cliente': {
                        templateUrl: rotasHtml.contratos.tabela
                    },
                    'estatisticas-tags@app.geral_cadastro_cliente_cliente': {
                        templateUrl: rotasHtml.estatisticasTagsAtendimento.templateUrl
                    },
                    'estatisticas-tags-form@app.geral_cadastro_cliente_cliente': {
                        templateUrl: rotasHtml.estatisticasTagsAtendimento.form
                    }
                },
                resolve: {
                    Solucoes: function (Api, RequisicaoGenericaService) {
                        return RequisicaoGenericaService.listarSemParams(Api.solucao_rotinas_tarefas.solucao.listarCodigoDescricao);
                    },
                    Pendencias: function (Api, RequisicaoGenericaService) {
                        return RequisicaoGenericaService.listarSemParams(Api.cliente_pendencia.listarPor);
                    },
                    ListarTodasUF: function (Api, RequisicaoGenericaService) {
                        return RequisicaoGenericaService.listarSemParams(Api.display.listarTodasUf);
                    },
                    ListarTipoClassificacao: function (Api, RequisicaoGenericaService) {
                        return RequisicaoGenericaService.listarSemParams(Api.display.listarTipoClassificacaoCliente);
                    },
                    ListarUsuariosSetorComercial: function (Api, RequisicaoGenericaService) {
                        return RequisicaoGenericaService.listarSemParams(Api.usuario.listarUsuariosSetorComercial);
                    },
                    ListarTiposEquipamento: function (Api, RequisicaoGenericaLocacaoService) {
                        return RequisicaoGenericaLocacaoService.listarSemParams(Api.locacao.equipamentos.tipo.listarTodos);
                    },
                    ListarEquipamentos: function (Api, RequisicaoGenericaLocacaoService) {
                        return RequisicaoGenericaLocacaoService.listarSemParams(Api.locacao.equipamentos.equipamento.listarTodos);
                    },
                    ListarDetalhesUsuario: function (Api, RequisicaoGenericaService, LoginUsuarioService) {
                        return RequisicaoGenericaService.listarSemParams(Api.usuario.detalhes_usuario.listarDetalhesUsuario
                            + LoginUsuarioService.usuarioArmazenado().codigo);
                    },
                }
            });
    }

})();

/**
 * Created by nova on 26/10/2016.
 */
(function () {
    'use strict';

    angular
        .module('app.geral.cadastro.cliente.cliente')
        .controller('ClienteDialogEquipamentosController',ClienteDialogEquipamentosController);


    function ClienteDialogEquipamentosController(
        $mdDialog,
        MdDialogService,
        MdToastService,
        RequisicaoGenericaService,
        RequisicaoGenericaLocacaoService,
        Api,
        Cliente,
        ClienteEquipamento,
        ServicosGenericoService,
        DeselecionarDetalhesEquipamento
    ) {
        var vm = this;

        // Data region
        vm.form = {};
        vm.mensagemPreloader = "";
        vm.titulo = "Cliente Equipamento";
        vm.preloader = {
            habilitar: false,
            mensagem: ""
        }

        vm.equipamentos = [];
        vm.fornecedores = [];
        vm.clienteEquipamentos = ClienteEquipamento;
        vm.clienteEquipamento = {};
        vm.obj = {};
        vm.codigoCliente = Cliente.codigo;
        vm.editandoEquip = false;

        /**
         * Chamada do metódo inicializador
         */
        init();

        // Definição dos Métodos region
        vm.metodosDialog = {
            salvar: salvar,
            configuraMdSelectFornecedor: configuraMdSelectFornecedor,
            configuraMdSelectEquipamento: configuraMdSelectEquipamento,
            excluir: excluir,
            fecharDialog: metodoDialogFecharDialog,
        };
        //endregion


        /**
         * Método inicializador
         */
        function init() {
            ListarEquipamentos();
            ListarFornecedores();

            if (vm.clienteEquipamentos) {
                vm.editandoEquip = true;
                vm.clienteEquipamento.codigoEquipamento = vm.clienteEquipamentos.equipamentoCodigo;
                vm.clienteEquipamento.codigoFornecedor = vm.clienteEquipamentos.fornecedorCodigo;
                vm.clienteEquipamento.quantidadeEquipamentos = vm.clienteEquipamentos.quantidade;
            }
        }

        ////////////////////////////////////////////// Métodos Internos //////////////////////////////////////////////

        /**
         * Método para listar todos equipamentos
         */
        function ListarEquipamentos() {
            vm.requisicaoSolicitada = true;
            vm.mensagemPreloader = "Carregando Equipamentos ..."
            RequisicaoGenericaLocacaoService.listarSemParams(Api.locacao.equipamentos.equipamento.listarTodos).then(
                function (success) {
                    vm.equipamentos = success.data;
                    vm.mensagemPreloader = "";
                    vm.requisicaoSolicitada = false;
                },
                function (error) {
                    MdDialogService.alertPadrao(error.data);
                    vm.mensagemPreloader = "";
                    vm.requisicaoSolicitada = false;
                });
        }

        /**
         * Método para listar todos Fornecedores
         */
        function ListarFornecedores() {
            vm.requisicaoSolicitada = true;
            vm.mensagemPreloader = "Carregando Fornecedores ..."
            RequisicaoGenericaLocacaoService.listarSemParams(Api.locacao.equipamentos.fornecedor.listarTodos).then(
                function (success) {
                    vm.fornecedores = success.data;
                    vm.mensagemPreloader = "";
                    vm.requisicaoSolicitada = false;
                },
                function (error) {
                    MdDialogService.alertPadrao(error.data);
                    vm.mensagemPreloader = "";
                    vm.requisicaoSolicitada = false;
                });
        }

        /**
         * Método para criar novo clienteEquipamento
         * @param {event} event event button
         * @param {object} modelo clienteEquipamento
         */
        function criar(event,modelo) {
            vm.obj = modelo;
            vm.obj.codigoCliente = vm.codigoCliente;
            vm.requisicaoSolicitada = true;
            vm.mensagemPreloader = "Gravando Equipamento ..."
            RequisicaoGenericaService.salvar(Api.cliente_equipamento.criar,vm.obj).then(
                function (success) {
                    MdToastService.toastPadrao("Equipamento cadastro com sucesso.");
                    vm.requisicaoSolicitada = false;
                    vm.mensagemPreloader = "";
                    $mdDialog.hide();
                    Cliente.equipamentos.push(success.data);
                },
                function (error) {
                    MdDialogService.alertPadrao(error.data,event);
                    vm.requisicaoSolicitada = false;
                    vm.mensagemPreloader = "";
                });
        }

        /**
         * Método para editar um clienteEquipamento
         * @param {event} event  event Button
         * @param {object} modelo clienteEquipamento
         */
        function editar(event,modelo) {
            vm.obj = modelo;
            vm.obj.codigoCliente = vm.codigoCliente;
            vm.obj.codigo = vm.clienteEquipamentos.cliEquipCodigo;
            vm.requisicaoSolicitada = true;
            vm.mensagemPreloader = "Editando Equipamento ..."

            RequisicaoGenericaService.editar(Api.cliente_equipamento.atualizar,vm.obj).then(
                function (success) {
                    MdToastService.toastPadrao("Equipamento editado com sucesso.");
                    vm.requisicaoSolicitada = false;
                    vm.mensagemPreloader = "";
                    $mdDialog.hide();
                },
                function (error) {
                    MdDialogService.alertPadrao(error.data,event);
                    vm.requisicaoSolicitada = false;
                    vm.mensagemPreloader = "";
                });
        }

        //////////////////////////////////////////////////////////////////////////////////////////////////////////////

        /**
         * Método para salvar um Equipamento
         * @param {event} event
         * @param {object} modelo clienteEquipamento
         */
        function salvar(event,modelo) {
            if (vm.editandoEquip)
                editar(event,modelo);
            else
                criar(event,modelo);
        }

        /**
         * Método para excluir um Equipamento
         * @param {event} event
         * @param {object} modelo clienteEquipamento
         */
        function excluir(event,modelo) {
            var indexEquipamento = Cliente.equipamentos.map(function (item) { return item.codigo }).indexOf(modelo.codigo);
            ServicosGenericoService.excluirRegistroPorCodigoOuGenericamenteEmDialogs(Api.cliente_equipamento.excluir,Cliente.equipamentos,modelo,vm.preloader,
                $mdDialog,event,"Deseja realmente excluir este equipamento?",
                function (success) {
                    DeselecionarDetalhesEquipamento();
                    MdToastService.toastPadrao(success.data);
                },indexEquipamento,"Excluíndo Equipamento ...",
                modelo.codigo + "/" + modelo.codigoCliente);
        }

        /**
         * Método para configurar md-select header de equipamentos
         */
        function configuraMdSelectEquipamento() {
            vm.filtrarEquipamentos = "";
            angular.element('#dialog-cliente-equipamento-equipamento-md-select').on('keydown',function (ev) {
                ev.stopPropagation();
            });
        }

        /**
         * Método para configurar md-select header de fornecedores
         */
        function configuraMdSelectFornecedor() {
            vm.filtrarFornecedores = "";
            angular.element('#dialog-cliente-equipamento-fornecedor-md-select').on('keydown',function (ev) {
                ev.stopPropagation();
            });
        }

        /**
         * Método para fechar o dialog quando pressionado o "X" no toolbar do Dialog
         */
        function metodoDialogFecharDialog() {
            $mdDialog.hide();
        }
        //endregion

    } // CONTROLLER

})();

/**
 * Created by nova on 26/10/2016.
 */
(function () {
    'use strict';

    angular
        .module('app.geral.cadastro.cliente.cliente')
        .controller('ClienteDialogEquipamentosDetalhesController',ClienteDialogEquipamentosDetalhesController);


    function ClienteDialogEquipamentosDetalhesController(
        $mdDialog,
        MdDialogService,
        MdToastService,
        RequisicaoGenericaService,
        Api,
        ServicosGenericoService,
        DetalhesEquipamentos,
        ClienteEquipamentoSelecionado,
        DetalheEquipamento,
        DataTableConfigPadrao
    ) {
        var vm = this;

        // Data region
        vm.form = {};
        vm.mensagemPreloader = "";
        vm.titulo = "Cliente Equipamento Detalhes"

        vm.preloader = {
            habilitar: false,
            mensagem: ""
        }

        vm.clienteSelecionado = ClienteEquipamentoSelecionado;
        vm.obj = {};

        if (DetalheEquipamento) {
            // vm.inserindo = false;
            vm.equipamentosDetalhes = angular.copy(DetalheEquipamento);
        }
        else {
            // vm.inserindo = true;
            vm.equipamentosDetalhes = {
                codigoCliente: ClienteEquipamentoSelecionado.clienteCodigo,
                codigoClienteEquipamento: ClienteEquipamentoSelecionado.cliEquipCodigo
            };
        }
        //endregion


        // Configurações Datatable
        vm.valorTotalSevico = 0;
        vm.dtOptionsClienteEquipamentosDetalhes = angular.copy(
            DataTableConfigPadrao.dtOptionsResponsivoSemPaginacaoComInitComplete
        );
        vm.dtOptionsClienteEquipamentosDetalhes.columnDefs = [{
            targets: 0,
            ordering: false,
            responsivePriority: 1,
            filterable: true,
            sortable: false
        },
        {
            targets: 1,
            ordering: false,
            responsivePriority: 1,
            filterable: true,
            sortable: false
        }]
        vm.resetarDataGridClienteEquipamentos = true;

        /**
         * Chamada do metódo inicializador
         */
        init();

        // Definição dos Métodos region
        vm.metodosDialog = {
            salvar: salvar,
            criar: criar,
            editar: editar,
            configuraMdSelectFornecedor: configuraMdSelectFornecedor,
            configuraMdSelectEquipamento: configuraMdSelectEquipamento,
            excluir: excluir,
            fecharDialog: metodoDialogFecharDialog,
        };
        //endregion


        /**
         * Método inicializador
         */
        function init() {

        }

        ////////////////////////////////////////////// Métodos Internos //////////////////////////////////////////////

        /**
         * Método para criar novo Detalhe Equipamento
         * @param {event} event event button
         * @param {object} modelo Detalhe Equipamento
         */
        function criar(event,modelo) {
            vm.obj.codigoClienteEquipamento = vm.clienteSelecionado.cliEquipCodigo;
            vm.obj.codigoCliente = vm.clienteSelecionado.clienteCodigo;
            vm.obj.cliente = null;
            vm.obj.clienteEquipamentos = null;
            vm.obj.codigo = 0;
            vm.obj.numeroImei = modelo.numeroImei;
            vm.obj.numeroLicenca = modelo.numeroLicenca;
            vm.obj.numeroSerie = modelo.numeroSerie;

            vm.requisicaoSolicitada = true;
            vm.mensagemPreloader = "Gravando Detalhe Equipamento ..."
            RequisicaoGenericaService.salvar(Api.cliente_equipamento_detalhe.criar,vm.obj).then(
                function (success) {
                    vm.equipamentosDetalhes.push(success.data);
                    vm.clienteEquipamentoDetalhe = null;
                    MdToastService.toastPadrao("Detalhe Equipamento cadastro com sucesso.");
                    vm.requisicaoSolicitada = false;
                    vm.mensagemPreloader = "";
                },
                function (error) {
                    MdDialogService.alertPadrao(error.data,event);
                    vm.requisicaoSolicitada = false;
                    vm.mensagemPreloader = "";
                });
        }

        /**
         * Método para editar um clienteEquipamento
         * @param {event} event  event Button
         * @param {object} modelo clienteEquipamento
         */

        function salvar(event,modelo) {
            if (modelo.codigo) {
                vm.requisicaoSolicitada = true;
                vm.mensagemPreloader = "Editando Detalhe Equipamento ..."
                RequisicaoGenericaService.editar(Api.cliente_equipamento_detalhe.atualizar,modelo).then(
                    function (success) {
                        vm.clienteEquipamentoDetalhe = null;
                        MdToastService.toastPadrao("Detalhe Equipamento editado com sucesso.");
                        vm.requisicaoSolicitada = false;
                        vm.mensagemPreloader = "";
                    },
                    function (error) {
                        MdDialogService.alertPadrao(error.data,event);
                        vm.requisicaoSolicitada = false;
                        vm.mensagemPreloader = "";
                    });
            }
            else {
                criar(undefined,modelo);
            }
        }

        function editar(event,modelo) {
            vm.clienteEquipamentoDetalhe = modelo;
        }

        //////////////////////////////////////////////////////////////////////////////////////////////////////////////

        /**
         * Método para salvar um Equipamento
         * @param {event} event
         * @param {object} modelo clienteEquipamento
         */
        // function salvar(event,modelo) {
        //     if (vm.inserindo)
        //         criar(event,modelo);
        //     else
        //         editar(event,modelo);

        // }

        /**
         * Método para excluir um Equipamento
         * @param {event} event
         * @param {object} modelo clienteEquipamento
         */
        function excluir(event,modelo) {
            var indexDetalheEquipamento = vm.equipamentosDetalhes.indexOf(modelo);
            ServicosGenericoService.excluirRegistroPorCodigoOuGenericamenteEmDialogs(
                Api.cliente_equipamento_detalhe.excluir,
                vm.equipamentosDetalhes,
                modelo,
                vm.preloader,
                null,
                null,
                "Deseja realmente excluir este Detalhe do Equipamento?",
                function (success) {
                    MdToastService.toastPadrao("Detalhe Equipamento excluido com sucesso.");
                    vm.clienteEquipamentoDetalhe = {};
                },
                indexDetalheEquipamento,"Excluíndo Detalhe do Equipamento ...",
                modelo.codigo + "/" + modelo.codigoCliente + "/" + modelo.codigoClienteEquipamento);
        }

        /**
         * Método para configurar md-select header de equipamentos
         */
        function configuraMdSelectEquipamento() {
            vm.filtrarEquipamentos = "";
            angular.element('#dialog-cliente-equipamento-equipamento-md-select').on('keydown',function (ev) {
                ev.stopPropagation();
            });
        }

        /**
         * Método para configurar md-select header de fornecedores
         */
        function configuraMdSelectFornecedor() {
            vm.filtrarFornecedores = "";
            angular.element('#dialog-cliente-equipamento-fornecedor-md-select').on('keydown',function (ev) {
                ev.stopPropagation();
            });
        }

        /**
         * Método para fechar o dialog quando pressionado o "X" no toolbar do Dialog
         */
        function metodoDialogFecharDialog() {
            $mdDialog.hide(vm.equipamentosDetalhes);
        }
        //endregion

    } // CONTROLLER

})();

/**
 * Created by nova on 12/08/2016.
 */
(function () {
    'use strict';

    angular
        .module('app.geral.cadastro.usuario.usuario', [])
        .config(config);

    function config($stateProvider, RotasHtml) {
        var rotasHtmlColaborador = RotasHtml.usuario;
        $stateProvider
            .state('app.geral_cadastro_usuario_usuario', {
                url: '/geral/cadastro/usuario/usuario',
                module: 'privado',
                views: {
                    'content@app': {
                        templateUrl: rotasHtmlColaborador.templateUrl,
                        controller: 'UsuarioController as vm'
                    },
                    'usuario-form@app.geral_cadastro_usuario_usuario': {
                        templateUrl: rotasHtmlColaborador.form
                    },
                    'usuarios-tabela@app.geral_cadastro_usuario_usuario': {
                        templateUrl: rotasHtmlColaborador.tabela
                    }
                },
                resolve: {
                    ListarTiposAtendimento: function (Api, RequisicaoGenericaService) {
                        return RequisicaoGenericaService.listarSemParams(Api.atendimento.listarTiposAtendimento);
                    },
                    setores: function (Api, RequisicaoGenericaService) {
                        return RequisicaoGenericaService.listarSemParams(Api.setor.listarCodigoDescricao);
                    },
                    perfis: function (Api, RequisicaoGenericaService) {
                        return RequisicaoGenericaService.listarSemParams(Api.perfil.listarTodos);
                    },
                    ListarCategorias: function (Api, RequisicaoGenericaService) {
                        return RequisicaoGenericaService.listarSemParams(Api.trabalhe_conosco.listarCategorias);
                    },
                    ListarTodosUsuarios: function (Api, RequisicaoGenericaService) {
                        return RequisicaoGenericaService.listarSemParams(Api.usuario.listarTodos);
                    }
                }
            });
    }

})();

(function () {
    'use strict';

    angular
        .module('app.geral.cadastro.usuario.usuario')
        .controller("DialogSenhaUsuarioController", DialogSenhaUsuarioController);

    function DialogSenhaUsuarioController($mdDialog, ServicosGenericoService, Usuario, Api, RequisicaoGenericaService, MdDialogService, form, PossuiSenha) {
        var vm = this;

        vm.usuario = PossuiSenha;
        vm.emProgresso = false;
        vm.inserirSenha = false;
        vm.metodosDialog = {
            fecharDialog: metodoDialogFecharDialog,
            salvar: salvar
        };

        if (PossuiSenha)
            vm.titulo = "Alteração de senha";
        else
            vm.titulo = "Inclusão de senha";

        var metodosInternos = {
          _novaSenha: _novaSenha,
          _atualizarSenha: _atualizarSenha,
          _redefineSenha: _redefineSenha
        };

        //#region Métodos

        function salvar() {
            if (vm.usuario)
                _atualizarSenha();
            else
                _novaSenha();

        }

        function metodoDialogFecharDialog() {
            $mdDialog.hide();
        }

        //#endregion

        //#region Métodos Internos

        function _novaSenha() {
            if (vm.senhaNova && vm.confirmacaoSenhaNova) {
                if (vm.senhaNova == vm.confirmacaoSenhaNova) {
                    vm.emProgresso = true;

                    RequisicaoGenericaService.listarComParams(Api.usuario.validarSenha, {senha: vm.senhaNova}).then(
                        function (success) {
                            vm.emProgresso = false;
                            Usuario.senha = vm.senhaNova;
                            MdDialogService.alertPadrao("Senha incluída com sucesso!", null);
                            $mdDialog.hide();
                        }, function (error) {
                            vm.emProgresso = false;
                            ServicosGenericoService.exibirAlertaDeErro(error, null);
                        });
                }
                else {
                    MdDialogService.alertPadrao("As senhas digitadas não conferem.", null);
                }
            }
        }

        function _atualizarSenha() {
            if (vm.senhaNova == vm.confirmacaoSenhaNova) {
                vm.emProgresso = true;
                  RequisicaoGenericaService.listarComParams(Api.usuario.validarSenha, { senha: vm.senhaNova }).then(
                    function (success) {
                      vm.emProgresso = false;
                      Usuario.senha = vm.senhaNova;
                      Usuario.possuiSenha = true;
                      Usuario.login = Usuario.login;
                      $mdDialog.hide();
                    }, function (error) {
                      vm.emProgresso = false;
                      ServicosGenericoService.exibirAlertaDeErro(error, null);
                    });
            }
            else {
                MdToastService.toastErro("As senhas digitadas não conferem.");
            }
        }

        function _redefineSenha(){
          Usuario.senha = vm.senhaNova;
          RequisicaoGenericaService.salvar(Api.usuario.configuracaoUsuario.criar,Usuario)
              .then(function(success){
                vm.emProgresso = false;
                var teste = success;
              },function(error){
                vm.emProgresso = false;
                ServicosGenericoService.exibirAlertaDeErro(error, null);
              })
        }

        //#endregion

    }
})();

/**
 * Created by nova on 26/10/2016.
 */
(function () {
    'use strict';

    angular
        .module('app.geral.cadastro.cliente.cliente')
        .controller('ClienteDialogCaracteristicaController', ClienteDialogCaracteristicaController);


    function ClienteDialogCaracteristicaController($mdDialog, DataTableConfigPadrao, MdDialogService, MdToastService, CodigoCliente,
        ServicosGenericoService, RequisicaoGenericaService, Api) {
        var vm = this;

        // Data region      
        vm.form = {};
        vm.titulo = "Característica Cliente";

        vm.preloader = {
            requisicaoSolicitada: false,
            mensagemPreloader: ""
        }

        vm.dtOptions = angular.copy(DataTableConfigPadrao.dtOptionsResponsivoSemPaginacaoComInitComplete);
        vm.dtOptions.columnDefs = [
            {
                targets: 0,
                ordering: false,
                filterable: false,
                sortable: false,
            },
            {
                targets: 1,
            },
            {
                targets: 2,
            },
        ];
        vm.dtOptions.dom = 'rt';
        //endregion                

        /**
         * Chamada do metódo inicializador
         */
        init();

        // Definição dos Métodos region 
        var metodosInterno = {
            listarCaracteristicas: listarCaracteristicas,
            listarCaracteristicasCliente: listarCaracteristicasCliente,
            limparModelCaracteristicaCliente: limparModelCaracteristicaCliente
        }
        vm.metodosDialog = {
            cadastrarCaracteristica: cadastrarCaracteristica,
            excluirCaracteristica: excluirCaracteristica,
            configurarMdSelectCaracteristica: configurarMdSelectCaracteristica,
            fecharDialog: metodoDialogFecharDialog,
        };
        //endregion


        /**
         * Método inicializador
         */
        function init() {
            vm.caracteristicaCliente = {
                codigoCliente: CodigoCliente
            }

            listarCaracteristicasCliente();
            listarCaracteristicas();
        }

        ////////////////////////////////////////////// Métodos Internos //////////////////////////////////////////////      

        /**
         * Método para listar todas as características
         */
        function listarCaracteristicas() {
            ServicosGenericoService.exibirPreloaderRequisicaoIniciada(vm.preloader, "Pesquisando características ...");

            RequisicaoGenericaService.listarSemParams(Api.cliente_caracteristica.listarTodos).then(
                function (success) {
                    ServicosGenericoService.ocultarPreloaderRequisicaoFinalizada(vm.preloader);

                    vm.caracteristicas = success.data;
                },
                function (error) {
                    ServicosGenericoService.ocultarPreloaderRequisicaoFinalizada(vm.preloader);

                    MdDialogService.alertPadrao(error.data);
                });
        }

        /**
         * Método para listar as características que o cliente possui
         */
        function listarCaracteristicasCliente() {
            ServicosGenericoService.exibirPreloaderRequisicaoIniciada(vm.preloader, "Pesquisando características do cliente ...");

            RequisicaoGenericaService.listarSemParams(Api.cliente_caracteristica.listarCaracteristicas + CodigoCliente).then(
                function (success) {
                    ServicosGenericoService.ocultarPreloaderRequisicaoFinalizada(vm.preloader);

                    vm.caracteristicasCliente = success.data;
                },
                function (error) {
                    ServicosGenericoService.ocultarPreloaderRequisicaoFinalizada(vm.preloader);

                    MdDialogService.alertPadrao(error.data);
                });
        }

        /**
         * Método para redifnir o model 'vm.caracteristicaCliente'
         */
        function limparModelCaracteristicaCliente() {
            vm.caracteristicaCliente = {
                codigoCliente: CodigoCliente
            }
        }

        //////////////////////////////////////////////////////////////////////////////////////////////////////////////


        ////////////////////////////////////////////// Métodos ///////////////////////////////////////////////////////

        /**         
         * Método para cadastrar uma nova caracterísitca para o cliente         
         * @param {caracteristica} modelo 
         * @param {event do button} event 
         */
        function cadastrarCaracteristica(modelo, event) {
            ServicosGenericoService.exibirPreloaderRequisicaoIniciada(vm.preloader, "Cadastrando Característica ...");

            RequisicaoGenericaService.salvar(Api.cliente.cadastrarCaracteristicaCliente, modelo).then(
                function (success) {
                    MdToastService.toastPadrao("Característica cadastrada com sucesso!");
                    ServicosGenericoService.ocultarPreloaderRequisicaoFinalizada(vm.preloader);

                    vm.caracteristicasCliente = success.data;

                    limparModelCaracteristicaCliente();
                },
                function (error) {
                    ServicosGenericoService.ocultarPreloaderRequisicaoFinalizada(vm.preloader);
                    MdDialogService.alertPadrao("Atenção!", null, error.data);
                });
        }

        /**
         * Método para excluir uma característica do cliente
         * @param {caracteristica do cliente selecionada} modelo 
         * @param {event do botão} event 
         */
        function excluirCaracteristica(modelo, event) {
            MdDialogService.confirmPadraoComEvento("Deseja realmente excluir está característica do cliente ?", null, event,
                function () {
                    ServicosGenericoService.exibirPreloaderRequisicaoIniciada(vm.preloader, "Excluindo Característica do cliente ...");
                    RequisicaoGenericaService.excluir(Api.cliente.excluirCaracteristicaCliente, modelo.codigo + "/" + CodigoCliente).then(
                        function (success) {
                            MdToastService.toastPadrao(success.data);
                            ServicosGenericoService.ocultarPreloaderRequisicaoFinalizada(vm.preloader);

                            vm.caracteristicasCliente.splice(vm.caracteristicasCliente.indexOf(modelo), 1);

                            limparModelCaracteristicaCliente();
                        },
                        function (error) {
                            MdDialogService.alertPadrao(error.data, event);
                            ServicosGenericoService.ocultarPreloaderRequisicaoFinalizada(vm.preloader);
                        });
                });
        }

        /**
         * método para configurar md-header do md-select do campo caracterísitca
         */
        function configurarMdSelectCaracteristica() {
            vm.filtrarCaracteristica = "";
            angular.element('#dialog-cliente-caracteristica-md-select-caracteristica').on('keydown', function (ev) {
                ev.stopPropagation();
            });
        }

        /**
         * Método para fechar o dialog quando pressionado o "X" no toolbar do Dialog
         */
        function metodoDialogFecharDialog() {
            $mdDialog.hide();
        }

        //////////////////////////////////////////////////////////////////////////////////////////////////////////////

    } // CONTROLLER

})();

/**
 * Created by nova on 26/10/2016.
 */
(function () {
    'use strict';

    angular
        .module('app.geral.cadastro.cliente.cliente')
        .controller('ClienteDialogAtendimentoController', ClienteDialogAtendimentoController);


    function ClienteDialogAtendimentoController(MenuFactory, $mdDialog, DatatableFactory, LoginUsuarioService, Cliente, MdDialogService,
        RequisicaoGenericaService, Api, RotasHtml) {
        var vm = this;

        // Data region      
        vm.form = {};

        var codigoUsuarioCorrente = LoginUsuarioService.usuarioArmazenado().codigo;

        vm.dtOptions = DatatableFactory.construirDtOptionsComPaginacaoResponsivoPadrao([]);
        //endregion                

        /**
         * Chamada do metódo inicializador
         */
        init();

        // Definição dos Métodos region           
        var metodosInterno = {
            pesquisarAtendimentosPorCliente: pesquisarAtendimentosPorCliente
        }
        vm.metodosDialog = {
            tabSelecionada: tabSelecionada,
            continuarParaAtendimento: continuarParaAtendimento,
            selecionarAtendimento: selecionarAtendimento,
            limparAtendimentoSelecionado: limparAtendimentoSelecionado,
            ngChangeRadioGroup: ngChangeRadioGroup,
            retornarDescricaoDisplay: retornarDescricaoDisplay,
            retornarSubstringAssunto: retornarSubstringAssunto,
            fecharDialog: metodoDialogFecharDialog,
        };
        //endregion


        /**
         * Método inicializador
         */
        function init() {
            vm.titulo = "Inserção/Continuação de Atendimento";
            vm.tabSelecionada = "atendimentosEmAberto";
            vm.htmlRota = RotasHtml.cliente.tabCliente.dialogAtendimento;

            vm.tipoAtendimento = 1;
            vm.atendimentoSelecionado = {};
            vm.indexAtendimentoSelecionado = null;

            pesquisarAtendimentosPorCliente();
        }

        ////////////////////////////////////////////// Métodos Internos //////////////////////////////////////////////

        /**
         * Método que realiza uma requisição para api e lista todos os atendimentos do cliente do ano atual
         */
        function pesquisarAtendimentosPorCliente() {
            vm.requisicaoSolicitada = true;
            vm.mensagemPreloader = "Pesquisando Atendimentos ..."
            RequisicaoGenericaService.listarSemParams(Api.atendimento.listarAtendimentosDoClientePorUsuarioCorrente
                + Cliente.codigo + "/" + codigoUsuarioCorrente).then(
                    function (success) {
                        vm.atendimentosClientesEmAberto = success.data.filter(function (item) {
                            return item.status == 1;
                        });
                        vm.todosAtendimentosClientes = success.data;
                        vm.mensagemPreloader = "";
                        vm.requisicaoSolicitada = false;
                    },
                    function (error) {
                        MdDialogService.alertPadrao(error.data);
                        vm.mensagemPreloader = "";
                        vm.requisicaoSolicitada = false;
                    });
        }

        //////////////////////////////////////////////////////////////////////////////////////////////////////////////


        function tabSelecionada(tabSelecionada) {
            vm.tabSelecionada = tabSelecionada;

            limparAtendimentoSelecionado();
        }

        function continuarParaAtendimento(modelo, tipoAtendimento, event) {
            if (tipoAtendimento == 1) {
                MenuFactory.navegarParaEstadoSeUsuarioTerAcesso('app.atendimento_processamento_atendimento', {
                    parametros: {
                        cliente: Cliente,
                        codigoCliente: Cliente.codigo,
                        chamarInsercao: true
                    }
                });
            }
            else {
                MenuFactory.navegarParaEstadoSeUsuarioTerAcesso('app.atendimento_processamento_atendimento', {
                    parametros: {
                        codigo: modelo.codigo,
                        ano: modelo.ano,
                        chamarPesquisa: true
                    }
                });
            }
            $mdDialog.hide();
        }

        /**
         * Método que define o atendimento selecionado pelo usuário
         * @param {atendimento selecionado} modelo 
         * @param {$index tabela} index 
         */
        function selecionarAtendimento(modelo, index) {
            if (vm.indexAtendimentoSelecionado == index) {
                limparAtendimentoSelecionado();
            }
            else {
                vm.indexAtendimentoSelecionado = index;
                vm.atendimentoSelecionado = modelo;
            }

        }

        /**
         * Método que limpar os models vm.indexAtendimentoSelecionado e vm.atendimentoSelecionado
         */
        function limparAtendimentoSelecionado() {
            vm.indexAtendimentoSelecionado = null;
            vm.atendimentoSelecionado = {};
        }

        /**
         * Método chamado quando o model do radion group sobre alterações
         */
        function ngChangeRadioGroup() {
            // se o tipo do atendimento for igual a nova consulta o atendimento selecionado é limpo
            if (vm.tipoAtendimento == 1) {
                limparAtendimentoSelecionado();
            }
        }

        function retornarDescricaoDisplay(status) {
            return status == 1 ? "Aberto" : "Fechado";
        }

        function retornarSubstringAssunto(assunto) {
            return assunto.length <= 50 ? assunto : assunto.substr(0, 50) + "...";
        }

        /**
         * Método para fechar o dialog quando pressionado o "X" no toolbar do Dialog
         */
        function metodoDialogFecharDialog() {
            $mdDialog.hide();
        }
        //endregion

    } // CONTROLLER

})();

(function () {
    'use strict';

    angular
        .module('app.planejamentoScrum.processamento.sprint')
        .controller('SprintDialogInformacaoCalculoMetaController', SprintDialogInformacaoCalculoMetaController);

    function SprintDialogInformacaoCalculoMetaController($mdDialog) {
        var vm = this;

        vm.metodosDialog = {
            fecharDialog: fecharDialog
        }

        function fecharDialog() {
            $mdDialog.hide();
        }

    }

})();
(function () {
    'use strict';

    angular
        .module('app.planejamentoScrum.processamento.sprint')
        .controller('AcompanhamentoMetaDialogController', AcompanhamentoMetaDialogController);

    function AcompanhamentoMetaDialogController(
        $mdDialog,
        $rootScope,
        $scope,
        AbrirDialogEstoriaColaboradores,
        AbrirHistoria,
        AbrirDialogEstoriaPontuacao,
        AbrirDialogEstoriaSituacao,
        Api,
        HistoriaMeta,
        RequisicaoGenericaService,
        RotasHtml,
        SituacoesHistorias,
        SprintFactory,
        SprintNumero,
        SquadCodigo,
        Stack,
        TiposMeta,
        TotalizadoresPontosDesenvolvedor,
        TotalizadoresPontosStack,
        VerificaPontuacao
    ) {
        var vm = this;
        var filtrouPorTermo = false;
        vm.totalizadoresPontosStack = TotalizadoresPontosStack;
        vm.totalizadoresPontosDesenvolvedor = TotalizadoresPontosDesenvolvedor;
        vm.tiposMeta = TiposMeta;
        vm.stack = Stack;
        vm.situacoesHistorias = SituacoesHistorias;
        vm.pesquisarHistorias = "";
        vm.historiasMetasFiltradas = HistoriaMeta;
        vm.totalPontos = calcularTotalPontos([]);
        vm.coresSituacoes = SprintFactory.coresSituacoes();
        vm.requisicaoSolicitada = false;
        $rootScope.historiaMetasFiltradas = [];
        vm.tiposMetaSelecionadas = [];

        vm.totalHistoriasFiltradas = vm.historiasMetasFiltradas.length;

        vm.dtOptions = SprintFactory.setDtOptionsAcompanhamentoMetas();
        vm.dtOptions.columnDefs = SprintFactory.setColumnsDefsDtOptionsSprintMeta();
        vm.dtOptions.order = [];
        vm.dtOptions.initComplete = function () {
            var api = this.api(),
                searchBox = angular.element('body').find('#pesquisarHistoriasMeta'),
                htmCollection = document.getElementsByClassName('array-buttons-metas');

            var elemento = [];

            angular.forEach(htmCollection, function (key, value) {
                elemento.push(angular.element(key));
                elemento[value].click(function (event) {
                    var arrayFormatado = $rootScope.historiaMetasFiltradas.join("|");
                    api.column(8).search(arrayFormatado, true, false).draw();
                    filtrarHistoriasPorNumeroAno(api.rows({ search: 'applied' }).data().toArray());
                    vm.totalHistoriasFiltradas = angular.copy(api.page.info().recordsDisplay);
                    $scope.$digest();
                });
            });

            if (searchBox.length > 0) {
                searchBox.on('keyup', function (event) {
                    api.search(event.target.value).draw();
                    vm.totalHistoriasFiltradas = angular.copy(api.page.info().recordsDisplay);
                    filtrarHistoriasPorNumeroAno(api.rows({ search: 'applied' }).data().toArray());
                    vm.totalPontos = calcularTotalPontos([]);
                    if (event.target.value) filtrouPorTermo = true;
                    else filtrouPorTermo = false;
                    vm.totalPontos = calcularTotalPontos(vm.tiposMetaSelecionadas);
                    $scope.$digest();
                });
            }
        }

        vm.metodosDialog = {
            abrirHistoria: AbrirHistoria,
            abrirDialogHistoriasVinculadas: abrirDialogHistoriasVinculadas,
            abrirDialogEstoriaSituacao: AbrirDialogEstoriaSituacao,
            abrirDialogEstoriaColaboradores: AbrirDialogEstoriaColaboradores,
            abrirDialogEstoriaPontuacao: AbrirDialogEstoriaPontuacao,
            verificaPontuacao: VerificaPontuacao,
            filtrarMetasHistorias: filtrarMetasHistorias,
            abrirDialogEstoriaPriorizacao: abrirDialogEstoriaPriorizacao,
            fecharDialog: fecharDialog,
            abrirDialogPontosDesenvolvedor: abrirDialogPontosDesenvolvedor,
            atualizarTabela: atualizarTabela
        }

        function filtrarHistoriasPorNumeroAno(historiasFiltradasPorTermo) {
            var historiasFiltradasPorTermoFormatado = historiasFiltradasPorTermo.map(function (historia) {
                return {
                    codigo: historia[9],
                    numeroAno: historia[1],
                    descricao: historia[2]
                };
            });
            vm.historiasFiltradasPorTermo = vm.historiasMetasFiltradas.filter(function (historiasMeta) {
                return historiasFiltradasPorTermoFormatado.some(function (historiaFiltrada) {
                    return historiasMeta.codigo.toString() === historiaFiltrada.codigo.toString();
                });
            });
        }

        function filtrarMetasHistorias(metasHistorias) {
            if (metasHistorias.codigo != 4) {
                if ($rootScope.historiaMetasFiltradas.indexOf(metasHistorias.codigo) === -1) {
                    $rootScope.historiaMetasFiltradas.push(metasHistorias.codigo);
                }
                else {
                    $rootScope.historiaMetasFiltradas.splice(
                        $rootScope.historiaMetasFiltradas.indexOf(metasHistorias.codigo), 1);
                }
            } else {
                $rootScope.historiaMetasFiltradas = [];
            }
            vm.tiposMetaSelecionadas = $rootScope.historiaMetasFiltradas;
            vm.totalPontos = calcularTotalPontos($rootScope.historiaMetasFiltradas);
        }


        vm.filtroSelecionado = function (codigo) {
            if (codigo === 4) {

                return $rootScope.historiaMetasFiltradas.length === 0;
            }
            return $rootScope.historiaMetasFiltradas.includes(codigo) || (
                $rootScope.historiaMetasFiltradas.length === 0 && codigo === 4);
        };

        function abrirDialogEstoriaPriorizacao(event, historiaMeta) {
            $mdDialog.show({
                controller: "SprintDialogBacklogPriorizacaoController",
                controllerAs: "vm",
                templateUrl: RotasHtml.sprint.tabBacklog.dialogPriorizacao,
                targetEvent: event,
                multiple: true,
                clickOutsideToClose: false,
                locals: {
                    BacklogItem: historiaMeta
                }
            }).then(function (houveAlteracao) {
                if (houveAlteracao) {
                    RequisicaoGenericaService.listarComParams(Api.sprint.meta.acompanhamentoMeta + SprintNumero).then(
                        function (success) {
                            vm.historiasMetasFiltradas = success.data.backlog;
                        }
                    );
                }
            });
        }

        function abrirDialogHistoriasVinculadas(historiaMeta) {
            var dadosHistoria = {
                numero: historiaMeta.estoria.numero,
                ano: historiaMeta.estoria.ano,
                squadCodigo: historiaMeta.estoria.squadCodigo
            };

            RequisicaoGenericaService.listarSemParams(
                Api.estoria.historiasVinculadas.listarHistoriasVinculadas + '/' + dadosHistoria.numero + '/' + dadosHistoria.ano + '/' + dadosHistoria.squadCodigo)
                .then(function (success) {
                    $mdDialog.show({
                        controller: "HistoriasVinculadasDialogController",
                        controllerAs: "vm",
                        templateUrl: 'app/main/planejamento-scrum/processamento/estoria/views/tabs/estoria/dialogs/historias-vinculadas-dialog/historias-vinculadas-dialog.html',
                        targetEvent: event,
                        multiple: true,
                        clickOutsideToClose: false,
                        locals: {
                            Dados: success.data,
                            HistoriaFiltrada: dadosHistoria
                        }
                    }).then(function (houveAlteracoes) {
                        if (houveAlteracoes) {
                            RequisicaoGenericaService.listarComParams(Api.sprint.meta.acompanhamentoMeta + SprintNumero).then(
                                function (success) {
                                    vm.historiasMetasFiltradas = success.data.backlog;
                                }
                            );
                        }
                    });
                }, function (error) {
                    MdDialogService.alertPadrao(error.data);
                })
        }

        function calcularTotalPontos(codigosTipoMetaExibirComoHoje) {
            let totalPontos = 0;
            if (filtrouPorTermo) {
                if (codigosTipoMetaExibirComoHoje.length === 0) {
                    vm.historiasFiltradasPorTermo.forEach(function (historiaMeta) {
                        totalPontos += historiaMeta.pontuacaoRestante;
                    });
                } else {
                    vm.historiasFiltradasPorTermo.forEach(function (historiaMeta) {
                        if (codigosTipoMetaExibirComoHoje.includes(historiaMeta.estoria.codigoTipoMeta)) {
                            totalPontos += historiaMeta.pontuacaoRestante;
                        }
                    });
                }
            } else {
                if (codigosTipoMetaExibirComoHoje.length === 0) {
                    totalPontos = vm.totalizadoresPontosStack.reduce(function (total, stack) {
                        return total + (stack.totalPontos || 0);
                    }, 0);
                } else {
                    vm.historiasMetasFiltradas.forEach(function (historiaMeta) {
                        if (codigosTipoMetaExibirComoHoje.includes(historiaMeta.estoria.codigoTipoMeta)) {
                            totalPontos += historiaMeta.pontuacaoRestante;
                        }
                    });
                }
            }

            return totalPontos;
        }


        function abrirDialogPontosDesenvolvedor() {
            $mdDialog.show({
                controller: "PontosDesenvolvedorDialogController",
                controllerAs: "vm",
                templateUrl: RotasHtml.sprint.tabMeta.dialogPontosDesenvolvedor,
                clickOutsideToClose: false,
                multiple: true,
                locals: {
                    TotalizadoresPontosDesenvolvedor: vm.totalizadoresPontosDesenvolvedor,
                }
            });
            if (codigosTipoMetaExibirComoHoje.length === 0 && filtrouPorTermo) {
                return vm.historiasMetasFiltradas.reduce(function (total, historiaMeta) {
                    return total + (historiaMeta.pontuacaoRestante || 0);
                }, 0);
            }

            if (codigosTipoMetaExibirComoHoje.length === 0) {
                return vm.totalizadoresPontosStack.reduce(function (total, stack) {
                    return total + (stack.totalPontos || 0);
                }, 0);
            }

            return vm.historiasMetasFiltradas.reduce(function (totalPontos, historiaMeta) {
                if (codigosTipoMetaExibirComoHoje.includes(historiaMeta.estoria.codigoTipoMeta)) {
                    return totalPontos + historiaMeta.pontuacaoRestante;
                }
                return totalPontos;
            }, 0);
        }

        function abrirDialogPontosDesenvolvedor() {
            var tiposMetaParams = vm.tiposMetaSelecionadas
                .map(function (tipo) {
                    return 'tipoMeta=' + tipo;
                })
                .join('&');

            var url = Api.sprint.meta.listarPorDesenvolvedor + '?' +
                'sprint=' + SprintNumero +
                '&squadCodigo=' + SquadCodigo;

            if (tiposMetaParams) {
                url += '&' + tiposMetaParams;
            }

            RequisicaoGenericaService.listarSemParams(url)
                .then(
                    function (sucess) {
                        $mdDialog.show({
                            controller: "PontosDesenvolvedorDialogController",
                            controllerAs: "vm",
                            templateUrl: RotasHtml.sprint.tabMeta.dialogPontosDesenvolvedor,
                            clickOutsideToClose: false,
                            multiple: true,
                            locals: {
                                TotalizadoresPontosDesenvolvedor: sucess.data,
                            }
                        });
                    }
                )
        }

        function atualizarTabela() {
            vm.requisicaoSolicitada = true;
            RequisicaoGenericaService.listarSemParams(Api.sprint.meta.acompanhamentoMeta + '/' + SprintNumero + '/' + SquadCodigo).then(
                function (success) {
                    vm.requisicaoSolicitada = false;
                    vm.desabilitarBotao = false;
                    $rootScope.historiaMetasFiltradas = [];
                    vm.historiasMetasFiltradas = success.data.backlog;
                    vm.totalizadoresPontosStack = success.data.totalizadoresPontosStack;
                    vm.totalizadoresPontosDesenvolvedor = success.data.totalizadoresPontosDesenvolvedor;
                    vm.totalPontos = calcularTotalPontos([]);
                    vm.totalHistoriasFiltradas = vm.historiasMetasFiltradas.length;
                });
        }

        function fecharDialog() {
            $mdDialog.hide();
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('app.planejamentoScrum.processamento.sprint')
        .controller('SprintDialogEstatisticasVisualizarEstoriasController', SprintDialogEstatisticasVisualizarEstoriasController);


    function SprintDialogEstatisticasVisualizarEstoriasController(
        NumeroSprint,
        SprintSquadCodigo,
        TipoRetorno,
        ListaHistorias,
        Api,
        $mdDialog,
        $state,
        DatatableFactory,
        RequisicaoGenericaService,
        MdDialogService,
        EstoriaFactory
    ) {
        var vm = this;

        vm.coresSituacoes = EstoriaFactory.coresSituacoes();
        vm.metodosDialog = {
            abrirEstoria: abrirEstoria,
            fecharDialog: fecharDialog
        };

        init();

        function init() {
            var codigoRetorno;
            vm.dtOptionsVisualizarEstorias = angular.copy(DatatableFactory.construirDtOptionsComPaginacaoResponsivoPadrao([]));

            if (TipoRetorno == 1) {
                vm.titulo = "Histórias retornadas por erro";
                codigoRetorno = 13;
                vm.dtOptionsVisualizarEstorias.columnDefs = [{
                    targets: 2,
                    ordering: false,
                    sortable: false,
                }];
            }
            else if (TipoRetorno == 2) {
                vm.titulo = "Pontos perdidos por história"
                vm.tipoRetorno = TipoRetorno;
                codigoRetorno = 13 + '/' + true
                vm.dtOptionsVisualizarEstorias.columnDefs = [{
                    targets: 4,
                    ordering: false,
                    sortable: false,
                }];
            }
            else if (TipoRetorno == 3) {
                vm.titulo = "Histórias retornadas por melhoria";
                codigoRetorno = 12;
                vm.dtOptionsVisualizarEstorias.columnDefs = [{
                    targets: 2,
                    ordering: false,
                    sortable: false,
                }];
            }
            else if (TipoRetorno == 6) {
                vm.titulo = "Histórias desenvolvidas";
                vm.historiasDesenvolvidas = true;
                vm.dtOptionsVisualizarEstorias.columnDefs = [{
                    targets: 3,
                    ordering: false,
                    sortable: false,
                }];
            }

            if (ListaHistorias.length > 0) {
                vm.historiasEstatistica = ListaHistorias;
                vm.dtOptionsVisualizarEstorias.order = [];
            } else {
                vm.requisicaoSolicitada = true;
                RequisicaoGenericaService.listarSemParams(Api.sprint.estatistica.listarEstatisticaPorStatus + '/' + NumeroSprint + '/' + SprintSquadCodigo + '/' + codigoRetorno)
                    .then(
                        function (success) {
                            vm.requisicaoSolicitada = false;
                            vm.historiasEstatistica = success.data;
                        },
                        function (error) {
                            vm.requisicaoSolicitada = false;
                            MdDialogService.alertPadrao("Atenção!", null, error.data);
                        }
                    );
            }
        }

        function abrirEstoria(historia) {
            $state.goNewTab("app.planejamento_processamento_estoria", {
                parametros: {
                    numero: historia.numeroHistoria,
                    ano: historia.anoHistoria,
                    squadCodigo: historia.squadCodigo,
                    chamarPesquisa: true
                }
            });
        }

        function fecharDialog() {
            $mdDialog.hide();
        }

    }

})();

/**
 * Created by nova on 26/10/2016.
 */
(function () {
    'use strict';

    angular
        .module('app.planejamentoScrum.processamento.sprint')
        .controller('SprintDialogBacklogSituacaoController', SprintDialogBacklogSituacaoController);

    function SprintDialogBacklogSituacaoController(
        Api,
        Index,
        RequisicaoGenericaService,
        Situacao,
        MdToastService,
        $mdDialog,
        MdDialogService,
        Estoria,
        Situacoes,
        LoginUsuarioService,
        DataTableConfigPadrao,
        EstoriaFactory,
        EstoriaBacklog
    ) {
        var vm = this;
        vm.form = {};
        vm.requisicaoSolicitada = false;
        vm.titulo = "Situação";
        vm.estorias = Estoria;
        vm.Backlog = EstoriaBacklog;
        vm.motivoCodigo = Estoria.motivoCodigo;
        // Data region
        vm.historicoSituacao = angular.copy(Situacao);

        if (vm.historicoSituacao.situacao.codigo !== 15) {
            vm.situacoes = angular.copy(Situacoes).filter(function (situacao) {
                return situacao.codigo !== 15;
            });
        } else {
            vm.situacoes = angular.copy(Situacoes);
        }

        if (vm.Backlog == null) {
            vm.rotinaProductBacklog = true;
        }

        //endregion
        if (vm.rotinaProductBacklog) {
            vm.historicoSituacao = angular.copy(Estoria);
            RequisicaoGenericaService.listarSemParams(
                Api.estoria.historico.listarPor +
                vm.historicoSituacao.numero +
                "/" +
                vm.historicoSituacao.ano +
                "/" +
                vm.historicoSituacao.squadCodigo +
                "/" +
                null
            ).then(function (success) {
                vm.listaEstoriaHistoricoSituacao = success.data;
            });
        } else {
            RequisicaoGenericaService.listarSemParams(
                Api.estoria.historico.listarPor +
                vm.historicoSituacao.estoriaNumero +
                "/" +
                vm.historicoSituacao.estoriaAno +
                "/" +
                vm.historicoSituacao.estoriaSquadCodigo +
                "/" +
                null
            ).then(function (success) {
                vm.listaEstoriaHistoricoSituacao = success.data;
            });
        }
        // Definição dos Métodos region
        vm.dtOptionsHistoricoSituacao = angular.copy(
            DataTableConfigPadrao.dtOptionsResponsivoSemPaginacaoComInitComplete
        );
        vm.dtOptionsHistoricoSituacao.columnDefs = EstoriaFactory.setColumnsDefsEstoriaHistoricoSituacao();
        vm.metodosDialog = {
            fecharDialog: metodoDialogFecharDialog,
            buscaPontosInicias: buscaPontosInicias,
            salvar: salvar
        };

        //endregion
        if (!vm.rotinaProductBacklog) {
            if (vm.historicoSituacao.situacao.descricao == "Homologada") {
                vm.historicoSituacao.pontosEntregue = vm.Backlog.pontuacaoEntregue;
                buscaPontosInicias(vm.historicoSituacao.situacao.descricao,
                    vm.historicoSituacao.estoriaNumero,
                    vm.historicoSituacao.estoriaAno
                );
            }
        }
        // Implementação dos Métodos region

        // Implementação dos Métodos Dialog region
        function salvar(event, historicoSituacao) {
            if (vm.rotinaProductBacklog) {
                var historicoSituacaoTemporario = {
                    data: new Date(),
                    situacaoCodigo: historicoSituacao.situacao.codigo,
                    usuarioCodigo: LoginUsuarioService.usuarioArmazenado().codigo,
                    estoriaNumero: historicoSituacao.numero,
                    estoriaAno: historicoSituacao.ano,
                    estoriaSquadCodigo: historicoSituacao.squadCodigo,
                    observacaoMotivoPausa: historicoSituacao.situacao.exigeMotivo
                        ? historicoSituacao.observacaoMotivoPausa
                        : null
                };
            } else {
                var historicoSituacaoTemporario = {
                    data: new Date(),
                    situacaoCodigo: historicoSituacao.situacao.codigo,
                    usuarioCodigo: LoginUsuarioService.usuarioArmazenado().codigo,
                    estoriaNumero: historicoSituacao.estoriaNumero,
                    estoriaAno: historicoSituacao.estoriaAno,
                    estoriaSquadCodigo: historicoSituacao.estoriaSquadCodigo,
                    observacaoMotivoPausa: historicoSituacao.situacao.exigeMotivo
                        ? historicoSituacao.observacaoMotivoPausa
                        : null,
                    pontosEntregue: historicoSituacao.pontosEntregue
                };
            }
            vm.requisicaoSolicitada = true;
            RequisicaoGenericaService.salvar(
                Api.estoria.historico.criar,
                historicoSituacaoTemporario
            ).then(
                function (success) {
                    MdToastService.toastPadrao("Situação cadastrada com sucesso!");
                    vm.houveAlteracao = true;
                    if (vm.rotinaProductBacklog) {
                        Estoria.situacaoCodigo = success.data.situacao.codigo;
                        Estoria.situacao = success.data.situacao;
                        Estoria.situacaoDescricao = success.data.situacao.descricao;
                        Estoria.observacaoMotivoPausa = success.data.observacaoMotivoPausa;
                    } else {
                        Situacao.situacaoCodigo = success.data.situacao.codigo;
                        Situacao.situacao = success.data.situacao;
                        Situacao.observacaoMotivoPausa = success.data.observacaoMotivoPausa;

                        vm.api = $("#datatable-backlog").DataTable();
                        $("#backlog-td-situacao" + Index).html(
                            ' <div class="border-bottom-historico">' +
                            Situacao.situacao.descricao +
                            "</div>"
                        );
                        vm.api
                            .cells("#backlog-td-situacao" + Index)
                            .invalidate()
                            .draw();
                    }

                    vm.requisicaoSolicitada = false;
                    $mdDialog.hide(vm.houveAlteracao);
                },
                function (error) {
                    vm.requisicaoSolicitada = false;
                    MdDialogService.alertPadrao("Atenção", event, error.data);
                }
            );
        }

        function metodoDialogFecharDialog() {
            $mdDialog.hide();
        }

        function buscaPontosInicias(situacao, numero, ano) {
            if (situacao == "Homologada") {
                RequisicaoGenericaService.listarSemParams(
                    Api.estoria.listarPontuacao + "?numero=" + numero + "&ano=" + ano + "&squadCodigo=" + vm.historicoSituacao.estoriaSquadCodigo
                ).then(
                    function (success) {
                        vm.historicoSituacao.pontosEntregue = success.data.pontuacaoEntregue;
                        vm.pontos = success.data.pontuacaoTotal;
                        vm.mensagemPreloader = "";
                        vm.requisicaoSolicitada = false;
                    },
                    function (error) {
                        MdDialogService.alertPadrao(error.data);
                        vm.mensagemPreloader = "";
                        vm.requisicaoSolicitada = false;
                    }
                );
            }
        }

        //endregion
        //endregion
    }

})();

/**
 * Created by nova on 26/10/2016.
 */
(function () {
    'use strict';

    angular
        .module('app.planejamentoScrum.processamento.sprint')
        .controller('SprintDialogBacklogEstimativaPontosController', SprintDialogBacklogEstimativaPontosController);

    function SprintDialogBacklogEstimativaPontosController($timeout, $rootScope, Api, LoginUsuarioService, RequisicaoGenericaService, RotasHtml, MdDialogService, MdToastService, $mdDialog,
        DataTableConfigPadrao, EstoriaFactory, BacklogItem) {
        var vm = this;
        ///////////////////////////////////////////////////////////////////// Data ////////////////////////////////////////////////////////////////
        vm.form = {};
        vm.titulo = "Pontuação";

        vm.requisicaoSolicitada = false;
        vm.htmlRota = RotasHtml;
        vm.backlogItem = angular.copy(BacklogItem);
        vm.estoria = angular.copy(vm.backlogItem.estoria);
        vm.backlogItem.estoria = null;
        vm.mensagemPreloader = "";
        vm.abrirDialoEditarTarefa = abrirDialoEditarTarefa;
        vm.dtOptions = EstoriaFactory.setDtOptionsTabTarefa(3, 4);
        vm.dtOptions.dom = 'rt';
        vm.dtOptions.order = [];
        vm.houveAlteracoes = false;

        vm.dtOptions.columnDefs = [
            {
                targets: 5,
                type: 'date-pt-br'
            },
            {
                targets: 6,
                type: 'date-pt-br'
            }
        ];


        init();
        ///////////////////////////////////////////////////////////////////// Fim Data ////////////////////////////////////////////////////////////////    

        //#region Broadcast


        $rootScope.$on("TarefaEditada", function (event, data) {
            vm.tarefas.forEach(function (item) {
                if (item.codigo == data.codigo) {
                    var indexItem = vm.tarefas.indexOf(item);
                    vm.tarefas.splice(indexItem, 1);
                    vm.tarefas.push(data);
                    _atualizaPontuacaoInicial(BacklogItem.estoriaNumero, BacklogItem.estoriaAno, BacklogItem.estoria.squadCodigo);
                }
            });
        });

        //#endregion Broadcast

        /////////////////////////////////////////////////////////////////// Definição dos Métodos /////////////////////////////////////////////////////
        vm.metodosInterno = {
            editar: editar
        };
        vm.metodosDialog = {
            fecharDialog: fecharDialog
        };


        /////////////////////////////////////////////////////////////////// Fim Definição dos Métodos /////////////////////////////////////////////////////


        /////////////////////////////////////////////////////////////////// Métodos Dialog  /////////////////////////////////////////////////////////

        /**
         * Método inicializador
         */
        function init() {
            vm.requisicaoSolicitada = true;
            vm.mensagemPreloader = "Pesquisando Tarefas ..."
            RequisicaoGenericaService.listarSemParams(Api.estoria.tarefa.listarPor
                + BacklogItem.estoriaNumero + "/" + BacklogItem.estoriaAno + "/" + BacklogItem.estoria.squadCodigo).then(
                    function (success) {
                        vm.tarefas = success.data;
                        _atualizaPontuacaoInicial(BacklogItem.estoriaNumero, BacklogItem.estoriaAno, BacklogItem.estoria.squadCodigo);
                        vm.mensagemPreloader = "";
                        vm.requisicaoSolicitada = false;
                    },
                    function (error) {
                        MdDialogService.alertPadrao(error.data);
                        vm.mensagemPreloader = "";
                        vm.requisicaoSolicitada = false;
                    });
        }


        function abrirDialoEditarTarefa(tarefa) {
            RequisicaoGenericaService.listarSemParams(Api.solucao_rotinas_tarefas.tarefas.listarTiposTarefas)
                .then(
                    function (success) {
                        $mdDialog.show({
                            controller: 'EstoriaDialogTarefasController',
                            controllerAs: 'vm',
                            multiple: true,
                            templateUrl: vm.htmlRota.estoria.tabTarefa.dialogTarefa,
                            //parent: ---------------,
                            targetEvent: event,
                            clickOutsideToClose: false,
                            locals: {
                                ControleForm: vm.controleForm,
                                UsuarioEstoriaLogado: LoginUsuarioService.usuarioArmazenado(),
                                Estoria: vm.estoria,
                                Tarefa: tarefa,
                                TiposTarefa: success.data,
                            }
                        }).then(
                            function (houveAlteracoes) {
                                vm.houveAlteracoes = houveAlteracoes;
                            }
                        )
                    },
                    function (error) {
                        MdDialogService.alertPadrao('Atenção! Erro ao listar tipos de tarefas.');
                    }

                )

        }

        /**
         * Método para editar a pontuação da estória
         * @param {event} event Evento do botão
         */
        function editar(event) {

            vm.requisicaoSolicitada = true;
            vm.mensagemPreloader = "Atualizando Pontuação ..."

            RequisicaoGenericaService.editar(Api.sprint.backlog.atualizar, vm.backlogItem).then(
                function (success) {
                    vm.mensagemPreloader = "";
                    BacklogItem.pontuacaoAtual = success.data.pontuacaoAtual;
                    BacklogItem.pontuacaoEntregue = success.data.pontuacaoEntregue;
                    _atualizaPontuacaoInicial(BacklogItem.estoriaNumero, BacklogItem.estoriaAno, BacklogItem.estoria.squadCodigo);
                    MdToastService.toastPadrao("Pontuação alterada com sucesso!");
                    vm.requisicaoSolicitada = false;
                    $mdDialog.hide();
                },
                function (error) {
                    vm.mensagemPreloader = "";
                    vm.requisicaoSolicitada = false;
                    alert("Falha ao editar a pontuação.\nDetalhes: " + error.data);
                });
        }

        function fecharDialog() {
            if (vm.houveAlteracoes) {
                BacklogItem.pontuacaoInicial = vm.backlogItem.pontuacaoInicial;
            }
            $mdDialog.hide();
        }

        function _atualizaPontuacaoInicial(numero, ano, squadCodigo) {
            vm.requisicaoSolicitada = true;
            vm.mensagemPreloader = "Atualizando Pontuação ..."

            RequisicaoGenericaService.listarSemParams(
                Api.estoria.listarPontuacao + "?numero=" + numero + "&ano=" + ano + "&squadCodigo=" + squadCodigo
            ).then(
                function (success) {
                    vm.backlogItem.pontuacaoInicial = success.data.pontuacaoTotal;
                    vm.backlogItem.pontuacaoEntregue = success.data.pontuacaoEntregue;

                    vm.mensagemPreloader = "";
                    vm.requisicaoSolicitada = false;
                },
                function (error) {
                    MdDialogService.alertPadrao(error.data);
                    vm.mensagemPreloader = "";
                    vm.requisicaoSolicitada = false;
                }
            );
        }
        /////////////////////////////////////////////////////////////////// Fim Métodos Dialog /////////////////////////////////////////////////////////
    } // CONTROLLER

})();

/**
 * Created by nova on 26/10/2016.
 */
(function () {
    'use strict';

    angular
        .module('app.planejamentoScrum.processamento.sprint')
        .controller('SprintDialogBacklogPriorizacaoController', SprintDialogBacklogPriorizacaoController);

    function SprintDialogBacklogPriorizacaoController(
        Api, RequisicaoGenericaService, MdDialogService, MdToastService, $mdDialog, BacklogItem) {
        var vm = this;

        vm.form = {};
        vm.titulo = "Priorização";
        vm.parseInt = parseInt;

        vm.backlogItem = angular.copy(BacklogItem);
        vm.backlogItem.squadCodigo = angular.copy(BacklogItem.estoria.squadCodigo);
        vm.estoria = angular.copy(vm.backlogItem.estoria);
        vm.backlogItem.estoria = null;

        vm.requisicaSolicitada = false;

        /**
         * Método inicializador
         */
        init();

        vm.metodosDialog = {
            editar: editar,
            fecharDialog: fecharDialog
        };

        function init() {
            vm.requisicaoSolicitada = true;

            RequisicaoGenericaService.listarSemParams(Api.display.listarPriorizacaoEstoria).then(
                function (success) {
                    vm.requisicaoSolicitada = false;

                    vm.dificuldades = success.data.dificuldade;
                    vm.origens = success.data.origem;
                    vm.criticidades = success.data.criticidade;
                },
                function (error) {
                    vm.requisicaoSolicitada = false;
                    alert("Falha ao editar a priorização.\nDetalhes: " + error.data);
                });
        }

        function editar(event) {
            vm.requisicaoSolicitada = true;

            RequisicaoGenericaService.editar(Api.sprint.backlog.atualizar, vm.backlogItem).then(
                function (success) {
                    BacklogItem.dificuldade = success.data.dificuldade;
                    BacklogItem.origem = success.data.origem;
                    BacklogItem.criticidade = success.data.criticidade;
                    BacklogItem.businessValue = success.data.businessValue;
                    vm.houveAlteracao = true;

                    MdToastService.toastPadrao("Priorização alterada com sucesso!");
                    vm.requisicaoSolicitada = false;

                    fecharDialog();
                },
                function (error) {
                    vm.requisicaoSolicitada = false;
                    alert("Falha ao editar a priorização.\nDetalhes: " + error.data);
                });
        }

        function fecharDialog() {
            $mdDialog.hide(vm.houveAlteracao);
        }
    }

})();

/**
 * Created by nova on 26/10/2016.
 */
(function () {
  'use strict';

  angular
    .module('app.planejamentoScrum.processamento.sprint')
    .controller('SprintDialogBacklogHorasController', SprintDialogBacklogHorasController);

  function SprintDialogBacklogHorasController($mdDialog, Estoria){
    var vm = this;

    // Data region
    vm.titulo = "Estimativa de horas das Tarefas";
    
    vm.estoria = angular.copy(Estoria);

    if(!vm.estoria.horasRestanteDesenvolvimento){
      vm.estoria.horasRestanteDesenvolvimento = "00:00";
    }
    if(!vm.estoria.horasRestanteTesteDesenvolvimento){
      vm.estoria.horasRestanteTesteDesenvolvimento = "00:00";
    }
    if(!vm.estoria.horasRestantesTestes){      
      vm.estoria.horasRestantesTestes = "00:00";
    }
    if(!vm.estoria.horasRestanteTotais){      
      vm.estoria.horasRestanteTotais = "00:00";
    }

    vm.requisicaoSolicitada = false;
    //endregion

    // Definição dos Métodos region
    vm.metodosDialog = {
      fecharDialog: fecharDialog,
    };
    //endregion

    // Implementação dos Métodos region
    function fecharDialog() {
      $mdDialog.hide();
    }
    //endregion
  }

})();

(function () {
    'use strict';

    angular
        .module('app.planejamentoScrum.processamento.sprint')
        .controller('SprintDialogBacklogColaboradoresController', SprintDialogBacklogColaboradoresController);

    function SprintDialogBacklogColaboradoresController(
        $mdDialog,
        Api,
        RequisicaoGenericaService,
        MdToastService,
        MdDialogService,
        Estoria
    ) {
        var vm = this;

        vm.form = {};
        vm.titulo = "Colaboradores";
        vm.estoria = angular.copy(Estoria);
        vm.requisicaoSolicitada = false;

        vm.metodosDialog = {
            fecharDialog: fecharDialog,
            salvar: salvar,
            alteraDesenvolvedor: alteraDesenvolvedor,
            changeCodigoDesenvolvedor: changeCodigoDesenvolvedor,
            changeCodigoTester: changeCodigoTester
        };

        init();

        function init() {
            vm.requisicaoSolicitada = true;
            RequisicaoGenericaService.listarSemParams(Api.setor.listarDesenvolvedores).then(
                function (success) {
                    _retornarSituacaoAtualHistoria();
                    vm.usuariosSetorDesenvolvimentoBkp = success.data
                    vm.usuariosSetorDesenvolvimento = angular.copy(vm.usuariosSetorDesenvolvimentoBkp);
                    vm.requisicaoSolicitada = false;

                    var desenvolvedorHistoria = {
                        codigo: vm.estoria.codigoDesenvolvedor,
                        nome: vm.estoria.desenvolvedorNome
                    };

                    var temNaLista = false;
                    if (desenvolvedorHistoria != null) {
                        vm.usuariosSetorDesenvolvimento[0].usuarios.forEach(function (item) {
                            if (item.codigo == desenvolvedorHistoria.codigo) {
                                temNaLista = true;
                            }
                        });

                        if (!temNaLista) {
                            if (desenvolvedorHistoria.codigo) {
                                desenvolvedorHistoria.login = vm.estoria.desenvolvedorNome.toUpperCase();
                                vm.usuariosSetorDesenvolvimento[0].usuarios.push(desenvolvedorHistoria);
                            }
                        }
                    }
                });

            RequisicaoGenericaService.listarSemParams(Api.setor.listarTesters).then(
                function (success) {
                    vm.usuariosSetorTestesBkp = success.data;
                    vm.usuariosSetorTestes = angular.copy(vm.usuariosSetorTestesBkp);
                    vm.requisicaoSolicitada = false;

                    var testerHistoria = {
                        codigo: vm.estoria.codigoTester,
                        nome: vm.estoria.testerNome
                    };
                    var temNaLista = false;
                    if (testerHistoria != null) {
                        vm.usuariosSetorTestes[0].usuarios.forEach(function (item) {
                            if (item.codigo == testerHistoria.codigo) {
                                temNaLista = true;
                            }
                        });

                        if (!temNaLista) {
                            if (testerHistoria.codigo) {
                                testerHistoria.login = vm.estoria.testerNome.toUpperCase();
                                vm.usuariosSetorTestes[0].usuarios.push(testerHistoria);
                            }
                        }
                    }
                });
        }

        function salvar() {
            vm.requisicaoSolicitada = true;
            RequisicaoGenericaService.editar(Api.estoria.atualizarColaboradores, vm.estoria).then(
                function (success) {
                    if (success.data.desenvolvedor == undefined)
                        Estoria.desenvolvedorNome = "Sem desenvolvedor";
                    else
                        Estoria.desenvolvedorNome = success.data.desenvolvedor.nome;
                    if (success.data.tester == undefined)
                        Estoria.testerNome = "Sem tester";
                    else
                        Estoria.testerNome = success.data.tester.nome;
                    Estoria.codigoDesenvolvedor = vm.estoria.codigoDesenvolvedor;
                    Estoria.codigoTester = vm.estoria.codigoTester;
                    MdToastService.toastPadrao("Colaborador(es) alterado(s) com sucesso!");

                    vm.requisicaoSolicitada = false;

                    $mdDialog.hide();
                },
                function (error) {
                    vm.requisicaoSolicitada = false;
                    MdDialogService.alertPadrao("Atenção", null, "Falha ao editar os colaboradores.\nDetalhes: " + error.data);
                });
        }

        function fecharDialog() {
            $mdDialog.hide();
        }

        function alteraDesenvolvedor(nome) {
            Estoria.desenvolvedorNome = nome;
        }

        function changeCodigoDesenvolvedor(valor) {
            if (!valor) {
                vm.form.colaboradores.dialogBacklogColaboradoresDesenvolvedor.$touched = true;
            }
        }

        function changeCodigoTester(valor) {
            if (!valor) {
                vm.form.colaboradores.dialogBacklogColaboradoresTester.$touched = true;
            }
        }

        function _retornarSituacaoAtualHistoria() {
            RequisicaoGenericaService.listarSemParams(Api.estoria.historico.listarPor + vm.estoria.numero + '/' + vm.estoria.ano +
                "/" +
                null).
                then(function (success) {
                    vm.exigeInsercaoDesenvolvedor = success.data.some(function (item) {
                        return item.situacaoCodigo == 6;
                    }) ? true : false;

                    vm.exigeInsercaoTester = success.data.some(function (item) {
                        return item.situacaoCodigo == 8;
                    }) ? true : false;
                }, function (error) {
                    console.log(error.data);
                });
        }
    }
})();
/**
 * Created by nova on 26/10/2016.
 */
(function () {
  'use strict';

  angular
    .module('app.planejamentoScrum.processamento.sprint')
    .controller('SprintDialogBacklogAdicionarEstoriaEspecificaController', SprintDialogBacklogAdicionarEstoriaEspecificaController);

  function SprintDialogBacklogAdicionarEstoriaEspecificaController(Api, RequisicaoGenericaService, MdDialogService, MdToastService, $mdDialog, Sprint) {

    var vm = this;

    // Data region
    vm.estorias = [];
    vm.form = {};
    vm.filtrarEstorias = "";
    vm.titulo = "Adicionar história no backlog";

    vm.requisicaoSolicitada = false;
    //endregion

    // Resolve region
    var sprintNumero = Sprint.numero;
    var sprintSquadCodigo = Sprint.squadCodigo;
    //endregion

    // Definição dos Métodos region
    vm.metodosDialog = {
      configurarMdSelectEstoria: configurarMdSelectEstoria,
      salvar: salvar,
      fecharDialog: fecharDialog,
    };
    init();
    //endregion

    // Implementação dos Métodos region
    function init() {
      vm.requisicaoSolicitada = true;
      RequisicaoGenericaService.listarSemParams(Api.estoria.listarEstoriasSemSprintBacklog + sprintNumero + "/" + sprintSquadCodigo).then(
        function (success) {
          angular.forEach(success.data, function (item, index) {
            vm.estorias.push(item.numero + "/" + item.ano);
          });
          vm.requisicaoSolicitada = false;
        }, function (error) { vm.requisicaoSolicitada = false; });
    }
    // Métodos Dialog region
    function configurarMdSelectEstoria() {
      vm.filtrarEstorias = "";
      angular.element('#sprint-dialog-backlog-adicionar-estorias-especificas-md-select').on('keydown', function (ev) {
        ev.stopPropagation();
      });
    }

    function salvar(event, estoria) {
      var estoriaConvertidaNumeroAno = estoria.split('/');
      var estoriaTemporaria = [
        {
          estoriaNumero: estoriaConvertidaNumeroAno[0],
          estoriaAno: estoriaConvertidaNumeroAno[1],
          sprintNumero: sprintNumero,
          squadCodigo: sprintSquadCodigo
        }];
      vm.requisicaoSolicitada = true;
      RequisicaoGenericaService.salvar(Api.sprint.backlog.criar, estoriaTemporaria).then(
        function (success) {
          Sprint.backlogEstorias = success.data;

          MdToastService.toastPadrao("História cadastrada no backlog com sucesso !");

          vm.requisicaoSolicitada = false;
          $mdDialog.hide();
        },
        function (error) {
          vm.requisicaoSolicitada = false;
          alert("Falha ao cadastrar a história no backlog.\nDetalhes: " + error.data);
        });
    }

    function fecharDialog() {
      $mdDialog.hide();
    }
    //endregion

    //endregion
  }

})();

/**
 * Created by nova on 23/08/2016.
 */
(function () {
    'use strict';

    angular
        .module('app.planejamentoScrum.processamento.estoria', ['ui.grid.resizeColumns'])
        .config(config);

    function config($stateProvider, RotasHtml) {
        var rotasHtmlEstoria = RotasHtml.estoria;
        $stateProvider
            .state('app.planejamento_processamento_estoria', {
                url: '/planejamento/processamento/estoria',
                module: 'privado',
                params: {
                    parametros: null,
                    parametrosSolicitacao: null
                },
                views: {
                    'content@app': {
                        templateUrl: rotasHtmlEstoria.templateUrl,
                        controller: 'EstoriaController as vm'
                    },
                    'estoria-form@app.planejamento_processamento_estoria': {
                        templateUrl: rotasHtmlEstoria.form
                    },
                    'estorias-tabela@app.planejamento_processamento_estoria': {
                        templateUrl: rotasHtmlEstoria.tabela
                    }
                },
                resolve: {
                    ListarTodosClientes: function (Api, RequisicaoGenericaService) {
                        return RequisicaoGenericaService.listarSemParams(Api.cliente.listarCodigoDescricao);
                    },
                    ListarTodasSolucoes: function (Api, RequisicaoGenericaService) {
                        return RequisicaoGenericaService.listarSemParams(Api.solucao_rotinas_tarefas.solucao.listarCodigoDescricao);
                    },
                    ListarTodosMotivos: function (Api, RequisicaoGenericaService) {
                        return RequisicaoGenericaService.listarSemParams(Api.motivo.listarTodos);
                    },
                    ListarTodosUsuarios: function (Api, RequisicaoGenericaService) {
                        return RequisicaoGenericaService.listarSemParams(Api.usuario.detalhes_usuario.listarUsuariosAtivos);
                    },
                    ListarTodasSituacoes: function (Api, RequisicaoGenericaService) {
                        return RequisicaoGenericaService.listarSemParams(Api.situacao.listarTodos);
                    },
                    ListarTodasOrigens: function (Api, RequisicaoGenericaService) {
                        return RequisicaoGenericaService.listarSemParams(Api.estoria.origens.listar);
                    },
                    TiposTarefas: function (Api, RequisicaoGenericaService) {
                        return RequisicaoGenericaService.listarSemParams(Api.solucao_rotinas_tarefas.tarefas.listarTiposTarefas);
                    },
                    ListarDesenvolvedoresAtivos: function (Api, RequisicaoGenericaService) {
                        return RequisicaoGenericaService.listarSemParams(Api.setor.listarDesenvolvedores);
                    },
                    ListarTestersAtivos: function (Api, RequisicaoGenericaService) {
                        return RequisicaoGenericaService.listarSemParams(Api.setor.listarTesters);
                    },
                    ListarNecessidadesCliente: function (Api, RequisicaoGenericaService) {
                        return RequisicaoGenericaService.listarSemParams(Api.display.listarNecessidadeCliente);
                    },
                    ListarTodosCustosSoftwares: function (Api, RequisicaoGenericaService) {
                        return RequisicaoGenericaService.listarSemParams(Api.custo_software.custo.listar);
                    },
                    ListarTodosTiposHistoria: function (Api, RequisicaoGenericaService) {
                        return RequisicaoGenericaService.listarSemParams(Api.tipo_historia.listarTodos);
                    },
                    ListarTiposHistoriaAtivos: function (Api, RequisicaoGenericaService) {
                        return RequisicaoGenericaService.listarSemParams(Api.tipo_historia.listarAtivos);
                    },
                    ListarUsuarioPorDetalhe: function (Api, RequisicaoGenericaService, LoginUsuarioService) {
                        return RequisicaoGenericaService.listarSemParams(Api.usuario.detalhes_usuario.listarDetalhesUsuario
                            + LoginUsuarioService.usuarioArmazenado().codigo);
                    }
                }
            });
    }

})();

/**
 * Created by nova on 26/10/2016.
 */
(function () {
    'use strict';

    angular
        .module('app.planejamentoScrum.processamento.estoria')
        .controller('EstoriaDialogTarefaAlterarCampoController', EstoriaDialogTarefaAlterarCampoController);

    function EstoriaDialogTarefaAlterarCampoController(Api, RequisicaoGenericaService, MdToastService, $mdDialog, MdDialogService, UsuarioEstoriaLogado, Estoria, 
        Tarefa, CampoTarefaASerEditado, ServicosGenericoService) {

        var vm = this;
        vm.form = {};
        vm.requisicaoSolicitada = false;

        // Data region
        vm.campoTarefaASerEditado = angular.copy(CampoTarefaASerEditado);
        vm.usuarioEstoriaLogado = UsuarioEstoriaLogado;
        vm.tarefa = angular.copy(Tarefa);
        vm.titulo = "Editando Tarefa";

        if (vm.campoTarefaASerEditado === 'dataHoraInicio') {
            if (vm.tarefa.dataHoraInicio) {
                vm.tarefa.dataHoraInicio = new Date(vm.tarefa.dataHoraInicio);
            } else {
                vm.tarefa.dataHoraInicio = new Date();
            }
            if (vm.tarefa.dataHoraFim) {
                vm.tarefa.dataHoraFim = new Date(vm.tarefa.dataHoraFim);
            }
        }

        if (vm.campoTarefaASerEditado === 'dataHoraFim') {
            if (vm.tarefa.dataHoraFim) {
                vm.tarefa.dataHoraFim = new Date(vm.tarefa.dataHoraFim);
            } else {
                vm.tarefa.dataHoraFim = new Date();
            }
            if (vm.tarefa.dataHoraInicio) {
                vm.tarefa.dataHoraInicio = new Date(vm.tarefa.dataHoraInicio);
            }
        }


        if (vm.campoTarefaASerEditado === 'usuario') {
            if (!vm.tarefa.usuarioCodigo) {
                vm.tarefa.usuarioCodigo = vm.usuarioEstoriaLogado.codigo;
            }
        }
        //endregion

        // Definição dos Métodos region
        vm.metodosDialog = {
            fecharDialog: metodoDialogFecharDialog,
            salvarAlteracoes: salvarAlteracoes
        }

        //endregion

        // Implementação dos Métodos region

        // Implementação dos Métodos Dialog region
        function salvarAlteracoes(event, tarefa) {
            tarefa.data = ServicosGenericoService.retornaHoraFormataComTempo(tarefa.data);
            delete tarefa.usuario;
            vm.requisicaoSolicitada = true;
            RequisicaoGenericaService.editar(Api.estoria.tarefa.atualizar, tarefa).then(
                function (success) {
                    MdToastService.toastPadrao("Tarefa editada com sucesso!");

                    angular.forEach(Estoria.tarefas, function (item, index) {
                        if (item.codigo === success.data.codigo) {
                            Estoria.tarefas[index] = success.data;
                        }
                    });

                    vm.requisicaoSolicitada = false;
                    $mdDialog.hide();
                },
                function (error) {
                    vm.requisicaoSolicitada = false;
                    alert(error.data);
                });
        }

        function metodoDialogFecharDialog() {
            $mdDialog.hide();
        }
        //endregion
        //endregion
    }

})();

(function () {
    'use strict';

    angular
        .module('app.planejamentoScrum.processamento.estoria')
        .controller('HistoriasVinculadasDialogController', HistoriasVinculadasDialogController);

    function HistoriasVinculadasDialogController(
        Dados,
        HistoriaFiltrada,
        $mdDialog,
        $q,
        $state,
        $timeout,
        DataTableConfigPadrao,
        EstoriaFactory,
        RequisicaoGenericaService,
        MdDialogService,
        Api) {
        var vm = this;
        vm.stacks = [
            {
                codigo: 1,
                descricao: "Back-end",
            },
            {
                codigo: 2,
                descricao: "Front-end",
            },
            {
                codigo: 3,
                descricao: "Mobile",
            },
            {
                codigo: 4,
                descricao: "Infraestrutura",
            },
            {
                codigo: 5,
                descricao: "Full-stack",
            },
        ];
        init();

        vm.metodos = {
            fecharDialog: fecharDialog,
            configurarMdSelectHistoriasVinculadas: configurarMdSelectHistoriasVinculadas,
            salvarHistoriasVinculadas: salvarHistoriasVinculadas,
            pesquisarAutoComplete: pesquisarAutoComplete,
            alterarItemSelecionadoAutoComplete: alterarItemSelecionadoAutoComplete,
            configuraAutoCompleteOnBlur: configuraAutoCompleteOnBlur,
            abrirHistoria: abrirHistoria,
            excluirHistoria: excluirHistoria
        }

        function init() {
            vm.dados = Dados;
            vm.historiaFiltrada = HistoriaFiltrada;
            vm.historiasVinculadasBckp = angular.copy(vm.dados.historiasVinculadas);
            vm.houveAlteracoes = false;
            vm.coresSituacoes = EstoriaFactory.coresSituacoes();
            vm.dtOptions = angular.copy(DataTableConfigPadrao.dtOptionsPadraoComPaginacaoEReponsivo);
            vm.dtOptions.columnDefs = [DataTableConfigPadrao.columnDefsPadrao];
            vm.historiaPai = Dados.dadosHistoriaPai;
            _validarHistoriaPaiIgualHistoriaAtual();
        }


        function fecharDialog() {
            if (_validarListaHistoriasIguais(vm.historiasVinculadasBckp,
                vm.dados.historiasVinculadas)) {
                $mdDialog.hide(vm.houveAlteracoes);
            } else {
                MdDialogService.confirmPadraoComEvento("Você realmente deseja sair da tela ?", "Pois todas as alterações serão perdidas.",
                    null,
                    function () {
                        $mdDialog.hide(vm.houveAlteracoes);
                    }, null);
            }
        }

        function configurarMdSelectHistoriasVinculadas() {
            vm.filtrarHistorias = "";

            angular.element('#dialog-historias-vinculadas-pesquisa').on('keydown', function (ev) {
                ev.stopPropagation();
            });
        }

        function salvarHistoriasVinculadas() {
            vm.emProgresso = true;

            var viewModel = angular.copy(vm.dados);

            RequisicaoGenericaService.salvar(Api.estoria.historiasVinculadas.atualizarHistoriasVinculadas, viewModel)
                .then(function (sucess) {
                    vm.houveAlteracoes = true;

                    if (!_validarExistenciaHistoriaAtual()
                        && !(vm.dados.estoriaNumero == vm.historiaFiltrada.numero && vm.dados.estoriaAno == vm.historiaFiltrada.ano)) {
                        MdDialogService.alertPadraoComEvento("Alterações gravadas com sucesso.",
                            function () {
                                $mdDialog.hide(vm.houveAlteracoes);
                            },
                            null,
                            "A rotina será encerrada, pois a história atual foi desvinculada.");
                    } else {
                        vm.historiasVinculadasBckp = angular.copy(vm.dados.historiasVinculadas);
                        MdDialogService.alertPadrao("Alterações gravadas com sucesso.");
                    }
                }, function (error) {
                    MdDialogService.alertPadrao(error.data);
                }).finally(function () {
                    vm.emProgresso = false;
                });
        }

        function configuraAutoCompleteOnBlur() {
            if (vm.historia) {
                vm.textoDePesquisaAutoComplete = "";
            }
        }

        function pesquisarAutoComplete(pesquisa) {
            vm.dados.pesquisa = pesquisa;
            var viewModel = angular.copy(vm.dados);
            var deferred = $q.defer();

            $timeout(function () {
                RequisicaoGenericaService.salvar(Api.estoria.historiasVinculadas.listarHistoriasSemVinculo, viewModel).then(
                    function (success) {
                        deferred.resolve(success.data);
                    },
                    function (error) {
                        deferred.reject(error.data);
                    });
            });

            vm.dados.pesquisa = "";

            return deferred.promise;
        }

        function alterarItemSelecionadoAutoComplete(historia) {
            if (historia) {
                vm.dados.historiasVinculadas.push(historia);
                vm.historia = null;
                vm.textoDePesquisaAutoComplete = "";
            }
        }

        function abrirHistoria(historia) {
            $state.goNewTab("app.planejamento_processamento_estoria", {
                parametros: {
                    numero: historia.numero,
                    ano: historia.ano,
                    squadCodigo: historia.squadCodigo,
                    chamarPesquisa: true
                }
            });
        }

        function excluirHistoria(historia) {
            var index = vm.dados.historiasVinculadas.findIndex(function (item) {
                return item.numero === historia.numero && item.ano == historia.ano;
            });

            if (index != -1) {
                vm.dados.historiasVinculadas.splice(index, 1);
            }
        }

        function _validarHistoriasIguais(historia1, historia2) {
            return historia1.numero == historia2.numero
                && historia1.ano == historia2.ano;
        }

        function _validarListaHistoriasIguais(lista1, lista2) {
            var todasHistoriasIguais = true;

            lista1.map(function (historia) {
                if (todasHistoriasIguais) {
                    todasHistoriasIguais = lista2.some(function (item) {
                        return _validarHistoriasIguais(historia, item);
                    });
                }
            });

            lista2.map(function (historia) {
                if (todasHistoriasIguais) {
                    todasHistoriasIguais = lista1.some(function (item) {
                        return _validarHistoriasIguais(historia, item);
                    });
                }
            });

            return lista1.length == lista2.length && todasHistoriasIguais;
        }

        function _validarExistenciaHistoriaAtual() {
            return vm.dados.historiasVinculadas.some(function (historia) {
                return _validarHistoriasIguais(historia, vm.historiaFiltrada);
            });
        }

        function _validarHistoriaPaiIgualHistoriaAtual() {
            if (vm.historiaPai.numero == vm.historiaFiltrada.numero &&
                vm.historiaPai.ano == vm.historiaFiltrada.ano) {
                vm.habilitaBotao = false;
                vm.exibeHistoriaPrincipal = false;
            } else {
                vm.habilitaBotao = true;
                vm.exibeHistoriaPrincipal = true;
            };
        }
    }
})();

/**
 * Created by nova on 05/09/2016.
 */
(function () {
    'use strict';

    angular
        .module('app.planejamentoScrum.processamento.estoria')
        .controller("EstoriaDialogTarefasController", EstoriaDialogTarefasController);

    function EstoriaDialogTarefasController(Api, RequisicaoGenericaService, $rootScope, $mdDialog, MdDialogService, MdToastService, Tarefa,
        UsuarioEstoriaLogado, Estoria, TiposTarefa, ServicosGenericoService, ControleForm, RotasHtml) {

        var vm = this;
        var rotasHtml = RotasHtml.estoria.tabTarefa;
        vm.requisicaSolicitada = false;
        vm.preloader = { habilitar: false };
        vm.requisicaInserirRegistroSolicitada = false;


        // Data region        
        vm.inserirRegistro = false;
        vm.desabilitaCamposDialoTarefa = false;
        vm.desabilitarEdicaoUsuario = false;
        vm.tarefa = {};
        vm.tiposTarefa = angular.copy(TiposTarefa);
        vm.usuarioEstoriaLogado = UsuarioEstoriaLogado;
        vm.registrosSituacoes = null
        vm.houveAlteracoes = false;
        var sprintNumeroTemporario = null;

        if (Tarefa) {
            vm.titulo = "Editando Tarefa";
            vm.inserirAtivo = false;
            vm.novaTarefa = false;
            vm.tarefa = angular.copy(Tarefa);
            if (vm.tarefa.horas) {
                vm.tarefa.horas = vm.tarefa.horas.substring(0, 5);
            }
            var descricaoSetor = vm.usuarioEstoriaLogado.clsSetor.descricao.toLowerCase();

            if (angular.isDefined(vm.usuarioEstoriaLogado.clsSetor)) {
                if ((vm.tarefa.tipo === 1 || vm.tarefa.tipo === 2) && (descricaoSetor != "desenvolvimento" && descricaoSetor != "análise")) {
                    vm.desabilitaCamposDialoTarefa = true;
                }
                if (vm.tarefa.tipo === 3 && (descricaoSetor !== 'testes' && descricaoSetor !== 'análise')) {
                    vm.desabilitaCamposDialoTarefa = true;
                }
            }

        } else {
            vm.titulo = "Inserindo Tarefa";
            vm.inserirAtivo = true;
            vm.novaTarefa = true;
            vm.tarefa = {
                estoriaNumero: Estoria.numero,
                estoriaAno: Estoria.ano,
                estoriaSquadCodigo: Estoria.squadCodigo
            }
        }
        //endregion

        // Definição Métodos region
        var metodosInterno = {
            salvar: metodoInternosSalvar,
            editar: metodosInternoEditar,
            abrirNovaTarefa: abrirNovaTarefa,
            listarSituacoesExcetoImpedimento: listarSituacoesExcetoImpedimento
        };
        vm.metodosDialog = {
            salvar: metodoDialogSalvar,
            excluir: metodoDialogExcluir,
            inserirRegistroNaSprint: inserirRegistroNaSprint,
            fecharDialog: metodoDialogFecharDialog
        };
        //endregion

        // Implmentação dos Métodos region

        // Métodos Interno region
        function metodoInternosSalvar(tarefa, event) {
            vm.requisicaSolicitada = true;
            RequisicaoGenericaService.salvar(Api.estoria.tarefa.criar, tarefa).then(
                function (success) {
                    MdToastService.toastPadrao("Tarefa cadastrada com sucesso!");

                    Estoria.tarefas.push(success.data);

                    vm.requisicaSolicitada = false;
                    vm.houveAlteracoes = true;
                    $mdDialog.hide(vm.houveAlteracoes);

                    MdDialogService.confirmPadraoComEvento("Deseja cadastrar uma nova tarefa ?", "", event, function () {
                        metodosInterno.abrirNovaTarefa();
                    });
                },
                function (error) {
                    vm.requisicaSolicitada = false;
                    alert(error.data);
                });
        }

        function metodosInternoEditar(tarefa) {
            delete tarefa.usuario;

            if (tarefa.registro) {
                tarefa.registro.estoriaNumero = tarefa.estoriaNumero;
                tarefa.registro.estoriaAno = tarefa.estoriaAno;
            }

            vm.requisicaSolicitada = true;
            RequisicaoGenericaService.editar(Api.estoria.tarefa.atualizar, tarefa).then(
                function (success) {
                    MdToastService.toastPadrao("Tarefa editada com sucesso!");
                    $rootScope.$broadcast('TarefaEditada', success.data);
                    angular.forEach(Estoria.tarefas, function (item, index) {
                        if (item.codigo === success.data.codigo) {
                            Estoria.tarefas[index] = success.data;
                        }
                    });

                    vm.requisicaSolicitada = false;
                    vm.houveAlteracoes = true;
                    $mdDialog.hide(vm.houveAlteracoes);
                },
                function (error) {
                    vm.requisicaSolicitada = false;
                    alert(error.data);
                });
        }

        function abrirNovaTarefa() {
            $mdDialog.show({
                controller: 'EstoriaDialogTarefasController',
                controllerAs: 'vm',
                templateUrl: rotasHtml.dialogTarefa,
                //parent: ---------------,
                targetEvent: event,
                clickOutsideToClose: false,
                locals: {
                    ControleForm: ControleForm,
                    UsuarioEstoriaLogado: vm.usuarioEstoriaLogado,
                    Estoria: Estoria,
                    Tarefa: null,
                    TiposTarefa: vm.tiposTarefa,
                }
            });
        }

        function listarSituacoesExcetoImpedimento() {
            vm.requisicaInserirRegistroSolicitada = true;
            RequisicaoGenericaService.listarSemParams(Api.sprint.ListarSprintCorrenteETodasSituacoesExcetoImpedimento)
                .then(function (success) {
                    vm.registrosSituacoes = success.data.situacoes;
                    vm.tarefa.registro.sprintNumero = success.data.sprintNumero;
                    sprintNumeroTemporario = success.data.sprintNumero;

                    vm.requisicaInserirRegistroSolicitada = false;
                }, function (error) {
                    alert(error.data);
                    vm.requisicaInserirRegistroSolicitada = false;
                });
        }
        //endregion

        // Métodos Dialog region
        function metodoDialogSalvar(tarefa, event) {
            tarefa.data = ServicosGenericoService.retornaHoraFormataComTempo(tarefa.data);
            if (!tarefa.horas)
                tarefa.horas = "00:00";
            if (vm.novaTarefa) {
                metodosInterno.salvar(tarefa, event);
            } else {
                metodosInterno.editar(tarefa);
            }
        }

        function metodoDialogExcluir(tarefa, event) {
            ServicosGenericoService
                .excluirRegistroPorCodigoOuGenericamenteEmDialogs(Api.estoria.tarefa.excluir, Estoria.tarefas, tarefa, vm.preloader, $mdDialog,
                    event, 'Deseja realmente excluir esta Tarefa ?');
        }

        function inserirRegistroNaSprint() {
            if (vm.tarefa.dataHoraFim) {
                if (!vm.inserirRegistro) {
                    vm.tarefa.inserirRegistroPelaTarefa = true;
                    vm.tarefa.registro = {
                        data: new Date(vm.tarefa.dataHoraFim),
                        descricao: vm.tarefa.descricao,
                        estoria: {
                            estoriaNumero: vm.tarefa.estoriaNumero,
                            estoriaAno: vm.tarefa.estoriaAno
                        },
                        usuarioCodigo: vm.usuarioEstoriaLogado.codigo,
                        sprintNumero: sprintNumeroTemporario
                    }
                    if (!vm.registrosSituacoes) {
                        metodosInterno.listarSituacoesExcetoImpedimento();
                    }
                } else {
                    vm.tarefa.inserirRegistroPelaTarefa = false;
                    vm.tarefa.registro = null;
                }
            } else {
                alert('É nececessário inserir a data de entrega da tarefa, para cadastrar um registro.');
                vm.inserirRegistro = true;
                vm.tarefa.inserirRegistroPelaTarefa = false;
                vm.tarefa.registro = null;
            }
        }

        function metodoDialogFecharDialog() {
            $mdDialog.hide(vm.houveAlteracoes);
        }
        //endregion
        //endregion
    }

})();

(function () {
    'use strict';

    angular
        .module('app.planejamentoScrum.processamento.estoria')
        .controller('HistoricoAlteracaoDataEntregaDialogController', HistoricoAlteracaoDataEntregaDialogController);

    function HistoricoAlteracaoDataEntregaDialogController(
        $mdDialog,
        HistoricoAlteracoes
    ) {
        var vm = this;
        vm.listaHistoricoAlteracoes = HistoricoAlteracoes;
        init();

        vm.metodos = {
            fecharDialog: fecharDialog,
        }

        function init() {
            console.log('HistoricoAlteracoes: ', HistoricoAlteracoes);
        }

        function fecharDialog() {
            $mdDialog.hide();
        }

    }
})();

(function () {
  'use strict';

  angular
    .module('app.planejamentoScrum.processamento.estoria')
    .controller('EstoriaDialogAlterarDataEntrega', EstoriaDialogAlterarDataEntrega);

  function EstoriaDialogAlterarDataEntrega(Api, RequisicaoGenericaService, UsuarioLogado, $mdDialog, $timeout, MdToastService, Estoria) {
    var vm = this;

    vm.form = {};
    vm.titulo = "Editando data entrega";
    vm.requisicaSolicitada = false;
    vm.estoria = angular.copy(Estoria);
    vm.antigaDataEntrega = vm.estoria.dataEntrega;
    vm.novaDataEntrega = vm.estoria.dataEntrega;

    vm.metodosDialog = {
      fecharDialog: metodoDialogFecharDialog,
      salvar: salvar
    }

    function salvar(estoria, event) {
      vm.requisicaSolicitada = true;
      var viewModel = {
        estoriaNumero: estoria.numero,
        estoriaAno: estoria.ano,
        estoriaSquadCodigo: estoria.squadCodigo,
        antigaDataEntrega: vm.antigaDataEntrega,
        novaDataEntrega: vm.novaDataEntrega,
        motivo: vm.motivoAlteracao,
        codigoUsuario: UsuarioLogado.codigo
      }
      RequisicaoGenericaService.salvar(Api.estoria.criarHistoricoDataEntrega, viewModel).then(
        function (success) {
          MdToastService.toastPadrao("Data Entrega alterada com sucesso.")
          $mdDialog.hide(success.data);
        },
        function (error) {
          alert(error.data, event);
        }).finally(function () {
          vm.requisicaSolicitada = false;
        });
    }

    function metodoDialogFecharDialog() {
      $mdDialog.hide();
    }
  }

})();


/**
 * Created by nova on 28/03/2017.
 */
(function () {
    'use strict';

    angular
        .module('app.pipeline.processamento.pipelineNegocio', [])
        .config(config);

    function config($stateProvider, RotasHtml) {
        var rotasHtml = RotasHtml.pipeline_negocio;

        $stateProvider
            .state('app.pipeline_processamento_pipelinenegocio', {
                abstract: true,
                url: '/pipeline/processamento/pipeline',
                module: 'privado',
                bodyClass: 'pipeline-negocio'
            })
            // Inicial
            .state('app.pipeline_processamento_pipelinenegocio.funis', {
                url: '/funis',
                params: {
                    existeNegociosVencidos: false
                },
                views: {
                    'content@app': {
                        templateUrl: rotasHtml.funis,
                        controller: "PipelineFunisController as vm"
                    }
                },
                resolve: {
                    ListarTodosFunis: function (Api, RequisicaoGenericaService) {
                        return RequisicaoGenericaService.listarSemParams(Api.pipeline.pipeline_funil.listarAtivos);
                    }
                }
            })
            .state('app.pipeline_processamento_pipelinenegocio.funis.negocios', {
                url: '/:codigoFunil/:funilDescricao',
                module: 'privado',
                views: {
                    'content@app': {
                        templateUrl: rotasHtml.templateUrl,
                        controller: "PipelineNegociosController as vm"
                    },
                    'pipeline-negocios@app.pipeline_processamento_pipelinenegocio.funis.negocios': {
                        templateUrl: rotasHtml.negocios,
                    }
                },
                resolve: {
                    ListarEtapasPorFunil: function (Api, RequisicaoGenericaService, $stateParams, PipelineNegocioFactory) {
                        var etapasFunil = PipelineNegocioFactory.etapasFunilFiltro
                        etapasFunil.codigoFunil = $stateParams.codigoFunil;
                        return RequisicaoGenericaService.listarComParams(Api.pipeline.pipeline_negocio.listarEtapasFunil, etapasFunil);
                    },
                    ListarFunis: function (Api, RequisicaoGenericaService) {
                        return RequisicaoGenericaService.listarSemParams(Api.pipeline.pipeline_funil.listarTodos);
                    }
                }
            });

    }

})();

(function () {
    'use strict';

    angular
        .module('app.pipeline.processamento.pipelineNegocio')
        .controller('DialogEdicaoFunilController', DialogEdicaoFunilController);

    function DialogEdicaoFunilController(Parametros, $mdDialog, $rootScope, MdToastService) {
        var vm = this;

        init();


        function init() {
            vm.funis = Parametros[0];
            vm.titulo = "Alteração de funil";
        }

        vm.metodos = {
            alterarItemSelecionadoSelectFunil: alterarItemSelecionadoSelectFunil,
            fecharDialog: fecharDialog,
            salvar: salvar
        }

        //#region metodos

        function alterarItemSelecionadoSelectFunil() {

            if (!vm.funil)
                return;
        }

        function fecharDialog() {
            $mdDialog.hide();
        }

        function salvar(event) {
            vm.funil.produtos = [];
            $rootScope.$broadcast('AlteracaoFunil', vm.funil);
            MdToastService.toastPadrao("Funil alterado!");
            $mdDialog.hide();
        }

        //#endregion
    }

})(); 
/**
 * Created by nova on 28/07/2016.
 */
(function()
 {
    'use strict';

    angular
        .module('app.diretivas',
                [

    ]);


})();

(function () {
    'use strict';

    angular
        .module('app.diretivas')
        .controller('SecaoSubitensController', SecaoSubitensController)
        .directive('secaoSubitens', secaoSubitens);

    function SecaoSubitensController($scope) {
        var vm = this;

        init();

        vm.metodos = {
            ngChangehabilitarTodos: ngChangehabilitarTodos,
            configuraAutoCompleteOnBlur: configuraAutoCompleteOnBlur,
            alterarItemSelecionadoAutoComplete: alterarItemSelecionadoAutoComplete,
            pesquisarAutoComplete: pesquisarAutoComplete,
            removerItem: removerItem,
            limpaTodos: limpaTodos
        };

        function init() {
            vm.habilitarTodos = true;
        }

        $scope.$watch('vm.filtros.length', function () {
            if (vm.filtros.length <= 0) {
                vm.habilitarTodos = true;
            }
        });

        function ngChangehabilitarTodos() {
            _habilitarTodos();
        }

        function limpaTodos() {
            _defineValoresDefault();
        }

        function configuraAutoCompleteOnBlur() {
            if (!vm.item) {
                vm.textoDePesquisaAutoComplete = "";
            }
        }

        function alterarItemSelecionadoAutoComplete(item) {
            if (item && !_verificaSeExisteNaLista(item)) {
                vm.filtros.push(item);
                vm.habilitarTodos = false;
            }

            vm.item = null;
            vm.textoDePesquisaAutoComplete = "";
        }

        function pesquisarAutoComplete(query) {
            if (!query) {
                return [];
            }

            var termo = query.toString().toLowerCase();

            return (vm.listaCompleta || []).filter(function (item) {
                return (item.codigo + '').toLowerCase().indexOf(termo) > -1 ||
                    (item.descricao || '').toLowerCase().indexOf(termo) > -1;
            }).filter(function (item) {
                if (_verificaSeExisteNaLista(item)) {
                    return false;
                }

                if (!vm.filtrosExcluir || !vm.filtrosExcluir.length) {
                    return true;
                }

                return !vm.filtrosExcluir.some(function (itemExcluido) {
                    return (item.codigo) == (itemExcluido.codigo);
                });
            });
        }

        function removerItem(item) {
            var index = vm.filtros.indexOf(item);

            if (index === -1) {
                index = vm.filtros.findIndex(function (x) {
                    return x.codigo == item.codigo;
                });
            }

            if (index > -1) {
                vm.filtros.splice(index, 1);
            }

            if (vm.filtros.length <= 0) {
                _defineValoresDefault();
            }
        }

        function _verificaSeExisteNaLista(item) {
            return vm.filtros.some(function (x) {
                return x.codigo == item.codigo;
            });
        }

        function _habilitarTodos() {
            if (vm.filtros.length == 0 || vm.habilitarTodos) {
                _defineValoresDefault();
            }
        }

        function _defineValoresDefault() {
            vm.filtros = [];
            vm.habilitarTodos = true;
        }
    }

    function secaoSubitens() {
        return {
            restrict: 'AE',
            scope: {},
            bindToController: {
                filtros: "=",
                listaCompleta: "=",
                filtrosExcluir: "=?"
            },
            controller: 'SecaoSubitensController as vm',
            templateUrl: 'app/main/financeiro/relatorio/contratos/views/step/produto-segmentacao/diretivas/secao-subitens/secao-subitens.html'
        };
    }
})();
(function () {
    'use strict';

    angular
        .module('app.diretivas')
        .controller('SecaoSubitensANaoImprimirController', SecaoSubitensANaoImprimirController)
        .directive('secaoSubitensANaoImprimir', secaoSubitensANaoImprimir);

    function SecaoSubitensANaoImprimirController($scope) {
        var vm = this;

        init();

        vm.metodos = {
            configuraAutoCompleteOnBlur: configuraAutoCompleteOnBlur,
            alterarItemSelecionadoAutoComplete: alterarItemSelecionadoAutoComplete,
            pesquisarAutoComplete: pesquisarAutoComplete,
            removerItem: removerItem,
            limpaTodos: limpaTodos
        };

        function init() {
            vm.filtros = vm.filtros || [];
        }

        function limpaTodos() {
            _defineValoresDefault();
        }

        function configuraAutoCompleteOnBlur() {
            if (!vm.item) {
                vm.textoDePesquisaAutoComplete = "";
            }
        }

        function alterarItemSelecionadoAutoComplete(item) {
            if (item && !_verificaSeExisteNaLista(item)) {
                vm.filtros.push(item);
            }

            vm.item = null;
            vm.textoDePesquisaAutoComplete = "";
        }

        function pesquisarAutoComplete(query) {
            if (!query) return [];

            var termo = query.toString().toLowerCase();

            return (vm.listaCompleta || []).filter(function (item) {
                return (item.codigo + '').toLowerCase().indexOf(termo) > -1 ||
                    (item.descricao || '').toLowerCase().indexOf(termo) > -1;
            }).filter(function (item) {
                if (_verificaSeExisteNaLista(item)) {
                    return false;
                }

                if (!vm.filtrosExcluir || !vm.filtrosExcluir.length) {
                    return true;
                }

                return !vm.filtrosExcluir.some(function (itemExcluido) {
                    return (item.codigo) == (itemExcluido.codigo);
                });
            });
        }

        function removerItem(item) {
            var index = vm.filtros.indexOf(item);

            if (index === -1) {
                index = vm.filtros.findIndex(function (x) {
                    return x.codigo == item.codigo;
                });
            }

            if (index > -1) {
                vm.filtros.splice(index, 1);
            }
        }

        function _verificaSeExisteNaLista(item) {
            return vm.filtros.some(function (x) {
                return x.codigo == item.codigo;
            });
        }

        function _defineValoresDefault() {
            vm.filtros = [];
        }
    }

    function secaoSubitensANaoImprimir() {
        return {
            restrict: 'AE',
            scope: {},
            bindToController: {
                filtros: "=",
                listaCompleta: "=",
                filtrosExcluir: "=?"
            },
            controller: 'SecaoSubitensANaoImprimirController as vm',
            templateUrl: 'app/main/financeiro/relatorio/contratos/views/step/produto-segmentacao/diretivas/secao-subitens-a-nao-imprimir/secao-subitens-a-nao-imprimir.html'
        };
    }
})();
(function () {
    'use strict';

    angular
        .module('app.diretivas')
        .controller('SecaoItensANaoImprimirController', SecaoItensANaoImprimirController)
        .directive('secaoItensANaoImprimir', secaoItensANaoImprimir);

    /** @ngInject */
    function SecaoItensANaoImprimirController($scope, ServicosGenericoService) {
        var vm = this;

        vm.metodos = {
            configuraAutoCompleteOnBlur: configuraAutoCompleteOnBlur,
            alterarItemSelecionadoAutoComplete: alterarItemSelecionadoAutoComplete,
            pesquisarAutoComplete: pesquisarAutoComplete,
            removerItem: removerItem,
        }

        //#region Metodos
        function configuraAutoCompleteOnBlur() {
            if (!vm.item) {
                vm.textoDePesquisaAutoComplete = "";
            }
        }

        function alterarItemSelecionadoAutoComplete(item) {
            if (item && !_verificaSeExisteNaLista(item)) {
                vm.filtros.push(item);
            }
            vm.textoDePesquisaAutoComplete = "";
        }

        function pesquisarAutoComplete(query) {
            return ServicosGenericoService.pesquisarAutoCompleteCodigoOuDescricaoGenericoApi(vm.rotaDaPesquisa, query)
                .then(_filtrarExcluidos);
        }

        function removerItem(item) {
            vm.filtros.splice(vm.filtros.indexOf(item), 1);
        }
        //#endregion Metodos

        //#region metodos internos

        function _verificaSeExisteNaLista(item) {
            return vm.filtros.some(function (itemExistente) {
                return ((item.codigo) == (itemExistente.codigo));
            });
        }

        function _filtrarExcluidos(lista) {
            return lista.filter(function (item) {
                if (_verificaSeExisteNaLista(item)) {
                    return false;
                }

                if (!vm.filtrosExcluir || !vm.filtrosExcluir.length) {
                    return true;
                }

                return !vm.filtrosExcluir.some(function (itemExcluido) {
                    return (item.codigo) == (itemExcluido.codigo);
                });
            });
        }
        //#endregion metodos internos

    }

    /** @ngInject */
    function secaoItensANaoImprimir() {
        return {
            restrict: 'AE',
            scope: {},
            bindToController: {
                filtros: "=",
                filtrosExcluir: "=?",
                rotaDaPesquisa: '@',
                modelTipoFiltro: "=?"
            },
            controller: 'SecaoItensANaoImprimirController as vm',
            templateUrl: 'app/main/financeiro/relatorio/contratos/views/step/produto-segmentacao/diretivas/secao-itens-a-nao-imprimir/secao-itens-a-nao-imprimir.html'
        };
    }
})();

/**
 * Created by nova on 27/09/2016.
 */
(function () {
    'use strict';

    angular
        .module('app.geral.processamento.controle-horas-trabalhadas.tab-historico-viagem', [])

})();

(function () {
    'use strict';

    angular
        .module('app.geral.processamento.controle-horas-trabalhadas.tab-historico-viagem')
        .controller('RegistroPontoDialogController', RegistroPontoDialogController);

    /** @ngInject */
    function RegistroPontoDialogController($mdDialog, $location, $anchorScroll, Colaboradores, MdToastService, ColaboradoresVinculados, RequisicaoGenericaService, Api, TituloDialog, Historico, DataMaxima, DataMinima, MdDialogService) {
        var vm = this;
        vm.intervaloData = {
            minimo: DataMinima,
            maximo: DataMaxima
        }
        vm.form = {};
        vm.controleForm = {};
        vm.historico = angular.copy(Historico);
        vm.listaColaboradores = angular.copy(ColaboradoresVinculados);


        init();

        vm.metodos = {
            closeDialog: _close,
            salvar: salvar,
            editar: editar,
            excluir: excluir,
            formataData: formataData,
            exibirColaboradores: exibirColaboradores,
            preparaColaboradoresNaTabela: preparaColaboradoresNaTabela
            , configuraMdSelectTecnico: configuraMdSelectTecnico
        };


        function init() {

            vm.form = {};
            vm.colaboradores = Colaboradores;
            vm.cliente = Historico.cliente;

            vm.dtOptionsHistoricoPonto = {
                dom: 'rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
                initComplete: function () {
                    var api = this.api(),
                        searchBox = angular.element('body').find('#pesquisar');

                    if (searchBox.length > 0) {
                        searchBox.on('keyup', function (event) {
                            api.search(event.target.value).draw();
                        });
                    }
                },
                pagingType: 'numbers',
                lengthMenu: [100],
                pageLength: 100,
                responsive: true,
                order: [],
                columnDefs: [
                    {
                        targets: [0],
                        responsivePriority: 1,
                        searchable: false,
                        orderable: false
                    }
                ]
            };

            vm.tituloDialog = TituloDialog != null ? TituloDialog : "";

            _carregaDadosPonto();

            _preparaBindingDatas();
        }



        //#region metodos

        function formataData(data) {
            return new Date(data).toLocaleDateString();
        }

        function preparaColaboradoresNaTabela(colaboradores) {
            var texto = "";

            if (colaboradores.length <= 0)
                texto = "Todos técnicos vinculados";

            else {
                var cont = 0;
                colaboradores.forEach(function (colaborador) {
                    if (cont == 2)
                        texto += "...";
                    if (cont <= 1)
                        texto += "<span style='font-size:15px;'>" + colaborador.nome + "</span><br/>";
                    cont++;
                });
            }

            return texto;
        }

        function configuraMdSelectTecnico() {
            vm.filtrarTecnicos = "";
            angular.element('#md-select-tecnico').on('keydown', function (ev) {
                ev.stopPropagation();
            });
        }

        function exibirColaboradores(event, colaboradores) {

            var texto = "<ul>";
            if (colaboradores.length <= 0)
                texto = "<span style='font-size:15px;>Todos técnicos vinculados.</span>";
            else
                colaboradores.forEach(function (colaborador) {
                    texto += "<li style='font-size:15px;'>" + colaborador.nome + "</li>";
                });

            texto += "</ul>"

            MdDialogService.alertPadrao("Técnicos vinculados", null, "<html>" + texto + "</html>");
        }

        function excluir(event, item) {

            MdDialogService.confirmPadraoComEvento("Excluir",
                'Deseja realmente excluir o registro de ponto?', event,
                function () {
                    vm.controleForm.emProgresso = true;
                    _requisicaoRemover(item).then(function (success) {
                        _removerPontoDaLista(item);

                    }, function (error) {
                        vm.controleForm.emProgresso = false;
                        MdDialogService.alertPadrao(error.data, null);

                    });
                });
        }

        function editar(event, item) {
            _limpaFormulario();
            $location.hash('target');
            $anchorScroll();

            if (item) {
                var copiaItem = angular.copy(item);
                vm.ponto = copiaItem;
                vm.colaboradores = copiaItem.colaboradores;
            }
        }

        function salvar() {

            var mensagem = _verificaSeHoraEhValida(vm.ponto.entradaManha, vm.ponto.saidaManha);

            if (mensagem == "") {
                mensagem += _verificaSeHoraEhValida(vm.ponto.entradaTarde, vm.ponto.saidaTarde);
            }

            if (mensagem != "")
                return MdDialogService.alertPadrao(mensagem, null);

            var existeItemNaLista = vm.ponto.codigo;

            var entidade = _preparaEntidadePonto(vm.ponto);

            if (existeItemNaLista == undefined)
                _criarNovoPonto(entidade)
            else
                _editarPontoSelecionado(entidade);

        }

        //#endregion metodos

        //#region metodosInternos

        function _preparaEntidadePonto(entidade) {
            return {
                codigo: entidade.codigo,
                historicoViagemCodigo: vm.historico.codigo,
                colaboradores: vm.colaboradores,
                data: entidade.data,
                entradaManha: entidade.entradaManha,
                entradaTarde: entidade.entradaTarde,
                saidaManha: entidade.saidaManha,
                saidaTarde: entidade.saidaTarde,
                observacao: entidade.observacao
            }
        }

        function _requisicaoRemover(item) {
            return RequisicaoGenericaService.excluir(Api.contole_horas.ponto.base, item.codigo);
        }

        function _removerPontoDaLista(item) {
            if (!item)
                return;
            var indexItem = vm.pontos.indexOf(item);

            if (indexItem < 0)
                return;

            vm.pontos.splice(indexItem, 1);

            MdToastService.toastPadrao("Ponto removido com sucesso!");
            vm.controleForm.emProgresso = false;
        }

        function _limpaFormulario() {
            vm.ponto = {};
            vm.colaboradores = [];
            vm.form.$setDirty();
            vm.form.$setPristine();
            vm.form.$setUntouched();
        }

        function _criarNovoPonto(item) {
            vm.controleForm.emProgresso = true;
            _requisicaoCriar(item).then(function (success) {
                if (success.data) {
                    vm.pontos.push(angular.copy(success.data));
                    MdToastService.toastPadrao("Ponto registrado com sucesso!");
                    vm.controleForm.emProgresso = false;
                    _limpaFormulario();
                }
            }, function (error) {
                MdDialogService.alertPadrao(error.data, null);
                vm.controleForm.emProgresso = false;

            });

        }

        function _verificaSeHoraEhValida(horaEntrada, horaSaida) {

            if (horaEntrada && horaSaida) {

                var horaEntradaFormatada = horaEntrada.split(':')
                    .reduce(function (acc, time) { return (60 * parseInt(acc) + +parseInt(time)) });

                var horaSaidaFormatada = horaSaida.split(':')
                    .reduce(function (acc, time) { return (60 * parseInt(acc) + +parseInt(time)) });

                if (horaSaidaFormatada <= horaEntradaFormatada)
                    return "Atenção! Hora de saída menor ou igual que a hora de chegada";

            }

            return "";

        }

        function _preparaBindingDatas() {
            vm.historico.dataSaida = new Date(vm.historico.dataSaida);
            vm.historico.dataChegada = new Date(vm.historico.dataChegada);
        }

        function _editarPontoSelecionado(item) {
            vm.controleForm.emProgresso = true;
            _requisicaoEditar(item).then(function (success) {
                var indexItem = vm.pontos.indexOf(item);
                vm.pontos.splice(indexItem, 1);
                vm.pontos.push(angular.copy(item));
                MdToastService.toastPadrao("Ponto editado com sucesso!");
                vm.controleForm.emProgresso = false;
                _limpaFormulario();

            }, function (error) {
                MdDialogService.alertPadrao(error.data, null);
                vm.controleForm.emProgresso = false;
            });

        }

        function _close() {
            $mdDialog.hide();
        }

        function _requisicaoCriar(entidade) {
            return RequisicaoGenericaService.salvar(Api.contole_horas.ponto.base, entidade);
        }

        function _requisicaoEditar(entidade) {
            return RequisicaoGenericaService.editar(Api.contole_horas.ponto.base, entidade);
        }

        function _carregaDadosPonto() {
            vm.controleForm.emProgresso = true;
            RequisicaoGenericaService.listarSemParams(Api.contole_horas.ponto.listar + '/' + vm.historico.codigo).then(function (success) {
                vm.pontos = success.data;
                vm.controleForm.emProgresso = false;
            }, function (error) {
                MdDialogService.alertPadrao(error.data, null);
                vm.controleForm.emProgresso = false;
            });
        }

        //#endregion metodosInternos

    }
})();

(function () {
    'use strict';

    angular
        .module('app.financeiro.processamento.contratos')
        .controller('DialogItensController', DialogItensController);

    function DialogItensController(
        $mdDialog,
        $scope,
        $q,
        $timeout,
        $state,
        $document,
        RequisicaoGenericaService,
        Api,
        MdDialogService,
        ContratoItem,
        Contrato,
        TiposBloqueio,
        Caracteristicas,
        Situacaoitem,
        SituacaoFinanceiraItem,
        FormasFaturamento,
        ApenasVisualizacao,
        HabilitarVisualizacao,
        ResumoEquipamentosPorContrato,
        MdToastService,
        RotasHtml,
        LoginUsuarioService,
        UsuariosSetorComercial,
        ListaMotivosRiscosContratuais,
        SubItensAtivos
    ) {
        var vm = this;

        vm.titulo = "Item";
        vm.editar = ContratoItem != null;
        vm.contratoItem = ContratoItem;
        vm.contratoBkp = angular.copy(ContratoItem);
        vm.acaoPosRescisao = !!Contrato.contratoRescisao;
        vm.contrato = Contrato;
        vm.tiposBloqueio = TiposBloqueio;
        vm.caracteristicas = Caracteristicas;
        vm.situacoesContrato = Situacaoitem;
        vm.situacoesFinanceirasContrato = SituacaoFinanceiraItem;
        vm.formasFaturamento = FormasFaturamento;
        vm.apenasVisualizacao = ApenasVisualizacao;
        vm.habilitarVisualizacao = HabilitarVisualizacao;
        vm.resumoEquipamentosPorContrato = ResumoEquipamentosPorContrato;
        vm.usuarios = UsuariosSetorComercial;
        vm.textoDePesquisaAutoCompleteAtendimento = "";
        vm.listaMotivosRiscoContratual = ListaMotivosRiscosContratuais;
        vm.subItensAtivos = SubItensAtivos;

        vm.filtroExecutivoContasResponsavel = "";
        vm.situacaoItemContrato = [
            {
                codigo: 1,
                descricao: "Ativo"
            },
            {
                codigo: 2,
                descricao: "Inativo"
            }
        ]

        vm.rotaDialogObservacao = RotasHtml.contratos.tabs.dialogObservacaoEDataInicial;
        vm.valorMensalBackup = null;
        vm.edicaoSubitensHabilitada = false;
        vm._subitensOriginais = [];
        init();
        _configurarAtalhoTeclado();

        $scope.$watchCollection(
            "[vm.contratoItem.contratoItemDadosSigiloso.valorMensal, vm.contratoItem.contratoItemDadosSigiloso.percentualComissionavel]",
            function (newValues, oldValues) {
                if (vm.contratoItem.contratoItemDadosSigiloso)
                    vm.contratoItem.contratoItemDadosSigiloso.valorComissionavel =
                        vm.contratoItem.contratoItemDadosSigiloso.valorMensal *
                        vm.contratoItem.contratoItemDadosSigiloso.percentualComissionavel;
            }
        );

        $scope.$watch('vm.contratoItem.contratoSubItens', function (newValue, oldValue) {
            if (newValue && newValue.length > 0) {
                newValue.forEach(function (subitem) {
                    if (subitem.codigoProduto && vm.subitens) {
                        var produtoSelecionado = vm.subitens.find(function (p) {
                            return p.codigo === subitem.codigoProduto;
                        });
                        if (produtoSelecionado) {
                            subitem.descricaoProduto = produtoSelecionado.descricao;
                        }
                        calcularValorTotalSubitem(subitem);
                    }
                });
                _calcularValorMensalPorSubitens();
            } else if (newValue && newValue.length === 0 && oldValue && oldValue.length > 0) {
                if (vm.valorMensalBackup !== null) {
                    vm.contratoItem.contratoItemDadosSigiloso.valorMensal = vm.valorMensalBackup;
                    vm.valorMensalBackup = null;
                } else if (vm.editar) {
                    vm.contratoItem.contratoItemDadosSigiloso.valorMensal = 0;
                }
            }
        }, true);

        if (vm.editar) {
            vm._subitensOriginais = angular.copy(vm.contratoItem.contratoSubItens || []);
        }

        vm.metodos = {
            fecharDialog: fecharDialog,
            configuraMdSelectProduto: configuraMdSelectProduto,
            configuraMdSelectFormaFaturamento: configuraMdSelectFormaFaturamento,
            configurarMdSelectCaracteristica: configurarMdSelectCaracteristica,
            onChangeNumeroLicencas: onChangeNumeroLicencas,
            salvar: salvar,
            abrirDialogDetalhes: abrirDialogDetalhes,
            changeProduto: changeProduto,
            configuraMdSelectNaturezaFaturamento: configuraMdSelectNaturezaFaturamento,
            onChangeQuantidadeLicencaTemporaria: onChangeQuantidadeLicencaTemporaria,
            onChangeSituacaoItem: onChangeSituacaoItem,
            onChangeTempoLicencaTemporaria: onChangeTempoLicencaTemporaria,
            onChangeRiscoRescisaoContratual: onChangeRiscoRescisaoContratual,
            configuraMdSelectExecutivoContasResponsavel: configuraMdSelectExecutivoContasResponsavel,
            filtrarExecutivoContasResponsavel: filtrarExecutivoContasResponsavel,
            filtrarMotivoRiscoContratualCodigo: filtrarMotivoRiscoContratualCodigo,
            pesquisarAutoCompleteAtendimento: pesquisarAutoCompleteAtendimento,
            alterarItemSelecionadoAutoCompleteAtendimento: alterarItemSelecionadoAutoCompleteAtendimento,
            configuraMdSelectMotivoRiscoContratualCodigo: configuraMdSelectMotivoRiscoContratualCodigo,
            visualizarAtendimento: visualizarAtendimento,
            adicionarSubitem: adicionarSubitem,
            validarSubitens: validarSubitens,
            configuraMdSelectSubitem: configuraMdSelectSubitem,
            verificarProdutoPermiteSubitens: verificarProdutoPermiteSubitens,
            onChangeSubitemQuantidade: onChangeSubitemQuantidade,
            calcularValorTotalSubitem: calcularValorTotalSubitem,
            removerSubitem: removerSubitem,
            editarObservacaoSubitem: editarObservacaoSubitem,
            filtrarSubitensDisponiveis: filtrarSubitensDisponiveis,
            possuiSubitens: _possuiSubitens,
            exibirFieldsetSubitens: exibirFieldsetSubitens
        }

        function init() {
            if (vm.contratoItem == null) {
                vm.contratoItem = {
                    contratoCodigo: vm.contrato.codigo,
                    itemCaracteristicas: [],
                    contratoItemDadosSigiloso: {
                        situacaoFinanceiraItem: 1,
                        situacaoItem: 1,
                        tipoBloqueio: 0
                    },
                    contratoSubItens: []
                };
            }

            if (!vm.contratoItem.contratoSubItens) {
                vm.contratoItem.contratoSubItens = [];
            }

            vm.iniciouSemSubitens = vm.editar && vm.contratoItem.contratoSubItens.length === 0;
            vm.subitens = angular.copy(vm.subItensAtivos).filter(function (item) {
                return item.subitemContratual === true;
            });

            if (vm.contratoItem.codigo == undefined) {
                vm.contratoItem.codigo == 0;
            };
            vm.usuarioPermiteEdicao = LoginUsuarioService.usuarioArmazenado().detalhesUsuario.editarReajusteItemContratual;
            vm.usuarioPermiteEdicaoExpiracaoLicenca = LoginUsuarioService.usuarioArmazenado().detalhesUsuario.permitirAtualizarExpiracaoLicenca;

            if (vm.editar || vm.apenasVisualizacao) {
                RequisicaoGenericaService.listarSemParams(
                    Api.produto.listarTodosProdutos)
                    .then(function (success) {
                        vm.produtos = success.data;
                        vm.subitens = angular.copy(success.data);
                    }, function (error) {
                        MdDialogService.alertPadrao("Atenção!", null, error.data);
                    });

                RequisicaoGenericaService.listarSemParams(
                    Api.naturezaFaturamento.listarTodos)
                    .then(function (success) {
                        vm.naturezaFaturamento = success.data;
                        _formataPercentualImpostoDescontar();
                    }, function (error) {
                        MdDialogService.alertPadrao("Atenção!", null, error.data);
                    });

            } else {
                vm.inserirAtivo = true
                RequisicaoGenericaService.listarSemParams(
                    Api.produto.listarProdutosAtivosEComercializaveis)
                    .then(function (success) {
                        vm.produtos = success.data;
                    }, function (error) {
                        MdDialogService.alertPadrao("Atenção!", null, error.data);
                    });

                RequisicaoGenericaService.listarSemParams(
                    Api.naturezaFaturamento.listarAtivos)
                    .then(function (success) {
                        vm.naturezaFaturamento = success.data;
                        _formataPercentualImpostoDescontar();
                    }, function (error) {
                        MdDialogService.alertPadrao("Atenção!", null, error.data);
                    });
            }

            if (vm.contratoItem.produtoCodigo == 2 || vm.contratoItem.produtoCodigo == 3) {
                vm.exibeLicencaTemporaria = true;
            } else {
                vm.exibeLicencaTemporaria = false;
            }
        }

        function configuraMdSelectNaturezaFaturamento() {
            vm.filtrarNaturezaFaturamento = "";
            angular
                .element("#cliente-dialog-contrato-natureza-md-select")
                .on("keydown", function (ev) {
                    ev.stopPropagation();
                })
        }

        function configuraMdSelectProduto() {
            vm.filtrarProduto = "";
            angular
                .element("#cliente-dialog-contrato-produto-md-select")
                .on("keydown", function (ev) {
                    ev.stopPropagation();
                });
        }

        function configuraMdSelectFormaFaturamento() {
            vm.filtrarFormaFaturamento = "";
            angular
                .element("#contrato-form-forma-faturamento-md-select")
                .on("keydown", function (ev) {
                    ev.stopPropagation();
                });
        }

        function configurarMdSelectCaracteristica() {
            vm.filtrarCaracteristica = "";
            angular
                .element("#dialog-contrato-item-caracteristica-md-select-caracteristica")
                .on("keydown", function (ev) {
                    ev.stopPropagation();
                });
        }

        function configuraMdSelectExecutivoContasResponsavel() {
            vm.filtroExecutivoContasResponsavel = "";
            angular.element('#dialog-contrato-item-executivo-contas-responsavel-md-select').on('keydown', function (ev) {
                ev.stopPropagation();
            });
        }

        function configuraMdSelectMotivoRiscoContratualCodigo() {
            vm.filtroMotivoRiscoContratualCodigo = "";
            angular.element('#dialog-contrato-item-motivo-risco-contratual-md-select').on('keydown', function (ev) {
                ev.stopPropagation();
            });
        }

        function filtrarExecutivoContasResponsavel(executivo) {
            return executivo.codigo == vm.filtroExecutivoContasResponsavel
                || executivo.login.toUpperCase().includes(vm.filtroExecutivoContasResponsavel.toUpperCase());
        }

        function visualizarAtendimento(atendimento) {
            if (!atendimento && atendimento !== 0) return;

            var atStr = atendimento.toString();
            var idx = atStr.indexOf('/');

            var numero = idx !== -1 ? atStr.substring(0, idx).trim() : atStr.trim();
            var ano = idx !== -1 ? atStr.substring(idx + 1).trim() : undefined;

            $state.goNewTab('app.atendimento_processamento_atendimento', {
                parametros: {
                    codigo: numero,
                    ano: ano,
                    chamarPesquisa: true
                }
            });
        }

        function filtrarMotivoRiscoContratualCodigo(motivo) {
            if (!vm.filtroMotivoRiscoContratual || vm.filtroMotivoRiscoContratual.trim() === '') {
                return true;
            }

            var filtro = vm.filtroMotivoRiscoContratual
                .toLowerCase()
                .normalize('NFD')
                .replace(/[\u0300-\u036f]/g, '');

            var descricao = motivo.descricao
                .toLowerCase()
                .normalize('NFD')
                .replace(/[\u0300-\u036f]/g, '');

            var codigo = motivo.codigo.toString();

            return codigo.indexOf(filtro) !== -1 || descricao.indexOf(filtro) !== -1;
        }


        function onChangeNumeroLicencas(numeroLicencas) {
            vm.mensagemErro = (numeroLicencas <= 0) ? true : false;
        }

        function salvar(contratoItem) {
            return vm.editar ? _validarEdicao(contratoItem) : _salvar(contratoItem);
        }

        function fecharDialog() {
            vm.valorMensalBackup = null;
            if (!vm.apenasVisualizacao && vm.editar && _subitensForamAlterados()) {
                MdDialogService.confirmPadraoComEvento(
                    "Atenção!",
                    "Existem subitens alterados que não foram salvos. Deseja realmente fechar?",
                    event,
                    function () {
                        $mdDialog.hide();
                    }
                );
                return;
            }
            $mdDialog.hide();
        }

        function _subitensForamAlterados() {
            var atuais = vm.contratoItem.contratoSubItens || [];
            var originais = vm._subitensOriginais || [];
            if (atuais.length !== originais.length) return true;
            for (var i = 0; i < atuais.length; i++) {
                var a = atuais[i], o = originais[i];
                if (!o ||
                    a.codigoProduto !== o.codigoProduto ||
                    a.descricaoProduto !== o.descricaoProduto ||
                    a.quantidade !== o.quantidade ||
                    a.valorUnitario !== o.valorUnitario ||
                    a.valorTotal !== o.valorTotal ||
                    a.observacao !== o.observacao) {
                    return true;
                }
            }
            return false;
        }

        function abrirDialogDetalhes(equipamentos) {
            $mdDialog.show({
                controller: 'DialogDetalhesEquipamentosController',
                controllerAs: 'vm',
                templateUrl: 'app/main/financeiro/processamento/contratos/views/tabs/tab-itens/dialogs/itens-dialog/detalhes-equipamentos-dialog/detalhes-equipamentos-dialog.html',
                targetEvent: event,
                clickOutsideToClose: false,
                multiple: true,
                locals: {
                    Equipamentos: equipamentos,
                    DataInicioContrato: vm.contrato.contratoDadosSigiloso.dataInicioPrimeiroContrato
                }
            });
        }

        function changeProduto(produtoCodigo) {
            var produto;
            vm.contrato.contratoItens.map(function (contratoItem) {
                if (contratoItem.produto.codigo == produtoCodigo) {
                    produto = contratoItem.produto;
                }
            });

            if (produto != undefined) {
                if (produto.codigoProtecao && produto.codigoProtecao > 0) {
                    MdDialogService.alertPadrao(
                        "Atenção!", null, "Não é possível cadastrar o item " +
                        produto.descricao + ", pois ele já está incluído no contrato.")
                }
            };

            if (produtoCodigo == 2 || produtoCodigo == 3) {
                vm.exibeLicencaTemporaria = true;
            } else {
                vm.exibeLicencaTemporaria = false;
            }
        }

        function onChangeQuantidadeLicencaTemporaria(quantidadeLicencaTemporaria) {
            vm.contratoItem.tempoMaximoLicencaTemporaria =
                (quantidadeLicencaTemporaria <= 0 || quantidadeLicencaTemporaria == undefined) ? undefined : "";
            vm.mensagemAvisoLicencaTemporaria = (quantidadeLicencaTemporaria == undefined) ? true : false;
        }

        function onChangeSituacaoItem(situacaoItem) {
            if (vm.contrato.contratoRescisao.rescindido
            ) {
                if (vm.contratoBkp.contratoItemDadosSigiloso.situacaoItem !== 2 && situacaoItem == 2) {
                    vm.contratoItem.contratoItemDadosSigiloso.situacaoItem = 2;
                    return;
                }

                if (
                    vm.contratoBkp.contratoItemDadosSigiloso.situacaoItem === 2 &&
                    vm.contratoBkp.contratoItemDadosSigiloso.situacaoItem !== situacaoItem
                ) {
                    vm.contratoItem.contratoItemDadosSigiloso.situacaoItem = vm.contratoBkp.contratoItemDadosSigiloso.situacaoItem;
                    MdDialogService.alertPadrao("Atenção!", event,
                        "Não é possível alterar a situação do item, o contrato atual foi sinalizado como rescindido.");

                }

                if (vm.contratoBkp.contratoItemDadosSigiloso.situacaoItem !== 2 && situacaoItem !== 2) {
                    MdDialogService.alertPadrao("Atenção!", event,
                        "O contrato atual foi sinalizado como rescindido. Por esse motivo, a situação do item não pode ser alterada.");
                    vm.contratoItem.contratoItemDadosSigiloso.situacaoItem = vm.contratoBkp.contratoItemDadosSigiloso.situacaoItem;
                }

            }
        }

        function onChangeTempoLicencaTemporaria(tempoLicenca) {
            vm.mensagemAvisoLicencaTemporaria = (tempoLicenca == 0) ? true : false;
        }

        function onChangeRiscoRescisaoContratual(riscoRescisaoContratual) {
            if (riscoRescisaoContratual) {
                vm.contratoItem.dataRiscoRescisaoContratual = new Date();
                $timeout(function () {
                    if (vm.form && vm.form.motivoRiscoContratualCodigo) {
                        vm.form.motivoRiscoContratualCodigo.$setTouched();
                        vm.form.motivoRiscoContratualCodigo.$setDirty();
                    }
                }, 10);
            } else {
                vm.contratoItem.dataRiscoRescisaoContratual = null;
                vm.contratoItem.motivoRiscoContratualCodigo = null;
                vm.contratoItem.atendimento = null;
                vm.textoDePesquisaAutoCompleteAtendimento = "";

            }
        }

        function pesquisarAutoCompleteAtendimento(pesquisa) {
            var viewModel = {
                pesquisa: pesquisa,
                clienteCodigo: vm.contrato.codigoCliente
            }
            var deferred = $q.defer();
            $timeout(function () {
                RequisicaoGenericaService.salvar(
                    Api.atendimento.listarAtendimentoAbertosPorCliente,
                    viewModel
                ).then(
                    function (success) {
                        deferred.resolve(success.data);
                    },
                    function (error) {
                        deferred.reject(error.data);
                    }
                );
            });

            return deferred.promise;
        }

        function alterarItemSelecionadoAutoCompleteAtendimento(atendimento) {
            if (atendimento) {
                vm.contratoItem.atendimento = atendimento;
            }
        }

        function _validarEdicao(contratoItem) {

            if (vm.contratoItem.numeroLicencas <= 0) {
                MdDialogService.alertPadrao("Atenção!", event,
                    "Não é permitido salvar um item com o Nº de licenças igual a 0.");
                return;
            }
            if (vm.contratoItem.produtoCodigo == 2 &&
                (vm.contratoItem.tempoMaximoLicencaTemporaria != undefined &&
                    vm.contratoItem.tempoMaximoLicencaTemporaria == 0)) {
                MdDialogService.alertPadrao("Atenção!", event,
                    "Não é permitido salvar um item com o tempo máximo de licença temporária igual a 0.");
                return;
            }

            if (vm.acaoPosRescisao) {
                MdDialogService.confirmPadraoComEvento(
                    "Atenção!",
                    "Identificamos a tentativa de alteração em um item vinculado a um contrato rescindido. Deseja continuar?",
                    event,
                    function () {
                        _editar(contratoItem);
                    }
                );
            } else {
                _editar(contratoItem);
            }
        }

        function _editar(contratoItem) {
            _iniciarProgresso("Salvando dados...");
            if (contratoItem.contratoItemDadosSigiloso.situacaoItem != 1) {
                _limparCamposRiscoContratual(contratoItem);
            }
            RequisicaoGenericaService.editar(Api.contrato.contrato_item.editar, contratoItem)
                .then(function (success) {
                    vm.contratoItem = success.data;
                    MdToastService.toastPadrao("Os dados foram salvos com sucesso!");
                    var houveAlteracoes = true;
                    $mdDialog.hide(houveAlteracoes);
                }, function (error) {
                    MdDialogService.alertPadrao(error.data);
                }).finally(function () {
                    vm.emProgresso = false;
                });
        }

        function _salvar(contratoItem) {
            var dataInicioContrato = vm.contrato.contratoDadosSigiloso.dataInicioPrimeiroContrato;
            if (vm.contratoItem.numeroLicencas <= 0) {
                MdDialogService.alertPadrao("Atenção!", event,
                    "Não é permitido salvar um item com o Nº de licenças igual a 0.");
                return;
            }
            if (vm.contratoItem.produtoCodigo == 2 &&
                (vm.contratoItem.tempoMaximoLicencaTemporaria != undefined &&
                    vm.contratoItem.tempoMaximoLicencaTemporaria == 0)) {
                MdDialogService.alertPadrao("Atenção!", event,
                    "Não é permitido salvar um item com o tempo máximo de licença temporária igual a 0.");
                return;
            }

            $mdDialog.show({
                controller: 'DialogObservacaoEDataInicialContrato',
                controllerAs: 'vm',
                templateUrl: vm.rotaDialogObservacao,
                targetEvent: event,
                clickOutsideToClose: false,
                multiple: true,
                locals: {
                    ContratoItem: contratoItem,
                    DataInicioContrato: dataInicioContrato
                }
            }).then(function (contratoItem) {
                _iniciarProgresso("Salvando dados...");
                if (contratoItem.contratoItemDadosSigiloso.situacaoItem != 1) {
                    _limparCamposRiscoContratual(contratoItem);
                }
                RequisicaoGenericaService.salvar(Api.contrato.contrato_item.editar, contratoItem)
                    .then(function (success) {
                        vm.contratoItem = success.data;
                        vm.editar = true;
                        MdToastService.toastPadrao("Os dados foram salvos com sucesso!");
                        var houveAlteracoes = true;
                        $mdDialog.hide(houveAlteracoes);
                    }, function (error) {
                        MdDialogService.alertPadrao("Atenção!", null, error.data);
                    }).finally(function () {
                        vm.emProgresso = false;
                    });
            })
        }

        function _iniciarProgresso(mensagem) {
            vm.mensagem = mensagem;
            vm.emProgresso = true;
        }

        function _formataPercentualImpostoDescontar() {
            vm.naturezaFaturamento.map(function (natureza) {
                var impostoDescontar = (natureza.percentualImpostoDescontar * 100).toFixed(2) + "%";
                natureza.percentualImpostoDescontar = impostoDescontar;
            })
        }

        function _limparCamposRiscoContratual(contratoItem) {
            contratoItem.riscoRescisaoContratual = false;
            contratoItem.dataRiscoRescisaoContratual = null;
            contratoItem.motivoRiscoContratualCodigo = null;
            contratoItem.atendimento = null;
            vm.textoDePesquisaAutoCompleteAtendimento = "";
        }

        function adicionarSubitem() {
            if (vm.contratoItem.contratoSubItens.length === 0 && vm.contratoItem.contratoItemDadosSigiloso.valorMensal && (!vm.editar || vm.iniciouSemSubitens)) {
                vm.valorMensalBackup = vm.contratoItem.contratoItemDadosSigiloso.valorMensal;
            }

            var novoSubitem = {
                contratoItemCodigo: vm.editar ? vm.contratoItem.codigo : null,
                codigoProduto: null,
                descricaoProduto: null,
                quantidade: null,
                valorUnitario: null,
                valorTotal: null,
                observacao: null
            };
            vm.contratoItem.contratoSubItens.push(novoSubitem);

            var novoIndex = vm.contratoItem.contratoSubItens.length - 1;
            _marcarCamposSubitemObrigatorios(novoIndex);
        }

        function validarSubitens() {
            if (!vm.contratoItem.contratoSubItens || vm.contratoItem.contratoSubItens.length === 0) {
                return true;
            }

            return vm.contratoItem.contratoSubItens.every(function (subitem) {
                return subitem.codigoProduto &&
                    subitem.quantidade &&
                    subitem.quantidade > 0 &&
                    subitem.valorUnitario !== null &&
                    subitem.valorUnitario !== undefined;
            });
        }

        function configuraMdSelectSubitem(index) {
            vm['filtrarSubitem' + index] = "";
            angular
                .element("#dialog-contrato-item-subitem-md-select-" + index)
                .on("keydown", function (ev) {
                    ev.stopPropagation();
                });
        }

        function verificarProdutoPermiteSubitens() {
            if (!vm.contratoItem.produtoCodigo || !vm.produtos) {
                return false;
            }

            var produtoSelecionado = vm.produtos.find(function (produto) {
                return produto.codigo === vm.contratoItem.produtoCodigo;
            });

            return produtoSelecionado && produtoSelecionado.permiteSubitens === true;
        }

        function onChangeSubitemQuantidade(subitem) {
            subitem.quantidadeInvalida = (subitem.quantidade <= 0) ? true : false;
            if (!subitem.quantidadeInvalida) {
                calcularValorTotalSubitem(subitem);
            }
        }

        function calcularValorTotalSubitem(subitem) {
            if (subitem.quantidade && subitem.valorUnitario !== null && subitem.valorUnitario !== undefined) {
                subitem.valorTotal = subitem.quantidade * subitem.valorUnitario;
            } else {
                subitem.valorTotal = null;
            }
        }

        function removerSubitem(index) {
            var subitem = vm.contratoItem.contratoSubItens[index];

            if (!subitem.codigoProduto) {
                vm.contratoItem.contratoSubItens.splice(index, 1);
                return;
            }

            var descricaoProduto = subitem.descricaoProduto || 'este subitem';

            MdDialogService.confirmPadraoComEvento(
                "Atenção!",
                "Deseja realmente desvincular o subitem " + descricaoProduto + "?",
                event,
                function () {
                    vm.contratoItem.contratoSubItens.splice(index, 1);
                }
            );
        }

        function editarObservacaoSubitem(subitem, index) {
            var apenasVisualizacao = vm.apenasVisualizacao  || (vm.editar && !vm.edicaoSubitensHabilitada);

            $mdDialog.show({
                controller: 'DialogObservacaoSubitemController',
                controllerAs: 'vm',
                templateUrl: 'app/main/financeiro/processamento/contratos/views/tabs/tab-itens/dialogs/itens-dialog/observacao-subitem-dialog/observacao-subitem-dialog.html',
                targetEvent: event,
                clickOutsideToClose: false,
                multiple: true,
                locals: {
                    Subitem: subitem,
                    ApenasVisualizacao: apenasVisualizacao,
                    DescricaoProduto: subitem.descricaoProduto
                }
            }).then(function (observacao) {
                vm.contratoItem.contratoSubItens[index].observacao = observacao;
            });
        }

        function filtrarSubitensDisponiveis(index) {
            if (!vm.subitens) {
                return [];
            }

            var codigosSelecionados = [];
            var codigosJaVinculados = [];

            if (vm.contratoItem.contratoSubItens) {
                vm.contratoItem.contratoSubItens.forEach(function (subitem, idx) {
                    if (subitem.codigoProduto) {
                        codigosJaVinculados.push(subitem.codigoProduto);
                        if (idx !== index) {
                            codigosSelecionados.push(subitem.codigoProduto);
                        }
                    }
                });
            }

            return vm.subitens.filter(function (produto) {
                if (produto.subitemContratual !== true) {
                    return false;
                }

                if (codigosSelecionados.indexOf(produto.codigo) !== -1) {
                    return false;
                }

                if (produto.ativo === true) {
                    return true;
                }

                if (vm.editar && codigosJaVinculados.indexOf(produto.codigo) !== -1) {
                    return true;
                }

                return false;
            });
        }

        function _calcularValorMensalPorSubitens() {
            if (!vm.contratoItem.contratoSubItens || vm.contratoItem.contratoSubItens.length === 0) {
                return;
            }

            var somaTotal = 0;
            vm.contratoItem.contratoSubItens.forEach(function (subitem) {
                if (subitem.valorTotal) {
                    somaTotal += subitem.valorTotal;
                }
            });

            vm.contratoItem.contratoItemDadosSigiloso.valorMensal = somaTotal;
        }

        function _restaurarValorMensalOriginal() {
            if (vm.valorMensalBackup !== null) {
                vm.contratoItem.contratoItemDadosSigiloso.valorMensal = vm.valorMensalBackup;
                vm.valorMensalBackup = null;
            }
        }

        function _possuiSubitens() {
            return vm.contratoItem.contratoSubItens && vm.contratoItem.contratoSubItens.length > 0;
        }

        function exibirFieldsetSubitens() {
            if (!verificarProdutoPermiteSubitens()) {
                return false;
            }

            if (vm.apenasVisualizacao) {
                return _possuiSubitens();
            }

            if(vm.editar){
                return _possuiSubitens() || vm.edicaoSubitensHabilitada;
            }

            return true;
        }

        function _configurarAtalhoTeclado() {
            $document.on('keydown', function (event) {
                if (vm.editar && event.ctrlKey && event.key === '.') {
                    $scope.$apply(function () {
                        var usuarioArmazenado = LoginUsuarioService.usuarioArmazenado();
                        var codigoSetor = usuarioArmazenado.clsSetor ? usuarioArmazenado.clsSetor.codigo : null;

                        if (codigoSetor !== 5 && codigoSetor !== 6 && codigoSetor !== 4) {
                            return;
                        }

                        if (!verificarProdutoPermiteSubitens()) {
                            MdToastService.toastPadrao("Este item não permite subitens.", true);
                            return;
                        }

                        vm.edicaoSubitensHabilitada = !vm.edicaoSubitensHabilitada;
                        if (vm.edicaoSubitensHabilitada) {
                            MdToastService.toastPadrao("Edição de subitens habilitada!");
                        } else {
                            MdToastService.toastPadrao("Edição de subitens desabilitada!");
                        }
                    });
                    event.preventDefault();
                }
            });

            $scope.$on('$destroy', function () {
                $document.off('keydown');
            });
        }

        function _marcarCamposSubitemObrigatorios(index) {
            $timeout(function () {
                if (!vm.form) return;

                var campos = [
                    'subitem_' + index,
                    'quantidade_' + index,
                    'valorUnitario_' + index
                ];

                campos.forEach(function (nomeCampo) {
                    if (vm.form[nomeCampo]) {
                        vm.form[nomeCampo].$setTouched();
                    }
                });
            }, 150);
        }
    }
})();
/**
 * Created by nova on 13/09/2016.
 */
/**
 * Created by nova on 13/09/2016.
 */
(function () {
    'use strict';

    angular
        .module('app.geral.cadastro.solucao.solucao', [])
        .config(Config);

    function Config($stateProvider, RotasHtml) {
        var rotasHtml = RotasHtml.solucao
        $stateProvider
            .state('app.geral_cadastro_solucao_solucao', {
                url: '/geral/cadastro/solucao/solucao',
                module: 'privado',
                views: {
                    'content@app': {
                        templateUrl: rotasHtml.templateUrl,
                        controller: 'SolucaoRotinasTarefasController as vm'
                    },
                    'solucao-form@app.geral_cadastro_solucao_solucao': {
                        templateUrl: rotasHtml.form
                    },
                    'solucoes-tabela@app.geral_cadastro_solucao_solucao': {
                        templateUrl: rotasHtml.tabela
                    }
                },
                resolve: {
                    SistemasOperacionais: function (Api, RequisicaoGenericaService) {
                        return RequisicaoGenericaService.listarSemParams(Api.sistemaOperacional.listarCodigoDescricao);
                    },
                    TiposTarefas: function (Api, RequisicaoGenericaService) {
                        return RequisicaoGenericaService.listarSemParams(Api.solucao_rotinas_tarefas.tarefas.listarTiposTarefas);
                    },
                    ListarProdutos: function (Api, RequisicaoGenericaService) {
                        return RequisicaoGenericaService.listarSemParams(Api.produto.listarPor);
                    },
                    ListarUsuarioPorDetalhe: function (Api, RequisicaoGenericaService, LoginUsuarioService) {
                        return RequisicaoGenericaService.listarSemParams(Api.usuario.detalhes_usuario.listarDetalhesUsuario
                            + LoginUsuarioService.usuarioArmazenado().codigo);
                    },
                }
            });
    }


})();

/**
 * Created by nova on 20/09/2016.
 */
(function () {
    'use strict';

    angular
        .module('app.geral.cadastro.solucao.solucao')
        .controller('DialogTarefasController', DialogTarefasController);

    function DialogTarefasController(
        Api, RequisicaoGenericaService, $mdDialog, Rotina, Tarefa, TiposTarefa, MdToastService, ControleForm, ServicosGenericoService
    ) {
        var vm = this;

        //<editor-fold desc="Data">
        // Data region
        vm.requisicaSolicitada = false;
        vm.preloader = { habilitar: false };

        vm.tiposTarefa = TiposTarefa;

        vm.tarefa = {};

        vm.rota = Api.solucao_rotinas_tarefas.tarefas.proximoCodigo;

        if (Tarefa) {
            vm.titulo = "Editar Tarefa";
            vm.inserirAtivo = false;
            vm.tarefa = angular.copy(Tarefa);
            if (vm.tarefa.horas)
                vm.tarefa.horas = vm.tarefa.horas.substring(0, 5);
        }
        else {
            vm.titulo = "Inserir Tarefa";
            vm.inserirAtivo = true;
            vm.tarefa.rotinaCodigo = Rotina.codigo;
        }
        //endregion
        //</editor-fold>

        //<editor-fold desc="Definição dos Métodos">
        // Definição dos Métodos region
        var metodosInternoDialog = {
            salvar: salvar,
            editar: editar,
        };
        vm.metodosDialogTarefas = {
            salvar: verificaSalvarOuEditarTarefas,
            excluir: excluir,
            fecharDialog: fecharDialog
        };
        //endregion
        //</editor-fold>

        //<editor-fold desc="Implementação dos Métodos">
        // Implementação dos Métodos region

        //<editor-fold desc="Métodos Internos">
        // Métodos Internos region
        function salvar(tarefa) {
            vm.requisicaSolicitada = true;
            RequisicaoGenericaService.salvar(Api.solucao_rotinas_tarefas.tarefas.criar, tarefa).then(
                function (success) {
                    MdToastService.toastPadrao("Tarefa cadastrada com sucesso!");

                    Rotina.tarefas.push(success.data);

                    vm.requisicaSolicitada = false;
                    $mdDialog.hide();
                },
                function (error) {
                    vm.requisicaSolicitada = false;
                    alert("Falha ao criar a Tarefa\nDetalhes: " + error.data);
                });
        }
        function editar(tarefa) {
            vm.requisicaSolicitada = true;
            RequisicaoGenericaService.editar(Api.solucao_rotinas_tarefas.tarefas.atualizar, tarefa).then(
                function (success) {
                    MdToastService.toastPadrao("Tarefa atualizada com sucesso!");

                    angular.forEach(Rotina.tarefas, function (item, index) {
                        if (item.codigo === success.data.codigo) {
                            Rotina.tarefas[index] = success.data;
                        }
                    });

                    vm.requisicaSolicitada = false;
                    $mdDialog.hide();
                },
                function (error) {
                    vm.requisicaSolicitada = false;
                    alert("Falha ao editar a tarefa\nDetalhes: " + error.data);
                });
        }
        function fecharDialogAtualizandoContexto(event) {
            AtualizarTarefas.atualizar(event);
            $mdDialog.hide();
        }
        //endregion
        //</editor-fold>

        //<editor-fold desc="Métodos DialogTarefas">
        // Métodos DialogTarefas region
        function verificaSalvarOuEditarTarefas(tarefa, event) {
            if(!tarefa.horas)
                tarefa.horas = "00:00";

            if (vm.inserirAtivo) {
                metodosInternoDialog.salvar(tarefa);
            }
            else {
                metodosInternoDialog.editar(tarefa);
            }
        }
        function excluir(tarefa, event) {
            ServicosGenericoService
                .excluirRegistroPorCodigoOuGenericamenteEmDialogs(Api.solucao_rotinas_tarefas.tarefas.excluir, Rotina.tarefas, tarefa, vm.preloader, $mdDialog,
                event, 'Deseja realmente excluir esta Tarefa ?');
        }
        function fecharDialog() {
            $mdDialog.hide();
        }
        //endregion
        //</editor-fold>

        //endregion
        //</editor-fold>
    }

})();

/**
 * Created by nova on 15/09/2016.
 */
(function () {
    'use strict';

    angular
        .module('app.geral.cadastro.solucao.solucao')
        .controller('DialogRotinasController', DialogRotinasController);

    function DialogRotinasController(Api, RequisicaoGenericaService, Solucao, Rotina,
        $mdDialog, MdToastService, ControleForm, ServicosGenericoService) {

        var vm = this;

        vm.requisicaSolicitada = false;
        vm.preloader = { habilitar: false };

        //<editor-fold desc="Data">
        // Data region
        vm.rotina = {};

        vm.rota = Api.solucao_rotinas_tarefas.rotinas.proximoCodigo;

        if (Rotina) {
            vm.titulo = "Editar Rotina";
            vm.inserirAtivo = false;
            vm.rotina = angular.copy(Rotina);
        }
        else {
            vm.titulo = "Inserir Rotina";
            vm.inserirAtivo = true;
            vm.rotina.solucaoCodigo = Solucao.codigo;
        }
        //endregion
        //</editor-fold>

        //<editor-fold desc="Definição dos Métodos">
        // Definição dos Métodos region
        var metodosInternoDialog = {
            salvar: salvar,
            editar: editar,
        };
        vm.metodosDialogRotinas = {
            salvar: verificaSalvarOuEditarRotinas,
            excluir: excluir,
            fecharDialog: fecharDialog
        };
        //endregion
        //</editor-fold>

        //<editor-fold desc="Implementação Dos Métodos">
        // Implementação Dos Métodos region

        //<editor-fold desc="Métodos Internos">
        // Métodos Internos region
        function salvar(rotina) {
            vm.requisicaSolicitada = true;
            RequisicaoGenericaService.salvar(Api.solucao_rotinas_tarefas.rotinas.criar, rotina).then(
                function (success) {
                    MdToastService.toastPadrao("Rotina cadastrada com sucesso!");

                    Solucao.rotinas.push(success.data);
                    console.log(success.data);

                    vm.requisicaSolicitada = false;
                    $mdDialog.hide();
                },
                function (error) {
                    vm.requisicaSolicitada = false;
                    alert("Falha ao criar a Rotina\nDetalhes: " + error.data);
                });
        }
        function editar(rotina) {
            vm.requisicaSolicitada = true;
            RequisicaoGenericaService.editar(Api.solucao_rotinas_tarefas.rotinas.atualizar, rotina).then(
                function (success) {
                    MdToastService.toastPadrao("Rotina atualizada com sucesso!");

                    angular.forEach(Solucao.rotinas, function (item, index) {
                        if (item.codigo === success.data.codigo) {
                            Solucao.rotinas[index] = success.data;
                        }
                    });

                    vm.requisicaSolicitada = false;
                    $mdDialog.hide();
                },
                function (erro) {
                    vm.requisicaSolicitada = false;
                    alert("Falaha ao editar a Rotina \nDetalhes: " + erro.data);
                });
        }
        //endregion
        //</editor-fold>

        //<editor-fold desc="Métodos DialogRotinas">
        // Métodos DialogRotinas region
        function verificaSalvarOuEditarRotinas(rotina) {
            if (vm.inserirAtivo) {
                metodosInternoDialog.salvar(rotina);
            }
            else {
                metodosInternoDialog.editar(rotina);
            }
        }
        function excluir(rotina, event) {
            var index = Solucao.rotinas.map(function (item) { return item.codigo }).indexOf(rotina.codigo);
            ServicosGenericoService
                .excluirRegistroPorCodigoOuGenericamenteEmDialogs(Api.solucao_rotinas_tarefas.rotinas.excluir, Solucao.rotinas, rotina, vm.preloader, $mdDialog,
                event, 'Deseja realmente excluir esta Rotina ?', null, index);            
        }
        function fecharDialog() {
            $mdDialog.hide();
        }
        //endregion
        //</editor-fold>

        //endregion
        //</editor-fold>

    }

})();

// Solucao.rotinas.splice(Solucao.rotinas.indexOf(rotina), 1);

(function () {
    'use strict';

    angular
        .module('app.geral.processamento.controle-horas-trabalhadas.tab-historico-viagem')
        .controller('AdicionarHistoricoViagemDialogController', AdicionarHistoricoViagemDialogController);

    /** @ngInject */
    function AdicionarHistoricoViagemDialogController($mdDialog, $scope, CodigoHistorico, DatasBinding, MdDialogService, $rootScope, RequisicaoGenericaService, Api, MdToastService, HistoricoViagemSelecionado, Editando, TituloDialog, ServicosGenericoService) {
        var vm = this;
        var editando = false;
        vm.form = {};
        init();

        vm.metodos = {
            verificaDataSaida: verificaDataSaida,
            verificaDataChegada: verificaDataChegada,
            closeDialog: _close,
            configuraAutoCompleteCidadeOnBlurOrigem: configuraAutoCompleteCidadeOnBlurOrigem,
            configuraAutoCompleteClienteOnBlur: configuraAutoCompleteClienteOnBlur,
            configuraAutoCompleteCidadeOnBlurDestino: configuraAutoCompleteCidadeOnBlurDestino,
            alterarItemSelecionadoAutoCompleteCidadeDestino: alterarItemSelecionadoAutoCompleteCidadeDestino,
            alterarItemSelecionadoAutoCompleteCidadeOrigem: alterarItemSelecionadoAutoCompleteCidadeOrigem,
            alterarItemSelecionadoAutoCompleteCliente: alterarItemSelecionadoAutoCompleteCliente,
            pesquisarAutoCompleteCidade: pesquisarAutoCompleteCidade,
            pesquisarAutoCompleteCliente: pesquisarAutoCompleteCliente,
            salvar: salvar
        };

        function init() {
            vm.tituloDialog = TituloDialog != null ? TituloDialog : "";

            _carregaDadosSeHistoricoViagemSelecionado();

            _preparaBindingDatas();
        }

        //#region metodosInternos

        function _close() {
            $mdDialog.hide();
        }

        function _verificaSeHoraEhValida() {

            if (!vm.entidade)
                return "Campos inválidos";

            if (!vm.entidade.dataSaida || !vm.entidade.dataChegada)
                return "Campos inválidos";

            if (!vm.entidade.horaSaida || !vm.entidade.horaChegada)
                return "Campos inválidos";

            if (angular.equals(vm.entidade.dataSaida, vm.entidade.dataChegada)) {

                var horaSaida = vm.entidade.horaSaida.split(':')
                    .reduce(function (acc, time) { return (60 * parseInt(acc) + +parseInt(time)) });

                var horaChegada = vm.entidade.horaChegada.split(':')
                    .reduce(function (acc, time) { return (60 * parseInt(acc) + +parseInt(time)) });

                if (horaSaida >= horaChegada)
                    return "Atenção! Hora de saída maior ou igual que a hora de chegada";

            }

            return "";

        }

        //#endregion metodosInternos

        //#region metodos

        function configuraAutoCompleteCidadeOnBlurDestino() {
            if (!vm.entidade.cidadeDestino) {
                vm.textoDePesquisaAutoCompleteCidadeDestino = "";
            }
        }

        function verificaDataSaida() {
            if (!vm.entidade.dataChegada)
                return;

            if (vm.entidade.dataChegada < vm.entidade.dataSaida)
                vm.entidade.dataChegada = angular.copy(vm.entidade.dataSaida);

        }

        function verificaDataChegada() {
            if (!vm.entidade.dataSaida)
                return;

            if (vm.entidade.dataChegada < vm.entidade.dataSaida)
                vm.entidade.dataChegada = angular.copy(vm.entidade.dataSaida);
        }

        function configuraAutoCompleteCidadeOnBlurOrigem() {
            if (!vm.entidade.cidadeOrigem) {
                vm.textoDePesquisaAutoCompleteCidadeOrigem = "";
            }
        }

        function configuraAutoCompleteClienteOnBlur() {
            if (!vm.entidade.cliente) {
                vm.textoDePesquisaAutoCompleteCliente = "";
            }
        }

        function alterarItemSelecionadoAutoCompleteCidadeDestino(item) {
            if (item) {
                vm.entidade.cidadeDestino = item;
            } else {
                vm.textoDePesquisaAutoCompleteCidade = "";
            }
        }

        function alterarItemSelecionadoAutoCompleteCidadeOrigem(item) {
            if (item) {
                vm.entidade.cidadeOrigem = item;
            } else {
                vm.textoDePesquisaAutoCompleteCidade = "";
            }
        }

        function alterarItemSelecionadoAutoCompleteCliente(item) {
            if (item) {
                vm.entidade.codigoCliente = item.codigo;
            } else {
                vm.textoDePesquisaAutoCompleteCliente = "";
                if (vm.entidade) {
                    vm.entidade.codigoCliente = null;
                    vm.entidade.cliente = null;
                }
            }
        }

        function pesquisarAutoCompleteCidade(query) {
            return ServicosGenericoService.pesquisarAutoCompleteDescricaoGenericoApi(Api.endereco.cidade.listarPor, query);
        }

        function pesquisarAutoCompleteCliente(query) {
            return ServicosGenericoService.pesquisarAutoCompleteCodigoOuNomeGenericoApi(Api.cliente.listarCodigoDescricao, query);
        }


        function salvar() {
            var mensagem = _verificaSeHoraEhValida();
            if (mensagem != "") {
                MdDialogService.alertPadrao(mensagem, null);
                return;
            }

            vm.enviando = true;

            if (editando) {
                _requisicaoEditar().then(function (success) {
                    MdToastService.toastPadrao("Histórico editado com sucesso!");
                    $rootScope.$broadcast('historico-controle-horas-edit', vm.entidade);
                    vm.enviando = false;
                }, function (error) {
                    MdDialogService.alertPadrao(error.data, null);
                    vm.enviando = false;
                });
            }

            else {
                _requiscaoCriar().then(function (success) {
                    $rootScope.$broadcast('historico-controle-horas-push', success.data);
                    MdToastService.toastPadrao("Histórico cadastrado com sucesso!");
                    vm.enviando = false;
                    _limpaFormulario();
                }, function (error) {
                    MdDialogService.alertPadrao(error.data, null);
                    vm.enviando = false;
                });
            }

        }
        //#endregion metodos


        //#region metodosInternos

        function _requiscaoCriar() {
            return RequisicaoGenericaService.salvar(Api.contole_horas.viagem, _preaparaHistoricoViagem(vm.entidade));
        }

        function _requisicaoEditar() {
            return RequisicaoGenericaService.editar(Api.contole_horas.viagem, _preaparaHistoricoViagem(vm.entidade));
        }

        function _preaparaHistoricoViagem(entidade) {
            if (angular.equals(undefined, entidade))
                return {};

            return {
                codigo: entidade.codigo,
                controleHoraCodigo: CodigoHistorico,
                cliente: entidade.cliente,
                dataSaida: entidade.dataSaida,
                horaSaida: entidade.horaSaida,
                dataChegada: entidade.dataChegada,
                horaChegada: entidade.horaChegada,
                cidadeOrigem: entidade.cidadeOrigem,
                cidadeDestino: entidade.cidadeDestino
            }

        }

        function _preparaBindingDatas() {
            if (!DatasBinding)
                return;
            vm.dataMinima = new Date(DatasBinding.minima);
            vm.dataMaxima = new Date(DatasBinding.maxima);

            if (angular.equals(undefined, vm.entidade))
                return;

            if (vm.entidade.dataSaida)
                vm.entidade.dataSaida = new Date(vm.entidade.dataSaida);

            if (vm.entidade.dataChegada)
                vm.entidade.dataChegada = new Date(vm.entidade.dataChegada);
        }

        function _limpaFormulario() {
            vm.entidade = {};
            vm.form.$setPristine();
            vm.form.$setUntouched();
        }

        function _carregaDadosSeHistoricoViagemSelecionado() {

            if (Editando)
                editando = Editando;

            if (HistoricoViagemSelecionado != null)
                vm.entidade = HistoricoViagemSelecionado;

        }
        //#endregion metodosInternos

    }
})();

(function(){
    'use strict';

    angular
        .module('app.solicitacao.processamento.solicitacao', [])
        .config(config);

    function config($stateProvider, RotasHtml){
        var rotasHtmlSolicitacao = RotasHtml.solicitacao.solicitacao;
        $stateProvider        
            .state('app.solicitacao_processamento_solicitacao', {
                url: '/solicitacao/processamento/solicitacao',
                module: 'privado',
                views : {
                        'content@app': {
                            templateUrl: rotasHtmlSolicitacao.templateUrl,
                            controller: 'SolicitacaoController as vm'
                        },
                        'solicitacao-form@app.solicitacao_processamento_solicitacao' : {
                            templateUrl: rotasHtmlSolicitacao.form
                        },
                        'solicitacao-table@app.solicitacao_processamento_solicitacao': {
                            templateUrl: rotasHtmlSolicitacao.table
                        },
                        'tab-documentacao@app.solicitacao_processamento_solicitacao': {
                            templateUrl: rotasHtmlSolicitacao.tabs.documentacao,
                            controller: 'TabDocumentacaoSolicitacaoController as vm'
                        },
                        'solicitacao--tab-historico@app.solicitacao_processamento_solicitacao': {
                            templateUrl: rotasHtmlSolicitacao.tabs.historico,
                            controller: "TabHistoricoSolicitacaoController as vm"
                        }
                },
                params:{
                    parametros: null
                },
                resolve:{
                    ListarTodasSolucoes: function (Api, RequisicaoGenericaService) {
                        return RequisicaoGenericaService.listarSemParams(Api.solucao_rotinas_tarefas.solucao.listarCodigoDescricao);
                    },
                    ListarTodasOrigens: function (Api, RequisicaoGenericaService) {                        
                        return RequisicaoGenericaService.listarSemParams(Api.solicitacao.solicitacao.origens.listar);
                    },
                    ListarNecessidadesCliente: function (Api, RequisicaoGenericaService) {
                        return RequisicaoGenericaService.listarSemParams(Api.display.listarNecessidadeCliente);
                    },
                    ListarTodosUsuarios: function (Api, RequisicaoGenericaService) {
                        return RequisicaoGenericaService.listarSemParams(Api.usuario.detalhes_usuario.listarUsuariosAtivos);
                    },
                    ListarTodosClientes: function (Api, RequisicaoGenericaService) {
                        return RequisicaoGenericaService.listarSemParams(Api.cliente.listarCodigoDescricao);
                    },
                    ListarTodasSolicitacaoFases: function (Api, RequisicaoGenericaService) {
                        return RequisicaoGenericaService.listarSemParams(Api.solicitacao.fase.listarTodos);
                    },
                    ListarUsuarioPorDetalhe: function (Api, RequisicaoGenericaService, LoginUsuarioService) {
                        return RequisicaoGenericaService.listarSemParams(Api.usuario.detalhes_usuario.listarDetalhesUsuario
                            + LoginUsuarioService.usuarioArmazenado().codigo);
                    },
                }
            });
    }

}());
(function(){
    'use strict';
    angular
        .module('app.solicitacao.processamento.solicitacao')
        .controller('EditarPontuacaoDialogController', EditarPontuacaoDialogController)

    /** @ngInject */
    function EditarPontuacaoDialogController($mdDialog, Solicitacao, Api, RequisicaoGenericaService, MdToastService){
        var vm = this;
        
        vm.titulo = "Editar Pontuação";

        vm.rotasApi = Api.solicitacao.solicitacao.editarPontuacao;

        init();

        function init(){
            vm.solicitacaoBkp = angular.copy(Solicitacao);
            vm.solicitacao = vm.solicitacaoBkp;
            vm.requisicaoSolicitada = false;
            vm.editarAtivo = true;
        }

        vm.metodosDialog = {
            salvarAlteracoes: salvarAlteracoes,
            fecharDialog: fecharDialog
        }

        function fecharDialog(){
            $mdDialog.hide();
        }
        function salvarAlteracoes(){
            vm.requisicaoSolicitada = true;

            var solicitacaoViewModel = {
                numero: vm.solicitacao.numero,
                ano: vm.solicitacao.ano,
                estimativaPontos : vm.solicitacao.estimativaPontos,
                squadCodigo: vm.solicitacao.squadCodigo
            }
            RequisicaoGenericaService.editar(vm.rotasApi, solicitacaoViewModel)
            .then(
                function(success){
                    MdToastService.toastPadrao("Pontuação alterada com sucesso!");
                    Solicitacao.estimativaPontos = solicitacaoViewModel.estimativaPontos;
                    vm.requisicaoSolicitada = false;
                    $mdDialog.hide();
                },
                function(error){
                    vm.requisicaoSolicitada = false;
                    alert(error);
                }
            )

        }
    }

}());
(function () {
    'use strict';

    angular
        .module('app.solicitacao.processamento.solicitacao')
        .controller('DocumentacaoDialogController', DocumentacaoDialogController)

    /** @ngInject */
    function DocumentacaoDialogController($q, $state, $mdDialog, MdDialogService, $scope, Solicitacao, Action, Etapa, RequisicaoGenericaService, Api,
        MdToastService, $timeout, EstoriaFactory) {

        var vm = this;

        vm.action = Action;
        vm.solicitacaoDocumentacao = Solicitacao.solicitacaoDocumentacao;
        vm.solicitacao = Solicitacao;

        vm.tipoEtapa = Etapa.etapa;
        vm.coresSituacoes = EstoriaFactory.coresSituacoes();
        vm.dados = {};
        vm.historiasVinculadasBckp = angular.copy(Solicitacao.estoriaVinculos);
        vm.solicitacao.historiasVinculadas = vm.solicitacao.estoriaVinculos || [];
        vm.rotasApi = Api.solicitacao.solicitacao.documentacao;
        vm.required = true;

        vm.metodosDialog = {
            fecharDialog: fecharDialog,
            setTitulo: _setTitulo,
            setEntidadeTemporaria: setEntidadeTemporaria,
            retornaEntidadeAlterada: retornaEntidadeAlterada,
            editarDocumentacao: editarDocumentacao,
            salvarAlteracoes: salvarAlteracoes,
            configurarSelectHistoriasVinculadas: configurarSelectHistoriasVinculadas,
            removerHistoriaVinculada: removerHistoriaVinculada,
            visualizarHistoria: visualizarHistoria,
            alterarItemSelecionadoAutoComplete: alterarItemSelecionadoAutoComplete,
            pesquisarAutoComplete: pesquisarAutoComplete,
            configuraAutoCompleteOnBlur: configuraAutoCompleteOnBlur
        }
        init();

        function init() {
            vm.metodosDialog.setEntidadeTemporaria();
            vm.metodosDialog.setTitulo();
            if (vm.action !== 'visualizar') {
                $timeout(function () {
                    var el = angular.element('#documentacao-dialog-documentacao').find('*[id*=taText]');

                    if (!el)
                        return;

                    el.focus();
                    var char = 1, sel;
                    sel = window.getSelection();

                    sel.collapse(el[0].lastChild, char);
                    var mdContent = angular.element('#dialogContent_dialog-solicitacao-documentacao');
                    mdContent[0].scrollTop = mdContent[0].scrollHeight;
                });
            }
        }

        function fecharDialog() {
            if (vm.tipoEtapa !== 4) {
                $mdDialog.hide();
                return;
            }
            var campoPorEtapa = {
                1: 'solicitacao',
                2: 'teste',
                3: 'analise',
                4: 'historia'
            };

            var campo = campoPorEtapa[vm.tipoEtapa];
            var conteudoOriginal = vm.solicitacaoDocumentacao[campo] || '';
            var conteudoAtual = vm.docTemp || '';
            var alterado = conteudoOriginal.trim() !== conteudoAtual.trim();
            var historiasAlteradas = !_validarListaHistoriasIguais(vm.historiasVinculadasBckp, vm.solicitacao.historiasVinculadas);

            if (!alterado && !historiasAlteradas) {
                $mdDialog.hide();
            } else {
                MdDialogService.confirmPadraoComEvento("Atenção!", "Possui alterações não salvas. Deseja continuar?",
                    null,
                    function () {
                        $mdDialog.hide();
                    }, null);
            }
        }

        function _validarHistoriasIguais(historia1, historia2) {
            return historia1.numero == historia2.numero
                && historia1.ano == historia2.ano;
        }

        function _validarListaHistoriasIguais(lista1, lista2) {
            var todasHistoriasIguais = true;

            lista1.map(function (historia) {
                if (todasHistoriasIguais) {
                    todasHistoriasIguais = lista2.some(function (item) {
                        return _validarHistoriasIguais(historia, item);
                    });
                }
            });

            lista2.map(function (historia) {
                if (todasHistoriasIguais) {
                    todasHistoriasIguais = lista1.some(function (item) {
                        return _validarHistoriasIguais(historia, item);
                    });
                }
            });

            return lista1.length == lista2.length && todasHistoriasIguais;
        }

        function _setTitulo() {
            const etapa = Etapa.nome.toLowerCase();
            if (vm.action === 'visualizar')
                vm.titulo = 'Visualizar documentação de ' + etapa;
            else
                vm.titulo = 'Editar documentação de ' + etapa;
        }

        $scope.$watch('vm.docTemp', function (newValue, oldValue) {
            if (newValue !== oldValue) {
                if (newValue.indexOf('<img') !== -1) {
                    vm.docTemp = newValue.replace(/<img[^>]+>/g, '');
                    MdDialogService.alertPadrao("Atenção!", null, "Não é possível inserir imagem.");
                }
            }
        });

        function editarDocumentacao(documentacao) {
            vm.requisicaoSolicitada = true;
            RequisicaoGenericaService.editar(vm.rotasApi.atualizar, documentacao)
                .then(function (success) {
                    MdToastService.toastPadrao("Documentação alterada com sucesso!");
                    Solicitacao.solicitacaoDocumentacao = vm.solicitacaoDocumentacao;
                    vm.requisicaoSolicitada = false;
                    $mdDialog.hide();
                }, function (error) {
                    vm.requisicaoSolicitada = false;
                    alert(error);
                });
        }

        function _atualizarHistoriasVinculadas(documentacao) {
            var entidadeEnvio = {
                documentacao: documentacao,
                historias: vm.solicitacao.historiasVinculadas,
            }

            vm.requisicaoSolicitada = true;
            RequisicaoGenericaService.editar(vm.rotasApi.atualizarHistoriasVinculadas, entidadeEnvio)
                .then(function (success) {
                    Solicitacao.solicitacaoDocumentacao = success.data.documentacao;
                    Solicitacao.estoriaVinculos = success.data.historias;
                    vm.requisicaoSolicitada = false;
                    MdToastService.toastPadrao("Documentação e histórias atualizadas com sucesso!");
                    $mdDialog.hide();
                }, function (error) {
                    vm.requisicaoSolicitada = false;
                    alert(error);
                });
        }

        function salvarAlteracoes() {
            var expr = Etapa.etapa;
            retornaEntidadeAlterada();
            if (expr == 4) {
                _atualizarHistoriasVinculadas(vm.solicitacaoDocumentacao);
            } else {
                editarDocumentacao(vm.solicitacaoDocumentacao);
            }
        }

        function setEntidadeTemporaria() {
            var expr = Etapa.etapa;
            switch (expr) {
                case 1:
                    vm.docTemp = vm.solicitacaoDocumentacao.solicitacao;
                    break;
                case 2:
                    vm.docTemp = vm.solicitacaoDocumentacao.teste;
                    break;
                case 3:
                    vm.docTemp = vm.solicitacaoDocumentacao.analise;
                    break;
                case 4:
                    vm.docTemp = vm.solicitacaoDocumentacao.historia;
                    break;
                default:
                    break;
            }
        }

        function retornaEntidadeAlterada() {
            var expr = Etapa.etapa;
            switch (expr) {
                case 1:
                    vm.solicitacaoDocumentacao.solicitacao = vm.docTemp;
                    break;
                case 2:
                    vm.solicitacaoDocumentacao.teste = vm.docTemp;
                    break;
                case 3:
                    vm.solicitacaoDocumentacao.analise = vm.docTemp;
                    break;
                case 4:
                    vm.solicitacaoDocumentacao.historia = vm.docTemp;
                    break;
                default:
                    break;
            }
        }

        function configurarSelectHistoriasVinculadas(ev) {
            vm.termoPesquisado = "";
            angular.element('#select-historias-vinculadas').on('keydown', function (ev) {
                ev.stopPropagation();
            });
        }

        function removerHistoriaVinculada(historia) {
            if (vm.solicitacao.historiasVinculadas.length) {
                if (historia == null)
                    return;

                var indexColaborador = vm.solicitacao.historiasVinculadas.indexOf(historia);
                vm.solicitacao.historiasVinculadas.splice(indexColaborador, 1);
            }
        }

        function visualizarHistoria(historia) {
            $state.goNewTab("app.planejamento_processamento_estoria", {
                parametros: {
                    numero: historia.estoriaNumero,
                    ano: historia.estoriaAno,
                    squadCodigo: historia.squadCodigo,
                    chamarPesquisa: true
                }
            });

        }

        function configuraAutoCompleteOnBlur() {
            if (vm.historia) {
                vm.textoDePesquisaAutoComplete = "";
            }
        }

        function pesquisarAutoComplete(pesquisa) {
            vm.dados.squadCodigo = vm.solicitacao.squadCodigo;
            vm.dados.pesquisa = pesquisa;

            var deferred = $q.defer();
            var url = vm.rotasApi.listarPorSquad + "?squadCodigo=" + vm.dados.squadCodigo + "&termoPesquisa=" + vm.dados.pesquisa;

            $timeout(function () {
                RequisicaoGenericaService.listarSemParams(url).then(
                    function (success) {
                        var dados = success.data || [];
                        deferred.resolve(Array.isArray(dados) ? dados : []);
                    },
                    function (error) {
                        deferred.reject(error.data || []);
                    }
                );
            });

            vm.dados.pesquisa = "";
            return deferred.promise;
        }

        function alterarItemSelecionadoAutoComplete(historia) {
            if (historia) {
                if (vm.solicitacao.historiasVinculadas.length === 0) {
                    vm.solicitacao.historiasVinculadas = [];
                }
                var existe = vm.solicitacao.historiasVinculadas.some(function (item) {
                    return item.estoriaNumero === historia.numero &&
                        item.estoriaAno === historia.ano &&
                        item.squadCodigo === historia.squadCodigo;
                });

                if (!existe) {
                    var novaHistoria = {
                        estoriaNumero: historia.numero,
                        estoriaAno: historia.ano
                    };
                    vm.solicitacao.historiasVinculadas.push(novaHistoria);
                } else {
                    MdDialogService.alertPadrao("Atenção!", null, "História já vinculada a solicitação.");
                }

                vm.historia = null;
                vm.textoDePesquisaAutoComplete = "";
            }
        }
    }
}());
/**
 * Created by nova on 14/11/2016.
 */
(function () {
    'use strict';

    angular
        .module('app.planejamentoScrum.processamento.sprint')
        .controller('SprintDialogVersaoEntregueController', SprintDialogVersaoEntregueController);

    function SprintDialogVersaoEntregueController(
        $mdDialog,
        $timeout,
        RequisicaoGenericaService,
        Api,
        ControleForm,
        SprintNumero,
        MdToastService,
        ServicosGenericoService,
        VersoesEntregues,
        VersaoEntregue,
        ApenasVisualizacao,
        LoginUsuarioService,
        SprintSquadCodigo
    ) {
        var vm = this;

        // Data region    
        vm.apenasVisualizacao = ApenasVisualizacao;
        vm.form = {};
        vm.versaoEntregue = {};
        vm.inserirAtivo = null;
        vm.solucoes = null;

        vm.requisicaSolicitada = false;
        vm.preloader = { habilitar: false };

        vm.usuarioLogado = LoginUsuarioService.usuarioArmazenado();

        if (VersaoEntregue) {
            vm.inserirAtivo = false;
            vm.titulo = "Editar Versão Entregue";
            vm.versaoEntregue = angular.copy(VersaoEntregue);
            delete vm.versaoEntregue.solucao;
        } else {
            vm.inserirAtivo = true;
            vm.titulo = "Inserir Versão Entregue";
            vm.versaoEntregue.dataVersaoGerada = new Date();
        }

        vm.versaoEntregue.sprintNumero = SprintNumero;
        vm.versaoEntregue.squadCodigo = SprintSquadCodigo;

        //endregion

        // Definição dos Métodos region
        var metodosInternos = {
            listarTodasSolucoes: listarTodasSolucoes,
            salvar: salvar,
            editar: editar,
            marcarCamposObrigatorios: marcarCamposObrigatorios
        };

        vm.metodosDialog = {
            persistirVersaoEntregue: persistirVersaoEntregue,
            excluir: excluir,
            fecharDialog: fecharDialog,
            configuraMdSelectVersaoEntregueSolucoes: configuraMdSelectVersaoEntregueSolucoes
        };
        //endregion

        // Implementação dos Métodos region

        function listarTodasSolucoes() {
            vm.requisicaSolicitada = true;
            RequisicaoGenericaService.listarSemParams(Api.solucao_rotinas_tarefas.solucao.listarTodos).then(
                function (success) {
                    vm.solucoes = success.data;
                    vm.requisicaSolicitada = false;
                },
                function (error) {
                    vm.requisicaSolicitada = false;
                    alert("Falha ao buscar solucões: \nDetalhes: " + error.data);
                    $mdDialog.hide();
                }
            );
        }

        function salvar(event, versaoEntregue) {
            vm.requisicaSolicitada = true;
            RequisicaoGenericaService.salvar(Api.sprint.versao_entrega.criar, versaoEntregue).then(
                function (success) {
                    MdToastService.toastPadrao("Versão cadastrada com sucesso!");

                    var rotaListar = Api.sprint.versao_entrega.listarPor + versaoEntregue.sprintNumero + "/" + versaoEntregue.squadCodigo;
                    RequisicaoGenericaService.listarSemParams(rotaListar).then(
                        function (listarSuccess) {
                            VersoesEntregues.length = 0;
                            Array.prototype.push.apply(VersoesEntregues, listarSuccess.data);
                            vm.requisicaSolicitada = false;
                            $mdDialog.hide();
                        },
                        function () {
                            vm.requisicaSolicitada = false;
                            $mdDialog.hide();
                        }
                    );
                },
                function (error) {
                    alert(error.data);
                    vm.requisicaSolicitada = false;
                }
            );
        }

        function editar(event, versaoEntregue) {
            vm.requisicaSolicitada = true;
            RequisicaoGenericaService.editar(Api.sprint.versao_entrega.atualizar, versaoEntregue).then(
                function (success) {
                    MdToastService.toastPadrao("Versão cadastrada com sucesso!");

                    angular.forEach(VersoesEntregues, function (item, index) {
                        if (item.codigo === success.data.codigo) {
                            VersoesEntregues[index] = success.data;
                        }
                    });

                    vm.requisicaSolicitada = false;
                    $mdDialog.hide();
                },
                function (error) {
                    alert("Falha ao editar a versão \nDetalhes: " + error.data);
                    vm.requisicaSolicitada = false;
                }
            );
        }

        function persistirVersaoEntregue(event, versaoEntregue) {
            if (vm.inserirAtivo) {
                metodosInternos.salvar(event, versaoEntregue);
            } else {
                metodosInternos.editar(event, versaoEntregue);
            }
        }

        function excluir(event, versaoEntregue) {
            ServicosGenericoService.excluirRegistroPorCodigoOuGenericamenteEmDialogs(
                Api.sprint.versao_entrega.excluir,
                VersoesEntregues,
                versaoEntregue,
                vm.preloader,
                $mdDialog,
                event,
                'Deseja realmente excluir está Versão ?'
            );
        }

        function fecharDialog() {
            $mdDialog.hide();
        }

        function configuraMdSelectVersaoEntregueSolucoes() {
            vm.filtrarSolucoesVersaoEntregue = "";
            angular.element('#dialog-versao-entregue-solucoes-md-select').on('keydown', function (ev) {
                ev.stopPropagation();
            });
        }

        // Marca campos obrigatórios como "tocados" para exibir erro ao abrir
        function marcarCamposObrigatorios() {
            $timeout(function () {
                if (!vm.form || !vm.form.dialogVersaoEntregue) return;
                var form = vm.form.dialogVersaoEntregue;

                // Marca o formulário como "submetido" e força os campos obrigatórios a exibirem erro
                form.$setSubmitted();

                // Campos obrigatórios que normalmente vêm vazios
                var campos = [
                    'sprintVersaoEntregueSolucoesMulti',
                    'sprintVersaoEntregueSolucoes',
                    'sprintVersaoEntregueNumero',
                    'sprintVersaoEntregueRelease',
                    'sprintVersaoEntregueCompatibilidade',
                    'sprintVersaoEntregueObservacao'
                ];

                campos.forEach(function (nomeCampo) {
                    if (form[nomeCampo]) {
                        form[nomeCampo].$setTouched();
                    }
                });
            }, 150);
        }

        //endregion

        // Execuções iniciais
        metodosInternos.listarTodasSolucoes();
        metodosInternos.marcarCamposObrigatorios();
        //endregion
    }

})();

/**
 * Created by nova on 26/10/2016.
 */
(function () {
    'use strict';

    angular
        .module('app.planejamentoScrum.processamento.sprint')
        .controller('SprintDialogRegistrosController', SprintDialogRegistrosController);


    function SprintDialogRegistrosController(SprintService, Api, RequisicaoGenericaService, MdToastService, $mdDialog, ServicosGenericoService, Registro, RegistrosSituacoes, Colaboradores, LoginUsuarioService, ControleForm, Sprint, ApenasVisualizacao) {

        var vm = this;

        // Data region
        vm.apenasVisualizacao = ApenasVisualizacao;
        vm.form = {};
        vm.inserirAtivo = null;
        vm.registro = {};
        vm.filtrarEstorias = "";

        vm.preloader = { habilitar: false };
        vm.requisicaoSolicitada = false;


        if (Registro) {
            vm.titulo = "Editar Registro";
            vm.inserirAtivo = false;
            vm.registro = angular.copy(Registro);
            vm.registro.estoria = {
                numero: Registro.estoriaNumero,
                ano: Registro.estoriaAno
            }
            if (vm.registro.duracao)
                vm.registro.duracao = vm.registro.duracao.substring(0, 5);
        } else {
            vm.titulo = "Inserir Registro";
            vm.inserirAtivo = true;
            vm.registro.data = new Date();
            vm.registro.usuarioCodigo = LoginUsuarioService.usuarioArmazenado().codigo;
        }
        vm.registro.SprintNumero = Sprint.numero;
        vm.registro.squadCodigo = Sprint.squadCodigo;
        //endregion

        init();

        // Resolve Region
        vm.registrosSituacoes = angular.copy(RegistrosSituacoes);
        vm.colaboradores = angular.copy(Colaboradores);
        //endregion

        // Definição dos Métodos region   
        var metodosInternos = {
            criar: criar,
            editar: editar
        };
        vm.metodosDialog = {
            configurarMdSelectEstoria: configurarMdSelectEstoria,
            salvar: selecionaMetodoInterno,
            excluir: excluirRegistro,
            fecharDialog: metodoDialogFecharDialog,
            configuraMdSelectColaboradoresRegistro: configuraMdSelectColaboradoresRegistro
        };
        //endregion

        // Implmentação dos Métodos Region

        // Métodos Internos region
        function init() {
            vm.requisicaoSolicitada = true;
            RequisicaoGenericaService.listarSemParams(Api.sprint.backlog.listarTodasEstoriasBacklog + Sprint.numero + "/" + Sprint.squadCodigo).then(
                function (success) {
                    vm.estoriasBacklog = success.data;
                    vm.requisicaoSolicitada = false;
                });
        }

        function criar(event, registro) {
            vm.requisicaoSolicitada = true;
            if (!registro.estoria) {
                registro.estoriaNumero = null;
                registro.estoriaAno = null;
            } else {
                registro.estoriaNumero = registro.estoria.numero;
                registro.estoriaAno = registro.estoria.ano;
            }
            RequisicaoGenericaService.salvar(Api.sprint.registro.criar, registro).then(
                function (success) {
                    MdToastService.toastPadrao("Registro cadastrado com sucesso!");

                    Sprint.registros.push(success.data.registro);

                    SprintService.verificaLegendasSelecionadasRegistros(success.data.totalHorasRegistros);
                    Sprint.totalDeHorasPorRegistroSituacao = success.data.totalHorasRegistros;

                    vm.requisicaoSolicitada = false;
                    $mdDialog.hide();
                },
                function (error) {
                    vm.requisicaoSolicitada = false;
                    alert(error.data);
                });
        }

        function editar(event, registro) {
            vm.requisicaoSolicitada = true;
            delete registro.registroSituacao;
            delete registro.usuario;
            if (!registro.estoria) {
                registro.estoriaNumero = null;
                registro.estoriaAno = null;
            } else {
                registro.estoriaNumero = registro.estoria.numero;
                registro.estoriaAno = registro.estoria.ano;
            }
            RequisicaoGenericaService.editar(Api.sprint.registro.atualizar, registro).then(
                function (success) {
                    MdToastService.toastPadrao("Registro editado com sucesso!");

                    SprintService.verificaLegendasSelecionadasRegistros(success.data.totalHorasRegistros);

                    Sprint.totalDeHorasPorRegistroSituacao = success.data.totalHorasRegistros;
                    angular.forEach(Sprint.registros, function (item, index) {
                        if (item.codigo === success.data.registro.codigo) {
                            Sprint.registros[index] = success.data.registro;
                        }
                    });

                    vm.requisicaoSolicitada = false;
                    $mdDialog.hide();
                },
                function (error) {
                    vm.requisicaoSolicitada = false;
                    alert("Falha ao editar o Registro: \nDetalhes: " + error.data);
                });
        }
        //endregion

        // Métodos Dialog region
        function selecionaMetodoInterno(event, registro) {
            if (vm.inserirAtivo) {
                metodosInternos.criar(event, registro);
            } else {
                metodosInternos.editar(event, registro);
            }
        }

        function excluirRegistro(event, registro) {
            var index = Sprint.registros.map(function (item) { return item.codigo }).indexOf(registro.codigo);
            ServicosGenericoService
                .excluirRegistroPorCodigoOuGenericamenteEmDialogs(Api.sprint.registro.excluir, Sprint.registros, registro, vm.preloader, null,
                    event, 'Deseja realmente excluir este Registro ?',
                    function (success) {
                        Sprint.totalDeHorasPorRegistroSituacao = success.data.totalHorasRegistros;
                        SprintService.verificaLegendasSelecionadasRegistros(success.data.totalHorasRegistros);

                        MdToastService.toastPadrao("Registro excluído com sucesso!");
                        $mdDialog.hide();
                    }, index);
        }

        function metodoDialogFecharDialog() {
            $mdDialog.hide();
        }

        function configurarMdSelectEstoria() {
            vm.filtrarEstorias = "";
            angular.element('#sprint-dialog-registros-md-select-estorias').on('keydown', function (ev) {
                ev.stopPropagation();
            });
        }

        function configuraMdSelectColaboradoresRegistro() {
            vm.filtrarColaboradorRegistro = "";
            angular.element('#dialog-registros-usuario-md-select').on('keydown', function (ev) {
                ev.stopPropagation();
            });
        }

        vm.diasDaSemanaMdDatePicker = function (data) {
            var diaDaSemana = data.getDay();
            return diaDaSemana > 0 && diaDaSemana < 6;
        }
        //endregion
        //endregion

    }

})();

(function () {
    'use strict';

    angular
        .module('app.planejamentoScrum.processamento.sprint')
        .controller('SprintDialogMetaController', SprintDialogMetaController);

    function SprintDialogMetaController(
        Api,
        RequisicaoGenericaService,
        $scope,
        $mdDialog,
        MdToastService,
        SprintNumero,
        SprintSquadCodigo,
        Metas,
        Meta,
        ServicosGenericoService,
        DataTableConfigPadrao,
        ApenasVisualizacao,
        EstoriaFactory,
        TiposMeta,
        $state

    ) {
        var vm = this;

        // Data region
        vm.apenasVisualizacao = ApenasVisualizacao;
        vm.meta = {};
        vm.form = {};
        vm.metaConcluida = {};
        vm.historiaHomologado = {};
        vm.inserirAtivo = null;
        vm.coresSituacoes = EstoriaFactory.coresSituacoes();
        _listarSolucoesVinculadasSquadSprint();
        vm.tiposMeta = TiposMeta;
        vm.estoria = {};

        vm.teste = function (item) {
            console.log(item);
            alert('Teste');
        }

        vm.requisicaSolicitada = false;
        vm.prelaoder = { habilitar: false };

        if (Meta) {
            vm.inserirAtivo = false;
            vm.titulo = "Editar Meta";
            vm.metaConcluida = angular.copy(Meta);
            vm.meta = angular.copy(Meta);
        } else {
            vm.inserirAtivo = true;
            vm.titulo = "Inserir Meta";
            vm.meta.sprintNumero = angular.copy(SprintNumero);
            vm.meta.squadCodigo = angular.copy(SprintSquadCodigo);
            vm.metaConcluida.sprintNumero = angular.copy(SprintNumero);
            vm.metaConcluida.squadCodigo = angular.copy(SprintSquadCodigo);
        }

        vm.dtOptionsMetas = angular.copy(
            DataTableConfigPadrao.dtOptionsPadraoComPaginacaoEReponsivo
        );
        vm.dtOptionsMetas.columnDefs = [DataTableConfigPadrao.columnDefsPadrao];
        vm.editar = Meta != undefined;

        init();
        //endregion

        $scope.$watch('vm.meta.metasEstorias', function () { });

        // Definição dos Métodos region
        var metodosInterno = {
            listarHomologados: listarHomologados,
            salvar: metodoInternoSalvar,
            editar: metodoInternoEditar,
            fecharDialogAtualizandoMeta: fecharDialogAtualizandoMeta,
            listarTodasEstoriasBacklog: listarTodasEstoriasBacklog,
        };
        vm.metodosDialog = {
            salvar: selecionaMetodoInterno,
            excluir: excluir,
            fecharDialog: fecharDialog,
            configuraMdSelectEstoriasMetas: configuraMdSelectEstoriasMetas,
            configuraMdSelectSolucao: configuraMdSelectSolucao,
            adicionarEstoriaNaMeta: adicionarEstoriaNaMeta,
            abrirEstoria: abrirEstoria,
        };
        //endregion

        // Implementação dos Métodos region

        // Métodos Interno region
        function init() {
            vm.requisicaoSolicitada = true;
            if (vm.editar) {
                vm.metaCodigo = Meta.codigo;
                RequisicaoGenericaService.listarSemParams(Api.sprint.meta.ListarEstoria + SprintNumero + '/' + SprintSquadCodigo + '/' + vm.metaCodigo).then(
                    function (success) {
                        vm.estoriasBacklog = success.data;
                        vm.requisicaoSolicitada = false;
                    },
                    function (error) {
                        vm.requisicaSolicitada = false;
                        alert("Falha ao buscar metas " + error.data);
                    });

            } else {
                vm.metaCodigo = 0;
                RequisicaoGenericaService.listarSemParams(Api.sprint.meta.ListarEstoria + SprintNumero + '/' + SprintSquadCodigo + '/' + vm.metaCodigo).then(
                    function (success) {
                        vm.estoriasBacklog = success.data;
                        vm.requisicaoSolicitada = false;
                    },
                    function (error) {
                        vm.requisicaSolicitada = false;
                        alert("Falha ao buscar metas " + error.data);
                    });

            }

        }

        function listarHomologados(estorias) {
            console.log(estorias);
        }

        function listarTodasEstoriasBacklog() {
            vm.requisicaSolicitada = true;
            RequisicaoGenericaService
                .listarTodosComParametrosPelaUrl(Api.sprint.backlog.listarTodasEstoriasBacklog, SprintNumero, SprintSquadCodigo).then(
                    function (success) {
                        vm.estoriasBacklog = success.data;
                        vm.requisicaSolicitada = false;
                    },
                    function (error) {
                        vm.requisicaSolicitada = false;
                        alert("Falha ao buscar Estórias do Backlog: \nDetalhes: " + error.data);
                        $mdDialog.hide();
                    });
        }

        function metodoInternoSalvar(event, meta) {
            vm.requisicaSolicitada = true;
            RequisicaoGenericaService.salvar(Api.sprint.meta.criar, meta).then(
                function (success) {
                    MdToastService.toastPadrao("Meta cadastrada com sucesso!");
                    Metas.push(success.data);
                    vm.requisicaSolicitada = false;
                    vm.houveAlteracoes = true;
                    $mdDialog.hide(meta);
                },
                function (error) {
                    vm.requisicaSolicitada = false;
                    alert("Falha ao criar a Meta: \nDetalhes: " + error.data);
                });
        }

        function metodoInternoEditar(event, meta) {
            vm.requisicaSolicitada = true;
            RequisicaoGenericaService.editar(Api.sprint.meta.atualizar, meta).then(
                function (success) {
                    MdToastService.toastPadrao("Meta editada com sucesso!");
                    vm.houveAlteracoes = true;
                    angular.forEach(Metas, function (item, index) {
                        if (item.codigo === success.data.codigo) {
                            Metas[index] = success.data;
                        }
                    })

                    vm.requisicaSolicitada = false;
                    var retorno = success.data.metasEstorias.map(function (item) {
                        item.sprintMetaCodigo = 1;
                    })
                    $mdDialog.hide(retorno);
                },
                function (error) {
                    vm.requisicaSolicitada = false;
                    alert("Falha ao editar a Meta: \nDetalhes: " + error.data);
                });
        }

        function fecharDialogAtualizandoMeta() {
            AtualizarMeta.atualizar();
            $mdDialog.hide();
        }
        //endregion

        // Métodos Dialog region
        function selecionaMetodoInterno(event, meta) {
            if (vm.inserirAtivo) {
                metodosInterno.salvar(event, meta);
            } else {
                metodosInterno.editar(event, meta);
            }
        }

        function excluir(event, meta) {
            ServicosGenericoService
                .excluirRegistroPorCodigoOuGenericamenteEmDialogs(
                    Api.sprint.meta.excluir, Metas, meta, vm.prelaoder, $mdDialog,
                    event, 'Deseja realmente excluir esta meta?');
        }

        function fecharDialog() {
            $mdDialog.hide(vm.houveAlteracoes);
        }

        function configuraMdSelectEstoriasMetas() {
            vm.filtrarEstoriasMetas = "";
            angular
                .element('#dialog-metas-estorias-md-select')
                .on('keydown', function (ev) {
                    ev.stopPropagation();
                });
        }

        function adicionarEstoriaNaMeta(estorias) {
            vm.metaConcluida.metasEstorias.push(estorias);
        }

        function configuraMdSelectSolucao() {
            vm.filtrarSolucoes = '';
            angular
                .element('#tab-meta-solucao-md-select')
                .on('keydown', function (ev) {
                    ev.stopPropagation();
                });
        }

        function abrirEstoria(meta) {
            $state.goNewTab("app.planejamento_processamento_estoria", {
                parametros: {
                    numero: meta.numero,
                    ano: meta.ano,
                    squadCodigo: SprintSquadCodigo,
                    chamarPesquisa: true
                }
            });
        }

        function _listarSolucoesVinculadasSquadSprint() {
            var url = Api.solucao_rotinas_tarefas.solucao.listarPorSquadCliente;
            var entidadeEnvio = {
                codigoCliente: null,
                codigoSquads: [SprintSquadCodigo],
                exibirSolucaoComSquad: true
            }
            return RequisicaoGenericaService.listarPorPaginacaoJsonFormato(url, entidadeEnvio)
                .then(function (success) {
                    vm.solucoes = success.data;
                })
                .catch(function (error) {
                    vm.solucoes = [];
                })
        }
    }
})();
/**
 * Created by nova on 14/11/2016.
 */
(function () {
    'use strict';

    angular
        .module('app.planejamentoScrum.processamento.sprint')
        .controller('SprintDialogCerimoniaDetalheController', SprintDialogCerimoniaDetalheController);


    function SprintDialogCerimoniaDetalheController
        (
            $mdDialog, ControleForm, SprintNumero, RequisicaoGenericaService, Api, MdToastService, DetalhesDasCerimonias, CerimoniaDetalhe, Cerimonias, ServicosGenericoService, ApenasVisualizacao, SprintSquadCodigo) {

        var vm = this;

        //<editor-fold desc="Data">
        // Data region
        vm.apenasVisualizacao = ApenasVisualizacao;
        vm.cerimonias = Cerimonias;
        vm.cerimoniaDetalhe = {};
        vm.form = {};
        vm.inserirAtivo = null;

        vm.requisicaSolicitada = false;
        vm.preloader = { habilitar: false };

        if (CerimoniaDetalhe) {
            vm.inserirAtivo = false;
            vm.titulo = "Editar Cerimônia Detalhe";
            vm.cerimoniaDetalhe = angular.copy(CerimoniaDetalhe);
            if (CerimoniaDetalhe.horaInicial) {
                vm.cerimoniaDetalhe.horaInicial = vm.cerimoniaDetalhe.horaInicial.substring(0, 5);
            }
            if (CerimoniaDetalhe.horaFinal) {
                vm.cerimoniaDetalhe.horaFinal = vm.cerimoniaDetalhe.horaFinal.substring(0, 5);
            }
        } else {
            vm.inserirAtivo = true;
            vm.titulo = "Inserir Cerimônia Detalhe";
            vm.cerimoniaDetalhe.data = new Date();
        }
        vm.cerimoniaDetalhe.SprintNumero = SprintNumero;
        vm.cerimoniaDetalhe.squadCodigo = SprintSquadCodigo;
        //endregion
        //</editor-fold>

        //<editor-fold desc="Definição dos Métodos">
        // Definição dos Métodos region
        var metodosInternos = {
            salvar: salvar,
            editar: editar,
        };
        vm.metodosDialog = {
            persistirCerimoniaDetalhe: persistirCerimoniaDetalhe,
            excluir: excluir,
            fecharDialog: fecharDialog
        };
        //endregion
        //</editor-fold>

        //<editor-fold desc="Implementação dos Métodos">
        // Implementação dos Métodos region

        //<editor-fold desc="Métodos Internos">
        // Métodos Internos region
        function salvar(event, cerimoniaDetalhe) {
            vm.requisicaSolicitada = true;
            RequisicaoGenericaService.salvar(Api.sprint.cerimonia_detalhe.criar, cerimoniaDetalhe).then(
                function (success) {
                    MdToastService.toastPadrao("Cerimônia cadastrada com sucesso!");

                    DetalhesDasCerimonias.push(success.data);

                    vm.requisicaSolicitada = false;
                    $mdDialog.hide();
                },
                function (error) {
                    alert(error.data);
                    vm.requisicaSolicitada = false;
                });
        }

        function editar(event, cerimoniaDetalhe) {
            vm.requisicaSolicitada = true;
            RequisicaoGenericaService.editar(Api.sprint.cerimonia_detalhe.atualizar, cerimoniaDetalhe).then(
                function (success) {
                    MdToastService.toastPadrao("Cerimônia editada com sucesso!");

                    angular.forEach(DetalhesDasCerimonias, function (item, index) {
                        if (item.codigo === success.data.codigo) {
                            DetalhesDasCerimonias[index] = success.data;
                        }
                    });

                    vm.requisicaSolicitada = false;
                    $mdDialog.hide();
                },
                function (error) {
                    alert("Falha ao editar a Cerimônia \nDetalhes: " + error.data);
                    vm.requisicaSolicitada = false;
                });
        }
        //endregion
        //</editor-fold>

        //<editor-fold desc="Métodos Dialog">
        // Métodos Dialog region
        function persistirCerimoniaDetalhe(event, cerimoniaDetalhe) {
            if (vm.inserirAtivo) {
                metodosInternos.salvar(event, cerimoniaDetalhe);
            } else {
                metodosInternos.editar(event, cerimoniaDetalhe);
            }
        }

        function excluir(event, cerimoniaDetalhe) {
            ServicosGenericoService
                .excluirRegistroPorCodigoOuGenericamenteEmDialogs(Api.sprint.cerimonia_detalhe.excluir, DetalhesDasCerimonias, cerimoniaDetalhe, vm.preloader, $mdDialog,
                    event, 'Deseja realmente excluir a Cerimônia ?');
        }

        function fecharDialog() {
            $mdDialog.hide();
        }
        //endregion
        //</editor-fold>

        //endregion
        //</editor-fold>
    }

})();

(function () {
    'use strict';

    angular
        .module('app.planejamentoScrum.processamento.estoria')
        .controller("EdicaoClientesVinculadosDialogController", EdicaoClientesVinculadosDialogController);

    function EdicaoClientesVinculadosDialogController(UsuarioEstoriaLogado, Estoria, Cliente, CampoClienteASerEditado, ListarTodosUsuarios, $mdDialog, Api, RequisicaoGenericaService, MdDialogService, VersoesGeradas) {
        var vm = this;
        vm.titulo = '';
        vm.estoria = angular.copy(Estoria);
        vm.usuarioEstoriaLogado = UsuarioEstoriaLogado;
        vm.campoClienteASerEditado = angular.copy(CampoClienteASerEditado);
        vm.cliente = angular.copy(Cliente);
        vm.todosUsuarios = angular.copy(ListarTodosUsuarios);
        vm.versoesGeradas = angular.copy(VersoesGeradas);
        var hoje = new Date();
        var dataMaxima = new Date();
        vm.dataAtualizacaoMaxima = new Date();
        dataMaxima.setDate(hoje.getDate() + 30);
        vm.dataMaximaPermitida = dataMaxima;

        init();

        vm.metodos = {
            closeDialog: closeDialog,
            salvar: salvar,
            pesquisarAutoCompleteClienteVinculado: pesquisarAutoCompleteClienteVinculado,
            configuraAutoCompleteVersaoOnBlur: configuraAutoCompleteVersaoOnBlur,
            alterarItemSelecionadoAutoCompleteVersao: alterarItemSelecionadoAutoCompleteVersao,
        }

        function init() {
            _configurarDialog();
            _setarValoresCliente();
        }

        function _configurarDialog() {
            if (CampoClienteASerEditado === 'dataPrevisaoAtualizacao') {
                vm.titulo = 'Editando data de previsão de atualização do cliente';
            }
            if (CampoClienteASerEditado === 'dataAtualizacao' || CampoClienteASerEditado === 'versao') {
                vm.titulo = 'Editando data de atualização e versão do cliente';
            }
            if (CampoClienteASerEditado === 'responsavel') {
                vm.titulo = 'Editando responsável';
            }
            if (CampoClienteASerEditado === 'observacao') {
                vm.titulo = 'Editando observação';
            }
        }

        function _setarValoresCliente() {
            if (Cliente.observacao) {
                vm.cliente.observacao = Cliente.observacao;
            }
            if (Cliente.usuarioCodigo) {
                vm.cliente.usuarioCodigo = Cliente.usuarioCodigo;
            }
            if (Cliente.dataAtualizacao) {
                vm.cliente.dataAtualizacao = new Date(Cliente.dataAtualizacao);
            }
            if (Cliente.versao) {
                var versaoObj = null;
                if (Array.isArray(vm.versoesGeradas)) {
                    versaoObj = vm.versoesGeradas.find(function (v) {
                        return v.codigo === Cliente.versao || v.numero === Cliente.versao;
                    });
                }
                vm.cliente.versao = versaoObj || Cliente.versao;
            }
            if (Cliente.dataPrevisaoAtualizacao) {
                vm.cliente.dataPrevisaoAtualizacao = new Date(Cliente.dataPrevisaoAtualizacao);
            }
        }

        function closeDialog() {
            $mdDialog.hide();
        }

        function salvar(informacoesClienteVinculado) {
            vm.requisicaSolicitada = true;
            var entidadeEnvio = {
                estoriaNumero: vm.estoria.numero,
                estoriaAno: vm.estoria.ano,
                estoriaSquadCodigo: vm.estoria.squadCodigo,
                clienteCodigo: Cliente.clienteCodigo,
                codigo: Cliente.codigo,
                dataPrevisaoAtualizacao: informacoesClienteVinculado.dataPrevisaoAtualizacao ? informacoesClienteVinculado.dataPrevisaoAtualizacao : null,
                dataAtualizacao: informacoesClienteVinculado.dataAtualizacao ? informacoesClienteVinculado.dataAtualizacao : null,
                observacao: informacoesClienteVinculado.observacao ? informacoesClienteVinculado.observacao : null,
                usuarioCodigo: (informacoesClienteVinculado.dataPrevisaoAtualizacao || informacoesClienteVinculado.dataAtualizacao) ? vm.usuarioEstoriaLogado.codigo : null,
                versao: (informacoesClienteVinculado.versao && informacoesClienteVinculado.versao.codigo)
                    ? informacoesClienteVinculado.versao.codigo
                    : null,

            }
            RequisicaoGenericaService.editar(Api.estoria.clientes.atualizar, entidadeEnvio).then(
                function (success) {
                    var dadosAtualizados = {
                        listaClientesVinculadosAtualizados: success.data,
                        informacoesClienteVinculado: informacoesClienteVinculado
                    }
                    $mdDialog.hide(dadosAtualizados);
                },
                function (error) {
                    MdDialogService.alertPadrao(error.data);
                }
            ).finally(function () {
                vm.requisicaSolicitada = false;
            });
        }

        function pesquisarAutoCompleteClienteVinculado(query) {
            if (!query) return vm.versoesGeradas;
            query = query.toLowerCase();
            return vm.versoesGeradas.filter(function (item) {
                var textoCompleto = (item.numero ? item.numero : '') + ' - ' + (item.release ? item.release : '') + (item.compatibilidade ? ' - ' + item.compatibilidade : '');
                return textoCompleto.toLowerCase().includes(query);
            });
        }

        function alterarItemSelecionadoAutoCompleteVersao(item) {
            if (item) {
                vm.cliente.versao = item;
            } else {
                vm.textoDePesquisaAutoCompleteVersao = "";
                vm.cliente.versao = null;
            }
        }

        function configuraAutoCompleteVersaoOnBlur() {
            if (!vm.cliente.versao) {
                vm.textoDePesquisaAutoCompleteVersao = "";
            }
        }
    }
})();

/**
 * Created by nova on 05/09/2016.
 */
(function () {
    'use strict';

    angular
        .module('app.planejamentoScrum.processamento.estoria')
        .controller("DialogHistoricoSituacaoController", DialogHistoricoSituacaoController);

    function DialogHistoricoSituacaoController(
        Api,
        RequisicaoGenericaService,
        MdToastService,
        MdDialogService,
        ServicosGenericoService,
        $mdDialog,
        ControleForm,
        Estoria,
        HistoricoSituacao,
        Situacoes,
        UsuarioEstoriaLogado
    ) {
        var vm = this;

        // Data region
        vm.requisicaSolicitada = false;
        vm.preloader = { habilitar: false };

        vm.historicoSituacao = {};
        vm.usuarioEstoriaLogado = UsuarioEstoriaLogado;
        vm.situacoes = angular.copy(Situacoes);

        vm.motivoCodigo = Estoria.motivoCodigo;
        var dataTemporaria;


        if (HistoricoSituacao) {
            vm.titulo = "Editar histórico de situação";
            vm.novoHistoricoSituacao = false;
            vm.historicoSituacao = angular.copy(HistoricoSituacao);
            dataTemporaria = new Date(HistoricoSituacao.data);
            if (vm.historicoSituacao.situacao.codigo !== 15) {
                vm.situacoes = angular.copy(Situacoes).filter(function (situacao) {
                    return situacao.codigo !== 15;
                });
            } else {
                vm.situacoes = angular.copy(Situacoes);
            }
        } else {
            vm.titulo = "Inserir histórico de situação";
            vm.novoHistoricoSituacao = true;
            vm.historicoSituacao = {
                estoriaNumero: Estoria.numero,
                estoriaAno: Estoria.ano,
                estoriaSquadCodigo: Estoria.squadCodigo,
                data: new Date()
            };
            vm.situacoes = angular.copy(Situacoes).filter(function (situacao) {
                return situacao.codigo !== 15;
            });
            dataTemporaria = new Date();
        }
        //endregion
        //</editor-fold>
        if (HistoricoSituacao && HistoricoSituacao.situacao.descricao == "Homologada") {
            buscaPontosInicias(
                HistoricoSituacao.situacao.descricao,
                HistoricoSituacao.estoriaNumero,
                HistoricoSituacao.estoriaAno
            );
        }
        //<editor-fold desc="Definição dos Métodos">
        // Definição dos Métodos region
        var metodosInternos = {
            salvar: metodoInternoSalvar,
            editar: metodoInternoEditar

        };
        vm.metodosDialog = {
            salvar: metodoDialogSalvar,
            excluir: metodoDialogExcluir,
            fecharDialog: metodoDialogFecharDialog,
            buscaPontosInicias: buscaPontosInicias,
            configuraMdSelectSituacao: configuraMdSelectSituacao
        };
        //endregion
        //</editor-fold>

        //<editor-fold desc="Implementação dos Métodos">
        // Implementação dos Métodos region

        //<editor-fold desc="Métodos Interno">
        // Métodos Interno region
        function metodoInternoSalvar(event, historicoSituacao) {
            vm.requisicaSolicitada = true;
            RequisicaoGenericaService.salvar(Api.estoria.historico.criar, historicoSituacao).then(
                function (success) {
                    MdToastService.toastPadrao("Histórico de situação cadastrado com sucesso!");

                    Estoria.historicoSituacao.push(success.data);
                    Estoria.situacaoAtualHistoria = success.data.situacao;

                    vm.requisicaSolicitada = false;
                    $mdDialog.hide(success.data.situacao.codigo);
                },
                function (error) {
                    vm.requisicaSolicitada = false;
                    MdDialogService.alertPadrao("Atenção", event, error.data);
                });
        }

        function metodoInternoEditar(event, historicoSituacao) {
            var situacaoAnterior = angular.copy(Estoria.situacaoAtualHistoria);
            vm.requisicaSolicitada = true;

            RequisicaoGenericaService.editar(Api.estoria.historico.atualizar, historicoSituacao).then(
                function (success) {
                    MdToastService.toastPadrao("Histórico de situação alterado com sucesso!");

                    angular.forEach(Estoria.historicoSituacao, function (item, index) {
                        if (item.codigo === success.data.codigo) {
                            Estoria.historicoSituacao[index] = success.data;
                            Estoria.situacaoAtualHistoria = success.data.situacao;
                        }
                    });

                    vm.requisicaSolicitada = false;

                    if (success.data.situacao.codigo == 12 || success.data.situacao.codigo == 13) {
                        $mdDialog.hide(success.data.situacao.codigo);
                    } else {
                        $mdDialog.hide(situacaoAnterior.codigo);
                    }

                },
                function (error) {
                    vm.requisicaSolicitada = false;
                    MdDialogService.alertPadrao("Atenção", event, error.data);
                });
        }

        //endregion
        //</editor-fold>

        //<editor-fold desc="Métodos Dialog">
        // Métodos Dialog region
        function metodoDialogSalvar(event, historicoSituacao) {
            historicoSituacao.situacaoCodigo = historicoSituacao.situacao.codigo;
            if (!historicoSituacao.situacao.exigeMotivo) {
                delete historicoSituacao.observacaoMotivoPausa;
            }
            delete historicoSituacao.usuario;
            delete historicoSituacao.situacao;


            if (dataTemporaria.getTime() !== new Date(historicoSituacao.data).getTime()) {
                historicoSituacao.data = ServicosGenericoService.retornaHoraFormataComTempo(historicoSituacao.data);
            }
            if (vm.novoHistoricoSituacao) {
                metodosInternos.salvar(event, historicoSituacao);
            } else {
                metodosInternos.editar(event, historicoSituacao);
            }
        }

        function metodoDialogExcluir(historicoSituacao, event) {
            var index = Estoria.historicoSituacao
                .map(function (item) { return item.codigo })
                .indexOf(historicoSituacao.codigo);

            ServicosGenericoService.excluirRegistroPorCodigoOuGenericamenteEmDialogs(
                Api.estoria.historico.excluir,
                Estoria.historicoSituacao,
                historicoSituacao,
                vm.preloader,
                $mdDialog,
                event,
                'Deseja realmente excluir este Histórico ?',
                _alterarSituacaoAtualHistoria,
                index,
                "",
                historicoSituacao.codigo + "/" + historicoSituacao.estoriaNumero + "/" + historicoSituacao.estoriaAno + "/" + historicoSituacao.estoriaSquadCodigo
            );

        }

        function metodoDialogFecharDialog() {
            $mdDialog.hide();
        }

        function configuraMdSelectSituacao() {
            vm.filtrarSituacoes = "";
            angular.element('#estoria-dialog-historico-situacao-md-select').on('keydown', function (ev) {
                ev.stopPropagation();
            });
        }
        function buscaPontosInicias(situacao, numero, ano) {
            if (situacao == "Homologada") {
                RequisicaoGenericaService.listarSemParams(
                    Api.estoria.listarPontuacao + "?numero=" + numero + "&ano=" + ano + "&squadCodigo=" + vm.historicoSituacao.estoriaSquadCodigo
                ).then(
                    function (success) {
                        vm.historicoSituacao.pontosEntregue = success.data.pontuacaoEntregue;
                        vm.pontos = success.data.pontuacaoTotal;

                        vm.mensagemPreloader = "";
                        vm.requisicaoSolicitada = false;
                    },
                    function (error) {
                        MdDialogService.alertPadrao(error.data);
                        vm.mensagemPreloader = "";
                        vm.requisicaoSolicitada = false;
                    }
                );
            }
        }

        function _alterarSituacaoAtualHistoria(success) {
            var situacaoAnterior = angular.copy(Estoria.situacaoAtualHistoria);
            Estoria.situacaoAtualHistoria = Estoria.historicoSituacao[0].situacao;

            MdToastService.toastPadrao(success.data);

            $mdDialog.hide(situacaoAnterior.codigo);
        }
        //endregion
        //</editor-fold>

        //endregion
        //</editor-fold>
    }

})();

(function () {
    'use strict';

    angular
        .module('app.pesquisa', [
            'app.pesquisa.cadastro',
            'app.pesquisa.processamento'
        ]);

}());
(function () {
    'use strict';

    angular
        .module('app.pesquisa')
        .controller('DialogPerguntasController', DialogPerguntasController);

    function DialogPerguntasController(
        $mdDialog,
        MdDialogService,
        MdToastService,
        Pesquisa,
        Pergunta) {

        var vm = this;

        vm.emProgresso = false;
        vm.preloader = { habilitar: false };

        vm.pergunta = {
            permitirPerguntaAberta: false
        };
        vm.pesquisa = Pesquisa;
        vm.inserirAtivo = !Pergunta;

        if (Pergunta) {
            vm.titulo = "Editar pergunta";
            vm.pergunta = Pergunta;
        }
        else {
            vm.titulo = "Inserir pergunta";
            vm.pergunta.notaMinima = 1;
            vm.pergunta.notaMaxima = 5;
        }

        vm.metodos = {
            salvar: verificaSalvarOuEditarRotinas,
            fecharDialog: fecharDialog,
            changePermitirRespostaAberta: changePermitirRespostaAberta,
            changeNotaMaxima: changeNotaMaxima
        };

        function verificaSalvarOuEditarRotinas(rotina) {
            if (vm.inserirAtivo) {
                salvar(rotina);
            }
            else {
                editar(rotina);
            }
        }

        function salvar() {
            MdToastService.toastPadrao("Pergunta cadastrada com sucesso!");
            vm.pesquisa.perguntas.push(vm.pergunta);

            MdDialogService.confirmPadraoComEvento(
                "Deseja cadastrar outra pergunta?",
                null,
                null,
                function () {
                    vm.pergunta = {
                        permitirPerguntaAberta: false
                    };
                },
                function () {
                    $mdDialog.hide(true);
                });
        }

        function editar() {
            MdToastService.toastPadrao("Pergunta atualizada com sucesso!");
            $mdDialog.hide(true);
        }

        function changePermitirRespostaAberta(permitirRespostaAberta) {
            vm.pergunta.notaMinima = null;
            vm.pergunta.notaMaxima = null;
            vm.pergunta.tamanhoMaximoResposta = null;
            if (!permitirRespostaAberta) {
                vm.pergunta.notaMinima = 1;
                vm.pergunta.notaMaxima = 5;
            }
        }

        function changeNotaMaxima(form) {
            if (vm.pergunta.notaMinima >= vm.pergunta.notaMaxima) {
                form.notaMaxima.$setValidity("tamanhoMinimo", false);
            } else {
                form.notaMaxima.$setValidity("tamanhoMinimo", true);
            }
        }

        function fecharDialog() {
            $mdDialog.hide();
        }
    }
})();

(function () {
    "use strict";

    angular
        .module("app.locacao.processamento.locacao.retorno.locacao_retorno",[])
        .config(config);

    function config($stateProvider,RotasHtml) {
        var rotasHtmlLocacaoRetorno = RotasHtml.locacao_retorno;
        $stateProvider.state(
            "app.locacao_processamento_retorno",{
            url: "/locacao/processamento/locacao/retorno",
            module: "privado",
            views: {
                "content@app": {
                    templateUrl: rotasHtmlLocacaoRetorno.templateUrl,
                    controller: "LocacaoRetornoController as vm"
                },
                "locacao-retorno-form@app.locacao_processamento_retorno": {
                    templateUrl: rotasHtmlLocacaoRetorno.form
                },
                "locacao-retorno-tabela@app.locacao_processamento_retorno": {
                    templateUrl: rotasHtmlLocacaoRetorno.tabela
                },
                "contrato-step@app.locacao_processamento_retorno": {
                    templateUrl: rotasHtmlLocacaoRetorno.step.contrato
                },
                "retorno-step@app.locacao_processamento_retorno": {
                    templateUrl: rotasHtmlLocacaoRetorno.step.retorno
                }
            },
            resolve: {
                ListarDetalhe: function (Api,RequisicaoGenericaLocacaoService) {
                    return RequisicaoGenericaLocacaoService.listarSemParams(Api.locacao.nota_item_detalhe.listarTodos);
                },
                ListarClientes: function (Api,RequisicaoGenericaService) {
                    return RequisicaoGenericaService.listarSemParams(Api.protecao.atualizacaoLicenca.listar);
                },
                ListarTipoRetorno: function (Api,RequisicaoGenericaLocacaoService) {
                    return RequisicaoGenericaLocacaoService.listarSemParams(Api.locacao.retornoLocacao.listarTodos)
                }
            }
        });
    }

})();
(function () {
    'use strict';

    angular
        .module('app.locacao.processamento.locacao.retorno.locacao_retorno')
        .controller('DialogEstadoConservacaoRetornoController',DialogEstadoConservacaoRetornoController)

    /** @ngInject */
    function DialogEstadoConservacaoRetornoController(
        $mdDialog,
        EquipamentoEstadoConservacao,
        EstadoConservacaoId,
        $scope,
        ArquivosService,
        MdDialogService,
        RotasHtml
    ) {
        var vm = this;
        vm.locacaoEnvio = {};
        vm.rotasHtml = RotasHtml.locacao_envio;
        vm.locacaoEnvio.fotos = [];

        vm.locacaoEnvio.equipamentoEstadoConservacao = EquipamentoEstadoConservacao[0];

        if (EstadoConservacaoId.id == 1)
            vm.locacaoEnvio.equipamentoEstadoConservacao.id = 1;

        else
            vm.locacaoEnvio.equipamentoEstadoConservacao = EstadoConservacaoId;


        vm.equipamentoEstadoConservacao = EquipamentoEstadoConservacao;

        vm.metodos = {
            cancel: cancel,
            dialogEstadoConservacao: dialogEstadoConservacao,
            dialog: dialog,
        };

        init();

        function init() {

        }

        function dialog(modelo,item) {
            vm.equipamentoEstadoConservacao.filter(function (conservacao) {
                if (conservacao.id == modelo.equipamentoEstadoConservacao)
                    modelo.estadoConservacao = conservacao;
            });
            $mdDialog.hide(modelo);
        }

        function cancel() {
            $mdDialog.cancel();
        }

        function dialogEstadoConservacao() {
            $mdDialog.hide();
        }

    }

}());

(function () {
    'use strict';

    angular
        .module('app.pipeline.processamento.pipelineNegocio')
        .controller('FiltrosNegocioSidenavController', FiltrosNegocioSidenavController);

    function FiltrosNegocioSidenavController(msUtils, PipelineNegocioFactory, ServicosGenericoService, $scope) {
        var vm = this;

        vm.filtrarCards = PipelineNegocioFactory.filtrosCard;
        vm.etapasFunil = PipelineNegocioFactory.etapasFunil;
        vm.etapasFunilFiltro = PipelineNegocioFactory.etapasFunilFiltro;

        vm.exists = msUtils.exists;
        vm.limparFiltrosCard = PipelineNegocioFactory.limparFiltrosCardRedefinindoEtapasFunil;
        vm.exibirButtonLimparFiltros = PipelineNegocioFactory.exibirButtonLimparFiltros;
        vm.filtrarClientesChange = filtrarClientesChange;
        vm.filtrarColaboradoresResponsaveisChange = filtrarColaboradoresResponsaveisChange;
        vm.filtrarProdutosChange = filtrarProdutosChange;
        vm.filtrarValorChange = filtrarValorChange;

        $scope.$watch('vm.filtrarCards.clientesFiltros', function (newVal, oldVal) {
            if (newVal !== oldVal) {
                filtrarClientesChange();
            }
        }, true);

        $scope.$watch('vm.filtrarCards.colaboradoresResponsaveisFiltrados', function (newVal, oldVal) {
            if (newVal !== oldVal) {
                filtrarColaboradoresResponsaveisChange();
            }
        }, true);

        $scope.$watch('vm.filtrarCards.produtosFiltros', function (newVal, oldVal) {
            if (newVal !== oldVal) {
                filtrarProdutosChange();
            }
        }, true);

        $scope.$watchGroup(['vm.filtrarCards.valorDe', 'vm.filtrarCards.valorAte'], function (newVal, oldVal) {
            filtrarValorChange();
        });

        function filtrarClientesChange() {
            vm.etapasFunilFiltro.codigoClientes = [];

            if (vm.filtrarCards.clientesFiltros && vm.filtrarCards.clientesFiltros.length > 0) {
                vm.filtrarCards.clientesFiltros.forEach(function (cliente) {
                    vm.etapasFunilFiltro.codigoClientes.push(cliente.codigoCliente);
                });
            }

            PipelineNegocioFactory.pesquisarEtapasFunil(vm.etapasFunilFiltro).then(function () {
            });
        }

        function filtrarColaboradoresResponsaveisChange() {
            vm.etapasFunilFiltro.codigoExecutivoContasResponsavel = [];

            if (vm.filtrarCards.colaboradoresResponsaveisFiltrados && vm.filtrarCards.colaboradoresResponsaveisFiltrados.length > 0) {
                vm.filtrarCards.colaboradoresResponsaveisFiltrados.forEach(function (colaborador) {
                    vm.etapasFunilFiltro.codigoExecutivoContasResponsavel.push(colaborador.codigoExecutivoContasResponsavel);
                });
            }

            PipelineNegocioFactory.pesquisarEtapasFunil(vm.etapasFunilFiltro).then(function () {
            });
        }

        function filtrarProdutosChange() {
        }

        function filtrarValorChange() {
        }
    }

})();
(function () {
    "use strict";

    angular
        .module("app.locacao.processamento.locacao.envio.locacao_envio", [])
        .config(config);

    function config($stateProvider, RotasHtml) {
        var rotasHtmlLocacaoEnvio = RotasHtml.locacao_envio;
        $stateProvider.state(
            "app.locacao_processamento_envio", {
            url: "/locacao/processamento/locacao/envio",
            module: "privado",
            views: {
                "content@app": {
                    templateUrl: rotasHtmlLocacaoEnvio.templateUrl,
                    controller: "LocacaoEnvioController as vm"
                },
                "locacao-envio-form@app.locacao_processamento_envio": {
                    templateUrl: rotasHtmlLocacaoEnvio.form
                },
                "locacao-envio-tabela@app.locacao_processamento_envio": {
                    templateUrl: rotasHtmlLocacaoEnvio.tabela
                },
                "contrato-step@app.locacao_processamento_envio": {
                    templateUrl: rotasHtmlLocacaoEnvio.step.contrato
                },
                "envio-step@app.locacao_processamento_envio": {
                    templateUrl: rotasHtmlLocacaoEnvio.step.envio
                }
            },
            resolve: {
                ListarDetalhe: function (Api, RequisicaoGenericaLocacaoService) {
                    return RequisicaoGenericaLocacaoService.listarSemParams(Api.locacao.nota_item_detalhe.listarDisponiveisEnvio);
                },
                ListarClientes: function (Api, RequisicaoGenericaService) {
                    return RequisicaoGenericaService.listarSemParams(Api.protecao.atualizacaoLicenca.listar);
                }
            }
        });
    }

})();
(function () {
  "use strict";

  angular
    .module("app.locacao.processamento.locacao.envio.locacao_envio")
    .controller(
      "DialogZoomFotoController",
      DialogZoomFotoController
    );

  /** @ngInject */
  function DialogZoomFotoController(
    $mdDialog,
    $scope,
    Foto,
    Servidor
  ) {
    var vm = this;
    vm.foto = Foto;
    vm.servidor = Servidor;
    vm.metodos = {
      cancel: cancel
    };

   function cancel() {
     $mdDialog.cancel();
   }
  }
})();

(function () {
    "use strict";

    angular
        .module("app.locacao.processamento.locacao.retorno.locacao_retorno")
        .controller("DialogRetornarTodosController",DialogRetornarTodosController);

    /** @ngInject */
    function DialogRetornarTodosController(
        Api,
        $mdDialog,
        RotasHtml,
        Contrato,
        Locados,
        MdDialogService,
        AtualizacaoLicencaFactory,
        RequisicaoGenericaLocacaoService
    ) {
        var vm = this;
        vm.estadoConservacaoId = 1;
        vm.rotasHtml = RotasHtml.locacao_envio;
        vm.rotasHtmlRetono = RotasHtml.locacao_retorno;
        vm.contrato = Contrato;
        vm.locados = Locados;
        vm.existeFotos = 0;
        vm.desabilitaBotao = true;
        vm.liberaBotaoSalvar = false;
        vm.metodos = {
            cancel: cancel,
            retornarTodos: retornarTodos,
            botaoDialogEstadoConservacao: botaoDialogEstadoConservacao,
            botaoDialogFoto: botaoDialogFoto,
            botaoDialog: botaoDialog,
            liberarBotalSalvar: liberarBotalSalvar
        };

        init();

        function cancel() {
            $mdDialog.cancel();
        }

        function init() {
            //console.log("vm.locado: ",vm.locados.equipamentoNotaItemDetalhe.fotos);
            listarEstadoConservacao();
            estadoConservacaoEFotosNuloNoInicio();
            vm.form = AtualizacaoLicencaFactory.form;
            vm.filtro = AtualizacaoLicencaFactory.filtros;
            vm.licencas = AtualizacaoLicencaFactory.licencas;
            vm.rotasHtml = RotasHtml.locacao_envio;
            vm.rotasHtmlRetono = RotasHtml.locacao_retorno;
        }

        function listarEstadoConservacao() {
            RequisicaoGenericaLocacaoService.listarSemParams(Api.locacao.equipamentos.estadoConservacao.listarTodos).then(function (success) {
                vm.equipamentoEstadoConservacao = success.data;
            });
        }

        function estadoConservacaoEFotosNuloNoInicio() {
            //  item.equipamentoEstadoConservacao.descricao[0] + item.equipamentoEstadoConservacao.descricao[1]
            vm.locados.forEach(function (item) {
                vm.estadoConservacaoN = item.equipamentoEstadoConservacao.descricao = "NV";
            });
        }

        function liberarBotalSalvar() {
            var resulado = vm.locados.filter(function (item) {
                if (item.equipamentoEstadoConservacao.descricao == "NV")
                    return item;
            });

            if (resulado.length > 0)
                vm.desabilitaBotao = true;
            else
                vm.desabilitaBotao = false;
        }

        function retornarTodos(event) {
            $mdDialog.hide();
        }

        function verificaItensMarcados() {
            vm.flag = false;
            vm.locados.map(function (item) {
                if (item.marcado == true) {
                    vm.flag = true;
                }
            });
            return vm.flag;
        }

        function botaoDialog() {
            // vm.mostrarTabela = true;
            if (!verificaItensMarcados()) {
                MdDialogService.alertPadrao("Favor selecionar algum equipamento.",null);
                return;
            }
            $mdDialog
                .show({
                    controller: "DialogLocacaoRetornoController",
                    controllerAs: "vm",
                    templateUrl: vm.rotasHtmlRetono.dialog.retorno,
                    multiple: true,
                    targetEvent: event,
                    clickOutsideToClose: false,
                    locals: {
                        Atendimentos: vm.atendimentos,
                        EquipamentoEstadoConservacao: vm.equipamentoEstadoConservacao,
                        TipoLocacao: vm.tipoLocacao,
                        ContratoCliente: vm.contratoCliente,
                        MostrarTabela: vm.mostrarTabela,
                        Retorno: vm.tipoRetornos,
                        LocacaoRetorno: null
                    }
                }).then(function (success) {

                    vm.locacaoRetorno = success;
                    salvar(vm.locacaoRetorno);
                });
        }

        function botaoDialogEstadoConservacao(index,detalhe) {
            $mdDialog
                .show({
                    controller: "DialogEstadoConservacaoController",
                    controllerAs: "vm",
                    templateUrl: vm.rotasHtml.dialog.estadoConservacao,
                    multiple: true,
                    targetEvent: event,
                    clickOutsideToClose: false,
                    locals: {
                        EstadoConservacaoId: detalhe.equipamentoEstadoConservacao,
                        EquipamentoEstadoConservacao: vm.equipamentoEstadoConservacao,
                        ApenasFoto: false,
                        Detalhe: detalhe.equipamentoNotaItemDetalhe

                    }
                }).then(function (success) {
                    vm.mostrarTabela = true;
                    vm.locados[index].equipamentoEstadoConservacao = success.equipamentoEstadoConservacao;
                    vm.locados[index].equipamentoNotaItemDetalhe.equipamentoEstadoConservacao = success.equipamentoEstadoConservacao;
                    liberarBotalSalvar();
                    //vm.locados[index].equipamentoNotaItemDetalhe.fotos = success.fotos;
                });
        }

        function botaoDialogFoto(index,detalhe) {
            $mdDialog
                .show({
                    controller: "DialogEstadoConservacaoController",
                    controllerAs: "vm",
                    templateUrl: vm.rotasHtml.dialog.estadoConservacao,
                    multiple: true,
                    targetEvent: event,
                    clickOutsideToClose: false,
                    locals: {
                        EstadoConservacaoId: detalhe.equipamentoEstadoConservacao,
                        EquipamentoEstadoConservacao: vm.equipamentoEstadoConservacao,
                        ApenasFoto: true,
                        Detalhe: detalhe.equipamentoNotaItemDetalhe,
                    },
                })
                .then(function (success) {
                    vm.mostrarTabela = true;
                    // vm.detalhes[vm.detalhes.indexOf(detalhe)].equipamentoEstadoConservacao = success.equipamentoEstadoConservacao;
                    vm.locados[vm.locados.indexOf(detalhe)].equipamentoNotaItemDetalhe.fotos = success.fotos;
                    vm.existeFotos = success.fotos.length;
                    console.log("aaa",vm.locados[vm.locados.indexOf(detalhe)].equipamentoNotaItemDetalhe.fotos.length);

                });
        }

    }
})();

(function () {
    "use strict";

    angular
        .module("app.locacao.processamento.locacao.envio.locacao_envio")
        .controller("DialogHistoricoController", DialogHistoricoController);

    /** @ngInject */
    function DialogHistoricoController(
        Api,
        $mdDialog,
        NumeroSerie,
        EmpresaAtivo,
        RequisicaoGenericaLocacaoService,
        HistoricoService,
        RotasHtml
    ) {
        var vm = this;
        vm.numeroSerie = NumeroSerie;
        vm.empresaAtivo = EmpresaAtivo;
        vm.rotasHtml = RotasHtml.historico;
        vm.historicoDtOptions = HistoricoService.detalheHistoricoConstruirDtOptionsdetalheHistorico();
        vm.historicoDtOptions.order = [0, "desc"];
        vm.historicoDtOptions.columnDefs = [
            {
                targets: [0, 1, 2],
                responsivePriority: 1
            },
            {
                targets: [6],
                orderable: false
            }
        ];

        vm.metodos = {
            cancel: cancel,
            pesquisarHistorico: pesquisarHistorico,
            dialogFoto: dialogFoto,
            retornaDescricaoEmpresaAtivo: retornaDescricaoEmpresaAtivo
        };

        init();

        function cancel() {
            $mdDialog.cancel();
        }
        function init() {
            pesquisarHistorico(vm.numeroSerie);
        }

        function pesquisarHistorico(numero) {
            vm.iniciaTabela = true;
            vm.pesquisando = true;
            RequisicaoGenericaLocacaoService.listarSemParams(
                Api.locacao.nota_item_detalhe_historico.listarHistoricos + numero
            ).then(function (success) {
                vm.detalhesHistoricos = success.data;
                vm.pesquisando = false;
            });
        }

        function dialogFoto(event, historico) {
            $mdDialog.show({
                controller: "DialogFotoController",
                controllerAs: "vm",
                templateUrl: vm.rotasHtml.dialogFoto,
                multiple: true,
                targetEvent: event,
                clickOutsideToClose: false,
                locals: {
                    Historico: historico,
                    EUltimoHistorico: true
                }
            });
        }

        function retornaDescricaoEmpresaAtivo(codigoEmpresaAtivo) {
            var descricao = "";

            vm.empresaAtivo.map(function (empresa) {
                if (empresa.codigo == codigoEmpresaAtivo) descricao = empresa.nome;
            });

            return descricao;
        }
    }
})();


(function () {
  "use strict";

  angular
    .module("app.locacao.processamento.locacao.retorno.locacao_retorno")
    .controller("DialogDetalhesController", DialogDetalhesController);

  /** @ngInject */
  function DialogDetalhesController(
    Api,
    $mdDialog,
    NumeroNota,
    RotasHtml,
    RequisicaoGenericaLocacaoService
  ) {
    var vm = this;
    vm.rotasHtml = RotasHtml.historico;
    vm.numeroNota = NumeroNota;
    vm.metodos = {
      cancel: cancel,
      ListarDetalhesPorNotaSaida: ListarDetalhesPorNotaSaida
    };

    init();

    function cancel() {
      $mdDialog.cancel();
    }
    function init() {
      ListarDetalhesPorNotaSaida(vm.numeroNota);
    }

    function ListarDetalhesPorNotaSaida(numeroNota) {
      vm.requisicaoSolicitada =true;
      RequisicaoGenericaLocacaoService.listarSemParams(
        Api.locacao.locacaoEnvio.ListarPorNotaSaida + numeroNota
      ).then(function (success) {
        vm.detalhes = success.data;
        vm.requisicaoSolicitada = false;
      });
    }
  }
})();

(function () {
    'use strict';

    angular
        .module('app.implantacaoMigracao.processamento.processosFunis.processoFunil', [])
        .config(config);

    function config($stateProvider, RotasHtml) {
        var rotasHtml = RotasHtml.implantacaoMigracao.processamento.processosFunis.processoFunil;
        $stateProvider
            .state('app.implantacaomigracao_processamento_processosfunis_processofunil', {
                url: '/implantacao-migracao/processamento/processos-funis/processo-funil/:processoCodigo/:processoDescricao',
                module: 'privado',
                views: {
                    'content@app': {
                        templateUrl: rotasHtml.templateUrl,
                        controller: "ProcessoFunilController as vm"
                    },
                    'processo-funil-form@app.implantacaomigracao_processamento_processosfunis_processofunil': {
                        templateUrl: rotasHtml.form
                    }
                },
                resolve: {
                    ListarTarefasPorProcesso: function (Api, RequisicaoGenericaService, $stateParams, ImplantacaoMigracaoFactory) {
                        var tarefasProcesso = ImplantacaoMigracaoFactory.tarefasProcessoFiltro;
                        tarefasProcesso.processoCodigo = $stateParams.processoCodigo;
                        return RequisicaoGenericaService.listarComParams(Api.implantacaoMigracao.processo.listarTarefasProcesso + tarefasProcesso.processoCodigo);
                    },
                    ListarProcessosFunis: function (Api, RequisicaoGenericaService) {
                        return RequisicaoGenericaService.listarSemParams(Api.implantacaoMigracao.processo.listarTodos);
                    }
                }
            });
    }
})();
(function () {
    'use strict';

    angular
        .module('app.implantacaoMigracao.processamento.processosFunis.processoFunil')
        .controller('DialogObservacaoSubprocessoController', DialogObservacaoSubprocessoController);

    function DialogObservacaoSubprocessoController(
        $mdDialog,
        Parametros,
        ImplantacaoMigracaoService,
        ImplantacaoMigracaoFactory
    ) {

        var vm = this;
        var cardSubprocesso = Parametros.cardSubprocesso;
        var codigoTarefaAnterior = Parametros.codigoTarefaAnterior;
        var codigoTarefaAtual = Parametros.codigoTarefaAtual;
        var tarefasProcesso = Parametros.tarefasProcesso;
        var arrastandoSubprocesso = Parametros.arrastandoSubprocesso;
        var codigoUsuarioLogado = Parametros.codigoUsuario;
        var tarefaFinalizada = Parametros.tarefaFinalizada;
        var tarefaAtual = {};

        vm.subProcessoHistorico = {
            codigoProcesso: cardSubprocesso.codigo,
            codigoTarefa: codigoTarefaAtual,
            codigoUsuario: codigoUsuarioLogado,
            data: new Date(),
            observacao: '',
            tarefaFinalizada: tarefaFinalizada
        };

        vm.metodos = {
            salvar: salvar,
            cancelar: cancelar,
            funcaoCancelamento: Parametros.funcaoCancelamento
        }

        init();

        function init() {
            if (!codigoTarefaAtual) {
                cardSubprocesso.codigoTarefaAtual = codigoTarefaAnterior;
            }

            if (arrastandoSubprocesso) {
                cardSubprocesso.codigoTarefaAtual = codigoTarefaAtual;
            }

            tarefasProcesso.forEach(function (tarefa) {
                if (tarefa.codigo == cardSubprocesso.codigoTarefaAtual) {
                    tarefaAtual = tarefa;
                }
            });

        }

        function salvar() {
            vm.requisicaoSolicitada = true;
            cardSubprocesso.subProcessoHistoricos.push(vm.subProcessoHistorico);

            ImplantacaoMigracaoService.atualizarTarefa(cardSubprocesso, tarefaAtual).then(
                function (success) {
                    vm.requisicaoSolicitada = false;
                    cardSubprocesso.tarefaFinalizada = false;
                    $mdDialog.hide(success);
                },
                function (error) {
                    vm.requisicaoSolicitada = false;
                    ImplantacaoMigracaoFactory.carregarTarefasFunil(tarefasProcesso);
                });
        }

        function cancelar() {
            vm.executouAcao = true;
            vm.metodos.funcaoCancelamento();
            $mdDialog.hide(null);
        }
    }

})();
(function () {
    'use strict';

    angular
        .module('app.implantacaoMigracao.processamento.processosFunis.processoFunil')
        .controller('DialogProcessoController', DialogProcessoController);

    function DialogProcessoController(
        $mdDialog,
        Parametros,
        ImplantacaoMigracaoFactory,
        ServicosGenericoService,
        Api,
        RequisicaoGenericaService,
        MdToastService,
        MdDialogService,
        RotasHtml,
        DataTableConfigPadrao
    ) {
        var vm = this;
        var codigoSubprocesso = Parametros.codigoSubprocesso;
        var codigoProcesso = Parametros.codigoProcesso;
        var _callbackCriacaoEntidade = Parametros.callbackCriacaoSubprocesso;
        var _callbackEdicaoEntidade = Parametros.callbackEdicaoSubprocesso;
        var codigoUsuarioLogado = Parametros.codigoUsuarioLogado;
        var usuariosAtivos = [];
        var subprocessoCopia;
        vm.executivoContas = Parametros.executivoContas;
        vm.processosFunis = Parametros.processosFunis;
        vm.tarefasProcesso = Parametros.tarefasProcesso;
        vm.codigoTarefaAtual = Parametros.codigoTarefaAtual;
        vm.descricaoProcesso = Parametros.descricaoProcesso;

        if (vm.processosFunis) {
            vm.processoFunil = vm.processosFunis.filter(function (item) {
                if (item.codigo == codigoProcesso) return item;
            })[0];
        }

        vm.tarefasFunil = [];
        vm.executivosResponsaveis = [];
        vm.tarefaAtual;

        var metodosInterno = {
            criarEntidade: _criarEntidade,
            editarEntidade: _editarEntidade,
            retornarSolucoesAtivas: _retornarSolucoesAtivas,
            retornarUsuariosSetorComercial: _retornarUsuariosSetorComercial,
            retornarUsuariosTecnicos: _retornarUsuariosTecnicos,
            retornarTarefas: _retornarTarefas,
            retornarCodigoTarefaAtual: _retornarCodigoTarefaAtual,
            listarTodosUsuarios: _listarTodosUsuarios,
            listarTodosAtendimentosCliente: _listarTodosAtendimentosCliente,
            pesquisarSubprocesso: _pesquisarSubprocesso,
            listarExecutivosResponsaveis: _listarExecutivosResponsaveis,
            callbackCriacaoEntidade: _callbackCriacaoEntidade,
            callbackEdicaoEntidade: _callbackEdicaoEntidade
        };

        vm.metodos = {
            salvar: salvar,
            fecharDialog: fecharDialog,
            tabSelecionada: tabSelecionada,
            configuraAutoCompleteClienteOnBlur: configuraAutoCompleteClienteOnBlur,
            alterarItemSelecionadoAutoCompleteCliente: alterarItemSelecionadoAutoCompleteCliente,
            pesquisarAutoCompleteCliente: pesquisarAutoCompleteCliente,
            configuraMdSelectSolucao: configuraMdSelectSolucao,
            atualizarDataFinalQuandoInserindo: atualizarDataFinalQuandoInserindo,
            configuraMdSelectAtendimento: configuraMdSelectAtendimento,
            listarAssuntoAtendimento: listarAssuntoAtendimento,
            selecionarAtendimento: selecionarAtendimento,
            atualizarTarefaAtualSubprocesso: atualizarTarefaAtualSubprocesso,
            retornarDescricaoTarefa: retornarDescricaoTarefa,
            retornarNomeUsuario: retornarNomeUsuario,
            reagendarDataFinalEtapa: reagendarDataFinalEtapa,
        };

        init();

        function init() {
            vm.htmlRota =
                RotasHtml.implantacaoMigracao.processamento.processosFunis.processoFunil.dialogs;
            vm.atendimentos = [];
            vm.subprocesso = ImplantacaoMigracaoFactory.subprocesso;
            vm.novaEntidade = angular.isUndefined(codigoSubprocesso);
            metodosInterno.retornarSolucoesAtivas();
            metodosInterno.retornarUsuariosSetorComercial();
            metodosInterno.retornarUsuariosTecnicos();
            metodosInterno.listarTodosUsuarios();
            metodosInterno.retornarTarefas(codigoProcesso);
            metodosInterno.pesquisarSubprocesso(codigoSubprocesso);

            vm.dtOptions = angular.copy(
                DataTableConfigPadrao.dtOptionsResponsivoSemPaginacao
            );

            vm.dtOptions.dom = "rt";
            vm.dtOptions.columnDefs = [
                {
                    targets: [1, 2, 3, 4],
                    orderable: false,
                },
                {
                    targets: [3],
                    width: "40%",
                },
                {
                    targets: [4],
                    width: "10%",
                },
            ];

            vm.dtOptions.order = [0, "desc"];
        }

        function salvar(subprocesso) {
            if (vm.novaEntidade) {
                metodosInterno.criarEntidade(subprocesso);
            } else {
                metodosInterno.editarEntidade(subprocesso);
            }
        }

        function fecharDialog() {
            $mdDialog.hide();
        }

        function tabSelecionada(tab) {
            vm.tabSelecionada = tab;
        }

        function configuraAutoCompleteClienteOnBlur() {
            if (!vm.subprocesso.cliente) vm.textoDePesquisaAutoCompleteCliente = "";
        }

        function alterarItemSelecionadoAutoCompleteCliente(item) {
            if (item && vm.novaEntidade) {
                vm.subprocesso.codigoCliente = item.codigo;
                vm.subprocesso.codigoExecutivoContasResponsavel = item.codigoUsuario;
            } else {
                vm.textoDePesquisaAutoCompleteCliente = "";
            }
        }

        function pesquisarAutoCompleteCliente(query) {
            return ServicosGenericoService.pesquisarAutoCompleteCodigoOuNomeGenericoApi(
                Api.cliente.listarCodigoDescricao,
                query
            );
        }

        function configuraMdSelectSolucao() {
            vm.filtrarSolucoes = "";
            angular
                .element("#implantacao-migracao-dialog-solucao-md-select")
                .on("keydown", function (ev) {
                    ev.stopPropagation();
                });
        }

        function atualizarDataFinalQuandoInserindo(dataInicio) {
            if (dataInicio) {
                var data = new Date(dataInicio).setDate(
                    dataInicio.getDate() + vm.tarefaAtual.periodo
                );
                vm.subprocesso.dataFinalTarefa = new Date(data);
            } else vm.subprocesso.dataFinalTarefa = null;
        }

        function configuraMdSelectAtendimento() {
            vm.filtrarAtendimentos = "";
            angular
                .element("#implantacao-migracao-subprocesso-atendimento-md-select")
                .on("keydown", function (ev) {
                    ev.stopPropagation();
                });

            if (vm.subprocesso.codigoCliente)
                _listarTodosAtendimentosCliente(vm.subprocesso.codigoCliente);
        }

        function listarAssuntoAtendimento(assunto) {
            if (assunto) {
                if (assunto.length < 130) return assunto;
                else return assunto.substring(0, 130) + "...";
            }
        }

        function selecionarAtendimento(atendimento) {
            if (atendimento) {
                vm.subprocesso.codigoAtendimento = atendimento.codigo;
                vm.subprocesso.anoAtendimento = atendimento.ano;
            }
        }

        function atualizarTarefaAtualSubprocesso(tarefaAtual) {
            if (tarefaAtual) {
                vm.subprocesso.codigoTarefaAtual = tarefaAtual.codigo;
                vm.codigoTarefaAtual = tarefaAtual.codigo;
                RequisicaoGenericaService.listarSemParams(
                    Api.implantacaoMigracao.atividade.listarAtividadesPorTarefa + vm.codigoTarefaAtual)
                    .then(function (success) {
                        _converterViewModelAtividadesTarefa(success.data);
                        _atualizarAtividadeTarefaSubprocesso();

                    }, function (error) {
                        MdDialogService.alertPadrao(error.data.error);
                    });
            }
        }

        function retornarDescricaoTarefa(codigoTarefa) {
            var descricao = "";

            vm.tarefasFunil.forEach(function (tarefa) {
                if (tarefa.codigo == codigoTarefa && tarefa.nivel != "")
                    descricao = tarefa.nivel + " - " + tarefa.descricao;
            });
            return descricao != "" ? descricao : "PAUSA";
        }

        function retornarNomeUsuario(codigoUsuario) {
            var nomeUsuario = "";
            usuariosAtivos.forEach(function (usuario) {
                if (usuario.codigo == codigoUsuario) {
                    nomeUsuario = usuario.login;
                }
            });
            return nomeUsuario;
        }

        function reagendarDataFinalEtapa(event, dataFinalTarefa) {
            var dataFinal = dataFinalTarefa ? new Date(dataFinalTarefa) : null;
            var hoje = new Date();
            hoje.setHours(0, 0, 0, 0);

            if (dataFinal) {
                dataFinal.setHours(0, 0, 0, 0);
            }

            if (!dataFinal || dataFinal <= hoje) {
                var codigoTarefaAtual = vm.subprocesso.codigoTarefaAtual || vm.codigoTarefaAtual;
                var tarefaAtual = (vm.tarefasProcesso || []).find(function (tarefa) {
                    return tarefa.codigo === codigoTarefaAtual;
                });

                if (!tarefaAtual || !tarefaAtual.periodo) {
                    return;
                }

                var novaDataFinal = new Date(hoje);
                novaDataFinal.setDate(novaDataFinal.getDate() + tarefaAtual.periodo);

                vm.subprocesso.dataFinalTarefa = novaDataFinal;

                if (vm.form && vm.form.dataFinal) {
                    vm.form.dataFinal.$setDirty();
                }
                if (vm.form) {
                    vm.form.$setDirty();
                }
            } else {
                MdDialogService.alertPadrao("Atenção!", null, "Não é possível alterar a data de vencimento da tarefa, pois o prazo mínimo ainda não foi atingido.");
            }
        }

        function _retornarSolucoesAtivas() {
            RequisicaoGenericaService.listarSemParams(
                Api.solucao_rotinas_tarefas.solucao.listarTodos
            ).then(
                function (success) {
                    vm.solucoes = success.data;
                },
                function (error) {
                    ServicosGenericoService.exibirAlertaDeErro(error, event);
                }
            );
        }

        function _retornarUsuariosSetorComercial() {
            RequisicaoGenericaService.listarSemParams(
                Api.usuario.listarUsuariosSetorComercial
            ).then(
                function (success) {
                    vm.executivosResponsaveis = success.data;
                },
                function (error) {
                    vm.requisicaoSolicitada = false;
                    vm.mensagemPreloader = "";
                    ServicosGenericoService.exibirAlertaDeErro(error, event);
                }
            );
        }

        function _retornarUsuariosTecnicos() {
            RequisicaoGenericaService.listarSemParams(Api.setor.listarTodos).then(
                function (success) {
                    vm.tecnicos = success.data[2].usuarios;
                },
                function (error) {
                    vm.requisicaoSolicitada = false;
                    vm.mensagemPreloader = "";
                    ServicosGenericoService.exibirAlertaDeErro(error, event);
                }
            );
        }

        function _retornarTarefas(codigoProcesso) {
            RequisicaoGenericaService.listarComParams(
                Api.implantacaoMigracao.tarefa.listarTarefasPorProcesso + codigoProcesso
            ).then(
                function (success) {
                    vm.tarefasFunil = success.data;
                },
                function (error) {
                    console.log(error);
                }
            );
        }

        function _retornarCodigoTarefaAtual(codigoSubprocesso) {
            vm.mensagemPreloader = "Carregando tarefa atual...";

            RequisicaoGenericaService.listarSemParams(Api + codigoSubprocesso).then(
                function (success) {
                    codigoTarefaAtual = success.data;
                },
                function (error) {
                    vm.requisicaoSolicitada = false;
                    vm.mensagemPreloader = "";
                    ServicosGenericoService.exibirAlertaDeErro(error, event);
                }
            );
        }

        function _listarTodosUsuarios() {
            RequisicaoGenericaService.listarSemParams(
                Api.usuario.detalhes_usuario.listarUsuariosAtivos
            ).then(
                function (success) {
                    usuariosAtivos = success.data;
                },
                function (error) {
                    ServicosGenericoService.exibirAlertaDeErro(error, event);
                }
            );
        }

        function _listarExecutivosResponsaveis() {
            vm.mensagemPreloader = "Carregando executivos responsáveis...";

            RequisicaoGenericaService.listarSemParams(
                Api.usuario.listarUsuariosSetorComercial
            ).then(
                function (success) {
                    var temNaLista;
                    vm.executivosResponsaveis = success.data;

                    if (vm.executivoContas) {
                        temNaLista = vm.executivosResponsaveis.some(function (item) {
                            return item.codigo == vm.executivoContas.codigo;
                        });

                        if (!temNaLista) {
                            vm.executivosResponsaveis.push(vm.executivoContas);
                        }
                    }
                },
                function (error) {
                    vm.requisicaoSolicitada = false;
                    vm.mensagemPreloader = "";
                    ServicosGenericoService.exibirAlertaDeErro(error, event);
                }
            );
        }

        function _listarTodosAtendimentosCliente(codigoCliente) {
            if (vm.atendimentos.length == 0 && codigoCliente) {
                vm.requisicaoSolicitada = true;
                vm.mensagemPreloader = "Carregando atendimentos do cliente...";

                RequisicaoGenericaService.listarComParams(
                    Api.atendimento.retornarAtendimentoPorCodigoCliente +
                    "/" +
                    codigoCliente
                )
                    .then(
                        function (success) {
                            vm.atendimentos = success.data;
                            vm.atendimento = vm.atendimentos.find(function (atendimento) {
                                return (
                                    atendimento.codigo == vm.subprocesso.codigoAtendimento &&
                                    atendimento.ano == vm.subprocesso.anoAtendimento
                                );
                            });
                        },
                        function (error) {
                            vm.requisicaoSolicitada = false;
                            vm.mensagemPreloader = "";
                            ServicosGenericoService.exibirAlertaDeErro(error, event);
                        }
                    )
                    .finally(function () {
                        vm.requisicaoSolicitada = false;
                        vm.mensagemPreloader = "";
                    });
            }
        }

        function _pesquisarSubprocesso(codigoSubprocesso) {
            vm.requisicaoSolicitada = true;
            vm.mensagemPreloader = "Carregando subprocesso...";

            if (!codigoSubprocesso) {
                vm.subprocesso = {};
                vm.requisicaoSolicitada = false;
                vm.mensagemPreloader = "";
            } else {

                RequisicaoGenericaService.listarSemParams(
                    Api.implantacaoMigracao.atividade.listarAtividadesPorTarefa + vm.codigoTarefaAtual)
                    .then(function (success) {
                        _converterViewModelAtividadesTarefa(success.data);

                        RequisicaoGenericaService.listarSemParams(
                            Api.implantacaoMigracao.subprocesso.listarPorCodigo + codigoSubprocesso
                        ).then(
                            function (success) {
                                vm.subprocesso = success.data;

                                _atualizarAtividadeTarefaSubprocesso();

                                metodosInterno.listarTodosAtendimentosCliente(vm.subprocesso.codigoCliente);
                                metodosInterno.listarExecutivosResponsaveis();
                                vm.requisicaoSolicitada = false;
                                vm.mensagemPreloader = "";

                                vm.tarefasFunil.forEach(function (tarefa) {
                                    if (vm.subprocesso.codigoTarefaAtual == tarefa.codigo) {
                                        vm.tarefaAtual = tarefa;
                                    }
                                });

                                subprocessoCopia = angular.copy(vm.subprocesso);
                            },
                            function (error) {
                                vm.requisicaoSolicitada = false;
                                vm.mensagemPreloader = "";
                                ServicosGenericoService.exibirAlertaDeErro(error, event);
                            }
                        );

                    }, function (error) {
                        MdDialogService.alertPadrao(error.data.error);
                    });
            }
        }

        function _criarEntidade(subprocesso) {
            if (codigoProcesso) {
                vm.requisicaoSolicitada = true;
                subprocesso.codigoProcesso = codigoProcesso;
                subprocesso.status = 1; // Em andamento

                RequisicaoGenericaService.salvar(
                    Api.implantacaoMigracao.subprocesso.criar,
                    subprocesso
                ).then(
                    function (success) {
                        MdToastService.toastPadrao("Subprocesso cadastrado com sucesso!");
                        vm.requisicaoSolicitada = false;
                        vm.mensagemPreloader = "";
                        if (metodosInterno.callbackCriacaoEntidade)
                            metodosInterno.callbackCriacaoEntidade(success.data);

                        fecharDialog();
                    },
                    function (error) {
                        vm.requisicaoSolicitada = false;
                        vm.mensagemPreloader = "";
                        ServicosGenericoService.exibirAlertaDeErro(error, event);
                        fecharDialog();
                    }
                );
            }
        }

        function _editarEntidade(subprocesso) {
            if (vm.processoFunil) {
                subprocesso.codigoProcesso = vm.processoFunil.codigo;
            }

            var historicoPossuiTarefa = subprocesso.subProcessoHistoricos.some(
                function (historico) {
                    return historico.codigoTarefa == subprocesso.codigoTarefaAtual;
                }
            );

            if (subprocesso.codigoTarefaAtual != 1 &&
                (!historicoPossuiTarefa || subprocessoCopia.codigoTarefaAtual == 1)) {
                vm.requisicaoSolicitada = true;
                vm.mensagemPreloader = "Atualizando subprocesso...";

                RequisicaoGenericaService.editar(
                    Api.implantacaoMigracao.subprocesso.alterar,
                    subprocesso
                ).then(
                    function (success) {
                        _atualizarSubprocesso(success, subprocesso);
                    },
                    function (error) {
                        vm.requisicaoSolicitada = false;
                        ServicosGenericoService.exibirAlertaDeErro(error, event);
                    }
                );
            } else {
                var funcaoCancelamento = function () { };

                var Parametros = {
                    cardSubprocesso: subprocesso,
                    codigoTarefaAnterior: subprocessoCopia.codigoTarefaAtual,
                    codigoTarefaAtual: subprocesso.codigoTarefaAtual,
                    tarefasProcesso: vm.tarefasProcesso,
                    funcaoCancelamento: funcaoCancelamento,
                    arrastandoSubprocesso: false,
                    codigoUsuario: codigoUsuarioLogado,
                };

                $mdDialog
                    .show({
                        controller: "DialogObservacaoSubprocessoController",
                        controllerAs: "vm",
                        templateUrl: vm.htmlRota.dialogObservacaoSubprocesso.templateUrl,
                        targetEvent: event,
                        clickOutsideToClose: false,
                        escapeToClose: false,
                        multiple: true,
                        locals: {
                            Parametros: Parametros,
                        },
                    })
                    .then(function (success) {
                        if (success != null) {
                            _atualizarSubprocesso(success, subprocesso);
                        }
                    });
            }
        }

        function _atualizarSubprocesso(success, subprocesso) {
            MdToastService.toastPadrao("Subprocesso atualizado com sucesso!");
            vm.requisicaoSolicitada = false;
            vm.mensagemPreloader = "";
            vm.subprocesso = success.data;
            vm.subprocesso.cliente = subprocesso.cliente;
            var data = new Date();
            var periodoTarefaAtual;

            vm.tarefasFunil.forEach(function (tarefa) {
                if (vm.subprocesso.codigoTarefaAtual == tarefa.codigo) {
                    periodoTarefaAtual = tarefa.periodo;
                }
            });

            data.setDate(data.getDate() + periodoTarefaAtual);

            if (vm.subprocesso.codigoTarefaAtual != 1) {
                vm.subprocesso.dataFinalTarefa = data;
            }

            var indexTarefaAnterior = vm.tarefasProcesso.findIndex(function (
                itensTarefa
            ) {
                return itensTarefa.codigo == subprocessoCopia.codigoTarefaAtual;
            });

            var indexTarefaAtual = vm.tarefasProcesso.findIndex(function (
                itensTarefa
            ) {
                return itensTarefa.codigo == subprocesso.codigoTarefaAtual;
            });

            var indexSubprocesso = vm.tarefasProcesso[
                indexTarefaAnterior
            ].subProcessos.findIndex(function (itensSubprocesso) {
                return itensSubprocesso.codigo == subprocesso.codigo;
            });

            vm.tarefasProcesso[indexTarefaAnterior].subProcessos.splice(
                indexSubprocesso,
                1
            );

            vm.tarefasProcesso[indexTarefaAtual].subProcessos.push(vm.subprocesso);

            if (metodosInterno.callbackEdicaoEntidade) {
                metodosInterno.callbackEdicaoEntidade(vm.subprocesso);
            }

            fecharDialog();
        }

        function _converterViewModelAtividadesTarefa(atividades) {
            vm.atividadesTarefa = [];
            if (atividades.length) {
                atividades.forEach(function (atividadeTarefa) {
                    var atividade = {
                        codigoAtividade: atividadeTarefa.codigo,
                        codigoSubProcesso: codigoSubprocesso,
                        codigoTarefa: vm.codigoTarefaAtual,
                        atividade: angular.copy(atividadeTarefa)
                    }
                    vm.atividadesTarefa.push(atividade);
                })
            }
        }

        function _atualizarAtividadeTarefaSubprocesso() {
            if (vm.subprocesso.atividadesTarefas.length == 0) {
                vm.subprocesso.atividadesTarefas = vm.atividadesTarefa;
            } else if (!_verificarAtividadesTarefaExistente()) {
                vm.subprocesso.atividadesTarefas = vm.subprocesso.atividadesTarefas.concat(vm.atividadesTarefa);
            } else {
                vm.atividadesTarefa.forEach(function (atividadeTarefa) {
                    if (!_verificarAtividadeExistente(atividadeTarefa.codigoAtividade)) {
                        vm.subprocesso.atividadesTarefas.push(atividadeTarefa);
                    }
                })
            }

            vm.subprocesso.atividadesTarefas.sort(function (a, b) {
                return a.codigoAtividade > b.codigoAtividade ? 1 : -1;
            });
        }

        function _verificarAtividadesTarefaExistente() {
            return vm.subprocesso.atividadesTarefas.some(function (atividade) {
                return atividade.codigoTarefa == vm.codigoTarefaAtual;
            });
        }

        function _verificarAtividadeExistente(codigoAtividade) {
            return vm.subprocesso.atividadesTarefas.some(function (atividade) {
                return (atividade.codigoAtividade == codigoAtividade) && (atividade.codigoTarefa == vm.codigoTarefaAtual);
            });
        }

    }
})();

(function () {
    "use strict";

    angular
        .module("app.financeiro.processamento.contratos")
        .controller(
            "DialogPrioritarioController",
            DialogPrioritarioController
        );

    function DialogPrioritarioController(
        $mdDialog,
        MdToastService,
        MdDialogService,
        RequisicaoGenericaService,
        Api,
        ServicosGenericoService,
        HistoricoContrato
    ) {
        var vm = this;
        vm.form = {};
        vm.titulo = "Histórico prioridade";
        vm.houveAlteracao = false;
        vm.contratoHistorico = HistoricoContrato;
        vm.controladorDialog = angular.copy(
            ServicosGenericoService.retornarControladorDialog()
        );

        vm.metodos = {
            atualizarPrioritario: atualizarPrioritario,
            fecharDialog: fecharDialog
        };

        function atualizarPrioritario(modelo) {
            var modelVM = angular.copy(modelo);
            ServicosGenericoService.exibirPreloaderRequisicaoIniciada(
                vm.controladorDialog,
                "Editando Histórico ..."
            );
            RequisicaoGenericaService.editar(
                Api.contrato.historico_contrato.atualizarPrioritario,
                modelVM
            ).then(
                function (success) {
                    MdToastService.toastPadrao("Histórico editado com sucesso!");
                    vm.houveAlteracao = true
                    $mdDialog.hide(vm.houveAlteracao);
                },
                function (error) {
                    ServicosGenericoService.ocultarPreloaderRequisicaoFinalizada(
                        vm.controladorDialog
                    );
                    MdDialogService.alertPadrao(error.data);
                }
            );
        }

        function fecharDialog() {
            $mdDialog.hide(vm.houveAlteracao);
        }
    }
})();

(function () {
    "use strict";

    angular
        .module("app.financeiro.processamento.contratos")
        .controller(
            "DialogContratosHistoricoController",
            DialogContratosHistoricoController
        );

    function DialogContratosHistoricoController(
        $mdDialog,
        MdToastService,
        MdDialogService,
        RequisicaoGenericaService,
        Api,
        ServicosGenericoService,
        HistoricoContrato,
        LoginUsuarioService,
        CodigoContrato,
        ExibirValorMensal,
        ContratoHistoricos,
        ApenasVisualizacao,
        EditarAtivo,
        ApenasPrioritario,
        Contrato,
        $timeout
    ) {
        var vm = this;
        vm.apenasVisualizacao = ApenasVisualizacao;
        vm.editarAtivo = EditarAtivo;
        vm.form = {};
        vm.apenasPrioritario = ApenasPrioritario;
        vm.diferencaValor = 0;
        vm.contrato = Contrato;
        vm.houveAlteracoes = false;
        vm.listaContratoHistorico = ContratoHistoricos;
        vm.usuarioLogado = LoginUsuarioService.usuarioArmazenado();
        vm.controladorDialog = angular.copy(ServicosGenericoService.retornarControladorDialog());
        vm.exibirValorMensal = ExibirValorMensal;
        vm.valorContrato = vm.contrato.valorTotalContrato;
        vm.dataMinimaHistorico = new Date(vm.contrato.contratoDadosSigiloso.dataInicioPrimeiroContrato);

        if (vm.listaContratoHistorico.length != 0) {
            vm.listaContratoHistorico.sort(function (a, b) {
                return a.codigo - b.codigo;
            });
            vm.ultimoContratoHistorico = vm.listaContratoHistorico[vm.listaContratoHistorico.length - 1];
            vm.dataMinima = new Date(vm.ultimoContratoHistorico.data);
        }

        if (HistoricoContrato) {
            vm.usuarioLogado.nome = HistoricoContrato.usuario.login;
            vm.inserirAtivo = false;
            vm.contratoHistorico = HistoricoContrato;

            if (vm.contratoHistorico.valorReajuste == null) {
                vm.exibirValorMensal = true;
            }
            vm.diferencaValor = _retornarDiferencaValor(vm.contratoHistorico.valorReajuste, vm.contratoHistorico.valorBase);

            if (vm.contratoHistorico.codigoContratoItem) {
                vm.contratoHistorico.valorContratoAposReajuste = vm.contratoHistorico.valor;
            }
        }
        else {
            vm.inserirAtivo = true;
            vm.contratoHistorico = {
                codigoUsuario: vm.usuarioLogado.codigo,
                codigoContrato: CodigoContrato,
                data: new Date(),
                tipoReajuste: 1
            };
        }

        if ((vm.editarAtivo || vm.apenasVisualizacao) && vm.contratoHistorico.codigoContratoItem == undefined) {
            vm.contratoHistorico.codigoContratoItem = 0;
        }

        init();

        vm.subitensDoItemSelecionado = [];

        vm.metodos = {
            salvar: salvar,
            zeraValorAjuste: zeraValorAjuste,
            resultadoValorAjustado: resultadoValorAjustado,
            configuraMdSelectItem: configuraMdSelectItem,
            changeContratoItem: changeContratoItem,
            changeSubitem: changeSubitem,
            changeMotivoAditivo: changeMotivoAditivo,
            fecharDialog: fecharDialog
        };

        function init() {
            _listarStatusContrato();
            _listarMotivoAditivo();
            _exibeItensAtivosSuprimidos();
        }
        /**
           * Método chamado pelo botão salvar da tela
           * @param {event} event
           * @param {object} modelo
           */
        function salvar(event, modelo) {
            if (vm.inserirAtivo)
                _criar(event, modelo);
            else
                _atualizar(event, modelo);
        }

        function zeraValorAjuste() {
            vm.contratoHistorico.valorReajuste = 0;
            vm.contratoHistorico.valorContratoAposAjuste = 0;
            resultadoValorAjustado();
        }

        function resultadoValorAjustado() {
            if (vm.contratoHistorico.tipoReajusteValor == 1) {
                _resultadoValorAjustadoPorcentagem();
            } else {
                _resultadoValorAjustadoEmReais();
            }
            _validarDescontoMaximo();
        }

        function configuraMdSelectItem() {
            vm.filtrarItem = "";
            angular
                .element("#cliente-dialog-historico-item-md-select")
                .on("keydown", function (ev) {
                    ev.stopPropagation();
                });
        }

        function changeContratoItem(item, codigoContratoItem) {
            if (item == undefined) {
                vm.editarAtivo = true;
            } else {
                vm.subitensDoItemSelecionado = [];
                item.forEach(function (produto) {
                    if (produto.codigo == codigoContratoItem) {
                        vm.contratoItem = produto.contratoItemDadosSigiloso;
                        vm.subitensDoItemSelecionado = produto.contratoSubItens || [];
                    }
                });

                if (vm.contratoHistorico.codigoContratoItem == 0) {
                    vm.exibirValorMensal = false;
                    vm.contratoHistorico.tipoReajusteValor = 1;
                    vm.contratoHistorico.valorReajuste = 0;
                    vm.subitensDoItemSelecionado = [];
                    vm.contratoHistorico.codigosSubitens = [];
                    return;
                } else {
                    vm.contratoHistorico.tipoReajusteValor = "";
                }

                if (vm.subitensDoItemSelecionado.length === 1) {
                    vm.subitemSelecionadoUi = vm.subitensDoItemSelecionado[0].codigo;
                } else if (vm.subitensDoItemSelecionado.length > 1) {
                    vm.subitemSelecionadoUi = "todos";
                } else {
                    vm.subitemSelecionadoUi = null;
                }
                changeSubitem(vm.subitemSelecionadoUi);

                if (!vm.exibirValorMensal && vm.subitensDoItemSelecionado.length === 0) {
                    vm.contratoHistorico.valorContratoAposReajuste = vm.contratoItem.valorMensal;
                    vm.contratoHistorico.valor = vm.contratoItem.valorMensal;
                }

                if (!vm.exibirValorMensal) {
                    vm.dataMinima = new Date(vm.ultimoContratoHistorico.data);
                }
            }
        }

        function changeSubitem(valorSelecionado) {
            var codigoSubitemUnico = null;

            if (valorSelecionado === "todos") {
                vm.contratoHistorico.codigosSubitens = vm.subitensDoItemSelecionado.map(function (subitem) {
                    return subitem.codigo;
                });
            } else if (valorSelecionado) {
                codigoSubitemUnico = valorSelecionado;
                vm.contratoHistorico.codigosSubitens = [valorSelecionado];
            } else {
                vm.contratoHistorico.codigosSubitens = [];
            }

            if (!vm.exibirValorMensal && vm.subitensDoItemSelecionado.length > 0) {
                var valorBase = vm.contratoItem ? vm.contratoItem.valorMensal : 0;
                if (codigoSubitemUnico) {
                    var subitem = vm.subitensDoItemSelecionado.find(function (s) {
                        return s.codigo == codigoSubitemUnico;
                    });
                    if (subitem) {
                        valorBase = subitem.valorTotal;
                    }
                }
                vm.contratoHistorico.valorContratoAposReajuste = valorBase;
                vm.contratoHistorico.valor = valorBase;
            }
        }

        function changeMotivoAditivo(codigoMotivoAditivo) {
            vm.motivoAditivo = vm.motivosAditivos.find(function (motivo) {
                return motivo.codigo == codigoMotivoAditivo;
            });
        }

        function fecharDialog() {
            $mdDialog.hide(vm.houveAlteracoes);
        }

        function _exibeItensAtivosSuprimidos() {
            if (!vm.apenasVisualizacao) {
                RequisicaoGenericaService.listarComParams(
                    Api.contrato.contrato_item.listarAtivosPorContrato + vm.contrato.codigo
                ).then(function (success) {
                    vm.itensContrato = success.data;
                });
            }
            else {
                vm.itensContrato = vm.contrato.contratoItens;
            }
        }

        function _preparaValorParaEnvio(modeloViewModel) {
            if (vm.contratoHistorico.codigoContratoItem == 0) {
                modeloViewModel.codigoContratoItem = null;
                modeloViewModel.valorBase = vm.contrato.valorTotalContrato;
                modeloViewModel.valor = vm.valorContrato;
            }
            else if (modeloViewModel.valorContratoAposReajuste > 0) {
                modeloViewModel.valorBase = modeloViewModel.valor;
                modeloViewModel.valor = modeloViewModel.valorContratoAposReajuste;
                if (modeloViewModel.tipoReajuste == 2) {
                    modeloViewModel.valorReajuste;
                }
            }
        }

        function _resultadoValorAjustadoEmReais() {
            vm.contratoHistorico.valorReajuste = vm.contratoHistorico.valorReajuste == undefined ? 0 : vm.contratoHistorico.valorReajuste;
            vm.diferencaValor = parseFloat(vm.contratoHistorico.valorReajuste);
            var valorBaseReais = vm.subitensDoItemSelecionado.length > 0
                ? parseFloat(vm.contratoHistorico.valor)
                : parseFloat(vm.contratoItem.valorMensal);
            if (vm.contratoHistorico.tipoReajuste == 1) {
                vm.contratoHistorico.valorContratoAposReajuste =
                    valorBaseReais +
                    parseFloat(vm.contratoHistorico.valorReajuste);
            }
            if (vm.contratoHistorico.tipoReajuste == 2) {
                vm.contratoHistorico.valorContratoAposReajuste =
                    valorBaseReais -
                    parseFloat(vm.contratoHistorico.valorReajuste);
            }

            if (vm.contratoHistorico.valorContratoAposReajuste < 0 ||
                vm.contratoHistorico.valorReajuste == undefined) {
                vm.contratoHistorico.valorContratoAposReajuste = 0;
            }
        }

        function _resultadoValorAjustadoPorcentagem() {
            vm.contratoHistorico.valorReajuste = vm.contratoHistorico.valorReajuste == undefined ? 0 : vm.contratoHistorico.valorReajuste;

            if (vm.contratoHistorico.tipoReajuste == 1) {
                if (vm.contratoHistorico.codigoContratoItem == 0) {
                    vm.diferencaValor = _retornarDiferencaValor(vm.contratoHistorico.valorReajuste, vm.contrato.valorTotalContrato);
                    vm.valorContrato = _retornarValorReajusteAcrescimo(vm.contratoHistorico.valorReajuste, vm.contrato.valorTotalContrato);
                } else {
                    vm.diferencaValor = _retornarDiferencaValor(vm.contratoHistorico.valorReajuste, vm.contratoHistorico.valor);
                    vm.contratoHistorico.valorContratoAposReajuste = _retornarValorReajusteAcrescimo(vm.contratoHistorico.valorReajuste, vm.contratoHistorico.valor);
                }
            }
            if (vm.contratoHistorico.tipoReajuste == 2) {
                if (vm.contratoHistorico.codigoContratoItem == 0) {
                    vm.diferencaValor = _retornarDiferencaValor(vm.contratoHistorico.valorReajuste, vm.contrato.valorTotalContrato);
                    vm.valorContrato = _retornarValorReajusteDesconto(vm.contratoHistorico.valorReajuste, vm.contrato.valorTotalContrato);
                } else {
                    vm.diferencaValor = _retornarDiferencaValor(vm.contratoHistorico.valorReajuste, vm.contratoHistorico.valor);
                    vm.contratoHistorico.valorContratoAposReajuste = _retornarValorReajusteDesconto(vm.contratoHistorico.valorReajuste, vm.contratoHistorico.valor);
                }
            }

            if (vm.contratoHistorico.valorContratoAposReajuste < 0 ||
                vm.contratoHistorico.valorReajuste == undefined) {
                vm.contratoHistorico.valorContratoAposReajuste = 0;
            }
        }

        function _listarStatusContrato() {
            ServicosGenericoService.exibirPreloaderRequisicaoIniciada(
                vm.controladorDialog,
                "Pesquisando status contrato..."
            );
            RequisicaoGenericaService.listarSemParams(
                Api.contrato.status_contrato.listarPor
            ).then(
                function (success) {
                    vm.statusContratos = success.data;
                    ServicosGenericoService.ocultarPreloaderRequisicaoFinalizada(
                        vm.controladorDialog
                    );
                },
                function (error) {
                    MdDialogService.alertPadrao(error.data, null);
                    ServicosGenericoService.ocultarPreloaderRequisicaoFinalizada(
                        vm.controladorDialog
                    );
                }
            );
        }

        function _listarMotivoAditivo() {
            ServicosGenericoService.exibirPreloaderRequisicaoIniciada(
                vm.controladorDialog,
                "Pesquisando motivos aditivos..."
            );
            RequisicaoGenericaService.listarSemParams(
                Api.contrato.motivo_aditivo.listarPor
            ).then(
                function (success) {
                    vm.motivosAditivos = success.data;
                    if (vm.contratoHistorico.codigoMotivoAditivo) {
                        changeMotivoAditivo(vm.contratoHistorico.codigoMotivoAditivo);
                    }

                    ServicosGenericoService.ocultarPreloaderRequisicaoFinalizada(
                        vm.controladorDialog
                    );
                },
                function (error) {
                    MdDialogService.alertPadrao(error.data, null);
                    ServicosGenericoService.ocultarPreloaderRequisicaoFinalizada(
                        vm.controladorDialog
                    );
                }
            );
        }

        function _retornarDiferencaValor(valorReajuste, valorBase) {
            return parseFloat(valorReajuste) * parseFloat(valorBase);
        }

        function _retornarValorReajusteAcrescimo(valorReajuste, valorBase) {
            return (parseFloat(valorBase) +
                parseFloat(valorReajuste) *
                parseFloat(valorBase));
        }

        function _retornarValorReajusteDesconto(valorReajuste, valorBase) {
            return (parseFloat(valorBase) -
                parseFloat(valorReajuste) *
                parseFloat(valorBase));
        }

        function _validarDescontoMaximo() {
            $timeout(function () {
                if (!vm.form.valorReajuste) return;

                var valorBase;
                if (vm.contratoHistorico.codigoContratoItem == 0) {
                    valorBase = vm.contrato.valorTotalContrato;
                } else {
                    valorBase = vm.contratoHistorico.valor || (vm.contratoItem ? vm.contratoItem.valorMensal : 0);
                }

                var descontoExcedido = false;

                if (vm.contratoHistorico.tipoReajuste == 2) {
                    if (vm.contratoHistorico.tipoReajusteValor == 2) {
                        descontoExcedido = vm.contratoHistorico.valorReajuste > valorBase;
                    } else if (vm.contratoHistorico.tipoReajusteValor == 1) {
                        descontoExcedido = vm.contratoHistorico.valorReajuste > 1;
                    }
                }

                if (descontoExcedido) {
                    vm.form.valorReajuste.$setValidity('descontoMaximo', false);
                    vm.form.valorReajuste.$setTouched();
                } else {
                    vm.form.valorReajuste.$setValidity('descontoMaximo', true);
                }
            }, 50);
        }

        /**
      * Método para criar um novo Historico do Contrato
      * @param {event} event
      * @param {object} modelo
      */
        function _criar(event, modelo) {
            var modeloViewModel = angular.copy(modelo);
            _preparaValorParaEnvio(modeloViewModel);
            ServicosGenericoService.exibirPreloaderRequisicaoIniciada(
                vm.controladorDialog,
                "Cadastrando histórico ..."
            );
            RequisicaoGenericaService.salvar(
                Api.contrato.historico_contrato.criar,
                modeloViewModel
            ).then(
                function (success) {
                    MdToastService.toastPadrao("Histórico cadastrado com sucesso!");
                    ContratoHistoricos.push(success.data);
                    vm.houveAlteracoes = true;
                    ServicosGenericoService.ocultarPreloaderRequisicaoFinalizada(
                        vm.controladorDialog
                    );
                    $mdDialog.hide(vm.houveAlteracoes);
                },
                function (error) {
                    ServicosGenericoService.ocultarPreloaderRequisicaoFinalizada(
                        vm.controladorDialog
                    );
                    MdDialogService.alertPadrao("Atenção!", null, error.data);
                }
            );
        }

        /**
     * Método para editar um histórico do contrato
     * @param {event} event
     * @param {object} modelo
     */
        function _atualizar(event, modelo) {
            var modeloViewModel = {
                codigo: modelo.codigo,
                observacoes: modelo.observacoes
            };
            _preparaValorParaEnvio(modeloViewModel);

            ServicosGenericoService.exibirPreloaderRequisicaoIniciada(
                vm.controladorDialog,
                "Editando histórico ..."
            );
            RequisicaoGenericaService.editar(
                Api.contrato.historico_contrato.atualizar,
                modeloViewModel
            ).then(
                function (success) {
                    MdToastService.toastPadrao("Histórico editado com sucesso!");
                    vm.houveAlteracoes = true;
                    ServicosGenericoService.ocultarPreloaderRequisicaoFinalizada(
                        vm.controladorDialog
                    );
                    $mdDialog.hide(vm.houveAlteracoes);
                }, function (error) {
                    ServicosGenericoService.ocultarPreloaderRequisicaoFinalizada(
                        vm.controladorDialog
                    );
                    MdDialogService.alertPadrao("Atenção!", null, error.data);
                }
            );
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('app.geral.brainstorming.brainstorming', [])
        .config(config);

    function config($stateProvider, RotasHtml) {
        var rotasHtml = RotasHtml.brainstorming.brainstorming;
        $stateProvider
            .state('app.geral_brainstorming_brainstorming', {
                url: '/geral/brainstorming',
                module: 'privado',
                params: {
                    parametros: null,
                    parametrosSolicitacao: null
                },
                views: {
                    'content@app': {
                        templateUrl: rotasHtml.templateUrl,
                        controller: 'BrainstormingController as vm'
                    },
                    'brainstorming-form@app.geral_brainstorming_brainstorming': {
                        templateUrl: rotasHtml.form
                    },
                    'brainstorming-tabela@app.geral_brainstorming_brainstorming': {
                        templateUrl: rotasHtml.tabela
                    }
                },
                resolve: {
                    ListarTodosUsuarios: function (Api, RequisicaoGenericaService) {
                        return RequisicaoGenericaService.listarSemParams(Api.usuario.detalhes_usuario.listarUsuariosAtivos);
                    }
                }
            });
    }

})();

(function () {
    'use strict'

    angular.module('app.geral.brainstorming.brainstorming')
        .controller('DialogRespostasController', DialogRespostasController);

    function DialogRespostasController(
        Brainstorming,
        usuarioLogado,
        $mdDialog,
        RequisicaoGenericaService,
        Api,
        MdDialogService,
        MdToastService
    ) {
        var vm = this;
        vm.requisicaSolicitada = false;
        vm.preloader = { habilitar: false };
        vm.resposta = {
            descricao: '',
            codigoUsuario: 0
        }

        vm.usuarioLogado = angular.copy(usuarioLogado)

        vm.metodosDialog = {
            salvar: metodoDialogSalvar,
            fecharDialog: metodoDialogFecharDialog
        };

        function metodoDialogSalvar(resposta) {
            vm.requisicaSolicitada = true;
            resposta.numeroBrainstorming = Brainstorming.numero;
            resposta.anoBrainstorming = Brainstorming.ano;

            var result = RequisicaoGenericaService.salvar(Api.brainstorming.brainstormingResposta.criar, resposta);

            result.then(
                function (success) {
                    vm.requisicaSolicitada = false;
                    MdToastService.toastPadrao("Resposta cadastrada com sucesso!");
                    Brainstorming.respostas.push(success.data);
                    $mdDialog.hide();
                },
                function (error) {
                    vm.requisicaSolicitada = false;
                    MdDialogService.alertPadrao(error.data);
                    $mdDialog.hide();
                }
            );
            return result;
        }

        function metodoDialogFecharDialog() {
            $mdDialog.hide();
        }

    }
})();
(function () {
    'use strict';

    angular
        .module('app.protecao.processamento.gerenciamentoprotecao', [])
        .config(Config);

    function Config($stateProvider, RotasHtml) {
        var rotasHtml = RotasHtml.gerenciamentoProtecao;
        $stateProvider
            .state('app.protecao_processamento_gerenciamentoprotecao', {
                url: '/protecao/processamento/gerenciamento-protecao',
                module: 'privado',
                params: {
                    parametros: null
                },
                views: {
                    'content@app': {
                        templateUrl: rotasHtml.templateUrl,
                        controller: 'GerenciamentoProtecaoController as vm'
                    },
                    'gerenciamento-protecao-form@app.protecao_processamento_gerenciamentoprotecao': {
                        templateUrl: rotasHtml.form
                    }
                },
                resolve: {
                    ListarTiposLicenca: function (Api, RequisicaoGenericaService) {
                        return RequisicaoGenericaService.listarSemParams(Api.protecao.tipoLicenca.listarTodos);
                    }
                }
            });
    }

})();

(function () {
    'use strict';

    angular.module('app.protecao.processamento.gerenciamentoprotecao')
        .controller('DetalhesDialogController', DetalhesDialogController);

    function DetalhesDialogController($mdDialog, LicencaSelecionada, Api, RequisicaoGenericaService) {
        var vm = this;
        vm.licencaSelecionada = LicencaSelecionada;
        var rotas = Api.protecao.tipoLicenca;

        listarTiposDeLicencaVinculadoALicenca();

        vm.metodosDialog = {
            fecharDialog: fecharDialog

        }

        function fecharDialog() {
            $mdDialog.hide();
        }



        function listarTiposDeLicencaVinculadoALicenca() {
            vm.requisicaSolicitada = true;

            RequisicaoGenericaService.listarSemParams(rotas.listarPorNumeroLicenca +
                "/" + vm.licencaSelecionada.numero)
                .then(function (success) {
                    vm.requisicaSolicitada = false;
                    vm.licencaSelecionada.tiposLicencas = success.data;
                    console.log(vm.licencaSelecionada.tiposLicencas);
                }, function (err) {
                    vm.requisicaSolicitada = false;
                });

        }

    }
})();

(function () {
    'use strict';

    angular.module('app.protecao.processamento.gerenciamentoprotecao')
        .controller('ProtecaoDialogController', ProtecaoDialogController);

    function ProtecaoDialogController($mdDialog, ProtecaoLicenca, NumeroLicenca) {
        var vm = this;
        vm.protecaoLicenca = angular.copy(ProtecaoLicenca);
        vm.numeroLicenca = angular.copy(NumeroLicenca);
        
        vm.metodosDialog = {
            fecharDialog: fecharDialog

        }

        function fecharDialog() {
            $mdDialog.hide();
        }


    }
})();

(function () {
    'use strict';

    angular.module('app.protecao.processamento.gerenciamentoprotecao')
        .controller('DialogQuantidadeLicencaController', DialogQuantidadeLicencaController);

    function DialogQuantidadeLicencaController($mdDialog, MdDialogService, GerenciamentoProtecaoService, MdToastService, LicencaSelecionada) {
        var vm = this;
        vm.licenca = angular.copy(LicencaSelecionada);

        vm.metodosDialog = {
            fecharDialog: fecharDialog,
            salvar: salvar
        }

        function fecharDialog() {
            $mdDialog.hide();
        }

        function salvar(event) {
            vm.requisicaSolicitada = true;
            var entidade = _preparaEntidadeParaSalvar();
            GerenciamentoProtecaoService.atualizarQuantidadeLicencas(entidade)
                .then(function (success) {
                    vm.requisicaSolicitada = false;
                    _preparaLicencaParaExibicao(success.data);
                    MdToastService.toastPadrao("Atualizado com sucesso!");
                    fecharDialog();
                }, function (error) {
                    vm.requisicaSolicitada = false;
                    MdDialogService.alertPadrao("Atenção", event, error.data);
                });
        }

        function _preparaLicencaParaExibicao(entidade) {
            LicencaSelecionada.quantidadeTotal = GerenciamentoProtecaoService.formata30AEsquerda(angular.copy(entidade.quantidadeTotal));
            LicencaSelecionada.quantidadeUtilizadas = GerenciamentoProtecaoService.formata30AEsquerda(angular.copy(entidade.quantidadeUtilizadas));
            LicencaSelecionada.quantidadeDisponiveis = GerenciamentoProtecaoService.formata30AEsquerda(angular.copy(entidade.quantidadeDisponiveis));
            LicencaSelecionada.quantidadeTotal = GerenciamentoProtecaoService.formata30AEsquerda(angular.copy(LicencaSelecionada.quantidadeTotal));
        }

        function _preparaEntidadeParaSalvar() {
            return {
                contratoItemCodigo: vm.licenca.contratoItemCodigo,
                tipoLicencaCodigo: vm.licenca.tipoLicenca.codigo,
                quantidadeDeLicencas: vm.licenca.quantidadeTotal
            };
        }
    }
})();

/**
 * Created by nova on 28/10/2016.
 */
(function ()
{
  'use strict';

  angular
    .module('app.planejamentoScrum.processamento.sprint')
    .controller('BurndownController', BurndownController);

  function BurndownController() {
    var vm = this;

    vm.metodosBurndown = {
      abrirDialogBurndown: abrirDialogBurndown
    }

    // Data
    vm.dataBurnDown = {
      dados:[
        {
          data: new Date(2016,4,20),
          burnup:23,
          velocity:23,
          burndown:336,
          ideal:324
        },{
          data: new Date(2016,4,22),
          burnup:50,
          velocity:27,
          burndown:309,
          ideal:288
        },{
          data: new Date(2016,4,25),
          burnup:83,
          velocity:33,
          burndown:276,
          ideal:252
        },{
          data: new Date(2016,4,26),
          burnup:104,
          velocity:21,
          burndown:255,
          ideal:216
        },{
          data: new Date(2016,4,27),
          burnup:135,
          velocity:31,
          burndown:224,
          ideal:180
        },{
          data: new Date(2016,4,28),
          burnup:160,
          velocity:25,
          burndown:199,
          ideal:144
        },{
          data: new Date(2016,4,29),
          burnup:188,
          velocity:28,
          burndown:171,
          ideal:108
        },{
          data: new Date(2016,5,2),
          burnup:217,
          velocity:29,
          burndown:142,
          ideal:72
        },{
          data: new Date(2016,5,3),
          burnup:249,
          velocity:32,
          burndown:110,
          ideal:36
        },{
          data: new Date(2016,5,4),
          burnup:270,
          velocity:21,
          burndown:89,
          ideal:0
        }
      ]
    }

    vm.lineChart = {
      options: {
        chart: {
          type: 'lineChart',
          height: 600,
          width: 1200,
          margin: {
            top: 20,
            right: 20,
            bottom: 40,
            left: 55
          },
          x: function (d) {
            return d.x;
          },
          y: function (d) {
            return d.y;
          },
          useInteractiveGuideline: true,
          xAxis: {
            axisLabel: 'Dias',
            tickFormat: function (d) {
              return DateToString(vm.dataBurnDown.dados[d].data);
            }
          },
          yAxis: {
            axisLabel: 'Horas',
            tickFormat: function (d) {
              return d3.format('.02f')(d);
            },
            axisLabelDistance: 30
          }
        }
      },
      data: preencherGrafico()
    };

    function DateToString(Dt1) {
      var dt =Dt1;
      var dia = dt.getDate();
      var mes = dt.getMonth();
      var ano = dt.getFullYear();
      return dia+"/"+mes+"/"+ano;
    }

    function preencherGrafico() {
      var idealTrend = [], burnDown = [], velocity = [],
        burnUp = [];

      //Data is represented as an array of {x,y} pairs.
      for (var i = 0; i < vm.dataBurnDown.dados.length; i++) {
        idealTrend.push({
          x: i,
          y: vm.dataBurnDown.dados[i].ideal
        });
        burnDown.push({
          x: i,
          y: vm.dataBurnDown.dados[i].burndown
        });
        burnUp.push({
          x: i,
          y: vm.dataBurnDown.dados[i].burnup
        });
        velocity.push({
          x: i,
          y: vm.dataBurnDown.dados[i].velocity
        });
      }

      return [
        {
          values: idealTrend,
          key: 'Ideal Trend',
          color: '#2980b9',
          strokeWidth: 2,
          classed: 'dashed'
        },
        {
          values: burnUp,
          key: 'BurnUp',
          color: '#f1c40f'
        },
        {
          values: burnDown,
          key: 'BurnDown',
          color: '#c0392b'
        }
        ,
        {
          values: velocity,
          key: 'Velocity',
          color: '#27ae60'
        }
      ];
    }

    function abrirDialogBurndown(){
      $mdDialog.show({
        controller: 'BurndownController',
        controllerAs: 'vm',
        templateUrl: 'app/main/planejamento/processamento/sprint/views/tabs/burndown/tab-burndown-grafico.html',
        //parent: ---------------,
        targetEvent: event,
        clickOutsideToClose: false,
        locals:{
          Sprint: vm.sprint
        }
      });
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('app.planejamentoScrum.consulta.estoria', [])
    .config(Config);

  function Config($stateProvider, RotasHtml) {
    var rotasHtmlConsultaEstoria = RotasHtml.consultaEstoria;
    var rotasHtmlEstoria = RotasHtml.estoria;
    $stateProvider.state("app.planejamento_consulta_estoria", {
      url: "/consultas/estorias",
      module: "privado",
      views: {
        "content@app": {
          templateUrl: rotasHtmlConsultaEstoria.templateUrl,
          controller: "ConsultaEstoriasController as vm"
        }
      },
      resolve: {
        ListarTodasSituacoes: function (Api, RequisicaoGenericaService) {
          return RequisicaoGenericaService.listarSemParams(
            Api.situacao.listarCodigoDescricao
          );
        },
        ListarUsuarioPorDetalhe: function (Api, RequisicaoGenericaService, LoginUsuarioService) {
          return RequisicaoGenericaService.listarSemParams(Api.usuario.detalhes_usuario.listarDetalhesUsuario
            + LoginUsuarioService.usuarioArmazenado().codigo);
        }
      }
    });
  }

})();

/**
 * Created by nova on 26/10/2016.
 */
(function () {
  'use strict';

  angular
    .module('app.planejamentoScrum.consulta.estoria')
    .controller('ConsultaEstoriasDialogInformativoController', ConsultaEstoriasDialogInformativoController);

  function ConsultaEstoriasDialogInformativoController($mdDialog) {
    var vm = this;
    vm.requisicaoSolicitada = false;

    vm.metodosDialog = {
      fecharDialog: fecharDialog,
    };

    function fecharDialog() {
      $mdDialog.hide();
    }
  }

})();

(function () {
    'use strict';

    angular
        .module('app.planejamentoScrum.consulta.estoria')
        .controller('ConsultaEstoriasDialogAlterarDataEstoriaController', ConsultaEstoriasDialogAlterarDataEstoriaController);

    function ConsultaEstoriasDialogAlterarDataEstoriaController($filter, ConsultasEstoriaService, Api, RequisicaoGenericaService, $mdDialog, MdToastService, MdDialogService, Index, Estoria, EstoriasVencidas, EstoriasSeteDiasRestantes) {
        var vm = this;

        //<editor-fold desc="Data">
        vm.form = {};
        vm.titulo = "Editando Data Entrega";
        vm.requisicaSolicitada = false;

        vm.estoria = angular.copy(Estoria);
        // Data region

        //endregion
        //</editor-fold>

        //<editor-fold desc="Definição Métodos">
        vm.metodosDialog = {
            fecharDialog: metodoDialogFecharDialog,
            salvar: salvar
        }
        // Definição Métodos region

        //endregion
        //</editor-fold>

        //<editor-fold desc="Implmentação dos Métodos">
        // Implmentação dos Métodos region
        function salvar(estoria, event) {
            vm.requisicaSolicitada = true;

            RequisicaoGenericaService.editar(Api.estoria.atualizarDataEntregaEstoria, estoria).then(
                function (success) {
                    vm.requisicaSolicitada = false;
                    MdToastService.toastPadrao("Data Entrega alterada com sucesso.");
                    Estoria.dataEntrega = success.data.dataEntrega;
                    var dataFormatada = $filter('date')(Estoria.dataEntrega, 'dd/MM/yyyy', 'UTC');

                    var api = $('#datatables-consultas-estorias').DataTable();
                    $('#td-consultas-estorias' + Index).html('<div class="border-bottom-azul">' + dataFormatada + '</div>');
                    api.cells("#td-consultas-estorias" + Index).invalidate().draw();

                    ConsultasEstoriaService.verificarDiasRestantes([Estoria], EstoriasVencidas, EstoriasSeteDiasRestantes);


                    $mdDialog.hide();
                },
                function (error) {
                    vm.requisicaSolicitada = false;
                    alert(error.data, event);
                });

        }

        function metodoDialogFecharDialog() {
            $mdDialog.hide();
        }
        //endregion
        //</editor-fold>

    }

})();



(function () {
    "use strict";

    angular
        .module("app.locacao.consulta.historico", [])
        .config(config);

    function config($stateProvider, RotasHtml) {
        var rotasHtmlHistorico = RotasHtml.historico;
        $stateProvider.state(
            "app.locacao_consulta_historico",
            {
                url: "/locacao/consulta/historico",
                module: "privado",
                views: {
                    "content@app": {
                        templateUrl: rotasHtmlHistorico.templateUrl,
                        controller: "HistoricoController as vm"
                    },
                    "historico-form@app.locacao_consulta_nota": {
                        templateUrl: rotasHtmlHistorico.form
                    }
                },
                resolve: {
                    ListarEmpresaAtivo: function (Api, RequisicaoGenericaLocacaoService) {
                        return RequisicaoGenericaLocacaoService.listarSemParams(Api.locacao.empresaAtiva.listarTodos);
                    }
                }

            }
        );
    }
})();

(function () {
    'use strict';

    angular
        .module('app.locacao.consulta.historico')
        .controller('DialogEstadoConservacaoHistoricoController',DialogEstadoConservacaoHistoricoController)

    /** @ngInject */
    function DialogEstadoConservacaoHistoricoController(
        Api,
        $mdDialog,
        MdDialogService,
        EquipamentoEstadoConservacao,
        RequisicaoGenericaLocacaoService,
        Detalhe,
        RotasHtml
    ) {
        var vm = this;
        vm.locacaoEnvio = {};
        vm.rotasHtml = RotasHtml.locacao_envio;
        vm.locacaoEnvio.fotos = [];
        vm.detalhe = Detalhe;
        vm.obj = {};

        vm.equipamentoEstadoConservacao = EquipamentoEstadoConservacao;

        vm.metodos = {
            cancel: cancel,
            dialogEstadoConservacao: dialogEstadoConservacao,
            dialog: dialog,
            editarEstadoDeConservacao: editarEstadoDeConservacao
        };

        init();

        function init() {
            vm.conservacao = vm.detalhe.equipamentoEstadoConservacaoId;
        }

        function editarEstadoDeConservacao(event,modelo) {
            vm.obj.id = vm.detalhe.id;
            vm.obj.equipamentoEstadoConservacaoId = modelo;
            vm.obj.numeroSerie = vm.detalhe.numeroSerie;
            RequisicaoGenericaLocacaoService.editar(
                Api.locacao.nota_item_detalhe_historico.editarEstadoConservacao,vm.obj
            ).then(function (success) {
                vm.detalhesHistoricos = success.data;
                $mdDialog.hide(vm.detalhesHistoricos);
            },function (err) {
                MdDialogService.alertPadrao(err.data);
            });
        }

        function dialog(modelo,item) {
            $mdDialog.hide(modelo);
        }

        function cancel() {
            $mdDialog.cancel();
        }

        function dialogEstadoConservacao() {
            $mdDialog.hide();
        }
    }

}());


(function () {
    "use strict";

    angular
        .module("app.manutencao.consulta.ordem-servico",[])
        .config(config);
    function config($stateProvider,RotasHtml) {
        var rotasHtmlConsultaOrdemServico = RotasHtml.ordem_servico_consulta;
        $stateProvider.state(
            "app.manutencao_consulta_ordemservico",
            {
                url: "/manutencao/consulta/ordem-servico",
                module: "privado",
                views: {
                    "content@app": {
                        templateUrl: rotasHtmlConsultaOrdemServico.ordem_servico.templateUrl,
                        controller: "ConsultaOrdemServicoController as vm"
                    }
                },
                resolve: {
                    ListarClientes: function (Api,RequisicaoGenericaLocacaoService) {
                        return RequisicaoGenericaLocacaoService.listarSemParams(Api.locacao.clientes.listarTodosDescricao);
                    },
                    ListarTodosUsuariosAtivos: function (Api,RequisicaoGenericaService) {
                        return RequisicaoGenericaService.listarSemParams(Api.usuario.detalhes_usuario.listarUsuariosAtivos);
                    },
                    ListarPrioridades: function (Api,RequisicaoGenericaLocacaoService) {
                        return RequisicaoGenericaLocacaoService.listarSemParams(Api.manutencao.prioridade.listarTodos);
                    },
                    ListarEmpresaAtivo: function (Api,RequisicaoGenericaLocacaoService) {
                        return RequisicaoGenericaLocacaoService.listarSemParams(Api.locacao.empresaAtiva.listarTodos);
                    },
                    ListarTipoServico: function (Api,RequisicaoGenericaLocacaoService) {
                        return RequisicaoGenericaLocacaoService.listarSemParams(Api.manutencao.tipoServico.listarTodos);
                    }
                }
            }
        );
    }
})();

(function () {
    "use strict";

    angular
        .module("app.manutencao.consulta.ordem-servico")
        .controller("DialogOrdemItemController",DialogOrdemItemController);

    function DialogOrdemItemController(
        $mdDialog,
        RequisicaoGenericaLocacaoService,
        Api,
        Item
    ) {
        var vm = this;

        init();

        function init() {
            vm.item = Item;
            pesquisarItensOs(vm.item.ordemServicoId)
        }

        vm.metodos = {
            cancel: cancel,
            pesquisarItensOs: pesquisarItensOs
        };

        function cancel() {
            $mdDialog.hide(vm.execucao);
        }

        function pesquisarItensOs(item) {
            RequisicaoGenericaLocacaoService.listarSemParams(Api.manutencao.ordem_servico_item.listarPorOS + item)
                .then(function (success) {
                    vm.itens = success.data;
                },function (err) {
                    MdDialogService.alertPadrao("Atenção",event,err.data.error);
                })
        }
    }
})();

(function () {
    'use strict';

    angular
        .module("app.locacao.consulta.historico")
        .controller("DialogFotoController", DialogFotoController);

    /** @ngInject */
    function DialogFotoController(
        Historico,
        $mdDialog,
        RequisicaoGenericaLocacaoService,
        Api,
        EUltimoHistorico,
        RotasHtml,
        MdDialogService,
        ArquivosService
    ) {
        var vm = this;
        vm.detalhe = Historico
        vm.rotasHtml = RotasHtml.locacao_envio;
        vm.historicoId = Historico.id;
        vm.exibeBotoes = EUltimoHistorico;
        if (vm.detalhe.equipamento != undefined)
            vm.detalhe.equipamentoDescricao = vm.detalhe.equipamento.descricao;
        if (EUltimoHistorico)
            PequisarFotos(vm.historicoId);
        else
            PesquisarFotosLocados(vm.historicoId);

        vm.metodos = {
            cancel: cancel,
            zoomImg: zoomImg,
            PesquisarFotosLocados: PesquisarFotosLocados,
            zoomFoto: zoomFoto,
            inputFoto: inputFoto,
            selecionarArquivoFotos: selecionarArquivoFotos,
            excluirFotos: excluirFotos,
            existeFotoSelecionada: existeFotoSelecionada
        };

        function zoomFoto(foto) {
            $mdDialog
                .show({
                    controller: "DialogZoomFotoController",
                    controllerAs: "vm",
                    templateUrl: vm.rotasHtml.dialog.zoomFoto,
                    multiple: true,
                    targetEvent: event,
                    clickOutsideToClose: false,
                    locals: {
                        Foto: foto,
                        Servidor: true
                    }
                })
        }

        function cancel() {
            $mdDialog.cancel();
        }

        function zoomImg(index) {
            vm.index = index;
        }

        function PequisarFotos(historicoId) {
            vm.pesquisando = true;
            RequisicaoGenericaLocacaoService.listarSemParams(
                Api.locacao.equipamentoFoto.listarFotos + historicoId
            ).then(function (success) {
                vm.foto = success.data;
                _adicionaTimestampFoto(vm.foto);
                vm.pesquisando = false;
            });
        }

        function PesquisarFotosLocados(detalheId) {
            vm.pesquisando = true;
            RequisicaoGenericaLocacaoService.listarSemParams(
                Api.locacao.equipamentoFoto.listarPorDetalhe + detalheId
            ).then(function (success) {
                vm.foto = success.data;
                vm.pesquisando = false;
            });
        }

        function inputFoto() {
            document.getElementById("inputFotos").click();
        }

        function selecionarArquivoFotos(event, arquivos) {
            vm.pesquisando = true;
            var fotos = [];

            angular.forEach(arquivos, function (arquivo, index) {
                ArquivosService.obterArquivo(arquivo).then(function (arquivoViewModel) {
                    fotos.push(arquivoViewModel.base64StringArquivo);
                    if (arquivos.length == (index + 1)) {
                        var viewModel = {
                            numeroSerie: vm.detalhe.numeroSerie,
                            historicoDetalheId: vm.historicoId,
                            fotos: fotos
                        };

                        RequisicaoGenericaLocacaoService.salvar(Api.locacao.equipamentoFoto.adicionarFotosHistorico, viewModel)
                            .then(function (success) {
                                vm.foto = success.data;
                                _adicionaTimestampFoto(vm.foto);
                            }, function (error) {
                                MdDialogService.alertPadrao(error.data);
                            }).finally(function () {
                                document.getElementById("inputFotos").value = null;
                                vm.pesquisando = false;
                            });
                    }
                });
            });
        }

        function excluirFotos() {
            MdDialogService.confirmPadraoComEvento("Deseja realmente excluir essa(s) foto(s)?", null, null, function () {
                vm.pesquisando = true;

                var fotos = [];

                vm.foto.map(function (foto) {
                    if (foto.selecionado) {
                        fotos.push(foto.id);
                    }
                });

                var viewModel = {
                    historicoDetalheId: vm.historicoId,
                    equipamentosFotoId: fotos
                }

                RequisicaoGenericaLocacaoService.salvar(Api.locacao.equipamentoFoto.excluirFotosHistorico, viewModel)
                    .then(function (success) {
                        vm.foto = success.data;
                        _adicionaTimestampFoto(vm.foto);
                    }, function (error) {
                        MdDialogService.alertPadrao(error.data);
                    }).finally(function () {
                        vm.pesquisando = false;
                    });
            }, null);
        }

        function existeFotoSelecionada() {
            return vm.foto.filter(function (foto) { return foto.selecionado; }).length > 0;
        }

        function _adicionaTimestampFoto(listaFotos) {
            //Adição de timestamp para evitar cache de imagens no navegador, devido a URL da api ter chances de ser a mesma
            var timestamp = new Date().getTime();

            listaFotos.map(function (foto) {
                foto.caminhoFoto += ("?" + timestamp)
            });
        }
    }
}());
(function () {
  "use strict";

  angular
    .module("app.locacao.processamento.nota", [])
    .config(config);

  function config($stateProvider, RotasHtml) {
    var rotasHtmlNota = RotasHtml.nota;
    $stateProvider.state(
      "app.locacao_processamento_nota",
      {
        url: "/locacao/processamento/nota",
        module: "privado",
        views: {
          "content@app": {
            templateUrl: rotasHtmlNota.templateUrl,
            controller: "NotaController as vm"
          }
          // "tipo-locacao-form@app.locacao_processamento_nota": {
          //   templateUrl: rotasHtmlNota.form
          // }
          // "tipo-locacao-tabela@app.locacao_processamento_nota": {
          //   templateUrl: rotasHtmlNota.tabela
          // }
        },
        resolve: {
          ListarFornecedor: function (Api, RequisicaoGenericaLocacaoService) {
            return RequisicaoGenericaLocacaoService.listarSemParams(Api.locacao.equipamentos.fornecedor.listarTodos);
          },
          ListarObjetivoNota: function (Api, RequisicaoGenericaLocacaoService) {
            return RequisicaoGenericaLocacaoService.listarSemParams(Api.locacao.objetivoNota.listarTodos);
          },
          ListarEquipamento: function (Api, RequisicaoGenericaLocacaoService) {
            return RequisicaoGenericaLocacaoService.listarSemParams(Api.locacao.equipamentos.equipamento.listarTodos);
          },
          ListarEmpresaAtivo: function (Api, RequisicaoGenericaLocacaoService) {
            return RequisicaoGenericaLocacaoService.listarSemParams(Api.locacao.empresaAtiva.listarTodos);
          },
          Listarsituacao: function (Api, RequisicaoGenericaLocacaoService) {
            return RequisicaoGenericaLocacaoService.listarSemParams(Api.locacao.equipamentos.equipamentoSituacao.listarTodos);
          },
          ListarEstadoConservacao: function (Api, RequisicaoGenericaLocacaoService) {
            return RequisicaoGenericaLocacaoService.listarSemParams(Api.locacao.equipamentos.estadoConservacao.listarTodos)
          }
        }
      }
    );
  }
})();

(function () {
    'use strict';

    angular
        .module("app.locacao.processamento.nota")
        .controller("DialogFotoNotaController", DialogFotoNotaController);

    /** @ngInject */
    function DialogFotoNotaController(
        $mdDialog,
        $scope,
        ArquivosService,
        MdDialogService,
        RotasHtml,
        RequisicaoGenericaLocacaoService,
        Api,
        Detalhe,
        Editando,
        Visualizacao,
        ObrigaFoto
    ) {
        var vm = this;
        vm.rotasHtml = RotasHtml.locacao_envio;
        vm.fotos = [];
        vm.carregandoFotos = false;
        vm.editando = Editando;
        vm.apenasVisualizacao = Visualizacao;
        vm.obrigaFoto = ObrigaFoto;

        vm.metodos = {
            cancel: cancel,
            dialogEstadoConservacao: dialogEstadoConservacao,
            dialog: dialog,
            selecionarArquivoFotoDivulgacao: selecionarArquivoFotoDivulgacao,
            excluirFoto: excluirFoto,
            zoomFoto: zoomFoto,
            inputFoto: inputFoto
        };

        init();

        function init() {

        }
        if (Detalhe.id != undefined)
            PesquisarFotosLocados(Detalhe.id);
        if (Detalhe.fotos != undefined) {
            vm.fotos = Detalhe.fotos;
            vm.fotosCarregadas = angular.copy(vm.fotos);
        }
        function PesquisarFotosLocados(detalheId) {
            vm.pesquisando = true;
            RequisicaoGenericaLocacaoService.listarSemParams(
                Api.locacao.equipamentoFoto.listarPorDetalhe + detalheId
            ).then(function (success) {
                vm.fotos = success.data;
                vm.pesquisando = false;
            });
        }

        function zoomFoto(foto) {
            if (!vm.editando && !vm.apenasVisualizacao)
                vm.servidor = false;
            else
                vm.servidor = true
            $mdDialog
                .show({
                    controller: "DialogZoomFotoController",
                    controllerAs: "vm",
                    templateUrl: vm.rotasHtml.dialog.zoomFoto,
                    multiple: true,
                    targetEvent: event,
                    clickOutsideToClose: false,
                    locals: {
                        Foto: foto,
                        Servidor: vm.servidor
                    }

                })
        }

        function validaTipoImagem(arquivos) {
            var resultado = false;
            angular.forEach(arquivos, function (item, index) {
                if (item.type != "image/jpeg" && item.type != "image/png")
                    resultado = true;
            });
            return resultado;
        }

        function selecionarArquivoFotoDivulgacao(event, arquivos) {
            vm.flagFoto = false;
            vm.carregandoFotos = true;
            if (validaTipoImagem(arquivos)) {
                MdDialogService.alertPadrao("Tipo de arquivo incompatível.");
                vm.carregandoFotos = false;
                return;
            }
            calcularTamanhoArquivosSelecionados(arquivos);
            angular.forEach(arquivos, function (element) {
                ArquivosService.obterArquivo(element).then(function (success) {
                    if (vm.fotos.includes(success.base64StringArquivo)) {
                        if (!vm.flagFoto) {
                            document.getElementById("inputFoto").value = null;
                            MdDialogService.alertPadrao("Não é possível adicionar fotos duplicadas.");
                        }
                        vm.carregandoFotos = false;
                        vm.flagFoto = true;
                        return;
                    }
                    else {
                        vm.fotos.push(success.base64StringArquivo);
                    }

                });
            });
            vm.carregandoFotos = false;
        }

        function dialog(modelo, item) {
            $mdDialog.hide(modelo);
        }

        function cancel() {
            $mdDialog.hide(vm.fotosCarregadas);
        }



        function dialogEstadoConservacao() {
            $mdDialog.hide();
        }

        // $scope.$watch('vm.fotos.length', function (newValue, oldValue) {
        //     if (newValue == 1) {
        //         vm.mensagemCaption = "1 arquivo selecionado";
        //         //calcularTamanhoArquivosSelecionados(vm.fotos);
        //     }
        //     else if (newValue > 1) {
        //         vm.mensagemCaption = vm.fotos.length + " arquivos selecionados";
        //         //calcularTamanhoArquivosSelecionados(vm.fotos);
        //     }
        //     else {
        //         vm.mensagemCaption = null;
        //     }
        // });

        /**
         * Método que irá calcular o tamanho total de todos os arquivos selecionados
         * @param {arquivos} arquivos Lista de Arquivos Selecionados
         */
        function calcularTamanhoArquivosSelecionados(arquivos) {
            var tamanhoArquivos = null;
            angular.forEach(arquivos, function (item, index) {
                tamanhoArquivos += item.size;
            });


            vm.tamanhosArquivosSelecionados = retornarTamanhoArquivo(tamanhoArquivos);
            vm.tamanhoArquivosSelecionadosEmBite = tamanhoArquivos;

            if (vm.tamanhoArquivosSelecionadosEmBite > vm.tamanhoMaximoArquivosSelecionados)
                vm.desabilitarButtonSalvar = true;
            else
                vm.desabilitarButtonSalvar = false;
        }

        /**
         * Método que retorna o tamanho de todos os arquivos selecionas em B, Kb, Mb ou Gb
         * @param {tamanhoArquivo} tamanhoArquivos Tamanho de todos os arquivos selecionados
         */
        function retornarTamanhoArquivo(tamanhoArquivos) {
            if (tamanhoArquivos < 1024) {
                return Math.trunc(tamanhoArquivos) + "B";
            }
            else if (tamanhoArquivos >= 1024 && tamanhoArquivos < 1048576) {
                return Math.trunc((tamanhoArquivos / 1024)) + "Kb";
            }
            else if (tamanhoArquivos >= 1048576 && tamanhoArquivos < 1073741824) {
                return Math.trunc((tamanhoArquivos / (1024 * 1024))) + "Mb";
            }
            else {
                return Math.trunc((tamanhoArquivos / (1024 * 1024 * 1024))) + "Gb";
            }
        }

        function excluirFoto(index, foto) {
            vm.fotos.splice(index, 1);
        }

        function inputFoto() {
            document.getElementById("inputFoto").click();
        }
    }

}());

(function () {
  "use strict";

  angular
    .module("app.locacao.processamento.nota")
    .controller("DialogNotaItemController", DialogNotaItemController);

  function DialogNotaItemController(
    Api,
    RequisicaoGenericaLocacaoService,
    $mdDialog,
    ApenasVisualizacao,
    MdDialogService,
    NotaVinculada,
    Itens,
    NotaItem
  ) {
    var vm = this;
    vm.nota ={};
    vm.editando = false;
    vm.salvando = false;
    vm.notaVinculada = NotaVinculada;
    vm.itens = Itens;
    vm.apenasVisualizacao = ApenasVisualizacao;
    if(NotaItem != null){
      vm.editando = true;
      vm.notaItem = angular.copy(NotaItem);
    }

    vm.metodos = {
      pesquisar: pesquisar,
      salvar: salvar,
      editar: editar,
      excluir: excluir,
      cancel: cancel
    };
    pesquisarEquipamentos();

    function pesquisarEquipamentos(){
      RequisicaoGenericaLocacaoService.listarSemParams(
        Api.locacao.equipamentos.equipamento.listarTodos
      ).then(function(success){
        vm.equipamentos = success.data;
      });
    }

    function cancel(){
      $mdDialog.cancel();
    }
    function pesquisar() {
      return RequisicaoGenericaLocacaoService.listarComObjetoComplexo(
        Api.locacao.tipoLocacao.listarComPaginacao,
        vm.entidadeDeEnvio
      );
    }

    function salvar(modelo) {
      vm.salvando = true;
      if(modelo.observacao == null)
               modelo.observacao = "";
      if(NotaItem !=null)
          editar(modelo);
      else{
          modelo.equipamentoNotaId = vm.notaVinculada.id;
          RequisicaoGenericaLocacaoService.salvar(Api.locacao.nota_item.criar,modelo)
          .then(function(success){
              $mdDialog.hide(success.data);
              vm.salvando = false;
          },function(err){
              MdDialogService.alertPadrao("Atenção", event, err.data.error[0]);
              vm.salvando = false;
          });
      }

    }

    function editar(modelo) {
      return RequisicaoGenericaLocacaoService.editar(
        Api.locacao.nota_item.editar,
        modelo
      ).then(function (success) {
        $mdDialog.hide(success.data, false);
         vm.salvando = false;
      },function(err){
          MdDialogService.alertPadrao("Atenção", event, err.data.error[0]);
          vm.salvando = false;
       });
    }

    function excluir(modelo) {
      return RequisicaoGenericaLocacaoService.excluir(
        Api.locacao.nota_item.remover,
        modelo.id
      ).then(function (success) {
        $mdDialog.hide(modelo, true);
      },function(err){
          MdDialogService.alertPadrao("Atenção", event, err.data.error[0]);
       });
    }
  }


})();

(function () {
    "use strict";

    angular
        .module("app.locacao.processamento.nota")
        .controller("DialogNotaController",DialogNotaController);

    function DialogNotaController(
        Api,
        RequisicaoGenericaLocacaoService,
        $mdDialog,
        LoginUsuarioService,
        Nota,
        ApenasVisualizacao,
        MdDialogService,
        Forncededores,
        ObjetivoNotas,
        EmpresasAtivos
    ) {
        var vm = this;
        vm.nota = {};
        vm.editando = false;
        vm.salvando = false;
        vm.apenasVisualizacao = ApenasVisualizacao;
        vm.fornecedor = Forncededores;
        vm.objetivoNota = ObjetivoNotas;
        vm.empresaAtivo = EmpresasAtivos;
        vm.dataAtual = new Date(Date.now());

        vm.formaPagamento = [
            { codigo: 1,descricao: "Á vista" },
            { codigo: 2,descricao: "Parcelado" }
        ]

        if (Nota != null) {
            vm.editando = true
            vm.nota = angular.copy(Nota);
            vm.nota.dataNota = new Date(vm.nota.dataNota);
            vm.nota.dataNotaEntrada = new Date(vm.nota.dataNotaEntrada);
            vm.nota.dataVencimento = new Date(vm.nota.dataVencimento);
        }

        vm.metodos = {
            pesquisar: pesquisar,
            salvar: salvar,
            editar: editar,
            excluir: excluir,
            cancel: cancel
        };

        init();

        function init() {
            if (!Nota)
                vm.nota.dataNotaEntrada = vm.dataAtual;
        }

        retornaUsuarioLogado();

        function cancel() {
            $mdDialog.cancel();
        }
        function pesquisar() {
            return RequisicaoGenericaLocacaoService.listarComObjetoComplexo(
                Api.locacao.tipoLocacao.listarComPaginacao,
                vm.entidadeDeEnvio
            );
        }

        function salvar(modelo) {
            vm.salvando = true;
            if (Nota != null)
                editar(modelo)
            else {
                if (modelo.observacao == null)
                    modelo.observacao = "";
                modelo.codigoUsuario = LoginUsuarioService.usuarioArmazenado().codigo;
                modelo.nomeUsuario = LoginUsuarioService.usuarioArmazenado().login;
                RequisicaoGenericaLocacaoService.salvar(Api.locacao.nota.criar,modelo)
                    .then(function (success) {
                        $mdDialog.hide(success.data);
                        vm.salvando = false;
                    },function (err) {
                        MdDialogService.alertPadrao("Atenção",event,err.data.error[0]);
                        vm.salvando = false;
                    });
            }
        }

        function editar(modelo) {
            return RequisicaoGenericaLocacaoService.editar(
                Api.locacao.nota.editar,
                modelo
            ).then(function (success) {
                $mdDialog.hide(success.data,false);
                vm.salvando = false;
            },function (err) {
                MdDialogService.alertPadrao("Atenção",event,err.data.error[0]);
                vm.salvando = false;
            });
        }

        function excluir(modelo) {
            return RequisicaoGenericaLocacaoService.excluir(
                Api.locacao.nota.remover,
                modelo.id
            ).then(function (success) {
                $mdDialog.hide(modelo,true);
            },function (err) {
                MdDialogService.alertPadrao("Atenção",event,err.data.error[0]);
            });
        }

        function retornaUsuarioLogado() {
            vm.loginUsuario = LoginUsuarioService.usuarioArmazenado().login;
        }
    }


})();

(function () {
    "use strict";

    angular
        .module("app.locacao.processamento.nota")
        .controller("DialogNotaItemDetalheController", DialogNotaItemDetalheController);

    function DialogNotaItemDetalheController(
        Api,
        RequisicaoGenericaLocacaoService,
        $mdDialog,
        MdDialogService,
        ItemVinculado,
        Situacao,
        Detalhe,
        ApenasVisualizacao,
        EstadoConservacao,
        LoginUsuarioService,
        RotasHtml
        // Itens,
        // NotaItemDetalhe
    ) {
        var vm = this;
        vm.nota = {};
        vm.detalhe = {};
        vm.detalhe.equipamentoSituacaoId = 1;
        vm.detalhe.equipamentoEstadoConservacaoId = 1;
        vm.salvando = false;
        vm.editando = false;
        vm.itemVinculado = ItemVinculado;
        vm.situacao = Situacao;
        vm.apenasVisualizacao = ApenasVisualizacao;
        vm.detalhe.precoUnitario = vm.itemVinculado.preco / vm.itemVinculado.quantidade;
        vm.estadosConservacoes = EstadoConservacao.data;
        vm.rotasHtmlNota = RotasHtml.nota;

        if (Detalhe != null) {
            vm.editando = true;
            vm.detalhe = angular.copy(Detalhe);
        }
        // vm.itens = Itens;
        vm.metodos = {
            salvar: salvar,
            editar: editar,
            cancel: cancel,
            dialogFoto: dialogFoto,
            estadoConservacaoObrigaFoto: estadoConservacaoObrigaFoto
        };

        function salvar(modelo) {
            modelo.usuarioNome = LoginUsuarioService.usuarioArmazenado().login;
            modelo.usuarioId = LoginUsuarioService.usuarioArmazenado().codigo;
            vm.salvando = true;
            if (modelo.observacao == null) modelo.observacao = "";
            if (modelo.imei == null) modelo.imei = "";
            if (Detalhe != null) editar(modelo);
            else {
                modelo.equipamentoId = vm.itemVinculado.equipamentoId;
                modelo.equipamentoNotaItemId = vm.itemVinculado.id;
                RequisicaoGenericaLocacaoService.salvar(
                    Api.locacao.nota_item_detalhe.criar,
                    modelo
                ).then(
                    function (success) {
                        $mdDialog.hide(success.data);
                        vm.salvando = false;
                    },
                    function (err) {
                        MdDialogService.alertPadrao("Atenção", event, err.data.error[0]);
                        vm.salvando = false;
                    }
                );
            }
        }

        function editar(modelo) {
            return RequisicaoGenericaLocacaoService.editar(
                Api.locacao.nota_item_detalhe.editar,
                modelo
            ).then(
                function (success) {
                    $mdDialog.hide(success.data, false);
                    vm.salvando = false;
                },
                function (err) {
                    MdDialogService.alertPadrao("Atenção", event, err.data.error[0]);
                    vm.salvando = false;
                }
            );
        }

        function cancel() {
            $mdDialog.cancel();
        }
        function dialogFoto(detalhe) {
            $mdDialog.show({
                controller: "DialogFotoNotaController",
                controllerAs: "vm",
                templateUrl: vm.rotasHtmlNota.dialog_foto,
                multiple: true,
                targetEvent: event,
                clickOutsideToClose: false,
                locals: {
                    Detalhe: detalhe,
                    Editando: vm.editando,
                    Visualizacao: vm.apenasVisualizacao,
                    ObrigaFoto: estadoConservacaoObrigaFoto(detalhe.equipamentoEstadoConservacaoId)
                },
            }).then(function (success) {
                vm.detalhe.fotos = success;
            });
        }

        function estadoConservacaoObrigaFoto(estadoConservacaoId) {
            var estadoConservacao = vm.estadosConservacoes.find(function (item) {
                return item.id == estadoConservacaoId;
            });

            return estadoConservacao.obrigaFoto;
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.locacao.processamento.troca_ativo', [])
        .config(config);

    function config($stateProvider, RotasHtml) {
        var rotasHtml = RotasHtml.troca_ativo;

        $stateProvider
            .state('app.locacao_processamento_troca_ativo', {
                url: '/locacao/processamento/troca-ativo',
                module: 'privado',
                views: {
                    'content@app': {
                        templateUrl: rotasHtml.templateUrl,
                        controller: 'TrocaAtivoController as vm'
                    },
                    'troca-ativo-form@app.locacao_processamento_troca_ativo': {
                        templateUrl: rotasHtml.form
                    }
                },
                resolve: {
                    ListarEmpresaAtivo: function (Api, RequisicaoGenericaLocacaoService) {
                        return RequisicaoGenericaLocacaoService.listarSemParams(Api.locacao.empresaAtiva.listarTodos);
                    },
                    ListarFornecedor: function (Api, RequisicaoGenericaLocacaoService) {
                        return RequisicaoGenericaLocacaoService.listarSemParams(Api.locacao.equipamentos.fornecedor.listarTodos);
                    },
                    ListarObjetivoNota: function (Api, RequisicaoGenericaLocacaoService) {
                        return RequisicaoGenericaLocacaoService.listarSemParams(Api.locacao.objetivoNota.listarTodos);
                    },
                    ListarSituacoes: function (Api, RequisicaoGenericaLocacaoService) {
                        return RequisicaoGenericaLocacaoService.listarSemParams(Api.locacao.equipamentos.equipamentoSituacao.listarTodos);
                    }
                }
            });
    }
})();

(function () {
    "use strict";

    angular
        .module("app.locacao.processamento.troca_ativo")
        .controller("DialogDetalheItemController", DialogDetalheItemController);

    /** @ngInject */
    function DialogDetalheItemController(
        ItemDetalhes,
        Nota,
        $mdDialog
    ) {
        var vm = this;

        vm.itemDetalhes = ItemDetalhes;
        vm.nota = Nota

        vm.metodos = {
            fechar: fechar
        }

        function fechar() {
            $mdDialog.cancel();
        }
    }
})();

(function () {
    "use strict";

    angular
        .module("app.locacao.processamento.troca_ativo")
        .controller("DialogDetalheEquipamentoController", DialogDetalheEquipamentoController);

    /** @ngInject */
    function DialogDetalheEquipamentoController(
        DetalheEquipamento,
        $mdDialog
    ) {
        var vm = this;

        vm.detalheEquipamento = DetalheEquipamento;

        vm.metodos = {
            fechar: fechar
        }

        function fechar() {
            $mdDialog.cancel();
        }

    }
})();

//<!-- Ultima mudança 28/03/2017.-->
(function () {
    'use strict';

    angular
        .module('app.financeiro.relatorio.contratos', [])
        .config(config);

    function config($stateProvider, RotasHtml) {
        var rotasHtml = RotasHtml.relatorioContratos;

        $stateProvider
            .state('app.financeiro_relatorio_contratos', {
                url: '/financeiro/relatorio/contratos',
                module: 'privado',
                params: {
                    parametros: null
                },
                onEnter: function (RelatorioContratosFactory) {
                    RelatorioContratosFactory.setValoresInciaisFiltroContrato();
                },
                views: {
                    'content@app': {
                        templateUrl: rotasHtml.templateUrl,
                        controller: 'RelatorioContratosController as vm'
                    },
                    'relatorio-contratos-@app.financeiro_relatorio_contratos': {
                        templateUrl: rotasHtml.form
                    },
                    'relatorio-contratos--steper-cliente@app.financeiro_relatorio_contratos': {
                        templateUrl: rotasHtml.tabs.cliente,
                        controller: 'ClienteStepController as vm'
                    },
                    'relatorio-contratos--steper-informacoes-gerais@app.financeiro_relatorio_contratos': {
                        templateUrl: rotasHtml.tabs.informacoesGerais,
                        controller: 'InformacoesGeraisController as vm'
                    },
                    'relatorio-contratos--steper-produto-segmentacao@app.financeiro_relatorio_contratos': {
                        templateUrl: rotasHtml.tabs.produtoSegmentacao,
                        controller: 'ProdutoSegmentacaoController as vm'
                    },
                    'relatorio-contratos--steper-caracteristica@app.financeiro_relatorio_contratos': {
                        templateUrl: rotasHtml.tabs.caracteristica,
                        controller: 'CaracteristicaStepFinanceiroController as vm'
                    },
                    'relatorio-contratos--steper-caracteristica-contrato@app.financeiro_relatorio_contratos': {
                        templateUrl: rotasHtml.tabs.caracteristicaContrato,
                        controller: 'CaracteristicaContratoStepController as vm'
                    },
                    'relatorio-contratos--steper-licenca@app.financeiro_relatorio_contratos': {
                        templateUrl: rotasHtml.tabs.licenca,
                        controller: 'LicencaStepController as vm'
                    },
                    'relatorio-contratos--steper-subitem@app.financeiro_relatorio_contratos': {
                        templateUrl: rotasHtml.tabs.subitem,
                        controller: 'SubitemStepController as vm'
                    },

                },
                resolve: {
                    ListarSituacaoContrato: function (Api, RequisicaoGenericaService) {
                        return RequisicaoGenericaService.listarSemParams(Api.display.listarSituacaoContrato);
                    },
                    ListarSituacoesFinanceirasContrato: function (Api, RequisicaoGenericaService) {
                        return RequisicaoGenericaService.listarSemParams(Api.display.listarSituacaoFinanceiraContrato);
                    },
                    ListarTodasFormaPagamento: function (Api, RequisicaoGenericaService) {
                        return RequisicaoGenericaService.listarSemParams(Api.formaPagamento.listarTodos);
                    },
                    ListarTodasSolucoes: function (Api, RequisicaoGenericaService) {
                        return RequisicaoGenericaService.listarSemParams(Api.solucao_rotinas_tarefas.solucao.listarTodos);
                    },
                    ListarTodasCaracteristicas: function (Api, RequisicaoGenericaService) {
                        return RequisicaoGenericaService.listarSemParams(Api.contrato_caracteristica.listarTodos);
                    },
                    ListarProdutosComercializaveis: function (Api, RequisicaoGenericaService) {
                        return RequisicaoGenericaService.listarSemParams(Api.produto.listarProdutosComercializaveis);
                    },
                    ListarTodosEstados: function (Api, RequisicaoGenericaService) {
                        return RequisicaoGenericaService.listarSemParams(Api.display.listarTodasUf);
                    },
                    ListarTodasDatasContrato: function (Api, RequisicaoGenericaService) {
                        return RequisicaoGenericaService.listarSemParams(Api.display.dataContrato);
                    },
                    ListarTiposPagamentoContrato: function (Api, RequisicaoGenericaService) {
                        return RequisicaoGenericaService.listarSemParams(Api.display.tipoPagamentoContrato);
                    },
                    ListarUsuariosSetorComercial: function (Api, RequisicaoGenericaService) {
                        return RequisicaoGenericaService.listarSemParams(Api.usuario.detalhes_usuario.listarUsuariosSetorComercial);
                    },
                    ListarTodasCaracteristicasItem: function (Api, RequisicaoGenericaService) {
                        return RequisicaoGenericaService.listarSemParams(
                            Api.contrato_caracteristica.listarTodasCaracteristicasItem
                        );
                    },
                    ListarEmpresasFaturamento: function (Api, RequisicaoGenericaService) {
                        return RequisicaoGenericaService.listarSemParams(
                            Api.cliente.listarClientesEmpresaFaturamento
                        );
                    },
                    ListarSubitensContratuais: function (Api, RequisicaoGenericaService) {
                        return RequisicaoGenericaService.listarSemParams(Api.produto.listarTodosProdutos)
                            .then(function (response) {
                                response.data = (response.data || []).filter(function (produto) {
                                    return produto.subitemContratual === true;
                                });
                                return response;
                            });
                    }
                }
            });
    }

})();

(function () {
    'use strict';

    angular.module('app.financeiro.relatorio.contratos')
        .controller('LicencaStepController', LicencaStepController);

    function LicencaStepController(RelatorioContratosFactory, Api, RotasHtml, $scope) {
        var vm = this;

        init();

        function init() {
            vm.form = RelatorioContratosFactory.form;
            vm.filtrosContratos = RelatorioContratosFactory.filtrosContratos;
            vm.dtOptions = RelatorioContratosFactory.configurarDtOptions();
            vm.translateTitulosSteps = RelatorioContratosFactory.definirTransleteTitulosSteps();
            vm.tiposLicenca = [];
            vm.tiposLicencaANaoImprimir = [];
            vm.habilitarTodosTiposLicenca = true;
            vm.rotasHtml = RotasHtml.relatorioContratos;
            vm.rota = Api.contrato.relatorio_contrato;
            vm.seletores = { 1: 'E', 2: 'OU' };
            vm.filtrosContratos.seletor = 2;
            vm.rotaDePesquisa = Api.protecao.tipoLicenca.listarPor;
        }

        var metodosInternos = {
            verificaSeExisteTipoLicencaNaLista: _verificaSeExisteTipoLicencaNaLista,
            verificaSeExisteTipoLicencaANaoImprimirNaLista: _verificaSeExisteTipoLicencaANaoImprimirNaLista,
            removerTipoLicenca: _removerTipoLicenca,
            removerTipoLicencaANaoImprimir: _removerTipoLicencaANaoImprimir
        }

        //#region Whatchs
        $scope.$watch('vm.filtrosContratos.tiposLicenca.length', function (newValue, oldValue) {
            vm.filtrosContratos.tiposLicenca.forEach(function (value) {
                if (_verificaSeExisteTipoLicencaANaoImprimirNaLista(value))
                    _removerTipoLicencaANaoImprimir(value);
            });
        });

        $scope.$watch('vm.filtrosContratos.tiposLicencaANaoImprimir.length', function (newValue, oldValue) {
            vm.filtrosContratos.tiposLicencaANaoImprimir.forEach(function (value) {
                if (_verificaSeExisteTipoLicencaNaLista(value))
                    _removerTipoLicenca(value);
            });
        });
        //#endregion whatchs

        //#region metodosInternos
        function _verificaSeExisteTipoLicencaNaLista(tipo) {
            return vm.filtrosContratos.tiposLicenca.some(function (item) {
                return ((tipo.codigo) == (item.codigo));
            });
        }

        function _verificaSeExisteTipoLicencaANaoImprimirNaLista(tipo) {
            return vm.filtrosContratos.tiposLicencaANaoImprimir.some(function (item) {
                return ((tipo.codigo) == (item.codigo));
            });
        }
        //#endregion metodosInternos

        //#region  metodos
        function _removerTipoLicenca(tipo) {
            if (tipo && _verificaSeExisteTipoLicencaNaLista(tipo)) {

                for (var i = vm.filtrosContratos.tiposLicenca.length - 1; i >= 0; i--) {
                    if (vm.filtrosContratos.tiposLicenca[i].codigo === tipo.codigo) {
                        vm.filtrosContratos.tiposLicenca.splice(i, 1);
                    }
                }
            }
        }

        function _removerTipoLicencaANaoImprimir(tipo) {
            if (tipo && _verificaSeExisteTipoLicencaANaoImprimirNaLista(tipo)) {

                for (var i = vm.filtrosContratos.tiposLicencaANaoImprimir.length - 1; i >= 0; i--) {
                    if (vm.filtrosContratos.tiposLicencaANaoImprimir[i].codigo === tipo.codigo) {
                        vm.filtrosContratos.tiposLicencaANaoImprimir.splice(i, 1);
                    }
                }

            }
        }
        //#endregion metodos
    }

})();
(function () {
    'use strict';

    angular
        .module('app.financeiro.relatorio.contratos')
        .controller('CaracteristicaContratoStepController', CaracteristicaContratoStepController)

    /** @ngInject */
    function CaracteristicaContratoStepController(
        RelatorioContratosFactory,
        Api,
        RotasHtml,
        $scope
    ) {

        var vm = this;

        init();

        var metodosInternos = {
            verificaSeExisteCaracteristicaContratoNaLista: _verificaSeExisteCaracteristicaContratoNaLista,
            verificaSeExisteCaracteristicaItemNaLista: _verificaSeExisteCaracteristicaItemNaLista,
            verificaSeExisteCaracteristicaContratoANaoImprimirNaLista: _verificaSeExisteCaracteristicaContratoANaoImprimirNaLista,
            verificaSeExisteCaracteristicaItemANaoImprimirNaLista: _verificaSeExisteCaracteristicaItemANaoImprimirNaLista,
            removerCaracteristicaContrato: _removerCaracteristicaContrato,
            removerCaracteristicaItem: _removerCaracteristicaItem,
            removerCaracteristicaContratoANaoImprimir: _removerCaracteristicaContratoANaoImprimir,
            removerCaracteristicaItemANaoImprimir: _removerCaracteristicaItemANaoImprimir
        };

        function init() {
            vm.form = RelatorioContratosFactory.form;
            vm.filtrosContratos = RelatorioContratosFactory.filtrosContratos;
            vm.dtOptions = RelatorioContratosFactory.configurarDtOptions();
            vm.translateTitulosSteps = RelatorioContratosFactory.definirTransleteTitulosSteps();
            vm.caracteristicasContrato = [];
            vm.caracteristicasContratoANaoImprimir = [];
            vm.caracteristicasContratoItem = [];
            vm.caracteristicasContratoItemANaoImprimir = [];
            vm.habilitarTodasCaracteristica = true;
            vm.rotasHtml = RotasHtml.relatorioContratos;
            vm.rota = Api.contrato.relatorio_contrato;
            vm.seletores = { 1: 'E', 2: 'OU' };
            vm.filtrosContratos.seletor = 2;
            vm.rotaDePesquisa = Api.contrato_caracteristica.listarPor;
            vm.rotaDePesquisaCaracteristicasItem = Api.contrato_caracteristica.listarTodasCaracteristicasItem;
        }

        $scope.$watch('vm.filtrosContratos.caracteristicasContrato.length', function (newValue, oldValue) {
            vm.filtrosContratos.caracteristicasContrato.forEach(function (value) {
                if (_verificaSeExisteCaracteristicaContratoANaoImprimirNaLista(value))
                    _removerCaracteristicaContratoANaoImprimir(value);
            });
        });

        $scope.$watch('vm.filtrosContratos.caracteristicasContratoItem.length', function (newValue, oldValue) {
            vm.filtrosContratos.caracteristicasContratoItem.forEach(function (value) {
                if (_verificaSeExisteCaracteristicaItemANaoImprimirNaLista(value))
                    _removerCaracteristicaItemANaoImprimir(value);
            });
        });

        $scope.$watch('vm.filtrosContratos.caracteristicasContratoANaoImprimir.length', function (newValue, oldValue) {
            vm.filtrosContratos.caracteristicasContratoANaoImprimir.forEach(function (value) {
                if (_verificaSeExisteCaracteristicaContratoNaLista(value))
                    _removerCaracteristicaContrato(value);
            });
        });

        $scope.$watch('vm.filtrosContratos.caracteristicasContratoItemANaoImprimir.length', function (newValue, oldValue) {
            vm.filtrosContratos.caracteristicasContratoItemANaoImprimir.forEach(function (value) {
                if (_verificaSeExisteCaracteristicaItemNaLista(value))
                    _removerCaracteristicaItem(value);
            });
        });

        function _verificaSeExisteCaracteristicaContratoNaLista(caracteristica) {
            return vm.filtrosContratos.caracteristicasContrato.some(function (item) {
                return ((caracteristica.codigo) == (item.codigo));
            });
        }

        function _verificaSeExisteCaracteristicaItemNaLista(caracteristica) {
            return vm.filtrosContratos.caracteristicasContratoItem.some(function (item) {
                return ((caracteristica.codigo) == (item.codigo));
            });
        }

        function _verificaSeExisteCaracteristicaContratoANaoImprimirNaLista(caracteristica) {
            return vm.filtrosContratos.caracteristicasContratoANaoImprimir.some(function (item) {
                return ((caracteristica.codigo) == (item.codigo));
            });
        }

        function _verificaSeExisteCaracteristicaItemANaoImprimirNaLista(caracteristica) {
            return vm.filtrosContratos.caracteristicasContratoItemANaoImprimir.some(function (item) {
                return ((caracteristica.codigo) == (item.codigo));
            });
        }

        function _removerCaracteristicaContrato(caracteristica) {
            if (caracteristica && _verificaSeExisteCaracteristicaContratoNaLista(caracteristica)) {

                var obj = vm.filtrosContratos.caracteristicasContrato.find(function (c) {
                    return c.codigo === caracteristica.codigo;
                });

                if (obj) {
                    var index = vm.filtrosContratos.caracteristicasContrato.indexOf(obj);
                    vm.filtrosContratos.caracteristicasContrato.splice(index, 1);
                }
            }
        }

        function _removerCaracteristicaItem(caracteristica) {
            if (caracteristica && _verificaSeExisteCaracteristicaItemNaLista(caracteristica)) {

                var obj = vm.filtrosContratos.caracteristicasContratoItem.find(function (c) {
                    return c.codigo === caracteristica.codigo;
                });

                if (obj) {
                    var index = vm.filtrosContratos.caracteristicasContratoItem.indexOf(obj);
                    vm.filtrosContratos.caracteristicasContratoItem.splice(index, 1);
                }
            }
        }

        function _removerCaracteristicaContratoANaoImprimir(caracteristica) {
            if (caracteristica && _verificaSeExisteCaracteristicaContratoANaoImprimirNaLista(caracteristica)) {

                var obj = vm.filtrosContratos.caracteristicasContratoANaoImprimir.find(function (c) {
                    return c.codigo === caracteristica.codigo;
                });

                if (obj) {
                    var index = vm.filtrosContratos.caracteristicasContratoANaoImprimir.indexOf(obj);
                    vm.filtrosContratos.caracteristicasContratoANaoImprimir.splice(index, 1);
                }
            }
        }

        function _removerCaracteristicaItemANaoImprimir(caracteristica) {
            if (caracteristica && _verificaSeExisteCaracteristicaItemANaoImprimirNaLista(caracteristica)) {

                var obj = vm.filtrosContratos.caracteristicasContratoItemANaoImprimir.find(function (c) {
                    return c.codigo === caracteristica.codigo;
                });

                if (obj) {
                    var index = vm.filtrosContratos.caracteristicasContratoItemANaoImprimir.indexOf(obj);
                    vm.filtrosContratos.caracteristicasContratoItemANaoImprimir.splice(index, 1);
                }
            }
        }
    }

}());

(function () {
    'use strict';

    angular.module('app.financeiro.relatorio.contratos')
        .controller('ClienteStepController', ClienteStepController);

    function ClienteStepController($scope, Api, RequisicaoGenericaService, RotasHtml, ServicosGenericoService,
        RelatorioContratosFactory) {
        var vm = this;

        init();

        function init() {
            vm.form = RelatorioContratosFactory.form;
            vm.filtrosContratos = RelatorioContratosFactory.filtrosContratos;
            vm.dtOptions = RelatorioContratosFactory.configurarDtOptions();
            vm.translateTitulosSteps = RelatorioContratosFactory.definirTransleteTitulosSteps();
            vm.clientes = [];
            vm.todosClientes = true;
            vm.rotaPesquisa = Api.cliente.listarCodigoDescricao;
        }
    }

})();
(function () {
    "use strict";

    angular.module("app.financeiro.relatorio.reajustes", []).config(config);

    function config($stateProvider, RotasHtml) {
        var rotasHtml = RotasHtml.relatorioReajustes;

        $stateProvider.state("app.financeiro_relatorio_reajustes", {
            url: "/financeiro/relatorio/reajustes",
            module: "privado",
            params: {
                parametros: null
            },
            views: {
                "content@app": {
                    templateUrl: rotasHtml.templateUrl,
                    controller: "RelatorioReajustesController as vm"
                },
                "relatorio-reajustes@app.financeiro_relatorio_reajustes": {
                    templateUrl: rotasHtml.form
                },
                "relatorio-reajustes-steper-informacoes@app.financeiro_relatorio_reajustes": {
                    templateUrl: rotasHtml.tabs.informacoesGerais,
                    controller: "InformacoesGeraisReajustesController as vm"
                },
                "relatorio-reajustes-steper-produtos@app.financeiro_relatorio_reajustes": {
                    templateUrl: rotasHtml.tabs.produtos,
                    controller: "ProdutosReajustesController as vm"
                },
                "relatorio-reajustes-steper-reajuste-cliente@app.financeiro_relatorio_reajustes": {
                    templateUrl: rotasHtml.tabs.clientes,
                    controller: "ClienteStepReajusteController as vm"
                },
                "relatorio-reajustes-steper-caracteristica-contrato@app.financeiro_relatorio_reajustes": {
                    templateUrl: rotasHtml.tabs.caracteristicas,
                    controller: "CaracteristicaContratoReajusteStepController as vm"
                },
                "tipo-licenca-steper@app.financeiro_relatorio_reajustes": {
                    templateUrl: rotasHtml.tabs.tipoLicenca,
                    controller: "TipoLicencaController as vm"
                },
            },
            resolve: {
                ListarSituacaoContrato: function (Api, RequisicaoGenericaService) {
                    return RequisicaoGenericaService.listarSemParams(
                        Api.display.listarSituacaoContrato
                    );
                },
                ListarTodasSolucoes: function (Api, RequisicaoGenericaService) {
                    return RequisicaoGenericaService.listarSemParams(
                        Api.solucao_rotinas_tarefas.solucao.listarTodos
                    );
                },
                ListarProdutosComercializaveis: function (Api, RequisicaoGenericaService) {
                    return RequisicaoGenericaService.listarSemParams(
                        Api.produto.listarProdutosComercializaveis
                    );
                },
                ListarUsuariosSetorComercial: function (Api, RequisicaoGenericaService) {
                    return RequisicaoGenericaService.listarSemParams(
                        Api.usuario.detalhes_usuario.listarUsuariosSetorComercial
                    );
                },
                ListarTodosAtendimentosMotivo: function (
                    Api,
                    RequisicaoGenericaService
                ) {
                    return RequisicaoGenericaService.listarSemParams(
                        Api.contrato.motivo_aditivo.listarPor
                    );
                },
                ListarTodasCaracteristicas: function (Api, RequisicaoGenericaService) {
                    return RequisicaoGenericaService.listarSemParams(
                        Api.contrato_caracteristica.listarTodos
                    );
                },
                ListarTodasCaracteristicasItem: function (Api, RequisicaoGenericaService) {
                    return RequisicaoGenericaService.listarSemParams(
                        Api.contrato_caracteristica.listarTodasCaracteristicasItem
                    );
                },
                ListarEmpresasFaturamento: function (Api, RequisicaoGenericaService) {
                    return RequisicaoGenericaService.listarSemParams(
                        Api.cliente.listarClientesEmpresaFaturamento
                    );
                }
            }
        });
    }
})();

(function () {
    "use strict";
    angular
        .module("app.financeiro.relatorio.reajustes")
        .controller("ProdutosReajustesController", ProdutosReajustesController);

    function ProdutosReajustesController(
        $scope,
        Api,
        RotasHtml,
        ListarProdutosComercializaveis,
        RelatorioContratosFactory,
        RelatorioReajustesFactory
    ) {
        var vm = this;

        init();

        vm.metodos = {};

        vm.metodosInternos = {};

        function init() {
            vm.produtos = ListarProdutosComercializaveis.data;
            vm.filtrosreajustes = RelatorioReajustesFactory.filtrosReajustes;
        }

        //#region whatchs

        //#endregion

        //#region metodos
    }
})();

(function () {
    'use strict';
    angular.module('app.financeiro.relatorio.contratos')
        .controller('ProdutoSegmentacaoController', ProdutoSegmentacaoController);

    function ProdutoSegmentacaoController(
        $scope,
        Api,
        RequisicaoGenericaService,
        RotasHtml,
        ServicosGenericoService,
        RelatorioContratosFactory,
        ListarTodasSolucoes,
        ListarProdutosComercializaveis,
        ListarSubitensContratuais) {
        var vm = this;

        init();

        vm.metodos = {
        }

        vm.metodosInternos = {
        }

        function init() {
            vm.form = RelatorioContratosFactory.form;
            vm.filtrosContratos = RelatorioContratosFactory.filtrosContratos;
            vm.dtOptions = RelatorioContratosFactory.configurarDtOptions();
            vm.translateTitulosSteps = RelatorioContratosFactory.definirTransleteTitulosSteps();
            vm.rotasHtml = RotasHtml.relatorioContratos;
            vm.rota = Api.contrato.relatorio_contrato;
            vm.habilitarTodasSegmentacoes = true;
            vm.solucoes = ListarTodasSolucoes.data;
            vm.habilitarTodasSolucoes = true;
            vm.habilitarTodosProdutos = true;
            vm.produtos = ListarProdutosComercializaveis.data;
            vm.segmentacoes = [];
            vm.rotaDaPesquisa = Api.segmentacao.listarPor;
            vm.rotaDaPesquisaProdutos = Api.produto.listarProdutosComercializaveisPor;
            vm.subitens = ListarSubitensContratuais.data;
        }

    }
})();

(function () {
    'use strict';
    angular.module('app.financeiro.relatorio.contratos')
        .controller('InformacoesGeraisController', InformacoesGeraisController);

    function InformacoesGeraisController(
        $scope,
        RelatorioContratosFactory,
        ListarTodasFormaPagamento,
        ListarTodosEstados,
        ListarTodasDatasContrato,
        ListarSituacaoContrato,
        ListarSituacoesFinanceirasContrato,
        ListarTiposPagamentoContrato,
        ListarUsuariosSetorComercial,
        ListarEmpresasFaturamento
    ) {
        var vm = this;

        init();

        vm.metodos = {
            ngChangeLimparFormaDePagamento: ngChangeLimparFormaDePagamento,
            ngChangehabilitarTodasFormasPagamento: ngChangehabilitarTodasFormasPagamento,
            configurarSelectFormaPagamento: configurarSelectFormaPagamento,
            ngChangeLimparDataContrato: ngChangeLimparDataContrato,
            onChangeTipoRelatorio: onChangeTipoRelatorio
        };

        function init() {
            vm.form = RelatorioContratosFactory.form;
            vm.filtrosContratos = RelatorioContratosFactory.filtrosContratos;
            vm.filtrosContratos.tipoRelatorio = 1;
            vm.situacoesContrato = ListarSituacaoContrato.data;
            vm.formasPagamento = ListarTodasFormaPagamento.data;
            vm.estados = ListarTodosEstados.data.map(function (item, index) {
                return {
                    codigo: index,
                    descricao: item
                }
            });
            vm.executivos = ListarUsuariosSetorComercial.data;
            vm.habilitarTodasFormasDePagamento = true;
            vm.habilitarTodosEstados = true;
            vm.situacoesFinanceirasContrato = ListarSituacoesFinanceirasContrato.data;
            vm.ordenacao = {
                1: 'Alfabética',
                2: 'Numérica'
            };
            vm.tiposPagamento = ListarTiposPagamentoContrato.data;
            vm.dataContrato = ListarTodasDatasContrato.data;
            vm.empresasFaturamento = ListarEmpresasFaturamento.data;
        }

        $scope.$watch('vm.filtrosContratos.formasPagamento', function (newValue, oldValue) {
            if (vm.formasPagamento && vm.formasPagamento.length == 0)
                return;
            else if (newValue && newValue.length > 0) {
                vm.habilitarTodasFormasDePagamento = false;
            }
            else if (newValue && newValue.length == vm.formasPagamento.length) {
                _defineValoresDefaultFormaDePagamento();
            }
        });

        function ngChangehabilitarTodasFormasPagamento() {
            if (vm.habilitarTodasFormasDePagamento) {
                vm.filtrosContratos.formasPagamento = [];
            }
        }

        function ngChangeLimparDataContrato(item) {
            if (item == 5) {
                vm.filtrosContratos.periodoInicial = null;
                vm.filtrosContratos.periodoFinal = null;
            }
        }

        function onChangeTipoRelatorio(tipoRelatorio) {
            if (tipoRelatorio == 3) {
                vm.filtrosContratos.tipoDePagamento = 1;
                vm.filtrosContratos.formasPagamento = [];

                vm.filtrosContratos.valorItem = 1;

                vm.filtrosContratos.datas = 5;
                vm.filtrosContratos.periodoInicial = null;
                vm.filtrosContratos.periodoFinal = null;
            } else if (tipoRelatorio != 3) {
                vm.filtrosContratos.subitens = [];
                vm.filtrosContratos.subitensANaoImprimir = [];
            }
        }

        function configurarSelectFormaPagamento() {
            vm.termoProcurado = "";
            angular.element('#select-forma-pagamento').on('keydown', function (ev) {
                ev.stopPropagation();
            });
        }

        function ngChangeLimparFormaDePagamento() {
            _defineValoresDefaultFormaDePagamento();
        }

        function _defineValoresDefaultFormaDePagamento() {
            vm.habilitarTodasFormasDePagamento = true;
            vm.filtrosContratos.formasPagamento = [];
        }
    }
})();

(function () {
    'use strict';

    angular.module('app.financeiro.relatorio.contratos')
        .controller('CaracteristicaStepFinanceiroController', CaracteristicaStepFinanceiroController);

    function CaracteristicaStepFinanceiroController($scope, Api, RequisicaoGenericaService, RotasHtml, ServicosGenericoService,
        RelatorioContratosFactory) {
        var vm = this;

        init();

        var metodosInternos = {
            verificaSeExisteCaracteristicaNaLista: _verificaSeExisteCaracteristicaNaLista,
            verificaSeExisteCaracteristicaANaoImprimirNaLista: _verificaSeExisteCaracteristicaANaoImprimirNaLista,
            removerCaracteristica: _removerCaracteristica,
            removerCaracteristicaANaoImprimir: _removerCaracteristicaANaoImprimir
        }

        //#region init
        function init() {

            vm.form = RelatorioContratosFactory.form;
            vm.filtrosContratos = RelatorioContratosFactory.filtrosContratos;
            vm.dtOptions = RelatorioContratosFactory.configurarDtOptions();
            vm.translateTitulosSteps = RelatorioContratosFactory.definirTransleteTitulosSteps();
            vm.caracteristicas = [];
            vm.caracteristicasANaoImprimir = [];
            vm.habilitarTodasCaracteristica = true;
            vm.rotasHtml = RotasHtml.relatorioContratos;
            vm.rota = Api.contrato.relatorio_contrato;
            vm.seletores = { 1: 'E', 2: 'OU' };
            vm.filtrosContratos.seletor = 2;
            vm.rotaDePesquisa = Api.cliente_caracteristica.listarPor;
        }
        //#endregion init

        //#region Whatchs
        $scope.$watch('vm.filtrosContratos.caracteristicas.length', function (newValue, oldValue) {
            vm.filtrosContratos.caracteristicas.forEach(function (value) {
                if (_verificaSeExisteCaracteristicaANaoImprimirNaLista(value))
                    _removerCaracteristicaANaoImprimir(value);
            });
        });

        $scope.$watch('vm.filtrosContratos.caracteristicasANaoImprimir.length', function (newValue, oldValue) {
            vm.filtrosContratos.caracteristicasANaoImprimir.forEach(function (value) {
                if (_verificaSeExisteCaracteristicaNaLista(value))
                    _removerCaracteristica(value);
            });
        });
        //#endregion whatchs

        //#region metodosInternos
        function _verificaSeExisteCaracteristicaNaLista(caracteristica) {
            return vm.filtrosContratos.caracteristicas.some(function (item) {
                return ((caracteristica.codigo) == (item.codigo));
            });
        }

        function _verificaSeExisteCaracteristicaANaoImprimirNaLista(caracteristica) {
            return vm.filtrosContratos.caracteristicasANaoImprimir.some(function (item) {
                return ((caracteristica.codigo) == (item.codigo));
            });
        }
        //#endregion metodosInternos

        //#region  metodos
        function _removerCaracteristica(caracteristica) {
            if (caracteristica && _verificaSeExisteCaracteristicaNaLista(caracteristica)) {

                for (var i = vm.filtrosContratos.caracteristicas.length - 1; i >= 0; i--) {
                    if (vm.filtrosContratos.caracteristicas[i].codigo === caracteristica.codigo) {
                        vm.filtrosContratos.caracteristicas.splice(i, 1);
                    }
                }
            }
        }

        function _removerCaracteristicaANaoImprimir(caracteristica) {
            if (caracteristica && _verificaSeExisteCaracteristicaANaoImprimirNaLista(caracteristica)) {

                for (var i = vm.filtrosContratos.caracteristicasANaoImprimir.length - 1; i >= 0; i--) {
                    if (vm.filtrosContratos.caracteristicasANaoImprimir[i].codigo === caracteristica.codigo) {
                        vm.filtrosContratos.caracteristicasANaoImprimir.splice(i, 1);
                    }
                }

            }
        }
        //#endregion metodos

    }

})();
(function () {
    "use strict";
    angular
        .module("app.financeiro.relatorio.reajustes")
        .controller("TipoLicencaController",TipoLicencaController);

    function TipoLicencaController(
        $scope,
        Api,
        RotasHtml,
        RelatorioContratosFactory,
        RelatorioReajustesFactory
    ) {
        var vm = this;

        init();

        vm.metodos = {};
        vm.seletores = { 1: 'E', 2: 'OU' };
        vm.metodosInternos = {};

        function init() {
            vm.form = RelatorioContratosFactory.form;
            vm.filtrosContratos = RelatorioContratosFactory.filtrosContratos;
            vm.dtOptions = RelatorioContratosFactory.configurarDtOptions();
            vm.translateTitulosSteps = RelatorioContratosFactory.definirTransleteTitulosSteps();
            vm.tiposLicenca = [];
            vm.tiposLicencaANaoImprimir = [];
            vm.habilitarTodosTiposLicenca = true;
            vm.rotasHtml = RotasHtml.relatorioContratos;
            vm.rota = Api.contrato.relatorio_contrato;
            vm.seletores = { 1: 'E', 2: 'OU' };
            vm.filtrosContratos.seletor = 2;
            vm.rotaDePesquisa = Api.protecao.tipoLicenca.listarPor;
            vm.filtrosreajustes = RelatorioReajustesFactory.filtrosReajustes;
        }

        var metodosInternos = {
            verificaSeExisteTipoLicencaNaLista: _verificaSeExisteTipoLicencaNaLista,
            verificaSeExisteTipoLicencaANaoImprimirNaLista: _verificaSeExisteTipoLicencaANaoImprimirNaLista,
            removerTipoLicenca: _removerTipoLicenca,
            removerTipoLicencaANaoImprimir: _removerTipoLicencaANaoImprimir
        }

        //#region Whatchs
        $scope.$watch('vm.filtrosContratos.tiposLicenca.length', function (newValue, oldValue) {
            vm.filtrosContratos.tiposLicenca.forEach(function (value) {
                if (_verificaSeExisteTipoLicencaANaoImprimirNaLista(value))
                    _removerTipoLicencaANaoImprimir(value);
            });
        });

        $scope.$watch('vm.filtrosreajustes.tiposLicencaANaoImprimir.length', function (newValue, oldValue) {
            vm.filtrosreajustes.tiposLicencaANaoImprimir.forEach(function (value) {
                if (_verificaSeExisteTipoLicencaNaLista(value))
                    _removerTipoLicenca(value);
            });
        });
        //#endregion whatchs

        //#region metodosInternos
        function _verificaSeExisteTipoLicencaNaLista(tipo) {
            return vm.filtrosreajustes.tiposLicenca.some(function (item) {
                return ((tipo.codigo) == (item.codigo));
            });
        }

        function _verificaSeExisteTipoLicencaANaoImprimirNaLista(tipo) {
            return vm.filtrosreajustes.tiposLicencaANaoImprimir.some(function (item) {
                return ((tipo.codigo) == (item.codigo));
            });
        }
        //#endregion metodosInternos

        //#region  metodos
        function _removerTipoLicenca(tipo) {
            if (tipo && _verificaSeExisteTipoLicencaNaLista(tipo)) {

                for (var i = vm.filtrosreajustes.tiposLicenca.length - 1; i >= 0; i--) {
                    if (vm.filtrosreajustes.tiposLicenca[i].codigo === tipo.codigo) {
                        vm.filtrosreajustes.tiposLicenca.splice(i, 1);
                    }
                }
            }
        }

        function _removerTipoLicencaANaoImprimir(tipo) {
            if (tipo && _verificaSeExisteTipoLicencaANaoImprimirNaLista(tipo)) {

                for (var i = vm.filtrosContratos.tiposLicencaANaoImprimir.length - 1; i >= 0; i--) {
                    if (vm.filtrosContratos.tiposLicencaANaoImprimir[i].codigo === tipo.codigo) {
                        vm.filtrosContratos.tiposLicencaANaoImprimir.splice(i, 1);
                    }
                }

            }
        }
        //#endregion metodos
    }
})();


(function () {
    'use strict';

    angular.module('app.financeiro.relatorio.reajustes')
        .controller('ClienteStepReajusteController', ClienteStepReajusteController);

    function ClienteStepReajusteController(
      $scope,
      Api,
      RequisicaoGenericaService,
      RotasHtml,
      ServicosGenericoService,
      RelatorioContratosFactory,
      RelatorioReajustesFactory
    ) {
      var vm = this;

      init();

      function init() {
        vm.form = RelatorioContratosFactory.form;
        vm.filtrosreajustes = RelatorioReajustesFactory.filtrosReajustes;
        vm.dtOptions = RelatorioContratosFactory.configurarDtOptions();
        vm.translateTitulosSteps = RelatorioContratosFactory.definirTransleteTitulosSteps();
        vm.clientes = [];
        vm.todosClientes = true;
        vm.rotaPesquisa = Api.cliente.listarCodigoDescricao;
      }
    }

})();

(function () {
    "use strict";
    angular
        .module("app.financeiro.relatorio.reajustes")
        .controller("InformacoesGeraisReajustesController", InformacoesGeraisReajustesController);

    function InformacoesGeraisReajustesController(
        Api,
        NavegacaoService,
        RequisicaoGenericaService,
        RelatorioReajustesFactory,
        RelatorioContratosFactory,
        ListarUsuariosSetorComercial,
        ListarTodosAtendimentosMotivo,
        ListarProdutosComercializaveis,
        ListarSituacaoContrato,
        ListarEmpresasFaturamento
    ) {
        var vm = this;
        NavegacaoService.setTituloAba("Financeiro relatório de reajustes");

        init();

        function init() {
            vm.produtos = ListarProdutosComercializaveis.data;
            vm.form = RelatorioContratosFactory.form;
            vm.executivos = ListarUsuariosSetorComercial.data;
            vm.motivos = ListarTodosAtendimentosMotivo.data;
            vm.filtrosreajustes = RelatorioReajustesFactory.filtrosReajustes;
            RelatorioReajustesFactory.setValoresInciaisFiltroContrato();
            RequisicaoGenericaService.listarSemParams(Api.contrato.status_contrato.listarPor).then(function (success) {
                vm.statusContrato = success.data;
            });
            vm.situacoesContrato = ListarSituacaoContrato.data;
            vm.ordenacao = {
                1: "Alfabética",
                2: "Numérica"
            };
            vm.empresasFaturamento = ListarEmpresasFaturamento.data;
        }
    }
})();

(function () {
    "use strict";

    angular
        .module("app.financeiro.relatorio.reajustes")
        .controller(
            "CaracteristicaContratoReajusteStepController",
            CaracteristicaContratoReajusteStepController
        );

    function CaracteristicaContratoReajusteStepController(
        RelatorioContratosFactory,
        RelatorioReajustesFactory,
        Api,
        RotasHtml,
        $scope
    ) {
        var vm = this;

        init();

        var metodosInternos = {
            verificaSeExisteCaracteristicaContratoNaLista: _verificaSeExisteCaracteristicaContratoNaLista,
            verificaSeExisteCaracteristicaItemNaLista: _verificaSeExisteCaracteristicaItemNaLista,
            verificaSeExisteCaracteristicaContratoANaoImprimirNaLista: _verificaSeExisteCaracteristicaContratoANaoImprimirNaLista,
            verificaSeExisteCaracteristicaItemANaoImprimirNaLista: _verificaSeExisteCaracteristicaItemANaoImprimirNaLista,
            removerCaracteristicaContrato: _removerCaracteristicaContrato,
            removerCaracteristicaItem: _removerCaracteristicaItem,
            removerCaracteristicaContratoANaoImprimir: _removerCaracteristicaContratoANaoImprimir,
            removerCaracteristicaItemANaoImprimir: _removerCaracteristicaItemANaoImprimir
        };

        function init() {
            vm.form = RelatorioContratosFactory.form;
            vm.filtrosreajustes = RelatorioReajustesFactory.filtrosReajustes;
            vm.dtOptions = RelatorioContratosFactory.configurarDtOptions();
            vm.translateTitulosSteps = RelatorioContratosFactory.definirTransleteTitulosSteps();
            vm.caracteristicasContrato = [];
            vm.caracteristicasContratoANaoImprimir = [];
            vm.caracteristicasContratoItem = [];
            vm.caracteristicasContratoItemANaoImprimir = [];
            vm.habilitarTodasCaracteristica = true;
            vm.rotasHtml = RotasHtml.relatorioReajustes;
            vm.rota = Api.contrato.relatorio_contrato;
            vm.seletores = { 1: "E", 2: "OU" };
            vm.filtrosreajustes.seletor = 2;
            vm.rotaDePesquisa = Api.contrato_caracteristica.listarPor;
            vm.rotaDePesquisaCaracteristicasItem = Api.contrato_caracteristica.listarTodasCaracteristicasItem;
        }

        $scope.$watch('vm.filtrosContratos.caracteristicasContrato.length', function (newValue, oldValue) {
            vm.filtrosreajustes.caracteristicasContrato.forEach(function (value) {
                if (_verificaSeExisteCaracteristicaContratoANaoImprimirNaLista(value))
                    _removerCaracteristicaContratoANaoImprimir(value);
            });
        });

        $scope.$watch('vm.filtrosreajustes.caracteristicasContratoItem.length', function (newValue, oldValue) {
            vm.filtrosreajustes.caracteristicasContratoItem.forEach(function (value) {
                if (_verificaSeExisteCaracteristicaItemANaoImprimirNaLista(value))
                    _removerCaracteristicaItemANaoImprimir(value);
            });
        });

        $scope.$watch('vm.filtrosreajustes.caracteristicasContratoANaoImprimir.length', function (newValue, oldValue) {
            vm.filtrosreajustes.caracteristicasContratoANaoImprimir.forEach(function (value) {
                if (_verificaSeExisteCaracteristicaContratoNaLista(value))
                    _removerCaracteristicaContrato(value);
            });
        });

        $scope.$watch('vm.filtrosreajustes.caracteristicasContratoItemANaoImprimir.length', function (newValue, oldValue) {
            vm.filtrosreajustes.caracteristicasContratoItemANaoImprimir.forEach(function (value) {
                if (_verificaSeExisteCaracteristicaItemNaLista(value))
                    _removerCaracteristicaItem(value);
            });
        });

        function _verificaSeExisteCaracteristicaContratoNaLista(caracteristica) {
            return vm.filtrosreajustes.caracteristicasContrato.some(function (item) {
                return ((caracteristica.codigo) == (item.codigo));
            });
        }

        function _verificaSeExisteCaracteristicaItemNaLista(caracteristica) {
            return vm.filtrosreajustes.caracteristicasContratoItem.some(function (item) {
                return ((caracteristica.codigo) == (item.codigo));
            });
        }

        function _verificaSeExisteCaracteristicaContratoANaoImprimirNaLista(caracteristica) {
            return vm.filtrosreajustes.caracteristicasContratoANaoImprimir.some(function (item) {
                return ((caracteristica.codigo) == (item.codigo));
            });
        }

        function _verificaSeExisteCaracteristicaItemANaoImprimirNaLista(caracteristica) {
            return vm.filtrosreajustes.caracteristicasContratoItemANaoImprimir.some(function (item) {
                return ((caracteristica.codigo) == (item.codigo));
            });
        }

        function _removerCaracteristicaContrato(caracteristica) {
            if (caracteristica && _verificaSeExisteCaracteristicaContratoNaLista(caracteristica)) {

                var obj = vm.filtrosreajustes.caracteristicasContrato.find(function (c) {
                    return c.codigo === caracteristica.codigo;
                });

                if (obj) {
                    var index = vm.filtrosreajustes.caracteristicasContrato.indexOf(obj);
                    vm.filtrosreajustes.caracteristicasContrato.splice(index, 1);
                }
            }
        }

        function _removerCaracteristicaItem(caracteristica) {
            if (caracteristica && _verificaSeExisteCaracteristicaItemNaLista(caracteristica)) {

                var obj = vm.filtrosreajustes.caracteristicasContratoItem.find(function (c) {
                    return c.codigo === caracteristica.codigo;
                });

                if (obj) {
                    var index = vm.filtrosreajustes.caracteristicasContratoItem.indexOf(obj);
                    vm.filtrosreajustes.caracteristicasContratoItem.splice(index, 1);
                }
            }
        }

        function _removerCaracteristicaContratoANaoImprimir(caracteristica) {
            if (caracteristica && _verificaSeExisteCaracteristicaContratoANaoImprimirNaLista(caracteristica)) {

                var obj = vm.filtrosreajustes.caracteristicasContratoANaoImprimir.find(function (c) {
                    return c.codigo === caracteristica.codigo;
                });

                if (obj) {
                    var index = vm.filtrosreajustes.caracteristicasContratoANaoImprimir.indexOf(obj);
                    vm.filtrosreajustes.caracteristicasContratoANaoImprimir.splice(index, 1);
                }
            }
        }

        function _removerCaracteristicaItemANaoImprimir(caracteristica) {
            if (caracteristica && _verificaSeExisteCaracteristicaItemANaoImprimirNaLista(caracteristica)) {

                var obj = vm.filtrosreajustes.caracteristicasContratoItemANaoImprimir.find(function (c) {
                    return c.codigo === caracteristica.codigo;
                });

                if (obj) {
                    var index = vm.filtrosreajustes.caracteristicasContratoItemANaoImprimir.indexOf(obj);
                    vm.filtrosreajustes.caracteristicasContratoItemANaoImprimir.splice(index, 1);
                }
            }
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.custosoftware.processamento.analise-custo', [])
        .config(config);

    function config($stateProvider, RotasHtml) {

        var rotasHtml = RotasHtml.custoSoftware.processamento.analiseCusto;

        $stateProvider
            .state('app.analise-custo', {
                url: '/gerenciamento-custo/processamento/analise-custo',
                module: 'privado',
                views: {
                    'content@app': {
                        templateUrl: rotasHtml.templateUrl,
                        controller: "AnaliseCustoController as vm"
                    },
                    'analise-custo-form@app.analise-custo': {
                        templateUrl: rotasHtml.form
                    },
                    'analise-custo-tabela@app.analise-custo': {
                        templateUrl: rotasHtml.tabela
                    }
                },
                resolve: {
                    ListarTodasSolucoes: function (Api, RequisicaoGenericaService) {
                        return RequisicaoGenericaService.listarSemParams(Api.solucao_rotinas_tarefas.solucao.listarCodigoDescricao);
                    },
                    ListarTodosCustosSoftwares: function (Api, RequisicaoGenericaService) {
                        return RequisicaoGenericaService.listarSemParams(Api.custo_software.custo.listar);
                    },
                    ListarTodosClientes: function (Api, RequisicaoGenericaService) {
                        return RequisicaoGenericaService.listarSemParams(Api.cliente.listarTodosAtivosContratuaisCodigoDescricao);
                    },
                    ListarUsuarioPorDetalhe: function (Api, RequisicaoGenericaService, LoginUsuarioService) {
                        return RequisicaoGenericaService.listarSemParams(Api.usuario.detalhes_usuario.listarDetalhesUsuario
                            + LoginUsuarioService.usuarioArmazenado().codigo);
                    },
                }
            })
    }
})();



(function () {
    'use strict';

    angular.module('app.custosoftware.processamento.analise-custo')
        .controller('DialogAnaliseCustoDashboardController', DialogAnaliseCustoDashboardController);

    function DialogAnaliseCustoDashboardController(
        $mdDialog,
        Dados
    ) {
        var vm = this;

        init();

        vm.metodos = {
            fecharDialog: fecharDialog,
            proximoItem: proximoItem,
            itemAnterior: itemAnterior,
            tratarValorNulo: tratarValorNulo
        }

        function init() {
            vm.posicaoConcluidos = 0;
            vm.posicaoAndamento = 0;
            vm.posicaoAguardando = 0;

            vm.desativarBotaoAnteriorConcluidos = true;
            vm.desativarBotaoAnteriorAndamento = true;
            vm.desativarBotaoAnteriorAguardando = true;

            vm.quantidadeElementosExibidos = 3;

            vm.dadosDashboard = Dados;
        }



        function fecharDialog() {
            $mdDialog.hide();
        }

        function proximoItem(quantidadeLista, posicao, classeCarousel) {
            var tamanhoElementos = 233;
            var moverPosicao = vm.quantidadeElementosExibidos * tamanhoElementos;
            var itensRestantes = quantidadeLista - (Math.abs(posicao) + vm.quantidadeElementosExibidos * tamanhoElementos) / tamanhoElementos;

            posicao -= itensRestantes >= vm.quantidadeElementosExibidos ? moverPosicao : itensRestantes * tamanhoElementos;

            var slide = angular.element(classeCarousel);
            slide.css({
                transform: "translateX(" + posicao + "px)"
            });

            _desativarBotoes(classeCarousel, posicao, quantidadeLista, tamanhoElementos);
        }

        function itemAnterior(quantidadeLista, posicao, classeCarousel) {
            var tamanhoElementos = 233;
            var moverPosicao = vm.quantidadeElementosExibidos * tamanhoElementos;
            var itensRestantes = Math.abs(posicao) / tamanhoElementos;

            posicao += itensRestantes >= vm.quantidadeElementosExibidos ? moverPosicao : itensRestantes * tamanhoElementos;

            var slide = angular.element(classeCarousel);
            slide.css({
                transform: "translateX(" + posicao + "px)"
            });

            _desativarBotoes(classeCarousel, posicao, quantidadeLista, tamanhoElementos);
        }

        function tratarValorNulo(valor) {
            if (angular.equals(null, valor) || angular.equals(undefined, valor)) return 0;
            else return valor;
        }

        function _desativarBotoes(classe, posicao, quantidadeLista, tamanhoElementos) {
            switch (classe) {
                case ".carousel-concluido": {
                    vm.desativarBotaoAnteriorConcluidos = (posicao === 0);
                    vm.desativarBotaoProximoConcluidos = (posicao <= -(quantidadeLista - vm.quantidadeElementosExibidos) * tamanhoElementos);
                    break;
                }
                case ".carousel-andamento": {
                    vm.desativarBotaoAnteriorAndamento = (posicao === 0);
                    vm.desativarBotaoProximoAndamento = (posicao <= -(quantidadeLista - vm.quantidadeElementosExibidos) * tamanhoElementos);
                    break
                }
                case ".carousel-aguardando": {
                    vm.desativarBotaoAnteriorAguardando = (posicao === 0);
                    vm.desativarBotaoProximoAguardando = (posicao <= -(quantidadeLista - vm.quantidadeElementosExibidos) * tamanhoElementos);
                    break;
                }
            }
        }
    }
})();
(function () {
    'use strict';

    angular.module('app.custosoftware.processamento.analise-custo')
        .controller('DialogAnaliseCustoConclusaoController', DialogAnaliseCustoConclusaoController);

    function DialogAnaliseCustoConclusaoController(
        Dados,
        $mdDialog,
        MdDialogService,
        MdToastService,
        RequisicaoGenericaService,
        Api
    ) {
        var vm = this;

        init();

        vm.metodos = {
            fecharDialog: fecharDialog,
            configuraMdSelectProjeto: configuraMdSelectProjeto,
            calcularSaldoProjeto: calcularSaldoProjeto,
            salvar: salvar
        }

        function init() {
            vm.projetos = Dados;
            vm.projeto = Dados[0];
            calcularSaldoProjeto();
        }

        function fecharDialog() {
            $mdDialog.hide();
        }

        function configuraMdSelectProjeto() {
            vm.filtrarProjetos = '';
            angular.element('#analise-custo-conclusao-projetos-md-select').on('keydown', function (ev) { ev.stopPropagation(); });
        }

        function calcularSaldoProjeto() {

            if (!vm.projeto) return;

            if (!vm.projeto.valorPago) vm.projeto.valorPago = 0;

            if (!vm.projeto.valorCusto) vm.projeto.valorCusto = 0;

            vm.projeto.saldo = vm.projeto.valorPago - vm.projeto.valorCusto;
        }

        function salvar() {
            if (!vm.projeto.fechamentoProjetoCodigo)
                _criar();
            else
                _editar();
        }

        function _editar() {
            vm.emProgresso = true;

            RequisicaoGenericaService.editar(Api.custo_software.analiseCusto.editar, _preparaEntidadeParaSalvar(vm.projeto))
                .then(function (success) {
                    MdDialogService.alertPadrao("Encerramento editado com sucesso!");
                    _atualizarDadosProjeto(success.data);
                }, function (error) {
                    _mensagemErro("Erro ao editar o encerramento", error.data);
                }).finally(function () {
                    vm.emProgresso = false;
                });
        }

        function _criar() {
            vm.emProgresso = true;

            RequisicaoGenericaService.salvar(Api.custo_software.analiseCusto.salvar, _preparaEntidadeParaSalvar(vm.projeto))
                .then(function (success) {
                    MdDialogService.alertPadrao("Encerramento cadastrado com sucesso!");
                    _atualizarDadosProjeto(success.data);
                }, function (error) {
                    _mensagemErro("Erro ao cadastrar", error.data);
                }).finally(function () {
                    vm.emProgresso = false;
                });
        }

        function _mensagemErro(mensagem, data) {
            MdDialogService.alertPadrao(mensagem, event, data);
        }

        function _preparaEntidadeParaSalvar(entidade) {
            var entidadePreparada = {
                codigo: entidade.fechamentoProjetoCodigo,
                codigoCustoSoftware: entidade.codigo,
                encerrado: entidade.encerrado,
                totalHistorias: entidade.totalHistorias,
                totalPontos: entidade.totalPontos,
                valorPago: entidade.valorPago,
                valorCusto: entidade.valorCusto,
                dataInicial: entidade.dataInicial,
                dataFinal: entidade.dataFinal
            }

            return entidadePreparada;
        }

        function _atualizarDadosProjeto(dados) {
            vm.projeto.fechamentoProjetoCodigo = dados.codigo;
            vm.projeto.dataInicial = dados.dataInicial;
            vm.projeto.dataInicialString = dados.dataInicialString;
            vm.projeto.dataFinal = dados.dataFinal;
            vm.projeto.dataFinalString = dados.dataFinalString;
        }
    }
})();
/**
 * Created by nova on 27/09/2016.
 */
(function () {
    'use strict';

    angular
        .module('app.geral.relatorio.cliente', [])
        .config(config)


    function config($stateProvider, RotasHtml) {
        var rotasHtmlRelatorioCliente = RotasHtml.relatorioClientes;

        $stateProvider
            .state('app.geral_relatorio_cliente', {
                url: '/geral/relatorio/relatorio_simplificado_de_cliente',
                module: 'privado',
                onEnter: function (RelatorioClienteFactory) {
                    RelatorioClienteFactory.setValoresInciaisFiltroCliente();
                },
                views: {
                    'content@app': {
                        templateUrl: rotasHtmlRelatorioCliente.templateUrl,
                        controller: "RelatorioClienteController as vm"
                    },
                    'relatorio-cliente-@app.geral_relatorio_cliente': {
                        templateUrl: rotasHtmlRelatorioCliente.form
                    },
                    'relatorio-clientes--steper-informacoes-gerais@app.geral_relatorio_cliente': {
                        templateUrl: rotasHtmlRelatorioCliente.informacoesGerais,
                        controller: "InformacoesGeraisClienteController as vm"

                    },
                    'relatorio-clientes--steper-produto-segmentacao@app.geral_relatorio_cliente': {
                        templateUrl: rotasHtmlRelatorioCliente.produtoSegmentacao,
                        controller: "ProdutoSegmentacaoClienteController as vm"
                    },
                    'relatorio-contratos--steper-caracteristica@app.geral_relatorio_cliente': {
                        templateUrl: rotasHtmlRelatorioCliente.caracteristica,
                        controller: "CaracteristicaClienteStepController as vm"
                    },'relatorio-clientes--steper-licenca@app.geral_relatorio_cliente': {
                        templateUrl: rotasHtmlRelatorioCliente.licenca,
                        controller: "TipoLicencaStepController as vm"
                    }

                },
                resolve: {
                    ListarTodasSolucoes: function (Api, RequisicaoGenericaService) {
                        return RequisicaoGenericaService.listarSemParams(Api.solucao_rotinas_tarefas.solucao.listarTodos);
                    },
                    ListarTodasCaracteristicas: function (Api, RequisicaoGenericaService) {
                        return RequisicaoGenericaService.listarSemParams(Api.cliente_caracteristica.listarTodos);
                    },
                    ListarTodosProdutos: function (Api, RequisicaoGenericaService) {
                        return RequisicaoGenericaService.listarSemParams(Api.produto.listarPor);
                    },
                    ListarTodosEstados: function (Api, RequisicaoGenericaService) {
                        return RequisicaoGenericaService.listarSemParams(Api.display.listarTodasUf);
                    },
                    ListarUsuariosSetorComercial: function (Api, RequisicaoGenericaService) {
                        return RequisicaoGenericaService.listarSemParams(Api.usuario.detalhes_usuario.listarUsuariosSetorComercial);
                    }


                }
            });
    }


})();

(function () {
    'use strict';

    angular.module('app.geral.relatorio.cliente')
        .controller('TipoLicencaStepController', TipoLicencaStepController);

    function TipoLicencaStepController(RelatorioClienteFactory, Api, $scope, TipoLicencaFactory, RotasHtml) {
        var vm = this;

        init();

        function init() {
            vm.form = RelatorioClienteFactory.form;
            vm.filtrosClientes = RelatorioClienteFactory.filtrosClientes;
            vm.dtOptions = RelatorioClienteFactory.configurarDtOptions();
            vm.translateTitulosSteps = RelatorioClienteFactory.definirTransleteTitulosSteps();
            vm.tiposLicenca = [];
            vm.tiposLicencaANaoImprimir = [];
            vm.habilitarTodosTiposLicenca = true;
            vm.rotasHtml = RotasHtml.relatorioClientes;
            vm.rota = Api.contrato.relatorio_contrato;
            vm.seletores = TipoLicencaFactory.seletores;
            vm.filtrosClientes.seletor = TipoLicencaFactory.seletor;
            vm.rotaDePesquisa = TipoLicencaFactory.rotaDePesquisa;
        }

        //#region Whatchs
        $scope.$watch('vm.filtrosClientes.tiposLicenca.length', function (newValue, oldValue) {
            vm.filtrosClientes.tiposLicenca.forEach(function (value) {
                if (_verificaSeExisteTipoLicencaANaoImprimirNaLista(value))
                    _removerTipoLicencaANaoImprimir(value);
            });
        });

        $scope.$watch('vm.filtrosClientes.tiposLicencaANaoImprimir.length', function (newValue, oldValue) {
            vm.filtrosClientes.tiposLicencaANaoImprimir.forEach(function (value) {
                if (_verificaSeExisteTipoLicencaNaLista(value))
                    _removerTipoLicenca(value);
            });
        });
        //#endregion whatchs

        //#region metodosInternos
        function _verificaSeExisteTipoLicencaNaLista(tipo) {
            return vm.filtrosClientes.tiposLicenca.some(function (item) {
                return ((tipo.codigo) == (item.codigo));
            });
        }

        function _verificaSeExisteTipoLicencaANaoImprimirNaLista(tipo) {
            return vm.filtrosClientes.tiposLicencaANaoImprimir.some(function (item) {
                return ((tipo.codigo) == (item.codigo));
            });
        }
        //#endregion metodosInternos

        //#region  metodos
        function _removerTipoLicenca(tipo) {
            if (tipo && _verificaSeExisteTipoLicencaNaLista(tipo)) {

                for (var i = vm.filtrosClientes.tiposLicenca.length - 1; i >= 0; i--) {
                    if (vm.filtrosClientes.tiposLicenca[i].codigo === tipo.codigo) {
                        vm.filtrosClientes.tiposLicenca.splice(i, 1);
                    }
                }
            }
        }

        function _removerTipoLicencaANaoImprimir(tipo) {
            if (tipo && _verificaSeExisteTipoLicencaANaoImprimirNaLista(tipo)) {

                for (var i = vm.filtrosClientes.tiposLicencaANaoImprimir.length - 1; i >= 0; i--) {
                    if (vm.filtrosClientes.tiposLicencaANaoImprimir[i].codigo === tipo.codigo) {
                        vm.filtrosClientes.tiposLicencaANaoImprimir.splice(i, 1);
                    }
                }

            }
        }
        //#endregion metodos
    }

})();
(function () {
    'use strict';
    angular.module('app.geral.relatorio.cliente')
        .controller('ProdutoSegmentacaoClienteController', ProdutoSegmentacaoClienteController);

    function ProdutoSegmentacaoClienteController($scope, Api, RequisicaoGenericaService, RotasHtml, ServicosGenericoService,
        RelatorioClienteFactory, ListarTodasSolucoes, ListarTodosProdutos) {
        var vm = this;

        init();

        vm.metodos = {
        }

        vm.metodosInternos = {
        }

        function init() {
            vm.rotaDaPesquisa = Api.segmentacao.listarPor;
            vm.form = RelatorioClienteFactory.form;
            vm.filtrosClientes = RelatorioClienteFactory.filtrosClientes;
            vm.translateTitulosSteps = RelatorioClienteFactory.definirTransleteTitulosSteps();
            vm.solucoes = ListarTodasSolucoes.data;
            vm.produtos = ListarTodosProdutos.data;
            vm.segmentacoes = [];
        }
    }
})();

(function () {
    'use strict';

    angular.module('app.geral.relatorio.cliente')
        .controller('InformacoesGeraisClienteController', InformacoesGeraisClienteController);

    function InformacoesGeraisClienteController($scope, RelatorioClienteFactory, ListarTodosEstados, ListarUsuariosSetorComercial) {

        var vm = this;
        vm.metodos = {
            configurarSelectEstados: configurarSelectEstados,
            ngChangeHabilitarTodosEstados: ngChangeHabilitarTodosEstados,
            ngChangeListarRescindidos: ngChangeListarRescindidos,
            ngChangeListarNaoAtendidos: ngChangeListarNaoAtendidos,

        }

        vm.metodosInternos = {
            defineValoresDefaultEstados: _defineValoresDefaultEstados,
        }


        init();

        function init() {
            vm.form = RelatorioClienteFactory.form;
            vm.filtrosClientes = RelatorioClienteFactory.filtrosClientes;
            vm.ordenacao = {
                1: "Numérica ",
                2: "Cidade"
            };
            vm.dadosClienteContratual = {
                1: "Sim",
                0: "Não",
                3: "Ambos"
            };

            vm.executivos = ListarUsuariosSetorComercial.data;
            vm.habilitarTodosEstados = true;
            vm.estados = ListarTodosEstados.data;
            vm.filtrosClientes.clienteContratual="1"

        }


        //#region  whatchs
       
        $scope.$watch('vm.filtrosClientes.estados', function (newValue, oldValue) {
            if (newValue && newValue.length == vm.estados.length) {
                _defineValoresDefaultEstados();
                return;
            }

            if (newValue && newValue.length > 0) {
                vm.habilitarTodosEstados = false;
                return;
            }
        });

        //#endregion whatchs


        //#region metodos
        function configurarSelectEstados() {
            vm.termoProcuradoEstados = "";
            angular.element('#select-estado').on('keydown', function (ev) {
                ev.stopPropagation();
            });
        }

        function ngChangeListarRescindidos() {
            if (!vm.listarRescindidos && vm.filtrosClientes != null) {
                vm.filtrosClientes.dataFimRescindidos = null;
                vm.filtrosClientes.dataInicioRescindidos = null;

            }
        }

        function ngChangeListarNaoAtendidos() {
            if (!vm.listarNaoAtendidos && vm.filtrosClientes != null) {
                vm.filtrosClientes.dataInicioNaoAtendidos = null;
                vm.filtrosClientes.dataFimNaoAtendidos = null;

            }

        }

        function ngChangeHabilitarTodosEstados() {
            if (vm.habilitarTodosEstados)
                _defineValoresDefaultEstados();
        }

        //#endregion metodos

        //#region metodos internos

        function _defineValoresDefaultEstados() {
            vm.habilitarTodosEstados = true;
            vm.filtrosClientes.estados = [];
        }

        //#endregion metodos internos


    }

})();

(function () {
    'use strict';

    angular.module('app.geral.relatorio.cliente')
        .controller('CaracteristicaClienteStepController', CaracteristicaClienteStepController);

    function CaracteristicaClienteStepController($scope, Api, RequisicaoGenericaService, RotasHtml, ServicosGenericoService,
        RelatorioClienteFactory) {
        var vm = this;

        init();

        vm.metodos = {
            removerCaracteristica: removerCaracteristica,
            removerCaracteristicaANaoImprimir: removerCaracteristicaANaoImprimir,
        }

        var metodosInternos = {
            verificaSeExisteCaracteristicaNaLista: _verificaSeExisteCaracteristicaNaLista,
            verificaSeExisteCaracteristicaANaoImprimirNaLista: _verificaSeExisteCaracteristicaANaoImprimirNaLista,
        }

        function init() {
            vm.rotaDaPesquisa = Api.cliente_caracteristica.listarPor;
            vm.form = RelatorioClienteFactory.form;
            vm.filtrosClientes = RelatorioClienteFactory.filtrosClientes;
            vm.dtOptions = RelatorioClienteFactory.configurarDtOptions();
            vm.translateTitulosSteps = RelatorioClienteFactory.definirTransleteTitulosSteps();
            vm.caracteristicas = [];
            vm.caracteristicasANaoImprimir = [];
            vm.habilitarTodasCaracteristica = true;
            vm.rotasHtml = RotasHtml.relatorioContratos;
            vm.rota = Api.contrato.relatorio_contrato;
            vm.filtrosClientes.seletor = 2;
        }

        //#region Whatchs
        $scope.$watch('vm.filtrosClientes.caracteristicas.length', function (newValue, oldValue) {
            vm.filtrosClientes.caracteristicas.forEach(function (value) {
                if (_verificaSeExisteCaracteristicaANaoImprimirNaLista(value))
                    removerCaracteristicaANaoImprimir(value);
            });
        });

        $scope.$watch('vm.filtrosClientes.caracteristicasANaoImprimir.length', function (newValue, oldValue) {
            vm.filtrosClientes.caracteristicasANaoImprimir.forEach(function (value) {
                if (_verificaSeExisteCaracteristicaNaLista(value))
                    removerCaracteristica(value);
            });
        });
        //#endregion whatchs

        //#region metodosInternos
        function _verificaSeExisteCaracteristicaNaLista(caracteristica) {
            return vm.filtrosClientes.caracteristicas.some(function (item) {
                return ((caracteristica.codigo) == (item.codigo));
            });
        }

        function _verificaSeExisteCaracteristicaANaoImprimirNaLista(caracteristica) {
            return vm.filtrosClientes.caracteristicasANaoImprimir.some(function (item) {
                return ((caracteristica.codigo) == (item.codigo));
            });
        }

        function removerCaracteristica(caracteristica) {
            if (caracteristica && _verificaSeExisteCaracteristicaNaLista(caracteristica)) {

                for (var i = vm.filtrosClientes.caracteristicas.length - 1; i >= 0; i--) {
                    if (vm.filtrosClientes.caracteristicas[i].codigo === caracteristica.codigo) {
                        vm.filtrosClientes.caracteristicas.splice(i, 1);
                    }
                }
            }
        }

        function removerCaracteristicaANaoImprimir(caracteristica) {
            if (caracteristica && _verificaSeExisteCaracteristicaANaoImprimirNaLista(caracteristica)) {

                for (var i = vm.filtrosClientes.caracteristicasANaoImprimir.length - 1; i >= 0; i--) {
                    if (vm.filtrosClientes.caracteristicasANaoImprimir[i].codigo === caracteristica.codigo) {
                        vm.filtrosClientes.caracteristicasANaoImprimir.splice(i, 1);
                    }
                }

            }
        }

    }

})();


(function () {
    'use strict';

    angular.module('app.geral.processamento.controle-horas-trabalhadas.tab-historico-viagem')
        .controller('TabHistoricoViagemController', TabHistoricoViagemController);

    function TabHistoricoViagemController($mdDialog, MdDialogService, DataTableConfigPadrao, MdToastService, Api, $rootScope, RequisicaoGenericaService, ControleHorasFactory, RotasHtml) {
        var vm = this;

        var rotasHtml = RotasHtml;
        init();


        vm.metodos = {
            abrirDialogCadastro: abrirDialogCadastro,
            abrirDialogRegistroHoraTrabalho: abrirDialogRegistroHoraTrabalho,
            excluirHistoricoViagem: excluirHistoricoViagem,
            preparaData:preparaData
        }


        function init() {
            configuraDtOptions();
        }

        //#region ListenerBroadcast

        $rootScope.$on('historico-viagem-carregado', function (event, historico) {
            vm.historicoViagem = historico;
        });

        $rootScope.$on('historico-controle-horas-push', function (event, historico) {
            vm.historicoViagem.push(historico);
        });

        $rootScope.$on('historico-controle-horas-edit', function (event, historico) {
            if (historico == null)
                return;
            var index = vm.historicoViagem.indexOf(historico);
            vm.historicoViagem.splice(index, 1);
            vm.historicoViagem.push(historico);
        });
        //#endregion ListenerBroadcast


        //#region metodos

        function abrirDialogCadastro(event, historicoViagemSelecionado, editando) {

            var tituloDialog = "Cadastrar Histórico";

            if (editando)
                tituloDialog = "Editar histórico";

            var historicoBind = angular.copy(ControleHorasFactory.historico());

            $mdDialog.show({
                controller: 'AdicionarHistoricoViagemDialogController',
                controllerAs: 'vm',
                templateUrl: rotasHtml.controleHorasTrabalhadas.tabs.historicoViagem.dialogHistoricoViagem,
                multiple: true,
                targetEvent: event,
                clickOutsideToClose: false,
                locals: {
                    CodigoHistorico: historicoBind.codigo,
                    TituloDialog: tituloDialog,
                    DatasBinding: {
                        minima: historicoBind.dataInicial,
                        maxima: historicoBind.dataFinal
                    },
                    HistoricoViagemSelecionado: historicoViagemSelecionado,
                    Editando: editando
                }
            });
        }

        function abrirDialogRegistroHoraTrabalho(event, historicoSelecionado) {
            $mdDialog.show({
                controller: 'RegistroPontoDialogController',
                controllerAs: 'vm',
                templateUrl: rotasHtml.controleHorasTrabalhadas.tabs.historicoViagem.dialogRegistroPonto,
                multiple: true,
                targetEvent: event,
                clickOutsideToClose: false,
                locals: {
                    Colaboradores: angular.copy(ControleHorasFactory.historico().colaboradores),
                    TituloDialog: "Registro de ponto",
                    Historico: historicoSelecionado,
                    DataMinima: new Date(historicoSelecionado.dataChegada),
                    DataMaxima: new Date(angular.copy(ControleHorasFactory.historico()).dataFinal),
                    ColaboradoresVinculados: ControleHorasFactory.historico().colaboradores
                }
            });
        }

        function excluirHistoricoViagem(event, historicoSelecionado) {
            MdDialogService.confirmPadraoComEvento("Excluir",
                'Deseja realmente excluir o registro ?', event,
                function () {
                    ControleHorasFactory.controleForm.emProgresso = true;
                    _requisicaoExcluir(historicoSelecionado).then(function (success) {
                        _removeHistoricoDaLista(historicoSelecionado);
                        ControleHorasFactory.controleForm.emProgresso = false;
                    }, function (error) {
                        MdDialogService.alertPadrao(error.data, null);
                        ControleHorasFactory.controleForm.emProgresso = false;
                    });

                });
        }


        //#endregion metodos

        //#region metodosinternos

        function configuraDtOptions() {
            vm.dtOptionsHistoricoViagem = DataTableConfigPadrao.dtOptionsPadraoComPaginacaoPaginTypeNumbersEReponsivo;
            vm.dtOptionsHistoricoViagem.lengthMenu = [10];
            vm.dtOptionsHistoricoViagem.pageLength = [10];
            vm.dtOptionsHistoricoViagem.columnDefs = [
                DataTableConfigPadrao.columnDefsPadrao,
            ];
        }

        function preparaData(data){
            if(data)
                return new Date(data).toLocaleDateString();
            return data;    
        }

        function _requisicaoExcluir(entidade) {
            return RequisicaoGenericaService.excluir(Api.contole_horas.viagem, entidade.codigo);
        }


        function _removeHistoricoDaLista(historico) {
            var indexHistorico = vm.historicoViagem.indexOf(historico);
            vm.historicoViagem.splice(indexHistorico, 1);
            MdToastService.toastPadrao("Dados removidos com sucesso!");

        }
        //#endregion metodosInternos

    } //CONTROLLER
})();

//<!-- Ultima mudança 31/03/2017.-->
(function () {
    'use strict';

    angular
        .module('app.atendimento.processamento.atendimento', [])
        .config(config);

    function config($stateProvider, RotasHtml) {
        var rotasHtml = RotasHtml;
        var rotasContratos = rotasHtml.contratos;
        var rotasHtmlAtendimento = rotasHtml.atendimento;
        $stateProvider
            .state('app.atendimento_processamento_atendimento', {
                url: '/atendimento/processamento/atendimento',
                module: 'privado',
                params: {
                    parametros: null
                },
                views: {
                    'content@app': {
                        templateUrl: rotasHtmlAtendimento.templateUrl,
                        controller: "AtendimentoController as vm"
                    },
                    'atendimento-form@app.atendimento_processamento_atendimento': {
                        templateUrl: rotasHtmlAtendimento.form
                    },
                    'atendimentos-tabela@app.atendimento_processamento_atendimento': {
                        templateUrl: rotasHtmlAtendimento.tabela
                    },
                    'contratos@app.atendimento_processamento_atendimento': {
                        templateUrl: rotasContratos.templateUrl
                    },
                    'contratos-form@app.atendimento_processamento_atendimento': {
                        templateUrl: rotasContratos.form
                    },
                    'contratos-tabela@app.atendimento_processamento_atendimento': {
                        templateUrl: rotasContratos.tabela
                    }
                },
                resolve: {
                    ListarTodosUsuariosAtivos: function (Api, RequisicaoGenericaService) {
                        return RequisicaoGenericaService.listarSemParams(Api.usuario.detalhes_usuario.listarUsuariosAtivos);
                    },
                    ListarTiposAtendimento: function (Api, RequisicaoGenericaService) {
                        return RequisicaoGenericaService.listarSemParams(Api.atendimento.listarTiposAtendimento);
                    },
                    ListarDetalhesUsuario: function (Api, RequisicaoGenericaService, LoginUsuarioService) {
                        return RequisicaoGenericaService.listarSemParams(Api.usuario.detalhes_usuario.listarDetalhesUsuario
                            + LoginUsuarioService.usuarioArmazenado().codigo);
                    },
                    ListarUsuarioPorDetalhe: function (Api, RequisicaoGenericaService, LoginUsuarioService) {
                        return RequisicaoGenericaService.listarSemParams(Api.usuario.detalhes_usuario.listarUsuarioPorDetalhe
                            + LoginUsuarioService.usuarioArmazenado().codigo);
                    },
                    ListarStatusAtendimento: function (Api, RequisicaoGenericaService) {
                        return RequisicaoGenericaService.listarSemParams(Api.atendimento.listarStatusAtendimento);
                    },
                    ListarTodasSolucoes: function (Api, RequisicaoGenericaService) {
                        return RequisicaoGenericaService.listarSemParams(Api.solucao_rotinas_tarefas.solucao.listarCodigoDescricao);
                    },
                    ListarTodosAtendimentosMotivo: function (Api, RequisicaoGenericaService, LoginUsuarioService) {
                        var codigo = LoginUsuarioService.usuarioArmazenado().codigo;
                        return RequisicaoGenericaService.listarComParams(Api.atendimento.grupo_atendimento.listarMotivoPorSetor + codigo);
                    },
                    ListarTodosAtendimentosPendencia: function (Api, RequisicaoGenericaService) {
                        return RequisicaoGenericaService.listarSemParams(Api.atendimento.pendencia_atendimento.listarPor);
                    },
                    ListarTodosAtendimentosConclusao: function (Api, RequisicaoGenericaService) {
                        return RequisicaoGenericaService.listarSemParams(Api.atendimento.conclusao.listarPor);
                    },
                    ListarTodosEventos: function (Api, RequisicaoGenericaService) {
                        return RequisicaoGenericaService.listarSemParams(Api.agenda.evento.listarTodos);
                    },
                    ListarStatusAtividade: function (Api, RequisicaoGenericaService) {
                        return RequisicaoGenericaService.listarSemParams(Api.agenda.atividade.listarStatus);
                    },
                    ListarTodasTags: function (Api, RequisicaoGenericaService) {
                        return RequisicaoGenericaService.listarSemParams(Api.atendimento.tag.listarTodas);
                    },
                    ListarUsuariosSetorComercial: function (Api, RequisicaoGenericaService) {
                        return RequisicaoGenericaService.listarSemParams(Api.usuario.listarUsuariosSetorComercial);
                    },
                }
            });
    }

})();

(function () {
    'use strict';

    angular
        .module('app.atendimento.processamento.atendimento')
        .controller('AtendimentoDialogSelecionarOSController', AtendimentoDialogSelecionarOSController);

    function AtendimentoDialogSelecionarOSController($mdDialog, $state, DatatableFactory, OS) {
        var vm = this;

        vm.form = {};

        vm.metodosDialog = {
            abrirOS: abrirOS,
            fecharDialog: metodoDialogFecharDialog
        };

        init();

        function init() {
            vm.ordensDeServicos = angular.copy(OS);
            vm.dtOptionsOrdensDeServico = angular.copy(DatatableFactory.construirDtOptionsComPaginacaoResponsivoPadrao([]));
            vm.dtOptionsOrdensDeServico.columnDefs = [
                {
                    targets: [2],
                    orderable: false
                }
            ]
        }

        function abrirOS(ordemServico) {
            $state.goNewTab("app.manutencao_ordem_servico", {
                parametros: {
                    os: ordemServico,
                    idOs: ordemServico.id
                }
            });
        }

        function metodoDialogFecharDialog() {
            $mdDialog.hide();
        }
    }
})();
/**
 * Created by nova on 26/10/2016.
 */
(function () {
    'use strict';

    angular
        .module('app.atendimento.processamento.atendimento')
        .controller('AtendimentoDialogUsuariosHaVisualizarController', AtendimentoDialogUsuariosHaVisualizarController);


    function AtendimentoDialogUsuariosHaVisualizarController(
        $mdDialog,
        $timeout,
        Api,
        Atendimento,
        ControleForm,
        DataTableConfigPadrao,
        InserirUsuariosHaVisualizarAtendimentoEmMemoria,
        AtendimentoAcompanhamentosVisualizacao,
        MdToastService,
        PesquisarAcompanhantesAtendimento,
        RequisicaoGenericaService,
        SquadService,
        SquadUsuarioLogado,
        UsuarioLogado
    ) {

        var vm = this;

        // Data region  
        vm.form = {};
        vm.inserirAtivo = false;
        vm.requisicaoSolicitada = false;
        vm.controleForm = ControleForm;
        vm.usuarioLogado = UsuarioLogado;

        vm.sigiloComercial = Atendimento.sigiloComercial;
        vm.todosUsuarios = null;

        vm.dtOptionsColaboradoresHaVisualizarAtendimento = angular.copy(DataTableConfigPadrao.dtOptionsResponsivoSemPaginacaoComInitComplete);
        vm.dtOptionsColaboradoresHaVisualizarAtendimento.dom = 'rt';
        vm.dtOptionsColaboradoresHaVisualizarAtendimento.columnDefs = [angular.copy(DataTableConfigPadrao.columnDefsPadrao)];
        //endregion                

        /**
         * Chamada do metódo inicializador
         */
        init();

        // Definição dos Métodos region   
        var metodosIterno = {
            verificaQuantidadeUsuariosVinculados: verificaQuantidadeUsuariosVinculados,
            salvarUsuariosHaVisualizarAtendimento: salvarUsuariosHaVisualizarAtendimento,
            salvarUsuariosHaVisualizarAtendimentoEmMemoria: salvarUsuariosHaVisualizarAtendimentoEmMemoria,
            inserirUsuariosComTipoAtendimentoComercial: inserirUsuariosComTipoAtendimentoComercial,
            inserirUsuariosComTipoAtendimentoComercialEmMemoria: inserirUsuariosComTipoAtendimentoComercialEmMemoria,
            removerUsuarioAtendimento: removerUsuarioAtendimento,
            removerUsuarioAtendimentoEmMemoria: removerUsuarioAtendimentoEmMemoria,
            removerTodosUsuariosDoAtendimento: removerTodosUsuariosDoAtendimento,
            removerTodosUsuariosDoAtendimentoEmMemoria: removerTodosUsuariosDoAtendimentoEmMemoria,
            construirUsuariosHaVisualizarAtendimentoViewModel: construirUsuariosHaVisualizarAtendimentoViewModel,
            redefinirSigiloComercial: redefinirSigiloComercial,
            atualizarSigiloComercialAtendimento: atualizarSigiloComercialAtendimento,
            atualizarSigiloComercialAtendimentoEmMemoria: atualizarSigiloComercialAtendimentoEmMemoria
        };
        vm.metodosDialog = {
            salvar: salvar,
            excluir: excluir,
            configuraMdSelectColaboradores: configuraMdSelectColaboradores,
            alterarEstadoCampoSigiloComercial: alterarEstadoCampoSigiloComercial,
            alterarEstadoCampoTodosUsuarios: alterarEstadoCampoTodosUsuarios,
            fecharDialog: metodoDialogFecharDialog,
            changeSquadsSelecionadas: changeSquadsSelecionadas,
            marcarDesmarcarTodasSquads: marcarDesmarcarTodasSquads,
            incluirNaLista: incluirNaLista
        };
        //endregion

        // Métodos Internos region  

        /**
         * Método inicizalizador
         */
        function init() {
            vm.squadUsuarioLogado = SquadUsuarioLogado;
            vm.squads = SquadService.listarSquadsUsuarioLogado(vm.squadUsuarioLogado);

            vm.requisicaoSolicitada = true;
            RequisicaoGenericaService.listarSemParams(Api.usuario.detalhes_usuario.listarUsuariosAtivos).then(
                function (success) {
                    vm.colaboradores = success.data;
                    vm.requisicaoSolicitada = false;
                    if (ControleForm.inserirAtivo) {
                        if (AtendimentoAcompanhamentosVisualizacao && AtendimentoAcompanhamentosVisualizacao.length) {
                            vm.usuariosHaVisualizarAtendimento = angular.copy(AtendimentoAcompanhamentosVisualizacao);
                            _setaValorCampoSquad();
                            _filtrarColaboradores(vm.codigoSquads);

                        } else {
                            vm.todasSquads = true;
                            vm.codigoSquads = vm.squadUsuarioLogado;
                            _filtrarColaboradores(vm.codigoSquads);
                            _atualizarUsuariosVisualizacaoAtendimento();
                        }
                        verificaQuantidadeUsuariosVinculados(vm.usuariosHaVisualizarAtendimento);
                        salvarUsuariosHaVisualizarAtendimentoEmMemoria();
                    }
                    else {
                        vm.requisicaoSolicitada = true;
                        RequisicaoGenericaService.listarSemParams(Api.atendimento.usuario_ha_visualizar_atendimento.listarAcompanhamentoVisualizacaoPorAtendimento +
                            Atendimento.codigo + "/" + Atendimento.ano).then(
                                function (success) {
                                    vm.usuariosHaVisualizarAtendimento = success.data;
                                    var colaboradoresSelecionados = [];
                                    _setaValorCampoSquad();
                                    angular.forEach(vm.colaboradores, function (colaborador) {
                                        if (vm.codigoSquads.some(function (squad) {
                                            return colaborador.codigoSquads.includes(squad);
                                        })) {
                                            colaboradoresSelecionados.push(colaborador);
                                        }
                                    });
                                    vm.colaboradoresFiltrados = colaboradoresSelecionados;
                                    verificaQuantidadeUsuariosVinculados(vm.usuariosHaVisualizarAtendimento);

                                    vm.requisicaoSolicitada = false;
                                }, function (error) { vm.requisicaoSolicitada = false; });
                    }
                }, function (error) { vm.requisicaoSolicitada = false; });
        }

        /**
         * Método que verifica a quantidade de usuarios vinculados
         * @param {arrayDeUsuarios} listaDeUsuariosHaVisualizar 
         */
        function verificaQuantidadeUsuariosVinculados(listaDeUsuariosHaVisualizar) {
            if (!listaDeUsuariosHaVisualizar && listaDeUsuariosHaVisualizar.length == 0) {
                vm.sigiloComercial = false;
                Atendimento.sigiloComercial = vm.sigiloComercial;
                redefinirSigiloComercial();
            }
        }

        function _setaValorCampoSquad() {
            var squadsPresentes = [];
            if (vm.squadUsuarioLogado.length === 1) vm.codigoSquads = vm.squadUsuarioLogado[0];
            vm.codigoSquads = SquadUsuarioLogado;
            vm.usuariosHaVisualizarAtendimento.forEach(function (usuario) {
                if (usuario.codigoSquads && usuario.codigoSquads.length) {
                    usuario.codigoSquads.forEach(function (codigo) {
                        if (vm.codigoSquads.includes(codigo) && !squadsPresentes.includes(codigo)) {
                            squadsPresentes.push(codigo);
                        }
                    });
                }
            });

            if (squadsPresentes.length) {
                vm.codigoSquads = squadsPresentes;
            }

            vm.todasSquads = squadsPresentes.length && vm.codigoSquads.every(function (codigo) {
                return squadsPresentes.includes(codigo);
            });
        }

        /**         
         * Método que faz uma requisição para api passando um usuarios para ser persistido no banco        
         * @param {colaborador} modelo
         */
        function salvarUsuariosHaVisualizarAtendimento(colaborador) {
            var modelo = construirViewModel(vm.sigiloComercial, colaborador);
            vm.requisicaoSolicitada = true;
            RequisicaoGenericaService.salvar(Api.atendimento.usuario_ha_visualizar_atendimento.criar, modelo).then(
                function (success) {
                    MdToastService.toastPadrao("Colaboradores vinculado com sucesso");
                    $mdDialog.hide();
                    vm.usuariosHaVisualizarAtendimento = success.data;
                    verificaQuantidadeUsuariosVinculados(vm.usuariosHaVisualizarAtendimento);
                    PesquisarAcompanhantesAtendimento(Atendimento.codigo, Atendimento.ano);
                    vm.requisicaoSolicitada = false;
                }, function (error) {
                    vm.requisicaoSolicitada = false;
                    MdToastService.toastPadrao(error.data, true);
                });
        }

        /**
         * Método que salva o usuário selecionado em memória para ser persistido posteriormente quando o
         * atendimento for criado
         * @param {colaborador} modelo 
         */
        function salvarUsuariosHaVisualizarAtendimentoEmMemoria(modelo) {
            if (modelo) {
                const usuarioJaListado = vm.usuariosHaVisualizarAtendimento.some(function (usuario) {
                    return usuario.codigo === modelo.codigo;
                });
                if (!usuarioJaListado) {
                    vm.usuariosHaVisualizarAtendimento.push(modelo);
                } else {
                    MdToastService.toastPadrao('O colaborador selecionado já está listado para visualizar o atendimento');
                }
            }
            InserirUsuariosHaVisualizarAtendimentoEmMemoria(vm.usuariosHaVisualizarAtendimento);
            verificaQuantidadeUsuariosVinculados(vm.usuariosHaVisualizarAtendimento);
        }

        /**
         * Método que faz uma requsição para api para inserir uma lista de usuários há visualizar o atendimento
         * com todos os usuários que tenham o tipo de atendimento == 'comercial'
         * @param {sigiloComercial} sigiloComercial
         */
        function inserirUsuariosComTipoAtendimentoComercial(sigiloComercial) {
            vm.requisicaoSolicitada = true;
            var modelo = construirUsuariosHaVisualizarAtendimentoViewModel(vm.sigiloComercial, []);
            RequisicaoGenericaService.salvar(Api.atendimento.usuario_ha_visualizar_atendimento.vincularUsuariosComTipoAtendimentoComercial, modelo).then(
                function (success) {
                    MdToastService.toastPadrao("Colaboradores vinculado com sucesso");
                    vm.usuariosHaVisualizarAtendimento = success.data;

                    verificaQuantidadeUsuariosVinculados(success.data);
                    PesquisarAcompanhantesAtendimento(Atendimento.codigo, Atendimento.ano);

                    Atendimento.sigiloComercial = sigiloComercial;
                    vm.requisicaoSolicitada = false;
                }, function (error) {
                    vm.sigiloComercial = false;
                    Atendimento.sigiloComercial = vm.sigiloComercial;
                    vm.requisicaoSolicitada = false;
                    MdToastService.toastPadrao(error.data, true);
                });
        }

        /**
         * Método que faz uma requsição para api para e busca todos os usuarios com 
         * que tenham tipo atendimento == 'comercial' e salva em memória
         * @param {sigiloComercial} sigiloComercial 
         */
        function inserirUsuariosComTipoAtendimentoComercialEmMemoria(sigiloComercial) {
            vm.requisicaoSolicitada = true;
            var modelo = construirUsuariosHaVisualizarAtendimentoViewModel(sigiloComercial, []);

            RequisicaoGenericaService.listarComParams(Api.atendimento.usuario_ha_visualizar_atendimento.vincularUsuariosComTipoAtendimentoComercialEmMemoria,
                modelo).then(
                    function (success) {
                        vm.usuariosHaVisualizarAtendimento = success.data;
                        vm.todosUsuarios = false;

                        InserirUsuariosHaVisualizarAtendimentoEmMemoria(vm.usuariosHaVisualizarAtendimento);
                        verificaQuantidadeUsuariosVinculados(success.data);

                        Atendimento.sigiloComercial = sigiloComercial;
                        vm.requisicaoSolicitada = false;
                    }, function (error) {
                        vm.sigiloComercial = false;
                        Atendimento.sigiloComercial = vm.sigiloComercial;

                        vm.requisicaoSolicitada = false;

                        MdToastService.toastPadrao(error.data, true);
                    });
        }

        /**
         * Método que faz uma requisição para Api e  remove o usuário selecionado do atendimento
         * @param {eventButton} event 
         * @param {usuario} modelo 
         */
        function removerUsuarioAtendimento(event, modelo) {
            vm.requisicaoSolicitada = true;
            RequisicaoGenericaService.excluir(Api.atendimento.usuario_ha_visualizar_atendimento.excluir,
                Atendimento.codigo + "/" + Atendimento.ano + "/" + modelo.codigo).then(
                    function (success) {
                        MdToastService.toastPadrao(success.data);

                        vm.usuariosHaVisualizarAtendimento.splice(vm.usuariosHaVisualizarAtendimento.indexOf(modelo), 1);

                        verificaQuantidadeUsuariosVinculados(vm.usuariosHaVisualizarAtendimento);
                        PesquisarAcompanhantesAtendimento(Atendimento.codigo, Atendimento.ano);

                        vm.requisicaoSolicitada = false;
                    },
                    function (error) {
                        vm.requisicaoSolicitada = false;
                        MdToastService.toastPadrao(error.data, true);
                    });
        }

        /**
         * Método que remove o usuário selecionado do atendimento
         * @param {eventButton} event 
         * @param {usuario} modelo 
         */
        function removerUsuarioAtendimentoEmMemoria(event, modelo) {
            vm.usuariosHaVisualizarAtendimento.splice(vm.usuariosHaVisualizarAtendimento.indexOf(modelo), 1);
            salvarUsuariosHaVisualizarAtendimentoEmMemoria();
            var colaboradoresSelecionados = [];
            angular.forEach(vm.colaboradores, function (colaborador) {
                if (vm.codigoSquads.some(function (squad) {
                    return colaborador.codigoSquads.includes(squad);
                })) {
                    colaboradoresSelecionados.push(colaborador);
                }
            });
            vm.colaboradoresFiltrados = colaboradoresSelecionados;
        }

        /**
         * Método que desvincula todo os usuários do atendimento, ou seja tornando visível o atendimento para 
         * todos os usuários do sistema
         */
        function removerTodosUsuariosDoAtendimento() {
            vm.requisicaoSolicitada = true;

            RequisicaoGenericaService.excluir(Api.atendimento.usuario_ha_visualizar_atendimento.removerUsuariosHaVisualizarDoAtendimento,
                Atendimento.codigo + "/" + Atendimento.ano).then(
                    function (success) {
                        if (success.data)
                            MdToastService.toastPadrao(success.data);

                        vm.usuariosHaVisualizarAtendimento = []
                        verificaQuantidadeUsuariosVinculados(vm.usuariosHaVisualizarAtendimento);

                        vm.sigiloComercial = false;
                        Atendimento.sigiloComercial = vm.sigiloComercial;

                        vm.requisicaoSolicitada = false;
                    }, function (error) {
                        vm.requisicaoSolicitada = false;
                        MdToastService.toastPadrao(error.data, true);
                    });
        }

        /**
         * Método que desvincula todos os usuários do atendimento em memória
         */
        function removerTodosUsuariosDoAtendimentoEmMemoria() {
            vm.usuariosHaVisualizarAtendimento = [];
            InserirUsuariosHaVisualizarAtendimentoEmMemoria(vm.usuariosHaVisualizarAtendimento);
            verificaQuantidadeUsuariosVinculados(vm.usuariosHaVisualizarAtendimento);
        }

        /**
         * Método para construir o view model de modelo a ser enviado para api
         */
        function construirUsuariosHaVisualizarAtendimentoViewModel(sigiloComercial, usuariosHaVisualizarAtendimento) {
            var codigosUsuarios = usuariosHaVisualizarAtendimento.map(function (usuario) {
                return usuario.codigo;
            });
            return {
                codigoAtendimento: Atendimento.codigo,
                anoAtendimento: Atendimento.ano,
                sigiloComercial: sigiloComercial,
                codigoUsuario: codigosUsuarios,
            }
        }

        function construirViewModel(sigiloComercial, usuariosHaVisualizarAtendimento) {
            if (usuariosHaVisualizarAtendimento && usuariosHaVisualizarAtendimento.length > 0) {
                return usuariosHaVisualizarAtendimento.map(function (usuario) {
                    return {
                        codigoAtendimento: Atendimento.codigo,
                        anoAtendimento: Atendimento.ano,
                        sigiloComercial: sigiloComercial,
                        codigoUsuario: usuario.codigo,
                    };
                });
            } else if (usuariosHaVisualizarAtendimento) {
                return [{
                    codigoAtendimento: Atendimento.codigo,
                    anoAtendimento: Atendimento.ano,
                    sigiloComercial: sigiloComercial,
                    codigoUsuario: usuariosHaVisualizarAtendimento.codigo,
                }];
            }
        }


        function alterarEstadoCampoTodosUsuarios(checkboxTodos) {
            if (checkboxTodos) {
                vm.usuariosHaVisualizarAtendimento = vm.colaboradoresFiltrados;
                vm.sigiloComercial = false;
            } else {
                vm.usuariosHaVisualizarAtendimento = [];
            }
        }

        function changeSquadsSelecionadas(squadsSelecionadas) {
            var todosSelecionados = true;
            angular.forEach(vm.squads, function (squad) {
                if (squadsSelecionadas.indexOf(squad.codigo) === -1) {
                    todosSelecionados = false;
                }
            });
            vm.todasSquads = todosSelecionados;
            vm.sigiloComercial = false;
            _filtrarColaboradores(squadsSelecionadas);
            _atualizarUsuariosVisualizacaoAtendimento();
        }

        function marcarDesmarcarTodasSquads() {
            $timeout(function () {
                if (vm.todasSquads) {
                    var todosCodigos = [];
                    angular.forEach(vm.squads, function (squad) {
                        todosCodigos.push(squad.codigo);
                    });
                    vm.codigoSquads = todosCodigos;
                } else {
                    vm.codigoSquads = [];
                }
                changeSquadsSelecionadas(vm.codigoSquads);
            });
        }

        function _filtrarColaboradores(squadsSelecionadas) {
            if (vm.colaboradores) {
                var colaboradoresSelecionados = [];
                angular.forEach(vm.colaboradores, function (colaborador) {
                    if (squadsSelecionadas.some(function (squad) {
                        return colaborador.codigoSquads.includes(squad);
                    })) {
                        colaboradoresSelecionados.push(colaborador);
                    }
                });
                vm.colaboradoresFiltrados = colaboradoresSelecionados;
                if (vm.colaboradoresFiltrados.length === 0) vm.todosUsuarios = false;
            }
        }

        function _atualizarUsuariosVisualizacaoAtendimento() {
            vm.usuariosHaVisualizarAtendimento = angular.copy(vm.colaboradoresFiltrados);
            if (ControleForm.inserirAtivo) {
                salvarUsuariosHaVisualizarAtendimentoEmMemoria();
            }
        }

        /**
         * Método que irá verificar se será redefinido o sigiloComercial do atendimento em memória
         * ou irá realizar uma requisição para Api para alterar a o sigiloComercial do atendimento no banco de dados
         */
        function redefinirSigiloComercial() {
            if (ControleForm.inserirAtivo && vm.sigiloComercial)
                atualizarSigiloComercialAtendimentoEmMemoria(false);
            else if (!ControleForm.inserirAtivo && vm.sigiloComercial)
                atualizarSigiloComercialAtendimento(false);
        }

        /**
         * Método para redefinir o SigiloComercial do atendimento
         * @param {boolSigiloComercial} sigiloComercial 
         */
        function atualizarSigiloComercialAtendimento(sigiloComercial) {
            var modelo = construirUsuariosHaVisualizarAtendimentoViewModel(false, null)
            RequisicaoGenericaService.editar(Api.atendimento.usuario_ha_visualizar_atendimento.atualizarSigiloComercialAtendimento, modelo).then(
                function (success) {
                    vm.sigiloComercial = sigiloComercial;
                    Atendimento.sigiloComercial = sigiloComercial;
                    vm.requisicaoSolicitada = false;
                },
                function (error) {
                    vm.requisicaoSolicitada = false;
                    MdToastService.toastPadrao(error.data, true);
                });
        }

        /**
         * Método para redefinir o SigiloComercial do atendimento em memoria
         * @param {boolSigiloComercial} sigiloComercial 
         */
        function atualizarSigiloComercialAtendimentoEmMemoria(sigiloComercial) {
            vm.sigiloComercial = sigiloComercial;
            Atendimento.sigiloComercial = sigiloComercial;
        }

        //endregion

        // Métodos Dialog region        

        /**
         * Método para vincular um novo Colaborador ao atendimento
         * @param {*event do button} event
         * @param {*acompanhante} modelo
         */
        function salvar(event, colaborador) {
            if (ControleForm.inserirAtivo) {
                salvarUsuariosHaVisualizarAtendimentoEmMemoria(colaborador);
            } else {
                salvarUsuariosHaVisualizarAtendimento(colaborador);
            }
        }

        function incluirNaLista(event, colaborador) {
            salvarUsuariosHaVisualizarAtendimentoEmMemoria(colaborador);
        }

        /**
         * Método para excluir o Colaborador selecionado do Atendimento
         * @param {oButton} event
         * @param {usuario} modelo
         */
        function excluir(event, modelo) {
            if (ControleForm.inserirAtivo)
                removerUsuarioAtendimentoEmMemoria(event, modelo);
            else
                removerUsuarioAtendimento(event, modelo);
        }

        /**
         * Método para configurar o md-select-header dos colaboradores
         */
        function configuraMdSelectColaboradores() {
            vm.filtrarColaborador = "";
            angular.element('#dialog-colaboradores-ha-visualizar-atendimento-md-select').on('keydown', function (ev) {
                ev.stopPropagation();
            });
        }


        /**
         * Método chamado quando o checkbox sigiloComercial é pressionado
         */
        function alterarEstadoCampoSigiloComercial(sigiloComercial) {
            if (ControleForm.inserirAtivo && sigiloComercial)
                inserirUsuariosComTipoAtendimentoComercialEmMemoria(sigiloComercial);
            else if (ControleForm.inserirAtivo && !sigiloComercial) {
                removerTodosUsuariosDoAtendimentoEmMemoria();
            }
            else if (!ControleForm.inserirAtivo && sigiloComercial)
                inserirUsuariosComTipoAtendimentoComercial(sigiloComercial);
            else if (!ControleForm.inserirAtivo && !sigiloComercial)
                removerTodosUsuariosDoAtendimento()
        }

        /**
         * Método para fechar o dialog quando pressionado o "X" no toolbar do Dialog
         */
        function metodoDialogFecharDialog() {
            $mdDialog.hide();
        }
        //endregion
    } // CONTROLLER

})();

(function () {
  "use strict";
  angular
    .module("app.atendimento.processamento.atualizacoespendentes", [])
    .config(config);

  function config($stateProvider, RotasHtml) {
    var rotasHtmlAtualizacoesPendentes = RotasHtml.atendimento.atualizacoesPendentes;
    $stateProvider
      .state(
        'app.atendimento_processamento_atualizacoespendentes',
        {
          url: '/atendimento/processamento/atualizacoes-pendentes',
          module: 'privado',
          views: {
            'content@app': {
              templateUrl: rotasHtmlAtualizacoesPendentes.templateUrl,
              controller: 'AtualizacoesPendentesController as vm'
            },
            'atualizacoes-pendentes-sidenav@app.atendimento_processamento_atualizacoespendentes': {
              templateUrl: rotasHtmlAtualizacoesPendentes.sidenav,
              controller: 'SidenavAtualizacoesPendentesController as vm'
            },
            'atualizacoes-pendentes-tabela@app.atendimento_processamento_atualizacoespendentes': {
              templateUrl: rotasHtmlAtualizacoesPendentes.tabela,
              controller: 'AtualizacoesPendentesController as vm'
            }
          },
          resolve: {
            ListarDetalhesUsuario: function (Api, RequisicaoGenericaService, LoginUsuarioService) {
              return RequisicaoGenericaService.listarSemParams(
                Api.usuario.detalhes_usuario.listarDetalhesUsuario +
                LoginUsuarioService.usuarioArmazenado().codigo
              );
            },
            ListaClientesPendentes: function (Api, RequisicaoGenericaService, ListarDetalhesUsuario) {
              return RequisicaoGenericaService.listarComObjetoComplexo(
                Api.atendimento.atualizacoesPendentes.listarAtualizacoesPendentesPorSquad,
                ListarDetalhesUsuario.data.codigoSquads
              );
            }
          }

        }
      );
  }
})();

(function () {
    'use strict';
    angular
        .module('app.atendimento.processamento.atualizacoespendentes')
        .service('SidenavAtualizacoesPendentesService', SidenavAtualizacoesPendentesService)

    /** @ngInject */
    function SidenavAtualizacoesPendentesService(RequisicaoGenericaService, Api, $mdSidenav) {
        var emProgresso = false;
        var _filtro;
        var service = {
            toggleFiltro: toggleFiltro,
            setFiltro: setFiltro,
            getFiltro: getFiltro,
            filtrarDados: filtrarDados
        }

        function toggleFiltro() {
            $mdSidenav('filtro-atualizacoes-pendentes').toggle();
        }

        function setFiltro(filtro) {
            _filtro = filtro;
        }

        function getFiltro() {
            return angular.copy(_filtro);
        }

        function filtrarDados(filtro) {
            setFiltro(filtro);
            return RequisicaoGenericaService.listarComObjetoComplexo(Api.atendimento.atualizacoesPendentes.listarAtualizacoesPendentesPorSquad, filtro);
        }

        return service;
    }

})();

(function () {
    'use strict';

    angular
        .module('app.atendimento.processamento.atendimento')
        .controller('DialogVisualizacaoHistoricoAtendimentoController', DialogVisualizacaoHistoricoAtendimentoController);

    function DialogVisualizacaoHistoricoAtendimentoController($mdDialog, historicoAtendimentos, indexHistoricoAtendimento) {
        var vm = this;
        vm.historicoAtendimentos = historicoAtendimentos;
        vm.indexHistoricoAtendimento = indexHistoricoAtendimento;
        vm.historicoSelecionado = historicoAtendimentos[indexHistoricoAtendimento] || {};

        vm.metodosDialog = {
            fecharDialog: fecharDialog,
            proximo: proximo,
            anterior: anterior,
            primeiro: primeiro,
            ultimo: ultimo
        };

        function fecharDialog() {
            $mdDialog.hide();
        }
        function proximo() {
            if (vm.indexHistoricoAtendimento < vm.historicoAtendimentos.length - 1) {
                vm.indexHistoricoAtendimento++;
                vm.historicoSelecionado = vm.historicoAtendimentos[vm.indexHistoricoAtendimento];
            }
        }
        function anterior() {
            if (vm.indexHistoricoAtendimento > 0) {
                vm.indexHistoricoAtendimento--;
                vm.historicoSelecionado = vm.historicoAtendimentos[vm.indexHistoricoAtendimento];
            }
        }
        function primeiro() {
            vm.indexHistoricoAtendimento = 0;
            vm.historicoSelecionado = vm.historicoAtendimentos[0];
        }
        function ultimo() {
            vm.indexHistoricoAtendimento = vm.historicoAtendimentos.length - 1;
            vm.historicoSelecionado = vm.historicoAtendimentos[vm.indexHistoricoAtendimento];
        }
    }
})();

/**
 * Created by nova on 26/10/2016.
 */
(function () {
    'use strict';

    angular
        .module('app.atendimento.processamento.atendimento')
        .controller('AtendimentoDialogHistoricoController', AtendimentoDialogHistoricoController);


    function AtendimentoDialogHistoricoController($mdDialog, $scope, MdToastService, HistoricoAtendimento, CopiaHistoricoAtendimento, CodigoAtendimento, AnoAtendimento, HistoricoAtendimentos,
        RecarregarHistoricoAtendimento, PesquisarAcompanhantesAtendimento, Cliente, ColaboradorCorrente, RequisicaoGenericaService, Api, Index,
        MdDialogService, StatusAtividade, SelecionarHistoricoAtendimento, EventosAtividade, ControleForm, CriarAtendimento, VisualizaTempoTecnico, VisualizarAtividadeService, EditarHistorico, AlterarDataUltimoAtendimento) {

        var vm = this;

        // Data region  
        vm.form = {};
        vm.colaboradorAtivo = ColaboradorCorrente;
        vm.inserirAtivo = null;
        vm.requisicaoSolicitada = false;
        vm.buttonSelecionadoPesquisarPessoasReferencia = false;

        vm.dataAtual = new Date();

        vm.controladorTempoTecnico = VisualizaTempoTecnico;

        vm.ehUltimoHistorico = EditarHistorico;

        vm.copiaHistoricoAtendimento = CopiaHistoricoAtendimento;

        /**
         * Condição para verificar se será realizado um novo atendimento ou
         * editar um atendimento selecionado
         */
        if (HistoricoAtendimento) {
            vm.titulo = "Editar Histórico Atendimento";
            vm.inserirAtivo = false;

            vm.historicoAtendimento = angular.copy(HistoricoAtendimento);
        }
        else {
            vm.titulo = "Inserir Histórico Atendimento";
            vm.inserirAtivo = true;

            construirHistoricoAtendimento();
        }
        //endregion                

        /**
         * Chamada do metódo inicializador
         */
        init();

        // Definição dos Métodos region   
        var metodosInternos = {
            construirHistoricoAtendimento: construirHistoricoAtendimento,
            construirHoras: construirHoras,
            formatarData: formatarData,
            selecionarHistoricoAExibirAtendimento: selecionarHistoricoAExibirAtendimento,
            criar: criar,
            editar: editar
        };
        vm.metodosDialog = {
            salvar: salvar,
            excluir: excluir,
            configuraMdSelectColaboradores: configuraMdSelectColaboradores,
            controlarMdSelectPessoaReferencia: controlarMdSelectPessoaReferencia,
            configuraMdSelectPessoaReferencia: configuraMdSelectPessoaReferencia,
            fecharDialog: metodoDialogFecharDialog
        };
        //endregion

        // Métodos Internos region  

        /**
         * Método inicizalizador
         */
        function init() {
            /**
             * Verifica se existe um cliente, caso exista faz uma requisição para Api
             * para buscar todas as pessoas de referência vinculadas a este cliente
             */
            if (Cliente.codigo) {
                RequisicaoGenericaService.listarSemParams(Api.cliente.listarPessoasDeReferencia + Cliente.codigo).then(
                    function (success) {
                        vm.pessoasReferencia = success.data;
                    });
            }
            /**
             * Realiza uma requisição para Api para buscar todos os colaboradores
             */
            RequisicaoGenericaService.listarSemParams(Api.usuario.detalhes_usuario.listarUsuariosAtivos).then(
                function (success) {
                    vm.colaboradores = success.data
                });

            vm.horasHistoricoAtendimento = construirHoras();
        }

        /**
         * Método para inicializar alguns campos do histórico do atendimento, 
         * quando é inserido um novo historico atendimento
         */
        function construirHistoricoAtendimento() {

            if (vm.copiaHistoricoAtendimento.codigoAtendimento != null) {
                vm.historicoAtendimento = angular.copy(vm.copiaHistoricoAtendimento);
            } else {
                vm.historicoAtendimento = {
                    codigoAtendimento: CodigoAtendimento,
                    anoAtendimento: AnoAtendimento,
                    data: new Date(),
                    usuario: ColaboradorCorrente,
                    codigoUsuario: ColaboradorCorrente.codigoUsuario
                }
            }
        }

        $scope.$watch('vm.historicoAtendimento.descricao', function (newValue, oldValue) {
            if (newValue !== oldValue) {
                if (newValue.indexOf('<img') !== -1) {
                    vm.historicoAtendimento.descricao = newValue.replace(/<img[^>]+>/g, '');
                    MdDialogService.alertPadrao("Atenção!", null, "Não é possivel inserir imagem.");
                }
            }
        });

        /**
         * Método que pega a data do "vm.historicoAtendimento" e retorna um tempo no formato "hh:MM:ss"
         */
        function construirHoras() {
            if (vm.historicoAtendimento.data)
                var data = new Date(vm.historicoAtendimento.data);
            else
                var data = new Date();

            var horas, minutos, segundos;

            horas = data.getHours().toString().length > 1 ? data.getHours() : "0" + data.getHours();
            minutos = data.getMinutes().toString().length > 1 ? data.getMinutes() : "0" + data.getMinutes();
            segundos = data.getSeconds().toString().length > 1 ? data.getSeconds() : "0" + data.getSeconds();
            return horas + ":" + minutos + ":" + segundos;
        }

        /**
         * Método que recebe uma data e uma hora e retorna um data formatada
         * no modelo {'dd/MM/yyyy - HH:mm:ss'}
         * @param {*data do atendimento} data 
         * @param {*horário do atendimento} horas 
         */
        function formatarData(data, horas) {
            var horasFormatada, minutosFormatado, segundosFormatado, tempo;
            tempo = horas.split(":");
            horasFormatada = tempo[0], minutosFormatado = tempo[1], segundosFormatado = tempo[2];
            if (typeof data == 'string')
                data = new Date(data);
            return new Date(data.getFullYear(), data.getMonth(), data.getDate(), horasFormatada, minutosFormatado, segundosFormatado, 0);
        }

        /**
         * Método para controlar o indice do toolbar do historico do atendimento e selecionar o historico a ser exibido no atendimento
         */
        function selecionarHistoricoAExibirAtendimento(index) {

            if (index !== -1 && HistoricoAtendimentos.length >= 1 && index !== (HistoricoAtendimentos.length)) {
                SelecionarHistoricoAtendimento(index, HistoricoAtendimentos[index]);
            }
            else if (index == HistoricoAtendimentos.length && HistoricoAtendimentos.length >= 1) {
                SelecionarHistoricoAtendimento(index - 1, HistoricoAtendimentos[index - 1]);
            }
            else {
                SelecionarHistoricoAtendimento(null, null, true);
            }
        }

        /**
         * Método para criar um Histórico Atendimento
         * @param {*event do button} event 
         * @param {*historicoAtendimento} modelo 
         */
        function criar(event, modelo) {

            /**
             * Verifica Se está inserindo um novo Atendimento caso a condição sejá verdadeira 
             * adiciona esse novo histórico a lista em memória para ser perssistido junto com o atendimento
             */
            if (ControleForm.inserirAtivo) {
                HistoricoAtendimentos.push(modelo);
                CriarAtendimento();
                $mdDialog.hide();
            }
            // Se a condição for falsa continua o processo de inserir um histórico do atendimento normalmente
            else {
                vm.requisicaoSolicitada = true;
                RequisicaoGenericaService.salvar(Api.atendimento.historico.criar, modelo).then(
                    function (success) {
                        MdToastService.toastPadrao("Histórico do Atendimento cadastrado  com sucesso!");

                        vm.requisicaoSolicitada = false;
                        $mdDialog.hide();

                        /**
                         * Método do controller do Atendimento responsável por recarrega os historicos do atendimento
                         * para controlar o indice do toolbar do historico do atendimento e afins
                         */
                        RecarregarHistoricoAtendimento(success.data.resultado, success.data.historicoCadastrado,
                            success.data.quantidadeDiasSemAtendimento);

                        /**
                         *  Método do controller do Atendimeto que faz uma chamada para Api para buscar os acompanhantes novamente
                         */
                        PesquisarAcompanhantesAtendimento(success.data.historicoCadastrado.codigoAtendimento,
                            success.data.historicoCadastrado.anoAtendimento);

                        _abrirDialogCadastroAtividade();

                    },
                    function (error) {
                        vm.requisicaoSolicitada = false;
                        alert("Falha ao Cadastrar o Histórico do Atendimento \nDetalhes: " + error.data);
                    });
            }
        }


        function _abrirDialogCadastroAtividade() {
            MdDialogService.confirmPadraoComEvento("Deseja cadastrar uma nova atividade?", null, event,
                function () {
                    $mdDialog.hide();
                    VisualizarAtividadeService.abrirCadastroAtividade(event, {
                        usuarioAtivo: {
                            codigo: vm.colaboradorAtivo.codigoUsuario,
                        },
                        cliente: Cliente,
                        atendimento: {
                            ano: AnoAtendimento,
                            codigo: CodigoAtendimento
                        }
                    }, EventosAtividade, StatusAtividade, false, true)
                });
        }

        /**
         * Método para editar o Atendimento selecionado
         * @param {*event do button} event
         * @param {*historicoAtendimento} modelo
         */
        function editar(event, modelo) {
            if (ControleForm.inserirAtivo) {

                HistoricoAtendimentos[Index] = modelo;
                /**
                 * Método do controller do Atendimento responsável por recarrega os historicos do atendimento
                 * para controlar o indice do toolbar do historico do atendimento e afins
                 */
                RecarregarHistoricoAtendimento(HistoricoAtendimentos, modelo);

                $mdDialog.hide();
            }
            else {
                vm.requisicaoSolicitada = true;
                RequisicaoGenericaService.editar(Api.atendimento.historico.atualizar, modelo).then(
                    function (success) {
                        MdToastService.toastPadrao("Histórico Atendimento editado com sucesso!");

                        vm.requisicaoSolicitada = false;
                        $mdDialog.hide();

                        /**
                         * Método do controller do Atendimento responsável por recarrega os historicos do atendimento
                         * para controlar o indice do toolbar do historico do atendimento e afins
                         */
                        RecarregarHistoricoAtendimento(success.data.resultado, success.data.historicoCadastrado, success.data.quantidadeDiasSemAtendimento);

                        /**
                         *  Método do controller do Atendimeto que faz uma chamada para Api para buscar os acompanhantes novamente
                         */
                        PesquisarAcompanhantesAtendimento(success.data.historicoCadastrado.codigoAtendimento, success.data.historicoCadastrado.anoAtendimento);
                    },
                    function (error) {
                        vm.requisicaoSolicitada = false;
                        alert("Falha ao editar o Histórico do Atendimento \nDetalhes: " + error.data);
                    });
            }
        }
        //endregion

        // Métodos Dialog region        

        /**
         * Método que verifica se irá inserir ou alterar o Histórico do atendimento
         * @param {*event do button} event
         * @param {*historicoAtendimento} modelo
         * @param {*horário do atendimento} horas 
         */
        function salvar(event, modelo, horas) {
            modelo.data = formatarData(modelo.data, horas);
            if (vm.inserirAtivo) {
                metodosInternos.criar(event, modelo);
            } else {
                metodosInternos.editar(event, modelo);
            }
        }

        /**
         * Método para excluir o Histórico Atendimento
         * @param {*event do button} event
         * @param {*historicoAtendimento} modelo
         */
        function excluir(event, modelo) {
            var index = HistoricoAtendimentos.map(function (item) { return item.sequencia }).indexOf(modelo.sequencia);

            /**
             * Verifica Se está inserindo um novo Atendimento caso a condição sejá verdadeira 
             * adiciona esse novo histórico a lista em memória para ser perssistido junto com o atendimento
             */
            if (ControleForm.inserirAtivo) {
                MdDialogService.confirmPadraoComEvento("Deseja realmente excluir este histórico do atendimento ?", null, event,
                    function () {
                        $mdDialog.hide();
                        MdToastService.toastPadrao("Histórico excluido com sucesso");

                        HistoricoAtendimentos.splice(index, 1);

                        selecionarHistoricoAExibirAtendimento(index);
                    });
            }
            // Se a condição for falsa continua o processo de inserir um histórico do atendimento normalmente
            else {
                MdDialogService.confirmPadraoComEvento("Deseja realmente excluir este histórico do atendimento?", null, event,
                    function () {
                        vm.requisicaoSolicitada = true;

                        if (!vm.ehUltimoHistorico) {
                            vm.requisicaoSolicitada = false;
                            return MdDialogService.alertPadrao("Só é possível excluir o último histórico e se o mesmo estiver vinculado ao seu usuário.");
                        }

                        RequisicaoGenericaService.excluir(Api.atendimento.historico.excluir,
                            modelo.sequencia + "/" + modelo.codigoAtendimento + "/" + modelo.anoAtendimento + "/" + ColaboradorCorrente.codigoUsuario).then(
                                function (success) {
                                    $mdDialog.hide();

                                    MdToastService.toastPadrao(success.data);

                                    HistoricoAtendimentos.splice(index, 1);

                                    selecionarHistoricoAExibirAtendimento(index);

                                    AlterarDataUltimoAtendimento();

                                    /**
                                     *  Método do controller do Atendimeto que faz uma chamada para Api para buscar os acompanhantes novamente
                                     */
                                    PesquisarAcompanhantesAtendimento(modelo.codigoAtendimento, modelo.anoAtendimento);

                                    vm.requisicaoSolicitada = false;
                                },
                                function (error) {
                                    vm.requisicaoSolicitada = false;
                                    alert("Falha ao excluir o Histórico do Atendimento \nDetalhes: " + error.data);
                                });
                    });
            }
        }


        /**
         * Método para configurar o md-select-header dos colaboradores
         */
        function configuraMdSelectColaboradores() {
            vm.filtrarColaborador = "";
            angular.element('#dialog-historico-atendimento-pessoa-referencia-md-select').on('keydown', function (ev) {
                ev.stopPropagation();
            });
        }

        /**
         * Método controlador que exibe ou não o md-select de pessoas de referência
         */
        function controlarMdSelectPessoaReferencia() {
            vm.buttonSelecionadoPesquisarPessoasReferencia = !vm.buttonSelecionadoPesquisarPessoasReferencia;
        }

        /**
         * Método para configurar o md-select-header do pessoal de referência
         */
        function configuraMdSelectPessoaReferencia() {
            vm.filtrarPessoaReferencia = "";
            angular.element('#dialog-historico-atendimento-colaborador-md-select').on('keydown', function (ev) {
                ev.stopPropagation();
            });
        }

        /**
         * Método para fechar o dialog quando pressionado o "X" no toolbar do Dialog
         */
        function metodoDialogFecharDialog(historicoAtendimento) {
            if (vm.inserirAtivo) {
                historicoAtendimento.data = formatarData(historicoAtendimento.data, vm.horasHistoricoAtendimento);
                $mdDialog.hide(historicoAtendimento);
            } else {
                $mdDialog.hide();
            }
        }
        //endregion
    } // CONTROLLER

})();

(function () {
    'use strict';
    angular
        .module('app.atendimento.estatisticas.tags', [])
        .config(Config);
    function Config($stateProvider, RotasHtml) {
        var rotasHtml = RotasHtml.estatisticasTagsAtendimento;
        $stateProvider
            .state('app.atendimento_estatisticas_tags', {
                url: '/atendimento/estatisticas/tags',
                views: {
                    'content@app': {
                        templateUrl: rotasHtml.templateUrl,
                        controller: 'EstatisticasTagsAtendimentoController as vm'
                    },
                    'filtro-estatisticas-tags@app.atendimento_estatisticas_tags': {
                        templateUrl: rotasHtml.components.sidenav,
                        controller: 'FiltroEstatisticasTagsController as vm'
                    },
                    'grafico-estatisticas-tags@app.atendimento_estatisticas_tags': {
                        templateUrl: rotasHtml.components.graficoTags,
                        controller: 'EstatisticasTagsAtendimentoController as vm'
                    },
                },
                resolve: {
                    ListarTodasTags: function (Api, RequisicaoGenericaService) {
                        return RequisicaoGenericaService.listarSemParams(Api.atendimento.tag.listarTodas);
                    },
                    DesabilitarSidenav: function () {
                        return false;
                    },
                    Cliente: function () {
                        return null;
                    },

                }
            });
    }
})();

(function () {
    'use strict';
    angular
        .module('app.atendimento.estatisticas.tags')
        .controller('DialogDetalhesAtendimentoController', DialogDetalhesAtendimentoController);

    function DialogDetalhesAtendimentoController(
        $mdDialog,
        $state,
        DetalhesAtendimento,
        ListarTodasTags,
        ListarCoresTagsAtendimento
    ) {
        var vm = this;
        vm.detalhesAtendimento = DetalhesAtendimento;
        vm.metodosDialog = {
            fecharDialog: fecharDialog,
            visualizarAtendimento: visualizarAtendimento,
            retornaCodigoItemSelecionado: retornaCodigoItemSelecionado,
        }

        function fecharDialog() {
            $mdDialog.hide();
        }

        function visualizarAtendimento(numero, ano) {
            $state.goNewTab('app.atendimento_processamento_atendimento', {
                parametros: {
                    codigo: numero,
                    ano: ano,
                    chamarPesquisa: true
                }
            });
        }

        function retornaCodigoItemSelecionado(codigo) {
            const item = (ListarTodasTags || []).find(function (item) {
                return item.codigo === codigo;
            });

            if (item) {
                const corEncontrada = ListarCoresTagsAtendimento.find(function (cor) {
                    return cor.background === item.corIdentificacao;
                });

                return {
                    descricao: item.descricao,
                    corTexto: corEncontrada ? corEncontrada.fonte : '#000',
                    corBackground: item.corIdentificacao,
                    inativo: false
                };
            }
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.atendimento.estatisticas.tags')
        .controller('FiltroEstatisticasTagsController', FiltroEstatisticasTagsController);

    function FiltroEstatisticasTagsController(
        $scope,
        Api,
        RequisicaoGenericaService,
        EstatisticaTagsService
    ) {
        var vm = this;

        vm.filtroTags = {};
        vm.todasTagsCadastradas = [];
        vm.textoDePesquisaAutoCompleteCliente = "";
        vm.pesquisando = false;
        vm.desabilitarSidenav = false;

        $scope.$on('atualizarDesabilitarSidenav', function (event, value) {
            vm.desabilitarSidenav = value;
        });

        $scope.$on('atualizarListaTodasTags', function (event, value) {
            vm.todasTagsCadastradas = value.data || value;
            $scope.$root.listaTodasTags = vm.todasTagsCadastradas;
        });

        $scope.$on('atualizarFiltroTags', function (event, viewModel) {
            vm.filtroTags = viewModel;
            EstatisticaTagsService.setFiltro(vm.filtroTags);
        });

        init();

        vm.metodos = {
            setDefaultAno: setDefaultAno,
            setDefaultMes: setDefaultMes,
            pesquisarAutoCompleteCliente: pesquisarAutoCompleteCliente,
            alterarItemSelecionadoAutoCompleteCliente: alterarItemSelecionadoAutoCompleteCliente,
            configuraAutoCompleteClienteOnBlur: configuraAutoCompleteClienteOnBlur,
            changeProduto: changeProduto,
            configuraMdSelectTags: configuraMdSelectTags,
            pesquisarBotao: pesquisarBotao,
            fecharSidenav: fecharSidenav,
        }

        function init() {
            var dataAtual = new Date();
            vm.filtroTags.mes = dataAtual.getMonth() + 1;
            vm.filtroTags.ano = dataAtual.getFullYear();
            if ($scope.$root.listaTodasTags) {
                vm.todasTagsCadastradas = $scope.$root.listaTodasTags;
            }
            if (typeof $scope.$root.desabilitarSidenav !== 'undefined') {
                vm.desabilitarSidenav = $scope.$root.desabilitarSidenav;
            }
            if (!vm.desabilitarSidenav) {
                pesquisarBotao(vm.filtroTags);
            }
        }


        function setDefaultAno() {
            if (vm.filtroTags.ano == undefined)
                vm.filtroTags.ano = new Date().getFullYear();
        }

        function setDefaultMes() {
            if (
                vm.filtroTags.mes == undefined ||
                vm.filtroTags.mes <= 0 ||
                vm.filtroTags.mes > 12
            )
                vm.filtroTags.mes = new Date().getMonth() + 1;
        }

        function configuraMdSelectTags() {
            vm.filtrarTags = "";
            angular
                .element("#card-tags-atendimento-md-select")
                .on("keydown", function (ev) {
                    ev.stopPropagation();
                });
        }

        function pesquisarAutoCompleteCliente(query) {
            return _pesquisarAutoComplete(Api.cliente.listarCodigoDescricao, query);
        }

        function configuraAutoCompleteClienteOnBlur() {
            if (!vm.pesquisa.cliente) {
                vm.textoDePesquisaAutoCompleteCliente = "";
            }
        }

        function alterarItemSelecionadoAutoCompleteCliente(item) {
            if (item) {
                vm.filtroTags.cliente = item.codigo;
                vm.pesquisa.cliente = item;
                vm.pesquisa.clienteCodigo = item.codigo;
            } else {
                vm.textoDePesquisaAutoCompleteCliente = "";
                vm.pesquisa.clienteCodigo = null;
                vm.pesquisa.cliente = null;
                vm.filtroTags.cliente = null;
            }
        }

        function changeProduto() {
            vm.pesquisa.cliente = null;
            vm.pesquisa.clienteCodigo = null;
        }

        function _pesquisarAutoComplete(rota, valor) {
            var queryConsulta = {
                produtoCodigo: vm.pesquisa.produtoCodigo,
            };

            if (parseInt(valor)) {
                queryConsulta.codigo = valor;
            }
            else {
                queryConsulta.nome = valor;
            }

            return RequisicaoGenericaService.listarComParams(rota, queryConsulta).then(
                function (success) {
                    return success.data;
                },
                function (error) {
                    return [];
                });
        }

        function pesquisarBotao(filtro) {
            var viewModel = {
                mes: filtro.mes,
                ano: filtro.ano,
                cliente: filtro.cliente ? filtro.cliente : null,
                tags: filtro.tags && filtro.tags.length > 0 ? filtro.tags : null,
            };

            if (vm.desabilitarSidenav && $scope.$root.clienteDialogCodigo) {
                viewModel.cliente = $scope.$root.clienteDialogCodigo;
            } else if (filtro.cliente) {
                viewModel.cliente = filtro.cliente;
            } else {
                viewModel.cliente = null;
            }
            EstatisticaTagsService.invokeListener(function () { return viewModel; });
        }

        function fecharSidenav() {
            EstatisticaTagsService.closeFiltroIfOpen && EstatisticaTagsService.closeFiltroIfOpen();
        }

    }
})();

/**
 * Created by nova on 26/10/2016.
 */
(function () {
    'use strict';

    angular
        .module('app.atendimento.processamento.atendimento')
        .controller('AtendimentoDialogAcompanhantesController', AtendimentoDialogAcompanhantesController);


    function AtendimentoDialogAcompanhantesController($mdDialog, MdToastService, RequisicaoGenericaService, DefinirUsuarioVisualizouAtendimento, DefinirUsuarioMarcouComoImportante,
        Api, ControleForm, DataTableConfigPadrao, AnoAtendimento, CodigoAtendimento, AcompanhantesAtendimento, CodigoUsuarioLogado) {

        var vm = this;

        // Data region  
        vm.form = {};
        vm.inserirAtivo = false;
        vm.requisicaoSolicitada = false;

        vm.titulo = "Lista de colaboradores que serão notificados quando este atendimento sofrer alterações";

        vm.acompanhantesAtendimento = AcompanhantesAtendimento;

        vm.dtOptions = angular.copy(DataTableConfigPadrao.dtOptionsResponsivoSemPaginacaoComInitComplete);
        vm.dtOptions.dom = 'rt';
        vm.dtOptions.columnDefs = [
            angular.copy(DataTableConfigPadrao.columnDefsPadrao),
            {
                // Target the status column
                targets: 2,
                filterable: false,
                render: function (data, type) {
                    if (type === 'display') {
                        if (data === 'true') {
                            return '<i class="icon-checkbox-marked-circle green-500-fg"></i>';
                        }

                        return '<i class="icon-cancel red-500-fg"></i>';
                    }
                    if (type === 'filter') {
                        if (data) {
                            return '1';
                        }
                        return '0';
                    }
                    return data;
                }
            }
        ];
        //endregion                

        /**
         * Chamada do metódo inicializador
         */
        init();

        // Definição dos Métodos region   
        var metodosIterno = {
            salvarAcompanhanteEmMemoria: salvarAcompanhanteEmMemoria,
            salvarAcompanhante: salvarAcompanhante,
            construirAtendimentoAcompanhamento: construirAtendimentoAcompanhamento
        }
        vm.metodosDialog = {
            salvar: salvar,
            excluir: excluir,
            configuraMdSelectColaboradores: configuraMdSelectColaboradores,
            fecharDialog: metodoDialogFecharDialog,
        };
        //endregion

        // Métodos Internos region  

        /**
         * Método inicizalizador
         */
        function init() {
            /**
             * Realiza uma requisição para Api para buscar todos os colaboradores
             */
            vm.requisicaoSolicitada = true;
            RequisicaoGenericaService.listarSemParams(Api.atendimento.usuario_ha_visualizar_atendimento.listarAcompanhamentoVisualizacaoPorAtendimento +
                CodigoAtendimento + "/" + AnoAtendimento).then(
                    function (success) {
                        vm.colaboradores = success.data;
                        vm.requisicaoSolicitada = false;
                    }, function (error) { vm.requisicaoSolicitada = false; });
        }

        /**
         * Método para salvar o acompanhante em memoria para ser inserido quando o atendimento for criado
         * @param {*Colaborador Acompanhante} modelo 
         */
        function salvarAcompanhanteEmMemoria(modelo) {
            AcompanhantesAtendimento.push(modelo);
            DefinirUsuarioVisualizouAtendimento(AcompanhantesAtendimento);
            DefinirUsuarioMarcouComoImportante(AcompanhantesAtendimento);
        }

        /**
         * Método para que realiza uma requisição para gravar o acompanhante no banco de dados
         * @param {*Colaborador acompanhante} modelo 
         */
        function salvarAcompanhante(modelo) {
            vm.requisicaoSolicitada = true;
            RequisicaoGenericaService.salvar(Api.atendimento.acompanhamento.criar, modelo).then(
                function (success) {
                    vm.requisicaoSolicitada = false;
                    MdToastService.toastPadrao("Acompanhante registrado com sucesso.");
                    AcompanhantesAtendimento.push(success.data);
                    DefinirUsuarioVisualizouAtendimento(AcompanhantesAtendimento);
                    DefinirUsuarioMarcouComoImportante(AcompanhantesAtendimento);
                },
                function (error) {
                    vm.requisicaoSolicitada = false;
                    alert(error.data);
                });
        }

        /**
         * Método que constroi o acompanhanto para ser persistido no banco
         * @param {*colaborador acompanhante} modelo 
         */
        function construirAtendimentoAcompanhamento(modelo) {
            return {
                codigoAtendimento: CodigoAtendimento,
                anoAtendimento: AnoAtendimento,
                codigoUsuario: modelo.colaborador.codigo,
                visualizado: CodigoUsuarioLogado == modelo.colaborador.codigo ? true : false,
                usuario: modelo.colaborador
            };
        }

        //endregion

        // Métodos Dialog region        

        /**
         * Método para vincular um novo Colaborador ao atendimento
         * @param {*event do button} event
         * @param {*acompanhante} modelo
         */
        function salvar(event, modelo) {
            var acompanhanteAtendimento = construirAtendimentoAcompanhamento(modelo);
            if (AcompanhantesAtendimento.map(function (item) { return item.codigoUsuario }).indexOf(modelo.colaborador.codigo) == -1) {
                vm.acompanhante.colaborador = null;
                if (ControleForm.inserirAtivo) {
                    salvarAcompanhanteEmMemoria(acompanhanteAtendimento);
                } else {
                    salvarAcompanhante(acompanhanteAtendimento);
                }
            } else {
                MdToastService.toastPadrao("Colaborador já está vinculado a este Atendimento", true);
            }

        }

        /**
         * Método para excluir o Acompanhante do Atendimento
         * @param {*event do button} event
         * @param {*acompanhante} modelo
         */
        function excluir(event, modelo) {

            if (ControleForm.inserirAtivo) {
                AcompanhantesAtendimento.splice(AcompanhantesAtendimento.indexOf(modelo), 1);
            } else {
                vm.requisicaoSolicitada = true;
                RequisicaoGenericaService.excluir(Api.atendimento.acompanhamento.excluir,
                    modelo.codigoAtendimento + "/" + modelo.anoAtendimento + "/" + modelo.codigoUsuario).then(
                        function (success) {
                            MdToastService.toastPadrao(success.data);

                            AcompanhantesAtendimento.splice(AcompanhantesAtendimento.indexOf(modelo), 1);

                            DefinirUsuarioVisualizouAtendimento(AcompanhantesAtendimento);
                            DefinirUsuarioMarcouComoImportante(AcompanhantesAtendimento);
                            vm.requisicaoSolicitada = false;
                        },
                        function (error) {
                            vm.requisicaoSolicitada = false;
                            MdToastService.toastPadrao(error.data, true);
                        });
            }
        }

        /**
         * Método para configurar o md-select-header dos colaboradores
         */
        function configuraMdSelectColaboradores() {
            vm.filtrarColaborador = "";
            angular.element('#dialog-acompanhante-atendimento-colaborador-md-select').on('keydown', function (ev) {
                ev.stopPropagation();
            });
        }

        /**
         * Método para fechar o dialog quando pressionado o "X" no toolbar do Dialog
         */
        function metodoDialogFecharDialog() {
            $mdDialog.hide();
        }
        //endregion
    } // CONTROLLER

})();

/**
 * Created by nova on 26/10/2016.
 */
(function () {
    'use strict';

    angular
        .module('app.atendimento.processamento.atendimento')
        .controller('AtendimentoDialogAnexoArquivosController', AtendimentoDialogAnexoArquivosController);


    function AtendimentoDialogAnexoArquivosController($mdDialog, $scope, MdToastService, ControleForm, Atendimento, Api, MdDialogService, RequisicaoGenericaService,
        ServicosGenericoService, ArquivosService, $timeout, DataTableConfigPadrao) {
        var vm = this;

        // Data region
        vm.form = {};
        vm.inserirAtivo = null;
        vm.titulo = "Anexos";

        vm.requisicaoSolicitada = false;
        vm.mensagemPreloader = null;

        vm.indexArquivoASerBaixado = null;
        vm.baixandoArquivos = false;

        var rotaArquivos = Atendimento.codigo + "/" + Atendimento.ano;

        var tipoAtualizador = {
            incrementar: 'incrementar',
            decrementar: 'decrementar'
        };

        vm.pesquisarAnexos = "";

        vm.desabilitarButtonSalvar = false;
        vm.tamanhoMaximoArquivosSelecionados = 52428800;
        vm.arquivosSelecionados = [];
        vm.tamanhosArquivosSelecionados = null;
        vm.tamanhoArquivosSelecionadosEmBite = null;
        vm.arquivos = [];

        vm.dtOptionsAnexos = DataTableConfigPadrao.dtOptionsResponsivoSemPaginacaoComInitComplete;
        vm.dtOptionsAnexos.columnDefs = [
            {
                targets: 0,
                ordering: false,
                filterable: false,
                sortable: false
            }
        ];
        vm.dtOptionsAnexos.order = [[4, "desc"]];
        //endregion

        /**
         * Chamada do metódo inicializador
         */
        init();

        // Definição dos Métodos region
        vm.metodosDialog = {
            listarTodosArquivos: listarTodosArquivos,
            salvarArquivos: salvarArquivos,
            excluirArquivo: excluirArquivo,
            baixarArquivo: baixarArquivo,
            pesquisarTabelaAnexos: pesquisarTabelaAnexos,
            fecharDialog: metodoDialogFecharDialog,
        };

        var metodosInternos = {
            atualizarContadorQuantidadeAnexos: _atualizarContadorQuantidadeAnexos
        }
        //endregion


        /**
         * Método inicializador
         */
        function init() {
            listarTodosArquivos();
        }


        /**
         * Watch que fica escutando a quantidade arquivos selecionados
         */
        $scope.$watch('vm.arquivosSelecionados.length', function (newValue, oldValue) {
            if (newValue == 1) {
                vm.mensagemCaption = "1 arquivo selecionado";
                calcularTamanhoArquivosSelecionados(vm.arquivosSelecionados);
            }
            else if (newValue > 1) {
                vm.mensagemCaption = vm.arquivosSelecionados.length + " arquivos selecionados";
                calcularTamanhoArquivosSelecionados(vm.arquivosSelecionados);
            }
            else {
                vm.mensagemCaption = null;
            }
        });

        /**
         * Método que irá calcular o tamanho total de todos os arquivos selecionados
         * @param {arquivos} arquivos Lista de Arquivos Selecionados
         */
        function calcularTamanhoArquivosSelecionados(arquivos) {
            var tamanhoArquivos = null;
            angular.forEach(arquivos, function (item, index) {
                tamanhoArquivos += item.lfFile.size;
            });


            vm.tamanhosArquivosSelecionados = retornarTamanhoArquivo(tamanhoArquivos);
            vm.tamanhoArquivosSelecionadosEmBite = tamanhoArquivos;

            if (vm.tamanhoArquivosSelecionadosEmBite > vm.tamanhoMaximoArquivosSelecionados)
                vm.desabilitarButtonSalvar = true;
            else
                vm.desabilitarButtonSalvar = false;
        }

        /**
         * Método que retorna o tamanho de todos os arquivos selecionas em B, Kb, Mb ou Gb
         * @param {tamanhoArquivo} tamanhoArquivos Tamanho de todos os arquivos selecionados
         */
        function retornarTamanhoArquivo(tamanhoArquivos) {
            if (tamanhoArquivos < 1024) {
                return Math.trunc(tamanhoArquivos) + "B";
            }
            else if (tamanhoArquivos >= 1024 && tamanhoArquivos < 1048576) {
                return Math.trunc((tamanhoArquivos / 1024)) + "Kb";
            }
            else if (tamanhoArquivos >= 1048576 && tamanhoArquivos < 1073741824) {
                return Math.trunc((tamanhoArquivos / (1024 * 1024))) + "Mb";
            }
            else {
                return Math.trunc((tamanhoArquivos / (1024 * 1024 * 1024))) + "Gb";
            }
        }

        /**
         * Realiza uma requisição para api listando todos os anexos vinculados ao atendimento
         */
        function listarTodosArquivos() {
            vm.requisicaoSolicitada = true;
            vm.mensagemPreloader = "Carregando Arquivos ...";
            RequisicaoGenericaService.listarSemParams(Api.atendimento.anexo_arquivo.listarArquivos + rotaArquivos).then(

                function (success) {
                    if (success.data)
                        vm.arquivos = success.data;

                    vm.mensagemPreloader = null;
                    vm.requisicaoSolicitada = false;
                },
                function (error) {
                    vm.mensagemPreloader = null;
                    vm.requisicaoSolicitada = false;

                    MdDialogService.alertPadrao(error.data, null);
                });
        }

        /**
         * Método salvar uma lista de arquivos selecionados
         * @param {arquivosSelecionados} arquivosSelecionados Lista de Arquivos Selecionados
         * @param {eventButton} event
         */
        function salvarArquivos(arquivosSelecionados, event) {
            vm.form.$invalid = false;

            vm.arquivosSelecionados = [];
            var _arquivosSelecionadosTemp = [];

            angular.forEach(arquivosSelecionados, function (item) {
                _arquivosSelecionadosTemp.push(item.lfFile)
            });
            vm.mensagemPreloader = "Enviando Arquivos ...";
            vm.requisicaoSolicitada = true;
            RequisicaoGenericaService.salvarArquivos(Api.atendimento.anexo_arquivo.enviarArquivo + rotaArquivos, _arquivosSelecionadosTemp).then(
                function (success) {
                    vm.arquivos = success.data.arquivosAnexados;
                    vm.requisicaoSolicitada = false;
                    vm.mensagemPreloader = null;

                    _atualizarContadorQuantidadeAnexos(tipoAtualizador.incrementar);

                    MdDialogService.alertPadrao("", event, success.data.situacaoArquivos);

                },
                function (error) {
                    vm.requisicaoSolicitada = false;
                    vm.mensagemPreloader = null;
                    var mensagemErro = "";
                    arquivosSelecionados.length == 1 ? mensagemErro = "O arquivo selecionado não foi encontrado."
                        : mensagemErro = "Os arquivos selecionados não foram encontrados."

                    if (!error.data)
                        MdDialogService.alertPadrao(mensagemErro);
                    else
                        MdDialogService.alertPadrao(error.data, event);
                });
        }

        /**
         * Método para o arquivo selecionado da api
         * @param {eventButton} event
         * @param {arquivo} modelo Arquivo selecionado
         */
        function excluirArquivo(event, modelo, indexArquivo) {
            MdDialogService.confirmPadraoComEvento("Deseja realmente excluir este arquivo ?", null, event,
                function () {
                    vm.indexArquivoASerBaixado = indexArquivo;
                    vm.baixandoArquivos = true;
                    vm.requisicaoSolicitada = true;
                    RequisicaoGenericaService.excluirComObjetoComplexo(Api.atendimento.anexo_arquivo.excluirArquivo, modelo).then(
                        function (success) {
                            MdToastService.toastPadrao(success.data);

                            vm.arquivos.splice(vm.arquivos.indexOf(modelo), 1);

                            _atualizarContadorQuantidadeAnexos(tipoAtualizador.decrementar);

                            vm.baixandoArquivos = false;
                            vm.requisicaoSolicitada = false;
                            vm.indexArquivoASerBaixado = null;
                        },
                        function (error) {
                            vm.baixandoArquivos = false;
                            vm.requisicaoSolicitada = false;
                            vm.indexArquivoASerBaixado = null;

                            MdDialogService.alertPadrao(error.data, null);
                        });
                });
        }

        /**
         * Método para baixar o arquivo selecionado da Api
         * @param {eventButton} event
         * @param {modelo} modelo Arquivo Selecionado
         */
        function baixarArquivo(event, modelo, indexArquivo) {
            vm.indexArquivoASerBaixado = indexArquivo;
            vm.baixandoArquivos = true;
            vm.requisicaoSolicitada = true;
            ArquivosService.baixarArquivo(Api.atendimento.anexo_arquivo.baixarArquivo, modelo).then(
                function (success) {
                    vm.baixandoArquivos = false;
                    vm.requisicaoSolicitada = false;
                    vm.indexArquivoASerBaixado = null;
                }, function (error) {
                    vm.baixandoArquivos = false;
                    vm.requisicaoSolicitada = false;
                    vm.indexArquivoASerBaixado = null;
                });
        }

        /**
         * Método que filtra pelas colunas nome e extensão da tabela
         * @param {item da tabela} item
         */
        function pesquisarTabelaAnexos(item) {
            if (!vm.pesquisarAnexos || (item.extensao.toLowerCase().search(vm.pesquisarAnexos) != -1) ||
                (item.nome.toLowerCase().search(vm.pesquisarAnexos) != -1)) {
                return true;
            }
            else {
                return false;
            }
        }

        /**
         * Método para fechar o dialog quando pressionado o "X" no toolbar do Dialog
         */
        function metodoDialogFecharDialog() {
            $mdDialog.hide();
        }
        //endregion

        //#region Métodos Internos

        function _atualizarContadorQuantidadeAnexos(atualizador) {

            if (atualizador == tipoAtualizador.incrementar) {
                Atendimento.quantidadeAnexos ?
                    Atendimento.quantidadeAnexos++ :
                    Atendimento.quantidadeAnexos = 1;
            }
            else if (atualizador == tipoAtualizador.decrementar) {
                Atendimento.quantidadeAnexos ?
                    Atendimento.quantidadeAnexos-- :
                    Atendimento.quantidadeAnexos = 0;
            }

        }

        //#endregion

        /**
         * $timeout utilizado para atrasar a inicialização do componente lf-ng-md-file-input
         */
        $timeout(function () {
            vm.habilitarComponente = true;
        }, 100);

    } // CONTROLLER

})();

(function () {
    'use strict';
    angular
        .module('app.atendimento.estatisticas.tags')
        .controller('DialogOutrasTagsController', DialogOutrasTagsController);

    function DialogOutrasTagsController(
        $mdDialog,
        $state,
        $scope,
        DTOptionsBuilder,
        ListaOutrasTags
    ) {
        var vm = this;

        vm.listaOutrasTags = ListaOutrasTags;

        vm.onDtInstance = function (instance) {
            vm.dtInstance = instance;
        };

        vm.dtOptions = DTOptionsBuilder.newOptions()
            .withOption('order', [[1, 'asc']])
            .withOption('orderCellsTop', true)
            .withOption('ordering', true)
            .withOption('paging', false)
            .withOption('info', false)
            .withOption('searching', true)
            .withOption('autoWidth', false)
            .withDOM('t<"dt-bottom"ip>');

        $scope.$watch('vm.pesquisar', function (valor) {
            if (vm.dtInstance && vm.dtInstance.DataTable) {
                vm.dtInstance.DataTable.search(valor || '').draw();
            }
        });

        vm.metodosDialog = {
            fecharDialog: fecharDialog,
            visualizarAtendimento: visualizarAtendimento
        };

        function fecharDialog() {
            $mdDialog.hide();
        }

        function visualizarAtendimento(numero, ano) {
            $state.goNewTab('app.atendimento_processamento_atendimento', {
                parametros: {
                    codigo: numero,
                    ano: ano,
                    chamarPesquisa: true
                }
            });
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.solicitacao.processamento.solicitacao')
        .controller('TabHistoricoSolicitacaoController', TabHistoricoSolicitacaoController)

    /** @ngInject */
    function TabHistoricoSolicitacaoController(Api, ServicosGenericoService,
        DataTableConfigPadrao, SolicitacaoFactory, RotasHtml, $mdDialog, ListarTodasSolicitacaoFases,
        LoginUsuarioService) {
        var vm = this;
        vm.solicitacao = SolicitacaoFactory.solicitacao;
        vm.htmlRota = RotasHtml.solicitacao.solicitacao;
        vm.usuarioLogado = LoginUsuarioService.usuarioArmazenado();
        // Data region

        //end reagion

        // Configurações Datatable region
        vm.dtOptionsSolicitacaoHistorico = angular.copy(DataTableConfigPadrao.dtOptionsResponsivoPaginacaoTipoNumberComInitComplete);
        vm.dtOptionsSolicitacaoHistorico.columnDefs = _setColumnsDefsDtOptionsTabEstoria();
        //end region
        init();


        function init() {
            vm.form = {};
            vm.historico = {};
            vm.entidadeDeEnvio = {
                intTamanhoPagina: 1,
                clsEntidade: vm.historico
            }

            // Resolve region
            vm.solicitacaoFases = ListarTodasSolicitacaoFases.data;
            //endregion
        }

        vm.metodosHistorico = {
            abrirDialogEditarHistorico: abrirDialogEditarHistorico,
            excluir: excluir
        }

        /**
         * Método para deletar um historicoSolicitacao
         * @param {eventButton} event
         * @param {historicoSolicitacao} historicoSolicitacao
         */
        function excluir(event, historicoSolicitacao) {
            var index = vm.solicitacao.solicitacaoHistoricos.map(function (item) { return item.codigo }).indexOf(historicoSolicitacao.codigo);
            ServicosGenericoService
                .excluirRegistroPorCodigoOuGenericamente(Api.solicitacao.solicitacao.historico.excluir, vm.solicitacao.solicitacaoHistoricos, historicoSolicitacao,
                    vm.controleForm, event, 'Deseja realmente excluir este Histórico ?', null, index,
                    '?codigo=' + historicoSolicitacao.codigo + '&solicitacaoNumero=' + historicoSolicitacao.solicitacaoNumero + '&solicitacaoAno=' + historicoSolicitacao.solicitacaoAno);
        }


        function _setColumnsDefsDtOptionsTabEstoria() {
            return [
                {
                    targets: 0,
                    ordering: false,
                    filterable: true,
                    sortable: false
                },
                {
                    targets: 3,
                    type: 'date-pt-br'
                }
            ];
        };

        /**
         * @param {eventButton} event
         * @param {index} indexArray Index do historicoSolicitacao selecionado na tabela
         * @param {historicoSolicitacao} historicoSolicitacao
         */
        function abrirDialogEditarHistorico(event, indexArray, historicoSolicitacao) {
            $mdDialog.show({
                controller: 'DialogHistoricoSolicitacaoController',
                controllerAs: 'vm',
                templateUrl: vm.htmlRota.dialogs.historicoSolicitacao,
                //parent: ---------------,
                targetEvent: event,
                clickOutsideToClose: false,
                locals: {
                    ControleForm: vm.controleForm,
                    Solicitacao: vm.solicitacao,
                    HistoricoSolicitacao: historicoSolicitacao,
                    SolicitacaoFases: vm.solicitacaoFases,
                    PodeEditar: true
                }
            });
        }


        /*function abrirDialogEditarPontuacao(event) {
            $mdDialog.show({
                controller: 'EditarPontuacaoDialogController',
                controllerAs: 'vm',
                templateUrl: vm.htmlRota.dialogs.editarPontuacao,
                //parent: ---------------,
                targetEvent: event,
                clickOutsideToClose: false,
                locals: {
                    ControleForm: vm.controleForm,
                    UsuarioEstoriaLogado: vm.usuarioEstoriaLogado,
                    Solicitacao: vm.solicitacao,
                }
            });
        }*/
    }

}());

(function () {
    'use strict';

    angular
        .module('app.solicitacao.processamento.solicitacao')
        .controller('TabDocumentacaoSolicitacaoController', TabDocumentacaoSolicitacaoController)

    /** @ngInject */
    function TabDocumentacaoSolicitacaoController(LoginUsuarioService, SolicitacaoFactory, RotasHtml, $mdDialog) {
        var vm = this;

        vm.usuario = LoginUsuarioService.usuarioArmazenado();

        vm.metodos = {
            abrirDialogDocumentacao: abrirDialogDocumentacao
        }

        vm.htmlRota = RotasHtml.solicitacao.solicitacao;
        vm.solicitacao = SolicitacaoFactory.solicitacao;

        vm.etapas = [
            {etapa : 1, nome: 'Solicitação'},
            {etapa: 2, nome:  'Teste'},
            {etapa: 3, nome: 'Análise'},
            {etapa: 4, nome:  'História' }
        ];

        function abrirDialogDocumentacao(etapa, action) {
            $mdDialog.show({
                controller: 'DocumentacaoDialogController',
                controllerAs: 'vm',
                templateUrl: vm.htmlRota.dialogs.documentacaoSolicitacao,
                targetEvent: event,
                clickOutsideToClose: action === 'visualizar',
                locals: {
                    ControleForm: vm.controleForm,
                    Action: action,
                    Solicitacao: vm.solicitacao,
                    Etapa: etapa
                }
            });
        };
    }

}());
(function () {
    'use strict';

    angular
        .module('app.solicitacao.consulta.solicitacao', [])
        .config(config);

    function config($stateProvider, RotasHtml) {
        var rotasHtmlConsultaSolicitacao = RotasHtml.solicitacao.consultaSolicitacao;
        $stateProvider
            .state('app.solicitacao_consulta_solicitacao', {
                url: '/solicitacao/consulta/solicitacao',
                module: 'privado',
                params: {
                    solicitacoesNaoVisualizadas: false
                },
                views: {
                    'content@app': {
                        templateUrl: rotasHtmlConsultaSolicitacao.templateUrl,
                        controller: 'ConsultaSolicitacaoController as vm'
                    },
                    'consulta-solicitacao-filtro@app.solicitacao_consulta_solicitacao': {
                        templateUrl: rotasHtmlConsultaSolicitacao.filtro
                    },
                    'consulta-solicitacao-resultado@app.solicitacao_consulta_solicitacao': {
                        templateUrl: rotasHtmlConsultaSolicitacao.resultado
                    }
                },
                resolve: {
                    ListarTodasSolicitacaoFases: function (Api, RequisicaoGenericaService) {
                        return RequisicaoGenericaService.listarSemParams(Api.solicitacao.fase.listarTodos);
                    },
                    ListarUsuarioPorDetalhe: function (Api, RequisicaoGenericaService, LoginUsuarioService) {
                        return RequisicaoGenericaService.listarSemParams(Api.usuario.detalhes_usuario.listarDetalhesUsuario
                            + LoginUsuarioService.usuarioArmazenado().codigo);
                    }
                }
            });
    }

}());
(function () {
    'use strict';

    angular
        .module('app.solicitacao.consulta.solicitacao')
        .controller('LegendaDialogController',LegendaDialogController)

    /** @ngInject */
    function LegendaDialogController(
        $mdDialog,
        RotasHtml,
        MdDialogService
        ) {
        var vm = this;

        vm.controleForm = {};

        init();


        function init() {

        }

        vm.metodos = {
            fecharDialog: fecharDialog
        }

        function fecharDialog() {
            $mdDialog.hide();
        }
    }

}());
(function () {
    'use strict';

    angular
        .module('app.solicitacao.consulta.solicitacao')
        .controller('ConsultaSolicitacaoDialogController', ConsultaSolicitacaoDialogController)

    /** @ngInject */
    function ConsultaSolicitacaoDialogController($mdDialog, Dados, Titulo, $state,
        SolicitacaoFases, RotasHtml, LoginUsuarioService, MdDialogService,
        DataTableConfigPadrao, Concluida) {
        var vm = this;
        vm.titulo = Titulo;
        vm.solicitacoes = Dados;
        vm.concluida = Concluida;
        vm.alterouDados = false;
        vm.controleForm = {};
        vm.htmlRotaHistorico = RotasHtml.solicitacao.solicitacao.dialogs.historicoSolicitacao;
        vm.usuarioLogado = LoginUsuarioService.usuarioArmazenado();
        vm.solicitacaoFases = SolicitacaoFases;
        vm.metodosDialog = {
            fecharDialog: fecharDialog,
            selecionarSolicitacao: selecionarSolicitacao,
            abrirDialogInserirHistorico: abrirDialogInserirHistorico
        }

        init();

        function init() {
            vm.dtOptions = DataTableConfigPadrao.dtOptionsPadraoComPaginacaoPaginTypeNumbersEReponsivo;
            vm.dtOptions.oLanguage = {
                "sInfo": "_START_ de _END_",
                "sSearch": "Pesquisar: ",
                "sLengthMenu": 'Exibir <select>' +
                    '<option value="10">10</option>' +
                    '<option value="20">20</option>' +
                    '<option value="50">50</option>' +
                    '<option value="100">100</option>' +
                    '</select> registros',
                oPaginate: {
                    "sPrevious": "Anterior",
                    "sNext": "Próximo",
                    "sLast": "Anterior",
                    "sShow": "Exibir"
                }
            };

            vm.dtOptions.columnDefs = DataTableConfigPadrao.columnDefsPadrao;

            vm.dtOptions.columnDefs = [
                {
                    targets: [0, 1, 2, 3, 4, 5, 7, 8],
                    responsivePriority: 1
                }
            ]
        }

        function fecharDialog() {
            $mdDialog.hide(vm.alterouDados);
        }

        function selecionarSolicitacao(solicitacao) {
            $state.goNewTab('app.solicitacao_processamento_solicitacao', {
                parametros: {
                    solicitacaoNumero: solicitacao.numero,
                    solicitacaoAno: solicitacao.ano,
                    squadCodigo: solicitacao.squadCodigo
                }
            });
        }

        /**
         * @param {solicitacao} solicitacao solicitacao selecionada
         * @param {event} event
         * @param {index} index indice do array de solicitações
         */
        function abrirDialogInserirHistorico(solicitacao, event, index) {
            vm.solicitacaoBkp = angular.copy(solicitacao);
            vm.solicitacaoBkp.solicitacaoHistoricos = [];
            $mdDialog.show({
                controller: 'DialogHistoricoSolicitacaoController',
                controllerAs: 'vm',
                templateUrl: vm.htmlRotaHistorico,
                multiple: true,
                //parent: ---------------,
                targetEvent: event,
                clickOutsideToClose: false,
                locals: {
                    ControleForm: vm.controleForm,
                    Solicitacao: vm.solicitacaoBkp,
                    HistoricoSolicitacao: null,
                    SolicitacaoFases: vm.solicitacaoFases,
                    PodeEditar: true
                }
            }).then(function () {
                if (vm.solicitacaoBkp.solicitacaoHistoricos[0].solicitacaoFase.concluida !== vm.concluida) {
                    vm.alterouDados = true;
                    vm.solicitacoes.splice(index, 1);
                }
                else
                    solicitacao.descricaoUltimaSolicitacaoFase = vm.solicitacaoBkp.solicitacaoHistoricos[0].solicitacaoFase.descricao;
            });
        }
    }

}());
(function () {
    'use strict';

    angular
        .module('app.protecao.processamento.atualizacaocliente', [])
        .config(config);

    function config($stateProvider, RotasHtml) {
        var rotasHtml = RotasHtml.protecaoProcessamentoAtualizacaoCliente;
        $stateProvider
            .state('app.protecao_processamento_atualizacao_cliente', {
                url: '/protecao/processamento/atualizacao-cliente',
                module: 'privado',
                onEnter: function (AtualizacaoClienteFactory) {
                    AtualizacaoClienteFactory.setValoresInciaisFiltro();
                },
                views: {
                    'content@app': {
                        templateUrl: rotasHtml.form,
                        controller: "AtualizacaoClienteController as vm"
                    }, 'protecao-atualizacao-cliente--steper-produto@app.protecao_processamento_atualizacao_cliente': {
                        templateUrl: rotasHtml.steps.produto.templateUrl,
                        controller: "ProdutoAtualizacaoClienteController as vm"
                    }, 'protecao-atualizacao-cliente--steper-contrato@app.protecao_processamento_atualizacao_cliente': {
                        templateUrl: rotasHtml.steps.contrato.templateUrl,
                        controller: "ContratoAtualizacaoClienteController as vm"
                    }, 'protecao-atualizacao-cliente--steper-data-expiracao@app.protecao_processamento_atualizacao_cliente': {
                        templateUrl: rotasHtml.steps.expiracao.templateUrl,
                        controller: "DataExpiracaoAtualizacaoClienteController as vm"
                    },
                    'protecao-atualizacao-cliente--steper-caracteristicas-atualizar@app.protecao_processamento_atualizacao_cliente': {
                        templateUrl: rotasHtml.steps.caracteristicas.templateUrl,
                         controller: "CaracteristicaStepController as vm"
                    }
                }, resolve: {
                    listarProdutosAtivos: function (Api, RequisicaoGenericaService) {
                        return RequisicaoGenericaService.listarSemParams(Api.contrato.listarProdutosAtivos);
                    }
                }
            })
    }
})();



(function () {
    'use strict';

    angular.module('app.protecao.processamento.atualizacaocliente')
        .controller('ContratoAtualizacaoClienteController', ContratoAtualizacaoClienteController);

    function ContratoAtualizacaoClienteController(
        AtualizacaoClienteFactory,
        $rootScope,
        LoginUsuarioService
    ) {
        var vm = this;

        vm.clienteContratoItens = [];
        vm.clienteSelecionado = null;
        vm.existeClienteSelecionado = true;

        init();

        function init() {
            vm.usuarioPermiteEdicao = LoginUsuarioService.usuarioArmazenado().detalhesUsuario.permitirAtualizarExpiracaoLicenca;
            vm.form = AtualizacaoClienteFactory.form.form.step.clientes;
            vm.filtro = AtualizacaoClienteFactory.filtros;
            vm.preLoader = AtualizacaoClienteFactory.preLoader;
            vm.onChange = true;
            vm.options = {
                dom: '<"top"f>rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
                pagingType: 'simple',
                pageLength: 10,
                lengthMenu: [10, 20, 50, 100],
                autoWidth: true,
                responsive: true,
                columnDefs: [
                    {
                        width: '20%',
                        targets: [0, 1]
                    },
                    {
                        targets: 0,
                        sortable: false,
                    }
                ],
                oLanguage: {
                    "sInfo": "_START_ de _END_",
                    "sEmptyTable": "Não existem dados para o filtro selecionado!",
                    "sSearch": "Pesquisar: ",
                    "sLengthMenu": 'Exibir <select>' +
                        '<option value="10">10</option>' +
                        '<option value="20">20</option>' +
                        '<option value="50">50</option>' +
                        '<option value="100">100</option>' +
                        '</select> registros',
                    oPaginate: {
                        "sPrevious": "Anterior",
                        "sNext": "Próximo",
                        "sLast": "Anterior",
                        "sShow": "Exibir"
                    }
                }
            }
            vm.options.order = [];
        }

        vm.metodosInternos = {
            selecionarCliente: _selecionarClientePorCodigo,
            atualizarSelecaoCliente: _atualizarSelecaoCliente,
            avancarAbaDataExpiracao: _avancarAbaDataExpiracao
        }

        vm.metodosCliente = {
            selecionarContratos: selecionarContratos,
            marcarTodos: marcarTodos,
            desmarcarTodos: desmarcarTodos,
            selecionar: selecionar
        }

        vm.metodosContrato = {
            adicionarTodos: adicionarTodos,
            removerTodos: removerTodos,
            selecaoContrato: selecaoContrato
        }

        $rootScope.$on('atualizarProdutoCodigoFactory', function (event, produtoCodigo) {
            vm.filtro.produtoCodigo = produtoCodigo;

            if (vm.filtro.clientes) {
                if (!vm.filtro.clientes)
                    return;
                selecionarContratos(vm.filtro.clientes[0]);
                _avancarAbaDataExpiracao(vm.filtro.clientes);
            }
        })

        function _selecionarClientePorCodigo(codigo) {
            return vm.filtro.clientes.filter(function (cliente) {
                if (cliente.codigo == codigo) {
                    return cliente;
                }
            });
        }

        function _atualizarSelecaoCliente(clienteCodigo, opcao) {
            var cliente = _selecionarClientePorCodigo(clienteCodigo)[0];
            cliente.selecionado = opcao;
            _avancarAbaDataExpiracao(vm.filtro.clientes);
        }

        function _avancarAbaDataExpiracao(clientes) {
            var clientesSelecionados = AtualizacaoClienteFactory.validarClientes(clientes);
            vm.existeClienteSelecionado = clientesSelecionados.length > 0;

            vm.selecaoCliente = vm.filtro.clientes.filter(function (clientes) {
                if (clientes.selecionado) {
                    return clientes;
                }
            });
        }

        function selecionarContratos(cliente) {
            if (!cliente)
                return;

            if (vm.filtro.produtoCodigo) {
                if (cliente) {
                    vm.clienteContratoItens = cliente.contratoItens.filter(function (contratoItem) {
                        if (contratoItem.produtoCodigo == vm.filtro.produtoCodigo) {
                            return contratoItem;
                        }
                    });
                }
                else {
                    vm.clienteContratoItens = [];
                }
            } else {
                vm.clienteContratoItens = cliente.contratoItens;
            }
        }

        function marcarTodos() {
            vm.filtro.clientes.map(function (cliente) {
                cliente.selecionado = true;
                adicionarTodos(cliente.contratoItens);
            });

            selecionarContratos(vm.filtro.clientes[0]);
        }

        function desmarcarTodos() {
            vm.filtro.clientes.map(function (cliente) {
                cliente.selecionado = false;
                removerTodos(cliente.contratoItens);
            });

            selecionarContratos(vm.filtro.clientes[0]);
        }

        function selecionar(cliente) {
            selecionarContratos(cliente);
            if (cliente.selecionado) {
                adicionarTodos(vm.clienteContratoItens);
            } else {
                removerTodos(vm.clienteContratoItens);
            }
            selecionarContratos(cliente);
            _enviarBroadcastCliente();
        }

        function _enviarBroadcastCliente() {
            $rootScope.$broadcast('clienteSelecionado', angular.copy(vm.filtro.clientes));
        }

        function adicionarTodos(contratoItens) {
            contratoItens.map(function (contratoItem) { contratoItem.selecionado = true });

            _atualizarSelecaoCliente(contratoItens[0].clienteCodigo, true);
        }

        function removerTodos(contratoItens) {
            contratoItens.map(function (contratoItem) { contratoItem.selecionado = false });

            _atualizarSelecaoCliente(contratoItens[0].clienteCodigo, false);
        }

        function selecaoContrato(contratoItem) {
            var cliente = _selecionarClientePorCodigo(contratoItem.clienteCodigo)[0];
            if (contratoItem.selecionado) {
                contratoItem.selecionado = false;

                var temContratoSelecionado = cliente.contratoItens.some(function (item) {
                    return item.selecionado;
                });

                if (!temContratoSelecionado) {
                    cliente.selecionado = false;
                }
            }
            else {
                contratoItem.selecionado = true;
                cliente.selecionado = true;
            }
            _avancarAbaDataExpiracao(vm.filtro.clientes);
            _enviarBroadcastCliente();
        }
    }
})();

(function () {
    'use strict';

    angular.module('app.protecao.processamento.atualizacaocliente')
        .controller('CaracteristicaStepController', CaracteristicaStepController);

    function CaracteristicaStepController(Api, $scope, AtualizacaoClienteFactory) {
        var vm = this;
        init();

        function init() {
            vm.form = AtualizacaoClienteFactory.form.form.step.caracteristicas;
            vm.preLoader = AtualizacaoClienteFactory.preLoader;
            vm.filtro = AtualizacaoClienteFactory.filtros;
            vm.rotaDePesquisa = Api.contrato_caracteristica.listarPor;
            vm.habilitarTodasCaracteristica = true;
        }

        $scope.$watch(' vm.filtro.caracteristicasContrato.length', function (newValue, oldValue) {
            vm.filtro.caracteristicasContrato.forEach(function (value) {
                if (_verificaSeExisteCaracteristicaANaoImprimirNaLista(value))
                    removerCaracteristicaANaoImprimir(value);
            });
            // $rootScope.$emit('pesquisarClientes')
        });

        $scope.$watch('vm.filtro.caracteristicasContratoANaoImprimir.length', function (newValue, oldValue) {
            vm.filtro.caracteristicasContratoANaoImprimir.forEach(function (value) {
                if (_verificaSeExisteCaracteristicaNaLista(value))
                    removerCaracteristica(value);
            });
            // $rootScope.$emit('pesquisarClientes')
        });


        vm.metodos = {
            removerCaracteristica: removerCaracteristica,
            removerCaracteristicaANaoImprimir: removerCaracteristicaANaoImprimir
        }

        function _verificaSeExisteCaracteristicaNaLista(caracteristica) {
            return vm.filtro.caracteristicasContrato.some(function (item) {
                return ((caracteristica.codigo) == (item.codigo));
            });
        }

        function _verificaSeExisteCaracteristicaANaoImprimirNaLista(caracteristica) {
            return vm.filtro.caracteristicasContratoANaoImprimir.some(function (item) {
                return ((caracteristica.codigo) == (item.codigo));
            });
        }

        function removerCaracteristica(caracteristica) {
            if (caracteristica && _verificaSeExisteCaracteristicaNaLista(caracteristica)) {

                for (var i = vm.filtro.caracteristicasContrato.length - 1; i >= 0; i--) {
                    if (vm.filtro.caracteristicasContrato[i].codigo === caracteristica.codigo) {
                        vm.filtro.caracteristicasContrato.splice(i, 1);
                    }
                }
            }
        }

        function removerCaracteristicaANaoImprimir(caracteristica) {
            if (caracteristica && _verificaSeExisteCaracteristicaANaoImprimirNaLista(caracteristica)) {

                for (var i = vm.filtro.caracteristicasContratoANaoImprimir.length - 1; i >= 0; i--) {
                    if (vm.filtro.caracteristicasContratoANaoImprimir[i].codigo === caracteristica.codigo) {
                        vm.filtro.caracteristicasContratoANaoImprimir.splice(i, 1);
                    }
                }

            }
        }


    }
})();
(function () {
    'use strict';

    angular.module('app.protecao.processamento.atualizacaocliente')
        .controller('DataExpiracaoAtualizacaoClienteController', DataExpiracaoAtualizacaoClienteController);

    function DataExpiracaoAtualizacaoClienteController(
        AtualizacaoClienteFactory,
        $scope
    ) {
        var vm = this;

        init();

        function init() {
            vm.form = AtualizacaoClienteFactory.form.form.step.data;
            vm.filtro = AtualizacaoClienteFactory.filtros;
            vm.preLoader = AtualizacaoClienteFactory.preLoader;
            vm.dataAtual = new Date();
        }

        $scope.$on("$destroy", function () {
            AtualizacaoClienteFactory.setValoresInciaisFiltro();
        });
    }
})();
(function () {
    'use strict';

    angular.module('app.protecao.processamento.atualizacaocliente')
        .controller('ProdutoAtualizacaoClienteController', ProdutoAtualizacaoClienteController);

    function ProdutoAtualizacaoClienteController(
        $timeout,
        $rootScope,
        AtualizacaoClienteFactory,
        listarProdutosAtivos
    ) {

        var vm = this;
        init();

        function init() {
            vm.produtos = listarProdutosAtivos.data;
            vm.form = AtualizacaoClienteFactory.form.form.step.produtos;
            vm.filtro = AtualizacaoClienteFactory.filtros;
            vm.filtro.produtoCodigo = AtualizacaoClienteFactory.filtros.produtoCodigo;
            vm.preLoader = AtualizacaoClienteFactory.preLoader;
            vm.requisicaoSolicitada = false;
            $timeout(function () {
                vm.filtro.msVerticalStepperController.gotoStep(1)
            });
        }

        vm.metodos = {
            selecionarProduto: selecionarProduto
        }

        function selecionarProduto() {
            $rootScope.$emit('pesquisarClientes');
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('app.protecao.processamento.atualizacaolicenca', [])
        .config(config);

    function config($stateProvider, RotasHtml) {
        var rotasHtml = RotasHtml.protecaoProcessamentoAtualizacaoLicenca;
        $stateProvider
            .state('app.protecao_processamento_atualizacao_licenca', {
                url: '/protecao/processamento/atualizacao',
                module: 'privado',
                onEnter: function (AtualizacaoLicencaFactory) {
                    AtualizacaoLicencaFactory.setValoresInciaisFiltro();
                },
                views: {
                    'content@app': {
                        templateUrl: rotasHtml.form,
                        controller: "AtualizacaoLicencaController as vm"
                    },'protecao-atualizacao-licenca--steper-cliente@app.protecao_processamento_atualizacao_licenca': {
                        templateUrl: rotasHtml.cliente.templateUrl,
                        controller: "ClienteAtualizacaoLicencaController as vm"
                    },
                    'protecao-atualizacao-licenca--steper-tipo-licenca@app.protecao_processamento_atualizacao_licenca': {
                        templateUrl: rotasHtml.tipoLicenca.templateUrl,
                        controller: "TipoLicencaAtualizacaoLicencaController as vm"
                    }
                }, resolve: {
                    ListarProdutos: function (Api, RequisicaoGenericaService) {
                        return RequisicaoGenericaService.listarSemParams(Api.produto.listarPor);
                    },
                    ListarTiposLicenca: function (Api, RequisicaoGenericaService) {
                        return RequisicaoGenericaService.listarSemParams(Api.protecao.tipoLicenca.listarPor);
                    },
                    ListarClientes: function (Api, RequisicaoGenericaService){
                        return RequisicaoGenericaService.listarSemParams(Api.protecao.atualizacaoLicenca.listar);
                    }
                }
            })
    }
})();



(function () {
    'use strict';

    angular.module('app.protecao.processamento.atualizacaolicenca')
        .controller('ClienteAtualizacaoLicencaController', ClienteAtualizacaoLicencaController);

    function ClienteAtualizacaoLicencaController($scope, $timeout, ListarClientes,
        AtualizacaoLicencaFactory,
        ServicosGenericoService, Api,
        RequisicaoGenericaService, MdDialogService) {
        var vm = this;

        vm.clientes = ListarClientes.data;

        vm.filtroClientes = vm.clientes.clientes;

        init();

        function init() {
            vm.form = AtualizacaoLicencaFactory.form;
            vm.filtro = AtualizacaoLicencaFactory.filtros;
            vm.licencas = AtualizacaoLicencaFactory.licencas;

            $timeout(function () { vm.filtro.msVerticalStepperController.gotoStep(1) });
        }

        vm.mentodosInternos = {
            inicializarProdutos: _inicializarProdutos,
            carregarProdutosPorCliente: _carregarProdutosPorCliente,
            buscarLicencas: _buscarLicencas
        }

        vm.metodos = {
            configuraAutoCompleteClienteOnBlur: configuraAutoCompleteClienteOnBlur,
            pesquisarAutoCompleteCliente: pesquisarAutoCompleteCliente,
            alterarItemSelecionadoAutoCompleteCliente: alterarItemSelecionadoAutoCompleteCliente
        };

        $scope.$watch('vm.filtro.produto', function (newValue, oldValue) {
            if (newValue) {
                _buscarLicencas(vm.filtro);
            }
        });

        /**
         * Método que limpa o texto de pesquisa do md-auto-complete da Cliente
         */
        function configuraAutoCompleteClienteOnBlur() {
            if (!vm.filtro.cliente) {
                vm.textoDePesquisaAutoCompleteCliente = "";
            }
        }

        /**
         * Método que realiza uma requisição para api para buscar os clientes em tempo de excução, * com base no que o usuário está digitando
         * @param {string} query 
         */
        function pesquisarAutoCompleteCliente(query) {
            var resultado = vm.filtroClientes.filter(function (cliente) {
                if (cliente.nome.toLowerCase().includes(query.toLowerCase()) ||
                    cliente.codigo == query) {
                    return cliente;
                }
            });

            return resultado;
            //return ServicosGenericoService.pesquisarAutoCompleteCodigoOuNomeGenericoApi(Api.cliente.listarCodigoDescricao, query);
        }

        /**
         * Método que controla qual cidade está selecionada no campo md-auto-complete do Cliente
         * @param {object} item 
         */
        function alterarItemSelecionadoAutoCompleteCliente(item) {
            if (item) {
                vm.filtro.cliente = item;
                _carregarProdutosPorCliente(vm.filtro.cliente.codigo);
            } else {
                _inicializarProdutos();
                vm.filtro.cliente = null;
                vm.filtro.produto = null;
                vm.textoDePesquisaAutoCompleteCliente = "";
            }
        }

        function _buscarLicencas(filtro) {
            var parametros = '/' + filtro.cliente.codigo + '/' + filtro.produto.codigo;
            RequisicaoGenericaService.listarSemParams(Api.protecao.atualizacaoLicenca.licencas + parametros).then(
                function (success) {
                    AtualizacaoLicencaFactory.setLicencas(success.data);
                },
                function (error) {
                    MdDialogService.alertPadrao(error.data);
                });
        }

        function _inicializarProdutos() {
            vm.produtos = {
                codigo: null,
                descricao: null
            };
        }

        function _carregarProdutosPorCliente(clienteCodigo) {
            _inicializarProdutos();

            RequisicaoGenericaService.listarSemParams(Api.produto.listarTodosProdutosAtivosCliente + clienteCodigo).then(
                function (success) {
                    vm.produtos = success.data;
                },
                function (error) {
                    MdDialogService.alertPadrao(error.data);
                });
        }
    }
})();
/**
 * Created by nova on 07/11/2016.
 */
(function () {
    'use strict';

    angular
        .module('app.planejamentoScrum.processamento.productBacklog', [])
        .config(Config);

    function Config($stateProvider, RotasHtml) {
        var rotasHtmlProductBacklog = RotasHtml.productBacklog;
        var rotasHtmlEstoria = RotasHtml.estoria;
        $stateProvider.state("app.planejamento_processamento_product_backlog", {
            url: "/planejamento/processamento/product-backlog",
            module: "privado",
            views: {
                "content@app": {
                    templateUrl: rotasHtmlProductBacklog.templateUrl,
                    controller: "ProductBacklogController as vm"
                }
            },
            resolve: {
                ListarTodasOrigens: function (Api, RequisicaoGenericaService) {
                    return RequisicaoGenericaService.listarSemParams(
                        Api.estoria.origens.listar
                    );
                },
                ListarProdutos: function (Api, RequisicaoGenericaService) {
                    return RequisicaoGenericaService.listarSemParams(
                        Api.produto.listarPor
                    );
                },
                ListarNecessidadesCliente: function (Api, RequisicaoGenericaService) {
                    return RequisicaoGenericaService.listarSemParams(
                        Api.display.listarNecessidadeCliente);
                },
                ListarUsuarioPorDetalhe: function (Api, RequisicaoGenericaService, LoginUsuarioService) {
                    return RequisicaoGenericaService.listarSemParams(Api.usuario.detalhes_usuario.listarDetalhesUsuario
                        + LoginUsuarioService.usuarioArmazenado().codigo);
                },
                ListarSprintCorrentePorSquads: function (Api, RequisicaoGenericaService, ListarUsuarioPorDetalhe) {
                    var objetoCodigoSquads = {
                        codigoSquads: ListarUsuarioPorDetalhe.data.codigoSquads,
                    }

                    return RequisicaoGenericaService.listarComObjetoComplexo(
                        Api.sprint.listarSprintCorrentePorSquads, objetoCodigoSquads
                    );
                },
                ListarTodosClientes: function (Api, RequisicaoGenericaService) {
                    return RequisicaoGenericaService.listarSemParams(
                        Api.cliente.listarCodigoDescricao);
                },
                ListarSituacoes: function (Api, RequisicaoGenericaService) {
                    return RequisicaoGenericaService.listarSemParams(
                        Api.situacao.listarTodos);
                },
            }
        });
    }

})();

(function () {
  'use strict';

  angular
    .module('app.planejamentoScrum.processamento.productBacklog')
    .controller('ProductBacklogDialogAlterarPrioridade', ProductBacklogDialogAlterarPrioridade);

  function ProductBacklogDialogAlterarPrioridade
    (
      Api, RequisicaoGenericaService, $mdDialog, MdToastService, MdDialogService, Estoria
    ) {
    var vm = this;

    //<editor-fold desc="Data">
    vm.form = {};
    vm.titulo = "Editando Prioridade";
    vm.requisicaSolicitada = false;

    vm.estoria = angular.copy(Estoria);
    // Data region

    //endregion
    //</editor-fold>

    //<editor-fold desc="Definição Métodos">
    vm.metodosDialog = {
      fecharDialog: metodoDialogFecharDialog,
      salvar: salvar
    }
    // Definição Métodos region

    //endregion
    //</editor-fold>

    //<editor-fold desc="Implmentação dos Métodos">
    // Implmentação dos Métodos region
    function salvar(estoria, event) {
      vm.requisicaSolicitada = true;

      RequisicaoGenericaService.editar(Api.estoria.atualizarProductBacklog, estoria).then(
        function (success) {
          vm.requisicaSolicitada = false;
          MdToastService.toastPadrao("Prioridade Alterada com Sucesso.")
          Estoria.prioridadeBacklog = estoria.prioridadeBacklog;
          $mdDialog.hide(true);
        },
        function (error) {
          vm.requisicaSolicitada = false;
          alert(error.data, event);
        });

    }

    function metodoDialogFecharDialog() {
      $mdDialog.hide();
    }
    //endregion
    //</editor-fold>

  }

})();


/**
 * Created by nova on 26/10/2016.
 */
(function () {
    'use strict';

    angular
        .module('app.planejamentoScrum.processamento.productBacklog')
        .controller('ProductBacklogDialogAlterarNecessidadeCliente', ProductBacklogDialogAlterarNecessidadeCliente);


    function ProductBacklogDialogAlterarNecessidadeCliente($mdDialog, MdDialogService, MdToastService, RequisicaoGenericaService, Api,
        Estoria) {

        var vm = this;

        /////////////////////////////////////////////////////// Data ////////////////////////////////////////////////////////////////////      
        vm.form = {};
        vm.titulo = "Necessidade do Cliente";
        vm.mensagemPreloader = "";

        vm.estoria = angular.copy(Estoria);
        vm.necessidadesCliente = [];
        /////////////////////////////////////////////////////// Fim Data ////////////////////////////////////////////////////////////////////      

        /**
         * Chamada do metódo inicializador
         */
        init();

        vm.metodosDialog = {
            salvar: salvar,
            fecharDialog: metodoDialogFecharDialog,
        };

        /////////////////////////////////////////////////////// Implmentação dos métodos ///////////////////////////////////////////////////////
        /**
         * Método inicializador
         */
        function init() {
            vm.requisicaoSolicitada = true;
            vm.mensagemPreloader = "Carregando Necessidades do Cliente ..."
            RequisicaoGenericaService.listarSemParams(Api.display.listarNecessidadeCliente).then(
                function (success) {
                    vm.necessidadesCliente = success.data;
                    vm.mensagemPreloader = "";
                    vm.requisicaoSolicitada = false;
                },
                function (error) {
                    vm.requisicaoSolicitada = false;
                    vm.mensagemPreloader = "";
                    MdDialogService.alertPadrao(error.data);
                });
        }

        /**
         * Método para atualizar a necessidade do cliente da estória solicitada
         * @param {object} modelo Estória
         * @param {event} event Event do botão
         */
        function salvar(modelo, event) {
            vm.requisicaoSolicitada = true;
            vm.mensagemPreloader = "Atualizando Necessidade do Cliente ...";

            RequisicaoGenericaService.editar(Api.estoria.atualizarProductBacklog, modelo).then(
                function (success) {
                    vm.requisicaoSolicitada = false;
                    MdToastService.toastPadrao("Necessidade do Cliente atualizada com sucesso.")
                    Estoria.necessidadeCliente = success.data.necessidadeCliente;
                    Estoria.necessidadeClienteDescricao = success.data.necessidadeClienteDescricao;
                    $mdDialog.hide();
                },
                function (error) {
                    vm.requisicaoSolicitada = false;
                    MdDialogService.alertPadrao(error.data, event);
                });

        }

        /**
         * Método para fechar o dialog quando pressionado o "X" no toolbar do Dialog
         */
        function metodoDialogFecharDialog() {
            $mdDialog.hide();
        }
        /////////////////////////////////////////////////////// Fim Implmentação dos métodos ///////////////////////////////////////////////////

    } // CONTROLLER

})();

(function () {
    'use strict';

    angular.module('app.protecao.processamento.atualizacaolicenca')
        .controller('TipoLicencaAtualizacaoLicencaController', TipoLicencaAtualizacaoLicencaController);

    function TipoLicencaAtualizacaoLicencaController(ListarTiposLicenca,
        $rootScope,
        AtualizacaoLicencaFactory,
        DataTableConfigPadrao,
        RequisicaoGenericaService, Api) {
        var vm = this;

        vm.tiposLicencaBkp = ListarTiposLicenca.data;
        vm.tiposLicenca = [];

        init();

        function init() {
            vm.form = AtualizacaoLicencaFactory.form;
            vm.filtro = AtualizacaoLicencaFactory.filtros;
            vm.licencas = AtualizacaoLicencaFactory.licencas();

            vm.ordenacao = {
                1: "Adicionar",
                2: "Remover"
            };
        }

        vm.metodosInternos = {
            carregarTiposLicencaPorClienteProduto: _carregarTiposLicencaPorClienteProduto,
            carregarTiposLicencaPorProduto: _carregarTiposLicencaPorProduto,
            verificaTipoLicencaInserida: _verificaTipoLicencaInserida
        }

        vm.metodos = {
            configuraMdSelectTipoLicenca: configuraMdSelectTipoLicenca,
            onClickColumnSelecionar: onClickColumnSelecionar
        }

        // Configurações Datatable region
        vm.dtOptionsLicenca = angular.copy(DataTableConfigPadrao.dtOptionsResponsivoSemPaginacaoComInitComplete);
        vm.dtOptionsLicenca.columnDefs = [
            {
                targets: 0,
                orderable: false,
                searchable: false,
            }
        ];
        vm.dtOptionsLicenca.dom = 'rt';

        $rootScope.$on('atualizarLicencasFactory', function (event, licencas) {
            vm.licencas = [].concat(licencas);
            if (vm.filtro.cliente) {
                vm.produtoDescricao = vm.filtro.produto.descricao;
                _carregarTiposLicencaPorClienteProduto(vm.filtro);
            }
        })


        function _carregarTiposLicencaPorClienteProduto(filtro) {
            vm.tiposLicenca = [];
            _carregarTiposLicencaPorProduto(filtro.produto.codigo);
        }

        function _carregarTiposLicencaPorProduto(produtoCodigo) {
            for (var i = vm.tiposLicencaBkp.length - 1; i >= 0; i--) {
                if (vm.tiposLicencaBkp[i].produtos.length > 0) {
                    vm.tiposLicencaBkp[i].produtos.filter(function (produto) {
                        if (produto.codigo == produtoCodigo && _verificaTipoLicencaInserida(vm.tiposLicencaBkp[i].codigo) == false) {
                            vm.tiposLicenca.push(vm.tiposLicencaBkp[i]);
                        }
                    });
                }
            }
        }

        function _verificaTipoLicencaInserida(tipoLicencaCodigo) {
            return vm.tiposLicenca.some(function (item) {
                return ((tipoLicencaCodigo) == (item.codigo));
            });
        }

        /**
         * Método que irá configurar e limpar o filtro do md-header do md-select tipo de licença
         */
        function configuraMdSelectTipoLicenca() {
            vm.filtrarTiposLicenca = "";
            angular.element('#atualizacao-form-tipo-licenca-md-select').on('keydown', function (ev) {
                ev.stopPropagation();
            });
        }

        /* Método responsável por capturar o evendo de click na coluna Selecionar da tabela
           que listas as licenças filtradas de acordo com o filtro selecionado  
        */
        function onClickColumnSelecionar(opcao) {
            for (var i = vm.licencas.length - 1; i >= 0; i--) {
                vm.licencas[i].flag = opcao;
            }
        }
    }
})();
(function () {
  'use strict';
  angular
    .module('app.planejamentoScrum.processamento.productBacklog')
    .controller('DialogLegendaTabelaProductBacklogController', DialogLegendaTabelaProductBacklogController);

  function DialogLegendaTabelaProductBacklogController($mdDialog) {
    var vm = this;
    vm.form = {};

    vm.metodosDialog = {
      fechar: fechar,
    }

    vm.legendaTabelaDatas = [
      {
        descricao: "Data de entrega vencida",
        cor: "red"
      },
      {
        descricao: "Data de entrega próxima",
        cor: "yellow"
      },
    ]

    function fechar() {
      $mdDialog.hide();
    }
  }

})();


(function () {
  'use strict';

  angular
    .module('app.planejamentoScrum.processamento.productBacklog')
    .controller('ProductBacklogDialogAlterarDataEntrega', ProductBacklogDialogAlterarDataEntrega);

  function ProductBacklogDialogAlterarDataEntrega(Api, RequisicaoGenericaService, $mdDialog, MdToastService, Estoria) {
    var vm = this;

    //<editor-fold desc="Data">
    vm.form = {};
    vm.titulo = "Editando Data Entrega";
    vm.requisicaSolicitada = false;

    vm.estoria = angular.copy(Estoria);
    // Data region

    //endregion
    //</editor-fold>

    //<editor-fold desc="Definição Métodos">
    vm.metodosDialog = {
      fecharDialog: metodoDialogFecharDialog,
      salvar: salvar
    }
    // Definição Métodos region

    //endregion
    //</editor-fold>

    //<editor-fold desc="Implmentação dos Métodos">
    // Implmentação dos Métodos region
    function salvar(estoria, event) {
      vm.requisicaSolicitada = true;

      RequisicaoGenericaService.editar(Api.estoria.atualizarProductBacklog, estoria).then(
        function (success) {
          vm.requisicaSolicitada = false;
          MdToastService.toastPadrao("Data Entrega alterada com sucesso.")
          Estoria.dataEntrega = success.data.dataEntrega;
          $mdDialog.hide();
        },
        function (error) {
          vm.requisicaSolicitada = false;
          alert(error.data, event);
        });

    }

    function metodoDialogFecharDialog() {
      $mdDialog.hide();
    }
    //endregion
    //</editor-fold>

  }

})();


(function () {
    'use strict';

    angular
        .module('app.planejamentoScrum.processamento.productBacklog')
        .controller('ProductBacklogDialogAdicionarSprintEspecificaController',
            ProductBacklogDialogAdicionarSprintEspecificaController);

    function ProductBacklogDialogAdicionarSprintEspecificaController(
        Api,
        RequisicaoGenericaService,
        MdDialogService,
        $mdDialog,
        SquadFiltrada,
        HistoriasSelecionadas,
        SquadService
    ) {

        var vm = this;
        vm.sprints = [];
        vm.historiasSelecionadas = HistoriasSelecionadas;
        vm.squadFiltrada = SquadFiltrada;
        vm.form = {};
        vm.filtrarSprints = "";
        vm.titulo = "Adicionar histórias à sprint backlog";
        vm.requisicaoSolicitada = false;

        vm.metodosDialog = {
            configurarMdSelectSprint: configurarMdSelectSprint,
            salvar: salvar,
            fecharDialog: fecharDialog,
        };

        init();

        function init() {
            _listarSprintEmAberto();
        }

        function _listarSprintEmAberto() {
            vm.requisicaoSolicitada = true;
            RequisicaoGenericaService.listarComObjetoComplexo(Api.sprint.backlog.listarSprintsEmAberto + vm.squadFiltrada)
                .then(function (success) {
                    vm.sprints = success.data.map(function (item) {
                        return {
                            numeroSprint: item.numero,
                            descricao: SquadService.descricaoSquad(item.squadCodigo) + ' - ' + item.numero
                        };
                    });
                    vm.requisicaoSolicitada = false;
                }, function (error) { vm.requisicaoSolicitada = false; });
        }

        function configurarMdSelectSprint() {
            vm.filtrarEstorias = "";
            angular.element('#product-backlog-dialog-adicionar-sprints-especificas-md-select').
                on('keydown', function (ev) {
                    ev.stopPropagation();
                });
        }

        function salvar(event, sprint) {
            var historiasSelecionadas = vm.historiasSelecionadas;
            var historiasVinculadas = historiasSelecionadas.filter(function (historia) {
                return historia.sprintNumero === sprint.numeroSprint;
            });

            var totalSelecionadas = historiasSelecionadas.length;
            var totalVinculadas = historiasVinculadas.length;
            var ehTodasVinculadas = totalVinculadas === totalSelecionadas;
            var ehUmaSelecionada = totalSelecionadas === 1;
            var ehUmaVinculada = totalVinculadas === 1;

            if (ehTodasVinculadas) {
                var mensagem = ehUmaSelecionada
                    ? "A história selecionada já está vinculada à sprint " + sprint.numeroSprint + "."
                    : "Todas as histórias selecionadas já estão vinculadas à sprint " + sprint.numeroSprint + ".";

                MdDialogService.alertPadrao(
                    "Atenção!",
                    event,
                    mensagem
                );
                return;
            }

            if (totalVinculadas > 0) {
                var lista = historiasVinculadas
                    .map(function (h) {
                        return h.numero + "/" + h.ano;
                    })
                    .join(', ');

                var mensagem = (ehUmaVinculada
                    ? "A história <strong>" + lista + "</strong> já está vinculada à sprint "
                    : "As histórias <strong>" + lista + "</strong> já estão vinculadas à sprint ")
                    + sprint.numeroSprint + ".<br>"
                    + (ehUmaVinculada ? "A restante será vinculada." : "As demais serão vinculadas.");

                MdDialogService.alertPadraoComEvento(
                    "Atenção!",
                    function () {
                        _removerHistoriasJaVinculadas(historiasVinculadas);
                        _enviarRequisicaoSalvar(sprint);
                    },
                    event,
                    mensagem
                );
                return;
            }

            _enviarRequisicaoSalvar(sprint);
        }



        function _enviarRequisicaoSalvar(sprint) {
            var sprintTemporaria = vm.historiasSelecionadas.map(function (historia) {
                return {
                    estoriaNumero: historia.numero,
                    estoriaAno: historia.ano,
                    sprintNumero: sprint.numeroSprint,
                    squadCodigo: vm.squadFiltrada
                };
            });

            vm.requisicaoSolicitada = true;

            RequisicaoGenericaService.salvar(Api.sprint.backlog.criar, sprintTemporaria).then(
                function (success) {
                    vm.requisicaoSolicitada = false;
                    $mdDialog.hide(true);
                },
                function (error) {
                    vm.requisicaoSolicitada = false;
                    alert("Falha ao cadastrar as histórias no backlog da sprint.\nDetalhes: " + error.data);
                }
            );
        }

        function _removerHistoriasJaVinculadas(historiasVinculadas) {
            vm.historiasSelecionadas = vm.historiasSelecionadas.filter(function (historia) {
                return !historiasVinculadas.some(function (v) {
                    return v.numero === historia.numero && v.ano === historia.ano;
                });
            });
        }

        function fecharDialog() {
            $mdDialog.hide();
        }
    }
})();
(function () {
    "use strict";

    angular
        .module("app.planejamentoscrum.consulta.estatisticas", [])
        .config(Config);

    function Config($stateProvider, RotasHtml) {
        var rotasHtmlestatistica = RotasHtml.estatistica;
        $stateProvider.state("app.planejamento_consulta_estatistica", {
            url: "/consulta/estatistica",
            module: "privado",
            views: {
                "content@app": {
                    templateUrl: rotasHtmlestatistica.templateUrl,
                    controller: "ConsultaEstatisticaController as vm"
                }
            },
            resolve: {
                ListarUsuarioPorDetalhe: function (Api, RequisicaoGenericaService, LoginUsuarioService) {
                    return RequisicaoGenericaService.listarSemParams(Api.usuario.detalhes_usuario.listarDetalhesUsuario
                        + LoginUsuarioService.usuarioArmazenado().codigo);
                },
                ListarAno: function (Api, RequisicaoGenericaService, ListarUsuarioPorDetalhe) {
                    var squadUsuarioLogado = ListarUsuarioPorDetalhe.data.codigoSquads[0];
                    return RequisicaoGenericaService.listarSemParams(Api.sprint.estatistica.listarAno + '?' + 'squadCodigo=' + squadUsuarioLogado);
                },
                ListarSprint: function (Api, RequisicaoGenericaService, ListarUsuarioPorDetalhe) {
                    var squadUsuarioLogado = ListarUsuarioPorDetalhe.data.codigoSquads[0];
                    return RequisicaoGenericaService.listarComParams(
                        Api.sprint.estatistica.listarSprint + '?' + 'ano=' + (new Date().getFullYear()) + "&" + 'squadCodigo=' + squadUsuarioLogado
                    );
                },
                ListarTipoFiltroEstatistica: function (Api, RequisicaoGenericaService) {
                    return RequisicaoGenericaService.listarSemParams(
                        Api.display.listarTipoFiltroEstatistica
                    )
                },

            }
        });
    }
})();

//ng-class="{'vermelho': estoria.diasRestantes <= 0,
//'amarelo': estoria.diasRestantes <= 7 && estoria.diasRestantes < 0}"
(function () {
    "use strict";

    angular
        .module("app.planejamentoscrum.consulta.estatisticas")
        .controller("ConsultaEstatisticaDialogController", ConsultaEstatisticaDialogController);

    function ConsultaEstatisticaDialogController(

        $mdDialog,
        Estatistica,
        Titulo
    ) {
        var vm = this;
        vm.estatistica = Estatistica;
        vm.titulo = Titulo;
        vm.metodos = {
            fecharDialog: fecharDialog
        };
        vm.sprints = "sprint 100,sprint 101,sprint 102,sprint 103,sprint 104,sprint 105";

        vm.options = {
            chart: {
                type: "lineChart",
                height: 300,
                margin: {
                    top: 20,
                    right: 20,
                    bottom: 50,
                    left: 55
                },
                x: function (d) {
                    return d.sprintNumero;
                },
                y: function (d) {
                    if (vm.titulo == "Pontos desenvolvidos") return d.pontuacaoEntregue;
                    if (vm.titulo == "Histórias desenvolvidas") return d.historiasDesenvolvidas;
                    if (vm.titulo == "Historias homologadas") return d.historiasHomologadas;
                    if (vm.titulo == "Pontos homologados") return d.pontuacaoHomologada;
                    if (vm.titulo == "Pontos perdidos") return d.pontuacaoPerdida;
                    if (vm.titulo == "Melhorias") return d.totalMelhorias;
                    if (vm.titulo == "Metas Concluídas") return d.metaConcluida;
                    return d.totalErros;
                },
                xAxis: {
                    axisLabel: "SPRINTS",
                    axisLabelDistance: 5
                },
                yAxis: {
                    axisLabel: vm.titulo.toUpperCase(),
                    axisLabelDistance: -10

                },
                forceY: [0],
                clipEdge: false,
                noData: "Sem informações à serem exibidas."
            }
        };

        vm.data = [
            {
                key: vm.titulo,
                strokeWidth: 2.0,
                values: vm.estatistica
            }
        ];




        function fecharDialog() {
            $mdDialog.hide();
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.planejamentoscrum.estatistica.estatisticaIndividual', [])
        .config(Config);

    function Config($stateProvider, RotasHtml) {
        var rotasHtml = RotasHtml.estatisticas.estatisticaIndividual;

        $stateProvider
            .state('app.planejamentoscrum_estatistica_estatisticaindividual', {
                url: '/planejamento/estatistica/estatistica-individual',
                module: 'privado',
                views: {
                    'content@app': {
                        templateUrl: rotasHtml.templateUrl,
                        controller: 'EstatisticaIndividualController as vm'
                    },
                    'estatistica-individual-form@app.planejamentoscrum_estatistica_estatisticaindividual': {
                        templateUrl: rotasHtml.form
                    },
                    'filtro-estatistica-individual@app.planejamentoscrum_estatistica_estatisticaindividual': {
                        templateUrl: rotasHtml.sidenav,
                        controller: 'FiltroEstatisticaIndividualController as vm'
                    }
                },
                resolve: {
                    ListarUsuarioPorDetalhe: function (Api, RequisicaoGenericaService, LoginUsuarioService) {
                        return RequisicaoGenericaService.listarSemParams(Api.usuario.detalhes_usuario.listarDetalhesUsuario
                            + LoginUsuarioService.usuarioArmazenado().codigo);
                    },
                    ListarAno: function (Api, RequisicaoGenericaService, ListarUsuarioPorDetalhe) {
                        var squadUsuarioLogado = ListarUsuarioPorDetalhe.data.codigoSquads[0];
                        return RequisicaoGenericaService.listarSemParams(Api.sprint.estatistica.listarAno + '?' + 'squadCodigo=' + squadUsuarioLogado);
                    },
                    ListarEstatisticaDesenvolvedorAno: function (Api, RequisicaoGenericaService, ListarUsuarioPorDetalhe) {
                        var squadUsuarioLogado = ListarUsuarioPorDetalhe.data.codigoSquads[0];
                        return RequisicaoGenericaService.listarSemParams(Api.estatisticas.estatisticas_individual.listarEstatisticaDesenvolvedorAno + '?' + 'ano=' + (new Date().getFullYear()) + "&" + 'squadCodigo=' + squadUsuarioLogado);
                    }
                }
            });
    }

})();

(function () {
    'use strict';

    angular
        .module('app.planejamentoscrum.estatistica.estatisticaIndividual')
        .controller('FiltroEstatisticaIndividualController', FiltroEstatisticaIndividualController);

    function FiltroEstatisticaIndividualController(
        Api,
        EstatisticaIndividualService,
        ListarAno,
        ListarUsuarioPorDetalhe,
        RequisicaoGenericaService,
        SquadService
    ) {
        var vm = this;

        vm.filtro = {};
        vm.filtro.sprints = [];
        vm.ano = ListarAno.data;
        vm.squadUsuarioLogado = ListarUsuarioPorDetalhe.data.codigoSquads;
        vm.squads = SquadService.listarSquadsUsuarioLogado(vm.squadUsuarioLogado);
        vm.metodos = {
            retornaSprintPorAno: retornaSprintPorAno,
            filtrarDados: filtrarDados,
            selectChangeSquad: selectChangeSquad
        };

        function retornaSprintPorAno(ano, squadCodigo) {
            squadCodigo = (vm.squadUsuarioLogado.length === 1 || !squadCodigo) ? vm.squadUsuarioLogado[0] : squadCodigo;
            vm.sprint = undefined;
            vm.filtro.numerosSprint = undefined;

            EstatisticaIndividualService.retornaSprintPorAno(ano, squadCodigo)
                .then(function (success) {
                    vm.sprint = success.data;
                    vm.sprint.map(function (sprint) {
                        sprint.descricao = sprint.numero + " de " + _dataParaString(sprint.dataInicial) + " a " + _dataParaString(sprint.dataFinal);
                    });
                });
        }

        function filtrarDados(filtro) {
            var numerosSprint = [];

            if (filtro.sprints && filtro.sprints.length) {
                numerosSprint = filtro.sprints.map(function (sprint) {
                    return sprint.numero;
                });
            } else {
                numerosSprint = vm.sprint.map(function (sprint) {
                    return sprint.numero;
                });
            }
            var squadCodigo = (vm.squadUsuarioLogado.length === 1) ? vm.squadUsuarioLogado[0] : filtro.squadCodigo;

            var viewModel = {
                sprint: numerosSprint,
                squadCodigo: squadCodigo
            };

            EstatisticaIndividualService.listener(function () { return viewModel; });
            EstatisticaIndividualService.toggleFiltro();
        }

        function _dataParaString(data) {
            return new Date(data).toLocaleDateString();
        }

        function selectChangeSquad(squadCodigo) {
            vm.ano = [];
            vm.filtro.sprintAno = null;
            vm.sprint = [];
            vm.filtro.sprints = null;
            return RequisicaoGenericaService.listarSemParams(
                Api.sprint.estatistica.listarAno + '?' +
                'squadCodigo=' + squadCodigo)
                .then(function (success) {
                    vm.ano = success.data;
                })
                .catch(function (error) {
                    vm.ano = [];
                })
        }

    }
})();

/**
 * Created by nova on 26/10/2016.
 */
(function () {
    'use strict';

    angular
        .module('app.pipeline.processamento.pipelineNegocio')
        .controller('PipelineEtapaAtividadeInformativoController', PipelineEtapaAtividadeInformativoController);

    function PipelineEtapaAtividadeInformativoController($mdDialog, Parametros) {
        var vm = this;

        //<editor-fold desc="Data">    
        vm.form = {};
        vm.titulo = "Atividades da etapa";

        vm.atividadesEtapa = angular.copy(Parametros[0]);

        vm.requisicaoSolicitada = false;
        //endregion

        // Resolve region
        //endregion

        // Definição dos Métodos region
        vm.metodos = {
            fecharDialog: fecharDialog,
        };
        //endregion

        // Implementação dos Métodos region

        // Métodos Dialog region    
        function fecharDialog() {
            $mdDialog.hide();
        }
        //</editor-fold>

        //endregion
    }

})();

(function () {
    'use strict';

    angular
        .module('app.pipeline.processamento.pipelineNegocio')
        .controller('PipelineNegocioResultadoDialogController', PipelineNegocioResultadoDialogController);

    function PipelineNegocioResultadoDialogController(
        $mdDialog,
        Parametros,
        Api,
        RequisicaoGenericaService,
        MdToastService,
        PipelineNegocioFactory
    ) {

        var vm = this;

        init();

        function init() {
            vm.form = {};
            vm.titulo = "Negócio";
            vm.executouAcao = false;
            vm.requisicaoSolicitada = false;
            vm.mensagemPreloader = "";
            vm.resultado = angular.copy(Parametros[0]);
            vm.dataAtual = new Date();
            vm.dataInicial = new Date(vm.resultado.dataInicioNegocio)

            if (vm.resultado.status == 2)
                listarMotivosPerda();
        }

        vm.metodos = {
            salvar: salvar,
            cancelar: cancelar,
            funcaoCancelamento: Parametros[1],
            fecharDialog: fecharDialog
        };

        function listarMotivosPerda() {
            vm.requisicaoSolicitada = true;
            vm.mensagemPreloader = "Carregando motivos de perda";

            RequisicaoGenericaService.listarSemParams(
                Api.pipeline.pipeline_motivoperdanegocio.listarMoticosPerda)
                .then(function (success) {
                    vm.requisicaoSolicitada = false;
                    vm.mensagemPreloader = "";
                    vm.motivosPerda = success.data;
                },
                    function (error) {
                        vm.requisicaoSolicitada = false;
                        vm.mensagemPreloader = "";
                        ServicosGenericoService.exibirAlertaDeErro(error, event);
                    });
        }
        /**
         * Método chamado quando o botão salvar é pressionado, assim verificando se será uma inserção ou uma edição
         * @param {event} event event
         * @param {object} modelo 
         */

        function salvar(event) {
            vm.requisicaoSolicitada = true;
            vm.executouAcao = true;

            RequisicaoGenericaService.salvar(
                Api.pipeline.pipeline_negocio.resultado.finalizarNegocio, vm.resultado)
                .then(function (success) {
                    MdToastService.toastPadrao("Negócio finalizado com sucesso!");
                    vm.requisicaoSolicitada = false;
                    vm.mensagemPreloader = "";

                    PipelineNegocioFactory.limparFiltrosCardRedefinindoEtapasFunil();
                    vm.metodos.fecharDialog();
                },
                    function (error) {
                        vm.requisicaoSolicitada = false;
                        vm.mensagemPreloader = "";
                        vm.metodos.funcaoCancelamento();
                        ServicosGenericoService.exibirAlertaDeErro(error, event);
                        vm.metodos.fecharDialog();
                    });
        }

        function cancelar(event) {
            vm.executouAcao = true;
            vm.metodos.funcaoCancelamento();
            vm.metodos.fecharDialog();
        }

        function fecharDialog() {
            if (!vm.executouAcao) {
                vm.metodos.funcaoCancelamento();
            }

            $mdDialog.hide();
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.pipeline.processamento.pipelineNegocio')
        .controller('PipelineNegocioExternosDialogController', PipelineNegocioExternosDialogController);

    function PipelineNegocioExternosDialogController(
        $mdDialog,
        $rootScope,
        Parametros,
        PipelineNegocioService,
        ServicosGenericoService,
        Api,
        RequisicaoGenericaService,
        MdToastService,
        RotasHtml,
        DatatableFactory,
        MdDialogService,
        LoginUsuarioService
    ) {

        var vm = this;
        var codigoNegocio = Parametros[0];
        var codigoFunil = Parametros[1];
        // tipo edicao: 1: total, 2: somente edicao, 3: desabilitada
        var tipoEdicao = Parametros[2];
        var _callbackCriacaoEntidade = Parametros[3];
        var _callbackEdicaoEntidade = Parametros[4];
        var _callbackExclusaoEntidade = Parametros[5];
        var codigoEtapaAtual;
        var codigousuarioLogado = LoginUsuarioService.usuarioArmazenado().codigo;
        vm.usuario = Parametros[7];
        vm.funis = Parametros[8];
        if (vm.funis) {
            vm.funil = vm.funis.filter(function (item) {
                if (item.codigo == Parametros[1])
                    return item;
            })[0].descricao;
        }

        init();

        var metodosInterno = {
            construirDtOptions: _construirDtOptions,
            listarProdutosPorFunil: _listarProdutosPorFunil,
            listarExecutivosResponsaveis: _listarExecutivosResponsaveis,
            limparNegocioDoAtendimento: _limparNegocioDoAtendimento,
            listarHistoricoNegocio: _listarHistoricoNegocio,
            listarTodosAtendimentoCliente: _listarTodosAtendimentoCliente,
            listarEtapasPorFunil: _listarEtapasPorFunil,
            pesquisarNegocio: _pesquisarNegocio,
            callbackCriacaoEntidade: _callbackCriacaoEntidade,
            callbackEdicaoEntidade: _callbackEdicaoEntidade,
            callbackExclusaoEntidade: _callbackExclusaoEntidade
        }
        vm.metodos = {
            fecharDialog: fecharDialog,
            tabSelecionada: tabSelecionada,
            configuraAutoCompleteClienteOnBlur: configuraAutoCompleteClienteOnBlur,
            pesquisarAutoCompleteCliente: pesquisarAutoCompleteCliente,
            alterarItemSelecionadoAutoCompleteCliente: alterarItemSelecionadoAutoCompleteCliente,
            configuraMdSelectProduto: configuraMdSelectProduto,
            configuraMdSelectFunil: configuraMdSelectFunil,
            configuraMdSelectAtendimento: configuraMdSelectAtendimento,
            configurarMdSelectAtendimentoOnClose: configurarMdSelectAtendimentoOnClose,
            reagendarDataFinalEtapa: reagendarDataFinalEtapa,
            atualizarDataFinalQuandoInserindo: atualizarDataFinalQuandoInserindo,
            listarAssuntoAtendimento: listarAssuntoAtendimento,
            selecionarAtendimento: selecionarAtendimento,
            verificarExecutivoContas: verificarExecutivoContas,
            atualizarEtapaAtualNegocio: atualizarEtapaAtualNegocio,
            excluir: excluir,
            alterarFunilNegocio: alterarFunilNegocio
        };

        function init() {
            vm.form = {};
            vm.titulo = "Negócio";
            vm.mensagemPreloader = "";
            vm.htmlRota = RotasHtml.pipeline_negocio;
            vm.requisicaoSolicitada = false;
            vm.tabSelecionada = "negocio";

            vm.produtos = [];
            vm.executivosResponsaveis = [];
            vm.atendimentos = [];
            vm.etapaAtual;

            vm.tipoEdicao = tipoEdicao;
            vm.novaEntidade = angular.isUndefined(codigoNegocio);

            vm.dtOptions = _construirDtOptions();

            _pesquisarNegocio(codigoNegocio);
        }

        $rootScope.$on('AlteracaoFunil', function (eventoHub, item) {
            if (!item)
                return;

            vm.negocio.produtos = [];
            vm.funil = angular.copy(item).descricao;
            _listarProdutosPorFunil(item.codigo)
            _listarFunis(item.codigo, null);
            vm.etapaAtual = null;
        });

        function fecharDialog() {
            $mdDialog.hide();
        }

        function tabSelecionada(tab) {
            vm.pesquisar = "";
            vm.tabSelecionada = tab;
            if (tab === "dadosHistorico") {
                _listarHistoricoNegocio();
            }

            if (tab === "dadosHistoricoFunil") {
                _listarHistoricoFunil();
            }
        }

        function configuraAutoCompleteClienteOnBlur() {
            if (!vm.negocio.cliente)
                vm.textoDePesquisaAutoCompleteCliente = "";
        }

        function pesquisarAutoCompleteCliente(query) {
            return ServicosGenericoService.pesquisarAutoCompleteCodigoOuNomeGenericoApi(Api.cliente.listarCodigoDescricao, query);
        }

        function alterarItemSelecionadoAutoCompleteCliente(item) {
            if (item) {
                vm.negocio.codigoCliente = item.codigo;
                if (vm.novaEntidade && vm.negocio.cliente.usuarioResponsavel) {
                    vm.negocio.codigoExecutivoContasResponsavel = vm.negocio.cliente.usuarioResponsavel.codigo;
                }

            } else {
                vm.textoDePesquisaAutoCompleteCliente = "";
                vm.negocio.codigoCliente = null;
                vm.negocio.cliente = null;
                vm.negocio.codigoExecutivoContasResponsavel = null;
            }
        }

        function configuraMdSelectProduto() {
            vm.filtrarProdutos = "";
            angular.element('#pipeline-negocio-dialog-produto-md-select').on('keydown', function (ev) {
                ev.stopPropagation();
            });
        }

        function configuraMdSelectFunil() {
            vm.filtrarFunil = "";
            angular.element('#pipeline-negocio-dialog-funil-md-select').on('keydown', function (ev) {
                ev.stopPropagation();
            });
        }

        function configuraMdSelectAtendimento() {
            vm.filtrarAtendimentos = "";
            angular.element('#pipeline-negocios-atendimento-md-select').on('keydown', function (ev) {
                ev.stopPropagation();
            });

            if (vm.negocio.codigoCliente)
                _listarTodosAtendimentoCliente(vm.negocio.codigoCliente);
        }

        function configurarMdSelectAtendimentoOnClose() {
            vm.filtrarAtendimentos = "";
        }

        /**
         * Método para reagender a data final da etapa através do botão de reagendamento
        */
        function reagendarDataFinalEtapa(event, strDataFinalEtapa) {
            var umDia = 1000 * 60 * 60 * 24;
            var dataAtual = new Date(Date.now())
            dataAtual.setHours(0);
            dataAtual.setMinutes(0);
            dataAtual.setSeconds(0);

            var dataFinalEtapa = new Date(strDataFinalEtapa);
            dataFinalEtapa.setHours(0);
            dataFinalEtapa.setMinutes(0);
            dataFinalEtapa.setSeconds(0);

            var dataAtualizada = new Date(new Date(dataAtual).setDate(dataAtual.getDate() + vm.etapaAtual.periodo))
            var diasParaReagendamento = Math.round((dataFinalEtapa - dataAtual) / umDia);

            // Se o a data mínima não for atingida será exibida um alerta para o usuário e a data não será alterada
            if (diasParaReagendamento >= vm.etapaAtual.limiteDiasSemContato) {
                MdDialogService.alertPadrao("Não é possível alterar a data de vencimento da etapa, pois o prazo mínimo ainda não foi atingido.");
                return;
            }
            else {
                vm.negocio.dataFinalEtapa = dataAtualizada;
            }
        }

        function atualizarDataFinalQuandoInserindo(dataInicio) {
            if (dataInicio) {
                var data = new Date(dataInicio).setDate(dataInicio.getDate() + vm.etapaAtual.periodo);
                vm.negocio.dataFinalEtapa = new Date(data);
            }
            else
                vm.negocio.dataFinalEtapa = null;
        }

        function atualizarEtapaAtualNegocio(tarefa) {
            if (tarefa) {
                vm.subprocesso.dataInicial = null;
                vm.subprocesso.dataFinalTarefa = null;
            }
        }

        function listarAssuntoAtendimento(assunto) {
            if (assunto) {
                if (assunto.length < 130)
                    return assunto
                else
                    return assunto.substring(0, 130) + "...";
            }
        }

        function selecionarAtendimento(atendimento) {
            if (atendimento) {
                vm.negocio.codigoAtendimento = atendimento.codigo;
                vm.negocio.anoAtendimento = atendimento.ano;
            }
        }

        /**
         * Método que irá excluir um negócio do pipeline
         * @param {event} event
         * @param {object} modelo vm.negocio
         */
        function excluir(event, modelo) {
            MdDialogService.confirmPadraoComEvento("Deseja realmente excluir este negócio ?", "", event, eventoSim, null)

            function eventoSim() {
                vm.requisicaoSolicitada = true;
                vm.mensagemPreloader = "Excluindo negócio...";

                RequisicaoGenericaService.excluir(Api.pipeline.pipeline_negocio.excluir, modelo.codigo).then(
                    function (success) {
                        MdToastService.toastPadrao("Negócio excluído com sucesso!");
                        vm.requisicaoSolicitada = false;
                        vm.mensagemPreloader = "";
                        if (metodosInterno.callbackExclusaoEntidade)
                            metodosInterno.callbackExclusaoEntidade();
                        fecharDialog();
                    },
                    function (error) {
                        ServicosGenericoService.exibirAlertaDeErro(error, event);
                        vm.requisicaoSolicitada = false;
                        vm.mensagemPreloader = "";
                    });
            }
        }

        function alterarFunilNegocio(event) {
            MdDialogService.abrirDialogPadrao(event, 'DialogEdicaoFunilController',
                vm.htmlRota.dialogs.dialogEdicaoFunil.templateUrl,
                [vm.funis],
                true);
        }

        function verificarExecutivoContas(event, modelo) {

            if (modelo.cliente.codigoUsuario) {
                if (modelo.codigoExecutivoContasResponsavel != modelo.cliente.codigoUsuario &&
                    modelo.codigoExecutivoContasResponsavel != codigousuarioLogado) {

                    MdDialogService.confirmPadraoComEvento(
                        "Atenção!",
                        "O executivo de contas responsável selecionado difere do informado no cadastro de cliente e do usuário logado. " +
                        "Deseja realmente salvar?",
                        event,
                        function () {
                            _salvar(event, modelo)
                        },
                        null);
                } else if (modelo.codigoExecutivoContasResponsavel != modelo.cliente.codigoUsuario) {

                    MdDialogService.confirmPadraoComEvento(
                        "Atenção!",
                        "O executivo de contas responsável selecionado difere do informado no cadastro de cliente. Deseja realmente salvar?",
                        event,
                        function () {
                            _salvar(event, modelo)
                        },
                        null);
                } else if (modelo.codigoExecutivoContasResponsavel != codigousuarioLogado) {
                    MdDialogService.confirmPadraoComEvento(
                        "Atenção!",
                        "O executivo de contas responsável difere do usuário logado. Deseja realmente salvar?",
                        event,
                        function () {
                            _salvar(event, modelo)
                        },
                        null);
                } else {
                    _salvar(event, modelo);
                }

            } else if (modelo.codigoExecutivoContasResponsavel != codigousuarioLogado) {
                MdDialogService.confirmPadraoComEvento(
                    "Atenção!",
                    "O executivo de contas responsável difere do usuário logado. Deseja realmente salvar?",
                    event,
                    function () {
                        _salvar(event, modelo)
                    },
                    null);
            } else {
                _salvar(event, modelo);
            }
        }

        function _salvar(event, modelo) {
            if (vm.novaEntidade)
                _criarEntidade(event, modelo);
            else
                _editarEntidade(event, modelo);
        }

        /**
         * Método para criar um novo negócio
         * @param {event} event Event
         * @param {object} modelo vm.negocio
         */
        function _criarEntidade(event, modelo) {
            modelo.codigoEtapaAtual = vm.etapaAtual.codigo;
            modelo.naoAtualizarEtapaNegocio = true;
            vm.requisicaoSolicitada = true;
            vm.mensagemPreloader = "Cadastrando novo negócio ..."
            RequisicaoGenericaService.salvar(Api.pipeline.pipeline_negocio.criar, modelo).then(
                function (success) {
                    MdToastService.toastPadrao("Negócio cadastrado com sucesso!");
                    vm.requisicaoSolicitada = false;
                    vm.mensagemPreloader = "";
                    if (metodosInterno.callbackCriacaoEntidade)
                        metodosInterno.callbackCriacaoEntidade(vm.etapaAtual);
                    fecharDialog();
                },
                function (error) {
                    vm.requisicaoSolicitada = false;
                    vm.mensagemPreloader = "";
                    ServicosGenericoService.exibirAlertaDeErro(error, event);
                });
        }

        /**
         * Método para editar um negócio
         * @param {event} event
         * @param {object} modelo vm.negocio
         */
        function _editarEntidade(event, modelo) {
            if (vm.funil) {
                modelo.codigoFunil = vm.funil.codigo;
            }
            modelo.codigoUsuarioLogado = LoginUsuarioService.usuarioArmazenado().codigo;
            modelo.codigoEtapa = vm.etapaAtual.codigo;
            vm.requisicaoSolicitada = true;
            vm.mensagemPreloader = "Atualizando negócio..."

            RequisicaoGenericaService.editar(Api.pipeline.pipeline_negocio.atualizar, modelo).then(
                function (success) {
                    MdToastService.toastPadrao("Negócio atualizado com sucesso!");
                    vm.requisicaoSolicitada = false;
                    vm.mensagemPreloader = "";
                    vm.negocio = success.data;
                    if (vm.etapaModificada) {
                        vm.requisicaoSolicitada = true;
                        vm.mensagemPreloader = "Atualizando etapa do negócio..."
                        PipelineNegocioService.atualizarEtapa(vm.negocio.codigo, vm.etapaAtual.codigo).then(
                            function (success) {
                                vm.negocio.dataFinalEtapa = success.data.dataFinalEtapa;

                                if (metodosInterno.callbackEdicaoEntidade)
                                    metodosInterno.callbackEdicaoEntidade(vm.negocio, vm.etapaAtual, vm.etapaModificada);

                                vm.requisicaoSolicitada = false;
                                vm.mensagemPreloader = "";

                                fecharDialog();
                            },
                            function (error) {
                                vm.requisicaoSolicitada = false;
                                vm.mensagemPreloader = "";
                            });
                    }
                    else {
                        if (metodosInterno.callbackEdicaoEntidade)
                            metodosInterno.callbackEdicaoEntidade(vm.negocio);

                        fecharDialog();
                    }
                },
                function (error) {
                    vm.requisicaoSolicitada = false;
                    ServicosGenericoService.exibirAlertaDeErro(error, event);
                })
        }

        function _construirDtOptions() {
            return DatatableFactory.construirDtOptionsComPaginacaoResponsivoPadrao([
                DatatableFactory.construirColunaAcaoPadrao(0)
            ]);
        }

        function _listarProdutosPorFunil(codigoFunil) {
            vm.mensagemPreloader = "Carregando produtos...";
            var success = function (success) {
                vm.produtos = success;
            };

            var error = function (error) {
                vm.requisicaoSolicitada = false;
                vm.mensagemPreloader = "";
                ServicosGenericoService.exibirAlertaDeErro(error, event);
            };

            PipelineNegocioService.listarProdutosPorFunil(codigoFunil,
                success, error);
        }

        function _listarExecutivosResponsaveis() {
            vm.mensagemPreloader = "Carregando executivos responsáveis...";

            RequisicaoGenericaService.listarSemParams(Api.usuario.listarTodosUsuariosSetorComercial).then(
                function (success) {
                    vm.executivosResponsaveis = success.data;
                },
                function (error) {
                    vm.requisicaoSolicitada = false;
                    vm.mensagemPreloader = "";
                    ServicosGenericoService.exibirAlertaDeErro(error, event);
                });
        }

        function _limparNegocioDoAtendimento() {
            vm.atendimento = null;
            vm.atendimentos = null;
            vm.negocio.codigoAtendimento = null;
            vm.negocio.anoAtendimento = null;
        }

        function _listarHistoricoNegocio() {
            vm.requisicaoSolicitada = true;
            vm.mensagemPreloader = "Carregando histórico do negócio...";

            RequisicaoGenericaService.listarSemParams(Api.pipeline.pipeline_negocio.historico.listarHistoricoDataTable + vm.negocio.codigo).then(
                function (success) {
                    vm.requisicaoSolicitada = false;
                    vm.mensagemPreloader = "";
                    vm.historicoNegocio = success.data;
                },
                function (error) {
                    vm.requisicaoSolicitada = false;
                    vm.mensagemPreloader = "";
                    ServicosGenericoService.exibirAlertaDeErro(error, event);
                });
        }

        function _listarHistoricoFunil() {
            vm.requisicaoSolicitada = true;
            vm.mensagemPreloader = "Carregando histórico do negócio...";

            RequisicaoGenericaService.listarSemParams(Api.pipeline.pipeline_historico_funil.listarPorCodigoNegocio + vm.negocio.codigo).then(
                function (success) {
                    vm.requisicaoSolicitada = false;
                    vm.mensagemPreloader = "";
                    vm.historicoFunil = success.data;
                },
                function (error) {
                    vm.requisicaoSolicitada = false;
                    vm.mensagemPreloader = "";
                    ServicosGenericoService.exibirAlertaDeErro(error, event);
                });
        }

        function _listarTodosAtendimentoCliente(codigoCliente) {
            if ((!vm.atendimentos || vm.atendimentos.length == 0) && codigoCliente) {
                var atendimento = {
                    codigoCliente: codigoCliente
                };

                vm.requisicaoSolicitada = true;

                vm.mensagemPreloader = "Carregando atendimentos do cliente..."
                RequisicaoGenericaService.listarComParams(Api.atendimento.listarDetalhesAtendimentos, atendimento).then(
                    function (success) {
                        vm.atendimentos = success.data;

                        vm.atendimento = vm.atendimentos.find(function (atendimento) {
                            return (atendimento.codigo == vm.negocio.codigoAtendimento && atendimento.ano == vm.negocio.anoAtendimento);
                        });

                        vm.requisicaoSolicitada = false;
                        vm.mensagemPreloader = "";
                    },
                    function (error) {
                        vm.requisicaoSolicitada = false;
                        vm.mensagemPreloader = "";
                        ServicosGenericoService.exibirAlertaDeErro(error, event);
                    });
            }
        }

        function _retornarCodigoEtapaAtual(codigoNegocio) {
            vm.mensagemPreloader = "Carregando etapa atual...";

            RequisicaoGenericaService.listarSemParams(Api.pipeline.pipeline_negocio.retornarCodigoEtapaAtual + codigoNegocio).then(
                function (success) {
                    codigoEtapaAtual = success.data;
                },
                function (error) {
                    vm.requisicaoSolicitada = false;
                    vm.mensagemPreloader = "";
                    ServicosGenericoService.exibirAlertaDeErro(error, event);
                });
        }

        function _listarEtapasPorFunil(codigoFunil) {
            vm.mensagemPreloader = "Carregando etapas...";

            _listarFunis(codigoFunil, function () {
                vm.etapasFunil.forEach(function (item, value) {
                    if (item.codigo == codigoEtapaAtual) {
                        vm.etapaAtual = item;
                    }
                })
            })
        }

        function _listarFunis(codigoFunil, executar) {
            vm.mensagemPreloader = "Carregando etapas...";

            RequisicaoGenericaService.listarSemParams(Api.pipeline.pipeline_etapa.listarEtapasPorFunil + codigoFunil).then(
                function (success) {

                    var etapas = success.data || [];

                    var possuiClienteOuProduto =
                        vm.negocio &&
                        (
                            vm.negocio.codigoCliente ||
                            (vm.negocio.produtos && vm.negocio.produtos.length > 0)
                        );

                    var codigoEtapaVinculada =
                        vm.negocio &&
                        (vm.negocio.codigoEtapa || vm.negocio.codigoEtapaAtual);

                    if (!possuiClienteOuProduto) {
                        vm.etapasFunil = etapas.filter(function (item) {
                            return item.ativo === true;
                        });
                    } else {
                        vm.etapasFunil = etapas.filter(function (item) {
                            return item.ativo === true || item.codigo === codigoEtapaVinculada;
                        });
                    }

                    if (executar)
                        executar();

                },
                function (error) {
                    vm.requisicaoSolicitada = false;
                    vm.mensagemPreloader = "";
                    ServicosGenericoService.exibirAlertaDeErro(error, event);
                });
        }

        function _pesquisarNegocio(codigoNegocio) {
            vm.requisicaoSolicitada = true;
            vm.mensagemPreloader = "Carregando negócio...";

            if (!codigoNegocio) {
                _listarExecutivosResponsaveis();
                _listarProdutosPorFunil(codigoFunil);
                _listarEtapasPorFunil(codigoFunil);
                vm.requisicaoSolicitada = false;
                vm.mensagemPreloader = "";
            }
            else {
                _retornarCodigoEtapaAtual(codigoNegocio);

                RequisicaoGenericaService.listarSemParams(Api.pipeline.pipeline_negocio.listarPorCodigo + codigoNegocio).then(
                    function (success) {
                        var negocioTemp = angular.copy(success.data);

                        vm.negocio = angular.copy(success.data);

                        _listarExecutivosResponsaveis();
                        _listarProdutosPorFunil(codigoFunil);
                        _listarEtapasPorFunil(codigoFunil);
                        _listarTodosAtendimentoCliente(negocioTemp.codigoCliente);
                        vm.requisicaoSolicitada = false;
                        vm.mensagemPreloader = "";
                    },
                    function (error) {
                        vm.requisicaoSolicitada = false;
                        vm.mensagemPreloader = "";

                        ServicosGenericoService.exibirAlertaDeErro(error, event);
                    });
            }
        }
    }
})();

/**
 * Created by nova on 28/03/2017.
 */
(function () {
    'use strict';

    angular.module('app.pipeline.processamento.pipelineNegocio')
        .controller('PipelineFunisController', PipelineFunisController);

    function PipelineFunisController(ListarTodosFunis, NavegacaoService, PipelineNegocioFactory, $stateParams, RotasHtml, MdDialogService) {
        var vm = this;
        NavegacaoService.setTituloAba('Pipeline funil');

        var rotasHtml = RotasHtml.pipeline_negocio;

        var metodosInterno = {
            init: _init,
            abrirDialogNegociosVencidosExecutivo: _abrirDialogNegociosVencidosExecutivo
        }
        vm.metodos = {
            exibirDescricao: exibirDescricao
        };

        _init()

        //#region  Métodos Interno

        function _init() {
            vm.funis = ListarTodosFunis.data;
            PipelineNegocioFactory.redefinirEtapasFunilFiltro();

            if ($stateParams.existeNegociosVencidos)
                _abrirDialogNegociosVencidosExecutivo();
        }

        function _abrirDialogNegociosVencidosExecutivo() {
            var parametros = [];
            MdDialogService.abrirDialogPadrao(event, 'NegociosVencidosExecutivoResponsavel',
                rotasHtml.dialogs.dialogNegociosVencidosExecutivoResponsavel, parametros, false);
        }
        //#endregion

        //#region Métodos
        function exibirDescricao(descricao) {
            return descricao.length <= 23 ? descricao : descricao.substring(0, 23) + "..."
        }
        //#endregion             
    }
})();

(function () {
    'use strict';

    angular.module('app.pipeline.processamento.pipelineNegocio')
        .controller('PipelineNegociosController', PipelineNegociosController);

    function PipelineNegociosController($filter, $mdSidenav, $stateParams, Api, RequisicaoGenericaService, ListarEtapasPorFunil, PipelineNegocioFactory,
        PipelineNegocioService, NavegacaoService, ListarFunis, MdDialogService, RotasHtml, msUtils, $scope, ServicosGenericoService) {
        var vm = this;
        NavegacaoService.setTituloAba('Pipeline negócios');

        vm.form = {};
        vm.rotasHtml = RotasHtml.pipeline_negocio;
        vm.funis = ListarFunis.data;

        init();

        var metodosInterno = {
            inicializarOpcoesCard: inicializarOpcoesCard
        };
        vm.metodos = {
            toggleSidenav: toggleSidenav,
            abrirDialogExibirAtividadesEtapa: abrirDialogExibirAtividadesEtapa,
            abrirDialogNegocio: abrirDialogNegocio
        };
        vm.metodosPipelineService = {
            verificarData: PipelineNegocioService.verificarDataVencida,
            navegarParaAtendimento: PipelineNegocioService.navegarParaAtendimento
        };
        vm.metodosPipelineFactory = {
            exibirButtonLimparFiltros: PipelineNegocioFactory.exibirButtonLimparFiltros,
            limparFiltrosCard: PipelineNegocioFactory.limparFiltrosCardRedefinindoEtapasFunil
        };

        vm.etapasFiltradasPorProduto = [];

        $scope.$watchCollection(function () { return PipelineNegocioFactory.filtrosCard.produtosFiltros; }, function (newVal, oldVal) {
            if (newVal !== oldVal) {
                atualizarCardsPorProduto();
            }
        });

        $scope.$watchCollection(function () { return PipelineNegocioFactory.etapasFunil; }, function (newVal, oldVal) {
            atualizarCardsPorProduto();
        });

        $scope.$watchGroup([
            function () { return PipelineNegocioFactory.filtrosCard.valorDe; },
            function () { return PipelineNegocioFactory.filtrosCard.valorAte; }
        ], function (newVal, oldVal) {
            if (newVal !== oldVal) {
                atualizarCardsPorProduto();
            }
        });

        function atualizarCardsPorProduto() {
            if (
                (!PipelineNegocioFactory.filtrosCard.produtosFiltros || PipelineNegocioFactory.filtrosCard.produtosFiltros.length === 0) &&
                (PipelineNegocioFactory.filtrosCard.valorDe == null && PipelineNegocioFactory.filtrosCard.valorAte == null)
            ) {
                vm.etapasFiltradasPorProduto = PipelineNegocioFactory.etapasFunil;
            } else {
                vm.etapasFiltradasPorProduto = PipelineNegocioFactory.filtrarNegociosPorProduto();
            }
        }

        function init() {
            vm.descricaoFunil = $stateParams.funilDescricao;
            vm.etapasFunil = PipelineNegocioFactory.etapasFunil;
            vm.filtrosCard = PipelineNegocioFactory.filtrosCard;
            vm.etapasFunilFiltro = PipelineNegocioFactory.etapasFunilFiltro;

            vm.resultadosNegocio = [
                {
                    codigo: 0,
                    descricao: "Negócio ganho",
                    negocios: []
                },
                {
                    codigo: 1,
                    descricao: "Negócio perdido",
                    negocios: []
                }
            ];

            inicializarOpcoesCard();
            PipelineNegocioFactory.carregarEtapasFunil(ListarEtapasPorFunil.data);
            PipelineNegocioFactory.limparFiltrosCard();
            PipelineNegocioFactory.carregarClientesEColaboradoresResponsaveis(ListarEtapasPorFunil.data);

            atualizarCardsPorProduto();
        }

        function inicializarOpcoesCard() {
            var etapaTemporaria = [];
            vm.arrastandoNegocio = false;

            vm.sortableCardOptions = PipelineNegocioFactory.configurarCardOptions();
            vm.sortableCardOptions.tolerance = "intersect";
            vm.sortableCardOptions.start = function (e, ui) {
                etapaTemporaria = angular.copy(vm.etapasFunil);
                $scope.$apply(function () {
                    vm.arrastandoNegocio = true;
                });
            }

            vm.sortableCardOptions.stop = function (e, ui) {
                $scope.$apply(vm.arrastandoNegocio = false);
            }

            vm.sortableCardOptions.update = function (e, ui) {
                var etapaAtualNegocio;
                vm.etapasFunil.map(function (list) {
                    list.negocios.map(function (cardId) {
                        if (ui.item.sortable.model.codigo == cardId.codigo && ui.item.sortable.received) {
                            etapaAtualNegocio = list;
                        }
                    });
                });

                if (etapaAtualNegocio) {
                    PipelineNegocioService.atualizarEtapa(ui.item.sortable.model.codigo, etapaAtualNegocio.codigo).then(
                        function (success) {
                            PipelineNegocioService.atualizarNegocio(vm.etapasFunil, success.data);
                        },
                        function (error) {
                            PipelineNegocioFactory.carregarEtapasFunil(etapaTemporaria);
                        });
                }
            };

            vm.sortableResultadoNegocio = PipelineNegocioFactory.configurarCardOptions();
            vm.sortableResultadoNegocio.tolerance = "intersect";
            vm.sortableResultadoNegocio.start = function (e, ui) {
                $scope.$apply(function () {
                    vm.arrastandoNegocio = true;
                });
            }

            vm.sortableResultadoNegocio.over = function (e, ui) {
                var elementoAlvo = angular.element(e.target).closest('.list');
                elementoAlvo.addClass('drag-over');
            }

            vm.sortableResultadoNegocio.out = function (e, ui) {
                var elementoAlvo = angular.element(e.target).closest('.list');
                elementoAlvo.removeClass('drag-over');
            }

            vm.sortableResultadoNegocio.update = function (e, ui) {
                angular.element('.list').removeClass('drag-over');

                var negocioGanho = vm.resultadosNegocio[0].negocios[0];
                var negocioPerdido = vm.resultadosNegocio[1].negocios[0];

                var resultado = {
                    codigoPipelineNegocio: null,
                    status: 0,
                    codigoPipelineMotivoPerdaNegocio: null,
                    data: new Date(),
                    observacao: "",
                    dataInicioNegocio: null
                };

                if (negocioGanho) {
                    resultado.codigoPipelineNegocio = negocioGanho.codigo;
                    resultado.status = 1;
                    resultado.dataInicioNegocio = negocioGanho.dataInicial;
                }
                else if (negocioPerdido) {
                    resultado.codigoPipelineNegocio = negocioPerdido.codigo;
                    resultado.status = 2;
                    resultado.dataInicioNegocio = negocioPerdido.dataInicial;
                }
                else {
                    return;
                }

                var funcaoCancelamento = function () {
                    PipelineNegocioFactory.carregarEtapasFunil(etapaTemporaria);
                };

                var parametros = [resultado, funcaoCancelamento];
                MdDialogService.abrirDialogPadrao(event, 'PipelineNegocioResultadoDialogController',
                    vm.rotasHtml.dialogs.dialogPipelineNegocioResultado, parametros, false);

                vm.resultadosNegocio[0].negocios = [];
                vm.resultadosNegocio[1].negocios = [];
            };
        }

        function toggleSidenav(sidenavId) {
            $mdSidenav(sidenavId).toggle();
        }

        function abrirDialogExibirAtividadesEtapa(event, atividadesEtapa) {
            var parametros = [atividadesEtapa];
            MdDialogService.abrirDialogPadrao(event, 'PipelineEtapaAtividadeInformativoController',
                vm.rotasHtml.dialogs.dialogInformativoAtividadesEtapa, parametros);
        }

        function abrirDialogNegocio(event, negocio, etapa) {
            var codigoNegocio = undefined;
            var executivoContas = undefined;

            if (negocio) {
                codigoNegocio = negocio.codigo;

                executivoContas = {
                    codigo: negocio.codigoExecutivoContasResponsavel,
                    nome: negocio.nomeColaboradorResponsavel
                };
            }

            var codigoEtapa = undefined;

            if (etapa)
                codigoEtapa = etapa.codigo;

            var callbackCriacaoNegocio = function (etapaAtual) {
                vm.etapasFunil.map(
                    function (item) {
                        if (item.codigo == etapaAtual.codigo)
                            item.negocios.push(etapaAtual);
                    });
            }

            var callbackEdicaoNegocio = function (negocioDialog, etapaAtual, etapaModificada) {
                negocio.codigo = negocioDialog.codigo;
                negocio.codigoCliente = negocioDialog.codigoCliente;
                negocio.valor = negocioDialog.valor;
                negocio.outrosValores = negocioDialog.outrosValores;
                negocio.dataFinalEtapa = negocioDialog.dataFinalEtapa;
                negocio.dataInicial = negocioDialog.dataInicial;
                negocio.codigoAtendimento = negocioDialog.codigoAtendimento;
                negocio.anoAtendimento = negocioDialog.anoAtendimento;
                negocio.nomeCliente = negocioDialog.nomeCliente;
                negocio.nomeColaboradorResponsavel = negocioDialog.nomeColaboradorResponsavel;
                negocio.produtos = negocioDialog.produtos;

                if (etapaModificada)
                    PipelineNegocioService.atualizarEtapaNegocio(vm.etapasFunil, etapaAtual, negocioDialog);

                var hasFiltroCliente = vm.filtrosCard.clientesFiltros && vm.filtrosCard.clientesFiltros.length > 0;
                var hasFiltroExecutivo = vm.filtrosCard.colaboradoresResponsaveisFiltrados && vm.filtrosCard.colaboradoresResponsaveisFiltrados.length > 0;

                if (hasFiltroCliente || hasFiltroExecutivo) {
                    PipelineNegocioFactory.pesquisarEtapasFunil(vm.etapasFunilFiltro).then(function () {
                        atualizarCardsPorProduto();
                    });
                } else {
                    atualizarCardsPorProduto();
                }
            }

            var callbackExclusaoNegocio = function () {
                PipelineNegocioService.removerNegocioDaEtapa(vm.etapasFunil, negocio);
            }

            var parametros = [codigoNegocio, $stateParams.codigoFunil, 1, callbackCriacaoNegocio,
                callbackEdicaoNegocio, callbackExclusaoNegocio, $stateParams.funilDescricao, executivoContas,
                vm.funis];

            MdDialogService.abrirDialogPadrao(event, 'PipelineNegocioExternosDialogController',
                vm.rotasHtml.dialogs.dialogPipelineNegocio.templateUrl, parametros);
        }
    }
})();
/**
 * Created by nova on 28/03/2017.
 */
(function () {
    'use strict';

    angular
        .module('app.pipeline.consulta.estatistica', ['nvd3'])
        .config(config);

    function config($stateProvider, RotasHtml) {
        var rotasHtml = RotasHtml.pipeline_consulta.estatistica;
        $stateProvider
            .state('app.pipeline_consulta_estatistica', {
                url: '/pipeline/consulta/estatisticas',
                module: 'privado',
                views: {
                    'content@app': {
                        templateUrl: rotasHtml.templateUrl,
                        controller: "PipelineConsultaEstatisticaController as vm"
                    },
                    'dashboard-estatisticas@app.pipeline_consulta_estatistica': {
                        templateUrl: rotasHtml.dashboard_estatisticas,
                    }
                },
                bodyClass: 'pipeline-consulta-estatistica',
                resolve: {
                    ListarFunisAtivos: function (Api, RequisicaoGenericaService) {
                        return RequisicaoGenericaService.listarSemParams(Api.pipeline.pipeline_funil.listarAtivos);
                    },
                    ListarUsuariosSetorComercial: function (Api, RequisicaoGenericaService) {
                        return RequisicaoGenericaService.listarSemParams(Api.usuario.listarUsuariosSetorComercial);
                    },
                    ListarProdutosPorFunil: function (Api, RequisicaoGenericaService, ListarFunisAtivos) {
                        return RequisicaoGenericaService.listarSemParams(Api.produto.listarProdutosPorFunil + ListarFunisAtivos.data[0].codigo);
                    },
                }
            });
    }

})();

(function () {
    'use strict';

    angular
        .module('app.pipeline.consulta.estatistica')
        .controller('DetalhamentoNegociosDialogController', DetalhamentoNegociosDialogController);

    function DetalhamentoNegociosDialogController(
        $timeout,
        $filter,
        $state,
        RequisicaoGenericaService,
        $mdDialog,
        DataTableConfigPadrao,
        Parametros,
        MdDialogService,
        RotasHtml
    ) {
        var vm = this;
        var rotasHtml = RotasHtml.pipeline_negocio;
        init();

        vm.metodosDialog = {
            fecharDialog: fecharDialog,
            abrirDialogNegocio: abrirDialogNegocio,
            abrirAtendimeto: abrirAtendimeto
        };


        function init() {
            vm.requisicaoSolicitada = false;
            vm.filtroNegocios = angular.copy(Parametros.filtroCard);
            vm.rota = Parametros.rota;
            vm.titulo = Parametros.titulo;
            vm.permiteEdicao = Parametros.permiteEdicao;
            vm.valorTotal = Parametros.valorTotal;
            vm.totalOutrosValores = Parametros.totalOutrosValores;
            vm.usuario = Parametros.executivo;

            construirDtOptions();
            carregarDados();
        }

        function carregarDados() {
            vm.requisicaoSolicitada = true;
            vm.mensagemPreloader = "Carregando dados ..."

            RequisicaoGenericaService.salvar(vm.rota, vm.filtroNegocios).then(
                function (success) {
                    vm.negocios = success.data;
                    vm.mensagemPreloader = "";
                    vm.requisicaoSolicitada = false;
                },
                function (error) {
                    MdDialogService.alertPadrao(error.data);
                    vm.mensagemPreloader = "";
                    vm.requisicaoSolicitada = false;
                });
        }

        function construirDtOptions() {
            _formataNomesComAcento();
            vm.dtOptions = angular.copy(DataTableConfigPadrao.dtOptionsResponsivoPaginacaoTipoNumberComInitComplete);
            vm.dtOptions.columnDefs = [
                {
                    targets: [1],
                    type: 'portugues'
                },
                {
                    targets: [2],
                    type: 'date-pt-br'
                },
                {
                    targets: [5],
                    render: $.fn.dataTable.render.number('.', ',', 2, 'R$ ')
                },
                {
                    targets: [6],
                    render: $.fn.dataTable.render.number('.', ',', 2, 'R$ ')
                }
            ];
        }

        function abrirAtendimeto(codigo, ano) {
            $state.goNewTab("app.atendimento_processamento_atendimento", {
                parametros: {
                    codigo: codigo,
                    ano: ano,
                    chamarPesquisa: true
                }
            });
        }

        function abrirDialogNegocio(event, negocio, permiteEdicao) {
            var callbackEdicaoNegocio = function () { carregarDados(); }

            var parametros = [negocio.codigo, negocio.codigoFunil, permiteEdicao ? 2 : 3,
                undefined, callbackEdicaoNegocio, undefined, negocio.funil, vm.usuario]
            MdDialogService.abrirDialogPadrao(event, 'PipelineNegocioExternosDialogController',
                rotasHtml.dialogs.dialogPipelineNegocio.templateUrl, parametros);
        }

        function fecharDialog() {
            $mdDialog.hide();
        }

        function _formataNomesComAcento() {
            jQuery.extend(jQuery.fn.dataTableExt.oSort, {
                "portugues-pre": function (data) {
                    var letrasEspeciais = {
                        "Á": "a", "á": "a", "Ã": "a", "ã": "a", "À": "a", "à": "a",
                        "É": "e", "é": "e", "Ê": "e", "ê": "e",
                        "Í": "i", "í": "i", "Î": "i", "î": "i",
                        "Ó": "o", "ó": "o", "Õ": "o", "õ": "o", "Ô": "o", "ô": "o",
                        "Ú": "u", "ú": "u", "Ü": "u", "ü": "u",
                        "ç": "c", "Ç": "c"
                    };
                    data = data.toLowerCase();
                    Object.entries(letrasEspeciais).forEach(function (valor) {
                        var valorEntrada = valor[0];
                        var valorSaida = valor[1];
                        data = data.split(valorEntrada).join(valorSaida);
                    });
                    return data;
                }
            });
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.manutencao.ordem-servico',[])
        .config(Config);

    function Config(
        $stateProvider,
        RotasHtml) {

        var rotaOS = RotasHtml.ordem_servico;

        $stateProvider
            .state('app.manutencao_ordem_servico',{
                url: '/manutencao/ordem-servico',
                module: 'privado',
                params: {
                    parametros: null
                },
                views: {
                    'content@app': {
                        templateUrl: rotaOS.templateUrl,
                        controller: 'OrdemServicoController as vm'
                    },
                    'ordem-servico-form@app.manutencao_ordem_servico': {
                        templateUrl: rotaOS.form
                    }
                    // 'entrada-tabela@app.manutencao_ordem_servico': {
                    //     templateUrl: rotaOS.tabela
                    // }
                },
                resolve: {
                    ListarTodosUsuariosAtivos: function (Api,RequisicaoGenericaService) {
                        return RequisicaoGenericaService.listarSemParams(Api.usuario.detalhes_usuario.listarUsuariosAtivos);
                    },
                    ListarClientes: function (Api,RequisicaoGenericaService) {
                        return RequisicaoGenericaService.listarSemParams(Api.protecao.atualizacaoLicenca.listar);
                    },
                    ListarEmpresaAtivo: function (Api,RequisicaoGenericaLocacaoService) {
                        return RequisicaoGenericaLocacaoService.listarSemParams(Api.locacao.empresaAtiva.listarTodos);
                    },
                    ListarPrioridade: function (Api,RequisicaoGenericaLocacaoService) {
                        return RequisicaoGenericaLocacaoService.listarSemParams(Api.manutencao.prioridade.listarTodos);
                    },
                    ListarTipoServico: function (Api,RequisicaoGenericaLocacaoService) {
                        return RequisicaoGenericaLocacaoService.listarSemParams(Api.manutencao.tipoServico.listarTodos);
                    },
                    // ListarRetornados: function (Api,RequisicaoGenericaLocacaoService) {
                    //     return RequisicaoGenericaLocacaoService.listarSemParams(Api.locacao.nota_item_detalhe.listarLocadosPorContrato)
                    // },
                    ListarTipoProcedimentos: function (Api,RequisicaoGenericaLocacaoService) {
                        return RequisicaoGenericaLocacaoService.listarSemParams(Api.manutencao.tipoProcedimento.listarTodos)
                    },
                    ListarOrigemPecaAtivo: function (Api,RequisicaoGenericaLocacaoService) {
                        return RequisicaoGenericaLocacaoService.listarSemParams(Api.manutencao.origemPeca.listarApenasAtivo)
                    },
                    ListarTipoEnvio: function (Api,RequisicaoGenericaLocacaoService) {
                        return RequisicaoGenericaLocacaoService.listarSemParams(Api.manutencao.tipoEnvio.listarTodos)
                    },
                    ListarTodosMargem: function (Api,RequisicaoGenericaLocacaoService) {
                        return RequisicaoGenericaLocacaoService.listarSemParams(Api.manutencao.margem.listarTodos)
                    }
                }

            });
    }

}());

(function () {
    "use strict";

    angular
        .module("app.manutencao.ordem-servico")
        .controller("DialogOrdemServicoProcedimentoController", DialogOrdemServicoProcedimentoController);

    function DialogOrdemServicoProcedimentoController(
        $mdDialog,
        Pecas,
        Procedimentos,
        DataTableConfigPadrao,
        OrdemVinculada,
        RotasHtml,
        ItemVinculado,
        MdDialogService,
        MdToastService,
        ValidaEquipamentos,
        Api,
        RequisicaoGenericaLocacaoService
    ) {
        var vm = this;
        vm.validaEquipamentos = ValidaEquipamentos;
        vm.ordemVinculada = OrdemVinculada;
        vm.ordensServicosProcedimentos = [];
        vm.oServItemOserProcedimento = [];
        vm.codigosProcedimentosItens = {}
        vm.obj = {};
        vm.rotasHtmlNota = RotasHtml.ordem_servico;
        vm.deixarExluirProcedimento = true;
        vm.pecaObrigatoria = false;
        vm.emProgresso = false;

        init();

        function init() {
            vm.valorTotalSevico = 0;
            vm.dtOptionsProcedimentos = angular.copy(
                DataTableConfigPadrao.dtOptionsResponsivoSemPaginacaoComInitComplete
            );
            vm.dtOptionsProcedimentos.columnDefs = [{
                targets: 0,
                ordering: false,
                responsivePriority: 1,
                filterable: true,
                sortable: false
            },
            {
                targets: 1,
                ordering: false,
                responsivePriority: 1,
                filterable: true,
                sortable: false
            }]
            vm.pecas = Pecas;
            vm.procedimentos = Procedimentos;
            vm.itemVinculado = ItemVinculado;
            if (vm.itemVinculado.equipamentoNotaItemDetalheId != null)
                filtrarProcedimentosPorEquipamento(vm.itemVinculado.equipDetEquipamentoCodigo);
            else
                filtrarProcedimentosPorEquipamento(vm.itemVinculado.osItemEquipamentoCodigo);

            filtrarProcedimentosObrigatórios();
            inicializaPesquisando(vm.itemVinculado.id);
        }

        vm.metodos = {
            cancel: cancel,
            calculaValorProcedimento: calculaValorProcedimento,
            adicionarProcedimento: adicionarProcedimento,
            salvar: salvar,
            excluirProcedimento: excluirProcedimento,
            dialogEditarProcedimento: dialogEditarProcedimento,
            calculaTotalServico: calculaTotalServico,
            calculaTotalServicoMaisProcedimentoVezesQuantidade: calculaTotalServicoMaisProcedimentoVezesQuantidade
        };

        function excluirProcedimento(event, item) {
            vm.emProgresso = true;
            if (item.obrigatorio)
                MdDialogService.alertPadrao("Atenção", event, "Não é permitido excluir um procedimento obrigatório.");
            else {
                MdDialogService.confirmPadraoComEvento("Deseja mesmo excluir este item?", null, event, function () {
                    RequisicaoGenericaLocacaoService.excluir(Api.manutencao.ordem_servico_procedimento.remover, item.id)
                        .then(function (success) {
                            var indice = vm.ordensServicosProcedimentos.indexOf(item);
                            vm.ordensServicosProcedimentos.splice(indice, 1);
                            calculaTotalServico();
                            calculaTotalServicoMaisProcedimentoVezesQuantidade();
                            var codigos = vm.procedimentosObrigatoriosOriginais.map(function (modelo) {
                                return modelo.id;
                            });
                            if (codigos.includes(item.ordemServicoTipoProcedimentoId)) {

                                var procedimento = vm.procedimentosObrigatoriosOriginais.filter(function (obrigatorio) {
                                    if (obrigatorio.id == item.ordemServicoTipoProcedimentoId)
                                        return obrigatorio;
                                });

                                vm.procedimentosObrigatorios.push(procedimento[0]);
                            }

                            MdToastService.toastPadrao("Procedimento removido com sucesso!");
                            filtrarProcedimentosObrigatórios();
                        }).finally(function () { vm.emProgresso = false; });
                }, function () {

                });
            }
        }

        function calculaTotalServico() {
            vm.valorTotalSevico = 0;

            vm.ordensServicosProcedimentos.map(function (item) {
                if (!item.custoPeca)
                    vm.valorTotalSevico += item.quantidade * item.custoPeca;
                else
                    vm.valorTotalSevico = 0;
            });
        }

        function calculaTotalServicoMaisProcedimentoVezesQuantidade() {
            vm.valorTotalSevicoMaisPecaVezesQtd = 0;

            vm.ordensServicosProcedimentos.map(function (item) {
                if (item.quantidade <= 0)
                    item.quantidade = 1;
                if (!item.custoPeca || item.custoPeca <= 0)
                    item.custoPeca = 0;

                var pecasVezesQtd = (item.quantidade * item.custoPeca);

                var procedimentosVezesQtd = (item.quantidade * item.valorProcedimento);

                vm.valorTotalSevicoMaisPecaVezesQtd += pecasVezesQtd + procedimentosVezesQtd;
            });
        }

        function salvar(modelo) {
            vm.emProgresso = true;

            modelo.ordemServicoItemId = vm.itemVinculado.id;
            if (modelo.ordemServicoOrigemPecaId == undefined)
                modelo.ordemServicoOrigemPecaId = null;

            if (modelo.quantidade == undefined)
                modelo.quantidade = 1;

            var verificaSeExiste = vm.ordensServicosProcedimentos.filter(function (item) {
                if (modelo.ordemServicoTipoProcedimentoId == item.ordemServicoTipoProcedimentoId)
                    return true;
            });

            if (verificaSeExiste.length > 0) {
                vm.emProgresso = false;
                MdDialogService.alertPadrao("Atenção", event, "Não é possível adicionar o mesmo procedimento mais de uma vez.");
                return;
            }

            RequisicaoGenericaLocacaoService.salvar(Api.manutencao.ordem_servico_procedimento.criar, modelo)
                .then(function (success) {
                    MdToastService.toastPadrao("Procedimento cadastrado com sucesso!");
                    removerItemObrigatorio(modelo.ordemServicoTipoProcedimentoId);
                    adicionarProcedimento(success.data);
                    filtrarProcedimentosObrigatórios();
                    calculaTotalServico();
                    calculaTotalServicoMaisProcedimentoVezesQuantidade();
                    vm.pecaObrigatoria = false;
                    vm.salvando = false;
                    vm.verde = true;
                }, function (err) {
                    filtrarProcedimentosObrigatórios();
                    MdDialogService.alertPadrao("Atenção", event, err.data.error[0]);
                    vm.salvando = false;
                }).finally(function () { vm.emProgresso = false; });
        }

        function removerItemObrigatorio(procedimentoId) {
            var procedimentoRemover = vm.procedimentosObrigatorios.filter(function (item) {
                if (item.id == procedimentoId)
                    return item;
            });

            if (procedimentoRemover.length > 0)
                vm.procedimentosObrigatorios.splice(vm.procedimentosObrigatorios.indexOf(procedimentoRemover[0]), 1);
        }

        function inicializaPesquisando(id) {
            vm.salvando = true;
            RequisicaoGenericaLocacaoService.listarSemParams(Api.manutencao.ordem_servico_procedimento.listarPorItem + id)
                .then(function (success) {
                    adicionarProcedimento(success.data);
                    verificaProcedimentosObrigatorios(vm.ordensServicosProcedimentos);
                    calculaTotalServicoMaisProcedimentoVezesQuantidade();
                    if (success.data.length == 0)
                        adicionaProcedimentoObrigatorioAoAbrirDialog(vm.procedimentosObrigatorios);
                    vm.salvando = false;
                });
        }

        function cancel() {
            $mdDialog.hide(vm.ordensServicosProcedimentos);
        }

        function verificaProcedimentosObrigatorios(procedimentos) {
            if (procedimentos.length <= 0)
                return;
            var codigos = procedimentos.map(function (item) {
                return item.ordemServicoTipoProcedimentoId;
            })
            var obrigatorios = vm.procedimentosPorEquipamento.filter(function (item) {
                if (codigos.includes(item.id))
                    return item;
            });
            if (obrigatorios.length <= 0)
                return;
            obrigatorios.map(function (item) {
                var indice = vm.procedimentosObrigatorios.indexOf(item);
                vm.procedimentosObrigatorios.splice(indice, 1);
            })
        }

        function adicionarProcedimento(adicionaProcedimento) {
            if (vm.obrigatorio.length <= 0)
                adicionarProcedimentoSegundaVez(adicionaProcedimento);
            if (vm.obrigatorio.length > 0) {
                vm.obrigatorio.filter(function (item) {
                    adicionaProcedimento.map(function (arg) {
                        if (arg.ordemServicoTipoProcedimentoId == item.id) {
                            arg.obrigatorio = true;
                        }
                        else
                            arg.obrigatorio = false;
                    });
                });
                vm.ordensServicosProcedimentos = adicionaProcedimento;
                vm.procedimento = null;
                filtrarProcedimentosObrigatórios();
            }
        }

        function adicionarProcedimentoSegundaVez(adicionaProcedimento) {
            vm.obrigatorio.filter(function (item) {
                adicionaProcedimento.map(function (arg) {
                    if (arg.ordemServicoTipoProcedimentoId == item.id) {
                        arg.obrigatorio = true;
                    }
                    else
                        arg.obrigatorio = false;
                });
            });
            vm.ordensServicosProcedimentos = adicionaProcedimento;
            vm.procedimento = null;
            filtrarProcedimentosObrigatórios();

        }

        function filtrarProcedimentosPorEquipamento(equipamento) {
            var procedimentos = vm.procedimentos.filter(function (procedimento) {
                if (equipamento == procedimento.equipamentoId)
                    return procedimento;
            })

            vm.procedimentosPorEquipamento = procedimentos;
        }

        function calculaValorProcedimento(procedimentoId) {
            validarPecaObrigatoria(procedimentoId);
            var valor = vm.procedimentosPorEquipamento.reduce(function (acc, procedimento) {
                if (procedimento.id == procedimentoId)
                    return acc + procedimento.valorProcedimento;
                else
                    return acc;
            }, 0)
            vm.procedimento.valorProcedimento = valor;
        }

        function validarPecaObrigatoria(procedimentoId) {
            var procedimento = vm.procedimentosPorEquipamento.filter(function (item) {
                if (procedimentoId == item.id)
                    return item;
            });

            vm.pecaObrigatoria = procedimento[0].necessitaPeca;
        }

        function filtrarProcedimentosObrigatórios() {
            vm.obrigatorio = vm.procedimentosPorEquipamento.filter(function (procedimento) {
                if (procedimento.obrigatorio)
                    return procedimento;
            })
            vm.procedimentosObrigatorios = vm.obrigatorio;
            vm.procedimentosObrigatoriosOriginais = angular.copy(vm.obrigatorio);
        }

        function adicionaProcedimentoObrigatorioAoAbrirDialog(procedimentoObrigatorio) {
            var resultadoRetorno = procedimentoObrigatorio.map(function (item) {
                vm.obj.ordemServicoTipoProcedimentoId = item.id;
                vm.obj.ordemServicoTipoProcedimentoDescricao = item.descricao;
                vm.obj.quantidade = 1;
                vm.obj.valorProcedimento = item.valorProcedimento;
                vm.obj.obrigatorio = item.obrigatorio;
                return vm.obj;
            });
            resultadoRetorno.forEach(function (item) {
                salvar(item);
            });
            adicionarProcedimento(resultadoRetorno);
        }

        function dialogEditarProcedimento(event, item) {
            if (item.obrigatorio)
                MdDialogService.alertPadrao("Atenção", event, "Não é permitido editar um procedimento obrigatório.");
            else {
                $mdDialog
                    .show({
                        controller: "DialogOrdemServicoProcedimentoEditarController",
                        controllerAs: "vm",
                        templateUrl: vm.rotasHtmlNota.dialogs.dialog_ordem_servico_item_editar,
                        multiple: true,
                        targetEvent: event,
                        clickOutsideToClose: false,
                        locals: {
                            Procedimento: item,
                            TiposProcedimento: vm.procedimentosPorEquipamento,
                            OrigemPecas: vm.pecas,
                            PecaObrigatoria: vm.pecaObrigatoria,
                            CalcularTotalServico: function () {
                                calculaTotalServico();
                                calculaTotalServicoMaisProcedimentoVezesQuantidade();
                            }
                        }
                    })
                    .then(function (success) {
                        filtrarProcedimentosObrigatórios();
                        vm.ordensServicosProcedimentos[vm.ordensServicosProcedimentos.indexOf(item)] = success;

                    });
            }
        }
    }
})();
/**
 * Created by nova on 28/03/2017.
 */
(function () {
    'use strict';

    angular
        .module('app.pipeline.consulta.projecoes', [])
        .config(config);

    function config($stateProvider, RotasHtml) {
        var rotasHtml = RotasHtml.pipeline_consulta.projecoes;
        $stateProvider
            .state('app.pipeline_consulta_projecoes', {
                url: '/pipeline/consulta/projecoes',
                module: 'privado',
                views: {
                    'content@app': {
                        templateUrl: rotasHtml.templateUrl,
                        controller: "PipelineConsultaProjecoesController as vm"
                    }
                },
                bodyClass: 'pipeline-consulta-projecoes-negocios',
                resolve: {                    
                    ListarFunisAtivos: function (Api, RequisicaoGenericaService) {
                        return RequisicaoGenericaService.listarSemParams(Api.pipeline.pipeline_funil.listarAtivos);
                    },
                    ListarUsuariosSetorComercial: function (Api, RequisicaoGenericaService) {
                        return RequisicaoGenericaService.listarSemParams(Api.usuario.listarUsuariosSetorComercial);
                    }
                }
            });
    }

})();

(function () {
    'use strict';

    angular
        .module('app.pipeline.consulta.projecoes')
        .controller('DetalhamentoProjecoesEtapaController', DetalhamentoProjecoesEtapaController);

    function DetalhamentoProjecoesEtapaController
        (
            $timeout,
            $filter,
            MdDialogService,
            RequisicaoGenericaService,
            $mdDialog,
            DataTableConfigPadrao,
            Parametros,
            Regex,
            Api,
            $window,
            urlApi
        ) {
        var vm = this;

        init();

        vm.metodosDialog = {
            fecharDialog: fecharDialog,
            gerarRelatorioProjecoes: gerarRelatorioProjecoes
        };

        function init() {
            vm.titulo = "Detalhamento projeções finalizações etapas"
            vm.requisicaoSolicitada = false;
            vm.projecoes = Parametros[0];
            vm.dadosPdf = {
                dadosRelatorio: Parametros[0],
                dadosFiltro: Parametros[1]
            }
            construirDtOptions();
        }

        function construirDtOptions() {
            vm.dtOptions = angular.copy(DataTableConfigPadrao.dtOptionsResponsivoPaginacaoTipoNumberComInitComplete);
            vm.dtOptions.order = [];
            vm.dtOptions.footerCallback = function (row, data, start, end, display) {
                var api = this.api(),
                    somatarioQuantidadeNegocios = 0,
                    somatorioValorTotal = 0,
                    somatorioValorTotalProjetado = 0;


                api.column(2, {
                    page: 'current'
                }).data()
                    .reduce(function (a, b) {
                        somatarioQuantidadeNegocios += Number(b)
                    }, 0)


                api.column(3, {
                    page: 'current'
                }).data()
                    .reduce(function (a, b) {
                        if (b) {
                            somatorioValorTotal += (parseFloat(b.replace(/[$,]/g, '')));
                        }
                    }, 0);

                api.column(4, {
                    page: 'current'
                }).data()
                    .reduce(function (a, b) {
                        if (b) {
                            somatorioValorTotalProjetado += (parseFloat(b.replace(/[$,]/g, '')));
                        }
                    }, 0);

                $(api.column(2).footer()).html("<label>" + somatarioQuantidadeNegocios + "</label>");
                $(api.column(3).footer()).html("<label>" + $filter('currency')(somatorioValorTotal, "R$ ") + "</label>");
                $(api.column(4).footer()).html("<label>" + $filter('currency')(somatorioValorTotalProjetado, "R$ ") + "</label>");
            };

            vm.dtOptions.columnDefs = [
                {
                    targets: [3, 4],
                    render: $.fn.dataTable.render.number('.', ',', 2, 'R$ ')
                }
            ];
        }

        function fecharDialog() {
            $mdDialog.hide();
        }

        function gerarRelatorioProjecoes(event) {
            vm.requisicaoSolicitada = true;
            vm.mensagemPreloader = "Gerando PDF ...";

            RequisicaoGenericaService.salvar(Api.pipeline.pipeline_projecoes.gerarRelatorioProjecoes, vm.dadosPdf).then(
                function (success) {
                    vm.requisicaoSolicitada = false;
                    vm.mensagemPreloader = "";
                    $window.open(urlApi.url_base_api + Api.relatorio.abrirRelatorio + success.data);
                },
                function (error) {
                    vm.requisicaoSolicitada = false;
                    vm.mensagemPreloader = "";
                    MdDialogService.alertPadrao(error.data);
                });

        }
    }
})();

(function () {
    "use strict";

    angular
        .module("app.manutencao.ordem-servico")
        .controller("DialogOrdemServicoValorController", DialogOrdemServicoValorController);

    function DialogOrdemServicoValorController(
        $mdDialog,
        TiposEnvios,
        Usuarios,
        MdDialogService,
        Api,
        Totais,
        Envio,
        ValorTotalProcedimentos,
        OrdemServicoId,
        OrdemServicoIdPesquisa,
        OrdemVinculada,
        TipoServico,
        RequisicaoGenericaLocacaoService,
        OrdemServicoValor
    ) {
        var vm = this;

        init();

        function init() {
            vm.usuarios = Usuarios;
            vm.tiposEnvios = TiposEnvios
            vm.valorPeca = Totais;
            vm.ordemVinculada = OrdemVinculada;
            vm.ordemServicoValor = OrdemServicoValor;
            vm.tipoServico = TipoServico.data;
            if (OrdemServicoId != undefined)
                vm.ordemServicoId = OrdemServicoId;
            else
                vm.ordemServicoId = OrdemServicoIdPesquisa;

            vm.valorTotalProcedimentos = ValorTotalProcedimentos;

            vm.envio = Envio;
            vm.total = 0;

            calculaValorFaturadoInicial();
            pesquisarValoresOs(vm.envio.ordemServicoId);
            verificaFaturado(vm.ordemVinculada);
            verificaServicoObrigaObservacao(vm.ordemVinculada);
        }

        vm.metodos = {
            cancel: cancel,
            salvar: salvar,
            editar: editar,
            calculaValorFaturadoInicial: calculaValorFaturadoInicial,
            calculaValorFaturado: calculaValorFaturado,
            pesquisarValoresOs: pesquisarValoresOs
        };

        function verificaFaturado(ordemServico) {
            vm.tipoServico.filter(function (servico) {
                if (servico.id == ordemServico.ordemServicoTipoServicoId) {
                    if (servico.faturar) {
                        vm.servicoFaturado = true;
                    }
                    else {
                        vm.servicoFaturado = false;
                    }
                }
            });

        }

        function verificaServicoObrigaObservacao(ordemServico) {
            vm.tipoServico.filter(function (servico) {
                if (servico.id == ordemServico.ordemServicoTipoServicoId) {
                    if (servico.permiteObservacao) {
                        vm.servicoObrigaObservacao = true;
                    }
                    else {
                        vm.servicoObrigaObservacao = false;
                    }
                }
            });

        }

        function verificaSeEstaEditando() {
            if (vm.valores != "") {
                vm.editando = true;
                calculaValorFaturado(vm.valores, vm.form.valorFrete, vm.form);
            }
            else {
                vm.valores = {};
            }
        }

        function pesquisarValoresOs(osId, index) {
            RequisicaoGenericaLocacaoService.listarSemParams(
                Api.manutencao.ordem_servico_envio_valores.listarPorOS + osId)
                .then(function (success) {
                    vm.valores = success.data;
                    verificaSeEstaEditando();
                    vm.valores.valorReal = vm.valorReal;

                }, function (err) {
                    MdDialogService.alertPadrao("Atenção", event, err.data.error);
                })
        }

        function cancel() {
            $mdDialog.cancel();
        }

        function calculaValorFaturadoInicial() {
            vm.valorRealInicial = vm.valorTotalProcedimentos + vm.valorPeca;
            vm.valorReal = angular.copy(vm.valorRealInicial);
        }

        function calculaValorFaturado(valores, input, form) {

            if (valores.valorFrete == undefined || valores.valorFrete == "") {
                valores.valorFrete = 0;
            }

            if ((valores.valorFrete == 0 || input.$modelValue <= 0 || input.$modelValue == undefined) && vm.envio.tipoEnvio[0].freteObrigatorio == 1) {
                form.valorFrete.$setValidity("valorFrete", false);
            }
            else {
                form.valorFrete.$setValidity("valorFrete", true);
            }

            vm.valorReal = (vm.valorRealInicial + valores.valorFrete);
        }

        function salvar(modelo) {
            modelo.valorPeca = vm.valorPeca;
            modelo.valorCusto = vm.valorTotalProcedimentos;
            modelo.ordemServicoId = vm.envio.ordemServicoId;
            modelo.valorReal = vm.valorReal;
            if (modelo.valorCobrado == null || modelo.valorCobrado == undefined)
                modelo.valorCobrado = 0;

            RequisicaoGenericaLocacaoService.salvar(Api.manutencao.ordem_servico_envio_valores.criar, modelo)
                .then(function (success) {
                    success.data.valorReal = modelo.valorReal;
                    $mdDialog.hide(success.data)
                }, function (err) {
                    MdDialogService.alertPadrao("Atenção!", event, "Para salvar é necessário informar os dados de envio!");
                });
        }

        function editar(modelo) {
            modelo.valorPeca = vm.valorPeca;
            modelo.valorCusto = vm.valorTotalProcedimentos;
            modelo.ordemServicoId = vm.ordemServicoValor.ordemServicoId;
            modelo.valorReal = vm.valorReal;
            if (modelo.valorCobrado == null || modelo.valorCobrado == undefined)
                modelo.valorCobrado = 0;

            RequisicaoGenericaLocacaoService.editar(Api.manutencao.ordem_servico_envio_valores.editar, modelo)
                .then(function (success) {
                    success.data.valorReal = vm.valorReal;
                    $mdDialog.hide(success.data);
                }, function (err) {
                    MdDialogService.alertPadrao("Atenção", event, err.data.error[0]);
                });
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.pipeline.consulta.projecoes')
        .controller('DetalhamentoProjecoesNegociosController', DetalhamentoProjecoesNegociosController);

    function DetalhamentoProjecoesNegociosController
        (
            $timeout,
            $filter,
            MdDialogService,
            RequisicaoGenericaService,
            $mdDialog,
            Api,
            Parametros,
            ServicosGenericoService,
            DatatableFactory
        ) {
        var vm = this;


        vm.filtrosProjecoes = angular.copy(Parametros[0]);
        var rota = angular.copy(Parametros[1]);

        init();

        vm.metodosInterno = {
            construirDtOptions: construirDtOptions,
        }
        vm.metodosDialog = {
            fecharDialog: fecharDialog
        };

        function init() {
            vm.titulo = vm.filtrosProjecoes.titulo;
            vm.requisicaoSolicitada = false;
            vm.mensagemPreloader = "";

            vm.dtOptions = construirDtOptions();

            carregarNegocios();
        }


        function carregarNegocios() {
            vm.requisicaoSolicitada = true;
            vm.mensagemPreloader = "Carregando negócios ...";
            RequisicaoGenericaService.listarComParams(rota, vm.filtrosProjecoes).then(
                function (success) {
                    vm.requisicaoSolicitada = false;
                    vm.mensagemPreloader = "";

                    vm.negocios = success.data.dadosProjecoes;
                },
                function (error) {
                    ServicosGenericoService.exibirAlertaDeErro(error, event);
                    vm.requisicaoSolicitada = false;
                    vm.mensagemPreloader = "";
                });
        }

        function construirDtOptions() {
            var dtOptions = DatatableFactory.construirDtOptionsComPaginacaoResponsivoPadrao([]);
            dtOptions.order = [];
            dtOptions.footerCallback = function (row, data, start, end, display) {
                var api = this.api(),
                    somatorioValorNominal = 0,
                    somatorioValorProjetado = 0;

                api.column(4, {
                    page: 'all'
                }).data()
                    .reduce(function (a, b) {
                        if (b) {
                            somatorioValorNominal += (parseFloat(b.replace(/[$,]/g, '')));
                        }
                    }, 0);

                api.column(5, {
                    page: 'all'
                }).data()
                    .reduce(function (a, b) {
                        if (b) {
                            somatorioValorProjetado += (parseFloat(b.replace(/[$,]/g, '')));
                        }
                    }, 0);

                $(api.column(4).footer()).html("<label>" + $filter('currency')(somatorioValorNominal, "R$") + "</label>");
                $(api.column(5).footer()).html("<label>" + $filter('currency')(somatorioValorProjetado, "R$") + "</label>");
            };

            dtOptions.columnDefs = [
                {
                    targets: [2, 3],
                    type: 'date-pt-br'
                },
                {
                    targets: [4, 5],
                    render: $.fn.dataTable.render.number('.', ',', 2, 'R$ ')
                }
            ];

            return dtOptions
        }

        function fecharDialog() {
            $mdDialog.hide();
        }
    }

})();
(function () {
    "use strict";

    angular
        .module("app.manutencao.ordem-servico")
        .controller("DialogOrdemServicoProcedimentoEditarController",DialogOrdemServicoProcedimentoEditarController);

    function DialogOrdemServicoProcedimentoEditarController(
        TiposProcedimento,
        CalcularTotalServico,
        OrigemPecas,
        $mdDialog,
        Procedimento,
        RequisicaoGenericaLocacaoService,
        Api,
        MdToastService,
        MdDialogService,
        PecaObrigatoria
    ) {
        var vm = this;

        init();

        function init() {
            vm.procedimento = Procedimento;
            vm.tiposProcedimentos = TiposProcedimento;
            vm.pecas = OrigemPecas;
            vm.pecaObrigatoria = PecaObrigatoria;
            validarPecaObrigatoria(vm.procedimento.ordemServicoTipoProcedimentoId);
        }

        vm.metodos = {
            cancel: cancel,
            salvar: salvar
        };

        function cancel() {
            $mdDialog.hide(vm.procedimento);
        }

        function salvar(modelo) {
            if (modelo.ordemServicoOrigemPecaId == 0)
                modelo.ordemServicoOrigemPecaId = null;

            RequisicaoGenericaLocacaoService.editar(Api.manutencao.ordem_servico_procedimento.editar,modelo)
                .then(function (success) {
                    MdToastService.toastPadrao("Procedimento editado com sucesso!");
                    vm.pecaObrigatoria = false;
                    $mdDialog.hide(success.data);
                    vm.salvando = false;
                    CalcularTotalServico();
                },function (err) {
                    MdDialogService.alertPadrao("Atenção",event,err.data.error[0]);
                    vm.salvando = false;
                });
        }

        function validarPecaObrigatoria(procedimentoId) {
            var procedimento = vm.tiposProcedimentos.filter(function (item) {
                if (procedimentoId == item.id)
                    return item;
            });

            vm.pecaObrigatoria = procedimento[0].necessitaPeca;
        }

    }


})();

(function () {
    "use strict";

    angular
        .module("app.manutencao.ordem-servico")
        .controller("DialogOrdemServicoItemController", DialogOrdemServicoItemController);

    function DialogOrdemServicoItemController(
        Api,
        Item,
        $mdDialog,
        MdToastService,
        OrdemVinculada,
        ApenasVisualizacao,
        MdDialogService,
        RequisicaoGenericaLocacaoService,
        ServicosGenericoService,
        LoginUsuarioService,
        RequisicaoGenericaService
    ) {
        var vm = this;
        vm.editando = false;
        init();

        function init() {
            vm.item = Item;
            vm.ordemServicoItem = {};
            vm.equipamentoItemGeral = {};

            vm.objExclusao = {};
            vm.ordemVinculada = OrdemVinculada;
            vm.desabilitarBotaoExcluir = true;

            if (vm.ordemVinculada.ordemServicoTipoServicoId == 2)
                ListarOrdemServicoEquipamento();

            ListarContratos(vm.ordemVinculada.clienteCodigo);

            vm.apenasVisualizacao = ApenasVisualizacao;
            if (Item != null) {
                vm.editando = true;
                vm.ordemServicoItem.id = angular.copy(Item.id);
                vm.ordemServicoItem.observacao = angular.copy(Item.observacao);
                vm.ordemServicoItem.equipamentoNotaItemDetalheId = angular.copy(Item.equipamentoNotaItemDetalheId);
                vm.ordemServicoItem.ordemServicoEquipamentoItemId = angular.copy(Item.ordemServicoEquipamentoItemId);
            }
            else
                ListarEquipamentosRetornados();
        }

        vm.metodos = {
            cancel: cancel,
            gravar: gravar,
            habilitarCampos: habilitarCampos,
            excluirItem: excluirItem,
            configuraMdSelectSolucao: configuraMdSelectSolucao
        };

        function cancel() {
            $mdDialog.cancel();
        }

        /**
         * Método que irá configurar e limpar o filtro do md-header do md-select de solução
         */
        function configuraMdSelectSolucao() {
            vm.filtrarEquipamentos = '';
            angular
                .element('#equipamento-form-solucao-md-select')
                .on('keydown', function (ev) {
                    ev.stopPropagation();
                });
        }

        // Excluir equipamento
        function excluirItem(modelo) {
            MdDialogService.confirmPadraoComEvento("Deseja mesmo excluir este item?", null, event, function () {
                return RequisicaoGenericaLocacaoService.excluir(
                    Api.manutencao.ordem_servico_item.remover, modelo.id
                ).then(
                    function (success) {
                        vm.objExclusao.id = modelo.id;
                        vm.objExclusao.mensagem = success.data;
                        ListarEquipamentosRetornados();
                        ListarOrdemServicoEquipamento();
                        $mdDialog.hide(vm.objExclusao);
                        vm.salvando = false;
                    },
                    function (err) {
                        MdDialogService.alertPadrao("Atenção", event, err.data.error);
                        vm.salvando = false;
                    }
                );
            }, function () {

            });

        }
        // endregion

        function habilitarCampos() {
            vm.apenasVisualizacao = false;
        }

        function gravar(modelo) {
            if (modelo.observacao == null) modelo.observacao = "";
            vm.salvando = true;
            preparaEntidadeEnvio(modelo);
            if (Item != null)
                editar(modelo);
            else {
                salvar(modelo);
            }
        }

        function salvar(modelo) {
            RequisicaoGenericaLocacaoService.salvar(Api.manutencao.ordem_servico_item.criar, modelo)
                .then(function (success) {
                    ListarEquipamentosRetornados();
                    ListarOrdemServicoEquipamento();
                    if (vm.ordemVinculada.status == 1) {
                        vm.ordemVinculada.status = 2;
                        RequisicaoGenericaLocacaoService.editar(Api.manutencao.ordem_servico.editar, vm.ordemVinculada)
                            .then(function (success) {
                                MdToastService.toastPadrao("Ordem de serviço editada com sucesso!");
                            }, function (err) {
                                MdDialogService.alertPadrao("Atenção", event, err.data.error[0]);
                            });
                    }
                    $mdDialog.hide(success.data);
                    vm.salvando = false;
                }, function (err) {
                    MdDialogService.alertPadrao("Atenção", event, err.data.error[0]);
                    vm.salvando = false;
                });
        }

        function editar(modelo) {
            RequisicaoGenericaLocacaoService.editar(Api.manutencao.ordem_servico_item.editar, modelo)
                .then(function (success) {
                    ListarEquipamentosRetornados();
                    ListarOrdemServicoEquipamento();
                    $mdDialog.hide(success.data);
                    vm.salvando = false;
                }, function (err) {
                    MdDialogService.alertPadrao("Atenção", event, err.data.error[0]);
                    vm.salvando = false;
                })
        }


        function ListarContratos(codigo) {
            return RequisicaoGenericaService.listarSemParams(
                Api.contrato.listarContratosPorCliente + codigo
            ).then(function (success) {
                vm.contratos = success.data;
                inicializaContratoVinculado(vm.contratos);

            });
        }

        function ListarOrdemServicoEquipamento() {
            return RequisicaoGenericaLocacaoService.listarSemParams(
                Api.manutencao.entrada.listarTodosEntrada
            ).then(function (success) {
                vm.equipamentosEntradas = success.data;
            });
        }

        function inicializaContratoVinculado(contratos) {
            var produto = contratos.filter(function (item) {
                if (item.codigo == vm.ordemVinculada.contrato)
                    return item.produto.descricao;
            })

            vm.produto = produto[0].produto.descricao;
        }

        function preparaEntidadeEnvio(modelo) {
            modelo.ordemServicoId = vm.ordemVinculada.id;
            modelo.contratoId = vm.ordemVinculada.contrato;
            modelo.clienteId = vm.ordemVinculada.clienteId;
            modelo.usuarioId = LoginUsuarioService.usuarioArmazenado().codigo;
            modelo.usuarioNome = LoginUsuarioService.usuarioArmazenado().login;
            modelo.produto = vm.produto;

            if (vm.ordemVinculada.ordemServicoTipoServicoId != 2 && Item == null) {
                console.log("equipamento", vm.equipamentoItemGeral)
                modelo.equipamentoNotaItemDetalheId = vm.equipamentoItemGeral.equipamentoNotaItemId;
                modelo.ordemServicoEquipamentoItemId = vm.equipamentoItemGeral.osEquipamentoItemCodigo;
            }
        }

        function ListarEquipamentosRetornados() {
            vm.preloader = "Carregando equipamentos...";
            vm.requisicaoSolicitada = true;
            RequisicaoGenericaLocacaoService.listarSemParams(
                Api.locacao.nota_item_detalhe.listarLocadosPorContrato
            ).then(function (success) {
                vm.preloader = "";
                vm.requisicaoSolicitada = false;
                vm.retornados = success.data;
                Retornados = angular.copy(vm.retornados);
            });
        }
    }
})();

(function () {
    "use strict";

    angular
        .module("app.manutencao.ordem-servico")
        .controller("DialogOrdemServicoEnvioController", DialogOrdemServicoEnvioController);

    function DialogOrdemServicoEnvioController(
        $mdDialog,
        TiposEnvios,
        Usuarios,
        MdDialogService,
        Api,
        OrdemVinculada,
        Envio,
        DataExecFinal,
        RequisicaoGenericaLocacaoService
    ) {
        var vm = this;

        init();

        function init() {
            vm.usuarios = Usuarios;
            vm.tiposEnvios = TiposEnvios
            vm.envio = Envio;
            vm.dataExecFinal = DataExecFinal;

            if (Envio.dataEnvio != undefined) {
                vm.editando = true;
                vm.envio.dataEnvio = new Date(Envio.dataEnvio);

                if (Envio.dataRecebimento != null)
                    vm.envio.dataRecebimento = new Date(Envio.dataRecebimento);
            }

        }

        vm.metodos = {
            cancel: cancel,
            salvar: salvar,
            editar: editar,
            verificaCheckRecebido: verificaCheckRecebido
        };

        function verificaCheckRecebido(valor) {
            if (!valor)
                vm.envio.recebidoPor = null;
        }

        function cancel() {
            $mdDialog.cancel();
        }

        function salvar(modelo) {
            modelo.ordemServicoId = OrdemVinculada.id;
            RequisicaoGenericaLocacaoService.salvar(Api.manutencao.ordem_servico_envio.criar, modelo)
                .then(function (success) {
                    $mdDialog.hide(success.data);
                    vm.salvando = false;
                }, function (err) {
                    MdDialogService.alertPadrao("Atenção", event, err.data.error[0]);
                    vm.salvando = false;
                });
        }

        function editar(modelo) {
            RequisicaoGenericaLocacaoService.editar(Api.manutencao.ordem_servico_envio.editar, modelo)
                .then(function (success) {
                    $mdDialog.hide(success.data);
                    vm.salvando = false;
                }, function (err) {
                    MdDialogService.alertPadrao("Atenção!", event, err.data.error[0]);
                    vm.salvando = false;
                });
        }
    }
})();

(function () {
    "use strict";

    angular
        .module("app.manutencao.ordem-servico")
        .controller("DialogOrdemServicoExecucaoController", DialogOrdemServicoExecucaoController);

    function DialogOrdemServicoExecucaoController(
        $mdDialog,
        Usuarios,
        OrdemVinculada,
        Item,
        LoginUsuarioService,
        RequisicaoGenericaLocacaoService,
        Api,
        MdToastService,
        ValidaEquipamentos
    ) {
        var vm = this;
        vm.execucao = {};
        vm.usuarios = Usuarios;
        vm.ordemVinculada = OrdemVinculada;
        vm.dataEntrada = new Date(vm.ordemVinculada.dataEntrada);
        vm.dataFim = null;
        vm.itemVinculado = Item;
        vm.validaEquipamentos = ValidaEquipamentos;
        init();

        function init() {
            pesquisarExecucao(vm.itemVinculado.id);
        }

        vm.metodos = {
            cancel: cancel,
            salvar: salvar,
            editar: editar,
            pesquisarExecucao: pesquisarExecucao,
            validarDataExecucao: validarDataExecucao
        };


        function cancel() {
            vm.execucao.dataInicio = vm.execucao.dataInicio;
            vm.execucao.dataFim = vm.execucao.dataFim;
            $mdDialog.hide(vm.execucao);
        }

        function pesquisarExecucao(item) {
            RequisicaoGenericaLocacaoService.listarSemParams(Api.manutencao.ordem_servico_execucao.listarPorItem + item)
                .then(function (success) {
                    if (success.data == "") {
                        vm.execucao.usuarioId = LoginUsuarioService.usuarioArmazenado().codigo;
                        vm.execucao.ordemServicoId = vm.ordemVinculada.id;
                        vm.execucao.ordemServicoItemId = vm.itemVinculado.id;
                    }
                    else {
                        vm.execucao = success.data;
                        vm.execucao.dataInicio = new Date(success.data.dataInicio);
                        if (success.data.dataFim != null) vm.execucao.dataFim = new Date(success.data.dataFim);
                    }

                    if (vm.execucao.dataInicio != undefined)
                        vm.editando = true;
                })
        }

        function salvar(modelo) {
            RequisicaoGenericaLocacaoService.salvar(Api.manutencao.ordem_servico_execucao.criar, modelo)
                .then(function (success) {
                    MdToastService.toastPadrao("Executado com sucesso!");
                    $mdDialog.hide(success.data);
                })
        }

        function editar(modelo) {
            RequisicaoGenericaLocacaoService.editar(Api.manutencao.ordem_servico_execucao.editar, modelo)
                .then(function (success) {
                    MdToastService.toastPadrao("Execução editada com sucesso!");
                    $mdDialog.hide(success.data);
                })
        }

        function validarDataExecucao(data, form) {
            var dataInicial = angular.copy(data.$modelValue);
            if (dataInicial.setDate(dataInicial.getDate() + 1) < vm.dataEntrada) {
                data.$setValidity("minDate", false);
                form.dataInicio.$setValidity("minDate", false);
            } else {
                data.$setValidity("minDate", true);
                form.dataInicio.$setValidity("minDate", true);
            }
        }
    }
})();

(function () {
    "use strict";

    angular
        .module("app.manutencao.ordem-servico")
        .controller("DialogOrdemServicoController", DialogOrdemServicoController);

    function DialogOrdemServicoController(
        EmpresasAtivos,
        $mdDialog,
        RequisicaoGenericaService,
        RequisicaoGenericaLocacaoService,
        Api,
        Prioridades,
        TipoServicos,
        Clientes,
        Filtro,
        LoginUsuarioService,
        Usuarios,
        MdDialogService,
        OrdemServico,
        ApenasVisualizacao
        // Retornados
    ) {
        var vm = this;
        init();

        function init() {
            vm.editando = false;
            vm.apenasVisualizacao = ApenasVisualizacao;
            vm.usuarios = Usuarios;
            vm.clientes = Clientes;
            vm.filtroClientes = vm.clientes.clientes;
            vm.filtro = Filtro;
            vm.empresaAtivos = EmpresasAtivos;
            vm.prioridades = Prioridades;
            vm.tipoServicos = TipoServicos;
            vm.ordemServico = {};
            vm.ordemServico.usuarioId = LoginUsuarioService.usuarioArmazenado().codigo;
            vm.ordemServico.dataEntrada = new Date;
            vm.ordemServico.ano = vm.ordemServico.dataEntrada.getFullYear();
            vm.ordemServico.status = 1;
            vm.fases = [
                { codigo: 1, descricao: 'Aberta' },
                { codigo: 2, descricao: 'Em execução' },
                { codigo: 3, descricao: 'Executada' },
                { codigo: 4, descricao: 'Cancelada' },
                { codigo: 5, descricao: 'Reprovada' }
            ];

            if (OrdemServico != null) {
                vm.editando = true;
                vm.ordemServico = angular.copy(OrdemServico);
                vm.ordemServicoStatusAtual = vm.ordemServico.status;
                inicializaCliente(vm.ordemServico);
                inicializaAtendimentoEditar(vm.ordemServico);


            }
            else {
                vm.cliente = null;
                RetornarProximoCodigo(vm.ordemServico.ano);
            }
        }

        vm.metodos = {
            cancel: cancel,
            configuraAutoCompleteClienteOnBlur: configuraAutoCompleteClienteOnBlur,
            pesquisarAutoCompleteCliente: pesquisarAutoCompleteCliente,
            alterarItemSelecionadoAutoCompleteCliente: alterarItemSelecionadoAutoCompleteCliente,
            verificarQualPesquisaDeClienteFazer: verificarQualPesquisaDeClienteFazer,
            gravar: gravar,
            validarProvavelDataEntrega: validarProvavelDataEntrega,
            limparCampoMotivoCancelamentoReprovacao: limparCampoMotivoCancelamentoReprovacao,
            changeTipoContrato: changeTipoContrato
        };

        function _listarClientesComCotratoAtivo() {
            return RequisicaoGenericaService.listarSemParams(
                Api.protecao.atualizacaoLicenca.listar
            ).then(function (success) {
                vm.filtroClientes = success.data.clientes;
            });
        }

        function _listarTodosClientes() {
            return RequisicaoGenericaService.listarSemParams(
                Api.cliente.listarCodigoDescricao
            ).then(function (success) {
                vm.filtroClientes = success.data;
            });
        }

        function verificarQualPesquisaDeClienteFazer(tipoServico) {
            if (tipoServico == 1)
                _listarClientesComCotratoAtivo();
            else
                _listarTodosClientes();
        }

        function gravar(modelo) {
            vm.salvando = true;
            preparaEntidadeParaEnvio(modelo);
            if (OrdemServico != null)
                editar(modelo);
            else
                salvar(modelo);
        }

        function salvar(modelo) {
            RequisicaoGenericaLocacaoService.salvar(Api.manutencao.ordem_servico.criar, modelo)
                .then(function (success) {
                    $mdDialog.hide(success.data);
                    vm.salvando = false;
                }, function (err) {
                    MdDialogService.alertPadrao("Atenção", event, err.data.error[0]);
                    vm.salvando = false;
                });
        }

        function editar(modelo) {
            RequisicaoGenericaLocacaoService.editar(Api.manutencao.ordem_servico.editar, modelo)
                .then(function (success) {
                    $mdDialog.hide(success.data);
                    vm.salvando = false;
                }, function (err) {
                    MdDialogService.alertPadrao("Atenção", event, err.data.error[0]);
                    vm.salvando = false;
                });
        }

        function preparaEntidadeParaEnvio(modelo) {
            if (vm.atendimento != undefined) {
                modelo.atendimentoAno = vm.atendimento.ano;
                modelo.atendimentoId = vm.atendimento.codigo;
            }
            if (vm.cliente != undefined) {
                modelo.clienteId = vm.cliente.codigo;
                modelo.clienteNome = vm.cliente.nome;
            }
        }

        function cancel() {
            if (OrdemServico != null) {
                vm.ordemServico = angular.copy(OrdemServico);
            } else {
                vm.ordemServico = {};
            }
            $mdDialog.cancel();
        }

        function RetornarProximoCodigo(ano) {
            return RequisicaoGenericaLocacaoService.listarSemParams(
                Api.manutencao.ordem_servico.listarProximoCodigo + ano
            ).then(function (success) {
                vm.ordemServico.numero = success.data;
            });
        }

        function ListarContratos(codigo) {
            return RequisicaoGenericaService.listarSemParams(
                Api.contrato.listarContratosPorCliente + codigo
            ).then(function (success) {
                vm.contratos = success.data;
                changeTipoContrato(vm.ordemServico);
            });
        }

        function listarAtendimento(codigo) {
            RequisicaoGenericaService.listarSemParams(
                Api.atendimento.retornarAtendimentoPorCodigoCliente + codigo
            ).then(function (success) {
                vm.atendimentos = success.data;
            });
        }

        function configuraAutoCompleteClienteOnBlur() {
            if (!vm.filtro.cliente) {
                vm.textoDePesquisaAutoCompleteCliente = "";
            }
        }

        function pesquisarAutoCompleteCliente(query) {
            var resultado = vm.filtroClientes.filter(function (cliente) {
                if (
                    cliente.nome.toLowerCase().includes(query.toLowerCase()) ||
                    cliente.codigo == query
                ) {
                    return cliente;
                }
            });

            return resultado;
        }

        function alterarItemSelecionadoAutoCompleteCliente(item) {
            if (item) {
                vm.filtro.cliente = item;
                ListarContratos(vm.filtro.cliente.codigo);
                listarAtendimento(vm.filtro.cliente.codigo);
            } else {
                _inicializarProdutos();
                vm.filtro.cliente = null;
                vm.filtro.produtoCodigo = null;
                vm.textoDePesquisaAutoCompleteCliente = "";
                vm.atendimento = undefined;
                vm.ordemServico.contrato = undefined;
            }
        }

        function _inicializarProdutos() {
            vm.produtos = {
                codigo: null,
                descricao: null
            };
        }

        function inicializaAtendimentoEditar(ordemServico) {
            RequisicaoGenericaService.listarSemParams(
                Api.atendimento.retornarAtendimentoPorCodigoCliente + ordemServico.clienteCodigo
            ).then(function (success) {
                vm.atendimentos = success.data;
                vm.resultado = vm.atendimentos.filter(function (item) {
                    if (item.ano == ordemServico.atendimentoAno && item.codigo == ordemServico.atendimentoId) {
                        return item;
                    }
                });
                vm.atendimento = vm.resultado[0];
            });
        }

        function inicializaCliente(ordemServico) {
            var resultado = vm.clientes.clientes.filter(function (item) {
                if (item.codigo == ordemServico.clienteCodigo)
                    return item;
            });

            vm.cliente = resultado[0];
            if (vm.cliente != undefined)
                ListarContratos(vm.cliente.codigo);
        }

        function validarProvavelDataEntrega(provavelDataEntrega, dataEntrada, form) {
            var dataEntregaOS = angular.copy(provavelDataEntrega);
            var dataAberturaOS = new Date(dataEntrada);

            if (dataEntregaOS.setDate(dataEntregaOS.getDate() + 1) < dataAberturaOS) {
                form.data.$setValidity("provavelDataEntrega", false);
            } else {
                form.data.$setValidity("provavelDataEntrega", true);
            }
        }

        function limparCampoMotivoCancelamentoReprovacao(ordemServico) {
            ordemServico.motivoCancelamentoReprovacao = '';
        }

        function changeTipoContrato(ordemServico) {
            vm.contrato = vm.contratos.filter(function (contrato) {
                return contrato.codigo == ordemServico.contrato;
            })[0];
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.manutencao.dashboard', [])
        .config(Config);

    function Config($stateProvider, RotasHtml) {

        var rotasHtml = RotasHtml.dashboard;

        $stateProvider
            .state('app.manutencao_dashboard', {
                url: '/manutencao/dashboard',
                module: 'privado',
                views: {
                    'content@app': {
                        templateUrl: rotasHtml.templateUrl,
                        controller: 'DashboardController as vm'
                    },
                    'dashboard-form@app.manutencao_dashboard': {
                        templateUrl: rotasHtml.form
                    }
                },
                resolve: {
                    ListarEmpresaAtivo: function (Api, RequisicaoGenericaLocacaoService) {
                        return RequisicaoGenericaLocacaoService.listarSemParams(Api.locacao.empresaAtiva.listarTodos);
                    },
                    ListarTipoServico: function (Api, RequisicaoGenericaLocacaoService) {
                        return RequisicaoGenericaLocacaoService.listarSemParams(Api.manutencao.tipoServico.listarTodos);
                    },
                    ListarTecnicos: function (Api, RequisicaoGenericaService) {
                        return RequisicaoGenericaService.listarSemParams(Api.setor.listarTodos);
                    },
                    ListarTodosUsuarios: function (Api, RequisicaoGenericaService) {
                        return RequisicaoGenericaService.listarSemParams(Api.usuario.detalhes_usuario.listarUsuariosAtivos);
                    },
                    ListarClientesOrdemServico: function (Api, RequisicaoGenericaLocacaoService) {
                        return RequisicaoGenericaLocacaoService.listarSemParams(Api.manutencao.dashboard.listarPorClientesQuePossuemOrdemServico);
                    }
                }
            });
    }

})();

(function () {
    "use strict";

    angular
        .module("app.manutencao.dashboard")
        .controller("DialogOrdensServicoPeriodoController", DialogOrdensServicoPeriodoController);

    function DialogOrdensServicoPeriodoController(
        $mdDialog,
        DatatableFactory,
        OrdensServico,
        ConverteParaReal,
        $state,
        UsuariosAtivos,
        Status
    ) {
        var vm = this;

        _init();

        function _init() {
            vm.ordensServico = angular.copy(OrdensServico);
            vm.converteParaReal = ConverteParaReal;
            vm.status = Status;
            vm.parseFloat = parseFloat;
            vm.pesquisar = "";

            jQuery.extend(jQuery.fn.dataTableExt.oSort, {
                "ordemservicodashboard-asc": function (a, b) {
                    var elementoA = new DOMParser().parseFromString(a, "text/xml");
                    var elementoB = new DOMParser().parseFromString(b, "text/xml");

                    var valorA = elementoA.firstChild.children[1].innerHTML;
                    var valorB = elementoB.firstChild.children[1].innerHTML;

                    var partesA = valorA.split("/");
                    var numeroA = parseInt(partesA[0]);
                    var anoA = parseInt(partesA[1]);

                    var partesB = valorB.split("/");
                    var numeroB = parseInt(partesB[0]);
                    var anoB = parseInt(partesB[1]);

                    return (anoA < anoB) ? -1 : ((anoA > anoB) ? 1 : ((numeroA < numeroB) ? -1 : 1));
                },

                "ordemservicodashboard-desc": function (a, b) {
                    var elementoA = new DOMParser().parseFromString(a, "text/xml");
                    var elementoB = new DOMParser().parseFromString(b, "text/xml");

                    var valorA = elementoA.firstChild.children[1].innerHTML;
                    var valorB = elementoB.firstChild.children[1].innerHTML;

                    var partesA = valorA.split("/");
                    var numeroA = parseInt(partesA[0]);
                    var anoA = parseInt(partesA[1]);

                    var partesB = valorB.split("/");
                    var numeroB = parseInt(partesB[0]);
                    var anoB = parseInt(partesB[1]);

                    return (anoA < anoB) ? 1 : ((anoA > anoB) ? -1 : ((numeroA < numeroB) ? 1 : -1));
                }
            });

            vm.dtOptionsOrdensServicoPeriodo = DatatableFactory.construirDtOptionsResponsivoSemPaginacaoPadraoComPesquisaHeaderPadrao(
                [
                    {
                        targets: [4, 5, 6, 7, 8],
                        orderable: false
                    },
                    {
                        targets: [0],
                        type: "ordemservicodashboard" //nome da ordenação customizada
                    }
                ]
            );


        }

        vm.metodosDialog = {
            fecharDialog: fecharDialog,
            retornaStatus: retornaStatus,
            retornaIniciasNomeUsuario: retornaIniciasNomeUsuario,
            retornaUsuario: retornaUsuario,
            abrirOS: abrirOS
        };

        function fecharDialog() {
            $mdDialog.hide();
        }

        function retornaStatus(codigoStatus) {
            var descricaoStatus = '';
            if (codigoStatus != 0) {
                vm.status.forEach(function (status) {
                    if (status.codigo == codigoStatus) {
                        descricaoStatus = status.descricao;
                    }
                });
            }

            return descricaoStatus;
        }

        function retornaUsuario(codigoUsuario) {
            var nome = 'Usuário não encontrado';
            if (codigoUsuario != 0) {
                UsuariosAtivos.forEach(function (usuario) {
                    if (usuario.codigo == codigoUsuario) {
                        nome = usuario.nome;
                    }
                });
            }

            return nome;
        }

        function retornaIniciasNomeUsuario(codigoUsuario) {
            var nome = retornaUsuario(codigoUsuario);

            if (nome == 'Usuário não encontrado') return '?';

            return nome[0] + nome[1];
        }

        function abrirOS(os) {
            $state.goNewTab("app.manutencao_ordem_servico", {
                parametros: {
                    idOs: os.ordemServicoId
                }
            });
        }

    }
})();

(function () {
    "use strict";

    angular
        .module("app.manutencao.dashboard")
        .controller("DialogEquipamentosController", DialogEquipamentosController);

    function DialogEquipamentosController(
        $mdDialog,
        DatatableFactory,
        Equipamentos
    ) {
        var vm = this;
        vm.equipamentos = Equipamentos;

        _init();

        function _init() {

            vm.dtOptionsOrdensServicoPeriodo = DatatableFactory.construirDtOptionsResponsivoSemPaginacaoPadraoComPesquisaHeaderPadrao();
            vm.dtOptionsOrdensServicoPeriodo.order = [1, 'desc'];
        }

        vm.metodosDialog = {
            fecharDialog: fecharDialog
        };

        function fecharDialog() {
            $mdDialog.hide();
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.manutencao.entrada',[])
        .config(Config);

    function Config(
        $stateProvider,
        RotasHtml) {

        var rotaEntrada = RotasHtml.entrada;

        $stateProvider
            .state('app.manutencao_entrada',{
                url: '/manutencao/entrada',
                module: 'privado',
                params: {
                    parametros: null
                },
                views: {
                    'content@app': {
                        templateUrl: rotaEntrada.templateUrl,
                        controller: 'EntradaController as vm'
                    },
                    'entrada-form@app.manutencao_entrada': {
                        templateUrl: rotaEntrada.form
                    },
                    'entrada-tabela@app.manutencao_entrada': {
                        templateUrl: rotaEntrada.tabela
                    }
                },
                resolve: {
                    ListarEquipamento: function (Api,RequisicaoGenericaLocacaoService) {
                        return RequisicaoGenericaLocacaoService.listarSemParams(Api.locacao.equipamentos.equipamento.listarTodos);
                    },
                    ListarClientes: function (Api,RequisicaoGenericaService) {
                        return RequisicaoGenericaService.listarSemParams(Api.cliente.listarCodigoDescricao);
                    }
                }

            });
    }

}());

(function () {
    'use strict';

    angular
        .module('app.manutencao.entrada')
        .controller('DialogEditarNotaController', DialogEditarNotaController)

    function DialogEditarNotaController(
        Nota,
        $mdDialog,
        LoginUsuarioService,
        RequisicaoGenericaLocacaoService,
        MdToastService,
        MdDialogService,
        Api,
        Entradas,
        Clientes,
        ClienteSelecionado,
        CodigoCliente
    ) {
        var vm = this;
        vm.entradas = Entradas.map(function (item) {
            return item.id;
        });

        init();

        vm.metodos = {
            cancel: cancel,
            editar: editar,
            alterarItemSelecionadoAutoCompleteCliente: alterarItemSelecionadoAutoCompleteCliente,
            pesquisarAutoCompleteCliente: pesquisarAutoCompleteCliente
        }

        function init() {
            vm.entrada = Nota;
            vm.filtro = {};
            vm.clienteSelecionado = ClienteSelecionado;
            vm.clientes = Clientes.data;
            vm.filtroClientes = vm.clientes.clientes;
            vm.clienteId = CodigoCliente;
        }

        function cancel() {
            $mdDialog.cancel();
        }

        function alterarItemSelecionadoAutoCompleteCliente(item) {
            if (item) {
                vm.filtro.cliente = item;
            } else {
                vm.filtro.cliente = null;
                vm.textoDePesquisaAutoCompleteCliente = "";
            }
        }

        function pesquisarAutoCompleteCliente(query) {
            var resultado = vm.filtroClientes.filter(function (cliente) {
                if (
                    cliente.nome.toLowerCase().includes(query.toLowerCase()) ||
                    cliente.codigo == query
                ) {
                    return cliente;
                }
            });

            return resultado;
        }

        function editar(modelo) {
            modelo.codigos = vm.entradas;
            vm.requisicaoSolicitada = true;
            vm.salvando = true;
            modelo.usuarioId = LoginUsuarioService.usuarioArmazenado().codigo;
            modelo.clienteNome = vm.clienteSelecionado.nome;
            RequisicaoGenericaLocacaoService.editar(Api.manutencao.entrada.editarNota, modelo)
                .then(function (success) {
                    vm.requisicaoSolicitada = false;
                    MdToastService.toastPadrao("Dados de entrada editado com sucesso!");
                    success.data.clienteId = vm.clienteSelecionado.codigo;
                    success.data.clienteSelecionado = vm.clienteSelecionado;
                    $mdDialog.hide(success.data);
                }, function (err) {
                    MdDialogService.alertPadrao("Atenção", event, err.data.error[0]);
                    vm.salvando = false;
                })
        }

    }
}());

(function () {
    "use strict";

    angular
        .module("app.manutencao.dashboard")
        .controller("DialogClientesController", DialogClientesController);

    function DialogClientesController(
        $mdDialog,
        DatatableFactory,
        OrdensServicoCliente,
        ConverteParaReal
    ) {
        var vm = this;

        vm.metodosDialog = {
            fecharDialog: fecharDialog
        };

        _init();

        function _init() {
            vm.ordensServicoCliente = angular.copy(OrdensServicoCliente);
            vm.converteParaReal = ConverteParaReal;
            vm.ordensServicoCliente[1].descricaoStatus = "Em execução";
            vm.dtOptionsClientes = DatatableFactory.construirDtOptionsResponsivoSemPaginacaoPadraoComPesquisaHeaderPadrao(
                [
                    {
                        targets: [2, 3, 4, 5],
                        orderable: false
                    },
                    {
                        targets: 0,
                        width: "30%"
                    }
                ]
            );
        }

        function fecharDialog() {
            $mdDialog.hide();
        }

    }
})();

(function () {
    'use strict';

    angular
        .module('app.manutencao.entrada')
        .controller('DialogEquipamentoItemController', DialogEquipamentoItemController)

    function DialogEquipamentoItemController(
        Equipamento,
        Nota,
        $mdDialog,
        LoginUsuarioService,
        RequisicaoGenericaLocacaoService,
        Api,
        MdToastService,
        MdDialogService,
        Editando,
        CodigoCliente,
        ClienteSelecionado
    ) {
        var vm = this;
        init();

        vm.metodos = {
            cancel: cancel,
            salvar: salvar,
            editar: editar,
            gravar: gravar,
            alterarItemSelecionadoAutoCompleteCliente: alterarItemSelecionadoAutoCompleteCliente,
            pesquisarAutoCompleteCliente: pesquisarAutoCompleteCliente
        }

        function init() {
            vm.filtro = {};
            vm.entrada = Nota;
            vm.equipamentos = Equipamento;
            vm.editando = Editando;
            vm.clienteId = CodigoCliente;
            vm.clienteSelecionado = ClienteSelecionado;
        }

        function alterarItemSelecionadoAutoCompleteCliente(item) {
            if (item) {
                vm.filtro.cliente = item;
            } else {
                vm.filtro.cliente = null;
                vm.textoDePesquisaAutoCompleteCliente = "";
            }
        }

        function pesquisarAutoCompleteCliente(query) {
            var resultado = vm.filtroClientes.filter(function (cliente) {
                if (
                    cliente.nome.toLowerCase().includes(query.toLowerCase()) ||
                    cliente.codigo == query
                ) {
                    return cliente;
                }
            });

            return resultado;
        }

        function cancel() {
            $mdDialog.cancel();
        }

        function gravar(modelo) {
            if (vm.editando)
                editar(modelo);
            else
                salvar(modelo);
        }

        function salvar(modelo) {
            if (modelo.imei == null)
                modelo.imei = " ";
            vm.requisicaoSolicitada = true;
            vm.salvando = true;
            modelo.usuarioId = LoginUsuarioService.usuarioArmazenado().codigo;
            modelo.clienteId = vm.clienteId;
            modelo.cliente = vm.clienteSelecionado.nome;
            RequisicaoGenericaLocacaoService.salvar(Api.manutencao.entrada.criar, modelo)
                .then(function (success) {
                    vm.requisicaoSolicitada = false;
                    MdToastService.toastPadrao("Equipamento cadastrado com sucesso!");
                    vm.salvando = false;
                    $mdDialog.hide(success.data);
                }, function (err) {
                    MdDialogService.alertPadrao("Atenção!", event, err.data.error[0]);
                    vm.salvando = false;
                })
        }

        function editar(modelo) {
            vm.requisicaoSolicitada = true;
            vm.salvando = true;
            modelo.usuarioId = LoginUsuarioService.usuarioArmazenado().codigo;
            modelo.clienteId = vm.clienteId;
            modelo.clienteNome = vm.clienteSelecionado.nome;
            RequisicaoGenericaLocacaoService.editar(Api.manutencao.entrada.editar, modelo)
                .then(function (success) {
                    vm.requisicaoSolicitada = false;
                    MdToastService.toastPadrao("Equipamento editado com sucesso!");
                    $mdDialog.hide(success.data);
                }, function (err) {
                    MdDialogService.alertPadrao("Atenção", event, err.data.error[0]);
                    vm.salvando = false;
                })
        }
    }
}());

(function () {
    'use strict';

    angular
        .module('app.locacao.processamento.locacao.envio.locacao_envio')
        .controller('DialogLocacaoEnvioController',DialogLocacaoEnvioController)

    /** @ngInject */
    function DialogLocacaoEnvioController(
        Api,
        Atendimentos,
        EquipamentoEstadoConservacao,
        TipoLocacao,
        $mdDialog,
        ContratoCliente,
        MostrarTabela
    ) {
        var vm = this;
        vm.atendimentos = Atendimentos;
        vm.equipamentoEstadoConservacao = EquipamentoEstadoConservacao;
        vm.tipoLocacao = TipoLocacao;
        vm.contratoCliente = ContratoCliente;
        vm.mostrarTabela = MostrarTabela

        vm.metodos = {
            cancel: cancel,
            dialog: dialog
        }

        init();

        function cancel() {
            $mdDialog.cancel();
        }
        function init() {
        }

        function dialog() {
            vm.locacaoEnvio.tipoLocacaoId = vm.locacaoEnvio.tipoLocacao.id;
            $mdDialog.hide(vm.locacaoEnvio);
        }
    }

}());
(function () {
    'use strict';

    angular
        .module('app.locacao.processamento.locacao.envio.locacao_envio')
        .controller('DialogEstadoConservacaoController',DialogEstadoConservacaoController)

    /** @ngInject */
    function DialogEstadoConservacaoController(
        $mdDialog,
        EquipamentoEstadoConservacao,
        EstadoConservacaoId,
        $scope,
        ArquivosService,
        ApenasFoto,
        Detalhe,
        MdDialogService,
        RotasHtml
    ) {
        var vm = this;
        vm.locacaoEnvio = {};
        vm.rotasHtml = RotasHtml.locacao_envio;
        vm.locacaoEnvio.fotos = [];
        vm.detalhe = Detalhe;
        vm.carregandoFotos = false;
        vm.apenasFoto = ApenasFoto;
        vm.locacaoEnvio.equipamentoEstadoConservacao = EquipamentoEstadoConservacao[0];


        if (vm.detalhe.fotos != undefined)
            vm.locacaoEnvio.fotos = vm.detalhe.fotos;
        if (EstadoConservacaoId.id == 1)
            vm.locacaoEnvio.equipamentoEstadoConservacao.id = 1;

        else
            vm.locacaoEnvio.equipamentoEstadoConservacao = EstadoConservacaoId;


        vm.equipamentoEstadoConservacao = EquipamentoEstadoConservacao;

        vm.metodos = {
            cancel: cancel,
            dialogEstadoConservacao: dialogEstadoConservacao,
            dialog: dialog,
            selecionarArquivoFotoDivulgacao: selecionarArquivoFotoDivulgacao,
            excluirFoto: excluirFoto,
            zoomFoto: zoomFoto,
            inputFoto: inputFoto
        };

        init();

        function init() {

        }

        function zoomFoto(foto) {
            $mdDialog
                .show({
                    controller: "DialogZoomFotoController",
                    controllerAs: "vm",
                    templateUrl: vm.rotasHtml.dialog.zoomFoto,
                    multiple: true,
                    targetEvent: event,
                    clickOutsideToClose: false,
                    locals: {
                        Foto: foto,
                        Servidor: false
                    }

                })
        }

        function validaTipoImagem(arquivos) {
            var resultado = false;
            angular.forEach(arquivos,function (item,index) {
                if (item.type != "image/jpeg" && item.type != "image/png")
                    resultado = true;
            });
            return resultado;
        }

        function selecionarArquivoFotoDivulgacao(event,arquivos) {
            vm.flagFoto = false;
            vm.carregandoFotos = true;
            if (validaTipoImagem(arquivos)) {
                MdDialogService.alertPadrao("Tipo de arquivo incompatível.");
                vm.carregandoFotos = false;
                return;
            }
            calcularTamanhoArquivosSelecionados(arquivos);
            angular.forEach(arquivos,function (element) {
                ArquivosService.obterArquivo(element).then(function (success) {
                    if (vm.locacaoEnvio.fotos.includes(success.base64StringArquivo)) {
                        if (!vm.flagFoto) {
                            document.getElementById("inputFoto").value = null;
                            MdDialogService.alertPadrao("Não é possível adicionar fotos duplicadas.");
                        }
                        vm.carregandoFotos = false;
                        vm.flagFoto = true;
                        return;
                    }
                    else {
                        vm.locacaoEnvio.fotos.push(success.base64StringArquivo);
                    }

                });
            });
            vm.carregandoFotos = false;
        }

        function dialog(modelo,item) {
            $mdDialog.hide(modelo);
        }

        function cancel() {
            $mdDialog.cancel();
        }

        function dialogEstadoConservacao() {
            $mdDialog.hide();
        }

        $scope.$watch('vm.locacaoEnvio.fotos.length',function (newValue,oldValue) {
            if (newValue == 1) {
                vm.mensagemCaption = "1 arquivo selecionado";
                //calcularTamanhoArquivosSelecionados(vm.locacaoEnvio.fotos);
            }
            else if (newValue > 1) {
                vm.mensagemCaption = vm.locacaoEnvio.fotos.length + " arquivos selecionados";
                //calcularTamanhoArquivosSelecionados(vm.locacaoEnvio.fotos);
            }
            else {
                vm.mensagemCaption = null;
            }
        });

        /**
         * Método que irá calcular o tamanho total de todos os arquivos selecionados
         * @param {arquivos} arquivos Lista de Arquivos Selecionados
         */
        function calcularTamanhoArquivosSelecionados(arquivos) {
            var tamanhoArquivos = null;
            angular.forEach(arquivos,function (item,index) {
                tamanhoArquivos += item.size;
            });


            vm.tamanhosArquivosSelecionados = retornarTamanhoArquivo(tamanhoArquivos);
            vm.tamanhoArquivosSelecionadosEmBite = tamanhoArquivos;

            if (vm.tamanhoArquivosSelecionadosEmBite > vm.tamanhoMaximoArquivosSelecionados)
                vm.desabilitarButtonSalvar = true;
            else
                vm.desabilitarButtonSalvar = false;
        }

        /**
         * Método que retorna o tamanho de todos os arquivos selecionas em B, Kb, Mb ou Gb
         * @param {tamanhoArquivo} tamanhoArquivos Tamanho de todos os arquivos selecionados
         */
        function retornarTamanhoArquivo(tamanhoArquivos) {
            if (tamanhoArquivos < 1024) {
                return Math.trunc(tamanhoArquivos) + "B";
            }
            else if (tamanhoArquivos >= 1024 && tamanhoArquivos < 1048576) {
                return Math.trunc((tamanhoArquivos / 1024)) + "Kb";
            }
            else if (tamanhoArquivos >= 1048576 && tamanhoArquivos < 1073741824) {
                return Math.trunc((tamanhoArquivos / (1024 * 1024))) + "Mb";
            }
            else {
                return Math.trunc((tamanhoArquivos / (1024 * 1024 * 1024))) + "Gb";
            }
        }

        function excluirFoto(index,foto) {
            vm.locacaoEnvio.fotos.splice(index,1);
        }

        function inputFoto() {
            document.getElementById("inputFoto").click();
        }

    }

}());

(function () {
    "use strict";

    angular
        .module("app.locacao.processamento.locacao.envio.locacao_envio")
        .controller("DialogEnvioController",DialogEnvioController);

    /** @ngInject */
    function DialogEnvioController(
        Api,
        Atendimentos,
        $mdDialog,
        Locado,
        Editando
    ) {
        var vm = this;
        vm.atendimentos = Atendimentos;
        vm.locacaoEnvio = Locado;
        vm.editando = Editando;
        vm.metodos = {
            cancel: cancel,
            dialog: dialog
        };

        init();

        function cancel() {
            $mdDialog.cancel();
        }
        function init() {
            if (!vm.editando) {
                vm.locacaoEnvio.dataEnvio = new Date();
                vm.locacaoEnvio.notaFiscalSaida = null;
            }
            else {
                inicializaAtendimentoEditar(vm.locacaoEnvio);
            }


        }

        function dialog(modelo) {
            vm.locacaoEnvio.atendimentoId = modelo.codigo;
            vm.locacaoEnvio.atendimentoAno = modelo.ano;
            $mdDialog.hide(vm.locacaoEnvio);
        }

        function inicializaAtendimentoEditar(envio) {
            vm.resultado = vm.atendimentos.filter(function (item) {
                if (item.ano == envio.atendimentoAno && item.codigo == envio.atendimentoId) {
                    return item;
                }
            });
            vm.atendimentoEnvio = vm.resultado[0];
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.locacao.processamento.locacao.retorno.locacao_retorno')
        .controller('DialogLocacaoRetornoController', DialogLocacaoRetornoController)

    /** @ngInject */
    function DialogLocacaoRetornoController(
        Atendimentos,
        EquipamentoEstadoConservacao,
        TipoLocacao,
        $mdDialog,
        ContratoCliente,
        MostrarTabela,
        Retorno,
        LocacaoRetorno,
        Envio,
        MdDialogService
    ) {
        var vm = this;
        vm.locacaoRetorno = {};
        vm.atendimentos = Atendimentos;
        vm.equipamentoEstadoConservacao = EquipamentoEstadoConservacao;
        vm.tipoLocacao = TipoLocacao;
        vm.contratoCliente = ContratoCliente;
        vm.mostrarTabela = MostrarTabela;
        vm.editando = false;
        vm.tipoRetornos = Retorno;
        vm.envio = Envio;
        if (LocacaoRetorno != null)
            vm.locacaoRetorno = angular.copy(LocacaoRetorno);

        vm.locacaoRetorno.notaFiscalDevolucao = vm.envio.notaFiscalSaida;

        vm.metodos = {
            cancel: cancel,
            dialog: dialog
        }

        init();

        function cancel() {
            $mdDialog.cancel();
        }

        function init() {
            vm.locacaoRetorno.dataRetorno = new Date();
            if (LocacaoRetorno != null) {
                vm.editando = true;
                vm.locacaoRetorno = angular.copy(LocacaoRetorno);
                inicializaAtendimentoEditar(vm.locacaoRetorno);
            }
        }

        function dialog(modelo) {
            if (vm.locacaoRetorno.notaFiscalDevolucao != vm.envio.notaFiscalSaida) {
                MdDialogService.confirmPadraoComEvento("Atenção!",
                    "A nota de saída é diferente da cadastrada nos “Dados de envio”. Deseja salvar mesmo assim?", null, function () {
                        vm.locacaoRetorno.retornoLocacaoId = vm.locacaoRetorno.retornoLocacaoId;
                        vm.locacaoRetorno.atendimentoId = modelo.codigo;
                        vm.locacaoRetorno.atendimentoAno = modelo.ano;
                        $mdDialog.hide(vm.locacaoRetorno, vm.editando);
                    }, function () { });
            } else {
                vm.locacaoRetorno.retornoLocacaoId = vm.locacaoRetorno.retornoLocacaoId;
                vm.locacaoRetorno.atendimentoId = modelo.codigo;
                vm.locacaoRetorno.atendimentoAno = modelo.ano;
                $mdDialog.hide(vm.locacaoRetorno, vm.editando);
            }

        }

        function inicializaAtendimentoEditar(retorno) {
            vm.resultado = vm.atendimentos.filter(function (item) {
                if (item.ano == retorno.atendimentoAno && item.codigo == retorno.atendimentoId) {
                    return item;
                }
            });
            vm.atendimentoRetorno = vm.resultado[0];
        }
    }

}());


(function () {
  "use strict";

  angular
    .module("app.locacao.consulta.controleEquipamento",[])
    .config(config);

  function config($stateProvider,RotasHtml) {
    var rotasHtmlControleEquipamento = RotasHtml.controle_equipamento;
    $stateProvider.state(
      "app.locacao_consulta_controle_equipamento",
      {
        url: "/locacao/consulta/controle-equipamento",
        module: "privado",
        views: {
          "content@app": {
            templateUrl: rotasHtmlControleEquipamento.templateUrl,
            controller: "ControleEquipamentoController as vm"
          }
        },
        resolve: {
          ListarEmpresaAtivo: function (Api,RequisicaoGenericaLocacaoService) {
            return RequisicaoGenericaLocacaoService.listarSemParams(Api.locacao.empresaAtiva.listarTodos);
          }
        }

      }
    );
  }
})();


(function () {
    'use strict';

    angular
        .module('app.locacao.consulta.controleEquipamento')
        .controller('DialogSituacaoController', DialogSituacaoController);

    function DialogSituacaoController(
        Api,
        $mdDialog,
        Equipamento,
        EmpresaAtivoId,
        RequisicaoGenericaLocacaoService,
        DatatableFactory
    ) {
        var vm = this;
        vm.equipamento = Equipamento;
        vm.empresaAtivoId = EmpresaAtivoId;
        vm.obj = {};

        vm.metodos = {
            fecharDialog: fecharDialog,
            pesquisar: pesquisar
        }

        init();

        function init() {
            vm.requisicaoProgress = false;
            vm.mensagemPreloader = "";
            pesquisar(vm.equipamento.equipamentoDescricao);

            vm.dtOptions = DatatableFactory.construirDtOptionsResponsivoSemPaginacaoPadraoComPesquisaHeaderPadrao([
                {
                    targets: [0, 1, 2],
                    orderable: true
                },
                {
                    targets: [0, 1],
                    width: '40%'
                },
                {
                    targets: [2],
                    width: '20%'
                }
            ]);
        }

        function pesquisar(descricao) {
            vm.obj.equipamentoDescricao = descricao;
            vm.obj.empresaAtivoId = vm.empresaAtivoId;
            vm.pesquisando = true;
            RequisicaoGenericaLocacaoService.listarComObjetoComplexo(
                Api.locacao.equipamentos.equipamento.listarPorDescricao, vm.obj
            ).then(function (success) {
                vm.equipamentosRetorno = success.data;
                vm.pesquisando = false;
            });
        }

        function fecharDialog() {
            $mdDialog.hide();
        }
    }

})();


(function () {
    'use strict';

    angular
        .module('app.locacao.consulta.controleEquipamento')
        .controller('DialogTipoController',DialogTipoController);

    function DialogTipoController(
        Api,
        $mdDialog,
        Equipamento,
        EmpresaAtivoId,
        RequisicaoGenericaLocacaoService
    ) {
        var vm = this;
        vm.equipamento = Equipamento;
        vm.empresaAtivoId = EmpresaAtivoId;
        vm.obj = {};

        vm.metodos = {
            fecharDialog: fecharDialog
        }

        init();

        function init() {
            vm.requisicaoProgress = false;
            vm.mensagemPreloader = "";
            // pesquisar(vm.equipamento.equipamentoDescricao);
        }

        // function pesquisar(descricao) {
        //     vm.obj.equipamentoDescricao = descricao;
        //     vm.obj.empresaAtivoId = vm.empresaAtivoId;
        //     vm.pesquisando = true;
        //     RequisicaoGenericaLocacaoService.listarComObjetoComplexo(
        //         Api.locacao.equipamentos.equipamento.listarPorDescricao,vm.obj
        //     ).then(function (success) {
        //         vm.equipamentosRetorno = success.data;
        //         vm.pesquisando = false;
        //     });
        // }

        function fecharDialog() {
            $mdDialog.hide();
        }
    }

})();

(function () {
    'use strict';

    angular
        .module('app.locacao.consulta.controleEquipamento')
        .controller('DialogSituacaoFabricanteController', DialogSituacaoFabricanteController);

    function DialogSituacaoFabricanteController($mdDialog, EquipamentosFabricantes, TituloDialog, DatatableFactory) {
        var vm = this;

        vm.metodos = {
            fecharDialog: fecharDialog
        }

        init();

        function init() {
            vm.equipamentosFabricantes = EquipamentosFabricantes;
            vm.tituloDialog = TituloDialog;

            vm.dtOptions = DatatableFactory.construirDtOptionsResponsivoSemPaginacaoPadraoComPesquisaHeaderPadrao([
                {
                    targets: [0, 1, 2],
                    orderable: true
                },
                {
                    targets: [3],
                    responsivePriority: 1
                },
                {
                    targets: [0, 1],
                    width: '40%'
                },
                {
                    targets: [2],
                    width: '20%'
                }
            ]);

            vm.dtOptions.dom = 'rt<"bottom"<"left"<"info"i>>>';
        }

        function fecharDialog() {
            $mdDialog.hide();
        }
    }

})();

(function () {
    'use strict';

    angular
        .module('app.financeiro.relatorio.risco-rescisao-contratual', [])
        .config(config)

    function config($stateProvider, RotasHtml) {
        var rotasHtml = RotasHtml.relatorioRiscoRescisaoContratual;
        $stateProvider
            .state('app.financeiro_relatorio_risco_rescisao_contratual', {
                url: '/financeiro/relatorio/clientes-em-monitoramento',
                module: 'privado',
                views: {
                    'content@app': {
                        templateUrl: rotasHtml.templateUrl,
                        controller: "RelatorioRiscoRescisaoContratualController as vm"
                    },
                    'form@app.financeiro_relatorio_risco_rescisao_contratual': {
                        templateUrl: rotasHtml.form
                    },
                    'tabela@app.financeiro_relatorio_risco_rescisao_contratual': {
                        templateUrl: rotasHtml.tabela
                    },
                    'card-filtro-utilizado@app.financeiro_relatorio_risco_rescisao_contratual': {
                        templateUrl: rotasHtml.cardFiltroUtilizado
                    }
                },
                resolve: {
                    ListarProdutosAtivosEComercializaveis: function (Api, RequisicaoGenericaService) {
                        return RequisicaoGenericaService.listarSemParams(
                            Api.produto.listarProdutosAtivosEComercializaveis);
                    },
                    ListarTodosEstados: function (Api, RequisicaoGenericaService) {
                        return RequisicaoGenericaService.listarSemParams(Api.display.listarTodasUf);
                    },
                    ListarMotivosRiscosContratuais: function (Api, RequisicaoGenericaService) {
                        return RequisicaoGenericaService.listarSemParams(Api.contrato.motivo_risco_contratual.listarTodosMotivos);
                    }
                }
            });
    }
})();

(function () {
    'use strict';
    angular
        .module('app.financeiro.relatorio.risco-rescisao-contratual')
        .controller('FiltroRelatorioRiscoRescisaoContratualController', FiltroRelatorioRiscoRescisaoContratualController);

    function FiltroRelatorioRiscoRescisaoContratualController($scope, RiscoRescisaoContratualService) {
        var vm = this;
        vm.emProgresso = RiscoRescisaoContratualService.getEmProgresso();
        vm.habilitarTodosEstados = true;
        vm.habilitarTodosProdutos = true;
        vm.habilitarTodosMotivos = true;

        vm.entidade = RiscoRescisaoContratualService.getFiltroUtilizado() || {
            estados: [],
            itensContratuais: [],
            motivos: []
        };

        vm.produtos = RiscoRescisaoContratualService.produtos;
        vm.estados = RiscoRescisaoContratualService.estados;
        vm.motivosRiscosContratuais = RiscoRescisaoContratualService.motivosRiscosContratuais;

        vm.metodos = {
            montarDados: montarDados,
            configurarSelectEstados: configurarSelectEstados,
            ngChangeHabilitarTodosEstados: ngChangeHabilitarTodosEstados,
            configurarSelectProdutos: configurarSelectProdutos,
            ngChangeHabilitarTodosProdutos: ngChangeHabilitarTodosProdutos,
            configurarSelectMotivos: configurarSelectMotivos,
            ngChangeHabilitarTodosMotivos: ngChangeHabilitarTodosMotivos
        }

        $scope.$watch(RiscoRescisaoContratualService.getEmProgresso, function (newValue) {
            vm.emProgresso = newValue;
        });

        $scope.$watch(
            function () { return vm.motivosRiscosContratuais.length; },
            function (newValue) {
                if (newValue === 0) {
                    vm.habilitarTodosMotivos = false;
                }
            }
        );

        $scope.$watch('vm.entidade.estados', function (newValue, oldValue) {
            if (newValue && newValue.length === vm.estados.length) {
                defineValoresDefaultEstados();
                return;
            }

            if (newValue && newValue.length > 0) {
                vm.habilitarTodosEstados = false;
                return;
            }
        });

        $scope.$watch('vm.entidade.itensContratuais', function (newValue, oldValue) {
            if (newValue && newValue.length === vm.produtos.length) {
                defineValoresDefaultProdutos();
                return;
            }

            if (newValue && newValue.length > 0) {
                vm.habilitarTodosProdutos = false;
                return;
            }
        });

        $scope.$watch('vm.entidade.motivos', function (newValue, oldValue) {
            if (newValue && newValue.length > 0) {
                vm.habilitarTodosMotivos = false;
                return;
            }
        });

        function montarDados() {
            RiscoRescisaoContratualService.montarDados(vm.entidade);
        }

        function configurarSelectEstados() {
            vm.termoProcuradoEstados = "";
            angular.element('#select-estado').on('keydown', function (ev) {
                ev.stopPropagation();
            });
        }

        function ngChangeHabilitarTodosEstados() {
            if (vm.habilitarTodosEstados)
                defineValoresDefaultEstados();
        }

        function defineValoresDefaultEstados() {
            vm.habilitarTodosEstados = true;
            vm.entidade.estados = [];
        }

        function configurarSelectProdutos() {
            vm.termoProcuradoProdutos = "";
            angular.element('#select-produto').on('keydown', function (ev) {
                ev.stopPropagation();
            });
        }

        function ngChangeHabilitarTodosProdutos() {
            if (vm.habilitarTodosProdutos)
                defineValoresDefaultProdutos();
        }

        function defineValoresDefaultProdutos() {
            vm.habilitarTodosProdutos = true;
            vm.entidade.itensContratuais = [];
        }

        function configurarSelectMotivos() {
            vm.termoProcuradoMotivos = "";
            angular.element('#select-motivo').on('keydown', function (ev) {
                ev.stopPropagation();
            });
        }

        function ngChangeHabilitarTodosMotivos() {
            if (vm.habilitarTodosMotivos)
                defineValoresDefaultMotivos();
        }

        function defineValoresDefaultMotivos() {
            vm.habilitarTodosMotivos = true;
            vm.entidade.motivos = [];
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('app.geral.indicadores.gestaoiaguas', [])
        .config(Config);

    function Config($stateProvider, RotasHtml) {
        var rotasHtml = RotasHtml.indicadores.gestaoIAguas;

        $stateProvider
            .state('app.geral_indicadores_gestaoiaguas', {
                url: '/geral/indicadores/gestao-iaguas',
                module: 'privado',
                views: {
                    'content@app': {
                        templateUrl: rotasHtml.templateUrl,
                        controller: 'GestaoIAguasController as vm'
                    },
                    'gestao-iaguas-form@app.geral_indicadores_gestaoiaguas': {
                        templateUrl: rotasHtml.form
                    },
                    'filtro-gestao-iaguas@app.geral_indicadores_gestaoiaguas': {
                        templateUrl: rotasHtml.sidenav,
                        controller: 'FiltroGestaoIAguasController as vm'
                    }
                },
                resolve: {
                    ListarClientesIAguas: function (Api, RequisicaoGenericaService) {
                        return RequisicaoGenericaService.listarSemParams(Api.indicadores.gestaoIAguas.listarClientesIAguas);
                    },
                }
            });
    }

})();

(function () {
    'use strict';

    angular
        .module('app.geral.indicadores.gestaoiaguas')
        .controller('FiltroGestaoIAguasController', FiltroGestaoIAguasController);

    function FiltroGestaoIAguasController(GestaoIAguasService, ListarClientesIAguas) {
        var vm = this;

        vm.filtro = {
            tipoFiltro: 1
        };
        vm.clientes = ListarClientesIAguas.data;

        vm.metodos = {
            filtrarDados: filtrarDados
        };

        function filtrarDados() {
            var viewModel = angular.copy(vm.filtro);

            if (viewModel.clientes.length > 0) {
                viewModel.codigoClientes = viewModel.clientes.map(function (item) { return item.codigo; });
            }
            else {
                viewModel.codigoClientes = vm.clientes.map(function (item) { return item.codigo; })
            }

            if (vm.filtro.tipoFiltro == 1) {
                viewModel.dataInicio = null;
                viewModel.dataFim = null;
            }

            GestaoIAguasService.setFiltro(viewModel);
            GestaoIAguasService.listener(function () { return viewModel; });
            GestaoIAguasService.toggleFiltro();
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.geral.indicadores.gestaoiaguas')
        .controller('InformativoGestaoIAguasDialogController', InformativoGestaoIAguasDialogController);

    function InformativoGestaoIAguasDialogController($mdDialog) {
        var vm = this;

        vm.metodosDialog = {
            fecharDialog: fecharDialog
        }

        function fecharDialog() {
            $mdDialog.hide();
        }
    }

})();
(function () {
    'use strict';

    angular
        .module('app.datamobil', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider) {
        $stateProvider
            .state('app.datamobil', {
                url: '/datamobil',
                module: 'privado',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/datamobil-ia/datamobil-ia.html',
                        controller: 'DatamobilController as vm'
                    }
                }
            });
    }
})();

(function () {
    'use strict';

    angular
        .module('app.datamobil')
        .controller('TabelaRespostaController', TabelaRespostaController)
        .directive('tabelaResposta', tabelaResposta);

    /** @ngInject */
    function TabelaRespostaController($scope, $filter) {
        var vm = this;

        var dadosOriginais = [];
        var dadosProcessados = [];

        vm.pesquisar = '';
        vm.cabecalhos = [];
        vm.dadosPaginados = [];
        vm.paginacao = {
            paginaAtual: 1,
            itensPorPagina: 5,
            opcoesItensPorPagina: [5, 10, 20, 50, 100, 500],
            totalItens: 0,
            totalPaginas: 0,
            itemInicial: 0,
            itemFinal: 0
        };
        vm.ordenacao = {
            coluna: null,
            direcao: 'asc'
        };

        vm.metodos = {
            primeiraPagina: primeiraPagina,
            paginaAnterior: paginaAnterior,
            proximaPagina: proximaPagina,
            ultimaPagina: ultimaPagina,
            mudarItensPorPagina: mudarItensPorPagina,
            ordenarPor: ordenarPor,
            processarDados: processarDados
        };

        $scope.$watch('vm.data', function (novosDados) {
            if (novosDados && angular.isArray(novosDados)) {
                ativar(angular.copy(novosDados));
            }
        });

        $scope.$watch('vm.pesquisar', function (novoValor, valorAntigo) {
            if (novoValor !== valorAntigo) {
                vm.paginacao.paginaAtual = 1;
                processarDados();
            }
        });

        function ativar(dados) {
            dadosOriginais = dados;
            if (dados.length > 0) {
                vm.cabecalhos = Object.keys(dados[0]).filter(function (key) {
                    return key !== '$$hashKey';
                });
                vm.pesquisar = '';
                vm.ordenacao.coluna = null;
                vm.paginacao.paginaAtual = 1;
                processarDados();
            } else {
                dadosOriginais = [];
                dadosProcessados = [];
                vm.cabecalhos = [];
                atualizarPaginacao();
            }
        }

        function processarDados() {
            var dadosFiltrados = $filter('filter')(dadosOriginais, vm.pesquisar);

            if (vm.ordenacao.coluna) {
                dadosFiltrados.sort(function (a, b) {
                    var valorA = a[vm.ordenacao.coluna];
                    var valorB = b[vm.ordenacao.coluna];
                    var resultado = 0;

                    if (typeof valorA === 'number' && typeof valorB === 'number') {
                        resultado = valorA - valorB;
                    } else {
                        resultado = String(valorA).localeCompare(String(valorB));
                    }
                    return vm.ordenacao.direcao === 'asc' ? resultado : -resultado;
                });
            }

            dadosProcessados = dadosFiltrados;
            atualizarPaginacao();
        }

        function ordenarPor(coluna) {
            if (vm.ordenacao.coluna === coluna) {
                vm.ordenacao.direcao = vm.ordenacao.direcao === 'asc' ? 'desc' : 'asc';
            } else {
                vm.ordenacao.coluna = coluna;
                vm.ordenacao.direcao = 'asc';
            }
            vm.paginacao.paginaAtual = 1;
            processarDados();
        }

        function mudarItensPorPagina() {
            vm.paginacao.paginaAtual = 1;
            atualizarPaginacao();
        }

        function primeiraPagina() {
            if (vm.paginacao.paginaAtual > 1) {
                vm.paginacao.paginaAtual = 1;
                atualizarPaginacao();
            }
        }

        function paginaAnterior() {
            if (vm.paginacao.paginaAtual > 1) {
                vm.paginacao.paginaAtual--;
                atualizarPaginacao();
            }
        }

        function proximaPagina() {
            if (vm.paginacao.paginaAtual < vm.paginacao.totalPaginas) {
                vm.paginacao.paginaAtual++;
                atualizarPaginacao();
            }
        }

        function ultimaPagina() {
            if (vm.paginacao.paginaAtual < vm.paginacao.totalPaginas) {
                vm.paginacao.paginaAtual = vm.paginacao.totalPaginas;
                atualizarPaginacao();
            }
        }

        function atualizarPaginacao() {
            if (!dadosProcessados) return;

            vm.paginacao.totalItens = dadosProcessados.length;
            vm.paginacao.totalPaginas = Math.ceil(vm.paginacao.totalItens / vm.paginacao.itensPorPagina) || 1;

            if (vm.paginacao.paginaAtual > vm.paginacao.totalPaginas) {
                vm.paginacao.paginaAtual = vm.paginacao.totalPaginas;
            }

            var inicio = (vm.paginacao.paginaAtual - 1) * vm.paginacao.itensPorPagina;
            var fim = inicio + vm.paginacao.itensPorPagina;

            vm.dadosPaginados = dadosProcessados.slice(inicio, fim);

            vm.paginacao.itemInicial = vm.paginacao.totalItens > 0 ? inicio + 1 : 0;
            vm.paginacao.itemFinal = Math.min(fim, vm.paginacao.totalItens);
        }
    }

    function tabelaResposta() {
        return {
            restrict: 'E',
            scope: {
                data: '='
            },
            templateUrl: 'app/main/datamobil-ia/components/mensagens-recebidas/components/tabela-resposta/tabela-resposta.html',
            controller: 'TabelaRespostaController',
            controllerAs: 'vm',
            bindToController: true
        };
    }
})();
(function () {
    "use strict";
    angular
        .module('app.datamobil')
        .controller("FavoritosDialogController", FavoritosDialogController);

    function FavoritosDialogController($mdDialog, $timeout, MdToastService, DatamobilIaService, MdDialogService, favorito) {
        var vm = this;

        vm.favorito = favorito || {};
        vm.modoEdicao = !!(favorito && favorito.id);
        vm.titulo = vm.modoEdicao ? "Editar favorito" : "Favoritar";
        vm.favoritando = false;
        vm.acaoCopiar = false;
        vm.metodos = {
            fecharDialog: fecharDialog,
            cancelar: cancelar,
            salvar: salvar,
            copiarComando: copiarComando
        };

        function mostrarDialogErroServidor() {
            MdDialogService.alertPadrao(
                'Atenção!',
                null,
                'Não foi possível concluir sua solicitação no momento.<br><br>Tente novamente em alguns instantes.'
            );
        }

        function fecharDialog() {
            if (vm.favoritando) return;
            $mdDialog.hide();
        }

        function cancelar() {
            if (vm.favoritando) return;
            $mdDialog.cancel();
        }

        function salvar() {
            vm.favoritando = true;
            var promise;
            if (vm.modoEdicao) {
                promise = DatamobilIaService.editarFavorito(vm.favorito);
            } else {
                promise = DatamobilIaService.criarFavorito(vm.favorito);
            }

            promise.then(function () {
                var msg = vm.modoEdicao ? 'Favorito atualizado com sucesso!' : 'Favorito criado com sucesso!';
                MdToastService.toastPadrao(msg, false);
                vm.favoritando = false;
                fecharDialog();
            }).catch(function () {
                mostrarDialogErroServidor();
                vm.favoritando = false;
            });
        }

        function copiarComando() {
            vm.acaoCopiar = true;

            var texto = vm.favorito.comando;
            var textarea = document.createElement('textarea');
            textarea.value = texto;
            textarea.style.position = 'fixed';
            textarea.style.left = '-999999px';
            textarea.style.top = '-999999px';
            document.body.appendChild(textarea);
            textarea.focus();
            textarea.select();
            document.execCommand('copy');
            document.body.removeChild(textarea);

            $timeout(function () {
                vm.acaoCopiar = false;
            }, 3000);
        }
    }
})();
(function () {
    'use strict';
    angular
        .module('app.atendimento.processamento.atualizacoespendentes')
        .controller('SidenavAtualizacoesPendentesController', SidenavAtualizacoesPendentesController);

    function SidenavAtualizacoesPendentesController(
        SidenavAtualizacoesPendentesService,
        ListarDetalhesUsuario,
        SquadService,
        $scope
    ) {
        var vm = this;
        vm.filtro = {};
        vm.squadUsuarioLogado = ListarDetalhesUsuario.data.codigoSquads;
        vm.squads = SquadService.listarSquadsUsuarioLogado(vm.squadUsuarioLogado);
        init();

        $scope.$watch(function () {
            return SidenavAtualizacoesPendentesService.emProgresso;
        }, function (novoValor) {
            vm.emProgresso = novoValor;
        });

        vm.metodos = {
            filtrarDados: filtrarDados,
        };

        function init() {
            vm.filtro.squadCodigo = vm.squads.map(function (s) {
                return s.codigo;
            });
        }

        function filtrarDados(filtro) {
            var squadCodigo = (vm.squadUsuarioLogado.length === 1) ? [vm.squadUsuarioLogado[0]] : filtro.squadCodigo;
            var viewModel = {
                squadCodigo: squadCodigo
            };
            SidenavAtualizacoesPendentesService.listener(function () { return viewModel; });
        }
    }
})();

/**
 * Created by nova on 05/08/2016.
 */
(function () {
    'use strict';

    angular.module('app.diretivas')
        .controller('ToolbarHistoricoAtendimentoController', ToolbarHistoricoAtendimentoController)
        .directive('toolbarHistoricoAtendimento', toolbarHistoricoAtendimentoDirective);


    function ToolbarHistoricoAtendimentoController($scope, $mdDialog, RotasHtml, AtendimentoService, AtendimentoFactory) {
        var vm = this;
        vm.rotasHtml = RotasHtml.atendimento;

        vm.metodos = {
            primeiro: primeiro,
            anterior: anterior,
            proximo: proximo,
            ultimo: ultimo,
            modoTabela: modoTabela,
            abrirDialogVisualizacaoHistorico: abrirDialogVisualizacaoHistorico
        };


        function abrirDialogVisualizacaoHistorico($event) {
            $mdDialog.show({
                controller: 'DialogVisualizacaoHistoricoAtendimentoController',
                controllerAs: 'vm',
                templateUrl: vm.rotasHtml.dialogVisualizacaoHistoricoAtendimento,
                parent: angular.element(document.body),
                targetEvent: $event,
                clickOutsideToClose: true,
                locals: {
                    historicoAtendimentos: vm.historicoAtendimentos,
                    indexHistoricoAtendimento: vm.indexHistoricoAtendimento
                }
            });
        }


        function primeiro() {
            vm.indexHistoricoAtendimento = 0;
            vm.historicoAtendimentoSelecionado = vm.historicoAtendimentos[vm.indexHistoricoAtendimento].descricao;
            vm.informacoesHistoricoAtendimento = vm.historicoAtendimentos[vm.indexHistoricoAtendimento];
        }
        function anterior() {
            vm.indexHistoricoAtendimento--;
            vm.historicoAtendimentoSelecionado = vm.historicoAtendimentos[vm.indexHistoricoAtendimento].descricao;
            vm.informacoesHistoricoAtendimento = vm.historicoAtendimentos[vm.indexHistoricoAtendimento];
        }
        function proximo() {
            vm.indexHistoricoAtendimento++;
            vm.historicoAtendimentoSelecionado = vm.historicoAtendimentos[vm.indexHistoricoAtendimento].descricao;
            vm.informacoesHistoricoAtendimento = vm.historicoAtendimentos[vm.indexHistoricoAtendimento];
        }

        function ultimo() {
            vm.indexHistoricoAtendimento = vm.historicoAtendimentos.length - 1;
            vm.historicoAtendimentoSelecionado = vm.historicoAtendimentos[vm.indexHistoricoAtendimento].descricao;
            vm.informacoesHistoricoAtendimento = vm.historicoAtendimentos[vm.indexHistoricoAtendimento];
        }

        function modoTabela() {
            $scope.$emit('exibirTabelaHistoricos');
        }
    } // Controller

    function toolbarHistoricoAtendimentoDirective(RotasHtml) {
        var rotasHtml = RotasHtml.atendimento;
        return {
            templateUrl: rotasHtml.diretiva.toolbarHistoricoAtendimento,
            scope: {},
            controller: 'ToolbarHistoricoAtendimentoController as vm',
            restrict: "AE",
            bindToController: {
                indexHistoricoAtendimento: '=?',
                historicoAtendimentos: '=?',
                historicoAtendimentoSelecionado: '=?',
                informacoesHistoricoAtendimento: '=?',
                editarHistorico: '&?',
                editarVisualizacaoHistorico: '&?'
            }
        }
    }
})();

//<!-- Ultima mudança 18/05/2017.-->
(function () {
    'use strict';

    angular
        .module('app.atendimento.processamento.atendimentosEmAberto', [])
        .config(config);

    function config($stateProvider, RotasHtml) {
        var rotasHtmlAtendimento = RotasHtml.atendimento;
        $stateProvider
            .state('app.atendimento_processamento_atendimentos_em_aberto', {
                url: '/atendimento/processamento/atendimento-em-aberto',
                module: 'privado',
                params: {
                    parametros: null,
                    iniciarListandoAtendimentosEmAberto: true,
                    codigoUsuariosHaListarAtendimentosEmAberto: null,
                    listarAtendimentosUsuarioComQuantidadeLimiteExcedida: null,
                    codigoUsuariosComAtendimentosEmAbertoExcedidos: null
                },
                views: {
                    'content@app': {
                        templateUrl: rotasHtmlAtendimento.templateUrl,
                        controller: "AtendimentoController as vm"
                    },
                    'atendimento-form@app.atendimento_processamento_atendimentos_em_aberto': {
                        templateUrl: rotasHtmlAtendimento.form
                    },
                    'atendimentos-tabela@app.atendimento_processamento_atendimentos_em_aberto': {
                        templateUrl: rotasHtmlAtendimento.tabelaAtendimentosEmAberto
                    }
                },
                resolve: {
                    ListarTodosUsuariosAtivos: function (Api, RequisicaoGenericaService) {
                        return RequisicaoGenericaService.listarSemParams(Api.usuario.detalhes_usuario.listarUsuariosAtivos);
                    },
                    ListarTiposAtendimento: function (Api, RequisicaoGenericaService) {
                        return RequisicaoGenericaService.listarSemParams(Api.atendimento.listarTiposAtendimento);
                    },
                    ListarStatusAtendimento: function (Api, RequisicaoGenericaService) {
                        return RequisicaoGenericaService.listarSemParams(Api.atendimento.listarStatusAtendimento);
                    },
                    ListarDetalhesUsuario: function (Api, RequisicaoGenericaService, LoginUsuarioService) {
                        return RequisicaoGenericaService.listarSemParams(Api.usuario.detalhes_usuario.listarDetalhesUsuario
                            + LoginUsuarioService.usuarioArmazenado().codigo);
                    },
                    ListarUsuarioPorDetalhe: function (Api, RequisicaoGenericaService, LoginUsuarioService) {
                        return RequisicaoGenericaService.listarSemParams(Api.usuario.detalhes_usuario.listarUsuarioPorDetalhe
                            + LoginUsuarioService.usuarioArmazenado().codigo);
                    },
                    ListarTodasSolucoes: function (Api, RequisicaoGenericaService) {
                        return RequisicaoGenericaService.listarSemParams(Api.solucao_rotinas_tarefas.solucao.listarCodigoDescricao);
                    },
                    ListarTodosAtendimentosMotivo: function (Api, RequisicaoGenericaService) {
                        return RequisicaoGenericaService.listarSemParams(Api.atendimento.grupo_atendimento.listarPor);
                    },
                    ListarTodosAtendimentosPendencia: function (Api, RequisicaoGenericaService) {
                        return RequisicaoGenericaService.listarSemParams(Api.atendimento.pendencia_atendimento.listarPor);
                    },
                    ListarTodosAtendimentosConclusao: function (Api, RequisicaoGenericaService) {
                        return RequisicaoGenericaService.listarSemParams(Api.atendimento.conclusao.listarPor);
                    },
                    ListarTodosEventos: function (Api, RequisicaoGenericaService) {
                        return RequisicaoGenericaService.listarSemParams(Api.agenda.evento.listarTodos);
                    },
                    ListarStatusAtividade: function (Api, RequisicaoGenericaService) {
                        return RequisicaoGenericaService.listarSemParams(Api.agenda.atividade.listarStatus);
                    },
                    ListarTodasTags: function (Api, RequisicaoGenericaService) {
                        return RequisicaoGenericaService.listarSemParams(Api.atendimento.tag.listarTodas);
                    },
                    ListarUsuariosSetorComercial: function (Api, RequisicaoGenericaService) {
                        return RequisicaoGenericaService.listarSemParams(Api.usuario.listarUsuariosSetorComercial);
                    },
                }
            });
    }

})();

/**
 * Created by nova on 26/10/2016.
 */
(function () {
    'use strict';

    angular
        .module('app.atendimento.processamento.atendimentosEmAberto')
        .controller('AtendimentoDialogUsuariosComAtendimentoEmAbertoDoSetor',
            AtendimentoDialogUsuariosComAtendimentoEmAbertoDoSetor);


    function AtendimentoDialogUsuariosComAtendimentoEmAbertoDoSetor(
        $mdDialog,
        $scope,
        Api,
        CodigoSetor,
        DataTableConfigPadrao,
        DetalhesUsuarioLogadoComUsuario,
        ListarAtendimentosEmAbertoUsuarioSelecionado,
        RequisicaoGenericaService,
        SquadUsuarioLogado,
        SquadService
    ) {

        var vm = this;

        // Data region
        vm.form = {};
        vm.inserirAtivo = false;
        vm.requisicaoSolicitada = false;
        vm.titulo = "Colaboradores com atendimento em aberto";

        vm.codigoUsuariosSelecionados = [];
        vm.squadUsuarioLogado = SquadUsuarioLogado;
        vm.squads = SquadService.listarSquadsUsuarioLogado(vm.squadUsuarioLogado);

        vm.dtOptions = angular.copy(DataTableConfigPadrao.dtOptionsResponsivoSemPaginacaoComInitComplete);

        //endregion

        /**
         * Chamada do metódo inicializador
         */
        init();

        // Definição dos Métodos region
        vm.metodosDialog = {
            pesquisar: pesquisar,
            verificaQuantidadeUsuariosSelecionado: verificaQuantidadeUsuariosSelecionado,
            alterarEstadoCheckboxTodosUsuarios: alterarEstadoCheckboxTodosUsuarios,
            fecharDialog: metodoDialogFecharDialog,
            selectChangeSquad: selectChangeSquad
        };
        //endregion

        // Métodos Internos region

        /**
         * Método inicizalizador
         */
        function init() {
            /**
             * Realiza uma requisição para Api para buscar todos os colaboradores
             */
            _listarUsuariosComAtendimentoEmAbertoPorSetor();
        }

        /**
         * Watch que fica escutando o tamanho do model 'vm.codigoUsuariosSelecionados' e se ele or maior que zero, o checkbox todos usuários é
         * desmarcado
         */
        $scope.$watch('vm.codigoUsuariosSelecionados.length', function (newValue, oldValue) {
            if (!vm.codigoUsuariosSelecionados)
                if (newValue > 0)
                    vm.todosUsuarios = false;
        })

        /**
         * Método que irá pesquisar os atendimentos em aberto do usuário solicitado
         * @param {listaCodigoUsuarios} listaCodigoUsuarios Lista com o Codigo de todos os usuários selecionados
         * @param {eventDoButton} event
         */
        function pesquisar(listaCodigoUsuarios, event) {
            if (vm.todosUsuarios) {
                listaCodigoUsuarios = vm.usuarios.map(function (usuario) {
                    return usuario.codigo
                })
            }
            var modelo = {
                codigoUsuarioGerente: DetalhesUsuarioLogadoComUsuario.codigoUsuario,
                listaCodigoUsuarios: listaCodigoUsuarios
            }
            ListarAtendimentosEmAbertoUsuarioSelecionado(modelo);
            $mdDialog.hide();
        }

        function verificaQuantidadeUsuariosSelecionado(codigoUsuariosSelecionados) {
            if ((angular.equals(codigoUsuariosSelecionados, []) || codigoUsuariosSelecionados === null) && (vm.usuarios && vm.usuarios.length)) {
                vm.todosUsuarios = true;
            }
            else
                vm.todosUsuarios = false;

        }

        /**
         * Método que limpa o model 'vm.codigoUsuariosSelecionados' quando o checkbox todos usuários estiver habilitado
         * @param {todosUsuarios} todosUsuarios
         */
        function alterarEstadoCheckboxTodosUsuarios(todosUsuarios) {
            if (todosUsuarios)
                vm.codigoUsuariosSelecionados = [];
        }

        /**
         * Método para fechar o dialog quando pressionado o "X" no toolbar do Dialog
         */
        function metodoDialogFecharDialog() {
            $mdDialog.hide();
        }

        function selectChangeSquad(codigoSquadSelecionada) {
            vm.codigoUsuariosSelecionados = null;
            if (!codigoSquadSelecionada) {
                vm.todosUsuarios = false;
            } else {
                vm.usuarios = vm.usuariosComAtendimentoEmAberto.filter(function (usuarios) {
                    return usuarios.codigoSquads.some(function (codigoSquad) {
                        return codigoSquadSelecionada.includes(codigoSquad)
                    })
                });
                vm.todosUsuarios = vm.usuarios.length === 0 ? false : true;;
            }
        }

        function _listarUsuariosComAtendimentoEmAbertoPorSetor() {
            RequisicaoGenericaService.listarSemParams(Api.atendimento.listarUsuariosComAtendimentoEmAbertoPorSetor + CodigoSetor).then(
                function (success) {
                    if (vm.squadUsuarioLogado.length === 1) {
                        var codigoSquadLogado = vm.squadUsuarioLogado;
                        vm.usuarios = success.data.filter(function (usuario) {
                            return usuario.codigoSquads.some(function (codigoSquad) {
                                return codigoSquadLogado.includes(codigoSquad)
                            })
                        });

                        if (vm.usuarios && vm.usuarios.length) {
                            vm.todosUsuarios = true;
                        }

                    }
                    vm.usuariosComAtendimentoEmAberto = success.data;
                    vm.codigoSquads = vm.squadUsuarioLogado;
                    selectChangeSquad(vm.squadUsuarioLogado)
                }, function (error) {
                    console.error('error: ', error);
                });
        }

        //endregion
    } // CONTROLLER

})();

(function () {
    'use strict';

    angular.module('app.atendimento.processamento.atendimentosEmAberto')
        .controller('DialogHistoriasVinculadasController', DialogHistoriasVinculadasController);

    function DialogHistoriasVinculadasController(Historias, DataTableConfigPadrao, EstoriaFactory, $mdDialog, $state) {
        var vm = this;

        vm.historias = Historias;

        init();

        vm.metodos = {
            fecharDialog: fecharDialog,
            abrirHistoriaNovaAba: abrirHistoriaNovaAba
        }

        function init() {
            vm.dtOptions = angular.copy(DataTableConfigPadrao.dtOptionsPadraoComPaginacaoPaginTypeNumbersEReponsivo);
            vm.dtOptions.columnDefs = [
                {
                    targets: [6],
                    orderable: false
                }
            ];

            vm.coresSituacoes = EstoriaFactory.coresSituacoes();
        }

        function fecharDialog() {
            $mdDialog.hide();
        }

        function abrirHistoriaNovaAba(historia) {
            $state.goNewTab("app.planejamento_processamento_estoria", {
                parametros: {
                    numero: historia.numero,
                    ano: historia.ano,
                    squadCodigo: historia.squadCodigo,
                    chamarPesquisa: true
                }
            });
        }
    }
})();
/**
 * Created by nova on 18/07/2016.
 */
(function () {
  'use strict';

  angular
    .module('app.service',
      [

      ]
    );

})();

angular
    .module('app.service')
    .service("MdToastAtividadeService", MdToastAtividadeService)

function MdToastAtividadeService($mdToast, $timeout) {
    var vm = this;
    this.isOpen = false;

    this.show = function (atividade) {
        vm.cor = _retornaCorAtividade(atividade);
        vm.texto = atividade.title;
        vm.toast = $mdToast.simple()
            .textContent(vm.texto)
            .position('bottom')
            .theme(vm.cor)
            .hideDelay();

        this.isOpen = true;

        $mdToast.show(
            vm.toast
        );
    }

    function _retornaCorAtividade(atividade) {
        switch (atividade.color) {
            case '#3A87AD': return 'aberto-toast';
            case '#4CAF50': return 'executado-toast';
            case '#F44336': return 'cancelado-toast';
            case '#FF9800': return 'ausencia-toast';
        }
    }

    this.dimiss = function () {
        return $mdToast.hide();
    }

}
(function () {
    'use strict';

    angular
        .module('app.agenda.processamento.visualizarAtividades', [
            'ui.calendar'])
        .config(config);

    /** @ngInject */
    function config($stateProvider, RotasHtml) {
        // State
        $stateProvider
            .state('app.visualizar_atividades', {
                url: '/agenda/visualizarAtividades',
                module: 'privado',
                views: {
                    'content@app': {
                        templateUrl: RotasHtml.agenda.atividade.visualizacao,
                        controller: 'VisualizarAtividadesController as vm'
                    }
                },
                resolve: {
                    parametros: function () {
                        return null;
                    },
                    DesabilitarAtendimento: function () {
                        return null;
                    },
                    ListarAtividadesPorCliente: function () {
                        return null;
                    },
                    ListarTodosUsuarios: function (Api, RequisicaoGenericaService) {
                        return RequisicaoGenericaService.listarSemParams(Api.usuario.detalhes_usuario.listarUsuariosAtivos);
                    },
                    ListarAtividadesPorUsuario: function (Api, LoginUsuarioService, RequisicaoGenericaService) {
                        const mesAtual = new Date().getMonth() + 1;
                        const anoAtual = new Date().getFullYear();

                        return RequisicaoGenericaService.listarSemParams(
                            Api.agenda.atividade.listarAtividadesPorColaborador +
                            '?codigoUsuario=' + LoginUsuarioService.usuarioArmazenado().codigo +
                            '&mes=' + mesAtual +
                            '&ano=' + anoAtual
                        );
                    },
                    ListarStatus: function (Api, RequisicaoGenericaService) {
                        return RequisicaoGenericaService.listarSemParams(Api.agenda.atividade.listarStatus);
                    },
                    ListarTodosEventos: function (Api, RequisicaoGenericaService) {
                        return RequisicaoGenericaService.listarSemParams(Api.agenda.evento.listarTodos);
                    },
                    ListarDetalhesUsuario: function (Api, RequisicaoGenericaService, LoginUsuarioService) {
                        return RequisicaoGenericaService.listarSemParams(Api.usuario.detalhes_usuario.listarDetalhesUsuario
                            + LoginUsuarioService.usuarioArmazenado().codigo);
                    },
                },
                bodyClass: 'calendar'
            });

    }
})();
(function () {
    'use strict';

    angular.module('app.agenda.processamento.visualizarAtividades')
        .controller('DialogLegendaController', DialogLegendaController);

    /** @ngInject */
    function DialogLegendaController($mdDialog, RotinaVisualizacaoAtividade) {

        var vm = this;
        init();

        function init() {
            if (RotinaVisualizacaoAtividade) {
                vm.legendas = [
                    { descricao: 'Aberta' },
                    { descricao: 'Executada' },
                    { descricao: 'Cancelada' },
                    { descricao: 'Ausência' }
                ]
            } else {
                vm.legendas = [
                    { descricao: 'Aberto' },
                    { descricao: 'Finalizado' },
                ]
            }

            vm.closeDialog = closeDialog;
        }

        function closeDialog() {
            $mdDialog.hide();
        }

    }
})();

(function () {
    'use strict';

    angular.module('app.agenda.processamento.visualizarAtividades')
        .controller('DialogDetalhesAtividadesController', DialogDetalhesAtividadesController);

    /** @ngInject */
    function DialogDetalhesAtividadesController($mdDialog, $scope, $rootScope, calendarEvent,
        MdToastService, MdDialogService, $timeout, MenuFactory, LoginUsuarioService, VisualizarAtividadeService, RequisicaoGenericaService, codigoColaboradorLogado,
        status, eventos, Api, event) {

        var vm = this;

        init();
        // Methods
        vm.metodos = {
            selecionarStatus: selecionarStatus,
            salvar: salvar,
            irParaInterfaceDeAtividade: irParaInterfaceDeAtividade,
            clonarAtividade: clonarAtividade,
            redirecionarParaCliente: redirecionarParaCliente,
            redirecionarParaAtendimento: redirecionarParaAtendimento,
        }

        function init() {
            vm.mindate = new Date();
            vm.rota = Api.agenda.atividade;
            vm.calendarEvent = calendarEvent;
            vm.desabilitarCampos = vm.calendarEvent.usuario.codigo != LoginUsuarioService.usuarioArmazenado().codigo;
            vm.status = status;
            vm.eventos = eventos;
            vm.statusOriginal = angular.copy(calendarEvent.status);
            vm.calendarEvent.dataHoraUltimoHistorico = new Date(vm.calendarEvent.dataHoraUltimoHistorico)
            vm.dataHoraUltimoHistoricoOriginal = angular.copy(vm.calendarEvent.dataHoraUltimoHistorico);
            vm.ocultarClonagem = (vm.calendarEvent.atividadeVinculadaAtendimento == undefined || vm.calendarEvent.atividadeVinculadaAtendimento == false);
            _setStyleHeader(vm.calendarEvent.color);
            vm.closeDialog = closeDialog;
        }

        $scope.$watch('vm.reagendamento', function () {
            if (vm.calendarEvent.dataHoraUltimoHistorico.setHours(0, 0, 0, 0) < new Date().setHours(0, 0, 0, 0))
                vm.calendarEvent.dataHoraUltimoHistorico = null;

            if (!vm.reagendamento)
                _limparCamposReagendamento();
        })

        $scope.$watch('vm.calendarEvent.hora', function () {
            if (vm.calendarEvent.hora && vm.calendarEvent.hora.length <= 0)
                vm.calendarEvent.motivo = null;
        })

        $scope.$watch('vm.calendarEvent.status', function () {
            if (vm.calendarEvent.status != 1)
                _limparCamposReagendamento();
        })

        function selecionarStatus() {
            if (vm.calendarEvent.status == 1 && (vm.calendarEvent.evento.codigo == 63 ||
                vm.calendarEvent.evento.codigo == 64 ||
                vm.calendarEvent.evento.codigo == 65)) {
                _setStyleHeader("#FF9800");
            }

            else {
                switch (vm.calendarEvent.status) {
                    case 1: _setStyleHeader("#3A87AD"); break;
                    case 2: _setStyleHeader("#4CAF50"); break;
                    case 3: _setStyleHeader("#F44336"); break;
                }
            }
        }

        function _setStyleHeader(color) {
            vm.styleHeader = { "background": color };
        }

        function salvar(atividade) {
            vm.emProgresso = true;
            var entidade = {
                ano: atividade.ano,
                numero: atividade.numero,
                codigoColaboradorResponsavel: codigoColaboradorLogado,
                dataAtividade: atividade.dataHoraUltimoHistorico,
                dataAtividadeString: atividade.dataHoraUltimoHistorico.toLocaleDateString(),
                hora: atividade.hora,
                status: atividade.status,
                motivo: atividade.motivo,
                motivoCancelamento: atividade.motivoCancelamento,
            }
            RequisicaoGenericaService.editar(vm.rota.reagendar, entidade)
                .then(function (success) {
                    MdToastService.toastPadrao("Atividade atualizada com sucesso!", "");
                    vm.emProgresso = false;
                    closeDialog();
                    $rootScope.$emit('atividadeReagendada', atividade);
                }).catch(function (erro) {
                    vm.emProgresso = false;
                    MdDialogService.alertPadrao("Atenção!", event, erro.data);
                });
        }

        function irParaInterfaceDeAtividade() {
            _redirecionarNovaAba('app.atividade_cadastro', {
                parametros: {
                    numero: vm.calendarEvent.numero,
                    ano: vm.calendarEvent.ano,
                    chamarPesquisa: true
                }
            })
        }

        function clonarAtividade() {
            vm.calendarEvent.ultimoHistorico = {
                data: null,
                hora: null
            }
            vm.calendarEvent.usuarioAtivo = vm.calendarEvent.usuario;

            if (vm.calendarEvent.atividadeVinculadaAtendimento) {
                vm.calendarEvent.atendimento = {
                    codigo: vm.calendarEvent.numeroAtendimento,
                    ano: vm.calendarEvent.anoAtendimento
                }
            }

            VisualizarAtividadeService
                .abrirCadastroAtividade(event,
                    vm.calendarEvent, { data: vm.eventos }, { data: vm.status }, true);
        }

        function _limparCamposReagendamento() {
            vm.reagendamento = false;
            vm.calendarEvent.dataHoraUltimoHistorico = new Date(vm.dataHoraUltimoHistoricoOriginal);
            vm.calendarEvent.hora = null;
            vm.calendarEvent.motivo = null;
        }

        function redirecionarParaAtendimento() {
            _redirecionarNovaAba('app.atendimento_processamento_atendimento', {
                parametros: {
                    codigo: vm.calendarEvent.numeroAtendimento,
                    ano: vm.calendarEvent.anoAtendimento,
                    chamarPesquisa: true
                }
            })
        }

        function redirecionarParaCliente(cliente) {
            _redirecionar('app.geral_cadastro_cliente_cliente', {
                navegacaoDeRelatorioAtendimento: { cliente: cliente }
            })
        }

        function _redirecionar(state, param) {
            closeDialog();
            $mdDialog.hide();
            MenuFactory.navegarParaEstadoSeUsuarioTerAcesso(state, param);
        }

        function _redirecionarNovaAba(state, param) {
            MenuFactory.navegarParaOutrabaSeUsuarioTerAcesso(state, param);
        }

        function closeDialog() {
            $mdDialog.hide();
        }

    }
})();

(function () {
    'use strict';

    angular
        .module('app.trabalheconosco.processamento.curriculo', [])
        .config(Config);

    function Config($stateProvider, RotasHtml) {
        var rotasHtmlProcessamentoCurriculo = RotasHtml.processamentoCurriculo;
        $stateProvider
            .state('app.trabalheconosco_processamento_curriculo', {
                url: '/trabalheconosco/processamento/curriculo',
                module: 'privado',
                params: {
                    parametros: null
                },
                views: {
                    'content@app': {
                        templateUrl: rotasHtmlProcessamentoCurriculo.templateUrl,
                        controller: 'ProcessamentoCurriculoController as vm'
                    }
                },
                resolve: {
                    ListarCategorias: function (Api, RequisicaoGenericaService) {
                        return RequisicaoGenericaService.listarSemParams(Api.trabalhe_conosco.listarCategorias);
                    },
                    ListarAreasAtuacao: function (Api, RequisicaoGenericaService) {
                        return RequisicaoGenericaService.listarSemParams(Api.trabalhe_conosco.listarAreasAtuacao);
                    }
                }
            });
    }

})();

/**
 * Created by nova on 26/10/2016.
 */
(function () {
    'use strict';

    angular
        .module('app.trabalheconosco.processamento.curriculo')
        .controller('CandidatoDialogHabilidadeController', CandidatoDialogHabilidadeController);


    function CandidatoDialogHabilidadeController($mdDialog, DataTableConfigPadrao, MdDialogService, CodigoCandidato,
        NomeCandidato, ServicosGenericoService, RequisicaoGenericaService, Api) {
        var vm = this;

        // Data region      
        vm.form = {};
        vm.titulo = "Habilidades do Candidato";

        vm.preloader = {
            requisicaoSolicitada: false,
            mensagemPreloader: "" 
        }        

        vm.dtOptions = angular.copy(DataTableConfigPadrao.dtOptionsResponsivoSemPaginacaoComInitComplete);
        vm.dtOptions.columnDefs = [
            {
                targets: 0,
            }
        ];
        vm.dtOptions.dom = 'rt';
        //endregion                

        /**
         * Chamada do metódo inicializador
         */
        init();

        // Definição dos Métodos region 
        vm.metodosDialog = {
            fecharDialog: metodoDialogFecharDialog
        };
        //endregion


        /**
         * Método inicializador
         */
        function init() {
            vm.habilidadeCandidato = {
                nome: NomeCandidato
            }

            listarHabilidadesCandidadato();
        }

        ////////////////////////////////////////////// Métodos Internos //////////////////////////////////////////////      

        /**
         * Método para listar as características que o cliente possui
         */
        function listarHabilidadesCandidadato() {
            ServicosGenericoService.exibirPreloaderRequisicaoIniciada(vm.preloader, "Pesquisando habilidades do candidato ...");
            
            RequisicaoGenericaService.listarSemParams(Api.trabalhe_conosco.candidato.listarHabilidades + CodigoCandidato + '/habilidades').then(
                function (success) {
                    ServicosGenericoService.ocultarPreloaderRequisicaoFinalizada(vm.preloader);

                    vm.habilidadesPrincipais = [];
                    vm.habilidadesSecundarias = [];

                    vm.habilidadesCandidato = success.data;

                    for (var i = vm.habilidadesCandidato.length - 1; i >= 0; i--) {
                        if(vm.habilidadesCandidato[i].principal === true) {
                            vm.habilidadesPrincipais.push(vm.habilidadesCandidato[i]);
                        }else{
                            vm.habilidadesSecundarias.push(vm.habilidadesCandidato[i]); 
                        }
                    }
                },
                function (error) {
                    ServicosGenericoService.ocultarPreloaderRequisicaoFinalizada(vm.preloader);

                    MdDialogService.alertPadrao(error.data);
                });
        }

        //////////////////////////////////////////////////////////////////////////////////////////////////////////////


        ////////////////////////////////////////////// Métodos ///////////////////////////////////////////////////////
        
        /**
         * Método para fechar o dialog quando pressionado o "X" no toolbar do Dialog
         */
        function metodoDialogFecharDialog() {
            $mdDialog.hide();
        }

        //////////////////////////////////////////////////////////////////////////////////////////////////////////////

    } // CONTROLLER

})();

(function () {
    'use strict';

    angular
        .module('app.protecao.processamento.licenca', [])
        .config(Config);

    function Config($stateProvider, RotasHtml) {
        var rotasHtml = RotasHtml.protecaoProcessamentoLicenca;
        $stateProvider
            .state('app.protecao_processamento_licenca', {
                url: '/protecao/processamento/licenca',
                module: 'privado',
                params: {
                    parametros: null
                },
                views: {
                    'content@app': {
                        templateUrl: rotasHtml.templateUrl,
                        controller: 'ProtecaoLicencaController as vm'
                    },
                    'protecao-licenca-form@app.protecao_processamento_licenca': {
                        templateUrl: rotasHtml.form
                    },
                    'protecao-licencas-tabela@app.protecao_processamento_licenca': {
                        templateUrl: rotasHtml.tabela
                    }
                },
                /*resolve: {
                    ListarIdiomas: function (Api, RequisicaoGenericaService) {
                        return RequisicaoGenericaService.listarSemParams(Api.display.idioma);
                    },
                    ListarNivelIdiomas: function (Api, RequisicaoGenericaService) {
                        return RequisicaoGenericaService.listarSemParams(Api.display.nivelIdioma);
                    }            
                }*/
            });
    }

})();

(function () {
    'use strict';

    angular
        .module('app.protecao.processamento.licenca')
        .directive('validacaoNumeroLicenca', validacaoNumeroLicencaDirective);

    function validacaoNumeroLicencaDirective($log) {
        return {
            restrict: 'A',
            require: '^ngModel',
            controller: function () {
            },
            link: function (scope, element, attrs, ngModelCtrl) {
                if (!ngModelCtrl) {
                    $log.error("É necessário informar o ng-model para o funcionamento correto da diretiva");
                    return;
                }

                /**
                 * Método de controle executado para validar ou inválidar o modél, também criando um validador customizado à ser utilizado na view
                 * 'validacaoDocumento', e este método é disparado sempre ao final da execução de um $parses ou $formatters
                 */
                ngModelCtrl.$validators.validacaoNumeroLicenca = function (modelValue, viewValue) {
                    if ((viewValue && viewValue.charAt(0) != attrs.validacaoNumeroLicenca) && attrs.required) {
                        return false
                    }

                    return true;
                }

                ngModelCtrl.$validators.validarTamanhoMinimoLicenca = function (modelValue, viewValue) {
                    if ((viewValue && viewValue.length != attrs.tamanhoMinimoLicenca) && attrs.required) {
                        return false
                    }

                    return true;
                }
            }
        }
    };

})();

(function () {
    'use strict';

    angular
        .module('app.planejamentoscrum.estatistica.estatisticaIndividual')
        .service('EstatisticaIndividualService', EstatisticaIndividualService)

    /** @ngInject */
    function EstatisticaIndividualService(RequisicaoGenericaService, Api, $mdSidenav) {

        var _filtro;

        var service = {
            toggleFiltro: toggleFiltro,
            setFiltro: setFiltro,
            getFiltro: getFiltro,
            retornaSprintPorAno: retornaSprintPorAno,
            filtrarDadosDashboard: filtrarDadosDashboard
        }

        function toggleFiltro() {
            $mdSidenav('filtro-estatistica-individual').toggle();
        }

        function setFiltro(filtro) {
            _filtro = filtro;
        }

        function getFiltro() {
            return angular.copy(_filtro);
        }

        function retornaSprintPorAno(ano, squadCodigo) {
            return RequisicaoGenericaService.listarSemParams(Api.sprint.estatistica.listarSprint + '?' + 'ano=' + ano + "&" + 'squadCodigo=' + squadCodigo);
        }

        function filtrarDadosDashboard(filtro) {
            setFiltro(filtro);
            return RequisicaoGenericaService.listarComObjetoComplexo(Api.estatisticas.estatisticas_individual.listarEstatistica, filtro);
        }

        return service;
    }

})();

(function () {
    "use strict";

    angular
        .module("app.locacao.processamento.locacao.envio.locacao_envio")
        .controller("LocacaoEnvioController", LocacaoEnvioController);

    function LocacaoEnvioController(
        Api,
        $scope,
        RequisicaoGenericaLocacaoService,
        LoginUsuarioService,
        RequisicaoGenericaService,
        NavegacaoService,
        DatatableLocacaoFactory,
        ListarDetalhe,
        RotasHtml,
        $mdDialog,
        AtualizacaoLicencaFactory,
        ListarClientes,
        MdToastService,
        MdDialogService
    ) {
        var vm = this;
        vm.dataAtual = new Date();
        vm.detalhes = ListarDetalhe.data;
        vm.detalhesOriginais = vm.detalhes;
        vm.clientes = ListarClientes.data;
        vm.filtroClientes = vm.clientes.clientes;
        vm.estadoConservacaoId = 1;
        vm.marcado = false;
        vm.mostrarTexto = false;
        vm.locados = [];
        vm.requisicaoSolicitada = false;
        vm.editandoEnvio = false;
        vm.pesquisa = "";

        NavegacaoService.setTituloAba("Locacao Envio");

        vm.metodos = {
            pesquisar: pesquisar,
            salvar: salvar,
            editar: editar,
            botaoVoltar: botaoVoltar,
            filtrarCliente: filtrarCliente,
            botaoDialog: botaoDialog,
            listarAtendimento: listarAtendimento,
            listarEstadoConservacao: listarEstadoConservacao,
            listarTipoLocacao: listarTipoLocacao,
            selecionarContrato: selecionarContrato,
            passarParaLocados: passarParaLocados,
            passarDisponiveis: passarDisponiveis,
            configuraAutoCompleteClienteOnBlur: configuraAutoCompleteClienteOnBlur,
            pesquisarAutoCompleteCliente: pesquisarAutoCompleteCliente,
            alterarItemSelecionadoAutoCompleteCliente: alterarItemSelecionadoAutoCompleteCliente,
            botaoDialogEstadoConservacao: botaoDialogEstadoConservacao,
            listarLocados: listarLocados,
            validadorCadastroEnvio: validadorCadastroEnvio,
            marcarTodos: marcarTodos,
            abrirDialogConfirmaLocacao: abrirDialogConfirmaLocacao,
            botaoDialogFoto: botaoDialogFoto,
            dialogFoto: dialogFoto,
            dialogHistorico: dialogHistorico,
            dialogEditarEnvio: dialogEditarEnvio,
            listarDetalhesPorNotaSaida: listarDetalhesPorNotaSaida,
            pesquisarDisponiveis: pesquisarDisponiveis,
            pesquisarTodos: pesquisarTodos,
            teclaEnter: teclaEnter
        };

        vm.mentodosInternos = {
            inicializarProdutos: _inicializarProdutos
        };

        init();

        function teclaEnter() {
            var input = document.getElementById("inputPesquisa");

            input.addEventListener("keyup", function (event) {
                if (event.keyCode === 13) {
                    event.preventDefault();
                    document.getElementById("botaoPesquisar").click();
                }
            })
        }

        function pesquisarDisponiveis(pesquisaInformada) {
            vm.marcarTodos = false;
            var novosDetalhes = vm.detalhesOriginais.filter(function (detalhe) {
                if (
                    detalhe.numeroSerie.toLowerCase().includes(pesquisaInformada.toLowerCase()) ||
                    detalhe.imei.toLowerCase().includes(pesquisaInformada.toLowerCase()) ||
                    detalhe.equipamento.descricao.toLowerCase().includes(pesquisaInformada.toLowerCase())
                )
                    return detalhe;
            })
            vm.detalhes = novosDetalhes;
        }

        function pesquisarTodos() {
            vm.marcarTodos = false;
            vm.detalhes = vm.detalhesOriginais;
            vm.pesquisa = "";
        }

        function dialogEditarEnvio(envio) {
            vm.editandoEnvio = true;
            $mdDialog
                .show({
                    controller: "DialogEnvioController",
                    controllerAs: "vm",
                    templateUrl: vm.rotasHtml.dialog.confirmacao,
                    multiple: true,
                    targetEvent: event,
                    clickOutsideToClose: false,
                    locals: {
                        Atendimentos: vm.atendimentos,
                        Locado: envio,
                        Editando: vm.editandoEnvio
                    }
                }).then(function (success) {
                    vm.editandoEnvio = false;
                    editar(success);
                });
        }

        function listarDetalhesPorNotaSaida(notaFiscalSaida) {
            vm.todosEnvios = false;
            vm.buscandoLocados = true;
            RequisicaoGenericaLocacaoService.listarSemParams(Api.locacao.locacaoEnvio.ListarPorNotaSaida + notaFiscalSaida).then(function (success) {
                vm.locados = success.data;
                vm.buscandoLocados = false;
            });
        }

        function filtrarLocados(modelo) {
            var listaEnvio = modelo.filter(function (item) {
                if (item.equipamentoNotaItemDetalhe == undefined) {
                    return item;
                }
            });
            return listaEnvio;
        }

        function validadorCadastroEnvio(event, modelo) {
            var dataContrato = new Date(modelo.retornoContratos.dataFinalLocacao);
            if (dataContrato < vm.dataAtual) {
                MdDialogService.alertPadrao("Não é possivel realizar a locação pois o contrato já expirou!", null);
                return;
            }
            if (modelo.retornoContratos == undefined)
                botaoDialog();

            else {
                vm.mostrarTabela = true;
                vm.locacaoEnvio = modelo.retornoContratos;
            }
        }

        function listarDetalhesDisponiveis() {
            RequisicaoGenericaLocacaoService.listarSemParams(Api.locacao.nota_item_detalhe.listarDisponiveisEnvio)
                .then(function (success) {
                    vm.detalhes = success.data;
                    vm.detalhesOriginais = vm.detalhes;
                    //inicializaEstadoConservacao();
                });
        }

        function init() {
            vm.form = AtualizacaoLicencaFactory.form;
            vm.filtro = AtualizacaoLicencaFactory.filtros;
            vm.licencas = AtualizacaoLicencaFactory.licencas;
            vm.rotasHtml = RotasHtml.locacao_envio;
            vm.rotasFotos = RotasHtml.historico;
            vm.filtro.retornoContratos = null;
            //inicializaEstadoConservacao();
        }

        function selecionarContrato() {
            botaoDialog()
        }

        function botaoVoltar() {
            vm.mostrarTabela = false;
            vm.cliente = null;
            vm.contrato = null;
            vm.textoDePesquisaAutoCompleteCliente = "";
            vm.marcarTodos = false;
            vm.mostrarTexto = false;
            vm.filtro.retornoContratos = null;
            marcarTodos(false);
            listarDetalhesDisponiveis();
        }

        function marcarTodos(modelo) {
            vm.detalhes.map(function (item) {
                item.marcado = modelo;
            });
        }

        function passarParaLocados() {

            vm.detalhesOriginais.map(function (item) {
                if (item.marcado) {
                    vm.locados.push(angular.copy(item));
                }
            });

            var array = vm.detalhesOriginais.filter(function (item) {
                if (!item.marcado)
                    return item;
            });
            vm.detalhesOriginais = [];
            vm.detalhesOriginais = array;
        }
        function verificaItensMarcados() {
            vm.flag = false;
            vm.detalhesOriginais.map(function (item) {
                if (item.marcado == true) {
                    vm.flag = true;
                }
            });
            return vm.flag;
        }
        function passarDisponiveis() {

            vm.locados.map(function (item) {
                if (item.marcado == true) {
                    vm.detalhesOriginais.push(angular.copy(item));
                }
            });

            var array = vm.locados.filter(function (item) {
                if (!item.marcado)
                    return item;
            });
            vm.locados = [];
            vm.locados = array;
        }

        listarEstadoConservacao();
        listarTipoLocacao();

        function filtrarCliente(codigos) {
            RequisicaoGenericaService.listarComObjetoComplexo(Api.cliente.listarTodosComContrato, codigos).then(function (success) {
                vm.clientes = success.data;
                listarAtendimento(vm.cliente[0].codigo);
            });
        }
        function _filtrarSituacao() {
            vm.situacoesFiltradas = vm.situacoes.filter(function (item) {
                if (item.id != 7 && item.id != 2)
                    return item;
            });
        }

        function listarAtendimento(codigo) {
            RequisicaoGenericaService.listarSemParams(Api.atendimento.retornarAtendimentoPorCodigoClienteLocacao + codigo).then(function (success) {
                vm.atendimentos = success.data.filter(function (at) {
                    if (at.atendimentoMotivo.codigo == 25
                        || at.atendimentoMotivo.codigo == 88
                        || at.atendimentoMotivo.codigo == 97)
                        return at;
                });
                if (vm.atendimentos.length <= 0) {
                    MdDialogService.alertPadrao("Atenção! ", null, "Não há atendimentos referentes aos motivos:" +
                        "88 - Manutenção de equipamentos, 25 - Envio e recebimento equipamentos, 97 - Faturamento.");
                }
            });
        }

        function listarLocados() {
            vm.buscandoLocados = true;
            RequisicaoGenericaLocacaoService.listarSemParams(Api.locacao.nota_item_detalhe.listarTodosLocados + vm.contrato.codigo).then(function (success) {
                vm.locados = success.data;
                vm.buscandoLocados = false;
                vm.requisicaoSolicitada = false;
                vm.todosEnvios = true;
            });

            RequisicaoGenericaLocacaoService.listarSemParams(Api.locacao.locacaoEnvio.ListarPorContratoItem + vm.contratoItem.codigo).then(function (success) {
                vm.filtro.retornoContratos = success.data[0];
                if (vm.filtro.retornoContratos == undefined)
                    vm.filtro.retornoContratos = {};
                vm.envios = success.data;
                vm.mostrarTexto = true;
                vm.filtro.retornoContratos.dataInicioLocacao = vm.contrato.contratoDadosSigiloso.dataInicioContratoAtual;
                vm.filtro.retornoContratos.dataFinalLocacao = vm.contrato.contratoDadosSigiloso.dataVencimentoContratoAtual;
                vm.locacaoEnvio = vm.filtro.retornoContratos;
            });


        }

        function listarEstadoConservacao() {
            RequisicaoGenericaLocacaoService.listarSemParams(Api.locacao.equipamentos.estadoConservacao.listarTodos).then(function (success) {
                vm.equipamentoEstadoConservacao = success.data;
            });
        }

        function listarTipoLocacao() {
            RequisicaoGenericaLocacaoService.listarSemParams(Api.locacao.tipoLocacao.listarTodos).then(function (success) {
                vm.tipoLocacao = success.data;
            });
        }

        function abrirDialogConfirmaLocacao(modelo) {
            if (!verificaItensMarcados()) {
                MdDialogService.alertPadrao("Favor selecionar algum equipamento.", null);
                return;
            }
            $mdDialog
                .show({
                    controller: "DialogEnvioController",
                    controllerAs: "vm",
                    templateUrl: vm.rotasHtml.dialog.confirmacao,
                    multiple: true,
                    targetEvent: event,
                    clickOutsideToClose: false,
                    locals: {
                        Atendimentos: vm.atendimentos,
                        Locado: modelo,
                        Editando: vm.editandoEnvio
                    }
                }).then(function (success) {
                    vm.locacaoEnvio = success;
                    salvar(vm.locacaoEnvio);
                });
        }

        function dialogFoto(event, historico) {
            $mdDialog.show({
                controller: "DialogFotoController",
                controllerAs: "vm",
                templateUrl: vm.rotasFotos.dialogFoto,
                multiple: true,
                targetEvent: event,
                clickOutsideToClose: false,
                locals: {
                    Historico: historico,
                    EUltimoHistorico: false,
                },
            });
        }

        function dialogHistorico(event, detalhe) {
            RequisicaoGenericaLocacaoService.listarSemParams(Api.locacao.empresaAtiva.listarTodos)
                .then(function (success) {
                    $mdDialog.show({
                        controller: "DialogHistoricoController",
                        controllerAs: "vm",
                        templateUrl: vm.rotasHtml.dialog.historico,
                        multiple: true,
                        targetEvent: event,
                        clickOutsideToClose: false,
                        locals: {
                            NumeroSerie: detalhe.numeroSerie,
                            EmpresaAtivo: success.data
                        }
                    });
                }, function (error) {
                    MdDialogService.alertPadrao(error.data, null);
                });
        }

        function botaoDialog() {
            // vm.mostrarTabela = true;
            $mdDialog
                .show({
                    controller: "DialogLocacaoEnvioController",
                    controllerAs: "vm",
                    templateUrl: vm.rotasHtml.dialog.envio,
                    multiple: true,
                    targetEvent: event,
                    clickOutsideToClose: false,
                    locals: {
                        Atendimentos: vm.atendimentos,
                        EquipamentoEstadoConservacao: vm.equipamentoEstadoConservacao,
                        TipoLocacao: vm.tipoLocacao,
                        ContratoCliente: vm.contratoCliente,
                        MostrarTabela: vm.mostrarTabela
                    }
                }).then(function (success) {
                    vm.mostrarTabela = true;
                    vm.locacaoEnvio = success;
                    vm.locacaoEnvio.dataInicioLocacao = vm.contrato.contratoDadosSigiloso.dataInicioContratoAtual;
                    vm.locacaoEnvio.dataFinalLocacao = vm.contrato.contratoDadosSigiloso.dataVencimentoContratoAtual;
                });
        }
        function botaoDialogEstadoConservacao(index, detalhe) {
            $mdDialog
                .show({
                    controller: "DialogEstadoConservacaoController",
                    controllerAs: "vm",
                    templateUrl: vm.rotasHtml.dialog.estadoConservacao,
                    multiple: true,
                    targetEvent: event,
                    clickOutsideToClose: false,
                    locals: {
                        EstadoConservacaoId: detalhe.equipamentoEstadoConservacao,
                        EquipamentoEstadoConservacao: vm.equipamentoEstadoConservacao,
                        ApenasFoto: false,
                        Detalhe: detalhe
                    }
                }).then(function (success) {
                    vm.mostrarTabela = true;
                    vm.detalhes[vm.detalhes.indexOf(detalhe)].equipamentoEstadoConservacao = success.equipamentoEstadoConservacao;
                    // vm.detalhes[vm.detalhes.indexOf(detalhe)].fotos = success.fotos;
                });
        }
        function botaoDialogFoto(index, detalhe) {
            $mdDialog
                .show({
                    controller: "DialogEstadoConservacaoController",
                    controllerAs: "vm",
                    templateUrl: vm.rotasHtml.dialog.estadoConservacao,
                    multiple: true,
                    targetEvent: event,
                    clickOutsideToClose: false,
                    locals: {
                        EstadoConservacaoId: detalhe.equipamentoEstadoConservacao,
                        EquipamentoEstadoConservacao: vm.equipamentoEstadoConservacao,
                        ApenasFoto: true,
                        Detalhe: detalhe
                    }
                }).then(function (success) {
                    vm.mostrarTabela = true;
                    // vm.detalhes[vm.detalhes.indexOf(detalhe)].equipamentoEstadoConservacao = success.equipamentoEstadoConservacao;
                    vm.detalhes[vm.detalhes.indexOf(detalhe)].fotos = success.fotos;
                });
        }

        function pesquisar() {
            return RequisicaoGenericaLocacaoService.listarComObjetoComplexo(Api.locacao.locacaoEnvio.listarComPaginacao, vm.entidadeDeEnvio);
        }

        function retornaCodigosDetalhes(detalhes) {
            var codigos = detalhes.map(function (item) {
                return item.id;
            })
            return codigos;
        }

        function salvar(modelo) {
            passarParaLocados();
            vm.requisicaoSolicitada = true;
            modelo.clienteNome = vm.cliente.nome;
            modelo.clienteId = vm.cliente.codigo;
            modelo.tipoLocacaoId = modelo.tipoLocacao.id;
            modelo.tipoContrato = vm.contrato.contratoTipo.descricao;
            modelo.contratoItemId = vm.contratoItem.codigo;
            modelo.Produto = vm.contratoItem.produto.descricao;
            modelo.usuarioNome = LoginUsuarioService.usuarioArmazenado().login;
            modelo.equipamentoNotaItemDetalhe = filtrarLocados(vm.locados);
            modelo.codigosDetalhes = retornaCodigosDetalhes(modelo.equipamentoNotaItemDetalhe);
            modelo.usuarioId = LoginUsuarioService.usuarioArmazenado().codigo;
            RequisicaoGenericaLocacaoService.salvar(Api.locacao.locacaoEnvio.criar, modelo)
                .then(function (success) {
                    MdToastService.toastPadrao("Envio criado com sucesso!");
                    MdDialogService.alertPadrao("Locação realizada com sucesso!", success);
                    listarDetalhesDisponiveis();
                    listarLocados();
                    //vm.requisicaoSolicitada = false;
                }, function (err) {
                    passarDisponiveis();
                    vm.requisicaoSolicitada = false;
                    vm.editandoEnvio = true;
                    MdDialogService.alertPadraoComEvento(err.data.error[0], function () {
                        abrirDialogConfirmaLocacao(modelo);
                    });
                });
        }


        function editar(modelo) {
            vm.requisicaoSolicitada = true;
            modelo.usuarioId = LoginUsuarioService.usuarioArmazenado().codigo;
            RequisicaoGenericaLocacaoService.editar(Api.locacao.locacaoEnvio.editar, modelo)
                .then(function (success) {
                    MdToastService.toastPadrao("Envio editado com sucesso!");
                    MdDialogService.alertPadrao("Locação editada com sucesso!", success);
                    listarDetalhesDisponiveis();
                    listarLocados();
                    vm.requisicaoSolicitada = false;
                }, function (err) {
                    passarDisponiveis();
                    vm.requisicaoSolicitada = false;
                    vm.editandoEnvio = true;
                    MdDialogService.alertPadraoComEvento(err.data.error[0], function () {
                        dialogEditarEnvio(modelo);
                    });
                });
        }



        /**
         * Método que limpa o texto de pesquisa do md-auto-complete da Cliente
         */
        function configuraAutoCompleteClienteOnBlur() {
            if (!vm.filtro.cliente) {
                vm.textoDePesquisaAutoCompleteCliente = "";
            }
        }

        /**
         * Método que realiza uma requisição para api para buscar os clientes em tempo de excução, * com base no que o usuário está digitando
         * @param {string} query
         */
        function pesquisarAutoCompleteCliente(query) {
            var resultado = vm.filtroClientes.filter(function (cliente) {
                if (cliente.nome.toLowerCase().includes(query.toLowerCase()) ||
                    cliente.codigo == query) {
                    return cliente;
                }
            });

            return resultado;
            //return ServicosGenericoService.pesquisarAutoCompleteCodigoOuNomeGenericoApi(Api.cliente.listarCodigoDescricao, query);
        }

        function ListarContratos(codigo) {
            return RequisicaoGenericaService.listarSemParams(Api.contrato.listarContratosPorCliente + codigo)
                .then(function (success) {
                    vm.contratos = success.data;
                });
        }
        /**
         * Método que controla qual cidade está selecionada no campo md-auto-complete do Cliente
         * @param {object} item
         */
        function alterarItemSelecionadoAutoCompleteCliente(item) {
            if (item) {
                vm.filtro.cliente = item;
                ListarContratos(vm.filtro.cliente.codigo);
                listarAtendimento(vm.filtro.cliente.codigo);
            } else {
                _inicializarProdutos();
                vm.filtro.cliente = null;
                vm.filtro.produtoCodigo = null;
                vm.textoDePesquisaAutoCompleteCliente = "";
            }
        }

        function _inicializarProdutos() {
            vm.produtos = {
                codigo: null,
                descricao: null
            };
        }

    }
})();

(function () {
    "use strict";

    angular
        .module("app.locacao.processamento.locacao.retorno.locacao_retorno")
        .controller("LocacaoRetornoController", LocacaoRetornoController);

    function LocacaoRetornoController(
        Api,
        $scope,
        RequisicaoGenericaLocacaoService,
        LoginUsuarioService,
        RequisicaoGenericaService,
        NavegacaoService,
        DatatableLocacaoFactory,
        ListarDetalhe,
        RotasHtml,
        $mdDialog,
        AtualizacaoLicencaFactory,
        ListarClientes,
        MdToastService,
        MdDialogService,
        ListarTipoRetorno
    ) {
        var vm = this;
        vm.detalhes = [];
        vm.clientes = ListarClientes.data;
        vm.filtroClientes = vm.clientes.clientes;
        vm.estadoConservacaoId = 1;
        vm.atendimentoDados = {};
        vm.marcado = false;
        vm.tipoRetornos = ListarTipoRetorno.data;
        vm.locados = [];
        vm.retornosPorEnvio = [];
        vm.requisicaoSolicitada = false;
        vm.validaDatasContrato = false;

        NavegacaoService.setTituloAba("Locacao Retorno");

        vm.metodos = {
            pesquisar: pesquisar,
            salvar: salvar,
            construirDtOptions: construirDtOptions,
            botaoVoltar: botaoVoltar,
            filtrarCliente: filtrarCliente,
            botaoDialog: botaoDialog,
            listarAtendimento: listarAtendimento,
            listarEstadoConservacao: listarEstadoConservacao,
            listarTipoLocacao: listarTipoLocacao,
            selecionarContrato: selecionarContrato,
            passarParaLocados: passarParaLocados,
            passarDisponiveis: passarDisponiveis,
            configuraAutoCompleteClienteOnBlur: configuraAutoCompleteClienteOnBlur,
            pesquisarAutoCompleteCliente: pesquisarAutoCompleteCliente,
            alterarItemSelecionadoAutoCompleteCliente: alterarItemSelecionadoAutoCompleteCliente,
            botaoDialogEstadoConservacao: botaoDialogEstadoConservacao,
            listarLocados: listarLocados,
            validadorCadastroRetorno: validadorCadastroRetorno,
            marcarTodos: marcarTodos,
            envioSelecionado: envioSelecionado,
            ListarDetalhesPorNotaSaida: ListarDetalhesPorNotaSaida,
            botaoDialogFoto: botaoDialogFoto,
            dialogdetalhes: dialogdetalhes,
            dialogRetornarTodos: dialogRetornarTodos,
            marcarTodosEnvios: marcarTodosEnvios,
            listarTodosLocadosPorContrato: listarTodosLocadosPorContrato,
            dialogEditarRetorno: dialogEditarRetorno,
            editar: editar
        };

        init();

        function envioSelecionado(envio) {
            listarRetornosPorEnvio(envio.notaFiscalSaida);
            setaValoresListaEnvios(envio);
            vm.envio = envio;
            vm.atendimentoDados = envio.atendimentoId + "/" + envio.atendimentoAno;
            vm.clicado = envio.id;
            vm.notaSaida = envio.notaFiscalSaida;
            ListarDetalhesPorNotaSaida(envio.notaFiscalSaida);
        }

        function listarRetornosPorEnvio(notaSaida) {
            RequisicaoGenericaLocacaoService.listarSemParams(
                Api.locacao.locacaoRetorno.ListarPorEnvio + notaSaida
            ).then(function (success) {
                vm.retornosPorEnvio = success.data;
            });
        }

        function dialogEditarRetorno(retorno) {
            $mdDialog
                .show({
                    controller: "DialogLocacaoRetornoController",
                    controllerAs: "vm",
                    templateUrl: vm.rotasHtmlRetono.dialog.retorno,
                    multiple: true,
                    targetEvent: event,
                    clickOutsideToClose: false,
                    locals: {
                        Atendimentos: vm.atendimentos,
                        EquipamentoEstadoConservacao: vm.equipamentoEstadoConservacao,
                        TipoLocacao: vm.tipoLocacao,
                        ContratoCliente: vm.contratoCliente,
                        MostrarTabela: vm.mostrarTabela,
                        Retorno: vm.tipoRetornos,
                        LocacaoRetorno: retorno,
                        Envio: vm.envio
                    }
                }).then(function (success) {
                    vm.mostrarTabela = true;
                    editar(success);
                });
        }

        function editar(modelo) {
            vm.requisicaoSolicitada = true;
            modelo.usuarioId = LoginUsuarioService.usuarioArmazenado().codigo;
            RequisicaoGenericaLocacaoService.editar(Api.locacao.locacaoRetorno.editar, modelo)
                .then(function (success) {
                    MdToastService.toastPadrao("Retorno editado com sucesso!");
                    MdDialogService.alertPadrao("Retorno editado com sucesso!", success);
                    listarDetalhesDisponiveis();
                    listarRetornosPorEnvio(vm.notaSaida);
                    vm.requisicaoSolicitada = false;
                }, function (err) {
                    vm.requisicaoSolicitada = false;
                    MdDialogService.alertPadraoComEvento(err.data.error[0], function () {
                        dialogRetornoDados(modelo);
                    });
                });
        }

        function filtrarLocados(modelo) {
            var listaEnvio = modelo.filter(function (item) {
                if (item.locacaoEnvio != undefined) {
                    return item;
                }
            });
            return listaEnvio;
        }

        function setaValoresListaEnvios(modelo) {
            vm.filtro.retornoContratos.map(function (item) {
                if (modelo.id != item.id)
                    item.marcado = false;
            });
        }

        function validaItemSelecionadoListaEnvio() {
            vm.flagEnvio = false;
            vm.filtro.retornoContratos.map(function (item) {
                if (item.marcado)
                    vm.flagEnvio = true
            });
            return vm.flagEnvio;
        }

        function validadorCadastroRetorno(event, modelo) {
            if (!validaItemSelecionadoListaEnvio()) {
                MdDialogService.alertPadrao("Favor selecione um envio.");
                return;
            }
            else {
                vm.mostrarTabela = true;
            }
        }

        function listarDetalhesDisponiveis() {
            RequisicaoGenericaLocacaoService.listarSemParams(Api.locacao.nota_item_detalhe.listarTodos)
                .then(function (success) {
                    vm.detalhes = success.data;
                });
        }

        function init() {
            vm.form = AtualizacaoLicencaFactory.form;
            vm.filtro = AtualizacaoLicencaFactory.filtros;
            vm.licencas = AtualizacaoLicencaFactory.licencas;
            vm.rotasHtml = RotasHtml.locacao_envio;
            vm.rotasHtmlRetono = RotasHtml.locacao_retorno;
        }

        function marcarTodos(modelo) {
            vm.locados.map(function (item) {
                item.marcado = modelo;
                item.equipamentoNotaItemDetalhe.equipamentoEstadoConservacao = item.equipamentoEstadoConservacao;
            });
        }

        function selecionarContrato() {
            botaoDialog()
        }

        function botaoVoltar() {
            vm.mostrarTabela = false;
            vm.detalhes = [];
            vm.locados = [];
            vm.cliente = null;
            vm.contrato = null;
            vm.textoDePesquisaAutoCompleteCliente = "";
            vm.marcarTodos = false;
            vm.marcarTodosEnvios = false;
        }

        function marcarTodosEnvios() {
            vm.marcarTodosEnvios != vm.marcarTodosEnvios;
            if (vm.marcarTodosEnvios) {
                vm.filtro.retornoContratos.map(function (item) {
                    item.marcado = true;
                    vm.atendimentoMarcado = item.marcado;
                });
            }
            else {
                vm.filtro.retornoContratos.map(function (item) {
                    item.marcado = false;
                    vm.atendimentoMarcado = item.marcado;
                });
            }
        }

        function passarParaLocados() {
            vm.locados = angular.copy(vm.locadosOriginais);
        }

        function verificaItensMarcados() {
            vm.flag = false;
            vm.locados.map(function (item) {
                if (item.marcado == true) {
                    vm.flag = true;
                }
            });
            return vm.flag;
        }

        function passarDisponiveis() {
            vm.locadosOriginais = angular.copy(vm.locados);
            vm.locados.map(function (item) {
                if (item.marcado == true) {
                    item.equipamentoNotaItemDetalhe.locacaoEnvioId = item.id;
                    vm.detalhes.push(angular.copy(item.equipamentoNotaItemDetalhe));
                }
            });

            var array = vm.locados.filter(function (item) {
                if (!item.marcado)
                    return item;
            });
            vm.locados = [];
            vm.locados = array;
        }

        listarEstadoConservacao();
        listarTipoLocacao();

        function filtrarCliente(codigos) {
            RequisicaoGenericaService.listarComObjetoComplexo(Api.cliente.listarTodosComContrato, codigos).then(function (success) {
                vm.clientes = success.data;
                listarAtendimento(vm.cliente[0].codigo);
            });
        }

        function listarAtendimento(codigo) {
            RequisicaoGenericaService.listarSemParams(Api.atendimento.retornarAtendimentoPorCodigoClienteLocacao + codigo).then(function (success) {
                vm.atendimentos = success.data;
            });
        }

        function listarLocados() {
            RequisicaoGenericaLocacaoService.listarSemParams(Api.locacao.locacaoEnvio.ListarPorContratoItem + vm.contratoItem.codigo).then(function (success) {
                vm.filtro.retornoContratos = success.data;
            });
        }

        function ListarDetalhesPorNotaSaida(numeroNota) {
            RequisicaoGenericaLocacaoService.listarSemParams(Api.locacao.locacaoEnvio.ListarPorNotaSaida + numeroNota).then(function (success) {
                vm.locados = success.data;
            });
        }

        function listarEstadoConservacao() {
            RequisicaoGenericaLocacaoService.listarSemParams(Api.locacao.equipamentos.estadoConservacao.listarTodos).then(function (success) {
                vm.equipamentoEstadoConservacao = success.data;
            });
        }

        function listarTipoLocacao() {
            RequisicaoGenericaLocacaoService.listarSemParams(Api.locacao.tipoLocacao.listarTodos).then(function (success) {
                vm.tipoLocacao = success.data;
            });
        }

        function listarTodosLocadosPorContrato(contrato) {
            RequisicaoGenericaLocacaoService.listarSemParams(Api.locacao.nota_item_detalhe.listarTodosLocados + contrato).then(function (success) {
                vm.locados = angular.copy(success.data);
                if (vm.locados.length > 0) {
                    dialogRetornarTodos();
                    marcarTodos(true);
                }
                else
                    MdDialogService.alertPadrao("Atenção!", null, "Este contrato não possui locação.");
            });
        }

        function dialogRetornoDados(modelo) {
            $mdDialog
                .show({
                    controller: "DialogLocacaoRetornoController",
                    controllerAs: "vm",
                    templateUrl: vm.rotasHtmlRetono.dialog.retorno,
                    multiple: true,
                    targetEvent: event,
                    clickOutsideToClose: false,
                    locals: {
                        Atendimentos: vm.atendimentos,
                        EquipamentoEstadoConservacao: vm.equipamentoEstadoConservacao,
                        TipoLocacao: vm.tipoLocacao,
                        ContratoCliente: vm.contratoCliente,
                        MostrarTabela: vm.mostrarTabela,
                        Retorno: vm.tipoRetornos,
                        LocacaoRetorno: modelo,
                        Envio: vm.envio
                    },
                })
                .then(function (success) {
                    vm.mostrarTabela = true;
                    vm.locacaoRetorno = success;
                    salvar(vm.locacaoRetorno);
                });
        }

        function botaoDialog() {
            if (!verificaItensMarcados()) {
                MdDialogService.alertPadrao("Atenção!", null, "Favor selecionar algum equipamento.");
                return;
            }
            $mdDialog
                .show({
                    controller: "DialogLocacaoRetornoController",
                    controllerAs: "vm",
                    templateUrl: vm.rotasHtmlRetono.dialog.retorno,
                    multiple: true,
                    targetEvent: event,
                    clickOutsideToClose: false,
                    locals: {
                        Atendimentos: vm.atendimentos,
                        EquipamentoEstadoConservacao: vm.equipamentoEstadoConservacao,
                        TipoLocacao: vm.tipoLocacao,
                        ContratoCliente: vm.contratoCliente,
                        MostrarTabela: vm.mostrarTabela,
                        Retorno: vm.tipoRetornos,
                        LocacaoRetorno: null,
                        Envio: vm.envio
                    }
                }).then(function (success) {
                    vm.locacaoRetorno = success;
                    salvar(vm.locacaoRetorno);
                });
        }

        function dialogdetalhes(numeroNota) {
            $mdDialog.show({
                controller: "DialogDetalhesController",
                controllerAs: "vm",
                templateUrl: vm.rotasHtmlRetono.dialog.detalhes,
                multiple: true,
                targetEvent: event,
                clickOutsideToClose: false,
                locals: {
                    NumeroNota: numeroNota
                }
            });
        }

        function botaoDialogEstadoConservacao(index, detalhe) {
            $mdDialog
                .show({
                    controller: "DialogEstadoConservacaoRetornoController",
                    controllerAs: "vm",
                    templateUrl: vm.rotasHtmlRetono.dialog.estadoConservacaoRetorno,
                    multiple: true,
                    targetEvent: event,
                    clickOutsideToClose: false,
                    locals: {
                        EstadoConservacaoId: detalhe.equipamentoNotaItemDetalhe.equipamentoEstadoConservacao.id,
                        EquipamentoEstadoConservacao: vm.equipamentoEstadoConservacao,
                    }
                }).then(function (success) {
                    vm.mostrarTabela = true;
                    vm.locados[vm.locados.indexOf(detalhe)].equipamentoEstadoConservacao = success.estadoConservacao;
                    vm.locados[vm.locados.indexOf(detalhe)].equipamentoNotaItemDetalhe.equipamentoEstadoConservacao = success.estadoConservacao;
                });
        }

        function botaoDialogFoto(index, detalhe) {
            $mdDialog
                .show({
                    controller: "DialogEstadoConservacaoController",
                    controllerAs: "vm",
                    templateUrl: vm.rotasHtml.dialog.estadoConservacao,
                    multiple: true,
                    targetEvent: event,
                    clickOutsideToClose: false,
                    locals: {
                        EstadoConservacaoId: detalhe.equipamentoEstadoConservacao,
                        EquipamentoEstadoConservacao: vm.equipamentoEstadoConservacao,
                        ApenasFoto: true,
                        Detalhe: detalhe.equipamentoNotaItemDetalhe,
                    },
                })
                .then(function (success) {
                    vm.mostrarTabela = true;
                    vm.locados[
                        vm.locados.indexOf(detalhe)
                    ].equipamentoNotaItemDetalhe.fotos = success.fotos;
                });
        }

        function pesquisar() {
            return RequisicaoGenericaLocacaoService.listarComObjetoComplexo(Api.locacao.locacaoEnvio.listarComPaginacao, vm.entidadeDeEnvio);
        }

        function dialogRetornarTodos(contrato) {
            $mdDialog.show({
                controller: "DialogRetornarTodosController",
                controllerAs: "vm",
                templateUrl: vm.rotasHtmlRetono.dialog.retornarTodos,
                multiple: true,
                targetEvent: event,
                clickOutsideToClose: false,
                locals: {
                    Contrato: vm.contrato,
                    Locados: vm.locados
                }
            }).then(function (success) {
                botaoDialog();

            });
        }

        function validarDataPorEnvio(modelo) {
            var datalocacaoEnvio = new Date(vm.envio.dataEnvio);
            if (modelo.dataRetorno < datalocacaoEnvio) {
                vm.validaDatasContrato = true;
            }
            else
                vm.validaDatasContrato = false;
        }

        function validaDataRetornarTodos(modelo) {
            vm.datasRetornosMenores = vm.locados.filter(function (item) {
                var datalocacaoEnvio = new Date(item.dataEnvio);
                if (modelo.dataRetorno < datalocacaoEnvio) {
                    return item;
                }

            });
        }

        function salvar(modelo) {
            if (vm.envio != undefined) {
                validarDataPorEnvio(modelo);
                if (vm.validaDatasContrato) {
                    MdDialogService.alertPadraoComEvento("Data do retorno não pode ser inferior ou igual a data de envio.", function () {
                        dialogRetornoDados(modelo);
                    });
                    return;
                }
            }
            else {
                validaDataRetornarTodos(modelo);
                if (vm.datasRetornosMenores.length > 0) {
                    MdDialogService.alertPadraoComEvento("Data do retorno não pode ser inferior ou igual a data de envio.", function () {
                        dialogRetornoDados(modelo);
                    });
                    return;
                }

                modelo.locacaoEnvioId = vm.locados
            }
            vm.requisicaoSolicitada = true;
            passarDisponiveis();
            modelo.tipoContrato = vm.contrato.contratoTipo.descricao;
            modelo.locacaoEnvioId = vm.clicado;
            modelo.notaFiscalEnvio = vm.notaSaida;
            modelo.clienteNome = vm.cliente.nome;
            modelo.clienteId = vm.cliente.codigo;
            modelo.contratoItemId = vm.contratoItem.codigo;
            modelo.Produto = vm.contratoItem.produto.descricao;
            modelo.usuarioNome = LoginUsuarioService.usuarioArmazenado().login;
            modelo.equipamentoNotaItemDetalhe = filtrarLocados(vm.detalhes);
            modelo.usuarioId = LoginUsuarioService.usuarioArmazenado().codigo;
            RequisicaoGenericaLocacaoService.salvar(Api.locacao.locacaoRetorno.criar, modelo)
                .then(function (success) {
                    botaoVoltar();
                    MdToastService.toastPadrao("Retorno criado com sucesso!");
                    MdDialogService.alertPadrao("Retorno realizado com sucesso!", success);
                    listarDetalhesDisponiveis();
                    listarRetornosPorEnvio(vm.notaSaida);
                    vm.requisicaoSolicitada = false;
                    vm.filtro.retornoContratos = '';
                }, function (err) {
                    passarParaLocados();
                    vm.requisicaoSolicitada = false;
                    vm.detalhes = [];
                    MdDialogService.alertPadraoComEvento(err.data.error[0], function () {
                        dialogRetornoDados(modelo);
                    });

                });
        }

        function construirDtOptions() {
            DatatableLocacaoFactory.destruirTabela();
            if (!vm.entidadeDeEnvio.clsEntidade.id) {
                vm.entidadeDeEnvio.clsEntidade = null;
            }
            DatatableLocacaoFactory.construirDtOptionsComPaginacaoProcessadoNoServidorParaToolbar
                (Api.locacao.objetivoNota.listarComPaginacaoDatatable, vm.entidadeDeEnvio.clsEntidade, '#datatable-objetivo',
                    [
                        DatatableLocacaoFactory.construirColunaDeSelecionarPadrao(function (indexLinha) { vm.metodos.selecionar(indexLinha) }),
                        {
                            targets: 1,
                            name: "Descricao",
                            data: "descricao",
                            defaultContent: ""
                        }
                    ]);
            vm.entidadeDeEnvio.clsEntidade = {};
        }

        vm.mentodosInternos = {
            inicializarProdutos: _inicializarProdutos,
            carregarProdutosPorCliente: _carregarProdutosPorCliente,
            buscarLicencas: _buscarLicencas
        }

        $scope.$watch('vm.filtro.produtoCodigo', function (newValue, oldValue) {
            if (newValue) {
                _buscarLicencas(vm.filtro);
            }
        });

        /**
         * Método que limpa o texto de pesquisa do md-auto-complete da Cliente
         */
        function configuraAutoCompleteClienteOnBlur() {
            if (!vm.filtro.cliente) {
                vm.textoDePesquisaAutoCompleteCliente = "";
            }
        }

        /**
         * Método que realiza uma requisição para api para buscar os clientes em tempo de excução, * com base no que o usuário está digitando
         * @param {string} query
         */
        function pesquisarAutoCompleteCliente(query) {
            var resultado = vm.filtroClientes.filter(function (cliente) {
                if (cliente.nome.toLowerCase().includes(query.toLowerCase()) ||
                    cliente.codigo == query) {
                    return cliente;
                }
            });

            return resultado;
        }

        function ListarContratos(codigo) {
            return RequisicaoGenericaService.listarSemParams(Api.contrato.listarContratosPorCliente + codigo)
                .then(function (success) {
                    vm.contratos = success.data;
                });
        }
        /**
         * Método que controla qual cidade está selecionada no campo md-auto-complete do Cliente
         * @param {object} item
         */
        function alterarItemSelecionadoAutoCompleteCliente(item) {
            if (item) {
                vm.filtro.cliente = item;
                ListarContratos(vm.filtro.cliente.codigo);
                listarAtendimento(vm.filtro.cliente.codigo);
            } else {
                _inicializarProdutos();
                vm.filtro.cliente = null;
                vm.filtro.produtoCodigo = null;
                vm.textoDePesquisaAutoCompleteCliente = "";
            }
        }

        function _inicializarProdutos() {
            vm.produtos = {
                codigo: null,
                descricao: null
            };
        }

        function _carregarProdutosPorCliente(clienteCodigo) {
            _inicializarProdutos();
            for (var i = vm.clientes.clientes.length - 1; i >= 0; i--) {
                if (vm.clientes.clientes[i].codigo == clienteCodigo) {
                    vm.produtos = [].concat(vm.clientes.clientes[i].produtos);
                }
            }
        }

        function _buscarLicencas(filtro) {
            var parametros = '/' + filtro.cliente.codigo + '/' + filtro.produtoCodigo;
            RequisicaoGenericaService.listarSemParams(Api.protecao.atualizacaoLicenca.licencas + parametros).then(
                function (success) {
                    AtualizacaoLicencaFactory.setLicencas(success.data);
                },
                function (error) {
                    MdDialogService.alertPadrao(error.data);
                });
        }

    }
})();
(function () {
    'use strict';

    angular
        .module('app.service')
        .service('TrocaAtivoService', TrocaAtivoService)

    /** @ngInject */
    function TrocaAtivoService(RequisicaoGenericaLocacaoService, Api) {

        var service = {
            listarEquipamentosEmpresaAtivo: listarEquipamentosEmpresaAtivo,
            retornarResumoEquipamentosEmpresa: retornarResumoEquipamentosEmpresa,
            realizarTrocaAtivo: realizarTrocaAtivo,
            listarEstadoConservacao: listarEstadoConservacao
        };

        function listarEquipamentosEmpresaAtivo(empresaAtivoId) {
            return RequisicaoGenericaLocacaoService.listarSemParams(Api.locacao.trocaAtivo.listarEquipamentos + '/' + empresaAtivoId);
        }

        function retornarResumoEquipamentosEmpresa(dados) {
            return RequisicaoGenericaLocacaoService.salvar(Api.locacao.trocaAtivo.retornarResumoEquipamentosEmpresa, dados);
        }

        function realizarTrocaAtivo(dados) {
            return RequisicaoGenericaLocacaoService.salvar(Api.locacao.trocaAtivo.realizarTrocaAtivo, dados)
        }

        function listarEstadoConservacao() {
            return RequisicaoGenericaLocacaoService.listarSemParams(Api.locacao.equipamentos.estadoConservacao.listarTodos);
        }

        return service;
    }

}());
(function () {
    'use strict';

    angular
        .module('app.locacao.cadastro.equipamentos.equipamento_tipo', [])
        .config(config);

    function config($stateProvider, RotasHtml) {
        var rotasHtmlEquipamentoTipo = RotasHtml.equip_tipo;
        $stateProvider.state(
          "app.locacao_cadastro_equipamentos_equipamento_tipo",
          {
            url: "/locacao/cadastro/equipamentos/equipamento-tipo",
            module: "privado",
            views: {
              "content@app": {
                templateUrl: rotasHtmlEquipamentoTipo.templateUrl,
                controller: "EquipamentoTipoController as vm"
              },
              "equipamento-tipo-form@app.locacao_cadastro_equipamentos_equipamento_tipo": {
                templateUrl: rotasHtmlEquipamentoTipo.form
              },
              "equipamento-tipo-tabela@app.locacao_cadastro_equipamentos_equipamento_tipo": {
                templateUrl: rotasHtmlEquipamentoTipo.tabela
              }
            }
          }
        );
    }

})();

/**
 * Created by nova on 05/05/2020.
 */
(function () {
  "use strict";

  angular
    .module("app.locacao.cadastro.equipamentos.equipamento_tipo")
    .controller("EquipamentoTipoController", EquipamentoTipoController);

  function EquipamentoTipoController(
    Api,
    RequisicaoGenericaLocacaoService,
    NavegacaoService,
    DatatableLocacaoFactory
  ) {
    var vm = this;
    NavegacaoService.setTituloAba("Equipamento tipo");

    vm.metodos = {
      pesquisar: pesquisar,
      salvar: salvar,
      editar: editar,
      excluir: excluir,
      selecionar: selecionar,
      construirDtOptions: construirDtOptions
    };

     function pesquisar() {
            return RequisicaoGenericaLocacaoService.listarComObjetoComplexo(Api.locacao.equipamentos.tipo.listarComPaginacao, vm.entidadeDeEnvio);
        }


        function salvar(modelo) {
            return RequisicaoGenericaLocacaoService.salvar(Api.locacao.equipamentos.tipo.criar, modelo);
        }

        function editar(modelo) {
            return RequisicaoGenericaLocacaoService.editar(Api.locacao.equipamentos.tipo.editar, modelo)
        }

        function excluir(modelo) {
            return RequisicaoGenericaLocacaoService.excluir(Api.locacao.equipamentos.tipo.remover, modelo.id)
        }

        function selecionar(posicaoEntidade) {
            vm.metodosExternosPgToolbar.metodoControladorExternoListarTodasEntidades(null, posicaoEntidade);
        }

        function construirDtOptions() {
          DatatableLocacaoFactory.destruirTabela();

            vm.entidadeDeEnvio.clsEntidade = null;

            DatatableLocacaoFactory.construirDtOptionsComPaginacaoProcessadoNoServidorParaToolbar
                (Api.locacao.equipamentos.tipo.listarComPaginacaoDatatable, vm.entidadeDeEnvio.clsEntidade, '#datatable-tipo',
                [

                    DatatableLocacaoFactory.construirColunaDeSelecionarPadrao(function (indexLinha) { vm.metodos.selecionar(indexLinha) }),
                    {
                        targets: 1,
                        name: "Descricao",
                        data: "descricao",
                        defaultContent: ""
                    },
                    {
                      targets: 2,
                        name: "Depreciação",
                        data: "depreciacao",
                        defaultContent: ""
                    }
                ]);
            vm.entidadeDeEnvio.clsEntidade = {};
        }


  }
})();

(function () {
    'use strict';

    angular
        .module('app.locacao.cadastro.equipamentos.equipamento_motivo_baixa', [])
        .config(config);

    function config($stateProvider, RotasHtml) {
        var rotasHtmlMotivoBaixa = RotasHtml.equipamento_motivo_baixa;
        $stateProvider.state(
          "app.locacao_cadastro_equipamentos_equipamento_motivo_baixa",
          {
            url: "/locacao/cadastro/equipamentos/equipamento-motivo_baixa",
            module: "privado",
            views: {
              "content@app": {
                templateUrl: rotasHtmlMotivoBaixa.templateUrl,
                controller: "EquipamentoMotivoBaixaController as vm"
              },
              "equipamento-motivo-baixa-form@app.locacao_cadastro_equipamentos_equipamento_motivo_baixa": {
                templateUrl: rotasHtmlMotivoBaixa.form
              },
              "equipamento-motivo-baixa-tabela@app.locacao_cadastro_equipamentos_equipamento_motivo_baixa": {
                templateUrl: rotasHtmlMotivoBaixa.tabela
              }
            }
          }
        );
    }

})();

(function () {
  "use strict";

  angular
    .module("app.locacao.cadastro.equipamentos.equipamento_motivo_baixa")
    .controller("EquipamentoMotivoBaixaController", EquipamentoMotivoBaixaController);

  function EquipamentoMotivoBaixaController(
    Api,
    RequisicaoGenericaLocacaoService,
    NavegacaoService,
    DatatableLocacaoFactory
  ) {
    var vm = this;
    NavegacaoService.setTituloAba("Motivo baixa");

    vm.metodos = {
      pesquisar: pesquisar,
      salvar: salvar,
      editar: editar,
      excluir: excluir,
      selecionar: selecionar,
      construirDtOptions: construirDtOptions
    };

     function pesquisar() {
            return RequisicaoGenericaLocacaoService.listarComObjetoComplexo(Api.locacao.equipamentos.motivoBaixa.listarComPaginacao, vm.entidadeDeEnvio);
        }


        function salvar(modelo) {
            return RequisicaoGenericaLocacaoService.salvar(Api.locacao.equipamentos.motivoBaixa.criar, modelo);
        }

        function editar(modelo) {
            return RequisicaoGenericaLocacaoService.editar(Api.locacao.equipamentos.motivoBaixa.editar, modelo)
        }

        function excluir(modelo) {
            return RequisicaoGenericaLocacaoService.excluir(Api.locacao.equipamentos.motivoBaixa.remover, modelo.id)
        }

        function selecionar(posicaoEntidade) {
            vm.metodosExternosPgToolbar.metodoControladorExternoListarTodasEntidades(null, posicaoEntidade);
        }
        function construirDtOptions() {
          DatatableLocacaoFactory.destruirTabela();

            vm.entidadeDeEnvio.clsEntidade = null;

          DatatableLocacaoFactory.construirDtOptionsComPaginacaoProcessadoNoServidorParaToolbar(
            Api.locacao.equipamentos.motivoBaixa.listarComPaginacaoDatatable,
            vm.entidadeDeEnvio.clsEntidade,
            "#datatable-motivo-baixa",
            [
              DatatableLocacaoFactory.construirColunaDeSelecionarPadrao(
                function (indexLinha) {
                  vm.metodos.selecionar(indexLinha);
                }
              ),
              {
                targets: 1,
                name: "Descricao",
                data: "descricao",
                defaultContent: "",
              },
            ]
          );
          vm.entidadeDeEnvio.clsEntidade = {};
        }


  }
})();

/**
 * Created by nova on 05/05/2020.
 */
(function () {
  "use strict";

  angular
    .module("app.locacao.cadastro.equipamentos.equipamento_tipo")
    .controller("EquipamentoNotaController", EquipamentoNotaController);

  function EquipamentoNotaController(
    Api,
    RequisicaoGenericaLocacaoService,
    NavegacaoService
  ) {
    var vm = this;
    NavegacaoService.setTituloAba("Equipamento nota");

    vm.metodos = {
      pesquisar: pesquisar,
      salvar: salvar,
      editar: editar,
      excluir: excluir,
      selecionar: selecionar
    };

     function pesquisar() {
            return RequisicaoGenericaLocacaoService.listarComObjetoComplexo(Api.locacao.equipamentos.nota.listarComPaginacao, vm.entidadeDeEnvio);
        }


        function salvar(modelo) {
            return RequisicaoGenericaLocacaoService.salvar(Api.locacao.equipamentos.nota.criar, modelo);
        }

        function editar(modelo) {
            return RequisicaoGenericaLocacaoService.editar(Api.locacao.equipamentos.nota.editar, modelo)
        }

        function excluir(modelo) {
            return RequisicaoGenericaLocacaoService.excluir(Api.locacao.equipamentos.nota.excluir, modelo.codigo)
        }

        function selecionar(posicaoEntidade) {
            vm.metodosExternosPgToolbar.metodoControladorExternoListarTodasEntidades(null, posicaoEntidade);
        }


  }
})();

(function () {
    'use strict';

    angular
        .module('app.locacao.cadastro.equipamentos.equipamento_situacao', [])
        .config(config);

    function config($stateProvider, RotasHtml) {
        var rotasHtmlEquipamentoSituacao = RotasHtml.equipamento_situacao;
        $stateProvider.state(
          "app.locacao_cadastro_equipamentos_equipamento_situacao",
          {
            url: "/locacao/cadastro/equipamentos/equipamento-situacao",
            module: "privado",
            views: {
              "content@app": {
                templateUrl: rotasHtmlEquipamentoSituacao.templateUrl,
                controller: "EquipamentoSituacaoController as vm"
              },
              "equipamento-situacao-form@app.locacao_cadastro_equipamentos_equipamento_situacao": {
                templateUrl: rotasHtmlEquipamentoSituacao.form
              },
              "equipamento-situacao-tabela@app.locacao_cadastro_equipamentos_equipamento_situacao": {
                templateUrl: rotasHtmlEquipamentoSituacao.tabela
              }
            }
          }
        );
    }

})();


(function () {
    "use strict";

    angular
        .module("app.locacao.cadastro.equipamentos.equipamento_situacao")
        .controller("EquipamentoSituacaoController", EquipamentoSituacaoController);

    function EquipamentoSituacaoController(
        Api,
        RequisicaoGenericaLocacaoService,
        NavegacaoService,
        DatatableLocacaoFactory
    ) {
        var vm = this;
        NavegacaoService.setTituloAba("Equipamento situação");

        vm.metodos = {
            pesquisar: pesquisar,
            salvar: salvar,
            editar: editar,
            excluir: excluir,
            selecionar: selecionar,
            construirDtOptions: construirDtOptions
        };

        function pesquisar() {
            return RequisicaoGenericaLocacaoService.listarComObjetoComplexo(Api.locacao.equipamentos.equipamentoSituacao.listarComPaginacao, vm.entidadeDeEnvio);
        }


        function salvar(modelo) {

            if (!modelo.peso) modelo.peso = 0;

            return RequisicaoGenericaLocacaoService.salvar(Api.locacao.equipamentos.equipamentoSituacao.criar, modelo);
        }

        function editar(modelo) {
            if (!modelo.peso) modelo.peso = 0;

            return RequisicaoGenericaLocacaoService.editar(Api.locacao.equipamentos.equipamentoSituacao.editar, modelo)
        }

        function excluir(modelo) {
            return RequisicaoGenericaLocacaoService.excluir(Api.locacao.equipamentos.equipamentoSituacao.remover, modelo.id)
        }

        function selecionar(posicaoEntidade) {
            vm.metodosExternosPgToolbar.metodoControladorExternoListarTodasEntidades(null, posicaoEntidade);
        }

        function construirDtOptions() {
            DatatableLocacaoFactory.destruirTabela();

            vm.entidadeDeEnvio.clsEntidade = null;

            DatatableLocacaoFactory.construirDtOptionsComPaginacaoProcessadoNoServidorParaToolbar
                (Api.locacao.equipamentos.equipamentoSituacao.listarComPaginacaoDatatable, vm.entidadeDeEnvio.clsEntidade, '#datatable-equipamento-situacao',
                    [

                        DatatableLocacaoFactory.construirColunaDeSelecionarPadrao(function (indexLinha) { vm.metodos.selecionar(indexLinha) }),
                        {
                            targets: 1,
                            name: "Descricao",
                            data: "descricao",
                            defaultContent: ""
                        }
                    ]);
            vm.entidadeDeEnvio.clsEntidade = {};
        }



    }
})();

(function () {
    'use strict';

    angular
        .module('app.locacao.cadastro.equipamentos.equipamento_estado_conservacao', [])
        .config(config);

    function config($stateProvider, RotasHtml) {
        var rotasHtmlEquipamentoEstadoConservacao = RotasHtml.equipamento_estado_conservacao;
        $stateProvider.state(
          "app.locacao_cadastro_equipamentos_equipamento_estado_conservacao",
          {
            url: "/locacao/cadastro/equipamentos/equipamento-estado-conservacao",
            module: "privado",
            views: {
              "content@app": {
                templateUrl: rotasHtmlEquipamentoEstadoConservacao.templateUrl,
                controller: "EquipamentoEstadoConservacaoController as vm"
              },
              "equipamento-estado-conservacao-form@app.locacao_cadastro_equipamentos_equipamento_estado_conservacao": {
                templateUrl: rotasHtmlEquipamentoEstadoConservacao.form
              },
              "equipamento-estado-conservacao-tabela@app.locacao_cadastro_equipamentos_equipamento_estado_conservacao": {
                templateUrl: rotasHtmlEquipamentoEstadoConservacao.tabela
              }
            }
          }
        );
    }

})();

/**
 * Created by nova on 24/03/2017.
 */
(function () {
    "use strict";

    angular
        .module("app.locacao.cadastro.equipamentos.equipamento_estado_conservacao")
        .controller("EquipamentoEstadoConservacaoController", EquipamentoEstadoConservacaoController);

    function EquipamentoEstadoConservacaoController(
        Api,
        RequisicaoGenericaLocacaoService,
        NavegacaoService,
        DatatableLocacaoFactory
    ) {
        var vm = this;
        NavegacaoService.setTituloAba("Estado conservação");

        vm.metodos = {
            pesquisar: pesquisar,
            salvar: salvar,
            editar: editar,
            excluir: excluir,
            selecionar: selecionar,
            construirDtOptions: construirDtOptions,
            predefinirCamposInsercao: predefinirCamposInsercao
        };

        function pesquisar() {
            return RequisicaoGenericaLocacaoService.listarComObjetoComplexo(Api.locacao.equipamentos.estadoConservacao.listarComPaginacao, vm.entidadeDeEnvio);
        }

        function predefinirCamposInsercao() {
            vm.equipamentoEstadoConservacao = {
                obrigaFoto: true
            }
        }

        function salvar(modelo) {
            return RequisicaoGenericaLocacaoService.salvar(Api.locacao.equipamentos.estadoConservacao.criar, modelo);
        }

        function editar(modelo) {
            return RequisicaoGenericaLocacaoService.editar(Api.locacao.equipamentos.estadoConservacao.editar, modelo)
        }

        function excluir(modelo) {
            return RequisicaoGenericaLocacaoService.excluir(Api.locacao.equipamentos.estadoConservacao.remover, modelo.id)
        }

        function selecionar(posicaoEntidade) {
            vm.metodosExternosPgToolbar.metodoControladorExternoListarTodasEntidades(null, posicaoEntidade);
        }

        function construirDtOptions() {
            DatatableLocacaoFactory.destruirTabela();

            vm.entidadeDeEnvio.clsEntidade = null;

            DatatableLocacaoFactory.construirDtOptionsComPaginacaoProcessadoNoServidorParaToolbar(
                Api.locacao.equipamentos.estadoConservacao.listarComPaginacaoDatatable,
                vm.entidadeDeEnvio.clsEntidade,
                "#datatable-estado-conservacao",
                [

                    DatatableLocacaoFactory.construirColunaDeSelecionarPadrao(function (
                        indexLinha
                    ) {
                        vm.metodos.selecionar(indexLinha);
                    }),
                    {
                        targets: 1,
                        name: "Descricao",
                        data: "descricao",
                        defaultContent: "",
                    },
                ]
            );
            vm.entidadeDeEnvio.clsEntidade = {};
        }
    }
})();

//<!-- Ultima mudança 28/03/2017.-->
(function () {
    'use strict';

    angular
        .module('app.geral.cadastro.equipamento.equipamento', [])
        .config(config);

    function config($stateProvider, RotasHtml) {
        var rotasHtmlCargo = RotasHtml.equipamento;
        $stateProvider
            .state('app.geral_cadastro_equipamento_equipamento', {
                url: '/geral/cadastro/equipamento',
                module: 'privado',
                views: {
                    'content@app': {
                        templateUrl: rotasHtmlCargo.templateUrl,
                        controller: 'EquipamentoController as vm'
                    },
                    'equipamento-form@app.geral_cadastro_equipamento_equipamento': {
                        templateUrl: rotasHtmlCargo.form
                    },
                    'equipamentos-tabela@app.geral_cadastro_equipamento_equipamento': {
                        templateUrl: rotasHtmlCargo.tabela
                    }
                },
                resolve: {
                    ListarFabricantes: function (Api, RequisicaoGenericaService) {
                        return RequisicaoGenericaService.listarSemParams(Api.equipamento.equipamento_fabricante.listarPor);
                    },
                    ListarTiposEquipamento: function (Api, RequisicaoGenericaService) {
                        return RequisicaoGenericaService.listarSemParams(Api.equipamento.equipamento_tipo.listarPor);
                    },
                }
            });
    }

})();

(function () {
    'use strict';

    angular.module('app.geral.cadastro.equipamento.equipamento')
        .controller('EquipamentoLocacaoController',EquipamentoLocacaoController);

    function EquipamentoLocacaoController(Api,NavegacaoService,RequisicaoGenericaLocacaoService,DatatableLocacaoFactory,ListarFabricantes,ListarTiposEquipamento) {
        var vm = this;
        NavegacaoService.setTituloAba('Equipamento');

        vm.form = {};

        vm.fabricantes = ListarFabricantes.data;
        vm.tiposEquipamento = ListarTiposEquipamento.data;

        vm.metodos = {
            pesquisar: pesquisar,
            salvar: salvar,
            editar: editar,
            excluir: excluir,
            selecionar: selecionar,
            construirDtOptions: construirDtOptions,
            configuraMdSelectFabricante: configuraMdSelectFabricante,
            configuraMdSelectTipoEquipamento: configuraMdSelectTipoEquipamento
        }

        function pesquisar() {
            return RequisicaoGenericaLocacaoService.listarComObjetoComplexo(Api.locacao.equipamentos.equipamento.listarComPaginacao,vm.entidadeDeEnvio);
        }

        function salvar(modelo) {
            return RequisicaoGenericaLocacaoService.salvar(Api.locacao.equipamentos.equipamento.criar,modelo);
        }

        function editar(modelo) {
            return RequisicaoGenericaLocacaoService.editar(Api.locacao.equipamentos.equipamento.editar,modelo)
        }


        function excluir(modelo) {
            return RequisicaoGenericaLocacaoService.excluir(Api.locacao.equipamentos.equipamento.remover,modelo.id)
        }


        function selecionar(posicaoEntidade) {
            vm.metodosExternosPgToolbar.metodoControladorExternoListarTodasEntidades(null,posicaoEntidade);
        }


        function construirDtOptions() {
            DatatableLocacaoFactory.destruirTabela();

            vm.entidadeDeEnvio.clsEntidade = null;

            DatatableLocacaoFactory.construirDtOptionsComPaginacaoProcessadoNoServidorParaToolbar
                (Api.locacao.equipamentos.equipamento.listarComPaginacaoDatatable,vm.entidadeDeEnvio.clsEntidade,'#datatable-equipamento-locacao',
                    [

                        DatatableLocacaoFactory.construirColunaDeSelecionarPadrao(function (indexLinha) { vm.metodos.selecionar(indexLinha) }),
                        {
                            targets: 1,
                            name: "CodigoFabricante",
                            data: "fabricanteDescricao",
                            defaultContent: ""
                        },
                        {
                            targets: 2,
                            name: "CodigoTipoEquipamento",
                            data: "tipoDescricao",
                            defaultContent: ""
                        },
                        {
                            targets: 3,
                            name: "Descricao",
                            data: "descricao",
                            defaultContent: ""
                        }
                    ]);
            vm.entidadeDeEnvio.clsEntidade = {};

        }


        function configuraMdSelectFabricante() {
            vm.filtrarFabricantes = "";
            angular.element('#fabricante-md-select').on('keydown',function (ev) {
                ev.stopPropagation();
            });
        }

        function configuraMdSelectTipoEquipamento() {
            vm.filtrarFabricantes = "";
            angular.element('#tipo-equipamento-md-select').on('keydown',function (ev) {
                ev.stopPropagation();
            });
        }


    }
})();

(function () {
    'use strict';

    angular
        .module('app.locacao.cadastro.equipamentos.equipamento_fabricante', [])
        .config(config);

    function config($stateProvider, RotasHtml) {
        var rotasHtmlEquipamentoFabricante = RotasHtml.fabricante;
        $stateProvider.state(
          "app.locacao_cadastro_equipamentos_equipamento_fabricante",
          {
            url: "/locacao/cadastro/equipamentos/equipamento-fabricante",
            module: "privado",
            views: {
              "content@app": {
                templateUrl: rotasHtmlEquipamentoFabricante.templateUrl,
                controller: "EquipamentoFabricanteController as vm"
              },
              "equipamento-fabricante-form@app.locacao_cadastro_equipamentos_equipamento_fabricante": {
                templateUrl: rotasHtmlEquipamentoFabricante.form
              },
              "equipamento-fabricante-tabela@app.locacao_cadastro_equipamentos_equipamento_fabricante": {
                templateUrl: rotasHtmlEquipamentoFabricante.tabela
              }
            }
          }
        );
    }

})();


(function () {
  "use strict";

  angular
    .module("app.locacao.cadastro.equipamentos.equipamento_fabricante")
    .controller("EquipamentoFabricanteController", EquipamentoFabricanteController);

  function EquipamentoFabricanteController(
    Api,
    RequisicaoGenericaLocacaoService,
    NavegacaoService,
    DatatableLocacaoFactory
  ) {
    var vm = this;
    NavegacaoService.setTituloAba("Equipamento fabricante");

    vm.metodos = {
      pesquisar: pesquisar,
      salvar: salvar,
      editar: editar,
      excluir: excluir,
      selecionar: selecionar,
      construirDtOptions: construirDtOptions
    };

     function pesquisar() {
            return RequisicaoGenericaLocacaoService.listarComObjetoComplexo(Api.locacao.equipamentos.fabricante.listarComPaginacao, vm.entidadeDeEnvio);
        }


        function salvar(modelo) {
            return RequisicaoGenericaLocacaoService.salvar(Api.locacao.equipamentos.fabricante.criar, modelo);
        }

        function editar(modelo) {
            return RequisicaoGenericaLocacaoService.editar(Api.locacao.equipamentos.fabricante.editar, modelo)
        }

        function excluir(modelo) {
            return RequisicaoGenericaLocacaoService.excluir(Api.locacao.equipamentos.fabricante.remover, modelo.id)
        }

        function selecionar(posicaoEntidade) {
            vm.metodosExternosPgToolbar.metodoControladorExternoListarTodasEntidades(null, posicaoEntidade);
        }

        function construirDtOptions() {
          DatatableLocacaoFactory.destruirTabela();

              vm.entidadeDeEnvio.clsEntidade = null;

            DatatableLocacaoFactory.construirDtOptionsComPaginacaoProcessadoNoServidorParaToolbar(
              Api.locacao.equipamentos.fabricante.listarComPaginacaoDatatable,
              vm.entidadeDeEnvio.clsEntidade,
              "#datatable-fabricante",
              [
                DatatableLocacaoFactory.construirColunaDeSelecionarPadrao(function (
                  indexLinha
                ) {
                  vm.metodos.selecionar(indexLinha);
                }),
                {
                  targets: 1,
                  name: "Descricao",
                  data: "descricao",
                  defaultContent: "",
                },
              ]
            );
            vm.entidadeDeEnvio.clsEntidade = {};
    }


  }
})();

(function () {
    'use strict';

    angular
        .module('app.locacao.cadastro.equipamentos.equipamento_fornecedor', [])
        .config(config);

    function config($stateProvider, RotasHtml) {
        var rotasHtmlEquipamentoFornecedor = RotasHtml.equipamento_fornecedor;
        $stateProvider.state(
          "app.locacao_cadastro_equipamentos_equipamento_fornecedor",
          {
            url: "/locacao/cadastro/equipamentos/equipamento-fornecedor",
            module: "privado",
            views: {
              "content@app": {
                templateUrl: rotasHtmlEquipamentoFornecedor.templateUrl,
                controller: "EquipamentoFornecedorController as vm"
              },
              "equipamento-fornecedor-form@app.locacao_cadastro_equipamentos_equipamento_fornecedor": {
                templateUrl: rotasHtmlEquipamentoFornecedor.form
              },
              "equipamento-fornecedor-tabela@app.locacao_cadastro_equipamentos_equipamento_fornecedor": {
                templateUrl: rotasHtmlEquipamentoFornecedor.tabela
              }
            }
          }
        );
    }

})();


(function () {
  "use strict";

  angular
    .module("app.locacao.cadastro.equipamentos.equipamento_fornecedor")
    .controller("EquipamentoFornecedorController", EquipamentoFornecedorController);

  function EquipamentoFornecedorController(
    Api,
    RequisicaoGenericaLocacaoService,
    NavegacaoService,
    DatatableLocacaoFactory
  ) {
    var vm = this;
    NavegacaoService.setTituloAba("Equipamento fornecedor");

    vm.metodos = {
      pesquisar: pesquisar,
      salvar: salvar,
      editar: editar,
      excluir: excluir,
      selecionar: selecionar,
      construirDtOptions: construirDtOptions
    };

     function pesquisar() {
            return RequisicaoGenericaLocacaoService.listarComObjetoComplexo(Api.locacao.equipamentos.fornecedor.listarComPaginacao, vm.entidadeDeEnvio);
        }


        function salvar(modelo) {
            return RequisicaoGenericaLocacaoService.salvar(Api.locacao.equipamentos.fornecedor.criar, modelo);
        }

        function editar(modelo) {
            return RequisicaoGenericaLocacaoService.editar(Api.locacao.equipamentos.fornecedor.editar, modelo)
        }

        function excluir(modelo) {
            return RequisicaoGenericaLocacaoService.excluir(Api.locacao.equipamentos.fornecedor.remover, modelo.id)
        }

        function selecionar(posicaoEntidade) {
            vm.metodosExternosPgToolbar.metodoControladorExternoListarTodasEntidades(null, posicaoEntidade);
        }
         function construirDtOptions() {
          DatatableLocacaoFactory.destruirTabela();

             vm.entidadeDeEnvio.clsEntidade = null;

           DatatableLocacaoFactory.construirDtOptionsComPaginacaoProcessadoNoServidorParaToolbar(
             Api.locacao.equipamentos.fornecedor.listarComPaginacaoDatatable,
             vm.entidadeDeEnvio.clsEntidade,
             "#datatable-fornecedor-locacao",
             [
               DatatableLocacaoFactory.construirColunaDeSelecionarPadrao(
                 function (indexLinha) {
                   vm.metodos.selecionar(indexLinha);
                 }
               ),
               {
                 targets: 1,
                 name: "Descricao",
                 data: "descricao",
                 defaultContent: ""
               }
             ]
           );
           vm.entidadeDeEnvio.clsEntidade = {};
         }


  }
})();

(function () {
    'use strict';

    angular.module('app.implantacaoMigracao.processamento.processosFunis.processoFunil')
        .controller('ProcessoFunilController', ProcessoFunilController);

    function ProcessoFunilController(
        $stateParams,
        $scope,
        $mdDialog,
        ListarTarefasPorProcesso,
        ImplantacaoMigracaoFactory,
        ImplantacaoMigracaoService,
        NavegacaoService,
        MdDialogService,
        RotasHtml,
        ListarProcessosFunis,
        LoginUsuarioService
    ) {

        var vm = this;
        var subProcessoHistorico = {};
        var codigoUsuarioLogado = LoginUsuarioService.usuarioArmazenado().codigo;

        NavegacaoService.setTituloAba('Processo');

        vm.form = {};
        vm.rotasHtml = RotasHtml.implantacaoMigracao.processamento.processosFunis.processoFunil;
        vm.processosFunis = ListarProcessosFunis.data;
        vm.metodos = {
            abrirDialogSubprocesso: abrirDialogSubprocesso
        }

        vm.metodosImplantacaoMigracaoService = {
            verificarData: ImplantacaoMigracaoService.verificarDataVencida,
            navegarParaAtendimento: ImplantacaoMigracaoService.navegarParaAtendimento
        };

        init();

        function init() {
            vm.descricaoFunil = $stateParams.processoDescricao.split('-').join(' ');
            vm.tarefasProcesso = ImplantacaoMigracaoFactory.tarefasProcesso;
            vm.filtrosCard = ImplantacaoMigracaoFactory.filtrosCard;
            vm.tarefasProcessoFiltro = ImplantacaoMigracaoFactory.tarefasProcessoFiltro;

            vm.resultadosSubprocesso = [
                {
                    codigo: 2,
                    descricao: "FINALIZAR",
                    subprocessos: []
                },
                {
                    codigo: 3,
                    descricao: "CANCELAR",
                    subprocessos: []
                }
            ];

            _inicializarOpcoesCard();
            ImplantacaoMigracaoFactory.carregarTarefasProcesso(ListarTarefasPorProcesso.data);

            // Adicionar a tarefa de pausa no fim do array
            vm.tarefasProcesso.push(vm.tarefasProcesso.splice(0, 1)[0]);
        }

        function abrirDialogSubprocesso($event, subprocesso) {
            var codigoSubprocesso = undefined;
            var executivoContas = undefined;
            var codigoTarefaAtual = undefined;

            if (subprocesso) {
                codigoSubprocesso = subprocesso.codigo;
                codigoTarefaAtual = subprocesso.codigoTarefaAtual;

                executivoContas = {
                    codigo: subprocesso.codigoExecutivoContasResponsavel
                };
            }

            var callbackCriacaoSubprocesso = function (subprocesso) {
                vm.tarefasProcesso.map(
                    function (tarefa) {
                        if (tarefa.codigo == subprocesso.codigoTarefaAtual)
                            tarefa.subProcessos.push(subprocesso);
                    });
            }

            var callbackEdicaoSubprocesso = function (subprocessoDialog, tarefaAtual, tarefaModificada) {
                subprocesso.codigo = subprocessoDialog.codigo;
                subprocesso.codigoCliente = subprocessoDialog.codigoCliente;
                subprocesso.dataInicial = subprocessoDialog.dataInicial;
                subprocesso.dataFinalTarefa = subprocessoDialog.dataFinalTarefa;
                subprocesso.codigoAtendimento = subprocessoDialog.codigoAtendimento;
                subprocesso.anoAtendimento = subprocessoDialog.anoAtendimento;
                subprocesso.produtos = subprocessoDialog.produtos;
                subprocesso.codigoTarefaAtual = subprocessoDialog.codigoTarefaAtual;

                if (tarefaModificada) {
                    ImplantacaoMigracaoService.atualizaTarefaSubprocesso(vm.tarefasProcesso, tarefaAtual, subprocessoDialog);
                }
            }
            var Parametros = {
                codigoSubprocesso: codigoSubprocesso,
                codigoProcesso: $stateParams.processoCodigo,
                descricaoProcesso: vm.descricaoFunil,
                callbackCriacaoSubprocesso: callbackCriacaoSubprocesso,
                callbackEdicaoSubprocesso: callbackEdicaoSubprocesso,
                descricaoFunil: $stateParams.funilDescricao,
                executivoContas: executivoContas,
                processosFunis: vm.processosFunis,
                rotasHtml: vm.rotasHtml,
                tarefasProcesso: vm.tarefasProcesso,
                codigoUsuario: codigoUsuarioLogado,
                codigoTarefaAtual: codigoTarefaAtual,
            };

            $mdDialog.show({
                controller: 'DialogProcessoController',
                controllerAs: 'vm',
                templateUrl: vm.rotasHtml.dialogs.dialogProcesso.templateUrl,
                targetEvent: event,
                clickOutsideToClose: false,
                escapeToClose: false,
                multiple: false,
                locals: {
                    Parametros: Parametros
                }
            });
        }

        function _inicializarOpcoesCard() {

            /*
            Não deverão ser realizadas manipulações na visualização dos cards, principalmente com o objetivo de ocultar algum deles,
            pois isso impactará diretamente no fluxo da rotina.
            Portanto, o que está sendo exibido na interface SEMPRE deverá ser compatível ao que existe na model vm.tarefasProcesso.
            */

            var tarefasTemporaria = [];
            vm.arrastandoSubprocesso = false;

            vm.opcoesCardOrdenavel = ImplantacaoMigracaoFactory.configurarCardOptions();
            vm.opcoesCardOrdenavel.start = function (e, ui) {
                tarefasTemporaria = angular.copy(vm.tarefasProcesso);
                $scope.$apply(function () {
                    vm.arrastandoSubprocesso = true;
                });
            }

            vm.opcoesCardOrdenavel.stop = function (e, ui) {
                $scope.$apply(function () {
                    vm.arrastandoSubprocesso = false;
                });
            }

            vm.opcoesCardOrdenavel.update = function (e, ui) {
                var tarefaAtualSubprocesso;

                vm.tarefasProcesso.map(function (tarefa) {
                    tarefa.subProcessos.map(function (subprocesso) {
                        if (ui.item.sortable.model.codigo == subprocesso.codigo && ui.item.sortable.received) {
                            tarefaAtualSubprocesso = tarefa;
                        }
                    });
                });

                if (tarefaAtualSubprocesso) {
                    var historicoPossuiTarefa = ui.item.sortable.model.subProcessoHistoricos.some(function (historico) {
                        return historico.codigoTarefa == tarefaAtualSubprocesso.codigo;
                    });

                    if (tarefaAtualSubprocesso.codigo != 1
                        && (!historicoPossuiTarefa || ui.item.sortable.model.codigoTarefaAtual == 1)) {
                        subProcessoHistorico = {
                            codigoProcesso: ui.item.sortable.model.codigo,
                            codigoTarefa: tarefaAtualSubprocesso.codigo,
                            codigoUsuario: codigoUsuarioLogado,
                            data: new Date(),
                            observacao: '',
                            tarefaFinalizada: ui.item.sortable.model.tarefaFinalizada
                        };

                        ui.item.sortable.model.subProcessoHistoricos.push(subProcessoHistorico);

                        ImplantacaoMigracaoService.atualizarTarefa(ui.item.sortable.model, tarefaAtualSubprocesso).then(
                            function (success) {
                                ImplantacaoMigracaoService.atualizarSubprocesso(vm.tarefasProcesso, success.data);
                            },
                            function (error) {
                                ImplantacaoMigracaoFactory.carregarTarefasProcesso(tarefasTemporaria);
                            });
                    } else {
                        var funcaoCancelamento = function () {
                            ImplantacaoMigracaoFactory.carregarTarefasProcesso(tarefasTemporaria);
                        };

                        var Parametros = {
                            cardSubprocesso: ui.item.sortable.model,
                            codigoTarefaAnterior: ui.item.sortable.model.codigoTarefaAtual,
                            codigoTarefaAtual: tarefaAtualSubprocesso.codigo,
                            tarefasProcesso: tarefasTemporaria,
                            codigoUsuario: codigoUsuarioLogado,
                            funcaoCancelamento: funcaoCancelamento,
                            arrastandoSubprocesso: true,
                            tarefaFinalizada: ui.item.sortable.model.tarefaFinalizada
                        };

                        MdDialogService.abrirDialogPadrao(event, 'DialogObservacaoSubprocessoController',
                            vm.rotasHtml.dialogs.dialogObservacaoSubprocesso.templateUrl, Parametros);
                    }
                }
            };

            // Configurações para finalizar ou cancelar um subprocesso
            vm.resultadoSubprocesso = ImplantacaoMigracaoFactory.configurarCardOptions();
            vm.resultadoSubprocesso.start = function (e, ui) {
                $scope.$apply(function () {
                    vm.arrastandoSubprocesso = true;
                });
            }

            vm.resultadoSubprocesso.stop = function (e, ui) {
                $scope.$apply(function () {
                    vm.arrastandoSubprocesso = false;
                });
            }

            vm.resultadoSubprocesso.update = function (e, ui) {

                var subprocessoFinalizado = vm.resultadosSubprocesso[0].subprocessos[0];
                var subprocessoCancelado = vm.resultadosSubprocesso[1].subprocessos[0];
                var funcaoCancelamento = function () {
                    ImplantacaoMigracaoFactory.carregarTarefasProcesso(tarefasTemporaria);
                };

                var Parametros = {
                    cardSubprocesso: ui.item.sortable.model,
                    codigoTarefaAnterior: ui.item.sortable.model.codigoTarefaAtual,
                    codigoTarefaAtual: null,
                    tarefasProcesso: tarefasTemporaria,
                    funcaoCancelamento: funcaoCancelamento,
                    arrastandoSubprocesso: false,
                    tarefaFinalizada: ui.item.sortable.model.tarefaFinalizada
                };

                if (subprocessoFinalizado) {
                    ui.item.sortable.model.status = 2;
                }
                else if (subprocessoCancelado) {
                    ui.item.sortable.model.status = 3;
                }
                else {
                    return;
                }

                if (ui.item.sortable.model.status === 2) {
                    _salvar(ui.item.sortable.model, Parametros)
                    vm.resultadosSubprocesso[0].subprocessos = [];
                    vm.resultadosSubprocesso[1].subprocessos = [];
                } else {
                    MdDialogService.abrirDialogPadrao(event, 'DialogObservacaoSubprocessoController',
                        vm.rotasHtml.dialogs.dialogObservacaoSubprocesso.templateUrl, Parametros);
                }

            };
        }

        function _salvar(subProcesso, parametros) {
            if (!parametros.codigoTarefaAtual) {
                parametros.cardSubprocesso.codigoTarefaAtual = parametros.codigoTarefaAnterior;
            }

            if (parametros.arrastandoSubprocesso) {
                parametros.cardSubprocesso.codigoTarefaAtual = parametros.codigoTarefaAtual;
            }

            var tarefaAtual = undefined;
            parametros.tarefasProcesso.forEach(function (tarefa) {
                tarefaAtual = tarefa;

            });

            subProcessoHistorico = {
                codigoProcesso: parametros.cardSubprocesso.codigo,
                codigoTarefa: parametros.codigoTarefaAtual,
                codigoUsuario: parametros.codigoUsuarioLogado,
                data: new Date(),
                observacao: '',
                tarefaFinalizada: parametros.tarefaFinalizada
            };

            vm.requisicaoSolicitada = true;
            subProcesso.subProcessoHistoricos.push(subProcessoHistorico);

            ImplantacaoMigracaoService.atualizarTarefa(subProcesso, tarefaAtual).then(
                function (success) {
                    vm.requisicaoSolicitada = false;
                    subProcesso.tarefaFinalizada = false;
                    if ($mdDialog && $mdDialog.hide) {
                        $mdDialog.hide(success);
                    }
                },
                function (error) {
                    vm.requisicaoSolicitada = false;
                    ImplantacaoMigracaoFactory.carregarTarefasProcesso(parametros.tarefasProcesso);
                });
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('app.financeiro.relatorio.risco-rescisao-contratual')
        .factory('RiscoRescisaoContratualService', RiscoRescisaoContratualService);

    function RiscoRescisaoContratualService(RequisicaoGenericaService, Api, MdDialogService, LoginUsuarioService, $filter) {

        var montandoDados = false;
        var filtroUtilizado = null;
        var emProgresso = false;
        var dadosTabela = null;

        var service = {
            produtos: [],
            estados: [],
            motivosRiscosContratuais: [],
            setDados: setDados,
            montarDados: montarDados,
            gerarRelatorio: gerarRelatorio,
            setMontandoDados: setMontandoDados,
            getMontandoDados: getMontandoDados,
            setFiltroUtilizado: setFiltroUtilizado,
            getFiltroUtilizado: getFiltroUtilizado,
            setEmProgresso: setEmProgresso,
            getEmProgresso: getEmProgresso,
            getDadosTabela: getDadosTabela
        };

        return service;

        function setDados(produtos, estados, motivosRiscosContratuais) {
            service.produtos = produtos;
            service.estados = estados;
            service.motivosRiscosContratuais = motivosRiscosContratuais;
        }

        function montarDados(entidade) {
            setEmProgresso(true);
            setFiltroUtilizado(entidade);
            var promise = RequisicaoGenericaService.salvar(
                Api.geral.relatorioRiscoRescisaoContratual.montarDadosRelatorio,
                entidade
            );
            promise.then(function (response) {
                dadosTabela = response.data;
                setMontandoDados(true);
                setEmProgresso(false);
            }, function (error) {
                setMontandoDados(false);
                setEmProgresso(false);
                MdDialogService.alertPadrao(
                    'Atenção!',
                    null,
                    error.data
                );
            });
            return promise;
        }

        function formatarMotivo(motivosIds) {
            if (!motivosIds || motivosIds.length === 0) {
                return 'Todos';
            }
            return motivosIds.map(function (codigo) {
                var motivo = service.motivosRiscosContratuais.find(function (m) { return m.codigo === codigo; });
                if (!motivo) {
                    return '';
                }
                var descricao = motivo.descricao;
                if (descricao.length > 20) {
                    return descricao.substring(0, 20) + '...';
                }
                return descricao;
            }).join(', ');
        }

        function formatarItem(itensIds) {
            if (!itensIds || itensIds.length === 0) {
                return 'Todos';
            }
            return itensIds.map(function (codigo) {
                var produto = service.produtos.find(function (p) { return p.codigo === codigo; });
                if (!produto) {
                    return '';
                }
                var descricao = produto.descricao;
                if (descricao.length > 20) {
                    return descricao.substring(0, 20) + '...';
                }
                return descricao;
            }).join(', ');
        }

        function montarFiltroUtilizado(entidade, usuarioLogado) {
            var dataInicio = $filter('date')(entidade.dataInicioRescisaoContratual, 'dd/MM/yyyy');
            var dataFim = $filter('date')(entidade.dataFimRescisaoContratual, 'dd/MM/yyyy');

            var itens = formatarItem(entidade.itensContratuais);

            var estados = 'Todos';
            if (entidade.estados.length > 0) {
                estados = entidade.estados.join(', ');
            }

            var motivos = formatarMotivo(entidade.motivos);

            return 'Colaborador: ' + usuarioLogado.nome +
                ', Data Inicial: ' + dataInicio +
                ', Data Final: ' + dataFim +
                ', Estado: ' + estados +
                ', Itens: ' + itens +
                ', Motivo: ' + motivos;
        }

        function gerarRelatorio(entidade, dadosClientesOrdenados, valorTotalClientes) {
            var usuarioLogado = LoginUsuarioService.usuarioArmazenado();

            var entidadeEnvio = {
                filtrosUtilizados: montarFiltroUtilizado(entidade, usuarioLogado),
                filtros: entidade,
                dados: {
                    dadosClientes: dadosClientesOrdenados,
                    totalClientes: dadosClientesOrdenados.length,
                    valorTotalClientes: valorTotalClientes,
                }
            };

            return RequisicaoGenericaService.listarComObjetoComplexo(
                Api.geral.relatorioRiscoRescisaoContratual.gerarRelatorio,
                entidadeEnvio
            );
        }

        function setMontandoDados(valor) { montandoDados = valor; }
        function getMontandoDados() { return montandoDados; }
        function setFiltroUtilizado(valor) { filtroUtilizado = valor; }
        function getFiltroUtilizado() { return filtroUtilizado; }
        function setEmProgresso(valor) { emProgresso = valor; }
        function getEmProgresso() { return emProgresso; }
        function getDadosTabela() { return dadosTabela; }
    }
}
)();
(function () {
    'use strict';

    angular
        .module('app.financeiro.cadastro.faturamento.natureza', [])
        .config(config);

    function config($stateProvider, RotasHtml) {
        var rotasHtml = RotasHtml.naturezaFaturamento;
        $stateProvider
            .state('app.financeiro_cadastro_faturamento_natureza', {
                url: '/financeiro/cadastro/natureza',
                module: 'privado',
                views: {
                    'content@app': {
                        templateUrl: rotasHtml.templateUrl,
                        controller: 'NaturezaController as vm'
                    },
                    'natureza-form@app.financeiro_cadastro_faturamento_natureza': {
                        templateUrl: rotasHtml.form
                    },
                    'naturezas-tabela@app.financeiro_cadastro_faturamento_natureza': {
                        templateUrl: rotasHtml.tabela
                    }
                }
            });
    }

})();

(function () {
    'use strict';

    angular.module('app.financeiro.cadastro.faturamento.natureza')
        .controller('NaturezaController', NaturezaController);

    function NaturezaController(NavegacaoService,
        Api,
        RequisicaoGenericaService,
        DatatableFactory,
        $filter) {
        var vm = this;
        NavegacaoService.setTituloAba('Natureza de faturamento');

        _init();

        vm.metodos = {
            pesquisar: pesquisar,
            salvar: salvar,
            editar: editar,
            excluir: excluir,
            selecionar: selecionar,
            construirDtOptions: construirDtOptions,
            preDefinirParaInsercao: preDefinirParaInsercao,
            onChangePercentualDescontar: onChangePercentualDescontar,
            reverterCadastro: reverterCadastro
        }

        function _init() {
            vm.form = {};
            vm.controleForm = {};
            vm.rota = Api.naturezaFaturamento;

            DatatableFactory.setConverterEntidadePesquisaParaJson(true);
        }

        function pesquisar() {
            return RequisicaoGenericaService.listarComObjetoComplexo(vm.rota.listarComPaginacao, vm.entidadeDeEnvio);
        }

        function salvar(modelo) {
            return RequisicaoGenericaService.salvar(vm.rota.criar, modelo);
        }

        function editar(modelo) {
            return RequisicaoGenericaService.editar(vm.rota.atualizar, modelo)
        }

        function excluir(modelo) {
            return RequisicaoGenericaService.excluir(vm.rota.excluir, modelo.codigo)
        }

        function selecionar(posicaoEntidade) {
            vm.metodosExternosPgToolbar.metodoControladorExternoListarTodasEntidades(null, posicaoEntidade);
        }

        function construirDtOptions() {
            DatatableFactory.construirDtOptionsComPaginacaoProcessadoNoServidorParaToolbar(vm.rota.listarComPaginacaoDatatable, vm.entidadeDeEnvio.clsEntidade, '#datatable-natureza',
                [

                    DatatableFactory.construirColunaDeSelecionarPadrao(function (indexLinha) { vm.metodos.selecionar(indexLinha) }),
                    {
                        targets: 1,
                        name: "Descricao",
                        data: "descricao",
                        defaultContent: ""
                    },
                    {
                        targets: 2,
                        name: "PercentualImpostoDescontar",
                        data: "percentualImpostoDescontar",
                        defaultContent: "",
                        render: function (data) {
                            return $filter('number')(data * 100, 2) + "%"
                        }
                    },
                    {
                        targets: 3,
                        name: "Ativo",
                        data: "ativo",
                        defaultContent: "",
                        render: function (data) {
                            return data ? "Sim" : "Não"
                        }
                    }
                ]);
        }

        function preDefinirParaInsercao() {
            vm.form.percentualImpostoDescontar.$setValidity("validaMaiorQueZero", false);
            vm.natureza = {
                ativo: true,
                percentualImpostoDescontar: 0
            }
        }

        function onChangePercentualDescontar(percentualDescontar) {
            if (percentualDescontar <= 0) {
                vm.form.percentualImpostoDescontar.$setValidity("validaMaiorQueZero", false);
            } else {
                vm.form.percentualImpostoDescontar.$setValidity("validaMaiorQueZero", true);
            }

        }

        function reverterCadastro() {
            vm.form.percentualImpostoDescontar.$setValidity("validaMaiorQueZero", true);
        }

    }
})();

//<!-- Ultima mudança 19/07/2017.-->
(function () {
    'use strict';

    angular
        .module('app.financeiro.cadastro.faturamento.formaFaturamento', [])
        .config(config);

    function config($stateProvider, RotasHtml) {
        var rotasHtml = RotasHtml.formaFaturamento;
        $stateProvider
            .state('app.financeiro_cadastro_faturamento_formafaturamento', {
                url: '/financeiro/cadastro/forma-faturamento',
                module: 'privado',
                views: {
                    'content@app': {
                        templateUrl: rotasHtml.templateUrl,
                        controller: 'FormaFaturamentoController as vm'
                    },
                    'forma-faturamento-form@app.financeiro_cadastro_faturamento_formafaturamento': {
                        templateUrl: rotasHtml.form
                    },
                    'formas-faturamentos-tabela@app.financeiro_cadastro_faturamento_formafaturamento': {
                        templateUrl: rotasHtml.tabela
                    }
                }               
            });
    }

})();

//<!-- Ultima mudança 19/07/2017.-->
(function () {
    'use strict';

    angular.module('app.financeiro.cadastro.faturamento.formaFaturamento')
        .controller('FormaFaturamentoController', FormaFaturamentoController);

    function FormaFaturamentoController(Api, NavegacaoService, RequisicaoGenericaService, DatatableFactory) {
        var vm = this;
        NavegacaoService.setTituloAba('Financeiro forma de faturamento');

        // Data region            

        _init();
        // endregion    


        // Definição dos Métodos region
        vm.metodos = {
            pesquisar: pesquisar,
            salvar: salvar,
            editar: editar,
            excluir: excluir,
            selecionar: selecionar,
            construirDtOptions: construirDtOptions
        }
        //endregion

        // Implementação dos Métodos region

        function _init() {
            vm.form = {};
            vm.rota = Api.formaFaturamento;

            DatatableFactory.setConverterEntidadePesquisaParaJson(true);
        }

        function pesquisar() {
            return RequisicaoGenericaService.listarPorPaginacaoJsonFormato(vm.rota.listarComPaginacao, vm.entidadeDeEnvio);
        }

        function salvar(modelo) {
            return RequisicaoGenericaService.salvar(vm.rota.criar, modelo);
        }

        function editar(modelo) {
            return RequisicaoGenericaService.editar(vm.rota.atualizar, modelo)
        }

        function excluir(modelo) {
            return RequisicaoGenericaService.excluir(vm.rota.excluir, modelo.codigo)
        }

        function selecionar(posicaoEntidade) {
            vm.metodosExternosPgToolbar.metodoControladorExternoListarTodasEntidades(null, posicaoEntidade);
        }

        function construirDtOptions() {
            DatatableFactory.construirDtOptionsComPaginacaoProcessadoNoServidorParaToolbar
                (vm.rota.listarComPaginacaoDatatable, vm.entidadeDeEnvio.clsEntidade, '#datatable-forma-faturamento',
                [

                    DatatableFactory.construirColunaDeSelecionarPadrao(function (indexLinha) { vm.metodos.selecionar(indexLinha) }),
                    {
                        targets: 1,
                        name: "Codigo",
                        data: "codigo",
                        defaultContent: "",
                        sortable: false  
                    },
                    {
                        targets: 2,
                        name: "Descricao",
                        data: "descricao",
                        defaultContent: "",
                        sortable: false  
                    }
                ]);
        }
        //endregion

    }
})();

//<!-- Ultima mudança 19/07/2017.-->
(function () {
    'use strict';

    angular
        .module('app.financeiro.cadastro.faturamento.formaPagamento', [])
        .config(config);

    function config($stateProvider, RotasHtml) {
        var rotasHtml = RotasHtml.formaPagamento;
        $stateProvider
            .state('app.financeiro_cadastro_faturamento_formapagamento', {
                url: '/financeiro/cadastro/forma-pagamento',
                module: 'privado',
                views: {
                    'content@app': {
                        templateUrl: rotasHtml.templateUrl,
                        controller: 'FormaPagamentoController as vm'
                    },
                    'forma-pagamento-form@app.financeiro_cadastro_faturamento_formapagamento': {
                        templateUrl: rotasHtml.form
                    },
                    'formas-pagamentos-tabela@app.financeiro_cadastro_faturamento_formapagamento': {
                        templateUrl: rotasHtml.tabela
                    }
                }               
            });
    }

})();

//<!-- Ultima mudança 19/07/2017.-->
(function () {
    'use strict';

    angular.module('app.financeiro.cadastro.faturamento.formaPagamento')
        .controller('FormaPagamentoController', FormaPagamentoController);

    function FormaPagamentoController(Api, NavegacaoService, RequisicaoGenericaService, DatatableFactory) {
        var vm = this;
        NavegacaoService.setTituloAba('Financeiro forma de pagamento');

        // Data region            

        _init();
        // endregion    


        // Definição dos Métodos region
        vm.metodos = {
            pesquisar: pesquisar,
            salvar: salvar,
            editar: editar,
            excluir: excluir,
            selecionar: selecionar,
            construirDtOptions: construirDtOptions
        }
        //endregion

        // Implementação dos Métodos region

        function _init() {
            vm.form = {};
            vm.rota = Api.formaPagamento;

            DatatableFactory.setConverterEntidadePesquisaParaJson(true);
        }

        function pesquisar() {
            return RequisicaoGenericaService.listarPorPaginacaoJsonFormato(vm.rota.listarComPaginacao, vm.entidadeDeEnvio);
        }

        function salvar(modelo) {
            return RequisicaoGenericaService.salvar(vm.rota.criar, modelo);
        }

        function editar(modelo) {
            return RequisicaoGenericaService.editar(vm.rota.atualizar, modelo)
        }

        function excluir(modelo) {
            return RequisicaoGenericaService.excluir(vm.rota.excluir, modelo.codigo)
        }

        function selecionar(posicaoEntidade) {
            vm.metodosExternosPgToolbar.metodoControladorExternoListarTodasEntidades(null, posicaoEntidade);
        }

        function construirDtOptions() {
            DatatableFactory.construirDtOptionsComPaginacaoProcessadoNoServidorParaToolbar
                (vm.rota.listarComPaginacaoDatatable, vm.entidadeDeEnvio.clsEntidade, '#datatable-forma-pagamento',
                    [

                        DatatableFactory.construirColunaDeSelecionarPadrao(function (indexLinha) { vm.metodos.selecionar(indexLinha) }),
                        {
                            targets: 1,
                            name: "Codigo",
                            data: "codigo",
                            defaultContent: "",
                            sortable: false
                        },
                        {
                            targets: 2,
                            name: "Descricao",
                            data: "descricao",
                            defaultContent: "",
                            sortable: false
                        }
                    ]);
        }
        //endregion

    }
})();

//<!-- Ultima mudança 28/03/2017.-->
(function () {
    'use strict';

    angular
        .module('app.financeiro.cadastro.contrato.indiceReajuste', [])
        .config(config);

    function config($stateProvider, RotasHtml) {
        var rotasHtmlBairro = RotasHtml.indice_reajuste;
        $stateProvider
            .state('app.financeiro_cadastro_contrato_indicereajuste', {
                url: '/financeiro/cadastro/contrato/indice-reajuste',
                module: 'privado',
                views: {
                    'content@app': {
                        templateUrl: rotasHtmlBairro.templateUrl,
                        controller: "IndiceReajusteController as vm"
                    },
                    'indice-reajuste-form@app.financeiro_cadastro_contrato_indicereajuste': {
                        templateUrl: rotasHtmlBairro.form
                    },
                    'indices-reajuste-tabela@app.financeiro_cadastro_contrato_indicereajuste': {
                        templateUrl: rotasHtmlBairro.tabela
                    }
                }
            });
    }

})();

/**
 * Created by nova on 24/03/2017.
 */
(function () {
    'use strict';

    angular.module('app.financeiro.cadastro.contrato.indiceReajuste')
        .controller('StatusContratoController', StatusContratoController);

    function StatusContratoController(Api, RequisicaoGenericaService, NavegacaoService, DatatableFactory) {
        var vm = this;
        NavegacaoService.setTituloAba('Financeiro status contrato');


        //////////////////////////////////////////////////////// Data ///////////////////////////////////////
        vm.form = {};
        //////////////////////////////////////////////////////// Fim Data ///////////////////////////////////////      

        // Definição dos Métodos region
        vm.metodos = {
            pesquisar: pesquisar,
            salvar: salvar,
            editar: editar,
            excluir: excluir,
            selecionar: selecionar,
            construirDtOptions: construirDtOptions
        }

        //////////////////////////////////////////////////////// Implementação dos Métodos ////////////////////////////////////////////////////////

        /**
         * Método para pesquisar um Status Contrato
         */
        function pesquisar() {
            return RequisicaoGenericaService.listarComObjetoComplexo(Api.contrato.status_contrato.listarComPaginacao, vm.entidadeDeEnvio);
        }

        /**
         * Método salvar um Status Contrato
         * @param {object} modelo 
         */
        function salvar(modelo) {
            return RequisicaoGenericaService.salvar(Api.contrato.status_contrato.criar, modelo);
        }

        /**
         * Método para editar um Status Contrato
         * @param {object} modelo
         */
        function editar(modelo) {
            return RequisicaoGenericaService.editar(Api.contrato.status_contrato.atualizar, modelo)
        }

        /**
         * Método para excluir um Status Contrato
         * @param {object} modelo
         */
        function excluir(modelo) {
            return RequisicaoGenericaService.excluir(Api.contrato.status_contrato.excluir, modelo.codigo)
        }

        /**
         * Método utilizado no modo exibido tabela, para selecionar um Status Contrato
         * @param {object} modelo
         */
        function selecionar(posicaoEntidade) {
            vm.metodosExternosPgToolbar.metodoControladorExternoListarTodasEntidades(null, posicaoEntidade);
        }

        /**
         * Método para construi o DtOptions da tabela
         */
        function construirDtOptions() {
            DatatableFactory.construirDtOptionsComPaginacaoProcessadoNoServidorParaToolbar
                (Api.contrato.status_contrato.listarComPaginacaoDatatable, vm.entidadeDeEnvio.clsEntidade, '#datatable-status-contrato',
                    [

                        DatatableFactory.construirColunaDeSelecionarPadrao(function (indexLinha) { vm.metodos.selecionar(indexLinha) }),
                        {
                            targets: 1,
                            name: "Descricao",
                            data: "descricao",
                        }
                    ]);
        }
        //////////////////////////////////////////////////////// Fim Implementação dos Métodos /////////////////////////////////////////////////////

    }
})();

(function () {
    'use strict';

    angular.module('app.financeiro.cadastro.contrato.indiceReajuste')
        .controller('MotivoAditivoController', MotivoAditivoController);

    function MotivoAditivoController(Api, NavegacaoService, RequisicaoGenericaService, DatatableFactory, urlApi) {
        var vm = this;
        NavegacaoService.setTituloAba('Financeiro motivo auditivo');

        vm.form = {};

        // Definição dos Métodos region
        vm.metodos = {
            pesquisar: pesquisar,
            salvar: salvar,
            editar: editar,
            excluir: excluir,
            selecionar: selecionar,
            construirDtOptions: construirDtOptions,
            preDefinirCamposParaInserir: preDefinirCamposParaInserir
        }

        /**
         * Método para pesquisar um Motivo Aditivo
         */
        function pesquisar() {
            return RequisicaoGenericaService.listarComObjetoComplexo(Api.contrato.motivo_aditivo.ListarComPaginacao, vm.entidadeDeEnvio);
        }

        /**
         * Método salvar um Motivo Aditivo
         * @param {object} modelo 
         */
        function salvar(modelo) {
            return RequisicaoGenericaService.salvar(Api.contrato.motivo_aditivo.criar, modelo);
        }

        /**
         * Método para editar um Motivo Aditivo
         * @param {object} modelo
         */
        function editar(modelo) {
            return RequisicaoGenericaService.editar(Api.contrato.motivo_aditivo.atualizar, modelo)
        }

        /**
         * Método para excluir um Motivo Aditivo
         * @param {object} modelo
         */
        function excluir(modelo) {
            return RequisicaoGenericaService.excluir(Api.contrato.motivo_aditivo.excluir, modelo.codigo)
        }

        /**
         * Método utilizado no modo exibido tabela, para selecionar um Motivo Aditivo
         * @param {number} posicaoEntidade posição da entidade
         */
        function selecionar(posicaoEntidade) {
            vm.metodosExternosPgToolbar.metodoControladorExternoListarTodasEntidades(null, posicaoEntidade);
        }

        /**
         * Método para construi o DtOptions da tabela
         */
        function construirDtOptions() {
            DatatableFactory.construirDtOptionsComPaginacaoProcessadoNoServidorParaToolbar
                (Api.contrato.motivo_aditivo.listarComPaginacaoDatatable, vm.entidadeDeEnvio.clsEntidade, '#datatable-motivo-aditivo',
                    [

                        DatatableFactory.construirColunaDeSelecionarPadrao(function (indexLinha) { vm.metodos.selecionar(indexLinha) }),
                        {
                            targets: 1,
                            name: "Codigo",
                            data: "codigo",
                            defaultContent: "",
                            sortable: false
                        },
                        {
                            targets: 2,
                            name: "Descricao",
                            data: "descricao",
                            defaultContent: "",
                            sortable: false
                        },
                        {
                            targets: 3,
                            name: "Permitir Reajuste",
                            data: "permitirReajuste",
                            render: function (data) {
                                if (data)
                                    return "Sim";
                                else
                                    return "Não";
                            },
                            defaultContent: "",
                            sortable: false
                        }
                    ]);
        }

        function preDefinirCamposParaInserir() {
            vm.motivoAditivo = {
                permitirReajuste: true
            }
        }
    }
})();

(function () {
    'use strict';

    angular.module('app.financeiro.cadastro.contrato.indiceReajuste')
        .controller('TipoContratoController', TipoContratoController);

    function TipoContratoController(Api,
        RequisicaoGenericaService,
        NavegacaoService,
        DatatableFactory) {

        var vm = this;

        NavegacaoService.setTituloAba('Financeiro tipo contrato');

        vm.form = {};

        vm.metodos = {
            pesquisar: pesquisar,
            salvar: salvar,
            editar: editar,
            excluir: excluir,
            selecionar: selecionar,
            construirDtOptions: construirDtOptions
        }

        function pesquisar() {
            return RequisicaoGenericaService.listarComObjetoComplexo(Api.contrato.tipo_contrato.listarComPaginacao, vm.entidadeDeEnvio);
        }

        function salvar(modelo) {
            return RequisicaoGenericaService.salvar(Api.contrato.tipo_contrato.criar, modelo);
        }

        function editar(modelo) {
            return RequisicaoGenericaService.editar(Api.contrato.tipo_contrato.atualizar, modelo)
        }

        function excluir(modelo) {
            return RequisicaoGenericaService.excluir(Api.contrato.tipo_contrato.excluir, modelo.codigo)
        }

        function selecionar(posicaoEntidade) {
            vm.metodosExternosPgToolbar.metodoControladorExternoListarTodasEntidades(null, posicaoEntidade);
        }

        function construirDtOptions() {
            DatatableFactory.construirDtOptionsComPaginacaoProcessadoNoServidorParaToolbar
                (Api.contrato.tipo_contrato.listarComPaginacaoDatatable, vm.entidadeDeEnvio.clsEntidade, '#datatable-tipo-contrato',
                    [

                        DatatableFactory.construirColunaDeSelecionarPadrao(function (indexLinha) { vm.metodos.selecionar(indexLinha) }),
                        {
                            targets: 1,
                            name: "Descricao",
                            data: "descricao",
                        }
                    ]);
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('app.financeiro.cadastro.contrato.motivoRiscoContratual', [])
        .config(config);

    function config($stateProvider, RotasHtml) {
        var rotasHtmlMotivoRiscoContratual = RotasHtml.motivo_risco_contratual;
        $stateProvider
            .state('app.financeiro_cadastro_contrato_motivo_risco_contratual', {
                url: '/financeiro/cadastro/contrato/motivo-risco-contratual',
                module: 'privado',
                views: {
                    'content@app': {
                        templateUrl: rotasHtmlMotivoRiscoContratual.templateUrl,
                        controller: "MotivoRiscoContratualController as vm"
                    },
                    'motivo-risco-contratual-form@app.financeiro_cadastro_contrato_motivo_risco_contratual': {
                        templateUrl: rotasHtmlMotivoRiscoContratual.form
                    },
                    'motivo-risco-contratual-tabela@app.financeiro_cadastro_contrato_motivo_risco_contratual': {
                        templateUrl: rotasHtmlMotivoRiscoContratual.tabela
                    }
                }
            });
    }

})();
(function () {
    'use strict';

    angular.module('app.financeiro.cadastro.contrato.motivoRiscoContratual')
        .controller('MotivoRiscoContratualController', MotivoRiscoContratualController);

    function MotivoRiscoContratualController(Api,
        RequisicaoGenericaService,
        NavegacaoService,
        DatatableFactory) {
        var vm = this;
        NavegacaoService.setTituloAba('Financeiro motivo risco contratual');

        vm.form = {};

        vm.metodos = {
            pesquisar: pesquisar,
            salvar: salvar,
            editar: editar,
            excluir: excluir,
            selecionar: selecionar,
            construirDtOptions: construirDtOptions
        }

        function pesquisar() {
            return RequisicaoGenericaService.listarComObjetoComplexo(Api.contrato.motivo_risco_contratual.listarComPaginacao, vm.entidadeDeEnvio);
        }

        function salvar(modelo) {
            return RequisicaoGenericaService.salvar(Api.contrato.motivo_risco_contratual.criar, modelo);
        }

        function editar(modelo) {
            return RequisicaoGenericaService.editar(Api.contrato.motivo_risco_contratual.atualizar, modelo)
        }

        function excluir(modelo) {
            return RequisicaoGenericaService.excluir(Api.contrato.motivo_risco_contratual.excluir, modelo.codigo)
        }

        function selecionar(posicaoEntidade) {
            vm.metodosExternosPgToolbar.metodoControladorExternoListarTodasEntidades(null, posicaoEntidade);
        }

        function construirDtOptions() {
            DatatableFactory.construirDtOptionsComPaginacaoProcessadoNoServidorParaToolbar
                (Api.contrato.motivo_risco_contratual.listarComPaginacaoDatatable, vm.entidadeDeEnvio.clsEntidade, '#datatable-motivo-risco-contratual',
                    [

                        DatatableFactory.construirColunaDeSelecionarPadrao(function (indexLinha) { vm.metodos.selecionar(indexLinha) }),
                        {
                            targets: 1,
                            name: "Codigo",
                            data: "codigo",
                        },
                        {
                            targets: 2,
                            name: "Descricao",
                            data: "descricao",
                        }
                    ]);
        }
    }
})();
/**
 * Created by nova on 24/03/2017.
 */
(function () {
    'use strict';

    angular.module('app.financeiro.cadastro.contrato.indiceReajuste')
        .controller('IndiceReajusteController', IndiceReajusteController);

    function IndiceReajusteController(Api, NavegacaoService,RequisicaoGenericaService, DatatableFactory) {
        var vm = this;
        NavegacaoService.setTituloAba('Financeiro índice reajuste');


        //////////////////////////////////////////////////////// Data ///////////////////////////////////////
        vm.form = {};
        //////////////////////////////////////////////////////// Fim Data ///////////////////////////////////////

        // Definição dos Métodos region
        vm.metodos = {
            pesquisar: pesquisar,
            salvar: salvar,
            editar: editar,
            excluir: excluir,
            selecionar: selecionar,
            construirDtOptions: construirDtOptions
        }

        //////////////////////////////////////////////////////// Implementação dos Métodos ////////////////////////////////////////////////////////

        /**
         * Método para pesquisar um IndiceReajuste
         */
        function pesquisar() {
            return RequisicaoGenericaService.listarComObjetoComplexo(Api.contrato.indice_reajuste.listarComPaginacao, vm.entidadeDeEnvio);
        }

        /**
         * Método salvar um IndiceReajuste
         * @param {object} modelo 
         */
        function salvar(modelo) {
            return RequisicaoGenericaService.salvar(Api.contrato.indice_reajuste.criar, modelo);
        }

        /**
         * Método para editar um IndiceReajuste
         * @param {object} modelo
         */
        function editar(modelo) {
            return RequisicaoGenericaService.editar(Api.contrato.indice_reajuste.atualizar, modelo)
        }

        /**
         * Método para excluir um IndiceReajuste
         * @param {object} modelo
         */
        function excluir(modelo) {
            return RequisicaoGenericaService.excluir(Api.contrato.indice_reajuste.excluir, modelo.codigo)
        }

        /**
         * Método utilizado no modo exibido tabela, para selecionar um IndiceReajuste
         * @param {object} modelo
         */
        function selecionar(posicaoEntidade) {
            vm.metodosExternosPgToolbar.metodoControladorExternoListarTodasEntidades(null, posicaoEntidade);
        }

        /**
         * Método para construi o DtOptions da tabela
         */
        function construirDtOptions() {
            DatatableFactory.construirDtOptionsComPaginacaoProcessadoNoServidorParaToolbar
                (Api.contrato.indice_reajuste.listarComPaginacaoDatatable, vm.entidadeDeEnvio.clsEntidade, '#datatable-indice-reajuste',
                [

                    DatatableFactory.construirColunaDeSelecionarPadrao(function (indexLinha) { vm.metodos.selecionar(indexLinha) }),
                    {
                        targets: 1,
                        name: "Descricao",
                        data: "descricao",
                        sortable: false  
                    }
                ]);
        }
        //////////////////////////////////////////////////////// Fim Implementação dos Métodos /////////////////////////////////////////////////////

    }
})();

(function () {
    'use strict';

    angular
        .module('app.geral.indicadores.gestaoiaguas')
        .service('GestaoIAguasService', GestaoIAguasService)

    /** @ngInject */
    function GestaoIAguasService($mdSidenav) {

        var _filtro;

        var service = {
            toggleFiltro: toggleFiltro,
            setFiltro: setFiltro,
            getFiltro: getFiltro
        }

        function toggleFiltro() {
            $mdSidenav('filtro-gestao-iaguas').toggle();
        }

        function setFiltro(filtro) {
            _filtro = filtro;
        }

        function getFiltro() {
            return angular.copy(_filtro);
        }

        return service;
    }

})();
/**
 * Created by nova on 12/08/2016.
 */
(function () {
    'use strict';

    angular
        .module('app.geral.cadastro.usuario.usuario')
        .controller('UsuarioController', UsuarioController);

    function UsuarioController($mdDialog, $scope, NavegacaoService, Api, $q, $timeout, RequisicaoGenericaService, setores, perfis, UsuarioService, ListarTiposAtendimento, LoginUsuarioService,
        DatatableFactory, ListarCategorias, ListarTodosUsuarios, ToolbarService, MdDialogService, ListarSquads) {
        var vm = this;
        NavegacaoService.setTituloAba('Colaborador');

        var senhaAntiga = "";

        // Data region
        vm.htmlRota = UsuarioService.listarHtmlRotas();
        vm.form = {};
        vm.tipoSanguineo = ["Nenhum", "A+", "A-", "B+", "B-", "AB+", "AB-", "O+", "O-"]
        vm.categoriasSelecionadas = [];

        vm.rota = Api.usuario.proximoCodigo;
        vm.tabSelecionada = "colaborador";
        vm.controleUsuario = {
            controladorDetalhesUsuario: false,
            controladorCategoriasDetalhesUsuario: false
        }

        vm.regexHora = /^([01]?[0-9]|2[0-3]):[0-5][0-9]$/;
        vm.diasSemana = [
            { dia: "Segunda", valor: "1" },
            { dia: "Terça", valor: "2" },
            { dia: "Quarta", valor: "3" },
            { dia: "Quinta", valor: "4" },
            { dia: "Sexta", valor: "5" },
            { dia: "Sábado", valor: "6" },
            { dia: "Domingo", valor: "0" }
        ];
        //endregion

        // Resolve region
        vm.setores = setores.data;
        vm.perfis = perfis.data;
        vm.tiposAtendimento = ListarTiposAtendimento.data;
        vm.categorias = ListarCategorias.data;
        vm.squads = ListarSquads;
        vm.categoria = [];
        vm.todosUsuarios = ListarTodosUsuarios.data;
        //endregion

        // Definição dos Métodos region
        vm.metodosGeral = {
            tabSelecionada: tabSelecionada,
        }
        vm.metodosUsuario = {
            pesquisar: pesquisar,
            salvar: salvar,
            editar: editar,
            selecionar: selecionar,
            construirDtOptions: construirDtOptions,
            rotinaSenha: rotinaSenha,
            onChangeUsuarioLogin: onChangeUsuarioLogin,
            preDefinirParaInsercao: preDefinirParaInsercao
        };

        vm.metodosDetalhesColaborador = {
            configuraAutoCompleteCidadeOnBlur: configuraAutoCompleteCidadeOnBlur,
            salvarDetalhes: salvarDetalhes,
            editarDetalhes: editarDetalhes,
            alterarEstadoCampoNotificarAtendimentosEmAbertoSetor: alterarEstadoCampoNotificarAtendimentosEmAbertoSetor,
            alterarEstadoCampoVisualizarAtendimentosEmAbertoSetor: alterarEstadoCampoVisualizarAtendimentosEmAbertoSetor,
            alterarItemSelecionadoAutoCompleteCidade: alterarItemSelecionadoAutoCompleteCidade,
            pesquisarAutoCompleteCidade: pesquisarAutoCompleteCidade,
            configuraAutoCompleteBairroOnBlur: configuraAutoCompleteBairroOnBlur,
            alterarItemSelecionadoAutoCompleteBairro: alterarItemSelecionadoAutoCompleteBairro,
            pesquisarAutoCompleteBairro: pesquisarAutoCompleteBairro,
            preparaTipoSanguineo: preparaTipoSanguineo,
            configuraMdSelectCategoria: configuraMdSelectCategoria,
            onChangeVizualizarCurriculos: onChangeVizualizarCurriculos
        };

        vm.metodosInternos = {
            verificaUsuarioDetalheCategoria: _verificaUsuarioDetalheCategoria,
            copiaObjeto: _copiaObjeto,
            alterarFlagCategoria: _alterarFlagCategoria,
            verificaHora: verificaHora
        };
        //endregion

        // Implementação dos Métodos region

        /**
         * Watch que fica escutando o objeto 'vm.usuario' e se o novo valor inserido neste objeto for vazio
         * é chamado o método 'tabSelecionada('colaborador')' para voltar para a tab inicial 'colaborador'
         */
        $scope.$watch('vm.usuario', function (newValue, oldValue) {
            if (angular.equals({}, newValue))
                vm.metodosGeral.tabSelecionada('colaborador');
            else {
                vm.metodosGeral.tabSelecionada(vm.tabSelecionada);
            }
        });

        $scope.$watch('vm.controleUsuario.controladorDetalhesUsuario', function (newValue, oldValue) {
            if (vm.controleUsuario.controladorDetalhesUsuario == false) {
                if (vm.usuario && vm.usuario.codigo) {
                    if (vm.usuario.detalhes.usuariosDetalheCategorias.length > 0 &&
                        vm.categoria.length == 0) {
                        vm.categoria = _copiaObjeto(vm.categoriaBkp);
                    }
                }
            }
        });

        // Watch necessário para fazer as requisições quase se utilizar a navegação
        $scope.$watch('vm.categoria', function (newValue, oldValue) {
            if (vm.categoria && vm.categoria.length > 0) {
                var existe = false;
                for (var i = vm.categoria.length - 1; i >= 0; i--) {
                    existe = false;
                    for (var j = vm.usuario.detalhes.usuariosDetalheCategorias.length - 1; j >= 0; j--) {
                        if (vm.usuario.detalhes.usuariosDetalheCategorias[j].categoriaCodigo == vm.categoria[i].codigo) {
                            if (vm.usuario.detalhes.usuariosDetalheCategorias[j].flag) {
                                _alterarFlagCategoria(vm.categoria[i].codigo, "I");
                            }
                            existe = true;
                            break;
                        }
                    }
                    if (!existe) {
                        vm.adicionar = {
                            categoriaCodigo: vm.categoria[i].codigo,
                            usuarioDetalheCodigo: vm.usuario.detalhes.codigo,
                            usuarioCodigo: vm.usuario.codigo,
                            flag: "I"
                        };
                        vm.usuario.detalhes.usuariosDetalheCategorias.push(vm.adicionar);
                    }
                }

                for (var i = vm.usuario.detalhes.usuariosDetalheCategorias.length - 1; i >= 0; i--) {
                    existe = false;
                    for (var j = vm.categoria.length - 1; j >= 0; j--) {
                        if (vm.usuario.detalhes.usuariosDetalheCategorias[i].categoriaCodigo == vm.categoria[j].codigo) {
                            existe = true;
                        }
                    }
                    if (!existe) {
                        vm.usuario.detalhes.usuariosDetalheCategorias[i].flag = "D";
                    }
                }
            }
            else if (oldValue && oldValue.length > 0) {
                if (vm.usuario.nome) {
                    for (var j = vm.usuario.detalhes.usuariosDetalheCategorias.length - 1; j >= 0; j--) {
                        if (vm.usuario.detalhes.usuariosDetalheCategorias[j].categoriaCodigo == oldValue[0].codigo) {
                            if (vm.usuario.detalhes.usuariosDetalheCategorias[j].flag) {
                                vm.usuario.detalhes.usuariosDetalheCategorias[j].flag = "D";
                            }
                        }
                    }
                }
            }
        });

        //Método para limpar a validação customizada quando algumas ações que resetam a toolbar são executadas
        $scope.$watch('vm.form.colaborador.login.$pristine', function (newValue, oldValue) {
            if (newValue) {
                if (vm.form.colaborador.login.$error) {
                    vm.form.colaborador.login.$error = {};
                }
            }
        });
        // Métodos Geral region

        function rotinaSenha(event) {

            $mdDialog.show({
                controller: 'DialogSenhaUsuarioController',
                controllerAs: 'vm',
                templateUrl: vm.htmlRota.tabs.tabUsuario.dialogSenha,
                //parent: ---------------,
                targetEvent: event,
                clickOutsideToClose: false,
                onShowing: function () {
                    senhaAntiga = btoa(vm.usuario.senha);
                },
                onRemoving: function () {
                    if (vm.usuario.possuiSenha) {
                        detectaAlteracaoSenha(vm.usuario.senha)
                    }
                },
                locals: {
                    Usuario: vm.usuario,
                    form: vm.form,
                    PossuiSenha: vm.usuario.possuiSenha
                }
            });
        }

        function detectaAlteracaoSenha(senhaAtual) {
            if (senhaAntiga != btoa(senhaAtual)) {
                vm.metodosExternosPgToolbar.metodoAcaoExternaEditarEntidade(null);
            }
        }


        /**
         * Método que é chamado sempre quando ocorre uma transição de tab
         * @param {tab} tab
         */
        function tabSelecionada(tab) {
            vm.tabSelecionada = tab;
            UsuarioService.verificaTabSelecionada(tab, vm.usuario, vm.controleForm, vm.controladorPreLoader, vm.categoria);
            UsuarioService.controlaButtonsToolbar(tab, vm.controleForm);

            if (vm.usuario && vm.usuario.codigo) {
                vm.usuario.possuiSenha = true;
            }
            else if (vm.usuario) {
                vm.usuario.possuiSenha = false;
            }
        }
        // endregion

        // Métodos Usuario

        /**
         * Método para pesquisar um colaborador
         */
        function pesquisar() {
            vm.categoria = [];
            var teste = RequisicaoGenericaService.listarComObjetoComplexo(Api.usuario.listarComPaginacao, vm.entidadeDeEnvio);
            teste.then(function (success) {
                var sucesso = success.data.lstResultado[0];
                UsuarioService.verificaTabSelecionada('permissoes', sucesso, vm.controleForm, vm.controladorPreLoader, vm.categoria);
            });
            return teste;
        }

        /**
         * Método para salvar um colaborador
         * @param {colaborador} modelo
         */
        function salvar(modelo) {
            var deferred = $q.defer();
            RequisicaoGenericaService.salvar(Api.usuario.criar, modelo).then(
                function (success) {
                    if (LoginUsuarioService.usuarioArmazenado().codigo == success.data.codigo) {
                        LoginUsuarioService.armazenarUsuario(success.data);
                    }

                    vm.categoriaBkp = [];
                    vm.categoria = [];
                    vm.categoriasSelecionadasBkp = [];
                    deferred.resolve(success);
                },
                function (error) {
                    console.log(error);
                    deferred.reject(error);
                });
            return deferred.promise;
        }

        /**
         * Método para editar uma colaborador
         * @param {colaborador} modelo
         */
        function editar(modelo) {
            var deferred = $q.defer();
            RequisicaoGenericaService.editar(Api.usuario.atualizar, modelo).then(
                function (success) {
                    if (LoginUsuarioService.usuarioArmazenado().codigo == success.data.codigo) {
                        LoginUsuarioService.armazenarUsuario(success.data);
                        var codigosSquadsArmazenados = ToolbarService.codigoSquadUsuarioLogado();
                        var codigosSquadsAtualizados = success.data.detalhesUsuario.codigoSquads;

                        if (JSON.stringify(codigosSquadsArmazenados) !== JSON.stringify(codigosSquadsAtualizados)) {
                            ToolbarService.armazenarCodigoSquadUsuarioLogado(success.data.detalhesUsuario.codigoSquads);
                        }
                    }
                    deferred.resolve(success);
                },
                function (error) {
                    deferred.reject(error);
                });
            return deferred.promise;
        }

        /**
         * Método utilizado no modo exibido tabela, para selecionar um cliente
         * @param {colaborador} modelo
         */
        function selecionar(posicaoEntidade) {
            vm.metodosExternosPgToolbar.metodoControladorExternoListarTodasEntidades(null, posicaoEntidade);
        }

        /**
         * Método para construi o DtOptions da tabela
         */
        function construirDtOptions() {
            DatatableFactory.construirDtOptionsComPaginacaoProcessadoNoServidorParaToolbar
                (Api.usuario.listarComPaginacaoDatatable, vm.entidadeDeEnvio.clsEntidade, '#datatable-usuario',
                    [

                        DatatableFactory.construirColunaDeSelecionarPadrao(function (indexLinha) { vm.metodosUsuario.selecionar(indexLinha) }),
                        {
                            targets: 1,
                            name: "Codigo",
                            data: "codigo",
                            defaultContent: ""
                        },
                        {
                            targets: 2,
                            name: "Nome",
                            data: "nome",
                            defaultContent: ""
                        },
                        {
                            targets: 3,
                            name: "CodigoSetor",
                            data: "clsSetor.descricao",
                            defaultContent: ""
                        },
                        {
                            targets: 4,
                            name: "CodigoPerfil",
                            data: "clsPerfil.descricao",
                            defaultContent: ""
                        }
                    ]);
        }


        function onChangeUsuarioLogin(loginUsuario, form, controleForm) {
            if (controleForm.editarAtivo || controleForm.inserirAtivo) {
                var existeUsuario = vm.todosUsuarios.some(function (usuario) {
                    return usuario.login == loginUsuario.$$rawModelValue.toUpperCase()
                        && vm.usuario.codigo != usuario.codigo;
                });

                if (existeUsuario) {
                    form.colaborador.login.$setValidity("usuarioExistente", false);
                } else {
                    form.colaborador.login.$setValidity("usuarioExistente", true);
                }
            }
        }

        function preDefinirParaInsercao() {
            vm.usuario = {
                codigo: '',
                nome: '',
                login: '',
                codigoSetor: '',
                codigoPerfil: '',
                dias: '',
                horaInicio: '',
                horaFim: ''
            }
            vm.usuario.detalhesUsuario = {
                ativo: true
            }
        }
        //endregion

        // Métodos Detalhes Usuario

        /**
         * Método para salvar os detalhes do colaborador
         * @param {detalhesColaborador} modelo
         */
        function salvarDetalhes(modelo) {
            modelo.codigoUsuario = vm.usuario.codigo;
            preparaTipoSanguineo(modelo);
            return RequisicaoGenericaService.salvar(Api.usuario.detalhes_usuario.criar, modelo);
        }

        function configuraAutoCompleteCidadeOnBlur() {
            if (!vm.usuario.detalhes.cidade) {
                vm.textoDePesquisaAutoCompleteCidade = {};
            }
        }

        /**
         * Método para editar os detalhes do colaborador
         * @param {detalhesColaborador} modelo
         */
        function editarDetalhes(modelo, abaDetalhesColaborador) {
            preparaTipoSanguineo(modelo);
            vm.categoriaBkp = _copiaObjeto(vm.categoria);
            vm.categoriasSelecionadasBkp = _copiaObjeto(vm.usuario.detalhes.usuariosDetalheCategorias);
            if (abaDetalhesColaborador) {
                if (
                    vm.usuario.detalhesUsuario.permitirAtualizarExpiracaoLicenca != modelo.permitirAtualizarExpiracaoLicenca ||
                    vm.usuario.detalhesUsuario.editarReajusteItemContratual != modelo.editarReajusteItemContratual) {
                    MdDialogService.alertPadrao("Para aplicar as alterações é necessário que o usuário acesse a aplicação novamente.");
                }
            }
            return RequisicaoGenericaService.editar(Api.usuario.detalhes_usuario.atualizar, modelo);
        }

        /**
         * Método que verifica se o checkbox de Notificar Atendimentos em aberto do setor foi marcado
         * se ele estiver marcado o checkbox de visualizar atendimentos em aberto também será marcado
         * pois para o gerênte poder ser notificado dos atendimentos em aberto dos usuários do setor ele precisa  visualiza-las
         * @param {statusCheckBox} statusCheckboxNotificarAtendimentosEmAbertoSetor
         */
        function alterarEstadoCampoNotificarAtendimentosEmAbertoSetor(statusCheckboxNotificarAtendimentosEmAbertoSetor) {
            if (statusCheckboxNotificarAtendimentosEmAbertoSetor)
                vm.usuario.detalhes.visualizarAtendimentosEmAbertoSetor = true;
        }

        /**
         * Método que verifica se o checkbox de Visualizar atendimentos do setor foi desmarcado
         * se ele estiver desmarcado obrigatóriamente o checkbox de Notificar atendimentos em aberto também será desabilitado
         * pois para o gerênte poder ser notificado dos atendimentos em aberto dos usuários do setor ele precisa  visualiza-las
         * @param {statusCheckBox} statusCheckboxVisualizarAtendimentosEmAbertoSetor
         */
        function alterarEstadoCampoVisualizarAtendimentosEmAbertoSetor(statusCheckboxVisualizarAtendimentosEmAbertoSetor) {
            if (!statusCheckboxVisualizarAtendimentosEmAbertoSetor && vm.usuario.detalhes.notificarAtendimentosEmAbertoSetor)
                vm.usuario.detalhes.notificarAtendimentosEmAbertoSetor = false;
        }

        function alterarItemSelecionadoAutoCompleteCidade(item) {
            if (item) {
                vm.usuario.detalhes.cidadeCodigo = item.codigo;
            } else {
                vm.textoDePesquisaAutoCompleteCidade = {};
                vm.usuario.detalhes.cidadeCodigo = null;
                vm.usuario.detalhes.cidade = null;
            }
        }

        function configuraAutoCompleteBairroOnBlur() {
            if (!vm.usuario.detalhes.bairro) {
                vm.textoDePesquisaAutoCompleteBairro = {};
            }
        }

        function alterarItemSelecionadoAutoCompleteBairro(item) {
            if (item) {
                vm.usuario.detalhes.bairroCodigo = item.codigo;
            } else {
                vm.textoDePesquisaAutoCompleteBairro = {};
                vm.usuario.detalhes.bairroCodigo = null;
                vm.usuario.detalhes.bairro = null;
            }
        }

        function preparaTipoSanguineo(modelo) {
            if (modelo.tipoSanguineo == "Nenhum")
                modelo.tipoSanguineo = "";
        }

        /**
         * Método que irá configurar e limpar o filtro do md-header do md-select de categoria
         */
        function configuraMdSelectCategoria() {
            vm.filtrarCategorias = "";
            angular.element('#usuario-detalhe-form-categoria-md-select').on('keydown', function (ev) {
                ev.stopPropagation();
            });
        }

        function onChangeVizualizarCurriculos() {
            if (vm.usuario && vm.usuario.codigo) {
                if (vm.categoria.length > 0) {
                    if (vm.usuario.detalhes.visualizarCurriculo == true) {
                        vm.usuario.detalhes.usuariosDetalheCategorias = _copiaObjeto(vm.categoriasSelecionadasBkp);
                        vm.categoria = _copiaObjeto(vm.categoriaBkp);
                    }
                    else {
                        vm.categoriasSelecionadasBkp = _copiaObjeto(vm.usuario.detalhes.usuariosDetalheCategorias);
                        for (var j = vm.usuario.detalhes.usuariosDetalheCategorias.length - 1; j >= 0; j--) {
                            _alterarFlagCategoria(vm.usuario.detalhes.usuariosDetalheCategorias[j].categoriaCodigo, "D");
                        }
                        vm.categoriaBkp = _copiaObjeto(vm.categoria);
                        vm.categoria = [];
                    }
                }
                vm.controleUsuario.controladorCategoriasDetalhesUsuario = vm.usuario.detalhes.visualizarCurriculo;
            }
        }

        function pesquisarAutoCompleteBairro(query) {
            var deferred = $q.defer();
            $timeout(function () {
                RequisicaoGenericaService.listarComParams(Api.endereco.bairro.listarPor, query).then(
                    function (success) {
                        deferred.resolve(success.data);
                    },
                    function (error) {
                        deferred.reject(error.data);
                    });
            });
            return deferred.promise;
        }


        function pesquisarAutoCompleteCidade(query) {
            var deferred = $q.defer();
            $timeout(function () {
                RequisicaoGenericaService.listarComParams(Api.endereco.cidade.listarPor, query).then(
                    function (success) {
                        deferred.resolve(success.data);
                    },
                    function (error) {
                        deferred.reject(error.data);
                    });
            });
            return deferred.promise;
        }

        function _verificaUsuarioDetalheCategoria(categoriaCodigo) {
            return vm.usuario.detalhes.usuariosDetalheCategorias.some(function (item) {
                return ((categoriaCodigo) == (item.categoriaCodigo));
            });
        }

        function _copiaObjeto(origem) {
            return [].concat(origem);
        }

        function _alterarFlagCategoria(categoriaCodigo, flag) {
            for (var j = vm.usuario.detalhes.usuariosDetalheCategorias.length - 1; j >= 0; j--) {
                if (vm.usuario.detalhes.usuariosDetalheCategorias[j].categoriaCodigo === categoriaCodigo) {
                    vm.usuario.detalhes.usuariosDetalheCategorias[j].flag = flag;
                }
            }
        }

        function verificaHora() {
            var inicio = new Date("2015-11-26T" + vm.usuario.horaInicio);
            var fim = new Date("2015-11-26T" + vm.usuario.horaFim);
            if (fim < inicio) {
                vm.form.colaborador.horaFim.$setValidity("hora", false);
                // vm.form.colaborador.horaFim.$error = {
                //   "hora": true
                // }
            }
            else {
                vm.form.colaborador.horaFim.$setValidity("hora", true);
                // vm.form.colaborador.horaFim.$error = {
                //   "hora": false
                // }
            }
        }


        // endregion

    }
})();

/**
 * Created by nova on 11/08/2016.
 */
(function () {
    'use strict';

    angular
        .module('app.geral.cadastro.usuario.setor', [])
        .config(config);

    function config($stateProvider, RotasHtml) {
        var rotasHtmlSetor = RotasHtml.setor;
        $stateProvider
            .state('app.geral_cadastro_usuario_setor', {
                url: '/geral/cadastro/usuario/setor',
                module: 'privado',
                views: {
                    'content@app': {
                        templateUrl: rotasHtmlSetor.templateUrl,
                        controller: 'SetorController as vm'
                    },
                    'setor-form@app.geral_cadastro_usuario_setor': {
                        templateUrl: rotasHtmlSetor.form
                    },
                    'setores-tabela@app.geral_cadastro_usuario_setor': {
                        templateUrl: rotasHtmlSetor.tabela
                    }
                },
                resolve: {
                    Usuarios: function (Api, RequisicaoGenericaService) {
                        return RequisicaoGenericaService.listarSemParams(Api.usuario.listarCodigoDescricao);
                    }
                }
            });
    }

})();

/**
 * Created by nova on 11/08/2016.
 */
(function () {
    'use strict';

    angular
        .module('app.geral.cadastro.usuario.setor')
        .controller('SetorController', SetorController);

    function SetorController(Api, RequisicaoGenericaService, NavegacaoService, DatatableFactory, Usuarios) {
        var vm = this;
        NavegacaoService.setTituloAba('Setor');

        //<editor-fold desc="Data">
        // Data region
        vm.setor = {};
        vm.setores = null;

        vm.usuarios = Usuarios.data;
        vm.usuariosSelecionados = [];

        vm.rota = Api.setor.proximoCodigo;
        //endregion
        //</editor-fold>


        //<editor-fold desc="Definição dos Métodos">
        // Definição dos Métodos region
        vm.metodosSetor = {
            pesquisar: pesquisar,
            salvar: salvar,
            editar: editar,
            excluir: excluir,
            selecionar: selecionar,
            construirDtOptions: construirDtOptions
        };
        //endregion
        //</editor-fold>

        //<editor-fold desc="Implementação dos Métodos">
        // Implementação dos Métodos region

        /**
         * Método para pesquisar um setor
         */
        function pesquisar() {
            return RequisicaoGenericaService.listarComObjetoComplexo(Api.setor.listarComPaginacao, vm.entidadeDeEnvio);
        }

        /**
         * Método para salvar um Setor
         * @param {setor} setor 
         */
        function salvar(setor) {
            return RequisicaoGenericaService.salvar(Api.setor.criar, setor);
        }

        /**
         * Método para editar um setor
         * @param {setor} setor 
         */
        function editar(setor) {
            return RequisicaoGenericaService.editar(Api.setor.atualizar, setor)
        }

        /**
         * Método para excluir um setor
         * @param {setor} setor 
         */
        function excluir(setor) {
            return RequisicaoGenericaService.excluir(Api.setor.excluir, setor.codigo)
        }

        /**
         * Método utilizado no modo exibido tabela, para selecionar um setor
         * @param {setor} setor 
         */
        function selecionar(posicaoEntidade) {
            vm.metodosExternosPgToolbar.metodoControladorExternoListarTodasEntidades(null, posicaoEntidade);
        }

        /**
         * Método para construi o DtOptions da tabela
         */
        function construirDtOptions() {
            DatatableFactory.construirDtOptionsComPaginacaoProcessadoNoServidorParaToolbar
                (Api.setor.listarComPaginacaoDatatable, vm.entidadeDeEnvio.clsEntidade, '#datatable-setor',
                [

                    DatatableFactory.construirColunaDeSelecionarPadrao(function (indexLinha) { vm.metodosSetor.selecionar(indexLinha) }),
                    {
                        targets: 1,
                        name: "Codigo",
                        data: "codigo",
                        defaultContent: ""
                    },
                    {
                        targets: 2,
                        name: "Descricao",
                        data: "descricao",
                        defaultContent: ""
                    }
                ]);
        }
        //endregion
        //</editor-fold>
    }

})();

/**
 * Created by nova on 13/09/2016.
 */
(function () {
    'use strict';

    angular
        .module('app.geral.cadastro.solucao.solucao')
        .controller('SolucaoRotinasTarefasController', SolucaoRotinasTarefasController);

    function SolucaoRotinasTarefasController(Api, RequisicaoGenericaService, DataTableConfigPadrao, $mdDialog, MdDialogService, DatatableFactory,
        SistemasOperacionais, ServicosGenericoService, NavegacaoService, TiposTarefas, ListarProdutos, SolucaoRotinasTarefasService, $scope, RotasHtml, ListarUsuarioPorDetalhe, SquadService) {
        var vm = this;
        NavegacaoService.setTituloAba('Solução');

        // Data region
        vm.tabSelecionada = 'solucao';
        vm.solucao = {};
        vm.solucoes = [];
        vm.squadUsuarioLogado = ListarUsuarioPorDetalhe.data.codigoSquads;
        vm.squads = SquadService.listarSquadsUsuarioLogado(vm.squadUsuarioLogado);
        _listarProdutosVinculados(vm.squadUsuarioLogado);
        vm.rotinaSelecionada = null;
        vm.linhaTabelaSelecionada = null;

        vm.htmlRota = RotasHtml.solucao;

        vm.rota = Api.solucao_rotinas_tarefas.solucao.proximoCodigo;
        // endregion

        // Resolve region
        vm.sistemasOperacionais = SistemasOperacionais.data;
        vm.tiposTarefa = TiposTarefas.data;
        vm.produtos = ListarProdutos.data;
        //endregion

        // Configurações Datatable region
        vm.dtOptionsRotinas = angular.copy(DataTableConfigPadrao.dtOptionsPadraoComPaginacaoEReponsivo);
        vm.dtOptionsRotinas.columnDefs = [DataTableConfigPadrao.columnDefsPadrao];

        vm.dtOptionsTarefasRotinas = angular.copy(DataTableConfigPadrao.dtOptionsResponsivoSemPaginacao);
        vm.dtOptionsTarefasRotinas.columnDefs = [DataTableConfigPadrao.columnDefsPadrao];

        vm.dtOptionsTarefas = {
            dom: 'rt<"bottom"<"left"<"info"i>>>',
            paging: false,
            responsive: true,

        };
        vm.dtOptionsTarefas.columnDefs = [DataTableConfigPadrao.columnDefsPadrao];
        //endregion

        // Definição dos Métodos region
        var metodosInternosTarefa = {
            resetarRotinaSelecionada: resetarRotinaSelecionada
        }
        vm.metodosGeral = {
            novaPesquisa: novaPesquisa,
            navegacao: navegacao,
            tabSelecionada: tabSelecionada,
            atualizarNoController: atualizarNoController
        };

        vm.metodosSolucao = {
            pesquisar: pesquisar,
            salvar: salvar,
            editar: editar,
            excluir: excluir,
            selecionar: selecionar,
            construirDtOptions: construirDtOptions,
            selectChangeSquad: selectChangeSquad,
            configuraMdSelectProduto: configuraMdSelectProduto
        };

        vm.metodosRotinas = {
            abrirDialogRotinas: abrirDialogRotinas,
            excluirRotina: excluirRotina
        };

        vm.metodosTarefas = {
            abrirDialogTarefas: abrirDialogTarefas,
            selecionarRotina: selecionarRotina,
            excluirTarefa: excluirTarefa
        };
        //endregion

        // Implementação  dos Métodos region

        // Métodos Geral region

        $scope.$watch('vm.solucao', function (newValue, oldValue) {
            if (angular.equals({}, newValue))
                vm.metodosGeral.tabSelecionada('solucao');
            else {
                vm.metodosGeral.tabSelecionada(vm.tabSelecionada);
            }
        });

        /**
         * Método que será chamado quando for clicado no botão nova pesquisa da toolbar
         */
        function novaPesquisa() {
            vm.tabSelecionada = 'solucao';
            metodosInternosTarefa.resetarRotinaSelecionada();
        }

        /**
         * Método para resetar as rotinas selecionadas quando a algum button da navegação da toolbar for clicado
         */
        function navegacao() {
            metodosInternosTarefa.resetarRotinaSelecionada();

            vm.tabelaLinhaSelecionada = null;
            vm.rotinaSelecionada = null;
        }

        /**
         * Método que é chamado sempre quando ocorrer uma transição entre tabs
         * @param {tab} tab 
         */
        function tabSelecionada(tab) {
            vm.tabSelecionada = tab;
            SolucaoRotinasTarefasService.verificaTabSelecionada(tab, vm.solucao, vm.solucao.codigo, vm.controleForm, vm.controlePreloader);

            if (angular.isDefined(vm.controleForm)) {
                SolucaoRotinasTarefasService.controlaButtonsToolbar(vm.controleForm, tab);
                vm.controleForm.pesquisarDatatable = SolucaoRotinasTarefasService.verificaTabParaHabilitarPesquisarHeaderPadrao(tab);
            }
        }

        /**
         * Método que recarrega a entidade da aba ativa quando for clicado no botão atualizar da  toolbar
         */
        function atualizarNoController() {
            vm.metodosGeral.tabSelecionada(vm.tabSelecionada);
        }
        // endregion

        // Métodos Solução region

        /**
         * Método que ira buscar uma lista de Soluções
         */
        function pesquisar() {
            if (vm.squadUsuarioLogado === 1) vm.entidadeDeEnvio.clsEntidade.codigoSquads = vm.squadUsuarioLogado[0];
            if (!vm.entidadeDeEnvio.clsEntidade.codigoSquads) {
                vm.entidadeDeEnvio.clsEntidade.codigoSquads = vm.squadUsuarioLogado;
            }
            return RequisicaoGenericaService.listarComObjetoComplexo(Api.solucao_rotinas_tarefas.solucao.listarComPaginacao, vm.entidadeDeEnvio);
        }

        /**
         * 
         * @param {solucao} solucao 
         */
        function salvar(solucao) {
            if (vm.squadUsuarioLogado.length === 1) {
                solucao.codigoSquads = [];
            }
            if (!solucao.codigoSquads) {
                solucao.codigoSquads = solucao.codigoSquads ? solucao.codigoSquads : [];
            }
            return RequisicaoGenericaService.salvar(Api.solucao_rotinas_tarefas.solucao.criar, solucao);
        }

        /**
         * 
         * @param {solucao} solucao 
         */
        function editar(solucao) {
            if (vm.squadUsuarioLogado.length === 1) {
                solucao.codigoSquads = [];
            }
            if (!solucao.codigoSquads) {
                solucao.codigoSquads = solucao.codigoSquads ? solucao.codigoSquads : [];
            }
            return RequisicaoGenericaService.editar(Api.solucao_rotinas_tarefas.solucao.atualizar, solucao);
        }

        /**
         * 
         * @param {solucao} solucao 
         */
        function excluir(solucao) {
            return RequisicaoGenericaService.excluir(Api.solucao_rotinas_tarefas.solucao.excluir, solucao.codigo);
        }

        /**
         * Método utilizado no modo exibido tabela, para selecionar uma solução
         * @param {solucao} solucao 
         */
        function selecionar(posicaoEntidade) {
            vm.metodosExternosPgToolbar.metodoControladorExternoListarTodasEntidades(null, posicaoEntidade);
        }

        /**
         * Método para construi o DtOptions da tabela
         */
        function construirDtOptions() {
            DatatableFactory.construirDtOptionsComPaginacaoProcessadoNoServidorParaToolbar
                (Api.solucao_rotinas_tarefas.solucao.listarComPaginacaoDatatable, vm.entidadeDeEnvio.clsEntidade, '#datatable-solucao',
                    [

                        DatatableFactory.construirColunaDeSelecionarPadrao(function (indexLinha) { vm.metodosSolucao.selecionar(indexLinha) }),
                        {
                            targets: 1,
                            name: "Codigo",
                            data: "codigo",
                            defaultContent: ""
                        },
                        {
                            targets: 2,
                            name: "Descricao",
                            data: "descricao",
                            defaultContent: ""
                        },
                        {
                            targets: 3,
                            name: "CodigoProduto",
                            data: "produto.descricao",
                            defaultContent: ""
                        },
                        {
                            targets: 4,
                            name: "SistemaOperacionalCodigo",
                            data: "sistemaOperacional.descricao",
                            defaultContent: ""
                        }
                    ]);
        }
        // endregion

        // Métodos Rotinas region

        /**
         * 
         * @param {eventButton} event 
         * @param {rotina} rotina rotina selecionada na tabela
         */
        function abrirDialogRotinas(event, rotina) {
            $mdDialog.show({
                controller: 'DialogRotinasController',
                controllerAs: 'vm',
                templateUrl: vm.htmlRota.tabRotina.dialog,
                targetEvent: event,
                clickOutsideToClose: false,
                locals: {
                    ControleForm: vm.controleForm,
                    Solucao: vm.solucao,
                    Rotina: rotina,
                }
            });
        }

        /**
         * Método que irá excluir a rotina selecionada na tabela
         * @param {rotina} rotina rotina selecionada na tabela
         * @param {eventButton} event 
         */
        function excluirRotina(rotina, event) {
            ServicosGenericoService
                .excluirRegistroPorCodigoOuGenericamente(Api.solucao_rotinas_tarefas.rotinas.excluir, vm.solucao.rotinas, rotina, vm.controleForm, event, 'Deseja realmente excluir esta Rotina ?');
        }
        // endregion

        // Métodos Tarefas region

        // Método Internos das Tarefas

        /**
         * Método que irá resetar as rotinas selecioandas
         */
        function resetarRotinaSelecionada() {
            vm.tabelaLinhaSelecionada = null;
            vm.rotinaSelecionada = null;
        }


        /**
         * 
         * @param {eventButton} event 
         * @param {tarefa} tarefa tarefa selecionada na tabela
         */
        function abrirDialogTarefas(event, tarefa) {
            $mdDialog.show({
                controller: 'DialogTarefasController',
                controllerAs: 'vm',
                templateUrl: vm.htmlRota.tabTarefa.dialog,
                targetEvent: event,
                clickOutsideToClose: false,
                locals: {
                    ControleForm: vm.controleForm,
                    Rotina: vm.rotinaSelecionada,
                    Tarefa: tarefa,
                    TiposTarefa: vm.tiposTarefa,
                }
            });
        }

        /**
         * Método que irá selecionar a rotina com suas tarefas e colorir a linha desta rotina na tabela
         * @param {rotina} rotina rotina selecionada na tabela
         * @param {index} linha index da rotina selecionada na tabela
         */
        function selecionarRotina(rotina, linha) {
            vm.tabelaLinhaSelecionada = linha;
            vm.rotinaSelecionada = rotina;
        }

        /**
         * Método que irá excluir a tarefa selecionada na tabela
         * @param {tarefa} tarefa tarefa selecionada na tabela
         * @param {eventButton} event 
         */
        function excluirTarefa(tarefa, event) {
            ServicosGenericoService
                .excluirRegistroPorCodigoOuGenericamente(Api.solucao_rotinas_tarefas.tarefas.excluir, vm.rotinaSelecionada.tarefas, tarefa, vm.controleForm, event, 'Deseja realmente excluir esta Tarefa ?');
        }
        //endregion

        function configuraMdSelectProduto() {
            vm.filtrarProdutos = '';
            angular
                .element('#produto-md-select')
                .on('keydown', function (ev) {
                    ev.stopPropagation();
                });
        }

        function selectChangeSquad(codigoSquadSelecionada) {
            vm.solucao.codigoProduto = null;
            _listarProdutosVinculados(codigoSquadSelecionada);
        }

        function _listarProdutosVinculados(codigoSquad) {
            var url = Api.produto.listarProdutoPorSquad;

            var squads = codigoSquad.length ? codigoSquad : vm.squadUsuarioLogado;

            var entidadeEnvio = {
                codigoSquads: squads.length > 0 ? squads : [vm.solucao.squadCodigo],
            }

            return RequisicaoGenericaService.listarPorPaginacaoJsonFormato(url, entidadeEnvio)
                .then(function (success) {
                    vm.produtos = success.data;
                })
                .catch(function (error) {
                    vm.produtos = [];
                })
        }

    }

})();

//<!-- Ultima mudança 28/03/2017.-->
(function() {
    'use strict';

    angular
        .module('app.geral.cadastro.cliente.pessoa', [])
        .config(config);

    function config($stateProvider, RotasHtml) {
        var rotasHtml = RotasHtml;

        $stateProvider
            .state('app.geral_cadastro_cliente_pessoa', {
                url: '/geral/cadastro/cliente/pessoa',
                module: 'privado',
                params: {
                    parametros: null
                },
                views: {
                    'content@app': {
                        templateUrl: rotasHtml.pessoa.templateUrl,
                        controller: 'PessoaController as vm'
                    },
                    'pessoa-form@app.geral_cadastro_cliente_pessoa': {
                        templateUrl: rotasHtml.pessoa.form
                    },
                    'pessoas-tabela@app.geral_cadastro_cliente_pessoa': {
                        templateUrl: rotasHtml.pessoa.tabela
                    }
                },
                resolve: {
                    ListarCargos: function(Api, RequisicaoGenericaService) {
                        return RequisicaoGenericaService.listarSemParams(Api.cargo.listarPor);
                    },
                    AbertoPeloDialog: function() {
                        return null;
                    },
                    DesabilitaExcluir: function() {
                        return false;
                    }
                }
            });
    }

})();
//<!-- Ultima mudança 28/03/2017.-->
(function () {
    'use strict';

    angular.module('app.geral.cadastro.cliente.pessoa')
        .controller('PessoaController', PessoaController);

    function PessoaController($mdDialog,
        $q,
        $scope,
        NavegacaoService,
        $timeout,
        Api,
        RotasHtml,
        RequisicaoGenericaService,
        DatatableFactory,
        PgToolbarFactory,
        ListarCargos,
        AbertoPeloDialog,
        DesabilitaExcluir
    ) {
        var vm = this;
        vm.desabilitaExcluir = DesabilitaExcluir
        NavegacaoService.setTituloAba('Cliente pessoa');

        // Data region    
        vm.form = {};

        var cidadeCodigo = null;
        vm.cargos = ListarCargos.data;

        _init();
        // endregion

        $scope.$watch('vm.pessoa', function () {
            if (!vm.pessoa.celular && !vm.pessoa.numeroWhatsapp) {
                vm.pessoa.numeroEhWhatsapp = false;
            }

            if (!vm.pessoa.celular)
                vm.pessoa.numeroEhWhatsapp = false;

            if (vm.pessoa.emailAlternativo && vm.pessoa.emailPrincipal)
                vm.form.pessoa.emailAlternativo.$setValidity("igual",
                    vm.pessoa.emailPrincipal.length > 0 &&
                    vm.pessoa.emailAlternativo.length > 0 &&
                    vm.pessoa.emailPrincipal != vm.pessoa.emailAlternativo)
            else
                vm.form.pessoa.emailAlternativo.$setValidity("igual", null);
        }, true)

        // Definição dos Métodos region
        var metodosInternos = {
            _init: _init
        };
        vm.metodos = {
            pesquisar: pesquisar,
            preDefinirCamposParaInsercao: preDefinirCamposParaInsercao,
            salvar: salvar,
            editar: editar,
            excluir: excluir,
            selecionar: selecionar,
            construirDtOptions: construirDtOptions,
            pesquisarAutoCompleteCidade: pesquisarAutoCompleteCidade,
            alterarItemSelecionadoAutoCompleteCidade: alterarItemSelecionadoAutoCompleteCidade,
            configuraAutoCompleteCidadeOnBlur: configuraAutoCompleteCidadeOnBlur,
            pesquisarAutoCompleteBairro: pesquisarAutoCompleteBairro,
            alterarItemSelecionadoAutoCompleteBairro: alterarItemSelecionadoAutoCompleteBairro,
            configuraAutoCompleteBairroOnBlur: configuraAutoCompleteBairroOnBlur,
            configuraMdSelectCargo: configuraMdSelectCargo,
            habilitarDesabilitarUtilizaIntegracaoRdStation: habilitarDesabilitarUtilizaIntegracaoRdStation
        };

        vm.metodosDialog = {
            fecharDialog: fecharDialog
        };
        //endregion

        //#region Métodos Internos

        function _init() {
            vm.requisicaoPesquisaBairrosSolicitada = false;
            vm.rotasHtml = RotasHtml;
            vm.rota = Api.pessoa.proximoCodigo;
            _inicializarCamposPessoa();
            if (AbertoPeloDialog) {
                if (AbertoPeloDialog.iniciarChamandoPesquisa) {
                    vm.iniciarChamandoPesquisa = true;
                    vm.pessoa = { codigo: AbertoPeloDialog.codigoPessoa };
                } else if (AbertoPeloDialog.iniciarChamandoInsercao) {
                    vm.iniciarChamandoInsercao = true;
                }
            }
        }

        function _inicializarCamposPessoa() {
            vm.pessoa = null;
            vm.pessoa = {
                numeroEhWhatsapp: false,
                permiteMensagensMarketing: true,
                emailAlternativo: '',
                emailPrincipal: ''
            }
        }

        //#endregion

        //region Métodos

        function pesquisar() {
            if (!vm.entidadeDeEnvio)
                vm.entidadeDeEnvio = PgToolbarFactory.construirEntidadeDeEnvioPadrao(vm.pessoa);

            return RequisicaoGenericaService.listarComObjetoComplexo(Api.pessoa.listarComPaginacao, vm.entidadeDeEnvio);
        }

        function preDefinirCamposParaInsercao() {
            _inicializarCamposPessoa();
        }

        function salvar(modelo) {
            return RequisicaoGenericaService.salvar(Api.pessoa.criar, modelo);
        }

        function editar(modelo) {
            return RequisicaoGenericaService.editar(Api.pessoa.atualizar, modelo)
        }

        function excluir(modelo) {
            return RequisicaoGenericaService.excluir(Api.pessoa.excluir, modelo.codigo)
        }

        function selecionar(posicaoEntidade) {
            vm.metodosExternosPgToolbar.metodoControladorExternoListarTodasEntidades(null, posicaoEntidade);
        }

        function construirDtOptions() {
            DatatableFactory.construirDtOptionsComPaginacaoProcessadoNoServidorParaToolbar(Api.pessoa.listarComPaginacaoDatatable, vm.entidadeDeEnvio.clsEntidade, '#datatable-pessoa', [

                DatatableFactory.construirColunaDeSelecionarPadrao(function (indexLinha) { vm.metodos.selecionar(indexLinha) }),
                {
                    targets: 1,
                    name: "Codigo",
                    data: "codigo",
                    defaultContent: "",
                    sortable: false
                },
                {
                    targets: 2,
                    name: "Nome",
                    data: "nome",
                    defaultContent: "",
                    sortable: false
                },
                {
                    targets: 3,
                    name: "CargoCodigo",
                    data: "cargo.descricao",
                    defaultContent: "",
                    sortable: false
                },
                {
                    targets: 4,
                    name: "CidadeCodigo",
                    data: "cidade.descricao",
                    defaultContent: "",
                    sortable: false
                },
                {
                    targets: 5,
                    name: "Telefone",
                    data: "telefone",
                    defaultContent: "",
                    sortable: false
                },
                {
                    targets: 6,
                    name: "Celular",
                    data: "celular",
                    defaultContent: "",
                    sortable: false
                },
                {
                    targets: 7,
                    name: "Skype",
                    data: "skype",
                    defaultContent: "",
                    sortable: false
                }
            ]);
        }
        function habilitarDesabilitarUtilizaIntegracaoRdStation(ativoInativo) {
            if (ativoInativo) {
                vm.pessoa.utilizarIntegracaoRDStation = false;
            }
        }

        function pesquisarAutoCompleteCidade(query) {
            var deferred = $q.defer();
            $timeout(function () {
                RequisicaoGenericaService.listarComParams(Api.endereco.cidade.listarPor, query).then(
                    function (success) {
                        deferred.resolve(success.data);
                    },
                    function (error) {
                        deferred.reject(error.data);
                    });
            });
            return deferred.promise;
        }

        function alterarItemSelecionadoAutoCompleteCidade(item) {
            if (item) {
                vm.pessoa.cidadeCodigo = item.codigo;
            } else {
                vm.textoDePesquisaAutoCompleteCidade = {};
                vm.pessoa.cidadeCodigo = null;
                vm.pessoa.cidade = null;
            }
        }

        function configuraAutoCompleteCidadeOnBlur() {
            if (!vm.pessoa.cidade) {
                vm.textoDePesquisaAutoCompleteCidade = {};
            }
        }

        function pesquisarAutoCompleteBairro(query) {
            var deferred = $q.defer();
            $timeout(function () {
                RequisicaoGenericaService.listarComParams(Api.endereco.bairro.listarPor, query).then(
                    function (success) {
                        deferred.resolve(success.data);
                    },
                    function (error) {
                        deferred.reject(error.data);
                    });
            });
            return deferred.promise;
        }

        function alterarItemSelecionadoAutoCompleteBairro(item) {
            if (item) {
                vm.pessoa.bairroCodigo = item.codigo;
            } else {
                vm.textoDePesquisaAutoCompleteBairro = {};
                vm.pessoa.bairroCodigo = null;
                vm.pessoa.bairro = null;
            }
        }

        function configuraAutoCompleteBairroOnBlur() {
            if (!vm.pessoa.bairro) {
                vm.textoDePesquisaAutoCompleteBairro = {};
            }
        }

        function configuraMdSelectCargo() {
            vm.filtrarCargos = "";
            angular.element('#pessoa-form-cargo-md-select').on('keydown', function (ev) {
                ev.stopPropagation();
            });
        }
        //endregion   

        //#region Métodos Dialog

        function fecharDialog() {
            $mdDialog.hide(vm.pessoa);
        }

        //#endregion

    } // Controller
})();
/**
 * Created by nova on 18/08/2016.
 */
(function(){
  'use strict';

  angular
    .module('app.geral.cadastro.usuario.perfil', [])
    .config(config);

    function config($stateProvider, RotasHtml){
        var rotasHtmlPerfil = RotasHtml.perfil;
    $stateProvider
        .state('app.geral_cadastro_usuario_perfil', {
        url: '/geral/cadastro/usuario/perfil',
        module: 'privado',
        views: {
          'content@app':{
              templateUrl: rotasHtmlPerfil.templateUrl,
            controller: 'PerfilController as vm'
          },
          'perfil-form@app.geral_cadastro_usuario_perfil':{
              templateUrl: rotasHtmlPerfil.form
          },
          'perfis-tabela@app.geral_cadastro_usuario_perfil':{
              templateUrl: rotasHtmlPerfil.tabela
          }
        }
      });
  }

})();

/**
 * Created by nova on 18/08/2016.
 */
(function () {
    'use strict';

    angular
        .module('app.geral.cadastro.usuario.perfil')
        .controller('PerfilController', PerfilController);

    function PerfilController(Api, RequisicaoGenericaService, NavegacaoService, DatatableFactory) {
        var vm = this;
        NavegacaoService.setTituloAba('Perfil');

        // <editor-fold desc="Data">
        // Data region
        vm.perfil = {};
        vm.perfis = null;

        vm.rota = Api.perfil.proximoCodigo;
        // endregion
        // </editor-fold>        

        // <editor-fold desc="Definição dos Métodos">
        // Definição dos Métodos region
        vm.metodosPerfil = {
            pesquisar: pesquisar,
            salvar: salvar,
            editar: editar,
            excluir: excluir,
            selecionar: selecionar,
            construirDtOptions: construirDtOptions
        };
        //endregion
        // </editor-fold>

        // <editor-fold desc="Implementação dos Métodos">
        // Implementação dos Métodos region

        /**
         * Método para pesquisar um perfil
         */
        function pesquisar() {
            return RequisicaoGenericaService.listarComObjetoComplexo(Api.perfil.listarComPaginacao, vm.entidadeDeEnvio);
        }

        /**
         * Método para salvar um perfil
         * @param {perfil} perfil 
         */
        function salvar(perfil) {
            return RequisicaoGenericaService.salvar(Api.perfil.criar, perfil);
        }

        /**
         * Método para editar um perfil
         * @param {perfil} perfil 
         */
        function editar(perfil) {
            return RequisicaoGenericaService.editar(Api.perfil.atualizar, perfil);
        }

        /**
         * Método para excluir um perfil
         * @param {perfil} perfil 
         */
        function excluir(perfil) {
            return RequisicaoGenericaService.excluir(Api.perfil.excluir, perfil.codigo);
        }

        /**
         * Método utilizado no modo exibido tabela, para selecionar um cliente
         * @param {perfil} perfil 
         */
        function selecionar(posicaoEntidade) {
            vm.metodosExternosPgToolbar.metodoControladorExternoListarTodasEntidades(null, posicaoEntidade);
        }

        /**
         * Método para construi o DtOptions da tabela
         */
        function construirDtOptions() {
            DatatableFactory.construirDtOptionsComPaginacaoProcessadoNoServidorParaToolbar
                (Api.perfil.listarComPaginacaoDatatable, vm.entidadeDeEnvio.clsEntidade, '#datatable-perfil',
                [

                    DatatableFactory.construirColunaDeSelecionarPadrao(function (indexLinha) { vm.metodosPerfil.selecionar(indexLinha) }),
                    {
                        targets: 1,
                        name: "Codigo",
                        data: "codigo",
                        defaultContent: ""
                    },
                    {
                        targets: 2,
                        name: "Descricao",
                        data: "descricao",
                        defaultContent: ""
                    }
                ]);
        }
        //endregion
        //</editor-fold>
    }
})();

/**
 * Created by nova on 28/07/2017.
 */
(function () {
    'use strict';

    angular
        .module('app.geral.cadastro.solucao.produto', [])
        .config(Config);

    function Config($stateProvider, RotasHtml) {
        var rotasHtmlRegistroSituacao = RotasHtml.produto;
        $stateProvider
            .state('app.geral_cadastro_solucao_produto', {
                url: '/geral/cadastro/solucao/produto',
                module: 'privado',
                params: {
                    parametros: null
                },
                views: {
                    'content@app': {
                        templateUrl: rotasHtmlRegistroSituacao.templateUrl,
                        controller: "ProdutoController as vm"
                    },
                    'produto-form@app.geral_cadastro_solucao_produto': {
                        templateUrl: rotasHtmlRegistroSituacao.form
                    },
                    'produtos-tabela@app.geral_cadastro_solucao_produto': {
                        templateUrl: rotasHtmlRegistroSituacao.tabela
                    }

                },
                resolve: {
                    ListarTodosFunis: function (Api, RequisicaoGenericaService) {
                        return RequisicaoGenericaService.listarSemParams(Api.pipeline.pipeline_funil.listarTodos);
                    },
                    ListarFinisAtivos: function (Api, RequisicaoGenericaService) {
                        return RequisicaoGenericaService.listarSemParams(Api.pipeline.pipeline_funil.listarAtivos);
                    },
                    AbertoPeloDialog: function () {
                        return null;
                    },
                    ListarUsuarioPorDetalhe: function (Api, RequisicaoGenericaService, LoginUsuarioService) {
                        return RequisicaoGenericaService.listarSemParams(Api.usuario.detalhes_usuario.listarDetalhesUsuario
                            + LoginUsuarioService.usuarioArmazenado().codigo);
                    },
                }
            });
    }

})();

/**
 * Created by nova on 26/10/2016.
 */
(function () {
    'use strict';

    angular
        .module('app.geral.cadastro.solucao.produto')
        .controller('ProdutoController', ProdutoController);

    function ProdutoController($stateParams, NavegacaoService, Api, RequisicaoGenericaService, DatatableFactory, ListarFinisAtivos, ListarTodosFunis, ListarSquads, SquadService, ListarUsuarioPorDetalhe,
        PgToolbarFactory) {
        var vm = this;
        NavegacaoService.setTituloAba('Produto');

        // Data region   

        vm.form = {};
        vm.funis = ListarTodosFunis.data;
        vm.produto = {};
        vm.produtos = [];
        vm.iniciarChamandoPesquisa = false;
        vm.squads = ListarSquads;

        _init();
        // endregion 


        // Definição dos Métodos region
        vm.metodosGeral = {
            _init: _init,
            preDefinirCamposParaInserir: preDefinirCamposParaInserir,
            preDefinirCamposParaEdicao: preDefinirCamposParaEdicao,
            acaoReverter: acaoReverter
        };
        vm.metodos = {
            pesquisar: pesquisar,
            salvar: salvar,
            editar: editar,
            excluir: excluir,
            selecionar: selecionar,
            filtrarFunis: filtrarFunis,
            configuraMdSelectProduto: configuraMdSelectProduto,
            construirDtOptions: construirDtOptions,
            onChangeComercializavel: onChangeComercializavel,
            onChangeSubitemContratual: onChangeSubitemContratual
        }
        vm.permiteSubitensHabilitado = true;

        function onChangeComercializavel() {
            if (vm.produto.comercializavel) {
                vm.produto.subitemContratual = false;
                vm.permiteSubitensHabilitado = true;
            }
        }

        function onChangeSubitemContratual() {
            if (vm.produto.subitemContratual) {
                vm.produto.comercializavel = false;
                vm.produto.permiteSubitens = false;
                vm.permiteSubitensHabilitado = false;
            } else {
                vm.permiteSubitensHabilitado = true;
            }
        }
        //endregion

        //#region Implementação dos Métodos

        function _init() {
            if ($stateParams.parametros) {
                vm.iniciarChamandoPesquisa = $stateParams.parametros.iniciarChamandoPesquisa;
                vm.produto = { codigo: $stateParams.parametros.codigoProduto };
            }
            vm.squadUsuarioLogado = ListarUsuarioPorDetalhe.data.codigoSquads;
            vm.squads = SquadService.listarSquadsUsuarioLogado(vm.squadUsuarioLogado);
        }

        function preDefinirCamposParaInserir() {
            vm.funis = ListarFinisAtivos.data;
            vm.produto = {
                ativo: true,
                comercializavel: false
            }
        }

        function preDefinirCamposParaEdicao() {
            vm.funis = ListarTodosFunis.data;
        }

        function acaoReverter() {
            if (vm.controleForm.pesquisaAtiva) {
                vm.funis = ListarTodosFunis.data;
            }
        }

        //#endregion 

        // Implementação dos Métodos region


        function filtrarFunis(item) {
            if (!vm.filtrarFunis || (item.descricao.toLowerCase().search(vm.filtrarFunis.toLowerCase()) != -1)) {
                return true;
            }
            else {
                return false;
            }
        }

        function configuraMdSelectProduto(modelo) {
            vm.filtrarFunis = "";
            angular.element('#produtos-funil-md-select').on('keydown', function (ev) {
                ev.stopPropagation();
            });
        }

        /**
         * Método para pesquisar os fornecedores
         */
        function pesquisar() {
            if (!vm.entidadeDeEnvio)
                vm.entidadeDeEnvio = PgToolbarFactory.construirEntidadeDeEnvioPadrao(vm.produto);

            vm.funis = ListarTodosFunis.data;

            if (vm.squadUsuarioLogado === 1) vm.entidadeDeEnvio.clsEntidade.codigoSquads = vm.squadUsuarioLogado[0];
            if (!vm.entidadeDeEnvio.clsEntidade.codigoSquads) {
                vm.entidadeDeEnvio.clsEntidade.codigoSquads = vm.squadUsuarioLogado;
            }
            return RequisicaoGenericaService.listarComObjetoComplexo(Api.produto.listarComPaginacao, vm.entidadeDeEnvio);
        }

        /**
         * Método para salvar um novo produto
         * @param {object} modelo produto
         */
        function salvar(modelo) {
            if (vm.squadUsuarioLogado.length === 1 && modelo.softwareProprio) modelo.codigoSquads = vm.squadUsuarioLogado;
            if (vm.squadUsuarioLogado.length === 1 && !modelo.softwareProprio) modelo.codigoSquads = [];
            if (!modelo.softwareProprio) modelo.codigoSquads = modelo.codigoSquads ? modelo.codigoSquads : [];

            return RequisicaoGenericaService.salvar(Api.produto.criar, modelo);
        }

        /**
         * Método para editar um produto
         * @param {object} modelo produto
         */
        function editar(modelo) {
            if (vm.squadUsuarioLogado.length === 1 && modelo.softwareProprio) modelo.codigoSquads = vm.squadUsuarioLogado;
            if (vm.squadUsuarioLogado.length === 1 && !modelo.softwareProprio) modelo.codigoSquads = [];
            if (!modelo.softwareProprio) modelo.codigoSquads = modelo.codigoSquads ? modelo.codigoSquads : [];
            return RequisicaoGenericaService.editar(Api.produto.atualizar, modelo)
        }

        /**
         * Método para excluir um produto
         * @param {object} modelo produto
         */
        function excluir(modelo) {
            return RequisicaoGenericaService.excluir(Api.produto.excluir, modelo.codigo)
        }

        /**
         * Método utilizado no modo exibido tabela, para selecionar um produto
         * @param {object} modelo
         */
        function selecionar(posicaoEntidade) {
            vm.metodosExternosPgToolbar.metodoControladorExternoListarTodasEntidades(null, posicaoEntidade);
        }

        /**
         * Método para construi o DtOptions da tabela
         */
        function construirDtOptions() {
            DatatableFactory.construirDtOptionsComPaginacaoProcessadoNoServidorParaToolbar
                (Api.produto.listarComPaginacaoDatatable, vm.entidadeDeEnvio.clsEntidade, '#datatable-produto',
                    [

                        DatatableFactory.construirColunaDeSelecionarPadrao(function (indexLinha) { vm.metodos.selecionar(indexLinha) }),
                        {
                            targets: 1,
                            name: "Codigo",
                            data: "codigo",
                            defaultContent: ""
                        },
                        {
                            targets: 2,
                            name: "Descricao",
                            data: "descricao",
                            defaultContent: ""
                        },
                        {
                            targets: 3,
                            name: "CodigoPipelineFunil",
                            data: "pipelineFunil",
                            render: function (data) {
                                if (data && data.descricao)
                                    return data.descricao;
                            },
                            defaultContent: ""
                        },
                        {
                            targets: 4,
                            name: "CodigoProtecao",
                            data: "codigoProtecao",
                            defaultContent: ""
                        },
                        {
                            targets: 5,
                            name: "Ativo",
                            data: "ativo",
                            render: function (data) {
                                if (data)
                                    return "Ativo";
                                else
                                    return "Inativo";
                            },
                            defaultContent: ""
                        },
                        {
                            targets: 6,
                            name: "Comercializavel",
                            data: "comercializavel",
                            render: function (data) {
                                if (data)
                                    return "Sim";
                                else
                                    return "Não";
                            },
                            defaultContent: ""
                        },
                        {
                            targets: 7,
                            name: "SubitemContratual",
                            data: "subitemContratual",
                            render: function (data) {
                                if (data)
                                    return "Sim";
                                else
                                    return "Não";
                            },
                            defaultContent: ""
                        },
                        {
                            targets: 8,
                            name: "PermiteSubitens",
                            data: "permiteSubitens",
                            render: function (data) {
                                if (data)
                                    return "Sim";
                                else
                                    return "Não";
                            },
                            defaultContent: ""
                        },
                        {
                            targets: 9,
                            name: "SoftwareProprio",
                            data: "softwareProprio",
                            render: function (data) {
                                if (data)
                                    return "Sim";
                                else
                                    return "Não";
                            },
                            defaultContent: ""
                        }

                    ]);
        }
        //endregion

    }

})();

//<!-- Ultima mudança 28/03/2017.-->
(function () {
    'use strict';

    angular
        .module('app.geral.cadastro.cliente.pendencia', [])
        .config(config);

    function config($stateProvider, RotasHtml) {
        var rotasHtml = RotasHtml.pendencia_cliente;
        $stateProvider
            .state('app.geral_cadastro_cliente_pendencia', {
                url: '/geral/cadastro/cliente/pendencia',
                module: 'privado',
                views: {
                    'content@app': {
                        templateUrl: rotasHtml.templateUrl,
                        controller: 'PendenciaClienteController as vm'
                    },
                    'pendencia-cliente-form@app.geral_cadastro_cliente_pendencia': {
                        templateUrl: rotasHtml.form
                    },
                    'pendencias-cliente-tabela@app.geral_cadastro_cliente_pendencia': {
                        templateUrl: rotasHtml.tabela
                    }
                }
            });
    }

})();

//<!-- Ultima mudança 28/03/2017.-->
(function () {
    'use strict';

    angular.module('app.geral.cadastro.cliente.pendencia')
        .controller('PendenciaClienteController', PendenciaClienteController);

    function PendenciaClienteController(Api, NavegacaoService, RequisicaoGenericaService, DatatableFactory) {
        var vm = this;
        NavegacaoService.setTituloAba('Cliente pendências');

        // Data region    
        vm.form = {};
        // endregion


        // Definição dos Métodos region
        vm.metodos = {
            pesquisar: pesquisar,
            salvar: salvar,
            editar: editar,
            excluir: excluir,
            selecionar: selecionar,
            construirDtOptions: construirDtOptions
        }
        //endregion

        // Implementação dos Métodos region

        /**
         * Método para pesquisar uma pendência de cliente
         */
        function pesquisar() {
            return RequisicaoGenericaService.listarComObjetoComplexo(Api.cliente_pendencia.listarComPaginacao, vm.entidadeDeEnvio);
        }

        /**
         * Método para salvar uma pendência de cliente
         * @param {clientePendencia} modelo 
         */
        function salvar(modelo) {
            return RequisicaoGenericaService.salvar(Api.cliente_pendencia.criar, modelo);
        }

        /**
         * Método para editar uma pendência de cliente
         * @param {clientePendencia} modelo 
         */
        function editar(modelo) {
            return RequisicaoGenericaService.editar(Api.cliente_pendencia.atualizar, modelo)
        }

        /**
         * Método para excluir uma pendência de cliente
         * @param {clientePendencia} modelo 
         */
        function excluir(modelo) {
            return RequisicaoGenericaService.excluir(Api.cliente_pendencia.excluir, modelo.codigo)
        }

        /**
         * Método utilizado no modo exibido tabela, para selecionar um motivo de atendimento
         * @param {clientePendencia} modelo
         */
        function selecionar(posicaoEntidade) {
            vm.metodosExternosPgToolbar.metodoControladorExternoListarTodasEntidades(null, posicaoEntidade);
        }

        /**
         * Método para construi o DtOptions da tabela
         */
        function construirDtOptions() {
            DatatableFactory.construirDtOptionsComPaginacaoProcessadoNoServidorParaToolbar
                (Api.cliente_pendencia.listarComPaginacaoDatatable, vm.entidadeDeEnvio.clsEntidade, '#datatable-pendencia-cliente',
                    [

                        DatatableFactory.construirColunaDeSelecionarPadrao(function (indexLinha) { vm.metodos.selecionar(indexLinha) }),
                        {
                            targets: 1,
                            name: "Descricao",
                            data: "descricao",
                            sortable: false
                        }
                    ]);
        }
        //endregion

    }
})();

//<!-- Ultima mudança 28/03/2017.-->
(function () {
    'use strict';

    angular
        .module('app.geral.cadastro.cliente.cargo', [])
        .config(config);

    function config($stateProvider, RotasHtml) {
        var rotasHtmlCargo = RotasHtml.cargo_cliente;
        $stateProvider
            .state('app.geral_cadastro_cliente_cargo', {
                url: '/geral/cadastro/cliente/cargo',
                module: 'privado',
                views: {
                    'content@app': {
                        templateUrl: rotasHtmlCargo.templateUrl,
                        controller: 'CargoClienteController as vm'
                    },
                    'cargo-cliente-form@app.geral_cadastro_cliente_cargo': {
                        templateUrl: rotasHtmlCargo.form
                    },
                    'cargos-cliente-tabela@app.geral_cadastro_cliente_cargo': {
                        templateUrl: rotasHtmlCargo.tabela
                    }
                }
            });
    }

})();

//<!-- Ultima mudança 28/03/2017.-->
(function () {
    'use strict';

    angular.module('app.geral.cadastro.cliente.cargo')
        .controller('CargoClienteController', CargoClienteController);

    function CargoClienteController(Api, RequisicaoGenericaService, NavegacaoService, DatatableFactory) {
        var vm = this;
        NavegacaoService.setTituloAba('Cliente cargo');

        // Data region    
        vm.form = {};
        vm.rota = Api.cargo.proximoCodigo;
        // endregion

        // Definição dos Métodos region
        vm.metodos = {
            pesquisar: pesquisar,
            salvar: salvar,
            editar: editar,
            excluir: excluir,
            selecionar: selecionar,
            construirDtOptions: construirDtOptions
        }
        //endregion

        // Implementação dos Métodos region

        /**
         * Método para pesquisar os cargos
         */
        function pesquisar() {
            return RequisicaoGenericaService.listarComObjetoComplexo(Api.cargo.listarComPaginacao, vm.entidadeDeEnvio);
        }

        /**
         * Método para salvar um novo cargo
         * @param {cargo} modelo 
         */
        function salvar(modelo) {
            return RequisicaoGenericaService.salvar(Api.cargo.criar, modelo);
        }

        /**
         * Método para editar um cargo
         * @param {cargo} modelo 
         */
        function editar(modelo) {
            return RequisicaoGenericaService.editar(Api.cargo.atualizar, modelo)
        }

        /**
         * Método para excluir um cargo
         * @param {cargo} modelo 
         */
        function excluir(modelo) {
            return RequisicaoGenericaService.excluir(Api.cargo.excluir, modelo.codigo)
        }

        /**
         * Método utilizado no modo exibido tabela, para selecionar um cargo
         * @param {cargo} modelo 
         */
        function selecionar(posicaoEntidade) {
            vm.metodosExternosPgToolbar.metodoControladorExternoListarTodasEntidades(null, posicaoEntidade);
        }

        /**
         * Método para construi o DtOptions da tabela
         */
        function construirDtOptions() {
            DatatableFactory.construirDtOptionsComPaginacaoProcessadoNoServidorParaToolbar
                (Api.cargo.listarComPaginacaoDatatable, vm.entidadeDeEnvio.clsEntidade, '#datatable-cargo-cliente',
                [

                    DatatableFactory.construirColunaDeSelecionarPadrao(function (indexLinha) { vm.metodos.selecionar(indexLinha) }),
                    {
                        targets: 1,
                        name: "Codigo",
                        data: "codigo",
                        sortable: false
                    },
                    {
                        targets: 2,
                        name: "Descricao",
                        data: "descricao",
                        sortable: false
                    }
                ]);
        }
        //endregion

    }
})();

(function () {
    "use strict";

    angular
        .module("app.geral.cadastro.cliente.cliente")
        .controller("ClienteController", ClienteController);

    function ClienteController(
        $mdDialog,
        $timeout,
        $rootScope,
        $scope,
        $state,
        $stateParams,
        Api,
        ClienteService,
        ControleAcessoConfig,
        DataTableConfigPadrao,
        DatatableFactory,
        ListarDetalhesUsuario,
        ListarEquipamentos,
        ListarTipoClassificacao,
        ListarTiposEquipamento,
        ListarTodasUF,
        ListarUsuariosSetorComercial,
        LoginUsuarioService,
        MdToastService,
        MdDialogService,
        MenuFactory,
        NavegacaoService,
        Pendencias,
        PgToolbarService,
        Regex,
        RequisicaoGenericaLocacaoService,
        RequisicaoGenericaService,
        RotasHtml,
        ServicosGenericoService,
        Solucoes,
        VisualizarAtividadeService
    ) {
        var vm = this;
        NavegacaoService.setTituloAba("Cliente");

        // Data
        vm.regex = Regex;
        vm.htmlRota = RotasHtml;
        vm.tabSelecionada = "cliente";
        vm.cliente = {};
        vm.clientes = [];

        vm.equipamentoTipo = ListarTiposEquipamento.data;
        vm.equipamento = ListarEquipamentos.data;
        vm.todosExecutivosSelecionados = false;

        vm.usuariosBkp = ListarUsuariosSetorComercial.data;
        vm.usuarios = angular.copy(vm.usuariosBkp);
        vm.possuiRiscoRescisaoContratual = false;
        vm.menuAberto = false;
        vm.solucoes = Solucoes.data;
        vm.pendencias = Pendencias.data;
        vm.solucoesSelecionadas = [];
        vm.ufs = ListarTodasUF.data;
        vm.tipoClassificacoes = ListarTipoClassificacao.data;
        vm.formulariosImpressao = [];
        vm.listarMetodosImpressao = [];
        vm.segmentacoes = [];
        vm.formasPagamento = [];
        vm.formasFaturamento = [];

        vm.exibirBotaoNegocios = false;

        if (
            ControleAcessoConfig.usuarioEDirecao() ||
            ControleAcessoConfig.usuarioEComercial()
        ) {
            vm.exibirBotaoNegocios = true;
        }

        vm.mascaraCampoDocumento = {
            mascara: "",
            mensagem: "",
        };

        vm.pessoa = null;
        vm.rota = Api.cliente.proximoCodigo;

        vm.controleAbasCliente = {
            controladorDadosAuxiliares: false,
        };

        vm.usuariocorrente = LoginUsuarioService.usuarioArmazenado();

        var EhComercial = vm.usuarios.filter(function (item) {
            return item.codigo == vm.usuariocorrente.codigo;
        })[0];

        /**
         * Verifica se o usuário pode visualizar a aba de informações contratuais
         */
        if (EhComercial) vm.usuarioComercial = true;
        else vm.usuarioComercial = false;
        // FIM DATA

        // Configurações Datatable
        vm.dtOptionsClientePessoalDeReferencia = angular.copy(
            DataTableConfigPadrao.dtOptionsResponsivoSemPaginacaoComInitComplete
        );
        vm.dtOptionsClientePessoalDeReferencia.columnDefs = [
            DataTableConfigPadrao.columnDefsPadrao,
        ];

        vm.dtOptionsClienteEquipamentos = angular.copy(
            DataTableConfigPadrao.dtOptionsPadraoComPaginacaoPaginTypeNumbersEReponsivo
        );
        vm.dtOptionsClienteEquipamentos.columnDefs = [
            DataTableConfigPadrao.columnDefsPadrao,
            {
                targets: 4,
                ordering: false,
                filterable: false,
                sortable: false,
                responsivePriority: 1,
            },
        ];
        vm.dtOptionsClienteEquipamentos.lengthMenu = [5];
        vm.dtOptionsClienteEquipamentos.pageLength = 5;

        vm.dtOptionsClienteEquipamentosDetalhes = angular.copy(
            DataTableConfigPadrao.dtOptionsResponsivoSemPaginacao
        );
        vm.dtOptionsClienteEquipamentosDetalhes.columnDefs = [
            DataTableConfigPadrao.columnDefsPadrao,
        ];

        vm.resetarDataGridClienteEquipamentos = true;

        _init();
        //FIM Configurações Datatable

        // Definição dos Métodos
        var metodosInterno = {
            _init: _init,
            verificaTabEquipamentos: verificaTabEquipamentos,
        };

        vm.metodosGeral = {
            tabSelecionada: tabSelecionada,
            novaPesquisa: novaPesquisa,
            preDefinirCamposParaInserir: preDefinirCamposParaInserir,
            atulizarEntidadeAbaAtiva: atulizarEntidadeAbaAtiva,
            preDefinirValoresQuandoNavegado: preDefinirValoresQuandoNavegado,
            abrirSolucao: abrirSolucao,
            copiarParaClipboard: copiarParaClipboard,
        };

        vm.metodosCliente = {
            toggleTodosExecutivos: toggleTodosExecutivos,
            onChangeExecutivos: onChangeExecutivos,
            pesquisar: pesquisar,
            salvar: salvar,
            editar: editar,
            excluir: excluir,
            selecionar: selecionar,
            construirDtOptions: construirDtOptions,
            pesquisarAutoCompleteCidade: pesquisarAutoCompleteCidade,
            alterarItemSelecionadoAutoCompleteCidade:
                alterarItemSelecionadoAutoCompleteCidade,
            configuraAutoCompleteCidadeOnBlur:
                configuraAutoCompleteCidadeOnBlur,
            pesquisarAutoCompleteBairro: pesquisarAutoCompleteBairro,
            alterarItemSelecionadoAutoCompleteBairro:
                alterarItemSelecionadoAutoCompleteBairro,
            ngChangeTipoClassificacao: ngChangeTipoClassificacao,
            configuraAutoCompleteBairroOnBlur:
                configuraAutoCompleteBairroOnBlur,
            configuraMdSelectSolucao: configuraMdSelectSolucao,
            configuraMdSelectFormaPagamento: configuraMdSelectFormaPagamento,
            configuraMdSelectFormaFaturamento:
                configuraMdSelectFormaFaturamento,
            configuraMdSelectUsuarioComercial: configuraMdSelectUsuarioComercial,
            abrirDialogAtendimento: abrirDialogAtendimento,
            abrirDialogCaracteristica: abrirDialogCaracteristica,
            abrirDialogContratos: abrirDialogContratos,
            abrirDialogNegociosEmAndamento: abrirDialogNegociosEmAndamento,
            abrirDialogAgenda: abrirDialogAgenda,
            abrirDialogEstatisticas: abrirDialogEstatisticas,
            verificarColaboradorEComercial: verificarColaboradorEComercial,
            navegarParaRelatorioAtendimento: navegarParaRelatorioAtendimento,
        };
        vm.metodosPessoalDeReferencia = {
            pesquisarAutoCompletepessoa: pesquisarAutoCompletepessoa,
            criarPessoaDeReferencia: criarPessoaDeReferencia,
            criarOuEditarPessoaDeReferencia: criarOuEditarPessoaDeReferencia,
            excluirPessoaDeReferencia: excluirPessoaDeReferencia,
            abrirWhatsappNovaAba: abrirWhatsappNovaAba,
        };
        vm.metodosClienteEquipamentos = {
            abrirDialogClienteEquipamentos: abrirDialogClienteEquipamentos,
            excluirClienteEquipamento: excluirClienteEquipamento,
            selecionarDetalhesEquipamento: selecionarDetalhesEquipamento,
            deselecionarDetalhesEquipamento: deselecionarDetalhesEquipamento,
            abrirDialogDetalhesEquipamento: abrirDialogDetalhesEquipamento,
            excluirClienteEquipamentoDetalhe: excluirClienteEquipamentoDetalhe,
        };
        // FIM Definição dos Métodos

        ///////////////////////////////////////////////////// Métodos Internos region ///////////////////////////////////////////////

        function _init() {
            vm.atividadesCliente = [];
            vm.parametros = $state.params.parametros;
            if (vm.parametros != null) {
                if (vm.parametros.cliente != null) {
                    vm.entidadeDeEnvio = {
                        intTamanhoPagina: 1,
                        clsEntidade: vm.cliente,
                    };
                    vm.entidadeDeEnvio.clsEntidade.codigo =
                        vm.parametros.cliente.codigo;
                    vm.iniciarChamandoPesquisa = true;
                }
            }
            vm.listarInformacoesDasTab = {
                dadosAuxiliares: _carregarDependenciasDadosAuxiliares,
                configuracoes: _carregarDependenciasConfiguracoes,
            };
        }

        // Métodos do carroulssel de equipamentos
        function listarEquipamentosPorContrato(codigoCliente) {
            RequisicaoGenericaLocacaoService.listarSemParams(
                Api.locacao.equipamentos.equipamento.listarPorCliente +
                codigoCliente
            ).then(
                function (success) {
                    vm.equipamentosPorContrato = success.data;
                },
                function (error) {
                    MdDialogService.alertPadrao(error.data.error);
                }
            );
        }

        function listarEquipamentosPorTerceiros(codigoCliente) {
            RequisicaoGenericaLocacaoService.listarSemParams(
                Api.locacao.equipamentos.equipamento
                    .listarPorContratoTerceiros + codigoCliente
            ).then(
                function (success) {
                    vm.equipamentosPorTerceiros = success.data;
                },
                function (error) {
                    MdDialogService.alertPadrao(error.data.error);
                }
            );
        }

        function abrirSolucao(caminho) {
            if (
                !caminho.startsWith("http://") &&
                !caminho.startsWith("https://")
            ) {
                caminho = "http://" + caminho;
            }
            window.open(caminho, "_blank");
        }

        function copiarParaClipboard(senha) {
            var elem = document.createElement("textarea");
            elem.value = senha;
            document.body.appendChild(elem);
            elem.select();
            document.execCommand("copy");
            document.body.removeChild(elem);
        }

        // Equipamento locação
        function _inicializarCarrosselEquipamentos() {
            var positionEquipamento = 0;
            vm.containerEquipamento = angular.element(".container-equipamento");
            vm.trackEquipamento = angular.element(".track-equipamento");
            vm.btnNextEquipamento = angular.element(".btn-next1");
            vm.btnPrevEquipamento = angular.element(".btn-prev1");

            vm.btnNextEquipamento.click(function () {
                const itemsLeftEquip =
                    vm.itemsCountEquipamento -
                    (Math.abs(positionEquipamento) +
                        vm.slidesToShowEquipamento * vm.itemWidthEquipamento) /
                    vm.itemWidthEquipamento;

                positionEquipamento -=
                    itemsLeftEquip >= vm.slidesToMoveEquipamento
                        ? vm.movePositionEquipamento
                        : itemsLeftEquip * vm.itemWidthEquipamento;

                setPositionEquipamento();
            });

            vm.btnPrevEquipamento.click(function () {
                const itemsLeftEquip =
                    Math.abs(positionEquipamento) / vm.itemWidthEquipamento;

                positionEquipamento +=
                    itemsLeftEquip >= vm.slidesToMoveEquipamento
                        ? vm.movePositionEquipamento
                        : itemsLeftEquip * vm.itemWidthEquipamento;

                setPositionEquipamento();
            });

            const setPositionEquipamento = function () {
                vm.trackEquipamento.css({
                    transform: "translateX(" + positionEquipamento + "px)",
                });
                checkBtnsEquipamento();
            };

            const checkBtnsEquipamento = function () {
                vm.btnPrevEquipamento.prop(
                    "disabled",
                    positionEquipamento === 0
                );
                vm.btnNextEquipamento.prop(
                    "disabled",
                    positionEquipamento <=
                    -(
                        vm.itemsCountEquipamento -
                        vm.slidesToShowEquipamento
                    ) *
                    vm.itemWidthEquipamento
                );
            };

            checkBtnsEquipamento();
        }
        // Final Equipamento locação

        // Equipamentos terceiros
        function _inicializarCarrosselEquipamentosTerceiros() {
            var positionEquipamentoTerceiros = 0;
            vm.containerEquipamentoTerceiros = angular.element(
                ".container-terceiros"
            );
            vm.trackEquipamentoTerceiros = angular.element(".track-terceiros");
            vm.btnNextEquipamentoTerceiros = angular.element(
                ".btn-next-terceiros"
            );
            vm.btnPrevEquipamentoTerceiros = angular.element(
                ".btn-prev-terceiros"
            );

            vm.btnNextEquipamentoTerceiros.click(function () {
                const itemsLeftEquip =
                    vm.itemsCountEquipamentoTerceiros -
                    (Math.abs(positionEquipamentoTerceiros) +
                        vm.slidesToShowEquipamentoTerceiros *
                        vm.itemWidthEquipamentoTerceiros) /
                    vm.itemWidthEquipamentoTerceiros;

                positionEquipamentoTerceiros -=
                    itemsLeftEquip >= vm.slidesToMoveEquipamentoTerceiros
                        ? vm.movePositionEquipamentoTerceiros
                        : itemsLeftEquip * vm.itemWidthEquipamentoTerceiros;

                setPositionEquipamentoTerceiros();
            });

            vm.btnPrevEquipamentoTerceiros.click(function () {
                const itemsLeftEquip =
                    Math.abs(positionEquipamentoTerceiros) /
                    vm.itemWidthEquipamentoTerceiros;

                positionEquipamentoTerceiros +=
                    itemsLeftEquip >= vm.slidesToMoveEquipamentoTerceiros
                        ? vm.movePositionEquipamentoTerceiros
                        : itemsLeftEquip * vm.itemWidthEquipamentoTerceiros;

                setPositionEquipamentoTerceiros();
            });

            const setPositionEquipamentoTerceiros = function () {
                vm.trackEquipamentoTerceiros.css({
                    transform:
                        "translateX(" + positionEquipamentoTerceiros + "px)",
                });
                checkBtnsEquipamentoTerceiros();
            };

            const checkBtnsEquipamentoTerceiros = function () {
                vm.btnPrevEquipamentoTerceiros.prop(
                    "disabled",
                    positionEquipamentoTerceiros === 0
                );
                vm.btnNextEquipamentoTerceiros.prop(
                    "disabled",
                    positionEquipamentoTerceiros <=
                    -(
                        vm.itemsCountEquipamentoTerceiros -
                        vm.slidesToShowEquipamentoTerceiros
                    ) *
                    vm.itemWidthEquipamentoTerceiros
                );
            };

            checkBtnsEquipamentoTerceiros();
        }
        // Final Equipamentos terceiros

        // Métodos do carroulssel de equipamentos

        function _carregarDependenciasDadosAuxiliares() {
            vm.controleForm.emProgresso = true;
            RequisicaoGenericaService.listarSemParams(
                Api.segmentacao.listarPor
            ).then(
                function (success) {
                    vm.segmentacoes = success.data;
                    vm.controleForm.emProgresso = false;
                },
                function error() {
                    console.error(error);
                    vm.controleForm.emProgresso = false;
                }
            );
        }

        function _carregarDependenciasConfiguracoes() {
            vm.controleForm.emProgresso = true;

            vm.metodosPgToolbar.metodosAcaoAtualizar();

            var promiseFormularios = RequisicaoGenericaService.listarSemParams(
                Api.display.listarFormularioImpressao
            );

            var promiseMetodosImpressao =
                RequisicaoGenericaService.listarSemParams(
                    Api.display.listarMetodoImpressao
                );

            vm.controleForm.emProgresso = true;

            Promise.all([promiseFormularios, promiseMetodosImpressao]).then(
                function (values) {
                    vm.formulariosImpressao = values[0].data;
                    vm.listarMetodosImpressao = values[1].data;
                    vm.controleForm.emProgresso = false;
                },
                function (error) {
                    console.log(error);
                    vm.controleForm.emProgresso = false;
                }
            );
        }

        /**
         * Método interno que verifica se a tab ativa é equipamentos
         */
        function verificaTabEquipamentos() {
            setTimeout(function () {
                listarEquipamentosPorContrato(vm.cliente.codigo);
                listarEquipamentosPorTerceiros(vm.cliente.codigo);
            }, 200);

            if (vm.tabSelecionada == "equipamentos") {
                vm.exibitarTabelaEquipamentos = false;
                $timeout(function () {
                    vm.exibitarTabelaEquipamentos = true;
                    // ------- Variaveis do tipo locação ------ //
                    vm.itemsCountEquipamento =
                        vm.equipamentosPorContrato.length;
                    vm.slidesToShowEquipamento = 4;
                    vm.itemWidthEquipamento = 250;
                    vm.slidesToMoveEquipamento = 1;
                    vm.movePositionEquipamento =
                        vm.slidesToMoveEquipamento * vm.itemWidthEquipamento;
                    if (vm.itemsCountEquipamento <= vm.slidesToShowEquipamento)
                        vm.desabilitarBtnMover1 = true;
                    else vm.desabilitarBtnMover1 = false;

                    // ------- Fim Variaveis do tipo locação ------ //

                    // ------- Variaveis de terceiros ------ //
                    vm.itemsCountEquipamentoTerceiros =
                        vm.equipamentosPorTerceiros.length;
                    vm.slidesToShowEquipamentoTerceiros = 4;
                    vm.itemWidthEquipamentoTerceiros = 250;
                    vm.slidesToMoveEquipamentoTerceiros = 1;
                    vm.movePositionEquipamentoTerceiros =
                        vm.slidesToMoveEquipamentoTerceiros *
                        vm.itemWidthEquipamentoTerceiros;
                    if (
                        vm.itemsCountEquipamentoTerceiros <=
                        vm.slidesToShowEquipamentoTerceiros
                    )
                        vm.desabilitarBtnMover2 = true;
                    else vm.desabilitarBtnMover2 = false;
                    // ------- Fim Variaveis de terceiros ------ //
                    _inicializarCarrosselEquipamentos();
                    _inicializarCarrosselEquipamentosTerceiros();
                }, 500);
                pesquisar();
            }
        }

        // Watch necessário para fazer as requisições quase se utilizar a navegação
        $scope.$watch("vm.cliente", function (newValue, oldValue) {
            if (angular.equals({}, newValue))
                vm.metodosGeral.tabSelecionada("cliente");
            if (vm.cliente.codigo) {
                _carregarAtividadesCliente();
            } else {
                vm.metodosGeral.tabSelecionada(vm.tabSelecionada);
            }
        });

        /**
         * Método que é chamado sempre quando ocorre uma transição de tab
         * @param {tab} tab
         */
        function tabSelecionada(tab) {
            vm.pesquisar = "";
            vm.tabSelecionada = tab;

            ClienteService.verificaTabSelecionadaService(
                tab,
                vm.cliente,
                vm.controleForm,
                vm.controlePreloader,
                vm.listarInformacoesDasTab
            );
            ClienteService.controlaButtonsToolbarService(tab, vm.controleForm);
            verificaTabEquipamentos();
        }

        /**
         * Método chamado quando o botão nova pesquisa é pressionado, assim chamando o método tabSelecionada passado a tab 'cliente'
         */
        function novaPesquisa() {
            vm.metodosGeral.tabSelecionada("cliente");
            vm.possuiRiscoRescisaoContratual = false;
            vm.todosExecutivosSelecionados = false;
        }

        /**
         * Método chamado quando o botão inserir da toolbar for clicado para pré definir alguns campos
         */
        function preDefinirCamposParaInserir() {
            vm.possuiRiscoRescisaoContratual = false;
            vm.usuarios = angular.copy(vm.usuariosBkp);

            vm.cliente = {
                dataCadastro: new Date(),
                tipoClassificacao: 1,
                ativo: true,
                observacoesTecnicas: "",
                codigoSegmentacao: null,
            };
            vm.mascaraCampoDocumento.mascara = "CNPJ";
            vm.mascaraCampoDocumento.mensagem =
                "Cpnj digitado inválido Ex: ##.###.###/####-##";
        }

        /**
         * Método que recarrega a entidade da aba ativa quando for clicado no botão atualizar da  toolbar
         */
        function atulizarEntidadeAbaAtiva() {
            vm.metodosGeral.tabSelecionada(vm.tabSelecionada);
            verificaTabEquipamentos();
        }

        /**
         * Método que sempre é chamado quando a navegação do toolbar for utilizada
         */
        function preDefinirValoresQuandoNavegado() {
            verificaTabEquipamentos();
        }

        /**
         * Método para pesquisar uma lista de clientes 183
         */
        function pesquisar() {
            if (vm.cliente.codigosUsuario) {
                vm.cliente.codigoUsuario = vm.cliente.codigosUsuario;
            } else if (vm.cliente.codigoUsuario) {
                vm.cliente.codigoUsuario = [vm.cliente.codigoUsuario];
            }

            var _entidadeParaEnvio = null;
            if (!vm.entidadeDeEnvio)
                _entidadeParaEnvio =
                    PgToolbarService.recuperarEntidadeDeEnvio();
            else {
                _entidadeParaEnvio = vm.entidadeDeEnvio;
            }

            if (
                vm.entidadeDeEnvio &&
                vm.entidadeDeEnvio.observacoesTecnicas &&
                vm.entidadeDeEnvio.observacoesTecnicas.trim().length == 0
            ) {
                delete vm.entidadeDeEnvio.observacoesTecnicas;
            }
            var result = RequisicaoGenericaService.listarComObjetoComplexo(
                Api.cliente.listarComPaginacao,
                _entidadeParaEnvio
            );

            result.then(
                function (sucess) {
                    verificaPossuiRiscoRescisaoContratual(sucess.data.lstResultado[0])
                    var usuarioResponsavel =
                        sucess.data.lstResultado[0].usuarioResponsavel;

                    vm.utilizaReader =
                        sucess.data.lstResultado[0].codigoSolucoes.includes(
                            2
                        ) ||
                        sucess.data.lstResultado[0].codigoSolucoes.includes(36);

                    vm.utilizaIService =
                        sucess.data.lstResultado[0].codigoSolucoes.includes(11);

                    vm.utilizaIAguas =
                        sucess.data.lstResultado[0].solucoes.some(function (
                            codigoSolucao
                        ) {
                            return (
                                codigoSolucao.codigo === 45 ||
                                codigoSolucao.codigo === 50
                            );
                        });

                    if (
                        vm.tabSelecionada == "configuracoes" &&
                        !vm.utilizaReader &&
                        !vm.utilizaIService &&
                        !vm.utilizaIAguas
                    ) {
                        MdDialogService.alertPadrao(
                            "As soluções Reader, IService e IÁguas não estão cadastradas para este cliente."
                        );
                    }

                    var temNaLista = false;
                    if (usuarioResponsavel != null) {
                        vm.usuarios.forEach(function (item) {
                            if (item.codigo == usuarioResponsavel.codigo) {
                                temNaLista = true;
                            }
                        });

                        if (!temNaLista) {
                            vm.usuarios.push(usuarioResponsavel);
                        }
                    }
                },
                function (error) { }
            );

            return result;
        }

        function verificaPossuiRiscoRescisaoContratual(cliente) {
            if (!cliente || !cliente.contratos) {
                vm.possuiRiscoRescisaoContratual = false;
                return;
            }

            vm.possuiRiscoRescisaoContratual = cliente.contratos.some(function (
                contrato
            ) {
                return (
                    contrato.contratoItens &&
                    contrato.contratoItens.some(function (item) {
                        return item.riscoRescisaoContratual === true;
                    })
                );
            });
        }


        /**
         * Método para salvar um novo cliente
         * @param {cliente} cliente
         */
        function salvar(cliente) {
            return RequisicaoGenericaService.salvar(Api.cliente.criar, cliente);
        }

        /**
         * Método para editar um cliente
         * @param {cliente} cliente
         */
        function editar(cliente) {
            return RequisicaoGenericaService.editar(
                Api.cliente.atualizar,
                cliente
            );
        }

        /**
         * Método para excluir um cliente
         * @param {cliente} cliente
         */
        function excluir(cliente) {
            return RequisicaoGenericaService.excluir(
                Api.cliente.excluir,
                cliente.codigo
            );
        }

        /**
         * Método utilizado no modo exibido tabela, para selecionar um cliente
         * @param {cliente} cliente
         */
        function selecionar(posicaoEntidade) {
            vm.metodosPgToolbar.metodoControladorExternoListarTodasEntidades(
                null,
                posicaoEntidade
            );
        }

        /**
         * Método para construi o DtOptions da tabela
         */
        function construirDtOptions() {
            DatatableFactory.construirDtOptionsComPaginacaoProcessadoNoServidorParaToolbar(
                Api.cliente.listarComPaginacaoDatatable,
                vm.entidadeDeEnvio.clsEntidade,
                "#datatable-cliente",
                [
                    DatatableFactory.construirColunaDeSelecionarPadrao(
                        function (indexLinha) {
                            vm.metodosCliente.selecionar(indexLinha);
                        }
                    ),
                    {
                        targets: 1,
                        name: "Codigo",
                        data: "codigo",
                        defaultContent: "",
                        sortable: false,
                    },
                    {
                        targets: 2,
                        name: "Nome",
                        data: "nome",
                        defaultContent: "",
                        sortable: false,
                    },
                    {
                        targets: 3,
                        name: "CodigoCidade",
                        data: "cidade.descricao",
                        defaultContent: "",
                        sortable: false,
                    },
                    {
                        targets: 4,
                        name: "Telefone",
                        data: "telefone",
                        defaultContent: "",
                        sortable: false,
                    },
                ]
            );
        }

        /**
         * Método que realiza uma requisição para api para buscar as cidades em tempo de excução, * com base no que o usuário está digitando
         * @param {string} query
         */
        function pesquisarAutoCompleteCidade(query) {
            return ServicosGenericoService.pesquisarAutoCompleteDescricaoGenericoApi(
                Api.endereco.cidade.listarPor,
                query
            );
        }

        /**
         * Método que controla qual cidade está selecionada no campo md-auto-complete da Cidade
         * @param {object} item
         */
        function alterarItemSelecionadoAutoCompleteCidade(item) {
            if (item) {
                vm.cidade = item;
                vm.cliente.codigoCidade = item.codigo;
                vm.cliente.uf = item.uf;
            } else {
                vm.cliente.cidade = null;
                vm.cliente.codigoCidade = null;
                vm.cliente.uf = null;
                vm.textoDePesquisaAutoCompleteCidade = "";
            }
        }

        function ngChangeTipoClassificacao(item) {
            vm.cliente.documento = null;
            if (item == 1) {
                vm.mascaraCampoDocumento.mascara = "CNPJ";
                vm.mascaraCampoDocumento.mensagem =
                    "Cpnj digitado inválido Ex: ##.###.###/####-##";
            } else if (item == 2) {
                vm.mascaraCampoDocumento.mascara = "CPF";
                vm.mascaraCampoDocumento.mensagem =
                    "Cpf digitado inválido Ex: ###.###.###-##";
            } else {
                vm.mascaraCampoDocumento.mascara = "";
                vm.mascaraCampoDocumento.mensagem = "";
            }
        }

        /**
         * Método que limpa o texto de pesquisa do md-auto-complete da Cidade
         */
        function configuraAutoCompleteCidadeOnBlur() {
            if (!vm.cliente.cidade) {
                vm.textoDePesquisaAutoCompleteCidade = "";
            }
        }

        /**
         * Método que realiza uma requisição para api para buscar os bairros em tempo de excução, * com base no que o usuário está digitando
         * @param {string} query
         */
        function pesquisarAutoCompleteBairro(query) {
            return ServicosGenericoService.pesquisarAutoCompleteDescricaoGenericoApi(
                Api.endereco.bairro.listarPor,
                query
            );
        }

        /**
         * Método que controla qual bairro está selecionada no campo md-auto-complete do Bairro
         * @param {object} item
         */
        function alterarItemSelecionadoAutoCompleteBairro(item) {
            if (item) {
                vm.cliente.bairro = item;
                if (!item.descricao) vm.cliente.bairro.descricao = " ";
                vm.cliente.codigoBairro = item.codigo;
            } else {
                vm.cliente.bairro = null;
                vm.cliente.codigoBairro = null;
                vm.textoDePesquisaAutoCompleteBairro = "";
            }
        }

        /**
         * Método que limpa o texto de pesquisa do md-auto-complete da Cidade
         */
        function configuraAutoCompleteBairroOnBlur() {
            if (!vm.cliente.bairro) {
                vm.textoDePesquisaAutoCompleteBairro = "";
            }
        }

        /**
         * Método que irá configurar e limpar o filtro do md-header do md-select de solução
         */
        function configuraMdSelectSolucao() {
            vm.filtrarSolucoes = "";
            angular
                .element("#cliente-form-solucao-md-select")
                .on("keydown", function (ev) {
                    ev.stopPropagation();
                });
        }

        function configuraMdSelectFormaPagamento() {
            vm.filtrarFormaPagamento = "";
            angular
                .element("#cliente-form-forma-pagamento-md-select")
                .on("keydown", function (ev) {
                    ev.stopPropagation();
                });
        }

        function configuraMdSelectFormaFaturamento() {
            vm.filtrarFormaFaturamento = "";
            angular
                .element("#cliente-form-forma-faturamento-md-select")
                .on("keydown", function (ev) {
                    ev.stopPropagation();
                });
        }

        function configuraMdSelectUsuarioComercial() {
            vm.filtrarUsuarios = "";
            angular
                .element("#tab-cliente-usuario-comercial-md-select")
                .on("keydown", function (ev) {
                    ev.stopPropagation();
                });
        }

        function toggleTodosExecutivos() {
            if (vm.todosExecutivosSelecionados) {
                vm.cliente.codigosUsuario = vm.usuarios.map(function (u) { return u.codigo; });
            } else {
                vm.cliente.codigosUsuario = [];
            }
        }

        function onChangeExecutivos() {
            if (!angular.isArray(vm.cliente.codigosUsuario)) {
                vm.todosExecutivosSelecionados = false;
                return;
            }
            var total = (vm.usuarios || []).length;
            var selecionados = (vm.cliente.codigosUsuario || []).length;
            if (total > 0 && selecionados === total) {
                vm.todosExecutivosSelecionados = true;
            } else {
                vm.todosExecutivosSelecionados = false;
            }
        }

        /**
         * Método que irá abrir o dialog de atendimentos do cliente
         * @param {event button} event
         */
        function abrirDialogAtendimento(event) {
            $mdDialog.show({
                controller: "ClienteDialogAtendimentoController",
                controllerAs: "vm",
                templateUrl:
                    vm.htmlRota.cliente.tabCliente.dialogAtendimento.dialog,
                //parent: ---------------,
                targetEvent: event,
                clickOutsideToClose: false,
                locals: {
                    Cliente: vm.cliente,
                },
            });
        }

        /**
         * Método para abrir o dialog de caracteristica do cliente
         * @param {event} event eventButton
         */
        function abrirDialogCaracteristica(event) {
            $mdDialog.show({
                controller: "ClienteDialogCaracteristicaController",
                controllerAs: "vm",
                templateUrl:
                    vm.htmlRota.cliente.tabCliente.dialogCaracteristica,
                //parent: ---------------,
                targetEvent: event,
                clickOutsideToClose: false,
                locals: {
                    CodigoCliente: vm.cliente.codigo,
                },
            });
        }

        /**
         * Método para abrir o dialog de Contratos
         * @param {event} event Event Button
         * @param {object} modelo Cliente
         */
        function abrirDialogContratos(event, modelo) {
            $mdDialog.show({
                controller: "ContratosController",
                controllerAs: "vm",
                templateUrl: vm.htmlRota.cliente.tabCliente.dialogContratos,
                //parent: ---------------,
                targetEvent: event,
                clickOutsideToClose: false,
                locals: {
                    Cliente: modelo,
                    DesabilitarBotoes: true,
                    ListarUsuariosSetorComercial: ListarUsuariosSetorComercial,
                },
                onRemoving: function () {
                    vm.metodosPgToolbar.metodosAcaoAtualizar();
                },
            });
        }


        function abrirDialogEstatisticas(event, cliente) {
            RequisicaoGenericaService.listarSemParams(Api.atendimento.tag.listarTodas).then(
                function (success) {
                    $rootScope.$broadcast('atualizarListaTodasTags', Array.isArray(success.data) ? { data: success.data } : success.data);
                    $rootScope.listaTodasTags = Array.isArray(success.data) ? success.data : success.data.data;
                    $mdDialog.show({
                        controller: "EstatisticasTagsAtendimentoController",
                        controllerAs: "vm",
                        templateUrl: vm.htmlRota.cliente.tabCliente.dialogEstatisticasTags,
                        //parent: ---------------,
                        targetEvent: event,
                        clickOutsideToClose: false,
                        locals: {
                            Cliente: cliente,
                            DesabilitarSidenav: true,
                            ListarTodasTags: success.data,
                        },
                    });

                });
        }

        /**
         * Método para abrir o dialog de negócios
         * @param {event} event Event Button
         * @param {object} modelo Cliente
         */
        function abrirDialogNegociosEmAndamento(event, modelo) {
            var dadosFiltro = {
                codigo: modelo.codigo,
            };
            var executivo = undefined;
            executivo = {
                codigo: null,
                nome: null,
            };

            if (modelo.usuarioResponsavel) {
                executivo.codigo = modelo.usuarioResponsavel.codigo;
                executivo.nome = modelo.usuarioResponsavel.nome;
            }

            var parametros = {
                filtroCard: dadosFiltro,
                rota: Api.pipeline.pipeline_estatisticas
                    .listaNegociosEmAndamentoPorCliente,
                titulo: "Negócios em andamento do cliente " + modelo.nome,
                executivo: executivo,
                permiteEdicao: true,
            };

            MdDialogService.abrirDialogPadrao(
                event,
                "DetalhamentoNegociosDialogController",
                vm.htmlRota.cliente.tabCliente.dialogListaNegocios,
                parametros
            );
        }

        function abrirDialogAgenda(event, cliente) {
            VisualizarAtividadeService.abrirDialogAtividade(
                event,
                cliente,
                RequisicaoGenericaService.listarSemParams(
                    Api.agenda.atividade.listarStatus
                ),
                RequisicaoGenericaService.listarSemParams(
                    Api.agenda.evento.listarTodos
                ),
                vm.atividadesCliente,
                null,
                null,
                ListarDetalhesUsuario
            );
        }


        $rootScope.$on("atividadeCadastrada", function (event, atividade) {
            _carregarAtividadesCliente();
        });

        $rootScope.$on("atividadeReagendada", function (event, atividade) {
            _carregarAtividadesCliente();
        });

        function verificarColaboradorEComercial() {
            return (
                ControleAcessoConfig.usuarioEComercial() ||
                ControleAcessoConfig.usuarioEDirecao() ||
                ControleAcessoConfig.usuarioEAdministrativo()
            );
        }

        function navegarParaRelatorioAtendimento(event) {
            MenuFactory.navegarParaEstadoSeUsuarioTerAcesso(
                "app.atendimento_relatorio_atendimento",
                { navegacaoDeCliente: { cliente: vm.cliente } }
            );
        }

        vm.detalhesEquipamentoSelecionado = [];
        var clienteEquipamentoSelecionado = null;
        vm.exibitarTabelaEquipamentos = true;
        vm.equipamentosSelecionados = false;

        /**
         * Método para abrir o dialog de Cliente-Equipamentos para inserir ou editar um equipamento
         * @param {event} event event do button
         * @param {object} clienteEquipamento equipamentoSelecionada
         */
        function abrirDialogClienteEquipamentos(event, clienteEquipamento) {
            $mdDialog
                .show({
                    controller: "ClienteDialogEquipamentosController",
                    controllerAs: "vm",
                    templateUrl:
                        vm.htmlRota.cliente.tabEquipamento
                            .dialogClienteEquipamento,
                    //parent: ---------------,
                    targetEvent: event,
                    clickOutsideToClose: false,
                    locals: {
                        Cliente: vm.cliente,
                        ClienteEquipamento: clienteEquipamento,
                        DeselecionarDetalhesEquipamento:
                            deselecionarDetalhesEquipamento,
                    },
                })
                .then(function (success) {
                    // vm.resultadoDialogEquipamentos = success.data;
                    pesquisar();
                    verificaTabEquipamentos();
                });
        }

        /**
         * Método para excluir um Equipamento da tabela
         * @param {event} event event button
         * @param {object} modelo clienteEquipamento
         */
        function excluirClienteEquipamento(event, modelo) {
            if (vm.cliente.equipamentos) {
                var indexClienteEquipamento = vm.cliente.equipamentos
                    .map(function (item) {
                        return item.codigo;
                    })
                    .indexOf(modelo.codigo);
            }
            ServicosGenericoService.excluirRegistroPorCodigoOuGenericamente(
                Api.cliente_equipamento.excluir,
                vm.cliente.equipamentos,
                modelo,
                vm.controleForm,
                event,
                "Deseja realmente excluir este Equipamento?",
                function (success) {
                    MdToastService.toastPadrao(success.data);
                    // deselecionarDetalhesEquipamento();
                    pesquisar();
                    verificaTabEquipamentos();
                },
                indexClienteEquipamento,
                modelo.cliEquipCodigo + "/" + modelo.clienteCodigo
            );
        }

        /**
         * Método que seleciona o array de detalhes do equipamentos e deixa a linha da tabela marcada
         * @param {array} modelo clienteEquipamento
         * @param {number} indexLinhaSelecionada
         */
        function selecionarDetalhesEquipamento(modelo, indexLinhaSelecionada) {
            debugger;
            vm.equipamentosSelecionados = true;
            vm.tabelaDetalhesEquipamentoLinhaSelecionada =
                indexLinhaSelecionada;
            clienteEquipamentoSelecionado = modelo;

            vm.pesquisandoDetalhesEquipamento = true;
            RequisicaoGenericaService.listarSemParams(
                Api.cliente_equipamento_detalhe
                    .listarClienteEquipamentoDetalhePorCodigoClienteEquipamento +
                modelo.clienteCodigo +
                "/" +
                modelo.cliEquipCodigo
            ).then(
                function (success) {
                    vm.detalhesEquipamentoSelecionado = success.data;
                    vm.pesquisandoDetalhesEquipamento = false;
                    abrirDialogDetalhesEquipamento(success.data);
                },
                function (error) {
                    MdDialogService.alertPadrao(error.data, null);
                    vm.pesquisandoDetalhesEquipamento = false;
                }
            );
        }

        /**
         * Método que deselecionar os detalhes do equipamento e desmarcar a linha
         */
        function deselecionarDetalhesEquipamento() {
            vm.equipamentosSelecionados = false;
            vm.tabelaDetalhesEquipamentoLinhaSelecionada = null;
            vm.detalhesEquipamentoSelecionado = [];
        }

        /**
         * Método para abrir dialog Cliente-Equipamento-Detalhes para inserir ou editar um detalhe do equipamento
         * @param {event} event event button
         * * @param {object} modelo detalheEquipamento
         */
        function abrirDialogDetalhesEquipamento(modelo, event) {
            // vm.metodosClienteEquipamentos.selecionarDetalhesEquipamento(modelo);
            $mdDialog
                .show({
                    controller: "ClienteDialogEquipamentosDetalhesController",
                    controllerAs: "vm",
                    templateUrl:
                        vm.htmlRota.cliente.tabEquipamento
                            .dialogClienteEquipamentoDetalhes,
                    //parent: ---------------,
                    targetEvent: event,
                    clickOutsideToClose: false,
                    locals: {
                        DetalhesEquipamentos: vm.detalhesEquipamentoSelecionado,
                        ClienteEquipamentoSelecionado:
                            clienteEquipamentoSelecionado,
                        DetalheEquipamento: modelo,
                    },
                })
                .then(function (success) {
                    pesquisar();
                    vm.equipamentosPorTerceiros.map(function (item) {
                        if (item.equipamentoCodigo == true) return;
                    });
                    vm.totalCadastrado = success.length;
                });
        }

        /**
         * Método para excluir um Detalhe do Equipamento
         * @param {event} event
         * @param {object} modelo
         */
        function excluirClienteEquipamentoDetalhe(event, modelo) {
            var indexClienteEquipamentoDetalhe =
                vm.detalhesEquipamentoSelecionado
                    .map(function (item) {
                        return item.codigo;
                    })
                    .indexOf(modelo.codigo);
            ServicosGenericoService.excluirRegistroPorCodigoOuGenericamente(
                Api.cliente_equipamentos_detalhe.excluir,
                vm.detalhesEquipamentoSelecionado,
                modelo,
                vm.controleForm,
                event,
                "Deseja realmente excluir este Detalhe do Equipamento?",
                null,
                indexClienteEquipamentoDetalhe,
                modelo.codigo +
                "/" +
                modelo.codigoCliente +
                "/" +
                modelo.codigoClienteEquipamento
            );
        }

        /**
         * Método para buscar na Api as pessoas de rederências cadastradas
         * @param {textoDePesquisa} query = ''
         */
        function pesquisarAutoCompletepessoa(query) {
            return ClienteService.pesquisarAutoCompletepessoaService(query);
        }

        /**
         * Método para vincular ao cliente a pessoa de referência selecionada
         * @param {pessoaReferencia} pessoa
         */
        function criarPessoaDeReferencia(pessoa) {
            ClienteService.criarPessoaDeReferenciaService(
                pessoa,
                vm.cliente,
                vm.controleForm,
                vm.controlePreloader
            );
            vm.pessoa = null;
        }

        function criarOuEditarPessoaDeReferencia(event, pessoa) {
            var _configDialog = null;
            // Se for passado uma pessoa como parâmetro será chamado a pesquisa com o codigo da pessoa,
            // se não iniciara o dialog para inserir uma nova pessoa
            if (pessoa)
                _configDialog = {
                    iniciarChamandoPesquisa: true,
                    codigoPessoa: pessoa.codigo,
                };
            else _configDialog = { iniciarChamandoInsercao: true };

            $mdDialog
                .show({
                    templateUrl:
                        vm.htmlRota.cliente.tabPessoaDeReferencia
                            .dialogPessoaDeReferencia,
                    controller: "PessoaController",
                    controllerAs: "vm",
                    //parent: ---------------,
                    targetEvent: event,
                    clickOutsideToClose: false,
                    fullscreen: true,
                    locals: {
                        ListarCargos: RequisicaoGenericaService.listarSemParams(
                            Api.cargo.listarPor
                        ),
                        AbertoPeloDialog: _configDialog,
                        DesabilitaExcluir: true,
                    },
                    onRemoving: function (element, removePromise, $scope) {
                        tabSelecionada(vm.tabSelecionada);
                    },
                })
                .then(function (success) {
                    vm.pessoa = success;
                });
        }

        /**
         * Método para desvincular a pessoa selecionada do cliente
         * @param {eventButton} event
         * @param {pessoa} pessoa
         */
        function excluirPessoaDeReferencia(event, pessoa) {
            ClienteService.excluirPessoaDeReferenciaService(
                pessoa,
                vm.cliente,
                vm.controleForm,
                event,
                vm.controlePreloader
            );
        }

        function abrirWhatsappNovaAba(celular) {
            if (!celular) return;
            var numero = celular.replace(/\D/g, '');

            if (!numero.startsWith("55")) {
                numero = "55" + numero;
            }

            var url = 'https://wa.me/' + numero;
            window.open(url, '_blank');
        }

        function _carregarAtividadesCliente() {
            vm.controleForm.emProgresso = true;

            VisualizarAtividadeService.listarAtividadesCliente(
                vm.cliente.codigo,
                function (success) {
                    vm.atividadesCliente = success.data;
                    vm.controleForm.emProgresso = false;
                },
                function (error) {
                    vm.controleForm.emProgresso = false;
                    console.log(error);
                }
            );
        }

        if ($stateParams.navegacaoDeRelatorioAtendimento) {
            vm.iniciarChamandoPesquisa = true;
            vm.cliente = {
                codigo: $stateParams.navegacaoDeRelatorioAtendimento.cliente
                    .codigo,
            };
        }
    }
})();

//<!-- Ultima mudança 24/03/2017.-->
(function () {
  'use strict';

  angular
    .module('app.geral.cadastro.endereco.cidade', [])
    .config(config);

  function config($stateProvider, RotasHtml) {
      var rotasHtmlCidade = RotasHtml.cidade;
    $stateProvider
      .state('app.geral_cadastro_endereco_cidade', {
        url: '/geral/cadastro/endereco/cidade',
        module: 'privado',
        views: {
          'content@app': {
            templateUrl: rotasHtmlCidade.templateUrl,
            controller: "CidadeController as vm"
          },
          'cidade-form@app.geral_cadastro_endereco_cidade': {
            templateUrl: rotasHtmlCidade.form
          },
          'cidades-tabela@app.geral_cadastro_endereco_cidade': {
            templateUrl: rotasHtmlCidade.tabela
          }
        },
        resolve: {
          ListarTodasUF: function (Api, RequisicaoGenericaService) {
              return RequisicaoGenericaService.listarSemParams(Api.display.listarTodasUf);
          },
          ListarTodosBairros: function (Api, RequisicaoGenericaService) {
            return RequisicaoGenericaService.listarSemParams(Api.endereco.bairro.listarPor);
          }
        }
      });
  }

})();

//<!-- Ultima mudança 24/03/2017.-->
(function () {
    'use strict';

    angular.module('app.geral.cadastro.endereco.cidade')
        .controller('CidadeController', CidadeController);

    function CidadeController(Api, NavegacaoService, RequisicaoGenericaService, DatatableFactory, ListarTodasUF, ListarTodosBairros) {
        var vm = this;
        NavegacaoService.setTituloAba('Endereço Cidade');

        vm.rota = Api.endereco.cidade.proximoCodigo;
        // Data region        
        vm.form = {};

        vm.ufs = ListarTodasUF.data;
        // endregion

        // Definição dos Métodos region    

        vm.metodos = {
            pesquisar: pesquisar,
            salvar: salvar,
            editar: editar,
            excluir: excluir,
            selecionar: selecionar,
            construirDtOptions: construirDtOptions
        }
        //endregion

        // Implementação dos Métodos region

        /**
         * Método chamado quando é clicado no botão inserir da toolbar para pre definir algunas campos
         */
        function preDefinirCamposParaInserir() {
            redefinirCidade();
        }

        /**
         * Método para pesquisar uma cidade
         */
        function pesquisar() {
            return RequisicaoGenericaService.listarComObjetoComplexo(Api.endereco.cidade.listarComPaginacao, vm.entidadeDeEnvio);
        }

        /**
         * Método para salvar uma cidade
         * @param {cidade} cidade 
         */
        function salvar(cidade) {
            return RequisicaoGenericaService.salvar(Api.endereco.cidade.criar, cidade);
        }

        /**
         * Método para editar uma cidade
         * @param {cidade} cidade 
         */
        function editar(cidade) {
            return RequisicaoGenericaService.editar(Api.endereco.cidade.atualizar, cidade)
        }

        /**
         * Método para excluir uma cidade
         * @param {cidade} cidade 
         */
        function excluir(cidade) {
            return RequisicaoGenericaService.excluir(Api.endereco.cidade.excluir, cidade.codigo)
        }

        /**
         * Método utilizado no modo exibido tabela, para selecionar uma cidade
         * @param {cidade} cidade 
         */
        function selecionar(posicaoEntidade) {
            vm.metodosExternosPgToolbar.metodoControladorExternoListarTodasEntidades(null, posicaoEntidade);
        }

        /**
         * Método para construi o DtOptions da tabela
         */
        function construirDtOptions() {
            DatatableFactory.construirDtOptionsComPaginacaoProcessadoNoServidorParaToolbar
                (Api.endereco.cidade.listarComPaginacaoDatatable, vm.entidadeDeEnvio.clsEntidade, '#datatable-endereco-cidade',
                [

                    DatatableFactory.construirColunaDeSelecionarPadrao(function (indexLinha) { vm.metodos.selecionar(indexLinha) }),
                    {
                        targets: 1,
                        name: "Codigo",
                        data: "codigo",
                        defaultContent: "",
                        sortable: false
                    },
                    {
                        targets: 2,
                        name: "Descricao",
                        data: "descricao",
                        defaultContent: "",
                        sortable: false
                    },
                    {
                        targets: 3,
                        name: "UF",
                        data: "uf",
                        defaultContent: "",
                        sortable: false
                    }
                ]);
        }
        //endregion

    }
})();

//<!-- Ultima mudança 28/03/2017.-->
(function () {
    'use strict';

    angular
        .module('app.geral.cadastro.endereco.bairro', [])
        .config(config);

    function config($stateProvider, RotasHtml) {
        var rotasHtmlBairro = RotasHtml.bairro;
        $stateProvider
            .state('app.geral_cadastro_endereco_bairro', {
                url: '/geral/cadastro/endereco/bairro',
                module: 'privado',
                views: {
                    'content@app': {
                        templateUrl: rotasHtmlBairro.templateUrl,
                        controller: "BairroController as vm"
                    },
                    'bairro-form@app.geral_cadastro_endereco_bairro': {
                        templateUrl: rotasHtmlBairro.form
                    },
                    'bairros-tabela@app.geral_cadastro_endereco_bairro': {
                        templateUrl: rotasHtmlBairro.tabela
                    }
                }
            });
    }

})();

/**
 * Created by nova on 24/03/2017.
 */
(function () {
    'use strict';

    angular.module('app.geral.cadastro.endereco.bairro')
        .controller('BairroController', BairroController);

    function BairroController(Api, NavegacaoService, RequisicaoGenericaService, DatatableFactory) {
        var vm = this;
        NavegacaoService.setTituloAba('Endereço bairro');

        // Data region    
        vm.form = {};
        vm.rota = Api.endereco.bairro.proximoCodigo;
        // endregion



        // Definição dos Métodos region
        vm.metodos = {
            pesquisar: pesquisar,
            salvar: salvar,
            editar: editar,
            excluir: excluir,
            selecionar: selecionar,
            construirDtOptions: construirDtOptions
        }
        //endregion

        // Implementação dos Métodos region

        /**
         * Método para pesquisar um bairro
         */
        function pesquisar() {
            return RequisicaoGenericaService.listarComObjetoComplexo(Api.endereco.bairro.listarComPaginacao, vm.entidadeDeEnvio);
        }

        /**
         * Método salvar um bairro
         * @param {bairro} bairro 
         */
        function salvar(bairro) {
            return RequisicaoGenericaService.salvar(Api.endereco.bairro.criar, bairro);
        }

        /**
         * Método para editar um bairro
         * @param {bairro} bairro 
         */
        function editar(bairro) {
            return RequisicaoGenericaService.editar(Api.endereco.bairro.atualizar, bairro)
        }

        /**
         * Método para excluir um bairro
         * @param {bairro} bairro 
         */
        function excluir(bairro) {
            return RequisicaoGenericaService.excluir(Api.endereco.bairro.excluir, bairro.codigo)
        }

        /**
         * Método utilizado no modo exibido tabela, para selecionar um cliente
         * @param {bairro} bairro 
         */
        function selecionar(posicaoEntidade) {
            vm.metodosExternosPgToolbar.metodoControladorExternoListarTodasEntidades(null, posicaoEntidade);
        }

        /**
         * Método para construi o DtOptions da tabela
         */
        function construirDtOptions() {
            DatatableFactory.construirDtOptionsComPaginacaoProcessadoNoServidorParaToolbar
                (Api.endereco.bairro.listarComPaginacaoDatatable, vm.entidadeDeEnvio.clsEntidade, '#datatable-endereco-bairro',
                [

                    DatatableFactory.construirColunaDeSelecionarPadrao(function (indexLinha) { vm.metodos.selecionar(indexLinha) }),
                    {
                        targets: 1,
                        name: "Codigo",
                        data: "codigo",
                        defaultContent: "",
                        sortable: false
                    },
                    {
                        targets: 2,
                        name: "Descricao",
                        data: "descricao",
                        defaultContent: "",
                        sortable: false
                    }
                ]);
        }
        //endregion

    }
})();

//<!-- Ultima mudança 19/07/2017.-->
(function () {
    'use strict';

    angular
        .module('app.geral.cadastro.equipamento.fornecedor', [])
        .config(config);

    function config($stateProvider, RotasHtml) {
        var rotasHtmlCargo = RotasHtml.fornecedor;
        $stateProvider
            .state('app.geral_cadastro_equipamento_fornecedor', {
                url: '/geral/cadastro/fornecedor',
                module: 'privado',
                views: {
                    'content@app': {
                        templateUrl: rotasHtmlCargo.templateUrl,
                        controller: 'FornecedorController as vm'
                    },
                    'fornecedor-form@app.geral_cadastro_equipamento_fornecedor': {
                        templateUrl: rotasHtmlCargo.form
                    },
                    'fornecedores-tabela@app.geral_cadastro_equipamento_fornecedor': {
                        templateUrl: rotasHtmlCargo.tabela
                    }
                }               
            });
    }

})();

//<!-- Ultima mudança 19/07/2017.-->
(function () {
    'use strict';

    angular.module('app.geral.cadastro.equipamento.fornecedor')
        .controller('FornecedorController', FornecedorController);

    function FornecedorController(Api, NavegacaoService, RequisicaoGenericaService, DatatableFactory) {
        var vm = this;
        NavegacaoService.setTituloAba('Equipamento fornecedor');
        
        // Data region    
        vm.form = {};
        // endregion    


        // Definição dos Métodos region
        vm.metodos = {
            pesquisar: pesquisar,
            salvar: salvar,
            editar: editar,
            excluir: excluir,
            selecionar: selecionar,
            construirDtOptions: construirDtOptions
        }
        //endregion

        // Implementação dos Métodos region

        /**
         * Método para pesquisar os fornecedores
         */
        function pesquisar() {
            return RequisicaoGenericaService.listarComObjetoComplexo(Api.fornecedor.listarComPaginacao, vm.entidadeDeEnvio);
        }

        /**
         * Método para salvar um novo equipamento
         * @param {fornecedor} modelo
         */
        function salvar(modelo) {
            return RequisicaoGenericaService.salvar(Api.fornecedor.criar, modelo);
        }

        /**
         * Método para editar um equipamento
         * @param {fornecedor} modelo
         */
        function editar(modelo) {
            return RequisicaoGenericaService.editar(Api.fornecedor.atualizar, modelo)
        }

        /**
         * Método para excluir um equipamento
         * @param {fornecedor} modelo
         */
        function excluir(modelo) {
            return RequisicaoGenericaService.excluir(Api.fornecedor.excluir, modelo.codigo)
        }

        /**
         * Método utilizado no modo exibido tabela, para selecionar um fornecedor
         * @param {fornecedor} modelo
         */
        function selecionar(posicaoEntidade) {
            vm.metodosExternosPgToolbar.metodoControladorExternoListarTodasEntidades(null, posicaoEntidade);
        }

        /**
         * Método para construi o DtOptions da tabela
         */
        function construirDtOptions() {
            DatatableFactory.construirDtOptionsComPaginacaoProcessadoNoServidorParaToolbar
                (Api.fornecedor.listarComPaginacaoDatatable, vm.entidadeDeEnvio.clsEntidade, '#datatable-fornecedor',
                [

                    DatatableFactory.construirColunaDeSelecionarPadrao(function (indexLinha) { vm.metodos.selecionar(indexLinha) }),                    
                    {
                        targets: 1,
                        name: "Descricao",
                        data: "descricao",
                        defaultContent: ""
                    }
                ]);
        }
        //endregion

    }
})();

//<!-- Ultima mudança 28/03/2017.-->
(function () {
    'use strict';

    angular
        .module('app.geral.cadastro.equipamento.equipamentoTipo', [])
        .config(config);

    function config($stateProvider, RotasHtml) {
        var rotasHtmlCargo = RotasHtml.equipamento_tipo;
        $stateProvider
            .state('app.geral_cadastro_equipamento_tipo', {
                url: '/geral/cadastro/equipamento/tipo',
                module: 'privado',
                views: {
                    'content@app': {
                        templateUrl: rotasHtmlCargo.templateUrl,
                        controller: 'EquipamentoTipoController as vm'
                    },
                    'equipamento-tipo-form@app.geral_cadastro_equipamento_tipo': {
                        templateUrl: rotasHtmlCargo.form
                    },
                    'equipamento-tipos-tabela@app.geral_cadastro_equipamento_tipo': {
                        templateUrl: rotasHtmlCargo.tabela
                    }
                }
            });
    }

})();

//<!-- Ultima mudança 13/07/2017.-->
(function () {
    'use strict';

    angular.module('app.geral.cadastro.equipamento.equipamentoTipo')
        .controller('EquipamentoTipoController', EquipamentoTipoController);

    function EquipamentoTipoController(Api,NavegacaoService, RequisicaoGenericaService, DatatableFactory) {
        var vm = this;
        NavegacaoService.setTituloAba('Equipamento tipo');

        // Data region    
        vm.form = {};
        // endregion

        // Definição dos Métodos region
        vm.metodos = {
            pesquisar: pesquisar,
            salvar: salvar,
            editar: editar,
            excluir: excluir,
            selecionar: selecionar,
            construirDtOptions: construirDtOptions
        }
        //endregion

        // Implementação dos Métodos region

        /**
         * Método para pesquisar os cargos
         */
        function pesquisar() {
            return RequisicaoGenericaService.listarComObjetoComplexo(Api.equipamento.equipamento_tipo.listarComPaginacao, vm.entidadeDeEnvio);
        }

        /**
         * Método para salvar um novo cargo
         * @param {equipamentoTipo} modelo
         */
        function salvar(modelo) {
            return RequisicaoGenericaService.salvar(Api.equipamento.equipamento_tipo.criar, modelo);
        }

        /**
         * Método para editar um cargo
         * @param {equipamentoTipo} modelo
         */
        function editar(modelo) {
            return RequisicaoGenericaService.editar(Api.equipamento.equipamento_tipo.atualizar, modelo)
        }

        /**
         * Método para excluir um cargo
         * @param {equipamentoTipo} modelo
         */
        function excluir(modelo) {
            return RequisicaoGenericaService.excluir(Api.equipamento.equipamento_tipo.excluir, modelo.codigo)
        }

        /**
         * Método utilizado no modo exibido tabela, para selecionar um cargo
         * @param {equipamentoTipo} modelo 
         */
        function selecionar(posicaoEntidade) {
            vm.metodosExternosPgToolbar.metodoControladorExternoListarTodasEntidades(null, posicaoEntidade);
        }

        /**
         * Método para construi o DtOptions da tabela
         */
        function construirDtOptions() {
            DatatableFactory.construirDtOptionsComPaginacaoProcessadoNoServidorParaToolbar
                (Api.equipamento.equipamento_tipo.listarComPaginacaoDatatable, vm.entidadeDeEnvio.clsEntidade, '#datatable-equipamento-tipo',
                [

                    DatatableFactory.construirColunaDeSelecionarPadrao(function (indexLinha) { vm.metodos.selecionar(indexLinha) }),                    
                    {
                        targets: 1,
                        name: "Descricao",
                        data: "descricao",
                        defaultContent: ""
                    }
                ]);
        }
        //endregion

    }
})();

//<!-- Ultima mudança 28/03/2017.-->
(function () {
    'use strict';

    angular
        .module('app.geral.cadastro.equipamento.equipamentoFabricante', [])
        .config(config);

    function config($stateProvider, RotasHtml) {
        var rotasHtmlCargo = RotasHtml.equipamento_fabricante;
        $stateProvider
            .state('app.geral_cadastro_equipamento_fabricante', {
                url: '/geral/cadastro/equipamento/fabricante',
                module: 'privado',
                views: {
                    'content@app': {
                        templateUrl: rotasHtmlCargo.templateUrl,
                        controller: 'EquipamentoFabricanteController as vm'
                    },
                    'equipamento-fabricante-form@app.geral_cadastro_equipamento_fabricante': {
                        templateUrl: rotasHtmlCargo.form
                    },
                    'equipamento-fabricantes-tabela@app.geral_cadastro_equipamento_fabricante': {
                        templateUrl: rotasHtmlCargo.tabela
                    }
                }
            });
    }

})();

//<!-- Ultima mudança 13/07/2017.-->
(function () {
    'use strict';

    angular.module('app.geral.cadastro.equipamento.equipamentoFabricante')
        .controller('EquipamentoFabricanteController', EquipamentoFabricanteController);

    function EquipamentoFabricanteController(Api, NavegacaoService, RequisicaoGenericaService, DatatableFactory) {
        var vm = this;
        NavegacaoService.setTituloAba('Equipamento fabricante');

        // Data region    
        vm.form = {};
        // endregion


        // Definição dos Métodos region
        vm.metodos = {
            pesquisar: pesquisar,
            salvar: salvar,
            editar: editar,
            excluir: excluir,
            selecionar: selecionar,
            construirDtOptions: construirDtOptions
        }
        //endregion

        // Implementação dos Métodos region

        /**
         * Método para pesquisar os cargos
         */
        function pesquisar() {
            return RequisicaoGenericaService.listarComObjetoComplexo(Api.equipamento.equipamento_fabricante.listarComPaginacao, vm.entidadeDeEnvio);
        }

        /**
         * Método para salvar um novo cargo
         * @param {equipamentoFabricante} modelo
         */
        function salvar(modelo) {
            return RequisicaoGenericaService.salvar(Api.equipamento.equipamento_fabricante.criar, modelo);
        }

        /**
         * Método para editar um cargo
         * @param {equipamentoFabricante} modelo
         */
        function editar(modelo) {
            return RequisicaoGenericaService.editar(Api.equipamento.equipamento_fabricante.atualizar, modelo)
        }

        /**
         * Método para excluir um cargo
         * @param {equipamentoFabricante} modelo
         */
        function excluir(modelo) {
            return RequisicaoGenericaService.excluir(Api.equipamento.equipamento_fabricante.excluir, modelo.codigo)
        }

        /**
         * Método utilizado no modo exibido tabela, para selecionar um cargo
         * @param {equipamentoFabricante} modelo
         */
        function selecionar(posicaoEntidade) {
            vm.metodosExternosPgToolbar.metodoControladorExternoListarTodasEntidades(null, posicaoEntidade);
        }

        /**
         * Método para construi o DtOptions da tabela
         */
        function construirDtOptions() {
            DatatableFactory.construirDtOptionsComPaginacaoProcessadoNoServidorParaToolbar
                (Api.equipamento.equipamento_fabricante.listarComPaginacaoDatatable, vm.entidadeDeEnvio.clsEntidade, '#datatable-equipamento-fabricante',
                [

                    DatatableFactory.construirColunaDeSelecionarPadrao(function (indexLinha) { vm.metodos.selecionar(indexLinha) }),                  
                    {
                        targets: 1,
                        name: "Descricao",
                        data: "descricao",
                        defaultContent: ""
                    }
                ]);
        }
        //endregion

    }
})();

//<!-- Ultima mudança 13/07/2017.-->
(function () {
    'use strict';

    angular.module('app.geral.cadastro.equipamento.equipamento')
        .controller('EquipamentoController', EquipamentoController);

    function EquipamentoController(Api, NavegacaoService, RequisicaoGenericaService, DatatableFactory, ListarFabricantes, ListarTiposEquipamento) {
        var vm = this;
        NavegacaoService.setTituloAba('Equipamento');

        // Data region    
        vm.form = {};
        // endregion

        // Resolve region
        vm.fabricantes = ListarFabricantes.data;
        vm.tiposEquipamento = ListarTiposEquipamento.data;
        // endregion

        // Definição dos Métodos region
        vm.metodos = {
            pesquisar: pesquisar,
            salvar: salvar,
            editar: editar,
            excluir: excluir,
            selecionar: selecionar,
            construirDtOptions: construirDtOptions,
            configuraMdSelectFabricante: configuraMdSelectFabricante,
            configuraMdSelectTipoEquipamento: configuraMdSelectTipoEquipamento
        }
        //endregion

        // Implementação dos Métodos region

        /**
         * Método para pesquisar os equipamentos
         */
        function pesquisar() {
            return RequisicaoGenericaService.listarComObjetoComplexo(Api.equipamento.listarComPaginacao, vm.entidadeDeEnvio);
        }

        /**
         * Método para salvar um novo equipamento
         * @param {equipamento} modelo
         */
        function salvar(modelo) {
            return RequisicaoGenericaService.salvar(Api.equipamento.criar, modelo);
        }

        /**
         * Método para editar um equipamento
         * @param {equipamento} modelo
         */
        function editar(modelo) {
            return RequisicaoGenericaService.editar(Api.equipamento.atualizar, modelo)
        }

        /**
         * Método para excluir um equipamento
         * @param {equipamento} modelo
         */
        function excluir(modelo) {
            return RequisicaoGenericaService.excluir(Api.equipamento.excluir, modelo.codigo)
        }

        /**
         * Método utilizado no modo exibido tabela, para selecionar um cargo
         * @param {equipamentoFabricante} modelo
         */
        function selecionar(posicaoEntidade) {
            vm.metodosExternosPgToolbar.metodoControladorExternoListarTodasEntidades(null, posicaoEntidade);
        }

        /**
         * Método para construi o DtOptions da tabela
         */
        function construirDtOptions() {
            DatatableFactory.construirDtOptionsComPaginacaoProcessadoNoServidorParaToolbar
                (Api.equipamento.listarComPaginacaoDatatable, vm.entidadeDeEnvio.clsEntidade, '#datatable-equipamento',
                [

                    DatatableFactory.construirColunaDeSelecionarPadrao(function (indexLinha) { vm.metodos.selecionar(indexLinha) }),
                    {
                        targets: 1,
                        name: "CodigoFabricante",
                        data: "fabricante.descricao",
                        defaultContent: ""
                    },
                    {
                        targets: 2,
                        name: "CodigoTipoEquipamento",
                        data: "tipoEquipamento.descricao",
                        defaultContent: ""
                    },
                    {
                        targets: 3,
                        name: "Descricao",
                        data: "descricao",
                        defaultContent: ""
                    }
                ]);
        }

        /**
         * método para configurar md-header do md-select do Fabricante
         */
        function configuraMdSelectFabricante() {
            vm.filtrarFabricantes = "";
            angular.element('#equipamento-fabricante-md-select').on('keydown', function (ev) {
                ev.stopPropagation();
            });
        }

        /**
         * método para configurar md-header do md-select do Tipo Equipamento
         */
        function configuraMdSelectTipoEquipamento() {
            vm.filtrarFabricantes = "";
            angular.element('#equipamento-tipo-equipamento-md-select').on('keydown', function (ev) {
                ev.stopPropagation();
            });
        }
        //endregion

    }
})();

(function () {
    'use strict';

    angular
        .module('app.geral.brainstorming.visualizacaoIdeias', [])
        .config(config);

    function config($stateProvider, RotasHtml) {
        var rotasHtml = RotasHtml.brainstorming.visualizacaoIdeias;
        $stateProvider
            .state('app.geral_brainstorming_visualizacaoideias', {
                url: '/geral/brainstorming/visualizacao-ideias',
                module: 'privado',
                views: {
                    'content@app': {
                        templateUrl: rotasHtml.templateUrl,
                        controller: 'VisualizacaoIdeiasController as vm'
                    },
                    'visualizacao-ideias-form@app.geral_brainstorming_visualizacaoideias': {
                        templateUrl: rotasHtml.form
                    }
                }
            });
    }

})();

(function () {
    'use strict'

    angular
        .module('app.geral.brainstorming.visualizacaoIdeias')
        .controller('VisualizacaoIdeiasStatusController', VisualizacaoIdeiasStatusController);

    function VisualizacaoIdeiasStatusController(
        Api,
        RequisicaoGenericaService,
        Ideia,
        Ideias,
        $mdDialog,
        MdDialogService,
        MdToastService,
        retornaDescricaoStatus,
        LoginUsuarioService
    ) {
        var vm = this;
        vm.requisicaoSolicitada = false;
        vm.ideia = angular.copy(Ideia);
        vm.titulo = "Editar Situação";

        vm.usuarioLogado = LoginUsuarioService.usuarioArmazenado();

        vm.status = [
            { codigo: 1, descricao: "Solicitada" },
            { codigo: 2, descricao: "Análise" },
            { codigo: 3, descricao: "Processada" },
            { codigo: 4, descricao: "Aprovada" },
            { codigo: 5, descricao: "Executada" },
            { codigo: 6, descricao: "Aguardando resposta" }
        ];

        vm.metodosDialog = {
            fecharDialog: fecharDialog,
            salvar: salvar
        }

        function fecharDialog() {
            $mdDialog.hide();
        }

        function salvar(ideia) {
            vm.requisicaoSolicitada = true;
            RequisicaoGenericaService.editar(Api.brainstorming.atualizar, ideia)
                .then(
                    function (success) {
                        vm.requisicaoSolicitada = false;
                        MdToastService.toastPadrao("Status cadastrado com sucesso!");
                        angular.forEach(Ideias, function (ideia, index) {
                            if (ideia.numero === success.data.numero && ideia.ano === success.data.ano) {
                                success.data.descricaoStatus = retornaDescricaoStatus(success.data);
                                Ideias[index] = success.data;
                            }
                        });
                        $mdDialog.hide();
                    },
                    function (error) {
                        vm.requisicaoSolicitada = false;
                        MdDialogService.alertPadrao(error.data);
                        $mdDialog.hide();
                    }
                );
        }
    }

})();
(function () {
    'use strict';
    angular
        .module('app.atendimento.estatisticas.tags')
        .service('EstatisticaTagsService', EstatisticaTagsService)
    /** @ngInject */
    function EstatisticaTagsService(RequisicaoGenericaService, Api, $mdSidenav) {
        var _filtro;
        var _pendingCallback = null;
        var service = {
            toggleFiltro: toggleFiltro,
            setFiltro: setFiltro,
            getFiltro: getFiltro,
            filtrarDadosDashboard: filtrarDadosDashboard,
            setListener: setListener,
            invokeListener: invokeListener,
            closeFiltroIfOpen: closeFiltroIfOpen
        }

        function toggleFiltro() {
            $mdSidenav('filtro-estatisticas-tags').toggle();
        }

        function setFiltro(filtro) {
            _filtro = filtro;
        }

        function getFiltro() {
            return angular.copy(_filtro);
        }

        function filtrarDadosDashboard(filtro) {
            setFiltro(filtro);
            return RequisicaoGenericaService.listarComObjetoComplexo(Api.atendimento.estatisticas_atendimento.tags.listarEstatisticasTags, filtro);
        }

        function setListener(fn) {
            service.listener = fn;
            if (_pendingCallback && typeof fn === 'function') {
                try { fn(_pendingCallback); } finally { _pendingCallback = null; }
            }
        }

        function invokeListener(cb) {
            if (typeof service.listener === 'function') {
                service.listener(cb);
            } else {
                _pendingCallback = cb;
            }
        }

        function closeFiltroIfOpen() {
            var sidenav = $mdSidenav('filtro-estatisticas-tags');
            if (sidenav.isOpen()) {
                sidenav.close();
            }
        }

        return service;
    }
})();

(function () {
    'use strict';

    angular.module('app.atendimento.processamento.atendimento')
        .controller('DialogCadastroTagAtendimentoController', DialogCadastroTagAtendimentoController);

    function DialogCadastroTagAtendimentoController(ListarDetalhesUsuarioESolucoes, DialogCadastro, CodigoSolucaoSelecionada, DescricaoSugerida, Api, NavegacaoService, RequisicaoGenericaService, ListarCoresTagsAtendimento, $mdDialog) {
        var vm = this;
        NavegacaoService.setTituloAba('Tag de atendimento');
        vm.codigoSolucaoSelecionada = CodigoSolucaoSelecionada
        vm.form = {};
        vm.corIdentificacao = null;
        vm.corSelecionada = null;
        vm.listaSolucoes = ListarDetalhesUsuarioESolucoes.solucoes;
        vm.dialogCadastroTags = DialogCadastro
        vm.cores = ListarCoresTagsAtendimento;
        vm.houveAlteracao = false;

        vm.metodos = {
            pesquisar: pesquisar,
            salvar: salvar,
            editar: editar,
            excluir: excluir,
            selecionarCor: selecionarCor,
            configuraMdSelectSolucoes: configuraMdSelectSolucoes,
            fecharDialog: fecharDialog
        }

        vm.metodosGeral = {
            preDefinirCamposParaInserir: preDefinirCamposParaInserir,
        };

        function configuraMdSelectSolucoes() {
            vm.filtrarSolucoes = "";
            angular.element('#solucoes-md-select').on('keydown', function (ev) {
                ev.stopPropagation();
            });
        }

        function preDefinirCamposParaInserir() {
            vm.tagAtendimento = {};
            vm.tagAtendimento.ativa = true;
            if (DescricaoSugerida) vm.tagAtendimento.descricao = DescricaoSugerida;
            if (vm.codigoSolucaoSelecionada) {
                var solucao = vm.listaSolucoes.find(function (solucao) {
                    return solucao.codigo === vm.codigoSolucaoSelecionada;
                });
                if (solucao) {
                    vm.tagAtendimento.solucoes = [solucao.codigo];
                }
            }
        }

        function selecionarCor(cor) {
            vm.corSelecionada = cor.fonte;
            const formField = vm.form.tagAtendimento.corIdentificacao;
            if (formField) {
                formField.$setViewValue(cor.background);
                formField.$render();
            }
        }

        function pesquisar() {
            if (vm.entidadeDeEnvio.clsEntidade && vm.entidadeDeEnvio.clsEntidade.solucoes && vm.entidadeDeEnvio.clsEntidade.solucoes.length === 0) {
                delete vm.entidadeDeEnvio.clsEntidade.solucoes;
            };
            return RequisicaoGenericaService.listarComObjetoComplexo(Api.atendimento.tag.listarComPaginacao, vm.entidadeDeEnvio);
        }

        function salvar(modelo) {
            vm.houveAlteracao = true;
            return RequisicaoGenericaService.salvar(Api.atendimento.tag.criar, modelo);
        }

        function editar(modelo) {
            vm.houveAlteracao = true;
            return RequisicaoGenericaService.editar(Api.atendimento.tag.atualizar, modelo);
        }

        function excluir(modelo) {
            vm.houveAlteracao = true;
            return RequisicaoGenericaService.excluir(Api.atendimento.tag.excluir, modelo.codigo);
        }

        function fecharDialog() {
            $mdDialog.hide(vm.houveAlteracao);
        }
    }
})();

/**
 * Created by nova on 20/07/2016.
 */
(function () {
    'use strict';

    angular
        .module('app.agenda.processamento.visualizarAtividades')
        .service("VisualizarAtividadeService", VisualizarAtividadeService);

    function VisualizarAtividadeService($mdDialog, RotasHtml, MdDialogService, LoginUsuarioService, Api, RequisicaoGenericaService) {
        this.abrirCadastroAtividade = function (event, atividade, listaEventos, listaStatus, clonando, desabilitarCampos, cliente) {

            var codigousuarioLogado = LoginUsuarioService.usuarioArmazenado().codigo;
            if (atividade.usuarioAtivo.codigo != codigousuarioLogado) {
                MdDialogService.alertPadrao('Atenção', event, "Não é possível inserir atividade pois o usuário selecionado é diferente do logado!");
                return;
            }

            if (atividade.atendimento && atividade.atendimento.status == 2) {
                MdDialogService.alertPadrao('Atenção', event, "Não é possível inserir atividade pois o atendimento está finalizado!");
                return;
            }

            $mdDialog.show({
                controller: 'AtividadeController',
                controllerAs: 'vm',
                templateUrl: 'app/main/agenda/processamento/visualizar-atividades/dialogs/dialog-cadastro-atividade/dialog-cadastro-atividades.html',
                targetEvent: event,
                clickOutsideToClose: true,
                multiple: true,
                locals: {
                    Cliente: cliente,
                    DesabilitarAtendimento: atividade.atendimento != null
                },
                resolve: {
                    ListarTodosEventos: function () { return listaEventos },
                    ListarStatus: function () { return listaStatus },
                    Atividade: function () { return angular.copy(atividade) },
                    Clonando: function () { return clonando },
                    DesabilitarCampos: function () { return desabilitarCampos }
                }
            });
        }


        this.abrirDialogAtividade = function (event, cliente, listaStatus, listarTodosEventos, listarAtividadesPorUsuario, atendimento, executaAoAbrir, listarDetalhesUsuario) {
            $mdDialog.show({
                controller: 'VisualizarAtividadesController',
                controllerAs: 'vm',
                templateUrl: RotasHtml.agenda.atividade.dialogs.dialogAtividade,
                //parent: ---------------,
                targetEvent: event,
                clickOutsideToClose: true,
                mdIsFullscreen: 'xs,sm,md',
                multiple: true,
                onComplete: function (element, callback) {
                    if (executaAoAbrir)
                        executaAoAbrir();
                },
                locals: {
                    parametros: {
                        cliente: cliente,
                        atendimento: atendimento
                    },
                    ListarTodosUsuarios: RequisicaoGenericaService.listarSemParams(Api.usuario.detalhes_usuario.listarUsuariosAtivos),
                    ListarAtividadesPorCliente: listarAtividadesPorUsuario,
                    ListarAtividadesPorUsuario: null,
                    ListarStatus: listaStatus,
                    ListarTodosEventos: listarTodosEventos,
                    ListarDetalhesUsuario: listarDetalhesUsuario
                }
            });
        }

        this.listarAtividadesCliente = function (codigoCliente, resultSuccess, resultError) {
            const mesAtual = new Date().getMonth() + 1;
            const anoAtual = new Date().getFullYear();
            RequisicaoGenericaService
                .listarSemParams(Api.agenda.atividade.listarAtividadesPorCliente + '?codigoCliente=' + codigoCliente + '&mes=' + mesAtual + '&ano=' + anoAtual)
                .then(function (success) {
                    resultSuccess(success);
                }, function (error) {
                    resultError(error);
                })
        }

        this.abrirCadastroAtividadeObrigatorio = function (event, atividade, listaEventos, listaStatus, cliente) {
            var codigousuarioLogado = LoginUsuarioService.usuarioArmazenado().codigo;
            if (atividade.usuarioAtivo.codigo != codigousuarioLogado) {
                MdDialogService.alertPadrao('Atenção', event, "Não é possível inserir atividade pois o usuário selecionado é diferente do logado!");
                return;
            }

            if (atividade.atendimento && atividade.atendimento.status == 2) {
                MdDialogService.alertPadrao('Atenção', event, "Não é possível inserir atividade pois o atendimento está finalizado!");
                return;
            }

            $mdDialog.show({
                controller: 'AtividadeController',
                controllerAs: 'vm',
                templateUrl: 'app/main/agenda/processamento/visualizar-atividades/dialogs/dialog-cadastro-atividade/dialog-cadastro-atividades.html',
                targetEvent: event,
                clickOutsideToClose: false,
                escapeToClose: false,
                multiple: true,
                locals: {
                    Cliente: cliente,
                    DesabilitarAtendimento: atividade.atendimento != null,
                    ForcarCadastro: true
                },
                resolve: {
                    ListarTodosEventos: function () { return listaEventos },
                    ListarStatus: function () { return listaStatus },
                    Atividade: function () { return angular.copy(atividade) },
                    Clonando: function () { return false },
                    DesabilitarCampos: function () { return false }
                }
            });
        }

        return {
            abrirCadastroAtividade: this.abrirCadastroAtividade,
            abrirDialogAtividade: this.abrirDialogAtividade,
            listarAtividadesCliente: this.listarAtividadesCliente,
            abrirCadastroAtividadeObrigatorio: this.abrirCadastroAtividadeObrigatorio
        };

    } // ArquivosService

})();

(function () {
    'use strict';

    angular
        .module('app.trabalheconosco.cadastro.habilidade', [])
        .config(Config);

    function Config($stateProvider, RotasHtml) {
        var rotasHtml = RotasHtml.trabalheConoscoCadastroHabilidade;
        $stateProvider
            .state('app.trabalheconosco_cadastro_habilidade', {
                url: '/trabalheconosco/cadastro/habilidade',
                module: 'privado',
                params: {
                    parametros: null
                },
                views: {
                    'content@app': {
                        templateUrl: rotasHtml.templateUrl,
                        controller: 'TrabalheConoscoHabilidadeController as vm'
                    },
                    'trabalhe-conosco-habilidade-form@app.trabalheconosco_cadastro_habilidade': {
                        templateUrl: rotasHtml.form
                    },
                    'trabalhe-conosco-habilidades-tabela@app.trabalheconosco_cadastro_habilidade': {
                        templateUrl: rotasHtml.tabela
                    }
                },
                resolve: {
                    ListarIdiomas: function (Api, RequisicaoGenericaService) {
                        return RequisicaoGenericaService.listarSemParams(Api.display.idioma);
                    },
                    ListarNivelIdiomas: function (Api, RequisicaoGenericaService) {
                        return RequisicaoGenericaService.listarSemParams(Api.display.nivelIdioma);
                    }            
                }
            });
    }

})();

/**
 * Created by nova on 24/03/2017.
 */
(function () {
    'use strict';

    angular.module('app.trabalheconosco.cadastro.habilidade')
        .controller('TrabalheConoscoCategoriaController', TrabalheConoscoCategoriaController);

    function TrabalheConoscoCategoriaController(Api, RequisicaoGenericaService,
        DatatableFactory,
        MdDialogService,
        ArquivosService,
        ListarTodosSetores, NavegacaoService,
        MdToastService,
        RotasHtml,
        $scope,
        ServicosGenericoService,
        $q) {
        var vm = this;
        NavegacaoService.setTituloAba('Trabalhe conosco categoria');

        vm.habilidadeSelecionada = null;

        vm.habilidadeAdicionada = {
            codigoHabilidade: null,
            descricao: ""
        };

        //#region Data
        vm.htmlRota = RotasHtml.trabalheConoscoCadastroCategoria;
        var rotas = Api.trabalhe_conosco.categoria;
        vm.form = {};

        vm.tabSelecionada = "categoria";
        vm.controleCategoria = {
            controladorHabildadesCategoria: false
        }

        var _eventoArquivoFotoDivulgacao = null,
            _eventoArquivoFotoIcone = null;

        _init();
        //#endregion

        //#region  Definição dos Métodos region
        vm.metodosGeral = {
            tabSelecionada: tabSelecionada,
        }

        vm.metodos = {
            novaPesquisa: novaPesquisa,
            preDefinirCamposParaEdicao: preDefinirCamposParaEdicao,
            preDefinirCamposParaInsercao: preDefinirCamposParaInsercao,
            pesquisar: pesquisar,
            salvar: salvar,
            editar: editar,
            excluir: excluir,
            selecionar: selecionar,
            construirDtOptions: construirDtOptions,
            selecionarArquivoFotoDivulgacao: selecionarArquivoFotoDivulgacao,
            selecionarArquivoFotoIcone: selecionarArquivoFotoIcone
        }

        vm.metodosHabilidade = {
            configuraAutoCompleteHabilidadeOnBlur: configuraAutoCompleteHabilidadeOnBlur,
            alterarItemSelecionadoAutoCompleteHabilidade: alterarItemSelecionadoAutoCompleteHabilidade,
            pesquisarAutoCompleteHabilidade: pesquisarAutoCompleteHabilidade,
            adicionarHabilidadeCategoria: adicionarHabilidadeCategoria,
            excluirHabilidade: excluirHabilidade,
            verificaHabilidadeInserida: verificaHabilidadeInserida
        }

        var metodosInternos = {
            _init: _init,
            _redefinirEventosSelecaoImagem: _redefinirEventosSelecaoImagem
        }

        //#endregion       

        //#region Métodos Internos      

        function _init() {
            //vm.controleForm = {};
            vm.categoria = {};
            vm.categorias = [];

            vm.setores = ListarTodosSetores.data;

            vm.controladorBotaoAdicionar = true;
        }

        function _redefinirEventosSelecaoImagem() {
            if (_eventoArquivoFotoDivulgacao)
                _eventoArquivoFotoDivulgacao.target.value = "";
            if (_eventoArquivoFotoIcone)
                _eventoArquivoFotoIcone.target.value = "";
        }

        //#endregion

        // Configurações Datatable region
        vm.dtOptionsLog = {
            dom: 'rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
            initComplete: function () {
                var api = this.api(),
                    searchBox = angular.element('body').find('#pesquisar');

                if (searchBox.length > 0) {
                    searchBox.on('keyup', function (event) {
                        api.search(event.target.value).draw();
                    });
                }
            },
            pagingType: 'numbers',
            lengthMenu: [100],
            pageLength: 100,
            responsive: true,
            order: [],
            columnDefs: [
                {
                    responsivePriority: 1, targets: [0],
                    searchable: false,
                    orderable: false
                }
            ]
        };

        //#endregion

        /**
          * Watch que fica escutando o objeto 'vm.area' e se o novo valor inserido neste objeto for vazio
          * é chamado o método 'tabSelecionada('areaAtuacao')' para voltar para a tab inicial 'colaborador'
          */
        $scope.$watch('vm.categoria', function (newValue, oldValue) {
            if (angular.equals({}, newValue))
                vm.metodosGeral.tabSelecionada('categoria');
            else {
                vm.metodosGeral.tabSelecionada(vm.tabSelecionada);
            }
        });


        //#region Métodos
        /**
                 * Método que é chamado sempre quando ocorre uma transição de tab
                 * @param {tab} tab 
                 */
        function tabSelecionada(tab) {
            vm.tabSelecionada = tab;
            if (tab !== 'categoria') {
                if (angular.isDefined(vm.controleForm)) {
                    vm.controleForm.desabilitarButtonEditar = true;
                    vm.controleForm.desabilitarButtonInserir = true;
                    vm.controleForm.desabilitarButtonExcluir = true;
                    vm.controleForm.desabilitarButtonListarTodos = true;
                    vm.controleForm.desabilitarMetodoToolbarAtualizar = true;
                }
            } else {
                if (angular.isDefined(vm.controleForm)) {
                    vm.controleForm.desabilitarButtonEditar = false;
                    vm.controleForm.desabilitarButtonInserir = false;
                    vm.controleForm.desabilitarButtonExcluir = false;
                    vm.controleForm.desabilitarButtonListarTodos = false;
                    vm.controleForm.desabilitarMetodoToolbarAtualizar = false;
                }
            }
        }

        function novaPesquisa() {
            _redefinirEventosSelecaoImagem();
        }

        function preDefinirCamposParaEdicao() {
            vm.form.$setDirty();
        }

        function preDefinirCamposParaInsercao() {
            _redefinirEventosSelecaoImagem();
            vm.categoria = {};
            vm.categoria.ativo = true;
        }

        function pesquisar() {
            vm.habilidadeAdicionada.codigoHabilidade = null;
            vm.habilidadeAdicionada.descricao = "";
            vm.habilidadeAdicionada.peso = 0;
            if (vm.textoDePesquisaAutoCompleteHabilidade)
                vm.textoDePesquisaAutoCompleteHabilidade = "";
            return RequisicaoGenericaService.listarComObjetoComplexo(rotas.listarComPaginacao, vm.entidadeDeEnvio);
        }

        function salvar(modelo) {
            return RequisicaoGenericaService.salvar(rotas.criar, modelo);
        }

        function editar(modelo) {
            //return RequisicaoGenericaService.editar(rotas.atualizar, modelo)
            var deferred = $q.defer();
            RequisicaoGenericaService.editar(rotas.atualizar, modelo).then(
                function (success) {
                    deferred.resolve(success);
                },
                function (error) {
                    _limpaCampoHabilidade();
                    deferred.reject(error);
                    MdDialogService.alertPadrao("Atenção",
                        null,
                        error.data);
                });
            return deferred.promise;
        }

        function excluir(modelo) {
            if (modelo.usuariosVinculados) {
                MdDialogService.alertPadrao("Atenção",
                    null,
                    "Categoria vinculada a um ou mais colaboradores.")
            }
            else {

                if (modelo.areasAtuacaoVinculadas) {
                    MdDialogService.confirmPadraoComEvento("Atenção",
                        "Existem uma ou mais áreas de atuação vinculadas a essa categoria. Ao prosseguir elas serão excluídas.<br/>Deseja realmente excluir o registro ?",
                        event,
                        function () {
                            vm.controleForm.emProgresso = true;
                            return RequisicaoGenericaService.excluir(rotas.excluir, modelo.codigo).then(
                                function (success) {
                                    vm.controleForm.emProgresso = false; vm.categoria = {};
                                    return success;
                                },
                                function (error) {
                                    vm.controleForm.emProgresso = false; vm.categoria = {};
                                    MdDialogService.alertPadrao(error.data, null);
                                });
                        });
                }
                else {
                    return RequisicaoGenericaService.excluir(rotas.excluir, modelo.codigo);
                }
            }
        }

        function selecionar(posicaoEntidade) {
            vm.metodosExternosPgToolbar.metodoControladorExternoListarTodasEntidades(null, posicaoEntidade);
        }

        function construirDtOptions() {
            DatatableFactory.construirDtOptionsComPaginacaoProcessadoNoServidorParaToolbar
                (rotas.listarComPaginacaoDatatable, vm.entidadeDeEnvio.clsEntidade, '#datatable-trabalheconosco-cadastro-categoria',
                    [
                        DatatableFactory.construirColunaDeSelecionarPadrao(function (indexLinha) { vm.metodos.selecionar(indexLinha) }),
                        {
                            targets: 1,
                            name: "Titulo",
                            data: "titulo",
                            defaultContent: ""
                        },
                        {
                            targets: 2,
                            name: "SetorCodigo",
                            data: "setor.descricao",
                            defaultContent: ""
                        },
                    ]);
        }

        function selecionarArquivoFotoDivulgacao(event, arquivos) {
            _eventoArquivoFotoDivulgacao = event;

            if (arquivos && arquivos.length > 0) {
                ArquivosService.obterArquivo(arquivos[0]).then(
                    function (success) {
                        if (success.tipoArquivo != 'image/jpeg' &&
                            success.tipoArquivo != 'image/png') {
                            MdDialogService.alertPadrao("Formato inválido.",
                                null)
                        }
                        else {
                            vm.categoria.imagemFotoDivulgacao = {
                                base64StringArquivo: success.base64StringArquivo,
                                nomeArquivo: success.nomeArquivo,
                                tipoArquivo: success.tipoArquivo
                            }
                        }
                    },
                    function (error) {
                        vm.categoria.imagemFotoDivulgacao = null;
                        MdDialogService.alertPadrao(error);
                    });
            }
            else {
                vm.categoria.imagemFotoDivulgacao = null;
            }
        }

        function selecionarArquivoFotoIcone(event, arquivos) {
            _eventoArquivoFotoIcone = event;

            if (arquivos && arquivos.length > 0) {
                ArquivosService.obterArquivo(arquivos[0]).then(
                    function (success) {
                        vm.categoria.imagemFotoIcone = {
                            base64StringArquivo: success.base64StringArquivo,
                            nomeArquivo: success.nomeArquivo,
                            tipoArquivo: success.tipoArquivo
                        }
                    },
                    function (error) {
                        vm.categoria.imagemFotoIcone = null;
                        MdDialogService.alertPadrao(error);
                    });
            }
            else {
                vm.categoria.imagemFotoIcone = null;
            }
        }
        //#endregion

        /**
          * Método que limpa o texto de pesquisa do md-auto-complete da Habilidade
          */
        function configuraAutoCompleteHabilidadeOnBlur() {
            if (!vm.categoria.habilidades) {
                vm.textoDePesquisaAutoCompleteHabilidade = "";
            }
        }

        /**
          * Método que controla qual habilidade está selecionada no campo md-auto-complete da Habilidade
          * @param {object} item 
          */
        function alterarItemSelecionadoAutoCompleteHabilidade(item) {
            if (item && item != null) {
                if (item.codigo) {
                    vm.habilidadeAdicionada.codigoHabilidade = item.codigo;
                    vm.habilidadeAdicionada.descricao = item.descricao;

                    vm.novaHabilidade = {
                        codigoHabilidade: item.codigo,
                        descricao: item.descricao,
                        flag: "I"
                    };
                }
            } else {
                if (vm.novaHabilidade) {
                    vm.novaHabilidade.codigoHabilidade = null;
                    vm.novaHabilidade.descricao = "";
                    vm.novaHabilidade.flag = "";
                }
                //vm.textoDePesquisaAutoCompleteHabilidade = "";
            }
        }

        /**
          * Método que realiza uma requisição para api para buscar as habilidades em tempo de excução, * com base no que o usuário está digitando
          * @param {string} query 
          */
        function pesquisarAutoCompleteHabilidade(query) {
            return ServicosGenericoService.pesquisarAutoCompleteDescricaoGenericoApi(Api.trabalhe_conosco.habilidade.listarPor, query);
        }

        function adicionarHabilidadeCategoria() {

            if (vm.novaHabilidade && vm.novaHabilidade.flag === "I") {
                if (verificaHabilidadeInserida(vm.novaHabilidade.codigoHabilidade) == false) {
                    vm.categoria.habilidades.push(vm.novaHabilidade);

                    vm.controleForm.emProgresso = true;
                    vm.controladorBotaoAdicionar = false;
                    editar(vm.categoria).then(
                        function (success) {
                            vm.categoria.habilidades = success.data.habilidades;
                            _limpaCampoHabilidade();
                        },
                        function (error) {
                            vm.controleForm.emProgresso = false;
                        }
                    );
                } else {
                    MdDialogService.alertPadrao("Atenção",
                        null,
                        "Habilidade já inserida.")
                }
            }
        }

        function excluirHabilidade(habilidade) {
            vm.habilidadeSelecionada = habilidade;
            habilidade.flag = "D";

            preDefinirCamposParaEdicao();

            var habilidadesBkp = [].concat(vm.categoria.habilidades);

            vm.controleForm.emProgresso = true;
            editar(vm.categoria).then(
                function (success) {
                    for (var i = habilidadesBkp.length - 1; i >= 0; i--) {
                        if (habilidadesBkp[i].flag === 'D') {
                            habilidadesBkp.splice(i, 1);
                        }
                    }
                    vm.categoria.habilidades = success.data.habilidades;
                    vm.controleForm.emProgresso = false;
                },
                function (eror) {
                    vm.controleForm.emProgresso = false;
                });
        }

        function verificaHabilidadeInserida(habilidadeCodigo) {
            if (vm.categoria.habilidades) {
                return vm.categoria.habilidades.some(function (item) {
                    return ((habilidadeCodigo) == (item.codigoHabilidade));
                });
            }
            else
                return false;

        }


        function _limpaCampoHabilidade() {

            if (vm.habilidadeSelecionada)
                vm.habilidadeSelecionada.flag = "";

            vm.controleForm.emProgresso = false;
            vm.controladorBotaoAdicionar = true;
            vm.habilidadeAdicionada.codigoHabilidade = null;
            vm.habilidadeAdicionada.descricao = "";
            if (vm.novaHabilidade) {
                vm.novaHabilidade.codigoHabilidade = null;
                vm.novaHabilidade.descricao = "";
                vm.novaHabilidade.flag = "";
            }
            vm.form.habilidade.$setUntouched();
            vm.form.habilidade.$setPristine();
        }

    }
})();

(function () {
    'use strict';

    angular
        .module('app.trabalheconosco.processamento.curriculo')
        .controller(
            'ProcessamentoCurriculoController',
            ProcessamentoCurriculoController
        );

    function ProcessamentoCurriculoController(
        $scope,
        RotasHtml,
        LoginUsuarioService,
        ListarAreasAtuacao,
        Api,
        RequisicaoGenericaService,
        MdDialogService,
        NavegacaoService,
        $window,
        $mdDialog,
        $filter,
        MdToastService,
        urlApi,
        ListarCategorias
    ) {
        NavegacaoService.setTituloAba('Trabalhe currículo');

        var vm = this;

        vm.form = {};
        vm.rotasHtml = RotasHtml.processamentoCurriculo;
        vm.requisicaoSolicitada = false;
        vm.pesquisaAtiva = false;
        vm.ordenacao = {
            areaAtuacaoTitulo: '',
            candidatoNome: '',
            candidatoCidade: ''
        };

        // Configurações Datatable region
        vm.dtOptionsLog = {
            dom: 'rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
            initComplete: function () {
                var api = this.api(),
                    searchBox = angular.element('body').find('#pesquisar');

                if (searchBox.length > 0) {
                    searchBox.on('keyup', function (event) {
                        api.search(event.target.value).draw();
                    });
                }
            },
            scrollY: 'auto',
            pagingType: 'numbers',
            lengthMenu: [100],
            pageLength: 100,
            responsive: true,
            order: [],
            columnDefs: [
                {
                    responsivePriority: 1,
                    targets: [7, 8],
                    searchable: false,
                    orderable: false
                },
                {
                    targets: 2,
                    name: 'CandidatoDataNascimento',
                    data: 'candidatoDataNascimento',
                    type: 'date-pt-br',
                    defaultContent: '',
                    render: function (data) {
                        return $filter('date')(data, 'dd/MM/yyyy');
                    },
                    sortable: true
                },
                {
                    targets: 6,
                    name: 'CandidatoDataInclusaoCurriculo',
                    data: 'candidatoDataInclusaoCurriculo',
                    type: 'date-pt-br',
                    defaultContent: '',
                    render: function (data) {
                        return $filter('date')(data, 'dd/MM/yyyy');
                    },
                    sortable: true
                }
            ]
        };

        vm.metodos = {
            BuscarCurriculos: BuscarCurriculos,
            visualizarCurriculo: visualizarCurriculo,
            novaConsulta: novaConsulta,
            abrirLinkedin: abrirLinkedin,
            visualizarHabilidades: visualizarHabilidades,
            ordenarPor: ordenarPor,
            formataTelefone: formataTelefone
        };

        vm.metodos.internos = {
            inicializaListaCategoriasSelecionadas: _inicializaListaCategoriasSelecionadas,
            inicializaListaAreasSelecionadas: _inicializaListaAreasSelecionadas,

            verificaCategoriaSelecionada: _verificaCategoriaSelecionada,
            retornaCategoriaSelecionada: _retornaCategoriaSelecionada,
            retornaCategoriaDesmarcada: _retornaCategoriaDesmarcada,
            removeCategoriaSelecionada: _removeCategoriaSelecionada,

            retornaAreaSelecionada: _retornaAreaSelecionada,
            retornaAreaDesmarcada: _retornaAreaDesmarcada,

            verificaSeExisteAreaAtuacaoNaLista: _verificaSeExisteAreaAtuacaoNaLista,
            insereAreaAtuacaoNaLista: _insereAreaAtuacaoNaLista,
            removeAreaAtuacaoNaLista: _removeAreaAtuacaoNaLista,
            removeAreasAtuacaoCategoria: _removeAreasAtuacaoCategoria,

            verificaSeExisteCidadeNaLista: _verificaSeExisteCidadeNaLista,
            insereCidadeNaLista: _insereCidadeNaLista,
            removeCidadeNalista: _removeCidadeNaLista,
            verificaAreaAtuacaoMesmaCidade: _verificaAreaAtuacaoMesmaCidade,

            preparaFiltroParaEnvio: preparaFiltroParaEnvio,
            formatarFiltroCategoria: _formatarFiltroCategoria,
            formatarFiltroAreaAtuacao: _formatarFiltroAreaAtuacao,
            formatarFiltroCidade: _formatarFiltroCidade
        };

        init();

        /**
         * Método inicilizador
         */
        function init() {
            vm.consultaCurriculo = {
                codigoUsuarioCorrente: LoginUsuarioService.usuarioArmazenado().codigo
            };

            vm.categoriasSelecionadas = [];
            vm.areasSelecionadas = [];
            vm.categorias = [];
            vm.areas = [];
            vm.cidades = [];

            vm.filtro = {
                categorias: [],
                cidades: [],
                areas: []
            };

            listarCategoriasPorUsuario(
                LoginUsuarioService.usuarioArmazenado().codigo
            );

            /*vm.categorias = ListarCategorias.data;
      
                  vm.areasTodas = ListarAreasAtuacao.data;
                  vm.areas = [].concat(vm.areasTodas);
      
                  vm.cidades = [];
      
                  for (var i = vm.areas.length - 1; i >= 0; i--) {
                      _insereCidadeNaLista(vm.areas[i].cidade);
                  }
      
                  vm.cidadesTodas = [].concat(vm.cidades);*/
        }

        $scope.$watch('vm.filtro.categorias', function (newValue, oldValue) {
            _inicializaListaCategoriasSelecionadas();

            if (newValue != null) {
                var categoriaSelecionada = null;
                if (newValue.length > 0) {
                    categoriaSelecionada = _retornaCategoriaSelecionada(newValue);

                    if (categoriaSelecionada != null) {
                        for (var i = vm.areasTodas.length - 1; i >= 0; i--) {
                            if (
                                vm.areasTodas[i].categoriaCodigo === categoriaSelecionada.codigo
                            ) {
                                _insereAreaAtuacaoNaLista(vm.areasTodas[i]);
                            } else {
                                _removeAreaAtuacaoNaLista(vm.areasTodas[i]);
                            }
                        }
                    } else {
                        var categoriaDesmarcada = _retornaCategoriaDesmarcada(newValue);
                        _removeAreasAtuacaoCategoria(categoriaDesmarcada);
                        _removeCategoriaSelecionada(categoriaDesmarcada);
                    }
                } else {
                    vm.areas = [].concat(vm.areasTodas);
                }
            } else if (oldValue != null) {
                if (oldValue.length > 0) {
                    _removeAreasAtuacaoCategoria(oldValue[0]);
                    _removeCategoriaSelecionada(oldValue[0]);
                }
            }
        });

        $scope.$watch('vm.filtro.areas', function (newValue, oldValue) {
            _inicializaListaAreasSelecionadas();

            if (newValue != null) {
                var areaSelecionada = null;
                if (newValue.length > 0) {
                    areaSelecionada = _retornaAreaSelecionada(newValue);

                    if (areaSelecionada != null) {
                        for (var i = vm.cidadesTodas.length - 1; i >= 0; i--) {
                            if (vm.cidadesTodas[i].codigo === areaSelecionada.cidade.codigo) {
                                _insereCidadeNaLista(vm.cidadesTodas[i]);
                            } else {
                                _removeCidadeNaLista(vm.cidadesTodas[i].codigo);
                            }
                        }
                    } else {
                        var areaDesmarcada = _retornaAreaDesmarcada(newValue);
                        _removeCidadeNaLista(areaDesmarcada.cidade.codigo);
                    }
                } else {
                    vm.cidades = [].concat(vm.cidadesTodas);
                }
            } else if (oldValue != null) {
                if (oldValue.length > 0) {
                    _removeCidadeNaLista(oldValue[0]);
                }
            }
        });

        /**
         * Método para listar as características que o cliente possui
         */
        function listarCategoriasPorUsuario(usuarioCodigo) {
            RequisicaoGenericaService.listarSemParams(
                Api.trabalhe_conosco.categoria.listarCategoriasUsuario + usuarioCodigo
            ).then(
                function (success) {
                    vm.categorias = success.data;
                    vm.areasTodas = [];
                    for (var i = vm.categorias.length - 1; i >= 0; i--) {
                        for (
                            var j = vm.categorias[i].areasAtuacao.length - 1;
                            j >= 0;
                            j--
                        ) {
                            vm.areasTodas.push(vm.categorias[i].areasAtuacao[j]);
                        }
                    }

                    vm.areas = [].concat(vm.areasTodas);

                    vm.cidades = [];

                    for (var i = vm.areas.length - 1; i >= 0; i--) {
                        _insereCidadeNaLista(vm.areas[i].cidade);
                    }

                    vm.cidadesTodas = [].concat(vm.cidades);
                },
                function (error) {
                    MdDialogService.alertPadrao(error.data);
                }
            );
        }

        function _inicializaListaCategoriasSelecionadas() {
            if (vm.filtro.categorias == null) {
                vm.categoriasSelecionadas = [];
            }
        }

        function _inicializaListaAreasSelecionadas() {
            if (vm.filtro.areas == null) {
                vm.areasSelecionadas = [];
            }
        }

        function _verificaSeExisteAreaAtuacaoNaLista(area) {
            return vm.areas.some(function (item) {
                return area.codigo == item.codigo;
            });
        }

        function _insereAreaAtuacaoNaLista(area) {
            if (!_verificaSeExisteAreaAtuacaoNaLista(area)) {
                vm.areas.push(area);
            }

            _insereCidadeNaLista(area.cidade);
        }

        function _removeAreaAtuacaoNaLista(area) {
            var removerAreaAtuacao = _verificaCategoriaSelecionada(
                area.categoriaCodigo
            );
            if (
                removerAreaAtuacao == false &&
                _verificaSeExisteAreaAtuacaoNaLista(area)
            ) {
                var posicao = vm.areas.indexOf(area);
                vm.areas.splice(posicao, 1);

                _removeCidadeNaLista(area.cidade.codigo);
            }
        }

        function _retornaCategoriaSelecionada(categorias) {
            for (var i = categorias.length - 1; i >= 0; i--) {
                if (vm.categoriasSelecionadas.indexOf(categorias[i]) === -1) {
                    vm.categoriasSelecionadas.push(categorias[i]);
                    return categorias[i];
                }
            }
        }

        function _retornaAreaSelecionada(areas) {
            for (var i = areas.length - 1; i >= 0; i--) {
                if (vm.areasSelecionadas.indexOf(areas[i]) === -1) {
                    vm.areasSelecionadas.push(areas[i]);
                    return areas[i];
                }
            }
        }

        function _retornaCategoriaDesmarcada(categorias) {
            for (var i = vm.categoriasSelecionadas.length - 1; i >= 0; i--) {
                if (categorias.indexOf(vm.categoriasSelecionadas[i]) === -1) {
                    return vm.categoriasSelecionadas[i];
                }
            }
        }

        function _retornaAreaDesmarcada(areas) {
            for (var i = vm.areasSelecionadas.length - 1; i >= 0; i--) {
                if (areas.indexOf(vm.areasSelecionadas[i]) === -1) {
                    return vm.areasSelecionadas[i];
                }
            }
        }

        function _verificaCategoriaSelecionada(categoriaCodigo) {
            return vm.categoriasSelecionadas.some(function (item) {
                return categoriaCodigo == item.codigo;
            });
        }

        function _removeAreasAtuacaoCategoria(categoria) {
            for (var i = vm.areasTodas.length - 1; i >= 0; i--) {
                if (vm.areasTodas[i].categoriaCodigo === categoria.codigo) {
                    var posicao = vm.areas.indexOf(vm.areasTodas[i]);
                    vm.areas.splice(posicao, 1);

                    _removeCidadeNaLista(vm.areasTodas[i].cidade.codigo);
                }
            }

            if (vm.filtro.categorias == null) {
                vm.areas = [].concat(vm.areasTodas);
            }
        }

        function _removeCategoriaSelecionada(categoria) {
            for (var i = vm.categoriasSelecionadas.length - 1; i >= 0; i--) {
                if (vm.categoriasSelecionadas[i].codigo === categoria.codigo) {
                    vm.categoriasSelecionadas.splice(i, 1);
                }
            }
        }

        function _verificaSeExisteCidadeNaLista(cidade) {
            return vm.cidades.some(function (item) {
                return cidade.codigo == item.codigo;
            });
        }

        function _insereCidadeNaLista(cidade) {
            if (!_verificaSeExisteCidadeNaLista(cidade)) {
                vm.cidades.push(cidade);
            }
        }

        function _removeCidadeNaLista(cidadeCodigo) {
            if (_verificaAreaAtuacaoMesmaCidade(cidadeCodigo) == false) {
                for (var i = vm.cidades.length - 1; i >= 0; i--) {
                    if (vm.cidades[i].codigo === cidadeCodigo) {
                        vm.cidades.splice(i, 1);
                    }
                }
            }
        }

        function _verificaAreaAtuacaoMesmaCidade(cidadeCodigo) {
            if (vm.areasSelecionadas != null) {
                return vm.areasSelecionadas.some(function (item) {
                    return cidadeCodigo == item.cidade.codigo;
                });
            } else {
                return vm.areas.some(function (item) {
                    return cidadeCodigo == item.cidade.codigo;
                });
            }
        }

        function BuscarCurriculos(filtro) {
            vm.requisicaoSolicitada = true;
            filtro.usuarioCorrente = vm.consultaCurriculo.codigoUsuarioCorrente;
            RequisicaoGenericaService.salvar(
                Api.trabalhe_conosco.triagemCurriculos,
                preparaFiltroParaEnvio(filtro)
            ).then(
                function (success) {
                    vm.candidatosTriagem = success.data;
                    vm.pesquisaAtiva = true;
                    vm.requisicaoSolicitada = false;
                },
                function (error) {
                    MdDialogService.alertPadrao(error.data, event);
                    vm.requisicaoSolicitada = false;
                }
            );
        }

        function visualizarCurriculo(candidato) {
            RequisicaoGenericaService.listarSemParams(
                Api.trabalhe_conosco.visualizarCurriculo + candidato
            ).then(
                function (success) {
                    var urlCurriculo = urlApi.url_base_api + success.data;
                    $window.open(urlCurriculo, '_blank');
                },
                function (error) {
                    MdToastService.toastPadrao(error.data, true);
                }
            );
        }

        function novaConsulta() {
            vm.candidatosTriagem = [];

            vm.pesquisar = '';

            vm.pesquisaAtiva = false;
            vm.requisicaoSolicitada = false;

            vm.filtro.categorias = [];
            vm.filtro.cidades = [];
            vm.filtro.areas = [];
        }

        function abrirLinkedin(urlLinkedin) {
            var ehLinkCompleto = urlLinkedin.startsWith("http://") || urlLinkedin.startsWith("https://");
            if (ehLinkCompleto) {
                $window.open(urlLinkedin);
            } else {
                $window.open("https://" + urlLinkedin);
            }

        }

        function visualizarHabilidades(candidato, event) {
            $mdDialog.show({
                controller: 'CandidatoDialogHabilidadeController',
                controllerAs: 'vm',
                templateUrl: vm.rotasHtml.dialogs.dialogHabilidades,
                //parent: ---------------,
                targetEvent: event,
                clickOutsideToClose: false,
                locals: {
                    CodigoCandidato: candidato.candidatoCodigo,
                    NomeCandidato: candidato.candidatoNome
                }
            });
        }

        function preparaFiltroParaEnvio(filtro) {
            var filtro = angular.copy(filtro);

            filtro.categorias = _formatarFiltroCategoria(filtro.categorias);
            filtro.areas = _formatarFiltroAreaAtuacao(filtro.areas);
            filtro.cidades = _formatarFiltroCidade(filtro.cidades);

            return filtro;
        }

        function _formatarFiltroCategoria(categorias) {
            if (categorias && categorias.length > 0)
                return categorias.map(function (item) {
                    return item.codigo;
                });
            else {
                return vm.categorias.map(function (item) {
                    return item.codigo;
                });
            }
        }

        function _formatarFiltroAreaAtuacao(areasAtuacao) {
            if (areasAtuacao && areasAtuacao.length > 0)
                return areasAtuacao.map(function (item) {
                    return item.codigo;
                });
            else {
                return vm.areas.map(function (item) {
                    return item.codigo;
                });
            }
        }

        function _formatarFiltroCidade(cidade) {
            if (cidade && cidade.length > 0)
                return cidade.map(function (item) {
                    return item.codigo;
                });
            else {
                return vm.cidades.map(function (item) {
                    return item.codigo;
                });
            }
        }

        function ordenarPor(campo, dados) {
            vm.candidatosTriagem = _ordenandoPorGenerico(campo, dados);
        }

        function formataTelefone(telefone) {
            if (!telefone || telefone == '') return '';
            telefone = telefone.replace(/\D/g, '');
            telefone = telefone.replace(/^(\d\d)(\d)/g, '($1) $2');
            if (telefone.length >= 9)
                telefone = telefone.replace(/(\d{5})(\d)/, '$1-$2');
            else telefone = telefone.replace(/(\d{4})(\d)/, '$1-$2');

            return telefone;
        }

        function _ordenandoPorGenerico(campo, dados) {
            _limparOrdenacao(campo);

            if (vm.ordenacao[campo] == '') {
                vm.ordenacao[campo] = 'asc';

                return dados.sort(function (a, b) {
                    return a[campo].localeCompare(b[campo]);
                });
            } else {
                if (vm.ordenacao[campo] == 'asc') {
                    vm.ordenacao[campo] = 'desc';
                    return dados.reverse();
                } else {
                    vm.ordenacao[campo] = '';
                    return ordenarPor(campo, dados);
                }
            }
        }

        function _limparOrdenacao(campo) {
            if (campo == 'areaAtuacaoTitulo') {
                vm.ordenacao.candidatoNome = '';
                vm.ordenacao.candidatoCidade = '';
            } else if (campo == 'candidatoNome') {
                vm.ordenacao.areaAtuacaoTitulo = '';
                vm.ordenacao.candidatoCidade = '';
            } else if (campo == 'candidatoCidade') {
                vm.ordenacao.areaAtuacaoTitulo = '';
                vm.ordenacao.candidatoNome = '';
            }
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.solicitacao.processamento.solicitacao')
        .controller('SolicitacaoController', SolicitacaoController)

    /** @ngInject */
    function SolicitacaoController(RequisicaoGenericaService, Api, DatatableFactory, ListarTodasSolucoes,
        RotasHtml, ListarTodasOrigens, ListarNecessidadesCliente, ListarTodosUsuarios,
        ListarTodosClientes, LoginUsuarioService, DataTableConfigPadrao, $filter,
        $mdDialog, SolicitacaoFactory, NavegacaoService, $q, $state, $timeout, ServicosGenericoService, ListarSquads, ListarUsuarioPorDetalhe, MdDialogService, SquadService, ToolbarService, PgToolbarService) {
        var vm = this;
        NavegacaoService.setTituloAba('Solicitação');

        var rotasApi = Api.solicitacao.solicitacao;

        // Data region      
        vm.htmlRota = RotasHtml.solicitacao.solicitacao;
        var solucoesTemporaria = ListarTodasSolucoes.data;
        vm.solucoes = ListarTodasSolucoes.data;
        vm.squads = ListarSquads;
        //end reagion
        vm.atendimentos = [];
        vm.atendimentoBkp = {};
        vm.buscandoSolucoes = false;
        // Configurações Datatable region
        vm.dtOptionsSolicitacao = angular.copy(DataTableConfigPadrao.dtOptionsResponsivoPaginacaoTipoNumberComInitComplete);
        vm.dtOptionsSolicitacao.columnDefs = setColumnsDefsDtOptionsTabSolicitacao();
        //end region

        init();

        function init() {
            vm.parametros = $state.params.parametros;
            vm.iniciarChamandoPesquisa = false;
            vm.solicitacao = {};
            vm.form = {};
            vm.entidadeDeEnvio = {
                intTamanhoPagina: 1,
                clsEntidade: vm.solicitacao
            }

            vm.atendimentos = [];
            vm.atendimento = null;
            vm.ultimoCliente = 0;
            // Resolve region
            vm.clientes = ListarTodosClientes.data;
            vm.origens = ListarTodasOrigens.data;
            vm.necessidadesCliente = ListarNecessidadesCliente.data;
            vm.usuariosBkp = ListarTodosUsuarios.data;
            vm.usuarios = angular.copy(vm.usuariosBkp);
            //endregion

            // Variáveis Controladoras das tabs region
            vm.tabSelecionada = "solicitacao";
            //endregion

            if (vm.parametros != null) {
                vm.entidadeDeEnvio.clsEntidade.numero = vm.parametros.solicitacaoNumero;
                vm.entidadeDeEnvio.clsEntidade.ano = vm.parametros.solicitacaoAno;
                vm.entidadeDeEnvio.clsEntidade.squadCodigo = vm.parametros.squadCodigo;
                vm.iniciarChamandoPesquisa = true;
            }
            ToolbarService.armazenarCodigoSquadUsuarioLogado(ListarUsuarioPorDetalhe.data.codigoSquads);
            vm.squadUsuarioLogado = ListarUsuarioPorDetalhe.data.codigoSquads;
            vm.squads = SquadService.listarSquadsUsuarioLogado(vm.squadUsuarioLogado)
            if (vm.squadUsuarioLogado.length === 1) _listarTodasSolucoes(vm.squadUsuarioLogado);
            if (vm.squadUsuarioLogado.length > 1) {
                $timeout(function () {
                    vm.solicitacao.squadCodigo = ToolbarService.squadSelecionado();
                    _listarTodasSolucoes(vm.solicitacao.squadCodigo);
                }, 500);
            }

        }

        vm.metodosSolicitacao = {
            alterarItemSelecionadoAutoCompleteCliente: alterarItemSelecionadoAutoCompleteCliente,
            atualizar: atualizar,
            configuraMdSelectAtendimento: configuraMdSelectAtendimento,
            configuraMdSelectSolucao: configuraMdSelectSolucao,
            configurarMdSelectAtendimentoOnClose: configurarMdSelectAtendimentoOnClose,
            construirDtOptions: construirDtOptions,
            criar: criar,
            criarHistoriaAPartirDaSolicitacao: criarHistoriaAPartirDaSolicitacao,
            excluir: excluir,
            listarTodosAtendimentoCliente: listarTodosAtendimentoCliente,
            pesquisar: pesquisar,
            pesquisarAutoCompleteCliente: pesquisarAutoCompleteCliente,
            selecionar: selecionar,
            selecionarAtendimento: selecionarAtendimento,
            selecionarSolicitacao: selecionarSolicitacao,
            selectChangeSolucao: selectChangeSolucao,
            selectChangeSquad: selectChangeSquad,
            aoSalvarConcluido: aoSalvarConcluido
        }

        vm.metodosEstimativa = {
            abrirDialogEditarPontuacao: abrirDialogEditarPontuacao
        }

        vm.metodosGeral = {
            novaPesquisa: novaPesquisa,
            preDefinirCamposParaEdicao: preDefinirCamposParaEdicao,
            preDefinirCamposParaInserir: preDefinirCamposParaInserir,
            reverter: reverter,
            tabSelecionada: tabSelecionada,
        }

        function criar(modelo) {
            if (vm.squadUsuarioLogado.length === 1) vm.solicitacao.squadCodigo = vm.squadUsuarioLogado[0];
            return $q(function (resolve, reject) {
                RequisicaoGenericaService.salvar(rotasApi.criar, modelo).then(
                    function (success) {
                        SolicitacaoFactory.solicitacao = success.data;
                        resolve(success);
                    }
                ).catch(function (error) {
                    reject(error);
                });
            });
        }

        function excluir(modelo) {
            if (vm.squadUsuarioLogado.length === 1) vm.solicitacao.squadCodigo = vm.squadUsuarioLogado[0];
            return RequisicaoGenericaService.excluir(rotasApi.excluir, '?numero=' + modelo.numero + '&ano=' + modelo.ano);
        }

        function atualizar(modelo) {
            if (vm.squadUsuarioLogado.length === 1) vm.solicitacao.squadCodigo = vm.squadUsuarioLogado[0];
            return RequisicaoGenericaService.editar(rotasApi.atualizar, modelo);
        }

        function pesquisar() {
            if (vm.squadUsuarioLogado.length === 1) vm.solicitacao.squadCodigo = vm.squadUsuarioLogado[0];
            _limparAtendimentos();
            return $q(function (resolve, reject) {
                RequisicaoGenericaService.listarComObjetoComplexo(rotasApi.listarComPaginacao, vm.entidadeDeEnvio).then(
                    function (success) {
                        SolicitacaoFactory.solicitacao = success.data.lstResultado[0];
                        vm.tabSelecionada = 'solicitacao';
                        resolve(success);
                    }

                ).catch(function (error) {
                    reject(error);
                });
            });
        }

        function selecionar(posicaoEntidade) {
            vm.metodosExternosPgToolbar.metodoControladorExternoListarTodasEntidades(null, posicaoEntidade);
        }

        /**
         * Método que configura o md-select de solução, sempre limpando o md-select-header de Solução quando o component é aberto
         */
        function configuraMdSelectSolucao() {
            vm.filtrarSolucoes = "";
            angular.element('#tab-solicitacao-solucao-md-select').on('keydown', function (ev) {
                ev.stopPropagation();
            });
        }

        /*
        * Método chamado ao clicar no botão reverter
        */
        function reverter() {
            vm.atendimento = vm.atendimentoBkp;
            if (!vm.controleForm.pesquisaAtiva) {
                if (vm.squadUsuarioLogado.length > 1) {
                    vm.solicitacaoForm.squadCodigo.$setValidity('required', false);
                    vm.solicitacaoForm.squadCodigo.$setTouched();
                }
            }
        }

        /**
        * Método que é chamado sempre quando ocorre uma transição de tab
        * @param {tab} tab 
        */
        function tabSelecionada(tab) {
            vm.tabSelecionada = tab;
        }

        /**
         * Método que irá pesquisar um cliente no componente md-auto-complete de Cliente com base no que está sendo digitado
         * @param {textoDePesquisa} query 
         */
        function pesquisarAutoCompleteCliente(query) {
            query = query.toLowerCase();
            var resultado = query ? vm.clientes.filter(function (item, index) {
                return (item.codigo == query || item.nome.toLowerCase().search(query) != -1);
            }) : vm.clientes;

            return resultado;
        }
        function configuraMdSelectAtendimento() {
            vm.filtrarAtendimentos = "";
            angular.element('#tab-solicitacao-atendimento-md-select').on('keydown', function (ev) {
                ev.stopPropagation();
            });

        }

        function inserindoOuEditando() {
            return vm.controleForm.inserirAtivo || vm.controleForm.editarAtivo;
        }

        function listarTodosAtendimentoCliente(clienteCodigo) {
            vm.solicitacaoForm.atendimento.$setValidity('sem_cliente', true);
            vm.solicitacaoForm.atendimento.$setValidity('sem_atendimentos', true);
            if (inserindoOuEditando() && !clienteCodigo && vm.solicitacao.origem == 2)
                vm.solicitacaoForm.atendimento.$setValidity('sem_cliente', false);

            if (!clienteCodigo || (vm.solicitacao.origem != 2)) {
                _limparAtendimentos();
            }
            if ((vm.solicitacao.origem == 2) && clienteCodigo && clienteCodigo != vm.ultimoCliente) {
                vm.requisicaoSolicitada = true;
                vm.ultimoCliente = clienteCodigo;
                vm.mensagemPreloader = "Carregando Atendimentos do Cliente ..."
                RequisicaoGenericaService.listarSemParams(Api.atendimento.listarAtendimentosPorCodigoCliente + "/" + clienteCodigo).then(
                    function (success) {
                        vm.atendimentos = success.data.map(function (item) {
                            return { ano: item.ano, codigo: item.codigo, descricao: item.codigo + '/' + item.ano };
                        });

                        vm.atendimento = vm.atendimentos.find(function (atendimento) {
                            return (atendimento.codigo == vm.solicitacao.atendimentoCodigo && atendimento.ano == vm.solicitacao.atendimentoAno);
                        });
                        if (!inserindoOuEditando())
                            vm.atendimentoBkp = angular.copy(vm.atendimento);
                        vm.requisicaoSolicitada = false;
                        vm.mensagemPreloader = "";
                        if (inserindoOuEditando())
                            vm.solicitacaoForm.atendimento.$setValidity('sem_atendimentos', !(vm.solicitacao.origem == 2 && vm.solicitacao.clienteCodigo && (!vm.atendimentos || vm.atendimentos.length == 0)));
                    },
                    function (error) {
                        vm.requisicaoSolicitada = false;
                        vm.mensagemPreloader = "";
                        ServicosGenericoService.exibirAlertaDeErro(error, event);
                    });
            }
        }

        function configurarMdSelectAtendimentoOnClose() {
            vm.filtrarAtendimentos = "";
        }

        function selecionarAtendimento(atendimento) {
            if (atendimento) {
                vm.solicitacao.atendimentoCodigo = atendimento.codigo;
                vm.solicitacao.atendimentoAno = atendimento.ano;
            }
        }

        /**
         * Método irá alterar o cliente de 'vm.estoria.clienteCodigo' sempre que o cliente mudar
         * @param {cliente} item 
         */
        function alterarItemSelecionadoAutoCompleteCliente(item) {
            if (item) {
                vm.solicitacao.clienteCodigo = item.codigo;
                vm.solicitacao.cliente = item;
                if (!vm.controleForm.pesquisaAtiva) {
                    vm.solicitacao.solucaoCodigo = null;
                }
            } else {
                vm.textoDePesquisaAutoCompleteCliente = "";
                vm.solicitacao.solucaoCodigo = null;
                vm.solicitacao.clienteCodigo = null;
                vm.solucoes = solucoesTemporaria;
                vm.solicitacao.cliente = null;
            }
            if (vm.squadUsuarioLogado.length === 1) vm.solicitacao.squadCodigo = vm.squadUsuarioLogado[0];
            _listarTodasSolucoes(vm.solicitacao.squadCodigo);
            listarTodosAtendimentoCliente(item ? item.codigo : null);
        }

        /**
        * Método chamado quando o botão de nova pesquisa da toolbar for clicado 
        */

        function novaPesquisa() {
            if (vm.squadUsuarioLogado.length > 1) {
                vm.solicitacao.squadCodigo = ToolbarService.squadSelecionado();
            }
            vm.textoDePesquisaAutoCompleteCliente = "";
            vm.textoDePesquisaAutoCompleteAtendimento = "";
            vm.solucoes = solucoesTemporaria;
            vm.tabSelecionada = 'solicitacao';
        }

        function preDefinirCamposParaEdicao() {
            if ((vm.atendimento.codigo != vm.atendimentoBkp.codigo) || (vm.atendimento.ano != vm.atendimentoBkp.ano)) {
                vm.atendimentoBkp = angular.copy(vm.atendimento);
            }
        }

        /**
         * Método chamado quando o botão inserir da toolbar for clicado para pré definir alguns campos
         */
        function preDefinirCamposParaInserir() {
            _limparAtendimentos();
            vm.solicitacao = {};
            vm.usuariosSetorDesenvolvimento = angular.copy(vm.usuariosSetorDesenvolvimentoBkp);
            vm.solicitacao.codigoUsuarioAbertura = LoginUsuarioService.usuarioArmazenado().codigo;
            var dataAtual = new Date();
            vm.solicitacao.ano = dataAtual.getFullYear();
            vm.solicitacao.dataAbertura = dataAtual;
            vm.tabSelecionada = 'solicitacao';
            vm.atendimentoBkp = {};

            alterarItemSelecionadoAutoCompleteCliente(null);

            vm.solicitacao.squadCodigo = ToolbarService.squadSelecionado();
            _sugerirProximoNumero(vm.solicitacao.squadCodigo);
        }

        function _sugerirProximoNumero(squadCodigo) {
            RequisicaoGenericaService.listarSemParams(rotasApi.proximoCodigo + '?' + 'squadCodigo=' + squadCodigo).then(
                function (success) {
                    vm.solicitacao.numero = success.data;
                },
                function (error) {
                    MdDialogService.alertPadrao(error.data);
                });
        }

        /*
        * Método chamado para criar as definições da datatable de solicitação
        */
        function setColumnsDefsDtOptionsTabSolicitacao() {
            return [
                {
                    targets: 0,
                    ordering: false,
                    filterable: true,
                    sortable: false
                },
                {
                    targets: 3,
                    type: 'date-pt-br'
                }
            ];
        }

        /**
         * Método utilizado no modo exibido tabela, para selecionar uma estória
         * @param {solicitacao} solicitacao 
         */
        function selecionarSolicitacao(solicitacao) {
            vm.controleForm.listarTodas(vm.solicitacoes.indexOf(solicitacao));
            vm.solicitacao = solicitacao;
            vm.pesquisar = "";
        }

        function construirDtOptions() {
            DatatableFactory.construirDtOptionsComPaginacaoProcessadoNoServidorParaToolbar
                (rotasApi.listarComPaginacaoDatatable, vm.entidadeDeEnvio.clsEntidade, '#datatable-solicitacao',
                    [
                        DatatableFactory.construirColunaDeSelecionarPadrao(function (indexLinha) { vm.metodosSolicitacao.selecionar(indexLinha) }),
                        {
                            targets: 1,
                            name: "Número",
                            data: "numero",
                            sortable: true
                        },
                        {
                            targets: 2,
                            name: "Ano",
                            data: "ano",
                            sortable: true
                        },
                        {
                            targets: 3,
                            name: "DataAbertura",
                            data: formatarData,
                            sortable: true
                        },
                        {
                            targets: 4,
                            name: "Cliente",
                            data: "cliente.nome",
                            sortable: true
                        },
                        {
                            targets: 5,
                            name: "Solucao",
                            data: "solucao.descricao",
                            render: verificarSolucao,
                            sortable: true
                        }
                    ]);
        }

        function verificarSolucao(data) {
            if (data)
                return data;
            else
                return "-";
        }

        function formatarData(data) {
            return $filter('date')(new Date(data.dataAbertura), 'dd/MM/yyyy');
        }

        function abrirDialogEditarPontuacao(event) {
            $mdDialog.show({
                controller: 'EditarPontuacaoDialogController',
                controllerAs: 'vm',
                templateUrl: vm.htmlRota.dialogs.editarPontuacao,
                //parent: ---------------,
                targetEvent: event,
                clickOutsideToClose: false,
                locals: {
                    ControleForm: vm.controleForm,
                    UsuarioEstoriaLogado: vm.usuarioEstoriaLogado,
                    Solicitacao: vm.solicitacao,
                }
            });
        }

        function criarHistoriaAPartirDaSolicitacao(solicitacao) {

            var atendimento = null;
            if (solicitacao.atendimentoCodigo && solicitacao.atendimentoAno)
                atendimento = solicitacao.atendimentoCodigo + '/' + solicitacao.atendimentoAno;

            $state.goNewTab('app.planejamento_processamento_estoria', {
                parametrosSolicitacao: {
                    cliente: solicitacao.cliente,
                    origem: solicitacao.origem,
                    squadCodigo: solicitacao.squadCodigo,
                    solucaoCodigo: solicitacao.solucaoCodigo,
                    atendimento: atendimento,
                    solicitacao: solicitacao
                }
            });
        }

        function selectChangeSquad(codigoSquadSelecionada) {
            if (vm.controleForm.inserirAtivo) {
                _sugerirProximoNumero(codigoSquadSelecionada);
            }
            vm.solicitacao.solucaoCodigo = null;
            if ([1, 2, 3].includes(codigoSquadSelecionada)) {
                _listarTodasSolucoes(codigoSquadSelecionada);
            } else {
                _listarTodasSolucoes();
            }
        }

        function selectChangeSolucao(solucaoSelecionada) {
            if (solucaoSelecionada === "Nenhum") vm.solicitacao.solucaoCodigo = null;
        }

        function _limparAtendimentos() {
            vm.atendimento = {};
            vm.atendimentos = [];
            vm.ultimoCliente = 0;
            vm.solicitacao.atendimentoCodigo = null;
            vm.solicitacao.atendimentoAno = null;
        }

        function _listarTodasSolucoes(codigoSquad) {
            vm.buscandoSolucoes = true;

            var url = Api.solucao_rotinas_tarefas.solucao.listarPorSquadCliente;

            var squads = Array.isArray(codigoSquad) ? codigoSquad : (codigoSquad ? [codigoSquad] : vm.squadUsuarioLogado);

            var entidadeEnvio = {
                codigoCliente: vm.solicitacao.clienteCodigo,
                codigoSquads: squads.length > 0 ? squads : [vm.solicitacao.squadCodigo],
                exibirSolucaoComSquad: true
            }

            return RequisicaoGenericaService.listarPorPaginacaoJsonFormato(url, entidadeEnvio)
                .then(function (success) {
                    vm.solucoes = success.data;
                })
                .catch(function (error) {
                    vm.solucoes = [];
                })
                .finally(function () {
                    vm.buscandoSolucoes = false;
                });

        }

        function aoSalvarConcluido() {
            _incluirQuestionarioSolicitacao(vm.solicitacao);
        }

        function _incluirQuestionarioSolicitacao(solicitacao) {
            PgToolbarService.iniciarPreLoaderToolbar(
                vm.controleForm,
                vm.controlePreloader
            );
            var entidadeEnvio = {
                numeroSolicitacao: solicitacao.numero,
                anoSolicitacao: solicitacao.ano,
                squadCodigo: solicitacao.squadCodigo,
                solicitacao: _construirQuestionarioSolicitacao(),
                teste: null,
                analise: null,
                historia: null
            };
            var rota = Api.solicitacao.solicitacao.documentacao.atualizar;
            RequisicaoGenericaService.editar(rota, entidadeEnvio)
                .then(function (success) {
                    vm.solicitacao.solicitacaoDocumentacao.solicitacao = success.data.solicitacao;
                    vm.solicitacao.solicitacaoDocumentacao.teste = success.data.teste;
                    vm.solicitacao.solicitacaoDocumentacao.analise = success.data.analise;
                    vm.solicitacao.solicitacaoDocumentacao.historia = success.data.historia;
                }, function (error) {
                    alert(error);
                }).finally(function () {
                    PgToolbarService.finalizarPreLoaderToolbar(
                        vm.controleForm,
                        vm.controlePreloader
                    );
                });
        }

        function _construirQuestionarioSolicitacao() {
            var questionario = '';

            if (vm.solicitacao.squadCodigo == 3) {
                questionario = '<h2><strong><u>Questionário:</u></strong></h2>' +
                    '<h2><strong>Objetivos e Problemas</strong></h2>' +
                    '<p><strong>Qual o objetivo do usuário?</strong><br>-</p>' +
                    '<p><strong>Qual problema essa funcionalidade resolve? Há alguma dor clara?</strong><br>-</p>' +
                    '<h2><strong>Detalhes da Funcionalidade</strong></h2>' +
                    '<p><strong>Menu:</strong><br>-</p>' +
                    '<p><strong>Link do banco de dados:</strong><br>-</p>' +
                    '<p><strong>O que deve ser feito exatamente?</strong><br>-</p>' +
                    '<p><strong>Existem regras de negócio, validações obrigatórias ou exceções?</strong><br>-</p>' +
                    '<p><strong>Qual deve ser o comportamento em caso de erro?</strong><br>-</p>' +
                    '<h2><strong>Exemplos e referências</strong></h2>' +
                    '<p><strong>Há alguma tela, relatório ou funcionalidade existente que sirva de referência?</strong><br>-</p>';
            } else {
                questionario = '<h2><strong><u>Questionário:</u></strong></h2>' +
                    '<h2><strong>Objetivos e Problemas</strong></h2>' +
                    '<p><strong>Qual o objetivo do usuário?</strong><br>-</p>' +
                    '<p><strong>O que o usuário quer alcançar?</strong><br>-</p>' +
                    '<p><strong>Qual problema essa funcionalidade resolve?</strong><br>-</p>' +
                    '<p><strong>Qual a situação atual (sem a funcionalidade)? Há alguma dor clara?</strong><br>-</p>' +
                    '<h2><strong>Detalhes da funcionalidade</strong></h2>' +
                    '<p><strong>O que deve ser feito exatamente?</strong><br>-</p>' +
                    '<p><strong>Existem regras específicas de negócio?</strong><br>-</p>' +
                    '<p><strong>Há validações obrigatórias ou exceções?</strong><br>-</p>' +
                    '<p><strong>Há campos obrigatórios, cálculos automáticos ou integrações?</strong><br>-</p>' +
                    '<p><strong>Qual deve ser o comportamento em caso de erro?</strong><br>-</p>' +
                    '<h2><strong>Exemplos e referências</strong></h2>' +
                    '<p><strong>Há alguma tela, modelo, sistema ou referência visual?</strong><br>-</p>' +
                    '<p><strong>Já existe algo parecido no sistema atual que possa servir de base?</strong><br>-</p>' +
                    '<p><strong>Observação:</strong><br>' +
                    'Por favor, inclua os arquivos de remessa, o banco de dados e quaisquer outros documentos necessários para a análise completa da solicitação.</p>';
            }

            return questionario;
        }
    }

}());

/**
 * Created by nova on 24/03/2017.
 */
(function () {
    'use strict';

    angular.module('app.trabalheconosco.cadastro.habilidade')
        .controller('TrabalheConoscoHabilidadeController', TrabalheConoscoHabilidadeController);

    function TrabalheConoscoHabilidadeController(Api, NavegacaoService, RequisicaoGenericaService, DatatableFactory, ListarIdiomas, ListarNivelIdiomas) {
        var vm = this;
        NavegacaoService.setTituloAba('Trabalhe conosco habilidade');

        //#region Data

        var rotas = Api.trabalhe_conosco.habilidade;

        vm.form = {};

        vm.idiomas = ListarIdiomas.data;
        vm.nivelIdiomas = ListarNivelIdiomas.data;

        _init();
        //#endregion

        //#region  Definição dos Métodos region
        vm.metodos = {
            pesquisar: pesquisar,
            salvar: salvar,
            editar: editar,
            excluir: excluir,
            selecionar: selecionar,
            construirDtOptions: construirDtOptions,
            ngChangeIdioma: ngChangeIdioma,
            preDefinirCamposParaInsercao: preDefinirCamposParaInsercao
        }

        var metodosInternos = {
            _init: _init
        }

        //#endregion       

        //#region Métodos Internos

        function _init() {
            vm.habilidade = {};
            vm.habilidades = [];

            vm.habilidade.ehIdioma = false;
        }

        //#endregion

        //#region Métodos

        function pesquisar() {
            delete vm.entidadeDeEnvio.clsEntidade.ehIdioma;
            return RequisicaoGenericaService.listarComObjetoComplexo(rotas.listarComPaginacao, vm.entidadeDeEnvio);
        }

        function salvar(modelo) {
            return RequisicaoGenericaService.salvar(rotas.criar, modelo);
        }

        function editar(modelo) {
            return RequisicaoGenericaService.editar(rotas.atualizar, modelo)
        }

        function excluir(modelo) {
            return RequisicaoGenericaService.excluir(rotas.excluir, modelo.codigo)
        }

        function selecionar(posicaoEntidade) {
            vm.metodosExternosPgToolbar.metodoControladorExternoListarTodasEntidades(null, posicaoEntidade);
        }

        function construirDtOptions() {
            console.log(vm.entidadeDeEnvio.clsEntidade);
            DatatableFactory.construirDtOptionsComPaginacaoProcessadoNoServidorParaToolbar
                (rotas.listarComPaginacaoDatatable, vm.entidadeDeEnvio.clsEntidade, '#datatable-trabalheconosco-cadastro-habilidade',
                [

                    DatatableFactory.construirColunaDeSelecionarPadrao(function (indexLinha) { vm.metodos.selecionar(indexLinha) }),
                    {
                        targets: 1,
                        name: "Descricao",
                        data: "descricao",
                        render: function (data, type, row, meta) {                            
                            if (row.ehIdioma)
                                data = row.descricao + " - " + row.descricaoNivel;

                            return data;
                        },
                        defaultContent: "",                  
                        sortable: false    
                    },
                    {
                        targets: 2,
                        name: "EhIdioma",
                        data: "ehIdioma",
                        render: function (data) {
                            if (data)
                                return "S";
                            else
                                return "N";
                        },
                        defaultContent: "",
                        orderable: false,
                        filterable: false
                    }
                ]);
        }

        function ngChangeIdioma(idioma) {
            if (!idioma){
                vm.habilidade.ehIdioma = null;
                vm.habilidade.nivel = null
            }
        }

        function preDefinirCamposParaInsercao() {
            vm.habilidade = {
                ehIdioma: false,
                nivel: null
            };
        }

        //#endregion

    }
})();

(function () {
    'use strict';

    angular
        .module('app.trabalheconosco.cadastro.areaatuacao',[])
        .config(Config);

    function Config($stateProvider, RotasHtml) {
        var rotasHtml = RotasHtml.trabalheConoscoCadastroAreaAtuacao;
        $stateProvider
            .state('app.trabalheconosco_cadastro_areaatuacao', {
                url: '/trabalheconosco/cadastro/areaatuacao',
                module: 'privado',
                params: {
                    parametros: null
                },
                views: {
                    'content@app': {
                        templateUrl: rotasHtml.templateUrl,
                        controller: 'TrabalheConoscoAreaAtuacao as vm'
                    },
                    'trabalhe-conosco-areaatuacao-form@app.trabalheconosco_cadastro_areaatuacao': {
                        templateUrl: rotasHtml.form
                    },
                    'trabalhe-conosco-areaatuacao-tabela@app.trabalheconosco_cadastro_areaatuacao': {
                        templateUrl: rotasHtml.tabela
                    }
                },
                resolve: {
                    ListarCategorias: function (Api, RequisicaoGenericaService) {
                        return RequisicaoGenericaService.listarSemParams(Api.trabalhe_conosco.listarCategorias);
                    },
                    ListarHabilidades: function (Api, RequisicaoGenericaService) {
                        return RequisicaoGenericaService.listarSemParams(Api.trabalhe_conosco.habilidade.listarTodasHabilidadesViewModel);
                    },
                    ListarTodasUF: function (Api, RequisicaoGenericaService) {
                        return RequisicaoGenericaService.listarSemParams(Api.display.listarTodasUf);
                    }           
                }
            });
    }

})();

/**
 * Created by nova on 14/08/2018.
 */
(function () {
    'use strict';

    angular.module('app.trabalheconosco.cadastro.areaatuacao')
        .controller('TrabalheConoscoAreaAtuacao', TrabalheConoscoAreaAtuacao);

    function TrabalheConoscoAreaAtuacao(Api, RotasHtml, ListarCategorias,
        ServicosGenericoService, RequisicaoGenericaService, $q,
        $scope, DatatableFactory, ListarTodasUF, NavegacaoService,
        MdDialogService) {
        var vm = this;
        NavegacaoService.setTituloAba('Trabalhe conosco área de atuação');

        vm.habilidadeSelecionada = null;
        vm.habilidadeIndexSelecionada = null;

        vm.habilidadeAdicionada = {
            codigoHabilidade: null,
            descricao: "",
            peso: 0
        };

        vm.TextoBotao = "Adicionar";
        vm.EditandoHabilidade = false;
        vm.controladorBotaoAdicionar = true;

        //#region Data
        vm.htmlRota = RotasHtml.trabalheConoscoCadastroAreaAtuacao;
        vm.form = {};

        vm.rota = Api.trabalhe_conosco.areaAtuacao.proximoCodigo;
        vm.tabSelecionada = "areaAtuacao";
        vm.controleArea = {
            controladorHabilidadesAreaAtuacao: false,
            editarResposabilidade: false,
            editarPesoHabilidade: false
        }

        vm.categorias = ListarCategorias.data;
        vm.ufs = ListarTodasUF.data;
        //#endregion

        //#region  Definição dos Métodos region
        vm.metodosGeral = {
            tabSelecionada: tabSelecionada,
        }

        vm.metodosArea = {
            pesquisar: pesquisar,
            salvar: salvar,
            editar: editar,
            excluir: excluir,
            selecionar: selecionar,
            construirDtOptions: construirDtOptions,
            configuraAutoCompleteCidadeOnBlur: configuraAutoCompleteCidadeOnBlur,
            alterarItemSelecionadoAutoCompleteCidade: alterarItemSelecionadoAutoCompleteCidade,
            pesquisarAutoCompleteCidade: pesquisarAutoCompleteCidade
        };

        vm.metodosResponsabilidade = {
            salvarResponsabilidade: salvarResponsabilidade,
            editarResponsabilidade: editarResponsabilidade
        }

        vm.metodosHabilidade = {
            onChangePeso: onChangePeso,
            onChangePesoTabela: onChangePesoTabela,
            configuraAutoCompleteHabilidadeOnBlur: configuraAutoCompleteHabilidadeOnBlur,
            alterarItemSelecionadoAutoCompleteHabilidade: alterarItemSelecionadoAutoCompleteHabilidade,
            pesquisarAutoCompleteHabilidade: pesquisarAutoCompleteHabilidade,
            salvarHabilidade: salvarHabilidade,
            editarHabilidade: editarHabilidade,
            selecionarHabilidade: selecionarHabilidade,
            alterarPesoHabilidade: alterarPesoHabilidade,
            adicionarHabilidadeAreaAtuacao: adicionarHabilidadeAreaAtuacao,
            excluirHabilidade: excluirHabilidade,
            verificaHabilidadeInserida: verificaHabilidadeInserida,
            verificaOperacaoHabilidade: verificaOperacaoHabilidade,
            cancelaEdicaoHabilidade: cancelaEdicaoHabilidade
        }

        // Configurações Datatable region
        vm.dtOptionsLog = {
            dom: 'rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
            initComplete: function () {
                var api = this.api(),
                    searchBox = angular.element('body').find('#pesquisar');

                if (searchBox.length > 0) {
                    searchBox.on('keyup', function (event) {
                        api.search(event.target.value).draw();
                    });
                }
            },
            pagingType: 'numbers',
            lengthMenu: [100],
            pageLength: 100,
            responsive: true,
            order: [],
            columnDefs: [
                {
                    responsivePriority: 1, targets: [0],
                    searchable: false,
                    orderable: false
                }
            ]
        };

        //#endregion       

        /**
          * Watch que fica escutando o objeto 'vm.area' e se o novo valor inserido neste objeto for vazio
          * é chamado o método 'tabSelecionada('areaAtuacao')' para voltar para a tab inicial 'colaborador'
          */
        $scope.$watch('vm.area', function (newValue, oldValue) {
            if (angular.equals({}, newValue))
                vm.metodosGeral.tabSelecionada('areaAtuacao');
            else {
                vm.metodosGeral.tabSelecionada(vm.tabSelecionada);
            }
        });

        $scope.$watch('vm.area.ativo', function () {
            if (!vm.area.ativo)
                vm.area.disponivel = false;
        })

        // $scope.$watch('vm.habilidadeAdicionada.peso', function (newValue, oldValue) {
        //     console.log('Escutou...');
        // });

        //#region Métodos
        /**
         * Método que é chamado sempre quando ocorre uma transição de tab
         * @param {tab} tab 
         */
        function tabSelecionada(tab) {
            vm.tabSelecionada = tab;
            if (tab !== 'areaAtuacao') {
                if (angular.isDefined(vm.controleForm)) {
                    vm.controleForm.desabilitarButtonEditar = true;
                    vm.controleForm.desabilitarButtonInserir = true;
                    vm.controleForm.desabilitarButtonExcluir = true;
                    vm.controleForm.desabilitarButtonListarTodos = true;
                    vm.controleForm.desabilitarMetodoToolbarAtualizar = true;

                    if (tab === 'responsabilidadesAreaAtuacao') {
                        vm.controleArea.editarResposabilidade = true;
                    }
                }
            } else {
                if (angular.isDefined(vm.controleForm)) {
                    vm.controleForm.desabilitarButtonEditar = false;
                    vm.controleForm.desabilitarButtonInserir = false;
                    vm.controleForm.desabilitarButtonExcluir = false;
                    vm.controleForm.desabilitarButtonListarTodos = false;
                    vm.controleForm.desabilitarMetodoToolbarAtualizar = false;
                }
            }
        }

        /**
         * Método para pesquisar uma área de atuação
         */
        function pesquisar() {
            vm.TextoBotao = "Adicionar";
            vm.EditandoHabilidade = false;
            vm.habilidadeAdicionada.codigoHabilidade = null;
            vm.habilidadeAdicionada.descricao = "";
            vm.habilidadeAdicionada.peso = 0;
            if (vm.textoDePesquisaAutoCompleteHabilidade)
                vm.textoDePesquisaAutoCompleteHabilidade = "";
            return RequisicaoGenericaService.listarComObjetoComplexo(Api.trabalhe_conosco.areaAtuacao.listarComPaginacao, vm.entidadeDeEnvio);
        }

        /**
         * Método para salvar uma área de atuação
         * @param {area} modelo 
         */
        function salvar(modelo) {
            var deferred = $q.defer();
            RequisicaoGenericaService.salvar(Api.trabalhe_conosco.areaAtuacao.criar, modelo).then(
                function (success) {
                    deferred.resolve(success);
                },
                function (error) {
                    deferred.reject(error);
                });
            return deferred.promise;
        }

        /**
         * Método para editar uma área de atuação
         * @param {area} modelo 
         */
        function editar(modelo) {
            var deferred = $q.defer();
            RequisicaoGenericaService.editar(Api.trabalhe_conosco.areaAtuacao.atualizar, modelo).then(
                function (success) {
                    deferred.resolve(success);
                },
                function (error) {
                    deferred.reject(error);
                });
            return deferred.promise;
        }

        /**
         * Método para excluir uma área de atuação
         * @param {area} modelo 
         */
        function excluir(modelo) {
            if (modelo.candidatosVinculados) {
                MdDialogService.alertPadrao("Atenção",
                    null,
                    "Existem um ou mais currículos vinculados a essa área de atuação.")
            }
            else {
                return RequisicaoGenericaService.excluir(Api.trabalhe_conosco.areaAtuacao.excluir, modelo.codigo);
            }
        }

        /**
         * Método utilizado no modo exibido tabela, para selecionar uma área de atuacao
         * @param {area} modelo 
         */
        function selecionar(posicaoEntidade) {
            vm.metodosExternosPgToolbar.metodoControladorExternoListarTodasEntidades(null, posicaoEntidade);
        }

        /**
         * Método para construi o DtOptions da tabela
         */
        function construirDtOptions() {
            DatatableFactory.construirDtOptionsComPaginacaoProcessadoNoServidorParaToolbar
                (Api.trabalhe_conosco.areaAtuacao.listarComPaginacaoDatatable, vm.entidadeDeEnvio.clsEntidade, '#datatable-area',
                    [
                        DatatableFactory.construirColunaDeSelecionarPadrao(function (indexLinha) { vm.metodosArea.selecionar(indexLinha) }),
                        {
                            targets: 1,
                            name: "Titulo",
                            data: "titulo",
                            defaultContent: ""
                        },
                        {
                            targets: 2,
                            name: "CodigoCategoria",
                            data: "categoria.titulo",
                            defaultContent: ""
                        },
                        {
                            targets: 3,
                            name: "CodigoCidade",
                            data: "cidade.descricao",
                            defaultContent: ""
                        },
                        {
                            targets: 4,
                            name: "UfCidade",
                            data: "cidade.uf",
                            defaultContent: ""
                        },
                        {
                            targets: 5,
                            name: "Ativo",
                            data: "ativo",
                            render: function (data) {
                                if (data)
                                    return "S";
                                else
                                    return "N";
                            },
                            defaultContent: "",
                            orderable: false,
                            filterable: false
                        }
                    ]);
        }

        /**
         * Método que limpa o texto de pesquisa do md-auto-complete da Cidade
         */
        function configuraAutoCompleteCidadeOnBlur() {
            if (!vm.area.cidade) {
                vm.textoDePesquisaAutoCompleteCidade = "";
            }
        }

        /**
         * Método que controla qual cidade está selecionada no campo md-auto-complete da Cidade
         * @param {object} item 
         */
        function alterarItemSelecionadoAutoCompleteCidade(item) {
            if (item) {
                if (item.codigo == null && item.descricao == null && item.uf) {
                    vm.area.cidade.codigo = 0;
                    vm.area.cidade.descricao = null;
                    vm.area.cidade.uf = item.uf;
                }
                else
                    vm.area.cidade = item;
            } else {
                vm.area.cidade = null;
                vm.textoDePesquisaAutoCompleteCidade = "";
            }
        }

        /**
         * Método que realiza uma requisição para api para buscar as cidades em tempo de excução, * com base no que o usuário está digitando
         * @param {string} query 
         */
        function pesquisarAutoCompleteCidade(query) {
            return ServicosGenericoService.pesquisarAutoCompleteDescricaoGenericoApi(Api.endereco.cidade.listarPor, query);
        }

        function editarResponsabilidade(modelo) {
            return RequisicaoGenericaService.editar(Api.trabalhe_conosco.areaAtuacao.atualizar, modelo);
        }

        function salvarResponsabilidade(modelo) {
            return RequisicaoGenericaService.salvar(Api.trabalhe_conosco.areaAtuacao.criar, modelo);
        }

        function onChangePeso() {
            if (vm.habilidadeAdicionada.peso && vm.habilidadeAdicionada.peso > 10)
                vm.habilidadeAdicionada.peso = 10;
        }

        function onChangePesoTabela(habilidade) {
            if (habilidade.peso && habilidade.peso > 10)
                habilidade.peso = 10;
            else if (habilidade.peso === "" || habilidade.peso < 0) {
                MdDialogService.alertPadrao("Atenção",
                    null,
                    "Peso deve ser maior ou igual a zero.");
            }
        }


        /**
          * Método que limpa o texto de pesquisa do md-auto-complete da Habilidade
          */
        function configuraAutoCompleteHabilidadeOnBlur() {
            if (!vm.area.exigencias) {
                vm.textoDePesquisaAutoCompleteHabilidade = "";
            }
        }

        /**
          * Método que controla qual habilidade está selecionada no campo md-auto-complete da Habilidade
          * @param {object} item 
          */
        function alterarItemSelecionadoAutoCompleteHabilidade(item) {
            if (item && item != null) {
                if (item.codigo) {
                    vm.habilidadeAdicionada.codigoHabilidade = item.codigo;
                    vm.habilidadeAdicionada.descricao = item.descricao;
                    vm.habilidadeAdicionada.peso = 0;

                    vm.novaHabilidade = {
                        codigoHabilidade: item.codigo,
                        descricao: item.descricao,
                        peso: 0,
                        flag: "I"
                    };
                }
            } else {
                if (vm.novaHabilidade) {
                    vm.novaHabilidade.codigoHabilidade = null;
                    vm.novaHabilidade.descricao = "";
                    vm.novaHabilidade.peso = 0;
                    vm.novaHabilidade.flag = "";
                }
                //vm.textoDePesquisaAutoCompleteHabilidade = "";
            }
        }

        /**
          * Método que realiza uma requisição para api para buscar as habilidades em tempo de excução, * com base no que o usuário está digitando
          * @param {string} query 
          */
        function pesquisarAutoCompleteHabilidade(query) {
            return ServicosGenericoService.pesquisarAutoCompleteDescricaoGenericoApiComParam(Api.trabalhe_conosco.habilidade.listarPor, query, vm.area.categoriaCodigo);
        }

        function salvarHabilidade(modelo) {
            return RequisicaoGenericaService.salvar(Api.trabalhe_conosco.areaAtuacao.criar, modelo);
        }

        function editarHabilidade(modelo) {
            return RequisicaoGenericaService.editar(Api.trabalhe_conosco.areaAtuacao.atualizar, modelo);
        }

        function selecionarHabilidade(index, habilidade) {
            if (vm.habilidadeSelecionada) {
                MdDialogService.alertPadrao("Atenção",
                    null,
                    "Salve as alterações realizadas na habilidade " + vm.habilidadeSelecionada.descricao +
                    " para alterar uma nova categoria.")
            }
            else {
                vm.EditandoHabilidade = true;
                vm.habilidadeAdicionada.descricao = habilidade.descricao;
                vm.habilidadeAdicionada.peso = habilidade.peso;

                vm.TextoBotao = "Salvar";
            }
        }

        function alterarPesoHabilidade(habilidade) {
            for (var i = vm.area.exigencias.length - 1; i >= 0; i--) {
                if (vm.area.exigencias[i].descricao === habilidade.descricao) {
                    vm.area.exigencias[i].peso = habilidade.peso;
                    vm.area.exigencias[i].flag = "A";
                }
            }

            vm.controladorBotaoAdicionar = false;
            editar(vm.area).then(
                function (success) {
                    vm.controladorBotaoAdicionar = true;

                    vm.habilidadeIndexSelecionada = null;
                    vm.habilidadeSelecionada = null;

                    vm.habilidadeAdicionada.codigoHabilidade = null;
                    vm.habilidadeAdicionada.descricao = "";
                    vm.habilidadeAdicionada.peso = 0;

                    vm.TextoBotao = "Adicionar";
                    vm.EditandoHabilidade = false;
                },
                function (error) {

                }
            );
        }

        function adicionarHabilidadeAreaAtuacao() {
            if (verificaHabilidadeInserida(vm.novaHabilidade.codigoHabilidade) == false) {
                vm.novaHabilidade.peso = vm.habilidadeAdicionada.peso;
                vm.area.exigencias.push(vm.novaHabilidade);

                vm.TextoBotao = "Adicionar";
                vm.EditandoHabilidade = false;

                vm.habilidadeAdicionada.codigoHabilidade = null;
                vm.habilidadeAdicionada.descricao = "";
                vm.habilidadeAdicionada.peso = 0;

                vm.controleForm.emProgresso = true;
                vm.controladorBotaoAdicionar = false;

                editar(vm.area).then(
                    function (success) {
                        vm.area.exigencias = success.data.exigencias;
                        vm.controleForm.emProgresso = false;
                        vm.controladorBotaoAdicionar = true;

                        vm.novaHabilidade.codigoHabilidade = null;
                        vm.novaHabilidade.descricao = "";
                        vm.novaHabilidade.peso = 0;
                        vm.novaHabilidade.flag = "I";
                    },
                    function (erro) {
                        vm.controleForm.emProgresso = false;
                    }
                );
            } else {
                MdDialogService.alertPadrao("Atenção",
                    null,
                    "Habilidade já inserida.")
            }
        }

        function excluirHabilidade(habilidade) {
            habilidade.flag = "D";

            vm.controleForm.emProgresso = true;
            editar(vm.area).then(
                function (success) {
                    vm.area.exigencias = success.data.exigencias;
                    vm.controleForm.emProgresso = false;
                },
                function (eror) {
                    vm.controleForm.emProgresso = false;
                });
        }

        function verificaHabilidadeInserida(habilidadeCodigo) {
            return vm.area.exigencias.some(function (item) {
                return ((habilidadeCodigo) == (item.codigoHabilidade));
            });
        }

        function verificaOperacaoHabilidade(operacao, habilidade) {
            if (habilidade.descricao != "") {
                vm.form.areaatuacao.habilidade.$setUntouched();
                vm.form.areaatuacao.habilidade.$setPristine();
                if (operacao === "Adicionar" && vm.novaHabilidade && vm.novaHabilidade.flag === "I") {
                    adicionarHabilidadeAreaAtuacao();
                }
                else if (operacao === "Salvar") {
                    alterarPesoHabilidade(habilidade);
                }
            }
        }

        function cancelaEdicaoHabilidade() {
            vm.habilidadeAdicionada.codigoHabilidade = null;
            vm.habilidadeAdicionada.descricao = null;
            vm.habilidadeAdicionada.peso = 0;

            vm.TextoBotao = "Adicionar";
            vm.EditandoHabilidade = false;
        }
        //#endregion

    }
})();

(function () {
    'use strict';

    angular
        .module('app.sqlConsulta',[])
        .config(Config);

    function Config(
        $stateProvider,
        RotasHtml) {

        var rotasHtmlSql = RotasHtml.rotasConsultaSql;

        $stateProvider
            .state('app.geral_processamento_consultasql',{
                url: '/consultasql/',
                module: 'privado',
                params: {
                    parametros: null
                },
                views: {
                    'content@app': {
                        templateUrl: rotasHtmlSql.templateUrl,
                        controller: 'ConsultaSqlController as vm'
                    },
                    'sql-consulta-form@app.consultaSql': {
                        templateUrl: rotasHtmlSql.form
                    },
                    // 'sql-consulta-tabela@app.consultaSql': {
                    //     templateUrl: rotasHtmlSql.tabela
                    // }
                },
                // resolve: {
                //     ListarConsulta: function (Api,RequisicaoGenericaService) {
                //         return RequisicaoGenericaService.listarSemParams(Api.consultaSql.consulta);
                //     },
                // }
            });
    }

})();

/**
 * Created by nova on 20/06/2020.
 */
(function () {
    'use strict';

    angular
        .module('app.sqlConsulta')
        .controller('DialogPlanilhaController',DialogPlanilhaController);

    function DialogPlanilhaController(
        $http,
        $scope,
        Api,
        RotasHtml,
        RequisicaoGenericaService,
        $mdDialog,
        Consulta,
        MdToastService,
        MdDialogService,
        ArquivosService
    ) {
        var vm = this;

        vm.metodos = {
            fecharDialog: fecharDialog,
            montarPlanilhaExcel: montarPlanilhaExcel,
            baixarPlanilha: baixarPlanilha,

        }

        vm.htmlRota = RotasHtml.rotasConsultaSql;
        vm.nomePlanilha = "";
        vm.objeto = {};

        function montarPlanilhaExcel(nomePlanilha) {
            vm.nomePlanilha = nomePlanilha;
            vm.consulta = Consulta;
            vm.objeto.nomePlanilha = nomePlanilha;
            vm.objeto.consulta = vm.consulta.query;
            vm.requisicaoProgress = true;
            vm.mensagemPreloader = "Aguarde...";
            // vm.consulta.query = query;
            return RequisicaoGenericaService.listarComObjetoComplexo(Api.consultaSql.montarPlanilhaExcel,vm.objeto).then(
                function (success) {
                    vm.habilitaDownload = true;
                    vm.requisicaoProgress = false;
                    vm.mensagemPreloader = "";
                    vm.resultado = success.data;
                    baixarPlanilha(nomePlanilha);
                    MdToastService.toastPadrao("Planilha exportada com sucesso!");
                },
                function (error) {
                    MdDialogService.alertPadrao(error.data.Message);
                    vm.requisicaoProgress = false;
                    vm.mensagemPreloader = "";
                }
            );
        }

        function baixarPlanilha(nomePlanilha) {
            vm.objeto.nome = nomePlanilha;
            vm.objeto.extensao = "csv";
            vm.requisicaoProgress = true;
            vm.mensagemPreloader = "Aguarde...";

            ArquivosService.baixarArquivo(Api.consultaSql.baixarPlanilha,vm.objeto).then(
                function (success) {
                    vm.habilitaDownload = false;
                    vm.requisicaoProgress = false;
                    vm.nomePlanilha = "";
                    vm.mensagemPreloader = "";
                    MdToastService.toastPadrao("Planilha baixada com sucesso!");
                },
                function (error) {
                    MdDialogService.alertPadrao(error.data.Message);
                    vm.requisicaoProgress = false;
                    vm.mensagemPreloader = "";
                }
            )
        }

        function fecharDialog() {
            $mdDialog.hide();
        }
    }

})();

(function () {
    'use strict';

    angular
        .module('app.solicitacao.consulta.solicitacao')
        .controller('ConsultaSolicitacaoController', ConsultaSolicitacaoController);

    function ConsultaSolicitacaoController(
        $mdDialog,
        $stateParams,
        Api,
        ListarTodasSolicitacaoFases,
        ListarUsuarioPorDetalhe,
        MdDialogService,
        NavegacaoService,
        RequisicaoGenericaService,
        RotasHtml,
        SquadService,
        ToolbarService
    ) {
        var vm = this;
        NavegacaoService.setTituloAba('Consulta de solicitação');

        vm.rotasApi = Api.solicitacao.consulta;
        vm.htmlRotaLegenda = RotasHtml.solicitacao.consultaSolicitacao.dialogs.legenda;
        vm.htmlRota = RotasHtml.solicitacao.consultaSolicitacao;
        vm.solicitacaoFasesBkp = ListarTodasSolicitacaoFases.data;
        vm.solicitacaoContagemViewModel = {};
        vm.solicitacaoFases = [];
        vm.controleForm = {
            filtroAtivo: true,
            filtroConcluidas: {
                concluidas: false,
                naoConcluidas: false,
                ambos: false
            }
        }
        vm.squadUsuarioLogado = ListarUsuarioPorDetalhe.data.codigoSquads;
        vm.squads = SquadService.listarSquadsUsuarioLogado(vm.squadUsuarioLogado);
        ToolbarService.armazenarCodigoSquadUsuarioLogado(vm.squadUsuarioLogado);
        vm.tiposSolicitacao = [
            {
                codigo: 1,
                descricao: 'Concluídas'
            },
            {
                codigo: 2,
                descricao: 'Não concluídas'
            },
            {
                codigo: 3,
                descricao: 'Todas'
            }
        ]

        vm.cards = [
            {
                titulo: '3 ou menos dias para concluir', quantidade: 0, classe: 'md-red-bg',
                concluida: false, rota: vm.rotasApi.listarSolicitacoesComTresOuMenosDiasParaVencer
            },
            {
                titulo: 'Entre 4 e 5 dias para concluir', quantidade: 0, classe: 'md-yellow-bg',
                concluida: false, rota: vm.rotasApi.listarSolicitacoesEntreQuatroECincoDiasParaVencer
            },
            {
                titulo: 'Mais de 5 dias para concluir', quantidade: 0, classe: 'md-primary-bg',
                concluida: false, rota: vm.rotasApi.listarSolicitacoesComMaisDeCincoParaVencerOuOutras
            },

        ];

        vm.copiaCards = angular.copy(vm.cards);
        vm.sugestaoFiltro = {
            tipo: 2,
        }
        vm.metodos = {
            defineFiltro: defineFiltro,
            filtrar: filtrar,
            preencherObjetoDeContagem: preencherObjetoDeContagem,
            novaConsulta: novaConsulta,
            abrirDialogDetalhes: abrirDialogDetalhes,
            abrirDialogLegenda: abrirDialogLegenda,
            preenchimentoObjetoContagemGenerico: preenchimentoObjetoContagemGenerico,
            retornarDescricaoSquad: retornarDescricaoSquad
        }

        init();

        function init() {
            defineFiltro();
            if ($stateParams.solicitacoesNaoVisualizadas) {
                vm.metodos.filtrar();
            }
            vm.squadCodigo = ToolbarService.squadSelecionado();
        }

        function defineFiltro() {
            var fasesDesmarcadas = vm.solicitacaoFases.reduce(function (prev, item) {
                if (vm.filtros.indexOf(item.codigo) < 0)
                    prev.push(item.codigo);
                return prev;
            }, []);

            vm.solicitacaoFases = vm.solicitacaoFasesBkp.reduce(function (prev, item) {
                if ((vm.sugestaoFiltro.tipo == '1') && (item.concluida)) {
                    prev.push(item);
                }
                else if ((vm.sugestaoFiltro.tipo == '2') && (!item.concluida)) {
                    prev.push(item);
                }
                else if ((vm.sugestaoFiltro.tipo == '3') && item) {
                    fasesDesmarcadas = [];
                    prev = vm.solicitacaoFasesBkp;
                }
                return prev;
            }, []);

            vm.filtros = vm.solicitacaoFases.reduce(function (prev, item) {
                if (fasesDesmarcadas.indexOf(item.codigo) < 0)
                    prev.push(item.codigo);
                return prev;
            }, [])
        }

        function filtrar(filtros) {
            vm.cards = angular.copy(vm.copiaCards);

            vm.controleForm.filtroConcluidas = vm.solicitacaoFases.reduce(function (prev, item) {
                if (vm.filtros.indexOf(item.codigo) >= 0) {
                    if (item.concluida)
                        prev.concluidas = true;
                    else if (!item.concluida)
                        prev.naoConcluidas = true;
                }
                return prev;
            }, { concluidas: false, naoConcluidas: false });

            preenchimentoObjetoContagemGenerico(filtros);
            preencherObjetoDeContagem();
            setDescricaoFiltros();
            setTipoFiltro();
            vm.controleForm.filtroAtivo = false;
        }

        function montarParametrosRequisicao() {
            var parametros = '?concluida=' + vm.controleForm.filtroConcluidas.concluidas;
            parametros += '&squadCodigo=' + vm.squadCodigo;
            vm.filtros.forEach(function (fase) {
                parametros += '&solicitacaoFase=' + fase
            });
            return parametros;
        }

        function preenchimentoObjetoContagemGenerico(filtros) {
            var parametros = '?squadCodigo=' + vm.squadCodigo;
            filtros.forEach(function (filtro) {
                parametros += '&generico=' + filtro
            });

            vm.requisicaoSolicitada = true;
            RequisicaoGenericaService.listarSemParams(vm.rotasApi.listarSolicitacoesGenericas + parametros).then(
                function (success) {
                    success.data.forEach(function (item) {
                        item.classe = 'md-accent-bg';
                        item.concluida = true;
                        item.rota = vm.rotasApi.listarTodasSolicitacoes + item.codigoFase + "/" + vm.squadCodigo;
                        vm.cards.push(item);
                    });
                });
        }

        function preencherObjetoDeContagem() {
            vm.requisicaoSolicitada = true;
            RequisicaoGenericaService.listarSemParams(vm.rotasApi.retornarContagem + montarParametrosRequisicao()).then(
                function (success) {
                    vm.solicitacaoContagemViewModel = success.data;
                    vm.cards[0].quantidade = success.data.tresOuMenosDias;
                    vm.cards[1].quantidade = success.data.entreQuatroECincoDias;
                    vm.cards[2].quantidade = success.data.maisDeCincoDias;
                    vm.requisicaoSolicitada = false;
                }, function (error) {
                    alert(error)
                }
            )
        }

        function setDescricaoFiltros() {
            vm.descricaoFiltros = vm.solicitacaoFases.reduce(function (prev, item) {
                if (vm.filtros.indexOf(item.codigo) >= 0) {
                    prev.push(item.descricao);
                }
                return prev
            }, []).join(', ');
        }

        function setTipoFiltro() {
            vm.tipoFiltro = '';
            if (vm.controleForm.filtroConcluidas.concluidas) {
                vm.tipoFiltro = 'Concluídas';
            }
            if (vm.controleForm.filtroConcluidas.naoConcluidas) {
                if (vm.tipoFiltro.length)
                    vm.tipoFiltro += ', ';
                vm.tipoFiltro += 'Não concluídas';
            }
        }

        function novaConsulta() {
            vm.controleForm.filtroAtivo = true;
            vm.solicitacaoContagemViewModel = {}
            vm.cards.forEach(function (card) {
                card.quantidade = 0;
            })
        }

        function abrirDialogLegenda() {
            $mdDialog.show({
                controller: 'LegendaDialogController',
                controllerAs: 'vm',
                templateUrl: vm.htmlRotaLegenda,
                multiple: true,
                //parent: ---------------,
                targetEvent: event,
                clickOutsideToClose: false,
                locals: {

                }
            });
        }

        function abrirDialogDetalhes(card) {
            console.log(card);
            if (card.quantidade == 0) {
                MdDialogService.alertPadrao(
                    "Atenção!", null, "Não foi encontrado nenhum registro para a consulta realizada!");
                return;
            }
            vm.requisicaoSolicitada = true;
            RequisicaoGenericaService.listarSemParams(card.rota + montarParametrosRequisicao())
                .then(function (success) {
                    vm.requisicaoSolicitada = false;
                    $mdDialog.show({
                        controller: 'ConsultaSolicitacaoDialogController',
                        controllerAs: 'vm',
                        templateUrl: vm.htmlRota.dialogs.detalheConsultaSolicitacao,
                        targetEvent: event,
                        escapeToClose: false,
                        locals: {
                            ControleForm: vm.controleForm,
                            Dados: success.data,
                            Titulo: card.titulo.toLowerCase(),
                            SolicitacaoFases: vm.solicitacaoFasesBkp,
                            Concluida: card.concluida
                        }
                    }).then(function (alterouDados) {
                        if (alterouDados) {
                            vm.cards = []
                            preenchimentoObjetoContagemGenerico(vm.filtros);
                            vm.requisicaoSolicitada = false;
                        }
                    });
                }, function (error) {
                    vm.requisicaoSolicitada = false;
                    alert(error)
                });
        }

        function retornarDescricaoSquad() {
            return SquadService.descricaoSquad(vm.squadCodigo);
        }
    }

})();
(function(){
    'use strict';

    angular
        .module('app.solicitacao.cadastro.fase', [])
        .config(config);

    function config($stateProvider, RotasHtml){
        var rotasHtmlFase = RotasHtml.solicitacao.fase;
        $stateProvider
            .state('app.solicitacao_cadastro_fase', {
                url: '/solicitacao/cadastro/fase',
                module: 'privado',
                views : {
                        'content@app': {
                            templateUrl: rotasHtmlFase.templateUrl,
                            controller: 'FaseController as vm'
                        },
                        'fase-form@app.solicitacao_cadastro_fase' : {
                            templateUrl: rotasHtmlFase.form
                        },
                        'fase-table@app.solicitacao_cadastro_fase': {
                            templateUrl: rotasHtmlFase.table
                        }
                }
            });
    }

}());
(function () {
    'use strict';

    angular
        .module('app.solicitacao.cadastro.fase')
        .controller('FaseController', FaseController)

    /** @ngInject */
    function FaseController(RequisicaoGenericaService, Api, NavegacaoService, DatatableFactory) {
        var vm = this;
        NavegacaoService.setTituloAba('Solicitação fase');

        var rotasApi = Api.solicitacao.fase;

        init();

        function init() {
            vm.form = {};
            vm.fase = {};
            vm.entidadeDeEnvio = {
                intTamanhoPagina: 1,
                clsEntidade: vm.fase
            }

            vm.fase.exige_motivo = false;
        }

        vm.metodos = {
            criar: criar,
            excluir: excluir,
            atualizar: atualizar,
            pesquisar: pesquisar,
            construirDtOptions: construirDtOptions,
            selecionar: selecionar
        }


        function criar(modelo) {
            return RequisicaoGenericaService.salvar(rotasApi.criar, modelo);
        }

        function excluir(modelo) {
            return RequisicaoGenericaService.excluir(rotasApi.excluir, modelo.codigo);
        }

        function atualizar(modelo) {
            return RequisicaoGenericaService.editar(rotasApi.atualizar, modelo);
        }
        function pesquisar() {
            return RequisicaoGenericaService.listarComObjetoComplexo(rotasApi.listarComPaginacao, vm.entidadeDeEnvio);
        }

        function selecionar(posicaoEntidade) {
            vm.metodosExternosPgToolbar.metodoControladorExternoListarTodasEntidades(null, posicaoEntidade);
        }

        function construirDtOptions() {
            DatatableFactory.construirDtOptionsComPaginacaoProcessadoNoServidorParaToolbar
                (rotasApi.listarComPaginacaoDatatable, vm.entidadeDeEnvio.clsEntidade, '#datatable-fase',
                    [
                        DatatableFactory.construirColunaDeSelecionarPadrao(function (indexLinha) { vm.metodos.selecionar(indexLinha) }),
                        {
                            targets: 1,
                            name: "Codigo",
                            data: "codigo",
                            sortable: true
                        },
                        {
                            targets: 2,
                            name: "Descricao",
                            data: "descricao",
                            sortable: true
                        },
                        {
                            targets: 3,
                            name: "ExigirMotivo",
                            data: "exige_Motivo",
                            render: verificarDadosBool,
                            sortable: true
                        },
                        {
                            targets: 4,
                            name: "ConcluirSolicitacao",
                            data: "concluida",
                            render: verificarDadosBool,
                            sortable: true
                        }
                    ]);
        }

        function verificarDadosBool(data) {
            if (data)
                return "Sim";
            else
                return "Não";
        }
    }

}());
(function () {
    'use strict';

    angular
        .module('app.protecao.cadastro.tipolicenca', [])
        .config(Config);

    function Config($stateProvider, RotasHtml) {
        var rotasHtml = RotasHtml.protecaoCadastroTipoLicenca;
        $stateProvider
            .state('app.protecao_cadastro_tipolicenca', {
                url: '/protecao/cadastro/tipolicenca',
                module: 'privado',
                params: {
                    parametros: null
                },
                views: {
                    'content@app': {
                        templateUrl: rotasHtml.templateUrl,
                        controller: 'ProtecaoTipoLicencaController as vm'
                    },
                    'protecao-tipo-licenca-form@app.protecao_cadastro_tipolicenca': {
                        templateUrl: rotasHtml.form
                    },
                    'protecao-tipo-licenca-tabela@app.protecao_cadastro_tipolicenca': {
                        templateUrl: rotasHtml.tabela
                    }
                },
                resolve: {
                    ListarUsuarioPorDetalhe: function (Api, RequisicaoGenericaService, LoginUsuarioService) {
                        return RequisicaoGenericaService.listarSemParams(Api.usuario.detalhes_usuario.listarDetalhesUsuario
                            + LoginUsuarioService.usuarioArmazenado().codigo);
                    },
                    ListarProdutos: function (Api, RequisicaoGenericaService, ListarUsuarioPorDetalhe) {
                        var objetoCodigoSquads = {
                            codigoSquads: ListarUsuarioPorDetalhe.data.codigoSquads,
                        }
                        return RequisicaoGenericaService.listarComObjetoComplexo(
                            Api.produto.listarProdutoSoftwareProprio, objetoCodigoSquads
                        );
                    },
                }
            });
    }

})();

(function () {
    'use strict';

    angular.module('app.protecao.cadastro.tipolicenca')
        .controller('ProtecaoTipoLicencaController', ProtecaoTipoLicencaController);

    function ProtecaoTipoLicencaController(Api, NavegacaoService, RequisicaoGenericaService, DatatableFactory, ListarProdutos) {
        var vm = this;
        NavegacaoService.setTituloAba('Tipo de licença');

        //#region Data

        var rotas = Api.protecao.tipoLicenca;

        vm.form = {};

        _init();
        //#endregion

        //#region  Definição dos Métodos region
        vm.metodos = {
            pesquisar: pesquisar,
            salvar: salvar,
            editar: editar,
            excluir: excluir,
            selecionar: selecionar,
            construirDtOptions: construirDtOptions,
            configuraMdSelectProduto: configuraMdSelectProduto
        }

        var metodosInternos = {
            _init: _init
        }

        //#endregion       

        //#region Métodos Internos

        function _init() {
            vm.tipoLicenca = {};
            vm.tipoLicencas = [];
            vm.produtos = ListarProdutos.data;
        }

        //#endregion

        //#region Métodos

        function pesquisar() {
            return RequisicaoGenericaService.listarComObjetoComplexo(rotas.listarComPaginacao, vm.entidadeDeEnvio);
        }

        function salvar(modelo) {
            return RequisicaoGenericaService.salvar(rotas.criar, modelo);
        }

        function editar(modelo) {
            return RequisicaoGenericaService.editar(rotas.atualizar, modelo)
        }

        function excluir(modelo) {
            return RequisicaoGenericaService.excluir(rotas.excluir, modelo.codigo)
        }

        function selecionar(posicaoEntidade) {
            vm.metodosExternosPgToolbar.metodoControladorExternoListarTodasEntidades(null, posicaoEntidade);
        }

        function construirDtOptions() {
            DatatableFactory.construirDtOptionsComPaginacaoProcessadoNoServidorParaToolbar
                (rotas.listarComPaginacaoDatatable, vm.entidadeDeEnvio.clsEntidade, '#datatable-protecao-cadastro-tipolicenca',
                [
                    DatatableFactory.construirColunaDeSelecionarPadrao(function (indexLinha) { vm.metodos.selecionar(indexLinha); }),
                    {
                        targets: 1,
                        name: "Descricao",
                        data: "descricao",
                        defaultContent: ""                     
                    }
                ]);
        }

        function configuraMdSelectProduto() {
            vm.filtrarProduto = "";
            angular.element('#tipo-licenca-produto-md-select').on('keydown', function (ev) {
                ev.stopPropagation();
            });
        }

        //#endregion

    }
})();

/**
 * Created by nova on 18/07/2016.
 */
(function () {
    'use strict';

    angular
        .module('app.planejamentoScrum.cadastro.feriado', [])
        .config(config);

    function config($stateProvider, RotasHtml) {
        var rotasHtmlFeriado = RotasHtml.feriado;
        $stateProvider
            .state('app.planejamento_cadastro_feriado', {
                url: '/planejamento/cadastro/feriado',
                module: 'privado',
                views: {
                    'content@app': {
                        templateUrl: rotasHtmlFeriado.templateUrl,
                        controller: "FeriadoController as vm"
                    },
                    'feriado-form@app.planejamento_cadastro_feriado': {
                        templateUrl: rotasHtmlFeriado.form
                    },
                    'feriados-tabela@app.planejamento_cadastro_feriado': {
                        templateUrl: rotasHtmlFeriado.tabela
                    }
                }
            });
    }

})();

/**
 * Created by nova on 19/07/2016.
 */
(function () {
    'use strict';

    angular.module('app.planejamentoScrum.cadastro.feriado')
        .controller('FeriadoController', FeriadoController);

    function FeriadoController($filter, Api, NavegacaoService, PgToolbarService, RequisicaoGenericaService, DatatableFactory, ProximoCodigoService, MdDialogService) {
        var vm = this;
        NavegacaoService.setTituloAba('Cadastro de feriado');

        //<editor-fold desc="Data">
        // Data region
        vm.feriado = {};
        vm.feriados = null;

        vm.rota = Api.feriado.proximoCodigo;
        // endregion
        //</editor-fold>

        vm.metodosGeral = {
            PreDefinirCamposParaInserir: PreDefinirCamposParaInserir
        };

        //<editor-fold desc="Definição dos Métodos">
        // Definição dos Métodos region
        vm.metodosFeriado = {
            pesquisar: pesquisar,
            salvar: salvar,
            editar: editar,
            excluir: excluir,
            selecionar: selecionar,
            construirDtOptions: construirDtOptions
        };
        //endregion
        //</editor-fold>

        /**
         * Método chamado quando é clicado no botão de inserir da toolbar, já pré definindo alguns campos
         */
        function PreDefinirCamposParaInserir() {

            // Defini de forma automática o próximo código do feriado
            PgToolbarService.iniciarPreLoaderToolbar(vm.controleForm, vm.controlePreloader);
            ProximoCodigoService.proximoCodigo(Api.feriado.proximoCodigo).then(
                function (success) {
                    vm.feriado = { codigo: success.data }
                    PgToolbarService.finalizarPreLoaderToolbar(vm.controleForm, vm.controlePreloader);
                },
                function (error) {
                    PgToolbarService.finalizarPreLoaderToolbar(vm.controleForm, vm.controlePreloader);
                    MdDialogService.alertPadrao(error.data);
                });
        }

        //<editor-fold desc="Implementação dos Métodos">
        // Implementação dos Métodos region

        /**
         * Método para pesquisar uma lista de feriados
         */
        function pesquisar() {
            return RequisicaoGenericaService.listarComObjetoComplexo(Api.feriado.listarComPaginacao, vm.entidadeDeEnvio);
        }

        /**
         * 
         * @param {feriado} feriado 
         */
        function salvar(feriado) {
            return RequisicaoGenericaService.salvar(Api.feriado.criar, feriado);
        }

        /**
         * 
         * @param {feriado} feriado 
         */
        function editar(feriado) {
            return RequisicaoGenericaService.editar(Api.feriado.atualizar, feriado)
        }

        /**
         * 
         * @param {feriado} feriado 
         */
        function excluir(feriado) {
            return RequisicaoGenericaService.excluir(Api.feriado.excluir, feriado.codigo)
        }

        /**
         * Método utilizado no modo exibido tabela, para selecionar um feriado
         * @param {feriado} feriado 
         */
        function selecionar(posicaoEntidade) {
            vm.metodosExternosPgToolbar.metodoControladorExternoListarTodasEntidades(null, posicaoEntidade);
        }

        /**
         * Método para construi o DtOptions da tabela
         */
        function construirDtOptions() {
            DatatableFactory.construirDtOptionsComPaginacaoProcessadoNoServidorParaToolbar
                (Api.feriado.listarComPaginacaoDatatable, vm.entidadeDeEnvio.clsEntidade, '#datatable-feriado',
                    [

                        DatatableFactory.construirColunaDeSelecionarPadrao(function (indexLinha) { vm.metodosFeriado.selecionar(indexLinha) }),
                        {
                            targets: 1,
                            name: "Descricao",
                            data: "descricao",
                            defaultContent: ""
                        },
                        {
                            targets: 2,
                            name: "Data",
                            data: "data",
                            render: function (data) {
                                return $filter('date')(data, 'dd/MM/yyyy')
                            },
                            defaultContent: ""
                        },
                    ]);
        }
        //endregion
        //</editor-fold>

    }
})();

/**
 * Created by nova on 18/08/2016.
 */
(function () {
    'use strict';

    angular
        .module('app.planejamentoScrum.cadastro.situacao', [])
        .config(config);

    function config($stateProvider, RotasHtml) {
        var rotasHtmlSituacaoEstoria = RotasHtml.situacao_estoria;
        $stateProvider
            .state('app.planejamento_cadastro_situacao', {
                url: '/planejcadastro/cadastro/situacao',
                module: 'privado',
                views: {
                    'content@app': {
                        templateUrl: rotasHtmlSituacaoEstoria.templateUrl,
                        controller: 'SituacaoEstoriaController as vm'
                    },
                    'situacao-estoria-form@app.planejamento_cadastro_situacao': {
                        templateUrl: rotasHtmlSituacaoEstoria.form
                    },
                    'situacoes-estoria-tabela@app.planejamento_cadastro_situacao': {
                        templateUrl: rotasHtmlSituacaoEstoria.tabela
                    }
                }
            });
    }

})();

/**
 * Created by nova on 18/08/2016.
 */
(function () {
    'use strict';

    angular
        .module('app.planejamentoScrum.cadastro.situacao')
        .controller("SituacaoEstoriaController", SituacaoEstoriaController);

    function SituacaoEstoriaController(Api, NavegacaoService, RequisicaoGenericaService, DatatableFactory) {
        var vm = this;
        NavegacaoService.setTituloAba('Cadastro de situação história');

        // <editor-fold desc="Data">
        // Data region
        vm.situacao = {};
        vm.situacoes = null;

        vm.rota = Api.situacao.proximoCodigo;
        // endregion
        //</editor-fold>      

        // <editor-fold desc="Definição dos Métodos">
        // Definição dos Métodos region
        vm.metodosSituacao = {
            pesquisar: pesquisar,
            salvar: salvar,
            editar: editar,
            excluir: excluir,
            selecionar: selecionar,
            construirDtOptions: construirDtOptions
        };
        // endregion
        //</editor-fold>

        // <editor-fold desc="Implementação dos Métodos">
        // Implementação dos Métodos region

        /**
         * Método para pesquisar uma lista de situações 
         */
        function pesquisar() {
            return RequisicaoGenericaService.listarComObjetoComplexo(Api.situacao.listarComPaginacao, vm.entidadeDeEnvio);
        }

        /**
         * 
         * @param {situacao} situacao 
         */
        function salvar(situacao) {
            return RequisicaoGenericaService.salvar(Api.situacao.criar, situacao);
        }

        /**
         * 
         * @param {situcao} situacao 
         */
        function editar(situacao) {
            return RequisicaoGenericaService.editar(Api.situacao.atualizar, situacao);
        }

        /**
         * 
         * @param {situcao} situacao 
         */
        function excluir(situacao) {
            return RequisicaoGenericaService.excluir(Api.situacao.excluir, situacao.codigo);
        }

        /**
         * Método utilizado no modo exibido tabela, para selecionar uma situação
         * @param {situacao} situacao 
         */
        function selecionar(posicaoEntidade) {
            vm.metodosExternosPgToolbar.metodoControladorExternoListarTodasEntidades(null, posicaoEntidade);
        }

        /**
         * Método para construi o DtOptions da tabela
         */
        function construirDtOptions() {
            DatatableFactory.construirDtOptionsComPaginacaoProcessadoNoServidorParaToolbar
                (Api.situacao.listarComPaginacaoDatatable, vm.entidadeDeEnvio.clsEntidade, '#datatable-situacao-estoria',
                [

                    DatatableFactory.construirColunaDeSelecionarPadrao(function (indexLinha) { vm.metodosSituacao.selecionar(indexLinha) }),
                    {
                        targets: 1,
                        name: "Codigo",
                        data: "codigo",
                        defaultContent: ""
                    },
                    {
                        targets: 2,
                        name: "Descricao",
                        data: "descricao",
                        defaultContent: ""
                    },
                    {
                        targets: 3,
                        name: "AbatePontos",
                        data: "abatePontos",
                        defaultContent: "",
                        render: function(data){
                            return data ? "Sim" : "Não";
                        }
                    },
                    {
                        targets: 4,
                        name: "GeraRetrabalho",
                        data: "geraRetrabalho",
                        defaultContent: "",
                        render: function (data) {
                            return data ? "Sim" : "Não";
                        }
                    },
                    {
                        targets: 5,
                        name: "FinalizaProcesso",
                        data: "finalizaProcesso",
                        defaultContent: "",
                        render: function (data) {
                            return data ? "Sim" : "Não";
                        }
                    },
                    {
                        targets: 6,
                        name: "ExigeMotivo",
                        data: "exigeMotivo",
                        defaultContent: "",
                        render: function (data) {
                            return data ? "Sim" : "Não";
                        }
                    }
                ]);
        }
        //endregion
        //</editor-fold>
    }

})();

(function () {
    'use strict';

    angular
        .module('app.planejamentoScrum.cadastro.tipo', [])
        .config(config);

    function config($stateProvider, RotasHtml) {
        var rotasHtmlTipoHistoria = RotasHtml.tipoHistoria;
        $stateProvider
            .state('app.planejamento_cadastro_tipo', {
                url: '/planejamento/cadastro/tipo-historia',
                module: 'privado',
                views: {
                    'content@app': {
                        templateUrl: rotasHtmlTipoHistoria.templateUrl,
                        controller: 'TipoHistoriaController as vm'
                    },
                    'tipo-historia-form@app.planejamento_cadastro_tipo': {
                        templateUrl: rotasHtmlTipoHistoria.form
                    },
                    'tipos-historia-tabela@app.planejamento_cadastro_tipo': {
                        templateUrl: rotasHtmlTipoHistoria.tabela
                    }
                }
            });
    }

})();

(function () {
    'use strict';

    angular
        .module('app.planejamentoScrum.cadastro.tipo')
        .controller("TipoHistoriaController", TipoHistoriaController);

    function TipoHistoriaController(
        Api,
        NavegacaoService,
        RequisicaoGenericaService,
        DatatableFactory
    ) {
        var vm = this;
        NavegacaoService.setTituloAba('Cadastro de tipo de história');

        vm.tipoHistoria = {};
        vm.tiposHistoria = null;

        vm.metodos = {
            pesquisar: pesquisar,
            salvar: salvar,
            editar: editar,
            excluir: excluir,
            selecionar: selecionar,
            construirDtOptions: construirDtOptions,
            preDefinirParaInsercao: preDefinirParaInsercao
        };

        
        function pesquisar() {
            return RequisicaoGenericaService.listarComObjetoComplexo(
                Api.tipo_historia.listarComPaginacao, vm.entidadeDeEnvio);
        }

        /**
         * 
         * @param {tipoHistoria} tipoHistoria 
         */
        function salvar(tipoHistoria) {
            return RequisicaoGenericaService.salvar(Api.tipo_historia.criar, tipoHistoria);
        }

        /**
         * 
         * @param {tipoHistoria} tipoHistoria 
         */
        function editar(tipoHistoria) {
            return RequisicaoGenericaService.editar(Api.tipo_historia.atualizar, tipoHistoria);
        }

        /**
         * 
         * @param {tipoHistoria} tipoHistoria 
         */
        function excluir(tipoHistoria) {
            return RequisicaoGenericaService.excluir(Api.tipo_historia.excluir, tipoHistoria.codigo);
        }

        /**
         * Método utilizado no modo exibido tabela, para selecionar um tipo de história
         * @param {tipoHistoria} tipoHistoria 
         */
        function selecionar(posicaoEntidade) {
            vm.metodosExternosPgToolbar.metodoControladorExternoListarTodasEntidades(null, posicaoEntidade);
        }

        function construirDtOptions() {
            DatatableFactory.construirDtOptionsComPaginacaoProcessadoNoServidorParaToolbar
                (Api.tipo_historia.listarComPaginacaoDatatable, vm.entidadeDeEnvio.clsEntidade, '#datatable-tipo-historia',
                    [

                        DatatableFactory.construirColunaDeSelecionarPadrao(function (indexLinha) { vm.metodos.selecionar(indexLinha) }),
                        {
                            targets: 1,
                            name: "Descricao",
                            data: "descricao",
                            defaultContent: ""

                        },
                        {
                            targets: 2,
                            name: "Ativo",
                            data: "ativo",
                            defaultContent: "",
                            render: function (data) {
                                return data ? "Sim" : "Não";
                            }

                        }
                    ]);
        }

        function preDefinirParaInsercao() {
            vm.tipoHistoria = {
                ativo: true
            }
        }
    }

})();

/**
 * Created by nova on 16/08/2016.
 */
(function () {
    'use strict';

    angular
        .module('app.planejamentoScrum.cadastro.plataforma', [])
        .config(config);

    function config($stateProvider, RotasHtml) {
        var rotasHtmlPlataforma = RotasHtml.plataforma
        $stateProvider
            .state('app.planejamento_cadastro_plataforma', {
                url: '/planejamento/cadastro/plataforma',
                module: 'privado',
                views: {
                    'content@app': {
                        templateUrl: rotasHtmlPlataforma.templateUrl,
                        controller: 'PlataformaController as vm'
                    },
                    'plataforma-form@app.planejamento_cadastro_plataforma': {
                        templateUrl: rotasHtmlPlataforma.form
                    },
                    'plataforma-tabela@app.planejamento_cadastro_plataforma': {
                        templateUrl: rotasHtmlPlataforma.tabela
                    }
                }
            });
    }

})();

/**
 * Created by nova on 16/08/2016.
 */
(function () {
    'use strict';

    angular
        .module('app.planejamentoScrum.cadastro.plataforma')
        .controller('PlataformaController', PlataformaController);

    function PlataformaController(Api, NavegacaoService, RequisicaoGenericaService, DatatableFactory) {
        var vm = this;
        NavegacaoService.setTituloAba('Cadastro de plataforma');

        // <editor-fold desc="Data">
        // Data region
        vm.form = {};

        vm.rota = Api.sistemaOperacional.proximoCodigo;
        // endregion
        //</editor-fold>

        // <editor-fold desc="Definição dos Métodos">
        // Definição dos Métodos region
        vm.metodosPlataforma = {
            pesquisar: pesquisar,
            salvar: salvar,
            editar: editar,
            excluir: excluir,
            selecionar: selecionar,
            construirDtOptions: construirDtOptions
        };
        // endregion
        //</editor-fold>

        // <editor-fold desc="Implementação dos Métodos">
        // Implementação dos Métodos region

        /**
         * Método para pesquisar uma lista de plataformas
         */
        function pesquisar() {
            return RequisicaoGenericaService.listarComObjetoComplexo(Api.sistemaOperacional.listarComPaginacao, vm.entidadeDeEnvio);
        }

        /**
         * 
         * @param {plataforma} plataforma 
         */
        function salvar(plataforma) {
            return RequisicaoGenericaService.salvar(Api.sistemaOperacional.criar, plataforma);
        }

        /**
         * 
         * @param {plataforma} plataforma 
         */
        function editar(plataforma) {
            return RequisicaoGenericaService.editar(Api.sistemaOperacional.atualizar, plataforma)
        }

        /**
         * 
         * @param {plataforma} plataforma 
         */
        function excluir(plataforma) {
            return RequisicaoGenericaService.excluir(Api.sistemaOperacional.excluir, plataforma.codigo)
        }

        /**
         * Método utilizado no modo exibido tabela, para selecionar uma plataforma
         * @param {plataforma} plataforma 
         */
        function selecionar(posicaoEntidade) {
            vm.metodosExternosPgToolbar.metodoControladorExternoListarTodasEntidades(null, posicaoEntidade);
        }

        /**
         * Método para construi o DtOptions da tabela
         */
        function construirDtOptions() {
            DatatableFactory.construirDtOptionsComPaginacaoProcessadoNoServidorParaToolbar
                (Api.sistemaOperacional.listarComPaginacaoDatatable, vm.entidadeDeEnvio.clsEntidade, '#datatable-plataforma',
                [

                    DatatableFactory.construirColunaDeSelecionarPadrao(function (indexLinha) { vm.metodosPlataforma.selecionar(indexLinha) }),
                    {
                        targets: 1,
                        name: "Codigo",
                        data: "codigo",
                        defaultContent: ""
                    },
                    {
                        targets: 2,
                        name: "Descricao",
                        data: "descricao",
                        defaultContent: ""
                    }
                ]);
        }
        // endregion
        // </editor-fold>
    }
})();

/**
 * Created by nova on 26/10/2016.
 */
(function () {
    'use strict';

    angular
        .module('app.planejamentoScrum.cadastro.registroSituacao', [])
        .config(Config);

    function Config($stateProvider, RotasHtml) {
        var rotasHtmlRegistroSituacao = RotasHtml.registroSituacao;
        $stateProvider
            .state('app.planejamento_cadastro_registro_situacao', {
                url: '/planejamento/cadastro/registro-situacao',
                module: 'privado',
                views: {
                    'content@app': {
                        templateUrl: rotasHtmlRegistroSituacao.templateUrl,
                        controller: "RegistroSituacaoController as vm"
                    },
                    'registro-situacao-form@app.planejamento_cadastro_registro_situacao': {
                        templateUrl: rotasHtmlRegistroSituacao.form
                    },
                    'registros-situacoes-tabela@app.planejamento_cadastro_registro_situacao': {
                        templateUrl: rotasHtmlRegistroSituacao.tabela
                    }
                }
            });
    }

})();

/**
 * Created by nova on 26/10/2016.
 */
(function () {
    'use strict';

    angular
        .module('app.planejamentoScrum.cadastro.registroSituacao')
        .controller('RegistroSituacaoController', RegistroSituacaoController);

    function RegistroSituacaoController(Api, NavegacaoService, RequisicaoGenericaService, DatatableFactory) {
        var vm = this;
        NavegacaoService.setTituloAba('Cadastro de situação');

        // Data region
        vm.form = {};
        //endregion

        //<editor-fold desc="Definição dos Métodos">
        // Definição dos Métodos region
        vm.metodosRegistroSituacao = {
            pesquisar: pesquisar,
            salvar: salvar,
            editar: editar,
            excluir: excluir,
            selecionar: selecionar,
            construirDtOptions: construirDtOptions
        };
        //endregion
        //</editor-fold>

        //<editor-fold desc="Implementação dos Métodos">
        // Implementação dos Métodos region

        /**
         * Método para pesquisar uma lista de Situações da estória
         */
        function pesquisar() {
            return RequisicaoGenericaService.listarComObjetoComplexo(Api.sprint.registro_situacao.listarComPaginacao, vm.entidadeDeEnvio);
        }

        /**
         * 
         * @param {registroSituacao} registroSituacao 
         */
        function salvar(registroSituacao) {
            return RequisicaoGenericaService.salvar(Api.sprint.registro_situacao.criar, registroSituacao);
        }

        /**
         * 
         * @param {registroSituacao} registroSituacao 
         */
        function editar(registroSituacao) {
            return RequisicaoGenericaService.editar(Api.sprint.registro_situacao.atualizar, registroSituacao)
        }

        /**
         * 
         * @param {registroSituacao} registroSituacao 
         */
        function excluir(registroSituacao) {
            return RequisicaoGenericaService.excluir(Api.sprint.registro_situacao.excluir, registroSituacao.codigo)
        }

        /**
         * Método utilizado no modo exibido tabela, para selecionar uma Situação
         * @param {registroSituacao} registroSituacao 
         */
        function selecionar(posicaoEntidade) {
            vm.metodosExternosPgToolbar.metodoControladorExternoListarTodasEntidades(null, posicaoEntidade);
        }

        /**
         * Método para construi o DtOptions da tabela
         */
        function construirDtOptions() {
            DatatableFactory.construirDtOptionsComPaginacaoProcessadoNoServidorParaToolbar
                (Api.sprint.registro_situacao.listarComPaginacaoDatatable, vm.entidadeDeEnvio.clsEntidade, '#datatable-registro-situacao',
                [

                    DatatableFactory.construirColunaDeSelecionarPadrao(function (indexLinha) { vm.metodosRegistroSituacao.selecionar(indexLinha) }),
                    {
                        targets: 1,
                        name: "Codigo",
                        data: "codigo",
                        defaultContent: ""
                    },
                    {
                        targets: 2,
                        name: "Descricao",
                        data: "descricao",
                        defaultContent: ""
                    }
                ]);
        }
        //endregion
        //</editor-fold>

    }

})();

/**
 * Created by nova on 18/08/2016.
 */
(function(){
  'use strict';

  angular
    .module('app.planejamentoScrum.cadastro.motivo', [])
    .config(config);

    function config($stateProvider, RotasHtml){
        var rotasHtmlMotivo = RotasHtml.motivo_estoria;
    $stateProvider
      .state('app.planejamento_cadastro_motivo', {
        url: '/planejamento/cadastro/motivo',
        module: 'privado',
        views: {
          'content@app':{
            templateUrl: rotasHtmlMotivo.templateUrl,
            controller: 'MotivoEstoriaController as vm'
          },
          'motivo-estoria-form@app.planejamento_cadastro_motivo':{
            templateUrl: rotasHtmlMotivo.form
          },
          'motivos-estoria-tabela@app.planejamento_cadastro_motivo':{
            templateUrl: rotasHtmlMotivo.tabela
          }
        }
      });
  }

})();

/**
 * Created by nova on 18/08/2016.
 */
(function () {
    'use strict';

    angular
        .module('app.planejamentoScrum.cadastro.motivo')
        .controller('MotivoEstoriaController', MotivoEstoriaController);

    function MotivoEstoriaController(Api, NavegacaoService, RequisicaoGenericaService, DatatableFactory) {
        var vm = this;
        NavegacaoService.setTituloAba('Cadastro de motivo da história');

        // <editor-fold desc="Data">
        // Data region
        vm.motivo = {};
        vm.motivos = null;

        vm.rota = Api.motivo.proximoCodigo;
        // endregion
        // </editor-fold>

        // <editor-fold desc="Definição dos Métodos">
        // Definição dos Métodos region
        vm.metodosMotivo = {
            pesquisar: pesquisar,
            salvar: salvar,
            editar: editar,
            excluir: excluir,
            selecionar: selecionar,
            construirDtOptions: construirDtOptions
        };
        //endregion
        //</editor-fold>

        // <editor-fold desc="Implemetação dos Métodos">
        // Implemetação dos Métodos region

        /**
         * Método para pesquisar uma lista de Motivos de Estória
         */
        function pesquisar() {
            return RequisicaoGenericaService.listarComObjetoComplexo(Api.motivo.listarComPaginacao, vm.entidadeDeEnvio);
        }

        /**
         * 
         * @param {motivo} motivo 
         */
        function salvar(motivo) {
            return RequisicaoGenericaService.salvar(Api.motivo.criar, motivo);
        }

        /**
         * 
         * @param {motivo} motivo 
         */
        function editar(motivo) {
            return RequisicaoGenericaService.editar(Api.motivo.atualizar, motivo)
        }

        /**
         * 
         * @param {motivo} motivo 
         */
        function excluir(motivo) {
            return RequisicaoGenericaService.excluir(Api.motivo.excluir, motivo.codigo)
        }

        /**
         * Método utilizado no modo exibido tabela, para selecionar um motivo de estória
         * @param {motivo} motivo 
         */
        function selecionar(posicaoEntidade) {
            vm.metodosExternosPgToolbar.metodoControladorExternoListarTodasEntidades(null, posicaoEntidade);
        }

        /**
         * Método para construi o DtOptions da tabela
         */
        function construirDtOptions() {
            DatatableFactory.construirDtOptionsComPaginacaoProcessadoNoServidorParaToolbar
                (Api.motivo.listarComPaginacaoDatatable, vm.entidadeDeEnvio.clsEntidade, '#datatable-motivo-estoria',
                [

                    DatatableFactory.construirColunaDeSelecionarPadrao(function (indexLinha) { vm.metodosMotivo.selecionar(indexLinha) }),
                    {
                        targets: 1,
                        name: "Codigo",
                        data: "codigo",
                        defaultContent: ""
                    },
                    {
                        targets: 2,
                        name: "Descricao",
                        data: "descricao",
                        defaultContent: ""
                    }
                ]);
        }
        // endregion
        // </editor-fold>
    }

})();

(function () {
    'use strict';

    angular.module('app.protecao.processamento.gerenciamentoprotecao')
        .controller('GerenciamentoProtecaoController', GerenciamentoProtecaoController);

    function GerenciamentoProtecaoController($q, Api, NavegacaoService, GerenciamentoProtecaoService, ListarTiposLicenca, RequisicaoGenericaService, ServicosGenericoService, LoginUsuarioService) {
        var vm = this;
        NavegacaoService.setTituloAba('Controle de proteção');


        //#region Data
        var rotas = Api.protecao.tipoLicenca;

        vm.form = {};
        vm.entidade = {};
        vm.entidades = [];
        vm.contratos = [];

        _init();
        //#endregion

        //#region  Definição dos Métodos region
        vm.metodos = {
            configuraAutoCompleteClienteOnBlur: configuraAutoCompleteClienteOnBlur,
            alterarItemSelecionadoAutoCompleteCliente: alterarItemSelecionadoAutoCompleteCliente,
            pesquisarAutoCompleteCliente: pesquisarAutoCompleteCliente,
            configuraMdSelectcontrato: configuraMdSelectcontrato,
            alterarItemSelecionadoContratoItem: alterarItemSelecionadoContratoItem,
            salvar: salvar,
            editarQuantidadeLicenca: editarQuantidadeLicenca,
            editar: editar,
            abrirDetalhesLicenca: abrirDetalhesLicenca,
            abrirOpcoesLicencas: abrirOpcoesLicencas,
            configuraMdSelectContratoItem: configuraMdSelectContratoItem
        }

        vm.metodosMenu = {
            protecaoAvulsaLicenca: protecaoAvulsaLicenca,
            protecaoAvulsaDataExpiracao: protecaoAvulsaDataExpiracao
        }

        //#region metodo menu
        function protecaoAvulsaLicenca(licencaSelecionada) {
            GerenciamentoProtecaoService.gerarProtecaoAvulsaPorLicenca(licencaSelecionada);
        }

        function protecaoAvulsaDataExpiracao(licencaSelecionada) {
            GerenciamentoProtecaoService.gerarProtecaoAvulsaPorDataExpiracao(licencaSelecionada);
        }
        //#endregion

        //#region Métodos

        function editar() {
            vm.habilitaEdicao = true;
            return salvar();
        }

        function abrirDetalhesLicenca(licenca, $event) {
            GerenciamentoProtecaoService.abrirDialogDetalhesLicenca(licenca);
        }

        function abrirOpcoesLicencas($mdMenu, ev) {
            // originatorEv = ev;
            $mdMenu.open(ev);
        }

        function editarQuantidadeLicenca(licencaSelecionada) {
            licencaSelecionada.contratoItemCodigo = vm.entidade.gerenciamento.contratoItemCodigo;
            GerenciamentoProtecaoService.abrirDialogEditarQuantidadeLicenca(licencaSelecionada);
        }

        function configuraAutoCompleteClienteOnBlur() {
            if (!vm.entidade.cliente) {
                vm.textoDePesquisaAutoCompleteCliente = "";
            }
        }

        function alterarItemSelecionadoAutoCompleteCliente(item) {
            if (item) {
                vm.entidade.cliente = item;
                _listarContratos(item.codigo);

            } else {
                vm.textoDePesquisaAutoCompleteCliente = "";
                vm.entidade.cliente = null;
                vm.entidade.contrato = null;
                vm.entidade.contratoItem = null;
                vm.entidade.gerenciamento = undefined;
                vm.contratos = [];

            }
        }

        function pesquisarAutoCompleteCliente(query) {
            return ServicosGenericoService.pesquisarAutoCompleteCodigoOuNomeGenericoApi(Api.cliente.listarCodigoDescricao, query);
        }

        function configuraMdSelectcontrato() {
            vm.filtrarcontratos = "";
            angular.element('#protecao-licenca-contrato-md-select').on('keydown', function (ev) {
                ev.stopPropagation();
            });
        }

        function configuraMdSelectContratoItem() {
            vm.filtrarContratoItem = "";
            angular.element('#protecao-licenca-contratoItem-md-select').on('keydown', function (ev) {
                ev.stopPropagation();
            });
        }

        function salvar() {
            var entidadeEnvio = {
                dataExpiracao: vm.entidade.gerenciamento.dataExpiracao,
                contratoItemCodigo: vm.entidade.gerenciamento.contratoItemCodigo
            }
            return GerenciamentoProtecaoService.atualizarDataExpiracao(entidadeEnvio);
        }

        function alterarItemSelecionadoContratoItem(item) {
            if (item) {
                _listarDetalhesGerenciamento(vm.entidade.cliente.codigo, item.produto.codigo, item.codigo);

                if (item.produto.codigo == 2 || item.produto.codigo == 3) {
                    vm.exibeLicencaTemporaria = true;
                } else {
                    vm.exibeLicencaTemporaria = false;
                }
            }
        }

        //#endregion

        //#region metodos internos
        function _constroiDtOptions() {
            vm.dtOptionsLicencas = GerenciamentoProtecaoService.retornaDtOptionsComColunas();
        }

        function _init() {
            vm.usuarioPermiteEdicao = LoginUsuarioService.usuarioArmazenado().detalhesUsuario.permitirAtualizarExpiracaoLicenca;
            if(!vm.usuarioPermiteEdicao){
                vm.dataMinimaExpiracao = null;
            }else{
                vm.dataMinimaExpiracao = new Date();
            }          
            vm.tiposLicencas = ListarTiposLicenca.data;
            vm.controladorAtivo = false;
            vm.controladorAtivo = GerenciamentoProtecaoService.controladorAtivo;
            vm.habilitaEdicao = false;
            vm.pesquisando = false;
            _constroiDtOptions();                     
        }

        function _listarContratos(codigoCliente) {
            vm.pesquisando = true;
            RequisicaoGenericaService.listarSemParams(Api.contrato.listarContratosAtivoPorCliente + codigoCliente).then(
                function (success) {
                    vm.pesquisando = false;
                    vm.contratos = success.data;
                },
                function (error) {
                    vm.pesquisando = false;
                    ServicosGenericoService.exibirAlertaDeErro(error, null);
                });

        }

        function _listarDetalhesGerenciamento(codigoCliente, codigoProduto, contratoItemCodigo) {
            vm.pesquisando = true;
            vm.entidade.gerenciamento = null;
            RequisicaoGenericaService.listarComParams(Api.protecao.gerenciamentoProtecao.listar, {
                contratoItemCodigo: contratoItemCodigo,
                codigoCliente: codigoCliente,
                codigoproduto: codigoProduto
            }).then(function (success) {                
                var dataMaxima = new Date(success.data.dataVencimentoContratoAtual);
                vm.entidade.gerenciamento = success.data;                
                vm.entidade.gerenciamento.dataVencimentoContratoAtual = dataMaxima;
                vm.pesquisando = false;                
            }, function (error) {
                vm.pesquisando = false;
            });
        }

    }
})();

(function () {
    'use strict';

    angular.module('app.protecao.processamento.licenca')
        .controller('ProtecaoLicencaController', ProtecaoLicencaController)
        .filter('filtraProdutoPorContrato', FiltraProdutoPorContrato);

    function ProtecaoLicencaController($state,
        Api,
        NavegacaoService,
        $q,
        RequisicaoGenericaService,
        DatatableFactory,
        ServicosGenericoService,
        MdDialogService,
        $timeout,
        $filter
    ) {
        var vm = this;
        NavegacaoService.setTituloAba('Proteção licenças');


        //#region Data
        vm.form = {};
        vm.controleForm = {};

        var _licencaTemporaria = null;

        var rotas = Api.protecao.licenca;

        init();
        //#endregion

        //#region  Definição dos Métodos region
        vm.metodos = {
            init: init,
            preDefinirCamposParaInsercao: preDefinirCamposParaInsercao,
            pesquisar: pesquisar,
            salvar: salvar,
            editar: editar,
            excluir: excluir,
            selecionar: selecionar,
            construirDtOptions: construirDtOptions,
            configuraAutoCompleteClienteOnBlur: configuraAutoCompleteClienteOnBlur,
            alterarItemSelecionadoAutoCompleteCliente: alterarItemSelecionadoAutoCompleteCliente,
            pesquisarAutoCompleteCliente: pesquisarAutoCompleteCliente,
            configuraMdSelectProduto: configuraMdSelectProduto,
            alterarItemSelecionadoProduto: alterarItemSelecionadoProduto,
            configuraAutoCompleteTiposLicencaOnBlur: configuraAutoCompleteTiposLicencaOnBlur,
            alterarItemSelecionadoAutoCompleteTiposLicenca: alterarItemSelecionadoAutoCompleteTiposLicenca,
            pesquisarAutoCompleteTiposLicenca: pesquisarAutoCompleteTiposLicenca,
            adicionarLicenca: adicionarLicenca,
            removerLicenca: removerLicenca,
            selecionarTodasLicencas: selecionarTodasLicencas
        };

        var metodosInternos = {
            _construirLicencaPadrao: _construirLicencaPadrao,
            _construirLicencaAposInsercao: _construirLicencaAposInsercao,
            _listarProdutos: _listarProdutos,
            _listarTiposLicenca: _listarTiposLicenca,
            _redefinirProdutosELicencas: _redefinirProdutosELicencas,
            _redefinirTipoLicencasELicencasSelecionadas: _redefinirTipoLicencasELicencasSelecionadas,
            _controlarSelecaoTodasLicencas: _controlarSelecaoTodasLicencas
        }

        //#endregion              

        //#region Métodos Internos

        function _construirLicencaPadrao() {
            return {
                cliente: null,
                clienteCodigo: null,
                produtoCodigo: null,
                produto: null,
                numero: null,
                usuario: null,
                todasLicencasSelecionadas: false,
                tiposLicenca: [],
                licencaTemporaria: null
            };
        }

        function _construirLicencaAposInsercao() {
            var retorno = {};
            if (_licencaTemporaria) {
                retorno = {
                    cliente: _licencaTemporaria.cliente,
                    clienteCodigo: _licencaTemporaria.clienteCodigo,
                    produto: _licencaTemporaria.produto,
                    produtoCodigo: _licencaTemporaria.produtoCodigo,
                    todasLicencasSelecionadas: _licencaTemporaria.todasLicencasSelecionadas,
                    tiposLicenca: []
                }
            }
            _licencaTemporaria = null;
            return retorno;
        }

        function _listarProdutos(codigoCliente) {
            vm.pesquisandoProdutos = true;
            RequisicaoGenericaService.listarSemParams(Api.produto.listarTodosProdutosAtivosCliente + codigoCliente).then(
                function (success) {
                    vm.pesquisandoProdutos = false;
                    vm.dataFormatada = $filter('date')(vm.licenca.dataHoraUltimaCarga, 'dd/MM/yyyy');
                    vm.produtos = success.data;
                },
                function (error) {
                    vm.pesquisandoProdutos = false;

                    ServicosGenericoService.exibirAlertaDeErro(error, null);
                });
        }

        function _listarTiposLicenca(codigoCliente, codigoProduto) {
            RequisicaoGenericaService.listarSemParams(Api.protecao.tipoLicenca.listarTiposLicencaPorClienteEProduto + codigoCliente + "/" + codigoProduto).then(
                function (success) {
                    vm.tipoLicencas = success.data;
                });
        }

        function _redefinirProdutosELicencas() {
            vm.produtos = [];
            vm.tipoLicencas = [];
        }

        function _redefinirTipoLicencasELicencasSelecionadas() {
            vm.tipoLicencas = [];
            vm.licenca.tiposLicenca = [];
            vm.licenca.todasLicencasSelecionadas = false;
        }

        function _controlarSelecaoTodasLicencas() {
            if (vm.licenca && vm.licenca.tiposLicenca && vm.licenca.tiposLicenca.length > 0 && vm.licenca.tiposLicenca.length == vm.tipoLicencas.length) {
                vm.licenca.todasLicencasSelecionadas = true;
            }
            else if (vm.licenca) {
                vm.licenca.todasLicencasSelecionadas = false;
            }
        }

        //#endregion

        //#region Métodos       

        function init() {
            vm.licenca = _construirLicencaPadrao();
            vm.licencas = [];
            vm.produtos = [];
            vm.tipoLicencas = [];

            vm.inserirNovaLicencaAposInsercao = false;
            vm.pesquisandoProdutos = false;

            vm.licencaAPesquisar = null;
            vm.codigoProtecao = null;
            vm.tipoLicencaSelecionado = null;
            vm.dataFormatada = null;
        }

        function preDefinirCamposParaInsercao() {
            vm.licenca = _construirLicencaAposInsercao();


            vm.dataFormatada = null;
        }

        function pesquisar() {
            var deferred = $q.defer();

            RequisicaoGenericaService.listarComObjetoComplexo(rotas.listarComPaginacao, vm.entidadeDeEnvio).then(
                function (success) {
                    vm.licenca = success.data.lstResultado[0];
                    vm.licencas = success.data.lstResultado;
                    success.data.atualizadoNoController = true;
                    deferred.resolve(success);

                    if (vm.licenca && vm.licenca.produto)
                        alterarItemSelecionadoProduto(vm.licenca.produto);
                },
                function (error) {
                    deferred.reject(error);
                });

            return deferred.promise;
        }

        function salvar(modelo) {
            var deferred = $q.defer();
            _licencaTemporaria = null;

            RequisicaoGenericaService.salvar(rotas.criar, modelo).then(
                function (success) {
                    MdDialogService.confirmPadraoComEvento("Deseja inserir outra licença ?", "", null,
                        function () {
                            _licencaTemporaria = angular.copy(success.data);

                            success.data.definirStatusToolbarParaInsercaoAposInsercao = true;

                            deferred.resolve(success);
                        },
                        function () {
                            deferred.resolve(success);
                        })
                },
                function (error) {
                    deferred.reject(error);
                });

            return deferred.promise;
        }

        function editar(modelo) {
            return RequisicaoGenericaService.editar(rotas.atualizar, modelo)
        }

        function excluir(modelo) {
            return RequisicaoGenericaService.excluir(rotas.excluir, modelo.codigo)
        }

        function selecionar(posicaoEntidade) {
            vm.metodosExternosPgToolbar.metodoControladorExternoListarTodasEntidades(null, posicaoEntidade);
        }

        function construirDtOptions() {
            DatatableFactory.construirDtOptionsComPaginacaoProcessadoNoServidorParaToolbar
                (rotas.listarComPaginacaoDatatable, vm.entidadeDeEnvio.clsEntidade, '#datatable-protecao-processamento-licenca',
                    [

                        DatatableFactory.construirColunaDeSelecionarPadrao(function (indexLinha) { vm.metodos.selecionar(indexLinha) }),
                        {
                            targets: 1,
                            name: "Cliente",
                            data: "cliente.nome",
                            defaultContent: ""
                        },
                        {
                            targets: 2,
                            name: "Produto",
                            data: "produto.descricao",
                            defaultContent: "",
                        },
                        {
                            targets: 3,
                            name: "Numero",
                            data: "numero",
                            defaultContent: "",
                        },
                        {
                            targets: 4,
                            name: "Leiturista/Equipe",
                            data: "leiturista",
                            defaultContent: "",
                        },
                        {
                            targets: 5,
                            name: "Data da última carga",
                            data: "dataHoraUltimaCarga",
                            defaultContent: "",
                            render: function (data) {
                                return $filter('date')(data, 'dd/MM/yyyy')
                            }
                        },
                        {
                            targets: 6,
                            name: "Usuario",
                            data: "usuario",
                            defaultContent: "",
                        }
                    ]);
        }

        function configuraAutoCompleteClienteOnBlur() {
            if (!vm.licenca.cliente) {
                vm.textoDePesquisaAutoCompleteCliente = "";
            }
        }

        function alterarItemSelecionadoAutoCompleteCliente(item) {
            if (item) {
                vm.licenca.clienteCodigo = item.codigo;

                _listarProdutos(item.codigo);
            } else {
                vm.textoDePesquisaAutoCompleteCliente = "";

                if (vm.licenca) {
                    vm.licenca.clienteCodigo = null;
                    vm.licenca.cliente = null;

                    vm.licenca.produtoCodigo = null;
                    vm.licenca.produto = null;

                    vm.licenca.tiposLicenca = [];
                }

                _redefinirProdutosELicencas();
                _controlarSelecaoTodasLicencas();
            }
        }

        function pesquisarAutoCompleteCliente(query) {
            return ServicosGenericoService.pesquisarAutoCompleteCodigoOuNomeGenericoApi(Api.cliente.listarCodigoDescricao, query);
        }

        function configuraMdSelectProduto() {
            vm.filtrarSolucoes = "";
            angular.element('#protecao-licenca-produto-md-select').on('keydown', function (ev) {
                ev.stopPropagation();
            });
        }

        function alterarItemSelecionadoProduto(item, event) {
            if (item) {
                if (item.codigoProtecao) {
                    vm.licenca.produtoCodigo = item.codigo;
                    vm.codigoProtecao = item.codigoProtecao;

                    //vm.tipoLicencas = item.tipoLicencas;

                    _listarTiposLicenca(vm.licenca.clienteCodigo, item.codigo);

                    if ((vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo)) {
                        _redefinirTipoLicencasELicencasSelecionadas();
                    }
                }
                else {
                    if ((vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo)) {
                        _redefinirTipoLicencasELicencasSelecionadas();
                    }

                    var eventSim = function () {
                        $state.go("app.geral_cadastro_solucao_produto", { parametros: { iniciarChamandoPesquisa: true, codigoProduto: item.codigo } })
                    }

                    var eventNao = function () {
                        vm.licenca.produto = null;
                    }

                    MdDialogService.confirmPadraoComEvento("Produto não contem um código de proteção vinculado",
                        "<h3>Deseja vincular um código ao produto ? <br><br>Ou selecione outro produto</h3>", event,
                        eventSim, eventNao);
                }
            }
            else {
                vm.licenca.produtoCodigo = null;
                vm.codigoProtecao = null;

                _redefinirTipoLicencasELicencasSelecionadas();
            }
        }

        function configuraAutoCompleteTiposLicencaOnBlur() {
            if (!vm.tipoLicencaSelecionado) {
                vm.textoDePesquisaAutoCompleteTiposLicenca = "";
            }
        }

        function alterarItemSelecionadoAutoCompleteTiposLicenca(item) {
            if (!item) {
                vm.textoDePesquisaAutoCompleteTiposLicenca = "";
                vm.tipoLicencaSelecionado = null;
            }
        }

        function pesquisarAutoCompleteTiposLicenca(query) {
            return ServicosGenericoService.pesquisarAutoCompleteCodigoOuDescricaoGenerico(vm.tipoLicencas, query)
                .filter(function (itemTipoLicenca) {
                    if (vm.licenca && vm.licenca.tiposLicenca && vm.licenca.tiposLicenca.length == 0)
                        return true;
                    var retorno = true;
                    for (var i = 0; i < vm.licenca.tiposLicenca.length; i++) {
                        if (vm.licenca.tiposLicenca[i].codigo == itemTipoLicenca.codigo) {
                            retorno = false;
                            break;
                        }
                    }
                    return retorno;
                });
        }

        function adicionarLicenca(licencaSelecionada) {
            if (licencaSelecionada) {
                if (licencaSelecionada.quantidadeLicencaDisponivel > 0) {
                    if (vm.licenca.tiposLicenca.map(function (item) { return item.codigo }).indexOf(licencaSelecionada.codigo) == -1) {
                        licencaSelecionada.Flag = "I";
                        vm.licenca.tiposLicenca.push(licencaSelecionada);
                    }
                }
                else {
                    MdDialogService.alertPadrao("Não há licenças disponíveis para o tipo selecionado.")
                }
                vm.textoDePesquisaAutoCompleteTiposLicenca = "";
                vm.tipoLicencaSelecionado = null;

                _controlarSelecaoTodasLicencas();
            }
        }

        function removerLicenca(item) {
            vm.form.$setDirty();

            vm.licenca.tiposLicenca.splice(vm.licenca.tiposLicenca.indexOf(item), 1);

            _controlarSelecaoTodasLicencas();
        }

        function selecionarTodasLicencas() {
            $timeout(function () {
                var mensagem = "";
                vm.licenca.tiposLicenca = [];
                for (var i = 0; i < vm.tipoLicencas.length; i++) {
                    if (vm.tipoLicencas[i].quantidadeLicencaDisponivel <= 0)
                        mensagem += " Não há licenças disponíveis para o tipo selecionado " + vm.tipoLicencas[i].codigo + " - " + vm.tipoLicencas[i].descricao + "<br>"
                    else
                        vm.licenca.tiposLicenca.push(vm.tipoLicencas[i]);
                }

                if (mensagem) {
                    vm.licenca.todasLicencasSelecionadas = false;
                    MdDialogService.alertPadrao("", null, mensagem);
                }
            });
        }
        //#endregion    
    }

    function FiltraProdutoPorContrato() {
        return function (contratos, textoPesquisa) {
            var resultado = [];
            var contratoEncontrado = new RegExp(textoPesquisa, 'i');

            for (var i = 0; i < contratos.length; i++) {

                var produtoNoContratoAtual = contratos[i].produto;
                if (contratoEncontrado.test(produtoNoContratoAtual.descricao)
                    || contratoEncontrado.test(produtoNoContratoAtual.codigo)) {
                    resultado.push(contratos[i]);
                }
            }

            return resultado;
        };

    }
})();


(function () {
    'use strict';

    angular.module('app.protecao.processamento.atualizacaocliente')
        .controller('AtualizacaoClienteController', AtualizacaoClienteController);

    function AtualizacaoClienteController(
        $q,
        $scope,
        $rootScope,
        MdDialogService,
        NavegacaoService,
        AtualizacaoClienteFactory,
        RequisicaoGenericaService,
        Api,
        LoginUsuarioService
    ) {
        var vm = this;
        var nenhumClienteEncontrado = false;
        vm.clientesSelecionados = [];

        NavegacaoService.setTituloAba('Proteção atualização de cliente');

        init();

        function init() {
            vm.usuarioPermiteEdicao = LoginUsuarioService.usuarioArmazenado().detalhesUsuario.permitirAtualizarExpiracaoLicenca;
            AtualizacaoClienteFactory.form = vm;
            vm.filtro = AtualizacaoClienteFactory.filtros;
            vm.preLoader = AtualizacaoClienteFactory.preLoader;
        }

        $rootScope.$on('clienteSelecionado', function (event, data) {
            vm.clientesSelecionados = data;
            console.log('dados recebidos', data);
        })

        vm.metodosInternos = {
            validar: _validar,
            atualizarContratos: _atualizarContratos,
            prepararDadosEnvio: _prepararDadosEnvio
        };

        vm.metodos = {
            atualizarDataExpiracao: atualizarDataExpiracao,
            pesquisarClientes: _pesquisarClientes
        };

        function _validar(filtro) {
            if (!filtro.dataExpiracao) {
                MdDialogService.alertPadrao("Atenção", null, "Informa a nova data de expiração.");
                vm.preLoader = false;
                return false;
            }
            else
                return true;
        }

        function _atualizarContratos(dados) {
            vm.preLoaderEnvio = true;
            var deferred = $q.defer();
            RequisicaoGenericaService.editar(Api.contrato.atualizarDataExpiracao, dados).then(
                function (success) {
                    AtualizacaoClienteFactory.setValoresInciaisFiltro();
                    vm.filtro.clientes = undefined;
                    $rootScope.$broadcast('atualizarProdutoCodigoFactory', vm.filtro.produtoCodigo);
                    vm.filtro.selectStep = 1;
                    vm.clientesSelecionados = [];
                    deferred.resolve(success);
                    vm.preLoader = false;
                    vm.preLoaderEnvio = false;
                    MdDialogService.alertPadrao("Atenção", null, success.data);
                },
                function (error) {
                    deferred.reject(error);
                    MdDialogService.alertPadrao("Atenção", null, error.data);
                    vm.preLoaderEnvio = false;
                });
            return deferred.promise;
        }

        function _prepararDadosEnvio(filtro) {
            var objRequest = {
                clientes: filtro.clientes,
                novaDataExpiracao: filtro.dataExpiracao
            };

            return objRequest;
        }

        function atualizarDataExpiracao() {
            if (vm.clientesSelecionados && vm.clientesSelecionados.length > 0)
                vm.filtro.clientes = vm.clientesSelecionados;

            if (_validar(vm.filtro)) {
                _atualizarContratos(_prepararDadosEnvio(vm.filtro));
            }
        }

        function _pesquisarClientes() {
            if (!nenhumClienteEncontrado) {
                if (vm.filtro.msVerticalStepperController.currentStepNumber != 2) {
                    vm.preLoader = true;
                    var dados = {
                        caracteristicasContrato: vm.filtro.caracteristicasContrato.map(function (car) { return car.codigo }),
                        caracteristicasContratoANaoImprimir: vm.filtro.caracteristicasContratoANaoImprimir.map(function (car) { return car.codigo }),
                        produtoCodigo: vm.filtro.produtoCodigo,
                        seletorCaracteristicaNaoImprimir: vm.filtro.seletorCaracteristicaNaoImprimir,
                        seletorCaracteristica: vm.filtro.seletorCaracteristica
                    };

                    RequisicaoGenericaService
                        .listarComObjetoComplexo(Api.contrato.listarInformacoesDataExpiracao, dados)
                        .then(function (success) {
                            vm.filtro.clientes = success.data.clientes;
                            vm.filtro.produtos = success.data.produtos;
                            vm.preLoader = false;
                            $rootScope.$broadcast('atualizarProdutoCodigoFactory', vm.filtro.produtoCodigo);
                            if (vm.filtro.clientes.length == 0) {
                                nenhumClienteEncontrado = true;
                                vm.filtro.produtoCodigo = null;
                                vm.filtro.msVerticalStepperController.gotoStep(1);
                            }
                            vm.preLoader = false;
                        }).catch(function (erro) {
                            vm.preLoader = false;
                            MdDialogService.alertPadrao("Atenção", null, "Ocorreu um erro ao listar os clientes: " + erro.data);
                        });
                }

            } else {
                MdDialogService.alertPadrao("Atenção!", null, "Não foi encontrado nenhum registro para a consulta realizada.");
                nenhumClienteEncontrado = false;
                return;
            }
        }

        $scope.$on("$destroy", function () {
            AtualizacaoClienteFactory.setValoresInciaisFiltro();
        });

        $rootScope.$on('pesquisarClientes', function () {
            _pesquisarClientes();
        });
    }
})();
(function () {
    'use strict';

    angular.module('app.protecao.processamento.atualizacaolicenca')
        .controller('AtualizacaoLicencaController', AtualizacaoLicencaController);

    function AtualizacaoLicencaController(AtualizacaoLicencaFactory, NavegacaoService, MdDialogService, RequisicaoGenericaService, Api, $q) {
        var vm = this;
        NavegacaoService.setTituloAba('Proteção atualização de licença');

        init();

        function init() {
            vm.form = AtualizacaoLicencaFactory.form;
            vm.filtro = AtualizacaoLicencaFactory.filtros;
        }

        vm.metodosInternos = {
            atualizarLicencas: _atualizarLicencas,
            prepararDadosEnvio: _prepararDadosEnvio
        };

        vm.metodos = {
            executarRotina: executarRotina
        };

        function executarRotina(event, filtro) {
            var licencas = AtualizacaoLicencaFactory.licencas();
            var resultado = licencas.filter(function (licenca) {
                if (licenca.flag == true) {
                    return licenca;
                }
            });
            if (resultado.length == 0) {
                vm.filtro.selectStep = 2;
                event.preventDefault();
                event.stopPropagation();
                MdDialogService.alertPadrao("Atenção", null, "Selecione pelo menos uma licença.");
            }
            else {
                _atualizarLicencas(_prepararDadosEnvio(filtro, resultado));
            }
        }

        function _atualizarLicencas(dados) {
            var deferred = $q.defer();
            RequisicaoGenericaService.salvar(Api.protecao.atualizacaoLicenca.post, dados).then(
                function (success) {
                    deferred.resolve(success);
                    MdDialogService.alertPadrao("Atenção", null, "Atualização de licenças realizada com sucesso.");
                    AtualizacaoLicencaFactory.setValoresInciaisFiltro();
                    vm.filtro.selectStep = 1;
                },
                function (error) {
                    deferred.reject(error);
                    MdDialogService.alertPadrao("Atenção", null, error.data);
                });
            return deferred.promise;
        }

        function _prepararDadosEnvio(filtro, dados) {
            var objRequest = {
                clienteCodigo: filtro.cliente.codigo,
                produtoCodigo: filtro.produto.codigo,
                rotina: filtro.rotina,
                tiposLicenca: filtro.tiposLicenca.map(function (item) {
                    return item.codigo
                }),
                licencas: dados
            };

            return objRequest;
        }
    }
})();
/**
 * Created by nova on 25/10/2016.
 */
(function () {
    'use strict';

    angular
        .module('app.planejamentoScrum.processamento.sprint')
        .controller('SprintController', SprintController);

    function SprintController(
        $filter,
        $mdDialog,
        $rootScope,
        $scope,
        $state,
        $timeout,
        Api,
        DataTableConfigPadrao,
        DatatableFactory,
        MdDialogService,
        MdToastService,
        NavegacaoService,
        RequisicaoGenericaService,
        ListarTodosUsuarios,
        ListarSprintCorrente,
        ListarTodasCerimonias,
        ListarTodasSituacoes,
        ListarTodasSolucoes,
        ListarUsuarioPorDetalhe,
        PgToolbarFactory,
        PgToolbarService,
        ProximoCodigoService,
        RegistrosSituacoes,
        ServicosGenericoService,
        SprintFactory,
        SprintService,
        SquadService,
        ToolbarService
    ) {
        var vm = this;
        NavegacaoService.setTituloAba("Sprint");
        vm.valorTeste = 98;
        vm.desabilitarBotao = false;
        vm.squadUsuarioLogado = ListarUsuarioPorDetalhe.data.codigoSquads;
        ToolbarService.armazenarCodigoSquadUsuarioLogado(vm.squadUsuarioLogado);
        // Data region
        vm.htmlRota = SprintFactory.setHtmlRota();
        if (ListarSprintCorrente.data.lstResultado.length) {
            vm.desabilitarModoTabela = true;
            vm.sprint = ListarSprintCorrente.data.lstResultado[0];
            vm.sprintCorrente = true;
            vm.iniciarChamandoPesquisa = true;
            var sprintCorrente = vm.sprint.numero;
            vm.sprintCorrenteBindado = vm.sprint.numero;
        } else {
            vm.sprint = {};
            vm.iniciarChamandoPesquisa = false;
        }
        vm.sprints = [];

        vm.squads = SquadService.listarSquadsUsuarioLogado(vm.squadUsuarioLogado);
        vm.cards = [
            { titulo: "Total de histórias", valor: 1 },
            { titulo: "Total de pontos", valor: 2 },
            { titulo: "Histórias homologadas", valor: 3 },
            { titulo: "Pontos homologados", valor: 4 }
        ];
        vm.cardsEstoriasAnteriores = [
            { titulo: "Retornos de erros", valor: 1 },
            { titulo: "Pontos perdidos", valor: 2 },
            { titulo: "Retornos de melhorias", valor: 3 },
            { titulo: "Pontos desenvolvidos", valor: 4 }
        ];
        vm.habilitarTabela = true;
        vm.estorias = null;
        var sprintTemporario = {};
        vm.semDev = "Sem desenvolvedor";
        vm.semQa = "Sem tester";
        vm.form = {};
        vm.recurso = {};
        vm.abatimento = {};
        vm.pontuacaoSprintsAnteriores = {};
        vm.ocultarProgress = false;
        vm.requisicaoSolicitada = false;
        vm.positivaSelecionada = null;
        vm.estoriasBacklog = {
            selecionado: false,
            estorias: [],
            estoriasSemEstimativaDesenvolvimento: []
        };
        $rootScope.situacoesSelecionadasDescricoes = [];
        vm.situacoesNegadasSelecionadasDescricoes = [];

        $rootScope.registrosSelecionados = [];

        vm.coresSituacoes = SprintFactory.coresSituacoes();
        //endregion

        // Resolve region
        vm.usuarios = ListarTodosUsuarios.data;
        vm.registrosSituacoes = RegistrosSituacoes.data;
        vm.cerimonias = ListarTodasCerimonias.data;
        vm.situacoes = ListarTodasSituacoes.data;
        vm.solucoes = ListarTodasSolucoes.data;
        //endregion

        // Configurações Datatable region
        vm.dtOptionsSprint = angular.copy(
            DataTableConfigPadrao.dtOptionsPadraoComPaginacaoEReponsivo
        );
        vm.dtOptionsSprint.columnDefs = [DataTableConfigPadrao.columnDefsPadrao];

        vm.dtOptionsSprintBacklog = SprintFactory.setDtOptionsBacklog();
        vm.dtOptionsSprintBacklog.columnDefs = SprintFactory.setColumnsDefsDtOptionsSprintBacklog();
        vm.dtOptionsSprintBacklog.order = [];

        vm.dtOptionsSprintCadastroBacklog = angular.copy(
            DataTableConfigPadrao.dtOptionsPadraoComPaginacaoPaginTypeNumbersEReponsivo
        );
        vm.dtOptionsSprintCadastroBacklog.columnDefs = [
            DataTableConfigPadrao.columnDefsPadrao,
            {
                targets: 2,
                searchable: false
            },
            {
                targets: 5,
                searchable: false
            }
        ];

        vm.dtOptionsSprintRecursos = SprintFactory.setDtOptionsRecursos();
        vm.dtOptionsSprintRecursos.columnDefs = [
            DataTableConfigPadrao.columnDefsPadrao
        ];

        vm.dtOptionsSprintAbatimentos = SprintFactory.setDtOptionsAbatimentos();
        vm.dtOptionsSprintAbatimentos.columnDefs = [
            DataTableConfigPadrao.columnDefsPadrao
        ];

        vm.dtOptionsRegistros = SprintFactory.setDtOptionsRegistros();
        vm.dtOptionsRegistros.columnDefs = SprintFactory.setColumnsDefsDtOptionsRegistros();

        vm.dtOptionsSprintLimites = angular.copy(
            DataTableConfigPadrao.dtOptionsResponsivoSemPaginacaoComInitComplete
        );
        vm.dtOptionsSprintLimites.columnDefs = [
            DataTableConfigPadrao.columnDefsPadrao
        ];

        vm.dtOptionsMetas = angular.copy(
            DataTableConfigPadrao.dtOptionsPadraoComPaginacaoEReponsivo
        );
        vm.dtOptionsMetas.columnDefs = [DataTableConfigPadrao.columnDefsPadrao];
        vm.dtOptionsMetas.lengthMenu = [25, 30, 35, 40];
        vm.dtOptionsMetas.pageLength = 25;

        vm.dtOptionsSprintEstatisticas = angular.copy(
            DataTableConfigPadrao.dtOptionsResponsivoSemPaginacaoComInitComplete
        );

        vm.dtOptionsCerimoniaDetalhe = angular.copy(
            DataTableConfigPadrao.dtOptionsPadraoComPaginacaoEReponsivo
        );
        vm.dtOptionsCerimoniaDetalhe.columnDefs = SprintFactory.setColumnsDefsDtOptionsCerimoniaDetalhes(
            vm.cerimonias
        );

        vm.dtOptionsVersaoEntregue = angular.copy(
            DataTableConfigPadrao.dtOptionsPadraoComPaginacaoEReponsivo
        );
        vm.dtOptionsVersaoEntregue.columnDefs = [
            DataTableConfigPadrao.columnDefsPadrao
        ];
        //endregion
        //</editor-fold>

        // Variáveis Controladoras das tabs region
        vm.tabSelecionada = "sprint";
        vm.tresUltimas = false;
        vm.controladorSprint = SprintFactory.defineArrayDeVariaveisControladorasDoSprint();
        //endregion

        // Varíaveis controladoras tab backlog region
        var templatesSprintBacklog = SprintFactory.defineTemplatesSprintBacklog();
        vm.templateSelecionadoSprintBacklog = templatesSprintBacklog[0];
        vm.estoriasSelecionadas = [];

        vm.stack = [
            {
                codigo: 1,
                descricao: "Back-end"
            },
            {
                codigo: 2,
                descricao: "Front-end"
            },
            {
                codigo: 3,
                descricao: "Mobile"
            },
            {
                codigo: 4,
                descricao: "Infraestrutura"
            },
            {
                codigo: 5,
                descricao: "Full-stack"
            }];

        vm.tiposMeta = [
            {
                codigo: 1,
                descricao: "Desenvolvida"
            },
            {
                codigo: 2,
                descricao: "Dsv e homologada"
            },
            {
                codigo: 3,
                descricao: "Homologada"
            },
            {
                codigo: 4,
                descricao: "Todas"
            }];
        //endregion

        // Preenchimento do controle de horas dos recursos region
        vm.dadosTabela = SprintFactory.defineDadosDaTabelaBurndown();
        //endregion

        // Definição dos Métodos region
        var setaChavePrimariaSprint = setaChavePrimariaSprint;
        var verificaSprintCorrente = verificaSprintCorrente;
        var alertaUsuarioSprintNaoAtual = alertaUsuarioSprintNaoAtual;
        vm.metodosGeral = {
            calculaMeta: calculaMeta,
            tabSelecionada: tabSelecioanda,
            redefineConfiguracoesIniciaisNoFormulario: redefineConfiguracoesIniciaoNoFormulario,
            novaPesquisa: novaPesquisa,
            preDefinirCamposParaInserir: preDefinirCamposParaInserir,
            preDefinirCamposParaEdicao: preDefinirCamposParaEdicao,
            atualizarNoController: atualizarNoController,
            calculaConcluidos: calculaConcluidos,
            listarNumeroEAnoHistoria: listarNumeroEAnoHistoria

        };
        vm.metodosSprint = {
            pesquisar: pesquisar,
            salvar: salvar,
            editar: editar,
            excluir: excluir,
            selecionarSprint: selecionarSprint,
            construirDtOptions: construirDtOptions,
            selectChangeSquad: selectChangeSquad
        };
        vm.metodosBacklog = {
            selecionarTemplate: selecionarTemplate,
            selecionarEstorias: backlogSelecionarEstorias,
            salvarEstoriaBacklog: salvarEstoriaBacklog,
            excluirEstoriaBacklog: excluirEstoriaBacklog,
            abrirDialogAdicionarEstoriaBacklog: abrirDialogAdicionarEstoriaBacklog,
            abrirDialogEstoriaBacklogSituacao: abrirDialogEstoriaBacklogSituacao,
            abrirDialogEstoriaBacklogPontuacao: abrirDialogEstoriaBacklogPontuacao,
            abrirDialogEstoriaBacklogColaboradores: abrirDialogEstoriaBacklogColaboradores,
            abrirDialogEstoriaBacklogHoras: abrirDialogEstoriaBacklogHoras,
            abrirDialogEstoriaBacklogPriorizacao: abrirDialogEstoriaBacklogPriorizacao,
            editarEstoriaBacklog: editarEstoriaBacklog,
            filtrarTabelaPorSituacao: filtrarTabelaPorSituacao,
            desmarcarFiltrosBacklog: desmarcarFiltrosBacklog,
            retornaSigla: retornaSigla,
            verificaPontuacao: verificaPontuacao,
            abrirDialogHistoriasVinculadasBacklog: abrirDialogHistoriasVinculadasBacklog
        };
        vm.metodosRecursos = {
            salvarRecurso: salvarRecurso,
            editarRecurso: editarRecurso,
            excluirRecurso: excluirRecurso,
            selecionarRecurso: selecionarRecurso,
            configuraMdSelectRecursos: configuraMdSelectRecursos
        };
        vm.metodosAbatimento = {
            salvarAbatimento: salvarAbatimento,
            editarAbatimento: editarAbatimento,
            excluirAbatimento: excluirAbatimento,
            selecionarAbatimento: selecionarAbatimento
        };
        vm.metodosRegistro = {
            abrirDialogRegistro: abrirDialogRegistro,
            excluirRegistro: excluirRegistro,
            filtrarTabelaPorRegistro: filtrarTabelaPorRegistro,
            desmarcarFiltros: desmarcarFiltros
        };
        vm.metodosLimite = {
            salvarLimite: salvarLimite,
            editarLimite: editarLimite,
            excluirLimite: excluirLimite,
            selecionarLimite: selecionarLimite
        };
        vm.metodosMeta = {
            abrirDialogMeta: abrirDialogMeta,
            abrirDialogInformacaoCalculoMeta: abrirDialogInformacaoCalculoMeta,
            abrirDialogAcompanhamentoMeta: abrirDialogAcompanhamentoMeta,
            excluirMeta: excluirMeta
        };
        vm.metodosBurndown = {
            abrirDialogBurndown: abrirDialogBurndown
        };
        vm.metodosCerimoniaDetalhe = {
            abrirDialogCerimoniaDetalhe: abrirDialogCerimoniaDetalhe,
            excluirCerimoniaDetalhe: excluirCerimoniaDetalhe
        };
        vm.metodosVersaoEntregue = {
            abrirDialogVersaoEntregue: abrirDialogVersaoEntregue,
            excluirVersaoEntregue: excluirVersaoEntregue
        };

        vm.metodosPontuacao = {
            tresUltimas: tresUltimas,
            abrirDialogVisualizarEstorias: abrirDialogVisualizarEstorias,
            calcularTotalPontuacao: calcularTotalPontuacao
        };
        //endregion

        // Implementação dos métodos region

        _init();

        function _init() {
            $rootScope.scrollButtonContainerLocal = "div#container-sprint";
        }

        /**
         * método para setar a chave primaria da sprint
         * @param {*} entidade entidade qualquer vinculada a sprint
         */
        function setaChavePrimariaSprint(entidade) {
            entidade.SprintNumero = vm.sprint.numero;
            return entidade;
        }

        /**
         * Método que verifica se a sprint atual é a sprint corrente
         */
        function verificaSprintCorrente() {
            if (angular.isDefined(sprintCorrente)) {
                if (sprintCorrente > vm.sprint.numero) {
                    return true;
                } else {
                    return false;
                }
            } else {
                return false;
            }
        }

        function listarNumeroEAnoHistoria(meta) {
            vm.metasHistorias = meta;
        }

        function calculaConcluidos(historias) {
            vm.totalConcluidos = historias.filter(function (item) {
                if (item.concluido)
                    return item;
            });
            return vm.totalConcluidos.length;
        }

        function calculaMeta(meta) {
            var total = calculoPorcentagem(meta);
            var totalHomologado = calculaPorcentagemConcluida(meta);

            if (totalHomologado == 0) {
                vm.totalPontos = 0;
                return vm.totalPontos;
            } else {
                var result = ((totalHomologado / total) * 100).toFixed(2);
                vm.totalPontos = result;
                return vm.totalPontos;
            }
        }

        function calculaPorcentagemConcluida(meta) {
            var homologada = meta.filter(function (element) {
                if (element.sprintMetaCodigo != undefined && element.concluido) {
                    return element;
                }
            });

            if (homologada.length <= 0) {
                return 0;
            }

            var pontos = calculoPorcentagem(homologada);

            return pontos;
        }

        function calculoPorcentagem(meta) {
            var quantidadeHistoriasZeradas = 0;
            var porcentagem = meta.reduce(function (total, valor) {
                if (valor.sprintMetaCodigo != undefined && valor.pontos == 0) {
                    quantidadeHistoriasZeradas++;
                }

                if (valor.sprintMetaCodigo != undefined && valor.pontos > 0) {
                    return total + valor.pontos;
                }
                else {
                    return total;
                }
            }, 0);

            if (meta.length == quantidadeHistoriasZeradas) {
                return quantidadeHistoriasZeradas;
            }

            porcentagem += quantidadeHistoriasZeradas;

            return porcentagem;
        }
        /**
         * Função para alerta o usuário quando a sprint selecionada não for a sprint corrente
         * @param {eventSim} eventSim função delegate para a ser passada por parâmetro
         * @param {eventNao} eventNao função delegate para a ser passada por parâmetro
         */
        function alertaUsuarioSprintNaoAtual(eventSim, eventNao) {
            eventSim();
            return;
        }
        // Métodos Interno Sprint region

        /**
         * Método para redefinir as configurações iniciais no formulário,
         * sempre que for persistido, editado ou cancelado algum item da sprint
         *
         */
        function redefineConfiguracoesIniciaoNoFormulario() {
            vm.form.sprintForm.$setUntouched();
            vm.form.sprintForm.$setPristine();
            $rootScope.registrosSelecionados = [];
            vm.situacaoSelecionada = null;
            desmarcarFiltrosBacklog();
        }
        //endregion

        // Métodos Gerais region

        $scope.$watch("vm.sprint", function (newValue, oldValue) {
            if (angular.equals({}, newValue))
                vm.metodosGeral.tabSelecionada("sprint");
            else {
                vm.metodosGeral.tabSelecionada(vm.tabSelecionada);
            }
        });

        /**
         * Método que é chamado sempre quando ocorre uma transição de tab
         * @param {tab} tab
         */
        function tabSelecioanda(tab) {
            vm.pesquisar = "";
            if (tab === "backlog") {
                $rootScope.utilizaBotaoScroll = true;
                SprintService.verificaTabAtiva(
                    tab,
                    vm.controladorSprint,
                    vm.sprint,
                    vm.sprint.numero,
                    vm.controleForm,
                    vm.estoriasBacklog,
                    vm.controlePreloader,
                    vm.sprint.squadCodigo
                );
            } else {
                $rootScope.utilizaBotaoScroll = false;
                SprintService.verificaTabAtiva(
                    tab,
                    vm.controladorSprint,
                    vm.sprint,
                    vm.sprint.numero,
                    vm.controleForm,
                    null,
                    vm.controlePreloader,
                    vm.sprint.squadCodigo
                );
            }
            if (tab === "metas") {
                var dataAtual = new Date();
                var dataAtualMenosUmDia = new Date();
                dataAtualMenosUmDia.setDate(dataAtual.getDate() - 1);
                vm.sprint.dataFinal = new Date(vm.sprint.dataFinal);
                vm.exibeBotao = vm.sprint.dataFinal > dataAtualMenosUmDia ? false : true;
            }

            vm.tabSelecionada = tab;

            vm.habilitarTabela = false;

            $timeout(function () {
                vm.habilitarTabela = true;
            }, 250);

            SprintService.controlaButtonsToolbar(vm.controleForm, tab);
            if (angular.isDefined(vm.controleForm)) {
                vm.controleForm.pesquisarDatatable = SprintService.verificaTabParaHabilitarPesquisarHeaderPadrao(
                    tab
                );
            }
            vm.metodosGeral.redefineConfiguracoesIniciaisNoFormulario();
        }

        /**
         * Método que será chamado quando o botão de nova pesquisa da toolbar for clicado
         */
        function novaPesquisa() {
            vm.desabilitarModoTabela = false;
            vm.estoriasBacklog = {};
            vm.sprintCorrente = false;
            $rootScope.situacoesSelecionadasDescricoes = [];
            vm.situacoesNegadasSelecionadasDescricoes = [];
            vm.positivaSelecionada = null;
            angular.forEach(vm.coresSituacoes, function (item, indice) {
                item.legendaSelecionada = false;
            });
            $rootScope.registrosSelecionados = [];
            vm.sprint.squadCodigo = ToolbarService.squadSelecionado();
            angular.forEach(vm.sprint.totalDeHorasPorRegistroSituacao, function (
                item,
                value
            ) {
                item.legendaSelecionada = false;
            });
        }

        /**
         * Método que será chamado quando o botão de inserir da toolbar for clicado
         */
        function preDefinirCamposParaInserir() {
            vm.sprint = {
                dataInicial: new Date(),
                corrente: false
            };
            vm.sprint.squadCodigo = ToolbarService.squadSelecionado();
            _sugerirProximoNumero(vm.sprint.squadCodigo);
        }

        function _sugerirProximoNumero(squadCodigo) {
            PgToolbarService.iniciarPreLoaderToolbar(
                vm.controleForm,
                vm.controlePreloader
            );
            ProximoCodigoService.proximoNumeroSprint(Api.sprint.proximoNumero, squadCodigo).then(
                function (success) {
                    vm.sprint = { numero: success.data, squadCodigo: squadCodigo, dataInicial: new Date(), corrente: false };
                    PgToolbarService.finalizarPreLoaderToolbar(
                        vm.controleForm,
                        vm.controlePreloader
                    );
                },
                function (error) {
                    PgToolbarService.finalizarPreLoaderToolbar(
                        vm.controleForm,
                        vm.controlePreloader
                    );
                    MdDialogService.alertPadrao(error.data);
                }
            );
        }

        /**
         * Método que será chamado quando o botão de editar da toolbar for clicado
         */
        function preDefinirCamposParaEdicao() {
            var itensInternos = function () {
                vm.sprint.dataInicial = new Date(vm.sprint.dataInicial);
                vm.sprint.dataFinal = new Date(vm.sprint.dataFinal);
                vm.sprintCorrente = false;
            };

            // Verifica Se é o Srint corrente
            if (verificaSprintCorrente()) {
                alertaUsuarioSprintNaoAtual(
                    function () {
                        itensInternos();
                    },
                    function () {
                        vm.controleForm.reverter();
                    }
                );
            } else {
                itensInternos();
            }
        }

        /**
         * Método que recarrega a entidade da aba ativa quando for clicado no botão atualizar da  toolbar
         */
        function atualizarNoController() {
            vm.metodosGeral.tabSelecionada(vm.tabSelecionada);
        }
        //endregion

        // Metodos Tab Sprint region

        /**
         * Método que irá uma sprint
         */
        function pesquisar() {
            if (!vm.entidadeDeEnvio || vm.sprintCorrente) {
                if (!vm.entidadeDeEnvio) {
                    var objetoCodigoSquads = {
                        codigoSquads: ListarUsuarioPorDetalhe.data.codigoSquads,
                    }
                    vm.entidadeDeEnvio = PgToolbarFactory.construirEntidadeDeEnvioPadrao(
                        objetoCodigoSquads);
                }
                return RequisicaoGenericaService.listarComObjetoComplexo(
                    Api.sprint.listarSprintCorrente, vm.entidadeDeEnvio
                );
            }
            else {
                if (vm.squadUsuarioLogado.length === 1) vm.sprint.squadCodigo = vm.squadUsuarioLogado[0];

                return RequisicaoGenericaService.listarComObjetoComplexo(
                    Api.sprint.listarComPaginacao,
                    vm.entidadeDeEnvio
                );
            }
        }


        /**
         *
         * @param {sprint} sprint
         */
        function salvar(sprint) {
            if (vm.squadUsuarioLogado.length === 1) vm.sprint.squadCodigo = vm.squadUsuarioLogado[0];
            return RequisicaoGenericaService.salvar(Api.sprint.criar, sprint);
        }

        /**
         *
         * @param {sprint} sprint
         */
        function editar(sprint) {
            if (vm.squadUsuarioLogado.length === 1) vm.sprint.squadCodigo = vm.squadUsuarioLogado[0];
            return RequisicaoGenericaService.editar(Api.sprint.atualizar, sprint);
        }

        /**
         *
         * @param {sprint} sprint
         */
        function excluir(sprint) {
            return RequisicaoGenericaService.excluir(
                Api.sprint.excluir,
                sprint.numero + "/" +
                sprint.squadCodigo
            );
        }

        /**
         * Método utilizado no modo exibido tabela, para selecionar um Motivo Aditivo
         * @param {number} posicaoEntidade posição da entidade
         */
        function selecionarSprint(posicaoEntidade) {
            vm.metodosExternosPgToolbar.metodoControladorExternoListarTodasEntidades(
                null,
                posicaoEntidade
            );
        }

        /**
         * Método para construi o DtOptions da tabela
         */
        function construirDtOptions() {
            DatatableFactory.construirDtOptionsComPaginacaoProcessadoNoServidorParaToolbar(
                Api.sprint.listarComPaginacaoDatatable,
                vm.entidadeDeEnvio.clsEntidade,
                "#datatable-sprint", [
                DatatableFactory.construirColunaDeSelecionarPadrao(function (
                    indexLinha
                ) {
                    vm.metodosSprint.selecionarSprint(indexLinha);
                }),
                {
                    targets: 1,
                    name: 'Squad',
                    data: 'squadCodigo',
                    render: function (data) {
                        return SquadService.descricaoSquad(data);
                    },
                    defaultContent: ""
                },
                {
                    targets: 2,
                    name: "Numero",
                    data: "numero",
                    defaultContent: ""
                },
                {
                    targets: 3,
                    name: "DataInicial",
                    data: "dataInicial",
                    render: function (data) {
                        return $filter("date")(data, "dd/MM/yyyy");
                    },
                    defaultContent: ""
                },
                {
                    targets: 4,
                    name: "DataFinal",
                    data: "dataFinal",
                    render: function (data) {
                        return $filter("date")(data, "dd/MM/yyyy");
                    },
                    defaultContent: ""
                },
                {
                    targets: 5,
                    name: "Descricao",
                    data: "descricao",
                    defaultContent: ""
                }
            ]
            );
        }
        //endregion

        // Métodos Tab Backlog region

        /**
         * Método que irá filtrar a tabela de backlog com base nas situações selecionadas
         * @param {index} index index situacao
         * @param {situacaoSelecionada} situacaoSelecionado situacao que foi selecionada
         */
        function filtrarTabelaPorSituacao(index, situacaoSelecionado) {
            vm.index = index;
            vm.situacao = situacaoSelecionado;
            if (situacaoSelecionado) {
                if (situacaoSelecionado.descricao !== "Histórias não refinadas") {
                    vm.positivaSelecionada = true;
                    situacaoSelecionado.legendaSelecionada = !situacaoSelecionado.legendaSelecionada;
                    if (
                        $rootScope.situacoesSelecionadasDescricoes.indexOf(
                            situacaoSelecionado.descricaoFiltro
                        ) === -1
                    )
                        $rootScope.situacoesSelecionadasDescricoes.push(
                            situacaoSelecionado.descricaoFiltro
                        );
                    else
                        $rootScope.situacoesSelecionadasDescricoes.splice(
                            $rootScope.situacoesSelecionadasDescricoes.indexOf(
                                situacaoSelecionado.descricaoFiltro
                            ),
                            1
                        );
                } else {
                    situacaoSelecionado.legendaSelecionada = !situacaoSelecionado.legendaSelecionada;
                    if (vm.positivaSelecionada == false) {
                        $rootScope.situacoesSelecionadasDescricoes = [];
                        vm.positivaSelecionada = null;
                    } else {
                        $rootScope.situacoesSelecionadasDescricoes = [
                            "Solicitação",
                            "Análise"
                        ];
                        vm.positivaSelecionada = false;
                    }
                }
            }
            if ($rootScope.situacoesSelecionadasDescricoes.length == 0)
                vm.positivaSelecionada = null;
        }

        /**
         * Método que irá desabilitar todos os filtros marcados da aba de backlog, retornando a tabela de backlog
         * para seu estado inicial
         */
        function desmarcarFiltrosBacklog(naoExibirTodasEstoriasBacklog) {
            if (!naoExibirTodasEstoriasBacklog) {
                vm.sprint.backlogEstorias = vm.estoriasBacklog.estorias;
            }

            $rootScope.situacoesSelecionadasDescricoes = [];
            vm.positivaSelecionada = null;
            vm.situacoesNegadasSelecionadasDescricoes = [];
            angular.forEach(vm.coresSituacoes, function (item, indice) {
                item.legendaSelecionada = false;
            });
        }

        /**
         * Método que irá selecionar o template para inserir estórias no backlog da sprint
         * @param {templateSelecionado} templateSelecionado template que foi selecionado
         * 'Listar todas estórias que não estão no backlog da sprint' ou
         * 'abrir dialog para inserir estoria especifica no backlog da sprint'
         * @param {eventButton} event
         */
        function selecionarTemplate(templateSelecionado, event) {
            if (
                templateSelecionado ==
                "viewParaCadastrarEstoriasNoBacklogListandoEstoriasSemBacklog"
            ) {
                vm.templateSelecionadoSprintBacklog = templatesSprintBacklog[1];
                $rootScope.utilizaBotaoScroll = true;
                PgToolbarService.iniciarPreLoaderToolbar(
                    vm.controleForm,
                    vm.controlePreloader
                );
                RequisicaoGenericaService.listarSemParams(
                    Api.estoria.listarEstoriasSemSprintBacklog + vm.sprint.numero + "/" + vm.sprint.squadCodigo,
                    vm.controleForm
                ).then(
                    function (success) {
                        vm.estorias = success.data;
                        PgToolbarService.finalizarPreLoaderToolbar(
                            vm.controleForm,
                            vm.controlePreloader
                        );
                    },
                    function () {
                        vm.templateSelecionadoSprintBacklog = templatesSprintBacklog[0];
                        $rootScope.utilizaBotaoScroll = false;
                        vm.estoriasSelecionadas = [];
                        PgToolbarService.finalizarPreLoaderToolbar(
                            vm.controleForm,
                            vm.controlePreloader
                        );
                    }
                );
            } else {
                vm.templateSelecionadoSprintBacklog = templatesSprintBacklog[0];
                vm.estoriasSelecionadas = [];
                $rootScope.utilizaBotaoScroll = true;
                PgToolbarService.finalizarPreLoaderToolbar(
                    vm.controleForm,
                    vm.controlePreloader
                );
            }
        }

        /**
         * Método chamada para marcar as estórias que foram selecionadas na para serem inseridas
         * no tempate 'Listar todas estórias que não estão no backlog da sprint'
         * @param {estoria} estoria
         * @param {eventButton} event
         */
        function backlogSelecionarEstorias(estoria, event) {
            if (event) {
                event.stopPropagation();
            }
            if (vm.estoriasSelecionadas.indexOf(estoria) > -1) {
                vm.estoriasSelecionadas.splice(
                    vm.estoriasSelecionadas.indexOf(estoria),
                    1
                );
            } else {
                vm.estoriasSelecionadas.push(estoria);
            }
        }

        /**
         * Salvar a lista de estórias selecionadas
         * @param {event} event
         */
        function salvarEstoriaBacklog(event) {
            var itensInternos = function () {
                var sprintBacklogItens = [];

                angular.forEach(vm.estoriasSelecionadas, function (item, index) {
                    sprintBacklogItens.push({
                        sprintNumero: vm.sprint.numero,
                        estoriaNumero: item.numero,
                        estoriaAno: item.ano,
                        squadCodigo: item.squadCodigo
                    });
                });
                PgToolbarService.iniciarPreLoaderToolbar(
                    vm.controleForm,
                    vm.controlePreloader
                );
                RequisicaoGenericaService.salvar(
                    Api.sprint.backlog.criar,
                    sprintBacklogItens,
                    vm.controleForm
                ).then(
                    function (success) {
                        MdToastService.toastPadrao(
                            "Estórias inseridas com sucesso no backlog!"
                        );
                        vm.sprint.backlogEstorias = success.data.backlog;
                        vm.templateSelecionadoSprintBacklog = templatesSprintBacklog[0];
                        vm.estoriasSelecionadas = [];

                        PgToolbarService.finalizarPreLoaderToolbar(
                            vm.controleForm,
                            vm.controlePreloader
                        );
                        vm.estoriasBacklog.estoriasSemEstimativaDesenvolvimentoSelecionado = false;
                        vm.estoriasBacklog.estorias = success.data.backlog;
                        atualizarNoController();
                    },
                    function (error) {
                        MdDialogService.alertPadrao(error.data, event);
                        PgToolbarService.finalizarPreLoaderToolbar(
                            vm.controleForm,
                            vm.controlePreloader
                        );
                    }
                );
            };

            // Verifica Se é o Srint corrente
            if (verificaSprintCorrente()) {
                alertaUsuarioSprintNaoAtual(function () {
                    itensInternos();
                });
            } else {
                itensInternos();
            }
        }

        /**
         * Redireciona para a tela de estória a estória que o usário deseja editar
         * @param {estoriaBacklog} estoriaBacklog
         */
        function editarEstoriaBacklog(event, estoriaBacklog) {
            $state.goNewTab("app.planejamento_processamento_estoria", {
                parametros: {
                    numero: estoriaBacklog.estoria.numero,
                    ano: estoriaBacklog.estoria.ano,
                    squadCodigo: estoriaBacklog.estoria.squadCodigo,
                    chamarPesquisa: true
                }
            });
        }

        /**
         * Excluir estória selecionada do backlog da sprint
         * @param {eventButton} event
         * @param {estoriaBacklgo} estoriaBacklog
         */
        function excluirEstoriaBacklog(event, estoriaBacklog) {
            var itensInternos = function () {
                ServicosGenericoService.excluirRegistroPorCodigoOuGenericamente(
                    Api.sprint.backlog.excluir,
                    vm.sprint.backlogEstorias,
                    estoriaBacklog,
                    vm.controleForm,
                    event,
                    "Deseja realmente excluir esta estória do backlog ?"
                );
            };

            // Verifica Se é o Srint corrente
            if (verificaSprintCorrente()) {
                alertaUsuarioSprintNaoAtual(function () {
                    itensInternos();
                });
            } else {
                itensInternos();
            }
        }

        function abrirDialogHistoriasVinculadasBacklog(estoriaBacklog) {
            PgToolbarService.iniciarPreLoaderToolbar(vm.controleForm, vm.controlePreloader);

            var dadosHistoria = {
                numero: estoriaBacklog.estoria.numero,
                ano: estoriaBacklog.estoria.ano,
                squadCodigo: estoriaBacklog.estoria.squadCodigo
            };

            RequisicaoGenericaService.listarSemParams(Api.estoria.historiasVinculadas.listarHistoriasVinculadas + '/' + dadosHistoria.numero + '/' + dadosHistoria.ano + '/' + dadosHistoria.squadCodigo)
                .then(function (success) {
                    $mdDialog.show({
                        controller: "HistoriasVinculadasDialogController",
                        controllerAs: "vm",
                        templateUrl: 'app/main/planejamento-scrum/processamento/estoria/views/tabs/estoria/dialogs/historias-vinculadas-dialog/historias-vinculadas-dialog.html',
                        targetEvent: event,
                        multiple: true,
                        clickOutsideToClose: false,
                        locals: {
                            Dados: success.data,
                            HistoriaFiltrada: dadosHistoria
                        }
                    }).then(function (houveAlteracoes) {
                        if (houveAlteracoes) {
                            vm.metodosExternosPgToolbar.metodosAcaoAtualizar();
                        }
                    });
                }, function (error) {
                    MdDialogService.alertPadrao(error.data);
                }).finally(function () {
                    PgToolbarService.finalizarPreLoaderToolbar(vm.controleForm, vm.controlePreloader);
                });
        }

        /**
         *
         * @param {eventButton} event
         */
        function abrirDialogAdicionarEstoriaBacklog(event) {
            var itensIterno = function () {
                $mdDialog.show({
                    controller: "SprintDialogBacklogAdicionarEstoriaEspecificaController",
                    controllerAs: "vm",
                    templateUrl: vm.htmlRota.tabBacklog.cadastrarEstoriaEspecificaNoBacklog,
                    //parent: ---------------,
                    targetEvent: event,
                    clickOutsideToClose: false,
                    locals: {
                        Sprint: vm.sprint
                    }
                });
            };

            // Verifica Se é o Srint corrente
            if (verificaSprintCorrente()) {
                alertaUsuarioSprintNaoAtual(function () {
                    itensIterno();
                });
            } else {
                itensIterno();
            }
        }

        /**
         *
         * @param {index} index index na tabela da estoria selecionada
         * @param {eventButton} event
         * @param {situacao} situacao
         * @param {estoria} estoria estoria selecionada da tabela
         */
        function abrirDialogEstoriaBacklogSituacao(
            index,
            event,
            situacao,
            estoria,
            estoriaBacklog
        ) {
            var itensIterno = function () {
                $mdDialog.show({
                    controller: "SprintDialogBacklogSituacaoController",
                    controllerAs: "vm",
                    templateUrl: vm.htmlRota.tabBacklog.dialogSituacao,
                    //parent: ---------------,
                    targetEvent: event,
                    multiple: true,
                    clickOutsideToClose: false,
                    locals: {
                        Index: index,
                        Situacao: situacao,
                        Situacoes: vm.situacoes,
                        Estoria: estoria,
                        EstoriaBacklog: estoriaBacklog,
                        SituacoesFiltrada: null
                    }
                });
            };

            // Verifica Se é o Srint corrente
            if (verificaSprintCorrente()) {
                alertaUsuarioSprintNaoAtual(function () {
                    itensIterno();
                });
            } else {
                itensIterno();
            }
        }

        /**
         *
         * @param {eventButton} event
         * @param {estoria} estoria
         */
        function abrirDialogEstoriaBacklogColaboradores(event, estoria) {
            var itensIterno = function () {
                $mdDialog.show({
                    controller: "SprintDialogBacklogColaboradoresController",
                    controllerAs: "vm",
                    templateUrl: vm.htmlRota.tabBacklog.dialogColaborador,
                    //parent: ---------------,
                    targetEvent: event,
                    multiple: true,
                    clickOutsideToClose: false,
                    locals: {
                        Estoria: estoria
                    }
                });
            };

            // Verifica Se é o Srint corrente
            if (verificaSprintCorrente()) {
                alertaUsuarioSprintNaoAtual(function () {
                    itensIterno();
                });
            } else {
                itensIterno();
            }
        }

        /**
         *
         * @param {event} event
         * @param {estoria} backlogItem
         */
        function abrirDialogEstoriaBacklogPontuacao(event, backlogItem) {
            var itensIterno = function () {
                $mdDialog.show({
                    controller: "SprintDialogBacklogEstimativaPontosController",
                    controllerAs: "vm",
                    multiple: true,
                    templateUrl: vm.htmlRota.tabBacklog.dialogEstimativaPontos,
                    //parent: ---------------,
                    targetEvent: event,
                    clickOutsideToClose: false,
                    locals: {
                        BacklogItem: backlogItem
                    }
                });
            };

            // Verifica Se é o Srint corrente
            if (verificaSprintCorrente()) {
                alertaUsuarioSprintNaoAtual(function () {
                    itensIterno();
                });
            } else {
                itensIterno();
            }
        }

        function retornaSigla(event, item) {
            var arrayNomes = item.split(" ");
            var retorno = arrayNomes[0][0] + arrayNomes[0][1];
            return retorno;
        }

        function verificaPontuacao(estoria, pontuacaoEntregue) {
            if ((pontuacaoEntregue > 0 && (estoria.estoria.ultimoHistoricoSituacao.situacaoCodigo != 15 && estoria.estoria.ultimoHistoricoSituacao.situacaoCodigo != 9)) || pontuacaoEntregue > estoria.pontuacaoInicial) {
                return true;
            } else
                return false;
        }
        /**
         *
         * @param {event} event
         * @param {estoria} backlogItem
         */
        function abrirDialogEstoriaBacklogHoras(event, backlogItem) {
            $mdDialog.show({
                controller: "SprintDialogBacklogHorasController",
                controllerAs: "vm",
                templateUrl: vm.htmlRota.tabBacklog.dialogEstimativaHoras,
                //parent: ---------------,
                targetEvent: event,
                clickOutsideToClose: false,
                locals: {
                    Estoria: backlogItem.estoria
                }
            });
        }

        /**
         *
         * @param {event} event
         * @param {estoria} backlogItem
         */
        function abrirDialogEstoriaBacklogPriorizacao(event, backlogItem) {
            var itensIterno = function () {
                $mdDialog.show({
                    controller: "SprintDialogBacklogPriorizacaoController",
                    controllerAs: "vm",
                    templateUrl: vm.htmlRota.tabBacklog.dialogPriorizacao,
                    //parent: ---------------,
                    targetEvent: event,
                    multiple: true,
                    clickOutsideToClose: false,
                    locals: {
                        BacklogItem: backlogItem
                    }

                }).then(function (houveAlteracao) {
                    if (houveAlteracao) {
                        atualizarNoController();
                    }
                })
            };

            // Verifica Se é o Srint corrente
            if (verificaSprintCorrente()) {
                alertaUsuarioSprintNaoAtual(function () {
                    itensIterno();
                });
            } else {
                itensIterno();
            }
        }
        //endregion

        // Métodos Tab Recursos region

        /**
         *
         * @param {recurso} recurso
         */
        function salvarRecurso(recurso) {
            recurso = setaChavePrimariaSprint(recurso);
            return RequisicaoGenericaService.salvar(
                Api.sprint.recurso.criar,
                recurso
            );
        }

        /**
         *
         * @param {recurso} recurso
         */
        function editarRecurso(recurso) {
            recurso = setaChavePrimariaSprint(recurso);
            return RequisicaoGenericaService.editar(
                Api.sprint.recurso.atualizar,
                recurso
            );
        }

        /**
         *
         * @param {eventButton} event
         * @param {recurso} recurso
         */
        function excluirRecurso(event, recurso) {
            var itensIterno = function () {
                ServicosGenericoService.excluirRegistroPorCodigoOuGenericamente(
                    Api.sprint.recurso.excluir,
                    vm.sprint.recursos,
                    recurso,
                    vm.controleForm,
                    event,
                    "Deseja realmente excluir este recurso ?"
                );
            };

            // Verifica Se é o Srint corrente
            if (verificaSprintCorrente()) {
                alertaUsuarioSprintNaoAtual(function () {
                    itensIterno();
                });
            } else {
                itensIterno();
            }
        }

        /**
         * Método que irá selecionar o recurso selecionado na tabela
         * @param {recurso} recurso
         */
        function selecionarRecurso(recurso) {
            var itensIterno = function () {
                vm.recurso = angular.copy(recurso);
                vm.metodosGeral.redefineConfiguracoesIniciaisNoFormulario();
                vm.controladorSprint.tabRecursos.editar = true;
            };

            // Verifica Se é o Srint corrente
            if (verificaSprintCorrente()) {
                alertaUsuarioSprintNaoAtual(function () {
                    itensIterno();
                });
            } else {
                itensIterno();
            }
        }

        /**
         * Método que irá configurar e limpar o filtro do md-header do md-select de Recursos
         */
        function configuraMdSelectRecursos() {
            vm.filtrarRecursos = "";
            angular
                .element("#tab-recursos-usuario-md-select")
                .on("keydown", function (ev) {
                    ev.stopPropagation();
                });
        }
        //endregion

        // Métodos Tab Abatimentos region

        /**
         *
         * @param {abatimento} abatimento
         */
        function salvarAbatimento(abatimento) {
            abatimento = setaChavePrimariaSprint(abatimento);
            return RequisicaoGenericaService.salvar(
                Api.sprint.abatimento.criar,
                abatimento
            );
        }

        /**
         *
         * @param {abatimento} abatimento
         */
        function editarAbatimento(abatimento) {
            abatimento = setaChavePrimariaSprint(abatimento);
            return RequisicaoGenericaService.editar(
                Api.sprint.abatimento.atualizar,
                abatimento
            );
        }

        /**
         *
         * @param {eventButton} event
         * @param {abatimento} abatimento
         */
        function excluirAbatimento(event, abatimento) {
            var itensIterno = function () {
                ServicosGenericoService.excluirRegistroPorCodigoOuGenericamente(
                    Api.sprint.abatimento.excluir,
                    vm.sprint.abatimentos,
                    abatimento,
                    vm.controleForm,
                    event,
                    "Deseja realmente excluir está abatimento ?"
                );
            };

            // Verifica Se é o Srint corrente
            if (verificaSprintCorrente()) {
                alertaUsuarioSprintNaoAtual(function () {
                    itensIterno();
                });
            } else {
                itensIterno();
            }
        }

        /**
         * Método para selecionar o abatimento selecionado na tabela
         * @param {abatimento} abatimento
         */
        function selecionarAbatimento(abatimento) {
            var itensIterno = function () {
                vm.abatimento = angular.copy(abatimento);
                vm.metodosGeral.redefineConfiguracoesIniciaisNoFormulario();
                vm.controladorSprint.tabAbatimentos.editar = true;
            };

            // Verifica Se é o Srint corrente
            if (verificaSprintCorrente()) {
                alertaUsuarioSprintNaoAtual(function () {
                    itensIterno();
                });
            } else {
                itensIterno();
            }
        }
        //endregion

        // Métodos Tab Registros region

        /**
         *
         * @param {eventButton} event
         * @param {registro} registro registro selecionado na tabela
         * @param {apenasVisualizacao} apenasVisualizacao variavel booleana que irá definir se será possível editar ou não os campos no dialog
         */
        function abrirDialogRegistro(event, registro, apenasVisualizacao) {
            var itensIterno = function () {
                $mdDialog.show({
                    controller: "SprintDialogRegistrosController",
                    controllerAs: "vm",
                    templateUrl: vm.htmlRota.tabRegistro.dialogRegistro,
                    //parent: ---------------,
                    targetEvent: event,
                    clickOutsideToClose: false,
                    locals: {
                        FiltrarTabelaPorRegistro: vm.metodosRegistro.filtrarTabelaPorRegistro,
                        ControleForm: vm.controleForm,
                        Sprint: vm.sprint,
                        Registro: registro,
                        RegistrosSituacoes: vm.registrosSituacoes,
                        Colaboradores: vm.usuarios,
                        EstoriasBacklog: vm.sprint.backlogEstorias,
                        ApenasVisualizacao: apenasVisualizacao
                    }
                });
            };

            // Verifica Se é o Srint corrente
            if (verificaSprintCorrente() && !apenasVisualizacao) {
                alertaUsuarioSprintNaoAtual(function () {
                    itensIterno();
                });
            } else {
                itensIterno();
            }
        }

        /**
         *
         * @param {eventButton} event
         * @param {registro} registro
         */
        function excluirRegistro(event, registro) {
            var itensIterno = function () {
                ServicosGenericoService.excluirRegistroPorCodigoOuGenericamente(
                    Api.sprint.registro.excluir,
                    vm.sprint.registros,
                    registro,
                    vm.controleForm,
                    event,
                    "Deseja realmente excluir este registro ?",
                    function (success) {
                        MdToastService.toastPadrao("Registro excluído com sucesso!");
                        SprintService.verificaLegendasSelecionadasRegistros(
                            success.data.totalHorasRegistros
                        );
                        vm.sprint.totalDeHorasPorRegistroSituacao =
                            success.data.totalHorasRegistros;
                    }
                );
            };

            // Verifica Se é o Srint corrente
            if (verificaSprintCorrente()) {
                alertaUsuarioSprintNaoAtual(function () {
                    itensIterno();
                });
            } else {
                itensIterno();
            }
        }

        /**
         * Método que irá filtrar tabela por registro selecionado
         * @param {index} index index do registro selecionado na tabela
         * @param {*} registroSelecionado registro selecionado na tabela
         */
        function filtrarTabelaPorRegistro(index, registroSelecionado) {
            registroSelecionado.legendaSelecionada = !registroSelecionado.legendaSelecionada;
            if (
                $rootScope.registrosSelecionados.indexOf(
                    registroSelecionado.descricao
                ) === -1
            ) {
                $rootScope.registrosSelecionados.push(registroSelecionado.descricao);
            } else {
                $rootScope.registrosSelecionados.splice(
                    $rootScope.registrosSelecionados.indexOf(
                        registroSelecionado.descricao
                    ),
                    1
                );
            }
        }

        /**
         *
         */
        function desmarcarFiltros() {
            $rootScope.registrosSelecionados = [];
            angular.forEach(vm.sprint.totalDeHorasPorRegistroSituacao, function (
                item,
                value
            ) {
                item.legendaSelecionada = false;
            });
        }

        //endregion

        // Métodos Tab Limites region

        /**
         *
         * @param {limite} limite
         */
        function salvarLimite(limite) {
            limite = setaChavePrimariaSprint(limite);
            return RequisicaoGenericaService.salvar(
                Api.sprint.registro_situacao_limite_aceitavel.criar,
                limite
            );
        }

        /**
         *
         * @param {limite} limite
         */
        function editarLimite(limite) {
            limite = setaChavePrimariaSprint(limite);
            return RequisicaoGenericaService.editar(
                Api.sprint.registro_situacao_limite_aceitavel.atualizar,
                limite
            );
        }

        /**
         *
         * @param {eventButton} event
         * @param {limite} limite
         */
        function excluirLimite(event, limite) {
            var itensIterno = function () {
                ServicosGenericoService.excluirRegistroPorCodigoOuGenericamente(
                    Api.sprint.registro_situacao_limite_aceitavel.excluir,
                    vm.sprint.situacoesLimitesAceitaveis,
                    limite,
                    vm.controleForm,
                    event,
                    "Deseja realmente excluir este limite ?"
                );
            };

            // Verifica Se é o Srint corrente
            if (verificaSprintCorrente()) {
                alertaUsuarioSprintNaoAtual(function () {
                    itensIterno();
                });
            } else {
                itensIterno();
            }
        }

        /**
         * Método que irá selecionar o limite selecionado da tabela
         * @param {limite} situacaoLimiteAceitavel
         */
        function selecionarLimite(situacaoLimiteAceitavel) {
            var itensIterno = function () {
                vm.situacaoLimiteAceitavel = angular.copy(situacaoLimiteAceitavel);
                vm.metodosGeral.redefineConfiguracoesIniciaisNoFormulario();
                vm.controladorSprint.tabLimites.editar = true;
            };

            // Verifica Se é o Srint corrente
            if (verificaSprintCorrente()) {
                alertaUsuarioSprintNaoAtual(function () {
                    itensIterno();
                });
            } else {
                itensIterno();
            }
        }
        //endregion

        // Métodos Tab Meta region

        /**
         *
         * @param {eventButton} event
         * @param {meta} meta
         * @param {apenasVisualizacao} apenasVisualizacao variavel booleana que irá definir se será possível editar ou não os campos no dialog
         */

        var tiposMeta = vm.tiposMeta.reverse();

        function abrirDialogAcompanhamentoMeta() {
            if (!vm.desabilitarBotao) {
                vm.desabilitarBotao = true;
                vm.requisicaoSolicitada = true
            }

            RequisicaoGenericaService.listarSemParams(Api.sprint.meta.acompanhamentoMeta + '/' + vm.sprint.numero + '/' + vm.sprint.squadCodigo).then(
                function (success) {
                    $mdDialog.show({
                        controller: "AcompanhamentoMetaDialogController",
                        controllerAs: "vm",
                        templateUrl: vm.htmlRota.tabMeta.dialogAcompanhamentoMeta,
                        clickOutsideToClose: false,
                        multiple: true,
                        locals: {
                            TiposMeta: tiposMeta,
                            SituacoesHistorias: vm.coresSituacoes,
                            AbrirHistoria: editarEstoriaBacklog,
                            SprintNumero: vm.sprint.numero,
                            AbrirDialogHistoriasVinculadas: abrirDialogHistoriasVinculadasBacklog,
                            AbrirDialogEstoriaSituacao: abrirDialogEstoriaBacklogSituacao,
                            AbrirDialogEstoriaColaboradores: abrirDialogEstoriaBacklogColaboradores,
                            AbrirDialogEstoriaPontuacao: abrirDialogEstoriaBacklogPontuacao,
                            VerificaPontuacao: verificaPontuacao,
                            HistoriaMeta: success.data.backlog,
                            TotalizadoresPontosStack: success.data.totalizadoresPontosStack,
                            TotalizadoresPontosDesenvolvedor: success.data.totalizadoresPontosDesenvolvedor,
                            Stack: vm.stack,
                            SquadCodigo: vm.sprint.squadCodigo
                        }
                    });
                    vm.desabilitarBotao = false;
                    vm.requisicaoSolicitada = false;
                });
        }

        function abrirDialogMeta(event, meta, apenasVisualizacao) {
            var itensIterno = function () {
                $mdDialog.show({
                    controller: "SprintDialogMetaController",
                    controllerAs: "vm",
                    templateUrl: vm.htmlRota.tabMeta.dialogMeta,
                    //parent: ---------------,
                    targetEvent: event,
                    clickOutsideToClose: false,
                    locals: {
                        ControleForm: vm.controleForm,
                        SprintNumero: vm.sprint.numero,
                        SprintSquadCodigo: vm.sprint.squadCodigo,
                        Metas: vm.sprint.metas,
                        Meta: meta,
                        ApenasVisualizacao: apenasVisualizacao,
                        Solucoes: vm.solucoes,
                        TiposMeta: vm.tiposMeta
                    }
                }).then(function (success, houveAlteracoes) {
                    if (houveAlteracoes) {
                        vm.metodosExternosPgToolbar.metodosAcaoAtualizar();
                    }
                    vm.totalPontos = calculaMeta(success);
                });
            };

            // Verifica Se é o Srint corrente
            if (verificaSprintCorrente() && !apenasVisualizacao) {
                alertaUsuarioSprintNaoAtual(function () {
                    itensIterno();
                });
            } else {
                itensIterno();
            }
        }

        function abrirDialogInformacaoCalculoMeta() {
            $mdDialog.show({
                controller: "SprintDialogInformacaoCalculoMetaController",
                controllerAs: "vm",
                templateUrl: vm.htmlRota.tabMeta.dialogInformacaoCalculoMeta,
                targetEvent: event,
                clickOutsideToClose: false
            })
        }

        /**
         *
         * @param {eventButton} event
         * @param {meta} meta
         */

        function excluirMeta(event, meta) {
            var itensIterno = function () {
                ServicosGenericoService.excluirRegistroPorCodigoOuGenericamente(
                    Api.sprint.meta.excluir,
                    vm.sprint.metas,
                    meta,
                    vm.controleForm,
                    event,
                    "Deseja realmente excluir esta meta ?"
                );
            };

            // Verifica Se é o Srint corrente
            if (verificaSprintCorrente()) {
                alertaUsuarioSprintNaoAtual(function () {
                    itensIterno();
                });
            } else {
                itensIterno();
            }
        }
        //endregion

        // Métodos Tab Burndown region

        /**
         *
         * @param {eventButton} event
         */

        function abrirDialogBurndown(event) {
            $mdDialog.show({
                controller: "BurndownController",
                controllerAs: "vm",
                templateUrl: vm.htmlRota.tabBurndown.dialogBurndown,
                //parent: ---------------,
                targetEvent: event,
                clickOutsideToClose: false,
                locals: {
                    Sprint: vm.sprint
                }
            });
        }
        //endregion

        // Métodos Tab Cerimônia Detalhe region

        /**
         *
         * @param {eventButton} event
         * @param {cerimoniaDetalhe} cerimoniaDetalhe
         * @param {apenasVisualizacao} apenasVisualizacao variavel booleana que irá definir se será possível editar ou não os campos no dialog
         */
        function abrirDialogCerimoniaDetalhe(
            event,
            cerimoniaDetalhe,
            apenasVisualizacao
        ) {
            var itensIterno = function () {
                $mdDialog.show({
                    controller: "SprintDialogCerimoniaDetalheController",
                    controllerAs: "vm",
                    templateUrl: vm.htmlRota.tabCerimoniaDetalhe.dialogCerimoniaDetalhe,
                    //parent: ---------------,
                    targetEvent: event,
                    clickOutsideToClose: false,
                    locals: {
                        ControleForm: vm.controleForm,
                        SprintNumero: vm.sprint.numero,
                        SprintSquadCodigo: vm.sprint.squadCodigo,
                        DetalhesDasCerimonias: vm.sprint.detalhesDaCerimonia,
                        Cerimonias: vm.cerimonias,
                        CerimoniaDetalhe: cerimoniaDetalhe,
                        ApenasVisualizacao: apenasVisualizacao
                    }
                });
            };

            // Verifica Se é o Srint corrente
            if (verificaSprintCorrente() && !apenasVisualizacao) {
                alertaUsuarioSprintNaoAtual(function () {
                    itensIterno();
                });
            } else {
                itensIterno();
            }
        }

        /**
         *
         * @param {eventButton} event
         * @param {cerimoniaDetalhe} cerimoniaDetalhe
         */
        function excluirCerimoniaDetalhe(event, cerimoniaDetalhe) {
            var itensIterno = function () {
                ServicosGenericoService.excluirRegistroPorCodigoOuGenericamente(
                    Api.sprint.cerimonia_detalhe.excluir,
                    vm.sprint.detalhesDaCerimonia,
                    cerimoniaDetalhe,
                    vm.controleForm,
                    event,
                    "Deseja realmente excluir a cerimônia ?"
                );
            };

            // Verifica Se é o Srint corrente
            if (verificaSprintCorrente()) {
                alertaUsuarioSprintNaoAtual(function () {
                    itensIterno();
                });
            } else {
                itensIterno();
            }
        }
        //endregion

        // Métodos Tab Versão Entregue region

        /**
         *
         * @param {eventButton} event
         * @param {versaoEntregue} versaoEntregue
         * @param {apenasVisualizacao} apenasVisualizacao variavel booleana que irá definir se será possível editar ou não os campos no dialog
         */
        function abrirDialogVersaoEntregue(
            event,
            versaoEntregue,
            apenasVisualizacao
        ) {
            var itensIterno = function () {
                $mdDialog.show({
                    controller: "SprintDialogVersaoEntregueController",
                    controllerAs: "vm",
                    templateUrl: vm.htmlRota.tabVersaoEntregue.dialogVersaoEntregue,
                    //parent: ---------------,
                    targetEvent: event,
                    clickOutsideToClose: false,
                    locals: {
                        ControleForm: vm.controleForm,
                        SprintNumero: vm.sprint.numero,
                        SprintSquadCodigo: vm.sprint.squadCodigo,
                        VersoesEntregues: vm.sprint.versoesEntregues,
                        VersaoEntregue: versaoEntregue,
                        ApenasVisualizacao: apenasVisualizacao
                    }
                });
            };

            // Verifica Se é o Srint corrente
            if (verificaSprintCorrente() && !apenasVisualizacao) {
                alertaUsuarioSprintNaoAtual(function () {
                    itensIterno();
                });
            } else {
                itensIterno();
            }
        }

        /**
         *
         * @param {eventButton} event
         * @param {versaoEntregue} versaoEntregue
         */
        function excluirVersaoEntregue(event, versaoEntregue) {
            var itensIterno = function () {
                ServicosGenericoService.excluirRegistroPorCodigoOuGenericamente(
                    Api.sprint.versao_entrega.excluir,
                    vm.sprint.versoesEntregues,
                    versaoEntregue,
                    vm.controleForm,
                    event,
                    "Deseja realmente excluir está versão ?"
                );
            };

            // Verifica Se é o Srint corrente
            if (verificaSprintCorrente()) {
                alertaUsuarioSprintNaoAtual(function () {
                    itensIterno();
                });
            } else {
                itensIterno();
            }
        }
        //endregion

        //endregion

        //#region Metodos pontuacao
        function calcularTotalPontuacao(desenvolvedores) {
            var total = 0;
            angular.forEach(desenvolvedores, function (item, indice) {
                total += item.pontuacao;
            });

            return total;
        }

        function tresUltimas() {
            if (vm.tresUltimas)
                vm.tresUltimas = false;
            else
                vm.tresUltimas = true;
        }

        function abrirDialogVisualizarEstorias(estatisticas, cardAnterior) {
            $mdDialog.show({
                controller: "SprintDialogEstatisticasVisualizarEstoriasController",
                controllerAs: "vm",
                templateUrl: vm.htmlRota.tabEstatisticas.dialogs.dialogVisualizarEstorias,
                targetEvent: event,
                clickOutsideToClose: true,
                locals: {
                    NumeroSprint: estatisticas.sprintNumero,
                    SprintSquadCodigo: estatisticas.squadCodigo,
                    TipoRetorno: cardAnterior.valor,
                    ListaHistorias: []
                }
            });
        }
        //#endregion metodos pontuacao

        function selectChangeSquad(codigoSquadSelecionada) {
            vm.sprint.numero = null;
            if (vm.controleForm.inserirAtivo) _sugerirProximoNumero(codigoSquadSelecionada);
        }
    }

})();

(function () {
    "use strict";

    angular
        .module("app.planejamentoScrum.processamento.estoria")
        .controller("EstoriaController", EstoriaController);

    function EstoriaController(
        $filter,
        $mdDialog,
        $q,
        $scope,
        $state,
        $timeout,
        Api,
        DataTableConfigPadrao,
        DatatableFactory,
        EstoriaFactory,
        EstoriaService,
        ListarDesenvolvedoresAtivos,
        ListarNecessidadesCliente,
        ListarTestersAtivos,
        ListarTiposHistoriaAtivos,
        ListarTodasOrigens,
        ListarTodasSituacoes,
        ListarTodasSolucoes,
        ListarTodosClientes,
        ListarTodosMotivos,
        ListarTodosUsuarios,
        ListarTodosTiposHistoria,
        ListarUsuarioPorDetalhe,
        LoginUsuarioService,
        MdDialogService,
        MdToastService,
        NavegacaoService,
        PgToolbarService,
        RequisicaoGenericaService,
        ServicosGenericoService,
        SquadService,
        TiposTarefas,
        ToolbarService
    ) {
        var vm = this;
        vm.parseInt = parseInt;
        NavegacaoService.setTituloAba("História");
        ToolbarService.armazenarCodigoSquadUsuarioLogado(
            ListarUsuarioPorDetalhe.data.codigoSquads
        );
        vm.htmlRota = EstoriaFactory.htmlRota();
        vm.rotinas = [];
        vm.usuarioEstoriaLogado = LoginUsuarioService.usuarioArmazenado();
        vm.solicitacoes = [];
        vm.listaCustoSoftware = [];
        vm.solicitacao = null;
        vm.solicitacaoBkp = null;
        vm.ultimoCliente = 0;
        vm.controleForm = {};
        vm.clonandoHistoria = false;
        vm.listaHistoricoAlteracaoDataEntrega = [];
        var solucoesTemporaria = ListarTodasSolucoes.data;
        var PRAZO_PADRAO_DIAS = 30;
        var squadCodigoUltimaPesquisa = null;

        vm.clientes = ListarTodosClientes.data;
        // vm.solucoes = ListarTodasSolucoes.data;

        vm.motivos = ListarTodosMotivos.data;
        vm.tiposHistoria = ListarTodosTiposHistoria.data;
        vm.tiposHistoriaAtivos = ListarTiposHistoriaAtivos.data;
        vm.usuariosBkp = ListarTodosUsuarios.data;
        vm.usuarios = angular.copy(vm.usuariosBkp);
        vm.situacoes = ListarTodasSituacoes.data;
        vm.coresSituacoes = EstoriaFactory.coresSituacoes();
        vm.origens = ListarTodasOrigens.data;
        vm.tiposTarefa = TiposTarefas.data;

        vm.usuariosSetorDesenvolvimentoBkp = ListarDesenvolvedoresAtivos.data;
        vm.usuariosSetorDesenvolvimento = angular.copy(
            vm.usuariosSetorDesenvolvimentoBkp
        );

        vm.squadUsuarioLogado = ListarUsuarioPorDetalhe.data.codigoSquads;
        vm.squads = SquadService.listarSquadsUsuarioLogado(
            vm.squadUsuarioLogado
        );
        if (vm.squadUsuarioLogado.length === 1)
            _listarSolucoesVinculadas(vm.squadUsuarioLogado[0]);
        if (vm.squadUsuarioLogado.length === 1)
            _listarProjetosGerenciarCustos(vm.squadUsuarioLogado[0]);

        vm.usuariosSetorTestesBkp = ListarTestersAtivos.data;
        vm.usuariosSetorTestes = angular.copy(vm.usuariosSetorTestesBkp);
        vm.necessidadesCliente = ListarNecessidadesCliente.data;
        vm.dificuldades = EstoriaFactory.defineValoresPriorizacaoDificuldade();
        vm.origensPriorizacao = EstoriaFactory.defineValoresPriorizacaoOrigem();
        vm.criticidades = EstoriaFactory.defineValoresPriorizacaoCriticidade();
        vm.dtOptionsEstoria = angular.copy(
            DataTableConfigPadrao.dtOptionsResponsivoPaginacaoTipoNumberComInitComplete
        );
        vm.dtOptionsEstoria.columnDefs =
            EstoriaFactory.setColumnsDefsDtOptionsTabEstoria();

        vm.dtOptionsEstoriaEstimativa =
            EstoriaFactory.setDtOptionsTabEstimativa();

        vm.dtOptionsEstoriaPriorizacao = angular.copy(
            DataTableConfigPadrao.dtOptionsResponsivoSemPaginacaoComInitComplete
        );
        vm.dtOptionsEstoriaPriorizacao.columnDefs =
            EstoriaFactory.setColumnsDefsDtOptionsTabPriorizacao();

        vm.dtOptionsHistoricoSituacao = angular.copy(
            DataTableConfigPadrao.dtOptionsResponsivoSemPaginacaoComInitComplete
        );
        vm.dtOptionsHistoricoSituacao.columnDefs =
            EstoriaFactory.setColumnsDefsEstoriaHistoricoSituacao();

        vm.dtOptionsTabTarefas = EstoriaFactory.setDtOptionsTabTarefa();
        vm.dtOptionsTabTarefas.columnDefs =
            EstoriaFactory.setColumnsDefsDtOptionsTabTarefa(vm.tiposTarefa);

        vm.dtOptionsEstoriaTarefasPorRotinas_Rotinas = angular.copy(
            DataTableConfigPadrao.dtOptionsResponsivoSemPaginacao
        );
        vm.dtOptionsEstoriaTarefasPorRotinas_Rotinas.columnDefs = [
            DataTableConfigPadrao.columnDefsPadrao,
        ];

        vm.dtOptionsEstoriaTarefasPorRotinas_Tarefas = angular.copy(
            DataTableConfigPadrao.dtOptionsResponsivoSemPaginacao
        );
        vm.dtOptionsEstoriaTarefasPorRotinas_Tarefas.columnDefs =
            EstoriaFactory.setColumnsDefsEstoriaTarefasPorRotinas_tarefas();

        vm.tabSelecionada = "estoria";
        vm.controladorEstoria =
            EstoriaFactory.defineVariaveisControladorasDoSprint();

        var templatesEstoriaTarefa =
            EstoriaFactory.retornaTemplatesEstoriaTarefa();
        vm.templateSelecionadoEstoriaTarefa = templatesEstoriaTarefa[0];
        vm.rotinasSelecionadas = [];
        vm.listaDeTarefas = [];
        vm.tarefasSelecionadas = [];
        vm.exigeInsercaoDesenvolvedor = false;
        vm.exigeInsercaoTester = false;
        vm.stack = [
            {
                codigo: 1,
                descricao: "Back-end",
            },
            {
                codigo: 2,
                descricao: "Front-end",
            },
            {
                codigo: 3,
                descricao: "Mobile",
            },
            {
                codigo: 4,
                descricao: "Infraestrutura",
            },
            {
                codigo: 5,
                descricao: "Full-stack",
            },
        ];

        if ($state.params.parametrosSolicitacao) {
            vm.iniciarHabilitandoInsercao = true;
        }

        var setaChavePrimariaEstoria = setaChavePrimariaEstoria;
        var metodosInternosTarefa = {
            abrirViewParaCriarTarefasPorRotinas:
                abrirViewParaCriarTarefasPorRotinas,
            abrirViewTabelaTarefasDaEstoriaComVerificacao:
                abrirViewTabelaTarefasDaEstoriaComVerificacao,
            abrirViewTabelaTarefasDaEstoriaSemVerificacao:
                abrirViewTabelaTarefasDaEstoriaSemVerificacao,
        };

        vm.metodosGeral = {
            tabSelecionada: tabSelecionada,
            novaPesquisa: novaPesquisa,
            preDefinirCamposParaInserir: preDefinirCamposParaInserir,
            PreDefinirCamposParaEdicao: PreDefinirCamposParaEdicao,
            atualizarNoController: atualizarNoController,
            reverter: reverter,
            definirCamposClonados: definirCamposClonados,
        };

        vm.metodosEstoria = {
            pesquisar: pesquisar,
            salvar: salvar,
            editar: editar,
            excluir: excluir,
            limparCampoAtendimento: limparCampoAtendimento,
            pesquisarAutoCompleteCliente: pesquisarAutoCompleteCliente,
            alterarItemSelecionadoAutoCompleteCliente:
                alterarItemSelecionadoAutoCompleteCliente,
            selecionarEstoria: selecionarEstoria,
            configuraMdSelectSolucao: configuraMdSelectSolucao,
            configuraMdSelectCustoSoftware: configuraMdSelectCustoSoftware,
            configuraMdSelectStackResponsavel:
                configuraMdSelectStackResponsavel,
            configuraMdSelectDesenvolvedorResponsavel:
                configuraMdSelectDesenvolvedorResponsavel,
            configuraMdTesterResponsavel: configuraMdTesterResponsavel,
            configuraMdSelectUsuarioResponsavelAbertura:
                configuraMdSelectUsuarioResponsavelAbertura,
            desabilitaBotoesManipulacaoEstoria:
                desabilitaBotoesManipulacaoEstoria,
            desabilitaBotoesExcetoEdicaoManipulacaoEstoria:
                desabilitaBotoesExcetoEdicaoManipulacaoEstoria,
            ngChangeFaturarAParte: ngChangeFaturarAParte,
            configuraMdSelectSolicitacao: configuraMdSelectSolicitacao,
            configurarMdSelectSolicitacaoOnClose:
                configurarMdSelectSolicitacaoOnClose,
            selecionarSolicitacao: selecionarSolicitacao,
            listarTodasSolicitacoesCliente: listarTodasSolicitacoesCliente,
            selecionar: selecionar,
            construirDtOptions: construirDtOptions,
            abrirDialogHistoriasVinculadas: abrirDialogHistoriasVinculadas,
            configuraAutoCompleteOnBlurAtendiemnto:
                configuraAutoCompleteOnBlurAtendiemnto,
            pesquisarAutoCompleteAtendimento: pesquisarAutoCompleteAtendimento,
            alterarItemSelecionadoAutoCompleteAtendimento:
                alterarItemSelecionadoAutoCompleteAtendimento,
            changeCodigoDesenvolvedor: changeCodigoDesenvolvedor,
            changeCodigoTester: changeCodigoTester,
            selectChangeSquad: selectChangeSquad,
            selectChangeMultiplasSquads: selectChangeMultiplasSquads,
            aoSalvarConcluido: aoSalvarConcluido,
            acaoPosEditar: acaoPosEditar,
            listarHistoricoAlteracaoDataEntrega: listarHistoricoAlteracaoDataEntrega,
            abrirDialogAlterarDataEntrega: abrirDialogAlterarDataEntrega,
            abrirDialogHistoricoAlteracaoDataEntrega: abrirDialogHistoricoAlteracaoDataEntrega,
            desabilitaBotaoClonar: desabilitaBotaoClonar,
            desabilitarBotaoEditandoRequisito: desabilitarBotaoEditandoRequisito,
            trackSolicitacao: trackSolicitacao,
        };

        vm.metodosTarefa = {
            abrirDialogTarefas: abrirDialogTarefas,
            abrirDialogEditarCampoTarefa: abrirDialogEditarCampoTarefa,
            selecionarTemplate: selecionarTemplate,
            excluir: excluirTarefa,
            converteIdParaTipo: converteIdParaTipo,
            metodosParaGerarTarefasEstoriaPorRotinas: {
                metodosRotina: {
                    selecionarTarefasDasRotinas: selecionarTarefasDasRotinas,
                    gerarListaDeTarefas: gerarListaDeTarefas,
                },
                metodosTarefas: {
                    selecionarTarefas: selecionarTarefas,
                    salvar: salvarTarefas,
                    cancelar: cancelarTarefa,
                },
            },
        };

        vm.metodosHistorico = {
            abrirDialogEditarHistorico: abrirDialogEditarHistorico,
            excluir: excluirHistorico,
        };

        vm.metodosRequisito = {
            editarRequisito: editarRequisito,
            salvarRequisito: salvarRequisito,
        };

        $scope.$watch("vm.estoria", function (newValue, oldValue) {
            vm.metodosGeral.tabSelecionada(vm.tabSelecionada);
            if (vm.controleForm.editarAtivo) {
                vm.desabilitarDataEntrega = vm.estoria.prazoAcordado &&
                    vm.listaHistoricoAlteracaoDataEntrega &&
                    vm.listaHistoricoAlteracaoDataEntrega.length > 0;
            } else {
                vm.desabilitarDataEntrega = !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo || vm.estoria.prazoAcordado;
            }
            if (vm.clonandoHistoria) {
                _configurarDataEntregaParaInsercao(vm.estoria.prazoAcordado);
            }
        });

        $scope.$watch("vm.estoria.prazoAcordado", function (newValue, oldValue) {
            if (oldValue === newValue) {
                if (vm.controleForm.editarAtivo) {
                    vm.desabilitarDataEntrega = vm.estoria.prazoAcordado && _temHistoricoAlteracao();
                }
                return;
            }

            if (vm.controleForm.inserirAtivo) {
                _configurarDataEntregaParaInsercao(vm.estoria.prazoAcordado);
            } else if (vm.controleForm.editarAtivo) {
                _configurarDataEntregaParaEdicao(vm.estoria.prazoAcordado);
            } else {
                _configurarDataEntregaPadrao();
            }
        });

        $scope.$watch(
            "vm.estoria.faturamentoRealizado",
            function (newValue, oldValue) {
                if (vm.estoria.faturamentoRealizado) {
                    vm.estoria.faturamentoRealizado = true;
                } else vm.estoria.faturamentoRealizado = false;
            }
        );
        /**
         *
         * @param {*} entidade
         */
        function setaChavePrimariaEstoria(entidade) {
            entidade.estoria = {
                numero: vm.estoria.numero,
                ano: vm.estoria.ano,
                usuarioCodigoAbertura: vm.estoria.usuarioCodigoAbertura,
            };
        }

        /**
         * Método que é chamado sempre quando ocorre uma transição de tab
         * @param {tab} tab
         */
        function tabSelecionada(tab) {
            if (vm.squadUsuarioLogado.length === 1) {
                vm.estoria.squadCodigo = vm.squadUsuarioLogado[0];
                vm.estoria.squadCodigos = vm.squadUsuarioLogado;
            }
            vm.tabSelecionada = tab;
            EstoriaService.verificaTabSelecionada(
                tab,
                vm.estoria,
                vm.estoria.numero,
                vm.estoria.ano,
                vm.controleForm,
                vm.estoria.squadCodigo
            );
            EstoriaService.controlaButtonsToolbar(tab, vm.controleForm);
            if (angular.isDefined(vm.controleForm)) {
                vm.controleForm.pesquisarDatatable =
                    EstoriaService.verificaTabParaHabilitarPesquisarHeaderPadrao(
                        tab
                    );
            }
        }

        function novaPesquisa() {
            vm.textoDePesquisaAutoCompleteCliente = "";
            vm.tabSelecionada = "estoria";
            vm.tiposHistoria = ListarTodosTiposHistoria.data;
            vm.estoria = {};
            var squadPadrao = ToolbarService.squadSelecionado();
            vm.estoria.squadCodigo = squadPadrao;
            vm.estoria.squadCodigos = [squadPadrao];
            _listarSolucoesVinculadas(squadPadrao);
        }

        function preDefinirCamposParaInserir() {
            vm.solicitacao = {};
            _limparSolicitacoes();
            vm.solucoes = [];
            vm.listaHistoricoAlteracaoDataEntrega = [];
            vm.estoria.faturamentoRealizado = true;
            vm.estoria.faturarAParte = false;
            vm.estoria.motivoNaoFaturamento = "";
            vm.estoria.permitirConsultaExterna = true;
            vm.usuariosSetorDesenvolvimento = angular.copy(
                vm.usuariosSetorDesenvolvimentoBkp
            );
            vm.usuariosSetorTestes = angular.copy(vm.usuariosSetorTestesBkp);
            vm.usuarios = angular.copy(vm.usuariosBkp);

            vm.estoria = EstoriaFactory.predefinirCamposParaInserirEstoria(
                vm.controleForm,
                vm.listaCustoSoftware,
                $state.params.parametrosSolicitacao
            );

            vm.tiposHistoria = angular.copy(vm.tiposHistoriaAtivos);

            if ($state.params.parametrosSolicitacao) {
                vm.textoDePesquisaAutoCompleteCliente =
                    $state.params.parametrosSolicitacao.cliente.codigo +
                    " - " +
                    $state.params.parametrosSolicitacao.cliente.nome;
                alterarItemSelecionadoAutoCompleteCliente(
                    $state.params.parametrosSolicitacao.cliente
                );
                if (vm.squadUsuarioLogado.length > 1) {
                    vm.estoria.squadCodigo =
                        $state.params.parametrosSolicitacao.squadCodigo;
                }
                _sugerirProximoNumero(
                    $state.params.parametrosSolicitacao.squadCodigo
                );
                vm.solicitacao =
                    $state.params.parametrosSolicitacao.solicitacao;
                selecionarSolicitacao(vm.solicitacao);
            } else {
                vm.estoria.squadCodigo = ToolbarService.squadSelecionado();
                _sugerirProximoNumero(vm.estoria.squadCodigo);
                _listarProjetosGerenciarCustos(vm.estoria.squadCodigo);
            }

            if (vm.estoria.clienteCodigo) {
                vm.ultimoCliente = 0;
                listarTodasSolicitacoesCliente(vm.estoria.clienteCodigo);
            }
        }

        function _sugerirProximoNumero(squadCodigo) {
            RequisicaoGenericaService.listarSemParams(
                Api.estoria.proximoCodigo + "/" + squadCodigo
            ).then(
                function (success) {
                    vm.estoria.numero = success.data;
                },
                function (error) {
                    MdDialogService.alertPadrao(error.data);
                }
            );
        }

        function PreDefinirCamposParaEdicao() {
            vm.estoriaForm.$setDirty();
            vm.estoriaBkp = angular.copy(vm.estoria);
            vm.estoria.dataEntrada = new Date(vm.estoria.dataEntrada);
            vm.estoria.dataEntrega = new Date(vm.estoria.dataEntrega);
            if (vm.estoria.clienteCodigo) {
                vm.ultimoCliente = 0;
                listarTodasSolicitacoesCliente(vm.estoria.clienteCodigo);
            }

            vm.desabilitarDataEntrega = vm.estoria.prazoAcordado &&
                vm.listaHistoricoAlteracaoDataEntrega &&
                vm.listaHistoricoAlteracaoDataEntrega.length > 0;

            if (!vm.estoria.codigoCustoSoftware)
                vm.estoria.codigoCustoSoftware =
                    EstoriaFactory.retornaCodigoCustoSoftwareDefault(
                        vm.listaCustoSoftware
                    );

            vm.tiposHistoria = angular.copy(vm.tiposHistoriaAtivos);

            var tipoInativo = ListarTodosTiposHistoria.data.find(function (
                tipo
            ) {
                return tipo.codigo == vm.estoria.tipoCodigo && !tipo.ativo;
            });

            if (tipoInativo) {
                vm.tiposHistoria.push(tipoInativo);
            }

            _realizarRequisicao().then(function (success) {
                _retornarSituacaoAtualHistoria(success);
            });
        }

        /**
         * Método que recarrega a entidade da aba ativa quando for clicado no botão atualizar da  toolbar
         */
        function atualizarNoController() {
            vm.metodosGeral.tabSelecionada(vm.tabSelecionada);
        }

        function pesquisar() {
            var squadCodigoSelecionado = vm.estoria.squadCodigo;
            squadCodigoUltimaPesquisa = squadCodigoSelecionado;

            if (vm.squadUsuarioLogado.length === 1) {
                vm.estoria.squadCodigo = vm.squadUsuarioLogado;
            } else {
                if (vm.estoria.squadCodigos) {
                    vm.estoria.squadCodigo = vm.estoria.squadCodigos;
                } else {
                    vm.estoria.squadCodigo = [vm.estoria.squadCodigo];
                }
            }

            var entidadeParaEnvio = vm.entidadeDeEnvio
                ? vm.entidadeDeEnvio.clsEntidade
                : PgToolbarService.recuperarEntidadeDeEnvio().clsEntidade;

            if (entidadeParaEnvio) {
                entidadeParaEnvio.squadCodigo = vm.estoria.squadCodigo;
            }

            vm.usuariosSetorDesenvolvimento = angular.copy(
                vm.usuariosSetorDesenvolvimentoBkp
            );
            vm.usuariosSetorTestes = angular.copy(vm.usuariosSetorTestesBkp);
            vm.usuarios = angular.copy(vm.usuariosBkp);

            var result = _realizarRequisicao();

            result.then(
                function (success) {
                    vm.estoria.squadCodigo = squadCodigoSelecionado;
                    vm.tiposHistoria = ListarTodosTiposHistoria.data;
                    var desenvolvedorHistoria =
                        success.data.lstResultado[0].desenvolvedor;
                    var testerHistoria = success.data.lstResultado[0].tester;
                    var usuarioAbertura =
                        success.data.lstResultado[0].usuarioAbertura;
                    var usuarioResponsavel =
                        success.data.lstResultado[0].usuarioResponsavel;
                    _retornarSituacaoAtualHistoria(success);

                    listarHistoricoAlteracaoDataEntrega(success.data.lstResultado[0])
                        .then(function (historicoSuccess) {
                            vm.listaHistoricoAlteracaoDataEntrega = historicoSuccess.data || [];
                            if (vm.controleForm.editarAtivo) {
                                vm.desabilitarDataEntrega = vm.estoria.prazoAcordado &&
                                    vm.listaHistoricoAlteracaoDataEntrega &&
                                    vm.listaHistoricoAlteracaoDataEntrega.length > 0;
                            }
                        })
                        .catch(function (historicoError) {
                            vm.listaHistoricoAlteracaoDataEntrega = [];
                            if (vm.controleForm.editarAtivo) {
                                vm.desabilitarDataEntrega = false;
                            }
                        });

                    if (success.data.lstResultado[0].solicitacaoNumero) {
                        var solicitacaoVinculada = {
                            numero: success.data.lstResultado[0].solicitacaoNumero,
                            ano: success.data.lstResultado[0].solicitacaoAno,
                            squadCodigo: success.data.lstResultado[0].squadCodigo,
                            descricao: success.data.lstResultado[0].solicitacaoNumero + "/" + success.data.lstResultado[0].solicitacaoAno
                        };

                        vm.solicitacoes = [solicitacaoVinculada];
                        vm.solicitacao = solicitacaoVinculada;
                    } else {
                        vm.solicitacao = {};
                    }

                    vm.solicitacaoBkp = angular.copy(vm.solicitacao);

                    var temNaLista = false;
                    if (desenvolvedorHistoria != null) {
                        vm.usuariosSetorDesenvolvimento[0].usuarios.forEach(
                            function (item) {
                                if (
                                    item.codigo == desenvolvedorHistoria.codigo
                                ) {
                                    temNaLista = true;
                                }
                            }
                        );

                        if (!temNaLista) {
                            vm.usuariosSetorDesenvolvimento[0].usuarios.push(
                                desenvolvedorHistoria
                            );
                        }
                    }

                    temNaLista = false;
                    if (testerHistoria != null) {
                        vm.usuariosSetorTestes[0].usuarios.forEach(function (
                            item
                        ) {
                            if (item.codigo == testerHistoria.codigo) {
                                temNaLista = true;
                            }
                        });

                        if (!temNaLista) {
                            vm.usuariosSetorTestes[0].usuarios.push(
                                testerHistoria
                            );
                        }
                    }

                    temNaLista = false;
                    if (usuarioAbertura != null) {
                        vm.usuarios.forEach(function (item) {
                            if (item.codigo == usuarioAbertura.codigo) {
                                temNaLista = true;
                            }
                        });

                        if (!temNaLista) {
                            vm.usuarios.push(usuarioAbertura);
                        }
                    }

                    temNaLista = false;
                    if (usuarioResponsavel != null) {
                        vm.usuarios.forEach(function (item) {
                            if (item.codigo == usuarioResponsavel.codigo) {
                                temNaLista = true;
                            }
                        });

                        if (!temNaLista) {
                            vm.usuarios.push(usuarioResponsavel);
                        }
                    }
                },
                function (error) {
                    vm.estoria.squadCodigo = squadCodigoSelecionado;
                    console.log(error);
                }
            );
            return result;
        }

        /**
         *
         * @param {estoria} estoria
         */
        function salvar(estoria) {

            if (vm.squadUsuarioLogado.length === 1)
                vm.estoria.squadCodigo = vm.squadUsuarioLogado[0];
            return RequisicaoGenericaService.salvar(Api.estoria.criar, estoria);
        }

        /**
         *
         * @param {estoria} estoria
         */
        function editar(estoria) {
            estoria.gerarLogAutomacaoPrazoAcordado = estoria.prazoAcordado &&
                vm.listaHistoricoAlteracaoDataEntrega &&
                vm.listaHistoricoAlteracaoDataEntrega.length == 0;

            if (vm.squadUsuarioLogado.length === 1)
                vm.estoria.squadCodigo = vm.squadUsuarioLogado[0];
            return RequisicaoGenericaService.editar(
                Api.estoria.atualizar,
                vm.estoria
            );
        }

        /**
         *
         * @param {estoria} estoria
         */
        function excluir(estoria) {
            if (vm.squadUsuarioLogado.length === 1)
                vm.estoria.squadCodigo = vm.squadUsuarioLogado[0];
            return RequisicaoGenericaService.excluir(
                Api.estoria.excluir,
                estoria.numero + "/" + estoria.ano + "/" + estoria.squadCodigo
            );
        }

        /**
         * Método que irá limpar o campo de atendimento quando a origem for diferente de for diferente de atendimento
         * @param {origem} origem
         */
        function limparCampoAtendimento(origem) {
            if (origem != 2) {
                vm.estoria.atendimento = null;
            }
        }

        /**
         * Método utilizado no modo exibido tabela, para selecionar uma estória
         * @param {estoria} estoria
         */
        function selecionarEstoria(estoria) {
            vm.controleForm.listarTodas(vm.estorias.indexOf(estoria));
            vm.estoria = estoria;
            vm.pesquisar = "";
        }

        /**
         * Método que irá pesquisar um cliente no componente md-auto-complete de Cliente com base no que está sendo digitado
         * @param {textoDePesquisa} query
         */
        function pesquisarAutoCompleteCliente(query) {
            query = query.toLowerCase();
            var resultado = query
                ? vm.clientes.filter(function (item, index) {
                    return (
                        item.codigo == query ||
                        item.nome.toLowerCase().search(query) != -1
                    );
                })
                : vm.clientes;

            return resultado;
        }

        /**
         * Método irá alterar o cliente de 'vm.estoria.clienteCodigo' sempre que o cliente mudar
         * @param {cliente} item
         */
        function alterarItemSelecionadoAutoCompleteCliente(item) {
            if (item) {
                vm.estoria.clienteCodigo = item.codigo;
                vm.estoria.cliente = item;
                vm.solucoes = item.solucoes;
                if (
                    !vm.controleForm.pesquisaAtiva &&
                    !$state.params.parametrosSolicitacao
                ) {
                    vm.estoria.solucaoCodigo = null;
                }
            } else {
                vm.textoDePesquisaAutoCompleteCliente = "";
                vm.estoria.solucaoCodigo = null;
                vm.estoria.clienteCodigo = null;
                vm.solucoes = solucoesTemporaria;
                vm.estoria.cliente = null;
            }
            _listarSolucoesVinculadas(vm.estoria.squadCodigo);
            _listarProjetosGerenciarCustos(vm.estoria.squadCodigo);
            listarTodasSolicitacoesCliente(item ? item.codigo : null);
        }

        /**
         * Método que configura o md-select de solução, sempre limpando o md-select-header de Solução quando o component é aberto
         */
        function configuraMdSelectSolucao() {
            vm.filtrarSolucoes = "";
            angular
                .element("#tab-estoria-solucao-md-select")
                .on("keydown", function (ev) {
                    ev.stopPropagation();
                });
        }

        function configuraMdSelectCustoSoftware() {
            vm.filtrarCustoSoftware = "";
            angular
                .element("#tab-estoria-custo-software-md-select")
                .on("keydown", function (ev) {
                    ev.stopPropagation();
                });
        }

        function configuraMdSelectStackResponsavel() {
            vm.filtrarStackResponsavel = "";
            angular
                .element("#tab-estoria-stack-responsavel-md-select")
                .on("keydown", function (ev) {
                    ev.stopPropagation();
                });
        }

        function configuraMdSelectDesenvolvedorResponsavel() {
            vm.filtrarDesenvolvedores = "";
            angular
                .element("#tab-estoria-desenvolvedorResponsavel-md-select")
                .on("keydown", function (ev) {
                    ev.stopPropagation();
                });
        }

        function configuraMdTesterResponsavel() {
            vm.filtrarTesters = "";
            angular
                .element("#tab-estoria-testerResponsavel-md-select")
                .on("keydown", function (ev) {
                    ev.stopPropagation();
                });
        }

        function configuraMdSelectUsuarioResponsavelAbertura() {
            vm.filtrarUsuarios = "";
            angular
                .element("#tab-estoria-usuarioResponsavelHistoria-md-select")
                .on("keydown", function (ev) {
                    ev.stopPropagation();
                });
        }

        function ngChangeFaturarAParte() {
            if (!vm.estoria.faturarAParte)
                vm.estoria.faturamentoRealizado = true;
        }

        function desabilitaBotoesManipulacaoEstoria() {
            switch (vm.tabSelecionada) {
                case "priorizacao":
                    return true;
                case "estimativa":
                    return true;
                case "tarefas":
                    return true;
                case "historico":
                    return true;
                case "requisito":
                    return true;
                case "faturamento":
                    return true;
                case "clientes":
                    return true;
                default:
                    return false;
            }
        }

        function desabilitaBotoesExcetoEdicaoManipulacaoEstoria() {
            switch (vm.tabSelecionada) {
                case "faturamento":
                    return false;
                default:
                    return desabilitaBotoesManipulacaoEstoria();
            }
        }

        function desabilitaBotaoClonar() {
            return desabilitaBotoesManipulacaoEstoria();
        }

        function desabilitarBotaoEditandoRequisito() {
            return vm.controladorEstoria.editarRequisito;
        }

        /**
         * Método que será chamado quando o botão de inserir tarefas por rotinas for clicado
         */
        function abrirViewParaCriarTarefasPorRotinas() {
            vm.templateSelecionadoEstoriaTarefa = templatesEstoriaTarefa[1];
            vm.controladorEstoria.editarTarefas = true;
        }

        function abrirViewTabelaTarefasDaEstoriaComVerificacao() {
            if (vm.listaDeTarefas.length > 0) {
                MdDialogService.confirmPadraoComEvento(
                    "Cancelar",
                    "Deseja realmente cancelar o processo",
                    event,
                    function () {
                        vm.templateSelecionadoEstoriaTarefa =
                            templatesEstoriaTarefa[0];
                        vm.controladorEstoria.editarTarefas = false;
                        vm.listaDeTarefas = [];
                        vm.rotinasSelecionadas = [];
                        vm.tarefasSelecionadas = [];
                    }
                );
            } else {
                vm.templateSelecionadoEstoriaTarefa = templatesEstoriaTarefa[0];
                vm.controladorEstoria.editarTarefas = false;
            }
        }

        function abrirViewTabelaTarefasDaEstoriaSemVerificacao() {
            vm.templateSelecionadoEstoriaTarefa = templatesEstoriaTarefa[0];
            vm.controladorEstoria.editarTarefas = false;
            vm.listaDeTarefas = [];
            vm.rotinasSelecionadas = [];
            vm.tarefasSelecionadas = [];
        }

        function selecionarTemplate() {
            if (
                vm.templateSelecionadoEstoriaTarefa.view ==
                "viewTabelaTarefasDaEstoria"
            ) {
                metodosInternosTarefa.abrirViewParaCriarTarefasPorRotinas();
                vm.controleForm.pesquisarDatatable = false;
                EstoriaService.listarRotinas(
                    vm.rotinas,
                    vm.estoria.solucaoCodigo,
                    vm.controleForm
                ).then(function (success) {
                    vm.rotinas = success.data;
                });
            } else {
                metodosInternosTarefa.abrirViewTabelaTarefasDaEstoriaComVerificacao();
                vm.controleForm.pesquisarDatatable = true;
            }
        }

        /**
         *
         * @param {eventButton} event
         * @param {index} index Index da tarefa selecionado
         * @param {tarefa} tarefa  Tarefa Selecionada
         */
        function abrirDialogTarefas(event, index, tarefa) {
            $mdDialog.show({
                controller: "EstoriaDialogTarefasController",
                controllerAs: "vm",
                templateUrl: vm.htmlRota.tabTarefa.dialogTarefa,
                multiple: true,
                //parent: ---------------,
                targetEvent: event,
                clickOutsideToClose: false,
                locals: {
                    ControleForm: vm.controleForm,
                    UsuarioEstoriaLogado: vm.usuarioEstoriaLogado,
                    Estoria: vm.estoria,
                    Tarefa: tarefa,
                    TiposTarefa: vm.tiposTarefa,
                },
            });
        }

        /**
         * Método que irá abrir um dialog exibindo apenas o campo que foi clicado na tabela de tarefas
         * @param {eventButton} event
         * @param {tarefa} tarefa Tarefa da tabela
         * @param {campoTarefaASerEditado} campoTarefaASerEditado Contém uma string informando qual campo será exibido no dialog
         */
        function abrirDialogEditarCampoTarefa(
            event,
            tarefa,
            campoTarefaASerEditado
        ) {
            $mdDialog.show({
                controller: "EstoriaDialogTarefaAlterarCampoController",
                controllerAs: "vm",
                templateUrl: vm.htmlRota.tabTarefa.dialogAlterarCampoTarefa,
                //parent: ---------------,
                targetEvent: event,
                clickOutsideToClose: false,
                locals: {
                    UsuarioEstoriaLogado: vm.usuarioEstoriaLogado,
                    Estoria: vm.estoria,
                    Tarefa: tarefa,
                    CampoTarefaASerEditado: campoTarefaASerEditado,
                },
            });
        }

        /**
         * Método para excluir uma tarefa
         * @param {eventButton} event
         * @param {tarefa} tarefa
         */
        function excluirTarefa(event, tarefa) {
            ServicosGenericoService.excluirRegistroPorCodigoOuGenericamente(
                Api.estoria.tarefa.excluir,
                vm.estoria.tarefas,
                tarefa,
                vm.controleForm,
                event,
                "Deseja realmente excluir esta Tarefa ?"
            );
        }

        function converteIdParaTipo(idTipoTarefa) {
            if (!idTipoTarefa) return "Não específicado";

            switch (idTipoTarefa) {
                case 1:
                    return "Desenvolvimento";
                case 2:
                    return "Teste de Desenvolvimento";
                case 3:
                    return "Testes";
            }
        }

        /**
         *
         * @param {tarefas} tarefas Lista de tarefas
         * @param {eventButton} event
         */
        function selecionarTarefasDasRotinas(tarefas, event) {
            if (event) {
                event.stopPropagation();
            }
            if (vm.rotinasSelecionadas.indexOf(tarefas) > -1) {
                vm.rotinasSelecionadas.splice(
                    vm.rotinasSelecionadas.indexOf(tarefas),
                    1
                );
            } else {
                vm.rotinasSelecionadas.push(tarefas);
            }
        }

        /**
         *
         * @param {listaDeTarefas} listaDeTarefas
         */
        function gerarListaDeTarefas(listaDeTarefas) {
            vm.listaDeTarefas = [];
            vm.tarefasSelecionadas = [];
            listaDeTarefas.map(function (valorAtual, indice, array) {
                angular.forEach(valorAtual, function (key, value) {
                    vm.listaDeTarefas.push(key);
                });
            });
        }

        /**
         *
         * @param {tarefa} tarefa
         * @param {eventButton} event
         */
        function selecionarTarefas(tarefa, event) {
            if (event) {
                event.stopPropagation();
            }
            if (vm.tarefasSelecionadas.indexOf(tarefa) > -1) {
                vm.tarefasSelecionadas.splice(
                    vm.tarefasSelecionadas.indexOf(tarefa),
                    1
                );
            } else {
                vm.tarefasSelecionadas.push(tarefa);
            }
        }

        /**
         *
         * @param {tarefasSelecionadas} tarefasSelecionadas
         * @param {eventButton} event
         */
        function salvarTarefas(tarefasSelecionadas, event) {
            EstoriaService.salvarListaDeTarefas(
                vm.estoria,
                vm.controleForm,
                tarefasSelecionadas,
                metodosInternosTarefa.abrirViewTabelaTarefasDaEstoriaSemVerificacao,
                event
            );
        }

        function cancelarTarefa() {
            metodosInternosTarefa.abrirViewTabelaTarefasDaEstoriaComVerificacao();
        }

        /**
         *
         * @param {eventButton} event
         * @param {index} indexArray Index do historicoSituacao selecionado na tabela
         * @param {historicoSituacao} historicoSituacao
         */
        function abrirDialogEditarHistorico(
            event,
            indexArray,
            historicoSituacao
        ) {
            $mdDialog
                .show({
                    controller: "DialogHistoricoSituacaoController",
                    controllerAs: "vm",
                    multiple: true,
                    templateUrl: vm.htmlRota.tabHistorico.dialogHistorico,
                    //parent: ---------------,
                    targetEvent: event,
                    clickOutsideToClose: false,
                    locals: {
                        ControleForm: vm.controleForm,
                        Estoria: vm.estoria,
                        HistoricoSituacao: historicoSituacao,
                        UsuarioEstoriaLogado: vm.usuarioEstoriaLogado,
                        Situacoes: vm.situacoes,
                    },
                })
                .then(function (resultado) {
                    if (resultado == 12 || resultado == 13) {
                        vm.metodosExternosPgToolbar.metodosAcaoAtualizar();
                    }
                });
        }

        /**
         * Método para deletar um historicoSituacao pela tabela
         * @param {eventButton} event
         * @param {historicoSituacao} historicoSituacao
         */
        function excluirHistorico(event, historicoSituacao) {
            var indexHistorico = vm.estoria.historicoSituacao
                .map(function (item) {
                    return item.codigo;
                })
                .indexOf(historicoSituacao.codigo);

            ServicosGenericoService.excluirRegistroPorCodigoOuGenericamente(
                Api.estoria.historico.excluir,
                vm.estoria.historicoSituacao,
                historicoSituacao,
                vm.controleForm,
                event,
                "Deseja realmente excluir este Histórico ?",
                _alterarSituacaoAtualHistoria,
                indexHistorico,
                historicoSituacao.codigo +
                "/" +
                historicoSituacao.estoriaNumero +
                "/" +
                historicoSituacao.estoriaAno +
                "/" +
                vm.estoria.squadCodigo
            );
        }

        function editarRequisito(modelo) {
            modelo.estoriaSquadCodigo = vm.estoria.squadCodigo;
            return RequisicaoGenericaService.editar(
                Api.estoria.requisito.atualizar,
                modelo
            );
        }

        function salvarRequisito(modelo) {
            modelo.EstoriaNumero = vm.estoria.numero;
            modelo.EstoriaAno = vm.estoria.ano;
            modelo.estoriaSquadCodigo = vm.estoria.squadCodigo;
            return RequisicaoGenericaService.salvar(
                Api.estoria.requisito.criar,
                modelo
            );
        }

        /*
         **  If que verifica se esta vindo parametros na transição de estado,
         **  caso contenha o método pesquisar já é chamado para pesquisar a estória recebida
         */
        if ($state.params.parametros) {
            vm.estoria = {
                numero: $state.params.parametros.numero,
                ano: $state.params.parametros.ano,
                squadCodigo: $state.params.parametros.squadCodigo,
                squadCodigos: [$state.params.parametros.squadCodigo],
                chamarPesquisa: $state.params.parametros.chamarPesquisa,
            };
        } else if (!vm.estoria) {
            vm.estoria = {};
            if (vm.squadUsuarioLogado.length > 1) {
                $timeout(function () {
                    vm.estoria.squadCodigos = [
                        ToolbarService.squadSelecionado(),
                    ];
                    _listarSolucoesVinculadas(vm.estoria.squadCodigos);
                    _listarProjetosGerenciarCustos(vm.estoria.squadCodigos);
                }, 500);
            }
        }

        function reverter() {
            vm.tiposHistoria = ListarTodosTiposHistoria.data;
            if (vm.estoriaBkp && vm.estoriaBkp.numero) {
                vm.estoria = angular.copy(vm.estoriaBkp);
            } else {
                $timeout(function () {
                    if (
                        !vm.estoria.numero &&
                        !vm.estoria.squadCodigo &&
                        !(vm.estoria.squadCodigos && vm.estoria.squadCodigos.length)
                    ) {
                        var squadPadrao =
                            squadCodigoUltimaPesquisa || ToolbarService.squadSelecionado();
                        vm.estoria.squadCodigo = squadPadrao;
                        vm.estoria.squadCodigos = [squadPadrao];
                        _listarSolucoesVinculadas(squadPadrao);
                    }
                });
            }

            if (vm.estoria.solicitacaoNumero) {
                var solicitacaoRevertida = {
                    numero: vm.estoria.solicitacaoNumero,
                    ano: vm.estoria.solicitacaoAno,
                    squadCodigo: vm.estoria.squadCodigo,
                    descricao: vm.estoria.solicitacaoNumero + "/" + vm.estoria.solicitacaoAno
                };
                vm.solicitacoes = [solicitacaoRevertida];
                vm.solicitacao = solicitacaoRevertida;
            } else {
                vm.solicitacao = {};
            }

            vm.clonandoHistoria = false;
        }

        function definirCamposClonados() {
            vm.clonandoHistoria = true;
            var entidadeClonada = angular.copy(vm.controleForm.entidadeClonada);
            vm.estoriaBkp = angular.copy(vm.estoria);

            entidadeClonada.numero = null;
            entidadeClonada.usuarioCodigoAbertura = null;
            [
                'stackResponsavel',
                'stackResponsavelDescricao',
                'usuarioAbertura',
                'solucao',
                'motivo',
                'ano',
                'dataEntrada',
                'historicoSituacao',
                'ultimoHistoricoSituacao',
                'custoSoftware',
                'necessidadeClienteDescricao',
                'codigoDesenvolvedor',
                'desenvolvedor',
                'tester',
                'codigoTester',
                'situacaoAtualHistoria',
                'existeRetorno',
            ].forEach(function (campo) {
                delete entidadeClonada[campo];
            });

            var dataAtual = new Date();
            vm.estoria = entidadeClonada;
            vm.estoria.usuarioCodigoAbertura = vm.usuarioEstoriaLogado.codigo;
            _sugerirProximoNumero(entidadeClonada.squadCodigo);
            vm.estoria.ano = dataAtual.getFullYear();
            vm.estoria.dataEntrada = dataAtual;

            delete vm.estoria.clientesVinculados;
            delete vm.estoria.estimativas;
            delete vm.estoria.estoriaRequisito;
            delete vm.estoria.priorizacoes;
            delete vm.estoria.tarefas;
            delete vm.estoria.estoriaTipo;
            vm.controleForm.inserirAtivo = true;
        }

        function _listarRequisito(estoria) {
            var url = Api.estoria.requisito.listarPor + estoria.numero + "/" + estoria.ano + "/" + estoria.squadCodigo;
            PgToolbarService.iniciarPreLoaderToolbar(
                vm.controleForm,
                vm.controlePreloader
            );
            return RequisicaoGenericaService.listarSemParams(url)
                .then(function (success) {
                    var modelRequisito = {
                        estoriaNumero: vm.estoria.numero,
                        estoriaAno: vm.estoria.ano,
                        estoriaSquadCodigo: vm.estoria.squadCodigo,
                        descricaoProblema: success.data.descricaoProblema
                    };
                    _inserirRequisitoHistoriaClonada(modelRequisito);
                })
                .finally(function () {
                    PgToolbarService.finalizarPreLoaderToolbar(
                        vm.controleForm,
                        vm.controlePreloader
                    );
                });
        }

        function _listarClientesVinculados(estoria) {
            PgToolbarService.iniciarPreLoaderToolbar(
                vm.controleForm,
                vm.controlePreloader
            );
            var url = Api.estoria.clientes.listarPor + estoria.numero + "/" + estoria.ano + "/" + estoria.squadCodigo;
            return RequisicaoGenericaService.listarSemParams(url)
                .then(function (success) {
                    _vincularClientesHistoriaClonada(success.data);
                })
                .finally(function () {
                    PgToolbarService.finalizarPreLoaderToolbar(
                        vm.controleForm,
                        vm.controlePreloader
                    );
                });
        }

        function _inserirRequisitoHistoriaClonada(modelRequisito) {
            PgToolbarService.iniciarPreLoaderToolbar(
                vm.controleForm,
                vm.controlePreloader
            );
            return RequisicaoGenericaService.salvar(
                Api.estoria.requisito.atualizar, modelRequisito)
                .then()
                .finally(function () {
                    PgToolbarService.finalizarPreLoaderToolbar(
                        vm.controleForm,
                        vm.controlePreloader
                    );
                });
        }

        /**
         * Callback chamado após o salvar da estória ser concluído pela toolbar
         */
        function aoSalvarConcluido() {
            listarHistoricoAlteracaoDataEntrega(vm.estoria)
                .then(function (success) {
                    vm.listaHistoricoAlteracaoDataEntrega = success.data || [];
                })
                .catch(function () {
                    vm.listaHistoricoAlteracaoDataEntrega = [];
                });
            if (vm.clonandoHistoria) {
                vm.clonandoHistoria = false;
                _listarRequisito(vm.controleForm.entidadeClonada);
                _listarClientesVinculados(vm.controleForm.entidadeClonada);
            }
        }

        /**
         * Callback chamado após o editar da estória ser concluído pela toolbar
         */
        function acaoPosEditar() {
            listarHistoricoAlteracaoDataEntrega(vm.estoria)
                .then(function (success) {
                    vm.listaHistoricoAlteracaoDataEntrega = success.data || [];
                })
                .catch(function () {
                    vm.listaHistoricoAlteracaoDataEntrega = [];
                });
            if (!vm.clonandoHistoria) return;
            vm.clonandoHistoria = false;
        }

        function _vincularClientesHistoriaClonada(listaClientesVinculadosHistoriaOriginal) {
            if (listaClientesVinculadosHistoriaOriginal) {
                listaClientesVinculadosHistoriaOriginal.forEach(function (item, index) {
                    if (
                        index === 0 ||
                        !item.cliente ||
                        item.cliente.codigo === vm.estoria.cliente.codigo
                    ) {
                        return;
                    }
                    _requisicaoVincularCliente(item.cliente);
                });
            }
        }

        function configuraMdSelectSolicitacao() {
            vm.filtrarSolicitacoes = "";
            angular
                .element("#tab-estoria-solicitacao-md-select")
                .on("keydown", function (ev) {
                    ev.stopPropagation();
                });
        }

        function configurarMdSelectSolicitacaoOnClose() {
            vm.filtrarSolicitacoes = "";
        }

        function selecionarSolicitacao(solicitacao) {
            if (solicitacao) {
                vm.estoria.solicitacaoNumero = solicitacao.numero;
                vm.estoria.solicitacaoAno = solicitacao.ano;
            }
        }

        function trackSolicitacao(item) {
            if (!item) return '';
            return item.numero + '_' + item.ano + '_' + item.squadCodigo;
        }

        function _limparSolicitacoes() {
            vm.solicitacao = {};
            vm.solicitacoes = [];
            vm.ultimoCliente = 0;
            vm.estoria.solicitacaoAno = null;
            vm.estoria.solicitacaoNumero = null;
        }

        function listarTodasSolicitacoesCliente(clienteCodigo) {
            if (!clienteCodigo) _limparSolicitacoes();

            if (clienteCodigo && clienteCodigo != vm.ultimoCliente) {
                vm.requisicaoSolicitada = true;
                vm.ultimoCliente = clienteCodigo;
                vm.mensagemPreloader = "Carregando Solicitações do Cliente ...";
                RequisicaoGenericaService.listarSemParams(
                    Api.solicitacao.solicitacao.listarTodasSolicitacoesPorCliente +
                    "/" +
                    clienteCodigo
                ).then(
                    function (success) {
                        if (vm.squadUsuarioLogado.length === 1)
                            vm.estoria.squadCodigo = vm.squadUsuarioLogado[0];

                        vm.solicitacoes = success.data
                            .filter(function (item) {
                                if (vm.controleForm.inserirAtivo) {
                                    return !item.concluida;
                                }
                                if (vm.controleForm.editarAtivo) {
                                    return !item.concluida ||
                                        (item.numero == vm.estoria.solicitacaoNumero && item.ano == vm.estoria.solicitacaoAno);
                                }
                                return true;
                            })
                            .map(function (item) {
                                return {
                                    numero: item.numero,
                                    ano: item.ano,
                                    squadCodigo: item.squadCodigo,
                                    descricao: item.numero + "/" + item.ano,
                                    concluida: item.concluida,
                                };
                            });

                        vm.solicitacao = vm.solicitacoes.find(function (
                            solicitacao
                        ) {
                            return (
                                solicitacao.numero ==
                                vm.estoria.solicitacaoNumero &&
                                solicitacao.ano == vm.estoria.solicitacaoAno
                            );
                        });

                        if (!inserindoOuEditando()) {
                            vm.solicitacaoBkp = vm.solicitacao;
                        }

                        vm.requisicaoSolicitada = false;
                        vm.mensagemPreloader = "";
                    },
                    function (error) {
                        vm.requisicaoSolicitada = false;
                        vm.mensagemPreloader = "";
                        ServicosGenericoService.exibirAlertaDeErro(
                            error,
                            event
                        );
                    }
                );
            }
        }

        /**
         * Método utilizado no modo exibido tabela, para selecionar uma estoria
         * @param {estoria} estoria
         */
        function selecionar(posicaoEntidade) {
            vm.metodosExternosPgToolbar.metodoControladorExternoListarTodasEntidades(
                null,
                posicaoEntidade
            );
        }

        function construirDtOptions() {
            if (vm.entidadeDeEnvio.clsEntidade.dataEntrada) {
                vm.entidadeDeEnvio.clsEntidade.dataEntrada =
                    vm.entidadeDeEnvio.clsEntidade.dataEntrada.toJSON();
            }

            if (vm.entidadeDeEnvio.clsEntidade.dataEntrega) {
                vm.entidadeDeEnvio.clsEntidade.dataEntrega =
                    vm.entidadeDeEnvio.clsEntidade.dataEntrega.toJSON();
            }

            DatatableFactory.construirDtOptionsComPaginacaoProcessadoNoServidorParaToolbar(
                Api.estoria.listarComPaginacaoDatatable,
                vm.entidadeDeEnvio.clsEntidade,
                "#datatable-estoria",
                [
                    DatatableFactory.construirColunaMultiAcoes(
                        function (indexLinha) {
                            vm.metodosEstoria.selecionar(indexLinha);
                        },
                        function (indexLinha, td, cellData, rowData) {
                            abrirDialogHistoriasVinculadas(rowData);
                        },
                        "icon-pencil",
                        "icon-playlist-plus"
                    ),
                    {
                        targets: 1,
                        name: "Numero",
                        data: "numero",
                        defaultContent: "",
                        sortable: false,
                    },
                    {
                        targets: 2,
                        name: "Ano",
                        data: "ano",
                        defaultContent: "",
                        sortable: false,
                    },
                    {
                        targets: 3,
                        name: "Descricao",
                        data: "descricao",
                        defaultContent: "",
                        sortable: false,
                    },
                    {
                        targets: 4,
                        name: "DataEntrada",
                        data: "dataEntrada",
                        render: function (data) {
                            return $filter("date")(data, "dd/MM/yyyy");
                        },
                        defaultContent: "",
                    },
                    {
                        targets: 5,
                        name: "DataEntrega",
                        data: "dataEntrega",
                        render: function (data) {
                            return $filter("date")(data, "dd/MM/yyyy");
                        },
                        defaultContent: "",
                    },
                    {
                        targets: 6,
                        name: "Status",
                        data: "ultimoHistoricoSituacao.situacaoCodigo",
                        render: function (codigoSituacao) {
                            var descricaoSituacao = "";
                            vm.coresSituacoes.forEach(function (situacao) {
                                if (codigoSituacao == situacao.codigo) {
                                    descricaoSituacao = situacao.descricao;
                                }
                            });
                            return descricaoSituacao;
                        },
                        defaultContent: "",
                        sortable: false,
                    },
                ]
            );
        }

        function inserindoOuEditando() {
            return vm.controleForm.inserirAtivo || vm.controleForm.editarAtivo;
        }

        function abrirDialogHistoriasVinculadas(historia) {
            PgToolbarService.iniciarPreLoaderToolbar(
                vm.controleForm,
                vm.controlePreloader
            );

            var dadosHistoria = {
                numero: historia.numero,
                ano: historia.ano,
                squadCodigo: historia.squadCodigo,
            };

            RequisicaoGenericaService.listarSemParams(
                Api.estoria.historiasVinculadas.listarHistoriasVinculadas +
                "/" +
                dadosHistoria.numero +
                "/" +
                dadosHistoria.ano +
                "/" +
                dadosHistoria.squadCodigo
            )
                .then(
                    function (success) {
                        console.log('success: ', success.data);
                        $mdDialog
                            .show({
                                controller:
                                    "HistoriasVinculadasDialogController",
                                controllerAs: "vm",
                                templateUrl:
                                    "app/main/planejamento-scrum/processamento/estoria/views/tabs/estoria/dialogs/historias-vinculadas-dialog/historias-vinculadas-dialog.html",
                                targetEvent: null,
                                clickOutsideToClose: false,
                                locals: {
                                    Dados: success.data,
                                    HistoriaFiltrada: dadosHistoria
                                },
                            })
                            .then(function (houveAlteracoes) {
                                if (houveAlteracoes) {
                                    vm.metodosExternosPgToolbar.metodosAcaoAtualizar();
                                }
                            });
                    },
                    function (error) {
                        MdDialogService.alertPadrao(error.data);
                    }
                )
                .finally(function () {
                    PgToolbarService.finalizarPreLoaderToolbar(
                        vm.controleForm,
                        vm.controlePreloader
                    );
                });
        }

        function configuraAutoCompleteOnBlurAtendiemnto() {
            if (vm.atendimento) {
                vm.textoDePesquisaAutoCompleteAtendimento = "";
            }
        }

        function pesquisarAutoCompleteAtendimento(pesquisa) {
            vm.estoria.pesquisa = pesquisa;
            var viewModel = angular.copy(vm.estoria);
            var deferred = $q.defer();

            $timeout(function () {
                RequisicaoGenericaService.salvar(
                    Api.atendimento.listarAtendimentoAbertosPorCliente,
                    viewModel
                ).then(
                    function (success) {
                        deferred.resolve(success.data);
                    },
                    function (error) {
                        deferred.reject(error.data);
                    }
                );
            });

            vm.estoria.pesquisa = "";
            return deferred.promise;
        }

        function alterarItemSelecionadoAutoCompleteAtendimento(atendimento) {
            if (atendimento) {
                vm.estoria.atendimento = atendimento;
            } else {
                vm.estoria.prazoAcordado = false;
            }
        }

        function _alterarSituacaoAtualHistoria(success) {
            var situacaoAnterior = angular.copy(
                vm.estoria.situacaoAtualHistoria
            );
            vm.estoria.situacaoAtualHistoria =
                vm.estoria.historicoSituacao[0].situacao;

            MdToastService.toastPadrao(success.data);

            if (
                situacaoAnterior.codigo == 12 ||
                situacaoAnterior.codigo == 13
            ) {
                vm.metodosExternosPgToolbar.metodosAcaoAtualizar();
            }
        }

        function changeCodigoDesenvolvedor(valor) {
            if (!valor) {
                vm.estoriaForm.estoriaUsuarioCodigoDesenvolvedores.$touched = true;
            }
        }

        function changeCodigoTester(valor) {
            if (!valor) {
                vm.estoriaForm.estoriaUsuarioDescricaoTesters.$touched = true;
            }
        }

        function _realizarRequisicao() {
            var _entidadeParaEnvio = null;

            if (!vm.entidadeDeEnvio)
                _entidadeParaEnvio =
                    PgToolbarService.recuperarEntidadeDeEnvio();
            else _entidadeParaEnvio = vm.entidadeDeEnvio;
            return RequisicaoGenericaService.listarComObjetoComplexo(
                Api.estoria.listarEstoriaComPaginacao,
                _entidadeParaEnvio
            );
        }

        function _retornarSituacaoAtualHistoria(situacao) {
            var estoria = situacao.data.lstResultado[0];
            return EstoriaService.retornaSituacaoAtualDaHistoria(
                estoria,
                estoria.numero,
                estoria.ano,
                vm.controleForm,
                estoria.squadCodigo
            ).then(function (resultado) {
                vm.exigeInsercaoDesenvolvedor =
                    resultado.historicoSituacao.some(function (item) {
                        return item.situacaoCodigo == 6;
                    })
                        ? true
                        : false;

                vm.exigeInsercaoTester = resultado.historicoSituacao.some(
                    function (item) {
                        return item.situacaoCodigo == 8;
                    }
                )
                    ? true
                    : false;
            });
        }

        function selectChangeSquad(squadCodigoSelecionada) {
            if (vm.controleForm.inserirAtivo) {
                _sugerirProximoNumero(squadCodigoSelecionada);
            }

            vm.estoria.solucaoCodigo = null;
            _listarSolucoesVinculadas(squadCodigoSelecionada);

            vm.estoria.codigoCustoSoftware = null;
            _listarProjetosGerenciarCustos(squadCodigoSelecionada);
        }

        function selectChangeMultiplasSquads(squadCodigos) {
            vm.estoria.solucaoCodigo = null;
            _listarSolucoesVinculadas(squadCodigos);

            vm.estoria.codigoCustoSoftware = null;
            _listarProjetosGerenciarCustos(squadCodigos);
        }


        function abrirDialogHistoricoAlteracaoDataEntrega(historia) {
            PgToolbarService.iniciarPreLoaderToolbar(
                vm.controleForm,
                vm.controlePreloader
            );
            listarHistoricoAlteracaoDataEntrega(historia).then(function (success) {
                $mdDialog.show({
                    controller: "HistoricoAlteracaoDataEntregaDialogController",
                    controllerAs: "vm",
                    templateUrl: 'app/main/planejamento-scrum/processamento/estoria/views/tabs/estoria/dialogs/historico-alteracoes-data-entrega-dialog/historico-alteracoes-data-entrega-dialog.html',
                    multiple: true,
                    //parent: ---------------,
                    targetEvent: event,
                    clickOutsideToClose: false,
                    locals: {
                        HistoricoAlteracoes: success.data,
                    },
                });
            }).finally(function () {
                PgToolbarService.finalizarPreLoaderToolbar(
                    vm.controleForm,
                    vm.controlePreloader
                );
            });

        }

        function listarHistoricoAlteracaoDataEntrega(historia) {
            return RequisicaoGenericaService.listarComParams(
                Api.estoria.listarHistoricoAlteracaoDataEntrega +
                "/" +
                historia.numero +
                "/" +
                historia.ano +
                "/" +
                historia.squadCodigo

            );
        }

        function abrirDialogAlterarDataEntrega(estoria, event) {
            if (!vm.controleForm.editarAtivo) return;
            $mdDialog.show({
                controller: "EstoriaDialogAlterarDataEntrega",
                controllerAs: "vm",
                templateUrl: 'app/main/planejamento-scrum/processamento/estoria/views/tabs/estoria/dialogs/dialog-alterar-data-entrega/estoria-dialog-alterar-data-entrega.html',
                //parent: ---------------,
                targetEvent: event,
                clickOutsideToClose: false,
                locals: {
                    Estoria: estoria,
                    UsuarioLogado: vm.usuarioEstoriaLogado
                }
            }).then(function (viewModelDataAlteracao) {
                if (viewModelDataAlteracao) {
                    vm.estoria.dataEntrega = viewModelDataAlteracao.novaDataEntrega;
                    editar(vm.estoria)
                    vm.controleForm.editarAtivo = false;
                    vm.controleForm.pesquisaAtiva = true;
                    vm.textoExibidoToolbar = 'Exibindo';
                }
            });
        }

        function _listarSolucoesVinculadas(squadCodigo) {
            var url = Api.solucao_rotinas_tarefas.solucao.listarPorSquadCliente;
            var codigoCliente =
                vm.estoria &&
                    vm.estoria.cliente &&
                    vm.estoria.cliente.codigo != null
                    ? vm.estoria.cliente.codigo
                    : null;

            var entidadeEnvio = {
                codigoCliente: codigoCliente,
                codigoSquads: Array.isArray(squadCodigo)
                    ? squadCodigo
                    : [squadCodigo],
                exibirSolucaoComSquad: true,
            };

            RequisicaoGenericaService.listarPorPaginacaoJsonFormato(
                url,
                entidadeEnvio
            )
                .then(function (success) {
                    vm.solucoes = success.data;
                })
                .catch(function (error) {
                    vm.solucoes = [];
                });
        }

        function _listarProjetosGerenciarCustos(squadCodigo) {
            if (Array.isArray(squadCodigo)) {
                var url = Api.estoria.ListarCustosSoftwarePorSquads;
                var model = { squadCodigo: squadCodigo[0] };
                RequisicaoGenericaService.listarComParams(url, model)
                    .then(function (success) {
                        vm.listaCustoSoftware = success.data;
                    })
                    .catch(function (error) {
                        vm.listaCustoSoftware = [];
                    });
            } else {
                var url = Api.estoria.ListarCustosSoftwarePorSquad;

                RequisicaoGenericaService.listarComParams(url + squadCodigo)
                    .then(function (success) {
                        vm.listaCustoSoftware = success.data;
                    })
                    .catch(function (error) {
                        vm.listaCustoSoftware = [];
                    });
            }
        }

        function _criarDataFutura(diasAFrente) {
            var dataAtual = new Date();
            var dataFutura = new Date(dataAtual);
            dataFutura.setDate(dataAtual.getDate() + diasAFrente);
            return dataFutura;
        }

        function _temHistoricoAlteracao() {
            return vm.listaHistoricoAlteracaoDataEntrega &&
                vm.listaHistoricoAlteracaoDataEntrega.length > 0;
        }

        function _isFormularioInativo() {
            return !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo;
        }

        function _configurarDataEntregaParaInsercao(prazoAcordado) {
            if (prazoAcordado) {
                vm.estoria.dataEntrega = null;
                vm.desabilitarDataEntrega = false;
            } else {
                vm.estoria.dataEntrega = _criarDataFutura(PRAZO_PADRAO_DIAS);
                vm.desabilitarDataEntrega = _isFormularioInativo() || vm.estoria.prazoAcordado;
            }
        }

        function _configurarDataEntregaParaEdicao(prazoAcordado) {
            var temHistorico = _temHistoricoAlteracao();

            if (prazoAcordado) {
                vm.desabilitarDataEntrega = temHistorico;
                if (!temHistorico) {
                    vm.estoria.dataEntrega = null;
                }
            } else {
                vm.desabilitarDataEntrega = temHistorico;
                if (!temHistorico) {
                    vm.estoria.dataEntrega = _criarDataFutura(PRAZO_PADRAO_DIAS);
                }
            }
        }

        function _configurarDataEntregaPadrao() {
            vm.desabilitarDataEntrega = _isFormularioInativo() || vm.estoria.prazoAcordado;
        }

        // SEÇÃO CLIENTES VINCULADOS
        vm.metodosClientesVinculados = {
            pesquisarAutoCompleteClienteVinculado:
                pesquisarAutoCompleteClienteVinculado,
            vincularCliente: vincularCliente,
            desvincularCliente: desvincularCliente,
            visualizarCliente: visualizarCliente,
            abrirDialogEditarInformacoes: abrirDialogEditarInformacoes,
            getNomeUsuario: getNomeUsuario,
        };

        function pesquisarAutoCompleteClienteVinculado(query) {
            query = query.toLowerCase();
            var resultado = query
                ? vm.clientes.filter(function (item, index) {
                    return (
                        item.codigo == query ||
                        item.nome.toLowerCase().search(query) != -1
                    );
                })
                : vm.clientes;

            return resultado;
        }

        function vincularCliente(clienteSelecionado) {
            if (!clienteSelecionado) return;

            var jaVinculado = vm.estoria.clientesVinculados.some(function (
                cliente
            ) {
                return cliente.clienteCodigo === clienteSelecionado.codigo;
            });

            if (!jaVinculado) {
                _requisicaoVincularCliente(clienteSelecionado);
            } else
                MdDialogService.alertPadrao(
                    "Atenção!",
                    _limparCampoClienteAbaClientesVinculados(),
                    "O cliente" +
                    " " +
                    clienteSelecionado.nome +
                    " " +
                    "já está vinculado a história."
                );
        }

        function _requisicaoVincularCliente(clienteSelecionado) {
            PgToolbarService.iniciarPreLoaderToolbar(
                vm.controleForm,
                vm.controlePreloader
            );
            var entidadeEnvio = {
                estoriaNumero: vm.estoria.numero,
                estoriaAno: vm.estoria.ano,
                estoriaSquadCodigo: vm.estoria.squadCodigo,
                clienteCodigo: clienteSelecionado.codigo,
            };

            RequisicaoGenericaService.salvar(
                Api.estoria.clientes.vincular,
                entidadeEnvio
            )
                .then(
                    function (success) {
                        MdToastService.toastPadrao(
                            "Cliente" +
                            " " +
                            clienteSelecionado.nome +
                            " " +
                            "vinculado com sucesso."
                        );
                        vm.estoria.clientesVinculados = success.data;
                    },
                    function (error) {
                        MdDialogService.alertPadrao(
                            "Atenção!",
                            null,
                            error.data
                        );
                    }
                )
                .finally(function () {
                    _limparCampoClienteAbaClientesVinculados();
                    PgToolbarService.finalizarPreLoaderToolbar(
                        vm.controleForm,
                        vm.controlePreloader
                    );
                });

        }

        function desvincularCliente(clienteSelecionado, index) {
            if (!clienteSelecionado || index === 0) return;
            MdDialogService.confirmPadraoComEvento(
                "Desvincular",
                "Deseja realmente desvincular o cliente" +
                " " +
                clienteSelecionado.cliente.nome +
                "?",
                null,
                function () {
                    _requisicaoDesvincularCliente(clienteSelecionado);
                },
                function () {
                    $mdDialog.hide();
                }
            );
        }

        function _requisicaoDesvincularCliente(clienteSelecionado) {
            PgToolbarService.iniciarPreLoaderToolbar(
                vm.controleForm,
                vm.controlePreloader
            );
            RequisicaoGenericaService.excluir(
                Api.estoria.clientes.deletar,
                clienteSelecionado.codigo
            ).then(
                function (success) {
                    MdToastService.toastPadrao(
                        "Cliente" +
                        " " +
                        clienteSelecionado.cliente.nome +
                        " " +
                        "descinculado com sucesso."
                    );
                    vm.estoria.clientesVinculados = success.data;
                },
                function (error) {
                    MdDialogService.alertPadrao("Atenção!", null, error.data);
                }
            ).finally(function () {
                PgToolbarService.finalizarPreLoaderToolbar(
                    vm.controleForm,
                    vm.controlePreloader
                );
            });
        }

        function visualizarCliente(clienteSelecionado) {
            $state.goNewTab("app.geral_cadastro_cliente_cliente", {
                parametros: {
                    cliente: {
                        codigo: clienteSelecionado.codigo,
                        nome: clienteSelecionado.nome,
                    },
                },
            });
        }

        function abrirDialogEditarInformacoes(
            event,
            cliente,
            campoClienteASerEditado
        ) {
            if (campoClienteASerEditado === 'dataAtualizacao' || campoClienteASerEditado === 'versao') {
                _listarVersoesGeradas()
                    .then(
                        function (success) {
                            vm.versoesGeradas = success.data;
                            realizaAberturaDialogoEdicaoCliente(event, cliente, campoClienteASerEditado);
                        },
                        function (error) {
                            vm.versoesGeradas = [];
                            MdDialogService.alertPadrao("Atenção!", null, error.data);
                        }).finally(function () {
                            PgToolbarService.finalizarPreLoaderToolbar(
                                vm.controleForm,
                                vm.controlePreloader
                            );
                        });

            } else {
                realizaAberturaDialogoEdicaoCliente(event, cliente, campoClienteASerEditado);
            }
        }

        function realizaAberturaDialogoEdicaoCliente(event,
            cliente,
            campoClienteASerEditado) {
            $mdDialog
                .show({
                    controller: "EdicaoClientesVinculadosDialogController",
                    controllerAs: "vm",
                    templateUrl:
                        vm.htmlRota.tabClientes.edicaoClientesVinculadosDialog,
                    //parent: ---------------,
                    targetEvent: event,
                    clickOutsideToClose: false,
                    locals: {
                        UsuarioEstoriaLogado: vm.usuarioEstoriaLogado,
                        Estoria: vm.estoria,
                        Cliente: cliente,
                        CampoClienteASerEditado: campoClienteASerEditado,
                        ListarTodosUsuarios: ListarTodosUsuarios.data,
                        VersoesGeradas: vm.versoesGeradas || [],
                    },
                })
                .then(function (dadosAtualizados) {
                    if (dadosAtualizados.listaClientesVinculadosAtualizados) {
                        MdToastService.toastPadrao(
                            "Cliente" +
                            " " +
                            dadosAtualizados.informacoesClienteVinculado
                                .cliente.nome +
                            " " +
                            "editado com sucesso."
                        );
                        vm.estoria.clientesVinculados =
                            dadosAtualizados.listaClientesVinculadosAtualizados;
                    }
                });
        }

        function _limparCampoClienteAbaClientesVinculados() {
            vm.clienteSelecionado = null;
            vm.textoDePesquisaAutoCompleteClienteVinculado = "";
        }

        function getNomeUsuario(codigoUsuario) {
            var usuario = ListarTodosUsuarios.data.find(function (usuario) {
                return usuario.codigo === codigoUsuario;
            });
            return usuario ? usuario.login : "";
        }

        function _listarVersoesGeradas() {
            PgToolbarService.iniciarPreLoaderToolbar(
                vm.controleForm,
                vm.controlePreloader
            );
            var codigoSolucao = vm.estoria && vm.estoria.solucaoCodigo ? vm.estoria.solucaoCodigo : null;
            if (!codigoSolucao) {
                vm.versoesGeradas = [];
                MdDialogService.alertPadrao("Atenção!", null, "Código da solução não informado.");
                return;
            }
            return RequisicaoGenericaService.listarComParams(Api.sprint.versao_entrega.listarVersoesReleasePorSolucao + "/" + codigoSolucao + "/" + vm.estoria.squadCodigo);
        }
        // SEÇÃO CLIENTES VINCULADOS
    }
})();

(function () {
    'use strict';

    angular
        .module('app.planejamentoscrum.estatistica.estatisticaIndividual')
        .controller('EstatisticaIndividualController', EstatisticaIndividualController);

    function EstatisticaIndividualController(
        $mdDialog,
        ListarEstatisticaDesenvolvedorAno,
        EstatisticaIndividualService,
        SprintFactory,
        MdDialogService,
        NavegacaoService
    ) {
        var vm = this;

        vm.multiBarChart = {};
        vm.htmlRota = SprintFactory.setHtmlRota();
        NavegacaoService.setTituloAba("Estatística individual");

        vm.metodos = {
            abrirFiltro: abrirFiltro,
            abrirDialogVisualizarEstorias: abrirDialogVisualizarEstorias
        }

        init();

        function init() {
            vm.dadosDashboard = ListarEstatisticaDesenvolvedorAno.data;
            if (vm.dadosDashboard.dadosSprint) _montarDadosGraficoGeral(vm.dadosDashboard.dadosSprint);

            EstatisticaIndividualService.listener = function (callback) {
                vm.emProgresso = true;
                var viewModel = callback();
                vm.squadCodigo = viewModel.squadCodigo;

                EstatisticaIndividualService.filtrarDadosDashboard(viewModel)
                    .then(function (success) {
                        vm.dadosDashboard = success.data;
                        _montarDadosGraficoGeral(vm.dadosDashboard.dadosSprint);
                    }, function (error) {
                        MdDialogService.alertPadrao("Atenção!", null, error.data);
                    }).finally(function () {
                        vm.emProgresso = false;
                    });
            };

        }

        function abrirFiltro() {
            EstatisticaIndividualService.toggleFiltro();
        }

        function abrirDialogVisualizarEstorias(tipoRetorno, historias) {
            $mdDialog.show({
                controller: "SprintDialogEstatisticasVisualizarEstoriasController",
                controllerAs: "vm",
                templateUrl: vm.htmlRota.tabEstatisticas.dialogs.dialogVisualizarEstorias,
                targetEvent: event,
                clickOutsideToClose: true,
                locals: {
                    TipoRetorno: tipoRetorno,
                    ListaHistorias: historias,
                    NumeroSprint: 0,
                    SprintSquadCodigo: vm.squadCodigo,
                }
            });
        }

        function _montarDadosGraficoGeral(dadosSprint) {
            var dados = _retornaDados(dadosSprint);

            vm.multiBarChart = {
                options: {
                    chart: {
                        type: 'multiBarChart',
                        showControls: false,
                        transitionDuration: 500,
                        height: 400,
                        legend: {
                            maxKeyLength: 50
                        },
                        yAxis: {
                            tickFormat: function (d) {
                                if (d % 1 === 0) {
                                    return d3.format(',f')(d);
                                } else {
                                    return d3.format(',.2f')(d);
                                }
                            }
                        }
                    }
                },
                data: dados
            };
        }

        function _retornaDados(dados) {
            var historiasDesenvolvidas = {
                key: 'Histórias desenvolvidas',
                color: '#4CAF50',
                values: []
            };

            var pontosDesenvolvidos = {
                key: 'Pontos desenvolvidos',
                color: '#069CE6',
                values: []
            };

            var retornoMelhoria = {
                key: 'Retornos de Melhoria',
                color: '#FDB308',
                values: []
            };

            var retornoErro = {
                key: 'Retornos de Erro',
                color: '#AA0707',
                values: []
            };

            var pontosPerdidos = {
                key: 'Pontos Perdidos',
                color: '#FF7033',
                values: []
            };

            dados.map(function (dado) {
                historiasDesenvolvidas.values.push({
                    x: dado.numeroSprint,
                    y: dado.quantidadeHistoriasDesenvolvidas
                });

                pontosDesenvolvidos.values.push({
                    x: dado.numeroSprint,
                    y: dado.pontuacaoEntregue
                });

                retornoMelhoria.values.push({
                    x: dado.numeroSprint,
                    y: dado.quantidadeRetornoMelhoria
                });

                retornoErro.values.push({
                    x: dado.numeroSprint,
                    y: dado.quantidadeRetornoErro
                });

                pontosPerdidos.values.push({
                    x: dado.numeroSprint,
                    y: dado.quantidadePontosPerdidos
                });
            });

            return [
                historiasDesenvolvidas,
                pontosDesenvolvidos,
                retornoMelhoria,
                retornoErro,
                pontosPerdidos
            ];
        }
    }
})();

(function () {
    "use strict";

    angular
        .module("app.planejamentoScrum.processamento.productBacklog")
        .controller("ProductBacklogController", ProductBacklogController);

    function ProductBacklogController(
        $mdDialog,
        $rootScope,
        $state,
        $timeout,
        Api,
        ListarNecessidadesCliente,
        ListarProdutos,
        ListarSituacoes,
        ListarSprintCorrentePorSquads,
        ListarTodasOrigens,
        ListarTodosClientes,
        ListarUsuarioPorDetalhe,
        MdDialogService,
        NavegacaoService,
        RequisicaoGenericaService,
        RotasHtml,
        SquadService,
        ToolbarService
    ) {
        var vm = this;

        init();

        vm.api = {};
        NavegacaoService.setTituloAba("Product Backlog");

        vm.htmlRota = RotasHtml.productBacklog;
        vm.requisicaoSolicitada = false;
        vm.mostrarTabela = false;
        vm.mensagemPreloader = "";
        vm.codigoProdutoAtual = null;
        vm.estorias = [];
        vm.produtos = ListarProdutos.data;
        vm.necessidadesCliente = ListarNecessidadesCliente.data;
        vm.origens = ListarTodasOrigens.data;
        vm.clientes = ListarTodosClientes.data;
        $rootScope.situacoesSelecionadasDescricoes = [];
        vm.squadUsuarioLogado = ListarUsuarioPorDetalhe.data.codigoSquads;

        ToolbarService.armazenarCodigoSquadUsuarioLogado(vm.squadUsuarioLogado);
        vm.squads = SquadService.listarSquadsUsuarioLogado(vm.squadUsuarioLogado);

        _listarProdutosVinculados();
        var arrayDePesquisa = [];
        var clientes = [];
        var legendaErroClienteTemporario = "";
        vm.defineLegendasProductBacklog = [
            {
                situacaoSelecionada: false,
                descricao: "Erro Cliente",
                cor: "red"
            },
            {
                situacaoSelecionada: false,
                descricao: "Erro",
                cor: "orange"
            },
            {
                situacaoSelecionada: false,
                descricao: "Solicitação",
                cor: "yellow"
            },
            {
                situacaoSelecionada: false,
                descricao: "Visita",
                cor: "blue"
            }
        ];

        vm.coresDataEntrega = [
            {
                descricao: "Data de entrega vencida",
                cor: "red"
            },
            {
                descricao: "Data de entrega próxima",
                cor: "yellow"
            },
        ];

        vm.desmarcarFiltro = {
            descricao: "Desmarcar filtros",
            cor: "#323232"
        };

        vm.dtOptionsProductBacklog = {
            dom: 'rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
            initComplete: function () {
                jQuery.fn.dataTable.ext.type.order['numeric-html-pre'] = function (d) {
                    var num = d.replace(/<[^>]*>/g, '').trim();
                    return parseInt(num, 10) || 0;
                };
                var api = this.api(),
                    searchBox = angular.element("body").find("#pesquisar"),
                    htmCollection = document.getElementsByClassName(
                        "array-buttons-product-backlog"
                    ),
                    elemento = [];

                vm.api = api;

                angular.forEach(htmCollection, function (key, value, array) {
                    elemento.push(angular.element(key));
                    if (value === 0) {
                        // Botão "Erro Cliente"
                        elemento[value].click(function (event) {
                            metodosInternoProductBacklog.defineSituacaoLegendas(true);
                            vm.api
                                .columns([6, 11])  // Atualizado para colunas Situação e Motivo
                                .search(legendaErroClienteTemporario, true, false)
                                .draw();
                        });
                    } else if (value === array.length - 1) {
                        // Botão "Desmarcar filtros"
                        elemento[value].click(function (event) {
                            vm.api
                                .columns([6, 11])  // Mesmas colunas para resetar filtro
                                .search("")
                                .draw();
                        });
                    } else {
                        elemento[value].click(function (event) {
                            if (metodosInternoProductBacklog.defineSituacaoLegendas(false)) {
                                vm.api
                                    .column(6)  // Situação limpa antes
                                    .search("")
                                    .draw();
                            }
                            var arrayFormatado = arrayDePesquisa
                                .toString()
                                .replace(/,/g, "|");
                            vm.api
                                .column(11)  // Motivo recebe o filtro regex
                                .search(arrayFormatado, true, false)
                                .draw();
                        });
                    }
                });

                // Bind an external input as a table wide search box
                if (searchBox.length > 0) {
                    searchBox.on("keyup", function (event) {
                        vm.api.search(event.target.value).draw();
                    });
                }
            },
            paging: false,
            responsive: true
        };

        vm.dtOptionsProductBacklog.columnDefs = [
            {
                targets: [0, 14],  // índice 0 e 14 continuam iguais, responsividade
                responsivePriority: 1
            },
            {
                targets: 10,      // Stack escondida
                class: "none"
            },
            {
                targets: 9, // Prioridade
                type: 'numeric-html'
            },
            {
                targets: 11,  // Motivo
                class: "none",
                render: function (data, tipo, elemento, objeto) {
                    angular.forEach(vm.origens, function (item, index) {
                        if (index == data) {
                            data = item;
                        }
                    });
                    return data;
                }
            },
            {
                targets: 12,
                class: "none",
                type: "date-pt-br"
            },
            {
                targets: 13,
                class: "none",
                type: "date-pt-br"
            },
            {
                targets: 3,  // Data entrega
                type: "date-pt-br",
                responsivePriority: 2
            },
            {
                targets: 14,  // Sprint (visível)
                responsivePriority: 2
            },
            {
                targets: 13,  // Origem (class none)
                class: "none",
                type: "enum-necessidade-cliente"
            }
        ];


        vm.stacks = [
            {
                codigo: 1,
                descricao: "Back-end"
            },
            {
                codigo: 2,
                descricao: "Front-end"
            },
            {
                codigo: 3,
                descricao: "Mobile"
            },
            {
                codigo: 4,
                descricao: "Infraestrutura"
            },
            {
                codigo: 5,
                descricao: "Full-stack"
            }];

        var metodosInternoProductBacklog = {
            defineArrayDePesquisa: defineArrayDePesquisa,
            defineSituacaoLegendas: defineSituacaoLegendas
        };

        vm.metodosProductBacklog = {
            pesquisarProductBacklog: pesquisarProductBacklog,
            abrirDialogAlterarPrioridadeBacklog: abrirDialogAlterarPrioridadeBacklog,
            abrirDialogAlterarDataEntregaBacklog: abrirDialogAlterarDataEntregaBacklog,
            abrirDialogNecessidadeCliente: abrirDialogNecessidadeCliente,
            filtrarTabela: filtrarTabela,
            resetarFiltros: resetarFiltros,
            abrirDialogEstoria: abrirDialogEstoria,
            atuliazarTabela: atualizarTabela,
            abrirDialogAdicionarSprintProductBacklog: abrirDialogAdicionarSprintProductBacklog,
            pesquisarAutoCompleteCliente: pesquisarAutoCompleteCliente,
            abrirDialogSituacao: abrirDialogSituacao,
            configuraMdSelectProduto: configuraMdSelectProduto,
            selectChangeSquad: selectChangeSquad,
            abrirDialogLegendaTabela: abrirDialogLegendaTabela,
            gerarBacklog: gerarBacklog,
            reverterGerarBacklog: reverterGerarBacklog,
            onChangeHistoriasSelecionadas: onChangeHistoriasSelecionadas,
            definirCoresDataEntrega: definirCoresDataEntrega,
            calcularDiasParaVencimento: calcularDiasParaVencimento,
        };

        function init() {
            $rootScope.utilizaBotaoScroll = true;
            $rootScope.scrollButtonContainerLocal = "div#container-product-backlog";
            vm.squadCodigo = ToolbarService.squadSelecionado();
            reverterGerarBacklog();
        }

        /**
         * Método que recebe o código do produto e faz uma requisição para Api para buscar todas as estórias
         * com base no produto solicitado
         * @param {number} codigoProduto
         */
        function pesquisarProductBacklog(codigoProduto, necessidadeCliente, cliente, stackResponsavel, squadCodigo) {
            vm.mostrarTabela = false;
            vm.requisicaoSolicitada = true;
            vm.mensagemPreloader = "Pesquisando histórias...";
            clientes = [];
            if (cliente != null) {
                var codigoCliente = cliente.codigo;
            };
            vm.codigoProduto = codigoProduto;
            vm.necessidadeCliente = necessidadeCliente;
            vm.codigoCliente = codigoCliente;
            vm.stackResponsavel = stackResponsavel;
            resetarFiltros();
            reverterGerarBacklog();

            _retornoRequisicao().then(
                function (success) {
                    vm.requisicaoSolicitada = false;
                    vm.mostrarTabela = true;
                    vm.codigoProdutoAtual = codigoProduto;
                    vm.estorias = success.data;

                    if (success.data.length <= 0) {
                        vm.mostrarTabela = false;
                        vm.requisicaoSolicitada = false;
                        MdDialogService.alertPadrao(
                            "Atenção!", null, "Não foi encontrado nenhum registro para a consulta realizada.");
                    }

                    $timeout(function () {
                        angular.forEach(success.data, function (item, value, array) {
                            if (item.clienteCodigo !== 1) {
                                clientes.push(item.clienteNome);
                            }
                            if (value === array.length - 1) {
                                clientes.push("Erro");
                            }
                        });
                        clientes = clientes.toString().replace(/,/g, "|");

                        vm.requisicaoSolicitada = false;
                    }, 250);
                },
                function (error) {
                    MdDialogService.alertPadrao("Atenção!", null, error.data);
                    vm.mensagemPreloader = "";
                    vm.mostrarTabela = false;
                    vm.requisicaoSolicitada = false;
                    vm.codigoProduto = vm.codigoProdutoAtual;
                    vm.necessidadeCliente = "";
                    vm.cliente = "";
                    vm.stackResponsavel = "";
                }
            );
        }
        /**
         *
         * @param {estoria} estoria
         * @param {eventButton} event
         */
        function abrirDialogAlterarPrioridadeBacklog(estoria, event) {
            $mdDialog.show({
                controller: "ProductBacklogDialogAlterarPrioridade",
                controllerAs: "vm",
                templateUrl: vm.htmlRota.dialogAlterarPrioridadeBacklog,
                //parent: ---------------,
                targetEvent: event,
                clickOutsideToClose: false,
                locals: {
                    Estoria: estoria
                }
            });
        }

        /**
         *
         * @param {index} index Index da estoria na tabela
         * @param {estoria} estoria estoria selecionada na tabela
         * @param {eventButton} event
         */
        function abrirDialogAlterarDataEntregaBacklog(index, estoria, event) {
            $mdDialog.show({
                controller: "ProductBacklogDialogAlterarDataEntrega",
                controllerAs: "vm",
                templateUrl: vm.htmlRota.dialogAlterarDataEntrega,
                //parent: ---------------,
                targetEvent: event,
                clickOutsideToClose: false,
                locals: {
                    Estoria: estoria,
                    Index: index
                }
            });
        }

        /**
         * Método para abrir o dialog para editar o campo "necessidadeCliente"
         * @param {object} estoria
         * @param {object} event
         */
        function abrirDialogNecessidadeCliente(estoria, event) {
            $mdDialog.show({
                controller: "ProductBacklogDialogAlterarNecessidadeCliente",
                controllerAs: "vm",
                templateUrl: vm.htmlRota.dialogAlterarNecessidadeCliente,
                //parent: ---------------,
                targetEvent: event,
                clickOutsideToClose: false,
                locals: {
                    Estoria: estoria
                }
            });
        }

        /**
         * Filtra tabela com base no que está sendo digitado no campo Pesquisar na tela
         * @param {textoDePesquisa} filtro
         */
        function filtrarTabela(filtro) {
            vm.filtro = filtro;
            metodosInternoProductBacklog.defineArrayDePesquisa(filtro);
        }

        /**
         * Reseta todos os filtros para voltar a tabela para o estado inicial
         */
        function resetarFiltros() {
            angular.forEach(
                vm.defineLegendasProductBacklog,
                function (item, index, array) {
                    item.situacaoSelecionada = false;
                    arrayDePesquisa = [];
                    legendaErroClienteTemporario = "";
                }
            );
        }

        // Implementação dos Métodos internos region

        /**
         *
         * @param {filtro} filtro
         */
        function defineArrayDePesquisa(filtro) {
            angular.forEach(vm.defineLegendasProductBacklog, function (item, index) {
                if (filtro.descricao === "Erro Cliente" && index === 0) {
                    item.situacaoSelecionada = !item.situacaoSelecionada;
                    !legendaErroClienteTemporario ? (legendaErroClienteTemporario = clientes) : (legendaErroClienteTemporario = "");
                } else if (item.descricao === filtro.descricao) {
                    item.situacaoSelecionada = !item.situacaoSelecionada;
                    if (arrayDePesquisa.indexOf(item.descricao) === -1) {
                        arrayDePesquisa.push(item.descricao);
                    } else {
                        arrayDePesquisa.splice(arrayDePesquisa.indexOf(item.descricao), 1);
                    }
                }
            });
        }

        /**
         *
         * @param {buttonErroClienteClicado} buttonErroClienteClicado Button selecionado
         */
        function defineSituacaoLegendas(buttonErroClienteClicado) {
            if (buttonErroClienteClicado) {
                angular.forEach(vm.defineLegendasProductBacklog, function (
                    item,
                    index,
                    array
                ) {
                    if (index > 0) {
                        item.situacaoSelecionada = false;
                    }
                });
                arrayDePesquisa = [];
            } else {
                vm.defineLegendasProductBacklog[0].situacaoSelecionada = false;
                legendaErroClienteTemporario = "";
                return true;
            }
        }

        function abrirDialogEstoria(estoria) {
            $state.goNewTab("app.planejamento_processamento_estoria", {
                parametros: {
                    numero: estoria.numero,
                    ano: estoria.ano,
                    chamarPesquisa: true,
                    squadCodigo: estoria.squadCodigo
                }
            });
        }

        function atualizarTabela() {
            vm.mostrarTabela = false;
            vm.requisicaoSolicitada = true;
            vm.mensagemPreloader = "Pesquisando histórias...";
            reverterGerarBacklog();
            _retornoRequisicao().then(
                function (success) {
                    vm.mensagemPreloader = "";
                    vm.mostrarTabela = false;
                    vm.requisicaoSolicitada = false;
                    vm.estorias = success.data;
                });
        }

        function abrirDialogAdicionarSprintProductBacklog(estoria) {
            vm.historiasSelecionadas = [];
            vm.historiasSelecionadas.push(estoria);
            gerarBacklog();
        }

        function pesquisarAutoCompleteCliente(query) {
            query = query.toLowerCase();
            var resultado = query
                ? vm.clientes.filter(function (item) {
                    return (
                        item.codigo == query ||
                        item.nome.toLowerCase().search(query) != -1
                    );
                })
                : vm.clientes;

            return resultado;
        }

        function abrirDialogSituacao(
            index,
            event,
            situacao,
            estoria
        ) {

            var situacoes = ListarSituacoes.data.filter(function (situacao) {
                if (situacao.codigo == 1 || situacao.codigo == 2 || situacao.codigo == 3 ||
                    situacao.codigo == 16 || situacao.codigo == 17)
                    return situacao;
            });
            var situacaoAtual = {
                situacao: {
                    codigo: estoria.situacaoCodigo,
                    descricao: estoria.situacaoDescricao
                }
            };
            $mdDialog.show({
                controller: "SprintDialogBacklogSituacaoController",
                controllerAs: "vm",
                templateUrl: 'app/main/planejamento-scrum/processamento/sprint/views/tabs/backlog/dialogs/situacao-dialog/sprint-dialog-backlog-situacao.html',
                targetEvent: event,
                clickOutsideToClose: false,
                locals: {
                    Index: index,
                    Situacao: situacaoAtual,
                    Situacoes: situacoes,
                    Estoria: estoria,
                    EstoriaBacklog: null
                }
            });
        }

        function _retornoRequisicao() {
            return RequisicaoGenericaService.listarComParams(
                Api.estoria.listarEstoriasPorProductBacklog + '?' + 'codigoProduto=' + vm.codigoProduto +
                (vm.squadCodigo ? ('&squadCodigo=' + vm.squadCodigo) : '') +
                (vm.necessidadeCliente ? ('&necessidadeCliente=' + vm.necessidadeCliente) : '') +
                (vm.stackResponsavel ? ('&stackResponsavel=' + vm.stackResponsavel) : '') +
                (vm.codigoCliente ? ('&codigoCliente=' + vm.codigoCliente) : '')
            );
        }

        function configuraMdSelectProduto() {
            vm.filtrarProdutos = '';
            angular
                .element('#produto-md-select')
                .on('keydown', function (ev) {
                    ev.stopPropagation();
                });
        }

        function selectChangeSquad(codigoSquadSelecionada) {
            vm.codigoProduto = null;
            _listarProdutosVinculados(codigoSquadSelecionada);
        }

        function abrirDialogLegendaTabela() {
            $mdDialog.show({
                controller: "DialogLegendaTabelaProductBacklogController",
                controllerAs: "vm",
                templateUrl: 'app/main/planejamento-scrum/processamento/product-backlog/views/dialog-legenda-tabela/dialog-legenda-tabela.html',
                targetEvent: event,
                clickOutsideToClose: false,
                locals: {

                }
            });
        }

        function gerarBacklog() {
            $mdDialog.show({
                controller: "ProductBacklogDialogAdicionarSprintEspecificaController",
                controllerAs: "vm",
                templateUrl: vm.htmlRota.dialogAdicionarSprint,
                targetEvent: event,
                clickOutsideToClose: false,
                locals: {
                    SquadFiltrada: vm.squadCodigo,
                    HistoriasSelecionadas: vm.historiasSelecionadas,
                    SprintCorrente: ListarSprintCorrentePorSquads,
                }
            }).then(function (houveAlteracao) {
                if (houveAlteracao) {
                    pesquisarProductBacklog(vm.codigoProduto, vm.necessidadeCliente,
                        vm.cliente, vm.stackResponsavel, vm.squadCodigo);
                }
            });
        }

        function onChangeHistoriasSelecionadas(historiaSelecionada) {
            var idx = vm.historiasSelecionadas.findIndex(function (h) {
                return h.numero === historiaSelecionada.numero && h.ano === historiaSelecionada.ano;
            });
            if (idx === -1) {
                vm.historiasSelecionadas.push(historiaSelecionada);
            } else {
                vm.historiasSelecionadas.splice(idx, 1);
            }
        }

        function reverterGerarBacklog() {
            vm.gerandoBacklog = false;
            vm.historiasSelecionadas = [];
            vm.checkboxSelecionado = {};
        }

        function _listarProdutosVinculados(codigoSquad) {
            var url = Api.produto.listarProdutoSoftwareProprio;

            var squads = codigoSquad ? [codigoSquad] : vm.squadUsuarioLogado;

            var entidadeEnvio = {
                codigoSquads: squads.length > 0 ? squads : [vm.squadCodigo],
            }

            return RequisicaoGenericaService.listarPorPaginacaoJsonFormato(url, entidadeEnvio)
                .then(function (success) {
                    vm.produtos = success.data;
                })
                .catch(function (error) {
                    vm.produtos = [];
                })
        }


        function definirCoresDataEntrega(dataEntrega) {
            if (!dataEntrega) return '';
            var hoje = new Date();
            var data = new Date(dataEntrega);
            hoje.setHours(0, 0, 0, 0);
            data.setHours(0, 0, 0, 0);
            var diffMs = data - hoje;
            var diffDias = Math.ceil(diffMs / (1000 * 60 * 60 * 24));
            if (diffDias < 0) {
                return vm.coresDataEntrega[0].cor;
            } else if (diffDias >= 0 && diffDias <= 5) {
                return vm.coresDataEntrega[1].cor;
            }
            return '';
        }

        function calcularDiasParaVencimento(dataEntrega) {
            if (!dataEntrega) return '';
            var hoje = new Date();
            var data = new Date(dataEntrega);
            hoje.setHours(0, 0, 0, 0);
            data.setHours(0, 0, 0, 0);
            var diffMs = data - hoje;
            var diffDias = Math.ceil(diffMs / (1000 * 60 * 60 * 24));
            return diffDias;
        };
    }
})();
//ng-class="{'vermelho': estoria.diasRestantes <= 0,
//'amarelo': estoria.diasRestantes <= 7 && estoria.diasRestantes < 0}"
(function () {
    "use strict";

    angular
        .module("app.planejamentoscrum.consulta.estatisticas")
        .controller("ConsultaEstatisticaController", ConsultaEstatisticaController);

    function ConsultaEstatisticaController(
        $timeout,
        $mdSidenav,
        $mdDialog,
        Api,
        ListarAno,
        ListarSprint,
        MdDialogService,
        NavegacaoService,
        ListarTipoFiltroEstatistica,
        ListarUsuarioPorDetalhe,
        RequisicaoGenericaService,
        RotasHtml,
        SquadService
    ) {
        var vm = this;
        vm.rotasHtml = RotasHtml.estatistica;
        vm.listarTipoFiltroEstatistica = ListarTipoFiltroEstatistica.data;
        vm.exibeCardMetasConcluidas = true;

        vm.squadUsuarioLogado = ListarUsuarioPorDetalhe.data.codigoSquads;
        vm.squads = SquadService.listarSquadsUsuarioLogado(vm.squadUsuarioLogado);

        vm.estatisticasGeral = {
            pontuacaoEntregue: 0,
            historiasDesenvolvidas: 0,
            historiasHomologadasTotal: 0,
            pontosHomologados: 0,
            retornoMelhorias: 0,
            retornoErro: 0,
            pontosPerdidos: 0,
            metaConcluida: 0
        };

        vm.cards = [
            { titulo: "Pontos desenvolvidos", valor: 1 },
            { titulo: "Histórias desenvolvidas", valor: 2 },
            { titulo: "Histórias homologadas", valor: 3 },
            { titulo: "Pontos homologados", valor: 4 },
            { titulo: "Melhorias", valor: 5 },
            { titulo: "Erros", valor: 6 },
            { titulo: "Pontos perdidos", valor: 7 },
            { titulo: 'Metas concluídas', valor: 8 }
        ];

        vm.ano = ListarAno.data;
        vm.filtro = {
            numeroSprint: [],
            tipoFiltro: 0,
            squadCodigo: vm.squadUsuarioLogado[0],
        };

        vm.consultaEstatistica = {
            sprints: [],
            tipoFiltro: 0
        };

        vm.sprintNumero = [];
        NavegacaoService.setTituloAba("Estatísticas");
        vm.sprintsAnoCorrente = ListarSprint.data;

        if (vm.sprintsAnoCorrente.length >= 4) {
            vm.sprintsAnoCorrente = vm.sprintsAnoCorrente.slice(vm.sprintsAnoCorrente.lastIndexOf() - 3);
        }

        vm.sprintsAnoCorrente.forEach(function (item, index) {
            vm.sprintNumero.push(item.numero);
        });

        vm.filtro.numeroSprint = vm.sprintNumero;

        buscarSprints(vm.filtro);

        vm.toggleLeft = buildDelayedToggler("left");
        vm.toggleRight = buildToggler("right");
        vm.isOpenRight = function () {
            return $mdSidenav("right").isOpen();
        };

        vm.close = function () {
            $mdSidenav("right")
                .close()
        };

        vm.metodos = {
            buscarSprints: buscarSprints,
            retornaSprintPorAno: retornaSprintPorAno,
            abrirDialogGrafico: abrirDialogGrafico,
            fecharDialog: fecharDialog,
            selectChangeSquad: selectChangeSquad
        };

        function debounce(func, wait) {
            var timer;

            return function debounced() {
                var context = this,
                    args = Array.prototype.slice.call(arguments);
                $timeout.cancel(timer);
                timer = $timeout(function () {
                    timer = undefined;
                    func.apply(context, args);
                }, wait || 10);
            };
        }

        function buildDelayedToggler(navID) {
            return debounce(function () {
                $mdSidenav(navID)
                    .toggle()
            }, 200);
        }

        function buildToggler(navID) {
            return function () {
                $mdSidenav(navID)
                    .toggle()
            };
        }

        function buscarSprints(filtro) {
            var squadCodigo = (vm.squadUsuarioLogado.length === 1) ? vm.squadUsuarioLogado[0] : filtro.squadCodigo;
            var viewModel = {
                tipoFiltro: filtro.tipoFiltro,
                squadCodigo: squadCodigo
            };

            if (filtro.sprints) {
                if (filtro.sprints.length) {
                    viewModel.numeroSprint = filtro.sprints.map(function (sprint) {
                        return sprint.numero;
                    });
                }
                else {
                    viewModel.numeroSprint = vm.sprint.map(function (sprint) {
                        return sprint.numero;
                    });
                }
            }
            else {
                viewModel = filtro;
            }

            vm.requisicaoSolicitada = true;
            RequisicaoGenericaService.listarComObjetoComplexo(
                Api.sprint.estatistica.listarEstatistica,
                viewModel
            ).then(
                function (success) {
                    vm.estatistica = success.data;
                    vm.estoriasnasVersoesGeradasPelaPesquisa = success.data;
                    vm.pesquisaAtiva = true;
                    vm.requisicaoSolicitada = false;

                    vm.estatisticasGeral.pontuacaoEntregue = 0;
                    vm.estatisticasGeral.historiasDesenvolvidas = 0;
                    vm.estatisticasGeral.historiasHomologadasTotal = 0;
                    vm.estatisticasGeral.pontosHomologados = 0;
                    vm.estatisticasGeral.retornoMelhorias = 0;
                    vm.estatisticasGeral.retornoErro = 0;
                    vm.estatisticasGeral.pontosPerdidos = 0;
                    vm.estatisticasGeral.metaConcluida = 0;

                    calculaTotalizador(vm.estatistica);
                    vm.form.filtros.$setPristine();
                    vm.form.filtros.$setValidity();
                    vm.form.filtros.$setUntouched();
                    vm.close();

                    vm.exibeCardMetasConcluidas = vm.consultaEstatistica.tipoFiltro != 2;
                },
                function (error) {
                    MdDialogService.alertPadrao(error.data, event);
                    vm.requisicaoSolicitada = false;
                }
            );
        }

        function retornaSprintPorAno(ano, squadCodigo) {
            squadCodigo = (vm.squadUsuarioLogado.length === 1 || !squadCodigo) ? vm.squadUsuarioLogado[0] : squadCodigo;
            vm.sprint = null;
            vm.consultaEstatistica.sprints = [];
            RequisicaoGenericaService.listarSemParams(
                Api.sprint.estatistica.listarSprint + '?' + 'ano=' + ano + "&" + 'squadCodigo=' + squadCodigo
            ).then(function (success) {
                vm.sprint = success.data;
                vm.sprint.map(function (sprint) {
                    sprint.descricao = sprint.numero + " de " + _dataParaString(sprint.dataInicial) + " a " + _dataParaString(sprint.dataFinal);
                });
            });
        }

        function calculaTotalizador(sprints) {
            sprints.forEach(function (item) {
                vm.estatisticasGeral.pontuacaoEntregue += item.pontuacaoEntregue;
                vm.estatisticasGeral.historiasDesenvolvidas += item.historiasDesenvolvidas;
                vm.estatisticasGeral.historiasHomologadasTotal += item.historiasHomologadas;
                vm.estatisticasGeral.pontosHomologados += item.pontuacaoHomologada;
                vm.estatisticasGeral.retornoMelhorias += item.totalMelhorias;
                vm.estatisticasGeral.retornoErro += item.totalErros;
                vm.estatisticasGeral.pontosPerdidos += item.pontuacaoPerdida;
                vm.estatisticasGeral.metaConcluida += item.metaConcluida ? 1 : 0;
            });
        }

        function abrirDialogGrafico(event, titulo) {
            $mdDialog.show({
                controller: "ConsultaEstatisticaDialogController",
                controllerAs: "vm",
                templateUrl: vm.rotasHtml.dialogGrafico,
                targetEvent: event,
                clickOutsideToClose: false,
                locals: {
                    Estatistica: vm.estatistica,
                    Titulo: titulo
                }
            });
        }
        function fecharDialog() {
            $mdDialog.hide();
        }

        function _dataParaString(data) {
            return new Date(data).toLocaleDateString();
        }

        function selectChangeSquad(squadCodigo) {
            vm.ano = [];
            vm.sprintAno = null;
            vm.sprint = [];
            vm.consultaEstatistica.sprints = null;
            return RequisicaoGenericaService.listarSemParams(
                Api.sprint.estatistica.listarAno + '?' +
                'squadCodigo=' + squadCodigo)
                .then(function (success) {
                    vm.ano = success.data;
                })
                .catch(function (error) {
                    vm.ano = [];
                })
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.planejamentoScrum.consulta.controleVersao', [])
        .config(Config);

    function Config($stateProvider, RotasHtml) {
        var rotasHtmlControleVersao = RotasHtml.consultaControleVersao;
        $stateProvider
            .state('app.planejamento_consulta_controle_versao', {
                url: '/consultas/controle-versao',
                module: 'privado',
                views: {
                    'content@app': {
                        templateUrl: rotasHtmlControleVersao.templateUrl,
                        controller: 'ConsultaControleVersaoController as vm'
                    }
                },
                resolve: {
                    ListarSolucoesCodigoDescricao: function (Api, RequisicaoGenericaService) {
                        return RequisicaoGenericaService.listarSemParams(Api.solucao_rotinas_tarefas.solucao.listarCodigoDescricao);
                    },
                    ListarUsuarioPorDetalhe: function (Api, RequisicaoGenericaService, LoginUsuarioService) {
                        return RequisicaoGenericaService.listarSemParams(Api.usuario.detalhes_usuario.listarDetalhesUsuario
                            + LoginUsuarioService.usuarioArmazenado().codigo);
                    }
                }
            });
    }

})();

//ng-class="{'vermelho': estoria.diasRestantes <= 0,
//'amarelo': estoria.diasRestantes <= 7 && estoria.diasRestantes < 0}"
(function () {
    'use strict';

    angular
        .module('app.planejamentoScrum.consulta.controleVersao')
        .controller('ConsultaControleVersaoController', ConsultaControleVersaoController);

    function ConsultaControleVersaoController(Api,
        NavegacaoService, RequisicaoGenericaService,
        ListarUsuarioPorDetalhe,
        SquadService,
        MdDialogService, RotasHtml, EstoriaFactory) {
        var vm = this;
        NavegacaoService.setTituloAba('Controle de versão');

        // Data region
        vm.rotasHtml = RotasHtml.consultaControleVersao
        vm.requisicaoSolicitada = false;
        vm.pesquisaAtiva = false;
        vm.form = {};
        vm.consultaVersao = {};
        vm.squadUtilizada = "";
        vm.solucaoUtilizada = "";
        vm.versoesUtilizadas = "";
        vm.releasesUtilizadas = "";
        vm.coresSituacoes = EstoriaFactory.coresSituacoes();
        vm.squadUsuarioLogado = ListarUsuarioPorDetalhe.data.codigoSquads;
        vm.squads = SquadService.listarSquadsUsuarioLogado(vm.squadUsuarioLogado);
        if (vm.squadUsuarioLogado.length === 1) _listarSolucoesVinculadas();
        vm.versoes = [];
        vm.releases = [];

        vm.requisicaoPesquisaVersaoSolicitada = false;
        var solucaoCodigo = null;
        var quantidadeVersoes = null;

        vm.requisicaoPesquisaReleaseSolicitada = false;
        //endregion

        // Configurações Datatable region
        vm.dtOptionsLog = {
            dom: 'rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
            initComplete: function () {
                var api = this.api(),
                    searchBox = angular.element('body').find('#pesquisar');
                // Bind an external input as a table wide search box
                if (searchBox.length > 0) {
                    searchBox.on('keyup', function (event) {
                        api.search(event.target.value).draw();
                    });
                }
            },
            scrollY: 'auto',
            pagingType: 'numbers',
            lengthMenu: [100],
            pageLength: 100,
            responsive: true,
            order: []
        };
        //endregion

        // Definição dos Métodos region    
        var metodosInterno = {
            defineFiltrosUtilizados: defineFiltrosUtilizados,
            defineSolucaoUtilizada: defineSolucaoUtilizada,
            defineVersoesUtilizada: defineVersoesUtilizada,
            defineReleasesUtilizada: defineReleasesUtilizada
        };

        vm.metodosControleVersao = {
            redefineVersoesEReleases: redefineVersoesEReleases,
            redefineReleases: redefineReleases,
            configuraMdSelectSolucao: configuraMdSelectSolucao,
            configuraMdSelectVersoes: configuraMdSelectVersoes,
            configuraMdSelectReleases: configuraMdSelectReleases,
            pesquisar: pesquisar,
            novaConsulta: novaConsulta,
            selectChangeSquad: selectChangeSquad
        };
        //endregion      

        // Implementação dos Métodos region    

        // Métodos Interno region

        /**
         * 
         * @param {consultaVersao} consultaVersao 
         */
        function defineFiltrosUtilizados(consultaVersao) {
            metodosInterno.defineSolucaoUtilizada(consultaVersao);
            metodosInterno.defineVersoesUtilizada(consultaVersao);
            metodosInterno.defineReleasesUtilizada(consultaVersao);
        }

        function selectChangeSquad(squadSelecionada) {
            _listarSolucoesVinculadas(squadSelecionada);
        }

        function _listarSolucoesVinculadas(squadCodigo) {
            vm.consultaVersao.solucaoCodigo = null;
            vm.consultaVersao.versoes = null;
            vm.consultaVersao.releases = null;

            var url = Api.solucao_rotinas_tarefas.solucao.listarPorSquadCliente;
            var entidadeEnvio = {
                codigoSquads: squadCodigo ? [squadCodigo] : vm.squadUsuarioLogado,
                exibirSolucaoComSquad: true
            }
            return RequisicaoGenericaService.listarPorPaginacaoJsonFormato(url, entidadeEnvio)
                .then(function (success) {
                    vm.solucoes = success.data;
                })
                .catch(function (error) {
                    vm.solucoes = [];
                })
        }

        /**
         * 
         * @param {solucao} consultaVersao 
         */
        function defineSolucaoUtilizada(consultaVersao) {
            angular.forEach(vm.solucoes, function (item, index) {
                if (item.codigo == consultaVersao.solucaoCodigo)
                    vm.solucaoUtilizada = item.descricao;
            });
        }

        /**
         * 
         * @param {versoes} consultaVersao 
         */
        function defineVersoesUtilizada(consultaVersao) {
            angular.forEach(consultaVersao.versoes, function (item, index) {
                if (consultaVersao.versoes.length - 1 === index) {
                    vm.versoesUtilizadas += item;
                } else {
                    vm.versoesUtilizadas += item + ", ";
                }
            });
        }

        /**
         * 
         * @param {releases} consultaVersao 
         */
        function defineReleasesUtilizada(consultaVersao) {
            angular.forEach(consultaVersao.releases, function (item, index) {
                if (consultaVersao.releases.length - 1 === index) {
                    vm.releasesUtilizadas += item;
                } else {
                    vm.releasesUtilizadas += item + ", ";
                }
            });
        }
        //endregion

        /**
         * Método para redefinir todos os campos para uma nova pesquisa
         */
        function redefineVersoesEReleases() {
            vm.versoes = [];
            vm.consultaVersao.versoes = [];
            vm.releases = [];
            vm.consultaVersao.releases = [];
            solucaoCodigo = null
            quantidadeVersoes = null;
        }

        /**
         * Método para redefinir as Releases e Versões 
         */
        function redefineReleases() {
            vm.releases = [];
            vm.consultaVersao.releases = [];
            quantidadeVersoes = null;
        }

        /**
         * Método que configura o md-select de Soluções e limpa o filtro do md-select-header quando o component
         * md-select de Soluções é aberto
         */
        function configuraMdSelectSolucao() {
            vm.filtrarSolucoes = "";
            angular.element('#consulta-controle-versao-solucao-md-select').on('keydown', function (ev) {
                ev.stopPropagation();
            });
        }

        /**
         * Configura o md-select de Versoes, sempre quando o componente for aberto será feito uma requisição para Api
         * para buscar todas as Versões com base na Solução selecionada anteriormente
         * @param {codigoSolucao} codigoSolucao 
         */
        function configuraMdSelectVersoes(codigoSolucao) {

            if (solucaoCodigo !== codigoSolucao || !solucaoCodigo) {
                solucaoCodigo = codigoSolucao;

                if (vm.squadUsuarioLogado.length === 1) vm.consultaVersao.squadCodigo = vm.squadUsuarioLogado[0];
                const entidadeEnvio = {
                    solucaoCodigo: codigoSolucao,
                    squadCodigo: vm.consultaVersao.squadCodigo
                }

                vm.requisicaoPesquisaVersaoSolicitada = true;
                RequisicaoGenericaService.listarComParams(Api.consultas.controle_versao.listarVersoesPorSolucao, entidadeEnvio)
                    .then(function (success) {
                        vm.versoes = success.data;

                        vm.requisicaoPesquisaVersaoSolicitada = false;
                    }, function (error) {
                        MdDialogService.alertPadrao(error.data, event);
                        vm.requisicaoPesquisaVersaoSolicitada = false;
                    });
            }
        }

        /**
         * Configura o md-select de Releases, sempre quando o componente for aberto será feito uma requisição para Api
         * para buscas todas as Releases com base nas Versões selecioandas anteriormente
         * @param {versoes} consultaRelease 
         */
        function configuraMdSelectReleases(consultaRelease) {
            if (consultaRelease.versoes.length !== quantidadeVersoes || !quantidadeVersoes) {
                if (vm.squadUsuarioLogado.length === 1) vm.consultaVersao.squadCodigo = vm.squadUsuarioLogado[0];
                vm.requisicaoPesquisaReleaseSolicitada = true;
                RequisicaoGenericaService.listarComParams(Api.consultas.controle_versao.listarReleasesPorVersoes, consultaRelease)
                    .then(function (success) {
                        vm.releases = success.data;
                        quantidadeVersoes = consultaRelease.versoes.length;

                        vm.requisicaoPesquisaReleaseSolicitada = false;
                    }, function (error) {
                        MdDialogService.alertPadrao(error.data, event);
                        vm.requisicaoPesquisaReleaseSolicitada = false;
                    });
            }
        }

        /**
         * 
         * @param {consulta} consultaVersao 
         */
        function pesquisar(consultaVersao) {
            if (vm.squadUsuarioLogado.length === 1) consultaVersao.squadCodigo = vm.squadUsuarioLogado[0];
            vm.requisicaoSolicitada = true;
            RequisicaoGenericaService.listarComParams(Api.consultas.controle_versao.listarEstoriasNasVersoes, consultaVersao)
                .then(function (success) {
                    vm.estoriasnasVersoesGeradasPelaPesquisa = success.data;
                    vm.pesquisaAtiva = true;
                    vm.requisicaoSolicitada = false;
                    vm.squadUtilizada = SquadService.descricaoSquad(consultaVersao.squadCodigo);

                    metodosInterno.defineFiltrosUtilizados(vm.consultaVersao);
                }, function (error) {
                    MdDialogService.alertPadrao(error.data, event);
                    vm.requisicaoSolicitada = false;
                });
        }

        /**
         * 
         */
        function novaConsulta() {
            vm.form.consultaControleVersao.$setPristine();
            vm.form.consultaControleVersao.$setUntouched();
            vm.consultaVersao = {};
            vm.pesquisaAtiva = false;
            vm.pesquisar = "";
            vm.squadUtilizada = "";
            vm.solucaoUtilizada = "";
            vm.versoesUtilizadas = "";
            vm.releasesUtilizadas = "";
        }
        //endregion
    }

})();

/**
 * Created by nova on 28/03/2017.
 */
(function () {
    'use strict';

    angular
        .module('app.pipeline.processamento.pipelineNegociosGanhosPerdidos', [])
        .config(config);

    function config($stateProvider, RotasHtml) {
        var rotasHtml = RotasHtml.pipeline_negocios_ganhos_perdidos;
        $stateProvider
            .state('app.pipeline_processamento_pipelinenegociosganhosperdidos', {
                url: '/pipeline/processamento/pipeline/negocios-ganhos-perdidos',
                module: 'privado',
                views: {
                    'content@app': {
                        templateUrl: rotasHtml.templateUrl,
                        controller: "PipelineNegociosGanhosPerdidosController as vm"
                    }
                }
            });
    }

})();

(function () {
    'use strict';

    angular
        .module('app.pipeline.processamento.pipelineNegociosGanhosPerdidos')
        .controller('PipelineNegociosGanhosPerdidosController', PipelineNegociosGanhosPerdidosController);

    function PipelineNegociosGanhosPerdidosController($filter, NavegacaoService, MdDialogService, MdToastService, RequisicaoGenericaService, DatatableFactory, Api) {
        var vm = this;
        NavegacaoService.setTituloAba('Pipeline negócios ganhos e perdidos');
        //#region Data
        var tabela;

        vm.rota = Api.pipeline.pipeline_negocio;

        _init();

        var metodosInterno = {
            _init: _init,
            _construirDtOptions: _construirDtOptions
        }

        vm.metodos = {
            selecionar: selecionar
        }
        //#endregion


        //#region Métodos
        function _init() {

            DatatableFactory.setConverterEntidadePesquisaParaJson(true);
            _construirDtOptions();
        }

        function _construirDtOptions() {
            DatatableFactory.construirDtOptionsComPaginacaoProcessadoNoServidorParaToolbar
                (vm.rota.resultado.listarNegociosComResultadosComPaginacaoDatatable, null, '#datatable-pipeline-negocios-ganhos-perdidos',
                    [
                        DatatableFactory.construirColunaDeSelecionarPadrao(
                            function (indexLinha, td, cellData, rowData, col) { vm.metodos.selecionar(indexLinha, td, cellData, rowData, col) }, "icon-delete"),
                        {
                            targets: 1,
                            name: "Codigo",
                            data: "codigo",
                            defaultContent: "",
                        },
                        {
                            targets: 2,
                            name: "DescricaoEtapa",
                            data: "descricaoEtapa",
                            defaultContent: "",
                        },
                        {
                            targets: 3,
                            name: "NomeCliente",
                            data: "nomeCliente",
                            defaultContent: "",
                        },
                        {
                            targets: 4,
                            name: "DataInicial",
                            data: "dataInicial",
                            defaultContent: "",
                            render: function (data) {
                                return $filter('date')(data, 'dd/MM/yyyy')
                            },
                        },
                        {
                            targets: 5,
                            name: "DataFinal",
                            data: "dataFinal",
                            defaultContent: "",
                            render: function (data) {
                                return $filter('date')(data, 'dd/MM/yyyy')
                            },
                        },
                        {
                            targets: 6,
                            name: "Valor",
                            data: "valor",
                            defaultContent: "",
                            render: function (data) {
                                return $filter('currency')(data, 'R$')
                            }
                        },
                        {
                            targets: 7,
                            name: "OutrosValores",
                            data: "outrosValores",
                            defaultContent: "",
                            render: function (data) {
                                return $filter('currency')(data, 'R$')
                            }
                        },
                        {
                            targets: 8,
                            name: "DescricaoFunil",
                            data: "descricaoFunil",
                            defaultContent: "",
                        },
                        {
                            targets: 9,
                            name: "StatusNegocio",
                            data: "descricaoStatusNegocio",
                            defaultContent: "",
                        },
                        {
                            targets: 10,
                            name: "Atendimento",
                            data: function (data) {
                                return data.codigoAtendimento + "/" + data.anoAtendimento;
                            },
                            defaultContent: "",
                            orderable: false,
                            filterable: false,
                        },
                    ]).then(function (success) {
                        tabela = success;
                    });
        }


        function selecionar(index, td, cellData, rowData, col) {
            MdDialogService.confirmPadraoComEvento("Deseja realmente retornar o negócio selecionado para o funil ?", "", null,
                function (ok) {
                    RequisicaoGenericaService.excluir(vm.rota.resultado.retornarNegocioAoFunil, rowData.codigo).then(
                        function (success) {
                            tabela.api().ajax.reload(null, true);
                            MdToastService.toastPadrao(success.data);
                        },
                        function (error) {

                        });
                });
        }

        //#endregion

    } // CONTROLLER

})();

/**
 * Created by nova on 28/03/2017.
 */
(function () {
    'use strict';

    angular
        .module('app.pipeline.processamento.pipelineNegociosVencidosExecutivoResponsavel', [])
        .config(config);

    function config($stateProvider, RotasHtml) {
        var rotasHtmlFeriado = RotasHtml.pipeline_negocios_vencidos_executivos_responsavel;
        $stateProvider
            .state('app.pipeline_processamento_pipelinenegociovencidosexecutivoresponsavel', {
                url: '/pipeline/processamento/pipeline/negocios-vencidos',
                module: 'privado',
                views: {
                    'content@app': {
                        templateUrl: rotasHtmlFeriado.templateUrl,
                        controller: "PipelineNegociosVencidosExecutivoResponsavel as vm"
                    }
                }
            });
    }

})();

/**
 * Created by nova on 26/10/2016.
 */
(function () {
    'use strict';

    angular
        .module('app.pipeline.processamento.pipelineNegociosVencidosExecutivoResponsavel')
        .controller('PipelineNegociosVencidosExecutivoResponsavel', PipelineNegociosVencidosExecutivoResponsavel);

    function PipelineNegociosVencidosExecutivoResponsavel(DatatableFactory, MenuFactory, MdDialogService, RotasHtml, Api,
        RequisicaoGenericaService, LoginUsuarioService, NavegacaoService) {
        var vm = this;
        NavegacaoService.setTituloAba('Pipeline negócios vencidos');

        var rotasHtml = RotasHtml.pipeline_negocio;

        //region Definição dos Métodos
        var metodosInternos = {
            init: _init,
            construirDtOptions: _construirDtOptions,
        }

        vm.metodos = {
            abrirDialogNegocio: abrirDialogNegocio
        };
        //endregion

        _init();

        //#region Métodos Interno

        function _init() {
            _listarTodosNegociosExecutivoContas();
            vm.dtOptions = _construirDtOptions();
        }

        function _listarTodosNegociosExecutivoContas() {
            RequisicaoGenericaService.listarSemParams(Api.pipeline.pipeline_negocio.listarNegociosVencidosExecutivoContas +
                LoginUsuarioService.usuarioArmazenado().codigo)
                .then(function (success) {
                    if (success.data && success.data.length > 0)
                        vm.negociosVencidos = success.data;
                    else {
                        MdDialogService.alertPadrao("Não existem negociações com etapas a vencer ou vencidas.");
                        MenuFactory.navegarParaEstadoSeUsuarioTerAcesso('app.pipeline_processamento_pipelinenegocio.funis');
                    }
                },
                    function (error) {
                        MdDialogService.alertPadrao("Não foi possível carregar os dados de negociações vencidas.");
                    });
        }

        function _construirDtOptions() {
            return DatatableFactory.construirDtOptionsComPaginacaoResponsivoPadrao([
                DatatableFactory.construirColunaAcaoPadrao(0)
            ]);
        }

        //#endregion

        //#region Métodos
        function abrirDialogNegocio(event, negocio) {
            var callbackEdicaoNegocio = function () {
                _listarTodosNegociosExecutivoContas();
            };

            var parametros = [negocio.codigo, negocio.codigoFunil, 2, undefined, callbackEdicaoNegocio, undefined, negocio.descricaoFunil]
            MdDialogService.abrirDialogPadrao(event, 'PipelineNegocioExternosDialogController',
                rotasHtml.dialogs.dialogPipelineNegocio.templateUrl, parametros);
        }
        //#endregion

    } // CONTROLLER

})();
//ng-class="{'vermelho': estoria.diasRestantes <= 0,
//'amarelo': estoria.diasRestantes <= 7 && estoria.diasRestantes < 0}"
(function () {
  "use strict";

  angular
    .module("app.planejamentoScrum.consulta.estoria")
    .controller("ConsultaEstoriasController", ConsultaEstoriasController);

  function ConsultaEstoriasController(
    $mdDialog,
    $state,
    $timeout,
    Api,
    ConsultasEstoriaFactory,
    ConsultasEstoriaService,
    ListarTodasSituacoes,
    ListarUsuarioPorDetalhe,
    LoginUsuarioService,
    MdDialogService,
    NavegacaoService,
    RequisicaoGenericaService,
    RotasHtml,
    SquadService,
    ToolbarService
  ) {
    var vm = this;
    NavegacaoService.setTituloAba("Consulta de histórias");

    // Data region
    vm.htmlRota = RotasHtml.consultaEstoria;

    vm.estorias = null;
    var estoriasVencidas = [];
    var estoriasSeteDiasRestantes = [];
    vm.filtroUtilizado;
    vm.usuarioCorrenteTodasEstorias = true;

    vm.filtroAtivo = false;
    vm.tipoFiltro = "geral";
    vm.sugestaoFiltro = ConsultasEstoriaFactory.setSugestaoFiltros();
    vm.filtrosEspecificos = ListarTodasSituacoes.data;
    var filtroFormatadoEstoriasNaoConcluidasColaborador = ConsultasEstoriaFactory.setArrayFormatadoDeFiltrosEstoriasNaoConcluidasDoColaborador();
    vm.filtros = [];
    vm.requisicaoSolicitada = false;
    vm.squadUsuarioLogado = ListarUsuarioPorDetalhe.data.codigoSquads;
    vm.squads = SquadService.listarSquadsUsuarioLogado(vm.squadUsuarioLogado);
    vm.squadCodigo = ToolbarService.squadSelecionado();
    vm.legendaSelecionada = null;
    var arrayDePesquisa = "";
    vm.defineLegendasConsultasEstorias = ConsultasEstoriaFactory.setLegendasCoresConsultaEstoria();

    var dataAtual = ConsultasEstoriaFactory.setDataAtual();

    //endregion

    // Configurações Datatable region
    vm.dtOptions = ConsultasEstoriaFactory.setDtOptionsPadrao();
    vm.dtOptions.initComplete = function () {
      var api = this.api(),
        searchBox = angular.element("body").find("#pesquisar"),
        htmCollection = document.getElementsByClassName(
          "array-buttons-consultas-estorias"
        ),
        checkBoxUsuarioCorrente = angular
          .element("body")
          .find("#consulta-estoria-checkbox-concluidas-usuario-corrente"),
        elemento = [];
      vm.api = api;

      checkBoxUsuarioCorrente.click(function (event) {
        if (!vm.usuarioCorrenteTodasEstorias) {
          vm.api
            .column(7)
            .search(
              filtroFormatadoEstoriasNaoConcluidasColaborador,
              true,
              false
            )
            .draw();
        } else {
          vm.api
            .column(7)
            .search("")
            .draw();
        }
      });

      angular.forEach(htmCollection, function (key, value, array) {
        elemento.push(angular.element(key));

        elemento[value].click(function (event) {
          var arrayFormatado = arrayDePesquisa.toString().replace(/,/g, "|");
          vm.api
            .column(2)
            .search(arrayFormatado, true, false)
            .draw();
        });
      });

      // Bind an external input as a table wide search box
      if (searchBox.length > 0) {
        searchBox.on("keyup", function (event) {
          vm.api.search(event.target.value).draw();
        });
      }
    };

    vm.dtOptions.columnDefs = ConsultasEstoriaFactory.setColumnsDefsDtOptionsConsultaEstorias();
    vm.dtOptions.oLanguage = ConsultasEstoriaFactory.setLanguageConsultaEstorias();
    vm.dtColumns = [];
    //endregion

    // Definição dos Métodos region
    var metodosInternos = {
      filtrarEspecificamente: filtrarEspecificamente,
      filtrarGeral: filtrarGeral
    };
    vm.metodos = {
      filtrar: filtrar,
      resetarFiltros: resetarFiltros,
      novaConsulta: novaConsulta,
      abrirDialogInformativo: abrirDialogInformativo,
      abrirDialogAlterarDataEstoria: abrirDialogAlterarDataEstoria,
      filtrarTabela: filtrarTabela,
      sugestaoFiltroFiltrosConcluidos: sugestaoFiltroFiltrosConcluidos,
      sugestaoFiltroFiltrosNaoConcluidos: sugestaoFiltroFiltrosNaoConcluidos,
      abrirDialogEstoria: abrirDialogEstoria
    };
    //endregion

    // Implementação dos Métodos region

    // Métodos Internos region

    /**
     *
     * @param {filtro} filtro
     */
    function filtrarEspecificamente(filtro) {
      const parametros = angular.extend({
        squadCodigo: vm.squadCodigo,
      }, filtro);

      if (vm.prazoAcordado) {
        parametros.prazoAcordado = vm.prazoAcordado;
      }

      const modelos = Object.values(filtro).filter(function (valor) {
        return valor !== "";
      });

      let params = 'squadCodigo=' + encodeURIComponent(parametros.squadCodigo);

      var valorPrazoAcordado = parametros.prazoAcordado ? encodeURIComponent(parametros.prazoAcordado) : null;

      params += '&prazoAcordado=' + valorPrazoAcordado;

      modelos.forEach(function (modelo) {
        params += '&modelo=' + encodeURIComponent(modelo);
      });

      RequisicaoGenericaService.listarComArrayDeParams(
        Api.consultas.estoria.listarEstoriasEspecificas + '?' + params,
        {}
      ).then(
        function (success) {
          vm.requisicaoSolicitada = false;
          vm.estorias = success.data.map(function (estoria) {
            estoria.historiaOrdenacao = (estoria.ano * 1000000) + estoria.numero;
            return estoria;
          });
          ConsultasEstoriaService.verificarDiasRestantes(
            vm.estorias,
            estoriasVencidas,
            estoriasSeteDiasRestantes
          );
        },
        function (error) {
          MdDialogService.alertPadrao(error.data, event);
          vm.requisicaoSolicitada = false;
        }
      );
    }

    /**
     *
     * @param {rota} rota  rota da Api
     * @param {parametros} paramatro Parametros para serem passados como filtro
     */
    function filtrarGeral(rota, parametro) {
      const parametros = angular.extend({
        squadCodigo: vm.squadCodigo
      }, parametro);
      const queryParams = new URLSearchParams(parametros).toString();
      const urlComParametros = rota + '?' + queryParams;

      RequisicaoGenericaService.listarSemParams(urlComParametros).then(
        function (success) {
          vm.requisicaoSolicitada = false;
          vm.estorias = success.data.map(function (estoria) {
            estoria.historiaOrdenacao = (estoria.ano * 1000000) + estoria.numero;
            return estoria;
          });
          ConsultasEstoriaService.verificarDiasRestantes(
            vm.estorias,
            estoriasVencidas,
            estoriasSeteDiasRestantes
          );
        },
        function (error) {
          MdDialogService.alertPadrao(error.data, event);
          vm.requisicaoSolicitada = false;
        }
      );
    }


    //endregion

    // Métodos Geral region

    /**
     *
     * @param {filtro} filtro Filtro selecionado
     * @param {tipoFiltro} tipoFiltro Tipo de filtro a ser utilizado "Geral" ou "Específico"
     * @param {buttonEvent} event
     */
    function filtrar(filtro, tipoFiltro, event) {
      if (vm.squadUsuarioLogado.length === 1) vm.squadCodigo = vm.squadUsuarioLogado[0]
      vm.requisicaoSolicitada = true;
      vm.filtroAtivo = true;
      vm.squadCodigoUtilizado = SquadService.descricaoSquad(vm.squadCodigo);
      if (tipoFiltro.toLocaleLowerCase() === "geral") {
        switch (filtro.toLocaleLowerCase()) {
          case "em aberto":
            metodosInternos.filtrarGeral(
              Api.consultas.estoria.listarEstoriasEmAberto
            );
            break;
          case "em andamento":
            metodosInternos.filtrarGeral(
              Api.consultas.estoria.listarEstoriasEmAndamento
            );
            break;
          case "concluidas":
            metodosInternos.filtrarGeral(
              Api.consultas.estoria.listarEstoriasConcluidas
            );
            break;
          case "todas":
            metodosInternos.filtrarGeral(
              Api.consultas.estoria.listarTodasEstorias
            );
            break;
          default:
            metodosInternos.filtrarGeral(
              Api.consultas.estoria.listarEstoriasEmPausa
            );
            break;
        }
        vm.filtroUtilizado = filtro;
      } else {
        metodosInternos.filtrarEspecificamente(filtro);
        angular.forEach(vm.filtrosEspecificos, function (
          itemFiltroEspecifico,
          indexFiltroEspecifico
        ) {
          angular.forEach(filtro, function (itemFiltro, indexFiltro) {
            if (itemFiltroEspecifico.codigo == itemFiltro) {
              if (filtro.length - 1 === indexFiltro) {
                vm.filtroUtilizado += itemFiltroEspecifico.descricao;
              } else {
                vm.filtroUtilizado += itemFiltroEspecifico.descricao + ", ";
              }
            }
          });
        });
      }
    }

    /**
     *
     */
    function resetarFiltros() {
      vm.filtros = [];
      vm.filtroUtilizado = "";
      vm.squadCodigoUtilizado = "";
      vm.sugestaoFiltro.concluidas.selecionado = false;
      vm.sugestaoFiltro.naoConcluidas.selecionado = false;
    }

    /**
     *
     */
    function novaConsulta() {
      vm.pesquisar = "";
      vm.estorias = null;
      vm.filtroAtivo = false;
      vm.filtros = [];
      vm.squadCodigo = ToolbarService.squadSelecionado();
      vm.legendaSelecionada = null;
      vm.usuarioCorrenteTodasEstorias = true;
      estoriasVencidas = [];
      estoriasSeteDiasRestantes = [];
      resetarFiltros();
    }

    /**
     *
     * @param {buttonEvent} event
     */
    function abrirDialogInformativo(event) {
      $mdDialog.show({
        controller: "ConsultaEstoriasDialogInformativoController",
        controllerAs: "vm",
        templateUrl: vm.htmlRota.dialogInformativo,
        //parent: ---------------,
        targetEvent: event,
        clickOutsideToClose: false
      });
    }

    /**
     *
     * @param {index} index index da estória na tablea
     * @param {estoria} estoria estoria selecionada na tabela
     * @param {buttonEvent} event
     */
    function abrirDialogAlterarDataEstoria(index, estoria, event) {
      $mdDialog.show({
        controller: "ConsultaEstoriasDialogAlterarDataEstoriaController",
        controllerAs: "vm",
        templateUrl: vm.htmlRota.dialogAlterarDataEstoria,
        //parent: ---------------,
        targetEvent: event,
        clickOutsideToClose: false,
        locals: {
          Index: index,
          Estoria: estoria,
          EstoriasVencidas: estoriasVencidas,
          EstoriasSeteDiasRestantes: estoriasSeteDiasRestantes
        }
      });
    }

    /**
     *
     * @param {legenda} legenda legenda
     * @param {index} index  Index da tabela
     */
    function filtrarTabela(legenda, index) {
      vm.legenda = legenda;
      vm.index = index;
      if (vm.legendaSelecionada !== index) {
        vm.legendaSelecionada = index;
        arrayDePesquisa = ConsultasEstoriaService.defineArrayDePesquisa(
          legenda,
          estoriasVencidas,
          estoriasSeteDiasRestantes
        );
      } else {
        vm.legendaSelecionada = null;
        arrayDePesquisa = "";
      }
    }

    /**
     * Método chamado quando o checkbox de Concluídas é selecionado
     * @param {sugestaoFiltro} sugestaoFiltro Sugestão de filtros concluidos
     */
    function sugestaoFiltroFiltrosConcluidos(sugestaoFiltro) {
      ConsultasEstoriaService.sugestaoFiltro(
        sugestaoFiltro,
        vm.filtros
      );
    }

    /**
     * Método chamado quando checkbox de Não Concluídas é selecionado
     * @param {sugestaoFiltro} sugestaoFiltro  Sugestão de filtros não concluídas
     */
    function sugestaoFiltroFiltrosNaoConcluidos(sugestaoFiltro) {
      ConsultasEstoriaService.sugestaoFiltro(
        sugestaoFiltro,
        vm.filtros
      );
    }

    //endregion

    //endregion

    function abrirDialogEstoria(estoriaBacklog) {
      $state.goNewTab("app.planejamento_processamento_estoria", {
        parametros: {
          numero: estoriaBacklog.numero,
          ano: estoriaBacklog.ano,
          squadCodigo: estoriaBacklog.squadCodigo,
          chamarPesquisa: true
        }
      });

    }
  }
})();

/**
 * Created by nova on 18/07/2016.
 */
(function () {
    'use strict';

    angular
        .module('app.pipeline.cadastro.pipeline-funil', [])
        .config(config);

    function config($stateProvider, RotasHtml) {
        var rotasHtmlPipelineFunil = RotasHtml.pipeline_funil;
        $stateProvider
            .state('app.pipeline_cadastro_pipeline_funil', {
                url: '/pipeline/cadastro/pipeline-funil',
                module: 'privado',
                views: {
                    'content@app': {
                        templateUrl: rotasHtmlPipelineFunil.templateUrl,
                        controller: "PipelineFunilController as vm"
                    },
                    'pipeline-funil-form@app.pipeline_cadastro_pipeline_funil': {
                        templateUrl: rotasHtmlPipelineFunil.form
                    },
                    'pipeline-funil-tabela@app.pipeline_cadastro_pipeline_funil': {
                        templateUrl: rotasHtmlPipelineFunil.tabela
                    }
                },
                resolve: {
                    Etapas: function (Api, RequisicaoGenericaService) {
                        return RequisicaoGenericaService.listarSemParams(Api.pipeline.pipeline_etapa.listarTodasEtapas);
                    }
                }
            });
    }

})();

/**
 * Created by nova on 19/07/2016.
 */
(function () {
    'use strict';

    angular.module('app.pipeline.cadastro.pipeline-funil')
        .controller('PipelineFunilController', PipelineFunilController);

    function PipelineFunilController($filter, NavegacaoService, Api, PgToolbarService, RequisicaoGenericaService, DatatableFactory, ProximoCodigoService, MdDialogService,
        Etapas) {
        var vm = this;
        NavegacaoService.setTituloAba('Pipeline funil');

        //#region Data

        vm.rota = Api.pipeline.pipeline_funil.proximoCodigo;

        vm.etapas = Etapas.data;

        //#endregion

        //#region Definição dos Métodos region

        vm.metodosGeral = {
            preDefinirCamposParaInserir: preDefinirCamposParaInserir,
            configuraMdSelectEtapa: configuraMdSelectEtapa
        };

        vm.metodosPipelineFunil = {
            pesquisar: pesquisar,
            salvar: salvar,
            editar: editar,
            excluir: excluir,
            selecionar: selecionar,
            construirDtOptions: construirDtOptions
        };

        //#endregion

        //#region Implementação dos métodos 'MetodosGeral'

        /**
         * Método chamado quando é clicado no botão de inserir da toolbar, já pré definindo alguns campos
         */
        function preDefinirCamposParaInserir() {
            
            // Defini de forma automática o próximo código do feriado
            PgToolbarService.iniciarPreLoaderToolbar(vm.controleForm, vm.controlePreloader);
            ProximoCodigoService.proximoCodigo(Api.pipeline.pipeline_funil.proximoCodigo).then(
                function (success) {
                    vm.pipelineFunil = { codigo: success.data, ativo: true };
                    PgToolbarService.finalizarPreLoaderToolbar(vm.controleForm, vm.controlePreloader);
                },
                function (error) {
                    vm.pipelineFunil = { ativo: true };
                    PgToolbarService.finalizarPreLoaderToolbar(vm.controleForm, vm.controlePreloader);
                    MdDialogService.alertPadrao(error.data);
                });

                
        }

        /**
         * Método que irá configurar e limpar o filtro do md-header do md-select de etapa
         */
        function configuraMdSelectEtapa() {
            vm.filtrarEtapas = "";
            angular.element('#pipeline-funil-etapas-md-select').on('keydown', function (ev) {
                ev.stopPropagation();
            });
        }

        //#endregion        

        //#region Implementação dos Métodos 'Métodos'

        /**
         * Método para pesquisar uma lista de feriados
         */
        function pesquisar() {
            return RequisicaoGenericaService.listarComObjetoComplexo(Api.pipeline.pipeline_funil.listarComPaginacao, vm.entidadeDeEnvio);
        }

        function salvar(pipelineFunil) {
            return RequisicaoGenericaService.salvar(Api.pipeline.pipeline_funil.criar, pipelineFunil);
        }

        function editar(pipelineFunil) {
            return RequisicaoGenericaService.editar(Api.pipeline.pipeline_funil.atualizar, pipelineFunil)
        }

        function excluir(pipelineFunil) {
            return RequisicaoGenericaService.excluir(Api.pipeline.pipeline_funil.excluir, pipelineFunil.codigo)
        }

        function selecionar(posicaoEntidade) {
            vm.metodosExternosPgToolbar.metodoControladorExternoListarTodasEntidades(null, posicaoEntidade);
        }

        function construirDtOptions() {
            DatatableFactory.construirDtOptionsComPaginacaoProcessadoNoServidorParaToolbar
                (Api.pipeline.pipeline_funil.listarComPaginacaoDatatable, vm.entidadeDeEnvio.clsEntidade, '#datatable-pipeline-funil',
                    [
                        DatatableFactory.construirColunaDeSelecionarPadrao(function (indexLinha) { vm.metodosPipelineFunil.selecionar(indexLinha) }),
                        {
                            targets: 1,
                            name: "Codigo",
                            data: "codigo",
                            defaultContent: ""
                        },
                        DatatableFactory.construirColunaDeSelecionarPadrao(function (indexLinha) { vm.metodosPipelineFunil.selecionar(indexLinha) }),
                        {
                            targets: 2,
                            name: "Descricao",
                            data: "descricao",
                            defaultContent: ""
                        },
                    ]);
        }

        //#endregion

    }
})();

/**
 * Created by nova on 18/07/2016.
 */
(function () {
    'use strict';

    angular
        .module('app.pipeline.cadastro.pipeline-motivo-perda-negocio', [])
        .config(config);

    function config($stateProvider, RotasHtml) {
        var rotasHtmlPipelineMotivoPerdaNegocio = RotasHtml.pipeline_motivo_perda_negocio;
        $stateProvider
            .state('app.pipeline_cadastro_pipeline_motivo_perda_negocio', {
                url: '/pipeline/cadastro/pipeline-motivo-perda-negocio',
                module: 'privado',
                views: {
                    'content@app': {
                        templateUrl: rotasHtmlPipelineMotivoPerdaNegocio.templateUrl,
                        controller: "PipelineMotivoPerdaNegocioController as vm"
                    },
                    'pipeline-motivo-perda-negocio-form@app.pipeline_cadastro_pipeline_motivo_perda_negocio': {
                        templateUrl: rotasHtmlPipelineMotivoPerdaNegocio.form
                    },
                    'pipeline-motivo-perda-negocio-tabela@app.pipeline_cadastro_pipeline_motivo_perda_negocio': {
                        templateUrl: rotasHtmlPipelineMotivoPerdaNegocio.tabela
                    }
                }
            });
    }

})();

/**
 * Created by nova on 19/07/2016.
 */
(function () {
    'use strict';

    angular.module('app.pipeline.cadastro.pipeline-motivo-perda-negocio')
        .controller('PipelineMotivoPerdaNegocioController', PipelineMotivoPerdaNegocioController);

    function PipelineMotivoPerdaNegocioController($filter, NavegacaoService, Api, PgToolbarService, RequisicaoGenericaService, DatatableFactory, ProximoCodigoService, MdDialogService) {
        var vm = this;
        NavegacaoService.setTituloAba('Pipeline perda de negócio');

        //<editor-fold desc="Data">
        // Data region
        vm.pipeline_motivoperdanegocios = {};
        vm.pipeline_motivoperdanegocio = null;

        vm.rota = Api.pipeline.pipeline_motivoperdanegocio.proximoCodigo;
        // endregion
        //</editor-fold>

        vm.metodosGeral = {
            PreDefinirCamposParaInserir: PreDefinirCamposParaInserir
        };

        //<editor-fold desc="Definição dos Métodos">
        // Definição dos Métodos region
        vm.metodosPipelineMotivoPerdaNegocio = {
            pesquisar: pesquisar,
            salvar: salvar,
            editar: editar,
            excluir: excluir,
            selecionar: selecionar,
            construirDtOptions: construirDtOptions
        };
        //endregion
        //</editor-fold>

        /**
         * Método chamado quando é clicado no botão de inserir da toolbar, já pré definindo alguns campos
         */
        function PreDefinirCamposParaInserir() {

            // Defini de forma automática o próximo código do feriado
            PgToolbarService.iniciarPreLoaderToolbar(vm.controleForm, vm.controlePreloader);
            ProximoCodigoService.proximoCodigo(Api.pipeline.pipeline_motivoperdanegocio.proximoCodigo).then(
                function (success) {
                    vm.pipeline_motivoperdanegocio = { codigo: success.data };
                    PgToolbarService.finalizarPreLoaderToolbar(vm.controleForm, vm.controlePreloader);
                },
                function (error) {
                    PgToolbarService.finalizarPreLoaderToolbar(vm.controleForm, vm.controlePreloader);
                    MdDialogService.alertPadrao(error.data);
                });
        }

        //<editor-fold desc="Implementação dos Métodos">
        // Implementação dos Métodos region

        /**
         * Método para pesquisar uma lista de feriados
         */
        function pesquisar() {
            return RequisicaoGenericaService.listarComObjetoComplexo(Api.pipeline.pipeline_motivoperdanegocio.listarComPaginacao, vm.entidadeDeEnvio);
        }

        /**
         * 
         * @param {pipeline_motivo_perda_negocio} pipeline_motivo_perda_negocio
         */
        function salvar(pipeline_motivo_perda_negocio) {
            console.log(pipeline_motivo_perda_negocio);
            return RequisicaoGenericaService.salvar(Api.pipeline.pipeline_motivoperdanegocio.criar, pipeline_motivo_perda_negocio);
        }

        /**
         * 
         * @param {pipeline_motivo_perda_negocio} pipeline_motivo_perda_negocio
         */
        function editar(pipeline_motivo_perda_negocio) {
            return RequisicaoGenericaService.editar(Api.pipeline.pipeline_motivoperdanegocio.atualizar, pipeline_motivo_perda_negocio)
        }

        /**
         * 
         * @param {feriado} feriado 
         */
        function excluir(pipeline_motivo_perda_negocio) {
            return RequisicaoGenericaService.excluir(Api.pipeline.pipeline_motivoperdanegocio.excluir, pipeline_motivo_perda_negocio.codigo)
        }

        /**
         * Método utilizado no modo exibido tabela, para selecionar um feriado
         * @param {feriado} feriado 
         */
        function selecionar(posicaoEntidade) {
            vm.metodosExternosPgToolbar.metodoControladorExternoListarTodasEntidades(null, posicaoEntidade);
        }

        /**
         * Método para construi o DtOptions da tabela
         */
        function construirDtOptions() {
            DatatableFactory.construirDtOptionsComPaginacaoProcessadoNoServidorParaToolbar
                (Api.pipeline.pipeline_motivoperdanegocio.listarComPaginacaoDatatable, vm.entidadeDeEnvio.clsEntidade, '#datatable-pipeline-motivo-perda-negocio',
                [
                    DatatableFactory.construirColunaDeSelecionarPadrao(function (indexLinha) { vm.metodosPipelineMotivoPerdaNegocio.selecionar(indexLinha) }),
                    {
                        targets: 1,
                        name: "Codigo",
                        data: "codigo",
                        defaultContent: ""
                    },
                    DatatableFactory.construirColunaDeSelecionarPadrao(function (indexLinha) { vm.metodosPipelineMotivoPerdaNegocio.selecionar(indexLinha) }),
                    {
                        targets: 2,
                        name: "Descricao",
                        data: "descricao",
                        defaultContent: ""
                    },
                ]);
        }
        //endregion
        //</editor-fold>

    }
})();

(function () {
    'use strict';

    angular
        .module('app.pipeline.cadastro.pipeline-etapa', [])
        .config(config);

    function config($stateProvider, RotasHtml) {
        var rotasHtml = RotasHtml.pipeline_etapa;
        $stateProvider
            .state('app.pipeline_cadastro_pipeline_etapa', {
                url: '/pipeline/cadastro/pipeline-etapa',
                module: 'privado',
                views: {
                    'content@app': {
                        templateUrl: rotasHtml.templateUrl,
                        controller: "PipelineEtapaController as vm"
                    },
                    'pipeline-etapa-form@app.pipeline_cadastro_pipeline_etapa': {
                        templateUrl: rotasHtml.form
                    },
                    'pipeline-etapas-tabela@app.pipeline_cadastro_pipeline_etapa': {
                        templateUrl: rotasHtml.tabela
                    }
                }
            });
    }

})();

/**
 * Created by nova on 19/07/2016.
 */
(function () {
    'use strict';

    angular.module('app.pipeline.cadastro.pipeline-etapa')
        .controller('PipelineEtapaController', PipelineEtapaController);

    function PipelineEtapaController(Api, NavegacaoService, RequisicaoGenericaService, PgToolbarService, ProximoCodigoService, DatatableFactory, MdDialogService) {
        var vm = this;
        NavegacaoService.setTituloAba('Pipeline etapa');

        vm.form = {};

        //#region Data
        vm.metodosGeral = {
            preDefinirCamposParaInserir: preDefinirCamposParaInserir
        }
        vm.metodos = {
            pesquisar: pesquisar,
            salvar: salvar,
            editar: editar,
            excluir: excluir,
            selecionar: selecionar,
            construirDtOptions: construirDtOptions
        }
        //#endregion

        //#region Implementação dos Métodos 'Metodos Geral'

        /**
         * Método chamado quando é clicado no botão para inserir uma nova Etapa
         */
        function preDefinirCamposParaInserir() {
            PgToolbarService.iniciarPreLoaderToolbar(vm.controleForm, vm.controlePreloader);
            ProximoCodigoService.proximoCodigo(Api.pipeline.pipeline_etapa.proximoCodigo).then(
                function (success) {
                    vm.pipelineEtapa = {
                        codigo: success.data,
                        ativo: true
                    };
                    PgToolbarService.finalizarPreLoaderToolbar(vm.controleForm, vm.controlePreloader);
                },
                function (error) {
                    PgToolbarService.finalizarPreLoaderToolbar(vm.controleForm, vm.controlePreloader);
                    MdDialogService.alertPadrao(error.data);
                });
        }

        //#endregion

        //#region Implementação dos Métodos  'Metodos'

        function pesquisar() {
            return RequisicaoGenericaService.listarComObjetoComplexo(Api.pipeline.pipeline_etapa.listarComPaginacao, vm.entidadeDeEnvio);
        }

        function salvar(modelo) {
            return RequisicaoGenericaService.salvar(Api.pipeline.pipeline_etapa.criar, modelo);
        }

        function editar(modelo) {
            return RequisicaoGenericaService.editar(Api.pipeline.pipeline_etapa.atualizar, modelo)
        }

        function excluir(modelo) {
            return RequisicaoGenericaService.excluir(Api.pipeline.pipeline_etapa.excluir, modelo.codigo)
        }

        function selecionar(posicaoEntidade) {
            vm.metodosExternosPgToolbar.metodoControladorExternoListarTodasEntidades(null, posicaoEntidade);
        }

        function construirDtOptions() {
            DatatableFactory.construirDtOptionsComPaginacaoProcessadoNoServidorParaToolbar
                (Api.pipeline.pipeline_etapa.listarComPaginacaoDatatable, vm.entidadeDeEnvio.clsEntidade, '#datatable-pipeline-etapas',
                    [

                        DatatableFactory.construirColunaDeSelecionarPadrao(function (indexLinha) { vm.metodos.selecionar(indexLinha) }),
                        {
                            targets: 1,
                            name: "Codigo",
                            data: "codigo",
                            defaultContent: ""
                        },
                        {
                            targets: 2,
                            name: "Descricao",
                            data: "descricao",
                            defaultContent: ""
                        },
                        {
                            targets: 3,
                            name: "Nivel",
                            data: "nivel",
                            defaultContent: ""
                        },
                        {
                            targets: 4,
                            name: "Periodo",
                            data: "periodo",
                            defaultContent: ""
                        },
                        {
                            targets: 5,
                            name: "ProbabilidadeFechamento",
                            data: "probabilidadeFechamento",
                            render: function (data) {
                                return data + "%"
                            },
                            defaultContent: ""
                        },
                        {
                            targets: 6,
                            name: "LimiteDiasSemContato",
                            data: "limiteDiasSemContato",
                            defaultContent: ""
                        },
                        {
                            targets: 7,
                            name: "DiasAlertaVencimento",
                            data: "diasAlertaVencimento",
                            defaultContent: ""
                        },
                    ]);
        }

        //#endregion

    }
})();

(function () {
    "use strict";

    angular
        .module('app.pipeline.consulta.estatistica')
        .controller('PipelineConsultaEstatisticaController', PipelineConsultaEstatisticaController);

    function PipelineConsultaEstatisticaController(
        $mdSidenav,
        ListarFunisAtivos,
        NavegacaoService,
        RequisicaoGenericaService,
        Api,
        MdDialogService,
        RotasHtml,
        ListarUsuariosSetorComercial,
        ListarProdutosPorFunil) {
        var vm = this;
        var rotasHtml = RotasHtml.pipeline_consulta.estatistica;
        NavegacaoService.setTituloAba('Pipeline estatísticas');

        //region Init
        Init();

        function Init() {

            vm.requisicaoSolicitada = false;
            vm.carregandoProdutos = false;
            vm.mensagemPreloader = "";

            vm.form = {};
            vm.dataAtual = new Date();

            vm.EnumPeriodo = {
                EsteMes: "EsteMes",
                EstaSemana: "EstaSemana",
                SemanaPassada: "SemanaPassada",
                EsteAno: "EsteAno",
                Customizado: "Customizado"
            };

            vm.periodos = [{
                id: vm.EnumPeriodo.EsteMes,
                descricao: "Este mês"
            }, {
                id: vm.EnumPeriodo.EstaSemana,
                descricao: "Esta semana"
            }, {
                id: vm.EnumPeriodo.SemanaPassada,
                descricao: "Semana passada"
            }, {
                id: vm.EnumPeriodo.EsteAno,
                descricao: "Este ano"
            }, {
                id: vm.EnumPeriodo.Customizado,
                descricao: "Customizado"
            }];
            vm.funis = ListarFunisAtivos.data;
            vm.usuarios = ListarUsuariosSetorComercial.data;
            vm.produtos = ListarProdutosPorFunil.data;
            vm.filtroEstatisticas = {
                codigoFunil: vm.funis[0].codigo,
                periodo: vm.periodos[0].id,
                dataInicial: undefined,
                dataFinal: undefined,
                produtosFiltros: []
            };

            vm.dados = {
                negociosNoPeriodo: {
                    quantidade: 0,
                    valorTotal: 0,
                    totalOutrosValores: 0
                },
                negociosEmAndamento: {
                    quantidade: 0,
                    valorTotal: 0,
                    totalOutrosValores: 0
                },
                negociosGanhos: {
                    quantidade: 0,
                    valorTotal: 0,
                    totalOutrosValores: 0
                },
                negociosPerdidos: {
                    quantidade: 0,
                    valorTotal: 0,
                    totalOutrosValores: 0
                },
                dadosGraficoGanhosPerdidosGanhos: {
                    key: "Negócios Ganhos",
                    color: "#4CAF50",
                    values: []
                },
                dadosGraficoGanhosPerdidosPerdidos: {
                    key: "Negócios Perdidos",
                    color: "#F44336",
                    values: []
                },
                dadosGraficoMotivosPerda: []
            };

            vm.toggleRight = function () {
                $mdSidenav('right').toggle()
            };

            InitGraficoNegociosGanhosPerdidos();
            InitGraficoMotivosPerda();
            filtrarDados();
        }

        function InitGraficoNegociosGanhosPerdidos() {
            vm.graficoGanhosPerdidos = {
                options: {
                    chart: {
                        type: "multiBarChart",
                        x: function (d) {
                            return d.legenda;
                        },
                        y: function (d) {
                            return d.quantidade;
                        },
                        showControls: false,
                        showValues: true,
                        stacked: false,
                        staggerLabels: true,
                        transitionDuration: 500,
                        reduceXTicks: false,
                        xAxis: {
                            showMaxMin: false,
                            axisLabel: "",
                            axisLabelDistance: 0,
                            tickFormat: function (d) {
                                return d;
                            }
                        },
                        yAxis: {
                            axisLabel: "Quantidade",
                            axisLabelDistance: -15,
                            tickFormat: function (d) {
                                return d;
                            }
                        },
                        noData: "Não existem dados a serem exibidos",
                        legend: {
                            rightAlign: false
                        },
                        tooltip: {
                            gravity: "s",
                            classes: "gravity-s"
                        }
                    }
                },
                data: [vm.dados.dadosGraficoGanhosPerdidosGanhos, vm.dados.dadosGraficoGanhosPerdidosPerdidos]
            };
        }

        function InitGraficoMotivosPerda() {
            vm.graficoMotivosPerda = {
                options: {
                    chart: {
                        type: "pieChart",
                        height: 400,
                        margin: {
                            top: 0,
                            right: 0,
                            bottom: 0,
                            left: 0
                        },
                        donut: false,
                        clipEdge: true,
                        cornerRadius: 0,
                        labelType: "percent",
                        padAngle: 0.02,
                        x: function (d) {
                            return d.motivoPerda;
                        },
                        y: function (d) {
                            return d.quantidade;
                        },
                        tooltip: {
                            gravity: "s",
                            classes: "gravity-s"
                        },
                        legend: {
                            maxKeyLength: 100
                        },
                        noData: "Não existem dados a serem exibidos",
                    }
                },
                data: vm.dados.dadosGraficoMotivosPerda
            };
        }

        vm.metodos = {
            filtrarDados: filtrarDados,
            listarNegociosDoPeriodo: listarNegociosDoPeriodo,
            listarNegociosEmAndamento: listarNegociosEmAndamento,
            listarNegociosGanhos: listarNegociosGanhos,
            listarNegociosPerdidos: listarNegociosPerdidos,
            retornaConversao: retornaConversao,
            carregarProdutosPorFunil: carregarProdutosPorFunil
        }

        function carregarProdutosPorFunil() {
            vm.filtroEstatisticas.produtosFiltros = [];
            vm.carregandoProdutos = true;
            RequisicaoGenericaService.listarSemParams(
                Api.produto.listarProdutosPorFunil + vm.filtroEstatisticas.codigoFunil).then(
                    function (success) {
                        vm.produtos = success.data;
                        vm.carregandoProdutos = false;
                    },
                    function (error) {
                        vm.carregandoProdutos = false;
                        MdDialogService.alertPadrao(error.data);
                    });
        }

        function filtrarDados(event) {
            vm.requisicaoSolicitada = true;
            vm.mensagemPreloader = "Carregando dados...";
            $mdSidenav('right').toggle();

            var filtro = {
                codigoFunil: vm.filtroEstatisticas.codigoFunil,
                periodo: vm.filtroEstatisticas.periodo,
                dataInicial: vm.filtroEstatisticas.dataInicial,
                dataFinal: vm.filtroEstatisticas.dataFinal,
                codigoExecutivoDeContas: vm.filtroEstatisticas.codigoExecutivoDeContas,
                produtos: vm.filtroEstatisticas.produtosFiltros.map(function (p) { return p.codigo; })
            };

            RequisicaoGenericaService.salvar(
                Api.pipeline.pipeline_estatisticas.retornarEstatisticas, filtro).then(
                    function (success) {
                        vm.requisicaoSolicitada = false;
                        vm.mensagemPreloader = "";
                        atualizarDados(success.data)
                    },
                    function (error) {
                        MdDialogService.alertPadrao(error.data);
                        vm.requisicaoSolicitada = false;
                        vm.mensagemPreloader = "";
                    });
        }

        function listarNegociosDoPeriodo(event) {
            var valorTotal = vm.dados.negociosNoPeriodo.valorTotal;
            var totalOutrosValores = vm.dados.negociosNoPeriodo.totalOutrosValores;
            if (vm.dados.negociosNoPeriodo.quantidade > 0) {
                abrirDialogDetalhamentoNegocios(Api.pipeline.pipeline_estatisticas.listaNegociosDoPeriodo,
                    "Negócios", event, true, valorTotal, totalOutrosValores);
            }
        }

        function listarNegociosEmAndamento(event) {
            var valorTotal = vm.dados.negociosEmAndamento.valorTotal;
            var totalOutrosValores = vm.dados.negociosEmAndamento.totalOutrosValores;
            if (vm.dados.negociosEmAndamento.quantidade > 0) {
                abrirDialogDetalhamentoNegocios(Api.pipeline.pipeline_estatisticas.listaNegociosEmAndamento,
                    "Negócios em andamento", event, true, valorTotal, totalOutrosValores);
            }
        }

        function listarNegociosGanhos(event) {
            var valorTotal = vm.dados.negociosGanhos.valorTotal;
            var totalOutrosValores = vm.dados.negociosGanhos.totalOutrosValores;
            if (vm.dados.negociosGanhos.quantidade > 0) {
                abrirDialogDetalhamentoNegocios(Api.pipeline.pipeline_estatisticas.listaNegociosGanhos,
                    "Negócios ganhos", event, false, valorTotal, totalOutrosValores);
            }
        }

        function listarNegociosPerdidos(event) {
            var valorTotal = vm.dados.negociosPerdidos.valorTotal;
            var totalOutrosValores = vm.dados.negociosPerdidos.totalOutrosValores;
            if (vm.dados.negociosPerdidos.quantidade > 0) {
                abrirDialogDetalhamentoNegocios(Api.pipeline.pipeline_estatisticas.listaNegociosPerdidos,
                    "Negócios perdidos", event, false, valorTotal, totalOutrosValores);
            }
        }

        function abrirDialogDetalhamentoNegocios(rota, titulo, event, permiteEdicao, valorTotal, totalOutrosValores) {
            var parametros =
            {
                filtroCard: vm.filtroCard,
                rota: rota,
                titulo: titulo,
                event: event,
                permiteEdicao: permiteEdicao,
                valorTotal: valorTotal,
                totalOutrosValores: totalOutrosValores
            }
            MdDialogService.abrirDialogPadrao(event, 'DetalhamentoNegociosDialogController',
                rotasHtml.dialogs.dialogListaNegocios, parametros);
        }

        function atualizarDados(data) {
            vm.dados = data;
            if (!vm.dados.dadosGraficoGanhosPerdidosGanhos.values)
                vm.dados.dadosGraficoGanhosPerdidosGanhos.values = [];

            if (!vm.dados.dadosGraficoGanhosPerdidosPerdidos.values)
                vm.dados.dadosGraficoGanhosPerdidosPerdidos.values = [];

            vm.graficoGanhosPerdidos.data = [vm.dados.dadosGraficoGanhosPerdidosGanhos,
            vm.dados.dadosGraficoGanhosPerdidosPerdidos];
            vm.graficoMotivosPerda.data = vm.dados.dadosGraficoMotivosPerda;
            vm.filtroCard = angular.copy(vm.filtroEstatisticas);
            vm.filtroCard.produtos = vm.filtroEstatisticas.produtosFiltros.map(function (p) { return p.codigo; });
            delete vm.filtroCard.produtosFiltros;
        }

        function retornaConversao(quantidadeConvertida, quantidadeComparada) {
            var valorCalculado = ((quantidadeConvertida / (quantidadeConvertida + quantidadeComparada)) * 100);

            return (Number.isNaN(valorCalculado) ? (0).toFixed(2) : (valorCalculado).toFixed(2)).replace(".", ",");
        }

    }
})();

(function () {
    'use strict';

    angular
        .module('app.pesquisa.cadastro.tipo-pesquisa', [])
        .config(config);

    function config($stateProvider, RotasHtml) {
        var rotasHtmlTipoPesquisa = RotasHtml.pesquisa.tipoPesquisa;
        $stateProvider
            .state('app.pesquisa_cadastro_tipo_pesquisa', {
                url: '/pesquisa/cadastro/tipo_pesquisa',
                module: 'privado',
                views: {
                    'content@app': {
                        templateUrl: rotasHtmlTipoPesquisa.templateUrl,
                        controller: 'TipoPesquisaController as vm'
                    },
                    'tipo-pesquisa-form@app.pesquisa_cadastro_tipo_pesquisa': {
                        templateUrl: rotasHtmlTipoPesquisa.form
                    },
                    'tipo-pesquisa-table@app.pesquisa_cadastro_tipo_pesquisa': {
                        templateUrl: rotasHtmlTipoPesquisa.tabela
                    }
                }
            });
    }

}());
(function () {
    'use strict';

    angular
        .module('app.pesquisa.cadastro.tipo-pesquisa')
        .controller('TipoPesquisaController', TipoPesquisaController)

    /** @ngInject */
    function TipoPesquisaController(RequisicaoGenericaService, Api, NavegacaoService, DatatableFactory) {
        var vm = this;
        NavegacaoService.setTituloAba('Tipo de pesquisa');

        vm.tipoPesquisa = {};

        vm.metodos = {
            criar: criar,
            excluir: excluir,
            atualizar: atualizar,
            pesquisar: pesquisar,
            construirDtOptions: construirDtOptions,
            selecionar: selecionar
        }


        function criar() {
            return RequisicaoGenericaService.salvar(Api.pesquisa.tipoPesquisa.criar, vm.tipoPesquisa);
        }

        function excluir() {
            return RequisicaoGenericaService.excluir(Api.pesquisa.tipoPesquisa.excluir, vm.tipoPesquisa.codigo);
        }

        function atualizar() {
            return RequisicaoGenericaService.editar(Api.pesquisa.tipoPesquisa.atualizar, vm.tipoPesquisa);
        }

        function pesquisar() {
            return RequisicaoGenericaService.listarComObjetoComplexo(Api.pesquisa.tipoPesquisa.listarComPaginacao, vm.entidadeDeEnvio);
        }

        function selecionar(posicaoEntidade) {
            vm.metodosExternosPgToolbar.metodoControladorExternoListarTodasEntidades(null, posicaoEntidade);
        }

        function construirDtOptions() {
            DatatableFactory.construirDtOptionsComPaginacaoProcessadoNoServidorParaToolbar
                (Api.pesquisa.tipoPesquisa.listarComPaginacaoDatatable, vm.entidadeDeEnvio.clsEntidade, '#datatable-tipo-pesquisa',
                    [
                        DatatableFactory.construirColunaDeSelecionarPadrao(function (indexLinha) { vm.metodos.selecionar(indexLinha) }),
                        {
                            targets: 1,
                            name: "Codigo",
                            data: "codigo",
                            sortable: true
                        },
                        {
                            targets: 2,
                            name: "Descricao",
                            data: "descricao",
                            sortable: true
                        },
                    ]);
        }
    }

}());
(function () {
    "use strict";

    angular
        .module('app.pipeline.consulta.projecoes')
        .controller('PipelineConsultaProjecoesController', PipelineConsultaProjecoesController);

    function PipelineConsultaProjecoesController(
        $scope,
        $mdSidenav,
        NavegacaoService,
        RequisicaoGenericaService,
        MdDialogService,
        Api,
        ListarFunisAtivos,
        RotasHtml,
        ListarUsuariosSetorComercial
    ) {
        var vm = this;
        NavegacaoService.setTituloAba('Pipeline projeções');
        vm.form = {};
        vm.rotasHtml = RotasHtml.pipeline_consulta.projecoes;

        $(document).ready(function () {
            $('#pipeline-consulta-projecoes-negocios').on('click', function (event) {
                if (!vm.dados) {
                    $mdSidenav('sidenav').open();
                }
            });

            $('.sidenav').on('click', function (event) {
                event.stopPropagation();
            });

        });

        vm.alternaVisibilidadeSidnav = function () {
            $mdSidenav('sidenav').toggle()
        };

        vm.metodosInternos = {
            atualizarDados: atualizarDados,
            inicializarGraficoProjecoes: inicializarGraficoProjecoes
        };
        vm.metodos = {
            filtrarDados: filtrarDados,
            abrirDialogProjecoesEtapa: abrirDialogProjecoesEtapa,
            abrirDialogProjecoesNegocios: abrirDialogProjecoesNegocios,
            changeFunil: changeFunil
        };

        init();

        function init() {
            vm.requisicaoSolicitada = false;
            vm.mensagemPreloader = "";

            vm.exibirDetalhamentoProjecoes = null;

            vm.dataAtual = new Date();

            vm.todosUsuarios = true;

            vm.funis = ListarFunisAtivos.data;

            vm.usuarios = ListarUsuariosSetorComercial.data;

            vm.EnumPeriodo = {
                EsteMes: "EsteMes",
                EsteTrismestre: "EsteTrismestre",
                EsteSemestre: "EsteSemestre",
                EsteAno: "EsteAno",
                Customizado: "Customizado"
            };

            vm.periodos = [
                {
                    id: vm.EnumPeriodo.EsteMes,
                    descricao: "Este mês"
                },
                {
                    id: vm.EnumPeriodo.EsteTrismestre,
                    descricao: "Este trimestre"
                },
                {
                    id: vm.EnumPeriodo.EsteSemestre,
                    descricao: "Este semestre"
                },
                {
                    id: vm.EnumPeriodo.EsteAno,
                    descricao: "Este ano"
                },
                {
                    id: vm.EnumPeriodo.Customizado,
                    descricao: "Customizado"
                }];

            vm.filtrosProjecoes = {
                codigoFunil: vm.funis[0].codigo,
                produtos: [],
                etapaNivel: undefined,
                periodo: vm.periodos[4].id,
                dataInicial: undefined,
                dataFinal: undefined,
                tipoPesquisa: 1
            };

            vm.produtosVinculados = vm.funis[0].produtos;
        }

        function atualizarDados(dados) {
            vm.dados = dados;
            if (vm.dados && vm.dados.dadosGraficoProjecaoViewModel)
                inicializarGraficoProjecoes(vm.dados.dadosGraficoProjecaoViewModel.values);
        }

        function inicializarGraficoProjecoes(data) {
            if (vm.filtrosProjecoes.tipoPesquisa == 2) {
                setTimeout(function () {
                    var chart = AmCharts.makeChart("chartdiv-pipeline-projecoes-finalizacao-etapa", {
                        "type": "funnel",
                        "theme": "light",
                        "pullDistance": 0,
                        "responsive": {
                            "enabled": true
                        },
                        "dataProvider": data,
                        "balloon": {
                            "fixedPosition": true
                        },
                        "valueField": "value",
                        "titleField": "title",
                        "marginRight": 240,
                        "marginLeft": 50,
                        "startX": -500,
                        "depth3D": 100,
                        "angle": 40,
                        "outlineAlpha": 1,
                        "outlineColor": "#FFFFFF",
                        "outlineThickness": 2,
                        "labelPosition": "right",
                        "balloonText": "[[title]]\nQuantidade de negócios: [[value]]",
                        "clickSlice": function (dataItem, event, chart) {
                            abrirDialogProjecoesNegocios(dataItem.title);
                        }
                    });
                }, 150);
            }
            else {
                setTimeout(function () {
                    var chart = AmCharts.makeChart("chartdiv-pipeline-projecoes-fechamento-comercial", {
                        "type": "funnel",
                        "theme": "light",
                        "pullDistance": 0,
                        "responsive": {
                            "enabled": true
                        },
                        "dataProvider": data,
                        "balloon": {
                            "fixedPosition": true
                        },
                        "valueField": "value",
                        "titleField": "title",
                        "marginRight": 240,
                        "marginLeft": 50,
                        "startX": -500,
                        "depth3D": 100,
                        "angle": 40,
                        "outlineAlpha": 1,
                        "outlineColor": "#FFFFFF",
                        "outlineThickness": 2,
                        "labelPosition": "right",
                        "balloonText": "[[title]]\nQuantidade de negócios: [[value]]",
                        "clickSlice": function (dataItem, event, chart) {
                            abrirDialogProjecoesNegocios(dataItem.title);
                        }
                    });
                }, 150);
            }
        }

        function filtrarDados(event, modelo) {
            vm.requisicaoSolicitada = true;
            vm.mensagemPreloader = "Carregando dados...";
            vm.modelFiltro = {
                codigoFunil: modelo.codigoFunil,
                codigosProduto: [],
                codigoUsuarios: [],
                periodo: modelo.periodo,
                dataInicial: modelo.dataInicial,
                dataFinal: modelo.dataFinal,
                tipoPesquisa: modelo.tipoPesquisa
            };

            if (modelo.produtos) {
                modelo.produtos.forEach(function (produto) {
                    vm.modelFiltro.codigosProduto.push(produto.codigo);
                });
            }

            if (modelo.usuarios) {
                modelo.usuarios.forEach(function (usuario) {
                    vm.modelFiltro.codigoUsuarios.push(usuario.codigo);
                });

            }

            RequisicaoGenericaService.listarComParams(
                Api.pipeline.pipeline_projecoes.consultar, vm.modelFiltro).then(
                    function (success) {
                        vm.requisicaoSolicitada = false;
                        vm.mensagemPreloader = "";
                        atualizarDados(success.data);
                        $mdSidenav('sidenav').toggle();

                        if (vm.filtrosProjecoes.tipoPesquisa == 1)
                            vm.exibirDetalhamentoProjecoes = 1;
                        else if (vm.filtrosProjecoes.tipoPesquisa == 2)
                            vm.exibirDetalhamentoProjecoes = 2;
                    },
                    function (error) {
                        MdDialogService.alertPadrao(error.data);
                        vm.requisicaoSolicitada = false;
                        vm.mensagemPreloader = "";
                    });
        }

        function abrirDialogProjecoesEtapa() {
            vm.filtrosProjecoes.codigosProduto = vm.modelFiltro.codigosProduto;
            vm.filtrosProjecoes.codigoUsuarios = vm.modelFiltro.codigoUsuarios;

            var parametros = [vm.dados.dadosProjecoes, vm.filtrosProjecoes];
            MdDialogService.abrirDialogPadrao(event, 'DetalhamentoProjecoesEtapaController',
                vm.rotasHtml.dialogs.dialogDetalhamentoProjecoesEtapa, parametros);
        }

        function abrirDialogProjecoesNegocios(etapaAtual) {
            var modelo = {
                codigoFunil: vm.filtrosProjecoes.codigoFunil,
                codigoUsuarios: vm.modelFiltro.codigoUsuarios,
                codigosProduto: vm.modelFiltro.codigosProduto,
                periodo: vm.modelFiltro.periodo,
                dataInicial: vm.modelFiltro.dataInicial,
                dataFinal: vm.modelFiltro.dataFinal,
                tipoPesquisa: vm.filtrosProjecoes.tipoPesquisa
            }
            modelo.etapaNivel = etapaAtual.substring(0, 1);

            var rota;

            if (modelo.tipoPesquisa == 1) {
                modelo.titulo = "Detalhamento Projeções Fechamento Comercial ( " + etapaAtual + " )";
                rota = Api.pipeline.pipeline_projecoes.detalhamentoProjecoesFechamentoComercial;
            } else {
                modelo.titulo = "Detalhamento Projeções Finalização Etapa ( " + etapaAtual + " )";
                rota = Api.pipeline.pipeline_projecoes.detalhamentoProjecoesFinalizacaoEtapa;
            }

            var parametros = [modelo, rota];
            MdDialogService.abrirDialogPadrao(event, 'DetalhamentoProjecoesNegociosController',
                vm.rotasHtml.dialogs.dialogDetalhamentoProjecoesNegocios, parametros);
        }

        function changeFunil(codigoFunil) {
            var funilEncontrado = vm.funis.find(function (funil) {
                return funil.codigo == codigoFunil;
            });

            if (funilEncontrado) {
                vm.produtosVinculados = funilEncontrado.produtos;
            }
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.pesquisa.processamento.pesquisa')
        .controller('PesquisaController', PesquisaController)

    /** @ngInject */
    function PesquisaController(
        $mdDialog,
        $scope,
        $state,
        Api,
        DataTableConfigPadrao,
        DatatableFactory,
        ListarProdutosAtivos,
        ListarTodosProdutos,
        ListarTiposPequisa,
        MdDialogService,
        MdToastService,
        NavegacaoService,
        PgToolbarService,
        RequisicaoGenericaService,
        RotasHtml
    ) {
        var vm = this;
        NavegacaoService.setTituloAba('Pesquisa');

        vm.campoClienteObrigatorio = false;
        vm.clienteRespostas = [];
        vm.controleForm = {};
        vm.controleForm.editarAtivo = false;
        vm.controleForm.inserirAtivo = false;
        vm.dtOptions = angular.copy(DataTableConfigPadrao.dtOptionsPadraoComPaginacaoEReponsivo);
        vm.dtOptions.columnDefs = [DataTableConfigPadrao.columnDefsPadrao];
        vm.emProgresso = false;
        vm.htmlRota = RotasHtml.pesquisa.pesquisa;
        vm.mediaGeralRespostas = [];
        vm.exibirGrafico = false;
        vm.pesquisa = {};
        vm.pesquisa.clientes = [];
        vm.produtos = ListarProdutosAtivos.data;
        vm.tabSelecionada = 'pesquisa';
        vm.textoDePesquisaAutoCompleteCliente = "";
        vm.tiposPesquisa = ListarTiposPequisa.data;

        vm.metodos = {
            abrirDialogPerguntas: abrirDialogPerguntas,
            alterarItemSelecionadoAutoCompleteCliente: alterarItemSelecionadoAutoCompleteCliente,
            aoPaginarConcluido: aoPaginarConcluido,
            aoPesquisarConcluido: aoPesquisarConcluido,
            calcularPorcentagem: calcularPorcentagem,
            changeProduto: changeProduto,
            configuraAutoCompleteClienteOnBlur: configuraAutoCompleteClienteOnBlur,
            construirDtOptions: construirDtOptions,
            definirCamposClonados: definirCamposClonados,
            desvincularCliente: desvincularCliente,
            editar: editar,
            excluir: excluir,
            excluirPergunta: excluirPergunta,
            novaPesquisa: novaPesquisa,
            pesquisar: pesquisar,
            pesquisarAutoCompleteCliente: pesquisarAutoCompleteCliente,
            preDefinirInserir: preDefinirInserir,
            salvar: salvar,
            selecionar: selecionar,
            tabSelecionada: tabSelecionada,
            visualizarCliente: visualizarCliente,
            visualizarRepostas: visualizarRepostas,
            vincularCliente: vincularCliente,
            desabilitaBotaoClonar: desabilitaBotaoClonar
        };


        $scope.$watch(
            "vm.pesquisa.clientes",
            function (newValue, oldValue) {
                vm.campoClienteObrigatorio = (vm.controleForm.inserirAtivo || vm.controleForm.editarAtivo) &&
                    (!newValue || newValue.length === 0);

                if (vm.campoClienteObrigatorio) {
                    vm.form.$setDirty();
                    vm.form.$setValidity('cliente', false);
                } else {
                    vm.form.$setValidity('cliente', true);
                }
            },
            true
        );

        function novaPesquisa() {
            vm.tabSelecionada = 'pesquisa';
            vm.clienteRespostas = [];
            vm.mediaGeralRespostas = [];
            vm.exibirGrafico = false;
        }

        function tabSelecionada(tab) {
            if (tab === 'respostas') {
                _listarRespostasClientes();
            } else {
                vm.tabSelecionada = tab;
            }
        }

        function pesquisar() {
            vm.emProgresso = true;
            vm.tabSelecionada = 'pesquisa';
            vm.clienteRespostas = [];
            vm.mediaGeralRespostas = [];
            vm.exibirGrafico = false;
            return RequisicaoGenericaService.listarComObjetoComplexo(Api.pesquisa.pesquisa.listarComPaginacao, vm.entidadeDeEnvio);
        }

        function aoPesquisarConcluido() {
            vm.emProgresso = false;
        }

        function aoPaginarConcluido() {
            vm.emProgresso = false;
        }

        function salvar(pesquisa) {
            pesquisa.clientes = vm.pesquisa.clientes;
            var pesquisaEnvio = angular.copy(pesquisa);
            delete pesquisaEnvio.cliente;
            delete pesquisaEnvio.clienteCodigo;
            return RequisicaoGenericaService.salvar(Api.pesquisa.pesquisa.criar, pesquisaEnvio);
        }

        function editar(pesquisa) {
            pesquisa.clientes = vm.pesquisa.clientes;
            var pesquisaEnvio = angular.copy(pesquisa);
            delete pesquisaEnvio.cliente;
            delete pesquisaEnvio.clienteCodigo;
            return RequisicaoGenericaService.editar(Api.pesquisa.pesquisa.atualizar, pesquisaEnvio);
        }

        function excluir(pesquisa) {
            return RequisicaoGenericaService.excluir(Api.pesquisa.pesquisa.excluir, pesquisa.codigo);
        }

        function preDefinirInserir() {
            vm.pesquisa = {
                ativa: true,
                perguntas: []
            };
        }

        function pesquisarAutoCompleteCliente(query) {
            return _pesquisarAutoComplete(Api.cliente.ListarCodigoDescricaoAtivosContratuaisProduto, query);
        }

        function alterarItemSelecionadoAutoCompleteCliente(item) {
            if (item) {
                vm.pesquisa.cliente = item;
                vm.pesquisa.clienteCodigo = item.codigo;
            } else {
                vm.textoDePesquisaAutoCompleteCliente = "";
                vm.pesquisa.clienteCodigo = null;
                vm.pesquisa.cliente = null;
            }
        }

        function vincularCliente(clienteSelecionado) {
            if (!clienteSelecionado) return;
            if (!vm.pesquisa.clientes) {
                vm.pesquisa.clientes = [];
            }

            var jaVinculado = vm.pesquisa.clientes.some(function (cliente) {
                return cliente.codigo === clienteSelecionado.codigo;
            });

            if (!jaVinculado) {
                vm.pesquisa.clientes.push({
                    codigo: clienteSelecionado.codigo,
                    nome: clienteSelecionado.nome
                });
                vm.pesquisa.cliente = null;
                vm.textoDePesquisaAutoCompleteCliente = "";
                MdToastService.toastPadrao(
                    "Cliente" +
                    " " +
                    clienteSelecionado.nome +
                    " " +
                    "vinculado com sucesso."
                );
            } else {
                MdDialogService.alertPadrao(
                    "Atenção!",
                    _limparCampoCliente(),
                    "O cliente" +
                    " " +
                    clienteSelecionado.nome +
                    " " +
                    "já está vinculado a pesquisa."
                );
            }
        }

        function desvincularCliente(clienteSelecionado, index) {
            if (!clienteSelecionado) return;
            MdDialogService.confirmPadraoComEvento(
                "Atenção!",
                "Deseja realmente remover o cliente" +
                " " +
                clienteSelecionado.nome +
                "?",
                null,
                function () {
                    vm.pesquisa.clientes.splice(index, 1);
                    vm.form.cliente.$setDirty();
                },
                function () {
                    $mdDialog.hide();
                }
            );
        }

        function visualizarCliente(clienteSelecionado) {
            $state.goNewTab("app.geral_cadastro_cliente_cliente", {
                parametros: {
                    cliente: {
                        codigo: clienteSelecionado.codigo,
                        nome: clienteSelecionado.nome,
                    },
                },
            });
        }

        function calcularPorcentagem() {
            var total = vm.clienteRespostas.length;
            if (!total) return 0;
            var respondidos = vm.clienteRespostas.filter(function (c) { return c.respondido; }).length;
            return Math.floor((respondidos / total) * 100);
        };

        function configuraAutoCompleteClienteOnBlur() {
            if (!vm.pesquisa.cliente) {
                vm.textoDePesquisaAutoCompleteCliente = "";
            }
        }

        function abrirDialogPerguntas(pergunta) {
            $mdDialog.show({
                controller: 'DialogPerguntasController',
                controllerAs: 'vm',
                templateUrl: vm.htmlRota.dialogs.dialogPergunta,
                targetEvent: null,
                clickOutsideToClose: false,
                locals: {
                    Pesquisa: vm.pesquisa,
                    Pergunta: pergunta
                }
            }).then(function (alterado) {
                if (alterado) {
                    vm.form.$setDirty();
                }
            });
        }

        function excluirPergunta(perguntaRemover) {
            vm.pesquisa.perguntas = vm.pesquisa.perguntas.filter(function (pergunta) {
                return pergunta !== perguntaRemover;
            });
        };

        function definirCamposClonados() {
            var entidade = angular.copy(vm.controleForm.entidadeClonada);

            entidade.codigo = null;
            entidade.cliente = null;
            entidade.clienteCodigo = null;
            entidade.produtoCodigo = vm.controleForm.entidadeClonada.produtoCodigo;
            entidade.perguntas = entidade.perguntas.map(function (pergunta) {
                return {
                    codigo: null,
                    permitirRespostaAberta: pergunta.permitirRespostaAberta,
                    pergunta: pergunta.pergunta,
                    notaMinima: pergunta.notaMinima,
                    notaMaxima: pergunta.notaMaxima,
                    tamanhoMaximoResposta: pergunta.tamanhoMaximoResposta,
                }
            });
            if (vm.pesquisa.clientes.length > 0) {
                vm.form.cliente.$setDirty();
            }
            vm.pesquisa = entidade;
        }

        function desabilitaBotaoClonar() {
            return desabilitaBotoesToolbar();
        }

        function desabilitaBotoesToolbar() {
            switch (vm.tabSelecionada) {
                case "pesquisa":
                    return false;
                case "perguntas":
                    return false;
                case "respostas":
                    return true;
                default:
                    return false;
            }
        }

        function changeProduto() {
            vm.pesquisa.cliente = null;
            vm.pesquisa.clienteCodigo = null;
            vm.pesquisa.clientes = [];
        }

        function selecionar(posicaoEntidade) {
            vm.metodosExternosPgToolbar.metodoControladorExternoListarTodasEntidades(null, posicaoEntidade);
        }

        function construirDtOptions() {
            DatatableFactory.construirDtOptionsComPaginacaoProcessadoNoServidorParaToolbar(
                Api.pesquisa.pesquisa.listarComPaginacaoDatatable,
                vm.entidadeDeEnvio.clsEntidade,
                "#datatable-pesquisa-satisfacao",
                [
                    DatatableFactory.construirColunaDeSelecionarPadrao(function (
                        indexLinha
                    ) {
                        vm.metodos.selecionar(indexLinha);
                    }),
                    {
                        targets: 1,
                        name: "Codigo",
                        data: "codigo",
                        sortable: false
                    },
                    {
                        targets: 2,
                        name: "Descricao",
                        data: "descricao",
                        sortable: false
                    },
                    {
                        targets: 3,
                        name: "DataInicio",
                        data: "dataInicio",
                        sortable: false,
                        render: function (data) {
                            return new Date(data).toLocaleDateString();
                        }
                    },
                    {
                        targets: 4,
                        name: "DataFim",
                        data: "dataFim",
                        sortable: false,
                        render: function (data) {
                            return new Date(data).toLocaleDateString();
                        }
                    },
                    {
                        targets: 5,
                        name: "Ativa",
                        data: "ativa",
                        sortable: false,
                        render: function (data) {
                            if (data) return "Sim";
                            else return "Não";
                        }
                    },
                    {
                        targets: 6,
                        name: "ProdutoCodigo",
                        data: "produtoCodigo",
                        sortable: false,
                        render: function (data) {
                            return ListarTodosProdutos.data.find(function (produto) {
                                return produto.codigo === data;
                            }).descricao;
                        }
                    },
                    {
                        targets: 7,
                        name: "QuantidadePerguntas",
                        data: "quantidadePerguntas",
                        sortable: false
                    }
                ]
            );
        }

        function visualizarRepostas(cliente) {
            if (!cliente.respondido) return;
            PgToolbarService.iniciarPreLoaderToolbar(
                vm.controleForm,
                vm.controlePreloader
            );
            var rota = Api.pesquisa.pesquisa.listarPerguntasRespostasClientes + "/" + vm.pesquisa.codigo + "/" + cliente.codigo;
            RequisicaoGenericaService.listarSemParams(rota)
                .then(function (success) {
                    _abrirDialogRespostasClientes(cliente, success.data);
                })
                .catch(function (error) {
                    console.error('Erro ao buscar respostas do cliente:', error);
                })
                .finally(function () {
                    PgToolbarService.finalizarPreLoaderToolbar(
                        vm.controleForm,
                        vm.controlePreloader
                    );
                });

        }

        function _limparCampoCliente() {
            vm.pesquisa.cliente = null;
            vm.textoDePesquisaAutoCompleteCliente = "";
        }

        function _abrirDialogRespostasClientes(cliente, respostas) {
            $mdDialog
                .show({
                    controller:
                        "RepostasClientesDialogController",
                    controllerAs: "vm",
                    templateUrl: vm.htmlRota.tabs.respostas.dialogs.dialogRespostasClientes,
                    targetEvent: null,
                    clickOutsideToClose: false,
                    locals: {
                        Respostas: respostas,
                        Cliente: cliente
                    },
                })
        }

        function _listarRespostasClientesGraficos(codigoPesquisa, perguntaSelecionada) {
            if (perguntaSelecionada.perguntaAberta) return;
            PgToolbarService.iniciarPreLoaderToolbar(
                vm.controleForm,
                vm.controlePreloader
            );
            var rota = Api.pesquisa.pesquisa.listarRespostasClientesGraficos + "/" + vm.pesquisa.codigo + "/" + perguntaSelecionada.codigoPergunta;
            RequisicaoGenericaService.listarSemParams(rota)
                .then(function (success) {
                    _abrirDialogRespostasGraficos(codigoPesquisa, perguntaSelecionada.codigoPergunta, success.data);
                })
                .finally(function () {
                    PgToolbarService.finalizarPreLoaderToolbar(
                        vm.controleForm,
                        vm.controlePreloader
                    );
                });
        }

        function _abrirDialogRespostasGraficos(codigoPesquisa, codigoPergunta, perguntaRepostas) {
            $mdDialog
                .show({
                    controller:
                        "RepostasClientesGraficoDialogController",
                    controllerAs: "vm",
                    templateUrl: vm.htmlRota.tabs.respostas.dialogs.dialogRespostasClientesGraficos,
                    targetEvent: null,
                    clickOutsideToClose: false,
                    locals: {
                        CodigoPesquisa: codigoPesquisa,
                        CodigoPergunta: codigoPergunta,
                        ListaPerguntas: vm.mediaGeralRespostas,
                        PerguntaRepostas: perguntaRepostas
                    },
                })
        }

        function _configurarGrafico() {
            var perguntasFechadas = vm.mediaGeralRespostas.filter(function (item) {
                return !item.perguntaAberta;
            });

            if (perguntasFechadas.length === 0) {
                vm.barChart = null;
                return;
            }

            var valoresFechadas = perguntasFechadas.map(function (item) {
                return {
                    label: 'Pergunta_' + item.codigoPergunta,
                    value: item.mediaResposta,
                    codigoPergunta: item.codigoPergunta,
                    perguntaAberta: item.perguntaAberta,
                    pergunta: item.pergunta,
                    mostrarValor: true
                };
            });

            var menorNotaMinima = perguntasFechadas.reduce(
                function (min, item) { return item.notaMinima < min ? item.notaMinima : min; },
                perguntasFechadas[0].notaMinima
            );

            var maiorNotaMaxima = perguntasFechadas.reduce(
                function (max, item) { return item.notaMaxima > max ? item.notaMaxima : max; },
                perguntasFechadas[0].notaMaxima
            );

            var ticksArray = [];
            for (var i = menorNotaMinima; i <= maiorNotaMaxima; i++) {
                ticksArray.push(i);
            }

            vm.barChart = {
                options: {
                    chart: {
                        type: 'multiBarHorizontalChart',
                        x: function (d) { return d.label; },
                        y: function (d) { return d.value; },
                        showControls: false,
                        showValues: true,
                        showLegend: false,
                        reduceXTicks: false,
                        groupSpacing: 0.8,
                        barSpacing: 0.1,
                        valueFormat: function (d) { return d === null ? '' : d; },
                        duration: 500,
                        forceY: [menorNotaMinima, maiorNotaMaxima],
                        multibar: {
                            dispatch: {
                                elementClick: function (e) {
                                    _listarRespostasClientesGraficos(vm.pesquisa.codigo, e.data);
                                }
                            }
                        },
                        xAxis: {
                            showMaxMin: false,
                            tickFormat: function (d) {
                                return 'Pergunta';
                            }
                        },
                        yAxis: {
                            axisLabel: '',
                            tickFormat: function (d) { return d; },
                            ticks: ticksArray.length,
                            tickValues: ticksArray
                        },
                        tooltip: {
                            enabled: true,
                            contentGenerator: function (d) {
                                if (!d || !d.data) return '';
                                var pergunta = d.data.pergunta || '';
                                var mostrarValor = d.data.mostrarValor;
                                var valor = mostrarValor ? '<br/><strong>Média:</strong> ' + d.data.value : '';
                                return (
                                    '<div style="padding: 10px; background-color: #ffffff; color: #000000; border: 1px solid #ccc; border-radius: 4px; max-width: 300px; word-break: break-word; white-space: pre-line;">' +
                                    '<strong>' + 'Pergunta:' + '</strong> ' + pergunta +
                                    valor +
                                    '</div>'
                                );
                            }
                        },
                        margin: { left: 140, right: 20, top: 20, bottom: 20 },
                    }
                },
                data: [
                    {
                        key: 'Perguntas',
                        color: '#084ca5',
                        values: valoresFechadas
                    }
                ]
            };
        }

        function _listarRespostasClientes() {
            PgToolbarService.iniciarPreLoaderToolbar(
                vm.controleForm,
                vm.controlePreloader
            );
            var rota = Api.pesquisa.pesquisa.listarRespostasClientes + "/" + vm.pesquisa.codigo;
            RequisicaoGenericaService.listarSemParams(rota)
                .then(function (success) {
                    vm.clienteRespostas = success.data.mediaGeralClientes;
                    vm.mediaGeralRespostas = success.data.mediaGeralPerguntas;
                    vm.exibirGrafico = vm.mediaGeralRespostas.length > 0 &&
                        vm.mediaGeralRespostas.some(function (item) {
                            return !item.perguntaAberta;
                        });
                    _configurarGrafico();
                    vm.tabSelecionada = 'respostas';
                })
                .finally(function () {
                    PgToolbarService.finalizarPreLoaderToolbar(
                        vm.controleForm,
                        vm.controlePreloader
                    );
                });
        }

        function _pesquisarAutoComplete(rota, valor) {
            var queryConsulta = {
                produtoCodigo: vm.pesquisa.produtoCodigo,
            };

            if (parseInt(valor)) {
                queryConsulta.codigo = valor;
            }
            else {
                queryConsulta.nome = valor;
            }

            return RequisicaoGenericaService.listarComParams(rota, queryConsulta).then(
                function (success) {
                    return success.data;
                },
                function (error) {
                    return [];
                });
        }
    }

}());

(function () {
    'use strict';

    angular
        .module('app.mensageiro', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, RotasHtml) {

        var rotasHtml = RotasHtml.mensageiro;

        // State
        $stateProvider
            .state('app.mensageiro', {
                abstract: true,
                url: '/mensageiro',
                module: 'privado'
            })
            .state('app.mensageiro.threads', {
                url: '/{type:(?:label)}/:filter',
                views: {
                    'content@app': {
                        templateUrl: rotasHtml.templateUrl,
                        controller: 'MensageiroController as vm'
                    }
                },
                params: {
                    type: {
                        value: null,
                        squash: true
                    }
                },
                bodyClass: 'mail',
                resolve: {
                    ListarUsuarioPorDetalhe: function (Api, RequisicaoGenericaService, LoginUsuarioService) {
                        return RequisicaoGenericaService.listarSemParams(Api.usuario.detalhes_usuario.listarDetalhesUsuario
                            + LoginUsuarioService.usuarioArmazenado().codigo);
                    }
                }
            })
            .state('app.mensageiro.threads.mensagem', {
                url: '/:mensagemId',
                bodyClass: 'mail'
            });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/mensageiro');

    }
})();

(function () {
    'use strict';

    angular
        .module('app.mensageiro')
        .controller('EnviarMensagemDialogController', EnviarMensagemDialogController);

    /** @ngInject */
    function EnviarMensagemDialogController(
        $mdDialog,
        $scope,
        $timeout,
        $rootScope,
        $filter,
        MdDialogService,
        LoginUsuarioService,
        MensageiroService,
        selectedMail,
        HistoricoMensagens,
        ListarUsuarioPorDetalhe,
        SquadService) {
        var vm = this;
        vm.form = {};
        init();


        vm.metodos = {
            closeDialog: closeDialog,
            removerContatoSelecionado: removerContatoSelecionado,
            carregaDepartamentos: carregaDepartamentos,
            carregaColaboradores: carregaColaboradores,
            configurarSelectContatoDepartamento: configurarSelectContatoDepartamento,
            configurarSelectColaboradores: configurarSelectColaboradores,
            ngChangeRadioGroupSelecaoContato: ngChangeRadioGroupSelecaoContato,
            enviarMensagem: enviarMensagem,
            limparCampos: limparCampos,
            limparColaboradoresSelecionados: limparColaboradoresSelecionados,
            exibeSelectColaboradores: exibeSelectColaboradores,
            defineSelectColaboradoresObrigatorio: defineSelectColaboradoresObrigatorio,
            habilitaBotaoLimparCampos: habilitaBotaoLimparCampos,
            retornaTamanhoAssunto: retornaTamanhoAssunto,
            removerImagens: removerImagens,
            onChangeSquad: onChangeSquad
        };

        vm.metodosInternos = {
            filtraColaboradoresDeAcordoComDepartamento: _filtraColaboradoresDeAcordoComDepartamento,
            selecionaTodos: _selecionaTodos,
            preparaMensagem: _preparaMensagem,
            removeColaboradorLogado: _removeColaboradorLogado,
            disparaBroadcastIndicandoOEnvioDaMensagem: _disparaBroadcastIndicandoOEnvioDaMensagem,
            adicionaColaboradorNoArray: _adicionaColaboradorNoArray,
            confirmaAcao: _confirmaAcao,
            defineCamposIniciais: _defineCamposIniciais,
            defineCamposIniciaisDaResposta: _defineCamposIniciaisDaResposta,
            inicializaSeForResposta: _inicializaSeForResposta,
            inicializaSeForEncaminhar: _inicializaSeForEncaminhar
        }

        function init() {
            _defineCamposIniciais();

            //se encaminhando
            if (_inicializaSeForEncaminhar()) {
                carregaDepartamentos();
                carregaColaboradores();
                return;
            }

            // se Respondendo
            if (_inicializaSeForResposta()) {
                vm.exibirHistorico = true;
                carregaSquads();
                vm.historicoMensagens = construirMensagemHistorico(HistoricoMensagens);
                return;
            }


            carregaDepartamentos();
            carregaColaboradores();
        }

        //#region watch
        $scope.$watch('vm.model.departamentosSelecionados', function (oldValue, newValue) {
            if (!vm.respostaDeMensagem)
                vm.model.colaboradoresSelecionados = _filtraColaboradoresDeAcordoComDepartamento(vm.model.departamentosSelecionados);
        });

        $scope.$watch('vm.model.colaboradoresSelecionados', function (oldValue, newValue) {
            if (vm.model.colaboradoresSelecionados == null)
                vm.model.departamentosSelecionados.length = 0;
        });

        $scope.$watch('vm.model.mensagem', function () {
            removerImagens();
        })

        $scope.$watch('vm.model.mensagem', function (newValue, oldValue) {
            if (newValue !== oldValue) {
                if (newValue.indexOf('<img') !== -1) {
                    vm.model.mensagem = newValue.replace(/<img[^>]+>/g, '');
                    MdDialogService.alertPadrao("Atenção!", null, "Não é possível inserir imagem.");
                }
            }
        });
        //#region metodos

        function exibeSelectColaboradores() {
            if (vm.respostaDeMensagem != null)
                if (vm.respostaDeMensagem)
                    return true;
            if (vm.radioSelecaoContato == 'colaboradores')
                return true;
            return false;
        }

        function defineSelectColaboradoresObrigatorio() {
            if (vm.model.colaboradoresSelecionados == null)
                return true;
            if (vm.model.colaboradoresSelecionados.length > 0)
                return false;
            if (vm.habilitarTodos)
                return false;
            return true;
        }

        function retornaTamanhoAssunto() {
            if (vm.respostaDeMensagem || vm.encaminhamentoDeMensagem)
                return 60;
            return 50;
        }

        function construirMensagemHistorico(historicoMensagens) {
            var mensagemFormatada = '';

            historicoMensagens.forEach(function (mensagem) {
                var remetente = (mensagem.remetente || '').trim();
                var dataEnvioCompleta = mensagem.dataEnvioCompleta;
                var destinatarios = (mensagem.copiaPara.usuariosNomeEmCopia || '').trim();
                var corpo = (mensagem.corpo || '').trim();
                var dataEnvio = $filter('date')(new Date(dataEnvioCompleta), 'dd/MM/yyyy - HH:mm');

                var listaDestinatarios = destinatarios.split(',').map(function (destinatario) { return destinatario.trim(); });
                var primeirosDestinatarios = listaDestinatarios.slice(0, 5);
                var quantidadeDestinatariosRestantes = listaDestinatarios.length - 5;
                var textoColaborador =
                    quantidadeDestinatariosRestantes > 0
                        ? ' + ' + quantidadeDestinatariosRestantes + ' ' + (quantidadeDestinatariosRestantes === 1 ? 'colaborador' : 'colaboradores')
                        : '';

                var destinatariosFormatados = primeirosDestinatarios.join(', ') + textoColaborador;

                mensagemFormatada +=
                    '<div><strong>De:</strong> ' + remetente + '</div>' +
                    '<div><strong>Data:</strong> ' + dataEnvio + '</div>' +
                    '<div><strong>Para:</strong> ' + destinatariosFormatados + '</div>' +
                    '<br><div>' + corpo + '</div>' +
                    '<hr style="border: 1px solid #000; margin: 10px 0;">';
            });

            return mensagemFormatada;
        }


        function habilitaBotaoLimparCampos() {
            if (vm.respostaDeMensagem || vm.encaminhamentoDeMensagem)
                return false;
            return true;
        }

        function limparColaboradoresSelecionados() {

            if (vm.model.colaboradoresSelecionados == null)
                return;

            if (vm.model.colaboradoresSelecionados.length <= 0)
                return;

            _confirmaAcao(function () {
                vm.model.colaboradoresSelecionados.length = 0;
                vm.model.departamentosSelecionados.length = 0;
                vm.radioSelecaoContato = "colaboradores"
                $scope.vm.form.$setUntouched();
                $scope.vm.form.$setPristine();
            }, function () {
                return;
            }, "Atenção", "Deseja realmente limpar os colaboradores?");


            //vm.metodos.carregaDepartamentos();
        }

        function configurarSelectColaboradores(ev) {
            vm.termoProcuradoColaborador = "";
            angular.element('#select-colaboradores').on('keydown', function (ev) {
                ev.stopPropagation();
            });
        }

        function configurarSelectContatoDepartamento(ev) {
            vm.termoProcuradoDepartamento = "";
            angular.element('#select-departamento').on('keydown', function (ev) {
                ev.stopPropagation();
            });
        }

        function enviarMensagem() {
            vm.enviandoMensagem = true;

            if (vm.form.$error != null)
                if (vm.form.$error.length > 0) {
                    MdDialogService.alertPadrao("Verifique se todos os campos foram informados", function () { });
                    vm.enviandoMensagem = false;
                    return;
                }

            if (vm.form.$invalid) {
                MdDialogService.alertPadrao("Verifique se todos os campos foram informados", function () { });
                vm.enviandoMensagem = false;
                return;
            }

            var mensagem = _preparaMensagem();
            MensageiroService.enviar(mensagem, function (result) {
                //   MdDialogService.alertPadrao("Mensagem enviada com sucesso!");
                vm.enviandoMensagem = false;

                _disparaBroadcastIndicandoOEnvioDaMensagem(mensagem, vm.respostaDeMensagem);
                MdDialogService.alertPadraoComEvento('Atenção', function () {
                    _close();
                    limparCampos(true);
                }, null, "Mensagem enviada com sucesso!")
                return;
            }, function (error) {
                MdDialogService.alertPadrao(error.data);
                vm.enviandoMensagem = false;
                return;
            });
        }

        function ngChangeRadioGroupSelecaoContato(tipoSelecao) {
            if (tipoSelecao === 'todos') {

                if (vm.model.colaboradoresSelecionados == null)
                    _selecionaTodos();

                if (vm.model.colaboradoresSelecionados.length == vm.model.colaboradores.length)
                    return;

                if (vm.model.colaboradoresSelecionados.length > 1 || vm.model.departamentosSelecionados.length > 1) {
                    _confirmaAcao(_selecionaTodos, function () { }, "Deseja selecionar todos?", "Caso selecione, a seleção anterior será perdida!");
                    return;
                }

                _selecionaTodos();
            }
        }

        function carregaColaboradores() {
            if (vm.model.squadCodigos.length > 0) {
                return MensageiroService.listarColaboradoresSquad(vm.model.squadCodigos)
                    .then(function (result) {
                        vm.model.colaboradores = result;
                        _removeColaboradorLogado();
                    }).catch(function (err) { });
            }
        }

        function carregaSquads() {
            return MensageiroService.listarColaboradoresSquad(vm.squadUsuarioLogado)
                .then(function (result) {
                    var codigosUsuariosVinculadosMensagem = selectedMail.copiaPara.usuarios.map(function (usuario) {
                        return usuario.codigo;
                    });

                    var colaboradoresFiltrados = result.filter(function (usuario) {
                        return codigosUsuariosVinculadosMensagem.includes(usuario.codigo);
                    });

                    var remetente = result.find(function (usuario) {
                        return usuario.codigo === selectedMail.codigoRemetente;
                    });

                    if (remetente && !colaboradoresFiltrados.find(function (usuario) {
                        return usuario.codigo === remetente.codigo;
                    })) {
                        colaboradoresFiltrados.push(remetente);
                    }

                    colaboradoresFiltrados = colaboradoresFiltrados.filter(function (usuario) {
                        return usuario.codigo !== vm.usuarioLogado.codigo;
                    });

                    vm.model.colaboradores = result;
                    vm.model.colaboradoresSelecionados = colaboradoresFiltrados;

                    var codigosSquadsUsuariosVinculadosMensagem = colaboradoresFiltrados
                        .flatMap(function (usuario) {
                            return usuario.codigoSquads;
                        });

                    codigosSquadsUsuariosVinculadosMensagem = Array.from(new Set(codigosSquadsUsuariosVinculadosMensagem));

                    vm.model.squadCodigos = codigosSquadsUsuariosVinculadosMensagem;

                    if (vm.squadUsuarioLogado.length === 1) {
                        var codigosUsuariosSelecionados = selectedMail.copiaPara.usuarios.map(function (usuario) {
                            return usuario.codigo;
                        });

                        vm.model.colaboradoresSelecionados = vm.model.colaboradores.filter(function (usuario) {
                            return codigosUsuariosSelecionados.includes(usuario.codigo);
                        });
                    }

                    _removeColaboradorLogado();
                })
                .catch(function (err) {
                    console.error('Erro ao carregar squads:', err);
                });
        }


        function carregaDepartamentos() {
            if (vm.model.squadCodigos.length > 0) {
                vm.emProgresso = true;
                return MensageiroService.listarDepartamentosSquad(vm.model.squadCodigos)
                    .then(function (result) {
                        vm.model.departamentos = result;
                        vm.emProgresso = false;
                    }, function (err) {
                        vm.emProgresso = false;
                    });
            }
        }

        function _confirmaAcao(acaoSim, acaoNao, titulo, mensagem) {
            MdDialogService.confirmPadraoComEvento(titulo, mensagem, event, acaoSim, acaoNao);
        }

        function closeDialog() {
            if (!existeDadosNaMensagem()) {
                _close();
                return;
            }

            _confirmaAcao(_close, function () { }, "Deseja sair?", "O conteúdo informado será perdido!");

        }

        function existeDadosNaMensagem() {
            if (vm.model.colaboradoresSelecionados == null && vm.model.mensagem == null && vm.model.assunto == null)
                return false;

            if (vm.model.mensagem != null || vm.model.assunto != null || vm.model.colaboradoresSelecionados.length > 0)
                return true;

            return false;
        }

        function removerContatoSelecionado(contato) {
            if (vm.model.colaboradoresSelecionados.length < 1)
                return;

            if (contato == null)
                return;

            var indexColaborador = vm.model.colaboradoresSelecionados.indexOf(contato);
            vm.model.colaboradoresSelecionados.splice(indexColaborador, 1);
        }

        function removerImagens(file, insertAction) {
            if (file) {
                MdDialogService.alertPadrao("Não é possível inserir arquivos no corpo da mensagem!");
            }
            return true;
        }

        function onChangeSquad() {
            vm.model.colaboradoresSelecionados = [];
            vm.model.departamentosSelecionados = [];
            carregaColaboradores();
            carregaDepartamentos();
        }

        //#endregion

        //#region metodos internos

        function _defineCamposIniciais(enviando) {
            vm.model = {
                prioridadeMensagem: 1,
                departamentos: [],
                departamentosSelecionados: [],
                colaboradores: [],
                colaboradoresSelecionados: [],
                assunto: null,
                mensagem: '',
                squadCodigos: []
            };

            vm.tituloDialog = "Nova mensagem";
            vm.usuarioLogado = LoginUsuarioService.usuarioArmazenado();
            vm.respostaDeMensagem = false;
            vm.encaminhamentoDeMensagem = false;
            vm.radioSelecaoContato = "departamento";
            vm.squadUsuarioLogado = ListarUsuarioPorDetalhe.data.codigoSquads;
            vm.squads = SquadService.listarSquadsUsuarioLogado(vm.squadUsuarioLogado);
            vm.emProgresso = false;

            if (vm.squadUsuarioLogado.length == 1) {
                vm.model.squadCodigos.push(vm.squadUsuarioLogado[0]);
                carregaColaboradores();
                carregaDepartamentos();
            }
            else {
                if (!enviando) {
                    $timeout(function () {
                        vm.form.squadCodigos.$setTouched();
                    }, 500);
                }
            }
        }

        function _defineCamposIniciaisDaResposta() {
            vm.dataResposta = "";
            vm.respostaDeMensagem = true;
            vm.model.mensagemOrigem = selectedMail;
            vm.tituloDialog = "Responder mensagem";
            vm.model.assunto = selectedMail.assunto;
        }

        function _defineCamposIniciaisDoEncaminhamento() {
            vm.dataResposta = "";
            vm.encaminhamentoDeMensagem = true;
            vm.model.mensagem = selectedMail.corpo;
            vm.tituloDialog = "Encaminhar a mensagem";
            vm.model.assunto = "ENC: " + selectedMail.assunto;
        }

        function _inicializaSeForEncaminhar() {
            if (angular.isDefined(selectedMail)) {
                if (!selectedMail.encaminhar)
                    return false;
                _defineCamposIniciaisDoEncaminhamento();
                return true;
            }
            return false;
        }

        function _inicializaSeForResposta() {
            if (angular.isDefined(selectedMail)) {
                if (!selectedMail.responder)
                    return false;
                _defineCamposIniciaisDaResposta();
                var remetente = [];
                MensageiroService.listarColaboradorPeloCodigo({
                    codigo: selectedMail.codigoRemetente
                }).then(function (result) {
                    remetente = result[0];
                    selectedMail.copiaPara.usuarios.forEach(function (value) {
                        if (value.codigo != vm.usuarioLogado.codigo) {
                            _adicionaColaboradorNoArray(value);
                        }
                    });
                    _adicionaColaboradorNoArray(remetente);
                    return true;
                });
                return true;
            }
            return false;
        }

        function _adicionaColaboradorNoArray(contato) {
            if (contato == null)
                return;

            if (contato.codigo == vm.usuarioLogado.codigo)
                return;

            if (vm.model.colaboradores.indexOf(contato) > -1)
                return;

            if (contato.login) {
                contato.nome = contato.login;
            }
            vm.model.colaboradores.push(contato);

            if (vm.model.colaboradoresSelecionados != null)
                vm.model.colaboradoresSelecionados.push(contato);
        }

        function _close() {
            $mdDialog.hide();
        }

        function _disparaBroadcastIndicandoOEnvioDaMensagem(mensagem, ehResposta) {
            $rootScope.$broadcast('enviou-mensagem', mensagem, ehResposta);
        }

        function _removeColaboradorLogado() {
            if (vm.model.colaboradores == null)
                return;

            vm.model.colaboradores.forEach(function (value) {
                if (value.codigo == vm.usuarioLogado.codigo) {
                    var indexValue = vm.model.colaboradores.indexOf(value);
                    vm.model.colaboradores.splice(indexValue, 1);
                }
            });
        }

        function _preparaMensagem() {
            {
                var mensagem = {
                    CodigoUsuarioRemetente: vm.usuarioLogado.codigo,
                    DataEnvio: new Date(),
                    Assunto: vm.model.assunto.trim(),
                    Corpo: vm.model.mensagem.trim(),
                    Prioridade: vm.model.prioridadeMensagem,
                    DiretorioAnexo: "",
                    importante: false,
                    UsuarioSelecionados: vm.model.colaboradoresSelecionados.map(function (item, index) {
                        if (item.codigo != vm.usuarioLogado.codigo)
                            return item.codigo;
                    }),
                    GruposSelecionados: vm.model.departamentosSelecionados.map(function (item, index) {
                        vm.model.colaboradoresSelecionados.forEach(function (value, key) {
                            if (value.codigoSetor == item.codigo)
                                return item.codigo;
                        });
                    })
                };

                if (vm.respostaDeMensagem) {
                    mensagem.identificadorOrigem = vm.model.mensagemOrigem.mensagemIdentificadorOrigem || vm.model.mensagemOrigem.mensagemIdentificador;
                }

                return mensagem;
            }
        }

        function _filtraColaboradoresDeAcordoComDepartamento(departamentos) {
            var contatosFiltrados = [];

            angular.forEach(departamentos, function (value, key) {
                for (i = 0; i < vm.model.colaboradores.length; i++) {
                    if (vm.model.colaboradores[i].codigoSetor == value.codigo) {
                        contatosFiltrados.push(vm.model.colaboradores[i]);
                        //_removeColaboradorLogado(contatosFiltrados);
                    }
                }
            });

            return contatosFiltrados;
        }

        function _selecionaTodos() {
            _removeColaboradorLogado();
            vm.model.colaboradoresSelecionados = angular.copy(vm.model.colaboradores);
            vm.model.departamentosSelecionados = angular.copy(vm.model.departamentos);
        }

        function limparCampos(enviando) {
            if (enviando) {
                _defineCamposIniciais(enviando);
                carregaColaboradores();
                carregaDepartamentos();
                $scope.vm.form.$setUntouched();
                $scope.vm.form.$setPristine();
                return;
            }

            _confirmaAcao(function () {
                init();
                $scope.vm.form.$setUntouched();
                $scope.vm.form.$setPristine();

            }, function () {
                return;
            }, "Atenção", "Deseja realmente limpar os campos?");

        }
        //#endregion
    }
})();

(function () {
    'use strict';

    angular
        .module('app.manutencao.prioridade',[])
        .config(Config);

    function Config(
        $stateProvider,
        RotasHtml) {

        var rotasManutencao = RotasHtml.prioridade;

        $stateProvider
            .state('app.manutencao_cadastro_prioridade',{
                url: '/manutencao/cadastro/prioridade',
                module: 'privado',
                params: {
                    parametros: null
                },
                views: {
                    'content@app': {
                        templateUrl: rotasManutencao.templateUrl,
                        controller: 'PrioridadeController as vm'
                    },
                    'prioridade-form@app.manutencao_cadastro_prioridade': {
                        templateUrl: rotasManutencao.form
                    },
                    'prioridade-tabela@app.manutencao_cadastro_prioridade': {
                        templateUrl: rotasManutencao.tabela
                    }
                },
                // resolve: {
                //     ListarConsulta: function (Api,RequisicaoGenericaService) {
                //         return RequisicaoGenericaService.listarSemParams(Api.consultaSql.consulta);
                //     },
                // }
            });
    }

}());
(function () {
    'use strict';

    angular
        .module('app.manutencao.prioridade')
        .controller('PrioridadeController',PrioridadeController)

    function PrioridadeController(
        Api,
        $scope,
        NavegacaoService,
        RequisicaoGenericaLocacaoService,
        DatatableLocacaoFactory
    ) {
        var vm = this;
        vm.tipoServico = { faturar: false};
        NavegacaoService.setTituloAba('Prioridade');

        init();

        function init() {
        }

        vm.cores = [
            { id: 1, nome: 'Vermelho' },
            { id: 2, nome: 'Verde'},
            { id: 3, nome: 'Azul' },
            { id: 4, nome: 'Amarelo' },
            { id: 4, nome: 'Laranja' },
            { id: 4, nome: 'Preto' },
          ];

        vm.metodos = {
            pesquisar: pesquisar,
            salvar: salvar,
            editar: editar,
            excluir: excluir,
            selecionar: selecionar,
            construirDtOptions: construirDtOptions,
            definirAtivo:definirAtivo
        };

        function pesquisar() {
            return RequisicaoGenericaLocacaoService.listarComObjetoComplexo(Api.manutencao.prioridade.listarComPaginacao,vm.entidadeDeEnvio);
        }

        function definirAtivo(){
            vm.tipoServico.faturar = true;
        }

        function salvar(modelo) {
            return RequisicaoGenericaLocacaoService.salvar(Api.manutencao.prioridade.criar,modelo);
        }

        function editar(modelo) {
            return RequisicaoGenericaLocacaoService.editar(Api.manutencao.prioridade.editar,modelo)
        }

        function excluir(modelo) {
            return RequisicaoGenericaLocacaoService.excluir(Api.manutencao.prioridade.remover,modelo.id)
        }

        function selecionar(posicaoEntidade) {
            vm.metodosExternosPgToolbar.metodoControladorExternoListarTodasEntidades(null,posicaoEntidade);
        }

        function construirDtOptions() {
            DatatableLocacaoFactory.destruirTabela();

            vm.entidadeDeEnvio.clsEntidade = null;

            DatatableLocacaoFactory.construirDtOptionsComPaginacaoProcessadoNoServidorParaToolbar(
                Api.manutencao.prioridade.listarComPaginacaoDataTable,
                vm.entidadeDeEnvio.clsEntidade,
                "#datatable-prioridade",
                [
                    DatatableLocacaoFactory.construirColunaDeSelecionarPadrao(function (
                        indexLinha
                    ) {
                        vm.metodos.selecionar(indexLinha);
                    }),
                    {
                        targets: 1,
                        name: "Descricao",
                        data: "descricao",
                        defaultContent: "",
                    },
                    {
                        targets: 2,
                        name: "Cor",
                        data: "cor",
                        defaultContent: "",
                    },
                    {
                        targets: 3,
                        name: "Dias",
                        data: "prazo",
                        defaultContent: "",
                    },
                ]
            );
            vm.entidadeDeEnvio.clsEntidade = {};
        }
    }
}());
(function () {
    'use strict';

    angular
        .module('app.manutencao.tipo-servico',[])
        .config(Config);

    function Config(
        $stateProvider,
        RotasHtml) {

        var rotasManutencao = RotasHtml.tipoServico;

        $stateProvider
            .state('app.manutencao_cadastro_tiposervico',{
                url: '/manutencao/cadastro/tiposervico',
                module: 'privado',
                params: {
                    parametros: null
                },
                views: {
                    'content@app': {
                        templateUrl: rotasManutencao.templateUrl,
                        controller: 'TipoServicoController as vm'
                    },
                    'tipo-servico-form@app.manutencao_cadastro_tiposervico': {
                        templateUrl: rotasManutencao.form
                    },
                    'tipo-servico-tabela@app.manutencao_cadastro_tiposervico': {
                        templateUrl: rotasManutencao.tabela
                    }
                },
                // resolve: {
                //     ListarConsulta: function (Api,RequisicaoGenericaService) {
                //         return RequisicaoGenericaService.listarSemParams(Api.consultaSql.consulta);
                //     },
                // }
            });
    }

}());
(function () {
    'use strict';

    angular
        .module('app.manutencao.tipo-servico')
        .controller('TipoServicoController', TipoServicoController)

    function TipoServicoController(
        Api,
        NavegacaoService,
        RequisicaoGenericaLocacaoService,
        DatatableLocacaoFactory
    ) {
        var vm = this;
        vm.tipoServico = { faturar: false };
        NavegacaoService.setTituloAba('Tipo Serviço');

        init();

        function init() {
        }

        vm.metodos = {
            pesquisar: pesquisar,
            salvar: salvar,
            editar: editar,
            excluir: excluir,
            selecionar: selecionar,
            construirDtOptions: construirDtOptions,
            definirAtivo: definirAtivo,
            onChangeFaturar: onChangeFaturar
        };

        function pesquisar() {
            return RequisicaoGenericaLocacaoService.listarComObjetoComplexo(Api.manutencao.tipoServico.listarComPaginacao, vm.entidadeDeEnvio);
        }

        function definirAtivo() {
            vm.tipoServico = {
                faturar: true
            }
        }

        function onChangeFaturar(valor) {
            if (!valor) {
                vm.tipoServico.permiteObservacao = false;
            }
        }

        function salvar(modelo) {
            return RequisicaoGenericaLocacaoService.salvar(Api.manutencao.tipoServico.criar, modelo);
        }

        function editar(modelo) {
            return RequisicaoGenericaLocacaoService.editar(Api.manutencao.tipoServico.editar, modelo)
        }

        function excluir(modelo) {
            return RequisicaoGenericaLocacaoService.excluir(Api.manutencao.tipoServico.remover, modelo.id)
        }

        function selecionar(posicaoEntidade) {
            vm.metodosExternosPgToolbar.metodoControladorExternoListarTodasEntidades(null, posicaoEntidade);
        }

        function construirDtOptions() {
            DatatableLocacaoFactory.destruirTabela();

            vm.entidadeDeEnvio.clsEntidade = null;

            DatatableLocacaoFactory.construirDtOptionsComPaginacaoProcessadoNoServidorParaToolbar(
                Api.manutencao.tipoServico.listarComPaginacaoDataTable,
                vm.entidadeDeEnvio.clsEntidade,
                "#datatable-tipo-servico",
                [
                    DatatableLocacaoFactory.construirColunaDeSelecionarPadrao(function (
                        indexLinha
                    ) {
                        vm.metodos.selecionar(indexLinha);
                    }),
                    {
                        targets: 1,
                        name: "Descricao",
                        data: "descricao",
                        defaultContent: "",
                        sortable: false
                    },
                    {
                        targets: 2,
                        name: "Observação",
                        data: "observacao",
                        defaultContent: "",
                        sortable: false
                    },
                    {
                        targets: 3,
                        name: "Faturar",
                        data: "faturarDt",
                        defaultContent: "",
                        sortable: false
                    },
                    {
                        targets: 4,
                        name: "Imprimir",
                        data: "imprimirDt",
                        defaultContent: "",
                        sortable: false
                    },
                    {
                        targets: 5,
                        name: "Enviar e-mail",
                        data: "enviarEmailDt",
                        defaultContent: "",
                        sortable: false

                    }
                ]
            );

            vm.entidadeDeEnvio.clsEntidade = {};
        }
    }
}());
(function () {
    'use strict';

    angular
        .module('app.manutencao.tipo-procedimento',[])
        .config(Config);

    function Config(
        $stateProvider,
        RotasHtml) {

        var rotasManutencao = RotasHtml.tipoProcedimento;

        $stateProvider
            .state('app.manutencao_cadastro_tipoprocedimento',{
                url: '/manutencao/cadastro/tipo-procedimento',
                module: 'privado',
                params: {
                    parametros: null
                },
                views: {
                    'content@app': {
                        templateUrl: rotasManutencao.templateUrl,
                        controller: 'TipoProcedimentoController as vm'
                    },
                    'tipo-procedimento-form@app.manutencao_cadastro_tipoprocedimento': {
                        templateUrl: rotasManutencao.form
                    },
                    'tipo-procedimento-tabela@app.manutencao_cadastro_tipoprocedimento': {
                        templateUrl: rotasManutencao.tabela
                    }
                },
                resolve: {
                    ListarEquipamentos: function (Api, RequisicaoGenericaLocacaoService) {
                        return RequisicaoGenericaLocacaoService.listarSemParams(Api.locacao.equipamentos.equipamento.listarTodos);
                    }
                }
            });
    }

}());
(function () {
    'use strict';

    angular
        .module('app.manutencao.tipo-procedimento')
        .controller('TipoProcedimentoController',TipoProcedimentoController)

    function TipoProcedimentoController(
        Api,
        NavegacaoService,
        RequisicaoGenericaLocacaoService,
        DatatableLocacaoFactory,
        ListarEquipamentos
    ) {

        var vm = this;
        vm.equipamentos = ListarEquipamentos.data;
        vm.regexHora = /^([01]?[0-9]|2[0-3]):[0-5][0-9]$/;
        vm.index = null;

        NavegacaoService.setTituloAba('Tipo Procedimento');

        init();

        function init() {
        }

        vm.metodos = {
            pesquisar: pesquisar,
            salvar: salvar,
            editar: editar,
            excluir: excluir,
            selecionar: selecionar,
            construirDtOptions: construirDtOptions,
            configuraMdSelectSolucao: configuraMdSelectSolucao,
            verificarIndex: verificarIndex
        };

        /**
         * Método que irá configurar e limpar o filtro do md-header do md-select de solução
         */
        function configuraMdSelectSolucao() {
            // vm.tipoProcedimento.equipamentoId = vm.tipoProcedimento.equipamentoId;
            vm.filtrarEquipamentos = '';

            angular
                .element('#equipamento-form-solucao-md-select')
                .on('keydown',function (ev) {
                    ev.stopPropagation();
                });
        }

        function verificarIndex(index) {
            console.log("index geral",vm.index);
            console.log("index",index);
        }

        function pesquisar() {
            return RequisicaoGenericaLocacaoService.listarComObjetoComplexo(Api.manutencao.tipoProcedimento.listarComPaginacao,vm.entidadeDeEnvio);
        }

        function salvar(modelo) {
            return RequisicaoGenericaLocacaoService.salvar(Api.manutencao.tipoProcedimento.criar,modelo);
        }

        function editar(modelo) {
            return RequisicaoGenericaLocacaoService.editar(Api.manutencao.tipoProcedimento.editar,modelo)
        }

        function excluir(modelo) {
            return RequisicaoGenericaLocacaoService.excluir(Api.manutencao.tipoProcedimento.remover,modelo.id)
        }

        function selecionar(posicaoEntidade) {
            vm.metodosExternosPgToolbar.metodoControladorExternoListarTodasEntidades(null,posicaoEntidade);
        }

        function construirDtOptions() {
            DatatableLocacaoFactory.destruirTabela();

            vm.entidadeDeEnvio.clsEntidade = null;

            DatatableLocacaoFactory.construirDtOptionsComPaginacaoProcessadoNoServidorParaToolbar(
                Api.manutencao.tipoProcedimento.listarComPaginacaoDataTable,
                vm.entidadeDeEnvio.clsEntidade,
                "#datatable-tipo-procedimento",
                [
                    DatatableLocacaoFactory.construirColunaDeSelecionarPadrao(function (
                        indexLinha
                    ) {
                        vm.metodos.selecionar(indexLinha);
                    }),
                    {
                        targets: 1,
                        name: "Descricao",
                        data: "descricao",
                        defaultContent: "",
                    },
                    {
                        targets: 2,
                        name: "Equipamento",
                        data: "equipamentoDt",
                        defaultContent: "",
                    },
                    {
                        targets: 3,
                        name: "Obrigatorio",
                        data: "obrigatorioDt",
                        defaultContent: "",
                    },
                    {
                        targets: 4,
                        name: "Obrigatorio",
                        data: "necessitaPecaDt",
                        defaultContent: "",
                    },
                    {
                        targets: 5,
                        name: "Tempo gasto",
                        data: "tempoTecnicoMinutos",
                        defaultContent: "",
                    },
                    {
                        targets: 6,
                        name: "Garantia",
                        data: "garantiaDias",
                        defaultContent: "",
                    },
                    {
                        targets: 7,
                        name: "Valor gasto",
                        data: "valorProcedimento",
                        defaultContent: "",
                    },
                ]
            );
            vm.entidadeDeEnvio.clsEntidade = {};
        }
    }
}());

(function () {
    'use strict';

    angular
        .module('app.manutencao.origem-peca',[])
        .config(Config);

    function Config(
        $stateProvider,
        RotasHtml) {

        var rotasManutencao = RotasHtml.origemPeca;

        $stateProvider
            .state('app.manutencao_cadastro_origempeca',{
                url: '/manutencao/cadastro/origempeca',
                module: 'privado',
                params: {
                    parametros: null
                },
                views: {
                    'content@app': {
                        templateUrl: rotasManutencao.templateUrl,
                        controller: 'OrigemPecaController as vm'
                    },
                    'origem-peca-form@app.manutencao_cadastro_origempeca': {
                        templateUrl: rotasManutencao.form
                    },
                    'origem-peca-tabela@app.manutencao_cadastro_origempeca': {
                        templateUrl: rotasManutencao.tabela
                    }
                },
                // resolve: {
                //     ListarConsulta: function (Api,RequisicaoGenericaService) {
                //         return RequisicaoGenericaService.listarSemParams(Api.consultaSql.consulta);
                //     },
                // }
            });
    }

}());
(function () {
    'use strict';

    angular
        .module('app.manutencao.origem-peca')
        .controller('OrigemPecaController', OrigemPecaController)

    function OrigemPecaController(
        Api,
        NavegacaoService,
        RequisicaoGenericaLocacaoService,
        DatatableLocacaoFactory
    ) {
        var vm = this;
        NavegacaoService.setTituloAba('Origem Peça');

        init();

        function init() {
        }

        vm.metodos = {
            pesquisar: pesquisar,
            salvar: salvar,
            editar: editar,
            excluir: excluir,
            selecionar: selecionar,
            definirAtivo: definirAtivo,
            construirDtOptions: construirDtOptions
        };

        function definirAtivo() {
            vm.origemPeca = {
                ativo: true
            }
        }

        function pesquisar() {
            return RequisicaoGenericaLocacaoService.listarComObjetoComplexo(Api.manutencao.origemPeca.listarComPaginacao, vm.entidadeDeEnvio);
        }

        function salvar(modelo) {
            return RequisicaoGenericaLocacaoService.salvar(Api.manutencao.origemPeca.criar, modelo);
        }

        function editar(modelo) {
            return RequisicaoGenericaLocacaoService.editar(Api.manutencao.origemPeca.editar, modelo)
        }

        function excluir(modelo) {
            return RequisicaoGenericaLocacaoService.excluir(Api.manutencao.origemPeca.remover, modelo.id)
        }

        function selecionar(posicaoEntidade) {
            vm.metodosExternosPgToolbar.metodoControladorExternoListarTodasEntidades(null, posicaoEntidade);
        }

        function construirDtOptions() {
            DatatableLocacaoFactory.destruirTabela();

            vm.entidadeDeEnvio.clsEntidade = null;

            DatatableLocacaoFactory.construirDtOptionsComPaginacaoProcessadoNoServidorParaToolbar(
                Api.manutencao.origemPeca.listarComPaginacaoDatatable,
                vm.entidadeDeEnvio.clsEntidade,
                "#datatable-origem-peca",
                [
                    DatatableLocacaoFactory.construirColunaDeSelecionarPadrao(function (
                        indexLinha
                    ) {
                        vm.metodos.selecionar(indexLinha);
                    }),
                    {
                        targets: 1,
                        name: "Descricao",
                        data: "descricao",
                        defaultContent: ""
                    },
                    {
                        targets: 1,
                        name: "Observação",
                        data: "observacao",
                        defaultContent: ""
                    },
                    {
                        targets: 2,
                        name: "Ativo",
                        data: "ativoDt",
                        defaultContent: ""
                    }
                ]
            );
            vm.entidadeDeEnvio.clsEntidade = {};
        }
    }
}());

(function () {
    'use strict';

    angular
        .module('app.manutencao.tipo-envio',[])
        .config(Config);

    function Config(
        $stateProvider,
        RotasHtml) {

        var rotasManutencao = RotasHtml.tipoEnvio;

        $stateProvider
            .state('app.manutencao_cadastro_tipoenvio',{
                url: '/manutencao/cadastro/tipoenvio',
                module: 'privado',
                params: {
                    parametros: null
                },
                views: {
                    'content@app': {
                        templateUrl: rotasManutencao.templateUrl,
                        controller: 'TipoEnvioController as vm'
                    },
                    'tipo-envio-form@app.manutencao_cadastro_tipoenvio': {
                        templateUrl: rotasManutencao.form
                    },
                    'tipo-envio-tabela@app.manutencao_cadastro_tipoenvio': {
                        templateUrl: rotasManutencao.tabela
                    }
                },
                // resolve: {
                //     ListarConsulta: function (Api,RequisicaoGenericaService) {
                //         return RequisicaoGenericaService.listarSemParams(Api.consultaSql.consulta);
                //     },
                // }
            });
    }

}());
(function () {
    'use strict';

    angular
        .module('app.manutencao.tipo-envio')
        .controller('TipoEnvioController',TipoEnvioController)

    function TipoEnvioController(
        Api,
        NavegacaoService,
        RequisicaoGenericaLocacaoService,
        DatatableLocacaoFactory
    ) {
        var vm = this;
        NavegacaoService.setTituloAba('Tipo Envio');

        init();

        function init() {
        }

        vm.metodos = {
            pesquisar: pesquisar,
            salvar: salvar,
            editar: editar,
            excluir: excluir,
            selecionar: selecionar,
            construirDtOptions: construirDtOptions
        };

        function pesquisar() {
            return RequisicaoGenericaLocacaoService.listarComObjetoComplexo(Api.manutencao.tipoEnvio.listarComPaginacao,vm.entidadeDeEnvio);
        }

        function salvar(modelo) {
            return RequisicaoGenericaLocacaoService.salvar(Api.manutencao.tipoEnvio.criar,modelo);
        }

        function editar(modelo) {
            return RequisicaoGenericaLocacaoService.editar(Api.manutencao.tipoEnvio.editar,modelo)
        }

        function excluir(modelo) {
            return RequisicaoGenericaLocacaoService.excluir(Api.manutencao.tipoEnvio.remover,modelo.id)
        }

        function selecionar(posicaoEntidade) {
            vm.metodosExternosPgToolbar.metodoControladorExternoListarTodasEntidades(null,posicaoEntidade);
        }

        function construirDtOptions() {
            DatatableLocacaoFactory.destruirTabela();

            vm.entidadeDeEnvio.clsEntidade = null;

            DatatableLocacaoFactory.construirDtOptionsComPaginacaoProcessadoNoServidorParaToolbar(
                Api.manutencao.tipoEnvio.listarComPaginacaoDataTable,
                vm.entidadeDeEnvio.clsEntidade,
                "#datatable-tipo-envio",
                [
                    DatatableLocacaoFactory.construirColunaDeSelecionarPadrao(function (
                        indexLinha
                    ) {
                        vm.metodos.selecionar(indexLinha);
                    }),
                    {
                        targets: 1,
                        name: "Descricao",
                        data: "descricao",
                        defaultContent: "",
                    }
                ]
            );
            vm.entidadeDeEnvio.clsEntidade = {};
        }
    }
}());
(function () {
    'use strict';

    angular
        .module('app.manutencao.margem',[])
        .config(Config);

    function Config(
        $stateProvider,
        RotasHtml) {

        var rotasManutencao = RotasHtml.margem;

        $stateProvider
            .state('app.manutencao_cadastro_margem',{
                url: '/manutencao/cadastro/margem',
                module: 'privado',
                params: {
                    parametros: null
                },
                views: {
                    'content@app': {
                        templateUrl: rotasManutencao.templateUrl,
                        controller: 'MargemController as vm'
                    },
                    'margem-form@app.manutencao_cadastro_margem': {
                        templateUrl: rotasManutencao.form
                    },
                    'margem-tabela@app.manutencao_cadastro_margem': {
                        templateUrl: rotasManutencao.tabela
                    }
                },
                // resolve: {
                //     ListarConsulta: function (Api,RequisicaoGenericaService) {
                //         return RequisicaoGenericaService.listarSemParams(Api.consultaSql.consulta);
                //     },
                // }
            });
    }

}());
(function () {
    'use strict';

    angular
        .module('app.manutencao.margem')
        .controller('MargemController',MargemController)

    function MargemController(
        Api,
        NavegacaoService,
        RequisicaoGenericaLocacaoService,
        DatatableLocacaoFactory
    ) {
        var vm = this;
        NavegacaoService.setTituloAba('Margem');

        init();

        function init() {
        }

        vm.metodos = {
            pesquisar: pesquisar,
            salvar: salvar,
            editar: editar,
            excluir: excluir,
            selecionar: selecionar,
            construirDtOptions: construirDtOptions
        };

        function pesquisar() {
            return RequisicaoGenericaLocacaoService.listarComObjetoComplexo(Api.manutencao.margem.listarComPaginacao,vm.entidadeDeEnvio);
        }

        function salvar(modelo) {
            return RequisicaoGenericaLocacaoService.salvar(Api.manutencao.margem.criar,modelo);
        }

        function editar(modelo) {
            return RequisicaoGenericaLocacaoService.editar(Api.manutencao.margem.editar,modelo)
        }

        function excluir(modelo) {
            return RequisicaoGenericaLocacaoService.excluir(Api.manutencao.margem.remover,modelo.id)
        }

        function selecionar(posicaoEntidade) {
            vm.metodosExternosPgToolbar.metodoControladorExternoListarTodasEntidades(null,posicaoEntidade);
        }

        function construirDtOptions() {
            DatatableLocacaoFactory.destruirTabela();

            vm.entidadeDeEnvio.clsEntidade = null;

            DatatableLocacaoFactory.construirDtOptionsComPaginacaoProcessadoNoServidorParaToolbar(
                Api.manutencao.margem.listarComPaginacaoDatatable,
                vm.entidadeDeEnvio.clsEntidade,
                "#datatable-margem",
                [
                    DatatableLocacaoFactory.construirColunaDeSelecionarPadrao(function (
                        indexLinha
                    ) {
                        vm.metodos.selecionar(indexLinha);
                    }),
                    {
                        targets: 1,
                        name: "Margem",
                        data: "margem",
                        defaultContent: "",
                    },
                ]
            );
            vm.entidadeDeEnvio.clsEntidade = {};
        }
    }
}());
(function () {
    "use strict";

    angular
        .module("app.manutencao.consulta.ordem-servico")
        .controller("ConsultaOrdemServicoController", ConsultaOrdemServicoController);

    function ConsultaOrdemServicoController(
        $state,
        $mdDialog,
        Api,
        RotasHtml,
        RequisicaoGenericaLocacaoService,
        MdToastService,
        MdDialogService,
        ListarClientes,
        ListarTodosUsuariosAtivos,
        ListarPrioridades,
        ListarEmpresaAtivo,
        ListarTipoServico,
        SprintFactory,
        ServicosGenericoService,
        NavegacaoService
    ) {
        var vm = this;
        NavegacaoService.setTituloAba('Ordens de serviço');

        vm.metodos = {
            resetarFiltros: resetarFiltros,
            validarFiltro: validarFiltro,
            abrirDialogItens: abrirDialogItens,
            abrirOS: abrirOS,
            abrirAtendimento: abrirAtendimento,
            converterParaDataFormatada: converterParaDataFormatada,
            listarOS: listarOS,
            configuraAutoCompleteClienteOnBlur: configuraAutoCompleteClienteOnBlur,
            alterarItemSelecionadoAutoCompleteCliente: alterarItemSelecionadoAutoCompleteCliente,
            pesquisarAutoCompleteCliente: pesquisarAutoCompleteCliente
        }

        init();

        function init() {
            //função de ordenação customizada da tabela
            jQuery.extend(jQuery.fn.dataTableExt.oSort, {
                "ordemservico-asc": function (a, b) {
                    var partesA = a.split("/");
                    var numeroA = partesA[0];
                    var anoA = partesA[1];

                    var partesB = a.split("/");
                    var numeroB = partesB[0];
                    var anoB = partesB[1];

                    return (anoA < anoB) ? -1 : ((anoA > anoB) ? 1 : ((numeroA < numeroB) ? -1 : 1));
                },

                "ordemservico-desc": function (a, b) {
                    var partesA = a.split("/");
                    var numeroA = partesA[0];
                    var anoA = partesA[1];

                    var partesB = a.split("/");
                    var numeroB = partesB[0];
                    var anoB = partesB[1];

                    return (anoA < anoB) ? 1 : ((anoA > anoB) ? -1 : ((numeroA < numeroB) ? 1 : -1));
                }
            });


            vm.tipoPesquisa = 1;
            vm.fases = [
                { codigo: 1, descricao: 'Aberta' },
                { codigo: 2, descricao: 'Em execução' },
                { codigo: 3, descricao: 'Executada' },
                { codigo: 4, descricao: 'Cancelada' },
                { codigo: 5, descricao: 'Reprovada' }
            ];
            vm.consulta = {
                codigoCliente: null,
                numeroSerie: "",
                imei: ""
            };
            vm.ordensServicos = {};
            vm.rotasHtmlItem = RotasHtml.tipoServico;
            vm.pesquisando = false;
            vm.mostrarTabela = false;
            vm.habilitarBotao = false;
            vm.tipoFiltro = 2;
            vm.listaDeClientes = ListarClientes.data;
            vm.usuarioAtivo = ListarTodosUsuariosAtivos.data;
            vm.prioridade = ListarPrioridades.data;
            vm.empresaAtivo = ListarEmpresaAtivo.data;
            vm.tipoServico = ListarTipoServico.data;
            vm.semExecucao = "Sem execução";
            vm.item = "Item";
            vm.pequisandoPorStatusExecucao = false;

            vm.dtOptionsOrdemServico = SprintFactory.setDtOptionsBacklog();
            vm.dtOptionsOrdemServico.columnDefs = [
                {
                    targets: [0, 1, 9],
                    responsivePriority: 1
                },
                {
                    targets: [0],
                    type: "ordemservico" //nome da ordenação customizada
                }
            ];

            vm.dtOptionsOrdemServico.responsive = {
                details: {
                    display: $.fn.dataTable.Responsive.display.childRow
                }
            };

            vm.dtOptionsOrdemServico.initComplete = function () {
                var api = this.api(),
                    searchBox = angular.element('body').find('#pesquisar');

                if (searchBox.length > 0) {
                    searchBox.on('keyup', function (event) {
                        api.search(event.target.value).draw();
                    });
                }
            }
        }

        function resetarFiltros() {
            vm.consulta = {
                codigoCliente: null,
                numeroSerie: "",
                imei: ""
            };
            vm.habilitarBotao = false;
        }

        function validarFiltro(consulta) {
            if (consulta.dataInicial != undefined && consulta.dataFinal != undefined) {
                vm.habilitarBotao = true;
            } else {
                vm.habilitarBotao = false;
            }
        }

        function abrirDialogItens(event, item) {
            if (item.status == 1) {
                MdDialogService.alertPadrao("Atenção! ", null, "Esta ordem de serviço ainda não possui procedimentos.");
                return;
            }
            $mdDialog
                .show({
                    controller: "DialogOrdemItemController",
                    controllerAs: "vm",
                    templateUrl: vm.rotasHtmlItem.dialogs.dialog_itens,
                    multiple: true,
                    targetEvent: event,
                    clickOutsideToClose: false,
                    locals: {
                        EmpresasAtivos: ListarEmpresaAtivo.data,
                        Item: item
                    }
                })
                .then(function (success) { });
        }

        function abrirOS(event, os) {
            $state.goNewTab("app.manutencao_ordem_servico", {
                parametros: {
                    os: os,
                    idOs: os.ordemServicoId
                }
            });
        }

        function abrirAtendimento(event, atendimento) {
            $state.goNewTab("app.atendimento_processamento_atendimento", {
                parametros: {
                    codigo: atendimento.atendimentoId,
                    ano: atendimento.atendimentoAno,
                    chamarPesquisa: true
                }
            });
        }

        function listarOS(consulta, tipoFiltro) {
            vm.pesquisando = true;
            vm.mensagemPreloader = "Buscando...";
            vm.mostrarTabela = false;

            var viewModel;

            if (tipoFiltro == 1) {
                viewModel = {
                    codigoCliente: consulta.codigoCliente,
                    dataFinal: consulta.dataFinal,
                    dataInicial: consulta.dataInicial,
                    imei: consulta.imei,
                    numeroSerie: consulta.numeroSerie,
                    statusOS: consulta.statusOS
                }
                return RequisicaoGenericaLocacaoService
                    .listarComObjetoComplexo(Api.manutencao.ordem_servico.listarStatusPorDataAbertura, viewModel)
                    .then(
                        function (succsses) {
                            vm.ordensServicos = succsses.data;

                            if (vm.ordensServicos.length > 0) {
                                MdToastService.toastPadrao("Consulta realizada com sucesso!");
                                vm.pesquisando = false;
                                vm.mostrarTabela = true;

                                vm.ordensServicos.forEach(function (os) {
                                    // Pega a descrição da prioridade
                                    vm.prioridade.forEach(function (prioridade) {
                                        if (os.prioridadeCodigo == prioridade.id) {
                                            os.prioridadeDescricao = prioridade.descricao.toUpperCase();
                                        }
                                    });

                                    // Pega a descrição da empresa ativo
                                    vm.empresaAtivo.forEach(function (empresaAtivo) {
                                        if (os.empresaAtivoId == empresaAtivo.id) {
                                            os.empresaAtivoDescricao = empresaAtivo.nome.split(" ");
                                        }
                                    });

                                    // Pega a descrição do tipo de serviço
                                    vm.tipoServico.forEach(function (tipoServico) {
                                        if (os.ordemServicoTipoServicoId == tipoServico.id) {
                                            os.tipoServicoDescricao = tipoServico.descricao.toUpperCase();
                                        }
                                    });

                                    // Pega a descrição do responsável pela abertura e pela execução
                                    vm.usuarioAtivo.forEach(function (usuario) {
                                        if (os.responsavelAbertura == usuario.codigo) {
                                            os.reponsavelNome = usuario.nome;
                                        }
                                        if (os.responsavelExecucao == usuario.codigo) {
                                            os.responsavelExecucaoNome = usuario.nome;
                                        }
                                        if (os.responsavelExecucaoNome == undefined) {
                                            os.responsavelExecucaoNome = vm.semExecucao;
                                        }
                                    });
                                });

                            } else {
                                MdDialogService.alertPadrao("Atenção! ", null, "Não há dados para a consulta realizada!");
                                vm.pesquisando = false;
                                vm.mostrarTabela = false;
                            }
                        },
                        function (error) {
                            MdDialogService.alertPadrao("Atenção! ", null, "Não há dados para a consulta realizada!");
                            vm.pesquisando = false;
                        }
                    );
            } else {
                viewModel = {
                    codigoCliente: consulta.codigoCliente,
                    dataFinal: consulta.dataFinal,
                    dataInicial: consulta.dataInicial,
                    imei: consulta.imei,
                    numeroSerie: consulta.numeroSerie
                }
                return RequisicaoGenericaLocacaoService
                    .listarComObjetoComplexo(Api.manutencao.ordem_servico.listarPorDataAberturaOsExecutadas, viewModel)
                    .then(
                        function (succsses) {
                            vm.ordensServicos = succsses.data;

                            if (vm.ordensServicos.length > 0) {
                                MdToastService.toastPadrao("Consulta realizada com sucesso!");
                                vm.pesquisando = false;
                                vm.mostrarTabela = true;

                                vm.ordensServicos.forEach(function (os) {
                                    // Pega a descrição da prioridade
                                    vm.prioridade.forEach(function (prioridade) {
                                        if (os.prioridadeCodigo == prioridade.id) {
                                            os.prioridadeDescricao = prioridade.descricao.toUpperCase();
                                        }
                                    });

                                    // Pega a descrição da empresa ativo
                                    vm.empresaAtivo.forEach(function (empresaAtivo) {
                                        if (os.empresaAtivoId == empresaAtivo.id) {
                                            os.empresaAtivoDescricao = empresaAtivo.nome.split(" ");
                                        }
                                    });

                                    // Pega a descrição do tipo de serviço
                                    vm.tipoServico.forEach(function (tipoServico) {
                                        if (os.ordemServicoTipoServicoId == tipoServico.id) {
                                            os.tipoServicoDescricao = tipoServico.descricao.toUpperCase();
                                        }
                                    });

                                    // Pega a descrição do responsável pela abertura e pela execução
                                    vm.usuarioAtivo.forEach(function (usuario) {
                                        if (os.responsavelAbertura == usuario.codigo) {
                                            os.reponsavelNome = usuario.nome;
                                        }
                                        if (os.responsavelExecucao == usuario.codigo) {
                                            os.responsavelExecucaoNome = usuario.nome;
                                        }
                                        if (os.responsavelExecucaoNome == undefined) {
                                            os.responsavelExecucaoNome = vm.semExecucao;
                                        }
                                    });
                                });

                            } else {
                                MdDialogService.alertPadrao("Atenção! ", null, "Não há dados para a consulta realizada!");
                                vm.pesquisando = false;
                                vm.mostrarTabela = false;
                            }
                        },
                        function (error) {
                            MdDialogService.alertPadrao("Atenção! ", null, "Não há dados para a consulta realizada!");
                            vm.pesquisando = false;
                        }
                    );
            }

        }

        function configuraAutoCompleteClienteOnBlur() {
            if (!vm.consulta.cliente)
                vm.textoDePesquisaAutoCompleteCliente = "";
        }

        function alterarItemSelecionadoAutoCompleteCliente(item) {
            if (item) {
                vm.consulta.codigoCliente = item.codigo;
            } else {
                vm.consulta.codigoCliente = null;
                vm.textoDePesquisaAutoCompleteCliente = "";
            }
        }

        function pesquisarAutoCompleteCliente(query) {
            return ServicosGenericoService.pesquisarAutoCompleteCodigoOuNomeGenericoApi(Api.cliente.listarCodigoDescricao, query);
        }

        function converterParaDataFormatada(data) {
            var dataFormatada;

            if (data != null) {
                dataFormatada = new Date(data)
                return dataFormatada;
            }
        }
    }
})();

(function () {
    "use strict";

    angular
        .module("app.locacao.consulta.historico")
        .controller("HistoricoController", HistoricoController);

    function HistoricoController(
        ListarEmpresaAtivo,
        Api,
        RequisicaoGenericaLocacaoService,
        NavegacaoService,
        HistoricoService,
        RotasHtml,
        $mdDialog,
        MdDialogService
    ) {
        var vm = this;

        vm.empresaAtivo = ListarEmpresaAtivo.data;
        vm.pesquisando = false;
        vm.iniciaTabela = false;
        vm.tipoPesquisa = 1;
        vm.notaFiscalEntrada = "";
        vm.notaFiscalRevenda = "";

        vm.rotasHtml = RotasHtml.historico;
        NavegacaoService.setTituloAba("Histórico");
        vm.historicoDtOptions = HistoricoService.detalheHistoricoConstruirDtOptionsdetalheHistorico();
        vm.historicoDtOptions.columnDefs = [
            {
                targets: [0, 1, 2],
                responsivePriority: 1
            },
            {
                targets: [6],
                orderable: false
            }
        ];
        vm.historicoDtOptions.order = [0, "desc"];

        vm.metodos = {
            pesquisarHistorico: pesquisarHistorico,
            dialogFoto: dialogFoto,
            botaoDialogEstadoConservacao: botaoDialogEstadoConservacao,
            retornaDescricaoEmpresaAtivo: retornaDescricaoEmpresaAtivo
        };

        init();

        function init() {
            listarEstadoConservacao();
        }

        function pesquisarHistorico(event, numero) {
            vm.notaFiscalEntrada = "";
            vm.notaFiscalRevenda = "";
            vm.pesquisando = true;

            if (vm.tipoPesquisa == 1)
                listarPorSerie(numero);
            else
                listarPorImei(numero);

        }

        function retornaDescricaoEmpresaAtivo(codigoEmpresaAtivo) {
            var descricao = "";

            vm.empresaAtivo.map(function (empresa) {
                if (empresa.codigo == codigoEmpresaAtivo) descricao = empresa.nome;
            });

            return descricao;
        }

        function listarPorSerie(numero) {
            RequisicaoGenericaLocacaoService.listarSemParams(
                Api.locacao.nota_item_detalhe_historico.listarUltimaNotaFiscalEquipamentoNumeroSerie + numero
            ).then(function (success) {
                vm.notaFiscalEntrada = success.data.notaFiscalEntrada;
                vm.notaFiscalRevenda = success.data.notaFiscalRevenda;
            });

            RequisicaoGenericaLocacaoService.listarSemParams(
                Api.locacao.nota_item_detalhe_historico.listarHistoricos + numero
            ).then(function (success) {
                vm.detalhesHistoricos = success.data;
                vm.pesquisando = false;
                vm.index = vm.detalhesHistoricos.length - 1;
                verificaListaHistorico(vm.detalhesHistoricos.length);

            }).catch(function (erro) {
                vm.pesquisando = false;
                vm.iniciaTabela = false;
                MdDialogService.alertPadrao("Nenhum registro encontrado!");
            });
        }

        function listarPorImei(numero) {
            RequisicaoGenericaLocacaoService.listarSemParams(
                Api.locacao.nota_item_detalhe_historico.listarUltimaNotaFiscalEquipamentoImei + numero
            ).then(function (success) {
                vm.notaFiscalEntrada = success.data.notaFiscalEntrada;
                vm.notaFiscalRevenda = success.data.notaFiscalRevenda;
            });

            RequisicaoGenericaLocacaoService.listarSemParams(
                Api.locacao.nota_item_detalhe_historico.listarHistoricoPorImei + numero
            ).then(function (success) {
                vm.detalhesHistoricos = success.data;
                vm.pesquisando = false;
                vm.index = vm.detalhesHistoricos.length - 1;
                verificaListaHistorico(vm.detalhesHistoricos.length);
            }).catch(function (erro) {
                vm.pesquisando = false;
                vm.iniciaTabela = false;
                MdDialogService.alertPadrao("Nenhum registro encontrado!");
            });
        }

        function verificaListaHistorico(tamanhoLista) {
            if (tamanhoLista > 0)
                vm.iniciaTabela = true;
            else {
                vm.iniciaTabela = false;
                MdDialogService.alertPadrao("Nenhum registro encontrado!");
            }
        }

        function dialogFoto(event, historico) {
            $mdDialog.show({
                controller: "DialogFotoController",
                controllerAs: "vm",
                templateUrl: vm.rotasHtml.dialogFoto,
                multiple: true,
                targetEvent: event,
                clickOutsideToClose: false,
                locals: {
                    Historico: historico,
                    EUltimoHistorico: true
                }
            });
        }

        function listarEstadoConservacao() {
            RequisicaoGenericaLocacaoService.listarSemParams(Api.locacao.equipamentos.estadoConservacao.listarTodos).then(function (success) {
                vm.equipamentoEstadoConservacao = success.data;
            });
        }

        function botaoDialogEstadoConservacao(index, detalhe) {
            $mdDialog
                .show({
                    controller: "DialogEstadoConservacaoHistoricoController",
                    controllerAs: "vm",
                    templateUrl: vm.rotasHtml.dialogEstadoConservacao,
                    multiple: true,
                    targetEvent: event,
                    clickOutsideToClose: false,
                    locals: {
                        EstadoConservacaoId: detalhe.equipamentoEstadoConservacao,
                        EquipamentoEstadoConservacao: vm.equipamentoEstadoConservacao,
                        ApenasFoto: false,
                        Detalhe: detalhe
                    }
                }).then(function (success) {
                    vm.detalhesHistoricos = success;
                    setTimeout(function () {
                        MdDialogService.alertPadrao("Estado de conservação editado com sucesso!", success);
                    }, 500);
                });
        }
    }
})();


(function () {
    "use strict";

    angular
        .module("app.locacao.consulta.locacao", [])
        .config(config);

    function config($stateProvider, RotasHtml) {

        var rotasHtmlLocacao = RotasHtml.consultaLocacao;

        $stateProvider.state(
            "app.locacao_consulta_locacao",
            {
                url: "/locacao/consulta/locacao",
                module: "privado",
                views: {
                    "content@app": {
                        templateUrl: rotasHtmlLocacao.templateUrl,
                        controller: "LocacaoController as vm"
                    }
                },
                resolve: {
                    ListarClientes: function (Api, RequisicaoGenericaLocacaoService) {
                        return RequisicaoGenericaLocacaoService.listarSemParams(Api.locacao.clientes.listarTodos);
                    },
                    ListarTodosEquipamentos: function (Api, RequisicaoGenericaLocacaoService) {
                        return RequisicaoGenericaLocacaoService.listarSemParams(Api.locacao.equipamentos.equipamento.listarTodos);
                    },
                    ListarTiposLocacao: function (Api, RequisicaoGenericaLocacaoService) {
                        return RequisicaoGenericaLocacaoService.listarSemParams(Api.locacao.tipoLocacao.listarTodos);
                    }
                }
            }
        );
    }
})();

(function () {
    "use strict";

    angular
        .module("app.locacao.consulta.locacao")
        .controller("LocacaoController", LocacaoController);

    function LocacaoController(
        Api,
        NavegacaoService,
        ListarClientes,
        RotasHtml,
        MdDialogService,
        MdToastService,
        RequisicaoGenericaService,
        RequisicaoGenericaLocacaoService,
        ListarTodosEquipamentos,
        ListarTiposLocacao
    ) {
        var vm = this;
        vm.pesquisando = false;
        vm.rotasHtml = RotasHtml.locacao;
        vm.clientes = {};
        vm.codigos = ListarClientes.data;
        vm.equipamentos = ListarTodosEquipamentos.data;
        vm.equipamentos.forEach(function (equipamento) {
            equipamento.codigo = equipamento.id;
        });
        vm.tiposLocacao = ListarTiposLocacao.data;
        vm.tiposLocacao.forEach(function (locacao) {
            locacao.codigo = locacao.id;
        });
        vm.filtroConsulta = {};
        vm.filtroConsulta.clientes = [];
        vm.envioOuRetorno = "";
        vm.mostraTitulo = false;
        vm.requisicaoProgress = false;
        vm.mostraAlertaSemContrato = false;
        vm.mensagemPreloader = "";
        vm.clienteContratos = [];

        NavegacaoService.setTituloAba("Locação");

        init();

        vm.metodos = {
            listarTodosClientesPorCodigos: listarTodosClientesPorCodigos,
            listarClientes: listarClientes
        };

        function init() {
            listarTodosClientesPorCodigos();
        }

        function listarTodosClientesPorCodigos() {
            vm.clientes.codigos = vm.codigos;

            RequisicaoGenericaService.listarComObjetoComplexo(Api.cliente.listarTodosDoLocacaoComContrato, vm.clientes)
                .then(function (success) {
                    vm.clientesImanager = success.data;

                }, function (error) {
                    MdDialogService.alertPadrao(error.data.Message);
                });
        }

        function listarClientes(event, clientesImanager) {

            if (clientesImanager.tipoPesquisa == 1) {
                vm.envioOuRetorno = "Busca por envio";
                vm.textoCardEnvio = true;
            }
            if (clientesImanager.tipoPesquisa == 2) {
                vm.envioOuRetorno = "Busca por retorno";
                vm.textoCardEnvio = true;
            }
            if (clientesImanager.tipoPesquisa == 3) {
                vm.envioOuRetorno = "Busca por envio sem retorno";
                vm.textoCardEnvio = true;
            }

            if (clientesImanager.clientesSelecionados.length <= 0) {

                vm.clientesImanager.forEach(function (cliente) {

                    var clienteArray = {};
                    clienteArray.nome = cliente.nome;
                    clienteArray.codigo = cliente.codigo;

                    vm.filtroConsulta.clientes.push(clienteArray);

                    var todosContratos = [];
                    cliente.contratos.map(function (contrato) {
                        todosContratos = todosContratos.concat(contrato.contratoItens);
                    });

                    vm.itens = todosContratos.map(function (item) {
                        return item.codigo;
                    });

                    vm.filtroConsulta.clientes[vm.filtroConsulta.clientes.indexOf(clienteArray)].contratoItens = vm.itens;
                });
            }
            else {
                clientesImanager.clientesSelecionados.forEach(function (cliente) {
                    var clienteArray = {};
                    clienteArray.nome = cliente.nome;
                    clienteArray.codigo = cliente.codigo;
                    vm.filtroConsulta.clientes.push(clienteArray);

                    var todosContratos = []
                    cliente.contratos.map(function (contrato) {
                        todosContratos = todosContratos.concat(contrato.contratoItens);
                    });

                    vm.itens = todosContratos.map(function (item) {
                        return item.codigo;
                    });

                    vm.filtroConsulta.clientes[vm.filtroConsulta.clientes.indexOf(clienteArray)].contratoItens = vm.itens;
                });
            }
            vm.filtroConsulta.dataInicial = clientesImanager.dataInicial;
            vm.filtroConsulta.dataFinal = clientesImanager.dataFinal;
            vm.filtroConsulta.equipamentos = clientesImanager.equipamentos.map(function (equipamento) {
                return equipamento.codigo;
            });
            vm.filtroConsulta.tipoLocacao = clientesImanager.tipoLocacao.map(function (locacao) {
                return locacao.codigo;
            });

            if (clientesImanager.tipoPesquisa == "1")
                listarClientesPoEnvio(vm.filtroConsulta);
            if (clientesImanager.tipoPesquisa == "2")
                listarClientesPoRetorno(vm.filtroConsulta);
            if (clientesImanager.tipoPesquisa == "3")
                listarClientesEnvioSemRetorno(vm.filtroConsulta);
        }

        function listarClientesPoEnvio(clientes) {
            vm.requisicaoProgress = true;
            vm.mensagemPreloader = "Buscando...";
            if (vm.requisicaoProgress)
                vm.clientesFiltrados = null;

            setTimeout(function () {
                RequisicaoGenericaLocacaoService.listarComObjetoComplexo(Api.locacao.locacaoEnvio.ListarPorEnvios, clientes)
                    .then(function (success) {

                        if (success.data.length > 0) {
                            vm.mostraTitulo = true;
                            MdToastService.toastPadrao("Consulta realizada com sucesso!");
                            vm.requisicaoProgress = false;
                            vm.filtroConsulta.clientes = [];
                        }
                        else {
                            vm.mostraTitulo = false;
                            vm.requisicaoProgress = false;
                            vm.mensagemPreloader = "";
                            MdDialogService.alertPadrao("Atenção! ", null, "Não há dados para a consulta realizada!");
                            vm.filtroConsulta.clientes = [];
                        }

                        vm.clientesFiltrados = success.data;
                        vm.totais = vm.clientesFiltrados.length;

                        inserirDescricaoContratosClientes(vm.clientesImanager, vm.clientesFiltrados);
                        pegaAPrimeiraPalavraNomeCliente(vm.clientesFiltrados);
                    });
            }, 2000);
        }

        function listarClientesPoRetorno(clientes) {
            vm.requisicaoProgress = true;
            vm.mensagemPreloader = "Buscando...";
            if (vm.requisicaoProgress)
                vm.clientesFiltrados = null;

            setTimeout(function () {
                RequisicaoGenericaLocacaoService.listarComObjetoComplexo(Api.locacao.locacaoRetorno.ListarPorRetornos, clientes)
                    .then(function (success) {
                        if (success.data.length > 0) {
                            vm.mostraTitulo = true;
                            MdToastService.toastPadrao("Consulta realizada com sucesso!");
                            vm.requisicaoProgress = false;
                            vm.filtroConsulta.clientes = [];
                        }

                        else {
                            vm.mostraTitulo = false;
                            vm.requisicaoProgress = false;
                            vm.mensagemPreloader = "";
                            MdDialogService.alertPadrao("Atenção! ", null, "Não há dados para a consulta realizada!");
                            vm.filtroConsulta.clientes = [];
                        }

                        vm.clientesFiltrados = success.data;
                        vm.totais = vm.clientesFiltrados.length;

                        inserirDescricaoContratosClientes(vm.clientesImanager, vm.clientesFiltrados);
                        pegaAPrimeiraPalavraNomeCliente(vm.clientesFiltrados);
                    });
            }, 2000);
        }

        function listarClientesEnvioSemRetorno(clientes) {
            vm.requisicaoProgress = true;
            vm.mensagemPreloader = "Buscando...";
            if (vm.requisicaoProgress)
                vm.clientesFiltrados = null;

            setTimeout(function () {
                RequisicaoGenericaLocacaoService.listarComObjetoComplexo(Api.locacao.locacaoEnvio.ListarPorEnviosSemRetorno, clientes)
                    .then(function (success) {
                        if (success.data.length > 0) {
                            vm.mostraTitulo = true;
                            MdToastService.toastPadrao("Consulta realizada com sucesso!");
                            vm.requisicaoProgress = false;
                            vm.filtroConsulta.clientes = [];
                        }

                        else {
                            vm.mostraTitulo = false;
                            vm.requisicaoProgress = false;
                            vm.mensagemPreloader = "";
                            MdDialogService.alertPadrao("Atenção! ", null, "Não há dados para a consulta realizada!");
                            vm.filtroConsulta.clientes = [];
                        }

                        vm.clientesFiltrados = success.data;
                        vm.totais = vm.clientesFiltrados.length;

                        inserirDescricaoContratosClientes(vm.clientesImanager, vm.clientesFiltrados);
                        pegaAPrimeiraPalavraNomeCliente(vm.clientesFiltrados);
                    });
            }, 2000);
        }
    }
    function inserirDescricaoContratosClientes(clientes, clientesFiltrados) {
        clientes.forEach(function (cliente) {
            clientesFiltrados.map(function (item) {
                cliente.contratos.map(function (contrato) {
                    if (item.contratoId == contrato.codigo) {
                        item.contratoDescricao = contrato.produto.descricao;
                        item.contratoDescricao = item.contratoDescricao.split(' ')[0]; // separar str por espaços
                    }
                });
            });
        });
    }
})();

(function () {
  "use strict";

  angular
    .module("app.locacao.consulta.contratosAEncerrar", [])
    .config(config);

  function config($stateProvider, RotasHtml) {

    var rotasHtmlContratosAEncerrar = RotasHtml.contratosAEncerrar;

    $stateProvider.state(
      "app.locacao_consulta_contratos_a_encerrar",
      {
        url: "/locacao/consulta/contratosAEncerrar",
        module: "privado",
        views: {
          "content@app": {
            templateUrl: rotasHtmlContratosAEncerrar.templateUrl,
            controller: "ContratosAEncerrarController as vm"
          }
        },
        resolve: {
          ListarEmpresaAtivo: function (Api, RequisicaoGenericaLocacaoService) {
            return RequisicaoGenericaLocacaoService.listarSemParams(Api.locacao.empresaAtiva.listarTodos);
          },
          ListarClientes: function (Api, RequisicaoGenericaLocacaoService) {
            return RequisicaoGenericaLocacaoService.listarSemParams(Api.locacao.clientes.listarTodos);
          }
        }
      }
    );
  }
})();


(function () {
    "use strict";

    angular
        .module("app.locacao.consulta.contratosAEncerrar")
        .controller("ContratosAEncerrarController",ContratosAEncerrarController);

    function ContratosAEncerrarController(
        NavegacaoService,
        ListarEmpresaAtivo,
        ListarClientes,
        Api,
        RequisicaoGenericaLocacaoService,
        RequisicaoGenericaService,
        MdDialogService
    ) {
        var vm = this;

        vm.pesquisando = false;
        vm.mensagemPreloader = "";
        vm.empresaAtivo = ListarEmpresaAtivo.data;
        vm.dados;
        vm.clientes = {};
        vm.codigos = ListarClientes.data;
        vm.totalClientes = 0;
        vm.totalEquipamentos = 0;
        vm.clientesImanager = {};
        vm.tipoPesquisa = 1;

        NavegacaoService.setTituloAba("Contratos a encerrar");

        init();

        vm.metodos = {
            pesquisarDados: pesquisarDados
        };

        function init() {
            _listarTodosClientesPorCodigos();
        }

        function pesquisarDados() {
            vm.pesquisando = true;
            vm.totalEquipamentos = 0;
            vm.totalClientes = 0;
            vm.dados = undefined;

            if (vm.tipoPesquisa == 1)
                vm.filtro.tipoPesquisa = 1;
            else
                vm.filtro.tipoPesquisa = 2;

            var viewModel = {
                tipoFiltro: vm.filtro.tipoPesquisa,
                empresaAtivoId: vm.empresaAtivoId,
                dataInicial: vm.filtro.dataInicial,
                dataFinal: vm.filtro.dataFinal
            }

            var _rotaAPI = Api.locacao.equipamentos.equipamento.listarPorContratoAEncerrar;
            var pListar = RequisicaoGenericaLocacaoService.salvar(_rotaAPI,viewModel);

            pListar
                .then(
                    function (success) {
                        vm.dados = success.data;
                        if (vm.dados.length == 0) {
                            MdDialogService.alertPadrao("Não foram encontrados dados para o filtro informado!",null,null);
                            vm.dados = undefined;
                        } else {
                            vm.totalClientes = vm.dados.length;

                            _inserirDescricaoContratosClientes(vm.clientesImanager,vm.dados);

                            vm.dados.forEach(function (dado) {
                                if (dado.equipamentos != null) {
                                    dado.totalEquipamentos = 0;
                                    dado.equipamentos.forEach(function (equipamento) {
                                        vm.totalEquipamentos = vm.totalEquipamentos + equipamento.quantidade;
                                        dado.totalEquipamentos = dado.totalEquipamentos + equipamento.quantidade;
                                    });
                                }
                            });
                        }
                    },function (error) {
                        MdDialogService.alertPadrao(error.data,null,null);
                    }
                )
                .finally(function () {
                    vm.pesquisando = false;
                });
        }


        function _listarTodosClientesPorCodigos() {
            vm.clientes.codigos = vm.codigos;
            RequisicaoGenericaService.listarComObjetoComplexo(Api.cliente.listarTodosDoLocacaoComContrato,vm.clientes)
                .then(function (success) {
                    vm.clientesImanager = success.data;
                },function (error) {
                    MdDialogService.alertPadrao(error.data.Message);
                });
        }

        function _inserirDescricaoContratosClientes(clientes,clientesFiltrados) {
            clientes.forEach(function (cliente) {
                clientesFiltrados.map(function (item) {
                    cliente.contratos.map(function (contrato) {
                        if (item.cabecalho.contratoCodigo == contrato.codigo) {
                            item.cabecalho.contratoDescricao = contrato.produto.descricao;
                            item.cabecalho.contratoDescricao = item.cabecalho.contratoDescricao.split(' ')[0]; // separar str por espaços
                        }
                    });
                });
            });
        }
    }
})();


(function () {
    "use strict";

    angular
        .module("app.locacao.consulta.controleEquipamento")
        .controller("ControleEquipamentoController", ControleEquipamentoController);

    function ControleEquipamentoController(
        Api,
        RequisicaoGenericaLocacaoService,
        ListarEmpresaAtivo,
        NavegacaoService,
        RotasHtml,
        $mdDialog
    ) {
        var vm = this;
        vm.mostrarFildSet = false;
        vm.equipamentosSeparados = [];
        vm.rotasHtml = RotasHtml.controle_equipamento;
        NavegacaoService.setTituloAba("Controle de equipamentos");

        vm.empresaAtivo = ListarEmpresaAtivo.data;
        vm.metodos = {
            pesquisar: pesquisar,
            calcularTotalizadorGeral: calcularTotalizadorGeral,
            calcularTotalizador: calcularTotalizador,
            retornarQuantidadeItemEquipamento: retornarQuantidadeItemEquipamento,
            retornarQuantidadeItemEquipamentoSituacao: retornarQuantidadeItemEquipamentoSituacao,
            pesquisarPorSituacao: pesquisarPorSituacao,
            dialogSituacao: dialogSituacao,
            dialogTipo: dialogTipo,
            listarPorEstadoConservacaoEEmpresaAtivoId: listarPorEstadoConservacaoEEmpresaAtivoId,
            pesquisarPorSituacaoFabricante: pesquisarPorSituacaoFabricante
        };

        init();

        function init() {
            vm.emProgresso = false;
        }

        function retornarQuantidadeItemEquipamento(equipamento) {
            var quantidade = 0;
            equipamento.filter(function (equip) {
                quantidade += equip.quantidade;
            });

            return quantidade;
        }

        function retornarQuantidadeItemEquipamentoSituacao(equipamento) {
            var quantidade = 0;
            equipamento.filter(function (equip) {
                quantidade += equip.quantidade;
            });

            return quantidade;
        }

        function calcularTotalizador() {
            vm.equipamentos.map(function (equipamento) {
                vm.totalizador = 0;
                equipamento.filter(function (i) {
                    vm.totalizador += i.quantidade;
                });
                return vm.totalizador;
            });
        }

        function calcularTotalizadorGeral() {
            vm.totalizadorGeral = 0;
            vm.equipamentos.map(function (equipamento) {
                equipamento.map(function (i) {
                    vm.totalizadorGeral += i.quantidade;
                });
            });
            return vm.totalizadorGeral;
        }

        function pesquisar(empresaAtivoId) {
            vm.empresaAtivoId = empresaAtivoId;
            vm.pesquisando = true;
            vm.mensagemPreloader = "Carregando...";
            vm.mostrarFildSet = false;
            RequisicaoGenericaLocacaoService.listarSemParams(
                Api.locacao.equipamentos.equipamento.listarPorEmpresaAtivo + empresaAtivoId
            ).then(function (success) {
                pesquisarPorSituacao(vm.empresaAtivoId);
                vm.equipamentos = success.data;
                vm.pesquisando = false;
                vm.mensagemPreloader = "";
                vm.mostrarFildSet = true;
                calcularTotalizador();
                vm.itemsCountEquipamento = vm.equipamentos.length;
                vm.slidesToShowEquipamento = 4;
                vm.itemWidthEquipamento = 250;
                vm.slidesToMoveEquipamento = 1;
                vm.movePositionEquipamento = vm.slidesToMoveEquipamento * vm.itemWidthEquipamento;
            });
        }

        function listarPorEstadoConservacaoEEmpresaAtivoId(estadoConservacoes) {
            vm.emProgresso = true;

            var listaEstadoConservacao = [];
            estadoConservacoes.forEach(function (element) {
                listaEstadoConservacao.push(element.estadoConservacaoId);
            });
            vm.objData = {};
            vm.objData.empresaAtivoId = vm.empresaAtivoId;
            vm.objData.estadoConservacoes = listaEstadoConservacao;
            vm.objData.tipoEquipamento = estadoConservacoes[0].equipamentoDescricao;
            vm.mensagemPreloader = "Carregando...";
            return RequisicaoGenericaLocacaoService
                .listarComObjetoComplexo(Api.locacao.equipamentos.equipamento.listarPorEstadoConservacao, vm.objData)
                .then(function (succsses) {
                    vm.equipamentosTipo = succsses.data;
                    console.log(succsses.data);
                    dialogTipo();
                }, function (err) {
                }).finally(function () {
                    vm.emProgresso = false;
                });;
        }

        function dialogSituacao(event) {
            $mdDialog.show({
                controller: 'DialogSituacaoController',
                controllerAs: 'vm',
                templateUrl: vm.rotasHtml.dialogs.dialogSituacao,
                targetEvent: event,
                clickOutsideToClose: false,
                locals: {
                    Equipamento: vm.equipamentos,
                    EmpresaAtivoId: vm.empresaAtivoId
                }
            })
        }

        function dialogTipo(event) {
            $mdDialog.show({
                controller: 'DialogTipoController',
                controllerAs: 'vm',
                templateUrl: vm.rotasHtml.dialogs.dialogTipo,
                targetEvent: event,
                clickOutsideToClose: false,
                locals: {
                    Equipamento: vm.equipamentosTipo,
                    EmpresaAtivoId: vm.empresaAtivoId
                }
            });
        }

        function pesquisarPorSituacao(empresaAtivoId) {
            RequisicaoGenericaLocacaoService.listarSemParams(
                Api.locacao.equipamentos.equipamento.listarPorSituacao + empresaAtivoId
            ).then(function (success) {
                vm.equipamentoSituacao = success.data;
                vm.itemsCount = vm.equipamentoSituacao.length;
                vm.slidesToShow = 4;
                vm.itemWidth = 250;
                vm.slidesToMove = 1;
                vm.movePosition = vm.slidesToMove * vm.itemWidth;
                _inicializarCarrosselSituacao();
                _inicializarCarrosselEquipamentos();
            });
        }

        function pesquisarPorSituacaoFabricante(empresaAtivoId, situacaoCodigo, tituloDialog) {
            vm.emProgresso = true;

            var situacao = parseInt(situacaoCodigo);

            var inputModel = {
                empresaAtivoId: empresaAtivoId,
                situacaoCodigo: situacao
            }

            RequisicaoGenericaLocacaoService.salvar(Api.locacao.equipamentos.equipamento.listarPorSituacaoFabricante, inputModel)
                .then(function (success) {
                    console.log(success.data);
                    $mdDialog.show({
                        controller: 'DialogSituacaoFabricanteController',
                        controllerAs: 'vm',
                        templateUrl: vm.rotasHtml.dialogs.dialogSituacaoFabricante,
                        targetEvent: event,
                        clickOutsideToClose: false,
                        locals: {
                            EquipamentosFabricantes: success.data,
                            TituloDialog: tituloDialog
                        }
                    })
                }, function (error) {
                    console.log(error);
                }).finally(function () {
                    vm.emProgresso = false;
                });
        }

        function _inicializarCarrosselSituacao() {
            var positionSituacao = 0;
            vm.container = angular.element(".container-situacao");
            vm.track = angular.element(".track-situacao");
            vm.btnNext = angular.element(".btn-next");
            vm.btnPrev = angular.element(".btn-prev");

            vm.btnNext.click(function () {
                const itemsLeft =
                    vm.itemsCount - (Math.abs(positionSituacao) + vm.slidesToShow * vm.itemWidth) / vm.itemWidth;

                positionSituacao -=
                    itemsLeft >= vm.slidesToMove ? vm.movePosition : itemsLeft * vm.itemWidth;

                setPosition();
            });

            vm.btnPrev.click(function () {
                const itemsLeft = Math.abs(positionSituacao) / vm.itemWidth;

                positionSituacao +=
                    itemsLeft >= vm.slidesToMove ? vm.movePosition : itemsLeft * vm.itemWidth;

                setPosition();
            });

            const setPosition = function () {
                vm.track.css({
                    transform: "translateX(" + positionSituacao + "px)"
                });
                checkBtns();
            };

            const checkBtns = function () {
                vm.btnPrev.prop("disabled", positionSituacao === 0);
                vm.btnNext.prop(
                    "disabled",
                    positionSituacao <= -(vm.itemsCount - vm.slidesToShow) * vm.itemWidth
                );
            };

            checkBtns();

            if (window.matchMedia("(max-width: 640px)").matches) {
                vm.movePosition = 305;
                vm.itemWidth = vm.movePosition;
                vm.slidesToShow = 1;

                vm.movePositionEquipamento = 305;
                vm.itemWidthEquipamento = vm.movePositionEquipamento;
                vm.slidesToShowEquipamento = 1;
            }
        }

        function _inicializarCarrosselEquipamentos() {
            var positionEquipamento = 0;
            vm.containerEquipamento = angular.element(".container-equipamento");
            vm.trackEquipamento = angular.element(".track-equipamento");
            vm.btnNextEquipamento = angular.element('.btn-next1');
            vm.btnPrevEquipamento = angular.element(".btn-prev1");

            vm.btnNextEquipamento.click(function () {
                const itemsLeftEquip =
                    vm.itemsCountEquipamento - (Math.abs(positionEquipamento) + vm.slidesToShowEquipamento * vm.itemWidthEquipamento) / vm.itemWidthEquipamento;

                positionEquipamento -=
                    itemsLeftEquip >= vm.slidesToMoveEquipamento ? vm.movePositionEquipamento : itemsLeftEquip * vm.itemWidthEquipamento;

                setPositionEquipamento();
            });

            vm.btnPrevEquipamento.click(function () {
                const itemsLeftEquip = Math.abs(positionEquipamento) / vm.itemWidthEquipamento;

                positionEquipamento +=
                    itemsLeftEquip >= vm.slidesToMoveEquipamento ? vm.movePositionEquipamento : itemsLeftEquip * vm.itemWidthEquipamento;

                setPositionEquipamento();
            });

            const setPositionEquipamento = function () {
                vm.trackEquipamento.css({
                    transform: "translateX(" + positionEquipamento + "px)"
                });
                checkBtnsEquipamento();
            };

            const checkBtnsEquipamento = function () {
                vm.btnPrevEquipamento.prop("disabled", positionEquipamento === 0);
                vm.btnNextEquipamento.prop(
                    "disabled",
                    positionEquipamento <= -(vm.itemsCountEquipamento - vm.slidesToShowEquipamento) * vm.itemWidthEquipamento
                );
            };

            checkBtnsEquipamento();
        };
    }
})();

(function () {
    'use strict'

    angular
        .module('app.locacao.processamento.troca_ativo')
        .controller('TrocaAtivoController', TrocaAtivoController);

    function TrocaAtivoController(
        ListarEmpresaAtivo,
        ListarObjetivoNota,
        ListarFornecedor,
        ListarSituacoes,
        RotasHtml,
        DatatableFactory,
        TrocaAtivoService,
        MdDialogService,
        LoginUsuarioService,
        $mdDialog
    ) {
        var vm = this;

        vm.empresaAtivoId = 0;
        vm.nota = {};
        vm.equipamentos = [];
        vm.equipamentosTroca = [];
        vm.equipamentosBkp = [];
        vm.resumoTroca = [];
        vm.resumoTrocaEquipamentos = [];
        vm.valorTotalResumo = 0;
        vm.valorTotalResumoEquipamentos = 0;

        vm.empresaAtivo = ListarEmpresaAtivo.data;
        vm.fornecedor = ListarFornecedor.data;
        vm.objetivoNota = ListarObjetivoNota.data;
        vm.situacoes = ListarSituacoes.data;

        vm.formaPagamento = [
            { codigo: 1, descricao: "Á vista" },
            { codigo: 2, descricao: "Parcelado" }
        ];

        vm.etapa = { codigo: 1, estado: "trocaEquipamento" };

        vm.etapas = [
            { codigo: 1, estado: "trocaEquipamento" },
            { codigo: 2, estado: "notaFiscal", descricao: "- NF" },
            { codigo: 3, estado: "resumoTroca" }
        ];

        vm.htmlRota = RotasHtml.troca_ativo;

        init();

        vm.metodos = {
            pesquisar: pesquisar,
            adicionarEquipamento: adicionarEquipamento,
            removerEquipamento: removerEquipamento,
            proximaEtapa: proximaEtapa,
            voltarEtapa: voltarEtapa,
            salvarTroca: salvarTroca,
            abrirDialogDetalheItem: abrirDialogDetalheItem,
            abrirDialogDetalheEquipamento: abrirDialogDetalheEquipamento,
            retornarDescricaoSituacao: retornarDescricaoSituacao,
            selecionarAgrupamentoEquipamentos: selecionarAgrupamentoEquipamentos
        }

        function init() {
            _reiniciarDadosNota();

            vm.dtOptionsOrigem = DatatableFactory.construirDtOptionsResponsivoSemPaginacaoPadraoComPesquisaHeaderPadrao([
                {
                    targets: [0],
                    orderable: false
                },
                {
                    targets: [0],
                    width: '5%'
                }
            ]);

            vm.dtOptionsOrigem.dom = '<"top"<"right"<"filter"f>>>rt<"bottom"<"left"<"info"i>>>';
            vm.dtOptionsOrigem.order = [1, 'asc'];
            vm.dtOptionsOrigem.oLanguage.sSearch = "_INPUT_";
            vm.dtOptionsOrigem.scrollY = '60vh';
            vm.dtOptionsOrigem.scrollCollapse = true;

            vm.dtOptionsDestino = DatatableFactory.construirDtOptionsResponsivoSemPaginacaoPadraoComPesquisaHeaderPadrao([
                {
                    targets: [0, 3],
                    orderable: false
                },
                {
                    targets: [0],
                    width: '5%'
                }
            ]);

            vm.dtOptionsDestino.dom = '<"top"<"right"<"filter"f>>>rt<"bottom"<"left"<"info"i>>>';
            vm.dtOptionsDestino.order = [1, 'asc'];
            vm.dtOptionsDestino.oLanguage.sSearch = "_INPUT_";
            vm.dtOptionsDestino.oLanguage.sEmptyTable = "---";
            vm.dtOptionsDestino.scrollY = '60vh';
            vm.dtOptionsDestino.scrollCollapse = true;

            TrocaAtivoService.listarEstadoConservacao().then(function (success) {
                vm.estadosConservacao = success.data;
            });
        }

        function pesquisar(empresaAtivo) {
            vm.emProgresso = true;

            vm.equipamentos = [];
            vm.equipamentosTroca = [];
            vm.equipamentosBkp = [];

            _reiniciarDadosNota();

            TrocaAtivoService.listarEquipamentosEmpresaAtivo(empresaAtivo)
                .then(function (success) {
                    vm.equipamentos = success.data;
                    vm.equipamentosBkp = angular.copy(vm.equipamentos);
                    vm.equipamentos.map(function (equipamento) {
                        equipamento.valor = null;
                    });
                }, function (error) {
                    MdDialogService.alertPadrao(error.data, null);
                }).finally(function () {
                    vm.emProgresso = false;
                });
        }

        function adicionarEquipamento() {
            _moverEquipamentos(vm.equipamentos, vm.equipamentosTroca, _equipamentoSelecionado);
        }

        function removerEquipamento() {
            _moverEquipamentos(vm.equipamentosTroca, vm.equipamentos, _equipamentoSelecionado);
        }

        function proximaEtapa() {
            var indice = vm.etapas.findIndex(function (etapa) {
                return etapa.estado === vm.etapa.estado
            });

            if ((indice + 1) < (vm.etapas.length)) {
                vm.etapa = vm.etapas[indice + 1];
            } else {
                vm.etapa = vm.etapas[vm.etapas.length];
            }

            if (vm.etapa.estado == 'notaFiscal') {
                vm.nota.valorTotalNota = 0;

                vm.equipamentosTroca.map(function (equipamento) {
                    vm.nota.valorTotalNota += equipamento.valor;
                });
            }

            if (vm.etapa.estado == 'resumoTroca') {
                vm.emProgresso = true;

                var inputModel = {
                    equipamentos: vm.equipamentosTroca
                };

                TrocaAtivoService.retornarResumoEquipamentosEmpresa(inputModel)
                    .then(function (success) {
                        _prepararResumoTroca(success.data);
                    }, function (error) {
                        MdDialogService.alertPadrao(error.data, null);
                        voltarEtapa();
                    }).finally(function () {
                        vm.emProgresso = false;
                    });
            }
        }

        function voltarEtapa() {
            var indice = vm.etapas.findIndex(function (etapa) {
                return etapa.estado === vm.etapa.estado
            });

            if ((indice - 1) > 0) {
                vm.etapa = vm.etapas[indice - 1];
            } else {
                vm.etapa = vm.etapas[0];
            }
        }

        function salvarTroca() {
            vm.emProgresso = true;

            var inputModel = vm.nota;

            inputModel.codigoUsuario = LoginUsuarioService.usuarioArmazenado().codigo;
            inputModel.nomeUsuario = LoginUsuarioService.usuarioArmazenado().login;
            inputModel.equipamentos = vm.resumoTroca;

            TrocaAtivoService.realizarTrocaAtivo(inputModel)
                .then(function (success) {
                    MdDialogService.alertPadraoComEvento("Troca realizada com sucesso.", function () { _reiniciarRotina() });
                }, function (error) {
                    MdDialogService.alertPadrao(error.data.error[0], null);

                    vm.emProgresso = false;
                });
        }

        function abrirDialogDetalheItem(item) {

            $mdDialog
                .show({
                    controller: "DialogDetalheItemController",
                    controllerAs: "vm",
                    templateUrl: "app/main/locacao/processamento/troca-ativo/views/dialogs/dialog-detalhe-item/dialog-detalhe-item.html",
                    multiple: true,
                    targetEvent: event,
                    clickOutsideToClose: false,
                    locals: {
                        ItemDetalhes: item,
                        Nota: vm.nota
                    }
                });
        }

        function abrirDialogDetalheEquipamento(equipamento) {
            equipamento.estadosConservacaoDescricao = _retornarDescricaoEstadoConservacao(equipamento.equipamentoEstadoConservacaoId);

            $mdDialog
                .show({
                    controller: "DialogDetalheEquipamentoController",
                    controllerAs: "vm",
                    templateUrl: "app/main/locacao/processamento/troca-ativo/views/dialogs/dialog-detalhe-equipamento/dialog-detalhe-equipamento.html",
                    multiple: true,
                    targetEvent: event,
                    clickOutsideToClose: false,
                    locals: {
                        DetalheEquipamento: equipamento
                    }
                });
        }

        function retornarDescricaoSituacao(id) {
            var descricao = "";


            vm.situacoes.map(function (situacao) {
                if (situacao.id == id) descricao = situacao.descricao;
            });

            return descricao;
        }

        function selecionarAgrupamentoEquipamentos(resumoEquipamentos) {
            var arrayEquipamentos = [];
            vm.resumoTrocaEquipamentos = [];
            vm.valorTotalResumoEquipamentos = resumoEquipamentos.preco;

            resumoEquipamentos.detalhes.map(function (detalhe) {
                detalhe.descricao = resumoEquipamentos.descricao;
                arrayEquipamentos.push(detalhe);
            });

            vm.resumoTrocaEquipamentos = arrayEquipamentos;
            _selecionarAgrupamento(resumoEquipamentos);
        }

        function _moverEquipamentos(origem, destino, equipamentoSelecionado) {
            for (var i = 0; i < origem.length; i++) {
                var equipamento = origem[i];
                if (equipamentoSelecionado(equipamento)) {
                    equipamento.valor = null;
                    origem.splice(i, 1);
                    destino.push(equipamento);
                    i--;
                }
            }
        }

        function _equipamentoSelecionado(element) {
            if (element.selecionado) {
                element.selecionado = false;
                return true;
            }
        }

        function _selecionarAgrupamento(resumoEquipamentos) {

            vm.resumoTroca.forEach(function (resumo) {
                if (resumo.selecionado) resumo.selecionado = false;
            });

            resumoEquipamentos.selecionado = true;
        }

        function _prepararResumoTroca(dados) {
            vm.resumoTroca = dados;
            vm.resumoTrocaEquipamentos = [];
            vm.valorTotalResumo = 0;
            vm.valorTotalResumoEquipamentos = 0;

            vm.resumoTroca.map(function (resumo) {
                vm.valorTotalResumo += resumo.preco;
            });
        }

        function _retornarDescricaoEstadoConservacao(id) {
            var descricao = "";
            vm.estadosConservacao.map(function (estado) {
                if (estado.id == id) descricao = estado.descricao;
            });

            return descricao;
        }

        function _reiniciarRotina() {
            vm.empresaAtivoId = 0;

            vm.equipamentos = [];
            vm.equipamentosTroca = [];
            vm.equipamentosBkp = [];
            vm.resumoTroca = [];
            vm.resumoTrocaEquipamentos = [];
            vm.valorTotalResumo = 0;
            vm.valorTotalResumoEquipamentos = 0;
            vm.etapa = { codigo: 1, estado: "trocaEquipamento" };
            vm.emProgresso = false;

            _reiniciarDadosNota();
        }

        function _reiniciarDadosNota() {
            vm.nota = {};
            vm.nota.dataNotaEntrada = new Date(Date.now());
            vm.nota.observacao = "";
        }
    }
})();
(function () {
  "use strict";

  angular
    .module("app.locacao.processamento.nota")
    .controller("NotaController",NotaController);

  function NotaController(
    Api,
    RequisicaoGenericaLocacaoService,
    NavegacaoService,
    $mdDialog,
    RotasHtml,
    MdToastService,
    ListarFornecedor,
    ListarObjetivoNota,
    ListarEquipamento,
    ListarEmpresaAtivo,
    Listarsituacao,
    ListarEstadoConservacao,
    MdDialogService,
    $mdSidenav,
    $timeout
  ) {
    var vm = this;
    vm.transicao = true;
    vm.fornecedor = ListarFornecedor.data;
    vm.notas = [];
    vm.notaitens = [];
    vm.filtro = {};
    vm.notaitensDetalhes = [];
    vm.detalhes = [];
    vm.clicado = null;
    vm.expandirItens = false;
    vm.expandirDetalhes = false;
    vm.rotasHtmlNota = RotasHtml.nota;
    NavegacaoService.setTituloAba("Nota");

    vm.metodos = {
      excluir: excluir,
      abrirDialogNota: abrirDialogNota,
      pesquisarItensNota: pesquisarItensNota,
      abrirDialogNotaEdicao: abrirDialogNotaEdicao,
      abrirDialogNotaVisualizacao: abrirDialogNotaVisualizacao,
      filtrarNota: filtrarNota,
      cadastro: cadastro
    };
    vm.metodosNotaItem = {
      excluirItem: excluirItem,
      abrirDialogNotaItem: abrirDialogNotaItem,
      abrirDialogNotaItemEdicao: abrirDialogNotaItemEdicao,
      abrirDialogNotaItemVisualizacao: abrirDialogNotaItemVisualizacao,
      pesquisarDetalhesItensNota: pesquisarDetalhesItensNota,
      validaTotalItens: validaTotalItens
    };

    vm.metodosDetalhe = {
      abrirDialogDetalhe: abrirDialogDetalhe,
      abrirDialogDetalheVisualizacao: abrirDialogDetalheVisualizacao,
      abrirDialogDetalheEditar: abrirDialogDetalheEditar,
      excluirDetalhe: excluirDetalhe
    };
    vm.toggleLeft = buildDelayedToggler("left");
    vm.toggleRight = buildToggler("right");
    vm.isOpenRight = function () {
      return $mdSidenav("right").isOpen();
    };

    function cadastro() {
      vm.transicao = false;
    }

    vm.close = function () {
      // Component lookup should always be available since we are not using `ng-if`
      $mdSidenav("right").close();
    };

    function debounce(func,wait) {
      var timer;

      return function debounced() {
        var context = this,
          args = Array.prototype.slice.call(arguments);
        $timeout.cancel(timer);
        timer = $timeout(function () {
          timer = undefined;
          func.apply(context,args);
        },wait || 10);
      };
    }

    function buildDelayedToggler(navID) {
      return debounce(function () {
        // Component lookup should always be available since we are not using `ng-if`
        $mdSidenav(navID).toggle();
      },200);
    }

    function buildToggler(navID) {
      return function () {
        // Component lookup should always be available since we are not using `ng-if`
        $mdSidenav(navID).toggle();
      };
    }

    //#region ------------------------------------------- NOTA --------------------------------------------

    function filtrarNota(filtro) {
      cadastro();
      vm.requisicaoSolicitada = true;
      if (filtro.fornecedorId == undefined)
        filtro.fornecedorId = 0;
      if (filtro.numeroNota == undefined)
        filtro.numeroNota = ""
      RequisicaoGenericaLocacaoService.listarComObjetoComplexo(Api.locacao.nota.listarPorFiltro,filtro)
        .then(function (success) {
          vm.notas = [];
          vm.expandirItens = false;
          vm.expandirDetalhes = false;
          vm.notaitens = [];
          vm.notaitensDetalhes = [];
          vm.clicado = null;
          vm.notas = success.data;
          vm.requisicaoSolicitada = false;
          filtro.fornecedorId = null;
          filtro.numeroNota = null;
          if (vm.notas.length <= 0)
            MdDialogService.alertPadrao("Não foram encontrados registros");

        })
      vm.close();

    }

    function excluir(modelo,index) {
      MdDialogService.confirmPadraoComEvento("Deseja mesmo excluir este item?",null,event,function () {
        return RequisicaoGenericaLocacaoService.excluir(
          Api.locacao.nota.remover,
          modelo.id
        ).then(
          function (success) {
            MdToastService.toastPadrao("Nota removida com sucesso!");
            vm.notas.splice(vm.notas.indexOf(modelo),1);
            if (vm.notaVinculada.id == modelo.id) {
              vm.expandirItens = false;
              vm.expandirDetalhes = false;
              vm.notaitens = [];
              vm.notaitensDetalhes = [];
              vm.clicado = null;
            }
          },
          function (err) {
            MdDialogService.alertPadrao("Atenção",event,err.data.error);
          }
        );
      },function () {

      });
    }

    function abrirDialogNota(event) {
      $mdDialog
        .show({
          controller: "DialogNotaController",
          controllerAs: "vm",
          templateUrl: vm.rotasHtmlNota.dialog_nota,
          multiple: true,
          targetEvent: event,
          clickOutsideToClose: false,
          locals: {
            Nota: null,
            ApenasVisualizacao: false,
            Forncededores: ListarFornecedor.data,
            ObjetivoNotas: ListarObjetivoNota.data,
            EmpresasAtivos: ListarEmpresaAtivo.data
          }
        })
        .then(function (success) {
          if (success != undefined) {
            MdToastService.toastPadrao("Nota cadastrada com sucesso!");
            vm.notas.push(success);
          }
        });
    }

    function abrirDialogNotaEdicao(event,nota,index) {
      $mdDialog
        .show({
          controller: "DialogNotaController",
          controllerAs: "vm",
          templateUrl: vm.rotasHtmlNota.dialog_nota,
          multiple: true,
          targetEvent: event,
          clickOutsideToClose: false,
          locals: {
            Nota: nota,
            ApenasVisualizacao: false,
            Forncededores: ListarFornecedor.data,
            ObjetivoNotas: ListarObjetivoNota.data,
            EmpresasAtivos: ListarEmpresaAtivo.data
          },
        })
        .then(function (success) {
          if (success != undefined) {
            MdToastService.toastPadrao("Nota editada com sucesso!");
            vm.notas[vm.notas.indexOf(nota)] = success;

          }
        });
    }

    function abrirDialogNotaVisualizacao(event,nota) {
      $mdDialog.show({
        controller: "DialogNotaController",
        controllerAs: "vm",
        templateUrl: vm.rotasHtmlNota.dialog_nota,
        multiple: true,
        targetEvent: event,
        clickOutsideToClose: false,
        locals: {
          Nota: nota,
          ApenasVisualizacao: true,
          Forncededores: ListarFornecedor.data,
          ObjetivoNotas: ListarObjetivoNota.data,
          EmpresasAtivos: ListarEmpresaAtivo.data
        },
      });
    }

    function somaTotais(success) {
      vm.precoTotalItens = 0;
      success.map(function (item) {
        vm.precoTotalItens += item.preco;
      });
    }

    function somaTotaisDetalhe(success) {
      vm.precoTotalItensDetalhe = 0;
      success.map(function (item) {
        vm.precoTotalItensDetalhe += item.precoUnitario;
      });
    }

    function pesquisarItensNota(nota,index) {
      vm.expandirDetalhes = false;
      vm.itemClicado = null;
      vm.buscando = true;
      vm.clicado = nota.id;
      vm.notaVinculada = nota;
      RequisicaoGenericaLocacaoService.listarSemParams(
        Api.locacao.nota_item.listarPorNota + nota.id
      ).then(
        function (success) {
          vm.notaitens = success.data;
          vm.buscando = false;
          validaTotalItens(vm.notaitens);
          somaTotais(success.data);
        },
        function (err) {
          console.log(err.data.error);
        }
      );
      vm.expandirItens = true;

    }
    //#endregion ------------------------------------------------------------------


    //#region ----------------------------------------------NOTA_ITEM------------------------------------------

    function excluirItem(modelo) {
      MdDialogService.confirmPadraoComEvento("Deseja mesmo excluir este item?",null,event,function () {
        return RequisicaoGenericaLocacaoService.excluir(
          Api.locacao.nota_item.remover,
          modelo.id
        ).then(
          function (success) {
            MdToastService.toastPadrao("Item removido com sucesso!");
            vm.notaitens.splice(vm.notaitens.indexOf(modelo),1);
            if (vm.itemVinculado.id == modelo.id) {
              vm.expandirDetalhes = false;
              vm.notaitensDetalhes = [];
            }
          },
          function (err) {
            MdDialogService.alertPadrao("Atenção",event,err.data.error);
          }
        );
      },function () {

      });

    }

    function validaTotalItens(itens) {
      if (itens == undefined)
        return;
      vm.total = itens.reduce(function (acumulador,atual) {
        return acumulador + atual.preco;
      },0)

      if (vm.total.toFixed(2) < vm.notaVinculada.valorTotalNota)
        vm.flagValor = true;
      else
        vm.flagValor = false;

      return vm.flagValor;
    }

    function abrirDialogNotaItem(event) {
      $mdDialog
        .show({
          controller: "DialogNotaItemController",
          controllerAs: "vm",
          templateUrl: vm.rotasHtmlNota.dialog_item,
          multiple: true,
          targetEvent: event,
          clickOutsideToClose: false,
          locals: {
            NotaVinculada: vm.notaVinculada,
            NotaItem: null,
            Itens: vm.itens,
            ApenasVisualizacao: false,
            Equipamentos: ListarEquipamento.data
          }
        })
        .then(function (success) {
          if (success != undefined) {
            MdToastService.toastPadrao("Item cadastrado com sucesso!");
            vm.notaitens.push(success);
            validaTotalItens(vm.notaitens);
            somaTotais(vm.notaitens);
          }
        });
    }

    function abrirDialogNotaItemEdicao(event,item,index) {
      $mdDialog
        .show({
          controller: "DialogNotaItemController",
          controllerAs: "vm",
          templateUrl: vm.rotasHtmlNota.dialog_item,
          multiple: true,
          targetEvent: event,
          clickOutsideToClose: false,
          locals: {
            NotaVinculada: vm.notaVinculada,
            NotaItem: item,
            Itens: vm.itens,
            ApenasVisualizacao: false,
            Equipamentos: ListarEquipamento.data
          }
        })
        .then(function (success) {
          if (success != undefined) {
            MdToastService.toastPadrao("Item editado com sucesso!");
            vm.notaitens[vm.notaitens.indexOf(item)] = success;
            validaTotalItens(vm.notaitens);
            somaTotais(vm.notaitens);
            if (vm.itemVinculado.id == success.id)
              vm.itemVinculado = success;
          }
        });
    }

    function abrirDialogNotaItemVisualizacao(event,item) {
      $mdDialog.show({
        controller: "DialogNotaItemController",
        controllerAs: "vm",
        templateUrl: vm.rotasHtmlNota.dialog_item,
        multiple: true,
        targetEvent: event,
        clickOutsideToClose: false,
        locals: {
          NotaVinculada: vm.notaVinculada,
          NotaItem: item,
          Itens: vm.itens,
          ApenasVisualizacao: true,
          Equipamentos: ListarEquipamento.data
        }
      });
    }

    function pesquisarDetalhesItensNota(item,index) {
      vm.itemClicado = item.id;
      vm.itemVinculado = item;
      vm.buscandoDetalhe = true;
      RequisicaoGenericaLocacaoService.listarSemParams(
        Api.locacao.nota_item_detalhe.listarPorItem + item.id
      ).then(
        function (success) {
          vm.notaitensDetalhes = success.data;
          vm.buscandoDetalhe = false;
          validaTotalDetalhes(vm.notaitensDetalhes);
          somaTotaisDetalhe(vm.notaitensDetalhes);
        },
        function (err) {
          console.log(err.data.error);
        }
      );
      vm.expandirDetalhes = true;
    }

    //#endregion

    //#region -------------------------------------ITEM_DETALHE---------------------------------------------

    function abrirDialogDetalhe(event) {
      $mdDialog
        .show({
          controller: "DialogNotaItemDetalheController",
          controllerAs: "vm",
          templateUrl: vm.rotasHtmlNota.dialog_item_detalhe,
          multiple: true,
          targetEvent: event,
          clickOutsideToClose: false,
          locals: {
            ItemVinculado: vm.itemVinculado,
            Situacao: Listarsituacao.data,
            Detalhe: null,
            ApenasVisualizacao: false,
            EstadoConservacao: ListarEstadoConservacao

          }
        })
        .then(function (success) {
          if (success != undefined) {
            MdToastService.toastPadrao("Detalhe cadastrado com sucesso!");
            vm.notaitensDetalhes.push(success);
            validaTotalDetalhes(vm.notaitensDetalhes);
            somaTotaisDetalhe(vm.notaitensDetalhes);
            MdDialogService.confirmPadraoComEvento(
              "Deseja Cadastrar mais detalhes?",
              null,
              event,
              function () {
                abrirDialogDetalhe();
              },
              function () { }
            );
          }
        });
    }

    function validaTotalDetalhes(detalhes) {
      if (detalhes == undefined)
        return;
      vm.totalDetalhes = detalhes.reduce(function (acumulador,atual) {   
        return acumulador + atual.precoUnitario;
      },0)

      if (vm.totalDetalhes.toFixed(2) < vm.itemVinculado.preco || detalhes.length < vm.itemVinculado.quantidade)
        vm.flagValorDetalhe = true;
      else
        vm.flagValorDetalhe = false;

      return vm.flagValorDetalhe;
    }

    function abrirDialogDetalheEditar(event,detalhe,index) {
      $mdDialog
        .show({
          controller: "DialogNotaItemDetalheController",
          controllerAs: "vm",
          templateUrl: vm.rotasHtmlNota.dialog_item_detalhe,
          multiple: true,
          targetEvent: event,
          clickOutsideToClose: false,
          locals: {
            ItemVinculado: vm.itemVinculado,
            Situacao: Listarsituacao.data,
            Detalhe: detalhe,
            ApenasVisualizacao: false,
            EstadoConservacao: ListarEstadoConservacao
          },
        })
        .then(function (success) {
          if (success != undefined) {
            MdToastService.toastPadrao("Detalhe editado com sucesso!");
            vm.notaitensDetalhes[
              vm.notaitensDetalhes.indexOf(detalhe)
            ] = success;
            validaTotalDetalhes(vm.notaitensDetalhes);
            somaTotaisDetalhe(vm.notaitensDetalhes);
          }
        });
    }


    function abrirDialogDetalheVisualizacao(event,detalhe) {
      $mdDialog
        .show({
          controller: "DialogNotaItemDetalheController",
          controllerAs: "vm",
          templateUrl: vm.rotasHtmlNota.dialog_item_detalhe,
          multiple: true,
          targetEvent: event,
          clickOutsideToClose: false,
          locals: {
            ItemVinculado: vm.itemVinculado,
            Situacao: Listarsituacao.data,
            Detalhe: detalhe,
            ApenasVisualizacao: true,
            EstadoConservacao: ListarEstadoConservacao
          }
        });
    }

    function excluirDetalhe(modelo) {
      MdDialogService.confirmPadraoComEvento(
        "Deseja mesmo excluir este item?",
        null,
        event,
        function () {
          return RequisicaoGenericaLocacaoService.excluir(
            Api.locacao.nota_item_detalhe.remover,
            modelo.id
          ).then(
            function (success) {
              MdToastService.toastPadrao("Detalhe removido com sucesso!");
              vm.notaitensDetalhes.splice(vm.notaitensDetalhes.indexOf(modelo),1);
              somaTotaisDetalhe(vm.notaitensDetalhes);

            },
            function (err) {
              MdDialogService.alertPadrao("Atenção",event,err.data.error);
            }
          );
        },
        function () { }
      );

    }

    //#endregion ------------------------------------------------------------------

  }
})();

(function () {
  "use strict";

  angular
    .module("app.locacao.processamento.revenda", [])
    .config(config);

  function config($stateProvider, RotasHtml) {
    var rotasHtmlRevenda = RotasHtml.revenda_equipamento;
    $stateProvider.state(
      "app.locacao_processamento_revenda",
      {
        url: "/locacao/processamento/revenda",
        module: "privado",
        views: {
          "content@app": {
            templateUrl: rotasHtmlRevenda.templateUrl,
            controller: "RevendaController as vm"
          }
          // "tipo-locacao-form@app.locacao_processamento_revenda": {
          //   templateUrl: rotasHtmlNota.form
          // }
          // "tipo-locacao-tabela@app.locacao_processamento_revenda": {
          //   templateUrl: rotasHtmlNota.tabela
          // }
        },
        resolve: {
          ListarClientes: function (Api, RequisicaoGenericaService) {
            return RequisicaoGenericaService.listarSemParams(Api.protecao.atualizacaoLicenca.listar);
          },
          ListarSituacoes: function (Api, RequisicaoGenericaLocacaoService) {
            return RequisicaoGenericaLocacaoService.listarSemParams(Api.locacao.equipamentos.equipamentoSituacao.listarPorFinalizarProcesso);
          },
          ListarTodosClientes: function (Api, RequisicaoGenericaService) {
            return RequisicaoGenericaService.listarSemParams(Api.cliente.listarCodigoDescricao);
          },
        }
      }
    );
  }
})();

(function () {
    "use strict";

    angular
        .module("app.locacao.processamento.revenda")
        .controller("RevendaController", RevendaController);

    function RevendaController(
        Api,
        RequisicaoGenericaLocacaoService,
        RequisicaoGenericaService,
        NavegacaoService,
        LoginUsuarioService,
        MdDialogService,
        MdToastService,
        ListarClientes,
        ListarSituacoes,
        ListarTodosClientes
    ) {
        var vm = this;
        NavegacaoService.setTituloAba("Revenda");

        vm.clientes = ListarClientes.data;
        vm.clientesDetalhe = ListarClientes.data;
        vm.listaTodosClientes = ListarTodosClientes.data;
        vm.filtroClientes = vm.clientes.clientes;
        vm.filtroClientesDetalhe = vm.clientes.clientes;
        vm.filtroClientesDetalhesSituacao = vm.listaTodosClientes;
        vm.situacoes = ListarSituacoes.data;
        vm.clienteObrigatorio = false;
        vm.pesquisando = false;
        vm.atendimentoObrigatorio = true;
        vm.verificaDataAtual = false;
        vm.dataAtual = new Date(Date.now());

        vm.metodos = {
            pesquisarAutoCompleteCliente: pesquisarAutoCompleteCliente,
            pesquisarAutoCompleteClienteDetalhe: pesquisarAutoCompleteClienteDetalhe,
            alterarItemSelecionadoAutoCompleteCliente: alterarItemSelecionadoAutoCompleteCliente,
            pesquisarEquipamentos: pesquisarEquipamentos,
            verificaEnvioClienteObrigatorio: verificaEnvioClienteObrigatorio,
            passarParaRevenda: passarParaRevenda,
            pesquisarDisponiveis: pesquisarDisponiveis,
            pesquisarRevendas: pesquisarRevendas,
            teclaEnter: teclaEnter,
            teclaEnterRevenda: teclaEnterRevenda,
            limparInputDisponiveis: limparInputDisponiveis,
            limparInputRevenda: limparInputRevenda,
            passarParaDisponiveis: passarParaDisponiveis,
            criarRevenda: criarRevenda,
            verificarDataMaiorQueAtual: verificarDataMaiorQueAtual,
            marcarTodosDisponiveis: marcarTodosDisponiveis,
            marcarTodosRevenda: marcarTodosRevenda
        };

        init();

        function init() {
            _filtrarSituacao();
            _limparCampos();
            vm.equipamentosParaRevenda = [];
            vm.filtro.tipoPesquisaEnvio = 1;
        }

        function _limparCampos() {
            vm.equipamentosDispoiniveis = {};
            vm.filtro = {};
            vm.equipamentosParaRevenda = {};
            vm.equipamentosDispoiniveisOriginais = {};
            vm.pesquisa = null;
        }

        function _limparFormularioRevenda() {
            vm.filtro.clienteDetalhe = null;
            vm.filtro.atendimentoCodigo = null;
            vm.filtro.notaFiscal = null;
            vm.filtro.periodoGarantia = null;
            vm.filtro.dataRevenda = null;
        }

        function verificarDataMaiorQueAtual(data) {
            if (data > vm.dataAtual)
                vm.habilitarBtnSalvarRevenda = true;
            else
                vm.habilitarBtnSalvarRevenda = false;
        }

        function limparInputDisponiveis() {
            vm.pesquisa = null;
        }

        function limparInputRevenda() {
            vm.pesquisaRevenda = null;
        }

        // Métodos do auto complete
        function pesquisarAutoCompleteCliente(query) {
            var resultado = vm.filtroClientes.filter(function (cliente) {
                if (cliente.nome.toLowerCase().includes(query.toLowerCase()) ||
                    cliente.codigo == query) {
                    return cliente;
                }
            });
            return resultado;
        }

        function pesquisarAutoCompleteClienteDetalhe(query) {
            query = query.toLowerCase();
            if (vm.filtro.tipoPesquisaEnvio == 1) {
                var resultado = vm.filtroClientesDetalhe.filter(function (cliente) {
                    if (cliente.nome.toLowerCase().includes(query) ||
                        cliente.codigo == query) {
                        return cliente;
                    }
                });
                return resultado;
            }
            if (vm.filtro.tipoPesquisaEnvio == 2) {
                var resultado = vm.listaTodosClientes.filter(function (cliente) {
                    if (cliente.nome.toLowerCase().includes(query) ||
                        cliente.codigo == query) {
                        return cliente;
                    }
                });
                return resultado;
            }
        }

        function marcarTodosDisponiveis(modelo) {
            vm.equipamentosDispoiniveis.map(function (item) {
                item.marcado = modelo;
            });
        }

        function marcarTodosRevenda(modelo) {
            vm.equipamentosParaRevenda.map(function (item) {
                item.marcado = modelo;
            });
        }

        function alterarItemSelecionadoAutoCompleteCliente(item) {
            vm.filtro.atendimentoCodigo = null;
            vm.filtro.dataRevenda = null;
            vm.filtro.notaFiscal = null;
            vm.filtro.periodoGarantia = null;
            vm.atendimentoObrigatorio = false;
            if (item) {
                vm.filtro.cliente = item;
                _listarAtendimento(vm.filtro.cliente.codigo);
            } else {
                vm.filtro.cliente = null;
            }
        }

        // ---------------------------------
        function _filtrarSituacao() {
            vm.situacoesFiltradas = vm.situacoes.filter(function (item) {
                if (item.id != 7 && item.id != 2 && item.id != 9)
                    return item;
            });
        }

        function pesquisarEquipamentos(event, modelo) {
            vm.equipamentosParaRevenda = [];
            vm.pesquisando = true;
            vm.mensagemPreloader = "Carregando..."
            if (modelo.item)
                modelo.codigoCliente = modelo.item.codigo;

            if (modelo.tipoPesquisaEnvio == "1") {
                modelo.codigoFiltro = [];
                modelo.codigoFiltro = [2];
            }

            RequisicaoGenericaLocacaoService.listarComObjetoComplexo(Api.locacao.equipamentoRevenda.listarPorSituacao, modelo)
                .then(function (success) {
                    vm.pesquisando = false;
                    vm.mensagemPreloader = ""
                    vm.equipamentosDispoiniveisOriginais = success.data;
                    vm.equipamentosDispoiniveis = success.data;
                    _limparFormularioRevenda();

                    if (vm.equipamentosDispoiniveis.length <= 0) {
                        MdDialogService.alertPadrao("Atenção! ", null, "Não há dados para a consulta realizada!");
                        return;
                    }
                });
        }

        function criarRevenda(event, modelo) {
            vm.pesquisando = true;
            vm.mensagemPreloader = "Salvando..."

            modelo.equipamentosRevendaEntradaViewModel = [];

            vm.equipamentosParaRevenda.map(function (equipamento) {
                var objetoEquipamento = {};
                objetoEquipamento.detalheCodigo = equipamento.detalheCodigo;
                objetoEquipamento.equipamentoCodigo = equipamento.equipamentoCodigo;
                modelo.equipamentosRevendaEntradaViewModel.push(objetoEquipamento);
            });

            modelo.clienteCodigo = modelo.cliente.codigo;
            modelo.usuarioNome = LoginUsuarioService.usuarioArmazenado().login;
            modelo.usuarioCodigo = LoginUsuarioService.usuarioArmazenado().codigo;
            vm.mensagemPreloader = "Salvando.."
            RequisicaoGenericaLocacaoService.salvar(Api.locacao.equipamentoRevenda.criar, modelo)
                .then(function (success) {
                    vm.pesquisando = false;
                    vm.mensagemPreloader = ""
                    MdDialogService.alertPadrao("Revenda realizada com sucesso!", success);
                    MdToastService.toastPadrao("Revenda realizada com sucesso!");
                    _limparCampos();
                });
        }

        function _listarAtendimento(codigo) {
            RequisicaoGenericaService.listarSemParams(
                Api.atendimento.retornarAtendimentoPorCodigoCliente + codigo
            ).then(function (success) {
                vm.atendimentos = success.data;
            });
        }

        function verificaEnvioClienteObrigatorio(filtro) {
            if (filtro.tipoPesquisaEnvio == "2" && filtro.item) {
                filtro.item = null;
                filtro.codigoFiltro = null;
            }

            if (filtro.tipoPesquisaEnvio == "1")
                filtro.codigoFiltro = null;
        }

        // Disponiveis para Revenda
        function passarParaRevenda() {
            vm.marcarTodos = false;
            vm.marcarTodosRevenda = false;
            var equipamentosSelecionadosParaRevenda = vm.equipamentosDispoiniveis.filter(function (equipamentos) {
                if (equipamentos.marcado) {
                    equipamentos.marcado = false;
                    return equipamentos;
                }
            });

            equipamentosSelecionadosParaRevenda.forEach(function (item) {
                _adicionarParaRevenda(item);
            });

            _removerEquipamentosJaAdicionadosParaRevenda();
        }

        function _removerEquipamentosJaAdicionadosParaRevenda() {
            vm.marcarTodos = false;
            vm.marcarTodosRevenda = false;
            vm.equipamentosDispoiniveis = vm.equipamentosDispoiniveis.filter(function (item) {
                var equipamentoAdicionadoRevenda = _consultarEquipamentosNaRevenda(item);
                return !equipamentoAdicionadoRevenda;
            });
        }

        function _adicionarParaRevenda(item) {
            vm.marcarTodos = false;
            vm.marcarTodosRevenda = false;
            var equipAdicionadoNaRevenda = _consultarEquipamentosNaRevenda(item);

            if (!equipAdicionadoNaRevenda) {
                vm.equipamentosParaRevenda.push(item);
                vm.equipamentosParaRevendaOriginal = vm.equipamentosParaRevenda;
            }
        }

        function _consultarEquipamentosNaRevenda(equipamento) {
            vm.marcarTodos = false;
            vm.marcarTodosRevenda = false;
            return vm.equipamentosParaRevenda.filter(function (equip) {
                if (equip.numeroSerie == equipamento.numeroSerie)
                    return equip;
            })[0];
        }
        // ---------------------------------

        // Revenda para Disponiveis
        function passarParaDisponiveis() {
            vm.marcarTodos = false;
            vm.marcarTodosRevenda = false;
            var equipamentosSelecionadosParaDisponiveis = vm.equipamentosParaRevenda.filter(function (equipamentos) {
                if (equipamentos.marcado) {
                    equipamentos.marcado = false;
                    return equipamentos;
                }
            });

            equipamentosSelecionadosParaDisponiveis.forEach(function (item) {
                _adicionarParaDisponiveis(item);
            });

            _removerEquipamentosJaAdicionadosParaDisponiveis();
        }

        function _removerEquipamentosJaAdicionadosParaDisponiveis() {
            vm.marcarTodos = false;
            vm.marcarTodosRevenda = false;
            vm.equipamentosParaRevenda = vm.equipamentosParaRevenda.filter(function (item) {
                var equipamentoAdicionadoDisponiveis = _consultarEquipamentosNosDisponiveis(item);
                return !equipamentoAdicionadoDisponiveis;
            });
        }

        function _adicionarParaDisponiveis(item) {
            vm.marcarTodos = false;
            vm.marcarTodosRevenda = false;
            var equipAdicionadoNosDisponiveis = _consultarEquipamentosNosDisponiveis(item);

            if (!equipAdicionadoNosDisponiveis) {
                vm.equipamentosDispoiniveis.push(item);
            }
        }

        function _consultarEquipamentosNosDisponiveis(equipamento) {
            vm.marcarTodos = false;
            vm.marcarTodosRevenda = false;
            return vm.equipamentosDispoiniveis.filter(function (equip) {
                if (equip.numeroSerie == equipamento.numeroSerie)
                    return equip;
            })[0];
        }
        // ---------------------------------

        // Pesquisar equipamentos dentro do card de disponiveis
        function teclaEnter() {
            var input = document.getElementById("inputPesquisa");

            input.addEventListener("keyup", function (event) {
                if (event.keyCode === 13) {
                    event.preventDefault();
                    document.getElementById("botaoPesquisar").click();
                }
            })
        }

        function pesquisarDisponiveis(pesquisaInformada) {
            vm.marcarTodos = false;
            vm.marcarTodosRevenda = false;
            var novosDetalhes = vm.equipamentosDispoiniveis.filter(function (detalhe) {
                if (
                    detalhe.numeroSerie.toLowerCase().includes(pesquisaInformada.toLowerCase()) ||
                    detalhe.equipamentoDescricao.toLowerCase().includes(pesquisaInformada.toLowerCase())
                )
                    return detalhe;
            })
            vm.equipamentosDispoiniveis = novosDetalhes;
        }

        // function pesquisarTodosDisponiveis() {
        //     vm.marcarTodos = false;
        //     vm.equipamentosDispoiniveis = vm.equipamentosDispoiniveisOriginais;
        // }
        // --------------------------------------

        // Pesquisar equipamentos dentro do card de revenda
        function teclaEnterRevenda() {
            var input = document.getElementById("inputPesquisaRevenda");

            input.addEventListener("keyup", function (event) {
                if (event.keyCode === 13) {
                    event.preventDefault();
                    document.getElementById("botaoPesquisarRevenda").click();
                }
            })
        }

        function pesquisarRevendas(pesquisaInformada) {
            vm.marcarTodos = false;
            vm.marcarTodosRevenda = false;
            var novosDetalhes = vm.equipamentosParaRevenda.filter(function (detalhe) {
                if (
                    detalhe.numeroSerie.toLowerCase().includes(pesquisaInformada.toLowerCase()) ||
                    detalhe.equipamentoDescricao.toLowerCase().includes(pesquisaInformada.toLowerCase())
                )
                    return detalhe;
            })
            vm.equipamentosParaRevenda = novosDetalhes;
        }

        function pesquisarTodosRevenda() {
            vm.marcarTodos = false;
            vm.marcarTodosRevenda = false;
            vm.equipamentosParaRevenda = vm.equipamentosParaRevendaOriginal;
        }
        // ----------------------------------------
    }
})();

(function () {
    "use strict";

    angular
        .module("app.locacao.processamento.retorno.baixa_equipamento",[])
        .config(config);

    function config($stateProvider,RotasHtml) {
        var rotasHtmlbaixaEquipamento = RotasHtml.baixa_equipamento;

        $stateProvider.state(
            "app.locacao_processamento_baixa",{
            url: "/locacao/processamento/equipamento/baixa",
            module: "privado",
            views: {
                "content@app": {
                    templateUrl: rotasHtmlbaixaEquipamento.templateUrl,
                    controller: "BaixaEquipamentoController as vm"
                }
            },
            resolve: {
                ListarTodosMotivoBaixa: function (Api,RequisicaoGenericaLocacaoService) {
                    return RequisicaoGenericaLocacaoService.listarSemParams(Api.locacao.equipamentos.motivoBaixa.listarTodos);
                },
            }
        });
    }

})();
/**
 * Created by nova on 24/03/2017.
 */
(function () {
    "use strict";

    angular
        .module("app.locacao.processamento.retorno.baixa_equipamento")
        .controller("BaixaEquipamentoController", BaixaEquipamentoController);

    function BaixaEquipamentoController(
        Api,
        NavegacaoService,
        RotasHtml,
        RequisicaoGenericaLocacaoService,
        ListarTodosMotivoBaixa,
        LoginUsuarioService,
        MdToastService,
        MdDialogService
    ) {
        var vm = this;

        vm.tipoPesquisa = 1
        vm.totasEquipamentos = RotasHtml;
        vm.desabilitaBotao = true;
        vm.resultado = null;
        vm.load = false;
        vm.loadBaixa = false;
        vm.mostrarCards = false;
        vm.mensagemPreloader = ""
        vm.motivo = ListarTodosMotivoBaixa.data;

        NavegacaoService.setTituloAba("Baixa de equipamentos");

        vm.metodos = {
            listarEquipamentoNotaItemDetalhe: listarEquipamentoNotaItemDetalhe,
            salvarBaixa: salvarBaixa
        };

        init();

        function init() {

        }

        function listarEquipamentoNotaItemDetalhe(event, numeroSerieOuIMEI) {

            var requisicaoService = RequisicaoGenericaLocacaoService.listarSemParams(
                Api.locacao.nota_item_detalhe.listarPorNumeroDeSerie + numeroSerieOuIMEI);

            if (vm.tipoPesquisa == "1") {
                pesquisarHistoricoNumeroSerie(event, numeroSerieOuIMEI);
            }
            if (vm.tipoPesquisa == "2") {
                pesquisarHistoricoIMEI(event, numeroSerieOuIMEI);
                requisicaoService = RequisicaoGenericaLocacaoService.listarSemParams(
                    Api.locacao.nota_item_detalhe.listarPorImei + numeroSerieOuIMEI);
            }

            vm.iniciaTabela = true;
            vm.pesquisando = true;
            vm.exibirDados = false;
            vm.load = true;
            vm.mensagemPreloader = "Carregando...";


            requisicaoService.then(function (success) {
                console.log('success: ', success);
                if (success.data.foiBaixado == 1) {
                    MdDialogService.alertPadrao("Atenção", event, "Equipamento não encontrado.");
                    vm.mostrarCards = false;
                    vm.load = false;
                    vm.exibirDados = true;
                    vm.mensagemPreloader = "";
                    vm.baixa.equipamentoMotivoBaixaId = null;
                    vm.baixa.observacao = "";
                }
                else if (success.data.foiBaixado == 2) {
                    MdDialogService.alertPadrao("Atenção", event, "Este equipamento já foi baixado.");
                    vm.mostrarCards = false;
                    vm.load = false;
                    vm.exibirDados = true;
                    vm.mensagemPreloader = "";
                    vm.baixa.equipamentoMotivoBaixaId = null;
                    vm.baixa.observacao = "";
                }
                else {
                    vm.mostrarCards = true;
                    vm.load = false;
                    vm.exibirDados = true;
                    vm.mensagemPreloader = "";
                    vm.resultado = success.data;
                    console.log('vm.resultado: ', vm.resultado);
                    vm.baixa.equipamentoMotivoBaixaId = null;
                    vm.baixa.observacao = "";
                }
            }, function (err) {
                vm.load = false;
                vm.exibirDados = false;
                vm.mensagemPreloader = "";
                MdDialogService.alertPadrao("Atenção", event, err.data.error);
            });
        }

        function pesquisarHistoricoNumeroSerie(event, numeroSerie) {
            var inputModel = {
                numeroSerie: numeroSerie,
                imei: null
            }

            RequisicaoGenericaLocacaoService.salvar(Api.locacao.nota_item_detalhe_historico.listarHistoricoUltimaEmpresaAtivo, inputModel)
                .then(function (success) {
                    vm.detalhesHistoricos = success.data;
                }, function (err) {
                    MdDialogService.alertPadrao("Atenção", event, err.data.error);
                });
        }

        function pesquisarHistoricoIMEI(event, IMEI) {
            var inputModel = {
                numeroSerie: null,
                imei: IMEI
            }

            RequisicaoGenericaLocacaoService.salvar(Api.locacao.nota_item_detalhe_historico.listarHistoricoUltimaEmpresaAtivo, inputModel)
                .then(function (success) {
                    vm.detalhesHistoricos = success.data;
                }, function (err) {
                    MdDialogService.alertPadrao("Atenção", event, err.data.error);
                });
        }



        function salvarBaixa() {
            vm.loadBaixa = true;
            vm.mensagemPreloader = "Carregando...";
            vm.baixa.EquipamentoNotaItemDetalheId = vm.resultado.id
            vm.baixa.numeroSerieOuIMEI = vm.numeroSerieOuIMEI;
            vm.baixa.equipamentoEstadoConservacaoId = vm.resultado.equipamentoEstadoConservacaoId;
            vm.baixa.equipamentoSituacaoId = vm.resultado.equipamentoSituacaoId;
            vm.baixa.nomeUsuario = LoginUsuarioService.usuarioArmazenado().login;
            vm.baixa.idUsuario = LoginUsuarioService.usuarioArmazenado().codigo;
            RequisicaoGenericaLocacaoService.listarComObjetoComplexo(Api.locacao.equipamentos.historicoBaixa.criar, vm.baixa)
                .then(function (success) {
                    vm.loadBaixa = false;
                    vm.mostrarCards = false;
                    vm.resultado = null;
                    vm.baixa.equipamentoMotivoBaixaId = "";
                    vm.baixa.observacao = "";
                    vm.mensagemPreloader = "";
                    MdToastService.toastPadrao("Baixado com sucesso!");
                    MdDialogService.alertPadrao("Baixa realizada com sucesso!", success);
                }, function (err) {
                    vm.loadBaixa = false;
                    vm.mostrarCards = false;
                    vm.mensagemPreloader = "";
                    MdDialogService.alertPadrao("Atenção", event, err.data.error);
                });
        }
    }
})();

(function () {
    "use strict";

    angular
        .module("app.locacao.cadastro.empresa_ativa",[])
        .config(config);

    function config($stateProvider,RotasHtml) {
        var rotasHtmlEmpresaAtiva = RotasHtml.empresa_ativa;
        $stateProvider.state(
            "app.locacao_cadastro_empresa_ativa",{
            url: "/locacao/cadastro/empresa-ativa",
            module: "privado",
            views: {
                "content@app": {
                    templateUrl: rotasHtmlEmpresaAtiva.templateUrl,
                    controller: "EmpresaAtivaController as vm"
                },
                "empresa-ativa-form@app.locacao_cadastro_empresa_ativa": {
                    templateUrl: rotasHtmlEmpresaAtiva.form
                },
                "empresa-ativa-tabela@app.locacao_cadastro_empresa_ativa": {
                    templateUrl: rotasHtmlEmpresaAtiva.tabela
                }
            }
        }
        );
    }
})();

/**
 * Created by nova on 24/03/2017.
 */
(function () {
  "use strict";

  angular
    .module("app.locacao.cadastro.empresa_ativa")
    .controller("EmpresaAtivaController", EmpresaAtivaController);

  function EmpresaAtivaController(
    Api,
    RequisicaoGenericaLocacaoService,
    NavegacaoService,
    DatatableLocacaoFactory,
    ServicosGenericoService
  ) {
    var vm = this;
    vm.vazio ={};
    vm.empresaEnvio = {};
    vm.empresaAtiva = null;
    NavegacaoService.setTituloAba("Empresa ativo");
    vm.metodos = {
      pesquisar: pesquisar,
      salvar: salvar,
      editar: editar,
      excluir: excluir,
      selecionar: selecionar,
      construirDtOptions: construirDtOptions,
      configuraAutoCompleteClienteOnBlur: configuraAutoCompleteClienteOnBlur,
      alterarItemSelecionadoAutoCompleteCliente: alterarItemSelecionadoAutoCompleteCliente,
      pesquisarAutoCompleteCliente: pesquisarAutoCompleteCliente
    };

     function pesquisar() {
       RequisicaoGenericaLocacaoService.listarComObjetoComplexo(
         Api.locacao.empresaAtiva.listarComPaginacao,
         vm.entidadeDeEnvio
       ).then(function(success){
         vm.empresaEnvio = {};
         vm.empresaEnvio = success.data.lstResultado[0];
       });
            return RequisicaoGenericaLocacaoService.listarComObjetoComplexo(Api.locacao.empresaAtiva.listarComPaginacao, vm.entidadeDeEnvio);
        }


        function salvar(modelo) {
          vm.empresaEnvio.nome = modelo.nome;
          vm.empresaEnvio.codigo = modelo.codigo;
            return RequisicaoGenericaLocacaoService.salvar(Api.locacao.empresaAtiva.criar, vm.empresaEnvio);
        }

        function editar(modelo) {
          if(vm.empresaAtiva.id != undefined)
              vm.empresaEnvio.id = vm.empresaAtiva.id;
          vm.empresaEnvio.nome = modelo.nome;
          vm.empresaEnvio.codigo = modelo.codigo;
            return RequisicaoGenericaLocacaoService.editar(Api.locacao.empresaAtiva.editar,  vm.empresaEnvio)
        }

        function excluir(modelo) {
            return RequisicaoGenericaLocacaoService.excluir(Api.locacao.empresaAtiva.remover, modelo.id)
        }

        function selecionar(posicaoEntidade) {
            vm.metodosExternosPgToolbar.metodoControladorExternoListarTodasEntidades(null, posicaoEntidade);
        }

        function construirDtOptions() {
          DatatableLocacaoFactory.destruirTabela();
          vm.entidadeDeEnvio.clsEntidade = null;
            DatatableLocacaoFactory.construirDtOptionsComPaginacaoProcessadoNoServidorParaToolbar(
              Api.locacao.empresaAtiva.listarComPaginacaoDatatable,
              vm.entidadeDeEnvio.clsEntidade,
              "#datatable-empresa-ativo",
              [
                DatatableLocacaoFactory.construirColunaDeSelecionarPadrao(function (
                  indexLinha
                ) {
                  vm.metodos.selecionar(indexLinha);
                }),
                {
                  targets: 1,
                  name: "Nome",
                  data: "nome",
                  defaultContent: ""
                }
              ]
            );
            vm.entidadeDeEnvio.clsEntidade = {};
    }

    function configuraAutoCompleteClienteOnBlur() {
      if (!vm.empresaAtiva) {
        vm.textoDePesquisaAutoCompleteCliente = "";
      }
    }

    function alterarItemSelecionadoAutoCompleteCliente(item) {
      if (item && item.codigo) {
        vm.empresaAtiva.codigo = item.codigo;
      } else {
        vm.textoDePesquisaAutoCompleteCliente = "";
        vm.empresaAtiva = null;
      }
    }

    function pesquisarAutoCompleteCliente(query) {
      return ServicosGenericoService.pesquisarAutoCompleteCodigoOuNomeGenericoApi(
        Api.cliente.listarCodigoDescricao,
        query
      );
    }


  }
})();

(function () {
  "use strict";

  angular
    .module("app.locacao.cadastro.tipo_locacao", [])
    .config(config);

  function config($stateProvider, RotasHtml) {
    var rotasHtmlTipoLocacao = RotasHtml.tipo_locacao;
    $stateProvider.state(
      "app.locacao_cadastro_tipo_locacao",
      {
        url: "/locacao/cadastro/tipo-locacao",
        module: "privado",
        views: {
          "content@app": {
            templateUrl: rotasHtmlTipoLocacao.templateUrl,
            controller: "TipoLocacaoController as vm"
          },
          "tipo-locacao-form@app.locacao_cadastro_tipo_locacao": {
            templateUrl: rotasHtmlTipoLocacao.form
          },
          "tipo-locacao-tabela@app.locacao_cadastro_tipo_locacao": {
            templateUrl: rotasHtmlTipoLocacao.tabela
          }
        }
      }
    );
  }
})();

/**
 * Created by nova on 24/03/2017.
 */
(function () {
  "use strict";

  angular
    .module("app.locacao.cadastro.tipo_locacao")
    .controller("TipoLocacaoController", TipoLocacaoController);

  function TipoLocacaoController(
    Api,
    RequisicaoGenericaLocacaoService,
    NavegacaoService,
    DatatableLocacaoFactory
  ) {
    var vm = this;
    NavegacaoService.setTituloAba("Tipo");

    vm.metodos = {
      pesquisar: pesquisar,
      salvar: salvar,
      editar: editar,
      excluir: excluir,
      selecionar: selecionar,
      construirDtOptions: construirDtOptions
    };

    function pesquisar() {
      return RequisicaoGenericaLocacaoService.listarComObjetoComplexo(
        Api.locacao.tipoLocacao.listarComPaginacao,
        vm.entidadeDeEnvio
      );
    }

    function salvar(modelo) {
      return RequisicaoGenericaLocacaoService.salvar(
        Api.locacao.tipoLocacao.criar,
        modelo
      );
    }

    function editar(modelo) {
      return RequisicaoGenericaLocacaoService.editar(
        Api.locacao.tipoLocacao.editar,
        modelo
      );
    }

    function excluir(modelo) {
      return RequisicaoGenericaLocacaoService.excluir(
        Api.locacao.tipoLocacao.remover,
        modelo.id
      );
    }

    function selecionar(posicaoEntidade) {
      vm.metodosExternosPgToolbar.metodoControladorExternoListarTodasEntidades(
        null,
        posicaoEntidade
      );
    }

    function construirDtOptions() {
      DatatableLocacaoFactory.destruirTabela();

        vm.entidadeDeEnvio.clsEntidade = null;

      DatatableLocacaoFactory.construirDtOptionsComPaginacaoProcessadoNoServidorParaToolbar(
        Api.locacao.tipoLocacao.listarComPaginacaoDatatable,
        vm.entidadeDeEnvio.clsEntidade,
        "#datatable-locacao",
        [
          DatatableLocacaoFactory.construirColunaDeSelecionarPadrao(function (
            indexLinha
          ) {
            vm.metodos.selecionar(indexLinha);
          }),
          // {
          //   targets: 1,
          //   name: "CodigoFabricante",
          //   data: "fabricante.descricao",
          //   defaultContent: "",
          // },
          // {
          //   targets: 2,
          //   name: "CodigoTipoEquipamento",
          //   data: "tipoEquipamento.descricao",
          //   defaultContent: "",
          // },
          {
            targets: 1,
            name: "Descricao",
            data: "descricao",
            defaultContent: "",
          },
        ]
      );
      vm.entidadeDeEnvio.clsEntidade = {};
    }
  }
})();

(function () {
  "use strict";

  angular
    .module("app.locacao.cadastro.retorno_locacao", [])
    .config(config);

  function config($stateProvider, RotasHtml) {
    var rotasHtmlRetornoLocacao = RotasHtml.retorno_locacao;
    $stateProvider.state(
      "app.locacao_cadastro_retorno_locacao",
      {
        url: "/locacao/cadastro/retorno-locacao",
        module: "privado",
        views: {
          "content@app": {
            templateUrl: rotasHtmlRetornoLocacao.templateUrl,
            controller: "RetornoLocacaoController as vm"
          },
          "retorno-locacao-form@app.locacao_cadastro_retorno_locacao": {
            templateUrl: rotasHtmlRetornoLocacao.form
          },
          "retorno-locacao-tabela@app.locacao_cadastro_retorno_locacao": {
            templateUrl: rotasHtmlRetornoLocacao.tabela
          }
        }
      }
    );
  }
})();

/**
 * Created by nova on 24/03/2017.
 */
(function () {
  "use strict";

  angular
    .module("app.locacao.cadastro.retorno_locacao")
    .controller("RetornoLocacaoController", RetornoLocacaoController);

  function RetornoLocacaoController(
    Api,
    RequisicaoGenericaLocacaoService,
    NavegacaoService,
    DatatableLocacaoFactory
  ) {
    var vm = this;
    NavegacaoService.setTituloAba("Retorno");

    vm.metodos = {
      pesquisar: pesquisar,
      salvar: salvar,
      editar: editar,
      excluir: excluir,
      selecionar: selecionar,
      construirDtOptions: construirDtOptions
    };

     function pesquisar() {
            return RequisicaoGenericaLocacaoService.listarComObjetoComplexo(Api.locacao.retornoLocacao.listarComPaginacao, vm.entidadeDeEnvio);
        }


        function salvar(modelo) {
            return RequisicaoGenericaLocacaoService.salvar(Api.locacao.retornoLocacao.criar, modelo);
        }

        function editar(modelo) {
            return RequisicaoGenericaLocacaoService.editar(Api.locacao.retornoLocacao.editar, modelo)
        }

        function excluir(modelo) {
            return RequisicaoGenericaLocacaoService.excluir(Api.locacao.retornoLocacao.remover, modelo.id)
        }

        function selecionar(posicaoEntidade) {
            vm.metodosExternosPgToolbar.metodoControladorExternoListarTodasEntidades(null, posicaoEntidade);
        }

        function construirDtOptions() {
          DatatableLocacaoFactory.destruirTabela();

              vm.entidadeDeEnvio.clsEntidade = null;

            DatatableLocacaoFactory.construirDtOptionsComPaginacaoProcessadoNoServidorParaToolbar(
              Api.locacao.retornoLocacao.listarComPaginacaoDatatable,
              vm.entidadeDeEnvio.clsEntidade,
              "#datatable-retorno-locacao",
              [
                DatatableLocacaoFactory.construirColunaDeSelecionarPadrao(function (
                  indexLinha
                ) {
                  vm.metodos.selecionar(indexLinha);
                }),
                {
                  targets: 1,
                  name: "Descricao",
                  data: "descricao",
                  defaultContent: "",
                },
              ]
            );
            vm.entidadeDeEnvio.clsEntidade = {};
    }


  }
})();

(function () {
  "use strict";

  angular
    .module("app.locacao.cadastro.objetivo_nota", [])
    .config(config);

  function config($stateProvider, RotasHtml) {
    var rotasHtmlObjetivoNota = RotasHtml.objetivo_nota;
    $stateProvider.state(
      "app.locacao_cadastro_objetivo_nota",
      {
        url: "/locacao/cadastro/objetivo-nota",
        module: "privado",
        views: {
          "content@app": {
            templateUrl: rotasHtmlObjetivoNota.templateUrl,
            controller: "ObjetivoNotaController as vm"
          },
          "objetivo-nota-form@app.locacao_cadastro_objetivo_nota": {
            templateUrl: rotasHtmlObjetivoNota.form
          },
          "objetivo-nota-tabela@app.locacao_cadastro_objetivo_nota": {
            templateUrl: rotasHtmlObjetivoNota.tabela
          }
        }
      }
    );
  }
})();

/**
 * Created by nova on 24/03/2017.
 */
(function () {
  "use strict";

  angular
    .module("app.locacao.cadastro.objetivo_nota")
    .controller("ObjetivoNotaController", ObjetivoNotaController);

  function ObjetivoNotaController(
    Api,
    RequisicaoGenericaLocacaoService,
    NavegacaoService,
    DatatableLocacaoFactory
  ) {
    var vm = this;
    NavegacaoService.setTituloAba("Objetivo nota");

    vm.metodos = {
      pesquisar: pesquisar,
      salvar: salvar,
      editar: editar,
      excluir: excluir,
      selecionar: selecionar,
      construirDtOptions: construirDtOptions
    };

     function pesquisar() {
            return RequisicaoGenericaLocacaoService.listarComObjetoComplexo(Api.locacao.objetivoNota.listarComPaginacao, vm.entidadeDeEnvio);
        }


        function salvar(modelo) {
            return RequisicaoGenericaLocacaoService.salvar(Api.locacao.objetivoNota.criar, modelo);
        }

        function editar(modelo) {
            return RequisicaoGenericaLocacaoService.editar(Api.locacao.objetivoNota.editar, modelo)
        }

        function excluir(modelo) {
            return RequisicaoGenericaLocacaoService.excluir(Api.locacao.objetivoNota.remover, modelo.id)
        }

        function selecionar(posicaoEntidade) {
            vm.metodosExternosPgToolbar.metodoControladorExternoListarTodasEntidades(null, posicaoEntidade);
        }

        function construirDtOptions() {
          DatatableLocacaoFactory.destruirTabela();

            vm.entidadeDeEnvio.clsEntidade = null;

            DatatableLocacaoFactory.construirDtOptionsComPaginacaoProcessadoNoServidorParaToolbar
                (Api.locacao.objetivoNota.listarComPaginacaoDatatable, vm.entidadeDeEnvio.clsEntidade, '#datatable-objetivo',
                [

                    DatatableLocacaoFactory.construirColunaDeSelecionarPadrao(function (indexLinha) { vm.metodos.selecionar(indexLinha) }),
                    {
                        targets: 1,
                        name: "Descricao",
                        data: "descricao",
                        defaultContent: ""
                    }
                ]);
            vm.entidadeDeEnvio.clsEntidade = {};
        }

  }
})();

(function () {
    'use strict';

    angular
        .module('app.implantacaoMigracao.processamento.processosFinalizadosCancelados', [])
        .config(config);

    function config($stateProvider, RotasHtml) {
        var rotasHtml = RotasHtml.implantacaoMigracao.processamento.processosFinalizadosCancelados;
        $stateProvider
            .state('app.implantacaomigracao_processamento_processosfinalizadoscancelados', {
                url: '/implantacao-migracao/processamento/processos-finalizados-e-cancelados',
                module: 'privado',
                views: {
                    'content@app': {
                        templateUrl: rotasHtml.templateUrl,
                        controller: "ProcessosFinalizadosCanceladosController as vm"
                    },
                    'processos-finalizados-cancelados-form@app.implantacaomigracao_processamento_processosfinalizadoscancelados': {
                        templateUrl: rotasHtml.form
                    }
                },
                resolve: {
                    SubprocessosCanceladosFinalizados: function (RequisicaoGenericaService, Api) {
                        return RequisicaoGenericaService.listarSemParams(Api.implantacaoMigracao.subprocesso.listarTodosCanceladosFinalizados);
                    },
                    ListarTodosProcessos: function (Api, RequisicaoGenericaService) {
                        return RequisicaoGenericaService.listarSemParams(Api.implantacaoMigracao.processo.listarTodos);
                    }
                }
            });
    }
})();
(function () {
    'use strict';

    angular
        .module('app.implantacaoMigracao.processamento.processosFinalizadosCancelados')
        .controller('ProcessosFinalizadosCanceladosController', ProcessosFinalizadosCanceladosController);

    function ProcessosFinalizadosCanceladosController(
        NavegacaoService,
        Api,
        MdDialogService,
        RequisicaoGenericaService,
        DatatableFactory,
        SubprocessosCanceladosFinalizados,
        ListarTodosProcessos,
        MdToastService,
        $log,
        MenuFactory,
        DataTableConfigPadrao
    ) {
        var vm = this;

        NavegacaoService.setTituloAba('Subprocessos finalizados e cancelados');

        vm.processos = ListarTodosProcessos.data;
        vm.listaSubprocessosFinalizadosCancelados = SubprocessosCanceladosFinalizados.data;
        vm.dtOptionsSubprocessosFinalizadosCancelados = angular.copy(DataTableConfigPadrao.dtOptionsPadraoComPaginacaoEReponsivo);

        vm.dtOptionsSubprocessosFinalizadosCancelados.columnDefs = [
            {
                targets: [0],
                orderable: false
            }
        ];

        vm.dtOptionsSubprocessosFinalizadosCancelados.order = [4, 'desc'];

        vm.dtOptionsSubprocessosFinalizadosCancelados.oLanguage = {
            "sEmptyTable": "Não foram encontrados dados!",
            "sZeroRecords": "Nenhum dado encontrado com base na pesquisa informada."
        }

        vm.metodos = {
            retornaSubprocessoParaStatusAnterior: retornaSubprocessoParaStatusAnterior,
            retornaDescricaoProcesso: retornaDescricaoProcesso,
            retornaDescricaoTarefa: retornaDescricaoTarefa
        }

        _init();

        function _init() {
            if (vm.listaSubprocessosFinalizadosCancelados == 0) {
                MdDialogService.alertPadrao("Não existem processos finalizados ou cancelados.");
                MenuFactory.navegarParaEstadoSeUsuarioTerAcesso('app.implantacaomigracao_processamento_processosfunis');
            }
        }

        function retornaSubprocessoParaStatusAnterior(subprocesso) {
            var codigoStatusEmAndamento = 1;
            MdDialogService.confirmPadraoComEvento("Deseja realmente retornar o processo selecionado para a status anterior?", "", null,
                function () {
                    RequisicaoGenericaService.editar(Api.implantacaoMigracao.subprocesso.retornarSubprocessoStatusAnterior + '?codigoSubprocesso=' + subprocesso.codigo + '&codigoStatus=' + codigoStatusEmAndamento)
                        .then(
                            function (success) {
                                MdToastService.toastPadrao(success.data);
                                vm.requisicaoSolicitada = true;

                                RequisicaoGenericaService.listarSemParams(Api.implantacaoMigracao.subprocesso.listarTodosCanceladosFinalizados)
                                    .then(
                                        function (success) {
                                            vm.requisicaoSolicitada = false;
                                            vm.listaSubprocessosFinalizadosCancelados = success.data;
                                            _init();
                                        },
                                        function (error) {
                                            vm.requisicaoSolicitada = false;
                                            $log.log(error);
                                        }
                                    );

                            },
                            function (error) {
                                $log.log(error);
                            });
                });
        }

        function retornaDescricaoProcesso(codigoProcesso) {
            var descricaoProcesso = '';
            vm.processos.forEach(function (processo) {
                if (processo.codigo == codigoProcesso) {
                    descricaoProcesso = processo.descricao;
                }
            });
            return descricaoProcesso;
        }

        function retornaDescricaoTarefa(codigoProcesso, codigoTarefaAtual) {
            var descricaoTarefa = '';
            vm.processos.forEach(function (processo) {
                if (processo.codigo == codigoProcesso) {
                    processo.tarefas.forEach(function (tarefa) {
                        if (tarefa.codigo == codigoTarefaAtual) {
                            descricaoTarefa = tarefa.descricao;
                        }
                    });
                }
            });
            return descricaoTarefa;
        }
    }

})();


(function () {
    'use strict';

    angular
        .module('app.implantacaoMigracao.cadastro.tarefa', [])
        .config(config);

    function config($stateProvider, RotasHtml) {
        var rotasHtml = RotasHtml.implantacaoMigracao.cadastro.tarefa;
        $stateProvider
            .state('app.implantacaomigracao_cadastro_tarefa', {
                url: '/implantacao-migracao/cadastro/tarefa',
                module: 'privado',
                views: {
                    'content@app': {
                        templateUrl: rotasHtml.templateUrl,
                        controller: "TarefaController as vm"
                    },
                    'tarefa-form@app.implantacaomigracao_cadastro_tarefa': {
                        templateUrl: rotasHtml.form
                    },
                    'tarefa-tabela@app.implantacaomigracao_cadastro_tarefa': {
                        templateUrl: rotasHtml.tabela
                    }
                },
                resolve: {
                    ListarTodasAtividades: function (Api, RequisicaoGenericaService) {
                        return RequisicaoGenericaService.listarSemParams(Api.implantacaoMigracao.atividade.listarTodasAtividades);
                    },
                    ListarTodasAtividadesAtivas: function (Api, RequisicaoGenericaService) {
                        return RequisicaoGenericaService.listarSemParams(Api.implantacaoMigracao.atividade.listarTodasAtividadesAtivas);
                    }
                }

            });
    }
})();
(function () {
    'use strict';

    angular.module('app.implantacaoMigracao.cadastro.tarefa')
        .controller('TarefaController', TarefaController);

    function TarefaController(
        Api,
        MdDialogService,
        RequisicaoGenericaService,
        PgToolbarService,
        ProximoCodigoService,
        DatatableFactory,
        ListarTodasAtividades,
        ListarTodasAtividadesAtivas
    ) {
        var vm = this;
        vm.atividades = angular.copy(ListarTodasAtividades.data);
        vm.metodos = {
            preDefinirCamposParaInserir: preDefinirCamposParaInserir,
            pesquisar: pesquisar,
            salvar: salvar,
            editar: editar,
            excluir: excluir,
            selecionar: selecionar,
            construirDtOptions: construirDtOptions,
            configuraMdSelectAtividades: configuraMdSelectAtividades,
            predefinirCamposParaEdicao: predefinirCamposParaEdicao,
        }

        function preDefinirCamposParaInserir() {
            PgToolbarService.iniciarPreLoaderToolbar(vm.controleForm, vm.controlePreloader);
            ProximoCodigoService.proximoCodigo(Api.implantacaoMigracao.tarefa.proximoCodigo).then(
                function (success) {
                    vm.atividades =  angular.copy(ListarTodasAtividadesAtivas.data);
                    vm.tarefa = {
                        codigo: success.data,
                        exigirFinalizacaoTarefa: true
                    };
                    PgToolbarService.finalizarPreLoaderToolbar(vm.controleForm, vm.controlePreloader);
                },
                function (error) {
                    console.log(error);
                    PgToolbarService.finalizarPreLoaderToolbar(vm.controleForm, vm.controlePreloader);
                    MdDialogService.alertPadrao(error.data);
                });
        }

        function predefinirCamposParaEdicao() {
            vm.atividades = angular.copy(ListarTodasAtividadesAtivas.data);

            vm.tarefa.atividades.forEach(function (atividadeTarefa) {
                if (!vm.atividades.some(function (atividade) {
                    return atividade.codigo === atividadeTarefa;
                })) {
                   var atividadeInativa = ListarTodasAtividades.data.find(function (atividade) {
                       return atividadeTarefa == atividade.codigo;
                   });

                    vm.atividades.push(atividadeInativa);
                    vm.atividades.sort(function (a, b) {
                        return a.codigo > b.codigo ? 1 : -1;
                    })
                }
            });

        }

        function pesquisar() {
        vm.atividades =  angular.copy(ListarTodasAtividades.data);
          return RequisicaoGenericaService.listarComObjetoComplexo(Api.implantacaoMigracao.tarefa.listarComPaginacao, vm.entidadeDeEnvio);
        }

        function salvar(modelo) {
            return RequisicaoGenericaService.salvar(Api.implantacaoMigracao.tarefa.criar, modelo);
        }

        function editar(modelo) {
            return RequisicaoGenericaService.editar(Api.implantacaoMigracao.tarefa.atualizar, modelo)
        }

        function excluir(modelo) {
            return RequisicaoGenericaService.excluir(Api.implantacaoMigracao.tarefa.excluir, modelo.codigo)
        }

        function selecionar(posicaoEntidade) {
            vm.metodosExternosPgToolbar.metodoControladorExternoListarTodasEntidades(null, posicaoEntidade);
        }

        function construirDtOptions() {
            DatatableFactory.construirDtOptionsComPaginacaoProcessadoNoServidorParaToolbar
                (Api.implantacaoMigracao.tarefa.listarComPaginacaoDatatable, vm.entidadeDeEnvio.clsEntidade, '#datatable-tarefas',
                    [
                        DatatableFactory.construirColunaDeSelecionarPadrao(function (indexLinha) { vm.metodos.selecionar(indexLinha) }),
                        {
                            targets: 1,
                            name: "Codigo",
                            data: "codigo",
                            defaultContent: ""
                        },
                        {
                            targets: 2,
                            name: "Descricao",
                            data: "descricao",
                            defaultContent: ""
                        },
                        {
                            targets: 3,
                            name: "Nivel",
                            data: "nivel",
                            defaultContent: ""
                        },
                        {
                            targets: 4,
                            name: "Periodo",
                            data: "periodo",
                            defaultContent: ""
                        },
                        {
                            targets: 5,
                            name: "ExigirFinalizacaoTarefa",
                            data: "exigirFinalizacaoTarefa",
                            defaultContent: ""
                        }
                    ]);
        }

        function configuraMdSelectAtividades() {
            vm.filtrarAtividadesAtivas = "";
            angular.element('#tarefa-atividades-md-select').on('keydown', function (ev) {
                ev.stopPropagation();
            });
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.implantacaoMigracao.processamento.processosFunis', ['app.implantacaoMigracao.processamento.processosFunis.processoFunil'])
        .config(config);

    function config($stateProvider, RotasHtml) {
        var rotasHtml = RotasHtml.implantacaoMigracao.processamento.processosFunis;
        $stateProvider
            .state('app.implantacaomigracao_processamento_processosfunis', {
                url: '/implantacao-migracao/processamento/processos-funis',
                module: 'privado',
                views: {
                    'content@app': {
                        templateUrl: rotasHtml.templateUrl,
                        controller: "ProcessosFunisController as vm"
                    }
                },
                resolve: {
                    ListarTodosProcessos: function (Api, RequisicaoGenericaService) {
                        return RequisicaoGenericaService.listarSemParams(Api.implantacaoMigracao.processo.listarTodos);
                    }
                }
            });
    }
})();
(function () {
    'use strict';

    angular
        .module('app.implantacaoMigracao.processamento.processosFunis')
        .controller('ProcessosFunisController', ProcessosFunisController);

    function ProcessosFunisController(
        ListarTodosProcessos,
        NavegacaoService,
        ImplantacaoMigracaoFactory,
        $stateParams,
        RotasHtml,
        MdDialogService
    ) {
        var vm = this;
        NavegacaoService.setTituloAba('Processos funis');

        var rotasHtml = RotasHtml.pipeline_negocio;

        vm.metodos = {
            exibirDescricao: exibirDescricao,
            retornarRotaDescricao: retornarRotaDescricao
        };

        _init()

        //#region  Métodos Interno

        function _init() {
            vm.funis = ListarTodosProcessos.data;
        }
        //#endregion

        //#region Métodos
        function exibirDescricao(descricao) {
            return descricao.length <= 23 ? descricao : descricao.substring(0, 23) + "..."
        }
        //#endregion

        function retornarRotaDescricao(descricao) {
            var descricaoFormatada = angular.copy(descricao);
            return descricaoFormatada.toLowerCase().split(' ').join('-');
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.financeiro.relatorio.risco-rescisao-contratual')
        .controller('RelatorioRiscoRescisaoContratualController', RelatorioRiscoRescisaoContratualController);

    function RelatorioRiscoRescisaoContratualController(
        $scope,
        NavegacaoService,
        RiscoRescisaoContratualService,
        ListarProdutosAtivosEComercializaveis,
        ListarTodosEstados,
        ListarMotivosRiscosContratuais,
        DTOptionsBuilder,
        DTColumnDefBuilder,
        MdDialogService,
        $window,
        urlApi,
        Api,
        $timeout
    ) {
        var vm = this;
        NavegacaoService.setTituloAba('Relatório de clientes em monitoramento');

        var serviceProdutos = ListarProdutosAtivosEComercializaveis.data;
        var serviceMotivos = ListarMotivosRiscosContratuais.data;

        RiscoRescisaoContratualService.setDados(
            serviceProdutos,
            ListarTodosEstados.data,
            serviceMotivos
        );

        RiscoRescisaoContratualService.setMontandoDados(false);
        RiscoRescisaoContratualService.setFiltroUtilizado(null);
        RiscoRescisaoContratualService.setEmProgresso(false);

        vm.montandoDados = RiscoRescisaoContratualService.getMontandoDados();
        vm.filtroUtilizado = RiscoRescisaoContratualService.getFiltroUtilizado();
        vm.dadosTabela = RiscoRescisaoContratualService.getDadosTabela();
        vm.emProgresso = RiscoRescisaoContratualService.getEmProgresso();
        vm.gerandoRelatorio = false;
        vm.resultadosVisiveis = 0;
        vm.totalClientesVisiveis = 0;
        vm.valorTotalClientesVisiveis = 0;

        vm.dtOptions = DTOptionsBuilder.newOptions()
            .withOption('order', [])
            .withOption('paging', false)
            .withOption('info', false)
            .withOption('searching', true)
            .withOption('autoWidth', false)
            .withDOM('t')
            .withOption('drawCallback', function (settings) {
                var api = this.api();
                $scope.$evalAsync(function () {
                    var visibleRows = api.rows({ search: 'applied', order: 'applied' }).indexes().toArray();
                    var dadosVisiveis = [];
                    angular.forEach(visibleRows, function (index) {
                        dadosVisiveis.push(vm.dadosTabela.dadosClientes[index]);
                    });
                    vm.resultadosVisiveis = dadosVisiveis.length;
                    var codigosUnicos = {};
                    var totalUnicos = 0;
                    angular.forEach(dadosVisiveis, function (cliente) {
                        if (cliente.codigo && !codigosUnicos[cliente.codigo]) {
                            codigosUnicos[cliente.codigo] = true;
                            totalUnicos++;
                        }
                    });
                    vm.totalClientesVisiveis = totalUnicos;
                    vm.valorTotalClientesVisiveis = dadosVisiveis.reduce(function (acc, cliente) {
                        return acc + (cliente.valorItem || 0);
                    }, 0);
                });
            });

        vm.dtColumnDefs = [];

        vm.onDtInstance = function (instance) {
            vm.dtInstance = instance;
        };

        $scope.$watch('vm.pesquisar', function (valor) {
            if (vm.dtInstance && vm.dtInstance.DataTable) {
                vm.dtInstance.DataTable.search(valor || '').draw();
            }
        });

        vm.metodos = {
            voltar: voltar,
            gerarRelatorio: gerarRelatorio,
            formatarItem: formatarItem,
            formatarMotivo: formatarMotivo,
            obterDescricaoCompletaMotivo: obterDescricaoCompletaMotivo
        };

        $scope.$watch(RiscoRescisaoContratualService.getEmProgresso, function (newValue) {
            vm.emProgresso = newValue;
        });

        $scope.$watch(RiscoRescisaoContratualService.getMontandoDados, function (newValue) {
            vm.montandoDados = newValue;
            if (newValue) {
                vm.dadosTabela = RiscoRescisaoContratualService.getDadosTabela();
                vm.filtroUtilizado = RiscoRescisaoContratualService.getFiltroUtilizado();
                if (vm.dtInstance && vm.dtInstance.DataTable) {
                    $timeout(function () {
                        vm.dtInstance.DataTable.draw();
                    });
                }
            }
        });

        function voltar() {
            RiscoRescisaoContratualService.setMontandoDados(false);
        }

        function gerarRelatorio() {
            vm.gerandoRelatorio = true;
            var visibleRows = vm.dtInstance.DataTable.rows({ search: 'applied', order: 'applied' }).indexes().toArray();
            var dadosClientesVisiveis = [];
            angular.forEach(visibleRows, function (index) {
                dadosClientesVisiveis.push(vm.dadosTabela.dadosClientes[index]);
            });
            var valorTotalVisivel = dadosClientesVisiveis.reduce(function (acc, curr) {
                return acc + (curr.valorItem || 0);
            }, 0);
            var promise = RiscoRescisaoContratualService.gerarRelatorio(vm.filtroUtilizado, dadosClientesVisiveis, valorTotalVisivel);
            promise.then(
                function (success) {
                    $window.open(urlApi.url_base_api + Api.relatorio.abrirRelatorio + success.data);
                },
                function (error) {
                    MdDialogService.alertPadrao(error.data);
                }).finally(function () {
                    vm.gerandoRelatorio = false;
                });
        }

        function formatarItem(id) {
            var produto = serviceProdutos.find(function (p) { return p.codigo === id; });
            if (!produto) return '';
            var descricao = produto.descricao;
            return descricao.length > 20 ? descricao.substring(0, 20) + '...' : descricao;
        }

        function formatarMotivo(id) {
            var motivo = serviceMotivos.find(function (m) { return m.codigo === id; });
            if (!motivo) return '';
            var descricao = motivo.descricao;
            return descricao.length > 20 ? descricao.substring(0, 20) + '...' : descricao;
        }

        function obterDescricaoCompletaMotivo(id) {
            var motivo = serviceMotivos.find(function (m) { return m.codigo === id; });
            return motivo ? motivo.descricao : '';
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('app.implantacaoMigracao.cadastro.processo', [])
        .config(config);

    function config($stateProvider, RotasHtml) {
        var rotasHtml = RotasHtml.implantacaoMigracao.cadastro.processo;
        $stateProvider
            .state('app.implantacaomigracao_cadastro_processo', {
                url: '/implantacao-migracao/cadastro/processo',
                module: 'privado',
                views: {
                    'content@app': {
                        templateUrl: rotasHtml.templateUrl,
                        controller: "ProcessoController as vm"
                    },
                    'processo-form@app.implantacaomigracao_cadastro_processo': {
                        templateUrl: rotasHtml.form
                    },
                    'processo-tabela@app.implantacaomigracao_cadastro_processo': {
                        templateUrl: rotasHtml.tabela
                    }
                },
                resolve: {
                    Tarefas: function (Api, RequisicaoGenericaService) {
                        return RequisicaoGenericaService.listarSemParams(Api.implantacaoMigracao.tarefa.listarTodos);
                    }
                }
            });
    }
})();
(function () {
    'use strict';

    angular.module('app.implantacaoMigracao.cadastro.processo')
        .controller('ProcessoController', ProcessoController);

    function ProcessoController(
        Api,
        PgToolbarService,
        RequisicaoGenericaService,
        DatatableFactory,
        ProximoCodigoService,
        MdDialogService,
        Tarefas
    ) {

        var vm = this;

        vm.tarefas = Tarefas.data;

        //#region Definição dos Métodos region
        vm.metodosGeral = {
            PreDefinirCamposParaInserir: PreDefinirCamposParaInserir
        };

        vm.metodos = {
            pesquisar: pesquisar,
            salvar: salvar,
            editar: editar,
            excluir: excluir,
            selecionar: selecionar
        };
        //#endregion

        //#region Implementação dos métodos ''

        /**
         * Método chamado quando é clicado no botão de inserir da toolbar, já pré definindo alguns campos
         */
        function PreDefinirCamposParaInserir() {

            // Defini de forma automática o próximo código do feriado
            PgToolbarService.iniciarPreLoaderToolbar(vm.controleForm, vm.controlePreloader);
            ProximoCodigoService.proximoCodigo(Api.implantacaoMigracao.processo.proximoCodigo).then(
                function (success) {
                    vm.processo = { codigo: success.data };
                    PgToolbarService.finalizarPreLoaderToolbar(vm.controleForm, vm.controlePreloader);
                },
                function (error) {
                    PgToolbarService.finalizarPreLoaderToolbar(vm.controleForm, vm.controlePreloader);
                    MdDialogService.alertPadrao(error.data);
                });
        }


        //#endregion        

        //#region Implementação dos Métodos 'Métodos'
        /**
         * Método para pesquisar uma lista de feriados
         */
        function pesquisar() {
            return RequisicaoGenericaService.listarComObjetoComplexo(Api.implantacaoMigracao.processo.listarComPaginacao, vm.entidadeDeEnvio);
        }

        function salvar(processoFunil) {
            if (!processoFunil.tarefas) processoFunil.tarefas = [];

            return RequisicaoGenericaService.salvar(Api.implantacaoMigracao.processo.criar, processoFunil);
        }

        function editar(processoFunil) {
            return RequisicaoGenericaService.editar(Api.implantacaoMigracao.processo.atualizar, processoFunil)
        }

        function excluir(processoFunil) {
            return RequisicaoGenericaService.excluir(Api.implantacaoMigracao.processo.excluir, processoFunil.codigo)
        }

        function selecionar(posicaoEntidade) {
            vm.metodosExternosPgToolbar.metodoControladorExternoListarTodasEntidades(null, posicaoEntidade);
        }

        //#endregion

    }
})();
(function () {
    'use strict';

    angular
        .module('app.implantacaoMigracao.cadastro.atividadeimplantacaomigracao', [])
        .config(config);

    function config($stateProvider, RotasHtml) {
        var rotasHtml = RotasHtml.implantacaoMigracao.cadastro.atividade;
        $stateProvider
            .state('app.implantacaomigracao_cadastro_atividade', {
                url: '/implantacao-migracao/cadastro/atividade',
                module: 'privado',
                views: {
                    'content@app': {
                        templateUrl: rotasHtml.templateUrl,
                        controller: "AtividadeImplantacaoMigracaoController as vm"
                    },
                    'atividade-form@app.implantacaomigracao_cadastro_atividade': {
                        templateUrl: rotasHtml.form
                    },
                    'atividade-tabela@app.implantacaomigracao_cadastro_atividade': {
                        templateUrl: rotasHtml.tabela
                    }
                }

            });
    }
})();
(function () {
    'use strict';

    angular.module('app.implantacaoMigracao.cadastro.atividadeimplantacaomigracao')
        .controller('AtividadeImplantacaoMigracaoController', AtividadeImplantacaoMigracaoController);

    function AtividadeImplantacaoMigracaoController(
        Api,
        PgToolbarService,
        RequisicaoGenericaService,
        ProximoCodigoService,
        MdDialogService
    ) {

        var vm = this;

        vm.metodos = {
            preDefinirCamposParaInserir: preDefinirCamposParaInserir,
            pesquisar: pesquisar,
            salvar: salvar,
            editar: editar,
            excluir: excluir,
            selecionar: selecionar,
            construirDtOptions: construirDtOptions
        };

        function preDefinirCamposParaInserir() {
            PgToolbarService.iniciarPreLoaderToolbar(vm.controleForm, vm.controlePreloader);
            ProximoCodigoService.proximoCodigo(Api.implantacaoMigracao.atividade.proximoCodigo).then(
                function (success) {
                    vm.atividade = {
                        codigo: success.data,
                        ativo: true,
                    };
                    PgToolbarService.finalizarPreLoaderToolbar(vm.controleForm, vm.controlePreloader);
                },
                function (error) {
                    PgToolbarService.finalizarPreLoaderToolbar(vm.controleForm, vm.controlePreloader);
                    MdDialogService.alertPadrao(error.data);
                });
        }

        function pesquisar() {
            return RequisicaoGenericaService.listarComObjetoComplexo(Api.implantacaoMigracao.atividade.listarComPaginacao, vm.entidadeDeEnvio);
        }

        function salvar(atividade) {
            return RequisicaoGenericaService.salvar(Api.implantacaoMigracao.atividade.criar, atividade);
        }

        function editar(atividade) {
            return RequisicaoGenericaService.editar(Api.implantacaoMigracao.atividade.atualizar, atividade)
        }

        function excluir(atividade) {
            return RequisicaoGenericaService.excluir(Api.implantacaoMigracao.atividade.excluir, atividade.codigo)
        }

        function selecionar(posicaoEntidade) {
            vm.metodosExternosPgToolbar.metodoControladorExternoListarTodasEntidades(null, posicaoEntidade);
        }

        function construirDtOptions() {
            DatatableFactory.construirDtOptionsComPaginacaoProcessadoNoServidorParaToolbar
                (Api.atividade.listarComPaginacaoDatatable, vm.entidadeDeEnvio.clsEntidade, '#datatable-atividade',
                    [

                        DatatableFactory.construirColunaDeSelecionarPadrao(function (indexLinha) { vm.metodos.selecionar(indexLinha) }),
                        {
                            targets: 1,
                            name: "Codigo",
                            data: "codigo",
                            defaultContent: ""
                        },
                        {
                            targets: 2,
                            name: "Descricao",
                            data: "descricao",
                            defaultContent: ""
                        },
                        {
                            targets: 3,
                            name: "Ativo",
                            data: "ativo",
                            render: function (data) {
                                if (data)
                                    return "Sim";
                                else
                                    return "Não";
                            },
                            defaultContent: ""
                        }
                    ]);
        }
    }
})();
(function () {
    'use strict';

    angular.module('app.financeiro.relatorio.contratos')
        .controller('RelatorioContratosController', RelatorioContratosController);

    function RelatorioContratosController(
        $window,
        Api,
        RequisicaoGenericaService,
        RotasHtml,
        RelatorioContratosFactory,
        NavegacaoService,
        RelatorioContratosService,
        urlApi,
        MdDialogService
    ) {
        var vm = this;
        NavegacaoService.setTituloAba('Financeiro relatório de contratos');

        init();

        vm.metodos = {
            gerarRelatorio: gerarRelatorio
        };

        function init() {
            vm.form = RelatorioContratosFactory.form;
            vm.filtrosContratos = RelatorioContratosFactory.filtrosContratos;
            vm.translateTitulosSteps = RelatorioContratosFactory.definirTransleteTitulosSteps();
            vm.rotasHtml = RotasHtml.relatorioContratos;
            vm.rota = Api.contrato.relatorio_contrato;

            vm.requisicaoSolicitada = false;
            vm.mensagemPreloader = "";
        };

        function gerarRelatorio(item) {
            var filtro = RelatorioContratosService.preparaFiltroParaEnvio(item);

            vm.requisicaoSolicitada = true;
            vm.mensagemPreloader = "Gerando relatório ..."

            RequisicaoGenericaService.salvar(
                Api.contrato.relatorio_contrato, filtro
            ).then(
                function (success) {
                    vm.requisicaoSolicitada = false;
                    vm.mensagemPreloader = "";
                    $window.open(
                        urlApi.url_base_api + Api.relatorio.abrirRelatorio + success.data
                    );
                },
                function (error) {
                    vm.requisicaoSolicitada = false;
                    vm.mensagemPreloader = "";
                    MdDialogService.alertPadrao("Atenção!", null, error.data);
                }
            );
        }
    }
})();
(function () {
    "use strict";

    angular
        .module("app.financeiro.relatorio.reajustes")
        .controller("RelatorioReajustesController", RelatorioReajustesController);

    function RelatorioReajustesController(
        $window,
        RequisicaoGenericaService,
        RelatorioContratosService,
        MdDialogService,
        NavegacaoService,
        RelatorioContratosFactory,
        RelatorioReajustesFactory,
        Api,
        RotasHtml,
        urlApi
    ) {
        var vm = this;
        NavegacaoService.setTituloAba("Financeiro relatório de reajustes");

        init();

        vm.metodos = {
            gerarRelatorio: gerarRelatorio
        };

        function init() {
            vm.form = RelatorioContratosFactory.form;
            vm.filtrosreajustes = RelatorioReajustesFactory.filtrosReajustes;
            vm.translateTitulosSteps = RelatorioContratosFactory.definirTransleteTitulosSteps();
            vm.rotasHtml = RotasHtml.relatorioreajustes;
            vm.rota = Api.contrato.relatorio_contrato;

            vm.requisicaoSolicitada = false;
            vm.mensagemPreloader = "";
        }

        function gerarRelatorio(item) {
            var filtro = RelatorioContratosService.preparaFiltroReajusteParaEnvio(item);

            vm.requisicaoSolicitada = true;
            vm.mensagemPreloader = "Gerando relatório ...";

            RequisicaoGenericaService.salvar(
                Api.contrato.relatorio_reajuste, filtro
            ).then(
                function (success) {
                    vm.requisicaoSolicitada = false;
                    vm.mensagemPreloader = "";
                    $window.open(
                        urlApi.url_base_api + Api.relatorio.abrirRelatorio + success.data
                    );
                },
                function (error) {
                    vm.requisicaoSolicitada = false;
                    vm.mensagemPreloader = "";
                    MdDialogService.alertPadrao("Atenção!", null, error.data);
                }
            );
        }
    }
})();

(function () {
    "use strict";
    angular
        .module("app.financeiro.processamento.contratos")
        .controller("ContratosController", ContratosController);

    function ContratosController(
        DataTableConfigPadrao,
        MdDialogService,
        ServicosGenericoService,
        DesabilitarBotoes,
        RequisicaoGenericaService,
        RotasHtml,
        Api,
        $scope,
        $timeout,
        NavegacaoService,
        $mdDialog,
        ControleAcessoConfig,
        Cliente,
        PgToolbarService,
        MdToastService,
        RequisicaoGenericaLocacaoService,
        PgToolbarFactory,
        ListarUsuariosSetorComercial
    ) {
        var vm = this;
        NavegacaoService.setTituloAba("Financeiro contratos");
        vm.rotasHtml = RotasHtml.contratos;
        vm.controladorDialog = ServicosGenericoService.retornarControladorDialog();
        vm.form = {};
        vm.regexUltimaChaveValidacao = /^[\d\D]{2}.[\d\D]{2}.[\d\D]{2}.[\d\D]{2}.[\d\D]{2}.[\d\D]{2}$/g;
        vm.titulo = "";
        vm.tabSelecionada = "contrato";

        vm.tabs = {
            primeiraAba: "contrato",
            segundaAba: "itens",
            terceiraAba: "historico",
            quartaAba: "caracteristicas"
        };

        vm.desabilitarBotoes = DesabilitarBotoes;
        vm.metodosInterno = configurarDtOptions();
        vm.exibirTabelaHistorico = true;
        vm.dtOptionsCaracteristicas = _dtOptionsCaracteristicas();


        vm.tiposMulta = [
            {
                codigo: 1,
                descricao: 'Não se aplica'
            },
            {
                codigo: 2,
                descricao: 'Cobrança única'
            }
        ];

        vm.tiposJuros = [
            {
                codigo: 1,
                descricao: 'Não se aplica'
            },
            {
                codigo: 2,
                descricao: 'Cobrança única'
            },
            {
                codigo: 3,
                descricao: 'Cobrança diária'
            },
        ];

        vm.cobrancaMultaJuros = [
            {

                codigo: 1,
                descricao: 'Valor fixo'
            },
            {
                codigo: 2,
                descricao: 'Percentual'
            }
        ];

        vm.tiposCorrecaoMonetaria = [
            {
                codigo: 1,
                descricao: 'Não se aplica'
            },
            {
                codigo: 2,
                descricao: 'IPCA'
            },
            {
                codigo: 3,
                descricao: 'IGP-M'
            },
            {
                codigo: 4,
                descricao: 'INPC'
            },
            {
                codigo: 5,
                descricao: 'Selic'
            },
            {
                codigo: 6,
                descricao: 'CDI'
            }
        ]

        //Verifica se o usuário tem acesso a todos os campos/informações
        if (
            ControleAcessoConfig.usuarioEDirecao() ||
            ControleAcessoConfig.usuarioEComercial() ||
            ControleAcessoConfig.usuarioEAdministrativo()
        ) {
            vm.habilitarVisualizacao = true;
            vm.desabilitarBotoes = false;
        } else {
            vm.habilitarVisualizacao = false;
        }

        vm.usuarioEhManutencao = ControleAcessoConfig.usuarioEManutencao();

        init();

        $scope.$watch("vm.contrato", function () {
            vm.resumoEquipamentosPorContrato = undefined;
            vm.possuiRiscoRescisaoContratual = !!(vm.contrato && vm.contrato.contratoItens && vm.contrato.contratoItens.find(function (item) {
                return item.riscoRescisaoContratual;
            }));
            tabSelecionada(vm.tabSelecionada);
        });

        $scope.$watch("vm.form.$valid", function (newValue, oldValue) {
            if (vm.controleForm) vm.controleForm.habilitarButtonSalvar = newValue;
        });

        vm.metodosInterno = {
            configurarDtOptions: configurarDtOptions,
            listarHistoricosDoContrato: listarHistoricosDoContrato,
            listarUsuarios: listarUsuarios,
            listarTiposBloqueio: listarTiposBloqueio,
            listarSituacoesContrato: listarSituacoesContrato,
            listarSituacoesFinanceirasContrato: listarSituacoesFinanceirasContrato,
            listarIndicesReajuste: listarIndicesReajuste,
            listarTodasSolucoes: listarTodasSolucoes,
            listarClientesEmpresaFaturamento: listarClientesEmpresaFaturamento,
            _preDefinirContrato: _preDefinirContrato,
            _preDefinirVariaveisDeControle: _preDefinirVariaveisDeControle
        };

        vm.metodosGeral = {
            tabSelecionada: tabSelecionada,
            preDefinirValoresQuandoNavegado: preDefinirValoresQuandoNavegado,
            fecharDialog: fecharDialog
        };

        vm.metodos = {
            pesquisar: pesquisar,
            salvar: salvar,
            editar: editar,
            excluir: excluir,
            preDefinirCamposParaInsercao: preDefinirCamposParaInsercao,
            formatarVisualizacaoCampoObservacao: formatarVisualizacaoCampoObservacao,
            configurarAutoCompleteClienteOnBlur: configurarAutoCompleteClienteOnBlur,
            alterarItemSelecionadoAutoCompleteCliente: alterarItemSelecionadoAutoCompleteCliente,
            pesquisarAutoCompleteCliente: pesquisarAutoCompleteCliente,
            abrirDialogHistoricoContrato: abrirDialogHistoricoContrato,
            ngChangeContratoRescindido: ngChangeContratoRescindido,
            configurarMdSelectEmpresaFaturamento: configurarMdSelectEmpresaFaturamento,
            configurarMdSelectFormaPagamento: configurarMdSelectFormaPagamento,
            configurarMdSelectTipoContrato: configurarMdSelectTipoContrato,
            cadastrarCaracteristica: cadastrarCaracteristica,
            excluirCaracteristica: excluirCaracteristica,
            abrirDialogPrioritario: abrirDialogPrioritario,
            abrirDialogItem: abrirDialogItem,
            retornarDescricaoSituacaoItem: retornarDescricaoSituacaoItem,
            retornarDescricaoSituacaoFinanceiraItem: retornarDescricaoSituacaoFinanceiraItem,
            retornarDescricaoItem: retornarDescricaoItem,
            formatarDescricaoSubitensHistorico: formatarDescricaoSubitensHistorico,
            truncarDescricaoSubitensHistorico: truncarDescricaoSubitensHistorico,
            desabilitaBotaoInserirHistorico: desabilitaBotaoInserirHistorico,
            onchangeValorZerado: onchangeValorZerado,
            setUndefinedMultaJuros: setUndefinedMultaJuros,
            setCamposUndefined: setCamposUndefined,
        };

        function init() {
            vm.controleForm = {};
            vm.contrato = {};
            vm.contratos = [];
            vm.bloquearEdicaoCliente = false;
            vm.iniciarChamandoPesquisa = false;
            vm.menssagemErro = "";

            listarUsuarios();
            listarTiposBloqueio();
            listarSituacoesContrato();
            listarSituacoesFinanceirasContrato();
            listarIndicesReajuste();
            listarTodasSolucoes();
            listarCaracteristicas();
            listarClientesEmpresaFaturamento();

            _preDefinirVariaveisDeControle();
            _preDefinirContrato();
            _carregarDependenciasFaturamento();
            listarTiposContrato();
            listarFormasPagamento();
            listarTodasCaracteristicasItem();
        }

        function configurarDtOptions() {
            vm.dtOptionsContratoHistorico =
                DataTableConfigPadrao.dtOptionsPadraoComPaginacaoPaginTypeNumbersEReponsivo;
            vm.dtOptionsContratoHistorico.lengthMenu = [10];
            vm.dtOptionsContratoHistorico.pageLength = [10];
            vm.dtOptionsContratoHistorico.columnDefs = [
                DataTableConfigPadrao.columnDefsPadrao
            ];
        }

        function listarHistoricosDoContrato() {
            vm.controleForm.emProgresso = true;
            ServicosGenericoService.exibirPreloaderRequisicaoIniciada(
                vm.controladorDialog
            );
            RequisicaoGenericaService.listarSemParams(
                Api.contrato.historico_contrato.listarHistoricoPorContrato +
                vm.contrato.codigo
            ).then(
                function (success) {
                    vm.controleForm.emProgresso = false;
                    ServicosGenericoService.ocultarPreloaderRequisicaoFinalizada(
                        vm.controladorDialog
                    );
                    vm.contratoHistoricos = _permiteEditarHistorico(success.data);
                },
                function (error) {
                    vm.controleForm.emProgresso = false;
                    ServicosGenericoService.ocultarPreloaderRequisicaoFinalizada(
                        vm.controladorDialog
                    );
                    MdDialogService.alertPadrao(error.data, null);
                }
            );
        }

        function formatarDescricaoSubitensHistorico(item) {
            return item.descricaoSubItens || '-';
        }

        function truncarDescricaoSubitensHistorico(item) {
            var descricao = formatarDescricaoSubitensHistorico(item);
            if (descricao.length > 30) {
                return descricao.substring(0, 27) + '...';
            }
            return descricao;
        }

        function listarUsuarios() {
            ServicosGenericoService.exibirPreloaderRequisicaoIniciada(
                vm.controladorDialog
            );
            RequisicaoGenericaService.listarSemParams(
                Api.usuario.detalhes_usuario.listarUsuariosAtivos
            ).then(
                function (success) {
                    ServicosGenericoService.ocultarPreloaderRequisicaoFinalizada(
                        vm.controladorDialog
                    );
                    vm.usuariosBkp = success.data;
                    vm.usuarios = angular.copy(vm.usuariosBkp);
                },
                function (error) {
                    ServicosGenericoService.ocultarPreloaderRequisicaoFinalizada(
                        vm.controladorDialog
                    );
                    MdDialogService.alertPadrao(error.data, null);
                }
            );
        }

        function listarTiposBloqueio() {
            ServicosGenericoService.exibirPreloaderRequisicaoIniciada(
                vm.controladorDialog
            );
            RequisicaoGenericaService.listarSemParams(
                Api.display.listarTipoBloqueioContrato
            ).then(
                function (success) {
                    ServicosGenericoService.ocultarPreloaderRequisicaoFinalizada(
                        vm.controladorDialog
                    );
                    vm.tiposBloqueio = success.data;
                },
                function (error) {
                    ServicosGenericoService.ocultarPreloaderRequisicaoFinalizada(
                        vm.controladorDialog
                    );
                    MdDialogService.alertPadrao(error.data, null);
                }
            );
        }

        function listarSituacoesContrato() {
            ServicosGenericoService.exibirPreloaderRequisicaoIniciada(
                vm.controladorDialog
            );
            RequisicaoGenericaService.listarSemParams(
                Api.display.listarSituacaoContrato
            ).then(
                function (success) {

                    ServicosGenericoService.ocultarPreloaderRequisicaoFinalizada(
                        vm.controladorDialog
                    );
                    vm.situacoesContrato = success.data;
                },
                function (error) {
                    ServicosGenericoService.ocultarPreloaderRequisicaoFinalizada(
                        vm.controladorDialog
                    );
                    MdDialogService.alertPadrao(error.data, null);
                }
            );
        }

        function listarSituacoesFinanceirasContrato() {
            ServicosGenericoService.exibirPreloaderRequisicaoIniciada(
                vm.controladorDialog
            );
            RequisicaoGenericaService.listarSemParams(
                Api.display.listarSituacaoFinanceiraContrato
            ).then(
                function (success) {
                    ServicosGenericoService.ocultarPreloaderRequisicaoFinalizada(
                        vm.controladorDialog
                    );
                    vm.situacoesFinanceirasContrato = success.data;
                },
                function (error) {
                    ServicosGenericoService.ocultarPreloaderRequisicaoFinalizada(
                        vm.controladorDialog
                    );
                    MdDialogService.alertPadrao(error.data, null);
                }
            );
        }

        function listarIndicesReajuste() {
            ServicosGenericoService.exibirPreloaderRequisicaoIniciada(
                vm.controladorDialog
            );
            RequisicaoGenericaService.listarSemParams(
                Api.contrato.indice_reajuste.listarPor
            ).then(
                function (success) {
                    ServicosGenericoService.ocultarPreloaderRequisicaoFinalizada(
                        vm.controladorDialog
                    );
                    vm.indicesReajuste = success.data;
                },
                function (error) {
                    ServicosGenericoService.ocultarPreloaderRequisicaoFinalizada(
                        vm.controladorDialog
                    );
                    MdDialogService.alertPadrao(error.data, null);
                }
            );
        }

        function listarTodasSolucoes() {
            ServicosGenericoService.exibirPreloaderRequisicaoIniciada(
                vm.controladorDialog
            );
            RequisicaoGenericaService.listarComArrayDeParams(
                Api.solucao_rotinas_tarefas.solucao.listarPor
            ).then(
                function (success) {
                    ServicosGenericoService.ocultarPreloaderRequisicaoFinalizada(
                        vm.controladorDialog
                    );
                    vm.solucoes = success.data;
                },
                function (error) {
                    ServicosGenericoService.ocultarPreloaderRequisicaoFinalizada(
                        vm.controladorDialog
                    );
                    MdDialogService.alertPadrao(error.data, null);
                }
            );
        }

        function listarClientesEmpresaFaturamento() {
            ServicosGenericoService.exibirPreloaderRequisicaoIniciada(
                vm.controladorDialog
            );
            RequisicaoGenericaService.listarSemParams(
                Api.cliente.listarClientesEmpresaFaturamento
            ).then(
                function (success) {
                    ServicosGenericoService.ocultarPreloaderRequisicaoFinalizada(
                        vm.controladorDialog
                    );
                    vm.clientesEmpresaFaturamento = success.data;
                },
                function (error) {
                    ServicosGenericoService.ocultarPreloaderRequisicaoFinalizada(
                        vm.controladorDialog
                    );
                    MdDialogService.alertPadrao(error.data, null);
                }
            );
        }

        function _preDefinirContrato() {
            if (Cliente) {
                vm.contrato = {
                    cliente: Cliente,
                    codigoCliente: Cliente.codigo
                };
            } else {
                vm.contrato = {};
            }
        }

        function _preDefinirVariaveisDeControle() {
            if (Cliente) {
                vm.iniciarChamandoPesquisa = true;
                vm.bloquearEdicaoCliente = true;
            } else {
                vm.iniciarChamandoPesquisa = false;
                vm.bloquearEdicaoCliente = false;
            }
        }

        function tabSelecionada(tab) {
            vm.tabSelecionada = tab;

            if (tab == vm.tabs.terceiraAba) {
                listarHistoricosDoContrato();

                vm.exibirTabelaHistorico = false;
                $timeout(function () {
                    vm.exibirTabelaHistorico = true;
                }, 250);
            } else if (tab == vm.tabs.quartaAba && !vm.controleForm.inserirAtivo) {
                listarCaracteristicasContrato();
                limparModelCaracteristicaContrato();
            }
            else if (tab == vm.tabs.segundaAba) {
                atualizar();
            }
        }

        function preDefinirValoresQuandoNavegado() {
            tabSelecionada(vm.tabSelecionada);
        }

        function fecharDialog() {
            $mdDialog.hide();
        }

        function pesquisar() {
            vm.entidadeDeEnvio = PgToolbarService.recuperarEntidadeDeEnvio();

            return RequisicaoGenericaService.listarComObjetoComplexo(
                Api.contrato.listarComPaginacao,
                vm.entidadeDeEnvio
            )
        }

        function atualizar() {
            return RequisicaoGenericaService.listarComParams(
                Api.contrato.listarValoresContratos + vm.contrato.codigo
            ).then(function (success) {
                vm.contratoItem.contratoItemDadosSigiloso.valorMensal = success.data.valorMensal;
                vm.contratoItem.contratoItemDadosSigiloso.valorComissionavel = success.data.valorComissionavel;
            });
        }

        function salvar(modelo) {
            return RequisicaoGenericaService.salvar(Api.contrato.criar, modelo)
        }

        function editar(modelo) {
            return RequisicaoGenericaService.editar(Api.contrato.atualizar, modelo);
        }

        function excluir(modelo) {
            return RequisicaoGenericaService.excluir(
                Api.contrato.excluir,
                modelo.codigo + "/" + modelo.codigoCliente
            );
        }

        function _permiteEditarHistorico(contratoHistoricos) {
            contratoHistoricos.map(function (historico) {

                var historicosOrdenados = contratoHistoricos
                    .filter(function (historicoContrato) {
                        return historicoContrato.codigoContratoItem == historico.codigoContratoItem
                    });

                historicosOrdenados.sort(function (a, b) {
                    return b.codigo - a.codigo;
                });

                var ultimoHistorico = historicosOrdenados[0];

                historico.permiteEditarHistorico = !(ultimoHistorico.codigo == historico.codigo);
            });

            return contratoHistoricos;
        }

        function preDefinirCamposParaInsercao() {
            _preDefinirContrato();
            vm.contrato.contratoEncargo = {
                multa: 1,
                juros: 1,
                correcaoMonetaria: 1,
            }
        }

        function onchangeValorZerado(form, valor) {
            if (form.$name == 'valorMulta') {
                if (valor <= 0 || valor == '') {
                    form.$setValidity("validaMaiorQueZero", false);
                } else {
                    form.$setValidity("validaMaiorQueZero", true);
                }
            }

            if (form.$name == 'valorJuros') {
                if (valor <= 0 || valor == '') {
                    form.$setValidity("validaMaiorQueZero", false);
                } else {
                    form.$setValidity("validaMaiorQueZero", true);
                }
            }
        }

        function setCamposUndefined(valor, form) {
            if (valor == 1 && form.$name == 'tipoMulta') {
                vm.contrato.contratoEncargo.cobrancaMulta = undefined;
                vm.contrato.contratoEncargo.valorMulta = undefined;
            }
            if (valor == 1 && form.$name == 'tipoJuros') {
                vm.contrato.contratoEncargo.cobrancaJuros = undefined;
                vm.contrato.contratoEncargo.valorJuros = undefined;
            }
            if (valor == 1 && form.$name == 'correcaoMonetaria') {
                vm.contrato.contratoEncargo.dataBaseCorrecaoMonetaria = undefined;
            }
        }

        function setUndefinedMultaJuros(multa) {
            if (multa) {
                vm.contrato.contratoEncargo.valorMulta = undefined;
            } else {
                vm.contrato.contratoEncargo.valorJuros = undefined;
            }

        }

        function formatarVisualizacaoCampoObservacao(campo) {
            if (campo) {
                return campo.length > 80 ? campo.substring(0, 77) + "..." : campo;
            }
        }

        function configurarAutoCompleteClienteOnBlur() {
            if (!vm.contrato.cliente) {
                vm.textoDePesquisaAutoCompleteCliente = "";
            }
        }

        function alterarItemSelecionadoAutoCompleteCliente(item) {
            if (item) {
                vm.contrato.codigoCliente = item.codigo;
            } else {
                vm.textoDePesquisaAutoCompleteCliente = "";
                if (vm.contrato) {
                    vm.contrato.codigoCliente = null;
                    vm.contrato.cliente = null;
                }
            }
        }

        function pesquisarAutoCompleteCliente(query) {
            return ServicosGenericoService.pesquisarAutoCompleteCodigoOuNomeGenericoApi(
                Api.cliente.listarCodigoDescricao,
                query
            );
        }

        function abrirDialogHistoricoContrato(event, historicoContrato, apenasVisualizacao, editarAtivo) {
            event.preventDefault();
            var exibirValorMensal = false;
            if (
                !vm.contratoHistoricos ||
                (vm.contratoHistoricos && vm.contratoHistoricos.length <= 0)
            ) {
                exibirValorMensal = true;
            }

            $mdDialog.show({
                controller: "DialogContratosHistoricoController",
                controllerAs: "vm",
                templateUrl: vm.rotasHtml.tabs.tabHistorico.dialog,
                multiple: true,
                targetEvent: event,
                clickOutsideToClose: false,
                locals: {
                    ContratoHistoricos: vm.contratoHistoricos,
                    HistoricoContrato: angular.copy(historicoContrato),
                    CodigoContrato: vm.contrato.codigo,
                    ExibirValorMensal: angular.copy(exibirValorMensal),
                    ApenasVisualizacao: apenasVisualizacao,
                    EditarAtivo: editarAtivo,
                    ApenasPrioritario: false,
                    Contrato: vm.contrato
                },
            }).then(function (houveAlteracoes) {
                if (houveAlteracoes == true) {
                    _atualizarDadosDoContrato();
                }
            });
        }

        function abrirDialogPrioritario(event, historicoContrato) {
            event.preventDefault();
            var exibirValorMensal = false;
            if (!vm.contratoHistoricos ||
                (vm.contratoHistoricos && vm.contratoHistoricos.length <= 0)
            ) {
                exibirValorMensal = true;
            }

            $mdDialog.show({
                controller: "DialogPrioritarioController",
                controllerAs: "vm",
                templateUrl: vm.rotasHtml.tabs.tabHistorico.prioritario,
                multiple: true,
                targetEvent: event,
                clickOutsideToClose: false,
                locals: {
                    HistoricoContrato: angular.copy(historicoContrato)
                },
            }).then(function (houveAlteracoes) {
                if (houveAlteracoes == true) {
                    _atualizarDadosDoContrato();
                }
            });
        }

        function ngChangeContratoRescindido(contratoRescindido) {
            if (contratoRescindido) {
                vm.contrato.contratoDadosSigiloso.situacaoContrato = 2;
                vm.contrato.contratoDadosSigiloso.situacaoFinanceiraContrato = 2;
            } else {
                vm.contrato.contratoRescisao.dataRescisao = null;
                vm.contrato.contratoRescisao.motivoRescisao = null;
            }
        }

        function configurarMdSelectEmpresaFaturamento() {
            vm.filtrarEmpresaFaturamento = "";
            angular
                .element("#contrato-cliente-empresa-faturamento-md-select")
                .on("keydown", function (ev) {
                    ev.stopPropagation();
                });
        }

        function configurarMdSelectFormaPagamento() {
            vm.filtrarFormaPagamento = "";
            angular
                .element("#contrato-forma-pagamento-md-select")
                .on("keydown", function (ev) {
                    ev.stopPropagation();
                });
        }

        function configurarMdSelectTipoContrato() {
            vm.filtrarTipoContrato = "";
            angular
                .element("#contrato-form-tipo-contrato-md-select")
                .on("keydown", function (ev) {
                    ev.stopPropagation();
                });
        }

        function _carregarDependenciasFaturamento() {
            vm.controleForm.emProgresso = true;

            var promiseFaturamento = RequisicaoGenericaService.listarSemParams(
                Api.formaFaturamento.listarTodos
            );

            Promise.all([promiseFaturamento]).then(
                function (value) {

                    vm.formasFaturamento = value[0].data;
                    vm.controleForm.emProgresso = false;
                },
                function (error) {
                    vm.controleForm.emProgresso = false;
                    console.log(error);
                }
            );
        }

        function listarTiposContrato() {
            RequisicaoGenericaService.listarSemParams(
                Api.contrato.tipo_contrato.listarTodos
            ).then(
                function (success) {
                    vm.tiposContrato = success.data
                },
                function (error) {
                    MdDialogService.alertPadrao(error.data);
                    console.log(error);
                }
            );
        }

        function listarFormasPagamento() {
            RequisicaoGenericaService.listarSemParams(
                Api.formaPagamento.listarTodos
            ).then(
                function (success) {
                    vm.formasPagamento = success.data
                },
                function (error) {
                    MdDialogService.alertPadrao(error.data);
                    console.log(error);
                }
            );
        }

        function listarTodasCaracteristicasItem() {
            RequisicaoGenericaService.listarSemParams(
                Api.contrato_caracteristica.listarTodasCaracteristicasItem
            ).then(
                function (success) {
                    vm.todasCaracteristicasItem = success.data
                },
                function (error) {
                    MdDialogService.alertPadrao(error.data);
                    console.log(error);
                }
            );
        }

        function listarSubItensAtivos() {
            return RequisicaoGenericaService.listarSemParams(
                Api.produto.listarTodosProdutosAtivos
            );
        }

        function listarCaracteristicas() {
            RequisicaoGenericaService.listarSemParams(
                Api.contrato_caracteristica.listarTodos
            ).then(
                function (success) {
                    vm.caracteristicas = success.data;
                },
                function (error) {
                    MdDialogService.alertPadrao(error.data);
                }
            );
        }

        function _dtOptionsCaracteristicas() {
            var options = angular.copy(
                DataTableConfigPadrao.dtOptionsResponsivoSemPaginacaoComInitComplete
            );
            options.columnDefs = [
                {
                    targets: 0,
                    ordering: false,
                    filterable: false,
                    sortable: false,
                    width: "20%",
                    responsivePriority: 1
                },
                {
                    targets: 1,
                    width: "20%"
                },
                {
                    targets: 2,
                    responsivePriority: 1
                }
            ];
            options.dom = "rt";
            options.oLanguage = {
                sEmptyTable: "Não foram encontrados dados para exibir"
            };
            return options;
        }

        function listarCaracteristicasContrato() {
            vm.controleForm.emProgresso = true;
            RequisicaoGenericaService.listarSemParams(
                Api.contrato_caracteristica.listarCaracteristicas +
                "/" +
                vm.contrato.codigo
            ).then(
                function (success) {
                    vm.controleForm.emProgresso = false;
                    vm.caracteristicasContrato = success.data;
                },
                function (error) {
                    vm.controleForm.emProgresso = false;
                    MdDialogService.alertPadrao(error.data);
                }
            );
        }

        function cadastrarCaracteristica(modelo, event) {
            RequisicaoGenericaService.salvar(
                Api.contrato_caracteristica.vincularCaracteristica,
                modelo
            ).then(
                function (success) {
                    MdToastService.toastPadrao("Característica cadastrada com sucesso!");
                    vm.caracteristicasContrato = success.data;
                    limparModelCaracteristicaContrato();
                },
                function (error) {
                    MdDialogService.alertPadrao(error.data);
                }
            );
        }

        function excluirCaracteristica(modelo, event) {
            MdDialogService.confirmPadraoComEvento(
                "Deseja realmente excluir esta característica do contrato?",
                null,
                event,
                function () {
                    RequisicaoGenericaService.excluir(
                        Api.contrato_caracteristica.excluirCaracteristica,
                        "/" + modelo.codigo + "/" + vm.contrato.codigo
                    ).then(
                        function (success) {
                            MdToastService.toastPadrao(success.data);
                            vm.caracteristicasContrato.splice(
                                vm.caracteristicasContrato.indexOf(modelo),
                                1
                            );
                            limparModelCaracteristicaContrato();
                        },
                        function (error) {
                            MdDialogService.alertPadrao(error.data, event);
                        }
                    );
                }
            );
        }

        function limparModelCaracteristicaContrato() {
            vm.caracteristicaContrato = {
                codigoContrato: vm.contrato.codigo
            };
        }

        function listarResumoEquipamentosPorContrato(contratoItemCodigo) {
            return RequisicaoGenericaLocacaoService.listarSemParams(
                Api.locacao.equipamentos.equipamento.listarPorClienteContratoItem + contratoItemCodigo);
        }

        function abrirDialogItem(contratoItem, apenasVisualizacao, contratoItemCodigo) {
            if (contratoItem != null) {
                contratoItem.itemCaracteristicas = contratoItem.caracteristicas.
                    map(function (caracteristica) {
                        return caracteristica.codigo;
                    });
            };

            if (contratoItem != null) {
                contratoItemCodigo = contratoItem.codigo;
            };

            vm.controleForm.emProgresso = true;
            ServicosGenericoService.exibirPreloaderRequisicaoIniciada(
                vm.controladorDialog
            );

            RequisicaoGenericaService.listarSemParams(Api.contrato.motivo_risco_contratual.listarTodosMotivos)
                .then(function (motivosRiscosSuccess) {
                    listarSubItensAtivos()
                        .then(function (subItensAtivosSuccess) {
                            listarResumoEquipamentosPorContrato(contratoItemCodigo)
                                .then(function (success) {
                                    $mdDialog.show({
                                        controller: 'DialogItensController',
                                        controllerAs: 'vm',
                                        templateUrl: vm.rotasHtml.tabs.dialogInserirItens,
                                        multiple: true,
                                        targetEvent: event,
                                        clickOutsideToClose: false,
                                        escapeToClose: false,
                                        locals: {
                                            ContratoItem: angular.copy(contratoItem),
                                            Contrato: vm.contrato,
                                            TiposBloqueio: vm.tiposBloqueio,
                                            Caracteristicas: vm.todasCaracteristicasItem,
                                            Situacaoitem: vm.situacoesContrato,
                                            SituacaoFinanceiraItem: vm.situacoesFinanceirasContrato,
                                            FormasFaturamento: vm.formasFaturamento,
                                            ApenasVisualizacao: apenasVisualizacao,
                                            HabilitarVisualizacao: vm.habilitarVisualizacao,
                                            ResumoEquipamentosPorContrato: success.data,
                                            UsuariosSetorComercial: ListarUsuariosSetorComercial.data,
                                            ListaMotivosRiscosContratuais: motivosRiscosSuccess.data,
                                            SubItensAtivos: subItensAtivosSuccess.data
                                        }
                                    }).then(function (houveAlteracoes) {
                                        _atualizarDadosDoContrato();
                                        if (contratoItem == null && houveAlteracoes) {
                                            MdDialogService.confirmPadraoComEvento("Deseja cadastrar um novo item?", "", null,
                                                function () {
                                                    vm.metodos.abrirDialogItem();
                                                }
                                            )
                                        }
                                    });
                                }, function (error) {
                                    MdDialogService.alertPadrao(error.data.error);
                                }).finally(function () {
                                    vm.controleForm.emProgresso = false;
                                    ServicosGenericoService.ocultarPreloaderRequisicaoFinalizada(
                                        vm.controladorDialog
                                    );
                                });
                        }, function (error) {
                            MdDialogService.alertPadrao(error.data.error);
                        });
                }, function (error) {
                    MdDialogService.alertPadrao(error.data.error);
                });
        }

        function retornarDescricaoSituacaoItem(codigoSituacao) {
            var situacoesContrato = Object.entries(vm.situacoesContrato).map(function (dados) {
                return ({ codigo: dados[0], descricao: dados[1] });
            });

            var situacao = situacoesContrato.find(function (situacao) {
                return situacao.codigo == codigoSituacao;
            });

            if (situacao != null & situacao != undefined) {
                return situacao.descricao;
            } else {
                return "";
            }
        }

        function retornarDescricaoSituacaoFinanceiraItem(codigoSituacaoFinanceira) {
            var situacoesFinanceirasContrato = Object.entries(vm.situacoesFinanceirasContrato).map(function (dados) {
                return ({ codigo: dados[0], descricao: dados[1] });
            });

            var situacao = situacoesFinanceirasContrato.find(function (situacao) {
                return situacao.codigo == codigoSituacaoFinanceira;
            });

            if (situacao != null & situacao != undefined) {
                return situacao.descricao;
            } else {
                return "";
            }
        }

        function retornarDescricaoItem(contratoItemCodigo) {
            if (vm.contrato.contratoItens) {
                var item = vm.contrato.contratoItens.find(function (item) {
                    return item.codigo == contratoItemCodigo;
                });
                if (item != null & item != undefined) {
                    return item.produto.descricao;
                } else {
                    return "Contrato";
                }
            }
        }

        function desabilitaBotaoInserirHistorico() {
            if (vm.contrato.contratoItens) {
                return vm.contrato.contratoItens.every(function (contratoItem) {
                    return contratoItem.contratoItemDadosSigiloso.situacaoItem == 2
                        && contratoItem.contratoItemDadosSigiloso.situacaoFinanceiraItem == 2;
                });
            }

            return true;
        }

        function _atualizarDadosDoContrato() {
            PgToolbarService.iniciarPreLoaderToolbar(vm.controleForm, vm.controlePreloader);
            var entidadeDeEnvio = PgToolbarFactory.construirEntidadeDeEnvioPadrao(vm.contrato);
            return RequisicaoGenericaService.listarComObjetoComplexo(
                Api.contrato.listarComPaginacao, entidadeDeEnvio
            ).then(function (success) {
                vm.contrato = success.data.lstResultado[0];
                PgToolbarService.finalizarPreLoaderToolbar(vm.controleForm, vm.controlePreloader);
            }, function (error) {
                MdDialogService.alertPadrao("Atenção!", null, error.data);
                PgToolbarService.finalizarPreLoaderToolbar(vm.controleForm, vm.controlePreloader);
            })
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('app.custosoftware.cadastro.historico-custo', [])
        .config(config);

    function config($stateProvider, RotasHtml) {

        var rotasHtml = RotasHtml.custoSoftware.cadastro.historico;

        $stateProvider
            .state('app.custo_software_historico', {
                url: '/custo-software/cadastro/historico',
                module: 'privado',
                views: {
                    'content@app': {
                        templateUrl: rotasHtml.templateUrl,
                        controller: "HistoricoCustoController as vm"
                    },
                    'custo_software_historico-form@app.custo_software_historico': {
                        templateUrl: rotasHtml.form
                    },
                    'custo_software_historico-tabela@app.custo_software_historico': {
                        templateUrl: rotasHtml.tabela
                    }
                },
                resolve: {
                    ListarUsuarioPorDetalhe: function (Api, RequisicaoGenericaService, LoginUsuarioService) {
                        return RequisicaoGenericaService.listarSemParams(Api.usuario.detalhes_usuario.listarDetalhesUsuario
                            + LoginUsuarioService.usuarioArmazenado().codigo);
                    },
                }
            })
    }
})();



(function () {
    'use strict';

    angular.module('app.custosoftware.cadastro.historico-custo')
        .controller('HistoricoCustoController', HistoricoCustoController);

    function HistoricoCustoController(
        $filter,
        Api,
        DatatableFactory,
        ListarUsuarioPorDetalhe,
        NavegacaoService,
        RequisicaoGenericaService,
        SquadService
    ) {
        var vm = this;
        NavegacaoService.setTituloAba('Custo por ponto');

        vm.squadUsuarioLogado = ListarUsuarioPorDetalhe.data.codigoSquads;
        vm.squads = SquadService.listarSquadsUsuarioLogado(vm.squadUsuarioLogado);

        vm.metodos = {
            pesquisar: pesquisar,
            salvar: salvar,
            editar: editar,
            selecionar: selecionar,
            excluir: excluir,
            construirDtOptions: construirDtOptions,
            predefinirCamposParaEdicao: predefinirCamposParaEdicao
        }

        //#region METODOS

        function pesquisar() {
            if (vm.squadUsuarioLogado.length === 1) {
                vm.entidadeDeEnvio.clsEntidade.squadCodigo = vm.squadUsuarioLogado[0]
            }
            return RequisicaoGenericaService.listarComObjetoComplexo(Api.custo_software.historico.listarComPaginacao, vm.entidadeDeEnvio);
        }

        function salvar(modelo) {
            if (vm.squadUsuarioLogado.length === 1) {
                modelo.squadCodigo = vm.squadUsuarioLogado[0];
            }
            return RequisicaoGenericaService.salvar(Api.custo_software.historico.salvar, modelo);
        }

        function excluir(modelo) {
            if (vm.squadUsuarioLogado.length === 1) {
                modelo.squadCodigo = vm.squadUsuarioLogado[0];
            }
            return RequisicaoGenericaService.excluir(Api.custo_software.historico.excluir, modelo.codigo)
        }

        function editar(modelo) {
            if (vm.squadUsuarioLogado.length === 1) {
                modelo.squadCodigo = vm.squadUsuarioLogado[0];
            }
            return RequisicaoGenericaService.editar(Api.custo_software.historico.atualizar, modelo)
        }

        function selecionar(posicaoEntidade) {
            vm.metodosExternosPgToolbar.metodoControladorExternoListarTodasEntidades(null, posicaoEntidade);
        }

        function predefinirCamposParaEdicao(entidadeDeEnvio) {
            entidadeDeEnvio.periodoInicial = new Date(entidadeDeEnvio.periodoInicial);
            entidadeDeEnvio.periodoFinal = new Date(entidadeDeEnvio.periodoFinal);
        }

        function construirDtOptions() {
            DatatableFactory.construirDtOptionsComPaginacaoProcessadoNoServidorParaToolbar
                (Api.custo_software.historico.listarcompaginacaodatatable, vm.entidadeDeEnvio.clsEntidade, '#datatable-conclusao-atendimento',
                    [
                        DatatableFactory.construirColunaDeSelecionarPadrao(function (indexLinha) { vm.metodos.selecionar(indexLinha) }),
                        {
                            targets: 1,
                            name: "Squad",
                            data: "squadCodigo",
                            render: function (squadCodigo) {
                                if (squadCodigo)
                                    return SquadService.descricaoSquad(squadCodigo);
                            },
                        },
                        {
                            targets: 2,
                            name: "ValorPonto",
                            data: "valorPonto",
                            render: function (data) {
                                return $filter('currency')(data, "R$ ");
                            }
                        },
                        {
                            targets: 3,
                            name: "PeriodoInicial",
                            data: "periodoInicial",
                            render: function (data) {
                                return $filter('date')(data, 'dd/MM/yyyy')
                            }
                        },
                        {
                            targets: 4,
                            name: "PeriodoFinal",
                            data: "periodoFinal",
                            render: function (data) {
                                return $filter('date')(data, 'dd/MM/yyyy')
                            }
                        }
                    ]);
        }
        //#endregion METODOS
    }
})();
/**
 * Created by nova on 26/10/2016.
 */
(function () {
  'use strict';

  angular
    .module('app.financeiro.processamento.contratos')
    .controller('EnvioDeEmailsController', EnvioDeEmailsController);


  function EnvioDeEmailsController($q, ServicosGenericoService, RequisicaoGenericaService, Api,
    LoginUsuarioService, MdDialogService, NavegacaoService, ListarTodosFinanceirosEmails) {
    var vm = this;
    NavegacaoService.setTituloAba('Financeiro envio de e-mails');


    //#region Data

    _init();
    //#endregion

    //#region Definição dos Métodos

    vm.metodos = {
      configuraAutoCompleteClienteOnBlur: configuraAutoCompleteClienteOnBlur,
      alterarItemSelecionadoAutoCompleteCliente: alterarItemSelecionadoAutoCompleteCliente,
      pesquisarAutoCompleteCliente: pesquisarAutoCompleteCliente,
      removerCliente: removerCliente,
      ngChangehabilitarTodosClientes: ngChangehabilitarTodosClientes,
      enviarEmails: enviarEmails

    };

    vm.metodosInternos = {
      _init: _init,
      _verificaSeExisteClienteNaLista: _verificaSeExisteClienteNaLista,
      _habilitarTodosClientes: _habilitarTodosClientes
    };

    //#endregion

    //#region Métodos

    function _init() {
      vm.filtroEnvioDeEmails = {
        arquivosSelecionados: [],
        solicitarConfirmacaoLeitura: true
      };
      vm.todosClientes = true;
      vm.financeiroEmails = ListarTodosFinanceirosEmails.data;
    }

    function configuraAutoCompleteClienteOnBlur() {
      if (!vm.cliente) {
        vm.textoDePesquisaAutoCompleteCliente = "";
      }
    }

    function pesquisarAutoCompleteCliente(query) {
      return ServicosGenericoService.pesquisarAutoCompleteCodigoOuNomeGenericoApi(Api.cliente.listarCodigoDescricao, query);
    }

    function alterarItemSelecionadoAutoCompleteCliente(item) {
      if (item && !_verificaSeExisteClienteNaLista(item)) {
        vm.filtroEnvioDeEmails.clientes.push({ nome: item.nome, codigo: item.codigo });
        vm.todosClientes = false;
      }
      vm.textoDePesquisaAutoCompleteCliente = "";

      vm.cliente = null;

    }

    function removerCliente(cliente) {
      vm.filtroEnvioDeEmails.clientes.splice(vm.filtroEnvioDeEmails.clientes.indexOf(cliente), 1);
      _habilitarTodosClientes();
    }

    function ngChangehabilitarTodosClientes() {
      _habilitarTodosClientes();
    }

    function enviarEmails(event, filtroUtilizado) {
      var deferred = $q.defer();

      var _modeloEnvio = {
        arquivos: filtroUtilizado.arquivosSelecionados,
        modelo: {
          codigoUsuario: LoginUsuarioService.usuarioArmazenado().codigo,
          codigoFinanceiroEmail: filtroUtilizado.email.codigo,
          solicitarConfirmacaoLeitura: filtroUtilizado.solicitarConfirmacaoLeitura
        }
      };

      RequisicaoGenericaService.salvarArquivosComObjeto(Api.financeiroEnvioDeEmails.enviarEmails, _modeloEnvio).then(
        function (success) {
          vm.todosClientes = true;

          if (success.data)
            MdDialogService.alertPadrao("", event, success.data.substrituirQuebraDeLinhasParaTagHtml());
          else
            MdDialogService.alertPadrao("Arquivos enviados com sucesso!");


          deferred.resolve(success);
        },
        function (error) {
          deferred.reject(error);
        });
      return deferred.promise;
    }

    //#endregion

    //#region Métodos Internos

    function _verificaSeExisteClienteNaLista(cliente) {
      return vm.filtroEnvioDeEmails.clientes.some(function (clienteExistente) {
        return ((cliente.codigo) == (clienteExistente.codigo));
      });
    }

    function _habilitarTodosClientes() {
      if (vm.filtroEnvioDeEmails.clientes.length == 0 || vm.todosClientes) {
        vm.filtroEnvioDeEmails.clientes = [];
        vm.todosClientes = true;
      }
    }

    //#endregion

  } // CONTROLLER

})();

//<!-- Ultima mudança 19/07/2017.-->
(function () {
  'use strict';

  angular
    .module('app.financeiro.cadastro.email', [])
    .config(config);

  function config($stateProvider, RotasHtml) {
    var rotasHtml = RotasHtml.financeiroEmail;
    $stateProvider
      .state('app.financeiro_cadastro_email', {
        url: '/financeiro/cadastro/email',
        module: 'privado',
        views: {
          'content@app': {
            templateUrl: rotasHtml.templateUrl,
            controller: 'FinanceiroEmailController as vm'
          },
          'financeiro-email-form@app.financeiro_cadastro_email': {
            templateUrl: rotasHtml.form
          },
          'financeiro-emails-tabela@app.financeiro_cadastro_email': {
            templateUrl: rotasHtml.tabela
          }
        },
        resolve: {
          ListarTodosDiretoriosCertidoes: function (Api, RequisicaoGenericaService) {
            return RequisicaoGenericaService.listarSemParams(Api.financeiroEmail.listarTodosDiretoriosCertidoes);
          }
        }
      });
  }

})();

(function () {
  'use strict';

  angular.module('app.financeiro.cadastro.email')
    .controller('FinanceiroEmailController', FinanceiroEmailController);

  function FinanceiroEmailController($q, Api, NavegacaoService, MdDialogService, RequisicaoGenericaService, DatatableFactory, ListarTodosDiretoriosCertidoes) {
    var vm = this;
    NavegacaoService.setTituloAba('Financeiro e-mail');

    // Data region

    _init();
    // endregion

    //#region Definição dos Métodos
    vm.metodos = {
      pesquisar: pesquisar,
      salvar: salvar,
      editar: editar,
      excluir: excluir,
      selecionar: selecionar,
      construirDtOptions: construirDtOptions
    }

    //endregion

    //#region Implementação dos Métodos
    function pesquisar() {
      var deferred = $q.defer();
      delete vm.entidadeDeEnvio.clsEntidade.mensagem;
      RequisicaoGenericaService.listarPorPaginacaoJsonFormato(vm.rota.listarComPaginacao, vm.entidadeDeEnvio).then(
        function (success) {
          vm.financeiroEmail = success.data.lstResultado[0];
          vm.financeiroEmail.senha = atob(success.data.lstResultado[0].senha);
          vm.financeiroEmails = success.data.lstResultado;

          success.data.atualizadoNoController = true;

          deferred.resolve(success);
        },
        function (error) {
          deferred.reject(error);
        });
      return deferred.promise;
    }

    function salvar(modelo) {
      var deferred = $q.defer();
      var modeloEnvio = angular.copy(modelo);
      modeloEnvio.senha = btoa(modelo.senha);

      if (_verificarSeDiretorioCertidaoValido(modeloEnvio)) {
        _requisicaoCriarEmail(modeloEnvio, deferred);
      } else {
        _exibirDialogConfirmacaoCertidaoInvalida("Criar", modelo, function () {
          _requisicaoCriarEmail(modeloEnvio, deferred);
        });
      }

      return deferred.promise;
    }

    function editar(modelo) {
      var deferred = $q.defer();
      var modeloEnvio = angular.copy(modelo);
      modeloEnvio.senha = btoa(modelo.senha);

      if (_verificarSeDiretorioCertidaoValido(modeloEnvio)) {
        _requisicaoEditarEmail(modeloEnvio, deferred);
      } else {
        _exibirDialogConfirmacaoCertidaoInvalida("Editar", modeloEnvio, function () {
          _requisicaoEditarEmail(modeloEnvio, deferred);
        });
      }

      return deferred.promise;
    }

    function excluir(modelo) {
      return RequisicaoGenericaService.excluir(vm.rota.excluir, modelo.codigo)
    }

    function selecionar(posicaoEntidade) {
      vm.metodosExternosPgToolbar.metodoControladorExternoListarTodasEntidades(null, posicaoEntidade);
    }

    function construirDtOptions() {
      DatatableFactory.construirDtOptionsComPaginacaoProcessadoNoServidorParaToolbar
        (vm.rota.listarComPaginacaoDatatable, vm.entidadeDeEnvio.clsEntidade, '#datatable-cadastro-financeiro-email',
          [

            DatatableFactory.construirColunaDeSelecionarPadrao(function (indexLinha) { vm.metodos.selecionar(indexLinha) }),
            {
              targets: 1,
              name: "Assunto",
              data: "assunto",
              defaultContent: "",
              sortable: false
            },
            {
              targets: 2,
              name: "Email",
              data: "email",
              defaultContent: "",
              sortable: false
            }
          ]);
    }

    //#endregion

    //#region Métodos Internos

    function _init() {
      vm.form = {};
      vm.financeiroEmails = [];
      vm.financeiroEmail = {};
      vm.diretoriosFinanceiroEmail = ListarTodosDiretoriosCertidoes.data;

      vm.rota = Api.financeiroEmail;
    }


    function _requisicaoEditarEmail(modeloEnvio, deferred) {
      RequisicaoGenericaService.editar(vm.rota.atualizar, modeloEnvio).then(
        function (success) {
          vm.financeiroEmail = success.data;
          vm.financeiroEmail.senha = atob(success.data.senha);
          success.data.atualizadoNoController = true;
          deferred.resolve(success);
        },
        function (error) {
          deferred.reject(error);
        });
    }

    function _requisicaoCriarEmail(modeloEnvio, deferred) {
      RequisicaoGenericaService.salvar(vm.rota.criar, modeloEnvio).then(
        function (success) {
          vm.financeiroEmail = success.data;
          vm.financeiroEmail.senha = atob(success.data.senha);

          success.data.atualizadoNoController = true;

          deferred.resolve(success);
        },
        function (error) {
          deferred.reject(error);
        });
    }

    function _verificarSeDiretorioCertidaoValido(modelo) {
      if (!modelo.diretorioCertidoes)
        return true;
      var diretorioEmail = modelo.email.split("@")[1].split(".")[0];
      return diretorioEmail == modelo.diretorioCertidoes;
    }

    function _exibirDialogConfirmacaoCertidaoInvalida(acao, modelo, eventoSim) {
      MdDialogService.confirmPadraoComEvento(acao,
        'A pasta selecionada ' + modelo.diretorioCertidoes + ' não corresponde ao domínio do e-mail ' + modelo.email + ', deseja continuar?',
        event,
        eventoSim,
        function () {
          vm.controleForm.emProgresso = false;
        });
    }

    //#endregion Métodos Internos

  }
})();

(function () {
    'use strict';

    angular.module('app.custosoftware.processamento.analise-custo')
        .controller('AnaliseCustoController', AnaliseCustoController);

    function AnaliseCustoController(
        $mdDialog,
        Api,
        DataTableConfigPadrao,
        ListarTodosClientes,
        ListarTodosCustosSoftwares,
        ListarTodasSolucoes,
        ListarUsuarioPorDetalhe,
        MdDialogService,
        NavegacaoService,
        RequisicaoGenericaService,
        SquadService,
        ToolbarService
    ) {
        var vm = this;
        NavegacaoService.setTituloAba('Análise de custo');

        vm.squadUsuarioLogado = ListarUsuarioPorDetalhe.data.codigoSquads;
        ToolbarService.armazenarCodigoSquadUsuarioLogado(vm.squadUsuarioLogado);
        vm.squads = SquadService.listarSquadsUsuarioLogado(vm.squadUsuarioLogado);

        vm.squadCodigo = ToolbarService.squadSelecionado();
        _listarProjetosGerenciarCustos(vm.squadCodigo);
        _listarSolucoesVinculadas();

        vm.metodos = {
            retornaPonto: retornaPonto,
            filtraPorLegenda: filtraPorLegenda,
            configuraMdSelectProjetos: configuraMdSelectProjetos,
            configuraMdSelectSolucoes: configuraMdSelectSolucoes,
            configuraMdSelectClientes: configuraMdSelectClientes,
            pesquisar: pesquisar,
            abrirDialogDashboard: abrirDialogDashboard,
            abrirDialogConclusao: abrirDialogConclusao,
            selectChangeSquad: selectChangeSquad,
            selectChangeCliente: selectChangeCliente
        }

        init();


        function init() {
            vm.todosClientes = ListarTodosClientes.data;
            vm.enviando = false;
            vm.totalHistorias = 0;

            vm.historias = [];
            vm.todasHistoriasFiltradas = [];

            vm.legenda = [
                { titulo: 'Erro:', cod: 13 },
                { titulo: 'Desenvolvimento:', cod: 6 },
                { titulo: 'Melhoria:', cod: 12 },
                { titulo: 'Pausa:', cod: 14 },
                { titulo: 'Homologada:', cod: 9 },
                { titulo: 'Liberada:', cod: 7 },
                { titulo: 'Teste:', cod: 8 },
                { titulo: 'Todos', cod: 0 }
            ];

            vm.projetos = [];
            vm.solucoes = [];
            vm.clientes = [];

            vm.filtros = {
                projetos: vm.projetos,
                solucoes: vm.solucoes,
                clientes: vm.clientes,
                dataInicialAberturaHistoria: vm.dataInicialAberturaHistoria,
                dataFinalAberturaHistoria: vm.dataFinalAberturaHistoria
            };

            vm.emProgresso = false;

            vm.dtOptions = angular.extend({}, DataTableConfigPadrao.dtOptionsResponsivoSemPaginacao, {
                dom: 'rt<"bottom footer-tabela-analise-custo"<"left valor-totalizador"i>>',
                language: {
                    emptyTable: "Não existem dados para serem exibidos.",
                    zeroRecords: "Não existem dados para o filtro selecionado.",
                    info: "Exibindo _START_ até _END_ de _TOTAL_ registros",
                    infoEmpty: "Não existem dados para serem exibidos."
                },
                paging: false,
                info: true,
                order: [],
                columnDefs: [
                    {
                        targets: [0, 1, 3],
                        orderable: false
                    }
                ]
            });
        }

        function retornaPonto(ponto) {
            if (angular.equals(null, ponto) || angular.equals(undefined, ponto))
                return 0;
            else
                return ponto;
        }

        function filtraPorLegenda(legenda) {
            vm.historias = angular.copy(vm.todasHistoriasFiltradas);
            vm.filtroLegenda = legenda.cod;
            if (legenda.cod == 0)
                return;

            vm.historias = vm.historias.filter(function (hist) {

                if ((legenda.cod == 14 || legenda.codigo == 11) && (hist.situacao == 11 || hist.situacao == 14)) {
                    return hist;
                }

                if (legenda.cod == 9 && hist.situacao == 15) {
                    return hist;
                }

                if (hist.situacao == legenda.cod) {
                    return hist;
                }

            });
        }

        function configuraMdSelectProjetos() {
            vm.filtrarProjetos = '';
            angular.element('#analise-custo-projetos-md-select').on('keydown', function (ev) { ev.stopPropagation(); });
        }

        function configuraMdSelectSolucoes() {
            vm.filtrarSolucoes = '';
            angular.element('#analise-custo-solucoes-md-select').on('keydown', function (ev) { ev.stopPropagation(); });
        }

        function configuraMdSelectClientes() {
            vm.filtrarClientes = '';
            angular.element('#analise-custo-clientes-md-select').on('keydown', function (ev) { ev.stopPropagation(); });
        }

        function pesquisar() {
            vm.emProgresso = true;
            vm.historias = [];
            vm.todasHistoriasFiltradas = [];

            if (vm.squadUsuarioLogado.length === 1) {
                vm.squadCodigo = vm.squadUsuarioLogado[0];
            }

            vm.filtros = {
                squadCodigo: vm.squadCodigo,
                projetos: vm.projetos,
                solucoes: vm.solucoes,
                clientes: vm.clientes,
                dataInicialAberturaHistoria: vm.dataInicialAberturaHistoria,
                dataFinalAberturaHistoria: vm.dataFinalAberturaHistoria
            }

            RequisicaoGenericaService.salvar(Api.custo_software.analiseCusto.listarDetalhamentoHistoriasPorProjeto, vm.filtros)
                .then(function (sucess) {
                    vm.historias = sucess.data;
                    vm.todasHistoriasFiltradas = sucess.data;
                    vm.filtroLegenda = 0;
                }, function (error) {
                    MdDialogService.alertPadrao(error.data);
                }).finally(function () { vm.emProgresso = false });
        }

        function abrirDialogDashboard() {
            vm.emProgresso = true;

            RequisicaoGenericaService.salvar(Api.custo_software.analiseCusto.listarDetalhamentoAno, vm.filtros)
                .then(function (sucess) {
                    $mdDialog
                        .show({
                            controller: "DialogAnaliseCustoDashboardController",
                            controllerAs: "vm",
                            templateUrl: 'app/main/gerenciamento-custo/processamento/analise-custo/views/dialogs/analise-custo-dashboard-dialog/analise-custo-dashboard-dialog.html',
                            multiple: true,
                            targetEvent: null,
                            clickOutsideToClose: false,
                            locals: {
                                Dados: sucess.data
                            }
                        });
                }, function (error) {
                    MdDialogService.alertPadrao(error.data);
                }).finally(function () { vm.emProgresso = false });
        }

        function selectChangeSquad(squadCodigoSelecionada) {
            vm.projetos = [];
            _listarProjetosGerenciarCustos(squadCodigoSelecionada);

            vm.solucoes = [];
            _listarSolucoesVinculadas()
        }

        function selectChangeCliente(codigoClienteSelecionado) {
            vm.solucoes = [];
            _listarSolucoesVinculadas();
        }

        function _listarSolucoesVinculadas() {
            var url = Api.solucao_rotinas_tarefas.solucao.listarPorSquadClientes;
            var entidadeEnvio = {
                clienteCodigo: vm.clientes,
                squadCodigo: vm.squadCodigo,
            }

            RequisicaoGenericaService.listarComParams(url, entidadeEnvio)
                .then(function (success) {
                    vm.todasSolucoes = success.data;
                })
                .catch(function (error) {
                    vm.todasSolucoes = [];
                })
        }

        function _listarProjetosGerenciarCustos(squadCodigo) {
            var url = Api.estoria.ListarCustosSoftwarePorSquad;
            RequisicaoGenericaService.listarComParams(url + squadCodigo)
                .then(function (success) {
                    vm.todosProjetos = success.data;
                })
                .catch(function (error) {
                    vm.todosProjetos = [];
                });
        }

        function abrirDialogConclusao() {
            vm.emProgresso = true;

            var viewModel = {
                projetos: vm.filtros.projetos,
                squadCodigo: vm.filtros.squadCodigo
            };

            RequisicaoGenericaService.salvar(Api.custo_software.analiseCusto.listarTotalizadoresPorProjeto, viewModel)
                .then(function (success) {
                    $mdDialog
                        .show({
                            controller: "DialogAnaliseCustoConclusaoController",
                            controllerAs: "vm",
                            templateUrl: 'app/main/gerenciamento-custo/processamento/analise-custo/views/dialogs/analise-custo-conclusao-dialog/analise-custo-conclusao-dialog.html',
                            multiple: true,
                            targetEvent: null,
                            clickOutsideToClose: false,
                            locals: {
                                Dados: success.data
                            }
                        });
                }, function (error) {
                    MdDialogService.alertPadrao(error.data);
                }).finally(function () { vm.emProgresso = false; });
        }


    }


})();
(function () {
    'use strict';

    angular
        .module('app.custosoftware.cadastro.custo', [])
        .config(config);

    function config($stateProvider, RotasHtml) {

        var rotasHtml = RotasHtml.custoSoftware.cadastro.custo;

        $stateProvider
            .state('app.custo_software', {
                url: '/custo-software/cadastro/custo',
                module: 'privado',
                views: {
                    'content@app': {
                        templateUrl: rotasHtml.templateUrl,
                        controller: "CustoController as vm"
                    },
                    'custo_software-form@app.custo_software': {
                        templateUrl: rotasHtml.form
                    },
                    'custo_software-tabela@app.custo_software': {
                        templateUrl: rotasHtml.tabela
                    }
                },
                resolve:{
                    ListarUsuarioPorDetalhe: function (Api, RequisicaoGenericaService, LoginUsuarioService) {
                        return RequisicaoGenericaService.listarSemParams(Api.usuario.detalhes_usuario.listarDetalhesUsuario
                            + LoginUsuarioService.usuarioArmazenado().codigo);
                    },
                }
            })
    }
})();



(function () {
    'use strict';

    angular.module('app.custosoftware.cadastro.custo')
        .controller('CustoController', CustoController);

    function CustoController(
        $scope,
        Api,
        CustoSoftwareService,
        DatatableFactory,
        ListarUsuarioPorDetalhe,
        NavegacaoService,
        SquadService,
        RequisicaoGenericaService
    ) {
        var vm = this;

        NavegacaoService.setTituloAba('Custo por projeto');
        vm.squadUsuarioLogado = ListarUsuarioPorDetalhe.data.codigoSquads;
        vm.squads = SquadService.listarSquadsUsuarioLogado(vm.squadUsuarioLogado);
        _listaTodosHistoricosCustos(vm.squadUsuarioLogado);

        vm.metodos = {
            configurarSelect: configurarSelect,
            pesquisar: pesquisar,
            selecionar: selecionar,
            salvar: salvar,
            editar: editar,
            excluir: excluir,
            construirDtOptions: construirDtOptions,
            preparaDataParaString: preparaDataParaString,
            selectChangeSquads: selectChangeSquads,
            predefinirCamposParaInsercao: predefinirCamposParaInsercao
        }

        init();

        //#region watchs
        $scope.$watch('vm.custo', function () {
            if (vm.custo && !vm.custo.custo)
                vm.custo.custo = 0;
        })
        //#endregion watchs

        //#region METODOS

        function init() {

        }

        function pesquisar() {
            if (vm.squadUsuarioLogado === 1) vm.entidadeDeEnvio.clsEntidade.squadCodigo = vm.squadUsuarioLogado[0];
            if (!vm.entidadeDeEnvio.clsEntidade.squadCodigo) {
                vm.entidadeDeEnvio.clsEntidade.squadCodigo = vm.squadUsuarioLogado;
            }
            return CustoSoftwareService.pesquisar(vm.entidadeDeEnvio);
        }

        function salvar(modelo) {
            modelo.squadCodigo = SquadService.setarValorSquad(vm.custo.squadCodigo, vm.squadUsuarioLogado);
            return CustoSoftwareService.salvar(modelo);
        }

        function editar(modelo) {
            modelo.squadCodigo = SquadService.setarValorSquad(vm.custo.squadCodigo, vm.squadUsuarioLogado);
            return CustoSoftwareService.editar(modelo);
        }

        function excluir(modelo) {
            return CustoSoftwareService.excluir(modelo);
        }

        function predefinirCamposParaInsercao() {
            vm.custo = {};
            _listaTodosHistoricosCustos(vm.squadUsuarioLogado);
        }

        function preparaDataParaString(data) {
            return new Date(data).toLocaleDateString();
        }

        function configurarSelect() {
            vm.termoProcurado = "";
            angular.element('#select').on('keydown', function (ev) {
                ev.stopPropagation();
            });
        }

        function selecionar(posicaoEntidade) {
            vm.metodosExternosPgToolbar.metodoControladorExternoListarTodasEntidades(null, posicaoEntidade);
        }

        function construirDtOptions() {
            DatatableFactory.construirDtOptionsComPaginacaoProcessadoNoServidorParaToolbar
                (Api.custo_software.custo.listarcompaginacaodatatable, vm.entidadeDeEnvio.clsEntidade, '#datatable-conclusao-atendimento',
                    [
                        DatatableFactory.construirColunaDeSelecionarPadrao(function (indexLinha) { vm.metodos.selecionar(indexLinha) }),
                        {
                            targets: 1,
                            name: "Descricao",
                            data: "descricao"
                        },
                        {
                            targets: 2,
                            name: "Custo",
                            data: "custo"
                        },
                        {
                            targets: 3,
                            name: "Prazo",
                            data: "prazo"
                        }

                    ]);
        }

        //#endregion METODOS

        function selectChangeSquads(squadCodigos) {
            vm.custo.historicoCusto = null;
            _listaTodosHistoricosCustos(squadCodigos);
        }

        function _listaTodosHistoricosCustos(squadCodigo) {
            var url = Api.custo_software.historico.listar;
            var model = { squadCodigo: squadCodigo.length == 0 ? vm.squadUsuarioLogado : squadCodigo };

            RequisicaoGenericaService.listarComParams(url, model).then(
                function (success) {
                    vm.listaHistoricoCusto = success.data;
                }
            );
        }
    }
})();
/**
 * Created by nova on 11/08/2016.
 */
(function () {
    'use strict';

    angular
        .module('app.geral.relatorio.cliente')
        .controller('RelatorioControleHorasController', RelatorioControleHorasController);

    function RelatorioControleHorasController(urlApi, NavegacaoService, $scope, $translate, Api, RelatorioControleHorasService, RequisicaoGenericaService, MdDialogService, $window) {
        var vm = this;
        NavegacaoService.setTituloAba('Relatório de controle de horas');

        vm.metodos = {
            gerarRelatorio: gerarRelatorio,
            configuraMdSelect: configuraMdSelect
        };

        init();

        //#region watch
        $scope.$watch('vm.filtros.mes', function (current, old) {
            if (vm.filtros.mes) {
                if (angular.equals(undefined, vm.filtros.ano) || angular.equals(null, vm.filtros.ano) || angular.equals(0, vm.filtros.ano))
                    vm.filtros.ano = new Date().getFullYear();
                vm.rota = Api.geral.relatorio_controle_horas.listaColaboradoresComHorasNoMes + '/' + vm.filtros.mes.codigo + '/' + vm.filtros.ano;
                _carrregaColaboradores();
            } else {
                vm.filtros.mes = vm.meses[0];
            }
        });

        $scope.$watch('vm.filtros.ano', function (current, old) {
            if (current) {
                if (current >= 2000) {
                    if (angular.equals(undefined, vm.filtros.mes) || angular.equals(null, vm.filtros.mes))
                        vm.filtros.mes = { codigo: 0 };
                    vm.rota = Api.geral.relatorio_controle_horas.listaColaboradoresComHorasNoMes + '/' + vm.filtros.mes.codigo + '/' + current;
                    _carrregaColaboradores();
                }
            } else {
                vm.filtros.ano = 0;
            }
        });
        //#endregion watch

        function init() {
            vm.filtros = {};
            vm.mensagemPreloader = "";
            vm.requisicaoSolicitada = false;
            vm.rota = Api.geral.relatorio_controle_horas.listaColaboradoresComHorasNoMes + '/0/' + new Date().getFullYear();
            vm.translateTitulosSteps = translateTitulosSteps();
            vm.dadosUsuario = {};
            vm.meses = RelatorioControleHorasService.listaMes();
            _carrregaColaboradores();

        }

        function _carrregaColaboradores() {
            vm.limparUsuarios = false;
            vm.requisicaoSolicitada = true;
            vm.mensagemPreloader = "Carregando Colaboradores...";
            RequisicaoGenericaService.listarSemParams(vm.rota)
                .then(function (success) {
                    vm.limparUsuarios = true;
                    vm.requisicaoSolicitada = false;
                    vm.todosColaboradores = success.data.map(function (dados) {
                        vm.mensagemPreloader = "";
                        return dados.usuario
                    }, function (err) {
                        vm.mensagemPreloader = "";
                        vm.requisicaoSolicitada = false;
                    });
                });
        }

        function translateTitulosSteps() {
            return {
                informacoesGerais: $translate.instant('Informações Gerais')
            }
        }

        function configuraMdSelect() {
            vm.filtrarMes = "";
            angular.element('#md-select-mes').on('keydown', function (ev) {
                ev.stopPropagation();
            });
        }

        function gerarRelatorio(item) {
            var filtro = RelatorioControleHorasService.preparaFiltroParaEnvio(item);
            vm.requisicaoSolicitada = true;
            vm.mensagemPreloader = "Gerando relatório ..."

            RequisicaoGenericaService.salvar(Api.geral.relatorio_controle_horas.relatorio, filtro).then(
                function (success) {
                    vm.requisicaoSolicitada = false;
                    vm.mensagemPreloader = "";
                    $window.open(urlApi.url_base_api + Api.relatorio.abrirRelatorio + success.data);
                },
                function (error) {
                    vm.requisicaoSolicitada = false;
                    vm.mensagemPreloader = "";
                    MdDialogService.alertPadrao(error.data);
                });
        }


    }
})();

(function () {
    'use strict';

    angular
        .module('app.geral.indicadores.gestaoiaguas')
        .controller('GestaoIAguasController', GestaoIAguasController);

    function GestaoIAguasController(
        $rootScope,
        $mdSidenav,
        $mdDialog,
        GestaoIAguasService,
        MdDialogService,
        NavegacaoService,
        Api,
        RequisicaoGenericaService,
        DatatableFactory,
        RotasHtml
    ) {
        var vm = this;

        NavegacaoService.setTituloAba("Gestão IÁguas");

        vm.metodos = {
            abrirFiltro: abrirFiltro,
            calcularTotal: calcularTotal,
            abrirDialogInformativo: abrirDialogInformativo,
            calcularPorcentagem: calcularPorcentagem,
            calcularPorcentagemTotal: calcularPorcentagemTotal
        }

        vm.rotasHtml = RotasHtml.indicadores.gestaoIAguas;
        vm.dados = [];
        vm.filtro = {};
        vm.dtOptions = DatatableFactory.construirDtOptionsResponsivoSemPaginacaoPadraoComPesquisaHeaderPadrao([
            {
                targets: [0, 3, 6, 8],
                orderable: false
            },
            {
                targets: [3, 6, 8],
                width: "5%"
            },
        ]);

        vm.dtOptions.order = [];

        $(document).ready(function () {
            setTimeout(function () {
                abrirFiltro();
            }, 700);

            $('#gestao-iaguas').on('click', function (event) {
                if (!vm.dados.length) {
                    $mdSidenav('filtro-gestao-iaguas').open();
                }
            });
            $('.sidenav').on('click', function (event) {
                event.stopPropagation();
            });
        });

        init();

        function init() {
            $rootScope.utilizaBotaoScroll = true;
            $rootScope.scrollButtonContainerLocal = "md-content#content";

            GestaoIAguasService.listener = function (callback) {
                vm.emProgresso = true;
                vm.filtro = callback();

                RequisicaoGenericaService.salvar(Api.indicadores.gestaoIAguas.retornarDados, vm.filtro)
                    .then(function (success) {
                        vm.dados = success.data;
                    }, function (error) {
                        MdDialogService.alertPadrao(error.data);
                        vm.dados = [];
                        abrirFiltro();
                    }).finally(function () {
                        vm.emProgresso = false;
                    });
            };
        }

        function abrirFiltro() {
            GestaoIAguasService.toggleFiltro();
        }

        function abrirDialogInformativo() {
            $mdDialog.show({
                controller: "InformativoGestaoIAguasDialogController",
                controllerAs: "vm",
                templateUrl: vm.rotasHtml.dialogs.informativo,
                targetEvent: event,
                clickOutsideToClose: false
            });
        }

        function calcularTotal(propriedade) {
            return vm.dados.reduce(function (total, item) {
                var valor = item[propriedade] || 0;
                return total + valor;
            }, 0);
        }

        function calcularPorcentagem(totalEnviado, valorEnviado) {
            var total = totalEnviado || 0;
            var valor = valorEnviado || 0;

            if (total === 0) {
                return 0;
            }

            var porcentagem = ((valor / total) * 100).toFixed(2);
            return porcentagem.replace('.', ',')
        }

        function calcularPorcentagemTotal(propriedadeTotal, propriedadeCalculo) {
            var total = calcularTotal(propriedadeTotal);
            var valorAhCalcular = calcularTotal(propriedadeCalculo);

            return calcularPorcentagem(total, valorAhCalcular);
        }
    }
})();

/**
 * Created by nova on 11/08/2016.
 */
(function () {
    'use strict';

    angular
        .module('app.geral.relatorio.cliente')
        .controller('RelatorioClienteController', RelatorioClienteController);

    function RelatorioClienteController(RelatorioClienteFactory, NavegacaoService, RelatorioClienteService, urlApi, Api, RequisicaoGenericaService, MdDialogService, $window) {
        var vm = this;
        NavegacaoService.setTituloAba('Relatório de clientes');

        vm.metodos = {
            gerarRelatorio: gerarRelatorio
        };

        init();


        function init() {
            vm.form = RelatorioClienteFactory.form;
            vm.filtrosClientes = RelatorioClienteFactory.filtrosClientes;
            vm.translateTitulosSteps = RelatorioClienteFactory.definirTransleteTitulosSteps();
            //vm.rotasHtml = RotasHtml.relatorioContratos;
            //vm.rota = Api.contrato.relatorio_contrato;
            vm.requisicaoSolicitada = false;
            vm.mensagemPreloader = "Carregando relatório...";
            vm.ordenacao = ["Nome", "Cidade"]

        }




        function gerarRelatorio(item) {
            var filtro = RelatorioClienteService.preparaFiltroParaEnvio(item);

            vm.requisicaoSolicitada = true;
            vm.mensagemPreloader = "Gerando relatório ..."

            RequisicaoGenericaService.salvar(Api.geral.relatorio_cliente, filtro).then(
                function (success) {
                    vm.requisicaoSolicitada = false;
                    vm.mensagemPreloader = "";
                    $window.open(urlApi.url_base_api + Api.relatorio.abrirRelatorio + success.data);
                },
                function (error) {
                    vm.requisicaoSolicitada = false;
                    vm.mensagemPreloader = "";
                    MdDialogService.alertPadrao(error.data);
                });
        }

    }



})();

/**
 * Created by nova on 27/09/2016.
 */
(function () {
    'use strict';

    angular
        .module('app.geral.processamento.controle-horas-trabalhadas', [
            'app.geral.processamento.controle-horas-trabalhadas.tab-historico-viagem'])
        .config(config);

    function config($stateProvider, RotasHtml) {
        var rotasHtml = RotasHtml;
        $stateProvider
            .state('app.geral_processamento_controle_horas_trabalhadas', {
                url: '/geral/processamento/controle-horas-trabalhadas',
                module: 'privado',

                views: {
                    'content@app': {
                        templateUrl: rotasHtml.controleHorasTrabalhadas.templateUrl,
                        controller: "ControleHorasTrabalhadasController as vm"
                    },

                    'controle-horas-form@app.geral_processamento_controle_horas_trabalhadas': {
                        templateUrl: rotasHtml.controleHorasTrabalhadas.form
                        
                    },
                    'controle-horas-tabela@app.geral_processamento_controle_horas_trabalhadas': {
                        templateUrl: rotasHtml.controleHorasTrabalhadas.tabela
                    },
                    'aba-geral@app.geral_processamento_controle_horas_trabalhadas': {
                        templateUrl: rotasHtml.controleHorasTrabalhadas.tabs.geral
                    }

                    , 'aba-historico-viagem@app.geral_processamento_controle_horas_trabalhadas': {
                        templateUrl: rotasHtml.controleHorasTrabalhadas.tabs.historicoViagem.form,
                        controller: 'TabHistoricoViagemController as vm'
                    }

                }

            });
    }

})();

/**
 * Created by nova on 19/07/2016.
 */
(function () {
    'use strict';

    angular.module('app.geral.processamento.controle-horas-trabalhadas')
        .controller('ControleHorasTrabalhadasController', ControleHorasTrabalhadasController);

    function ControleHorasTrabalhadasController(ControleHorasFactory, NavegacaoService, $filter, DatatableFactory, MdDialogService, $scope, MdToastService, PgToolbarFactory, RequisicaoGenericaService, Api) {
        var vm = this;
        vm.historico = {};
        var entidadeOriginal = {};
        NavegacaoService.setTituloAba('Controle de horas trabalhadas');

        vm.controleForm = {
            emProgresso: false
        };

        init();

        function init() {
            _carregaColaboradores();
            ControleHorasFactory.controleForm = vm.controleForm;
        }

        vm.metodos = {
            pesquisar: pesquisar,
            salvar: salvar,
            excluir: excluir,
            obrigarInformarCampo: obrigarInformarCampo,
            configuraMdSelectTecnico: configuraMdSelectTecnico,
            construirDtOptions: construirDtOptions,
            selecionar: selecionar
        }

        vm.metodosGeral = {
            desativaAbaViagem: desativaAbaViagem,
            tabSelecionada: tabSelecionada,
            desabilitarNovasPesquisas: desabilitarNovasPesquisas,
            predefinirCamposParaInserir: predefinirCamposParaInserir,
            desabilitaBotaoEditar: desabilitaBotaoEditar,
            predefinirCamposParaEdicao: predefinirCamposParaEdicao,
            desabilitaBotaoInserir: desabilitaBotaoInserir

        };


        //#region watch
        $scope.$watch('vm.historico', function (newValue, oldValue) {
            if (newValue)
                ControleHorasFactory.historico(newValue);

            if (vm.historico && vm.historico.dataInicial)
                vm.historico.dataInicial = new Date(vm.historico.dataInicial);

            if (vm.historico && vm.historico.dataFinal)
                vm.historico.dataFinal = new Date(vm.historico.dataFinal);
        });

        //#endregion watch


        //#region metodos

        function obrigarInformarCampo() {
            if (!vm.controleForm)
                return false;

            if (vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo)
                return true;

            return false;
        }

        function salvar() {

            vm.controleForm.emProgresso = true;

            var modelo = _preaparaEntidadeParaEnvio(vm.historico);

            if (vm.controleForm.editarAtivo)
                return RequisicaoGenericaService.editar(Api.contole_horas.editar, modelo);

            return RequisicaoGenericaService.salvar(Api.contole_horas.criar, modelo);

        }

        function excluir() {
            if (!vm.historico)
                return;
            if (!vm.historico.codigo)
                return;

            return RequisicaoGenericaService.excluir(Api.contole_horas.excluir, vm.historico.codigo);
        }


        function pesquisar() {
            if (!vm.entidadeDeEnvio)
                vm.entidadeDeEnvio = PgToolbarFactory.construirEntidadeDeEnvioPadrao(_preparaEntidadeParaListagem(vm.historico));


            if (vm.filtrarTecnicos)
                vm.filtrarTecnicos = "";


            return RequisicaoGenericaService.listarComObjetoComplexo(Api.contole_horas.listarComPaginacao, vm.entidadeDeEnvio);

        }


        function _preparaEntidadeParaListagem(historico) {
            return {
                dataInicial: historico.dataInicial,
                dataFinal: historico.dataFinal,
                colaboradores: historico.colaboradoresSelecionados
            }
        }


        function _preaparaEntidadeParaEnvio(historico) {
            if (!historico.colaboradores)
                historico.colaboradores = [];

            var entidade = {
                dataInicial: historico.dataInicial,
                dataFinal: historico.dataFinal,
                colaboradores: historico.colaboradores
            }

            if (vm.controleForm.editarAtivo)
                entidade.codigo = historico.codigo;

            return entidade;
        }


        function _limpaFormulario() {
            vm.form.$setDirty();
            vm.form.$setPristine();
            vm.form.$setUntouched();
        }


        function _carregaColaboradores() {

            RequisicaoGenericaService.listarSemParams(Api.usuario.detalhes_usuario.listarUsuariosAtivos).then(
                function (success) {
                    vm.listaColaboradores = success.data;
                }, function (error) {
                    MdDialogService.alertPadrao(error.data, null);
                });
        }

        //#endregion metodos

        //#region metodosGeral

        function desativaAbaViagem() {

            return vm.controleForm.emProgresso ||
                (angular.equals({}, vm.historico, {}) || angular.equals(undefined, vm.historico)
                    || vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo);
        }

        function tabSelecionada(abaSelecionada) {
            vm.tabSelecionada = abaSelecionada;

            if (abaSelecionada == 'historicoViagem')
                vm.controleForm.editarAtivo = false;

        }

        function desabilitarNovasPesquisas() {

            if (vm.tabSelecionada == 'historicoViagem')
                return true;

            if (!vm.historico)
                return true;

            return false;
        }

        function configuraMdSelectTecnico() {
            vm.filtrarTecnicos = "";
            angular.element('#md-select-tecnico').on('keydown', function (ev) {
                ev.stopPropagation();
            });
        }

        function selecionar(posicaoEntidade) {
            vm.metodosExternosPgToolbar.metodoControladorExternoListarTodasEntidades(null, posicaoEntidade);
        }

        function construirDtOptions() {
            DatatableFactory.construirDtOptionsComPaginacaoProcessadoNoServidorParaToolbar
                (Api.contole_horas.listarComPaginacaoDatatable, vm.entidadeDeEnvio.clsEntidade, '#datatable-controle-horas',
                [

                    DatatableFactory.construirColunaDeSelecionarPadrao(function (indexLinha) { vm.metodos.selecionar(indexLinha) })
                    ,
                    {
                        targets: 1,
                        name: "DataInicial",
                        data: "dataInicial",
                        defaultContent: "",
                        render: function (data) {
                            return $filter('date')(data, 'dd/MM/yyyy')
                        },
                        sortable: false
                    },
                    {
                        targets: 2,
                        name: "DataFinal",
                        data: "dataFinal",
                        defaultContent: "",
                        render: function (data) {
                            return $filter('date')(data, 'dd/MM/yyyy')
                        },
                        sortable: false
                    },
                    {
                        targets: 3,
                        name: "Colaboradores",
                        data: "colaboradores",
                        defaultContent: "",
                        render: function (data) {
                            var colaboradores = '';
                            var totalizador = 0;
                            data.forEach(function (colaborador) {
                                if ((totalizador + 1) >= data.length || data.length <= 0)
                                    colaboradores += colaborador.usuario.nome;
                                else
                                    colaboradores += colaborador.usuario.nome + ", ";
                                totalizador++;
                            });
                            return colaboradores;
                        },
                        sortable: false
                    }
                ]);

        }

        function desabilitaBotaoInserir() {
            if (vm.tabSelecionada == 'historicoViagem')
                return true;
            return false;
        }

        function predefinirCamposParaEdicao() {
            vm.form.$setDirty();

            if (!vm.historico)
                return;

            entidadeOriginal = vm.historico;

        }

        function desabilitaBotaoEditar() {

            if (vm.tabSelecionada == 'historicoViagem')
                return true;

            if (!vm.controleForm)
                return false;

            if (vm.historico)
                return false;

            if (vm.controleForm.editarAtivo)
                return true;

            return false;

        }

        function predefinirCamposParaInserir() {
            if (vm.historico)
                vm.historico = null;
        }
        //#endregion metodosGeral



    } //CONTROLLER
})();

(function () {
    'use strict';

    angular
        .module('app.geral.consulta.log', [])
        .config(Config);

    function Config($stateProvider, RotasHtml) {
        var rotasHtmlLog = RotasHtml.log;
        $stateProvider
            .state('app.geral_consulta_log', {
                url: '/geral/consulta/log',
                module: 'privado_gerencia',
                views: {
                    'content@app': {
                        templateUrl: rotasHtmlLog.templateUrl,
                        controller: 'ConsultaLogController as vm'
                    }
                },
                resolve: {
                    ListarTodasEntidades: function (Api, RequisicaoGenericaService) {
                        return RequisicaoGenericaService.listarSemParams(Api.consultas.log.listarTodasEntidades);
                    },
                    ListarTodosUsuarios: function (Api, RequisicaoGenericaService) {
                        return RequisicaoGenericaService.listarSemParams(Api.usuario.listarCodigoDescricao);
                    }
                }
            });
    }

})();

//ng-class="{'vermelho': estoria.diasRestantes <= 0,
//'amarelo': estoria.diasRestantes <= 7 && estoria.diasRestantes < 0}"
(function () {
    'use strict';

    angular
        .module('app.geral.consulta.log')
        .controller('ConsultaLogController', ConsultaLogController);

    function ConsultaLogController(Api, RequisicaoGenericaService, ListarTodosUsuarios,
        MdDialogService, ListarTodasEntidades, NavegacaoService, RotasHtml) {
        var vm = this;
        NavegacaoService.setTituloAba('Consulta log');

        // Data region
        vm.rotasHtml = RotasHtml.log;
        vm.form = {};
        vm.logs = [];
        vm.pesquisaAtiva = false;
        vm.requisicaoSolicitada = false;
        vm.log = {
            data: new Date()
        }

        vm.usuarios = ListarTodosUsuarios.data;
        vm.entidades = ListarTodasEntidades.data;
        //endregion

        // Configurações Datatable region
        vm.dtOptionsLog = {
            dom: 'rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
            initComplete: function () {
                var api = this.api(),
                    searchBox = angular.element('body').find('#pesquisar');
                // Bind an external input as a table wide search box
                if (searchBox.length > 0) {
                    searchBox.on('keyup', function (event) {
                        api.search(event.target.value).draw();
                    });
                }
            },
            scrollY: 'auto',
            pagingType: 'numbers',
            lengthMenu: [100],
            pageLength: 100,
            responsive: true,
            order: []
        };
        //endregion

        // Definição dos Métodos region
        vm.metodosLog = {
            pesquisar: pesquisar,
            novaConsulta: novaConsulta,
            configuraMdSelectUsuarioLog: configuraMdSelectUsuarioLog,
            configuraMdSelectEntidadeLog: configuraMdSelectEntidadeLog
        }
        //endregion

        // Implementação dos Métodos region

        // Métodos Geral region

        /**
         * Método para pesquisar uma lista de logs
         * @param {log} log 
         * @param {event} event  event do Botao
         */
        function pesquisar(log, event) {
            vm.requisicaoSolicitada = true
            RequisicaoGenericaService.listarComParams(Api.consultas.log.listarPor, log).then(
                function (success) {
                    vm.logs = success.data;
                    console.log(vm.logs);

                    vm.pesquisaAtiva = true;
                    vm.requisicaoSolicitada = false;
                },
                function (error) {
                    MdDialogService.alertPadrao(error.data, event);
                    vm.requisicaoSolicitada = false;
                });
        }

        /**
         * Método para limpar todos os campos e realizar uma nova consulta de log
         */
        function novaConsulta() {
            vm.pesquisar = "";
            vm.logs = [];
            vm.log = {};
            vm.pesquisaAtiva = false;
        }

        /**
         * Método para configurar o md-select de Usuario e limpar o campo de pesquisa do md-select-header quando 
         * o componente md-select do Usuário é aberto
         */
        function configuraMdSelectUsuarioLog() {
            vm.filtrarUsuarioLog = "";
            angular.element('#consultas-log-md-select-usuario').on('keydown', function (ev) {
                ev.stopPropagation();
            });
        }

        /**
       * Método para configurar o md-select de EntidadeLog e limpar o campo de pesquisa do md-select-header quando 
       * o componente md-select da ntidadeLog é aberto
       */
        function configuraMdSelectEntidadeLog() {
            vm.filtrarEntidadeLog = "";
            angular.element('#consultas-log-md-select-entidade').on('keydown', function (ev) {
                ev.stopPropagation();
            });
        }
        //endregion

        //endregion
    }

})();

//<!-- Ultima mudança 19/07/2017.-->
(function () {
    'use strict';

    angular
        .module('app.geral.cadastro.segmentacao', [])
        .config(config);

    function config($stateProvider, RotasHtml) {
        var rotasHtml = RotasHtml.segmentacao;
        $stateProvider
            .state('app.geral_cadastro_segmentacao', {
                url: '/geral/cadastro/segmentacao',
                module: 'privado',
                views: {
                    'content@app': {
                        templateUrl: rotasHtml.templateUrl,
                        controller: 'SegmentacaoController as vm'
                    },
                    'segmentacao-form@app.geral_cadastro_segmentacao': {
                        templateUrl: rotasHtml.form
                    },
                    'segmentacoes-tabela@app.geral_cadastro_segmentacao': {
                        templateUrl: rotasHtml.tabela
                    }
                }
            });
    }

})();

//<!-- Ultima mudança 19/07/2017.-->
(function () {
    'use strict';

    angular.module('app.geral.cadastro.segmentacao')
        .controller('SegmentacaoController', SegmentacaoController);

    function SegmentacaoController(Api, NavegacaoService, RequisicaoGenericaService, DatatableFactory) {
        var vm = this;
        NavegacaoService.setTituloAba('Segmentação');

        // Data region            

        _init();
        // endregion    


        // Definição dos Métodos region
        vm.metodos = {
            pesquisar: pesquisar,
            salvar: salvar,
            editar: editar,
            excluir: excluir,
            selecionar: selecionar,
            construirDtOptions: construirDtOptions
        }
        //endregion

        // Implementação dos Métodos region

        function _init(){
            vm.form = {};
            vm.rotaProximoCodigo = Api.segmentacao.retornaProximoCodigo;

            DatatableFactory.setConverterEntidadePesquisaParaJson(true);
        }

        function pesquisar() {
            return RequisicaoGenericaService.listarPorPaginacaoJsonFormato(Api.segmentacao.listarComPaginacao, vm.entidadeDeEnvio);
        }

        function salvar(modelo) {
            return RequisicaoGenericaService.salvar(Api.segmentacao.criar, modelo);
        }

        function editar(modelo) {
            return RequisicaoGenericaService.editar(Api.segmentacao.atualizar, modelo)
        }

        function excluir(modelo) {
            return RequisicaoGenericaService.excluir(Api.segmentacao.excluir, modelo.codigo)
        }

        function selecionar(posicaoEntidade) {
            vm.metodosExternosPgToolbar.metodoControladorExternoListarTodasEntidades(null, posicaoEntidade);
        }

        function construirDtOptions() {
            DatatableFactory.construirDtOptionsComPaginacaoProcessadoNoServidorParaToolbar
                (Api.segmentacao.listarComPaginacaoDatatable, vm.entidadeDeEnvio.clsEntidade, '#datatable-seguimentacao',
                [

                    DatatableFactory.construirColunaDeSelecionarPadrao(function (indexLinha) { vm.metodos.selecionar(indexLinha) }),
                    {
                        targets: 1,
                        name: "Codigo",
                        data: "codigo",
                        defaultContent: ""
                    },
                    {
                        targets: 2,
                        name: "Descricao",
                        data: "descricao",
                        defaultContent: ""
                    }
                ]);
        }
        //endregion

    }
})();

//<!-- Ultima mudança 28/03/2017.-->
(function () {
    'use strict';

    angular
        .module('app.geral.cadastro.caracteristica', [])
        .config(config);

    function config($stateProvider, RotasHtml) {
        var rotasHtml = RotasHtml.caracteristica;
        $stateProvider
            .state('app.geral_cadastro_caracteristica', {
                url: '/geral/cadastro/caracteristica',
                module: 'privado',
                views: {
                    'content@app': {
                        templateUrl: rotasHtml.templateUrl,
                        controller: 'CaracteristicaController as vm'
                    },
                    'caracteristica-form@app.geral_cadastro_caracteristica': {
                        templateUrl: rotasHtml.form
                    },
                    'caracteristicas-tabela@app.geral_cadastro_caracteristica': {
                        templateUrl: rotasHtml.tabela
                    }
                }
            });
    }

})();

//<!-- Ultima mudança 28/03/2017.-->
(function () {
    'use strict';

    angular.module('app.geral.cadastro.caracteristica')
        .controller('CaracteristicaController', CaracteristicaController);

    function CaracteristicaController(Api, NavegacaoService, RequisicaoGenericaService,
        DatatableFactory, RotasHtml,
        ServicosGenericoService,
        DataTableConfigPadrao,
        MdDialogService,
        MdToastService) {
        var vm = this;
        NavegacaoService.setTituloAba('Características');

        vm.cliente = null;

        // Data region    
        vm.form = {};
        vm.rota = Api.caracteristica.proximoCodigo;
        // endregion

        vm.htmlRota = RotasHtml.caracteristica;

        vm.tabSelecionada = "caracteristica";

        vm.controleAba = {
            controladorCaracteristica: false,
            controladorCliente: false
        }

        // Definição dos Métodos region
        vm.metodosGeral = {
            tabSelecionada: tabSelecionada
        }

        vm.metodos = {
            pesquisar: pesquisar,
            salvar: salvar,
            editar: editar,
            excluir: excluir,
            selecionar: selecionar,
            construirDtOptions: construirDtOptions,
            predefinirCamposInsercao: predefinirCamposInsercao
        }

        vm.metodosAbaCliente = {
            configuraAutoCompleteClienteOnBlur: configuraAutoCompleteClienteOnBlur,
            pesquisarAutoCompleteCliente: pesquisarAutoCompleteCliente,
            alterarItemSelecionadoAutoCompleteCliente: alterarItemSelecionadoAutoCompleteCliente,
            inserirCliente: inserirCliente,
            excluirCliente : excluirCliente
        }

        vm.metodosInternos = {
            verificarVinculoCliente: _verificarVinculoCliente,
            vincularClienteCaracteristica: _vincularClienteCaracteristica
        }

        vm.dtOptions = angular.copy(DataTableConfigPadrao.dtOptionsPadraoComPaginacaoEReponsivo);
        vm.dtOptions.columnDefs = [DataTableConfigPadrao.columnDefsPadrao];
        //endregion

        // Implementação dos Métodos region

        /**
         * Método que é chamado sempre quando ocorre uma transição de tab
         * @param {tab} tab 
         */
        function tabSelecionada(tab) {
            vm.tabSelecionada = tab;
            if (tab !== 'caracteristica') {
                if (angular.isDefined(vm.controleForm)) {
                    vm.controleForm.desabilitarButtonEditar = true;
                    vm.controleForm.desabilitarButtonInserir = true;
                    vm.controleForm.desabilitarButtonExcluir = true;
                    vm.controleForm.desabilitarButtonListarTodos = true;
                    vm.controleForm.desabilitarMetodoToolbarAtualizar = true;
                }
            } else {
                if (angular.isDefined(vm.controleForm)) {
                    vm.controleForm.desabilitarButtonEditar = false;
                    vm.controleForm.desabilitarButtonInserir = false;
                    vm.controleForm.desabilitarButtonExcluir = false;
                    vm.controleForm.desabilitarButtonListarTodos = false;
                    vm.controleForm.desabilitarMetodoToolbarAtualizar = false;
                }
            }
        }

        /**
         * Método para pesquisar os cargos
         */
        function pesquisar() {
            return RequisicaoGenericaService.listarComObjetoComplexo(Api.caracteristica.listarComPaginacao, vm.entidadeDeEnvio);
        }

        /**
         * Método para salvar uma nova caracteristica
         * @param {caracteristica} modelo
         */
        function salvar(modelo) {
            return RequisicaoGenericaService.salvar(Api.caracteristica.criar, modelo);
        }

        /**
         * Método para editar uma caracteristica
         * @param {caracteristica} modelo
         */
        function editar(modelo) {
            return RequisicaoGenericaService.editar(Api.caracteristica.atualizar, modelo)
        }

        /**
         * Método para excluir uma caracteristica
         * @param {caracteristica} modelo
         */
        function excluir(modelo) {
            return RequisicaoGenericaService.excluir(Api.caracteristica.excluir, modelo.codigo)
        }

        /**
         * Método utilizado no modo exibido tabela, para selecionar uma caracteristica
         * @param {caracteristica} modelo
         */
        function selecionar(posicaoEntidade) {
            vm.metodosExternosPgToolbar.metodoControladorExternoListarTodasEntidades(null, posicaoEntidade);
        }

        /**
         * Método para construi o DtOptions da tabela
         */
        function construirDtOptions() {
            DatatableFactory.construirDtOptionsComPaginacaoProcessadoNoServidorParaToolbar
                (Api.caracteristica.listarComPaginacaoDatatable, vm.entidadeDeEnvio.clsEntidade, '#datatable-cliente-caracteristica',
                [

                    DatatableFactory.construirColunaDeSelecionarPadrao(function (indexLinha) { vm.metodos.selecionar(indexLinha) }),
                    {
                        targets: 1,
                        name: "Codigo",
                        data: "codigo",
                        sortable: false
                    },
                    {
                        targets: 2,
                        name: "Descricao",
                        data: "descricao",
                        sortable: false
                    }
                ]);
        }
        //endregion

        /**
         * Método que limpa o texto de pesquisa do md-auto-complete do Cliente
         */
        function configuraAutoCompleteClienteOnBlur() {
            if (!vm.cliente) {
                vm.textoDePesquisaAutoCompleteCliente = "";
            }
        }

        /**
         * Método que realiza uma requisição para api para buscar os clientes em tempo de excução, * com base no que o usuário está digitando
         * @param {string} query 
         */
        function pesquisarAutoCompleteCliente(query) {
            return ServicosGenericoService.pesquisarAutoCompleteCodigoOuNomeGenericoApi(Api.cliente.listarCodigoDescricao, query);
        }

        /**
         * Método que controla qual cidade está selecionada no campo md-auto-complete do Cliente
         * @param {object} item 
         */
        function alterarItemSelecionadoAutoCompleteCliente(item) {
            if (item) {
                vm.cliente = item;
            } else {
                vm.cliente = null;
                vm.textoDePesquisaAutoCompleteCliente = "";
            }
        }

        function inserirCliente(cliente) {
            if (vm.caracteristica.clientes) {
                var clienteVinculado = _verificarVinculoCliente(cliente.codigo);
                if (clienteVinculado) {
                    MdDialogService.alertPadrao("Atenção", null,
                        "Já existe um cliente com esse código vinculado à Característica.");
                }
                else {
                    var modelo = {
                        codigoCliente: cliente.codigo,
                        codigoCaracteristica: vm.caracteristica.codigo
                    };
                    _vincularClienteCaracteristica(modelo);
                }
            }
            else{
                _vincularClienteCaracteristica(modelo);
            }
        }

        function excluirCliente(clienteCaracteristica){
            MdDialogService.confirmPadraoComEvento("Deseja realmente remover o vinculo deste cliente da característica?", null, event,
                function () {
                    vm.controleForm.emProgresso = true;
                    RequisicaoGenericaService.excluir(Api.cliente.excluirCaracteristicaCliente, vm.caracteristica.codigo + "/" + clienteCaracteristica.codigo).then(
                        function (success) {
                            MdToastService.toastPadrao("Vinculo removido com sucesso."); 
                            
                            vm.caracteristica.clientes = vm.caracteristica.clientes.filter(function (cliente) {
                                if (cliente.codigo != clienteCaracteristica.codigo) {
                                    return cliente;
                                }
                            });
                            vm.controleForm.emProgresso = false;
                        },
                        function (error) {               
                            vm.controleForm.emProgresso = false;             
                            MdDialogService.alertPadrao(error.data, event);
                        });
                });
        }

        function _verificarVinculoCliente(clienteCodigo) {
            var resultado = vm.caracteristica.clientes.filter(function (cliente) {
                if (cliente.codigo == clienteCodigo) {
                    return cliente;
                }
            });

            return resultado.length > 0;
        }

        function _vincularClienteCaracteristica(modelo) {
            vm.controleForm.emProgresso = true;
            RequisicaoGenericaService.salvar(Api.cliente.cadastrarCaracteristicaCliente, modelo).then(
                function (success) {
                    MdToastService.toastPadrao("Cliente vinculado com sucesso!");
                    vm.caracteristica.clientes.push(vm.cliente);
                    vm.cliente = null;
                    vm.controleForm.emProgresso = false;
                    //vm.caracteristicas.clientes = vm.caracteristicas.clientes.push(success.data[0]);
                },
                function (error) {
                    MdDialogService.alertPadrao(error.data);
                    vm.controleForm.emProgresso = false;
                });
        }

        function predefinirCamposInsercao(){
            vm.caracteristica = {
                tipo: 1
            };
        }

    }
})();

(function () {
    'use strict';

    angular
        .module('app.datamobil')
        .controller('MensagensRecebidasController', MensagensRecebidasController)
        .directive('mensagemRecebida', mensagemRecebida);

    function MensagensRecebidasController(DatamobilIaService, MdDialogService) {
        var vm = this;

        vm.respostaAvaliada = null;
        vm.baixandoRelatorio = false;
        vm.avaliando = { acao: null, carregando: false };

        vm.metodos = {
            avaliar: avaliar,
            download: download
        };

        function mostrarDialogErroServidor() {
            MdDialogService.alertPadrao(
                'Atenção!',
                null,
                'Não foi possível concluir sua solicitação no momento.<br><br>Tente novamente em alguns instantes.'
            );
        }

        function avaliar(avaliacao) {
            if (vm.avaliando.carregando) {
                return;
            }
            var novaAvaliacao = vm.respostaAvaliada === avaliacao ? null : avaliacao;

            vm.avaliando.acao = avaliacao;
            vm.avaliando.carregando = true;

            DatamobilIaService.avaliarResposta(vm.mensagem, novaAvaliacao)
                .then(function () {
                    vm.respostaAvaliada = novaAvaliacao;
                }).catch(function () {
                    mostrarDialogErroServidor();
                }).finally(function () {
                    vm.avaliando.carregando = false;
                    vm.avaliando.acao = null;
                });
        }

        function download() {
            vm.baixandoRelatorio = true;
            DatamobilIaService.gerarRelatorio(vm.mensagem.data)
                .then(function (response) {
                    DatamobilIaService.baixarArquivoXLSX(response, 'Datamobil_ia_relatorio.xlsx');
                }).catch(function () {
                    mostrarDialogErroServidor();
                }).finally(function () {
                    vm.baixandoRelatorio = false;
                });
        }
    }

    function mensagemRecebida() {
        return {
            restrict: 'E',
            scope: {
                mensagem: '='
            },
            templateUrl: 'app/main/datamobil-ia/components/mensagens-recebidas/mensagens-recebidas.html',
            controller: 'MensagensRecebidasController',
            controllerAs: 'vm',
            bindToController: true
        };
    }
})();
(function () {
    'use strict'

    angular
        .module('app.geral.brainstorming.visualizacaoIdeias')
        .controller('VisualizacaoIdeiasController', VisualizacaoIdeiasController);

    function VisualizacaoIdeiasController(
        Api,
        DataTableConfigPadrao,
        RequisicaoGenericaService,
        MdDialogService,
        $state,
        $mdDialog,
        RotasHtml
    ) {
        var vm = this;

        vm.ideias = {};
        vm.requisicaSolicitada = false;

        vm.htmlRota = RotasHtml.brainstorming.visualizacaoIdeias;

        vm.coresSituacoes = [
            { codigo: 1, descricao: 'Solicitada', cor: '#808080', selecionada: false },
            { codigo: 2, descricao: 'Análise', cor: '#33CCFF', selecionada: false },
            { codigo: 3, descricao: 'Processada', cor: '#FF0000', selecionada: false },
            { codigo: 4, descricao: 'Aprovada', cor: '#FFA500', selecionada: false },
            { codigo: 5, descricao: 'Executada', cor: '#008000', selecionada: false },
            { codigo: 6, descricao: 'Aguardando resposta', cor: '#800080', selecionada: false }
        ];
        vm.statusFiltrados = [];
        vm.dtInstance = {};
        vm.dtOptionsIdeias = DataTableConfigPadrao.dtOptionsResponsivoSemPaginacaoComInitComplete;
        vm.dtOptionsIdeias.columnDefs = [
            {
                targets: [0, 1, 2],
                orderable: false
            },
            {
                targets: 1,
                width: "5%"
            },
            {
                targets: 2,
                width: "5%"
            },
            {
                targets: 3,
                responsivePriority: 1,
                width: "70%"
            },
            {
                targets: 4,
                width: "15%"
            },
            {
                targets: 5,
                width: "5%"
            }
        ];

        vm.dtOptionsIdeias.order = [
            [4, "desc"]
        ];

        vm.metodosVisualizarIdeias = {
            retornaSituacao: retornaSituacao,
            retornaDescricaoStatus: retornaDescricaoStatus,
            exibirIdeia: exibirIdeia,
            filtrarPorStatus: filtrarPorStatus,
            desmarcarFiltros: desmarcarFiltros,
            abrirDialogEditarStatus: abrirDialogEditarStatus,
            retornarSubstringDescricao: retornarSubstringDescricao
        }

        init();

        function init() {
            vm.requisicaSolicitada = true;
            RequisicaoGenericaService.listarSemParams(Api.brainstorming.listarTodos)
                .then(
                    function (success) {
                        vm.requisicaSolicitada = false;
                        vm.ideias = success.data;

                        vm.ideias.forEach(function (ideia) {
                            ideia.descricaoStatus = retornaDescricaoStatus(ideia);
                        });
                    },
                    function (error) {
                        vm.requisicaSolicitada = false;
                        MdDialogService.alertPadrao(error.data);
                    }
                );
        }

        function exibirIdeia(event, ideia) {

            $state.goNewTab("app.geral_brainstorming_brainstorming", {
                parametros: {
                    numero: ideia.numero,
                    ano: ideia.ano,
                    chamarPesquisa: true
                }
            });
        }

        function retornaSituacao(ideia) {
            return ideia.respostas.length > 0 ? 'Sim' : 'Não';
        }

        function retornaDescricaoStatus(ideia) {
            var status = vm.coresSituacoes.filter(function (status) {
                return status.codigo == ideia.status;
            });
            return status[0].descricao;
        }

        function filtrarPorStatus(situacao) {
            situacao.selecionada = !situacao.selecionada;

            if (vm.statusFiltrados.some(function (item) {
                return item == situacao.codigo;
            })) {
                var indice = vm.statusFiltrados.indexOf(situacao.codigo);
                vm.statusFiltrados.splice(indice, 1);
            }
            else {
                vm.statusFiltrados.push(situacao.codigo);
            }
            vm.dtInstance.DataTable.column(0).search(vm.statusFiltrados.join('|'), true, false).draw();
        }

        function desmarcarFiltros() {
            vm.statusFiltrados = [];
            vm.coresSituacoes.forEach(function (situacao) {
                situacao.selecionada = false;
            });
            vm.dtInstance.DataTable.column(0).search("").draw();
        }

        function abrirDialogEditarStatus(ideia) {
            $mdDialog.show({
                controller: "VisualizacaoIdeiasStatusController",
                controllerAs: "vm",
                templateUrl: vm.htmlRota.dialogStatus,
                targetEvent: event,
                clickOutsideToClose: false,
                locals: {
                    Ideia: ideia,
                    Ideias: vm.ideias,
                    retornaDescricaoStatus: retornaDescricaoStatus
                }
            });
        }

        function retornarSubstringDescricao(descricao) {
            return descricao.length <= 250 ? descricao : descricao.substr(0, 250) + "...";
        }
    }
})();
(function () {
    'use strict'

    angular.module('app.geral.brainstorming.brainstorming')
        .controller('BrainstormingController', BrainstormingController);

    function BrainstormingController(
        Api,
        NavegacaoService,
        RotasHtml,
        LoginUsuarioService,
        ProximoCodigoService,
        MdDialogService,
        RequisicaoGenericaService,
        PgToolbarService,
        $mdDialog,
        DataTableConfigPadrao,
        ListarTodosUsuarios,
        $state,
        DatatableFactory
    ) {

        var vm = this;

        NavegacaoService.setTituloAba('Brainstorming');
        vm.tabSelecionada = "brainstorming";

        vm.htmlRota = RotasHtml.brainstorming.brainstorming;

        vm.usuarioLogado = LoginUsuarioService.usuarioArmazenado();

        vm.usuariosAtivos = ListarTodosUsuarios.data;

        vm.status = [
            { codigo: 1, descricao: "Solicitada" },
            { codigo: 2, descricao: "Análise" },
            { codigo: 3, descricao: "Processada" },
            { codigo: 4, descricao: "Aprovada" },
            { codigo: 5, descricao: "Executada" },
            { codigo: 6, descricao: "Aguardando resposta" }
        ];

        vm.dtOptionsRespostas = DataTableConfigPadrao.dtOptionsResponsivoSemPaginacao;

        vm.dtOptionsRespostas.columnDefs = [
            {
                targets: 0,
                width: "10%"
            },
            {
                targets: 1,
                responsivePriority: 1,
                width: "80%"
            },
            {
                targets: 2,
                width: "10%"
            }
        ];

        vm.dtOptionsRespostas.order = [
            [2, "desc"]
        ];

        vm.metodosGeral = {
            tabSelecionada: tabSelecionada,
            preDefinirCamposParaInserir: preDefinirCamposParaInserir,
            retornaUsuario: retornaUsuario,
            retornaIniciasNomeUsuario: retornaIniciasNomeUsuario
        };

        vm.metodosBrainstorming = {
            salvar: salvar,
            editar: editar,
            excluir: excluir,
            pesquisar: pesquisar,
            selecionar: selecionar,
            construirDtOptions: construirDtOptions
        }

        vm.metodosResposta = {
            abrirDialogInserirResposta: abrirDialogInserirResposta
        }

        function salvar(brainstorming) {
            return RequisicaoGenericaService.salvar(Api.brainstorming.criar, brainstorming);
        }

        function editar(brainstorming) {
            return RequisicaoGenericaService.editar(Api.brainstorming.atualizar, brainstorming);
        }

        function excluir(brainstorming) {
            return RequisicaoGenericaService.excluir(
                Api.brainstorming.excluir,
                brainstorming.numero + '/' + brainstorming.ano
            );
        }

        function pesquisar() {
            var _entidadeParaEnvio = null;

            if (!vm.entidadeDeEnvio) {
                _entidadeParaEnvio = PgToolbarService.recuperarEntidadeDeEnvio();
            }
            else _entidadeParaEnvio = vm.entidadeDeEnvio;

            return RequisicaoGenericaService.listarComObjetoComplexo(
                Api.brainstorming.listarComPaginacao,
                _entidadeParaEnvio
            );
        }

        /**
         * Método utilizado no modo exibido tabela, para selecionar um brainstorming
         * @param {brainstorming} brainstorming
         */
        function selecionar(posicaoEntidade) {
            vm.metodosExternosPgToolbar.metodoControladorExternoListarTodasEntidades(
                null,
                posicaoEntidade
            );
        }

        function construirDtOptions() {

            if (vm.entidadeDeEnvio.clsEntidade.dataAbertura) {
                vm.entidadeDeEnvio.clsEntidade.dataAbertura = vm.entidadeDeEnvio.clsEntidade.dataAbertura.toJSON();
            }

            DatatableFactory.construirDtOptionsComPaginacaoProcessadoNoServidorParaToolbar(
                Api.brainstorming.listarComPaginacaoDatatable,
                vm.entidadeDeEnvio.clsEntidade,
                '#datatable-brainstorming', [
                DatatableFactory.construirColunaDeSelecionarPadrao(function (indexLinha) {
                    vm.metodosBrainstorming.selecionar(indexLinha);
                }),
                {
                    targets: 1,
                    name: 'Numero',
                    data: 'numero',
                    width: "5%",
                    defaultContent: '',
                    sortable: false
                },
                {
                    targets: 2,
                    name: 'Ano',
                    data: 'ano',
                    width: "5%",
                    defaultContent: '',
                    sortable: false
                },
                {
                    targets: 3,
                    name: 'Descricao',
                    data: 'descricao',
                    width: "90%",
                    defaultContent: '',
                    className: 'descricao-ideia',
                    responsivePriority: 1,
                    sortable: false
                }
            ]
            );
        }

        function tabSelecionada(tab) {
            vm.tabSelecionada = tab;
        }

        function preDefinirCamposParaInserir() {
            var dataAtual = new Date();

            vm.brainstorming.descricao = '';
            vm.brainstorming.dataAbertura = dataAtual;
            vm.brainstorming.ano = dataAtual.getFullYear();
            vm.brainstorming.status = 1;
            vm.brainstorming.codigoUsuario = 0;

            ProximoCodigoService.proximoCodigo(Api.brainstorming.proximoNumero).then(
                function (success) {
                    vm.brainstorming.numero = success.data;
                },
                function (error) {
                    MdDialogService.alertPadrao(error.data);
                }
            );
        }

        function retornaUsuario(codigoUsuario) {
            var nome = 'Anônimo';
            if (codigoUsuario != 0) {
                vm.usuariosAtivos.forEach(function (usuario) {
                    if (usuario.codigo == codigoUsuario) {
                        nome = usuario.nome;
                    }
                });
            }

            return nome;
        }

        function retornaIniciasNomeUsuario(codigoUsuario) {
            var nome = retornaUsuario(codigoUsuario);

            if (nome == "Anônimo") return '?';

            return nome[0] + nome[1];
        }

        function abrirDialogInserirResposta(event) {
            $mdDialog.show({
                controller: 'DialogRespostasController',
                controllerAs: 'vm',
                multiple: true,
                templateUrl: vm.htmlRota.tabs.tabRespostas.dialogResposta,
                targetEvent: event,
                clickOutsideToClose: false,
                locals: {
                    Brainstorming: vm.brainstorming,
                    usuarioLogado: vm.usuarioLogado
                }
            });
        }

        /*
        **  If que verifica se esta vindo parametros na transição de estado,
        **  caso contenha o método pesquisar já é chamado para pesquisar o brainstorming recebido
        */
        if ($state.params.parametros) {
            vm.brainstorming = {
                numero: $state.params.parametros.numero,
                ano: $state.params.parametros.ano,
                chamarPesquisa: $state.params.parametros.chamarPesquisa
            };
        } else if (!vm.brainstorming) {
            vm.brainstorming = {};
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('app.datamobil')
        .controller('ListaFavoritosController', ListaFavoritosController)
        .directive('listaFavoritos', listaFavoritosDirective);

    function ListaFavoritosController($mdDialog, MdToastService, DatamobilIaService, MdDialogService) {
        var vm = this;
        vm.datamobilIaService = DatamobilIaService;

        vm.metodos = {
            adicionarEditarFavoritos: adicionarEditarFavoritos,
            removerFavorito: removerFavorito
        };

        function mostrarDialogErroServidor() {
            MdDialogService.alertPadrao(
                'Atenção!',
                null,
                'Não foi possível concluir sua solicitação no momento.<br><br>Tente novamente em alguns instantes.'
            );
        }

        vm.carregando = true;

        vm.datamobilIaService.listarFavoritos().catch(function () {
            mostrarDialogErroServidor();
        }).finally(function () {
            vm.carregando = false;
        });

        function adicionarEditarFavoritos(favorito, event) {
            $mdDialog
                .show({
                    controller: "FavoritosDialogController",
                    controllerAs: "vm",
                    templateUrl: 'app/main/datamobil-ia/components/lista-favoritos/components/dialog-favoritos/dialog-favoritos.html',
                    targetEvent: event,
                    clickOutsideToClose: false,
                    multiple: true,
                    escapeToClose: false,
                    locals: {
                        favorito: angular.copy(favorito)
                    }
                });
        }

        function removerFavorito(favorito, event) {
            var titulo = 'Remover favorito';
            var htmlContent = 'Tem certeza que deseja remover este comando dos seus favoritos?';

            function eventoSim() {
                vm.datamobilIaService.removerFavorito(favorito.id).then(function () {
                    MdToastService.toastPadrao('Favorito removido com sucesso!', false);
                }).catch(function () {
                    mostrarDialogErroServidor();
                });
            }

            MdDialogService.confirmPadraoComEvento(titulo, htmlContent, event, eventoSim);
        }
    }

    function listaFavoritosDirective() {
        return {
            restrict: 'E',
            templateUrl: 'app/main/datamobil-ia/components/lista-favoritos/lista-favoritos.html',
            scope: {
                onComandoSelecionado: '&',
                carregando: '='
            },
            controller: 'ListaFavoritosController',
            controllerAs: 'vm',
            bindToController: true
        };
    }
})();
(function () {
    'use strict';

    angular
        .module('app.datamobil')
        .controller('MensagensEnviadasController', MensagensEnviadasController)
        .directive('mensagemEnvio', mensagemEnvio);

    function MensagensEnviadasController($mdDialog, $timeout, DatamobilIaService) {
        var vm = this;
        vm.acaoCopiar = false;
        vm.atualizandoFavorito = false;

        vm.metodos = {
            copiarMensagem: copiarMensagem,
            atualizarFavorito: atualizarFavorito,
            isFavorito: isFavorito
        };

        function copiarMensagem(mensagem, event) {
            vm.acaoCopiar = true;

            var elementoPai = angular.element(event.currentTarget).closest('#container-mensagem-envio');
            var elemento = elementoPai.find('.mensagem-digitada')[0];
            if (elemento) {
                var texto = elemento.textContent || elemento.innerText;
                var textarea = document.createElement('textarea');
                textarea.value = texto;
                textarea.style.position = 'fixed';
                textarea.style.left = '-999999px';
                textarea.style.top = '-999999px';
                document.body.appendChild(textarea);
                textarea.focus();
                textarea.select();
                document.execCommand('copy');
                document.body.removeChild(textarea);
            }

            $timeout(function () {
                vm.acaoCopiar = false;
            }, 3000);
        }

        function atualizarFavorito(mensagem) {
            if (!isFavorito(mensagem)) {
                $mdDialog
                    .show({
                        controller: "FavoritosDialogController",
                        controllerAs: "vm",
                        templateUrl: 'app/main/datamobil-ia/components/lista-favoritos/components/dialog-favoritos/dialog-favoritos.html',
                        targetEvent: event,
                        clickOutsideToClose: false,
                        multiple: true,
                        escapeToClose: false,
                        locals: {
                            favorito: angular.copy(mensagem)
                        }
                    });
            } else {
                vm.atualizandoFavorito = true;
                DatamobilIaService.atualizarFavorito(mensagem.comando)
                    .finally(function () {
                        vm.atualizandoFavorito = false;
                    });
            }

        }

        function isFavorito(mensagem) {
            return DatamobilIaService.isFavorito(mensagem.comando);
        }
    }

    function mensagemEnvio() {
        return {
            restrict: 'E',
            scope: {
                mensagem: '='
            },
            templateUrl: 'app/main/datamobil-ia/components/mensagem-envio/mensagem-envio.html',
            controller: 'MensagensEnviadasController',
            controllerAs: 'vm',
            bindToController: true
        };
    }

})();
(function () {
    "use strict";
    angular
        .module("app.atendimento.processamento.atualizacoespendentes")
        .controller(
            "AtualizacoesPendentesController",
            AtualizacoesPendentesController
        );

    function AtualizacoesPendentesController(
        SidenavAtualizacoesPendentesService,
        MdDialogService,
        $mdSidenav,
        $scope,
        $state,
        ListarDetalhesUsuario,
        ListaClientesPendentes,
        EstoriaFactory,
        SquadService
    ) {
        var vm = this;
        vm.squadUsuarioLogado = ListarDetalhesUsuario.data.codigoSquads;
        vm.iniciarChamandoPesquisa = true;
        vm.coresSituacoes = EstoriaFactory.coresSituacoes();
        vm.clientes = _agruparClientesComHistorias(ListaClientesPendentes.data);
        vm.squadService = SquadService;
        init();

        vm.metodos = {
            abrirFiltro: abrirFiltro,
            filtrarDados: filtrarDados,
            visualizarHistoria: visualizarHistoria,
            visualizarCliente: visualizarCliente,
            visualizarSolicitacao: visualizarSolicitacao,
        };

        $scope.$watch(
            function () {
                return SidenavAtualizacoesPendentesService.emProgresso;
            },
            function (novoValor) {
                vm.emProgresso = novoValor;
            }
        );

        function init() {
            filtrarDados();
        }

        function abrirFiltro() {
            SidenavAtualizacoesPendentesService.toggleFiltro();
        }

        function filtrarDados() {
            SidenavAtualizacoesPendentesService.listener = function (callback) {
                SidenavAtualizacoesPendentesService.emProgresso = true;
                var viewModel = callback();
                SidenavAtualizacoesPendentesService.filtrarDados(
                    viewModel.squadCodigo
                )
                    .then(
                        function (success) {
                            vm.clientes = _agruparClientesComHistorias(
                                success.data
                            );
                        },
                        function (error) {
                            MdDialogService.alertPadrao(
                                "Atenção!",
                                null,
                                error.data
                            );
                        }
                    )
                    .finally(function () {
                        SidenavAtualizacoesPendentesService.emProgresso = false;
                        var sidenav = $mdSidenav(
                            "filtro-atualizacoes-pendentes"
                        );
                        if (sidenav.isOpen()) {
                            sidenav.close();
                        }
                    });
            };
        }

        function visualizarHistoria(historia) {
            $state.goNewTab("app.planejamento_processamento_estoria", {
                parametros: {
                    numero: historia.numero,
                    ano: historia.ano,
                    squadCodigo: historia.squadCodigo,
                    chamarPesquisa: true,
                },
            });
        }

        function visualizarSolicitacao(numero, ano, squadCodigo) {
            $state.goNewTab("app.solicitacao_processamento_solicitacao", {
                parametros: {
                    solicitacaoNumero: numero,
                    solicitacaoAno: ano,
                    squadCodigo: squadCodigo,
                },
            });
        }

        function visualizarCliente(clienteSelecionado) {
            $state.goNewTab("app.geral_cadastro_cliente_cliente", {
                parametros: {
                    cliente: {
                        codigo: clienteSelecionado.codigo,
                        nome: clienteSelecionado.nome,
                    },
                },
            });
        }

        function _agruparClientesComHistorias(dados) {
            var mapaClientes = {};
            dados.forEach(function (item) {
                var codigoCliente = item.clienteCodigo;
                if (!mapaClientes[codigoCliente]) {
                    mapaClientes[codigoCliente] = {
                        cliente: item.cliente,
                        historias: [],
                    };
                }
                item.estoria.dadosAtualizacao = item;
                mapaClientes[codigoCliente].historias.push(item.estoria);
            });
            var resultado = [];
            for (var key in mapaClientes) {
                if (mapaClientes.hasOwnProperty(key)) {
                    resultado.push(mapaClientes[key]);
                }
            }

            console.log("Resultado", resultado);
            return resultado;
        }
    }
})();

/**
 * Created by nova on 18/07/2016.
 */
(function () {
    'use strict';

    angular
        .module('app.cadastromenu', [])
        .config(config);

    function config($stateProvider, RotasHtml) {
        var rotasHtml = RotasHtml.cadastro_menu;
        $stateProvider
            .state('app.cadastro_menu', {
                url: '/cadastro/menu',
                module: 'privado_desenvolvimento',
                views: {
                    'content@app': {
                        templateUrl: rotasHtml.templateUrl,
                        controller: "CadastroMenuController as vm"
                    },
                    'cadastro-menu-form@app.cadastro_menu': {
                        templateUrl: rotasHtml.form
                    },
                }                
            });
    }

})();

/**
 * Created by nova on 26/10/2016.
 */
(function () {
    'use strict';

    angular
        .module('app.cadastromenu')
        .controller('CadastroMenuDialogController', CadastroMenuDialogController);


    function CadastroMenuDialogController($mdDialog, $scope, ServicosGenericoService, MdDialogService, MdToastService, RequisicaoGenericaService, Api, Parametros, MenuFactory) {
        var vm = this;

        //#region Data
        vm.form = {};
        vm.titulo = "Menu";

        vm.preloader = {
            requisicaoSolicitada: false,
            mensagemPreloader: ""
        }

        vm.listaMenus = angular.copy(Parametros[2]);
        vm.menuPaiSelecionado = undefined;
        vm.inserindo = false;

        var modo = angular.copy(Parametros[0]),
            Menu = Parametros[1],
            ListaMenus = Parametros[2],
            MetodoExternoCarregarMenus = Parametros[3],
            MetodoExternosRecarregarListaMenus = Parametros[4];

        _init();
        //#endregion   

        var metodosInterno = {
            _init: _init,
            _selecionarMenuPai: _selecionarMenuPai,
            _preencherNavegacaoMenu: _preencherNavegacaoMenu,
            _verificarSeNavegacaoEMenorQueNavegacaoPai: _verificarSeNavegacaoEMenorQueNavegacaoPai,
            _atualizar: _atualizar,
            _criar: _criar
        }
        vm.metodos = {
            previnirEspaco: previnirEspaco,
            alterarMenuPai: alterarMenuPai,
            verificarCampoNavegacao: verificarCampoNavegacao,
            salvar: salvar,
            excluir: excluir,
            fecharDialog: fecharDialog,
        };

        //#region Watchs

        $scope.$watch('vm.menu.navegacao.length', function (newValue, oldValue) {
            if (_verificarSeNavegacaoEMenorQueNavegacaoPai())
                _preencherNavegacaoMenu();
        })

        //#endregion

        //#region Métodos Internos    

        function _init() {
            if (modo === 'insercao') {
                vm.menu = {
                    codigoMenuPai: Menu.codigo
                };
                vm.inserindo = true;
            }
            else
                vm.menu = angular.copy(Menu);            

            _selecionarMenuPai();
        }

        function _selecionarMenuPai() {
            var index = vm.listaMenus.map(function (item) { return item.codigo }).indexOf(vm.menu.codigoMenuPai);
            vm.menuPaiSelecionado = vm.listaMenus[index];
        }

        function _preencherNavegacaoMenu() {
            vm.menu.navegacao = vm.menuPaiSelecionado.navegacao + ".";
        }

        function _verificarSeNavegacaoEMenorQueNavegacaoPai() {
            return !vm.menu.navegacao || vm.menu.navegacao.length <= vm.menuPaiSelecionado.navegacao.length + 1 ? true : false;
        }

        function _atualizar(menu, event) {
            vm.preloader.requisicaoSolicitada = true;
            vm.preloader.mensagemPreloader = "Atualizando Menu ...";
            RequisicaoGenericaService.editar(Api.menu.atualizar, menu).then(
                function (success) {
                    MdToastService.toastPadrao("Menu atualizado com sucesso.");
                    vm.preloader.requisicaoSolicitada = false;
                    vm.preloader.mensagemPreloader = "";                    

                    MetodoExternoCarregarMenus();

                    fecharDialog();
                },
                function (error) {
                    vm.preloader.requisicaoSolicitada = false;
                    vm.preloader.mensagemPreloader = "";
                    ServicosGenericoService.exibirAlertaDeErro(error, event);
                });
        }

        function _criar(menu, event) {
            vm.preloader.requisicaoSolicitada = true;
            vm.preloader.mensagemPreloader = "Cadastrando novo Menu ...";
            RequisicaoGenericaService.salvar(Api.menu.criar, menu).then(
                function (success) {
                    MdToastService.toastPadrao("Menu cadastrado com sucesso.");
                    vm.preloader.requisicaoSolicitada = false;
                    vm.preloader.mensagemPreloader = "";                    

                    MetodoExternoCarregarMenus();
                    MetodoExternosRecarregarListaMenus();

                    fecharDialog();
                },
                function (error) {
                    vm.preloader.requisicaoSolicitada = false;
                    vm.preloader.mensagemPreloader = "";
                    ServicosGenericoService.exibirAlertaDeErro(error, event);
                });
        }

        //#endregion

        //#region  Métodos

        function previnirEspaco(event) {
            if (event && event.keyCode == 32)
                event.preventDefault();
        }

        function alterarMenuPai() {
            _selecionarMenuPai();
            _preencherNavegacaoMenu();
        }

        function verificarCampoNavegacao(event) {
            if (_verificarSeNavegacaoEMenorQueNavegacaoPai() && (event.keyCode == 8 || event.keyCode == 46)) {
                event.preventDefault();
            }
        }

        function salvar(menu, event) {
            if (modo == 'edicao')
                _atualizar(menu, event);
            else
                _criar(menu, event);
        }

        function excluir(menu, event) {
            function functionExclusaoSucces(success) {
                MdToastService.toastPadrao("Menu excluido com sucesso.");                

                MetodoExternoCarregarMenus();
                MetodoExternosRecarregarListaMenus();

                fecharDialog();
            }
            ServicosGenericoService.excluirRegistroPorCodigoOuGenericamenteEmDialogs(Api.menu.excluir, null, null, vm.preloader, null, event,
                "Deseja realmente excluir o menu solicitado ?", functionExclusaoSucces, null, "Menu excluido com sucesso.", menu.codigo);
        }

        function fecharDialog() {
            $mdDialog.hide();
        }

        //#endregion


    } // CONTROLLER

})();

(function () {
    'use strict';

    angular
        .module('app.documentosTecnicos.manuaisInternos.manualDesenvolvimento', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, RotasHtml) {

        var rotasHtml = RotasHtml.manualDesenvolvimento;

        // State
        $stateProvider
            .state('app.manual_desenvolvimento', {
                abstract: false,
                url: '/manual-desenvolvimento',
                module: 'privado',
                views: {
                    'content@app': {
                        templateUrl: rotasHtml.templateUrl,
                        controller: 'ManualDesenvolvimentoController as vm'
                    }
                }
            });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/documentos-tecnicos/manuais-internos/desenvolvimento');

    }
})();

//<!-- Ultima mudança 28/03/2017.-->
(function () {
    'use strict';

    angular.module('app.documentosTecnicos.manuaisInternos.manualDesenvolvimento')
        .run(['$anchorScroll', function ($anchorScroll) {
            $anchorScroll.yOffset = 50;   // always scroll by 50 extra pixels
        }])
        .controller('ManualDesenvolvimentoController', ManualDesenvolvimentoController);

    function ManualDesenvolvimentoController($mdSidenav, NavegacaoService, RotasHtml, $anchorScroll, $location, $scope) {
        var vm = this;
        NavegacaoService.setTituloAba('Manual do Desenvolvimento');

        init();

        vm.metodos = {
            toggleSidenav: toggleSidenav,
            goToAnchor: goToAnchor
        }

        vm.metodosInternos = {
            procuraCapitulo: _procuraCapitulo
        }

        function init() {
            vm.capitulos = [{ titulo: 'Início', id: 0, peso: 1 },
            { titulo: 'Código Fonte', id: 1, peso: 2 },
            { titulo: 'Banco de dados', id: 2, peso: 3 },
            { titulo: 'Erros Comuns', id: 3, peso: 4 },
            { titulo: 'Materiais de Estudo', id: 4, peso: 1 }];

            vm.rotasHtml = RotasHtml.manualDesenvolvimento;
            vm.tituloSumario = "Sumário";
            vm.tituloCapitulo = vm.capitulos[0].titulo;
        }


        //Troca o titulo de acordo com a posição do conteúdo no scroll
        vm.elements = vm.capitulos.map(function (value, index) {
            return {
                id: value.id,
                elementHtml: document.getElementById(value.id)
            };
        });

        angular.element(document.getElementById('pagina-manual')).bind('scroll', function (scroll) {
            vm.elements.forEach(function (element) {
                if (element != null && element.elementHtml != null)
                    if (scroll.target.scrollTop >= element.elementHtml.offsetTop) {
                        vm.tituloCapitulo = _procuraCapitulo(element.id).titulo;
                        console.log(vm.tituloCapitulo);
                    }
            });

        });
        //FIM Troca de titulo


        //#region Metodo

        function goToAnchor(id) {
            vm.capitulos.forEach(function (value) {
                if (value.id == id)
                    vm.tituloCapitulo = value.titulo;
                console.log(vm.tituloCapitulo);
            });

            $location.hash(id);
            $anchorScroll();
        }

        function toggleSidenav(sidenavId) {
            $mdSidenav(sidenavId).toggle();
        }

        $(window).on('100', function () {
            console.log("Aqui");
        });

        //#endregion

        //#region Métodos Internos
        function _procuraCapitulo(id) {
            var capituloEncontrado = null;
            vm.capitulos.forEach(function (cap) {
                if (cap.id == id)
                    capituloEncontrado = cap;
            });

            return capituloEncontrado;
        }
        //#endregion    Metodos Internos        

    }
})();

(function () {
    'use strict';

    angular
        .module('app.atendimento.relatorio.atendimento', [])
        .config(Config);

    function Config($stateProvider, RotasHtml) {
        var rotasHtml = RotasHtml.relatorioAtendimento;
        $stateProvider
            .state('app.atendimento_relatorio_atendimento', {
                url: '/atendimento/relatorio/atendimento',
                module: 'privado',
                params: {
                    navegacaoDeCliente: null
                },
                views: {
                    'content@app': {
                        templateUrl: rotasHtml.templateUrl,
                        controller: 'RelatorioAtendimentoController as vm'
                    }
                },
                resolve: {
                    ListarTodasSolucoes: function (Api, RequisicaoGenericaService) {
                        return RequisicaoGenericaService.listarSemParams(Api.solucao_rotinas_tarefas.solucao.listarCodigoDescricao);
                    },
                    ListarTodosUsuarios: function (Api, RequisicaoGenericaService) {
                        return RequisicaoGenericaService.listarSemParams(Api.usuario.detalhes_usuario.listarUsuariosAtivos);
                    },
                    ListarDetalhesUsuario: function (Api, RequisicaoGenericaService, LoginUsuarioService) {
                        return RequisicaoGenericaService.listarSemParams(Api.usuario.detalhes_usuario.listarDetalhesUsuario
                            + LoginUsuarioService.usuarioArmazenado().codigo);
                    },
                    ListarTodosAtendimentosPendencia: function (Api, RequisicaoGenericaService) {
                        return RequisicaoGenericaService.listarSemParams(Api.atendimento.pendencia_atendimento.listarPor);
                    },
                    ListarTiposAtendimentoGeral: function (Api, RequisicaoGenericaService) {
                        return RequisicaoGenericaService.listarSemParams(Api.atendimento.listarTiposAtendimentoGeral);
                    },
                    ListarStatusAtendimentoGeral: function (Api, RequisicaoGenericaService) {
                        return RequisicaoGenericaService.listarSemParams(Api.atendimento.listarStatusAtendimentoGeral);
                    },
                    ListarSituacaoCliente: function (Api, RequisicaoGenericaService) {
                        return RequisicaoGenericaService.listarSemParams(Api.cliente.listarSituacaoCliente);
                    },
                    ListarMotivosAtendimentos: function (Api, RequisicaoGenericaService) {
                        return RequisicaoGenericaService.listarSemParams(Api.atendimento.grupo_atendimento.listarPor);
                    }
                }
            });
    }

})();

(function () {
    'use strict';

    angular
        .module('app.atendimento.relatorio.atendimento')
        .controller('RelatorioAtendimentoController', RelatorioAtendimentoController);

    function RelatorioAtendimentoController($window, $scope, $filter, $stateParams, MenuFactory, Api, RequisicaoGenericaService, urlApi, RotasHtml, ListarTodasSolucoes,
        ServicosGenericoService, ListarTodosUsuarios, ListarMotivosAtendimentos, ListarTodosAtendimentosPendencia, ListarTiposAtendimentoGeral, ListarStatusAtendimentoGeral,
        ListarSituacaoCliente, LoginUsuarioService, MdDialogService, NavegacaoService, ListarDetalhesUsuario, SquadService) {
        var vm = this;
        NavegacaoService.setTituloAba('Atendimento relatório');

        var dataAtual = new Date();

        vm.relatorioAtendimento = {};
        vm.rotasHtml = RotasHtml.relatorioAtendimento;


        vm.solucoes = ListarTodasSolucoes.data;
        vm.usuarios = ListarTodosUsuarios.data;
        vm.usuariosFiltrados = ListarTodosUsuarios.data;
        vm.pendenciasAtendimento = ListarTodosAtendimentosPendencia.data;
        vm.tipoAtendimentosGeral = ListarTiposAtendimentoGeral.data;
        vm.statusAtendimentoGeral = ListarStatusAtendimentoGeral.data;
        vm.situacaoClienteGeral = ListarSituacaoCliente.data;
        vm.listaMotivoAtendimentos = ListarMotivosAtendimentos.data;
        vm.squadUsuarioLogado = ListarDetalhesUsuario.data.codigoSquads;
        vm.squads = SquadService.listarSquadsUsuarioLogado(vm.squadUsuarioLogado);
        var todasSolucoes = ListarTodasSolucoes.data;

        var metodosInternos = {
            construirFiltroUtilizado: construirFiltroUtilizado,
            habilitarTodosUsuarios: habilitarTodosUsuarios,
            habilitarTodasPendenciasAtendimento: habilitarTodasPendenciasAtendimento
        }

        vm.metodos = {
            gerarRelatorio: gerarRelatorio,
            pesquisarAutoCompleteCliente: pesquisarAutoCompleteCliente,
            alterarItemSelecionadoAutoCompleteCliente: alterarItemSelecionadoAutoCompleteCliente,
            configuraAutoCompleteClienteOnBlur: configuraAutoCompleteClienteOnBlur,
            pesquisarAutoCompleteSolucao: pesquisarAutoCompleteSolucao,
            alterarItemSelecionadoAutoCompleteSolucao: alterarItemSelecionadoAutoCompleteSolucao,
            configuraAutoCompleteSolucaoOnBlur: configuraAutoCompleteSolucaoOnBlur,
            alterarEstadoCheckboxTodosUsuarios: alterarEstadoCheckboxTodosUsuarios,
            alterarEstadoCheckboxTodasPendenciasAtendimento: alterarEstadoCheckboxTodasPendenciasAtendimento,
            ngChangeStatusAtendimento: ngChangeStatusAtendimento,
            configuraMdSelectUsuario: configuraMdSelectUsuario,
            configuraMdSelectPendenciaAtendimento: configuraMdSelectPendenciaAtendimento,
            implementarVoltarParaOEstado: implementarVoltarParaOEstado,
            configuraMdSelectSolucao: configuraMdSelectSolucao,
            selectChangeSquad: selectChangeSquad,
        };

        init();

        /**
         * Método inicilizador
         */
        function init() {
            vm.relatorioAtendimento = {
                codigoUsuarioCorrente: LoginUsuarioService.usuarioArmazenado().codigo,
                tipoAtendimento: 3,
                statusAtendimento: 3,
                situacaoCliente: 1,
                periodoFinal: new Date(dataAtual),
                periodoInicial: new Date(dataAtual.getFullYear(), dataAtual.getMonth() - 12, dataAtual.getDate()),
                exibirSomenteHistoricoColaboradoresSelecionados: false
            };

            vm.todosUsuarios = true;
            vm.todasPendenciasAtendimento = true;
            vm.requisicaoSolicitada = false;
            if (vm.squadUsuarioLogado.length === 1) {
                vm.relatorioAtendimento.squadCodigo = vm.squadUsuarioLogado;
                selectChangeSquad(vm.relatorioAtendimento.squadCodigo);
            } else {
                vm.usuariosFiltrados = vm.usuarios;
            }
        }

        /**
         * Watch que fica escutando o tamanho do model 'vm.codigoUsuariosSelecionados' e se ele or maior que zero, o checkbox todos usuários é
         * desmarcado
         */
        $scope.$watch('vm.relatorioAtendimento.codigoUsuarios.length', function (newValue, oldValue) {
            if (newValue == vm.usuarios.length) {
                habilitarTodosUsuarios();
            }
            else if (newValue > 0) {
                vm.todosUsuarios = false;
            }
            else if (newValue <= 0) {
                habilitarTodosUsuarios();
                vm.relatorioAtendimento.exibirSomenteHistoricoColaboradoresSelecionados = false;
            }
        })

        /**
        * Watch que fica escutando o tamanho do model 'vm.codigoPendenciasAtendimento' e se ele or maior que zero, o checkbox todas pendências é
        * desmarcado
        */
        $scope.$watch('vm.relatorioAtendimento.codigoPendenciasAtendimento.length', function (newValue, oldValue) {
            if (newValue == vm.pendenciasAtendimento.length) {
                habilitarTodasPendenciasAtendimento();
            }
            else if (newValue > 0) {
                vm.todasPendenciasAtendimento = false;
            }
            else if (newValue <= 0) {
                habilitarTodasPendenciasAtendimento();
            }
        })

        //////////////////////////////////////////////////////////// Métodos Internos ////////////////////////////////////////////////////////////

        /**
         * Método que verifica todos os filtros que foram utilizados para gerar o relatório e retorna o filtro utilizado formatado
         * @param {objeto para construção do relatório} item
         */
        function construirFiltroUtilizado(item) {

            var filtroUtilizado = "";
            filtroUtilizado += "Colaborador Corrente: " + LoginUsuarioService.usuarioArmazenado().nome + ", ";
            if (item.periodoInicial && item.periodoFinal) {
                filtroUtilizado += "Período: " + $filter('date')(item.periodoInicial, 'dd/MM/yyyy') + " a " +
                    $filter('date')(item.periodoFinal, 'dd/MM/yyyy') + ", ";
            }
            if (item.codigoAtendimento && item.codigoAtendimento > 0) {
                filtroUtilizado += "Codigo Atendimento: " + item.codigoAtendimento + ", ";
            }
            if (item.anoAtendimento && item.anoAtendimento > 0) {
                filtroUtilizado += "Ano Atendimento: " + item.anoAtendimento + ", ";
            }
            if (item.codigoCliente && item.codigoCliente > 0) {
                filtroUtilizado += "Cliente: " + vm.cliente.nome + ", ";
            }
            if (item.codigoSolucao && item.codigoSolucao > 0) {
                filtroUtilizado += "Solucao: " + vm.solucao.descricao + ", ";
            }
            if (!vm.todosUsuarios && item.codigoUsuarios && item.codigoUsuarios.length > 0) {
                filtroUtilizado += "Colaboradores: [";
                angular.forEach(item.codigoUsuarios, function (usuarioSelecionado, indexUsuarioSelecionado) {
                    angular.forEach(vm.usuarios, function (usuario, indexUsuario) {
                        if (usuarioSelecionado == usuario.codigo) {
                            if (item.codigoUsuarios.length - 1 == indexUsuarioSelecionado) {
                                filtroUtilizado += usuario.nome + "], ";
                            }
                            else {
                                filtroUtilizado += usuario.nome + ", ";
                            }
                        }
                    });
                });
            }
            if (item.codigoPendenciasAtendimento && item.codigoPendenciasAtendimento.length > 0) {
                filtroUtilizado += "Pendências: [";
                angular.forEach(item.codigoPendenciasAtendimento, function (pendenciaSelecionada, indexPendenciaSelecionada) {
                    angular.forEach(vm.pendenciasAtendimento, function (pendencia, indexPendencia) {
                        if (pendenciaSelecionada == pendencia.codigo) {
                            if (item.codigoPendenciasAtendimento.length - 1 == indexPendenciaSelecionada) {
                                filtroUtilizado += pendencia.descricao + "], ";
                            }
                            else {
                                filtroUtilizado += pendencia.descricao + ", ";
                            }
                        }
                    });
                });
            }
            filtroUtilizado += "Tipo Atendimento: " + vm.tipoAtendimentosGeral[item.tipoAtendimento] + ", ";
            filtroUtilizado += "Status Atendimento: " + vm.statusAtendimentoGeral[item.statusAtendimento] + ", ";
            filtroUtilizado += "Situação Cliente: " + vm.situacaoClienteGeral[item.situacaoCliente] + ", ";

            if (item.motivoAtendimento && item.motivoAtendimento.length > 0) {
                filtroUtilizado += "Motivo do atendimento: [";
                angular.forEach(item.motivoAtendimento, function (motivo, indexMotivo) {


                    if (item.motivoAtendimento.length - 1 == indexMotivo) {
                        filtroUtilizado += motivo.titulo + "] ";
                    }
                    else {
                        filtroUtilizado += motivo.titulo + ", ";
                    }

                });
            }

            return filtroUtilizado;
        }

        /**
         * Método chamado para limpar o array do model 'vm.relatorioAtendimento.codigoUsuarios' e habilitar o checkbox Todos do usuário
         */
        function habilitarTodosUsuarios() {
            vm.todosUsuarios = true;
            vm.relatorioAtendimento.codigoUsuarios = [];
        }

        /**
         * Método chamado para limpar o array do model 'vm.relatorioAtendimento.codigoPendenciasAtendimento' e habilitar o checkbox Todas as Pendências
         */
        function habilitarTodasPendenciasAtendimento() {
            vm.todasPendenciasAtendimento = true;
            vm.relatorioAtendimento.codigoPendenciasAtendimento = [];
        }

        function selectChangeSquad(squadCodigoSelecionada) {
            vm.relatorioAtendimento.codigoUsuarios = [];
            if (squadCodigoSelecionada.length === 0) {
                vm.usuariosFiltrados = vm.usuarios;
            } else {
                vm.usuariosFiltrados = vm.usuarios.filter(function (usuario) {
                    return squadCodigoSelecionada.some(function (squadCodigo) {
                        return usuario.codigoSquads.includes(squadCodigo);
                    });
                });
            }
        }


        function configuraMdSelectSolucao() {
            vm.filtrarSolucoes = '';
            angular
                .element('#solucao-md-select')
                .on('keydown', function (ev) {
                    ev.stopPropagation();
                });
        }

        //////////////////////////////////////////////////////////// /Métodos Internos ///////////////////////////////////////////////////////////


        //////////////////////////////////////////////////////////// Métodos /////////////////////////////////////////////////////////////////////

        function gerarRelatorio(item, event) {
            if (vm.todosUsuarios) {
                item.codigoUsuarios = vm.usuariosFiltrados.map(function (usuario) { return usuario.codigo; });
            }

            item.filtroUtilizado = construirFiltroUtilizado(item);
            if (item.motivoAtendimento && item.motivoAtendimento.length > 0) {
                item.codigoMotivoAtendimento = item.motivoAtendimento.map(function (mot) { return mot.codigo });
            } else {
                item.codigoMotivoAtendimento = null;
            }
            vm.form.$setPristine();
            vm.requisicaoSolicitada = true;
            vm.mensagemPreloader = "Gerando relatório ...";
            RequisicaoGenericaService.salvar(Api.atendimento.relatorio_atendimento.gerarRelatorioAtendimento, item).then(
                function (success) {
                    vm.requisicaoSolicitada = false;
                    vm.mensagemPreloader = "";
                    $window.open(urlApi.url_base_api + Api.relatorio.abrirRelatorio + success.data);
                },
                function (error) {
                    vm.requisicaoSolicitada = false;
                    vm.mensagemPreloader = "";
                    MdDialogService.alertPadrao(error.data);
                });
        }

        /**
         * Método que realiza uma requisição para api para buscar os clientes na em tempo de excução, * com base no que o usuário está digitando
         * @param {*query de pesquisa} query
         */
        function pesquisarAutoCompleteCliente(query) {
            return ServicosGenericoService.pesquisarAutoCompleteCodigoOuNomeGenericoApi(Api.cliente.listarCodigoDescricao, query);
        }

        /**
         * Método que controla qual cliente está selecionado no campo md-auto-complete do Cliente
         * @param {*cliente} item
         */
        function alterarItemSelecionadoAutoCompleteCliente(item) {
            if (item) {
                vm.cliente = item;
                vm.relatorioAtendimento.codigoCliente = item.codigo;
                if (!vm.relatorioAtendimento.codigoSolucao
                    || (item.solucoes.map(function (itemSolucao) { return itemSolucao.codigo }).indexOf(vm.relatorioAtendimento.codigoSolucao) == -1)) {
                    vm.textoDePesquisaAutoCompleteSolucao = "";
                    vm.solucao = null;
                }
            } else {
                vm.textoDePesquisaAutoCompleteCliente = "";
                vm.textoDePesquisaAutoCompleteSolucao = "";
                vm.relatorioAtendimento.codigoCliente = null;
                vm.relatorioAtendimento.codigoSolucao = null;
                vm.cliente = null;
                vm.solucao = null;
            }

            _listarSolucoesVinculadas(vm.relatorioAtendimento.squadCodigo);
        }

        /**
        * Método que limpa o texto de pesquisa do md-auto-complete do Cliente
        */
        function configuraAutoCompleteClienteOnBlur() {
            if (!vm.cliente) {
                vm.textoDePesquisaAutoCompleteCliente = "";
            }
        }

        /**
         * Método que busca na lista de solucoes e filtra as solucoes com base no que está sendo digitado com base no que o usuário está digitando
         * @param {*query de pesquisa} query
         */
        function pesquisarAutoCompleteSolucao(query) {
            return ServicosGenericoService.pesquisarAutoCompleteDescricaoGenerico(vm.solucoes, query)
        }

        /**
       * Método que controla qual solução está selecionada no campo md-auto-complete da Solução
       * e seta o codigo da solução para o objeto de consulta 'vm.consultaAtendimento.codigoSolucao'
       * @param {solucao} item
       */
        function alterarItemSelecionadoAutoCompleteSolucao(item) {
            if (item) {
                vm.solucao = item;
                vm.relatorioAtendimento.codigoSolucao = item.codigo;
            }
            else {
                vm.solucao = null;
                vm.relatorioAtendimento.codigoSolucao = null;
                vm.textoDePesquisaAutoCompleteSolucao = "";
            }
        }

        /**
         * Método que limpa o texto de pesquisa do md-auto-complete da Solução
         */
        function configuraAutoCompleteSolucaoOnBlur() {
            if (!vm.solucao) {
                vm.textoDePesquisaAutoCompleteSolucao = "";
            }
        }

        /**
         * Método que limpa o model 'vm.codigoUsuariosSelecionados' quando o checkbox todos usuários estiver habilitado
         * @param {todosUsuarios} todosUsuarios
         */
        function alterarEstadoCheckboxTodosUsuarios(todosUsuarios) {
            if (todosUsuarios) {
                vm.relatorioAtendimento.codigoUsuarios = [];
                vm.relatorioAtendimento.exibirSomenteHistoricoColaboradoresSelecionados = false;
            }
        }

        function alterarEstadoCheckboxTodasPendenciasAtendimento(todasPendenciasAtendimento) {
            if (todasPendenciasAtendimento) {
                vm.relatorioAtendimento.codigoPendenciasAtendimento = [];
            }
        }

        /**
         *
         * @param {*} statusAtendimento
         */
        function ngChangeStatusAtendimento(statusAtendimento) {
            if (statusAtendimento == 2) {
                vm.relatorioAtendimento.codigoPendenciasAtendimento = [];
            }
        }

        /**
         * método para configurar md-header do md-select do campo colaborador
         */
        function configuraMdSelectUsuario() {
            vm.filtrarUsuarios = "";
            angular.element('#relatorio-atendimento-colaborador-md-select').on('keydown', function (ev) {
                ev.stopPropagation();
            });
        }

        /**
         * Método para configurar md-header do md-select do campo pendencia_atendimento
         */
        function configuraMdSelectPendenciaAtendimento() {
            vm.filtrarPendenciasAtendimento = "";
            angular.element('#relatorio-atendimento-pendencias-atendimento-md-select').on('keydown', function (ev) {
                ev.stopPropagation();
            });
        }

        function implementarVoltarParaOEstado() {
            if (vm.habilitarIconeVoltarATelaDeCliente) {
                MenuFactory.navegarParaEstadoSeUsuarioTerAcesso('app.geral_cadastro_cliente_cliente', { navegacaoDeRelatorioAtendimento: { cliente: $stateParams.navegacaoDeCliente.cliente } });
            }
        }

        //////////////////////////////////////////////////////////// /Métodos ////////////////////////////////////////////////////////////////////

        //#region  $stateParams

        if ($stateParams.navegacaoDeCliente) {
            vm.habilitarIconeVoltarATelaDeCliente = true;
            vm.mensagemTooltipIconeEstadoAnteriorHeaderPadrao = "Voltar para tela de cliente";

            vm.cliente = $stateParams.navegacaoDeCliente.cliente;
            vm.relatorioAtendimento.codigoCliente = $stateParams.navegacaoDeCliente.cliente.codigo;
        }

        //#endregion

    } // Controller

})();


//<!-- Ultima mudança 31/03/2017.-->
(function () {
    "use strict";

    angular
        .module("app.atendimento.processamento.atendimento")
        .controller("AtendimentoController", AtendimentoController);

    function AtendimentoController(
        $mdDialog,
        $rootScope,
        $scope,
        $state,
        $stateParams,
        $timeout,
        Api,
        AtendimentoFactory,
        AtendimentoService,
        ListarDetalhesUsuario,
        ListarStatusAtendimento,
        ListarStatusAtividade,
        ListarTiposAtendimento,
        ListarTodasSolucoes,
        ListarTodasTags,
        ListarTodosAtendimentosConclusao,
        ListarTodosAtendimentosMotivo,
        ListarTodosAtendimentosPendencia,
        ListarTodosEventos,
        ListarTodosUsuariosAtivos,
        ListarUsuarioPorDetalhe,
        ListarUsuariosSetorComercial,
        LoginUsuarioService,
        MenuFactory,
        MdDialogService,
        MdToastService,
        NavegacaoService,
        RequisicaoGenericaService,
        RotasHtml,
        ServicosGenericoService,
        SquadService,
        VisualizarAtividadeService,
        ControleAcessoConfig
    ) {
        NavegacaoService.setTituloAba("Atendimento");

        var vm = this;

        vm.iniciarChamandoPesquisa = false;

        vm.form = {};

        vm.rota = Api.atendimento.grupo_atendimento.proximoCodigo;
        vm.rotasHtml = RotasHtml.atendimento;
        vm.solicitacoes = [];
        vm.solicitacao = null;
        vm.solicitacaoBkp = null;
        vm.ultimoCliente = 0;
        vm.codigoAtendimentoMotivoPermiteSolicitacao = 90;
        vm.todasTagsCadastradas = ListarTodasTags.data;
        vm.aguardandoConfirmacaoPendenciaCliente = false;
        vm.exibirBotaoNegocios = false;
        vm.abrindoDialogContratos = false;
        if (
            ControleAcessoConfig.usuarioEDirecao() ||
            ControleAcessoConfig.usuarioEComercial()
        ) {
            vm.exibirBotaoNegocios = true;
        }

        /**
         * Condição que verifica se o usuário contém o tipo atendimento informado caso contenha
         * o usuario logado será informado com seu tipo de atendimento
         * se não o usuario logado será definido sem seu tipo de atendimento
         */
        if (ListarUsuarioPorDetalhe.data) {
            vm.usuarioLogado = ListarUsuarioPorDetalhe.data;
        } else {
            alert(
                "O Tipo de Atendimento não está definido no colaborador\nPor favor defina."
            );
            vm.usuarioLogado = LoginUsuarioService.usuarioArmazenado();
        }
        // Variável para passar para o dialog de visualização os usuarios vinculados ao atendimento com codigo e nome
        vm.atendimentoAcompanhamentosVisualizacao = [];
        // Variável que irar receber uma lista de usuarios a ser persistido quando o atendimento for criado
        var atendimentoAcompanhamentosVisualizacaoEmMemoria = [];

        vm.tiposAtendimento = ListarTiposAtendimento.data;
        vm.statusAtendimento = ListarStatusAtendimento.data;
        vm.atendimentosPendencia = ListarTodosAtendimentosPendencia.data;
        vm.motivosAtendimento = ListarTodosAtendimentosMotivo.data;
        vm.conclusoesAtendimento = ListarTodosAtendimentosConclusao.data;
        vm.usuariosAtivosBkp = ListarTodosUsuariosAtivos.data;
        vm.usuariosAtivos = angular.copy(vm.usuariosAtivosBkp);
        vm.squadUsuarioLogado = ListarDetalhesUsuario.data.codigoSquads;
        vm.listarDetalhesUsuario = ListarDetalhesUsuario.data;
        vm.solucoes = ListarTodasSolucoes.data;
        vm.listaTagsAtendimento = [];
        vm.buscandoTagsAtendimentoCadastradas = false;
        _listarTodasSolucoes();

        vm.copiaHistoricoAtendimento = AtendimentoFactory.historicoAtendimento;

        init();
        // endregion

        // Configurações Datatable region
        vm.dtOptions = AtendimentoFactory.setDtOptionsPadrao();
        vm.dtOptionsHistoricoAtendimento =
            AtendimentoFactory.setDtOptionsHistoricoAtendimento();
        //endregion

        // Definição dos Métodos region
        var metodosInterno = {
            recarregarHistoricoAtendimento: recarregarHistoricoAtendimento,
            inserirUsuariosHaVisualizarAtendimentoEmMemoria:
                inserirUsuariosHaVisualizarAtendimentoEmMemoria,
            definirAcompanhanteNovoAtendimento:
                definirAcompanhanteNovoAtendimento,
            pesquisarHistoricoAtendimento: pesquisarHistoricoAtendimento,
            atualizarAcompanhantesAtendimento:
                atualizarAcompanhantesAtendimento,
            pesquisarAcompanhantesAtendimento:
                pesquisarAcompanhantesAtendimento,
            definiriSigiloComercialAtendimento:
                definiriSigiloComercialAtendimento,
            definirUsuarioVisualizouAtendimento:
                definirUsuarioVisualizouAtendimento,
            definirUsuarioMarcouComoImportante:
                definirUsuarioMarcouComoImportante,
        };
        vm.metodosGeral = {
            novaPesquisa: novaPesquisa,
            preDefinirCamposParaInserir: preDefinirCamposParaInserir,
            preDefinirCamposParaEditar: preDefinirCamposParaEditar,
            redefinirCampos: redefinirCampos
        };
        vm.metodos = {
            pesquisar: pesquisar,
            salvar: salvar,
            editar: editar,
            excluir: excluir,
            selecionar: selecionar,
            pesquisarAutoCompleteCliente: pesquisarAutoCompleteCliente,
            pesquisarAutoCompleteAtendimentoMotivo: pesquisarAutoCompleteAtendimentoMotivo,
            alterarItemSelecionadoAutoCompleteCliente: alterarItemSelecionadoAutoCompleteCliente,
            alterarItemSelecionadoAutoCompleteAtendimentoMotivo: alterarItemSelecionadoAutoCompleteAtendimentoMotivo,
            configuraAutoCompleteClienteOnBlur: configuraAutoCompleteClienteOnBlur,
            configuraAutoCompleteAtendimentoMotivoOnBlur: configuraAutoCompleteAtendimentoMotivoOnBlur,
            configuraMdSelectUsuarioAtivo: configuraMdSelectUsuarioAtivo,
            configuraMdSelectSolucao: configuraMdSelectSolucao,
            configuraMdSelectMotivoAtendimento: configuraMdSelectMotivoAtendimento,
            limparCamposVinculadoStatusAtendimento: limparCamposVinculadoStatusAtendimento,
            selecionarHistoricoAtendimento: selecionarHistoricoAtendimento,
            abrirDialogHistorico: abrirDialogHistorico,
            abrirDialogColaboradoresHaNotificar: abrirDialogColaboradoresHaNotificar,
            abrirDialogColaboradoresHaVisualizar: abrirDialogColaboradoresHaVisualizar,
            abrirDialogAnexoArquivos: abrirDialogAnexoArquivos,
            implementarVoltarParaOEstadoAnteriorHeaderPadrao: implementarVoltarParaOEstadoAnteriorHeaderPadrao,
            criarAtendimento: criarAtendimento,
            alterarDataUltimoAtendimento: alterarDataUltimoAtendimento,
            atualizarVisualizacaoAcompanhamentoUsuario: atualizarVisualizacaoAcompanhamentoUsuario,
            configuraMdSelectSolicitacao: configuraMdSelectSolicitacao,
            configurarMdSelectSolicitacaoOnClose: configurarMdSelectSolicitacaoOnClose,
            selecionarSolicitacao: selecionarSolicitacao,
            listarTodasSolicitacoesCliente: listarTodasSolicitacoesCliente,
            verificarSolucaoAtendimentoSolicitacao: verificarSolucaoAtendimentoSolicitacao,
            abrirDialogAgenda: abrirDialogAgenda,
            abrirCadastroCliente: abrirCadastroCliente,
            abrirCadastroSolicitacao: abrirCadastroSolicitacao,
            recarregarMotivosAtendimentos: recarregarMotivosAtendimentos,
            abrirDialogHistoriasVinculadas: abrirDialogHistoriasVinculadas,
            abrirDialogOrdensDeServicos: abrirDialogOrdensDeServicos,
            marcarComoImportante: marcarComoImportante,
            abrirDialogContratos: abrirDialogContratos,
            abrirDialogNegociosEmAndamento: abrirDialogNegociosEmAndamento,
            abrirDialogCaracteristica: abrirDialogCaracteristica,
            abrirDialogVisualizacaoHistorico: abrirDialogVisualizacaoHistorico
        };


        //endregion

        // Métodos Interno region

        function recarregarMotivosAtendimentos(codigoUsuario) {
            RequisicaoGenericaService.listarComParams(
                Api.atendimento.grupo_atendimento.listarMotivoPorSetor +
                codigoUsuario
            ).then(function (success) {
                vm.motivosAtendimento = success.data;
            });
        }

        /**Método que recarrega o histórico atendimento e verifica o index e o item
         * a ser controlado pelo toolbar
         * @param {*lista de historicoAtendimentos} historicoAtendimentos
         * @param {*historicoAtendimento atual} modelo
         */
        function recarregarHistoricoAtendimento(
            historicoAtendimentos,
            modelo,
            quantidadeDiasSemAtendimento
        ) {
            vm.atendimento.ultimaDataHistoricoAtendimento = modelo.data;
            if (quantidadeDiasSemAtendimento) {
                vm.atendimento.quantidadeDiasSemContato =
                    quantidadeDiasSemAtendimento;
            }
            vm.historicoAtendimentos = historicoAtendimentos;
            angular.forEach(historicoAtendimentos, function (item, index) {
                if (
                    item.sequencia === modelo.sequencia &&
                    item.codigoAtendimento === modelo.codigoAtendimento &&
                    item.anoAtendimento === modelo.anoAtendimento
                ) {
                    selecionarHistoricoAtendimento(index, item);
                }
            });
        }

        /**
         * Método que recebi um ou mais usuarios e seta estes usuarios na variavel 'vm.atendimentoAcompanhamentosVisualizacao' em memória para
         * ser persistido posterioremente quando o atendimento for inserido
         * @param {usuarios} usuarios
         */
        function inserirUsuariosHaVisualizarAtendimentoEmMemoria(usuarios) {
            // Redefini as configurações inicia da variável
            atendimentoAcompanhamentosVisualizacaoEmMemoria = [];
            for (i = 0; i < usuarios.length; i++) {
                atendimentoAcompanhamentosVisualizacaoEmMemoria.push({
                    codigoUsuario: usuarios[i].codigo,
                });
            }
            vm.atendimentoAcompanhamentosVisualizacao = usuarios;
        }

        function definirAcompanhanteNovoAtendimento() {
            vm.acompanhantesAtendimento.push({
                codigoAtendimento: vm.atendimento.codigo,
                anoAtendimento: vm.atendimento.ano,
                codigoUsuario: vm.usuarioLogado.codigoUsuario,
                usuario: vm.usuarioLogado.usuario,
                visualizado: true,
            });
        }

        /**
         * Requisição para buscar os historicos do atendimento
         */
        function pesquisarHistoricoAtendimento(
            codigoAtendimento,
            anoAtendimento
        ) {
            AtendimentoService.atendimentoPesquisarHistoricoAtendimento(
                codigoAtendimento,
                anoAtendimento,
                vm.controleForm
            ).then(
                function (success) {
                    if (success.length > 0) {
                        vm.historicoAtendimentos = success;
                        vm.historicoAtendimentoSelecionado =
                            success[0].descricao;
                        vm.informacoesHistoricoAtendimentoSelecionado =
                            success[0];
                        vm.indexHistoricoAtendimento = 0;
                    }
                },
                function (err) {
                    vm.historicoAtendimentos = [];
                    vm.historicoAtendimentoSelecionado = "";
                    vm.informacoesHistoricoAtendimentoSelecionado = undefined;
                    vm.indexHistoricoAtendimento = 0;
                }
            );
            recarregarMotivosAtendimentos(vm.atendimento.codigoUsuario);
        }

        /**
         * Requisição para buscasr os acompanhantes do atendimento, sempré colocando o status do colaborador corrente para visualizado quando
         * ele estiver vinculado ao Acompanhanamento do Atendimento
         */
        function atualizarAcompanhantesAtendimento(
            codigoAtendimento,
            anoAtendimento,
            visualizado
        ) {
            AtendimentoService.atualizarAcompanhamentoAtendimentoUsuario(
                codigoAtendimento,
                anoAtendimento,
                vm.usuarioLogado.codigoUsuario,
                vm.controleForm,
                visualizado
            ).then(
                function (success) {
                    vm.acompanhantesAtendimento = success.resultado;
                },
                function (error) {
                    MdDialogService.alertPadrao(error.data);
                }
            );
        }

        function pesquisarAcompanhantesAtendimento(
            codigoAtendimento,
            anoAtendimento
        ) {
            AtendimentoService.atendimentoPesquisarAcompanhantesAtendimento(
                codigoAtendimento,
                anoAtendimento,
                vm.controleForm
            ).then(
                function (success) {
                    vm.acompanhantesAtendimento = success;
                    definirUsuarioVisualizouAtendimento(
                        vm.acompanhantesAtendimento
                    );
                    definirUsuarioMarcouComoImportante(
                        vm.acompanhantesAtendimento
                    );
                },
                function (error) {
                    MdDialogService.alertPadrao(error);
                }
            );
        }

        function definiriSigiloComercialAtendimento() {
            if (vm.usuarioLogado.tipoAtendimento == 2) {
                if (vm.controleForm) {
                    vm.controleForm.preLoaderToolbar.inicioProgresso();
                }
                RequisicaoGenericaService.listarComParams(
                    Api.atendimento.usuario_ha_visualizar_atendimento
                        .vincularUsuariosComTipoAtendimentoComercialEmMemoria,
                    null
                ).then(
                    function (success) {
                        if (vm.controleForm) {
                            vm.controleForm.preLoaderToolbar.fimProgresso();
                        }

                        inserirUsuariosHaVisualizarAtendimentoEmMemoria(
                            success.data
                        );
                        vm.atendimento.sigiloComercial = true;
                        vm.requisicaoSolicitada = false;
                    },
                    function (error) {
                        if (vm.controleForm) {
                            vm.controleForm.preLoaderToolbar.fimProgresso();
                        }

                        MdToastService.toastPadrao(error.data, true);
                    }
                );
            }
        }

        function definirUsuarioVisualizouAtendimento(acompanhantesAtendimento) {
            var index = acompanhantesAtendimento
                .map(function (item) {
                    return item.codigoUsuario;
                })
                .indexOf(LoginUsuarioService.usuarioArmazenado().codigo);
            if (index != -1) {
                vm.usuarioVinculadoAoAtendimento = true;
                vm.usuarioVisualizouAtendimento =
                    acompanhantesAtendimento[index].visualizado;
            } else {
                vm.usuarioVinculadoAoAtendimento = false;
            }
        }

        function definirUsuarioMarcouComoImportante(acompanhantesAtendimento) {
            var index = acompanhantesAtendimento
                .map(function (item) {
                    return item.codigoUsuario;
                })
                .indexOf(LoginUsuarioService.usuarioArmazenado().codigo);
            if (index != -1) {
                vm.usuarioVinculadoAoAtendimento = true;
                vm.atendimentoImportante = acompanhantesAtendimento[index]
                    .importante
                    ? true
                    : false;
            } else {
                vm.usuarioVinculadoAoAtendimento = false;
            }
        }
        // endregion

        // Métodos Geral region

        /**
         * $watch para sempre irá buscar o HistoricoAtendimentos e os Acompanhantes quando o Atendimento mudar
         */
        $scope.$watch("vm.atendimento", function (newValue, oldValue) {
            if (
                newValue &&
                newValue.codigo &&
                newValue.ano &&
                !newValue.chamarPesquisa
            ) {
                vm.copiaHistoricoAtendimento =
                    AtendimentoFactory.historicoAtendimento;
                pesquisarHistoricoAtendimento(newValue.codigo, newValue.ano);
                _verificarExistePendenciaAtualizacaoCliente(
                    newValue.codigoCliente
                );
                pesquisarAcompanhantesAtendimento(
                    newValue.codigo,
                    newValue.ano
                );
                ajustarExibicaoOrdensServicoAtendimento(newValue);
                _listarTagsVinculadasSolucao(
                    newValue.codigoSolucao
                );
            }
            if (moduloAtendimentoEmAberto) {
                AtendimentoService.atendimentosEmAbertoAtualizarArraysDeAtendimentoEmAberto(
                    vm.atendimentos
                );
            }
        });

        /**
         * Função para inicialiar setar valores iniciais no objeto "vm.atendimento"
         */
        function init() {
            vm.historicoAtendimentos = [];
            vm.acompanhantesAtendimento = [];
            vm.indexHistoricoAtendimento = null;
            vm.historicoAtendimentoSelecionado = "";
            vm.informacoesHistoricoAtendimentoSelecionado = {};

            vm.ordensServicos = "";

            vm.atendimento = {
                usuario: vm.usuarioLogado.usuario,
                emitirAlerta: true,
                tags: [],
            };

            /**
             * Os campos cliente e codigoCliente serão definidos quando houver a navegação do cliente para o atendimento
             * já iniciando o atendimento com a inserção de um novo cliente
             */
            if (vm.iniciarAtendimentoInserindoNovoAtendimento) {
                vm.atendimento.cliente = $stateParams.parametros.cliente;
                vm.atendimento.codigoCliente =
                    $stateParams.parametros.codigoCliente;
            }
        }

        /**
         * Método chamado quando o button nova pesquisar da diretiva "toolbar-mobile-desktop" é pressionado
         */
        function novaPesquisa() {
            init();
        }

        /**
         * Método para pré-definir valores iniciais nos campos do "vm.atendimento" quando for realizado uma inserção
         */
        function preDefinirCamposParaInserir() {
            vm.solicitacao = {};
            _limparSolicitacoes();
            vm.usuariosAtivos = angular.copy(vm.usuariosAtivosBkp);
            if (vm.controleForm) {
                vm.controleForm.preLoaderToolbar.inicioProgresso();
            }
            RequisicaoGenericaService.listarSemParams(
                Api.atendimento.listarAtendimentosComDataVencida +
                vm.usuarioLogado.codigoUsuario
            ).then(
                function (success) {
                    if (vm.controleForm) {
                        vm.controleForm.preLoaderToolbar.fimProgresso();
                    }
                    init();

                    vm.atendimento.tipo = vm.usuarioLogado.tipoAtendimento;
                    vm.atendimento.codigoUsuario =
                        vm.usuarioLogado.codigoUsuario;
                    vm.atendimentoAcompanhamentosVisualizacao =
                        ListarTodosUsuariosAtivos.data;
                    inserirUsuariosHaVisualizarAtendimentoEmMemoria(
                        ListarTodosUsuariosAtivos.data
                    );

                    // Defini como Acompanhante principal do atendimento o usuario logado
                    definirAcompanhanteNovoAtendimento();

                    // Defini se o atendimento terá sigilo comercial ou não
                    definiriSigiloComercialAtendimento();
                },
                function (error) {
                    if (vm.controleForm) {
                        vm.controleForm.preLoaderToolbar.fimProgresso();
                    }

                    var mensagemAtendimentosVencidos =
                        AtendimentoService.atendimentoCriarMensagemAtendimentosVencidos(
                            error.data
                        );

                    MdDialogService.alertPadrao(
                        "Atendimentos Vencidos !",
                        null,
                        mensagemAtendimentosVencidos
                    );
                    vm.controleForm.reverter(false);
                }
            );
        }

        /**
         * Método para pré-definir valores iniciais nos campos do "vm.atendimento" quando for realizado uma edição do atendimento
         */
        function preDefinirCamposParaEditar() {
            vm.codigoAtendimentoMotivoBkp =
                vm.atendimento.codigoAtendimentoMotivo;
            if (
                AtendimentoService.verificarExistenciaClientePendencia(
                    vm.atendimento.cliente
                )
            )
                AtendimentoService.abrirDialogClientePendencia(
                    vm.atendimento.cliente
                );
            _listarAcompanhantesAtendimento(vm.atendimento);
        }

        function _listarAcompanhantesAtendimento(atendimento) {
            RequisicaoGenericaService.listarSemParams(
                Api.atendimento.usuario_ha_visualizar_atendimento
                    .listarAcompanhamentoVisualizacaoPorAtendimento +
                atendimento.codigo +
                "/" +
                atendimento.ano
            ).then(function (success) {
                vm.usuariosAtivos = success.data.filter(function (usuario) {
                    return vm.usuariosAtivosBkp.some(function (usuarioAtivo) {
                        return usuarioAtivo.codigo === usuario.codigo;
                    });
                });

                var usuarioExiste = vm.usuariosAtivos.some(function (usuario) {
                    return usuario.codigo === atendimento.usuario.codigo;
                });

                if (!usuarioExiste) {
                    vm.usuariosAtivos.push(atendimento.usuario);
                }
            });
        }

        /**
         * Método sempre chamando quando for clicado no botão reverter
         */
        function redefinirCampos() {
            vm.iniciarAtendimentoInserindoNovoAtendimento = false;
            vm.solicitacao = vm.solicitacaoBkp;
        }

        function _abrirDialogCadastrarAtividade(event) {
            if (!vm.usuarioLogado || !vm.atendimento) return;

            var statusEmAberto = vm.atendimento.status == 1;

            if (!statusEmAberto) return;
            if (vm.atendimento.dataPrevisaoFechamento) {
                var dataPrevisao = new Date(vm.atendimento.dataPrevisaoFechamento);
                var hoje = new Date();
                dataPrevisao.setHours(0, 0, 0, 0);
                hoje.setHours(0, 0, 0, 0);
                if (dataPrevisao < hoje) return;
            }

            var usuarioSetorComercial =
                vm.usuarioLogado.usuario &&
                vm.usuarioLogado.usuario.codigoSetor == 5;

            var usuarioLogado = LoginUsuarioService.usuarioArmazenado();

            var atividade = {
                usuarioAtivo: {
                    codigo: usuarioLogado.codigo,
                    nome: usuarioLogado.nome
                },
                atendimento: {
                    codigo: vm.atendimento.codigo,
                    ano: vm.atendimento.ano,
                    status: vm.atendimento.status
                }
            };

            if (usuarioSetorComercial) {
                VisualizarAtividadeService.abrirCadastroAtividadeObrigatorio(
                    event || null,
                    atividade,
                    ListarTodosEventos,
                    ListarStatusAtividade,
                    vm.atendimento.cliente
                );
            } else {
                var confirm = $mdDialog.confirm()
                    .title('Atenção!')
                    .textContent('Deseja cadastrar uma nova atividade?')
                    .ariaLabel('Atenção!')
                    .ok('Sim')
                    .cancel('Não')
                    .targetEvent(event);

                $mdDialog.show(confirm).then(function () {
                    VisualizarAtividadeService.abrirCadastroAtividade(
                        event || null,
                        atividade,
                        ListarTodosEventos,
                        ListarStatusAtividade,
                        false,
                        false,
                        vm.atendimento.cliente
                    );
                }, function () {
                });
            }
        }
        // endregion

        // Métodos region

        /**
         * Método para pesquisar os atendimentos
         */
        function pesquisar() {
            vm.copiaHistoricoAtendimento =
                AtendimentoFactory.historicoAtendimento;

            /**
             * Verifica se existe a entidade de pesquisa e exclui os objetos do complexo da entidade de pesquisa
             * pois os mesmos não são necessários enviar para api para realização da consulta
             */
            if (vm.controleForm && vm.controleForm.entidadesPesquisadas) {
                delete vm.controleForm.entidadesPesquisadas.usuario;
                delete vm.controleForm.entidadesPesquisadas.cliente;
                delete vm.controleForm.entidadesPesquisadas.solucao;
                delete vm.controleForm.entidadesPesquisadas.atendimentoMotivo;
                delete vm.controleForm.entidadesPesquisadas
                    .atendimentoPendencia;
                delete vm.controleForm.entidadesPesquisadas
                    .atendimentoConclusao;
            }

            /**
             * if que contem o Método que será chamado quando a tela for de atendimentos não visualizados
             * este método iniciará a tela já realizando uma requisição para Api para listar todos os atendimentos não visualizados do usuário corrente
             */
            if (vm.atendimento.listarAtendimentosPendentes) {
                return AtendimentoService.atendimentoPesquisarAtendimentosNaoVisualizados(
                    vm.usuarioLogado.codigoUsuario
                );
            } else if (vm.atendimento.listarAtendimentosImportantes) {
                return AtendimentoService.atendimentoPesquisarAtendimentosImportantes(
                    vm.usuarioLogado.codigoUsuario
                );
            } else if (vm.atendimento.listarTodosAtendimentosEmAberto) {
                /**
                 * else if que contém o Método que será chamado quando o modulo for atendimentos em aberto
                 * Já iniciando na tela de listagem de todos atendimentos do modulo atendimentos em aberto
                 */
                if (typeof usuariosHaListarAtendimentosEmAberto == "number") {
                    return AtendimentoService.atendimentoPesquisarAtendimentosEmAbertoDoUsuario(
                        usuariosHaListarAtendimentosEmAberto
                    );
                } else {
                    return AtendimentoService.atendimentoPesquisarAtendimentosEmAbertoUsuariosPorGerente(
                        usuariosHaListarAtendimentosEmAberto
                    );
                }
            } else if (vm.atendimento.chamarPesquisa)
                /**
                 * else if que contem o Método que será chamado quando o modulo for de atendimentos não visualizados
                 * este método iniciará a tela já realizando uma requisição para Api para listar o atendimento não visualizado do usuário corrente
                 */
                return RequisicaoGenericaService.listarComParams(
                    Api.atendimento.listarPor,
                    vm.atendimento
                );
            /**
             * Caso não esteja na tela de atendimentos não visualizado o fluxo irá acontecer normalmente
             */ else {
                var result = RequisicaoGenericaService.listarComParams(
                    Api.atendimento.listarPor,
                    vm.controleForm.entidadesPesquisadas
                );

                result.then(
                    function (sucess) {
                        if (sucess.data[0].codigoSolucao)
                            _listarTagsVinculadasSolucao(
                                sucess.data[0].codigoSolucao
                            );
                        var usuarioResponsavel = sucess.data[0].usuario;
                        recarregarMotivosAtendimentos(
                            usuarioResponsavel.codigo
                        );
                        var temNaLista = false;
                        if (usuarioResponsavel != null) {
                            vm.usuariosAtivos.forEach(function (item) {
                                if (item.codigo == usuarioResponsavel.codigo) {
                                    temNaLista = true;
                                }
                            });

                            if (!temNaLista) {
                                vm.usuariosAtivos.push(usuarioResponsavel);
                            }
                        }
                        _verificarExistePendenciaAtualizacaoCliente(
                            sucess.data[0].codigoCliente
                        );
                        vm.informacoesParaEditarHistorico = {
                            PesquisarAcompanhantesAtendimento:
                                pesquisarAcompanhantesAtendimento,
                            RecarregarHistoricoAtendimento:
                                recarregarHistoricoAtendimento,
                            SelecionarHistoricoAtendimento:
                                selecionarHistoricoAtendimento,
                            HistoricoAtendimentos: vm.historicoAtendimentos,
                            CopiaHistoricoAtendimento:
                                vm.copiaHistoricoAtendimento,
                            CodigoAtendimento: vm.atendimento.codigo,
                            AnoAtendimento: vm.atendimento.ano,
                            Cliente: sucess.data[0].codigoCliente
                                ? sucess.data[0].codigoCliente
                                : null,
                            ColaboradorCorrente: vm.usuarioLogado,
                            ControleForm: vm.controleForm,
                            CriarAtendimento: criarAtendimento,
                            VisualizaTempoTecnico:
                                vm.usuarioLogado.visualizarTempoTecnico,
                            AlterarDataUltimoAtendimento:
                                alterarDataUltimoAtendimento,
                            EventosAtividade: ListarTodosEventos,
                            StatusAtividade: ListarStatusAtividade,
                            UltimaDataHistoricoAtendimento:
                                vm.atendimento.ultimaDataHistoricoAtendimento,
                        };
                    },
                    function (error) { }
                );
                return result;
            }
        }

        /**
         * Método para salvar um novo Atendimento
         * @param {*Atendimento} modelo
         */
        function salvar(modelo) {
            /**
             *  Verifica se existe pelo menos um histórico do atendimento vinculado,
             *  se existir cria uma entidadePara envio com o atendimento e o historico e envia para Api
             */
            if (angular.equals(vm.historicoAtendimentos, [])) {
                MdDialogService.alertPadraoComEvento(
                    "Atenção!",
                    abrirDialogHistorico,
                    null,
                    "É necessário inserir um histórico de atendimento para cadastrar um atendimento."
                );
            } else {
                AtendimentoService.setarValoresParaSalvarEEditar(
                    modelo,
                    ListarTodosAtendimentosConclusao.data[0].codigo
                );
                var modeloParaEnvio = {
                    atendimento: modelo,
                    historicoAtendimentos: vm.historicoAtendimentos,
                    acompanhantesAtendimento: vm.acompanhantesAtendimento,
                    atendimentoAcompanhamentosVisualizacao:
                        atendimentoAcompanhamentosVisualizacaoEmMemoria,
                };
                vm.controleForm.preLoaderToolbar.inicioProgresso();
                RequisicaoGenericaService.salvar(
                    Api.atendimento.criar,
                    modeloParaEnvio
                ).then(
                    function (success) {
                        MdToastService.toastPadrao(
                            "Registro cadastrado com sucesso."
                        );
                        _verificarExistePendenciaAtualizacaoCliente(
                            success.data.resultado.codigoCliente
                        );
                        vm.atendimentos.push(success.data.resultado);
                        vm.atendimento = success.data.resultado;
                        vm.controleForm.atualizarIndice.atualizarIndiceParaUltimaPosicao();

                        vm.controleForm.preLoaderToolbar.fimProgresso();
                        vm.controleForm.reverter(true);

                        if (success.data.mensagem)
                            MdDialogService.alertPadrao(
                                "Aviso:",
                                null,
                                success.data.mensagem
                            );
                        _abrirDialogCadastrarAtividade();
                    },
                    function (error) {
                        MdDialogService.alertPadrao(error.data, event);
                        vm.controleForm.preLoaderToolbar.fimProgresso();
                    }
                );
            }
        }

        /**
         * Método para editar um Atendimento
         * @param {*Atendimento} modelo
         */
        function editar(modelo) {
            AtendimentoService.setarValoresParaSalvarEEditar(
                modelo,
                ListarTodosAtendimentosConclusao.data[0].codigo
            );
            return RequisicaoGenericaService.editar(
                Api.atendimento.atualizar,
                modelo
            );
        }

        /**
         * Método para excluir um Atendimento
         * @param {*Atendimento} modelo
         */
        function excluir(modelo) {
            return RequisicaoGenericaService.excluir(
                Api.atendimento.excluir,
                modelo.codigo + "/" + modelo.ano
            );
        }

        /**
         * Método utilizado para selecionar um Atendimento quando a exibição em modo lista está ativo
         * @param {*Atendimento} modelo
         */
        function selecionar(modelo) {
            vm.controleForm.listarTodas(vm.atendimentos.indexOf(modelo));
            vm.atendimento = modelo;
            vm.pesquisar = "";
        }

        /**
         * Método que realiza uma requisição para api para buscar os clientes em tempo de pesquisa,
         * com base no que o usuário está digitando
         * @param {*query de pesquisa} query
         */
        function pesquisarAutoCompleteCliente(query) {
            return ServicosGenericoService.pesquisarAutoCompleteCodigoOuNomeGenericoApi(
                Api.cliente.listarCodigoDescricao,
                query
            );
        }

        /**
         * Método que exibi uma lista de Motivos de Atendimento e irá filtrar está lista
         * quando o usuario for digitando
         * @param {query} query texto de pesquisa
         */
        function pesquisarAutoCompleteAtendimentoMotivo(query) {
            return AtendimentoService.atendimentoPesquisarAtendimentoMotivoAutoComplete(
                query,
                vm.motivosAtendimento
            );
        }

        /**
         * Método que controla qual cliente está selecionado no campo md-auto-complete do Cliente
         * @param {*cliente} item
         */
        function alterarItemSelecionadoAutoCompleteCliente(item) {
            if (item) {
                vm.atendimento.codigoCliente = item.codigo;

                if (
                    vm.controleForm.inserirAtivo ||
                    vm.controleForm.editarAtivo
                ) {
                    if (
                        AtendimentoService.verificarExistenciaClientePendencia(
                            item
                        )
                    )
                        AtendimentoService.abrirDialogClientePendencia(item);
                }
            } else {
                vm.textoDePesquisaAutoCompleteCliente = "";

                vm.atendimento.codigoCliente = null;
                vm.atendimento.cliente = null;
            }
            listarTodasSolicitacoesCliente(item ? item.codigo : null);
        }

        /**
         * Método que controla qual motivoAtendimento está selecionado no campo md-auto-complete do Motivo de Atendimento
         * @param {motivoAtendimento} item
         */
        function alterarItemSelecionadoAutoCompleteAtendimentoMotivo(item) {
            if (item) {
                if (
                    vm.controleForm.editarAtivo &&
                    item.codigo ==
                    vm.codigoAtendimentoMotivoPermiteSolicitacao &&
                    vm.atendimento.codigoAtendimentoMotivo !=
                    vm.codigoAtendimentoMotivoPermiteSolicitacao &&
                    vm.usuarioLogado.codigoUsuario !=
                    vm.atendimento.codigoUsuario
                ) {
                    vm.atendimento.atendimentoMotivo =
                        vm.motivosAtendimento.find(function (atendimento) {
                            return (
                                atendimento.codigo ==
                                vm.codigoAtendimentoMotivoBkp
                            );
                        });
                    MdDialogService.alertPadrao(
                        "",
                        null,
                        "<h2>Só é possível alterar o motivo do atendimento para Análise de Solicitação se o atendimento estiver vinculado ao seu usuário.</h2>"
                    );
                    return;
                }
                vm.atendimento.codigoAtendimentoMotivo = item.codigo;
            } else {
                vm.textoDePesquisaAutoCompleteAtendimentoMotivo = "";
                vm.atendimento.codigoAtendimentoMotivo = null;
                vm.atendimento.atendimentoMotivo = null;
            }
            listarTodasSolicitacoesCliente(vm.atendimento.codigoCliente);
        }

        /**
         * Método que limpa o texto de pesquisa do md-auto-complete do Cliente
         */
        function configuraAutoCompleteClienteOnBlur() {
            /**
             * O texto sempre é limpado quando o campo md-auto-complete do Cliente é fechado e o
             * valor do cliente "vm.atendimento.cliente" é vazio
             */
            if (!vm.atendimento.cliente) {
                vm.textoDePesquisaAutoCompleteCliente = "";
            }
        }

        /**
         * Método que limpa o texto de pesquisa do md-auto-complete do Atendimento Motivo
         */
        function configuraAutoCompleteAtendimentoMotivoOnBlur() {
            /**
             * O texto sempre é limpado quando o campo md-auto-complete do Atendimento Motivo é fechado e o
             * valor do Atendimento Motivo "vm.atendimento.atendimentoMotivo" é vazio
             */
            if (!vm.atendimento.atendimentoMotivo) {
                vm.textoDePesquisaAutoCompleteAtendimentoMotivo = "";
            }
        }

        /**
         * Método para configurar o md-header do md-select do campo colaborador responsável
         */
        function configuraMdSelectUsuarioAtivo() {
            vm.filtrarUsuariosAtivo = "";
            angular
                .element("#atendimento-usuarios-ativos-md-select")
                .on("keydown", function (ev) {
                    ev.stopPropagation();
                });
        }

        /**
         * método para configurar md-header do md-select da Solução
         */
        function configuraMdSelectSolucao() {
            vm.filtrarSolucoes = "";
            angular
                .element("#atendimento-solucao-md-select")
                .on("keydown", function (ev) {
                    ev.stopPropagation();
                });
        }

        /**
         * método para configurar md-header do md-select do Motivo do Atendimento
         */
        function configuraMdSelectMotivoAtendimento() {
            vm.filtrarMotivoAtendimento = "";
            angular
                .element("#atendimento-motivo-atendimento-md-select")
                .on("keydown", function (ev) {
                    ev.stopPropagation();
                });
        }

        /**
         * método chamado quando o o status atendimento é modificado
         */
        function limparCamposVinculadoStatusAtendimento(status) {
            if (status == 2) {
                vm.atendimento.dataPrevisaoFechamento = null;
                vm.atendimento.codigoAtendimentoPendencia = null;
            } else {
                vm.atendimento.codigoAtendimentoConclusao = null;
            }
        }

        /**
         * Método que que controla o index e a descrição do HistoricoAtendimento que está selecionado
         * @param {*index selecionado da lista de historico atendimentos} index
         * @param {*historicoAtendimento selecionado} historico
         * @param {*boolean para verifica se é pra limpar a descricao do HistoricoAtendimento} limparDescricaoHistoricoSituacao
         */
        function selecionarHistoricoAtendimento(
            index,
            historico,
            limparDescricaoHistoricoSituacao
        ) {
            if (limparDescricaoHistoricoSituacao) {
                vm.historicoAtendimentoSelecionado = "";
                vm.informacoesHistoricoAtendimentoSelecionado = {};
                vm.indexHistoricoAtendimento = -1;
            } else {
                vm.historicoAtendimentoSelecionado = historico.descricao;
                vm.informacoesHistoricoAtendimentoSelecionado = historico;
                vm.indexHistoricoAtendimento = index;
            }
            vm.modoTabelaAtivo = false;
        }

        /**
         * Método que abri o dilog para cadastrar ou alterar um Historico do Atendimento
         * @param {*event do button} event
         * @param {*historiAtendimento selecionado} historicoAtendimento
         */
        function abrirDialogHistorico(event, historicoAtendimento, index) {
            var podeEditarUltimoHistorico = false;
            if (!historicoAtendimento) {
                podeEditarUltimoHistorico = true;
            } else if (
                vm.atendimento.ultimaDataHistoricoAtendimento ==
                historicoAtendimento.data &&
                historicoAtendimento.usuario.codigo ==
                vm.usuarioLogado.codigoUsuario
            ) {
                podeEditarUltimoHistorico = true;
            }

            var metodoInterno = function () {
                $mdDialog
                    .show({
                        controller: "AtendimentoDialogHistoricoController",
                        controllerAs: "vm",
                        templateUrl: vm.rotasHtml.dialogHistorico,
                        //parent: ---------------,
                        targetEvent: event,
                        clickOutsideToClose: false,
                        locals: {
                            Index: index,
                            PesquisarAcompanhantesAtendimento:
                                pesquisarAcompanhantesAtendimento,
                            RecarregarHistoricoAtendimento:
                                recarregarHistoricoAtendimento,
                            SelecionarHistoricoAtendimento:
                                selecionarHistoricoAtendimento,
                            HistoricoAtendimentos: vm.historicoAtendimentos,
                            HistoricoAtendimento: historicoAtendimento,
                            CopiaHistoricoAtendimento:
                                vm.copiaHistoricoAtendimento,
                            CodigoAtendimento: vm.atendimento.codigo,
                            AnoAtendimento: vm.atendimento.ano,
                            Cliente: vm.atendimento.cliente
                                ? vm.atendimento.cliente
                                : null,
                            ColaboradorCorrente: vm.usuarioLogado,
                            ControleForm: vm.controleForm,
                            CriarAtendimento: criarAtendimento,
                            VisualizaTempoTecnico:
                                vm.usuarioLogado.visualizarTempoTecnico,
                            EditarHistorico: podeEditarUltimoHistorico,
                            AlterarDataUltimoAtendimento:
                                alterarDataUltimoAtendimento,
                            EventosAtividade: ListarTodosEventos,
                            StatusAtividade: ListarStatusAtividade,
                        },
                    })
                    .then(function (data) {
                        if (data) {
                            vm.copiaHistoricoAtendimento = data;
                        } else {
                            vm.copiaHistoricoAtendimento =
                                AtendimentoFactory.historicoAtendimento;
                        }
                    });
            };

            if (
                AtendimentoService.verificarExistenciaClientePendencia(
                    vm.atendimento.cliente
                )
            )
                AtendimentoService.abrirDialogClientePendencia(
                    vm.atendimento.cliente,
                    function () {
                        metodoInterno();
                    }
                );
            else metodoInterno();
        }

        /**
         * Método que abri o dilog para visualizar excluir ou inseir Um novo Colaborador Acompanhante no Atendimento
         * @param {*event do button} event
         */
        function abrirDialogColaboradoresHaNotificar(event) {
            var metodoInterno = function () {
                $mdDialog.show({
                    controller: "AtendimentoDialogAcompanhantesController",
                    controllerAs: "vm",
                    templateUrl: vm.rotasHtml.dialogAcompanhantes,
                    //parent: ---------------,
                    targetEvent: event,
                    clickOutsideToClose: false,
                    locals: {
                        ControleForm: vm.controleForm,
                        CodigoAtendimento: vm.atendimento.codigo,
                        AnoAtendimento: vm.atendimento.ano,
                        CodigoUsuarioLogado: vm.usuarioLogado.codigoUsuario,
                        AcompanhantesAtendimento: vm.acompanhantesAtendimento,
                        DefinirUsuarioVisualizouAtendimento:
                            definirUsuarioVisualizouAtendimento,
                        DefinirUsuarioMarcouComoImportante:
                            definirUsuarioMarcouComoImportante,
                    },
                });
            };

            if (
                AtendimentoService.verificarExistenciaClientePendencia(
                    vm.atendimento.cliente
                )
            )
                AtendimentoService.abrirDialogClientePendencia(
                    vm.atendimento.cliente,
                    function () {
                        metodoInterno();
                    }
                );
            else metodoInterno();
        }

        /**
         * Método que abri o dilog para visualizar excluir ou inseir Um novo Colaborador que poderá
         * visualizar o atendimento
         * @param {evenButton} event
         */
        function abrirDialogColaboradoresHaVisualizar(event) {
            var metodoInterno = function () {
                $mdDialog.show({
                    controller:
                        "AtendimentoDialogUsuariosHaVisualizarController",
                    controllerAs: "vm",
                    templateUrl:
                        vm.rotasHtml.dialogUsuariosHaVisualizarAtendimento,
                    //parent: ---------------,
                    targetEvent: event,
                    clickOutsideToClose: false,
                    locals: {
                        ControleForm: vm.controleForm,
                        Atendimento: vm.atendimento,
                        UsuarioLogado: vm.usuarioLogado,
                        AtendimentoAcompanhamentosVisualizacao:
                            vm.atendimentoAcompanhamentosVisualizacao,
                        InserirUsuariosHaVisualizarAtendimentoEmMemoria:
                            inserirUsuariosHaVisualizarAtendimentoEmMemoria,
                        PesquisarAcompanhantesAtendimento:
                            pesquisarAcompanhantesAtendimento,
                        SquadUsuarioLogado: vm.squadUsuarioLogado,
                    },
                });
            };

            if (
                AtendimentoService.verificarExistenciaClientePendencia(
                    vm.atendimento.cliente
                )
            )
                AtendimentoService.abrirDialogClientePendencia(
                    vm.atendimento.cliente,
                    function () {
                        metodoInterno();
                    }
                );
            else metodoInterno();
        }

        function abrirDialogAnexoArquivos(event) {
            var metodoInterno = function () {
                $mdDialog.show({
                    controller: "AtendimentoDialogAnexoArquivosController",
                    controllerAs: "vm",
                    templateUrl: vm.rotasHtml.dialogAnexoArquivos,
                    //parent: ---------------,
                    targetEvent: event,
                    clickOutsideToClose: false,
                    locals: {
                        ControleForm: vm.controleForm,
                        Atendimento: vm.atendimento,
                    },
                });
            };

            if (
                AtendimentoService.verificarExistenciaClientePendencia(
                    vm.atendimento.cliente
                )
            )
                AtendimentoService.abrirDialogClientePendencia(
                    vm.atendimento.cliente,
                    function () {
                        metodoInterno();
                    }
                );
            else metodoInterno();
        }

        function implementarVoltarParaOEstadoAnteriorHeaderPadrao() {
            if (vm.habilitarIconeVoltarATelaConsultaAtendimentosHeaderPadrao) {
                MenuFactory.navegarParaEstadoSeUsuarioTerAcesso(
                    "app.atendimento_consulta_atendimento",
                    {
                        parametros: {
                            iniciarListandoAtendimentosConsultadoTemporaria: true,
                        },
                    }
                );
            }
        }

        /**
         * Método que quando chamado chama o método da toolbar para inserir um registro
         */
        function criarAtendimento() {
            vm.metodosExternos.metodoAcaoExternoCriar();
        }

        function alterarDataUltimoAtendimento() {
            if (vm.historicoAtendimentos.length <= 0) return;

            var ultimoAtendimeto = vm.historicoAtendimentos[0];

            if (!ultimoAtendimeto) return;

            vm.atendimento.ultimaDataHistoricoAtendimento =
                ultimoAtendimeto.data;
        }

        function marcarComoImportante(codigoAtendimento, anoAtendimento) {
            vm.atendimentoImportante = !vm.atendimentoImportante;
            AtendimentoService.atualizarImportanciaAtendimentoUsuario(
                codigoAtendimento,
                anoAtendimento,
                vm.usuarioLogado.codigoUsuario,
                vm.controleForm,
                vm.atendimentoImportante
            ).then(
                function (success) {
                    vm.acompanhantesAtendimento = success.resultado;
                    definirUsuarioMarcouComoImportante(
                        vm.acompanhantesAtendimento
                    );
                },
                function (error) {
                    MdDialogService.alertPadrao(error.data);
                }
            );
        }

        function atualizarVisualizacaoAcompanhamentoUsuario(
            codigoAtendimento,
            anoAtendimento,
            usuarioVisualizouAtendimento
        ) {
            atualizarAcompanhantesAtendimento(
                codigoAtendimento,
                anoAtendimento,
                usuarioVisualizouAtendimento
            );
        }
        // endregion

        // region Region para o modulo/tela de atendimentos não visualizados e atendimentos em aberto

        //////////////////////////////// Métodos Modulo Atendimento Em Aberto ///////////////////////////////
        var moduloAtendimentosNaoVisualizados = false;
        /////////////////////////////////////////////////////////////////////////////////////////////////////

        //////////////////////////////// Métodos Modulo Atendimento Em Aberto ///////////////////////////////
        var usuariosHaListarAtendimentosEmAberto;
        vm.legendasAtendimentosEmAberto =
            AtendimentoFactory.setLegendasCoresAtendimentosEmAberto();
        vm.legendaSelecionadaAtendimentosEmAberto = null;
        var moduloAtendimentoEmAberto = false;
        var moduloAtendimentosImportantes = false;

        var metodosInternoModuloAtendimentoEmAberto = {
            listarAtendimentosEmAbertoUsuarioSelecionado:
                listarAtendimentosEmAbertoUsuarioSelecionado,
        };
        vm.metodosModuloAtendimentoEmAberto = {
            abrirDialogUsuariosComAtendimentosEmAbertoSetor:
                abrirDialogUsuariosComAtendimentosEmAbertoSetor,
            filtrarTabelaAtendimentosEmAberto:
                filtrarTabelaAtendimentosEmAberto,
        };

        /**
         * Método interno que chama a função pesquisar da toolbar listando todos os atendimentos em aberto
         * do usuário passado como parâmetro
         * @param {codigoUsuario} codigoUsuario
         */
        function listarAtendimentosEmAbertoUsuarioSelecionado(modelo) {
            vm.atendimento = { listarTodosAtendimentosEmAberto: true };
            usuariosHaListarAtendimentosEmAberto = modelo;
            vm.controleForm.pesquisa.chamarPesquisar();
        }

        function _carregarAtividadesCliente(callback) {
            vm.atividadesCliente = null;
            if (!vm.atendimento.cliente.codigo) return;

            vm.carregandoAtividades = true;
            vm.controleForm.emProgresso = true;

            VisualizarAtividadeService.listarAtividadesCliente(
                vm.atendimento.cliente.codigo,
                function (success) {
                    vm.controleForm.emProgresso = false;
                    vm.carregandoAtividades = false;
                    vm.atividadesCliente = success.data;
                    if (callback) callback();
                },
                function (error) {
                    vm.controleForm.emProgresso = false;
                    vm.carregandoAtividades = false;
                }
            );
        }

        $rootScope.$on("atividadeCadastrada", function (event, atividade) {
            _carregarAtividadesCliente(null);
        });

        $rootScope.$on("atividadeReagendada", function (event, atividade) {
            _carregarAtividadesCliente(null);
        });

        $scope.$on("exibirTabelaHistoricos", function () {
            vm.modoTabelaAtivo = true;
        });

        $scope.$on("formAlterado", function () {
            vm.form.atendimento.$setDirty();
        });

        function abrirDialogAgenda(event) {
            vm.controleForm.emProgresso = true;
            _carregarAtividadesCliente(function () {
                VisualizarAtividadeService.abrirDialogAtividade(
                    event,
                    vm.atendimento.cliente,
                    ListarStatusAtividade,
                    ListarTodosEventos,
                    vm.atividadesCliente,
                    vm.atendimento,
                    function () {
                        vm.controleForm.emProgresso = false;
                    },
                    ListarDetalhesUsuario
                );
            });
        }

        /**
         * Método que abre o dialog para pesquisar os atendimentos dos usuários do setor
         * @param {eventButton} event
         */
        function abrirDialogUsuariosComAtendimentosEmAbertoSetor(event) {
            AtendimentoService.atendimentosEmAbertoLimparArraysAtendimentosEmAbertoParaNovaPesquisa();
            $mdDialog.show({
                controller:
                    "AtendimentoDialogUsuariosComAtendimentoEmAbertoDoSetor",
                controllerAs: "vm",
                templateUrl:
                    vm.rotasHtml.dialogUsuariosComAtendimentosEmAbertoDoSetor,
                //parent: ---------------,
                targetEvent: event,
                clickOutsideToClose: false,
                locals: {
                    DetalhesUsuarioLogadoComUsuario: vm.usuarioLogado,
                    CodigoSetor: vm.usuarioLogado.usuario.codigoSetor,
                    SquadUsuarioLogado: ListarDetalhesUsuario.data.codigoSquads,
                    ListarAtendimentosEmAbertoUsuarioSelecionado:
                        listarAtendimentosEmAbertoUsuarioSelecionado,
                },
            });
        }

        function filtrarTabelaAtendimentosEmAberto(legenda, index) {
            if (vm.legendaSelecionadaAtendimentosEmAberto !== index) {
                vm.legendaSelecionadaAtendimentosEmAberto = index;
                AtendimentoService.atendimentosEmAbertoSelecionarArrayDePesquisa(
                    legenda
                );
            } else {
                vm.legendaSelecionadaAtendimentosEmAberto = null;
                AtendimentoService.atendimentosEmAbertoSelecionarArrayDePesquisa(
                    null
                );
            }
        }

        function configuraMdSelectSolicitacao() {
            vm.filtrarSolicitacoes = "";
            angular
                .element("#tab-atendimento-solicitacao-md-select")
                .on("keydown", function (ev) {
                    ev.stopPropagation();
                });
        }
        function configurarMdSelectSolicitacaoOnClose() {
            vm.filtrarSolicitacoes = "";
        }

        function selecionarSolicitacao(solicitacao) {
            if (solicitacao) {
                vm.atendimento.solicitacaoNumero = solicitacao.numero;
                vm.atendimento.solicitacaoAno = solicitacao.ano;
                verificarSolucaoAtendimentoSolicitacao();
            }
        }

        function _limparSolicitacoes() {
            vm.solicitacao = {};
            vm.solicitacoes = [];
            vm.ultimoCliente = 0;
            vm.atendimento.solicitacaoNumero = null;
            vm.atendimento.solicitacaoAno = null;
        }

        function listarTodasSolicitacoesCliente(clienteCodigo) {
            if (
                !clienteCodigo ||
                vm.atendimento.codigoAtendimentoMotivo !=
                vm.codigoAtendimentoMotivoPermiteSolicitacao
            ) {
                _limparSolicitacoes();
                return;
            }

            if (clienteCodigo && vm.ultimoCliente != clienteCodigo) {
                vm.requisicaoSolicitada = true;
                vm.ultimoCliente = clienteCodigo;
                vm.mensagemPreloader = "Carregando Solicitações do Cliente ...";
                RequisicaoGenericaService.listarSemParams(
                    Api.solicitacao.solicitacao.listarSolicitacoesPorCliente +
                    "/" +
                    clienteCodigo
                ).then(
                    function (success) {
                        vm.solicitacoes = success.data.map(function (item) {
                            return {
                                numero: item.numero,
                                ano: item.ano,
                                descricao:
                                    SquadService.descricaoSquad(
                                        item.squadCodigo
                                    ) +
                                    " - " +
                                    item.numero +
                                    "/" +
                                    item.ano,
                                solucaoCodigo: item.solucaoCodigo,
                                squadCodigo: item.squadCodigo,
                            };
                        });

                        vm.solicitacao = vm.solicitacoes.find(function (
                            solicitacao
                        ) {
                            return (
                                solicitacao.numero ==
                                vm.atendimento.solicitacaoNumero &&
                                solicitacao.ano == vm.atendimento.solicitacaoAno
                            );
                        });

                        if (
                            !(
                                vm.controleForm.editarAtivo ||
                                vm.controleForm.inserirAtivo
                            )
                        ) {
                            vm.solicitacaoBkp = vm.solicitacao;
                        }

                        vm.requisicaoSolicitada = false;
                        vm.mensagemPreloader = "";
                    },
                    function (error) {
                        vm.requisicaoSolicitada = false;
                        vm.mensagemPreloader = "";
                        ServicosGenericoService.exibirAlertaDeErro(
                            error,
                            event
                        );
                    }
                );
            }
        }

        function verificarSolucaoAtendimentoSolicitacao(codigoSolucao) {
            if (
                (vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo) &&
                vm.atendimento.codigoSolucao &&
                vm.solicitacao.solucaoCodigo &&
                vm.atendimento.codigoSolucao != vm.solicitacao.solucaoCodigo
            ) {
                MdDialogService.alertPadrao(
                    "",
                    null,
                    "<h2>A solução informada na solicitação difere da solução do atendimento.</h2>"
                );
            }

            if (codigoSolucao) {
                _listarTagsVinculadasSolucao(codigoSolucao);
            }
            $scope.$emit("formAlterado");
        }

        $scope.$on("dialogFechado", function (event, houveAlteracao) {
            if (houveAlteracao) {
                _listarTagsCadastradas();
                _listarTagsVinculadasSolucao(vm.atendimento.codigoSolucao);
            }
        });

        function _listarTagsVinculadasSolucao(codigoSolucao) {
            vm.buscandoTagsAtendimentoCadastradas = true;
            var url =
                Api.atendimento.tag.listarPorSolucao +
                "?codigoSolucao=" +
                codigoSolucao;
            var tagsSelecionadas = vm.atendimento.tags
                ? vm.atendimento.tags
                : [];
            vm.listaTagsAtendimento = [];
            vm.atendimento.tags = [];

            RequisicaoGenericaService.listarSemParams(url)
                .then(function (success) {
                    vm.listaTagsAtendimento = success.data;
                    tagsSelecionadas.forEach(function (codigoSelecionado) {
                        const tagExistente = vm.listaTagsAtendimento.find(
                            function (tag) {
                                return tag.codigo === codigoSelecionado;
                            }
                        );
                        if (tagExistente) {
                            vm.atendimento.tags.push(tagExistente.codigo);
                        } else {
                            if (
                                !vm.listaTagsAtendimento.some(function (tag) {
                                    return tag.codigo === codigoSelecionado;
                                })
                            ) {
                                vm.atendimento.tags.push(codigoSelecionado);
                            }
                        }
                    });
                })
                .catch(function (error) {
                    vm.listaTagsAtendimento = [];
                })
                .finally(function () {
                    vm.buscandoTagsAtendimentoCadastradas = false;
                });
        }

        function _listarTagsCadastradas() {
            RequisicaoGenericaService.listarSemParams(
                Api.atendimento.tag.listarTodas
            )
                .then(function (success) {
                    vm.todasTagsCadastradas = success.data;
                })
                .catch(function (error) {
                    vm.todasTagsCadastradas = [];
                });
        }

        function abrirCadastroCliente(cliente) {
            if (!cliente)
                MdDialogService.alertPadrao(
                    "É necessário selecionar um cliente!"
                );
            else {
                $state.goNewTab("app.geral_cadastro_cliente_cliente", {
                    parametros: {
                        cliente: cliente,
                    },
                });
            }
        }

        function abrirCadastroSolicitacao(solicitacao) {
            if (!solicitacao)
                MdDialogService.alertPadrao(
                    "É necessário selecionar uma solicitação!"
                );
            else {
                $state.goNewTab("app.solicitacao_processamento_solicitacao", {
                    parametros: {
                        solicitacaoNumero: solicitacao.numero,
                        solicitacaoAno: solicitacao.ano,
                    },
                });
            }
        }

        function ajustarExibicaoOrdensServicoAtendimento(atendimento) {
            vm.ordensServicos = "";

            if (
                atendimento.ordensServicos &&
                atendimento.ordensServicos.length > 0
            ) {
                atendimento.ordensServicos.forEach(function (
                    ordemServico,
                    index,
                    array
                ) {
                    vm.ordensServicos +=
                        ordemServico.codigo + "/" + ordemServico.ano;
                    if (index !== array.length - 1) {
                        vm.ordensServicos += "; ";
                    }
                });
            } else {
                vm.ordensServicos = "";
            }
        }

        function abrirDialogHistoriasVinculadas(atendimento) {
            vm.controleForm.emProgresso = true;
            AtendimentoService.pesquisarHistoriasVinculadas(atendimento)
                .then(
                    function (success) {
                        $mdDialog.show({
                            controller: "DialogHistoriasVinculadasController",
                            controllerAs: "vm",
                            templateUrl:
                                "app/main/atendimento/processamento/atendimento/atendimentos-em-aberto/dialog-historias-vinculadas/dialog-historias-vinculadas.html",
                            targetEvent: event,
                            clickOutsideToClose: false,
                            locals: {
                                Historias: success.data,
                            },
                        });
                    },
                    function (error) {
                        MdDialogService.alertPadrao(error.data);
                    }
                )
                .finally(function () {
                    vm.controleForm.emProgresso = false;
                });
        }

        function abrirDialogOrdensDeServicos(ordensServicos) {
            if (ordensServicos.length == 1) {
                $state.goNewTab("app.manutencao_ordem_servico", {
                    parametros: {
                        os: ordensServicos[0],
                        idOs: ordensServicos[0].id,
                    },
                });
            }

            if (ordensServicos.length > 1) {
                $mdDialog.show({
                    controller: "AtendimentoDialogSelecionarOSController",
                    controllerAs: "vm",
                    templateUrl: vm.rotasHtml.dialogSelecionarOS,
                    targetEvent: event,
                    clickOutsideToClose: false,
                    locals: {
                        OS: ordensServicos,
                    },
                });
            }
        }

        function abrirDialogContratos(event) {
            vm.abrindoDialogContratos = true;
            ServicosGenericoService.pesquisarAutoCompleteCodigoOuNomeGenericoApi(
                Api.cliente.listarCodigoDescricao,
                vm.atendimento.cliente.nome
            ).then(function (success) {
                vm.abrindoDialogContratos = false;
                $mdDialog.show({
                    controller: "ContratosController",
                    controllerAs: "vm",
                    templateUrl: 'app/main/atendimento/processamento/atendimento/views/dialogs/contratos/contrato-clientes.html',
                    //parent: ---------------,
                    targetEvent: event,
                    clickOutsideToClose: false,
                    locals: {
                        Cliente: success[0],
                        DesabilitarBotoes: true,
                        ListarUsuariosSetorComercial: ListarUsuariosSetorComercial,
                    },
                });
            }, function (error) {
                vm.abrindoDialogContratos = false;
                MdDialogService.alertPadrao(
                    "Não foi possível localizar o cliente vinculado ao atendimento."
                );
            }
            )
        }

        function abrirDialogCaracteristica(event) {
            $mdDialog.show({
                controller: "ClienteDialogCaracteristicaController",
                controllerAs: "vm",
                templateUrl: 'app/main/geral/cadastro/cliente/cliente/views/tabs/cliente/dialogs/caracteristica-dialog/cliente-dialog-caracteristica.html',
                //parent: ---------------,
                targetEvent: event,
                clickOutsideToClose: false,
                locals: {
                    CodigoCliente: vm.atendimento.cliente.codigo,
                },
            });
        }

        function abrirDialogVisualizacaoHistorico($event) {
            $mdDialog.show({
                controller: 'DialogVisualizacaoHistoricoAtendimentoController',
                controllerAs: 'vm',
                templateUrl: vm.rotasHtml.dialogVisualizacaoHistoricoAtendimento,
                //parent: ---------------,
                targetEvent: $event,
                clickOutsideToClose: true,
                locals: {
                    historicoAtendimentos: vm.historicoAtendimentos,
                    indexHistoricoAtendimento: vm.indexHistoricoAtendimento
                }
            });
        }

        function abrirDialogNegociosEmAndamento(event) {
            ServicosGenericoService.pesquisarAutoCompleteCodigoOuNomeGenericoApi(
                Api.cliente.listarCodigoDescricao,
                vm.atendimento.cliente.nome
            ).then(function (success) {
                var modelo = success[0];
                var dadosFiltro = {
                    codigo: modelo.codigo,
                };
                var executivo = undefined;
                executivo = {
                    codigo: null,
                    nome: null,
                };

                if (modelo.usuarioResponsavel) {
                    executivo.codigo = modelo.usuarioResponsavel.codigo;
                    executivo.nome = modelo.usuarioResponsavel.nome;
                }

                var parametros = {
                    filtroCard: dadosFiltro,
                    rota: Api.pipeline.pipeline_estatisticas
                        .listaNegociosEmAndamentoPorCliente,
                    titulo: "Negócios em andamento do cliente " + modelo.nome,
                    executivo: executivo,
                    permiteEdicao: true,
                };

                MdDialogService.abrirDialogPadrao(
                    event,
                    "DetalhamentoNegociosDialogController",
                    'app/main/pipeline/consulta/estatististica-negocios/dialogs/detalhamento-negocios/detalhamento-negocios-dialog.html',
                    parametros
                );
            }, function (error) {
                MdDialogService.alertPadrao(
                    "Não foi possível localizar o cliente vinculado ao atendimento."
                );
            }
            )
        }

        function _listarTodasSolucoes(clienteCodigoSelecionado) {
            var clienteCodigo = clienteCodigoSelecionado;
            vm.buscandoSolucoes = true;
            var url = Api.solucao_rotinas_tarefas.solucao.listarPorSquadCliente;
            var entidadeEnvio = {
                codigoCliente: clienteCodigo,
                codigoSquads: vm.squadUsuarioLogado,
                exibirSolucaoComSquad: false,
            };
            return RequisicaoGenericaService.listarPorPaginacaoJsonFormato(
                url,
                entidadeEnvio
            )
                .then(function (success) {
                    vm.solucoes = success.data;
                })
                .catch(function (error) {
                    vm.solucoes = [];
                })
                .finally(function () {
                    vm.buscandoSolucoes = false;
                });
        }

        function _verificarExistePendenciaAtualizacaoCliente(codigoCliente) {
            if (!codigoCliente || vm.aguardandoConfirmacaoPendenciaCliente)
                return;

            vm.aguardandoConfirmacaoPendenciaCliente = true;
            vm.controleForm.preLoaderToolbar.inicioProgresso();

            RequisicaoGenericaService.listarComParams(
                Api.atendimento.existePendenciaAtualizacao +
                "?codigoCliente=" +
                codigoCliente
            )
                .then(
                    function (success) {
                        if (success.data) {
                            MdDialogService.alertPadraoComEvento(
                                "Atenção!",
                                function () {
                                    vm.aguardandoConfirmacaoPendenciaCliente = false;
                                },
                                null,
                                success.data
                            );
                        } else {
                            vm.aguardandoConfirmacaoPendenciaCliente = false;
                        }
                    },
                    function (error) {
                        MdDialogService.alertPadrao(error.data, event);
                        vm.aguardandoConfirmacaoPendenciaCliente = false;
                    }
                )
                .finally(function () {
                    vm.controleForm.preLoaderToolbar.fimProgresso();
                });
        }

        if ($state.params.parametros) {
            vm.iniciarChamandoPesquisa = true;
            vm.atendimento = {
                codigo: $state.params.parametros.codigo,
                ano: $state.params.parametros.ano,
                chamarPesquisa: $state.params.parametros.chamarPesquisa,
            };
        }

        /////////////////////////////////////////////////////////////////////////////////////////////////////

        /**
         * If que verifica se esta vindo parametros na transição de estado, casó contenha o atributo chamarPesquisa já é chamado
         * o método pesquisar
         */
        if ($stateParams.parametros) {
            vm.iniciarChamandoPesquisa = true;
            vm.idTabelaHistoricoAtendimento =
                "atendimento-historico-atendimentos-tabela";

            /**
             * Se o parâmetro "chamarPesquisa" estiver definido será feito uma requisição para api
             * quando o controller for iniciado, já buscando o atendimento relacionado trazido pelos parâmetros da rota
             */
            if ($stateParams.parametros.chamarPesquisa) {
                vm.atendimento = {
                    codigo: $stateParams.parametros.codigo,
                    ano: $stateParams.parametros.ano,
                    chamarPesquisa: $stateParams.parametros.chamarPesquisa,
                };
            }

            // Se o parâmetro "chamarInsercao" já é definido o estado inicial do atendimento em modo inserção
            if ($stateParams.parametros.chamarInsercao) {
                vm.atendimento = {
                    chamarInsercao: $stateParams.parametros.chamarInsercao,
                };
                vm.iniciarAtendimentoInserindoNovoAtendimento = true;
            }
            /**
             *  Se o parâmetro "habilitarIconeVoltarAConsultaDeAtendimentos" é definido o botão voltar no header padrao
             *  para  voltar para tela de atendimentos
             */
            if (
                $stateParams.parametros
                    .habilitarIconeVoltarAConsultaDeAtendimentos
            ) {
                vm.habilitarIconeVoltarATelaConsultaAtendimentosHeaderPadrao = true;
                vm.mensagemTooltipIconeEstadoAnteriorHeaderPadrao =
                    "Voltar para tela de Consulta de Atendimentos";
            }
        } else if (
            /**
             * Se existir o parâmetro "iniciarListandoAtendimentosNaoVisualizados, iniciarListandoAtendimentosEmAberto ou iniciarListandoAtendimentosImportantes"
             * o controller já será iniciado setando a váriavel "vm.iniciarChamandoPesquisa" para true e fazendo uma requição para Api
             * e desabilitando os buttons para as telas de atendimentos não visualizado ou atendimentos em aberto
             */
            !$stateParams.parametros &&
            ($stateParams.iniciarListandoAtendimentosNaoVisualizados ||
                $stateParams.iniciarListandoAtendimentosEmAberto ||
                $stateParams.iniciarListandoAtendimentosImportantes)
        ) {
            vm.iniciarChamandoPesquisa = true;
            vm.desabilitarButtons =
                AtendimentoService.setarValoresParaIniciarChamandoPesquisa();
            vm.idTabelaHistoricoAtendimento =
                "atendimento-historico-atendimentos-tabela-nao-visualizados";
            /**
             * Caso o parâmetro seja iniciarListandoAtendimentosNaoVisualizados iniciára a tela já carregando os atendimentos
             * não visualizados do usuário corrente
             */
            if ($stateParams.iniciarListandoAtendimentosNaoVisualizados) {
                moduloAtendimentosNaoVisualizados = true;
                vm.atendimento = {
                    listarAtendimentosPendentes: true,
                    chamarPesquisa: true,
                };
            } else if ($stateParams.iniciarListandoAtendimentosImportantes) {
                moduloAtendimentosImportantes = true;
                vm.atendimento = {
                    listarAtendimentosImportantes: true,
                    chamarPesquisa: true,
                };
            } else if ($stateParams.iniciarListandoAtendimentosEmAberto) {
                /**
                 * Caso o parâmetro seja iniciarListandoAtendimentosEmAberto inciára pesquisando todas os atendimentos em aberto
                 * com a exibição em modo tabela
                 */
                vm.idTabelaHistoricoAtendimento =
                    "atendimento-historico-atendimentos-tabela-em-abertos";
                vm.dtOptionsAtendimentosEmAberto =
                    AtendimentoService.atendimentosEmAbertoConstruirDtOptionsAtendimentosEmAberto();
                moduloAtendimentoEmAberto = true;

                vm.atendimento = {
                    listarTodosAtendimentosEmAberto: true,
                    chamarPesquisa: true,
                    listandoTodasEntidades: true,
                };
                /**
                 * Se o parâmetro codigoUsuariosHaListarAtendimentosEmAberto for preenchido a pesquisa para buscar todos atendimentos em aberto
                 * do usuário será feito com base no codigo do usuário passado por parâmetro
                 */
                if ($stateParams.codigoUsuariosHaListarAtendimentosEmAberto)
                    usuariosHaListarAtendimentosEmAberto =
                        $stateParams.codigoUsuariosHaListarAtendimentosEmAberto;
                /**
                 * Se o parâmeto listarAtendimentosUsuarioComQuantidadeLimiteExcedida for preenchido, a pesquisa para buscar todos os atendimentos dos usuários do
                 * setor do usuário gerente corrente com atendimentos a quantidade de atendimentos excedido será realizada
                 */ else if (
                    $stateParams.listarAtendimentosUsuarioComQuantidadeLimiteExcedida
                ) {
                    usuariosHaListarAtendimentosEmAberto = {
                        codigoUsuarioGerente: vm.usuarioLogado.codigoUsuario,
                        listaCodigoUsuarios:
                            $stateParams.codigoUsuariosComAtendimentosEmAbertoExcedidos,
                    };
                } else if (
                    vm.usuarioLogado.visualizarAtendimentosEmAbertoSetor
                ) {
                    /**
                     * Se o usuário for um gerente e em seus detalhes estiver marcado para visualizar os atendimentos em aberto do setor dele
                     * irá abrir uma caixa de dialog para ele selecionar o usuário que ele deseja visualizar os atendimentos em aberto
                     */
                    vm.atendimento.chamarPesquisa = false;
                    abrirDialogUsuariosComAtendimentosEmAbertoSetor();
                } else {
                    /**
                     * Se não a pesquisa será feita com base no codigo do usuário corrente
                     */
                    vm.idTabelaHistoricoAtendimento =
                        "atendimento-historico-atendimentos-tabela";
                    usuariosHaListarAtendimentosEmAberto =
                        vm.usuarioLogado.codigoUsuario;
                }
            }
        }
        //endregion

        /**
         * Verifica qual modulo está aberto e seta o titulo no header com base no modulo aberto
         * modulo atendimento nao visualizados  = ATENDIMENTO.ATENDIMENTOS_NAO_VISUALIZADO
         * modulo atendimentos em aberto = "ATENDIMENTO.ATENDIMENTOS_EM_ABERTO"
         * modulo atendimentos importantes = "ATENDIMENTO.ATENDIMENTOS_IMPORTANTES"
         * se for o modulo principal = "ATENDIMENTO.ATENDIMENTO"
         */
        if (moduloAtendimentosNaoVisualizados)
            vm.tituloHeader = "ATENDIMENTO.ATENDIMENTOS_NAO_VISUALIZADO";
        else if (moduloAtendimentoEmAberto)
            vm.tituloHeader = "ATENDIMENTO.ATENDIMENTOS_EM_ABERTO";
        else if (moduloAtendimentosImportantes)
            vm.tituloHeader = "ATENDIMENTO.ATENDIMENTOS_IMPORTANTES";
        else vm.tituloHeader = "ATENDIMENTO.ATENDIMENTO";
    } // Controller
})();

//<!-- Ultima mudança 18/05/2017.-->
(function() {
  "use strict";

  angular
    .module("app.atendimento.processamento.atendimentosVinculados", [])
    .config(config);

  function config($stateProvider, RotasHtml) {
    var rotasHtmlAtendimento = RotasHtml.atendimento;
    $stateProvider.state(
      "app.atendimento_processamento_atendimentosvinculados",
      {
        url: "/atendimento/processamento/atendimentos-vinculados",
        module: "privado",
        views: {
          "content@app": {
            templateUrl: rotasHtmlAtendimento.atendimentosVinculados,
            controller: "AtendimentoVinculadosController as vm"
          },
          "atendimentos-vinculados@app.atendimento_processamento_atendimentosvinculados": {
            templateUrl: rotasHtmlAtendimento.atendimentosVinculados
          }
        },
        resolve: {
          ListarUsuarioPorDetalhe: function(
            Api,
            RequisicaoGenericaService,
            LoginUsuarioService
          ) {
            return RequisicaoGenericaService.listarSemParams(
              Api.usuario.detalhes_usuario.listarUsuarioPorDetalhe +
                LoginUsuarioService.usuarioArmazenado().codigo
            );
          }
      }
    }
    );
  }
})();

/**
 * Created by nova on 16/12/2019.
 */
(function () {
    "use strict";

    angular
        .module("app.atendimento.processamento.atendimentosVinculados")
        .controller(
            "AtendimentoVinculadosController",
            AtendimentoVinculadosController
        );

    function AtendimentoVinculadosController(
        AtendimentoService,
        AtendimentoFactory,
        RequisicaoGenericaService,
        ListarUsuarioPorDetalhe,
        ServicosGenericoService,
        $q,
        Api,
        $filter,
        MdDialogService,
        $state,
        NavegacaoService,
        $timeout
    ) {
        NavegacaoService.setTituloAba("Atendimentos Vinculados");
        var vm = this;
        var usuario = ListarUsuarioPorDetalhe.data;
        vm.tituloHeader = "Atendimentos Vinculados";
        vm.iniciarChamandoPesquisa = true;
        vm.form = {};
        vm.legendaSelecionadaAtendimentosVinculados = 0;
        vm.flag = true;
        vm.abertos = true;
        vm.metodos = {
            editar: editar,
            filtrarTabelaAtendimentosFinalizados: filtrarTabelaAtendimentosFinalizados
        };
        vm.legendasAtendimentosVinculados = AtendimentoFactory.setLegendasCoresAtendimentosVinculados();
        vm.dtOptionsAtendimentosVinculados = AtendimentoService.atendimentosVinculadosConstruirDtOptionsAtendimentosVinculados();

        vm.dtOptionsAtendimentosVinculados.columnDefs = [
            {
                targets: 0,
                responsivePriority: 1
            },
            {
                targets: 1,
                responsivePriority: 1
            },
            {
                targets: 2,
                responsivePriority: 1
            },
            {
                targets: 5,
                responsivePriority: 1
            }
        ];
        init();
        function init() {
            iniciarPesquisando();
        }

        function iniciarPesquisando() {
            var deferred = $q.defer();
            vm.progressoFiltrarAtendimentos = true;
            RequisicaoGenericaService.listarSemParams(
                Api.atendimento.listarAtendimentosVinculados + usuario.codigoUsuario
            )
                .then(
                    function (success) {
                        if (success.data.length <= 0) {
                            MdDialogService.alertPadrao("Não foram encontrados atendimentos vinculados.");
                            vm.progressoFiltrarAtendimentos = false;
                            redirecionarParaAtendimento();
                        }
                        else {
                            vm.atendimentosVinculados = success.data;
                            // AtendimentoService.construirArraysDeAtendimentosFinalizados(
                            //   success.data
                            //   );
                            vm.atendimentosVinculadosExibir = vm.atendimentosVinculados.filter(
                                function (item) {

                                    var caracteresAssunto = item.assunto.substr(0,116);
                                    item.assunto = caracteresAssunto;

                                    var caracteresCliente = item.cliente.substr(0,20);
                                    item.cliente = caracteresCliente;
                                    return item.status == 1;
                                }
                            );
                        }
                        vm.progressoFiltrarAtendimentos = false;
                        deferred.resolve(success);
                    },
                    function (error) {
                        redirecionarParaAtendimento();

                        deferred.reject(error);
                    }
                )
                .finally(function () {
                    AtendimentoService.atendimentosVinculadosSelecionarArrayDePesquisa(
                        (legenda = { codigoLegenda: 1 })
                    );
                });
        }
        //return deferred.promise;

        function editar(atendimentoVinculado) {
            $state.goNewTab("app.atendimento_processamento_atendimento",{
                parametros: {
                    codigo: atendimentoVinculado.codigo,
                    ano: atendimentoVinculado.ano,
                    chamarPesquisa: true
                }
            });
        }

        function redirecionarParaAtendimento() {
            $state.go("app.atendimento_processamento_atendimento");
        }

        function filtrarTabelaAtendimentosFinalizados(legenda,index) {
            if (vm.flag) {
                vm.flag = false;
                if (vm.legendaSelecionadaAtendimentosVinculados !== index) {
                    vm.legendaSelecionadaAtendimentosVinculados = index;
                    if (legenda.codigoLegenda == 0) {
                        vm.atendimentosVinculadosExibir = vm.atendimentosVinculados.filter(
                            function (item) {
                                return item.status == 1;
                            }
                        );
                        vm.abertos = true;
                    } else if (legenda.codigoLegenda == 1) {
                        vm.atendimentosVinculadosExibir = [];
                        vm.atendimentosVinculadosExibir = vm.atendimentosVinculados.filter(
                            function (item) {
                                return item.status == 2;
                            }
                        );
                        vm.abertos = false;
                    } else {
                        vm.atendimentosVinculadosExibir = angular.copy(
                            vm.atendimentosVinculados
                        );
                    }
                } else {

                    vm.atendimentosVinculadosExibir = angular.copy(
                        vm.atendimentosVinculados
                    );
                    vm.legendaSelecionadaAtendimentosVinculados = null;
                    vm.abertos = true;
                }
            }
            $timeout(function () {
                vm.flag = true;

            },100);
        }
    } // CONTROLLER
})();

(function () {
    'use strict';
    angular
        .module('app.atendimento.estatisticas.tags')
        .controller('EstatisticasTagsAtendimentoController', EstatisticasTagsAtendimentoController);

    function EstatisticasTagsAtendimentoController(
        $state, $scope, $mdDialog, $rootScope, RotasHtml, DataService, EstatisticaTagsService, MdDialogService, ListarTodasTags, ListarCoresTagsAtendimento, DesabilitarSidenav, Cliente) {
        var vm = this;
        vm.rotasHtml = RotasHtml.estatisticasTagsAtendimento;
        vm.listaCores = ListarCoresTagsAtendimento;
        vm.detalhes = null;
        vm.tagsmaisUtilizadas = [];
        vm.tipoVisualizacaoCalendario = 'month';
        vm.emProgresso = false;
        vm.viewModel = {};
        vm.cliente = Cliente;
        vm.desabilitarSidenav = DesabilitarSidenav;
        $rootScope.desabilitarSidenav = vm.desabilitarSidenav;
        $rootScope.$broadcast('atualizarDesabilitarSidenav', vm.desabilitarSidenav);
        $rootScope.$broadcast('atualizarListaTodasTags', Array.isArray(ListarTodasTags) ? { data: ListarTodasTags } : ListarTodasTags);
        $rootScope.listaTodasTags = Array.isArray(ListarTodasTags) ? ListarTodasTags : ListarTodasTags.data;
        init();

        vm.metodos = {
            abrirFiltro: abrirFiltro,
            filtrarEstatisticasTags: filtrarEstatisticasTags,
            atualizarFiltro: atualizarFiltro,
            exibirLegenda: exibirLegenda,
            irParaHoje: irParaHoje,
            alterarModoVisualizacao: alterarModoVisualizacao,
            visualizarAtendimento: visualizarAtendimento,
            proximo: proximo,
            anterior: anterior,
            fecharDialog: fecharDialog
        }

        $scope.$watch('vm.dataSelecionada', function () {
            if (!vm.dataSelecionada)
                return;

            if (vm.dataSelecionada)
                vm.calendar.gotoDate(vm.dataSelecionada)

            if (vm.dataSelecionada.getMonth() + 1 != vm.mesSelecionado) {
                atualizarFiltro();
            }
        });

        function init() {
            vm.emProgresso = false;
            vm.events = [];
            vm.mesSelecionado = DataService.dataAtual;
            construirUiCalendar();
            if (vm.cliente && vm.cliente.codigo) {
                var dataAtual = new Date();
                vm.viewModel.mes = dataAtual.getMonth() + 1;
                vm.viewModel.ano = dataAtual.getFullYear();
                vm.viewModel.cliente = vm.cliente.codigo;
                vm.viewModel.tags = null;
                _filtrarEstatisticas(vm.viewModel);
                filtrarEstatisticasTags();
            } else {
                filtrarEstatisticasTags();
            }
        }

        function abrirFiltro() {
            $rootScope.$broadcast('atualizarDesabilitarSidenav', vm.desabilitarSidenav);
            EstatisticaTagsService.toggleFiltro();
        }

        function filtrarEstatisticasTags() {
            EstatisticaTagsService.setListener(function (callback) {
                vm.viewModel = angular.copy(callback());
                const hoje = new Date();
                const diaAtual = hoje.getDate();
                const ano = vm.viewModel.ano;
                const mes = vm.viewModel.mes - 1;
                const data = new Date(ano, mes, diaAtual);

                if (vm.calendar) {
                    vm.calendar.gotoDate(data);
                }
                _filtrarEstatisticas(vm.viewModel);
            });
        }

        function atualizarFiltro() {
            vm.viewModel.mes = vm.mesSelecionado;
            _filtrarEstatisticas(vm.viewModel);
        }

        function construirUiCalendar() {
            vm.calendarUiConfig = {
                calendar: {
                    locale: 'pt-br',
                    axisFormat: 'HH:mm',
                    timeFormat: 'HH:mm',
                    editable: false,
                    height: 1000,
                    eventLimit: true,
                    allDay: 'Teste',
                    minTime: '07:00',
                    maxTime: '20:00',
                    header: '',
                    handleWindowResize: false,
                    aspectRatio: 1,
                    fixedWeekCount: false,
                    dayNames: ['Domingo', 'Segunda', 'Terça', 'Quarta', 'Quinta', 'Sexta', 'Sábado'],
                    dayNamesShort: ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sab'],
                    viewRender:
                        function (view) {
                            vm.calendarView = view;
                            vm.calendar = vm.calendarView.calendar;
                            vm.currentMonthShort = vm.calendar.getDate().format('MMM')
                        },
                    columnFormat: {
                        month: 'ddd',
                        week: 'ddd D',
                        day: 'dddd'
                    },
                    eventClick: eventDetail,
                    selectable: true,
                    selectHelper: true,
                    selectOverlap: false,
                    select: select,
                    eventMouseover: function (event, element, view) {
                        exibeDetalhes(event, element, view);
                    },
                    eventMouseout: function (event, element, view) {
                        ocultaDetalhes(event, element);
                    }
                }
            }
        }

        function eventDetail(event, jsEvent, view) {
            vm.detalhes = event;
            _abrirDialogDetalhesAtendimento(event, vm.detalhes);
        }

        function select(start, end, e) {
        }

        function exibeDetalhes(atividade, e, view) {
        }

        function ocultaDetalhes(atividade, element) {
        }

        function _filtrarEstatisticas(viewModel) {
            vm.emProgresso = true;
            vm.detalhes = null;
            EstatisticaTagsService.setFiltro(viewModel);
            $rootScope.$broadcast('atualizarFiltroTags', viewModel);
            EstatisticaTagsService.filtrarDadosDashboard(viewModel)
                .then(function (success) {
                    _carregarAtividades(success.data.atendimentos);
                    vm.ultimaBusca = success.data;
                    vm.tagsmaisUtilizadas = success.data.estatistica.tagsMaisUtilizadas;
                    vm.totalizador = success.data.estatistica.totalizador;

                    vm.totalTagsGeral = (success.data.estatistica.tagsMaisUtilizadas || []).reduce(function (sum, item) {
                        return sum + (item.quantidade || 0);
                    }, 0);

                    vm.totalTags = (success.data.estatistica.tagsMaisUtilizadas || []).length;

                    var clientes = success.data.estatistica.clientesRecorrentes || [];
                    vm.clientesRecorrentes = clientes.slice(0, 10);

                    vm.clientesRecorrentesTotal = vm.clientesRecorrentes.reduce(function (sum, item) {
                        return sum + (item.quantidade || 0);
                    }, 0);

                    _formatarTagsMaisUtilizadas();
                    _configurarGraficoTags();
                    _configurarGraficoTagsClientes();
                }, function (error) {
                    MdDialogService.alertPadrao("Atenção!", null, error.data);
                }).finally(function () {
                    vm.emProgresso = false;
                    EstatisticaTagsService.closeFiltroIfOpen();
                });
        }

        function _carregarAtividades(atividades) {
            vm.events.length = 0;
            vm.events.push(atividades);
        }

        function exibirLegenda() {
            $mdDialog.show({
                controller: 'DialogLegendaController',
                controllerAs: 'vm',
                multiple: true,
                templateUrl: 'app/main/agenda/processamento/visualizar-atividades/dialogs/legenda/dialog-legenda.html',
                targetEvent: event,
                clickOutsideToClose: true,
                locals: {
                    RotinaVisualizacaoAtividade: false
                }
            });
        }

        function irParaHoje() {
            vm.calendar.changeView('agendaDay');
            vm.tipoVisualizacaoCalendario = 'today';
            return _navegar('today');
        }

        function alterarModoVisualizacao(modo) {
            vm.tipoVisualizacaoCalendario = modo;
            vm.calendar.changeView(modo);
        }

        function visualizarAtendimento(numero, ano) {
            $state.goNewTab('app.atendimento_processamento_atendimento', {
                parametros: {
                    codigo: numero,
                    ano: ano,
                    chamarPesquisa: true
                }
            });
        }

        function proximo() {
            return _navegar('next');
        }

        function anterior() {
            return _navegar('prev');
        }

        function _navegar(direcao) {
            if (direcao == 'next')
                vm.calendarView.calendar.next();
            if (direcao == 'prev')
                vm.calendarView.calendar.prev();
            if (direcao == 'today')
                vm.calendar.today();

            var mesSelecionado = vm.calendarView.calendar.getDate().toDate().getMonth() + 1;
            var anoSelecionado = vm.calendarView.calendar.getDate().toDate().getFullYear();

            if (vm.viewModel.mes != mesSelecionado || vm.viewModel.ano != anoSelecionado) {
                vm.mesSelecionado = mesSelecionado;
                vm.viewModel.mes = mesSelecionado;
                vm.viewModel.ano = anoSelecionado;
                atualizarFiltro();
            }
        }

        function _formatarTagsMaisUtilizadas() {
            vm.outrasTagsDetalhes = [];
            vm.tagsmaisUtilizadas = vm.tagsmaisUtilizadas.map(function (tag) {
                var corEncontrada = vm.listaCores.find(function (cor) {
                    return cor.background === tag.corIdentificacao;
                });
                return Object.assign({}, tag, {
                    corIdentificacao: corEncontrada ? corEncontrada.fonte : tag.corIdentificacao
                });
            });

            if (vm.tagsmaisUtilizadas.length > 10) {
                var outrasTags = vm.tagsmaisUtilizadas.slice(10);
                vm.outrasTagsDetalhes = outrasTags;
                var totalOutras = outrasTags.reduce(function (sum, item) {
                    return sum + (item.quantidade || 0);
                }, 0);
                var outras = {
                    codigo: 9999999,
                    descricao: "Outras",
                    corIdentificacao: "#CCCC",
                    quantidade: totalOutras
                };
                vm.tagsmaisUtilizadas = vm.tagsmaisUtilizadas.slice(0, 10);
                vm.tagsmaisUtilizadas.push(outras);
            } else {
                vm.outrasTagsDetalhes = [];
            }
        }

        function _configurarGraficoTags() {
            vm._totalGraficoTags = (vm.tagsmaisUtilizadas || []).reduce(function (sum, item) {
                return sum + (item.quantidade || 0);
            }, 0);

            vm.donutChart = {
                options: {
                    chart: {
                        type: 'pieChart',
                        height: 420,
                        donut: true,
                        x: function (d) { return d.descricao.length > 12 ? d.descricao.substring(0, 12) + '...' : d.descricao; },
                        y: function (d) { return d.quantidade; },
                        showLabels: true,
                        labelThreshold: 0.01,
                        labelSunbeamLayout: false,
                        labelType: function (d) {
                            return d.data.quantidade;
                        },
                        color: function (d) { return d.corIdentificacao; },
                        transitionDuration: 500,
                        tooltip: {
                            contentGenerator: function (d) {
                                var total = vm._totalGraficoTags;
                                var label = d.data.label || d.data.descricao || '';
                                var value = d.data.quantidade || 0;
                                var porcentagem = total > 0 ? ((value / total) * 100).toFixed(2) : '0.00';
                                return '<div style="padding: 8px; background: #222; color: #fff; border-radius: 4px;">' +
                                    '<strong>' + label + '</strong><br>' +
                                    porcentagem + '%' +
                                    '</div>';
                            }
                        },
                        noData: 'Não há dados para o filtro selecionado',
                    }
                },
                data: vm.tagsmaisUtilizadas
            };
            setTimeout(function () {
                var slices = document.querySelectorAll('.nv-pie .nv-slice');
                slices.forEach(function (slice, idx) {
                    slice.onclick = function (evt) {
                        var data = vm.tagsmaisUtilizadas[idx];
                        if (data && data.codigo === 9999999) {
                            $scope.$apply(function () {
                                _abrirDialogOutrasTags(evt, vm.outrasTagsDetalhes);
                            });
                        }
                    };
                });
            }, 1000);
        }

        function _configurarGraficoTagsClientes() {
            vm._totalGraficoClientes = (vm.clientesRecorrentes || []).reduce(function (sum, item) {
                return sum + (item.quantidade || 0);
            }, 0);

            var listaCores = vm.listaCores;
            var coresGrafico = [];
            for (var i = 0; i < listaCores.length; i++) {
                coresGrafico.push(listaCores[i].fonte);
            }
            for (var j = 0; j < listaCores.length; j++) {
                if (listaCores[j].cor === 'Roxo') {
                    coresGrafico.push(listaCores[j].backgroud);
                    break;
                }
            }

            vm.donutChartClientes = {
                options: {
                    chart: {
                        type: 'pieChart',
                        height: 420,
                        donut: true,
                        x: function (d) { return d.descricao.length > 10 ? d.descricao.substring(0, 10) + '...' : d.descricao; },
                        y: function (d) { return d.quantidade; },
                        showLabels: true,
                        labelThreshold: 0.01,
                        labelSunbeamLayout: false,
                        labelType: function (d) {
                            return d.data.quantidade;
                        },
                        color: function (d, i) { return coresGrafico[i % coresGrafico.length]; },
                        transitionDuration: 500,
                        tooltip: {
                            contentGenerator: function (d) {
                                var total = vm._totalGraficoClientes;
                                var label = d.data.label || d.data.descricao || '';
                                var value = d.data.quantidade || 0;
                                var porcentagem = total > 0 ? ((value / total) * 100).toFixed(2) : '0.00';
                                return '<div style="padding: 8px; background: #222; color: #fff; border-radius: 4px;">' +
                                    '<strong>' + label + '</strong><br>' +
                                    porcentagem + '%' +
                                    '</div>';
                            }
                        },
                        noData: 'Não há dados para o filtro selecionado'
                    }
                },
                data: vm.clientesRecorrentes
            };
        }

        function _gerarListaOutrasTags(atendimentos, tagsMaisUtilizadas) {
            var codigosMaisUtilizadas = (tagsMaisUtilizadas || []).map(function (t) { return t.codigo; });
            var lista = [];

            (atendimentos || []).forEach(function (at) {
                (at.tags || []).forEach(function (tag) {
                    if (codigosMaisUtilizadas.indexOf(tag.codigo) === -1) {
                        lista.push({
                            cliente: at.cliente,
                            tag: tag.descricao,
                            corIdentificacao: tag.corIdentificacao,
                            solucao: at.descricaoSolucao,
                            dataAbertura: at.dataAbertura,
                            dataFechamento: at.start,
                            numero: at.numero,
                            ano: at.ano
                        });
                    }
                });
            });

            return lista;
        }

        function _abrirDialogOutrasTags(event, outrasTagsDetalhes) {
            const listaOutrasTags = _gerarListaOutrasTags(
                vm.ultimaBusca.atendimentos,
                vm.tagsmaisUtilizadas
            );

            $mdDialog.show({
                controller: 'DialogOutrasTagsController',
                controllerAs: 'vm',
                templateUrl: vm.rotasHtml.components.dialogs.outrasTags,
                targetEvent: event,
                multiple: true,
                clickOutsideToClose: true,
                locals: {
                    ListaOutrasTags: listaOutrasTags
                }
            });
        }

        function _abrirDialogDetalhesAtendimento(event, detalhesAtendimento) {
            var tagsAtualizadas = $rootScope.listaTodasTags;
            $mdDialog.show({
                controller: 'DialogDetalhesAtendimentoController',
                controllerAs: 'vm',
                templateUrl: vm.rotasHtml.components.dialogs.detalhesAtendimento,
                targetEvent: event,
                multiple: true,
                clickOutsideToClose: true,
                locals: {
                    DetalhesAtendimento: detalhesAtendimento,
                    ListarTodasTags: tagsAtualizadas,
                    ListarCoresTagsAtendimento: ListarCoresTagsAtendimento
                }
            });
        }

        function fecharDialog() {
            $mdDialog.hide();
        }
    }
})();

/**
 * Created by nova on 28/03/2017.
 */
(function () {
    'use strict';

    angular
        .module('app.atendimento.cadastro.conclusao', [])
        .config(config);

    function config($stateProvider, RotasHtml) {
        var rotasConclusaoHtml = RotasHtml.conclusao_atendimento;
        $stateProvider
            .state('app.atendimento_cadastro_conclusao', {
                url: '/atendimento/cadastro/conclusao',
                module: 'privado',
                views: {
                    'content@app': {
                        templateUrl: rotasConclusaoHtml.templateUrl,
                        controller: "ConclusaoAtendimentoController as vm"
                    },
                    'conclusao-atendimento-form@app.atendimento_cadastro_conclusao': {
                        templateUrl: rotasConclusaoHtml.form
                    },
                    'conclusoes-atendimento-tabela@app.atendimento_cadastro_conclusao': {
                        templateUrl: rotasConclusaoHtml.tabela
                    }
                }
            });
    }

})();

/**
 * Created by nova on 28/03/2017.
 */
(function () {
    'use strict';

    angular.module('app.atendimento.cadastro.conclusao')
        .controller('ConclusaoAtendimentoController', ConclusaoAtendimentoController);

    function ConclusaoAtendimentoController(Api, NavegacaoService, RequisicaoGenericaService, DatatableFactory) {
        var vm = this;
        NavegacaoService.setTituloAba('Atendimento conclusão');  
        // Data region    
        vm.form = {};
        // endregion

        // Definição dos Métodos region
        vm.metodos = {
            pesquisar: pesquisar,
            salvar: salvar,
            editar: editar,
            excluir: excluir,
            selecionar: selecionar,
            construirDtOptions: construirDtOptions
        }
        //endregion

        // Implementação dos Métodos region

        /**
         * Método para pesquisar as conclusões
         */
        function pesquisar() {
            return RequisicaoGenericaService.listarComObjetoComplexo(Api.atendimento.conclusao.listarComPaginacao, vm.entidadeDeEnvio);
        }

        /**
         * 
         * @param {conclusao} modelo 
         */
        function salvar(modelo) {
            return RequisicaoGenericaService.salvar(Api.atendimento.conclusao.criar, modelo);
        }

        /**
         * Método para editar uma conclusão
         * @param {conclusao} modelo 
         */
        function editar(modelo) {
            return RequisicaoGenericaService.editar(Api.atendimento.conclusao.atualizar, modelo)
        }

        /**
         * Método para excluir uma conclusão
         * @param {conclusao} modelo 
         */
        function excluir(modelo) {
            return RequisicaoGenericaService.excluir(Api.atendimento.conclusao.excluir, modelo.codigo)
        }

        /**
         * Método utilizado no modo exibido tabela, para selecionar a conclusão selecionada
         * @param {posicaoEntidade} modelo
         */
        function selecionar(posicaoEntidade) {
            vm.metodosExternosPgToolbar.metodoControladorExternoListarTodasEntidades(null, posicaoEntidade);
        }

        function construirDtOptions() {
            DatatableFactory.construirDtOptionsComPaginacaoProcessadoNoServidorParaToolbar
                (Api.atendimento.conclusao.listarComPaginacaoDatatable, vm.entidadeDeEnvio.clsEntidade, '#datatable-conclusao-atendimento',
                [
                    DatatableFactory.construirColunaDeSelecionarPadrao(function (indexLinha) { vm.metodos.selecionar(indexLinha) }),
                    {
                        targets: 1,
                        name: "Descricao",
                        data: "descricao",
                        sortable: false  
                    }
                ]);
        }
        //endregion

    }
})();

(function () {
    'use strict';

    angular
        .module('app.atendimento.consulta.atendimento', [])
        .config(Config);

    function Config($stateProvider, RotasHtml) {
        var rotasHtmlConsultaEstoria = RotasHtml.consultaAtendimento;
        $stateProvider
            .state('app.atendimento_consulta_atendimento', {
                url: '/atendimento/consulta/atendimento',
                module: 'privado',
                params: {
                    parametros: null
                },
                views: {
                    'content@app': {
                        templateUrl: rotasHtmlConsultaEstoria.templateUrl,
                        controller: 'ConsultaAtendimentoController as vm'
                    }
                },
                resolve: {
                    ListarTipoDetalheAtendimento: function (Api, RequisicaoGenericaService) {
                        return RequisicaoGenericaService.listarSemParams(Api.atendimento.listarTipoDetalheAtendimento);
                    },
                    ListarTodasSolucoes: function (Api, RequisicaoGenericaService) {
                        return RequisicaoGenericaService.listarSemParams(Api.solucao_rotinas_tarefas.solucao.listarCodigoDescricao);
                    },
                    ListarTodosUsuarios: function (Api, RequisicaoGenericaService) {
                        return RequisicaoGenericaService.listarSemParams(Api.usuario.detalhes_usuario.listarUsuariosAtivos);
                    },
                    ListarTiposAtendimento: function (Api, RequisicaoGenericaService) {
                        return RequisicaoGenericaService.listarSemParams(Api.atendimento.listarTiposAtendimento);
                    },
                    ListarStatusAtendimento: function (Api, RequisicaoGenericaService) {
                        return RequisicaoGenericaService.listarSemParams(Api.atendimento.listarStatusAtendimento);
                    }
                }
            });
    }

})();

//ng-class="{'vermelho': estoria.diasRestantes <= 0,
//'amarelo': estoria.diasRestantes <= 7 && estoria.diasRestantes < 0}"
(function () {
    'use strict';

    angular
        .module('app.atendimento.consulta.atendimento')
        .controller('ConsultaAtendimentoController', ConsultaAtendimentoController);

    function ConsultaAtendimentoController(Api, NavegacaoService,ListarTipoDetalheAtendimento, ServicosGenericoService, ListarTodasSolucoes, ListarTodosUsuarios,
        ListarTiposAtendimento, ListarStatusAtendimento, RequisicaoGenericaService, MdDialogService, RotasHtml, DataTableConfigPadrao, $rootScope,
        MenuFactory, $stateParams, LoginUsuarioService) {
        NavegacaoService.setTituloAba('Atendimento consulta');
        var vm = this;

        /**
         * Se exitir o parametro iniciarListandoAtendimentosConsultadoTemporaria
         * o controlle já é inicializado listando os atendimentos consultados anteriormente
         */
        if ($stateParams.parametros && $stateParams.parametros.iniciarListandoAtendimentosConsultadoTemporaria) {
            recuperarConsultaEAtendimentosTemporario();
        }
        else {
            init()
        }

        vm.form = {};
        vm.rotasHtml = RotasHtml.consultaAtendimento;

        vm.listarTipoDetalheAtendimento = ListarTipoDetalheAtendimento.data;
        vm.listarTiposAtendimento = ListarTiposAtendimento.data;
        vm.listarStatusAtendimento = ListarStatusAtendimento.data
        vm.solucoes = ListarTodasSolucoes.data;
        var todasSolucoes = ListarTodasSolucoes.data;

        vm.mensagemPreloader = "Consultando Atendimentos ..."

        vm.dtOptions = DataTableConfigPadrao.dtOptionsResponsivoComPaginacaoComScrollYEInitComplete;
        vm.dtOptions.columnDefs = [
            {
                targets: 9,
                class: 'none'
            },
            {
                targets: 10,
                class: 'none'
            },
            {
                targets: 11,
                class: 'none'
            },
        ];
        vm.dtOptions.initComplete = function () {
            var api = this.api(),
                searchBox = angular.element('body').find('#pesquisar'),
                htmCollection = document.getElementsByClassName('array-buttons-consulta-atendimentos'),
                elemento = [];

            angular.forEach(htmCollection, function (key, value, array) {
                elemento.push(angular.element(key));

                elemento[value].click(function (event) {
                    var arrayFormatado = arrayDePesquisa.toString().replace(/,/g, "|");
                    api.column(4).search(arrayFormatado, true, false).draw();
                });
            });

            // Bind an external input as a table wide search box
            if (searchBox.length > 0) {
                searchBox.on('keyup', function (event) {
                    api.search(event.target.value).draw();
                });
            }


        }

        var arrayDePesquisa = "";
        vm.legendaCoresConsultaAtendimento = [
            {
                descricao: "Atendimentos Em Aberto",
                codigoLegenda: 1,
                cor: "red",
                descricaoTabela: "Aberto"
            },
            {
                descricao: "Atendimentos Finalizados",
                codigoLegenda: 2,
                cor: "green",
                descricaoTabela: "Finalizado"
            }
        ]

        var metodosInternos = {
            recuperarConsultaEAtendimentosTemporario: recuperarConsultaEAtendimentosTemporario,
            definirModelsVinculadosAoUsuarioParaNull: definirModelsVinculadosAoUsuarioParaNull
        }
        vm.metodos = {
            pesquisar: pesquisar,
            novaConsulta: novaConsulta,
            pesquisarAutoCompleteCliente: pesquisarAutoCompleteCliente,
            alterarItemSelecionadoAutoCompleteCliente: alterarItemSelecionadoAutoCompleteCliente,
            configuraAutoCompleteClienteOnBlur: configuraAutoCompleteClienteOnBlur,
            pesquisarAutoCompleteSolucao: pesquisarAutoCompleteSolucao,
            alterarItemSelecionadoAutoCompleteSolucao: alterarItemSelecionadoAutoCompleteSolucao,
            configuraAutoCompleteSolucaoOnBlur: configuraAutoCompleteSolucaoOnBlur,
            pesquisarAutoCompleteUsuario: pesquisarAutoCompleteUsuario,
            alterarItemSelecionadoAutoCompleteUsuario: alterarItemSelecionadoAutoCompleteUsuario,
            configuraAutoCompleteUsuarioOnBlur: configuraAutoCompleteUsuarioOnBlur,
            filtrarTabela: filtrarTabela,
            navegarParaAtendimento: navegarParaAtendimento,
            ngChangeRadioGroupTipoDetalheAtendimento: ngChangeRadioGroupTipoDetalheAtendimento
        };

        /**
         * Método inicilizador
         */
        function init() {
            $rootScope.atendimentosTemporariosConsultado = null;
            $rootScope.consultaAtendimentoTemporario = null;

            vm.consultaAtendimento = {
                periodoInicial: new Date(),
                periodoFinal: new Date(),
                codigoUsuarioCorrente: LoginUsuarioService.usuarioArmazenado().codigo
            };

            vm.textoDePesquisaAutoCompleteUsuario = "";
            vm.usuario = null;
            vm.textoDePesquisaAutoCompleteSolucao = "";
            vm.solucao = null;
            vm.textoDePesquisaAutoCompleteCliente = "";
            vm.cliente = null;

            vm.habilitarPesquisarHeaderPadrao = false;
            vm.pesquisar = "";

            vm.consultaAtendimento.tipoDetalheAtendimento = 2;
            vm.consultaAtendimento.tipoAtendimento = 3;
            vm.consultaAtendimento.statusAtendimento = 3;

            vm.requisicaoSolicitada = false;

            vm.listaAtendimentosConsultados = [];
            vm.pesquisaAtiva = false;

            vm.legendaSelecionada = null;
        }

        //////////////////////////////////////////////////////////// Métodos Internos ////////////////////////////////////////////////////////////

        /**
         * Método que seta os valores temporarios da consulta realizada novamente na consultaAtendimento e também na listaAtendimentosConsultados
         */
        function recuperarConsultaEAtendimentosTemporario() {
            vm.listaAtendimentosConsultados = $rootScope.atendimentosTemporariosConsultado;
            vm.consultaAtendimento = $rootScope.consultaAtendimentoTemporario;
            vm.usuario = vm.consultaAtendimento.usuario;
            vm.cliente = vm.consultaAtendimento.cliente;
            vm.solucao = vm.consultaAtendimento.solucao;
            vm.pesquisaAtiva = true;
        }

        /**
         * Método que seta os valores dos models vinculados ao usuário para null
         */
        function definirModelsVinculadosAoUsuarioParaNull() {
            vm.usuario = null;
            vm.consultaAtendimento.usuario = null;
            vm.consultaAtendimento.codigoUsuario = null;
            vm.textoDePesquisaAutoCompleteUsuario = "";
        }

        //////////////////////////////////////////////////////////// /Métodos Internos ///////////////////////////////////////////////////////////


        //////////////////////////////////////////////////////////// Métodos /////////////////////////////////////////////////////////////////////

        /**
         *
         * Método que faz uma requisicão para api passando um filtro e recebendo uma lista de atendimentos consultados
         * @param {*objeto} consultaAtendimento
         * @param {*event do botão} event
         */
        function pesquisar(consultaAtendimento, event) {
            vm.requisicaoSolicitada = true;
            RequisicaoGenericaService.listarComParams(Api.atendimento.consulta_atendimento.consultarAtendimentos, consultaAtendimento).then(
                function (success) {
                    if (success.data && success.data.length > 0) {
                        vm.listaAtendimentosConsultados = success.data;
                        vm.pesquisaAtiva = true;
                        vm.habilitarPesquisarHeaderPadrao = true;
                    }
                    else {
                        MdDialogService.alertPadrao("Não foi encontrado nenhum registro.");
                    }

                    vm.requisicaoSolicitada = false;
                },
                function (error) {
                    MdDialogService.alertPadrao(error.data);
                    vm.requisicaoSolicitada = false;
                });
        }

        /**
         * Método que limpa todos os campos e objetos para realizar uma nova pesquisa
         */
        function novaConsulta() {
            vm.listaAtendimentosConsultados = [];

            vm.habilitarPesquisarHeaderPadrao = false;
            vm.pesquisar = "";

            vm.pesquisaAtiva = false;
            vm.requisicaoSolicitada = false;

            vm.legendaSelecionada = null;
        }

        /**
         * Método que realiza uma requisição para api para buscar os clientes na em tempo de excução, * com base no que o usuário está digitando
         * @param {*query de pesquisa} query
         */
        function pesquisarAutoCompleteCliente(query) {
            return ServicosGenericoService.pesquisarAutoCompleteCodigoOuNomeGenericoApi(Api.cliente.listarCodigoDescricao, query);
        }

        /**
         * Método que controla qual cliente está selecionado no campo md-auto-complete do Cliente
         * e seta o codigo do cliente para o objeto de consulta 'vm.consultaAtendimento.codigoCliente'
         * @param {*cliente} item
         */
        function alterarItemSelecionadoAutoCompleteCliente(item) {
            if (item) {
                vm.cliente = item;
                vm.consultaAtendimento.codigoCliente = item.codigo;
                if (!vm.consultaAtendimento.codigoSolucao
                    || (item.solucoes.map(function (itemSolucao) { return itemSolucao.codigo }).indexOf(vm.relatorioAtendimento.codigoSolucao) == -1)) {
                    vm.solucoes = item.solucoes;
                    vm.textoDePesquisaAutoCompleteSolucao = "";
                }
            } else {
                vm.textoDePesquisaAutoCompleteCliente = "";
                vm.textoDePesquisaAutoCompleteSolucao = "";

                vm.consultaAtendimento.codigoSolucao = null;
                vm.consultaAtendimento.codigoCliente = null;

                vm.cliente = null;
                vm.solucao = null;

                vm.solucoes = todasSolucoes;
            }
        }

        /**
         * Método que limpa o texto de pesquisa do md-auto-complete do Cliente
         */
        function configuraAutoCompleteClienteOnBlur() {
            if (!vm.cliente) {
                vm.textoDePesquisaAutoCompleteCliente = "";
            }
        }

        /**
         * Método que busca na lista de solucoes e filtra as solucoes com base no que está sendo digitado com base no que o usuário está digitando
         * @param {*query de pesquisa} query
         */
        function pesquisarAutoCompleteSolucao(query) {
            return ServicosGenericoService.pesquisarAutoCompleteDescricaoGenerico(vm.solucoes, query)
        }

        /**
         * Método que controla qual solução está selecionada no campo md-auto-complete da Solução
         * e seta o codigo da solução para o objeto de consulta 'vm.consultaAtendimento.codigoSolucao'
         * @param {*solucao} item
         */
        function alterarItemSelecionadoAutoCompleteSolucao(item) {
            if (item) {
                vm.solucao = item;
                vm.consultaAtendimento.codigoSolucao = item.codigo;
            }
            else {
                vm.solucao = null;
                vm.consultaAtendimento.codigoSolucao = null;
                vm.textoDePesquisaAutoCompleteSolucao = "";
            }
        }

        /**
         * Método que limpa o texto de pesquisa do md-auto-complete da Solução
         */
        function configuraAutoCompleteSolucaoOnBlur() {
            if (!vm.solucao) {
                vm.textoDePesquisaAutoCompleteSolucao = "";
            }
        }

        /**
         * Método que busca na lista de usuarios e filtra usuarios com base no que está sendo digitado pelo usuário no md-autocomplete
         * @param {*query de pesquisa} query
         */
        function pesquisarAutoCompleteUsuario(query) {
            return ServicosGenericoService.pesquisarAutoCompleteCodigoOuNomeGenerico(ListarTodosUsuarios.data, query);
        }

        /**
         * Método que controla qual usuário está selecionado no campo md-auto-complete do usuário
         * e seta o codigo do usuário para o objeto de consulta 'vm.consultaAtendimento.codigoUsuario'
         * @param {*solucao} item
         */
        function alterarItemSelecionadoAutoCompleteUsuario(item) {
            if (item) {
                vm.consultaAtendimento.codigoUsuario = item.codigo;
                vm.consultaAtendimento.usuario = item;
            }
            else {
                definirModelsVinculadosAoUsuarioParaNull();
            }
        }

        /**
         * Método que limpa o texto de pesquisa do md-auto-complete do Colaborador
         */
        function configuraAutoCompleteUsuarioOnBlur() {
            if (!vm.usuario) {
                vm.textoDePesquisaAutoCompleteUsuario = "";
            }
        }

        /**
         * Método que filtra a tabela de acordo com a legenda selecionada
         * @param {legenda selecionada} item
         * @param {$index} index
         */
        function filtrarTabela(item, index) {
            if (vm.legendaSelecionada !== index) {
                arrayDePesquisa = item.descricaoTabela;
                vm.legendaSelecionada = index;

            } else {
                vm.legendaSelecionada = null;
                arrayDePesquisa = "";
            }
        }

        /**
         * Método para navegar para o atendimento passadando o codigo e o ano do atendimento
         * @param {atendimento selecionado} item
         * @param {$index} index
         */
        function navegarParaAtendimento(item, index) {
            $rootScope.atendimentosTemporariosConsultado = vm.listaAtendimentosConsultados;
            $rootScope.consultaAtendimentoTemporario = vm.consultaAtendimento;

            MenuFactory.navegarParaEstadoSeUsuarioTerAcesso('app.atendimento_processamento_atendimento',
                {
                    parametros: {
                        codigo: item.codigoAtendimento,
                        ano: item.anoAtendimento,
                        chamarPesquisa: true,
                        habilitarIconeVoltarAConsultaDeAtendimentos: true
                    }
                });
        }

        /**
         * Método chamado sempre quando o valor do radio group do tipo detalhe atendimento sofrer alteração
         * @param {tipoDetalheAtendimento selecionado} item
         */
        function ngChangeRadioGroupTipoDetalheAtendimento(item) {
            if (item == 2) {
                definirModelsVinculadosAoUsuarioParaNull();
            }
        }

        //////////////////////////////////////////////////////////// /Métodos ////////////////////////////////////////////////////////////////////

    } // Controller

})();


/**
 * Created by nova on 28/03/2017.
 */
(function () {
    'use strict';

    angular
        .module('app.atendimento.cadastro.pendencia', [])
        .config(config);

    function config($stateProvider, RotasHtml) {
        var rotasHtmlPendencia = RotasHtml.pendencia_atendimento;
        $stateProvider
            .state('app.atendimento_cadastro_pendencia', {
                url: '/atendimento/cadastro/pendencia',
                module: 'privado',
                views: {
                    'content@app': {
                        templateUrl: rotasHtmlPendencia.templateUrl,
                        controller: "PendenciaAtendimentoController as vm"
                    },
                    'pendencia-atendimento-form@app.atendimento_cadastro_pendencia': {
                        templateUrl: rotasHtmlPendencia.form
                    },
                    'pendencias-atendimento-tabela@app.atendimento_cadastro_pendencia': {
                        templateUrl: rotasHtmlPendencia.tabela
                    }
                }
            });
    }

})();

/**
 * Created by nova on 28/03/2017.
 */
(function () {
    'use strict';

    angular.module('app.atendimento.cadastro.pendencia')
        .controller('PendenciaAtendimentoController', PendenciaAtendimentoController);

    function PendenciaAtendimentoController(Api, NavegacaoService, RequisicaoGenericaService, DatatableFactory) {
        var vm = this;
        NavegacaoService.setTituloAba('Atendimento pendência');  

        // Data region    
        vm.form = {};
        vm.rota = Api.atendimento.pendencia_atendimento.proximoCodigo;
        // endregion


        // Definição dos Métodos region
        vm.metodos = {
            pesquisar: pesquisar,
            salvar: salvar,
            editar: editar,
            excluir: excluir,
            selecionar: selecionar,
            construirDtOptions: construirDtOptions
        }
        //endregion

        // Implementação dos Métodos region

        /**
         * Método para pequisar uma pendência de atendimento
         */
        function pesquisar() {
            return RequisicaoGenericaService.listarComObjetoComplexo(Api.atendimento.pendencia_atendimento.listarComPaginacao, vm.entidadeDeEnvio);
        }

        /**
         * Método para salvar uma pendência de atendimento
         * @param {pendenciaAtendimento} modelo 
         */
        function salvar(modelo) {
            return RequisicaoGenericaService.salvar(Api.atendimento.pendencia_atendimento.criar, modelo);
        }

        /**
         * Método para editar uma pendência de atendimento
         * @param {pendenciaAtendimento} modelo 
         */
        function editar(modelo) {
            return RequisicaoGenericaService.editar(Api.atendimento.pendencia_atendimento.atualizar, modelo)
        }

        /**
         * Método para excluir uma pendência de atendimento
         * @param {pendenciaAtendimento} modelo 
         */
        function excluir(modelo) {
            return RequisicaoGenericaService.excluir(Api.atendimento.pendencia_atendimento.excluir, modelo.codigo)
        }

        /**
         * Método utilizado no modo exibido tabela, para selecionar uma pendência de atendimento
         * @param {pendenciaAtendimento} modelo 
         */
        function selecionar(posicaoEntidade) {
            vm.metodosExternosPgToolbar.metodoControladorExternoListarTodasEntidades(null, posicaoEntidade);
        }

        /**
         * Método para construi o DtOptions da tabela
         */
        function construirDtOptions() {
            DatatableFactory.construirDtOptionsComPaginacaoProcessadoNoServidorParaToolbar
                (Api.atendimento.pendencia_atendimento.listarComPaginacaoDatatable, vm.entidadeDeEnvio.clsEntidade, '#datatable-pendencia',
                [
                    DatatableFactory.construirColunaDeSelecionarPadrao(function (indexLinha) { vm.metodos.selecionar(indexLinha) }),
                    {
                        targets: 1,
                        name: "Codigo",
                        data: "codigo",
                        sortable: false  
                    },
                    {
                        targets: 2,
                        name: "Descricao",
                        data: "descricao",
                        sortable: false                          
                    }
                ]);
        }
        //endregion

    }
})();

//<!-- Ultima mudança 31/03/2017.-->
(function () {
    'use strict';

    angular
        .module('app.atendimento.cadastro.configuracaoAtendimento', [])
        .config(config);

    function config($stateProvider, RotasHtml) {
        var rotasHtml = RotasHtml.configuracao_atendimento;
        $stateProvider
            .state('app.atendimento_configuracao_atendimento', {
                url: '/atendimento/processamento/configuracao-atendimento',
                module: 'privado_gerencia',
                views: {
                    'content@app': {
                        templateUrl: rotasHtml.templateUrl,
                        controller: "ConfiguracaoAtendimentoController as vm"
                    },
                    'configuracao-atendimento-form@app.atendimento_configuracao_atendimento': {
                        templateUrl: rotasHtml.form
                    }
                }
            });
    }

})();

(function () {
    'use strict';

    angular
        .module('app.atendimento.cadastro.configuracaoAtendimento')
        .controller('ConfiguracaoAtendimentoController', ConfiguracaoAtendimentoController);

    /** @ngInject */
    function ConfiguracaoAtendimentoController(Api, NavegacaoService, RequisicaoGenericaService) {

        var vm = this;

        //////////////////////////////////////////// DATA //////////////////////////////////////////////// 
        vm.form = {};


        init();
        //////////////////////////////////////////////////////////////////////////////////////////////////


        var init = init;
        vm.metodos = {
            pesquisar: pesquisar,
            editar: editar
        }

        /**
         * Método inicializador do controller
         */
        function init() {
            NavegacaoService.setTituloAba('Atendimento configuração');  

            vm.configuracaoAtendimento = {
                chamarPesquisa: true
            }
        }

        /**
         * Método para buscar as configurações do Atendimento
         */
        function pesquisar() {            
            return RequisicaoGenericaService.listarSemParams(Api.atendimento.configuracao_atendimento.listarConfiguracao);
        }

        /**
         * Método que realiza uma chamada para Api para editar as configurações do atendimento
         */
        function editar(modelo) {
            return RequisicaoGenericaService.editar(Api.atendimento.configuracao_atendimento.atualizar, modelo);
        }
    }

})();

/**
 * Created by nova on 18/07/2016.
 */
(function () {
    'use strict';

    angular
        .module('app.atendimento.cadastro.motivoAtendimento', [])
        .config(config);

    function config($stateProvider, RotasHtml) {
        var rotasHtmlMotivo = RotasHtml.motivo_atendimento
        $stateProvider
            .state('app.atendimento_cadastro_grupo', {
                url: '/atendimento/cadastro/grupo',
                module: 'privado',
                views: {
                    'content@app': {
                        templateUrl: rotasHtmlMotivo.templateUrl,
                        controller: "MotivoAtendimentoController as vm"
                    },
                    'motivo-atendimento-form@app.atendimento_cadastro_grupo': {
                        templateUrl: rotasHtmlMotivo.form
                    },
                    'motivos-atendimento-tabela@app.atendimento_cadastro_grupo': {
                        templateUrl: rotasHtmlMotivo.tabela
                    }
                },
                resolve: {
                    ListarSetores: function (Api, RequisicaoGenericaService) {
                        return RequisicaoGenericaService.listarSemParams(Api.setor.listarCodigoDescricao);
                    },
                }
            });
    }

})();

/**
 * Created by nova on 28/03/2017.
 */
(function () {
  'use strict';

  angular.module('app.atendimento.cadastro.motivoAtendimento')
    .controller('MotivoAtendimentoController',GrupoController);

  function GrupoController(Api,NavegacaoService,RequisicaoGenericaService,DatatableFactory,ListarSetores) {
    var vm = this;
    vm.grupoAtendimento = { inativo: false }
    vm.rota = Api.atendimento.grupo_atendimento.proximoCodigo;
    NavegacaoService.setTituloAba('Atendimento motivo');


    // Data region
    vm.form = {};

    vm.setores = ListarSetores.data;
    vm.entidadeEnvio = {};
    vm.atendimentoMotivoSetores = []
    // endregion;

    // Definição dos Métodos region
    vm.metodos = {
      pesquisar: pesquisar,
      salvar: salvar,
      editar: editar,
      excluir: excluir,
      selecionar: selecionar,
      construirDtOptions: construirDtOptions,
      metodoExternoAcaoNovaPesquisa: metodoExternoAcaoNovaPesquisa,
      definirAtivo: definirAtivo,
    };
    //endregion

    // Implementação dos Métodos region

    /**
     * Método para pesquisar um motivo de atendimento
     */
    function pesquisar() {
      return RequisicaoGenericaService.listarComObjetoComplexo(Api.atendimento.grupo_atendimento.listarComPaginacao,vm.entidadeDeEnvio);
    }

    /**
     * Método para salvar um motivo de atendimento
     * @param {atendimentoMotivo} modelo
     */

    // vm.teste = intTotalResultado.lstResultado.atendimentoMotivoSetores;
    function montarObjeto(modelo) {
      vm.atendimentoMotivoSetores = [];

      if(modelo.codigoSetor != undefined){
        modelo.codigoSetor.forEach(function (element) {
          vm.entidadeEnvio.setorCodigo = element;
          vm.entidadeEnvio.AtendimentoMotivoCodigo = modelo.codigo;
          vm.atendimentoMotivoSetores.push(angular.copy(vm.entidadeEnvio));
  
        });
        modelo.atendimentoMotivoSetores = vm.atendimentoMotivoSetores;
      }
    };

    function salvar(modelo) {
      montarObjeto(modelo);
      return RequisicaoGenericaService.salvar(Api.atendimento.grupo_atendimento.criar,modelo);
    }

    /**
     * Método para editar um motivo de atendimento
     * @param {atendimentoMotivo} modelo
     */
    function editar(modelo) {
      montarObjeto(modelo);
      return RequisicaoGenericaService.editar(Api.atendimento.grupo_atendimento.atualizar,modelo);
    }

    /**
     * Método para excluir um motivo de atendimento
     * @param {atendimentoMotivo} modelo
     */
    function excluir(modelo) {
      return RequisicaoGenericaService.excluir(Api.atendimento.grupo_atendimento.excluir,modelo.codigo)
    }

    /**
     * Método utilizado no modo exibido tabela, para selecionar um motivo de atendimento
     * @param {atendimentoMotivo} modelo
     */
    function selecionar(posicaoEntidade) {
      vm.metodosExternosPgToolbar.metodoControladorExternoListarTodasEntidades(null,posicaoEntidade);
    }

    function metodoExternoAcaoNovaPesquisa() {
      vm.grupoAtendimento = { inativo: false };
    }

    function definirAtivo() {
      vm.grupoAtendimento = { inativo: false };
    }

    /**
     * Método para construi o DtOptions da tabela
     */
    function construirDtOptions() {
      DatatableFactory.construirDtOptionsComPaginacaoProcessadoNoServidorParaToolbar(
        Api.atendimento.grupo_atendimento.listarComPaginacaoDatatable,
        vm.entidadeDeEnvio.clsEntidade,
        "#datatable-motivo-atendimento",
        [
          DatatableFactory.construirColunaDeSelecionarPadrao(function (
            indexLinha
          ) {
            vm.metodos.selecionar(indexLinha);
          }),
          {
            targets: 1,
            name: "Codigo",
            data: "codigo",
            sortable: false
          },
          {
            targets: 2,
            name: "Titulo",
            data: "titulo",
            sortable: false
          },
          {
            targets: 3,
            defaultContent: "",
            name: "Descricao",
            data: "descricao",
            sortable: false
          },
          {
            targets: 4,
            defaultContent: "",
            name: "CodigoSetor",
            data: "setor.descricao",
            sortable: false
          },
          {
            targets: 5,
            defaultContent: "",
            name: "Inativo",
            data: "inativo",
            sortable: false,
            render: function (data) {
              if (data) return "Sim";
              else return "Não";
            }
          }
        ]
      );
    }
    //endregion

  }
})();

(function () {
    'use strict';

    angular
        .module('app.atendimento.cadastro.tag', [])
        .config(config);

    function config($stateProvider, RotasHtml) {
        var rotasTagHtml = RotasHtml.tag_atendimento;
        $stateProvider
            .state('app.atendimento_cadastro_tag', {
                url: '/atendimento/cadastro/tag',
                module: 'privado',
                views: {
                    'content@app': {
                        templateUrl: rotasTagHtml.templateUrl,
                        controller: "TagAtendimentoController as vm"
                    },
                    'tag-atendimento-form@app.atendimento_cadastro_tag': {
                        templateUrl: rotasTagHtml.form
                    },
                    'tag-atendimento-tabela@app.atendimento_cadastro_tag': {
                        templateUrl: rotasTagHtml.tabela
                    }
                },
                resolve: {
                    ListarDetalhesUsuarioESolucoes: function (Api, RequisicaoGenericaService, LoginUsuarioService, $q) {
                        return RequisicaoGenericaService.listarSemParams(Api.usuario.detalhes_usuario.listarDetalhesUsuario
                            + LoginUsuarioService.usuarioArmazenado().codigo)
                            .then(function (detalhesUsuario) {
                                var codigoSquads = detalhesUsuario.data.codigoSquads || [];
                                var entidadeEnvio = {
                                    codigoCliente: null,
                                    codigoSquads: Array.isArray(codigoSquads) ? codigoSquads : [codigoSquads],
                                    exibirSolucaoComSquad: true
                                };
                                return RequisicaoGenericaService.listarPorPaginacaoJsonFormato(
                                    Api.solucao_rotinas_tarefas.solucao.listarPorSquadCliente,
                                    entidadeEnvio
                                ).then(function (solucoesResponse) {
                                    return {
                                        detalhesUsuario: detalhesUsuario.data,
                                        solucoes: solucoesResponse.data
                                    };
                                });
                            })
                            .catch(function (error) {
                                console.error('Erro no resolve:', error);
                                return $q.reject(error);
                            });
                    }
                }

            });
    }

})();


(function () {
    'use strict';

    angular.module('app.atendimento.cadastro.tag')
        .controller('TagAtendimentoController', TagAtendimentoController);

    function TagAtendimentoController(Api, NavegacaoService, RequisicaoGenericaService, DatatableFactory, ListarDetalhesUsuarioESolucoes, ListarCoresTagsAtendimento) {
        var vm = this;
        NavegacaoService.setTituloAba('Tag de atendimento');
        vm.form = {};
        vm.corIdentificacao = null;
        vm.corSelecionada = null;
        vm.listaSolucoes = ListarDetalhesUsuarioESolucoes.solucoes;
        vm.cores = ListarCoresTagsAtendimento;
        vm.metodos = {
            pesquisar: pesquisar,
            salvar: salvar,
            editar: editar,
            excluir: excluir,
            selecionar: selecionar,
            construirDtOptions: construirDtOptions,
            selecionarCor: selecionarCor,
            configuraMdSelectSolucoes: configuraMdSelectSolucoes
        }

        vm.metodosGeral = {
            preDefinirCamposParaInserir: preDefinirCamposParaInserir,
        };

        function configuraMdSelectSolucoes() {
            vm.filtrarSolucoes = "";
            angular.element('#solucoes-md-select').on('keydown', function (ev) {
                ev.stopPropagation();
            });
        }

        function preDefinirCamposParaInserir() {
            vm.tagAtendimento = {};
            vm.tagAtendimento.ativa = true;
        }

        function selecionarCor(cor) {
            vm.corSelecionada = cor.fonte;
            const formField = vm.form.tagAtendimento.corIdentificacao;
            if (formField) {
                formField.$setViewValue(cor.background);
                formField.$render();
            }
        }

        function pesquisar() {
            if (vm.entidadeDeEnvio.clsEntidade && vm.entidadeDeEnvio.clsEntidade.solucoes && vm.entidadeDeEnvio.clsEntidade.solucoes.length === 0) {
                delete vm.entidadeDeEnvio.clsEntidade.solucoes;
            };
            return RequisicaoGenericaService.listarComObjetoComplexo(Api.atendimento.tag.listarComPaginacao, vm.entidadeDeEnvio);
        }

        function salvar(modelo) {
            return RequisicaoGenericaService.salvar(Api.atendimento.tag.criar, modelo);
        }

        function editar(modelo) {
            return RequisicaoGenericaService.editar(Api.atendimento.tag.atualizar, modelo);
        }

        function excluir(modelo) {
            return RequisicaoGenericaService.excluir(Api.atendimento.tag.excluir, modelo.codigo);
        }

        function selecionar(posicaoEntidade) {
            vm.metodosExternosPgToolbar.metodoControladorExternoListarTodasEntidades(null, posicaoEntidade);
        }

        function construirDtOptions() {
            DatatableFactory.construirDtOptionsComPaginacaoProcessadoNoServidorParaToolbar
                (Api.atendimento.tag.listarComPaginacaoDatatable, vm.entidadeDeEnvio.clsEntidade, '#datatable-tag-atendimento',
                    [
                        DatatableFactory.construirColunaDeSelecionarPadrao(function (indexLinha) { vm.metodos.selecionar(indexLinha) }),
                        {
                            targets: 1,
                            name: "Codigo",
                            data: "codigo",
                            sortable: true
                        },
                        {
                            targets: 2,
                            name: "Descricao",
                            data: "descricao",
                            sortable: false
                        }
                    ]);
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.agenda.processamento.visualizarAtividades')
        .controller('VisualizarAtividadesController', VisualizarAtividadesController);

    function VisualizarAtividadesController(
        $mdDialog,
        NavegacaoService,
        $scope,
        $document,
        $rootScope,
        MdToastAtividadeService,
        DataService,
        RequisicaoGenericaService,
        Api,
        LoginUsuarioService,
        VisualizarAtividadeService,
        ListarStatus,
        ListarTodosEventos,
        ListarAtividadesPorUsuario,
        ListarAtividadesPorCliente,
        ListarTodosUsuarios,
        parametros,
        ListarDetalhesUsuario,
        SquadService) {
        var vm = this;

        init();

        vm.metodos = {
            configuraMdSelectUsuarioAtivo: configuraMdSelectUsuarioAtivo,
            alterarModoVisualizacao: alterarModoVisualizacao,
            carregarAtividades: carregarAtividades,
            proximo: proximo,
            anterior: anterior,
            irParaHoje: irParaHoje,
            exibirLegenda: exibirLegenda,
            cadastrarAtividade: cadastrarAtividade,
            recarregarAtividades: recarregarAtividades,
            fecharDialog: fecharDialog,
            onChangeSquad: onChangeSquad
        }



        $scope.$watch('vm.dataSelecionada', function () {
            if (!vm.dataSelecionada)
                return;

            if (vm.dataSelecionada)
                vm.calendar.gotoDate(vm.dataSelecionada)
            var novoMes = vm.dataSelecionada.getMonth() + 1;
            var novoAno = vm.dataSelecionada.getFullYear();

            if (novoMes !== vm.mesSelecionado || novoAno !== vm.anoSelecionado) {
                carregarAtividades(vm.atividade.usuarioAtivo.codigo, novoMes, novoAno);
                vm.mesSelecionado = novoMes;
                vm.anoSelecionado = novoAno;
            }
        });


        $rootScope.$on('atividadeReagendada', function (event, atividade) {
            carregarAtividades(vm.atividade.usuarioAtivo.codigo)
        });

        $rootScope.$on('atividadeCadastrada', function (event, data) {
            carregarAtividades(vm.atividade.usuarioAtivo.codigo)
        })

        function init() {
            vm.eventoMouseOver = "";
            vm.parametros = parametros;
            vm.mesSelecionado = DataService.dataAtual;
            vm.anoSelecionado = DataService.anoAtual;
            vm.events = [];
            vm.emProgresso = false;
            vm.exibeCalendario = "";
            vm.atividade = {
                usuarioAtivo: LoginUsuarioService.usuarioArmazenado()
            };
            vm.usuariosAtivos = ListarTodosUsuarios.data;
            vm.squadUsuarioLogado = ListarDetalhesUsuario.data.codigoSquads;
            vm.codigoSquads = ListarDetalhesUsuario.data.codigoSquads;
            vm.squads = SquadService.listarSquadsUsuarioLogado(vm.squadUsuarioLogado);
            vm.usuarios = vm.usuariosAtivos.filter(function (usuarios) {
                return usuarios.codigoSquads.some(function (codigoSquad) {
                    return vm.codigoSquads.includes(codigoSquad)
                })
            });

            if (vm.parametros != null) {
                _carregarAtividades(ListarAtividadesPorCliente);
            }

            else {
                NavegacaoService.setTituloAba('Agenda visualização');
                _carregarAtividades(ListarAtividadesPorUsuario.data);
            }

            construirUiCalendar();
        }

        function construirUiCalendar() {
            // setTimeout(function () {
            vm.calendarUiConfig = {
                calendar: {
                    locale: 'pt-br',
                    axisFormat: 'HH:mm',
                    timeFormat: 'HH:mm',
                    editable: false,
                    height: vm.parametros != null ? 750 : 1200, // 750 visão cliente e atendimento 1200 vsão colaborador
                    eventLimit: true,
                    allDay: 'Teste',
                    minTime: '07:00',
                    maxTime: '20:00',
                    header: '',
                    handleWindowResize: false,
                    aspectRatio: 1,
                    dayNames: ['Domingo', 'Segunda', 'Terça', 'Quarta', 'Quinta', 'Sexta', 'Sábado'],
                    dayNamesShort: ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sab'],
                    viewRender:
                        function (view) {
                            vm.calendarView = view;
                            vm.calendar = vm.calendarView.calendar;
                            vm.currentMonthShort = vm.calendar.getDate().format('MMM')
                        },
                    columnFormat: {
                        month: 'ddd',
                        week: 'ddd D',
                        day: 'dddd'
                    },
                    eventClick: eventDetail,
                    selectable: true,
                    selectHelper: true,
                    selectOverlap: false,
                    select: select,
                    eventMouseover: function (event, element, view) {
                        exibeDetalhes(event, element, view);
                    },
                    eventMouseout: function (event, element, view) {
                        ocultaDetalhes(event, element);
                    }
                }
            }
            // },300);
        }

        function exibeDetalhes(atividade, e, view) {
            if (MdToastAtividadeService.isOpen) {
                MdToastAtividadeService.dimiss().then(function () {
                    MdToastAtividadeService.isOpen = false;
                    MdToastAtividadeService.show(atividade);
                })
            } else {
                MdToastAtividadeService.show(atividade);
            }
        }

        function ocultaDetalhes(atividade, element) {
            MdToastAtividadeService.dimiss(atividade);
        }

        function configuraMdSelectUsuarioAtivo() {
            vm.filtrarUsuariosAtivo = "";
            angular.element('#visualizar-atividade-usuarios-ativos-md-select').on('keydown', function (ev) {
                ev.stopPropagation();
            });
        }

        function alterarModoVisualizacao(modo) {
            vm.calendar.changeView(modo);
        }

        function proximo() {
            return _navegar('next');
        }

        function anterior() {
            return _navegar('prev');
        }

        function _navegar(direcao) {
            if (direcao == 'next')
                vm.calendarView.calendar.next();

            if (direcao == 'prev')
                vm.calendarView.calendar.prev();

            if (direcao == 'today')
                vm.calendar.today()

            var mesSelecionado = _retornaDataCalendario().getMonth() + 1;

            if (mesSelecionado != vm.mesSelecionado) {
                carregarAtividades(vm.atividade.usuarioAtivo.codigo, mesSelecionado)
                vm.mesSelecionado = mesSelecionado;
            }
        }

        function _retornaDataCalendario() {
            return vm.calendarView.calendar.getDate().toDate();
        }

        function eventDetail(calendarEvent, e) {
            showEventDetailDialog(calendarEvent, e);
        }

        function carregarAtividades(codigo, mes, ano) {
            var rota = Api.agenda.atividade.listarAtividadesPorColaborador + '?codigoUsuario=' + codigo;

            if (vm.parametros != null && vm.parametros.cliente) {
                codigo = vm.parametros.cliente.codigo;
                rota = Api.agenda.atividade.listarAtividadesPorCliente + '?codigoCliente=' + codigo;
            }

            if (!mes)
                mes = vm.mesSelecionado;

            if (!ano) {
                if (vm.dataSelecionada && (vm.dataSelecionada.getMonth() + 1 === mes)) {
                    ano = vm.dataSelecionada.getFullYear();
                } else {
                    var dataAtualCalendario = _retornaDataCalendario();
                    ano = dataAtualCalendario.getFullYear();
                }
            }

            vm.emProgresso = true;

            RequisicaoGenericaService.listarSemParams(rota +
                '&mes=' + mes +
                '&ano=' + ano)
                .then(function (success) {
                    vm.emProgresso = false;
                    _carregarAtividades(success.data);
                }).catch(function (erro) {
                    vm.emProgresso = false;
                });
        }



        function select(start, end, e) {
            console.log('selecionou...', e);
            // showEventFormDialog('add', false, start, end, e);
        }

        function irParaHoje() {
            vm.calendar.changeView('agendaDay')
            return _navegar('today');
        }

        function _carregarAtividades(atividades) {

            // Altera cor da atividade quando for ausente
            atividades.map(function (atividade) {
                if (atividade.status == 1 && (atividade.codigoEvento == 63 ||
                    atividade.codigoEvento == 64 ||
                    atividade.codigoEvento == 65)) {
                    atividade.color = "#FF9800";
                }
            });

            vm.events.length = 0;
            vm.events.push(atividades);
        }

        function showEventDetailDialog(calendarEvent, e) {
            $mdDialog.show({
                controller: 'DialogDetalhesAtividadesController',
                controllerAs: 'vm',
                templateUrl: 'app/main/agenda/processamento/visualizar-atividades/dialogs/detalhes-atividade/dialog-detalhes-atividades.html',
                parent: angular.element($document.body),
                targetEvent: e,
                multiple: true,
                clickOutsideToClose: true,
                locals: {
                    calendarEvent: angular.copy(calendarEvent),
                    event: e,
                    status: ListarStatus.data,
                    eventos: ListarTodosEventos.data,
                    codigoColaboradorLogado: LoginUsuarioService.usuarioArmazenado().codigo
                }
            });
        }

        function exibirLegenda() {
            $mdDialog.show({
                controller: 'DialogLegendaController',
                controllerAs: 'vm',
                multiple: true,
                templateUrl: 'app/main/agenda/processamento/visualizar-atividades/dialogs/legenda/dialog-legenda.html',
                targetEvent: event,
                clickOutsideToClose: true,
                locals: {
                    RotinaVisualizacaoAtividade: true
                }
            });
        }


        function cadastrarAtividade(event) {
            var cliente = null;

            if (vm.parametros != null) {
                if (vm.parametros.cliente)
                    cliente = vm.parametros.cliente;

                if (vm.parametros.atendimento)
                    vm.atividade.atendimento = vm.parametros.atendimento;
            }

            VisualizarAtividadeService
                .abrirCadastroAtividade(event,
                    vm.atividade, ListarTodosEventos, ListarStatus, false, false, cliente);
        }

        function recarregarAtividades() {
            carregarAtividades(vm.atividade.usuarioAtivo.codigo, vm.mesSelecionado);
        }

        function fecharDialog() {
            $mdDialog.hide();
        }

        function onChangeSquad(codigoSquadSelecionada) {
            if (codigoSquadSelecionada && codigoSquadSelecionada.length > 0) {
                var usuarios = vm.usuariosAtivos.filter(function (usuarios) {
                    return usuarios.codigoSquads.some(function (codigoSquad) {
                        return codigoSquadSelecionada.includes(codigoSquad)
                    })
                });
                vm.usuarios = usuarios;
            } else {
                vm.usuarios = [];
                var usuario = vm.usuariosAtivos.find(function (usuario) { return usuario.codigo == vm.atividade.usuarioAtivo.codigo });
                vm.usuarios.push(usuario);
            }
        }
    }

})();
/**
 * Created by nova on 28/03/2017.
 */
(function () {
    'use strict';

    angular
        .module('app.agenda.processamento.atividade', [])
        .config(config);

    function config($stateProvider, RotasHtml) {
        var rotasHtmlAtividade = RotasHtml.agenda.atividade;
        $stateProvider
            .state('app.atividade_cadastro', {
                url: '/agenda/cadastro/atividade',
                module: 'privado',
                params: {
                    parametros: null
                },
                views: {
                    'content@app': {
                        templateUrl: rotasHtmlAtividade.templateUrl,
                        controller: "AtividadeController as vm"
                    },
                    'atividade-form@app.atividade_cadastro': {
                        templateUrl: rotasHtmlAtividade.form
                    },
                    'atividade-tabela@app.atividade_cadastro': {
                        templateUrl: rotasHtmlAtividade.tabela
                    }
                },
                resolve: {
                    ListarTodosEventos: function (Api, RequisicaoGenericaService) {
                        return RequisicaoGenericaService.listarSemParams(Api.agenda.evento.listarTodos);
                    }, ListarStatus: function (Api, RequisicaoGenericaService) {
                        return RequisicaoGenericaService.listarSemParams(Api.agenda.atividade.listarStatus);
                    },
                    Atividade: function () { return { atendimento: {} } },
                    Clonando: function () { return false },
                    DesabilitarCampos: function () { return false },
                    Cliente: function () { return null },
                    DesabilitarAtendimento: function () { return false }
                }
            });
    }

})();

/**
 * Created by nova on 28/03/2017.
 */
(function () {
    'use strict';

    angular.module('app.agenda.processamento.atividade')
        .controller('AtividadeController', AtividadeController);

    function AtividadeController($scope, NavegacaoService, Api, $mdDialog, $rootScope, $state, RequisicaoGenericaService, MdToastService, $stateParams, DatatableFactory, ListarTodosEventos, MdDialogService, ListarStatus,
        LoginUsuarioService, ServicosGenericoService, Atividade, Clonando, DesabilitarCampos, Cliente, DesabilitarAtendimento) {

        var vm = this;
        vm.regexHora = /^(([1]{1}[0-8]{1}){1}|([0]{1}[7-9]){1}){1}:[0-5]{1}[0-9]{1}$/;
        vm.desabilitarCampos = DesabilitarCampos;
        vm.desabilitarAtendimento = DesabilitarAtendimento;
        var rotas = Api.agenda.atividade;

        // Definição dos Métodos region
        vm.metodos = {
            pesquisar: pesquisar,
            salvar: salvar,
            salvarDialog: salvarDialog,
            editar: editar,
            selecionar: selecionar,
            construirDtOptions: construirDtOptions,
            pesquisarAutoCompleteCliente: pesquisarAutoCompleteCliente,
            alterarItemSelecionadoAutoCompleteCliente: alterarItemSelecionadoAutoCompleteCliente,
            configuraAutoCompleteClienteOnBlur: configuraAutoCompleteClienteOnBlur,
            configuraMdSelectAtendimento: configuraMdSelectAtendimento,
            configuraMdSelectEvento: configuraMdSelectEvento,
            configuraMdSelectStatus: configuraMdSelectStatus,
            configurarMdSelectAtendimentoOnClose: configurarMdSelectAtendimentoOnClose,
            configurarMdSelectEventoOnClose: configurarMdSelectEventoOnClose,
            configurarMdSelectStatusOnClose: configurarMdSelectStatusOnClose,
            selecionarAtendimento: selecionarAtendimento,
            selecionarEvento: selecionarEvento,
            selecionarStatus: selecionarStatus,
            listarAssuntoAtendimento: listarAssuntoAtendimento,
            acaoPosEditar: acaoPosEditar,
            preDefinirInserir: preDefinirInserir,
            removerAtendimento: removerAtendimento
        }
        //endregion

        init();

        function init() {

            NavegacaoService.setTituloAba('Agenda atividade');
            vm.clonando = Clonando;
            vm.mindate = new Date();
            vm.controleForm = {};
            vm.textoPesquisaAtendimento = "Não existe atendimentos vinculados ao cliente";
            vm.form = {};
            vm.atendimentos = [];
            vm.atividade = {
                atendimento: {}
            };

            if (Atividade) {
                vm.atividade = Atividade;
                if (vm.atividade.cliente)
                    _listarTodosAtendimentoCliente(vm.atividade.cliente.codigo)
            }

            if (vm.clonando == undefined || !vm.clonando) {
                vm.atividade.atividadeVinculadaAtendimento = true;
            } else {
                if (vm.atividade.atividadeVinculadaAtendimento == undefined)
                    vm.atividade.atividadeVinculadaAtendimento = false;
            }

            if ($stateParams.parametros) {
                vm.atividade.numero = $stateParams.parametros.numero;
                vm.atividade.ano = $stateParams.parametros.ano;
                vm.inicializaChamandoPesquisa = $stateParams.parametros.chamarPesquisa;
            }
            if ($state.params.parametros) {
                vm.atividade.numero = $state.params.parametros.numero;
                vm.atividade.ano = $state.params.parametros.ano;
                vm.inicializaChamandoPesquisa = $state.params.parametros.chamarPesquisa;
            }

            vm.eventos = ListarTodosEventos.data;
            vm.entidadeDeEnvio = {
                intTamanhoPagina: 1,
                clsEntidade: vm.atividade
            };
            vm.codigoUsuario = LoginUsuarioService.usuarioArmazenado().codigo;
            vm.status = ListarStatus.data;
            vm.minDateDataAtividade = new Date();
            vm.carregandoAtendimento = false;

            if (Cliente) {
                vm.inicializouComCliente = Cliente != null;
                vm.atividade.cliente = Cliente;
                vm.codigoCliente = Cliente.codigo;
            }
        }

        $scope.$watch('vm.codigoCliente', function () {
            if (vm.codigoCliente > 0) {
                _listarTodosAtendimentoCliente(vm.codigoCliente);
            }
        })

        // Implementação dos Métodos region

        function pesquisar() {
            return RequisicaoGenericaService.listarComObjetoComplexo(rotas.listarPaginacao, vm.entidadeDeEnvio);
        }


        function salvar(modelo) {
            modelo = _preaparaModelo(modelo);
            var rota = rotas.criar + "/" + Clonando;
            return RequisicaoGenericaService.salvar(rota, modelo);
        }

        function salvarDialog(modelo) {
            vm.controleForm.emProgresso = true;
            modelo = _preaparaModelo(modelo);
            var rota = rotas.criar + "/" + Clonando;
            RequisicaoGenericaService.salvar(rota, modelo).then(function (success) {
                vm.controleForm.emProgresso = false;
                MdToastService.toastPadrao("Atividade cadastrada com sucesso!");
                if (success && success.data && success.data.mensagem) {
                    MdDialogService.alertPadrao("Atenção", null, success.data.mensagem);
                }
                $rootScope.$emit('atividadeCadastrada', success.data.agendamento);
                $mdDialog.hide();
            }).catch(function (erro) {
                vm.controleForm.emProgresso = false;
                MdDialogService.alertPadrao("Atenção", event, erro.data);
            });
        }

        function editar(modelo) {
            _preaparaModelo(modelo);
            return RequisicaoGenericaService.editar(rotas.atualizar, modelo)
        }

        function selecionar(posicaoEntidade) {
            vm.metodosExternosPgToolbar.metodoControladorExternoListarTodasEntidades(null, posicaoEntidade);
        }

        function _retornaStatusPeloValue(iVal) {
            var result = "";
            vm.status.forEach(function (item) {
                if (item.value == iVal && item.key.length) {
                    result = item.key;
                }
            });

            return result;
        }

        function construirDtOptions() {
            DatatableFactory.construirDtOptionsComPaginacaoProcessadoNoServidorParaToolbar
                (rotas.listarComPaginacaoDatatable, vm.entidadeDeEnvio.clsEntidade, '#datatable-atividade',
                    [
                        DatatableFactory.construirColunaDeSelecionarPadrao(function (indexLinha) { vm.metodos.selecionar(indexLinha) }),
                        {
                            targets: 1,
                            name: "Ano",
                            data: "ano",
                            sortable: false
                        },
                        {
                            targets: 2,
                            name: "Numero",
                            data: "numero",
                            sortable: false
                        },

                        {
                            targets: 3,
                            name: "Evento",
                            data: "evento",
                            render: function (evento) {
                                return evento.descricao;
                            }
                        },
                        {
                            targets: 4,
                            name: "Status",
                            data: "status",
                            render: function (status) {
                                if (status)
                                    return _retornaStatusPeloValue(status);
                            },
                            defaultContent: ""
                        },
                        {
                            targets: 5,
                            name: "Data",
                            data: "ultimoHistorico.data",
                            render: function (data) {
                                if (data) {
                                    return new Date(data).toLocaleDateString();
                                }

                            }
                        }

                    ]);
        }

        function pesquisarAutoCompleteCliente(query) {
            return ServicosGenericoService.pesquisarAutoCompleteCodigoOuNomeGenericoApi(Api.cliente.listarCodigoDescricao, query);
        }

        /**
         * Método que controla qual cliente está selecionado no campo md-auto-complete do Cliente
         * e seta o codigo do cliente para o objeto de consulta 'vm.consultaAtendimento.codigoCliente'
         * @param {*cliente} item
         */
        function alterarItemSelecionadoAutoCompleteCliente(item) {
            if (item) {
                vm.codigoCliente = item.codigo;
                _listarTodosAtendimentoCliente(vm.codigoCliente);
            } else {
                vm.textoDePesquisaAutoCompleteCliente = "";
                vm.textoDePesquisaAutoCompleteSolucao = "";
                if (vm.atividade) {
                    vm.atividade.cliente = null;
                    vm.atividade.atendimento = null;
                }
                vm.atendimentos = [];
            }
        }

        function listarAssuntoAtendimento(assunto) {
            if (assunto) {
                if (assunto.length < 50)
                    return assunto
                else
                    return assunto.substring(0, 50) + "...";
            }
        }

        function acaoPosEditar() {
            vm.controleForm.editarAtivo = false;
        }

        function preDefinirInserir() {
            if (vm.codigoUsuario == null)
                return;

            vm.controleForm.emProgresso = true;

            RequisicaoGenericaService.listarSemParams(rotas.verificaAgendamentoVencidos + "?codigoUsuario=" + vm.codigoUsuario).then(
                function (success) {
                    vm.controleForm.emProgresso = false;
                },
                function error(error) {
                    vm.controleForm.emProgresso = false;
                    MdDialogService.alertPadrao("Atividades Vencidas !", null, error.data);
                    vm.controleForm = {
                        inserirAtivo: false,
                        editarAtivo: false
                    }
                }
            );

            _limpaFormulario();
            vm.atividade.atividadeVinculadaAtendimento = true;
        }


        function configuraAutoCompleteClienteOnBlur() {
            if (!vm.atividade.cliente) {
                vm.textoDePesquisaAutoCompleteCliente = "";
            }
        }

        function configurarMdSelectAtendimentoOnClose() {
            vm.filtrarAtendimentos = "";
        }

        function configurarMdSelectStatusOnClose() {
            vm.filtrarStatus = "";
        }

        function configurarMdSelectEventoOnClose() {
            vm.filtrarEvento = "";
        }


        function configuraMdSelectAtendimento() {
            vm.atividade.atendimento = null;
            vm.filtrarAtendimentos = "";
            angular.element('#atendimento-md-select').on('keydown', function (ev) {
                ev.stopPropagation();
            });
        }

        function configuraMdSelectEvento() {
            vm.atividade.evento = null;
            vm.filtrarEvento = "";
            angular.element('#evento-md-select').on('keydown', function (ev) {
                ev.stopPropagation();
            });
        }

        function configuraMdSelectStatus() {
            vm.atividade.status = null;
            vm.filtrarStatus = "";
            angular.element('#status-md-select').on('keydown', function (ev) {
                ev.stopPropagation();
            });
        }

        function selecionarAtendimento(atendimento) {
            if (atendimento) {
                vm.atividade.atendimento = angular.copy(atendimento);
                vm.atividade.anoAtendimento = atendimento.ano;
                vm.atividade.numeroAtendimento = atendimento.codigo;
            }
        }

        function selecionarStatus(status) {
            if (status) {
                vm.atividade.status = status;
            }
        }

        function selecionarEvento(evento) {
            if (evento) {
                vm.atividade.evento = evento;
            }
        }


        function _listarTodosAtendimentoCliente(codigoCliente) {
            vm.controleForm.emProgresso = true;
            vm.carregandoAtendimento = true;
            if (codigoCliente) {
                // var atendimento = {
                //     codigoCliente: codigoCliente,
                //     status: 1
                // };

                vm.textoPesquisaAtendimento = "Carregando Atendimentos do Cliente ...";
                vm.mensagemPreloader = "Carregando Atendimentos do Cliente ..."
                RequisicaoGenericaService.listarComParams(Api.atendimento.retornarAtendimentoPorCodigoCliente + "/" + codigoCliente).then(
                    function (success) {
                        vm.atendimentos = success.data;
                        vm.controleForm.emProgresso = false;
                        vm.carregandoAtendimento = false;
                        vm.mensagemPreloader = "";
                        vm.textoPesquisaAtendimento = "Não existe atendimentos vinculados ao cliente";
                    },
                    function (error) {
                        vm.controleForm.emProgresso = false;
                        vm.carregandoAtendimento = false;
                        vm.mensagemPreloader = "";
                        ServicosGenericoService.exibirAlertaDeErro(error, event);
                        vm.textoDePesquisaAutoCompleteCliente = "Não existe atendimentos vinculados ao cliente";
                    });
            }
        }

        function _preaparaModelo(modelo) {
            var retorno = {
                codigoUsuario: vm.codigoUsuario,
                numero: 0,
                ano: 0,
                dataHoraCriacao: modelo.dataHoraCriacao,
                codigoEvento: modelo.codigoEvento,
                codigoAgendaCancelamento: 0,
                cliente: modelo.cliente,
                codigoCliente: modelo.cliente.codigo,
                ultimoHistorico: modelo.ultimoHistorico,
                status: 0,
                agendaCancelamento: null,
                usuario: null,
                evento: modelo.evento,
                historicoAtendimento: null,
                observacao: modelo.observacao,
                atividadeVinculadaAtendimento: modelo.atividadeVinculadaAtendimento
            }
            if (retorno.ultimoHistorico.data) {
                if (typeof retorno.ultimoHistorico.data === 'string') {
                    retorno.ultimoHistorico.data = new Date(retorno.ultimoHistorico.data);
                }
                retorno.ultimoHistorico.dataEmString = retorno.ultimoHistorico.data.toLocaleDateString();
            }

            if (modelo.evento) {
                retorno.codigoEvento = modelo.evento.codigo;
            }
            if (modelo.atividadeVinculadaAtendimento) {
                retorno.atendimento = modelo.atendimento,
                    retorno.anoAtendimento = modelo.atendimento.ano,
                    retorno.numeroAtendimento = modelo.atendimento.codigo
            }

            return retorno;
        }

        function _limpaFormulario() {
            vm.atividade = {};
            vm.cliente = null;
            vm.codigoCliente = 0;
            vm.atendimentos = [];
        }

        function removerAtendimento() {
            if ((vm.atividade.numeroAtendimento && vm.atividade.anoAtendimento) && vm.atividade.atendimento) {
                vm.atividade.atendimento = null;
                vm.atividade.numeroAtendimento = null;
                vm.atividade.anoAtendimento = null;
            }
        }

        //endregion

    }
})();

/**
 * Created by nova on 28/03/2017.
 */
(function () {
    'use strict';

    angular
        .module('app.agenda.cadastro.evento', [])
        .config(config);

    function config($stateProvider, RotasHtml) {
        var rotasHtmlEvento = RotasHtml.agenda.evento;
        $stateProvider
            .state('app.evento_cadastro', {
                url: '/agenda/cadastro/evento',
                module: 'privado',
                views: {
                    'content@app': {
                        templateUrl: rotasHtmlEvento.templateUrl,
                        controller: "EventoController as vm"
                    },
                    'evento-form@app.evento_cadastro': {
                        templateUrl: rotasHtmlEvento.form
                    },
                    'evento-tabela@app.evento_cadastro': {
                        templateUrl: rotasHtmlEvento.tabela
                    }
                }
            });
    }

})();

/**
 * Created by nova on 28/03/2017.
 */
(function () {
    'use strict';

    angular.module('app.agenda.cadastro.evento')
        .controller('EventoController', EventoController);

    function EventoController(Api, RequisicaoGenericaService, DatatableFactory, NavegacaoService) {
        var vm = this;
        var rotas = Api.agenda.evento;

        vm.horaEvento = [
          { nome: "10 minutos antes", valor: "10" },
          { nome: "15 minutos antes", valor: "15" },
          { nome: "30 minutos antes", valor: "30" }
        ];

        // Definição dos Métodos region
        vm.metodos = {
            pesquisar: pesquisar,
            salvar: salvar,
            editar: editar,
            excluir: excluir,
            selecionar: selecionar,
            construirDtOptions: construirDtOptions
        }
        //endregion

        init();

        function init() {
            NavegacaoService.setTituloAba('Agenda eventos');
            vm.form = {};
            vm.evento = null;
            vm.entidadeDeEnvio = {
                intTamanhoPagina: 1,
                clsEntidade: vm.evento
            };
        }

        // Implementação dos Métodos region

        function pesquisar() {
            return RequisicaoGenericaService.listarComObjetoComplexo(rotas.listarPaginacao, vm.entidadeDeEnvio);
        }


        function salvar(modelo) {
            return RequisicaoGenericaService.salvar(rotas.criar, modelo);
        }


        function editar(modelo) {
            return RequisicaoGenericaService.editar(rotas.atualizar, modelo)
        }

        function excluir(modelo) {
            return RequisicaoGenericaService.excluir(rotas.excluir, modelo.codigo)
        }


        function selecionar(posicaoEntidade) {
            vm.metodosExternosPgToolbar.metodoControladorExternoListarTodasEntidades(null, posicaoEntidade);
        }


        function construirDtOptions() {
            DatatableFactory.construirDtOptionsComPaginacaoProcessadoNoServidorParaToolbar
                (rotas.listarComPaginacaoDatatable, vm.entidadeDeEnvio.clsEntidade, '#datatable-pendencia',
                [
                    DatatableFactory.construirColunaDeSelecionarPadrao(function (indexLinha) { vm.metodos.selecionar(indexLinha) }),
                    {
                        targets: 1,
                        name: "Codigo",
                        data: "codigo",
                        sortable: false
                    },
                    {
                        targets: 2,
                        name: "Descricao",
                        data: "descricao",
                        sortable: false
                    }
                ]);
        }
        //endregion

    }
})();

/**
 * Created by nova on 28/03/2017.
 */
(function () {
    'use strict';

    angular
        .module('app.agenda.cadastro.parametros', [])
        .config(config);

    function config($stateProvider, RotasHtml) {
        var rotasHtmlParametros = RotasHtml.agenda.parametros;
        $stateProvider
            .state('app.agenda_cadastro_parametros', {
                url: '/agenda/cadastro/parametros',
                module: 'privado',
                views: {
                    'content@app': {
                        templateUrl: rotasHtmlParametros.templateUrl,
                        controller: "ParametrosController as vm"
                    },
                    'parametros-form@app.agenda_cadastro_parametros': {
                        templateUrl: rotasHtmlParametros.form
                    },
                    'parametros-tabela@app.agenda_cadastro_parametros': {
                        templateUrl: rotasHtmlParametros.tabela
                    }
                }
            });
    }

})();

(function () {
    'use strict';

    angular.module('app.agenda.cadastro.parametros')
        .controller('ParametrosController', ParametrosController);

    function ParametrosController(Api, RequisicaoGenericaService, DatatableFactory, NavegacaoService) {
        var vm = this;
        var rotas = Api.agenda.parametros;

        vm.metodos = {
            pesquisar: pesquisar,
            salvar: salvar,
            editar: editar,
            excluir: excluir,
            selecionar: selecionar,
            construirDtOptions: construirDtOptions,
            onChangeBloquearReagendamentoPorLimite: onChangeBloquearReagendamentoPorLimite
        }

        init();

        function init() {
            NavegacaoService.setTituloAba('Agenda Parâmetros');
            vm.form = {};
            vm.parametros = null;
            vm.entidadeDeEnvio = {
                intTamanhoPagina: 1,
                clsEntidade: vm.evento
            };
        }

        function pesquisar() {
            return RequisicaoGenericaService.listarComObjetoComplexo(rotas.listarPaginacao, vm.entidadeDeEnvio);
        }

        function salvar(modelo) {
            return RequisicaoGenericaService.salvar(rotas.criar, modelo);
        }

        function editar(modelo) {
            return RequisicaoGenericaService.editar(rotas.atualizar, modelo)
        }

        function excluir(modelo) {
            return RequisicaoGenericaService.excluir(rotas.excluir, modelo.codigo)
        }

        function selecionar(posicaoEntidade) {
            vm.metodosExternosPgToolbar.metodoControladorExternoListarTodasEntidades(null, posicaoEntidade);
        }

        function onChangeBloquearReagendamentoPorLimite(bloquearReagendamentoPorLimite) {
            vm.parametros.limiteReagendamento = bloquearReagendamentoPorLimite ? vm.parametros.limiteReagendamento : null;
        }

        function construirDtOptions() {
            DatatableFactory.construirDtOptionsComPaginacaoProcessadoNoServidorParaToolbar
                (rotas.listarComPaginacaoDatatable, vm.entidadeDeEnvio.clsEntidade, '#datatable-parametros',
                    [
                        DatatableFactory.construirColunaDeSelecionarPadrao(function (indexLinha) { vm.metodos.selecionar(indexLinha) }),
                        {
                            targets: 1,
                            name: "Codigo",
                            data: "codigo",
                            sortable: false
                        },
                        {
                            targets: 2,
                            name: "Descricao",
                            data: "descricaoSetor",
                            sortable: false
                        },
                        {
                            targets: 3,
                            name: "Bloquear reagendamento por limite",
                            data: "bloquearReagendamentoPorLimite",
                            sortable: false,
                            render: function (data) {
                                return data ? 'Sim' : 'Não'
                            },
                        },
                        {
                            targets: 4,
                            name: "Número limite de reagendamento",
                            data: "limiteReagendamento",
                            sortable: false,
                            render: function (data) {
                                return data ? data : 0
                            },
                        }
                    ]);
        }
    }
})();

/**
 * Created by nova on 20/07/2016.
 */
(function () {
    'use strict';

    angular
        .module('app.service')
        .service("NotificationService", NotificationService);

    function NotificationService($window, MdDialogService, MenuFactory) {

        this.criarNotificacao = criarNotificacao;
        this.criarNotificacaoAtividade = criarNotificacaoAtividade;
        this.verificarPermissao = verificarPermissao;

        /**
         * Método para criar e exibir uma notificação
         * @param {*titulo da notificação} titulo
         * @param {*mensagem da notificação} body
         * @param {*indentificador unico da notificação} tag
         * @param {*função opcional quando a notificação é exibida} functionOnShow
         * @param {*função opcional quando é clicado em cima da notificação} functionOnClick
         * @param {*função opcional quando a notificação é fechada} functionOnClose
         * @param {*função opcional quando ocorre algum erro com a notificação} functionOnerror
         */
        function criarNotificacao(titulo, body, tag, functionOnShow, functionOnClick, functionOnClose, functionOnerror, estadoNavegacao) {
            if (!estadoNavegacao)
                throw new Error("É obrigatório informar o 'estadoNavegacao' ");
            else if (!MenuFactory.verificarSeUsuarioTemAcessoAoMenu(estadoNavegacao))
                return;


            /**
             * Método para criar a notificação
             */
            function notificacao() {
                var opcoes = {
                    body: body ? body : "",
                    tag: tag ? tag : null,
                    icon: '/assets/images/logos/logo-small.png',
                    iconUrl: '/assets/images/logos/logo-small.png',
                }

                var notificacao = new Notification(titulo, opcoes);

                if (functionOnShow)
                    notificacao.onshow = functionOnShow;

                if (functionOnClick)
                    notificacao.onclick = functionOnClick;
                else {
                    notificacao.onclick = function () {
                        notificacao.close();
                    }
                }

                if (functionOnClose)
                    notificacao.onclose = functionOnClose;

                if (functionOnerror)
                    notificacao.onerror = functionOnerror;
                else {
                    notificacao.onerror = function (event) {
                        console.log("Ocorreu um erro para criar a notificação\nDetalhes: " + event);
                    }
                }

                return notificacao;
            }

            /**
             * Verifica se o browser suporta a componente de notificação, caso não suporte
             * será criado um dialog para exibir a notificação
             */
            if (!("Notification" in window)) {
                MdDialogService.confirmPadraoComEvento(titulo, body, null, functionOnClick, functionOnClose);
            }

            /**
             * Verifica se é permitido criar a notificação no browser para o usuário
             */
            else if (Notification.permission === "granted") {
                return notificacao();
            }

            /**
             * Se não houve permissão para criar a notificação, é solicitado a permissão
             */
            else if (Notification.permission !== 'denied') {
                Notification.requestPermission(function (permission) {
                    // Se o usuario aceitar é criado a notificação
                    if (permission === "granted") {
                        return notificacao();
                    }
                });
            }
            else
                alert("As notificações do seu browser para o IManager estão bloqueadas. Por favor habilite as nas configurações do seu browser")

        }


        function criarNotificacaoAtividade(titulo, body, tag, functionOnShow, functionOnClick, functionOnClose, functionOnerror, estadoNavegacao) {
            if (!estadoNavegacao)
                throw new Error("É obrigatório informar o 'estadoNavegacao' ");
            else if (!MenuFactory.verificarSeUsuarioTemAcessoAoMenu(estadoNavegacao))
                return;



            /**
             * Método para criar a notificação
             */
            function notificacao() {
                var opcoes = {
                    body: body ? body : "",
                    tag: tag ? tag : null,
                    icon: '/assets/images/logos/calendar.png',
                    iconUrl: '/assets/images/logos/calendar.png',
                }

                var notificacao = new Notification(titulo, opcoes);

                if (functionOnShow)
                    notificacao.onshow = functionOnShow;

                if (functionOnClick)
                    notificacao.onclick = functionOnClick;
                else {
                    notificacao.onclick = function () {
                        notificacao.close();
                    }
                }

                if (functionOnClose)
                    notificacao.onclose = functionOnClose;

                if (functionOnerror)
                    notificacao.onerror = functionOnerror;
                else {
                    notificacao.onerror = function (event) {
                        console.log("Ocorreu um erro para criar a notificação\nDetalhes: " + event);
                    }
                }

                return notificacao;
            }

            /**
             * Verifica se o browser suporta a componente de notificação, caso não suporte
             * será criado um dialog para exibir a notificação
             */
            if (!("Notification" in window)) {
                MdDialogService.confirmPadraoComEvento(titulo, body, null, functionOnClick, functionOnClose);
            }

            /**
             * Verifica se é permitido criar a notificação no browser para o usuário
             */
            else if (Notification.permission === "granted") {
                return notificacao();
            }

            /**
             * Se não houve permissão para criar a notificação, é solicitado a permissão
             */
            else if (Notification.permission !== 'denied') {
                Notification.requestPermission(function (permission) {
                    // Se o usuario aceitar é criado a notificação
                    if (permission === "granted") {
                        return notificacao();
                    }
                });
            }
            else
                alert("As notificações do seu browser para o IManager estão bloqueadas. Por favor habilite as nas configurações do seu browser")

        }
        /**
         * Método que retorna a permissão do usuário para Notificações
         */
        function verificarPermissao() {
            return Notification.permission;
        }

    } // NotificationService

})();

(function () {
    'use strict';

    angular
        .module('app.service')
        .service('NotificacaoService', NotificacaoService);

    /** @ngInject */
    function NotificacaoService(NotificacaoPipelineService, NotificacaoAtendimentoService, NotificacaoMensageiroService, NotificacaoSolicitacaoService) {
        this.fecharTodasNotificacoes = _fecharTodasNotificacoes;

        function _fecharTodasNotificacoes() {
            NotificacaoPipelineService.fecharTodasNotificacoes();
            NotificacaoAtendimentoService.fecharTodasNotificacoes();
            NotificacaoMensageiroService.fecharTodasNotificacoes();
            NotificacaoSolicitacaoService.fecharTodasNotificacoes();
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.service')
        .service('NotificacaoSolicitacaoService', NotificacaoSolicitacaoService);

    /** @ngInject */
    function NotificacaoSolicitacaoService(NotificationService, $state) {

        this.exibirNotificacaoSolicitacoesNaoVisualizadas = _exibirNotificacaoSolicitacoesNaoVisualizadas;
        this.exibirNotificacaoNovaSolicitacao = _exibirNotificacaoNovaSolicitacao;
        this.fecharTodasNotificacoes = _fecharTodasNotificacoes;
        var notificacaoSolicitacoesNaoVisualizadas = null;
        var notificacaoNovaSolicitacao = null;

        function _exibirNotificacaoSolicitacoesNaoVisualizadas(quantidadeSolicitacoesNaoVisualizadas) {
            var functionOnClick = function () {
                $state.go("app.solicitacao_consulta_solicitacao", {
                    solicitacoesNaoVisualizadas: true
                });
                notificacaoSolicitacoesNaoVisualizadas.close();
            }

            var mensagemSolicitacaoNaoVizualidas = " ";
            if (quantidadeSolicitacoesNaoVisualizadas > 1) {
                mensagemSolicitacaoNaoVizualidas = " solicitações que ainda não foram finalizadas."
            } else {
                mensagemSolicitacaoNaoVizualidas = " solicitação que ainda nao foi finalizada."
            }
            notificacaoSolicitacoesNaoVisualizadas = NotificationService.criarNotificacao(
                "Há " + quantidadeSolicitacoesNaoVisualizadas + mensagemSolicitacaoNaoVizualidas,
                "Clique aqui para visualizar",
                quantidadeSolicitacoesNaoVisualizadas, null, functionOnClick, null, null, 'app.solicitacao');
        }

        function _exibirNotificacaoNovaSolicitacao(numeroSolicitacao) {
            var functionOnClick = function () {
                $state.go("app.solicitacao_consulta_solicitacao", {
                    solicitacoesNaoVisualizadas: true
                });
                notificacaoNovaSolicitacao.close();
            }
            notificacaoNovaSolicitacao = NotificationService.criarNotificacao(
                "Você recebeu uma nova solicitação.",
                "Clique aqui para visualizar.",
                numeroSolicitacao, null, functionOnClick, null, null, 'app.solicitacao');
        }

        function _fecharTodasNotificacoes() {
            if (notificacaoSolicitacoesNaoVisualizadas) {
                notificacaoSolicitacoesNaoVisualizadas.close();
            }
            if (notificacaoNovaSolicitacao) {
                notificacaoNovaSolicitacao.close();
            }
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.service')
        .service('NotificacaoPipelineService', NotificacaoPipelineService);

    /** @ngInject */
    function NotificacaoPipelineService(NotificationService, $state, RequisicaoGenericaService, Api) {

        this.fecharTodasNotificacoes = fecharTodasNotificacoes;

        ////////////////////////////////////////////// Métodos Atendimento ///////////////////////////////////
        this.exibirNotificacaoNegociacaoEmAlerta = exibirNotificacaoNegociacaoEmAlerta;
        this.fecharTodasNotificacoes = fecharTodasNotificacoes;
        /////////////////////////////////////////////////////////////////////////////////////////////////////

        ////////////////////////////////////////////// Métodos Atendimento ////////////////////////////////////////////
        var notificacaoNegociacaoEmAlerta = null;

        function exibirNotificacaoNegociacaoEmAlerta(intCodigoUsuario) {
            RequisicaoGenericaService.listarSemParams(Api.pipeline.pipeline_negocio.listarNegociosVencidosExecutivoContas + intCodigoUsuario).then(
                function (success) {
                    if (success && success.data && success.data.length > 0) {
                        var strAlerta = "Existem negociações com etapas a vencer ou vencidas.";

                        /**
                         * Método a ser passado para notificação para se invocado quando for clicado em cima da notificação
                         */
                        var functionOnClick = function () {
                            /**
                             * Realiza a chamada para ir para a tela de visualização do pipeline
                             */
                            $state.go('app.pipeline_processamento_pipelinenegociovencidosexecutivoresponsavel');
                            notificacaoNegociacaoEmAlerta.close();
                        }

                        notificacaoNegociacaoEmAlerta = NotificationService.criarNotificacao(
                            strAlerta, "Clique aqui para visualizar os funis de vendas",
                            "not-negociacao", null, functionOnClick, null, null,
                            'app.pipeline_processamento_pipelinenegociovencidosexecutivoresponsavel')
                    }
                });
        }
        //////////////////////////////////////////////////////////////////////////////////////////////////////////////


        function fecharTodasNotificacoes() {
            if (notificacaoNegociacaoEmAlerta)
                notificacaoNegociacaoEmAlerta.close();
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.service')
        .service('NotificacaoMensageiroService', NotificacaoMensageiroService);

    /** @ngInject */
    function NotificacaoMensageiroService(NotificationService, $state) {

        this.fecharTodasNotificacoes = _fecharTodasNotificacoes;

        this.exibirNotificacaoNovaMensagem = _exibirNotificacaoNovaMensagem;
        this.exibirNotificacaoMensagensNaoVisualizadas = _exibirNotificacaoMensagensNaoVisualizadas;

        //#region Notificações
        var notificacaoNovaMensagem = null;
        var notificacaoMensagensNaoVisualizadas = null;
        //#endregion


        //#region Métodos
        function _exibirNotificacaoNovaMensagem() {
            var functionOnClick = function () {
                $state.go('app.mensageiro.threads');
                notificacaoNovaMensagem.close();
            }

            notificacaoNovaMensagem = NotificationService.criarNotificacao("Você recebeu nova mensagem", "Clique aqui para visualizar",
                null, null, functionOnClick, null, null, 'app.mensageiro.threads');
        }

        function _exibirNotificacaoMensagensNaoVisualizadas(quantidadeMensagens) {
            var functionOnClick = function () {
                $state.go('app.mensageiro.threads');
                notificacaoMensagensNaoVisualizadas.close();
            }

            var mensagem = " ";
            if (quantidadeMensagens > 1) {
                mensagem = " Mensagens ainda não foram visualizadas.";
            } else {
                mensagem = " Mensagem ainda não foi visualizada.";
            }

            notificacaoMensagensNaoVisualizadas =
                NotificationService.criarNotificacao(
                    quantidadeMensagens + mensagem,
                    "Clique aqui para visualizar",
                    null, null, functionOnClick, null, null, 'app.mensageiro.threads');
        }

        //#endregion



        function _fecharTodasNotificacoes() {
            if (notificacaoNovaMensagem)
                notificacaoNovaMensagem.close();
            if (notificacaoMensagensNaoVisualizadas)
                notificacaoMensagensNaoVisualizadas.close();


        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.service')
        .service('NotificacaoAtendimentoService', NotificacaoAtendimentoService);

    /** @ngInject */
    function NotificacaoAtendimentoService(NotificationService, $state) {

        this.fecharTodasNotificacoes = fecharTodasNotificacoes;

        ////////////////////////////////////////////// Métodos Atendimento ///////////////////////////////////
        this.exibirNotificacaoAtendimentosNaoVisualizados = exibirNotificacaoAtendimentosNaoVisualizados;
        this.exibirNotificacaoAtendimentosEmAberto = exibirNotificacaoAtendimentosEmAberto;
        this.exibirNotificacaoAtendimentosAlteracaoHistoricoAtendimento = exibirNotificacaoAtendimentosAlteracaoHistoricoAtendimento;
        this.exibirNotificacaoAtendimentosUsuarioVinculadoEmNovoAtendimento = exibirNotificacaoAtendimentosUsuarioVinculadoEmNovoAtendimento;
        this.exibirNotificacaoAtendimentosGerenteAtendimentosEmAbertoExcedidoUsuario = exibirNotificacaoAtendimentosGerenteAtendimentosEmAbertoExcedidoUsuario;
        this.fecharNotificacoesModuloAtendimentosEmAberto = fecharNotificacoesModuloAtendimentosEmAberto;
        this.fecharNotificacoesAtendimento = fecharNotificacoesAtendimento;
        this.fecharTodasNotificacoes = fecharTodasNotificacoes;
        /////////////////////////////////////////////////////////////////////////////////////////////////////                

        ////////////////////////////////////////////// Métodos Atendimento ////////////////////////////////////////////
        var notificacaoAtendimentosNaoVisualizados = null;
        var notificacaoAtendimentosEmAberto = null;
        var notificacaoAtendimentosEmAbertoExcedido = null;
        var notificacaoAtendimentosAlteracoesHistoricoAtendimento = null;
        var notificacaoAtendimentosUsuarioVinculadoEmNovoAtendimento = null;
        var notificacaoAtendimentoGerenteAtendimentosEmAbertoExcedidoUsuario = null

        function exibirNotificacaoAtendimentosNaoVisualizados(quantidadeAtendimentosNaoVisualizados) {
            /**
             * Método a ser passado para notificação para se invocado quando for clicado em cima da notificação
             */
            var functionOnClick = function () {
                /**
                 * Realiza a chamada para ir para a tela do atendimento já realizando uma pesquisa
                 * para listar todos os atendimentos não visualizados do usuário corrente
                 */
                $state.go('app.atendimento_processamento_atendimentos_nao_visualizados');
                notificacaoAtendimentosNaoVisualizados.close();
            }
            notificacaoAtendimentosNaoVisualizados = NotificationService.criarNotificacao(quantidadeAtendimentosNaoVisualizados +
                " Atendimento(s) ainda não foi(ram) visualizado(s)", "Clique aqui para visualizar",
                quantidadeAtendimentosNaoVisualizados, null, functionOnClick, null, null, 'app.atendimento_processamento_atendimentos_nao_visualizados');
        }

        function exibirNotificacaoAtendimentosEmAberto(quantidadeAtendimentosEmAberto, codigoUsuario) {
            /**
             * Método a ser passado para notificação para se invocado quando for clicado em cima da notificação
             */
            var functionOnClick = function () {
                /**
                 * Realiza a chamada para ir para a tela do atendimento já realizando uma pesquisa
                 * para listar todos os atendimentos não visualizados do usuário corrente
                 */
                $state.go('app.atendimento_processamento_atendimentos_em_aberto', { codigoUsuariosHaListarAtendimentosEmAberto: codigoUsuario });
                fecharNotificacoesModuloAtendimentosEmAberto();
            }

            notificacaoAtendimentosEmAberto = NotificationService.criarNotificacao(
                quantidadeAtendimentosEmAberto + " Atendimento(s) ainda está(ão) em aberto", "Clique aqui para visualizar",
                quantidadeAtendimentosEmAberto, null, functionOnClick, null, null, 'app.atendimento_processamento_atendimentos_em_aberto');
        }


        function exibirNotificacaoAtendimentosEmAbertoExcedido(codigoUsuariosComAtendimentosEmAbertoExcedidos) {
            /**
             * Método a ser passado para notificação para se invocado quando for clicado em cima da notificação
             */
            var functionOnClick = function () {
                /**
                 * Realiza a chamada para ir para a tela do atendimento já realizando uma pesquisa
                 * para listar todos os atendimentos não visualizados do usuário corrente
                 */
                $state.go('app.atendimento_processamento_atendimentos_em_aberto', {
                    listarAtendimentosUsuarioComQuantidadeLimiteExcedida: true,
                    codigoUsuariosComAtendimentosEmAbertoExcedidos: codigoUsuariosComAtendimentosEmAbertoExcedidos
                });
                fecharNotificacoesModuloAtendimentosEmAberto();
            }

            notificacaoAtendimentosEmAbertoExcedido = NotificationService.criarNotificacao(
                "Um ou mais colaboradores excederam o limite de atendimentos em aberto", "Clique aqui para visualizar",
                null, null, functionOnClick, null, null, 'app.atendimento_processamento_atendimentos_em_aberto');
        }

        function exibirNotificacaoAtendimentosAlteracaoHistoricoAtendimento(codigoAtendimento, anoAtendimento) {
            /**
             * Método a ser passado para notificação para se invocado quando for clicado em cima da notificação
             */
            var functionOnClick = function () {
                /**
                 * Realiza a chamada para ir para a tela dos não visualizados, já realizando uma pesquisa
                 * para o atendimento não visualizado do usuário corrente
                 */
                $state.go('app.atendimento_processamento_atendimentos_nao_visualizados', {
                    parametros: {
                        codigo: codigoAtendimento,
                        ano: anoAtendimento,
                        chamarPesquisa: true
                    }
                });
                notificacaoAtendimentosAlteracoesHistoricoAtendimento.close();
            }

            // Método que cria uma notificação e redirecionar para o atendimento não visualizados quando clicado na notificação                              
            notificacaoAtendimentosAlteracoesHistoricoAtendimento = NotificationService.criarNotificacao
                ("Houve alterações no Histórico do Atendimento: " + codigoAtendimento + "/" + anoAtendimento,
                    "Clique aqui para visualizar", codigoAtendimento + "/" + anoAtendimento, null, functionOnClick, null, null,
                    'app.atendimento_processamento_atendimentos_nao_visualizados');
        }

        function exibirNotificacaoAtendimentosUsuarioVinculadoEmNovoAtendimento(codigoAtendimento, anoAtendimento) {
            /**
             * Método a ser passado para notificação para se invocado quando for clicado em cima da notificação
             */
            var functionOnClick = function () {
                /**
                 * Realiza a chamada para ir para a tela dos não visualizados, já realizando uma pesquisa
                 * para o atendimento não visualizado do usuário corrente
                 */
                $state.go('app.atendimento_processamento_atendimentos_nao_visualizados', {
                    parametros: {
                        codigo: codigoAtendimento,
                        ano: anoAtendimento,
                        chamarPesquisa: true
                    }
                });
                notificacaoAtendimentosUsuarioVinculadoEmNovoAtendimento.close();
            }

            // Método que cria uma notificação e redirecionar para o atendimento não visualizados quando clicado na notificação                              
            notificacaoAtendimentosUsuarioVinculadoEmNovoAtendimento = NotificationService.criarNotificacao
                ("Você foi adicionado no Atendimento: " + codigoAtendimento + "/" + anoAtendimento + "para acompanhar",
                    "Clique aqui para visualizar", codigoAtendimento + "/" + anoAtendimento, null, functionOnClick, null, null,
                    'app.atendimento_processamento_atendimentos_nao_visualizados');

        }

        function exibirNotificacaoAtendimentosGerenteAtendimentosEmAbertoExcedidoUsuario(codigoUsuarioAtendimentosExcedido, mensagem) {
            /**
             * Método a ser passado para notificação para se invocado quando for clicado em cima da notificação
             */
            var functionOnClick = function () {
                /**
                 * Realiza a chamada para ir para a tela dos não visualizados, já realizando uma pesquisa
                 * para o atendimento não visualizado do usuário corrente
                 */
                $state.go('app.atendimento_processamento_atendimentos_em_aberto', {
                    codigoUsuariosHaListarAtendimentosEmAberto: codigoUsuarioAtendimentosExcedido
                });
                fecharNotificacoesModuloAtendimentosEmAberto();
            }

            // Método que cria uma notificação e redirecionar para o atendimento não visualizados quando clicado na notificação                              
            notificacaoAtendimentoGerenteAtendimentosEmAbertoExcedidoUsuario = NotificationService.criarNotificacao
                ("", mensagem + "\nClique aqui para visualizar.", codigoUsuarioAtendimentosExcedido, null, functionOnClick, null, null,
                    'atendimento_processamento_atendimentos_em_aberto');
        }

        function fecharNotificacoesModuloAtendimentosEmAberto() {
            if (notificacaoAtendimentosEmAberto)
                notificacaoAtendimentosEmAberto.close()
            if (notificacaoAtendimentosEmAbertoExcedido)
                notificacaoAtendimentosEmAbertoExcedido.close();
            if (notificacaoAtendimentoGerenteAtendimentosEmAbertoExcedidoUsuario)
                notificacaoAtendimentoGerenteAtendimentosEmAbertoExcedidoUsuario.close();
        }

        function fecharNotificacoesAtendimento() {
            if (notificacaoAtendimentosNaoVisualizados)
                notificacaoAtendimentosNaoVisualizados.close();
            if (notificacaoAtendimentosEmAberto)
                notificacaoAtendimentosEmAberto.close();
            if (notificacaoAtendimentosEmAbertoExcedido)
                notificacaoAtendimentosEmAbertoExcedido.close();
            if (notificacaoAtendimentosAlteracoesHistoricoAtendimento)
                notificacaoAtendimentosAlteracoesHistoricoAtendimento.close();
            if (notificacaoAtendimentosUsuarioVinculadoEmNovoAtendimento)
                notificacaoAtendimentosUsuarioVinculadoEmNovoAtendimento.close();
            if (notificacaoAtendimentoGerenteAtendimentosEmAbertoExcedidoUsuario)
                notificacaoAtendimentoGerenteAtendimentosEmAbertoExcedidoUsuario.close();
        }
        //////////////////////////////////////////////////////////////////////////////////////////////////////////////


        function fecharTodasNotificacoes() {
            if (notificacaoAtendimentosNaoVisualizados)
                notificacaoAtendimentosNaoVisualizados.close();
            if (notificacaoAtendimentosEmAberto)
                notificacaoAtendimentosEmAberto.close();
            if (notificacaoAtendimentosEmAbertoExcedido)
                notificacaoAtendimentosEmAbertoExcedido.close();
            if (notificacaoAtendimentosAlteracoesHistoricoAtendimento)
                notificacaoAtendimentosAlteracoesHistoricoAtendimento.close();
            if (notificacaoAtendimentosUsuarioVinculadoEmNovoAtendimento)
                notificacaoAtendimentosUsuarioVinculadoEmNovoAtendimento.close();
            if (notificacaoAtendimentoGerenteAtendimentosEmAbertoExcedidoUsuario)
                notificacaoAtendimentoGerenteAtendimentosEmAbertoExcedidoUsuario.close();
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.service')
        .service('NotificacaoAgendaService', NotificacaoAgendaService);

    /** @ngInject */
    function NotificacaoAgendaService(NotificationService, $state) {

        this.exibirNotificacaoAtividade = _exibirNotificacaoAtividade;

        //#region Métodos
        function _exibirNotificacaoAtividade(atividadesAgenda) {
            var functionOnClick = function () {
                $state.goNewTab("app.visualizar_atividades");
            }

            if (atividadesAgenda.length) {

                atividadesAgenda.map(function (atividade) {
                    var dadosAtividade = atividade.NumeroAtividade + " / " + atividade.AnoAtividade;

                    NotificationService.criarNotificacaoAtividade(
                        "Alerta de atividade",
                        "Atividade: " + dadosAtividade +
                        "\nData: " + atividade.Data + " Hora: " + atividade.Hora +
                        "\nCliente: " + atividade.ClienteNome +
                        "\nAtendimento: " + atividade.NumeroAtendimento + "/" + atividade.AnoAtendimento,
                        dadosAtividade, null, functionOnClick, null, null, 'app.agenda.cadastro');
                });
            }
        }

    }
})();

(function ()
 {
    'use strict';

    angular
        .module('app.service')
        .service('HistoricoService', HistoricoService);

    /** @ngInject */
    function HistoricoService(DataTableConfigPadrao)
    {
          var arraydetalheHistoricoArrayDePesquisa = null;
           var apiDataTable = null;

          this.detalheHistoricoConstruirDtOptionsdetalheHistorico = detalheHistoricoConstruirDtOptionsdetalheHistorico;





        function detalheHistoricoConstruirDtOptionsdetalheHistorico() {
          var dtOptions = angular.copy(
            DataTableConfigPadrao.dtOptionsPadraoComPaginacaoPaginTypeNumbersEReponsivo
          );
          dtOptions.columnDefs = [DataTableConfigPadrao.columnDefsPadrao];
          dtOptions.lengthMenu = [10, 15, 20, 25];
          dtOptions.pageLength = 10;
          dtOptions.initComplete = function () {
            var api = this.api(),
              searchBox = angular.element("body").find("#pesquisar"),
              htmlCollection = document.getElementsByClassName(
                "array-buttons-atendimentos-vinculados"
              ),
              elemento = [];
            apiDataTable = api;

            angular.forEach(htmlCollection, function (key, value, array) {
              elemento.push(angular.element(key));

              elemento[value].click(function (event) {
                if (arraydetalheHistoricoArrayDePesquisa) {
                  var arrayFormatado = arraydetalheHistoricoArrayDePesquisa
                    .toString()
                    .replace(/,/g, "|");
                  api.column(5).search(arrayFormatado, true, false).draw();
                } else {
                  api.column(5).search("").draw();
                }
              });
            });

            // Bind an external input as a table wide search box
            if (searchBox.length > 0) {
              searchBox.on("keyup", function (event) {
                api.search(event.target.value).draw();
              });
            }
          };
          return dtOptions;
        }

    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.toolbar', [])
        .config(config);

    /** @ngInject */
    function config($translatePartialLoaderProvider)
    {
        $translatePartialLoaderProvider.addPart('app/toolbar');
    }
})();

(function () {
    'use strict';

    angular
        .module('app.toolbar')
        .controller("DialogSenhaImplantacaoController", DialogSenhaImplantacaoController);

    function DialogSenhaImplantacaoController($mdDialog, $timeout, SenhaImplantacao) {
        var vm = this;

        vm.emProgresso = false;
        vm.iconeCopiar = 'icon-content-copy';

        vm.metodos = {
            fecharDialog: fecharDialog,
            copiarParaClipboard: copiarParaClipboard
        };

        init();

        function init() {
            vm.senhaImplantacao = SenhaImplantacao;
            vm.dataAtual = new Date();
            if (vm.senhaImplantacao) {
                copiarParaClipboard();
            }
        }

        function fecharDialog() {
            $mdDialog.cancel();
        }

        function copiarParaClipboard() {
            var elem = document.createElement('textarea');
            elem.value = vm.senhaImplantacao;
            document.body.appendChild(elem);
            elem.select();
            document.execCommand('copy');
            document.body.removeChild(elem);

            vm.iconeCopiar = 'icon-check';
            $timeout(function () {
                vm.iconeCopiar = 'icon-content-copy';
            }, 2000);
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.toolbar')
        .controller("DialogAlteracaoSenhaToolbarController", DialogAlteracaoSenhaToolbarController);

    function DialogAlteracaoSenhaToolbarController($mdDialog, MdDialogService, LoginUsuarioService, Api, ServicosGenericoService, RequisicaoGenericaService,
        MdToastService) {
        var vm = this;

        vm.abrirInfo = false;
        vm.emProgresso = false;
        vm.metodos = {
          alterarSenha: alterarSenha,
          fecharDialog: fecharDialog,
          abrirInformacao: abrirInformacao
        };

        function alterarSenha(event, senhaAtual, novaSenha, confirmacaoSenha) {
            if (novaSenha != confirmacaoSenha)
                MdDialogService.alertPadrao("As senhas devem ser iguais");

            var _usuarioParaEnvio = angular.copy(LoginUsuarioService.usuarioArmazenado());

            vm.emProgresso = true;
            RequisicaoGenericaService.listarComParams(Api.usuario.confirmarSenhaPorCodigo + _usuarioParaEnvio.codigo + "/" + btoa(senhaAtual))
                .then(function (success) {
                    if (!success.data)
                        return Promise.reject({ data: "Senha atual inválida" });

                    _usuarioParaEnvio.senha = novaSenha;
                    return RequisicaoGenericaService.editar(Api.usuario.configuracaoUsuario.criar, _usuarioParaEnvio);
                })
                .then(function (success) {
                    LoginUsuarioService.armazenarUsuario(success.data);
                    MdToastService.toastPadrao("Senha alterada com sucesso!");
                    vm.emProgresso = false;
                    $mdDialog.hide();
                })
                .catch(function (error) {
                    vm.emProgresso = false;
                    vm.abrirInfo = true;
                    ServicosGenericoService.exibirAlertaDeErro(error, event);
                })
        }

        function fecharDialog() {
            $mdDialog.cancel();
        }

        function abrirInformacao(){
          if(vm.abrirInfo)
            vm.abrirInfo = false;
          else
            vm.abrirInfo = true
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.solicitacao.processamento.solicitacao')
        .controller("DialogHistoricoSolicitacaoController", DialogHistoricoSolicitacaoController);

    function DialogHistoricoSolicitacaoController(
        Api,
        RequisicaoGenericaService,
        MdToastService,
        ServicosGenericoService,
        $mdDialog,
        HistoricoSolicitacao,
        Solicitacao,
        SolicitacaoFases,
        LoginUsuarioService,
        PodeEditar,
        MdDialogService
    ) {
        var vm = this;

        vm.requisicaSolicitada = false;
        vm.preloader = { habilitar: false };
        vm.filtrarSolicitacaoFases = '';
        vm.solicitacaoFases = angular.copy(SolicitacaoFases);
        vm.usuarioLogado = LoginUsuarioService.usuarioArmazenado();

        vm.dataMaxima = new Date();

        vm.historicoSolicitacao = {};
        vm.form = {};
        var dataTemporaria;


        if (HistoricoSolicitacao) {
            if (PodeEditar)
                vm.titulo = "Editar histórico da solicitação";
            else
                vm.titulo = "Visualizar histórico da solicitação";
            vm.novoHistoricoSolicitacao = false;
            vm.historicoSolicitacao = angular.copy(HistoricoSolicitacao);
            dataTemporaria = new Date(HistoricoSolicitacao.data);
            vm.podeEditar = PodeEditar;
        } else {
            vm.podeEditar = true;
            vm.titulo = "Inserir histórico da solicitação";
            vm.novoHistoricoSolicitacao = true;
            vm.historicoSolicitacao = {
                solicitacaoNumero: Solicitacao.numero,
                solicitacaoAno: Solicitacao.ano,
                solicitacaoFase: Solicitacao.faseCodigo,
                squadCodigo: Solicitacao.squadCodigo,
                data: new Date()
            };
            dataTemporaria = new Date();
        }

        var metodosInternos = {
            salvar: metodoInternoSalvar,
            editar: metodoInternoEditar

        };
        vm.metodosDialog = {
            salvar: metodoDialogSalvar,
            excluir: metodoDialogExcluir,
            fecharDialog: metodoDialogFecharDialog,
            configuraMdSelectSolicitacaoFase: configuraMdSelectSolicitacaoFase
        };

        function metodoInternoSalvar(event, historicoSolicitacao) {
            vm.requisicaSolicitada = true;
            var solicitacaoFaseBkp = historicoSolicitacao.solicitacaoFase;
            delete historicoSolicitacao.solicitacaoFase;
            RequisicaoGenericaService.salvar(Api.solicitacao.solicitacao.historico.criar, historicoSolicitacao).then(
                function (success) {
                    MdToastService.toastPadrao("Histórico da solicitação cadastrado com sucesso!");

                    Solicitacao.solicitacaoHistoricos.push(success.data);

                    vm.requisicaSolicitada = false;
                    $mdDialog.hide();
                },
                function (error) {
                    vm.requisicaSolicitada = false;
                    historicoSolicitacao.solicitacaoFase = solicitacaoFaseBkp;
                    MdDialogService.alertPadrao(error.data);
                });
        }

        function metodoInternoEditar(event, historicoSolicitacao) {
            vm.requisicaSolicitada = true;
            var solicitacaoFaseBkp = historicoSolicitacao.solicitacaoFase;
            delete historicoSolicitacao.solicitacaoFase;

            RequisicaoGenericaService.editar(Api.solicitacao.solicitacao.historico.atualizar, historicoSolicitacao).then(
                function (success) {
                    MdToastService.toastPadrao("Histórico da solicitação alterado com sucesso!");

                    angular.forEach(Solicitacao.solicitacaoHistoricos, function (item, index) {
                        if (item.codigo === success.data.codigo) {
                            Solicitacao.solicitacaoHistoricos[index] = success.data;
                        }
                    });

                    vm.requisicaSolicitada = false;
                    $mdDialog.hide();
                },
                function (error) {
                    vm.requisicaSolicitada = false;
                    historicoSolicitacao.solicitacaoFase = solicitacaoFaseBkp;
                    MdDialogService.alertPadrao(error.data);
                });
        }

        function metodoDialogSalvar(event, historicoSolicitacao) {
            historicoSolicitacao.codigoUsuarioAbertura = vm.usuarioLogado.codigo;
            historicoSolicitacao.codigoFase = historicoSolicitacao.solicitacaoFase.codigo;
            if (!historicoSolicitacao.solicitacaoFase.exige_Motivo) {
                delete historicoSolicitacao.motivoFase;
            }
            if (dataTemporaria.getTime() !== new Date(historicoSolicitacao.data).getTime()) {
                historicoSolicitacao.data = ServicosGenericoService.retornaHoraFormataComTempo(historicoSolicitacao.data);
            }
            if (vm.novoHistoricoSolicitacao) {
                metodosInternos.salvar(event, historicoSolicitacao);
            } else {
                metodosInternos.editar(event, historicoSolicitacao);
            }
        }

        function metodoDialogExcluir(historicoSolicitacao, event) {
            var index = Solicitacao.solicitacaoHistoricos.map(function (item) { return item.codigo }).indexOf(historicoSolicitacao.codigo);
            ServicosGenericoService
                .excluirRegistroPorCodigoOuGenericamenteEmDialogs(Api.solicitacao.solicitacao.historico.excluir, Solicitacao.solicitacaoHistoricos, historicoSolicitacao, vm.preloader, $mdDialog,
                    event, 'Deseja realmente excluir este histórico ?', null, index, "",
                    '?codigo=' + historicoSolicitacao.codigo + '&solicitacaoNumero=' + historicoSolicitacao.solicitacaoNumero + '&solicitacaoAno=' + historicoSolicitacao.solicitacaoAno);
        }

        function metodoDialogFecharDialog() {
            $mdDialog.hide();
        }

        function configuraMdSelectSolicitacaoFase() {
            vm.filtrarSolicitacaoFases = "";
            angular.element('#solicitacao-dialog-historico-solicitacao-fase-md-select').on('keydown', function (ev) {
                ev.stopPropagation();
            });
        }
    }
})();




(function () {
    'use strict';
    angular
        .module('app.service')
        .service('MensageiroControllerService', MensageiroControllerService);

    function MensageiroControllerService(MdDialogService,
        LocalStorageService, $rootScope, $state, MensageiroService, $window) {
        var classe = this;
        this.recarregarPagina = function (vm, executarAoCompletar) {
            if (vm.pesquisar.length > 0) {
                MdDialogService.confirmPadraoComEvento("Atenção",
                    "A barra de pesquisa não está vazia, deseja prosseguir?", event,
                    function () {
                        if (vm.menuSelecionado != null) {
                            vm.pesquisar = "";
                            classe.fazRequisicaoDeAcordoComMenuSelecionado(vm.menuSelecionado, vm, executarAoCompletar);
                        }
                    });
                return;
            }

            if (vm.mensagensSelecionadas.length > 0) {
                MdDialogService.confirmPadraoComEvento("Atenção",
                    "Você possui mensagens selecionadas, deseja prosseguir?", event,
                    function () {
                        if (vm.menuSelecionado != null) {
                            vm.mensagensSelecionadas = [];
                            classe.fazRequisicaoDeAcordoComMenuSelecionado(vm.menuSelecionado, vm, executarAoCompletar);
                        }
                    });
                return;
            }

            if (vm.menuSelecionado != null)
                classe.fazRequisicaoDeAcordoComMenuSelecionado(vm.menuSelecionado, vm, executarAoCompletar);
        }

        this.removeRespostasNaoReferentesAoDestinatarioLogado = function (mensagem, vm) {
            if (mensagem.respostas == null)
                return;

            if (mensagem.respostas.length <= 0)
                return;


            mensagem.respostas.forEach(function (value, index) {

                if (value.copiaPara != null)
                    value.copiaPara.usuarios.forEach(function (codigo) {
                        if (codigo == vm.usuarioLogado.codigo)
                            mensagem.respostas.splice(index, 1);
                    });
            });

        }

        this.retornaRespostasNaoLidasDoUsuarioLogado = function (mensagem, vm) {
            var respostas = [];

            if (mensagem.respostas == null)
                return respostas;

            if (mensagem.respostas.length <= 0)
                return respostas;

            mensagem.respostas.forEach(function (item) {
                if (item.destinatario == vm.usuarioLogado.nome && item.remetente != vm.usuarioLogado.nome)
                    if (item.status != null && item.status.id == 2)
                        respostas.push(item);
            });
            return respostas;
        }

        this.retornaPosicaoMensagem = function (mensagem, vm) {
            if (mensagem == null)
                return 0;

            return vm.mensagens.dados.mensagens.indexOf(mensagem) + 1;
        }

        this.pesquisa = function (vm) {
            if (!vm.pesquisandoMensagem)
                vm.pagina = 1;

            vm.pesquisandoMensagem = true;
            vm.carregandoMensagens = true;
            MensageiroService.pesquisar(vm.usuarioLogado.codigo, vm.pagina, vm.pesquisar, this.retornaGrupo(vm)).then(function (success) {
                vm.mensagens.dados = success.dados;
                vm.carregandoMensagens = false;
            }, function () {
                vm.pesquisandoMensagem = false;
                vm.carregandoMensagens = false;
                vm.mensagens.dados.fim = true;
                vm.mensagens.dados.totalizador = "0 de 0";
                vm.mensagens.dados.mensagens.length = 0;
            });
        }

        this.selecionaMenu = function (name, vm) {
            vm.menuSelecionado = name;

            if (vm.mensagemSelecionada) {
                vm.fecharMensagem();
            }

            if (vm.isFolderActive(name)) {
                return;
            }

            // Show loader
            $rootScope.loadingProgress = true;

            vm.pagina = 1;
            this.fazRequisicaoDeAcordoComMenuSelecionado(name, vm);

            // Update the state without reloading the controller
            $state.go('app.mensageiro.threads', {
                type: null,
                filter: name
            }, {
                notify: false
            });
        }

        this.preparaDados = function (mensagem, dados, vm) {

            if (mensagem.mensagemDestinatarioIdentificador == 0)
                mensagem.mensagemDestinatarioIdentificador = mensagem.mensagemIdentificador;

            if (mensagem.codigoRemetente == vm.usuarioLogado.codigo) {
                mensagem.mensagemDestinatarioIdentificador = mensagem.mensagemIdentificador;
            }

            dados.identificadorMensagemDestinatario = mensagem.mensagemDestinatarioIdentificador;
            dados.codigoUsuario = vm.usuarioLogado.codigo;
            dados.identificadorMensagem = mensagem.mensagemIdentificador;
        }


        this.defineModoDeVisualizacaoDoMensageiro = function (vm) {
            var viewMensageiroArmazenada = LocalStorageService.recuperar('MENSAGEIRO_VIEW');
            var tamanhoDaTela = $window.innerWidth;

            if (viewMensageiroArmazenada == null && tamanhoDaTela >= 960) {
                vm.defaultView = 'outlook';
                vm.currentView = 'outlook';
                LocalStorageService.armazenar('MENSAGEIRO_VIEW', vm.defaultView);
                return;
            }
            if (tamanhoDaTela < 960) {
                vm.defaultView = 'classic';
                vm.currentView = 'classic';
                return;
            }

            vm.defaultView = viewMensageiroArmazenada;
            vm.currentView = viewMensageiroArmazenada;
        }

        this.arquivaMensagensNaoLidas = function (listaMensagensNaoLidas, vm) {
            var classe = this;
            if (listaMensagensNaoLidas.length > 0)
                MdDialogService.confirmPadraoComEvento("Atenção",
                    "A mensagem ainda não foi visualizada, deseja prosseguir?", event,
                    function () {
                        listaMensagensNaoLidas.forEach(function (value) {
                            MensageiroService.marcarComoArquivado(value).then(function () {
                                classe.recarregarPagina(vm);
                            });
                        });
                    });
        }

        this.arquivaMensagensComStatusLerMaisTarde = function (listaMensagensLerMaisTarde, vm) {
            var classe = this;
            if (listaMensagensLerMaisTarde.length > 0)
                MdDialogService.confirmPadraoComEvento("Atenção",
                    "A mensagem está marcada para ler mais tarde, deseja prosseguir?", event,
                    function () {
                        listaMensagensLerMaisTarde.forEach(function (value) {
                            MensageiroService.marcarComoArquivado(value).then(function () {
                                classe.recarregarPagina(vm);
                            });
                        });
                    });
        }

        this.retornaGrupo = function (vm) {

            if (vm.menuSelecionado == null)
                return;

            switch (vm.menuSelecionado) {
                case 'sent':
                    return 2;
                case 'inbox':
                    return 1;
                case 'important':
                    return 3;
                case 'trash':
                    return 4;
                default:
                    return 0;
            }
        }

        this.arquiva = function (data, vm) {

            if (vm.menuSelecionado == 'sent')
                return;

            if (this.marcaSeTiverListaDeMensagens(data, vm))
                return;

        }

        this.marcaSeTiverListaDeMensagens = function (data, vm) {

            var listaMensagensLerMaisTarde = [];
            var listaMensagensNaoLidas = [];

            if (vm.mensagensSelecionadas.length > 0) {
                var classe = this;
                vm.mensagensSelecionadas.forEach(function (value) {

                    var dataResult = {
                        //"identificadorMensagemDestinatario": value.mensagemDestinatarioIdentificador,
                        "arquivar": data.arquivar
                    };

                    classe.preparaDados(value, dataResult, vm);

                    if (value.status.id == 3 && vm.menuSelecionado != 'trash')
                        listaMensagensLerMaisTarde.push(dataResult);

                    if (value.status.id == 2 && vm.menuSelecionado != 'trash')
                        listaMensagensNaoLidas.push(dataResult);

                    if (value.status.id != 3 && value.status.id != 2 || vm.menuSelecionado == 'trash')
                        MensageiroService.marcarComoArquivado(dataResult).then(function () {
                            classe.removeMensagemDaLista(value, vm);
                        },
                            function (error) {
                                MdDialogService.alertPadrao(error.data, null);
                            });
                });

                this.arquivaMensagensNaoLidas(listaMensagensNaoLidas, vm);
                this.arquivaMensagensComStatusLerMaisTarde(listaMensagensLerMaisTarde, vm);

                return true;
            }
            return false;
        }

        this.removeMensagemDaLista = function (mensagem, vm) {
            vm.mensagensSelecionadas = [];
            var index = vm.mensagens.dados.mensagens.indexOf(mensagem);
            vm.mensagemSelecionada = [];
            vm.mensagens.dados.mensagens.splice(index, 1);
            this.recarregarPagina(vm);
        }

        this.alteracoesTrocaDeMenu = function (name, vm) {
            vm.currentFilter = {
                type: null,
                filter: name
            };

            // if (vm.mensagemSelecionada) {
            //   vm.fecharMensagem();
            // }

            $rootScope.loadingProgress = false;
        }

        this.filtraPrioridade = function (idPrioridade, vm) {
            return vm.mensagens.dados.mensagens.filter(function (val) {
                if (val.prioridade.id == idPrioridade)
                    return val;
            });
        }

        this.filtraLidasNaoLidas = function (statusVisualizacao, vm) {
            switch (statusVisualizacao) {
                case 'lidas':
                    return vm.mensagens.dados.mensagens.filter(function (val) {
                        if (val.status.id == 1)
                            return val;
                    });
                default:
                    return vm.mensagens.dados.mensagens.filter(function (val) {
                        if (val.status.id != 1)
                            return val;
                    });
            }
        }

        this.retornaTodas = function (vm) {
            return vm.mensagens.dados.mensagens.slice();
        }

        this.fazRequisicaoDeAcordoComMenuSelecionado = function (nome, vm, executarAoCompletar) {
            if (vm.carregandoMensagens)
                return;

            vm.mensagens = [];
            vm.menuSelecionado = nome;
            vm.checkBoxSelecionado = "Selecione";

            switch (nome) {
                case 'inbox':
                    vm.ordenacaoMensagens = '-status.id';
                    vm.reverso = false;
                    this.listarMensagensCaixaDeEntrada(vm.pagina, vm, executarAoCompletar);
                    this.alteracoesTrocaDeMenu(nome, vm);
                    break;

                case 'sent':
                    vm.ordenacaoMensagens = '';
                    vm.reverso = '';
                    this.listarMensagensEnviadas(vm.pagina, vm, executarAoCompletar);
                    this.alteracoesTrocaDeMenu(nome, vm);
                    break;

                case 'important':
                    vm.ordenacaoMensagens = '-status.id';
                    vm.reverso = false;
                    this.listarMensagensImportantes(vm.pagina, vm, executarAoCompletar);
                    this.alteracoesTrocaDeMenu(nome, vm);
                    break;

                case 'trash':
                    vm.ordenacaoMensagens = '';
                    vm.reverso = '';
                    this.listarMensagensArquivadas(vm.pagina, vm, executarAoCompletar);
                    this.alteracoesTrocaDeMenu(nome, vm);
                    break;
            }

        }

        this.verificaSeExisteLabel = function (id, vm) {
            if (vm.getLabel(id))
                return true;

            return false;
        }

        this.listaMenuLateral = function () {
            return [{
                "id": 1,
                "name": "inbox",
                "title": "Caixa de Entrada",
                "icon": "icon-inbox"
            },
            {
                "id": 2,
                "name": "sent",
                "title": "Enviadas",
                "icon": "icon-send"
            },
            {
                "id": 3,
                "name": "important",
                "title": "Importantes",
                "icon": "icon-star"
            },
            {
                "id": 5,
                "name": "trash",
                "title": "Arquivados",
                "icon": "icon-archive"
            }
            ];
        }

        this.listarMensagensCaixaDeEntrada = function (pagina, vm, executarAoCompletar) {
            vm.carregandoMensagens = true;

            return MensageiroService.listarMensagens(vm.usuarioLogado.codigo, pagina)
                .then(function (response) {
                    vm.mensagens = response;
                    // Hide the loading screen
                    vm.carregandoMensagens = false;
                    // Open the mensagem if needed
                    if ($state.params.mensagemId) {
                        for (var i = 0; i < vm.mensagens.length; i++) {
                            if (vm.mensagens[i].id === $state.params.mensagemId) {
                                vm.abrirMensagem(vm.mensagens[i]);
                                break;
                            }
                        }
                    }

                    executarAoCompletar(vm.mensagens);
                }, function (err) {
                    vm.carregandoMensagens = false;
                    MdDialogService.alertPadrao('Atenção', null, 'Não foi possível carregar as mensagens: ' + err)
                });
        }

        this.listarMensagensEnviadas = function (pagina, vm, executarAoCompletar) {
            vm.carregandoMensagens = true;
            return MensageiroService.listarMensagensEnviadas(vm.usuarioLogado.codigo, pagina, null)
                .then(function (response) {
                    vm.mensagens = response;
                    vm.carregandoMensagens = false;
                    if ($state.params.mensagemId) {
                        for (var i = 0; i < vm.mensagens.length; i++) {
                            if (vm.mensagens[i].id === $state.params.mensagemId) {
                                vm.abrirMensagem(vm.mensagens[i]);
                                break;
                            }
                        }
                    }
                    executarAoCompletar(vm.mensagens);
                }, function (err) {
                    vm.carregandoMensagens = false;
                    MdDialogService.alertPadrao('Atenção', null, 'Não foi possível carregar as mensagens: ' + err)
                });
        }

        this.listarMensagensImportantes = function (pagina, vm, executarAoCompletar) {
            vm.carregandoMensagens = true;
            return MensageiroService.listarMensagensImportantes(vm.usuarioLogado.codigo, pagina, null)

                .then(function (response) {

                    vm.mensagens = response;

                    vm.carregandoMensagens = false;

                    if ($state.params.mensagemId) {
                        for (var i = 0; i < vm.mensagens.length; i++) {
                            if (vm.mensagens[i].id === $state.params.mensagemId) {
                                vm.abrirMensagem(vm.mensagens[i]);
                                break;
                            }
                        }
                    }
                    executarAoCompletar(vm.mensagens);

                }, function (err) {
                    vm.carregandoMensagens = false;
                    MdDialogService.alertPadrao('Atenção', null, 'Não foi possível carregar as mensagens: ' + err)
                });
        }

        this.listarMensagensArquivadas = function (pagina, vm, executarAoCompletar) {
            vm.carregandoMensagens = true;
            return MensageiroService.listarMensagensArquivadas(vm.usuarioLogado.codigo, pagina, null)

                .then(function (response) {
                    vm.mensagens = response;

                    vm.carregandoMensagens = false;

                    if ($state.params.mensagemId) {
                        for (var i = 0; i < vm.mensagens.length; i++) {
                            if (vm.mensagens[i].id === $state.params.mensagemId) {
                                vm.abrirMensagem(vm.mensagens[i]);
                                break;
                            }
                        }
                    }
                    executarAoCompletar(vm.mensagens);
                }, function (err) {
                    vm.carregandoMensagens = false;
                    MdDialogService.alertPadrao('Atenção', null, 'Não foi possível carregar as mensagens: ' + err)
                });
        }

        return this;
    }
})();

(function () {
    'use strict';

    angular
        .module('app.manutencao.ordem-servico')
        .controller('OrdemServicoController', OrdemServicoController)

    function OrdemServicoController(
        $state,
        $scope,
        $mdDialog,
        $q,
        NavegacaoService,
        Api,
        AtualizacaoLicencaFactory,
        ListarClientes,
        ListarEmpresaAtivo,
        ListarPrioridade,
        ListarTipoServico,
        MdToastService,
        RotasHtml,
        ListarTodosUsuariosAtivos,
        RequisicaoGenericaLocacaoService,
        MdDialogService,
        ListarOrigemPecaAtivo,
        ListarTipoEnvio,
        ListarTipoProcedimentos,
        ListarTodosMargem,
        LoginUsuarioService

    ) {
        var vm = this;
        NavegacaoService.setTituloAba("Ordem de serviço");

        init();

        function init() {
            vm.ordemServicoEnvio = {};
            vm.ordens = [];
            vm.itens = [];
            vm.rotasHtmlNota = RotasHtml.ordem_servico;
            vm.filtro = AtualizacaoLicencaFactory.filtros;
            vm.envios = ListarTipoEnvio.data;
            vm.usuarioAtivo = ListarTodosUsuariosAtivos.data;
            vm.todasMargens = ListarTodosMargem.data;
            vm.mostarEnvio = false;
            vm.mostarEnvio1 = false;
            vm.mostarEnvio2 = false;
            vm.mostralistaEnvio = false;
            vm.mostralistaValor = false;
            vm.editando = false;
            vm.flagValor = true;
            vm.abrirDialogsAoIniciar = false;
            vm.desabilitaBotaoOsConcluida = false;
            vm.validaEquipamentos = false;
            vm.datasFinaisPreenchidas = false;
            vm.desabilitaBotaoOsValor = false;
            vm.valorTodosProcedimentos = 0;
            vm.usuarioId = LoginUsuarioService.usuarioArmazenado().codigo;
            vm.usuarioNome = LoginUsuarioService.usuarioArmazenado().login;
            vm.iniciaPesquinando = $state.params.parametros;
            vm.listaDeClientes = ListarClientes.data;

            if (vm.iniciaPesquinando != undefined)
                listarOsPorCodigo(vm.iniciaPesquinando);
        }

        vm.metodos = {
            abrirDialogOs: abrirDialogOs,
            pesquisarItensOs: pesquisarItensOs,
            excluir: excluir
        };

        vm.metodosItens = {
            abrirDialogItens: abrirDialogItens,
            excluirItem: excluirItem,
            abrirDialogProcedimentos: abrirDialogProcedimentos,
            abrirDialogExecucao: abrirDialogExecucao,
            abrirDialogEnvio: abrirDialogEnvio,
            abrirDialogValor: abrirDialogValor,
            abrirFinalizarOs: abrirFinalizarOs
        }

        function listarOsPorCodigo(os) {
            return RequisicaoGenericaLocacaoService.listarSemParams(
                Api.manutencao.ordem_servico.listarPorCodigo + os.idOs
            ).then(function (success) {
                vm.codigoOs = success.data.id;
                vm.ordemServicoConcluir = success.data;
                vm.listaDeClientes.clientes.filter(function (item) {
                    if (success.data.clienteId == item.codigo)
                        vm.ordens.clienteNome = item.nome;
                });
                if (vm.ordemServicoConcluir.status == 3) {
                    vm.desabilitaBotaoOsConcluida = true;
                    vm.validaEquipamentos = true;
                }

                vm.abrirDialogsAoIniciar = true;
                vm.ordens.push(success.data);
            });
        }

        function listarEnvioPorCodigo() {
            return RequisicaoGenericaLocacaoService.listarSemParams(
                Api.manutencao.ordem_servico_envio.listarPorOs + vm.itemId
            ).then(function (success) {
                if (success.data != "") {
                    vm.ordemServicoEnvio = success.data;
                    vm.editando = true;
                    vm.flagValor = true;
                } else {
                    vm.ordemServicoEnvio = {};
                }

                if (success.data.recebido)
                    vm.recebido = "Sim"

                else
                    vm.recebido = "Não"

                vm.ordemServicoEnvio.tipoEnvioNomeUsuario = vm.usuarioAtivo.filter(function (arg) {
                    if (arg.codigo == success.data.recebidoPor)
                        return arg;
                });

                vm.ordemServicoEnvio.tipoEnvio = vm.envios.filter(function (item) {
                    if (item.id == success.data.ordemServicoTipoEnvioId)
                        return item;
                });
            });
        }

        function listarValorPorCodigoOs() {
            return RequisicaoGenericaLocacaoService.listarSemParams(
                Api.manutencao.ordem_servico_envio_valores.listarPorOS + vm.itemId
            ).then(function (success) {
                vm.ordemServicoValor = success.data;

                vm.ordemServicoValor.valorReal = vm.ordemServicoValor.valorCusto + vm.ordemServicoValor.valorFrete + vm.ordemServicoValor.valorPeca;

                vm.flagValor = false;
            });
        }

        //-----------------------FINALIZAR SERVIÇO----------------------------
        function abrirFinalizarOs() {
            var dataInicioExecucao = vm.itens.reduce(function (menor, item) {
                if (item.execucao.dataInicio && (!menor || item.execucao.dataInicio < menor)) {
                    return item.execucao.dataInicio;
                } else {
                    return menor;
                }
            }, null);

            var modelo = vm.objDialogEquipamento;

            MdDialogService.confirmPadraoComEvento("Deseja mesmo finalizar esta ordem de serviço?", null, event, function () {
                if (modelo.status == 4 || modelo.status == 5) {
                    MdDialogService.alertPadraoComEvento("Atenção!", function () {
                        $mdDialog.hide();
                    }, null, "<h2>Não é possível finalizar uma ordem de serviço cancelada ou reprovada.</h2>");
                }
                else {
                    modelo.status = 3;
                    modelo.responsavelExecucaoId = vm.usuarioId;
                    modelo.usuarioNome = vm.usuarioNome;
                    modelo.dataExecucaoInicial = dataInicioExecucao;
                    modelo.dataExecucaoFinal = new Date();

                    RequisicaoGenericaLocacaoService.editar(Api.manutencao.ordem_servico.editar, modelo)
                        .then(function (success) {
                            vm.ordens.forEach(function (item) {
                                if (item.id == modelo.id) {
                                    var ordens = vm.ordens.indexOf(item);
                                    vm.ordens.splice(ordens, 1);
                                }
                            });

                            MdToastService.toastPadrao(
                                "Ordem de serviço finalizada com sucesso!"
                            );
                            vm.cardItem = false;
                            vm.mostarEnvio = false;
                            vm.mostralistaEnvio = false;
                            vm.mostralistaValor = false;
                            vm.editando = false;
                            vm.ordemServicoEnvio = {};
                            vm.ordemServicoValor = "";
                        }, function (err) {
                            MdDialogService.alertPadrao("Atenção!", event, err.data.error[0]);
                            vm.salvando = false;
                        });
                }
            });
        }
        //-----------------------FINALIZAR SERVIÇO----------------------------

        //-----------------------ORDEM DE SERVIÇO----------------------------

        function abrirDialogOs(event, modelo, visualizacao) {
            $mdDialog
                .show({
                    controller: "DialogOrdemServicoController",
                    controllerAs: "vm",
                    templateUrl: vm.rotasHtmlNota.dialogs.dialog_ordem_servico,
                    multiple: true,
                    targetEvent: event,
                    clickOutsideToClose: false,
                    locals: {
                        EmpresasAtivos: ListarEmpresaAtivo.data,
                        Prioridades: ListarPrioridade.data,
                        TipoServicos: ListarTipoServico.data,
                        Clientes: ListarClientes.data,
                        Filtro: vm.filtro,
                        Usuarios: ListarTodosUsuariosAtivos.data,
                        OrdemServico: modelo,
                        ApenasVisualizacao: visualizacao
                    }
                })
                .then(function (success) {
                    vm.ordemServicoConcluir = success;
                    vm.ordemServicoId = success.id;
                    if (success != undefined) {
                        MdToastService.toastPadrao(
                            "Ordem de serviço cadastrada com sucesso!"
                        );
                        if (modelo == null)
                            vm.ordens.push(success);
                        else
                            vm.ordens[vm.ordens.indexOf(modelo)] = success;

                        if (vm.itemId == success.id)
                            vm.ordemVinculada = success;

                    }
                });
        }

        function verificaSeTodosEquipamentosTemDataDeExecucao() {
            vm.oSFinalizada = false;
            vm.itens.forEach(function (item) {
                if (item.execucao == undefined) {
                    vm.oSFinalizada = true;
                }
            });
        }

        function pesquisarItensOs(item, index) {
            vm.mostarEnvio = false;
            vm.objDialogEquipamento = item;
            vm.itemId = item.id;
            RequisicaoGenericaLocacaoService.listarSemParams(Api.manutencao.ordem_servico_item.listarPorOS + vm.itemId)
                .then(function (success) {
                    if (success.data.length > 0) {
                        vm.mostarEnvio = true;
                        vm.mostralistaEnvio = true;
                        vm.mostralistaValor = true;
                        listarEnvioPorCodigo(vm.itemId);
                        listarValorPorCodigoOs(vm.itemId);
                    }

                    var promessas = [];
                    vm.itens = success.data;
                    vm.itens.forEach(function (equipamento) {
                        if (equipamento) {
                            promessas.push(atualizarProcedimentos(equipamento));
                            promessas.push(atualizarExecucao(equipamento));
                        };
                    });

                    $q.all(promessas).then(function () {
                        vm.valorTotalProcedimentos = 0;
                        vm.valorTotalPecas = 0;
                        somaProcedimentosDeTodosOsItens(vm.itens);
                        somaProcedimentosDeTodosOsItensPeca(vm.itens);
                    })

                    verificaSeTodosEquipamentosTemDataDeExecucao();
                    vm.cardItem = true;
                    vm.ordemVinculada = item;

                    if (vm.ordemServicoEnvio.ordemServicoId != item.id || vm.ordemServicoValor.ordemServicoId != item.id) {
                        vm.ordemServicoEnvio = {};
                        vm.ordemServicoValor = {};
                    }
                }, function (err) {
                    MdDialogService.alertPadrao("Atenção!", event, err.data.error);
                })
        }

        function atualizarProcedimentos(equipamento) {
            return RequisicaoGenericaLocacaoService.listarSemParams(
                Api.manutencao.ordem_servico_procedimento.listarPorItem + equipamento.id).
                then(function (success) {
                    equipamento.procedimentos = success.data;
                    vm.flagValor = (vm.ordemServicoConcluir.status == 3) ? false : true;
                });
        }

        function atualizarExecucao(equipamento) {
            return RequisicaoGenericaLocacaoService.listarSemParams(
                Api.manutencao.ordem_servico_execucao.listarPorItem + equipamento.id).
                then(function (success) {
                    if (success.data == "") {
                        equipamento.execucao = undefined;
                    } else {
                        equipamento.execucao = success.data;
                        vm.flagValor = (vm.ordemServicoConcluir.status == 3) ? false : true;
                    }
                });
        }

        function excluir(modelo) {
            MdDialogService.confirmPadraoComEvento("Deseja mesmo excluir esta ordem de serviço?", null, event, function () {
                return RequisicaoGenericaLocacaoService.excluir(
                    Api.manutencao.ordem_servico.remover,
                    modelo.id
                ).then(
                    function (success) {
                        MdToastService.toastPadrao("Item removido com sucesso!");
                        vm.cardItem = false;
                        vm.ordens.splice(vm.ordens.indexOf(modelo), 1);
                    },
                    function (err) {
                        MdDialogService.alertPadrao("Atenção!", event, err.data.error);
                    }
                );
            }, function () {

            });
        }

        //---------------------------------------------------------ORDEM DE SERVIÇO-----------------------------


        //-----------------------------------------------------ITENS DA ORDEM SE SERVIÇO-----------------------

        function abrirDialogItens(event, item, visualizacao) {
            $mdDialog
                .show({
                    controller: "DialogOrdemServicoItemController",
                    controllerAs: "vm",
                    templateUrl: vm.rotasHtmlNota.dialogs.dialog_ordem_servico_item,
                    multiple: true,
                    targetEvent: event,
                    clickOutsideToClose: false,
                    locals: {
                        EmpresasAtivos: ListarEmpresaAtivo.data,
                        OrdemVinculada: vm.ordemVinculada,
                        Item: item,
                        ApenasVisualizacao: visualizacao
                    }
                })
                .then(function (success) {
                    if (success != undefined) {

                        if (item == null) {
                            MdToastService.toastPadrao(
                                "Equipamento cadastrado com sucesso!"
                            );
                            vm.itens.push(success);
                        }
                        else if (success.mensagem == "Registro exluído com sucesso.") {
                            MdToastService.toastPadrao(
                                "Equipamento removido com sucesso!"
                            );
                            pesquisarItensOs(vm.objDialogEquipamento);
                            vm.itens[vm.itens.indexOf(item)] = success;
                        }
                        else {
                            MdToastService.toastPadrao(
                                "Equipamento editado com sucesso!"
                            );
                            vm.itens[vm.itens.indexOf(item)] = success;
                        }

                        verificaSeTodosEquipamentosTemDataDeExecucao();
                    }
                });
        }

        function excluirItem(modelo) {
            MdDialogService.confirmPadraoComEvento("Deseja mesmo excluir este item?", null, event, function () {
                return RequisicaoGenericaLocacaoService.excluir(
                    Api.manutencao.ordem_servico_item.remover,
                    modelo.id
                ).then(
                    function (success) {
                        MdToastService.toastPadrao("Item removido com sucesso!");
                        vm.itens.splice(vm.itens.indexOf(modelo), 1);
                    },
                    function (err) {
                        MdDialogService.alertPadrao("Atenção", event, err.data.error);
                    }
                );
            }, function () {

            });
        }

        function abrirDialogProcedimentos(index, modelo) {
            $mdDialog
                .show({
                    controller: "DialogOrdemServicoProcedimentoController",
                    controllerAs: "vm",
                    templateUrl: vm.rotasHtmlNota.dialogs.dialog_ordem_servico_procedimento,
                    multiple: true,
                    targetEvent: event,
                    clickOutsideToClose: false,
                    locals: {
                        Pecas: ListarOrigemPecaAtivo.data,
                        Procedimentos: ListarTipoProcedimentos.data,
                        ItemVinculado: modelo,
                        OrdemVinculada: vm.ordemVinculada,
                        ValidaEquipamentos: vm.validaEquipamentos
                    }

                })
                .then(function (success) {
                    vm.itens[vm.itens.indexOf(modelo)].procedimentos = success;
                    vm.valorTotalProcedimentos = 0;
                    vm.valorTotalPecas = 0;

                    somaProcedimentosDeTodosOsItens(vm.itens);
                    somaProcedimentosDeTodosOsItensPeca(vm.itens);

                    if (vm.ordemServicoValor.valorCusto != undefined) {
                        if (vm.ordemServicoValor.valorCusto != _arredondaValorDecimal(vm.valorTodosProcedimentos))
                            vm.flagValor = true;
                        else
                            vm.flagValor = false;
                    }

                    vm.desabilitaBotaoOsValor = !vm.itens.every(function (item) {
                        return item.procedimentos.length > 0;
                    });
                });
        }

        function somaProcedimentosDeTodosOsItensPeca(itens) {
            itens.forEach(function (peca) {
                peca.procedimentos.map(function (item) {
                    var qtd = item.quantidade;
                    vm.valorTotalPecas += (item.custoPeca * qtd);
                });
            });

            vm.valorTodosProcedimentosPeca = vm.valorTotalPecas;
        }

        function somaProcedimentosDeTodosOsItens(itens) {
            itens.forEach(function (equipamento) {
                equipamento.procedimentos.map(function (item) {
                    vm.valorTotalProcedimentos += item.valorProcedimento * item.quantidade;
                });
            });
            vm.valorTodosProcedimentos = vm.valorTotalProcedimentos;
        }

        function abrirDialogExecucao(event, item) {
            $mdDialog
                .show({
                    controller: "DialogOrdemServicoExecucaoController",
                    controllerAs: "vm",
                    templateUrl: vm.rotasHtmlNota.dialogs.dialog_ordem_servico_execucao,
                    multiple: true,
                    targetEvent: event,
                    clickOutsideToClose: false,
                    locals: {
                        Usuarios: ListarTodosUsuariosAtivos.data,
                        OrdemVinculada: vm.ordemVinculada,
                        Item: item,
                        ValidaEquipamentos: vm.validaEquipamentos
                    }
                })
                .then(function (success) {
                    verificaSeTodosEquipamentosTemDataDeExecucao();
                    if (success.dataInicio != undefined) {
                        vm.itens[vm.itens.indexOf(item)].execucao = success;

                        vm.datasFinaisPreenchidas = !vm.itens.some(function (item) {
                            return item.execucao.dataFim == null;
                        });
                        vm.mostarEnvio = true;
                        vm.dataExecFinalParaODialogDeEnvio = success.dataFim;
                        vm.desabilitaBotaoOsValor = !vm.itens.every(function (item) {
                            return item.procedimentos.length > 0;
                        });
                    }
                    else
                        return;

                    verificaSeTodosEquipamentosTemDataDeExecucao();
                });
        }

        function abrirDialogEnvio(event) {
            $mdDialog
                .show({
                    controller: "DialogOrdemServicoEnvioController",
                    controllerAs: "vm",
                    templateUrl:
                        vm.rotasHtmlNota.dialogs.dialog_ordem_servico_envio,
                    multiple: true,
                    targetEvent: event,
                    clickOutsideToClose: false,
                    locals: {
                        Usuarios: ListarTodosUsuariosAtivos.data,
                        TiposEnvios: ListarTipoEnvio.data,
                        OrdemVinculada: vm.ordemVinculada,
                        Envio: vm.ordemServicoEnvio,
                        DataExecFinal: vm.dataExecFinalParaODialogDeEnvio
                    }
                })
                .then(function (success) {
                    MdToastService.toastPadrao("Envio adicionado com sucesso!");
                    vm.ordemServicoEnvio = success;
                    vm.mostralistaEnvio = true;
                    vm.editando = true;
                    vm.flagValor = true;

                    verificaSeTodosEquipamentosTemDataDeExecucao();

                    if (success.recebido)
                        vm.recebido = "Sim"

                    else
                        vm.recebido = "Não"

                    vm.ordemServicoEnvio.tipoEnvioNomeUsuario = vm.usuarioAtivo.filter(function (arg) {
                        if (arg.codigo == success.recebidoPor)
                            return arg;
                    });

                    vm.ordemServicoEnvio.tipoEnvio = vm.envios.filter(function (item) {
                        if (item.id == success.ordemServicoTipoEnvioId)
                            return item;
                    });

                    vm.desabilitaBotaoOsValor = !vm.itens.every(function (item) {
                        return item.procedimentos.length > 0;
                    });
                });
        }

        function abrirDialogValor(event) {
            $mdDialog
                .show({
                    controller: "DialogOrdemServicoValorController",
                    controllerAs: "vm",
                    templateUrl:
                        vm.rotasHtmlNota.dialogs.dialog_ordem_servico_valor,
                    multiple: true,
                    targetEvent: event,
                    clickOutsideToClose: false,
                    locals: {
                        Usuarios: ListarTodosUsuariosAtivos.data,
                        TiposEnvios: ListarTipoEnvio.data,
                        OrdemVinculada: vm.ordemVinculada,
                        Envio: vm.ordemServicoEnvio,
                        Totais: vm.valorTodosProcedimentosPeca,
                        OrdemServicoId: vm.ordemServicoId,
                        OrdemServicoIdPesquisa: vm.codigoOs,
                        MargemMinima: vm.todasMargens,
                        ValorTotalProcedimentos: vm.valorTodosProcedimentos,
                        TipoServico: ListarTipoServico,
                        OrdemServicoValor: vm.ordemServicoValor
                    }
                })
                .then(function (success) {
                    MdToastService.toastPadrao("Valores adicionados com sucesso!");
                    vm.ordemServicoValor = success;
                    vm.mostralistaValor = true;
                    verificaSeTodosEquipamentosTemDataDeExecucao();

                    if (vm.ordemServicoValor.valorCusto != _arredondaValorDecimal(vm.valorTodosProcedimentos))
                        vm.flagValor = true;
                    else
                        vm.flagValor = false;

                    vm.datasFinaisPreenchidas = !vm.itens.some(function (item) {
                        return item.execucao.dataFim == null;
                    });

                });
        }

        function _arredondaValorDecimal(valor) {
            return Math.round(valor * 100) / 100;
        }
    }
}());



(function () {
    'use strict';

    angular
        .module('app.manutencao.entrada')
        .controller('EntradaController', EntradaController)

    function EntradaController(
        $state,
        $mdDialog,
        Api,
        NavegacaoService,
        RequisicaoGenericaLocacaoService,
        DatatableLocacaoFactory,
        ListarEquipamento,
        LoginUsuarioService,
        RotasHtml,
        MdDialogService,
        MdToastService,
        ListarClientes
    ) {
        var vm = this;
        NavegacaoService.setTituloAba('Entrada');
        vm.equipamentos = ListarEquipamento.data;
        vm.cadastrarItens = false;
        vm.rotasHtmlNota = RotasHtml.entrada;
        vm.entradas = [];
        vm.entrada = {};
        vm.filtro = {};
        init();

        function init() {
            vm.clientes = ListarClientes.data;
            vm.filtroClientes = ListarClientes.data;
        }

        vm.metodos = {
            pesquisar: pesquisar,
            excluir: excluir,
            selecionar: selecionar,
            construirDtOptions: construirDtOptions,
            cadastrarItens: cadastrarItens,
            dialogEquipamentoItem: dialogEquipamentoItem,
            voltar: voltar,
            dialogEquipamentoItemEditar: dialogEquipamentoItemEditar,
            editarNota: editarNota,
            configuraAutoCompleteClienteOnBlur: configuraAutoCompleteClienteOnBlur,
            alterarItemSelecionadoAutoCompleteCliente: alterarItemSelecionadoAutoCompleteCliente,
            pesquisarAutoCompleteCliente: pesquisarAutoCompleteCliente,
            abrirCadastroCliente: abrirCadastroCliente
        };

        function voltar() {
            vm.entradas = [];
            vm.cadastrarItens = false;
            vm.adicionandoEquip = false;
            vm.entrada = {};
            vm.form.$setPristine();
            vm.form.$setValidity();
            vm.form.$setUntouched();
        }


        function configuraAutoCompleteClienteOnBlur() {
            if (!vm.filtro.cliente) {
                vm.textoDePesquisaAutoCompleteCliente = "";
            }
        }

        function alterarItemSelecionadoAutoCompleteCliente(item) {
            if (item) {
                vm.filtro.cliente = item;

            } else {
                vm.textoDePesquisaAutoCompleteCliente = "";

                vm.filtro.cliente = null;
                vm.textoDePesquisaAutoCompleteCliente = "";
            }
        }

        function pesquisarAutoCompleteCliente(query) {
            var resultado = vm.filtroClientes.filter(function (cliente) {
                if (
                    cliente.nome.toLowerCase().includes(query.toLowerCase()) ||
                    cliente.codigo == query
                ) {
                    return cliente;
                }
            });

            return resultado;
        }

        function dialogEquipamentoItem(nota) {
            $mdDialog
                .show({
                    controller: "DialogEquipamentoItemController",
                    controllerAs: "vm",
                    templateUrl: vm.rotasHtmlNota.dialogs.dialog_equipamento_item,
                    multiple: true,
                    targetEvent: event,
                    clickOutsideToClose: false,
                    locals: {
                        Nota: angular.copy(nota),
                        Equipamento: vm.equipamentos,
                        Editando: false,
                        CodigoCliente: vm.filtro.cliente.codigo,
                        ClienteSelecionado: vm.filtro.cliente
                    }
                })
                .then(function (success) {
                    vm.entradas.push(success);
                });
        }

        function dialogEquipamentoItemEditar(nota) {
            $mdDialog
                .show({
                    controller: "DialogEquipamentoItemController",
                    controllerAs: "vm",
                    templateUrl: vm.rotasHtmlNota.dialogs.dialog_equipamento_item,
                    multiple: true,
                    targetEvent: event,
                    clickOutsideToClose: false,
                    locals: {
                        Nota: angular.copy(nota),
                        Equipamento: vm.equipamentos,
                        Editando: true,
                        CodigoCliente: vm.filtro.cliente.codigo,
                        ClienteSelecionado: vm.filtro.cliente
                    },
                })
                .then(function (success) {
                    vm.entradas[vm.entradas.indexOf(nota)] = success;
                });
        }

        function cadastrarItens(notaSaida) {
            vm.requisicaoSolicitada = true;
            vm.cadastrarItens = true;
            vm.adicionandoEquip = true;

            RequisicaoGenericaLocacaoService.listarSemParams(Api.manutencao.entrada.listarPorNotaSaida + notaSaida.trim())
                .then(function (success) {
                    vm.entradas = success.data;
                    vm.requisicaoSolicitada = false;
                })
        }

        function pesquisar() {
            return RequisicaoGenericaLocacaoService.listarComObjetoComplexo(Api.manutencao.entrada.listarComPaginacao, vm.entidadeDeEnvio);
        }

        function excluir(modelo) {
            MdDialogService.confirmPadraoComEvento("Deseja mesmo excluir este item?", null, event, function () {
                RequisicaoGenericaLocacaoService.excluir(Api.manutencao.entrada.remover, modelo.id)
                    .then(function (success) {
                        MdToastService.toastPadrao("Item removido com sucesso!");
                        vm.entradas.splice(vm.entradas.indexOf(modelo), 1);
                    }, function (err) {
                        MdDialogService.alertPadrao("Atenção", event, err.data.error);
                    })
            }, function () {

            });


        }

        function editarNota(nota) {
            $mdDialog
                .show({
                    controller: "DialogEditarNotaController",
                    controllerAs: "vm",
                    templateUrl: vm.rotasHtmlNota.dialogs.dialog_editar_nota,
                    multiple: true,
                    targetEvent: event,
                    clickOutsideToClose: false,
                    locals: {
                        Nota: angular.copy(nota),
                        Entradas: angular.copy(vm.entradas),
                        Clientes: ListarClientes,
                        CodigoCliente: vm.filtro.cliente.codigo,
                        ClienteSelecionado: vm.filtro.cliente
                    }
                })
                .then(function (success) {
                    vm.entrada.clienteId = success.clienteId;
                    vm.entrada.dataEntrada = success.dataEntrada;
                    vm.entrada.notaFiscalSaida = success.notaFiscalSaida;
                    vm.entrada.notaFiscalEntrada = success.notaFiscalEntrada;
                    vm.clienteSelecionadoDialogEdicao = success.clienteSelecionado;
                    cadastrarItens(vm.entrada.notaFiscalSaida);
                    editarItemAoEditarNota(success);
                });
        }

        function editarItemAoEditarNota(modelo) {
            vm.requisicaoSolicitada = true;
            vm.salvando = true;
            modelo.usuarioId = LoginUsuarioService.usuarioArmazenado().codigo;
            modelo.clienteNome = modelo.clienteSelecionado.nome
            RequisicaoGenericaLocacaoService.editar(Api.manutencao.entrada.editar, modelo)
                .then(function (success) {
                    vm.requisicaoSolicitada = false;
                    vm.salvando = false;
                    MdToastService.toastPadrao("Equipamento editado com sucesso!");
                    $mdDialog.hide(success.data);
                }, function (err) {
                    MdDialogService.alertPadrao("Atenção", event, err.data.error[0]);
                    vm.salvando = false;
                })
        }

        function selecionar(posicaoEntidade) {
            vm.metodosExternosPgToolbar.metodoControladorExternoListarTodasEntidades(null, posicaoEntidade);
        }

        function construirDtOptions() {
            DatatableLocacaoFactory.destruirTabela();

            vm.entidadeDeEnvio.clsEntidade = null;

            DatatableLocacaoFactory.construirDtOptionsComPaginacaoProcessadoNoServidorParaToolbar
                (Api.manutencao.entrada.listarComPaginacaoDataTable,
                    vm.entidadeDeEnvio.clsEntidade,
                    '#datatable-equipamentoItem',
                    [

                        DatatableLocacaoFactory.construirColunaDeSelecionarPadrao(function (indexLinha) { vm.metodos.selecionar(indexLinha) }),
                        {
                            targets: 1,
                            name: "Equipamento",
                            data: "equipamentoDescricao",
                            defaultContent: ""
                        },
                        {
                            targets: 2,
                            name: "Serie",
                            data: "numeroSerie",
                            defaultContent: ""
                        },
                        {
                            targets: 3,
                            name: "IMEI",
                            data: "imei",
                            defaultContent: ""
                        },
                        {
                            targets: 4,
                            name: "notaEntrada",
                            data: "notaFiscalEntrada",
                            defaultContent: ""
                        },
                        {
                            targets: 5,
                            name: "notaSaida",
                            data: "notaFiscalSaida",
                            defaultContent: ""
                        }
                    ]);
            vm.entidadeDeEnvio.clsEntidade = {};

        }

        function abrirCadastroCliente(cliente) {
            if (!cliente)
                MdDialogService.alertPadrao("É necessário selecionar um cliente!");
            else {
                $state.goNewTab("app.geral_cadastro_cliente_cliente", {
                    parametros: {
                        cliente: cliente
                    }
                });
            }
        }
    }
}());

(function () {
    'use strict';

    angular
        .module('app.manutencao.dashboard')
        .controller('DashboardController', DashboardController)

    function DashboardController(
        Api,
        $mdDialog,
        RotasHtml,
        RequisicaoGenericaLocacaoService,
        $timeout,
        $mdSidenav,
        ListarEmpresaAtivo,
        ListarTipoServico,
        ListarTecnicos,
        ListarTodosUsuarios,
        ListarClientesOrdemServico,
        MdDialogService,
        NavegacaoService
    ) {
        var vm = this;

        NavegacaoService.setTituloAba('Dashboard');

        vm.rotasHtmlDashboard = RotasHtml.dashboard;
        vm.clienteComOrdemServico = ListarClientesOrdemServico.data;
        vm.empresaAtivo = ListarEmpresaAtivo.data;
        vm.tipoServico = ListarTipoServico.data;
        vm.usuariosAtivos = ListarTodosUsuarios.data;

        vm.clienteComOrdemServico.forEach(function (cliente) {
            cliente.codigo = cliente.id;
        });
        vm.tipoServico.forEach(function (servico) {
            servico.codigo = servico.id;
            servico.quantidade = 0;
        });
        vm.tecnicos = ListarTecnicos.data.find(function (setor) {
            //setor manutenção
            return setor.codigo == 12;
        }).usuarios;

        vm.totalClientes = 0;
        vm.status = [
            { codigo: 1, descricao: "Aberta" },
            { codigo: 2, descricao: "Em execução" },
            { codigo: 3, descricao: "Executada" },
            { codigo: 4, descricao: "Cancelada" },
            { codigo: 5, descricao: "Reprovada" }
        ];

        vm.clienteComOrdemServicoSelecionado = [];
        vm.empresaAtivoSelecionado = [];
        vm.tipoServicoSelecionado = [];
        vm.statusSelecionado = [];
        vm.tecnicosSelecionado = [];

        vm.filtro = {
            tipoPesquisa: 2,
            dataInicial: '',
            dataFinal: '',
            clientes: [],
            empresaAtivo: [],
            ordemServicoTipoServico: [],
            status: [],
            responsavelAbertura: []
        };

        vm.cards = [
            {
                codigo: 1,
                nome: 'Total de peças',
                valor: 0
            },
            {
                codigo: 2,
                nome: 'Total mão de obra',
                valor: 0
            },
            {
                codigo: 3,
                nome: 'Frete',
                valor: 0
            },
            {
                codigo: 4,
                nome: 'Custo base total',
                valor: 0
            },
            {
                codigo: 5,
                nome: 'Faturado',
                valor: 0
            },
            {
                codigo: 6,
                nome: 'Margem',
                valor: 0
            }
        ];

        vm.dadosPorStatus = [
            {
                disabled: false,
                descricao: "Em aberto",
                quantidade: 0
            },
            {
                disabled: false,
                descricao: "Em execução",
                quantidade: 0
            },
            {
                disabled: false,
                descricao: "Executadas",
                quantidade: 0
            },
            {
                disabled: false,
                descricao: "Canceladas",
                quantidade: 0
            },
            {
                disabled: false,
                descricao: "Reprovadas",
                quantidade: 0
            }
        ];

        vm.toggleLeft = buildDelayedToggler("left");
        vm.toggleRight = buildToggler("right");
        vm.isOpenRight = function () {
            return $mdSidenav("right").isOpen();
        };
        vm.close = function () {
            // Component lookup should always be available since we are not using `ng-if`
            $mdSidenav("right").close()
        };

        vm.metodos = {
            abrirDialogOrdensServicoPeriodo: abrirDialogOrdensServicoPeriodo,
            abrirDialogClientes: abrirDialogClientes,
            abrirDialogEquipamentos: abrirDialogEquipamentos,
            buscarOrdensServico: buscarOrdensServico
        }

        init();

        function init() {
            vm.requisicaoSolicitada = false;
            vm.possuiOSFinalizada = false;
            vm.mostrarDados = false;

            vm.graficoPorStatus = {
                options: {
                    chart: {
                        type: "pieChart",
                        height: 400,
                        margin: {
                            top: 0,
                            right: 0,
                            bottom: 0,
                            left: 0
                        },
                        donut: false,
                        clipEdge: true,
                        cornerRadius: 0,
                        labelType: "percent",
                        padAngle: 0,
                        x: function (d) {
                            return d.descricao;
                        },
                        y: function (d) {
                            return d.quantidade;
                        },
                        tooltip: {
                            gravity: "s",
                            classes: "gravity-s"
                        },
                        legend: {
                            maxKeyLength: 100,
                            margin: {
                                top: 5,
                                right: 0,
                                bottom: 0,
                                left: 0
                            }
                        },
                        noData: "Não existem dados a serem exibidos"
                    }
                },
                data: vm.dadosPorStatus
            };

            vm.graficoPorTipoServico = {
                options: {
                    chart: {
                        type: "pieChart",
                        height: 400,
                        margin: {
                            top: 0,
                            right: 0,
                            bottom: 0,
                            left: 0
                        },
                        donut: false,
                        clipEdge: true,
                        cornerRadius: 0,
                        labelType: "percent",
                        padAngle: 0,
                        x: function (d) {
                            return d.descricao;
                        },
                        y: function (d) {
                            return d.quantidade;
                        },
                        tooltip: {
                            gravity: "s",
                            classes: "gravity-s"
                        },
                        legend: {
                            maxKeyLength: 100,
                            margin: {
                                top: 5,
                                right: 10,
                                bottom: 0,
                                left: 0
                            }
                        },
                        noData: "Não existem dados a serem exibidos"
                    }
                },
                data: vm.tipoServico
            };
        }

        function debounce(func, wait) {
            var timer;

            return function debounced() {
                var context = this,
                    args = Array.prototype.slice.call(arguments);
                $timeout.cancel(timer);
                timer = $timeout(function () {
                    timer = undefined;
                    func.apply(context, args);
                }, wait || 10);
            };
        }

        function buildDelayedToggler(navID) {
            return debounce(function () {
                // Component lookup should always be available since we are not using `ng-if`
                $mdSidenav(navID).toggle()
            }, 200);
        }

        function buildToggler(navID) {
            return function () {
                // Component lookup should always be available since we are not using `ng-if`
                $mdSidenav(navID).toggle()
            };
        }

        function buscarOrdensServico(filtro) {
            vm.requisicaoSolicitada = true;

            filtro.ordemServicoTipoServico = vm.tipoServicoSelecionado.map(function (servico) {
                return servico.codigo;
            });
            filtro.empresaAtivo = vm.empresaAtivoSelecionado.map(function (empresa) {
                return empresa.codigo;
            });
            filtro.status = vm.statusSelecionado.map(function (status) {
                return status.codigo;
            });
            filtro.responsavelAbertura = vm.tecnicosSelecionado.map(function (tecnico) {
                return tecnico.codigo;
            });
            filtro.clientes = vm.clienteComOrdemServicoSelecionado.map(function (cliente) {
                return cliente.codigo;
            });

            RequisicaoGenericaLocacaoService.listarComObjetoComplexo(Api.manutencao.dashboard.listarPorPeriodo, filtro)
                .then(function (success) {
                    vm.requisicaoSolicitada = false;
                    vm.ordensServico = success.data;

                    if (vm.ordensServico.length > 0) {
                        _limparDadosGrafico(vm.dadosPorStatus);
                        _limparDadosGrafico(vm.tipoServico);

                        vm.possuiOSFinalizada = vm.ordensServico.some(function (os) {
                            return os.status == 3
                        });

                        vm.ordensServico.forEach(function (os) {
                            switch (os.status) {
                                case 1:
                                    vm.dadosPorStatus[0].quantidade += 1;
                                    break;
                                case 2:
                                    vm.dadosPorStatus[1].quantidade += 1;
                                    break;
                                case 3:
                                    vm.dadosPorStatus[2].quantidade += 1;
                                    break;
                                case 4:
                                    vm.dadosPorStatus[3].quantidade += 1;
                                    break;
                                case 5:
                                    vm.dadosPorStatus[4].quantidade += 1;
                                    break;
                                default:
                                    return;
                            }
                        });

                        var quantidadeTiposServico = {};
                        vm.ordensServico.forEach(function (os) {
                            quantidadeTiposServico[os.ordemServicoTipoServico] = (quantidadeTiposServico[os.ordemServicoTipoServico] || 0) + 1;
                        });

                        vm.tipoServico.forEach(function (tipoServico) {
                            var descricao = tipoServico.descricao;
                            if (quantidadeTiposServico[descricao]) {
                                tipoServico.quantidade = quantidadeTiposServico[descricao];
                            }
                        });

                        vm.mostrarDados = true;

                        vm.close();
                    } else {
                        MdDialogService.alertPadrao("Atenção! ", null, "Não há dados para o filtro realizado!");
                        vm.requisicaoSolicitada = false;
                        vm.mostrarDados = false;
                    }
                }, function (error) {
                    MdDialogService.alertPadrao("Atenção! ", null, "Não há dados para o filtro realizado!");
                    vm.requisicaoSolicitada = false;
                    vm.mostrarDados = false;
                });

            RequisicaoGenericaLocacaoService.listarComObjetoComplexo(Api.manutencao.dashboard.listarPorCliente, filtro)
                .then(function (success) {
                    vm.ordensServicoCliente = success.data;
                });

            RequisicaoGenericaLocacaoService.listarComObjetoComplexo(Api.manutencao.dashboard.listarPorTotalizadores, filtro)
                .then(function (success) {
                    vm.totalizadores = success.data[0];
                });

            RequisicaoGenericaLocacaoService.listarComObjetoComplexo(Api.manutencao.dashboard.listarPorTotalizadoresEquipamentos, filtro)
                .then(function (success) {
                    vm.equipamentos = success.data;
                });

            RequisicaoGenericaLocacaoService.listarComObjetoComplexo(Api.manutencao.dashboard.listarPorTotalizadoresOsExecutadas, filtro)
                .then(function (success) {
                    vm.totalizadoresOsExecutadas = success.data[0];
                    vm.cards[0].valor = _converteParaReal(vm.totalizadoresOsExecutadas.valorTotalPeca);
                    vm.cards[1].valor = _converteParaReal(vm.totalizadoresOsExecutadas.valorTotalMaoObra);
                    vm.cards[2].valor = _converteParaReal(vm.totalizadoresOsExecutadas.valorTotalFrete);
                    vm.cards[3].valor = _converteParaReal(vm.totalizadoresOsExecutadas.valorTotalCustoBase);
                    vm.cards[4].valor = _converteParaReal(vm.totalizadoresOsExecutadas.valorTotalFaturado);
                });

            RequisicaoGenericaLocacaoService.listarComObjetoComplexo(Api.manutencao.dashboard.listarPorMargem, filtro)
                .then(function (success) {
                    vm.cards[5].valor = success.data[0].margem;
                });
        }

        function abrirDialogOrdensServicoPeriodo() {
            $mdDialog
                .show({
                    controller: "DialogOrdensServicoPeriodoController",
                    controllerAs: "vm",
                    templateUrl: vm.rotasHtmlDashboard.dialogs.dialogOrdensServicoPeriodo,
                    multiple: true,
                    targetEvent: event,
                    clickOutsideToClose: false,
                    locals: {
                        OrdensServico: vm.ordensServico,
                        UsuariosAtivos: vm.usuariosAtivos,
                        Status: vm.status,
                        ConverteParaReal: _converteParaReal
                    }
                });
        }

        function abrirDialogClientes() {
            $mdDialog
                .show({
                    controller: "DialogClientesController",
                    controllerAs: "vm",
                    templateUrl: vm.rotasHtmlDashboard.dialogs.dialogClientes,
                    multiple: true,
                    targetEvent: event,
                    clickOutsideToClose: false,
                    locals: {
                        OrdensServicoCliente: vm.ordensServicoCliente,
                        ConverteParaReal: _converteParaReal
                    }
                });
        }

        function abrirDialogEquipamentos() {
            $mdDialog
                .show({
                    controller: "DialogEquipamentosController",
                    controllerAs: "vm",
                    templateUrl: vm.rotasHtmlDashboard.dialogs.dialogQuantidadeEquipamento,
                    multiple: true,
                    targetEvent: event,
                    clickOutsideToClose: false,
                    locals: {
                        Equipamentos: vm.equipamentos
                    }
                });
        }

        function _converteParaReal(valor) {
            if (!valor)
                valor = 0;

            return valor.toLocaleString('pt-Br', {
                style: 'currency',
                currency: 'BRL'
            });

        }

        function _limparDadosGrafico(dados) {
            dados.forEach(function (data) {
                data.quantidade = 0;
            });
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.diretivas')
        .directive('controleAcessoMenuMdCheckboxClick', controleAcessoMenuMdCheckboxClickDirective);

    function controleAcessoMenuMdCheckboxClickDirective() {
        return {
            restrict: 'A',
            require: "^ngModel",
            scope: {
                controleAcessoMenuMdCheckboxClick: '&?',
                menuSelecionado: '=?'
            },
            link: function (scope, element, attrs, ngModelCtrl) {
                element.bind('click', function (event) {
                    scope.controleAcessoMenuMdCheckboxClick(event, "asd", "asd");
                })
            }
        }
    }

})();

/**
 * Created by nova on 27/09/2016.
 */
(function () {
    'use strict';

    angular
        .module('app.erros.error-404', [])
        .config(Config);

    function Config($stateProvider, RotasHtml) {
        var rotasHtmlErro404 = RotasHtml.erro_404;
        // State
        $stateProvider.state('app.erros_error-404', {
            url: '/error-404',
            views: {
                'main@': {
                    templateUrl: 'app/core/layouts/content-only.html',
                    controller: 'IndexController as vm'
                },
                'content@app.erros_error-404': {
                    templateUrl: rotasHtmlErro404.templateUrl,
                    controller: 'Error404Controller as vm'
                }
            },
            bodyClass: 'error-404'
        });

    }

})();

(function ()
 {
  'use strict';

  angular
    .module('app.erros.error-404')
    .controller('Error404Controller', Error404Controller);

  /** @ngInject */
  function Error404Controller($state, $rootScope)
  {
    var vm = this;
    // Data

    // Methods

    //////////
  }
})();

/**
 * Created by nova on 27/09/2016.
 */
(function(){
  'use strict';

  angular
    .module('app.erros.manutencao', [])
    .config(Config);

  function Config($stateProvider, RotasHtml) {
    var rotasHtmlManutencao = RotasHtml.manutencao;    
    // State
    $stateProvider.state('app.em_manutencao', {
      url      : '/em-manutencao',
      views    : {
        'main@': {
          templateUrl: 'app/core/layouts/content-only.html',
          controller: 'IndexController as vm'
        },
        'content@app.em_manutencao': {
            templateUrl: rotasHtmlManutencao.templateUrl,
          controller : 'ManutencaoController as vm'
        }
      },
      bodyClass: 'maintenance'
    });

  }

})();

(function ()
 {
  'use strict';

  angular
    .module('app.erros.manutencao')
    .controller('ManutencaoController', ManutencaoController);

  /** @ngInject */
  function ManutencaoController($state, $rootScope)
  {
    var vm = this;
    // Data

    // Methods

    //////////
  }
})();

(function () {
    'use strict';

    angular
        .module('app.datamobil')
        .service('RequisicaoDatamobilService', RequisicaoDatamobilService);

    function RequisicaoDatamobilService($http, $q, LoginUsuarioService) {
        var service = this;
        var urlBase = "https://datamobil.reader.homologacao.inovamobil.com.br";
        var datamobilToken = null;
        var codigoProduto = 3;

        service.autenticar = autenticar;
        service.get = get;
        service.post = post;
        service.put = put;
        service.delete = _delete;
        service.download = download;
        service.consultarN8N = consultarN8N;

        function consultarN8N(data) {
            var url = "https://n8n.srv954202.hstgr.cloud/webhook/DataMobil_IManager?Solicitacao=" + encodeURIComponent(data.solicitacao);
            return $http({
                url: url,
                method: "GET"
            });
        }

        function _fazerRequisicaoComRetry(config) {
            var promise = datamobilToken ? $q.resolve() : autenticar();

            return promise.then(function () {
                config.headers = _getHeaders();
                return $http(config);
            }).catch(function (error) {
                if (error.status === 401) {
                    return autenticar().then(function () {
                        config.headers = _getHeaders();
                        return $http(config);
                    });
                }
                return $q.reject(error);
            });
        }

        function _getHeaders() {
            return {
                "Authorization": "Bearer " + datamobilToken,
                "Content-Type": "application/json"
            };
        }

        function _verificarUrlBase() {
            if (!urlBase) {
                var errorMsg = "URL da API Datamobil.IA não configurada em config.json (url_datamobil).";
                console.error(errorMsg);
                return $q.reject(errorMsg);
            }
            return null;
        }

        function autenticar() {
            var error = _verificarUrlBase();
            if (error) return error;

            var usuario = LoginUsuarioService.usuarioArmazenado();
            var credenciais = {
                login: usuario.login,
                codigoUsuario: usuario.codigo
            };

            return $http({
                url: urlBase + '/api/autenticacao/login-externo',
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "X-Auth": "READER"
                },
                data: credenciais,
                ignoreAuthInterceptor: true
            }).then(function (response) {
                if (response && response.data) {
                    datamobilToken = response.data;
                }
                return response;
            });
        }

        function get(rota, params) {
            var error = _verificarUrlBase();
            if (error) return error;

            var queryParams = angular.extend({}, params, { produto: codigoProduto });

            var config = {
                url: urlBase + rota,
                method: "GET",
                params: queryParams,
                ignoreAuthInterceptor: true
            };

            return _fazerRequisicaoComRetry(config);
        }

        function post(rota, dados) {
            var error = _verificarUrlBase();
            if (error) return error;

            var postData = angular.extend({}, dados, { produto: codigoProduto });

            var config = {
                url: urlBase + rota,
                method: "POST",
                data: postData,
                ignoreAuthInterceptor: true
            };

            return _fazerRequisicaoComRetry(config);
        }

        function put(rota, dados) {
            var error = _verificarUrlBase();
            if (error) return error;

            var config = {
                url: urlBase + rota,
                method: "PUT",
                data: dados,
                ignoreAuthInterceptor: true
            };

            return _fazerRequisicaoComRetry(config);
        }

        function _delete(rota) {
            var error = _verificarUrlBase();
            if (error) return error;

            var config = {
                url: urlBase + rota,
                method: "DELETE",
                ignoreAuthInterceptor: true
            };

            return _fazerRequisicaoComRetry(config);
        }

        function download(rota, dados) {
            var error = _verificarUrlBase();
            if (error) return error;

            var config = {
                url: urlBase + rota,
                method: "POST",
                responseType: 'arraybuffer',
                data: dados,
                ignoreAuthInterceptor: true
            };

            return _fazerRequisicaoComRetry(config);
        }

    }
})();
(function () {
    'use strict';
    angular
        .module('app.datamobil')
        .service("DatamobilIaService", DatamobilIaService);

    function DatamobilIaService(RequisicaoDatamobilService) {
        var service = this;
        var codigoImanager = '0001';

        service.favoritos = [];
        service.avaliarResposta = avaliarResposta;
        service.gerarRelatorio = gerarRelatorio;
        service.atualizarFavorito = atualizarFavorito;
        service.listarFavoritos = listarFavoritos;
        service.isFavorito = isFavorito;
        service.criarFavorito = criarFavorito;
        service.removerFavorito = removerFavorito;
        service.editarFavorito = editarFavorito;
        service.baixarArquivoXLSX = baixarArquivoXLSX;
        service.consultarIA = consultarIA;
        service.salvarHistoricoComandos = salvarHistoricoComandos;

        function listarFavoritos() {
            return RequisicaoDatamobilService.get('/api/comandos-favoritos/obter-todos', { codigoIManager: codigoImanager })
                .then(function (response) {
                    service.favoritos = response.data || [];
                    return service.favoritos;
                });
        }

        function consultarIA(comando) {
            var dados = {
                solicitacao: comando,
                codigoIManager: codigoImanager
            };
            return RequisicaoDatamobilService.consultarN8N(dados);
        }

        function criarFavorito(entidade) {
            var dadosEnvio = {
                codigoIManager: codigoImanager,
                comando: entidade.comando,
                titulo: entidade.titulo || ''
            };
            return RequisicaoDatamobilService.post('/api/comandos-favoritos', dadosEnvio)
                .then(function (response) {
                    var criado = response.data;
                    service.favoritos.push(criado);
                    return criado;
                });
        }

        function removerFavorito(id) {
            return RequisicaoDatamobilService.delete('/api/comandos-favoritos/' + id)
                .then(function () {
                    var index = service.favoritos.findIndex(function (item) { return item.id === id; });
                    if (index > -1) {
                        service.favoritos.splice(index, 1);
                    }
                });
        }

        function editarFavorito(favorito) {
            var dadosEnvio = {
                id: favorito.id,
                comando: favorito.comando,
                titulo: favorito.titulo
            };
            return RequisicaoDatamobilService.put('/api/comandos-favoritos', dadosEnvio)
                .then(function (response) {
                    var atualizado = response.data;
                    var index = service.favoritos.findIndex(function (item) { return item.id === atualizado.id; });
                    if (index > -1) {
                        service.favoritos[index] = atualizado;
                    }
                    return atualizado;
                });
        }

        function atualizarFavorito(comando) {
            var existente = service.favoritos.find(function (item) { return item.comando === comando; });
            if (existente) {
                return removerFavorito(existente.id);
            }
            return criarFavorito(comando);
        }

        function isFavorito(comando) {
            return service.favoritos.some(function (item) { return item.comando === comando; });
        }

        function avaliarResposta(mensagem, avaliacao) {
            var rota = '/api/historico-comandos';
            var dadosPut = {
                id: mensagem.avaliacaoId,
                avaliacaoPositiva: avaliacao === null ? null : avaliacao === 'positiva',
            };
            return RequisicaoDatamobilService.put(rota, dadosPut);
        }

        function salvarHistoricoComandos(mensagem) {
            var usageGpt = mensagem.usageGPT || {};
            var usageGptDiagnostico = mensagem.usageGptDiagnostico || {};

            var dadosEnvio = {
                codigoIManager: codigoImanager,
                comando: mensagem.comando,
                query: mensagem.query || 'Não possui query',
                avaliacaoPositiva: null,
                erro: mensagem.texto || '',
                tokenInputGeradorQuery: usageGpt.input_tokens || 0,
                tokenOutputGeradorQuery: usageGpt.output_tokens || 0,
                tokenTotalGeradorQuery: usageGpt.total_tokens || 0,
                tokenInputDiagnostico: usageGptDiagnostico.input_tokens || 0,
                tokenOutputDiagnostico: usageGptDiagnostico.output_tokens || 0,
                tokenTotalDiagnostico: usageGptDiagnostico.total_tokens || 0
            };

            return RequisicaoDatamobilService.post('/api/historico-comandos', dadosEnvio)
                .then(function (response) {
                    var retorno = response.data;
                    mensagem.avaliacaoId = retorno.id;
                    return retorno;
                });
        }

        function gerarRelatorio(listaDeDados) {
            var rota = '/api/relatorio/gerar-planilha';
            var corpoRequisicao = {
                dados: listaDeDados
            };
            return RequisicaoDatamobilService.download(rota, corpoRequisicao);
        }

        function baixarArquivoXLSX(response, nomeArquivo) {
            var contentType = response.headers('content-type');
            var blob = new Blob([response.data], { type: contentType });
            var nomeFinal = nomeArquivo || 'relatorio.xlsx';

            var url = window.URL.createObjectURL(blob);
            var a = document.createElement('a');
            a.href = url;
            a.download = nomeFinal;
            a.style.display = 'none';
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
            window.URL.revokeObjectURL(url);
        }

    }
})();
(function () {
    'use strict';

    angular
        .module('app.diretivas')
        .directive('validadorNavegacao', validadorNavegacaoDirective);

    function validadorNavegacaoDirective() {
        return {
            restrict: 'A',
            require: "^ngModel",
            scope: {
                validadorNavegacao: '=?'
            },
            link: function (scope, element, attrs, ngModelCtrl) {
                if (!scope.validadorNavegacao)
                    throw new Error("é necessário definir a navegação do menu pai selecionado.");

                ngModelCtrl.$parsers.push(validador);
                ngModelCtrl.$formatters.push(validador);

                function validador(valor) {
                    if (valor && valor.length <= scope.validadorNavegacao) {
                        ngModelCtrl.$setValidity('menuIgualAoMenuPai', false);
                    }
                    else {
                        ngModelCtrl.$setValidity('menuIgualAoMenuPai', true);
                    }

                    return valor;
                }
            }
        }
    }

})();

(function () {
    'use strict';

    angular
        .module('app.diretivas')
        .directive('mascaraTextoCampoEstadoNavegacaoTipoCaixa', mascaraTextoCampoEstadoNavegacaoTipoCaixaDirective);

    function mascaraTextoCampoEstadoNavegacaoTipoCaixaDirective() {
        return {
            restrict: 'A',
            require: "^ngModel",
            link: function (scope, element, attrs, ngModelCtrl) {
                var aceitaUnderline = false,
                    aceitaPonto = false;

                if (angular.isDefined(attrs.aceitaPonto))
                    aceitaPonto = true;

                if (angular.isDefined(attrs.aceitaUnderline))
                    aceitaUnderline = true;

                ngModelCtrl.$parsers.push(mascararTexto);
                function mascararTexto(valor) {
                    if (!valor)
                        return valor;

                    valor.toString();

                    var valorFormatado = valor.toLowerCase();
                    if (valorFormatado != valor) {
                        ngModelCtrl.$setViewValue(valorFormatado);
                        ngModelCtrl.$render();
                    }

                    return valorFormatado;
                }

                element.bind('keydown', function (event) {
                    if (_verificaInConcistenciaTexto(event.keyCode))
                        event.preventDefault();
                });

                //#region  Métodos Internos

                function _verificaInConcistenciaTexto(keyCode) {
                    if ((keyCode >= 65 && keyCode <= 90) || (aceitaPonto && keyCode == 190) || keyCode == 8 || keyCode == 46 || (aceitaUnderline && keyCode == 189)
                        || (keyCode >= 35 && keyCode <= 40) || keyCode == 9) 
                        return false;
                    else
                        return true;
                }
                //#endregion
            }
        }
    }

})();

/**
 * Created by nova on 27/09/2016.
 */
(function () {
    'use strict';

    angular
        .module('app.atendimento.processamento', [
            'app.atendimento.processamento.atendimento',
            'app.atendimento.processamento.atendimentoNaoVisualizados',
            'app.atendimento.processamento.atendimentosEmAberto',
            'app.atendimento.processamento.atendimentosVinculados',
            'app.atendimento.processamento.atendimentosimportantes',
            'app.atendimento.processamento.atualizacoespendentes',
        ]);

})();

(function () {
    'use strict';

    angular
        .module('app.atendimento.processamento')
        .directive('validarCodigoAtendimento', validarCodigoAtendimentoDirective);

    function validarCodigoAtendimentoDirective(RequisicaoGenericaService, Api) {
        return {
            restrict: 'A',
            require: '^ngModel',
            scope: {
                mascaraAUtilizar: '@?',
                desabilitarMascara: '=?',
                limitarTamanhoCampoQuandoDesabilitarMascaraAtivo: '@?',
                alterarMascaraDinamicamente: '=?'
            },
            controller: function () {
            },
            link: function (scope, element, attrs, ngModelCtrl) {
                var timeout;

                scope.$watch(function () {
                    return ngModelCtrl.$modelValue;
                }, function (newValue) {
                    if (newValue) {
                        if (timeout) clearTimeout(timeout);

                        timeout = setTimeout(function () {
                            RequisicaoGenericaService.listarSemParams(Api.atendimento.verificarSeExisteCodigoAtendimento + newValue).then(
                                function (success) { ngModelCtrl.$setValidity('codigoAtendimentoNaoEncontrado', success.data); });
                        }, 200)
                    }
                });
            }
        }
    };

})();

(function () {
    'use strict';

    angular
        .module('app.atendimento.processamento')
        .directive('validarAnoAtendimento', validarAnoAtendimentoDirective);

    function validarAnoAtendimentoDirective(RequisicaoGenericaService, Api) {
        return {
            restrict: 'A',
            require: '^ngModel',
            scope: {},
            controller: function () {
            },
            link: function (scope, element, attrs, ngModelCtrl) {
                var timeout;

                scope.$watch(function () {
                    return ngModelCtrl.$modelValue;
                }, function (newValue) {
                    if (newValue) {
                        if (timeout) clearTimeout(timeout);

                        timeout = setTimeout(function () {
                            RequisicaoGenericaService.listarSemParams(Api.atendimento.verificarSeExisteAnoAtendimento + newValue).then(
                                function (success) { ngModelCtrl.$setValidity('anoAtendimentoNaoEncontrado', success.data); });
                        }, 200)
                    }
                });
            }
        }
    };

})();

(function(){
  'use strict'

  angular
    .module('app.filtros', []);

})();

(function () {
  'use strict';

  angular
    .module('app.filtros')
    .filter('filtrarPorDescricao', filtrarPorDescricao);

  function filtrarPorDescricao() {
    return function (itens, descricao) {
      if (itens.length == 0 || !descricao) {
        return itens;
      }
      var filtrados = [];

      angular.forEach(itens, function (key, value) {
        if (key.registroSituacao.descricao == descricao) {
          filtrados.push(key);
        }
      });

      console.log(filtrados);
      return filtrados;

    }
  }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core',
            [
                'ngAnimate',
                'ngAria',
                'ngCookies',
                'ngMessages',
                'ngResource',
                'ngSanitize',
                'ngMaterial',
                'pascalprecht.translate',
                'ui.router'
            ]);
})();
(function () {
    'use strict';

    angular
        .module('app.core')
        .controller('MsStepperController', MsStepperController)
        .directive('msHorizontalStepper', msHorizontalStepperDirective)
        .directive('msHorizontalStepperStep', msHorizontalStepperStepDirective)
        .directive('msVerticalStepper', msVerticalStepperDirective)
        .directive('msVerticalStepperStep', msVerticalStepperStepDirective);

    /** @ngInject */
    function MsStepperController(
        $timeout,
        $scope
    ) {

        var vm = this;

        if (vm.customButtonSubmitText == null ||
            vm.customButtonSubmitText == undefined) {
            vm.customButtonSubmitText = "Enviar";
        }

        // Data
        vm.mainForm = undefined;

        vm.orientation = 'horizontal';
        vm.steps = [];
        vm.currentStep = undefined;
        vm.currentStepNumber = 1;

        // Methods
        vm.setOrientation = setOrientation;
        vm.registerMainForm = registerMainForm;
        vm.registerStep = registerStep;
        vm.setupSteps = setupSteps;
        vm.resetForm = resetForm;

        vm.setCurrentStep = setCurrentStep;

        vm.gotoStep = gotoStep;
        vm.gotoPreviousStep = gotoPreviousStep;
        vm.gotoNextStep = gotoNextStep;
        vm.gotoFirstStep = gotoFirstStep;
        vm.gotoLastStep = gotoLastStep;

        vm.isFirstStep = isFirstStep;
        vm.isLastStep = isLastStep;

        vm.isStepCurrent = isStepCurrent;
        vm.isStepDisabled = isStepDisabled;
        vm.isStepOptional = isStepOptional;
        vm.isStepHidden = isStepHidden;
        vm.filterHiddenStep = filterHiddenStep;
        vm.isStepValid = isStepValid;
        vm.isStepNumberValid = isStepNumberValid;

        vm.isFormValid = isFormValid;

        if (vm.model) {
            vm.model.msVerticalStepperController = this;
        }
        //////////

        /**
         * Set the orientation of the stepper
         *
         * @param orientation
         */
        function setOrientation(orientation) {
            vm.orientation = orientation || 'horizontal';
        }

        /**
         * Register the main form
         *
         * @param form
         */
        function registerMainForm(form) {
            vm.mainForm = form;
        }

        /**
         * Register a step
         *
         * @param element
         * @param scope
         * @param form
         */
        function registerStep(element, scope, form) {
            var step = {
                element: element,
                scope: scope,
                form: form,
                stepNumber: scope.step || (vm.steps.length + 1),
                stepTitle: scope.stepTitle,
                stepTitleTranslate: scope.stepTitleTranslate
            };

            // Push the step into steps array
            vm.steps.push(step);

            // Sort steps by stepNumber
            vm.steps.sort(function (a, b) {
                return a.stepNumber - b.stepNumber;
            });

            return step;
        }

        /**
         * Setup steps for the first time
         */
        function setupSteps() {
            vm.setCurrentStep(vm.currentStepNumber);
        }

        /**
         * Reset steps and the main form
         */
        function resetForm() {

            // Timeout is required here because we need to
            // let form model to reset before setting the
            // statuses
            $timeout(function () {
                // Reset all the steps
                for (var x = 0; x < vm.steps.length; x++) {
                    vm.steps[x].form.$setPristine();
                    vm.steps[x].form.$setUntouched();
                }

                // Reset the main form
                vm.mainForm.$setPristine();
                vm.mainForm.$setUntouched();

                if (vm.onSubmitValueStep) {
                    setCurrentStep(vm.model.selectStep);
                    return;
                }

                // Go to first step
                gotoFirstStep();
            });
        }

        /**
         * Set current step
         *
         * @param stepNumber
         */
        function setCurrentStep(stepNumber) {
            // If the stepNumber is not a valid step number, bail...
            if (!isStepNumberValid(stepNumber)) {
                return;
            }

            if (vm.currentStepNumber != stepNumber) {
                if (vm.selectStepClick)
                    vm.selectStepClick();
            }

            // Update the current step number
            vm.currentStepNumber = stepNumber;


            if (vm.orientation === 'horizontal') {
                // Hide all steps
                for (var i = 0; i < vm.steps.length; i++) {
                    vm.steps[i].element.hide();
                }

                // Show the current step
                vm.steps[vm.currentStepNumber - 1].element.show();
            }
            else if (vm.orientation === 'vertical') {
                // Hide all step content
                for (var j = 0; j < vm.steps.length; j++) {
                    vm.steps[j].element.find('.ms-stepper-step-content').hide();
                }

                // Show the current step content
                vm.steps[vm.currentStepNumber - 1].element.find('.ms-stepper-step-content').show();
            }
        }

        /**
         * Go to a step
         *
         * @param stepNumber
         */
        function gotoStep(stepNumber) {
            // If the step we are about to go
            // is hidden, bail...
            if (isStepHidden(stepNumber)) {
                return;
            }

            vm.setCurrentStep(stepNumber);
        }

        /**
         * Go to the previous step
         */
        function gotoPreviousStep() {
            var stepNumber = vm.currentStepNumber - 1;

            // Test the previous steps and make sure we
            // will land to the one that is not hidden
            for (var s = stepNumber; s >= 1; s--) {
                if (!isStepHidden(s)) {
                    stepNumber = s;
                    break;
                }
            }

            vm.setCurrentStep(stepNumber);
        }

        /**
         * Go to the next step
         */
        function gotoNextStep() {
            var stepNumber = vm.currentStepNumber + 1;

            // Test the following steps and make sure we
            // will land to the one that is not hidden
            for (var s = stepNumber; s <= vm.steps.length; s++) {
                if (!isStepHidden(s)) {
                    stepNumber = s;
                    break;
                }
            }
            vm.setCurrentStep(stepNumber);
        }

        /**
         * Go to the first step
         */
        function gotoFirstStep() {
            vm.setCurrentStep(1);
        }

        /**
         * Go to the last step
         */
        function gotoLastStep() {
            vm.setCurrentStep(vm.steps.length);
        }

        /**
         * Check if the current step is the first step
         *
         * @returns {boolean}
         */
        function isFirstStep() {
            return vm.currentStepNumber === 1;
        }

        /**
         * Check if the current step is the last step
         *
         * @returns {boolean}
         */
        function isLastStep() {
            return vm.currentStepNumber === vm.steps.length;
        }

        /**
         * Check if the given step is the current one
         *
         * @param stepNumber
         * @returns {null|boolean}
         */
        function isStepCurrent(stepNumber) {
            // If the stepNumber is not a valid step number, bail...
            if (!isStepNumberValid(stepNumber)) {
                return null;
            }

            return vm.currentStepNumber === stepNumber;
        }

        /**
         * Check if the given step should be disabled
         *
         * @param stepNumber
         * @returns {null|boolean}
         */
        function isStepDisabled(stepNumber) {
            // If the stepNumber is not a valid step number, bail...
            if (!isStepNumberValid(stepNumber)) {
                return null;
            }

            var disabled = false;

            for (var i = 1; i < stepNumber; i++) {
                if (!isStepValid(i)) {
                    disabled = true;
                    break;
                }
            }

            return disabled;
        }

        /**
         * Check if the given step is optional
         *
         * @param stepNumber
         * @returns {null|boolean}
         */
        function isStepOptional(stepNumber) {
            // If the stepNumber is not a valid step number, bail...
            if (!isStepNumberValid(stepNumber)) {
                return null;
            }

            return vm.steps[stepNumber - 1].scope.optionalStep;
        }

        /**
         * Check if the given step is hidden
         *
         * @param stepNumber
         * @returns {null|boolean}
         */
        function isStepHidden(stepNumber) {
            // If the stepNumber is not a valid step number, bail...
            if (!isStepNumberValid(stepNumber)) {
                return null;
            }

            return !!vm.steps[stepNumber - 1].scope.hideStep;
        }

        /**
         * Check if the given step is hidden as a filter
         *
         * @param step
         * @returns {boolean}
         */
        function filterHiddenStep(step) {
            return !isStepHidden(step.stepNumber);
        }

        /**
         * Check if the given step is valid
         *
         * @param stepNumber
         * @returns {null|boolean}
         */
        function isStepValid(stepNumber) {
            // If the stepNumber is not a valid step number, bail...
            if (!isStepNumberValid(stepNumber)) {
                return null;
            }

            // If the step is optional, always return true
            if (isStepOptional(stepNumber)) {
                return true;
            }

            return vm.steps[stepNumber - 1].form.$valid;
        }

        /**
         * Check if the given step number is a valid step number
         *
         * @param stepNumber
         * @returns {boolean}
         */
        function isStepNumberValid(stepNumber) {
            return !(angular.isUndefined(stepNumber) || stepNumber < 1 || stepNumber > vm.steps.length);
        }

        /**
         * Check if the entire form is valid
         *
         * @returns {boolean}
         */
        function isFormValid() {
            return vm.mainForm.$valid;
        }
    }

    /** @ngInject */
    function msHorizontalStepperDirective() {
        return {
            restrict: 'A',
            scope: {},
            require: ['form', 'msHorizontalStepper'],
            priority: 1001,
            controller: 'MsStepperController as MsStepper',
            bindToController: {
                model: '=ngModel',
                disableSteps: "=?",
                selectStepClick: '&?',
                onSubmitValueStep: '@?',
                customButtonSubmitText: '@?'
            },
            transclude: true,
            templateUrl: 'app/core/directives/ms-stepper/templates/horizontal/horizontal.html',
            compile: function (tElement) {
                tElement.addClass('ms-stepper');

                return function postLink(scope, iElement, iAttrs, ctrls) {
                    var FormCtrl = ctrls[0],
                        MsStepperCtrl = ctrls[1];

                    // Register the main form and setup
                    // the steps for the first time
                    MsStepperCtrl.setOrientation('horizontal');
                    MsStepperCtrl.registerMainForm(FormCtrl);
                    MsStepperCtrl.setupSteps();
                };
            }
        };
    }

    /** @ngInject */
    function msHorizontalStepperStepDirective() {
        return {
            restrict: 'E',
            require: ['form', '^msHorizontalStepper'],
            priority: 1000,
            scope: {
                step: '=?',
                stepTitle: '=?',
                stepTitleTranslate: '=?',
                optionalStep: '=?',
                hideStep: '=?'
            },
            compile: function (tElement) {
                tElement.addClass('ms-stepper-step');

                return function postLink(scope, iElement, iAttrs, ctrls) {
                    var FormCtrl = ctrls[0],
                        MsStepperCtrl = ctrls[1];

                    // Is it an optional step?
                    scope.optionalStep = angular.isDefined(iAttrs.optionalStep);

                    // Register the step
                    MsStepperCtrl.registerStep(iElement, scope, FormCtrl);

                    // Hide the step by default
                    iElement.hide();
                };
            }
        };
    }

    /** @ngInject */
    function msVerticalStepperDirective($timeout) {
        return {
            restrict: 'A',
            scope: {},
            require: ['form', 'msVerticalStepper'],
            priority: 1001,
            controller: 'MsStepperController as MsStepper',
            bindToController: {
                model: '=ngModel',
                disableSteps: "=?",
                selectStepClick: '&?',
                onSubmitValueStep: '@?',
                customButtonSubmitText: '@?',
                desabilitaBotaoNext: '=?',
                exibeBotaoNext: '=?'
            },
            transclude: true,
            templateUrl: 'app/core/directives/ms-stepper/templates/vertical/vertical.html',
            compile: function (tElement) {
                tElement.addClass('ms-stepper');

                return function postLink(scope, iElement, iAttrs, ctrls) {
                    var FormCtrl = ctrls[0],
                        MsStepperCtrl = ctrls[1];

                    // Register the main form and setup
                    // the steps for the first time

                    // Timeout is required in vertical stepper
                    // as we are using transclusion in steps.
                    // We have to wait for them to be transcluded
                    // and registered to the controller
                    $timeout(function () {
                        MsStepperCtrl.setOrientation('vertical');
                        MsStepperCtrl.registerMainForm(FormCtrl);
                        MsStepperCtrl.setupSteps();
                    });
                };
            }
        };
    }

    /** @ngInject */
    function msVerticalStepperStepDirective() {
        return {
            restrict: 'E',
            require: ['form', '^msVerticalStepper'],
            priority: 1000,
            scope: {
                step: '=?',
                stepTitle: '=?',
                stepTitleTranslate: '=?',
                optionalStep: '=?',
                hideStep: '=?'
            },
            transclude: true,
            templateUrl: 'app/core/directives/ms-stepper/templates/vertical/step/vertical-step.html',
            compile: function (tElement) {
                tElement.addClass('ms-stepper-step');

                return function postLink(scope, iElement, iAttrs, ctrls) {
                    var FormCtrl = ctrls[0],
                        MsStepperCtrl = ctrls[1];

                    // Is it an optional step?
                    scope.optionalStep = angular.isDefined(iAttrs.optionalStep);

                    // Register the step
                    scope.stepInfo = MsStepperCtrl.registerStep(iElement, scope, FormCtrl);

                    // Expose the controller to the scope
                    scope.MsStepper = MsStepperCtrl;

                    MsStepperCtrl

                    // Hide the step content by default
                    iElement.find('.ms-stepper-step-content').hide();
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsWidgetController', MsWidgetController)
        .directive('msWidget', msWidgetDirective)
        .directive('msWidgetFront', msWidgetFrontDirective)
        .directive('msWidgetBack', msWidgetBackDirective);

    /** @ngInject */
    function MsWidgetController($scope, $element)
    {
        var vm = this;

        // Data
        vm.flipped = false;

        // Methods
        vm.flip = flip;

        //////////

        /**
         * Flip the widget
         */
        function flip()
        {
            if ( !isFlippable() )
            {
                return;
            }

            // Toggle flipped status
            vm.flipped = !vm.flipped;

            // Toggle the 'flipped' class
            $element.toggleClass('flipped', vm.flipped);
        }

        /**
         * Check if widget is flippable
         *
         * @returns {boolean}
         */
        function isFlippable()
        {
            return (angular.isDefined($scope.flippable) && $scope.flippable === true);
        }
    }

    /** @ngInject */
    function msWidgetDirective()
    {
        return {
            restrict  : 'E',
            scope     : {
                flippable: '=?'
            },
            controller: 'MsWidgetController',
            transclude: true,
            compile   : function (tElement)
            {
                tElement.addClass('ms-widget');

                return function postLink(scope, iElement, iAttrs, MsWidgetCtrl, transcludeFn)
                {
                    // Custom transclusion
                    transcludeFn(function (clone)
                    {
                        iElement.empty();
                        iElement.append(clone);
                    });

                    //////////
                };
            }
        };
    }

    /** @ngInject */
    function msWidgetFrontDirective()
    {
        return {
            restrict  : 'E',
            require   : '^msWidget',
            transclude: true,
            compile   : function (tElement)
            {
                tElement.addClass('ms-widget-front');

                return function postLink(scope, iElement, iAttrs, MsWidgetCtrl, transcludeFn)
                {
                    // Custom transclusion
                    transcludeFn(function (clone)
                    {
                        iElement.empty();
                        iElement.append(clone);
                    });

                    // Methods
                    scope.flipWidget = MsWidgetCtrl.flip;
                };
            }
        };
    }

    /** @ngInject */
    function msWidgetBackDirective()
    {
        return {
            restrict  : 'E',
            require   : '^msWidget',
            transclude: true,
            compile   : function (tElement)
            {
                tElement.addClass('ms-widget-back');

                return function postLink(scope, iElement, iAttrs, MsWidgetCtrl, transcludeFn)
                {
                    // Custom transclusion
                    transcludeFn(function (clone)
                    {
                        iElement.empty();
                        iElement.append(clone);
                    });

                    // Methods
                    scope.flipWidget = MsWidgetCtrl.flip;
                };
            }
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msSplashScreen', msSplashScreenDirective);

    /** @ngInject */
    function msSplashScreenDirective($animate)
    {
        return {
            restrict: 'E',
            link    : function (scope, iElement)
            {
                var splashScreenRemoveEvent = scope.$on('msSplashScreen::remove', function ()
                {
                    $animate.leave(iElement).then(function ()
                    {
                        // De-register scope event
                        splashScreenRemoveEvent();

                        // Null-ify everything else
                        scope = iElement = null;
                    });
                });
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsTimelineController', MsTimelineController)
        .directive('msTimeline', msTimelineDirective)
        .directive('msTimelineItem', msTimelineItemDirective);

    /** @ngInject */
    function MsTimelineController()
    {
        var vm = this;

        // Data
        vm.scrollEl = undefined;

        // Methods
        vm.setScrollEl = setScrollEl;
        vm.getScrollEl = getScrollEl;

        //////////

        /**
         * Set scroll element
         *
         * @param scrollEl
         */
        function setScrollEl(scrollEl)
        {
            vm.scrollEl = scrollEl;
        }

        /**
         * Get scroll element
         *
         * @returns {undefined|*}
         */
        function getScrollEl()
        {
            return vm.scrollEl;
        }
    }

    /** @ngInject */
    function msTimelineDirective()
    {
        return {
            scope     : {
                msTimeline: '=?',
                loadMore  : '&?msTimelineLoadMore'
            },
            controller: 'MsTimelineController',
            compile   : function (tElement)
            {
                tElement.addClass('ms-timeline');

                return function postLink(scope, iElement, iAttrs, MsTimelineCtrl)
                {
                    // Create an element for triggering the load more action and append it
                    var loadMoreEl = angular.element('<div class="ms-timeline-loader md-accent-bg md-whiteframe-4dp"><span class="spinner animate-rotate"></span></div>');
                    iElement.append(loadMoreEl);

                    // Default config
                    var config = {
                        scrollEl: '#content'
                    };

                    // Extend the configuration
                    config = angular.extend(config, scope.msTimeline, {});
                    
                    // Grab the scrollable element and store it in the controller for general use
                    var scrollEl = angular.element(config.scrollEl);
                    MsTimelineCtrl.setScrollEl(scrollEl);

                    // Threshold
                    var threshold = 144;

                    // Register onScroll event for the first time
                    registerOnScroll();

                    /**
                     * onScroll Event
                     */
                    function onScroll()
                    {
                        if ( scrollEl.scrollTop() + scrollEl.height() + threshold > loadMoreEl.position().top )
                        {
                            // Show the loader
                            loadMoreEl.addClass('show');

                            // Unregister scroll event to prevent triggering the function over and over again
                            unregisterOnScroll();

                            // Trigger load more event
                            scope.loadMore().then(
                                // Success
                                function ()
                                {
                                    // Hide the loader
                                    loadMoreEl.removeClass('show');

                                    // Register the onScroll event again
                                    registerOnScroll();
                                },

                                // Error
                                function ()
                                {
                                    // Remove the loader completely
                                    loadMoreEl.remove();
                                }
                            );
                        }
                    }

                    /**
                     * onScroll event registerer
                     */
                    function registerOnScroll()
                    {
                        scrollEl.on('scroll', onScroll);
                    }

                    /**
                     * onScroll event unregisterer
                     */
                    function unregisterOnScroll()
                    {
                        scrollEl.off('scroll', onScroll);
                    }

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        unregisterOnScroll();
                    });
                };
            }
        };
    }

    /** @ngInject */
    function msTimelineItemDirective($timeout, $q)
    {
        return {
            scope  : true,
            require: '^msTimeline',
            compile: function (tElement)
            {
                tElement.addClass('ms-timeline-item').addClass('hidden');

                return function postLink(scope, iElement, iAttrs, MsTimelineCtrl)
                {
                    var threshold = 72,
                        itemLoaded = false,
                        itemInViewport = false,
                        scrollEl = MsTimelineCtrl.getScrollEl();

                    //////////

                    init();

                    /**
                     * Initialize
                     */
                    function init()
                    {
                        // Check if the timeline item has ms-card
                        if ( iElement.find('ms-card') )
                        {
                            // If the ms-card template loaded...
                            scope.$on('msCard::cardTemplateLoaded', function (event, args)
                            {
                                var cardEl = angular.element(args[0]);

                                // Test the card to see if there is any image on it
                                testForImage(cardEl).then(function ()
                                {
                                    $timeout(function ()
                                    {
                                        itemLoaded = true;
                                    });
                                });
                            });
                        }
                        else
                        {
                            // Test the element to see if there is any image on it
                            testForImage(iElement).then(function ()
                            {
                                $timeout(function ()
                                {
                                    itemLoaded = true;
                                });
                            });
                        }

                        // Check if the loaded element also in the viewport
                        scrollEl.on('scroll', testForVisibility);

                        // Test for visibility for the first time without waiting for the scroll event
                        testForVisibility();
                    }

                    // Item ready watcher
                    var itemReadyWatcher = scope.$watch(
                        function ()
                        {
                            return itemLoaded && itemInViewport;
                        },
                        function (current, old)
                        {
                            if ( angular.equals(current, old) )
                            {
                                return;
                            }

                            if ( current )
                            {
                                iElement.removeClass('hidden').addClass('animate');

                                // Unbind itemReadyWatcher
                                itemReadyWatcher();
                            }
                        }, true);

                    /**
                     * Test the given element for image
                     *
                     * @param element
                     * @returns promise
                     */
                    function testForImage(element)
                    {
                        var deferred = $q.defer(),
                            imgEl = element.find('img');

                        if ( imgEl.length > 0 )
                        {
                            imgEl.on('load', function ()
                            {
                                deferred.resolve('Image is loaded');
                            });
                        }
                        else
                        {
                            deferred.resolve('No images');
                        }

                        return deferred.promise;
                    }

                    /**
                     * Test the element for visibility
                     */
                    function testForVisibility()
                    {
                        if ( scrollEl.scrollTop() + scrollEl.height() > iElement.position().top + threshold )
                        {
                            $timeout(function ()
                            {
                                itemInViewport = true;
                            });

                            // Unbind the scroll event
                            scrollEl.off('scroll', testForVisibility);
                        }
                    }
                };
            }
        };
    }
})();
(function () {
    'use strict';

    angular
        .module('app.core')
        .controller('MsShortcutsController', MsShortcutsController)
        .directive('msShortcuts', msShortcutsDirective);

    /** @ngInject */
    function MsShortcutsController($scope, $cookies, $document, $timeout, $q, msNavigationService,
        RequisicaoGenericaService, MdToastService, ApiAtalhos, LoginUsuarioService, $rootScope) {
        var vm = this;

        var codigoUsuarioLogado = LoginUsuarioService.usuarioArmazenado().codigo;

        // Data
        vm.query = '';
        vm.queryOptions = {
            debounce: 300
        };
        vm.resultsLoading = false;
        vm.selectedResultIndex = 0;
        vm.ignoreMouseEvents = false;
        vm.mobileBarActive = false;

        vm.results = null;
        vm.shortcuts = [];

        vm.sortableOptions = {
            ghostClass: 'ghost',
            forceFallback: true,
            fallbackClass: 'dragging',
            onSort: function () {
                vm.saveShortcuts();
            }
        };

        // Methods
        vm.populateResults = populateResults;
        vm.loadShortcuts = loadShortcuts;
        vm.saveShortcuts = saveShortcuts;
        vm.addShortcut = addShortcut;
        vm.removeShortcut = removeShortcut;
        vm.handleResultClick = handleResultClick;

        vm.absorbEvent = absorbEvent;
        vm.handleKeydown = handleKeydown;
        vm.handleMouseenter = handleMouseenter;
        vm.temporarilyIgnoreMouseEvents = temporarilyIgnoreMouseEvents;
        vm.ensureSelectedResultIsVisible = ensureSelectedResultIsVisible;
        vm.toggleMobileBar = toggleMobileBar;

        //////////

        init();

        function init() {
            // Load the shortcuts
            vm.loadShortcuts().then(
                // Success
                function (response) {
                    vm.shortcuts = response;

                    // Add shortcuts as results by default
                    if (vm.shortcuts.length > 0) {
                        vm.results = response;
                    }
                }
            );

            // Watch the model changes to trigger the search
            $scope.$watch('MsShortcuts.query', function (current, old) {
                if (angular.isUndefined(current)) {
                    return;
                }

                if (angular.equals(current, old)) {
                    return;
                }

                // Show the loader
                vm.resultsLoading = true;

                // Populate the results
                vm.populateResults().then(
                    // Success
                    function (response) {
                        vm.results = response;
                    },
                    // Error
                    function () {
                        vm.results = [];
                    }
                ).finally(
                    function () {
                        // Hide the loader
                        vm.resultsLoading = false;
                    }
                );
            });
        }

        /**
         * Populate the results
         */
        function populateResults() {
            var results = [],
                flatNavigation = msNavigationService.getFlatNavigation(),
                deferred = $q.defer();

            // Iterate through the navigation array and
            // make sure it doesn't have any groups or
            // none ui-sref items
            for (var x = 0; x < flatNavigation.length; x++) {
                if (flatNavigation[x].uisref) {
                    results.push(flatNavigation[x]);
                }
            }

            // If there is a query, filter the results
            if (vm.query) {
                results = results.filter(function (item) {
                    if (angular.lowercase(item.title).search(angular.lowercase(vm.query)) > -1) {
                        return true;
                    }
                });

                // Iterate through one last time and
                // add required properties to items
                for (var i = 0; i < results.length; i++) {
                    // Add false to hasShortcut by default
                    results[i].hasShortcut = false;

                    // Test if the item is in the shortcuts list
                    for (var y = 0; y < vm.shortcuts.length; y++) {
                        if (vm.shortcuts[y]._id === results[i]._id && vm.shortcuts[y]._path === results[i]._path) {
                            results[i].hasShortcut = true;
                            break;
                        }
                    }
                }
            }
            else {
                // If the query is empty, that means
                // there is nothing to search for so
                // we will populate the results with
                // current shortcuts if there is any
                if (vm.shortcuts.length > 0) {
                    results = vm.shortcuts;
                }
            }

            // Reset the selected result
            vm.selectedResultIndex = 0;

            // Fake the service delay
            $timeout(function () {
                // Resolve the promise
                deferred.resolve(results);
            }, 250);

            // Return a promise
            return deferred.promise;
        }

        /**
         * Load shortcuts
         */
        function loadShortcuts() {
            var deferred = $q.defer();

            // For the demo purposes, we will
            // load the shortcuts from the cookies.
            // But here you can make an API call
            // to load them from the DB.
            $timeout(function () {
                $rootScope.loadingProgress = true;
                RequisicaoGenericaService.listarSemParams(ApiAtalhos.atalhos.listarTodos + codigoUsuarioLogado).then(
                    function (success) {
                        $rootScope.loadingProgress = false;
                        deferred.resolve(success.data);
                    },
                    function (error) {
                        $rootScope.loadingProgress = false;
                        deferred.reject(error.data);
                    });
            });

            return deferred.promise;
        }

        /**
         * Save the shortcuts
         */
        function saveShortcuts(item, adicionarShortCuts) {
            vm.query = "";
            /**
             * Verifica Se é pra inserir ou excluir o atalho com base na váriavel adicionarShortCuts
             */
            if (adicionarShortCuts) {
                // Add as a shortcut
                vm.shortcuts = item;
                vm.results = item;
            }
            else {
                // Remove the shortcut
                for (var x = 0; x < vm.shortcuts.length; x++) {
                    if (vm.shortcuts[x]._id === item._id && vm.shortcuts[x]._path == item._path) {
                        // Remove the x-th item from the array
                        vm.shortcuts.splice(x, 1);

                        // If we aren't searching for anything...
                        if (!vm.query) {
                            // If all the shortcuts have been removed,
                            // null-ify the results
                            if (vm.shortcuts.length === 0) {
                                vm.results = null;
                            }
                            // Otherwise update the selected index
                            else {
                                if (x >= vm.shortcuts.length) {
                                    vm.selectedResultIndex = vm.shortcuts.length - 1;
                                }
                            }
                        }
                    }
                }
            }
        }

        /**
         * Add item as shortcut
         *
         * @param item
         */
        function addShortcut(item) {
            var deferred = $q.defer();

            // Update the hasShortcut status                        
            item.hasShortcut = true;

            var modelo = {
                codigoUsuario: codigoUsuarioLogado,
                id: item._id,
                path: item._path,
                atalho: item.hasShortcut,
                icone: item.icon,
                estado: item.state,
                titulo: item.title,
                uisref: item.uisref,
                peso: item.weight
            };
            // Requisição para api para inserir o Atalho solicitado
            $timeout(function () {
                $rootScope.loadingProgress = true;
                RequisicaoGenericaService.salvar(ApiAtalhos.atalhos.criar, modelo).then(
                    function (success) {
                        $rootScope.loadingProgress = false;
                        MdToastService.toastPadrao("Atalho cadastrado com sucesso!");
                        deferred.resolve(success.data);

                        // Save the shortcuts
                        vm.saveShortcuts(success.data, true);
                    },
                    function (error) {
                        $rootScope.loadingProgress = false;
                        item.hasShortcut = false;
                        MdToastService.toastPadrao(error.data, true);
                        deferred.reject(error.data);
                    });
            });

            return deferred.promise;
        }

        /**
         * Remove item from shortcuts
         *
         * @param item
         */
        function removeShortcut(item) {
            var deferred = $q.defer();

            // Update the hasShortcut status
            item.hasShortcut = false;

            // Requisição para Api para remover o Atalho
            $timeout(function () {
                $rootScope.loadingProgress = true;
                RequisicaoGenericaService.excluir(ApiAtalhos.atalhos.excluir, item.codigo + "/" + item.codigoUsuario).then(
                    function (success) {
                        $rootScope.loadingProgress = false;
                        MdToastService.toastPadrao(success.data);
                        deferred.resolve(success.data);

                        //Save the shortcuts
                        vm.saveShortcuts(item, false);
                    },
                    function (error) {
                        $rootScope.loadingProgress = false;
                        MdToastService.toastPadrao(error.data, true);
                        deferred.reject(error.data);
                    });
            });

            return deferred.promise;
        }

        /**
         * Handle the result click
         *
         * @param item
         */
        function handleResultClick(item) {
            // Add or remove the shortcut
            if (item.hasShortcut) {
                vm.removeShortcut(item);
            }
            else {
                vm.addShortcut(item);
            }
        }

        /**
         * Absorb the given event
         *
         * @param event
         */
        function absorbEvent(event) {
            event.preventDefault();
        }

        /**
         * Handle keydown
         *
         * @param event
         */
        function handleKeydown(event) {
            var keyCode = event.keyCode,
                keys = [38, 40];

            // Prevent the default action if
            // one of the keys are pressed that
            // we are listening
            if (keys.indexOf(keyCode) > -1) {
                event.preventDefault();
            }

            switch (keyCode) {
                // Enter
                case 13:

                    // Trigger result click
                    vm.handleResultClick(vm.results[vm.selectedResultIndex]);

                    break;

                // Up Arrow
                case 38:

                    // Decrease the selected result index
                    if (vm.selectedResultIndex - 1 >= 0) {
                        // Decrease the selected index
                        vm.selectedResultIndex--;

                        // Make sure the selected result is in the view
                        vm.ensureSelectedResultIsVisible();
                    }

                    break;

                // Down Arrow
                case 40:

                    // Increase the selected result index
                    if (vm.selectedResultIndex + 1 < vm.results.length) {
                        // Increase the selected index
                        vm.selectedResultIndex++;

                        // Make sure the selected result is in the view
                        vm.ensureSelectedResultIsVisible();
                    }

                    break;

                default:
                    break;
            }
        }

        /**
         * Handle mouseenter
         *
         * @param index
         */
        function handleMouseenter(index) {
            if (vm.ignoreMouseEvents) {
                return;
            }

            // Update the selected result index
            // with the given index
            vm.selectedResultIndex = index;
        }

        /**
         * Set a variable for a limited time
         * to make other functions to ignore
         * the mouse events
         */
        function temporarilyIgnoreMouseEvents() {
            // Set the variable
            vm.ignoreMouseEvents = true;

            // Cancel the previous timeout
            $timeout.cancel(vm.mouseEventIgnoreTimeout);

            // Set the timeout
            vm.mouseEventIgnoreTimeout = $timeout(function () {
                vm.ignoreMouseEvents = false;
            }, 250);
        }

        /**
         * Ensure the selected result will
         * always be visible on the results
         * area
         */
        function ensureSelectedResultIsVisible() {
            var resultsEl = $document.find('#ms-shortcut-add-menu').find('.results'),
                selectedItemEl = angular.element(resultsEl.find('.result')[vm.selectedResultIndex]);

            if (resultsEl && selectedItemEl) {
                var top = selectedItemEl.position().top - 8,
                    bottom = selectedItemEl.position().top + selectedItemEl.outerHeight() + 8;

                // Start ignoring mouse events
                vm.temporarilyIgnoreMouseEvents();

                if (resultsEl.scrollTop() > top) {
                    resultsEl.scrollTop(top);
                }

                if (bottom > (resultsEl.height() + resultsEl.scrollTop())) {
                    resultsEl.scrollTop(bottom - resultsEl.height());
                }
            }
        }

        /**
         * Toggle mobile bar
         */
        function toggleMobileBar() {
            vm.mobileBarActive = !vm.mobileBarActive;
        }
    }

    /** @ngInject */
    function msShortcutsDirective() {
        return {
            restrict: 'E',
            scope: {},
            require: 'msShortcuts',
            controller: 'MsShortcutsController as MsShortcuts',
            bindToController: {},
            templateUrl: 'app/core/directives/ms-shortcuts/ms-shortcuts.html',
            compile: function (tElement) {
                // Add class
                tElement.addClass('ms-shortcuts');

                return function postLink(scope, iElement) {
                    // Data

                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msSidenavHelper', msSidenavHelperDirective);

    /** @ngInject */
    function msSidenavHelperDirective()
    {
        return {
            restrict: 'A',
            require : '^mdSidenav',
            link    : function (scope, iElement, iAttrs, MdSidenavCtrl)
            {
                // Watch md-sidenav open & locked open statuses
                // and add class to the ".page-layout" if only
                // the sidenav open and NOT locked open
                scope.$watch(function ()
                {
                    return MdSidenavCtrl.isOpen() && !MdSidenavCtrl.isLockedOpen();
                }, function (current)
                {
                    if ( angular.isUndefined(current) )
                    {
                        return;
                    }

                    iElement.parent().toggleClass('full-height', current);
                    angular.element('html').toggleClass('sidenav-open', current);
                });
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsSearchBarController', MsSearchBarController)
        .directive('msSearchBar', msSearchBarDirective);

    /** @ngInject */
    function MsSearchBarController($scope, $element, $timeout)
    {
        var vm = this;

        // Data
        vm.collapsed = true;
        vm.query = '';
        vm.queryOptions = {
            debounce: vm.debounce || 0
        };
        vm.resultsLoading = false;
        vm.results = null;
        vm.selectedResultIndex = 0;
        vm.ignoreMouseEvents = false;

        // Methods
        vm.populateResults = populateResults;

        vm.expand = expand;
        vm.collapse = collapse;

        vm.absorbEvent = absorbEvent;
        vm.handleKeydown = handleKeydown;
        vm.handleMouseenter = handleMouseenter;
        vm.temporarilyIgnoreMouseEvents = temporarilyIgnoreMouseEvents;
        vm.handleResultClick = handleResultClick;
        vm.ensureSelectedResultIsVisible = ensureSelectedResultIsVisible;

        //////////

        init();

        function init()
        {
            // Watch the model changes to trigger the search
            $scope.$watch('MsSearchBar.query', function (current, old)
            {
                if ( angular.isUndefined(current) )
                {
                    return;
                }

                if ( angular.equals(current, old) )
                {
                    return;
                }

                if ( vm.collapsed )
                {
                    return;
                }

                // Evaluate the onSearch function to access the
                // function itself
                var onSearchEvaluated = $scope.$parent.$eval(vm.onSearch, {query: current}),
                    isArray = angular.isArray(onSearchEvaluated),
                    isPromise = (onSearchEvaluated && !!onSearchEvaluated.then);

                if ( isArray )
                {
                    // Populate the results
                    vm.populateResults(onSearchEvaluated);
                }

                if ( isPromise )
                {
                    // Show the loader
                    vm.resultsLoading = true;

                    onSearchEvaluated.then(
                        // Success
                        function (response)
                        {
                            // Populate the results
                            vm.populateResults(response);
                        },
                        // Error
                        function ()
                        {
                            // Assign an empty array to show
                            // the no-results screen
                            vm.populateResults([]);
                        }
                    ).finally(function ()
                        {
                            // Hide the loader
                            vm.resultsLoading = false;
                        }
                    );
                }
            });
        }

        /**
         * Populate the results
         *
         * @param results
         */
        function populateResults(results)
        {
            // Before doing anything,
            // make sure the search bar is expanded
            if ( vm.collapsed )
            {
                return;
            }

            var isArray = angular.isArray(results),
                isNull = results === null;

            // Only accept arrays and null values
            if ( !isArray && !isNull )
            {
                return;
            }

            // Reset the selected result
            vm.selectedResultIndex = 0;

            // Populate the results
            vm.results = results;
        }

        /**
         * Expand
         */
        function expand()
        {
            // Set collapsed status
            vm.collapsed = false;

            // Call expand on scope
            $scope.expand();

            // Callback
            if ( vm.onExpand && angular.isFunction(vm.onExpand) )
            {
                vm.onExpand();
            }
        }

        /**
         * Collapse
         */
        function collapse()
        {
            // Empty the query
            vm.query = '';

            // Empty results to hide the results view
            vm.populateResults(null);

            // Set collapsed status
            vm.collapsed = true;

            // Call collapse on scope
            $scope.collapse();

            // Callback
            if ( vm.onCollapse && angular.isFunction(vm.onCollapse) )
            {
                vm.onCollapse();
            }
        }

        /**
         * Absorb the given event
         *
         * @param event
         */
        function absorbEvent(event)
        {
            event.preventDefault();
        }

        /**
         * Handle keydown
         *
         * @param event
         */
        function handleKeydown(event)
        {
            var keyCode = event.keyCode,
                keys = [27, 38, 40];

            // Prevent the default action if
            // one of the keys are pressed that
            // we are listening
            if ( keys.indexOf(keyCode) > -1 )
            {
                event.preventDefault();
            }

            switch ( keyCode )
            {
                // Enter
                case 13:

                    // Trigger result click
                    vm.handleResultClick(vm.results[vm.selectedResultIndex]);

                    break;

                // Escape
                case 27:

                    // Collapse the search bar
                    vm.collapse();

                    break;

                // Up Arrow
                case 38:

                    // Decrease the selected result index
                    if ( vm.selectedResultIndex - 1 >= 0 )
                    {
                        // Decrease the selected index
                        vm.selectedResultIndex--;

                        // Make sure the selected result is in the view
                        vm.ensureSelectedResultIsVisible();
                    }

                    break;

                // Down Arrow
                case 40:

                    if ( !vm.results )
                    {
                        return;
                    }

                    // Increase the selected result index
                    if ( vm.selectedResultIndex + 1 < vm.results.length )
                    {
                        // Increase the selected index
                        vm.selectedResultIndex++;

                        // Make sure the selected result is in the view
                        vm.ensureSelectedResultIsVisible();
                    }

                    break;

                default:
                    break;
            }
        }

        /**
         * Handle mouseenter
         *
         * @param index
         */
        function handleMouseenter(index)
        {
            if ( vm.ignoreMouseEvents )
            {
                return;
            }

            // Update the selected result index
            // with the given index
            vm.selectedResultIndex = index;
        }

        /**
         * Set a variable for a limited time
         * to make other functions to ignore
         * the mouse events
         */
        function temporarilyIgnoreMouseEvents()
        {
            // Set the variable
            vm.ignoreMouseEvents = true;

            // Cancel the previous timeout
            $timeout.cancel(vm.mouseEventIgnoreTimeout);

            // Set the timeout
            vm.mouseEventIgnoreTimeout = $timeout(function ()
            {
                vm.ignoreMouseEvents = false;
            }, 250);
        }

        /**
         * Handle the result click
         *
         * @param item
         */
        function handleResultClick(item)
        {
            if ( vm.onResultClick )
            {
                vm.onResultClick({item: item});
            }

            // Collapse the search bar
            vm.collapse();
        }

        /**
         * Ensure the selected result will
         * always be visible on the results
         * area
         */
        function ensureSelectedResultIsVisible()
        {
            var resultsEl = $element.find('.ms-search-bar-results'),
                selectedItemEl = angular.element(resultsEl.find('.result')[vm.selectedResultIndex]);

            if ( resultsEl && selectedItemEl )
            {
                var top = selectedItemEl.position().top - 8,
                    bottom = selectedItemEl.position().top + selectedItemEl.outerHeight() + 8;

                // Start ignoring mouse events
                vm.temporarilyIgnoreMouseEvents();

                if ( resultsEl.scrollTop() > top )
                {
                    resultsEl.scrollTop(top);
                }

                if ( bottom > (resultsEl.height() + resultsEl.scrollTop()) )
                {
                    resultsEl.scrollTop(bottom - resultsEl.height());
                }
            }
        }
    }

    /** @ngInject */
    function msSearchBarDirective($document)
    {
        return {
            restrict        : 'E',
            scope           : {},
            require         : 'msSearchBar',
            controller      : 'MsSearchBarController as MsSearchBar',
            bindToController: {
                debounce     : '=?',
                onSearch     : '@',
                onResultClick: '&?',
                onExpand     : '&?',
                onCollapse   : '&?'
            },
            templateUrl     : 'app/core/directives/ms-search-bar/ms-search-bar.html',
            compile         : function (tElement)
            {
                // Add class
                tElement.addClass('ms-search-bar');

                return function postLink(scope, iElement)
                {
                    // Data
                    var inputEl,
                        bodyEl = $document.find('body');

                    // Methods
                    scope.collapse = collapse;
                    scope.expand = expand;

                    //////////

                    // Initialize
                    init();

                    /**
                     * Initialize
                     */
                    function init()
                    {
                        // Grab the input element
                        inputEl = iElement.find('#ms-search-bar-input');
                    }

                    /**
                     * Expand action
                     */
                    function expand()
                    {
                        // Add expanded class
                        iElement.addClass('expanded');

                        // Add helper class to the body
                        bodyEl.addClass('ms-search-bar-expanded');

                        // Focus on the input
                        inputEl.focus();
                    }

                    /**
                     * Collapse action
                     */
                    function collapse()
                    {
                        // Remove expanded class
                        iElement.removeClass('expanded');

                        // Remove helper class from the body
                        bodyEl.removeClass('ms-search-bar-expanded');
                    }
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('msMaterialColorPickerController', msMaterialColorPickerController)
        .directive('msMaterialColorPicker', msMaterialColorPicker);

    /** @ngInject */
    function msMaterialColorPickerController($scope, $mdColorPalette, $mdMenu, fuseGenerator)
    {
        var vm = this;
        vm.palettes = $mdColorPalette; // Material Color Palette
        vm.selectedPalette = false;
        vm.selectedHues = false;
        $scope.$selectedColor = {};

        // Methods
        vm.activateHueSelection = activateHueSelection;
        vm.selectColor = selectColor;
        vm.removeColor = removeColor;

        /**
         * Initialize / Watch model changes
         */
        $scope.$watch('ngModel', setSelectedColor);

        /**
         * Activate Hue Selection
         * @param palette
         * @param hues
         */
        function activateHueSelection(palette, hues)
        {
            vm.selectedPalette = palette;
            vm.selectedHues = hues;
        }

        /**
         * Select Color
         * @type {selectColor}
         */
        function selectColor(palette, hue)
        {
            // Update Selected Color
            updateSelectedColor(palette, hue);

            // Update Model Value
            updateModel();

            // Hide The picker
            $mdMenu.hide();
        }

        function removeColor()
        {
            vm.selectedColor = {
                palette: '',
                hue    : '',
                class  : ''
            };

            activateHueSelection(false, false);

            updateModel();
        }

        /**
         * Set SelectedColor by model type
         */
        function setSelectedColor()
        {
            if ( !vm.modelCtrl.$viewValue || vm.modelCtrl.$viewValue === '' )
            {
                removeColor();
                return;
            }

            var palette, hue;

            // If ModelType Class
            if ( vm.msModelType === 'class' )
            {
                var color = vm.modelCtrl.$viewValue.split('-');
                if ( color.length >= 5 )
                {
                    palette = color[1] + '-' + color[2];
                    hue = color[3];
                }
                else
                {
                    palette = color[1];
                    hue = color[2];
                }
            }

            // If ModelType Object
            else if ( vm.msModelType === 'obj' )
            {
                palette = vm.modelCtrl.$viewValue.palette;
                hue = vm.modelCtrl.$viewValue.hue || 500;
            }

            // Update Selected Color
            updateSelectedColor(palette, hue);
        }

        /**
         * Update Selected Color
         * @param palette
         * @param hue
         */
        function updateSelectedColor(palette, hue)
        {
            vm.selectedColor = {
                palette     : palette,
                hue         : hue,
                class       : 'md-' + palette + '-' + hue + '-bg',
                bgColorValue: fuseGenerator.rgba(vm.palettes[palette][hue].value),
                fgColorValue: fuseGenerator.rgba(vm.palettes[palette][hue].contrast)
            };

            // If Model object not Equals the selectedColor update it
            // it can be happen when the model only have pallete and hue values
            if ( vm.msModelType === 'obj' && !angular.equals(vm.selectedColor, vm.modelCtrl.$viewValue) )
            {
                // Update Model Value
                updateModel();
            }

            activateHueSelection(palette, vm.palettes[palette]);

            $scope.$selectedColor = vm.selectedColor;
        }

        /**
         * Update Model Value by model type
         */
        function updateModel()
        {
            if ( vm.msModelType === 'class' )
            {
                vm.modelCtrl.$setViewValue(vm.selectedColor.class);
            }
            else if ( vm.msModelType === 'obj' )
            {
                vm.modelCtrl.$setViewValue(vm.selectedColor);
            }
        }
    }

    /** @ngInject */
    function msMaterialColorPicker()
    {
        return {
            require    : ['msMaterialColorPicker', 'ngModel'],
            restrict   : 'E',
            scope      : {
                ngModel    : '=',
                msModelType: '@?'
            },
            controller : 'msMaterialColorPickerController as vm',
            transclude : true,
            templateUrl: 'app/core/directives/ms-material-color-picker/ms-material-color-picker.html',
            link       : function (scope, element, attrs, controllers, transclude)
            {
                var ctrl = controllers[0];

                /**
                 *  Pass model controller to directive controller
                 */
                ctrl.modelCtrl = controllers[1];

                /**
                 * ModelType: 'obj', 'class'(default)
                 * @type {string|string}
                 */
                ctrl.msModelType = scope.msModelType || 'class';

                transclude(scope, function (clone)
                {
                    clone = clone.filter(function (i, el)
                    {
                        return ( el.nodeType === 1 ) ? true : false;
                    });

                    if ( clone.length )
                    {
                        element.find('ms-color-picker-button').replaceWith(clone);
                    }
                });
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('msScrollConfig', msScrollConfigProvider)
        .directive('msScroll', msScrollDirective);

    /** @ngInject */
    function msScrollConfigProvider()
    {
        // Default configuration
        var defaultConfiguration = {
            wheelSpeed            : 1,
            wheelPropagation      : false,
            swipePropagation      : true,
            minScrollbarLength    : null,
            maxScrollbarLength    : null,
            useBothWheelAxes      : false,
            useKeyboard           : true,
            suppressScrollX       : false,
            suppressScrollY       : false,
            scrollXMarginOffset   : 0,
            scrollYMarginOffset   : 0,
            stopPropagationOnClick: true
        };

        // Methods
        this.config = config;

        //////////

        /**
         * Extend default configuration with the given one
         *
         * @param configuration
         */
        function config(configuration)
        {
            defaultConfiguration = angular.extend({}, defaultConfiguration, configuration);
        }

        /**
         * Service
         */
        this.$get = function ()
        {
            var service = {
                getConfig: getConfig
            };

            return service;

            //////////

            /**
             * Return the config
             */
            function getConfig()
            {
                return defaultConfiguration;
            }
        };
    }

    /** @ngInject */
    function msScrollDirective($timeout, msScrollConfig, msUtils, fuseConfig)
    {
        return {
            restrict: 'AE',
            compile : function (tElement)
            {
                // Do not replace scrollbars if
                // 'disableCustomScrollbars' config enabled
                if ( fuseConfig.getConfig('disableCustomScrollbars') )
                {
                    return;
                }

                // Do not replace scrollbars on mobile devices
                // if 'disableCustomScrollbarsOnMobile' config enabled
                if ( fuseConfig.getConfig('disableCustomScrollbarsOnMobile') && msUtils.isMobile() )
                {
                    return;
                }

                // Add class
                tElement.addClass('ms-scroll');

                return function postLink(scope, iElement, iAttrs)
                {
                    var options = {};

                    // If options supplied, evaluate the given
                    // value. This is because we don't want to
                    // have an isolated scope but still be able
                    // to use scope variables.
                    // We don't want an isolated scope because
                    // we should be able to use this everywhere
                    // especially with other directives
                    if ( iAttrs.msScroll )
                    {
                        options = scope.$eval(iAttrs.msScroll);
                    }

                    // Extend the given config with the ones from provider
                    options = angular.extend({}, msScrollConfig.getConfig(), options);

                    // Initialize the scrollbar
                    $timeout(function ()
                    {
                        PerfectScrollbar.initialize(iElement[0], options);
                    }, 0);

                    // Update the scrollbar on element mouseenter
                    iElement.on('mouseenter', updateScrollbar);

                    // Watch scrollHeight and update
                    // the scrollbar if it changes
                    scope.$watch(function ()
                    {
                        return iElement.prop('scrollHeight');
                    }, function (current, old)
                    {
                        if ( angular.isUndefined(current) || angular.equals(current, old) )
                        {
                            return;
                        }

                        updateScrollbar();
                    });

                    // Watch scrollWidth and update
                    // the scrollbar if it changes
                    scope.$watch(function ()
                    {
                        return iElement.prop('scrollWidth');
                    }, function (current, old)
                    {
                        if ( angular.isUndefined(current) || angular.equals(current, old) )
                        {
                            return;
                        }

                        updateScrollbar();
                    });

                    /**
                     * Update the scrollbar
                     */
                    function updateScrollbar()
                    {
                        PerfectScrollbar.update(iElement[0]);
                    }

                    // Cleanup on destroy
                    scope.$on('$destroy', function ()
                    {
                        iElement.off('mouseenter');
                        PerfectScrollbar.destroy(iElement[0]);
                    });
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msResponsiveTable', msResponsiveTableDirective);

    /** @ngInject */
    function msResponsiveTableDirective()
    {
        return {
            restrict: 'A',
            link    : function (scope, iElement)
            {
                // Wrap the table
                var wrapper = angular.element('<div class="ms-responsive-table-wrapper"></div>');
                iElement.after(wrapper);
                wrapper.append(iElement);

                //////////
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('msNavigationService', msNavigationServiceProvider)
        .controller('MsNavigationController', MsNavigationController)
        // Vertical
        .directive('msNavigation', msNavigationDirective)
        .controller('MsNavigationNodeController', MsNavigationNodeController)
        .directive('msNavigationNode', msNavigationNodeDirective)
        .directive('msNavigationItem', msNavigationItemDirective)
        //Horizontal
        .directive('msNavigationHorizontal', msNavigationHorizontalDirective)
        .controller('MsNavigationHorizontalNodeController', MsNavigationHorizontalNodeController)
        .directive('msNavigationHorizontalNode', msNavigationHorizontalNodeDirective)
        .directive('msNavigationHorizontalItem', msNavigationHorizontalItemDirective);

    /** @ngInject */
    function msNavigationServiceProvider()
    {
        // Inject $log service
        var $log = angular.injector(['ng']).get('$log');

        // Navigation array
        var navigation = [];

        var service = this;

        // Methods
        service.saveItem = saveItem;
        service.deleteItem = deleteItem;
        service.sortByWeight = sortByWeight;

        //////////

        /**
         * Create or update the navigation item
         *
         * @param path
         * @param item
         */
        function saveItem(path, item)
        {
            if ( !angular.isString(path) )
            {
                $log.error('path must be a string (eg. `dashboard.project`)');
                return;
            }

            var parts = path.split('.');

            // Generate the object id from the parts
            var id = parts[parts.length - 1];

            // Get the parent item from the parts
            var parent = _findOrCreateParent(parts);

            // Decide if we are going to update or create
            var updateItem = false;

            for ( var i = 0; i < parent.length; i++ )
            {
                if ( parent[i]._id === id )
                {
                    updateItem = parent[i];

                    break;
                }
            }

            // Update
            if ( updateItem )
            {
                angular.extend(updateItem, item);

                // Add proper ui-sref
                updateItem.uisref = _getUiSref(updateItem);
            }
            // Create
            else
            {
                // Create an empty children array in the item
                item.children = [];

                // Add the default weight if not provided or if it's not a number
                if ( angular.isUndefined(item.weight) || !angular.isNumber(item.weight) )
                {
                    item.weight = 1;
                }

                // Add the item id
                item._id = id;

                // Add the item path
                item._path = path;

                // Add proper ui-sref
                item.uisref = _getUiSref(item);

                // Push the item into the array
                parent.push(item);
            }
        }

        /**
         * Delete navigation item
         *
         * @param path
         */
        function deleteItem(path)
        {
            if ( !angular.isString(path) )
            {
                $log.error('path must be a string (eg. `dashboard.project`)');
                return;
            }

            // Locate the item by using given path
            var item = navigation,
                parts = path.split('.');

            for ( var p = 0; p < parts.length; p++ )
            {
                var id = parts[p];

                for ( var i = 0; i < item.length; i++ )
                {
                    if ( item[i]._id === id )
                    {
                        // If we have a matching path,
                        // we have found our object:
                        // remove it.
                        if ( item[i]._path === path )
                        {
                            item.splice(i, 1);
                            return true;
                        }

                        // Otherwise grab the children of
                        // the current item and continue
                        item = item[i].children;
                        break;
                    }
                }
            }

            return false;
        }

        /**
         * Sort the navigation items by their weights
         *
         * @param parent
         */
        function sortByWeight(parent)
        {
            // If parent not provided, sort the root items
            if ( !parent )
            {
                parent = navigation;
                parent.sort(_byWeight);
            }

            // Sort the children
            for ( var i = 0; i < parent.length; i++ )
            {
                var children = parent[i].children;

                if ( children.length > 1 )
                {
                    children.sort(_byWeight);
                }

                if ( children.length > 0 )
                {
                    sortByWeight(children);
                }
            }
        }

        /* ----------------- */
        /* Private Functions */
        /* ----------------- */

        /**
         * Find or create parent
         *
         * @param parts
         * @returns {Array|Boolean}
         * @private
         */
        function _findOrCreateParent(parts)
        {
            // Store the main navigation
            var parent = navigation;

            // If it's going to be a root item
            // return the navigation itself
            if ( parts.length === 1 )
            {
                return parent;
            }

            // Remove the last element from the parts as
            // we don't need that to figure out the parent
            parts.pop();

            // Find and return the parent
            for ( var i = 0; i < parts.length; i++ )
            {
                var _id = parts[i],
                    createParent = true;

                for ( var p = 0; p < parent.length; p++ )
                {
                    if ( parent[p]._id === _id )
                    {
                        parent = parent[p].children;
                        createParent = false;

                        break;
                    }
                }

                // If there is no parent found, create one, push
                // it into the current parent and assign it as a
                // new parent
                if ( createParent )
                {
                    var item = {
                        _id     : _id,
                        _path   : parts.join('.'),
                        title   : _id,
                        weight  : 1,
                        children: []
                    };

                    parent.push(item);
                    parent = item.children;
                }
            }

            return parent;
        }

        /**
         * Sort by weight
         *
         * @param x
         * @param y
         * @returns {number}
         * @private
         */
        function _byWeight(x, y)
        {
            return parseInt(x.weight) - parseInt(y.weight);
        }

        /**
         * Setup the ui-sref using state & state parameters
         *
         * @param item
         * @returns {string}
         * @private
         */
        function _getUiSref(item)
        {
            var uisref = '';

            if ( angular.isDefined(item.state) )
            {
                uisref = item.state;

                if ( angular.isDefined(item.stateParams) && angular.isObject(item.stateParams) )
                {
                    uisref = uisref + '(' + angular.toJson(item.stateParams) + ')';
                }
            }

            return uisref;
        }

        /* ----------------- */
        /* Service           */
        /* ----------------- */

        this.$get = function ()
        {
            var activeItem = null,
                navigationScope = null,
                folded = null,
                foldedOpen = null;

            var service = {
                saveItem          : saveItem,
                deleteItem        : deleteItem,
                sort              : sortByWeight,
                clearNavigation   : clearNavigation,
                setActiveItem     : setActiveItem,
                getActiveItem     : getActiveItem,
                getNavigation     : getNavigation,
                getFlatNavigation : getFlatNavigation,
                setNavigationScope: setNavigationScope,
                setFolded         : setFolded,
                getFolded         : getFolded,
                setFoldedOpen     : setFoldedOpen,
                getFoldedOpen     : getFoldedOpen,
                toggleFolded      : toggleFolded
            };

            return service;

            //////////

            /**
             * Clear the entire navigation
             */
            function clearNavigation()
            {
                // Clear the navigation array
                navigation = [];

                // Clear the vm.navigation from main controller
                if ( navigationScope )
                {
                    navigationScope.vm.navigation = navigation;
                }
            }

            /**
             * Set active item
             *
             * @param node
             * @param scope
             */
            function setActiveItem(node, scope)
            {
                activeItem = {
                    node : node,
                    scope: scope
                };
            }

            /**
             * Return active item
             */
            function getActiveItem()
            {
                return activeItem;
            }

            /**
             * Return navigation array
             *
             * @param root
             * @returns Array
             */
            function getNavigation(root)
            {
                if ( root )
                {
                    for ( var i = 0; i < navigation.length; i++ )
                    {
                        if ( navigation[i]._id === root )
                        {
                            return [navigation[i]];
                        }
                    }

                    return null;
                }

                return navigation;
            }

            /**
             * Return flat navigation array
             *
             * @param root
             * @returns Array
             */
            function getFlatNavigation(root)
            {
                // Get the correct navigation array
                var navigation = getNavigation(root);

                // Flatten the navigation object
                return _flattenNavigation(navigation);
            }

            /**
             * Store navigation's scope for later use
             *
             * @param scope
             */
            function setNavigationScope(scope)
            {
                navigationScope = scope;
            }

            /**
             * Set folded status
             *
             * @param status
             */
            function setFolded(status)
            {
                folded = status;
            }

            /**
             * Return folded status
             *
             * @returns {*}
             */
            function getFolded()
            {
                return folded;
            }

            /**
             * Set folded open status
             *
             * @param status
             */
            function setFoldedOpen(status)
            {
                foldedOpen = status;
            }

            /**
             * Return folded open status
             *
             * @returns {*}
             */
            function getFoldedOpen()
            {
                return foldedOpen;
            }


            /**
             * Toggle fold on stored navigation's scope
             */
            function toggleFolded()
            {
                navigationScope.toggleFolded();
            }

            /**
             * Flatten the given navigation
             *
             * @param navigation
             * @private
             */
            function _flattenNavigation(navigation)
            {
                var flatNav = [];

                for ( var x = 0; x < navigation.length; x++ )
                {
                    // Copy and clear the children of the
                    // navigation that we want to push
                    var navToPush = angular.copy(navigation[x]);
                    navToPush.children = [];

                    // Push the item
                    flatNav.push(navToPush);

                    // If there are child items in this navigation,
                    // do some nested function magic
                    if ( navigation[x].children.length > 0 )
                    {
                        flatNav = flatNav.concat(_flattenNavigation(navigation[x].children));
                    }
                }

                return flatNav;
            }
        };
    }

    /** @ngInject */
    function MsNavigationController($scope, msNavigationService)
    {
        var vm = this;

        // Data
        if ( $scope.root )
        {
            vm.navigation = msNavigationService.getNavigation($scope.root);
        }
        else
        {
            vm.navigation = msNavigationService.getNavigation();
        }

        // Methods
        vm.toggleHorizontalMobileMenu = toggleHorizontalMobileMenu;

        //////////

        init();

        /**
         * Initialize
         */
        function init()
        {
            // Sort the navigation before doing anything else
            msNavigationService.sort();
        }

        /**
         * Toggle horizontal mobile menu
         */
        function toggleHorizontalMobileMenu()
        {
            angular.element('body').toggleClass('ms-navigation-horizontal-mobile-menu-active');
        }
    }

    /** @ngInject */
    function msNavigationDirective($rootScope, $timeout, $mdSidenav, msNavigationService)
    {
        return {
            restrict   : 'E',
            scope      : {
                folded: '=',
                root  : '@'
            },
            controller : 'MsNavigationController as vm',
            templateUrl: 'app/core/directives/ms-navigation/templates/vertical.html',
            transclude : true,
            compile    : function (tElement)
            {
                tElement.addClass('ms-navigation');

                return function postLink(scope, iElement)
                {
                    var bodyEl = angular.element('body'),
                        foldExpanderEl = angular.element('<div id="ms-navigation-fold-expander"></div>'),
                        foldCollapserEl = angular.element('<div id="ms-navigation-fold-collapser"></div>'),
                        sidenav = $mdSidenav('navigation');

                    // Store the navigation in the service for public access
                    msNavigationService.setNavigationScope(scope);

                    // Initialize
                    init();

                    /**
                     * Initialize
                     */
                    function init()
                    {
                        // Set the folded status for the first time.
                        // First, we have to check if we have a folded
                        // status available in the service already. This
                        // will prevent navigation to act weird if we already
                        // set the fold status, remove the navigation and
                        // then re-initialize it, which happens if we
                        // change to a view without a navigation and then
                        // come back with history.back() function.

                        // If the service didn't initialize before, set
                        // the folded status from scope, otherwise we
                        // won't touch anything because the folded status
                        // already set in the service...
                        if ( msNavigationService.getFolded() === null )
                        {
                            msNavigationService.setFolded(scope.folded);
                        }

                        if ( msNavigationService.getFolded() )
                        {
                            // Collapse everything.
                            // This must be inside a $timeout because by the
                            // time we call this, the 'msNavigation::collapse'
                            // event listener is not registered yet. $timeout
                            // will ensure that it will be called after it is
                            // registered.
                            $timeout(function ()
                            {
                                $rootScope.$broadcast('msNavigation::collapse');
                            });

                            // Add class to the body
                            bodyEl.addClass('ms-navigation-folded');

                            // Set fold expander
                            setFoldExpander();
                        }
                    }

                    // Sidenav locked open status watcher
                    scope.$watch(function ()
                    {
                        return sidenav.isLockedOpen();
                    }, function (current, old)
                    {
                        if ( angular.isUndefined(current) || angular.equals(current, old) )
                        {
                            return;
                        }

                        var folded = msNavigationService.getFolded();

                        if ( folded )
                        {
                            if ( current )
                            {
                                // Collapse everything
                                $rootScope.$broadcast('msNavigation::collapse');
                            }
                            else
                            {
                                // Expand the active one and its parents
                                var activeItem = msNavigationService.getActiveItem();
                                if ( activeItem )
                                {
                                    activeItem.scope.$emit('msNavigation::stateMatched');
                                }
                            }
                        }
                    });

                    // Folded status watcher
                    scope.$watch('folded', function (current, old)
                    {
                        if ( angular.isUndefined(current) || angular.equals(current, old) )
                        {
                            return;
                        }

                        setFolded(current);
                    });

                    /**
                     * Set folded status
                     *
                     * @param folded
                     */
                    function setFolded(folded)
                    {
                        // Store folded status on the service for global access
                        msNavigationService.setFolded(folded);

                        if ( folded )
                        {
                            // Collapse everything
                            $rootScope.$broadcast('msNavigation::collapse');

                            // Add class to the body
                            bodyEl.addClass('ms-navigation-folded');

                            // Set fold expander
                            setFoldExpander();
                        }
                        else
                        {
                            // Expand the active one and its parents
                            var activeItem = msNavigationService.getActiveItem();
                            if ( activeItem )
                            {
                                activeItem.scope.$emit('msNavigation::stateMatched');
                            }

                            // Remove body class
                            bodyEl.removeClass('ms-navigation-folded ms-navigation-folded-open');

                            // Remove fold collapser
                            removeFoldCollapser();
                        }
                    }

                    /**
                     * Set fold expander
                     */
                    function setFoldExpander()
                    {
                        iElement.parent().append(foldExpanderEl);

                        // Let everything settle for a moment
                        // before registering the event listener
                        $timeout(function ()
                        {
                            foldExpanderEl.on('mouseenter touchstart', onFoldExpanderHover);
                        });
                    }

                    /**
                     * Set fold collapser
                     */
                    function setFoldCollapser()
                    {
                        bodyEl.find('#main').append(foldCollapserEl);
                        foldCollapserEl.on('mouseenter touchstart', onFoldCollapserHover);
                    }

                    /**
                     * Remove fold collapser
                     */
                    function removeFoldCollapser()
                    {
                        foldCollapserEl.remove();
                    }

                    /**
                     * onHover event of foldExpander
                     */
                    function onFoldExpanderHover(event)
                    {
                        if ( event )
                        {
                            event.preventDefault();
                        }

                        // Set folded open status
                        msNavigationService.setFoldedOpen(true);

                        // Expand the active one and its parents
                        var activeItem = msNavigationService.getActiveItem();
                        if ( activeItem )
                        {
                            activeItem.scope.$emit('msNavigation::stateMatched');
                        }

                        // Add class to the body
                        bodyEl.addClass('ms-navigation-folded-open');

                        // Remove the fold opener
                        foldExpanderEl.remove();

                        // Set fold collapser
                        setFoldCollapser();
                    }

                    /**
                     * onHover event of foldCollapser
                     */
                    function onFoldCollapserHover(event)
                    {
                        if ( event )
                        {
                            event.preventDefault();
                        }

                        // Set folded open status
                        msNavigationService.setFoldedOpen(false);

                        // Collapse everything
                        $rootScope.$broadcast('msNavigation::collapse');

                        // Remove body class
                        bodyEl.removeClass('ms-navigation-folded-open');

                        // Remove the fold collapser
                        foldCollapserEl.remove();

                        // Set fold expander
                        setFoldExpander();
                    }

                    /**
                     * Public access for toggling folded status externally
                     */
                    scope.toggleFolded = function ()
                    {
                        var folded = msNavigationService.getFolded();

                        setFolded(!folded);
                    };

                    /**
                     * On $stateChangeStart
                     */
                    scope.$on('$stateChangeStart', function ()
                    {
                        // Close the sidenav
                        sidenav.close();
                    });

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        foldCollapserEl.off('mouseenter touchstart');
                        foldExpanderEl.off('mouseenter touchstart');
                    });
                };
            }
        };
    }

    /** @ngInject */
    function MsNavigationNodeController($scope, $element, $rootScope, $animate, $state, msNavigationService)
    {
        var vm = this;

        // Data
        vm.element = $element;
        vm.node = $scope.node;
        vm.hasChildren = undefined;
        vm.collapsed = undefined;
        vm.collapsable = undefined;
        vm.group = undefined;
        vm.animateHeightClass = 'animate-height';

        // Methods
        vm.toggleCollapsed = toggleCollapsed;
        vm.collapse = collapse;
        vm.expand = expand;
        vm.getClass = getClass;
        vm.isHidden = isHidden;

        //////////

        init();

        /**
         * Initialize
         */
        function init()
        {
            // Setup the initial values

            // Has children?
            vm.hasChildren = vm.node.children.length > 0;

            // Is group?
            vm.group = !!(angular.isDefined(vm.node.group) && vm.node.group === true);

            // Is collapsable?
            if ( !vm.hasChildren || vm.group )
            {
                vm.collapsable = false;
            }
            else
            {
                vm.collapsable = !!(angular.isUndefined(vm.node.collapsable) || typeof vm.node.collapsable !== 'boolean' || vm.node.collapsable === true);
            }

            // Is collapsed?
            if ( !vm.collapsable )
            {
                vm.collapsed = false;
            }
            else
            {
                vm.collapsed = !!(angular.isUndefined(vm.node.collapsed) || typeof vm.node.collapsed !== 'boolean' || vm.node.collapsed === true);
            }

            // Expand all parents if we have a matching state or
            // the current state is a child of the node's state
            if ( vm.node.state === $state.current.name || $state.includes(vm.node.state) )
            {
                // If state params are defined, make sure they are
                // equal, otherwise do not set the active item
                if ( angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params) )
                {
                    return;
                }

                $scope.$emit('msNavigation::stateMatched');

                // Also store the current active menu item
                msNavigationService.setActiveItem(vm.node, $scope);
            }

            $scope.$on('msNavigation::stateMatched', function ()
            {
                // Expand if the current scope is collapsable and is collapsed
                if ( vm.collapsable && vm.collapsed )
                {
                    $scope.$evalAsync(function ()
                    {
                        vm.collapsed = false;
                    });
                }
            });

            // Listen for collapse event
            $scope.$on('msNavigation::collapse', function (event, path)
            {
                if ( vm.collapsed || !vm.collapsable )
                {
                    return;
                }

                // If there is no path defined, collapse
                if ( angular.isUndefined(path) )
                {
                    vm.collapse();
                }
                // If there is a path defined, do not collapse
                // the items that are inside that path. This will
                // prevent parent items from collapsing
                else
                {
                    var givenPathParts = path.split('.'),
                        activePathParts = [];

                    var activeItem = msNavigationService.getActiveItem();
                    if ( activeItem )
                    {
                        activePathParts = activeItem.node._path.split('.');
                    }

                    // Test for given path
                    if ( givenPathParts.indexOf(vm.node._id) > -1 )
                    {
                        return;
                    }

                    // Test for active path
                    if ( activePathParts.indexOf(vm.node._id) > -1 )
                    {
                        return;
                    }

                    vm.collapse();
                }
            });

            // Listen for $stateChangeSuccess event
            $scope.$on('$stateChangeSuccess', function ()
            {
                if ( vm.node.state === $state.current.name )
                {
                    // If state params are defined, make sure they are
                    // equal, otherwise do not set the active item
                    if ( angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params) )
                    {
                        return;
                    }

                    // Update active item on state change
                    msNavigationService.setActiveItem(vm.node, $scope);

                    // Collapse everything except the one we're using
                    $rootScope.$broadcast('msNavigation::collapse', vm.node._path);
                }

                // Expand the parents if we the current
                // state is a child of the node's state
                if ( $state.includes(vm.node.state) )
                {
                    // If state params are defined, make sure they are
                    // equal, otherwise do not set the active item
                    if ( angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params) )
                    {
                        return;
                    }

                    // Emit the stateMatched
                    $scope.$emit('msNavigation::stateMatched');
                }
            });
        }

        /**
         * Toggle collapsed
         */
        function toggleCollapsed()
        {
            if ( vm.collapsed )
            {
                vm.expand();
            }
            else
            {
                vm.collapse();
            }
        }

        /**
         * Collapse
         */
        function collapse()
        {
            // Grab the element that we are going to collapse
            var collapseEl = vm.element.children('ul');

            // Grab the height
            var height = collapseEl[0].offsetHeight;

            $scope.$evalAsync(function ()
            {
                // Set collapsed status
                vm.collapsed = true;

                // Add collapsing class to the node
                vm.element.addClass('collapsing');

                // Animate the height
                $animate.animate(collapseEl,
                    {
                        'display': 'block',
                        'height' : height + 'px'
                    },
                    {
                        'height': '0px'
                    },
                    vm.animateHeightClass
                ).then(
                    function ()
                    {
                        // Clear the inline styles after animation done
                        collapseEl.css({
                            'display': '',
                            'height' : ''
                        });

                        // Clear collapsing class from the node
                        vm.element.removeClass('collapsing');
                    }
                );

                // Broadcast the collapse event so child items can also be collapsed
                $scope.$broadcast('msNavigation::collapse');
            });
        }

        /**
         * Expand
         */
        function expand()
        {
            // Grab the element that we are going to expand
            var expandEl = vm.element.children('ul');

            // Move the element out of the dom flow and
            // make it block so we can get its height
            expandEl.css({
                'position'  : 'absolute',
                'visibility': 'hidden',
                'display'   : 'block',
                'height'    : 'auto'
            });

            // Grab the height
            var height = expandEl[0].offsetHeight;

            // Reset the style modifications
            expandEl.css({
                'position'  : '',
                'visibility': '',
                'display'   : '',
                'height'    : ''
            });

            $scope.$evalAsync(function ()
            {
                // Set collapsed status
                vm.collapsed = false;

                // Add expanding class to the node
                vm.element.addClass('expanding');

                // Animate the height
                $animate.animate(expandEl,
                    {
                        'display': 'block',
                        'height' : '0px'
                    },
                    {
                        'height': height + 'px'
                    },
                    vm.animateHeightClass
                ).then(
                    function ()
                    {
                        // Clear the inline styles after animation done
                        expandEl.css({
                            'height': ''
                        });

                        // Clear expanding class from the node
                        vm.element.removeClass('expanding');
                    }
                );

                // If item expanded, broadcast the collapse event from rootScope so that the other expanded items
                // can be collapsed. This is necessary for keeping only one parent expanded at any time
                $rootScope.$broadcast('msNavigation::collapse', vm.node._path);
            });
        }

        /**
         * Return the class
         *
         * @returns {*}
         */
        function getClass()
        {
            return vm.node.class;
        }

        /**
         * Check if node should be hidden
         *
         * @returns {boolean}
         */
        function isHidden()
        {
            if ( angular.isDefined(vm.node.hidden) && angular.isFunction(vm.node.hidden) )
            {
                return vm.node.hidden();
            }

            return false;
        }
    }

    /** @ngInject */
    function msNavigationNodeDirective()
    {
        return {
            restrict        : 'A',
            bindToController: {
                node: '=msNavigationNode'
            },
            controller      : 'MsNavigationNodeController as vm',
            compile         : function (tElement)
            {
                tElement.addClass('ms-navigation-node');

                return function postLink(scope, iElement, iAttrs, MsNavigationNodeCtrl)
                {
                    // Add custom classes
                    iElement.addClass(MsNavigationNodeCtrl.getClass());

                    // Add group class if it's a group
                    if ( MsNavigationNodeCtrl.group )
                    {
                        iElement.addClass('group');
                    }
                };
            }
        };
    }

    /** @ngInject */
    function msNavigationItemDirective()
    {
        return {
            restrict: 'A',
            require : '^msNavigationNode',
            compile : function (tElement)
            {
                tElement.addClass('ms-navigation-item');

                return function postLink(scope, iElement, iAttrs, MsNavigationNodeCtrl)
                {
                    // If the item is collapsable...
                    if ( MsNavigationNodeCtrl.collapsable )
                    {
                        iElement.on('click', MsNavigationNodeCtrl.toggleCollapsed);
                    }

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        iElement.off('click');
                    });
                };
            }
        };
    }

    /** @ngInject */
    function msNavigationHorizontalDirective(msNavigationService)
    {
        return {
            restrict   : 'E',
            scope      : {
                root: '@'
            },
            controller : 'MsNavigationController as vm',
            templateUrl: 'app/core/directives/ms-navigation/templates/horizontal.html',
            transclude : true,
            compile    : function (tElement)
            {
                tElement.addClass('ms-navigation-horizontal');

                return function postLink(scope)
                {
                    // Store the navigation in the service for public access
                    msNavigationService.setNavigationScope(scope);
                };
            }
        };
    }

    /** @ngInject */
    function MsNavigationHorizontalNodeController($scope, $element, $rootScope, $state, msNavigationService)
    {
        var vm = this;

        // Data
        vm.element = $element;
        vm.node = $scope.node;
        vm.hasChildren = undefined;
        vm.group = undefined;

        // Methods
        vm.getClass = getClass;

        //////////

        init();

        /**
         * Initialize
         */
        function init()
        {
            // Setup the initial values

            // Is active
            vm.isActive = false;

            // Has children?
            vm.hasChildren = vm.node.children.length > 0;

            // Is group?
            vm.group = !!(angular.isDefined(vm.node.group) && vm.node.group === true);

            // Mark all parents as active if we have a matching state
            // or the current state is a child of the node's state
            if ( vm.node.state === $state.current.name || $state.includes(vm.node.state) )
            {
                // If state params are defined, make sure they are
                // equal, otherwise do not set the active item
                if ( angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params) )
                {
                    return;
                }

                $scope.$emit('msNavigation::stateMatched');

                // Also store the current active menu item
                msNavigationService.setActiveItem(vm.node, $scope);
            }

            $scope.$on('msNavigation::stateMatched', function ()
            {
                // Mark as active if has children
                if ( vm.hasChildren )
                {
                    $scope.$evalAsync(function ()
                    {
                        vm.isActive = true;
                    });
                }
            });

            // Listen for clearActive event
            $scope.$on('msNavigation::clearActive', function ()
            {
                if ( !vm.hasChildren )
                {
                    return;
                }

                var activePathParts = [];

                var activeItem = msNavigationService.getActiveItem();
                if ( activeItem )
                {
                    activePathParts = activeItem.node._path.split('.');
                }

                // Test for active path
                if ( activePathParts.indexOf(vm.node._id) > -1 )
                {
                    $scope.$evalAsync(function ()
                    {
                        vm.isActive = true;
                    });
                }
                else
                {
                    $scope.$evalAsync(function ()
                    {
                        vm.isActive = false;
                    });
                }

            });

            // Listen for $stateChangeSuccess event
            $scope.$on('$stateChangeSuccess', function ()
            {
                if ( vm.node.state === $state.current.name || $state.includes(vm.node.state) )
                {
                    // If state params are defined, make sure they are
                    // equal, otherwise do not set the active item
                    if ( angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params) )
                    {
                        return;
                    }

                    // Update active item on state change
                    msNavigationService.setActiveItem(vm.node, $scope);

                    // Clear all active states except the one we're using
                    $rootScope.$broadcast('msNavigation::clearActive');
                }
            });
        }

        /**
         * Return the class
         *
         * @returns {*}
         */
        function getClass()
        {
            return vm.node.class;
        }
    }

    /** @ngInject */
    function msNavigationHorizontalNodeDirective()
    {
        return {
            restrict        : 'A',
            bindToController: {
                node: '=msNavigationHorizontalNode'
            },
            controller      : 'MsNavigationHorizontalNodeController as vm',
            compile         : function (tElement)
            {
                tElement.addClass('ms-navigation-horizontal-node');

                return function postLink(scope, iElement, iAttrs, MsNavigationHorizontalNodeCtrl)
                {
                    // Add custom classes
                    iElement.addClass(MsNavigationHorizontalNodeCtrl.getClass());

                    // Add group class if it's a group
                    if ( MsNavigationHorizontalNodeCtrl.group )
                    {
                        iElement.addClass('group');
                    }
                };
            }
        };
    }

    /** @ngInject */
    function msNavigationHorizontalItemDirective($mdMedia)
    {
        return {
            restrict: 'A',
            require : '^msNavigationHorizontalNode',
            compile : function (tElement)
            {
                tElement.addClass('ms-navigation-horizontal-item');

                return function postLink(scope, iElement, iAttrs, MsNavigationHorizontalNodeCtrl)
                {
                    iElement.on('click', onClick);

                    function onClick()
                    {
                        if ( !MsNavigationHorizontalNodeCtrl.hasChildren || $mdMedia('gt-md') )
                        {
                            return;
                        }

                        iElement.toggleClass('expanded');
                    }

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        iElement.off('click');
                    });
                };
            }
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msRandomClass', msRandomClassDirective);

    /** @ngInject */
    function msRandomClassDirective()
    {
        return {
            restrict: 'A',
            scope   : {
                msRandomClass: '='
            },
            link    : function (scope, iElement)
            {
                var randomClass = scope.msRandomClass[Math.floor(Math.random() * (scope.msRandomClass.length))];
                iElement.addClass(randomClass);
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .factory('msNavFoldService', msNavFoldService)
        .directive('msNavIsFolded', msNavIsFoldedDirective)
        .controller('MsNavController', MsNavController)
        .directive('msNav', msNavDirective)
        .directive('msNavTitle', msNavTitleDirective)
        .directive('msNavButton', msNavButtonDirective)
        .directive('msNavToggle', msNavToggleDirective);

    /** @ngInject */
    function msNavFoldService()
    {
        var foldable = {};

        var service = {
            setFoldable    : setFoldable,
            isNavFoldedOpen: isNavFoldedOpen,
            toggleFold     : toggleFold,
            openFolded     : openFolded,
            closeFolded    : closeFolded
        };

        return service;

        //////////

        /**
         * Set the foldable
         *
         * @param scope
         * @param element
         */
        function setFoldable(scope, element)
        {
            foldable = {
                'scope'  : scope,
                'element': element
            };
        }

        /**
         * Is folded open
         */
        function isNavFoldedOpen()
        {
            return foldable.scope.isNavFoldedOpen();
        }

        /**
         * Toggle fold
         */
        function toggleFold()
        {
            foldable.scope.toggleFold();
        }

        /**
         * Open folded navigation
         */
        function openFolded()
        {
            foldable.scope.openFolded();
        }

        /**
         * Close folded navigation
         */
        function closeFolded()
        {
            foldable.scope.closeFolded();
        }
    }

    /** @ngInject */
    function msNavIsFoldedDirective($document, $rootScope, msNavFoldService)
    {
        return {
            restrict: 'A',
            link    : function (scope, iElement, iAttrs)
            {
                var isFolded = (iAttrs.msNavIsFolded === 'true'),
                    isFoldedOpen = false,
                    body = angular.element($document[0].body),
                    openOverlay = angular.element('<div id="ms-nav-fold-open-overlay"></div>'),
                    closeOverlay = angular.element('<div id="ms-nav-fold-close-overlay"></div>'),
                    sidenavEl = iElement.parent();

                // Initialize the service
                msNavFoldService.setFoldable(scope, iElement, isFolded);

                // Set the fold status for the first time
                if ( isFolded )
                {
                    fold();
                }
                else
                {
                    unfold();
                }

                /**
                 * Is nav folded open
                 */
                function isNavFoldedOpen()
                {
                    return isFoldedOpen;
                }

                /**
                 * Toggle fold
                 */
                function toggleFold()
                {
                    isFolded = !isFolded;

                    if ( isFolded )
                    {
                        fold();
                    }
                    else
                    {
                        unfold();
                    }
                }

                /**
                 * Fold the navigation
                 */
                function fold()
                {
                    // Add classes
                    body.addClass('ms-nav-folded');

                    // Collapse everything and scroll to the top
                    $rootScope.$broadcast('msNav::forceCollapse');
                    iElement.scrollTop(0);

                    // Append the openOverlay to the element
                    sidenavEl.append(openOverlay);

                    // Event listeners
                    openOverlay.on('mouseenter touchstart', function (event)
                    {
                        openFolded(event);
                        isFoldedOpen = true;
                    });
                }

                /**
                 * Open folded navigation
                 */
                function openFolded(event)
                {
                    if ( angular.isDefined(event) )
                    {
                        event.preventDefault();
                    }

                    body.addClass('ms-nav-folded-open');

                    // Update the location
                    $rootScope.$broadcast('msNav::expandMatchingToggles');

                    // Remove open overlay
                    sidenavEl.find(openOverlay).remove();

                    // Append close overlay and bind its events
                    sidenavEl.parent().append(closeOverlay);
                    closeOverlay.on('mouseenter touchstart', function (event)
                    {
                        closeFolded(event);
                        isFoldedOpen = false;
                    });
                }

                /**
                 * Close folded navigation
                 */
                function closeFolded(event)
                {
                    if ( angular.isDefined(event) )
                    {
                        event.preventDefault();
                    }

                    // Collapse everything and scroll to the top
                    $rootScope.$broadcast('msNav::forceCollapse');
                    iElement.scrollTop(0);

                    body.removeClass('ms-nav-folded-open');

                    // Remove close overlay
                    sidenavEl.parent().find(closeOverlay).remove();

                    // Append open overlay and bind its events
                    sidenavEl.append(openOverlay);
                    openOverlay.on('mouseenter touchstart', function (event)
                    {
                        openFolded(event);
                        isFoldedOpen = true;
                    });
                }

                /**
                 * Unfold the navigation
                 */
                function unfold()
                {
                    body.removeClass('ms-nav-folded ms-nav-folded-open');

                    // Update the location
                    $rootScope.$broadcast('msNav::expandMatchingToggles');

                    iElement.off('mouseenter mouseleave');
                }

                // Expose functions to the scope
                scope.toggleFold = toggleFold;
                scope.openFolded = openFolded;
                scope.closeFolded = closeFolded;
                scope.isNavFoldedOpen = isNavFoldedOpen;

                // Cleanup
                scope.$on('$destroy', function ()
                {
                    openOverlay.off('mouseenter touchstart');
                    closeOverlay.off('mouseenter touchstart');
                    iElement.off('mouseenter mouseleave');
                });
            }
        };
    }


    /** @ngInject */
    function MsNavController()
    {
        var vm = this,
            disabled = false,
            toggleItems = [],
            lockedItems = [];

        // Data

        // Methods
        vm.isDisabled = isDisabled;
        vm.enable = enable;
        vm.disable = disable;
        vm.setToggleItem = setToggleItem;
        vm.getLockedItems = getLockedItems;
        vm.setLockedItem = setLockedItem;
        vm.clearLockedItems = clearLockedItems;

        //////////

        /**
         * Is navigation disabled
         *
         * @returns {boolean}
         */
        function isDisabled()
        {
            return disabled;
        }

        /**
         * Disable the navigation
         */
        function disable()
        {
            disabled = true;
        }

        /**
         * Enable the navigation
         */
        function enable()
        {
            disabled = false;
        }

        /**
         * Set toggle item
         *
         * @param element
         * @param scope
         */
        function setToggleItem(element, scope)
        {
            toggleItems.push({
                'element': element,
                'scope'  : scope
            });
        }

        /**
         * Get locked items
         *
         * @returns {Array}
         */
        function getLockedItems()
        {
            return lockedItems;
        }

        /**
         * Set locked item
         *
         * @param element
         * @param scope
         */
        function setLockedItem(element, scope)
        {
            lockedItems.push({
                'element': element,
                'scope'  : scope
            });
        }

        /**
         * Clear locked items list
         */
        function clearLockedItems()
        {
            lockedItems = [];
        }
    }

    /** @ngInject */
    function msNavDirective($rootScope, $mdComponentRegistry, msNavFoldService)
    {
        return {
            restrict  : 'E',
            scope     : {},
            controller: 'MsNavController',
            compile   : function (tElement)
            {
                tElement.addClass('ms-nav');

                return function postLink(scope)
                {
                    // Update toggle status according to the ui-router current state
                    $rootScope.$broadcast('msNav::expandMatchingToggles');

                    // Update toggles on state changes
                    var stateChangeSuccessEvent = $rootScope.$on('$stateChangeSuccess', function ()
                    {
                        $rootScope.$broadcast('msNav::expandMatchingToggles');

                        // Close navigation sidenav on stateChangeSuccess
                        $mdComponentRegistry.when('navigation').then(function (navigation)
                        {
                            navigation.close();

                            if ( msNavFoldService.isNavFoldedOpen() )
                            {
                                msNavFoldService.closeFolded();
                            }
                        });
                    });

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        stateChangeSuccessEvent();
                    });
                };
            }
        };
    }

    /** @ngInject */
    function msNavTitleDirective()
    {
        return {
            restrict: 'A',
            compile : function (tElement)
            {
                tElement.addClass('ms-nav-title');

                return function postLink()
                {

                };
            }
        };
    }

    /** @ngInject */
    function msNavButtonDirective()
    {
        return {
            restrict: 'AE',
            compile : function (tElement)
            {
                tElement.addClass('ms-nav-button');

                return function postLink()
                {

                };
            }
        };
    }

    /** @ngInject */
    function msNavToggleDirective($rootScope, $q, $animate, $state)
    {
        return {
            restrict: 'A',
            require : '^msNav',
            scope   : true,
            compile : function (tElement, tAttrs)
            {
                tElement.addClass('ms-nav-toggle');

                // Add collapsed attr
                if ( angular.isUndefined(tAttrs.collapsed) )
                {
                    tAttrs.collapsed = true;
                }

                tElement.attr('collapsed', tAttrs.collapsed);

                return function postLink(scope, iElement, iAttrs, MsNavCtrl)
                {
                    var classes = {
                        expanded         : 'expanded',
                        expandAnimation  : 'expand-animation',
                        collapseAnimation: 'collapse-animation'
                    };

                    // Store all related states
                    var links = iElement.find('a');
                    var states = [];
                    var regExp = /\(.*\)/g;

                    angular.forEach(links, function (link)
                    {
                        var state = angular.element(link).attr('ui-sref');

                        if ( angular.isUndefined(state) )
                        {
                            return;
                        }

                        // Remove any parameter definition from the state name before storing it
                        state = state.replace(regExp, '');

                        states.push(state);
                    });

                    // Store toggle-able element and its scope in the main nav controller
                    MsNavCtrl.setToggleItem(iElement, scope);

                    // Click handler
                    iElement.children('.ms-nav-button').on('click', toggle);

                    // Toggle function
                    function toggle()
                    {
                        // If navigation is disabled, do nothing...
                        if ( MsNavCtrl.isDisabled() )
                        {
                            return;
                        }

                        // Disable the entire navigation to prevent spamming
                        MsNavCtrl.disable();

                        if ( isCollapsed() )
                        {
                            // Clear the locked items list
                            MsNavCtrl.clearLockedItems();

                            // Emit pushToLockedList event
                            scope.$emit('msNav::pushToLockedList');

                            // Collapse everything but locked items
                            $rootScope.$broadcast('msNav::collapse');

                            // Expand and then...
                            expand().then(function ()
                            {
                                // Enable the entire navigation after animations completed
                                MsNavCtrl.enable();
                            });
                        }
                        else
                        {
                            // Collapse with all children
                            scope.$broadcast('msNav::forceCollapse');
                        }
                    }

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        iElement.children('.ms-nav-button').off('click');
                    });

                    /*---------------------*/
                    /* Scope Events        */
                    /*---------------------*/

                    /**
                     * Collapse everything but locked items
                     */
                    scope.$on('msNav::collapse', function ()
                    {
                        // Only collapse toggles that are not locked
                        var lockedItems = MsNavCtrl.getLockedItems();
                        var locked = false;

                        angular.forEach(lockedItems, function (lockedItem)
                        {
                            if ( angular.equals(lockedItem.scope, scope) )
                            {
                                locked = true;
                            }
                        });

                        if ( locked )
                        {
                            return;
                        }

                        // Collapse and then...
                        collapse().then(function ()
                        {
                            // Enable the entire navigation after animations completed
                            MsNavCtrl.enable();
                        });
                    });

                    /**
                     * Collapse everything
                     */
                    scope.$on('msNav::forceCollapse', function ()
                    {
                        // Collapse and then...
                        collapse().then(function ()
                        {
                            // Enable the entire navigation after animations completed
                            MsNavCtrl.enable();
                        });
                    });

                    /**
                     * Expand toggles that match with the current states
                     */
                    scope.$on('msNav::expandMatchingToggles', function ()
                    {
                        var currentState = $state.current.name;
                        var shouldExpand = false;

                        angular.forEach(states, function (state)
                        {
                            if ( currentState === state )
                            {
                                shouldExpand = true;
                            }
                        });

                        if ( shouldExpand )
                        {
                            expand();
                        }
                        else
                        {
                            collapse();
                        }
                    });

                    /**
                     * Add toggle to the locked list
                     */
                    scope.$on('msNav::pushToLockedList', function ()
                    {
                        // Set expanded item on main nav controller
                        MsNavCtrl.setLockedItem(iElement, scope);
                    });

                    /*---------------------*/
                    /* Internal functions  */
                    /*---------------------*/

                    /**
                     * Is element collapsed
                     *
                     * @returns {bool}
                     */
                    function isCollapsed()
                    {
                        return iElement.attr('collapsed') === 'true';
                    }

                    /**
                     * Is element expanded
                     *
                     * @returns {bool}
                     */
                    function isExpanded()
                    {
                        return !isCollapsed();
                    }

                    /**
                     * Expand the toggle
                     *
                     * @returns $promise
                     */
                    function expand()
                    {
                        // Create a new deferred object
                        var deferred = $q.defer();

                        // If the menu item is already expanded, do nothing..
                        if ( isExpanded() )
                        {
                            // Reject the deferred object
                            deferred.reject({'error': true});

                            // Return the promise
                            return deferred.promise;
                        }

                        // Set element attr
                        iElement.attr('collapsed', false);

                        // Grab the element to expand
                        var elementToExpand = angular.element(iElement.find('ms-nav-toggle-items')[0]);

                        // Move the element out of the dom flow and
                        // make it block so we can get its height
                        elementToExpand.css({
                            'position'  : 'absolute',
                            'visibility': 'hidden',
                            'display'   : 'block',
                            'height'    : 'auto'
                        });

                        // Grab the height
                        var height = elementToExpand[0].offsetHeight;

                        // Reset the style modifications
                        elementToExpand.css({
                            'position'  : '',
                            'visibility': '',
                            'display'   : '',
                            'height'    : ''
                        });

                        // Animate the height
                        scope.$evalAsync(function ()
                        {
                            $animate.animate(elementToExpand,
                                {
                                    'display': 'block',
                                    'height' : '0px'
                                },
                                {
                                    'height': height + 'px'
                                },
                                classes.expandAnimation
                            ).then(
                                function ()
                                {
                                    // Add expanded class
                                    elementToExpand.addClass(classes.expanded);

                                    // Clear the inline styles after animation done
                                    elementToExpand.css({'height': ''});

                                    // Resolve the deferred object
                                    deferred.resolve({'success': true});
                                }
                            );
                        });

                        // Return the promise
                        return deferred.promise;
                    }

                    /**
                     * Collapse the toggle
                     *
                     * @returns $promise
                     */
                    function collapse()
                    {
                        // Create a new deferred object
                        var deferred = $q.defer();

                        // If the menu item is already collapsed, do nothing..
                        if ( isCollapsed() )
                        {
                            // Reject the deferred object
                            deferred.reject({'error': true});

                            // Return the promise
                            return deferred.promise;
                        }

                        // Set element attr
                        iElement.attr('collapsed', true);

                        // Grab the element to collapse
                        var elementToCollapse = angular.element(iElement.find('ms-nav-toggle-items')[0]);

                        // Grab the height
                        var height = elementToCollapse[0].offsetHeight;

                        // Animate the height
                        scope.$evalAsync(function ()
                        {
                            $animate.animate(elementToCollapse,
                                {
                                    'height': height + 'px'
                                },
                                {
                                    'height': '0px'
                                },
                                classes.collapseAnimation
                            ).then(
                                function ()
                                {
                                    // Remove expanded class
                                    elementToCollapse.removeClass(classes.expanded);

                                    // Clear the inline styles after animation done
                                    elementToCollapse.css({
                                        'display': '',
                                        'height' : ''
                                    });

                                    // Resolve the deferred object
                                    deferred.resolve({'success': true});
                                }
                            );
                        });

                        // Return the promise
                        return deferred.promise;
                    }
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('msMasonryController', msMasonryController)
        .directive('msMasonry', msMasonry)
        .directive('msMasonryItem', msMasonryItem);

    /** @ngInject */
    function msMasonryController($scope, $window, $mdMedia, $timeout)
    {
        var vm = this,
            defaultOpts = {
                columnCount     : 5,
                respectItemOrder: false,
                reLayoutDebounce: 400,
                responsive      : {
                    md: 3,
                    sm: 2,
                    xs: 1
                }
            },
            reLayoutTimeout = true;

        vm.options = null;
        vm.container = [];
        vm.containerPos = '';
        vm.columnWidth = '';
        vm.items = [];

        // Methods
        vm.reLayout = reLayout;
        vm.initialize = initialize;
        vm.waitImagesLoaded = waitImagesLoaded;

        function initialize()
        {
            vm.options = !vm.options ? defaultOpts : angular.extend(defaultOpts, vm.options);


            watchContainerResize();
        }

        $scope.$on('msMasonry:relayout', function ()
        {
            reLayout();
        });

        function waitImagesLoaded(element, callback)
        {
            if ( typeof imagesLoaded !== 'undefined' )
            {
                var imgLoad = $window.imagesLoaded(element);

                imgLoad.on('done', function ()
                {
                    callback();
                });
            }
            else
            {
                callback();
            }
        }

        function watchContainerResize()
        {
            $scope.$watch(
                function ()
                {
                    return vm.container.width();
                },
                function (newValue, oldValue)
                {
                    if ( newValue !== oldValue )
                    {
                        reLayout();
                    }
                }
            );
        }

        function reLayout()
        {
            // Debounce for relayout
            if ( reLayoutTimeout )
            {
                $timeout.cancel(reLayoutTimeout);
            }

            reLayoutTimeout = $timeout(function ()
            {
                start();

                $scope.$broadcast('msMasonry:relayoutFinished');

            }, vm.options.reLayoutDebounce);

            // Start relayout
            function start()
            {
                vm.containerPos = vm.container[0].getBoundingClientRect();

                updateColumnOptions();

                $scope.$broadcast('msMasonry:relayoutStarted');

                vm.items = vm.container.find('ms-masonry-item');

                //initialize lastRowBottomArr
                var referenceArr = Array.apply(null, new Array(vm.columnCount)).map(function ()
                {
                    return 0;
                });

                // set item positions
                for ( var i = 0; i < vm.items.length; i++ )
                {
                    var item = vm.items[i],
                        xPos, yPos, column, refTop;

                    item = angular.element(item);

                    if ( item.scope() )
                    {
                        item.scope().$broadcast('msMasonryItem:startReLayout');
                    }

                    item.css({'width': vm.columnWidth});

                    if ( vm.options.respectItemOrder )
                    {
                        column = i % vm.columnCount;
                        refTop = referenceArr[column];
                    }
                    else
                    {
                        refTop = Math.min.apply(Math, referenceArr);
                        column = referenceArr.indexOf(refTop);
                    }

                    referenceArr[column] = refTop + item[0].getBoundingClientRect().height;

                    xPos = Math.round(column * vm.columnWidth);
                    yPos = refTop;

                    item.css({'transform': 'translate3d(' + xPos + 'px,' + yPos + 'px,0px)'});
                    item.addClass('placed');

                    if ( item.scope() )
                    {
                        item.scope().$broadcast('msMasonryItem:finishReLayout');
                    }
                }
            }
        }

        function updateColumnOptions()
        {
            vm.columnCount = vm.options.columnCount;

            if ( $mdMedia('gt-md') )
            {
                vm.columnCount = vm.options.columnCount;
            }
            else if ( $mdMedia('md') )
            {
                vm.columnCount = (vm.columnCount > vm.options.responsive.md ? vm.options.responsive.md : vm.columnCount);
            }
            else if ( $mdMedia('sm') )
            {
                vm.columnCount = (vm.columnCount > vm.options.responsive.sm ? vm.options.responsive.sm : vm.columnCount);
            }
            else
            {
                vm.columnCount = vm.options.responsive.xs;
            }

            vm.columnWidth = vm.containerPos.width / vm.columnCount;

        }
    }

    /** @ngInject */
    function msMasonry($timeout)
    {
        return {
            restrict  : 'AEC',
            controller: 'msMasonryController',
            compile   : compile
        };
        function compile(element, attributes)
        {
            return {
                pre : function preLink(scope, iElement, iAttrs, controller)
                {
                    controller.options = angular.fromJson(attributes.options || '{}');
                    controller.container = element;
                },
                post: function postLink(scope, iElement, iAttrs, controller)
                {
                    $timeout(function ()
                    {
                        controller.initialize();
                    });
                }
            };
        }
    }

    /** @ngInject */
    function msMasonryItem()
    {
        return {
            restrict: 'AEC',
            require : '^msMasonry',
            priority: 1,
            link    : link
        };

        function link(scope, element, attributes, controller)
        {
            controller.waitImagesLoaded(element, function ()
            {
                controller.reLayout();

            });

            scope.$on('msMasonryItem:finishReLayout', function ()
            {
                scope.$watch(function ()
                {
                    return element.height();
                }, function (newVal, oldVal)
                {
                    if ( newVal !== oldVal )
                    {
                        controller.reLayout();
                    }
                });
            });

            element.on('$destroy', function ()
            {
                controller.reLayout();
            });
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('msDatepickerFixConfig', msDatepickerFixConfigProvider)
        .directive('msDatepickerFix', msDatepickerFix);

    /** @ngInject */
    function msDatepickerFixConfigProvider()
    {
        var service = this;

        // Default configuration
        var defaultConfig = {
            // To view
            formatter: function (val)
            {
                if ( !val )
                {
                    return '';
                }

                return val === '' ? val : new Date(val);
            },
            // To model
            parser   : function (val)
            {
                if ( !val )
                {
                    return '';
                }

                return moment(val).add(moment(val).utcOffset(), 'm').toDate();
            }
        };

        // Methods
        service.config = config;

        //////////

        /**
         * Extend default configuration with the given one
         *
         * @param configuration
         */
        function config(configuration)
        {
            defaultConfig = angular.extend({}, defaultConfig, configuration);
        }

        /**
         * Service
         */
        service.$get = function ()
        {
            return defaultConfig;
        };
    }

    /** @ngInject */
    function msDatepickerFix(msDatepickerFixConfig)
    {
        return {
            require : 'ngModel',
            priority: 1,
            link    : function (scope, elem, attrs, ngModel)
            {
                ngModel.$formatters.push(msDatepickerFixConfig.formatter); // to view
                ngModel.$parsers.push(msDatepickerFixConfig.parser); // to model
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msInfoBar', msInfoBarDirective);

    /** @ngInject */
    function msInfoBarDirective($document)
    {
        return {
            restrict   : 'E',
            scope      : {},
            transclude : true,
            templateUrl: 'app/core/directives/ms-info-bar/ms-info-bar.html',
            link       : function (scope, iElement)
            {
                var body = $document.find('body'),
                    bodyClass = 'ms-info-bar-active';

                // Add body class
                body.addClass(bodyClass);

                /**
                 * Remove the info bar
                 */
                function removeInfoBar()
                {
                    body.removeClass(bodyClass);
                    iElement.remove();
                    scope.$destroy();
                }

                // Expose functions
                scope.removeInfoBar = removeInfoBar;
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msCard', msCardDirective);

    /** @ngInject */
    function msCardDirective()
    {
        return {
            restrict: 'E',
            scope   : {
                templatePath: '=template',
                card        : '=ngModel',
                vm          : '=viewModel'
            },
            template: '<div class="ms-card-content-wrapper" ng-include="templatePath" onload="cardTemplateLoaded()"></div>',
            compile : function (tElement)
            {
                // Add class
                tElement.addClass('ms-card');

                return function postLink(scope, iElement)
                {
                    // Methods
                    scope.cardTemplateLoaded = cardTemplateLoaded;

                    //////////

                    /**
                     * Emit cardTemplateLoaded event
                     */
                    function cardTemplateLoaded()
                    {
                        scope.$emit('msCard::cardTemplateLoaded', iElement);
                    }
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsFormWizardController', MsFormWizardController)
        .directive('msFormWizard', msFormWizardDirective)
        .directive('msFormWizardForm', msFormWizardFormDirective);

    /** @ngInject */
    function MsFormWizardController()
    {
        var vm = this;

        // Data
        vm.forms = [];
        vm.selectedIndex = 0;

        // Methods
        vm.registerForm = registerForm;

        vm.previousStep = previousStep;
        vm.nextStep = nextStep;
        vm.firstStep = firstStep;
        vm.lastStep = lastStep;

        vm.totalSteps = totalSteps;
        vm.isFirstStep = isFirstStep;
        vm.isLastStep = isLastStep;

        vm.currentStepInvalid = currentStepInvalid;
        vm.previousStepInvalid = previousStepInvalid;
        vm.formsIncomplete = formsIncomplete;
        vm.resetForm = resetForm;

        //////////

        /**
         * Register form
         *
         * @param form
         */
        function registerForm(form)
        {
            vm.forms.push(form);
        }

        /**
         * Go to previous step
         */
        function previousStep()
        {
            if ( isFirstStep() )
            {
                return;
            }

            vm.selectedIndex--;
        }

        /**
         * Go to next step
         */
        function nextStep()
        {
            if ( isLastStep() )
            {
                return;
            }

            vm.selectedIndex++;
        }

        /**
         * Go to first step
         */
        function firstStep()
        {
            vm.selectedIndex = 0;
        }

        /**
         * Go to last step
         */
        function lastStep()
        {
            vm.selectedIndex = totalSteps() - 1;
        }

        /**
         * Return total steps
         *
         * @returns {int}
         */
        function totalSteps()
        {
            return vm.forms.length;
        }

        /**
         * Is first step?
         *
         * @returns {boolean}
         */
        function isFirstStep()
        {
            return vm.selectedIndex === 0;
        }

        /**
         * Is last step?
         *
         * @returns {boolean}
         */
        function isLastStep()
        {
            return vm.selectedIndex === totalSteps() - 1;
        }

        /**
         * Is current step invalid?
         *
         * @returns {boolean}
         */
        function currentStepInvalid()
        {
            return angular.isDefined(vm.forms[vm.selectedIndex]) && vm.forms[vm.selectedIndex].$invalid;
        }

        /**
         * Is previous step invalid?
         *
         * @returns {boolean}
         */
        function previousStepInvalid()
        {
            return vm.selectedIndex > 0 && angular.isDefined(vm.forms[vm.selectedIndex - 1]) && vm.forms[vm.selectedIndex - 1].$invalid;
        }

        /**
         * Check if there is any incomplete forms
         *
         * @returns {boolean}
         */
        function formsIncomplete()
        {
            for ( var x = 0; x < vm.forms.length; x++ )
            {
                if ( vm.forms[x].$invalid )
                {
                    return true;
                }
            }

            return false;
        }

        /**
         * Reset form
         */
        function resetForm()
        {
            // Go back to the first step
            vm.selectedIndex = 0;

            // Make sure all the forms are back in the $pristine & $untouched status
            for ( var x = 0; x < vm.forms.length; x++ )
            {
                vm.forms[x].$setPristine();
                vm.forms[x].$setUntouched();
            }
        }
    }

    /** @ngInject */
    function msFormWizardDirective()
    {
        return {
            restrict  : 'E',
            scope     : true,
            controller: 'MsFormWizardController as msWizard',
            compile   : function (tElement)
            {
                tElement.addClass('ms-form-wizard');

                return function postLink()
                {

                };
            }
        };
    }

    /** @ngInject */
    function msFormWizardFormDirective()
    {
        return {
            restrict: 'A',
            require : ['form', '^msFormWizard'],
            compile : function (tElement)
            {
                tElement.addClass('ms-form-wizard-form');

                return function postLink(scope, iElement, iAttrs, ctrls)
                {
                    var formCtrl = ctrls[0],
                        MsFormWizardCtrl = ctrls[1];

                    MsFormWizardCtrl.registerForm(formCtrl);
                };
            }
        };
    }

})();
(function () {

    'use strict';

    angular
        .module('app.service')
        .service('ValidacaoIEService', ValidacaoIEService);

    /** @ngInject */
    function ValidacaoIEService() {
        this.validarInscricaoEstadual = validarInscricaoEstadual;

        function eIndefinido(objeto) {
            return typeof objeto === typeof undefined;
        }

        function tamanhoNaoE(string, tamanho) {
            if (eIndefinido(tamanho)) {
                tamanho = 9;
            }

            return string.length !== tamanho;
        }

        function tamanhoE(string, tamanho) {
            return !tamanhoNaoE(string, tamanho);
        }

        function serie(de, ate) {
            var resultado = [];

            while (de <= ate) {
                resultado.push(de++);
            }

            return resultado;
        }

        function primeiros(string, quantidade) {
            if (eIndefinido(quantidade)) {
                quantidade = 8;
            }

            return string.substring(0, quantidade);
        }

        function substracaoPor11SeMaiorQue2CasoContrario0(valor) {
            return valor < 2 ? 0 : 11 - valor;
        }

        function mod(valor, multiplicadores, divisor) {
            if (eIndefinido(divisor)) {
                divisor = 11;
            }

            if (eIndefinido(multiplicadores)) {
                multiplicadores = serie(2, 9);
            }

            var i = 0;

            return valor.split('').reduceRight(function (anterior, atual) {
                if (i > multiplicadores.length - 1) {
                    i = 0;
                }

                return (multiplicadores[i++] * parseInt(atual, 10)) + anterior;
            }, 0) % divisor;
        }

        function calculoTrivial(valor, base, validarTamanho) {
            if (!validarTamanho && tamanhoNaoE(valor)) {
                return false;
            }

            if (eIndefinido(base)) {
                base = primeiros(valor);
            }

            var digito = substracaoPor11SeMaiorQue2CasoContrario0(mod(base));

            return valor === base + digito;
        }

        function naoComecaCom(string, valor) {
            return string.substring(0, valor.length) !== valor;
        }

        function entre(valor, limiteInferior, limiteSuperior) {
            if (typeof valor === 'string') {
                valor = parseInt(valor, 10);
            }

            return valor >= limiteInferior && valor <= limiteSuperior;
        }

        var funcoes = {
            ba: function (valor) {
                if (tamanhoNaoE(valor, 8) && tamanhoNaoE(valor)) {
                    return false;
                }

                var base = primeiros(valor, valor.length - 2);
                var primeiroDigito, segundoDigito;

                var segundoMultiplicador = serie(2, 7);
                var primeiroMultiplicador = serie(2, 8);

                var primeiroResto, segundoResto;
                var digitoComparacao = valor.substring(0, 1);

                if (tamanhoE(valor, 9)) {
                    segundoMultiplicador.push(8);
                    primeiroMultiplicador.push(9);
                    digitoComparacao = valor.substring(1, 2);
                }

                if ('0123458'.split('').indexOf(digitoComparacao) !== -1) {
                    segundoResto = mod(base, segundoMultiplicador, 10);
                    segundoDigito = segundoResto === 0 ? 0 : 10 - segundoResto;

                    primeiroResto = mod(base + segundoDigito, primeiroMultiplicador, 10);
                    primeiroDigito = primeiroResto === 0 ? 0 : 10 - primeiroResto;
                } else {
                    segundoResto = mod(base, segundoMultiplicador);
                    segundoDigito = substracaoPor11SeMaiorQue2CasoContrario0(segundoResto);

                    primeiroResto = mod(base + segundoDigito, primeiroMultiplicador);
                    primeiroDigito = substracaoPor11SeMaiorQue2CasoContrario0(primeiroResto);
                }

                return valor === base + primeiroDigito + segundoDigito;
            },

            se: function (valor) {
                if (tamanhoNaoE(valor)) {
                    return false;
                }

                return calculoTrivial(valor);
            },

            al: function (valor) {
                if (tamanhoNaoE(valor)) {
                    return false;
                }

                if (naoComecaCom(valor, '24')) {
                    return false;
                }

                //
                // Removi a validação do tipo da empresa abaixo
                // devido a ambiguidade entre a especificação do
                // Sintegra (http://www.sintegra.gov.br/Cad_Estados/cad_AL.html) e do
                // site do da Sefaz do Alagoas (http://www.sefaz.al.gov.br/sintegra/cad_AL.asp).
                // Veja o issue #4 - https://github.com/gammasoft/ie/issues/4
                //
                // if('03578'.split('').indexOf(valor.substring(2, 3)) === -1) {
                //     return false;
                // }

                var base = primeiros(valor);

                var resto = mod(base) * 10;
                resto = resto - (parseInt(resto / 11, 10) * 11);
                var digito = resto === 10 ? 0 : resto;

                return valor === base + digito;
            },

            pb: function (valor) {
                if (tamanhoNaoE(valor)) {
                    return false;
                }

                return calculoTrivial(valor);
            },

            rn: function (valor) {
                if (tamanhoNaoE(valor) && tamanhoNaoE(valor, 10)) {
                    return false;
                }

                if (naoComecaCom(valor, '20')) {
                    return false;
                }

                var base = valor.substring(0, valor.length - 1);

                var multiplicadores = serie(2, 9);
                if (tamanhoE(valor, 10)) {
                    multiplicadores.push(10);
                }

                var resto = (mod(base, multiplicadores) * 10) % 11;
                var digito = resto === 10 ? 0 : resto;

                return valor === base + digito;
            },

            ap: function (valor) {
                if (tamanhoNaoE(valor)) {
                    return false;
                }

                if (naoComecaCom(valor, '03')) {
                    return false;
                }

                var base = primeiros(valor);

                var p, d;

                if (entre(base, 3000001, 3017000)) {
                    p = 5;
                    d = 0;
                } else if (entre(base, 3017001, 3019022)) {
                    p = 9;
                    d = 1;
                } else {
                    p = 0;
                    d = 0;
                }

                var resto = mod(p + base, [2, 3, 4, 5, 6, 7, 8, 9, 1]);

                var digito;
                if (resto === 1) {
                    digito = 0;
                } else if (resto === 0) {
                    digito = d;
                } else {
                    digito = 11 - resto;
                }

                return valor === base + digito;
            },

            rr: function (valor) {
                if (tamanhoNaoE(valor)) {
                    return false;
                }

                if (naoComecaCom(valor, '24')) {
                    return false;
                }

                var base = primeiros(valor);
                var digito = mod(base, [8, 7, 6, 5, 4, 3, 2, 1], 9);

                return valor === base + digito;
            },

            am: function (valor) {
                if (tamanhoNaoE(valor)) {
                    return false;
                }

                return calculoTrivial(valor);
            },

            ro: function (valor) {
                var base, digito, resultadoMod;

                if (tamanhoE(valor, 9)) {
                    base = valor.substring(3, 8);
                    digito = substracaoPor11SeMaiorQue2CasoContrario0(mod(base));

                    return valor === valor.substring(0, 3) + base + digito;
                } else if (tamanhoE(valor, 14)) {
                    base = primeiros(valor, 13);
                    resultadoMod = mod(base);
                    digito = resultadoMod <= 1 ? 1 : 11 - resultadoMod;

                    return valor === base + digito;
                } else {
                    return false;
                }
            },

            rj: function (valor) {
                if (tamanhoNaoE(valor, 8)) {
                    return false;
                }

                var base = primeiros(valor, 7);
                var digito = substracaoPor11SeMaiorQue2CasoContrario0(mod(base, serie(2, 7)));

                return valor === base + digito;
            },

            sc: function (valor) {
                return calculoTrivial(valor);
            },

            pi: function (valor) {
                return calculoTrivial(valor);
            },

            es: function (valor) {
                return calculoTrivial(valor);
            },

            pr: function (valor) {
                if (tamanhoNaoE(valor, 10)) {
                    return false;
                }

                var base = primeiros(valor);

                var restoPrimeiro = mod(base, serie(2, 7));
                var primeiro = 11 - restoPrimeiro >= 10 ? 0 : 11 - restoPrimeiro;

                var restoSegundo = mod(base + primeiro, serie(2, 7));
                var segundo = 11 - restoSegundo >= 10 ? 0 : 11 - restoSegundo;

                return valor === base + primeiro + segundo;
            },

            pa: function (valor) {
                if (tamanhoNaoE(valor)) {
                    return false;
                }

                if (naoComecaCom(valor, '15')) {
                    return false;
                }

                return calculoTrivial(valor);
            },

            ce: function (valor) {
                if (tamanhoNaoE(valor)) {
                    return false;
                }

                if (naoComecaCom(valor, '06')) {
                    return false;
                }

                return calculoTrivial(valor);
            },

            pe: function (valor) {
                var base = valor.substring(0, valor.length - 2);

                var restoPrimeiro = mod(base);
                var primeiro = 11 - restoPrimeiro >= 10 ? 0 : 11 - restoPrimeiro;

                var restoSegundo = mod(base + primeiro);
                var segundo = 11 - restoSegundo >= 10 ? 0 : 11 - restoSegundo;

                return valor === base + primeiro + segundo;
            },

            ma: function (valor) {
                if (tamanhoNaoE(valor)) {
                    return false;
                }

                if (naoComecaCom(valor, '12')) {
                    return false;
                }

                return calculoTrivial(valor);
            },

            ac: function (valor) {
                if (tamanhoNaoE(valor, 13)) {
                    return false;
                }

                if (naoComecaCom(valor, '01')) {
                    return false;
                }

                var base = primeiros(valor, 11);

                var primeiroDigito = substracaoPor11SeMaiorQue2CasoContrario0(mod(base));
                var segundoDigito = substracaoPor11SeMaiorQue2CasoContrario0(mod(base + primeiroDigito));

                return valor === base + primeiroDigito + segundoDigito;
            },

            rs: function (valor) {
                if (tamanhoNaoE(valor, 10)) {
                    return false;
                }

                var base = primeiros(valor, 9);
                return calculoTrivial(valor, base, true);
            },

            mt: function (valor) {
                if (tamanhoNaoE(valor, 11) && tamanhoNaoE(valor)) {
                    return false;
                }

                var base = tamanhoE(valor, 11) ? valor.substring(0, 10) : primeiros(valor);
                return calculoTrivial(valor, base);
            },

            sp: function (valor) {
                valor = valor.toUpperCase();

                var segundaBase;

                if (valor.substr(0, 1) === 'P') {
                    if (tamanhoNaoE(valor, 13)) {
                        return false;
                    }

                    var base = valor.substring(1, 9);
                    segundaBase = valor.substring(10, 13);
                    var resto = mod(base, [10, 8, 7, 6, 5, 4, 3, 1]).toString();
                    var digito = resto.length > 1 ? resto[1] : resto[0];

                    return valor === 'P' + base + digito + segundaBase;
                } else {
                    if (tamanhoNaoE(valor, 12)) {
                        return false;
                    }

                    var primeiraBase = primeiros(valor);
                    segundaBase = valor.substring(9, 11);

                    var primeiroResto = mod(primeiraBase, [10, 8, 7, 6, 5, 4, 3, 1]).toString();
                    var primeiro = primeiroResto.length > 1 ? primeiroResto[1] : primeiroResto[0];

                    var segundoResto = mod(primeiraBase + primeiro + segundaBase, serie(2, 10)).toString();
                    var segundo = segundoResto.length > 1 ? segundoResto[1] : segundoResto[0];

                    return valor === primeiraBase + primeiro + segundaBase + segundo;
                }
            },

            mg: function (valor) {
                if (tamanhoNaoE(valor, 13)) {
                    return false;
                }

                var base = primeiros(valor, 11);

                var baseComZero = valor.substring(0, 3) + '0' + valor.substring(3, 11);

                var i = 0;
                var produtorioLiteral = baseComZero.split('').reduceRight(function (anterior, atual) {
                    if (i > [2, 1].length - 1) {
                        i = 0;
                    }

                    return ([2, 1][i++] * parseInt(atual, 10)).toString() + anterior.toString();
                }, '').split('').reduce(function (anterior, atual) {
                    return anterior + parseInt(atual);
                }, 0);

                var primeiro = ((parseInt(produtorioLiteral / 10) + 1) * 10) - produtorioLiteral;
                if (primeiro === 10) {
                    primeiro = 0;
                }

                var segundo = substracaoPor11SeMaiorQue2CasoContrario0(mod(base + primeiro, serie(2, 11)));

                return valor === base + primeiro + segundo;
            },

            to: function (valor) {
                if (tamanhoNaoE(valor) && tamanhoNaoE(valor, 11)) {
                    return false;
                }

                var base;

                if (tamanhoE(valor, 11)) {
                    if (['01', '02', '03', '99'].indexOf(valor.substring(2, 4)) === -1) {
                        return false;
                    }

                    base = valor.substring(0, 2) + valor.substring(4, 10);
                } else {
                    base = primeiros(valor);
                }

                var digito = substracaoPor11SeMaiorQue2CasoContrario0(mod(base));

                return valor === valor.substring(0, valor.length - 1) + digito;
            },

            go: function (valor) {
                if (tamanhoNaoE(valor)) {
                    return false;
                }

                if (['10', '11', '15'].indexOf(valor.substring(0, 2)) === -1) {
                    return false;
                }

                var base = primeiros(valor);

                if (base === '11094402') {
                    return valor.substr(8) === '1' || valor.substr(8) === '0';
                }

                var resto = mod(base);
                var digito;

                if (resto === 0) {
                    digito = 0;
                } else if (resto === 1) {
                    if (entre(base, 10103105, 10119997)) {
                        digito = 1;
                    } else {
                        digito = 0;
                    }
                } else {
                    digito = 11 - resto;
                }

                return valor === base + digito;
            },

            ms: function (valor) {
                if (naoComecaCom(valor, '28')) {
                    return false;
                }

                return calculoTrivial(valor);
            },

            df: function (valor) {
                if (tamanhoNaoE(valor, 13)) {
                    return false;
                }

                var base = primeiros(valor, 11);

                var primeiro = substracaoPor11SeMaiorQue2CasoContrario0(mod(base));
                var segundo = substracaoPor11SeMaiorQue2CasoContrario0(mod(base + primeiro));

                return valor === base + primeiro + segundo;
            }
        };

        function lookup(ie) {
            var resultado = [];

            for (var estado in funcoes) {
                if (funcoes[estado](ie)) {
                    resultado.push(estado);
                }
            }

            if (tamanhoE(resultado, 0)) {
                return false;
            } else {
                return resultado;
            }
        }

        function validarInscricaoEstadual(ie, estado) {
            if (eIndefinido(estado) || estado === null) {
                estado = '';
            }

            estado = estado.toLowerCase();

            if (estado !== '' && !(estado in funcoes)) {
                throw new Error('estado não é válido');
            }

            if (eIndefinido(ie)) {
                throw new Error('ie deve ser fornecida');
            }

            if (Array.isArray(ie)) {
                return ie.map(function (ie) { return validar(ie, estado); });
            }

            if (typeof ie !== 'string') {
                throw new Error('ie deve ser string ou array de strings');
            }

            if (ie.match(/^ISENTO$/i)) {
                return true;
            }

            ie = ie.replace(/[\.|\-|\/|\s]/g, '');

            if (estado === '') {
                return lookup(ie);
            }

            if (/^\d+$/.test(ie) || estado === 'sp') {
                return funcoes[estado](ie);
            }

            return false;
        }
    }

})();
(function () {
    'use strict';

    angular
        .module('app.diretivas')
        .directive('validacaoIe', validacaoIeDirective);

    function validacaoIeDirective(ValidacaoIEService) {
        return {
            restrict: 'A',
            require: '^ngModel',
            scope: {
                uf: '=?',
                naoHabilitarValidacao: '=?'
            },
            controller: function () {
            },
            link: function (scope, element, attrs, ngModelCtrl) {
                if (!ngModelCtrl) {
                    $log.error("É necessário informar o ng-model para o funcionamento correto da diretiva");
                    return;
                }

                /**
                 * Método de controle executado para validar ou inválidar o modél, também criando um validador customizado à ser utilizado na view
                 * 'validacaoDocumento', e este método é disparado sempre ao final da execução de um $parses ou $formatters
                 */
                ngModelCtrl.$validators.validacaoIE = function (modelValue, viewValue) {
                    if (!viewValue || viewValue.length == 0)
                        return true;
                    else if (scope.naoHabilitarValidacao ){
                        return true;
                    }
                    else if (viewValue && ValidacaoIEService.validarInscricaoEstadual(viewValue, scope.uf)) {
                        return true;
                    }
                    else
                        return false;

                }
            }
        }
    };

})();

/**
 * Created by nova on 05/08/2016.
 */
(function () {
    'use strict';

    angular.module('app.diretivas')
        .controller('ToolbarDesktopMobileController', ToolbarDesktopMobileController)
        .directive('toolbarDesktopMobile', toolbarDesktopMobileDirective);


    function ToolbarDesktopMobileController($scope, $rootScope, $mdSidenav, MdDialogService, MdToastService, $interval, $timeout) {
        var vm = this;

        // Controladores
        this.$onInit = function () {

            vm.metodosExternos = {
                metodoAcaoExternoCriar: metodoToolbarSalvar
            };

            // Controle do Formulário utilizado pela diretiva no bindToController{controleForm: "=?"}
            vm.controleForm = {
                emProgresso: false,
                desabilitarButtonEditar: false,
                desabilitarButtonInserir: false,
                desabilitarButtonExcluir: false,
                desabilitarButtonListarTodos: false,
                desabilitarMetodoToolbarAtualizar: false,
                habilitarButtonSalvar: false,
                pesquisa: {
                    pesquisar: function () {
                        vm.toolbar.pesquisar();
                    },
                    novaPesquisa: function () {
                        vm.toolbar.novaPesquisa();
                    },
                    chamarPesquisar: function () {
                        vm.metodosToolbar.pesquisar();
                    }
                },
                reverter: function (ativarControladorPesquisaAtiva) {
                    vm.toolbar.reverter(ativarControladorPesquisaAtiva);
                },
                pesquisaAtiva: false,
                inserirAtivo: false,
                editarAtivo: false,
                listarTodasEntidades: false,
                chamarListagemTodasEntidades: function () {
                    listarTodasEntidades();
                },
                pesquisarDatatable: false,
                entidadesPesquisadas: null,
                atualizarIndice: {
                    atualizarIndiceParaUltimaPosicao: function () {
                        vm.indice = vm.entidades.length - 1;
                    }
                },
                listarTodas: function (id) {
                    vm.indice = id;

                    if (vm.indice === 0) {
                        vm.controlador.primeiraEntidade = true;
                        vm.controlador.ultimaEntidade = false;
                    } else if (vm.indice === vm.entidades.length - 1) {
                        vm.controlador.primeiraEntidade = false;
                        vm.controlador.ultimaEntidade = true;
                    } else {
                        vm.controlador.primeiraEntidade = false;
                        vm.controlador.ultimaEntidade = false;
                    }

                    vm.controleForm.listarTodasEntidades = false;
                    vm.toolbar.listarTodasEntidades();
                },
                preLoaderToolbar: {
                    inicioProgresso: function () {
                        metodosInternosToolbar.preLoaderToolbar.inicioProgresso();
                    },
                    fimProgresso: function () {
                        metodosInternosToolbar.preLoaderToolbar.fimProgresso();
                    }
                },
                atualizar: {
                    atualizar: function (event) {
                        vm.metodosToolbar.atualizar(event);
                    }
                }
            };

            // Controlador para exibir o textoExibido da aplicação no determinado momento
            vm.controleTextoAExibir = {
                aguardando: "Aguardando",
                novaPesquisa: "Nova Pesquisa",
                pesquisando: "Exibindo",
                editando: "Editando",
                inserindo: "Inserindo",
                listarTodasEntidades: "Exibindo em modo Tabela"
            };

            // Controlador para habilitar e desabilitar os buttons com base no textoExibido que à aplicação está
            vm.controlador = {
                pesquisaAtiva: false,
                primeiraEntidade: false,
                ultimaEntidade: false,
                editarAtivo: false,
                novaEntidade: false,
                listarTodasEntidades: false,
                processaEntidade: false,
            };

            /**
             * Função que interage com o recurso link da diretiva,
             * para pegar o controle do formulário
             * @param formCtrl
             */
            $scope.getFormCtrl = function (formCtrl) {
                vm.formulario = formCtrl;
            };

            // Data
            vm.textoExibido = vm.controleTextoAExibir.aguardando;
            vm.buttonSelecionado = null;
            vm.tempoDelay = 350;
            vm.indice = 0;
            vm.progresso = 0;
            vm.progressoBuffer = 0;
            var promessa = null;
            var processando = undefined;
            var entidadeTemporaria = {};

            ///////////////////////////////////////////////////////////////////

            // Definição Dos Métodos
            var metodosInternosToolbar = {
                chamarPesquisa: chamarPesquisa,
                atualizarFormulario: atualizarFormulario,
                preLoaderToolbar: {
                    inicioProgresso: inicioProgresso,
                    fimProgresso: fimProgresso
                },
                preDefinirControleForm: preDefinirControleForm
            };
            vm.toolbar = {
                novaPesquisa: novaPesquisa,
                pesquisar: pesquisar,
                editar: editar,
                inserir: inserir,
                reverter: reverter,
                primeira: primeira,
                anterior: anterior,
                proxima: proxima,
                ultima: ultima,
                listarTodasEntidades: listarTodasEntidades,
                abrirSidenav: abrirSidenav
            };
            vm.metodosToolbar = {
                pesquisar: metodoToolbarPesquisar,
                atualizar: metodoToolbarAtualizar,
                salvar: metodoToolbarSalvar,
                excluir: metodoToolbarExcluir
            };
            ////////////////////////////////////////////////////////////////////////////


            // Métodos em Scopo

            $scope.$on('$destroy', function () {
                metodosInternosToolbar.preLoaderToolbar.fimProgresso();
            });

            // Métodos Internos
            function chamarPesquisa(event, implementacaoSuccess) {
                promessa = vm.pesquisar();
                if (promessa) {
                    metodosInternosToolbar.preLoaderToolbar.inicioProgresso();
                    promessa.then(
                        function (success) {
                            if (success.data.length > 0) {
                                implementacaoSuccess(success);
                                metodosInternosToolbar.preLoaderToolbar.fimProgresso();
                            } else {
                                metodosInternosToolbar.preLoaderToolbar.fimProgresso();

                                if (!vm.desabilitarMensagemAoPesquisar)
                                    MdDialogService.alertPadrao("Não foi encontrado nenhum registro cadastrado", event);

                                vm.toolbar.novaPesquisa();
                            }
                        },
                        function (error) {
                            if (error.data && (typeof error.data.substrituirQuebraDeLinhasParaTagHtml !== "undefined")) {
                                if (error.data.indexOf("\n") != -1)
                                    MdDialogService.alertPadrao("", event, error.data.substrituirQuebraDeLinhasParaTagHtml());
                                else
                                    MdDialogService.alertPadrao(error.data, event);
                            }
                            else {
                                MdDialogService.alertPadrao(error.data, event);
                            }

                            metodosInternosToolbar.preLoaderToolbar.fimProgresso();
                            vm.toolbar.novaPesquisa();
                        });
                }
            }

            function atualizarFormulario() {
                if (angular.isDefined(vm.formulario)) {
                    vm.formulario.$setUntouched();
                    vm.formulario.$setPristine();
                }
            }

            function inicioProgresso() {
                vm.controleForm.emProgresso = true;
                processando = $interval(function () {
                    vm.progresso += 3;

                    if (vm.progresso > 100)
                        vm.progresso = 0;

                }, 100);
            }

            function fimProgresso() {
                vm.controleForm.emProgresso = false;
                vm.progresso = 0;
                if (angular.isDefined(processando)) {
                    $interval.cancel(processando);
                    processando = undefined;
                }
            }

            /**
             * Método para redefinidir as propriedade de vm.controleForm
             * @param {string} chamada 
             */
            function preDefinirControleForm(chamada) {
                if (chamada == "novaPesquisa") {
                    vm.controleForm.pesquisaAtiva = false;
                    vm.controleForm.listarTodasEntidades = false;
                    vm.controleForm.entidadesPesquisadas = null;
                    vm.controleForm.desabilitarButtonInserir = false;
                    vm.controleForm.desabilitarButtonEditar = false;
                }
                if (chamada == "reverter") {

                }
                vm.controleForm.inserirAtivo = false;
                vm.controleForm.editarAtivo = false;
                vm.controleForm.habilitarButtonSalvar = false;
            }
            ////////////////////////////////////////////

            // Métodos Toolbar
            function novaPesquisa() {
                metodosInternosToolbar.atualizarFormulario();


                $rootScope.desabilitarMudancaDeEstadoDaAplicacao = false;

                vm.controlador.pesquisaAtiva = false;
                vm.controlador.primeiraEntidade = false;
                vm.controlador.ultimaEntidade = false;
                vm.controlador.editarAtivo = false;
                vm.controlador.novaEntidade = false;
                vm.controlador.listarTodasEntidades = false;
                vm.controlador.processaEntidade = false;


                preDefinirControleForm("novaPesquisa");



                vm.indice = 0;
                vm.textoExibido = vm.controleTextoAExibir.novaPesquisa;
                vm.entidades = [];
                vm.entidade = {};
                entidadeTemporaria = {};

                if (angular.isDefined(vm.toolbarNovaPesquisa)) {
                    vm.toolbarNovaPesquisa();
                }

                if (!$rootScope.tamanhoTelaDesktop) {
                    $mdSidenav('sidenav').close();
                }
            }

            function pesquisar() {
                metodosInternosToolbar.atualizarFormulario();

                $rootScope.desabilitarMudancaDeEstadoDaAplicacao = false;

                vm.controleForm.pesquisaAtiva = true;
                vm.controlador.pesquisaAtiva = true;

                vm.controlador.primeiraEntidade = true;

                if (vm.controlador.listarTodasEntidades) {
                    vm.textoExibido = vm.controleTextoAExibir.listarTodasEntidades;
                }
                else {
                    vm.textoExibido = vm.controleTextoAExibir.pesquisando;
                }
            }

            function editar(entidade) {
                metodosInternosToolbar.atualizarFormulario();

                if (angular.isDefined(vm.toolbarEditar)) {
                    vm.toolbarEditar();
                }

                $rootScope.desabilitarMudancaDeEstadoDaAplicacao = true;

                entidadeTemporaria = angular.copy(entidade);
                vm.textoExibido = vm.controleTextoAExibir.editando;
                vm.controleForm.editarAtivo = true;
                vm.controlador.editarAtivo = true;

                if (!$rootScope.tamanhoTelaDesktop) {
                    $mdSidenav('sidenav').close();
                }
            }

            function inserir(entidade) {
                //      metodosInternosToolbar.atualizarFormulario();

                if (angular.isDefined(vm.toolbarInserir)) {
                    vm.toolbarInserir();
                }
                if (entidade) {
                    entidadeTemporaria = entidade;
                }

                $rootScope.desabilitarMudancaDeEstadoDaAplicacao = true;

                vm.textoExibido = vm.controleTextoAExibir.inserindo;
                vm.controleForm.inserirAtivo = true;
                vm.controlador.novaEntidade = true;

                if (vm.controlador.pesquisaAtiva) {
                    vm.entidade = {};
                }

                if (!$rootScope.tamanhoTelaDesktop) {
                    $mdSidenav('sidenav').close();
                }

            }

            function reverter(ativarControladorPesquisaAtiva) {
                metodosInternosToolbar.atualizarFormulario();

                if (angular.isDefined(vm.toolbarReverter)) {
                    vm.toolbarReverter();
                }

                // Seta os controladores de edição ou inserção para false e retorna a entidade para o textoExibido anterior
                preDefinirControleForm("reverter");

                $rootScope.desabilitarMudancaDeEstadoDaAplicacao = false;

                vm.controlador.editarAtivo = false;
                vm.controlador.novaEntidade = false;

                if (!vm.controlador.pesquisaAtiva && ativarControladorPesquisaAtiva) {
                    vm.toolbar.pesquisar();
                } else if (vm.controlador.pesquisaAtiva && !ativarControladorPesquisaAtiva) {
                    vm.textoExibido = vm.controleTextoAExibir.pesquisando;
                    vm.entidade = entidadeTemporaria;
                } else if (!vm.controlador.pesquisaAtiva && !ativarControladorPesquisaAtiva) {
                    vm.textoExibido = vm.controleTextoAExibir.novaPesquisa;
                    vm.entidade = entidadeTemporaria;
                }

                if (vm.indice === -1) {
                    vm.toolbar.novaPesquisa();
                } else if (vm.indice === 0) {
                    vm.controlador.primeiraEntidade = true;
                    vm.controlador.ultimaEntidade = false;
                } else if (vm.indice === vm.entidades.length - 1) {
                    vm.controlador.ultimaEntidade = true;
                    vm.controlador.primeiraEntidade = false;
                } else {
                    vm.controlador.ultimaEntidade = false;
                    vm.controlador.primeiraEntidade = false;
                }
            }

            function primeira() {
                vm.controlador.processaEntidade = true;
                $timeout(function () {
                    vm.indice = 0;
                    vm.entidade = vm.entidades[0];
                    vm.controlador.primeiraEntidade = true;
                    vm.controlador.ultimaEntidade = false;
                    vm.controlador.processaEntidade = false;
                }, 250);

                if (angular.isDefined(vm.primeira)) {
                    vm.primeira();
                }
            }

            function anterior() {
                vm.controlador.processaEntidade = true;
                $timeout(function () {
                    if (vm.indice > 0) {
                        vm.controlador.ultimaEntidade = false;
                        vm.entidade = vm.entidades[vm.indice - 1];
                        vm.indice--;
                        vm.controlador.processaEntidade = false;
                        if (vm.indice === 0) {
                            vm.controlador.primeiraEntidade = true;
                        }
                    }
                }, 250);

                if (angular.isDefined(vm.anterior)) {
                    vm.anterior();
                }
            }

            function proxima() {
                vm.controlador.processaEntidade = true;
                $timeout(function () {
                    if (vm.indice < vm.entidades.length - 1) {
                        vm.controlador.primeiraEntidade = false;
                        vm.entidade = vm.entidades[vm.indice + 1];
                        vm.indice++;
                        vm.controlador.processaEntidade = false;
                        if (vm.indice === vm.entidades.length - 1) {
                            vm.controlador.ultimaEntidade = true;
                        }
                    }
                }, 250);

                if (angular.isDefined(vm.proxima)) {
                    vm.proxima();
                }
            }

            function ultima() {
                vm.controlador.processaEntidade = true;
                $timeout(function () {
                    vm.indice = vm.entidades.length - 1;
                    vm.entidade = vm.entidades[vm.entidades.length - 1];
                    vm.controlador.primeiraEntidade = false;
                    vm.controlador.ultimaEntidade = true;
                    vm.controlador.processaEntidade = false;
                }, 250);

                if (angular.isDefined(vm.ultima)) {
                    vm.ultima();
                }
            }

            function listarTodasEntidades() {
                if (!vm.controlador.listarTodasEntidades) {
                    vm.controleForm.pesquisarDatatable = true;
                    vm.controlador.listarTodasEntidades = true;
                    vm.controleForm.listarTodasEntidades = true;
                    vm.textoExibido = vm.controleTextoAExibir.listarTodasEntidades;
                    vm.buttonSelecionado = "listarTodos";

                    if (!$rootScope.tamanhoTelaDesktop) {
                        $mdSidenav('sidenav').close();
                    }
                } else {
                    vm.controleForm.pesquisarDatatable = false;
                    vm.controleForm.listarTodasEntidades = false;
                    vm.controlador.listarTodasEntidades = false;
                    vm.buttonSelecionado = null;
                    vm.textoExibido = vm.controleTextoAExibir.pesquisando;

                    if (!$rootScope.tamanhoTelaDesktop) {
                        $mdSidenav('sidenav').close();
                    }
                }
            }

            function abrirSidenav() {
                $mdSidenav('sidenav').toggle();
            }
            /////////////////////////////////////

            // Métodos com Interação com o Controller exterior
            function metodoToolbarPesquisar(entidadeDePesquisa, event) {
                vm.controleForm.entidadesPesquisadas = entidadeDePesquisa;
                metodosInternosToolbar.chamarPesquisa(event, function (success) {
                    if (!success.data.length) {
                        vm.entidades = [success.data];
                        vm.entidade = success.data;
                    } else {
                        vm.entidades = success.data;
                        vm.entidade = vm.entidades[0];
                    }
                    if (angular.isDefined(vm.toolbarPesquisar)) {
                        vm.toolbarPesquisar();
                    }
                    vm.toolbar.pesquisar();
                });
            }

            function metodoToolbarAtualizar(event) {
                if (!vm.controleForm.desabilitarMetodoToolbarAtualizar) {
                    metodosInternosToolbar.chamarPesquisa(event, function (success) {
                        if (angular.isDefined(vm.toolbarAtualizar)) {
                            vm.toolbarAtualizar();
                        }
                        vm.entidades = success.data;
                        vm.entidade = success.data[vm.indice];
                        vm.indice < vm.entidades.length - 1 ? vm.controlador.ultimaEntidade = false : vm.controlador.ultimaEntidade = true;
                    });
                } else {
                    vm.atualizarEntidadeNoController();
                }
            }

            function metodoToolbarSalvar(event) {
                if (vm.controlador.novaEntidade) {
                    promessa = vm.salvar();
                    if (promessa) {
                        metodosInternosToolbar.preLoaderToolbar.inicioProgresso();
                        promessa.then(
                            function (success) {
                                metodosInternosToolbar.preLoaderToolbar.fimProgresso();
                                MdToastService.toastPadrao("Registro cadastrado com sucesso.");
                                vm.entidades.push(success.data);
                                vm.entidade = success.data;
                                vm.indice = vm.entidades.length - 1;
                                vm.toolbar.reverter(true);
                            },
                            function (error) {
                                if (error.data && (typeof error.data.substrituirQuebraDeLinhasParaTagHtml !== "undefined")) {
                                    if (error.data.indexOf("\n") != -1)
                                        MdDialogService.alertPadrao("", event, error.data.substrituirQuebraDeLinhasParaTagHtml());
                                    else
                                        MdDialogService.alertPadrao(error.data, event);
                                }
                                else {
                                    MdDialogService.alertPadrao(error.data, event);
                                }
                                metodosInternosToolbar.preLoaderToolbar.fimProgresso();

                            });
                    }
                }
                else {
                    promessa = vm.editar();
                    if (promessa) {
                        metodosInternosToolbar.preLoaderToolbar.inicioProgresso();
                        promessa.then(
                            function (success) {
                                metodosInternosToolbar.preLoaderToolbar.fimProgresso();
                                vm.entidades[vm.indice] = success.data;
                                MdToastService.toastPadrao("Registro alterado com sucesso.");
                                entidadeTemporaria = success.data;
                                vm.toolbar.reverter();
                            },
                            function (error) {
                                if (error.data && (typeof error.data.substrituirQuebraDeLinhasParaTagHtml !== "undefined")) {
                                    if (error.data.indexOf("\n") != -1)
                                        MdDialogService.alertPadrao("", event, error.data.substrituirQuebraDeLinhasParaTagHtml());
                                    else
                                        MdDialogService.alertPadrao(error.data, event);
                                }
                                else {
                                    MdDialogService.alertPadrao(error.data, event);
                                }

                                metodosInternosToolbar.preLoaderToolbar.fimProgresso();
                            });
                    }
                }
            }

            function metodoToolbarExcluir(entidade, event) {
                MdDialogService.confirmPadraoComEvento("Excluir",
                    'Deseja realmente excluir o registro ?', event,
                    function () {
                        promessa = vm.excluir();
                        if (promessa) {
                            metodosInternosToolbar.preLoaderToolbar.inicioProgresso();
                            promessa.then(
                                function (success) {
                                    metodosInternosToolbar.preLoaderToolbar.fimProgresso();
                                    MdToastService.toastPadrao(success.data);
                                    vm.entidades.splice(vm.entidades.indexOf(entidade), 1);
                                    vm.indice = vm.entidades.length - 1;
                                    entidadeTemporaria = vm.entidades[vm.indice];
                                    vm.toolbar.reverter();
                                },
                                function (error) {
                                    if (typeof error.data.substrituirQuebraDeLinhasParaTagHtml !== "undefined") {
                                        if (error.data.indexOf("\n") != -1)
                                            MdDialogService.alertPadrao("", event, error.data.substrituirQuebraDeLinhasParaTagHtml());
                                        else
                                            MdDialogService.alertPadrao(error.data, event);
                                    }
                                    else {
                                        MdDialogService.alertPadrao(error.data, event);
                                    }

                                    metodosInternosToolbar.preLoaderToolbar.fimProgresso();
                                });
                        }
                    });
            }
            //////////////////////////////////////////////////////////////////

            /* 
              Vericações realizadas quando a diretiva é inicializada    
            */

            if (angular.isUndefined(vm.ngUtilizaNavegacao)) {
                vm.ngUtilizaNavegacao = true;
            }

            if (angular.isUndefined(vm.entidades) || !vm.entidades) {
                vm.entidades = [];
            }

            if (angular.isUndefined(vm.entidade) || !vm.entidade) {
                vm.entidade = {};
            } else {
                vm.controleForm.entidadesPesquisadas = vm.entidade
            }

            vm.tipolayout = vm.ngUtilizaNavegacao ? "space-between center" : "";

            /*
              Condição que verifica se a entidade da diretiva já está preenchida no controller
              caso a condição, já realiza a consulta com base na entidade preenchida do controller
            */
            if (vm.iniciarChamandoPesquisa) {


                /**
                 * Se o parâmetro "habilitarPesquisar" que foi preenchido no controller que está utilizando o toolbar
                 * estiver preenchido será habilitado o estado de pesquisar da toolbar
                 */
                if (vm.entidade.habilitarPesquisar) {
                    vm.toolbar.pesquisar();
                }

                /**
                 * Se o parâmetro "chamarPesquisa" que foi preenchido no controller que está utilizando o toolbar
                 * estiver preenchido será feito uma chamada para api buscando as entidades no banco de dados
                 */

                if (vm.entidade.chamarPesquisa) {
                    vm.metodosToolbar.pesquisar(vm.entidade);
                }


                /**
                 * Se a entidade "chamarInsercao" estiver preenchida será colocado a toolbar em modo de inserção
                 */
                if (vm.entidade.chamarInsercao) {
                    vm.toolbar.inserir()
                }

                /**
                 * Se a entidade "listandoTodasEntidades" estiver preenchida será colocado a toolbar em modo exibição em Tabela
                 */
                if (vm.entidade.listandoTodasEntidades) {
                    vm.toolbar.listarTodasEntidades()
                }
            }
        } // onNit

    } // Controller

    function toolbarDesktopMobileDirective($rootScope) {
        return {
            templateUrl: $rootScope.tamanhoTelaDesktop ? 'app/compartilhado/diretivas/toolbar-mobile-desktop/desktop/toolbar-desktop.html' : 'app/compartilhado/diretivas/toolbar-mobile-desktop/mobile/toolbar-mobile.html',
            scope: {},
            controller: 'ToolbarDesktopMobileController as vm',
            restrict: "AE",
            require: '^form',
            bindToController: {
                iniciarChamandoPesquisa: '=?',
                ngDisabled: '=?',
                ngDisabledBotaoNovaPesquisa: '=?',
                ngDisabledBotaoPesquisar: '=?',
                ngDisabledBotaoSalvar: '=?',
                ngDisabledBotaoReverter: '=?',
                ngDisabledBotaoExcluir: '=?',
                ngDisabledBotaoEditar: '=?',
                ngDisabledBotaoInserir: '=?',
                ngDisabledBotaoAtualizar: '=?',
                ngDisabledBotaoPrimeira: '=?',
                ngDisabledBotaoAnterior: '=?',
                ngDisabledBotaoProxima: '=?',
                ngDisabledBotaoUltima: '=?',
                ngDisabledBotaoListarTodasEntidades: '=?',
                ngDisabledBotaoListarTodasEntidadesEmModoExibicaoTabela: '=?',
                ngUtilizaNavegacao: '=?',
                ngOcultaBotaoNovaPesquisa: '=?',
                ngOcultaBotaoPesquisar: '=?',
                ngOcultaBotaoSalvar: '=?',
                ngOcultaBotaoReverter: '=?',
                ngOcultaBotaoExcluir: '=?',
                ngOcultaBotaoEditar: '=?',
                ngOcultaBotaoInserir: '=?',
                ngOcultaBotaoAtualizar: '=?',
                toolbarNovaPesquisa: '&?',
                toolbarPesquisar: '&?',
                toolbarAtualizar: '&?',
                toolbarReverter: '&?',
                toolbarEditar: '&?',
                toolbarInserir: '&?',
                metodosExternos: '=?',
                entidades: '=?',
                entidade: '=?',
                controleForm: '=?',
                pesquisar: '&?',
                salvar: "&?",
                editar: "&?",
                excluir: "&?",
                atualizarEntidadeNoController: "&?",
                primeira: "&?",
                proxima: "&?",
                anterior: "&?",
                ultima: "&?",
                desabilitarMensagemAoPesquisar: "=?"
            },
            link: function (scope, element, attr, formCtrl) {
                scope.getFormCtrl(formCtrl);
            }
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.diretivas')
        .directive('teste', testeDirective);

    function testeDirective() {
        return {
            restrict: 'A',            
            require: '^ngModel',            
            link: function (scope, element, attrs, ngModelCtrl) {                
                ngModelCtrl.$validators.testando = function (modelValue, viewValue) {
                    console.log(viewValue)
                    return false;
                }
            }
        }
    };

})();

/**
 * Created by nova on 30/09/2016.
 */
(function(){
  'use strict';

  angular
    .module('app.diretivas')
    .controller("PesquisarPorIdentificadorController", PesquisarPorIdentificadorController)
    .directive("pesquisarPorIdentificador", pesquisarPorIdentificadorDirective);

  function PesquisarPorIdentificadorController($linq){
    var vm = this;

    var resultado = {};

    vm.metodoControllerPesquisarPorCodigo = {
      implementarPesquisa : function(implementacao){
        implementacao(vm.codigo);        
      }
    };

    vm.pesquisar = {
      onKeydown: function (event) {
          if (event.key == "Enter") {
            event.target.blur();
          }
      },
      onBlur: function(codigo) {
        console.log(codigo);
        if (angular.isUndefined(vm.implementarNoController)) {
          if(angular.isDefined(vm.listaAPesquisar)) {
            resultado = $linq.Enumerable().From(vm.listaAPesquisar)
              .Where(function (item) {
                return item.identificador == codigo
              }).FirstOrDefault();
            if (resultado != undefined) {
              vm.entidade = resultado.identificador;
              vm.codigo = null;
            }
            else {
              vm.entidade = null;
              vm.codigo = "";
            }
          }
          else{
            console.log("Para realizar a pesquisa pela diretiva é necessário passar a lista à pesquisar e a entidade");
          }

        }
        else{
          vm.implementarNoController();
        }
      }
    };

  }

  function pesquisarPorIdentificadorDirective(){
    return{
      templateUrl: 'app/compartilhado/diretivas/pesquisar-por-identificador/pesquisar-por-identificador.html',
      controller: 'PesquisarPorIdentificadorController as vm',
      restrict: 'E',
      scope:{},
      bindToController: {
        listaAPesquisar: '=?',
        entidade: '=?',
        metodoControllerPesquisarPorCodigo: '=?',
        implementarNoController: '&?',
        ngDisabled: '=?'
      }
    }
  }



})();

(function () {
    'use strict';

    angular
        .module('app.service')
        .service('QuebraLinhasTextareaService', QuebraLinhasTextareaService);


    function QuebraLinhasTextareaService() {

        this.fabricarTipoQuberaLinha = fabricarTipoQuberaLinha;


        var metodosInterno = {
            preencherLinhasQuandoColandoModoComponente: _preencherLinhasQuandoColandoModoComponente,
            preencherLinhasModoComponente: _preencherLinhasModoComponente,
            preencherLinhasQuandoColandoModoColuna: _preencherLinhasQuandoColandoModoColuna,
            preencherLinhasModoColuna: _preencherLinhasModoColuna,
            retonarQuantidadeCaracteres: _retonarQuantidadeCaracteres
        }

        var tamanhosCaracteres = {
            lowercase: undefined,
            uppercase: undefined
        }


        function fabricarTipoQuberaLinha(quebraLinhasTipoColuna, tamanhoCaractereLowercase, tamanhoCaractereUppercase) {
            tamanhosCaracteres.lowercase = tamanhoCaractereLowercase;
            tamanhosCaracteres.uppercase = tamanhoCaractereUppercase;

            if (quebraLinhasTipoColuna) {
                return {
                    preencherLinhasQuandoColando: _preencherLinhasQuandoColandoModoColuna,
                    preencherLinhas: _preencherLinhasModoColuna
                }
            }
            else {
                return {
                    preencherLinhasQuandoColando: _preencherLinhasQuandoColandoModoComponente,
                    preencherLinhas: _preencherLinhasModoComponente
                }
            }
        }


        function _preencherLinhasQuandoColandoModoComponente(caractertesUltimaLinha, linhas, tamanhoCaracteres, tamanhoElemento) {
            for (var i = 0; i < caractertesUltimaLinha.length; i++) {
                tamanhoCaracteres += _retonarQuantidadeCaracteres(caractertesUltimaLinha[i]);

                if (tamanhoCaracteres >= tamanhoElemento) {
                    caractertesUltimaLinha.insert(i, '\n');
                    tamanhoCaracteres = 0;
                }

            }

            var novasLinhas = caractertesUltimaLinha.toString().replace(/,/g, '').split('\n');
            linhas[linhas.length - 1] = novasLinhas[0];
            novasLinhas.splice(0, 1);
            novasLinhas.map(function (item) {
                linhas.push(item);
            });

            return (linhas.toString().replace(/,/g, '\n'));
        }

        function _preencherLinhasModoComponente(caractertesUltimaLinha, tamanhoCaracteres, tamanhoElemento) {
            var retorno = "";
            for (var i = 0; i < caractertesUltimaLinha.length; i++) {

                tamanhoCaracteres += _retonarQuantidadeCaracteres(caractertesUltimaLinha[i]);

                if (tamanhoCaracteres >= tamanhoElemento) {
                    retorno = "\n";
                    break;
                }
            }

            return retorno;
        }

        function _preencherLinhasQuandoColandoModoColuna(caractertesUltimaLinha, linhas, tamanhoCaracteres, tamanhoElemento) {
            for (var i = 0; i < caractertesUltimaLinha.length; i++) {
                tamanhoCaracteres++;

                if (tamanhoCaracteres >= tamanhoElemento) {
                    caractertesUltimaLinha.insert(i, '\n');
                    tamanhoCaracteres = 0;
                }
            }

            var novasLinhas = caractertesUltimaLinha.toString().replace(/,/g, '').split('\n');
            linhas[linhas.length - 1] = novasLinhas[0];
            novasLinhas.splice(0, 1);
            novasLinhas.map(function (item) {
                linhas.push(item);
            });

            return (linhas.toString().replace(/,/g, '\n'));
        }

        function _preencherLinhasModoColuna(caractertesUltimaLinha, tamanhoCaracteres, tamanhoElemento) {
            var retorno = "";
            for (var i = 0; i < caractertesUltimaLinha.length; i++) {
                tamanhoCaracteres++;

                if (tamanhoCaracteres >= tamanhoElemento) {
                    retorno = "\n";
                    break;
                }
            }

            return retorno;
        };

        function _retonarQuantidadeCaracteres(caractere) {            
            if (caractere == caractere.toUpperCase())
                return tamanhosCaracteres.uppercase ? tamanhosCaracteres.uppercase : 11;
            else
                return tamanhosCaracteres.lowercase ? tamanhosCaracteres.lowercase : 10;
        }

    }

})();


(function () {
    'use strict';

    angular
        .module('app.diretivas')
        .directive('quebrarLinhasTextarea', quebrarLinhasTextareaDirective);

    function quebrarLinhasTextareaDirective(QuebraLinhasTextareaService) {
        return {
            restrict: 'A',
            require: "^ngModel",
            link: function (scope, element, attrs, ngModelCtrl) {
                var colandoAtivo = false;
                var servicoQuebraLinhasTextArea = QuebraLinhasTextareaService
                    .fabricarTipoQuberaLinha(attrs.quebrarLinhasTextarea, attrs.tamanhoCaractereLowercase,
                        attrs.tamanhoCaractereUppercase);

                ngModelCtrl.$parsers.push(function (viewValue) {
                    var tamanhoElemento = attrs.quebrarLinhasTextarea ?
                        attrs.quebrarLinhasTextarea :
                        parseInt(element[0].offsetWidth);
                    var tamanhoCaracteres = 0;
                    var linhas = viewValue.split('\n');
                    var caractertesUltimaLinha = linhas[linhas.length - 1].split('')

                    if (colandoAtivo) {
                        viewValue = servicoQuebraLinhasTextArea
                            .preencherLinhasQuandoColando(caractertesUltimaLinha, linhas, tamanhoCaracteres, tamanhoElemento);

                        colandoAtivo = false;
                    } else {
                        viewValue += servicoQuebraLinhasTextArea.
                            preencherLinhas(caractertesUltimaLinha, tamanhoCaracteres, tamanhoElemento);
                    }

                    ngModelCtrl.$setViewValue(viewValue);
                    ngModelCtrl.$render();
                    return viewValue;
                });

                element.bind('keydown', function (event) {
                    if (event.ctrlKey == true && event.key == 'v')
                        colandoAtivo = true;

                    if (ngModelCtrl.$viewValue) {
                        var linhas = ngModelCtrl.$viewValue.split('\n');
                        if (event.keyCode == 8) {
                            if (linhas[linhas.length - 1].length == 0) {
                                element[0].value = element[0].value.substring(0, element[0].value.length - 1);
                            }
                        }
                    }
                });

            }
        }
    }

})();

/**
 * Created by nova on 30/09/2016.
 */
(function () {
    'use strict';

    angular
        .module('app.diretivas')
        .directive("pesquisarPorCodigo", pesquisarPorCodigoDirective);

    function pesquisarPorCodigoDirective($linq) {
        return {
            restrict: 'A',
            require: '^ngModel',
            scope: {
                listaAPesquisar: '=?',
                entidadePesquisada: '=?',
                idProximoComponenteAFocar: '@?'
            },
            link: function (scope, element, attrs, ngModelCtrl) {
                scope.$watch('entidadePesquisada', function (newValue, oldValue) {
                    var resultado = $linq.Enumerable().From(scope.listaAPesquisar)
                        .Where(function (item) {
                            return item.codigo == newValue;
                        }).FirstOrDefault();
                    if (!resultado && !scope.listaAPesquisar && scope.entidadePesquisada) {
                        ngModelCtrl.$setViewValue(scope.entidadePesquisada);
                        ngModelCtrl.$render();
                    }
                    else if (resultado) {
                        ngModelCtrl.$setViewValue(resultado.codigo);
                        ngModelCtrl.$render();
                    }
                    else {
                        ngModelCtrl.$setViewValue(null);
                        ngModelCtrl.$render();
                    }
                });

                element.bind('keydown', function (event) {
                    if (event.key == 'Enter') {
                        event.target.blur();
                        event.stopPropagation();
                    }
                })

                element.bind('blur', function (event) {
                    var resultado = $linq.Enumerable().From(scope.listaAPesquisar)
                        .Where(function (item) {
                            return item.codigo == ngModelCtrl.$viewValue;
                        }).FirstOrDefault();
                    if (resultado) {
                        scope.entidadePesquisada = resultado.codigo;

                        if (scope.idProximoComponenteAFocar) {
                            document.getElementById(scope.idProximoComponenteAFocar).focus();
                        }
                    }
                    else {
                        ngModelCtrl.$setViewValue(null);
                        ngModelCtrl.$render();
                        scope.entidadePesquisada = null;

                        event.target.focus();
                    }

                    event.stopPropagation();
                    event.preventDefault();
                });

            }
        }
    }



})();

app.directive('scrollTopoAoAtualizar', function ($timeout) {
    return {
        restrict: 'A',
        link: function (scope, element, attrs) {
            scope.$watch(attrs.scrollTopoAoAtualizar, function (novoValor, antigoValor) {
                if (novoValor && novoValor !== antigoValor) {
                    $timeout(function () {
                        element[0].scrollTop = 0;
                    });
                }
            }, true);
        }
    };
});

(function () {
    'use strict';

    angular
        .module('app.diretivas')
        .directive('scrollClass', function ($rootScope) {

            return {
                restrict: 'A',
                link: function (scope, element, attr) {
                    /*
                    ** O atributo scrollContainerTag deve ser a div/tag que está com o scroll
                    ** para identificar quando a pagina está ou não sendo "scrollada"
                    */
                    var scrollContainer = $(attr.scrollContainerTag);
                    var isScrolling = false;

                    if ($rootScope.utilizaBotaoScroll) {
                        updateState();
                        scrollContainer.on('scroll', updateState);

                        element.click(function () {
                            scrollContainer.animate({
                                scrollTop: 0
                            }, "slow")
                        });
                    }

                    function updateState() {
                        var newState = scrollContainer.scrollTop() !== 0;
                        if (newState !== isScrolling) {
                            element.toggleClass(attr.scrollClass, newState);
                        }
                        isScrolling = newState;
                    }
                }
            };
        });
}());
/**
 * Created by nova on 29/09/2016.
 */
(function (){
  'use strict';

  angular
    .module('app.diretivas')
    .controller('ProximoCodigoController', ProximoCodigoController)
    .directive('proximoCodigo', proximoCodigoDirective);

  function ProximoCodigoController(ProximoCodigoService, MdDialogService, $log) {
    var vm = this;


    if(angular.isDefined(vm.rota)) {
      vm.gerarProximoCodigo = function (event) {
        if(angular.isDefined(vm.preLoaderToolbar)) {
          vm.preLoaderToolbar.inicioProgresso();
        }
        if(angular.isDefined(vm.ativaPreLoader)){
          vm.ativaPreLoader = true;
        }
        var promessa = ProximoCodigoService.proximoCodigo(vm.rota);
        promessa.then(
          function(success){
            vm.entidadeCodigo = success.data;
            if(angular.isDefined(vm.preLoaderToolbar)) {
              vm.preLoaderToolbar.fimProgresso();
            }
            if(angular.isDefined(vm.ativaPreLoader)){
              vm.ativaPreLoader = false;
            }
          },
          function(error){
            MdDialogService.alertPadrao(error.data, event);
            if(angular.isDefined(vm.preLoaderToolbar)) {
              vm.preLoaderToolbar.fimProgresso();
            }
            if(angular.isDefined(vm.ativaPreLoader)){
              vm.ativaPreLoader = false;
            }
          });
      };
    }
    else{
      $log.error("Para o funcionamento desta diretiva é necessário passar a rota do proximo código");
    }

  }

  function proximoCodigoDirective(){
    return{
      templateUrl: 'app/compartilhado/diretivas/proximo-codigo/proximo-codigo.html',
      controller: 'ProximoCodigoController as vm',
      restrict: 'E',
      scope: {},
      bindToController:{
        rota: '=?',
        entidadeCodigo: '=?',
        preLoaderToolbar: '=?',
        ativaPreLoader: '=?'
      }
    };
  }

})();

(function () {
    'use strict';

    angular
        .module('app.diretivas')
        .controller('ProgressLinearController', ProgressLinearController)
        .directive('progressLinear', progressLinearDirective);

    function ProgressLinearController($scope, $interval) {
        var vm = this;

        vm.metodosInternos = {
            iniciarProgresso: _iniciarProgresso,
            _fimProgresso: _fimProgresso
        }

        if (!vm.mode)
            vm.mdMode = "buffer"
        else
            vm.mdMode = vm.mode;

        $scope.$watch('vm.ngDisabled', function (newValue, oldValue) {
            if (vm.ngDisabled)
                _iniciarProgresso();
            else
                _fimProgresso();
        });

        function _iniciarProgresso() {
            $interval(function () {
                vm.progresso += 3;
                if (vm.progresso > 100)
                    vm.progresso = 0;
            }, 100);
        }

        function _fimProgresso() {
            vm.progresso = 0;
        }
    }

    function progressLinearDirective() {
        return {
            templateUrl: 'app/compartilhado/diretivas/progress-linear/progress-linear.html',
            controller: 'ProgressLinearController as vm',
            restrict: 'E',
            scope: {},
            bindToController: {
                ngDisabled: '=?',
                mode: '@?',
            }
        }
    };

})();

/**
 * Created by nova on 29/09/2016.
 */
(function () {
    'use strict';

    angular
        .module('app.diretivas')
        .service('PgToolbarService', PgToolbarService)

    function PgToolbarService($interval, MdDialogService, ServicosGenericoService) {

        //#region  Data

        var _funcaoInterval = undefined;
        var _entidadeDeEnvio = null;

        //#endregion

        //////////////////////////// Definição dos Métodos //////////////////////////////////////////
        this.iniciarPreLoaderToolbar = iniciarPreLoaderToolbar;
        this.finalizarPreLoaderToolbar = finalizarPreLoaderToolbar;
        this.atualizarEntidadeDeEnvio = atualizarEntidadeDeEnvio;
        this.atualizarEntidadeDeEnvioQuandoRegistroForExcluido = atualizarEntidadeDeEnvioQuandoRegistroForExcluido;
        this.atualizarBotoesDeNavegacao = atualizarBotoesDeNavegacao;
        this.definirPosicaoEntidadeDeEnvio = definirPosicaoEntidadeDeEnvio;
        this.exibirAlertaDeErro = exibirAlertaDeErro;
        this.armazenarEntidadeDeEnvio = armazenarEntidadeDeEnvio;
        this.recuperarEntidadeDeEnvio = recuperarEntidadeDeEnvio;
        this.executarFuncaoPorParametro = executarFuncaoPorParametro;
        //////////////////////////// FIM Definição dos Métodos //////////////////////////////////////////        

        //////////////////////////// Implementação dos Métodos ////////////////////////////////////////////        

        /**
         * Método para iniciar o pré-loader da toolbar
         * @param {object} controladorToolbar controladorToolbar
         * @param {object} controladorPreloader controladroPrealoder
         */
        function iniciarPreLoaderToolbar(controladorToolbar, controladorPreloader) {
            if (controladorToolbar && controladorPreloader) {
                controladorPreloader.progresso = 0;
                controladorToolbar.emProgresso = true;
                _funcaoInterval = $interval(function () {
                    controladorPreloader.progresso += 3;
                    if (controladorPreloader.progresso > 100)
                        controladorPreloader.progresso = 0;

                }, 100);
            }
        }

        /**
         * Método para finalizar o pré-loader da toolbar
         * @param {object} controladorToolbar controladorToolbar
         * @param {object} controladorPreloader controladroPrealoder
         */
        function finalizarPreLoaderToolbar(controladorToolbar, controladorPreloader) {
            if (controladorToolbar && controladorPreloader) {
                controladorPreloader.progresso = 0;
                controladorToolbar.emProgresso = false;
                $interval.cancel(_funcaoInterval);
                _funcaoInterval = undefined;
            }
        }


        /**
         * Método para atualizar os campos da entidade de envio
         * @param {object} entidadeDeEnvio vm.entidadeDeEnvio
         * @param {object} novaEntidadeDeEnvio succes.data
         */
        function atualizarEntidadeDeEnvio(entidadeDeEnvio, novaEntidadeDeEnvio) {
            if (entidadeDeEnvio && novaEntidadeDeEnvio) {
                entidadeDeEnvio.intPosicao = novaEntidadeDeEnvio.intPosicao;
                entidadeDeEnvio.intTamanhoPagina = novaEntidadeDeEnvio.intTamanhoPagina;
                entidadeDeEnvio.intTotalResultado = novaEntidadeDeEnvio.intTotalResultado;
            }
        }

        /**
         * Método para atualizar a entidade de envio quando é excluído um registro         
         * @param {object} entidadeDeEnvio
         * Retorno boolean: 'true' se entidadeDeEnvio.intTotalResultado >= 1
         *                  'false' se entidadeDeEnvio.intTotalResultado < 1
         */
        function atualizarEntidadeDeEnvioQuandoRegistroForExcluido(entidadeDeEnvio) {
            entidadeDeEnvio.intTotalResultado--;
            if (entidadeDeEnvio.intTotalResultado >= 1) {
                if (entidadeDeEnvio.intPosicao > 1)
                    entidadeDeEnvio.intPosicao--;

                return true;
            }
            else
                return false;
        }

        /**
         * Método para autlizar o campo clsEntidade com uma nova entidade de pesquisa
         * @param {object} entidadeDeEnvio vm.entidadeDeEnvio
         * @param {object} novaEntidadeDePesquisa vm.entidade entidade do controller
         */
        function atualizarEntidadeDeEnvioComNovaEntidadeParaPesquisa(entidadeDeEnvio, novaEntidadeDePesquisa) {
            if (entidadeDeEnvio && novaEntidadeDePesquisa)
                entidadeDeEnvio.clsEntidade = novaEntidadeDePesquisa;
        }

        /**
         * Método para atualizar os botões de navegações verificando qual é a posição para habiltiar ou desabilitar os botões:
         * primeira anterior proxima e ultima
         * @param {object} entidadeDeEnvio 
         * @param {object} controladorToolbar 
         */
        function atualizarBotoesDeNavegacao(entidadeDeEnvio, controladorToolbar) {
            if (entidadeDeEnvio && controladorToolbar) {
                if (entidadeDeEnvio.intPosicao > 1)
                    controladorToolbar.primeiraEntidade = false;
                else if (entidadeDeEnvio.intPosicao <= 1)
                    controladorToolbar.primeiraEntidade = true;

                if (entidadeDeEnvio.intPosicao >= entidadeDeEnvio.intTotalResultado)
                    controladorToolbar.ultimaEntidade = true;
                else if (entidadeDeEnvio.intPosicao < entidadeDeEnvio.intTotalResultado)
                    controladorToolbar.ultimaEntidade = false;
            }
        }


        /**
         * Defini qual será o valor da posição da entidade de envio, 
         * com base na no botão de navegação pressionado
         * @param {object} entidadeDeEnvio Entidade de Envio
         * @param {string} direcao botão pressionado pelo usuário
         */
        function definirPosicaoEntidadeDeEnvio(entidadeDeEnvio, direcao) {
            if (entidadeDeEnvio && direcao) {
                if (direcao == "primeira")
                    entidadeDeEnvio.intPosicao = 1;
                else if (direcao == 'anterior')
                    entidadeDeEnvio.intPosicao--;
                else if (direcao == "proxima")
                    entidadeDeEnvio.intPosicao++;
                else if (direcao == "ultima")
                    entidadeDeEnvio.intPosicao = entidadeDeEnvio.intTotalResultado;
                else
                    alert("direção passada como parâmetro na navegação não existe");
            }
        }

        /**
         * Método que exibi o alerta de erro padrão verificando se existe quebra de linha no texto assim exibindo as linhas quebradas 
         * caso exista ou em forma de titulo caso não exista
         * @param {object} error error
         * @param {event} event event do botão
         */
        function exibirAlertaDeErro(error, event) {
            ServicosGenericoService.exibirAlertaDeErro(error, event);
        }

        /**
         * Método para armazenar em vm.entidadeDeEnvio.clsEntidade a "entidadeDePesquisa" ou não
         * verificando a condição do verificaodr "verificacaoNaoArmazenarEntidadeDePesquisa" :
         *  false = vm.entidadeDeEnvio.clsEntidade = entidadeDePesquisa
         *  true = entidadde de pesquisa não recebe nenhum valor
         * @param {object} entidadeDeEnvio vm.entidadeDeEnvio
         * @param {bool} verificador 
         */
        function armazenarEntidadeDeEnvio(entidadeDeEnvio, verificacaoNaoArmazenarEntidadeDePesquisa, entidadeDePesquisa) {
            if (!verificacaoNaoArmazenarEntidadeDePesquisa) {
                entidadeDeEnvio.clsEntidade = entidadeDePesquisa;
            }
            _entidadeDeEnvio = entidadeDeEnvio;
        }

        /**
         * Método que retorna a entidade de envio
         */
        function recuperarEntidadeDeEnvio() {
            return _entidadeDeEnvio;
        }

        /**
         * Métodos que exceuta um função passada como parâmetro
         * Primeiro tenta executar a função por sua referência, caso contrário somente executára a função
         * @param {funcao} funcao 
         * @param {valores} valores a ser passado como parâmetro
         */
        function executarFuncaoPorParametro(funcao, valores) {
            if (typeof funcao !== 'function') {
                throw new Error("O parâemetro funcão deve ser do tipo function");
            }
            try {
                funcao()(valores);
            }
            catch (exception) {
                funcao();
            }
        }
        //////////////////////////// Fim Implementação dos Métodos ////////////////////////////////////////////
    }


})();

(function () {
    'use strict'

    angular.module('app.factory', []);

})();

(function () {
    'use strict';

    angular
        .module('app.factory')
        .factory('PgToolbarFactory', PgToolbarFactory);

    function PgToolbarFactory(DataTableConfigPadrao, $rootScope, urlApi) {

        //////////////////////////// Definição dos Métodos //////////////////////////////////////////
        return {
            construirEntidadeDeEnvioPadrao: construirEntidadeDeEnvioPadrao,
            verificarUtilizacaoNavegacao: verificarUtilizacaoNavegacao,
            definirTipoLayout: definirTipoLayout,
            construirPathHtmlComponentes: construirPathHtmlComponentes,
            construirTextosAExibir: construirTextosAExibir,
            preDefinirControladoresDaToolbar: preDefinirControladoresDaToolbar,
            predefinirControladorPreLoader: predefinirControladorPreLoader
        }
        //////////////////////////// FIM Definição dos Métodos //////////////////////////////////////////        

        //////////////////////////// Implementação dos Métodos ////////////////////////////////////////////        

        /**
         * Método que constroí a entidade genérica padrão para se trabalhar com a toolbar de paginação
         */
        function construirEntidadeDeEnvioPadrao(entidadeDeEnvio) {
            return {
                intPosicao: 1,
                intTamanhoPagina: 1,
                intTotalResultado: 0,
                clsEntidade: entidadeDeEnvio ? entidadeDeEnvio : {}
            }
        }


        /**
         * Verifica se a toolbar irá utilizar navegação
         * Por default utilizaNavegacao será false assim retornará true
         * @param {bool} utilizaNavegacao 
         */
        function verificarUtilizacaoNavegacao(utilizaNavegacao) {
            if (!utilizaNavegacao)
                return true;
            else
                return false;
        }

        /**
         * Defini o tipo de layout que a toolbar irá ter
         * pode default seu layout será "space-between center"
         * @param {string} tipoLayout 
         */
        function definirTipoLayout(tipoLayout) {
            if (tipoLayout)
                return tipoLayout;
            else
                return "space-between center";
        }

        /**
         * Defini todos os paths dos componenetes
         */
        function construirPathHtmlComponentes() {
            return {
                botaoNovaPesquisa: 'app/compartilhado/diretivas/pg-toolbar/componentes/pg-toolbar-botao-nova-pesquisa.html',
                botaoPesquisar: 'app/compartilhado/diretivas/pg-toolbar/componentes/pg-toolbar-botao-pesquisar.html',
                botaoSalvar: 'app/compartilhado/diretivas/pg-toolbar/componentes/pg-toolbar-botao-salvar.html',
                botaoReverter: 'app/compartilhado/diretivas/pg-toolbar/componentes/pg-toolbar-botao-reverter.html',
                botaoExcluir: 'app/compartilhado/diretivas/pg-toolbar/componentes/pg-toolbar-botao-excluir.html',
                botaoEditar: 'app/compartilhado/diretivas/pg-toolbar/componentes/pg-toolbar-botao-editar.html',
                botaoInserir: 'app/compartilhado/diretivas/pg-toolbar/componentes/pg-toolbar-botao-inserir.html',
                botaoAtualizar: 'app/compartilhado/diretivas/pg-toolbar/componentes/pg-toolbar-botao-atualizar.html',
                botaoClonar: 'app/compartilhado/diretivas/pg-toolbar/componentes/pg-toolbar-botao-clonar.html',
                listarTodasEntidades: 'app/compartilhado/diretivas/pg-toolbar/componentes/pg-toolbar-botao-listar-todas-entidades.html',
                navegacao: {
                    botaoPrimeira: 'app/compartilhado/diretivas/pg-toolbar/componentes/pg-toolbar-navegacao-botao-primeira.html',
                    botaoAnterior: 'app/compartilhado/diretivas/pg-toolbar/componentes/pg-toolbar-navegacao-botao-anterior.html',
                    botaoProxima: 'app/compartilhado/diretivas/pg-toolbar/componentes/pg-toolbar-navegacao-botao-proxima.html',
                    botaoUltima: 'app/compartilhado/diretivas/pg-toolbar/componentes/pg-toolbar-navegacao-botao-ultima.html'
                },
                sidenav: {
                    botaoSidenav: 'app/compartilhado/diretivas/pg-toolbar/componentes/sidenav/pg-toolbar-botao-sidenav.html',
                    sidenav: 'app/compartilhado/diretivas/pg-toolbar/componentes/sidenav/pg-toolbar-mobile-sidenav.html',
                }
            }
        }

        /**
         * Defini todos os textos que serão exibidos
         */
        function construirTextosAExibir() {
            return {
                aguardando: "Aguardando",
                novaPesquisa: "Nova Pesquisa",
                pesquisando: "Exibindo",
                editando: "Editando",
                inserindo: "Inserindo",
                listarTodasEntidades: "Exibindo em modo Tabela"
            }
        }

        /**
         * Pré-defini os controladores padrão da toolbar
         */
        function preDefinirControladoresDaToolbar() {
            return {
                pesquisaAtiva: false,
                primeiraEntidade: false,
                ultimaEntidade: false,
                editarAtivo: false,
                inserirAtivo: false,
                listarTodasEntidades: false,
                emProgresso: false,
                entidadeTemporaria: {}
            }
        }

        /**
         * Pre-defini controladores padrão pre-loader
         */
        function predefinirControladorPreLoader() {
            return {
                progresso: 0
            }
        }
        //////////////////////////// Fim Implementação dos Métodos ////////////////////////////////////////////
    }

})();

/**
 * Created by nova on 29/09/2016.
 */
(function () {
    'use strict';

    angular
        .module('app.diretivas')
        .controller('PgToolbarController', PgToolbarController)
        .directive('pgToolbar', pgToolbarDirective);

    function PgToolbarController($log, $scope, $rootScope, $mdSidenav, $window, PgToolbarService, PgToolbarFactory, MdDialogService, MdToastService, DatatableFactory) {
        var vm = this;

        $scope.obterControleFormulario = function (formCtrl) {
            vm.form = formCtrl;
        };


        /////////////////////////////////////////////////// DATA ///////////////////////////////////////////////////////
        vm.tela = $window;
        vm.larguraPadraoMobileTela = 600;

        // verifica se a entidade foi declarada no controller externo, caso não seja elas são definidas
        if (!vm.entidade)
            vm.entidade = {}
        if (!vm.entidades)
            vm.entidades = [];

        vm.entidadeDeEnvio = PgToolbarFactory.construirEntidadeDeEnvioPadrao();

        vm.tempoDelay = 350;
        var primeiraConsulta = false;

        vm.tipolayout = PgToolbarFactory.definirTipoLayout(vm.ngTipoLayout);
        vm.htmlComponente = PgToolbarFactory.construirPathHtmlComponentes();
        vm.textoExibido = PgToolbarFactory.construirTextosAExibir().aguardando;

        vm.controladorToolbar = PgToolbarFactory.preDefinirControladoresDaToolbar();
        vm.controladorPreLoader = PgToolbarFactory.predefinirControladorPreLoader();

        init();
        /////////////////////////////////////////////////// FIM DATA ///////////////////////////////////////////////////////

        /////////////////////////////////////////////////// DEFINIÇÃO MÉTODOS ///////////////////////////////////////////////////////

        var metodosInternos = {
            _definirStatusToolbarAposInsercaoOuEdicao: _definirStatusToolbarAposInsercaoOuEdicao
        }

        vm.metodosExternos = {
            metodoControladorExternoListarTodasEntidades: metodoControladorListarTodasEntidades,
            metodoControladorListarTodasEntidadesPorObjeto: metodoControladorListarTodasEntidadesPorObjeto,
            metodoAcaoExternaEditarEntidade: metodosAcaoAEditar,
            metodosAcaoAtualizar: metodosAcaoAtualizar,
            metodoAcaoExternoCriar: metodoControladorSalvar,
            metodosStatus: metodosStatus
        };

        vm.metodosControladores = {
            metodoControladorAtualizarFormulario: metodoControladorAtualizarFormulario,
            metodoControladorNovaPesquisa: metodoControladorNovaPesquisa,
            metodoControladorPesquisar: metodoControladorPesquisar,
            metodoControladorSalvar: metodoControladorSalvar,
            metodoControladorInserir: metodoControladorInserir,
            metodoControladorEditar: metodoControladorEditar,
            metodoControladorReverter: metodoControladorReverter,
            metodoControladorListarTodasEntidades: metodoControladorListarTodasEntidades,
            metodoControladorAbrirSidenav: metodoControladorAbrirSidenav,
            metodoControladorFecharSidenav: metodoControladorFecharSidenav,
            metodoControladorClonar: metodoControladorClonar
        };

        vm.metodosAcao = {
            metodoAcaoNavegacao: metodoAcaoNavegacao,
            metodoAcaoPesquisar: metodoAcaoPesquisar,
            metodosAcaoAtualizar: metodosAcaoAtualizar,
            metodosAcaoCriar: metodosAcaoCriar,
            metodosAcaoAEditar: metodosAcaoAEditar,
            metodosAcaoExcluir: metodosAcaoExcluir
        };

        /////////////////////////////////////////////////// FIM DEFINIÇÃO MÉTODOS ///////////////////////////////////////////////////////

        /////////////////////////////////////////////////// IMPLEMENTAÇÃO MÉTODOS INIT E WATCHS /////////////////////////////////////////////////

        /**
         * Método inciializador
         */
        function init() {
            if (vm.iniciarChamandoPesquisa) {
                metodoAcaoPesquisar(vm.entidade, null, false);
            }
            else if (vm.iniciarHabilitandoModoPesquisa) {
                metodoControladorPesquisar();
            }
            else if (vm.iniciarHabilitandoInsercao) {
                metodoControladorInserir(null, null);
            }


        }

        /////////////////////////////////////////////////// FIM IMPLEMENTAÇÃO MÉTODOS INIT E WATCHS /////////////////////////////////////////////

        /////////////////////////////////////////////////// IMPLEMENTAÇÃO MÉTODOS INTERNOS //////////////////////////////////////////////////////

        function _definirStatusToolbarAposInsercaoOuEdicao() {
            if (vm.definirStatusToolbarParaInsercaoAposInsercao && vm.definirStatusToolbarParaEdicaoAposEdicao)
                throw new Error("Somente uma expressão 'definirStatusToolbarParaInsercaoAposInsercao' ou 'definirStatusToolbarParaEdicaoAposEdicao' deve ser utilizado por vez");

            metodoControladorPesquisar();

            if (vm.definirStatusToolbarParaInsercaoAposInsercao)
                metodoControladorInserir()
            else if (vm.definirStatusToolbarParaEdicaoAposEdicao)
                metodoControladorEditar();
            else {
                vm.controladorToolbar.editarAtivo = false;
                vm.controladorToolbar.inserirAtivo = false;
            }
        }

        /////////////////////////////////////////////////// FIM IMPLEMENTAÇÃO MÉTODOS INTERNOS //////////////////////////////////////////////////

        /////////////////////////////////////////////////// IMPLEMENTAÇÃO  MÉTODOS CONTROLADORES /////////////////////////////////////////////////

        /**
         * Método para reconfigurar as definições do formulário
         */
        function metodoControladorAtualizarFormulario() {
            if (vm.form) {
                vm.form.$setUntouched();
                vm.form.$setPristine();
            }
        }

        /**
         * Método controlador chamado quando é pressionado o botão de Nova Pesquisa setando os valores inicias novamente
         */
        function metodoControladorNovaPesquisa() {
            vm.entidade = {};
            vm.entidades = [];
            $rootScope.desabilitarMudancaDeEstadoDaAplicacao = false;

            vm.entidadeDeEnvio = PgToolbarFactory.construirEntidadeDeEnvioPadrao();

            vm.controladorToolbar = PgToolbarFactory.preDefinirControladoresDaToolbar();
            vm.controladorPreLoader = PgToolbarFactory.predefinirControladorPreLoader()
            vm.textoExibido = PgToolbarFactory.construirTextosAExibir().novaPesquisa;

            metodoControladorAtualizarFormulario();

            metodoControladorFecharSidenav();

            if (vm.metodoExternoAcaoNovaPesquisa)
                vm.metodoExternoAcaoNovaPesquisa();
        }

        /**
         * Método controlador chamado quando é pressioando o botão de Pesquisar
         */
        function metodoControladorPesquisar() {
            $rootScope.desabilitarMudancaDeEstadoDaAplicacao = false;

            vm.controladorToolbar.pesquisaAtiva = true;

            vm.textoExibido = PgToolbarFactory.construirTextosAExibir().pesquisando;
        }

        /**
         * Método controlador chamando quando é pressioando o botão salvar da toolbar
         * Verificando se é um inserção ou edição assim chamando a ação correta para inserir ou editar
         * o registro na API
         * @param {object} entidade entidade do controller
         */
        function metodoControladorSalvar(entidade) {
            if (vm.controladorToolbar.inserirAtivo)
                metodosAcaoCriar(entidade)
            else if (vm.controladorToolbar.editarAtivo)
                metodosAcaoAEditar(entidade)
        }

        /**
         * Método controlado chamado quando o botão Inserir é pressionado alterando a toolbar para o estado de Inserção
         * @param {object} entidade entidade do controller
         * @param {event} event event do botão
         */
        function metodoControladorInserir(entidade, event) {
            if (vm.definirStatusToolbarParaInsercaoAposInsercao)
                vm.definirStatusToolbarParaInsercaoAposInsercao = false;

            $rootScope.desabilitarMudancaDeEstadoDaAplicacao = true;
            metodoControladorAtualizarFormulario();
            metodoControladorFecharSidenav();

            vm.controladorToolbar.entidadeTemporaria = angular.copy(vm.entidade);

            vm.controladorToolbar.inserirAtivo = true;
            vm.textoExibido = PgToolbarFactory.construirTextosAExibir().inserindo;

            if (vm.preDefinirCamposParaInsercao)
                vm.preDefinirCamposParaInsercao();
            else
                vm.entidade = {};
        }

        /**
         * Método controlador que chamado quando o botão editar é pressioando alterando
         * o estado da toolbar para Editando
         * @param {object} entidade  entidade do controller
         */
        function metodoControladorEditar(entidade) {
            if (vm.definirStatusToolbarParaEdicaoAposEdicao)
                vm.definirStatusToolbarParaEdicaoAposEdicao = false;

            $rootScope.desabilitarMudancaDeEstadoDaAplicacao = true;
            metodoControladorAtualizarFormulario();
            metodoControladorFecharSidenav();

            vm.controladorToolbar.entidadeTemporaria = angular.copy(entidade);
            vm.controladorToolbar.editarAtivo = true;
            vm.textoExibido = PgToolbarFactory.construirTextosAExibir().editando;

            if (vm.preDefinirCamposParaEdicao)
                vm.preDefinirCamposParaEdicao();
        }

        /**
         * Método controlado chamado quando o botão Reverter da toolbar é pressioando,
         * assim retornando a toolbar para seu estado anterior
         */
        function metodoControladorReverter() {
            $rootScope.desabilitarMudancaDeEstadoDaAplicacao = false;
            metodoControladorAtualizarFormulario();

            if (!vm.controladorToolbar.pesquisaAtiva) {
                if (!primeiraConsulta)
                    vm.textoExibido = PgToolbarFactory.construirTextosAExibir().aguardando;
                else
                    vm.textoExibido = PgToolbarFactory.construirTextosAExibir().novaPesquisa;

                vm.entidade = angular.copy(vm.controladorToolbar.entidadeTemporaria);
            }
            else if (vm.controladorToolbar.pesquisaAtiva) {
                vm.textoExibido = PgToolbarFactory.construirTextosAExibir().pesquisando;

                vm.entidade = angular.copy(vm.controladorToolbar.entidadeTemporaria);
            }

            vm.controladorToolbar.inserirAtivo = false;
            vm.controladorToolbar.editarAtivo = false;
            vm.controladorToolbar.entidadeTemporaria = {};

            if (vm.metodoExternoAcaoReverter)
                vm.metodoExternoAcaoReverter();
        }

        /**
         * Método controlado chamado quando o botão listar todas entidades é pressioando
         * alterando a forma de exibição da tabela para modo tabela ou alterando novamente para o modo
         * de exibição tradional
         * @param {event} event
         */
        function metodoControladorListarTodasEntidades(event, posicaoEntidadeSelecionada) {
            metodoControladorFecharSidenav();
            DatatableFactory.destruirTabela()


            if (!vm.controladorToolbar.listarTodasEntidades) {
                vm.controladorToolbar.listarTodasEntidades = true;
                vm.textoExibido = PgToolbarFactory.construirTextosAExibir().listarTodasEntidades;

                if (vm.construirDtOptions)
                    vm.construirDtOptions();
            }
            else {
                vm.controladorToolbar.listarTodasEntidades = false;
                vm.textoExibido = PgToolbarFactory.construirTextosAExibir().pesquisando;
                vm.campoPesquisar = "";

                if (posicaoEntidadeSelecionada) {
                    vm.entidadeDeEnvio.intPosicao = posicaoEntidadeSelecionada;
                    metodoAcaoPesquisar(null, null, true)
                }
            }
        }

        function metodoControladorListarTodasEntidadesPorObjeto(event, objeto) {
            metodoControladorFecharSidenav();
            DatatableFactory.destruirTabela()


            if (!vm.controladorToolbar.listarTodasEntidades) {
                vm.controladorToolbar.listarTodasEntidades = true;
                vm.textoExibido = PgToolbarFactory.construirTextosAExibir().listarTodasEntidades;

                if (vm.construirDtOptions)
                    vm.construirDtOptions();
            }
            else {
                vm.controladorToolbar.listarTodasEntidades = false;
                vm.textoExibido = PgToolbarFactory.construirTextosAExibir().pesquisando;
                vm.campoPesquisar = "";
                vm.entidadeDeEnvio.clsEntidade = objeto;
                vm.entidadeDeEnvio.intPosicao = 0;
                metodoAcaoPesquisar(vm.entidadeDeEnvio, null, true)
            }
        }

        /**
         * Método para abrir o sidenav quando estiver em mobile
         */
        function metodoControladorAbrirSidenav() {
            if (vm.tela.screen.width < vm.larguraPadraoMobileTela)
                $mdSidenav('pg-toolbar-sidenav').toggle();
        }

        /**
         * Método que fecha o sidenav quando é chamado
         */
        function metodoControladorFecharSidenav() {
            if (vm.tela.screen.width < vm.larguraPadraoMobileTela)
                $mdSidenav('pg-toolbar-sidenav').close();
        }

        function metodoControladorClonar(entidade, event) {
            $rootScope.desabilitarMudancaDeEstadoDaAplicacao = true;
            metodoControladorAtualizarFormulario();
            metodoControladorFecharSidenav();

            vm.controladorToolbar.entidadeTemporaria = angular.copy(vm.entidade);
            vm.controladorToolbar.entidadeClonada = angular.copy(entidade);
            vm.entidade = {};
            vm.controladorToolbar.inserirAtivo = true;
            vm.textoExibido = PgToolbarFactory.construirTextosAExibir().inserindo;

            if (vm.definirCamposClonados)
                vm.definirCamposClonados();
        }
        /////////////////////////////////////////////////// FIM IMPLEMENTAÇÃO  MÉTODOS CONTROLADORES /////////////////////////////////////////////

        /////////////////////////////////////////////////// IMPLEMENTAÇÃO  MÉTODOS AÇÃO /////////////////////////////////////////////////

        /**
         * Método que navega entre as entidades sempre realizando uma pesquisa para API
         * @param {string} direcao 'primeira', 'anterior', 'proxima', 'ultima'
         */
        function metodoAcaoNavegacao(direcao) {
            if (angular.isDefined(vm.acaoPesquisar)) {
                var posicaoTemporaria = vm.entidadeDeEnvio.intPosicao;

                if (vm.metodoExternoAcaoNavegacao)
                    vm.metodoExternoAcaoNavegacao();

                PgToolbarService.definirPosicaoEntidadeDeEnvio(vm.entidadeDeEnvio, direcao);
                PgToolbarService.iniciarPreLoaderToolbar(vm.controladorToolbar, vm.controladorPreLoader);

                var promessa = vm.acaoPesquisar();
                if (promessa) {
                    promessa.then(
                        function (success) {
                            if (vm.metodoExternoAlterarEntidadeExternamente) {
                                PgToolbarService.executarFuncaoPorParametro(vm.metodoExternoAlterarEntidadeExternamente, success.data);
                            }
                            else if (!success.data.atualizadoNoController) {
                                vm.entidade = success.data.lstResultado[0];
                                vm.entidades = success.data.lstResultado;
                            }

                            PgToolbarService.atualizarBotoesDeNavegacao(success.data, vm.controladorToolbar);
                            PgToolbarService.atualizarEntidadeDeEnvio(vm.entidadeDeEnvio, success.data);
                            PgToolbarService.finalizarPreLoaderToolbar(vm.controladorToolbar, vm.controladorPreLoader);
                            if (vm.acaoPosPaginacao) {
                                vm.acaoPosPaginacao();
                            }
                        },
                        function (error) {
                            vm.entidadeDeEnvio.intPosicao = posicaoTemporaria;
                            PgToolbarService.finalizarPreLoaderToolbar(vm.controladorToolbar, vm.controladorPreLoader);
                        });
                }
                else
                    PgToolbarService.finalizarPreLoaderToolbar(vm.controladorToolbar, vm.controladorPreLoader);
            }
        }

        /**
         * Método utilizado para realizar a pesquisa com base na entidade de pesquisa
         * @param {object} entidade entidade de pesquisa
         * @param {event} event event do botão
         * @param {boolean} naoArmazenarEntidadeDePesquisa booleano para verificar se é para armazenar o ou não a entidade de pesquisa
         */
        function metodoAcaoPesquisar(entidade, event, naoArmazenarEntidadeDePesquisa) {
            if (angular.isDefined(vm.acaoPesquisar)) {

                PgToolbarService.armazenarEntidadeDeEnvio(vm.entidadeDeEnvio, naoArmazenarEntidadeDePesquisa, entidade);

                PgToolbarService.iniciarPreLoaderToolbar(vm.controladorToolbar, vm.controladorPreLoader);
                var promessa = vm.acaoPesquisar();
                if (promessa) {
                    promessa.then(
                        function (success) {
                            if (success.data && success.data.lstResultado && success.data.lstResultado.length > 0) {
                                if (vm.metodoExternoAlterarEntidadeExternamente) {
                                    PgToolbarService.executarFuncaoPorParametro(vm.metodoExternoAlterarEntidadeExternamente, success);
                                }
                                else if (!success.data.atualizadoNoController) {
                                    vm.entidade = success.data.lstResultado[0];
                                    vm.entidades = success.data.lstResultado;
                                }
                                primeiraConsulta = true;

                                metodoControladorPesquisar();

                                PgToolbarService.atualizarBotoesDeNavegacao(success.data, vm.controladorToolbar);
                                PgToolbarService.atualizarEntidadeDeEnvio(vm.entidadeDeEnvio, success.data);
                            }
                            else {
                                MdDialogService.alertPadrao("Atenção!", null, "Não foi encontrado nenhum registro para a consulta realizada.");
                                metodoControladorReverter()
                            }
                            PgToolbarService.finalizarPreLoaderToolbar(vm.controladorToolbar, vm.controladorPreLoader);
                            if (vm.acaoPosPesquisar) {
                                vm.acaoPosPesquisar();
                            }
                        },
                        function (error) {
                            PgToolbarService.exibirAlertaDeErro(error, event);
                            vm.entidadeDeEnvio = PgToolbarFactory.construirEntidadeDeEnvioPadrao();
                            PgToolbarService.finalizarPreLoaderToolbar(vm.controladorToolbar, vm.controladorPreLoader);
                        });
                }
                else
                    PgToolbarService.finalizarPreLoaderToolbar(vm.controladorToolbar, vm.controladorPreLoader);
            }
            else {
                $log.warn("Para o funcionamento da ação do botão pesquisar.\n" +
                    "É necessário passar uma função pelo parâmetro 'acao-pesquisar'")
            }
        }

        function metodosStatus(status) {
            vm.textoExibido = status;
        }

        /**
         * Método utilizado para recarregar a consulta realizado na pesquisa
         */
        function metodosAcaoAtualizar(event) {
            if (vm.controladorAtualizarEntidadeExternamente) {
                if (vm.metodoExternoAtualizarEntidadeExternamente) {
                    vm.metodoExternoAtualizarEntidadeExternamente();
                }
                else {
                    $log.warn("Para o funcionamento correto da atualizar a entidade externamente.\n" +
                        "É necessário definir passar uma função pelo parâmetro 'metodo-externo-atualizar-entidade-externamente'")
                }
            }
            else {
                if (angular.isDefined(vm.acaoPesquisar)) {
                    metodoControladorFecharSidenav();

                    PgToolbarService.iniciarPreLoaderToolbar(vm.controladorToolbar, vm.controladorPreLoader);
                    var promessa = vm.acaoPesquisar();
                    if (promessa) {
                        promessa.then(
                            function (success) {
                                if (vm.metodoExternoAlterarEntidadeExternamente) {
                                    PgToolbarService.executarFuncaoPorParametro(vm.metodoExternoAlterarEntidadeExternamente, success.data);
                                }
                                else if (!success.data.atualizadoNoController) {
                                    vm.entidade = success.data.lstResultado[0];
                                    vm.entidades = success.data.lstResultado;
                                }

                                PgToolbarService.atualizarBotoesDeNavegacao(success.data, vm.controladorToolbar);
                                PgToolbarService.atualizarEntidadeDeEnvio(vm.entidadeDeEnvio, success.data);
                                PgToolbarService.finalizarPreLoaderToolbar(vm.controladorToolbar, vm.controladorPreLoader);
                            },
                            function (error) {
                                PgToolbarService.exibirAlertaDeErro(error, event);
                                vm.entidadeDeEnvio = PgToolbarFactory.construirEntidadeDeEnvioPadrao();
                                PgToolbarService.finalizarPreLoaderToolbar(vm.controladorToolbar, vm.controladorPreLoader);
                                metodoControladorNovaPesquisa();
                            });
                    }
                    else
                        PgToolbarService.finalizarPreLoaderToolbar(vm.controladorToolbar, vm.controladorPreLoader);
                }
            }
        }

        /**
         * Método utilizado para mandar um requisição para api para Criar um novo registro
         * @param {event} event event do botão
         */
        function metodosAcaoCriar(event) {
            if (angular.isDefined(vm.acaoCriar)) {
                PgToolbarService.iniciarPreLoaderToolbar(vm.controladorToolbar, vm.controladorPreLoader);
                var promessa = vm.acaoCriar();
                if (promessa) {
                    promessa.then(
                        function (success) {
                            if (success && success.data && success.data.definirStatusToolbarParaInsercaoAposInsercao)
                                vm.definirStatusToolbarParaInsercaoAposInsercao = true;

                            if (vm.metodoExternoAlterarEntidadeExternamente) {
                                PgToolbarService.executarFuncaoPorParametro(vm.metodoExternoAlterarEntidadeExternamente, success.data);
                            }
                            else if (!success.data.atualizadoNoController) {
                                vm.entidade = success.data;
                            }

                            _definirStatusToolbarAposInsercaoOuEdicao();
                            MdToastService.toastPadrao("Registro cadastrado com sucesso.");

                            vm.entidadeDeEnvio.intPosicao = 1;
                            vm.entidadeDeEnvio.intTotalResultado = 1;
                            vm.entidadeDeEnvio.clsEntidade = success.data;

                            PgToolbarService.atualizarBotoesDeNavegacao(vm.entidadeDeEnvio, vm.controladorToolbar);
                            PgToolbarService.finalizarPreLoaderToolbar(vm.controladorToolbar, vm.controladorPreLoader);
                            if (vm.acaoPosCriar) {
                                vm.acaoPosCriar();
                            }

                        },
                        function (error) {
                            PgToolbarService.exibirAlertaDeErro(error, event);
                            PgToolbarService.finalizarPreLoaderToolbar(vm.controladorToolbar, vm.controladorPreLoader);

                        });
                }
                else
                    PgToolbarService.finalizarPreLoaderToolbar(vm.controladorToolbar, vm.controladorPreLoader);
            }
            else {
                $log.warn("Para o funcionamento da ação do botão criar.\n" +
                    "É necessário passar uma função pelo parâmetro 'acao-criar'")
            }
        }

        /**
         * Método utilizado para mandar um requisição para api para Editar um registro
         * @param {event} event event do botão
         */
        function metodosAcaoAEditar(event) {
            if (vm.acaoEditar) {
                PgToolbarService.iniciarPreLoaderToolbar(vm.controladorToolbar, vm.controladorPreLoader);
                var promessa = vm.acaoEditar();
                if (promessa) {
                    promessa.then(
                        function (success) {
                            if (success.status > 203) {
                                PgToolbarService.exibirAlertaDeErro(success, event);
                                metodosAcaoAtualizar();
                            } else {
                                if (success && success.data && success.data.definirStatusToolbarParaEdicaoAposEdicao)
                                    vm.definirStatusToolbarParaEdicaoAposEdicao = true;

                                if (vm.metodoExternoAlterarEntidadeExternamente) {
                                    PgToolbarService.executarFuncaoPorParametro(vm.metodoExternoAlterarEntidadeExternamente, success.data);
                                }
                                else if (!success.data.atualizadoNoController) {
                                    vm.entidade = success.data;
                                }

                                _definirStatusToolbarAposInsercaoOuEdicao();
                                MdToastService.toastPadrao("Registro Editado com sucesso.");
                            }

                            PgToolbarService.atualizarBotoesDeNavegacao(vm.entidadeDeEnvio, vm.controladorToolbar);
                            PgToolbarService.finalizarPreLoaderToolbar(vm.controladorToolbar, vm.controladorPreLoader);
                            if (vm.acaoPosEditar) {
                                vm.acaoPosEditar();
                            }
                        },
                        function (error) {
                            PgToolbarService.exibirAlertaDeErro(error, event);
                            PgToolbarService.finalizarPreLoaderToolbar(vm.controladorToolbar, vm.controladorPreLoader);
                            if (vm.acaoPosEditar) {
                                metodoControladorReverter();
                                vm.acaoPosEditar();
                            }

                        });
                }
                else
                    PgToolbarService.finalizarPreLoaderToolbar(vm.controladorToolbar, vm.controladorPreLoader);
            }
            else {
                $log.warn("Para o funcionamento da ação do botão editar.\n" +
                    "É necessário passar uma função pelo parâmetro 'acao-editar'")
            }
        }

        /**
         * Método utilizado para mandar uma requisição para Api para excluir um registro
         * @param {evemt} event
         */
        function metodosAcaoExcluir(event) {
            if (angular.isDefined(vm.acaoExcluir)) {
                MdDialogService.confirmPadraoComEvento("Excluir",
                    'Deseja realmente excluir o registro ?', event,
                    function () {
                        PgToolbarService.iniciarPreLoaderToolbar(vm.controladorToolbar, vm.controladorPreLoader);
                        var promessa = vm.acaoExcluir();
                        if (promessa) {
                            promessa.then(
                                function (success) {
                                    MdToastService.toastPadrao(success.data);

                                    if (PgToolbarService.atualizarEntidadeDeEnvioQuandoRegistroForExcluido(vm.entidadeDeEnvio))
                                        metodoAcaoNavegacao();
                                    else
                                        metodoControladorNovaPesquisa();

                                    vm.controladorToolbar.editarAtivo = false;
                                    PgToolbarService.atualizarBotoesDeNavegacao(vm.entidadeDeEnvio, vm.controladorToolbar);
                                    PgToolbarService.finalizarPreLoaderToolbar(vm.controladorToolbar, vm.controladorPreLoader);
                                },
                                function (error) {
                                    PgToolbarService.exibirAlertaDeErro(error, event);
                                    PgToolbarService.finalizarPreLoaderToolbar(vm.controladorToolbar, vm.controladorPreLoader);
                                });
                        }
                        else
                            PgToolbarService.finalizarPreLoaderToolbar(vm.controladorToolbar, vm.controladorPreLoader);
                    });
            }
            else {
                $log.warn("Para o funcionamento da ação do botão excluir.\n" +
                    "É necessário passar uma função pelo parâmetro 'acao-excluir'")
            }
        }
        /////////////////////////////////////////////////// FIM IMPLEMENTAÇÃO  MÉTODOS AÇÃO /////////////////////////////////////////////////

    } // CONTROLLER

    function pgToolbarDirective() {
        return {
            templateUrl: 'app/compartilhado/diretivas/pg-toolbar/pg-toolbar.html',
            controller: 'PgToolbarController as vm',
            require: '^form',
            restrict: "AE",
            scope: {},
            bindToController: {
                ngTipoLayout: '@?',
                entidade: '=?',
                entidades: '=?',
                metodosExternos: '=?',
                metodoExternoAcaoNavegacao: '&?',
                metodoExternoAcaoNovaPesquisa: '&?',
                metodoExternoAcaoReverter: '&?',
                metodoExternoAtualizarEntidadeExternamente: '&?',
                metodoExternoAlterarEntidadeExternamente: '&?',
                metodoExternoControladorPesquisar: '&?',
                controladorAtualizarEntidadeExternamente: '=?',
                entidadeDeEnvio: '=?',
                controladorToolbar: '=?',
                controladorPreLoader: '=?',
                acaoPesquisar: '&?',
                acaoPosPesquisar: '&?',
                acaoCriar: '&?',
                acaoPosCriar: '&?',
                acaoEditar: '&?',
                acaoExcluir: '&?',
                acaoPosEditar: '&?',
                construirDtOptions: '&?',
                campoPesquisar: '=?',
                definirStatusToolbarParaInsercaoAposInsercao: '=?',
                definirStatusToolbarParaEdicaoAposEdicao: '=?',
                iniciarChamandoPesquisa: '=?',
                iniciarHabilitandoModoPesquisa: '=?',
                iniciarHabilitandoInsercao: '=?',
                desabilitarBotaoNovaPesquisa: '=?',
                desabilitarBotaoPesquisar: '=?',
                desabilitarBotaoSalvar: '=?',
                desabilitarBotaoReverter: '=?',
                desabilitarBotaoExcluir: '=?',
                desabilitarBotaoEditar: '=?',
                desabilitarBotaoInserir: '=?',
                desabilitarBotaoAtualizar: '=?',
                desabilitarBotoesNavegacao: '=?',
                desabilitarBotaoPrimeira: '=?',
                desabilitarBotaoAnterior: '=?',
                desabilitarBotaoProxima: '=?',
                desabilitarBotaoUltima: '=?',
                acaoPosPaginacao: '&?',
                desabilitarBotaoListarTodasEntidades: '=?',
                esconderBotaoNovaPesquisa: '=?',
                esconderBotaoPesquisar: '=?',
                esconderBotaoSalvar: '=?',
                esconderBotaoReverter: '=?',
                esconderBotaoExcluir: '=?',
                esconderBotaoEditar: '=?',
                esconderBotaoInserir: '=?',
                esconderBotaoAtualizar: '=?',
                esconderMensagemStatus: '=?',
                esconderBotaoPrimeira: '=?',
                esconderBotaoAnterior: '=?',
                escoderTextoInformativoQuantidade: '=?',
                esconderBotaoProxima: '=?',
                esconderBotaoUltima: '=?',
                esconderBotaoListarTodasEntidades: '=?',
                preDefinirCamposParaEdicao: '&?',
                preDefinirCamposParaInsercao: '&?',
                textoExibido: '=?',
                definirCamposClonados: '&?',
                utilizaBotaoClonar: '=?',
                desabilitarBotaoClonar: '=?'
            },
            link: function (scope, element, attr, formCtrl) {
                scope.obterControleFormulario(formCtrl);
            }
        };
    }

})();

(function () {
    'use strict';

    angular
        .module('app.diretivas')
        .config(config);

    function config($translatePartialLoaderProvider) {

        // TRADUÇÃO       
        $translatePartialLoaderProvider.addPart('app/compartilhado/diretivas/pg-toolbar');
        // endregion
    }

})();

(function () {
    'use strict';

    angular
        .module('app.diretivas')
        .controller('MsAutoCompleteTabelaController', MsAutoCompleteTabelaController)
        .directive('msAutoCompleteTabela', msAutoCompleteTabela);

    /** @ngInject */
    function MsAutoCompleteTabelaController($scope, ServicosGenericoService) {
        var vm = this;

        init();

        vm.metodos = {
            ngChangehabilitarTodos: ngChangehabilitarTodos,
            configuraAutoCompleteOnBlur: configuraAutoCompleteOnBlur,
            alterarItemSelecionadoAutoComplete: alterarItemSelecionadoAutoComplete,
            pesquisarAutoComplete: pesquisarAutoComplete,
            removerItem: removerItem,
            limpaTodos: limpaTodos,
            configurarSelect: configurarSelect
        }

        vm.metodosInternos = {
            habilitarTodos: _habilitarTodos,
            defineValoresDefault: _defineValoresDefault,
            verificaSeExisteNaLista: _verificaSeExisteNaLista
        }

        function init() {
            vm.seletores = {
                1: 'E',
                2: 'OU'
            };
            vm.habilitarTodos = true;
        }

        //#region watch
        $scope.$watch('vm.filtros.length', function (newVlue, oldValue) {
            if (vm.filtros.length <= 0)
                vm.habilitarTodos = true;
        });
        //#endregion watch

        //#region Metodos
        function configurarSelect() {
            vm.termoProcuradoCaracteristica = "";
            angular.element('#select').on('keydown', function (ev) {
                ev.stopPropagation();
            });
        }

        function ngChangehabilitarTodos() {
            _habilitarTodos();
        }

        function limpaTodos() {
            _defineValoresDefault();
        }

        function configuraAutoCompleteOnBlur() {
            if (!vm.item) {
                vm.textoDePesquisaAutoComplete = "";
            }
        }

        function alterarItemSelecionadoAutoComplete(item) {

            if (item && !_verificaSeExisteNaLista(item)) {
                vm.filtros.push(item);
                vm.habilitarTodos = false;
            }
            vm.textoDePesquisaAutoComplete = "";

            vm.segmentacao = null;
        }

        function pesquisarAutoComplete(query) {
            return ServicosGenericoService.pesquisarAutoCompleteCodigoOuDescricaoGenericoApi(vm.rotaDaPesquisa, query)
                .then(_filtrarExcluidos);
        }

        function removerItem(item) {
            vm.removeuItemGrid = true;
            vm.filtros.splice(vm.filtros.indexOf(item), 1);
            if (vm.filtros.length <= 0)
                _habilitarTodos();
        }

        function configuraAutoCompleteOnBlur() {
            if (!vm.segmentacao) {
                vm.textoDePesquisaAutoCompleteSegmentacao = "";
            }
        }

        //#endregion Metodos

        //#region metodos internos

        function _verificaSeExisteNaLista(item) {
            return vm.filtros.some(function (itemExistente) {
                return ((item.codigo) == (itemExistente.codigo));
            });
        }

        function _filtrarExcluidos(lista) {
            return lista.filter(function (item) {
                if (_verificaSeExisteNaLista(item)) {
                    return false;
                }

                if (!vm.filtrosExcluir || !vm.filtrosExcluir.length) {
                    return true;
                }

                return !vm.filtrosExcluir.some(function (itemExcluido) {
                    return (item.codigo) == (itemExcluido.codigo);
                });
            });
        }

        function _habilitarTodos() {
            if (vm.filtros.length == 0 || vm.habilitarTodos) {
                _defineValoresDefault();
            }
        }

        function _defineValoresDefault() {
            vm.filtros = [];
            vm.habilitarTodos = true;
            vm.todosSelecionados = true;
            vm.todosRemovidos = true;
        }
        //#endregion metodos internos

    }

    /** @ngInject */
    function msAutoCompleteTabela() {
        return {
            restrict: 'AE',
            scope: {},
            bindToController: {
                desabilitarCampos:"=?",
                textoFildSet: '@',
                inputName: '@',
                rotaDaPesquisa: '@',
                itemTemplate: "@",
                mensagemNaoEncontrado: "@",
                labelCheck: "@?",
                tituloTabela: "@",
                textoIconeRemover: "@",
                filtros: "=",
                filtrosExcluir: "=?",
                todosSelecionados: "=?",
                todosRemovidos: "=?",
                removeuItemGrid: "=?",
                textoFloatingLabel: "@?",
                nomeDoCampoFlagAndOr: "@?",
                modelCampoAndOr: "=?",
                habilitaCheckLimpar: "=?",
                labelCheckLimpar: "@?",
                executaAoSelecionar:"=?"
            },
            controller: 'MsAutoCompleteTabelaController as vm',
            templateUrl: 'app/compartilhado/diretivas/ms-auto-complete-tabela/ms-auto-complete-tabela.html'

        };
    }
})();

(function () {
  'use strict';

  angular
    .module('app.diretivas')
    .directive('pesquisarCliente', pesquisarClienteDirective);

  function pesquisarClienteDirective($linq) {
    return {
      restrict: 'A',
      require: '^ngModel',
      scope: {
        listaAPesquisar: '=?',
        entidadePesquisada: '=?',
        solucoes: '=?',
        pesquisaSolucaoCodigo: '=?',
        solucaoCodigo: '=?'
      },
      link: function (scope, element, attrs, ngModelCtrl) {
        var lista = scope.listaAPesquisar;
        var solucoesTemporarias = angular.copy(scope.solucoes);

        scope.$watch('entidadePesquisada', function (newValue, oldValue) {
          var resultado = $linq.Enumerable().From(lista)
            .Where(function (item) {
              return item.codigo == newValue;
            }).FirstOrDefault();
          if (resultado) {
            ngModelCtrl.$setViewValue(resultado.codigo);
            ngModelCtrl.$render();
            scope.solucoes = resultado.solucoes;
            scope.solucaoCodigo = null;
            scope.pesquisaSolucaoCodigo = null
          } else {
            ngModelCtrl.$setViewValue(null);
            ngModelCtrl.$render();
            scope.solucoes = solucoesTemporarias;
            scope.solucaoCodigo = null;
            scope.pesquisaSolucaoCodigo = null
          }
        });

        element.bind('keydown', function (event) {
          if (event.key == 'Enter') {
            event.target.blur();
            event.stopPropagation();
          }
        })

        element.bind('blur', function () {
          var resultado = $linq.Enumerable().From(lista)
            .Where(function (item) {
              return item.codigo == ngModelCtrl.$viewValue;
            }).FirstOrDefault();
          if (resultado) {
            scope.entidadePesquisada = resultado.codigo;
            scope.solucaoCodigo = null;
            scope.pesquisaSolucaoCodigo = null
          } else {
            ngModelCtrl.$setViewValue(null);
            ngModelCtrl.$render();
            scope.entidadePesquisada = null;
            scope.solucaoCodigo = null;
            scope.pesquisaSolucaoCodigo = null
          }
        });

      }
    }
  }

})();

/**
 * Created by nova on 29/09/2016.
 */
(function () {
    'use strict';

    angular
        .module('app.diretivas')
        .controller('MultiSelectController', MultiSelectController)
        .directive('multiSelectDirective', multiSelectDirective);

    function MultiSelectController($scope, $element) {
        var vm = this;
        vm.todos = true;

        vm.metodos = {
            limparSelecao: limparSelecao,
            onChangeItem: onChangeItem
        }

        $scope.searchTerm;
        $scope.clearSearchTerm = function () {
            $scope.searchTerm = '';
        };

        $element.find('input').on('keydown', function (ev) {
            ev.stopPropagation();
        });

        function limparSelecao() {

            if (vm.todos === true) {
                $scope.model = [];
            }
        }

        function onChangeItem() {
            if ($scope.model.length > 0)
                vm.todos = false;

            if (($scope.model.length === $scope.data.length)
                || ($scope.model.length === 0)) {
                vm.todos = true;
                $scope.model = [];
            }
        }

        $scope.$watch('data', function () {
            $scope.model = [];
            vm.todos = true;
        });
    }

    function multiSelectDirective() {
        return {
            templateUrl: 'app/compartilhado/diretivas/multi-select/multi-select.html',
            controller: 'MultiSelectController as vm',
            restrict: 'E',
            scope: {
                data: '=',
                model: '= ',
                descricaoExibicao: '@',
                textoPlaceholder: '@',
                flex: '@?',
                formName: '@?',
                obrigatorio: '@?',
                textoPesquisaPlaceholder: '@',
                disabled: '='
            }
        };
    }

})();

/**
 * Created by nova on 09/09/2016.
 */
(function () {
    'use strict';

    angular
        .module('app.diretivas')
        .directive('mascaraTamanhoCampo', mascaraTamanhoCampoDirective);

    function mascaraTamanhoCampoDirective() {
        return {
            restrict: 'A',
            require: "^ngModel",
            link: function (scope, element, attrs, ngModelCtrl) {
                var quantidadeMaximaCaracteres = attrs.mascaraTamanhoCampo;
                if (!quantidadeMaximaCaracteres) {
                    alert("Para o funcionamento correto da diretiva mascara-tamanho-campo.\n" +
                        "É necessário informa a quantidade de caracteres máxima na diretiva \n" +
                        "Exemplo: mascara-tamanho-campo='50'");
                }

                var formatarDiretiva = function (valor) {
                    if (valor !== undefined) {
                        if (quantidadeMaximaCaracteres) {
                            if (valor && (valor.length > quantidadeMaximaCaracteres)) {
                                valor = valor.substring(0, quantidadeMaximaCaracteres);
                            }
                        }
                    }

                    return valor;
                };

                ngModelCtrl.$parsers.push(function (valorView) {
                    if (angular.isUndefined(valorView)) {
                        var valorView = '';
                    }

                    var valor = formatarDiretiva(valorView);

                    if (valorView !== valor) {
                        ngModelCtrl.$setViewValue(valor);
                        ngModelCtrl.$render();
                    }
                    return valor;
                });

                element.bind('keydown', function (event) {
                    if (event.key && event.key.length === 1 && angular.isDefined(ngModelCtrl.$viewValue)) {
                        var valorViewValue;
                        if (angular.isDefined(attrs.uiMoneyMask)) {
                            valorViewValue = ngModelCtrl.$viewValue
                                .replace('R$ ', '')
                                .replace(/\./g, "")
                                .replace(',', '.');
                        }
                        else if (angular.isDefined(attrs.uiPercentageMask)) {
                            valorViewValue = ngModelCtrl.$viewValue
                                .replace(' %', '');                                
                        }
                        else {
                            valorViewValue = ngModelCtrl.$viewValue
                        }                        

                        if (valorViewValue && valorViewValue.length >= quantidadeMaximaCaracteres) {
                            event.preventDefault();
                        }
                    }
                });
            }
        }
    }

})();

(function () {
    'use strict';

    angular
        .module('app.diretivas')
        .controller('MsSelecionarMultiValoresController', MsSelecionarMultiValoresController)
        .directive('msSelecinarMultiValores', msSelecinarMultiValoresDirective);

    /** @ngInject */
    function MsSelecionarMultiValoresController($scope, $window, RotasHtml) {
        var vm = this;
        vm.rotas = RotasHtml.msAutoSelecionar.templateUrl;

        init();


        angular.element($window).bind('resize', function () {
            vm.larguraTela = $window.innerWidth;
        });

        vm.metodos = {
            configurarSelect: configurarSelect,
            ngChangeHabilitarTodos: ngChangeHabilitarTodos,
            retornaStringModelSelecionados: retornaStringModelSelecionados
        }

        vm.metodosInternos = {
            defineValoresDefault: _defineValoresDefault
        }

        function init() {
            vm.larguraTela = $window.innerWidth;

            vm.maxLengthTextoExibicao = 5;

            vm.modelDados = [];

            vm.habilitarTodos = true;

            if (angular.equals(null, vm.obrigatorio) || angular.equals(undefined, vm.obrigatorio))
                vm.obrigatorio = true;

            if (angular.equals(null, vm.autoSelecionar) || angular.equals(undefined, vm.autoSelecionar))
                vm.autoSelecionar = true;

            if (angular.equals(null, vm.temFieldSet) || angular.equals(undefined, vm.temFieldSet))
                vm.temFieldSet = true;

            if (angular.equals(null, vm.autoSelecionar) || angular.equals(undefined, vm.autoSelecionar))
                vm.autoSelecionar = true;

        }


        //#region watch
        $scope.$watch('vm.modelDados', function (newValue, oldValue) {

            if (angular.equals(null, vm.modelDados) || angular.equals(undefined, vm.modelDados)) {
                if (vm.autoSelecionar)
                    vm.habilitarTodos = true;

                return;
            }

            if (vm.modelDados.length == vm.dados) {
                _defineValoresDefault();
                return;
            }

            if (vm.modelDados.length > 0) {
                vm.habilitarTodos = false;
                vm.textoLabelSelect
                return;
            }

        }, true);
        //#endregion watch

        //#region Metodos
        function configurarSelect() {
            vm.termoProcurado = "";
            angular.element('.ms-select input').on('keydown', function (ev) {
                ev.stopPropagation();
            });
        }

        function retornaStringModelSelecionados() {
            if (!vm.modelDados || vm.modelDados.length <= 0)
                return vm.namePlaceholder;
            var texto = "";

            vm.modelDados.forEach(function (item, index) {
                if (index == vm.modelDados.length - 1) {
                    texto += item[vm.propriedadeParaAExibicaoDaRepeticao];
                }
                else {
                    texto += item[vm.propriedadeParaAExibicaoDaRepeticao] + ",";
                }
            });


            switch (vm.larguraTela) {
                case vm.larguraTela <= 400: vm.maxLengthTextoExibicao = "25"; break;
                case vm.larguraTela <= 1200: vm.maxLengthTextoExibicao = "30"; break;
                case vm.larguraTela <= 1400: vm.maxLengthTextoExibicao = "45"; console.log("caiu"); break;
                default: vm.maxLengthTextoExibicao = "55";
            }

            if (texto.length <= vm.maxLengthTextoExibicao)
                return texto;

            return texto.substring(0, vm.maxLengthTextoExibicao) + "...";
        }

        function ngChangeHabilitarTodos() {
            if (vm.habilitarTodos)
                _defineValoresDefault();

        }

        //#endregion Metodos

        //#region metodos internos
        function _defineValoresDefault() {
            vm.habilitarTodos = true;
            vm.modelDados = [];
        }

        //#endregion metodos internos

    }

    /** @ngInject */
    function msSelecinarMultiValoresDirective() {

        return {
            restrict: 'AE',
            scope: {},
            bindToController: {
                orderByOption: "@?",
                mensagemDeErroDoFormulario: "@?",
                propriedadeParaAExibicaoDaRepeticao: "@?",
                propriedadeParaOTrackBy: "=?",
                limpaDadosDoFiltro: "&?",
                textoLabelSelect: "=?",
                textoFieldSet: "@?",
                namePlaceholder: "@?",
                nameCheck: "=?",
                form: "=?",
                dados: "=?",
                modelDados: "=?",
                limitarWidth: "=?",
                obrigatorio: "=?",
                autoSelecionar: "=?",
                temFieldSet: "=?",
                desabilitar: "=?"
            },
            controller: 'MsSelecionarMultiValoresController as vm',
            templateUrl: 'app/compartilhado/diretivas/ms-selecionar-multi-valores/ms-selecionar-multi-valores.html'

        };
    }
})();

(function () {

    'use strict';

    angular
        .module('app.diretivas')
        .controller('MsAutoCompleteColaborador', MsAutoCompleteColaborador)
        .directive('msAutoCompleteColaborador', msAutoCompleteColaborador);


    function MsAutoCompleteColaborador( $scope,ServicosGenericoService) {
        var vm = this;
  
      
        init();

        $scope.$watch('vm.limparUsuarios',function(current,old){
            if(current)
                _definirModelsVinculadosAoUsuarioParaNull();
        });

        vm.metodos = {
            configuraAutoCompleteUsuarioOnBlur: configuraAutoCompleteUsuarioOnBlur,
            alterarItemSelecionadoAutoCompleteUsuario: alterarItemSelecionadoAutoCompleteUsuario,
            pesquisarAutoCompleteUsuario: pesquisarAutoCompleteUsuario

        }

        function init() {
            vm.bindUsuario = {};
        }

        //#region metodos 
        function configuraAutoCompleteUsuarioOnBlur() {
            if (!vm.usuario || !vm.bindUsuario) {
                vm.textoDePesquisaAutoCompleteUsuario = "";
            }
        }

        function alterarItemSelecionadoAutoCompleteUsuario(item) {
            if (item) {
                vm.bindUsuario.codigo = item.codigo;
                vm.bindUsuario.usuario = item;
            }
            else {
                _definirModelsVinculadosAoUsuarioParaNull();
            }
        }

        function pesquisarAutoCompleteUsuario(query) {
            return ServicosGenericoService.pesquisarAutoCompleteCodigoOuNomeGenerico(vm.listaTodosUsuarios, query);
        }

        //#endregion metodos

        //#region metodos internos
        function _definirModelsVinculadosAoUsuarioParaNull() {
            vm.usuario = null;
            vm.bindUsuario.usuario = null;
            vm.bindUsuario.codigoUsuario = null;
            vm.textoDePesquisaAutoCompleteUsuario = "";
        }
        //#endregion metodos internos
    }

    function msAutoCompleteColaborador() {
        return {
            restrict: 'E',
            scope: {},
            bindToController: {
                bindUsuario: '=?',
                listaTodosUsuarios: '=?',
                desabilitarCampo:'=?',
                limparUsuarios:'=?'
            },
            controller: 'MsAutoCompleteColaborador as vm',
            templateUrl: 'app/compartilhado/diretivas/ms-auto-complete-colaborador/ms-auto-complete-colaborador.html'
        };
    }
})();


/**
 * Created by nova on 09/09/2016.
 */
(function(){
    'use strict';

    angular
        .module('app.diretivas')
        .directive('mascaraTelefone', mascaraTelefoneDirective);

    function mascaraTelefoneDirective() {
        return {
            restrict: 'A',
            require: '^ngModel',
            link: function(scope, element, attrs, ngModelCtrl) {
                if (!ngModelCtrl) {
                    return;
                }

                String.prototype.insert = function (index, string) {
                    if (index > 0)
                        return this.substring(0, index) + string + this.substring(index, this.length);
                    else
                        return string + this;
                };

                var lstrMascara8 = "####-####";
                var lstrMascara9 = "#####-####";
                var lstrMascara11 = "(##)####-####";
                var lstrMascara12 = "(##)#####-####";

                var EhDigitoValido = function(key) {
                    var re = /[\d-()]+/;
                    return re.exec(key) != null;
                }

                var RetirarMascara = function(strTexto) {
                    return strTexto.replace('(', '').replace(')', '').replace('-', '');
                }

                var Mascarar = function(texto) {
                    texto = RetirarMascara(texto);
                    if (texto.length < 5)
                        return texto;

                    var digitosMascara = [];

                    var mascara = texto.length <= 8 ? lstrMascara8 :
                    texto.length <= 9 ? lstrMascara9 :
                    texto.length <= 10 ? lstrMascara11 : lstrMascara12;

                    for (var i = 0; i < mascara.length; i++) {
                        var lchDigito = mascara[i];
                        if (lchDigito != '#') {
                            var digTemp = {};
                            digTemp.indice = i;
                            digTemp.digito = lchDigito;
                            digitosMascara.push(digTemp);
                        }
                    }

                    var textomascarado = texto;

                    for (var i = 0; i < digitosMascara.length; i++) {
                        var value = digitosMascara[i];
                        textomascarado = textomascarado.insert(value.indice, value.digito);
                    }
                    return textomascarado;
                }
                ngModelCtrl.$parsers.push(function(valorView) {
                    if (angular.isUndefined(valorView)) {
                        var valorView = '';
                    }
                    var _valor = valorView.replace(/[^\d]+/g, "");
                    var valor = Mascarar(_valor);
                    if (valorView !== valor) {
                        ngModelCtrl.$setViewValue(valor);
                        ngModelCtrl.$render();
                    }
                    return valor;
                });

                element.bind('keydown', function(event) {                   
                    // bloqueia o espaço
                    if (event.keyCode === 32) {
                        event.preventDefault();
                    }

                    if (EhDigitoValido(event.key)) {
                        if (angular.isDefined(ngModelCtrl.$viewValue) && ngModelCtrl.$viewValue != null &&
                            ngModelCtrl.$viewValue.length == 14) {
                            event.preventDefault();
                        }
                    }
                });
            }
        }
    }

})();

/**
 * Created by nova on 25/10/2016.
 */
(function () {
    'use strict';

    angular
        .module('app.diretivas')
        .service('MascaraDocumentoService', MascaraDocumentoService);

    function MascaraDocumentoService() {

        this.verificarCPF = verificarCPF;

        function verificarCPF(strCPF) {
            var Soma;
            var Resto;
            Soma = 0;
            if (strCPF == "00000000000") return false;

            for (var i = 1; i <= 9; i++) Soma = Soma + parseInt(strCPF.substring(i - 1, i)) * (11 - i);
            Resto = (Soma * 10) % 11;

            if ((Resto == 10) || (Resto == 11)) Resto = 0;
            if (Resto != parseInt(strCPF.substring(9, 10))) return false;

            Soma = 0;
            for (var i = 1; i <= 10; i++) Soma = Soma + parseInt(strCPF.substring(i - 1, i)) * (12 - i);
            Resto = (Soma * 10) % 11;

            if ((Resto == 10) || (Resto == 11)) Resto = 0;
            if (Resto != parseInt(strCPF.substring(10, 11))) return false;
            return true;
        }
    }

})();

(function () {
  'use strict';

  angular
    .module('app.diretivas')
    .directive('mascaraDocumento', mascaraDocumentoDirective);

  function mascaraDocumentoDirective($log, Regex, MascaraDocumentoService) {
    return {
      restrict: 'A',
      require: '^ngModel',
      scope: {
        mascaraAUtilizar: '@?',
        desabilitarMascara: '=?',
        limitarTamanhoCampoQuandoDesabilitarMascaraAtivo: '@?',
        alterarMascaraDinamicamente: '=?'
      },
      controller: function () {},
      link: function (scope, element, attrs, ngModelCtrl) {
        if (!ngModelCtrl) {
          $log.error("É necessário informar o ng-model para o funcionamento correto da diretiva");
          return;
        }

        String.prototype.insert = function (index, string) {
          if (index > 0)
            return this.substring(0, index) + string + this.substring(index, this.length);
          else
            return string + this;
        };

        //////////////////////////////////////// Variáveis Locais ///////////////////////////////////////////////////////////////
        var ultimoDigito = "";
        var mascaraCnpj = "##.###.###/####-##";
        var mascaraCpf = "###.###.###-##";
        var tamanhoMascara = null;
        var tipoMascara = null;
        var regex = null;
        var regexLimpeza = null;
        var regexValidacaoUtilizada = null;
        /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

        //////////////////////////////////////// Chamadas Incializadoras ////////////////////////////////////////////////////////                          
        preDefinirRegex(preDefinirDigitosMascara(mascaraCnpj));
        preDefinirMascara();
        /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

        //////////////////////////////////////// Métodos  ////////////////////////////////////////////////////////

        /**
         * Método para definir qual mascará será utiliza no campo
         * 'AMBOS' / 'CNPJ' / 'CPF'
         * E também definir qual RegeEpx de validação será utilizada no model
         */
        function preDefinirMascara() {
          if (!scope.mascaraAUtilizar || scope.mascaraAUtilizar.toUpperCase() == "AMBOS") {
            tipoMascara = "AMBOS"
            tamanhoMascara = mascaraCnpj.length;
            regexValidacaoUtilizada = new RegExp(Regex.cpfCnpj);
          } else if (scope.mascaraAUtilizar && scope.mascaraAUtilizar.toUpperCase() == "CNPJ") {
            tamanhoMascara = mascaraCnpj.length;
            tipoMascara = "CNPJ";
            regexValidacaoUtilizada = new RegExp(Regex.cnpj);
          } else if (scope.mascaraAUtilizar && scope.mascaraAUtilizar.toUpperCase() == "CPF") {
            tamanhoMascara = mascaraCpf.length;
            tipoMascara = "CPF";
            regexValidacaoUtilizada = new RegExp(Regex.cpf);
          }
        }

        /**
         * Método que verifica se a tecla digitada é valido
         * @param {string} key 
         */
        function ehDigitoValido(key) {
          return regex.exec(key) != null
        }

        /**
         * Método que verifica se a tecla digitada é um digito de navegação
         * @param {string} key 
         */
        function ehDigitoDeNavegacao(key) {
          if (key == 8 || key == 46 || key == 37 || key == 37 || key == 38 || key == 39 || key == 40)
            return true;
          else
            return false;
        }

        /**
         * Método que defini quais são os digitos da mascara, com base na mascara passada como parâmetro
         * Exemplo: CPF: '###.###.###-##' então seus digitos são: '..-'
         * @param {Array} mascaraAtiva 
         */
        function preDefinirDigitosMascara(mascaraAtiva) {
          var digitosMarscaraAtiva = []
          for (var i = 0; i < mascaraAtiva.length; i++) {
            if (mascaraAtiva[i] != '#') {
              digitosMarscaraAtiva.push({
                indice: i,
                digito: mascaraAtiva[i]
              });
            }
          }
          return digitosMarscaraAtiva;
        }

        /**
         * Método que defini as regex da diretiva, com base no array de digitos da mascará ativa passada como parâmetro
         * variáveis 'regex' e 'regexLimpeza'
         * @param {Array} arrayDigitosMascara 
         */
        function preDefinirRegex(arrayDigitosMascara) {
          var _regex = "[\\d";
          var _regexLimpeza = "[^\\d";
          for (var i = 0; i < arrayDigitosMascara.length; i++) {
            var digto = arrayDigitosMascara[i].digito;
            if (_regex.indexOf(digto) !== -1)
              continue;
            _regex += digto;
            _regexLimpeza += digto;
          }
          _regex += "]+";
          _regexLimpeza += "]+";

          regex = new RegExp(_regex);
          regexLimpeza = new RegExp(_regexLimpeza, "g");
        }

        /**
         * Método que retorna o texto do campo sem a mascará 
         * @param {Array} arrayDigistosMascara 
         * @param {string} textoARemover 
         */
        function retirarMascara(arrayDigistosMascara, textoARemover) {
          for (var i = 0; i < arrayDigistosMascara.length; i++) {
            textoARemover = textoARemover.replace(arrayDigistosMascara[i].digito, '');
          }
          return textoARemover;
        }

        /**
         * Método que recebe o texto do campo e o mascará
         * @param {string} texto 
         */
        function mascarar(texto) {
          var mascara = tipoMascara == "CNPJ" ? mascaraCnpj :
            tipoMascara == "CPF" ? mascaraCpf :
            tipoMascara == "AMBOS" && texto.length < 15 ? mascaraCpf :
            mascaraCnpj;


          var digitosMascara = preDefinirDigitosMascara(mascara);
          preDefinirRegex(digitosMascara);

          // se nao tem mascara retorna
          if (digitosMascara.length == 0)
            return texto;

          // se o tamanho é menor que o primeiro indice retorna
          if (texto.length < digitosMascara[0].indice + 1)
            return texto;

          // se houve backspace retorna
          if (ultimoDigito != null && texto.length < ultimoDigito.length)
            return texto;

          // se o tamanho é maior que o máximo retorna a informação correta
          if (texto.length > tamanhoMascara)
            return ultimoDigito;

          var textoMascarado = retirarMascara(digitosMascara, texto);


          for (var i = 0; i < digitosMascara.length; i++) {
            var value = digitosMascara[i];
            textoMascarado = textoMascarado.insert(value.indice, value.digito);
            var proximo = i + 1;
            if (angular.isDefined(digitosMascara[proximo]))
              if (textoMascarado.length < digitosMascara[proximo].indice)
                return textoMascarado;
          }

          return textoMascarado;
        }
        /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

        //////////////////////////////////////// Métodos de Controle do Model  //////////////////////////////////////////////////

        /**
         * Método de controle do model executado sempre que o valor é alterado na View
         */
        ngModelCtrl.$parsers.push(function (valorView) {
          if (!scope.desabilitarMascara) {
            if (!valorView || angular.isUndefined(valorView)) {
              var valorView = '';
            }
            var _valor = valorView.replace(regexLimpeza, "");
            var valor = mascarar(_valor);
            ultimoDigito = valor;
            if (valorView !== valor) {
              ngModelCtrl.$setViewValue(valor);
              ngModelCtrl.$render();
            }
            return valor;
          } else {
            ultimoDigito = valorView;
            return valorView;
          }
        });

        /**
         * Método de controle do model executado sempre que o valor é alterado no model ou 'Controller'
         */
        ngModelCtrl.$formatters.push(function (modelValue) {
          if (!modelValue)
            ultimoDigito = "";

          return modelValue;
        });

        /**
         * Método de controle executado para validar ou inválidar o modél, também criando um validador customizado à ser utilizado na view
         * 'validacaoDocumento', e este método é disparado sempre ao final da execução de um $parses ou $formatters
         */
        ngModelCtrl.$validators.validacaoDocumento = function (modelValue, viewValue) {
          if (!viewValue || viewValue.length == 0)
            return true;
          else if (scope.desabilitarMascara)
            return true
          else if (viewValue && regexValidacaoUtilizada.test(viewValue)) {
            return true;
          } else
            return false;

        }

        /**
         * Método de controle executado para validar ou inválidar o CPF preenchido, assim criando um validador customizado
         * 'cpfValidacao'
         */
        ngModelCtrl.$validators.cpfValidacao = function (modelValue, viewValue) {
          if (!viewValue || viewValue.length == 0 || tipoMascara !== "CPF")
            return true;
          else if (viewValue && MascaraDocumentoService.verificarCPF(viewValue.replace(/\./g, '').replace(/\-/g, '')))
            return true;
          else
            return false;

        }

        /**
         * Método de controle executado sempre que o usuário pressionar alguma teclado no campo
         */
        element.bind('keydown', function (event) {
          // bloqueia o espaço
          if (event.keyCode === 32) {
            event.preventDefault();
          }

          if (scope.alterarMascaraDinamicamente || angular.isDefined(attrs.alterarMascaraDinamicamente)) {
            preDefinirMascara();
          }

          if (ultimoDigito.length >= scope.limitarTamanhoCampoQuandoDesabilitarMascaraAtivo && scope.desabilitarMascara &&
            !ehDigitoDeNavegacao(event.keyCode)) {
            event.preventDefault();
          }
        });
        /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
      }
    }
  };

})();

(function () {
    'use strict';

    angular
        .module('app.diretivas')
        .directive('mascaraNumeroVersao', MascaraNumeroVersaoDirective);

    function MascaraNumeroVersaoDirective() {
        return {
            require: 'ngModel',
            restrict: 'A',
            link: function (escopo, elemento, atributos, controladorModelo) {
                controladorModelo.$parsers.push(function (valorDigitado) {
                    if (!valorDigitado) return '';

                    var valorLimpo = valorDigitado.replace(/[^0-9.]/g, '');

                    var indicePonto = valorLimpo.indexOf('.');
                    if (indicePonto !== -1) {
                        if (indicePonto > 3) {
                            valorLimpo = valorLimpo.replace('.', '');
                            indicePonto = -1;
                        }
                    }

                    valorLimpo = valorLimpo.replace(/\.(?=.*\.)/g, '');

                    if (indicePonto === -1 && valorLimpo.length > 3) {
                        valorLimpo = valorLimpo.substring(0, 3) + '.' + valorLimpo.substring(3, 5);
                    } else if (indicePonto !== -1) {
                        var partes = valorLimpo.split('.');
                        valorLimpo = partes[0].substring(0, 3) + '.' + (partes[1] ? partes[1].substring(0, 2) : '');
                    }

                    if (valorLimpo.endsWith('.') && valorLimpo.split('.').length === 2) {
                    }

                    if (valorLimpo !== valorDigitado) {
                        controladorModelo.$setViewValue(valorLimpo);
                        controladorModelo.$render();
                    }

                    return valorLimpo;
                });

                elemento.on('blur', function () {
                    var valor = controladorModelo.$modelValue;

                    if (!valor) return;

                    var partes = valor.split('.');

                    var parteInteira = partes[0] || '0';
                    var parteDecimal = partes[1] || '';

                    if (parteDecimal.length === 0) {
                        parteDecimal = '00';
                    } else if (parteDecimal.length === 1) {
                        parteDecimal = parteDecimal + '0';
                    } else {
                        parteDecimal = parteDecimal.substring(0, 2);
                    }

                    var valorFormatado = parteInteira + '.' + parteDecimal;

                    if (valorFormatado !== valor) {
                        escopo.$applyAsync(function () {
                            controladorModelo.$setViewValue(valorFormatado);
                            controladorModelo.$render();
                        });
                    }
                });
            }
        }
    }

})();

(function () {
    'use strict';

    angular
        .module('app.diretivas')
        .directive('mascaraRelease', MascaraReleaseDirective);

    function MascaraReleaseDirective() {
        return {
            require: 'ngModel',
            restrict: 'A',
            link: function (scope, element, attrs, modelCtrl) {

                modelCtrl.$parsers.push(function (inputValue) {
                    if (inputValue == null) {
                        modelCtrl.$setValidity('formatoRelease', false);
                        return '';
                    }

                    var cleanInputValue = inputValue.replace(/[^0-9a-zA-Z]/gi, '').toUpperCase();

                    var mascaraInput = "";

                    if (cleanInputValue.length >= 1 && /^\d$/.test(cleanInputValue[0])) {
                        mascaraInput += cleanInputValue[0];
                    }

                    if (cleanInputValue.length >= 2) {
                        if (/^\d$/.test(cleanInputValue[1])) {
                            mascaraInput += cleanInputValue[1];
                        } else if (/^[a-zA-Z]$/.test(cleanInputValue[1])) {
                            mascaraInput += "/" + cleanInputValue[1];
                        }
                    }

                    if (cleanInputValue.length >= 3 && /^\d$/.test(cleanInputValue[0]) && /^\d$/.test(cleanInputValue[1]) && /^[a-zA-Z]$/.test(cleanInputValue[2])) {
                        mascaraInput = cleanInputValue[0] + cleanInputValue[1] + "/" + cleanInputValue[2];
                    }

                    if (mascaraInput.length > 4) {
                        mascaraInput = mascaraInput.substring(0, 4);
                    }

                    var padraoValido = /^\d{1,2}\/[A-Z]$/;
                    var valido = padraoValido.test(mascaraInput);

                    modelCtrl.$setValidity('formatoRelease', valido);

                    if (mascaraInput !== inputValue) {
                        modelCtrl.$setViewValue(mascaraInput);
                        modelCtrl.$render();
                    }

                    return mascaraInput;
                });
            }
        };
    }

})();

/**
 * Created by nova on 09/09/2016.
 */
(function () {
  'use strict';

  angular
    .module('app.diretivas')
    .directive('mascaraNumeros', mascaraNumerosDirective);

  function mascaraNumerosDirective() {
    return {
      restrict: 'A',
      require: '^ngModel',
      link: function (scope, element, attrs, ngModelCtrl) {
        if (!ngModelCtrl) {
          return;
        }

        var tamanhoMaximo = attrs.mascaraNumeros;
        if (tamanhoMaximo == '')
          tamanhoMaximo = 5;

        var aceitaNegativo = angular.isDefined(attrs.aceitaNegativo);

        var numeroCasasDecimais = attrs.numeroCasasDecimais;

        if (angular.isUndefined(numeroCasasDecimais))
          numeroCasasDecimais = 0;
        else {
          if (numeroCasasDecimais === 0)
            numeroCasasDecimais = 2;
        }

        var EhDigitoValido = function (key) {
          var re = /[\d-.]+/;
          return re.exec(key) != null;
        };

        ngModelCtrl.$parsers.push(function (valorView) {
          if (valorView === null) {
            return valorView;
          } else if (angular.isUndefined(valorView)) {
            var valorView = '';
          }

		  valorView = String(valorView);

          var valor = valorView.replace(/[^\d-.]+/g, "");
          //var valor = valorView;

          if (aceitaNegativo) {
            var vetNegativoCheck = valor.split('-');
            if (!angular.isUndefined(vetNegativoCheck[1])) {
              vetNegativoCheck[1] = vetNegativoCheck[1].slice(0, vetNegativoCheck[1].length);
              valor = vetNegativoCheck[0] + '-' + vetNegativoCheck[1];
              if (vetNegativoCheck[0].length > 0 || !aceitaNegativo) {
                valor = vetNegativoCheck[0];
              }
            }
          }

          if (numeroCasasDecimais > 0) {
            var vetDecimalCheck = valor.split('.');
            if (!angular.isUndefined(vetDecimalCheck[1])) {
              if (numeroCasasDecimais === 0) {
                valor = vetDecimalCheck[0];
              } else {
                vetDecimalCheck[1] = vetDecimalCheck[1].slice(0, numeroCasasDecimais);
                valor = vetDecimalCheck[0] + '.' + vetDecimalCheck[1];
              }
            }
          }

          if (valorView !== valor) {
            ngModelCtrl.$setViewValue(valor);
            ngModelCtrl.$render();
          }
          return Number(valor);
        });

        element.bind('keydown', function (event) {
          // bloqueia o espaço
          if (event.key == ' ') {
            event.preventDefault();
          }

          // bloqueia o negativo
          if (!aceitaNegativo && event.key == '-') {
            event.preventDefault();
          }

          // bloqueia o decimal
          if (numeroCasasDecimais === 0 && event.key == '.') {
            event.preventDefault();
          }

          if (EhDigitoValido(event.key)) {
            if (angular.isDefined(ngModelCtrl.$viewValue) && ngModelCtrl.$viewValue != null &&
              ngModelCtrl.$viewValue.length == tamanhoMaximo) {
              event.preventDefault();
            }
          }
        });
      }
    }
  }

})();

(function () {
  'use strict';

  angular
    .module('app.diretivas')
    .directive('mascaraNumeroGenerica', MascaraNumeroGenericaDirective);

  function MascaraNumeroGenericaDirective() {
    return {
      restrict: 'A',
      require: '^ngModel',
      link: function (scope, element, attrs, ngModelCtrl) {        
        var mascara = attrs.mascaraNumeroGenerica;
        if (!mascara) {
          alert("Para o funcionamento correto da diretiva mascara-numero-generica.\n" +
            "É necessário informar a máscara na diretiva \n" +
            "Exemplo: mascara-numero-generica='###-###'");
          return;
        }

        if (mascara === '')
          return;

        if (!ngModelCtrl) {
          return;
        }

        // Método de insert para string
        String.prototype.insert = function (index, string) {
          if (index > 0)
            return this.substring(0, index) + string + this.substring(index, this.length);
          else
            return string + this;
        };

        //tamanho máximo da mascara
        var tamanhoMaximo = mascara.length;

        // vetor com os digitos especiais da mascara
        var digitosMascara = [];
        for (var i = 0; i < mascara.length; i++) {
          var lchDigito = mascara[i];
          if (lchDigito != '#') {
            var digTemp = {};
            digTemp.indice = i;
            digTemp.digito = lchDigito;
            digitosMascara.push(digTemp);
          }
        }

        var _regex = "[\\d";
        var _regexLimpeza = "[^\\d";
        for (var i = 0; i < digitosMascara.length; i++) {
          var digto = digitosMascara[i].digito;
          if (_regex.indexOf(digto) !== -1)
            continue;
          _regex += digto;
          _regexLimpeza += digto;
        }
        _regex += "]+";
        _regexLimpeza += "]+";
        // Regex para validar mascara
        var regexMascara = new RegExp(_regex);
        // Regex para limpar o conteudo da mascara
        var regexLimpeza = new RegExp(_regexLimpeza, "g");

        var EhDigitoValido = function (key) {
          return regexMascara.exec(key) != null;
        }

        var RetirarMascara = function (strTexto) {
          for (var i = 0; i < digitosMascara.length; i++) {
            strTexto = strTexto.replace(digitosMascara[i].digito, '');
          }
          return strTexto;
        }

        var ultimoValor = null;
        var Mascarar = function (texto) {
          // se nao tem mascara retorna
          if (digitosMascara.length == 0)
            return texto;

          // se o tamanho é menor que o primeiro indice retorna
          if (texto.length < digitosMascara[0].indice + 1)
            return texto;

          // se houve backspace retorna
          if (ultimoValor != null && texto.length < ultimoValor.length)
            return texto;

          // se o tamanho é maior que o máximo retorna a informação correta
          if (texto.length > tamanhoMaximo)
            return ultimoValor;

          texto = RetirarMascara(texto);
          var textoMascarado = texto;

          for (var i = 0; i < digitosMascara.length; i++) {
            var value = digitosMascara[i];
            textoMascarado = textoMascarado.insert(value.indice, value.digito);
            var proximo = i + 1;
            if (angular.isDefined(digitosMascara[proximo]))
              if (textoMascarado.length < digitosMascara[proximo].indice)
                return textoMascarado;
          }

          return textoMascarado;
        }
      
        ngModelCtrl.$parsers.push(function (valorView) {   
          if (angular.isUndefined(valorView)) {
            var valorView = '';
          }
          var _valor = valorView.replace(regexLimpeza, "");
          var valor = Mascarar(_valor);
          ultimoValor = valor;
          if (valorView !== valor) {
            ngModelCtrl.$setViewValue(valor);
            ngModelCtrl.$render();
          }

          if (angular.isDefined(attrs.converteMascaraParaNumero))
            return Number(valor);
          else
            return valor;
        });

        element.bind('keydown', function (event) {
          // bloqueia o espaço
          if (event.keyCode === 32) {
            event.preventDefault();
          }

          if (EhDigitoValido(event.key)) {
            if (angular.isDefined(ngModelCtrl.$viewValue) && ngModelCtrl.$viewValue != null &&
              ngModelCtrl.$viewValue.length == tamanhoMaximo) {
              var elm = element[0];

              // Se tiver algum texto selecionado, permite a substituição deste texto
              var valorSelecionado = elm.value.substr(elm.selectionStart, elm.selectionEnd);

              if (valorSelecionado == "") {
                event.preventDefault();
              }
            }
          }
        });

        element.bind('blur', function (e) {
          if (angular.isDefined(ngModelCtrl.$viewValue) && ngModelCtrl.$viewValue != null) {
            ngModelCtrl.$setViewValue(Mascarar(ngModelCtrl.$viewValue));
            ngModelCtrl.$render();
          }
        });
      }
    }
  }

})();

/**
 * Created by nova on 12/09/2016.
 */
(function () {
    'use strict'

    angular
        .module('app.diretivas')
        .directive('mascaraFormatarNome', mascaraFormatarNomeDirective);

    function mascaraFormatarNomeDirective() {
        return {
            restrict: 'A',
            require: 'ngModel',
            link: function (scope, element, attrs, ngModelCtrl) {

                var formatarDiretiva = function (valor) {
                    if (valor !== undefined) {
                        valor = valor.replace(/[^A-Za-záàâãéèêíïóôõöúçñÁÀÂÃÉÈÍÏÓÔÕÖÚÇÑ?\s]/g, "");

                        return valor;
                    }
                };

                ngModelCtrl.$parsers.push(function (valorView) {
                    if (angular.isUndefined(valorView)) {
                        var valorView = '';
                    }

                    var valor = formatarDiretiva(valorView);

                    if (valorView !== valor) {
                        ngModelCtrl.$setViewValue(valor);
                        ngModelCtrl.$render();
                    }
                    return valor;
                });
            }
        }
    }


})();

(function () {
    'use strict';

    angular
        .module('app.diretivas')
        .directive('mascaraCampoGenerica', mascaraCampoGenerica);

    function mascaraCampoGenerica() {
        return {
            restrict: 'A',
            require: '^ngModel',
            link: function (scope, element, attrs, ngModelCtrl) {
                var mascara = attrs.mascaraCampoGenerica;
                if (!mascara) {
                    alert("Para o funcionamento correto da diretiva mascara-campo-generica.\n" +
                        "É necessário informar a máscara na diretiva \n" +
                        "Exemplo: mascara-campo-generica='###-###'");
                    return;
                }

                if (mascara === '')
                    return;

                if (!ngModelCtrl) {
                    return;
                }

                // Método de insert para string
                String.prototype.insert = function (index, string) {
                    if (index > 0)
                        return this.substring(0, index) + string + this.substring(index, this.length);
                    else
                        return string + this;
                };

                //tamanho máximo da mascara
                var tamanhoMaximo = mascara.length;

                // vetor com os digitos especiais da mascara
                var digitosMascara = [];
                for (var i = 0; i < mascara.length; i++) {
                    var lchDigito = mascara[i];
                    if (lchDigito != '#') {
                        var digTemp = {};
                        digTemp.indice = i;
                        digTemp.digito = lchDigito;
                        digitosMascara.push(digTemp);
                    }
                }

                var _regex = "[\\d";
                var _regexLimpeza = "[^\\d";
                var ultimoDigitoValido = null;
                for (var i = 0; i < digitosMascara.length; i++) {
                    var digto = digitosMascara[i].digito;
                    if (_regex.indexOf(digto) !== -1)
                        continue;
                    _regex += digto;
                    _regexLimpeza += digto;
                }
                _regex += "]+";
                _regexLimpeza += "]+";
                // Regex para validar mascara
                var regexMascara = new RegExp(_regex);
                // Regex para limpar o conteudo da mascara
                var regexLimpeza = new RegExp(_regexLimpeza, "g");

                var EhDigitoValido = function(key){                    
                    if (key != 37 && key != 39 && key != 16 && key != 17 && key != 37 && key != 8 && key != 38 && key != 40 
                        && (ultimoDigitoValido == 37 && key == 65)){
                        return true;
                        ultimoDigitoValido = key;
                    }
                    else 
                        return false;
                }

                var RetirarMascara = function (strTexto) {
                    for (var i = 0; i < digitosMascara.length; i++) {
                        strTexto = strTexto.replace(digitosMascara[i].digito, '');
                    }
                    return strTexto;
                }

                var ultimoValor = null;
                var Mascarar = function (texto) {
                    // se nao tem mascara retorna
                    if (digitosMascara.length == 0)
                        return texto;

                    // se o tamanho é menor que o primeiro indice retorna
                    if (texto.length < digitosMascara[0].indice + 1)
                        return texto;

                    // se houve backspace retorna
                    if (ultimoValor != null && texto.length < ultimoValor.length)
                        return texto;

                    // se o tamanho é maior que o máximo retorna a informação correta
                    if (texto.length > tamanhoMaximo)
                        return ultimoValor;

                    texto = RetirarMascara(texto);
                    var textoMascarado = texto;

                    for (var i = 0; i < digitosMascara.length; i++) {
                        var value = digitosMascara[i];
                        textoMascarado = textoMascarado.insert(value.indice, value.digito);
                        var proximo = i + 1;
                        if (angular.isDefined(digitosMascara[proximo]))
                            if (textoMascarado.length < digitosMascara[proximo].indice)
                                return textoMascarado;
                    }

                    return textoMascarado;
                }

                ngModelCtrl.$parsers.push(function (valorView) {
                    
                    if (angular.isUndefined(valorView)) {
                        var valorView = '';
                    }
                    var valor = Mascarar(valorView);
                    ultimoValor = valor;                    
                    if (valorView !== valor) {
                        ngModelCtrl.$setViewValue(valor);
                        ngModelCtrl.$render();
                    }

                    if (angular.isDefined(attrs.converteMascaraParaNumero))
                        return Number(valor);
                    else
                        return valor;
                });

                element.bind('keydown', function (event) {
                    // bloqueia o espaço
                    if (event.keyCode === 32) {
                        event.preventDefault();
                    }

                    if (angular.isDefined(ngModelCtrl.$viewValue) && ngModelCtrl.$viewValue != null &&
                        ngModelCtrl.$viewValue.length == tamanhoMaximo && EhDigitoValido(event.keyCode)) {
                        var elm = element[0];

                        // Se tiver algum texto selecionado, permite a substituição deste texto
                        var valorSelecionado = elm.value.substr(elm.selectionStart, elm.selectionEnd);
                    
                        if (valorSelecionado == "") {
                            event.preventDefault();
                        }
                    }
                });

                element.bind('blur', function (e) {
                    if (angular.isDefined(ngModelCtrl.$viewValue) && ngModelCtrl.$viewValue != null) {
                        ngModelCtrl.$setViewValue(Mascarar(ngModelCtrl.$viewValue));
                        ngModelCtrl.$render();
                    }
                });
            }
        }
    }

})();

(function () {
    'use strict';

    angular
        .module('app.diretivas')
        .directive('imSelecionarProximoComponenteEnterPressionado', imSelecionarProximoComponenteEnterPressionadoDirective)

    function imSelecionarProximoComponenteEnterPressionadoDirective() {
        return {
            restrict: 'A',
            link: function (scope, element, attrs) {
                element.bind("keydown keypress", function (event) {
                    if (event.which === 13) {
                        event.preventDefault();

                        if (attrs.imSelecionarProximoComponenteEnterPressionado)
                            document.getElementById(attrs.imSelecionarProximoComponenteEnterPressionado).focus();
                        else
                            throw new Error("é necessário definir o id do próximo elemento");
                    }
                });
            }
        }
    }

})();

/**
 * Created by nova on 29/08/2016.
 */
(function () {
  'use strict';

  angular
    .module('app.diretivas')
    .directive('mascaraConversorStringParaData', mascaraConversorStringParaDataDirective);

  function mascaraConversorStringParaDataDirective($filter) {
    return {
      restrict: "A",
      require: "^ngModel",
      link: function (scope, element, attrs, ngModelCtrl) {

        ngModelCtrl.$parsers.push(function (modelValue) {
          if (modelValue) {
            var data = $filter('date')(modelValue, 'dd/MM/yyyy');
            var dataFormatada = data.split('/');
            return new Date(dataFormatada[2], dataFormatada[1] - 1, dataFormatada[0]);
          }
          else{
            return null;
          }
        });

        ngModelCtrl.$formatters.push(function (modelValue) {
          if (modelValue) {
            var data = $filter('date')(modelValue, 'dd/MM/yyyy');
            var dataFormatada = data.split('/');
            return new Date(dataFormatada[2], dataFormatada[1] - 1, dataFormatada[0]);
          } else {
            return null;
          }
        });
      }
    }

  }

})();

(function () {
    'use strict';

    angular
        .module('app.diretivas')
        .directive('imEnterPressionado', imEnterPressionadoDirective)

    function imEnterPressionadoDirective() {
        return {
            restrict: 'A',
            link: function (scope, element, attrs) {
                element.bind("keydown keypress", function (event) {
                    if (event.which === 13) {
                        scope.$apply(function () {
                            scope.$eval(attrs.imEnterPressionado, {$event: event})
                        });

                        event.preventDefault();
                    }
                });
            }
        }
    }

})();

(function () {
    'use strict';

    angular
        .module('app.diretivas')
        .controller('ImSelecaoArquivosController', ImSelecaoArquivosController)
        .directive('imSelecaoArquivos', imSelecaoArquivosDirective);


    function ImSelecaoArquivosController($q, $scope, $interval, MdToastService, MdDialogService, ServicosGenericoService) {
        var vm = this;

        //#region gion Data

        var _funcaoIntervalProgresso = undefined,
            _eventArquivosSelecionados = undefined;

        _init();
        //#endregion


        //#region  Definição Métodos
        vm.metodos = {
            selecionarArquivos: selecionarArquivos,
            enviarArquivos: enviarArquivos,
            excluirTodosArquivosSelecionados: excluirTodosArquivosSelecionados,
            excluirArquivoSelecionado: excluirArquivoSelecionado,
            retornarTextoExtensaoTamanhoArquivosSelecionados: retornarTextoExtensaoTamanhoArquivosSelecionados,
        }

        var metodosInternos = {
            _init: _init,
            _redefinirArquivosSelecionados: _redefinirArquivosSelecionados,
            _retornarTamanhoMaximoArquivosSelecionados: _retornarTamanhoMaximoArquivosSelecionados,
            _atualizarArquivosSelecionados: _atualizarArquivosSelecionados,
            _atualizarTamanhoArquivosSelecionados: _atualizarTamanhoArquivosSelecionados,
            _atualizarCaption: _atualizarCaption,
            _calcularTamanhoArquivos: _calcularTamanhoArquivos,
            _retornarTextoCaption: _retornarTextoCaption,
            _inserirArquivoQuandoUtilizandoTabela: _inserirArquivoQuandoUtilizandoTabela,
            _consistirArquivos: _consistirArquivos,
            _iniciarPreLoader: _iniciarPreLoader,
            _finalizarPreLoader: _finalizarPreLoader
        };
        //#endregion

        //#region Métodos

        $scope.$watch('vm.tamanhoArquivosSelecionados', function (newValue, oldValue) {
            if (newValue > vm.tamanhoMaximoArquivosSelecionados)
                vm.tamanhoMaximoArquivosSelecionadosExcedidos = true;
            else
                vm.tamanhoMaximoArquivosSelecionadosExcedidos = false;
        });

        function selecionarArquivos(event, arquivos) {
            _eventArquivosSelecionados = event;
            if (!arquivos || arquivos.length <= 0) {
                _redefinirArquivosSelecionados();
                return;
            }

            _atualizarArquivosSelecionados(arquivos).then(function (sucesss) {
                _atualizarTamanhoArquivosSelecionados(sucesss);
                _atualizarCaption(sucesss);
            });
        }

        function enviarArquivos(event, arquivos) {
            if (vm.imMetodoEnviar) {
                _iniciarPreLoader();

                var _verificadoConsistenciaArquivos = _consistirArquivos(arquivos);
                if (_verificadoConsistenciaArquivos != "") {
                    MdDialogService.alertPadrao("", event, _verificadoConsistenciaArquivos);
                    _finalizarPreLoader();
                    return;
                }


                var promessa = vm.imMetodoEnviar();
                if (promessa) {
                    promessa.then(
                        function (success) {
                            if (success && !vm.imPreencherMensagemSuccesNoController)
                                MdToastService.toastPadrao("Arquivos enviados com sucesso!");

                            _redefinirArquivosSelecionados();

                            _finalizarPreLoader();
                        }, function (error) {
                            ServicosGenericoService.exibirAlertaDeErro(error, event);
                            _finalizarPreLoader();
                        });
                }
                else
                    _finalizarPreLoader();
            }
        }

        function excluirTodosArquivosSelecionados(event) {
            _redefinirArquivosSelecionados();
        }

        function excluirArquivoSelecionado(event, arquivo) {
            _eventArquivosSelecionados.target.value = null;
            var index = vm.arquivosSelecionados.map(function (item) { return item.name }).indexOf(arquivo.name);
            vm.arquivosSelecionados.splice(index, 1);
            selecionarArquivos(_eventArquivosSelecionados, vm.arquivosSelecionados);
        }

        function retornarTextoExtensaoTamanhoArquivosSelecionados(tamanhoArquivosSelecionados) {
            if (!vm.imTamanhoMaximoArquivos)
                return "";

            var _textoTamanhoArquivosSelecionados = "";
            if (tamanhoArquivosSelecionados < 1024) {
                _textoTamanhoArquivosSelecionados = Math.trunc(tamanhoArquivosSelecionados) + "B";
            }
            else if (tamanhoArquivosSelecionados >= 1024 && tamanhoArquivosSelecionados < 1048576) {
                _textoTamanhoArquivosSelecionados = Math.trunc((tamanhoArquivosSelecionados / 1024)) + "Kb";
            }
            else if (tamanhoArquivosSelecionados >= 1048576 && tamanhoArquivosSelecionados < 1073741824) {
                _textoTamanhoArquivosSelecionados = Math.trunc((tamanhoArquivosSelecionados / (1024 * 1024))) + "Mb";
            }
            else {
                _textoTamanhoArquivosSelecionados = Math.trunc((tamanhoArquivosSelecionados / (1024 * 1024 * 1024))) + "Gb";
            }

            return "(" + _textoTamanhoArquivosSelecionados + ")";
        }

        //#endregion

        //#region Métodos Internos
        function _init() {
            vm.controladorRequisicao = {
                requisicaoSolicitada: false,
                progresso: 0
            };

            vm.tamanhoArquivosSelecionados = 0;
            vm.arquivosSelecionados = [];
            vm.tamanhoMaximoArquivosSelecionadosExcedidos = false;
            vm.tamanhoMaximoArquivosSelecionados = _retornarTamanhoMaximoArquivosSelecionados(vm.imTamanhoMaximoArquivos);

            _atualizarCaption(null);


            if (vm.imUtilizaButtonEnviar && (!vm.imMetodoEnviar))
                throw new Error("Quando utilizado o butão enviar é necessário definir o método enviar")

            if (angular.isUndefined(vm.imHabilitarTabela))
                vm.habilitarTabela = true;
        }

        function _redefinirArquivosSelecionados() {
            _eventArquivosSelecionados.target.value = null;
            vm.tamanhoArquivosSelecionados = 0;
            vm.arquivosSelecionados = [];

            _atualizarCaption(null);
        }

        function _retornarTamanhoMaximoArquivosSelecionados(tamanhoMaximoArquivos) {
            if (!tamanhoMaximoArquivos)
                return null;

            var _tamanhoMaximoArquivosSelecionadosTemp = tamanhoMaximoArquivos.replace(/\D+/g, '');
            var _extensasotamanhoMaximoArquivosSelecionadosTemp = tamanhoMaximoArquivos.replace(/\d+/g, '');


            if (_extensasotamanhoMaximoArquivosSelecionadosTemp.toLowerCase() == 'k')
                return _tamanhoMaximoArquivosSelecionadosTemp;
            else if (_extensasotamanhoMaximoArquivosSelecionadosTemp.toLowerCase() == 'kb')
                return _tamanhoMaximoArquivosSelecionadosTemp * 1024;
            else if (_extensasotamanhoMaximoArquivosSelecionadosTemp.toLowerCase() == 'mb')
                return _tamanhoMaximoArquivosSelecionadosTemp * (1024 * 1024);
            else if (_extensasotamanhoMaximoArquivosSelecionadosTemp.toLowerCase() == 'gb')
                return _tamanhoMaximoArquivosSelecionadosTemp * (1024 * 1024 * 1024);
            else
                throw new Error("Tipo de extensão de arquivo não encontrado informe um tipo válido: 'K', 'Kb', 'Mb', 'Gb'")

        }

        function _atualizarArquivosSelecionados(arquivos) {
            var _deferred = $q.defer();
            if (!vm.imUtilizaTabela) {
                vm.arquivosSelecionados = arquivos;
                _deferred.resolve(vm.arquivosSelecionados);
            }
            else {
                _inserirArquivoQuandoUtilizandoTabela(vm.arquivosSelecionados, arquivos).then(
                    function (success) {
                        vm.arquivosSelecionados = vm.arquivosSelecionados.concat(success);
                        _deferred.resolve(vm.arquivosSelecionados);
                    });
            }
            return _deferred.promise;
        }

        function _atualizarTamanhoArquivosSelecionados(arquivos) {
            vm.tamanhoArquivosSelecionados = _calcularTamanhoArquivos(arquivos);
        }

        function _atualizarCaption(arquivos) {
            var _textoTempCaption = "", _textoTempTamanhoArquivos = "";

            if (!arquivos) {
                _textoTempCaption = "Selecionar Arquivos"
                if (vm.imTamanhoMaximoArquivos)
                    _textoTempCaption += " (Limite Total " + vm.imTamanhoMaximoArquivos + ")";

                vm.caption = _textoTempCaption;
            }
            else {
                _textoTempCaption = _retornarTextoCaption(arquivos);
                _textoTempTamanhoArquivos = retornarTextoExtensaoTamanhoArquivosSelecionados(vm.tamanhoArquivosSelecionados);

                vm.caption = vm.arquivosSelecionados.length + " " + _textoTempCaption + " " + _textoTempTamanhoArquivos;
            }
        }

        function _calcularTamanhoArquivos(arquivos) {
            var _tamanhoArquivosTemp = 0;

            angular.forEach(arquivos, function (arquivo) {
                _tamanhoArquivosTemp += arquivo.size;
            });

            return _tamanhoArquivosTemp;
        }

        function _retornarTextoCaption(arquivos) {
            if (arquivos.length == 1)
                return "arquivo selecionado";
            else
                return "arquivos selecionados"
        }

        function _inserirArquivoQuandoUtilizandoTabela(arquivosSelecionados, arquivos) {
            var _deferred = $q.defer(),
                _arquivosSelecionadosTemp = [];

            angular.forEach(arquivos, function (itemArquivo) {
                var index = arquivosSelecionados.map(function (itemMap) { return itemMap.name }).indexOf(itemArquivo.name);
                if (index == -1)
                    _arquivosSelecionadosTemp.push(itemArquivo);
            });
            _deferred.resolve(_arquivosSelecionadosTemp);
            return _deferred.promise;
        }

        function _consistirArquivos(arquivos) {
            var mensagem = "";
            for (var i = 0; i < arquivos.length; i++) {
                var arquivo = arquivos[i];
                if (arquivo.size == 0) {
                    if (mensagem == "")
                        mensagem += "Não foi possível realizar o envio do(s) arquivo(s), pois o(s) seguinte(s) arquivo(s) pode(m) ter sido alterado(s) ou removido(s) da pasta: <br>";

                    mensagem += arquivo.name + "<br>";
                }
            }
            return mensagem;
        }

        function _iniciarPreLoader() {
            vm.controladorRequisicao.requisicaoSolicitada = true;
            _funcaoIntervalProgresso = $interval(function () {
                vm.controladorRequisicao.progresso += 3;

                if (vm.controladorRequisicao.progresso >= 100)
                    vm.controladorRequisicao.progresso = 0;
            }, 100);
        }

        function _finalizarPreLoader() {
            vm.controladorRequisicao.requisicaoSolicitada = false;
            vm.controladorRequisicao.progresso = 0;
            $interval.cancel(_funcaoIntervalProgresso);
            _funcaoIntervalProgresso = undefined;
        }
        //#endregion

    }

    function imSelecaoArquivosDirective() {
        return {
            templateUrl: 'app/compartilhado/diretivas/im-selecao-arquivos/im-selecao-arquivos.html',
            restrict: 'E',
            controller: 'ImSelecaoArquivosController as vm',
            scope: {},
            bindToController: {
                arquivosSelecionados: '=?',
                imPreencherMensagemSuccesNoController: '=?',
                imTamanhoMaximoArquivos: '@?',
                imUtilizaButtonEnviar: '=?',
                imMetodoEnviar: '&?',
                imUtilizaTabela: '=?',
                imPesquisarNaTabela: '=?',
                imHabilitarTabela: '=?',
                imDesabilitarButomEnviar: '=?'
            }
        }
    }

})();

(function () {
    'use strict';

    angular
        .module('app.diretivas')
        .directive('imFileChange', imFileChangeDirective)

    function imFileChangeDirective() {
        return {
            restrict: 'A',
            scope: {
                imFileChange: '&?'
            },
            link: function (scope, element) {

                element.on('change', function (event) {
                    scope.$apply(function () {
                        scope.imFileChange({ $event: event, arquivos: event.target.files })
                    })
                })

            }
        }
    }

})();

/**
 * Created by nova on 27/10/2016.
 */
(function () {
    'use strict';

    angular.module('app.diretivas')
        .controller('GroupButtonHorizontalController', GroupButtonHorizontalController)
        .directive('groupButtonHorizontal', groupButtonHorizontalDirective);

    function GroupButtonHorizontalController($scope, MdDialogService, MdToastService) {
        var vm = this;

        //<editor-fold desc="Data">
        vm.requisicaSolicitada = false;
        //</editor-fold>

        //<editor-fold desc"Definição dos Métodos">
        var metodosInterno = {
            redefineConfiguracoesIniciaisNoFormulario: redefineConfiguracoesIniciaisNoFormulario
        };
        vm.metodosGroupButtonHorizontal = {
            salvar: salvar,
            editar: editar,
            cancelar: cancelar
        };
        //</editor-fold>

        //<editor-fold desc"Implementação dos Métodos">
        /**
         * Função que interage com o recurso link da diretiva,
         * para pegar o controle do formulário
         * @param formCtrl
         */
        $scope.getFormCtrl = function (formCtrl) {
            vm.formulario = formCtrl;
        };

        //<editor-fold desc"Métodos Interno">
        function redefineConfiguracoesIniciaisNoFormulario() {
            vm.formulario.$setUntouched();
            vm.formulario.$setPristine();
        }
        //</editor-fold>

        //<editor-fold desc"Métodos GroupButtonHorizontal">
        function salvar(event) {
            vm.requisicaSolicitada = true;
            if (vm.controleForm && vm.controleForm.preLoaderToolbar && vm.controleForm.preLoaderToolbar.inicioProgresso)
                vm.controleForm.preLoaderToolbar.inicioProgresso();
            vm.salvar().then(
                function (success) {
                    MdToastService.toastPadrao(vm.nomeEntidade + " cadastrado com sucesso!");
                    metodosInterno.redefineConfiguracoesIniciaisNoFormulario();

                    vm.entidade = {};
                    vm.entidades.push(success.data);
                    vm.requisicaSolicitada = false;
                    vm.verificaEditarAtivo = false;

                    if (vm.controleForm && vm.controleForm.preLoaderToolbar && vm.controleForm.preLoaderToolbar.fimProgresso)
                        vm.controleForm.preLoaderToolbar.fimProgresso();
                },
                function (error) {
                    MdDialogService.alertPadrao(error.data, event);
                    vm.requisicaSolicitada = false;

                    if (vm.controleForm && vm.controleForm.preLoaderToolbar && vm.controleForm.preLoaderToolbar.fimProgresso)
                        vm.controleForm.preLoaderToolbar.fimProgresso();
                });
        }
        function editar(event) {
            vm.requisicaSolicitada = true;
            if (vm.controleForm && vm.controleForm.preLoaderToolbar && vm.controleForm.preLoaderToolbar.inicioProgresso)
                vm.controleForm.preLoaderToolbar.inicioProgresso();
            vm.editar().then(
                function (success) {
                    MdToastService.toastPadrao(vm.nomeEntidade + " editado com sucesso!");
                    metodosInterno.redefineConfiguracoesIniciaisNoFormulario();

                    angular.forEach(vm.entidades, function (item, index) {
                        if (item.codigo === success.data.codigo) {
                            vm.entidades[index] = success.data;
                        }
                    });                    
                    vm.entidade = {};
                    vm.requisicaSolicitada = false;
                    vm.verificaEditarAtivo = false;

                    if (vm.controleForm && vm.controleForm.preLoaderToolbar && vm.controleForm.preLoaderToolbar.fimProgresso)
                        vm.controleForm.preLoaderToolbar.fimProgresso();
                },
                function (error) {
                    MdDialogService.alertPadrao("Falha ao editar o Registro\n Detalhes: " + error.data, event);                    
                    vm.requisicaSolicitada = false;

                    if (vm.controleForm && vm.controleForm.preLoaderToolbar && vm.controleForm.preLoaderToolbar.fimProgresso)
                        vm.controleForm.preLoaderToolbar.fimProgresso();
                });
        }
        function cancelar() {
            vm.entidade = {};
            metodosInterno.redefineConfiguracoesIniciaisNoFormulario();
            vm.verificaEditarAtivo = false;
        }
        //</editor-fold>

        //</editor-fold>

    }

    function groupButtonHorizontalDirective() {
        return {
            templateUrl: 'app/compartilhado/diretivas/group-button-horizontal/group-button-horizontal.html',
            controller: 'GroupButtonHorizontalController as vm',
            restrict: 'AE',
            require: '^form',
            scope: {},
            bindToController: {
                entidade: '=?',
                entidades: '=?',
                verificaEditarAtivo: '=?',
                salvar: '&?',
                editar: '&?',
                controleForm: '=?',
                nomeEntidade: '@?'
            },
            link: function (scope, element, attr, formCtrl) {
                scope.getFormCtrl(formCtrl);
            }
        }
    }

})();

/**
 * Created by nova on 01/09/2016.
 */
(function () {
    'use strict';

    angular
        .module('app.diretivas')
        .controller('GroupButtonController', GroupButtonController)
        .directive('groupButton', groupButtonDirective);

    function GroupButtonController($scope, $rootScope, MdDialogService, MdToastService) {
        var vm = this;

        // Data
        vm.requisicaoSolicitada = false
        var entidadeTemporaria = null;
        var verificaSeExisteEntidade;
        var verificaCancelar = true;
        var promessa;
        var existeAtributoRegistroExistente = false;
        ////////////////////////////////////////

        // Métodos

        /**
         * Função que interage com o recurso link da diretiva,
         * para pegar o controle do formulário
         * @param formCtrl
         */
        $scope.getFormCtrl = function (formCtrl) {
            vm.formulario = formCtrl;
        };

        $scope.verfificarSeExisteAtributo = function(existe){
            existeAtributoRegistroExistente = existe;
        }

        var metodosInternos = {
            salvar: function () {
                vm.requisicaoSolicitada = true;
                if (angular.isDefined(vm.toolbarPreLoader)) {
                    vm.toolbarPreLoader.inicioProgresso();
                }
                promessa = vm.salvar();
                promessa.then(
                    function (success) {
                        vm.requisicaoSolicitada = false;
                        if (angular.isDefined(vm.toolbarPreLoader)) {
                            vm.toolbarPreLoader.fimProgresso();
                        }
                        vm.entidade = success.data;
                        verificaCancelar = false;
                        MdToastService.toastPadrao("Registro cadastrado com sucesso!");
                        vm.metodosControladores.cancelarEdicao();
                    },
                    function (error) {
                        vm.requisicaoSolicitada = false;
                        if (angular.isDefined(vm.toolbarPreLoader)) {
                            vm.toolbarPreLoader.fimProgresso();
                        }
                        MdDialogService.alertPadrao(error.data);
                    });
            },
            editar: function () {
                vm.requisicaoSolicitada = true;
                if (angular.isDefined(vm.toolbarPreLoader)) {
                    vm.toolbarPreLoader.inicioProgresso();
                }
                promessa = vm.editar();
                promessa.then(
                    function (success) {
                        vm.requisicaoSolicitada = false;
                        if (angular.isDefined(vm.toolbarPreLoader)) {
                            vm.toolbarPreLoader.fimProgresso();
                        }
                        vm.entidade = success.data;
                        verificaCancelar = false;
                        MdToastService.toastPadrao("Registro editado com sucesso!");
                        vm.metodosControladores.cancelarEdicao();
                    },
                    function (error) {
                        vm.requisicaoSolicitada = false;
                        if (angular.isDefined(vm.toolbarPreLoader)) {
                            vm.toolbarPreLoader.fimProgresso();
                        }
                        MdDialogService.alertPadrao(error.data);
                    });
            }
        };

        vm.metodosControladores = {
            habilitaEditar: function (entidade) {
                $rootScope.desabilitarMudancaDeEstadoDaAplicacao = true;

                entidadeTemporaria = angular.copy(entidade);
                verificaCancelar = true;
                vm.controladorAtivo = true;

                if (existeAtributoRegistroExistente){
                    verificaSeExisteEntidade = vm.registroExistente;
                }
                else
                    verificaSeExisteEntidade = entidade;


            },
            cancelarEdicao: function () {
                vm.controladorAtivo = false;
                $rootScope.desabilitarMudancaDeEstadoDaAplicacao = false;
                vm.formulario.$setUntouched();
                vm.formulario.$setPristine();

                if (verificaCancelar) {
                    vm.entidade = entidadeTemporaria;
                }

            }
        };

        vm.metodosButtons = {
            salvar: function (event) {
                if (!verificaSeExisteEntidade) {
                    metodosInternos.salvar();
                }
                else {
                    metodosInternos.editar();
                }
            },
            excluir: function (event) {
                MdDialogService.confirmPadraoComEvento("Excluir",
                    'Deseja realmente excluir o registro ?', event, function () {
                        vm.requisicaoSolicitada = true;
                        if (angular.isDefined(vm.toolbarPreLoader)) {
                            vm.toolbarPreLoader.inicioProgresso();
                        }
                        promessa = vm.excluir();
                        promessa.then(
                            function (success) {
                                vm.requisicaoSolicitada = false;
                                if (angular.isDefined(vm.toolbarPreLoader)) {
                                    vm.toolbarPreLoader.fimProgresso();
                                }
                                verificaCancelar = false;
                                MdToastService.toastPadrao(success.data);
                                vm.entidade = null;
                                vm.metodosControladores.cancelarEdicao();
                            },
                            function (error) {
                                vm.requisicaoSolicitada = false;
                                if (angular.isDefined(vm.toolbarPreLoader)) {
                                    vm.toolbarPreLoader.fimProgresso();
                                }
                                MdDialogService.alertPadrao(error.data, event);
                            });
                    });
            }
        };

        ////////////////////////////////////////

    }

    function groupButtonDirective() {
        return {
            templateUrl: 'app/compartilhado/diretivas/group-button/group-button.html',
            controller: 'GroupButtonController as vm',
            restrict: 'AE',
            require: '^form',
            scope: {},
            bindToController: {
                ngDisabled: '=?',
                ngDisabledExcluir: '=?',
                preLoader: '=?',
                entidade: '=?',
                registroExistente: '=?',
                controladorAtivo: '=?',
                salvar: '&?',
                editar: '&?',
                excluir: '&?',
                toolbarPreLoader: '=?'
            },
            link: function (scope, element, attr, formCtrl) {
                scope.getFormCtrl(formCtrl);
                scope.verfificarSeExisteAtributo(angular.isDefined(attr.registroExistente))
            }
        }
    }

})();

(function () {
    'use strict';

    angular
        .module('app.diretivas')
        .directive('cardRiscoPerdaContratual', cardRiscoPerdaContratual);
    function cardRiscoPerdaContratual() {
        return {
            templateUrl: 'app/compartilhado/diretivas/card-risco-perda-contratual/card-risco-perda-contratual.html',
            restrict: 'E',
            scope: {
                exibirIcone: '<'
            }
        };
    }
})();
/**
 * Created by nova on 19/08/2016.
 */
(function () {
    'use strict';

    angular
        .module('app.diretivas')
        .controller('HeaderPadraoController', HeaderPadraoController)
        .directive('headerPadrao', headerPadraoDirective);

    function HeaderPadraoController() {
        var vm = this;

        vm.navegarParaEstadoAnterior = navegarParaEstadoAnterior;

        function navegarParaEstadoAnterior() {
            if (angular.isDefined(vm.voltarAoEstadoAnterior)) {
                vm.voltarAoEstadoAnterior();
            }
            else {
                alert("É necessário implementar o método para voltar ao estado anterior");
            }
        }

        if (angular.isUndefined(vm.ngUtilizaPesquisa)) {
            vm.ngUtilizaPesquisa = true;
        }
    }

    function headerPadraoDirective() {
        return {
            templateUrl: 'app/compartilhado/diretivas/header-padrao/header-padrao.html',
            restrict: 'E',
            scope: {
                icone: '@?',
                translateNome: '@?',                
            },
            controller: 'HeaderPadraoController as vm',
            bindToController: {
                liberarPesquisaQuandoDatatableAtivo: '=?',
                pesquisar: '=?',
                ngUtilizaPesquisa: '=?',
                textoAuxiliar: '=?',
                textoAuxiliarHabilitado: '=?',
                habilitarIconeVoltarAoEstadoAnterior: '=?',
                voltarAoEstadoAnterior: '&?',
                mensagemTooltipIconeEstadoAnterior: '=?'
            }

        }
    }

})();

/**
 * Created by nova on 09/09/2016.
 */
(function () {
  'use strict';

  angular
    .module('app.diretivas')
    .controller('DefineFocusController', DefineFocusController)
    .directive('defineFocus', defineFocusDirective);

  function DefineFocusController($scope, $timeout) {
    var vm = this;
    var elemento;

    $scope.getElement = function (element) {
      elemento = element;
    }


    if (angular.isUndefined(vm.defineFocusNoCampoQuandoNovaPesquisa)) {
      vm.defineFocusNoCampoQuandoNovaPesquisa = false;
    }

    if (vm.defineFocusNoCampoQuandoNovaPesquisa) {
      if (angular.isDefined(vm.modelFocus)) {
        $scope.$watch('vm.modelFocus', function (newValue, oldValue) {
          if (Object.getOwnPropertyNames(newValue).length === 0) {
            $timeout(function () {
              elemento.focus();
            });
          }
        });
      } else {
        alert("O atributo: define-focus-no-campo-quando-nova-pesquisa está habilitado\nÉ necessário definir o model em: model-focus");
      }
    } 
    else {
      $timeout(function () {
        elemento.focus();
      });      
    }
  }

  function defineFocusDirective($timeout) {
    return {
      restrict: 'A',
      scope: {},
      controller: 'DefineFocusController as vm',
      bindToController: {
        defineFocus: '=?',
        modelFocus: '=?',
        defineFocusNoCampoQuandoNovaPesquisa: '=?'
      },
      link: function (scope, element, attrs) {
        scope.getElement(element);
      }
    }
  }

})();

(function () {
    'use strict';

    angular
        .module('app.diretivas')
        .controller('CarregamentoCircularController', CarregamentoCircularController)
        .directive('carregamentoCircular', carregamentoCircular);

    function CarregamentoCircularController($scope) {
        var vm = this;
    }


    /** @ngInject */
    function carregamentoCircular() {

        return {
            templateUrl: "app/compartilhado/diretivas/carregamento-circular/carregamento-circular.html",
            controller: 'CarregamentoCircularController as vm',
            restrict: 'E',
            scope: {},
            bindToController: {
                emProgresso: '=?',
                mensagem: '@?',
                titulo: '@?'
            }
        }
    }

}());
(function () {
    'use strict';

    angular
        .module('app.diretivas')
        .controller('CardTagsAtendimentoController', CardTagsAtendimentoController)
        .directive('cardTagsAtendimento', cardTagsAtendimento);

    function CardTagsAtendimentoController($mdSelect, $mdDialog, $scope, ListarCoresTagsAtendimento) {
        var vm = this;
        vm.model = vm.model || [];
        vm.metodos = {
            adicionarItens: adicionarItens,
            removerItem: removerItem,
            retornaCodigoItemSelecionado: retornaCodigoItemSelecionado,
            configuraMdSelectTags: configuraMdSelectTags,
            sincronizarModelComData: sincronizarModelComData,
            abrirDialogCadastroTags: abrirDialogCadastroTags
        };

        $scope.$on('formAlterado', function () {
            vm.form.atendimento.$setDirty();
        });

        function sincronizarModelComData() {
            $scope.$emit('formAlterado');
        }

        function adicionarItens() {
            if (!vm.itensSelecionados || !Array.isArray(vm.itensSelecionados)) {
                vm.itensSelecionados = [];
                return;
            }

            vm.itensSelecionados.forEach(function (itemSelecionado) {
                if (!vm.model.includes(itemSelecionado.codigo)) {
                    vm.model.push(itemSelecionado.codigo);
                }
            });

            vm.itensSelecionados = [];
            $scope.$emit('formAlterado');
        }


        function removerItem(codigo) {
            vm.model = vm.model.filter(function (item) {
                return item !== codigo;
            });
            $scope.$emit('formAlterado');
        }

        function retornaCodigoItemSelecionado(codigo) {
            const item = (vm.todasTagsCadastradas || []).find(function (item) {
                return item.codigo === codigo;
            });

            if (item) {
                const corEncontrada = ListarCoresTagsAtendimento.find(function (cor) {
                    return cor.background === item.corIdentificacao;
                });

                return {
                    descricao: item.descricao,
                    corTexto: item.ativa ? (corEncontrada ? corEncontrada.fonte : '#000') : 'rgba(0, 0, 0, 0.6);',
                    corBackground: item.ativa ? item.corIdentificacao : '#ccc',
                    inativo: !item.ativa
                };
            }
        }

        function configuraMdSelectTags() {
            vm.filtrarTags = "";
            angular
                .element("#card-tags-atendimento-md-select")
                .on("keydown", function (ev) {
                    ev.stopPropagation();
                });
        }

        $scope.$watch('vm.data', function (newValue) {
            if (newValue) {
                sincronizarModelComData();
            }
        });

        function abrirDialogCadastroTags() {
            $mdSelect.hide();
            $mdDialog.show({
                controller: 'DialogCadastroTagAtendimentoController',
                controllerAs: 'vm',
                templateUrl: 'app/main/atendimento/cadastro/tag-atendimento/dialog-cadastro-tags/dialog-cadastro-tags.html',
                multiple: true,
                fullscreen: true,
                clickOutsideToClose: true,
                locals: {
                    ListarDetalhesUsuarioESolucoes: vm.listarDetalhesUsuarioESolucoes,
                    DialogCadastro: true,
                    CodigoSolucaoSelecionada: vm.codigoSolucaoSelecionada,
                    DescricaoSugerida: vm.filtrarTags
                }
            }).then(function (houveAlteracao) {
                $scope.$emit('dialogFechado', houveAlteracao);
            });
        }
    }

    function cardTagsAtendimento() {
        return {
            templateUrl: 'app/compartilhado/diretivas/card-tags-atendimento/card-tags-atendimento.html',
            controller: 'CardTagsAtendimentoController as vm',
            restrict: 'E',
            scope: {
                data: '=',
                model: '=',
                form: '=?',
                descricaoExibicao: '@?',
                disabled: '=?',
                required: '=?',
                listarDetalhesUsuarioESolucoes: '=?',
                codigoSolucaoSelecionada: '=?',
                todasTagsCadastradas: '=?'
            },
            bindToController: true
        };
    }
})();

(function () {
    'use strict';
    angular
        .module('app.diretivas')
        .directive('caracteresPermitidos', caracteresPermitidosDirective);

    /** @ngInject */
    function caracteresPermitidosDirective() {
        return {
            restrict: 'A',
            require: 'ngModel',
            link: function (scope, element, attrs, ngModelCtrl) {
                var regexDeCaracteresInvalidos = /[^a-zA-Z0-9áàâãéèêíïóôõöúçñÁÀÂÃÉÈÊÍÏÓÔÕÖÚÇÑ \-!@#$%^&*()_=+\[\]{};':"\\|,.<>\/?~`]/g;

                function removerCaracteresInvalidos(texto) {
                    if (!texto) {
                        return undefined;
                    }

                    var textoLimpo = texto.replace(regexDeCaracteresInvalidos, '');

                    if (textoLimpo !== texto) {
                        ngModelCtrl.$setViewValue(textoLimpo);
                        ngModelCtrl.$render();
                    }
                    return textoLimpo;
                }

                ngModelCtrl.$parsers.push(removerCaracteresInvalidos);
            }
        };
    }
})();

/**
 * Created by nova on 09/09/2016.
 */
(function () {
    'use strict';

    angular
        .module('app.diretivas')
        .controller('CardQuantidadeLicencaController', CardQuantidadeLicencaController)
        .directive('cardQuantidadeLicencaDirective', cardQuantidadeLicencaDirective);

    function CardQuantidadeLicencaController($scope, GerenciamentoProtecaoService) {
        var vm = this;

        init();

        vm.metodos = {
            editar: editar
        }

        function editar() {
            if (vm.disableEditar)
                return;
            vm.editar();
        }


        function init() {
            if (!vm.quantidade)
                vm.quantidade = "0";

            if (!vm.quantidadeDisponiveis)
                vm.quantidadeDisponiveis = "0";

            if (!vm.quantidadeUtilizado)
                vm.quantidadeUtilizado = "0";

            if (vm.tamanhoTitulo && vm.titulo.trim().length > vm.tamanhoTitulo)
                vm.titulo = vm.titulo.substring(0, vm.tamanhoTitulo) + '...';

            vm.quantidade = GerenciamentoProtecaoService.formata30AEsquerda(vm.quantidade);
            vm.quantidadeDisponiveis = GerenciamentoProtecaoService.formata30AEsquerda(vm.quantidadeDisponiveis);
            vm.quantidadeUtilizado = GerenciamentoProtecaoService.formata30AEsquerda(vm.quantidadeUtilizado);
        }

    }

    function cardQuantidadeLicencaDirective() {
        return {
            templateUrl: 'app/compartilhado/diretivas/card-quantidade-licença/card-quantidade-licenca.html',
            restrict: 'E',
            scope: {},
            controller: 'CardQuantidadeLicencaController as vm',
            bindToController: {
                titulo: '=?',
                quantidade: '=?',
                texto: '@?',
                tamanhoTitulo: '=?',
                quantidadeUtilizado: '=?',
                quantidadeDisponiveis: '=?',
                editar: '&?',
                disableEditar: "=?"
            }
        }
    }

})();

(function () {
    'use strict';

    angular
        .module('app.diretivas')
        .controller('CardDocumentacaoSolicitacaoController', CardDocumentacaoSolicitacaoController)
        .directive('cardDocumentacaoSolicitacao', cardDocumentacaoSolicitacao);



    function CardDocumentacaoSolicitacaoController($scope, SolicitacaoFactory, MdDialogService) {
        var vm = this;
        vm.solicitacao = SolicitacaoFactory.solicitacao;
        console.log('vm.solicitacao: ', vm.solicitacao);

        vm.metodos = {
            abrirDialogEditar: vm.abrirDialogEditar,
            editar: editar,
            visualizar: visualizar,
            abrirDialogVisualizar: vm.abrirDialogVisualizar,
            verificarOperacaoEdicao: verificarOperacaoEdicao,
            verificarVisualizacao: verificarVisualizacao
        }



        function verificarOperacaoEdicao() {
            const exp = vm.etapa.etapa;
            switch (exp) {
                case 1:
                    return true;
                case 2:
                    return vm.solicitacao.solicitacaoDocumentacao.solicitacao !== null;
                case 3:
                    return vm.solicitacao.solicitacaoDocumentacao.teste !== null;
                case 4:
                    return vm.solicitacao.solicitacaoDocumentacao.analise !== null;
                default:
                    break;
            };
        }
        function verificarVisualizacao() {
            console.log('tem história vinculada?');
            const exp = vm.etapa.etapa;
            switch (exp) {
                case 1:
                    return vm.solicitacao.solicitacaoDocumentacao.solicitacao !== null;
                case 2:
                    return vm.solicitacao.solicitacaoDocumentacao.teste !== null;
                case 3:
                    return vm.solicitacao.solicitacaoDocumentacao.analise !== null;
                case 4:
                    return vm.solicitacao.solicitacaoDocumentacao.historia !== null || (vm.solicitacao.estoriaVinculos && vm.solicitacao.estoriaVinculos.length > 0);
                default:
                    break;
            };
        }
        function editar() {
            const editavel = verificarOperacaoEdicao();
            if (editavel)
                vm.abrirDialogEditar();
            else
                MdDialogService.alertPadrao("Para inserir dados nesta fase, é preciso adicionar dados na fase anterior.");
        }

        function visualizar() {
            const ret = verificarVisualizacao();
            if (ret)
                vm.abrirDialogVisualizar();
            else
                MdDialogService.alertPadrao("Não existe documentação para esta fase.");
        }
    }

    function cardDocumentacaoSolicitacao() {
        return {
            templateUrl: 'app/compartilhado/diretivas/card-documentacao-solicitacao/card-documentacao-solicitacao.html',
            controller: 'CardDocumentacaoSolicitacaoController as vm',
            restrict: 'E',
            transclude: true,
            scope: {},
            bindToController: {
                titulo: '=?',
                etapa: '=?',
                abrirDialogEditar: '&?',
                abrirDialogVisualizar: '&?',
                esconderEdicao: '=?'
            }
        }
    }

}());
(function () {
    'use strict';

    angular
        .module('app.service')
        .service('UsuarioService', UsuarioService);

    /** @ngInject */
    function UsuarioService(Api, RequisicaoGenericaService, MdToastService, PgToolbarService, MdDialogService, $q, RotasHtml) {
        // Métodos de Requests region

        // Método de request interno do Serviço
        var listarGenericamente = function (rota, colaborador, controleForm, controlePreloader) {
            var deferred = $q.defer();

            PgToolbarService.iniciarPreLoaderToolbar(controleForm, controlePreloader);
            RequisicaoGenericaService.listarSemParams(rota + colaborador.codigo).then(
                function (success) {
                    PgToolbarService.finalizarPreLoaderToolbar(controleForm, controlePreloader);
                    deferred.resolve(success.data);
                },
                function (error) {
                    PgToolbarService.finalizarPreLoaderToolbar(controleForm, controlePreloader);
                    deferred.reject(error.data);
                });
            return deferred.promise;
        }

        var carregarCategoriasSeleciondas = function (categoria, categoriasSelecionadas){
            for (var i = categoriasSelecionadas.length - 1; i >= 0; i--) {
                var item = {
                    codigo:categoriasSelecionadas[i].categoria.codigo,
                    descricao: categoriasSelecionadas[i].categoria.descricao
                };
                categoria.push(item);
            }
        };
        // endregion

        this.verificaTabSelecionada = function (tab, usuario, controleForm, controlePreloader, categoria) {
            switch (tab) {
                case 'detalhesColaborador':
                    listarGenericamente(Api.usuario.detalhes_usuario.listarDetalhesUsuario, usuario, controleForm, controlePreloader).then
                        (function (success) {
                            usuario.detalhes = success;
                            carregarCategoriasSeleciondas(categoria, usuario.detalhes.usuariosDetalheCategorias);
                        });
                    break;

                case 'enderecoColaborador':
                    listarGenericamente(Api.usuario.detalhes_usuario.listarDetalhesUsuario, usuario, controleForm, controlePreloader).then
                        (function (success) { usuario.detalhes = success; });
                    break;

                case 'contatoColaborador':
                    listarGenericamente(Api.usuario.detalhes_usuario.listarDetalhesUsuario, usuario, controleForm, controlePreloader).then
                        (function (success) { usuario.detalhes = success; });
                    break;
                case 'permissoes':
                  if(usuario.codigo == undefined)
                        break;
                  listarGenericamente(Api.usuario.configuracaoUsuario.listarConfiguracao,usuario,controleForm,controlePreloader)
                  .then(function(success){
                     usuario.dias = success.dias,
                     usuario.horaInicio = success.horaInicio,
                     usuario.horaFim = success.horaFim; });
                  break;

                default:
                    break;
            }
        };

        this.controlaButtonsToolbar = function (tab, controleForm) {
            if (tab !== 'colaborador') {
                if (angular.isDefined(controleForm)) {
                    controleForm.desabilitarButtonEditar = true;
                    controleForm.desabilitarButtonInserir = true;
                    controleForm.desabilitarButtonExcluir = true;
                    controleForm.desabilitarButtonListarTodos = true;
                    controleForm.desabilitarMetodoToolbarAtualizar = true;
                }
            } else {
                if (angular.isDefined(controleForm)) {
                    controleForm.desabilitarButtonEditar = false;
                    controleForm.desabilitarButtonInserir = false;
                    controleForm.desabilitarButtonExcluir = false;
                    controleForm.desabilitarButtonListarTodos = false;
                    controleForm.desabilitarMetodoToolbarAtualizar = false;
                }
            }
        };

        this.listarHtmlRotas = function () {
            return RotasHtml.usuario;
        };
    }
})();


(function () {
    'use strict';

    angular
        .module('app.service')
        .service('TreeControlService', TreeControlService);

    /** @ngInject */
    function TreeControlService(ControleAcessoConfig) {

        this.carregarOpcoesTree = carregarOpcoesTree;
        this.expandirMenus = expandirMenus;


        var _arrayMenusExpandidos = [];

        var metodosInternos = {
            _expandirTodosMenus: _expandirTodosMenus
        }

        //#region Implementação dos Métodos
        function carregarOpcoesTree(nodeChildren) {
            return {
                nodeChildren: nodeChildren,
                dirSelectable: true,
                injectClasses: {
                    ul: "md-title",
                    li: "md-title",
                    liSelected: "md-title",
                    iExpanded: "md-title",
                    iCollapsed: "md-title",
                    iLeaf: "md-title",
                    label: "md-title",
                    labelSelected: "md-title"
                }
            }
        }

        function expandirMenus(menu) {
            _arrayMenusExpandidos = [];
            if (!menu || typeof (menu) == "array" && menu.length == 0)
                return;

            _expandirTodosMenus(menu);              
            return _arrayMenusExpandidos;
        }
        //#endregion

        //#region Métodos Internos

        function _expandirTodosMenus(menu) {                        
            for (var i = 0; i < menu.length; i++) {
                _arrayMenusExpandidos.push(menu[i]);

                if (menu[i] && menu[i].subMenus)
                    _expandirTodosMenus(menu[i].subMenus)
            }
        }

        //#endregion
    }
})();

(function () {
    'use strict';

    angular
        .module('app.service')
        .service('ToolbarService', ToolbarService);

    /** @ngInject */
    function ToolbarService() {
        const ICONE_SQUAD = {
            1: 'alpha.svg',
            2: 'elite.svg',
            3: 'partners.svg'
        };

        this.armazenarCodigoSquadUsuarioLogado = function (codigoSquads) {
            sessionStorage.setItem('codigoSquad_usuarioLogado', JSON.stringify(codigoSquads));
        };

        this.codigoSquadUsuarioLogado = function () {
            return JSON.parse(sessionStorage.getItem('codigoSquad_usuarioLogado')) || [];
        };

        this.obterIconePadrao = function (codigoSquad) {
            return ICONE_SQUAD[codigoSquad] || 'alpha.svg';
        };

        this.atualizarFlagsSquad = function (squadUsuarioLogado) {
            return {
                temSquadAlpha: squadUsuarioLogado.includes(1),
                temSquadElite: squadUsuarioLogado.includes(2),
                temSquadPartners: squadUsuarioLogado.includes(3)
            };
        };

        this.armazenarSquadSelecionado = function (codigoSquad) {
            localStorage.setItem('squadSelecionado', JSON.stringify(codigoSquad));
        };

        this.squadSelecionado = function () {
            var squad = JSON.parse(localStorage.getItem('squadSelecionado'));
            return squad || null;
        };

    }
})();

(function ()
{
  'use strict';

  angular
    .module('app.service')
    .service('TokenService', TokenService);

  /** @ngInject */
  function TokenService(ControleAcessoConfig) {
    this.setarToken = function(strToken) {
      sessionStorage.setItem(ControleAcessoConfig.key_token, strToken);
    }

    this.getToken = function() {
      return sessionStorage.getItem(ControleAcessoConfig.key_token);
    }
  }
})();

angular
    .module('app.service')
    .service('SquadService', function (ListarSquads) {

        this.setarValorSquad = function (campoFormulario, codigoSquadUsuarioLogado) {
            if (campoFormulario) {
                return campoFormulario;
            } else if (codigoSquadUsuarioLogado.length === 1) {
                return [codigoSquadUsuarioLogado[0]];
            } else {
                return codigoSquadUsuarioLogado;
            }
        };

        this.listarSquadsUsuarioLogado = function (squadUsuarioLogado) {
            return ListarSquads.filter(function (squad) {
                return squadUsuarioLogado.includes(squad.codigo);
            });
        }

        this.descricaoSquad = function (codigoSquad) {
            switch (codigoSquad) {
                case 1:
                    return "Alpha";
                case 2:
                    return "Elite";
                case 3:
                    return "Partners";
            }
        };
    });
(function () {
    'use strict';
    angular
        .module('app.service')
        .service('SprintService', SprintService);

    function SprintService($rootScope, Api, DataTableConfigPadrao, PgToolbarService, RequisicaoGenericaService, MdDialogService, $q) {

        // Métodos de Request region
        var listarGenericamente = function (rota, numeroSprint, squadCodigo, controleForm, controlePreloader) {
            var deferred = $q.defer();
            PgToolbarService.iniciarPreLoaderToolbar(controleForm, controlePreloader);
            RequisicaoGenericaService.listarSemParams(rota + numeroSprint + "/" + squadCodigo).then(
                function (success) {
                    PgToolbarService.finalizarPreLoaderToolbar(controleForm, controlePreloader);
                    deferred.resolve(success.data);
                },
                function (error) {
                    PgToolbarService.finalizarPreLoaderToolbar(controleForm, controlePreloader);
                    deferred.reject(error.data);
                });
            return deferred.promise;
        }
        //endregion

        this.verificaTabAtiva = function (tab, controladorSprint, sprint, numeroSprint, controleForm, aux, controlePreloader, squadCodigo) {
            switch (tab) {
                case 'backlog':
                    listarGenericamente(Api.sprint.backlog.listarPor, numeroSprint, squadCodigo, controleForm, controlePreloader)
                        .then(function (success) {
                            sprint.backlogEstorias = success.backlog;
                            aux.estorias = success.backlog;
                        });
                    break;
                case 'recursos':
                    controladorSprint.tabRecursos.ativa = true;
                    controladorSprint.tabAbatimentos.ativa = false;
                    controladorSprint.tabLimites.ativa = false;
                    listarGenericamente(Api.sprint.recurso.listarPor, numeroSprint, squadCodigo, controleForm, controlePreloader)
                        .then(function (success) {
                            sprint.recursos = success;
                        });
                    break;
                case 'abatimentos':
                    controladorSprint.tabRecursos.ativa = false;
                    controladorSprint.tabAbatimentos.ativa = true;
                    controladorSprint.tabLimites.ativa = false;
                    listarGenericamente(Api.sprint.abatimento.listarPor, numeroSprint, squadCodigo, controleForm, controlePreloader)
                        .then(function (success) {
                            sprint.abatimentos = success;
                        });
                    break;
                case 'registros':
                    listarGenericamente(Api.sprint.registro.listarPor, numeroSprint, squadCodigo, controleForm, controlePreloader)
                        .then(function (success) {
                            sprint.registros = success.registros;
                            sprint.totalDeHorasPorRegistroSituacao = success.totalHorasRegistros;
                        });
                    break;
                case 'limites':
                    controladorSprint.tabRecursos.ativa = false;
                    controladorSprint.tabAbatimentos.ativa = false;
                    controladorSprint.tabLimites.ativa = true;
                    listarGenericamente(Api.sprint.registro_situacao_limite_aceitavel.listarPor, numeroSprint, squadCodigo, controleForm, controlePreloader).then(function (success) {
                        sprint.situacoesLimitesAceitaveis = success;
                    });
                    break;
                case 'metas':
                    listarGenericamente(Api.sprint.meta.listarPor, numeroSprint, squadCodigo, controleForm)
                        .then(function (success) {
                            sprint.metas = success;
                        });
                    break;
                case 'estatisticas':
                    listarGenericamente(Api.sprint.backlog.listarEstatistica, numeroSprint, squadCodigo, controleForm, controlePreloader).then(function (success) {
                        sprint.estatisticas = success;
                    });
                    break;
                case 'cerimoniaDetalhe':
                    listarGenericamente(Api.sprint.cerimonia_detalhe.listarPor, numeroSprint, squadCodigo, controleForm, controlePreloader).then(function (success) {
                        sprint.detalhesDaCerimonia = success;
                    });
                    break;
                case 'versaoEntregue':
                    listarGenericamente(Api.sprint.versao_entrega.listarPor, numeroSprint, squadCodigo, controleForm, controlePreloader)
                        .then(function (success) {
                            sprint.versoesEntregues = success;
                        });
                    break;
                case 'pontuacao':
                    listarGenericamente(Api.sprint.pontuacao.listarPontuacaoColaboradores, numeroSprint, squadCodigo)
                        .then(function (success) {
                            sprint.colaboradores = success;
                        });
                    break;
                default:
                    controladorSprint.tabRecursos.ativa = false;
                    controladorSprint.tabAbatimentos.ativa = false;
                    controladorSprint.tabLimites.ativa = false;
                    break;
            }
        };

        this.controlaButtonsToolbar = function (controleForm, tab) {
            if (angular.isDefined(controleForm)) {
                if (tab != 'sprint') {
                    controleForm.desabilitarButtonEditar = true;
                    controleForm.desabilitarButtonInserir = true;
                    controleForm.desabilitarButtonExcluir = true;
                    controleForm.desabilitarButtonListarTodos = true;
                    controleForm.desabilitarMetodoToolbarAtualizar = true;
                } else {
                    controleForm.desabilitarButtonEditar = false;
                    controleForm.desabilitarButtonInserir = false;
                    controleForm.desabilitarButtonExcluir = false;
                    controleForm.desabilitarButtonListarTodos = false;
                    controleForm.desabilitarMetodoToolbarAtualizar = false;
                }
            }
        };

        this.verificaTabParaHabilitarPesquisarHeaderPadrao = function (tab) {
            if (tab == 'backlog' || tab == 'recursos' || tab == 'abatimentos' || tab == 'limites' || tab == 'metas' || tab == 'cerimoniaDetalhe' || tab == 'versaoEntregue' || tab == 'historico' || tab == 'tarefas' || tab == 'registros' || tab == 'estatisticas') {
                return true;
            } else {
                return false;
            }
        };

        this.verificaLegendasSelecionadasRegistros = function (totalHorasRegistros) {
            if ($rootScope.registrosSelecionados) {
                angular.forEach(totalHorasRegistros, function (itemTotalHoraRegistro) {
                    angular.forEach($rootScope.registrosSelecionados, function (itemRegistroSelecionado, valueRegistroSelecionado) {
                        if (itemTotalHoraRegistro.descricao.indexOf(itemRegistroSelecionado) !== -1) {
                            itemTotalHoraRegistro.legendaSelecionada = true;
                        }
                    });
                });
            }
        };

    }


})();

(function () {
    'use strict';
    angular
        .module('app.service')
        .service('SolucaoRotinasTarefasService', SolucaoRotinasTarefasService);

    function SolucaoRotinasTarefasService($q, Api, RequisicaoGenericaService, PgToolbarService) {

        // Métodos de Requests region
        var listarGenericamente = function (rota, solucaoCodigo, controleForm, controlePreloader) {
            var deferred = $q.defer();
            PgToolbarService.iniciarPreLoaderToolbar(controleForm, controlePreloader);
            RequisicaoGenericaService.listarSemParams(Api.solucao_rotinas_tarefas.rotinas.listarRotinasPorSolucao + solucaoCodigo).then(
                function (success) {
                    console.log(success.data);
                    PgToolbarService.finalizarPreLoaderToolbar(controleForm, controlePreloader);
                    deferred.resolve(success.data);
                },
                function (error) {
                    PgToolbarService.finalizarPreLoaderToolbar(controleForm, controlePreloader);
                    deferred.reject(error.data);
                });
            return deferred.promise;
        };
        //endregion

        this.verificaTabSelecionada = function (tab, solucao, solucaoCodigo, controleForm, controlePreloader) {
            switch (tab) {
                case 'rotinas':
                    listarGenericamente(Api.solucao_rotinas_tarefas.rotinas.listarRotinasPorSolucao, solucaoCodigo, controleForm, controlePreloader).then(function (success) {
                        solucao.rotinas = success;
                    })
                    break;
                case 'tarefas':
                    listarGenericamente(Api.solucao_rotinas_tarefas.rotinas.listarRotinasPorSolucao, solucaoCodigo, controleForm, controlePreloader).then(function (success) {
                        solucao.rotinas = success;
                    })
                    break;
                default:
                    break;
            }
        };

        this.controlaButtonsToolbar = function (controleForm, tab) {
            if (tab !== 'solucao') {
                if (angular.isDefined(controleForm)) {
                    controleForm.desabilitarButtonEditar = true;
                    controleForm.desabilitarButtonInserir = true;
                    controleForm.desabilitarButtonExcluir = true;
                    controleForm.desabilitarButtonListarTodos = true;
                    controleForm.desabilitarMetodoToolbarAtualizar = true;
                }
            } else {
                if (angular.isDefined(controleForm)) {
                    controleForm.desabilitarButtonEditar = false;
                    controleForm.desabilitarButtonInserir = false;
                    controleForm.desabilitarButtonExcluir = false;
                    controleForm.desabilitarButtonListarTodos = false;
                    controleForm.desabilitarMetodoToolbarAtualizar = false;
                }
            }
        };

        this.verificaTabParaHabilitarPesquisarHeaderPadrao = function (tab) {
            if (tab == 'rotinas') {
                return true;
            } else {
                return false;
            }
        };

    }

})();

(function () {
    'use strict';

    angular
        .module('app.service')
        .service('SessionStorageService', SessionStorageService);

    /** @ngInject */
    function SessionStorageService() {

        this.armazenar = function (chave, valor) {
            sessionStorage.setItem(chave, JSON.stringify(valor));
        }

        this.recuperar = function (chave) {
            return JSON.parse(sessionStorage.getItem(chave));
        }

        this.remover = function (chave) {
            sessionStorage.removeItem(chave);
        }

        this.removerTodosItens = function(){
            sessionStorage.clear();
        }
    } // SessionStorageService
})();

(function () {
    'use strict';

    angular
        .module('app.service')
        .service('ServicosGenericoService', ServicosGenericoService);


    function ServicosGenericoService($q, $timeout, Api, RequisicaoGenericaService, MdDialogService, MdToastService) {

        this.pesquisarAutoCompleteCodigoOuNomeGenericoApi = pesquisarAutoCompleteCodigoOuNomeGenericoApi;
        this.pesquisarAutoCompleteCodigoOuNomeGenericoApiParamsEmFormatoString = pesquisarAutoCompleteCodigoOuNomeGenericoApiParamsEmFormatoString;
        this.pesquisarAutoCompleteCodigoOuNomeGenerico = pesquisarAutoCompleteCodigoOuNomeGenerico;
        this.pesquisarAutoCompleteCodigoOuDescricaoGenericoApi = pesquisarAutoCompleteCodigoOuDescricaoGenericoApi;
        this.pesquisarAutoCompleteCodigoOuDescricaoGenerico = pesquisarAutoCompleteCodigoOuDescricaoGenerico;
        this.pesquisarAutoCompleteDescricaoGenericoApi = pesquisarAutoCompleteDescricaoGenericoApi;
        this.pesquisarAutoCompleteDescricaoGenericoApiComParam = pesquisarAutoCompleteDescricaoGenericoApiComParam;
        this.pesquisarAutoCompleteDescricaoGenerico = pesquisarAutoCompleteDescricaoGenerico;
        this.retornaSomatorioDeHorasEMinutos = retornaSomatorioDeHorasEMinutos;
        this.excluirRegistroPorCodigoOuGenericamente = excluirRegistroPorCodigoOuGenericamente;
        this.excluirRegistroPorCodigoOuGenericamenteEmDialogs = excluirRegistroPorCodigoOuGenericamenteEmDialogs;
        this.retornaHoraFormataComTempo = retornaHoraFormataComTempo;
        this.definirDataAtual = definirDataAtual;
        this.definirTempoParaNull = definirTempoParaNull;
        this.retornarControladorDialog = retornarControladorDialog;
        this.exibirPreloaderRequisicaoIniciada = exibirPreloaderRequisicaoIniciada;
        this.ocultarPreloaderRequisicaoFinalizada = ocultarPreloaderRequisicaoFinalizada;
        this.exibirAlertaDeErro = exibirAlertaDeErro;

        /**
         * Método para buscar api na rota passada como parametro por código ou nome
         * com base no texto digitado pelo usuário
         * @param {*rota para pesquisar na api} Rota
         * @param {*texto pesquisado no camo md-autocomplete-cliente} query
         */
        function pesquisarAutoCompleteCodigoOuNomeGenericoApi(rota, query) {
            var queryConsulta = {};
            if (parseInt(query))
                queryConsulta.codigo = query;
            else
                queryConsulta.nome = query;

            var deferred = $q.defer();
            $timeout(function () {
                RequisicaoGenericaService.listarComParams(rota, queryConsulta).then(
                    function (success) {
                        deferred.resolve(success.data);
                    },
                    function (error) {
                        deferred.reject(error.data);
                    });
            });
            return deferred.promise;
        }


        /**
         * Método para buscar api com params em formato string na rota passada como parametro por código ou nome
         * com base no texto digitado pelo usuário
         * @param {*rota para pesquisar na api} Rota
         * @param {*texto pesquisado no camo md-autocomplete-cliente} query
         */
        function pesquisarAutoCompleteCodigoOuNomeGenericoApiParamsEmFormatoString(rota, query) {
            var queryConsulta = {};
            if (parseInt(query))
                queryConsulta.codigo = query;
            else
                queryConsulta.nome = query;

            var deferred = $q.defer();
            $timeout(function () {
                RequisicaoGenericaService.listarComParamsFormatoString(rota, queryConsulta).then(
                    function (success) {
                        deferred.resolve(success.data);
                    },
                    function (error) {
                        deferred.reject(error.data);
                    });
            });
            return deferred.promise;
        }

        /**
        * Método que irá buscar buscar um objeto por código ou nome  em cima da lista passada como parametro no md-autocomplete
        * @param {listaAPesquisar} listaAPesquisar Lista generica de pesquisa
        * @param {*texto pesquisado no campo md-autocomplete} queryDePesquisa query generica
        */
        function pesquisarAutoCompleteCodigoOuNomeGenerico(listaAPesquisar, queryDePesquisa) {
            var query = queryDePesquisa.toLowerCase();
            var resultado = query ? listaAPesquisar.filter(function (item, index) {
                return (item.codigo == query || item.nome.toLowerCase().search(query) != -1);
            }) : listaAPesquisar;
            return resultado;
        }

        /**
         * Método para buscar api na rota passada como parametro por código ou descricao
         * com base no texto digitado pelo usuário
         * @param {*rota para pesquisar na api} Rota
         * @param {*texto pesquisado no camo md-autocomplete-cliente} query
         */
        function pesquisarAutoCompleteCodigoOuDescricaoGenericoApi(rota, query) {
            var queryConsulta = {};
            if (parseInt(query))
                queryConsulta.codigo = query;
            else
                queryConsulta.descricao = query;

            var deferred = $q.defer();
            $timeout(function () {
                RequisicaoGenericaService.listarComParams(rota, queryConsulta).then(
                    function (success) {
                        deferred.resolve(success.data);
                    },
                    function (error) {
                        deferred.reject(error.data);
                    });
            });
            return deferred.promise;
        }

        /**
         * Método que irá buscar buscar um objeto por código ou descrição em cima da lista passada como parametro no md-autocomplete
         * @param {listaAPesquisar} listaAPesquisar Lista generica de pesquisa
         * @param {*texto pesquisado no campo md-autocomplete} queryDePesquisa query generica
         */
        function pesquisarAutoCompleteCodigoOuDescricaoGenerico(listaAPesquisar, queryDePesquisa) {
            var query = queryDePesquisa.toLowerCase();
            var resultado = query ? listaAPesquisar.filter(function (item, index) {
                return (item.codigo == query || item.descricao.toLowerCase().search(query) != -1);
            }) : listaAPesquisar;
            return resultado;
        }

        /**
         * Método para buscar api na rota passada como parametro por descricao
         * com base no texto digitado pelo usuário
         * @param {*rota para pesquisar na api} Rota
         * @param {*texto pesquisado no camo md-autocomplete-cliente} queryDePesquisa
         */
        function pesquisarAutoCompleteDescricaoGenericoApi(rota, queryDePesquisa) {
            var queryConsulta = {
                descricao: queryDePesquisa
            };

            var deferred = $q.defer();
            $timeout(function () {
                RequisicaoGenericaService.listarComParams(rota, queryConsulta).then(
                    function (success) {
                        deferred.resolve(success.data);
                    },
                    function (error) {
                        deferred.reject(error.data);
                    });
            });
            return deferred.promise;
        }

        function pesquisarAutoCompleteDescricaoGenericoApiComParam(rota, queryDePesquisa, param) {
            var queryConsulta = {
                descricao: queryDePesquisa
            };

            var deferred = $q.defer();
            $timeout(function () {
                RequisicaoGenericaService.listarComParams(rota + "/" + param, queryConsulta).then(
                    function (success) {
                        deferred.resolve(success.data);
                    },
                    function (error) {
                        deferred.reject(error.data);
                    });
            });
            return deferred.promise;
        }

        /**
         * Método que irá buscar buscar um objeto por descrição em cima da lista passada como parametro no md-autocomplete
         * @param {listaAPesquisar} listaAPesquisar Lista generica de pesquisa
         * @param {*texto pesquisado no campo md-autocomplete} queryDePesquisa query generica
         */
        function pesquisarAutoCompleteDescricaoGenerico(listaAPesquisar, queryDePesquisa) {
            var query = queryDePesquisa.toLowerCase();
            var resultado = query ? listaAPesquisar.filter(function (item, index) {
                return (item.descricao.toLowerCase().search(query) != -1);
            }) : listaAPesquisar;
            return resultado;
        }

        /**
         * Recebe um array de Tempo e realiza o retorna o somatario de horas e minutos do mesmo
         * @param {*arrayDeHorasEMinutos} arrayTotalHoras
         */
        function retornaSomatorioDeHorasEMinutos(arrayTotalHoras) {
            var tempoTotal = 0;
            arrayTotalHoras.forEach(function (item, index) {
                if (item[0] && item[1]) {
                    item[0] = parseInt(item[0]) * 60;
                    item[1] = parseInt(item[1]);
                    tempoTotal += item[0] + item[1];
                }
            });

            var horasTotais = Math.floor(tempoTotal / 60);
            var minutosTotais = tempoTotal % 60;

            var stringHoras = horasTotais.toString().length === 1 ? "0" + horasTotais : horasTotais;
            var stringMinutos = minutosTotais.toString().length === 1 ? "0" + minutosTotais : minutosTotais;

            return stringHoras + ":" + stringMinutos;
        }

        /**
         * Método que faz uma requisição para Api para excluir uma Entidade por código
         * @param {*rota Api} rota
         * @param {*Lista de Entidade} entidades
         * @param {*Entidade a ser excluida} entidade
         * @param {*vm.controleForm} controleForm
         * @param {*event do button} event
         * @param {*Titulo da Mensagem} tituloMensagem
         * @param {*Delegate de função se necessário} functionSuccess
         */
        function excluirRegistroPorCodigoOuGenericamente(rota, entidades, entidade, controleForm, event, tituloMensagem, functionSuccess, index,
            dataExclusao) {
            if (tituloMensagem) {
                var mensagem = tituloMensagem;
            } else {
                var mensagem = 'Deseja realmente excluir o Registro?';
            }

            if (dataExclusao) {
                var dataParaExclusao = dataExclusao;
            }
            else {
                var dataParaExclusao = entidade.codigo
            }
            MdDialogService.confirmPadraoComEvento("Excluir",
                mensagem, event,
                function () {
                    if (controleForm) {
                        if (controleForm.preLoaderToolbar)
                            controleForm.preLoaderToolbar.inicioProgresso();
                    }
                    RequisicaoGenericaService.excluir(rota, dataParaExclusao).then(
                        function (success) {
                            if (controleForm) {
                                if (controleForm.preLoaderToolbar)
                                    controleForm.preLoaderToolbar.fimProgresso();
                            }

                            if (index || typeof index !== 'undefined') {
                                entidades.splice(index, 1);
                            }
                            else {
                                entidades.splice(entidades.indexOf(entidade), 1);
                            }

                            if (functionSuccess) {
                                functionSuccess(success);
                            } else {
                                MdToastService.toastPadrao(success.data);
                            }
                        },
                        function (error) {
                            MdDialogService.alertPadrao(error.data, event);
                            if (controleForm) {
                                if (controleForm.preLoaderToolbar)
                                    controleForm.preLoaderToolbar.fimProgresso();
                            }
                        });
                });
        }

        /**
         * Método que faz uma requisição para Api para excluir uma Entidade por código em Dialogs
         * @param {*rota Api} rota
         * @param {*Lista de Entidade} entidades
         * @param {*Entidade a ser excluida} entidade
         * @param {*vm.preloader} preloader.habilitar Váriavel para habilitar o preloader do dialog aberto
         * @param {*event do button} event
         * @param {*Titulo da Mensagem} tituloMensagem
         * @param {*Delegate de função se necessário} functionSuccess
         */
        function excluirRegistroPorCodigoOuGenericamenteEmDialogs(rota, entidades, entidade, preloader, mdDialog, event, tituloMensagem,
            functionSuccess, index, mensagemExclusao, dataExclusao) {
            if (tituloMensagem) {
                var mensagem = tituloMensagem;
            } else {
                var mensagem = 'Deseja realmente excluir o Registro?';
            }

            if (dataExclusao) {
                var dataParaExclusao = dataExclusao;
            }
            else {
                var dataParaExclusao = entidade.codigo
            }

            MdDialogService.confirmPadraoComEvento("Excluir",
                mensagem, event,
                function () {

                    if (preloader) {
                        preloader.habilitar = true;
                        preloader.requisicaoSolicitada = true;
                        if (mensagemExclusao) {
                            preloader.mensagem = mensagemExclusao;
                            preloader.mensagemPreloader = mensagemExclusao;

                        }
                    }
                    RequisicaoGenericaService.excluir(rota, dataParaExclusao).then(
                        function (success) {

                            if (preloader) {
                                preloader.habilitar = false;
                                preloader.mensagem = null;
                                preloader.requisicaoSolicitada = false;
                                preloader.mensagemPreloader = mensagemExclusao;
                                if (mensagemExclusao)
                                    preloader.mensagem = null;
                            }


                            if (entidades && (index || typeof index !== 'undefined')) {
                                entidades.splice(index, 1);
                            }
                            else if (entidades) {
                                entidades.splice(entidades.indexOf(entidade), 1);
                            }

                            if (functionSuccess) {
                                functionSuccess(success);
                            } else {
                                MdToastService.toastPadrao(success.data);
                            }

                            if (mdDialog) {
                                mdDialog.hide();
                            }
                        },
                        function (error) {
                            if (preloader) {
                                preloader.habilitar = false;
                                preloader.requisicaoSolicitada = false;
                            }
                            MdDialogService.alertPadrao(error.data, event);
                        });
                });
        }

        /**
         * Método que recebe uma data sem tempo e retorna uma data formatada "dd/MM/yyyy - hh-MM-ss"
         * @param {*data que será passada como parametro} dataSemTempo
         */
        function retornaHoraFormataComTempo(dataSemTempo) {
            var data = new Date();

            var dataFormatada = new Date(dataSemTempo);
            dataFormatada.setHours(data.getHours(), data.getMinutes(), data.getSeconds());

            return dataFormatada;
        }

        /**
         * Método que que retorna um data no formato 'dd/MM/yyyy' com horas, minutos, segundos e milisegundos zeradas
         */
        function definirDataAtual() {
            var data = new Date();
            data.setHours(0);
            data.setMinutes(0);
            data.setSeconds(0);
            data.setMilliseconds(0);

            return data
        }

        /**
         * Método que seta as horas, minutos, segundos e milisegundos para zero do tempo da Data
         * @param {data} data
         */
        function definirTempoParaNull(data) {
            data.setHours(0);
            data.setMinutes(0);
            data.setSeconds(0);
            data.setMilliseconds(0);

            return data;
        }

        /**
         * Método para retornar o controleDialog padrão
         */
        function retornarControladorDialog() {
            return {
                requisicaoSolicitada: false,
                mensagemPreloader: ""
            };
        }

        /**
         * Método genérico que recebe o objeto 'preloader' e habilita a sua requisição e seta a mensagem passada para ser exibida
         * @param {object} preloader
         * @param {string} mensagem
         */
        function exibirPreloaderRequisicaoIniciada(preloader, mensagem) {
            preloader.requisicaoSolicitada = true;
            mensagem ? preloader.mensagemPreloader = mensagem : preloader.mensagemPreloader = "";
        }

        /**
         * Método genérico que recebe o objeto 'preloader' e desabilita a sua requisição e seta a mensagem do objeto para null
         * @param {object} preloader
         */
        function ocultarPreloaderRequisicaoFinalizada(preloader) {
            preloader.requisicaoSolicitada = false;
            preloader.mensagemPreloader = "";
        }

        /**
      * Método que exibi o alerta de erro padrão verificando se existe quebra de linha no texto assim exibindo as linhas quebradas
      * caso exista ou em forma de titulo caso não exista
      * @param {object} error error
      * @param {event} event event do botão
      */
        function exibirAlertaDeErro(error, event) {
            console.log('erro', error);
            if (error && error.data && (typeof error.data.substrituirQuebraDeLinhasParaTagHtml !== "undefined")) {
                if (error.data.indexOf("\n") != -1)
                    MdDialogService.alertPadrao("Atenção!", event, error.data.substrituirQuebraDeLinhasParaTagHtml());
                else if (error.data.indexOf("<br>") != -1 || error.data.indexOf("<br/>") != -1)
                    MdDialogService.alertPadrao("Atenção!", event, error.data);
                else
                    MdDialogService.alertPadrao("Atenção!", event, error.data);
            }
            else if (error && error.data.error) {
                MdDialogService.alertPadrao("Atenção!", event, error.data.error[0]);
            }
            else if (error && error.data && error.data.length > 0 && error.data[0].errorMessage) {
                let mensagensError = error.data.map(function(item) {
                    return item.errorMessage;
                }).join("<br>");
                MdDialogService.alertPadrao("Atenção!", event, mensagensError);
            }
            else if (error && error.data) {
                MdDialogService.alertPadrao("Atenção!", event, error.data);
            }
        }

    }

})();

(function ()
{
  'use strict';

  angular
    .module('app.service')
    .service('SegurancaService', SegurancaService);

  /** @ngInject */
  function SegurancaService(ApiAcesso, $http, ControleAcessoConfig, TokenService) {
    this.AlterarSenha = function (_strLogin, _strSenhaAtual, _strSenhaNova) {
      var lstrLogin = btoa(_strLogin);
      var lstrSenhaAtual = btoa (_strSenhaAtual);
      var lstrSenhaNova = btoa (_strSenhaNova);
      var token = TokenService.getToken();
      var configuracao = ControleAcessoConfig.configuracao;

      var lstrUrl = configuracao.url_base_api + ApiAcesso.baseUrl +
        ApiAcesso.seguranca.alterarsenha +
        "?strLogin=" + lstrLogin + "&strSenhaAtual=" + lstrSenhaAtual + "&strSenhaNova=" + lstrSenhaNova

      return $http({
        url: lstrUrl,
        method: "PUT",
        headers : { "Authorization": "Bearer " + token }
      });
    }
  }
})();

/**
 * Created by nova on 25/10/2016.
 */
(function () {
    'use strict';

    angular
        .module('app.service')
        .service('RequisicaoGenericaService', RequisicaoGenericaService);

    function RequisicaoGenericaService($log, urlApi, $http, TokenService) {

        this.listarSemParams = listarSemParams;
        this.listarComParams = listarComParams;
        this.listarComParamsFormatoString = listarComParamsFormatoString;
        this.listarComArrayDeParams = listarComArrayDeParams;
        this.baixarArquivo = baixarArquivo;
        this.salvar = salvar;
        this.salvarArquivos = salvarArquivos;
        this.salvarArquivosComObjeto = salvarArquivosComObjeto;
        this.editar = editar;
        this.excluir = excluir;
        this.excluirComObjetoComplexo = excluirComObjetoComplexo;
        this.listarComObjetoComplexo = listarComObjetoComplexo;
        this.listarPorPaginacaoJsonFormato = listarPorPaginacaoJsonFormato;
        this.postComQueryParams = postComQueryParams;

        function listarSemParams(rota) {
            var token = TokenService.getToken();

            return $http({
                url: urlApi.url_base_api + rota,
                method: "GET",
                headers: {
                    "Authorization": "Bearer " + token
                }
            });
        }

        function postComQueryParams(rota, params) {
            var token = TokenService.getToken();
            var queryString = Object.keys(params)
                .map(function (key) {
                    return encodeURIComponent(key) + '=' + encodeURIComponent(params[key]);
                })
                .join('&');
            return $http({
                url: urlApi.url_base_api + rota + '?' + queryString,
                method: 'POST',
                headers: {
                    'Authorization': 'Bearer ' + token
                }
            });
        }

        function listarComParams(rota, data) {
            var token = TokenService.getToken();

            return $http({
                url: urlApi.url_base_api + rota,
                method: "GET",
                headers: {
                    "Authorization": "Bearer " + token
                },
                params: data
            });
        }

        function listarComParamsFormatoString(rota, data) {
            var token = TokenService.getToken();
            var json = angular.toJson(data, false);

            return $http({
                url: urlApi.url_base_api + rota,
                method: "GET",
                headers: {
                    "Authorization": "Bearer " + token
                },
                params: { modelo: json }
            });
        }

        function listarComArrayDeParams(rota, parametro) {
            var token = TokenService.getToken();

            return $http({
                url: urlApi.url_base_api + rota,
                method: "GET",
                headers: {
                    "Authorization": "Bearer " + token
                },
                params: {
                    "modelo": parametro
                }
            });
        }

        function baixarArquivo(rota, data) {
            var token = TokenService.getToken();

            return $http({
                url: urlApi.url_base_api + rota,
                method: "GET",
                headers: {
                    "Authorization": "Bearer " + token
                },
                params: data,
                responseType: 'arraybuffer'
            });
        }

        function listarComObjetoComplexo(rota, data) {
            var token = TokenService.getToken();

            return $http({
                url: urlApi.url_base_api + rota,
                method: "POST",
                headers: {
                    "Authorization": "Bearer " + token
                },
                data: data
            });
        }

        function salvar(rota, data) {
            var token = TokenService.getToken();

            return $http({
                url: urlApi.url_base_api + rota,
                method: "POST",
                headers: {
                    "Authorization": "Bearer " + token
                },
                data: data
            });
        }

        function salvarArquivos(rota, data) {
            if (!data || data.length == 0) {
                $log.warn("É necessário passar um array de arquivo");
            }
            var token = TokenService.getToken();
            var formData = new FormData();

            angular.forEach(data, function (obj) {
                formData.append('files[]', obj);
            });

            return $http({
                url: urlApi.url_base_api + rota,
                method: "POST",
                transformRequest: angular.identity,
                headers: {
                    'Content-Type': undefined,
                    "Authorization": "Bearer " + token
                },
                data: formData
            });
        }

        function salvarArquivosComObjeto(rota, data) {
            if (!data || data.arquivos.length == 0) {
                $log.warn("É necessário passar um array de arquivo");
            }
            var token = TokenService.getToken();
            var formData = new FormData();

            formData.append("modelo", angular.toJson(data.modelo)),
                angular.forEach(data.arquivos, function (item) {
                    formData.append('files[]', item);
                });

            return $http({
                url: urlApi.url_base_api + rota,
                method: "POST",
                transformRequest: angular.identity,
                headers: {
                    'Content-Type': undefined,
                    "Authorization": "Bearer " + token
                },
                data: formData
            })
        }

        function editar(rota, data) {
            var token = TokenService.getToken();

            return $http({
                url: urlApi.url_base_api + rota,
                method: "PUT",
                headers: {
                    "Authorization": "Bearer " + token
                },
                data: data
            });
        }

        function excluir(rota, data) {
            var token = TokenService.getToken();

            return $http({
                url: urlApi.url_base_api + rota + data,
                method: "DELETE",
                headers: {
                    "Authorization": "Bearer " + token
                },
                data: data
            });
        }

        function excluirComObjetoComplexo(rota, data) {
            var token = TokenService.getToken();

            return $http({
                url: urlApi.url_base_api + rota,
                method: "POST",
                headers: {
                    "Authorization": "Bearer " + token
                },
                data: data
            });
        }

        function listarPorPaginacaoJsonFormato(rota, data) {
            var token = TokenService.getToken();
            var entidadeEnvio = angular.copy(data);
            entidadeEnvio.clsEntidade = angular.toJson(data.clsEntidade, false);

            return $http({
                url: urlApi.url_base_api + rota,
                method: "POST",
                headers: { "Content-Type": "Application/Json", "Authorization": "Bearer " + token },
                data: entidadeEnvio
            });
        }
    }

})();

/**
 * Created by nova on 25/10/2016.
 */
(function () {
    'use strict';

    angular
        .module('app.service')
        .service('RequisicaoGenericaLocacaoService', RequisicaoGenericaLocacaoService);

    function RequisicaoGenericaLocacaoService($log, urlApi, $http, TokenService) {

        this.listarSemParams = listarSemParams;
        this.listarComParams = listarComParams;
        this.listarComParamsFormatoString = listarComParamsFormatoString;
        this.listarComArrayDeParams = listarComArrayDeParams;
        this.baixarArquivo = baixarArquivo;
        this.salvar = salvar;
        this.salvarArquivos = salvarArquivos;
        this.salvarArquivosComObjeto = salvarArquivosComObjeto;
        this.editar = editar;
        this.excluir = excluir;
        this.excluirComObjetoComplexo = excluirComObjetoComplexo;
        this.listarComObjetoComplexo = listarComObjetoComplexo;
        this.listarPorPaginacaoJsonFormato = listarPorPaginacaoJsonFormato;


        function listarSemParams(rota) {
            var token = TokenService.getToken();

            return $http({
                url: urlApi.url_locacao_api + rota,
                method: "GET",
                headers: {
                    "Authorization": "Bearer " + token
                }
            });
        };

        function listarComParams(rota, data) {
            var token = TokenService.getToken();

            return $http({
                url: urlApi.url_locacao_api + rota,
                method: "GET",
                headers: {
                    "Authorization": "Bearer " + token
                },
                params: data
            });
        };

        function listarComParamsFormatoString(rota, data) {
            var token = TokenService.getToken();
            var json = angular.toJson(data, false);

            return $http({
                url: urlApi.url_locacao_api + rota,
                method: "GET",
                headers: {
                    "Authorization": "Bearer " + token
                },
                params: { modelo: json }
            });
        };

        function listarComArrayDeParams(rota, parametro) {
            var token = TokenService.getToken();

            return $http({
                url: urlApi.url_locacao_api + rota,
                method: "GET",
                headers: {
                    "Authorization": "Bearer " + token
                },
                params: {
                    "modelo": parametro
                }
            });
        };

        function baixarArquivo(rota, data) {
            var token = TokenService.getToken();

            return $http({
                url: urlApi.url_locacao_api + rota,
                method: "GET",
                headers: {
                    "Authorization": "Bearer " + token
                },
                params: data,
                responseType: 'arraybuffer'
            });
        };

        function listarComObjetoComplexo(rota, data) {
            var token = TokenService.getToken();

            return $http({
                url: urlApi.url_locacao_api + rota,
                method: "POST",
                headers: {
                    "Authorization": "Bearer " + token
                },
                data: data
            });
        };

        function salvar(rota, data) {
            var token = TokenService.getToken();

            return $http({
                url: urlApi.url_locacao_api + rota,
                method: "POST",
                headers: {
                    "Authorization": "Bearer " + token
                },
                data: data
            });
        };

        function salvarArquivos(rota, data) {
            if (!data || data.length == 0) {
                $log.warn("É necessário passar um array de arquivo");
            }
            var token = TokenService.getToken();
            var formData = new FormData();

            angular.forEach(data, function (obj) {
                formData.append('files[]', obj);
            });

            return $http({
                url: urlApi.url_locacao_api + rota,
                method: "POST",
                transformRequest: angular.identity,
                headers: {
                    'Content-Type': undefined,
                    "Authorization": "Bearer " + token
                },
                data: formData
            });
        }

        function salvarArquivosComObjeto(rota, data) {
            if (!data || data.arquivos.length == 0) {
                $log.warn("É necessário passar um array de arquivo");
            }
            var token = TokenService.getToken();
            var formData = new FormData();

            formData.append("modelo", angular.toJson(data.modelo)),
                angular.forEach(data.arquivos, function (item) {
                    formData.append('files[]', item);
                });

            return $http({
                url: urlApi.url_locacao_api + rota,
                method: "POST",
                transformRequest: angular.identity,
                headers: {
                    'Content-Type': undefined,
                    "Authorization": "Bearer " + token
                },
                data: formData
            })
        }

        function editar(rota, data) {
            var token = TokenService.getToken();

            return $http({
                url: urlApi.url_locacao_api + rota,
                method: "PUT",
                headers: {
                    "Authorization": "Bearer " + token
                },
                data: data
            });
        };

        function excluir(rota, data) {
            var token = TokenService.getToken();

            return $http({
                url: urlApi.url_locacao_api + rota + data,
                method: "DELETE",
                headers: {
                    "Authorization": "Bearer " + token
                },
                data: data
            });
        };

        function excluirComObjetoComplexo(rota, data) {
            var token = TokenService.getToken();

            return $http({
                url: urlApi.url_locacao_api + rota,
                method: "POST",
                headers: {
                    "Authorization": "Bearer " + token
                },
                data: data
            });
        };

        function listarPorPaginacaoJsonFormato(rota, data) {
            var token = TokenService.getToken();
            var entidadeEnvio = angular.copy(data);
            entidadeEnvio.clsEntidade = angular.toJson(data.clsEntidade, false);

            return $http({
                url: urlApi.url_locacao_api + rota,
                method: "POST",
                headers: { "Content-Type": "Application/Json", "Authorization": "Bearer " + token },
                data: entidadeEnvio
            });
        };

    }

})();

(function () {
    'use strict';

    angular
        .module('app.service')
        .service("RelatorioContratosService", RelatorioContratosService);

    function RelatorioContratosService($filter, LoginUsuarioService) {

        this.preparaFiltroParaEnvio = preparaFiltroParaEnvio;
        this.preparaFiltroReajusteParaEnvio = preparaFiltroReajusteParaEnvio;



        var formatarFiltroFormasPagamento = _formatarFiltroFormasPagamento
        var formatarFiltroCaracteristica = _formatarFiltroCaracteristica;
        var formatarFiltroClientes = _formatarFiltroClientes;
        var formatarFiltroSolucoes = _formatarFiltroSolucoes;
        var formatarFiltroProdutos = _formatarFiltroProdutos;
        var formatarFiltroTiposLicenca = _formatarFiltroTiposLicenca;
        var formatarFiltroStatus = _formatarFiltroStatus;

        var filtrosUtilizados = {
            _construiFiltrosUtilizados: _construiFiltrosUtilizados,
            _construirFiltroUtilizadoColaboradorCorrente: _construirFiltroUtilizadoColaboradorCorrente,
            _construirFiltroUtilizadoSituacaoContratual: _construirFiltroUtilizadoSituacaoContratual,
            _construirFiltroUtilizadoSituacaoFinanceira: _construirFiltroUtilizadoSituacaoFinanceira,
            _construirFiltroUtilizadoTipoPagamento: _construirFiltroUtilizadoTipoPagamento,
            _construirFiltroUtilizadoEstado: _construirFiltroUtilizadoEstado,
            _construirFiltroUtilizadoOrdenacao: _construirFiltroUtilizadoOrdenacao,
            _construirFiltroUtilizadoDatas: _construirFiltroUtilizadoDatas,
            _construirFiltroUtilizadoDatasReajuste: _construirFiltroUtilizadoDatasReajuste,
            _construirFiltroUtilizadoClientes: _construirFiltroUtilizadoClientes,
            _construirFiltroUtilizadoCaracteristicas: _construirFiltroUtilizadoCaracteristicas,
            _construiFiltrosUtilizadoSolucao: _construiFiltrosUtilizadoSolucao,
            _construirFiltroUtilizadoMotivo: _construirFiltroUtilizadoMotivo,
            _construiFiltrosUtilizadoProduto: _construiFiltrosUtilizadoProduto,
            _construiFiltrosUtilizadoProdutosANaoImprimir: _construiFiltrosUtilizadoProdutosANaoImprimir,
            _construiFiltrosUtilizadoSegmentacoes: _construiFiltrosUtilizadoSegmentacoes,
            _construiFiltrosUtilizadoExecutivos: _construiFiltrosUtilizadoExecutivos,
            _construirFiltroUtilizadoTiposLicenca: _construirFiltroUtilizadoTiposLicenca,
            _construirFiltroUtilizadoTiposLicencaANaoImprimir: _construirFiltroUtilizadoTiposLicencaANaoImprimir,
            _construirFiltroUtilizadoLicenca: _construirFiltroUtilizadoLicenca
        }

        //#region Métodos

        function preparaFiltroParaEnvio(item) {
            var filtro = angular.copy(item);
            filtro.formasPagamento = _formatarFiltroFormasPagamento(item.formasPagamento);
            filtro.caracteristicas = _formatarFiltroCaracteristica(item.caracteristicas);
            filtro.caracteristicasANaoImprimir = _formatarFiltroCaracteristica(item.caracteristicasANaoImprimir);
            filtro.caracteristicasContrato = _formatarFiltroCaracteristica(item.caracteristicasContrato);
            filtro.caracteristicasContratoANaoImprimir = _formatarFiltroCaracteristica(item.caracteristicasContratoANaoImprimir);
            filtro.caracteristicasANaoImprimir = _formatarFiltroCaracteristica(item.caracteristicasANaoImprimir);
            filtro.caracteristicasContratoItem = _formatarFiltroCaracteristica(item.caracteristicasContratoItem);
            filtro.caracteristicasContratoItemANaoImprimir = _formatarFiltroCaracteristica(item.caracteristicasContratoItemANaoImprimir);
            filtro.clientes = _formatarFiltroClientes(item.clientes);
            filtro.segmentacoes = _formatarFiltroSegmentacoes(item.segmentacoes);
            filtro.solucoes = _formatarFiltroSolucoes(item.solucoes);
            filtro.produtos = _formatarFiltroProdutos(item.produtos);
            filtro.subitens = _formatarFiltroProdutos(item.subitens);
            filtro.subitensANaoImprimir = _formatarFiltroProdutos(item.subitensANaoImprimir);
            filtro.produtosANaoImprimir = _formatarFiltroProdutos(item.produtosANaoImprimir);
            filtro.executivos = _formatarFiltroExecutivos(item.executivos);
            filtro.estados = _formatarFiltroEstados(item.estados);
            filtro.tiposLicenca = _formatarFiltroTiposLicenca(item.tiposLicenca);
            filtro.tiposLicencaANaoImprimir = _formatarFiltroTiposLicenca(item.tiposLicencaANaoImprimir);
            filtro.filtrosUtilizados = _construiFiltrosUtilizados(item);
            filtro.motivos = _formatarFiltroMotivos(item.motivos);
            filtro.empresasFaturamento = _formatarFiltroEmpresasFaturamento(item.empresasFaturamento);

            return filtro;
        }

        function preparaFiltroReajusteParaEnvio(item) {
            var filtro = angular.copy(item);
            filtro.formasPagamento = _formatarFiltroFormasPagamento(item.formasPagamento);
            filtro.caracteristicas = _formatarFiltroCaracteristica(item.caracteristicas);
            filtro.caracteristicasANaoImprimir = _formatarFiltroCaracteristica(item.caracteristicasANaoImprimir);
            filtro.caracteristicasContrato = _formatarFiltroCaracteristica(item.caracteristicasContrato);
            filtro.caracteristicasContratoANaoImprimir = _formatarFiltroCaracteristica(item.caracteristicasContratoANaoImprimir);
            filtro.caracteristicasContratoItem = _formatarFiltroCaracteristica(item.caracteristicasContratoItem);
            filtro.caracteristicasContratoItemANaoImprimir = _formatarFiltroCaracteristica(item.caracteristicasContratoItemANaoImprimir);
            filtro.clientes = _formatarFiltroClientes(item.clientes);
            filtro.segmentacoes = _formatarFiltroSegmentacoes(item.segmentacoes);
            filtro.solucoes = _formatarFiltroSolucoes(item.solucoes);
            filtro.produtos = _formatarFiltroProdutos(item.produtos);
            filtro.subitens = _formatarFiltroProdutos(item.subitens);
            filtro.subitensANaoImprimir = _formatarFiltroProdutos(item.subitensANaoImprimir);
            filtro.executivos = _formatarFiltroExecutivos(item.executivos);
            filtro.estados = _formatarFiltroEstados(item.estados);
            filtro.tiposLicenca = _formatarFiltroTiposLicenca(item.tiposLicenca);
            filtro.tiposLicencaANaoImprimir = _formatarFiltroTiposLicenca(item.tiposLicencaANaoImprimir);
            filtro.filtrosUtilizados = _construiFiltrosUtilizados(item);
            filtro.motivos = _formatarFiltroMotivos(item.motivos);
            filtro.status = _formatarFiltroStatus(item.status);
            filtro.licenca = _formatarFiltroLicenca(item.licenca);
            filtro.empresasFaturamento = _formatarFiltroEmpresasFaturamento(item.empresasFaturamento);

            return filtro;
        }

        //#endregion

        //#region  Métodos internos

        function _formatarFiltroMotivos(motivo) {
            return motivo.map(function (item) {
                return item.codigo;
            })
        }

        function _formatarFiltroFormasPagamento(formasPagamento) {
            return formasPagamento.map(function (item) {
                return item.codigo;
            });
        }

        function _formatarFiltroCaracteristica(caracteristicas) {
            return caracteristicas.map(function (item) {
                return item.codigo;
            });
        }

        function _formatarFiltroTiposLicenca(tipo) {
            return tipo.map(function (item) {
                return item.codigo;
            });
        }

        function _formatarFiltroClientes(clientes) {
            return clientes.map(function (item) {
                return item.codigo;
            });
        }

        function _formatarFiltroSegmentacoes(segmentacoes) {
            return segmentacoes.map(function (item) {
                return item.codigo;
            });
        }

        function _formatarFiltroSolucoes(solucoes) {
            return solucoes.map(function (item) {
                return item.codigo;
            });
        }

        function _formatarFiltroProdutos(produtos) {
            return produtos.map(function (item) {
                return item.codigo;
            });
        }

        function _formatarFiltroExecutivos(executivos) {
            return executivos.map(function (item) {
                return item.codigo;
            });
        }

        function _formatarFiltroEstados(estados) {
            return estados.map(function (item) {
                return item.descricao;
            });
        }
        function _formatarFiltroStatus(status) {
            if (status != undefined) {
                return status.map(function (item) {
                    return item.codigo;
                });
            }
            return null;
        }
        function _formatarFiltroLicenca(licenca) {
            if (licenca != undefined) {
                return licenca.map(function (item) {
                    return item.codigo;
                });
            }
            return null;
        }

        function _formatarFiltroEmpresasFaturamento(empresas) {
            return empresas.map(function (item) {
                return item.codigo;
            });
        }

        //#region Métodos internos construção filtros utilizados

        function _construiFiltrosUtilizados(filtros) {
            var filtrosUtilizados = _construirFiltroUtilizadoColaboradorCorrente() + "Filtros Utilizados: ";

            filtrosUtilizados += _construirFiltroUtilizadoLicenca(filtros.tiposLicenca);
            filtrosUtilizados += _construirFiltroUtilizadoSituacaoContratual(filtros.tipoSituacaoContratual);
            filtrosUtilizados += _construirFiltroUtilizadoSituacaoFinanceira(filtros.tipoSituacaoFinanceira);
            filtrosUtilizados += _construirFiltroUtilizadoTipoPagamento(filtros.tipoDePagamento, filtros.formasPagamento);
            filtrosUtilizados += _construirFiltroUtilizadoEstado(filtros.estados)
            //filtrosUtilizados += _construirFiltroUtilizadoOrdenacao(filtros.ordenacao);
            filtrosUtilizados += _construirFiltroUtilizadoDatas(filtros.datas, filtros.periodoInicial, filtros.periodoFinal)
            filtrosUtilizados += _construirFiltroUtilizadoClientes(filtros.clientes);
            filtrosUtilizados += _construirFiltroUtilizadoCaracteristicas(filtros.caracteristicas, filtros.caracteristicasANaoImprimir);
            filtrosUtilizados += _construirFiltroUtilizadoCaracteristicasContrato(filtros.caracteristicasContrato, filtros.caracteristicasContratoItem, filtros.caracteristicasContratoANaoImprimir, filtros.caracteristicasContratoItemANaoImprimir);
            filtrosUtilizados += _construiFiltrosUtilizadoSubItens(filtros.subitens);
            filtrosUtilizados += _construiFiltrosUtilizadoSubItensANaoImprimir(filtros.subitensANaoImprimir);
            filtrosUtilizados += _construiFiltrosUtilizadoProduto(filtros.produtos);
            filtrosUtilizados += _construiFiltrosUtilizadoProdutosANaoImprimir(filtros.produtosANaoImprimir);
            filtrosUtilizados += _construiFiltrosUtilizadoSolucao(filtros.solucoes);
            filtrosUtilizados += _construirFiltroUtilizadoMotivo(filtros.motivos);
            filtrosUtilizados += _construiFiltrosUtilizadoSegmentacoes(filtros.segmentacoes);
            filtrosUtilizados += _construiFiltrosUtilizadoExecutivos(filtros.executivos);
            filtrosUtilizados += _construirFiltroUtilizadoTiposLicenca(filtros.tiposLicenca);
            filtrosUtilizados += _construirFiltroUtilizadoDatasReajuste(filtros.periodoInicial, filtros.periodoFinal);
            filtrosUtilizados += _construirFiltroUtilizadoTiposLicencaANaoImprimir(filtros.tiposLicencaANaoImprimir);
            filtrosUtilizados += _construiFiltrosUtilizadoEmpresasFaturamento(filtros.empresasFaturamento);
            return filtrosUtilizados.substring(0, filtrosUtilizados.length - 2);
        }

        function _construirFiltroUtilizadoColaboradorCorrente() {
            return "Colaborador Corrente: " + LoginUsuarioService.usuarioArmazenado().nome + ", ";
        }

        function _construirFiltroUtilizadoLicenca(licenca) {
            switch (licenca) {
                case "1":
                    return "Situação Contratual: Ativo, ";
                case "2":
                    return "Situação Contratual: Inativo, ";
                default:
                    return "";
            }
        }

        function _construirFiltroUtilizadoSituacaoContratual(situacaoContratual) {
            switch (situacaoContratual) {
                case "1":
                    return "Situação Contratual: Ativo, ";
                case "2":
                    return "Situação Contratual: Inativo, ";
                default:
                    return "";
            }
        }

        function _construirFiltroUtilizadoSituacaoFinanceira(situacaoFinanceira) {
            switch (situacaoFinanceira) {
                case "1":
                    return "Situação Financeira: Ativo, ";
                case "2":
                    return "Situação Financeira: Inativo, ";
                default:
                    return "";
            }
        }

        function _construirFiltroUtilizadoTipoPagamento(tipoPagamento, formasPagamento) {
            switch (tipoPagamento) {
                case "2":
                    if (formasPagamento.length == 0)
                        return ""

                    var filtroFormasPagamento = "";

                    angular.forEach(formasPagamento, function (item, index) {
                        if (index == (formasPagamento.length - 1))
                            filtroFormasPagamento += item.descricao
                        else
                            filtroFormasPagamento += item.descricao + ", ";
                    });
                    return "Formas de Pagamento: [" + filtroFormasPagamento + "], ";
                default: return "";

            }
        }

        function _construirFiltroUtilizadoEstado(estados) {
            if (estados.length == 0)
                return "";

            var filtroEstados = "";
            angular.forEach(estados, function (item, index) {
                if (index == (estados.length - 1))
                    filtroEstados += item.descricao;
                else
                    filtroEstados += item.descricao + ", ";
            });

            return "Estados: [" + filtroEstados + "], ";
        }

        function _construirFiltroUtilizadoOrdenacao(ordenacao) {
            switch (ordenacao) {
                case 1:
                    return "Ordenação: Alfabética, ";
                default:
                    return "Ordernação: Numérica, ";
            }
        }

        function _construirFiltroUtilizadoDatasReajuste(periodoInicial, periodoFinal) {
            if (periodoFinal != undefined && periodoFinal != undefined) {
                return "Período: " +
                    "[" + $filter('date')(periodoInicial, 'dd/MM/yyyy') + " a " +
                    $filter('date')(periodoFinal, 'dd/MM/yyyy') + "], ";
            }
            return "";
        }

        function _construirFiltroUtilizadoDatas(datas, periodoInicial, periodoFinal) {
            switch (datas) {
                case "1":
                    return "Período: " +
                        "[" + $filter('date')(periodoInicial, 'dd/MM/yyyy') + " a " +
                        $filter('date')(periodoFinal, 'dd/MM/yyyy') + "], ";
                case "2":
                    return "Período: " +
                        "[" + $filter('date')(periodoInicial, 'dd/MM/yyyy') + " a " +
                        $filter('date')(periodoFinal, 'dd/MM/yyyy') + "], ";
                case "3":
                    return "Período: " +
                        "[" + $filter('date')(periodoInicial, 'dd/MM/yyyy') + " a " +
                        $filter('date')(periodoFinal, 'dd/MM/yyyy') + "], ";
                case "4":
                    return "Período: " +
                        "[" + $filter('date')(periodoInicial, 'dd/MM/yyyy') + " a " +
                        $filter('date')(periodoFinal, 'dd/MM/yyyy') + "], ";
                default:
                    return ""
            }
        }

        function _construiFiltrosUtilizadoSubItens(subitens) {
            if (subitens.length == 0)
                return "";

            var filtroSubItens = "";
            angular.forEach(subitens, function (item, index) {
                if (index == (subitens.length - 1))
                    filtroSubItens += item.descricao;
                else
                    filtroSubItens += item.descricao + ", ";
            });

            return "Subitens: [" + filtroSubItens + "], ";
        }

        function _construiFiltrosUtilizadoSubItensANaoImprimir(subitensANaoImprimir) {
            if (subitensANaoImprimir && subitensANaoImprimir.length == 0)
                return "";

            var filtroSubItensANaoImprimir = "";
            angular.forEach(subitensANaoImprimir, function (item, index) {
                if (index == (subitensANaoImprimir.length - 1))
                    filtroSubItensANaoImprimir += item.descricao;
                else
                    filtroSubItensANaoImprimir += item.descricao + ", ";
            });

            return "Subitens a não imprimir: [" + filtroSubItensANaoImprimir + "], ";
        }

        function _construirFiltroUtilizadoClientes(clientes) {
            if (clientes.length == 0)
                return "";

            var filtroClientes = "";
            angular.forEach(clientes, function (item, index) {
                if (index == (clientes.length - 1))
                    filtroClientes += item.nome;
                else
                    filtroClientes += item.nome + ", ";
            });

            return "Clientes: [" + filtroClientes + "], ";
        }

        function _construirFiltroUtilizadoCaracteristicas(caracteristicasAImprimir, caracteristicasANaoImprimir) {
            if (caracteristicasAImprimir.length == 0 && caracteristicasANaoImprimir.length == 0)
                return "";
            else if (caracteristicasAImprimir.length > 0) {
                var filtroCaracteristicasAImprimir = "";
                angular.forEach(caracteristicasAImprimir, function (item, index) {
                    if (index == (caracteristicasAImprimir.length - 1))
                        filtroCaracteristicasAImprimir += item.descricao;
                    else
                        filtroCaracteristicasAImprimir += item.descricao + ", ";
                });

                return "Características: [" + filtroCaracteristicasAImprimir + "], ";
            }
            else {
                var filtroCaracteristicasANaoImprimir = "";
                angular.forEach(caracteristicasANaoImprimir, function (item, index) {
                    if (index == (caracteristicasANaoImprimir.length - 1))
                        filtroCaracteristicasANaoImprimir += item.descricao;
                    else
                        filtroCaracteristicasANaoImprimir += item.descricao + ", ";
                });

                return "Características a não imprimir: [" + filtroCaracteristicasANaoImprimir + "], ";
            }

        }

        function _construirFiltroUtilizadoCaracteristicasContrato(caracteristicasContratoAImprimir, caracteristicasContratoItemAImprimir, caracteristicasContratoANaoImprimir, caracteristicasContratoItemANaoImprimir) {
            var filtro = '';
            if (caracteristicasContratoAImprimir.length == 0 && caracteristicasContratoItemAImprimir.length == 0 && caracteristicasContratoANaoImprimir.length == 0 && caracteristicasContratoItemANaoImprimir.length == 0)
                return "";
            if (caracteristicasContratoAImprimir.length > 0) {
                var filtroCaracteristicasContratoAImprimir = "";
                angular.forEach(caracteristicasContratoAImprimir, function (item, index) {
                    if (index == (caracteristicasContratoAImprimir.length - 1))
                        filtroCaracteristicasContratoAImprimir += item.descricao;
                    else
                        filtroCaracteristicasContratoAImprimir += item.descricao + ", ";
                });

                filtro = "Características de contrato: [" + filtroCaracteristicasContratoAImprimir + "], ";
            }
            if (caracteristicasContratoItemAImprimir.length > 0) {
                var filtroCaracteristicasContratoItemAImprimir = "";
                angular.forEach(caracteristicasContratoItemAImprimir, function (item, index) {
                    if (index == (caracteristicasContratoItemAImprimir.length - 1))
                        filtroCaracteristicasContratoItemAImprimir += item.descricao;
                    else
                        filtroCaracteristicasContratoItemAImprimir += item.descricao + ", ";
                });

                filtro = "Características de item: [" + filtroCaracteristicasContratoItemAImprimir + "], ";
            }
            if (caracteristicasContratoANaoImprimir.length > 0) {
                var filtroCaracteristicasContratoANaoImprimir = "";
                angular.forEach(caracteristicasContratoANaoImprimir, function (item, index) {
                    if (index == (caracteristicasContratoANaoImprimir.length - 1))
                        filtroCaracteristicasContratoANaoImprimir += item.descricao;
                    else
                        filtroCaracteristicasContratoANaoImprimir += item.descricao + ", ";
                });

                filtro += "Características de contrato a não imprimir: [" + filtroCaracteristicasContratoANaoImprimir + "], ";
            }
            if (caracteristicasContratoItemANaoImprimir.length > 0) {
                var filtroCaracteristicasContratoItemANaoImprimir = "";
                angular.forEach(caracteristicasContratoItemANaoImprimir, function (item, index) {
                    if (index == (caracteristicasContratoItemANaoImprimir.length - 1))
                        filtroCaracteristicasContratoItemANaoImprimir += item.descricao;
                    else
                        filtroCaracteristicasContratoItemANaoImprimir += item.descricao + ", ";
                });

                filtro += "Características de item a não imprimir: [" + filtroCaracteristicasContratoItemANaoImprimir + "], ";
            }
            return filtro
        }

        function _construirFiltroUtilizadoMotivo(motivo) {
            if (motivo.length == 0) {
                return "";
            }
            var filtroMotivo = "";
            angular.forEach(motivo, function (item, index) {
                if (index == (motivo.length - 1)) {
                    filtroMotivo += item.descricao
                }
                else {
                    filtroMotivo += item.descricao + ", ";
                }
            });
            return "Motivos: [" + filtroMotivo + "], ";

        }
        function _construiFiltrosUtilizadoSolucao(solucoes) {
            if (solucoes.length == 0)
                return "";

            var filtroSolucoes = "";
            angular.forEach(solucoes, function (item, index) {
                if (index == (solucoes.length - 1))
                    filtroSolucoes += item.descricao;
                else
                    filtroSolucoes += item.descricao + ", ";
            });

            return "Soluções: [" + filtroSolucoes + "], ";
        }

        function _construiFiltrosUtilizadoProduto(produtos) {
            if (produtos.length == 0)
                return "";

            var filtroProdutos = "";
            angular.forEach(produtos, function (item, index) {
                if (index == (produtos.length - 1))
                    filtroProdutos += item.descricao;
                else
                    filtroProdutos += item.descricao + ", ";
            });

            return "Itens: [" + filtroProdutos + "], ";
        }

        function _construiFiltrosUtilizadoProdutosANaoImprimir(produtosANaoImprimir) {
            if (produtosANaoImprimir && produtosANaoImprimir.length == 0)
                return "";

            var filtroProdutosANaoImprimir = "";
            angular.forEach(produtosANaoImprimir, function (item, index) {
                if (index == (produtosANaoImprimir.length - 1))
                    filtroProdutosANaoImprimir += item.descricao;
                else
                    filtroProdutosANaoImprimir += item.descricao + ", ";
            });

            return "Itens a não imprimir: [" + filtroProdutosANaoImprimir + "], ";
        }


        function _construiFiltrosUtilizadoExecutivos(executivos) {
            if (executivos == null) return "Executivos: Todos, ";

            var filtroExecutivos = "";
            angular.forEach(executivos, function (item, index) {
                if (index == (executivos.length - 1))
                    filtroExecutivos += item.nome;
                else
                    filtroExecutivos += item.nome + ", ";
            });

            if (filtroExecutivos.length > 0)
                return "Executivos: [" + filtroExecutivos + "], ";

            return "Executivos: Todos, ";
        }

        function _construiFiltrosUtilizadoSegmentacoes(segmentacoes) {
            if (segmentacoes.length == 0)
                return "";

            var filtroSegmentacoes = "";
            angular.forEach(segmentacoes, function (item, index) {
                if (index == (segmentacoes.length - 1))
                    filtroSegmentacoes += item.descricao;
                else
                    filtroSegmentacoes += item.descricao + ", ";
            });

            return "Segmentações: [" + filtroSegmentacoes + "], ";
        }


        function _construirFiltroUtilizadoTiposLicenca(tiposLicencasAImprimir) {

            if (tiposLicencasAImprimir.length == 0)
                return "";

            var filtroTipoLicenca = "";
            angular.forEach(tiposLicencasAImprimir, function (item, index) {
                if (index == (tiposLicencasAImprimir.length - 1))
                    filtroTipoLicenca += item.descricao;
                else
                    filtroTipoLicenca += item.descricao + ", ";
            });

            return "Tipos de licença: [" + filtroTipoLicenca + "], ";
        }

        function _construirFiltroUtilizadoTiposLicencaANaoImprimir(tipoLicencaANaoImprimir) {

            if (tipoLicencaANaoImprimir.length == 0)
                return "";

            var filtroTipoLicenca = "";
            angular.forEach(tipoLicencaANaoImprimir, function (item, index) {
                if (index == (tipoLicencaANaoImprimir.length - 1))
                    filtroTipoLicenca += item.descricao;
                else
                    filtroTipoLicenca += item.descricao + ", ";
            });

            return "Tipos de licença a não imprimir: [" + filtroTipoLicenca + "], ";
        }

        function _construiFiltrosUtilizadoEmpresasFaturamento(empresas) {
            if (empresas == null)
                return;
            var filtroEmpresas = "";
            angular.forEach(empresas, function (item, index) {
                if (index == (empresas.length - 1))
                    filtroEmpresas += item.nome;
                else
                    filtroEmpresas += item.nome + ", ";
            });
            if (filtroEmpresas.length > 0)
                return "Empresas de faturamento: [" + filtroEmpresas + "], ";
            return "";
        }

        //#endregion

        //#endregion

    }

})();

(function () {
    'use strict';

    angular
        .module('app.service')
        .service("RelatorioControleHorasService", RelatorioControleHorasService);


    function RelatorioControleHorasService(RequisicaoGenericaService, $window, MdDialogService, urlApi, Api) {

        var filtros = {};

        return {
            listaMes: listaMes,
            preparaFiltroParaEnvio: preparaFiltroParaEnvio
        }

        function preparaFiltroParaEnvio(item) {
            filtros = angular.copy(item);
            filtros.codigoUsuario = item.dadosUsuario.codigo;
            if (filtros.mes)
                filtros.mes = item.mes.codigo;
            filtros.construirFiltrosUtilizados = _construirFiltrosUtilizados(item);
            return filtros;
        }

        function _construirFiltrosUtilizados(item) {
            filtros.filtrosUtilizados = _formatarFiltroColaborador(item.dadosUsuario.usuario);
            filtros.filtrosUtilizados += _formatarFiltroMes(item.mes);
            filtros.filtrosUtilizados += _formataFiltroAno(item.ano);
        }

        function _formatarFiltroColaborador(colaborador) {
            if (angular.equals(null, colaborador) || angular.equals(undefined, colaborador))
                return "";
            return "Técnico: " + colaborador.nome;
        }

        function _formataFiltroAno(ano) {
            if (angular.equals(null, ano) || angular.equals(undefined, ano) || ano == "0")
                return "";
            return ", Ano: " + ano;
        }

        function _formatarFiltroMes(mes) {
            if (angular.equals(null, mes) || angular.equals(undefined, mes))
                return "";
            return ", Mês: " + mes.descricao;
        }

        function listaMes() {
            return [
                {
                    codigo: 0,
                    descricao: "Todos"
                },
                {
                    codigo: 1,
                    descricao: "Janeiro"
                },
                {
                    codigo: 2,
                    descricao: "Fevereiro"
                },
                {
                    codigo: 3,
                    descricao: "Março"
                },
                {
                    codigo: 4,
                    descricao: "Abril"
                },
                {
                    codigo: 5,
                    descricao: "Maio"
                },
                {
                    codigo: 6,
                    descricao: "Junho"
                },
                {
                    codigo: 7,
                    descricao: "Julho"
                },
                {
                    codigo: 8,
                    descricao: "Agosto"
                },
                {
                    codigo: 9,
                    descricao: "Setembro"
                },
                {
                    codigo: 10,
                    descricao: "Outubro"
                },
                {
                    codigo: 11,
                    descricao: "Novembro"
                },
                {
                    codigo: 12,
                    descricao: "Dezembro"
                }
            ];
        }

    }

})();
(function () {
    'use strics'
    angular.module('app.service')
        .service('RelatorioClienteService', RelatorioClienteService);

    function RelatorioClienteService($filter, LoginUsuarioService) {

        this.preparaFiltroParaEnvio = preparaFiltroParaEnvio;

        var filtrosUtilizados = {
            _contruirFiltrosUtilizados: _contruirFiltrosUtilizados,
            _construirFiltroUtilizadoColaboradorCorrente: _construirFiltroUtilizadoColaboradorCorrente,
            _construirFiltroUtilizadoEstado: _construirFiltroUtilizadoEstado,
            _construirFiltroUtilizadoOrdenacao: _construirFiltroUtilizadoOrdenacao,
            _construirFiltroUtilizadoCaracteristicas: _construirFiltroUtilizadoCaracteristicas,
            _contruirFiltrosUtilizadoSolucao: _contruirFiltrosUtilizadoSolucao,
            _construirFiltrosUtilizadoDataRescindido: _construirFiltrosUtilizadoDataRescindido,
            _contruirFiltrosUtilizadoDataNaoAtendido: _contruirFiltrosUtilizadoDataNaoAtendido,
            _contruirFiltrosUtilizadoProduto: _contruirFiltrosUtilizadoProduto,
            _contruirFiltrosUtilizadoSegmentacoes: _contruirFiltrosUtilizadoSegmentacoes,
            _construirFiltrosUtilizadoClienteContratual: _construirFiltrosUtilizadoClienteContratual,
            _construirFiltroUtilizadoTiposLicenca: _construirFiltroUtilizadoTiposLicenca,
            _construirFiltroUtilizadoTiposLicencaANaoImprimir: _construirFiltroUtilizadoTiposLicencaANaoImprimir
        }
        var formatarFiltroCaracteristica = _formatarFiltroCaracteristica;
        //var formatarFiltroClientes = _formatarFiltroClientes;
        var formatarFiltroExecutivo = _formatarFiltroExecutivo;
        var formatarFiltroSolucoes = _formatarFiltroSolucoes;
        var formatarFiltroProdutos = _formatarFiltroProdutos;
        var formatarFiltrosSegmentacoes = _formatarFiltroSegmentacoes;
        var formatarFiltrosClienteContratual = _formatarFiltroClienteContratual;
        var formatarFiltroTiposLicenca = _formatarFiltroTiposLicenca;

        function _construirFiltroUtilizadoCaracteristicas(caracteristicasAImprimir) {

            if (caracteristicasAImprimir.length == 0)
                return "";

            var filtroCaracteristica = "";
            angular.forEach(caracteristicasAImprimir, function (item, index) {
                if (index == (caracteristicasAImprimir.length - 1))
                    filtroCaracteristica += item.descricao;
                else
                    filtroCaracteristica += item.descricao + ", ";
            });

            return "Características: [" + filtroCaracteristica + "], ";
        }

        function _construirFiltroUtilizadoCaracteristicasANaoImprimir(caracteristicasANaoImprimir) {

            if (caracteristicasANaoImprimir.length == 0)
                return "";

            var filtroCaracteristica = "";
            angular.forEach(caracteristicasANaoImprimir, function (item, index) {
                if (index == (caracteristicasANaoImprimir.length - 1))
                    filtroCaracteristica += item.descricao;
                else
                    filtroCaracteristica += item.descricao + ", ";
            });

            return "Características a não imprimir: [" + filtroCaracteristica + "], ";
        }

        function _construirFiltroUtilizadoTiposLicenca(tiposLicencasAImprimir) {

            if (tiposLicencasAImprimir.length == 0)
                return "";

            var filtroTipoLicenca = "";
            angular.forEach(tiposLicencasAImprimir, function (item, index) {
                if (index == (tiposLicencasAImprimir.length - 1))
                    filtroTipoLicenca += item.descricao;
                else
                    filtroTipoLicenca += item.descricao + ", ";
            });

            return "Tipos de licença: [" + filtroTipoLicenca + "], ";
        }

        function _construirFiltroUtilizadoTiposLicencaANaoImprimir(tipoLicencaANaoImprimir) {

            if (tipoLicencaANaoImprimir.length == 0)
                return "";

            var filtroTipoLicenca = "";
            angular.forEach(tipoLicencaANaoImprimir, function (item, index) {
                if (index == (tipoLicencaANaoImprimir.length - 1))
                    filtroTipoLicenca += item.descricao;
                else
                    filtroTipoLicenca += item.descricao + ", ";
            });

            return "Tipos de licença a não imprimir: [" + filtroTipoLicenca + "], ";
        }

        function preparaFiltroParaEnvio(item) {
            var filtro = angular.copy(item);
            filtro.caracteristicas = _formatarFiltroCaracteristica(item.caracteristicas);
            filtro.caracteristicasANaoImprimir = _formatarFiltroCaracteristica(item.caracteristicasANaoImprimir);
            filtro.clientes = _formatarFiltroClientes(item.clientes);
            filtro.solucoes = _formatarFiltroSolucoes(item.solucoes);
            filtro.produtos = _formatarFiltroProdutos(item.produtos);
            filtro.executivos = _formatarFiltroExecutivo(item.executivos);
            filtro.filtrosUtilizados = _contruirFiltrosUtilizados(item);
            filtro.clienteContratual = formatarFiltrosClienteContratual(item.clienteContratual);
            filtro.segmentacoes = formatarFiltrosSegmentacoes(item.segmentacoes);
            filtro.tiposLicenca = _formatarFiltroTiposLicenca(item.tiposLicenca);
            filtro.tiposLicencaANaoImprimir = _formatarFiltroTiposLicenca(item.tiposLicencaANaoImprimir);
            return filtro;
        }

        function _formatarFiltroCaracteristica(caracteristicas) {
            return caracteristicas.map(function (item) {
                return item.codigo;
            });
        }

        function _formatarFiltroTiposLicenca(tipo) {
            return tipo.map(function (item) {
                return item.codigo;
            });
        }

        function _formatarFiltroSegmentacoes(segmentacoes) {
            return segmentacoes.map(function (item) {
                return item.codigo;
            });
        }

        function _formatarFiltroClienteContratual(item) {
            if (item == 3)
                return null;
            return item;
        }

        function _formatarFiltroExecutivo(executivo) {
            return executivo.map(function (item) {
                return item.codigo;
            });
        }

        function _formatarFiltroClientes(clientes) {
            if (clientes == null)
                return "";
            return clientes.map(function (item) {
                return item.codigo;
            });
        }


        function _formatarFiltroSolucoes(solucoes) {
            return solucoes.map(function (item) {
                return item.codigo;
            });
        }

        function _formatarFiltroProdutos(produtos) {
            return produtos.map(function (item) {
                return item.codigo;
            });
        }

        function _formatarFiltroTiposLicenca(tipos) {
            return tipos.map(function (item) {
                return item.codigo;
            });
        }


        function _contruirFiltrosUtilizados(filtros) {
            var filtrosUtilizados = _construirFiltroUtilizadoColaboradorCorrente();
            filtrosUtilizados += _construirFiltroUtilizadoEstado(filtros.estados)
            filtrosUtilizados += _construirFiltroUtilizadoOrdenacao(filtros.ordem);
            filtrosUtilizados += _construirFiltrosUtilizadoExecutivos(filtros.executivos);
            filtrosUtilizados += _construirFiltrosUtilizadoClienteContratual(filtros.clienteContratual);
            filtrosUtilizados += _construirFiltrosUtilizadoDataRescindido(filtros.dataInicioRescindidos, filtros.dataFimRescindidos);
            filtrosUtilizados += _contruirFiltrosUtilizadoDataNaoAtendido(filtros.dataInicioNaoAtendidos, filtros.dataFimNaoAtendidos);
            filtrosUtilizados += _construirFiltroUtilizadoCaracteristicas(filtros.caracteristicas);
            filtrosUtilizados += _construirFiltroUtilizadoCaracteristicasANaoImprimir(filtros.caracteristicasANaoImprimir);
            filtrosUtilizados += _contruirFiltrosUtilizadoProduto(filtros.produtos);
            filtrosUtilizados += _contruirFiltrosUtilizadoSolucao(filtros.solucoes);
            filtrosUtilizados += _contruirFiltrosUtilizadoSegmentacoes(filtros.segmentacoes);
            filtrosUtilizados += _construirFiltroUtilizadoTiposLicenca(filtros.tiposLicenca);
            filtrosUtilizados += _construirFiltroUtilizadoTiposLicencaANaoImprimir(filtros.tiposLicencaANaoImprimir);
            filtrosUtilizados = _verificaFinalDeCaracter(filtrosUtilizados);
            return filtrosUtilizados;
        }


        function _construirFiltroUtilizadoColaboradorCorrente() {
            return "Colaborador Corrente: " + LoginUsuarioService.usuarioArmazenado().nome + ", ";
        }

        function _verificaFinalDeCaracter(filtros) {
            var result = filtros.trim();
            if (result.charAt(result.length - 1) == ',') {
                return result.substr(0, result.length - 1);
            }

            return filtros;
        }

        function _construirFiltrosUtilizadoClienteContratual(clienteContratual) {
            switch (parseInt(clienteContratual)) {
                case 1:
                    return "Cliente contratual: Sim, ";
                case 0:
                    return "Cliente contratual: Não, ";
                case 3:
                    return "Cliente contratual: Ambos,  ";
            }

        }

        function _construirFiltroUtilizadoEstado(estados) {
            if (estados.length == 0)
                return "";

            var filtroEstados = "";
            angular.forEach(estados, function (item, index) {
                if (index == (estados.length - 1))
                    filtroEstados += item;
                else
                    filtroEstados += item + ", ";
            });

            return "Estados: [" + filtroEstados + "], ";
        }

        function _construirFiltrosUtilizadoDataRescindido(dataInicio, dataFim) {
            if (dataInicio == null || dataFim == null)
                return "";
            return "Rescindidos entre: " + dataInicio.toLocaleDateString() + " e " + dataFim.toLocaleDateString() + ", ";

        }

        function _contruirFiltrosUtilizadoDataNaoAtendido(dataInicio, dataFim) {
            if (dataInicio == null || dataFim == null)
                return "";
            return "Não atendidos entre: " + dataInicio.toLocaleDateString() + " e " + dataFim.toLocaleDateString() + ", ";
        }


        function _construirFiltroUtilizadoOrdenacao(ordenacao) {
            switch (parseInt(ordenacao)) {
                case 1:
                    return "Ordenação: Numérica, ";
                case 2:
                    return "Ordenação: Cidade,  ";
                default: return "";
            }
        }

        function _construirFiltrosUtilizadoExecutivos(executivos) {
            if (executivos.length == 0)
                return "";

            var filtrosExecutivos = "";
            angular.forEach(executivos, function (item, index) {
                if (index == (executivos.length - 1))
                    filtrosExecutivos += item.nome;
                else
                    filtrosExecutivos += item.nome + ", ";
            });

            return "Executivos: [" + filtrosExecutivos + "], ";
        }

        function _contruirFiltrosUtilizadoSolucao(solucoes) {
            if (solucoes.length == 0)
                return "";

            var filtroSolucoes = "";
            angular.forEach(solucoes, function (item, index) {
                if (index == (solucoes.length - 1))
                    filtroSolucoes += item.descricao;
                else
                    filtroSolucoes += item.descricao + ", ";
            });

            return "Soluções: [" + filtroSolucoes + "], ";
        }

        function _contruirFiltrosUtilizadoProduto(produtos) {
            if (produtos.length == 0)
                return "";

            var filtroProdutos = "";
            angular.forEach(produtos, function (item, index) {
                if (index == (produtos.length - 1))
                    filtroProdutos += item.descricao;
                else
                    filtroProdutos += item.descricao + ", ";
            });

            return "Produtos: [" + filtroProdutos + "], ";
        }

        function _contruirFiltrosUtilizadoSegmentacoes(segmentacoes) {
            if (segmentacoes.length == 0)
                return "";

            var filtroSegmentacoes = "";
            angular.forEach(segmentacoes, function (item, index) {
                if (index == (segmentacoes.length - 1))
                    filtroSegmentacoes += item.descricao;
                else
                    filtroSegmentacoes += item.descricao + ", ";
            });

            return "Segmentações: [" + filtroSegmentacoes + "], ";
        }

    }

})();

(function () {
    'use strict';

    angular
        .module('app.service')
        .service('RedefinirSenhaService', RedefinirSenhaService);

    /** @ngInject */
    function RedefinirSenhaService(
        $mdDialog,
        LoginUsuarioService,
        MenuFactory,
        NotificacaoService,
        SessionStorageService,
        AtendimentoHubFactory,
        SolicitacaoHubFactory,
        NotificacaoPipelineService,
        MensageiroHubFactory,
        ControleAcessoConfig,
        HubFactory,
        $mdToast,
        $state
    ) {

        var configuracao = ControleAcessoConfig.configuracao;
        this.rotinaSenha = function abrirDialogAlteracaoSenha(event) {
            return $mdDialog
                .show({
                    controller: "DialogAlteracaoSenhaToolbarController",
                    controllerAs: "vm",
                    templateUrl:
                        "app/toolbar/dialogs/dialog-alteracao-senha/dialog-alteracao-senha-toolbar.html",
                    //parent: ---------------,
                    targetEvent: event,
                    clickOutsideToClose: false
                })
            // .then(
            //   function() {},
            //   function() {}
            // );
        };

        this.logar = function LogarSistema() {
            var usuario = LoginUsuarioService.usuarioArmazenado();
            AtendimentoHubFactory.atualizarQuantidadeAtendimentosNaoVisualizados(usuario.codigo, true);
            AtendimentoHubFactory.atualizarQuantidadeAtendimentoEmAberto(usuario.codigo, true);
            AtendimentoHubFactory.atualizarQuantidadeAtendimentoImportante(usuario.codigo, true);
            NotificacaoPipelineService.exibirNotificacaoNegociacaoEmAlerta(usuario.codigo);
            MensageiroHubFactory.atualizarQuantidadeMensagensNaoVisualizados(usuario.codigo, true);
            SolicitacaoHubFactory.atualizarQuantidadeSolicitacoesNaoVisualizados(usuario.codigo, true);
            $state.go(configuracao.estado_home);
        }

        this.cancelDialog = function Cancelar() {
            LoginUsuarioService.logout();
            MenuFactory.removeTodosMenus();
            NotificacaoService.fecharTodasNotificacoes();
            SessionStorageService.removerTodosItens();
            //LocalStorageService.removerTodosItens();
            HubFactory.desconectar();

            $mdToast.show({
                template:
                    '<md-toast id="logout-message" layout="column" layout-align="center start"><div class="md-toast-content">Processo de redefinição de senha não foi concluído !</div></md-toast>',
                hideDelay: 7000,
                position: "top right",
                parent: "#content"
            });
        }
    }
})();

/**
 * Created by nova on 29/09/2016.
 */
(function () {
  'use strict';

  angular
    .module('app.service')
    .service("ProximoCodigoService", ProximoCodigoService);

  function ProximoCodigoService(urlApi, $http, TokenService) {

    this.proximoCodigo = function (rota) {
      var token = TokenService.getToken();
      return $http({
        url: urlApi.url_base_api + rota,
        method: "GET",
        headers: { "Authorization": "Bearer " + token }
      });
    };

    this.proximoNumeroHistoria = function (rota, squadCodigo) {
      var token = TokenService.getToken();
      return $http({
        url: urlApi.url_base_api + rota,
        method: "GET",
        headers: { "Authorization": "Bearer " + token },
        params: { squadCodigo: squadCodigo }
      });
    };

    this.proximoNumeroSprint = function (rota, squadCodigo) {
      var token = TokenService.getToken();
      return $http({
        url: urlApi.url_base_api + rota,
        method: "GET",
        headers: {
          "Authorization": "Bearer " + token
        },
        params: { squadCodigo: squadCodigo }
      });
    };

  }

})();

(function () {
    'use strict';
    angular
        .module('app.service')
        .service('PipelineNegocioService', PipelineNegocioService);

    function PipelineNegocioService($q, $state, msUtils, RequisicaoGenericaService, Api, MdDialogService, ServicosGenericoService, MdToastService) {

        this.verificarDataVencida = verificarDataVencida;
        this.navegarParaAtendimento = navegarParaAtendimento;
        this.atualizarEtapa = atualizarEtapa;
        this.atualizarNegocio = atualizarNegocio;
        this.atualizarEtapaNegocio = atualizarEtapaNegocio;
        this.removerNegocioDaEtapa = removerNegocioDaEtapa;
        this.adicionarNegocioNaEtapa = adicionarNegocioNaEtapa;
        this.listarProdutosPorFunil = _listarProdutosPorFunil;

        /**
         * Método para verificar se a dataFinal da etapa do negócio foi excedida
         * @param {Date} data negocio.dataFinalEtapa
         */
        function verificarDataVencida(data) {
            if (data) {
                var dataAtual = new Date();
                var dataFinal = new Date(data);
                return dataFinal <= dataAtual ? true : false;
            }
            else
                throw new ("É necessário informar a data");
        }

        /**
         * Método que quando chamado irá navegar para tela de atendimento já pesquisando o atendimento passado como parâmetro
         * @param {number} codigoAtendimento
         * @param {number} anoAtendimento
         */
        function navegarParaAtendimento(codigoAtendimento, anoAtendimento) {
            $state.goNewTab('app.atendimento_processamento_atendimento', {
                parametros: {
                    codigo: codigoAtendimento,
                    ano: anoAtendimento,
                    chamarPesquisa: true
                },
            });
        }


        /**
         * Método para atualizar a etapa de um negócio
         * @param {number} codigoNegocio
         * @param {number} codigoEtapa
         */
        function atualizarEtapa(codigoNegocio, codigoEtapa) {
            var deferred = $q.defer();
            var modelo = {
                codigoNegocio: codigoNegocio,
                codigoEtapa: codigoEtapa
            }
            RequisicaoGenericaService.editar(Api.pipeline.pipeline_negocio.atualizarEtapaNegocio, modelo).then(
                function (success) {
                    MdToastService.toastPadrao("Alteração de etapa realizada com sucesso!");
                    deferred.resolve(success);
                },
                function (error) {
                    deferred.reject(error);
                    ServicosGenericoService.exibirAlertaDeErro(error, event)
                });
            return deferred.promise;
        }

        /**
         * Método para atualizar a datafinal de um negócio
         * @param {Array} etapasFunil
         * @param {object} negocioAtualizado
         */
        function atualizarNegocio(etapasFunil, negocioAtualizado) {
            etapasFunil.map(function (itensEtapa) {
                itensEtapa.negocios.map(function (itensNegocio) {
                    if (itensNegocio.codigo == negocioAtualizado.codigo) {
                        itensNegocio.dataFinalEtapa = negocioAtualizado.dataFinalEtapa;
                    }
                });
            });
        }

        /**
         * Método que atualizar a etapa do negócio removendo da etapa em que ele se encontrava
         * e inserindo o negócio na nova etapa atual do mesmo
         * @param {Array} etapasFunil
         * @param {Object} etapaAtual
         * @param {Object} negocio
         */
        function atualizarEtapaNegocio(etapasFunil, etapaAtual, negocio) {
            removerNegocioDaEtapa(etapasFunil, negocio);
            adicionarNegocioNaEtapa(etapasFunil, etapaAtual, negocio);
        }


        /**
         * Método para remover um negócio de sua etapa
         * @param {Array} etapasFunil
         * @param {object} negocio
         */
        function removerNegocioDaEtapa(etapasFunil, negocio) {
            var negocioRemovido = false;
            etapasFunil.map(function (itensEtapa) {
                itensEtapa.negocios.map(function (itensNegocio) {
                    if (itensNegocio.codigo == negocio.codigo && !negocioRemovido) {
                        negocioRemovido = true;
                        itensEtapa.negocios.splice(itensEtapa.negocios.indexOf(itensNegocio), 1);
                    }
                });
            });
        }

        /**
         * Método para adicionar um negócio em uma nova etapa
         * @param {Array} etapasFunil
         * @param {object} etapaAtual
         * @param {object} negocio
         */
        function adicionarNegocioNaEtapa(etapasFunil, etapaAtual, negocio) {
            var negocioInserido = false;
            etapasFunil.map(function (itensEtapa) {
                if (itensEtapa.codigo == etapaAtual.codigo && !negocioInserido && (itensEtapa.negocios.indexOf(negocio) == -1)) {
                    negocioInserido = true;
                    itensEtapa.negocios.push(negocio);
                }
            });
        }

        function _listarProdutosPorFunil(codigoFunil, acaoSuccess, acaoError) {
            RequisicaoGenericaService.listarSemParams(Api.produto.listarProdutosPorFunil + codigoFunil).then(
                function (success) {
                    acaoSuccess(success.data);
                },
                function (error) {
                    acaoError(error);
                });
        }

    }


})();

(function () {
    'use strict';
    angular
        .module('app.service')
        .service('NavegacaoService', NavegacaoService);

    function NavegacaoService($rootScope) {
        var preTituloAba = "IManager - ";
        this.setTituloAba = function (tituloAba) {
            $rootScope.$emit('atualizarTitle', preTituloAba + tituloAba);
        }
    }

})();

(function () {
    'use strict';
    angular
        .module('app.service')
        .service('MensageiroService', MensageiroService);

    function MensageiroService($rootScope, Api, DataTableConfigPadrao, PgToolbarService, RequisicaoGenericaService, MdDialogService, $q) {

        // Métodos de Request region
        var listarGenericamente = function (rota, codigoColaborador, controleForm, controlePreloader) {
            var deferred = $q.defer();
            PgToolbarService.iniciarPreLoaderToolbar(controleForm, controlePreloader);
            RequisicaoGenericaService.
                listarSemParams(rota + codigoColaborador).then(
                    function (success) {
                        PgToolbarService.finalizarPreLoaderToolbar(controleForm, controlePreloader);
                        deferred.resolve(success.data);
                    },
                    function (error) {
                        PgToolbarService.finalizarPreLoaderToolbar(controleForm, controlePreloader);
                        deferred.reject(error.data);
                    });
            return deferred.promise;
        }

        this.listarColaboradorPeloCodigo = function (dados) {
            var defered = $q.defer();
            RequisicaoGenericaService.listarComParams(Api.usuario.listarPor,
                dados).then(function (success) {
                    defered.resolve(success.data);
                }, function (err) {
                    defered.reject(err.data);
                });
            return defered.promise;
        }

        this.listarColaboradores = function () {
            var deferred = $q.defer();
            RequisicaoGenericaService.listarSemParams(Api.usuario.detalhes_usuario.listarUsuariosAtivos).then(
                function (success) {
                    deferred.resolve(success.data);
                },
                function (error) {
                    deferred.reject(error.data);
                }
            );
            return deferred.promise;
        }

        this.listarColaboradoresSquad = function (squadCodigos) {
            var deferred = $q.defer();
            var dados = {
                squadCodigos: squadCodigos
            };

            RequisicaoGenericaService.listarComParams(Api.usuario.detalhes_usuario.listarUsuariosAtivosSquad, dados).then(
                function (success) {
                    deferred.resolve(success.data);
                },
                function (error) {
                    deferred.reject(error.data);
                }
            );
            return deferred.promise;
        }

        this.listarDepartamentos = function () {
            var deferred = $q.defer();
            RequisicaoGenericaService.listarSemParams(Api.setor.listarTodos).then(
                function (success) {
                    deferred.resolve(success.data);
                },
                function (error) {
                    deferred.reject(error.data);
                }
            );
            return deferred.promise;
        }

        this.listarDepartamentosSquad = function (squadCodigos) {
            var deferred = $q.defer();
            var dados = {
                squadCodigos: squadCodigos
            };

            RequisicaoGenericaService.listarComParams(Api.setor.ListarTodosSquad, dados).then(
                function (success) {
                    deferred.resolve(success.data);
                },
                function (error) {
                    deferred.reject(error.data);
                }
            );
            return deferred.promise;
        }

        this.listarMensagens = function (codigoColaborador, pagina) {
            var deferred = $q.defer();
            var rota = Api.mensageiro.listarMensagens + '/' + codigoColaborador + '/' + pagina;
            RequisicaoGenericaService.listarSemParams(rota).then(
                function (success) {
                    deferred.resolve(success.data);

                },
                function (error) {
                    deferred.reject(error.data);
                }
            );
            return deferred.promise;
        }

        this.procuraMensagemPeloId = function (codigoMensagem) {
            var deferred = $q.defer();
            var rota = Api.mensageiro.procuraMensagemPeloId + '/' + codigoMensagem;
            RequisicaoGenericaService.listarSemParams(rota).then(
                function (success) {
                    deferred.resolve(success.data);

                },
                function (error) {
                    deferred.reject(error.data);
                }
            );
            return deferred.promise;

        }


        this.listarMensagensEnviadas = function (codigoColaborador, pagina, controlePreloader) {
            var deferred = $q.defer();
            var rota = Api.mensageiro.listarMensagensEnviadas + '/' + codigoColaborador + '/' + pagina;
            RequisicaoGenericaService.listarSemParams(rota).then(
                function (success) {
                    deferred.resolve(success.data);
                },
                function (error) {
                    deferred.reject(error.data);
                }
            );
            return deferred.promise;
        };

        this.listarMensagensArquivadas = function (codigoColaborador, pagina, controlePreloader) {
            var deferred = $q.defer();
            var rota = Api.mensageiro.listarMensagensArquivadas + '/' + codigoColaborador + '/' + pagina;
            RequisicaoGenericaService.listarSemParams(rota).then(
                function (success) {
                    deferred.resolve(success.data);
                },
                function (error) {
                    deferred.reject(error.data);
                }
            );
            return deferred.promise;
        };

        this.listarMensagensImportantes = function (codigoColaborador, pagina, controlePreloader) {
            var deferred = $q.defer();
            var rota = Api.mensageiro.listarMensagensImportantes + '/' + codigoColaborador + '/' + pagina;
            RequisicaoGenericaService.listarSemParams(rota).then(
                function (success) {
                    deferred.resolve(success.data);
                },
                function (error) {
                    deferred.reject(error.data);
                }
            );
            return deferred.promise;
        }

        this.listarHistoricoMensagem = function (identificadorMensagem) {
            return RequisicaoGenericaService.listarSemParams(Api.mensageiro.listarHistoricoMensagem + identificadorMensagem);
        }

        this.enviar = function (mensagem, success, error) {
            var deferred = $q.defer();
            console.log('mensagem a ser enviada', mensagem);
            RequisicaoGenericaService.salvar(Api.mensageiro.enviar, mensagem)
                .then(
                    function (response) {
                        success();
                    },
                    function (erro) {
                        error(erro)
                    });

            return deferred.promise;
        }

        this.marcarComoArquivado = function (dadoMensagem) {
            var defered = $q.defer();
            RequisicaoGenericaService.editar(Api.mensageiro.marcarComoArquivado, dadoMensagem).then(
                function (response) {
                    defered.resolve(response);
                },
                function (err) {
                    defered.reject(err);
                });

            return defered.promise;
        }

        this.marcarComoImportante = function (dadoMensagem) {
            var defered = $q.defer();
            RequisicaoGenericaService.editar(Api.mensageiro.marcarComoImportante, dadoMensagem).then(
                function (response) {
                    defered.resolve(response);
                },
                function (err) {
                    defered.reject(err);
                });

            return defered.promise;
        }

        this.marcarComoLido = function (dadoMensagem) {
            var defered = $q.defer();
            RequisicaoGenericaService.editar(Api.mensageiro.marcarComoLido, dadoMensagem).then(
                function (response) {
                    defered.resolve(response);
                },
                function (err) {
                    defered.reject(err);
                });

            return defered.promise;
        }

        this.pesquisar = function (codigoColaborador, pagina, criteriosDeBusca, grupo) {
            var deferred = $q.defer();
            var rota = Api.mensageiro.pesquisar +
                +codigoColaborador + '/' + pagina + '?condicao=' + criteriosDeBusca + "&grupo=" + grupo;
            RequisicaoGenericaService.listarSemParams(rota).then(
                function (success) {
                    deferred.resolve(success.data);
                },
                function (error) {
                    deferred.reject(error.data);
                }
            );
            return deferred.promise;
        };

        //endregion
    }


})();

/**
 * Created by nova on 20/07/2016.
 */
(function () {
    'use strict';

    angular
        .module('app.service')
        .service("MdToastService", MdToastService);

    function MdToastService($mdToast) {

        this.toastPadrao = function (texto, erro) {
            _constroiToast(texto, erro, null);
        }

        this.toastPadraoCor = function (texto, cor) {
            _constroiToast(texto, null, cor);
        }
        this.toastPadraoLocacao = function(texto,erro, tempo){
          _constroiToastLocacao(texto,erro,tempo, null);
        }

        function _constroiToast(texto, erro, cor) {
            var corToast;

            if (erro)
                corToast = 'error-toast';
            else
                corToast = 'success-toast'

            if (!angular.equals(undefined,cor) && !angular.equals(null,cor))
                corToast = cor;

            $mdToast.show(
                $mdToast.simple()
                    .textContent(texto)
                    .position('top')
                    .theme(corToast)
                    .hideDelay(3000));
        }

        function _constroiToastLocacao(texto, erro, tempo, cor) {
            var corToast;

            if (erro)
                corToast = 'error-toast';
            else
                corToast = 'success-toast'

            if (!angular.equals(undefined,cor) && !angular.equals(null,cor))
                corToast = cor;

            $mdToast.show(
                $mdToast.simple()
                    .textContent(texto)
                    .position('top')
                    .theme(corToast)
                    .hideDelay(tempo));
        }

    } // MdDialogService

})();

/**
 * Created by nova on 20/07/2016.
 */
(function () {
    'use strict';

    angular
        .module('app.service')
        .service("MdDialogService", MdDialogService);

    function MdDialogService($mdDialog) {

        this.alertPadrao = function (titulo, event, htmlContent) {
            var alert = $mdDialog.alert()
                .parent(angular.element(document.querySelector('body')))
                .targetEvent(event)
                .clickOutsideToClose(true)
                .title(titulo)
                .htmlContent(htmlContent)
                .ariaLabel(titulo)
                .multiple(true)
                .ok("Ok");

            $mdDialog.show(alert);
        };

        this.alertPadraoComEvento = function (titulo, eventSim, event, htmlContent) {
            var alert = $mdDialog.alert()
                .parent(angular.element(document.querySelector('body')))
                .targetEvent(event)
                .clickOutsideToClose(true)
                .title(titulo)
                .htmlContent(htmlContent)
                .ariaLabel(titulo)
                .multiple(true)
                .ok("Ok");

            $mdDialog.show(alert).then(
                function () {
                    eventSim();
                }
            );
        };

        this.confirmPadraoComEvento = function (titulo, htmlContent, event, eventSim, eventNao) {
            var confirm = $mdDialog.confirm()
                .title(titulo)
                .ariaLabel(titulo)
                .htmlContent(htmlContent)
                .clickOutsideToClose(false)
                .targetEvent(event)
                .multiple(true)
                .ok("Sim")
                .cancel("Não");

            $mdDialog.show(confirm).then(
                function () {
                    if (angular.isDefined(eventSim) && eventSim) {
                        eventSim();
                    }
                },
                function () {
                    if (angular.isDefined(eventNao) && eventNao) {
                        eventNao();
                    }
                }
            );

        }

        this.alertPadraoResolve = function (titulo, event) {
            var alert = $mdDialog.alert()
                .parent(angular.element(document.querySelector('body')))
                .targetEvent(event)
                .clickOutsideToClose(true)
                .title("Falha ao resolver as dependências")
                .textContent("A conexão foi recusada pelo servidor. A aplicação será redirecionada para o estado anterior ativo.")
                .ariaLabel("Falha ao resolver as dependências, a conexão foi recusada pelo servidor")
                .multiple(true)
                .ok("Ok");

            $mdDialog.show(alert);
        };

        this.abrirDialogPadrao = function (event, NomeController, templateHtml, parametros, escToClose) {
            if (angular.isUndefined(escToClose))
                escToClose = true;

            $mdDialog.show({
                controller: NomeController,
                controllerAs: 'vm',
                templateUrl: templateHtml,
                //parent: ---------------,
                targetEvent: event,
                clickOutsideToClose: false,
                escapeToClose: escToClose,
                multiple: true,
                locals: {
                    Parametros: parametros
                }
            });
        }

    } // MdDialogService

})();

(function ()
 {
    'use strict';

    angular
        .module('app.service')
        .service('LoginService', LoginService);

    /** @ngInject */
    function LoginService(ApiAcesso, $http, ControleAcessoConfig, urlApi)
    {
        var configuracao = ControleAcessoConfig.configuracao;


        this.gerarToken = function(usuario, senha){
            return $http({
                url: urlApi.url_base_api + ApiAcesso.baseUrl + ApiAcesso.seguranca.token,
                data : 'grant_type=password&username=' + btoa(usuario) + '&password=' + btoa(senha),
                headers : {
                    'Content-Type': 'application/x-www-form-urlencoded'
                },
                method: "POST"
            });
        };

    }
})();

(function () {
    'use strict';

    angular
        .module('app.service')
        .service('LoginUsuarioService', LoginUsuarioService);

    /** @ngInject */
    function LoginUsuarioService(ApiAcesso, $http, ControleAcessoConfig, TokenService, urlApi, Api) {
        var configuracao = ControleAcessoConfig.configuracao;

        this.listarTodos = function () {
            var token = TokenService.getToken();
            return $http({
                url: urlApi.url_base_api + ApiAcesso.baseUrl + ApiAcesso.usuario.listartodos,
                method: "GET",
                headers: { "Authorization": "Bearer " + token }
            });
        };

        this.listarPorPerfil = function (intCodigoPerfil) {
            var token = TokenService.getToken();
            return $http({
                url: urlApi.url_base_api + ApiAcesso.baseUrl + ApiAcesso.usuario.listarporperfil + intCodigoPerfil,
                method: "GET",
                headers: { "Authorization": "Bearer " + token }
            });
        };

        this.usuarioPorId = function (intCodigo) {
            var token = TokenService.getToken();
            return $http({
                url: urlApi.url_base_api + ApiAcesso.baseUrl + ApiAcesso.usuario.baseUrl + intCodigo,
                method: "GET",
                headers: { "Authorization": "Bearer " + token }
            });
        };

        this.usuarioPorLoginSenha = function (strLogin, strSenha) {
            var lstrLogin = btoa(strLogin);
            var lstrSenha = btoa(strSenha);
            var token = TokenService.getToken();

            return $http({
                url: urlApi.url_base_api + Api.usuario.retornarUsuarioPorUsuarioESenha,
                params: {
                    strLogin: lstrLogin,
                    strSenha: lstrSenha
                },
                method: "GET",
                headers: { "Authorization": "Bearer " + token }
            });
        };

        this.alterarSenha = function (_strLogin, _strSenhaAtual, _strSenhaNova) {
            var lstrLogin = btoa(_strLogin);
            var lstrSenhaAtual = btoa(_strSenhaAtual);
            var lstrSenhaNova = btoa(_strSenhaNova);
            var token = TokenService.getToken();
            var configuracao = ControleAcessoConfig.configuracao;

            var lstrUrl = urlApi.url_base_api + ApiAcesso.baseUrl + ApiAcesso.usuario.baseUrl +
                ApiAcesso.usuario.alterarsenha +
                "?strLogin=" + lstrLogin + "&strSenhaAtual=" + lstrSenhaAtual + "&strSenhaNova=" + lstrSenhaNova;

            return $http({
                url: lstrUrl,
                method: "PUT",
                headers: { "Authorization": "Bearer " + token }
            });
        };

        this.armazenarUsuario = function (usuario) {
            sessionStorage.setItem(ControleAcessoConfig.key_usuario, JSON.stringify(usuario));
        };

        this.usuarioArmazenado = function () {
            return JSON.parse(sessionStorage.getItem(ControleAcessoConfig.key_usuario));
        };

        this.logout = function () {
            sessionStorage.removeItem(ControleAcessoConfig.key_usuario);
            sessionStorage.removeItem(ControleAcessoConfig.key_token);
            localStorage.removeItem('squadCodigo_usuarioLogado');
        };
    }
})();

(function () {
    'use strict';

    angular
        .module('app.service')
        .service('LocalStorageService', LocalStorageService);

    /** @ngInject */
    function LocalStorageService() {

        this.chavesLocalStorage = {
            tamanhoPaginaDatatable: "Tamanho_Pagina_Datatable",
            badgeMensagensNaoVisualizadas: "Badge_Mensagens_Nao_Visualizadas",
            menus: "Menus"
        }

        this.armazenar = function (chave, valor) {
            var valorArmezanar = JSON.stringify(valor);
            localStorage.setItem(chave, valorArmezanar);
        }

        this.recuperar = function (chave) {
            var valorRecuperado = localStorage.getItem(chave);
            return _ehJson(valorRecuperado) ? JSON.parse(valorRecuperado) : valorRecuperado;
        }

        this.remover = function (chave) {
            localStorage.removeItem(chave);
        }

        this.removerTodosItens = function(){
            localStorage.clear();
        }

        function _ehJson(valor) {
            try {
                JSON.parse(valor);
            } catch (e) {
                return false;
            }
            return true;
        }

    }

})();

(function () {
    'use strict';
    angular
        .module('app.service')
        .service('ImplantacaoMigracaoService', ImplantacaoMigracaoService);

    function ImplantacaoMigracaoService($q, $state, msUtils, RequisicaoGenericaService, Api, MdDialogService, ServicosGenericoService, MdToastService) {

        this.verificarDataVencida = verificarDataVencida;
        this.navegarParaAtendimento = navegarParaAtendimento;
        this.atualizarTarefa = atualizarTarefa;
        this.atualizarSubprocesso = atualizarSubprocesso;
        this.atualizarTarefaSubprocesso = atualizarTarefaSubprocesso;
        this.removerSubprocessoDaTarefa = removerSubprocessoDaTarefa;
        this.adicionarSubprocessoNaTarefa = adicionarSubprocessoNaTarefa;

        /**
         * Método para verificar se a dataFinal da etapa do subprocesso foi excedida
         * @param {Date} data
         */
        function verificarDataVencida(data) {
            if (data) {
                var dataAtual = new Date();
                var dataFinal = new Date(data);
                return dataFinal <= dataAtual ? true : false;
            }
            else
                throw new ("É necessário informar a data");
        }

        /**
         * Método que quando chamado irá navegar para tela de atendimento já pesquisando o atendimento passado como parâmetro
         * @param {number} codigoAtendimento
         * @param {number} anoAtendimento
         */
        function navegarParaAtendimento(codigoAtendimento, anoAtendimento) {
            $state.goNewTab('app.atendimento_processamento_atendimento', {
                parametros: {
                    codigo: codigoAtendimento,
                    ano: anoAtendimento,
                    chamarPesquisa: true
                }
            });
        }


        /**
         * Método para atualizar a tarefa de um subprocesso
         * @param {object} subprocesso
         * @param {object} tarefaAtual
         */
        function atualizarTarefa(subprocesso, tarefaAtual) {
            var deferred = $q.defer();
            var data = new Date();

            data.setDate(data.getDate() + tarefaAtual.periodo);

            subprocesso.codigoTarefaAtual = tarefaAtual.codigo;

            if (subprocesso.codigoTarefaAtual != 1) {
                subprocesso.dataFinalTarefa = data;
            }

            RequisicaoGenericaService.editar(Api.implantacaoMigracao.subprocesso.alterar, subprocesso).then(
                function (success) {
                    MdToastService.toastPadrao("Alteração de tarefa realizada com sucesso!");
                    deferred.resolve(success);
                },
                function (error) {
                    deferred.reject(error);
                    ServicosGenericoService.exibirAlertaDeErro(error, event)
                });
            return deferred.promise;
        }

        /**
         * Método para atualizar a datafinal de um subprocesso
         * @param {Array} tarefasProcesso
         * @param {object} subprocessoAtualizado
         */
        function atualizarSubprocesso(tarefasProcesso, subprocessoAtualizado) {
            tarefasProcesso.map(function (itensTarefa) {
                itensTarefa.subProcessos.map(function (itensSubprocesso) {
                    if (itensSubprocesso.codigo == subprocessoAtualizado.codigo) {
                        itensSubprocesso.dataFinalTarefa = subprocessoAtualizado.dataFinalTarefa;
                        itensSubprocesso.tarefaFinalizada = false;
                    }
                });
            });
        }

        /**
         * Método que atualizar a etapa do subprocesso removendo da etapa em que ele se encontrava
         * e inserindo o subprocesso na nova etapa atual do mesmo
         * @param {Array} tarefasProcesso
         * @param {Object} etapaAtual
         * @param {Object} subprocesso
         */
        function atualizarTarefaSubprocesso(tarefasProcesso, etapaAtual, subprocesso) {
            removerSubprocessoDaTarefa(tarefasProcesso, subprocesso);
            adicionarSubprocessoNaTarefa(tarefasProcesso, etapaAtual, subprocesso);
        }


        /**
         * Método para remover um subprocesso de sua tarefa
         * @param {Array} tarefasProcesso
         * @param {object} subprocesso
         */
        function removerSubprocessoDaTarefa(tarefasProcesso, subprocesso) {
            var subprocessoRemovido = false;
            tarefasProcesso.map(function (tarefa) {
                tarefa.subProcessos.map(function (itenSubprocesso) {
                    if (itenSubprocesso.codigo == subprocesso.codigo && !subprocessoRemovido) {
                        subprocessoRemovido = true;
                        tarefa.subProcessos.splice(tarefa.subProcessos.indexOf(itenSubprocesso), 1);
                    }
                });
            });
        }

        /**
         * Método para adicionar um subprocesso em uma nova etapa
         * @param {Array} tarefasProcesso
         * @param {object} etapaAtual
         * @param {object} subprocesso
         */
        function adicionarSubprocessoNaTarefa(tarefasProcesso, etapaAtual, subprocesso) {
            var subprocessoInserido = false;
            tarefasProcesso.map(function (itensTarefa) {
                if (itensTarefa.codigo == etapaAtual.codigo && !subprocessoInserido && (itensTarefa.subprocessos.indexOf(subprocesso) == -1)) {
                    subprocessoInserido = true;
                    itensTarefa.subprocessos.push(subprocesso);
                }
            });
        }

    }


})();

(function () {
    'use strict';

    angular
        .module('app.service')
        .service('GerenciamentoProtecaoService', GerenciamentoProtecaoService);

    function GerenciamentoProtecaoService(DatatableFactory, RequisicaoGenericaService, $mdDialog, RotasHtml, Api) {

        var _api = Api.protecao;
        var controladorAtivo = false;

        function _retornaDtOptionsComColunas() {            
            return DatatableFactory.construirDtOptionsComPaginacaoResponsivoPadrao([
                DatatableFactory.construirColunaAcaoPadrao(0)
            ]);
        }

        function _atualizarQuantidadeLicencas(entidade) {
            return RequisicaoGenericaService.editar(_api.gerenciamentoProtecao.atualizarQuantidadeLicenca, entidade);
        }

        function _atualizarDataExpiracao(data) {
            return RequisicaoGenericaService.editar(_api.gerenciamentoProtecao.atualizarDataExpiracao, data);
        }

        function _formata30AEsquerda(numero) {
            var numetoString = String(numero);
            if (numetoString.length == 1)
                return "00" + numero;
            if (numetoString.length == 2)
                return "0" + numero;
            if (numero >= 3)
                return numero;
        }

        function _abrirDialogEditarQuantidadeLicenca(licencaSelecionada) {
            $mdDialog.show({
                controller: 'DialogQuantidadeLicencaController',
                controllerAs: 'vm',
                templateUrl: RotasHtml.gerenciamentoProtecao.dialogs.quantidadeLicenca,
                multiple: true,
                targetEvent: event,
                clickOutsideToClose: false,
                locals: {
                    LicencaSelecionada: licencaSelecionada
                }
            });
        }

        function _abrirDialogDetalhesLicenca(licencaSelecionada){
            $mdDialog.show({
                controller: 'DetalhesDialogController',
                controllerAs: 'vm',
                templateUrl: RotasHtml.gerenciamentoProtecao.dialogs.detalhes,
                multiple: true,
                targetEvent: event,
                clickOutsideToClose: false,
                locals: {
                    LicencaSelecionada: angular.copy(licencaSelecionada)
                }
            });
        }

        function _abrirDialogProtecao(protecaoLicenca, numero) {
            $mdDialog.show({
                controller: 'ProtecaoDialogController',
                controllerAs: 'vm',
                templateUrl: RotasHtml.gerenciamentoProtecao.dialogs.protecao,
                multiple: true,
                targetEvent: event,
                clickOutsideToClose: false,
                locals: {
                    ProtecaoLicenca: protecaoLicenca,
                    NumeroLicenca: numero
                }
            });
        }

        function _gerarProtecaoAvulsaPorDataExpiracao(licencaSelecionada) {
            var uri = _api.protecaoAvulsa.listarDataExpiracao + '/' + licencaSelecionada.clienteCodigo + '/' + licencaSelecionada.numero;
            _geraProtecaoAvulsaRequisicaoUrl(licencaSelecionada, uri);

        }

        function _gerarProtecaoAvulsaPorLicenca(licencaSelecionada) {
         
            var uri = _api.protecaoAvulsa.listarLicenca + '/' + licencaSelecionada.clienteCodigo + '/' + licencaSelecionada.numero;
            _geraProtecaoAvulsaRequisicaoUrl(licencaSelecionada, uri);
        }

        function _geraProtecaoAvulsaRequisicaoUrl(licencaSelecionada, url) {
            controladorAtivo = true;
            RequisicaoGenericaService.listarSemParams(url)
                .then(function (success) {
                    _abrirDialogProtecao(success.data, licencaSelecionada.numero);
                    controladorAtivo = false;

                }, function (error) {
                    controladorAtivo = false;
                });
        }


        return {
            requisicaoSolicitada: controladorAtivo,
            retornaDtOptionsComColunas: _retornaDtOptionsComColunas,
            abrirDialogEditarQuantidadeLicenca: _abrirDialogEditarQuantidadeLicenca,
            formata30AEsquerda: _formata30AEsquerda,
            atualizarQuantidadeLicencas: _atualizarQuantidadeLicencas,
            atualizarDataExpiracao: _atualizarDataExpiracao,
            gerarProtecaoAvulsaPorLicenca: _gerarProtecaoAvulsaPorLicenca,
            abrirDialogDetalhesLicenca: _abrirDialogDetalhesLicenca,
            gerarProtecaoAvulsaPorDataExpiracao: _gerarProtecaoAvulsaPorDataExpiracao
        }
    }
})();
/**
 * Created by nova on 25/10/2016.
 */
(function () {
    'use strict';

    angular
        .module('app.service')
        .service('EstoriaService', EstoriaService);

    function EstoriaService(Api, RequisicaoGenericaService, MdToastService, MdDialogService, $q) {

        // Métodos de Requests region

        // Método de request interno do Serviço
        var listarGenericamente = function (rota, estoriaNumero, estoriaAno, controleForm, squadCodigo, prazoAcordado) {
            var deferred = $q.defer();
            controleForm.emProgresso = true;
            var rotaCompleta = rota + estoriaNumero + '/' + estoriaAno;
            if (squadCodigo !== undefined && squadCodigo !== null) {
                rotaCompleta += '/' + squadCodigo;
            }
            if (arguments.length >= 6) {
                rotaCompleta += '/' + prazoAcordado;
            }
            RequisicaoGenericaService.
                listarSemParams(rotaCompleta).then(
                    function (success) {
                        controleForm.emProgresso = false;
                        deferred.resolve(success.data);
                    },
                    function (error) {
                        controleForm.emProgresso = false;
                        deferred.reject(error.data);
                    });
            return deferred.promise;
        }

        this.salvarListaDeTarefas = function (estoria, controleForm, listaDeTarefas, abrirViewTabelaTarefasDaEstoriaSemVerificacao, event) {
            var modelo = {
                estoriaNumero: estoria.numero,
                estoriaAno: estoria.ano,
                estoriaTarefas: listaDeTarefas
            };
            controleForm.preLoaderToolbar.inicioProgresso();
            RequisicaoGenericaService.salvar(Api.estoria.tarefa.gerarTarefas, modelo).then(
                function (success) {
                    MdToastService.toastPadrao("Tarefas cadastradas com sucesso!");

                    success.data.estoriaTarefas.forEach(function (item, index) {
                        estoria.tarefas.push(item);
                    });


                    controleForm.preLoaderToolbar.fimProgresso();
                    abrirViewTabelaTarefasDaEstoriaSemVerificacao();
                },
                function (error) {
                    controleForm.preLoaderToolbar.fimProgresso();
                    MdDialogService.alertPadrao(error.data, event);
                });
        }

        this.listarRotinas = function (rotinas, solucaoCodigo, controleForm) {
            controleForm.preLoaderToolbar.inicioProgresso();
            return RequisicaoGenericaService.
                listarSemParams(Api.solucao_rotinas_tarefas.rotinas.listarRotinasPorSolucao + solucaoCodigo).then(
                    function (success) {
                        controleForm.preLoaderToolbar.fimProgresso();
                        return success;
                    },
                    function (error) {
                        controleForm.preLoaderToolbar.fimProgresso();
                    });
        };
        // endregion

        this.verificaTabSelecionada = function (tab, estoria, estoriaNumero, estoriaAno, controleForm, squadCodigo, prazoAcordado) {
            switch (tab) {
                case 'clientes':
                    listarGenericamente(Api.estoria.clientes.listarPor, estoriaNumero, estoriaAno, controleForm, squadCodigo).then(function (success) {
                        estoria.clientesVinculados = success;
                    });
                    break;
                case 'estimativa':
                    listarGenericamente(Api.sprint.backlog.listarPontuacao, estoriaNumero, estoriaAno, controleForm, squadCodigo).then(function (success) {
                        estoria.estimativas = success;
                    });
                    break;
                case 'priorizacao':
                    listarGenericamente(Api.sprint.backlog.listarPriorizacao, estoriaNumero, estoriaAno, controleForm, squadCodigo).then(function (success) {
                        estoria.priorizacoes = success;
                    });
                    break;
                case 'tarefas':
                    listarGenericamente(Api.estoria.tarefa.listarPor, estoriaNumero, estoriaAno, controleForm, squadCodigo).then(function (success) {
                        estoria.tarefas = success;
                    });
                    break;
                case 'historico':
                    listarGenericamente(Api.estoria.historico.listarPor, estoriaNumero, estoriaAno, controleForm, squadCodigo, null).then(function (success) {
                        estoria.historicoSituacao = success;
                    });
                    break;
                case 'requisito':
                    listarGenericamente(Api.estoria.requisito.listarPor, estoriaNumero, estoriaAno, controleForm, squadCodigo).then(function (success) {
                        estoria.estoriaRequisito = success;
                    });
                    break;
                default:
                    break;
            }
        };

        this.controlaButtonsToolbar = function (tab, controleForm) {
            if (tab !== 'estoria') {
                if (angular.isDefined(controleForm)) {
                    controleForm.desabilitarButtonEditar = true;
                    controleForm.desabilitarButtonInserir = true;
                    controleForm.desabilitarButtonExcluir = true;
                    controleForm.desabilitarButtonListarTodos = true;
                    controleForm.desabilitarMetodoToolbarAtualizar = true;
                }
            } else {
                if (angular.isDefined(controleForm)) {
                    controleForm.desabilitarButtonEditar = false;
                    controleForm.desabilitarButtonInserir = false;
                    controleForm.desabilitarButtonExcluir = false;
                    controleForm.desabilitarButtonListarTodos = false;
                    controleForm.desabilitarMetodoToolbarAtualizar = false;
                }
            }
        };

        this.verificaTabParaHabilitarPesquisarHeaderPadrao = function (tab) {
            if (tab !== 'estoria') {
                return true;
            } else {
                return false;
            }
        }

        this.pesquisarCliente = function (query, clientes) {
            query = query.toLowerCase();
            var results = query ? clientes.filter(function (value, indice, array) {
                return ((value.codigo == query) || (value.nome.toLowerCase().indexOf(query) === 0));
            }) : clientes;
            return results;
        }

        this.clienteSelecionado = function (item, estoria, solucoes, textoDePesquisaCliente, solucoesTemporaria) {
            if (item) {
                estoria.clienteCodigo = item.codigo;
                solucoes = item.solucoes;
            } else {
                estoria.clienteCodigo = null;
                estoria.solucaoCodigo = null;
                textoDePesquisaCliente = ""
                solucoes = solucoesTemporaria;
            }
        }

        this.retornaSituacaoAtualDaHistoria = function (estoria, estoriaNumero, estoriaAno, controleForm, squadCodigo) {
            var deferred = $q.defer();

            listarGenericamente(Api.estoria.historico.listarPor, estoriaNumero, estoriaAno, controleForm, squadCodigo, null).then(function (success) {
                estoria.situacaoAtualHistoria = success[0].situacao;
                deferred.resolve({ historicoSituacao: success, situacaoAtualHistoria: estoria.situacaoAtualHistoria });
            }, function (error) {
                deferred.reject(error);
            });
            return deferred.promise;
        };
    }
})();

(function () {
    'use strict';

    angular
        .module('app.service')
        .service('DataService', DataService);

    function DataService() {

        this.getDataAtual = function () {
            return new Date().getMonth() + 1;
        };

        this.getAnoAtual = function () {
            return new Date().getFullYear();
        };

        return {
            dataAtual: this.getDataAtual(),
            anoAtual: this.getAnoAtual()
        };
    }

})();

(function () {
    'use strict';

    angular
        .module('app.service')
        .service('CustoSoftwareService', CustoSoftwareService);

    function CustoSoftwareService(RequisicaoGenericaService, Api) {

        this.salvar = function (modelo) {
            return RequisicaoGenericaService.salvar(Api.custo_software.custo.salvar, _preparaEntidadeParaSalvar(modelo));
        };

        this.editar = function (modelo) {
            return RequisicaoGenericaService.editar(Api.custo_software.custo.atualizar, _preparaEntidadeParaSalvar(modelo));
        }

        this.pesquisar = function (entidadeDeEnvio) {
            return RequisicaoGenericaService.listarComObjetoComplexo(Api.custo_software.custo.listarComPaginacao, entidadeDeEnvio);
        }

        this.excluir = function (modelo) {
            return RequisicaoGenericaService.excluir(Api.custo_software.custo.excluir, modelo.codigo)
        }

        this.listarTodosHistoricosCusto = function () {
            return RequisicaoGenericaService.listarSemParams(Api.custo_software.historico.listar);
        }

        function _preparaEntidadeParaSalvar(entidade) {
            return {
                codigo: entidade.codigo,
                descricao: entidade.descricao,
                custo: entidade.custo,
                prazo: entidade.prazo,
                squadCodigo: entidade.squadCodigo,
                codigoHistoricoCusto: entidade.historicoCusto.codigo
            };

        }

    }

})();
/**
 * Created by nova on 25/10/2016.
 */
(function () {
  'use strict';

  angular
    .module('app.service')
    .service('ConsultasEstoriaService', ConsultasEstoriaService);

  function ConsultasEstoriaService($filter, Api, LoginUsuarioService, ConsultasEstoriaFactory) {

    var dataAtual = ConsultasEstoriaFactory.setDataAtual();

    this.verificarDiasRestantes = function (listaDeEstorias, estoriasVencidas, estoriasSeteDiasRestantes) {
      angular.forEach(listaDeEstorias, function (key, value) {
        var dataEntrega = new Date(key.dataEntrega);
        dataEntrega.setHours(0);
        dataEntrega.setMinutes(0);
        dataEntrega.setSeconds(0);
        dataEntrega.setMilliseconds(0);
        var dataFormatada = $filter('date')(dataEntrega, 'dd/MM/yyyy', 'UTC');
        var diasRestantes;
        if (dataAtual >= dataEntrega) {
          listaDeEstorias[value].diasRestantes = 0;
          diasRestantes = 0
          estoriasVencidas.push(dataFormatada);
        } else {
          diasRestantes = parseInt((((((dataEntrega.getTime() - dataAtual.getTime()) / 1000) / 60) / 60) / 24));
          listaDeEstorias[value].diasRestantes = diasRestantes;
          if (diasRestantes <= 7 && diasRestantes > 0) {
            estoriasSeteDiasRestantes.push(dataFormatada);
          }
        }
        return diasRestantes;
      });
    };

    this.defineArrayDePesquisa = function (legenda, estoriasVencidas, estoriasSeteDiasRestantes) {
      if (legenda.codigoLegenda === 1) {
        if (estoriasVencidas.length > 0) {
          return estoriasVencidas;
        } else {
          return "Sem Estórias Vencidas";
        }
      } else {
        if (estoriasSeteDiasRestantes.length > 0) {
          return estoriasSeteDiasRestantes;
        } else {
          return "Sem estórias com 7 Dias Restantes";
        }
      }
    };

    this.sugestaoFiltro = function (sugestaoFiltro, filtros) {
      if (!sugestaoFiltro.selecionado) {
        angular.forEach(sugestaoFiltro.filtros, function (item, index) {
          if (filtros.indexOf(item) === -1) {
            filtros.push(item);
          }
        });
      } else {
        angular.forEach(sugestaoFiltro.filtros, function (item, index) {
          if (filtros.indexOf(item) > -1) {
            filtros.splice(filtros.indexOf(item), 1);
          }
        });
      }
    };
  }

})();

/**
 * Created by nova on 25/10/2016.
 */
(function() {
    'use strict';

    angular
        .module('app.service')
        .service('ClienteService', ClienteService);

    function ClienteService($q, $timeout, RequisicaoGenericaService, Api, MdDialogService, MdToastService, PgToolbarService) {

        // ********************************************* Variáveis locais *********************************************

        // ********************************************* Fim Variáveis locais *********************************************

        // ******************************************** Métodos Cliente *************************************************

        this.controlaButtonsToolbarService = controlaButtonsToolbarService;
        this.verificaTabSelecionadaService = verificaTabSelecionadaService;
        this.pesquisarAutoCompletepessoaService = pesquisarAutoCompletepessoaService;
        this.criarPessoaDeReferenciaService = criarPessoaDeReferenciaService;
        this.excluirPessoaDeReferenciaService = excluirPessoaDeReferenciaService;

        /**
         * Função que faz uma requisição de forma genérica para api e retorna uma promise
         * @param {*Api.constant} rota
         * @param {*vm.cliente} cliente
         * @param {*vm.controleForm} controleForm
         */
        function pesquisarGenericamente(rota, cliente, controleForm, controlePreloader) {
            var deferred = $q.defer();
            PgToolbarService.iniciarPreLoaderToolbar(controleForm, controlePreloader);
            RequisicaoGenericaService.listarSemParams(rota + cliente.codigo).then(
                function(success) {
                    console.log(success.data);
                    PgToolbarService.finalizarPreLoaderToolbar(controleForm, controlePreloader);
                    deferred.resolve(success.data);
                },
                function(error) {
                    PgToolbarService.finalizarPreLoaderToolbar(controleForm, controlePreloader);
                    deferred.reject(error.data);
                });
            return deferred.promise;
        }


        /**
         * Método controlador de requisições por tab
         * @param {*tab cliente-form} tab
         * @param {*vm.cliente} cliente
         * @param {*vm.controleForm} controleForm
         */
        function verificaTabSelecionadaService(tab, cliente, controleForm, controlePreloader, listarInformacoesDaTab) {
            if (listarInformacoesDaTab[tab] != null)
                listarInformacoesDaTab[tab]();

            switch (tab) {
                case 'pessoalDeReferencia':
                    pesquisarGenericamente(Api.cliente.listarPessoasDeReferencia, cliente, controleForm, controlePreloader).then(
                        function(success) {
                            cliente.pessoasDeReferencia = success;
                        });
                    break;
                case 'equipamentos':
                    pesquisarGenericamente(Api.cliente_equipamento.listarClienteEquipamentoPorCodigoCliente, cliente, controleForm, controlePreloader).then(
                        function(success) {
                            cliente.equipamentos = success;
                        });
                    break;
                default:
                    break;
            }
        };

        /**
         * Método que controlla os buttons do toolbar nas tabs
         * @param {*tab cliente-form} tab
         * @param {*vm.controleForm} controleForm
         */
        function controlaButtonsToolbarService(tab, controleForm) {
            if (tab !== 'cliente' && tab !== 'observacoesTecnicas' && tab !== 'dadosAuxiliares') {
                if (angular.isDefined(controleForm)) {
                    controleForm.desabilitarButtonListarTodos = true;
                    controleForm.desabilitarMetodoToolbarAtualizar = true;
                    controleForm.desabilitarButtonEditar = true;
                    controleForm.desabilitarButtonInserir = true;
                    controleForm.desabilitarButtonExcluir = true;
                }
            } else {
                if (angular.isDefined(controleForm)) {
                    controleForm.desabilitarButtonEditar = false;
                    controleForm.desabilitarButtonInserir = false;
                    controleForm.desabilitarButtonExcluir = false;
                    controleForm.desabilitarButtonListarTodos = false;
                    controleForm.desabilitarMetodoToolbarAtualizar = false;
                }
            }
        };

        /**
         * Função para pesquisar dinâmicamente uma pessoa
         * @param {*query de pesquisa} query
         */
        function pesquisarAutoCompletepessoaService(query) {

            var deferred = $q.defer();
            var queryConsulta = {};
            if (parseInt(query))
                queryConsulta.codigo = query;
            else
                queryConsulta.nome = query;

            $timeout(function() {


                RequisicaoGenericaService.listarComParamsFormatoString(Api.pessoa.listarPorCodigoENome, queryConsulta).then(
                    function(success) {
                        deferred.resolve(success.data)
                    },
                    function(error) { deferred.reject(error.data) });
            });
            return deferred.promise;
        }

        /**
         * Função que inserir uma pessoa de referencia no cliente
         * @param {*objeto} pessoa
         */
        function criarPessoaDeReferenciaService(pessoa, cliente, controleForm, controlePreloader) {
            var pessoaDeReferencia = {
                codigoCliente: cliente.codigo,
                codigoPessoa: pessoa.codigo
            };

            PgToolbarService.iniciarPreLoaderToolbar(controleForm, controlePreloader);
            RequisicaoGenericaService.editar(Api.cliente.cadastrarPessoaDeReferencia, pessoaDeReferencia).then(
                function(success) {
                    controleForm.emProgresso = false;
                    cliente.pessoasDeReferencia.push(success.data);
                    PgToolbarService.finalizarPreLoaderToolbar(controleForm, controlePreloader);
                },
                function(error) {
                    MdDialogService.alertPadrao(error.data, event);
                    controleForm.emProgresso = false;
                    PgToolbarService.finalizarPreLoaderToolbar(controleForm, controlePreloader);
                })
        }

        /**
         * Função para excluir uma pessoa de referencia do cliente
         * @param {*objeto} pessoa
         * @param {*vm.cliente} cliente
         * @param {*controleForm} controleForm
         * @param {*event do button} event
         */
        function excluirPessoaDeReferenciaService(pessoa, cliente, controleForm, event, controlePreloader) {
            MdDialogService.confirmPadraoComEvento("Excluir",
                'Deseja realmente está Pessoa ?', event,
                function() {
                    PgToolbarService.iniciarPreLoaderToolbar(controleForm, controlePreloader);
                    RequisicaoGenericaService.excluir(Api.cliente.excluirPessoaDeReferencia, pessoa.codigo + '/' + cliente.codigo).then(
                        function(success) {
                            MdToastService.toastPadrao(success.data);
                            cliente.pessoasDeReferencia.splice(cliente.pessoasDeReferencia.indexOf(pessoa), 1);
                            PgToolbarService.finalizarPreLoaderToolbar(controleForm, controlePreloader);
                        },
                        function(error) {
                            MdDialogService.alertPadrao(error.data, event);
                            PgToolbarService.finalizarPreLoaderToolbar(controleForm, controlePreloader);
                        });
                });
        }

        // ******************************************** Fim Métodos Cliente *************************************************

        // ******************************************** Métodos Privados *************************************************

        // ******************************************** Fim Métodos Privados *************************************************

    }

})();
/**
 * Created by nova on 25/10/2016.
 */
(function () {
    "use strict";

    angular
        .module("app.service")
        .service("AtendimentoService", AtendimentoService);

    function AtendimentoService(
        $q,
        $timeout,
        $state,
        $filter,
        RequisicaoGenericaService,
        ServicosGenericoService,
        Api,
        MdDialogService,
        MdToastService,
        DataTableConfigPadrao,
        AtendimentoHubFactory
    ) {
        ///////////////////////////////////////////////////////// Atributos /////////////////////////////////////////////////////////
        var arrayAtendimentosEmAbertoSeteDiasRestantes = [];
        var arrayAtendimentosEmAbertoVencidos = [];
        var arrayAtendimentoFinalizado = [];
        var arrayAtendimentoAberto = [];
        var arrayAtendimentosEmAbertoArrayDePesquisa = null;
        var arrayAtendimentosVinculadosArrayDePesquisa = null;
        var apiDataTable = null;

        /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

        this.atendimentosEmAbertoConstruirDtOptionsAtendimentosEmAberto = atendimentosEmAbertoConstruirDtOptionsAtendimentosEmAberto;
        this.atendimentosVinculadosConstruirDtOptionsAtendimentosVinculados = atendimentosVinculadosConstruirDtOptionsAtendimentosVinculados;
        this.atendimentosEmAbertoSelecionarArrayDePesquisa = atendimentosEmAbertoSelecionarArrayDePesquisa;
        this.construirArraysDeAtendimentosFinalizados = construirArraysDeAtendimentosFinalizados;
        this.atendimentosVinculadosSelecionarArrayDePesquisa = atendimentosVinculadosSelecionarArrayDePesquisa;
        this.atendimentosEmAbertoAtualizarArraysDeAtendimentoEmAberto = atendimentosEmAbertoAtualizarArraysDeAtendimentoEmAberto;
        this.atendimentosEmAbertoLimparArraysAtendimentosEmAbertoParaNovaPesquisa = atendimentosEmAbertoLimparArraysAtendimentosEmAbertoParaNovaPesquisa;
        this.atendimentoPesquisarAtendimentoMotivoAutoComplete = atendimentoPesquisarAtendimentoMotivoAutoComplete;
        this.atendimentoPesquisarHistoricoAtendimento = atendimentoPesquisarHistoricoAtendimento;
        this.atualizarAcompanhamentoAtendimentoUsuario = atualizarAcompanhamentoAtendimentoUsuario;
        this.atualizarImportanciaAtendimentoUsuario = atualizarImportanciaAtendimentoUsuario;
        this.listarAcompanhamentoPorAtendimentoEUsuario = listarAcompanhamentoPorAtendimentoEUsuario;
        this.atendimentoPesquisarAcompanhantesAtendimentoAtualizandoVisualizado = atendimentoPesquisarAcompanhantesAtendimentoAtualizandoVisualizado;
        this.atualizarAtendimentosImportantes = atualizarAtendimentosImportantes;
        this.atendimentoPesquisarAcompanhantesAtendimento = atendimentoPesquisarAcompanhantesAtendimento;
        this.atendimentoPesquisarAtendimentosNaoVisualizados = atendimentoPesquisarAtendimentosNaoVisualizados;
        this.atendimentoPesquisarAtendimentosImportantes = atendimentoPesquisarAtendimentosImportantes;
        this.atendimentoPesquisarAtendimentosEmAbertoDoUsuario = atendimentoPesquisarAtendimentosEmAbertoDoUsuario;
        this.atendimentoPesquisarAtendimentosEmAbertoUsuariosPorGerente = atendimentoPesquisarAtendimentosEmAbertoUsuariosPorGerente;
        this.verificarExistenciaClientePendencia = verificarExistenciaClientePendencia;
        this.abrirDialogClientePendencia = abrirDialogClientePendencia;
        this.abrirDialogAlertSolicitandoHistoricoAtendimento = abrirDialogAlertSolicitandoHistoricoAtendimento;
        this.setarValoresParaIniciarChamandoPesquisa = setarValoresParaIniciarChamandoPesquisa;
        this.atendimentoCriarMensagemAtendimentosVencidos = atendimentoCriarMensagemAtendimentosVencidos;
        this.setarValoresParaSalvarEEditar = setarValoresParaSalvarEEditar;
        this.pesquisarHistoriasVinculadas = pesquisarHistoriasVinculadas;

        /**
         * Método Interno que redireciona a aplicação para a tela de atendimento
         */
        function redirecionarParaAtendimento() {
            $state.go("app.atendimento_processamento_atendimento");
        }

        /**
         * Método Interno que constroi a 'lista de atendimentos em aberto vencidos' e a 'lista de atendimentos em aberto com sete dias restantes'
         * @param {listaAtendimentosEmAberto} listaAtendimentosEmAberto Lista de Atendimentos em aberto retornado da Api
         */
        function construirArraysDeAtendimentosEmAberto(listaAtendimentosEmAberto) {
            var dataAtual = ServicosGenericoService.definirDataAtual();
            angular.forEach(listaAtendimentosEmAberto, function (item, index) {
                var dataPrevisaoFechamento = new Date(item.dataPrevisaoFechamento);
                var dataPrevisaoFechamentoFormatado = $filter("date")(
                    dataPrevisaoFechamento,
                    "dd/MM/yyyy",
                    "UTC"
                );
                var diasRestantes;

                dataPrevisaoFechamento = ServicosGenericoService.definirTempoParaNull(
                    dataPrevisaoFechamento
                );

                if (dataAtual > dataPrevisaoFechamento) {
                    listaAtendimentosEmAberto[index].diasRestantes = -1;
                    arrayAtendimentosEmAbertoVencidos.push(
                        dataPrevisaoFechamentoFormatado
                    );
                } else {
                    diasRestantes = parseInt(
                        (dataPrevisaoFechamento.getTime() - dataAtual.getTime()) /
                        1000 /
                        60 /
                        60 /
                        24
                    );
                    listaAtendimentosEmAberto[index].diasRestantes = diasRestantes;
                    if (diasRestantes <= 7 && diasRestantes >= 0) {
                        arrayAtendimentosEmAbertoSeteDiasRestantes.push(
                            dataPrevisaoFechamentoFormatado
                        );
                    }
                }

                diasRestantes = null;
            });
        }

        function construirArraysDeAtendimentosFinalizados(listaAtendimentosEmAberto) {
            angular.forEach(listaAtendimentosEmAberto, function (item, index) {
                if (item.status == 1) {
                    arrayAtendimentoAberto.push(item.status);
                    arrayAtendimentosVinculadosArrayDePesquisa.push(item.status);
                }
                else {
                    arrayAtendimentoFinalizado.push(item.status);
                }


            });
        }

        /**
         * Método para construir as configurações do datable da tela/module Atendimentos em aberto
         */
        function atendimentosEmAbertoConstruirDtOptionsAtendimentosEmAberto() {
            var dtOptions = angular.copy(
                DataTableConfigPadrao.dtOptionsPadraoComPaginacaoPaginTypeNumbersEReponsivo
            );
            dtOptions.columnDefs = [
                DataTableConfigPadrao.columnDefsPadrao,
                { targets: -1, orderable: false }
            ];
            dtOptions.initComplete = function () {
                var api = this.api(),
                    searchBox = angular.element("body").find("#pesquisar"),
                    htmlCollection = document.getElementsByClassName(
                        "array-buttons-atendimentos-em-aberto"
                    ),
                    elemento = [];

                angular.forEach(htmlCollection, function (key, value, array) {
                    elemento.push(angular.element(key));

                    elemento[value].click(function (event) {
                        if (arrayAtendimentosEmAbertoArrayDePesquisa) {
                            var arrayFormatado = arrayAtendimentosEmAbertoArrayDePesquisa
                                .toString()
                                .replace(/,/g, "|");
                            api
                                .column(7)
                                .search(arrayFormatado, true, false)
                                .draw();
                        } else {
                            api
                                .column(7)
                                .search("")
                                .draw();
                        }
                    });
                });

                // Bind an external input as a table wide search box
                if (searchBox.length > 0) {
                    searchBox.on("keyup", function (event) {
                        api.search(event.target.value).draw();
                    });
                }
            };
            return dtOptions;
        }

        function atendimentosVinculadosConstruirDtOptionsAtendimentosVinculados() {
            var dtOptions = angular.copy(
                DataTableConfigPadrao.dtOptionsPadraoComPaginacaoPaginTypeNumbersEReponsivo
            );
            dtOptions.columnDefs = [DataTableConfigPadrao.columnDefsPadrao];
            dtOptions.initComplete = function () {
                var api = this.api(),
                    searchBox = angular.element("body").find("#pesquisar"),
                    htmlCollection = document.getElementsByClassName(
                        "array-buttons-atendimentos-vinculados"
                    ),
                    elemento = [];
                apiDataTable = api;

                angular.forEach(htmlCollection, function (key, value, array) {
                    elemento.push(angular.element(key));

                    elemento[value].click(function (event) {
                        if (arrayAtendimentosVinculadosArrayDePesquisa) {
                            var arrayFormatado = arrayAtendimentosVinculadosArrayDePesquisa
                                .toString()
                                .replace(/,/g, "|");
                            api
                                .column(5)
                                .search(arrayFormatado, true, false)
                                .draw();
                        } else {
                            api
                                .column(5)
                                .search("")
                                .draw();
                        }
                    });
                });

                // Bind an external input as a table wide search box
                if (searchBox.length > 0) {
                    searchBox.on("keyup", function (event) {
                        api.search(event.target.value).draw();
                    });
                }
            };
            return dtOptions;
        }

        /**
         * Método para selecionar o qual array de pesquisa será utilizado para filtrar a tabela
         * 'arrayAtendimentosEmAbertoSeteDiasRestantes' ou 'arrayAtendimentosEmAbertoVencidos'
         * @param {legeda} legenda legenda tela de atendimentos em aberto
         */
        function atendimentosEmAbertoSelecionarArrayDePesquisa(legenda) {
            if (!legenda) {
                arrayAtendimentosEmAbertoArrayDePesquisa = null;
            } else if (legenda.codigoLegenda == 1) {
                if (arrayAtendimentosEmAbertoVencidos.length > 0)
                    arrayAtendimentosEmAbertoArrayDePesquisa = arrayAtendimentosEmAbertoVencidos;
                else
                    arrayAtendimentosEmAbertoArrayDePesquisa =
                        "Sem Atendimentos Vencidos";
            } else {
                if (arrayAtendimentosEmAbertoSeteDiasRestantes.length > 0)
                    arrayAtendimentosEmAbertoArrayDePesquisa = arrayAtendimentosEmAbertoSeteDiasRestantes;
                else
                    arrayAtendimentosEmAbertoArrayDePesquisa =
                        "Sem Atendimentos com sete dias restantes";
            }
        }


        function atendimentosVinculadosSelecionarArrayDePesquisa(legenda) {
            if (!legenda) {
                arrayAtendimentosVinculadosArrayDePesquisa = null;
            } else if (legenda.codigoLegenda == 1) {
                if (arrayAtendimentoAberto.length > 0) {
                    arrayAtendimentosVinculadosArrayDePesquisa = arrayAtendimentoAberto;
                } else
                    arrayAtendimentosVinculadosArrayDePesquisa =
                        "Sem atendimentos abertos";
            } else if (legenda.codigoLegenda == 2) {
                if (arrayAtendimentoFinalizado.length > 0) {
                    arrayAtendimentosVinculadosArrayDePesquisa = arrayAtendimentoFinalizado;
                } else
                    arrayAtendimentosVinculadosArrayDePesquisa =
                        "Sem atendimentos finalizados";
            } else if (legenda.codigoLegenda == 3) {
                arrayAtendimentosVinculadosArrayDePesquisa = null;
            }
        }

        /**
         * Método que chama o método interno 'construirArraysDeAtendimentosEmAberto' para reconstruir os arrays
         * 'arrayAtendimentosEmAbertoSeteDiasRestantes' e 'arrayAtendimentosEmAbertoVencidos'
         * @param {listaDeAtendimentosEmAberto} listaDeAtendimentosEmAberto Lista de Atendimentos em Aberto
         */
        function atendimentosEmAbertoAtualizarArraysDeAtendimentoEmAberto(
            listaDeAtendimentosEmAberto
        ) {
            construirArraysDeAtendimentosEmAberto(listaDeAtendimentosEmAberto);
        }

        /**
         * Método que irá restauras os arrays 'arrayAtendimentosEmAbertoSeteDiasRestantes', 'arrayAtendimentosEmAbertoVencidos' e
         * 'arrayAtendimentosEmAbertoArrayDePesquisa'
         */
        function atendimentosEmAbertoLimparArraysAtendimentosEmAbertoParaNovaPesquisa() {
            arrayAtendimentosEmAbertoSeteDiasRestantes = [];
            arrayAtendimentosEmAbertoVencidos = [];
            arrayAtendimentosEmAbertoArrayDePesquisa = null;
        }

        /**
         * Método que irá buscar o o motivo de atendmento na lista passada 'motivosAtendimento' com base
         * na query de pesquisa que o usuário digitou
         * @param {query} query texto para pesquisar na lista
         * @param {motivosAtendimento} motivosAtendimento lista de motivos de atendimento
         */
        function atendimentoPesquisarAtendimentoMotivoAutoComplete(
            query,
            motivosAtendimento
        ) {
            query = query.toLowerCase();
            var resultado = query
                ? motivosAtendimento.filter(function (item, index) {
                    return item.titulo.toLowerCase().search(query) != -1;
                })
                : motivosAtendimento;

            return resultado;
        }

        /**
         * Método que sempre irá buscar o histórico do atendimento quando o atendimento for selecionado
         * @param {*codigo do atendimento} codigoAtendimento
         * @param {*ano do atendimento} anoAtendimento
         * @param {*controle do formulário do toolbar-mobile-desktop} controleForm
         */
        function atendimentoPesquisarHistoricoAtendimento(
            codigoAtendimento,
            anoAtendimento,
            controleForm
        ) {
            var deferred = $q.defer();
            if (controleForm) controleForm.preLoaderToolbar.inicioProgresso();
            RequisicaoGenericaService.listarSemParams(
                Api.atendimento.historico.listarHistoricoPorAtendimento +
                codigoAtendimento +
                "/" +
                anoAtendimento
            ).then(
                function (success) {
                    deferred.resolve(success.data);

                    if (controleForm) controleForm.preLoaderToolbar.fimProgresso();
                },
                function (error) {
                    var message = error.data == "Sem permissão para visualizar os históricos do atendimento solicitado"
                        ? error.data
                        : "Falha ao listar o(s) histórico(s) do atendimento";
                    MdDialogService.alertPadrao(
                        message
                    );
                    deferred.reject();
                    if (controleForm) controleForm.preLoaderToolbar.fimProgresso();
                }
            );
            return deferred.promise;
        }

        /**
         * Método utilizado na tela de atendimentos pendentes(atendimento não visualizados)
         * este método iniciará a tela já realizando uma requisição para Api para listar todos os atendimentos não visualizados do usuário corrente
         * @param {codigoUsuario} codigoUsuario
         */
        function atendimentoPesquisarAtendimentosNaoVisualizados(codigoUsuario) {
            var deferred = $q.defer();
            RequisicaoGenericaService.listarSemParams(
                Api.atendimento.listarAtendimentosNaoVisualizados + codigoUsuario
            ).then(
                function (success) {
                    /**
                     * Se o usuario corrente não conter nenhum atendimento não visualizado ele será redirecionado para tela de atendimento
                     */
                    if (success.data.length == 0) redirecionarParaAtendimento();

                    deferred.resolve(success);
                },
                function (error) {
                    redirecionarParaAtendimento();

                    deferred.reject(error);
                }
            );
            return deferred.promise;
        }

        /**
        * Método utilizado na tela de atendimentos importantes
        * este método iniciará a tela já realizando uma requisição para Api para listar todos os atendimentos não visualizados do usuário corrente
        * @param {codigoUsuario} codigoUsuario
        */
        function atendimentoPesquisarAtendimentosImportantes(codigoUsuario) {
            var deferred = $q.defer();
            RequisicaoGenericaService.listarSemParams(
                Api.atendimento.listarAtendimentosImportantes + codigoUsuario
            ).then(
                function (success) {
                    /**
                     * Se o usuario corrente não conter nenhum atendimento importante, ele será redirecionado para tela de atendimento
                     */
                    if (success.data.length == 0) redirecionarParaAtendimento();

                    deferred.resolve(success);
                },
                function (error) {
                    redirecionarParaAtendimento();

                    deferred.reject(error);
                }
            );
            return deferred.promise;
        }

        /**
         * Método utilizado na tela de atendimentos em aberto
         * este método irá fazer uma requisição para api já listando todos os atendimentos em aberto do usuário passado como parâmetro
         * @param {codigoUsuario} codigoUsuario
         */
        function atendimentoPesquisarAtendimentosEmAbertoDoUsuario(codigoUsuario) {
            var deferred = $q.defer();
            RequisicaoGenericaService.listarSemParams(
                Api.atendimento.listarAtendimentosEmAbertoDoUsuario + codigoUsuario
            ).then(
                function (success) {
                    /**
                     * Se o usuario corrente não conter nenhum atendimento não visualizado ele será redirecionado para tela de atendimento
                     */
                    if (success.data.length == 0) redirecionarParaAtendimento();
                    else {
                        construirArraysDeAtendimentosEmAberto(success.data);
                    }

                    deferred.resolve(success);
                },
                function (error) {
                    redirecionarParaAtendimento();

                    deferred.reject(error);
                }
            );
            return deferred.promise;
        }

        /**
         * Método para pesquisar os atendimentos em aberto dos usuários
         * @param {modelo} modelo  View Model para realizar a pesquisa dos usuários com atendimentos em aberto
         */
        function atendimentoPesquisarAtendimentosEmAbertoUsuariosPorGerente(
            modelo
        ) {
            var deferred = $q.defer();
            RequisicaoGenericaService.listarComParams(
                Api.atendimento.listarAtendimentosEmAbertoUsuariosPorGerente,
                modelo
            ).then(
                function (success) {
                    /**
                     * Se o usuario corrente não conter nenhum atendimento não visualizado ele será redirecionado para tela de atendimento
                     */
                    if (success.data.length == 0) redirecionarParaAtendimento();
                    else {
                        construirArraysDeAtendimentosEmAberto(success.data);

                        deferred.resolve(success);
                    }
                },
                function (error) {
                    redirecionarParaAtendimento();

                    deferred.reject(error);
                }
            );
            return deferred.promise;
        }

        /**
         * Método que verifica se o usuário já verificou se o usuário já visualizou o atendimento, caso não é exibido um dialog para o mesmo
         * perguntando se ele deseja confirma a leitura, se o usuário pressionar o botão sim é então realizado uma requisição para Api assim atualizando
         * o status da notificação do usuário
         * @param {*codigo do atendimento} codigoAtendimento
         * @param {*ano do atendimento} anoAtendimento
         * @param {*codigo do colaborador} codigoColaborador
         * @param {*controle do formulário do toolbar-mobilde-desktop} controleForm
         */
        function atualizarAcompanhamentoAtendimentoUsuario(
            codigoAtendimento,
            anoAtendimento,
            codigoUsuario,
            controleForm,
            visualizado
        ) {
            var deferred = $q.defer();
            atendimentoPesquisarAcompanhantesAtendimentoAtualizandoVisualizado(
                codigoAtendimento,
                anoAtendimento,
                codigoUsuario,
                controleForm,
                visualizado
            ).then(
                function (success) {
                    deferred.resolve(success);
                    AtendimentoHubFactory.atualizarBadgeAtendimento(
                        success.countAtendimentosNaoVisualizados
                    );
                },
                function (error) {
                    deferred.resolve(error);
                }
            );
            return deferred.promise;
        }

        /**
         * Método que verifica se o usuário já verificou se o usuário já visualizou o atendimento, caso não é exibido um dialog para o mesmo
         * perguntando se ele deseja confirma a leitura, se o usuário pressionar o botão sim é então realizado uma requisição para Api assim atualizando
         * o status da notificação do usuário
         * @param {*codigo do atendimento} codigoAtendimento
         * @param {*ano do atendimento} anoAtendimento
         * @param {*codigo do colaborador} codigoColaborador
         * @param {*controle do formulário do toolbar-mobilde-desktop} controleForm
         */
        function atualizarImportanciaAtendimentoUsuario(
            codigoAtendimento,
            anoAtendimento,
            codigoUsuario,
            controleForm,
            importante
        ) {
            var deferred = $q.defer();
            atualizarAtendimentosImportantes(
                codigoAtendimento,
                anoAtendimento,
                codigoUsuario,
                controleForm,
                importante
            ).then(
                function (success) {
                    deferred.resolve(success);
                    AtendimentoHubFactory.atualizarBadgeAtendimentosImportantes(
                        success.quantidadeAtendimentosImportantes
                    );
                },
                function (error) {
                    deferred.resolve(error);
                }
            );
            return deferred.promise;
        }


        /**
         * Método que verifica na api  se o usuári está vinculado para ser notificado e retonar o usuário caso o mesmo esteja
         * @param {*codigo do atendimento} codigoAtendimento
         * @param {*ano do atendimento} anoAtendimento
         * @param {*codigo do colaborador} codigoColaborador
         * @param {*controle do formulário do toolbar-mobilde-desktop} controleForm
         */
        function listarAcompanhamentoPorAtendimentoEUsuario(
            codigoAtendimento,
            anoAtendimento,
            codigoColaborador,
            controleForm
        ) {
            var deferred = $q.defer();

            if (controleForm) controleForm.preLoaderToolbar.inicioProgresso();
            RequisicaoGenericaService.listarSemParams(
                Api.atendimento.acompanhamento
                    .listarAcompanhamentoPorAtendimentoEUsuario +
                codigoAtendimento +
                "/" +
                anoAtendimento +
                "/" +
                codigoColaborador
            ).then(
                function (success) {
                    deferred.resolve(success);

                    if (controleForm) controleForm.preLoaderToolbar.fimProgresso();
                },
                function (error) {
                    deferred.reject(error);

                    if (controleForm) controleForm.preLoaderToolbar.fimProgresso();
                }
            );
            return deferred.promise;
        }

        /**
         * Método que sempre irá buscar os acompanhantes do atendimento quando o atendimento for selecionado atualizando o status de visualizado do usuário corrente
         * @param {*codigo do atendimento} codigoAtendimento
         * @param {*ano do atendimento} anoAtendimento
         * @param {*codigo do codigoColaborador} codigoColaborador
         * @param {*controle do formulário do toolbar-mobile-desktop} controleForm
         */
        function atendimentoPesquisarAcompanhantesAtendimentoAtualizandoVisualizado(
            codigoAtendimento,
            anoAtendimento,
            codigoColaborador,
            controleForm,
            visualizado
        ) {
            var deferred = $q.defer();

            if (controleForm) controleForm.preLoaderToolbar.inicioProgresso();
            RequisicaoGenericaService.listarSemParams(
                Api.atendimento.acompanhamento
                    .listarAcompanhantesPorAtendimentoAtualizandoVisualizado +
                codigoAtendimento +
                "/" +
                anoAtendimento +
                "/" +
                codigoColaborador +
                "/" +
                visualizado
            ).then(
                function (success) {
                    deferred.resolve(success.data);

                    if (controleForm) controleForm.preLoaderToolbar.fimProgresso();
                },
                function (error) {
                    MdDialogService.alertPadrao(
                        "Falha ao Listar os Acompanhantes do Atendimento"
                    );

                    if (controleForm) controleForm.preLoaderToolbar.fimProgresso();
                }
            );
            return deferred.promise;
        }

        /**
         * Método que sempre irá buscar os acompanhantes do atendimento quando o atendimento for selecionado atualizando o status de visualizado do usuário corrente
         * @param {*codigo do atendimento} codigoAtendimento
         * @param {*ano do atendimento} anoAtendimento
         * @param {*codigo do codigoColaborador} codigoColaborador
         * @param {*controle do formulário do toolbar-mobile-desktop} controleForm
         */
        function atualizarAtendimentosImportantes(
            codigoAtendimento,
            anoAtendimento,
            codigoColaborador,
            controleForm,
            importante
        ) {
            var deferred = $q.defer();

            if (controleForm) controleForm.preLoaderToolbar.inicioProgresso();
            var parametros = {
                codigoAtendimento: codigoAtendimento,
                anoAtendimento: anoAtendimento,
                codigoUsuario: codigoColaborador,
                importante: importante
            }
            RequisicaoGenericaService.postComQueryParams(
                Api.atendimento.acompanhamento
                    .atualizarImportanciaAtendimento,
                parametros
            ).then(
                function (success) {
                    deferred.resolve(success.data);

                    if (controleForm) controleForm.preLoaderToolbar.fimProgresso();
                },
                function (error) {
                    MdDialogService.alertPadrao(
                        "Falha ao atualizar Atendimento"
                    );

                    if (controleForm) controleForm.preLoaderToolbar.fimProgresso();
                }
            );
            return deferred.promise;
        }

        /**
         * Método que sempre irá buscar os acompanhantes do atendimento quando o atendimento for selecionado atualizando o status de visualizado do usuário corrente
         * @param {*codigo do atendimento} codigoAtendimento
         * @param {*ano do atendimento} anoAtendimento
         * @param {*codigo do codigoColaborador} codigoColaborador
         * @param {*controle do formulário do toolbar-mobile-desktop} controleForm
         */
        function atendimentoPesquisarAcompanhantesAtendimento(
            codigoAtendimento,
            anoAtendimento,
            controleForm
        ) {
            var deferred = $q.defer();

            if (controleForm) controleForm.preLoaderToolbar.inicioProgresso();
            RequisicaoGenericaService.listarSemParams(
                Api.atendimento.acompanhamento.listarAcompanhamentoPorAtendimento +
                codigoAtendimento +
                "/" +
                anoAtendimento
            ).then(
                function (success) {
                    deferred.resolve(success.data);

                    if (controleForm) controleForm.preLoaderToolbar.fimProgresso();
                },
                function (error) {
                    MdDialogService.alertPadrao(
                        "Falha ao Listar os Acompanhantes do Atendimento"
                    );

                    if (controleForm) controleForm.preLoaderToolbar.fimProgresso();
                }
            );
            return deferred.promise;
        }

        /**
         * Método que verifica se o cliente possui alguma pendência
         * @param {*vm.atendimento.cliente} cliente
         */
        function verificarExistenciaClientePendencia(cliente) {
            if (cliente && cliente.codigoPendencia) return true;
            else return false;
        }

        /**
         * Método que irá abrir uma dialog notificando que o cliente possui alguma pendência
         * @param {*vm.atendimento.cliente} cliente
         * @param {*função delegate} eventSim
         */
        function abrirDialogClientePendencia(cliente, eventSim) {
            var mensagem = "Alerta este cliente possui uma Pendência !";
            var htmlContent =
                "<div class='font-size-16 font-weight-400 mt-15'>" +
                cliente.pendencia.descricao +
                "</div>";
            if (eventSim)
                MdDialogService.alertPadraoComEvento(
                    mensagem,
                    eventSim,
                    null,
                    htmlContent
                );
            else MdDialogService.alertPadrao(mensagem, null, htmlContent);
        }

        /**
         * Método que ira abrir um dialog notificando que é necessário ter pelo menos um historico do atendimento
         * para cadastar um novo atendimento
         */
        function abrirDialogAlertSolicitandoHistoricoAtendimento() {
            MdDialogService.alertPadrao(
                "É necessário inserir um historico de atendimento para cadastrar um atendimento",
                null
            );
        }

        /**
         * Função para setar quais botoes serão desabilitados quando for iniciado o controller já chamando uma pesquisa
         * este método será usado nos modulos 'atendimentosNaoVisualizados' e 'atendimentosEmAberto'
         */
        function setarValoresParaIniciarChamandoPesquisa() {
            return {
                novaPesquisa: true,
                inserir: true,
                atualizar: true,
                desabilitarButtonListarTodasEntidadesEmModoExibicaoTabela: true
            };
        }

        /**
         * Método que cria uma mensagem, exibindo todos os atendimentos vencidos do usuário
         * @param {atendimentosVencido} atendimentosVencido Lista de Atendimentos da Codigo, Ano e Data
         */
        function atendimentoCriarMensagemAtendimentosVencidos(atendimentosVencido) {
            var mensagemAtendimentosVencidos =
                "<div class='font-size-14'> Os seguintes atendimentos estão em aberto e com a data de conclusão vencida: <br><br>";
            angular.forEach(atendimentosVencido, function (item, index) {
                if (atendimentosVencido.length - 1 == index)
                    mensagemAtendimentosVencidos +=
                        "Atendimento: " +
                        item.codigo +
                        "/" +
                        item.ano +
                        " Data: " +
                        $filter("date")(item.data, "dd/MM/yyyy") +
                        "<br><br>";
                else
                    mensagemAtendimentosVencidos +=
                        "Atendimento: " +
                        item.codigo +
                        "/" +
                        item.ano +
                        " Data: " +
                        $filter("date")(item.data, "dd/MM/yyyy") +
                        "<br>";
            });
            mensagemAtendimentosVencidos +=
                "Por favor reagende estes atendimentos ou finalize-os, para posteriormente cadastrar novos atendimentos </div>";

            return mensagemAtendimentosVencidos;
        }

        /**
         * Método para setar os valores de objetos complexos para null
         * @param {*atendimento} modelo
         */
        function setarValoresParaSalvarEEditar(modelo, conclusaoFinalizada) {
            modelo.usuario = null;
            modelo.cliente = null;
            modelo.solucao = null;
            modelo.atendimentoMotivo = null;
            modelo.atendimentoPendencia = null;
            modelo.atendimentoConclusao = null;
            modelo.historicosAtendimentos = null;
        }

        function pesquisarHistoriasVinculadas(atendimento) {
            return RequisicaoGenericaService.listarSemParams(
                Api.atendimento.consultarHistoriasVinculadas + atendimento.codigo + "/" + atendimento.ano
            );
        }
    } // Controller
})();

/**
 * Created by nova on 20/07/2016.
 */
(function () {
    'use strict';

    angular
        .module('app.service')
        .service("ArquivosService",ArquivosService);

    function ArquivosService($q,RequisicaoGenericaService,MdDialogService) {

        this.retornarIcone = retornarIcone;
        this.baixarArquivo = baixarArquivo;
        this.obterArquivo = obterArquivo;


        /**
         * Método que retorna o icone e o css com base na extensão
         * @param {extensao} extensao extensao do arquivo 
         */
        function retornarIcone(extensao) {
            /**
             * cores do css:
             * imagem: green, * video: aqua, * documento: blue, * audio: red, * compactado: yellowgreen, * outros: dimgray
             */
            if (extensao.search("png" || "jpg" || "jpeg" || "gif" || "bmp") != -1)
                return { icone: "icon-file-image",css: "imagem" }
            else if (extensao.search("avi" || "mp4" || "mpeg" || "amv" || "mkv" || "mov" || "rmvb") != -1)
                return { icone: "icon-file-video",css: "video" }
            else if (extensao.search("mp3" || "wav" || "ac3" || "wma" || "cc3" || "ogg") != -1)
                return { icone: "icon-file-music",css: "audio" }
            else if (extensao.search("rar" || "zip" || "7z") != -1)
                return { icone: "icon-file-presentation-box",css: "compactado" }
            else if (extensao.search("doc" || "docx") != -1)
                return { icone: "icon-file-word",css: "documento" }
            else if (extensao.search("xls" || "xlsx") != -1)
                return { icone: "icon-file-excel",css: "documento" }
            else if (extensao.search("csv") != -1)
                return { icone: "icon-file-excel",css: "documento" }
            else if (extensao.search("pdf") != -1)
                return { icone: "icon-file-pdf",css: "documento" }
            else if (extensao.search("ppt" || "pps" || "ppsx") != -1)
                return { icone: "icon-file-powerpoint",css: "documento" }
            else if (extensao.search("txt") != -1)
                return { icone: "icon-file-document",css: "documento" }
            else if (extensao.search("xml" || "xaml") != -1)
                return { icone: "icon-file-xml",css: "documento" }
            else
                return { icone: "icon-file",css: "outros" }
        }

        /**
         * Método genérico que faz uma requisição para api buscando o arquivo a ser realizado o download
         * e posteriormente criando o blob para que o usuário possa selecionar aonde salvar o arquivo selecionado
         * em sua máquina
         * @param {rota} rota Rota da Api
         * @param {modelo} modelo  Arquivo selecionado
         */
        function baixarArquivo(rota,modelo) {
            var deferred = $q.defer();

            RequisicaoGenericaService.baixarArquivo(rota,modelo)
                .then(function (success) {
                    console.log("serviço", success.config);
                    var data = success.data,
                        headers = success.headers(),
                        params = success.config.params,
                        nomeArquivo = params.nome + "." + params.extensao,
                        contentType = headers['content-type'],
                        elementoLink = document.createElement('a');

                    try {
                        var blob = new Blob([data],{ type: contentType }),
                            url = window.URL.createObjectURL(blob),
                            eventoClick = new MouseEvent("click",{
                                "view": window,
                                "bubbles": true,
                                "cancelable": false
                            });

                        elementoLink.setAttribute('href',url);
                        elementoLink.setAttribute("download",nomeArquivo);
                        elementoLink.dispatchEvent(eventoClick);

                        deferred.resolve(success);
                    } catch (ex) {
                        MdDialogService.alertPadrao(ex,null,null);

                        deferred.reject(ex);
                    }
                },function (error) {
                    MdDialogService.alertPadrao(error.data,null,null);

                    deferred.reject(error);
                });
            return deferred.promise;
        }

        /**
         * Método genérico que realizar a leitura de um arquivo através da classe FileReader e retorna sua leitura em um objeto da seguinte forma
         * {
         *      bytes: bytes,
         *      base64StringArquivo: base64StringArquivo,
         *      nomeArquivo: arquivo.nome,
         *      tipoArquivo: arquivo.type
         * }
         * @param {file} arquivo 
         */
        function obterArquivo(arquivo) {
            if (!arquivo)
                throw new Error("É necessário informar um arquivo");
            var reader = new FileReader();

            return $q(function (resolve,reject) {
                reader.onerror = function () {
                    reader.abort();
                    reject(new Error("Erro ao converter arquivo"));
                }
                reader.onload = function () {
                    //This will result in an array that will be recognized by C#.NET WebApi as a byte[]
                    var bytesArquivo = Array.from(new Uint8Array(this.result));

                    //if you want the base64encoded file you would use the below line:
                    var base64StringArquivo = btoa(bytesArquivo.map(function (item) { return String.fromCharCode(item) }).join(""));

                    //Resolve the promise with your custom file structure
                    resolve({
                        bytesArquivo: bytesArquivo,
                        base64StringArquivo: base64StringArquivo,
                        nomeArquivo: arquivo.name,
                        tipoArquivo: arquivo.type
                    });
                }
                reader.readAsArrayBuffer(arquivo);
            });
        }

    } // ArquivosService

})();

(function () {
    'use strict';

    angular.module('app.sqlConsulta')
        .controller('ConsultaSqlController',ConsultaSqlController);

    function ConsultaSqlController(
        Api,
        RotasHtml,
        $mdDialog,
        NavegacaoService,
        MdDialogService,
        MdToastService,
        RequisicaoGenericaService
    ) {
        var vm = this;
        NavegacaoService.setTituloAba('Execução SQL');
        vm.htmlRota = RotasHtml.rotasConsultaSql;
        vm.consulta = {};
        vm.pontoEvirgula = false;
        vm.buscaDados = false;
        vm.query = "";
        vm.metodos = {
            fazerConsulta: fazerConsulta,
            abrirDialogPlanilha: abrirDialogPlanilha,
            verificaPontoEVirgula: verificaPontoEVirgula
        }

        init();

        function init() {
            vm.requisicaoProgress = false;
            vm.mensagemPreloader = "";
        }

        function verificaPontoEVirgula() {
            if (vm.query.includes(";")) {
                vm.pontoEvirgula = true
            }
            else
                vm.pontoEvirgula = false;
        }

        function fazerConsulta(query) {
            vm.buscaDados = true;
            vm.resultado = null;
            vm.requisicaoProgress = true;
            vm.mensagemPreloader = "Aguarde...";
            vm.consulta.query = query.toUpperCase();
            setTimeout(function () {
                
                return RequisicaoGenericaService.listarComObjetoComplexo(Api.consultaSql.consulta,vm.consulta).then(
                    function (success) {
                        if (success.data.registros.length <= 0) {
                            vm.buscaDados = false;
                            vm.requisicaoProgress = false;
                            vm.mensagemPreloader = "";
                            vm.resultado = success.data;
                            MdDialogService.alertPadrao("Atenção! ",null,"Não há dados para a consulta realizada!");
                        }

                        else {
                            vm.buscaDados = false;
                            vm.requisicaoProgress = false;
                            vm.mensagemPreloader = "";
                            vm.resultado = success.data;
                            MdToastService.toastPadrao("Consulta realizada com sucesso!");
                        }
                    },
                    function (error) {
                        vm.buscaDados = false;
                        MdDialogService.alertPadrao("Atenção! ",null,error.data.Message);
                        vm.requisicaoProgress = false;
                        vm.mensagemPreloader = "";
                    }
                )
            },2000);
        };

        function abrirDialogPlanilha() {
            $mdDialog.show({
                controller: 'DialogPlanilhaController',
                controllerAs: 'vm',
                templateUrl: vm.htmlRota.dialogs.nomePlanilha,
                targetEvent: event,
                clickOutsideToClose: false,
                locals: {
                    Consulta: vm.consulta
                }
            });
        }

    }
})();
(function () {
    'use strict';

    angular
        .module('app.mensageiro')
        .controller('MensageiroController', MensageiroController);

    /** @ngInject */
    function MensageiroController($scope, $rootScope, NavegacaoService, $document, $mdDialog, $mdMedia, $mdSidenav, $state, msApi, LoginUsuarioService,
        MensageiroService, LocalStorageService, MensageiroHubFactory, MdDialogService,
        RotasHtml, MensageiroControllerService, ListarUsuarioPorDetalhe) {

        var vm = this;

        init();

        vm.metodos = {
            retornaSeRemetenteOuDestinatarioListaEmail: retornaSeRemetenteOuDestinatarioListaEmail,
            proximaPagina: proximaPagina,
            paginaAnterior: paginaAnterior,
            marcarComoArquivado: marcarComoArquivado,
            marcarComodesarquivado: marcarComodesarquivado,
            marcarComoImportante: marcarComoImportante,
            marcarComoSinalizado: marcarComoSinalizado,
            definirStatusMensagem: definirStatusMensagem,
            retornaDestinatariosDaMensagem: retornaDestinatariosDaMensagem,
            verificaSeImporante: verificaSeImporante,
            pesquisarMensagens: pesquisarMensagens,
            retornaTituloStatusDeAcordoComOStatus: retornaTituloStatusDeAcordoComOStatus,
            verificaDataEnvioResposta: verificaDataEnvioResposta,
            aplicaCssMensagemNaoLida: aplicaCssMensagemNaoLida,
            verificaNovasRespostas: verificaNovasRespostas,
            mensagemAnterior: mensagemAnterior,
            proximaMensagem: proximaMensagem,
            contaTotalDeMensagens: contaTotalDeMensagens,
            verificaSeultimaResposta: verificaSeultimaResposta,
            recarregarPagina: MensageiroControllerService.recarregarPagina
        }

        //#region whatch
        $scope.$watch(function () {
            return $mdMedia('xs');
        }, function (current, old) {
            if (angular.equals(current, old)) {
                return;
            }

            if (current) {
                vm.currentView = 'classic';
            }
        });

        $scope.$watch(function () {
            return $mdMedia('sm');
        }, function (current, old) {
            if (angular.equals(current, old)) {
                return;
            }

            if (current) {
                vm.currentView = 'classic';
            }
        });


        $scope.$watch(function () {
            return $mdMedia('gt-sm');
        }, function (current, old) {
            if (angular.equals(current, old)) {
                return;
            }

            if (current) {
                if (vm.defaultView === 'outlook') {
                    vm.currentView = 'outlook';
                }
            }
        });

        $scope.$watch('vm.menuSelecionado', function () {
            vm.pagina = 1;
            $mdDialog.hide();
            switch (vm.menuSelecionado && vm.mensagensSelecionadas.length > 0) {
                case 'sent':
                    vm.habilitaBotaoArquivar = false;
                    break;
                case 'trash':
                    vm.habilitaBotaoArquivar = false;
                    break;
                default:
                    vm.habilitaBotaoArquivar = true;
                    break;
            }
        });


        $scope.$watch('vm.mensagensSelecionadas', function () {

            if (vm.mensagensSelecionadas.length <= 0) {
                vm.checkBoxSelecionado = "Selecione";
                if (vm.mensagemSelecionada != null) {
                    vm.mensagemSelecionada = [];
                    fecharMensagem();
                }
            }

        });

        $scope.$watch('vm.pesquisar', function () {
            if (vm.pesquisar != "")
                if (vm.pesquisar.length <= 0)
                    vm.pesquisandoMensagem = false;
        });
        //#endregion

        //#region Broadcast
        $scope.$on('novaMensagem', function (event, msg) {
            if (vm.menuSelecionado == 'inbox') {
                var mensagemSelecionada = angular.copy(vm.mensagemSelecionada);
                if (mensagemSelecionada) {
                    vm.carregandoHistorico = false
                    setTimeout(function () {
                        MensageiroControllerService.recarregarPagina(vm, function (mensagens) {
                            vm.mensagens.dados.mensagens.forEach(function (mensagem) {
                                if (mensagem.mensagemIdentificador == mensagemSelecionada.mensagemIdentificador) {
                                    mensagem.respostas = mensagemSelecionada.respostas;
                                    // vm.mensagemSelecionada = mensagemSelecionada;
                                    reabrirMensagem(mensagem);
                                    // vm.mensagensSelecionadas = [];
                                    // vm.mensagensSelecionadas.push(mensagem);
                                    // vm.posicaoMensagem = MensageiroControllerService.retornaPosicaoMensagem(mensagem, vm);
                                }
                            });
                        });
                    }, 1000);
                    return;
                }

                MensageiroControllerService.recarregarPagina(vm);

            }
        });

        $scope.$on('enviou-mensagem', function (event, mensagem, ehResposta) {
            if (ehResposta && vm.mensagemSelecionada != null) {
                MensageiroService.procuraMensagemPeloId(vm.mensagemSelecionada.mensagemIdentificador).then(function (success) {
                    vm.mensagemSelecionada.respostas = success.respostas;
                });
            }

            if (vm.menuSelecionado == 'sent') {
                MensageiroControllerService.recarregarPagina(vm);
            }
        });

        //#endregion Broadcast


        //#region metodos

        function verificaSeultimaResposta(resposta) {
            if (vm.mensagemSelecionada == null)
                return false;
            if (vm.mensagemSelecionada.respostas.length <= 0)
                return false;
            var primeiraRespostaNaFila = vm.mensagemSelecionada.respostas[0];
            if (primeiraRespostaNaFila == resposta)
                return true;
            return false;
        }

        function contaTotalDeMensagens() {
            if (vm.pagina > 1)
                return (vm.pagina - 1) * 10 + vm.mensagens.dados.mensagens.length;
            return vm.mensagens.dados.mensagens.length;
        }

        function mensagemAnterior(mensagem) {
            if (mensagem == null)
                return;

            var indexMensagem = vm.mensagens.dados.mensagens.indexOf(mensagem);
            vm.posicaoMensagem = MensageiroControllerService.retornaPosicaoMensagem(mensagem, vm);


            if (indexMensagem <= 0) {
                vm.proximaMensagem = true;
                vm.mensagemAnterior = false;
                return;
            }

            vm.mensagemAnterior = true;
            vm.proximaMensagem = true;
            vm.mensagemSelecionada = vm.mensagens.dados.mensagens[indexMensagem - 1];
            vm.posicaoMensagem = vm.posicaoMensagem - 1;
            _carregarHistoricoMensagem(vm.mensagemSelecionada);
        }

        function proximaMensagem(mensagem) {

            if (mensagem == null)
                return;
            var tamanhoListaMensagem = vm.mensagens.dados.mensagens.length;
            var indexMensagem = vm.mensagens.dados.mensagens.indexOf(mensagem);
            vm.posicaoMensagem = MensageiroControllerService.retornaPosicaoMensagem(mensagem, vm);

            if (indexMensagem >= tamanhoListaMensagem - 1) {
                vm.mensagemAnterior = true;
                vm.proximaMensagem = false;
                return;
            }

            vm.proximaMensagem = true;
            vm.mensagemAnterior = true;
            vm.mensagemSelecionada = vm.mensagens.dados.mensagens[indexMensagem + 1]
            vm.posicaoMensagem = vm.posicaoMensagem + 1;
            _carregarHistoricoMensagem(vm.mensagemSelecionada);
        }

        function aplicaCssMensagemNaoLida(mensagem) {

            if (mensagem.status == null)
                return false;

            if (mensagem.status.id == 2 && vm.menuSelecionado != 'sent')
                return true;


            return false;
        }

        function verificaNovasRespostas(mensagem) {
            if (vm.menuSelecionado == 'inbox') {
                if (mensagem.respostas == null)
                    return;

                if (mensagem.respostas.length <= 0)
                    return;

                if (mensagem.status.id == 2)
                    return true;

                return false;
            }
        }

        function verificaDataEnvioResposta(data, index) {
            if (index == 0) {
                vm.dataResposta = data;
                return true;
            }

            if (vm.dataResposta == "") {
                vm.dataResposta = data;
                return true;
            }

            if (data == vm.dataResposta)
                return false;

            else {
                vm.dataResposta = data;
                return true;
            }

        }

        function pesquisarMensagens(event) {
            //aqui
            if (event) {
                event.stopPropagation();
            }

            if (vm.usuarioLogado == null)
                return;

            if (vm.pesquisar == null)
                return;

            if (vm.pesquisar.length == 0)
                MensageiroControllerService.recarregarPagina(vm);

            if (vm.carregandoMensagens)
                return;

            if (MensageiroControllerService.retornaGrupo(vm) == 0)
                return;

            if (event == null) {
                MensageiroControllerService.pesquisa(vm);
                return;
            }

            if (event.keyCode === 13) {
                vm.mensagemSelecionada = null;
                vm.pagina = 1;
                MensageiroControllerService.pesquisa(vm);
            }
        }

        function isLabelActive(name) {
            return (vm.currentFilter.type === 'label' && vm.currentFilter.filter === name);
        }

        function retornaTituloStatusDeAcordoComOStatus(status) {
            switch (status) {
                case 1:
                    return 'Lido';
                case 2:
                    return 'Não lido';
                case 3:
                    return 'Ler mais tarde';
                default:
                    return 'Não definido';
            }
        }

        function marcarComoArquivado() {
            var data = {
                "arquivar": true
            };
            MensageiroControllerService.arquiva(data, vm);
        }

        function marcarComodesarquivado() {
            var data = {
                "arquivar": false
            };
            MensageiroControllerService.arquiva(data, vm);
        }

        function isFolderActive(name) {
            return (vm.currentFilter.type === null && vm.currentFilter.filter === name);
        }

        function retornaDestinatariosDaMensagem(mensagem, simplifica) {
            if (mensagem.copiaPara == null)
                return mensagem.destinatario;

            if (mensagem.copiaPara.usuariosNomeEmCopia == "")
                return mensagem.destinatario;
            if (mensagem.copiaPara.usuarios.length > 0) {
                if (!simplifica)
                    return mensagem.copiaPara.usuariosNomeEmCopia;
                if (mensagem.copiaPara.usuariosNomeEmCopia.length >= 20)
                    return mensagem.copiaPara.usuariosNomeEmCopia.slice(0, 17) + "...";
                return mensagem.copiaPara.usuariosNomeEmCopia;
            }

            return mensagem.destinatario;

        }


        function defineStatusRespostas(mensagem) {

            if (mensagem.respostas == null)
                return;

            var respostasNaoLidasDoUsuarioLogado = MensageiroControllerService.retornaRespostasNaoLidasDoUsuarioLogado(mensagem, vm);

            if (respostasNaoLidasDoUsuarioLogado.length <= 0)
                return;

            respostasNaoLidasDoUsuarioLogado.forEach(function (value) {
                definirStatusMensagem(value, 1);
            });

        }

        function definirStatusMensagem(mensagem, status) {

            if (vm.menuSelecionado == 'sent')
                return;

            if (mensagem == null || status == 0)
                return;

            var data = {
                "status": status
            };

            MensageiroControllerService.preparaDados(mensagem, data, vm);

            MensageiroService.marcarComoLido(data).then(function (success) {
                MensageiroHubFactory.atualizarBadgeQuantidadeMensagensNaoVisualizados(success.data.quantidadeNaoLidas);
                mensagem.status = success.data.status;
                defineStatusRespostas(mensagem);
                //_atualizaStatusResposta(mensagem.respostas);
            });

        }

        function verificaSeImporante(mensagem) {
            if (mensagem.importante == "N")
                return false;
            return true;
        }

        function proximaPagina(event) {
            if (event) {
                event.stopPropagation();
            }

            if (vm.carregandoMensagens)
                return;

            if (vm.mensagens.dados == null || vm.mensagens.dados.fim)
                return;

            fecharMensagem();

            vm.pagina = vm.pagina + 1;

            //se clicar na próxima página e estiver pesquisando irá retornar a pesquisa da página 2, 3, n
            if (vm.pesquisar != null && vm.pesquisandoMensagem) {
                pesquisarMensagens();
                return;
            }

            MensageiroControllerService.fazRequisicaoDeAcordoComMenuSelecionado(vm.menuSelecionado, vm);

        }

        function paginaAnterior(event) {
            if (event)
                event.stopPropagation();

            if (vm.carregandoMensagens)
                return;

            if (vm.mensagens.dados == null || vm.mensagens.dados.paginas <= 1)
                return;

            vm.pagina = vm.pagina - 1;

            fecharMensagem();

            if (vm.pesquisar != null && vm.pesquisandoMensagem) {
                pesquisarMensagens();
                return;
            }

            MensageiroControllerService.fazRequisicaoDeAcordoComMenuSelecionado(vm.menuSelecionado, vm);

        }

        function retornaSeRemetenteOuDestinatarioListaEmail(mensagem) {
            switch (vm.menuSelecionado) {
                case 'sent':
                    return mensagem.destinatario;
                case 'inbox':
                    return mensagem.remetente
                default:
                    return mensagem.remetente
            }
        }

        function loadFolder(name) {
            if (vm.pesquisar != "") {
                MdDialogService.confirmPadraoComEvento("Atenção", "A barra de pesquisa não está vazia, deseja prosseguir?", event, function () {
                    vm.pesquisar = "";
                    MensageiroControllerService.selecionaMenu(name, vm);
                }, function () {
                    return;
                })
                return;
            }
            if (vm.mensagensSelecionadas.length > 0) {
                MdDialogService.confirmPadraoComEvento("Atenção", "Você possui mensagens selecionadas, deseja prosseguir?", event, function () {
                    vm.mensagensSelecionadas = [];
                    MensageiroControllerService.selecionaMenu(name, vm);
                }, function () {
                    return;
                })
                return;
            }
            MensageiroControllerService.selecionaMenu(name, vm);
        }

        function loadLabel(name) {
            // Update the state without reloading the controller
            $state.go('app.mensageiro.threads', {
                type: 'label',
                filter: name
            }, {
                notify: false
            });

            // If we are already in the selected folder and
            // there is an open mensagem just close it
            if (vm.isLabelActive(name)) {
                // Close the current mensagem if open
                if (vm.mensagemSelecionada) {
                    vm.fecharMensagem();
                }

                return;
            }

            // Show loader
            $rootScope.loadingProgress = true;

            // Build the API name
            var apiName = 'mail.label.' + name + '@get';

            // Make the call
            msApi.request(apiName).then(
                // Success
                function (response) {
                    // Load new mensagems
                    vm.mensagens = response.data;

                    // Set the current filter
                    vm.currentFilter = {
                        type: 'label',
                        filter: name
                    };

                    // Close the current mensagem if open
                    if (vm.mensagemSelecionada) {
                        vm.fecharMensagem();
                    }

                    // Hide loader
                    $rootScope.loadingProgress = false;
                }
            );
        }

        function reabrirMensagem(mensagem) {

            vm.mensagensSelecionadas = [];

            vm.mensagensSelecionadas.push(mensagem);

            vm.mensagemSelecionada = mensagem;

            mensagem.read = true;

            vm.posicaoMensagem = MensageiroControllerService.retornaPosicaoMensagem(mensagem, vm);

            $state.go('app.mensageiro.threads.mensagem', {
                mensagemId: mensagem.id
            }, {
                notify: false
            });
        }

        function abrirMensagem(mensagem) {

            vm.mensagensSelecionadas = [];

            vm.mensagensSelecionadas.push(mensagem);

            vm.mensagemSelecionada = {
                respostas: []
            };

            mensagem.read = true;

            vm.posicaoMensagem = MensageiroControllerService.retornaPosicaoMensagem(mensagem, vm);

            _carregarHistoricoMensagem(mensagem);

            $state.go('app.mensageiro.threads.mensagem', {
                mensagemId: mensagem.id
            }, {
                notify: false
            });
        }

        function _carregarHistoricoMensagem(mensagem) {
            if (vm.menuSelecionado == 'sent') {
                vm.mensagemSelecionada = mensagem;
                vm.mensagemSelecionada.respostas = [mensagem];
            } else {
                vm.carregandoHistorico = true;
                MensageiroService.listarHistoricoMensagem(mensagem.mensagemIdentificador)
                    .then(function (success) {

                        defineStatusRespostas(mensagem);

                        if (mensagem.status.id != 3)
                            definirStatusMensagem(mensagem, 1);

                        var respostas = success.data.filter(function (item) {
                            return item;
                            //  return item.mensagemIdentificador != mensagem.mensagemIdentificador;
                        });

                        vm.mensagemSelecionada = mensagem;
                        vm.mensagemSelecionada.respostas = respostas;

                        if (vm.mensagemSelecionada.status == null) {
                            definirStatusMensagem(vm.mensagemSelecionada, 1);
                            return;
                        }
                        vm.carregandoHistorico = false;
                        // MensageiroControllerService.removeRespostasNaoReferentesAoDestinatarioLogado(vm.mensagemSelecionada, vm);
                    }, function (error) {
                        console.log(error);
                        vm.carregandoHistorico = false;
                    });
            }
        }

        function fecharMensagem() {
            vm.mensagemSelecionada = null;

            // Update the state without reloading the controller
            $state.go('app.mensageiro.threads', {
                type: vm.currentFilter.type,
                filter: vm.currentFilter.filter
            }, {
                notify: false
            });
        }

        function isSelected(mensagem) {
            return vm.mensagensSelecionadas.indexOf(mensagem) > -1;
        }

        function toggleSelectmensagem(mensagem, event) {

            if (event) {
                event.stopPropagation();
            }

            if (vm.mensagemSelecionada != null) {
                vm.mensagemSelecionada = [];
                fecharMensagem();
            }
            if (vm.mensagensSelecionadas.indexOf(mensagem) < 0)
                vm.mensagensSelecionadas.push(mensagem);
            else
                vm.mensagensSelecionadas.splice(vm.mensagensSelecionadas.indexOf(mensagem), 1);

        }

        function selecionarMensagens(filtro) {

            vm.mensagemSelecionada = null;
            fecharMensagem();
            // vm.mensagensSelecionadas = [];
            // vm.checkBoxSelecionado = "Selecione";

            switch (filtro) {
                case 'todas':
                    vm.mensagensSelecionadas = MensageiroControllerService.retornaTodas(vm);
                    vm.checkBoxSelecionado = "Todas";
                    break;
                case 'nenhuma':
                    vm.mensagensSelecionadas = []
                    vm.checkBoxSelecionado = "Nenhuma";
                    break;
                case 'lido':
                    vm.mensagensSelecionadas = MensageiroControllerService.filtraLidasNaoLidas('lidas', vm);
                    vm.checkBoxSelecionado = "Lidas";
                    break;
                case 'naolido':
                    vm.mensagensSelecionadas = MensageiroControllerService.filtraLidasNaoLidas('naolidas', vm)
                    vm.checkBoxSelecionado = "Não Lidas";
                    break;
                case 'urgente':
                    vm.mensagensSelecionadas = MensageiroControllerService.filtraPrioridade(4, vm);
                    vm.checkBoxSelecionado = "Urgente";
                    break;
                case 'alta':
                    vm.mensagensSelecionadas = MensageiroControllerService.filtraPrioridade(3, vm);
                    vm.checkBoxSelecionado = "Alta";
                    break;
                case 'media':
                    vm.mensagensSelecionadas = MensageiroControllerService.filtraPrioridade(2, vm);
                    vm.checkBoxSelecionado = "Média";
                    break;
                case 'baixa':
                    vm.mensagensSelecionadas = MensageiroControllerService.filtraPrioridade(1, vm);
                    vm.checkBoxSelecionado = "Baixa";
                    break;
                default:
                    vm.checkBoxSelecionado = "Todas";
                    vm.mensagensSelecionadas = vm.mensagens.dados.mensagens;
                    break;

            }

        }

        function deselecionarMensagens() {
            vm.mensagensSelecionadas = [];
        }

        function toggleselecionarMensagens() {

            if (vm.mensagensSelecionadas.length > 0) {
                vm.selecionarMensagens('Nenhuma');
            } else {
                vm.selecionarMensagens('todas');
            }
        }

        function setStatusMensagem(key, value, mensagem, event) {
            // Stop the propagation if event provided
            // This will stop unwanted actions on button clicks
            if (event) {
                event.stopPropagation();
            }

            // If the mensagem provided, do the changes on that
            // particular mensagem
            if (mensagem) {
                mensagem[key] = value;
                return;
            }

            // If the current mensagem is available, do the
            // changes on that one
            if (vm.mensagemSelecionada) {
                vm.mensagemSelecionada[key] = value;
                return;
            }

            // Otherwise do the status update on selected mensagems
            for (var x = 0; x < vm.mensagensSelecionadas.length; x++) {
                vm.mensagensSelecionadas[x][key] = value;
            }
        }

        function marcarComoSinalizado(mensagem, event) {

            if (event) {
                event.stopPropagation();
            }

            if (mensagem.status == null) {
                mensagem.status = {};
                mensagem.status.titulo = "Lido"
                mensagem.status.id = 1;
                definirStatusMensagem(mensagem, 1);
            }

            if (mensagem.status.id == 3) {
                mensagem.status.id = 1;
                definirStatusMensagem(mensagem, 1);
            } else {
                mensagem.status.id = 3;
                definirStatusMensagem(mensagem, 3);
            }

        }

        function marcarComoImportante(mensagem, event) {
            if (event) {
                event.stopPropagation();
            }
            if (mensagem.codigoRemetente == vm.usuarioLogado.codigo)
                mensagem.mensagemDestinatarioIdentificador = mensagem.mensagemIdentificador;

            var dados = {
                importante: !mensagem.importante
            };

            MensageiroControllerService.preparaDados(mensagem, dados, vm);

            MensageiroService.marcarComoImportante(dados).then(function () {
                mensagem.importante = !mensagem.importante;
                if (vm.menuSelecionado == 'important') {
                    MensageiroControllerService.removeMensagemDaLista(mensagem, vm);
                }
            });
        }

        function getPrioridadeCor(prioridade) {
            if (prioridade != null) {
                return prioridade;
            }
        }

        function getLabelTitle(id) {
            if (MensageiroControllerService.verificaSeExisteLabel(id, vm))
                return vm.getLabel(id).title;
            return "";
        }

        function changeView(view) {
            if (vm.views[view]) {
                vm.defaultView = view;
                vm.currentView = view;
                LocalStorageService.armazenar('MENSAGEIRO_VIEW', view);
            }
        }

        function dialogEnviar(ev) {
            $mdDialog.show({
                controller: 'EnviarMensagemDialogController',
                controllerAs: 'vm',
                locals: {
                    selectedMail: undefined,
                    ListarUsuarioPorDetalhe: ListarUsuarioPorDetalhe,
                    HistoricoMensagens: ''
                },
                templateUrl: RotasHtml.mensageiro.dialogs.enviar,
                parent: angular.element($document.body),
                targetEvent: ev,
                clickOutsideToClose: false
            });
        }

        function replyDialog(ev, mensagem) {
            mensagem.encaminhar = false;
            mensagem.responder = true;
            $mdDialog.show({
                controller: 'EnviarMensagemDialogController',
                controllerAs: 'vm',
                locals: {
                    selectedMail: mensagem,
                    ListarUsuarioPorDetalhe: ListarUsuarioPorDetalhe,
                    HistoricoMensagens: vm.mensagemSelecionada.respostas
                },
                templateUrl: RotasHtml.mensageiro.dialogs.enviar,
                parent: angular.element($document.body),
                targetEvent: ev,
                clickOutsideToClose: false
            });
        }

        function forwardDialog(ev, mensagem) {
            mensagem.responder = false;
            mensagem.encaminhar = true;
            $mdDialog.show({
                controller: 'EnviarMensagemDialogController',
                controllerAs: 'vm',
                locals: {
                    selectedMail: mensagem,
                    ListarUsuarioPorDetalhe: ListarUsuarioPorDetalhe,
                    HistoricoMensagens: ''
                },
                templateUrl: RotasHtml.mensageiro.dialogs.enviar,
                parent: angular.element($document.body),
                targetEvent: ev,
                clickOutsideToClose: false
            });
        }

        function toggleSidenav(sidenavId) {
            $mdSidenav(sidenavId).toggle();
        }

        //#endregion

        //#region
        function init() {
            NavegacaoService.setTituloAba('Mensageiro');

            vm.colors = ['blue-bg', 'blue-grey-bg', 'orange-bg', 'pink-bg', 'purple-bg'];
            vm.pesquisar = "";
            vm.usuarioLogado = LoginUsuarioService.usuarioArmazenado();
            vm.folders = MensageiroControllerService.listaMenuLateral();
            vm.carregandoMensagens = true;
            vm.currentFilter = {
                type: $state.params.type,
                filter: $state.params.filter
            };
            vm.mensagemSelecionada = null;
            vm.mensagensSelecionadas = [];
            vm.views = {
                classic: 'app/main/mensageiro/views/classic/classic-view.html',
                outlook: 'app/main/mensageiro/views/outlook/outlook-view.html'
            };

            MensageiroControllerService.defineModoDeVisualizacaoDoMensageiro(vm);

            vm.pagina = 1;
            //#endregion propriedades

            //#region instanciação Template
            vm.loadFolder = loadFolder;
            vm.totalizador = 0;
            vm.loadLabel = loadLabel;
            vm.isFolderActive = isFolderActive;
            vm.isLabelActive = isLabelActive;
            vm.abrirMensagem = abrirMensagem;
            vm.fecharMensagem = fecharMensagem;
            vm.isSelected = isSelected;
            vm.toggleSelectmensagem = toggleSelectmensagem;
            vm.selecionarMensagens = selecionarMensagens;
            vm.deselecionarMensagens = deselecionarMensagens;
            vm.toggleselecionarMensagens = toggleselecionarMensagens;
            vm.setStatusMensagem = setStatusMensagem;
            vm.menuSelecionado = '';
            vm.getPrioridadeCor = getPrioridadeCor;
            vm.getLabelTitle = getLabelTitle;
            vm.changeView = changeView;
            vm.dialogEnviar = dialogEnviar;
            vm.replyDialog = replyDialog;
            vm.forwardDialog = forwardDialog;
            vm.toggleSidenav = toggleSidenav;
            vm.habilitaBotaoArquivar = true;
            //#endregion
            vm.proximaMensagem = true;
            vm.mensagemAnterior = true;
            vm.menuSelecionado = 'inbox';
            vm.currentFilter.filter = 'inbox';
            vm.loadFolder(vm.menuSelecionado);
            vm.ordenacaoMensagens = '-status.id';
            vm.reverso = false;
            vm.checkBoxSelecionado = "Selecione"
            // Figure out the api name
            // var apiName = 'mail.' + ($state.params.type || 'folder') + '.' + $state.params.filter + '@get';

            MensageiroControllerService.listarMensagensCaixaDeEntrada(vm.pagina, vm);
            vm.carregandoHistorico = false;
        }
        //#endregion

    }
})();

(function () {
    'use strict';

    angular
        .module('app.login', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider) {
        // State
        $stateProvider.state('app.login', {
            url: '/login',
            module: 'publico',
            views: {
                'main@': {
                    templateUrl: 'app/core/layouts/content-only.html',
                    controller: 'MainController as vm'
                },
                'content@app.login': {
                    templateUrl: 'app/main/login/login.html',
                    controller: 'LoginController as vm'
                }
            },            
            params: {
                logout: null
            },
            bodyClass: 'login'
        });

        // Tradução
        $translatePartialLoaderProvider.addPart('app/main/login');
    }

})();

(function () {
    'use strict';

    angular
        .module('app.login')
        .controller('LoginController', LoginController);

    /** @ngInject */
    function LoginController($rootScope, $mdToast, NavegacaoService, RequisicaoGenericaService, Api, MdDialogService, LoginService, ControleAcessoConfig, $state, ToolbarService, LoginUsuarioService,
        TokenService, urlApi, versaoImanager, RedefinirSenhaService, AtendimentoHubFactory, NotificacaoPipelineService, HubFactory, MensageiroHubFactory, MenuFactory, SessionStorageService, NotificacaoService) {
        var vm = this;
        NavegacaoService.setTituloAba('Login');

        $rootScope.desabilitarMudancaDeEstadoDaAplicacao = false;

        vm.versao = versaoImanager.versao;
        vm.release = versaoImanager.release;

        vm.configuracao = ControleAcessoConfig.configuracao;
        vm.urlApi = urlApi;

        // if (!$stateParams.logout && !SessionStorageService.recuperar("pagina_atualizada")) {
        //     vm.requisicaoSolicitada = true;
        //     RequisicaoGenericaService.listarSemParams(Api.listarUltimaVersaoReleaseIManager).then(
        //         function (success) {
        //             if (success && success.data) {
        //                 vm.requisicaoSolicitada = false;
        //                 console.log("API versão: " + success.data.versao + " release: " + success.data.release);
        //                 console.log("LOCAL versão: " + vm.versao + " release: " + vm.release);
        //                 if (vm.versao != success.data.versao || vm.release != success.data.release) {
        //                     window.location.reload(true);
        //                     SessionStorageService.armazenar("pagina_atualizada", true);
        //                 }
        //             }
        //         }, function (error) { });
        // }

        vm.metodos = {
            autenticarUsuario: function (event) {
                var usuario = vm.form.usuario;
                var senha = vm.form.senha;
                vm.requisicaoSolicitada = true;

                LoginService.gerarToken(usuario, senha)
                    .then(function (success) {
                        TokenService.setarToken(success.data.access_token);
                        return LoginUsuarioService.usuarioPorLoginSenha(usuario, senha);
                    })
                    .then(function (success) {
                        obterDetalhesUsuario(success.data.codigo);
                        LoginUsuarioService.armazenarUsuario(success.data);
                        HubFactory.conectar();

                        if ((success.data.clsPerfil.descricao.toLowerCase() == "gerência" || success.data.codigoPerfil == 2) &&
                            (success.data.detalhesUsuario.visualizarAtendimentosEmAbertoSetor &&
                                success.data.detalhesUsuario.notificarAtendimentosEmAbertoSetor)) {
                            AtendimentoHubFactory.notificarLimiteAtendimentosEmAbertoExcedido(success.data.codigo);
                        }
                        return MenuFactory.listarMenus(success.data.codigo, success.data.codigoPerfil);
                    })
                    .then(function (success) {
                        var usuario = LoginUsuarioService.usuarioArmazenado();
                        RequisicaoGenericaService.listarSemParams(Api.usuario.configuracaoUsuario.validaUsuarioRedefinicaoSenha + usuario.codigo)
                            .then(function (success) {
                                if (success.data == 1) {
                                    MdDialogService.alertPadraoComEvento("Atenção", function () {
                                        RedefinirSenhaService.rotinaSenha(event).then(function (success) {
                                            vm.requisicaoSolicitada = false;
                                            RedefinirSenhaService.logar();
                                        }, function (err) {
                                            RedefinirSenhaService.cancelDialog();
                                            vm.requisicaoSolicitada = false;
                                        });
                                    }, event, "<h3>Visando maior segurança, implementamos o recurso de redefinição de senhas periódicas.<br>Favor prosseguir para redefinição de sua senha.</h3>");
                                }
                                else if (success.data == 2) {
                                    MdDialogService.alertPadraoComEvento("Atenção", function () {
                                        RedefinirSenhaService.rotinaSenha(event).then(function (success) {
                                            vm.requisicaoSolicitada = false;
                                            RedefinirSenhaService.logar();
                                        }, function (err) {
                                            RedefinirSenhaService.cancelDialog();
                                            vm.requisicaoSolicitada = false;
                                        });
                                    }, event, "<h3>Senha atual expirada.<br>Favor prosseguir para redefinição de sua senha.</h3>");
                                }
                                else {
                                    vm.requisicaoSolicitada = false;
                                    RedefinirSenhaService.logar();
                                }
                            });
                    })
                    .catch(function (error) {
                        vm.requisicaoSolicitada = false;
                        ShowError(error, event);
                    })
            }
        };

        function obterDetalhesUsuario(codigoUsuario) {
            return RequisicaoGenericaService.listarSemParams(Api.usuario.detalhes_usuario.listarDetalhesUsuario
                + codigoUsuario).then(
                    function (success) {
                        ToolbarService.armazenarCodigoSquadUsuarioLogado(success.data.codigoSquads);
                    }
                );
        }

        function ShowError(error, event) {
            var erro = null;
            if (error.data != null && error.data == 'Usuário inativo.') {
                MdDialogService.alertPadrao(error.data, null);
                return;
            }
            if (error.data != null && error.data == "Acesso negado: \r\n Usuário com restrições de acesso nessa data/hora.") {
                MdDialogService.alertPadrao(error.data, null);
                return;
            }

            if (error.data != null &&
                error.data.error_description != null) {
                erro = error.data.error_description;
            } else {
                erro = error;
            }

            MdDialogService.alertPadrao(erro, event);
        }


    }
})();

/**
 * Created by nova on 27/09/2016.
 */
(function () {
    'use strict';

    angular
        .module('app.inicio', [])
        .config(Config);

    function Config($stateProvider) {



        $stateProvider
            .state('app.inicio', {
                url: '/inicio',
                module: 'privado',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/inicio/views/inicio.html',
                        controller: 'InicioController as vm'
                    }
                }
            });

    }

})();

/**
 * Created by nova on 27/09/2016.
 */
(function () {
    'use strict';

    angular
        .module('app.inicio')
        .run(['$anchorScroll', function ($anchorScroll) {
            $anchorScroll.yOffset = 50;
        }])
        .controller('InicioController', InicioController);

    function InicioController($mdSidenav, NavegacaoService, RotasHtml, $anchorScroll, $location, contatos) {
        var vm = this;
        vm.rotasHtml = RotasHtml.inicio;
        vm.setores = contatos;

        NavegacaoService.setTituloAba('Início');

        vm.metodos = {
            alteraSidenav: alteraSidenav,
            irParaSetor: irParaSetor
        }

        function irParaSetor(setor) {
            $location.hash(setor.descricao);
            $anchorScroll();
        }

        function alteraSidenav(sidenavId) {
            $mdSidenav(sidenavId).toggle();
        }
    }
})();
/**
 * Created by nova on 18/07/2016.
 */
(function () {
    'use strict';

    angular
        .module('app.controleAcessoMenu', [])
        .config(config);

    function config($stateProvider, RotasHtml) {
        var rotasHtml = RotasHtml.controle_acesso_menu
        $stateProvider
            .state('app.controleacessomenu', {
                url: '/controle-acesso-menu',
                module: 'privado',
                views: {
                    'content@app': {
                        templateUrl: rotasHtml.templateUrl,
                        controller: "ControleAcessoMenuController as vm"
                    },
                    'controle-acesso-menu-form@app.controleacessomenu': {
                        templateUrl: rotasHtml.form
                    }
                },
                resolve: {
                    Perfis: function (Api, RequisicaoGenericaService) {
                        return RequisicaoGenericaService.listarSemParams(Api.perfil.listarTodos);
                    },
                    MenusEmArvore: function (Api, RequisicaoGenericaService) {
                        return RequisicaoGenericaService.listarSemParams(Api.menu.listarMenusEmArvore);
                    },
                    TodosMenus: function (Api, RequisicaoGenericaService) {
                        return RequisicaoGenericaService.listarSemParams(Api.menu.listarTodosMenus);
                    },
                    TodasPermissoes: function (Api, RequisicaoGenericaService) {
                        return RequisicaoGenericaService.listarSemParams(Api.controle_acesso_menu.listarTodasPermissoesAcessoMenu);
                    }
                }
            });
    }

})();

(function () {
    'use strict';

    angular.module('app.controleAcessoMenu')
        .controller('ControleAcessoMenuController', ControleAcessoMenuController);

    function ControleAcessoMenuController(RequisicaoGenericaService, Api, NavegacaoService, RotasHtml, TreeControlService, Perfis, MenusEmArvore, TodosMenus, TodasPermissoes,
        MdToastService, ServicosGenericoService) {
        var vm = this;
        NavegacaoService.setTituloAba('Controle de Acesso');

        // Data region    
        vm.form = {};

        var _todosMenusExpandidosTemp = TreeControlService.expandirMenus([MenusEmArvore.data]),
            _todosMenus = TodosMenus.data,
            _todasPermissoesAcessoMenus = TodasPermissoes.data,
            _inserindoNovoControleAcesso = undefined;


        _init();
        // endregion    

        vm.metodos = {
            ngChangePerfil: ngChangePerfil,
            colapsarTodosMenus: colapsarTodosMenus,
            expandirTodosMenus: expandirTodosMenus,
            ngClickSelectMenu: ngClickSelectMenu,
            verificaCheckBoxMarcado: verificaCheckBoxMarcado,
            marcarTodosMenus: marcarTodosMenus,
            desmarcarTodosMenus: desmarcarTodosMenus,
            gravarControleAcesso: gravarControleAcesso
        };

        var metodosInterno = {
            _init: _init,
            _adicionarMenusAoControleDeAcesso: _adicionarMenusAoControleDeAcesso,
            _removerMenusDoControleDeAcesso: _removerMenusDoControleDeAcesso,
            _retornarIndexsMenus: _retornarIndexsMenus,
            _verificarSeMenuPaiNaoEstaSelecionado: _verificarSeMenuPaiNaoEstaSelecionado,
            _verificarSeMenuPaiEstaSelecionado: _verificarSeMenuPaiEstaSelecionado,
            _inserirMenuPai: _inserirMenuPai,
            _removerMenuPai: _removerMenuPai,
            _selecionarControleAcessoMenu: _selecionarControleAcessoMenu,
            _selecionarUsuariosDoPerfil: _selecionarUsuariosDoPerfil,
            _alterarEstadoBotaoGravarDesabilitado: _alterarEstadoBotaoGravarDesabilitado,
            _criarControleAcesso: _criarControleAcesso,
            _editarControleAcesso: _editarControleAcesso,
            _atualizarTodasPermissoes: _atualizarTodasPermissoes
        };

        //#region Métodos Interno

        function _init() {
            vm.rotasHtml = RotasHtml.controle_acesso_menu;
            vm.controleAcessoMenu = {};
            vm.usuariosPerfilSelecionado = [];
            vm.opcoesTree = TreeControlService.carregarOpcoesTree("subMenus");
            vm.menusExpandidos = _todosMenusExpandidosTemp;
            vm.botaoGravarDesabilitado = undefined;
            vm.controladorPreloaders = {
                atualizandoMenus: false,
                atualizandoUsuariosPorPerfil: false
            }

            vm.perfis = angular.copy(Perfis.data);
            vm.menusEmArvore = MenusEmArvore.data;

            _alterarEstadoBotaoGravarDesabilitado(true);
            _selecionarUsuariosDoPerfil(vm.perfis[0]);
            _selecionarControleAcessoMenu(vm.perfis[0]);
        }

        function _adicionarMenusAoControleDeAcesso(menu) {
            for (var i = 0; i < menu.length; i++) {
                var indexMenus = _retornarIndexsMenus(menu[i]);

                if (indexMenus.indexMenuPrincipal == -1)
                    vm.controleAcessoMenu.menus.push(menu[i]);

                if (menu[i] && menu[i].subMenus) {
                    _adicionarMenusAoControleDeAcesso(menu[i].subMenus);
                }

            }
        }

        function _removerMenusDoControleDeAcesso(menu) {
            for (var i = 0; i < menu.length; i++) {
                var indexMenus = _retornarIndexsMenus(menu[i]);

                if (indexMenus.indexMenuPrincipal != -1)
                    vm.controleAcessoMenu.menus.splice(indexMenus.indexMenuPrincipal, 1);

                if (menu[i] && menu[i].subMenus) {
                    _removerMenusDoControleDeAcesso(menu[i].subMenus);
                }

            }
        }

        function _retornarIndexsMenus(menu) {
            var codigosMenus = vm.controleAcessoMenu.menus.map(function (item) { return item.codigo });
            return {
                indexMenuPrincipal: codigosMenus.indexOf(menu.codigo),
                indexMenuPai: codigosMenus.indexOf(menu.codigoMenuPai),
            }
        }

        function _verificarSeMenuPaiNaoEstaSelecionado(menu) {
            var indexMenus = _retornarIndexsMenus(menu);

            if (indexMenus.indexMenuPai == -1)
                _inserirMenuPai(menu)
        }

        function _verificarSeMenuPaiEstaSelecionado(menu) {
            var indexMenus = _retornarIndexsMenus(menu);
            var quantidadeItensMenuPai = 0

            if (indexMenus.indexMenuPai > -1) {
                var menuPai = vm.controleAcessoMenu.menus[indexMenus.indexMenuPai];
                vm.controleAcessoMenu.menus.forEach(function (item) {
                    if (item.codigoMenuPai == menuPai.codigo) {
                        quantidadeItensMenuPai++;
                    }
                });

                if (quantidadeItensMenuPai <= 1)
                    _removerMenuPai(menuPai, indexMenus.indexMenuPai)
            }
        }

        function _inserirMenuPai(menu) {
            var index = _todosMenus.map(function (item) { return item.codigo }).indexOf(menu.codigoMenuPai);
            var menuPai = _todosMenus[index];

            vm.controleAcessoMenu.menus.push(menuPai);

            if (menuPai.codigoMenuPai)
                _verificarSeMenuPaiNaoEstaSelecionado(menuPai);
        }

        function _removerMenuPai(menuPai, indexMenuPai) {
            vm.controleAcessoMenu.menus.splice(indexMenuPai, 1);

            if (menuPai.codigoMenuPai)
                _verificarSeMenuPaiEstaSelecionado(menuPai);
        }

        function _selecionarControleAcessoMenu(perfil) {
            var index = _todasPermissoesAcessoMenus.map(function (item) { return item.codigo }).indexOf(perfil.codigo);

            if (index == -1) {
                _inserindoNovoControleAcesso = true;
                vm.controleAcessoMenu.codigo = perfil.codigo;
                vm.controleAcessoMenu.menus = [];
            }
            else {
                _inserindoNovoControleAcesso = false;
                vm.controleAcessoMenu.codigo = _todasPermissoesAcessoMenus[index].codigo;
                vm.controleAcessoMenu.menus = _todasPermissoesAcessoMenus[index].menus
            }

        }

        function _selecionarUsuariosDoPerfil(perfil) {
            var modelo = { codigoPerfil: perfil.codigo, ativo: true };
            vm.controladorPreloaders.atualizandoUsuariosPorPerfil = true;
            RequisicaoGenericaService.listarComParams(Api.usuario.detalhes_usuario.listarUsuariosDetalhesPor, modelo).then(
                function (success) {
                    vm.usuariosPerfilSelecionado = success.data;
                    vm.controladorPreloaders.atualizandoUsuariosPorPerfil = false;
                },
                function (error) {
                    vm.controladorPreloaders.atualizandoUsuariosPorPerfil = false;
                    ServicosGenericoService.exibirAlertaDeErro(error, event);
                });
        }

        function _alterarEstadoBotaoGravarDesabilitado(estado) {
            vm.botaoGravarDesabilitado = estado;
        }

        function _criarControleAcesso(event, controleAcessoMenu) {
            vm.controladorPreloaders.atualizandoMenus = true;
            RequisicaoGenericaService.salvar(Api.controle_acesso_menu.criar, controleAcessoMenu).then(
                function (success) {
                    MdToastService.toastPadrao("Menus atualizado com sucesso.");
                    vm.botaoGravarDesabilitado = true;
                    vm.controladorPreloaders.atualizandoMenus = false;

                    _atualizarTodasPermissoes(success.data);
                },
                function (error) {
                    vm.controladorPreloaders.atualizandoMenus = false;
                    ServicosGenericoService.exibirAlertaDeErro(error, event);
                });
        }

        function _editarControleAcesso(event, controleAcessoMenu) {
            vm.controladorPreloaders.atualizandoMenus = true;
            RequisicaoGenericaService.editar(Api.controle_acesso_menu.editar, controleAcessoMenu).then(
                function (success) {
                    MdToastService.toastPadrao("Menus atualizado  com sucesso.");
                    vm.botaoGravarDesabilitado = true;
                    vm.controladorPreloaders.atualizandoMenus = false;

                    _atualizarTodasPermissoes(success.data);
                },
                function (error) {
                    ServicosGenericoService.exibirAlertaDeErro(error, event);
                    vm.controladorPreloaders.atualizandoMenus = false;
                });
        }

        function _atualizarTodasPermissoes(permissao) {
            var index = _todasPermissoesAcessoMenus.map(function (item) { return item.codigo }).indexOf(permissao.codigo);
            if (index == -1) {
                _todasPermissoesAcessoMenus.push(permissao);
            }
            else {
                _todasPermissoesAcessoMenus[index] = permissao;
            }
        }
        //#endregion

        // Métodos region

        function ngChangePerfil(event, codigoPerfil) {
            var index = vm.perfis.map(function (item) { return item.codigo }).indexOf(codigoPerfil);

            _alterarEstadoBotaoGravarDesabilitado(true);
            _selecionarUsuariosDoPerfil(vm.perfis[index]);
            _selecionarControleAcessoMenu(vm.perfis[index]);
        }

        function colapsarTodosMenus(event) {
            vm.menusExpandidos = [];
        }

        function expandirTodosMenus(event) {
            vm.menusExpandidos = _todosMenusExpandidosTemp;
        }

        function ngClickSelectMenu(event, naoSelecionado, menu) {
            _alterarEstadoBotaoGravarDesabilitado(false);
            if (menu.codigoMenuPai && !naoSelecionado)
                _verificarSeMenuPaiNaoEstaSelecionado(menu);
            else
                _verificarSeMenuPaiEstaSelecionado(menu);

            !naoSelecionado ? _adicionarMenusAoControleDeAcesso([menu]) : _removerMenusDoControleDeAcesso([menu])
        }

        function verificaCheckBoxMarcado(event, menu) {
            if (!vm.controleAcessoMenu.menus || typeof (vm.controleAcessoMenu.menus) == "array" && vm.controleAcessoMenu.menus.length == 0)
                return false;

            return vm.controleAcessoMenu.menus.map(function (item) { return item.codigo }).indexOf(menu.codigo) > -1 ? true : false
        }

        function marcarTodosMenus() {
            _alterarEstadoBotaoGravarDesabilitado(false);
            vm.controleAcessoMenu.menus = _todosMenus;
        }

        function desmarcarTodosMenus() {
            _alterarEstadoBotaoGravarDesabilitado(false);
            vm.controleAcessoMenu.menus = [];
        }

        function gravarControleAcesso(event, controleAcessoMenu) {
            if (_inserindoNovoControleAcesso)
                _criarControleAcesso(event, controleAcessoMenu);
            else
                _editarControleAcesso(event, controleAcessoMenu);
        }

        //endregion

    }
})();

(function () {
    'use strict';

    angular
        .module('app.datamobil')
        .controller('DatamobilController', DatamobilController);

    function DatamobilController($timeout, DatamobilIaService, msNavigationService, $mdSidenav, SessionStorageService, $mdDialog, MdDialogService) {
        var vm = this;
        vm.sidenavAberta = false;
        vm.emProgresso = false;
        vm.conversaIniciada = false;
        vm.mensagens = [];
        vm.historicoComandos = SessionStorageService.recuperar('historicoComandosDatamobil') || [];
        vm.historicoIndex = null;

        vm.metodos = {
            abrirFecharSidenav: abrirFecharSidenav,
            enviarMensagem: enviarMensagem,
            pressionandoTecla: pressionandoTecla,
            enviarComandoFavorito: enviarComandoFavorito
        };

        $timeout(function () {
            if (!msNavigationService.getFolded()) {
                msNavigationService.toggleFolded();
            }
            $mdSidenav('filtro').open();
        }, 50);

        function abrirFecharSidenav(sidenavId) {
            var sidenav = $mdSidenav(sidenavId);
            sidenav.toggle().then(function () {
                var el = document.getElementById('datamobil-ia');
                if (sidenav.isOpen()) {
                    el.classList.add('sidenav-aberta');
                } else {
                    el.classList.remove('sidenav-aberta');
                }
            });
            vm.sidenavAberta = !vm.sidenavAberta;
        }

        function enviarComandoFavorito(comando) {
            enviarMensagem(comando);
            if (vm.sidenavAberta) {
                abrirFecharSidenav('filtro');
            }
        }

        function enviarMensagem(mensagem) {
            if (!mensagem || vm.emProgresso) return;

            executarEnvioMensagem(mensagem);
        }

        function executarEnvioMensagem(mensagem) {
            vm.emProgresso = true;
            vm.conversaIniciada = true;
            vm.mensagens.push({ comando: mensagem, tipo: 'enviada' });
            if (!vm.historicoComandos.length || vm.historicoComandos[vm.historicoComandos.length - 1] !== mensagem) {
                vm.historicoComandos.push(mensagem);
                SessionStorageService.armazenar('historicoComandosDatamobil', vm.historicoComandos);
            }
            vm.historicoIndex = null;
            vm.comando = '';
            rolarParaFinal();
            _realizarConsultarSQL(mensagem);
        }

        function mostrarDialogErroServidor() {
            MdDialogService.alertPadrao(
                'Atenção!',
                null,
                'Não foi possível concluir sua solicitação no momento.<br><br>Tente novamente em alguns instantes.'
            );
        }

        function rolarParaFinal() {
            $timeout(function () {
                var elemento = document.querySelector('.mensagens');
                if (elemento) {
                    try {
                        elemento.scrollTo({ top: elemento.scrollHeight, behavior: 'smooth' });
                    } catch (e) {
                        elemento.scrollTop = elemento.scrollHeight;
                    }
                }
            }, 0);
        }

        function pressionandoTecla(event) {
            var codigoTeclaPressionada = event.keyCode;
            if (codigoTeclaPressionada === 13) {
                pressionandoEnter(event);
            } else if (codigoTeclaPressionada === 38) {
                pressionandoSetaParaCima(event);
            } else if (codigoTeclaPressionada === 40) {
                pressionandoSetaParaBaixo(event);
            }
        }

        function pressionandoEnter(event) {
            enviarMensagem(vm.comando);
            event.preventDefault();
        }

        function pressionandoSetaParaCima(event) {
            if (!vm.historicoComandos.length) return;
            if (vm.historicoIndex === null) {
                vm.historicoIndex = vm.historicoComandos.length - 1;
            } else if (vm.historicoIndex > 0) {
                vm.historicoIndex--;
            }
            vm.comando = vm.historicoComandos[vm.historicoIndex];
            event.preventDefault();
        }

        function pressionandoSetaParaBaixo(event) {
            if (!vm.historicoComandos.length || vm.historicoIndex === null) return;
            if (vm.historicoIndex < vm.historicoComandos.length - 1) {
                vm.historicoIndex++;
                vm.comando = vm.historicoComandos[vm.historicoIndex];
            } else {
                vm.historicoIndex = null;
                vm.comando = '';
            }
            event.preventDefault();
        }

        function _realizarConsultarSQL(comando) {
            DatamobilIaService.consultarIA(comando).then(function (response) {
                var resposta = response.data;
                var novaMensagem = { tipo: 'recebida', comando: comando };

                if (resposta && resposta.data && resposta.query) {
                    novaMensagem.data = resposta.data;
                    novaMensagem.query = resposta.query;
                    novaMensagem.usageGPT = resposta.usage_GPT;
                    novaMensagem.usageGptDiagnostico = resposta.usage_GPT_Diagnostico;
                } else if (resposta && angular.isArray(resposta.dados)) {
                    novaMensagem.data = resposta.dados;
                } else {
                    var texto = resposta && (resposta.error || resposta.Erro || resposta.erro ||
                        resposta.mensagem || resposta.Mensagem || resposta.message);
                    novaMensagem.texto = texto ?
                        texto.split(' [line')[0].replace('❌', '').trim() :
                        'Não foi possível concluir sua solicitação no momento.';
                }
                vm.mensagens.push(novaMensagem);
                DatamobilIaService.salvarHistoricoComandos(novaMensagem);
            }).catch(function () {
                mostrarDialogErroServidor();
            }).finally(function () {
                vm.emProgresso = false;
                rolarParaFinal();
            });
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.cadastromenu')
        .controller('CadastroMenuController', CadastroMenuController);

    function CadastroMenuController(NavegacaoService, Api, RequisicaoGenericaService, MdDialogService, RotasHtml, TreeControlService) {
        var vm = this;
        NavegacaoService.setTituloAba('Cadastros de Menu');

        //#region Data

        var _listaMenus = [];

        vm.opcoes = TreeControlService.carregarOpcoesTree("subMenus");

        vm.requisicaoSolicitada = false;

        //#endregion

        var metodosInternos = {
            _init: _init,
            _carregarMenus: _carregarMenus,
            _listarMenus: _listarMenus
        };

        vm.metodos = {
            abrirDialogMenu: abrirDialogMenu,

        };

        _init();

        //#region Métododos Internos

        function _init() {
            vm.rotasHtml = RotasHtml.cadastro_menu;
            _carregarMenus();
            _listarMenus();
        }

        function _carregarMenus() {
            vm.requisicaoSolicitada = true;
            return RequisicaoGenericaService.listarSemParams(Api.menu.listarMenusEmArvore).then(
                function (success) {                    
                    vm.requisicaoSolicitada = false;

                    vm.menu = [success.data];
                    vm.menusExpandidos = [vm.menu[0]];
                },
                function (error) {
                    vm.requisicaoSolicitada = false;
                });
        }

        function _listarMenus() {
            vm.requisicaoSolicitada = true;
            return RequisicaoGenericaService.listarSemParams(Api.menu.listarTodosMenus).then(
                function (success) {
                    _listaMenus = success.data;
                    vm.requisicaoSolicitada = false;
                },
                function (error) {
                    vm.requisicaoSolicitada = false;
                });
        }

        //#endregion

        //#region Métodos

        function abrirDialogMenu(menu, modo, event) {
            MdDialogService.abrirDialogPadrao(event, 'CadastroMenuDialogController', vm.rotasHtml.dialog, [modo, menu, _listaMenus, _carregarMenus, _listarMenus], true);
        }

        //#endregion       
    }
})();

(function () {
    'use strict';

    angular
        .module('app.factory')
        .factory("TipoLicencaFactory", TipoLicencaFactory);

    function TipoLicencaFactory(Api) {

        var _rotaDePesquisa = Api.protecao.tipoLicenca.listarPor;
        var _seletores = { 1: 'E', 2: 'OU' };
        var _seletor = 2;

        var _tiposLicenca = [];
        var _tiposLicencaANaoImprimir = [];

        return {
            rotaDePesquisa: _rotaDePesquisa,
            verificaSeExisteTipoLicencaANaoImprimirNaLista : _verificaSeExisteTipoLicencaANaoImprimirNaLista,
            removerTipoLicencaANaoImprimir : _removerTipoLicencaANaoImprimir,
            verificaSeExisteTipoLicencaNaLista: _verificaSeExisteTipoLicencaNaLista,
            removerTipoLicenca: _removerTipoLicenca,
            tiposLicenca:_tiposLicenca,
            tiposLicencaANaoImprimir:_tiposLicencaANaoImprimir,
            seletores: _seletores,
            seletor: _seletor
        }

        function _verificaSeExisteTipoLicencaNaLista(tiposLicenca, tipo) {
            return tiposLicenca.some(function (item) {
                return ((tipo.codigo) == (item.codigo));
            });
        }

        function _verificaSeExisteTipoLicencaANaoImprimirNaLista(tiposLicencaANaoImprimir, tipo) {
            return tiposLicencaANaoImprimir.some(function (item) {
                return ((tipo.codigo) == (item.codigo));
            });
        }

        function _removerTipoLicenca(tiposLicenca, tipo) {
            if (tipo && _verificaSeExisteTipoLicencaNaLista(tiposLicenca, tipo)) {
                for (var i = tiposLicenca.length - 1; i >= 0; i--) {
                    if (tiposLicenca[i].codigo === tipo.codigo) {
                        _tiposLicenca = tiposLicenca.splice(i, 1);
                    }
                }
            }

            if (_tiposLicenca == undefined || _tiposLicenca.length == 0) {
                _tiposLicenca = tiposLicenca;
            }
        }

        function _removerTipoLicencaANaoImprimir(tiposLicencaANaoImprimir, tipo) {
            if (tipo && _verificaSeExisteTipoLicencaANaoImprimirNaLista(tiposLicencaANaoImprimir, tipo)) {
                for (var i = tiposLicencaANaoImprimir.length - 1; i >= 0; i--) {
                    if (tiposLicencaANaoImprimir[i].codigo === tipo.codigo) {
                        _tiposLicencaANaoImprimir = tiposLicencaANaoImprimir.splice(i, 1);
                    }
                }
            }

            if (_tiposLicencaANaoImprimir == undefined || _tiposLicencaANaoImprimir.length == 0) {
                _tiposLicencaANaoImprimir = tiposLicencaANaoImprimir;
            }
        }
    }

})();
(function () {
    'use strict';

    angular
        .module('app.factory')
        .factory('SprintFactory', SprintFactory);

    function SprintFactory(DataTableConfigPadrao, $rootScope, ServicosGenericoService, RotasHtml) {

        return {
            setHtmlRota: _setHtmlRota,
            setDtOptionsBacklog: _setDtOptionsBacklog,
            setColumnsDefsDtOptionsSprintBacklog: _setColumnsDefsDtOptionsSprintBacklog,
            setDtOptionsRecursos: _setDtOptionsRecursos,
            setDtOptionsRegistros: _setDtOptionsRegistros,
            setColumnsDefsDtOptionsRegistros: _setColumnsDefsDtOptionsRegistros,
            setDtOptionsAbatimentos: _setDtOptionsAbatimentos,
            setColumnsDefsDtOptionsCerimoniaDetalhes: _setColumnsDefsDtOptionsCerimoniaDetalhes,
            defineArrayDeVariaveisControladorasDoSprint: _defineArrayDeVariaveisControladorasDoSprint,
            defineTemplatesSprintBacklog: _defineTemplatesSprintBacklog,
            defineDadosDaTabelaBurndown: _defineDadosDaTabelaBurndown,
            coresSituacoes: _defineCoresBacklogHistoricoSituacao,
            setDtOptionsAcompanhamentoMetas: setDtOptionsAcompanhamentoMetas,
            setDtOptionsPontosDesenvolvedor: setDtOptionsPontosDesenvolvedor,
            setColumnsDefsDtOptionsSprintPontosDesenvolvedor: _setColumnsDefsDtOptionsSprintPontosDesenvolvedor,
            setColumnsDefsDtOptionsSprintMeta: _setColumnsDefsDtOptionsSprintMeta
        }

        function _setHtmlRota() {
            return RotasHtml.sprint;
        }

        function setDtOptionsAcompanhamentoMetas() {
            return {
                dom: 'rt<"bottom"<"left"<"info"i>>>',
                initComplete: function () {
                    var api = this.api(),
                        searchBox = angular.element('body').find('#pesquisarHistoriasMeta'),
                        htmCollection = document.getElementsByClassName('array-buttons-metas');

                    var elemento = [];
                    
                    
                    angular.forEach(htmCollection, function (key, value) {
                        elemento.push(angular.element(key));
                        elemento[value].click(function (event) {
                            var arrayFormatado = $rootScope.historiaMetasFiltradas.join("|");
                            api.column(8).search(arrayFormatado, true, false).draw(); 
                            var totalRecords = api.page.info().recordsDisplay;                           
                            $rootScope.$emit('totalRegistrosUpdated', totalRecords);
                        });
                    });

                    if (searchBox.length > 0) {
                        searchBox.on('keyup', function (event) {
                            api.search(event.target.value).draw();
                            var totalRecords = api.page.info().recordsDisplay;
                            $rootScope.$emit('totalRegistrosUpdated', totalRecords);
                        });
                    }
                    
                },
                paging: false,
                responsive: true,
                language: {
                    emptyTable: "Não existem dados para serem exibidos.",
                    zeroRecords: "Não existem dados para o filtro selecionado.",
                    info: "Exibindo _TOTAL_ itens",
                    infoEmpty: " "
                },
                drawCallback: function() {                    
                    var totalRecords = this.api().page.info().recordsDisplay;
                    $rootScope.$emit('totalRegistrosUpdated', totalRecords);
                }
            };
        }

        function setDtOptionsPontosDesenvolvedor() {
            return {
                dom: 'rt<"bottom"<"left"<"info"i>>>',
                initComplete: function () {
                    var api = this.api(),
                        searchBox = angular.element('body').find('#pesquisarHistoriasMeta'),
                        htmCollection = document.getElementsByClassName('array-buttons-metas');

                    var elemento = [];

                    angular.forEach(htmCollection, function (key, value) {
                        elemento.push(angular.element(key));
                        elemento[value].click(function (event) {
                            var arrayFormatado = $rootScope.historiaMetasFiltradas.join("|");
                            api.column(8).search(arrayFormatado, true, false).draw();
                        });
                    });

                    if (searchBox.length > 0) {
                        searchBox.on('keyup', function (event) {
                            api.search(event.target.value).draw();
                        });
                    }
                },                
                paging: false,
                responsive: true,
                language: {
                    emptyTable: "Não existem dados para serem exibidos.",
                    zeroRecords: "Não existem dados para o filtro selecionado.",
                    info: "Exibindo _TOTAL_ itens",
                    infoEmpty: " "
                }
            };
        }

        function _setColumnsDefsDtOptionsSprintPontosDesenvolvedor() {
            return [
                {
                    targets: 0,
                    orderable: true,
                    responsivePriority: 1
                },
                {
                    targets: 1,
                    orderable: true,
                }
            ];
        };

        function _setColumnsDefsDtOptionsSprintMeta() {
            return [
                {
                    targets: 0,
                    ordering: false,
                    filterable: false,
                    sortable: false
                },
                {
                    targets: 1,
                    ordering: false,
                    filterable: false,
                    sortable: false
                },
                {
                    targets: 2,
                    ordering: false,
                    filterable: false,
                    sortable: false,
                    responsivePriority: 1
                },
                {
                    targets: 7,
                    ordering: false,
                    filterable: false,
                    sortable: false,
                    responsivePriority: 1
                }
            ];
        };

        function _setDtOptionsBacklog() {
            return {
                dom: 'rt<"bottom"<"left"<"info"i>>>',
                initComplete: function () {
                    var api = this.api(),
                        searchBox = angular.element('body').find('#pesquisar'),
                        htmCollection = document.getElementsByClassName('array-buttons-backlog');

                    var elemento = [];

                    angular.forEach(htmCollection, function (key, value) {
                        elemento.push(angular.element(key));
                        elemento[value].click(function (event) {
                            var arrayFormatado = $rootScope.situacoesSelecionadasDescricoes.toString().replace(/,/g, "|");
                            api.column(4).search(arrayFormatado, true, false).draw();
                        });
                    });

                    // Bind an external input as a table wide search box
                    if (searchBox.length > 0) {
                        searchBox.on('keyup', function (event) {
                            api.search(event.target.value).draw();
                        });
                    }
                },
                paging: false,
                responsive: true,
                language: {
                    emptyTable: "Não existem dados para serem exibidos.",
                    zeroRecords: "Não existem dados para o filtro selecionado.",
                    info: "Exibindo _TOTAL_ itens",
                    infoEmpty: " "
                }
            };
        };

        function _setColumnsDefsDtOptionsSprintBacklog() {
            return [
                {
                    targets: 0,
                    ordering: false,
                    filterable: false,
                    sortable: false,
                    responsivePriority: 1
                },
                {
                    targets: 1,
                    ordering: false,
                    filterable: false,
                    sortable: false
                },
                {
                    targets: 2,
                    ordering: false,
                    filterable: false,
                    sortable: false,
                    responsivePriority: 1
                },
                {
                    targets: 7,
                    ordering: false,
                    filterable: false,
                    sortable: false,
                    responsivePriority: 1
                }
            ];
        };        

        function _setDtOptionsRecursos() {
            return {
                dom: 'rt<"bottom"<"left"<"info"i>>>',
                responsive: true,
                initComplete: function () {
                    var api = this.api(),
                        searchBox = angular.element('body').find('#pesquisar');

                    // Bind an external input as a table wide search box
                    if (searchBox.length > 0) {
                        searchBox.on('keyup', function (event) {
                            api.search(event.target.value).draw();
                        });
                    }
                },
                footerCallback: function (row, data, start, end, display) {
                    var api = this.api();
                    var arrayTotalHorasRecursosSprint = [],
                        arrayTotalHorasRecursosDiario = [];

                    api.column(4, {
                        page: 'current'
                    }).data()
                        .reduce(function (a, b) {
                            arrayTotalHorasRecursosSprint.push(b.split(":"));
                        }, 0);
                    $(api.column(4).footer()).html("<label class='centraliza-tfooter'>" + ServicosGenericoService.retornaSomatorioDeHorasEMinutos(arrayTotalHorasRecursosSprint) + '</label>');

                    api.column(3, {
                        page: 'current'
                    }).data()
                        .reduce(function (a, b) {
                            arrayTotalHorasRecursosDiario.push(b.split(":"));
                        }, 0);
                    $(api.column(3).footer()).html("<label class='centraliza-tfooter'>" + ServicosGenericoService.retornaSomatorioDeHorasEMinutos(arrayTotalHorasRecursosDiario) + '</label>');
                },
                paging: false,
            }
        }

        function _setDtOptionsRegistros() {
            return {
                dom: 'rt<"bottom"<"left"<"info"i>>>',
                initComplete: function () {
                    var api = this.api(),
                        searchBox = angular.element('body').find('#pesquisar'),
                        htmCollection = document.getElementsByClassName('array-buttons-registro');

                    var elemento = [];

                    angular.element('#sprint-button-desmarcar-filtros-registros').click(function (ev) {
                        api.column(5).search("").draw();
                    });

                    if ($rootScope.registrosSelecionados.length > 0) {
                        var arrayFormatado = $rootScope.registrosSelecionados.toString().replace(/,/g, "|");
                        api.column(5).search(arrayFormatado, true, false).draw();
                    }

                    angular.forEach(htmCollection, function (key, value) {
                        elemento.push(angular.element(key));
                        elemento[value].click(function (event) {
                            var arrayFormatado = $rootScope.registrosSelecionados.toString().replace(/,/g, "|");
                            api.column(5).search(arrayFormatado, true, false).draw();
                        });
                    });

                    // Bind an external input as a table wide search box
                    if (searchBox.length > 0) {
                        searchBox.on('keyup', function (event) {
                            api.search(event.target.value).draw();
                        });
                    }
                },
                footerCallback: function (row, data, start, end, display) {
                    var api = this.api();
                    var arrayTotalHoras = [];

                    api.column(4, {
                        page: 'current'
                    }).data()
                        .reduce(function (a, b) {
                            if (b) {
                                arrayTotalHoras.push(b.split(":"));
                            }
                        }, 0);
                    $(api.column(4).footer()).html("<label class='centraliza-tfooter'>" + ServicosGenericoService.retornaSomatorioDeHorasEMinutos(arrayTotalHoras) + '</label>');
                },
                paging: false,
                responsive: true
            };
        };

        function _setColumnsDefsDtOptionsRegistros() {
            return [{
                targets: 0,
                ordering: false,
                filterable: false,
                sortable: false,
                responsivePriority: 1
            },
            {
                targets: 3,
                type: 'date-pt-br'
            },
            {
                targets: 6,
                searchable: false
            }
            ]
        };

        function _setDtOptionsAbatimentos() {
            return {
                dom: 'rt<"bottom"<"left"<"info"i>>>',
                responsive: true,
                initComplete: function () {
                    var api = this.api(),
                        searchBox = angular.element('body').find('#pesquisar');

                    // Bind an external input as a table wide search box
                    if (searchBox.length > 0) {
                        searchBox.on('keyup', function (event) {
                            api.search(event.target.value).draw();
                        });
                    }
                },
                footerCallback: function (row, data, start, end, display) {
                    var api = this.api();
                    var arrayTotalHoras = [];

                    api.column(2, {
                        page: 'current'
                    }).data()
                        .reduce(function (a, b) {
                            arrayTotalHoras.push(b.split(":"));
                        }, 0);
                    $(api.column(2).footer()).html("<label class='centraliza-tfooter'>" + ServicosGenericoService.retornaSomatorioDeHorasEMinutos(arrayTotalHoras) + '</label>');

                },
                paging: false
            }
        }

        function _setColumnsDefsDtOptionsCerimoniaDetalhes(cerimonias) {
            return [{
                targets: 0,
                ordering: false,
                filterable: false,
                sortable: false,
            },
            {
                // Target the status column
                targets: 1,
                render: function (data, tipo, elemento, objeto) {
                    angular.forEach(cerimonias, function (item, index) {
                        if (index == data) {
                            data = item;
                        }
                    });
                    return data;
                }
            },
            {
                targets: 2,
                type: 'date-pt-br'
            },
            ]
        };

        function _defineArrayDeVariaveisControladorasDoSprint() {
            return {
                tabRecursos: {
                    ativa: false,
                    editar: false
                },
                tabAbatimentos: {
                    ativa: false,
                    editar: false
                },
                tabLimites: {
                    ativa: false,
                    editar: false
                }
            };
        };

        function _defineTemplatesSprintBacklog() {
            return [{
                cadastroAtivo: false,
                view: 'viewTabelaSprintBacklog',
                url: _setHtmlRota().tabBacklog.tabelaBacklog
            },
            {
                cadastroAtivo: true,
                view: 'viewParaCadastrarEstoriasNoBacklogListandoEstoriasSemBacklog',
                url: _setHtmlRota().tabBacklog.cadastroBacklog
            }
            ];
        };

        function _defineDadosDaTabelaBurndown() {
            return {
                titulos: [{
                    title: "Recursos"
                },
                {
                    title: "26/10",
                    totalHoras: 20
                },
                {
                    title: "27/10",
                    totalHoras: 0
                },
                {
                    title: "28/10",
                    totalHoras: 0
                },
                {
                    title: "31/11",
                    totalHoras: 0
                },
                {
                    title: "01/11",
                    totalHoras: 0
                },
                {
                    title: "03/11",
                    totalHoras: 0
                },
                {
                    title: "04/11",
                    totalHoras: 0
                },
                {
                    title: "07/11",
                    totalHoras: 0
                },
                {
                    title: "08/11",
                    totalHoras: 0
                },
                {
                    title: "09/11",
                    totalHoras: 0
                },
                ],
                recursos: [{
                    identificador: 1,
                    nome: "Jéssica",
                    dias: [{
                        data: new Date(2016, 10, 26),
                        horas: 6
                    },
                    {
                        data: new Date(2016, 10, 27),
                        horas: 5
                    },
                    {
                        data: new Date(2016, 10, 28),
                        horas: 7
                    },
                    {
                        data: new Date(2016, 10, 31),
                        horas: 9
                    },
                    {
                        data: new Date(2016, 11, 1),
                        horas: 3
                    },
                    {
                        data: new Date(2016, 11, 3),
                        horas: 4
                    },
                    {
                        data: new Date(2016, 11, 4),
                        horas: 8
                    },
                    {
                        data: new Date(2016, 11, 7),
                        horas: 6
                    },
                    {
                        data: new Date(2016, 11, 8),
                        horas: 4
                    },
                    {
                        data: new Date(2016, 11, 9),
                        horas: 5
                    }
                    ]
                }, {
                    identificador: 2,
                    nome: "Ana",
                    dias: [{
                        data: new Date(2016, 10, 26),
                        horas: 7
                    },
                    {
                        data: new Date(2016, 10, 27),
                        horas: 6
                    },
                    {
                        data: new Date(2016, 10, 28),
                        horas: 9
                    },
                    {
                        data: new Date(2016, 10, 31),
                        horas: 8
                    },
                    {
                        data: new Date(2016, 11, 1),
                        horas: 6
                    },
                    {
                        data: new Date(2016, 11, 3),
                        horas: 6
                    },
                    {
                        data: new Date(2016, 11, 4),
                        horas: 6
                    },
                    {
                        data: new Date(2016, 11, 7),
                        horas: 6
                    },
                    {
                        data: new Date(2016, 11, 8),
                        horas: 6
                    },
                    {
                        data: new Date(2016, 11, 9),
                        horas: 6
                    }
                    ]
                }, {
                    identificador: 1,
                    nome: "Fabiano",
                    totalHoras: 0,
                    dias: [{
                        data: new Date(2016, 10, 26),
                        horas: 6
                    },
                    {
                        data: new Date(2016, 10, 27),
                        horas: 6
                    },
                    {
                        data: new Date(2016, 10, 28),
                        horas: 6
                    },
                    {
                        data: new Date(2016, 10, 31),
                        horas: 6
                    },
                    {
                        data: new Date(2016, 11, 1),
                        horas: 6
                    },
                    {
                        data: new Date(2016, 11, 3),
                        horas: 6
                    },
                    {
                        data: new Date(2016, 11, 4),
                        horas: 6
                    },
                    {
                        data: new Date(2016, 11, 7),
                        horas: 6
                    },
                    {
                        data: new Date(2016, 11, 8),
                        horas: 6
                    },
                    {
                        data: new Date(2016, 11, 9),
                        horas: 6
                    }
                    ]
                }, {
                    identificador: 1,
                    nome: "Julio",
                    totalHoras: 0,
                    dias: [{
                        data: new Date(2016, 10, 26),
                        horas: 6
                    },
                    {
                        data: new Date(2016, 10, 27),
                        horas: 6
                    },
                    {
                        data: new Date(2016, 10, 28),
                        horas: 6
                    },
                    {
                        data: new Date(2016, 10, 31),
                        horas: 6
                    },
                    {
                        data: new Date(2016, 11, 1),
                        horas: 6
                    },
                    {
                        data: new Date(2016, 11, 3),
                        horas: 6
                    },
                    {
                        data: new Date(2016, 11, 4),
                        horas: 6
                    },
                    {
                        data: new Date(2016, 11, 7),
                        horas: 6
                    },
                    {
                        data: new Date(2016, 11, 8),
                        horas: 6
                    },
                    {
                        data: new Date(2016, 11, 9),
                        horas: 6
                    }
                    ]
                }, {
                    identificador: 1,
                    nome: "Leticia",
                    totalHoras: 0,
                    dias: [{
                        data: new Date(2016, 10, 26),
                        horas: 6
                    },
                    {
                        data: new Date(2016, 10, 27),
                        horas: 6
                    },
                    {
                        data: new Date(2016, 10, 28),
                        horas: 6
                    },
                    {
                        data: new Date(2016, 10, 31),
                        horas: 6
                    },
                    {
                        data: new Date(2016, 11, 1),
                        horas: 6
                    },
                    {
                        data: new Date(2016, 11, 3),
                        horas: 6
                    },
                    {
                        data: new Date(2016, 11, 4),
                        horas: 6
                    },
                    {
                        data: new Date(2016, 11, 7),
                        horas: 6
                    },
                    {
                        data: new Date(2016, 11, 8),
                        horas: 6
                    },
                    {
                        data: new Date(2016, 11, 9),
                        horas: 6
                    }
                    ]
                }, {
                    identificador: 1,
                    nome: "Bruno",
                    totalHoras: 0,
                    dias: [{
                        data: new Date(2016, 10, 26),
                        horas: 6
                    },
                    {
                        data: new Date(2016, 10, 27),
                        horas: 6
                    },
                    {
                        data: new Date(2016, 10, 28),
                        horas: 6
                    },
                    {
                        data: new Date(2016, 10, 31),
                        horas: 6
                    },
                    {
                        data: new Date(2016, 11, 1),
                        horas: 6
                    },
                    {
                        data: new Date(2016, 11, 3),
                        horas: 6
                    },
                    {
                        data: new Date(2016, 11, 4),
                        horas: 6
                    },
                    {
                        data: new Date(2016, 11, 7),
                        horas: 6
                    },
                    {
                        data: new Date(2016, 11, 8),
                        horas: 6
                    },
                    {
                        data: new Date(2016, 11, 9),
                        horas: 6
                    }
                    ]
                }, {
                    identificador: 1,
                    nome: "Luis",
                    totalHoras: 0,
                    dias: [{
                        data: new Date(2016, 10, 26),
                        horas: 6
                    },
                    {
                        data: new Date(2016, 10, 27),
                        horas: 6
                    },
                    {
                        data: new Date(2016, 10, 28),
                        horas: 6
                    },
                    {
                        data: new Date(2016, 10, 31),
                        horas: 6
                    },
                    {
                        data: new Date(2016, 11, 1),
                        horas: 6
                    },
                    {
                        data: new Date(2016, 11, 3),
                        horas: 6
                    },
                    {
                        data: new Date(2016, 11, 4),
                        horas: 6
                    },
                    {
                        data: new Date(2016, 11, 7),
                        horas: 6
                    },
                    {
                        data: new Date(2016, 11, 8),
                        horas: 6
                    },
                    {
                        data: new Date(2016, 11, 9),
                        horas: 6
                    }
                    ]
                }, {
                    identificador: 1,
                    nome: "Tiago",
                    totalHoras: 0,
                    dias: [{
                        data: new Date(2016, 10, 26),
                        horas: 6
                    },
                    {
                        data: new Date(2016, 10, 27),
                        horas: 6
                    },
                    {
                        data: new Date(2016, 10, 28),
                        horas: 6
                    },
                    {
                        data: new Date(2016, 10, 31),
                        horas: 6
                    },
                    {
                        data: new Date(2016, 11, 1),
                        horas: 6
                    },
                    {
                        data: new Date(2016, 11, 3),
                        horas: 6
                    },
                    {
                        data: new Date(2016, 11, 4),
                        horas: 6
                    },
                    {
                        data: new Date(2016, 11, 7),
                        horas: 6
                    },
                    {
                        data: new Date(2016, 11, 8),
                        horas: 6
                    },
                    {
                        data: new Date(2016, 11, 9),
                        horas: 6
                    }
                    ]
                }]
            };
        };

        function _defineCoresBacklogHistoricoSituacao() {
            return [{
                codigo: 9,
                legendaSelecionada: false,
                descricao: "Homologada",
                descricaoFiltro: "Homologada",
                cor: "#008000",
                situacaoPositiva: true
            },
            {
                codigo: 13,
                legendaSelecionada: false,
                descricao: "Erro",
                descricaoFiltro: "Retorno de Erro",
                cor: "#FF0000",
                situacaoPositiva: true
            },
            {
                codigo: 12,
                legendaSelecionada: false,
                descricao: "Melhoria",
                descricaoFiltro: "Retorno por Melhoria",
                cor: "#FFA500",
                situacaoPositiva: true
            },
            {
                codigo: [11, 14],
                legendaSelecionada: false,
                descricao: "Pausa",
                descricaoFiltro: "Pausa",
                cor: "#33CCFF",
                situacaoPositiva: true
            },
            {
                codigo: 8,
                legendaSelecionada: false,
                descricao: "Teste",
                descricaoFiltro: "Em teste",
                cor: "#800080",
                situacaoPositiva: true
            },
            {
                codigo: 7,
                legendaSelecionada: false,
                descricao: "Lib. para teste",
                descricaoFiltro: "Liberada para Teste",
                cor: "#808080",
                situacaoPositiva: true
            },
            {
                codigo: 6,
                legendaSelecionada: false,
                descricao: "Desenvolvimento",
                descricaoFiltro: "Em desenvolvimento",
                cor: "#FFFF00",
                situacaoPositiva: true
            },
            {
                codigo: 16,
                legendaSelecionada: false,
                descricao: "Refinada",
                descricaoFiltro: "Refinada",
                cor: "#3F51B5",
                situacaoPositiva: true
            },
            {
                codigo: 17,
                legendaSelecionada: false,
                descricao: "Estimada",
                descricaoFiltro: "Estimada",
                cor: "#99CC99",
                situacaoPositiva: true
            },
            {
                codigo: -16,
                legendaSelecionada: false,
                descricao: "Histórias não refinadas",
                descricaoFiltro: "Refinada",
                cor: "#FFF",
                situacaoPositiva: false
            },
            {
                codigo: 15,
                legendaSelecionada: false,
                descricao: "Atualizada no cliente",
                descricaoFiltro: "Atualizada no cliente",
                cor: "#00FF7F",
                situacaoPositiva: true
            },
            {
                codigo: 3,
                legendaSelecionada: false,
                descricao: "Análise",
                descricaoFiltro: "Análise",
                cor: "#FFADFE",
                situacaoPositiva: true
            }
            ];
        };
    }
})();
(function () {
  'use strict';

  angular
    .module('app.factory')
    .factory('SolicitacaoFactory', SolicitacaoFactory)

  /** @ngInject */
  function SolicitacaoFactory() {
    
    var _solicitacao = {};

    return {          
      solicitacao : _solicitacao
    }
  }

}());
(function () {
    "use strict";

    angular
        .module("app.factory")
        .factory("RelatorioReajustesFactory", RelatorioReajustesFactory);

    function RelatorioReajustesFactory($translate) {

        var _filtrosReajustes = {
            tipoSituacaoContratual: "",
            tipoSituacaoFinanceira: "",
            tipoDePagamento: 1,
            ordenacao: 1,
            datas: 5,
            imposto: 0,
            comissao: 0,
            formasPagamento: [],
            clientes: [],
            solucoes: [],
            caracteristicas: [],
            motivos: [],
            produtos: [],
            segmentacoes: [],
            estados: [],
            caracteristicasANaoImprimir: [],
            executivos: [],
            tiposLicenca: [],
            tiposLicencaANaoImprimir: [],
            caracteristicasContrato: [],
            caracteristicasContratoANaoImprimir: [],
            periodoInicial: [],
            periodoFinal: [],
            tipoAgrupamento: 0,
            caracteristicasContratoItem: [],
            caracteristicasContratoItemANaoImprimir: [],
            empresasFaturamento: []
        };

        var _form = {};

        return {
            filtrosReajustes: _filtrosReajustes,
            form: _form,
            setValoresInciaisFiltroContrato: setValoresInciaisFiltroContrato,
            configurarDtOptions: configurarDtOptions
        };

        function setValoresInciaisFiltroContrato() {
            _filtrosReajustes.periodoInicial = "",
                _filtrosReajustes.periodoFinal = "",
                _filtrosReajustes.tiposLicenca = [],
                _filtrosReajustes.tiposLicencaANaoImprimir = [],
                _filtrosReajustes.clientes = [],
                _filtrosReajustes.caracteristicasContratoANaoImprimir = [],
                _filtrosReajustes.caracteristicasContrato = [],
                _filtrosReajustes.caracteristicasContratoItemANaoImprimir = [],
                _filtrosReajustes.caracteristicasContratoItem = []
        }

        function configurarDtOptions() {
            return {
                dom: ''
            };
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.factory')
        .factory('RelatorioContratosFactory', RelatorioContratosFactory);

    function RelatorioContratosFactory($translate) {

        var _filtrosContratos = {
            tipoSituacaoContratual: "",
            tipoSituacaoFinanceira: "",
            tipoDePagamento: 1,
            ordenacao: 1,
            datas: 5,
            imposto: 0,
            comissao: 0,
            formasPagamento: [],
            clientes: [],
            solucoes: [],
            caracteristicas: [],
            motivos: [],
            produtos: [],
            produtosANaoImprimir: [],
            segmentacoes: [],
            estados: [],
            caracteristicasANaoImprimir: [],
            executivos: [],
            tiposLicenca: [],
            tiposLicencaANaoImprimir: [],
            caracteristicasContrato: [],
            caracteristicasContratoANaoImprimir: [],
            tipoAgrupamento: 0,
            tipoRelatorio: 3,
            valorItem: 1,
            caracteristicasContratoItem: [],
            caracteristicasContratoItemANaoImprimir: [],
            empresasFaturamento: [],
            tipoProdutosANaoImprimir: 1,
            subitens: [],
            subitensANaoImprimir: []
        }

        var _form = {};

        return {
            filtrosContratos: _filtrosContratos,
            form: _form,
            setValoresInciaisFiltroContrato: setValoresInciaisFiltroContrato,
            configurarDtOptions: configurarDtOptions,
            definirTransleteTitulosSteps: definirTransleteTitulosSteps
        }


        function setValoresInciaisFiltroContrato() {
            _filtrosContratos.ordenacao = 1;
            _filtrosContratos.clientes = [];
            _filtrosContratos.solucoes = [];
            _filtrosContratos.caracteristicas = [];
            _filtrosContratos.produtos = [];
            _filtrosContratos.produtosANaoImprimir = [];
            _filtrosContratos.subitens = [];
            _filtrosContratos.subitensANaoImprimir = [];
            _filtrosContratos.segmentacoes = [];
            _filtrosContratos.caracteristicasANaoImprimir = [],
                _filtrosContratos.tiposLicenca = [],
                _filtrosContratos.tiposLicencaANaoImprimir = [],
                _filtrosContratos.caracteristicasContrato = [],
                _filtrosContratos.caracteristicasContratoANaoImprimir = [],
                _filtrosContratos.caracteristicasContratoItem = [],
                _filtrosContratos.caracteristicasContratoItemANaoImprimir = []
        }

        function configurarDtOptions() {
            return {
                dom: ''
            };
        }

        function definirTransleteTitulosSteps() {
            return {
                informacoesGerais: $translate.instant('RELATORIO_CONTRATOS.INFORMACOES_GERAIS'),
                clientes: $translate.instant('RELATORIO_CONTRATOS.CLIENTES'),
                software: $translate.instant('RELATORIO_CONTRATOS.SOFTWARE'),
                caracteristica: $translate.instant('RELATORIO_CONTRATOS.CARACTERISTICAS'),
                caracteristicaContrato: $translate.instant('RELATORIO_CONTRATOS.CARACTERISTICA_CONTRATO'),
                itemSegmentacao: $translate.instant('RELATORIO_CONTRATOS.ITEM_SEGMENTACAO'),
                licenca: $translate.instant('RELATORIO_CONTRATOS.LICENCA'),
                item: $translate.instant('RELATORIO_CONTRATOS.ITEM')
            };
        }

    }

})();

(function () {
    'use strict';

    angular.module('app.factory')
        .factory('RelatorioClienteFactory', RelatorioClienteFactory);

    function RelatorioClienteFactory($translate) {


        var _filtrosClientes = {
            ordem: 1,
            clienteContratual: 3,
            //clientes: [],
            solucoes: [],
            dataInicioNaoAtendidos: null,
            dataFimNaoAtendidos: null,
            dataFimRescindidos: null,
            dataInicioRescindidos: null,
            caracteristicas: [],
            produtos: [],
            segmentacoes: [],
            executivos: [],
            caracteristicasANaoImprimir: [],
            tiposLicenca: [],
            tiposLicencaANaoImprimir: [],
            estados: []
        }


        var _form = {};

        return {
            filtrosClientes: _filtrosClientes,
            form: _form,
            definirTransleteTitulosSteps: _definirTransleteTitulosSteps,
            configurarDtOptions: configurarDtOptions,
            setValoresInciaisFiltroCliente: setValoresInciaisFiltroCliente
        }

        function _definirTransleteTitulosSteps() {
            return {
                informacoesGerais: $translate.instant('Informações Gerais'),
                produtoSegmentacao: $translate.instant('Produto e Segmentação'),
                caracteristica: $translate.instant('Característica de cliente'),
                licenca: $translate.instant('Tipos de licença')
            };
        }

        function configurarDtOptions() {
            return {
                dom: ''
            };
        }


        function setValoresInciaisFiltroCliente() {
            _filtrosClientes.clienteContratual = 0;
            _filtrosClientes.ordenacao = 1;
            _filtrosClientes.imposto = 0;
            _filtrosClientes.dataInicioNaoAtendidos = null;
            _filtrosClientes.dataFimNaoAtendidos = null;
            _filtrosClientes.dataFimRescindidos = null;
            _filtrosClientes.dataInicioRescindidos = null;
            _filtrosClientes.comissao = 0;
            _filtrosClientes.solucoes = [];
            _filtrosClientes.caracteristicas = [];
            _filtrosClientes.produtos = [];
            _filtrosClientes.segmentacoes = [];
            _filtrosClientes.estados = [];
            _filtrosClientes.caracteristicasANaoImprimir = [];
            _filtrosClientes.executivos = [];
            _filtrosClientes.tiposLicenca = [];
            _filtrosClientes.tiposLicencaANaoImprimir = [];
        }


    }

})();

(function () {
    'use strict';

    angular
        .module('app.factory')
        .factory('PipelineNegocioFactory', PipelineNegocioFactory);

    function PipelineNegocioFactory($q, msUtils, RequisicaoGenericaService, Api) {

        var filtrosCard = {
            pesquisa: '',
            clientesFiltros: [],
            clientes: [],
            colaboradoresResponsaveisFiltrados: [],
            colaboradoresResponsaveis: [],
            filtrarNegocioPorDiasRestantes: null,
            produtosFiltros: [],
            produtos: [],
            valorDe: null,
            valorAte: null
        };

        var etapasFunil = [];

        var etapasFunilFiltro = {
            emProgresso: false,
            codigoFunil: null,
            codigoExecutivoContasResponsavel: [],
            codigoClientes: []
        };

        return {
            configurarCardOptions: _configurarCardOptions,
            carregarClientesEColaboradoresResponsaveis: _carregarClientesEColaboradoresResponsaveis,
            exibirButtonLimparFiltros: _exibirButtonLimparFiltros,
            limparFiltrosCard: _limparFiltrosCard,
            limparFiltrosCardRedefinindoEtapasFunil: _limparFiltrosCardRedefinindoEtapasFunil,
            carregarEtapasFunil: _carregarEtapasFunil,
            redefinirEtapasFunilFiltro: _redefinirEtapasFunilFiltro,
            pesquisarEtapasFunil: _pesquisarEtapasFunil,
            filtrosCard: filtrosCard,
            etapasFunil: etapasFunil,
            etapasFunilFiltro: etapasFunilFiltro,
            filtrarNegociosPorProduto: _filtrarNegociosPorProduto
        }

        function _configurarCardOptions() {
            return {
                appendTo: 'body',
                connectWith: '.list-cards',
                delay: 75,
                distance: 7,
                forceHelperSize: true,
                forcePlaceholderSize: true,
                handle: msUtils.isMobile() ? '.list-card-sort-handle' : false,
                helper: function (event, el) {
                    return el.clone().addClass('list-card-sort-helper');
                },
                placeholder: 'list-card card-sortable-placeholder',
                tolerance: 'pointer',
                scroll: true,
                sort: function (event, ui) {
                    var listContentEl = ui.placeholder.closest('.list-content');
                    var boardContentEl = ui.placeholder.closest('.board');

                    if (listContentEl) {
                        var listContentElHeight = listContentEl[0].clientHeight,
                            listContentElScrollHeight = listContentEl[0].scrollHeight;

                        if (listContentElHeight !== listContentElScrollHeight) {
                            var itemTop = ui.position.top,
                                itemBottom = itemTop + ui.item.height(),
                                listTop = listContentEl.offset().top,
                                listBottom = listTop + listContentElHeight;

                            if (itemTop < listTop + 25) {
                                listContentEl.scrollTop(listContentEl.scrollTop() - 25);
                            }

                            if (itemBottom > listBottom - 25) {
                                listContentEl.scrollTop(listContentEl.scrollTop() + 25);
                            }
                        }
                    }

                    if (boardContentEl && boardContentEl[0]) {
                        var boardContentElWidth = boardContentEl[0].clientWidth;
                        var boardContentElScrollWidth = boardContentEl[0].scrollWidth;

                        if (boardContentElWidth !== boardContentElScrollWidth) {
                            var itemLeft = ui.position.left,
                                itemRight = itemLeft + ui.item.width(),
                                boardLeft = boardContentEl.offset().left,
                                boardRight = boardLeft + boardContentElWidth;

                            if (itemLeft < boardLeft + 25) {
                                boardContentEl.scrollLeft(boardContentEl.scrollLeft() - 25);
                            }

                            if (itemRight > boardRight) {
                                boardContentEl.scrollLeft(boardContentEl.scrollLeft() + 25);
                            }
                        }
                    }
                }
            }
        }

        function _carregarClientesEColaboradoresResponsaveis(etapasFunil) {
            var clientesFiltradosAntigos = angular.copy(filtrosCard.clientesFiltros);
            var colaboradoresFiltradosAntigos = angular.copy(filtrosCard.colaboradoresResponsaveisFiltrados);

            filtrosCard.clientes = [];
            filtrosCard.colaboradoresResponsaveis = [];

            etapasFunil.forEach(function (etapa) {
                etapa.negocios.forEach(function (negocio) {

                    if (!filtrosCard.clientes.find(function (item) {
                        return !item || item.nomeCliente.indexOf(negocio.nomeCliente) == -1 ? undefined : item;
                    })) {
                        filtrosCard.clientes.push(
                            {
                                nomeCliente: negocio.nomeCliente,
                                codigoCliente: negocio.codigoCliente,
                            }
                        );
                    }

                    if (!filtrosCard.colaboradoresResponsaveis.find(function (item) {
                        return !item || item.nomeColaboradorResponsavel.indexOf(negocio.nomeColaboradorResponsavel) == -1 ? undefined : item;
                    })) {
                        filtrosCard.colaboradoresResponsaveis.push(
                            {
                                nomeColaboradorResponsavel: negocio.nomeColaboradorResponsavel,
                                codigoExecutivoContasResponsavel: negocio.codigoExecutivoContasResponsavel,
                            }
                        );
                    }
                });
            });

            _carregarProdutosUnicos(etapasFunil);
        }

        function _carregarProdutosUnicos(etapasFunil) {
            var produtosMap = {};
            filtrosCard.produtos = [];
            etapasFunil.forEach(function (etapa) {
                etapa.negocios.forEach(function (negocio) {
                    if (Array.isArray(negocio.produtos)) {
                        negocio.produtos.forEach(function (produto) {
                            if (produto && produto.codigo && !produtosMap[produto.codigo]) {
                                produtosMap[produto.codigo] = true;
                                filtrosCard.produtos.push({
                                    codigo: produto.codigo,
                                    descricao: produto.descricao
                                });
                            }
                        });
                    }
                });
            });
            filtrosCard.produtos.sort(function (a, b) {
                return a.descricao.localeCompare(b.descricao);
            });
        }

        function _exibirButtonLimparFiltros() {
            if (
                filtrosCard.clientesFiltros.length > 0 ||
                filtrosCard.colaboradoresResponsaveisFiltrados.length > 0 ||
                filtrosCard.filtrarNegocioPorDiasRestantes ||
                filtrosCard.produtosFiltros.length > 0 ||
                filtrosCard.valorDe != null ||
                filtrosCard.valorAte != null
            )
                return true;
            else
                return false;
        }

        function _limparFiltrosCard() {
            filtrosCard.pesquisa = '';
            filtrosCard.clientesFiltros = []
            filtrosCard.colaboradoresResponsaveisFiltrados = [];
            filtrosCard.filtrarNegocioPorDiasRestantes = null;
            filtrosCard.produtosFiltros = [];
            filtrosCard.valorDe = null;
            filtrosCard.valorAte = null;

            etapasFunilFiltro.codigoClientes = [];
            etapasFunilFiltro.codigoExecutivoContasResponsavel = [];
        }

        function _limparFiltrosCardRedefinindoEtapasFunil() {
            _limparFiltrosCard();
            _pesquisarEtapasFunil(etapasFunilFiltro).then(
                function (success) {
                    _carregarClientesEColaboradoresResponsaveis(success.data);
                });
        }

        function _carregarEtapasFunil(etapasFunilParam) {
            etapasFunil.splice(0, etapasFunil.length);
            etapasFunilParam.map(function (item) {
                etapasFunil.push(item);
            });
        }

        function _redefinirEtapasFunilFiltro() {
            etapasFunilFiltro.emProgresso = false;
            etapasFunilFiltro.codigoFunil = null;
            etapasFunilFiltro.codigoExecutivoContasResponsavel = [];
            etapasFunilFiltro.codigoClientes = [];
        }

        function _pesquisarEtapasFunil(etapasFunilParam) {
            etapasFunilFiltro.emProgresso = true;
            return $q(function (resolve, reject) {
                RequisicaoGenericaService.listarComParams(Api.pipeline.pipeline_negocio.listarEtapasFunil, etapasFunilParam).then(
                    function (success) {
                        etapasFunilFiltro.emProgresso = false;
                        _carregarEtapasFunil(success.data);
                        resolve(success)
                    },
                    function (error) {
                        etapasFunilFiltro.emProgresso = false;
                        ServicosGenericoService.exibirAlertaDeErro(error, null);
                        reject(error);
                    });
            });
        }

        function _filtrarNegociosPorProduto() {
            var etapas = etapasFunil;
            if (filtrosCard.produtosFiltros && filtrosCard.produtosFiltros.length > 0) {
                var codigosProdutosSelecionados = filtrosCard.produtosFiltros.map(function (p) { return p.codigo; });
                etapas = etapas.map(function (etapa) {
                    var negociosFiltrados = etapa.negocios.filter(function (negocio) {
                        if (!negocio.produtos || negocio.produtos.length === 0) return false;
                        return negocio.produtos.some(function (produto) {
                            return codigosProdutosSelecionados.indexOf(produto.codigo) !== -1;
                        });
                    });
                    return angular.extend({}, etapa, { negocios: negociosFiltrados });
                });
            }
            var valorDe = filtrosCard.valorDe;
            var valorAte = filtrosCard.valorAte;

            var isPreenchido = function (v) {
                var num = Number(v);
                return v !== null && v !== undefined && v !== '' && !isNaN(num) && num !== 0;
            };
            if (isPreenchido(valorDe) || isPreenchido(valorAte)) {
                etapas = etapas.map(function (etapa) {
                    var negociosFiltrados = etapa.negocios.filter(function (negocio) {
                        var valor = Number(negocio.valor);
                        var de = isPreenchido(valorDe) ? Number(valorDe) : null;
                        var ate = isPreenchido(valorAte) ? Number(valorAte) : null;
                        if (de !== null && ate !== null) {
                            return valor >= de && valor <= ate;
                        } else if (de !== null) {
                            return valor >= de;
                        } else if (ate !== null) {
                            return valor <= ate;
                        }
                        return true;
                    });
                    return angular.extend({}, etapa, { negocios: negociosFiltrados });
                });
            }
            return etapas;
        }
    }

})();
/**
 * Created by nova on 29/09/2016.
 */
(function () {
    'use strict';

    angular
        .module('app.service')
        .factory("MenuFactory", MenuFactory);

    function MenuFactory($q, $rootScope, $state, MdDialogService, msNavigationService, RequisicaoGenericaService, Api, LocalStorageService, ControleAcessoConfig) {

        var _menuAcessivel = false;
        var _metodosInterno = {
            _construirMenusEmArvore: _construirMenusEmArvore,
            _construirSubMenus: _construirSubMenus,
            _construirMenuApp: _construirMenuApp,
            _construirMenuDesenvolvimento: _construirMenuDesenvolvimento,
            _construirMenuControleAcessoMenu: _construirMenuControleAcessoMenu,
            _verificarSeMenuEAcessivelMenuEmArvore: _verificarSeMenuEAcessivelMenuEmArvore,
            _removerTodosMenusEmArvore: _removerTodosMenusEmArvore
        }

        return {
            listarMenus: listarMenus,
            atualizarMenus: atualizarMenus,
            recarregarMenus: recarregarMenus,
            construirMenuSeUsuarioTerAcesso: construirMenuSeUsuarioTerAcesso,
            navegarParaEstadoSeUsuarioTerAcesso: navegarParaEstadoSeUsuarioTerAcesso,
            navegarParaOutrabaSeUsuarioTerAcesso: navegarParaOutrabaSeUsuarioTerAcesso,
            verificarSeUsuarioTemAcessoAoMenu: verificarSeUsuarioTemAcessoAoMenu,
            removeTodosMenus: removeTodosMenus,
            construirMenusemVerificacao: construirMenusemVerificacao
        }

        //#region  Métodos Internos

        function _construirMenu(menuNavegacao, titulo, icone, estado, peso, grupo, badge, parametrosEstado) {
            var navegacao = {
                menuNavegacao: menuNavegacao != undefined || menuNavegacao != null ? menuNavegacao : "",
                titulo: titulo != undefined || titulo != null ? titulo : "",
                icone: icone != undefined || icone != null ? icone : "",
                estado: estado != undefined || estado != null ? estado : "",
                peso: peso != undefined || peso != null ? peso : 0,
                grupo: grupo != undefined || grupo != null ? grupo : false,
                badge: badge != undefined || badge != null ? badge : null,
                parametrosEstado: parametrosEstado != undefined || parametrosEstado != null ? parametrosEstado : null
            }

            msNavigationService.saveItem(navegacao.menuNavegacao, {
                title: navegacao.titulo,
                icon: navegacao.icone,
                state: navegacao.estado,
                weight: navegacao.peso,
                group: navegacao.grupo,
                badge: navegacao.badge,
                stateParams: navegacao.parametrosEstado
            });
        }

        function _construirMenusEmArvore(menu) {
            var deferred = $q.defer();
            if (menu) {
                LocalStorageService.armazenar(LocalStorageService.chavesLocalStorage.menus, menu);

                _construirMenu(menu.navegacao, menu.menuDetalhe.titulo, menu.menuDetalhe.icone, menu.menuDetalhe.estado, menu.menuDetalhe.peso, menu.menuDetalhe.grupo)
                if (menu.subMenus)
                    _construirSubMenus(menu.subMenus);
            }

            _construirMenuApp();
            _construirMenuDesenvolvimento();
            _construirMenuControleAcessoMenu();

            deferred.resolve("Finalizado");
            return deferred.promise;
        }

        function _construirSubMenus(subMenu) {
            if (subMenu) {
                subMenu.forEach(function (item, index) {
                    _construirMenu(item.navegacao, item.menuDetalhe.titulo, item.menuDetalhe.icone, item.menuDetalhe.estado, item.menuDetalhe.peso, item.menuDetalhe.grupo)
                    if (item.subMenus)
                        _construirSubMenus(item.subMenus);
                });
            }
        }

        function _construirMenuApp() {
            _construirMenu('app', 'IManager', '', '', 0, true);
        }

        function _construirMenuDesenvolvimento() {
            if (ControleAcessoConfig.usuarioEDesenvolvimento()) {
                _construirMenu('app.cadastromenu', 'Menus Aplicação', 'icon-menu', 'app.cadastro_menu', 9998, false);
            }
        }

        function _construirMenuControleAcessoMenu() {
            if (ControleAcessoConfig.usuarioEAdministradorSistema()) {
                _construirMenu('app.controleacessomenu', 'Controle Acesso Menus', 'icon-menu', 'app.controleacessomenu', 9999, false);
                _construirMenu('app.geral.cadastro.usuario', 'Colaborador', '', '', 9999, false);
                _construirMenu('app.geral.cadastro.usuario.usuario', 'Colaborador', '', 'app.geral_cadastro_usuario_usuario', 1, false);
                _construirMenu('app.geral.cadastro.usuario.perfil', 'Perfil', '', 'app.geral_cadastro_usuario_perfil', 2, false);
                _construirMenu('app.geral.cadastro.usuario.setor', 'Setor', '', 'app.geral_cadastro_usuario_setor', 3, false);
            }
        }

        function _verificarSeMenuEAcessivelMenuEmArvore(menus, navegacaoOuEstado) {
            if (!menus || !menus[0])
                return _menuAcessivel;


            for (var i = 0; i < menus.length; i++) {
                if (menus[i].navegacao == navegacaoOuEstado || menus[i].menuDetalhe.estado == navegacaoOuEstado) {
                    _menuAcessivel = true;
                    break;
                }
                else if (_menuAcessivel)
                    break;
                else if (menus[i].subMenus)
                    _verificarSeMenuEAcessivelMenuEmArvore(menus[i].subMenus, navegacaoOuEstado);
            }
            return _menuAcessivel;
        }

        function _removerTodosMenusEmArvore(menus) {
            if (!menus || !menus[0])
                return _menuAcessivel;

            for (var i = 0; i < menus.length; i++) {
                if (menus[i].navegacao)
                    msNavigationService.deleteItem(menus[i].navegacao);

                if (menus[i].subMenus)
                    _removerTodosMenusEmArvore(menus[i].subMenus);
            }
        }

        //#endregion

        //#region Métodos

        function listarMenus(codigoUsuario, codigoPerfil) {
            var deferred = $q.defer();
            RequisicaoGenericaService.listarSemParams(Api.controle_acesso_menu.listarMenusPorPerfil + codigoUsuario + '/' + codigoPerfil
            ).then(
                function (success) {
                    deferred.resolve(success);
                    _construirMenusEmArvore(success.data)
                },
                function (error) {
                    deferred.reject(error);
                });

            return deferred.promise;
        }

        function atualizarMenus(menu) {
            _construirMenusEmArvore(menu);
        }

        function recarregarMenus() {
            var menus = LocalStorageService.recuperar(LocalStorageService.chavesLocalStorage.menus);
            return _construirMenusEmArvore(menus);
        }

        function construirMenuSeUsuarioTerAcesso(menu) {
            _menuAcessivel = false;
            var menus = [LocalStorageService.recuperar(LocalStorageService.chavesLocalStorage.menus)];

            if (_verificarSeMenuEAcessivelMenuEmArvore(menus, menu.menuNavegacao)) {
                _construirMenu(menu.menuNavegacao, menu.titulo, menu.icone, menu.estado, menu.peso, menu.grupo, menu.badge, menu.parametrosEstado);
            }
        }

        function construirMenusemVerificacao(menu) {
            console.log('menu: ', menu);
            _construirMenu(menu.menuNavegacao, menu.titulo, menu.icone, menu.estado, menu.peso, menu.grupo, menu.badge, menu.parametrosEstado);

        }

        function navegarParaEstadoSeUsuarioTerAcesso(estado, parametros) {
            _menuAcessivel = false;
            var menus = [LocalStorageService.recuperar(LocalStorageService.chavesLocalStorage.menus)];

            if (_verificarSeMenuEAcessivelMenuEmArvore(menus, estado)) {
                $state.go(estado, parametros);
            }
            else {
                MdDialogService.alertPadrao("Acesso negado.\nSeu perfil não possui acesso ao menu solicitado.", null, null);
            }
        }

        function navegarParaOutrabaSeUsuarioTerAcesso(estado, parametros) {
            _menuAcessivel = false;
            var menus = [LocalStorageService.recuperar(LocalStorageService.chavesLocalStorage.menus)];

            if (_verificarSeMenuEAcessivelMenuEmArvore(menus, estado)) {
                $state.goNewTab(estado, parametros);
            }
            else {
                MdDialogService.alertPadrao("Acesso negado.\nSeu perfil não possui acesso ao menu solicitado.", null, null);
            }
        }

        function verificarSeUsuarioTemAcessoAoMenu(navegacaoOuEstado) {
            _menuAcessivel = false;
            var menus = [LocalStorageService.recuperar(LocalStorageService.chavesLocalStorage.menus)];

            return _verificarSeMenuEAcessivelMenuEmArvore(menus, navegacaoOuEstado);
        }

        function removeTodosMenus() {
            var menus = [LocalStorageService.recuperar(LocalStorageService.chavesLocalStorage.menus)];

            return _removerTodosMenusEmArvore(menus);
        }


        //#endregion
    }

})();

(function () {
  'use strict';

  angular
    .module('app.factory')
    .factory('MensageiroFactory', MensageiroFactory);

  function MensageiroFactory() {
    var _modelMensageiro = {
      departamentosSelecionados: []
    };

    return {
      modelMensageiro: _modelMensageiro
    };

  }

})();

(function () {
    'use strict';

    angular
        .module('app.factory')
        .factory('InterceptorRequestFactory', InterceptorRequestFactory);

    function InterceptorRequestFactory($q, $injector, $rootScope) {
        return {
            request: function (config) {
                if (navigator.onLine)
                    return config;
                else {
                    if (!$rootScope.interceptorRequestError.disconnected) {
                        $rootScope.interceptorRequestError.disconnected = true;

                        $injector.get('MdDialogService').alertPadraoComEvento("Não foi possível fazer a requisição para o servidor" +
                            " Por favor verifique sua conexão com a internet.",
                            function () {
                                $rootScope.interceptorRequestError.disconnected = false;
                            });
                    }
                    return config
                }
            },
            requestError: function (rejection) {
                return $q.reject(rejection);
            },
            response: function (response) {
                return response
            },
            responseError: function (rejection) {

                if (rejection && (rejection.status === 401 || rejection.status === 403)) {

                    if (!$rootScope.interceptorRequestError.unauthorizedError) {
                        $rootScope.interceptorRequestError.unauthorizedError = true;

                        $injector.get('MdDialogService').alertPadraoComEvento("A autenticação com o servidor foi perdida, você foi redirecionado para a tela de login para se autenticar novamente.",
                            function () {
                                $injector.get('$state').go('app.login');
                                $rootScope.interceptorRequestError.unauthorizedError = false;
                            });
                    }

                }
                else {
                    return $q.reject(rejection);
                }
            }
        };
    }

})();

(function () {
    'use strict';

    angular
        .module('app.factory')
        .factory('ImplantacaoMigracaoFactory', ImplantacaoMigracaoFactory);

    function ImplantacaoMigracaoFactory(msUtils) {

        var subprocesso = {
            codigoProcesso: null,
            codigoCliente: null,
            produtos: [],
            codigoExecutivoContasResponsavel: null,
            codigoTecnicoResponsavel: null,
            status: null,
            codigoTarefaAtual: null,
            dataInicial: '',
            dataFinalTarefa: '',
            codigoAtendimento: null,
            anoAtendimento: null,
            observacao: '',
            subprocessoHistorico: []
        }

        // Etapas funil que irá sempre variar com os filtros 
        var tarefasProcesso = [];


        var tarefasProcessoFiltro = {
            emProgresso: false,
            codigoProcesso: null,
            codigoExecutivoContasResponsavel: [],
            codigoClientes: []
        };

        return {
            configurarCardOptions: _configurarCardOptions,
            carregarTarefasProcesso: _carregarTarefasProcesso,
            tarefasProcesso: tarefasProcesso,
            tarefasProcessoFiltro: tarefasProcessoFiltro,
            subprocesso: subprocesso
        }

        function _configurarCardOptions() {
            return {
                appendTo: 'body',
                connectWith: '.list-cards',
                delay: 75,
                distance: 7,
                forceHelperSize: true,
                forcePlaceholderSize: true,
                handle: msUtils.isMobile() ? '.list-card-sort-handle' : false,
                helper: function (event, el) {
                    return el.clone().addClass('list-card-sort-helper');
                },
                placeholder: 'list-card card-sortable-placeholder',
                tolerance: 'intersect',
                scroll: true,
                sort: function (event, ui) {
                    var listContentEl = ui.placeholder.closest('.list-content');
                    var boardContentEl = ui.placeholder.closest('.board');

                    if (listContentEl) {
                        var listContentElHeight = listContentEl[0].clientHeight,
                            listContentElScrollHeight = listContentEl[0].scrollHeight;

                        if (listContentElHeight !== listContentElScrollHeight) {
                            var itemTop = ui.position.top,
                                itemBottom = itemTop + ui.item.height(),
                                listTop = listContentEl.offset().top,
                                listBottom = listTop + listContentElHeight;

                            if (itemTop < listTop + 25) {
                                listContentEl.scrollTop(listContentEl.scrollTop() - 25);
                            }

                            if (itemBottom > listBottom - 25) {
                                listContentEl.scrollTop(listContentEl.scrollTop() + 25);
                            }
                        }
                    }

                    if (boardContentEl && boardContentEl[0]) {
                        var boardContentElWidth = boardContentEl[0].clientWidth;
                        var boardContentElScrollWidth = boardContentEl[0].scrollWidth;

                        if (boardContentElWidth !== boardContentElScrollWidth) {
                            var itemLeft = ui.position.left,
                                itemRight = itemLeft + ui.item.width(),
                                boardLeft = boardContentEl.offset().left,
                                boardRight = boardLeft + boardContentElWidth;

                            if (itemLeft < boardLeft + 25) {
                                boardContentEl.scrollLeft(boardContentEl.scrollLeft() - 25);
                            }

                            if (itemRight > boardRight) {
                                boardContentEl.scrollLeft(boardContentEl.scrollLeft() + 25);
                            }
                        }
                    }
                }
            }
        }

        function _carregarTarefasProcesso(tarefasProcessoParam) {
            tarefasProcesso.splice(0, tarefasProcesso.length);
            tarefasProcessoParam.map(function (item) {
                tarefasProcesso.push(item);
            });
        }
    }

})();

(function () {
    'use strict';

    angular
        .module('app.factory')
        .factory('EstoriaFactory', EstoriaFactory);

    function EstoriaFactory(DataTableConfigPadrao, LoginUsuarioService, MdDialogService, ServicosGenericoService, RotasHtml) {

        return {
            htmlRota: _htmlRota,
            setColumnsDefsDtOptionsTabEstoria: _setColumnsDefsDtOptionsTabEstoria,
            setDtOptionsTabEstimativa: _setDtOptionsTabEstimativa,
            setColumnsDefsDtOptionsTabPriorizacao: _setColumnsDefsDtOptionsTabPriorizacao,
            setDtOptionsTabTarefa: _setDtOptionsTabTarefa,
            setColumnsDefsDtOptionsTabTarefa: _setColumnsDefsDtOptionsTabTarefa,
            setColumnsDefsEstoriaTarefasPorRotinas_tarefas: _setColumnsDefsEstoriaTarefasPorRotinas_tarefas,
            setColumnsDefsEstoriaHistoricoSituacao: _setColumnsDefsEstoriaHistoricoSituacao,
            defineVariaveisControladorasDoSprint: _defineVariaveisControladorasDaEstoria,
            retornaTemplatesEstoriaTarefa: _retornaTemplatesEstoriaTarefa,
            predefinirCamposParaInserirEstoria: _predefinirCamposParaInserirEstoria,
            defineValoresPriorizacaoDificuldade: _defineValoresPriorizacaoDificuldade,
            defineValoresPriorizacaoOrigem: _defineValoresPriorizacaoOrigem,
            defineValoresPriorizacaoCriticidade: _defineValoresPriorizacaoCriticidade,
            retornaCodigoCustoSoftwareDefault: _retornaCodigoCustoSoftwareDefault,
            coresSituacoes: _defineCoresHistoricoSituacao
        }

        function _htmlRota() {
            return RotasHtml.estoria;
        }

        function _setColumnsDefsDtOptionsTabEstoria() {
            return [
                {
                    targets: 0,
                    ordering: false,
                    filterable: true,
                    sortable: false
                },
                {
                    targets: 3,
                    type: 'date-pt-br'
                },
                {
                    targets: 4,
                    type: 'date-pt-br'
                }
            ];
        }

        function _setDtOptionsTabEstimativa() {
            return {
                dom: 'rt<"bottom"<"left"<"info"i>>>',
                responsive: true,
                initComplete: function () {
                    var api = this.api(),
                        searchBox = angular.element('body').find('#pesquisar');

                    // Bind an external input as a table wide search box
                    if (searchBox.length > 0) {
                        searchBox.on('keyup', function (event) {
                            api.search(event.target.value).draw();
                        });
                    }
                },
                paging: false,
                order: [[0, "desc"]]
            }
        }

        function _setColumnsDefsDtOptionsTabPriorizacao() {
            return [
                {
                    targets: 0,
                    order: function () {
                        console.log("AWE")
                    }
                },
            ]
        }

        /**
         * Método que constroi as configurações da tabela
         * @param {number} parametroColunaPontos Coluna de pontos não obrigatório
         * @param {number} parametroColunaHoras Coluna de horas não obrigatório
         */
        function _setDtOptionsTabTarefa(parametroColunaPontos, parametroColunaHoras) {
            var colunaPontos, colunaHoras;

            /**
             * Verifica se a coluna foi definida como parâmetro, caso tenha sido definida os somatórios de pontos
             * e horas são realizados em cimas das colunas passadas como parâmetro, se não as colunas padrões são:
             * coluna de pontos = 3
             * coluna de horas = 4
             */
            if (parametroColunaPontos)
                colunaPontos = parametroColunaPontos;
            else
                colunaPontos = 3;

            return {
                dom: 'rt<"bottom"<"left"<"info"i>>>',
                initComplete: function () {
                    var api = this.api(),
                        searchBox = angular.element('body').find('#pesquisar');

                    // Bind an external input as a table wide search box
                    if (searchBox.length > 0) {
                        searchBox.on('keyup', function (event) {
                            api.search(event.target.value).draw();
                        });
                    }
                },
                footerCallback: function (row, data, start, end, display) {
                    var api = this.api();
                    var somatorioPontos = 0;
                    var regex = /([0-9]{2}:[0-9]{2})$/gm;

                    api.column(colunaPontos, {
                        page: 'current'
                    }).data()
                        .reduce(function (a, b) {
                            somatorioPontos += Number(b);
                        }, 0);

                    $(api.column(colunaPontos).footer()).html("<label>" + somatorioPontos + "</label>");


                },
                paging: false,
                responsive: true,
                order: [[2, "asc"]]
            }
        }

        function _setColumnsDefsDtOptionsTabTarefa(tiposTarefa) {
            return [
                {
                    targets: 0,
                    ordering: false,
                    filterable: true,
                    sortable: false
                },
                {
                    targets: 2,
                    render: function (data, tipo, elemento, objeto) {
                        angular.forEach(tiposTarefa, function (item, index) {
                            if (index == data) {
                                data = item;
                            }
                        });
                        return data;
                    }
                },
                {
                    targets: 5,
                    type: 'date-pt-br'
                },
                {
                    targets: 6,
                    type: 'date-pt-br'
                },
            ];
        }

        function _setColumnsDefsEstoriaTarefasPorRotinas_tarefas() {
            return [
                {
                    targets: 0,
                    ordering: false,
                    filterable: false,
                    sortable: false
                },
                {
                    targets: 3,
                    ordering: false,
                    filterable: false,
                    sortable: false
                },
                {
                    targets: 5,
                    filterable: false,
                    render: function (data, type) {
                        if (type === 'display') {
                            if (data === 'true') {
                                return '<i class="icon-checkbox-marked-circle green-500-fg"></i>';
                            }

                            return '<i class="icon-cancel red-500-fg"></i>';
                        }
                        if (type === 'filter') {
                            if (data) {
                                return '1';
                            }
                            return '0';
                        }
                        return data;
                    }
                }
            ];
        }

        function _setColumnsDefsEstoriaHistoricoSituacao() {
            return [
                {
                    targets: 0,
                    ordering: false,
                    filterable: false,
                    sortable: false,
                },
                {
                    targets: 3,
                    type: 'date-pt-br'
                },
            ]
        }

        function _defineVariaveisControladorasDaEstoria() {
            return {
                editarEstimativa: false,
                editarPriorizacao: false,
                editarTarefas: false,
                editarHistorico: false,
                editarRequisito: false,
                editarClientesVinculados: false
            };
        }

        function _retornaTemplatesEstoriaTarefa() {
            return [
                {
                    view: 'viewTabelaTarefasDaEstoria',
                    url: _htmlRota().tabTarefa.viewDeTarefas
                },
                {
                    view: 'viewParaCriarTarefasPorRotinas',
                    url: _htmlRota().tabTarefa.viewParaCriarTarefasPorRotinas
                }];
        }

        function _predefinirCamposParaInserirEstoria(controleForm, listaCustoSoftware, parametrosSolicitacao) {
            var dataAtual = new Date();
            var dataFutura = new Date(dataAtual.getFullYear(), dataAtual.getMonth(), dataAtual.getDate() + 30);
            var resultado = {
                codigoCustoSoftware: _retornaCodigoCustoSoftwareDefault(listaCustoSoftware),
                numero: null,
                ano: dataAtual.getFullYear(),
                dataEntrada: new Date(dataAtual),
                dataEntrega: new Date(dataFutura),
                usuarioCodigoAbertura: LoginUsuarioService.usuarioArmazenado().codigo,
                permitirConsultaExterna: true
            };

            if (parametrosSolicitacao) {
                resultado.origem = parametrosSolicitacao.origem.toString();
                resultado.solucaoCodigo = parametrosSolicitacao.solucaoCodigo;
                resultado.atendimento = parametrosSolicitacao.atendimento ? parametrosSolicitacao.atendimento : null;
            }

            return resultado;
        }

        function _retornaCodigoCustoSoftwareDefault(listaCustoSoftware) {
            var item = listaCustoSoftware.find(function (item) {
                if (item.descricao && item.descricao.toLowerCase() == "história")
                    return item;
            });

            if (angular.equals(undefined, item) || angular.equals(null, item))
                return 0;

            return item.codigo;
        }

        function _defineValoresPriorizacaoDificuldade() {
            return [
                {
                    descricao: "Fácil",
                    valor: 1
                },
                {
                    descricao: "Médio",
                    valor: 3
                },
                {
                    descricao: "Dificil",
                    valor: 5
                },
                {
                    descricao: "Muito Dificil",
                    valor: 7
                }
            ];
        }

        function _defineValoresPriorizacaoOrigem() {
            return [
                {
                    descricao: "Melhoria/Ajuste",
                    valor: 1
                },
                {
                    descricao: "Implementação",
                    valor: 3
                },
                {
                    descricao: "Erro",
                    valor: 5
                }
            ];
        }

        function _defineValoresPriorizacaoCriticidade() {
            return [
                {
                    descricao: "Baixa",
                    valor: 1
                },
                {
                    descricao: "Normal",
                    valor: 3
                },
                {
                    descricao: "Alta",
                    valor: 5
                },
                {
                    descricao: "Urgência",
                    valor: 7
                }
            ];
        }

        function _defineCoresHistoricoSituacao() {
            return [{
                codigo: 1,
                descricao: "Solicitação",
                cor: "#FFF"
            },
            {
                codigo: 2,
                descricao: "Cancelada",
                cor: "#AA0000"
            },
            {
                codigo: 3,
                descricao: "Análise",
                cor: "#FFF"
            },
            {
                codigo: 6,
                descricao: "Desenvolvimento",
                cor: "#FFC100"
            },
            {
                codigo: 7,
                descricao: "Lib. para teste",
                cor: "#808080"
            },
            {
                codigo: 8,
                descricao: "Teste",
                cor: "#800080"
            },
            {
                codigo: 9,
                descricao: "Homologada",
                cor: "#008000"
            },
            {
                codigo: 11,
                descricao: "Pausa no desenvolvimento",
                cor: "#33CCFF"
            },
            {
                codigo: 12,
                descricao: "Melhoria",
                cor: "#FFA500"
            },
            {
                codigo: 13,
                descricao: "Erro",
                cor: "#FF0000"
            },
            {
                codigo: 14,
                descricao: "Pausa no teste",
                cor: "#33CCFF"
            },
            {
                codigo: 15,
                descricao: "Atualizada no cliente",
                cor: "#00FF7F"
            },
            {
                codigo: 16,
                descricao: "Refinada",
                cor: "#3F51B5"
            },
            {
                codigo: 17,
                descricao: "Estimada",
                cor: "#99CC99"
            },
            {
                codigo: -16,
                descricao: "Histórias não refinadas",
                cor: "#C0C0C0"
            }
            ];
        }
    }

})();

(function () {
    'use strict';

    angular
        .module('app.factory')
        .factory('DatatableLocacaoFactory',DatatableLocacaoFactory);

    function DatatableLocacaoFactory(urlApi,$q,LocalStorageService,TokenService) {

        var _tabela;
        var _converterEntidadePesquisaParaJson = false;
        var _quantidadeItensPorPagina = LocalStorageService.recuperar(LocalStorageService.chavesLocalStorage.tamanhoPaginaDatatable);

        function construirButtonSelecionar(td,col,icone) {
            var iconeUtilizado = icone ? icone : "icon-pencil";
            return $q(function (resolve) {
                $(td).html(
                    '<i id=acao-selecionar' + col + ' class="' + iconeUtilizado + ' s16 icone-cor-padrao" ng-click="" ng-disabled=""> </i>'
                );
                resolve('ok');
            });
        }

        function construirDtOptionsComPaginacaoResponsivoPadrao(definicaoColunas) {
            return {
                dom: 'rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
                initComplete: function () {
                    var api = this.api(),
                        searchBox = angular.element('body').find('#pesquisar');

                    // Bind an external input as a table wide search box
                    if (searchBox.length > 0) {
                        searchBox.on('keyup',function (event) {
                            api.search(event.target.value).draw();
                        });
                    }
                },
                drawCallback: function () {
                    var api = this.api();
                    if (api && (tamanhoPaginaDatatable() != api.page.info().length)) {
                        armazenarTamanhoPaginaDatatable(api.page.info().length);
                    }
                },
                pagingType: 'numbers',
                lengthMenu: [10,30,50,100],
                pageLength: _quantidadeItensPorPagina,
                responsive: true,
                columnDefs: definicaoColunas
            }
        }

        function construirDtOptionsComPaginacaoProcessadoNoServidorParaToolbar(rotaApi,entidadePesquisa,idDatatable,definicaoColunas) {
            var deferred = $q.defer();

            var token = TokenService.getToken();
            var entidadeDeEnvio = angular.copy(entidadePesquisa);

            $(function () {
                _tabela = $(idDatatable).dataTable({
                    dom: 'rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
                    processing: true,
                    serverSide: true,
                    ajax: {
                        url: urlApi.url_locacao_api + rotaApi,
                        type: "POST",
                        headers: {
                            "Content-Type": "Application/Json"
                        },

                        data: function (data) {
                            if (entidadeDeEnvio && entidadeDeEnvio != {}) {
                                _converterEntidadePesquisaParaJson ?
                                    data.clsEntidade = angular.toJson(entidadeDeEnvio,false) :
                                    data.clsEntidade = angular.toJson(entidadeDeEnvio,false)
                            }
                            return angular.toJson(data);
                        },
                        dataSrc: function (json) {
                            return json.data;
                        }
                    },
                    initComplete: function () {
                        var api = this.api(),
                            searchBox = angular.element('body').find('#pesquisar');

                        // Bind an external input as a table wide search box
                        if (searchBox.length > 0) {
                            searchBox.on('keyup',function (event) {
                                api.search(event.target.value).draw();
                            });
                        }
                    },
                    drawCallback: function () {
                        var api = this.api();
                        if (api && api.page.info() && (tamanhoPaginaDatatable() != api.page.info().length))
                            armazenarTamanhoPaginaDatatable(api.page.info().length);
                    },
                    pagingType: 'numbers',
                    lengthMenu: [10,30,50,100],
                    pageLength: _quantidadeItensPorPagina,
                    responsive: true,
                    columnDefs: definicaoColunas
                });
                deferred.resolve(_tabela);
            });
            return deferred.promise;
        }

        function destruirTabela() {
            if (_tabela && _tabela.api())
                _tabela.api().destroy();
        }

        function armazenarTamanhoPaginaDatatable(tamanhoPagina) {
            _quantidadeItensPorPagina = tamanhoPagina;
            LocalStorageService.armazenar(LocalStorageService.chavesLocalStorage.tamanhoPaginaDatatable,tamanhoPagina);
        }

        function tamanhoPaginaDatatable() {
            return LocalStorageService.recuperar(LocalStorageService.chavesLocalStorage.tamanhoPaginaDatatable);
        }

        function construirColunaDeSelecionarPadrao(selecionar,icone) {
            return {
                targets: 0,
                createdCell: function (td,cellData,rowData,col) {
                    var tabela = this.DataTable();
                    construirButtonSelecionar(td,col,icone).then(
                        function (success) {
                            $('#acao-selecionar' + col).on('click',function () {
                                var indexLinha = tabela.page.info().start + (tabela.cell(td).index().row + 1);
                                if (selecionar)
                                    selecionar(indexLinha,td,cellData,rowData,col);
                            });
                        });
                },
                defaultContent: "",
                orderable: false,
                filterable: false,
                sortable: false,
                responsivePriority: 1
            };
        }

        function _construirColunaAcaoPadrao(targetColuna) {
            return {
                targets: targetColuna,
                ordering: false,
                filterable: false,
                sortable: false,
                responsivePriority: 1
            }
        }

        function _setConverterEntidadePesquisaParaJson(valor) {
            _converterEntidadePesquisaParaJson = valor;
        }

        return {
            construirDtOptionsComPaginacaoResponsivoPadrao: construirDtOptionsComPaginacaoResponsivoPadrao,
            construirDtOptionsComPaginacaoProcessadoNoServidorParaToolbar: construirDtOptionsComPaginacaoProcessadoNoServidorParaToolbar,
            //construirDtOptionsComPaginacaoProcessadoNoServidorComSrollY: construirDtOptionsComPaginacaoProcessadoNoServidorComSrollY,
            construirColunaDeSelecionarPadrao: construirColunaDeSelecionarPadrao,
            destruirTabela: destruirTabela,
            construirColunaAcaoPadrao: _construirColunaAcaoPadrao,
            setConverterEntidadePesquisaParaJson: _setConverterEntidadePesquisaParaJson
        }
    }

})();
(function () {
    'use strict';

    angular
        .module('app.factory')
        .factory('DatatableFactory', DatatableFactory);

    function DatatableFactory(urlApi, $q, LocalStorageService, TokenService) {

        var _tabela;
        var _converterEntidadePesquisaParaJson = false;
        var _quantidadeItensPorPagina = LocalStorageService.recuperar(LocalStorageService.chavesLocalStorage.tamanhoPaginaDatatable);

        function construirButtonSelecionar(td, col, icone) {
            var iconeUtilizado = icone ? icone : "icon-pencil";
            return $q(function (resolve) {
                $(td).html(
                    '<i id=acao-selecionar' + col + ' class="' + iconeUtilizado + ' s16 icone-cor-padrao" ng-click="" ng-disabled=""> </i>'
                );
                resolve('ok');
            });
        }

        function construirBotoesAcoes(td, col, iconeSelecionar, iconeAcao) {
            return $q(function (resolve) {
                $(td).html(
                    '<i id=acao-selecionar' + col + ' class="' + iconeSelecionar + ' s16 icone-cor-padrao" ng-click="" ng-disabled=""> </i>' +
                    '<i id=acao-customizada' + col + ' class="' + iconeAcao + ' s16 icone-cor-padrao ml-10" ng-click="" ng-disabled=""> </i>'
                );
                resolve('ok');
            });
        }

        function construirDtOptionsComPaginacaoResponsivoPadrao(definicaoColunas) {
            return {
                dom: 'rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
                initComplete: function () {
                    var api = this.api(),
                        searchBox = angular.element('body').find('#pesquisar');

                    // Bind an external input as a table wide search box
                    if (searchBox.length > 0) {
                        searchBox.on('keyup', function (event) {
                            api.search(event.target.value).draw();
                        });
                    }
                },
                drawCallback: function (settings) {
                    var api = this.api();
                    if (api && (tamanhoPaginaDatatable() != api.page.info().length)) {
                        armazenarTamanhoPaginaDatatable(api.page.info().length);
                    }
                },
                pagingType: 'numbers',
                lengthMenu: [10, 30, 50, 100],
                pageLength: _quantidadeItensPorPagina,
                responsive: true,
                columnDefs: definicaoColunas
            }
        }

        function construirDtOptionsComPaginacaoProcessadoNoServidorParaToolbar(rotaApi, entidadePesquisa, idDatatable, definicaoColunas) {
            var deferred = $q.defer();

            var token = TokenService.getToken();
            var entidadeDeEnvio = angular.copy(entidadePesquisa);

            $(function () {
                _tabela = $(idDatatable).dataTable({
                    dom: 'rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
                    processing: true,
                    serverSide: true,
                    ajax: {
                        url: urlApi.url_base_api + rotaApi,
                        type: "POST",
                        headers: {
                            "Authorization": "Bearer " + token
                        },
                        data: function (data, settings) {
                            if (entidadeDeEnvio) {
                                _converterEntidadePesquisaParaJson ?
                                    data.clsEntidade = angular.toJson(entidadeDeEnvio, false) :
                                    data.clsEntidade = entidadeDeEnvio
                            }

                            return data;
                        },
                        dataSrc: function (json) {
                            return json.data;
                        }
                    },
                    initComplete: function () {
                        var api = this.api(),
                            searchBox = angular.element('body').find('#pesquisar');

                        // Bind an external input as a table wide search box
                        if (searchBox.length > 0) {
                            searchBox.on('keyup', function (event) {
                                api.search(event.target.value).draw();
                            });
                        }
                    },
                    drawCallback: function (settings) {
                        var api = this.api();
                        if (api && api.page.info() && (tamanhoPaginaDatatable() != api.page.info().length))
                            armazenarTamanhoPaginaDatatable(api.page.info().length);
                    },
                    pagingType: 'numbers',
                    lengthMenu: [10, 30, 50, 100],
                    pageLength: _quantidadeItensPorPagina,
                    responsive: true,
                    columnDefs: definicaoColunas
                });
                deferred.resolve(_tabela);
            });
            return deferred.promise;
        }

        function destruirTabela() {
            if (_tabela && _tabela.api())
                _tabela.api().destroy();
        }

        function armazenarTamanhoPaginaDatatable(tamanhoPagina) {
            _quantidadeItensPorPagina = tamanhoPagina;
            LocalStorageService.armazenar(LocalStorageService.chavesLocalStorage.tamanhoPaginaDatatable, tamanhoPagina);
        }

        function tamanhoPaginaDatatable() {
            return LocalStorageService.recuperar(LocalStorageService.chavesLocalStorage.tamanhoPaginaDatatable);
        }

        function construirColunaDeSelecionarPadrao(selecionar, icone) {
            return {
                targets: 0,
                createdCell: function (td, cellData, rowData, col) {
                    var tabela = this.DataTable();
                    construirButtonSelecionar(td, col, icone).then(
                        function (success) {
                            $('#acao-selecionar' + col).on('click', function () {
                                var indexLinha = tabela.page.info().start + (tabela.cell(td).index().row + 1);
                                if (selecionar)
                                    selecionar(indexLinha, td, cellData, rowData, col);
                            });
                        });
                },
                defaultContent: "",
                orderable: false,
                filterable: false,
                sortable: false,
                responsivePriority: 1
            };
        }

        function construirColunaMultiAcoes(selecionar, acaoCustomizada, iconeSelecionar, iconeAcao) {
            return {
                targets: 0,
                createdCell: function (td, cellData, rowData, col) {
                    var tabela = this.DataTable();
                    construirBotoesAcoes(td, col, iconeSelecionar, iconeAcao).then(
                        function (success) {
                            $('#acao-selecionar' + col).on('click', function () {
                                var indexLinha = tabela.page.info().start + (tabela.cell(td).index().row + 1);
                                if (selecionar) selecionar(indexLinha, td, cellData, rowData, col);
                            });

                            $('#acao-customizada' + col).on('click', function () {
                                var indexLinha = tabela.page.info().start + (tabela.cell(td).index().row + 1);
                                if (acaoCustomizada) acaoCustomizada(indexLinha, td, cellData, rowData, col);
                            });

                            if (rowData.possuiVinculo) {
                                $('#acao-customizada' + col).append(
                                    $('<div>').addClass('ui-icon-bullet')
                                );
                            }
                        });
                },
                defaultContent: "",
                orderable: false,
                filterable: false,
                sortable: false,
                responsivePriority: 1
            };
        }

        function _construirColunaAcaoPadrao(targetColuna) {
            return {
                targets: targetColuna,
                ordering: false,
                filterable: false,
                sortable: false,
                responsivePriority: 1
            }
        }

        function _setConverterEntidadePesquisaParaJson(valor) {
            _converterEntidadePesquisaParaJson = valor;
        }

        function construirDtOptionsResponsivoSemPaginacaoPadraoComPesquisaHeaderPadrao(definicaoColunas) {
            return {
                dom: 'rt<"bottom"<"left"<"info"i>>>',
                responsive: true,
                paging: false,
                initComplete: function () {
                    var api = this.api(),
                        searchBox = angular.element('body').find('#pesquisar');
                    if (searchBox.length > 0) {
                        searchBox.on('keyup', function (event) {
                            api.search(event.target.value).draw();
                        });
                    }
                },
                columnDefs: definicaoColunas,
                oLanguage: {
                    "sInfo": "",
                    "sEmptyTable": "Não foram encontrados dados!",
                    "sSearch": "Pesquisar: ",
                    "sSearchPlaceholder": "",
                    "sInfoEmpty": "",
                    "sInfoFiltered": "",
                    "sLoadingRecords": "hfcgxhfghfgh",
                    "sProcessing": "",
                    "sZeroRecords": "Nenhum dado encontrado com base na pesquisa informada."
                }
            }
        }

        return {
            construirDtOptionsComPaginacaoResponsivoPadrao: construirDtOptionsComPaginacaoResponsivoPadrao,
            construirDtOptionsComPaginacaoProcessadoNoServidorParaToolbar: construirDtOptionsComPaginacaoProcessadoNoServidorParaToolbar,
            //construirDtOptionsComPaginacaoProcessadoNoServidorComSrollY: construirDtOptionsComPaginacaoProcessadoNoServidorComSrollY,
            construirColunaDeSelecionarPadrao: construirColunaDeSelecionarPadrao,
            destruirTabela: destruirTabela,
            construirColunaAcaoPadrao: _construirColunaAcaoPadrao,
            setConverterEntidadePesquisaParaJson: _setConverterEntidadePesquisaParaJson,
            construirDtOptionsResponsivoSemPaginacaoPadraoComPesquisaHeaderPadrao: construirDtOptionsResponsivoSemPaginacaoPadraoComPesquisaHeaderPadrao,
            construirColunaMultiAcoes: construirColunaMultiAcoes
        }
    }

})();

(function () {
    'use strict';

    angular
        .module('app.factory')
        .factory('ControleHorasFactory', ControleHorasFactory);

    function ControleHorasFactory($rootScope, Api, RequisicaoGenericaService, RotasHtml) {

        var _historico = {};
        var _controleForm;

        return {
            setHtmlRota: _setHtmlRota,
            historico: _setHistorico,
            controleForm:_setControleForm
        }


        function _setControleForm(){
            return _controleForm;
        }

  

        function _setHistorico(itemHistorico) {
            if (angular.equals({}, itemHistorico) || angular.equals(undefined, itemHistorico))
                return _historico

            _historico = itemHistorico;
            _listarHistoricoViagem();
            return _historico;

        }

        function _listarHistoricoViagem() {
            RequisicaoGenericaService.listarSemParams(Api.contole_horas.viagem + '/' + _historico.codigo)
                .then(function (success) {
                    console.log(success);
                    $rootScope.$broadcast('historico-viagem-carregado', success.data); 
                });
        }

        function _setHtmlRota() {
            return RotasHtml.controleHorasTrabalhadas;
        }


    }

})();

(function () {
  'use strict';

  angular
    .module('app.factory')
    .factory('ConsultasEstoriaFactory', ConsultasEstoriaFactory);

  function ConsultasEstoriaFactory(DataTableConfigPadrao) {

    return {
      setDtOptionsPadrao: _setDtOptionsPadrao,
      setColumnsDefsDtOptionsConsultaEstorias: _setColumnsDefsDtOptionsConsultaEstorias,
      setDtOptionsComInitComplete: _setDtOptionsComInitComplete,
      setSugestaoFiltros: _setSugestaoFiltros,
      setLegendasCoresConsultaEstoria: _setLegendasCoresConsultaEstoria,
      setDataAtual: _setDataAtual,
      setArrayFormatadoDeFiltrosEstoriasNaoConcluidasDoColaborador: _setArrayFormatadoDeFiltrosEstoriasNaoConcluidasDoColaborador,
      setLanguageConsultaEstorias: _setLanguageConsultaEstorias
    }

    function _setDtOptionsPadrao() {
      return {
        dom: 'rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
        orderMulti: true,
        scrollY: 'auto',
        pagingType: 'numbers',
        lengthMenu: [100],
        pageLength: 100,
        responsive: false,
      };
    };

    function _setColumnsDefsDtOptionsConsultaEstorias() {
      return [
        {
          targets: 0,
          responsivePriority: 1,
        },
        {
          targets: 1,
          type: 'date-pt-br'
        },
        {
          targets: 2,
          type: 'date-pt-br'
        },
        {
          targets: 4,
          responsivePriority: 1,
        },
        {
          targets: 8,
          responsivePriority: 1,
        }
      ];
    };

    function _setLanguageConsultaEstorias() {
      return {
        "sInfo": "Exibindo _START_ até _END_ de _TOTAL_ registros",
        "sEmptyTable": "Não foram encontrados dados!",
        "sSearch": "Pesquisar: ",
        "sSearchPlaceholder": "",
        "sInfoEmpty": "Nenhum dado disponível",
        "sInfoFiltered": "(filtrado de _MAX_ registros no total)",
        "sLoadingRecords": "Carregando...",
        "sProcessing": "Processando...",
        "sZeroRecords": "Nenhum dado encontrado com base na pesquisa informada."
      }
    };

    function _setDtOptionsComInitComplete() {
      return {
        dom: 'rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
        initComplete: function () {
          var api = this.api(),
            searchBox = angular.element('body').find('#pesquisar');
          if (searchBox.length > 0) {
            searchBox.on('keyup', function (event) {
              api.search(event.target.value).draw();
            });
          }
        },
        scrollY: 'auto',
        pagingType: 'numbers',
        lengthMenu: [100],
        pageLength: 100,
        responsive: true,
        order: []
      };
    };

    function _setSugestaoFiltros() {
      return {
        concluidas: {
          selecionado: false,
          filtros: [2, 9, 10, 15]
        },
        naoConcluidas: {
          selecionado: false,
          filtros: [1, 3, 6, 7, 8, 11, 12, 13, 14, 16, 17]
        },
      };
    };

    function _setLegendasCoresConsultaEstoria() {
      return [
        {
          descricao: "Vencidas",
          codigoLegenda: 1,
          cor: "red"
        },
        {
          descricao: "7 Dias Restantes",
          codigoLegenda: 2,
          cor: "yellow"
        }
      ]
    };

    function _setDataAtual() {
      var data = new Date();
      data.setHours(0);
      data.setMinutes(0);
      data.setSeconds(0);
      data.setMilliseconds(0);

      return data
    };

    function _setArrayFormatadoDeFiltrosEstoriasNaoConcluidasDoColaborador() {
      return "Solicitação|Análise|Autorizada|Repassada|Desenvolvimento|Liberada para Teste|Testes|Pausa no desenvolvimento|Retorno por Melhoria|Retorno de Erro|Pausa no teste";
    };

  }

})();

(function () {
    'use strict';

    angular.module('app.factory')
        .factory('AtualizacaoLicencaFactory', AtualizacaoLicencaFactory);

    function AtualizacaoLicencaFactory( $rootScope) {

        var _filtros = {
            selectStep : 1,
            cliente: null,
            produtoCodigo: null,
            rotina: 1,
            tiposLicenca: [],
            marcarTodos: false
        }

        var _licencas = {
            flag: null,
            numero: null
        }

        var _form = {};

        return {
            filtros: _filtros,
            form: _form,
            setValoresInciaisFiltro: setValoresInciaisFiltro,
            licencas: function(){return _licencas},
            setLicencas: setLicencas
        }

        function setValoresInciaisFiltro() {
            _filtros.cliente = null;
            _filtros.produtoCodigo = null;
            _filtros.rotina = 1;
            _filtros.tiposLicenca = [];
            _filtros.marcarTodos = false;
            setLicencas(_filtros.tiposLicenca);
        }

        function setLicencas(dados){
            _licencas = [].concat(dados);
            $rootScope.$broadcast('atualizarLicencasFactory', _licencas);
        }
    }

})();
(function () {
    'use strict';

    angular.module('app.factory')
        .factory('AtualizacaoClienteFactory', AtualizacaoClienteFactory);

    function AtualizacaoClienteFactory() {

        var _form = {
        };

        var _filtros = {
            selectStep: 1,
            clientes: [],
            caracteristicasContrato: [],
            caracteristicasContratoANaoImprimir: [],
            produtoCodigo: null,
            dataExpiracao: null,
            seletorCaracteristica: 2
        }

        var _preLoader = false;

        var _clienteSelecionado = false;

        return {
            filtros: _filtros,
            form: _form,
            preLoader: _preLoader,
            clienteSelecionado: _clienteSelecionado,
            setValoresInciaisFiltro: setValoresInciaisFiltro,
            validarClientes: validarClientes
        }

        function setValoresInciaisFiltro() {
            _filtros.clientes = [];
            _filtros.produtoCodigo = null;
            _filtros.dataExpiracao = null;
            _preLoader = false;
            _filtros.caracteristicasContrato = [];
            _filtros.caracteristicasContratoANaoImprimir = [];
            _filtros.dataExpiracao = null;
            _filtros.seletorCaracteristica = 2;
        }

        function validarClientes(clientes) {
            return clientes.filter(function (cliente) {
                if (cliente.selecionado == true) {
                    return cliente;
                }
            });
        }
    }

})();
(function () {
    'use strict';

    angular
        .module('app.factory')
        .factory('AtendimentoFactory', AtendimentoFactory);

    function AtendimentoFactory(DataTableConfigPadrao, $rootScope) {

        var _ultimoAtendimentoVisualizado = {
            codigo: null,
            ano: null,
            codigoUsuario: null
        };

        var _historicoAtendimento = {
            anoAtendimento: null,
            codigoAtendimento: null,
            codigoUsuario: null,
            contato: '',
            data: {},
            descricao: '',
            usuario: {},
            sequencia: null
        }

        return {
            ultimoAtendimentoAtendimentoVisualizadoPadrao: _ultimoAtendimentoAtendimentoVisualizadoPadrao,
            historicoAtendimento: _historicoAtendimento,
            setDtOptionsPadrao: _setDtOptionsPadrao,
            setDtOptionsHistoricoAtendimento: _setDtOptionsHistoricoAtendimento,
            setLegendasCoresAtendimentosEmAberto: _setLegendasCoresAtendimentosEmAberto,
            setLegendasCoresAtendimentosVinculados: _setLegendasCoresAtendimentosVinculados
        };

        function _setDtOptionsPadrao() {
            var dtOptions = angular.copy(DataTableConfigPadrao.dtOptionsPadraoComPaginacaoPaginTypeNumbersEReponsivo);
            dtOptions.orderMulti = true;
            dtOptions.columnDefs = [
                DataTableConfigPadrao.columnDefsPadrao,
                {
                    targets: 1,
                    orderData: [2, 1],
                }

            ];
            return dtOptions;
        }

        function _ultimoAtendimentoAtendimentoVisualizadoPadrao() {
            return {
                codigo: null,
                ano: null,
                codigoUsuario: null
            }
        }

        function _setDtOptionsHistoricoAtendimento() {
            var dtOptions = angular.copy(DataTableConfigPadrao.dtOptionsPadraoComPaginacaoPaginTypeNumbersEReponsivo);
            dtOptions.dom = 'rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>';
            dtOptions.lengthMenu = [10];
            dtOptions.pageLength = 10;
            dtOptions.order = [1];
            dtOptions.columnDefs = [
                DataTableConfigPadrao.columnDefsPadrao,
                {
                    targets: 1,
                    type: 'date-pt-br'
                }
            ];

            return dtOptions;
        }

        function _setLegendasCoresAtendimentosEmAberto() {
            return [
                {
                    descricao: "Atendimentos Vencidos",
                    codigoLegenda: 1,
                    cor: "red"
                },
                {
                    descricao: "Atendimentos 7 Dias Restantes",
                    codigoLegenda: 2,
                    cor: "yellow"
                }
            ]
        }

        function _setLegendasCoresAtendimentosVinculados() {
            return [
                {
                    descricao: "Abertos",
                    codigoLegenda: 0,
                    cor: "white"
                },
                {
                    descricao: "Finalizados",
                    codigoLegenda: 1,
                    cor: "green"
                },
                {
                    descricao: "Todos",
                    codigoLegenda: 2
                }
            ]
        }
    }

})();

/**
 * Created by nova on 27/09/2016.
 */
(function () {
    'use strict';

    angular
        .module('app.hub', [
        ])
        .config(Config);

    function Config() { };

})();

(function () {
    'use strict';

    angular
        .module('app.hub')
        .run(runBlock);

    /** @ngInject */
    function runBlock($rootScope, SolicitacaoHubFactory, LoginUsuarioService, NotificationService, NotificacaoAtendimentoService, $state) {
        $rootScope.quantidadeSolicitacoesNaoVisualizados = 0;


        /**
         * @param {codigoUsuario} codigoUsuario
         * @param {quantidadeSolicitacoesNaoVisualizado} quantidadeSolicitacoesNaoVisualizado
         */
        $rootScope.$on('atualizarBadgeQuantidadeSolicitacoesNaoVisualizado', function (eventoHub, codigoUsuarios, quantidadeSolicitacoesNaoVisualizado) {
        
            if (codigoUsuarios.includes(LoginUsuarioService.usuarioArmazenado().codigo)
                && LoginUsuarioService.usuarioArmazenado().clsSetor.codigo == 10) {
                SolicitacaoHubFactory.atualizarBadgeSolicitacao(quantidadeSolicitacoesNaoVisualizado);
            }
        });
    }
})();
(function () {
    'use strict';

    angular
        .module('app.hub')
        .factory('SolicitacaoHubFactory', SolicitacaoHubFactory);

    function SolicitacaoHubFactory($rootScope,
        RequisicaoGenericaService,
        Api,
        MenuFactory,
        LoginUsuarioService,
        NotificacaoSolicitacaoService) {
        var _proxy;
        var quantidadeSolicitacoes = null;

        return {
            construirProxy: construirProxy,
            atualizarBadgeSolicitacao: atualizarBadgeSolicitacao,
            atualizarQuantidadeSolicitacoesNaoVisualizados: atualizarQuantidadeSolicitacoesNaoVisualizados
        }


        function construirProxy(conexao) {
            _proxy = conexao.createHubProxy('NotificacoesSolicitacao');

            _proxy.on('atualizarBadgeQuantidadeSolicitacoesNaoVisualizado', function (codigoUsuarios, quantidadeSolicitacoesNaoVisualizadas) {
                $rootScope.$broadcast('atualizarBadgeQuantidadeSolicitacoesNaoVisualizado', codigoUsuarios, quantidadeSolicitacoesNaoVisualizadas);
            });

            _proxy.on('notificarSolicitacoes', function (codigoUsuarios, numeroSolicitacao, anoSolicitacao) {
                $rootScope.$broadcast('notificarSolicitacoes', codigoUsuarios, numeroSolicitacao, anoSolicitacao);
                if (LoginUsuarioService.usuarioArmazenado().clsSetor.codigo == 10 && $rootScope.toState.name != 'app.solicitacao_consulta_solicitacao') {
                    NotificacaoSolicitacaoService.exibirNotificacaoNovaSolicitacao(numeroSolicitacao)
                }
            });
        }


        function atualizarQuantidadeSolicitacoesNaoVisualizados(codigoUsuario, notificarSolicitacoesNaoVisualizadas) {
            if (codigoUsuario === LoginUsuarioService.usuarioArmazenado().codigo
                && LoginUsuarioService.usuarioArmazenado().clsSetor.codigo == 10) {
                RequisicaoGenericaService.listarSemParams(Api.solicitacao.solicitacao.listarQuantidadeNaoVisualizado).then(
                    function (success) {
                        atualizarBadgeSolicitacao(success.data);
                        if (success.data > 0 && notificarSolicitacoesNaoVisualizadas) {
                            NotificacaoSolicitacaoService.exibirNotificacaoSolicitacoesNaoVisualizadas(success.data);
                        }
                    });
            }
        }


        function atualizarBadgeSolicitacao(quantidade) {
            $rootScope.quantidadeSolicitacoesNaoVisualizadass = quantidade;

            MenuFactory.construirMenuSeUsuarioTerAcesso({
                menuNavegacao: 'app.solicitacao',
                titulo: 'Solicitação',
                icone: 'icon-book-multiple',
                peso: 4,
                grupo: false,
                badge: quantidade > 0 ? { content: quantidade, color: '#F44336' } : null
            });
        }
    }

})();

(function () {
    'use strict';

    angular
        .module('app.hub')
        .run(runBlock);

    /** @ngInject */
    function runBlock(MensageiroHubFactory) {        
    }
})();
(function () {
  'use strict';

  angular
    .module('app.hub')
    .factory('MensageiroHubFactory', MensageiroHubFactory);

  function MensageiroHubFactory($rootScope, RequisicaoGenericaService, Api, MenuFactory,
    NotificacaoMensageiroService, LocalStorageService, LoginUsuarioService) {
    var _proxy;

    var metodosInternos = {
      _armazenarBadgeQuantidadeMensagensNaoVisualizadosLocalStorage: _armazenarBadgeQuantidadeMensagensNaoVisualizadosLocalStorage,
      _obterBadgeQuantidadeMensagensNaoVisualizadosLocalStorage: _obterBadgeQuantidadeMensagensNaoVisualizadosLocalStorage
    }

    return {
      construirProxy: construirProxy,
      atualizarQuantidadeMensagensNaoVisualizados: atualizarQuantidadeMensagensNaoVisualizados,
      recarregarBadgeQuantidadeMensagensNaoVisualizadosLocalStorage: recarregarBadgeQuantidadeMensagensNaoVisualizadosLocalStorage,
      atualizarBadgeQuantidadeMensagensNaoVisualizados: atualizarBadgeQuantidadeMensagensNaoVisualizados
    }


    function construirProxy(conexao) {
      _proxy = conexao.createHubProxy('NotificacoesMensageiro');

      _proxy.on('Notificar', function (quantidadeMensagensNaoVisualizadas, mensagem) {
        atualizarBadgeQuantidadeMensagensNaoVisualizados(quantidadeMensagensNaoVisualizadas);
        if ($rootScope.toState.name != "app.mensageiro.threads")
          NotificacaoMensageiroService.exibirNotificacaoNovaMensagem();
        else
          $rootScope.$broadcast('novaMensagem', mensagem);
      });
    }

    function atualizarQuantidadeMensagensNaoVisualizados(codigoUsuario, notificarMensagensNaoVisualizadas) {
      RequisicaoGenericaService.listarSemParams(Api.mensageiro.mensagensNaoLidas + codigoUsuario).then(
        function (success) {
          atualizarBadgeQuantidadeMensagensNaoVisualizados(success.data.dados);
          if (success.data.dados > 0 && notificarMensagensNaoVisualizadas)
            NotificacaoMensageiroService.exibirNotificacaoMensagensNaoVisualizadas(success.data.dados);
        });
    }

    function recarregarBadgeQuantidadeMensagensNaoVisualizadosLocalStorage() {
      var quantidade = _obterBadgeQuantidadeMensagensNaoVisualizadosLocalStorage();
      atualizarBadgeQuantidadeMensagensNaoVisualizados(quantidade);
    }

    function atualizarBadgeQuantidadeMensagensNaoVisualizados(quantidade) {
      _armazenarBadgeQuantidadeMensagensNaoVisualizadosLocalStorage(quantidade);

      MenuFactory.construirMenuSeUsuarioTerAcesso({
        menuNavegacao: 'app.mensageiro',
        titulo: 'Mensageiro',
        icone: 'icon-email',
        estado: 'app.mensageiro.threads',
        peso: 7,
        grupo: false,
        badge: quantidade > 0 ? { content: quantidade, color: '#F44336' } : null,
        parametrosEstado: { filter: 'inbox' }
      });
    }


    //#region Métodos Internos
    function _armazenarBadgeQuantidadeMensagensNaoVisualizadosLocalStorage(quantidade) {
      LocalStorageService.armazenar(LocalStorageService.chavesLocalStorage.badgeMensagensNaoVisualizadas, quantidade);
    }

    function _obterBadgeQuantidadeMensagensNaoVisualizadosLocalStorage() {
      return LocalStorageService.recuperar(LocalStorageService.chavesLocalStorage.badgeMensagensNaoVisualizadas);
    }
    //#endregion


  }

})();

(function () {
    'use strict';

    angular
        .module('app.hub')
        .run(runBlock);

    /** @ngInject */
    function runBlock(AtendimentoHubFactory, $rootScope, LoginUsuarioService, NotificationService, NotificacaoAtendimentoService, $state) {
        $rootScope.quantidadeAtendimentosNaoVisualizados = 0;

        /**
         * Evento que escuta o método que esta em broadcast 'notificarAtendimentoUsuarioEspecifico' que esta na Api
         * quando esse método é disparado pela Api ele é recebido no lado do cliente atraves deste método
         * E esse método é responsável por notificar todos os usuarios que estão vinculados ao atendimento que houve uma mudança no atendimento
         * @param {*evento do Hub} eventoHub
         * @param {*Lista de acompanhantes do Atendimento} acompanhantesAtendimento
         */
        $rootScope.$on('notificarAtendimentos', function (eventoHub, acompanhantesAtendimento) {

            angular.forEach(acompanhantesAtendimento, function (item, index) {
                /**
                 * Verifica quais é o usuario corrente e também se ele ainda não visualizou o atendimento 
                 * caso a condição seja verdadeiro é disparado uma notificação para o usuario corrente
                 */
                if (item.CodigoUsuario === LoginUsuarioService.usuarioArmazenado().codigo && !item.Visualizado) {
                    // Exibi a notificação de alterações no historico do atendimento acompanhado
                    NotificacaoAtendimentoService.exibirNotificacaoAtendimentosAlteracaoHistoricoAtendimento(item.CodigoAtendimento, item.AnoAtendimento);
                    AtendimentoHubFactory.atualizarQuantidadeAtendimentosNaoVisualizados(item.CodigoUsuario);
                }
            });
        });

        /**
         * Evento que escuta o método que esta em broadcast 'notificarAtendimentoUsuarioEspecifico' que esta na Api
         * quando esse método é disparado pela Api ele é recebido no lado do cliente atraves deste método 
         * E esse método é responsável por notificar o usuario quando ele for vinculado as notificacoes de um atendimento
         * @param {eventoDoHub} eventoHub
         * @param {codigoUsuario} codigoUsuario Codigo do usuário que foi inserido nas notificações do Atendimento
         * @param {codigoAtendimento} codigoAtendimento Codigo do Atendimento
         * @param {anoAtendimento} anoAtendimento Ano do Atendimento
         */
        $rootScope.$on('notificarAtendimentoUsuarioEspecifico', function (eventoHub, codigoUsuario, codigoAtendimento, anoAtendimento) {
            if (codigoUsuario === LoginUsuarioService.usuarioArmazenado().codigo) {
                // Exibi notificação falando que você o colaborador inserido em um novo atendimento para acompanhar
                NotificacaoAtendimentoService.exibirNotificacaoAtendimentosUsuarioVinculadoEmNovoAtendimento(codigoAtendimento, anoAtendimento);
                AtendimentoHubFactory.atualizarQuantidadeAtendimentosNaoVisualizados(codigoUsuario);
            }
        });

        /**
         * Evento que escuta o método que esta em broadcast 'notificarAtendimentoUsuarioEspecifico' que esta na Api
         * quando esse método é disparado pela Api ele é recebido no lado do cliente atraves deste método
         * E esse método é responsável por atualizar o badge dos atendimentos visualizados do usuário corrente quando necessário
         * @param {codigoUsuario} codigoUsuario Codigo do Usuário
         * @param {quantidadeAtendimentosNaoVisualizados} quantidadeAtendimentosNaoVisualizados Quantidade de Atendimentos não visualizados pelo usuário
         */
        $rootScope.$on('atualizarBadgeQuantidadeAtendimentosNaoVisualizado', function (eventoHub, codigoUsuario, quantidadeAtendimentosNaoVisualizados) {
            if (codigoUsuario === LoginUsuarioService.usuarioArmazenado().codigo) {
                // Método que cria uma notificação e redirecionar para o atendimento não visualizados quando clicado na notificação
                AtendimentoHubFactory.atualizarBadgeAtendimento(quantidadeAtendimentosNaoVisualizados);
            }
        });

        /**
         * Evento que escuta o método que esta em broadcast 'atualizarBadgeQuantidadeAtendimentosEmAberto' que esta na Api
         * quando esse método é disparado pela Api ele é recebido no lado do cliente atraves deste método
         * E esse método é responsável por atualizar o badge dos atendimentos em aberto do usuário corrente quando necessário
         * @param {codigoUsuario} codigoUsuario Codigo do Usuário
         * @param {quantidadeAtendimentosEmAberto} quantidadeAtendimentosEmAberto  Quantidade de Atendimentos que o status está em aberto pelo usuário
         */
        $rootScope.$on('atualizarBadgeQuantidadeAtendimentosEmAberto', function (eventoHub, codigoUsuario, quantidadeAtendimentosEmAberto) {
            if (codigoUsuario === LoginUsuarioService.usuarioArmazenado().codigo) {
                AtendimentoHubFactory.atualizarBadgeAtendimentosEmAberto(quantidadeAtendimentosEmAberto);
            }
        });

        /**
         * Evento que escuta o método que esta em broadcast 'atualizarBadgeQuantidadeAtendimentosImportantesEmAberto' que esta na Api
         * quando esse método é disparado pela Api ele é recebido no lado do cliente atraves deste método
         * E esse método é responsável por atualizar o badge dos atendimentos em aberto do usuário corrente quando necessário
         * @param {codigoUsuario} codigoUsuario Codigo do Usuário
         * @param {quantidadeAtendimentosImportantesEmAberto } quantidadeAtendimentosImportantesEmAberto   Quantidade de Atendimentos que o status está em aberto pelo usuário
         */
        $rootScope.$on('atualizarBadgeQuantidadeAtendimentosImportantesEmAberto', function (eventoHub, codigoUsuario, quantidadeAtendimentosImportantesEmAberto) {
            if (codigoUsuario === LoginUsuarioService.usuarioArmazenado().codigo) {
                AtendimentoHubFactory.atualizarBadgeAtendimentosImportantes(quantidadeAtendimentosImportantesEmAberto);
            }
        });


        /**
         * Evento que escuta o método que esta em broadcast 'notificaUsuarioGerenteDeAtendimentosExtrapolados' que esta na Api
         * quando esse método é disparado pela Api ele é recebido no lado do cliente através deste método
         * E esse método é responsável por notificar os usuários gerentes que estão com as flags em seus detalhes de usuário
         * 'visualizar atendimentos do setor' e 'notificar atendimentos do setor' habilitado, que um usuário excedeu o limite de atendimentos 
         * em aberto limite
         * @param {listaUsuariosGerente} codigoUsuario Lista de usuários gerentes que estão habilitados a receber está notificação
         * @param {mensagem} mensagem  Mensagem a ser exibida na notificação
         * @param {codigoUsuarioAtendimentoExcedido} codigoUsuarioAtendimentoExcedido   Código do usuário que excedeu a quantidade limite de atendimentos em aberto
         */
        $rootScope.$on('notificaUsuarioGerenteDeAtendimentosExtrapolados', function (eventoHub, listaUsuariosGerente, mensagem, codigoUsuarioAtendimentosExcedido) {

            angular.forEach(listaUsuariosGerente, function (item, index) {
                if (item.CodigoUsuario === LoginUsuarioService.usuarioArmazenado().codigo) {
                    // Método que cria uma notificação e exibi o usuário que excedeu a quantidade atendimentos em aberto limite para o usuário gerente
                    NotificacaoAtendimentoService.exibirNotificacaoAtendimentosGerenteAtendimentosEmAbertoExcedidoUsuario(codigoUsuarioAtendimentosExcedido, mensagem);
                }
            });
        });

    }
})();
(function () {
    'use strict';

    angular
        .module('app.hub')
        .factory('AtendimentoHubFactory', AtendimentoHubFactory);

    function AtendimentoHubFactory($rootScope, MenuFactory, NotificacaoAtendimentoService, Api, RequisicaoGenericaService) {
        var _proxy;

        return {
            construirProxy: _construirProxy,
            atualizarQuantidadeAtendimentosNaoVisualizados: _atualizarQuantidadeAtendimentosNaoVisualizados,
            atualizarBadgeAtendimento: _atualizarBadgeAtendimento,
            atualizarBadgeAtendimentosImportantes: _atualizarBadgeAtendimentosImportantes,
            atualizarQuantidadeAtendimentoEmAberto: _atualizarQuantidadeAtendimentoEmAberto,
            atualizarQuantidadeAtendimentoImportante: atualizarQuantidadeAtendimentoImportante,
            atualizarBadgeAtendimentosEmAberto: _atualizarBadgeAtendimentosEmAberto,
            notificarLimiteAtendimentosEmAbertoExcedido: _notificarLimiteAtendimentosEmAbertoExcedido
        }

        function _construirProxy(conexao) {
            _proxy = conexao.createHubProxy('NotificacoesAtendimento');

            _proxy.on('notificarAtendimentos', function (acompanhantesAtendimento) {
                $rootScope.$broadcast('notificarAtendimentos', acompanhantesAtendimento);
            });
            _proxy.on('notificarAtendimentoUsuarioEspecifico', function (codigoUsuario, codigoAtendimento, anoAtendimento) {
                $rootScope.$broadcast('notificarAtendimentoUsuarioEspecifico', codigoUsuario, codigoAtendimento, anoAtendimento);
            });
            _proxy.on('atualizarBadgeQuantidadeAtendimentosNaoVisualizado', function (codigoUsuario, quantidadeAtendimentosNaoVisualizados) {
                $rootScope.$broadcast('atualizarBadgeQuantidadeAtendimentosNaoVisualizado', codigoUsuario, quantidadeAtendimentosNaoVisualizados);
            });
            _proxy.on('atualizarBadgeQuantidadeAtendimentosEmAberto', function (codigoUsuario, quantidadeAtendimentosEmAberto) {
                $rootScope.$broadcast('atualizarBadgeQuantidadeAtendimentosEmAberto', codigoUsuario, quantidadeAtendimentosEmAberto);
            });
            _proxy.on('atualizarBadgeQuantidadeAtendimentosImportantesEmAberto', function (codigoUsuario, quantidadeAtendimentosImportantesEmAberto) {
                $rootScope.$broadcast('atualizarBadgeQuantidadeAtendimentosImportantesEmAberto', codigoUsuario, quantidadeAtendimentosImportantesEmAberto);
            });
            _proxy.on('notificaUsuarioGerenteDeAtendimentosExtrapolados', function (listaUsuariosGerente, mensagem, codigoUsuarioAtendimentosExcedido) {
                $rootScope.$broadcast('notificaUsuarioGerenteDeAtendimentosExtrapolados', listaUsuariosGerente, mensagem, codigoUsuarioAtendimentosExcedido);
            });
        }


        /**
         * Método que invoca o método externo da Api para notificar os atendimentos pendentes
         * @param {*codigo do usuario corrente} codigoUsuario 
         */
        function _notificarAtendimentoPendentes(codigoUsuario) {
            _proxy.invoke('NotificarAtendimentos', codigoUsuario);
        };

        /**
         * Método que faz uma requisição para Api e busca a quantidade de atendimentos não visualizados do usuário corrente
         * @param {*código do usuario corrente} codigoUsuario
         */
        function _atualizarQuantidadeAtendimentosNaoVisualizados(codigoUsuario, notificarQuantidadeAtendimentos) {

            // Sempre que atualizar a quantidade de atendimentos a badge do atendimento deve ser atualizado
            RequisicaoGenericaService.listarSemParams(Api.atendimento.listarQuantidadeAtendimentosNaoVisualizados + codigoUsuario).then(
                function (success) {

                    // Sempre que atualizar a quantidade de atendimentos a badge do atendimento deve ser atualizado
                    _atualizarBadgeAtendimento(success.data);
                    if (notificarQuantidadeAtendimentos && success.data > 0) {
                        // Exibi a notificação de atendimentos não visualizados
                        NotificacaoAtendimentoService.exibirNotificacaoAtendimentosNaoVisualizados(success.data);
                    }
                });
        }

        /**            
          * Método que recarrega o campo de atendimento da navegação
          * Atualizando a quantidade de atendimentos não visualizados
          * @param {*quantidade de atendimentos não visualizados} quantidade
          */
        function _atualizarBadgeAtendimento(quantidade) {
            $rootScope.quantidadeAtendimentosNaoVisualizados = quantidade;

            MenuFactory.construirMenuSeUsuarioTerAcesso({
                menuNavegacao: 'app.atendimento',
                titulo: 'Atendimento',
                icone: 'icon-phone-log',
                peso: 3,
                grupo: false,
                badge: quantidade > 0 ? { content: quantidade, color: 'rgb(3, 155, 229)' } : null
            });

            MenuFactory.construirMenuSeUsuarioTerAcesso({
                menuNavegacao: 'app.atendimento.processamento.atendimentonaovisualizados',
                titulo: 'Aten. não visualizados',
                estado: 'app.atendimento_processamento_atendimentos_nao_visualizados',
                peso: 2,
                grupo: false,
                badge: quantidade > 0 ? { content: quantidade, color: 'rgb(3, 155, 229)', marginRight: '-38px !important' } : null
            });
        }

        /**
         * Método que ira notificar o usuário de seus atendimentos em aberto quando logar no sistema
         * @param {codigoUsuario} codigoUsuario 
         */
        function _atualizarQuantidadeAtendimentoEmAberto(codigoUsuario, notificarQuantidadeAtendimentosEmAberto) {
            RequisicaoGenericaService.listarSemParams(Api.atendimento.listarQuantidadeAtendimentosEmAberto + codigoUsuario).then(
                function (success) {
                    _atualizarBadgeAtendimentosEmAberto(success.data);

                    if (success.data > 0 && notificarQuantidadeAtendimentosEmAberto) {
                        // Exibi a notificação de atendimentos em aberto
                        NotificacaoAtendimentoService.exibirNotificacaoAtendimentosEmAberto(success.data, codigoUsuario);
                    }
                });
        }

        /**
         * Método que ira notificar o usuário de seus atendimentos em aberto quando logar no sistema
         * @param {codigoUsuario} codigoUsuario 
         */
        function atualizarQuantidadeAtendimentoImportante(codigoUsuario, notificarQuantidadeAtendimentosImportantes) {
            RequisicaoGenericaService.listarSemParams(Api.atendimento.listarQuantidadeAtendimentosImportantesEmAberto + codigoUsuario).then(
                function (success) {
                    _atualizarBadgeAtendimentosImportantes(success.data);
                });
        }

        /**            
          * Método que recarrega o campo de atendimento em aberto da navegação
          * Atualizando a quantidade de atendimentos em aberto
          * @param {quantidadeAtendimentosEmAberto} quantidade
          */
        function _atualizarBadgeAtendimentosEmAberto(quantidade) {
            MenuFactory.construirMenuSeUsuarioTerAcesso({
                menuNavegacao: 'app.atendimento.processamento.atendimentosemaberto',
                titulo: 'Aten. em aberto',
                estado: 'app.atendimento_processamento_atendimentos_em_aberto',
                peso: 3,
                grupo: false,
                badge: quantidade > 0 ? { content: quantidade, color: 'rgb(3, 155, 229)', marginRight: '-20px !important' } : null,
            });
        }

        /**            
          * Método que recarrega o campo de atendimentos importantes em aberto da navegação
          * Atualizando a quantidade de atendimentos em aberto
          * @param {quantidadeAtendimentosImportantesEmAberto} quantidade
          */
        function _atualizarBadgeAtendimentosImportantes(quantidade) {
            MenuFactory.construirMenuSeUsuarioTerAcesso({
                menuNavegacao: 'app.atendimento.processamento.atendimentosimportantes',
                titulo: 'Aten. importantes',
                estado: 'app.atendimento_processamento_atendimentos_importantes',
                peso: 5,
                grupo: false,
                badge: quantidade > 0 ? { content: quantidade, color: 'rgb(3, 155, 229)', marginRight: '-20px !important' } : null,
            });
        }

        /**
         * Método que irá notificar o usuário gerente quando ele logar no sistema, se houve um ou mais usuários que tenham excedido a quantidade limite
         * de atendimentos em aberto 
         * @param {codigoSetor} codigoSetor Codigo do Setor do usuário gerente
         */
        function _notificarLimiteAtendimentosEmAbertoExcedido(codigoUsuario) {
            RequisicaoGenericaService.listarSemParams(Api.atendimento.verificaSeExisteAtendimentosExcedidosPorSetor + codigoUsuario).then(
                function (success) {
                    if (success.data.usuarioAtendimentosExcedido) {
                        // Exibi a notificação de atendimentos em aberto excedido
                        NotificacaoAtendimentoService.exibirNotificacaoAtendimentosEmAbertoExcedido(success.data.codigoUsuariosComAtendimentosEmAbertoExcedidos)
                    }
                });
        }

    }

})();

(function () {
    'use strict';

    angular
        .module('app.hub')
        .factory('ControleAcessoMenuHubFactory', ControleAcessoMenuHubFactory);

    function ControleAcessoMenuHubFactory($rootScope, SessionStorageService, MdDialogService) {
        var _proxy;

        return {
            construirProxy: construirProxy,
        }

        var metodosInternos = {}

        function construirProxy(conexao) {
            _proxy = conexao.createHubProxy('ControleAcessoMenu');

            _proxy.on('AtualizarMenusPerfil', function () {
                $rootScope.desabilitarMudancaDeEstadoDaAplicacao = false;
                $rootScope.$broadcast('logout');
                MdDialogService.alertPadrao("Houve alterações no seu acesso dentro do sistema você será redirecionado para a tela de login para atualizar seu acesso.", null, "");
            });
        }


        //#region Métodos Internos    
        //#endregion


    }

})();


(function() {
  "use strict";

  angular
    .module("app.hub")
    .factory("AgendaEventoHubFactory", AgendaEventoHubFactory);

  function AgendaEventoHubFactory(
    $rootScope,
    MenuFactory,
    NotificacaoAgendaService,
    Api,
    MdDialogService,
    RequisicaoGenericaService,
    LoginUsuarioService
  ) {
    var _proxy;

    return {
      construirProxy: _construirProxy
    };

    function _construirProxy(conexao) {
      _proxy = conexao.createHubProxy("NotificarAtividadesAgenda");

      _proxy.on("notificarAtividadesAgenda", function(atividadesAgenda,codigoUsuario) {
        $rootScope.$broadcast("notificarAtividadesAgenda", atividadesAgenda,codigoUsuario);
        if (codigoUsuario === LoginUsuarioService.usuarioArmazenado().codigo){
          NotificacaoAgendaService.exibirNotificacaoAtividade(atividadesAgenda);
        }
      });
    }
  }
})();

/**
 * Created by nova on 18/07/2016.
 */
(function () {
    'use strict';

    angular
        .module('app.filtro',
        [

        ]
        );

})();

(function () {
    'use strict';

    angular
        .module('app.filtro')
        .filter('filtrarEstoria', filtrarEstoria);

    /** @ngInject */
    function filtrarEstoria(input) {
        console.log("awe");
        return undefined;
    }


})();
(function () {
    'use strict';

    angular
        .module('app.core')
        .factory('msUtils', msUtils);

    /** @ngInject */
    function msUtils($window) {
        // Private variables
        var mobileDetect = new MobileDetect($window.navigator.userAgent),
            browserInfo = null;

        var service = {
            exists: exists,
            detectBrowser: detectBrowser,
            guidGenerator: guidGenerator,
            isMobile: isMobile,
            toggleInArray: toggleInArray
        };

        return service;

        //////////

        /**
         * Check if item exists in a list
         *
         * @param item
         * @param list
         * @returns {boolean}
         */
        function exists(item, list) {
            return list.indexOf(item) > -1;
        }

        /**
         * Returns browser information
         * from user agent data
         *
         * Found at http://www.quirksmode.org/js/detect.html
         * but modified and updated to fit for our needs
         */
        function detectBrowser() {
            // If we already tested, do not test again
            if (browserInfo) {
                return browserInfo;
            }

            var browserData = [
                {
                    string: $window.navigator.userAgent,
                    subString: 'Edge',
                    versionSearch: 'Edge',
                    identity: 'Edge'
                },
                {
                    string: $window.navigator.userAgent,
                    subString: 'Chrome',
                    identity: 'Chrome'
                },
                {
                    string: $window.navigator.userAgent,
                    subString: 'OmniWeb',
                    versionSearch: 'OmniWeb/',
                    identity: 'OmniWeb'
                },
                {
                    string: $window.navigator.vendor,
                    subString: 'Apple',
                    versionSearch: 'Version',
                    identity: 'Safari'
                },
                {
                    prop: $window.opera,
                    identity: 'Opera'
                },
                {
                    string: $window.navigator.vendor,
                    subString: 'iCab',
                    identity: 'iCab'
                },
                {
                    string: $window.navigator.vendor,
                    subString: 'KDE',
                    identity: 'Konqueror'
                },
                {
                    string: $window.navigator.userAgent,
                    subString: 'Firefox',
                    identity: 'Firefox'
                },
                {
                    string: $window.navigator.vendor,
                    subString: 'Camino',
                    identity: 'Camino'
                },
                {
                    string: $window.navigator.userAgent,
                    subString: 'Netscape',
                    identity: 'Netscape'
                },
                {
                    string: $window.navigator.userAgent,
                    subString: 'MSIE',
                    identity: 'Explorer',
                    versionSearch: 'MSIE'
                },
                {
                    string: $window.navigator.userAgent,
                    subString: 'Trident/7',
                    identity: 'Explorer',
                    versionSearch: 'rv'
                },
                {
                    string: $window.navigator.userAgent,
                    subString: 'Gecko',
                    identity: 'Mozilla',
                    versionSearch: 'rv'
                },
                {
                    string: $window.navigator.userAgent,
                    subString: 'Mozilla',
                    identity: 'Netscape',
                    versionSearch: 'Mozilla'
                }
            ];

            var osData = [
                {
                    string: $window.navigator.platform,
                    subString: 'Win',
                    identity: 'Windows'
                },
                {
                    string: $window.navigator.platform,
                    subString: 'Mac',
                    identity: 'Mac'
                },
                {
                    string: $window.navigator.platform,
                    subString: 'Linux',
                    identity: 'Linux'
                },
                {
                    string: $window.navigator.platform,
                    subString: 'iPhone',
                    identity: 'iPhone'
                },
                {
                    string: $window.navigator.platform,
                    subString: 'iPod',
                    identity: 'iPod'
                },
                {
                    string: $window.navigator.platform,
                    subString: 'iPad',
                    identity: 'iPad'
                },
                {
                    string: $window.navigator.platform,
                    subString: 'Android',
                    identity: 'Android'
                }
            ];

            var versionSearchString = '';

            function searchString(data) {
                for (var i = 0; i < data.length; i++) {
                    var dataString = data[i].string;
                    var dataProp = data[i].prop;

                    versionSearchString = data[i].versionSearch || data[i].identity;

                    if (dataString) {
                        if (dataString.indexOf(data[i].subString) !== -1) {
                            return data[i].identity;

                        }
                    }
                    else if (dataProp) {
                        return data[i].identity;
                    }
                }
            }

            function searchVersion(dataString) {
                var index = dataString.indexOf(versionSearchString);

                if (index === -1) {
                    return;
                }

                return parseInt(dataString.substring(index + versionSearchString.length + 1));
            }

            var browser = searchString(browserData) || 'unknown-browser';
            var version = searchVersion($window.navigator.userAgent) || searchVersion($window.navigator.appVersion) || 'unknown-version';
            var os = searchString(osData) || 'unknown-os';

            // Prepare and store the object
            browser = browser.toLowerCase();
            version = browser + '-' + version;
            os = os.toLowerCase();

            browserInfo = {
                browser: browser,
                version: version,
                os: os
            };

            return browserInfo;
        }

        /**
         * Generates a globally unique id
         *
         * @returns {*}
         */
        function guidGenerator() {
            var S4 = function () {
                return (((1 + Math.random()) * 0x10000) || 0).toString(16).substring(1);
            };
            return (S4() + S4() + S4() + S4() + S4() + S4());
        }

        /**
         * Return if current device is a
         * mobile device or not
         */
        function isMobile() {
            return mobileDetect.mobile();
        }

        /**
         * Toggle in array (push or splice)
         *
         * @param item
         * @param array
         */
        function toggleInArray(item, array) {
            if (array.indexOf(item) === -1) {
                array.push(item);
            }
            else {
                array.splice(array.indexOf(item), 1);
            }
        }
    }
}());
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('msApi', msApiProvider);

    /** @ngInject **/
    function msApiProvider()
    {
        /* ----------------- */
        /* Provider          */
        /* ----------------- */
        var provider = this;

        // Inject the $log service
        var $log = angular.injector(['ng']).get('$log');

        // Data
        var baseUrl = '';
        var api = [];

        // Methods
        provider.setBaseUrl = setBaseUrl;
        provider.getBaseUrl = getBaseUrl;
        provider.getApiObject = getApiObject;
        provider.register = register;

        //////////

        /**
         * Set base url for API endpoints
         *
         * @param url {string}
         */
        function setBaseUrl(url)
        {
            baseUrl = url;
        }

        /**
         * Return the base url
         *
         * @returns {string}
         */
        function getBaseUrl()
        {
            return baseUrl;
        }

        /**
         * Return the api object
         *
         * @returns {object}
         */
        function getApiObject()
        {
            return api;
        }

        /**
         * Register API endpoint
         *
         * @param key
         * @param resource
         */
        function register(key, resource)
        {
            if ( !angular.isString(key) )
            {
                $log.error('"path" must be a string (eg. `dashboard.project`)');
                return;
            }

            if ( !angular.isArray(resource) )
            {
                $log.error('"resource" must be an array and it must follow $resource definition');
                return;
            }

            // Store the API object
            api[key] = {
                url          : baseUrl + (resource[0] || ''),
                paramDefaults: resource[1] || [],
                actions      : resource[2] || [],
                options      : resource[3] || {}
            };
        }

        /* ----------------- */
        /* Service           */
        /* ----------------- */
        this.$get = function ($log, $q, $resource, $rootScope)
        {
            // Data

            // Methods
            var service = {
                setBaseUrl: setBaseUrl,
                getBaseUrl: getBaseUrl,
                register  : register,
                resolve   : resolve,
                request   : request
            };

            return service;

            //////////

            /**
             * Resolve an API endpoint
             *
             * @param action {string}
             * @param parameters {object}
             * @returns {promise|boolean}
             */
            function resolve(action, parameters)
            {
                // Emit an event
                $rootScope.$broadcast('msApi::resolveStart');
                
                var actionParts = action.split('@'),
                    resource = actionParts[0],
                    method = actionParts[1],
                    params = parameters || {};

                if ( !resource || !method )
                {
                    $log.error('msApi.resolve requires correct action parameter (resourceName@methodName)');
                    return false;
                }

                // Create a new deferred object
                var deferred = $q.defer();

                // Get the correct resource definition from api object
                var apiObject = api[resource];

                if ( !apiObject )
                {
                    $log.error('Resource "' + resource + '" is not defined in the api service!');
                    deferred.reject('Resource "' + resource + '" is not defined in the api service!');
                }
                else
                {
                    // Generate the $resource object based on the stored API object
                    var resourceObject = $resource(apiObject.url, apiObject.paramDefaults, apiObject.actions, apiObject.options);

                    // Make the call...
                    resourceObject[method](params,

                        // Success
                        function (response)
                        {
                            deferred.resolve(response);

                            // Emit an event
                            $rootScope.$broadcast('msApi::resolveSuccess');
                        },

                        // Error
                        function (response)
                        {
                            deferred.reject(response);

                            // Emit an event
                            $rootScope.$broadcast('msApi::resolveError');
                        }
                    );
                }

                // Return the promise
                return deferred.promise;
            }

            /**
             * Make a request to an API endpoint
             *
             * @param action {string}
             * @param [parameters] {object}
             * @param [success] {function}
             * @param [error] {function}
             *
             * @returns {promise|boolean}
             */
            function request(action, parameters, success, error)
            {
                // Emit an event
                $rootScope.$broadcast('msApi::requestStart');
                
                var actionParts = action.split('@'),
                    resource = actionParts[0],
                    method = actionParts[1],
                    params = parameters || {};

                if ( !resource || !method )
                {
                    $log.error('msApi.resolve requires correct action parameter (resourceName@methodName)');
                    return false;
                }

                // Create a new deferred object
                var deferred = $q.defer();

                // Get the correct resource definition from api object
                var apiObject = api[resource];

                if ( !apiObject )
                {
                    $log.error('Resource "' + resource + '" is not defined in the api service!');
                    deferred.reject('Resource "' + resource + '" is not defined in the api service!');
                }
                else
                {
                    // Generate the $resource object based on the stored API object
                    var resourceObject = $resource(apiObject.url, apiObject.paramDefaults, apiObject.actions, apiObject.options);

                    // Make the call...
                    resourceObject[method](params,

                        // SUCCESS
                        function (response)
                        {
                            // Emit an event
                            $rootScope.$broadcast('msApi::requestSuccess');
                            
                            // Resolve the promise
                            deferred.resolve(response);

                            // Call the success function if there is one
                            if ( angular.isDefined(success) && angular.isFunction(success) )
                            {
                                success(response);
                            }
                        },

                        // ERROR
                        function (response)
                        {
                            // Emit an event
                            $rootScope.$broadcast('msApi::requestError');
                            
                            // Reject the promise
                            deferred.reject(response);

                            // Call the error function if there is one
                            if ( angular.isDefined(error) && angular.isFunction(error) )
                            {
                                error(response);
                            }
                        }
                    );
                }

                // Return the promise
                return deferred.promise;
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .factory('apiResolver', apiResolverService);

    /** @ngInject */
    function apiResolverService($q, $log, api)
    {
        var service = {
            resolve: resolve
        };

        return service;

        //////////
        /**
         * Resolve api
         * @param action
         * @param parameters
         */
        function resolve(action, parameters)
        {
            var actionParts = action.split('@'),
                resource = actionParts[0],
                method = actionParts[1],
                params = parameters || {};

            if ( !resource || !method )
            {
                $log.error('apiResolver.resolve requires correct action parameter (ResourceName@methodName)');
                return false;
            }

            // Create a new deferred object
            var deferred = $q.defer();

            // Get the correct api object from api service
            var apiObject = getApiObject(resource);

            if ( !apiObject )
            {
                $log.error('Resource "' + resource + '" is not defined in the api service!');
                deferred.reject('Resource "' + resource + '" is not defined in the api service!');
            }
            else
            {
                apiObject[method](params,

                    // Success
                    function (response)
                    {
                        deferred.resolve(response);
                    },

                    // Error
                    function (response)
                    {
                        deferred.reject(response);
                    }
                );
            }

            // Return the promise
            return deferred.promise;
        }

        /**
         * Get correct api object
         *
         * @param resource
         * @returns {*}
         */
        function getApiObject(resource)
        {
            // Split the resource in case if we have a dot notated object
            var resourceParts = resource.split('.'),
                apiObject = api;

            // Loop through the resource parts and go all the way through
            // the api object and return the correct one
            for ( var l = 0; l < resourceParts.length; l++ )
            {
                if ( angular.isUndefined(apiObject[resourceParts[l]]) )
                {
                    $log.error('Resource part "' + resourceParts[l] + '" is not defined!');
                    apiObject = false;
                    break;
                }

                apiObject = apiObject[resourceParts[l]];
            }

            if ( !apiObject )
            {
                return false;
            }

            return apiObject;
        }
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .service('fuseTheming', fuseThemingService);

    /** @ngInject */
    function fuseThemingService($cookies, $log, $mdTheming)
    {
        var service = {
            getRegisteredPalettes: getRegisteredPalettes,
            getRegisteredThemes  : getRegisteredThemes,
            setActiveTheme       : setActiveTheme,
            setThemesList        : setThemesList,
            themes               : {
                list  : {},
                active: {
                    'name' : '',
                    'theme': {}
                }
            }
        };

        return service;

        //////////

        /**
         * Get registered palettes
         *
         * @returns {*}
         */
        function getRegisteredPalettes()
        {
            return $mdTheming.PALETTES;
        }

        /**
         * Get registered themes
         *
         * @returns {*}
         */
        function getRegisteredThemes()
        {
            return $mdTheming.THEMES;
        }

        /**
         * Set active theme
         *
         * @param themeName
         */
        function setActiveTheme(themeName)
        {
            // If theme does not exist, fallback to the default theme
            if ( angular.isUndefined(service.themes.list[themeName]) )
            {
                // If there is no theme called "default"...
                if ( angular.isUndefined(service.themes.list.default) )
                {
                    $log.error('You must have at least one theme named "default"');
                    return;
                }

                $log.warn('The theme "' + themeName + '" does not exist! Falling back to the "default" theme.');

                // Otherwise set theme to default theme
                service.themes.active.name = 'default';
                service.themes.active.theme = service.themes.list.default;
                $cookies.put('selectedTheme', service.themes.active.name);

                return;
            }

            service.themes.active.name = themeName;
            service.themes.active.theme = service.themes.list[themeName];
            $cookies.put('selectedTheme', themeName);
        }

        /**
         * Set available themes list
         *
         * @param themeList
         */
        function setThemesList(themeList)
        {
            service.themes.list = themeList;
        }
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.core')
        .config(config);

    /** @ngInject */
    function config($mdThemingProvider, fusePalettes, fuseThemes)
    {
        // Inject Cookies Service
        var $cookies;
        angular.injector(['ngCookies']).invoke([
            '$cookies', function (_$cookies)
            {
                $cookies = _$cookies;
            }
        ]);

        // Check if custom theme exist in cookies
        var customTheme = $cookies.getObject('customTheme');
        if ( customTheme )
        {
            fuseThemes['custom'] = customTheme;
        }

        $mdThemingProvider.alwaysWatchTheme(true);

        // Define custom palettes
        angular.forEach(fusePalettes, function (palette)
        {
            $mdThemingProvider.definePalette(palette.name, palette.options);
        });

        // Register custom themes
        angular.forEach(fuseThemes, function (theme, themeName)
        {
            $mdThemingProvider.theme(themeName)
                .primaryPalette(theme.primary.name, theme.primary.hues)
                .accentPalette(theme.accent.name, theme.accent.hues)
                .warnPalette(theme.warn.name, theme.warn.hues)
                .backgroundPalette(theme.background.name, theme.background.hues);
        });
    }

})();
(function ()
{
    'use strict';

    var fuseThemes = {
        default  : {
            primary   : {
                name: 'fuse-paleblue',
                hues: {
                    'default': '700',
                    'hue-1'  : '500',
                    'hue-2'  : '600',
                    'hue-3'  : '400'
                }
            },
            accent    : {
                name: 'light-blue',
                hues: {
                    'default': '600',
                    'hue-1'  : '400',
                    'hue-2'  : '700',
                    'hue-3'  : 'A100'
                }
            },
            warn      : {
                name: 'red'
            },
            background: {
                name: 'grey',
                hues: {
                    'default': 'A100',
                    'hue-1'  : 'A100',
                    'hue-2'  : '100',
                    'hue-3'  : '300'
                }
            }
        },
        'pinkTheme': {
            primary   : {
                name: 'blue-grey',
                hues: {
                    'default': '800',
                    'hue-1'  : '600',
                    'hue-2'  : '400',
                    'hue-3'  : 'A100'
                }
            },
            accent    : {
                name: 'pink',
                hues: {
                    'default': '400',
                    'hue-1'  : '300',
                    'hue-2'  : '600',
                    'hue-3'  : 'A100'
                }
            },
            warn      : {
                name: 'blue'
            },
            background: {
                name: 'grey',
                hues: {
                    'default': 'A100',
                    'hue-1'  : 'A100',
                    'hue-2'  : '100',
                    'hue-3'  : '300'
                }
            }
        },
        'tealTheme': {
            primary   : {
                name: 'fuse-blue',
                hues: {
                    'default': '900',
                    'hue-1'  : '600',
                    'hue-2'  : '500',
                    'hue-3'  : 'A100'
                }
            },
            accent    : {
                name: 'teal',
                hues: {
                    'default': '500',
                    'hue-1'  : '400',
                    'hue-2'  : '600',
                    'hue-3'  : 'A100'
                }
            },
            warn      : {
                name: 'deep-orange'
            },
            background: {
                name: 'grey',
                hues: {
                    'default': 'A100',
                    'hue-1'  : 'A100',
                    'hue-2'  : '100',
                    'hue-3'  : '300'
                }
            }
        }
    };

    angular
        .module('app.core')
        .constant('fuseThemes', fuseThemes);
})();
(function () {
    'use strict';

    var fusePalettes = [
        {
            name: 'fuse-blue',
            options: {
                '50': '#ebf1fa',
                '100': '#c2d4ef',
                '200': '#9ab8e5',
                '300': '#78a0dc',
                '400': '#5688d3',
                '500': '#3470ca',
                '600': '#2e62b1',
                '700': '#275498',
                '800': '#21467e',
                '900': '#1a3865',
                'A100': '#c2d4ef',
                'A200': '#9ab8e5',
                'A400': '#5688d3',
                'A700': '#275498',
                'contrastDefaultColor': 'light',
                'contrastDarkColors': '50 100 200 A100',
                'contrastStrongLightColors': '300 400'
            }
        },
        {
            name: 'fuse-paleblue',
            options: {
                '50': '#ececee',
                '100': '#c5c6cb',
                '200': '#9ea1a9',
                '300': '#7d818c',
                '400': '#5c616f',
                '500': '#3c4252',
                '600': '#353a48',
                '700': '#2d323e',
                '800': '#262933',
                '900': '#1e2129',
                'A100': '#c5c6cb',
                'A200': '#9ea1a9',
                'A400': '#5c616f',
                'A700': '#2d323e',
                'contrastDefaultColor': 'light',
                'contrastDarkColors': '50 100 200 A100',
                'contrastStrongLightColors': '300 400'
            }
        }
    ];

    angular
        .module('app.core')
        .constant('fusePalettes', fusePalettes);
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .factory('fuseGenerator', fuseGeneratorService);

    /** @ngInject */
    function fuseGeneratorService($cookies, $log, fuseTheming)
    {
        // Storage for simplified themes object
        var themes = {};

        var service = {
            generate: generate,
            rgba    : rgba
        };

        return service;

        //////////

        /**
         * Generate less variables for each theme from theme's
         * palette by using material color naming conventions
         */
        function generate()
        {
            // Get registered themes and palettes and copy
            // them so we don't modify the original objects
            var registeredThemes = angular.copy(fuseTheming.getRegisteredThemes());
            var registeredPalettes = angular.copy(fuseTheming.getRegisteredPalettes());

            // First, create a simplified object that stores
            // all registered themes and their colors

            // Iterate through registered themes
            angular.forEach(registeredThemes, function (registeredTheme)
            {
                themes[registeredTheme.name] = {};

                // Iterate through color types (primary, accent, warn & background)
                angular.forEach(registeredTheme.colors, function (colorType, colorTypeName)
                {
                    themes[registeredTheme.name][colorTypeName] = {
                        'name'  : colorType.name,
                        'levels': {
                            'default': {
                                'color'    : rgba(registeredPalettes[colorType.name][colorType.hues.default].value),
                                'contrast1': rgba(registeredPalettes[colorType.name][colorType.hues.default].contrast, 1),
                                'contrast2': rgba(registeredPalettes[colorType.name][colorType.hues.default].contrast, 2),
                                'contrast3': rgba(registeredPalettes[colorType.name][colorType.hues.default].contrast, 3),
                                'contrast4': rgba(registeredPalettes[colorType.name][colorType.hues.default].contrast, 4)
                            },
                            'hue1'   : {
                                'color'    : rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].value),
                                'contrast1': rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].contrast, 1),
                                'contrast2': rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].contrast, 2),
                                'contrast3': rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].contrast, 3),
                                'contrast4': rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].contrast, 4)
                            },
                            'hue2'   : {
                                'color'    : rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].value),
                                'contrast1': rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].contrast, 1),
                                'contrast2': rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].contrast, 2),
                                'contrast3': rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].contrast, 3),
                                'contrast4': rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].contrast, 4)
                            },
                            'hue3'   : {
                                'color'    : rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].value),
                                'contrast1': rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].contrast, 1),
                                'contrast2': rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].contrast, 2),
                                'contrast3': rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].contrast, 3),
                                'contrast4': rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].contrast, 4)
                            }
                        }
                    };
                });
            });

            // Process themes one more time and then store them in the service for external use
            processAndStoreThemes(themes);

            // Iterate through simplified themes
            // object and create style variables
            var styleVars = {};

            // Iterate through registered themes
            angular.forEach(themes, function (theme, themeName)
            {
                styleVars = {};
                styleVars['@themeName'] = themeName;

                // Iterate through color types (primary, accent, warn & background)
                angular.forEach(theme, function (colorTypes, colorTypeName)
                {
                    // Iterate through color levels (default, hue1, hue2 & hue3)
                    angular.forEach(colorTypes.levels, function (colors, colorLevelName)
                    {
                        // Iterate through color name (color, contrast1, contrast2, contrast3 & contrast4)
                        angular.forEach(colors, function (color, colorName)
                        {
                            styleVars['@' + colorTypeName + ucfirst(colorLevelName) + ucfirst(colorName)] = color;
                        });
                    });
                });

                // Render styles
                render(styleVars);
            });
        }

        // ---------------------------
        //  INTERNAL HELPER FUNCTIONS
        // ---------------------------

        /**
         * Process and store themes for global use
         *
         * @param _themes
         */
        function processAndStoreThemes(_themes)
        {
            // Here we will go through every registered theme one more time
            // and try to simplify their objects as much as possible for
            // easier access to their properties.
            var themes = angular.copy(_themes);

            // Iterate through themes
            angular.forEach(themes, function (theme)
            {
                // Iterate through color types (primary, accent, warn & background)
                angular.forEach(theme, function (colorType, colorTypeName)
                {
                    theme[colorTypeName] = colorType.levels;
                    theme[colorTypeName].color = colorType.levels.default.color;
                    theme[colorTypeName].contrast1 = colorType.levels.default.contrast1;
                    theme[colorTypeName].contrast2 = colorType.levels.default.contrast2;
                    theme[colorTypeName].contrast3 = colorType.levels.default.contrast3;
                    theme[colorTypeName].contrast4 = colorType.levels.default.contrast4;
                    delete theme[colorTypeName].default;
                });
            });

            // Store themes and set selected theme for the first time
            fuseTheming.setThemesList(themes);

            // Remember selected theme.
            var selectedTheme = $cookies.get('selectedTheme');

            if ( selectedTheme )
            {
                fuseTheming.setActiveTheme(selectedTheme);
            }
            else
            {
                fuseTheming.setActiveTheme('default');
            }
        }


        /**
         * Render css files
         *
         * @param styleVars
         */
        function render(styleVars)
        {
            var cssTemplate = '/* Content hack because they wont fix */\n/* https://github.com/angular/material/pull/8067 */\n[md-theme="@themeName"] md-content.md-hue-1,\nmd-content.md-@themeName-theme.md-hue-1 {\n    color: @backgroundHue1Contrast1;\n    background-color: @backgroundHue1Color;\n}\n\n[md-theme="@themeName"] md-content.md-hue-2,\nmd-content.md-@themeName-theme.md-hue-2 {\n    color: @backgroundHue2Contrast1;\n    background-color: @backgroundHue2Color;\n}\n\n[md-theme="@themeName"] md-content.md-hue-3,\n md-content.md-@themeName-theme.md-hue-3 {\n    color: @backgroundHue3Contrast1;\n    background-color: @backgroundHue3Color;\n}\n\n/* Text Colors */\n[md-theme="@themeName"] a {\n    color: @accentDefaultColor;\n}\n\n[md-theme="@themeName"] .secondary-text,\n[md-theme="@themeName"] .icon {\n    color: @backgroundDefaultContrast2;\n}\n\n[md-theme="@themeName"] .hint-text,\n[md-theme="@themeName"] .disabled-text {\n    color: @backgroundDefaultContrast3;\n}\n\n[md-theme="@themeName"] .fade-text,\n[md-theme="@themeName"] .divider {\n    color: @backgroundDefaultContrast4;\n}\n\n/* Primary */\n[md-theme="@themeName"] .md-primary-bg {\n    background-color: @primaryDefaultColor;\n    color: @primaryDefaultContrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg .secondary-text,\n[md-theme="@themeName"] .md-primary-bg .icon {\n    color: @primaryDefaultContrast2;\n}\n\n[md-theme="@themeName"] .md-primary-bg .hint-text,\n[md-theme="@themeName"] .md-primary-bg .disabled-text {\n    color: @primaryDefaultContrast3;\n}\n\n[md-theme="@themeName"] .md-primary-bg .fade-text,\n[md-theme="@themeName"] .md-primary-bg .divider {\n    color: @primaryDefaultContrast4;\n}\n\n/* Primary, Hue-1 */\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 {\n    background-color: @primaryHue1Color;\n    color: @primaryHue1Contrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .secondary-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .icon {\n    color: @primaryHue1Contrast2;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .hint-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .disabled-text {\n    color: @primaryHue1Contrast3;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .fade-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .divider {\n    color: @primaryHue1Contrast4;\n}\n\n/* Primary, Hue-2 */\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 {\n    background-color: @primaryHue2Color;\n    color: @primaryHue2Contrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .secondary-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .icon {\n    color: @primaryHue2Contrast2;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .hint-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .disabled-text {\n    color: @primaryHue2Contrast3;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .fade-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .divider {\n    color: @primaryHue2Contrast4;\n}\n\n/* Primary, Hue-3 */\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 {\n    background-color: @primaryHue3Color;\n    color: @primaryHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .secondary-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .icon {\n    color: @primaryHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .hint-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .disabled-text {\n    color: @primaryHue3Contrast3;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .fade-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .divider {\n    color: @primaryHue3Contrast4;\n}\n\n/* Primary foreground */\n[md-theme="@themeName"] .md-primary-fg {\n    color: @primaryDefaultColor !important;\n}\n\n/* Primary foreground, Hue-1 */\n[md-theme="@themeName"] .md-primary-fg.md-hue-1 {\n    color: @primaryHue1Color !important;\n}\n\n/* Primary foreground, Hue-2 */\n[md-theme="@themeName"] .md-primary-fg.md-hue-2 {\n    color: @primaryHue2Color !important;\n}\n\n/* Primary foreground, Hue-3 */\n[md-theme="@themeName"] .md-primary-fg.md-hue-3 {\n    color: @primaryHue3Color !important;\n}\n\n/* Accent */\n[md-theme="@themeName"] .md-accent-bg {\n    background-color: @accentDefaultColor;\n    color: @accentDefaultContrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg .secondary-text,\n[md-theme="@themeName"] .md-accent-bg .icon {\n    color: @accentDefaultContrast2;\n}\n\n[md-theme="@themeName"] .md-accent-bg .hint-text,\n[md-theme="@themeName"] .md-accent-bg .disabled-text {\n    color: @accentDefaultContrast3;\n}\n\n[md-theme="@themeName"] .md-accent-bg .fade-text,\n[md-theme="@themeName"] .md-accent-bg .divider {\n    color: @accentDefaultContrast4;\n}\n\n/* Accent, Hue-1 */\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 {\n    background-color: @accentHue1Color;\n    color: @accentHue1Contrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .secondary-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .icon {\n    color: @accentHue1Contrast2;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .hint-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .disabled-text {\n    color: @accentHue1Contrast3;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .fade-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .divider {\n    color: @accentHue1Contrast4;\n}\n\n/* Accent, Hue-2 */\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 {\n    background-color: @accentHue2Color;\n    color: @accentHue2Contrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .secondary-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .icon {\n    color: @accentHue2Contrast2;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .hint-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .disabled-text {\n    color: @accentHue2Contrast3;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .fade-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .divider {\n    color: @accentHue2Contrast4;\n}\n\n/* Accent, Hue-3 */\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 {\n    background-color: @accentHue3Color;\n    color: @accentHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .secondary-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .icon {\n    color: @accentHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .hint-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .disabled-text {\n    color: @accentHue3Contrast3;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .fade-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .divider {\n    color: @accentHue3Contrast4;\n}\n\n/* Accent foreground */\n[md-theme="@themeName"] .md-accent-fg {\n    color: @accentDefaultColor !important;\n}\n\n/* Accent foreground, Hue-1 */\n[md-theme="@themeName"] .md-accent-fg.md-hue-1 {\n    color: @accentHue1Color !important;\n}\n\n/* Accent foreground, Hue-2 */\n[md-theme="@themeName"] .md-accent-fg.md-hue-2 {\n    color: @accentHue2Color !important;\n}\n\n/* Accent foreground, Hue-3 */\n[md-theme="@themeName"] .md-accent-fg.md-hue-3 {\n    color: @accentHue3Color !important;\n}\n\n/* Warn */\n[md-theme="@themeName"] .md-warn-bg {\n    background-color: @warnDefaultColor;\n    color: @warnDefaultContrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg .secondary-text,\n[md-theme="@themeName"] .md-warn-bg .icon {\n    color: @warnDefaultContrast2;\n}\n\n[md-theme="@themeName"] .md-warn-bg .hint-text,\n[md-theme="@themeName"] .md-warn-bg .disabled-text {\n    color: @warnDefaultContrast3;\n}\n\n[md-theme="@themeName"] .md-warn-bg .fade-text,\n[md-theme="@themeName"] .md-warn-bg .divider {\n    color: @warnDefaultContrast4;\n}\n\n/* Warn, Hue-1 */\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 {\n    background-color: @warnHue1Color;\n    color: @warnHue1Contrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .secondary-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .icon {\n    color: @warnHue1Contrast2;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .hint-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .disabled-text {\n    color: @warnHue1Contrast3;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .fade-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .divider {\n    color: @warnHue1Contrast4;\n}\n\n/* Warn, Hue-2 */\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 {\n    background-color: @warnHue2Color;\n    color: @warnHue2Contrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .secondary-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .icon {\n    color: @warnHue2Contrast2;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .hint-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .disabled-text {\n    color: @warnHue2Contrast3;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .fade-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .divider {\n    color: @warnHue2Contrast4;\n}\n\n/* Warn, Hue-3 */\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 {\n    background-color: @warnHue3Color;\n    color: @warnHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .secondary-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .icon {\n    color: @warnHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .hint-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .disabled-text {\n    color: @warnHue3Contrast3;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .fade-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .divider {\n    color: @warnHue3Contrast4;\n}\n\n/* Warn foreground */\n[md-theme="@themeName"] .md-warn-fg {\n    color: @warnDefaultColor !important;\n}\n\n/* Warn foreground, Hue-1 */\n[md-theme="@themeName"] .md-warn-fg.md-hue-1 {\n    color: @warnHue1Color !important;\n}\n\n/* Warn foreground, Hue-2 */\n[md-theme="@themeName"] .md-warn-fg.md-hue-2 {\n    color: @warnHue2Color !important;\n}\n\n/* Warn foreground, Hue-3 */\n[md-theme="@themeName"] .md-warn-fg.md-hue-3 {\n    color: @warnHue3Color !important;\n}\n\n/* Background */\n[md-theme="@themeName"] .md-background-bg {\n    background-color: @backgroundDefaultColor;\n    color: @backgroundDefaultContrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg .secondary-text,\n[md-theme="@themeName"] .md-background-bg .icon {\n    color: @backgroundDefaultContrast2;\n}\n\n[md-theme="@themeName"] .md-background-bg .hint-text,\n[md-theme="@themeName"] .md-background-bg .disabled-text {\n    color: @backgroundDefaultContrast3;\n}\n\n[md-theme="@themeName"] .md-background-bg .fade-text,\n[md-theme="@themeName"] .md-background-bg .divider {\n    color: @backgroundDefaultContrast4;\n}\n\n/* Background, Hue-1 */\n[md-theme="@themeName"] .md-background-bg.md-hue-1 {\n    background-color: @backgroundHue1Color;\n    color: @backgroundHue1Contrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .secondary-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .icon {\n    color: @backgroundHue1Contrast2;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .hint-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .disabled-text {\n    color: @backgroundHue1Contrast3;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .fade-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .divider {\n    color: @backgroundHue1Contrast4;\n}\n\n/* Background, Hue-2 */\n[md-theme="@themeName"] .md-background-bg.md-hue-2 {\n    background-color: @backgroundHue2Color;\n    color: @backgroundHue2Contrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .secondary-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .icon {\n    color: @backgroundHue2Contrast2;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .hint-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .disabled-text {\n    color: @backgroundHue2Contrast3;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .fade-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .divider {\n    color: @backgroundHue2Contrast4;\n}\n\n/* Background, Hue-3 */\n[md-theme="@themeName"] .md-background-bg.md-hue-3 {\n    background-color: @backgroundHue3Color;\n    color: @backgroundHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .secondary-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .icon {\n    color: @backgroundHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .hint-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .disabled-text {\n    color: @backgroundHue3Contrast3;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .fade-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .divider {\n    color: @backgroundHue3Contrast4;\n}\n\n/* Background foreground */\n[md-theme="@themeName"] .md-background-fg {\n    color: @backgroundDefaultColor !important;\n}\n\n/* Background foreground, Hue-1 */\n[md-theme="@themeName"] .md-background-fg.md-hue-1 {\n    color: @backgroundHue1Color !important;\n}\n\n/* Background foreground, Hue-2 */\n[md-theme="@themeName"] .md-background-fg.md-hue-2 {\n    color: @backgroundHue2Color !important;\n}\n\n/* Background foreground, Hue-3 */\n[md-theme="@themeName"] .md-background-fg.md-hue-3 {\n    color: @backgroundHue3Color !important;\n}';

            var regex = new RegExp(Object.keys(styleVars).join('|'), 'gi');
            var css = cssTemplate.replace(regex, function (matched)
            {
                return styleVars[matched];
            });

            var headEl = angular.element('head');
            var styleEl = angular.element('<style type="text/css"></style>');
            styleEl.html(css);
            headEl.append(styleEl);
        }

        /**
         * Convert color array to rgb/rgba
         * Also apply contrasts if needed
         *
         * @param color
         * @param _contrastLevel
         * @returns {string}
         */
        function rgba(color, _contrastLevel)
        {
            var contrastLevel = _contrastLevel || false;

            // Convert 255,255,255,0.XX to 255,255,255
            // According to Google's Material design specs, white primary
            // text must have opacity of 1 and we will fix that here
            // because Angular Material doesn't care about that spec
            if ( color.length === 4 && color[0] === 255 && color[1] === 255 && color[2] === 255 )
            {
                color.splice(3, 4);
            }

            // If contrast level provided, apply it to the current color
            if ( contrastLevel )
            {
                color = applyContrast(color, contrastLevel);
            }

            // Convert color array to color string (rgb/rgba)
            if ( color.length === 3 )
            {
                return 'rgb(' + color.join(',') + ')';
            }
            else if ( color.length === 4 )
            {
                return 'rgba(' + color.join(',') + ')';
            }
            else
            {
                $log.error('Invalid number of arguments supplied in the color array: ' + color.length + '\n' + 'The array must have 3 or 4 colors.');
            }
        }

        /**
         * Apply given contrast level to the given color
         *
         * @param color
         * @param contrastLevel
         */
        function applyContrast(color, contrastLevel)
        {
            var contrastLevels = {
                'white': {
                    '1': '1',
                    '2': '0.7',
                    '3': '0.3',
                    '4': '0.12'
                },
                'black': {
                    '1': '0.87',
                    '2': '0.54',
                    '3': '0.26',
                    '4': '0.12'
                }
            };

            // If white
            if ( color[0] === 255 && color[1] === 255 && color[2] === 255 )
            {
                color[3] = contrastLevels.white[contrastLevel];
            }
            // If black
            else if ( color[0] === 0 && color[1] === 0 && color[2] === 0 )
            {
                color[3] = contrastLevels.black[contrastLevel];
            }

            return color;
        }

        /**
         * Uppercase first
         */
        function ucfirst(string)
        {
            return string.charAt(0).toUpperCase() + string.slice(1);
        }
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsThemeOptionsController', MsThemeOptionsController)
        .directive('msThemeOptions', msThemeOptions);

    /** @ngInject */
    function MsThemeOptionsController($cookies, fuseTheming)
    {
        var vm = this;

        // Data
        vm.themes = fuseTheming.themes;

        vm.layoutModes = [
            {
                label: 'Boxed',
                value: 'boxed'
            },
            {
                label: 'Wide',
                value: 'wide'
            }
        ];
        vm.layoutStyles = [
            {
                label : 'Vertical Navigation',
                value : 'verticalNavigation',
                figure: '/assets/images/theme-options/vertical-nav.jpg'
            },
            {
                label : 'Vertical Navigation with Fullwidth Toolbar',
                value : 'verticalNavigationFullwidthToolbar',
                figure: '/assets/images/theme-options/vertical-nav-with-full-toolbar.jpg'
            },
            {
                label : 'Vertical Navigation with Fullwidth Toolbar 2',
                value : 'verticalNavigationFullwidthToolbar2',
                figure: '/assets/images/theme-options/vertical-nav-with-full-toolbar-2.jpg'
            },
            {
                label : 'Horizontal Navigation',
                value : 'horizontalNavigation',
                figure: '/assets/images/theme-options/horizontal-nav.jpg'
            },
            {
                label : 'Content with Toolbar',
                value : 'contentWithToolbar',
                figure: '/assets/images/theme-options/content-with-toolbar.jpg'
            },
            {
                label : 'Content Only',
                value : 'contentOnly',
                figure: '/assets/images/theme-options/content-only.jpg'
            },
        ];

        vm.layoutMode = 'wide';
        vm.layoutStyle = $cookies.get('layoutStyle') || 'verticalNavigation';

        // Methods
        vm.setActiveTheme = setActiveTheme;
        vm.getActiveTheme = getActiveTheme;
        vm.updateLayoutMode = updateLayoutMode;
        vm.updateLayoutStyle = updateLayoutStyle;

        //////////

        /**
         * Set active theme
         *
         * @param themeName
         */
        function setActiveTheme(themeName)
        {
            fuseTheming.setActiveTheme(themeName);
        }

        /**
         * Get active theme
         *
         * @returns {service.themes.active|{name, theme}}
         */
        function getActiveTheme()
        {
            return fuseTheming.themes.active;
        }

        /**
         * Update layout mode
         */
        function updateLayoutMode()
        {
            var bodyEl = angular.element('body');

            // Update class on body element
            bodyEl.toggleClass('boxed', (vm.layoutMode === 'boxed'));
        }

        /**
         * Update layout style
         */
        function updateLayoutStyle()
        {
            // Update the cookie
            $cookies.put('layoutStyle', vm.layoutStyle);

            // Reload the page to apply the changes
            location.reload();
        }
    }

    /** @ngInject */
    function msThemeOptions($mdSidenav)
    {
        return {
            restrict   : 'E',
            scope      : {},
            controller : 'MsThemeOptionsController as vm',
            templateUrl: 'app/core/theme-options/theme-options.html',
            compile    : function (tElement)
            {
                tElement.addClass('ms-theme-options');

                return function postLink(scope)
                {
                    /**
                     * Toggle options sidenav
                     */
                    function toggleOptionsSidenav()
                    {
                        // Toggle the fuse theme options panel
                        $mdSidenav('fuse-theme-options').toggle();
                    }

                    // Expose the toggle function
                    scope.toggleOptionsSidenav = toggleOptionsSidenav;
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .filter('filterByTags', filterByTags)
        .filter('filterSingleByTags', filterSingleByTags);

    /** @ngInject */
    function filterByTags()
    {
        return function (items, tags)
        {
            if ( items.length === 0 || tags.length === 0 )
            {
                return items;
            }

            var filtered = [];

            items.forEach(function (item)
            {
                var match = tags.every(function (tag)
                {
                    var tagExists = false;

                    item.tags.forEach(function (itemTag)
                    {
                        if ( itemTag.name === tag.name )
                        {
                            tagExists = true;
                            return;
                        }
                    });

                    return tagExists;
                });

                if ( match )
                {
                    filtered.push(item);
                }
            });

            return filtered;
        };
    }

    /** @ngInject */
    function filterSingleByTags()
    {
        return function (itemTags, tags)
        {
            if ( itemTags.length === 0 || tags.length === 0 )
            {
                return;
            }

            if ( itemTags.length < tags.length )
            {
                return [];
            }

            var filtered = [];

            var match = tags.every(function (tag)
            {
                var tagExists = false;

                itemTags.forEach(function (itemTag)
                {
                    if ( itemTag.name === tag.name )
                    {
                        tagExists = true;
                        return;
                    }
                });

                return tagExists;
            });

            if ( match )
            {
                filtered.push(itemTags);
            }

            return filtered;
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .filter('filterByPropIds', filterByPropIds);

    /** @ngInject */
    function filterByPropIds()
    {
        return function (items, parameter, ids)
        {
            if ( items.length === 0 || !ids || ids.length === 0 )
            {
                return items;
            }

            var filtered = [];

            for ( var i = 0; i < items.length; i++ )
            {
                var item = items[i];
                var match = false;

                for ( var j = 0; j < ids.length; j++ )
                {
                    var id = ids[j];
                    if ( item[parameter].indexOf(id) > -1 )
                    {
                        match = true;
                        break;
                    }
                }

                if ( match )
                {
                    filtered.push(item);
                }

            }

            return filtered;

        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .filter('filterByIds', filterByIds);

    /** @ngInject */
    function filterByIds()
    {
        return function (items, ids)
        {

            if ( items.length === 0 || !ids )
            {
                return items;
            }

            if ( ids.length === 0 )
            {
                return [];
            }

            var filtered = [];

            for ( var i = 0; i < items.length; i++ )
            {
                var item = items[i];
                var match = false;

                for ( var j = 0; j < ids.length; j++ )
                {
                    var id = ids[j];
                    if ( item.id === id )
                    {
                        match = true;
                        break;
                    }
                }

                if ( match )
                {
                    filtered.push(item);
                }

            }

            return filtered;

        };
    }

})();
(function () {
    'use strict';

    angular
        .module('app.core')
        .filter('toTrusted', toTrustedFilter)
        .filter('htmlToPlaintext', htmlToPlainTextFilter)
        .filter('nospace', nospaceFilter)
        .filter('humanizeDoc', humanizeDocFilter);

    /** @ngInject */
    function toTrustedFilter($sce) {
        return function (value) {
            return $sce.trustAsHtml(value);
        };
    }

    /** @ngInject */
    function htmlToPlainTextFilter() {
        return function (text) {
            return String(text)
                    .replace(/<[^>]+>/gm, '')
                    .replace('&#65279;', ' ');
        };
    }

    /** @ngInject */
    function nospaceFilter() {
        return function (value) {
            return (!value) ? '' : value.replace(/ /g, '');
        };
    }

    /** @ngInject */
    function humanizeDocFilter() {
        return function (doc) {
            if (!doc) {
                return;
            }
            if (doc.type === 'directive') {
                return doc.name.replace(/([A-Z])/g, function ($1) {
                    return '-' + $1.toLowerCase();
                });
            }
            return doc.label || doc.name;
        };
    }

})();

(function ()
{
    'use strict';

    angular
        .module('app.core')
        .filter('altDate', altDate);

    /** @ngInject */
    function altDate()
    {
        return function (value)
        {
            var diff = Date.now() - new Date(value);

            /**
             * If in a hour
             * e.g. "2 minutes ago"
             */
            if ( diff < (60 * 60 * 1000) )
            {
                return moment(value).fromNow();
            }
            /*
             * If in the day
             * e.g. "11:23"
             */
            else if ( diff < (60 * 60 * 24 * 1000) )
            {
                return moment(value).format('HH:mm');
            }
            /*
             * If in week
             * e.g "Tuesday"
             */
            else if ( diff < (60 * 60 * 24 * 7 * 1000) )
            {
                return moment(value).format('dddd');
            }
            /*
             * If more than a week
             * e.g. 03/29/2016
             */
            else
            {
                return moment(value).calendar();
            }

        };
    }

})();
(function () {
    'use strict';

    angular
        .module('app.core')
        .directive('hljs', hljsDirective);

    /** @ngInject */
    function hljsDirective($timeout, $q, $interpolate) {
        return {
            restrict: 'E',
            compile : function (element, attr) {
                var code;
                //No attribute? code is the content
                if (!attr.code) {
                    code = element.html();
                    element.empty();
                }

                return function (scope, element, attr) {

                    if (attr.code) {
                        // Attribute? code is the evaluation
                        code = scope.$eval(attr.code);
                    }
                    var shouldInterpolate = scope.$eval(attr.shouldInterpolate);

                    $q.when(code).then(function (code) {
                        if (code) {
                            if (shouldInterpolate) {
                                code = $interpolate(code)(scope);
                            }
                            var contentParent = angular.element(
                                '<pre><code class="highlight" ng-non-bindable></code></pre>'
                            );
                            element.append(contentParent);
                            // Defer highlighting 1-frame to prevent GA interference...
                            $timeout(function () {
                                render(code, contentParent);
                            }, 34, false);
                        }
                    });

                    function render(contents, parent) {

                        var codeElement = parent.find('code');
                        var lines = contents.split('\n');

                        // Remove empty lines
                        lines = lines.filter(function (line) {
                            return line.trim().length;
                        });

                        // Make it so each line starts at 0 whitespace
                        var firstLineWhitespace = lines[0].match(/^\s*/)[0];
                        var startingWhitespaceRegex = new RegExp('^' + firstLineWhitespace);
                        lines = lines.map(function (line) {
                            return line
                                .replace(startingWhitespaceRegex, '')
                                .replace(/\s+$/, '');
                        });

                        var highlightedCode = hljs.highlight(attr.language || attr.lang, lines.join('\n'), true);
                        highlightedCode.value = highlightedCode.value
                            .replace(/=<span class="hljs-value">""<\/span>/gi, '')
                            .replace('<head>', '')
                            .replace('<head/>', '');
                        codeElement.append(highlightedCode.value).addClass('highlight');
                    }
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('fuseConfig', fuseConfigProvider);

    /** @ngInject */
    function fuseConfigProvider()
    {
        // Default configuration
        var fuseConfiguration = {
            'disableCustomScrollbars'        : false,
            'disableMdInkRippleOnMobile'     : true,
            'disableCustomScrollbarsOnMobile': true
        };

        // Methods
        this.config = config;

        //////////

        /**
         * Extend default configuration with the given one
         *
         * @param configuration
         */
        function config(configuration)
        {
            fuseConfiguration = angular.extend({}, fuseConfiguration, configuration);
        }

        /**
         * Service
         */
        this.$get = function ()
        {
            var service = {
                getConfig: getConfig,
                setConfig: setConfig
            };

            return service;

            //////////

            /**
             * Returns a config value
             */
            function getConfig(configName)
            {
                if ( angular.isUndefined(fuseConfiguration[configName]) )
                {
                    return false;
                }

                return fuseConfiguration[configName];
            }

            /**
             * Creates or updates config object
             *
             * @param configName
             * @param configValue
             */
            function setConfig(configName, configValue)
            {
                fuseConfiguration[configName] = configValue;
            }
        };
    }

})();
String.prototype.removerTagsHtml = function () {
    return this.replace(/<.*?>/g, '');
}

String.prototype.substrituirQuebraDeLinhasParaTagHtml = function () {
    return this.replace(/\n/g, "<br>");
}

String.prototype.converterMonetarioParaFloat = function () {

    var value = this.replace("R$", "").replace(" ", "");

    var countDots = value.split(".").length;

    for (var index = 0; index < countDots; index++) {
        value = value.replace(".", "");
    }

    return value.replace(",", ".");
}

String.prototype.insertAt = function (index, string) {
    return this.substr(0, index) + string + this.substr(index);
} 
jQuery.extend(jQuery.fn.dataTableExt.oSort, {
    "enum-necessidade-cliente-pre": function (a) {
        var retorno;
        switch (a.removerTagsHtml().trim()) {
            case "Deve ter": retorno = 4; break;
            case "Deveria ter": retorno = 3; break;
            case "Poderia ter": retorno = 2; break;
            case "Não terá por enquanto": retorno = 1; break;
            default: retorno = 0;
        }
        return retorno;
    },

    "enum-necessidade-cliente-asc": function (a, b) {
        return ((a < b) ? -1 : ((a > b) ? 1 : 0));
    },

    "enum-necessidade-cliente-desc": function (a, b) {
        return ((a < b) ? 1 : ((a > b) ? -1 : 0));
    }
});
jQuery.extend(jQuery.fn.dataTableExt.oSort, {
  "numero-ano-pre": function (a) {
    var ukDatea = a.split('/');
    console.log(ukDatea);
    return (ukDatea[1] + ukDatea[0]) * 1;
  },

  "numero-ano-asc": function (a, b) {
    console.log(a);
    console.log(b);
    return ((a < b) ? -1 : ((a > b) ? 1 : 0));
  },

  "numero-ano-desc": function (a, b) {
    console.log(a);
    console.log(b);
    return ((a < b) ? 1 : ((a > b) ? -1 : 0));
  }
});

/**
 * This sorting plug-in for DataTables will correctly sort data in date time or date
 * format typically used in Germany:
 * date and time:`dd.mm.YYYY HH:mm`
 * just date:`dd.mm.YYYY`.
 *
 * Please note that this plug-in is **deprecated*. The
 * [datetime](//datatables.net/blog/2014-12-18) plug-in provides enhanced
 * functionality and flexibility.
 *
 *  @name Date (dd.mm.YYYY) or date and time (dd.mm.YYYY HH:mm)
 *  @summary Sort date / time in the format `dd.mm.YYYY HH:mm` or `dd.mm.YYYY`.
 *  @author [Ronny Vedrilla](http://www.ambient-innovation.com)
 *  @deprecated
 *
 *  @example
 *    $('#example').dataTable( {
 *       columnDefs: [
 *         { type: 'de_datetime', targets: 0 },
 *         { type: 'de_date', targets: 1 }
 *       ]
 *    } );
 */

jQuery.extend(jQuery.fn.dataTableExt.oSort, {
  "date-pt-br-pre": function (a) {
    var regex = /([0-9]{2}\/[0-9]{2}\/[0-9]{4})/gm;
    var data = regex.exec(a);
    if (data) {
      var ukDatea = data[0].split('/');
      return (ukDatea[2] + ukDatea[1] + ukDatea[0]) * 1;
    }else{return null;}
  },

  "date-pt-br-asc": function (a, b) {
    console.log(a);
    console.log(b);
    return ((a < b) ? -1 : ((a > b) ? 1 : 0));
  },

  "date-pt-br-desc": function (a, b) {
    console.log(a);
    console.log(b);
    return ((a < b) ? 1 : ((a > b) ? -1 : 0));
  }
});

// jQuery.extend( jQuery.fn.dataTableExt.oSort, {
//	"de_datetime-asc": function ( a, b ) {
//		var x, y;
//		if (jQuery.trim(a) !== '') {
//			var deDatea = jQuery.trim(a).split(' ');
//			var deTimea = deDatea[1].split(':');
//			var deDatea2 = deDatea[0].split('.');
//                        if(typeof deTimea[2] != 'undefined') {
//                            x = (deDatea2[2] + deDatea2[1] + deDatea2[0] + deTimea[0] + deTimea[1] + deTimea[2]) * 1;
//                        } else {
//                            x = (deDatea2[2] + deDatea2[1] + deDatea2[0] + deTimea[0] + deTimea[1]) * 1;
//                        }
//		} else {
//			x = Infinity; // = l'an 1000 ...
//		}
//
//		if (jQuery.trim(b) !== '') {
//			var deDateb = jQuery.trim(b).split(' ');
//			var deTimeb = deDateb[1].split(':');
//			deDateb = deDateb[0].split('.');
//                        if(typeof deTimeb[2] != 'undefined') {
//                            y = (deDateb[2] + deDateb[1] + deDateb[0] + deTimeb[0] + deTimeb[1] + deTimeb[2]) * 1;
//                        } else {
//                            y = (deDateb[2] + deDateb[1] + deDateb[0] + deTimeb[0] + deTimeb[1]) * 1;
//                        }
//		} else {
//			y = Infinity;
//		}
//		var z = ((x < y) ? -1 : ((x > y) ? 1 : 0));
//		return z;
//	},
//
//	"de_datetime-desc": function ( a, b ) {
//		var x, y;
//		if (jQuery.trim(a) !== '') {
//			var deDatea = jQuery.trim(a).split(' ');
//			var deTimea = deDatea[1].split(':');
//			var deDatea2 = deDatea[0].split('.');
//                        if(typeof deTimea[2] != 'undefined') {
//                            x = (deDatea2[2] + deDatea2[1] + deDatea2[0] + deTimea[0] + deTimea[1] + deTimea[2]) * 1;
//                        } else {
//                            x = (deDatea2[2] + deDatea2[1] + deDatea2[0] + deTimea[0] + deTimea[1]) * 1;
//                        }
//		} else {
//			x = Infinity;
//		}
//
//		if (jQuery.trim(b) !== '') {
//			var deDateb = jQuery.trim(b).split(' ');
//			var deTimeb = deDateb[1].split(':');
//			deDateb = deDateb[0].split('.');
//                        if(typeof deTimeb[2] != 'undefined') {
//                            y = (deDateb[2] + deDateb[1] + deDateb[0] + deTimeb[0] + deTimeb[1] + deTimeb[2]) * 1;
//                        } else {
//                            y = (deDateb[2] + deDateb[1] + deDateb[0] + deTimeb[0] + deTimeb[1]) * 1;
//                        }
//		} else {
//			y = Infinity;
//		}
//		var z = ((x < y) ? 1 : ((x > y) ? -1 : 0));
//		return z;
//	},
//
//	"de_date-asc": function ( a, b ) {
//		var x, y;
//		if (jQuery.trim(a) !== '') {
//			var deDatea = jQuery.trim(a).split('.');
//			x = (deDatea[2] + deDatea[1] + deDatea[0]) * 1;
//		} else {
//			x = Infinity; // = l'an 1000 ...
//		}
//
//		if (jQuery.trim(b) !== '') {
//			var deDateb = jQuery.trim(b).split('.');
//			y = (deDateb[2] + deDateb[1] + deDateb[0]) * 1;
//		} else {
//			y = Infinity;
//		}
//		var z = ((x < y) ? -1 : ((x > y) ? 1 : 0));
//		return z;
//	},
//
//	"de_date-desc": function ( a, b ) {
//		var x, y;
//		if (jQuery.trim(a) !== '') {
//			var deDatea = jQuery.trim(a).split('.');
//			x = (deDatea[2] + deDatea[1] + deDatea[0]) * 1;
//		} else {
//			x = Infinity;
//		}
//
//		if (jQuery.trim(b) !== '') {
//			var deDateb = jQuery.trim(b).split('.');
//			y = (deDateb[2] + deDateb[1] + deDateb[0]) * 1;
//		} else {
//			y = Infinity;
//		}
//		var z = ((x < y) ? 1 : ((x > y) ? -1 : 0));
//		return z;
//	}
//} );

/**
 * Array prototype
 *
 * Get by id
 *
 * @param value
 * @returns {T}
 */
Array.prototype.getById = function (value) {
    return this.filter(function (x) {
        return x.id === value;
    })[0];
};

Array.prototype.getByCodigo = function (value) {
    return this.filter(function (x) {
        return x.codigo === value;
    })[0];
};

Array.prototype.insert = function (index, item) {
    this.splice(index, 0, item);
};
/**
 * Created by nova on 09/09/2016.
 */
(function () {
    'use strict';

    angular
        .module('app.diretivas')
        .directive('mascaraTeste', mascaraTeste);

    function mascaraTeste() {
        return {
            restrict: 'AE',
            tempalte: '<ng-transclude>asdasd</ng-transclude>'
        }
    }

})();

(function () {
    'use strict';

    angular
        .module('app.toolbar')
        .controller('ToolbarController', ToolbarController);

    /** @ngInject */
    function ToolbarController($rootScope, $q, $state, $timeout, $mdSidenav, $mdToast, NotificacaoService,
        msNavigationService, LoginUsuarioService, versaoImanager, $scope, ToolbarService, dateFilter,
        HubFactory, SessionStorageService, $mdDialog, MenuFactory, RequisicaoGenericaService, Api) {
        var vm = this;

        vm.versao = versaoImanager.versao;
        vm.release = versaoImanager.release;

        vm.horaAtual = dateFilter(new Date(), 'dd/MM/yyyy HH:mm');

        var updateTime = setInterval(function () {
            vm.horaAtual = dateFilter(new Date(), 'dd/MM/yyyy HH:mm');
        }, 1000);

        // Data
        $rootScope.global = {
            search: ''
        };

        vm.bodyEl = angular.element('body');

        vm.usuario = LoginUsuarioService.usuarioArmazenado();

        // Methods
        vm.toggleSidenav = toggleSidenav;
        vm.logout = logout;
        vm.toggleHorizontalMobileMenu = toggleHorizontalMobileMenu;
        vm.toggleMsNavigationFolded = toggleMsNavigationFolded;
        vm.search = search;
        vm.searchResultClick = searchResultClick;
        vm.abrirDialogAlteracaoSenha = abrirDialogAlteracaoSenha;
        vm.abrirDialogSenhaImplantacao = abrirDialogSenhaImplantacao;
        vm.selecionarSquad = alterarSquad;

        //////////

        init();

        /**
         * Initialize
         */
        function init() {
            vm.statusConexao = 'Conectado';
            inicializarEstado();
        }

        /**
         * Toggle sidenav
         *
         * @param sidenavId
         */
        function toggleSidenav(sidenavId) {
            $mdSidenav(sidenavId).toggle();
        }

        function inicializarEstado() {
            var squadSelecionado = ToolbarService.squadSelecionado();
            var squads = ToolbarService.codigoSquadUsuarioLogado();

            if (squadSelecionado !== null && squads.includes(squadSelecionado)) {
                vm.codigoSquadAtual = squadSelecionado;
            } else {
                vm.codigoSquadAtual = squads.length > 0 ? squads[0] : 1;
                ToolbarService.armazenarSquadSelecionado(vm.codigoSquadAtual);
            }

            vm.iconeAtual = ToolbarService.obterIconePadrao(vm.codigoSquadAtual);
            vm.squadsUsuarioLogado = squads;

            atualizarFlags();
        }

        function atualizarFlags() {
            var flags = ToolbarService.atualizarFlagsSquad(vm.squadsUsuarioLogado);
            vm.squads = [
                { codigo: 1, descricao: 'Alpha', icone: 'alpha.svg', temSquad: flags.temSquadAlpha },
                { codigo: 2, descricao: 'Elite', icone: 'elite.svg', temSquad: flags.temSquadElite },
                { codigo: 3, descricao: 'Partners', icone: 'partners.svg', temSquad: flags.temSquadPartners }
            ].filter(function (squad) {
                return squad.temSquad;
            });
        }

        $scope.$watch(function () {
            return ToolbarService.codigoSquadUsuarioLogado();
        }, function (novoValor, valorAntigo) {
            if (novoValor !== valorAntigo) {
                var squadSelecionado = ToolbarService.squadSelecionado();
                var squadSelecionadoExiste = novoValor.includes(squadSelecionado);

                if (!squadSelecionadoExiste) {
                    vm.codigoSquadAtual = novoValor.length > 0 ? novoValor[0] : 1;
                    ToolbarService.armazenarSquadSelecionado(vm.codigoSquadAtual);
                } else {
                    vm.codigoSquadAtual = squadSelecionado;
                }

                vm.squadsUsuarioLogado = novoValor;
                vm.iconeAtual = ToolbarService.obterIconePadrao(vm.codigoSquadAtual);
                atualizarFlags();
            }
        }, true);

        function alterarSquad(codigo) {
            vm.codigoSquadAtual = codigo;
            vm.iconeAtual = ToolbarService.obterIconePadrao(codigo);
            ToolbarService.armazenarSquadSelecionado(codigo);
        };


        /**
         * Logout Function
         */
        function logout() {
            LoginUsuarioService.logout();
            MenuFactory.removeTodosMenus();
            NotificacaoService.fecharTodasNotificacoes();
            SessionStorageService.removerTodosItens();
            //LocalStorageService.removerTodosItens();
            HubFactory.desconectar();

            $mdToast.show({
                template: '<md-toast id="logout-message" layout="column" layout-align="center start"><div class="md-toast-content">Logout realizado com sucesso !!</div></md-toast>',
                hideDelay: 7000,
                position: 'top right',
                parent: '#content'
            });
            $state.go('app.login', { logout: true });
        }

        /**
         * Toggle horizontal mobile menu
         */
        function toggleHorizontalMobileMenu() {
            vm.bodyEl.toggleClass('ms-navigation-horizontal-mobile-menu-active');
        }

        /**
         * Toggle msNavigation folded
         */
        function toggleMsNavigationFolded() {
            msNavigationService.toggleFolded();
        }

        /**
         * Search action
         *
         * @param query
         * @returns {Promise}
         */
        function search(query) {
            var navigation = [],
                flatNavigation = msNavigationService.getFlatNavigation(),
                deferred = $q.defer();

            // Iterate through the navigation array and
            // make sure it doesn't have any groups or
            // none ui-sref items
            for (var x = 0; x < flatNavigation.length; x++) {
                if (flatNavigation[x].uisref) {
                    navigation.push(flatNavigation[x]);
                }
            }

            // If there is a query, filter the navigation;
            // otherwise we will return the entire navigation
            // list. Not exactly a good thing to do but it's
            // for demo purposes.
            if (query) {
                navigation = navigation.filter(function (item) {
                    if (angular.lowercase(item.title).search(angular.lowercase(query)) > -1) {
                        return true;
                    }
                });
            }

            // Fake service delay
            $timeout(function () {
                deferred.resolve(navigation);
            }, 1000);

            return deferred.promise;
        }

        /**
         * Search result click action
         *
         * @param item
         */
        function searchResultClick(item) {
            // If item has a link
            if (item.uisref) {
                // If there are state params,
                // use them...
                if (item.stateParams) {
                    $state.go(item.state, item.stateParams);
                } else {
                    $state.go(item.state);
                }
            }
        }

        function abrirDialogAlteracaoSenha(event) {
            $mdDialog.show({
                controller: 'DialogAlteracaoSenhaToolbarController',
                controllerAs: 'vm',
                templateUrl: 'app/toolbar/dialogs/dialog-alteracao-senha/dialog-alteracao-senha-toolbar.html',
                //parent: ---------------,
                targetEvent: event,
                clickOutsideToClose: false
            });
        }

        function abrirDialogSenhaImplantacao() {
            $rootScope.loadingProgress = true;

            RequisicaoGenericaService.listarSemParams(Api.modoimplantacao.gerarSenhaImplantacao)
                .then(function (success) {
                    $mdDialog.show({
                        controller: 'DialogSenhaImplantacaoController',
                        controllerAs: 'vm',
                        templateUrl: 'app/toolbar/dialogs/dialog-senha-implantacao/dialog-senha-implantacao.html',
                        targetEvent: null,
                        clickOutsideToClose: false,
                        locals: {
                            SenhaImplantacao: success.data
                        }
                    });

                    $rootScope.loadingProgress = false;
                });
        }

        $rootScope.$on('status-conexao', function (event, status) {
            vm.statusConexao = status;
        })

        $scope.$on('logout', function (event) {
            logout();
        });
    }

})();

(function ()
{
    'use strict';

    /**
     * Main module of the Fuse
     */
    angular
        .module('fuse', [

            // Common 3rd Party Dependencies
            'angular-chartist',
            'chart.js',
            'datatables',
            'gridshore.c3js.chart',
            'nvd3',
            'timer',
            'ui.sortable',
            'ng-sortable',
            'moment-picker',
            'uiGmapgoogle-maps',
            'textAngular',
            'xeditable',
            'ngMask',

            // Core
            'app.core',

            // Navigation
            'app.navigation',

            // Toolbar
            'app.toolbar',

            // Servico
            'app.service',

            // Filtro
            'app.filtro',

            // Factory
            'app.factory',

            // Compartilhado
            'app.compartilhado',

            // Configs
            'app.configs',

            // Constants
            'app.constants',

            // Main
            'app'

        ]);
})();

(function () {
    'use strict';

    angular
        .module('fuse')
        .provider('versaoImanager', getVersaoImanager);

    /** @ngInject */
    function getVersaoImanager() {
        var versao;
        return {
            setVersao: function (value) {
                versao = value;
            },
            $get: function () {
                return versao;
            }
        }
    }

})();

(function () {
    'use strict';

    angular
        .module('fuse')
        .provider('urlApi', geturlApi);

    /** @ngInject */
    function geturlApi(){
        var url;
        return {
            setUrl: function (value) {
                url = value;
            },
            $get: function () {
                return url;
            }
        }
    }

})();

(function () {
    'use strict';

    angular
        .module('fuse')
        .provider('contatos', getContatos);

    /** @ngInject */
    function getContatos() {
        var contatos;
        return {
            setContatos: function (value) {
                contatos = value;
            },
            $get: function () {
                return contatos;
            }
        }
    }

})();

(function ()
{
    'use strict';

    angular
        .module('fuse')
        .controller('MainController', MainController);

    /** @ngInject */
    function MainController($scope, $rootScope)
    {
        // Data

        //////////

        // Remove the splash screen
        $scope.$on('$viewContentAnimationEnded', function (event)
        {
            if ( event.targetScope.$id === $scope.$id )
            {
                $rootScope.$broadcast('msSplashScreen::remove');
            }
        });
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.navigation', [])
        .config(config);

    /** @ngInject */
    function config()
    {
        
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.navigation')
        .controller('NavigationController', NavigationController);

    /** @ngInject */
    function NavigationController($scope)
    {
        var vm = this;

        // Data
        vm.bodyEl = angular.element('body');
        vm.folded = false;
        vm.msScrollOptions = {
            suppressScrollX: true
        };

        // Methods
        vm.toggleMsNavigationFolded = toggleMsNavigationFolded;

        //////////

        /**
         * Toggle folded status
         */
        function toggleMsNavigationFolded()
        {
            vm.folded = !vm.folded;
        }

        // Close the mobile menu on $stateChangeSuccess
        $scope.$on('$stateChangeSuccess', function ()
        {
            vm.bodyEl.removeClass('ms-navigation-horizontal-mobile-menu-active');
        });
    }

})();
(function () {
    'use strict';

    angular
        .module('app.hub')
        .run(runBlock);

    /** @ngInject */
    function runBlock() {
       
    }
})();
(function () {
    'use strict';

    angular
        .module('app.hub')
        .value('$', $)
        .factory('HubFactory', HubFactory);

    function HubFactory($, $rootScope, $timeout, urlApi, MdToastService, LoginUsuarioService, SolicitacaoHubFactory, AtendimentoHubFactory, MensageiroHubFactory,
        ControleAcessoMenuHubFactory, AgendaEventoHubFactory) {
        var _conexao;

        return {
            conectar: _conectar,
            conectando: _conectando,
            conectado: _conectado,
            desconectar: _desconectar,
        }

        function _conectar() {
            _conexao = $.hubConnection(urlApi.url_base_api);
            _conexao.qs = {
                "usuarioCodigo": LoginUsuarioService.usuarioArmazenado().codigo,
                "setorCodigo": LoginUsuarioService.usuarioArmazenado().codigoSetor,
                "perfilCodigo": LoginUsuarioService.usuarioArmazenado().codigoPerfil
            };
            MensageiroHubFactory.construirProxy(_conexao);
            AtendimentoHubFactory.construirProxy(_conexao);
            ControleAcessoMenuHubFactory.construirProxy(_conexao);
            SolicitacaoHubFactory.construirProxy(_conexao);
            AgendaEventoHubFactory.construirProxy(_conexao);

            _conexao.logging = true;
            _conexao.start().done(function () {
                _enviaBroadcastStatusConexao("Conectado")
                console.log("Conexão com o servidor estabelecida");
            })

            _conexao.error(function (error) {
                console.log('SignalR error: ' + error)
            });

            _conexao.disconnected(function () {
                _enviaBroadcastStatusConexao("Desconectado");
                console.log("Não foi possível estabelecer conexão com o servidor");
                if (LoginUsuarioService.usuarioArmazenado()) {
                    $timeout(function () { _conexao.start({ transport: 'webSockets' }).done(function () { }); }, 5000)
                    //_conexao.start();
                }
            });

            _conexao.starting(function () {
                console.log("Conectando com o servidor");
                _enviaBroadcastStatusConexao("Conectando");
            });

            _conexao.received(function () {
                console.log("SignalR recebido")
            });

            _conexao.connectionSlow(function () {
                _enviaBroadcastStatusConexao("Conexão lenta")
                console.log("Conexão com o servidor lenta")
            });

            _conexao.reconnecting(function () {
                _enviaBroadcastStatusConexao("Conectando");
                console.log("Reconectando ao servidor");
            });

            _conexao.reconnected(function () {
                _enviaBroadcastStatusConexao("Conectado");
                console.log("Conexão reestabelecida");

            });

            _conexao.stateChanged(function () {
                console.log("SignalR alteração de estado")
            });

        }

        function _conectando() {
            if (_conexao != null)
                return _conexao.state === 0;
        }

        function _conectado() {
            if (_conexao != null)
                return _conexao.state === 1;
        }

        function _desconectar() {
            if (_conexao != null)
                _conexao.stop();
        }

        function _enviaBroadcastStatusConexao(mensagem) {
            $rootScope.$broadcast('status-conexao', mensagem);
        }
    }

})();

/**
 * Created by nova on 19/08/2016.
 */
(function () {
    'use strict';

    angular
        .module('app.configs', [
            'datatables.scroller',
            'lfNgMdFileInput',
            'angular-linq',
            'ui.utils.masks',
            'treeControl',
            'ngFitText',
            'ui.mask'
        ]);

})();

/**
 * Created by nova on 11/08/2016.
 */
(function () {
    'use strict';

    angular
        .module('app.configs')
        .config(config);

    function config($translatePartialLoaderProvider) {

        // TRADUÇÃO

        // Compartilhado region
        $translatePartialLoaderProvider.addPart('app/compartilhado/mensagens-validacao');
        $translatePartialLoaderProvider.addPart('app/compartilhado/diretivas/toolbar-mobile-desktop');
        $translatePartialLoaderProvider.addPart('app/compartilhado/diretivas/pg-toolbar');
        $translatePartialLoaderProvider.addPart('app/compartilhado/diretivas/proximo-codigo');
        $translatePartialLoaderProvider.addPart('app/compartilhado/diretivas/header-padrao');
        $translatePartialLoaderProvider.addPart('app/compartilhado/diretivas/group-button');
        $translatePartialLoaderProvider.addPart('app/compartilhado/diretivas/group-button-horizontal');

        // endregion

        // Inicio region
        $translatePartialLoaderProvider.addPart('app/main/inicio/');
        // endregion

        // Erros region
        $translatePartialLoaderProvider.addPart('app/main/erros/error-404/');
        $translatePartialLoaderProvider.addPart('app/main/erros/manutencao/');
        // endregion

        // Atendimento region
        $translatePartialLoaderProvider.addPart('app/main/atendimento/cadastro/conclusao-atendimento');
        $translatePartialLoaderProvider.addPart('app/main/atendimento/cadastro/motivo-atendimento');
        $translatePartialLoaderProvider.addPart('app/main/atendimento/cadastro/pendencia-atendimento');

        $translatePartialLoaderProvider.addPart('app/main/atendimento/consulta/atendimento');

        $translatePartialLoaderProvider.addPart('app/main/atendimento/cadastro/configuracao-atendimento');

        $translatePartialLoaderProvider.addPart('app/main/atendimento/processamento/atendimento');

        $translatePartialLoaderProvider.addPart('app/main/atendimento/relatorio/atendimento');
        //endregion

        // Geral region
        $translatePartialLoaderProvider.addPart('app/main/geral/relatorio/');
        $translatePartialLoaderProvider.addPart('app/main/geral/cadastro/cliente/cliente');
        $translatePartialLoaderProvider.addPart('app/main/geral/cadastro/cliente/pendencia-cliente');
        $translatePartialLoaderProvider.addPart('app/main/geral/cadastro/cliente/cargo-cliente');
        $translatePartialLoaderProvider.addPart('app/main/geral/cadastro/cliente/pessoa');

        $translatePartialLoaderProvider.addPart('app/main/geral/cadastro/equipamento/equipamento');
        $translatePartialLoaderProvider.addPart('app/main/geral/cadastro/equipamento/equipamento-tipo');
        $translatePartialLoaderProvider.addPart('app/main/geral/cadastro/equipamento/equipamento-fabricante');
        $translatePartialLoaderProvider.addPart('app/main/geral/cadastro/equipamento/fornecedor');

        $translatePartialLoaderProvider.addPart('app/main/geral/cadastro/endereco/bairro');
        $translatePartialLoaderProvider.addPart('app/main/geral/cadastro/endereco/cidade');

        $translatePartialLoaderProvider.addPart('app/main/geral/cadastro/usuario/usuario');
        $translatePartialLoaderProvider.addPart('app/main/geral/cadastro/usuario/perfil');
        $translatePartialLoaderProvider.addPart('app/main/geral/cadastro/usuario/setor');

        $translatePartialLoaderProvider.addPart('app/main/geral/consulta/log');

        $translatePartialLoaderProvider.addPart('app/main/geral/cadastro/segmentacao');

        $translatePartialLoaderProvider.addPart('app/main/geral/cadastro/caracteristica');

        $translatePartialLoaderProvider.addPart('app/main/geral/cadastro/solucao/produto');
        $translatePartialLoaderProvider.addPart('app/main/geral/cadastro/solucao/solucao');
        $translatePartialLoaderProvider.addPart('app/main/geral/processamento/');
        //endregion


        // Planejamento
        $translatePartialLoaderProvider.addPart('app/main/planejamento-scrum/cadastro/feriado');
        $translatePartialLoaderProvider.addPart('app/main/planejamento-scrum/cadastro/motivo-estoria');
        $translatePartialLoaderProvider.addPart('app/main/planejamento-scrum/cadastro/plataforma');
        $translatePartialLoaderProvider.addPart('app/main/planejamento-scrum/cadastro/registro-situacao');
        $translatePartialLoaderProvider.addPart('app/main/planejamento-scrum/cadastro/situacao-estoria');
        $translatePartialLoaderProvider.addPart('app/main/planejamento-scrum/cadastro/tipo-historia');

        $translatePartialLoaderProvider.addPart('app/main/planejamento-scrum/consulta/estoria');
        $translatePartialLoaderProvider.addPart('app/main/planejamento-scrum/consulta/controle-versao');

        $translatePartialLoaderProvider.addPart('app/main/planejamento-scrum/processamento/estoria');
        $translatePartialLoaderProvider.addPart('app/main/planejamento-scrum/processamento/sprint');
        $translatePartialLoaderProvider.addPart('app/main/planejamento-scrum/processamento/product-backlog');

        // endregion


        // Financeiro
        $translatePartialLoaderProvider.addPart('app/main/financeiro/cadastro/email');
        $translatePartialLoaderProvider.addPart('app/main/financeiro/cadastro/contrato/indice-reajuste');
        $translatePartialLoaderProvider.addPart('app/main/financeiro/cadastro/contrato/motivo-aditivo');
        $translatePartialLoaderProvider.addPart('app/main/financeiro/cadastro/contrato/status-contrato');
        $translatePartialLoaderProvider.addPart('app/main/financeiro/cadastro/contrato/tipo-contrato');
        $translatePartialLoaderProvider.addPart('app/main/financeiro/cadastro/faturamento/forma-pagamento');
        $translatePartialLoaderProvider.addPart('app/main/financeiro/cadastro/faturamento/forma-faturamento');
        $translatePartialLoaderProvider.addPart('app/main/financeiro/cadastro/faturamento/natureza');

        $translatePartialLoaderProvider.addPart('app/main/financeiro/processamento/contratos');
        $translatePartialLoaderProvider.addPart('app/main/financeiro/processamento/envio-de-emails');

        $translatePartialLoaderProvider.addPart('app/main/financeiro/relatorio/contratos');
        $translatePartialLoaderProvider.addPart('app/main/financeiro/relatorio/reajustes');

        // endregion

        // Pipeline
        $translatePartialLoaderProvider.addPart('app/main/pipeline/consulta/estatististica-negocios');
        $translatePartialLoaderProvider.addPart('app/main/pipeline/consulta/projecoes-negocios');

        $translatePartialLoaderProvider.addPart('app/main/pipeline/cadastro/pipeline-funil');
        $translatePartialLoaderProvider.addPart('app/main/pipeline/cadastro/pipeline-motivo-perda-negocio');
        $translatePartialLoaderProvider.addPart('app/main/pipeline/cadastro/pipeline-etapa');

        $translatePartialLoaderProvider.addPart('app/main/pipeline/processamento/pipeline-negocio');

        $translatePartialLoaderProvider.addPart('app/main/pipeline/processamento/pipeline-negocios-vencidos-executivo-responsavel');

        $translatePartialLoaderProvider.addPart('app/main/pipeline/processamento/pipeline-negocios-ganhos-perdidos');
        // endregion

        //#region Controle Acesso menubar
        $translatePartialLoaderProvider.addPart('app/main/controle-acesso-menu');
        $translatePartialLoaderProvider.addPart('app/main/cadastro-menu');
        //#endregion

        //#region Trabalhe Conosco
        $translatePartialLoaderProvider.addPart('app/main/trabalhe-conosco/cadastro/categoria');
        $translatePartialLoaderProvider.addPart('app/main/trabalhe-conosco/cadastro/habilidade');
        $translatePartialLoaderProvider.addPart('app/main/trabalhe-conosco/cadastro/area-atuacao');

        $translatePartialLoaderProvider.addPart('app/main/trabalhe-conosco/processamento/curriculo');
        //#endregion Trabalhe Conosco

        //#region Custo Software
        $translatePartialLoaderProvider.addPart('app/main/gerenciamento-custo');
        //#endregion Custo Software

        //#region Proteção
        $translatePartialLoaderProvider.addPart('app/main/protecao/cadastro/tipo-licenca');
        $translatePartialLoaderProvider.addPart('app/main/protecao/processamento/licenca');
        $translatePartialLoaderProvider.addPart('app/main/protecao/processamento/gerenciamento-protecao');
        $translatePartialLoaderProvider.addPart('app/main/protecao/processamento/atualizacao-licenca');
        $translatePartialLoaderProvider.addPart('app/main/protecao/processamento/atualizacao-cliente');
        //#endregion Proteção

        //#region agenda
        $translatePartialLoaderProvider.addPart('app/main/agenda');
        //#endregion agenda

        //#region solicitacao
        $translatePartialLoaderProvider.addPart('app/main/solicitacao');

        //#endregion solicitacao

        //#region brainstorming
        $translatePartialLoaderProvider.addPart('app/main/geral/brainstorming/brainstorming');
        $translatePartialLoaderProvider.addPart('app/main/geral/brainstorming/visualizacao-ideias');
        //#endregion brainstorming

        //#region implantacao-migracao
        $translatePartialLoaderProvider.addPart('app/main/implantacao-migracao/cadastro/tarefa');
        $translatePartialLoaderProvider.addPart('app/main/implantacao-migracao/cadastro/processo');
        $translatePartialLoaderProvider.addPart('app/main/implantacao-migracao/cadastro/atividade');
        $translatePartialLoaderProvider.addPart('app/main/implantacao-migracao/processamento/processos-finalizados-cancelados');

        //#endregion implantacao-migracao
    }

})();

/**
 * Created by nova on 11/08/2016.
 */
(function () {
    'use strict';

    angular
        .module('app.configs')
        .config(config);

    function config($mdThemingProvider) {
        $mdThemingProvider.theme("success-toast");
        $mdThemingProvider.theme("error-toast")
        $mdThemingProvider.theme("alert-toast")
        $mdThemingProvider.theme("info-toast")
        $mdThemingProvider.theme("aberto-toast")
        $mdThemingProvider.theme("executado-toast")
        $mdThemingProvider.theme("cancelado-toast")
        $mdThemingProvider.theme("ausencia-toast")
    }

})();

/**
 * Created by nova on 11/08/2016.
 */
(function(){
  'use strict';

  angular
    .module('app.configs')
    .config(config);

  function config($httpProvider){
    $httpProvider.interceptors.push("InterceptorRequestFactory");
  }

})();

/**
 * Created by nova on 11/08/2016.
 */
(function(){
  'use strict';

  angular
    .module('app.configs')
    .config(config);

  function config($mdDateLocaleProvider){
    $mdDateLocaleProvider.months = ['Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho', 'Julho',
      'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro'];

    $mdDateLocaleProvider.shortMonths = ['Jan', 'Fev', 'Mar', 'Abr', 'Mai', 'Jun', 'Jul',
      'Ago', 'Set', 'Out', 'Nov', 'Dez'];

    $mdDateLocaleProvider.days = ['Domingo', 'Segunda', 'Terça', 'Quarta', 'Quinta', 'Sexta', 'Sabado', 'Domingo'];

    $mdDateLocaleProvider.shortDays = ['D', 'S', 'T', 'Q', 'Q', 'S', 'S'];

    $mdDateLocaleProvider.msgCalendar = "Calendário";

    $mdDateLocaleProvider.msgOpenCalendar = "Abrir Calendário";

    $mdDateLocaleProvider.formatDate = function(date) {
      if(!date){
        return '';
      }
      return moment(date).format('DD/MM/YYYY');
    };

    $mdDateLocaleProvider.parseDate = function(dateString) {
      var m = moment(dateString, 'DD/MM/YYYY', true);
      return m.isValid() ? m.toDate() : new Date(NaN);
    };

  }

})();

/**
 * Created by nova on 11/08/2016.
 */
(function () {
    'use strict';

    angular
        .module('app.configs')
        .config(config);

  function config($compileProvider, $qProvider) {
        $qProvider.errorOnUnhandledRejections(false);
        $compileProvider.preAssignBindingsEnabled(true);
    }

})();

/**
 * Created by nova on 27/09/2016.
 */
(function () {
    'use strict';

    angular
        .module('app', [
            'app.inicio',
            'app.login',
            'app.hub',
            'app.erros',
            'app.atendimento',
            'app.geral',
            'app.mensageiro',
            'app.planejamentoScrum',
            'app.pipeline',
            'app.financeiro',
            'app.cadastromenu',
            'app.controleAcessoMenu',
            'app.documentosTecnicos',
            'app.trabalheconosco',
            'app.custosoftware',
            'app.protecao',
            'app.agenda',
            'app.solicitacao',
            'app.sqlConsulta',
            'app.locacao',
            'app.manutencao',
            'app.implantacaoMigracao',
            'app.datamobil',
            'app.pesquisa'
        ]);
})();

angular.module('app').service('ListarCoresTagsAtendimento', function () {
    return [
        {
            fonte: '#166534',
            background: '#DCFCE7',
            cor: 'Verde claro'
        },
        {
            fonte: '#1976D2',
            background: '#BBDEFB',
            cor: 'Azul claro'
        },
        {
            fonte: '#3730A3',
            background: '#E0E7FF',
            cor: 'Azul bebê'
        },
        {
            fonte: '#616161',
            background: '#F5F5F5',
            cor: 'Cinza'
        },
        {
            fonte: '#8E24AA',
            background: '#E1BEE7',
            cor: 'Roxo'
        },
        {
            fonte: '#92400E',
            background: '#FEF3C7',
            cor: 'Amarelo'
        },
        {
            fonte: '#9D174D',
            background: '#FCE7F3',
            cor: 'Rosa'
        },
        {
            fonte: '#D32F2F',
            background: '#FFCDD2',
            cor: 'Vermelho'
        },
        {
            fonte: '#F57C00',
            background: '#FFE0B2',
            cor: 'Laranja'
        },
    ];
});

angular.module('app').service('ListarSquads', function() {
    return [
        {
            codigo: 1,
            descricao: 'Alpha'
        },
        {
            codigo: 2,
            descricao: 'Elite'
        },
        {
            codigo: 3,
            descricao: 'Partners'
        }
    ];
});

/**
 * Created by nova on 19/08/2016.
 */
(function(){
  'use strict';

  angular
    .module('app.constants', [

    ]);

})();

(function () {
    'use strict';

    angular
        .module('app.constants')
        .constant('RotasHtml', {

            inicio: {
                templateUrl: 'app/main/inicio/views/inicio.html',
                sidenav: 'app/main/inicio/views/sidenav/sidenav-inicio.html'
            },

            conclusao_atendimento: {
                templateUrl: 'app/main/atendimento/cadastro/conclusao-atendimento/views/conclusao-atendimento.html',
                form: 'app/main/atendimento/cadastro/conclusao-atendimento/views/conclusao-atendimento-form.html',
                tabela: 'app/main/atendimento/cadastro/conclusao-atendimento/views/conclusoes-atendimento-tabela.html'
            },

            tag_atendimento: {
                templateUrl: 'app/main/atendimento/cadastro/tag-atendimento/views/tag-atendimento.html',
                form: 'app/main/atendimento/cadastro/tag-atendimento/views/tag-atendimento-form.html',
                tabela: 'app/main/atendimento/cadastro/tag-atendimento/views/tag-atendimento-tabela.html'
            },

            equipamento_situacao: {
                templateUrl: 'app/main/locacao/cadastro/equipamentos/equipamento-situacao/views/equipamento-situacao.html',
                form: 'app/main/locacao/cadastro/equipamentos/equipamento-situacao/views/equipamento-situacao-form.html',
                tabela: 'app/main/locacao/cadastro/equipamentos/equipamento-situacao/views/equipamento-situacao-tabela.html'
            },

            equipamento_estado_conservacao: {
                templateUrl: 'app/main/locacao/cadastro/equipamentos/equipamento-estado-conservacao/views/equipamento-estado-conservacao.html',
                form: 'app/main/locacao/cadastro/equipamentos/equipamento-estado-conservacao/views/equipamento-estado-conservacao-form.html',
                tabela: 'app/main/locacao/cadastro/equipamentos/equipamento-estado-conservacao/views/equipamento-estado-conservacao-tabela.html'
            },

            equipamento_motivo_baixa: {
                templateUrl: 'app/main/locacao/cadastro/equipamentos/equipamento-motivo-baixa/views/equipamento-motivo-baixa.html',
                form: 'app/main/locacao/cadastro/equipamentos/equipamento-motivo-baixa/views/equipamento-motivo-baixa-form.html',
                tabela: 'app/main/locacao/cadastro/equipamentos/equipamento-motivo-baixa/views/equipamento-motivo-baixa-tabela.html'
            },

            equipamento_fornecedor: {
                templateUrl: 'app/main/locacao/cadastro/equipamentos/equipamento-fornecedor/views/equipamento-fornecedor.html',
                form: 'app/main/locacao/cadastro/equipamentos/equipamento-fornecedor/views/equipamento-fornecedor-form.html',
                tabela: 'app/main/locacao/cadastro/equipamentos/equipamento-fornecedor/views/equipamento-fornecedor-tabela.html'
            },

            equip_tipo: {
                templateUrl: 'app/main/locacao/cadastro/equipamentos/equipamento-tipo/views/equipamento-tipo.html',
                form: 'app/main/locacao/cadastro/equipamentos/equipamento-tipo/views/equipamento-tipo-form.html',
                tabela: 'app/main/locacao/cadastro/equipamentos/equipamento-tipo/views/equipamento-tipo-tabela.html'
            },

            tipo_locacao: {
                templateUrl: 'app/main/locacao/cadastro/tipo-locacao/views/tipo-locacao.html',
                form: 'app/main/locacao/cadastro/tipo-locacao/views/tipo-locacao-form.html',
                tabela: 'app/main/locacao/cadastro/tipo-locacao/views/tipo-locacao-tabela.html'
            },

            nota: {
                templateUrl: 'app/main/locacao/processamento/nota/views/nota.html',
                dialog_nota: 'app/main/locacao/processamento/nota/views/dialogs/dialog-nota/dialog-nota.html',
                dialog_item: 'app/main/locacao/processamento/nota/views/dialogs/dialog-item/dialog-item.html',
                dialog_item_detalhe: 'app/main/locacao/processamento/nota/views/dialogs/dialog-detalhe/dialog-detalhe.html',
                dialog_foto: 'app/main/locacao/processamento/nota/views/dialogs/dialog-foto/dialog-foto-nota.html'

            },

            retorno_locacao: {
                templateUrl: 'app/main/locacao/cadastro/retorno-locacao/views/retorno-locacao.html',
                form: 'app/main/locacao/cadastro/retorno-locacao/views/retorno-locacao-form.html',
                tabela: 'app/main/locacao/cadastro/retorno-locacao/views/retorno-locacao-tabela.html'
            },

            baixa_equipamento: {
                templateUrl: 'app/main/locacao/processamento/baixa-equipamento/views/baixa-equipamento.html',
                form: 'app/main/locacao/cadastro/retorno-locacao/views/retorno-locacao-form.html',
                tabela: 'app/main/locacao/cadastro/retorno-locacao/views/retorno-locacao-tabela.html'
            },

            revenda_equipamento: {
                templateUrl: 'app/main/locacao/processamento/revenda/views/revenda.html'
            },

            objetivo_nota: {
                templateUrl: 'app/main/locacao/cadastro/objetivo-nota/views/objetivo-nota.html',
                form: 'app/main/locacao/cadastro/objetivo-nota/views/objetivo-nota-form.html',
                tabela: 'app/main/locacao/cadastro/objetivo-nota/views/objetivo-nota-tabela.html'
            },

            empresa_ativa: {
                templateUrl: 'app/main/locacao/cadastro/empresa-ativa/views/empresa-ativa.html',
                form: 'app/main/locacao/cadastro/empresa-ativa/views/empresa-ativa-form.html',
                tabela: 'app/main/locacao/cadastro/empresa-ativa/views/empresa-ativa-tabela.html'
            },

            locacao_envio: {
                templateUrl: 'app/main/locacao/processamento/locacao/envio/view/locacao-envio.html',
                form: 'app/main/locacao/processamento/locacao/envio/view/locacao-envio-form.html',
                tabela: 'app/main/locacao/processamento/locacao/envio/view/locacao-envio-tabela.html',
                dialog: {
                    envio: 'app/main/locacao/processamento/locacao/dialogs/dialog-locacao-envio/dialog-locacao-envio.html',
                    estadoConservacao: 'app/main/locacao/processamento/locacao/dialogs/dialog-estado-conservacao/dialog-estado-conservacao.html',
                    salvoComSucesso: 'app/main/locacao/processamento/locacao/dialogs/dialog-salvar/dialog-salvar.html',
                    confirmacao: 'app/main/locacao/processamento/locacao/dialogs/dialog-confirma-envio/dialog-confirma-envio.html',
                    historico: 'app/main/locacao/processamento/locacao/envio/view/dialogs/dialog-historico/dialog-historico.html',
                    zoomFoto: 'app/main/locacao/processamento/locacao/envio/view/dialogs/dialog-zoom-foto/dialog-zoom-foto.html'
                },
                step: {
                    contrato: 'app/main/locacao/processamento/locacao/envio/step/contrato/contrato-step.html',
                    envio: 'app/main/locacao/processamento/locacao/envio/step/envio/envio-step.html',
                }
            },

            locacao_retorno: {
                templateUrl: 'app/main/locacao/processamento/locacao/retorno/view/locacao-retorno.html',
                form: 'app/main/locacao/processamento/locacao/retorno/view/locacao-retorno-form.html',
                tabela: 'app/main/locacao/processamento/locacao/retorno/view/locacao-retorno-tabela.html',
                dialog: {
                    retorno: 'app/main/locacao/processamento/locacao/dialogs/dialog-locacao-retorno/dialog-locacao-retorno.html',
                    estadoConservacao: 'app/main/locacao/processamento/locacao/dialogs/dialog-estado-conservacao/dialog-estado-conservacao.html',
                    estadoConservacaoRetorno: 'app/main/locacao/processamento/locacao/retorno/view/dialogs/dialog-estado-conservacao-retorno/dialog-conservacao.html',
                    salvoComSucesso: 'app/main/locacao/processamento/locacao/dialogs/dialog-salvar/dialog-salvar.html',
                    detalhes: 'app/main/locacao/processamento/locacao/retorno/view/dialogs/dialog-detalhes-envio/dialog-detalhes-envio.html',
                    retornarTodos: 'app/main/locacao/processamento/locacao/retorno/view/dialogs/dialog-retornar-todos/dialog-retornar-todos.html'
                },
                step: {
                    contrato: 'app/main/locacao/processamento/locacao/retorno/step/contrato/contrato-step.html',
                    retorno: 'app/main/locacao/processamento/locacao/retorno/step/retorno/retorno-step.html',
                }

            },

            historico: {
                templateUrl: 'app/main/locacao/consulta/historico/views/historico.html',
                form: 'app/main/locacao/consulta/historico/views/historico-form.html',
                dialogFoto: 'app/main/locacao/consulta/historico/views/dialogs/dialog-foto/dialog-foto.html',
                dialogEstadoConservacao: 'app/main/locacao/consulta/historico/views/dialogs/dialog-estado-conservacao/dialog-estado-conservacao.html'
            },

            consultaLocacao: {
                templateUrl: 'app/main/locacao/consulta/locacao/views/locacao.html',
                form: 'app/main/locacao/consulta/locacao/views/locacao-form.html',
            },

            controle_equipamento: {
                templateUrl: 'app/main/locacao/consulta/controle-equipamento/views/controle-equipamento.html',
                dialogs: {
                    dialogTipo: 'app/main/locacao/consulta/controle-equipamento/views/dialog-tipo/dialog-tipo.html',
                    dialogSituacao: 'app/main/locacao/consulta/controle-equipamento/views/dialog-situacao/dialog-situacao.html',
                    dialogSituacaoFabricante: 'app/main/locacao/consulta/controle-equipamento/views/dialog-situacao-fabricante/dialog-situacao-fabricante.html'
                }
            },

            equipamento_locacao: {
                templateUrl: 'app/main/locacao/cadastro/equipamentos/equipamento/views/equipamento.html',
                form: 'app/main/locacao/cadastro/equipamentos/equipamento/views/equipamento-form.html',
                tabela: 'app/main/locacao/cadastro/equipamentos/equipamento/views/equipamento-tabela.html'
            },

            fabricante: {
                templateUrl: 'app/main/locacao/cadastro/equipamentos/equipamento-fabricante/views/equipamento-fabricante.html',
                form: 'app/main/locacao/cadastro/equipamentos/equipamento-fabricante/views/equipamento-fabricante-form.html',
                tabela: 'app/main/locacao/cadastro/equipamentos/equipamento-fabricante/views/equipamento-fabricante-tabela.html'
            },

            contratosAEncerrar: {
                templateUrl: 'app/main/locacao/consulta/contratos-a-encerrar/views/contratos-a-encerrar.html'
            },

            // Manutenção

            origemPeca: {
                templateUrl: 'app/main/manutencao/cadastro/origem-peca/views/origem-peca.html',
                form: 'app/main/manutencao/cadastro/origem-peca/views/origem-peca-form.html',
                tabela: 'app/main/manutencao/cadastro/origem-peca/views/origem-peca-tabela.html'
            },

            margem: {
                templateUrl: 'app/main/manutencao/cadastro/margem/views/margem.html',
                form: 'app/main/manutencao/cadastro/margem/views/margem-form.html',
                tabela: 'app/main/manutencao/cadastro/margem/views/margem-tabela.html'
            },

            entrada: {
                templateUrl: 'app/main/manutencao/entrada/views/entrada.html',
                form: "app/main/manutencao/entrada/views/entrada-form.html",
                tabela: 'app/main/manutencao/entrada/views/entrada-tabela.html',
                dialogs: {
                    dialog_equipamento_item: 'app/main/manutencao/entrada/views/dialogs/dialog-equipamento-item/dialog-equipamento-item.html',
                    dialog_editar_nota: 'app/main/manutencao/entrada/views/dialogs/dialog-editar-nota/dialog-editar-nota.html'
                }
            },

            tipoServico: {
                templateUrl: 'app/main/manutencao/cadastro/tipo-servico/views/tipo-servico.html',
                form: 'app/main/manutencao/cadastro/tipo-servico/views/tipo-servico-form.html',
                tabela: 'app/main/manutencao/cadastro/tipo-servico/views/tipo-servico-tabela.html',
                dialogs: {
                    dialog_itens: 'app/main/manutencao/consulta/ordem-servico/views/dialogs/dialog-item/dialog-item.html',
                }
            },

            tipoProcedimento: {
                templateUrl: 'app/main/manutencao/cadastro/tipo-procedimento/views/tipo-procedimento.html',
                form: 'app/main/manutencao/cadastro/tipo-procedimento/views/tipo-procedimento-form.html',
                tabela: 'app/main/manutencao/cadastro/tipo-procedimento/views/tipo-procedimento-tabela.html'
            },

            prioridade: {
                templateUrl: 'app/main/manutencao/cadastro/prioridade/views/prioridade.html',
                form: 'app/main/manutencao/cadastro/prioridade/views/prioridade-form.html',
                tabela: 'app/main/manutencao/cadastro/prioridade/views/prioridade-tabela.html'
            },
            tipoEnvio: {
                templateUrl: 'app/main/manutencao/cadastro/tipo-envio/views/tipo-envio.html',
                form: 'app/main/manutencao/cadastro/tipo-envio/views/tipo-envio-form.html',
                tabela: 'app/main/manutencao/cadastro/tipo-envio/views/tipo-envio-tabela.html'
            },

            ordem_servico: {
                templateUrl: 'app/main/manutencao/ordem-servico/views/ordem-servico.html',
                form: 'app/main/manutencao/ordem-servico/views/ordem-servico-form.html',
                dialogs: {
                    dialog_ordem_servico: 'app/main/manutencao/ordem-servico/views/dialogs/dialog-ordem-servico/dialog-ordem-servico.html',
                    dialog_ordem_servico_valor: 'app/main/manutencao/ordem-servico/views/dialogs/dialog-ordem-servico-valor/dialog-ordem-servico-valor.html',
                    dialog_ordem_servico_item: 'app/main/manutencao/ordem-servico/views/dialogs/dialog-ordem-servico-item/dialog-ordem-servico-item.html',
                    dialog_ordem_servico_procedimento: 'app/main/manutencao/ordem-servico/views/dialogs/dialog-ordem-servico-procedimento/dialog-ordem-servico-procedimento.html',
                    dialog_ordem_servico_item_editar: 'app/main/manutencao/ordem-servico/views/dialogs/dialog-ordem-servico-procedimento-editar/dialog-ordem-servico-procedimento-editar.html',
                    dialog_ordem_servico_execucao: 'app/main/manutencao/ordem-servico/views/dialogs/dialog-ordem-servico-execucao/dialog-ordem-servico-execucao.html',
                    dialog_ordem_servico_envio: 'app/main/manutencao/ordem-servico/views/dialogs/dialog-ordem-servico-envio/dialog-ordem-servico-envio.html',
                    dialog_ordem_servico_finalizar: 'app/main/manutencao/ordem-servico/views/dialogs/dialog-ordem-servico-finalizar/dialog-ordem-servico-finalizar.html'
                }
            },

            ordem_servico_consulta: {
                ordem_servico: {
                    templateUrl: 'app/main/manutencao/consulta/ordem-servico/views/consulta-ordem-servico.html',
                }
            },

            dashboard: {
                templateUrl: 'app/main/manutencao/dashboard/views/dashboard.html',
                form: 'app/main/manutencao/dashboard/views/dashboard-form.html',
                dialogs: {
                    dialogOrdensServicoPeriodo: 'app/main/manutencao/dashboard/views/dialogs/dialog-ordens-servico-periodo/dialog-ordens-servico-periodo.html',
                    dialogClientes: 'app/main/manutencao/dashboard/views/dialogs/dialog-clientes/dialog-clientes.html',
                    dialogQuantidadeEquipamento: 'app/main/manutencao/dashboard/views/dialogs/dialog-equipamentos/dialog-equipamentos.html'
                }
            },

            // Manutenção

            motivo_atendimento: {
                templateUrl: 'app/main/atendimento/cadastro/motivo-atendimento/views/motivo-atendimento.html',
                form: 'app/main/atendimento/cadastro/motivo-atendimento/views/motivo-atendimento-form.html',
                tabela: 'app/main/atendimento/cadastro/motivo-atendimento/views/motivos-atendimento-tabela.html'
            },

            pendencia_atendimento: {
                templateUrl: 'app/main/atendimento/cadastro/pendencia-atendimento/views/pendencia-atendimento.html',
                form: 'app/main/atendimento/cadastro/pendencia-atendimento/views/pendencia-atendimento-form.html',
                tabela: 'app/main/atendimento/cadastro/pendencia-atendimento/views/pendencias-atendimento-tabela.html'
            },

            agenda: {
                evento: {
                    templateUrl: 'app/main/agenda/cadastro/evento/views/evento.html',
                    form: 'app/main/agenda/cadastro/evento/views/evento-form.html',
                    tabela: 'app/main/agenda/cadastro/evento/views/evento-tabela.html'
                },
                parametros: {
                    templateUrl: 'app/main/agenda/cadastro/parametros/views/parametros.html',
                    form: 'app/main/agenda/cadastro/parametros/views/parametros-form.html',
                    tabela: 'app/main/agenda/cadastro/parametros/views/parametros-tabela.html'
                },
                atividade: {
                    templateUrl: 'app/main/agenda/processamento/atividade/views/atividade.html',
                    form: 'app/main/agenda/processamento/atividade/views/atividade-form.html',
                    tabela: 'app/main/agenda/processamento/atividade/views/atividade-tabela.html',
                    visualizacao: 'app/main/agenda/processamento/visualizar-atividades/visualizar-atividades.html',
                    dialogs: {
                        dialogAtividade: 'app/main/agenda/processamento/visualizar-atividades/dialogs/atividade-dialog/atividade-dialog.html'
                    }
                }
            },
            atendimento: {
                templateUrl: 'app/main/atendimento/processamento/atendimento/views/atendimento.html',
                form: 'app/main/atendimento/processamento/atendimento/views/atendimento-form.html',
                tabela: 'app/main/atendimento/processamento/atendimento/views/atendimentos-tabela.html',
                atendimentosVinculados: 'app/main/atendimento/processamento/atendimentos-vinculados/atendimentos-vinculados.html',
                tabelaAtendimentosEmAberto: 'app/main/atendimento/processamento/atendimento/atendimentos-em-aberto/atendimentos-em-aberto-tabela.html',
                toolbarAtendimento: 'app/main/atendimento/processamento/atendimento/views/toolbar-atendimento.html',
                historicoAtendimentosTabela: 'app/main/atendimento/processamento/atendimento/views/historico-atendimentos-tabela.html',
                historicoAtendimentoTabelaNaoVisualizado: 'app/main/atendimento/processamento/atendimento/atendimentos-nao-visualizados/' +
                    'historico-atendimentos-tabela-nao-visualizado.html',
                dialogHistorico: 'app/main/atendimento/processamento/atendimento/views/dialogs/' +
                    'historico-dialog/atendimento-dialog-historico.html',
                dialogAcompanhantes: 'app/main/atendimento/processamento/atendimento/views/dialogs/' +
                    'acompanhantes-dialog/atendimento-dialog-acompanhantes.html',
                dialogUsuariosHaVisualizarAtendimento: 'app/main/atendimento/processamento/atendimento/views/dialogs/' +
                    'usuarios-ha-visualizar-atendimento/atendimento-dialog-usuarios-ha-visualizar-atendimento.html',
                dialogUsuariosComAtendimentosEmAbertoDoSetor: 'app/main/atendimento/processamento/atendimento/' +
                    'atendimentos-em-aberto/dialog-tendimentos-em-aberto/atendimento-em-aberto-dialog.html',
                dialogAnexoArquivos: 'app/main/atendimento/processamento/atendimento/views/dialogs/' +
                    'anexos-arquivos-dialog/atendimento-dialog-anexo-arquivos.html',
                dialogSelecionarOS: 'app/main/atendimento/processamento/atendimento/views/dialogs/' +
                    'selecionar-os-dialog/atendimento-dialog-selecionar-os.html',
                dialogVisualizacaoHistoricoAtendimento: 'app/main/atendimento/processamento/atendimento/views/dialogs/' +
                    'dialog-visualizacao-historico-atendimento/dialog-visualizacao-historico-atendimento.html',
                diretiva: {
                    toolbarHistoricoAtendimento: 'app/main/atendimento/processamento/atendimento/diretivas' +
                        '/toolbar-historico-atendimento/toolbar-historico-atendimento.html'
                },
                atualizacoesPendentes: {
                    templateUrl: 'app/main/atendimento/processamento/atualizacoes-pendentes/atualizacoes-pendentes.html',
                    tabela: 'app/main/atendimento/processamento/atualizacoes-pendentes/components/tabela/tabela-atualizacoes-pendentes.html',
                    sidenav: 'app/main/atendimento/processamento/atualizacoes-pendentes/components/sidenav/sidenav-atualizacoes-pendentes.html',
                }
            },
            mensageiro: {
                templateUrl: 'app/main/mensageiro/views/mail.html',
                dialogs: {
                    enviar: 'app/main/mensageiro/dialogs/enviar-mensagem/enviar-mensagem-dialog.html'
                }
            },

            estatisticasTagsAtendimento: {
                templateUrl: 'app/main/atendimento/estatisticas/tags/views/tags-atendimento.html',
                form: 'app/main/atendimento/estatisticas/tags/views/tags-atendimento-form.html',
                components: {
                    sidenav: 'app/main/atendimento/estatisticas/tags/components/sidenavs/filtro/views/filtro-estatisticas-tags.html',
                    graficoTags: 'app/main/atendimento/estatisticas/tags/components/grafico-tags/grafico-tags.html',
                    graficoClientes: 'app/main/atendimento/estatisticas/tags/components/grafico-clientes/grafico-clientes.html',
                    detalhes: 'app/main/atendimento/estatisticas/tags/components/detalhes-atendimento/detalhes-atendimento.html',
                    totalizadorAtendimentos: 'app/main/atendimento/estatisticas/tags/components/totalizador-atendimentos/totalizador-atendimentos.html',
                    dialogs: {
                        detalhesAtendimento: 'app/main/atendimento/estatisticas/tags/components/dialogs/dialog-detalhes-atendimento/dialog-detalhes-atendimento.html',
                        outrasTags: 'app/main/atendimento/estatisticas/tags/components/dialogs/dialog-outras-tags/dialog-outras-tags.html'
                    }
                }
            },
            relatorioAtendimento: {
                templateUrl: 'app/main/atendimento/relatorio/atendimento/views/relatorio-atendimento.html',
                form: 'app/main/atendimento/relatorio/atendimento/views/relatorio-atendimento-form.html'

            },
            manualDesenvolvimento: {
                templateUrl: 'app/main/documentos-tecnicos/manuais-internos/Desenvolvimento/views/manual-desenvolvimento.html',
                sidenav: 'app/main/documentos-tecnicos/manuais-internos/Desenvolvimento/views/sidenav/sidenav-manual-desenvolvimento.html'
            },

            relatorioClientes: {
                templateUrl: "app/main/geral/relatorio/Clientes/views/listagem-simplificada-de-clientes.html",
                form: "app/main/geral/relatorio/Clientes/views/listagem-simplificada.form.html",
                informacoesGerais: 'app/main/geral/relatorio/Clientes/views/step/cliente/informacoes-gerais-steper.html',
                caracteristica: 'app/main/geral/relatorio/Clientes/views/step/caracteristica/caracteristica-step.html',
                produtoSegmentacao: 'app/main/geral/relatorio/Clientes/views/step/produto-segmentacao/produto-segmentacao-step.html',
                licenca: 'app/main/geral/relatorio/Clientes/views/step/licenca/licenca-step.html'

            },
            relatorioControleHoras: {
                templateUrl: 'app/main/geral/relatorio/controle-horas/views/controle-horas.html',
                form: 'app/main/geral/relatorio/controle-horas/views/controle-horas.form.html',
                informacoesGerais: 'app/main/geral/relatorio/controle-horas/views/step/geral/informacoes-gerais-steper.html'
            },
            relatorioContratos: {
                templateUrl: 'app/main/financeiro/relatorio/contratos/views/contratos.html',
                form: 'app/main/financeiro/relatorio/contratos/views/contratos-form.html',
                tabs: {
                    informacoesGerais: 'app/main/financeiro/relatorio/contratos/views/step/informacoes-gerais/informacoes-gerais-step.html',
                    cliente: 'app/main/financeiro/relatorio/contratos/views/step/cliente/cliente-step.html',
                    produtoSegmentacao: 'app/main/financeiro/relatorio/contratos/views/step/produto-segmentacao/produto-segmentacao-step.html',
                    caracteristica: "app/main/financeiro/relatorio/contratos/views/step/caracteristica/caracteristica-step.html",
                    caracteristicaContrato: "app/main/financeiro/relatorio/contratos/views/step/caracteristica-contrato/caracteristica-contrato-step.html",
                    licenca: "app/main/financeiro/relatorio/contratos/views/step/licenca/licenca-step.html"
                }
            },

            relatorioReajustes: {
                templateUrl: 'app/main/financeiro/relatorio/reajustes/views/reajustes.html',
                form: 'app/main/financeiro/relatorio/reajustes/views/reajuste-form.html',
                tabs: {
                    informacoesGerais: 'app/main/financeiro/relatorio/reajustes/views/step/informacoes-gerais/informacoes-gerais.html',
                    produtos: 'app/main/financeiro/relatorio/reajustes/views/step/produtos/produtos.html',
                    clientes: 'app/main/financeiro/relatorio/reajustes/views/step/clientes/cliente-step-reajuste.html',
                    caracteristicas: 'app/main/financeiro/relatorio/reajustes/views/step/caracteristicas-contrato/caracteristicas-contrato.html',
                    tipoLicenca: 'app/main/financeiro/relatorio/reajustes/views/step/tipos-licencas/tipo-licenca.html'
                }
            },

            relatorioRiscoRescisaoContratual: {
                templateUrl: 'app/main/financeiro/relatorio/risco-rescisao-contratual/views/risco-rescisao-contratual.html',
                form: 'app/main/financeiro/relatorio/risco-rescisao-contratual/views/risco-rescisao-contratual-form.html',
                tabela: 'app/main/financeiro/relatorio/risco-rescisao-contratual/components/tabela/tabela-risco-rescisao-contratual.html',
                cardFiltroUtilizado: 'app/main/financeiro/relatorio/risco-rescisao-contratual/components/card-filtro-utilizado/card-filtro-utilizado.html'
            },

            consultaAtendimento: {
                templateUrl: 'app/main/atendimento/consulta/atendimento/views/consulta-atendimento.html',
                consultaAtendimentoForm: 'app/main/atendimento/consulta/atendimento/views/consulta-atendimento-form.html',
                tabelaConsultaAtendimento: 'app/main/atendimento/consulta/atendimento/views/tabela-consulta-atendimento.html'
            },

            consultaAtendimentoEmAberto: {
                templateUrl: 'app/main/atendimento/consulta/atendimento-em-aberto/views/atendimento-em-aberto.html',
            },

            configuracao_atendimento: {
                templateUrl: 'app/main/atendimento/cadastro/configuracao-atendimento/views/configuracao-atendimento.html',
                form: 'app/main/atendimento/cadastro/configuracao-atendimento/views/configuracao-atendimento-form.html',
            },

            erro_404: {
                templateUrl: 'app/main/erros/error-404/error-404.html'
            },
            manutencao: {
                templateUrl: 'app/main/erros/manutencao/manutencao.html'
            },

            cliente: {
                templateUrl: 'app/main/geral/cadastro/cliente/cliente/views/cliente.html',
                form: 'app/main/geral/cadastro/cliente/cliente/views/cliente-form.html',
                tabela: 'app/main/geral/cadastro/cliente/cliente/views/clientes-tabela.html',
                tabs: {
                    cliente: 'app/main/geral/cadastro/cliente/cliente/views/tabs/cliente/tab-cliente.html',
                    configuracoes: 'app/main/geral/cadastro/cliente/cliente/views/tabs/configuracoes/configuracoes-form.html',
                    tabConfiguracaoReader: 'app/main/geral/cadastro/cliente/cliente/views/tabs/configuracoes/tabs/tab-reader/tab-reader-configuracoes.html',
                    tabConfiguracaoiService: 'app/main/geral/cadastro/cliente/cliente/views/tabs/configuracoes/tabs/tab-iservice/tab-iservice-configuracoes.html',
                    tabConfiguracaoiAguas: 'app/main/geral/cadastro/cliente/cliente/views/tabs/configuracoes/tabs/tab-iaguas/tab-iaguas-configuracoes.html',
                    observacoesTecnicas: 'app/main/geral/cadastro/cliente/cliente/views/tabs/observacoes-tecnicas/' +
                        'tab-cliente-observacoes-tecnicas.html',
                    pessoalDeReferencia: 'app/main/geral/cadastro/cliente/cliente/' +
                        'views/tabs/pessoal-de-referencia/tab-cliente-pessoal-de-referencia.html',
                    equipamentos: 'app/main/geral/cadastro/cliente/cliente/' +
                        'views/tabs/equipamentos/tab-cliente-equipamentos.html',
                    dadosAuxiliares: 'app/main/geral/cadastro/cliente/cliente/views/tabs/dados-auxiliares/' +
                        'tab-cliente-dados-auxiliares.html',
                    tabFaturamento: 'app/main/geral/cadastro/cliente/cliente/views/tabs/faturamento/' +
                        'tab-cliente-faturamento.html'
                },
                tabCliente: {
                    dialogAtendimento: {
                        dialog: 'app/main/geral/cadastro/cliente/cliente/views/tabs/cliente/dialogs/' +
                            'atendimento-dialog/cliente-dialog-atendimento.html',
                        tabs: {
                            tabAtendimentosEmAberto: 'app/main/geral/cadastro/cliente/cliente/views/tabs/cliente' +
                                '/dialogs/atendimento-dialog/tabs/atendimentos-em-aberto/cliente-dialog-atendimento-tab-atendimentos-em-aberto.html',
                            todosAtendimentos: 'app/main/geral/cadastro/cliente/cliente/views/tabs/cliente/dialogs' +
                                '/atendimento-dialog/tabs/todos-atendimentos/cliente-dialog-atendimento-tab-todos-atendimentos.html'
                        }
                    },
                    dialogCaracteristica: 'app/main/geral/cadastro/cliente/cliente/views/tabs/cliente/dialogs/caracteristica-dialog/cliente-dialog-caracteristica.html',
                    dialogListaNegocios: 'app/main/pipeline/consulta/estatististica-negocios/dialogs/detalhamento-negocios/detalhamento-negocios-dialog.html',
                    dialogContratos: 'app/main/geral/cadastro/cliente/cliente/views/tabs/cliente/dialogs/contrato-dialog/cliente-dialog-contrato.html',
                    dialogEstatisticasTags: 'app/main/geral/cadastro/cliente/cliente/views/tabs/cliente/dialogs/dialog-estatisticas-tags/dialog-estatisticas-tags.html'
                },
                tabEquipamento: {
                    dialogClienteEquipamento: 'app/main/geral/cadastro/cliente/cliente/views/tabs/equipamentos/dialogs/' +
                        'equipamento-dialog/cliente-equipamento-dialog.html',
                    dialogClienteEquipamentoDetalhes: 'app/main/geral/cadastro/cliente/cliente/views/tabs/equipamentos/dialogs/' +
                        'detalhes-equipamento-dialog/cliente-equipamento-detalhes.html'
                },
                tabPessoaDeReferencia: {
                    dialogPessoaDeReferencia: 'app/main/geral/cadastro/cliente/cliente/views/tabs/pessoal-de-referencia/dialog/cliente-dialog-pessoa-de-referencia.html'
                }
            },

            caracteristica: {
                templateUrl: 'app/main/geral/cadastro/caracteristica/views/caracteristica.html',
                form: 'app/main/geral/cadastro/caracteristica/views/caracteristica-form.html',
                tabela: 'app/main/geral/cadastro/caracteristica/views/caracteristicas-tabela.html',
                tabs: {
                    tabCaracteristica: 'app/main/geral/cadastro/caracteristica/views/tabs/caracteristica/tab-caracteristica.html',
                    tabCliente: 'app/main/geral/cadastro/caracteristica/views/tabs/cliente/tab-cliente.html'
                }
            },

            cargo_cliente: {
                templateUrl: 'app/main/geral/cadastro/cliente/cargo-cliente/views/cargo-cliente.html',
                form: 'app/main/geral/cadastro/cliente/cargo-cliente/views/cargo-cliente-form.html',
                tabela: 'app/main/geral/cadastro/cliente/cargo-cliente/views/cargos-cliente-tabela.html'
            },

            pendencia_cliente: {
                templateUrl: 'app/main/geral/cadastro/cliente/pendencia-cliente/views/pendencia-cliente.html',
                form: 'app/main/geral/cadastro/cliente/pendencia-cliente/views/pendencia-cliente-form.html',
                tabela: 'app/main/geral/cadastro/cliente/pendencia-cliente/views/pendencias-cliente-tabela.html',
            },

            contratos: {
                templateUrl: 'app/main/financeiro/processamento/contratos/views/contratos.html',
                form: 'app/main/financeiro/processamento/contratos/views/contratos-form.html',
                tabela: 'app/main/financeiro/processamento/contratos/views/contratos-tabela.html',
                tabs: {
                    tabContratos: {
                        templateUrl: 'app/main/financeiro/processamento/contratos/views/tabs/tab-contratos/tab-contratos.html',
                    },
                    tabItens: 'app/main/financeiro/processamento/contratos/views/tabs/tab-itens/tab-itens.html',
                    dialogInserirItens: 'app/main/financeiro/processamento/contratos/views/tabs/tab-itens/dialogs/itens-dialog/itens-dialog.html',
                    dialogObservacaoEDataInicial: 'app/main/financeiro/processamento/contratos/views/tabs/tab-itens/dialogs/itens-dialog/observacao-data-inicial-dialog/observacao-data-inicial-dialog.html',
                    tabHistorico: {
                        tab: 'app/main/financeiro/processamento/contratos/views/tabs/tab-historico-contratos/tab-historico-contratos.html',
                        prioritario: 'app/main/financeiro/processamento/contratos/views/tabs/tab-historico-contratos/dialog-prioritario/dialog-prioritario.html',
                        dialog: 'app/main/financeiro/processamento/contratos/views/tabs/tab-historico-contratos/dialog-historico-contratos/dialog-contratos-historico.html',
                    },
                    tabCaracteristicas: 'app/main/financeiro/processamento/contratos/views/tabs/tab-caracteristicas/tab-caracteristicas.html'
                }
            },

            envio_de_emails: {
                templateUrl: 'app/main/financeiro/processamento/envio-de-emails/views/envio-de-emails.html',
                form: 'app/main/financeiro/processamento/envio-de-emails/views/envio-de-emails-form.html'
            },

            indice_reajuste: {
                templateUrl: 'app/main/financeiro/cadastro/contrato/indice-reajuste/views/indice-reajuste.html',
                form: 'app/main/financeiro/cadastro/contrato/indice-reajuste/views/indice-reajuste-form.html',
                tabela: 'app/main/financeiro/cadastro/contrato/indice-reajuste/views/indices-reajuste-tabela.html'
            },

            motivo_aditivo: {
                templateUrl: 'app/main/financeiro/cadastro/contrato/motivo-aditivo/views/motivo-aditivo.html',
                form: 'app/main/financeiro/cadastro/contrato/motivo-aditivo/views/motivo-aditivo-form.html',
                tabela: 'app/main/financeiro/cadastro/contrato/motivo-aditivo/views/motivos-aditivo-tabela.html'
            },

            status_contrato: {
                templateUrl: 'app/main/financeiro/cadastro/contrato/status-contrato/views/status-contrato.html',
                form: 'app/main/financeiro/cadastro/contrato/status-contrato/views/status-contrato-form.html',
                tabela: 'app/main/financeiro/cadastro/contrato/status-contrato/views/status-contratos-tabela.html'
            },

            tipo_contrato: {
                templateUrl: 'app/main/financeiro/cadastro/contrato/tipo-contrato/views/tipo-contrato.html',
                form: 'app/main/financeiro/cadastro/contrato/tipo-contrato/views/tipo-contrato-form.html',
                tabela: 'app/main/financeiro/cadastro/contrato/tipo-contrato/views/tipo-contratos-tabela.html'
            },

            motivo_risco_contratual: {
                templateUrl: 'app/main/financeiro/cadastro/contrato/motivo-risco-contratual/views/motivo-risco-contratual.html',
                form: 'app/main/financeiro/cadastro/contrato/motivo-risco-contratual/views/motivo-risco-contratual-form.html',
                tabela: 'app/main/financeiro/cadastro/contrato/motivo-risco-contratual/views/motivo-risco-contratual-tabela.html'
            },

            equipamento: {
                templateUrl: 'app/main/geral/cadastro/equipamento/equipamento/views/equipamento.html',
                form: 'app/main/geral/cadastro/equipamento/equipamento/views/equipamento-form.html',
                tabela: 'app/main/geral/cadastro/equipamento/equipamento/views/equipamentos-tabela.html',
            },

            equipamento_tipo: {
                templateUrl: 'app/main/geral/cadastro/equipamento/equipamento-tipo/views/equipamento-tipo.html',
                form: 'app/main/geral/cadastro/equipamento/equipamento-tipo/views/equipamento-tipo-form.html',
                tabela: 'app/main/geral/cadastro/equipamento/equipamento-tipo/views/equipamento-tipos-tabela.html',
            },
            equipamento_fabricante: {
                templateUrl: 'app/main/geral/cadastro/equipamento/equipamento-fabricante/views/equipamento-fabricante.html',
                form: 'app/main/geral/cadastro/equipamento/equipamento-fabricante/views/equipamento-fabricante-form.html',
                tabela: 'app/main/geral/cadastro/equipamento/equipamento-fabricante/views/equipamento-fabricantes-tabela.html',
            },

            fornecedor: {
                templateUrl: 'app/main/geral/cadastro/equipamento/fornecedor/views/fornecedor.html',
                form: 'app/main/geral/cadastro/equipamento/fornecedor/views/fornecedor-form.html',
                tabela: 'app/main/geral/cadastro/equipamento/fornecedor/views/fornecedores-tabela.html',
            },

            segmentacao: {
                templateUrl: 'app/main/geral/cadastro/segmentacao/views/segmentacao.html',
                form: 'app/main/geral/cadastro/segmentacao/views/segmentacao-form.html',
                tabela: 'app/main/geral/cadastro/segmentacao/views/segmentacoes-tabela.html',
            },

            financeiroEmail: {
                templateUrl: 'app/main/financeiro/cadastro/email/views/financeiro-email.html',
                form: 'app/main/financeiro/cadastro/email/views/financeiro-email-form.html',
                tabela: 'app/main/financeiro/cadastro/email/views/financeiro-emails-tabela.html'
            },

            naturezaFaturamento: {
                templateUrl: 'app/main/financeiro/cadastro/faturamento/natureza/views/natureza.html',
                form: 'app/main/financeiro/cadastro/faturamento/natureza/views/natureza-form.html',
                tabela: 'app/main/financeiro/cadastro/faturamento/natureza/views/natureza-tabela.html'
            },

            formaPagamento: {
                templateUrl: 'app/main/financeiro/cadastro/faturamento/forma-pagamento/views/forma-pagamento.html',
                form: 'app/main/financeiro/cadastro/faturamento/forma-pagamento/views/forma-pagamento-form.html',
                tabela: 'app/main/financeiro/cadastro/faturamento/forma-pagamento/views/formas-pagamentos-tabela.html',
            },

            formaFaturamento: {
                templateUrl: 'app/main/financeiro/cadastro/faturamento/forma-faturamento/views/forma-faturamento.html',
                form: 'app/main/financeiro/cadastro/faturamento/forma-faturamento/views/forma-faturamento-form.html',
                tabela: 'app/main/financeiro/cadastro/faturamento/forma-faturamento/views/formas-faturamentos-tabela.html',
            },

            pessoa: {
                templateUrl: 'app/main/geral/cadastro/cliente/pessoa/views/pessoa.html',
                form: 'app/main/geral/cadastro/cliente/pessoa/views/pessoa-form.html',
                tabela: 'app/main/geral/cadastro/cliente/pessoa/views/pessoas-tabela.html'
            },

            usuario: {
                templateUrl: 'app/main/geral/cadastro/usuario/usuario/views/usuario.html',
                form: 'app/main/geral/cadastro/usuario/usuario/views/usuario-form.html',
                tabela: 'app/main/geral/cadastro/usuario/usuario/views/usuarios-tabela.html',
                tabs: {
                    tabUsuario: {
                        tab: 'app/main/geral/cadastro/usuario/usuario/views/tabs/usuario/tab-usuario.html',
                        dialogSenha: 'app/main/geral/cadastro/usuario/usuario/views/tabs/usuario/dialogs/senha-usuario/senha-usuario.html'
                    },
                    contato_usuario: 'app/main/geral/cadastro/usuario/usuario/views/tabs/contato-usuario/tab-contato-usuario.html',
                    detalhes_usuario: 'app/main/geral/cadastro/usuario/usuario/views/tabs/' +
                        'detalhes-usuario/tab-detalhes-usuario.html',
                    endereco_usuario: 'app/main/geral/cadastro/usuario/usuario/views/tabs/endereco-usuario/tab-endereco-usuario.html',
                    permissoes_acesso: 'app/main/geral/cadastro/usuario/usuario/views/tabs/permissoes-acesso/tab-permissoes-acesso.html'
                }
            },

            perfil: {
                templateUrl: 'app/main/geral/cadastro/usuario/perfil/views/perfil.html',
                form: 'app/main/geral/cadastro/usuario/perfil/views/perfil-form.html',
                tabela: 'app/main/geral/cadastro/usuario/perfil/views/perfis-tabela.html'
            },

            setor: {
                templateUrl: 'app/main/geral/cadastro/usuario/setor/views/setor.html',
                form: 'app/main/geral/cadastro/usuario/setor/views/setor-form.html',
                tabela: 'app/main/geral/cadastro/usuario/setor/views/setores-tabela.html'
            },

            bairro: {
                templateUrl: 'app/main/geral/cadastro/endereco/bairro/views/bairro.html',
                form: 'app/main/geral/cadastro/endereco/bairro/views/bairro-form.html',
                tabela: 'app/main/geral/cadastro/endereco/bairro/views/bairros-tabela.html'
            },

            cidade: {
                templateUrl: 'app/main/geral/cadastro/endereco/cidade/views/cidade.html',
                form: 'app/main/geral/cadastro/endereco/cidade/views/cidade-form.html',
                tabela: 'app/main/geral/cadastro/endereco/cidade/views/cidades-tabela.html'
            },

            log: {
                templateUrl: 'app/main/geral/consulta/log/views/consulta-log.html',
                consultaTabelaLog: 'app/main/geral/consulta/log/views/consulta-tabela-log.html'
            },

            feriado: {
                templateUrl: 'app/main/planejamento-scrum/cadastro/feriado/views/feriado.html',
                form: 'app/main/planejamento-scrum/cadastro/feriado/views/feriado-form.html',
                tabela: 'app/main/planejamento-scrum/cadastro/feriado/views/feriados-tabela.html'
            },

            motivo_estoria: {
                templateUrl: 'app/main/planejamento-scrum/cadastro/motivo-estoria/views/motivo-estoria.html',
                form: 'app/main/planejamento-scrum/cadastro/motivo-estoria/views/motivo-estoria-form.html',
                tabela: 'app/main/planejamento-scrum/cadastro/motivo-estoria/views/motivos-estoria-tabela.html'
            },

            plataforma: {
                templateUrl: 'app/main/planejamento-scrum/cadastro/plataforma/views/plataforma.html',
                form: 'app/main/planejamento-scrum/cadastro/plataforma/views/plataforma-form.html',
                tabela: 'app/main/planejamento-scrum/cadastro/plataforma/views/plataformas-tabela.html'
            },

            produto: {
                templateUrl: 'app/main/geral/cadastro/solucao/produto/views/produto.html',
                form: 'app/main/geral/cadastro/solucao/produto/views/produto-form.html',
                tabela: 'app/main/geral/cadastro/solucao/produto/views/produtos-tabela.html'
            },

            registroSituacao: {
                templateUrl: 'app/main/planejamento-scrum/cadastro/registro-situacao/views/registro-situacao.html',
                form: 'app/main/planejamento-scrum/cadastro/registro-situacao/views/registro-situacao-form.html',
                tabela: 'app/main/planejamento-scrum/cadastro/registro-situacao/views/registros-situacoes-tabela.html'
            },

            situacao_estoria: {
                templateUrl: 'app/main/planejamento-scrum/cadastro/situacao-estoria/views/situacao-estoria.html',
                form: 'app/main/planejamento-scrum/cadastro/situacao-estoria/views/situacao-estoria-form.html',
                tabela: 'app/main/planejamento-scrum/cadastro/situacao-estoria/views/situacoes-estoria-tabela.html'
            },

            tipoHistoria: {
                templateUrl: 'app/main/planejamento-scrum/cadastro/tipo-historia/views/tipo-historia.html',
                form: 'app/main/planejamento-scrum/cadastro/tipo-historia/views/tipo-historia-form.html',
                tabela: 'app/main/planejamento-scrum/cadastro/tipo-historia/views/tipo-historia-tabela.html'
            },

            consultaControleVersao: {
                templateUrl: 'app/main/planejamento-scrum/consulta/controle-versao/views/consulta-controle-versao.html',
                tabelaControleVersao: 'app/main/planejamento-scrum/consulta/controle-versao/views/consulta-tabela-controle-versao.html'
            },

            consultaEstoria: {
                templateUrl: 'app/main/planejamento-scrum/consulta/estoria/views/consulta-estorias.html',
                dialogInformativo: 'app/main/planejamento-scrum/consulta/estoria/views/dialogs/' +
                    'informativo-dialog/consulta-estorias-dialog-informativo.html',
                dialogAlterarDataEstoria: 'app/main/planejamento-scrum/consulta/estoria/views/dialogs/' +
                    'alterar-data-estoria-dialog/consulta-estorias-dialog-alterar-data-estoria.html'
            },

            estatistica: {
                templateUrl: 'app/main/planejamento-scrum/estatisticas/estatistica/views/consulta-estatistica.html',
                dialogGrafico: 'app/main/planejamento-scrum/estatisticas/estatistica/views/dialogs/consulta-estatistica-dialog.html'
            },

            estoria: {
                templateUrl: 'app/main/planejamento-scrum/processamento/estoria/views/estoria.html',
                form: 'app/main/planejamento-scrum/processamento/estoria/views/estoria-form.html',
                tabela: 'app/main/planejamento-scrum/processamento/estoria/views/estorias-tabela.html',
                tabs: {
                    estoria: 'app/main/planejamento-scrum/processamento/estoria/views/tabs/estoria/tab-estoria.html',
                    estimativa: 'app/main/planejamento-scrum/processamento/estoria/views/tabs/estimativa/tab-estimativa.html',
                    priorizacao: 'app/main/planejamento-scrum/processamento/estoria/views/tabs/priorizacao/tab-priorizacao.html',
                    tarefas: 'app/main/planejamento-scrum/processamento/estoria/views/tabs/tarefas/tab-tarefas.html',
                    historico: 'app/main/planejamento-scrum/processamento/estoria/views/tabs/historico/tab-historico.html',
                    requisito: 'app/main/planejamento-scrum/processamento/estoria/views/tabs/requisito/tab-requisito.html',
                    faturamento: 'app/main/planejamento-scrum/processamento/estoria/views/tabs/faturamento/tab-faturamento.html',
                    clientes: 'app/main/planejamento-scrum/processamento/estoria/views/tabs/clientes/tab-clientes-vinculados.html'

                },
                tabHistorico: {
                    dialogHistorico: 'app/main/planejamento-scrum/processamento/estoria/views/tabs/' +
                        'historico/dialogs/estoria-dialog-historico-situacao.html',
                },
                tabTarefa: {
                    viewDeTarefas: 'app/main/planejamento-scrum/processamento/estoria/views/tabs/' +
                        'tarefas/views/tabela-estoria-tarefas.html',
                    viewParaCriarTarefasPorRotinas: 'app/main/planejamento-scrum/processamento/estoria/views/tabs/' +
                        'tarefas/views/processar-estoria-tarefa-por-rotinas.html',
                    dialogTarefa: 'app/main/planejamento-scrum/processamento/estoria/views/tabs/' +
                        'tarefas/dialogs/tarefa-dialog/estoria-dialog-tarefas.html',
                    dialogAlterarCampoTarefa: 'app/main/planejamento-scrum/processamento/estoria/views/tabs/' +
                        'tarefas/dialogs/alterar-campo-tarefa-dialog/estoria-dialog-alterar-campo-tarefa.html',
                },
                tabClientes: {
                    edicaoClientesVinculadosDialog: 'app/main/planejamento-scrum/processamento/estoria/views/tabs/' +
                        'clientes/edicao-clientes-vinculados-dialog/edicao-clientes-vinculados-dialog.html'
                }
            },
            sprint: {
                templateUrl: 'app/main/planejamento-scrum/processamento/sprint/views/sprint.html',
                form: 'app/main/planejamento-scrum/processamento/sprint/views/sprint-form.html',
                tabela: 'app/main/planejamento-scrum/processamento/sprint/views/sprints-tabela.html',
                tabs: {
                    sprint: 'app/main/planejamento-scrum/processamento/sprint/views/tabs/sprint/tab-sprint.html',
                    backlog: 'app/main/planejamento-scrum/processamento/sprint/views/tabs/backlog/tab-backlog.html',
                    recursos: 'app/main/planejamento-scrum/processamento/sprint/views/tabs/recursos/tab-recursos.html',
                    abatimentos: 'app/main/planejamento-scrum/processamento/sprint/views/tabs/abatimentos/tab-abatimentos.html',
                    registros: 'app/main/planejamento-scrum/processamento/sprint/views/tabs/registros/tab-registros.html',
                    limitesAceitaveis: 'app/main/planejamento-scrum/processamento/sprint/views/tabs/limites/tab-limites.html',
                    metas: 'app/main/planejamento-scrum/processamento/sprint/views/tabs/meta/tab-meta.html',
                    burndown: 'app/main/planejamento-scrum/processamento/sprint/views/tabs/burndown/tab-burndown.html',
                    estatisticas: 'app/main/planejamento-scrum/processamento/sprint/views/tabs/estatisticas/tab-estatisticas.html',
                    cerimoniaDetalhe: 'app/main/planejamento-scrum/processamento/sprint/views/tabs/cerimonia-detalhe/tab-cerimonia-detalhe.html',
                    versaoEntregue: 'app/main/planejamento-scrum/processamento/sprint/views/tabs/versao-entregue/tab-versao-entregue.html',
                    pontuacao: 'app/main/planejamento-scrum/processamento/sprint/views/tabs/pontuacao/tab-pontuacao.html'
                },
                tabBacklog: {
                    tabelaBacklog: 'app/main/planejamento-scrum/processamento/sprint/views/tabs/backlog/views/tabela-backlog.html',
                    cadastroBacklog: 'app/main/planejamento-scrum/processamento/sprint/views/tabs/backlog/views/tabela-cadastro-backlog.html',
                    cadastrarEstoriaEspecificaNoBacklog: 'app/main/planejamento-scrum/processamento/sprint/views/tabs/backlog/dialogs/' +
                        'adicionar-estoria-especifica-dialog/' +
                        'sprint-dialog-backlog-adicionar-estoria-especifica.html',
                    dialogEstoria: 'app/main/planejamento-scrum/processamento/sprint/views/tabs/backlog/dialogs/estoria-dialog/estoria-dialog.html',
                    dialogColaborador: 'app/main/planejamento-scrum/processamento/sprint/views/tabs/backlog/dialogs/' +
                        'colaboradores-dialog/sprint-dialog-backlog-colaboradores.html',
                    dialogEstimativaHoras: 'app/main/planejamento-scrum/processamento/sprint/views/tabs/backlog/dialogs/' +
                        'estimativa-horas-dialog/sprint-dialog-backlog-estimativa-horas.html',
                    dialogEstimativaPontos: 'app/main/planejamento-scrum/processamento/sprint/views/tabs/backlog/dialogs/' +
                        'estimativa-pontos-dialog/sprint-dialog-backlog-estimativa-pontos.html',
                    dialogPriorizacao: 'app/main/planejamento-scrum/processamento/sprint/views/tabs/backlog/dialogs/' +
                        'priorizacao-dialog/sprint-dialog-backlog-priorizacao.html',
                    dialogSituacao: 'app/main/planejamento-scrum/processamento/sprint/views/tabs/backlog/dialogs/' +
                        'situacao-dialog/sprint-dialog-backlog-situacao.html',
                },
                tabBurndown: {
                    dialogBurndown: 'app/main/planejamento-scrum/processamento/sprint/views/tabs/burndown/tab-burndown-grafico.html',
                },
                tabCerimoniaDetalhe: {
                    dialogCerimoniaDetalhe: 'app/main/planejamento-scrum/processamento/sprint/views/tabs/' +
                        'cerimonia-detalhe/dialogs/sprint-dialog-cerimonia-detalhe.html',
                },
                tabMeta: {
                    dialogMeta: 'app/main/planejamento-scrum/processamento/sprint/views/tabs/meta/dialogs/sprint-dialog-meta.html',

                    dialogAcompanhamentoMeta: 'app/main/planejamento-scrum/processamento/sprint/views/tabs/meta/dialogs/acompanhamento-meta-dialog/acompanhamento-meta-dialog.html',

                    dialogInformacaoCalculoMeta: 'app/main/planejamento-scrum/processamento/sprint/views/tabs/meta/dialogs/' +
                        'informacao-calculo-meta-dialog/sprint-dialog-informacao-calculo-meta.html',

                    dialogPontosDesenvolvedor: 'app/main/planejamento-scrum/processamento/sprint/views/tabs/meta/dialogs/acompanhamento-meta-dialog/dialog-desenvolvedores/dialog-pontos-desenvolvedor.html'
                },
                tabRegistro: {
                    dialogRegistro: 'app/main/planejamento-scrum/processamento/sprint/views/tabs/registros/dialogs/sprint-dialog-registros.html',
                },
                tabVersaoEntregue: {
                    dialogVersaoEntregue: 'app/main/planejamento-scrum/processamento/sprint/views/tabs/' +
                        'versao-entregue/dialogs/sprint-dialog-versao-entregue.html',
                },
                tabEstatisticas: {
                    dialogs: {
                        dialogVisualizarEstorias: 'app/main/planejamento-scrum/processamento/sprint/views/tabs/' +
                            'estatisticas/dialogs/visualizar-estorias-dialog/sprint-dialog-estatisticas-visualizar-estorias.html'
                    }
                }
            },

            productBacklog: {
                templateUrl: 'app/main/planejamento-scrum/processamento/product-backlog/views/product-backlog.html',
                dialogAlterarPrioridadeBacklog: 'app/main/planejamento-scrum/processamento/product-backlog/views/' +
                    'dialog-alterar-prioridade/product-backlog-dialog-alterar-prioridade.html',
                dialogAlterarDataEntrega: 'app/main/planejamento-scrum/processamento/product-backlog/views/' +
                    'dialog-alterar-data-entrega/product-backlog-dialog-alterar-data-entrega.html',
                dialogAlterarNecessidadeCliente: 'app/main/planejamento-scrum/processamento/product-backlog/views/' +
                    'dialog-alterar-necessidade-cliente/product-backlog-dialog-alterar-necessidade-cliente.html',
                dialogAdicionarSprint: 'app/main/planejamento-scrum/processamento/product-backlog/views/' +
                    'dialog-adicionar-sprint/product-backlog-dialog-adicionar-sprint-especifica.html',
                dialogAlterarSituacao: 'app/main/planejamento-scrum/processamento/product-backlog/views/' +
                    'dialog-alterar-situacao/product-backlog-dialog-alterar-situacao.html'
            },
            solucao: {
                templateUrl: 'app/main/geral/cadastro/solucao/solucao/views/solucao.html',
                form: 'app/main/geral/cadastro/solucao/solucao/views/solucao-form.html',
                tabela: 'app/main/geral/cadastro/solucao/solucao/views/solucoes-tabela.html',
                tabs: {
                    solucao: 'app/main/geral/cadastro/solucao/solucao/views/tabs/solucao/tab-solucao.html',
                    rotinas: 'app/main/geral/cadastro/solucao/solucao/views/tabs/rotinas/tab-rotinas.html',
                    tarefas: 'app/main/geral/cadastro/solucao/solucao/views/tabs/tarefas/tab-tarefas.html'
                },
                tabRotina: {
                    dialog: 'app/main/geral/cadastro/solucao/solucao/views/tabs/' +
                        'rotinas/dialog-editar-inserir/solucao-rotinas-tarefas-dialog-rotinas.html'
                },
                tabTarefa: {
                    dialog: 'app/main/geral/cadastro/solucao/solucao/views/tabs/tarefas/' +
                        'dialog-editar-inserir/solucao-rotinas-tarefas-dialog-tarefas.html',
                }
            },

            pipeline_motivo_perda_negocio: {
                templateUrl: 'app/main/pipeline/cadastro/pipeline-motivo-perda-negocio/views/pipeline-motivo-perda-negocio.html',
                form: 'app/main/pipeline/cadastro/pipeline-motivo-perda-negocio/views/pipeline-motivo-perda-negocio-form.html',
                tabela: 'app/main/pipeline/cadastro/pipeline-motivo-perda-negocio/views/pipeline-motivo-perda-negocio-tabela.html'
            },

            pipeline_funil: {
                templateUrl: 'app/main/pipeline/cadastro/pipeline-funil/views/pipeline-funil.html',
                form: 'app/main/pipeline/cadastro/pipeline-funil/views/pipeline-funil-form.html',
                tabela: 'app/main/pipeline/cadastro/pipeline-funil/views/pipeline-funil-tabela.html'
            },

            pipeline_etapa: {
                templateUrl: 'app/main/pipeline/cadastro/pipeline-etapa/views/pipeline-etapa.html',
                form: 'app/main/pipeline/cadastro/pipeline-etapa/views/pipeline-etapa-form.html',
                tabela: 'app/main/pipeline/cadastro/pipeline-etapa/views/pipeline-etapas-tabela.html'
            },
            pipeline_consulta: {
                estatistica: {
                    templateUrl: 'app/main/pipeline/consulta/estatististica-negocios/views/estatistica-negocios.html',
                    dashboard_estatisticas: 'app/main/pipeline/consulta/estatististica-negocios/views/estatistica-negocios-dashboard.html',
                    dialogs: {
                        dialogListaNegocios: 'app/main/pipeline/consulta/estatististica-negocios/dialogs/detalhamento-negocios/detalhamento-negocios-dialog.html',
                    },
                },
                projecoes: {
                    templateUrl: 'app/main/pipeline/consulta/projecoes-negocios/views/projecoes-negocios.html',
                    projecoesNegociosPrevisaoFechamento: 'app/main/pipeline/consulta/projecoes-negocios/views/projecoes-negocios-previsao-fechamento.html',
                    projecoesNegocioFinalizacaoEtapa: 'app/main/pipeline/consulta/projecoes-negocios/views/projecoes-negocios-finalizacao-etapa.html',
                    dialogs: {
                        dialogDetalhamentoProjecoesEtapa: 'app/main/pipeline/consulta/projecoes-negocios/dialogs/detalhamento-projecoes-etapa/detalhamento-etapa-dialog.html',
                        dialogDetalhamentoProjecoesNegocios: 'app/main/pipeline/consulta/projecoes-negocios/dialogs/detalhamento-projecoes-negocios/detalhamento-projecoes-negocios-dialog.html'
                    }
                }
            },
            pipeline_negocio: {
                templateUrl: 'app/main/pipeline/processamento/pipeline-negocio/views/pipeline-negocio.html',
                negocios: 'app/main/pipeline/processamento/pipeline-negocio/views/pipeline-negocios/pipeline-negocio-negocios.html',
                funis: 'app/main/pipeline/processamento/pipeline-negocio/views/pipeline-funis/pipeline-funis.html',
                sidenavs: 'app/main/pipeline/processamento/pipeline-negocio/views/pipeline-negocios/sidenavs/filters/filters-sidenav.html',
                dialogs: {
                    dialogInformativoAtividadesEtapa: 'app/main/pipeline/processamento/pipeline-negocio/dialogs/' +
                        'informativo-atividades-etapa/pipeline-etapa-atividade-dialog.html',
                    dialogPipelineNegocio: {
                        templateUrl: 'app/main/pipeline/processamento/pipeline-negocio/dialogs/pipeline-negocio-negocios/' +
                            'pipeline-negocio-negocios-dialog.html',
                        tabs: {
                            tabDadosNegocio: 'app/main/pipeline/processamento/pipeline-negocio/dialogs/pipeline-negocio-negocios/tabs/tab-dados-negocio.html',
                            tabDadosHistorico: 'app/main/pipeline/processamento/pipeline-negocio/dialogs/pipeline-negocio-negocios/tabs/tab-dados-historico.html',
                            tabDadosHistoricoFunil: 'app/main/pipeline/processamento/pipeline-negocio/dialogs/pipeline-negocio-negocios/tabs/tab-historico-alteracao-funil.html'
                        }
                    },
                    dialogEdicaoFunil: {
                        templateUrl: 'app/main/pipeline/processamento/pipeline-negocio/dialogs/pipeline-negocio-negocios/tabs/dialogs/edicao-funil/dialog-edicao-funil.html'
                    },
                    dialogPipelineNegocioResultado: 'app/main/pipeline/processamento/pipeline-negocio/dialogs/pipeline-negocio-resultado/' +
                        'pipeline-negocio-resultado-dialog.html'
                }
            },
            pipeline_negocios_vencidos_executivos_responsavel: {
                templateUrl: 'app/main/pipeline/processamento/pipeline-negocios-vencidos-executivo-responsavel/views/' +
                    'pipeline-negocios-vencidos-executivo-responsavel.html'
            },
            pipeline_negocios_ganhos_perdidos: {
                templateUrl: 'app/main/pipeline/processamento/pipeline-negocios-ganhos-perdidos/views' +
                    '/pipeline-negocios-ganhos-perdidos.html'
            },

            cadastro_menu: {
                templateUrl: 'app/main/cadastro-menu/views/cadastro-menu.html',
                form: 'app/main/cadastro-menu/views/cadastro-menu-form.html',
                dialog: 'app/main/cadastro-menu/views/dialogs/cadastro-menu-dialog.html'
            },

            controle_acesso_menu: {
                templateUrl: 'app/main/controle-acesso-menu/views/controle-acesso-menu.html',
                form: 'app/main/controle-acesso-menu/views/controle-acesso-menu-form.html',
                sidenav_esquerda: 'app/main/controle-acesso-menu/views/sidenavs/esquerda/sidenav-esquerda-controle-acesso-menu.html'
            },

            processamentoCurriculo: {
                templateUrl: 'app/main/trabalhe-conosco/processamento/curriculo/views/curriculo.html',
                processamentoCurriculoForm: 'app/main/trabalhe-conosco/processamento/curriculo/views/processamento-curriculo-form.html',
                tabelaProcessamentoCurriculo: 'app/main/trabalhe-conosco/processamento/curriculo/views/tabela-processamento-curriculo.html',
                dialogs: {
                    dialogHabilidades: 'app/main/trabalhe-conosco/processamento/curriculo/dialogs/candidato-dialog-habilidade.html'
                }
            },

            trabalheConoscoCadastroCategoria: {
                templateUrl: 'app/main/trabalhe-conosco/cadastro/categoria/views/trabalhe-conosco-categoria.html',
                form: 'app/main/trabalhe-conosco/cadastro/categoria/views/trabalhe-conosco-categoria-form.html',
                tabela: 'app/main/trabalhe-conosco/cadastro/categoria/views/trabalhe-conosco-categorias-tabela.html',
                tabs: {
                    categoria: 'app/main/trabalhe-conosco/cadastro/categoria/views/tabs/tab-categoria.html',
                    habilidadesCategoria: 'app/main/trabalhe-conosco/cadastro/categoria/views/tabs/habilidades-categoria/tab-habilidades-categoria.html'
                }
            },

            trabalheConoscoCadastroHabilidade: {
                templateUrl: 'app/main/trabalhe-conosco/cadastro/habilidade/views/trabalhe-conosco-habilidade.html',
                form: 'app/main/trabalhe-conosco/cadastro/habilidade/views/trabalhe-conosco-habilidade-form.html',
                tabela: 'app/main/trabalhe-conosco/cadastro/habilidade/views/trabalhe-conosco-habilidades-tabela.html'
            },

            trabalheConoscoCadastroAreaAtuacao: {
                templateUrl: 'app/main/trabalhe-conosco/cadastro/area-atuacao/views/trabalhe-conosco-areaatuacao.html',
                form: 'app/main/trabalhe-conosco/cadastro/area-atuacao/views/trabalhe-conosco-areaatuacao-form.html',
                tabela: 'app/main/trabalhe-conosco/cadastro/area-atuacao/views/trabalhe-conosco-areaatuacao-tabela.html',
                tabs: {
                    areaAtuacao: 'app/main/trabalhe-conosco/cadastro/area-atuacao/views/tabs/tab-area-atuacao.html',
                    habilidadesAreaAtuacao: 'app/main/trabalhe-conosco/cadastro/area-atuacao/views/tabs/habilidades-area/tab-habilidades-area-atuacao.html',
                    responsabilidadesAreaAtuacao: 'app/main/trabalhe-conosco/cadastro/area-atuacao/views/tabs/responsabilidades-area/tab-responsabilidades-area-atuacao.html'
                }
            },

            controleHorasTrabalhadas: {
                templateUrl: "app/main/geral/processamento/controle-horas-trabalhadas/views/controle-horas-trabalhadas.html",
                form: "app/main/geral/processamento/controle-horas-trabalhadas/views/controle-horas-trabalhadas-form.html",
                tabela: "app/main/geral/processamento/controle-horas-trabalhadas/views/controle-horas-trabalhadas-tabela.html",
                tabs: {
                    geral: "app/main/geral/processamento/controle-horas-trabalhadas/views/tabs/geral/tab-geral.html",
                    historicoViagem: {
                        form: "app/main/geral/processamento/controle-horas-trabalhadas/views/tabs/historico-viagem/tab-historico-viagem.html",
                        dialogHistoricoViagem: "app/main/geral/processamento/controle-horas-trabalhadas/views/tabs/historico-viagem/dialogs/adicionar-historico-viagem/adicionar-historico-viagem-dialog.html",
                        dialogRegistroPonto: "app/main/geral/processamento/controle-horas-trabalhadas/views/tabs/historico-viagem/dialogs/registro-ponto-dialog/registro-ponto-dialog.html"
                    }
                }
            },

            custoSoftware: {
                cadastro: {
                    custo: {
                        templateUrl: 'app/main/gerenciamento-custo/cadastro/custo/views/custo.html',
                        form: 'app/main/gerenciamento-custo/cadastro/custo/views/custo-form.html',
                        tabela: 'app/main/gerenciamento-custo/cadastro/custo/views/custo-tabela.html'
                    },
                    historico: {
                        templateUrl: 'app/main/gerenciamento-custo/cadastro/historico-custo/views/historico-custo.html',
                        form: 'app/main/gerenciamento-custo/cadastro/historico-custo/views/historico-custo-form.html',
                        tabela: 'app/main/gerenciamento-custo/cadastro/historico-custo/views/historico-custo-tabela.html'
                    }
                },
                processamento: {
                    analiseCusto: {
                        templateUrl: 'app/main/gerenciamento-custo/processamento/analise-custo/views/analise-custo.html',
                        form: 'app/main/gerenciamento-custo/processamento/analise-custo/views/analise-custo-form.html',
                        tabela: 'app/main/gerenciamento-custo/processamento/analise-custo/views/analise-custo-tabela.html'
                    }
                }
            },

            msAutoSelecionar: {
                templateUrl: 'app/compartilhado/diretivas/ms-selecionar-multi-valores/view/ms-auto-selecionar-form.html'
            },

            protecaoCadastroTipoLicenca: {
                templateUrl: 'app/main/protecao/cadastro/tipo-licenca/views/protecao-tipo-licenca.html',
                form: 'app/main/protecao/cadastro/tipo-licenca/views/protecao-tipo-licenca-form.html',
                tabela: 'app/main/protecao/cadastro/tipo-licenca/views/protecao-tipo-licenca-tabela.html'
            },

            protecaoProcessamentoLicenca: {
                templateUrl: 'app/main/protecao/processamento/licenca/views/protecao-licenca.html',
                form: 'app/main/protecao/processamento/licenca/views/protecao-licenca-form.html',
                tabela: 'app/main/protecao/processamento/licenca/views/protecao-licencas-tabela.html'
            },
            gerenciamentoProtecao: {
                templateUrl: 'app/main/protecao/processamento/gerenciamento-protecao/views/gerenciamento-protecao.html',
                form: 'app/main/protecao/processamento/gerenciamento-protecao/views/gerenciamento-protecao-form.html',
                dialogs: {
                    quantidadeLicenca: 'app/main/protecao/processamento/gerenciamento-protecao/views/dialog/quantidade-licenca/quantidade-licenca-dialog.html',
                    protecao: 'app/main/protecao/processamento/gerenciamento-protecao/views/dialog/protecao/protecao-dialog.html',
                    detalhes: 'app/main/protecao/processamento/gerenciamento-protecao/views/dialog/detalhes/detalhes-dialog.html'
                }
            },
            protecaoProcessamentoAtualizacaoLicenca: {
                templateUrl: 'app/main/protecao/processamento/atualizacao-licenca/views/protecao-atualizacao-licenca.html',
                form: 'app/main/protecao/processamento/atualizacao-licenca/views/protecao-atualizacao-licenca-form.html',
                tabela: 'app/main/protecao/processamento/atualizacao-licenca/views/protecao-atualizacao-licenca-tabela.html',
                cliente: {
                    templateUrl: 'app/main/protecao/processamento/atualizacao-licenca/step/cliente/cliente-step.html'
                },
                tipoLicenca: {
                    templateUrl: 'app/main/protecao/processamento/atualizacao-licenca/step/tipo-licenca/tipo-licenca-step.html'
                }
            },
            protecaoProcessamentoAtualizacaoCliente: {
                templateUrl: 'app/main/protecao/processamento/atualizacao-cliente/views/protecao-atualizacao-cliente.html',
                form: 'app/main/protecao/processamento/atualizacao-cliente/views/protecao-atualizacao-cliente-form.html',
                steps: {
                    produto: {
                        templateUrl: 'app/main/protecao/processamento/atualizacao-cliente/step/produto/produto-step.html'
                    },
                    contrato: {
                        templateUrl: 'app/main/protecao/processamento/atualizacao-cliente/step/contrato/contrato-step.html'
                    },
                    expiracao: {
                        templateUrl: 'app/main/protecao/processamento/atualizacao-cliente/step/data-expiracao/data-expiracao-step.html'
                    },
                    caracteristicas: {
                        templateUrl: 'app/main/protecao/processamento/atualizacao-cliente/step/caracteristicas/caracteristicas-step.html'
                    }
                }
            },
            solicitacao: {
                fase: {
                    templateUrl: 'app/main/solicitacao/cadastro/fase/views/fase.html',
                    form: 'app/main/solicitacao/cadastro/fase/views/fase-form.html',
                    table: 'app/main/solicitacao/cadastro/fase/views/fase-table.html'
                },
                solicitacao: {
                    templateUrl: 'app/main/solicitacao/processamento/solicitacao/views/solicitacao.html',
                    form: 'app/main/solicitacao/processamento/solicitacao/views/solicitacao-form.html',
                    table: 'app/main/solicitacao/processamento/solicitacao/views/solicitacao-table.html',
                    tabs: {
                        solicitacao: 'app/main/solicitacao/processamento/solicitacao/tabs/solicitacao/tab-solicitacao.html',
                        estimativa: 'app/main/solicitacao/processamento/solicitacao/tabs/estimativa/tab-estimativa.html',
                        documentacao: 'app/main/solicitacao/processamento/solicitacao/tabs/documentacao/tab-documentacao.html',
                        historico: 'app/main/solicitacao/processamento/solicitacao/tabs/historico/tab-historico.html'
                    },
                    dialogs: {
                        editarPontuacao: 'app/main/solicitacao/processamento/solicitacao/tabs/estimativa/dialogs/editar-pontuacao-dialog/editar-pontuacao-dialog.html',
                        documentacaoSolicitacao: 'app/main/solicitacao/processamento/solicitacao/tabs/documentacao/dialogs/documentacao-dialog/documentacao-dialog.html',
                        historicoSolicitacao: 'app/main/solicitacao/dialogs/solicitacao-dialog-historico-solicitacao.html',
                    }
                },
                consultaSolicitacao: {
                    templateUrl: 'app/main/solicitacao/consulta/solicitacao/views/consulta-solicitacao.html',
                    filtro: 'app/main/solicitacao/consulta/solicitacao/views/consulta-solicitacao-filtro.html',
                    resultado: 'app/main/solicitacao/consulta/solicitacao/views/consulta-solicitacao-resultado.html',
                    dialogs: {
                        detalheConsultaSolicitacao: 'app/main/solicitacao/consulta/solicitacao/views/consulta-solicitacao-dialog/consulta-solicitacao-dialog.html',
                        legenda: 'app/main/solicitacao/consulta/solicitacao/views/legenda-dialog/legenda-dialog.html'
                    }
                }
            },
            rotasConsultaSql: {
                templateUrl: 'app/main/sql-consulta/views/sql-consulta.html',
                dialogs: {
                    nomePlanilha: 'app/main/sql-consulta/views/dialogs/dialog-planilha.html'
                }
            },

            brainstorming: {
                brainstorming: {
                    templateUrl: 'app/main/geral/brainstorming/brainstorming/views/brainstorming.html',
                    form: 'app/main/geral/brainstorming/brainstorming/views/brainstorming-form.html',
                    tabela: 'app/main/geral/brainstorming/brainstorming/views/brainstorming-tabela.html',
                    tabs: {
                        tabBrainstorming: 'app/main/geral/brainstorming/brainstorming/views/tabs/brainstorming/tab-brainstorming.html',
                        tabRespostas: {
                            respostas: 'app/main/geral/brainstorming/brainstorming/views/tabs/respostas/tab-respostas.html',
                            dialogResposta: 'app/main/geral/brainstorming/brainstorming/views/tabs/respostas/dialog-resposta/brainstorming-dialog-cadastro-resposta.html'
                        }
                    }
                },
                visualizacaoIdeias: {
                    templateUrl: 'app/main/geral/brainstorming/visualizacao-ideias/views/visualizacao-ideias.html',
                    form: 'app/main/geral/brainstorming/visualizacao-ideias/views/visualizacao-ideias-form.html',
                    dialogStatus: 'app/main/geral/brainstorming/visualizacao-ideias/dialog-status/visualizacao-ideias-dialog-status.html'
                }
            },

            troca_ativo: {
                form: 'app/main/locacao/processamento/troca-ativo/views/troca-ativo-form.html',
                templateUrl: 'app/main/locacao/processamento/troca-ativo/views/troca-ativo.html',
                etapas: {
                    trocaEquipamento: 'app/main/locacao/processamento/troca-ativo/views/etapas/troca-equipamento/troca-equipamento-etapa.html',
                    notaFiscal: 'app/main/locacao/processamento/troca-ativo/views/etapas/nota-fiscal/nota-fiscal-etapa.html',
                    resumoTroca: 'app/main/locacao/processamento/troca-ativo/views/etapas/resumo-troca/resumo-troca-etapa.html'
                }
            },

            implantacaoMigracao: {
                cadastro: {
                    tarefa: {
                        templateUrl: 'app/main/implantacao-migracao/cadastro/tarefa/views/tarefa.html',
                        form: 'app/main/implantacao-migracao/cadastro/tarefa/views/tarefa-form.html',
                        tabela: 'app/main/implantacao-migracao/cadastro/tarefa/views/tarefa-tabela.html'
                    },
                    processo: {
                        templateUrl: 'app/main/implantacao-migracao/cadastro/processo/views/processo.html',
                        form: 'app/main/implantacao-migracao/cadastro/processo/views/processo-form.html',
                        tabela: 'app/main/implantacao-migracao/cadastro/processo/views/processo-tabela.html'
                    },
                    atividade: {
                        templateUrl: 'app/main/implantacao-migracao/cadastro/atividade/views/atividade.html',
                        form: 'app/main/implantacao-migracao/cadastro/atividade/views/atividade-form.html',
                        tabela: 'app/main/implantacao-migracao/cadastro/atividade/views/atividade-tabela.html'
                    }

                },
                processamento: {
                    processosFunis: {
                        templateUrl: 'app/main/implantacao-migracao/processamento/processos-funis/views/processos-funis.html',
                        form: 'app/main/implantacao-migracao/processamento/processos-funis/views/processos-funis-form.html',
                        processoFunil: {
                            templateUrl: 'app/main/implantacao-migracao/processamento/processos-funis/processo-funil/views/processo-funil.html',
                            form: 'app/main/implantacao-migracao/processamento/processos-funis/processo-funil/views/processo-funil-form.html',
                            dialogs: {
                                dialogProcesso: {
                                    templateUrl: 'app/main/implantacao-migracao/processamento/processos-funis/processo-funil/views/dialogs/dialog-processo/dialog-processo.html',
                                    tabs: {
                                        tabDadosProcesso: 'app/main/implantacao-migracao/processamento/processos-funis/processo-funil/views/dialogs/dialog-processo/tabs/tab-dados-processo.html',
                                        tabAtividadesProcesso: 'app/main/implantacao-migracao/processamento/processos-funis/processo-funil/views/dialogs/dialog-processo/tabs/tab-atividades-processo.html',
                                        tabDadosHistorico: 'app/main/implantacao-migracao/processamento/processos-funis/processo-funil/views/dialogs/dialog-processo/tabs/tab-historico-processo.html'
                                    },
                                    edicaoFunil: {
                                        templateUrl: 'app/main/implantacao-migracao/processamento/processos-funis/processo-funil/views/dialogs/dialog-processo/tabs/dialogs/edicao-funil/dialog-edicao-funil.html'
                                    }
                                },
                                dialogObservacaoSubprocesso: {
                                    templateUrl: 'app/main/implantacao-migracao/processamento/processos-funis/processo-funil/views/dialogs/dialog-observacao-subprocesso/dialog-observacao-subprocesso.html'
                                }
                            }
                        }
                    },
                    processosFinalizadosCancelados: {
                        templateUrl: 'app/main/implantacao-migracao/processamento/processos-finalizados-cancelados/views/processos-finalizados-cancelados.html',
                        form: 'app/main/implantacao-migracao/processamento/processos-finalizados-cancelados/views/processos-finalizados-cancelados-form.html'
                    }
                }
            },

            estatisticas: {
                estatisticaIndividual: {
                    form: 'app/main/planejamento-scrum/estatisticas/estatistica-individual/views/estatistica-individual.form.html',
                    templateUrl: 'app/main/planejamento-scrum/estatisticas/estatistica-individual/views/estatistica-individual.html',
                    sidenav: 'app/main/planejamento-scrum/estatisticas/estatistica-individual/sidenavs/filtro/views/filtro-estatistica-individual.html'
                }
            },

            indicadores: {
                gestaoIAguas: {
                    form: 'app/main/geral/indicadores/gestao-iaguas/views/gestao-iaguas.form.html',
                    templateUrl: 'app/main/geral/indicadores/gestao-iaguas/views/gestao-iaguas.html',
                    sidenav: 'app/main/geral/indicadores/gestao-iaguas/sidenavs/filtro/views/filtro-gestao-iaguas.html',
                    dialogs: {
                        informativo: 'app/main/geral/indicadores/gestao-iaguas/dialogs/informativo-gestao-iaguas-dialog/views/informativo-gestao-iaguas-dialog.html'
                    }
                }
            },

            pesquisa: {
                pesquisa: {
                    form: 'app/main/pesquisa/processamento/pesquisa/views/pesquisa-form.html',
                    templateUrl: 'app/main/pesquisa/processamento/pesquisa/views/pesquisa.html',
                    tabs: {
                        pesquisa: 'app/main/pesquisa/processamento/pesquisa/views/tabs/pesquisa/tab-pesquisa.html',
                        perguntas: 'app/main/pesquisa/processamento/pesquisa/views/tabs/perguntas/tab-perguntas.html',
                        respostas: {
                            templateUrl: 'app/main/pesquisa/processamento/pesquisa/views/tabs/respostas/tab-respostas.html',
                            dialogs: {
                                dialogRespostasClientes: 'app/main/pesquisa/processamento/pesquisa/views/tabs/respostas/components/dialogs/repostas-clientes-dialog/repostas-clientes-dialog.html',
                                dialogRespostasClientesGraficos: 'app/main/pesquisa/processamento/pesquisa/views/tabs/respostas/components/dialogs/repostas-grafico-dialog/repostas-grafico-dialog.html'
                            }
                        }
                    },
                    dialogs: {
                        dialogPergunta: 'app/main/pesquisa/processamento/pesquisa/views/tabs/perguntas/dialog-perguntas/dialog-perguntas.html'
                    },
                    tabela: 'app/main/pesquisa/processamento/pesquisa/views/pesquisa-tabela.html'
                },
                tipoPesquisa: {
                    form: 'app/main/pesquisa/cadastro/tipo-pesquisa/views/tipo-pesquisa-form.html',
                    templateUrl: 'app/main/pesquisa/cadastro/tipo-pesquisa/views/tipo-pesquisa.html',
                    tabela: 'app/main/pesquisa/cadastro/tipo-pesquisa/views/tipo-pesquisa-table.html'
                }
            }
        });
})();


(function () {
    'use strict';

    angular
        .module('app.constants')
        .constant('Regex', {
            telefone: /\([1-9]{2}\)\s?[0-9]{4,5}\-[0-9]{4}$/,
            cpf: /^\d{3}\.\d{3}\.\d{3}\-\d{2}$/,
            cnpj: /^\d{2}\.\d{3}\.\d{3}\/\d{4}\-\d{2}$/,
            cpfCnpj: /(^\d{3}\.\d{3}\.\d{3}\-\d{2}$)|(^\d{2}\.\d{3}\.\d{3}\/\d{4}\-\d{2}$)/
        });
})();

/**
 * Created by nova on 19/08/2016.
 */
(function () {
    'use strict';

    angular
        .module('app.constants')
        .constant('DataTableConfigPadrao', {
            dtOptionsPadraoComPaginacaoEReponsivo: {
                dom: 'rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
                initComplete: function () {
                    var api = this.api(),
                        searchBox = angular.element('body').find('#pesquisar');

                    // Bind an external input as a table wide search box
                    if (searchBox.length > 0) {
                        searchBox.on('keyup', function (event) {
                            api.search(event.target.value).draw();
                        });
                    }
                },
                pagingType: 'simple',
                lengthMenu: [10, 15, 20, 25],
                pageLength: 10,
                responsive: true,
            },
            dtOptionsPadraoComPaginacaoPaginTypeNumbersEReponsivo: {
                dom: 'rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
                initComplete: function () {
                    var api = this.api(),
                        searchBox = angular.element('body').find('#pesquisar');

                    // Bind an external input as a table wide search box
                    if (searchBox.length > 0) {
                        searchBox.on('keyup', function (event) {
                            api.search(event.target.value).draw();
                        });
                    }
                },
                pagingType: 'numbers',
                lengthMenu: [100],
                pageLength: 100,
                responsive: true
            },
            dtOptionsPadraoComPaginacaoNaoReponsivo: {
                dom: 'rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
                initComplete: function () {
                    var api = this.api(),
                        searchBox = angular.element('body').find('#pesquisar');

                    // Bind an external input as a table wide search box
                    if (searchBox.length > 0) {
                        searchBox.on('keyup', function (event) {
                            api.search(event.target.value).draw();
                        });
                    }
                },
                pagingType: 'simple',
                lengthMenu: [10, 15, 20, 25],
                pageLength: 10,
                responsive: false,
            },
            dtOptionsResponsivoSemPaginacao: {
                dom: 'rt<"bottom"<"left"<"info"i>>>',
                paging: false,
                responsive: true
            },
            dtOptionsResponsivoSemPaginacaoComInitComplete: {
                dom: 'rt<"bottom"<"left"<"info"i>>>',
                initComplete: function () {
                    var api = this.api(),
                        searchBox = angular.element('body').find('#pesquisar');

                    // Bind an external input as a table wide search box
                    if (searchBox.length > 0) {
                        searchBox.on('keyup', function (event) {
                            api.search(event.target.value).draw();
                        });
                    }
                },
                paging: false,
                responsive: true,
            },
            dtOptionsNaoResponsivoSemPaginacaoComInitComplete: {
                dom: 'rt<"bottom"<"left"<"info"i>>>',
                responsive: false,
                initComplete: function () {
                    var api = this.api(),
                        searchBox = angular.element('body').find('#pesquisar');

                    // Bind an external input as a table wide search box
                    if (searchBox.length > 0) {
                        searchBox.on('keyup', function (event) {
                            api.search(event.target.value).draw();
                        });
                    }
                },
                paging: false
            },
            dtOptionsResponsivoPaginacaoTipoNumberComInitComplete: {
                dom: 'rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
                initComplete: function () {
                    var api = this.api(),
                        searchBox = angular.element('body').find('#pesquisar');

                    // Bind an external input as a table wide search box
                    if (searchBox.length > 0) {
                        searchBox.on('keyup', function (event) {
                            api.search(event.target.value).draw();
                        });
                    }
                },
                pagingType: 'numbers',
                lengthMenu: [10, 30, 50, 100],
                pageLength: 10,
                responsive: true,

            },
            dtOptionsResponsivoComPaginacaoComScrollYEInitComplete: {
                dom: 'rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
                initComplete: function () {
                    var api = this.api(),
                        searchBox = angular.element('body').find('#pesquisar');
                    // Bind an external input as a table wide search box
                    if (searchBox.length > 0) {
                        searchBox.on('keyup', function (event) {
                            api.search(event.target.value).draw();
                        });
                    }
                },
                scrollY: 'auto',
                pagingType: 'numbers',
                lengthMenu: [100],
                pageLength: 100,
                responsive: true,
                order: []
            },
            dtOptionsResponsivoSemPaginacaoComScrollYEInitComplete: {
                dom: 'rt<"bottom"<"left"<"info"i>>>',
                initComplete: function () {
                    var api = this.api(),
                        searchBox = angular.element('body').find('#pesquisar');

                    // Bind an external input as a table wide search box
                    if (searchBox.length > 0) {
                        searchBox.on('keyup', function (event) {
                            api.search(event.target.value).draw();
                        });
                    }
                },
                orderMulti: true,
                scrollY: 'auto',
                responsive: true,
                paging: false
            },
            initComplete: function () {
                var api = this.api(),
                    searchBox = angular.element('body').find('#pesquisar');
                // Bind an external input as a table wide search box
                if (searchBox.length > 0) {
                    searchBox.on('keyup', function (event) {
                        api.search(event.target.value).draw();
                    });
                }
            },
            columnDefsPadrao: {
                targets: 0,
                ordering: false,
                filterable: false,
                sortable: false,
                responsivePriority: 1
            }

        });

})();

(function () {
    'use strict';

    angular
        .module('app.constants')
        .constant('ControleAcessoConfig', {
            configuracao: {
                path_logo_small: '/assets/images/logos/logo-small.png',
                path_logo: '/assets/images/logos/logo.png',
                aplicacao: 'IManager ®',
                descricao_aplicacao: 'Solução de Gerenciamento Empresarial',
                url_base_api: 'http://192.168.0.108:8051/',
                estado_home: 'app.inicio',
                utilizaControleAcesso: true
            },
            key_token: 'ICM_TKN',
            key_usuario: 'ICM_USER',
            retornarUsuario: function () {
                return JSON.parse(sessionStorage.getItem(this.key_usuario));
            },
            usuarioEDirecao: function () {
                var usuario = JSON.parse(sessionStorage.getItem(this.key_usuario));
                if (usuario && usuario.clsSetor &&
                    ((usuario.clsSetor.descricao.toLocaleLowerCase() === 'direção' || usuario.codigoSetor === 6))) {
                    return true;
                } else {
                    return false;
                }
            },
            usuarioEComercial: function () {
                var usuario = JSON.parse(sessionStorage.getItem(this.key_usuario));
                if (usuario && usuario.clsSetor &&
                    ((usuario.clsSetor.descricao.toLocaleLowerCase() === 'comercial' || usuario.codigoSetor === 5))) {
                    return true;
                } else {
                    return false;
                }
            },
            usuarioEAdministrativo: function () {
                var usuario = JSON.parse(sessionStorage.getItem(this.key_usuario));
                if (usuario && usuario.clsSetor &&
                    ((usuario.clsSetor.descricao.toLocaleLowerCase() === 'administrativo' || usuario.codigoSetor === 4))) {
                    return true;
                } else {
                    return false;
                }
            },
            usuarioEDesenvolvimento: function () {
                var usuario = JSON.parse(sessionStorage.getItem(this.key_usuario));
                if (usuario && usuario.clsSetor &&
                    ((usuario.clsSetor.descricao.toLocaleLowerCase() === 'desenvolvimento' || usuario.codigoSetor === 1))) {
                    return true;
                } else {
                    return false;
                }
            },
            ePerfilGerencia: function () {
                var usuario = JSON.parse(sessionStorage.getItem(this.key_usuario));
                if (usuario && usuario.clsPerfil &&
                    ((usuario.clsPerfil.descricao.toLocaleLowerCase() == 'gerência' || usuario.codigoPerfil == 2))) {
                    return true;
                }
                else {
                    return false;
                }
            },
            usuarioEAdministradorSistema: function () {
                var usuario = JSON.parse(sessionStorage.getItem(this.key_usuario));
                if (usuario && usuario.detalhesUsuario && usuario.detalhesUsuario.administradorSistema) {
                    return true;
                }
                else {
                    return false
                }
            },
            usuarioEManutencao: function () {
                var usuario = JSON.parse(sessionStorage.getItem(this.key_usuario));
                if (usuario && usuario.clsSetor &&
                    ((usuario.clsSetor.descricao.toLocaleLowerCase() === 'Manutenção' || usuario.codigoSetor === 12))) {
                    return true;
                } else {
                    return false;
                }
            }
        });
})();

/**
 * Created by nova on 18/07/2016.
 */
/*
  http://192.168.0.108:8051/
  http://localhost:59186/
 */
(function () {
    'use strict';

    angular
        .module('app.constants')
        .constant('Api', {
            listarUltimaVersaoReleaseIManager: 'api/ListarUltimaVersaoReleaseIManager',

            cliente: {
                proximoCodigo: 'api/cliente/RetornaProximoCodigo',
                listarTodos: 'api/cliente/ListarTodos',
                listarPor: 'api/cliente/ListarPor',
                listarComPaginacao: 'api/cliente/ListarComPaginacao',
                listarComPaginacaoDatatable: 'api/cliente/ListarComPaginacaoDatatable',
                listarSituacaoCliente: 'api/cliente/ListarSituacaoCliente',
                listarPorId: 'api/cliente/',
                listarCodigoDescricao: 'api/cliente/ListarCodigoDescricao',
                ListarCodigoDescricaoAtivosContratuaisProduto: 'api/cliente/ListarCodigoDescricaoAtivosContratuais',
                listarPorCodigoENome: 'api/cliente/ListarPorCodigoENome',
                listarPessoasDeReferencia: 'api/cliente/ListarPessoasDeReferencia/',
                listarCaracteristicas: 'api/cliente/ListarCaracteristicas/',
                criar: 'api/cliente',
                atualizar: 'api/cliente',
                cadastrarPessoaDeReferencia: 'api/cliente/CadastrarPessoaDeReferencia',
                cadastrarCaracteristicaCliente: 'api/cliente/CadastrarCaracteristicaCliente',
                excluirPessoaDeReferencia: 'api/cliente/ExcluirPessoaDeReferencia/',
                excluirCaracteristicaCliente: 'api/cliente/ExcluirCaracteristicaCliente/',
                excluir: 'api/cliente/',
                listarComCodigo: 'api/cliente/ListarTodosComProdutos',
                listarTodosComContrato: 'api/cliente/ListarTodosComContrato',
                listarTodosDoLocacaoComContrato: 'api/cliente/ListarTodosDoLocacaoComContrato',
                listarTodosAtivosContratuaisCodigoDescricao: 'api/cliente/ListarTodosAtivosContratuaisCodigoDescricao',
                listarClientesEmpresaFaturamento: 'api/cliente/ListarClientesEmpresaFaturamento'
            },

            locacao: {
                clientes: {
                    listarTodos: 'api/clientes/listarTodos',
                    listarTodosDescricao: 'api/clientes/listarTodosDescricao'
                },
                equipamentos: {
                    equipamento: {
                        listarComPaginacao: 'api/equipamentos/listarPaginacao',
                        criar: 'api/equipamentos/criar',
                        editar: 'api/equipamentos/editar',
                        remover: 'api/equipamentos/remover/',
                        listarComPaginacaoDatatable: 'api/equipamentos/listarPaginacaoDataTable',
                        listarTodos: 'api/equipamentos/listarTodos',
                        listarPorEmpresaAtivo: 'api/equipamentos/listarPorEmpresaAtivo/',
                        listarPorDescricao: 'api/equipamentos/listarPordescricao/',
                        listarPorSituacao: 'api/equipamentos/listarPorSituacao/',
                        listarPorContratoAEncerrar: 'api/equipamentos/listarPorContratoAEncerrar',
                        listarPorCliente: 'api/equipamentos/listarPorCliente/',
                        listarPorContratoTerceiros: 'api/equipamentos/listarPorContratoTerceiros/',
                        listarPorEstadoConservacao: 'api/equipamentos/listarPorEstadoConservacao/',
                        listarPorSituacaoFabricante: 'api/equipamentos/listarPorSituacaoFabricante/',
                        listarPorClienteContratoItem: 'api/equipamentos/listarPorClienteContratoItem/'
                    },
                    equipamentoSituacao: {
                        listarComPaginacao: 'api/equipamentoSituacao/listarPaginacao',
                        criar: 'api/equipamentoSituacao/criar',
                        editar: 'api/equipamentoSituacao/editar',
                        remover: 'api/equipamentoSituacao/remover/',
                        listarComPaginacaoDatatable: 'api/equipamentoSituacao/listarPaginacaoDataTable',
                        listarTodos: 'api/equipamentoSituacao/listarTodos',
                        listarPorFinalizarProcesso: 'api/equipamentoSituacao/listarPorFinalizarProcesso'

                    },
                    estadoConservacao: {
                        listarComPaginacao: 'api/equipamentoEstadoConservacao/listarPaginacao',
                        criar: 'api/equipamentoEstadoConservacao/criar',
                        editar: 'api/equipamentoEstadoConservacao/editar',
                        remover: 'api/equipamentoEstadoConservacao/remover/',
                        listarComPaginacaoDatatable: 'api/equipamentoEstadoConservacao/listarPaginacaoDataTable',
                        listarTodos: 'api/equipamentoestadoconservacao/listarTodos'
                    },

                    motivoBaixa: {
                        listarComPaginacao: 'api/equipamentoMotivoBaixa/listarPaginacao',
                        criar: 'api/equipamentoMotivoBaixa/criar',
                        editar: 'api/equipamentoMotivoBaixa/editar',
                        remover: 'api/equipamentoMotivoBaixa/remover/',
                        listarComPaginacaoDatatable: 'api/equipamentoMotivoBaixa/listarPaginacaoDataTable',
                        listarTodos: 'api/equipamentoMotivoBaixa/listarTodos'

                    },

                    historicoBaixa: {
                        criar: 'api/historicoBaixa/criar'
                    },

                    fornecedor: {
                        listarComPaginacao: 'api/equipamentoFornecedor/listarPaginacao',
                        criar: 'api/equipamentoFornecedor/criar',
                        editar: 'api/equipamentoFornecedor/editar',
                        remover: 'api/equipamentoFornecedor/remover/',
                        listarComPaginacaoDatatable: 'api/equipamentoFornecedor/listarPaginacaoDataTable',
                        listarTodos: 'api/equipamentoFornecedor/listarTodos'

                    },

                    tipo: {
                        listarComPaginacao: 'api/equipamentoTipo/listarPaginacao',
                        listarTodos: 'api/equipamentoTipo/listarTodos',
                        criar: 'api/equipamentoTipo/criar',
                        editar: 'api/equipamentoTipo/editar',
                        remover: 'api/equipamentoTipo/remover/',
                        listarComPaginacaoDatatable: 'api/equipamentoTipo/listarPaginacaoDataTable'

                    },

                    fabricante: {
                        listarComPaginacao: 'api/equipamentoFabricante/listarPaginacao',
                        listarTodos: 'api/equipamentoFabricante/listarTodos',
                        criar: 'api/equipamentoFabricante/criar',
                        editar: 'api/equipamentoFabricante/editar',
                        remover: 'api/equipamentoFabricante/remover/',
                        listarComPaginacaoDatatable: 'api/equipamentoFabricante/listarPaginacaoDataTable'

                    }

                },

                nota: {
                    criar: 'api/equipamentoNota/criar',
                    editar: 'api/equipamentoNota/editar',
                    remover: 'api/equipamentoNota/remover/',
                    listarPorFiltro: 'api/equipamentoNota/listarPorFiltro'
                },

                nota_item: {
                    criar: 'api/equipamentoNotaItem/criar',
                    editar: 'api/equipamentoNotaItem/editar',
                    remover: 'api/equipamentoNotaItem/remover/',
                    listarPorNota: 'api/equipamentoNotaItem/listarPorNota/'
                },

                nota_item_detalhe: {
                    criar: 'api/equipamentoNotaItemDetalhe/criar',
                    editar: 'api/equipamentoNotaItemDetalhe/editar',
                    remover: 'api/equipamentoNotaItemDetalhe/remover/',
                    listarPorItem: 'api/equipamentoNotaItemDetalhe/listarPorItem/',
                    listarTodos: 'api/equipamentoNotaItemDetalhe/listarTodos/',
                    listarDisponiveisEnvio: 'api/equipamentoNotaItemDetalhe/listarDisponiveisEnvio/',
                    listarTodosLocados: 'api/equipamentoNotaItemDetalhe/listarTodosLocados/',
                    listarPorNumeroDeSerie: 'api/equipamentoNotaItemDetalhe/listarPorNumeroDeSerie/',
                    listarPorImei: 'api/equipamentoNotaItemDetalhe/listarPorImei/',
                    listarLocadosPorContrato: 'api/equipamentoNotaItemDetalhe/listarLocadosPorContrato'
                },

                nota_item_detalhe_historico: {
                    listarHistoricos: 'api/equipamentoNotaItemDetalheHistorico/listarhistoricosNumeroSerie/',
                    listarHistoricoPorImei: 'api/equipamentoNotaItemDetalheHistorico/listarhistoricosImei/',
                    editarEstadoConservacao: 'api/equipamentoNotaItemDetalheHistorico/editarEstadoDeConservacao/',
                    listarHistoricoUltimaEmpresaAtivo: 'api/equipamentoNotaItemDetalheHistorico/listarHistoricoUltimaEmpresaAtivo',
                    listarUltimaNotaFiscalEquipamentoNumeroSerie: 'api/equipamentoNotaItemDetalheHistorico/listarUltimaNotaFiscalEquipamentoNumeroSerie/',
                    listarUltimaNotaFiscalEquipamentoImei: 'api/equipamentoNotaItemDetalheHistorico/listarUltimaNotaFiscalEquipamentoImei/'
                },

                equipamentoFoto: {
                    listarFotos: 'api/equipamentoFoto/listarPorHistorico/',
                    listarPorDetalhe: 'api/equipamentoFoto/listarPorDetalhe/',
                    adicionarFotosHistorico: 'api/equipamentoFoto/adicionarFotosHistorico',
                    excluirFotosHistorico: 'api/equipamentoFoto/excluirFotosHistorico'
                },

                tipoLocacao: {
                    listarComPaginacao: 'api/tipoLocacao/listarPaginacao',
                    criar: 'api/tipoLocacao/criar',
                    editar: 'api/tipoLocacao/editar',
                    remover: 'api/tipoLocacao/remover/',
                    listarComPaginacaoDatatable: 'api/tipoLocacao/listarPaginacaoDataTable',
                    listarTodos: 'api/tipolocacao/listarTodos'
                },
                retornoLocacao: {
                    listarComPaginacao: 'api/retornoLocacao/listarPaginacao',
                    criar: 'api/retornoLocacao/criar',
                    editar: 'api/retornoLocacao/editar',
                    remover: 'api/retornoLocacao/remover/',
                    listarComPaginacaoDatatable: 'api/retornoLocacao/listarPaginacaoDataTable',
                    listarTodos: 'api/retornoLocacao/listarTodos'
                },

                equipamentoRevenda: {
                    listarPorSituacao: 'api/equipamentoRevenda/listarPorSituacao',
                    criar: 'api/equipamentoRevenda/criar'
                },

                objetivoNota: {
                    listarComPaginacao: 'api/objetivoNota/listarPaginacao',
                    criar: 'api/objetivoNota/criar',
                    editar: 'api/objetivoNota/editar',
                    remover: 'api/objetivoNota/remover/',
                    listarComPaginacaoDatatable: 'api/objetivoNota/listarPaginacaoDataTable',
                    listarTodos: 'api/objetivoNota/listarTodos'
                },

                empresaAtiva: {
                    listarComPaginacao: 'api/empresaAtiva/listarPaginacao',
                    criar: 'api/empresaAtiva/criar',
                    editar: 'api/empresaAtiva/editar',
                    remover: 'api/empresaAtiva/remover/',
                    listarComPaginacaoDatatable: 'api/empresaAtiva/listarPaginacaoDataTable',
                    listarTodos: 'api/empresaAtiva/listarTodos',
                    listarPorCodigo: 'api/empresaAtiva/listarPorCodigo/'
                },

                locacaoEnvio: {
                    listarComPaginacao: 'api/locacaoEnvio/listarPaginacao',
                    criar: 'api/locacaoEnvio/criar',
                    editar: 'api/locacaoEnvio/editar',
                    remover: 'api/locacaoEnvio/remover/',
                    listarComPaginacaoDatatable: 'api/locacaoEnvio/listarPaginacaoDataTable',
                    ListarTodosComProdutos: 'api/empresaAtiva/ListarTodos/',
                    ListarPorContratoItem: 'api/locacaoEnvio/listarPorContratoItem/',
                    ListarPorNotaSaida: 'api/locacaoEnvio/listarPorNotaSaida/',
                    ListarPorEnvios: 'api/locacaoEnvio/listarPorEnvios',
                    ListarPorEnviosSemRetorno: 'api/locacaoEnvio/listarPorEnviosSemRetorno'
                },

                locacaoRetorno: {
                    listarComPaginacao: 'api/locacaoEnvio/listarPaginacao',
                    criar: 'api/locacaoRetorno/criar',
                    editar: 'api/locacaoRetorno/editar',
                    remover: 'api/locacaoRetorno/remover/',
                    listarComPaginacaoDatatable: 'api/locacaoRetorno/listarPaginacaoDataTable',
                    ListarTodosComProdutos: 'api/empresaAtiva/ListarTodos/',
                    ListarPorContrato: 'api/locacaoRetorno/listarPorContrato/',
                    ListarPorEnvio: 'api/locacaoRetorno/listarPorEnvio/',
                    ListarPorRetornos: 'api/locacaoRetorno/listarPorRetornos'
                },

                trocaAtivo: {
                    listarEquipamentos: 'api/trocaempresaativo/listarEquipamentos',
                    retornarResumoEquipamentosEmpresa: 'api/trocaempresaativo/retornarResumoEquipamentosEmpresa',
                    realizarTrocaAtivo: 'api/trocaempresaativo/realizarTrocaAtivo'
                }
            },

            // Manutenção
            manutencao: {
                origemPeca: {
                    listarComPaginacao: 'api/origemPeca/listarPaginacao',
                    criar: 'api/origemPeca/criar',
                    editar: 'api/origemPeca/editar',
                    remover: 'api/origemPeca/remover/',
                    listarComPaginacaoDatatable: 'api/origemPeca/listarPaginacaoDataTable',
                    listarTodos: 'api/origemPeca/listarTodos',
                    listarApenasAtivo: 'api/origemPeca/listarApenasAtivo'
                },
                margem: {
                    listarComPaginacao: 'api/margem/listarPaginacao',
                    criar: 'api/margem/criar',
                    editar: 'api/margem/editar',
                    remover: 'api/margem/remover/',
                    listarComPaginacaoDatatable: 'api/margem/listarPaginacaoDataTable',
                    listarTodos: 'api/margem/listarTodos'
                },
                entrada: {
                    criar: 'api/equipamentoItem/criar',
                    editar: 'api/equipamentoItem/editar',
                    editarNota: 'api/equipamentoItem/editarNota',
                    remover: 'api/equipamentoItem/remover/',
                    listarComPaginacao: 'api/equipamentoItem/listarPaginacao',
                    listarComPaginacaoDataTable: 'api/equipamentoItem/listarPaginacaoDataTable',
                    listarPorNotaSaida: 'api/equipamentoItem/listarPorNotaSaida/',
                    listarTodosEntrada: 'api/equipamentoItem/listarTodosEntrada'
                },
                tipoServico: {
                    criar: 'api/tipoServico/criar',
                    editar: 'api/tipoServico/editar',
                    remover: 'api/tipoServico/remover/',
                    listarComPaginacao: 'api/tipoServico/listarPaginacao',
                    listarComPaginacaoDataTable: 'api/tipoServico/listarPaginacaoDataTable',
                    listarTodos: 'api/tipoServico/listarTodos'
                },
                tipoProcedimento: {
                    criar: 'api/tipoProcedimento/criar',
                    editar: 'api/tipoProcedimento/editar',
                    remover: 'api/tipoProcedimento/remover/',
                    listarComPaginacao: 'api/tipoProcedimento/listarPaginacao',
                    listarComPaginacaoDataTable: 'api/tipoProcedimento/listarPaginacaoDataTable',
                    listarTodos: 'api/tipoProcedimento/listarTodos'
                },
                prioridade: {
                    criar: 'api/prioridade/criar',
                    editar: 'api/prioridade/editar',
                    remover: 'api/prioridade/remover/',
                    listarComPaginacao: 'api/prioridade/listarPaginacao',
                    listarComPaginacaoDataTable: 'api/prioridade/listarPaginacaoDataTable',
                    listarTodos: 'api/prioridade/listarTodos'
                },
                tipoEnvio: {
                    criar: 'api/tipoEnvio/criar',
                    editar: 'api/tipoEnvio/editar',
                    remover: 'api/tipoEnvio/remover/',
                    listarComPaginacao: 'api/tipoEnvio/listarPaginacao',
                    listarComPaginacaoDataTable: 'api/tipoEnvio/listarPaginacaoDataTable',
                    listarTodos: 'api/tipoEnvio/listarTodos'
                },
                ordem_servico: {
                    criar: 'api/ordem-servico/criar',
                    editar: 'api/ordem-servico/editar',
                    remover: 'api/ordem-servico/remover/',
                    listarProximoCodigo: 'api/ordem-servico/listarProximoCodigo/',
                    listarPorStatus: 'api/ordem-servico/listarPorStatus/',
                    listarPorDataAbertura: 'api/ordem-servico/listarPorDataAbertura/',
                    listarPorCodigo: 'api/ordem-servico/listarPorCodigo/',
                    listarStatusPorDataAbertura: 'api/ordem-servico/listarStatusPorDataAbertura/',
                    listarPorDataAberturaOsExecutadas: 'api/ordem-servico/listarPorDataAberturaOsExecutadas/'
                },
                ordem_servico_item: {
                    criar: 'api/ordem-servico-item/criar',
                    editar: 'api/ordem-servico-item/editar',
                    remover: 'api/ordem-servico-item/remover/',
                    listarPorOS: 'api/ordem-servico-item/listarPorOs/'
                },
                ordem_servico_procedimento: {
                    criar: 'api/ordem-servico-procedimento/criar',
                    editar: 'api/ordem-servico-procedimento/editar',
                    remover: 'api/ordem-servico-procedimento/remover/',
                    listarPorItem: 'api/ordem-servico-procedimento/listarPorItem/'
                },
                ordem_servico_execucao: {
                    criar: 'api/ordem-servico-execucao/criar',
                    editar: 'api/ordem-servico-execucao/editar',
                    listarPorItem: 'api/ordem-servico-execucao/listarPorItem/'
                },
                ordem_servico_envio: {
                    criar: 'api/ordemServicoEnvio/criar',
                    editar: 'api/ordemServicoEnvio/editar',
                    remover: 'api/ordemServicoEnvio/remover/',
                    listarPorOs: 'api/ordemServicoEnvio/listarPorOs/'
                },
                ordem_servico_envio_valores: {
                    criar: 'api/ordemServicoValores/criar',
                    editar: 'api/ordemServicoValores/editar',
                    remover: 'api/ordemServicoValores/remover/',
                    listarPorOS: 'api/ordemServicoValores/listarPorOs/'
                },
                dashboard: {
                    listarPorPeriodo: 'api/ordem-servico/dashboard/listarPorPeriodo/',
                    listarPorCliente: 'api/ordem-servico/dashboard/listarPorCliente/',
                    listarPorTotalizadores: 'api/ordem-servico/dashboard/listarPorTotalizadores/',
                    listarPorTotalizadoresOsExecutadas: 'api/ordem-servico/dashboard/listarPorTotalizadoresOsExecutadas/',
                    listarPorMargem: 'api/ordem-servico/dashboard/margem/',
                    listarPorTotalizadoresEquipamentos: 'api/ordem-servico/dashboard/listarPorTotalizadoresEquipamentos',
                    listarPorClientesQuePossuemOrdemServico: 'api/ordem-servico/listarPorClientesQuePossuemOrdemServico'
                }
            },
            // Manutenção

            cliente_caracteristica: {
                listarPor: 'api/cliente/caracteristica/listarPor',
                listarTodos: 'api/cliente/caracteristica/listarTodos',
                listarCaracteristicas: 'api/cliente/caracteristica/ListarCaracteristicas/',
                cadastrarCaracteristicaCliente: 'api/cliente/caracteristica/CadastrarCaracteristicaCliente',
                excluirCaracteristicaCliente: 'api/cliente/caracteristica/ExcluirCaracteristicaCliente/'
            },

            caracteristica: {
                proximoCodigo: 'api/caracteristica/RetornaProximoCodigo',
                listarPor: 'api/caracteristica/ListarPor',
                listarComPaginacao: 'api/caracteristica/ListarComPaginacao',
                listarComPaginacaoDatatable: 'api/caracteristica/ListarComPaginacaoDatatable',
                criar: 'api/caracteristica',
                atualizar: 'api/caracteristica',
                excluir: 'api/caracteristica/'
            },

            cliente_pendencia: {
                listarPor: 'api/cliente/pendencia/ListarPor',
                listarComPaginacao: 'api/cliente/pendencia/ListarComPaginacao',
                listarComPaginacaoDatatable: 'api/cliente/pendencia/ListarComPaginacaoDatatable',
                criar: 'api/cliente/pendencia',
                atualizar: 'api/cliente/pendencia',
                excluir: 'api/cliente/pendencia/'
            },

            cliente_equipamento: {
                listarPor: 'api/cliente/equipamento/ListarPor',
                listarClienteEquipamentoPorCodigoCliente: 'api/cliente/equipamento/ListarClienteEquipamentoPorCodigoCliente/',
                criar: 'api/cliente/equipamento',
                atualizar: 'api/cliente/equipamento',
                excluir: 'api/cliente/equipamento/'
            },

            cliente_equipamento_detalhe: {
                listarPor: 'api/cliente/equipamento/detalhe/ListarPor',
                listarClienteEquipamentoDetalhePorCodigoClienteEquipamento: 'api/cliente/equipamento/detalhe/' +
                    'ListarClienteEquipamentoDetalhePorCodigoClienteEquipamento/',
                criar: 'api/cliente/equipamento/detalhe',
                atualizar: 'api/cliente/equipamento/detalhe',
                excluir: 'api/cliente/equipamento/detalhe/'
            },

            cliente_configuracao: {
                listarPor: 'api/cliente/configuracao/ListarPor',
                criar: 'api/cliente/configuracao',
                atualizar: 'api/cliente/configuracao',
                excluir: 'api/cliente/configuracao/'
            },

            contrato: {
                listarContratosPorCliente: 'api/contrato/ListarContratosPorCliente/',
                listarContratosAtivoPorCliente: 'api/contrato/ListarContratosAtivoPorCliente/',
                listarComPaginacao: 'api/contrato/ListarComPaginacao',
                listarValoresContratos: "api/contrato/ListarInformacoesContratuais/",
                listarComPaginacaoDatatable: 'api/contrato/ListarComPaginacaoDatatable',
                listarInformacoesDataExpiracao: 'api/contrato/ListarInformacoesDataExpiracao',
                listarProdutosAtivos: 'api/contrato/ListarProdutosAtivos',
                listarCaracteristicas: 'api/contrato/ListarCaracteristicas/',
                criar: 'api/contrato',
                atualizar: 'api/contrato',
                excluir: 'api/contrato/',
                atualizarDataExpiracao: 'api/contrato/AtualizarDataExpiracao',
                relatorio_contrato: 'api/contratos/relatorio/GerarRelatorioContratoItem',
                relatorio_reajuste: 'api/contratos/relatorio/GerarRelatorioReajuste',
                vincularCaracteristica: 'api/contratos/vincularCaracteristica',

                contrato_item: {
                    editar: 'api/contrato/contrato-item',
                    listarPorContrato: 'api/contrato/contrato-item/listarPorContrato/',
                    listarAtivosPorContrato: 'api/contrato/contrato-item/ListarAtivosPorContrato/'
                },

                indice_reajuste: {
                    listarPor: 'api/contrato/indice-reajuste/ListarPor',
                    listarComPaginacao: 'api/contrato/indice-reajuste/ListarComPaginacao',
                    listarComPaginacaoDatatable: 'api/contrato/indice-reajuste/ListarComPaginacaoDatatable',
                    criar: 'api/contrato/indice-reajuste',
                    atualizar: 'api/contrato/indice-reajuste',
                    excluir: 'api/contrato/indice-reajuste/'
                },
                motivo_aditivo: {
                    listarPor: 'api/contrato/motivo-aditivo/ListarPor',
                    ListarComPaginacao: 'api/contrato/motivo-aditivo/ListarComPaginacao',
                    listarComPaginacaoDatatable: 'api/contrato/motivo-aditivo/ListarComPaginacaoDatatable',
                    criar: 'api/contrato/motivo-aditivo',
                    atualizar: 'api/contrato/motivo-aditivo',
                    excluir: 'api/contrato/motivo-aditivo/'
                },
                status_contrato: {
                    listarPor: 'api/contrato/status-contrato/ListarPor',
                    listarComPaginacao: 'api/contrato/status-contrato/ListarComPaginacao',
                    listarComPaginacaoDatatable: 'api/contrato/status-contrato/ListarComPaginacaoDatatable',
                    criar: 'api/contrato/status-contrato',
                    atualizar: 'api/contrato/status-contrato',
                    excluir: 'api/contrato/status-contrato/'
                },

                motivo_risco_contratual: {
                    listarPor: 'api/contrato/motivo-risco-contratual/ListarPor',
                    listarComPaginacao: 'api/contrato/motivo-risco-contratual/ListarComPaginacao',
                    listarTodos: 'api/contrato/motivo-risco-contratual/ListarTodos',
                    listarComPaginacaoDatatable: 'api/contrato/motivo-risco-contratual/ListarComPaginacaoDatatable',
                    criar: 'api/contrato/motivo-risco-contratual',
                    atualizar: 'api/contrato/motivo-risco-contratual',
                    excluir: 'api/contrato/motivo-risco-contratual/',
                    listarTodosMotivos: 'api/contrato/motivo-risco-contratual/ListarTodos'
                },

                tipo_contrato: {
                    listarPor: 'api/contrato/tipo-contrato/ListarPor',
                    listarComPaginacao: 'api/contrato/tipo-contrato/ListarComPaginacao',
                    listarTodos: 'api/contrato/tipo-contrato/ListarTodos',
                    listarComPaginacaoDatatable: 'api/contrato/tipo-contrato/ListarComPaginacaoDatatable',
                    criar: 'api/contrato/tipo-contrato',
                    atualizar: 'api/contrato/tipo-contrato',
                    excluir: 'api/contrato/tipo-contrato/'
                },

                historico_contrato: {
                    listarHistoricoPorContrato: 'api/contrato/historico/ListarHistoricoPorContrato/',
                    criar: 'api/contrato/historico',
                    atualizar: 'api/contrato/historico',
                    excluir: 'api/contrato/historico/',
                    atualizarPrioritario: 'api/contrato/historico/atualizarPrioritario'
                }
            },

            contrato_caracteristica: {
                listarPor: 'api/contrato/caracteristica/listarpor',
                listarTodos: 'api/contrato/caracteristica/listartodos',
                listarCaracteristicas: 'api/contrato/caracteristica/listarCaracteristicas',
                vincularCaracteristica: 'api/contrato/caracteristica/vincularCaracteristica',
                excluirCaracteristica: 'api/contrato/caracteristica/ExcluirCaracteristicaContrato',
                listarTodasCaracteristicasItem: 'api/contrato/caracteristica/listarTodasCaracteristicasItem'
            },
            equipamento: {
                listarPor: 'api/equipamento/ListarPor',
                listarComPaginacao: 'api/equipamento/ListarComPaginacao',
                listarComPaginacaoDatatable: 'api/equipamento/ListarComPaginacaoDatatable',
                listarEquipamentoPorTerceiros: 'api/equipamento/ListarEquipamentoPorTerceiros/',
                listarTodos: 'api/equipamento/listarTodos/',
                criar: 'api/equipamento',
                atualizar: 'api/equipamento',
                excluir: 'api/equipamento/',

                equipamento_tipo: {
                    listarPor: 'api/equipamento/tipo/ListarPor',
                    listarComPaginacao: 'api/equipamento/tipo/ListarComPaginacao',
                    listarComPaginacaoDatatable: 'api/equipamento/tipo/ListarComPaginacaoDatatable',
                    criar: 'api/equipamento/tipo',
                    atualizar: 'api/equipamento/tipo',
                    excluir: 'api/equipamento/tipo/'
                },
                equipamento_fabricante: {
                    listarPor: 'api/equipamento/fabricante/ListarPor',
                    listarComPaginacao: 'api/equipamento/fabricante/ListarComPaginacao',
                    listarComPaginacaoDatatable: 'api/equipamento/fabricante/ListarComPaginacaoDatatable',
                    criar: 'api/equipamento/fabricante',
                    atualizar: 'api/equipamento/fabricante',
                    excluir: 'api/equipamento/fabricante/'
                }
            },

            fornecedor: {
                listarPor: 'api/fornecedor/ListarPor',
                listarComPaginacao: 'api/fornecedor/ListarComPaginacao',
                listarComPaginacaoDatatable: 'api/fornecedor/ListarComPaginacaoDatatable',
                listarTodos: 'api/fornecedor/ListarTodos',
                criar: 'api/fornecedor',
                atualizar: 'api/fornecedor',
                excluir: 'api/fornecedor/'
            },

            segmentacao: {
                retornaProximoCodigo: 'api/segmentacao/RetornaProximoCodigo',
                listarPor: 'api/segmentacao/ListarPor',
                listarComPaginacao: 'api/segmentacao/ListarComPaginacao',
                listarComPaginacaoDatatable: 'api/segmentacao/ListarComPaginacaoDatatable',
                criar: 'api/segmentacao',
                atualizar: 'api/segmentacao',
                excluir: 'api/segmentacao/'
            },

            formaPagamento: {
                proximoCodigo: 'api/formapagamento/proximocodigo',
                listarTodos: 'api/formapagamento/listartodos',
                listarPor: 'api/formapagamento/listarpor',
                listarPorCodigo: 'api/formapagamento/listarporcodigo',
                listarComPaginacao: 'api/formapagamento/listarcompaginacao',
                listarComPaginacaoDatatable: 'api/formapagamento/listarcompaginacaodatatable',
                criar: 'api/formapagamento/',
                atualizar: 'api/formapagamento',
                excluir: 'api/formapagamento/'
            },

            formaFaturamento: {
                proximoCodigo: 'api/formafaturamento/proximocodigo',
                listarTodos: 'api/formafaturamento/listartodos',
                listarPor: 'api/formafaturamento/listarpor',
                listarPorCodigo: 'api/formafaturamento/listarporcodigo',
                listarComPaginacao: 'api/formafaturamento/listarcompaginacao',
                listarComPaginacaoDatatable: 'api/formafaturamento/listarcompaginacaodatatable',
                criar: 'api/formafaturamento/',
                atualizar: 'api/formafaturamento',
                excluir: 'api/formafaturamento/'
            },

            naturezaFaturamento: {
                listarTodos: 'api/contrato/natureza-faturamento/listartodos',
                listarPor: 'api/contrato/natureza-faturamento/listarpor',
                listarComPaginacao: 'api/contrato/natureza-faturamento/ListarComPaginacao',
                listarComPaginacaoDatatable: 'api/contrato/natureza-faturamento/ListarComPaginacaoDatatable',
                listarAtivos: 'api/contrato/natureza-faturamento/ListarAtivos',
                criar: 'api/contrato/natureza-faturamento/',
                atualizar: 'api/contrato/natureza-faturamento/',
                excluir: 'api/contrato/natureza-faturamento/'
            },

            financeiroEmail: {
                listarTodos: 'api/financeiro/email/ListarTodos',
                listarTodosCodigoEEmail: 'api/financeiro/email/ListarTodosCodigoEEmail',
                listarComPaginacao: 'api/financeiro/email/ListarComPaginacao',
                listarComPaginacaoDatatable: 'api/financeiro/email/ListarComPaginacaoDatatable',
                criar: 'api/financeiro/email/',
                atualizar: 'api/financeiro/email/',
                excluir: 'api/financeiro/email/',
                listarTodosDiretoriosCertidoes: 'api/financeiro/email/ListarTodosDiretoriosCertidoes'
            },

            financeiroEnvioDeEmails: {
                enviarEmails: 'api/financeiro/email/enviodeemails'
            },

            pessoa: {
                proximoCodigo: 'api/pessoa/RetornaProximoCodigo',
                listarPor: 'api/pessoa/ListarPor',
                listarPorCodigoENome: 'api/pessoa/ListarPorCodigoENome',
                listarComPaginacao: 'api/pessoa/ListarComPaginacao',
                listarComPaginacaoDatatable: 'api/pessoa/ListarComPaginacaoDatatable',
                criar: 'api/pessoa',
                atualizar: 'api/pessoa',
                excluir: 'api/pessoa/'
            },

            cargo: {
                proximoCodigo: 'api/cargo/RetornaProximoCodigo',
                listarPor: 'api/cargo/ListarPor',
                listarComPaginacao: 'api/cargo/ListarComPaginacao',
                listarComPaginacaoDatatable: 'api/cargo/ListarComPaginacaoDatatable',
                criar: 'api/cargo',
                atualizar: 'api/cargo',
                excluir: 'api/cargo/'
            },

            mensageiro: {
                enviar: 'api/mensageiro/EnviarMensagem',
                listarMensagens: 'api/mensageiro/ListarCaixaEntrada/',
                listarMensagensEnviadas: 'api/mensageiro/ListarCaixaSaida/',
                listarMensagensArquivadas: 'api/mensageiro/ListarMensagensArquivadas/',
                listarMensagensImportantes: 'api/mensageiro/ListarMensagensImportantes/',
                listarHistoricoMensagem: 'api/mensageiro/ListarHistoricoMensagem?identificadorMensagem=',
                marcarComoImportante: 'api/mensageiro/MarcarImportante',
                marcarComoArquivado: 'api/mensageiro/Arquivar',
                marcarComoLido: 'api/mensageiro/AlterarStatus',
                pesquisar: 'api/mensageiro/Pesquisar/',
                mensagensNaoLidas: 'api/mensageiro/MensagensNaoLidas/',
                procuraMensagemPeloId: 'api/mensageiro/ProcurarMensagemPeloIdentificador/'
            },

            relatorio: {
                abrirRelatorio: 'api/relatorio/abrirRelatorio/?nomeArquivo='
            },

            atendimento: {
                retornaProximoAtendimento: 'api/atendimento/RetornarProximoAtendimetno',
                retornarAtendimentoPorCodigoCliente: 'api/atendimento/RetornarAtendimentoPorCodigoCliente/',
                retornarAtendimentoPorCodigoClienteLocacao: 'api/atendimento/RetornarAtendimentoPorCodigoClienteLocacao/',
                listarAtendimentosPorCodigoCliente: 'api/atendimento/ListarAtendimentosPorCodigoCliente',
                listarPor: 'api/atendimento/ListarPor',
                listarComPaginacaoDatatable: 'api/atendimento/ListarComPaginacaoDatatable',
                listarComPaginacaoDatatabeAtendimentosNaoVisualizados: 'api/atendimento/listarComPaginacaoDatatabeAtendimentosNaoVisualizados/',
                listarComPaginacaoDatatabeAtendimentosEmAberto: 'api/atendimento/listarComPaginacaoDatatabeAtendimentosEmAberto/',
                listarAtendimentosEmAbertoUsuariosPorGerenteDatatable: 'api/atendimento/ListarAtendimentosEmAbertoUsuariosPorGerenteDatatable/',
                listarPaginacao: 'api/atendimento/ListarComPaginacao',
                pesquisarAutoComplete: 'api/atendimento/PesquisarAutoComplete',
                listarDetalhesAtendimentos: 'api/atendimento/ListarDetalhesAtendimentos',
                criar: 'api/atendimento',
                atualizar: 'api/atendimento',
                excluir: 'api/atendimento/',
                verificarSeExisteCodigoAtendimento: 'api/atendimento/VerificarSeExisteCodigoAtendimento/',
                verificarSeExisteAnoAtendimento: 'api/atendimento/VerificarSeExisteAnoAtendimento/',
                listarAtendimentosDoClientePorUsuarioCorrente: 'api/atendimento/ListarAtendimentosDoClientePorUsuarioCorrente/',
                listarTiposAtendimento: 'api/atendimento/ListarTiposAtendimento',
                listarTiposAtendimentoGeral: 'api/atendimento/ListarTiposAtendimentoGeral',
                listarTipoDetalheAtendimento: 'api/atendimento/ListarTipoDetalheAtendimento',
                listarStatusAtendimento: 'api/atendimento/ListarStatusAtendimento',
                listarStatusAtendimentoGeral: 'api/atendimento/ListarStatusAtendimentoGeral',
                listarAtendimentosNaoVisualizados: 'api/atendimento/ListarAtendimentosNaoVisualizados/',
                listarAtendimentosImportantes: 'api/atendimento/ListarAtendimentosImportantes/',
                listarQuantidadeAtendimentosNaoVisualizados: 'api/atendimento/ListarQuantidadeAtendimentosNaoVisualizados/',
                listarAtendimentosEmAbertoDoUsuario: 'api/atendimento/ListarAtendimentosEmAbertoDoUsuario/',
                listarAtendimentosEmAbertoUsuariosPorGerente: 'api/atendimento/ListarAtendimentosEmAbertoUsuariosPorGerente',
                listarQuantidadeAtendimentosEmAberto: 'api/atendimento/ListarQuantidadeAtendimentosEmAberto/',
                listarQuantidadeAtendimentosImportantesEmAberto: 'api/atendimento/ListarQuantidadeAtendimentosImportantesEmAberto/',
                listarUsuariosComAtendimentoEmAbertoPorSetor: 'api/atendimento/ListarUsuariosComAtendimentoEmAbertoPorSetor/',
                listarAtendimentosComDataVencida: 'api/atendimento/ListarAtendimentosComDataVencida/',
                listarAtendimentosVinculados: "api/atendimento/listarAtendimentosVinculadosDoUsuario/",
                listarAtendimentoAbertosPorCliente: 'api/atendimento/ListarAbertosPorCliente',
                verificaSeExisteAtendimentosExcedidosPorSetor: 'api/atendimento/VerificaSeExisteAtendimentosExcedidosPorSetor/',
                consultarHistoriasVinculadas: "api/atendimento/ConsultarHistoriasVinculadas/",
                existePendenciaAtualizacao: "api/cliente/ExistePendenciaAtualizacao",

                anexo_arquivo: {
                    enviarArquivo: 'api/atendimento/anexoArquivo/uploadarquivo/',
                    listarArquivos: 'api/atendimento/anexoArquivo/ListarArquivos/',
                    excluirArquivo: 'api/atendimento/anexoArquivo/',
                    baixarArquivo: 'api/atendimento/anexoArquivo/BaixarArquivo'
                },

                consulta_atendimento: {
                    consultarAtendimentos: 'api/atendimento/ConsultarAtendimentos'
                },

                relatorio_atendimento: {
                    gerarRelatorioAtendimento: 'api/relatorio/atendimento/GerarRelatorioAtendimento'
                },

                estatisticas_atendimento: {
                    tags: {
                        listarEstatisticasTags: 'api/atendimento/estatisticas/tags'
                    }
                },

                configuracao_atendimento: {
                    listarConfiguracao: 'api/atendimento/configuracao/ListarConfiguracao',
                    atualizar: 'api/atendimento/configuracao'
                },

                historico: {
                    retornarProximoNumeroDaSequencia: 'api/atendimento/historico/RetornarProximoNumeroDaSequencia/',
                    listarPor: 'api/atendimento/historico/ListarPor',
                    listarHistoricoPorAtendimento: 'api/atendimento/historico/ListarHistoricoPorAtendimento/',
                    criar: 'api/atendimento/historico',
                    atualizar: 'api/atendimento/historico',
                    excluir: 'api/atendimento/historico/'
                },

                acompanhamento: {
                    listarAcompanhamentoPorAtendimento: 'api/atendimento/acompanhamento/ListarAcompanhamentoPorAtendimento/',
                    listarAcompanhamentoPorAtendimentoEUsuario: 'api/atendimento/acompanhamento/ListarAcompanhamentoPorAtendimentoEUsuario/',
                    listarAcompanhantesPorAtendimentoAtualizandoVisualizado: 'api/atendimento/acompanhamento/ListarAcompanhantesPorAtendimentoAtualizandoVisualizado/',
                    atualizarImportanciaAtendimento: 'api/atendimento/acompanhamento/AtualizarImportanciaAtendimento',
                    criar: 'api/atendimento/acompanhamento',
                    atualizar: 'api/atendimento/acompanhamento',
                    excluir: 'api/atendimento/acompanhamento/'
                },

                usuario_ha_visualizar_atendimento: {
                    listarAcompanhamentoVisualizacaoPorAtendimento: 'api/atendimento/acompanhamento-visualizacao/ListarAcompanhamentoVisualizacaoPorAtendimento/',
                    vincularUsuariosComTipoAtendimentoComercial: 'api/atendimento/acompanhamento-visualizacao/VincularUsuariosComTipoAtendimentoComercial',
                    vincularUsuariosComTipoAtendimentoComercialEmMemoria: 'api/atendimento/acompanhamento-visualizacao/' +
                        'VincularUsuariosComTipoAtendimentoComercialEmMemoria',
                    criar: 'api/atendimento/acompanhamento-visualizacao',
                    atualizar: 'api/atendimento/acompanhamento-visualizacao',
                    atualizarSigiloComercialAtendimento: 'api/atendimento/acompanhamento-visualizacao/AtualizarSigiloComercialAtendimento',
                    excluir: 'api/atendimento/acompanhamento-visualizacao/',
                    removerUsuariosHaVisualizarDoAtendimento: 'api/atendimento/acompanhamento-visualizacao/RemoverUsuariosHaVisualizarDoAtendimento/'
                },

                grupo_atendimento: {
                    proximoCodigo: 'api/atendimento/grupoAtendimento/RetornaProximoCodigo',
                    listarPor: 'api/atendimento/grupoAtendimento/ListarPor',
                    listarMotivoPorSetor: 'api/atendimento/grupoAtendimento/ListarMotivoPorSetor/',
                    listarComPaginacao: 'api/atendimento/grupoAtendimento/ListarComPaginacao',
                    listarComPaginacaoDatatable: 'api/atendimento/grupoAtendimento/ListarComPaginacaoDatatable',
                    criar: 'api/atendimento/grupoAtendimento',
                    atualizar: 'api/atendimento/grupoAtendimento',
                    excluir: 'api/atendimento/grupoAtendimento/'
                },

                pendencia_atendimento: {
                    proximoCodigo: 'api/atendimento/pendenciaAtendimento/RetornaProximoCodigo',
                    listarPor: 'api/atendimento/pendenciaAtendimento/ListarPor',
                    listarComPaginacao: 'api/atendimento/pendenciaAtendimento/ListarComPaginacao',
                    listarComPaginacaoDatatable: 'api/atendimento/pendenciaAtendimento/ListarComPaginacaoDatatable',
                    criar: 'api/atendimento/pendenciaAtendimento',
                    atualizar: 'api/atendimento/pendenciaAtendimento',
                    excluir: 'api/atendimento/pendenciaAtendimento/'
                },
                conclusao: {
                    listarPor: 'api/atendimento/conclusao/ListarPor',
                    listarComPaginacao: 'api/atendimento/conclusao/ListarComPaginacao',
                    listarComPaginacaoDatatable: 'api/atendimento/conclusao/ListarComPaginacaoDatatable',
                    criar: 'api/atendimento/conclusao',
                    atualizar: 'api/atendimento/conclusao',
                    excluir: 'api/atendimento/conclusao/'
                },

                tag: {
                    listarPor: 'api/atendimento/tag/ListarPor',
                    listarTodas: 'api/atendimento/tag/ListarTodas',
                    listarComPaginacao: 'api/atendimento/tag/ListarComPaginacao',
                    listarComPaginacaoDatatable: 'api/atendimento/tag/ListarComPaginacaoDatatable',
                    criar: 'api/atendimento/tag',
                    atualizar: 'api/atendimento/tag',
                    excluir: 'api/atendimento/tag/',
                    listarPorSolucao: 'api/atendimento/tag/ListarPorSolucao'
                },
                atualizacoesPendentes: {
                    listarAtualizacoesPendentesPorSquad: 'api/atendimento/AtualizacoesPendentes/ListarAtualizacoesPendentesPorSquad'
                }
            },

            endereco: {
                cidade: {
                    proximoCodigo: 'api/endereco/cidade/RetornaProximoCodigo',
                    listarTodos: 'api/endereco/cidade/ListarTodos',
                    listarPor: 'api/endereco/cidade/ListarPor',
                    listarComPaginacao: 'api/endereco/cidade/ListarComPaginacao',
                    listarComPaginacaoDatatable: 'api/endereco/cidade/ListarComPaginacaoDatatable',
                    criar: 'api/endereco/cidade',
                    atualizar: 'api/endereco/cidade',
                    excluir: 'api/endereco/cidade/'
                },
                bairro: {
                    proximoCodigo: 'api/endereco/bairro/RetornaProximoCodigo',
                    listarPor: 'api/endereco/bairro/ListarPor',
                    listarComPaginacao: 'api/endereco/bairro/ListarComPaginacao',
                    listarComPaginacaoDatatable: 'api/endereco/bairro/ListarComPaginacaoDatatable',
                    criar: 'api/endereco/bairro',
                    listarBairrosPorCidade: 'api/endereco/bairro/ListarBairrosPorCidade/',
                    atualizar: 'api/endereco/bairro',
                    excluir: 'api/endereco/bairro/'
                }
            },

            estoria: {
                proximoCodigo: 'api/estoria/RetornaProximoNumero',
                listarTodos: 'api/estoria/ListarTodos',
                listarPor: 'api/estoria/ListarPor',
                listarPorId: 'api/estoria/',
                listarEstoriaComPaginacao: 'api/estoria/ListarComPaginacao',
                listarComPaginacaoDatatable: 'api/estoria/ListarComPaginacaoDatatable',
                listarEstoriasSemSprintBacklog: 'api/estoria/ListarEstoriasSemSprintBacklog/',
                listarEstoriasSemSprintBacklogSimples: 'api/estoria/ListarEstoriasSemSprintBacklogSimples/',
                listarTodasEstorias: 'api/estoria/ListarTodasEstorias',
                listarEstoriasPorProductBacklog: 'api/estoria/ListarEstoriasPorProductBacklog',
                listarCustosSoftware: 'api/estoria/ListarCustosSoftware',
                ListarCustosSoftwarePorSquad: 'api/custo-software/ListarPorSquad/',
                ListarCustosSoftwarePorSquads: 'api/custo-software/ListarPorSquads',
                listarHistoricoAlteracaoDataEntrega: 'api/EstoriaHistoricoPrazoAcordado/ListarPor',
                criar: 'api/estoria',
                atualizar: 'api/estoria',
                atualizarDataEntregaEstoria: 'api/estoria/AtualizarDataEntregaEstoria',
                criarHistoricoDataEntrega: 'api/EstoriaHistoricoPrazoAcordado/criar',
                atualizarColaboradores: 'api/estoria/AtualizarColaboradores',
                atualizarProductBacklog: 'api/estoria/AtualizarProductBacklog',
                excluir: 'api/estoria/',
                listarPontuacao: 'api/estoria/ListarPontuacao',
                origens: {
                    listar: 'api/estoria/ListarOrigens'
                },
                estimativa: {
                    listarTodos: 'api/estimativa/ListarTodos',
                    listarPor: 'api/estimativa/ListarPor/',
                    listarEstimativa: 'api/estimativa/ListarEstimativa/',
                    criar: 'api/estimativa',
                    atualizar: 'api/estimativa',
                    excluir: 'api/estimativa/'
                },
                historico: {
                    listarTodos: 'api/historico/ListarTodos',
                    listarHistorico: 'api/historico/ListarHistorico/',
                    listarPor: 'api/historico/ListarPor/',
                    criar: 'api/historico',
                    atualizar: 'api/historico',
                    excluir: 'api/historico/'
                },
                priorizacao: {
                    listarTodos: 'api/priorizacao/ListarTodos',
                    listarPor: 'api/priorizacao/ListarPor/',
                    listarPriorizacao: 'api/priorizacao/ListarPriorizacao/',
                    criar: 'api/priorizacao',
                    atualizar: 'api/priorizacao',
                    excluir: 'api/priorizacao/'
                },
                tarefa: {
                    listarTodos: 'api/tarefa/ListarTodos',
                    listarPor: 'api/tarefa/ListarPor/',
                    listarTarefas: 'api/tarefa/ListarTarefas',
                    criar: 'api/tarefa',
                    gerarTarefas: 'api/tarefa/gerarTarefas',
                    atualizar: 'api/tarefa',
                    excluir: 'api/tarefa/'
                },
                requisito: {
                    listarPor: 'api/requisito/ListarPor/',
                    criar: 'api/requisito',
                    atualizar: 'api/requisito'
                },
                clientes: {
                    listarPor: 'api/estoria/clientevinculado/ListarPor/',
                    listarVersoesGeradas: 'api/estoria/clientevinculado/listarVersoesGeradas/',
                    vincular: 'api/estoria/clientevinculado/Vincular/',
                    atualizar: 'api/estoria/clientevinculado/Atualizar/',
                    deletar: 'api/estoria/clientevinculado/Deletar/'
                },
                historiasVinculadas: {
                    listarHistoriasVinculadas: 'api/estoria/estoriavinculo/ListarHistoriasVinculadas',
                    listarHistoriasSemVinculo: 'api/estoria/estoriavinculo/ListarHistoriasSemVinculo',
                    atualizarHistoriasVinculadas: 'api/estoria/estoriavinculo/AtualizarHistoriasVinculadas'
                }

            },

            feriado: {
                proximoCodigo: 'api/feriado/RetornaProximoCodigo',
                listarTodos: 'api/feriado/ListarTodos',
                listarPor: 'api/feriado/ListarPor',
                listarComPaginacao: 'api/feriado/ListarComPaginacao',
                listarComPaginacaoDatatable: 'api/feriado/ListarComPaginacaoDatatable',
                criar: 'api/feriado',
                atualizar: 'api/feriado',
                excluir: 'api/feriado/'
            },

            motivo: {
                proximoCodigo: 'api/motivo/RetornaProximoCodigo',
                listarCodigoDescricao: 'api/motivo/ListarCodigoDescricao',
                listarTodos: 'api/motivo/ListarTodos',
                listarPor: 'api/motivo/ListarPor',
                listarComPaginacao: 'api/motivo/ListarComPaginacao',
                listarComPaginacaoDatatable: 'api/motivo/ListarComPaginacaoDatatable',
                listarPorId: 'api/motivo/',
                criar: 'api/motivo',
                atualizar: 'api/motivo',
                excluir: 'api/motivo/'
            },

            solucao_rotinas_tarefas: {
                solucao: {
                    proximoCodigo: 'api/solucao/RetornaProximoCodigo',
                    listarCodigoDescricao: 'api/solucao/ListarCodigoDescricao',
                    listarPorSquadCliente: 'api/solucao/ListarPorSquadCliente',
                    listarPorSquadClientes: 'api/solucao/ListarPorSquadClientes',
                    listarTodos: 'api/solucao/ListarTodas',
                    listarPor: 'api/solucao/ListarPor',
                    listarComPaginacao: 'api/solucao/ListarComPaginacao',
                    listarComPaginacaoDatatable: 'api/solucao/ListarComPaginacaoDatatable',
                    listarPorId: 'api/solucao/',
                    criar: 'api/solucao',
                    atualizar: 'api/solucao',
                    excluir: 'api/solucao/'
                },
                rotinas: {
                    proximoCodigo: 'api/rotina/RetornaProximoCodigo',
                    listarCodigoDescricao: 'api/rotina/ListarCodigoDescricao',
                    listarTodos: 'api/rotina/ListarTodos',
                    listarPor: 'api/rotina/ListarPor',
                    listarRotinasPorSolucao: 'api/rotina/ListarRotinasPorSolucao/',
                    criar: 'api/rotina',
                    atualizar: 'api/rotina',
                    excluir: 'api/rotina/'
                },
                tarefas: {
                    proximoCodigo: 'api/tarefas/RetornaProximoCodigo',
                    listarCodigoDescricao: 'api/tarefas/ListarCodigoDescricao',
                    listarTodos: 'api/tarefas/ListarTodos',
                    listarTiposTarefas: 'api/tarefas/ListarTipoTarefas',
                    listarPor: 'api/tarefas/ListarPor',
                    listarTarefasPorRotina: 'api/tarefas/ListarTarefasPorRotina',
                    criar: 'api/tarefas',
                    atualizar: 'api/tarefas',
                    excluir: 'api/tarefas/'
                }
            },

            produto: {
                listarPor: 'api/produto/ListarPor',
                listarTodosProdutosAtivos: 'api/produto/ListarTodosProdutosAtivos',
                listarProdutoPorSolucoes: 'api/produto/ListarProdutoPorSolucoes/',
                listarComPaginacao: 'api/produto/ListarComPaginacao',
                listarComPaginacaoDatatable: 'api/produto/ListarComPaginacaoDatatable',
                listarProdutosPorFunil: 'api/produto/ListarProdutosPorFunil/',
                listarProdutosPorContrato: 'api/produto/ListarProdutosPorContrato/',
                listarProdutosComercializaveis: 'api/produto/ListarProdutosComercializaveis',
                listarProdutosComercializaveisPor: 'api/produto/ListarProdutosComercializaveisPor',
                listarProdutosAtivosEComercializaveis: 'api/produto/ListarProdutosAtivosEComercializaveis',
                listarProdutoPorSquad: 'api/produto/ListarProdutoPorSquad',
                listarTodosProdutos: 'api/produto/ListarTodosProdutos',
                listarProdutoSoftwareProprio: 'api/produto/ListarProdutoSoftwareProprio',
                criar: 'api/produto',
                atualizar: 'api/produto',
                excluir: 'api/produto/',
                listarTodosProdutosAtivosCliente: 'api/produto/listarTodosProdutosAtivosCliente/'
            },

            setor: {
                proximoCodigo: 'api/setor/RetornaProximoCodigo',
                listarCodigoDescricao: 'api/setor/ListarCodigoDescricao',
                listarTodos: 'api/setor/ListarTodos',
                ListarTodosSquad: 'api/setor/ListarTodosSquad',
                listarDesenvolvedores: 'api/setor/ListarDesenvolvedores',
                listarTesters: 'api/setor/ListarTesters',
                listarPor: 'api/setor/ListarPor',
                listarComPaginacao: 'api/setor/ListarComPaginacao',
                listarComPaginacaoDatatable: 'api/setor/ListarComPaginacaoDatatable',
                listarPorId: 'api/setor/',
                criar: 'api/setor',
                atualizar: 'api/setor',
                excluir: 'api/setor/'
            },

            sistemaOperacional: {
                proximoCodigo: 'api/sistemaoperacional/RetornaProximoCodigo',
                listarCodigoDescricao: 'api/sistemaoperacional/ListarCodigoDescricao',
                listarTodos: 'api/sistemaoperacional/ListarTodos',
                listarPor: 'api/sistemaoperacional/ListarPor',
                listarComPaginacao: 'api/sistemaoperacional/ListarComPaginacao',
                listarComPaginacaoDatatable: 'api/sistemaoperacional/ListarComPaginacaoDatatable',
                criar: 'api/sistemaoperacional',
                atualizar: 'api/sistemaoperacional',
                excluir: 'api/sistemaoperacional/'
            },

            situacao: {
                proximoCodigo: 'api/situacao/RetornaProximoCodigo',
                listarCodigoDescricao: 'api/situacao/ListarCodigoDescricao',
                listarTodos: 'api/situacao/ListarTodos',
                listarPor: 'api/situacao/ListarPor',
                listarComPaginacao: 'api/situacao/ListarComPaginacao',
                listarComPaginacaoDatatable: 'api/situacao/ListarComPaginacaoDatatable',
                criar: 'api/situacao',
                atualizar: 'api/situacao',
                excluir: 'api/situacao/'
            },

            tipo_historia: {
                listarTodos: 'api/estoria/tipo/ListarTodos',
                listarAtivos: 'api/estoria/tipo/ListarAtivos',
                listarComPaginacao: 'api/estoria/tipo/ListarComPaginacao ',
                listarComPaginacaoDatatable: 'api/estoria/tipo/ListarComPaginacaoDatatable ',
                criar: 'api/estoria/tipo',
                atualizar: 'api/estoria/tipo',
                excluir: 'api/estoria/tipo/'
            },

            usuario: {
                proximoCodigo: 'api/usuario/RetornaProximoCodigo',
                retornarUsuarioPorId: 'api/usuario/RetornarUsuarioPorId/',
                retornaProximoCodigoPerfil: 'api/usuario/RetornaProximoCodigoPerfil',
                retornaProximoCodigoPermissao: 'api/usuario/RetornaProximoCodigoPermissao',
                listarCodigoDescricao: 'api/usuario/ListarCodigoDescricao',
                listarTodos: 'api/usuario/ListarTodos',
                listarPor: 'api/usuario/ListarPor',
                validarSenha: 'api/usuario/ValidarSenha/',
                listarUsuariosSetorComercial: 'api/usuario/ListarUsuariosSetorComercial/',
                listarTodosUsuariosSetorComercial: 'api/usuario/ListarTodosUsuarioSetorComercial/',
                confirmarSenhaPorCodigo: 'api/seguranca/usuario/ConfirmarSenhaPorCodigo/',
                confirmarSenha: 'api/seguranca/usuario/ConfirmarSenha',
                listarComPaginacao: 'api/usuario/ListarComPaginacao',
                listarPorPaginacao: 'api/seguranca/usuario/listarcompaginacao',
                listarComPaginacaoDatatable: 'api/usuario/ListarComPaginacaoDatatable',
                retornarUsuarioPorUsuarioESenha: 'api/usuario/RetornarUsuarioPorUsuarioESenha',
                listarTodosDesenvolvedores: 'api/usuario/ListarTodosDesenvolvedores',
                listarTodosTesters: 'api/usuario/ListarTodosTesters',
                criar: 'api/usuario',
                atualizar: 'api/usuario',
                excluir: 'api/usuario/',

                detalhes_usuario: {
                    listarDetalhesUsuario: 'api/usuario/detalhesUsuario/ListarDetalhesUsuario/',
                    listarUsuarioPorDetalhe: 'api/usuario/detalhesUsuario/ListarUsuarioPorDetalhe/',
                    listarUsuariosTipoComercial: 'api/usuario/detalhesUsuario/ListarUsuariosTipoComercial',
                    listarUsuariosAtivos: 'api/usuario/detalhesUsuario/ListarUsuariosAtivos',
                    listarUsuariosAtivosSquad: 'api/usuario/detalhesUsuario/ListarUsuariosAtivosSquad',
                    listarUsuariosSetorComercial: 'api/usuario/detalhesUsuario/ListarUsuariosSetorComercial',
                    listarUsuariosDetalhesPor: 'api/usuario/detalhesUsuario/ListarUsuariosDetalhesPor',
                    criar: 'api/usuario/detalhesUsuario',
                    atualizar: 'api/usuario/detalhesUsuario/'
                },
                configuracaoUsuario: {
                    listarConfiguracao: 'api/usuario/usuarioConfiguracao/listarConfiguracao/',
                    validaUsuarioRedefinicaoSenha: 'api/usuario/usuarioConfiguracao/verificaUsuarioRedefinirSenha/',
                    criar: 'api/usuario/usuarioConfiguracao/AdicionaHistoricoSenha'
                }
            },

            uc_usuario: {
                listarTodos: 'api/seguranca/usuario/listartodos',
                listarPorPerfil: 'api/seguranca/usuario/listarporperfil/',
                listarUsuarioPorId: 'api/seguranca/usuario/',
                lisarUsuarioPorSenhaELogin: 'api/seguranca/usuario',
                criar: 'api/seguranca/usuario',
                atualizar: 'api/seguranca/usuario',
                atualizarSenha: 'api/seguranca/usuario/alterarsenha',
                atualizarSenhasHash: 'api/seguranca/usuario/atualizarSenhasHash',
                excluir: 'api/seguranca/usuario/'
            },

            geral: {
                relatorio_cliente: 'api/cliente/relatorio/GerarRelatorioListagemSimplificada',
                relatorio_controle_horas: {
                    relatorio: 'api/controle-hora/relatorio',
                    listaColaboradoresComHorasNoMes: 'api/controle-hora/relatorio/listaColaboradores'
                },

                relatorioRiscoRescisaoContratual: {
                    montarDadosRelatorio: "api/risco-rescisao-contratual/MontarDadosRelatorio",
                    gerarRelatorio: "api/risco-rescisao-contratual/GerarRelatorio"
                }

            },

            perfil: {
                proximoCodigo: 'api/usuario/retornaproximocodigoperfil',
                listarTodos: 'api/seguranca/perfil/listartodos',
                listarComPaginacao: 'api/usuario/perfil/ListarComPaginacao',
                listarComPaginacaoDatatable: 'api/usuario/perfil/ListarComPaginacaoDatatable',
                criar: 'api/seguranca/perfil',
                atualizar: 'api/seguranca/perfil',
                excluir: 'api/seguranca/perfil/'
            },

            sprint: {
                listarPorId: 'api/sprint/',
                listarTodos: 'api/sprint/ListarTodos',
                listarPor: 'api/sprint/ListarPor',
                listarComPaginacao: 'api/sprint/ListarComPaginacao',
                listarComPaginacaoDatatable: 'api/sprint/ListarComPaginacaoDatatable',
                listarSprintCorrente: 'api/sprint/ListarSprintCorrente',
                listarSprintCorrentePorSquads: 'api/sprint/ListarSprintCorrentePorSquads',
                listarSprintCorrentePorSquad: 'api/sprint/ListarSprintCorrentePorSquad',
                ListarSprintCorrenteETodasSituacoesExcetoImpedimento: 'api/sprint/ListarSprintCorrenteETodasSituacoesExcetoImpedimento',
                proximoNumero: 'api/sprint/RetornaProximoNumero',
                criar: 'api/sprint',
                clonar: 'api/sprint/ClonarUltimaSprint',
                atualizar: 'api/sprint',
                excluir: 'api/sprint/',

                abatimento: {
                    listarTodos: 'api/sprint/abatimento/ListarTodos',
                    listarTodosAbatimentos: 'api/sprint/abatimento/ListarTodosAbatimentos/',
                    listarPor: 'api/sprint/abatimento/ListarPor/',
                    criar: 'api/sprint/abatimento',
                    atualizar: 'api/sprint/abatimento',
                    excluir: 'api/sprint/abatimento/'
                },

                backlog: {
                    listarTodos: 'api/sprint/backlog/ListarTodos',
                    listarTodasEstoriasBacklog: 'api/sprint/backlog/ListarTodasEstoriasBacklog/',
                    listarBacklogPorPaginaPelaUrl: 'api/sprint/backlog/ListarBacklogPorPagina/',
                    listarBacklogPorPaginaPorParametro: 'api/sprint/backlog/ListarBacklogPorPagina',
                    listarEstatistica: 'api/sprint/estatistica/listarEstatistica/',
                    listarPriorizacao: 'api/sprint/backlog/ListarPriorizacao/',
                    listarPontuacao: 'api/sprint/backlog/ListarPontuacao/',
                    listarPor: 'api/sprint/backlog/ListarPor/',
                    listarSprintsEmAberto: 'api/sprint/ListarNumerosSprintEmAberto/',

                    criar: 'api/sprint/backlog',
                    atualizar: 'api/sprint/backlog',
                    excluir: 'api/sprint/backlog/'
                },

                cerimonia_detalhe: {
                    listarTodos: 'api/sprint/cerimonia_detalhe/ListarTodos',
                    listarCerimonias: 'api/sprint/cerimonia_detalhe/ListarCerimonias',
                    listarPor: 'api/sprint/cerimonia_detalhe/ListarPor/',
                    criar: 'api/sprint/cerimonia_detalhe',
                    atualizar: 'api/sprint/cerimonia_detalhe',
                    excluir: 'api/sprint/cerimonia_detalhe/'
                },

                pontuacao: {
                    listarPontuacaoColaboradores: 'api/sprint/listarPontuacaoColaboradores/'
                },

                fechamento: {
                    listarTodos: 'api/sprint/fechamento/ListarTodos',
                    listarPor: 'api/sprint/fechamento/ListarPor/',
                    criar: 'api/sprint/fechamento',
                    atualizar: 'api/sprint/fechamento',
                    excluir: 'api/sprint/fechamento/'
                },

                meta: {
                    listarTodos: 'api/sprint/meta/ListarTodos',
                    listarPor: 'api/sprint/meta/ListarPor/',
                    ListarEstoria: 'api/sprint/meta/ListarEstoria/',
                    acompanhamentoMeta: 'api/sprint/meta/Acompanhamento',
                    listarPorDesenvolvedor: 'api/sprint/meta/Acompanhamento/ListarPorDesenvolvedor',
                    listarTodasMetas: 'api/sprint/meta/ListarTodasMetas/',
                    criar: 'api/sprint/meta',
                    atualizar: 'api/sprint/meta',
                    excluir: 'api/sprint/meta/'
                },

                recurso: {
                    listarTodos: 'api/sprint/recurso/ListarTodos',
                    listarPor: 'api/sprint/recurso/ListarPor/',
                    listarTodosRecursos: 'api/sprint/recurso/ListarTodosRecursos/',
                    criar: 'api/sprint/recurso',
                    atualizar: 'api/sprint/recurso',
                    excluir: 'api/sprint/recurso/'
                },

                registro: {
                    listarTodos: 'api/sprint/registro/ListarTodos',
                    listarPor: 'api/sprint/registro/ListarPor/',
                    listarTodosRegistros: 'api/sprint/registro/ListarTodosRegistros/',
                    criar: 'api/sprint/registro',
                    atualizar: 'api/sprint/registro',
                    excluir: 'api/sprint/registro/'
                },

                registro_situacao: {
                    listarTodos: 'api/sprint/registrosituacao/ListarTodos',
                    listarPor: 'api/sprint/registrosituacao/ListarPor',
                    listarComPaginacao: 'api/sprint/registrosituacao/ListarComPaginacao',
                    listarComPaginacaoDatatable: 'api/sprint/registrosituacao/ListarComPaginacaoDatatable',
                    criar: 'api/sprint/registrosituacao',
                    atualizar: 'api/sprint/registrosituacao',
                    excluir: 'api/sprint/registrosituacao/'
                },

                registro_situacao_limite_aceitavel: {
                    listarTodos: 'api/sprint/registrosituacaolimiteaceitavel/ListarTodos',
                    listarPor: 'api/sprint/registrosituacaolimiteaceitavel/ListarPor/',
                    listarTodosLimitesAceitaveis: 'api/sprint/registrosituacaolimiteaceitavel/ListarTodosLimitesAceitaveis',
                    criar: 'api/sprint/registrosituacaolimiteaceitavel',
                    atualizar: 'api/sprint/registrosituacaolimiteaceitavel',
                    excluir: 'api/sprint/registrosituacaolimiteaceitavel/'
                },

                versao_entrega: {
                    listarTodos: 'api/sprint/versaoentrega/ListarTodos',
                    listarPor: 'api/sprint/versaoentrega/ListarPor/',
                    listarTodasVersoesEntrega: 'api/sprint/versaoentrega/ListarTodasVersoesEntrega',
                    listarVersoesReleasePorSolucao: 'api/sprint/versaoentrega/ListarVersoesReleasePorSolucao',
                    criar: 'api/sprint/versaoentrega',
                    atualizar: 'api/sprint/versaoentrega',
                    excluir: 'api/sprint/versaoentrega/'
                },

                estatistica: {
                    listarEstatistica: 'api/sprint/consulta/estatisticas/listaEstatistica',
                    listarAno: "api/sprint/consulta/estatisticas/listarano",
                    listarSprint: "api/sprint/consulta/estatisticas/listarsprint",
                    listarEstatisticaPorStatus: "api/sprint/estatistica/listarEstatisticaPorStatus"
                }
            },

            consultas: {
                estoria: {
                    listarEstoriasEspecificas: 'api/historico/listarEstoriasPor',
                    listarEstoriasEmAberto: 'api/historico/listarEstoriasEmAberto',
                    listarComPaginacaoDatatableEstoriasEmAberto: 'api/historico/ListarComPaginacaoDatatableEstoriasEmAberto',
                    listarEstoriasEmAndamento: 'api/historico/listarEstoriasEmAndamento',
                    listarEstoriasConcluidas: 'api/historico/listarEstoriasConcluidas',
                    listarEstoriasEmPausa: 'api/historico/listarEstoriasEmPausa',
                    listarTodasEstorias: 'api/historico/ListarTodasEstorias',
                    listarEstoriasUsuarioCorrente: 'api/historico/ListarEstoriasUsuarioCorrente'
                },
                log: {
                    listarPor: 'api/log/ListarPor/',
                    listarTodasEntidades: 'api/log/ListarTodasEntidades'
                },
                controle_versao: {
                    listarVersoesPorSolucao: "api/sprint/versaoentrega/ListarVersoesPorSolucao",
                    listarReleasesPorVersoes: "api/sprint/versaoentrega/listarReleasesPorVersoes",
                    listarEstoriasNasVersoes: "api/sprint/versaoentrega/ListarEstoriasNasVersoes"
                }
            },

            pipeline: {

                pipeline_funil: {
                    listarTodos: 'api/pipeline/funil/ListarTodos',
                    listarAtivos: 'api/pipeline/funil/ListarAtivos',
                    listarComPaginacao: 'api/pipeline/funil/ListarComPaginacao',
                    listarComPaginacaoDatatable: 'api/pipeline/funil/ListarComPaginacaoDatatable',
                    proximoCodigo: 'api/pipeline/funil/RetornaProximoCodigo',
                    criar: 'api/pipeline/funil/',
                    atualizar: 'api/pipeline/funil/',
                    excluir: 'api/pipeline/funil/',
                    listarEtapasFunil: 'api/pipeline/funil/ListarEtapasFunil/'
                },

                pipeline_motivoperdanegocio: {
                    listarMoticosPerda: 'api/pipeline/motivoperdanegocio',
                    listarPor: 'api/pipeline/motivoperdanegocio/ListarPor',
                    listarComPaginacao: 'api/pipeline/motivoperdanegocio/ListarComPaginacao',
                    listarComPaginacaoDatatable: 'api/pipeline/motivoperdanegocio/ListarComPaginacaoDatatable',
                    proximoCodigo: 'api/pipeline/motivoperdanegocio/RetornaProximoCodigo',
                    criar: 'api/pipeline/motivoperdanegocio/',
                    atualizar: 'api/pipeline/motivoperdanegocio/',
                    excluir: 'api/pipeline/motivoperdanegocio/'
                },

                pipeline_negocio: {
                    listarEtapasFunil: 'api/pipeline/negocio/ListarEtapasFunil/',
                    listarPorCodigo: 'api/pipeline/negocio/ListarPorCodigo/',
                    retornarCodigoEtapaAtual: 'api/pipeline/negocio/RetornarCodigoEtapaAtual/',
                    criar: 'api/pipeline/negocio/',
                    atualizar: 'api/pipeline/negocio/',
                    atualizarEtapaNegocio: 'api/pipeline/negocio/AlterarEtapaAtualNegocio/',
                    excluir: 'api/pipeline/negocio/',
                    verificarNotificacoesNegocios: 'api/pipeline/negocio/VerificarNotificacoesNegocios/',
                    listarNegociosVencidosExecutivoContas: 'api/pipeline/negocio/ListarNegociosVencidosExecutivoContas/',
                    historico: {
                        listarHistoricoDataTable: 'api/pipeline/negocio/historico/ListarHistoricoDataTable/'
                    },
                    resultado: {
                        finalizarNegocio: 'api/pipeline/negocio/resultado/FinalizarNegocio',
                        retornarNegocioAoFunil: 'api/pipeline/negocio/resultado/RetornarNegocioAoFunil/',
                        listarNegociosComResultadosComPaginacaoDatatable: 'api/pipeline/negocio/resultado/ListarNegociosComResultadosComPaginacaoDatatable'
                    }
                },

                pipeline_historico_funil: {
                    listarPorCodigoNegocio: 'api/pipeline/historico-funil/listarPorCodigoNegocio/'
                },
                pipeline_etapa: {
                    listarEtapasPorFunil: 'api/pipeline/etapa/ListarEtapasPorFunil/',
                    proximoCodigo: 'api/pipeline/etapa/RetornarProximoCodigo',
                    listarTodasEtapas: 'api/pipeline/etapa/ListarTodasEtapas',
                    listarComPaginacao: 'api/pipeline/etapa/ListarComPaginacao',
                    listarComPaginacaoDatatable: 'api/pipeline/etapa/ListarComPaginacaoDatatable',
                    criar: 'api/pipeline/etapa/',
                    atualizar: 'api/pipeline/etapa/',
                    excluir: 'api/pipeline/etapa/'
                },

                pipeline_estatisticas: {
                    retornarEstatisticas: 'api/pipeline/estatisticas',
                    listaNegociosDoPeriodo: 'api/pipeline/estatisticas/listaNegociosDoPeriodo',
                    listaNegociosEmAndamento: 'api/pipeline/estatisticas/listaNegociosEmAndamento',
                    listaNegociosGanhos: 'api/pipeline/estatisticas/listaNegociosGanhos',
                    listaNegociosPerdidos: 'api/pipeline/estatisticas/listaNegociosPerdidos',
                    listaNegociosEmAndamentoPorCliente: 'api/pipeline/estatisticas/listaNegociosEmAndamentoPorCliente'
                },

                pipeline_projecoes: {
                    consultar: 'api/pipeline/projecoes/ConsultarProjecoes',
                    detalhamentoProjecoesFechamentoComercial: 'api/pipeline/projecoes/DetalhamentoProjecoesFechamentoComercial',
                    detalhamentoProjecoesFinalizacaoEtapa: 'api/pipeline/projecoes/DetalhamentoProjecoesFinalizacaoEtapa',
                    gerarRelatorioProjecoes: 'api/relatorio/pipeline/GerarRelatorioProjecoes'
                }
            },

            atalhos: {
                listarTodos: 'api/atalhos/ListarTodos/',
                criar: 'api/atalhos',
                atualizar: 'api/atalhos',
                excluir: 'api/atalhos/'
            },

            display: {
                listarTodasUf: 'api/display/ListarTodasUF',
                listarTipoClassificacaoCliente: 'api/display/ListarTipoClassificacaoCliente',
                listarPriorizacaoEstoria: 'api/display/ListarPriorizacaoEstoria',
                listarNecessidadeCliente: 'api/display/ListarNecessidadeCliente',
                listarFormularioImpressao: 'api/display/ListarFormularioImpressao',
                listarMetodoImpressao: 'api/display/ListarMetodoImpressao',
                listarTipoBloqueioContrato: 'api/display/TipoBloqueioContrato',
                listarSituacaoContrato: 'api/display/SituacaoContrato',
                listarSituacaoFinanceiraContrato: 'api/display/SituacaoFinanceiraContrato',
                dataContrato: 'api/display/DataContrato',
                tipoPagamentoContrato: 'api/display/TipoPagamentoContrato',
                idioma: 'api/display/Idioma',
                nivelIdioma: 'api/display/NivelIdioma',
                listarTipoFiltroEstatistica: 'api/display/TipoFiltroEstatistica'
            },

            menu: {
                listarTodosMenus: "api/menu/listarTodosMenus",
                listarMenusEmArvore: 'api/menu/listarMenusEmArvore',
                criar: 'api/menu/',
                atualizar: 'api/menu/',
                excluir: 'api/menu/'
            },

            controle_acesso_menu: {
                listarTodasPermissoesAcessoMenu: 'api/permissaomenu/ListarTodasPermissoesAcessoMenu/',
                listarMenusPorPerfil: 'api/permissaomenu/ListarMenusPorPerfil/',
                verificaSeMenuEAcessivel: 'api/permissaomenu/VerificaSeMenuEAcessivel/',
                criar: 'api/permissaomenu/',
                editar: 'api/permissaomenu/'
            },

            trabalhe_conosco: {
                listarCategorias: 'api/categoria/ListarCategorias',
                listarAreasAtuacao: 'api/area-atuacao/',
                triagemCurriculos: 'api/triagem-curriculos/RealizarTriagem',
                visualizarCurriculo: 'api/triagem-curriculos/VisualizarCurriculo/',
                categoria: {
                    listarComPaginacao: 'api/categoria/listarcompaginacao',
                    listarComPaginacaoDatatable: 'api/categoria/listarcompaginacaodatatable',
                    listarCategoriasUsuario: 'api/categoria/ListarCategoriasUsuario/',
                    criar: 'api/categoria/',
                    atualizar: 'api/categoria/',
                    excluir: 'api/categoria/'
                },
                habilidade: {
                    listarTodasHabilidadesViewModel: 'api/habilidade/ListarTodasHabilidadesViewModel',
                    listarComPaginacao: 'api/habilidade/listarcompaginacao',
                    listarComPaginacaoDatatable: 'api/habilidade/listarcompaginacaodatatable',
                    criar: 'api/habilidade',
                    atualizar: 'api/habilidade',
                    excluir: 'api/habilidade/',
                    listarPor: "api/habilidade/ListarPor"
                },
                areaAtuacao: {
                    proximoCodigo: 'api/area-atuacao/RetornaProximoCodigo',
                    listarComPaginacao: 'api/area-atuacao/ListarComPaginacao',
                    criar: 'api/area-atuacao',
                    atualizar: 'api/area-atuacao',
                    excluir: 'api/area-atuacao/',
                    listarComPaginacaoDatatable: 'api/area-atuacao/listarcompaginacaodatatable'
                },
                candidato: {
                    listarHabilidades: 'api/candidato/'
                }
            },

            contole_horas: {
                listarComPaginacao: 'api/controle-hora/ListarComPaginacao',
                listarComPaginacaoDatatable: 'api/controle-hora/ListarComPaginacaoDatatable',
                criar: 'api/controle-hora/',
                editar: 'api/controle-hora/',
                excluir: 'api/controle-hora/',
                viagem: 'api/controle-hora/viagem/',
                ponto: {
                    base: 'api/controle-hora/historico/',
                    listar: 'api/controle-hora/historico/PorViagem/'
                }
            },

            custo_software: {

                analiseCusto: {
                    editar: 'api/analise-custo/',
                    listarPor: 'api/analise-custo/listarPor/',
                    salvar: 'api/analise-custo/',
                    listarDetalhamentoHistoriasPorProjeto: 'api/analise-custo/ListarDetalhamentoHistoriasPorProjeto',
                    listarDetalhamentoAno: 'api/analise-custo/ListarDetalhamentoAno',
                    listarTotalizadoresPorProjeto: 'api/analise-custo/ListarTotalizadoresPorProjeto'
                },

                custo: {
                    listarPor: 'api/custo-software/listarPor/',
                    listar: 'api/custo-software/',
                    salvar: 'api/custo-software/',
                    atualizar: 'api/custo-software/',
                    excluir: 'api/custo-software/',
                    listarComPaginacao: 'api/custo-software/listarcompaginacao',
                    listarcompaginacaodatatable: 'api/custo-software/listarcompaginacaodatatable'
                },
                historico: {
                    listar: 'api/custo-software/historico-custo/listar',
                    salvar: 'api/custo-software/historico-custo/',
                    atualizar: 'api/custo-software/historico-custo/',
                    excluir: 'api/custo-software/historico-custo/',
                    listarComPaginacao: 'api/custo-software/historico-custo/listarcompaginacao',
                    listarcompaginacaodatatable: 'api/custo-software/historico-custo/listarcompaginacaodatatable'
                }
            },

            protecao: {
                gerenciamentoProtecao: {
                    listar: 'api/protecao/gerenciamento',
                    atualizarQuantidadeLicenca: 'api/protecao/gerenciamento/AtualizarQuantidadeLicenca',
                    atualizarDataExpiracao: 'api/protecao/gerenciamento/AtualizarDataExpiracao'
                },
                tipoLicenca: {

                    listarPorNumeroLicenca: 'api/protecao/tipo-licenca/ListarPorNumeroLicenca',
                    listarTodos: 'api/protecao/tipo-licenca/ListarTodos',
                    listarPor: "api/protecao/tipo-licenca/ListarPor",
                    listarTiposLicencaPorClienteEProduto: "api/protecao/tipo-licenca/ListarTiposLicencaPorClienteEProduto/",
                    listarComPaginacao: 'api/protecao/tipo-licenca/listarcompaginacao',
                    listarComPaginacaoDatatable: 'api/protecao/tipo-licenca/listarcompaginacaodatatable',
                    criar: 'api/protecao/tipo-licenca',
                    atualizar: 'api/protecao/tipo-licenca',
                    excluir: 'api/protecao/tipo-licenca/',
                    listarPorClienteProduto: "api/protecao/tipo-licenca"
                },
                licenca: {
                    listarComPaginacao: "api/protecao/licenca/ListarComPaginacao",
                    listarComPaginacaoDatatable: "api/protecao/licenca/ListarComPaginacaoDatatable",
                    criar: 'api/protecao/licenca',
                    atualizar: 'api/protecao/licenca',
                    excluir: 'api/protecao/licenca/',
                    atualizarlicencas: 'api/protecao/licenca/AtualizarLicencas'
                },
                protecaoAvulsa: {
                    listarLicenca: 'api/protecao/protecao-avulsa/Licenca/',
                    listarDataExpiracao: 'api/protecao/protecao-avulsa/DataExpiracao/'
                },
                atualizacaoLicenca: {
                    listar: 'api/protecao/atualizacao-licenca/',
                    licencas: 'api/protecao/atualizacao-licenca/licencas',
                    post: 'api/protecao/atualizacao-licenca/'
                }
            },

            agenda: {
                evento: {
                    listarTodos: 'api/agenda/evento/',
                    listarPaginacao: 'api/agenda/evento/ListarComPaginacao',
                    listarComPaginacaoDatatable: 'api/agenda/evento/ListarComPaginacaoDatatable',
                    criar: 'api/agenda/evento/',
                    atualizar: 'api/agenda/evento/',
                    excluir: 'api/agenda/evento?codigo='
                },
                parametros: {
                    listarTodos: 'api/agenda/parametro/',
                    listarPaginacao: 'api/agenda/parametro/ListarComPaginacao',
                    listarComPaginacaoDatatable: 'api/agenda/parametro/ListarComPaginacaoDatatable',
                    criar: 'api/agenda/parametro/',
                    atualizar: 'api/agenda/parametro/',
                },
                atividade: {
                    verificaAgendamentoVencidos: 'api/agenda/agendamento/verificaAgendamentosVencidos',
                    listarPaginacao: 'api/agenda/agendamento/ListarComPaginacao',
                    listarComPaginacaoDatatable: 'api/agenda/agendamento/ListarComPaginacaoDatatable',
                    criar: 'api/agenda/agendamento/',
                    listarStatus: 'api/agenda/agendamento/listarStatus',
                    atualizar: 'api/agenda/agendamento/',
                    listarAtividadesPorColaborador: 'api/agenda/atividade/listarAtividadesPorColaborador',
                    listarAtividadesPorCliente: 'api/agenda/atividade/listarAtividadePorCliente',
                    reagendar: 'api/agenda/atividade/reagendar'
                }
            },
            solicitacao: {
                fase: {
                    criar: 'api/solicitacao/fase',
                    listarComPaginacao: 'api/solicitacao/fase/listarcompaginacao',
                    listarComPaginacaoDatatable: 'api/solicitacao/fase/listarcompaginacaodatatable',
                    listarTodos: 'api/solicitacao/fase',
                    atualizar: 'api/solicitacao/fase',
                    excluir: 'api/solicitacao/fase?codigo='
                },
                solicitacao: {
                    criar: 'api/solicitacao',
                    listarComPaginacao: 'api/solicitacao/listarcompaginacao',
                    listarComPaginacaoDatatable: 'api/solicitacao/listarcompaginacaodatatable',
                    listarSolicitacoesPorCliente: 'api/solicitacao/listarsolicitacoesporcliente',
                    listarTodasSolicitacoesPorCliente: 'api/solicitacao/listarTodasSolicitacoesPorCliente',
                    listarSolicitacoesPorClienteSquad: 'api/solicitacao/listarSolicitacoesPorClienteSquad',
                    listarTodos: 'api/solicitacao',
                    atualizar: 'api/solicitacao',
                    excluir: 'api/solicitacao',
                    proximoCodigo: 'api/solicitacao/RetornaProximoNumero',
                    origens: {
                        listar: 'api/solicitacao/ListarOrigens'
                    },
                    editarPontuacao: 'api/solicitacao/editarpontuacao',
                    documentacao: {
                        criar: 'api/solicitacao/documentacao',
                        atualizar: 'api/solicitacao/documentacao',
                        atualizarHistoriasVinculadas: 'api/solicitacao/documentacao/AtualizarHistoriasVinculadas/',
                        listarPorSquad: 'api/estoria/ListarPorSquad'
                    },
                    historico: {
                        criar: 'api/solicitacao/historico',
                        atualizar: 'api/solicitacao/historico',
                        excluir: 'api/solicitacao/historico',
                        listarTodos: 'api/solicitacao/historico'
                    },
                    listarQuantidadeNaoVisualizado: 'api/solicitacao/listarQuantidadeNaoVisualizado',
                    editarVisualizacao: 'api/solicitacao/editarVisualizacao'
                },
                consulta: {
                    retornarContagem: 'api/solicitacao/contarsolicitacaopor',
                    listarSolicitacoesComTresOuMenosDiasParaVencer: 'api/solicitacao/ListarSolicitacoesComTresOuMenosDiasParaVencer',
                    listarSolicitacoesEntreQuatroECincoDiasParaVencer: 'api/solicitacao/ListarSolicitacoesEntreQuatroECincoDiasParaVencer',
                    listarSolicitacoesComMaisDeCincoParaVencerOuOutras: 'api/solicitacao/ListarSolicitacoesComMaisDeCincoParaVencerOuOutras',
                    listarSolicitacoesConcluidas: 'api/solicitacao/ListarSolicitacoesConcluidas',
                    listarSolicitacoesAprovadas: 'api/solicitacao/ListarSolicitacoesAprovadas',
                    listarSolicitacoesReprovadas: 'api/solicitacao/ListarSolicitacoesReprovadas',
                    listarSolicitacoesCanceladas: 'api/solicitacao/ListarSolicitacoesCanceladas',
                    listarSolicitacoesGenericas: 'api/solicitacao/ListarSolicitacoesGenericas',
                    listarTodasSolicitacoes: 'api/solicitacao/ListarTodasSolicitacoes/'
                }
            },
            consultaSql: {
                consulta: 'api/consultasql/ListarConsulta',
                montarPlanilhaExcel: 'api/planilhaexcel/ExportarParaExcel',
                baixarPlanilha: 'api/planilhaexcel/BaixarPlanilha'
            },

            modoimplantacao: {
                gerarSenhaImplantacao: 'api/modoimplantacao/gerarSenhaImplantacao'
            },

            brainstorming: {
                proximoNumero: 'api/brainstorming/RetornarProximoNumero',
                criar: 'api/brainstorming/Criar',
                atualizar: 'api/brainstorming/Atualizar',
                excluir: 'api/brainstorming/Deletar/',
                listarTodos: 'api/brainstorming/ListarTodos',
                listarComPaginacao: 'api/brainstorming/ListarComPaginacao',
                listarComPaginacaoDatatable: 'api/brainstorming/ListarComPaginacaoDatatable',
                brainstormingResposta: {
                    criar: 'api/brainstormingResposta/Criar'
                }
            },

            implantacaoMigracao: {
                tarefa: {
                    proximoCodigo: 'api/implantacao-migracao/tarefa/RetornarProximoCodigo',
                    criar: 'api/implantacao-migracao/tarefa/Criar',
                    atualizar: 'api/implantacao-migracao/tarefa/Atualizar',
                    excluir: 'api/implantacao-migracao/tarefa/Deletar/',
                    listarTodos: 'api/implantacao-migracao/tarefa/ListarTodos',
                    listarComPaginacao: 'api/implantacao-migracao/tarefa/ListarComPaginacao',
                    listarTarefasPorProcesso: 'api/implantacao-migracao/tarefa/ListarTarefasPorProcesso/'
                },
                processo: {
                    proximoCodigo: 'api/implantacao-migracao/processo/RetornarProximoCodigo',
                    criar: 'api/implantacao-migracao/processo/Criar',
                    atualizar: 'api/implantacao-migracao/processo/Atualizar',
                    excluir: 'api/implantacao-migracao/processo/Deletar/',
                    listarTodos: 'api/implantacao-migracao/processo/ListarTodos',
                    listarComPaginacao: 'api/implantacao-migracao/processo/ListarComPaginacao',
                    listarTarefasProcesso: 'api/implantacao-migracao/processo/ListarTarefasProcesso/'
                },
                subprocesso: {
                    criar: 'api/implantacao-migracao/subprocesso/Criar',
                    excluir: 'api/implantacao-migracao/subprocesso/Deletar/',
                    alterar: 'api/implantacao-migracao/subprocesso/Alterar/',
                    listarPorCodigo: 'api/implantacao-migracao/subprocesso/ListarPorCodigo/',
                    criarHistoricoComObservacao: 'api/implantacao-migracao/subprocesso/CriarHistoricoComObservacao',
                    listarTodosCanceladosFinalizados: 'api/implantacao-migracao/subProcesso/ListarTodosCanceladosFinalizados',
                    retornarSubprocessoStatusAnterior: 'api/implantacao-migracao/subProcesso/AlterarStatus'
                },
                atividade: {
                    proximoCodigo: 'api/implantacao-migracao/atividade/RetornarProximoCodigo',
                    criar: 'api/implantacao-migracao/atividade/Criar',
                    atualizar: 'api/implantacao-migracao/atividade/Atualizar',
                    excluir: 'api/implantacao-migracao/atividade/Deletar/',
                    listarComPaginacao: 'api/implantacao-migracao/atividade/ListarComPaginacao',
                    listarComPaginacaoDatatable: 'api/atividade/ListarComPaginacaoDatatable',
                    listarTodasAtividades: 'api/implantacao-migracao/atividade/ListarTodos',
                    listarTodasAtividadesAtivas: 'api/implantacao-migracao/atividade/ListarTodosAtivos',
                    listarAtividadesPorTarefa: 'api/implantacao-migracao/atividade/ListarAtividadesPorTarefa/'
                }
            },

            estatisticas: {
                estatisticas_individual: {
                    listarEstatistica: 'api/estatistica-desenvolvedor',
                    listarEstatisticaDesenvolvedorAno: 'api/estatistica-desenvolvedor/listarEstatisticaDesenvolvedorAno'
                }
            },

            indicadores: {
                gestaoIAguas: {
                    listarClientesIAguas: 'api/indicadores/ListarClientesIAguas',
                    retornarDados: 'api/indicadores/RetornarDadosGestaoIAguas',
                }
            },

            pesquisa: {
                tipoPesquisa: {
                    listarTodos: 'api/pesquisa-tipo/ListarTodos',
                    listarComPaginacao: 'api/pesquisa-tipo/ListarComPaginacao',
                    listarComPaginacaoDatatable: 'api/pesquisa-tipo/ListarComPaginacaoDatatable',
                    criar: 'api/pesquisa-tipo',
                    atualizar: 'api/pesquisa-tipo',
                    excluir: 'api/pesquisa-tipo/'
                },
                pesquisa: {
                    listarComPaginacao: 'api/pesquisa-satisfacao/ListarComPaginacao',
                    listarComPaginacaoDatatable: 'api/pesquisa-satisfacao/ListarComPaginacaoDatatable',
                    listarRespostasClientes: 'api/pesquisa-satisfacao/listarRespostasClientes',
                    listarPerguntasRespostasClientes: 'api/pesquisa-satisfacao/listarPerguntasRespostasClientes',
                    listarRespostasClientesGraficos: 'api/pesquisa-satisfacao/listarRespostasClientesGraficos',
                    criar: 'api/pesquisa-satisfacao/criar',
                    atualizar: 'api/pesquisa-satisfacao',
                    excluir: 'api/pesquisa-satisfacao/'
                }
            }
        })
})();


(function () {
  'use strict';

  angular
    .module('app.constants')
    .constant('ApiAcesso', {
      baseUrl : 'api/seguranca/',
      estado_login : 'app.login',
      seguranca: {
        token : 'token'
      },
      usuario: {
        baseUrl: 'usuario/',
        listartodos: 'usuario/listartodos',
        alterarsenha: 'alterarsenha',
        listarporperfil: 'usuario/listarporperfil/',
      }
    })
})();

/**
 * Created by nova on 18/07/2016.
 */
/*
  http://192.168.0.108:8051/
  http://localhost:59186/
 */
(function () {
    'use strict';

    angular
        .module('app.constants')
        .constant('ApiAtalhos', {     
            atalhos: {
                listarTodos: 'api/atalhos/ListarTodos/',
                criar: 'api/atalhos',
                atualizar: 'api/atalhos',
                excluir: 'api/atalhos/'
            }
        })

})();


(function () {
  'use strict';

  angular
    .module('app.constants')
    .constant('ApiAcesso', {
      baseUrl : 'api/seguranca/',
      estado_login : 'app.login',
      seguranca: {
        token : 'token'
      },
      usuario: {
        baseUrl: 'usuario/',
        listartodos: 'usuario/listartodos',
        alterarsenha: 'alterarsenha',
        listarporperfil: 'usuario/listarporperfil/'
      }
    })
})();

(function ()
{
    'use strict';

    angular
        .module('app.core')
        .run(runBlock);

    /** @ngInject */
    function runBlock(msUtils, fuseGenerator, fuseConfig)
    {
        /**
         * Generate extra classes based on registered themes so we
         * can use same colors with non-angular-material elements
         */
        fuseGenerator.generate();

        /**
         * Disable md-ink-ripple effects on mobile
         * if 'disableMdInkRippleOnMobile' config enabled
         */
        if ( fuseConfig.getConfig('disableMdInkRippleOnMobile') && msUtils.isMobile() )
        {
            var bodyEl = angular.element('body');
            bodyEl.attr('md-no-ink', true);
        }

        /**
         * Put isMobile() to the html as a class
         */
        if ( msUtils.isMobile() )
        {
            angular.element('html').addClass('is-mobile');
        }

        /**
         * Put browser information to the html as a class
         */
        var browserInfo = msUtils.detectBrowser();
        if ( browserInfo )
        {
            var htmlClass = browserInfo.browser + ' ' + browserInfo.version + ' ' + browserInfo.os;
            angular.element('html').addClass(htmlClass);
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .config(config);

    /** @ngInject */
    function config($ariaProvider, $logProvider, msScrollConfigProvider, fuseConfigProvider)
    {
        // Enable debug logging
        $logProvider.debugEnabled(true);

        /*eslint-disable */

        // ng-aria configuration
        $ariaProvider.config({
            tabindex: false
        });

        // Fuse theme configurations
        fuseConfigProvider.config({
            'disableCustomScrollbars'        : false,
            'disableCustomScrollbarsOnMobile': true,
            'disableMdInkRippleOnMobile'     : true
        });

        // msScroll configuration
        msScrollConfigProvider.config({
            wheelPropagation: true
        });

        /*eslint-enable */
    }
})();
(function () {
    'use strict';

    angular
        .module('fuse')
        .run(recarregarPagina);

    /** @ngInject */
    function recarregarPagina($rootScope, $window, $state, LoginUsuarioService, HubFactory, AtendimentoHubFactory, MensageiroHubFactory, SolicitacaoHubFactory, MenuFactory) {
        $window.onload = function () {
            if (!LoginUsuarioService.usuarioArmazenado())
                $rootScope.$broadcast('logout');
            else {
                HubFactory.conectar();
                MenuFactory.recarregarMenus().then(
                    function (success) {
                        AtendimentoHubFactory.atualizarQuantidadeAtendimentosNaoVisualizados(LoginUsuarioService.usuarioArmazenado().codigo);
                        AtendimentoHubFactory.atualizarQuantidadeAtendimentoEmAberto(LoginUsuarioService.usuarioArmazenado().codigo);
                        AtendimentoHubFactory.atualizarQuantidadeAtendimentoImportante(LoginUsuarioService.usuarioArmazenado().codigo);
                        MensageiroHubFactory.atualizarQuantidadeMensagensNaoVisualizados(LoginUsuarioService.usuarioArmazenado().codigo);
                        SolicitacaoHubFactory.atualizarQuantidadeSolicitacoesNaoVisualizados(LoginUsuarioService.usuarioArmazenado().codigo);
                    });
            }
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('fuse')
        .run(runBlock);

    /** @ngInject */
    function runBlock(MdDialogService, ControleAcessoConfig, LoginUsuarioService, $rootScope, $timeout, $state, $mdMedia,
        editableThemes, msNavigationService, AtendimentoHubFactory, MensageiroHubFactory, MenuFactory, HubFactory, SolicitacaoHubFactory) {

        $rootScope.tamanhoTelaDesktop = $mdMedia('min-width: 960px');
        $rootScope.interceptorRequestError = {
            unauthorizedError: false,
            notFoundError: false,
            disconnected: false
        };

        $rootScope.desabilitarMudancaDeEstadoDaAplicacao = false;

        // 3rd Party Dependencies
        editableThemes.default.submitTpl = '<md-button class="md-icon-button" type="submit" aria-label="save"><md-icon md-font-icon="icon-checkbox-marked-circle" class="md-accent-fg md-hue-1"></md-icon></md-button>';
        editableThemes.default.cancelTpl = '<md-button class="md-icon-button" ng-click="$form.$cancel()" aria-label="cancel"><md-icon md-font-icon="icon-close-circle" class="icon-cancel"></md-icon></md-button>';

        // Activate loading indicator
        var stateChangeStartEvent = $rootScope.$on('$stateChangeStart', function (e, toState, toParams, fromState, fromParams) {
            $rootScope.toState = toState;
            $rootScope.toParams = toParams;
            $rootScope.fromState = fromState;
            $rootScope.fromParams = fromParams;

            $rootScope.loadingProgress = true;

            //Botão flutuante para voltar ao topo da página
            $rootScope.utilizaBotaoScroll = false;

            var usuario = LoginUsuarioService.usuarioArmazenado();

            /**
             * Se a váriavel global estiver habilitada 'desabilitarMudancaDeEstadoDaAplicacao' o evento será cancelado e perguntado
             * se o usuário realmente deseja navegar para outro estado
             */
            if ($rootScope.desabilitarMudancaDeEstadoDaAplicacao) {
                e.preventDefault();
                $rootScope.loadingProgress = false;
                MdDialogService.confirmPadraoComEvento("Você realmente deseja sair da tela ?", "Pois todos os dados informados serão perdidos",
                    null,
                    function () {
                        $rootScope.desabilitarMudancaDeEstadoDaAplicacao = false;
                        irParaEstadoSelecionado(toState.name, true, toParams);
                    }, null);
            }
            else if (toState.module === 'privado' && usuario == null) {

                $rootScope.loadingProgress = false;
                $rootScope.$broadcast('logout');
                //e.preventDefault();                
            }
            // else if (toState.module === 'privado_gerencia' && usuario && !ControleAcessoConfig.ePerfilGerencia()) {
            //     $rootScope.loadingProgress = false;
            //     e.preventDefault();
            //     MdDialogService.alertPadrao("Acesso restrito.", null, null);
            // }
            else if (toState.module === 'privado_desenvolvimento' && usuario && !ControleAcessoConfig.usuarioEDesenvolvimento()) {
                $rootScope.loadingProgress = false;
                e.preventDefault();
                MdDialogService.alertPadrao("Acesso restrito.", null, null);
            }


        });

        // De-activate loading indicator
        var stateChangeSuccessEvent = $rootScope.$on('$stateChangeSuccess', function (event, toState, toParams, fromState, fromParams) {

            $rootScope.previousState = fromState.name;
            var parametros = JSON.parse(sessionStorage.getItem('parametros'));
            if (parametros) {
                sessionStorage.removeItem('parametros');
                $rootScope.state.params = parametros;
            }
            $timeout(function () {
                $rootScope.loadingProgress = false;
            });

            if (LoginUsuarioService.usuarioArmazenado() && !msNavigationService.getNavigation().length) {
                HubFactory.conectar();
                MenuFactory.recarregarMenus().then(
                    function (success) {
                        AtendimentoHubFactory.atualizarQuantidadeAtendimentosNaoVisualizados(LoginUsuarioService.usuarioArmazenado().codigo);
                        AtendimentoHubFactory.atualizarQuantidadeAtendimentoEmAberto(LoginUsuarioService.usuarioArmazenado().codigo);
                        AtendimentoHubFactory.atualizarQuantidadeAtendimentoImportante(LoginUsuarioService.usuarioArmazenado().codigo);
                        MensageiroHubFactory.atualizarQuantidadeMensagensNaoVisualizados(LoginUsuarioService.usuarioArmazenado().codigo);
                        SolicitacaoHubFactory.atualizarQuantidadeSolicitacoesNaoVisualizados(LoginUsuarioService.usuarioArmazenado().codigo);
                    }, function (error) {
                        console.log(error);
                    });
            }
        });

        // Store state in the root scope for easy access
        $rootScope.state = $state;

        // Cleanup
        $rootScope.$on('$destroy', function () {
            stateChangeStartEvent();
            stateChangeSuccessEvent();
            stateChangeNotFound();
            stateChangeError();
        });

        // Método padrão para voltar um estado anterior
        $rootScope.voltarEstado = function () {
            $state.go($rootScope.previousState);
        }

        /**
         * Método que recebe o estado, e navega para o estado solicitado
         * @param {nomeEstado} estado
         * @param {boolean} habilitarLoadingProgress
         */
        function irParaEstadoSelecionado(estado, habilitarLoadingProgress, parametros) {
            if (habilitarLoadingProgress)
                $rootScope.loadingProgress = true;
            $state.go(estado, parametros);
        }
    }
})();

(function () {
  'use strict';

  angular
    .module('fuse')
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider, $urlRouterProvider, $locationProvider) {
    $locationProvider.html5Mode(true);

    $urlRouterProvider.otherwise('/login');

    var layouts = {
      verticalNavigationFullwidthToolbar2: {
        main: 'app/core/layouts/vertical-navigation-fullwidth-toolbar-2.html',
        toolbar: 'app/toolbar/layouts/vertical-navigation-fullwidth-toolbar-2/toolbar.html',
        navigation: 'app/navigation/layouts/vertical-navigation-fullwidth-toolbar-2/navigation.html'
      }
    };		
    // END - Layout Style Switcher

    // State definitions
    $stateProvider
      .state('app', {
        abstract: true,
        module: 'publico',
        views: {
          'main@': {
            templateUrl: layouts.verticalNavigationFullwidthToolbar2.main,
            controller: 'MainController as vm'
          },
          'toolbar@app': {
            templateUrl: layouts.verticalNavigationFullwidthToolbar2.toolbar,
            controller: 'ToolbarController as vm'
          },
          'navigation@app': {
            templateUrl: layouts.verticalNavigationFullwidthToolbar2.navigation,
            controller: 'NavigationController as vm'
          }
        }
      });
  }

})();

(function ()
{
    'use strict';

    angular
        .module('fuse')
        .controller('IndexController', IndexController);

    /** @ngInject */
    function IndexController(fuseTheming)
    {
        var vm = this;

        // Data
        vm.themes = fuseTheming.themes;

        //////////
    }
})();
(function ()
{
    'use strict';

    angular
        .module('fuse');
})();

(function () {
    'use strict';

    angular
        .module('fuse')
        .config(config);

    function config(uiGmapGoogleMapApiProvider, $translateProvider, $provide, urlApiProvider, versaoImanagerProvider, contatosProvider) {
        $.ajax({
            url: 'app/data/config.json',
            async: false,
            dataType: 'json',
            success: function (data) {
                urlApiProvider.setUrl(data);
            }
        });

        $.ajax({
            url: 'app/data/versao-imanager.json',
            async: false,
            dataType: 'json',
            success: function (data) {
                versaoImanagerProvider.setVersao(data);
            }
        });

        $.ajax({
            url: 'app/data/contatos.json',
            async: false,
            dataType: 'json',
            success: function (data) {
                contatosProvider.setContatos(data);
            }
        });


        // Put your common app configurations here

        // uiGmapgoogle-maps configuration
        uiGmapGoogleMapApiProvider.configure({
            //    key: 'your api key',
            v: '3.exp',
            libraries: 'weather,geometry,visualization'
        });

        // angular-translate configuration
        $translateProvider.useLoader('$translatePartialLoader', {
            urlTemplate: '{part}/i18n/{lang}.json'
        });
        $translateProvider.preferredLanguage('pt-br');
        $translateProvider.useSanitizeValueStrategy('sanitize');

        // Text Angular options
        $provide.decorator('taOptions', [
            '$delegate', function (taOptions) {
                taOptions.toolbar = [
                    ['h1', 'h2', 'h3', 'quote', 'bold', 'italics', 'underline', 'strikeThrough', 'ul', 'ol', 'redo', 'undo', 'justifyLeft', 'justifyCenter', 'justifyRight', 'indent', 'outdent', 'insertImage'
                    ],
                ];

                taOptions.classes = {
                    focussed: 'focussed',
                    toolbar: 'ta-toolbar',
                    toolbarGroup: 'ta-group',
                    toolbarButton: 'md-button',
                    toolbarButtonActive: 'active',
                    disabled: '',
                    textEditor: 'form-control',
                    htmlEditor: 'form-control'
                };

                return taOptions;
            }
        ]);

        $provide.decorator('$state', ['$delegate', '$window',
            function ($delegate, $window) {
                var extended = {
                    goNewTab: function (stateName, parametros) {
                        sessionStorage.setItem('parametros', JSON.stringify(parametros));
                        var url = this.href(stateName);
                        $window.open(url, '_blank');
                        sessionStorage.removeItem('parametros');
                    }
                };
                angular.extend($delegate, extended);
                return $delegate;
            }
        ]);

        // Text Angular tools
        $provide.decorator('taTools', [
            '$delegate', function (taTools) {
                taTools.quote.iconclass = 'icon-format-quote';
                taTools.bold.iconclass = 'icon-format-bold';
                taTools.italics.iconclass = 'icon-format-italic';
                taTools.underline.iconclass = 'icon-format-underline';
                taTools.strikeThrough.iconclass = 'icon-format-strikethrough';
                taTools.ul.iconclass = 'icon-format-list-bulleted';
                taTools.ol.iconclass = 'icon-format-list-numbers';
                taTools.redo.iconclass = 'icon-redo';
                taTools.undo.iconclass = 'icon-undo';
                taTools.clear.iconclass = 'icon-close-circle-outline';
                taTools.justifyLeft.iconclass = 'icon-format-align-left';
                taTools.justifyCenter.iconclass = 'icon-format-align-center';
                taTools.justifyRight.iconclass = 'icon-format-align-right';
                taTools.justifyFull.iconclass = 'icon-format-align-justify';
                taTools.indent.iconclass = 'icon-format-indent-increase';
                taTools.outdent.iconclass = 'icon-format-indent-decrease';
                taTools.html.iconclass = 'icon-code-tags';
                taTools.insertImage.iconclass = 'icon-file-image-box';
                taTools.insertLink.iconclass = 'icon-link';
                taTools.insertVideo.iconclass = 'icon-filmstrip';

                return taTools;
            }
        ]);

        $provide.decorator("mdDatepickerDirective", function ($delegate) {
            var directive = $delegate[0];

            var template = directive.template;
            var link = directive.link;

            // extending the link function
            directive.compile = function () {
                return function (scope, element, attrs, ctrl) {
                    link.apply(this, arguments);
                    if (attrs.ngMask) {
                        var inputNgModelControl = scope.ctrl.ngInputElement.controller(
                            "ngModel"
                        );

                        // for the first initialization
                        inputNgModelControl.$formatters.push(function (value) {
                            var viewValue = scope.ctrl.ngInputElement.controller(
                                "mdDatepicker"
                            ).ngModelCtrl.$viewValue;
                            if (!viewValue) {
                                return undefined;
                            }
                            return scope.ctrl.$mdDateLocale.formatDate(viewValue);
                        });
                    }
                };
            };
            // replacing template when needed
            directive.template = function (tElement, tAttrs) {
                var originalTemplate = template.apply(this, arguments);
                // adding mask and ng-model to mdDatepicker's input
                if (tAttrs.ngMask) {
                    var element = angular.element(originalTemplate);
                    element.find("input").attr("mask", tAttrs.ngMask);
                    element.find("input").attr("mask-validate", false);
                    element.find("input").attr("ng-model", "ctrl.dateInput");
                    element.find("input").attr("restrict", "reject");

                    // new tempalte with mask and ng-model attributes
                    var newTemplate = "";
                    for (var i = 0; i < element.length; i++) {
                        newTemplate += element[i].outerHTML;
                    }
                    return newTemplate;
                }
                return originalTemplate;
            };
            return $delegate;
        });
    }

})();

(function ()
{
    'use strict';

    angular
        .module('fuse')
        .factory('api', apiService);

    /** @ngInject */
    function apiService($resource)
    {
        /**
         * You can use this service to define your API urls. The "api" service
         * is designed to work in parallel with "apiResolver" service which you can
         * find in the "app/core/services/api-resolver.service.js" file.
         *
         * You can structure your API urls whatever the way you want to structure them.
         * You can either use very simple definitions, or you can use multi-dimensional
         * objects.
         *
         * Here's a very simple API url definition example:
         *
         *      api.getBlogList = $resource('http://api.example.com/getBlogList');
         *
         * While this is a perfectly valid $resource definition, most of the time you will
         * find yourself in a more complex situation where you want url parameters:
         *
         *      api.getBlogById = $resource('http://api.example.com/blog/:id', {id: '@id'});
         *
         * You can also define your custom methods. Custom method definitions allow you to
         * add hardcoded parameters to your API calls that you want to sent every time you
         * make that API call:
         *
         *      api.getBlogById = $resource('http://api.example.com/blog/:id', {id: '@id'}, {
         *         'getFromHomeCategory' : {method: 'GET', params: {blogCategory: 'home'}}
         *      });
         *
         * In addition to these definitions, you can also create multi-dimensional objects.
         * They are nothing to do with the $resource object, it's just a more convenient
         * way that we have created for you to packing your related API urls together:
         *
         *      api.blog = {
         *                   list     : $resource('http://api.example.com/blog'),
         *                   getById  : $resource('http://api.example.com/blog/:id', {id: '@id'}),
         *                   getByDate: $resource('http://api.example.com/blog/:date', {id: '@date'}, {
         *                       get: {
         *                            method: 'GET',
         *                            params: {
         *                                getByDate: true
         *                            }
         *                       }
         *                   })
         *       }
         *
         * If you look at the last example from above, we overrode the 'get' method to put a
         * hardcoded parameter. Now every time we make the "getByDate" call, the {getByDate: true}
         * object will also be sent along with whatever data we are sending.
         *
         * All the above methods are using standard $resource service. You can learn more about
         * it at: https://docs.angularjs.org/api/ngResource/service/$resource
         *
         * -----
         *
         * After you defined your API urls, you can use them in Controllers, Services and even
         * in the UIRouter state definitions.
         *
         * If we use the last example from above, you can do an API call in your Controllers and
         * Services like this:
         *
         *      function MyController (api)
         *      {
         *          // Get the blog list
         *          api.blog.list.get({},
         *
         *              // Success
         *              function (response)
         *              {
         *                  console.log(response);
         *              },
         *
         *              // Error
         *              function (response)
         *              {
         *                  console.error(response);
         *              }
         *          );
         *
         *          // Get the blog with the id of 3
         *          var id = 3;
         *          api.blog.getById.get({'id': id},
         *
         *              // Success
         *              function (response)
         *              {
         *                  console.log(response);
         *              },
         *
         *              // Error
         *              function (response)
         *              {
         *                  console.error(response);
         *              }
         *          );
         *
         *          // Get the blog with the date by using custom defined method
         *          var date = 112314232132;
         *          api.blog.getByDate.get({'date': date},
         *
         *              // Success
         *              function (response)
         *              {
         *                  console.log(response);
         *              },
         *
         *              // Error
         *              function (response)
         *              {
         *                  console.error(response);
         *              }
         *          );
         *      }
         *
         * Because we are directly using $resource service, all your API calls will return a
         * $promise object.
         *
         * --
         *
         * If you want to do the same calls in your UI Router state definitions, you need to use
         * "apiResolver" service we have prepared for you:
         *
         *      $stateProvider.state('app.blog', {
         *          url      : '/blog',
         *          views    : {
         *               'content@app': {
         *                   templateUrl: 'app/main/apps/blog/blog.html',
         *                   controller : 'BlogController as vm'
         *               }
         *          },
         *          resolve  : {
         *              Blog: function (apiResolver)
         *              {
         *                  return apiResolver.resolve('blog.list@get');
         *              }
         *          }
         *      });
         *
         *  You can even use parameters with apiResolver service:
         *
         *      $stateProvider.state('app.blog.show', {
         *          url      : '/blog/:id',
         *          views    : {
         *               'content@app': {
         *                   templateUrl: 'app/main/apps/blog/blog.html',
         *                   controller : 'BlogController as vm'
         *               }
         *          },
         *          resolve  : {
         *              Blog: function (apiResolver, $stateParams)
         *              {
         *                  return apiResolver.resolve('blog.getById@get', {'id': $stateParams.id);
         *              }
         *          }
         *      });
         *
         *  And the "Blog" object will be available in your BlogController:
         *
         *      function BlogController(Blog)
         *      {
         *          var vm = this;
         *
         *          // Data
         *          vm.blog = Blog;
         *
         *          ...
         *      }
         */

        var api = {};

        // Base Url
        api.baseUrl = 'app/data/';

        /**
         * Here you can find all the definitions that the Demo Project requires
         *
         * If you wish to use this method, you can create your API definitions
         * in a similar way.
         */

        /*
         api.dashboard = {
         project  : $resource(api.baseUrl + 'dashboard/project/data.json'),
         server   : $resource(api.baseUrl + 'dashboard/server/data.json'),
         analytics: $resource(api.baseUrl + 'dashboard/analytics/data.json')
         };

         api.cards = $resource(api.baseUrl + 'cards/cards.json');

         api.fileManager = {
         documents: $resource(api.baseUrl + 'file-manager/documents.json')
         };

         api.ganttChart = {
         tasks: $resource(api.baseUrl + 'gantt-chart/tasks.json'),
         timespans : $resource(api.baseUrl + 'gantt-chart/timespans.json')
         };

         api.icons = $resource('assets/icons/selection.json');

         api.invoice = $resource(api.baseUrl + 'invoice/invoice.json');

         api.mail = {
         inbox: $resource(api.baseUrl + 'mail/inbox.json')
         };

         api.profile = {
         timeline    : $resource(api.baseUrl + 'profile/timeline.json'),
         about       : $resource(api.baseUrl + 'profile/about.json'),
         photosVideos: $resource(api.baseUrl + 'profile/photos-videos.json')
         };

         api.quickPanel = {
         activities: $resource(api.baseUrl + 'quick-panel/activities.json'),
         contacts  : $resource(api.baseUrl + 'quick-panel/contacts.json'),
         events    : $resource(api.baseUrl + 'quick-panel/events.json'),
         notes     : $resource(api.baseUrl + 'quick-panel/notes.json')
         };

         api.search = {
         classic : $resource(api.baseUrl + 'search/classic.json'),
         mails   : $resource(api.baseUrl + 'search/mails.json'),
         users   : $resource(api.baseUrl + 'search/users.json'),
         contacts: $resource(api.baseUrl + 'search/contacts.json')
         };

         api.scrumboard = {
         boardList: $resource(api.baseUrl + 'scrumboard/boardList.json'),
         board    : $resource(api.baseUrl + 'scrumboard/boards/:id.json')
         };

         api.tables = {
         employees   : $resource(api.baseUrl + 'tables/employees.json'),
         employees100: $resource(api.baseUrl + 'tables/employees100.json')
         };

         api.timeline = {
         page1: $resource(api.baseUrl + 'timeline/page-1.json'),
         page2: $resource(api.baseUrl + 'timeline/page-2.json'),
         page3: $resource(api.baseUrl + 'timeline/page-3.json')
         };

         api.todo = {
         tasks: $resource(api.baseUrl + 'todo/tasks.json'),
         tags : $resource(api.baseUrl + 'todo/tags.json')
         };
         */

        return api;
    }

})();
(function () {
    'use strict';

    angular
        .module('fuse')
        .controller('HeaderController', HeaderController);

    /** @ngInject */
    function HeaderController($rootScope) {
        var vm = this;
        vm.tituloAbas = null;
        $rootScope.$on('atualizarTitle', function (event, title) {
            vm.tituloAbas = title;
        });
    }
})();
(function () {
    'use strict';

    angular
        .module('app.locacao.cadastro.equipamentos.equipamento_nota', [])
        .config(config);

    function config($stateProvider, RotasHtml) {
        var rotasHtmlEquipamentoNota = RotasHtml.equipamento_nota;
        $stateProvider.state(
          "app.locacao_cadastro_equipamentos_equipamento_nota",
          {
            url: "/locacao/cadastro/equipamentos/equipamento-nota",
            module: "privado",
            views: {
              "content@app": {
                templateUrl: rotasHtmlEquipamentoNota.templateUrl,
                controller: "EquipamentoNotaController as vm"
              },
              "equipamento-nota-form@app.locacao_cadastro_equipamentos_equipamento_nota": {
                templateUrl: rotasHtmlEquipamentoNota.form
              }
              // "equipamento-nota-tabela@app.locacao_cadastro_equipamentos_equipamento_nota": {
              //   templateUrl: rotasHtmlEquipamentoNota.tabela
              // }
            }
          }
        );
    }

})();

//<!-- Ultima mudança 28/03/2017.-->
(function () {
    'use strict';

    angular
      .module("app.locacao.cadastro.equipamentos.equipamento", [])
      .config(config);

    function config($stateProvider, RotasHtml) {
         var rotasHtmlEquipamentoTipo = RotasHtml.equipamento_locacao;
        $stateProvider
            .state('app.locacao_cadastro_equipamentos_equipamento', {
                url: '/locacao/cadastro/equipamentos/equipamento',
                module: 'privado',
                views: {
                    'content@app': {
                        templateUrl: rotasHtmlEquipamentoTipo.templateUrl,
                        controller: 'EquipamentoLocacaoController as vm'
                    },
                    'equipamento-form@app.locacao_cadastro_equipamentos_equipamento': {
                        templateUrl: rotasHtmlEquipamentoTipo.form
                    },
                    'equipamento-tabela@app.locacao_cadastro_equipamentos_equipamento': {
                        templateUrl: rotasHtmlEquipamentoTipo.tabela
                    }
                },
                resolve: {
                    ListarFabricantes: function (Api, RequisicaoGenericaLocacaoService) {
                        return RequisicaoGenericaLocacaoService.listarSemParams(Api.locacao.equipamentos.fabricante.listarTodos);
                    },
                    ListarTiposEquipamento: function (Api, RequisicaoGenericaLocacaoService) {
                        return RequisicaoGenericaLocacaoService.listarSemParams(Api.locacao.equipamentos.tipo.listarTodos);
                    }
                }
            });
    }

})();

(function () {
    'use strict';

    angular
        .module('app.financeiro.cadastro.contrato.statusContrato', [])
        .config(config);

    function config($stateProvider, RotasHtml) {
        var rotasHtmlBairro = RotasHtml.status_contrato;
        $stateProvider
            .state('app.financeiro_cadastro_contrato_statuscontrato', {
                url: '/financeiro/cadastro/contrato/status-contrato',
                module: 'privado',
                views: {
                    'content@app': {
                        templateUrl: rotasHtmlBairro.templateUrl,
                        controller: "StatusContratoController as vm"
                    },
                    'status-contrato-form@app.financeiro_cadastro_contrato_statuscontrato': {
                        templateUrl: rotasHtmlBairro.form
                    },
                    'status-contratos-tabela@app.financeiro_cadastro_contrato_statuscontrato': {
                        templateUrl: rotasHtmlBairro.tabela
                    }
                }
            });
    }

})();

(function () {
    'use strict';

    angular
        .module('app.financeiro.cadastro.contrato.motivoAditivo', [])
        .config(config);

    function config($stateProvider, RotasHtml) {
        var rotas = RotasHtml.motivo_aditivo;
        $stateProvider
            .state('app.financeiro_cadastro_contrato_motivoaditivo', {
                url: '/financeiro/cadastro/contrato/motivo-aditivo',
                module: 'privado',
                views: {
                    'content@app': {
                        templateUrl: rotas.templateUrl,
                        controller: "MotivoAditivoController as vm"
                    },
                    'motivo-aditivo-form@app.financeiro_cadastro_contrato_motivoaditivo': {
                        templateUrl: rotas.form
                    },
                    'motivos-aditivo-tabela@app.financeiro_cadastro_contrato_motivoaditivo': {
                        templateUrl: rotas.tabela
                    }
                }
            });
    }

})();

(function () {
    'use strict';

    angular
        .module('app.financeiro.cadastro.contrato.tipoContrato', [])
        .config(config);

    function config($stateProvider, RotasHtml) {
        var rotasHtmlTipoContrato = RotasHtml.tipo_contrato;
        $stateProvider
            .state('app.financeiro_cadastro_contrato_tipocontrato', {
                url: '/financeiro/cadastro/contrato/tipo-contrato',
                module: 'privado',
                views: {
                    'content@app': {
                        templateUrl: rotasHtmlTipoContrato.templateUrl,
                        controller: "TipoContratoController as vm"
                    },
                    'tipo-contrato-form@app.financeiro_cadastro_contrato_tipocontrato': {
                        templateUrl: rotasHtmlTipoContrato.form
                    },
                    'tipo-contratos-tabela@app.financeiro_cadastro_contrato_tipocontrato': {
                        templateUrl: rotasHtmlTipoContrato.tabela
                    }
                }
            });
    }

})();
//<!-- Ultima mudança 09/05/2017.-->
(function () {
    'use strict';

    angular
        .module('app.atendimento.processamento.atendimentoNaoVisualizados', [])
        .config(config);

    function config($stateProvider, RotasHtml) {
        var rotasHtmlAtendimento = RotasHtml.atendimento;
        var rotasContratos = RotasHtml.contratos;
        $stateProvider
            .state('app.atendimento_processamento_atendimentos_nao_visualizados', {
                url: '/atendimento/processamento/atendimento-nao-visualizados',
                module: 'privado',
                params: {
                    parametros: null,
                    iniciarListandoAtendimentosNaoVisualizados: true
                },
                views: {
                    'content@app': {
                        templateUrl: rotasHtmlAtendimento.templateUrl,
                        controller: "AtendimentoController as vm"
                    },
                    'atendimento-form@app.atendimento_processamento_atendimentos_nao_visualizados': {
                        templateUrl: rotasHtmlAtendimento.form
                    },
                    'atendimentos-tabela@app.atendimento_processamento_atendimentos_nao_visualizados': {
                        templateUrl: rotasHtmlAtendimento.tabela
                    },
                    'contratos@app.atendimento_processamento_atendimento': {
                        templateUrl: rotasContratos.templateUrl
                    },
                    'contratos-form@app.atendimento_processamento_atendimentos_nao_visualizados': {
                        templateUrl: rotasContratos.form
                    },
                    'contratos-tabela@app.atendimento_processamento_atendimentos_nao_visualizados': {
                        templateUrl: rotasContratos.tabela
                    }
                },
                resolve: {
                    ListarTodosUsuariosAtivos: function (Api, RequisicaoGenericaService) {
                        return RequisicaoGenericaService.listarSemParams(Api.usuario.detalhes_usuario.listarUsuariosAtivos);
                    },
                    ListarTiposAtendimento: function (Api, RequisicaoGenericaService) {
                        return RequisicaoGenericaService.listarSemParams(Api.atendimento.listarTiposAtendimento);
                    },
                    ListarUsuarioPorDetalhe: function (Api, RequisicaoGenericaService, LoginUsuarioService) {
                        return RequisicaoGenericaService.listarSemParams(Api.usuario.detalhes_usuario.listarUsuarioPorDetalhe
                            + LoginUsuarioService.usuarioArmazenado().codigo);
                    },
                    ListarStatusAtendimento: function (Api, RequisicaoGenericaService) {
                        return RequisicaoGenericaService.listarSemParams(Api.atendimento.listarStatusAtendimento);
                    },
                    ListarTodasSolucoes: function (Api, RequisicaoGenericaService) {
                        return RequisicaoGenericaService.listarSemParams(Api.solucao_rotinas_tarefas.solucao.listarCodigoDescricao);
                    },
                    ListarTodosAtendimentosMotivo: function (Api, RequisicaoGenericaService) {
                        return RequisicaoGenericaService.listarSemParams(Api.atendimento.grupo_atendimento.listarPor);
                    },
                    ListarTodosAtendimentosPendencia: function (Api, RequisicaoGenericaService) {
                        return RequisicaoGenericaService.listarSemParams(Api.atendimento.pendencia_atendimento.listarPor);
                    },
                    ListarTodosAtendimentosConclusao: function (Api, RequisicaoGenericaService) {
                        return RequisicaoGenericaService.listarSemParams(Api.atendimento.conclusao.listarPor);
                    },
                    ListarTodosEventos: function (Api, RequisicaoGenericaService) {
                        return RequisicaoGenericaService.listarSemParams(Api.agenda.evento.listarTodos);
                    },
                    ListarStatusAtividade: function (Api, RequisicaoGenericaService) {
                        return RequisicaoGenericaService.listarSemParams(Api.agenda.atividade.listarStatus);
                    },
                    ListarDetalhesUsuario: function (Api, RequisicaoGenericaService, LoginUsuarioService) {
                        return RequisicaoGenericaService.listarSemParams(Api.usuario.detalhes_usuario.listarDetalhesUsuario
                            + LoginUsuarioService.usuarioArmazenado().codigo);
                    },
                    ListarTodasTags: function (Api, RequisicaoGenericaService) {
                        return RequisicaoGenericaService.listarSemParams(Api.atendimento.tag.listarTodas);
                    },
                    ListarUsuariosSetorComercial: function (Api, RequisicaoGenericaService) {
                        return RequisicaoGenericaService.listarSemParams(Api.usuario.listarUsuariosSetorComercial);
                    },
                }
            });
    }

})();

(function () {
    'use strict';

    angular
        .module('app.atendimento.processamento.atendimentosimportantes', [])
        .config(config);

    function config($stateProvider, RotasHtml) {
        var rotasHtmlAtendimento = RotasHtml.atendimento;
        var rotasContratos = RotasHtml.contratos;
        $stateProvider
            .state('app.atendimento_processamento_atendimentos_importantes', {
                url: '/atendimento/processamento/atendimentos-importantes',
                module: 'privado',
                params: {
                    parametros: null,
                    iniciarListandoAtendimentosImportantes: true
                },
                views: {
                    'content@app': {
                        templateUrl: rotasHtmlAtendimento.templateUrl,
                        controller: "AtendimentoController as vm"
                    },
                    'atendimento-form@app.atendimento_processamento_atendimentos_importantes': {
                        templateUrl: rotasHtmlAtendimento.form
                    },
                    'atendimentos-tabela@app.atendimento_processamento_atendimentos_importantes': {
                        templateUrl: rotasHtmlAtendimento.tabela
                    },
                    'contratos@app.atendimento_processamento_atendimento': {
                        templateUrl: rotasContratos.templateUrl
                    },
                    'contratos-form@app.atendimento_processamento_atendimentos_importantes': {
                        templateUrl: rotasContratos.form
                    },
                    'contratos-tabela@app.atendimento_processamento_atendimentos_importantes': {
                        templateUrl: rotasContratos.tabela
                    }
                },
                resolve: {
                    ListarTodosUsuariosAtivos: function (Api, RequisicaoGenericaService) {
                        return RequisicaoGenericaService.listarSemParams(Api.usuario.detalhes_usuario.listarUsuariosAtivos);
                    },
                    ListarTiposAtendimento: function (Api, RequisicaoGenericaService) {
                        return RequisicaoGenericaService.listarSemParams(Api.atendimento.listarTiposAtendimento);
                    },
                    ListarUsuarioPorDetalhe: function (Api, RequisicaoGenericaService, LoginUsuarioService) {
                        return RequisicaoGenericaService.listarSemParams(Api.usuario.detalhes_usuario.listarUsuarioPorDetalhe
                            + LoginUsuarioService.usuarioArmazenado().codigo);
                    },
                    ListarStatusAtendimento: function (Api, RequisicaoGenericaService) {
                        return RequisicaoGenericaService.listarSemParams(Api.atendimento.listarStatusAtendimento);
                    },
                    ListarTodasSolucoes: function (Api, RequisicaoGenericaService) {
                        return RequisicaoGenericaService.listarSemParams(Api.solucao_rotinas_tarefas.solucao.listarCodigoDescricao);
                    },
                    ListarTodosAtendimentosMotivo: function (Api, RequisicaoGenericaService) {
                        return RequisicaoGenericaService.listarSemParams(Api.atendimento.grupo_atendimento.listarPor);
                    },
                    ListarTodosAtendimentosPendencia: function (Api, RequisicaoGenericaService) {
                        return RequisicaoGenericaService.listarSemParams(Api.atendimento.pendencia_atendimento.listarPor);
                    },
                    ListarTodosAtendimentosConclusao: function (Api, RequisicaoGenericaService) {
                        return RequisicaoGenericaService.listarSemParams(Api.atendimento.conclusao.listarPor);
                    },
                    ListarTodosEventos: function (Api, RequisicaoGenericaService) {
                        return RequisicaoGenericaService.listarSemParams(Api.agenda.evento.listarTodos);
                    },
                    ListarStatusAtividade: function (Api, RequisicaoGenericaService) {
                        return RequisicaoGenericaService.listarSemParams(Api.agenda.atividade.listarStatus);
                    },
                    ListarDetalhesUsuario: function (Api, RequisicaoGenericaService, LoginUsuarioService) {
                        return RequisicaoGenericaService.listarSemParams(Api.usuario.detalhes_usuario.listarDetalhesUsuario
                            + LoginUsuarioService.usuarioArmazenado().codigo);
                    },
                    ListarTodasTags: function (Api, RequisicaoGenericaService) {
                        return RequisicaoGenericaService.listarSemParams(Api.atendimento.tag.listarTodas);
                    },
                    ListarUsuariosSetorComercial: function (Api, RequisicaoGenericaService) {
                        return RequisicaoGenericaService.listarSemParams(Api.usuario.listarUsuariosSetorComercial);
                    },
                }
            });
    }

})();

(function () {
    'use strict';

    angular
        .module('app.trabalheconosco.cadastro.categoria', [])
        .config(Config);

    function Config($stateProvider, RotasHtml) {
        var rotasHtml = RotasHtml.trabalheConoscoCadastroCategoria;
        $stateProvider
            .state('app.trabalheconosco_cadastro_categoria', {
                url: '/trabalheconosco/cadastro/categoria',
                module: 'privado',
                params: {
                    parametros: null
                },
                views: {
                    'content@app': {
                        templateUrl: rotasHtml.templateUrl,
                        controller: 'TrabalheConoscoCategoriaController as vm'
                    },
                    'trabalhe-conosco-categoria-form@app.trabalheconosco_cadastro_categoria': {
                        templateUrl: rotasHtml.form
                    },
                    'trabalhe-conosco-categorias-tabela@app.trabalheconosco_cadastro_categoria': {
                        templateUrl: rotasHtml.tabela
                    }
                },
                resolve: {     
                    ListarTodosSetores: function (Api, RequisicaoGenericaService) {
                        return RequisicaoGenericaService.listarSemParams(Api.setor.listarCodigoDescricao);
                    },     
                }
            });
    }

})();

(function () {
    'use strict';

    angular.module("app.locacao.cadastro.equipamentos", [
      "app.locacao.cadastro.equipamentos.equipamento_situacao",
      "app.locacao.cadastro.equipamentos.equipamento_estado_conservacao",
      "app.locacao.cadastro.equipamentos.equipamento_motivo_baixa",
      "app.locacao.cadastro.equipamentos.equipamento_fornecedor",
      "app.locacao.cadastro.equipamentos.equipamento_tipo",
      "app.locacao.cadastro.equipamentos.equipamento_fabricante",
      "app.locacao.cadastro.equipamentos.equipamento"
    ]);
})();

(function () {
  'use strict';

  angular
    .module('app.financeiro.processamento.enviodeemails', [])
    .config(config);

  function config($stateProvider, RotasHtml) {
    var rotas = RotasHtml.envio_de_emails;
    $stateProvider
      .state('app.financeiro_processamento_enviodeemails', {
        url: '/financeiro/processamento/envio-de-emails',
        module: 'privado',
        views: {
          'content@app': {
            templateUrl: rotas.templateUrl,
            controller: "EnvioDeEmailsController as vm"
          },
          'envio-de-emails-form@app.financeiro_processamento_enviodeemails': {
            templateUrl: rotas.form
          }
        },
        resolve: {
          ListarTodosFinanceirosEmails: function (Api, RequisicaoGenericaService) {
            return RequisicaoGenericaService.listarSemParams(Api.financeiroEmail.listarTodosCodigoEEmail);
          }
        }
      });
  }

})();

/**
 * Created by nova on 27/09/2016.
 */
(function () {
    'use strict';

    angular
        .module('app.financeiro.cadastro.faturamento', [
            'app.financeiro.cadastro.faturamento.formaFaturamento',
            'app.financeiro.cadastro.faturamento.formaPagamento',
            'app.financeiro.cadastro.faturamento.natureza'
        ]);

})();

//<!-- Ultima mudança 10/08/2017.-->
(function () {
    'use strict';

    angular
        .module('app.financeiro.cadastro.contrato', [
            'app.financeiro.cadastro.contrato.indiceReajuste',
            'app.financeiro.cadastro.contrato.motivoAditivo',
            'app.financeiro.cadastro.contrato.statusContrato',
            'app.financeiro.cadastro.contrato.tipoContrato',
            'app.financeiro.cadastro.contrato.motivoRiscoContratual',
        ]);
})();

/**
 * Created by nova on 27/09/2016.
 */
(function () {
    'use strict';

    angular
        .module('app.geral.relatorio.controle-horas', [])
        .config(config)


    function config($stateProvider, RotasHtml) {
        var rotasHtmlRelatorioControleHoras = RotasHtml.relatorioControleHoras;

        $stateProvider
            .state('app.geral_relatorio_controle_horas', {
                url: '/geral/relatorio/relatorio_controle_horas',
                module: 'privado',
                views: {
                    'content@app': {
                        templateUrl: rotasHtmlRelatorioControleHoras.templateUrl,
                        controller: "RelatorioControleHorasController as vm"
                    },
                    'form@app.geral_relatorio_controle_horas': {
                        templateUrl: rotasHtmlRelatorioControleHoras.form
                    },
                    'steper-informacoes-gerais@app.geral_relatorio_controle_horas': {
                        templateUrl: rotasHtmlRelatorioControleHoras.informacoesGerais
                    }

                }
            });
    }


})();

/**
 * Created by nova on 27/09/2016.
 */
(function () {
  'use strict';

  angular
    .module('app.geral.cadastro.usuario', [
      'app.geral.cadastro.usuario.usuario',
      'app.geral.cadastro.usuario.perfil',
      'app.geral.cadastro.usuario.setor'      
    ]);

})();

/**
 * Created by nova on 27/09/2016.
 */
(function () {
    'use strict';

    angular
        .module('app.geral.cadastro.solucao', [
            'app.geral.cadastro.solucao.solucao',
            'app.geral.cadastro.solucao.produto'            
        ]);

})();

//<!-- Ultima mudança 28/03/2017.-->
(function () {
    'use strict';

    angular
        .module('app.geral.cadastro.cliente', [
            'app.geral.cadastro.cliente.cliente',
            'app.geral.cadastro.cliente.cargo',
            'app.geral.cadastro.cliente.pessoa',
            'app.geral.cadastro.cliente.pendencia'
        ]);
})();

//<!-- Ultima mudança 24/03/2017.-->
(function () {
  'use strict';

  angular
    .module('app.geral.cadastro.endereco', [
      'app.geral.cadastro.endereco.bairro',
      'app.geral.cadastro.endereco.cidade'      
    ]);

})();

//<!-- Ultima mudança 13/07/2017.-->
(function () {
    'use strict';

    angular
        .module('app.geral.cadastro.equipamento', [
            'app.geral.cadastro.equipamento.equipamento',
            'app.geral.cadastro.equipamento.equipamentoFabricante',
            'app.geral.cadastro.equipamento.equipamentoTipo',
            'app.geral.cadastro.equipamento.fornecedor'
        ]);

})();
/**
 * Created by nova on 27/09/2016.
 */
(function () {
    'use strict';

    angular
        .module('app.trabalheconosco.processamento', [
                'app.trabalheconosco.processamento.curriculo'
        ]);
})();
(function () {
    'use strict';

    angular
        .module('app.trabalheconosco.cadastro', [
            'app.trabalheconosco.cadastro.categoria',
            'app.trabalheconosco.cadastro.habilidade',
            'app.trabalheconosco.cadastro.areaatuacao'
        ]);
})();
(function(){
    'use strict';

    angular
        .module('app.solicitacao.processamento', [
            'app.solicitacao.processamento.solicitacao'
        ]);

}());

(function(){
    'use strict';

    angular
        .module('app.solicitacao.consulta', [
            'app.solicitacao.consulta.solicitacao'
        ]);

}());
(function(){
    'use strict';

    angular
        .module('app.solicitacao.cadastro', [
            'app.solicitacao.cadastro.fase'
        ]);

}());
(function () {
    'use strict';

    angular
        .module('app.protecao.cadastro', [
            'app.protecao.cadastro.tipolicenca',
        ]);
})();
(function () {
    'use strict';

    angular
        .module('app.planejamentoScrum.cadastro', [
            'app.planejamentoScrum.cadastro.feriado',
            'app.planejamentoScrum.cadastro.motivo',
            'app.planejamentoScrum.cadastro.plataforma',
            'app.planejamentoScrum.cadastro.registroSituacao',
            'app.planejamentoScrum.cadastro.situacao',
            'app.planejamentoScrum.cadastro.tipo'
        ]);

})();

(function () {
    'use strict';

    angular
        .module('app.protecao.processamento', [
            'app.protecao.processamento.licenca',
            'app.protecao.processamento.gerenciamentoprotecao',
            'app.protecao.processamento.atualizacaolicenca',
            'app.protecao.processamento.atualizacaocliente'
        ]);
})();
/**
 * Created by nova on 27/09/2016.
 */
(function () {
  'use strict';

  angular
    .module('app.planejamentoScrum.processamento', [
      'app.planejamentoScrum.processamento.estoria',
      'app.planejamentoScrum.processamento.sprint',
      'app.planejamentoScrum.processamento.productBacklog',      
    ]);

})();

/**
 * Created by nova on 27/09/2016.
 */
(function () {
  'use strict';

  angular
    .module('app.planejamentoScrum.relatorio', [
    
    ]);

})();

(function () {
    'use strict';

    angular.module('app.planejamentoscrum.estatistica', [
        'app.planejamentoscrum.estatistica.estatisticaIndividual'
    ]);

})();

/**
 * Created by nova on 27/09/2016.
 */
(function () {
  'use strict';

  angular.module("app.planejamentoScrum.consulta", [
    "app.planejamentoScrum.consulta.controleVersao",
    "app.planejamentoScrum.consulta.estoria",
    "app.planejamentoscrum.consulta.estatisticas"
  ]);

})();

/**
 * Created by nova on 27/09/2016.
 */
(function () {
    'use strict';

    angular
        .module('app.pipeline.processamento', [
            'app.pipeline.processamento.pipelineNegocio',
            'app.pipeline.processamento.pipelineNegociosVencidosExecutivoResponsavel',
            'app.pipeline.processamento.pipelineNegociosGanhosPerdidos',
        ]);
})();

/**
 * Created by nova on 27/09/2016.
 */
(function () {
    'use strict';

    angular
        .module('app.pipeline.cadastro', [
            'app.pipeline.cadastro.pipeline-etapa',
            'app.pipeline.cadastro.pipeline-funil',
            'app.pipeline.cadastro.pipeline-motivo-perda-negocio'
        ]);
})();

/**
 * Created by nova on 27/09/2016.
 */
(function () {
    'use strict';

    angular
        .module('app.pipeline.relatorio', [
        ]);

})();

/**
 * Created by nova on 27/09/2016.
 */
(function () {
    'use strict';

    angular
        .module('app.pipeline.consulta', [
            'app.pipeline.consulta.estatistica',
            'app.pipeline.consulta.projecoes'
        ]);
})();

(function () {
    'use strict';

    angular
        .module('app.pesquisa.processamento', [
            'app.pesquisa.processamento.pesquisa'
        ]);

}());

(function () {
    'use strict';

    angular
        .module('app.pesquisa.cadastro', [
            'app.pesquisa.cadastro.tipo-pesquisa'
        ]);

}());
(function () {
  "use strict";

  angular.module("app.locacao.consulta", [
    "app.locacao.consulta.historico",
    "app.locacao.consulta.locacao",
    "app.locacao.consulta.controleEquipamento",
    "app.locacao.consulta.contratosAEncerrar"
  ]);
})();

(function () {
    "use strict";

    angular.module("app.locacao.processamento", [
        "app.locacao.processamento.locacao.envio.locacao_envio",
        "app.locacao.processamento.locacao.retorno.locacao_retorno",
        "app.locacao.processamento.nota",
        "app.locacao.processamento.retorno.baixa_equipamento",
        "app.locacao.processamento.revenda",
        "app.locacao.processamento.troca_ativo"
    ]);
})();


(function () {
    "use strict";

    angular.module("app.locacao.cadastro",[
        "app.locacao.cadastro.equipamentos",
        "app.locacao.cadastro.tipo_locacao",
        "app.locacao.cadastro.retorno_locacao",
        "app.locacao.cadastro.objetivo_nota",
        "app.locacao.cadastro.empresa_ativa"
    ]);
})();
(function () {
    'use strict';

    angular
        .module('app.implantacaoMigracao.processamento', [
            'app.implantacaoMigracao.processamento.processosFunis',
            'app.implantacaoMigracao.processamento.processosFinalizadosCancelados'
        ]);

})();

(function () {
    'use strict';

    angular
        .module('app.implantacaoMigracao.cadastro', [
            'app.implantacaoMigracao.cadastro.tarefa',
            'app.implantacaoMigracao.cadastro.processo',
            'app.implantacaoMigracao.cadastro.atividadeimplantacaomigracao'
        ]);

})();

(function () {
  'use strict';

  angular.module(
    "app.financeiro.relatorio", [
    "app.financeiro.relatorio.contratos",
    "app.financeiro.relatorio.reajustes",
    'app.financeiro.relatorio.risco-rescisao-contratual'
  ]);
})();

(function () {
    'use strict';

    angular
        .module('app.financeiro.consulta', [

        ]);

})();

(function () {
    'use strict';

    angular
        .module('app.financeiro.processamento', [
            'app.financeiro.processamento.contratos',
            'app.financeiro.processamento.enviodeemails'
        ]);
})();

(function () {
    'use strict';

    angular
        .module('app.financeiro.cadastro', [
            'app.financeiro.cadastro.contrato',
            'app.financeiro.cadastro.faturamento',
            'app.financeiro.cadastro.email'
        ]);
})();

(function () {
    'use strict';

    angular
        .module('app.custosoftware.relatorio', [

        ]);
})();

(function () {
    'use strict';

    angular
        .module('app.custosoftware.processamento', [
            'app.custosoftware.processamento.analise-custo'
        ]);
})();

(function () {
    'use strict';

    angular
        .module('app.custosoftware.consulta', [

        ]);
})();

(function () {
    'use strict';

    angular
        .module('app.custosoftware.cadastro', [
           'app.custosoftware.cadastro.historico-custo',
           'app.custosoftware.cadastro.custo'
        ]);
})();

/**
 * Created by nova on 27/09/2016.
 */
(function () {
    'use strict';

    angular
        .module('app.geral.relatorio', [
            'app.geral.relatorio.cliente',
            'app.geral.relatorio.controle-horas',
        ])

})();




/**
 * Created by nova on 27/09/2016.
 */
(function () {
  'use strict';

  angular
    .module('app.geral.processamento', [
        'app.geral.processamento.controle-horas-trabalhadas'    
    ]);

})();

(function () {
    'use strict';

    angular
        .module('app.geral.indicadores', [
            'app.geral.indicadores.gestaoiaguas',
        ]);

})();
/**
 * Created by nova on 27/09/2016.
 */
(function () {
    'use strict';

    angular
        .module('app.geral.consulta', [
            'app.geral.consulta.log'
        ]);        

})();

/**
 * Created by nova on 27/09/2016.
 */
(function () {
    'use strict';

    angular
        .module('app.geral.cadastro', [
            'app.geral.cadastro.cliente',
            'app.geral.cadastro.endereco',
            'app.geral.cadastro.usuario',
            'app.geral.cadastro.equipamento',
            'app.geral.cadastro.solucao',
            'app.geral.cadastro.segmentacao',
            'app.geral.cadastro.caracteristica'
        ]);
})();

(function () {
    'use strict';

    angular
        .module('app.geral.brainstorming', [
            'app.geral.brainstorming.brainstorming',
            'app.geral.brainstorming.visualizacaoIdeias'
        ]);

})();
/**
 * Created by nova on 27/09/2016.
 */
(function () {
    'use strict';

    angular
        .module('app.documentosTecnicos.manuaisInternos', [
            'app.documentosTecnicos.manuaisInternos.manualDesenvolvimento'
        ]);

})();

/**
 * Created by nova on 27/09/2016.
 */
(function () {
    'use strict';

    angular
        .module('app.atendimento.relatorio', [
            'app.atendimento.relatorio.atendimento'
        ]);

})();

(function () {
    'use strict';
    angular
        .module('app.atendimento.estatisticas', [
            'app.atendimento.estatisticas.tags'
        ]);
})();

/**
 * Created by nova on 27/09/2016.
 */
(function () {
    'use strict';

    angular
        .module('app.atendimento.consulta', [
            'app.atendimento.consulta.atendimento'
        ]);
})();

/**
 * Created by nova on 27/09/2016.
 */
(function () {
    'use strict';

    angular
        .module('app.atendimento.cadastro', [
            'app.atendimento.cadastro.conclusao',
            'app.atendimento.cadastro.motivoAtendimento',
            'app.atendimento.cadastro.pendencia',
            'app.atendimento.cadastro.configuracaoAtendimento',
            'app.atendimento.cadastro.tag'
        ]);
})();

/**
 * Created by nova on 27/09/2016.
 */
(function () {
    'use strict';

    angular
        .module('app.agenda.processamento', [
            'app.agenda.processamento.atividade',
            'app.agenda.processamento.visualizarAtividades']);
})();

/**
 * Created by nova on 27/09/2016.
 */
(function () {
    'use strict';

    angular
        .module('app.agenda.cadastro', [
            'app.agenda.cadastro.evento',
            'app.agenda.cadastro.parametros'
        ]);
})();

/**
 * Created by nova on 08/08/2018.
 */
(function () {
    'use strict';

    angular
        .module('app.trabalheconosco', [
            'app.trabalheconosco.cadastro',
            'app.trabalheconosco.processamento'
        ]);
})();
(function(){
    'use strict';

    angular
        .module('app.solicitacao', [
            'app.solicitacao.cadastro',
            'app.solicitacao.processamento',
            'app.solicitacao.consulta'
        ]);

}());
(function () {
    'use strict';

    angular
        .module('app.protecao', [
            'app.protecao.cadastro',
            'app.protecao.processamento'
        ]);
})();
/**
 * Created by nova on 27/09/2016.
 */
(function () {
    'use strict';

    angular
        .module('app.planejamentoScrum', [
            'app.planejamentoScrum.cadastro',
            'app.planejamentoScrum.consulta',
            'app.planejamentoScrum.processamento',
            'app.planejamentoScrum.relatorio',
            'app.planejamentoscrum.estatistica'
        ]);
})();

(function () {
  'use strict';

  angular
    .module('app.pipeline', [
      'app.pipeline.cadastro',
      'app.pipeline.consulta',
      'app.pipeline.processamento',
      'app.pipeline.relatorio'
    ]);

})();

(function () {
    'use strict';

    angular
        .module('app.manutencao', [
            'app.manutencao.consulta.ordem-servico',
            'app.manutencao.margem',
            'app.manutencao.origem-peca',
            'app.manutencao.entrada',
            'app.manutencao.tipo-servico',
            'app.manutencao.prioridade',
            'app.manutencao.tipo-procedimento',
            'app.manutencao.ordem-servico',
            'app.manutencao.tipo-envio',
            'app.manutencao.dashboard'
        ]);

})();

(function () {
    'use strict';

    angular
        .module('app.locacao', [
            'app.locacao.cadastro',
            "app.locacao.processamento",
            "app.locacao.consulta"
        ]);

})();

(function () {
    'use strict';

    angular
        .module('app.implantacaoMigracao', [
            'app.implantacaoMigracao.cadastro',
            'app.implantacaoMigracao.processamento'
        ]);

})();

/**
 * Created by nova on 27/09/2016.
 */
(function () {
    'use strict';

    angular
        .module(
            'app.financeiro',[
            'app.financeiro.cadastro',
            'app.financeiro.consulta',
            'app.financeiro.processamento',
            'app.financeiro.relatorio'
        ]);

})();

/**
 * Created by nova on 27/09/2016.
 */
(function () {
    'use strict';

    angular
        .module('app.custosoftware', [
            'app.custosoftware.cadastro',
            // 'app.custosoftware.consulta',
             'app.custosoftware.processamento',
            // 'app.custosoftware.relatorio'
        ]);

})();

/**
 * Created by nova on 27/09/2016.
 */
(function () {
    'use strict';

    angular
        .module('app.geral', [
            'app.geral.cadastro',
            'app.geral.consulta',
            'app.geral.processamento',
            'app.geral.relatorio',
            'app.geral.brainstorming',
            'app.geral.indicadores'
        ]);

})();

/**
 * Created by nova on 27/09/2016.
 */
(function(){
  'use strict';

  angular
    .module('app.erros', [
    'app.erros.error-404',
    'app.erros.manutencao'
  ])
    .config(Config);

  function Config() {
  }

})();

/**
 * Created by nova on 27/09/2016.
 */
(function () {
    'use strict';

    angular
        .module('app.documentosTecnicos', [
            'app.documentosTecnicos.manuaisInternos'
        ]);

})();

/**
 * Created by nova on 27/09/2016.
 */
(function () {
    'use strict';

    angular
        .module('app.atendimento', [
            'app.atendimento.cadastro',
            'app.atendimento.consulta',
            'app.atendimento.processamento',
            'app.atendimento.relatorio',
            'app.atendimento.estatisticas'
        ]);
})();

/**
 * Created by nova on 27/09/2016.
 */
(function () {
    'use strict';

    angular
        .module('app.agenda', [
            'app.agenda.cadastro',
            'app.agenda.processamento'            
        ]);
})();

/**
 * Created by nova on 02/08/2016.
 */
/**
 * Created by nova on 28/07/2016.
 */
(function () {
    'use strict';

    angular
        .module('app.compartilhado',
            [                
                'app.diretivas',
                'app.filtros'
            ]);

})();

angular.module("fuse").run(["$templateCache", function($templateCache) {$templateCache.put("app/core/layouts/content-only.html","<div id=\"layout-content-only\" class=\"template-layout\" layout=\"column\" flex><md-content id=\"content\" \nclass=\"animate-slide-up md-hue-2\" ui-view=\"content\" flex></md-content></div>");
$templateCache.put("app/core/layouts/content-with-toolbar.html","<div id=\"layout-content-with-toolbar\" class=\"template-layout\" layout=\"column\" flex><md-toolbar id=\"toolbar\" \nclass=\"md-menu-toolbar md-whiteframe-1dp\" ui-view=\"toolbar\"></md-toolbar><md-content id=\"content\" \nclass=\"animate-slide-up md-hue-2\" ui-view=\"content\" flex></md-content><md-sidenav id=\"quick-panel\" \nclass=\"md-sidenav-right md-whiteframe-4dp\" md-component-id=\"quick-panel\" ms-scroll ui-view=\"quickPanel\"></md-sidenav>\n</div>");
$templateCache.put("app/core/layouts/horizontal-navigation.html","<div id=\"layout-horizontal-navigation\" class=\"template-layout\" layout=\"column\" flex><div \nid=\"toolbar-navigation-container\" class=\"md-whiteframe-1dp\" layout=\"column\" layout-align=\"space-between start\">\n<md-toolbar id=\"toolbar\" class=\"md-menu-toolbar md-whiteframe-1dp\" ui-view=\"toolbar\"></md-toolbar><div \nid=\"horizontal-navigation\" ui-view=\"navigation\" layout=\"row\" layout-align=\"start end\" flex></div></div><div \nid=\"content-container\" flex layout=\"column\"><md-content id=\"content\" class=\"animate-slide-up md-hue-2\" ms-scroll \nui-view=\"content\" flex></md-content></div><md-sidenav id=\"quick-panel\" class=\"md-sidenav-right md-whiteframe-4dp\" \nmd-component-id=\"quick-panel\" ms-scroll ui-view=\"quickPanel\"></md-sidenav></div>");
$templateCache.put("app/core/layouts/vertical-navigation-fullwidth-toolbar-2.html","<div id=\"layout-vertical-navigation-fullwidth-toolbar-2\" class=\"template-layout\" layout=\"column\" flex><md-toolbar \nid=\"toolbar\" class=\"md-menu-toolbar md-whiteframe-1dp md-accent\" ui-view=\"toolbar\"></md-toolbar><div \nid=\"main-container\" layout=\"row\" flex><md-sidenav id=\"vertical-navigation\" class=\"md-primary-bg\" \nmd-is-locked-open=\"$mdMedia(\'gt-sm\')\" md-component-id=\"navigation\" ms-scroll ui-view=\"navigation\"></md-sidenav><div \nid=\"content-container\" flex layout=\"column\"><md-content id=\"content\" class=\"animate-slide-up md-hue-2\" ms-scroll \nui-view=\"content\" flex></md-content></div><md-sidenav id=\"quick-panel\" class=\"md-sidenav-right md-whiteframe-4dp\" \nmd-component-id=\"quick-panel\" ms-scroll ui-view=\"quickPanel\"></md-sidenav></div></div><md-button \nclass=\"md-fab md-fab-bottom-right scroll-fab\" scroll-class=\"scrolling\" \nscroll-container-tag=\"{{ scrollButtonContainerLocal }}\" aria-label=\"Voltar para o topo\" ng-if=\"utilizaBotaoScroll\">\n<md-tooltip md-direction=\"top\">Voltar para o topo</md-tooltip><md-icon md-font-icon=\"icon-chevron-up\"></md-icon>\n</md-button>");
$templateCache.put("app/core/layouts/vertical-navigation-fullwidth-toolbar.html","<div id=\"layout-vertical-navigation-fullwidth-toolbar\" class=\"template-layout\" layout=\"column\" flex><md-toolbar \nid=\"toolbar\" class=\"md-menu-toolbar md-whiteframe-1dp md-accent\" ui-view=\"toolbar\"></md-toolbar><div \nid=\"main-container\" layout=\"row\" flex><md-sidenav id=\"vertical-navigation\" class=\"md-primary-bg\" \nmd-is-locked-open=\"$mdMedia(\'gt-sm\')\" md-component-id=\"navigation\" ms-scroll ui-view=\"navigation\"></md-sidenav><div \nid=\"content-container\" flex layout=\"column\"><md-content id=\"content\" class=\"animate-slide-up md-hue-2\" ms-scroll \nui-view=\"content\" flex></md-content></div><md-sidenav id=\"quick-panel\" class=\"md-sidenav-right md-whiteframe-4dp\" \nmd-component-id=\"quick-panel\" ms-scroll ui-view=\"quickPanel\"></md-sidenav></div></div>");
$templateCache.put("app/core/layouts/vertical-navigation.html","<div id=\"layout-vertical-navigation\" class=\"template-layout\" layout=\"row\" flex><md-sidenav id=\"vertical-navigation\" \nclass=\"md-primary-bg\" md-is-locked-open=\"$mdMedia(\'gt-sm\')\" md-component-id=\"navigation\" ms-scroll \nui-view=\"navigation\"></md-sidenav><div id=\"content-container\" flex layout=\"column\"><md-toolbar id=\"toolbar\" \nclass=\"md-menu-toolbar md-whiteframe-1dp\" ui-view=\"toolbar\"></md-toolbar><md-content id=\"content\" \nclass=\"animate-slide-up md-hue-2\" ms-scroll ui-view=\"content\" flex></md-content></div><md-sidenav id=\"quick-panel\" \nclass=\"md-sidenav-right md-whiteframe-4dp\" md-component-id=\"quick-panel\" ms-scroll ui-view=\"quickPanel\"></md-sidenav>\n</div>");
$templateCache.put("app/core/theme-options/theme-options.html","<div class=\"ms-theme-options-button md-primary-bg\" ng-click=\"toggleOptionsSidenav()\"><md-icon md-font-icon=\"icon-cog\" \nclass=\"white-text\"></md-icon></div><md-sidenav md-component-id=\"fuse-theme-options\" class=\"md-sidenav-right\"><div \nclass=\"ms-theme-options-list\" layout=\"column\"><div class=\"theme-option layout-options\"><div class=\"option-title\">\nLayout Style:</div><md-radio-group layout=\"row\" layout-align=\"start start\" layout-wrap ng-model=\"vm.layoutStyle\" \nng-change=\"vm.updateLayoutStyle()\"><md-radio-button ng-repeat=\"layoutStyle in vm.layoutStyles\" \nng-value=\"layoutStyle.value\"><div layout=\"column\" layout-align=\"center center\"><img ng-src=\"{{layoutStyle.figure}}\"> \n<span class=\"text-center font-size-12 mt-8\">{{layoutStyle.label}}</span></div></md-radio-button></md-radio-group></div>\n<md-divider></md-divider><div class=\"theme-option\"><div class=\"option-title\">Layout Mode:</div><md-radio-group \nlayout=\"row\" layout-align=\"start center\" ng-model=\"vm.layoutMode\" ng-change=\"vm.updateLayoutMode()\"><md-radio-button \nng-repeat=\"layoutMode in vm.layoutModes\" ng-value=\"layoutMode.value\">{{layoutMode.label}}</md-radio-button>\n</md-radio-group></div><md-divider></md-divider><div class=\"theme-option color-palettes\"><div class=\"option-title\">\nColor Palette:</div><div layout=\"row\" layout-align=\"start start\" layout-wrap><md-button \nng-repeat=\"(themeName, theme) in vm.themes.list\" class=\"md-raised theme-button\" layout=\"row\" \nlayout-align=\"center center\" aria-label=\"{{themeName}}\" ng-click=\"vm.setActiveTheme(themeName)\" \nng-style=\"{\'background-color\': theme.primary.color,\'border-color\': theme.accent.color,\'color\': theme.primary.contrast1}\" \nng-class=\"{active: vm.getActiveTheme().name === themeName}\"><md-icon ng-style=\"{\'color\': theme.primary.contrast1}\" \nmd-font-icon=\"icon-palette\" class=\"icon s32\"></md-icon></md-button></div></div></div></md-sidenav>");
$templateCache.put("app/main/datamobil-ia/datamobil-ia.html","<div id=\"datamobil-ia\" class=\"page-layout simple tabbed\" layout=\"column\"><md-button \nclass=\"md-fab md-raised md-mini botao-menu\" aria-label=\"menu\" \nng-class=\"{\'botao-menu-centralizado\': vm.conversaIniciada}\" ng-click=\"vm.metodos.abrirFecharSidenav(\'filtro\')\"><md-icon\n style=\"color: rgba(0, 0, 0, 0.54)\" md-font-icon=\"icon-menu s24\"></md-icon></md-button><md-sidenav \nclass=\"sidenav lista-favoritos-sugestoes md-sidenav-right\" md-component-id=\"filtro\" md-whiteframe=\"4\" ms-scroll \nms-sidenav-helper md-disable-backdrop md-disable-close-events id=\"lista-favoritos-sugestoes\"><md-toolbar \nclass=\"toolbar-filtro\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"titulo\"><p class=\"m-0\" flex=\"100\" \nstyle=\"color: rgba(0, 0, 0, 0.87);\r\n              font-size: 2rem;\r\n              font-weight: 600\">Datamobil <span \nclass=\"texto-gradiente-ia\">IA</span></p></div><md-button class=\"md-icon-button\" \nng-click=\"vm.metodos.abrirFecharSidenav(\'filtro\')\" aria-label=\"Fechar sidenav\"><md-icon \nstyle=\"color: rgba(0, 0, 0, 0.54)\" md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar>\n<md-progress-linear style=\"width: 100%\" class=\"md-accent\" md-mode=\"indeterminate\" ng-show=\"vm.carregandoFavoritos\">\n</md-progress-linear><md-content class=\"content-filtro\" flex><div class=\"container-sugestoes\" ng-hide=\"true\"><a \nclass=\"btn-notion\" href=\"https://buttery-onion-c2e.notion.site/Generate-Mock-5f6151aacaf64b2fa04d3f749c7967cd?pvs=74\" \ntarget=\"_blank\" rel=\"noopener noreferrer\"><span>Abrir sugestões</span><md-icon \nstyle=\"color: rgba(0, 0, 0, 0.54); margin-right: 8px\" md-font-icon=\"icon-open-in-new s20\"></md-icon></a></div>\n<lista-favoritos on-comando-selecionado=\"vm.metodos.enviarComandoFavorito(comando)\" \ncarregando=\"vm.carregandoFavoritos\"></lista-favoritos></md-content></md-sidenav><div class=\"conteudo-principal\" \nng-class=\"{\'sidenav-aberta\': !vm.sidenavAberta, \'conversas-iniciadas\': vm.conversaIniciada}\"><div class=\"titulo\"><h1 \nstyle=\"font-size: 3.5rem;\r\n          font-weight: 500;\r\n          color: rgba(0, 0, 0, 0.87);\r\n          line-height: 1.4 !important;\r\n          letter-spacing: -0.1px !important\">\nDatamobil <span class=\"texto-gradiente-ia\">IA</span></h1></div><div class=\"subtitulo\" ng-if=\"!vm.conversaIniciada\">\nConsultas inteligentes em segundos, sem complicação.</div><div class=\"mensagens\" ng-if=\"vm.conversaIniciada\"><div \nclass=\"mensagem-item\" ng-repeat=\"msg in vm.mensagens\" \nng-class=\"{\'enviada\': msg.tipo === \'enviada\', \'recebida\': msg.tipo === \'recebida\'}\"><mensagem-envio \nng-if=\"msg.tipo === \'enviada\'\" mensagem=\"msg\"></mensagem-envio><mensagem-recebida \nng-style=\"msg.data && {\'width\': \'100%\'}\" ng-if=\"msg.tipo === \'recebida\'\" mensagem=\"msg\"></mensagem-recebida></div><div \nng-show=\"vm.emProgresso\" class=\"loader\"><md-icon style=\"color: rgba(0, 0, 0, 0.87)\" \nmd-svg-src=\"assets/custom/auto-awesome.svg\"></md-icon><span style=\"margin-left: 30px; margin-right: 4px\">IA está</span>\n<div class=\"words\"><div class=\"word-list\"><span class=\"word texto-gradiente\">pensando...</span> <span \nclass=\"word texto-gradiente\">buscando...</span> <span class=\"word texto-gradiente\">processando...</span> <span \nclass=\"word texto-gradiente\">executando...</span> <span class=\"word texto-gradiente final\" \nng-class=\"{\'anim-dots\': vm.emProgresso}\">gerando<span class=\"dots\"><i class=\"dot\">.</i><i class=\"dot\">.</i><i \nclass=\"dot\">.</i></span></span></div></div></div></div><div class=\"input-container\" layout=\"row\" \nlayout-align=\"center center\"><md-input-container md-no-float class=\"md-block\"><textarea ng-model=\"vm.comando\" \nplaceholder=\"Insira um comando...\" ng-keydown=\"vm.metodos.pressionandoTecla($event)\" rows=\"1\" caracteres-permitidos>\n</textarea></md-input-container><md-button class=\"md-fab md-raised md-mini md-accent\" \nng-click=\"vm.metodos.enviarMensagem(vm.comando)\"><md-icon md-font-icon=\"icon-arrow-right s24\"></md-icon></md-button>\n</div></div></div>");
$templateCache.put("app/main/login/login.html","<div id=\"login\" layout=\"row\" layout-align=\"start\"><div id=\"login-intro\" flex hide show-gt-sm><div class=\"logo-login\">\n<img ng-src=\"{{vm.configuracao.path_logo}}\"> <span class=\"titulo-aplicacao\">{{vm.configuracao.aplicacao}}</span></div>\n<div class=\"title-login\">{{ vm.configuracao.descricao_aplicacao}}</div></div><div id=\"login-form-wrapper\" \nclass=\"flex-scrollable md-whiteframe-8dp\" ms-scroll><div id=\"login-form\"><div class=\"logo-small\" hide-gt-sm><img \nng-src=\"{{vm.configuracao.path_logo_small}}\"><br><span class=\"titulo-aplicacao\">{{vm.configuracao.aplicacao}}</span>\n</div><div><div class=\"versaorelease\">Versão: <span>{{vm.versao}}</span> Release: <span>{{vm.release}}</span></div>\n</div><div class=\"title text-center\" translate=\"LOGIN.TEXTO_LOGIN\">Realize o login</div><div \nclass=\"description text-center\" translate=\"LOGIN.DESCRICAO_LOGIN\">Entre com o seu usuário e senha do sistema</div><form\n name=\"loginForm\" novalidate><md-input-container class=\"md-block\" md-no-float><md-icon md-font-icon=\"icon-account\">\n</md-icon><input type=\"text\" name=\"usuario\" ng-model=\"vm.form.usuario\" placeholder=\"Usuário\" translate=\"UTF\" \nmaxlength=\"20\" onkeydown=\"var a = this; setTimeout(function(){a.value = a.value.toUpperCase();}, 1)\" required><div \nng-messages=\"loginForm.usuario.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span \ntranslate=\"LOGIN.MSG_USUARIO\">Usuário deve ser informado</span></div></div></md-input-container><md-input-container \nclass=\"md-block\" md-no-float><md-icon md-font-icon=\"icon-lock-unlocked\"></md-icon><input type=\"password\" name=\"senha\" \nng-model=\"vm.form.senha\" placeholder=\"Senha\" mascara-tamanho-campo=\"32\" required md-maxlength=\"32\">\n</md-input-container><md-input-container class=\"md-block\" md-no-float><md-button type=\"submit\" \nclass=\"md-raised md-accent submit-button\" aria-label=\"ENTRAR\" translate=\"LOGIN.ENTRAR\" \ntranslate-attr-aria-label=\"LOGIN.ENTRAR\" ng-disabled=\"loginForm.$invalid || loginForm.$pristine\" \nng-click=\"vm.metodos.autenticarUsuario($event)\">ENTRAR</md-button></md-input-container><div layout=\"row\" \nlayout-align=\"center\"><md-progress-circular id=\"login-progress\" ng-if=\"vm.requisicaoSolicitada\" class=\"md-accent\" \nmd-mode=\"indeterminate\" md-diameter=\"50\"></md-progress-circular></div></form></div></div></div>");
$templateCache.put("app/core/directives/ms-info-bar/ms-info-bar.html","<div id=\"ms-info-bar\" layout=\"row\" layout-align=\"start center\" flex><div id=\"ms-info-bar-message\" ng-transclude flex>\n</div><md-button id=\"ms-info-bar-close\" class=\"md-icon-button\" aria-label=\"Close\" ng-click=\"removeInfoBar()\"><md-icon \nmd-font-icon=\"icon-close s24\"></md-icon></md-button></div>");
$templateCache.put("app/core/directives/ms-material-color-picker/ms-material-color-picker.html","<md-menu md-position-mode=\"target-right target\"><div ng-click=\"$mdOpenMenu($event)\"><ms-color-picker-button><md-button \naria-label=\"Row Color\" md-menu-origin ng-click=\"$mdOpenMenu($event)\" ng-class=\"vm.selectedColor.class\"><span \nng-show=\"vm.selectedColor.palette\">{{vm.selectedColor.palette}} {{vm.selectedColor.hue}} </span><span \nng-show=\"!vm.selectedColor.palette\">Select Color</span></md-button></ms-color-picker-button></div><md-menu-content \nclass=\"ms-material-color-picker-menu-content\" layout-column><header \nng-class=\"vm.selectedColor.class || \'md-accent-bg\'\" class=\"md-whiteframe-4dp\" layout=\"row\" \nlayout-align=\"space-between center\"><md-button md-prevent-menu-close ng-click=\"vm.activateHueSelection(false,false)\" \nclass=\"md-icon-button\" ng-class=\"{\'hidden\':!vm.selectedPalette}\" aria-label=\"Palette\"><md-icon \nmd-font-icon=\"icon-arrow-left\" class=\"s20\"></md-icon></md-button><span ng-if=\"vm.selectedColor.palette\">\n{{vm.selectedColor.palette}} {{vm.selectedColor.hue}} </span><span ng-if=\"!vm.selectedColor.palette\">Select Color\n</span><md-button class=\"remove-color-button md-icon-button\" ng-click=\"vm.removeColor()\" aria-label=\"Remove Color\">\n<md-icon md-font-icon=\"icon-delete\" class=\"s20\"></md-icon></md-button></header><div class=\"colors\" ms-scroll><div \nng-show=\"!vm.selectedPalette\" layout=\"row\" layout-wrap><div class=\"color\" ng-class=\"\'md-\'+palette+\'-500-bg\'\" \nng-repeat=\"(palette, hues) in vm.palettes\" ng-click=\"vm.activateHueSelection(palette,hues)\" layout=\"row\" \nlayout-align=\"start end\" md-prevent-menu-close md-ink-ripple><span class=\"label\">{{palette}}</span></div></div><div \nng-show=\"vm.selectedPalette\" layout=\"row\" layout-wrap><div class=\"color\" \nng-class=\"\'md-\'+vm.selectedPalette+\'-\'+hue+\'-bg\'\" ng-repeat=\"(hue, values) in vm.selectedHues\" \nng-click=\"vm.selectColor(vm.selectedPalette,hue)\" layout=\"row\" layout-align=\"start end\" md-ink-ripple><span \nclass=\"label\">{{hue}} </span><i ng-if=\"vm.selectedPalette == vm.selectedColor.palette && hue == vm.selectedColor.hue\" \nclass=\"s16 icon-check\"></i></div></div></div></md-menu-content></md-menu>");
$templateCache.put("app/core/directives/ms-search-bar/ms-search-bar.html","<div flex layout=\"row\" layout-align=\"start center\"><label for=\"ms-search-bar-input\"><md-button \nclass=\"ms-search-bar-expander md-icon-button\" aria-label=\"Expand Search Bar\" ng-click=\"MsSearchBar.expand()\" \nng-if=\"!MsSearchBar.resultsLoading || MsSearchBar.collapsed\"><md-icon md-font-icon=\"icon-magnify\" class=\"icon s24\">\n</md-icon></md-button><div class=\"ms-search-bar-loader\" layout=\"row\" layout-align=\"center center\" \nng-if=\"MsSearchBar.resultsLoading && !MsSearchBar.collapsed\"><md-progress-circular class=\"md-accent\" md-diameter=\"32\" \nmd-mode=\"indeterminate\"></md-progress-circular></div></label><input id=\"ms-search-bar-input\" type=\"text\" \nplaceholder=\"Pesquisar\" flex ng-model=\"MsSearchBar.query\" ng-model-options=\"MsSearchBar.queryOptions\" \nng-blur=\"MsSearchBar.collapse()\" ng-keydown=\"MsSearchBar.handleKeydown($event)\"><md-button \nclass=\"ms-search-bar-collapser md-icon-button\" ng-click=\"MsSearchBar.collapse()\" aria-label=\"Collapse Search Bar\">\n<md-icon md-font-icon=\"icon-close\" class=\"icon s24\"></md-icon></md-button><div class=\"ms-search-bar-results\" \nng-if=\"MsSearchBar.results\" ms-scroll><div class=\"no-results\" ng-if=\"MsSearchBar.results.length === 0\">No Results!\n</div><div class=\"result\" ng-repeat=\"result in MsSearchBar.results\" ng-click=\"MsSearchBar.handleResultClick(result)\" \nng-mouseenter=\"MsSearchBar.handleMouseenter($index)\" ng-mousedown=\"MsSearchBar.absorbEvent($event)\" \nng-class=\"{\'selected\': $index == MsSearchBar.selectedResultIndex}\" md-ink-ripple><div layout=\"row\" \nlayout-align=\"start center\"><div class=\"icon-container\" layout=\"row\" layout-align=\"center center\"><i \nng-if=\"result.icon\" class=\"icon {{result.icon}}\"></i><div ng-if=\"!result.icon\" class=\"square md-accent-bg\"></div></div>\n<div><div class=\"title\">{{result.title}}</div><div class=\"description\" ng-if=\"result.description\">\n{{result.description}}</div></div></div></div></div></div>");
$templateCache.put("app/core/directives/ms-shortcuts/ms-shortcuts.html","<div class=\"shortcuts-container\" layout=\"row\" layout-align=\"space-between center\" flex \nng-class=\"{\'mobile-bar-active\': MsShortcuts.mobileBarActive}\"><div class=\"flex-noshrink\" layout=\"row\" \nlayout-align=\"start center\" flex><div class=\"shortcuts hide show-gt-xs\" layout=\"row\" layout-align=\"start center\" \nms-scroll ng-if=\"MsShortcuts.shortcuts.length > 0\" ng-sortable=\"MsShortcuts.sortableOptions\"><div \nng-repeat=\"shortcut in MsShortcuts.shortcuts track by $index\" layout=\"row\" layout-align=\"center center\"><md-button \nclass=\"md-icon-button shortcut\" aria-label=\"{{shortcut.title}}\" ui-sref=\"{{shortcut.uisref}}\"><div \nclass=\"first-letter\">{{shortcut.title.charAt(0)}}</div><md-tooltip md-direction=\"bottom\">{{shortcut.title}}\n</md-tooltip></md-button></div></div><md-button class=\"md-icon-button toggle-mobile-menu hide-gt-xs\" \naria-label=\"Add shortcut\" ng-click=\"MsShortcuts.toggleMobileBar()\"><md-icon md-menu-origin md-font-icon=\"icon-star\" \nclass=\"icon amber-600-fg s24\" ng-hide=\"MsShortcuts.mobileBarActive\"></md-icon><md-icon md-menu-origin \nmd-font-icon=\"icon-close\" class=\"icon s24\" ng-hide=\"!MsShortcuts.mobileBarActive\"></md-icon></md-button><md-menu \nmd-offset=\"8 56\" class=\"shortcut-menu hide show-gt-xs\"><md-button class=\"md-icon-button add-shortcut-button\" \naria-label=\"Add shortcut\" ng-click=\"$mdMenu.open($event)\"><md-icon md-menu-origin md-font-icon=\"icon-star\" \nclass=\"icon amber-600-fg s24\"></md-icon><md-tooltip md-direction=\"bottom\">Clique para adicionar/remover atalhos\n</md-tooltip></md-button><md-menu-content><div id=\"ms-shortcut-add-menu\"><div class=\"shortcut-search\" layout=\"row\" \nlayout-align=\"start center\"><div class=\"search-icon\" layout=\"row\" layout-align=\"center center\" \nng-if=\"!MsShortcuts.resultsLoading\"><md-icon md-menu-align-target md-font-icon=\"icon-magnify\" class=\"icon s24\">\n</md-icon></div><div class=\"shortcut-loader\" layout=\"row\" layout-align=\"center center\" \nng-if=\"MsShortcuts.resultsLoading\"><md-progress-circular class=\"md-accent\" md-diameter=\"20\" md-mode=\"indeterminate\">\n</md-progress-circular></div><input type=\"text\" placeholder=\"Pesquisar\" flex ng-model=\"MsShortcuts.query\" \nng-model-options=\"MsShortcuts.queryOptions\" ng-keydown=\"MsShortcuts.handleKeydown($event)\"></div><div class=\"results\" \nng-if=\"MsShortcuts.results\" ms-scroll><div class=\"no-results\" ng-if=\"MsShortcuts.results.length === 0\">\nNenhum resultado encontrado!</div><div class=\"result\" ng-repeat=\"result in MsShortcuts.results\" \nng-click=\"MsShortcuts.handleResultClick(result)\" ng-mouseenter=\"MsShortcuts.handleMouseenter($index)\" \nng-mousedown=\"MsShortcuts.absorbEvent($event)\" ng-class=\"{\'selected\': $index == MsShortcuts.selectedResultIndex}\" \nmd-prevent-menu-close=\"md-prevent-menu-close\" md-ink-ripple><div layout=\"row\" layout-align=\"start space-between\"><div \nlayout=\"row\" layout-align=\"start center\" flex><div class=\"icon icon-container\" layout=\"row\" \nlayout-align=\"center center\"><i ng-if=\"result.icon\" class=\"{{result.icon}}\"></i><div ng-if=\"!result.icon\" \nclass=\"square md-accent-bg\"></div></div><div><div class=\"title\">{{result.title}}</div></div></div><md-icon \nmd-font-icon=\"icon-pin\" class=\"icon s18\" ng-class=\"{\'fade-text\': !result.hasShortcut}\"></md-icon></div></div></div>\n</div></md-menu-content></md-menu></div></div>");
$templateCache.put("app/compartilhado/diretivas/card-risco-perda-contratual/card-risco-perda-contratual.html","<div id=\"card-risco-perda-contratual\"><span><md-icon md-font-icon=\"icon-clipboard-text s16\" ng-if=\"exibirIcone\" \nstyle=\"color: white; margin-right: 3px\"></md-icon>Em monitoramento</span></div>");
$templateCache.put("app/compartilhado/diretivas/card-tags-atendimento/card-tags-atendimento.html","<div id=\"card-tags-atendimento\"><md-input-container class=\"md-block\"><label>{{vm.descricaoExibicao}}</label><md-select \nng-model=\"vm.model\" placeholder=\"{{vm.descricaoExibicao}}\" multiple=\"multiple\" name=\"tags\" \nng-change=\"vm.metodos.sincronizarModel()\" ng-disabled=\"vm.disabled\" ng-required=\"vm.required\" \nmd-on-open=\"vm.metodos.configuraMdSelectTags()\"><md-select-header ng-if=\"vm.data.length > 0\" \nstyle=\"height: 80px !important; max-height: 80px !important\"><div flex layout=\"column\" class=\"container-input-botao\" \nstyle=\"height: 70px !important; max-height: 70px !important\"><div class=\"input-pesquisa\" \nstyle=\"height: 35px !important; max-height: 35px !important\"><input id=\"card-tags-atendimento-md-select\" \nclass=\"md-text\" ng-model=\"vm.filtrarTags\" type=\"search\" placeholder=\"Pesquisar Tags\" \nstyle=\"width: 100%; padding: 8px; box-sizing: border-box; margin-top: 5px!important\"></div><div class=\"border-top\" \nstyle=\"height: 25px !important;\r\n                                    align-items: center !important; \r\n                                    justify-content: start !important; \r\n                                    padding: 3px 0px 0px 6px !important\" \nng-click=\"vm.metodos.abrirDialogCadastroTags()\"><div \nstyle=\"display: inline-flex;\r\n                                    align-items: center;\r\n                                    margin: 0 !important;\r\n                                    padding: 6px 8px !important;\r\n                                    border-radius: 2px;\r\n                                    background-color: rgb(0, 145, 234);\r\n                                    color: white !important;\r\n                                    text-transform: none !important\">\n<span>Inserir nova Tag</span> <span ng-if=\"vm.filtrarTags\" style=\"margin-left: 8px\">\"{{vm.filtrarTags}}\"</span></div>\n</div></div></md-select-header><md-option ng-value=\"item.codigo\" \nng-repeat=\"item in vm.data | filter:vm.filtrarTags track by item.codigo\">{{item.descricao}}</md-option></md-select><div\n ng-messages=\"vm.form.atendimento.tags.$error\"><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container><div class=\"chip-list\"><div \nclass=\"chip\" ng-repeat=\"codigo in vm.model track by codigo\" \nng-style=\"{\'background-color\': vm.metodos.retornaCodigoItemSelecionado(codigo).corBackground, \'color\': vm.metodos.retornaCodigoItemSelecionado(codigo).corTexto}\">\n<span>{{vm.metodos.retornaCodigoItemSelecionado(codigo).descricao}}</span><md-tooltip \nng-if=\"vm.metodos.retornaCodigoItemSelecionado(codigo).inativo\">Tag inativa</md-tooltip><md-icon ng-if=\"!vm.disabled\" \nng-click=\"vm.metodos.removerItem(codigo)\" md-font-icon=\"icon-close s18\"></md-icon></div></div></div>");
$templateCache.put("app/compartilhado/diretivas/card-documentacao-solicitacao/card-documentacao-solicitacao.html","<ms-widget flippable=\"false\" layout=\"row\" flex=\"100\"><ms-widget-front class=\"md-accent-bg\"><div \nclass=\"pl-16 pr-8 pv-16 h-55 white-fg\" layout=\"row\" layout-align=\"end start\"><button \nng-click=\"vm.metodos.visualizar()\" class=\"mr-25\"><i class=\"icon-open-in-new white-fg\"><md-tooltip><span>Visualizar\n</span></md-tooltip></i></button> <button ng-click=\"vm.metodos.editar()\" ng-if=\"!vm.esconderEdicao\"><i \nclass=\"icon-pencil white-fg\"><md-tooltip><span>Editar</span></md-tooltip></i></button></div><div \nclass=\"pt-8 pb-60 pr-8 pl-8\" layout=\"column\" layout-align=\"center center\"><div \nclass=\"white-fg font-size-36 line-height-36\"><label>{{vm.titulo}}</label></div></div></ms-widget-front></ms-widget>");
$templateCache.put("app/compartilhado/diretivas/carregamento-circular/carregamento-circular.html","<div id=\"carregamento-circular\" layout=\"column\" layout-align=\"center center\" class=\"pre-loader-full-width\" \nng-if=\"vm.emProgresso\" flex><md-content class=\"elementClass\"><div flex class=\"textoDiv\"><span ng-if=\"vm.titulo\">\n{{vm.titulo}}</span> <span ng-if=\"!vm.titulo\">Aguarde...</span></div><div layout=\"row\" layout-xs=\"column\" \nlayout-align=\"start center\" flex><div flex><md-progress-circular md-mode=\"indeterminate\" \nng-class=\"{\'md-circular-aguarde\':(!vm.mensagem || vm.mensagem === \' \')}\" class=\"md-accent\" md-diameter=\"60\">\n</md-progress-circular></div><div ng-if=\"vm.mensagem && vm.mensagem !== \' \'\" class=\"divAguarde\" flex=\"75\"><span \nstyle=\"white-space: pre-wrap\">{{vm.mensagem}}</span></div></div></md-content></div>");
$templateCache.put("app/compartilhado/diretivas/card-quantidade-licença/card-quantidade-licenca.html","<ms-widget flippable=\"true\" layout=\"row\" class=\"ms-widget ng-isolate-scope disable-select\" flex \nng-dblclick=\"vm.metodos.editar()\"><ms-widget-front class=\"white-bg ms-widget-front ng-scope\"><div \nclass=\"ph-8 pv-16 h-55 ng-scope layout-align-space-between-center layout-row\" layout=\"row\" flex \nlayout-align=\"space-between center\"><span class=\"titulo-card\">{{vm.titulo}}</span><i \nclass=\"icon-pencil s16 icone-cor-padrao ml-1\" ng-hide=\"vm.disableEditar\" ng-click=\"vm.metodos.editar()\" \nng-disabled=\"vm.controleForm.emProgresso\"><md-tooltip><label>Editar</label></md-tooltip></i></div><div \nclass=\"pt-8 pb-32 pl-32 pr-32 ng-scope layout-align-center-center layout-column\" layout=\"column\" flex \nlayout-align=\"center center\"><div class=\"light-blue-fg font-size-72 line-height-72 ng-binding\">{{vm.quantidade}}</div>\n</div><div class=\"p-16 pl-32 pr-32 grey-50-bg border-top ng-scope layout-align-start-center layout-column\" \nlayout=\"column\" layout-align=\"center start\"><div layout=\"row\" flex><div \nclass=\"h4 secondary-text text-truncate ng-binding\">Utilizadas: <span class=\"h4 ml-6 ng-binding badge-quantidade\">\n{{vm.quantidadeUtilizado}}</span></div></div><div layout=\"row\" flex><div \nclass=\"h4 secondary-text text-truncate ng-binding\">Disponíveis: <span class=\"h4 ml-6 ng-binding badge-quantidade\">\n{{vm.quantidadeDisponiveis}}</span></div></div></div></ms-widget-front></ms-widget>");
$templateCache.put("app/compartilhado/diretivas/group-button/group-button.html","<div id=\"group-button\" layout-gt-xs=\"row\" layout-align=\"end center\"><md-input-container><md-button \nclass=\"md-fab md-accent md-icon-button sample-show-hide\" \nng-click=\"vm.metodosControladores.habilitaEditar(vm.entidade)\" ng-disabled=\"vm.ngDisabled\" \nng-hide=\"vm.controladorAtivo\" aria-label=\"add contact\" translate translate-attr-aria-label=\"GROUP_BUTTON.EDICAO\">\n<md-icon md-font-icon=\"icon-pencil s30\"></md-icon></md-button></md-input-container><md-input-container><md-button \nclass=\"md-fab md-accent md-icon-button\" ng-click=\"vm.metodosButtons.salvar($event)\" \nng-disabled=\"vm.formulario.$pristine || vm.formulario.$invalid || vm.requisicaoSolicitada\" \nng-show=\"vm.controladorAtivo\" aria-label=\"add contact\" translate translate-attr-aria-label=\"GROUP_BUTTON.SALVAR\">\n<md-icon md-font-icon=\"icon-content-save s30\"></md-icon></md-button></md-input-container><md-input-container><md-button\n class=\"md-fab md-accent md-icon-button\" ng-click=\"vm.metodosControladores.cancelarEdicao()\" \nng-disabled=\"vm.requisicaoSolicitada\" ng-show=\"vm.controladorAtivo\" aria-label=\"add contact\" translate \ntranslate-attr-aria-label=\"GROUP_BUTTON.CANCELAR_EDICAO\"><md-icon md-font-icon=\"icon-replay s30\"></md-icon></md-button>\n</md-input-container><md-input-container ng-hide=\"vm.ngDisabledExcluir\"><md-button \nclass=\"md-fab md-accent md-icon-button\" ng-click=\"vm.metodosButtons.excluir($event)\" \nng-disabled=\"vm.requisicaoSolicitada\" ng-show=\"vm.controladorAtivo\" aria-label=\"add contact\" translate \ntranslate-attr-aria-label=\"GROUP_BUTTON.EXCLUIR\"><md-icon md-font-icon=\"icon-delete s30\"></md-icon></md-button>\n</md-input-container></div>");
$templateCache.put("app/compartilhado/diretivas/header-padrao/header-padrao.html","<div id=\"cabecalho-padrao\" class=\"page-layout simple tabbed\" layout=\"column\"><div class=\"header md-accent-bg\" \nlayout=\"row\" layout-align=\"space-between center\"><div class=\"white-fg\" layout=\"column\" layout-align=\"start start\" flex>\n<div class=\"h1\" layout=\"row\" layout-align=\"start center\"><i ng-if=\"vm.habilitarIconeVoltarAoEstadoAnterior\" \nclass=\"icon-arrow-left-bold s30\" ng-click=\"vm.navegarParaEstadoAnterior()\"><md-tooltip><span \nng-if=\"!vm.mensagemTooltipIconeEstadoAnterior\">Voltar para tela anterior </span><span \nng-if=\"vm.mensagemTooltipIconeEstadoAnterior\">{{vm.mensagemTooltipIconeEstadoAnterior}}</span></md-tooltip></i><md-icon\n md-font-icon=\"{{icone}}\"></md-icon><span translate=\"{{translateNome}}\"></span> <span \nng-show=\"vm.textoAuxiliarHabilitado\" ng-style=\"{\'margin-left\': \'10px\'}\">{{vm.textoAuxiliar}}</span></div></div><div \nclass=\"search\" layout=\"row\" layout-align=\"start start\" flex ng-if=\"vm.ngUtilizaPesquisa\"><label><md-icon \nmd-font-icon=\"icon-magnify\" class=\"white-text icon search-icon\"></md-icon></label><input id=\"pesquisar\" \nclass=\"search-input\" type=\"text\" placeholder=\"Pesquisar\" ng-disabled=\"!vm.liberarPesquisaQuandoDatatableAtivo\" \nng-model=\"vm.pesquisar\" ng-model-options=\"{debounce: 400}\" translate \ntranslate-attr-placeholder=\"CABECALHO_PADRAO.PESQUISAR\" flex></div></div></div>");
$templateCache.put("app/compartilhado/diretivas/group-button-horizontal/group-button-horizontal.html","<div id=\"group-button-horizontal\" class=\"espacamento-bottom\"><div layout=\"row\" ng-show=\"!vm.verificaEditarAtivo\">\n<md-button ng-click=\"vm.metodosGroupButtonHorizontal.salvar($event)\" class=\"send-button md-accent md-raised\" \naria-label=\"Salvar\" translate=\"GROUP_BUTTON_HORIZONTAL.SALVAR\" \ntranslate-attr-aria-label=\"GROUP_BUTTON_HORIZONTAL.SALVAR\" \nng-disabled=\"vm.formulario.$invalid || vm.formulario.$pristine || vm.requisicaSolicitada\"></md-button></div><div \nlayout=\"column\" ng-show=\"vm.verificaEditarAtivo\"><md-button ng-click=\"vm.metodosGroupButtonHorizontal.editar($event)\" \nclass=\"send-button md-accent md-raised\" aria-label=\"Salvar Edição\" translate=\"GROUP_BUTTON_HORIZONTAL.SALVAR_EDICAO\" \ntranslate-attr-aria-label=\"GROUP_BUTTON_HORIZONTAL.SALVAR_EDICAO\" \nng-disabled=\"vm.formulario.$invalid || vm.formulario.$pristine || vm.requisicaSolicitada\"></md-button><md-button \nng-click=\"vm.metodosGroupButtonHorizontal.cancelar()\" class=\"send-button md-accent md-raised\" \nng-disabled=\"vm.requisicaSolicitada\" aria-label=\"Cancelar Edição\" translate=\"GROUP_BUTTON_HORIZONTAL.CANCELAR\" \ntranslate-attr-aria-label=\"GROUP_BUTTON_HORIZONTAL.CANCELAR\"></md-button></div></div>");
$templateCache.put("app/compartilhado/diretivas/im-selecao-arquivos/im-selecao-arquivos.html","<div id=\"im-selecao-arquivos\" layout-padding class=\"md-background-bg md-whiteframe-1dp\"><div layout-gt-xs=\"row\" \nclass=\"md-background-bg md-whiteframe-1dp\"><div layout=\"row\" layout-align=\"start center\"><md-icon \nclass=\"selecao-cor-icone ml-10\" md-font-icon=\"icon-file\"></md-icon></div><div layout=\"row\" layout-align=\"start center\" \nflex class=\"selecao-arquivo-caption\">{{vm.caption}}</div><div layout=\"row\" layout-align=\"end center\"><md-button \nclass=\"md-accent md-raised button-excluir-margin\" im-file-mark-off ng-if=\"vm.arquivosSelecionados.length > 0\" \nng-click=\"vm.metodos.excluirTodosArquivosSelecionados($event)\" \nng-disabled=\"vm.controladorRequisicao.requisicaoSolicitada\" aria-label=\"Arquivo(s)\"><div layout=\"row\" \nlayout-align=\"center start\" flex><i class=\"icon-delete s30\"></i> <span class=\"title\">Excluir</span></div></md-button>\n<md-button class=\"md-accent md-raised button-arquivo-margin\" \nng-disabled=\"vm.controladorRequisicao.requisicaoSolicitada\" aria-label=\"Arquivo(s)\"><div layout=\"row\" \nlayout-align=\"center start\" flex><input class=\"input-selecao\" \nim-file-change=\"vm.metodos.selecionarArquivos($event, arquivos)\" type=\"file\" multiple=\"multiple\"> <i \nclass=\"icon-file s30\"></i> <span class=\"title\">Arquivo(s)</span></div></md-button><md-button \nclass=\"md-accent md-raised button-pasta-margin\" ng-disabled=\"vm.controladorRequisicao.requisicaoSolicitada\" \naria-label=\"Pasta\"><div layout=\"row\" layout-align=\"center start\" flex><input class=\"input-selecao\" \nim-file-change=\"vm.metodos.selecionarArquivos($event, arquivos)\" type=\"file\" webkitdirectory mozdirectory msdirectory \nodirectory directory multiple=\"multiple\"> <i class=\"icon-folder s32\"></i> <span \nclass=\"title button-pasta-texto-margin\">Pasta</span></div></md-button><md-button \nclass=\"md-accent md-raised button-enviar-margin\" ng-if=\"vm.imUtilizaButtonEnviar\" \nng-disabled=\"vm.arquivosSelecionados.length == 0 || vm.tamanhoMaximoArquivosSelecionadosExcedidos\r\n                       || vm.controladorRequisicao.requisicaoSolicitada || vm.imDesabilitarButomEnviar\" \nng-click=\"vm.metodos.enviarArquivos($event, vm.arquivosSelecionados)\" aria-label=\"Enviar\"><div layout=\"row\" \nlayout-align=\"center start\" flex><i class=\"icon-cloud-upload s30\"></i> <span class=\"title button-enviar-texto-margin\">\nEnviar</span></div></md-button></div></div><div layout-gt-xs=\"row\" \nng-if=\"vm.tamanhoMaximoArquivosSelecionadosExcedidos\"><div class=\"mensagem-erro-transicao\" \nng-show=\"vm.tamanhoMaximoArquivosSelecionadosExcedidos\" md-colors=\"{background: \'RED\'}\" flex><span \nstyle=\"margin-left: 10px\">O tamanho máximo de {{vm.imTamanhoMaximoArquivos}} foi excedido</span></div></div><div \nlayout-gt-xs=\"row\"><md-progress-linear class=\"md-accent\" md-mode=\"buffer\" \nvalue=\"{{vm.controladorRequisicao.progresso}}\" md-buffer-value=\"{{vm.controladorRequisicao.progresso}}\" \nng-disabled=\"!vm.controladorRequisicao.requisicaoSolicitada\"></div><div layout-gt-xs=\"row\" \nng-if=\"vm.imUtilizaTabela && (vm.habilitarTabela || vm.imHabilitarTabela)\"><table \nclass=\"dataTable row-border hover compact list-view\"><thead><tr><th \nclass=\"secondary-text borda-cima borda-esquerda borda-baixo\"><div class=\"table-header\"><span \nclass=\"column-title text-center\">Ação</span></div></th><th class=\"secondary-text borda-cima\"><div class=\"table-header\">\n<span class=\"column-title text-center\">Nome</span></div></th><th class=\"secondary-text borda-cima\"><div \nclass=\"table-header\"><span class=\"column-title text-center\">Tamanho</span></div></th><th \nclass=\"secondary-text borda-cima borda-baixo borda-direita\"><div class=\"table-header\"><span \nclass=\"column-title text-center\">Data Última Modificação</span></div></th></tr></thead><tbody><tr \nng-repeat=\"arquivo in vm.arquivosSelecionados | filter: vm.imPesquisarNaTabela\"><td class=\"borda-esquerda text-center\">\n<i class=\"icon-delete s20 icone-cor-padrao\" ng-if=\"vm.indexArquivoASerBaixado != $index\" \nng-click=\"vm.controladorRequisicao.requisicaoSolicitada || vm.metodos.excluirArquivoSelecionado($event, arquivo)\" \nng-disabled=\"vm.controladorRequisicao.requisicaoSolicitada\"></i></td><td class=\"text-center\">{{arquivo.name}}</td><td \nclass=\"text-center\">{{vm.metodos.retornarTextoExtensaoTamanhoArquivosSelecionados(arquivo.size)}}</td><td \nclass=\"text-center\">{{arquivo.lastModifiedDate | date:\'dd/MM/yyyy - HH:mm\'}}</td></tr></tbody></table></div></div>");
$templateCache.put("app/compartilhado/diretivas/ms-auto-complete-tabela/ms-auto-complete-tabela.html","<fieldset class=\"standard\" flex><legend class=\"grp-legend\" translate=\"{{vm.textoFildSet}}\"></legend><div \nlayout-gt-sm=\"row\" flex><div layout=\"column\" flex flex-gt-sm=\"30\"><div layout-gt-sm=\"row\"><md-input-container \nclass=\"md-block\" flex><md-autocomplete id=\"select\" md-input-name=\"segmentacoes\" md-no-cache=\"true\" \nng-blur=\"vm.metodos.configuraAutoCompleteOnBlur()\" md-selected-item=\"vm.item\" \nmd-selected-item-change=\"vm.metodos.alterarItemSelecionadoAutoComplete(item)\" \nmd-search-text=\"vm.textoDePesquisaAutoComplete\" \nmd-items=\"item in vm.metodos.pesquisarAutoComplete(vm.textoDePesquisaAutoComplete)\" \nmd-item-text=\"item.codigo + \' - \' + item.descricao\" md-autoselect md-delay=\"300\" \nmd-floating-label=\"{{vm.textoFloatingLabel}}\"><md-item-template><span \nmd-highlight-text=\"vm.textoDePesquisaAutoComplete\">{{item.codigo}} - {{item[vm.itemTemplate]}}</span>\n</md-item-template><md-not-found><label>{{vm.mensagemNaoEncontrado}}</label></md-not-found></md-autocomplete>\n</md-input-container></div><div layout-gt-sm=\"row\" ng-if=\"vm.labelCheck\"><md-input-container class=\"md-block ml-30\">\n<md-checkbox ng-model=\"vm.habilitarTodos\" ng-disabled=\"vm.filtros.length == 0 || vm.desabilitarCampos\" \nng-change=\"vm.metodos.ngChangehabilitarTodos()\" aria-label=\"todos\" name=\"todasSegmentacoes\"><span \nclass=\"float-label-cor-default\" translate=\"{{vm.labelCheck}}\"></span></md-checkbox></md-input-container></div><div \nlayout-gt-sm=\"row\" ng-if=\"vm.labelCheckLimpar\"><md-input-container class=\"md-block ml-30\" \nng-if=\"vm.habilitaCheckLimpar > 0\"><md-checkbox ng-model=\"vm.limparTodos\" \nng-disabled=\"vm.filtros.length == 0 || vm.desabilitarCampos\" ng-change=\"vm.metodos.limpaTodos()\" aria-label=\"todos\" \nname=\"todasSegmentacoes\"><span class=\"float-label-cor-default\" translate=\"{{vm.labelCheckLimpar}}\"></span>\n</md-checkbox></md-input-container></div><div layout-gt-sm=\"row\"><fieldset class=\"standard\" \nng-hide=\"vm.filtros.length == 0 || !vm.modelCampoAndOr\" flex><legend class=\"grp-legend\" \ntranslate=\"{{vm.nomeDoCampoFlagAndOr}}\"></legend><div layout=\"column\" flex><md-radio-group \nng-model=\"vm.modelCampoAndOr\"><md-radio-button value=\"{{key}}\" aria-label=\"{{value}}\" \nng-repeat=\"(key, value) in vm.seletores track by $index\">{{value}}</md-radio-button></md-radio-group></div></fieldset>\n</div></div><md-divider flex-offset=\"5\"></md-divider><div layout=\"column\" flex-offset=\"5\" flex><div \nclass=\"fullpage-datatable scrollable\" ms-scroll flex style=\"height:200px\"><table class=\"dataTable row-border hover\" \ndt-options=\"vm.dtOptions\" flex><thead><tr><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Código</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">{{vm.tituloTabela}}</span></div></th><th></th></tr></thead><tbody ng-repeat=\"item in vm.filtros\">\n<tr><td style=\"width:15%\"><span class=\"text-responsive\">{{item.codigo}}</span></td><td \nstyle=\"width:70%;text-align:left\"><span class=\"text-responsive\">{{item[vm.itemTemplate]}}</span></td><td \nclass=\"button-icone-cor-azul\" style=\"width:15%;text-align:right\"><i class=\"icon-delete s16 icone-cor-padrao\" \nng-click=\"vm.metodos.removerItem(item)\"><md-tooltip><label translate=\"{{vm.textoIconeRemover}}\"></label></md-tooltip>\n</i></td></tr></tbody></table></div></div></div></fieldset>");
$templateCache.put("app/compartilhado/diretivas/ms-auto-complete-colaborador/ms-auto-complete-colaborador.html","<md-autocomplete flex=\"33\" ng-required=\"true\" md-input-name=\"colaborador\" \nng-disabled=\"vm.requisicaoSolicitada || vm.desabilitarCampo\" md-no-cache=\"true\" \nng-blur=\"vm.metodos.configuraAutoCompleteUsuarioOnBlur()\" md-selected-item=\"vm.usuario\" \nmd-selected-item-change=\"vm.metodos.alterarItemSelecionadoAutoCompleteUsuario(item)\" \nmd-search-text=\"vm.textoDePesquisaAutoCompleteUsuario\" \nmd-items=\"item in vm.metodos.pesquisarAutoCompleteUsuario(vm.textoDePesquisaAutoCompleteUsuario)\" \nmd-item-text=\"item.codigo + \' - \' + item.nome\" md-autoselect md-floating-label=\"Colaborador\" md-min-length=\"0\">\n<md-item-template><span md-highlight-text=\"vm.textoDePesquisaAutoCompleteUsuario\">{{item.nome}}</span>\n</md-item-template><md-not-found><label>Não foi encontrado nenhum Colaborador.</label></md-not-found><div \nng-messages=\"vm.form.colaborador.$error\"><div ng-message=\"required\" translate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\">\n</div></div></md-autocomplete>");
$templateCache.put("app/compartilhado/diretivas/multi-select/multi-select.html","<div layout=\"row\" flex><md-input-container flex><label>{{textoPlaceholder}}</label><md-select ng-model=\"model\" \nng-change=\"vm.metodos.onChangeItem()\" md-on-close=\"clearSearchTerm()\" data-md-container-class=\"selectdemoSelectHeader\" \nng-disabled=\"disabled\" multiple=\"multiple\"><md-select-header class=\"demo-select-header\"><input ng-model=\"searchTerm\" \ntype=\"search\" placeholder=\"{{textoPesquisaPlaceholder}}\" class=\"demo-header-searchbox md-text\"></md-select-header>\n<md-optgroup label=\"item\"><md-option ng-value=\"item\" ng-repeat=\"item in data |\r\n              filter:searchTerm\">\n{{item[descricaoExibicao]}}</md-option></md-optgroup></md-select></md-input-container><md-input-container><md-checkbox \nstyle=\"margin-right: 10px\" ng-model=\"vm.todos\" ng-change=\"vm.metodos.limparSelecao()\" \naria-label=\"Checkbox Disabled Indeterminate\" ng-disabled=\"!model || model.length == 0\" class=\"md-primary\">Todos\n</md-checkbox></md-input-container></div>");
$templateCache.put("app/compartilhado/diretivas/ms-selecionar-multi-valores/ms-selecionar-multi-valores.html","<div id=\"ms-selecionar-multi-valores\"><fieldset ng-if=\"vm.temFieldSet\" class=\"standard\"><legend ng-if=\"vm.temFieldSet\" \nclass=\"grp-legend\" translate=\"{{vm.textoFieldSet}}\">{{vm.textoFieldSet}}</legend><div ng-if=\"vm.temFieldSet\" \nng-include src=\"vm.rotas\"></div></fieldset><div ng-if=\"!vm.temFieldSet\" ng-include src=\"vm.rotas\"></div></div>");
$templateCache.put("app/compartilhado/diretivas/pesquisar-por-identificador/pesquisar-por-identificador.html","<label translate=\"PESQUISAR_POR_CODIGO.CODIGO\"></label><input type=\"text\" ng-model=\"vm.codigo\" \nclass=\"pesquisar-por-codigo-borda-bottom-input\" placeholder=\"\" aria-label=\"Código\" ng-disabled=\"vm.ngDisabled\" \nng-model-options=\"{ debounce: 100 }\" translate translate-attr-aria-label=\"PESQUISAR_POR_CODIGO.CODIGO\" \nng-keydown=\"vm.pesquisar.onKeydown($event, vm.codigo)\" ng-blur=\"vm.pesquisar.onBlur(vm.codigo)\">");
$templateCache.put("app/compartilhado/diretivas/progress-linear/progress-linear.html","<md-progress-linear class=\"md-accent\" md-mode=\"{{vm.mdMode}}\" value=\"{{vm.progresso}}\" \nmd-buffer-value=\"{{vm.progresso}}\" ng-disabled=\"!vm.ngDisabled\">{{vm.emProgresso}}");
$templateCache.put("app/compartilhado/diretivas/pg-toolbar/pg-toolbar.html","<md-toolbar id=\"toolbar\" class=\"md-menu-toolbar md-whiteframe-1dp md-accent\"><div layout=\"row\" \nlayout-align=\"{{vm.tela.screen.width >= vm.larguraPadraoMobileTela ? vm.tipolayout : \'\'}}\"><div class=\"h1\" \nng-if=\"vm.tela.screen.width < vm.larguraPadraoMobileTela\" layout=\"row\" layout-align=\"start center\"><ng-include \nsrc=\"vm.htmlComponente.sidenav.botaoSidenav\"></ng-include></div><div class=\"h1\" \nng-if=\"(vm.tela.screen.width >= vm.larguraPadraoMobileTela) && !vm.esconderBotaoNovaPesquisa\" layout=\"row\" \nlayout-align=\"start center\"><ng-include src=\"vm.htmlComponente.botaoNovaPesquisa\"></ng-include></div><div class=\"h1\" \nlayout=\"row\" \nng-if=\"((vm.tela.screen.width >= vm.larguraPadraoMobileTela)\r\n             || (vm.tela.screen.width < vm.larguraPadraoMobileTela && !vm.controladorToolbar.pesquisaAtiva && !vm.controladorToolbar.editarAtivo && !vm.controladorToolbar.inserirAtivo))\r\n             && !vm.esconderBotaoPesquisar\" \nlayout-align=\"start center\"><ng-include src=\"vm.htmlComponente.botaoPesquisar\"></ng-include></div><div class=\"h1\" \nng-if=\"((vm.tela.screen.width >= vm.larguraPadraoMobileTela) \r\n                    || (vm.tela.screen.width < vm.larguraPadraoMobileTela && vm.controladorToolbar.editarAtivo || vm.controladorToolbar.inserirAtivo))\r\n                    && !vm.esconderBotaoSalvar\" \nlayout=\"row\" layout-align=\"start center\"><ng-include src=\"vm.htmlComponente.botaoSalvar\"></ng-include></div><div \nclass=\"h1\" \nng-if=\"((vm.tela.screen.width >= vm.larguraPadraoMobileTela)\r\n                    || (vm.tela.screen.width < vm.larguraPadraoMobileTela && vm.controladorToolbar.editarAtivo || vm.controladorToolbar.inserirAtivo))\r\n                    && !vm.esconderBotaoReverter\" \nlayout=\"row\" layout-align=\"start center\"><ng-include src=\"vm.htmlComponente.botaoReverter\"></ng-include></div><div \nclass=\"h1\" ng-if=\"(vm.tela.screen.width >= vm.larguraPadraoMobileTela) && !vm.esconderBotaoExcluir\" layout=\"row\" \nlayout-align=\"start center\"><ng-include src=\"vm.htmlComponente.botaoExcluir\"></ng-include></div><div class=\"h1\" \nng-if=\"(vm.tela.screen.width >= vm.larguraPadraoMobileTela) && !vm.esconderBotaoEditar\" layout=\"row\" \nlayout-align=\"start center\"><ng-include src=\"vm.htmlComponente.botaoEditar\"></ng-include></div><div class=\"h1\" \nng-if=\"(vm.tela.screen.width >= vm.larguraPadraoMobileTela) && !vm.esconderBotaoInserir\" layout=\"row\" \nlayout-align=\"start center\"><ng-include src=\"vm.htmlComponente.botaoInserir\"></ng-include></div><div class=\"h1\" \nng-if=\"(vm.tela.screen.width >= vm.larguraPadraoMobileTela) && vm.utilizaBotaoClonar\" layout=\"row\" \nlayout-align=\"start center\"><ng-include src=\"vm.htmlComponente.botaoClonar\"></ng-include></div><div class=\"h1\" \nng-if=\"(vm.tela.screen.width >= vm.larguraPadraoMobileTela) && !vm.esconderBotaoAtualizar\" layout=\"row\" \nlayout-align=\"start center\"><ng-include src=\"vm.htmlComponente.botaoAtualizar\"></ng-include></div><div \nclass=\"toolbar-separator\" ng-if=\"(vm.tela.screen.width >= vm.larguraPadraoMobileTela) && !vm.esconderMensagemStatus\">\n</div><div class=\"texto-primario\" layout=\"row\" layout-align=\"start center\" \nng-if=\"(vm.tela.screen.width >= vm.larguraPadraoMobileTela) && !vm.esconderMensagemStatus\"><span>{{vm.textoExibido}}\n</span></div><div class=\"toolbar-separator\" \nng-if=\"(vm.tela.screen.width >= vm.larguraPadraoMobileTela) && !vm.esconderMensagemStatus\"></div><div class=\"h1\" \nlayout=\"row\" layout-align=\"start center\" \nng-if=\"((vm.tela.screen.width >= vm.larguraPadraoMobileTela) \r\n                    || (vm.tela.screen.width < vm.larguraPadraoMobileTela && !vm.controladorToolbar.editarAtivo && !vm.controladorToolbar.inserirAtivo))\r\n                    && !vm.esconderBotaoPrimeira\">\n<ng-include src=\"vm.htmlComponente.navegacao.botaoPrimeira\"></ng-include></div><div class=\"h1\" layout=\"row\" \nlayout-align=\"start center\" \nng-if=\"((vm.tela.screen.width >= vm.larguraPadraoMobileTela)\r\n                    || (vm.tela.screen.width < vm.larguraPadraoMobileTela && !vm.controladorToolbar.editarAtivo && !vm.controladorToolbar.inserirAtivo))\r\n                    && !vm.esconderBotaoAnterior\">\n<ng-include src=\"vm.htmlComponente.navegacao.botaoAnterior\"></ng-include></div><div class=\"texto-secundario\" \nng-show=\"vm.entidadeDeEnvio.intTotalResultado && vm.entidadeDeEnvio.intTotalResultado > 0\" layout=\"row\" \nlayout-align=\"start center\" \nng-if=\"(vm.tela.screen.width >= vm.larguraPadraoMobileTela \r\n                    || (vm.tela.screen.width < vm.larguraPadraoMobileTela && !vm.controladorToolbar.editarAtivo && !vm.controladorToolbar.inserirAtivo)) \r\n                    && !vm.escoderTextoInformativoQuantidade\">\n<span>{{ vm.entidadeDeEnvio.intPosicao }} de {{(vm.entidadeDeEnvio.intTotalResultado)}}</span></div><div class=\"h1\" \nlayout=\"row\" layout-align=\"start center\" \nng-if=\"((vm.tela.screen.width >= vm.larguraPadraoMobileTela)\r\n                    || (vm.tela.screen.width < vm.larguraPadraoMobileTela && !vm.controladorToolbar.editarAtivo && !vm.controladorToolbar.inserirAtivo))\r\n                    && !vm.esconderBotaoProxima\">\n<ng-include src=\"vm.htmlComponente.navegacao.botaoProxima\"></ng-include></div><div class=\"h1\" layout=\"row\" \nlayout-align=\"start center\" \nng-if=\"((vm.tela.screen.width >= vm.larguraPadraoMobileTela) \r\n                    || (vm.tela.screen.width < vm.larguraPadraoMobileTela && !vm.controladorToolbar.editarAtivo && !vm.controladorToolbar.inserirAtivo))\r\n                    && !vm.esconderBotaoUltima\">\n<ng-include src=\"vm.htmlComponente.navegacao.botaoUltima\"></ng-include></div><div class=\"h1\" \nng-if=\"(vm.tela.screen.width >= vm.larguraPadraoMobileTela) && !vm.esconderBotaoListarTodasEntidades\" layout=\"row\" \nlayout-align=\"start center\"><ng-include src=\"vm.htmlComponente.listarTodasEntidades\"></ng-include></div></div>\n</md-toolbar><div id=\"pg-toolbar-sidenav\" ng-if=\"vm.tela.screen.width <= vm.larguraPadraoMobileTela\"><md-sidenav \nclass=\"md-sidenav-left md-whiteframe-4dp\" ms-scroll md-component-id=\"pg-toolbar-sidenav\" \nng-include=\"vm.htmlComponente.sidenav.sidenav\" ms-sidenav-helper></md-sidenav></div><md-progress-linear \nclass=\"md-accent\" md-mode=\"buffer\" value=\"{{vm.controladorPreLoader.progresso}}\" \nmd-buffer-value=\"{{vm.controladorPreLoader.progresso}}\" ng-disabled=\"!vm.controladorToolbar.emProgresso\">");
$templateCache.put("app/compartilhado/diretivas/proximo-codigo/proximo-codigo.html","<md-input-container class=\"md-block proximo-codigo\"><md-button class=\"md-icon-button\" \nng-click=\"vm.gerarProximoCodigo($event)\" aria-label=\"Proximo Código\" translate \ntranslate-attr-aria-label=\"MENSAGEM_PADRAO.PROXIMO_CODIGO\"><md-icon \nmd-font-icon=\"icon-arrow-right-bold-hexagon-outline s30\"></md-icon></md-button><md-tooltip><span \ntranslate=\"MENSAGEM_PROXIMO_CODIGO.PROXIMO_CODIGO\">Próximo Código</span></md-tooltip></md-input-container>");
$templateCache.put("app/main/cadastro-menu/views/cadastro-menu-form.html","<div class=\"md-background-bg md-whiteframe-1dp md-padding md-icon-tamanho-11 teste\"><fieldset><legend \nclass=\"grp-legend md-title\" translate=\"MENU.MENUS_IMANAGER\"></legend><treecontrol class=\"tree-light\" \ntree-model=\"vm.menu\" options=\"vm.opcoes\" on-selection=\"vm.showSelected(node, selected)\" \nexpanded-nodes=\"vm.menusExpandidos\">{{node.menuDetalhe.titulo}} ({{node.menuDetalhe.peso}}) <i \nclass=\"icon-pencil s18 icone-cor-padrao\" ng-if=\"node.navegacao != \'app\'\" ng-disabled=\"vm.requisicaoSolicitada\" \nng-click=\"vm.requisicaoSolicitada || vm.metodos.abrirDialogMenu(node, \'edicao\', $event)\"></i> <i \nclass=\"icon-plus s18 icone-cor-padrao\" ng-if=\"!node.menuDetalhe.estado\" ng-disabled=\"vm.requisicaoSolicitada\" \nng-click=\"vm.requisicaoSolicitada || vm.metodos.abrirDialogMenu(node, \'insercao\', $event)\"></i></treecontrol>\n</fieldset></div>");
$templateCache.put("app/main/cadastro-menu/views/cadastro-menu.html","<div id=\"cadastro-menu\" class=\"page-layout simple tabbed\" layout=\"column\"><header-padrao translate-nome=\"MENU.MENU\" \nicone=\"\" ng-utiliza-pesquisa=\"false\" liberar-pesquisa-quando-datatable-ativo=\"vm.controleForm.listarTodasEntidades\" \npesquisar=\"vm.pesquisar\"></header-padrao><div class=\"content\"><div ui-view=\"cadastro-menu-form\"></div></div></div>");
$templateCache.put("app/main/erros/error-404/error-404.html","<div id=\"error-404\" layout=\"column\" layout-align=\"center center\"><div class=\"content\" layout=\"column\" \nlayout-align=\"center center\"><div class=\"error-code\" translate=\"ERROR_404.STATUS\">404</div><div class=\"message\" \ntranslate=\"ERROR_404.MENSAGEM\"></div><a class=\"back-link md-accent-color\" ui-sref=\"app.inicio\" \ntranslate=\"ERROR_404.VOLTAR\"></a></div></div>");
$templateCache.put("app/main/erros/manutencao/manutencao.html","<div id=\"maintenance\" class=\"flex-scrollable\" layout=\"column\" ms-scroll><div id=\"maintenance-form-wrapper\" \nlayout=\"column\" layout-align=\"start center\"><div id=\"maintenance-form\" class=\"md-whiteframe-8dp\"><img \nclass=\"logo-image\" src=\"assets/images/logos/logo-inovacao.png\"><div class=\"title\" translate=\"MANUTENCAO.TITULO\"></div>\n<div class=\"subtitle\" translate=\"MANUTENCAO.SUBTITULO\"><br></div></div></div></div>");
$templateCache.put("app/main/controle-acesso-menu/views/controle-acesso-menu-form.html","<div class=\"md-background-bg md-whiteframe-1dp\" layout=\"row\" flex><md-sidenav class=\"sidenav md-sidenav-left\" \nmd-is-locked-open=\"$mdMedia(\'gt-md\')\" md-component-id=\"sinedav-esquerda-controle-acesso-menu\" \nng-include=\"vm.rotasHtml.sidenav_esquerda\" md-whiteframe=\"4\" ms-scroll ms-sidenav-helper></md-sidenav><md-content flex>\n<md-toolbar layout-padding id=\"controle-acesso-menu-toolbar\" \nclass=\"md-background-bg md-menu-toolbar md-whiteframe-1dp md-accent\"><div layout=\"row\" class=\"row-padding\">\n<md-input-container class=\"md-block\" flex=\"50\"><label translate=\"CONTROLE_ACESSO_MENU.PERFIL_A_ADMINISTRAR\">\nPerfil a administrar</label><md-select ng-model=\"vm.controleAcessoMenu.codigo\" \nng-change=\"vm.metodos.ngChangePerfil($event, vm.controleAcessoMenu.codigo)\" name=\"codigo\"><md-option \nng-value=\"perfil.codigo\" ng-repeat=\"perfil in vm.perfis track by perfil.codigo\">{{perfil.descricao}}</md-option>\n</md-select></md-input-container></div><div layout=\"row\" class=\"row-padding\"><md-input-container \nclass=\"md-block margin-content\"><md-button class=\"md-icon-button tamanho-icon-button button-icone-cor-azul\" \nng-click=\"vm.metodos.colapsarTodosMenus($event)\" aria-label=\"Salvar\"><md-icon \nmd-font-icon=\"icon-chevron-double-up s38\"></md-icon></md-button></md-input-container><md-input-container \nclass=\"md-block margin-content\"><md-button class=\"md-icon-button tamanho-icon-button button-icone-cor-azul\" \nng-click=\"vm.metodos.expandirTodosMenus($event)\" aria-label=\"Salvar\"><md-icon \nmd-font-icon=\"icon-chevron-double-down s38\"></md-icon></md-button></md-input-container><md-input-container \nclass=\"md-block margin-content\"><md-button class=\"md-icon-button tamanho-icon-button button-icone-cor-azul\" \nng-click=\"vm.metodos.marcarTodosMenus($event)\" aria-label=\"Salvar\"><md-icon md-font-icon=\"icon-clipboard-check s38\">\n</md-icon></md-button></md-input-container><md-input-container class=\"md-block margin-content\"><md-button \nclass=\"md-icon-button tamanho-icon-button button-icone-cor-azul\" ng-click=\"vm.metodos.desmarcarTodosMenus($event)\" \naria-label=\"Salvar\"><md-icon md-font-icon=\"icon-clipboard-outline s38\"></md-icon></md-button></md-input-container>\n</div></md-toolbar><div flex layout-padding><div layout=\"column\" layout-align=\"start center\" \nclass=\"carregamento-pre-loader\" ng-if=\"vm.controladorPreloaders.atualizandoMenus\" flex><md-progress-circular \nmd-mode=\"indeterminate\" class=\"mt-20 md-accent\" md-diameter=\"70\"></md-progress-circular></div><fieldset><legend \nclass=\"grp-legend md-title\" translate=\"CONTROLE_ACESSO_MENU.MENUS_IMANAGER\"></legend><treecontrol class=\"tree-light\" \ntree-model=\"vm.menusEmArvore\" options=\"vm.opcoesTree\" expanded-nodes=\"vm.menusExpandidos\"><md-checkbox \naria-label=\"Checkbox node\" ng-model=\"node.selecionado\" \ncontrole-acesso-menu-md-checkbox-click=\"vm.metodos.ngClickSelectMenu($event, node.selecionado, node)\" \nmenu-selecionado=\"node\" ng-checked=\"vm.metodos.verificaCheckBoxMarcado($event, node)\">\n{{node.menuDetalhe.titulo}} ({{node.menuDetalhe.peso}})</md-checkbox></treecontrol></fieldset></div></md-content></div>");
$templateCache.put("app/main/controle-acesso-menu/views/controle-acesso-menu.html","<div id=\"controle-acess-menu\" class=\"page-layout simple tabbed\" layout=\"column\"><header-padrao \ntranslate-nome=\"CONTROLE_ACESSO_MENU.CONTROLE_ACESSO_MENU\" icone=\"icon-menu\" ng-utiliza-pesquisa=\"false\" \npesquisar=\"vm.pesquisar\"></header-padrao><div class=\"content\"><div ui-view=\"controle-acesso-menu-form\"></div></div>\n</div>");
$templateCache.put("app/main/inicio/views/inicio.html","<div id=\"tela-inicial\" class=\"page-layout carded left-sidenav\" ng-if=\"vm.setores && vm.setores.length\" layout=\"row\">\n<md-sidenav class=\"sidenav\" md-is-locked-open=\"$mdMedia(\'gt-md\')\" md-component-id=\"sidenav\" ms-scroll \nms-sidenav-helper><md-content class=\"content\" style=\"background: #F5F5F5!important\" flex ms-scroll><div \nng-include=\"vm.rotasHtml.sidenav\"></div></md-content></md-sidenav><div class=\"center\" layout=\"column\" flex><div \nclass=\"content-card\" layout=\"column\" flex><div class=\"toolbar\" layout=\"row\" layout-align=\"start center\"><md-button \nclass=\"md-icon-button sidenav-toggle\" ng-click=\"vm.metodos.alteraSidenav(\'sidenav\')\" hide-gt-md \naria-label=\"Toggle left sidenav\"><md-icon md-font-icon=\"icon-menu\" class=\"icon\"></md-icon></md-button><p \nclass=\"texto-toolbar\">Setores</p></div><md-content class=\"content\" id=\"pagina-manual\" flex ms-scroll><div><div \nclass=\"demo-content\"><img src=\"assets\\images\\logos\\logo-inovacao.png\" class=\"md-card-image\" alt=\"sunrise\"><p><a \nhref=\"http://inovamobil.com.br/\" target=\"_blank\">www.inovamobil.com.br</a></p><h1>Setores</h1><div \nng-repeat=\"setor in vm.setores\"><h2 id=\"{{setor.descricao}}\" class=\"subtitulo\">{{setor.descricao}}</h2><h3 \nclass=\"subtitulo\" ng-if=\"setor.celular\">Whatsapp - {{setor.celular}}</h3><ul><li \nng-repeat=\"colaboradores in setor.colaboradores\"><span class=\"nomeColaborador\">{{colaboradores.nome}} </span><span \nng-if=\"colaboradores.ramal\">- Ramal: {{colaboradores.ramal}} </span><span ng-if=\"colaboradores.celular\">\n- Celular: {{colaboradores.celular}} </span><span ng-if=\"colaboradores.maquina\">- {{colaboradores.maquina}} </span>\n<span ng-if=\"colaboradores.email\">- {{colaboradores.email}}</span></li></ul></div></div></div></md-content></div></div>\n</div>");
$templateCache.put("app/main/mensageiro/views/mail.html","<div id=\"mail\" class=\"page-layout carded left-sidenav\" layout=\"row\"><div class=\"top-bg md-accent-bg\"></div><md-sidenav \nclass=\"sidenav\" md-is-locked-open=\"$mdMedia(\'gt-md\')\" md-component-id=\"main-sidenav\" \nng-include=\"\'app/main/mensageiro/sidenavs/main/main-sidenav.html\'\" ms-scroll ms-sidenav-helper></md-sidenav><div \nclass=\"center\" layout=\"column\" flex><div class=\"header\" layout=\"row\" layout-align=\"start center\"><div \nclass=\"search-wrapper md-whiteframe-4dp\" style=\"background:white\" layout=\"row\" layout-align=\"start center\" flex>\n<md-button class=\"md-icon-button sidenav-toggle\" ng-click=\"vm.toggleSidenav(\'main-sidenav\')\" hide-gt-md \naria-label=\"Toggle Sidenav\" translate translate-attr-aria-label=\"MAIL.TOGGLE_SIDENAV\"><md-icon class=\"icon\" \nmd-font-icon=\"icon-menu\"></md-icon></md-button><div class=\"search\" flex layout=\"row\" layout-align=\"start center\">\n<md-icon md-font-icon=\"icon-magnify\" class=\"icon s24\"></md-icon><input flex ng-model=\"vm.pesquisar\" \nng-keyup=\"vm.metodos.pesquisarMensagens($event)\" maxlength=\"55\" type=\"text\" placeholder=\"procurar...\" translate \ntranslate-attr-placeholder=\"MAIL.SEARCH_PLACEHOLDER\"></div></div></div><div class=\"content-card\" \nng-class=\"vm.currentView\" layout=\"column\" flex ng-include=\"vm.views[vm.currentView]\"></div></div></div>");
$templateCache.put("app/main/sql-consulta/views/sql-consulta.html","<div id=\"sql-consulta\" class=\"page-layout simple tabbed\" layout=\"column\" ms-scroll><header-padrao \ntranslate-nome=\"Execução SQL\" ng-utiliza-pesquisa=\"false\"></header-padrao><form name=\"vm.form.consultaSql\"><div \nlayout=\"row\" style=\"justify-content: center\"><fieldset class=\"standard\" flex style=\"max-width: 98%; margin-top: 20px\">\n<legend class=\"grp-legend\" translate=\"Comando SQL\"></legend><div layout-gt-sm=\"row\"><md-input-container \nclass=\"md-block\" style=\"margin: 18px 0px 0px 0px\" flex-gt-sm><label translate=\"Comando\"></label><textarea \nclass=\"text-uppercase campoQuery\" max-rows=\"5\" ng-model=\"vm.query\" ng-change=\"vm.metodos.verificaPontoEVirgula()\" \nmd-no-resize=\"true\" name=\"textoSql\">\r\n                </textarea><div ng-if=\"vm.pontoEvirgula\"><span \nstyle=\"font-size: small; color: red\">Não é permitido usar \' ; \'</span></div></md-input-container><div class=\"\">\n<md-button ng-disabled=\"vm.query.$invalid || vm.query == \'\' || vm.pontoEvirgula || vm.buscaDados\" \nclass=\"add-event-button md-fab md-toolbar botaoPlay\" style=\"width: 55px; height: 55px\" \nng-click=\"vm.metodos.fazerConsulta(vm.query)\" aria-label=\"Consultar\"><md-icon md-font-icon=\"icon-play\"></md-icon>\n<md-tooltip><label>Consultar</label></md-tooltip></md-button></div></div></fieldset></div><div layout=\"row\" \nclass=\"mb-10\" flex><div layout=\"row\" ng-show=\"vm.requisicaoProgress\" layout-align=\"center center\" flex><div \nlayout=\"column\" layout-align=\"center center\" class=\"mt-100\"><span class=\"font-weight-500\" style=\"font-size: 16px\">\n{{vm.mensagemPreloader}}</span><md-progress-circular md-mode=\"indeterminate\" md-diameter=\"100\" class=\"md-accent\">\n</md-progress-circular></div></div></div></form><div layout=\"row\" class=\"divRegistros\" ng-if=\"vm.resultado != null\">\n<div class=\"registros\"><p class=\"registros\">Registros: <span>{{ vm.resultado.registros.length }}</span></p></div><div \nclass=\"botaoPlanilha\"><md-button ng-disabled=\"vm.form.$invalid || vm.resultado == null\" \nclass=\"add-event-button md-fab md-toolbar botaoPlanilha\" style=\"width: 55px; height: 55px\" \nng-click=\"vm.metodos.abrirDialogPlanilha(vm.query)\" aria-label=\"Exportar\"><md-icon md-font-icon=\"icon-file-excel\">\n</md-icon><md-tooltip><label>Exportar planilha</label></md-tooltip></md-button></div></div><div layout=\"column\" \nclass=\"tabela\" ng-if=\"vm.resultado != null\"><table class=\"dataTable\" id=\"datatable-pendencia\"><thead><tr><th \nclass=\"secondary-text\" ng-repeat=\"item in vm.resultado.colunas;\"><div class=\"table-header\"><span \nclass=\"column-title text-center tabelaCabecalho\">{{ item.nome }}</span></div></th></tr></thead><tbody><tr \nng-repeat=\"item in vm.resultado.registros\"><td class=\"text-center\" ng-repeat=\"valor in item\">{{ valor.valor }}</td>\n</tr></tbody></table></div></div>");
$templateCache.put("app/main/solicitacao/dialogs/solicitacao-dialog-historico-solicitacao.html","<md-dialog class=\"dialogo-padrao\" id=\"dialog-historico-solicitacao\" aria-label=\"Dialog\"><form name=\"vm.form\" \nclass=\"md-inline-form\" novalidate><md-toolbar class=\"md-accent md-tall\" layout=\"column\"><div \nclass=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\">\n{{vm.titulo}}</span><md-button class=\"md-icon-button\" ng-click=\"vm.metodosDialog.fecharDialog()\" \naria-label=\"Fechar dialog\" translate translate-attr-aria-label=\"HISTORICO.FECHAR_DIALOG\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><div layout=\"row\" layout-sm=\"row\" \nlayout-align=\"center\" ng-show=\"vm.requisicaSolicitada || vm.preloader.habilitar\"><md-progress-circular \nmd-mode=\"indeterminate\" class=\"md-accent\"></md-progress-circular></div><md-dialog-content \nng-hide=\"vm.requisicaSolicitada || vm.preloader.habilitar\"><div layout=\"row\"><md-input-container class=\"md-block\" \nflex-gt-xs=\"25\" flex-xs=\"45\"><label translate=\"SOLICITACAO.NUMERO\"></label><input type=\"number\" \nng-model=\"vm.historicoSolicitacao.solicitacaoNumero\" name=\"numero\" ng-disabled=\"true\"></md-input-container>\n<md-input-container class=\"md-block\" flex-gt-xs=\"25\" flex-xs=\"45\"><label translate=\"SOLICITACAO.ANO\"></label><input \ntype=\"number\" name=\"ano\" ng-model=\"vm.historicoSolicitacao.solicitacaoAno\" ng-disabled=\"true\"></md-input-container>\n</div><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container class=\"md-block\" flex flex-gt-xs=\"50\"><label \ntranslate=\"HISTORICO.SOLICITACAO_FASE\"></label><md-select name=\"solicitacaoHistoricoSolicitacaoFaseCodigo\" \nmd-on-open=\"vm.metodosDialog.configuraMdSelectSolicitacaoFase()\" ng-model=\"vm.historicoSolicitacao.solicitacaoFase\" \nng-model-options=\"{trackBy: \'$value.codigo\'}\" ng-disabled=\"!vm.podeEditar\" ng-required=\"vm.novoHistoricoSolicitacao\">\n<md-select-header><input id=\"solicitacao-dialog-historico-solicitacao-fase-md-select\" class=\"md-text\" \nng-model=\"vm.filtrarSolicitacaoFases\" type=\"search\" placeholder=\"\" translate \ntranslate-attr-placeholder=\"HISTORICO.PESQUISAR_SOLICITACAO_FASE\" md-autofocus></md-select-header><md-option \nng-value=\"solicitacaoFase\" \nng-repeat=\"solicitacaoFase in vm.solicitacaoFases | filter:vm.filtrarSolicitacaoFases track by solicitacaoFase.codigo\">\n{{solicitacaoFase.descricao}}</md-option></md-select><div \nng-messages=\"vm.form.solicitacaoHistoricoSolicitacaoFaseCodigo.$error\"><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container><md-input-container \nid=\"solicitacao-dialog-historico-solicitacao-data-abertura\"><label translate=\"HISTORICO.DATA\"></label><md-datepicker \nflex-offset-gt-xs=\"5\" ng-model=\"vm.historicoSolicitacao.data\" name=\"dialogHistoricoSolicitacaoData\" \nmascara-conversor-string-para-data ng-mask=\"3?9/1?9/9999\" ng-disabled=\"!vm.podeEditar\" md-max-date=\"vm.dataMaxima\" \nng-required=\"true\"></md-datepicker><div ng-messages=\"vm.form.dialogHistoricoSolicitacaoData.$error\"><div \nng-message=\"valid\" translate=\"MENSAGEM_VALIDACAO.DATA_INVALIDA\"></div><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.DATA_OBRIGATORIA\"></div><div ng-message=\"maxdate\" \ntranslate=\"MENSAGEM_VALIDACAO.DATA_MAIOR_QUE_ATUAL\"></div></div></md-input-container></div><div layout=\"row\">\n<md-input-container ng-if=\"vm.historicoSolicitacao.solicitacaoFase.exige_Motivo\" class=\"md-block\" flex \nflex-gt-xs=\"100\"><label translate=\"HISTORICO.MOTIVO\"></label><input type=\"text\" name=\"solicitacaoHistoricoMotivoFase\" \nng-model=\"vm.historicoSolicitacao.motivoFase\" mascara-tamanho-campo=\"100\" md-maxlength=\"100\" ng-minlength=\"3\" \nng-disabled=\"!vm.podeEditar\" ng-required=\"vm.historicoSolicitacao.solicitacaoFase.exige_Motivo\"><div \nng-messages=\"vm.form.solicitacaoHistoricoMotivoFase.$error\"><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container></div></md-dialog-content>\n<md-dialog-actions layout=\"row\" ng-if=\"vm.podeEditar\" layout-align=\"space-between center\"><div layout=\"row\" \nlayout-align=\"start center\"><md-button type=\"submit\" \nng-click=\"vm.metodosDialog.salvar($event, vm.historicoSolicitacao)\" class=\"send-button md-accent md-raised\" \nng-disabled=\"vm.form.$invalid || vm.form.$pristine || vm.requisicaSolicitada\" aria-label=\"Salvar\" \ntranslate=\"HISTORICO.SALVAR\" translate-attr-aria-label=\"HISTORICO.SALVAR\">Salvar<md-tooltip md-autohide><span \ntranslate=\"HISTORICO.SALVAR\"></span></md-tooltip></md-button></div><div layout=\"row\"><md-button class=\"md-icon-button\" \nng-click=\"vm.metodosDialog.excluir(vm.historicoSolicitacao, $event)\" aria-label=\"Excluir\" \nng-hide=\"vm.novoHistoricoSolicitacao\" ng-disabled=\"vm.requisicaSolicitada\" translate \ntranslate-attr-aria-label=\"HISTORICO.EXCLUIR\"><md-icon md-font-icon=\"icon-delete\"></md-icon><md-tooltip md-autohide>\n<span translate=\"HISTORICO.EXCLUIR_HISTORICO_SOLICITACAO\"></span></md-tooltip></md-button></div></md-dialog-actions>\n</form></md-dialog>");
$templateCache.put("app/navigation/layouts/vertical-navigation-fullwidth-toolbar-2/navigation.html","<ms-navigation class=\"scrollable\" folded=\"vm.folded\" ms-scroll=\"vm.msScrollOptions\"></ms-navigation>");
$templateCache.put("app/toolbar/dialogs/dialog-senha-implantacao/dialog-senha-implantacao.html","<md-dialog id=\"dialog-senha-implantacao\" class=\"dialogo-padrao\" aria-label=\"Dialog\"><md-toolbar \nclass=\"md-accent md-tall\" layout=\"column\"><div class=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" \nlayout-align=\"space-between center\"><span class=\"title\" translate=\"TOOLBAR.TITULO_SENHA_IMPLANTACAO\"></span><md-button \nclass=\"md-icon-button\" ng-click=\"vm.metodos.fecharDialog()\" aria-label=\"Fechar dialog\" translate \ntranslate-attr-aria-label=\"TOOLBAR.FECHAR_DIALOG\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content ms-scroll><div class=\"ms-card-content-wrapper white-bg\"><div class=\"pt-8 pb-32\" \nlayout=\"column\" layout-align=\"center center\"><div \nclass=\"h3 secondary-text font-size-30 line-height-72 font-weight-500\">Senha</div><div layout=\"row\" \nlayout-align=\"center center\"><div class=\"light-blue-fg font-size-40 line-height-72\">{{ vm.senhaImplantacao }}</div>\n<md-button class=\"md-icon-button\" ng-click=\"vm.metodos.copiarParaClipboard()\"><md-tooltip md-direction=\"bottom\">\nCopiar senha</md-tooltip><md-icon class=\"icon\" md-font-icon=\"{{ vm.iconeCopiar }}\"></md-icon></md-button></div></div>\n<div class=\"p-16 grey-50-bg\" layout=\"row\" layout-align=\"center center\"><span class=\"h4 secondary-text text-truncate\">\nValido até:</span> <span class=\"h4 ml-8\">{{ vm.dataAtual | date:\'dd/MM/yyyy\' }}</span></div></div></md-dialog-content>\n</md-dialog>");
$templateCache.put("app/toolbar/dialogs/dialog-alteracao-senha/dialog-alteracao-senha-toolbar.html","<md-dialog id=\"dialog-alteracao-senha\" class=\"dialogo-padrao dialog-senha\" aria-label=\"Dialog\"><form \nname=\"alteracaoSenhaForm\" class=\"md-inline-form\" novalidate><md-toolbar class=\"md-accent md-tall\" layout=\"column\"><div \nclass=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\" \ntranslate=\"TOOLBAR.TITULO_ALTERACAO_SENHA\"></span><md-button class=\"md-icon-button\" \nng-click=\"vm.metodos.fecharDialog()\" aria-label=\"Fechar dialog\" translate \ntranslate-attr-aria-label=\"TOOLBAR.FECHAR_DIALOG\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content ms-scroll><div class=\"senhas\" layout-gt-xs=\"row\" flex><div flex></div><div \nclass=\"camposenha\" flex><div layout-gt-xs=\"row\" layout-align=\"center center\"><md-input-container class=\"md-block\">\n<label translate=\"TOOLBAR.SENHA_ATUAL\"></label><input type=\"password\" ng-model=\"vm.senhaAtual\" \nmascara-tamanho-campo=\"32\" ng-required=\"true\" ng-disabled=\"vm.emProgresso\" md-maxlength=\"32\"></md-input-container>\n</div><div layout-gt-xs=\"row\" layout-align=\"center center\"><md-input-container class=\"md-block\"><label \ntranslate=\"TOOLBAR.NOVA_SENHA\"></label><input type=\"password\" ng-model=\"vm.senhaNova\" mascara-tamanho-campo=\"32\" \nng-required=\"true\" ng-disabled=\"vm.emProgresso\" md-maxlength=\"32\"></md-input-container></div><div layout-gt-xs=\"row\" \nlayout-align=\"center center\"><md-input-container class=\"md-block\"><label translate=\"TOOLBAR.CONFIRMACA_SENHA\"></label>\n<input type=\"password\" ng-model=\"vm.confirmacaoSenhaNova\" name=\"confirmacaoSenhaNova\" ng-disabled=\"vm.emProgresso\" \nmascara-tamanho-campo=\"32\" ng-required=\"true\" md-maxlength=\"32\"></md-input-container></div><div layout=\"row\" \nlayout-align=\"center center\" class=\"erroSenha\" style=\"color: red\" ng-if=\"(vm.senhaNova != vm.confirmacaoSenhaNova)\">\nAs senhas devem ser iguais.</div></div><div flex class=\"botao\"><md-button \nclass=\"md-fab md-mini md-accent md-icon-button sample-show-hide\" ng-click=\"vm.metodos.abrirInformacao()\"><md-icon \nmd-font-icon=\"icon-information-outline\"></md-icon><md-tooltip md-autohide><span translate=\"Informações\"></span>\n</md-tooltip></md-button><md-card ng-if=\"vm.abrirInfo\" class=\"regras\"><md-card-content class=\"texto\" flex><p>\nSenha deve ter no mínimo 8 caracteres</p><p>Senha deve conter ao menos 1 número</p><p>\nSenha deve conter ao menos 1 letra maiúscula</p><p>Senha deve conter ao menos 1 letra minuscula</p><p>\nSenha deve conter ao menos 1 caractere especial</p></md-card-content></md-card></div></div><div layout-gt-xs=\"row\" \nlayout-align=\"center center\"><md-progress-circular id=\"toolbar-progress\" ng-if=\"vm.emProgresso\" class=\"md-accent\" \nmd-mode=\"indeterminate\" md-diameter=\"32\"></md-progress-circular><md-button class=\"md-raised md-accent\" \nng-if=\"!vm.emProgresso\" \nng-click=\"vm.metodos.alterarSenha($event, vm.senhaAtual, vm.senhaNova, vm.confirmacaoSenhaNova);\" \nng-disabled=\"alteracaoSenhaForm.$invalid || (vm.senhaNova != vm.confirmacaoSenhaNova)\" flex><span>Salvar</span>\n</md-button></div></md-dialog-content></form></md-dialog>");
$templateCache.put("app/toolbar/layouts/vertical-navigation-fullwidth-toolbar-2/toolbar.html","<div layout=\"row\" layout-align=\"start center\"><div layout=\"row\" layout-align=\"start center\"><div layout=\"row\" flex><div\n flex hide-xs class=\"logo\" layout=\"row\" layout-align=\"center center\"><img class=\"logo-image\" \nsrc=\"assets/images/logos/logo-inovacao.png\"></div><div hide-xs class=\"toolbar-separator\"></div><md-button \nid=\"navigation-toggle\" class=\"md-icon-button\" ng-click=\"vm.toggleSidenav(\'navigation\')\" hide-gt-sm \naria-label=\"Toggle navigation\" translate translate-attr-aria-label=\"TOOLBAR.TOGGLE_NAVIGATION\"><md-icon \nmd-font-icon=\"icon-menu\" class=\"icon\"></md-icon></md-button><md-button class=\"md-icon-button navigation-fold-toggle\" \nhide show-gt-sm aria-label=\"Toggle navigation fold\" translate \ntranslate-attr-aria-label=\"TOOLBAR.TOGGLE_NAVIGATION_FOLD\" ng-click=\"vm.toggleMsNavigationFolded()\"><md-icon \nclass=\"s18\" md-font-icon=\"icon-backburger\"></md-icon></md-button></div><div layout=\"row\"><ms-shortcuts></ms-shortcuts>\n<div class=\"toolbar-separator\"></div></div></div><div flex layout-align=\"center center\" layout=\"row\">\n<md-progress-circular id=\"toolbar-progress\" ng-if=\"$root.loadingProgress\" class=\"md-accent\" md-mode=\"indeterminate\" \nmd-diameter=\"32\"></md-progress-circular></div><div hide show-gt-sm id=\"datahora\" layout=\"row\"><span>Data/Hora:</span>\n<div>{{vm.horaAtual}}</div></div><div class=\"toolbar-separator\"></div><div hide show-gt-sm id=\"versaorelease\" \nlayout-wrap><div>Versão: <span class=\"Borda\">{{vm.versao}}</span> Release: <span class=\"Borda\">{{vm.release}}</span>\n</div></div><div class=\"toolbar-separator\"></div><div layout=\"row\" layout-align=\"start center\"><md-menu-bar \nid=\"squad-menu\" ng-if=\"vm.squadsUsuarioLogado.length > 1\"><md-menu><md-button class=\"squad-button\" \naria-label=\"Squad settings\" ng-click=\"$mdMenu.open($event)\"><div layout=\"row\" layout-align=\"space-between center\"><img \nng-src=\"assets/icons/invm/{{vm.iconeAtual}}\" alt=\"Ícone do Squad\"></div></md-button><md-menu-content width=\"3\">\n<md-menu-item class=\"md-indent\" ng-repeat=\"squad in vm.squads\"><md-icon><img \nng-src=\"assets/icons/invm/{{squad.icone}}\" alt=\"{{squad.descricao}} Icon\" class=\"menu-icon\"></md-icon><md-button \nng-click=\"vm.selecionarSquad(squad.codigo)\">{{squad.descricao}}</md-button></md-menu-item></md-menu-content></md-menu>\n</md-menu-bar><div class=\"toolbar-separator\"></div><md-menu-bar id=\"user-menu\"><md-menu md-position-mode=\"left bottom\">\n<md-button class=\"user-button\" ng-click=\"$mdMenu.open($event)\" aria-label=\"User settings\" translate \ntranslate-attr-aria-label=\"TOOLBAR.USER_SETTINGS\"><div layout=\"row\" layout-align=\"space-between center\"><span \nclass=\"username\" hide-sm>{{vm.usuario.login}}</span><md-icon md-font-icon=\"icon-chevron-down\" class=\"icon s16\" hide-sm>\n</md-icon></div></md-button><md-menu-content width=\"3\"><md-menu-item class=\"md-indent\"><md-icon \nmd-font-icon=\"icon-security\" class=\"icon\"></md-icon><md-button ng-click=\"vm.abrirDialogAlteracaoSenha($event)\">\nAlterar Senha</md-button></md-menu-item><md-menu-item class=\"md-indent\"><md-icon md-font-icon=\"icon-logout\" \nclass=\"icon\"></md-icon><md-button ng-click=\"vm.logout()\">Sair</md-button></md-menu-item></md-menu-content></md-menu>\n</md-menu-bar><div class=\"toolbar-separator\"></div><md-button class=\"md-icon-button\" \nng-click=\"vm.abrirDialogSenhaImplantacao()\" ng-disabled=\"$root.loadingProgress\"><md-tooltip md-direction=\"bottom\">\nGerar senha de implantação</md-tooltip><md-icon class=\"icon\" style=\"color: #279FDA\" md-font-icon=\"icon-lock-unlocked\">\n</md-icon></md-button><div class=\"toolbar-separator\"></div><ms-search-bar on-search=\"vm.search(query)\" \non-result-click=\"vm.searchResultClick(item)\" debounce=\"300\"></ms-search-bar></div></div>");
$templateCache.put("app/core/directives/ms-navigation/templates/horizontal.html","<div class=\"navigation-toggle\" hide-gt-sm><md-button class=\"md-icon-button\" ng-click=\"vm.toggleHorizontalMobileMenu()\" \naria-label=\"Toggle Mobile Navigation\"><md-icon md-font-icon=\"icon-menu\"></md-icon></md-button></div><ul \nclass=\"horizontal\"><li ng-repeat=\"node in vm.navigation\" ms-navigation-horizontal-node=\"node\" \nng-class=\"{\'has-children\': vm.hasChildren}\" ng-include=\"\'navigation-horizontal-nested.html\'\"></li></ul><script \ntype=\"text/ng-template\" id=\"navigation-horizontal-nested.html\">\n<div ms-navigation-horizontal-item layout=\"row\" ng-if=\"!vm.isHidden()\">\r\n\r\n        <div class=\"ms-navigation-horizontal-button\" ng-if=\"!node.uisref && node.title\"\r\n             ng-class=\"{\'active md-accent-bg md-accent-fg\': vm.isActive}\">\r\n            <i class=\"icon s18 {{node.icon}}\" ng-if=\"node.icon\"></i>\r\n            <span class=\"title\" translate=\"{{node.translate}}\" flex>{{node.title}}</span>\r\n            <span class=\"badge white-fg\" style=\"background: {{node.badge.color}}\" ng-if=\"node.badge\">{{node.badge.content}}</span>\r\n            <i class=\"icon-chevron-right s18 arrow\" ng-if=\"vm.hasChildren\"></i>\r\n        </div>\r\n\r\n        <a class=\"ms-navigation-horizontal-button\" ui-sref=\"{{node.uisref}}\" ui-sref-active=\"active md-accent-bg\"\r\n           ng-class=\"{\'active md-accent-bg md-accent-fg\': vm.isActive}\"\r\n           ng-if=\"node.uisref && node.title\">\r\n            <i class=\"icon s18 {{node.icon}}\" ng-if=\"node.icon\"></i>\r\n            <span class=\"title\" translate=\"{{node.translate}}\" flex>{{node.title}}</span>\r\n            <span class=\"badge white-fg\" style=\"background: {{node.badge.color}}\" ng-if=\"node.badge\">{{node.badge.content}}</span>\r\n            <i class=\"icon-chevron-right s18 arrow\" ng-if=\"vm.hasChildren\"></i>\r\n        </a>\r\n\r\n    </div>\r\n\r\n    <ul ng-if=\"vm.hasChildren && !vm.isHidden()\">\r\n        <li ng-repeat=\"node in node.children\" ms-navigation-horizontal-node=\"node\"\r\n            ng-class=\"{\'has-children\': vm.hasChildren}\"\r\n            ng-include=\"\'navigation-horizontal-nested.html\'\"></li>\r\n    </ul>\n</script>");
$templateCache.put("app/core/directives/ms-navigation/templates/vertical.html","<ul><li ng-repeat=\"node in vm.navigation\" ms-navigation-node=\"node\" \nng-class=\"{\'collapsed\': vm.collapsed, \'has-children\': vm.hasChildren}\" ng-include=\"\'navigation-nested.html\'\"></li></ul>\n<script type=\"text/ng-template\" id=\"navigation-nested.html\">\n<div ms-navigation-item layout=\"row\" ng-if=\"!vm.isHidden()\">\r\n\r\n        <div class=\"ms-navigation-button\" ng-if=\"!node.uisref && node.title\">\r\n            <i class=\"icon s16 {{node.icon}}\" ng-if=\"node.icon\"></i>\r\n            <span class=\"title\" translate=\"{{node.translate}}\" flex>{{node.title}}</span>\r\n            <span class=\"badge white-fg\" style=\"margin-right: {{node.badge.marginRight}}\" ng-style=\"{\'background\': node.badge.color}\" ng-if=\"node.badge\">{{node.badge.content}}</span>\r\n            <i class=\"icon-chevron-right s16 arrow\" ng-if=\"vm.collapsable && vm.hasChildren\"></i>\r\n        </div>\r\n\r\n        <a class=\"ms-navigation-button\" ui-sref=\"{{node.uisref}}\" ui-sref-active=\"active md-accent-bg\"\r\n           ng-if=\"node.uisref && node.title\">\r\n            <i class=\"icon s16 {{node.icon}}\" ng-if=\"node.icon\"></i>\r\n            <span class=\"title\" translate=\"{{node.translate}}\" flex>{{node.title}}</span>\r\n            <span class=\"badge white-fg\" style=\"margin-right: {{node.badge.marginRight}}\" ng-style=\"{\'background\': node.badge.color}\" ng-if=\"node.badge\">{{node.badge.content}}</span>\r\n            <i class=\"icon-chevron-right s16 arrow\" ng-if=\"vm.collapsable && vm.hasChildren\"></i>\r\n        </a>\r\n\r\n    </div>\r\n\r\n    <ul ng-if=\"vm.hasChildren && !vm.isHidden()\">\r\n        <li ng-repeat=\"node in node.children\" ms-navigation-node=\"node\"\r\n            ng-class=\"{\'collapsed\': vm.collapsed, \'has-children\': vm.hasChildren}\"\r\n            ng-include=\"\'navigation-nested.html\'\"></li>\r\n    </ul>\n</script>");
$templateCache.put("app/compartilhado/diretivas/ms-selecionar-multi-valores/view/ms-auto-selecionar-form.html","<div layout-gt-sm=\"row\" flex><md-input-container ng-class=\"{\'select tamanho-md-select\':vm.limitarWidth}\" \nclass=\"md-block select\" flex><label>{{vm.namePlaceholder}}</label><md-select class=\"ms-select\" \nng-model=\"vm.modelDados\" name=\"select\" md-selected-text=\"vm.metodos.retornaStringModelSelecionados()\" \nmd-on-open=\"vm.metodos.configurarSelect()\" ng-model-options=\"{trackBy: \'$value.codigo\'}\" \nng-disabled=\"(vm.habilitarTodos && !vm.autoSelecionar) || vm.desabilitar\" ng-required=\"!vm.habilitarTodos\" \nmultiple=\"multiple\"><md-select-header><input name=\"vm.termoProcurado\" ng-model=\"vm.termoProcurado\" type=\"search\" \nplaceholder=\"Pesquisar...\"></md-select-header><md-option ng-value=\"item\" \nng-disabled=\"vm.habilitarTodos && !vm.autoSelecionar\" \nng-repeat=\"item in vm.dados\r\n                                                 | filter:vm.termoProcurado | orderBy:vm.propriedadeParaAExibicaoDaRepeticao track by item.codigo\">\n{{item[vm.propriedadeParaAExibicaoDaRepeticao]}}</md-option></md-select><div \nng-messages=\"!vm.modelDados && !vm.habilitarTodos && vm.obrigatorio \"><div \nng-show=\"vm.modelDados == null && !vm.habilitarTodos && vm.obrigatorio\">Campo obrigatório</div></div>\n</md-input-container><md-input-container class=\"md-block\"><md-checkbox ng-model=\"vm.habilitarTodos\" \nng-disabled=\"!vm.modelDados.length \" ng-change=\"vm.metodos.ngChangeHabilitarTodos()\" aria-label=\"Todos\" name=\"todos\">\n<span class=\"float-label-cor-default\" translate=\"RELATORIO_CONTRATOS.TODOS\"></span></md-checkbox></md-input-container>\n</div>");
$templateCache.put("app/compartilhado/diretivas/pg-toolbar/componentes/pg-toolbar-botao-atualizar.html","<div><md-button class=\"md-icon-button\" id=\"pg-toolbar-botao-atualizar-1\" \nng-click=\"vm.metodosAcao.metodosAcaoAtualizar($event)\" \nng-disabled=\"vm.controladorToolbar.emProgresso || !vm.controladorToolbar.pesquisaAtiva\r\n                            || (vm.controladorToolbar.editarAtivo || vm.controladorToolbar.inserirAtivo)\r\n                            || vm.controladorToolbar.listarTodasEntidades || vm.desabilitarBotaoAtualizar\" \naria-label=\"Atualizar\"><md-icon md-font-icon=\"icon-refresh s30\"></md-icon></md-button><md-button hide-gt-xs \nid=\"pg-toolbar-botao-atualizar-2\" ng-click=\"vm.metodosAcao.metodosAcaoAtualizar($event)\" aria-label=\"Atualizar\" \nng-disabled=\"vm.controladorToolbar.emProgresso || !vm.controladorToolbar.pesquisaAtiva\r\n                            || (vm.controladorToolbar.editarAtivo || vm.controladorToolbar.inserirAtivo)\r\n                            || vm.controladorToolbar.listarTodasEntidades || vm.desabilitarBotaoAtualizar\">\n<span class=\"h3\" translate=\"PG_TOOLBAR.ATUALIZAR\">Atualizar</span></md-button><md-tooltip hide-xs \nid=\"pg-toolbar-tooltip-atualizar\" md-autohide md-delay=\"vm.tempoDelay\"><span translate=\"PG_TOOLBAR.ATUALIZAR\"></span>\n</md-tooltip></div>");
$templateCache.put("app/compartilhado/diretivas/pg-toolbar/componentes/pg-toolbar-botao-clonar.html","<div><md-button class=\"md-icon-button\" id=\"pg-toolbar-botao-clonar-1\" \nng-click=\"vm.metodosControladores.metodoControladorClonar(vm.entidade)\" \nng-disabled=\"vm.controladorToolbar.emProgresso || !vm.controladorToolbar.pesquisaAtiva\r\n               || vm.controladorToolbar.editarAtivo || vm.controladorToolbar.inserirAtivo\r\n               || vm.controladorToolbar.listarTodasEntidades || vm.desabilitarBotaoClonar\" \naria-label=\"Clonar\"><md-icon md-font-icon=\"icon-content-copy s30\"></md-icon></md-button><md-button hide-gt-xs \nid=\"pg-toolbar-botao-clonar-2\" ng-click=\"vm.metodosControladores.metodoControladorClonar(vm.entidade)\" \nng-disabled=\"vm.controladorToolbar.emProgresso || !vm.controladorToolbar.pesquisaAtiva\r\n               || vm.controladorToolbar.editarAtivo || vm.controladorToolbar.inserirAtivo\r\n               || vm.controladorToolbar.listarTodasEntidades || vm.desabilitarBotaoClonar\" \naria-label=\"Clonar\"><span class=\"h3\" translate=\"PG_TOOLBAR.CLONAR\">Clonar</span></md-button><md-tooltip hide-xs \nid=\"pg-toolbar-tooltip-clonar\" md-autohide md-delay=\"vm.tempoDelay\"><span translate=\"PG_TOOLBAR.CLONAR\"></span>\n</md-tooltip></div>");
$templateCache.put("app/compartilhado/diretivas/pg-toolbar/componentes/pg-toolbar-botao-editar.html","<div><md-button class=\"md-icon-button\" id=\"pg-toolbar-botao-editar-1\" \nng-click=\"vm.metodosControladores.metodoControladorEditar(vm.entidade)\" \nng-disabled=\"vm.controladorToolbar.emProgresso || !vm.controladorToolbar.pesquisaAtiva\r\n                            || vm.controladorToolbar.editarAtivo || vm.controladorToolbar.inserirAtivo\r\n                            || vm.controladorToolbar.listarTodasEntidades || vm.desabilitarBotaoEditar\" \naria-label=\"Editar\"><md-icon md-font-icon=\"icon-pencil s30\"></md-icon></md-button><md-button hide-gt-xs \nid=\"pg-toolbar-botao-editar-2\" ng-click=\"vm.metodosControladores.metodoControladorEditar(vm.entidade)\" \nng-disabled=\"vm.controladorToolbar.emProgresso || !vm.controladorToolbar.pesquisaAtiva \r\n                            || vm.controladorToolbar.editarAtivo || vm.controladorToolbar.inserirAtivo \r\n                            || vm.controladorToolbar.listarTodasEntidades || vm.desabilitarBotaoEditar\" \naria-label=\"Editar\"><span class=\"h3\" translate=\"PG_TOOLBAR.EDITAR\">Editar</span></md-button><md-tooltip hide-xs \nid=\"pg-toolbar-tooltip-editar\" md-autohide md-delay=\"vm.tempoDelay\"><span translate=\"PG_TOOLBAR.EDITAR\"></span>\n</md-tooltip></div>");
$templateCache.put("app/compartilhado/diretivas/pg-toolbar/componentes/pg-toolbar-botao-excluir.html","<div><md-button class=\"md-icon-button\" id=\"pg-toolbar-botao-excluir\" \nng-click=\"vm.metodosAcao.metodosAcaoExcluir($event)\" \nng-disabled=\"vm.controladorToolbar.emProgresso || !vm.controladorToolbar.pesquisaAtiva \r\n                            || vm.controladorToolbar.inserirAtivo || vm.controladorToolbar.listarTodasEntidades\r\n                            || vm.desabilitarBotaoExcluir\" \naria-label=\"Excluir\"><md-icon md-font-icon=\"icon-delete s30\"></md-icon></md-button><md-tooltip md-autohide \nid=\"pg-toolbar-tooltip-excluir\" md-delay=\"vm.tempoDelay\"><span translate=\"PG_TOOLBAR.EXCLUIR\"></span></md-tooltip>\n</div>");
$templateCache.put("app/compartilhado/diretivas/pg-toolbar/componentes/pg-toolbar-botao-inserir.html","<div><md-button class=\"md-icon-button\" id=\"pg-toolbar-botao-inserir-1\" \nng-click=\"vm.metodosControladores.metodoControladorInserir(vm.entidade)\" \nng-disabled=\"vm.controladorToolbar.emProgresso \r\n                            || vm.controladorToolbar.editarAtivo || vm.controladorToolbar.inserirAtivo\r\n                            || vm.controladorToolbar.listarTodasEntidades || vm.desabilitarBotaoInserir\" \naria-label=\"Inserir\"><md-icon md-font-icon=\"icon-plus s30\"></md-icon></md-button><md-button hide-gt-xs \nid=\"pg-toolbar-botao-inserir-2\" ng-click=\"vm.metodosControladores.metodoControladorInserir(vm.entidade)\" \nng-disabled=\"vm.controladorToolbar.emProgresso || vm.controladorToolbar.editarAtivo \r\n                            || vm.controladorToolbar.inserirAtivo || vm.controladorToolbar.listarTodasEntidades\r\n                            || vm.desabilitarBotaoInserir\" \naria-label=\"Inserir\"><span class=\"h3\" translate=\"PG_TOOLBAR.INSERIR\">Inserir</span></md-button><md-tooltip hide-xs \nid=\"pg-toolbar-tooltip-inserir\" md-autohide md-delay=\"vm.tempoDelay\"><span translate=\"PG_TOOLBAR.INSERIR\"></span>\n</md-tooltip></div>");
$templateCache.put("app/compartilhado/diretivas/pg-toolbar/componentes/pg-toolbar-botao-listar-todas-entidades.html","<div><md-button class=\"md-icon-button\" id=\"pg-toolbar-botao-listartodasentidades-1\" \nng-click=\"vm.metodosControladores.metodoControladorListarTodasEntidades($event)\" \nng-disabled=\"vm.controladorToolbar.emProgresso || !vm.controladorToolbar.pesquisaAtiva\r\n                            || (vm.controladorToolbar.editarAtivo || vm.controladorToolbar.inserirAtivo)\r\n                            || vm.desabilitarBotaoListarTodasEntidades\" \naria-label=\"Listar Todos\" ng-class=\"{\'selecionado\': vm.controladorToolbar.listarTodasEntidades}\"><md-icon \nmd-font-icon=\"icon-format-list-bulleted s30\"></md-icon></md-button><md-button hide-gt-xs \nid=\"pg-toolbar-botao-listartodasentidades-2\" \nng-click=\"vm.metodosControladores.metodoControladorListarTodasEntidades($event)\" \nng-disabled=\"vm.controladorToolbar.emProgresso || !vm.controladorToolbar.pesquisaAtiva \r\n                            || (vm.controladorToolbar.editarAtivo || vm.controladorToolbar.inserirAtivo)\r\n                             || vm.desabilitarBotaoListarTodasEntidades\" \naria-label=\"Listar Todos\"><span style=\"font-size: 1.2rem !important\" translate=\"PG_TOOLBAR.ALTERAR_EXIBICAO\"></span>\n</md-button><md-tooltip hide-xs id=\"pg-toolbar-tooltip-listartodasentidades-1\" \nng-if=\"!vm.controlador.listarTodasEntidades\" md-autohide md-delay=\"vm.tempoDelay\"><span \ntranslate=\"PG_TOOLBAR.ALTERAR_EXIBICAO_PARA_MODO_TABELA\"></span></md-tooltip><md-tooltip hide-xs \nid=\"pg-toolbar-tooltip-listartodasentidades-2\" ng-if=\"vm.controlador.listarTodasEntidades\" md-autohide \nmd-delay=\"vm.tempoDelay\"><span translate=\"PG_TOOLBAR.ALTERAR_EXIBICAO_PARA_MODO_EDICAO\"></span></md-tooltip></div>");
$templateCache.put("app/compartilhado/diretivas/pg-toolbar/componentes/pg-toolbar-botao-nova-pesquisa.html","<div layout-xs=\"row\"><md-button class=\"md-icon-button\" id=\"pg-toolbar-botao-nova-pesquisa-1\" \nng-click=\"vm.metodosControladores.metodoControladorNovaPesquisa()\" \nng-disabled=\"vm.controladorToolbar.emProgresso || !vm.controladorToolbar.pesquisaAtiva\r\n                            || (vm.controladorToolbar.editarAtivo || vm.controladorToolbar.inserirAtivo)\r\n                            || vm.controladorToolbar.listarTodasEntidades || vm.desabilitarBotaoNovaPesquisa\" \naria-label=\"Pesquisar\"><md-icon md-font-icon=\"icon-note-outline s30\"></md-icon></md-button><md-button hide-gt-xs \nid=\"pg-toolbar-botao-nova-pesquisa-2\" ng-click=\"vm.metodosControladores.metodoControladorNovaPesquisa()\" \nng-disabled=\"vm.controladorToolbar.emProgresso || !vm.controladorToolbar.pesquisaAtiva \r\n                                || (vm.controladorToolbar.editarAtivo || vm.controladorToolbar.inserirAtivo) \r\n                                || vm.controladorToolbar.listarTodasEntidades || vm.desabilitarBotaoNovaPesquisa\" \naria-label=\"Pesquisa\"><span translate=\"PG_TOOLBAR.NOVA_PESQUISA\" class=\"h3\">Nova Pesquisa</span></md-button><md-tooltip\n hide-xs id=\"pg-toolbar-tooltip-nova-pesquisa\" md-autohide md-delay=\"vm.tempoDelay\"><span \ntranslate=\"PG_TOOLBAR.NOVA_PESQUISA\"></span></md-tooltip></div>");
$templateCache.put("app/compartilhado/diretivas/pg-toolbar/componentes/pg-toolbar-botao-pesquisar.html","<div><md-button class=\"md-icon-button\" id=\"pg-toolbar-botao-pesquisar\" type=\"submit\" \nng-click=\"vm.metodosAcao.metodoAcaoPesquisar(vm.entidade, $event)\" \nng-disabled=\"vm.controladorToolbar.emProgresso || vm.controladorToolbar.pesquisaAtiva \r\n                           || (vm.controladorToolbar.editarAtivo || vm.controladorToolbar.inserirAtivo)\r\n                           || vm.controladorToolbar.listarTodasEntidades || vm.desabilitarBotaoPesquisar\" \naria-label=\"Buscar Pesquisa\"><md-icon md-font-icon=\"icon-magnify s30\"></md-icon></md-button><md-tooltip md-autohide \nid=\"pg-toolbar-tooltip-pesquisar\" md-delay=\"vm.tempoDelay\"><span translate=\"PG_TOOLBAR.BUSCAR_PESQUISA\"></span>\n</md-tooltip></div>");
$templateCache.put("app/compartilhado/diretivas/pg-toolbar/componentes/pg-toolbar-botao-reverter.html","<md-button class=\"md-icon-button\" id=\"pg-toolbar-botao-reverter\" \nng-click=\"vm.metodosControladores.metodoControladorReverter()\" \nng-disabled=\"vm.controladorToolbar.emProgresso || \r\n                        (!vm.controladorToolbar.editarAtivo && !vm.controladorToolbar.inserirAtivo)\r\n                         || vm.controladorToolbar.listarTodasEntidades || vm.desabilitarBotaoReverter\" \naria-label=\"Reverter\"><md-icon md-font-icon=\"icon-replay s30\"></md-icon></md-button><md-tooltip md-autohide \nid=\"pg-toolbar-tooltip-reverter\" md-delay=\"vm.tempoDelay\"><span translate=\"PG_TOOLBAR.REVERTER\">Reverter</span>\n</md-tooltip>");
$templateCache.put("app/compartilhado/diretivas/pg-toolbar/componentes/pg-toolbar-botao-salvar.html","<div><md-button class=\"md-icon-button\" id=\"pg-toolbar-botao-salvar\" type=\"submit\" \nng-click=\"vm.metodosControladores.metodoControladorSalvar(vm.entidade, $event)\" \nng-disabled=\"vm.controladorToolbar.emProgresso || vm.controladorToolbar.listarTodasEntidades\r\n                            || (!vm.controladorToolbar.editarAtivo && !vm.controladorToolbar.inserirAtivo)\r\n                            || vm.form.$invalid || vm.form.$pristine || vm.desabilitarBotaoSalvar\" \naria-label=\"Salvar\"><md-icon md-font-icon=\"icon-content-save s30\"></md-icon></md-button><md-tooltip md-autohide \nid=\"pg-toolbar-tooltip-salvar\" md-delay=\"vm.tempoDelay\"><span translate=\"PG_TOOLBAR.SALVAR\"></span></md-tooltip></div>");
$templateCache.put("app/compartilhado/diretivas/pg-toolbar/componentes/pg-toolbar-navegacao-botao-anterior.html","<div><md-button class=\"md-icon-button\" id=\"pg-toolbar-botao-anterior\" \nng-click=\"vm.metodosAcao.metodoAcaoNavegacao(\'anterior\')\" \nng-disabled=\"vm.controladorToolbar.emProgresso || !vm.controladorToolbar.pesquisaAtiva \r\n                            || vm.controladorToolbar.primeiraEntidade \r\n                            || (vm.controladorToolbar.editarAtivo || vm.controladorToolbar.inserirAtivo)\r\n                            || vm.controladorToolbar.listarTodasEntidades \r\n                            || (vm.desabilitarBotoesNavegacao || vm.desabilitarBotaoAnterior)\" \naria-label=\"Anterior\"><md-icon md-font-icon=\"icon-chevron-left s30\"></md-icon></md-button></div>");
$templateCache.put("app/compartilhado/diretivas/pg-toolbar/componentes/pg-toolbar-navegacao-botao-primeira.html","<div><md-button class=\"md-icon-button\" id=\"pg-toolbar-botao-primeira\" \nng-click=\"vm.metodosAcao.metodoAcaoNavegacao(\'primeira\')\" \nng-disabled=\"vm.controladorToolbar.emProgresso || !vm.controladorToolbar.pesquisaAtiva \r\n                            || vm.controladorToolbar.primeiraEntidade\r\n                            || (vm.controladorToolbar.editarAtivo || vm.controladorToolbar.inserirAtivo)\r\n                            || vm.controladorToolbar.listarTodasEntidades\r\n                            || (vm.desabilitarBotoesNavegacao || vm.desabilitarBotaoPrimeira)\" \naria-label=\"Primeiro\"><md-icon md-font-icon=\"icon-chevron-double-left s30\"></md-icon></md-button></div>");
$templateCache.put("app/compartilhado/diretivas/pg-toolbar/componentes/pg-toolbar-navegacao-botao-proxima.html","<div><md-button class=\"md-icon-button\" ng-click=\"vm.metodosAcao.metodoAcaoNavegacao(\'proxima\')\" \nid=\"pg-toolbar-botao-proxima\" \nng-disabled=\"vm.controladorToolbar.emProgresso || vm.controladorToolbar.ultimaEntidade \r\n                            || !vm.controladorToolbar.pesquisaAtiva\r\n                            || (vm.controladorToolbar.editarAtivo || vm.controladorToolbar.inserirAtivo)\r\n                            || vm.controladorToolbar.listarTodasEntidades\r\n                            || (vm.desabilitarBotoesNavegacao || vm.desabilitarBotaoProxima)\" \naria-label=\"Proximo\"><md-icon md-font-icon=\"icon-chevron-right s30\"></md-icon></md-button></div>");
$templateCache.put("app/compartilhado/diretivas/pg-toolbar/componentes/pg-toolbar-navegacao-botao-ultima.html","<div><md-button class=\"md-icon-button\" id=\"pg-toolbar-botao-ultima\" \nng-click=\"vm.metodosAcao.metodoAcaoNavegacao(\'ultima\')\" \nng-disabled=\"vm.controladorToolbar.emProgresso || vm.controladorToolbar.ultimaEntidade \r\n                            || !vm.controladorToolbar.pesquisaAtiva\r\n                            || (vm.controladorToolbar.editarAtivo || vm.controladorToolbar.inserirAtivo)\r\n                            || vm.controladorToolbar.listarTodasEntidades\r\n                            || (vm.desabilitarBotoesNavegacao || vm.desabilitarBotaoUltima)\" \naria-label=\"Ultimo\"><md-icon md-font-icon=\"icon-chevron-double-right s30\"></md-icon></md-button></div>");
$templateCache.put("app/compartilhado/diretivas/toolbar-mobile-desktop/desktop/toolbar-desktop.html","<md-toolbar id=\"toolbar\" class=\"md-menu-toolbar md-whiteframe-1dp md-accent\"><div layout=\"row\" \nlayout-align=\"{{vm.tipolayout}}\"><div class=\"h1\" layout=\"row\" layout-align=\"start center\" \nng-if=\"vm.ngUtilizaNavegacao && !vm.ngOcultaBotaoNovaPesquisa\"><md-button class=\"md-icon-button\" \nng-disabled=\"vm.ngDisabledBotaoNovaPesquisa || vm.controleForm.emProgresso || vm.ngDisabled || vm.controlador.novaEntidade\r\n                                    || vm.controlador.editarAtivo || !vm.controlador.pesquisaAtiva || vm.controlador.listarTodasEntidades\" \nng-click=\"vm.toolbar.novaPesquisa()\" aria-label=\"Pesquisar\"><md-icon md-font-icon=\"icon-note-outline s30\"></md-icon>\n</md-button><md-tooltip md-autohide md-delay=\"vm.tempoDelay\" ng-if=\"!vm.controlador.pesquisaAtiva\"><span \ntranslate=\"TOOLBAR.PESQUISAR\">Pesquisar</span></md-tooltip><md-tooltip md-autohide md-delay=\"vm.tempoDelay\" \nng-if=\"vm.controlador.pesquisaAtiva\"><span translate=\"TOOLBAR.NOVA_PESQUISA\">Nova Pesquisa</span></md-tooltip></div>\n<div class=\"h1\" layout=\"row\" layout-align=\"start center\" ng-if=\"!vm.ngOcultaBotaoPesquisar\"><md-button \nclass=\"md-icon-button\" type=\"submit\" \nng-disabled=\"vm.ngDisabledBotaoPesquisar || vm.controleForm.emProgresso || vm.ngDisabled || vm.controlador.pesquisaAtiva\r\n                                    || vm.controlador.novaEntidade || vm.controlador.listarTodasEntidades\" \nng-click=\"vm.metodosToolbar.pesquisar(vm.entidade, $event)\" aria-label=\"Buscar Pesquisa\"><md-icon \nmd-font-icon=\"icon-magnify s30\"></md-icon></md-button><md-tooltip md-autohide md-delay=\"vm.tempoDelay\"><span \ntranslate=\"TOOLBAR.BUSCAR_PESQUISA\">Buscar Pesquisa</span></md-tooltip></div><div class=\"h1\" layout=\"row\" \nlayout-align=\"start center\" ng-if=\"!vm.ngOcultaBotaoSalvar\"><md-button class=\"md-icon-button\" type=\"submit\" \nng-disabled=\"vm.ngDisabledBotaoSalvar || vm.controleForm.emProgresso || vm.ngDisabled\r\n                                    || (!vm.controlador.editarAtivo && !vm.controlador.novaEntidade)\r\n                                    || (vm.controlador.listarTodasEntidades || vm.formulario.$invalid || vm.formulario.$pristine)\r\n                                    && (!vm.controleForm.habilitarButtonSalvar && !vm.controleForm.emProgresso)\" \nng-click=\"vm.metodosToolbar.salvar(vm.entidade, $event)\" aria-label=\"Salvar\"><md-icon \nmd-font-icon=\"icon-content-save s30\"></md-icon></md-button><md-tooltip md-autohide md-delay=\"vm.tempoDelay\"><span \ntranslate=\"TOOLBAR.SALVAR\">Salvar</span></md-tooltip></div><div class=\"h1\" layout=\"row\" layout-align=\"start center\" \nng-if=\"!vm.ngOcultaBotaoReverter\"><md-button class=\"md-icon-button\" \nng-disabled=\"vm.ngDisabledBotaoReverter || vm.controleForm.emProgresso\r\n                                    || vm.ngDisabled || (!vm.controlador.editarAtivo && !vm.controlador.novaEntidade)\r\n                                    || vm.controlador.listarTodasEntidades\" \nng-click=\"vm.toolbar.reverter()\" aria-label=\"Reverter\"><md-icon md-font-icon=\"icon-replay s30\"></md-icon></md-button>\n<md-tooltip md-autohide md-delay=\"vm.tempoDelay\"><span translate=\"TOOLBAR.REVERTER\">Reverter</span></md-tooltip></div>\n<div class=\"h1\" layout=\"row\" layout-align=\"start center\" ng-if=\"!vm.ngOcultaBotaoExcluir\"><md-button \nclass=\"md-icon-button\" \nng-disabled=\"vm.ngDisabledBotaoExcluir || vm.controleForm.emProgresso || vm.ngDisabled\r\n                                    || !vm.controlador.pesquisaAtiva  || vm.controlador.novaEntidade\r\n                                    || vm.controlador.listarTodasEntidades || vm.controleForm.desabilitarButtonExcluir\" \nng-click=\"vm.metodosToolbar.excluir(vm.entidade, $event)\" aria-label=\"Excluir\"><md-icon md-font-icon=\"icon-delete s30\">\n</md-icon></md-button><md-tooltip md-autohide md-delay=\"vm.tempoDelay\"><span translate=\"TOOLBAR.EXCLUIR\">Excluir</span>\n</md-tooltip></div><div class=\"h1\" layout=\"row\" layout-align=\"start center\" ng-if=\"!vm.ngOcultaBotaoEditar\"><md-button \nclass=\"md-icon-button\" \nng-disabled=\"vm.ngDisabledBotaoEditar || vm.controleForm.emProgresso || vm.ngDisabled || vm.entidade === null\r\n                                    || !vm.controlador.pesquisaAtiva || vm.controlador.novaEntidade || vm.controlador.listarTodasEntidades\r\n                                    || vm.controlador.editarAtivo || vm.controleForm.desabilitarButtonEditar\" \nng-click=\"vm.toolbar.editar(vm.entidade)\" aria-label=\"Editar\"><md-icon md-font-icon=\"icon-pencil s30\"></md-icon>\n</md-button><md-tooltip md-autohide md-delay=\"vm.tempoDelay\"><span translate=\"TOOLBAR.EDITAR\">Editar</span>\n</md-tooltip></div><div class=\"h1\" layout=\"row\" layout-align=\"start center\" ng-if=\"!vm.ngOcultaBotaoInserir\"><md-button\n class=\"md-icon-button\" \nng-disabled=\"vm.ngDisabledBotaoInserir || vm.controleForm.emProgresso || vm.ngDisabled || vm.controlador.editarAtivo\r\n                                    || vm.controlador.listarTodasEntidades || vm.controlador.novaEntidade\r\n                                    || vm.controleForm.desabilitarButtonInserir\" \nng-click=\"vm.toolbar.inserir(vm.entidade)\" aria-label=\"Inserir\"><md-icon md-font-icon=\"icon-plus s30\"></md-icon>\n</md-button><md-tooltip md-autohide md-delay=\"vm.tempoDelay\"><span translate=\"TOOLBAR.INSERIR\">Inserir</span>\n</md-tooltip></div><div class=\"h1\" layout=\"row\" layout-align=\"start center\" ng-if=\"!vm.ngOcultaBotaoAtualizar\">\n<md-button class=\"md-icon-button\" ng-click=\"vm.metodosToolbar.atualizar($event)\" \nng-disabled=\"vm.ngDisabledBotaoAtualizar || !vm.controlador.pesquisaAtiva || vm.controleForm.emProgresso || vm.ngDisabled || vm.controlador.editarAtivo || vm.controlador.novaEntidade\r\n                       || vm.controlador.listarTodasEntidades || vm.controlador.processaEntidade \" \naria-label=\"Atualizar\"><md-icon md-font-icon=\"icon-refresh s30\"></md-icon></md-button><md-tooltip md-autohide \nmd-delay=\"vm.tempoDelay\"><span translate=\"TOOLBAR.ATUALIZAR\"></span></md-tooltip></div><div class=\"toolbar-separator\" \nng-if=\"vm.ngUtilizaNavegacao\"></div><div class=\"texto-primario\" layout=\"row\" layout-align=\"start center\" \nng-if=\"vm.ngUtilizaNavegacao\"><span>{{vm.textoExibido}}</span></div><div class=\"toolbar-separator\" \nng-if=\"vm.ngUtilizaNavegacao\"></div><div class=\"h1\" layout=\"row\" layout-align=\"start center\" \nng-if=\"vm.ngUtilizaNavegacao\"><md-button class=\"md-icon-button\" \nng-disabled=\"vm.ngDisabledBotaoPrimeira || vm.ngDisabled || vm.entidades.length === 0 || vm.controlador.primeiraEntidade\r\n                       || vm.controleForm.emProgresso || vm.entidades.length === 1\r\n                       || vm.controlador.novaEntidade || vm.controlador.editarAtivo\r\n                       || vm.controlador.listarTodasEntidades || vm.controlador.processaEntidade\" \nng-click=\"vm.toolbar.primeira()\" aria-label=\"Primeiro\"><md-icon md-font-icon=\"icon-chevron-double-left s30\"></md-icon>\n</md-button></div><div class=\"h1\" layout=\"row\" layout-align=\"start center\" ng-if=\"vm.ngUtilizaNavegacao\"><md-button \nclass=\"md-icon-button\" \nng-disabled=\"vm.ngDisabledBotaoAnterior || vm.ngDisabled || vm.entidades.length === 0 || vm.controlador.primeiraEntidade\r\n                       || vm.entidades.length === 1 || vm.controlador.novaEntidade || vm.controlador.editarAtivo || vm.controlador.listarTodasEntidades\r\n                       || vm.controleForm.emProgresso || vm.controlador.processaEntidade \" \nng-click=\"vm.toolbar.anterior()\" aria-label=\"Anterior\"><md-icon md-font-icon=\"icon-chevron-left s30\"></md-icon>\n</md-button></div><div class=\"texto-secundario\" layout=\"row\" layout-align=\"start center\" \nng-show=\"(vm.entidades !== null && !vm.controlador.novaEntidade && vm.entidades.length > 0)\r\n                      && !vm.controlador.listarTodasEntidades\" \nng-if=\"vm.ngUtilizaNavegacao\"><span>{{(vm.indice + 1)}} de {{(vm.entidades.length)}}</span></div><div class=\"h1\" \nlayout=\"row\" layout-align=\"start center\" ng-if=\"vm.ngUtilizaNavegacao\"><md-button class=\"md-icon-button\" \nng-disabled=\"vm.ngDisabledBotaoProxima || vm.ngDisabled || vm.entidades.length === 0 || vm.controlador.ultimaEntidade\r\n                       || vm.entidades.length === 1 || vm.controlador.novaEntidade || vm.controlador.editarAtivo || vm.controlador.listarTodasEntidades || vm.controleForm.emProgresso || vm.controlador.processaEntidade\" \nng-click=\"vm.toolbar.proxima(vm.proxima)\" aria-label=\"Proximo\"><md-icon md-font-icon=\"icon-chevron-right s30\">\n</md-icon></md-button></div><div class=\"h1\" layout=\"row\" layout-align=\"start center\" ng-if=\"vm.ngUtilizaNavegacao\">\n<md-button class=\"md-icon-button\" \nng-disabled=\"vm.ngDisabledBotaoUltima || vm.ngDisabled || vm.entidades.length === 0 || vm.controlador.ultimaEntidade\r\n                       || vm.entidades.length === 1|| vm.controlador.novaEntidade\r\n                       || vm.controlador.editarAtivo || vm.controlador.listarTodasEntidades\r\n                       || vm.controleForm.emProgresso || vm.controlador.processaEntidade \" \nng-click=\"vm.toolbar.ultima()\" aria-label=\"Ultimo\"><md-icon md-font-icon=\"icon-chevron-double-right s30\"></md-icon>\n</md-button></div><div class=\"h1\" layout=\"row\" layout-align=\"start center\" ng-if=\"vm.ngUtilizaNavegacao\"><md-button \nclass=\"md-icon-button\" \nng-class=\"{\'selecionado\': vm.buttonSelecionado === \'listarTodos\' && !vm.ngDisabledBotaoListarTodasEntidadesEmModoExibicaoTabela}\" \nng-disabled=\"vm.ngDisabledBotaoListarTodasEntidades || vm.controleForm.emProgresso || vm.ngDisabled\r\n                       || vm.entidades.length === 0 || vm.controlador.novaEntidade || vm.controlador.editarAtivo || vm.controleForm.desabilitarButtonListarTodos\r\n                       || (vm.ngDisabledBotaoListarTodasEntidadesEmModoExibicaoTabela && vm.controlador.listarTodasEntidades)\" \nng-click=\"vm.toolbar.listarTodasEntidades()\" aria-label=\"Listar Todos\"><md-icon \nmd-font-icon=\"icon-format-list-bulleted s30\"></md-icon></md-button><md-tooltip \nng-if=\"!vm.controlador.listarTodasEntidades\" md-autohide md-delay=\"vm.tempoDelay\"><span \ntranslate=\"TOOLBAR.ALTERAR_EXIBICAO_PARA_MODO_TABELA\">Alterar exibição para tabela</span></md-tooltip><md-tooltip \nng-if=\"vm.controlador.listarTodasEntidades\" md-autohide md-delay=\"vm.tempoDelay\"><span \ntranslate=\"TOOLBAR.ALTERAR_EXIBICAO_PARA_MODO_EDICAO\">Alterar exibição para edição</span></md-tooltip></div></div>\n</md-toolbar><md-progress-linear class=\"md-accent\" md-mode=\"buffer\" value=\"{{vm.progresso}}\" \nmd-buffer-value=\"{{vm.progresso}}\" ng-disabled=\"!vm.controleForm.emProgresso\">");
$templateCache.put("app/compartilhado/diretivas/toolbar-mobile-desktop/mobile/toolbar-mobile.html","<md-toolbar id=\"toolbar\" class=\"md-menu-toolbar md-whiteframe-1dp md-accent\"><div layout=\"row\" \nlayout-align=\"start center\"><div layout=\"row\" layout-align=\"start center\"><div class=\"h1\" layout=\"row\" \nlayout-align=\"start center\"><md-button class=\"md-icon-button\" \nng-disabled=\"vm.controleForm.emProgresso || vm.ngDisabled || vm.controleForm.listarTodasEntidades || vm.controlador.novaEntidade || vm.controlador.editarAtivo\" \nng-click=\"vm.toolbar.abrirSidenav()\" aria-label=\"Abrir Sidenav\"><md-icon md-font-icon=\"icon-menu s30\"></md-icon>\n</md-button></div><div class=\"h1\" layout=\"row\" layout-align=\"start center\"><md-button class=\"md-icon-button\" \nng-hide=\"vm.controleForm.emProgresso || vm.ngDisabled || vm.controlador.pesquisaAtiva || vm.controlador.novaEntidade || vm.controlador.listarTodasEntidades\" \nng-click=\"vm.metodosToolbar.pesquisar(vm.entidade, $event)\" aria-label=\"Buscar Pesquisa\"><md-icon \nmd-font-icon=\"icon-magnify s30\"></md-icon></md-button></div><div class=\"h1\" layout=\"row\" layout-align=\"start center\" \nng-if=\"!vm.ngOcultaBotaoSalvar\"><md-button class=\"md-icon-button\" type=\"submit\" \nng-hide=\"vm.controleForm.emProgresso || vm.ngDisabled || !vm.controlador.editarAtivo && !vm.controlador.novaEntidade ||                                   vm.controlador.listarTodasEntidades\" \nng-disabled=\"vm.formulario.$invalid || vm.formulario.$pristine\" \nng-click=\"vm.metodosToolbar.salvar(vm.entidade, $event)\" aria-label=\"Salvar\"><md-icon \nmd-font-icon=\"icon-content-save s30\"></md-icon></md-button></div><div class=\"h1\" layout=\"row\" \nlayout-align=\"start center\" ng-if=\"!vm.ngOcultaBotaoReverter\"><md-button class=\"md-icon-button\" \nng-hide=\"vm.controleForm.emProgresso || vm.ngDisabled || !vm.controlador.editarAtivo && !vm.controlador.novaEntidade\r\n                                    || vm.controlador.listarTodasEntidades\" \nng-click=\"vm.toolbar.reverter()\" aria-label=\"Reverter\"><md-icon md-font-icon=\"icon-replay s30\"></md-icon></md-button>\n</div><div class=\"h1\" layout=\"row\" layout-align=\"start center\" ng-if=\"!vm.ngOcultaBotaoExcluir\"><md-button \nclass=\"md-icon-button\" \nng-hide=\"vm.controleForm.emProgresso || vm.ngDisabled || !vm.controlador.editarAtivo\r\n                           || vm.controlador.listarTodasEntidades\" \nng-click=\"vm.metodosToolbar.excluir(vm.entidade, $event)\" aria-label=\"Excluir\"><md-icon md-font-icon=\"icon-delete s30\">\n</md-icon></md-button></div><div class=\"h1\" layout=\"row\" layout-align=\"start center\"><md-button class=\"md-icon-button\" \nng-click=\"vm.controleForm.emProgresso || vm.metodosToolbar.atualizar($event)\" \nng-hide=\"vm.controleForm.emProgresso || vm.ngDisabled || vm.controlador.novaEntidade\r\n                                    || vm.controlador.editarAtivo || vm.controlador.listarTodasEntidades\r\n                                    || !vm.controlador.pesquisaAtiva\" \naria-label=\"Atualizar\"><md-icon md-font-icon=\"icon-refresh s30\"></md-icon></md-button></div><div layout=\"row\" \nng-show=\"!vm.controlador.editarAtivo && !vm.controlador.novaEntidade\r\n                                       &&  !vm.controlador.listarTodasEntidades\" \nng-if=\"vm.ngUtilizaNavegacao\"><div class=\"h1\" layout=\"row\" layout-align=\"start center\"><md-button \nclass=\"md-icon-button\" \nng-disabled=\"vm.ngDisabled || vm.entidades === null || vm.controlador.primeiraEntidade|| vm.entidades.length === 1 || vm.controlador.novaEntidade || vm.controlador.editarAtivo || vm.controlador.listarTodasEntidades || vm.controlador.processaEntidade\" \nng-click=\"vm.toolbar.primeira()\" aria-label=\"Primeiro\"><md-icon md-font-icon=\"icon-chevron-double-left s30\"></md-icon>\n</md-button></div><div class=\"h1\" layout=\"row\" layout-align=\"start center\"><md-button class=\"md-icon-button\" \nng-disabled=\"vm.ngDisabled || vm.entidades === null || vm.controlador.primeiraEntidade|| vm.entidades.length === 1 || vm.controlador.novaEntidade || vm.controlador.editarAtivo|| vm.controlador.listarTodasEntidades\r\n                     || vm.controlador.processaEntidade\" \nng-click=\"vm.toolbar.anterior()\" aria-label=\"Anterior\"><md-icon md-font-icon=\"icon-chevron-left s30\"></md-icon>\n</md-button></div><div class=\"texto-secundario\" layout=\"row\" layout-align=\"start center\" \nng-show=\"vm.entidades !== null && !vm.controlador.novaEntidade && vm.entidades.length > 0\r\n                              && !vm.controlador.listarTodasEntidades\">\n{{(vm.indice + 1)}} de {{(vm.entidades.length)}}</div><div class=\"h1\" layout=\"row\" layout-align=\"start center\">\n<md-button class=\"md-icon-button\" \nng-disabled=\"vm.ngDisabled || vm.entidades === null || vm.controlador.ultimaEntidade || vm.entidades.length === 1 || vm.controlador.novaEntidade || vm.controlador.editarAtivo|| vm.controlador.listarTodasEntidades\r\n                     || vm.controlador.processaEntidade\" \nng-click=\"vm.toolbar.proxima()\" aria-label=\"Proximo\"><md-icon md-font-icon=\"icon-chevron-right s30\"></md-icon>\n</md-button></div><div class=\"h1\" layout=\"row\" layout-align=\"start center\"><md-button class=\"md-icon-button\" \nng-disabled=\"vm.ngDisabled || vm.entidades === null || vm.controlador.ultimaEntidade || vm.entidades.length === 1 || vm.controlador.novaEntidade || vm.controlador.editarAtivo || vm.controlador.listarTodasEntidades || vm.controlador.processaEntidade\" \nng-click=\"vm.toolbar.ultima()\" aria-label=\"Ultimo\"><md-icon md-font-icon=\"icon-chevron-double-right s30\"></md-icon>\n</md-button></div></div></div><div class=\"h1\" layout=\"row\" layout-align=\"end center\" ng-if=\"vm.ngUtilizaNavegacao\">\n<md-button class=\"md-icon-button\" \nng-class=\"{\'selecionado\': vm.buttonSelecionado === vm.controleButtonSelecionado.listarTodasEntidades}\" \nng-hide=\"vm.ngDisabled || !vm.controleForm.listarTodasEntidades\" ng-click=\"vm.toolbar.listarTodasEntidades()\" \naria-label=\"Listar Todos\"><md-icon md-font-icon=\"icon-format-list-bulleted s30\"></md-icon></md-button></div></div>\n</md-toolbar><div id=\"sidenav\"><md-sidenav class=\"md-sidenav-left md-whiteframe-4dp\" ms-scroll \nmd-component-id=\"sidenav\" \nng-include=\"\'app/compartilhado/diretivas/toolbar-mobile-desktop/mobile/sidenav/sidenav.html\'\" ms-sidenav-helper>\n</md-sidenav></div><md-progress-linear class=\"md-accent\" md-mode=\"buffer\" value=\"{{vm.progresso}}\" \nmd-buffer-value=\"{{vm.progresso}}\" ng-disabled=\"!vm.controleForm.emProgresso\">");
$templateCache.put("app/main/agenda/processamento/visualizar-atividades/visualizar-atividades.html","<div id=\"calendar\" class=\"page-layout simple fullwidth\" layout=\"column\" layout-fill><md-toolbar class=\"header\"><div \nclass=\"header-content\" layout=\"column\" layout-align=\"space-between\"><div class=\"header-top\" layout=\"row\" \nlayout-align=\"space-between center\" layout-xs=\"column\"><div class=\"logo\" hide-xs layout=\"row\" \nlayout-align=\"start center\"><span class=\"logo-icon\"><md-icon md-font-icon=\"icon-calendar-today\"></md-icon></span><span \nclass=\"logo-text\" translate=\"CALENDARIO.CALENDARIO\">Calendário</span></div><div class=\"toolbar\" layout=\"row\" \nlayout-align=\"start center\"><md-button class=\"md-icon-button\" ng-disabled=\"vm.emProgresso\" \nng-click=\"vm.metodos.recarregarAtividades()\" aria-label=\"Atualizar agenda\" translate \ntranslate-attr-aria-label=\"CALENDARIO.ATUALIZAR_AGENDA\"><md-icon md-font-icon=\"icon-refresh\"></md-icon><md-tooltip>\n<span translate=\"CALENDARIO.ATUALIZAR_AGENDA\">Atualizar agenda</span></md-tooltip></md-button><md-button \nclass=\"md-icon-button\" ng-click=\"vm.metodos.exibirLegenda()\" aria-label=\"Legenda\" translate \ntranslate-attr-aria-label=\"CALENDARIO.LEGENDA\"><md-icon md-font-icon=\"icon-information-outline\"></md-icon><md-tooltip>\n<span translate=\"CALENDARIO.LEGENDA\">Legenda</span></md-tooltip></md-button><md-button class=\"md-icon-button\" \nng-click=\"vm.metodos.irParaHoje()\" aria-label=\"Today\" translate translate-attr-aria-label=\"CALENDARIO.HOJE\"><md-icon \nmd-font-icon=\"icon-calendar-today\"></md-icon><md-tooltip><span translate=\"CALENDARIO.HOJE\">Hoje</span></md-tooltip>\n</md-button><md-button class=\"md-icon-button\" ng-click=\"vm.metodos.alterarModoVisualizacao(\'month\')\" aria-label=\"Week\" \ntranslate translate-attr-aria-label=\"CALENDAR.WEEK\"><md-icon md-font-icon=\"icon-view-week\"></md-icon><md-tooltip><span \ntranslate=\"CALENDARIO.MES\">Mês</span></md-tooltip></md-button><md-button class=\"md-icon-button\" \nng-click=\"vm.calendar.changeView(\'agendaDay\')\" aria-label=\"Day\" translate translate-attr-aria-label=\"CALENDARIO.DIA\">\n<md-icon md-font-icon=\"icon-view-day\"></md-icon><md-tooltip><span translate=\"CALENDARIO.DIA\">Dia</span></md-tooltip>\n</md-button><md-button class=\"md-icon-button\" ng-click=\"vm.metodos.alterarModoVisualizacao(\'agendaWeek\')\" \naria-label=\"semana\" translate translate-attr-aria-label=\"CALENDARIO.SEMANA\"><md-icon md-font-icon=\"icon-view-week\">\n</md-icon><md-tooltip><span translate=\"CALENDARIO.SEMANA\">Semana</span></md-tooltip></md-button></div></div><div \nclass=\"header-bottom\" layout=\"row\" layout-align=\"center center\"><md-button class=\"md-icon-button arrow\" \nng-click=\"vm.metodos.anterior()\" ng-disabled=\"vm.emProgresso\" aria-label=\"Anterior\" translate \ntranslate-attr-aria-label=\"CALENDAR.PREVIOUS\"><md-icon md-font-icon=\"icon-chevron-left\"></md-icon></md-button><div \nclass=\"title\" layout=\"column\" layout-align=\"center center\"><div ng-hide=\"vm.emProgresso\"><md-datepicker \nng-model=\"vm.dataSelecionada\" class=\"invisible\" md-placeholder=\"Enter date\" md-is-open=\"vm.datePicker.isOpen\" \nng-mask=\"3?9/1?9/9999\" md-mode=\"month\"></md-datepicker><span ng-click=\"vm.datePicker.isOpen = true\">\n{{vm.calendarView.title}}</span></div><md-progress-circular ng-show=\"vm.emProgresso\" style=\"color: white!important\" \nmd-diameter=\"18\" md-mode=\"indeterminate\"></md-progress-circular></div><md-button class=\"md-icon-button arrow\" \nng-click=\"vm.metodos.proximo()\" ng-disabled=\"vm.emProgresso\" aria-label=\"Próximo\" translate \ntranslate-attr-aria-label=\"CALENDAR.NEXT\"><md-icon md-font-icon=\"icon-chevron-right\"></md-icon></md-button></div></div>\n<md-button ng-disabled=\"vm.emProgresso\" hide-xs hide-sm class=\"add-event-button md-fab md-toolbar\" \nng-click=\"vm.metodos.cadastrarAtividade($event)\" aria-label=\"Cadastrar Atividade\" translate \ntranslate-attr-aria-label=\"CALENDARIO.CADASTRAR_ATIVIDADE\"><md-icon md-font-icon=\"icon-plus\"></md-icon></md-button>\n</md-toolbar><div hide-gt-sm layout=\"column\" flex><md-button flex ng-disabled=\"vm.emProgresso\" \nstyle=\"color:#FFF!Important;background:#2A84AF!Important\" ng-click=\"vm.metodos.cadastrarAtividade($event)\" \naria-label=\"Cadastrar Atividade\" translate translate-attr-aria-label=\"CALENDARIO.CADASTRAR_ATIVIDADE\"><span \nclass=\"text-center\">CADASTRAR ATIVIDADE</span></md-button></div><div class=\"usuario-selecionado\" \nng-if=\"!vm.parametros\"><md-input-container class=\"md-block\" flex=\"15\" ng-if=\"vm.squadUsuarioLogado.length > 1\"><label>\nSquad</label><md-select ng-model=\"vm.codigoSquads\" name=\"codigoSquads\" multiple=\"multiple\" \nng-disabled=\"vm.emProgresso\" ng-change=\"vm.metodos.onChangeSquad(vm.codigoSquads)\"><md-option ng-value=\"squad.codigo\" \nng-repeat=\"squad in vm.squads track by squad.codigo\">{{squad.descricao}}</md-option></md-select></md-input-container>\n<md-input-container class=\"md-block\" flex=\"15\"><label translate=\"ATENDIMENTO.COLABORADOR_RESPONSAVEL\"></label>\n<md-select ng-model=\"vm.atividade.usuarioAtivo.codigo\" ng-disabled=\"vm.emProgresso\" flex name=\"usuarioCodigo\" \nng-change=\"vm.metodos.carregarAtividades(vm.atividade.usuarioAtivo.codigo)\" \nmd-on-open=\"vm.metodos.configuraMdSelectUsuarioAtivo($event)\"><md-select-header ng-if=\"vm.usuariosAtivos.length > 0\">\n<input id=\"visualizar-atividade-usuarios-ativos-md-select\" flex class=\"md-text\" ng-model=\"vm.filtrarUsuariosAtivo\" \ntype=\"search\" placeholder=\"\" translate translate-attr-placeholder=\"ATENDIMENTO.PESQUISAR_COLABORADOR\">\n</md-select-header><md-option ng-value=\"usuario.codigo\" \nng-repeat=\"usuario in vm.usuarios | filter:vm.filtrarUsuariosAtivo track by usuario.codigo\">{{usuario.login}}\n</md-option></md-select></md-input-container></div><md-input-container ng-if=\"vm.parametros\" \nclass=\"md-block cliente-selecionado\"><span>{{vm.parametros.cliente.nome}}</span></md-input-container><md-content><div \nlayout=\"column\" flex><div id=\"calendario\" class=\"content\" flex><div id=\"calendarView\" \nng-mousemove=\"vm.metodos.cursorPosition($event)\" ui-calendar=\"vm.calendarUiConfig.calendar\" ng-model=\"vm.events\" \ncalendar=\"main\"></div></div></div></md-content></div>");
$templateCache.put("app/main/atendimento/processamento/atendimentos-vinculados/atendimentos-vinculados.html","<div layout=\"column\" flex><header-padrao translate-nome=\"{{vm.tituloHeader}}\" \nliberar-pesquisa-quando-datatable-ativo=\"true\" \nmensagem-tooltip-icone-estado-anterior=\"vm.mensagemTooltipIconeEstadoAnteriorHeaderPadrao\" pesquisar=\"vm.pesquisar\">\n</header-padrao><form name=\"vm.form.atendimentoVinculado\" novalidate><div layout=\"row\" class=\"md-background-bg\" flex>\n<div flex layout-align=\"start center\" layout=\"row\"><md-button class=\"array-buttons-atendimentos-vinculados\" \naria-label=\"{{item.descricao}}\" ng-repeat=\"item in vm.legendasAtendimentosVinculados\" \nng-class=\"{\'descricao-selecionada\': vm.legendaSelecionadaAtendimentosVinculados == $index}\" \nng-click=\"vm.metodos.filtrarTabelaAtendimentosFinalizados(item, $index)\" \nng-disabled=\"!vm.flag || vm.progressoFiltrarAtendimentos\"><md-icon md-font-icon=\"icon-label\" class=\"s16\" \nng-style=\"{\'color\' : item.cor}\"></md-icon><span class=\"title\">{{item.descricao}}</span></md-button></div></div><div \nlayout=\"column\" flex ng-if=\" vm.progressoFiltrarAtendimentos\" layout-align=\"center center\" class=\"mt-50\">\n<md-progress-circular class=\"md-accent\" md-mode=\"indeterminate\"></md-progress-circular></div><div layout=\"column\" flex \nng-if=\" !vm.progressoFiltrarAtendimentos\"><div \nclass=\"md-padding md-background-bg md-whiteframe-1dp fullpage-datatable\"><table \nclass=\"dataTable row-border hover tabela\" datatable=\"ng\" dt-options=\"vm.dtOptionsAtendimentosVinculados\"><thead><tr><th\n class=\"secondary-text\" style=\"width: 55px\"><div class=\"table-header\"><span class=\"column-title\">Ação</span></div></th>\n<th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Código</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Ano</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Cliente</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Solução</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Dias sem Contato</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Data Conclusão</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Assunto</span></div></th><th \nclass=\"th-vazio\"></th></tr></thead><tbody><tr ng-repeat=\"atendimentoVinculado in vm.atendimentosVinculadosExibir\"><td \nclass=\"button-icone-cor-azul\"><i class=\"icon-pencil s16 icone-cor-padrao\" style=\"margin-left: 15px\" \nng-click=\"vm.controleForm.emProgresso || vm.metodos.editar(atendimentoVinculado)\" \nng-disabled=\"vm.controleForm.emProgresso\"></i></td><td class=\"border-left border-right h3 text-center\" \nng-class=\"{\'item-aberto\': atendimentoVinculado.status == 1 ,\r\n          \'item-finalizado\': atendimentoVinculado.status == 2}\">\n{{atendimentoVinculado.codigo}}</td><td class=\"border-right border-right h3 text-center\" \nng-class=\"{\'item-aberto\': atendimentoVinculado.status == 1,\r\n          \'item-finalizado\': atendimentoVinculado.status == 2}\">\n{{atendimentoVinculado.ano}}</td><td>{{atendimentoVinculado.cliente}}</td><td>{{atendimentoVinculado.descricao}}</td>\n<td ng-if=\"atendimentoVinculado.status == 2\" class=\"text-center\">-</td><td ng-if=\"atendimentoVinculado.status == 2\" \nclass=\"text-center\">-</td><td ng-if=\"atendimentoVinculado.status == 1\" class=\"text-center\">\n{{atendimentoVinculado.quantidadeDiasSemContato}}</td><td ng-if=\"atendimentoVinculado.status == 1\" class=\"text-center\">\n{{atendimentoVinculado.dataPrevisaoFechamento | date:\'dd/MM/yyyy\'}}</td><td ng-hide=\"true\">\n{{atendimentoVinculado.status}}</td><td class=\"\">{{atendimentoVinculado.assunto}}</td></tr></tbody></table></div></div>\n</form></div>");
$templateCache.put("app/main/atendimento/processamento/atualizacoes-pendentes/atualizacoes-pendentes.html","<div layout=\"column\" flex id=\"atendimento-atualizacoes-pendentes\" style=\"height: 100%\"><header-padrao \ntranslate-nome=\"Atualizações pendentes\" ng-utiliza-pesquisa=\"false\"></header-padrao><div class=\"button-float\" \nng-hide=\"vm.squadUsuarioLogado.length === 1\"><md-button class=\"md-primary icon-filter-outline md-fab\" \naria-label=\"Abrir filtro\" ng-click=\"vm.metodos.abrirFiltro()\"></md-button></div><md-sidenav \nng-hide=\"vm.squadUsuarioLogado.length === 1\" class=\"sidenav md-sidenav-right\" \nmd-component-id=\"filtro-atualizacoes-pendentes\" md-whiteframe=\"4\" \nui-view=\"atualizacoes-pendentes-sidenav@app.atendimento_processamento_atualizacoespendentes\" ms-scroll \nms-sidenav-helper></md-sidenav><div style=\"padding: 15px; height: 100%\" class=\"content\" \nui-view=\"atualizacoes-pendentes-tabela\"></div></div>");
$templateCache.put("app/main/cadastro-menu/views/dialogs/cadastro-menu-dialog.html","<md-dialog id=\"cadastro-menu-dialog\" class=\"dialogo-padrao\" aria-label=\"Dialog\"><form name=\"vm.form\" \nclass=\"md-inline-form\" novalidate><md-toolbar class=\"md-accent md-tall\" layout=\"column\"><div \nclass=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\">\n{{vm.titulo}}</span><md-button class=\"md-icon-button\" ng-click=\"vm.metodos.fecharDialog()\" aria-label=\"Fechar dialog\" \ntranslate translate-attr-aria-label=\"MENU.FECHAR_DIALOG\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button>\n</div></md-toolbar><div layout=\"column\" class=\"mt-10\" layout-align=\"center center\" \nng-show=\"vm.preloader.requisicaoSolicitada && !vm.baixandoArquivos\"><span class=\"font-weight-500\">\n{{vm.preloader.mensagemPreloader}}</span><md-progress-circular md-mode=\"indeterminate\" md-diameter=\"30\" \nclass=\"md-accent\"></md-progress-circular></div><md-dialog-content><div layout-gt-xs=\"row\" layout-xs=\"row\">\n<md-input-container class=\"md-block\" flex-gt-sm=\"30\"><label translate=\"MENU.MENU_PAI\"></label><md-select \nng-model=\"vm.menu.codigoMenuPai\" ng-required=\"true\" ng-change=\"vm.metodos.alterarMenuPai()\" \nng-disabled=\"vm.preloader.requisicaoSolicitada || vm.inserindo\" name=\"menuPai\"><md-option ng-value=\"menuPai.codigo\" \nng-repeat=\"menuPai in vm.listaMenus\">{{menuPai.navegacao}}</md-option></md-select><div \nng-messages=\"vm.form.menuPai.$error\"><div ng-message=\"required\" translate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div>\n</div></md-input-container><md-input-container class=\"md-block\" flex><label translate=\"MENU.NAVEGACAO\"></label><input \ntype=\"text\" ng-model=\"vm.menu.navegacao\" ng-keydown=\"vm.metodos.verificarCampoNavegacao($event)\" \nng-disabled=\"vm.preloader.requisicaoSolicitada\" name=\"navegacao\" mascara-texto-campo-estado-navegacao-tipo-caixa \naceita-ponto mascara-tamanho-campo=\"100\" validador-navegacao=\"vm.menuPaiSelecionado.navegacao.length+1\" \nng-required=\"true\" md-maxlength=\"100\"><div ng-messages=\"vm.form.navegacao.$error\"><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div><div ng-message=\"menuIgualAoMenuPai\">\n{{\'MENU.VALIDADOR_MENU_IGUAL_AO_MENU_PAI\' | translate}} {{vm.menuPaiSelecionado.navegacao}}.novomenu</div></div>\n</md-input-container></div><div layout-gt-xs=\"row\" layout-xs=\"row\"><md-input-container class=\"md-block\" flex=\"50\">\n<label translate=\"MENU.TITULO\"></label><input type=\"text\" ng-model=\"vm.menu.menuDetalhe.titulo\" \nng-disabled=\"vm.preloader.requisicaoSolicitada\" ng-keydown=\"vm.metodos.previnirEspaco()\" name=\"titulo\" \nmascara-tamanho-campo=\"50\" md-maxlength=\"50\" ng-required=\"true\"><div ng-messages=\"vm.form.titulo.$error\"><div \nng-message=\"required\" translate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container>\n<md-input-container class=\"md-block\" flex=\"50\"><label translate=\"MENU.ICONE\"></label><input type=\"text\" \nng-model=\"vm.menu.menuDetalhe.icone\" ng-disabled=\"vm.preloader.requisicaoSolicitada\" \nng-keydown=\"vm.metodos.previnirEspaco()\" name=\"icone\" mascara-tamanho-campo=\"50\" md-maxlength=\"50\">\n</md-input-container></div><div layout-gt-xs=\"row\" layout-xs=\"row\"><md-input-container class=\"md-block\" flex><label \ntranslate=\"MENU.ESTADO\"></label><input type=\"text\" ng-model=\"vm.menu.menuDetalhe.estado\" \nng-disabled=\"vm.preloader.requisicaoSolicitada || vm.menu.subMenus.length > 0 || vm.menu.menuDetalhe.grupo\" \nname=\"estado\" mascara-texto-campo-estado-navegacao-tipo-caixa aceita-ponto aceita-underline \nmascara-tamanho-campo=\"100\" md-maxlength=\"100\"></md-input-container></div><div layout-gt-xs=\"row\" layout-xs=\"row\">\n<md-input-container class=\"md-block\" flex=\"10\"><label translate=\"MENU.PESO\"></label><input type=\"text\" \nmascara-numeros=\"3\" ng-model=\"vm.menu.menuDetalhe.peso\" ng-required=\"true\" \nng-disabled=\"vm.preloader.requisicaoSolicitada\" name=\"peso\"><div ng-messages=\"vm.form.peso.$error\"><div \nng-message=\"required\" translate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container>\n<md-input-container class=\"md-block\" flex-offset=\"5\"><md-checkbox ng-model=\"vm.menu.menuDetalhe.grupo\" \nng-disabled=\"vm.preloader.requisicaoSolicitada || vm.menu.menuDetalhe.estado\" aria-label=\"Grupo\" name=\"grupo\"><span \ntranslate=\"MENU.GRUPO\">Grupo</span></md-checkbox></md-input-container></div></md-dialog-content><md-dialog-actions \nlayout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><md-button \ntype=\"submit\" ng-click=\"vm.metodos.salvar(vm.menu, $event)\" class=\"send-button md-accent md-raised\" \nng-disabled=\"vm.form.$invalid || vm.form.$pristine || vm.preloader.requisicaoSolicitada\" aria-label=\"SALVAR\" \ntranslate=\"MENU.SALVAR\" translate-attr-aria-label=\"MENU.SALVAR\">Salvar</md-button></div><div layout=\"row\"><md-button \nclass=\"md-icon-button\" ng-click=\"vm.metodos.excluir(vm.menu, $event)\" ng-hide=\"vm.inserindo\" \nng-disabled=\"vm.preloader.requisicaoSolicitada\" aria-label=\"Excluir\" translate \ntranslate-attr-aria-label=\"MENU.EXCLUIR\"><md-icon md-font-icon=\"icon-delete\"></md-icon></md-button></div>\n</md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/datamobil-ia/components/mensagens-recebidas/mensagens-recebidas.html","<div id=\"container-mensagem-recebida\"><div class=\"mensagem-recebida\"><p class=\"conteudo-mensagem m-0\" \nng-if=\"vm.mensagem.texto\">{{vm.mensagem.texto}}</p><div class=\"tabela-container\" ng-if=\"vm.mensagem.data\"><div \nclass=\"tabela-container\" ng-if=\"vm.mensagem.data\" style=\"min-width: 100%\"><tabela-resposta data=\"vm.mensagem.data\">\n</tabela-resposta></div></div></div><div class=\"botoes-acoes\"><md-button class=\"md-fab md-raised md-mini acao-aprovar\" \naria-label=\"Aprovar\" ng-click=\"vm.metodos.avaliar(\'positiva\')\" ng-disabled=\"vm.avaliando.carregando\">\n<md-progress-circular md-mode=\"indeterminate\" class=\"md-hue-2\" md-diameter=\"20px\" \nng-if=\"vm.avaliando.carregando && vm.avaliando.acao === \'positiva\'\"></md-progress-circular><md-icon \nng-if=\"!vm.avaliando.carregando || vm.avaliando.acao !== \'positiva\'\" style=\"color: rgba(0, 0, 0, 0.54)\" \nmd-svg-src=\"{{vm.respostaAvaliada === \'positiva\' ? \'assets/custom/thumbs-up-filled.svg\' : \'assets/custom/thumbs-up.svg\'}}\">\n</md-icon><md-tooltip md-autohidemd-delay=\"200\"><span>Resposta satisfatória</span></md-tooltip></md-button><md-button \nng-click=\"vm.metodos.avaliar(\'negativa\')\" class=\"md-fab md-raised md-mini acao-reprovar\" aria-label=\"Reprovar\" \nng-disabled=\"vm.avaliando.carregando\"><md-progress-circular md-mode=\"indeterminate\" class=\"md-hue-2\" \nmd-diameter=\"20px\" style=\"margin-left: 4px\" ng-if=\"vm.avaliando.carregando && vm.avaliando.acao === \'negativa\'\">\n</md-progress-circular><md-icon ng-if=\"!vm.avaliando.carregando || vm.avaliando.acao !== \'negativa\'\" \nstyle=\"color: rgba(0, 0, 0, 0.54)\" \nmd-svg-src=\"{{vm.respostaAvaliada === \'negativa\' ? \'assets/custom/thumbs-down-filled.svg\' : \'assets/custom/thumbs-down.svg\'}}\">\n</md-icon><md-tooltip md-autohidemd-delay=\"200\"><span>Resposta insatisfatória</span></md-tooltip></md-button><md-button\n ng-if=\"vm.mensagem.data\" ng-click=\"vm.metodos.download()\" class=\"md-fab md-raised md-mini acao-download\" \naria-label=\"Download\" ng-disabled=\"vm.baixandoRelatorio\"><md-progress-circular style=\"margin-left: 4px\" \nmd-mode=\"indeterminate\" class=\"md-hue-2\" md-diameter=\"20px\" ng-if=\"vm.baixandoRelatorio\"></md-progress-circular>\n<md-icon ng-if=\"!vm.baixandoRelatorio\" style=\"color: rgba(0, 0, 0, 0.54)\" md-svg-src=\"assets/custom/download.svg\">\n</md-icon><md-tooltip md-autohidemd-delay=\"200\"><span>Download</span></md-tooltip></md-button></div></div>");
$templateCache.put("app/main/datamobil-ia/components/lista-favoritos/lista-favoritos.html","<div id=\"lista-favoritos\"><div class=\"titulo-lista-favoritos\"><p>Seus favoritos</p></div><div class=\"lista-container\">\n<div class=\"item-favorito\" ng-repeat=\"favorito in vm.datamobilIaService.favoritos track by favorito.id\"><md-button \nclass=\"comando-favorito\" ng-click=\"vm.onComandoSelecionado({comando: favorito.comando}); $event.currentTarget.blur()\" \nng-disabled=\"vm.carregando\">{{favorito.titulo ? favorito.titulo : favorito.comando}}<md-tooltip md-direction=\"bottom\">\n{{favorito.titulo ? favorito.titulo : favorito.comando}}</md-tooltip></md-button><md-menu \nmd-position-mode=\"target-right target\" style=\"margin-right: -2px\"><md-button class=\"md-icon-button btn-acao\" \naria-label=\"Opções\" ng-click=\"$mdMenu.open($event)\"><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon></md-button>\n<md-menu-content width=\"2\"><md-menu-item><md-button ng-click=\"vm.metodos.adicionarEditarFavoritos(favorito, $event)\">\n<md-icon md-font-icon=\"icon-pencil\" md-menu-align-target></md-icon>Editar</md-button></md-menu-item><md-menu-item>\n<md-button ng-click=\"vm.metodos.removerFavorito(favorito, $event)\"><md-icon md-font-icon=\"icon-delete\"></md-icon>\nRemover</md-button></md-menu-item></md-menu-content></md-menu></div><div \nng-if=\"!vm.datamobilIaService.favoritos.length\" class=\"sem-favoritos\"><p>Você ainda não tem favoritos.</p></div></div>\n</div>");
$templateCache.put("app/main/datamobil-ia/components/mensagem-envio/mensagem-envio.html","<div id=\"container-mensagem-envio\"><div class=\"mensagem-envio\"><p class=\"mensagem-digitada m-0\">{{vm.mensagem.comando}}\n</p></div><div class=\"botoes-acoes\"><md-button class=\"md-fab md-raised md-mini acao-copiar\" aria-label=\"Copiar\" \nng-click=\"vm.metodos.copiarMensagem(vm.mensagem, $event)\"><md-icon ng-if=\"!vm.acaoCopiar\" \nstyle=\"color: rgba(0, 0, 0, 0.54)\" md-svg-src=\"assets/custom/copy.svg\"></md-icon><md-icon ng-if=\"vm.acaoCopiar\" \nstyle=\"color: rgba(0, 0, 0, 0.54)\" md-font-icon=\"icon-check-circle s16\"></md-icon><md-tooltip \nmd-autohidemd-delay=\"200\"><span>Copiar</span></md-tooltip></md-button><md-button \nclass=\"md-fab md-raised md-mini acao-favoritar\" aria-label=\"Favoritar\" \nng-click=\"vm.metodos.atualizarFavorito(vm.mensagem)\" ng-disabled=\"vm.atualizandoFavorito\"><md-progress-circular \nstyle=\"margin-left: 4.5px\" ng-if=\"vm.atualizandoFavorito\" class=\"md-accent\" md-diameter=\"20\" md-mode=\"indeterminate\">\n</md-progress-circular><md-icon ng-if=\"!vm.atualizandoFavorito && !vm.metodos.isFavorito(vm.mensagem)\" \nstyle=\"color: rgba(0, 0, 0, 0.54)\" md-font-icon=\"icon-star-outline s20\"></md-icon><md-icon \nng-if=\"!vm.atualizandoFavorito && vm.metodos.isFavorito(vm.mensagem)\" style=\"color: rgba(0, 0, 0, 0.54)\" \nmd-font-icon=\"icon-star s20\"></md-icon><md-tooltip md-autohidemd-delay=\"200\"><span \nng-if=\"!vm.metodos.isFavorito(vm.mensagem)\">Favoritar</span> <span ng-if=\"vm.metodos.isFavorito(vm.mensagem)\">\nRemover favorito</span></md-tooltip></md-button></div></div>");
$templateCache.put("app/main/inicio/views/sidenav/sidenav-inicio.html","<div id=\"sidenav-inicio\"><md-list><md-subheader class=\"md-no-sticky\">Setores</md-subheader><md-divider></md-divider>\n<div><md-list-item ng-repeat=\"setor in vm.setores\" ng-click=\"vm.metodos.irParaSetor(setor)\"><md-divider></md-divider>\n<p>{{setor.descricao}}</p><md-divider></md-divider></md-list-item></div></md-list></div>");
$templateCache.put("app/main/manutencao/dashboard/views/dashboard-form.html","<div id=\"dashboard-form\" class=\"md-background-bg md-whiteframe-1dp\" layout=\"column\" flex><div \nng-if=\"vm.ordensServico && !vm.requisicaoSolicitada && vm.mostrarDados\" layout=\"column\" layout=\"center center\"><div \nlayout=\"row\" layout-align=\"center\" flex=\"100\"><md-card class=\"cards-superior\" flex=\"25\"><md-card-header \nstyle=\"display: block\"><div class=\"titulo-card\" layout=\"row\" layout-align=\"space-between center\"><strong><span \nclass=\"textos-span\" style=\"font-size: 21px\">Ordens de serviço</span> </strong><i \nclass=\"icon-format-list-bulleted s24 icone-cor-padrao\" ng-click=\"vm.metodos.abrirDialogOrdensServicoPeriodo()\">\n<md-tooltip md-direction=\"top\"><label translate=\"Listar ordens de serviço\"></label></md-tooltip></i></div><hr \nclass=\"solid\"><md-card-header-text layout=\"row\" class=\"cards-superior-cabecalho\"><div layout=\"row\" flex=\"100\" \nlayout-align=\"center center\"><span>{{vm.totalizadores.quantidadesDeOrdemServico}}</span></div></md-card-header-text>\n</md-card-header></md-card><md-card class=\"cards-superior\" flex=\"25\"><md-card-header style=\"display: block\"><div \nclass=\"titulo-card\" layout=\"row\" layout-align=\"space-between center\"><strong><span class=\"textos-span\" \nstyle=\"font-size: 21px\">Clientes</span> </strong><i class=\"icon-format-list-bulleted s24 icone-cor-padrao\" \nng-click=\"vm.metodos.abrirDialogClientes()\"><md-tooltip md-direction=\"top\"><label translate=\"Listar clientes\"></label>\n</md-tooltip></i></div><hr class=\"solid\"><md-card-header-text layout=\"row\" class=\"cards-superior-cabecalho\"><div \nlayout=\"row\" flex=\"100\" layout-align=\"center center\"><span>{{vm.totalizadores.quantidadeClientes}}</span></div>\n</md-card-header-text></md-card-header></md-card><md-card class=\"cards-superior\" flex=\"25\"><md-card-header \nstyle=\"display: block\"><div class=\"titulo-card\" layout=\"row\" layout-align=\"space-between center\"><strong><span \nclass=\"textos-span\" style=\"font-size: 21px\">Equipamentos</span> </strong><i \nclass=\"icon-format-list-bulleted s24 icone-cor-padrao\" ng-click=\"vm.metodos.abrirDialogEquipamentos()\"><md-tooltip \nmd-direction=\"top\"><label translate=\"Listar equipamentos\"></label></md-tooltip></i></div><hr class=\"solid\">\n<md-card-header-text layout=\"row\" class=\"cards-superior-cabecalho\"><div layout=\"row\" flex=\"100\" \nlayout-align=\"center center\"><span>{{vm.totalizadores.quantidadeEquipamento}}</span></div></md-card-header-text>\n</md-card-header></md-card></div><div layout=\"row\" layout-align=\"center\" ng-if=\"vm.possuiOSFinalizada\" flex=\"100\">\n<md-card class=\"cards-inferior\" ng-repeat=\"card in vm.cards\" flex=\"15\"><md-card-header style=\"display: block\"><div \nclass=\"titulo-card\" layout=\"row\" layout-align=\"center center\"><span class=\"font-size-12 textos-span\">{{card.nome}}\n</span></div><hr class=\"solid\"><md-card-header-text layout=\"row\" class=\"cards-inferior-cabecalho\"><div layout=\"row\" \nflex=\"100\" layout-align=\"center center\"><span ng-if=\"card.codigo != 6\">{{card.valor}}</span> <span \nng-if=\"card.codigo == 6\" \nng-class=\"{\'margem-positiva\': card.valor >= 0,\r\n                                             \'margem-negativa\': card.valor < 0}\">\n{{card.valor}}%</span></div></md-card-header-text></md-card-header></md-card></div><div layout=\"row\" \nlayout-align=\"center center\" flex=\"100\"><ms-widget layout=\"row\" flex=\"100\"><ms-widget-front class=\"white-bg\"><div \nclass=\"ph-16 pv-8 border-bottom\" layout=\"row\"><div class=\"pv-8 h3 text-center titulo-grafico\" flex=\"100\">Por status\n</div></div><div layout=\"row\" layout-align=\"center center\" layout-wrap><div class=\"p-16\" flex=\"100\" \nlayout-align=\"center center\"><nvd3 class=\"h-420\" layout-align=\"center center\" options=\"vm.graficoPorStatus.options\" \ndata=\"vm.graficoPorStatus.data\"></nvd3></div></div></ms-widget-front></ms-widget><ms-widget layout=\"row\" flex=\"100\">\n<ms-widget-front class=\"white-bg\"><div class=\"ph-16 pv-8 border-bottom\" layout=\"row\"><div \nclass=\"pv-8 h3 text-center titulo-grafico\" flex=\"100\">Por tipo de serviço</div></div><div layout=\"row\" \nlayout-align=\"center center\" layout-wrap><div class=\"p-16\" flex=\"100\" layout-align=\"center center\"><nvd3 class=\"h-420\" \nlayout-align=\"center center\" options=\"vm.graficoPorTipoServico.options\" data=\"vm.graficoPorTipoServico.data\"></nvd3>\n</div></div></ms-widget-front></ms-widget></div></div><div class=\"button-float\" layout=\"row\" layout-align=\"end center\">\n<md-button ng-click=\"vm.toggleRight()\" ng-hide=\"vm.isOpenRight()\" \nclass=\"md-primary button-toogle icon-filter-outline md-fab\" aria-label=\"Fitrar\"></md-button></div><md-sidenav \nclass=\"md-sidenav-right md-whiteframe-4dp\" md-component-id=\"right\"><md-toolbar style=\"background-color: #039BE5\"><h1 \nclass=\"md-toolbar-tools\">Filtro</h1></md-toolbar><md-content layout-padding flex><form name=\"vm.form\" layout=\"column\">\n<fieldset><legend class=\"grp-legend\">Período</legend><md-radio-group ng-model=\"vm.filtro.tipoPesquisa\" \nng-change=\"vm.metodos.resetarFiltros()\" layout-gt-sm=\"row\" layout-xs=\"row\" style=\"padding-top: 0px\" layout-padding>\n<md-radio-button value=\"1\" aria-label=\"Abertura\"><label translate=\"Abertura\"></label></md-radio-button><md-radio-button\n value=\"2\" aria-label=\"Execução\"><label translate=\"Execução\"></label></md-radio-button></md-radio-group><div \nlayout=\"column\"><md-input-container md-block style=\"margin: 0px 0px 10px 0px\"><label>Inicial</label><md-datepicker \nng-model=\"vm.filtro.dataInicial\" ng-required=\"true\" name=\"dataInicial\" ng-mask=\"3?9/1?9/9999\" \nmd-max-date=\"vm.filtro.dataFinal\"></md-datepicker><div ng-messages=\"vm.form.dataInicial.$error\"><div \nng-message=\"valid\" translate=\"MENSAGEM_VALIDACAO.DATA_INVALIDA\"></div><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.DATA_OBRIGATORIA\"></div><div ng-message=\"maxdate\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_DATA_INICIAL\"></div></div></md-input-container><md-input-container md-block \nstyle=\"margin: 0px\"><label>Final</label><md-datepicker ng-model=\"vm.filtro.dataFinal\" name=\"dataFinal\" \nng-required=\"true\" ng-mask=\"3?9/1?9/9999\" md-min-date=\"vm.filtro.dataInicial\"></md-datepicker><div \nng-messages=\"vm.form.dataFinal.$error\"><div ng-message=\"valid\" translate=\"MENSAGEM_VALIDACAO.DATA_INVALIDA\"></div><div \nng-message=\"required\" translate=\"MENSAGEM_VALIDACAO.DATA_OBRIGATORIA\"></div><div ng-message=\"maxdate\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_DATA_INICIAL\"></div><div ng-message=\"mindate\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_DATA_FINAL\"></div></div></md-input-container></div></fieldset>\n<ms-selecinar-multi-valores tem-field-set=\"true\" texto-field-set=\"Cliente\" dados=\"vm.clienteComOrdemServico\" \nname-placeholder=\"Cliente\" mensagem-de-erro-do-formulario=\"RELATORIO_REAJUSTE.STATUS_OBRIGATORIO\" \npropriedade-para-a-exibicao-da-repeticao=\"nome\" limitar-width=\"true\" \nmodel-dados=\"vm.clienteComOrdemServicoSelecionado\" obrigatorio=\"false\"></ms-selecinar-multi-valores>\n<ms-selecinar-multi-valores tem-field-set=\"true\" texto-field-set=\"Empresa ativo\" dados=\"vm.empresaAtivo\" \nname-placeholder=\"Empresa ativo\" mensagem-de-erro-do-formulario=\"RELATORIO_REAJUSTE.STATUS_OBRIGATORIO\" \npropriedade-para-a-exibicao-da-repeticao=\"nome\" limitar-width=\"true\" model-dados=\"vm.empresaAtivoSelecionado\" \nobrigatorio=\"false\"></ms-selecinar-multi-valores><ms-selecinar-multi-valores tem-field-set=\"true\" \ntexto-field-set=\"Tipo serviço\" dados=\"vm.tipoServico\" name-placeholder=\"Tipo serviço\" \nmensagem-de-erro-do-formulario=\"RELATORIO_REAJUSTE.STATUS_OBRIGATORIO\" \npropriedade-para-a-exibicao-da-repeticao=\"descricao\" limitar-width=\"true\" model-dados=\"vm.tipoServicoSelecionado\" \nobrigatorio=\"false\"></ms-selecinar-multi-valores><ms-selecinar-multi-valores tem-field-set=\"true\" \ntexto-field-set=\"Status da OS\" dados=\"vm.status\" name-placeholder=\"Status da OS\" \nmensagem-de-erro-do-formulario=\"RELATORIO_REAJUSTE.STATUS_OBRIGATORIO\" \npropriedade-para-a-exibicao-da-repeticao=\"descricao\" limitar-width=\"true\" model-dados=\"vm.statusSelecionado\" \nobrigatorio=\"false\"></ms-selecinar-multi-valores><ms-selecinar-multi-valores tem-field-set=\"true\" \ntexto-field-set=\"Técnico responsável\" dados=\"vm.tecnicos\" name-placeholder=\"Téc. Responsável\" \nmensagem-de-erro-do-formulario=\"RELATORIO_REAJUSTE.STATUS_OBRIGATORIO\" \npropriedade-para-a-exibicao-da-repeticao=\"login\" limitar-width=\"true\" model-dados=\"vm.tecnicosSelecionado\" \nobrigatorio=\"false\"></ms-selecinar-multi-valores></form><div layout=\"row\" flex=\"100\"><div layout=\"row\" \nlayout-align=\"center center\" ng-if=\"vm.requisicaoSolicitada\" flex><md-progress-circular class=\"md-accent\" \nmd-diameter=\"30\" md-mode=\"indeterminate\"></md-progress-circular></div><div class=\"text-center\" flex><md-button \nclass=\"md-raised md-accent\" ng-click=\"vm.metodos.buscarOrdensServico(vm.filtro)\" \nng-disabled=\"vm.requisicaoSolicitada || vm.form.$invalid\" layout-align=\"center center\"><span>Filtrar</span></md-button>\n</div></div></md-content></md-sidenav></div>");
$templateCache.put("app/main/manutencao/dashboard/views/dashboard.html","<div id=\"dashboard\" class=\"page-layout simple tabbed\" layout=\"column\"><header-padrao translate-nome=\"Dashboard\" \nng-utiliza-pesquisa=\"false\"></header-padrao><div class=\"content\"><div ui-view=\"dashboard-form\"></div></div></div>");
$templateCache.put("app/main/manutencao/ordem-servico/views/ordem-servico-form.html","<form name=\"vm.form\"><div class=\"div-cards\" layout=\"row\"><md-card class=\"tamanho-cards\" flex-gt-sm=\"33\">\n<md-card-title-text><span class=\"md-headline\">Ordens de serviços</span></md-card-title-text><md-content><div \nclass=\"scroll-OS\"><md-list flex><md-list-item class=\"md-3-line espacamento\" \nng-repeat=\"item in vm.ordens | orderBy:\'id\' :true\" ng-click=\"vm.metodos.pesquisarItensOs(item,$index)\" \nng-class=\"{\'selecionado\': vm.itemId == item.id,\'zebra\' : $index %2 == 0}\"><div class=\"md-list-item-text\" \nlayout=\"column\"><h4><strong>N° OS</strong>: {{ item.numero }}/{{item.ano}}</h4><h4><strong>Cliente</strong>\n: {{ item.clienteNome }}</h4><h4><strong>Prioridade</strong>: {{item.ordemServicoPrioridadeDescricao}}</h4></div>\n<md-button class=\"md-secondary tamanho-botao\" ng-click=\"vm.metodos.excluir(item,$index)\"><i \nclass=\"icon-delete s16 icone-cor-padrao ml-1\"><md-tooltip><label>Deletar</label></md-tooltip></i></md-button><md-button\n class=\"md-secondary tamanho-botao\" ng-click=\"vm.metodos.abrirDialogOs($event, item, false)\"><i \nclass=\"icon-pencil s16 icone-cor-padrao ml-1\"><md-tooltip><label>Editar</label></md-tooltip></i></md-button><md-button \nclass=\"md-secondary tamanho-botao\" ng-click=\"vm.metodos.abrirDialogOs($event, item, true)\"><i \nclass=\"icon-open-in-new s16 icone-cor-padrao\"><md-tooltip><label>Visualizar</label></md-tooltip></i></md-button>\n</md-list-item></md-list></div></md-content><div class=\"div-botao-flutuante\"><md-button \nclass=\"add-event-button md-fab md-toolbar\" aria-label=\"Adicionar nota\" \nng-click=\"vm.metodos.abrirDialogOs($event,null,false)\" ng-disabled=\"vm.desabilitaBotaoOsConcluida\"><md-icon \nmd-font-icon=\"icon-plus\"></md-icon><md-tooltip><label>Adicionar OS</label></md-tooltip></md-button></div></md-card>\n<md-card class=\"tamanho-cards\" flex=\"33\" ng-show=\"vm.cardItem\"><md-card-title-text><span class=\"md-headline\">\nEquipamentos</span></md-card-title-text><md-content><div class=\"scroll-OS\"><md-list flex><md-list-item \nclass=\"md-3-line espacamento\" ng-repeat=\"item in vm.itens | orderBy:\'id\' :true\" ng-click=\"null\" \nng-class=\"{\'zebra\' : $index %2 == 0}\"><div class=\"md-list-item-text\" layout=\"column\" \nng-if=\"item.ordemServicoEquipamentoItemSerie == null\"><h4><strong>N° Série</strong>\n: {{item.equipamentoNotaItemDetalheSerie}}</h4><h4><strong>N° IMEI</strong>: {{item.equipamentoNotaItemDetalheImei}}\n</h4><h4><strong>Equipamento</strong>: {{item.equipamentoNotaItemDetalheDescricao}}</h4></div><div \nclass=\"md-list-item-text\" layout=\"column\" ng-if=\"item.ordemServicoEquipamentoItemSerie != null\"><h4><strong>N° Série\n</strong>: {{item.ordemServicoEquipamentoItemSerie}}</h4><h4><strong>N° IMEI</strong>\n: {{item.ordemServicoEquipamentoItemImei}}</h4><h4><strong>Equipamento</strong>\n: {{item.ordemServicoEquipamentoItemDescricao}}</h4></div><md-button \nclass=\"md-secondary md-icon-button siglasVis tamanho-botao\" \nng-click=\"vm.metodosItens.abrirDialogItens($event, item,true)\"><i class=\"icon-open-in-new s20 icone-cor-padrao\">\n<md-tooltip><label>Visualizar</label></md-tooltip></i></md-button><md-button \nclass=\"md-secondary md-icon-button siglasPro tamanho-botao\" \nng-class=\"{\'possuiPreechimento\' : item.procedimentos.length > 0 || vm.validaEquipamentos}\" \nng-click=\"vm.metodosItens.abrirDialogProcedimentos($event, item)\"><i class=\"icon-briefcase-checked s20 cor-padrao\" \nng-class=\"{\'iconeProcedimento\' : item.procedimentos.length > 0 || vm.validaEquipamentos}\"></i><md-tooltip><span>\nProcedimentos</span></md-tooltip></md-button><md-button class=\"md-secondary md-icon-button siglas tamanho-botao\" \nng-class=\"{\'possuiPreechimento\' : (item.execucao != undefined && item.execucao.dataFim != undefined)|| vm.validaEquipamentos}\" \nng-click=\"vm.metodosItens.abrirDialogExecucao($event, item)\"><i \nclass=\"icon-checkbox-marked-circle-outline s20 cor-padrao\" \nng-class=\"{\'iconeProcedimento\' : (item.execucao.dataInicio != undefined && item.execucao.dataFim != undefined) || vm.validaEquipamentos}\">\n</i><md-tooltip><span>Execução</span></md-tooltip></md-button></md-list-item></md-list></div></md-content><div \nclass=\"div-botao-flutuante\"><md-button class=\"add-event-button md-fab md-toolbar botao-item\" \naria-label=\"Adicionar equipamento\" ng-click=\"vm.metodosItens.abrirDialogItens($event,null,false)\" \nng-disabled=\"vm.desabilitaBotaoOsConcluida\"><md-icon md-font-icon=\"icon-plus\"></md-icon><md-tooltip><label>\nAdicionar equipamento</label></md-tooltip></md-button></div></md-card><md-card class=\"tamanho-cards\" flex=\"33\" \nng-show=\"vm.mostarEnvio\" style=\"position: relative\"><md-card-title-text><span class=\"md-headline\">Envio/Valor</span> <i\n class=\"icon-alert-circle s24\" style=\"color: yellow\" ng-if=\"vm.flagValor\"><md-tooltip>\nValor total do procedimento não atingido.</md-tooltip></i></md-card-title-text><md-content><div class=\"scroll-OS\" \nstyle=\"position: relative\"><md-list flex><div class=\"md-3-line espacamento\" ng-model=\"vm.ordemServicoEnvio\" \nng-click=\"null\" ng-class=\"{\'zebra\' : $index %2 == 0}\" ng-if=\"vm.mostralistaEnvio\"><div class=\"md-list-item-text-h4\" \nlayout=\"column\"><h3 class=\"envio-titulo\">Envio</h3><h4><strong>Envio</strong>\n: {{vm.ordemServicoEnvio.dataEnvio | date:\'dd/MM/yyyy\'}}</h4><h4><strong>Recebimento</strong>\n: {{vm.ordemServicoEnvio.dataRecebimento | date:\'dd/MM/yyyy\'}}</h4><h4><strong>Tipo envio</strong>\n: {{vm.ordemServicoEnvio.tipoEnvio[0].descricao}}</h4><h4><strong>Código postagem</strong>\n: {{vm.ordemServicoEnvio.codigoPostagem}}</h4><h4><strong>Nota saída</strong>: {{vm.ordemServicoEnvio.notaSaida}}</h4>\n<div layout=\"row\" \nstyle=\"align-items: center; \r\n                                            padding: 0em .8em; \r\n                                            height: 25px; \r\n                                            white-space: nowrap\">\n<div flex=\"35\" style=\"display: contents\"><p><strong style=\"font-size: 1.4rem\">Recebido por:</strong></p></div><div \nstyle=\"max-width: 50px; \r\n                                                display: contents; \r\n                                                white-space: nowrap\" \nflex=\"65\"><p style=\"font-size: 1.4rem; \r\n                                                  margin-left: 5px\">\n{{vm.ordemServicoEnvio.recebidoPor}}</p></div></div><h4><strong>Recebido</strong>: {{vm.recebido}}</h4></div>\n<md-divider style=\"margin: 10px 0px\"></md-divider></div><div class=\"md-3-line espacamento\" \nng-model=\"vm.ordemServicoValor\" ng-click=\"null\" ng-if=\"vm.mostralistaValor\"><div class=\"md-list-item-text-h4\" \nlayout=\"column\"><h3 class=\"envio-titulo\">Valor</h3><h4><strong>Cod. Ordem serviço</strong>\n: {{vm.ordemServicoValor.ordemServicoId}}</h4><h4><strong>Valor peças</strong>\n: {{vm.ordemServicoValor.valorPeca | currency:\'R$ \'}}</h4><h4><strong>Valor procedimento</strong>\n: {{vm.ordemServicoValor.valorCusto | currency:\'R$ \'}}</h4><h4><strong>Valor frete</strong>\n: {{vm.ordemServicoValor.valorFrete | currency:\'R$ \'}}</h4><h4><strong>Valor custo</strong>\n: {{vm.ordemServicoValor.valorReal | currency:\'R$ \'}}</h4><h4><strong>Valor cobrado</strong>\n: {{vm.ordemServicoValor.valorCobrado | currency:\'R$ \'}}</h4></div><md-divider style=\"margin: 10px 0px\"></md-divider>\n</div></md-list></div></md-content><div class=\"div-botao-flutuante\"><md-button \nclass=\"add-event-button md-fab md-toolbar botao-envio\" aria-label=\"Adicionar envio\" \nng-click=\"vm.metodosItens.abrirDialogEnvio($event)\" ng-class=\"{\'botao-envio-inicial\': !vm.mostralistaEnvio}\" \nng-if=\"!vm.editando\" ng-disabled=\"vm.desabilitaBotaoOsConcluida\"><md-icon md-font-icon=\"icon-plus\"></md-icon>\n<md-tooltip><label>Adicionar envio</label></md-tooltip></md-button><md-button \nclass=\"add-event-button md-fab md-toolbar botao-envio\" aria-label=\"Adicionar envio\" \nng-click=\"vm.metodosItens.abrirDialogEnvio($event)\" ng-if=\"vm.editando\" ng-disabled=\"vm.desabilitaBotaoOsConcluida\">\n<md-icon md-font-icon=\"icon-pencil\"></md-icon><md-tooltip><label>Adicionar envio</label></md-tooltip></md-button>\n<md-button class=\"add-event-button md-fab md-toolbar botao-item-valores\" aria-label=\"Adicionar valores\" \nng-class=\"{\'botao-item-valores-amarelo\': vm.flagValor}\" ng-if=\"vm.mostralistaEnvio\" \nng-click=\"vm.metodosItens.abrirDialogValor($event)\" \nng-disabled=\"vm.desabilitaBotaoOsConcluida || vm.desabilitaBotaoOsValor\"><md-icon md-font-icon=\"icon-cash-usd\">\n</md-icon><md-tooltip><label>Atualizar valores</label></md-tooltip></md-button><md-button \nclass=\"add-event-button md-fab md-toolbar botao-item-os\" aria-label=\"Fechar O.S\" ng-if=\"vm.mostralistaEnvio\" \nng-click=\"vm.metodosItens.abrirFinalizarOs($event)\" \nng-disabled=\"!vm.datasFinaisPreenchidas || vm.flagValor || \r\n                                        vm.oSFinalizada || vm.desabilitaBotaoOsConcluida\">\n<md-icon md-font-icon=\"icon-cog-box\"></md-icon><md-tooltip><label>Finalizar O.S</label></md-tooltip></md-button></div>\n</md-card></div></form>");
$templateCache.put("app/main/manutencao/ordem-servico/views/ordem-servico.html","<div id=\"ordem-servico\" class=\"page-layout simple tabbed\" layout=\"column\"><header-padrao \ntranslate-nome=\"Ordem de serviço\" ng-utiliza-pesquisa=\"false\" pesquisar=\"vm.pesquisar\"></header-padrao><div \nclass=\"content\"><div ui-view=\"ordem-servico-form\"></div></div></div>");
$templateCache.put("app/main/manutencao/entrada/views/entrada-form.html","<div id=\"entrada-item\" class=\"md-background-bg md-whiteframe-1dp\" layout=\"column\" flex style=\"height: 72vh\"><form \nname=\"vm.form\" novalidate layout=\"column\" layout-gt-sm=\"row\" flex style=\"justify-content: center\"><md-card flex \nflex-gt-sm=\"30\"><md-card-title-text><span class=\"md-headline\">Dados de entrada</span></md-card-title-text><div flex>\n<md-content><md-input-container flex class=\"data-Nota\"><label>Data</label><md-datepicker \nng-model=\"vm.entrada.dataEntrada\" name=\"data\" mascara-conversor-string-para-data ng-mask=\"3?9/1?9/9999\" \nng-disabled=\"vm.adicionandoEquip\" ng-required=\"true\"></md-datepicker><div ng-messages=\"vm.form.data.$error\"><div \nng-message=\"valid\" translate=\"MENSAGEM_VALIDACAO.DATA_INVALIDA\"></div><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.DATA_OBRIGATORIA\"></div></div></md-input-container><md-input-container class=\"md-block\" \nflex=\"90\"><label translate=\"Nota de entrada\"></label><input type=\"text\" name=\"notaEntrada\" mascara-tamanho-campo=\"30\" \nmd-maxlength=\"30\" ng-model=\"vm.entrada.notaFiscalEntrada\" ng-disabled=\"vm.adicionandoEquip\" ng-required=\"true\"><div \nng-messages=\"vm.form.notaEntrada.$error\"><div ng-message=\"required\" translate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\">\n</div></div></md-input-container><md-input-container class=\"md-block\" flex=\"90\"><label translate=\"Nota de saída\">\n</label><input type=\"text\" mascara-tamanho-campo=\"30\" md-maxlength=\"30\" name=\"notaSaida\" \nng-disabled=\"vm.adicionandoEquip\" ng-model=\"vm.entrada.notaFiscalSaida\"></md-input-container><div layout=\"row\" flex>\n<md-autocomplete flex=\"85\" md-input-name=\"cliente\" md-no-cache=\"true\" ng-required=\"true\" \nng-blur=\"vm.metodos.configuraAutoCompleteClienteOnBlur()\" md-selected-item=\"vm.clienteSelecionadoDialogEdicao\" \nmd-selected-item-change=\"vm.metodos.alterarItemSelecionadoAutoCompleteCliente(item)\" \nmd-search-text=\"vm.textoDePesquisaAutoCompleteCliente\" \nmd-items=\"item in vm.metodos.pesquisarAutoCompleteCliente(vm.textoDePesquisaAutoCompleteCliente)\" \nmd-item-text=\"item.codigo + \' - \' + item.nome\" md-autoselect md-floating-label=\"Cliente\"><md-item-template><span \nmd-highlight-text=\"vm.textoDePesquisaAutoCompleteCliente\">{{item.codigo}} - {{item.nome}}</span></md-item-template>\n<md-not-found><label>Não foi encontrado nenhum Cliente.</label></md-not-found><div \nng-messages=\"vm.form.cliente.$error\"><div ng-message=\"required\" translate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div>\n</div></md-autocomplete><div class=\"pt-16 pl-2\" flex><i class=\"icon-account-box s32 icone-cor-padrao\" \nng-click=\"vm.metodos.abrirCadastroCliente(vm.clienteSelecionadoDialogEdicao)\"><md-tooltip md-autohide>\nVisualizar cadastro do cliente</md-tooltip></i></div></div></md-content><md-button \nclass=\"add-event-button md-fab md-toolbar botaoOSEditar\" ng-click=\"vm.metodos.editarNota(vm.entrada)\" \nng-if=\"vm.cadastrarItens && vm.entradas.length > 0;\" aria-label=\"Editar\"><md-icon md-font-icon=\"icon-pencil\"></md-icon>\n<md-tooltip md-direction=\"top\"><label>Editar</label></md-tooltip></md-button><md-button \nclass=\"add-event-button md-fab md-toolbar botaoOS\" ng-click=\"vm.metodos.cadastrarItens(vm.entrada.notaFiscalEntrada)\" \nng-if=\"!vm.cadastrarItens;\" \nng-disabled=\"vm.entrada.dataEntrada == undefined || vm.entrada.notaFiscalEntrada ==undefined || vm.form.data.$error.valid\r\n                    || vm.clienteSelecionadoDialogEdicao == undefined\" \naria-label=\"Avançar\"><md-icon md-font-icon=\"icon-arrow-right\"></md-icon><md-tooltip md-direction=\"top\"><label>Avançar\n</label></md-tooltip></md-button><md-button class=\"add-event-button md-fab md-toolbar botaoOSAdicionar\" \nng-class=\"{\'botaoOS\': vm.entradas.length <= 0}\" ng-click=\"vm.metodos.voltar()\" ng-if=\"vm.cadastrarItens;\" \naria-label=\"Avançar\"><md-icon md-font-icon=\"icon-plus-one\"></md-icon><md-tooltip md-direction=\"top\"><label>\nAdicionar entrada</label></md-tooltip></md-button></div></md-card><md-card flex flex-gt-sm=\"30\" layout=\"column\" \nng-show=\"vm.cadastrarItens\"><md-card-title-text><span class=\"md-headline\" layout-align=\"center center\">Equipamentos\n</span></md-card-title-text><div class=\"shortcut-loader\" layout=\"row\" layout-align=\"center center\" \nng-if=\"vm.requisicaoSolicitada\"><md-progress-circular class=\"md-accent\" md-diameter=\"20\" md-mode=\"indeterminate\">\n</md-progress-circular></div><div style=\"overflow: scroll\" layout=\"column\" flex><md-content><md-list flex><md-list-item\n class=\"md-3-line\" ng-repeat=\"item in vm.entradas\" style=\"box-shadow: 10px 1px 0px lightgrey\" \nng-class=\"{\'zebra\' : $index %2 == 0}\" ng-click=\"vm.metodos.listarDetalhesPorNotaSaida(item.notaFiscalSaida)\"><div \nclass=\"md-list-item-text\" layout=\"column\"><h4><strong>N° Série:</strong>: {{item.numeroSerie}}</h4><h4><strong>IMEI\n</strong>: {{item.imei}}</h4><h4><strong>Equipamento</strong>: {{item.equipamentoDescricao}}</h4></div><md-button \nclass=\"md-secondary tamanho-botao\" ng-click=\"vm.metodos.excluir(item)\"><i \nclass=\"icon-delete s16 icone-cor-padrao ml-1\"><md-tooltip><label>Deletar</label></md-tooltip></i></md-button><md-button\n class=\"md-secondary tamanho-botao\" ng-click=\"vm.metodos.dialogEquipamentoItemEditar(item)\"><i \nclass=\"icon-pencil s16 icone-cor-padrao ml-1\"><md-tooltip><label>Editar</label></md-tooltip></i></md-button>\n</md-list-item></md-list></md-content><md-button class=\"add-event-button md-fab md-toolbar botaoOSItem\" \nng-click=\"vm.metodos.dialogEquipamentoItem(vm.entrada)\" aria-label=\"Avançar\"><md-icon md-font-icon=\"icon-plus\">\n</md-icon><md-tooltip md-direction=\"top\"><label>Adicionar</label></md-tooltip></md-button></div></md-card></form></div>");
$templateCache.put("app/main/manutencao/entrada/views/entrada-tabela.html","<div layout=\"column\" flex><div class=\"md-padding md-background-bg md-whiteframe-1dp fullpage-datatable\" \nlayout=\"column\" flex><table class=\"dataTable row-border hover\" id=\"datatable-equipamentoItem\" width=\"100%\"><thead><tr>\n<th>Ação</th><th>Equipamento</th><th>Número série</th><th>IMEI</th><th>Nota entrada</th><th>Nota Saída</th></tr>\n</thead></table></div></div>");
$templateCache.put("app/main/manutencao/entrada/views/entrada.html","<div id=\"entrada\" class=\"page-layout simple tabbed\" layout=\"column\"><header-padrao translate-nome=\"Entrada\" \nng-utiliza-pesquisa=\"false\" pesquisar=\"vm.pesquisar\"></header-padrao><div class=\"content\"><div ui-view=\"entrada-form\">\n</div></div><div ui-view=\"entrada-tabela\" ng-if=\"vm.controleForm.listarTodasEntidades\"></div></div>");
$templateCache.put("app/main/mensageiro/dialogs/enviar-mensagem/enviar-mensagem-dialog.html","<md-dialog class=\"compose-dialog\" aria-label=\"New Message\"><form ng-submit=\"vm.metodos.enviarMensagem()\" \nname=\"vm.form\" class=\"md-inline-form\" novalidate><md-toolbar class=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" \nlayout=\"row\" layout-align=\"space-between center\"><span class=\"title\">{{vm.tituloDialog}}</span><md-button \nclass=\"md-icon-button\" ng-click=\"vm.metodos.closeDialog()\" aria-label=\"Close dialog\" tranlate \ntranslate-aria-label=\"MAIL.CLOSE_DIALOG\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar>\n<md-progress-linear class=\"md-accent\" ng-show=\"vm.enviandoMensagem\" md-mode=\"indeterminate\"></md-progress-linear>\n<md-dialog-content ms-scroll><div class=\"md-block\" \nng-include=\"\'app/main/mensageiro/views/info-contato-cadastro/info-contato-cadastro.html\'\"></div><div \nng-hide=\"vm.respostaDeMensagem\"><fieldset flex ng-show=\"vm.model.colaboradoresSelecionados.length\"><legend \ntranslate=\"MAIL.PRIORIDADE\">Prioridade</legend><md-radio-group name=\"prioridadeMensagem\" \nng-model=\"vm.model.prioridadeMensagem\" layout-md=\"row\" layout-padding><md-radio-button value=\"1\" \naria-label=\"MAIL.DEPARTAMENTO\"><label>Baixa</label></md-radio-button><md-radio-button value=\"2\" \naria-label=\"MAIL.COLABORADORES\"><label>Média</label></md-radio-button><md-radio-button value=\"3\" \naria-label=\"MAIL.COLABORADORES\"><label>Alta</label></md-radio-button><md-radio-button value=\"4\" \naria-label=\"MAIL.COLABORADORES\"><label>Urgente</label></md-radio-button></md-radio-group></fieldset></div><br>\n<md-input-container class=\"md-block\"><label translate=\"MAIL.SUBJECT\">Subject</label><input name=\"assunto\" \nmd-maxlength=\"vm.metodos.retornaTamanhoAssunto()\" maxlength=\"{{vm.metodos.retornaTamanhoAssunto()}}\" required \nng-required=\"true\" ng-disabled=\"vm.respostaDeMensagem || vm.encaminhamentoDeMensagem\" ng-model=\"vm.model.assunto\" \ntype=\"text\"><div ng-messages=\"vm.form.assunto.$error\"><div ng-message=\"required\" translate=\"MAIL.ASSUNTO_OBRIGATORIO\">\n</div></div></md-input-container><div ng-hide=\"vm.model.mensagem\" md-colors=\"{background: \'RED\'}\"><span \nstyle=\"padding: 10px\">Mensagem obrigatória.</span></div><text-angular name=\"campoMensagem\" id=\"campo-mensagem\" \nng-model=\"vm.model.mensagem\" \nta-toolbar=\"[[\'h1\', \'h2\', \'h3\', \'quote\', \'bold\', \'italics\', \'underline\', \'strikeThrough\', \'ul\', \'ol\', \'redo\', \'undo\', \'justifyLeft\', \'justifyCenter\', \'justifyRight\', \'indent\', \'outdent\']]\" \nautofocus></text-angular><text-angular style=\"min-height: 100px\" ng-if=\"vm.exibirHistorico\" id=\"campo-historico\" \nta-disabled=\"true\" ta-toolbar=\"[[]]\" ng-model=\"vm.historicoMensagens\" class=\"mt-10\"></text-angular></md-dialog-content>\n<md-dialog-actions layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\">\n<md-button \nng-disabled=\"vm.form.$invalid || vm.form.$error.length > 0 || vm.model.assunto.trim() == \'\' || vm.enviandoMensagem || !vm.model.mensagem\" \ntype=\"submit\" class=\"send-button md-accent md-raised\" id=\"submit\" value=\"Submit\" aria-label=\"Send\" \ntranslate=\"MAIL.SEND\" translate-attr-aria-label=\"MAIL.SEND\">SEND</md-button></div><div layout=\"row\"><md-button \nng-click=\"vm.metodos.limparColaboradoresSelecionados()\" class=\"md-icon-button\" aria-label=\"Delete\" \ntranslate-attr-aria-label=\"MAIL.LIMPAR_COLABORADORES_SELECIONADOS\"><md-icon md-font-icon=\"icon-account-remove\">\n</md-icon><md-tooltip><span translate=\"MAIL.LIMPAR_COLABORADORES_SELECIONADOS\"></span></md-tooltip></md-button>\n<md-button ng-show=\"vm.metodos.habilitaBotaoLimparCampos()\" ng-click=\"vm.metodos.limparCampos(false)\" \nclass=\"md-icon-button\" aria-label=\"Delete\" translate-attr-aria-label=\"MAIL.LIMPAR_CAMPOS\"><md-icon \nmd-font-icon=\"icon-backup-restore\"></md-icon><md-tooltip><span translate=\"MAIL.LIMPAR_CAMPOS\"></span></md-tooltip>\n</md-button></div></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/mensageiro/sidenavs/main/main-sidenav.html","<div class=\"header\" layout=\"column\" layout-align=\"space-between start\"><div class=\"logo\" layout=\"row\" \nlayout-align=\"start center\"><span class=\"logo-icon\"><md-icon md-font-icon=\"icon-email\"></md-icon></span><span \nclass=\"logo-text\" translate=\"MAIL.MAILBOX\">Mailbox</span></div></div><md-content ms-scroll class=\"content\" flex><div \nclass=\"compose-button\"><md-button class=\"md-accent md-raised\" aria-label=\"compose\" \nng-disabled=\"vm.carregandoMensagens\" ng-click=\"vm.dialogEnviar($event)\" ng-class=\"{\'disable\': vm.carregandoMensagens}\" \ntranslate=\"MAIL.COMPOSE\">COMPOSE</md-button></div><div class=\"navigation-simple\" layout=\"column\"><md-button \nclass=\"item\" aria-label=\"Caixa de entrada\" ng-repeat=\"folder in vm.folders\" ng-disabled=\"vm.carregandoMensagens\" \nng-click=\"vm.loadFolder(folder.name)\" ng-class=\"{\'selected\':vm.isFolderActive(folder.name)}\"><div layout=\"row\" \nlayout-align=\"start center\"><md-icon md-font-icon=\"{{folder.icon}}\" class=\"s16\"></md-icon><span class=\"title\">\n{{folder.title}}</span></div></md-button><div class=\"item subheader\"></div></div></md-content>");
$templateCache.put("app/main/mensageiro/views/info-contato-cadastro/info-contato-cadastro.html","<div id=\"info-contato-cadastro\" layout-flex=\"row\" class=\"md-block\"><fieldset flex><legend \ntranslate=\"MAIL.SELECIONE_DESTINATARIO\">Selecione</legend><div layout=\"row\" class=\"md-block\" \nng-if=\"vm.squadUsuarioLogado.length > 1\"><md-input-container class=\"md-block\" flex><label>Squads</label><md-select \nng-model=\"vm.model.squadCodigos\" name=\"squadCodigos\" ng-required=\"true\" ng-change=\"vm.metodos.onChangeSquad()\" \nmultiple=\"multiple\"><md-option ng-value=\"squad.codigo\" ng-repeat=\"squad in vm.squads track by squad.codigo\">\n{{squad.descricao}}</md-option></md-select><div ng-messages=\"vm.form.squadCodigos.$error\"><div ng-message=\"required\">\nCampo obrigatório</div></div></md-input-container></div><div ng-if=\"!vm.respostaDeMensagem\" layout=\"row\" \nclass=\"md-block\"><md-radio-group ng-model=\"vm.radioSelecaoContato\" layout-md=\"row\" \nng-disabled=\"!vm.model.squadCodigos.length || vm.emProgresso\" \nng-change=\"vm.metodos.ngChangeRadioGroupSelecaoContato(vm.radioSelecaoContato)\" layout-padding><md-radio-button \nvalue=\"departamento\" aria-label=\"MAIL.DEPARTAMENTO\"><label>Departamento</label></md-radio-button><md-radio-button \nvalue=\"colaboradores\" aria-label=\"MAIL.COLABORADORES\"><label>Colaboradores</label></md-radio-button><md-radio-button \nvalue=\"todos\" aria-label=\"MAIL.COLABORADORES\"><label>Todos</label></md-radio-button></md-radio-group></div><div \nng-if=\"!vm.respostaDeMensagem\" layout=\"row\" layout-align=\"center center\" \nng-show=\"vm.radioSelecaoContato === \'departamento\'\" class=\"tamanho-md-select\"><md-progress-circular \nng-if=\"vm.emProgresso\" md-mode=\"indeterminate\" md-diameter=\"20\" class=\"md-accent\"></md-progress-circular>\n<md-input-container class=\"md-block\" flex><label translate=\"MAIL.SELECIONE\">{{MAIL.SELECIONE}}</label><md-select \nng-model=\"vm.model.departamentosSelecionados\" name=\"selectDepartamento\" \nmd-on-open=\"vm.metodos.configurarSelectContatoDepartamento($event)\" ng-model-options=\"{trackBy: \'$value.codigo\'}\" \nng-disabled=\"vm.habilitarTodos || !vm.model.squadCodigos.length || vm.emProgresso\" multiple=\"multiple\">\n<md-select-header id=\"select-departamento\"><input ng-model=\"vm.termoProcuradoDepartamento\" type=\"search\" \nplaceholder=\"Pesquisar...\" class=\"md-text\"></md-select-header><md-option ng-value=\"itemContatoDepartamento\" \nng-disabled=\"vm.habilitarTodos\" ng-if=\"itemContatoDepartamento.usuarios.length > 0\" \nng-repeat=\"itemContatoDepartamento in vm.model.departamentos | orderBy:\'descricao\'\r\n          | filter:vm.termoProcuradoDepartamento track by itemContatoDepartamento.codigo \">\n{{itemContatoDepartamento.descricao}}</md-option></md-select><div ng-messages=\"vm.form.selectDepartamento.$error\"><div \nng-message=\"required\" translate=\"MAIL.DEPARTAMENTO_OBRIIGATORIO\"></div></div></md-input-container></div><div \nclass=\"select\" layout-gt-sm=\"row\" ng-show=\"vm.metodos.exibeSelectColaboradores()\" class=\"tamanho-md-select\">\n<md-input-container class=\"md-block\" flex><label translate=\"MAIL.SELECIONE\">{{MAIL.SELECIONE}}</label><md-select \nng-model=\"vm.model.colaboradoresSelecionados\" name=\"selectColaboradores\" \nmd-on-open=\"vm.metodos.configurarSelectColaboradores($event)\" ng-model-options=\"{trackBy: \'$value.codigo\'}\" \nng-disabled=\"vm.habilitarTodos || !vm.model.squadCodigos.length\" \nng-required=\"vm.metodos.defineSelectColaboradoresObrigatorio()\" multiple=\"multiple\"><md-select-header \nid=\"select-colaboradores\"><input name=\"colaboradoresSelecionados\" ng-model=\"vm.termoProcuradoColaborador\" \ntype=\"search\" placeholder=\"Pesquisar...\" class=\"md-text\"></md-select-header><md-option ng-value=\"itemColaborador\" \nng-repeat=\"itemColaborador in vm.model.colaboradores | orderBy:\'nome\'\r\n                  | filter:vm.termoProcuradoColaborador track by itemColaborador.codigo\">\n{{itemColaborador.nome}}</md-option></md-select><div ng-messages=\"vm.form.selectColaboradores.$error\"><div \nng-message=\"required\" translate=\"MAIL.COLABORADOR_OBRIGATORIO\"></div></div></md-input-container></div></fieldset>\n<fieldset flex ng-show=\"vm.model.colaboradoresSelecionados.length\"><legend translate=\"MAIL.CONTATO_SELECIONADO\">\nContatos Selecionados</legend><div class=\"fullpage-datatable scrollable\" ms-scroll style=\"height:200px\"><table \nclass=\"dataTable row-border hover\" dt-options=\"vm.dtOptions\" width=\"100%\"><thead><tr><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Código</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Nome</span></div></th><th></th></tr></thead><tbody \nng-repeat=\"contato in vm.model.colaboradoresSelecionados | orderBy:\'nome\' track by $index\"><tr><td>{{contato.codigo}}\n</td><td>{{contato.nome}}</td><td class=\"button-icone-cor-azul\"><i class=\"icon-delete s16 icone-cor-padrao\" \nng-click=\"vm.metodos.removerContatoSelecionado(contato)\"><md-tooltip><label \ntranslate=\"RELATORIO_CONTRATOS.REMOVER_CLIENTE\"></label></md-tooltip></i></td></tr></tbody></table></div></fieldset>\n</div>");
$templateCache.put("app/main/mensageiro/views/classic/classic-view.html","<div class=\"toolbar\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\">\n<div ng-if=\"vm.menuSelecionado != \'sent\'\"><label hide show-gt-xs for=\"menu-selecao\" ng-hide=\"vm.mensagemSelecionada\">\n{{vm.checkBoxSelecionado}}</label><md-menu id=\"menu-selecao\" class=\"select-menu\" ng-if=\"!vm.mensagemSelecionada\">\n<md-button class=\"md-icon-button\" ng-click=\"$mdOpenMenu($event)\" ng-disabled=\"vm.carregandoMensagens\" \naria-label=\"Filters\" translate translate-attr-aria-label=\"MAIL.FILTERS\"><md-icon md-font-icon=\"icon-menu-down\">\n</md-icon></md-button><md-menu-content width=\"3\"><md-menu-item><md-button ng-click=\"vm.selecionarMensagens(\'todas\')\" \naria-label=\"All\" ng-disabled=\"vm.carregandoMensagens\" translate=\"MAIL.TODAS\" translate-attr-aria-label=\"MAIL.ALL\">Todas\n</md-button></md-menu-item><md-menu-item><md-button ng-click=\"vm.selecionarMensagens(\'nenhuma\')\" aria-label=\"None\" \ntranslate=\"MAIL.NENHUMA\" translate-attr-aria-label=\"MAIL.NONE\">Nenhuma</md-button></md-menu-item><md-menu-item>\n<md-button ng-click=\"vm.selecionarMensagens(\'lido\')\" aria-label=\"Read\" ng-disabled=\"vm.carregandoMensagens\" \ntranslate=\"MAIL.LIDAS\" translate-attr-aria-label=\"MAIL.READ\">Lido</md-button></md-menu-item><md-menu-item><md-button \nng-click=\"vm.selecionarMensagens(\'naolido\')\" aria-label=\"Unread\" translate=\"MAIL.NAO_LIDAS\" \nng-disabled=\"vm.carregandoMensagens\" translate-attr-aria-label=\"MAIL.UNREAD\">Unread</md-button></md-menu-item>\n<md-menu-item><md-button ng-click=\"vm.selecionarMensagens(\'urgente\')\" aria-label=\"Important\" translate=\"MAIL.URGENTE\" \nng-disabled=\"vm.carregandoMensagens\" translate-attr-aria-label=\"MAIL.IMPORTANT\">Urgente</md-button></md-menu-item>\n<md-menu-item><md-button ng-click=\"vm.selecionarMensagens(\'alta\')\" aria-label=\"Not Important\" translate=\"MAIL.ALTA\" \nng-disabled=\"vm.carregandoMensagens\" translate-attr-aria-label=\"MAIL.NOT_IMPORTANT\">Alta</md-button></md-menu-item>\n<md-menu-item><md-button ng-click=\"vm.selecionarMensagens(\'media\')\" aria-label=\"Starred\" translate=\"MAIL.MEDIA\" \nng-disabled=\"vm.carregandoMensagens\" translate-attr-aria-label=\"MAIL.STARRED\">Média</md-button></md-menu-item>\n<md-menu-item><md-button ng-click=\"vm.selecionarMensagens(\'baixa\')\" aria-label=\"Unstarred\" translate=\"MAIL.BAIXA\" \nng-disabled=\"vm.carregandoMensagens\" translate-attr-aria-label=\"MAIL.UNSTARRED\">Baixa</md-button></md-menu-item>\n</md-menu-content></md-menu></div><md-button class=\"md-icon-button close-mensagem\" aria-label=\"Back\" \nng-click=\"vm.fecharMensagem()\" ng-if=\"vm.mensagemSelecionada\" translate translate-attr-aria-label=\"MAIL.BACK\"><md-icon \nmd-font-icon=\"icon-keyboard-backspace\"></md-icon></md-button><div class=\"action-buttons\" layout=\"row\" \nlayout-align=\"start center\" ng-show=\"vm.mensagensSelecionadas.length > 0\"><div class=\"divider-vertical\" \nng-show=\"vm.menuSelecionado != \'trash\' && vm.menuSelecionado != \'sent\'\"></div><md-button \nng-show=\"vm.menuSelecionado != \'trash\' && vm.menuSelecionado != \'sent\'\" class=\"md-icon-button\" aria-label=\"Arquivar\" \nng-disabled=\"vm.carregandoMensagens || vm.carregandoHistorico\" ng-click=\"vm.metodos.marcarComoArquivado()\" translate \ntranslate-attr-aria-label=\"MAIL.DELETE\"><md-icon md-font-icon=\"icon-archive\"></md-icon><md-tooltip><span \ntranslate=\"MAIL.ARQUIVAR\">Arquivar</span></md-tooltip></md-button><div class=\"divider-vertical\" \nng-show=\"vm.menuSelecionado == \'trash\'\"></div><md-button ng-show=\"vm.menuSelecionado == \'trash\'\" \nclass=\"md-icon-button\" ng-disabled=\"vm.carregandoMensagens || vm.carregandoHistorico\" aria-label=\"Desarquivar\" \nng-click=\"vm.metodos.marcarComodesarquivado()\" translate translate-attr-aria-label=\"MAIL.DESARQUIVAR\"><md-icon \nmd-font-icon=\"icon-backup-restore\"></md-icon><md-tooltip><span translate=\"MAIL.DESARQUIVAR\" ng-model=\"vm.desarquivar\">\nDesarquivar</span></md-tooltip></md-button><!--!DESARQUIVAR--><div ng-show=\"vm.selectedMailShowDetails\" \nclass=\"divider-vertical\"></div></div><div ng-show=\"vm.menuSelecionado != \'sent\'\" class=\"divider-vertical\"></div>\n<md-button class=\"md-icon-button\" aria-label=\"Recarregar\" ng-click=\"vm.metodos.recarregarPagina(vm)\" translate \nng-disabled=\"vm.carregandoMensagens || vm.carregandoHistorico\" translate-attr-aria-label=\"MAIL.DESARQUIVAR\"><md-icon \nmd-font-icon=\"icon-reload\"></md-icon><md-tooltip><span translate=\"MAIL.RECARREGAR_PAGINA\">Recarregar página</span>\n</md-tooltip></md-button></div><div layout=\"row\" layout-align=\"start center\" \nng-if=\"vm.mensagemSelecionada && vm.currentView != \'outlook\'\" ng-show=\"vm.mensagens.dados.mensagens.length > 0\">\n<md-button class=\"md-icon-button arrow\" aria-label=\"Mensagem Anterior\" \nng-disabled=\"!vm.mensagemAnterior || vm.carregandoHistorico\" \nng-click=\"vm.metodos.mensagemAnterior(vm.mensagemSelecionada)\" translate \ntranslate-attr-aria-label=\"MAIL.MENSAGEM_ANTERIOR\"><md-icon md-font-icon=\"icon-chevron-left\"></md-icon><md-tooltip>\n<span translate=\"MAIL.MENSAGEM_ANTERIOR\">Anterior</span></md-tooltip></md-button><span>{{vm.posicaoMensagem}}</span>\n<md-button class=\"md-icon-button arrow\" aria-label=\"Next\" \nng-click=\"vm.metodos.proximaMensagem(vm.mensagemSelecionada)\" \nng-disabled=\"!vm.proximaMensagem || vm.carregandoHistorico\" translate \ntranslate-attr-aria-label=\"MAIL.PROXIMA_MENSAGEM\"><md-icon md-font-icon=\"icon-chevron-right\"></md-icon><md-tooltip>\n<span translate=\"MAIL.PROXIMA_MENSAGEM\">Próxima mensagem</span></md-tooltip></md-button></div><div layout=\"row\" \nlayout-align=\"start center\" ng-if=\"!vm.mensagemSelecionada\"><span class=\"page-info\">{{vm.mensagens.dados.totalizador}}\n</span><md-button class=\"md-icon-button arrow\" aria-label=\"Previous\" \nng-show=\"vm.mensagens.dados.mensagens.length > 0 && vm.mensagensSelecionadas.length == 0\" \nng-disabled=\"vm.carregandoMensagens || vm.mensagens.dados.pagina == 1\" ng-click=\"vm.metodos.paginaAnterior($event)\" \ntranslate translate-attr-aria-label=\"MAIL.PREVIOUS\"><md-icon md-font-icon=\"icon-chevron-left\"></md-icon><md-tooltip>\n<span translate=\"MAIL.PREVIOUS\">Anterior</span></md-tooltip></md-button><span class=\"page-info\" hide-sm \nng-show=\"vm.mensagens.dados.mensagens.length > 0 && vm.mensagensSelecionadas.length == 0\">{{vm.pagina}}</span>\n<md-button class=\"md-icon-button arrow\" aria-label=\"Next\" \nng-show=\"vm.mensagens.dados.mensagens.length > 0 && vm.mensagensSelecionadas.length == 0\" \nng-click=\"vm.metodos.proximaPagina($event)\" ng-disabled=\"vm.carregandoMensagens || vm.mensagens.dados.fim\" translate \ntranslate-attr-aria-label=\"MAIL.NEXT\"><md-icon md-font-icon=\"icon-chevron-right\"></md-icon><md-tooltip><span \ntranslate=\"MAIL.NEXT\">Próximo</span></md-tooltip></md-button><div hide show-gt-sm><md-menu class=\"settings-menu\">\n<md-button class=\"md-icon-button\" ng-click=\"$mdOpenMenu($event)\" ng-disabled=\"vm.carregandoMensagens\" \naria-label=\"Settings\" translate translate-attr-aria-label=\"MAIL.SETTINGS\"><md-icon md-font-icon=\"icon-cog\"></md-icon>\n</md-button><md-menu-content width=\"3\"><md-menu-item><md-button ng-click=\"vm.changeView(\'classic\')\" \nng-disabled=\"vm.carregandoMensagens\"><md-icon md-font-icon=\"icon-checkbox-blank-outline\" \nng-if=\"vm.currentView !== \'classic\'\"></md-icon><md-icon md-font-icon=\"icon-checkbox-marked\" class=\"md-accent\" \nng-if=\"vm.currentView === \'classic\'\"></md-icon><span translate=\"MAIL.CLASSIC_VIEW\">Classic View</span></md-button>\n</md-menu-item><md-menu-item hide-xs><md-button ng-click=\"vm.changeView(\'outlook\')\" \nng-disabled=\"vm.carregandoMensagens\"><md-icon md-font-icon=\"icon-checkbox-blank-outline\" \nng-if=\"vm.currentView !== \'outlook\'\"></md-icon><md-icon md-font-icon=\"icon-checkbox-marked\" class=\"md-accent\" \nng-if=\"vm.currentView === \'outlook\'\"></md-icon><span translate=\"MAIL.OUTLOOK_VIEW\">Outlook View</span></md-button>\n</md-menu-item></md-menu-content></md-menu></div></div></div><div class=\"content-wrapper scrollable\" ms-scroll \nlayout=\"column\" flex><div class=\"content mensagem-detail\" ng-if=\"vm.mensagemSelecionada\" \nng-include=\"\'app/main/mensageiro/views/classic/detail/detail.html\'\" ms-scroll flex></div><div \nclass=\"content mensagem-list\" ng-if=\"!vm.mensagemSelecionada\" \nng-include=\"\'app/main/mensageiro/views/classic/list/list.html\'\" ms-scroll flex></div></div>");
$templateCache.put("app/main/mensageiro/views/outlook/outlook-view.html","<div class=\"toolbar\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\">\n<div ng-if=\"vm.menuSelecionado != \'sent\'\"><label hide show-gt-xs for=\"menu-selecao\">{{vm.checkBoxSelecionado}}</label>\n<md-menu id=\"menu-selecao\" name=\"menu-selecao-mensagens\" class=\"select-menu\"><md-button class=\"md-icon-button\" \nng-click=\"$mdOpenMenu($event)\" aria-label=\"Filters\" translate translate-attr-aria-label=\"MAIL.FILTERS\"><md-icon \nmd-font-icon=\"icon-menu-down\"></md-icon></md-button><md-menu-content width=\"3\"><md-menu-item><md-button \nng-click=\"vm.selecionarMensagens(\'todas\')\" aria-label=\"All\" translate=\"MAIL.TODAS\" \ntranslate-attr-aria-label=\"MAIL.ALL\">Todas</md-button></md-menu-item><md-menu-item><md-button \nng-click=\"vm.selecionarMensagens(\'nenhuma\')\" aria-label=\"None\" translate=\"MAIL.NENHUMA\" \ntranslate-attr-aria-label=\"MAIL.NONE\">Nenhuma</md-button></md-menu-item><md-menu-item><md-button \nng-click=\"vm.selecionarMensagens(\'lido\')\" aria-label=\"Read\" translate=\"MAIL.LIDAS\" \ntranslate-attr-aria-label=\"MAIL.READ\">Lido</md-button></md-menu-item><md-menu-item><md-button \nng-click=\"vm.selecionarMensagens(\'naolido\')\" aria-label=\"Unread\" translate=\"MAIL.NAO_LIDAS\" \ntranslate-attr-aria-label=\"MAIL.UNREAD\">Unread</md-button></md-menu-item><md-menu-item><md-button \nng-click=\"vm.selecionarMensagens(\'urgente\')\" aria-label=\"Important\" translate=\"MAIL.URGENTE\" \ntranslate-attr-aria-label=\"MAIL.IMPORTANT\">Urgente</md-button></md-menu-item><md-menu-item><md-button \nng-click=\"vm.selecionarMensagens(\'alta\')\" aria-label=\"Not Important\" translate=\"MAIL.ALTA\" \ntranslate-attr-aria-label=\"MAIL.NOT_IMPORTANT\">Alta</md-button></md-menu-item><md-menu-item><md-button \nng-click=\"vm.selecionarMensagens(\'media\')\" aria-label=\"Starred\" translate=\"MAIL.MEDIA\" \ntranslate-attr-aria-label=\"MAIL.STARRED\">Média</md-button></md-menu-item><md-menu-item><md-button \nng-click=\"vm.selecionarMensagens(\'baixa\')\" aria-label=\"Unstarred\" translate=\"MAIL.BAIXA\" \ntranslate-attr-aria-label=\"MAIL.UNSTARRED\">Baixa</md-button></md-menu-item></md-menu-content></md-menu></div><div \nclass=\"action-buttons\" layout=\"row\" layout-align=\"start center\" \nng-show=\"vm.mensagensSelecionadas.length > 0 || vm.mensagemSelecionada\" hide show-gt-xs><div \nng-show=\"vm.menuSelecionado != \'trash\' && vm.menuSelecionado != \'sent\'\" class=\"divider-vertical\"></div><md-button \nng-show=\"vm.menuSelecionado != \'trash\' && vm.menuSelecionado != \'sent\'\" class=\"md-icon-button\" aria-label=\"Delete\" \nng-click=\"vm.metodos.marcarComoArquivado()\" translate translate-attr-aria-label=\"MAIL.DELETE\"><md-icon \nmd-font-icon=\"icon-archive\"></md-icon><md-tooltip><span translate=\"MAIL.ARQUIVAR\">Arquivar</span></md-tooltip>\n</md-button><div ng-show=\"vm.menuSelecionado == \'trash\'\" class=\"divider-vertical\"></div><md-button \nng-show=\"vm.menuSelecionado == \'trash\'\" class=\"md-icon-button\" aria-label=\"Desarquivar\" \nng-click=\"vm.metodos.marcarComodesarquivado()\" translate translate-attr-aria-label=\"MAIL.DESARQUIVAR\"><md-icon \nmd-font-icon=\"icon-backup-restore\"></md-icon><md-tooltip><span translate=\"MAIL.DESARQUIVAR\" ng-model=\"vm.desarquivar\">\nDesarquivar</span></md-tooltip></md-button><!--!DESARQUIVAR--></div><div class=\"divider-vertical\" \nng-show=\"vm.menuSelecionado != \'sent\'\"></div><md-button class=\"md-icon-button\" aria-label=\"Recarregar\" \nng-click=\"vm.metodos.recarregarPagina(vm)\" translate translate-attr-aria-label=\"MAIL.DESARQUIVAR\"><md-icon \nmd-font-icon=\"icon-reload\"></md-icon><md-tooltip><span translate=\"MAIL.RECARREGAR_PAGINA\">Recarregar página</span>\n</md-tooltip></md-button><md-menu class=\"actions-menu\" hide-gt-xs><md-button class=\"md-icon-button\" \nng-click=\"$mdOpenMenu($event)\" aria-label=\"Mail Actions\" translate translate-attr-aria-label=\"MAIL.ACTIONS\"><md-icon \nmd-font-icon=\"icon-dots-vertical\"></md-icon></md-button><md-menu-content width=\"3\"><md-menu-item><md-button \naria-label=\"Archive\" translate-attr-aria-label=\"MAIL.ARCHIVE\"><md-icon md-font-icon=\"icon-archive\"></md-icon><span \ntranslate=\"MAIL.ARCHIVE\">Archive</span></md-button></md-menu-item><md-menu-item><md-button aria-label=\"Spam\" \ntranslate-attr-aria-label=\"MAIL.SPAM\"><md-icon md-font-icon=\"icon-alert-octagon\"></md-icon><span translate=\"MAIL.SPAM\">\nSpam</span></md-button></md-menu-item><md-menu-item><md-button aria-label=\"Delete\" translate-aria-label=\"MAIL.DELETE\">\n<md-icon md-font-icon=\"icon-delete\"></md-icon><span translate=\"MAIL.DELETE\">Delete</span></md-button></md-menu-item>\n<md-menu-item><md-button aria-label=\"Move To\" translate-attr-aria-label=\"MAIL.MOVE_TO\"><md-icon \nmd-font-icon=\"icon-folder-move\"></md-icon><span translate=\"MAIL.MOVE_TO\">Move To</span></md-button></md-menu-item>\n<md-menu-item><md-button aria-label=\"Labels\" translate-attr-aria-label=\"MAIL.LABELS\"><md-icon \nmd-font-icon=\"icon-label\"></md-icon><span translate=\"MAIL.LABELS\">Labels</span></md-button></md-menu-item>\n</md-menu-content></md-menu></div><div layout=\"row\" layout-align=\"start center\"><span class=\"page-info\" hide-sm \nng-show=\"vm.mensagens.dados.mensagens.length > 0\">{{vm.mensagens.dados.totalizador}}</span><md-button \nclass=\"md-icon-button arrow\" aria-label=\"Previous\" \nng-show=\"vm.mensagens.dados.mensagens.length > 0 && vm.mensagensSelecionadas.length == 0\" \nng-disabled=\"vm.carregandoMensagens || vm.mensagens.dados.pagina == 1\" ng-click=\"vm.metodos.paginaAnterior($event)\" \ntranslate translate-attr-aria-label=\"MAIL.PREVIOUS\"><md-icon md-font-icon=\"icon-chevron-left\"></md-icon><md-tooltip>\n<span translate=\"MAIL.PREVIOUS\">Anterior</span></md-tooltip></md-button><span class=\"page-info\" hide-sm \nng-show=\"vm.mensagens.dados.mensagens.length > 0 && vm.mensagensSelecionadas.length == 0\">{{vm.pagina}}</span>\n<md-button class=\"md-icon-button arrow\" aria-label=\"Next\" \nng-show=\"vm.mensagens.dados.mensagens.length > 0 && vm.mensagensSelecionadas.length == 0\" \nng-click=\"vm.metodos.proximaPagina($event)\" ng-disabled=\"vm.carregandoMensagens || vm.mensagens.dados.fim\" translate \ntranslate-attr-aria-label=\"MAIL.NEXT\"><md-icon md-font-icon=\"icon-chevron-right\"></md-icon><md-tooltip><span \ntranslate=\"MAIL.NEXT\">Próximo</span></md-tooltip></md-button><md-menu class=\"settings-menu\"><md-button \nclass=\"md-icon-button\" ng-click=\"$mdOpenMenu($event)\" aria-label=\"Settings\" translate \ntranslate-attr-aria-label=\"MAIL.SETTINGS\"><md-icon md-font-icon=\"icon-cog\"></md-icon></md-button><md-menu-content \nwidth=\"3\"><md-menu-item><md-button ng-click=\"vm.changeView(\'classic\')\"><md-icon \nmd-font-icon=\"icon-checkbox-blank-outline\" ng-if=\"vm.currentView !== \'classic\'\"></md-icon><md-icon \nmd-font-icon=\"icon-checkbox-marked\" class=\"md-accent\" ng-if=\"vm.currentView === \'classic\'\"></md-icon><span \ntranslate=\"MAIL.CLASSIC_VIEW\">Classic View</span></md-button></md-menu-item><md-menu-item hide-xs><md-button \nng-click=\"vm.changeView(\'outlook\')\"><md-icon md-font-icon=\"icon-checkbox-blank-outline\" \nng-if=\"vm.currentView !== \'outlook\'\"></md-icon><md-icon md-font-icon=\"icon-checkbox-marked\" class=\"md-accent\" \nng-if=\"vm.currentView === \'outlook\'\"></md-icon><span translate=\"MAIL.OUTLOOK_VIEW\">Outlook View</span></md-button>\n</md-menu-item></md-menu-content></md-menu></div></div><div class=\"content-wrapper\" layout=\"row\" flex><div \nclass=\"content mensagem-list\" ng-include=\"\'app/main/mensageiro/views/outlook/list/list.html\'\" ms-scroll flex=\"50\">\n</div><div class=\"content mensagem-detail scrollable\" \nng-include=\"\'app/main/mensageiro/views/outlook/detail/detail.html\'\" ms-scroll layout=\"column\" flex=\"50\"></div></div>");
$templateCache.put("app/main/sql-consulta/views/dialogs/dialog-planilha.html","<md-dialog id=\"pipeline-negocio-negocios-dialog\" class=\"dialogo-padrao\" style=\"width: 35%\" aria-label=\"Dialog\"><form \nname=\"vm.form\" class=\"md-inline-form\" novalidate><md-toolbar class=\"md-accent md-tall\" layout=\"column\"><div \nclass=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" layout-align=\"space-between center\" flex><div layout=\"row\" \nlayout-align=\"center\" flex><span class=\"title text-center\">Planilha Excel</span></div><div layout=\"row\"><md-button \nclass=\"md-icon-button\" ng-click=\"vm.metodos.fecharDialog()\" aria-label=\"Fechar dialog\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div></div></md-toolbar><md-dialog-content class=\"conteudo-dialog\">\n<div layout=\"row\" style=\"margin-top: 1em\"><md-input-container class=\"md-block\" flex><label \ntranslate=\"Nome da planilha\"></label><input id=\"ms-search-bar-input\" type=\"text\" flex ng-model=\"vm.nomePlanilha\" \npattern=\"[A-Za-záàâãéèêíïóôõöúçñÁÀÂÃÉÈÍÏÓÔÕÖÚÇÑ 0-9]+$\"><div ng-messages=\"vm.form.funil.$error\"><div \nng-message=\"required\">Campo obrigatório</div></div></md-input-container></div><div class=\"botaoPlamilha\" layout=\"row\" \nstyle=\"justify-content: flex-end\"><div style=\"text-align: right\"><md-button \nng-disabled=\"vm.form.$invalid || vm.nomePlanilha.length == 0 || vm.requisicaoProgress\" \nclass=\"add-event-button md-fab md-toolbar\" style=\"width: 40px; height: 40px\" \nng-click=\"vm.metodos.montarPlanilhaExcel(vm.nomePlanilha)\" aria-label=\"Exportar\"><md-icon \nmd-font-icon=\"icon-file-excel\"></md-icon><md-tooltip><label>Exportar</label></md-tooltip></md-button></div></div><div \nlayout=\"row\" class=\"mb-10\" flex><div layout=\"row\" ng-show=\"vm.requisicaoProgress\" layout-align=\"center center\" flex>\n<div layout=\"column\" layout-align=\"center center\" class=\"mt-100\"><span class=\"font-weight-500\" style=\"font-size: 16px\">\n{{vm.mensagemPreloader}}</span><md-progress-circular md-mode=\"indeterminate\" md-diameter=\"100\" class=\"md-accent\">\n</md-progress-circular></div></div></div></md-dialog-content></form></md-dialog>");
$templateCache.put("app/core/directives/ms-card/templates/template-1/template-1.html","<div class=\"template-1\"><div class=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" \nalt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div><div class=\"content pv-24 ph-16\"><div class=\"title h1\" \nng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">{{card.subtitle}}\n</div><div class=\"text pt-16\" ng-if=\"card.text\">{{card.text}}</div></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-10/template-10.html","<div class=\"template-10 p-16\"><div class=\"pb-16\" layout=\"row\" layout-align=\"space-between center\"><div class=\"info\">\n<div class=\"title secondary-text\" ng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle h2\" \nng-if=\"card.subtitle\">{{card.subtitle}}</div></div><div class=\"media ml-16\"><img class=\"image\" \nng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div></div><div \nclass=\"text\">{{card.text}}</div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-3/template-3.html","<div class=\"template-3 p-16 teal-bg white-fg\" layout=\"row\" layout-align=\"space-between\"><div layout=\"column\" \nlayout-align=\"space-between\"><div class=\"info\"><div class=\"title h1\" ng-if=\"card.title\">{{card.title}}</div><div \nclass=\"subtitle h3 secondary-text\" ng-if=\"card.subtitle\">{{card.subtitle}}</div></div><div class=\"cta\"><md-button \nclass=\"m-0\">{{card.cta}}</md-button></div></div><div class=\"media pl-16\"><img class=\"image\" \nng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-5/template-5.html","<div class=\"template-5 p-16\" layout=\"row\" layout-align=\"space-between start\"><div class=\"info\"><div \nclass=\"title secondary-text\" ng-if=\"card.title\">{{card.title}}</div><div class=\"event h2\" ng-if=\"card.event\">\n{{card.event}}</div></div><div class=\"media ml-16\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" \nalt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-2/template-2.html","<div class=\"template-2\"><div class=\"header p-16\" layout=\"row\" layout-align=\"start center\"><div ng-if=\"card.avatar\"><img\n class=\"avatar mr-16\" ng-src=\"{{card.avatar.src}}\" alt=\"{{card.avatar.alt}}\"></div><div class=\"info\"><div \nclass=\"title\" ng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">\n{{card.subtitle}}</div></div></div><div class=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" \nalt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div><div class=\"text p-16\" ng-if=\"card.text\">{{card.text}}\n</div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-7/template-7.html","<div class=\"template-7\" layout=\"row\" layout-align=\"space-between\"><div class=\"info\" layout=\"column\" \nlayout-align=\"space-between\" layout-fill flex><div class=\"p-16\"><div class=\"title h1\" ng-if=\"card.title\">{{card.title}}\n</div><div class=\"subtitle h4 secondary-text\" ng-if=\"card.subtitle\">{{card.subtitle}}</div><div class=\"text h4 pt-8\" \nng-if=\"card.text\">{{card.text}}</div></div><div><md-divider></md-divider><div class=\"p-8\" layout=\"row\"><md-icon \nmd-font-icon=\"icon-star-outline\" class=\"mh-5\"></md-icon><md-icon md-font-icon=\"icon-star-outline\" class=\"mh-5\">\n</md-icon><md-icon md-font-icon=\"icon-star-outline\" class=\"mh-5\"></md-icon><md-icon md-font-icon=\"icon-star-outline\" \nclass=\"mh-5\"></md-icon><md-icon md-font-icon=\"icon-star-outline\" class=\"mh-5\"></md-icon></div></div></div><div \nclass=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" \nng-show=\"card.media.image\"></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-4/template-4.html","<div class=\"template-4\"><div class=\"info white-fg ph-16 pv-24\"><div class=\"title h1\" ng-if=\"card.title\">{{card.title}}\n</div><div class=\"text\" ng-if=\"card.text\">{{card.text}}</div></div><div class=\"media\"><img class=\"image\" \nng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-6/template-6.html","<div class=\"template-6\"><div class=\"content pv-24 ph-16\"><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">\n{{card.subtitle}}</div><div class=\"title h2\" ng-if=\"card.title\">{{card.title}}</div><div class=\"text pt-8\" \nng-if=\"card.text\">{{card.text}}</div></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-9/template-9.html","<div class=\"template-9\"><div class=\"header p-16\" layout=\"row\" layout-align=\"start center\"><div ng-if=\"card.avatar\"><img\n class=\"avatar mr-16\" ng-src=\"{{card.avatar.src}}\" alt=\"{{card.avatar.alt}}\"></div><div class=\"info\"><div \nclass=\"title\" ng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">\n{{card.subtitle}}</div></div></div><div class=\"text ph-16 pb-16\" ng-if=\"card.text\">{{card.text}}</div><div \nclass=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" \nng-show=\"card.media.image\"></div><div class=\"buttons m-8\"><md-button class=\"md-icon-button mr-16\" \naria-label=\"Favorite\"><md-icon md-font-icon=\"icon-heart-outline\" class=\"s24\"></md-icon></md-button><md-button \nclass=\"md-icon-button\" aria-label=\"Share\"><md-icon md-font-icon=\"icon-share\" class=\"s24\"></md-icon></md-button></div>\n</div>");
$templateCache.put("app/core/directives/ms-card/templates/template-8/template-8.html","<div class=\"template-8\"><div class=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" \nalt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div><div class=\"content pv-24 ph-16\"><div class=\"title h1\" \nng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">{{card.subtitle}}\n</div><div class=\"buttons pt-16\"><md-button class=\"m-0\">{{card.button1}}</md-button><md-button class=\"m-0 md-accent\">\n{{card.button2}}</md-button></div><div class=\"text pt-16\" ng-if=\"card.text\">{{card.text}}</div></div></div>");
$templateCache.put("app/core/directives/ms-stepper/templates/horizontal/horizontal.html","<div class=\"ms-stepper-horizontal\"><div class=\"ms-stepper-navigation-wrapper\"><div class=\"ms-stepper-navigation\" \nlayout=\"row\" layout-align=\"center center\"><md-button class=\"ms-stepper-navigation-item\" \nng-class=\"{\'current\': MsStepper.isStepCurrent(step.stepNumber), \'valid\': MsStepper.isStepValid(step.stepNumber), \'disabled\': MsStepper.isStepDisabled(step.stepNumber), \'optional\': MsStepper.isStepOptional(step.stepNumber)}\" \nng-click=\"MsStepper.gotoStep(step.stepNumber)\" ng-disabled=\"MsStepper.isStepDisabled(step.stepNumber)\" \nng-repeat=\"step in MsStepper.steps | filter:MsStepper.filterHiddenStep\" layout=\"row\" layout-align=\"start center\"><div \nclass=\"step md-accent-bg\" ng-hide=\"MsStepper.steps.length == 1\" layout=\"row\" layout-align=\"center center\"><span \nng-if=\"!MsStepper.isStepValid(step.stepNumber) || MsStepper.isStepOptional(step.stepNumber)\">{{$index + 1}} </span>\n<span ng-if=\"MsStepper.isStepValid(step.stepNumber) && !MsStepper.isStepOptional(step.stepNumber)\"><i \nclass=\"icon icon-check s18\"></i></span></div><div layout=\"column\" layout-align=\"start start\"><div class=\"title\" \ntranslate=\"{{step.stepTitleTranslate}}\">{{step.stepTitle}}</div><div class=\"subtitle\" \nng-if=\"MsStepper.isStepOptional(step.stepNumber)\">Optional</div></div></md-button></div></div><div \nclass=\"ms-stepper-steps\" ng-transclude></div><div class=\"ms-stepper-controls\" layout=\"row\" \nlayout-align=\"center center\"><md-button class=\"md-accent md-raised\" ng-hide=\"MsStepper.isFirstStep()\" \nng-click=\"MsStepper.gotoPreviousStep()\">Voltar</md-button><div class=\"ms-stepper-dots\"><span \nng-repeat=\"step in MsStepper.steps\" ng-hide=\"MsStepper.isStepHidden(step.stepNumber)\" \nng-class=\"{\'selected md-accent-bg\':MsStepper.currentStepNumber === $index + 1}\"></span></div><md-button \nclass=\"md-accent md-raised\" ng-hide=\"MsStepper.hideBtnNext\" ng-if=\"!MsStepper.isLastStep()\" \nng-disabled=\"!MsStepper.isStepValid(MsStepper.currentStepNumber)\" ng-click=\"MsStepper.gotoNextStep()\">Próximo\n</md-button><md-button type=\"submit\" class=\"md-accent md-raised\" ng-click=\"MsStepper.resetForm()\" \nng-disabled=\"!MsStepper.isFormValid()\">Gerar Relatório</md-button></div></div>");
$templateCache.put("app/core/directives/ms-stepper/templates/vertical/vertical.html","<div class=\"ms-stepper-vertical\"><div class=\"ms-stepper-vertical-line\"></div><div class=\"ms-stepper-steps\" \nng-transclude></div></div>");
$templateCache.put("app/compartilhado/diretivas/pg-toolbar/componentes/sidenav/pg-toolbar-botao-sidenav.html","<div class=\"h1\" layout=\"row\" layout-align=\"start center\"><md-button class=\"md-icon-button\" \nng-click=\"vm.metodosControladores.metodoControladorAbrirSidenav()\" aria-label=\"Abrir Sidenav\"><md-icon \nmd-font-icon=\"icon-menu s30\"></md-icon></md-button></div>");
$templateCache.put("app/compartilhado/diretivas/pg-toolbar/componentes/sidenav/pg-toolbar-mobile-sidenav.html","<div class=\"h1\" layout=\"column\"><div class=\"h1\" layout=\"row\" layout-align=\"start center\"><ng-include \nsrc=\"vm.htmlComponente.botaoNovaPesquisa\"></ng-include></div><div class=\"h1\" layout=\"row\" layout-align=\"start center\">\n<ng-include src=\"vm.htmlComponente.botaoAtualizar\"></ng-include></div><div class=\"h1\" layout=\"row\" \nlayout-align=\"start center\"><ng-include src=\"vm.htmlComponente.botaoInserir\"></ng-include></div><div class=\"h1\" \nlayout=\"row\" layout-align=\"start center\"><ng-include src=\"vm.htmlComponente.botaoEditar\"></ng-include></div><div \nclass=\"h1\" layout=\"row\" layout-align=\"start center\"><ng-include src=\"vm.htmlComponente.listarTodasEntidades\">\n</ng-include></div></div>");
$templateCache.put("app/compartilhado/diretivas/toolbar-mobile-desktop/mobile/sidenav/sidenav.html","<div class=\"h1\" layout=\"column\"><div class=\"h1\" layout=\"row\" layout-align=\"start center\"><md-button \nclass=\"md-icon-button\" \nng-disabled=\"vm.entidade === null || !vm.controlador.pesquisaAtiva\r\n    || vm.controlador.novaEntidade || vm.controlador.editarAtivo ||vm.controlador.listarTodasEntidades\" \nng-click=\"vm.toolbar.novaPesquisa()\" aria-label=\"Pesquisa\"><md-icon md-font-icon=\"icon-note-outline s30\"></md-icon>\n</md-button><md-button \nng-disabled=\"vm.entidade === null || !vm.controlador.pesquisaAtiva\r\n    || vm.controlador.novaEntidade || vm.controlador.editarAtivo ||vm.controlador.listarTodasEntidades\" \nng-click=\"vm.toolbar.novaPesquisa()\" aria-label=\"Pesquisa\"><span translate=\"TOOLBAR.NOVA_PESQUISA\" class=\"h3\">\nNova Pesquisa</span></md-button></div><div class=\"h1\" layout=\"row\" layout-align=\"start center\" \nng-if=\"!vm.ngOcultaBotaoInserir\"><md-button class=\"md-icon-button\" \nng-class=\"{\'selecionado\': vm.buttonSelecionado === vm.controleButtonSelecionado.inserir}\" \nng-disabled=\"vm.controlador.editarAtivo || vm.controlador.listarTodasEntidades\" \nng-click=\"vm.toolbar.inserir(vm.cliente)\" aria-label=\"Inserir\"><md-icon md-font-icon=\"icon-plus s30\"></md-icon>\n</md-button><md-button ng-class=\'{\"selecionado\": vm.buttonSelecionado === vm.controleButtonSelecionado.inserir}\' \nng-disabled=\"vm.controlador.editarAtivo || vm.controlador.listarTodasEntidades\" \nng-click=\"vm.toolbar.inserir(vm.entidade)\" aria-label=\"Inserir\"><span class=\"h3\" translate=\"TOOLBAR.INSERIR\">Inserir\n</span></md-button></div><div class=\"h1\" layout=\"row\" layout-align=\"start center\" ng-if=\"!vm.ngOcultaBotaoEditar\">\n<md-button class=\"md-icon-button\" \nng-class=\"{\'selecionado\': vm.buttonSelecionado === vm.controleButtonSelecionado.editar}\" \nng-disabled=\"vm.entidade === null || !vm.controlador.pesquisaAtiva\r\n    || vm.controlador.novaEntidade || vm.controlador.listarTodasEntidades\" \nng-click=\"vm.toolbar.editar(vm.entidade)\" aria-label=\"Editar\"><md-icon md-font-icon=\"icon-pencil s30\"></md-icon>\n</md-button><md-button ng-class=\'{\"selecionado\": vm.buttonSelecionado === vm.controleButtonSelecionado.editar}\' \nng-disabled=\"vm.entidade === null || !vm.controlador.pesquisaAtiva\r\n    || vm.controlador.novaEntidade || vm.controlador.listarTodasEntidades\" \nng-click=\"vm.toolbar.editar(vm.entidade)\" aria-label=\"Editar\"><span class=\"h3\" translate=\"TOOLBAR.EDITAR\">Editar</span>\n</md-button></div><div class=\"h1\" layout=\"row\" layout-align=\"start center\"><md-button class=\"md-icon-button\" \nng-class=\"{\'selecionado\': vm.buttonSelecionado === vm.controleButtonSelecionado.listarTodasEntidades}\" \nng-disabled=\"vm.entidades === null || vm.controlador.novaEntidade\r\n                                || vm.controlador.editarAtivo\" \naria-label=\"Listar Todos\"><md-icon md-font-icon=\"icon-format-list-bulleted s30\"></md-icon></md-button><md-button \nclass=\"texto-secundario\" \nng-class=\'{\"selecionado\": vm.buttonSelecionado === vm.controleButtonSelecionado.listarTodasEntidades}\' \nng-disabled=\"vm.entidades === null || vm.controlador.novaEntidade || vm.controlador.editarAtivo\" \nng-click=\"vm.toolbar.listarTodasEntidades()\" aria-label=\"Listar Todos\"><span class=\"h4\" \ntranslate=\"TOOLBAR.ALTERAR_EXIBICAO\">Alterar Exibição</span></md-button></div></div>");
$templateCache.put("app/main/agenda/processamento/atividade/views/atividade-form.html","<div class=\"md-background-bg md-whiteframe-1dp\"><form name=\"vm.form.atividade\" novalidate><pg-toolbar \nentidades=\"vm.atividades\" entidade=\"vm.atividade\" entidade-de-envio=\"vm.entidadeDeEnvio\" \ncontrolador-toolbar=\"vm.controleForm\" iniciar-chamando-pesquisa=\"vm.inicializaChamandoPesquisa\" \nacao-pesquisar=\"vm.metodos.pesquisar()\" pre-definir-campos-para-insercao=\"vm.metodos.preDefinirInserir()\" \nacao-criar=\"vm.metodos.salvar(vm.atividade)\" acao-editar=\"vm.metodos.editar(vm.atividade)\" \nacao-pos-editar=\"vm.metodos.acaoPosEditar()\" construir-dt-options=\"vm.metodos.construirDtOptions()\" \nmetodos-externos=\"vm.metodosExternosPgToolbar\" desabilitar-botao-excluir=\"true\" campo-pesquisar=\"vm.pesquisar\">\n</pg-toolbar><md-content layout-padding ng-hide=\"vm.controleForm.listarTodasEntidades\" \nng-disabled=\"vm.controleForm.emProgresso\"><div class=\"form-container\"><div layout=\"row\" \nng-hide=\"vm.controleForm.inserirAtivo || vm.controleForm.editarAtivo\"><md-input-container class=\"md-block\" flex=\"20\" \nflex-gt-sm=\"10\"><label translate=\"AGENDA.NUMERO\"></label><input type=\"text\" \nng-disabled=\"vm.controleForm.pesquisaAtiva\" ng-model=\"vm.atividade.numero\" name=\"historicoNumero\" maxlength=\"5\" \nmascara-numero-generica=\"#####\"></md-input-container><md-input-container class=\"md-block\" flex=\"20\" flex-gt-sm=\"10\">\n<label translate=\"AGENDA.ANO\"></label><input type=\"text\" ng-disabled=\"vm.controleForm.pesquisaAtiva\" \nng-model=\"vm.atividade.ano\" name=\"historicoAno\" maxlength=\"4\" mascara-numero-generica=\"####\"></md-input-container>\n</div><div layout-gt-sm=\"row\"><fieldset class=\"standard\" flex><legend class=\"grp-legend\" translate=\"AGENDA.CLIENTE\">\n</legend><div layout-gt-sm=\"row\"><md-autocomplete flex ng-model-options=\"{debounce: 200}\" md-input-name=\"cliente\" \nng-required=\"vm.controleForm.inserirAtivo || vm.controleForm.editarAtivo\" \nng-disabled=\"vm.controleForm.emProgresso || (!(vm.controleForm.inserirAtivo || vm.controleForm.editarAtivo) && vm.controleForm.pesquisaAtiva)\" \nmd-no-cache=\"true\" ng-blur=\"vm.metodos.configuraAutoCompleteClienteOnBlur()\" md-selected-item=\"vm.atividade.cliente\" \nmd-selected-item-change=\"vm.metodos.alterarItemSelecionadoAutoCompleteCliente(item)\" \nmd-search-text=\"vm.textoDePesquisaAutoCompleteCliente\" \nmd-items=\"item in vm.metodos.pesquisarAutoCompleteCliente(vm.textoDePesquisaAutoCompleteCliente)\" \nmd-item-text=\"item.codigo + \' - \' + item.nome\" md-autoselect md-floating-label=\"Cliente\"><md-item-template><span \nmd-highlight-text=\"vm.textoDePesquisaAutoCompleteCliente\">{{item.codigo}} - {{item.nome}}</span></md-item-template>\n<md-not-found><label>Não foi encontrado nenhum Cliente.</label></md-not-found></md-autocomplete></div></fieldset>\n<fieldset class=\"standard\" flex><legend class=\"grp-legend\" translate=\"AGENDA.ATENDIMENTO\"></legend><div layout=\"row\" \nflex ng-if=\"(vm.controleForm.inserirAtivo || vm.controleForm.editarAtivo) || vm.controleForm.pesquisaAtiva\">\n<md-input-container><md-checkbox \nng-disabled=\"(!(vm.controleForm.inserirAtivo || vm.controleForm.editarAtivo) && vm.controleForm.pesquisaAtiva)\" \nng-model=\"vm.atividade.atividadeVinculadaAtendimento\" ng-change=\"vm.metodos.removerAtendimento()\"><span \ntranslate=\"AGENDA.VINCULAR_ATENDIMENTO\">Vincular atendimento</span></md-checkbox></md-input-container></div><div \nlayout=\"row\" flex \nng-if=\"(!(vm.controleForm.inserirAtivo || vm.controleForm.editarAtivo) && vm.controleForm.pesquisaAtiva) && vm.atividade.atividadeVinculadaAtendimento  ||\r\n                                    ((vm.controleForm.inserirAtivo || vm.controleForm.editarAtivo) && vm.atividade.atividadeVinculadaAtendimento) ||\r\n                                    (!vm.controleForm.pesquisaAtiva && !(vm.controleForm.inserirAtivo || vm.controleForm.editarAtivo))\">\n<md-input-container class=\"md-block\" flex=\"10\" ng-hide=\"!vm.carregandoAtendimento\"><md-progress-circular \nclass=\"md-accent\" md-diameter=\"30\" md-mode=\"indeterminate\"></md-progress-circular></md-input-container>\n<md-input-container class=\"md-block\" flex><label translate=\"AGENDA.ATENDIMENTO\"></label><md-select \nng-model=\"vm.atividade.atendimento\" flex name=\"atendimento\" ng-model-options=\"{trackBy: \'$value.codigo\'}\" \nmd-on-open=\"vm.metodos.configuraMdSelectAtendimento()\" md-on-close=\"vm.metodos.configurarMdSelectAtendimentoOnClose()\" \nng-change=\"vm.metodos.selecionarAtendimento(vm.atividade.atendimento)\" \nng-disabled=\"(!vm.cliente && !vm.codigoCliente) || vm.controleForm.emProgresso ||\r\n                                                           (!(vm.controleForm.inserirAtivo || vm.controleForm.editarAtivo) && vm.controleForm.pesquisaAtiva)\" \nng-required=\"true\"><md-select-header><input id=\"atendimento-md-select\" \nng-if=\"vm.atendimentos && vm.atendimentos.length > 0\" class=\"md-text\" ng-model=\"vm.filtrarAtendimentos\" type=\"search\" \nplaceholder=\"\" translate translate-attr-placeholder=\"PIPELINE_NEGOCIO.PESQUISAR_ATENDIMENTOS\"> <span \nng-if=\"!vm.atendimentos || vm.atendimentos.length == 0\">Não existe atendimentos vinculados ao cliente</span>\n</md-select-header><md-option layout=\"row\" ng-value=\"atendimento\" \nng-if=\"vm.atendimentos && vm.atendimentos.length > 0\" \nng-repeat=\"atendimento in vm.atendimentos | filter:vm.filtrarAtendimentos\"><span hide-sm hide-xs>\n{{atendimento.codigo}}/{{atendimento.ano}} - {{vm.metodos.listarAssuntoAtendimento(atendimento.assunto)}} </span><span \nhide-gt-sm>\n{{atendimento.codigo}}/{{atendimento.ano}} - {{vm.metodos.listarAssuntoAtendimento(atendimento.assunto).substring(0,17)}}...\n</span></md-option></md-select><md-tooltip ng-if=\"!vm.atividade.cliente && !vm.codigoCliente\"><span \ntranslate=\"AGENDA.INFORMAR_CLIENTE\"></span></md-tooltip><div ng-messages=\"vm.form.atividade.atendimento.$error\"><div \nng-message=\"required\" translate=\"AGENDA.OBRIGATORIO\"></div></div></md-input-container></div></fieldset></div><div \nlayout-gt-sm=\"row\"><fieldset class=\"standard\" flex><legend class=\"grp-legend\" translate=\"AGENDA.ATIVIDADE\"></legend>\n<div layout-gt-sm=\"row\"><md-input-container class=\"md-block\" flex-gt-sm><label translate=\"AGENDA.EVENTO\">Evento</label>\n<md-select ng-model=\"vm.atividade.evento\" ng-required=\"vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo\" \nng-model-options=\"{trackBy: \'$value.codigo\'}\" name=\"codigoEvento\" \nng-disabled=\"vm.controleForm.emProgresso || (!(vm.controleForm.inserirAtivo || vm.controleForm.editarAtivo) && vm.controleForm.pesquisaAtiva)\" \nmd-on-open=\"vm.metodos.configuraMdSelectEvento()\" md-on-close=\"vm.metodos.configurarMdSelectEventoOnClose()\" \nng-change=\"vm.metodos.selecionarEvento(vm.atividade.evento)\"><md-select-header><input id=\"evento-md-select\" \nclass=\"md-text\" ng-model=\"vm.filtrarEvento\" type=\"search\" placeholder=\"\" translate \ntranslate-attr-placeholder=\"AGENDA.PESQUISAR_EVENTO\"></md-select-header><md-option ng-value=\"evento\" \nng-repeat=\"evento in vm.eventos | filter:vm.filtrarEvento track by evento.codigo\"><span hide-sm hide-xs>\n{{evento.descricao}} </span><span hide-gt-sm>{{evento.descricao.substring(0,27)}}...</span></md-option></md-select><div\n ng-messages=\"vm.form.atividade.codigoEvento.$error\"><div ng-message=\"required\" translate=\"AGENDA.OBRIGATORIO\"></div>\n</div></md-input-container><div layout-gt-sm=\"row\"><div layout-gt-sm=\"column\" ng-hide=\"true\" flex><md-input-container \nclass=\"md-block\" flex-gt-sm><label translate=\"AGENDA.NUMERO\"></label><input type=\"text\" ng-model=\"vm.atividade.numero\" \nname=\"agendaAtividadeNumero\" mascara-numero-generica=\"######\" ng-disabled=\"true\"></md-input-container></div><div \nlayout-gt-sm=\"row\" ng-hide=\"true\" flex><md-input-container class=\"md-block\" flex-gt-sm><label translate=\"AGENDA.ANO\">\n</label><input type=\"text\" ng-model=\"vm.atividade.ano\" name=\"agendaAtividadeAno\" mascara-numero-generica=\"######\" \nng-disabled=\"true\"></md-input-container></div><md-input-container class=\"md-block\" flex-gt-sm><label \ntranslate=\"AGENDA.DATA\"></label><md-datepicker ng-model=\"vm.atividade.ultimoHistorico.data\" name=\"historicoData\" \nflex-gt-sm ng-mask=\"3?9/1?9/9999\" mascara-conversor-string-para-data \nng-disabled=\"vm.controleForm.emProgresso || (!(vm.controleForm.inserirAtivo || vm.controleForm.editarAtivo) && vm.controleForm.pesquisaAtiva)\" \nng-required=\"vm.controleForm.inserirAtivo || vm.controleForm.editarAtivo\"></md-datepicker><div \nng-messages=\"vm.form.atividade.historicoData.$error\"><div ng-message=\"valid\" \ntranslate=\"MENSAGEM_VALIDACAO.DATA_INVALIDA\"></div><div ng-message=\"mindate\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_DATA_ATUAL\"></div><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.DATA_OBRIGATORIA\"></div></div></md-input-container><md-input-container class=\"md-block\" \nflex-gt-sm><label translate=\"AGENDA.HORA\"></label><input type=\"text\" ng-model=\"vm.atividade.ultimoHistorico.hora\" \nng-disabled=\"vm.controleForm.emProgresso || (!(vm.controleForm.inserirAtivo || vm.controleForm.editarAtivo) && vm.controleForm.pesquisaAtiva)\" \nname=\"historicoHora\" mascara-numero-generica=\"##:##\" \npattern=\"^(([2]{1}[0-3]{1}){1}|([0-1]{1}[0-9]){1}){1}:[0-5]{1}[0-9]{1}$\"><div \nng-messages=\"vm.form.atividade.historicoHora.$error\"><div ng-message=\"pattern\" translate=\"AGENDA.HORA_INVALIDA\"></div>\n</div></md-input-container></div></div><div layout-gt-sm=\"row\"><md-input-container class=\"md-block\" flex-gt-sm><label \ntranslate=\"AGENDA.OBSERVACAO\"></label><textarea rows=\"2\" ng-model=\"vm.atividade.observacao\" \nng-required=\"!vm.atividade.atividadeVinculadaAtendimento\" mascara-tamanho-campo=\"100\" \nng-disabled=\"vm.controleForm.emProgresso ||\r\n                                             (!(vm.controleForm.inserirAtivo || vm.controleForm.editarAtivo) && vm.controleForm.pesquisaAtiva)\" \nname=\"agendaAtividadeObersacao\" md-maxlength=\"100\">\r\n                                </textarea><div \nng-messages=\"vm.form.atividade.agendaAtividadeObersacao.$error\"><div ng-message=\"required\" \ntranslate=\"AGENDA.OBRIGATORIO\"></div></div></md-input-container></div></fieldset></div></div></md-content></form></div>");
$templateCache.put("app/main/agenda/processamento/atividade/views/atividade-tabela.html","<div layout=\"column\" flex><div class=\"md-padding md-background-bg md-whiteframe-1dp fullpage-datatable\" \nlayout=\"column\" flex><table class=\"dataTable row-border hover\" id=\"datatable-atividade\" width=\"100%\"><thead><tr><th>\nAção</th><th>Ano</th><th>Número</th><th>Evento</th><th>Status</th><th>Data</th></tr></thead></table></div></div>");
$templateCache.put("app/main/agenda/processamento/atividade/views/atividade.html","<div id=\"pendencia-atendimento\" class=\"page-layout simple tabbed\" layout=\"column\"><header-padrao \ntranslate-nome=\"AGENDA.ATIVIDADE\" ng-utiliza-pesquisa=\"false\"></header-padrao><div class=\"content\"><div \nui-view=\"atividade-form\"></div></div><div ui-view=\"atividade-tabela\" ng-if=\"vm.controleForm.listarTodasEntidades\">\n</div></div>");
$templateCache.put("app/main/atendimento/processamento/atendimento/atendimentos-em-aberto/atendimentos-em-aberto-tabela.html","<div layout=\"row\" class=\"md-background-bg\" flex><div flex layout-align=\"start center\" layout=\"row\"><md-button \nclass=\"array-buttons-atendimentos-em-aberto\" aria-label=\"{{item.descricao}}\" \nng-repeat=\"item in vm.legendasAtendimentosEmAberto\" \nng-class=\"{\'descricao-selecionada\': vm.legendaSelecionadaAtendimentosEmAberto == $index}\" \nng-click=\"vm.metodosModuloAtendimentoEmAberto.filtrarTabelaAtendimentosEmAberto(item, $index)\"><md-icon \nmd-font-icon=\"icon-label\" class=\"s16\" ng-style=\"{\'color\' : item.cor}\"></md-icon><span class=\"title\">{{item.descricao}}\n</span></md-button></div><div layout=\"column\" ng-if=\"vm.usuarioLogado.visualizarAtendimentosEmAbertoSetor\" flex \nlayout-align=\"end end\"><md-button class=\"md-raised md-accent\" aria-label=\"Pesquisar\" \nng-disabled=\"vm.controleForm.emProgresso\" \nng-click=\"vm.metodosModuloAtendimentoEmAberto.abrirDialogUsuariosComAtendimentosEmAbertoSetor($event);\"><span>FILTRAR\n</span></md-button></div></div><div layout=\"column\" flex><div \nclass=\"md-padding md-background-bg md-whiteframe-1dp fullpage-datatable\"><table class=\"dataTable row-border hover\" \ndatatable=\"ng\" dt-options=\"vm.dtOptionsAtendimentosEmAberto\"><thead><tr><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Ação</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Código</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Ano</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Colaborador</span></div></th><th class=\"secondary-text\" \nstyle=\"width: 15%\"><div class=\"table-header\"><span class=\"column-title\">Cliente</span></div></th><th \nclass=\"secondary-text\" style=\"width: 12%\"><div class=\"table-header\"><span class=\"column-title\">Solução</span></div>\n</th><th class=\"secondary-text\" style=\"width: 10%\"><div class=\"table-header\"><span class=\"column-title\">\nDias sem Contato</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">\nData para Conclusão</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">\nPendência</span></div></th><th class=\"secondary-text\" style=\"width: 15%\" \nng-if=\"(vm.atendimentos | filter:{riscoRescisaoContratual:true}).length > 0\"><div class=\"table-header\"><span \nclass=\"column-title\"></span></div></th></tr></thead><tbody><tr ng-repeat=\"atendimento in vm.atendimentos\"><td \nclass=\"button-icone-cor-azul\"><i class=\"icon-pencil s16 icone-cor-padrao\" \nng-click=\"vm.controleForm.emProgresso || vm.metodos.selecionar(atendimento)\" ng-disabled=\"vm.controleForm.emProgresso\">\n</i> <i class=\"icon-apps s16 icone-cor-padrao\" ng-click=\"vm.metodos.abrirDialogHistoriasVinculadas(atendimento)\" \nng-disabled=\"vm.controleForm.emProgresso\"><md-tooltip md-autohide><span>Histórias vinculadas</span></md-tooltip></i>\n</td><td class=\"border-left border-right h3 text-center\" \nng-class=\"{\'item-vencido\': atendimento.diasRestantes < 0 ,\r\n                                   \'item-sete-dias-restantes-amarelo\': atendimento.diasRestantes <7 && atendimento.diasRestantes >= 0}\">\n{{atendimento.codigo}}</td><td class=\"border-right border-right h3 text-center\" \nng-class=\"{\'item-vencido\': atendimento.diasRestantes < 0 ,\r\n                                   \'item-sete-dias-restantes-amarelo\': atendimento.diasRestantes <7 && atendimento.diasRestantes >= 0}\">\n{{atendimento.ano}}</td><td>{{atendimento.usuario.login}}</td><td>{{atendimento.cliente.nome}}</td><td>\n{{atendimento.solucao.descricao}}</td><td>{{atendimento.quantidadeDiasSemContato}}</td><td>\n{{atendimento.dataPrevisaoFechamento | date:\'dd/MM/yyyy\'}}</td><td>{{atendimento.atendimentoPendencia.descricao}}</td>\n<td ng-if=\"(vm.atendimentos | filter:{riscoRescisaoContratual:true}).length > 0\"><card-risco-perda-contratual \nng-if=\"atendimento.riscoRescisaoContratual\"></card-risco-perda-contratual></td></tr></tbody></table></div></div>");
$templateCache.put("app/main/atendimento/processamento/atendimento/views/atendimento-form.html","<div id=\"atendimento\" class=\"h-full flex flex-col md-background-bg md-whiteframe-1dp page-layout simple fullwidth\" \nlayout=\"column\" layout-fill><form name=\"vm.form.atendimento\" novalidate class=\"h-full flex flex-col\">\n<toolbar-desktop-mobile controle-form=\"vm.controleForm\" entidades=\"vm.atendimentos\" entidade=\"vm.atendimento\" \npesquisar=\"vm.metodos.pesquisar()\" metodos-externos=\"vm.metodosExternos\" \ntoolbar-nova-pesquisa=\"vm.metodosGeral.novaPesquisa()\" toolbar-inserir=\"vm.metodosGeral.preDefinirCamposParaInserir()\" \ntoolbar-editar=\"vm.metodosGeral.preDefinirCamposParaEditar()\" toolbar-reverter=\"vm.metodosGeral.redefinirCampos()\" \nsalvar=\"vm.metodos.salvar(vm.atendimento)\" editar=\"vm.metodos.editar(vm.atendimento)\" \nexcluir=\"vm.metodos.excluir(vm.atendimento)\" ng-disabled-botao-nova-pesquisa=\"vm.desabilitarButtons.novaPesquisa\" \nng-disabled-botao-inserir=\"vm.desabilitarButtons.inserir\" \nng-disabled-botao-atualizar=\"vm.desabilitarButtons.atualizar\" \nng-disabled-botao-listar-todas-entidades-em-modo-exibicao-tabela=\"vm.desabilitarButtons.desabilitarButtonListarTodasEntidadesEmModoExibicaoTabela\" \niniciar-chamando-pesquisa=\"vm.iniciarChamandoPesquisa\"></toolbar-desktop-mobile><md-content class=\"h-full\" \nlayout=\"column\" layout-gt-xs=\"row\" layout-wrap ng-hide=\"vm.controleForm.listarTodasEntidades\" \nng-disabled=\"vm.controleForm.emProgresso\"><div layout-gt-xs=\"column\" style=\"overflow-x: hidden;\r\n    overflow-y: auto\" \nclass=\"border h-full flex flex-col container-formulario\" flex flex-gt-xs=\"40\"><div class=\"container-linha\">\n<md-input-container class=\"w-full\"><label translate=\"ATENDIMENTO.CODIGO\"></label><input type=\"text\" \nng-model=\"vm.atendimento.codigo\" name=\"codigo\" mascara-numero-generica=\"######\" converte-mascara-para-numero \nng-disabled=\"vm.controleForm.pesquisaAtiva || vm.controleForm.inserirAtivo || vm.controleForm.editarAtivo\r\n                                                    || vm.controleForm.emProgresso\">\n</md-input-container><md-input-container class=\"w-full\"><label translate=\"ATENDIMENTO.ANO\">Ano</label><input \nclass=\"field-search\" type=\"text\" name=\"ano\" ng-model=\"vm.atendimento.ano\" mascara-numero-generica=\"####\" \nconverte-mascara-para-numero \nng-disabled=\"vm.controleForm.pesquisaAtiva || vm.controleForm.inserirAtivo || vm.controleForm.editarAtivo\r\n                                                    || vm.controleForm.emProgresso\">\n</md-input-container><md-input-container class=\"w-full\"><label translate=\"ATENDIMENTO.TIPO_ATENDIMENTO\"></label>\n<md-select name=\"tipoAtendimento\" ng-model=\"vm.atendimento.tipo\" \nng-required=\"vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo\r\n                                                        && !vm.controleForm.inserirAtivo || vm.controleForm.emProgresso\">\n<md-option ng-value=\"key\" ng-repeat=\"(key, value) in vm.tiposAtendimento\">{{value}}</md-option></md-select><div \nng-messages=\"vm.form.atendimento.tipoAtendimento.$error\"><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container><div \nng-if=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.inserirAtivo\" class=\"flex w-full gap-4\"><div \nclass=\"btn-atendimento-importante\" ng-show=\"vm.atendimento.status == 1 && vm.usuarioVinculadoAoAtendimento\" \nng-click=\"vm.metodos.marcarComoImportante(vm.atendimento.codigo, vm.atendimento.ano)\"><md-icon \nng-if=\"!vm.atendimentoImportante\" md-font-icon=\"icon-star-outline\" class=\"s28\"></md-icon><md-icon \nng-if=\"vm.atendimentoImportante\" md-font-icon=\"icon-star\" class=\"s28\"></md-icon><md-tooltip md-autohide><span>\nMarcar como importante</span></md-tooltip></div><md-input-container class=\"check-visualizado\" \nng-if=\"vm.usuarioVinculadoAoAtendimento\"><md-checkbox ng-model=\"vm.usuarioVisualizouAtendimento\" \nng-change=\"vm.metodos.atualizarVisualizacaoAcompanhamentoUsuario(vm.atendimento.codigo, vm.atendimento.ano, vm.usuarioVisualizouAtendimento)\" \nng-disabled=\" vm.controleForm.emProgresso\" aria-label=\"Atend. Visualizado\"><span>Visualizado</span></md-checkbox>\n</md-input-container></div></div><div class=\"container-linha container-responsavel-card-risco-perda\" \nstyle=\"margin-bottom: 20px\"><md-input-container class=\"w-full\"><label>Responsável</label><md-select \nng-model=\"vm.atendimento.codigoUsuario\" name=\"usuarioCodigo\" \nng-change=\"vm.metodos.recarregarMotivosAtendimentos(vm.atendimento.codigoUsuario)\" \nng-required=\"vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo\" \nmd-on-open=\"vm.metodos.configuraMdSelectUsuarioAtivo()\" \nng-disabled=\"(vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo) || vm.controleForm.inserirAtivo || vm.controleForm.emProgresso\">\n<md-select-header ng-if=\"vm.usuariosAtivos.length > 0\"><input id=\"atendimento-usuarios-ativos-md-select\" \nclass=\"md-text\" ng-model=\"vm.filtrarUsuariosAtivo\" type=\"search\" placeholder=\"\" translate \ntranslate-attr-placeholder=\"ATENDIMENTO.PESQUISAR_COLABORADOR\"></md-select-header><md-option ng-value=\"usuario.codigo\" \nng-repeat=\"usuario in vm.usuariosAtivos | filter:vm.filtrarUsuariosAtivo track by usuario.codigo\">{{usuario.login}}\n</md-option></md-select><div ng-messages=\"vm.form.atendimento.usuarioCodigo.$error\"><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container><div style=\"width: 80%\" \nng-click=\"vm.metodos.abrirDialogContratos($event)\" ng-if=\"vm.atendimento.riscoRescisaoContratual\" \nng-disabled=\"vm.abrindoDialogContratos\"><card-risco-perda-contratual exibir-icone=\"true\"></card-risco-perda-contratual>\n</div></div><div class=\"container-linha\"><md-autocomplete class=\"w-full autocomplete-cliente-atendimento\" \nmd-input-name=\"cliente\" md-no-cache=\"true\" ng-required=\"vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo\" \nng-blur=\"vm.metodos.configuraAutoCompleteClienteOnBlur()\" md-selected-item=\"vm.atendimento.cliente\" \nmd-selected-item-change=\"vm.metodos.alterarItemSelecionadoAutoCompleteCliente(item)\" \nmd-search-text=\"vm.textoDePesquisaAutoCompleteCliente\" \nmd-items=\"item in vm.metodos.pesquisarAutoCompleteCliente(vm.textoDePesquisaAutoCompleteCliente)\" \nmd-item-text=\"item.codigo + \' - \' + item.nome\" md-autoselect md-floating-label=\"Cliente\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.inserirAtivo\r\n                                                            || vm.iniciarAtendimentoInserindoNovoAtendimento || vm.controleForm.emProgresso\">\n<md-item-template><span md-highlight-text=\"vm.textoDePesquisaAutoCompleteCliente\">{{item.codigo}} - {{item.nome}}\n</span></md-item-template><md-not-found><label>Não foi encontrado nenhum Cliente.</label></md-not-found><div \nng-messages=\"vm.form.atendimento.cliente.$error\"><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-autocomplete><div \nng-if=\"vm.controleForm.pesquisaAtiva && (!vm.controleForm.inserirAtivo && !vm.controleForm.editarAtivo)\"><i \nclass=\"icon-account-box s32 icone-cor-padrao\" ng-click=\"vm.metodos.abrirCadastroCliente(vm.atendimento.cliente)\">\n<md-tooltip md-autohide><span translate=\"ATENDIMENTO.VISUALIZAR_CADASTRO_CLIENTE\"></span></md-tooltip></i></div></div>\n<div class=\"container-linha\"><md-input-container class=\"w-full\"><label translate=\"ATENDIMENTO.SOLUCAO\">Solução</label>\n<md-select ng-model=\"vm.atendimento.codigoSolucao\" name=\"solucaoCodigo\" \nng-required=\"vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo\" \nng-change=\"vm.metodos.verificarSolucaoAtendimentoSolicitacao(vm.atendimento.codigoSolucao)\" \nmd-on-open=\"vm.metodos.configuraMdSelectSolucao()\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\r\n                                                        || vm.controleForm.emProgresso\">\n<md-select-header ng-if=\"vm.solucoes.length > 0\"><input id=\"atendimento-solucao-md-select\" class=\"md-text\" \nng-model=\"vm.filtrarSolucoes\" type=\"search\" placeholder=\"\" translate \ntranslate-attr-placeholder=\"ATENDIMENTO.PESQUISAR_SOLUCAO\"></md-select-header><md-option ng-value=\"solucao.codigo\" \nng-repeat=\"solucao in vm.solucoes | filter:vm.filtrarSolucoes track by solucao.codigo\">{{solucao.descricao}}\n</md-option><md-option ng-if=\"vm.atendimento.codigoSolucao\" ng-value=\"\">Desmarcar</md-option></md-select><div \nng-messages=\"vm.form.atendimento.solucaoCodigo.$error\"><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container><md-autocomplete class=\"w-full\" \nmd-input-name=\"motivoAtendimento\" md-no-cache=\"true\" \nng-required=\"vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\r\n                                                            || vm.controleForm.emProgresso || (vm.controleForm.editarAtivo && vm.atendimento.codigoAtendimentoMotivo == vm.codigoAtendimentoMotivoPermiteSolicitacao && vm.usuarioLogado.codigoUsuario != vm.atendimento.codigoUsuario)\" \nng-blur=\"vm.metodos.configuraAutoCompleteAtendimentoMotivoOnBlur()\" \nmd-selected-item=\"vm.atendimento.atendimentoMotivo\" \nmd-selected-item-change=\"vm.metodos.alterarItemSelecionadoAutoCompleteAtendimentoMotivo(item)\" \nmd-search-text=\"vm.textoDePesquisaAutoCompleteAtendimentoMotivo\" \nmd-items=\"item in vm.metodos.pesquisarAutoCompleteAtendimentoMotivo(vm.textoDePesquisaAutoCompleteAtendimentoMotivo)\" \nmd-item-text=\"item.titulo\" md-dropdown-items=\"5\" md-dropdown-position=\"bottom\" md-min-length=\"0\" md-autoselect \nmd-floating-label=\"Motivo\"><md-item-template><span md-highlight-text=\"vm.textoDePesquisaAutoCompleteCliente\">\n{{item.titulo}}</span></md-item-template><md-not-found><label>Não foi encontrado nenhum Motivo.</label></md-not-found>\n<div ng-messages=\"vm.form.atendimento.motivoAtendimento.$error\"><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-autocomplete></div><div class=\"container-linha\">\n<md-input-container style=\"min-width: 100px\"><label translate=\" ATENDIMENTO.STATUS_ATENDIMENTO\">Status Atendimento\n</label><md-select ng-model=\"vm.atendimento.status\" name=\"status\" \nmd-on-close=\"vm.metodos.limparCamposVinculadoStatusAtendimento(vm.atendimento.status)\" \nng-required=\"vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\r\n                                                        || vm.controleForm.emProgresso\">\n<md-option ng-value=\"key\" ng-repeat=\"(key, value) in vm.statusAtendimento\">{{value}}</md-option></md-select><div \nng-messages=\"vm.form.atendimento.status.$error\"><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container><md-input-container class=\"w-full\" \nstyle=\"min-width: 50px\"><label translate=\"ATENDIMENTO.PENDENCIA_ATENDIMENTO\"></label><md-select \nng-model=\"vm.atendimento.codigoAtendimentoPendencia\" name=\"codigoPendenciaAtendimento\" \nng-required=\"vm.atendimento.status == 1 && (vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo)\" \nng-disabled=\"vm.atendimento.status != 1 || (vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo\r\n                                                        && !vm.controleForm.inserirAtivo) || vm.controleForm.emProgresso\">\n<md-option ng-value=\"atendimentoPendencia.codigo\" \nng-repeat=\"atendimentoPendencia in vm.atendimentosPendencia track by atendimentoPendencia.codigo\">\n{{atendimentoPendencia.descricao}}</md-option></md-select><div \nng-messages=\"vm.form.atendimento.codigoPendenciaAtendimento.$error\"><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container><md-input-container class=\"w-full\" \nstyle=\"min-width: 176px; max-width: 176px\"><label translate=\"ATENDIMENTO.DATA_PREVISAO_ENCERRAMENTO\" \nstyle=\"font-size: 12px\"></label><md-datepicker ng-model=\"vm.atendimento.dataPrevisaoFechamento\" \nname=\"dataPrevisaoFechamento\" mascara-conversor-string-para-data ng-mask=\"3?9/1?9/9999\" \nng-required=\"vm.atendimento.status == 1 && (vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo)\" \nng-disabled=\"vm.atendimento.status != 1 || (vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo\r\n                                                                        && !vm.controleForm.inserirAtivo) || vm.controleForm.emProgresso\" \nmd-hide-icons></md-datepicker><div class=\"mensagens-validacao-data\" \nng-messages=\"vm.form.atendimento.dataPrevisaoFechamento.$error\"><div ng-message=\"valid\" \ntranslate=\"MENSAGEM_VALIDACAO.DATA_INVALIDA\"></div><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.DATA_OBRIGATORIA\"></div></div></md-input-container></div><div class=\"w-full\">\n<card-tags-atendimento data=\"vm.listaTagsAtendimento\" model=\"vm.atendimento.tags\" \ncodigo-solucao-selecionada=\"vm.atendimento.codigoSolucao\" form=\"vm.form\" \nlistar-detalhes-usuario-e-solucoes=\"\r\n                        {\r\n                            detalhesUsuario: vm.listarDetalhesUsuario,\r\n                            solucoes: vm.solucoes\r\n                        }\" \nrequired=\"!!(\r\n                            vm.usuarioLogado.usuario.clsSetor.codigo == 3 &&\r\n                            (vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo) &&\r\n                            vm.atendimento.codigoSolucao)\" \ndescricao-exibicao=\"Tags\" todas-tags-cadastradas=\"vm.todasTagsCadastradas\" \ndisabled=\"!vm.atendimento.codigoSolucao || (!vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo)\">\n</card-tags-atendimento></div></div><div layout-gt-xs=\"column\" id=\"historico-atendimento\" \nclass=\"border container-formulario gap-0 h-full flex flex-col\" flex flex-gt-xs=\"77\"><div layout-gt-xs=\"row\" \nclass=\"container-linha\"><md-input-container class=\"md-block\" flex><label translate=\"ATENDIMENTO.ASSUNTO\">Assunto\n</label><textarea ng-model=\"vm.atendimento.assunto\" name=\"assunto\" \nng-required=\"vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\r\n                                                        || vm.controleForm.emProgresso\" \nmd-no-resize=\"true\" rows=\"4\" max-rows=\"4\">\r\n                                </textarea><div \nng-messages=\"vm.form.atendimento.assunto.$error\"><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container></div><div \nclass=\"h-full flex flex-col\"><toolbar-historico-atendimento class=\"pb-10\" \nng-if=\"vm.historicoAtendimentoSelecionado.length && !vm.modoTabelaAtivo\" \nindex-historico-atendimento=\"vm.indexHistoricoAtendimento\" historico-atendimentos=\"vm.historicoAtendimentos\" \nhistorico-atendimento-selecionado=\"vm.historicoAtendimentoSelecionado\" \ninformacoes-historico-atendimento=\"vm.informacoesHistoricoAtendimentoSelecionado\" \neditar-historico=\"vm.metodos.abrirDialogHistorico($event, historico, index)\" \neditar-visualizacao-historico=\"vm.metodos.abrirDialogVisualizacaoHistorico($event)\"></toolbar-historico-atendimento>\n<md-content ng-if=\"vm.historicoAtendimentoSelecionado.length && !vm.modoTabelaAtivo\" style=\"flex: 1; border: none\" \nscroll-topo-ao-atualizar=\"vm.historicoAtendimentoSelecionado\"><div layout-gt-xs=\"row\" flex \nclass=\"scrollable historico\" ms-scroll><text-angular ng-disabled=\"true\" flex ta-toolbar=\"[]\" ta-disabled=\"true\" \nng-model=\"vm.historicoAtendimentoSelecionado\"></text-angular></div></md-content><ng-include ng-if=\"vm.modoTabelaAtivo\" \nng-hide=\"vm.historicoAtendimentos.length === 0\" src=\"vm.rotasHtml.historicoAtendimentosTabela\" \nclass=\"md-background-bg md-whiteframe-1dp fullpage-datatable\" layout=\"column\" flex></ng-include></div></div>\n</md-content></form></div>");
$templateCache.put("app/main/atendimento/processamento/atendimento/views/atendimento.html","<div id=\"atendimento\" class=\"page-layout simple tabbed\" style=\"background: #FFFFFF\" layout=\"column\" layout-fill>\n<header-padrao translate-nome=\"{{vm.tituloHeader}}\" \nliberar-pesquisa-quando-datatable-ativo=\"vm.controleForm.listarTodasEntidades\" \nhabilitar-icone-voltar-ao-estado-anterior=\"vm.habilitarIconeVoltarATelaConsultaAtendimentosHeaderPadrao\" \nvoltar-ao-estado-anterior=\"vm.metodos.implementarVoltarParaOEstadoAnteriorHeaderPadrao()\" \nmensagem-tooltip-icone-estado-anterior=\"vm.mensagemTooltipIconeEstadoAnteriorHeaderPadrao\" pesquisar=\"vm.pesquisar\">\n</header-padrao><ng-include ng-hide=\"vm.controleForm.listarTodasEntidades\" src=\"vm.rotasHtml.toolbarAtendimento\">\n</ng-include><div layout=\"column\" layout-align=\"center center\" class=\"pre-loader-full-width\" \nng-if=\"vm.carregandoAtividades\" flex><md-progress-circular md-mode=\"indeterminate\" class=\"md-accent\" md-diameter=\"70\">\n</md-progress-circular><span style=\"font-weight: 600;margin-top: 10px\">Carregando Atividades...</span></div><md-content\n ng-hide=\"vm.controleForm.listarTodasEntidades\" \nng-class=\"{\'h-full flex flex-col\': !vm.controleForm.listarTodasEntidades}\"><div ui-view=\"atendimento-form\" \nclass=\"h-full flex flex-col\"></div></md-content><md-content style=\"max-height: 70%\"><div ui-view=\"atendimentos-tabela\" \nng-if=\"vm.controleForm.listarTodasEntidades\"></div></md-content></div>");
$templateCache.put("app/main/atendimento/processamento/atendimento/views/atendimentos-tabela.html","<div layout=\"column\" flex><div class=\"md-padding md-background-bg md-whiteframe-1dp fullpage-datatable\"><table \nclass=\"dataTable row-border hover\" datatable=\"ng\" dt-options=\"vm.dtOptions\" width=\"100%\"><thead><tr><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Ação</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Código</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Ano</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Tipo</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Cliente</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Solução</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Status</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Assunto</span></div></th></tr></thead>\n<tbody><tr ng-repeat=\"atendimento in vm.atendimentos\"><td class=\"button-icone-cor-azul\"><i \nclass=\"icon-pencil s16 icone-cor-padrao\" ng-click=\"vm.controleForm.emProgresso || vm.metodos.selecionar(atendimento)\" \nng-disabled=\"vm.controleForm.emProgresso\"><md-tooltip><label translate=\"ATENDIMENTO.SELECIONAR_ATENDIMENTO\"></label>\n</md-tooltip></i></td><td>{{atendimento.codigo}}</td><td>{{atendimento.ano}}</td><td>\n{{atendimento.displayTipoAtendimento}}</td><td>{{atendimento.cliente.nome}}</td><td>{{atendimento.solucao.descricao}}\n</td><td>{{atendimento.displayStatusAtendimento}}</td><td>{{atendimento.assunto}}</td></tr></tbody></table></div></div>");
$templateCache.put("app/main/atendimento/processamento/atendimento/views/historico-atendimentos-tabela.html","<table class=\"dataTable hover tabela-historico-atendimento\" id=\"id-{{vm.idTabelaHistoricoAtendimento}}\" datatable=\"ng\" \ndt-options=\"vm.dtOptionsHistoricoAtendimento\" width=\"100%\"><thead><tr><th></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Data Atendimento</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Data Registro</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Técnico</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Contato</span></div></th></tr></thead><tbody><tr \nng-repeat=\"historicoAtendimento in vm.historicoAtendimentos\" \nng-click=\"vm.metodos.selecionarHistoricoAtendimento($index, historicoAtendimento)\"><td><md-icon ng-show=\"$index == 0\" \nng-style=\"{\'color\': \'rgb(3,155,229)\'}\" \nng-click=\"vm.metodos.abrirDialogHistorico($event, historicoAtendimento, $index)\" md-font-icon=\"icon-pencil s20\">\n</md-icon><md-icon ng-style=\"{\'color\': \'rgb(3,155,229)\'}\" ng-if=\"$index == vm.indexHistoricoAtendimento\" \nmd-font-icon=\"icon-chevron-right s30\"></md-icon></td><td>{{historicoAtendimento.data | date: \'dd/MM/yyyy - HH:mm:ss\'}}\n</td><td>{{historicoAtendimento.dataRegistro | date: \'dd/MM/yyyy - HH:mm:ss\'}}</td><td>\n{{historicoAtendimento.usuario.login}}</td><td>{{historicoAtendimento.contato}}</td></tr></tbody></table>");
$templateCache.put("app/main/atendimento/processamento/atendimento/views/toolbar-atendimento.html","<md-fab-speed-dial md-direction=\"left\" style=\"position: absolute; right: 1em; top: 13em; z-index: 999\" \nlayout-align=\"end start\" ng-init=\"menuAberto = false\"><md-fab-trigger><md-button aria-label=\"menu\" \nclass=\"md-fab md-accent md-icon-button botao-menu\" ng-click=\"menuAberto = !menuAberto\"><md-icon ng-disabled=\"true\" \nmd-font-icon=\"icon-menu s26\"></md-icon><md-icon class=\"s12 icone-contrato-risco-menu\" \nmd-font-icon=\"icon-checkbox-blank-circle\" ng-if=\"vm.atendimento.riscoRescisaoContratual && !menuAberto\" \nlayout-align=\"end end\"></md-icon></md-button></md-fab-trigger><md-fab-actions ng-show=\"menuAberto\"><div \nlayout=\"column\" style=\"position:relative\" flex-offset-xs=\"5\"><md-button \nng-disabled=\"!vm.controleForm.pesquisaAtiva && !vm.controleForm.inserirAtivo\r\n                    || !vm.atendimento.tipo\r\n                    || !vm.atendimento.codigoCliente\r\n                    || !vm.atendimento.codigoAtendimentoMotivo\r\n                    || (vm.atendimento.status == 1 && !vm.atendimento.dataPrevisaoFechamento)\r\n                    || (vm.atendimento.status == 1 && !vm.atendimento.codigoAtendimentoPendencia)\r\n                    || !vm.atendimento.status\r\n                    || (vm.atendimento.status == 2 && vm.usuarioLogado.usuario.clsSetor.codigo == 3 && vm.atendimento.tags.length == 0)\r\n                    || !vm.atendimento.assunto\r\n                    || vm.controleForm.listarTodasEntidades\" \nclass=\"md-fab md-raised md-mini md-accent\" ng-click=\"vm.metodos.abrirDialogHistorico($event)\" \naria-label=\"Inserir Histórico\" translate><md-icon md-font-icon=\"icon-plus\"></md-icon><md-tooltip><label>\nCadastrar novo histórico</label></md-tooltip></md-button></div><div layout=\"column\" style=\"position:relative\" \nflex-offset-xs=\"5\"><div ng-if=\"vm.atendimento.quantidadeAnexos > 0\" class=\"md-warn-bg contador-arquivos-anexados\">\n{{vm.atendimento.quantidadeAnexos > 99 ? \"99+\" : vm.atendimento.quantidadeAnexos }}</div><md-button \nclass=\"md-fab md-raised md-mini md-accent\" aria-label=\"Anexos\" translate \nng-disabled=\"!vm.controleForm.pesquisaAtiva || vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo\" \nng-click=\"vm.metodos.abrirDialogAnexoArquivos($event)\"><md-icon md-font-icon=\"icon-paperclip s24\"></md-icon><md-tooltip\n md-autohide><span translate=\"ATENDIMENTO.ANEXOS\"></span></md-tooltip></md-button></div><div layout=\"column\" \nstyle=\"position:relative\" flex-offset-xs=\"5\"><md-button class=\"md-fab md-raised md-mini md-accent\" \naria-label=\"Acompanhantes do Atendimento\" translate \nng-disabled=\"!vm.controleForm.pesquisaAtiva && !vm.controleForm.inserirAtivo\" \nng-click=\"vm.metodos.abrirDialogColaboradoresHaNotificar($event)\"><md-icon md-font-icon=\"icon-account-alert s24\">\n</md-icon><md-tooltip md-autohide><span translate=\"ATENDIMENTO.NOTIFICAR_ATENDIMENTO\"></span></md-tooltip></md-button>\n</div><div layout=\"column\" style=\"position:relative\" flex-offset-xs=\"5\"><md-button \nclass=\"md-fab md-raised md-mini md-accent\" \nng-hide=\"vm.templateSelecionadoEstoriaTarefa.view == \'viewTabelaTarefasDaEstoria\'\" \nng-disabled=\"!vm.controleForm.pesquisaAtiva && !vm.controleForm.inserirAtivo\" \naria-label=\"Acompanhantes do Atendimento\" translate translate-attr-aria-label=\"ESTORIA.VOLTAR_TABELA_TAREFAS\" \nng-click=\"vm.metodos.abrirDialogColaboradoresHaVisualizar($event)\"><md-icon md-font-icon=\"icon-eye s24\"></md-icon>\n<md-tooltip md-autohide><span translate=\"ATENDIMENTO.VISUALIZAR_ATENDIMENTO\"></span></md-tooltip></md-button></div><div\n layout=\"column\" style=\"position:relative\" flex-offset-xs=\"5\"><md-button class=\"md-fab md-raised md-mini md-accent\" \naria-label=\"Agenda\" translate \nng-disabled=\"!vm.controleForm.pesquisaAtiva || vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo || vm.controleForm.emProgresso\" \nng-click=\"vm.metodos.abrirDialogAgenda($event)\"><md-icon md-font-icon=\"icon-calendar-clock s24\"></md-icon><md-tooltip \nmd-autohide><span translate=\"ATENDIMENTO.AGENDA\"></span></md-tooltip></md-button></div><div layout=\"column\" \nstyle=\"position:relative\" flex-offset-xs=\"5\"><md-button class=\"md-fab md-raised md-mini md-accent\" \naria-label=\"Histórias vinculadas\" translate \nng-disabled=\"!vm.controleForm.pesquisaAtiva || vm.controleForm.editarAtivo ||\r\n               vm.controleForm.inserirAtivo || vm.controleForm.emProgresso || !vm.atendimento.possuiVinculoHistoria\" \nng-click=\"vm.metodos.abrirDialogHistoriasVinculadas(vm.atendimento)\"><md-icon md-font-icon=\"icon-apps s24\"></md-icon>\n<md-tooltip md-autohide><span translate=\"ATENDIMENTO.HISTORIAS_VINCULADAS\"></span></md-tooltip></md-button></div><div \nlayout=\"column\" style=\"position:relative\" flex-offset-xs=\"5\"><md-button class=\"md-fab md-raised md-mini md-accent\" \naria-label=\"Ordens de Serviço\" translate \nng-disabled=\"!vm.controleForm.pesquisaAtiva || vm.controleForm.editarAtivo ||\r\n     vm.controleForm.inserirAtivo || vm.controleForm.emProgresso || vm.ordensServicos.length === 0\" \nng-click=\"vm.metodos.abrirDialogOrdensDeServicos(vm.atendimento.ordensServicos)\"><md-icon md-font-icon=\"icon-cog s24\">\n</md-icon><md-tooltip md-autohide><span translate=\"ATENDIMENTO.ORDENS_SERVICO\"></span></md-tooltip></md-button></div>\n<div layout=\"column\" style=\"position:relative\" flex-offset-xs=\"5\"><md-button \nclass=\"md-fab md-raised md-mini md-accent\" ng-click=\"vm.metodos.abrirDialogContratos($event)\" \naria-label=\"Gerenciamento de contratos\" \nng-disabled=\"!vm.controleForm.pesquisaAtiva || vm.controleForm.editarAtivo ||\r\n     vm.controleForm.inserirAtivo || vm.controleForm.emProgresso\">\n<md-icon md-font-icon=\"icon-clipboard-text s20\"></md-icon><md-icon class=\"s12 icone-contrato-risco\" \nmd-font-icon=\"icon-checkbox-blank-circle\" ng-if=\"vm.atendimento.riscoRescisaoContratual\" layout-align=\"end end\">\n</md-icon><md-tooltip md-autohide><span>Gerenciamento de contratos</span></md-tooltip></md-button></div><div \nlayout=\"column\" style=\"position:relative\" flex-offset-xs=\"5\"><md-button class=\"md-fab md-raised md-mini md-accent\" \naria-label=\"Negócios em andamento\" ng-if=\"vm.exibirBotaoNegocios\" \nng-click=\"vm.metodos.abrirDialogNegociosEmAndamento($event)\" \nng-disabled=\"!vm.controleForm.pesquisaAtiva || vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo || vm.controleForm.emProgresso\">\n<md-icon md-font-icon=\"icon-currency-usd s20\"></md-icon><md-tooltip md-autohide><span>Negócios em andamento</span>\n</md-tooltip></md-button></div><div layout=\"column\" style=\"position:relative\" flex-offset-xs=\"5\"><md-button \nclass=\"md-fab md-raised md-mini md-accent\" aria-label=\"Característica\" \nng-click=\"vm.metodos.abrirDialogCaracteristica($event)\" \nng-disabled=\"!vm.controleForm.pesquisaAtiva || vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo || vm.controleForm.emProgresso\">\n<md-icon md-font-icon=\"icon-clipboard-outline s20\"></md-icon><md-tooltip md-autohide><span>Característica do cliente\n</span></md-tooltip></md-button></div></md-fab-actions></md-fab-speed-dial>");
$templateCache.put("app/main/agenda/cadastro/evento/views/evento-form.html","<div class=\"md-background-bg md-whiteframe-1dp\"><form name=\"vm.form.evento\" novalidate><pg-toolbar \nentidades=\"vm.pendenciasAtendimento\" entidade=\"vm.evento\" entidade-de-envio=\"vm.entidadeDeEnvio\" \ncontrolador-toolbar=\"vm.controleForm\" acao-pesquisar=\"vm.metodos.pesquisar()\" \nacao-criar=\"vm.metodos.salvar(vm.evento)\" acao-editar=\"vm.metodos.editar(vm.evento)\" \nacao-excluir=\"vm.metodos.excluir(vm.evento)\" construir-dt-options=\"vm.metodos.construirDtOptions()\" \nmetodos-externos=\"vm.metodosExternosPgToolbar\" campo-pesquisar=\"vm.pesquisar\"></pg-toolbar><md-content layout-padding \nng-hide=\"vm.controleForm.listarTodasEntidades\" ng-disabled=\"vm.controleForm.emProgresso\"><div class=\"form-container\">\n<div layout-gt-xs=\"row\"><div layout=\"row\"><md-input-container class=\"md-block\" flex-gt-sm \nng-hide=\"vm.controleForm.inserirAtivo\"><label translate=\"AGENDA.CODIGO\"></label><input type=\"text\" \nng-disabled=\"vm.controleForm.editarAtivo\" ng-model=\"vm.evento.codigo\" name=\"codigo\" mascara-numero-generica=\"#####\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo\">\n</md-input-container></div><md-input-container class=\"md-block\" flex><label translate=\"AGENDA.DESCRICAO\"></label><input\n type=\"text\" ng-model=\"vm.evento.descricao\" name=\"descricao\" mascara-tamanho-campo=\"50\" \nng-required=\"vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo\" md-maxlength=\"50\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\"><div \nng-messages=\"vm.form.evento.descricao.$error\"><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container></div><div layout=\"row\" flex \nlayout-align=\"start center\"><input-container class=\"md-block\"><md-checkbox ng-model=\"vm.evento.ultilizarAlertaEvento\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\"><span \nclass=\"float-label-cor-default\">Utilizar alerta de evento</span></md-checkbox></input-container><md-input-container \nclass=\"ml-20\" ng-show=\"vm.evento.ultilizarAlertaEvento\"><label>Hora do alerta</label><md-select \nng-model=\"vm.evento.horaEvento\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\"><md-option\n ng-repeat=\"hora in vm.horaEvento\" ng-value=\"hora.valor\">{{hora.nome}}</md-option></md-select></md-input-container>\n</div></div></md-content></form></div>");
$templateCache.put("app/main/agenda/cadastro/evento/views/evento-tabela.html","<div layout=\"column\" flex><div class=\"md-padding md-background-bg md-whiteframe-1dp fullpage-datatable\" \nlayout=\"column\" flex><table class=\"dataTable row-border hover\" id=\"datatable-pendencia\" width=\"100%\"><thead><tr><th>\nAção</th><th>Código</th><th>Descrição</th></tr></thead></table></div></div>");
$templateCache.put("app/main/agenda/cadastro/evento/views/evento.html","<div id=\"pendencia-atendimento\" class=\"page-layout simple tabbed\" layout=\"column\"><header-padrao \ntranslate-nome=\"AGENDA.EVENTO\" ng-utiliza-pesquisa=\"false\"></header-padrao><div class=\"content\"><div \nui-view=\"evento-form\"></div></div><div ui-view=\"evento-tabela\" ng-if=\"vm.controleForm.listarTodasEntidades\"></div>\n</div>");
$templateCache.put("app/main/atendimento/consulta/atendimento/views/consulta-atendimento-form.html","<div id=\"consulta-atendimento\" class=\"\" layout=\"row\"><div layout=\"column\" flex><form name=\"vm.form\" \nng-disabled=\"vm.requisicaoSolicitada\" novalidate><md-content layout-padding><div layout=\"column\" \nlayout-align=\"center center\" ng-show=\"vm.requisicaoSolicitada\"><span class=\"font-weight-500\">{{vm.mensagemPreloader}}\n</span><md-progress-circular md-mode=\"indeterminate\" md-diameter=\"30\" class=\"md-accent\"></md-progress-circular></div>\n<div layout=\"row\" layout-align=\"center center\"><label translate=\"CONSULTA_ATENDIMENTO.PERIODO_ATENDIMENTOS\">\nPeríodo dos atendimento:</label><md-input-container class=\"mt-30\"><label \ntranslate=\"CONSULTA_ATENDIMENTO.PERIODO_INCIAL\"></label><md-datepicker \nng-model=\"vm.consultaAtendimento.periodoInicial\" name=\"periodoInicial\" \nmd-max-date=\"vm.consultaAtendimento.periodoFinal\" mascara-conversor-string-para-data ng-mask=\"3?9/1?9/9999\" \nng-disabled=\"vm.requisicaoSolicitada\" ng-required=\"true\"></md-datepicker><div \nng-messages=\"vm.form.periodoInicial.$error\"><div ng-message=\"valid\" translate=\"MENSAGEM_VALIDACAO.DATA_INVALIDA\"></div>\n<div ng-message=\"required\" translate=\"MENSAGEM_VALIDACAO.DATA_OBRIGATORIA\"></div><div ng-message=\"maxdate\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_DATA_INICIAL\"></div></div></md-input-container><label class=\"ml-15\" \ntranslate=\"CONSULTA_ATENDIMENTO.A\">a</label><md-input-container class=\"mt-30\"><label \ntranslate=\"CONSULTA_ATENDIMENTO.PERIODO_FINAL\"></label><md-datepicker ng-model=\"vm.consultaAtendimento.periodoFinal\" \nname=\"periodoFinal\" md-min-date=\"vm.consultaAtendimento.periodoInicial\" mascara-conversor-string-para-data \nng-mask=\"3?9/1?9/9999\" ng-disabled=\"vm.requisicaoSolicitada\" ng-required=\"true\"></md-datepicker><div \nng-messages=\"vm.form.periodoFinal.$error\"><div ng-message=\"valid\" translate=\"MENSAGEM_VALIDACAO.DATA_INVALIDA\"></div>\n<div ng-message=\"mindate\" translate=\"MENSAGEM_VALIDACAO.CAMPO_DATA_FINAL\"></div><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.DATA_OBRIGATORIA\"></div><div ng-message=\"maxdate\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_DATA_INICIAL\"></div></div></md-input-container></div><div layout=\"row\" \nlayout-align=\"center center\"><fieldset><legend translate=\"CONSULTA_ATENDIMENTO.TIPO_DETALHE_ATENDIMENTO\">\nTipo de Detalhe do Atendimento</legend><md-radio-group ng-model=\"vm.consultaAtendimento.tipoDetalheAtendimento\" \nlayout=\"row\" \nng-change=\"vm.metodos.ngChangeRadioGroupTipoDetalheAtendimento(vm.consultaAtendimento.tipoDetalheAtendimento)\" \nlayout-padding><md-radio-button value=\"{{key}}\" ng-repeat=\"(key, value) in vm.listarTipoDetalheAtendimento\" \nng-disabled=\"vm.requisicaoSolicitada\" aria-label=\"{{value}}\"><label>{{value}}</label></md-radio-button>\n</md-radio-group></fieldset></div><div layout=\"row\" layout-align=\"center center\" class=\"mt-15\" layout-padding flex>\n<md-autocomplete flex=\"33\" ng-model-options=\"{debounce: 200}\" md-input-name=\"cliente\" \nng-disabled=\"vm.requisicaoSolicitada\" md-no-cache=\"true\" ng-blur=\"vm.metodos.configuraAutoCompleteClienteOnBlur()\" \nmd-selected-item=\"vm.cliente\" md-selected-item-change=\"vm.metodos.alterarItemSelecionadoAutoCompleteCliente(item)\" \nmd-search-text=\"vm.textoDePesquisaAutoCompleteCliente\" \nmd-items=\"item in vm.metodos.pesquisarAutoCompleteCliente(vm.textoDePesquisaAutoCompleteCliente)\" \nmd-item-text=\"item.codigo + \' - \' + item.nome\" md-autoselect md-floating-label=\"Cliente\"><md-item-template><span \nmd-highlight-text=\"vm.textoDePesquisaAutoCompleteCliente\">{{item.codigo}} - {{item.nome}}</span></md-item-template>\n<md-not-found><label>Não foi encontrado nenhum Cliente.</label></md-not-found></md-autocomplete><md-autocomplete \nflex=\"33\" md-input-name=\"solucao\" ng-disabled=\"vm.requisicaoSolicitada\" md-no-cache=\"true\" \nng-blur=\"vm.metodos.configuraAutoCompleteSolucaoOnBlur()\" md-selected-item=\"vm.solucao\" \nmd-selected-item-change=\"vm.metodos.alterarItemSelecionadoAutoCompleteSolucao(item)\" \nmd-search-text=\"vm.textoDePesquisaAutoCompleteSolucao\" \nmd-items=\"item in vm.metodos.pesquisarAutoCompleteSolucao(vm.textoDePesquisaAutoCompleteSolucao)\" \nmd-item-text=\"item.descricao\" md-autoselect md-floating-label=\"Solução\" md-min-length=\"0\"><md-item-template><span \nmd-highlight-text=\"vm.textoDePesquisaAutoCompleteSolucao\">{{item.descricao}}</span></md-item-template><md-not-found>\n<label>Não foi encontrado nenhuma Solução.</label></md-not-found></md-autocomplete><md-autocomplete flex=\"33\" \nng-required=\"vm.consultaAtendimento.tipoDetalheAtendimento == 1\" \nng-disabled=\"vm.consultaAtendimento.tipoDetalheAtendimento != 1\" md-input-name=\"colaborador\" \nng-disabled=\"vm.requisicaoSolicitada\" md-no-cache=\"true\" ng-blur=\"vm.metodos.configuraAutoCompleteUsuarioOnBlur()\" \nmd-selected-item=\"vm.usuario\" md-selected-item-change=\"vm.metodos.alterarItemSelecionadoAutoCompleteUsuario(item)\" \nmd-search-text=\"vm.textoDePesquisaAutoCompleteUsuario\" \nmd-items=\"item in vm.metodos.pesquisarAutoCompleteUsuario(vm.textoDePesquisaAutoCompleteUsuario)\" \nmd-item-text=\"item.codigo + \' - \' + item.nome\" md-autoselect md-floating-label=\"Colaborador\" md-min-length=\"0\">\n<md-item-template><span md-highlight-text=\"vm.textoDePesquisaAutoCompleteUsuario\">{{item.codigo}} - {{item.nome}}\n</span></md-item-template><md-not-found><label>Não foi encontrado nenhum Colaborador.</label></md-not-found><div \nng-messages=\"vm.form.colaborador.$error\"><div ng-message=\"required\" translate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\">\n</div></div></md-autocomplete></div><div layout=\"row\" layout-align=\"space-around center\"><div layout=\"row\"><fieldset>\n<legend translate=\"CONSULTA_ATENDIMENTO.TIPO_ATENDIMENTO\">Tipo Atendimento</legend><md-radio-group \nng-model=\"vm.consultaAtendimento.tipoAtendimento\" layout=\"row\" layout-padding><md-radio-button value=\"{{key}}\" \nng-repeat=\"(key, value) in vm.listarTiposAtendimento\" ng-disabled=\"vm.requisicaoSolicitada\" aria-label=\"{{value}}\">\n<label>{{value}}</label></md-radio-button><md-radio-button value=\"3\" ng-disabled=\"vm.requisicaoSolicitada\" \naria-label=\"Geral\"><label>Geral</label></md-radio-button></md-radio-group></fieldset></div><div layout=\"row\"><fieldset>\n<legend translate=\"CONSULTA_ATENDIMENTO.STATUS_ATENDIMENTO\">Status Atendimento</legend><md-radio-group \nng-model=\"vm.consultaAtendimento.statusAtendimento\" layout=\"row\" layout-padding><md-radio-button value=\"{{key}}\" \nng-repeat=\"(key, value) in vm.listarStatusAtendimento\" ng-disabled=\"vm.requisicaoSolicitada\" aria-label=\"{{value}}\">\n<label>{{value}}</label></md-radio-button><md-radio-button value=\"3\" ng-disabled=\"vm.requisicaoSolicitada\" \naria-label=\"Ambos\"><label>Ambos</label></md-radio-button></md-radio-group></fieldset></div></div></md-content>\n<md-button class=\"md-raised md-accent button-fixo\" aria-label=\"Pesquisar\" translate \ntranslate-attr-aria-label=\"CONSULTA_ATENDIMENTO.PESQUISAR\" \nng-click=\"vm.metodos.pesquisar(vm.consultaAtendimento, $event)\" \nng-disabled=\"vm.form.$invalid || vm.requisicaoSolicitada\"><span translate=\"CONSULTA_ATENDIMENTO.PESQUISAR\"></span>\n</md-button></form></div></div>");
$templateCache.put("app/main/atendimento/consulta/atendimento/views/consulta-atendimento.html","<div layout=\"column\" class=\"page-layout carded fullwidth\"><header-padrao \ntranslate-nome=\"CONSULTA_ATENDIMENTO.CONSULTA_ATENDIMENTO\" icone=\"\" \nliberar-pesquisa-quando-datatable-ativo=\"vm.habilitarPesquisarHeaderPadrao || vm.pesquisaAtiva\" \npesquisar=\"vm.pesquisar\"></header-padrao><md-content class=\"content\" ng-if=\"!vm.pesquisaAtiva\" flex ms-scroll><div \nng-include=\"vm.rotasHtml.consultaAtendimentoForm\"></div></md-content><div \nng-include=\"vm.rotasHtml.tabelaConsultaAtendimento\" ng-if=\"vm.pesquisaAtiva\" flex></div></div>");
$templateCache.put("app/main/atendimento/consulta/atendimento/views/tabela-consulta-atendimento.html","<div class=\"page-layout carded fullwidth\" flex id=\"consulta-atendimento\" layout=\"row\"><div layout=\"column\" flex><div \nlayout=\"row\" class=\"md-background-bg\"><div layout-align=\"start center\" flex layout=\"row\"><md-button \nclass=\"array-buttons-consulta-atendimentos\" aria-label=\"{{item.descricao}}\" \nng-repeat=\"item in vm.legendaCoresConsultaAtendimento\" \nng-class=\"{\'descricao-selecionada\': vm.legendaSelecionada == $index}\" \nng-click=\"vm.metodos.filtrarTabela(item, $index)\"><md-icon md-font-icon=\"icon-label\" class=\"s16\" \nng-style=\"{\'color\' : item.cor}\"></md-icon><span class=\"title\">{{item.descricao}}</span></md-button></div><div \nlayout=\"row\" flex layout-align=\"end end\"><md-button class=\"md-raised md-accent\" aria-label=\"Nova Consulta\" translate \ntranslate-attr-aria-label=\"CONSULTA_ATENDIMENTO.NOVA_CONSULTA\" ng-click=\"vm.metodos.novaConsulta();\"><span \ntranslate=\"CONSULTA_ATENDIMENTO.NOVA_CONSULTA\"></span></md-button></div></div><div \nclass=\"md-background-bg md-whiteframe-1dp fullpage-datatable\" layout=\"column\" flex><table \nclass=\"dataTable row-border hover\" datatable=\"ng\" dt-options=\"vm.dtOptions\"><thead><tr><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title text-left\">Ação</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title text-left\">Código</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title text-left\">Ano</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title text-left\">Data</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title text-left\">Status</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title text-left\">Tipo</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title text-left\">Solução</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title text-left\">Colaborador</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title text-left\">Cliente</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title text-left\">Data Conclusão</span></div></th><th class=\"secondary-text\">\n<div class=\"table-header\"><span class=\"column-title text-left\">Pendência</span></div></th><th class=\"secondary-text\">\n<div class=\"table-header\"><span class=\"column-title text-left\">Assunto</span></div></th></tr></thead><tbody><tr \nng-repeat=\"consultaAtendimento in vm.listaAtendimentosConsultados\"><td><i class=\"icon-pencil s16 icone-cor-padrao\" \nng-click=\"vm.metodos.navegarParaAtendimento(consultaAtendimento, $index)\"></i></td><td>\n{{consultaAtendimento.codigoAtendimento}}</td><td>{{consultaAtendimento.anoAtendimento}}</td><td>\n{{consultaAtendimento.data | date: \"dd/MM/yyyy \'-\' HH:mm:ss\"}}</td><td \nng-class=\"{\'atendimento-aberto\': consultaAtendimento.codigoSituacao == 1, \r\n                                       \'atendimento-fechado\': consultaAtendimento.codigoSituacao == 2}\">\n{{consultaAtendimento.descricacaoSituacao}}</td><td>{{consultaAtendimento.descricaoTipo}}</td><td>\n{{consultaAtendimento.descricaoSolucao}}</td><td>{{consultaAtendimento.nomeUsuario}}</td><td>\n{{consultaAtendimento.nomeCliente}}</td><td>{{consultaAtendimento.dataFechamento | date: \"dd/MM/yyyy\"}}</td><td>\n{{consultaAtendimento.descricaoPendencia}}</td><td>{{consultaAtendimento.assunto.substring(0, 120)}}</td></tr></tbody>\n</table></div></div></div>");
$templateCache.put("app/main/agenda/cadastro/parametros/views/parametros-form.html","<div class=\"md-background-bg md-whiteframe-1dp\" id=\"cadastro-agenda-parametros\"><form name=\"vm.form.parametros\" \nnovalidate><pg-toolbar entidades=\"vm.cadastroParametros\" entidade=\"vm.parametros\" \nentidade-de-envio=\"vm.entidadeDeEnvio\" controlador-toolbar=\"vm.controleForm\" acao-pesquisar=\"vm.metodos.pesquisar()\" \nacao-criar=\"vm.metodos.salvar(vm.parametros)\" acao-editar=\"vm.metodos.editar(vm.parametros)\" \nacao-excluir=\"vm.metodos.excluir(vm.parametros)\" construir-dt-options=\"vm.metodos.construirDtOptions()\" \nmetodos-externos=\"vm.metodosExternosPgToolbar\" campo-pesquisar=\"vm.pesquisar\" desabilitar-botao-excluir=\"true\" \ndesabilitar-botao-inserir=\"true\"></pg-toolbar><md-content layout-padding \nng-hide=\"vm.controleForm.listarTodasEntidades\" ng-disabled=\"vm.controleForm.emProgresso\"><div class=\"form-container\">\n<div layout-gt-xs=\"row\"><div layout=\"row\"><md-input-container class=\"md-block\" flex-gt-sm \nng-hide=\"vm.controleForm.inserirAtivo\"><label translate=\"AGENDA.CODIGO\"></label><input type=\"text\" \nng-disabled=\"vm.controleForm.pesquisaAtiva\" ng-model=\"vm.parametros.codigo\" name=\"codigo\" \nmascara-numero-generica=\"#####\"></md-input-container></div><md-input-container class=\"md-block\" flex><label \ntranslate=\"AGENDA.DESCRICAO\"></label><input type=\"text\" ng-model=\"vm.parametros.descricaoSetor\" name=\"descricaoSetor\" \nmascara-tamanho-campo=\"50\" md-maxlength=\"50\" ng-disabled=\"vm.controleForm.pesquisaAtiva\"><div \nng-messages=\"vm.form.parametros.descricaoSetor.$error\"><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container></div><div layout-gt-xs=\"row\">\n<fieldset class=\"standard fieldset-legend-switch\"><legend style=\"display: flex; align-items: center; gap: 10px\" \nng-style=\"{\'color\': (vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo) ? \'rgba(0, 0, 0, 0.6)\' : \'\'}\">\n<span>Bloquear reagendamento por limite</span><md-switch aria-label=\"Bloquear reagendamento por limite\" \nname=\"bloquearReagendamentoPorLimite\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\" \nng-change=\"vm.metodos.onChangeBloquearReagendamentoPorLimite(vm.parametros.bloquearReagendamentoPorLimite)\" \nng-model=\"vm.parametros.bloquearReagendamentoPorLimite\"></md-switch></legend><md-input-container class=\"md-block\" \nstyle=\"margin-top: 5px\"><label>Número limite de reagendamento</label><input type=\"text\" \nng-model=\"vm.parametros.limiteReagendamento\" name=\"limiteReagendamento\" mascara-numero-generica=\"##\" \nng-disabled=\"(vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo) || ((vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo) && !vm.parametros.bloquearReagendamentoPorLimite)\" \nng-required=\"vm.controleForm.editarAtivo && vm.parametros.bloquearReagendamentoPorLimite\"><div \nng-messages=\"vm.form.parametros.limiteReagendamento.$error\"><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container></fieldset></div></div></md-content>\n</form></div>");
$templateCache.put("app/main/agenda/cadastro/parametros/views/parametros-tabela.html","<div layout=\"column\" flex><div class=\"md-padding md-background-bg md-whiteframe-1dp fullpage-datatable\" \nlayout=\"column\" flex><table class=\"dataTable row-border hover\" id=\"datatable-parametros\" width=\"100%\"><thead><tr><th>\nAção</th><th>Código</th><th>Descrição</th><th>Bloquear reagendamento por limite</th><th>Número limite de reagendamento\n</th></tr></thead></table></div></div>");
$templateCache.put("app/main/agenda/cadastro/parametros/views/parametros.html","<div id=\"agenda-parametros\" class=\"page-layout simple tabbed\" layout=\"column\"><header-padrao \ntranslate-nome=\"AGENDA.PARAMETROS\" ng-utiliza-pesquisa=\"false\"></header-padrao><div class=\"content\"><div \nui-view=\"parametros-form\"></div></div><div ui-view=\"parametros-tabela\" ng-if=\"vm.controleForm.listarTodasEntidades\">\n</div></div>");
$templateCache.put("app/main/atendimento/cadastro/conclusao-atendimento/views/conclusao-atendimento-form.html","<div class=\"md-background-bg md-whiteframe-1dp\"><form name=\"vm.form.conclusaoAtendimento\" novalidate><pg-toolbar \nentidade=\"vm.conclusao\" entidades=\"vm.conclusoes\" entidade-de-envio=\"vm.entidadeDeEnvio\" \ncontrolador-toolbar=\"vm.controleForm\" acao-pesquisar=\"vm.metodos.pesquisar()\" \nacao-criar=\"vm.metodos.salvar(vm.conclusao)\" acao-editar=\"vm.metodos.editar(vm.conclusao)\" \nacao-excluir=\"vm.metodos.excluir(vm.conclusao)\" construir-dt-options=\"vm.metodos.construirDtOptions()\" \nmetodos-externos=\"vm.metodosExternosPgToolbar\" campo-pesquisar=\"vm.pesquisar\"></pg-toolbar><md-content layout-padding \nng-hide=\"vm.controleForm.listarTodasEntidades\" ng-disabled=\"vm.controleForm.emProgresso\"><div class=\"form-container\">\n<div layout-gt-xs=\"row\" flex><md-input-container class=\"md-block\" flex><label \ntranslate=\"ATENDIMENTO_CONCLUCAO.DESCRICAO\"></label><input type=\"text\" ng-model=\"vm.conclusao.descricao\" \nname=\"descricao\" mascara-tamanho-campo=\"60\" ng-required=\"vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo\" \nmd-maxlength=\"60\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo \r\n                                            && !vm.controleForm.inserirAtivo\">\n<div ng-messages=\"vm.form.conclusaoAtendimento.descricao.$error\"><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container></div></div></md-content></form>\n</div>");
$templateCache.put("app/main/atendimento/cadastro/conclusao-atendimento/views/conclusao-atendimento.html","<div id=\"conclusao\" class=\"page-layout simple tabbed\" layout=\"column\"><header-padrao \ntranslate-nome=\"ATENDIMENTO_CONCLUCAO.ATENDIMENTO_CONCLUCAO\" \nliberar-pesquisa-quando-datatable-ativo=\"vm.controleForm.listarTodasEntidades\" pesquisar=\"vm.pesquisar\">\n</header-padrao><div class=\"content\"><div ui-view=\"conclusao-atendimento-form\"></div></div><div \nui-view=\"conclusoes-atendimento-tabela\" ng-if=\"vm.controleForm.listarTodasEntidades\"></div></div>");
$templateCache.put("app/main/atendimento/cadastro/conclusao-atendimento/views/conclusoes-atendimento-tabela.html","<div layout=\"column\" flex><div class=\"md-padding md-background-bg md-whiteframe-1dp fullpage-datatable\" \nlayout=\"column\" flex><table class=\"dataTable row-border hover\" id=\"datatable-conclusao-atendimento\" width=\"100%\">\n<thead><tr><th>Ação</th><th>Descrição</th></tr></thead></table></div></div>");
$templateCache.put("app/main/atendimento/cadastro/motivo-atendimento/views/motivo-atendimento-form.html","<div class=\"md-background-bg md-whiteframe-1dp\"><form name=\"vm.form.grupoAtendimento\" novalidate><pg-toolbar \nentidades=\"vm.gruposAtendimento\" entidade=\"vm.grupoAtendimento\" entidade-de-envio=\"vm.entidadeDeEnvio\" \ncontrolador-toolbar=\"vm.controleForm\" acao-pesquisar=\"vm.metodos.pesquisar()\" \nacao-criar=\"vm.metodos.salvar(vm.grupoAtendimento)\" acao-editar=\"vm.metodos.editar(vm.grupoAtendimento)\" \nacao-excluir=\"vm.metodos.excluir(vm.grupoAtendimento)\" construir-dt-options=\"vm.metodos.construirDtOptions()\" \nmetodos-externos=\"vm.metodosExternosPgToolbar\" campo-pesquisar=\"vm.pesquisar\" \npre-definir-campos-para-insercao=\"vm.metodos.definirAtivo()\" \nmetodo-externo-acao-nova-pesquisa=\"vm.metodos.metodoExternoAcaoNovaPesquisa()\"></pg-toolbar><md-content layout-padding \nng-hide=\"vm.controleForm.listarTodasEntidades\" ng-disabled=\"vm.controleForm.emProgresso\"><div class=\"form-container\">\n<div layout-gt-xs=\"row\"><div layout=\"row\"><md-input-container class=\"md-block\" flex-gt-sm><label \ntranslate=\"GRUPO_ATENDIMENTO.CODIGO\"></label><input type=\"text\" name=\"codigo\" \nid=\"atendimento-cadastro-motivoatendimento-codigo\" ng-model=\"vm.grupoAtendimento.codigo\" \nmascara-numero-generica=\"#####\" ng-required=\"vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\"><div \nng-messages=\"vm.form.grupoAtendimento.codigo.$error\"><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container><proximo-codigo \nng-show=\"vm.controleForm.inserirAtivo\" rota=\"vm.rota\" entidade-codigo=\"vm.grupoAtendimento.codigo\" \npre-loader-toolbar=\"vm.controleForm.preLoaderToolbar\"></proximo-codigo></div><md-input-container class=\"md-block\" flex \nflex-offset-gt-sm=\"5\"><label translate=\"GRUPO_ATENDIMENTO.TITULO\"></label><input type=\"text\" name=\"titulo\" \nid=\"atendimento-cadastro-motivoatendimento-titulo\" ng-model=\"vm.grupoAtendimento.titulo\" mascara-tamanho-campo=\"60\" \nng-required=\"vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo\" md-maxlength=\"60\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\"><div \nng-messages=\"vm.form.grupoAtendimento.titulo.$error\"><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container><md-input-container class=\"md-block\" \nflex-offset-gt-sm=\"5\"><md-checkbox ng-model=\"vm.grupoAtendimento.inativo\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\" \naria-label=\"Ativo\" name=\"ativo\" , ng-true-value=\"false\" ng-false-value=\"true\"><span class=\"float-label-cor-default\" \ntranslate=\"GRUPO_ATENDIMENTO.ATIVO\"></span></md-checkbox></md-input-container></div><div layout-gt-xs=\"row\">\n<md-input-container class=\"md-block\" flex><label translate=\"GRUPO_ATENDIMENTO.DESCRICAO\"></label><input type=\"text\" \nname=\"descricao\" id=\"atendimento-cadastro-motivoatendimento-descricao\" ng-model=\"vm.grupoAtendimento.descricao\" \nmascara-tamanho-campo=\"150\" ng-required=\"vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo\" \nmd-maxlength=\"150\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\"><div \nng-messages=\"vm.form.grupoAtendimento.descricao.$error\"><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container></div><div layout-gt-xs=\"row\">\n<md-input-container class=\"md-block\" flex-gt-sm=\"30\"><label translate=\"GRUPO_ATENDIMENTO.SETOR\"></label><md-select \nng-model=\"vm.grupoAtendimento.codigoSetor\" name=\"setorCodigo\" id=\"atendimento-cadastro-motivoatendimento-setor\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\" \nmultiple=\"multiple\" required><md-option ng-value=\"setor.codigo\" \nid=\"atendimento-cadastro-motivoatendimento-setor-option-{{$index}}\" \nng-repeat=\"setor in vm.setores track by setor.codigo\">{{setor.descricao}}</md-option></md-select></md-input-container>\n</div></div></md-content></form></div>");
$templateCache.put("app/main/atendimento/cadastro/motivo-atendimento/views/motivo-atendimento.html","<div id=\"motivo-atendimento\" class=\"page-layout simple tabbed\" layout=\"column\"><header-padrao \ntranslate-nome=\"GRUPO_ATENDIMENTO.GRUPO_ATENDIMENTO\" \nliberar-pesquisa-quando-datatable-ativo=\"vm.controleForm.listarTodasEntidades\" pesquisar=\"vm.pesquisar\">\n</header-padrao><div class=\"content\"><div ui-view=\"motivo-atendimento-form\"></div></div><div \nui-view=\"motivos-atendimento-tabela\" ng-if=\"vm.controleForm.listarTodasEntidades\"></div></div>");
$templateCache.put("app/main/atendimento/cadastro/motivo-atendimento/views/motivos-atendimento-tabela.html","<div layout=\"column\" flex><div class=\"md-padding md-background-bg md-whiteframe-1dp fullpage-datatable\" \nlayout=\"column\" flex><table class=\"dataTable row-border hover\" id=\"datatable-motivo-atendimento\" width=\"100%\"><thead>\n<tr><th>Ação</th><th>Código</th><th>Titulo</th><th>Descrição</th><th>Setor</th><th>Inativo</th></tr></thead></table>\n</div></div>");
$templateCache.put("app/main/atendimento/cadastro/configuracao-atendimento/views/configuracao-atendimento-form.html","<div class=\"md-background-bg md-whiteframe-1dp\"><form name=\"vm.form.configuracaoAtendimento\" novalidate>\n<toolbar-desktop-mobile controle-form=\"vm.controleForm\" entidades=\"vm.configuracoesAtendimento\" \nentidade=\"vm.configuracaoAtendimento\" pesquisar=\"vm.metodos.pesquisar()\" \neditar=\"vm.metodos.editar(vm.configuracaoAtendimento)\" ng-oculta-botao-pesquisar=\"true\" \nng-oculta-botao-nova-pesquisar=\"true\" ng-oculta-botao-excluir=\"true\" ng-oculta-botao-inserir=\"true\" \nng-utiliza-navegacao=\"false\" iniciar-chamando-pesquisa=\"true\"></toolbar-desktop-mobile><md-content layout-padding \nng-hide=\"vm.controleForm.listarTodasEntidades\" ng-disabled=\"vm.controleForm.emProgresso\"><div class=\"form-container\">\n<div layout-gt-xs=\"row\"><md-input-container class=\"md-block\" flex-gt-sm=\"30\"><label \ntranslate=\"CONFIGURACAO_ATENDIMENTO.LIMITE_ATENDIMENTOS_EM_ABERTO\"></label><input type=\"text\" \nng-model=\"vm.configuracaoAtendimento.quantidadeLimiteAtendimentosAberto\" name=\"quantidadeAtendimentosEmAberto\" \nmascara-numero-generica=\"###\" converte-mascara-para-numero \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo\"></md-input-container></div></div>\n</md-content></form></div>");
$templateCache.put("app/main/atendimento/cadastro/configuracao-atendimento/views/configuracao-atendimento.html","<div id=\"configuracao-atendimento\" class=\"page-layout simple tabbed\" layout=\"column\"><header-padrao \ntranslate-nome=\"CONFIGURACAO_ATENDIMENTO.CONFIGURACAO_ATENDIMENTO\" \nliberar-pesquisa-quando-datatable-ativo=\"vm.controleForm.listarTodasEntidades\" pesquisar=\"vm.pesquisar\">\n</header-padrao><div class=\"content\"><div ui-view=\"configuracao-atendimento-form\"></div></div></div>");
$templateCache.put("app/main/atendimento/cadastro/tag-atendimento/dialog-cadastro-tags/dialog-cadastro-tags.html","<md-dialog id=\"dialog-cadastro-tags\" class=\"dialogTable\" aria-label=\"Dialog\"><md-toolbar \nclass=\"md-accent md-tall toolbar-cadastro-tags\" flex><div \nclass=\"md-toolbar-tools md-toolbar-tools-top container-header\" layout-gt-xs=\"row\" layout=\"column\" \nlayout-align=\"space-between center\"><span class=\"title\">Cadastrar tags</span><div class=\"container-input-fechar\">\n<md-button class=\"md-icon-button\" aria-label=\"Fechar dialog\" translate \ntranslate-attr-aria-label=\"SPRINT.FECHAR_DIALOG\" ng-click=\"vm.metodos.fecharDialog()\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div></div></md-toolbar><md-dialog-content \nclass=\"dialog-cadastro-tags-content\"><div class=\"md-background-bg md-whiteframe-1dp\"><form \nname=\"vm.form.tagAtendimento\" novalidate><pg-toolbar entidade=\"vm.tagAtendimento\" entidades=\"vm.tagAtendimentos\" \nentidade-de-envio=\"vm.entidadeDeEnvio\" \npre-definir-campos-para-insercao=\"vm.metodosGeral.preDefinirCamposParaInserir()\" controlador-toolbar=\"vm.controleForm\" \nacao-pesquisar=\"vm.metodos.pesquisar()\" acao-criar=\"vm.metodos.salvar(vm.tagAtendimento)\" \nacao-editar=\"vm.metodos.editar(vm.tagAtendimento)\" acao-excluir=\"vm.metodos.excluir(vm.tagAtendimento)\" \ndesabilitar-botao-nova-pesquisa=\"true\" desabilitar-botao-pesquisar=\"true\" \ndesabilitar-botao-listar-todas-entidades=\"true\" desabilitar-botao-editar=\"true\" desabilitar-botao-excluir=\"true\" \niniciar-habilitando-insercao=\"true\" metodos-externos=\"vm.metodosExternosPgToolbar\" campo-pesquisar=\"vm.pesquisar\">\n</pg-toolbar><md-content layout-padding ng-hide=\"vm.controleForm.listarTodasEntidades\" \nng-disabled=\"vm.controleForm.emProgresso\"><div><div layout-gt-xs=\"row\" flex><md-input-container class=\"md-block\" \nflex-gt-sm=\"5\" ng-if=\"!vm.controleForm.inserirAtivo\"><label>Código</label><input type=\"text\" \nng-disabled=\"vm.controleForm.pesquisaAtiva\" ng-model=\"vm.tagAtendimento.codigo\" name=\"codigo\" \nmascara-numero-generica=\"#####\"></md-input-container><md-input-container class=\"md-block\" flex><label>Descrição</label>\n<input type=\"text\" ng-model=\"vm.tagAtendimento.descricao\" name=\"descricao\" mascara-tamanho-campo=\"60\" \nng-required=\"vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo\" md-maxlength=\"60\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo \r\n                                                    && !vm.controleForm.inserirAtivo\">\n<div ng-messages=\"vm.form.tagAtendimento.descricao.$error\"><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container><md-input-container class=\"md-block\" \nflex-gt-sm=\"25\"><label>Soluções</label><md-select ng-model=\"vm.tagAtendimento.solucoes\" name=\"solucoes\" \nmultiple=\"multiple\" md-on-open=\"vm.metodos.configuraMdSelectSolucoes()\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo \r\n                                           && !vm.controleForm.inserirAtivo\" \nng-required=\"vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo\"><md-select-header><input \nid=\"solucoes-md-select\" class=\"md-text\" ng-model=\"vm.filtrarSolucoes\" type=\"search\" placeholder=\"\" translate \ntranslate-attr-placeholder=\"Pesquisar soluções\"></md-select-header><md-option ng-value=\"solucao.codigo\" \nng-repeat=\"solucao in vm.listaSolucoes | filter:vm.filtrarSolucoes track by solucao.codigo\">{{solucao.descricao}}\n</md-option></md-select><div ng-messages=\"vm.form.tagAtendimento.solucoes.$error\"><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container><md-input-container \nclass=\"botao-ativo-pesquisa\" flex-gt-sm=\"10\"><md-switch aria-label=\"Ativa\" name=\"ativa\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\" \nng-model=\"vm.tagAtendimento.ativa\">Ativa</md-switch></md-input-container></div><div layout-gt-xs=\"row\" flex><fieldset \nclass=\"standard\" \nng-class=\"{\'fieldset-obrigatorio\': (vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo) && !vm.tagAtendimento.corIdentificacao}\">\n<legend class=\"grp-legend\" \nng-class=\"{\'titulo-fieldset-obrigatorio\': (vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo) && !vm.tagAtendimento.corIdentificacao}\">\nSelecione uma cor</legend><md-input-container class=\"md-block\" flex><div layout=\"row\" layout-wrap><div \nng-repeat=\"cor in vm.cores\" name=\"corIdentificacao\" \nng-required=\"vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo\" \nng-click=\"!vm.controleForm.pesquisaAtiva || vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo ? vm.metodos.selecionarCor(cor) : null\" \nng-model=\"vm.tagAtendimento.corIdentificacao\" \nng-style=\"{\'background-color\': cor.background, \'color\': cor.fonte, \'cursor\': \'pointer\', \'padding\': \'8px\', \'margin\': \'5px\', \'border-radius\': \'50%\', \'text-align\': \'center\'}\" \nng-class=\"{\'selecionada\': vm.corSelecionada === cor.fonte}\" style=\"width: 40px; height: 40px; position: relative\"><span\n ng-if=\"vm.tagAtendimento.corIdentificacao === cor.background\" class=\"check-icon\">✔</span></div></div><div \nng-if=\"(vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo) && !vm.tagAtendimento.corIdentificacao\" \nclass=\"container-mensagem-obrigatoria\" flex><span class=\"mensagem-obrigatoria\">Campo obrigatório</span></div>\n</md-input-container></fieldset></div></div></md-content></form></div></md-dialog-content></md-dialog>");
$templateCache.put("app/main/atendimento/cadastro/tag-atendimento/views/tag-atendimento-form.html","<div class=\"md-background-bg md-whiteframe-1dp\"><form name=\"vm.form.tagAtendimento\" novalidate><pg-toolbar \nentidade=\"vm.tagAtendimento\" entidades=\"vm.tagAtendimentos\" entidade-de-envio=\"vm.entidadeDeEnvio\" \npre-definir-campos-para-insercao=\"vm.metodosGeral.preDefinirCamposParaInserir()\" controlador-toolbar=\"vm.controleForm\" \nacao-pesquisar=\"vm.metodos.pesquisar()\" acao-criar=\"vm.metodos.salvar(vm.tagAtendimento)\" \nacao-editar=\"vm.metodos.editar(vm.tagAtendimento)\" acao-excluir=\"vm.metodos.excluir(vm.tagAtendimento)\" \nconstruir-dt-options=\"vm.metodos.construirDtOptions()\" metodos-externos=\"vm.metodosExternosPgToolbar\" \ncampo-pesquisar=\"vm.pesquisar\"></pg-toolbar><md-content layout-padding ng-hide=\"vm.controleForm.listarTodasEntidades\" \nng-disabled=\"vm.controleForm.emProgresso\"><div><div layout-gt-xs=\"row\" flex><md-input-container class=\"md-block\" \nflex-gt-sm=\"5\" ng-if=\"!vm.controleForm.inserirAtivo\"><label>Código</label><input type=\"text\" \nng-disabled=\"vm.controleForm.pesquisaAtiva\" ng-model=\"vm.tagAtendimento.codigo\" name=\"codigo\" \nmascara-numero-generica=\"#####\"></md-input-container><md-input-container class=\"md-block\" flex><label>Descrição</label>\n<input type=\"text\" ng-model=\"vm.tagAtendimento.descricao\" name=\"descricao\" mascara-tamanho-campo=\"60\" \nng-required=\"vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo\" md-maxlength=\"60\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo \r\n                                            && !vm.controleForm.inserirAtivo\">\n<div ng-messages=\"vm.form.tagAtendimento.descricao.$error\"><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container><md-input-container class=\"md-block\" \nflex-gt-sm=\"25\"><label>Soluções</label><md-select ng-model=\"vm.tagAtendimento.solucoes\" name=\"solucoes\" \nmultiple=\"multiple\" md-on-open=\"vm.metodos.configuraMdSelectSolucoes()\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo \r\n                                   && !vm.controleForm.inserirAtivo\" \nng-required=\"vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo\"><md-select-header><input \nid=\"solucoes-md-select\" class=\"md-text\" ng-model=\"vm.filtrarSolucoes\" type=\"search\" placeholder=\"\" translate \ntranslate-attr-placeholder=\"Pesquisar soluções\"></md-select-header><md-option ng-value=\"solucao.codigo\" \nng-repeat=\"solucao in vm.listaSolucoes | filter:vm.filtrarSolucoes track by solucao.codigo\">{{solucao.descricao}}\n</md-option></md-select><div ng-messages=\"vm.form.tagAtendimento.solucoes.$error\"><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container><md-input-container class=\"md-block\" \nflex-gt-sm=\"10\"><md-switch aria-label=\"Ativa\" name=\"ativa\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\" \nng-model=\"vm.tagAtendimento.ativa\">Ativa</md-switch></md-input-container></div><div layout-gt-xs=\"row\" flex><fieldset \nclass=\"standard\" \nng-class=\"{\'fieldset-obrigatorio\': (vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo) && !vm.tagAtendimento.corIdentificacao}\">\n<legend class=\"grp-legend\" \nng-class=\"{\'titulo-fieldset-obrigatorio\': (vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo) && !vm.tagAtendimento.corIdentificacao}\">\nSelecione uma cor</legend><md-input-container class=\"md-block\" flex><div layout=\"row\" layout-wrap><div \nng-repeat=\"cor in vm.cores\" name=\"corIdentificacao\" \nng-required=\"vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo\" \nng-click=\"!vm.controleForm.pesquisaAtiva || vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo ? vm.metodos.selecionarCor(cor) : null\" \nng-model=\"vm.tagAtendimento.corIdentificacao\" \nng-style=\"{\'background-color\': cor.background, \'color\': cor.fonte, \'cursor\': \'pointer\', \'padding\': \'8px\', \'margin\': \'5px\', \'border-radius\': \'50%\', \'text-align\': \'center\'}\" \nng-class=\"{\'selecionada\': vm.corSelecionada === cor.fonte}\" style=\"width: 40px; height: 40px; position: relative\"><span\n ng-if=\"vm.tagAtendimento.corIdentificacao === cor.background\" class=\"check-icon\">✔</span></div></div><div \nng-if=\"(vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo) && !vm.tagAtendimento.corIdentificacao\" \nclass=\"container-mensagem-obrigatoria\" flex><span class=\"mensagem-obrigatoria\">Campo obrigatório</span></div>\n</md-input-container></fieldset></div></div></md-content></form></div>");
$templateCache.put("app/main/atendimento/cadastro/tag-atendimento/views/tag-atendimento-tabela.html","<div layout=\"column\" flex><div class=\"md-padding md-background-bg md-whiteframe-1dp fullpage-datatable\" \nlayout=\"column\" flex><table class=\"dataTable row-border hover\" id=\"datatable-tag-atendimento\" width=\"100%\"><thead><tr>\n<th>Ação</th><th>Código</th><th>Descrição</th></tr></thead></table></div></div>");
$templateCache.put("app/main/atendimento/cadastro/tag-atendimento/views/tag-atendimento.html","<div id=\"tag-atendimento\" class=\"page-layout simple tabbed\" layout=\"column\"><header-padrao \ntranslate-nome=\"Tag atendimento\" liberar-pesquisa-quando-datatable-ativo=\"vm.controleForm.listarTodasEntidades\" \npesquisar=\"vm.pesquisar\"></header-padrao><div class=\"content\"><div ui-view=\"tag-atendimento-form\"></div></div><div \nui-view=\"tag-atendimento-tabela\" ng-if=\"vm.controleForm.listarTodasEntidades\"></div></div>");
$templateCache.put("app/main/atendimento/cadastro/pendencia-atendimento/views/pendencia-atendimento-form.html","<div class=\"md-background-bg md-whiteframe-1dp\"><form name=\"vm.form.pendenciaDeAtendimento\" novalidate><pg-toolbar \nentidades=\"vm.pendenciasAtendimento\" entidade=\"vm.pendenciaAtendimento\" entidade-de-envio=\"vm.entidadeDeEnvio\" \ncontrolador-toolbar=\"vm.controleForm\" acao-pesquisar=\"vm.metodos.pesquisar()\" \nacao-criar=\"vm.metodos.salvar(vm.pendenciaAtendimento)\" acao-editar=\"vm.metodos.editar(vm.pendenciaAtendimento)\" \nacao-excluir=\"vm.metodos.excluir(vm.pendenciaAtendimento)\" construir-dt-options=\"vm.metodos.construirDtOptions()\" \nmetodos-externos=\"vm.metodosExternosPgToolbar\" campo-pesquisar=\"vm.pesquisar\"></pg-toolbar><md-content layout-padding \nng-hide=\"vm.controleForm.listarTodasEntidades\" ng-disabled=\"vm.controleForm.emProgresso\"><div class=\"form-container\">\n<div layout-gt-xs=\"row\"><div layout=\"row\"><md-input-container class=\"md-block\" flex-gt-sm><label \ntranslate=\"PENDENCIA_ATENDIMENTO.CODIGO\"></label><input type=\"text\" ng-model=\"vm.pendenciaAtendimento.codigo\" \nname=\"codigo\" mascara-numero-generica=\"#####\" \nng-required=\"vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\"><div \nng-messages=\"vm.form.pendenciaDeAtendimento.codigo.$error\"><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container><proximo-codigo \nng-show=\"vm.controleForm.inserirAtivo\" rota=\"vm.rota\" entidade-codigo=\"vm.pendenciaAtendimento.codigo\" \npre-loader-toolbar=\"vm.controleForm.preLoaderToolbar\"></proximo-codigo></div><md-input-container class=\"md-block\" flex \nflex-offset-gt-sm=\"5\"><label translate=\"PENDENCIA_ATENDIMENTO.DESCRICAO\"></label><input type=\"text\" \nng-model=\"vm.pendenciaAtendimento.descricao\" name=\"descricao\" mascara-tamanho-campo=\"60\" \nng-required=\"vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo\" md-maxlength=\"60\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\"><div \nng-messages=\"vm.form.pendenciaDeAtendimento.descricao.$error\"><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container></div></div></md-content></form>\n</div>");
$templateCache.put("app/main/atendimento/cadastro/pendencia-atendimento/views/pendencia-atendimento.html","<div id=\"pendencia-atendimento\" class=\"page-layout simple tabbed\" layout=\"column\"><header-padrao \ntranslate-nome=\"PENDENCIA_ATENDIMENTO.PENDENCIA_ATENDIMENTO\" \nliberar-pesquisa-quando-datatable-ativo=\"vm.controleForm.listarTodasEntidades\" pesquisar=\"vm.pesquisar\">\n</header-padrao><div class=\"content\"><div ui-view=\"pendencia-atendimento-form\"></div></div><div \nui-view=\"pendencias-atendimento-tabela\" ng-if=\"vm.controleForm.listarTodasEntidades\"></div></div>");
$templateCache.put("app/main/atendimento/cadastro/pendencia-atendimento/views/pendencias-atendimento-tabela.html","<div layout=\"column\" flex><div class=\"md-padding md-background-bg md-whiteframe-1dp fullpage-datatable\" \nlayout=\"column\" flex><table class=\"dataTable row-border hover\" id=\"datatable-pendencia\" width=\"100%\"><thead><tr><th>\nAção</th><th>Código</th><th>Descrição</th></tr></thead></table></div></div>");
$templateCache.put("app/main/atendimento/estatisticas/tags/views/tags-atendimento-form.html","<div class=\"container-calendario-detalhes-estatistiscas\"><div class=\"container-estatisticas-tags-detalhes-atendimento\" \nng-class=\"{\'visualizacao-por-mes\': vm.tipoVisualizacaoCalendario == \'month\'}\"><div style=\"width:100%\" class=\"border\" \nng-include=\"vm.rotasHtml.components.graficoTags\"></div><div class=\"div-totalizador border\" \nng-include=\"vm.rotasHtml.components.totalizadorAtendimentos\"></div><div style=\"width:100%\" class=\"border\" \nng-include=\"vm.rotasHtml.components.graficoClientes\"></div></div><div id=\"calendario\" \nclass=\"content container-calendario\"><div id=\"calendarView\" ng-mousemove=\"vm.metodos.cursorPosition($event)\" \nui-calendar=\"vm.calendarUiConfig.calendar\" ng-model=\"vm.events\" calendar=\"main\"></div></div></div>");
$templateCache.put("app/main/atendimento/estatisticas/tags/views/tags-atendimento.html","<div id=\"estatisticas-tags-atendimento\" layout=\"column\" \nclass=\"page-layout simple fullwidth estatisticas-tags-atendimento\"><md-sidenav class=\"sidenav md-sidenav-right\" \nmd-component-id=\"filtro-estatisticas-tags\" md-whiteframe=\"4\" ms-scroll ms-sidenav-helper style=\"z-index: 999\"><div \nng-controller=\"FiltroEstatisticasTagsController as vm\"><div \nng-include=\"\'app/main/atendimento/estatisticas/tags/components/sidenavs/filtro/views/filtro-estatisticas-tags.html\'\">\n</div></div></md-sidenav><md-toolbar class=\"header\"><div class=\"header-content\" layout=\"column\" \nlayout-align=\"space-between\"><div class=\"header-top\" layout=\"row\" layout-align=\"space-between center\" \nlayout-xs=\"column\"><div class=\"logo\" hide-xs layout=\"row\" layout-align=\"start center\"><span class=\"logo-icon\"><md-icon \nmd-font-icon=\"icon-chart-bar\"></md-icon></span><span class=\"logo-text\">Estatisticas tags</span></div><div \nclass=\"toolbar\" layout=\"row\" layout-align=\"start center\"><md-button class=\"md-icon-button\" \nng-disabled=\"vm.emProgresso\" aria-label=\"Atualizar\" ng-click=\"vm.metodos.atualizarFiltro()\"><md-icon \nmd-font-icon=\"icon-refresh\"></md-icon><md-tooltip><span>Atualizar</span></md-tooltip></md-button><md-button \nclass=\"md-icon-button\" ng-click=\"vm.metodos.exibirLegenda()\" aria-label=\"Legenda\" translate \ntranslate-attr-aria-label=\"CALENDARIO.LEGENDA\"><md-icon md-font-icon=\"icon-information-outline\"></md-icon><md-tooltip>\n<span translate=\"CALENDARIO.LEGENDA\">Legenda</span></md-tooltip></md-button><md-button class=\"md-icon-button\" \naria-label=\"Hoje\" ng-click=\"vm.metodos.irParaHoje()\"><md-icon md-font-icon=\"icon-calendar-today\"></md-icon><md-tooltip>\n<span>Hoje</span></md-tooltip></md-button><md-button class=\"md-icon-button\" aria-label=\"Mês\" \nng-click=\"vm.metodos.alterarModoVisualizacao(\'month\')\"><md-icon md-font-icon=\"icon-view-week\"></md-icon><md-tooltip>\n<span>Mês</span></md-tooltip></md-button><md-button class=\"md-icon-button\" aria-label=\"Dia\" \nng-click=\"vm.metodos.alterarModoVisualizacao(\'agendaDay\')\"><md-icon md-font-icon=\"icon-view-day\"></md-icon><md-tooltip>\n<span>Dia</span></md-tooltip></md-button><md-button class=\"md-icon-button\" aria-label=\"Semana\" \nng-click=\"vm.metodos.alterarModoVisualizacao(\'agendaWeek\')\"><md-icon md-font-icon=\"icon-view-week\"></md-icon>\n<md-tooltip><span>Semana</span></md-tooltip></md-button></div></div><div class=\"header-bottom\" layout=\"row\" \nlayout-align=\"center center\"><md-button ng-click=\"vm.metodos.anterior()\" class=\"md-icon-button arrow\" \nng-disabled=\"vm.emProgresso\" aria-label=\"Anterior\"><md-icon md-font-icon=\"icon-chevron-left\"></md-icon></md-button><div\n class=\"title\" layout=\"column\" layout-align=\"center center\"><div ng-hide=\"vm.emProgresso\"><md-datepicker \nng-model=\"vm.dataSelecionada\" class=\"invisible\" md-placeholder=\"Enter date\" md-is-open=\"vm.datePicker.isOpen\" \nng-mask=\"3?9/1?9/9999\" md-mode=\"month\"></md-datepicker><span ng-click=\"vm.datePicker.isOpen = true\">\n{{vm.calendarView.title}}</span></div><md-progress-circular ng-show=\"vm.emProgresso\" style=\"color: white!important\" \nmd-diameter=\"18\" md-mode=\"indeterminate\"></md-progress-circular></div><md-button ng-click=\"vm.metodos.proximo()\" \nclass=\"md-icon-button arrow\" ng-disabled=\"vm.emProgresso\" aria-label=\"Próximo\"><md-icon \nmd-font-icon=\"icon-chevron-right\"></md-icon></md-button></div></div><md-button ng-disabled=\"vm.emProgresso\" hide-xs \nhide-sm class=\"add-event-button md-fab md-toolbar\" ng-click=\"vm.metodos.abrirFiltro()\" aria-label=\"Abrir filtro\">\n<md-icon md-font-icon=\"icon-filter-outline\"></md-icon></md-button></md-toolbar><md-content class=\"content\" flex \nms-scroll><div ng-include=\"vm.rotasHtml.form\"></div></md-content></div>");
$templateCache.put("app/main/atendimento/relatorio/atendimento/views/relatorio-atendimento-form.html","<div id=\"consulta-atendimento\" class=\"\" layout=\"row\"><div layout=\"column\" flex><form name=\"vm.form\" \nng-disabled=\"vm.requisicaoSolicitada\" novalidate><md-content layout-padding><div layout=\"row\" flex><div layout=\"row\" \nng-show=\"vm.requisicaoSolicitada\" layout-align=\"end center\" flex><div layout=\"column\" layout-align=\"end center\"><span \nclass=\"font-weight-500\">{{vm.mensagemPreloader}}</span><md-progress-circular md-mode=\"indeterminate\" md-diameter=\"30\" \nclass=\"md-accent\"></md-progress-circular></div></div><div layout=\"row\" layout-align=\"end center\" flex><md-button \nclass=\"md-raised md-accent\" aria-label=\"Gerar relatório\" translate \ntranslate-attr-aria-label=\"RELATORIO_ATENDIMENTO.GERAR_RELATORIO\" \nng-click=\"vm.metodos.gerarRelatorio(vm.relatorioAtendimento, $event)\" \nng-disabled=\"vm.form.$invalid || vm.requisicaoSolicitada\"><span translate=\"RELATORIO_ATENDIMENTO.GERAR_RELATORIO\">\n</span></md-button></div></div><div layout-gt-xs=\"row\" layout-padding flex><div layout-gt-xs=\"column\" class=\"border\" \nflex><div layout=\"row\" class=\"ml-15\"><label class=\"mt-30\" translate=\"RELATORIO_ATENDIMENTO.PERIODO\">Período:</label>\n<md-input-container><label translate=\"RELATORIO_ATENDIMENTO.PERIODO_INCIAL\"></label><md-datepicker \nng-model=\"vm.relatorioAtendimento.periodoInicial\" name=\"periodoInicial\" \nmd-max-date=\"vm.relatorioAtendimento.periodoFinal\" mascara-conversor-string-para-data ng-mask=\"3?9/1?9/9999\" \nng-disabled=\"vm.requisicaoSolicitada\" \nng-required=\"!vm.relatorioAtendimento.codigoAtendimento && !vm.relatorioAtendimento.anoAtendimento\"></md-datepicker>\n<div ng-messages=\"vm.form.periodoInicial.$error\"><div ng-message=\"valid\" translate=\"MENSAGEM_VALIDACAO.DATA_INVALIDA\">\n</div><div ng-message=\"required\" translate=\"MENSAGEM_VALIDACAO.DATA_OBRIGATORIA\"></div><div ng-message=\"maxdate\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_DATA_INICIAL\"></div></div></md-input-container><label \ntranslate=\"RELATORIO_ATENDIMENTO.A\" class=\"ml-20 mt-30\">a</label><md-input-container class=\"maximo\"><label \ntranslate=\"RELATORIO_ATENDIMENTO.PERIODO_FINAL\"></label><md-datepicker ng-model=\"vm.relatorioAtendimento.periodoFinal\" \nname=\"periodoFinal\" md-min-date=\"vm.relatorioAtendimento.periodoInicial\" mascara-conversor-string-para-data \nng-mask=\"3?9/1?9/9999\" ng-disabled=\"vm.requisicaoSolicitada\" \nng-required=\"!vm.relatorioAtendimento.codigoAtendimento && !vm.relatorioAtendimento.anoAtendimento\"></md-datepicker>\n<div ng-messages=\"vm.form.periodoFinal.$error\"><div ng-message=\"valid\" translate=\"MENSAGEM_VALIDACAO.DATA_INVALIDA\">\n</div><div ng-message=\"mindate\" translate=\"MENSAGEM_VALIDACAO.CAMPO_DATA_FINAL\"></div><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.DATA_OBRIGATORIA\"></div><div ng-message=\"maxdate\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_DATA_INICIAL\"></div></div></md-input-container></div><div layout-gt-xs=\"row\">\n<md-input-container class=\"md-block\"><label translate=\"RELATORIO_ATENDIMENTO.CODIGO\"></label><input type=\"text\" \nng-model=\"vm.relatorioAtendimento.codigoAtendimento\" name=\"codigo\" mascara-numero-generica=\"######\" ng-required=\"\" \nconverte-mascara-para-numero ng-disabled=\"vm.requisicaoSolicitada\"></md-input-container><md-input-container \nclass=\"md-block\" flex-offset-gt-sm=\"5\"><label translate=\"RELATORIO_ATENDIMENTO.ANO\">Ano</label><input type=\"text\" \nname=\"ano\" ng-model=\"vm.relatorioAtendimento.anoAtendimento\" mascara-numero-generica=\"####\" \nconverte-mascara-para-numero ng-disabled=\"vm.requisicaoSolicitada\"></md-input-container></div><div layout=\"row\">\n<md-autocomplete flex md-input-name=\"cliente\" ng-disabled=\"vm.requisicaoSolicitada\" md-no-cache=\"true\" \nng-blur=\"vm.metodos.configuraAutoCompleteClienteOnBlur()\" md-selected-item=\"vm.cliente\" \nmd-selected-item-change=\"vm.metodos.alterarItemSelecionadoAutoCompleteCliente(item)\" \nmd-search-text=\"vm.textoDePesquisaAutoCompleteCliente\" \nmd-items=\"item in vm.metodos.pesquisarAutoCompleteCliente(vm.textoDePesquisaAutoCompleteCliente)\" \nmd-item-text=\"item.codigo + \' - \' + item.nome\" md-autoselect md-floating-label=\"Cliente\"><md-item-template><span \nmd-highlight-text=\"vm.textoDePesquisaAutoCompleteCliente\">{{item.codigo}} - {{item.nome}}</span></md-item-template>\n<md-not-found><label>Não foi encontrado nenhum Cliente.</label></md-not-found></md-autocomplete></div><div \nlayout=\"row\"><md-autocomplete flex md-input-name=\"solucao\" ng-disabled=\"vm.requisicaoSolicitada\" md-no-cache=\"true\" \nng-blur=\"vm.metodos.configuraAutoCompleteSolucaoOnBlur()\" md-selected-item=\"vm.solucao\" \nmd-selected-item-change=\"vm.metodos.alterarItemSelecionadoAutoCompleteSolucao(item)\" \nmd-search-text=\"vm.textoDePesquisaAutoCompleteSolucao\" \nmd-items=\"item in vm.metodos.pesquisarAutoCompleteSolucao(vm.textoDePesquisaAutoCompleteSolucao)\" \nmd-item-text=\"item.descricao\" md-autoselect md-floating-label=\"Solução\" md-min-length=\"0\"><md-item-template><span \nmd-highlight-text=\"vm.textoDePesquisaAutoCompleteSolucao\">{{item.descricao}}</span></md-item-template><md-not-found>\n<label>Não foi encontrado nenhuma Solução.</label></md-not-found></md-autocomplete></div><div layout-gt-xs=\"row\">\n<md-input-container class=\"md-block\" flex flex-gt-sm=\"30\" ng-if=\"vm.squadUsuarioLogado.length > 1\"><label>Squad</label>\n<md-select ng-model=\"vm.squadCodigo\" name=\"squadCodigo\" ng-change=\"vm.metodos.selectChangeSquad(vm.squadCodigo)\" \nng-disabled=\"vm.requisicaoSolicitada\" multiple=\"multiple\"><md-option ng-value=\"squad.codigo\" \nng-repeat=\"squad in vm.squads track by squad.codigo\">{{squad.descricao}}</md-option></md-select></md-input-container>\n<md-input-container class=\"md-block\" flex-gt-sm=\"50\"><label translate=\"RELATORIO_ATENDIMENTO.COLABORADOR\"></label>\n<md-select ng-model=\"vm.relatorioAtendimento.codigoUsuarios\" multiple=\"multiple\" \nmd-on-open=\"vm.metodos.configuraMdSelectUsuario()\" md-on-close=\"vm.metodos.configuraMdSelectUsuario()\" name=\"usuario\">\n<md-select-header><input id=\"relatorio-atendimento-colaborador-md-select\" class=\"md-text\" \nng-model=\"vm.filtrarUsuarios\" type=\"search\" placeholder=\"\" translate \ntranslate-attr-placeholder=\"RELATORIO_ATENDIMENTO.PESQUISAR_COLABORADOR\"></md-select-header><md-option \nng-value=\"usuario.codigo\" \nng-repeat=\"usuario in vm.usuariosFiltrados | filter:vm.filtrarUsuarios track by usuario.codigo\">{{usuario.login}}\n</md-option></md-select></md-input-container><md-input-container class=\"md-block\" flex-offset-gt-sm=\"5\"><md-checkbox \nng-model=\"vm.todosUsuarios\" ng-change=\"vm.metodos.alterarEstadoCheckboxTodosUsuarios(vm.todosUsuarios)\" \naria-label=\"Todos Colaboradores\" name=\"todosColaboradores\" \nng-disabled=\"vm.relatorioAtendimento.codigoUsuarios.length <= 0 || !vm.relatorioAtendimento.codigoUsuarios\"><span \nclass=\"float-label-cor-default\" translate=\"RELATORIO_ATENDIMENTO.TODOS_COLABORADORES\"></span></md-checkbox>\n</md-input-container></div><div><md-input-container class=\"md-block\"><md-checkbox \nng-model=\"vm.relatorioAtendimento.exibirSomenteHistoricoColaboradoresSelecionados\" \naria-label=\"Exibir somente históricos dos colaboradores selecionados\" \nname=\"exibirSomenteHistoricoColaboradoresSelecionados\" \nng-disabled=\"vm.relatorioAtendimento.codigoUsuarios.length <= 0 || !vm.relatorioAtendimento.codigoUsuarios\"><span \nclass=\"float-label-cor-default\" translate=\"RELATORIO_ATENDIMENTO.EXIBIR_SOMENTE_HISTORICO_COLABORADORES_SELECIONADOS\">\n</span></md-checkbox></md-input-container></div></div><div layout-gt-xs=\"column\" class=\"border\" flex><div \nlayout-gt-xs=\"row\"><md-input-container class=\"md-block\" flex-gt-sm=\"75\"><label \ntranslate=\"RELATORIO_ATENDIMENTO.PENDENCIAS_ATENDIMENTO\"></label><md-select \nng-model=\"vm.relatorioAtendimento.codigoPendenciasAtendimento\" \nng-disabled=\"vm.relatorioAtendimento.statusAtendimento == 2\" \nmd-on-open=\"vm.metodos.configuraMdSelectPendenciaAtendimento()\" \nmd-on-close=\"vm.metodos.configuraMdSelectPendenciaAtendimento()\" multiple=\"multiple\" name=\"pendencias\">\n<md-select-header><input id=\"relatorio-atendimento-pendencias-atendimento-md-select\" class=\"md-text\" \nng-model=\"vm.filtrarPendenciasAtendimento\" type=\"search\" placeholder=\"\" translate \ntranslate-attr-placeholder=\"RELATORIO_ATENDIMENTO.PESQUISAR_PENDENCIAS_ATENDIMENTO\"></md-select-header><md-option \nng-value=\"pendenciaAtendimento.codigo\" \nng-repeat=\"pendenciaAtendimento in vm.pendenciasAtendimento\r\n                                                                                    | filter:vm.filtrarPendenciasAtendimento track by pendenciaAtendimento.codigo\">\n{{pendenciaAtendimento.descricao}}</md-option></md-select></md-input-container><md-input-container class=\"md-block\">\n<md-checkbox ng-model=\"vm.todasPendenciasAtendimento\" \nng-change=\"vm.metodos.alterarEstadoCheckboxTodasPendenciasAtendimento(vm.todasPendenciasAtendimento)\" \nng-disabled=\"vm.relatorioAtendimento.codigoPendenciasAtendimento.length <= 0\r\n                                                                                || !vm.relatorioAtendimento.codigoPendenciasAtendimento\" \naria-label=\"Todos Colaboradores\" name=\"todosColaboradores\"><span class=\"float-label-cor-default\" \ntranslate=\"RELATORIO_ATENDIMENTO.TODOS_COLABORADORES\"></span></md-checkbox></md-input-container></div><div \nlayout-gt-xs=\"row\"><ms-selecinar-multi-valores flex-gt-sm=\"95\" \ntexto-field-set=\"RELATORIO_ATENDIMENTO.MOTIVO_ATENDIMENTO\" dados=\"vm.listaMotivoAtendimentos\" \nname-placeholder=\"Motivos atendimento\" model-dados=\"vm.relatorioAtendimento.motivoAtendimento\" \nform=\"vm.form.motivoAtendimento\" propriedade-para-a-exibicao-da-repeticao=\"titulo\" limitar-width=\"true\" \nauto-selecionar=\"true\" tem-field-set=\"false\"></ms-selecinar-multi-valores></div><div layout=\"row\"><fieldset><legend \ntranslate=\"RELATORIO_ATENDIMENTO.TIPO_ATENDIMENTO\">Tipo Atendimento</legend><md-radio-group \nng-model=\"vm.relatorioAtendimento.tipoAtendimento\" layout=\"row\" layout-padding><md-radio-button value=\"{{key}}\" \nng-disabled=\"vm.requisicaoSolicitada\" ng-repeat=\"(key, value) in vm.tipoAtendimentosGeral\" aria-label=\"{{value}}\">\n<label>{{value}}</label></md-radio-button></md-radio-group></fieldset></div><div layout=\"row\" class=\"mt-10\"><fieldset>\n<legend translate=\"RELATORIO_ATENDIMENTO.STATUS_ATENDIMENTO\">Status Atendimento</legend><md-radio-group \nng-model=\"vm.relatorioAtendimento.statusAtendimento\" \nng-change=\"vm.metodos.ngChangeStatusAtendimento(vm.relatorioAtendimento.statusAtendimento)\" layout=\"row\" \nlayout-padding><md-radio-button value=\"{{key}}\" ng-disabled=\"vm.requisicaoSolicitada\" \nng-repeat=\"(key, value) in vm.statusAtendimentoGeral\" aria-label=\"{{value}}\"><label>{{value}}</label></md-radio-button>\n</md-radio-group></fieldset></div><div layout=\"row\" class=\"mt-10\"><fieldset><legend \ntranslate=\"RELATORIO_ATENDIMENTO.SITUACAO_CLIENTE\">Situação Cliente</legend><md-radio-group \nng-model=\"vm.relatorioAtendimento.situacaoCliente\" layout=\"row\" layout-padding><md-radio-button value=\"{{key}}\" \nng-disabled=\"vm.requisicaoSolicitada\" ng-repeat=\"(key, value) in vm.situacaoClienteGeral\" aria-label=\"{{value}}\">\n<label>{{value}}</label></md-radio-button></md-radio-group></fieldset></div></div></div></md-content></form></div>\n</div>");
$templateCache.put("app/main/atendimento/relatorio/atendimento/views/relatorio-atendimento.html","<div layout=\"column\" class=\"page-layout carded fullwidth\"><header-padrao \ntranslate-nome=\"RELATORIO_ATENDIMENTO.RELATORIO_ATENDIMENTO\" icone=\"\" \nhabilitar-icone-voltar-ao-estado-anterior=\"vm.habilitarIconeVoltarATelaDeCliente\" \nvoltar-ao-estado-anterior=\"vm.metodos.implementarVoltarParaOEstado()\" \nmensagem-tooltip-icone-estado-anterior=\"vm.mensagemTooltipIconeEstadoAnteriorHeaderPadrao\" \nliberar-pesquisa-quando-datatable-ativo=\"false\" pesquisar=\"vm.pesquisar\"></header-padrao><md-content class=\"content\" \nflex ms-scroll><div ng-include=\"vm.rotasHtml.form\"></div></md-content></div>");
$templateCache.put("app/main/documentos-tecnicos/manuais-internos/Desenvolvimento/views/manual-desenvolvimento.html","<div class=\"page-layout carded left-sidenav\" layout=\"row\"><md-sidenav class=\"sidenav\" \nmd-is-locked-open=\"$mdMedia(\'gt-md\')\" md-component-id=\"sidenav\" ms-scroll ms-sidenav-helper><md-content \nclass=\"content\" style=\"background: #F5F5F5!important\" flex ms-scroll><div ng-include=\"vm.rotasHtml.sidenav\"></div>\n</md-content></md-sidenav><div class=\"center\" layout=\"column\" flex><div class=\"content-card\" layout=\"column\" flex><div \nclass=\"toolbar\" layout=\"row\" layout-align=\"start center\"><md-button class=\"md-icon-button sidenav-toggle\" \nng-click=\"vm.metodos.toggleSidenav(\'sidenav\')\" hide-gt-md aria-label=\"Toggle left sidenav\"><md-icon \nmd-font-icon=\"icon-menu\" class=\"icon\"></md-icon></md-button><p class=\"texto-toolbar\">{{vm.tituloCapitulo}}</p></div>\n<md-content class=\"content\" id=\"pagina-manual\" flex ms-scroll><div><div class=\"demo-content\"><img \nsrc=\"assets\\images\\logos\\logo-inovacao.png\" class=\"md-card-image\" alt=\"sunrise\"><h1 id=\"0\">Migração de Tecnologias</h1>\n<h2 class=\"secondary-text subtitulo\">Padronização de Desenvolvimento</h2><p>Versão 2.0</p><p><a \nhref=\"http://inovamobil.com.br/\" target=\"_blank\">www.inovamobil.com.br</a></p><h2 id=\"1\" class=\"subtitulo\">Código Fonte\n</h2><p>\nEste capítulo tem a intenção de documentar algumas padronizações adotadas pela equipe envolvida no processo de migração de tecnologias, a fim de construir uma base sólida desde sua concepção inicial, para que futuramente a manutenção e até mesmo o acréscimo de novas funcionalidades possa ocorrer de forma facilitada e otimizada.\n</p><ul><p>Ao longo deste capítulo, os seguintes processos serão considerados:</p><li>\nPadronização de nomenclatura usada na programação de métodos, objetos, variáveis e constantes. Além disso, trata como deverá ser feita a documentação dentro do código.\n</li><li>Padronização dos componentes a serem usados no desenvolvimento das aplicações.</li></ul><h3 class=\"subtitulo\">\nIndentação de código</h3><p>\nSerá utilizado o padrão de indentação das IDE’s, sendo que deverão ser utilizados os arquivos de configuração padrão para cada IDE, disponíveis no diretório:\n<br>C:\\Documentos Tecnicos\\Manuais Internos\\Desenvolvimento\\Padronizacao\\Codigo Fonte\\Padrão IDEs</p><h3 \nclass=\"subtitulo\">Comentários</h3><p>\nOs comentários quando necessários devem ser incluídos na documentação própria da linguagem (por exemplo Summary para C# e JavaDoc para Java, Javascript). Em novas linguagens ou linguagens sem padrão definido, utilizar a regra geral de incluir comentários sucintos e diretos, evitando a redundância e lixo de código.\n</p><h4 class=\"subtitulo\">Regions</h4><p>\nQuando disponível na linguagem que está sendo usada, utilizar o recurso de regions para melhor separar e identificar os trechos de código.\n</p><h3 class=\"subtitulo\">Recomendações gerais de escrita e nomenclatura</h3><ul><li>\nTente usar uma forma mais fluente para dar entendimento ao que se pretende, mas não exagere. Procure usar uma linguagem que seja adequada ao domínio que está sendo desenvolvido para aquela tarefa específica;\n</li><li>\nRaramente um número deve fazer parte de um nome de qualquer identificador. Se usar ele deve ter algum significado. Ex.: Norma452;\n</li><li>Evite nomes que podem ser confundidos com alguma outra coisa. Ex.: b001;</li><li>\nProcure manter nomes semelhantes para coisas semelhantes;</li><li>\nNomes devem ser fáceis de serem localizados com ferramentas de busca em código. Você deve achar facilmente o que está querendo, preferencialmente nada mais e nada menos do que o desejado. Tenha isto em mente;\n</li><li><span class=\"codigo\">DoThis()</span>\n pode ser ótimo como exemplo generalizado mas não tem nenhum significado para o código. O mais importante é dar nomes significativos. Principalmente não dê nomes que signifiquem outra coisa, mesmo que eventualmente. Ex.: string nonBlank = \" \";\n</li><li>\nProcure entender as sutilezas dos nomes. Counter é um contador, Count é uma contagem e TotalCount é o totalizador da contagem. Seja o mais específico possível. \n<span class=\"codigo\">SalveNome()</span> é melhor que <span class=\"codigo\">SalveCampo()</span>\n a não ser que o segundo salve qualquer campo a ser especificado;</li><li>\nEvite abreviações a não ser que faça sentido para todos e não crie ambiguidades. A abreviação pode ser tão conhecida que ela pode ser até melhor. Ex.: Ftp, UI, IO, DB, PK, AlgumaCoisaInfo, Config, ValorIcms, Id, Args, ex (para o que só pode ser exceção), i para loops (i tem um significado óbvio para qualquer programador), temp ou mesmo tmp (mas não use ambas). Em variáveis locais a abreviação não é tão problemática se não criar mnemônicos incompreensíveis. O melhor é evitá-las, mas não precisa exagerar. Passa ser problema se tudo estiver abreviado ou não dê para entender a intenção da variável por qualquer programador com o mínimo de experiência. Não me pergunte porque é melhor PascalCase em Ftp mas ALLCAPS em UI, IO, etc. Eu imagino que seja o fato de ter apenas duas letras no acrônimo. Já Id é uma só palavra. Há quem prefira ID. Eu não, mas mantenho um padrão;\n</li><li>\nNão use underscore (sublinhado) em nomes de identificadores a não ser que tenha um motivo muito forte, talvez para evitar conflitos possíveis em código lidando com situações em mais baixo nível (geradores). Especialmente não use o prefixo m_. O sublinhado pode ser usado para um parâmetro irrelevante em uma lambda. Ex.: \n<span class=\"codigo\">(_, __) => FazAlgo();</span>\n quando você sabe que precisa receber dois argumentos mas eles não serão usados na sua execução;</li><li>\nJá ficou claro que <a href=\"https://pt.wikipedia.org/wiki/Nota%C3%A7%C3%A3o_h%C3%BAngara\" target=\"_blank\">\nnotação húngara</a>\n não deve ser usada. Um identificador deve indicar o significado dele naquele contexto e não alguma característica técnica dele. No entanto você dizer que está usando um TextBox com descrição não é \n<a href=\"https://pt.wikipedia.org/wiki/Nota%C3%A7%C3%A3o_h%C3%BAngara\" target=\"_blank\">notação húngara</a>\n, é importante para entender o que é aquele identificador. Já um método <span class=\"codigo\">GetInt()</span>\n pode ser já que não está dizendo o que está pegando e sim o tipo do que está pegando, a intenção é esta, não é uma simples característica. carArray provavelmente é húngara, prefira carros;\n</li><li>Evite palavras reservadas usualmente presentes em outras linguagens que funcionam em cima da CLR;</li><li>\nSe o tipo fizer sentido em um nome de identificador (tipicamente um método), prefira o nome do tipo conhecido pela CLR e não o nome definido no C#, assim o identificador pode ser facilmente usado em outros linguagens. Até poderia evitar isto em identificadores privados ou que é absolutamente certo que nunca será usado em outra linguagem, mas por coerência, é melhor não criar exceções. Isto vale para nomear identificadores, não para usar declaração de tipo;\n</li><li>\nProcure alguns termos comuns fáceis e padronize seu uso quando realmente não dá para identificar o significado do identificador ou ele não é relevante. Use value ou valor, item, etc.\n</li><li>\nTente achar a semântica correta do que está tentando fazer e principalmente manter uma relação correta entre termos que se complementam. Por exemplo: Begin vem antes de um End, não confundir como um Start que vem antes de um Stop e um Initiate antes de Finish, um Open antes de Close, Lock antes de Unlock, Block e Deblock, Head e Tail, Header e Footer, Before e After, Read e Write, Input e Output, First e Last, Previous e Next, Increment e Decrement, Enter e Leave, Add e Remove, Create e Destroy, Insert e Delete, Show e Hide, Suspend e Resume, Top e Bottom, etc. Outros são mais complicados de afirmar ou depende de contexto. Do casa com Cancel? E Go tem relação com Quit? Ou o inverso entre os termos anteriores? E que tal o uso Run, Execute, Perform, Abort?. É bom aprender antes de usar. Entenda a diferença entre Find, Seek, Search, Lookup, Scan, Traverse, Locate, Select, Query, Pick, Trace, GetAbcXxx e assemelhados e suas traduções. Não se atenha a estas palavras, são apenas exemplos de conceitos parecidos que podem ser definidos mais precisamente com a palavra correta. Calcule é diferente de Pegue que é diferente de Leia. Uma propriedade TemPedidos é muito diferente de um método \n<span class=\"codigo\">VerifiqueExistênciaDePedidos()</span>\n. Entenda a diferença entre Increment, Add, Plus e Accumulate. Escolha nomes que identifiquem se haverá efeito colateral, mutação do objeto ou não.\n</li><li>\nEvite nomes que cause duplo negativo quando usa um operador de not. Ex.: !family.hasNoChildren. Seja afirmativo.</li>\n<li>\nSe está difícil dar um nome à um tipo ou método provavelmente ele faz mais do que deveria ou não está claro o que ele faz ou porque existe. Se precisa usar um And ou E tem chance de algo estar errado. • Não costuma haver problemas em usar uma variável ou propriedade com o mesmo nome do tipo como camelCase (Color color = Color.Red;). Isto só deve ser evitado se o nome da variável não indica bem o que ela está fazendo ali. O significado contextual pode ser perdido quando se adota este padrão (talvez melhor Color statusColor = Color.Red;).\n</li><li>\nIdentificadores de tipos booleanos podem, ou mesmo devem, ter prefixos indicando uma capacidade. Ex.: is, can, has, isThere (alguns preferem usar só o has), allow (que pode ser o mesmo que can). Ou em português é ou eh, está ou estah (costuma ser seguido de um verbo no particípio ou adjetivo), pode (normalmente seguido de um verbo no infinitivo), tem (provavelmente seguido de um substantivo), Existe (seguido de substantivo). O plural pode ser usado, ou outra conjugação, ex.: foiTentado. E lembre-se que uma enumeração costuma dar mais semântica que um booleano, mesmo quando só existe dois estados. A semântica do booleano é apenas dizer se é verdadeiro ou falso, não use para outras coisas que possuem apenas dois estados.\n</li></ul><h3 class=\"subtitulo\">Padrão de nomenclatura de arquivos de código</h3><p>Deverá ser utilizado o padrão <a \nhref=\"http://celsokitamura.com.br/pascal-case-e-camel-case/\" target=\"_blank\"><a \nhref=\"http://celsokitamura.com.br/pascal-case-e-camel-case/\" target=\"_blank\">Pascal Case</a> </a>\n, não sendo necessário o uso da <a href=\"https://pt.wikipedia.org/wiki/Nota%C3%A7%C3%A3o_h%C3%BAngara\" target=\"_blank\">\nnotação húngara</a>\n para as linguagens OO c#, java e afins salvo quando a padronização da linguagem tem suas particularidades tal como o javascript, neste caso utiliza-se, cliente-detalhes.js, conforme sua documentação.\n</p><ul>Exemplos:<li>Cliente.cs</li><li>Cliente.java</li><li>Cliente.html</li><li>Cliente.js</li></ul><h3 \nclass=\"subtitulo\">Nomenclatura de Classes</h3><p>Utilizar o padrão <a \nhref=\"http://celsokitamura.com.br/pascal-case-e-camel-case/\" target=\"_blank\">Pascal Case</a>.</p><ul>Exemplos:<li>\nCliente</li><li>Departamento</li><li>Funcionário</li></ul><h3 class=\"subtitulo\">Nomenclatura de Propriedades</h3><p>\nUtilizar o padrão <a href=\"http://celsokitamura.com.br/pascal-case-e-camel-case/\" target=\"_blank\">Pascal Case</a>\n. Prefira usar propriedades com encapsulamento a utilizar variáveis públicas para ter melhor uso do encapsulamento e princípios SOLID.\n</p><blockquote><p>\nSOLID é um acrônimo dos cinco primeiros princípios da programação orientada a objetos e design de código identificados por \n<a href=\"https://en.wikipedia.org/wiki/Robert_C._Martin\" target=\"_blank\">Robert C. Martin</a>\n (ou Uncle Bob) por volta do ano 2000. O acrônimo SOLID foi introduzido por <a href=\"https://twitter.com/mfeathers\" \ntarget=\"_blank\">Michael Feathers</a>, após observar que os cinco princípios poderiam se encaixar nesta palavra.</p>\n<footer>Eduardo Pires - <a href=\"http://www.eduardopires.net.br/2013/04/orientacao-a-objeto-solid/\" target=\"_blank\">\nBlog</a></footer></blockquote><a href=\"http://butunclebob.com/ArticleS.UncleBob.PrinciplesOfOod\" target=\"_blank\">\nSaiba mais sobre os Princípios SOLID.</a><p></p><h3 class=\"subtitulo\">Nomenclatura de Atributos</h3><p>\nUtilizar o padrão <a href=\"http://celsokitamura.com.br/pascal-case-e-camel-case/\" target=\"_blank\">camel Case</a>\n. Exemplos: private string nome;</p><h3 class=\"subtitulo\">Nomenclatura de Namespaces</h3><p>\nO Namespace a ser utilizado deve ser padronizado como o nome completo do Assembly que a classe/item pertence. Caso este item esteja armazenado dentro de um pacote/pasta específico, este nome deve ser inserido no Namespace do mesmo.\n</p><p class=\"codigo namespace\">namespace IInvent.Dominio</p><p>\nLevando em consideração um Assembly chamado IInvent. Dominio.dll ( <a \nhref=\"https://support.microsoft.com/pt-br/help/815065/what-is-a-dll\" target=\"_blank\">dll</a>\n de domínio do sistema IInvent), o nome do Namespace de qualquer classe que for armazenada diretamente dentro deste Assembly deverá ser: IInvent.Dominio.\n</p><p>\nCaso seja necessário dividir os itens por pacotes/pastas para melhor organização e sejam criadas as pastas “Entidades” e “Repositórios”, os Namespaces deverão ser gerados da seguinte forma:\n</p><p>\nPara a pasta “Entidades”, o Namespace deverá ser IInvent.Dominio.Entidades, e para a pasta “Repositórios” a lógica é a mesma: IInvent.Dominio.Repositorios.\n</p><p>\nNo caso de interfaces e classes abstratas, é definido que para melhor identificação e organização o Namespace deverá sempre seguir o padrão já citado, incluindo – se o subdiretório “Contrato”, diretório este que deverá ser colocado dentro do diretório referente à rotina à qual o contrato se refere.\n</p><p class=\"codigo namespace\">namespace IInvent.Servico.Leitura.Contrato</p><h3 class=\"subtitulo\">\nNomenclatura de Interfaces</h3><p>\nO nome de interface deve ser PascalCase (a primeira letra do identificador é maiúscula e a primeira letra de cada identificador subsequente concatenado é maiúscula), e começar com o prefixo “I”, para indicar que o tipo é uma interface.\n</p><p class=\"codigo interface\">ITestePadronizacao</p><h3 class=\"subtitulo\">Nomenclatura de Classes Abstratas</h3><p>\nO nome de classes abstratas deves ser PascalCase (a primeira letra do identificador é maiúscula e a primeira letra de cada identificador subsequente concatenado é maiúscula), e começar com o prefixo “A”, para indicar que o tipo é uma classe abstrata.\n</p><p class=\"codigo interface\">ARepositorio</p><p class=\"subtitulo\">Nomenclatura de Métodos</p><p>Utilizar padrão <a \nhref=\"http://celsokitamura.com.br/pascal-case-e-camel-case/\" target=\"_blank\">Pascal Case</a>\n. Em determinados casos tais como o java, javascript entre outras, tal padrão não se aplica, nessas situações utilizar sempre conforme a documentação da respectiva linguagem.\n</p><ul><a href=\"https://docs.microsoft.com/pt-br/dotnet/csharp/programming-guide/\" target=\"_blank\">C#</a><li \nclass=\"codigo\"><span class=\"variaveis\">private bool</span> PesquisaConfigurada()</li><li class=\"codigo\"><span \nclass=\"variaveis\">private string</span> RetornaTipoColuna()</li></ul><ul><a \nhref=\"http://www.oracle.com/technetwork/java/javase/documentation/index.html\" target=\"_blank\">JAVA</a><li \nclass=\"codigo\"><span class=\"variaveis\">private bool</span> pesquisaConfigurada()</li><li class=\"codigo\"><span \nclass=\"variaveis\">private string</span> retornaTipoColuna()</li></ul><h3 class=\"subtitulo\">Nomenclatura de Eventos</h3>\n<p>\nEventos são verbos no gerúndio (pré-evento) ou particípio passado (pós-evento) conforme a situação. Evite criar eventos com sufixo Before ou After ou nomes parecidos. Se o evento deve executar a ação o nome deve ser no infinitivo. Ex.: Deleting, Deleted e Delete. Os manipuladores de eventos devem ter o prefixo on.\n</p><h3 class=\"subtitulo\">Nomenclatura de Constantes</h3><p>Utilizar a nomenclatura em maiúsculo.</p><p class=\"codigo\">\n<span class=\"variaveis\">const string </span>TITULO = <span class=\"string\">\"Titulo\"</span>;</p><p>\nUtilizar o padrão camelCase. Nunca utilizar a <a href=\"https://pt.wikipedia.org/wiki/Nota%C3%A7%C3%A3o_h%C3%BAngara\" \ntarget=\"_blank\">notação húngara</a>\n, para melhor visualização do tipo do componente utilizado, iniciar o nome do componente com o tipo do componente.</p>\n<p>Exemplo:<br>TextBox textboxNome;<br>Button buttonSalvar;</p><h3 class=\"subtitulo\">Nomenclatura dos Assemblies</h3>\n<p>Para geração dos <em>Assemblies</em>\n, o padrão para criação será: nome do projeto + Tipo (Domínio, Data, Relatório, Lançamento) - estes projetos terão pastas distintas para organização da solução.\n</p><p>Temos o Projeto IInvent.</p><p>Tipos<br>Tipo (Relatório) – Relatorio<br>Tipo (Domínio) – Dominio<br>\nIInvent. Relatorio.dll<br>IInvent. Dominio.dll</p><h2 id=\"2\" class=\"subtitulo\">Banco de dados</h2><h3 \nclass=\"subtitulo\">Entidades</h3><p>\nTodos os nomes de entidades deverão ser escritos no singular e não utilizar caracteres especiais, abaixo segue imagem contendo duas entidades desenvolvidas, de acordo com a padronização estabelecida. Caso necessário, pode ser utilizado underline para melhor identificação da tabela, por exemplo para uso de prefixo (Ex: INT_Parametro – Tabela de parâmetro da interface).\n</p><img src=\"assets\\images\\documentacao\\exemplo-nome-banco-de-dados.png\" alt=\"nomenclatura do banco de dados\"><p>\nTodos os nomes de Entidades devem ser escritos por extenso, utilizando o nome mais intuitivo para identificação da mesma, sem utilização de abreviaturas, exceto em casos em que o nome for extremamente grande.\n</p><h3 class=\"subtitulo\">Atributos</h3><p>\nTodas as colunas escritas com iniciais em maiúsculo e serão compostas somente pela abreviatura da entidade e o nome da coluna, de acordo com o seguinte protótipo: {Abreviatura da entidade} _ {Nome da coluna}.\n<br><br>Obs.: A abreviatura da entidade deve conter no máximo 8 caracteres.<br><br>\nSempre coloque nomes intuitivos, evite abreviações na medida do possível<br><br>\nNome como CD, NM e VL como eram usado no Delphi não poderá mais ser utilizado.<br><br>\nO nome do atributo pode possuir Underline (_) para uma melhor visualização, fica a critério de o desenvolvedor verificar real necessidade.\n</p><h3 class=\"subtitulo\">Triggers, Views e Stored procedures.</h3><p>\nTodos os nomes destes objetos, sempre que aplicável, deverão ser escritos no Singular e devem seguir o seguinte protótipo:\n</p><p class=\"coddigo\">{VW} + {Nome da View} – Visão<br>{T} + {Nome da Trigger} – Trigger<br>\n{SP} + {Nome da sp} – Stored Procedure</p><p>\nTodos os nomes devem ser escritos por extenso, utilizando o nome mais intuitivo para identificação do objeto, sem utilização de abreviaturas, exceto em casos em que o nome for extremamente grande.\n</p><h3 class=\"subtitulo\">Query</h3><p>\nExemplos da padronização de alinhamentos de sentenças SQL em Query´s. Os FROM, WHERE, SET, GROUP BY, ORDER BY etc, são sempre duas posições após as aspas.\n</p><p class=\"codigo\">(\'SELECT cli_Codigo, cli_Nome, cli_Endereco\');<br>(\' FROM Cliente\');<br>\n(\' WHERE cli_Codigo = :param0);</p><footer><em>\nObs. Palavras reservadas serão escritas somente em maiúsculas, entidades e atributos sempre de acordo com sua nomenclatura no banco de dados\n</em></footer><p></p><h2 id=\"3\" class=\"subtitulo\">Erros Comuns</h2><h3 class=\"subtitulo\">Código em Eventos</h3><p>\nNunca deixe de usar métodos nos eventos dos componentes, não crie código no escopo de um evento.</p><img \nsrc=\"assets\\images\\documentacao\\exemplo-erros-comuns.png\" alt=\"Exemplo de erros comuns\"><p>\nNeste caso, para organização, cria-se um método que realiza o procedimento de sair e o mesmo é invocado no evento Click do Button.\n</p><h2 id=\"4\" class=\"subtitulo\">Materiais de Estudo</h2><p><a \nhref=\"http://samuelmg.wordpress.com/2008/11/11/boas-praticas-em-programacao-abreviando-objetos/\" target=\"_blank\">\nAbreviações de objetos</a><br><a href=\"http://msdn.microsoft.com/pt-br/library/cc580565.aspx\" target=\"_blank\">\nBoas práticas de programação com C#</a><br><a \nhref=\"http://www.codeproject.com/Articles/8971/C-Coding-Standards-and-Best-Programming-Practices\" target=\"_blank\">\nComeçando bem com o código</a><br><a href=\"https://www.devmedia.com.br/convencoes-de-codigo-java/23871\" \ntarget=\"_blank\">Convenções de código em JAVA</a><br><a \nhref=\"https://www.devmedia.com.br/refatoracao-explorando-os-recursos-do-visual-studio/26678\" target=\"_blank\">\nRefatoração</a><br><a \nhref=\"https://www.livrariacultura.com.br/p/livros/informatica-e-tecnologia/programacao/clean-code-2456630\" \ntarget=\"_blank\">Leitura do livro Clean Code</a><br></p></div></div></md-content></div></div></div>");
$templateCache.put("app/main/controle-acesso-menu/views/sidenavs/esquerda/sidenav-esquerda-controle-acesso-menu.html","<div class=\"header\" layout=\"column\" flex><fieldset><legend><div class=\"logo\" layout=\"row\" layout-align=\"start center\">\n<span class=\"logo-icon\"><md-icon md-font-icon=\"icon-key-variant\" class=\"icon cor-icone\"></md-icon></span><span \nclass=\"logo-text\" translate=\"CONTROLE_ACESSO_MENU.PERMISSAO\">PERMISSAO</span></div></legend><div \nclass=\"compose-button\" flex><md-button class=\"md-accent md-raised\" aria-label=\"compose\" \nng-click=\"vm.metodos.gravarControleAcesso($event, vm.controleAcessoMenu)\" \nng-disabled=\"vm.botaoGravarDesabilitado || vm.controladorPreloaders.atualizandoMenus || vm.controladorPreloaders.atualizandoUsuariosPorPerfil\">\n<div layout=\"row\" layout-align=\"center start\" flex><i class=\"icon-content-save mp-icon s30\"></i> <span \nclass=\"title tamanho-fonte\" translate=\"CONTROLE_ACESSO_MENU.GRAVAR\">Gravar</span></div></md-button></div></fieldset>\n</div><md-content ms-scroll class=\"content\" flex><div class=\"navigation-simple\" layout=\"column\"><div \nclass=\"item subheader\"></div><fieldset><legend><div class=\"logo\" layout=\"row\" layout-align=\"start center\"><span \nclass=\"logo-icon\"><md-icon md-font-icon=\"icon-account-multiple\" class=\"icon cor-icone\"></md-icon></span><span \nclass=\"logo-text\" translate=\"CONTROLE_ACESSO_MENU.COLABORADORES\">Colaboradores</span></div></legend><div layout=\"row\" \nflex layout-align=\"center center\" ng-if=\"vm.controladorPreloaders.atualizandoUsuariosPorPerfil\"><md-progress-circular \nmd-mode=\"indeterminate\" class=\"text-center md-accent\" md-diameter=\"40\"></md-progress-circular></div><md-list><div \nclass=\"item subheader\" flex></div><md-list-item \nng-repeat=\"usuario in vm.usuariosPerfilSelecionado | orderBy:\'nome\' track by usuario.codigo\"><div layout=\"column\" flex>\n<div flex layout=\"row\"><md-icon md-font-icon=\"icon-account-circle s32\"></md-icon><p class=\"list-item-p\" flex>\n{{usuario.login}}</p></div><div layout=\"row\" flex><div class=\"item subheader\" flex></div></div></div></md-list-item>\n</md-list></fieldset></div></md-content>");
$templateCache.put("app/main/financeiro/cadastro/email/views/financeiro-email-form.html","<div class=\"md-background-bg md-whiteframe-1dp\"><form name=\"vm.form\" autocomplete=\"off\" novalidate><pg-toolbar \nentidades=\"vm.financeiroEmails\" entidade=\"vm.financeiroEmail\" entidade-de-envio=\"vm.entidadeDeEnvio\" \ncontrolador-toolbar=\"vm.controleForm\" acao-pesquisar=\"vm.metodos.pesquisar()\" \nacao-criar=\"vm.metodos.salvar(vm.financeiroEmail)\" acao-editar=\"vm.metodos.editar(vm.financeiroEmail)\" \nacao-excluir=\"vm.metodos.excluir(vm.financeiroEmail)\" construir-dt-options=\"vm.metodos.construirDtOptions()\" \nmetodos-externos=\"vm.metodosExternosPgToolbar\" campo-pesquisar=\"vm.pesquisar\"></pg-toolbar><md-content layout-padding \nng-hide=\"vm.controleForm.listarTodasEntidades\" ng-disabled=\"vm.controleForm.emProgresso\"><div class=\"form-container\">\n<div layout-gt-xs=\"row\"><fieldset flex><legend translate=\"FINANCEIRO_EMAIL.OBSERVACAO_LEGEND\">Observação</legend><div \nlayout-gt-xs=\"row\" flex><span flex translate=\"FINANCEIRO_EMAIL.OBSERVACAO_SPAN\">\nOs campos [Cliente] e [Documento] serão alterados pelo respectivo nome e CNPJ do cliente durante o envio do email.\n</span></div></fieldset></div><div layout-gt-xs=\"row\" class=\"mt-10\"><md-input-container class=\"md-block\" flex><label \ntranslate=\"FINANCEIRO_EMAIL.DESCRICAO_CADASTRO\"></label><input name=\"descricaoCadastro\" md-maxlength=\"50\" \nmaxlength=\"50\" \nng-disabled=\"vm.controleForm.emProgresso\r\n                                                                || (vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo)\" \nng-required=\"vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo\" \nng-model=\"vm.financeiroEmail.descricaoCadastro\" type=\"text\"><div ng-messages=\"vm.form.descricaoCadastro.$error\"><div \nng-message=\"required\" translate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container></div><div \nlayout-gt-xs=\"row\" class=\"mt-10\"><md-input-container class=\"md-block\" flex><label translate=\"FINANCEIRO_EMAIL.ASSUNTO\">\n</label><input name=\"assunto\" md-maxlength=\"120\" maxlength=\"120\" \nng-disabled=\"vm.controleForm.emProgresso\r\n                                                || (vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo)\" \nng-required=\"vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo\" ng-model=\"vm.financeiroEmail.assunto\" \ntype=\"text\"><div ng-messages=\"vm.form.assunto.$error\"><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container></div><div layout-gt-xs=\"row\">\n<md-input-container class=\"md-block\" ng-if=\"!vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\" flex=\"70\">\n<label translate=\"FINANCEIRO_EMAIL.EMAIL\"></label><input name=\"email\" type=\"text\" md-maxlength=\"50\" maxlength=\"50\" \nng-disabled=\"vm.controleForm.emProgresso\r\n                                            || (vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo)\" \nng-required=\"vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo\" ng-model=\"vm.financeiroEmail.email\" \nautocomplete=\"off\"><div ng-messages=\"vm.form.email.$error\"><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div><div ng-message=\"email\" \ntranslate=\"MENSAGEM_VALIDACAO.EMAIL_INVALIDO\"></div></div></md-input-container><md-input-container class=\"md-block\" \nng-if=\"vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo\" flex=\"70\"><label \ntranslate=\"FINANCEIRO_EMAIL.EMAIL\"></label><input name=\"email\" type=\"email\" md-maxlength=\"50\" maxlength=\"50\" \nng-disabled=\"vm.controleForm.emProgresso\r\n                                                                || (vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo)\" \nng-required=\"vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo\" ng-model=\"vm.financeiroEmail.email\" \nautocomplete=\"off\"><div ng-messages=\"vm.form.email.$error\"><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div><div ng-message=\"email\" \ntranslate=\"MENSAGEM_VALIDACAO.EMAIL_INVALIDO\"></div></div></md-input-container><md-input-container class=\"md-block\" \nflex=\"40\"><label translate=\"FINANCEIRO_EMAIL.SENHA\"></label><input name=\"senha\" type=\"password\" md-maxlength=\"40\" \nmaxlength=\"40\" \nng-disabled=\"vm.controleForm.emProgresso || (!vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo)\" \nng-required=\"vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo\" ng-model=\"vm.financeiroEmail.senha\" \nautocomplete=\"new-password\"><div ng-messages=\"vm.form.senha.$error\"><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container></div><md-input-container \nclass=\"md-block\" flex style=\"margin-top: 30px\"><label translate=\"FINANCEIRO_EMAIL.DIRETORIO\"></label><md-select \nng-model=\"vm.financeiroEmail.diretorioCertidoes\" \nng-disabled=\"vm.controleForm.emProgresso || (!vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo)\" \nname=\"\r\n                     diretorioCertidoes\"><md-option ng-if=\"vm.financeiroEmail.diretorioCertidoes\" ng-value=\"\">\nDesmarcar</md-option><md-option ng-value=\"diretorio\" \nng-repeat=\"diretorio in vm.diretoriosFinanceiroEmail track by $index\">{{diretorio}}</md-option></md-select>\n</md-input-container><div layout-gt-xs=\"row\"><div layout-gt-xs=\"column\" flex><label \nclass=\"md-input-container-corpo-label\" \nng-class=\"{\'md-input-container-corpo-label-after\': vm.controleForm.editarAtivo,\r\n                                          \'md-input-container-corpo-label-invalido\': !vm.financeiroEmail.corpo,\r\n                                          \'md-input-container-corpo-label-valido\': vm.financeiroEmail.corpo}\" \ntranslate=\"FINANCEIRO_EMAIL.MENSAGEM\"></label><md-input-container class=\"md-block md-input-container-corpo\" flex>\n<text-angular name=\"mensagem\" ng-class=\"{\'ta-disabled\':!vm.controleForm.editarAtivo || vm.controleForm.emProgresso}\" \nng-required=\"vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo\" aria-label=\"Corpo\" \nta-disabled=\"vm.controleForm.emProgresso || (!vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo)\" \nng-model=\"vm.financeiroEmail.mensagem\"></text-angular><div class=\"corpo-mensagem-erro-transicao\" \nng-show=\"!vm.financeiroEmail.mensagem && vm.form.mensagem.$touched\" md-colors=\"{background: \'RED\'}\"><span \nstyle=\"padding: 10px\" translate=\"FINANCEIRO_EMAIL.CORPO_MENSAGEM_OBRIGATORIO\"></span></div></md-input-container></div>\n</div></div></md-content></form></div>");
$templateCache.put("app/main/financeiro/cadastro/email/views/financeiro-email.html","<div id=\"financeiro-email\" class=\"page-layout simple tabbed\" layout=\"column\"><header-padrao \ntranslate-nome=\"FINANCEIRO_EMAIL.FINANCEIRO_EMAIL\" \nliberar-pesquisa-quando-datatable-ativo=\"vm.controleForm.listarTodasEntidades\" pesquisar=\"vm.pesquisar\">\n</header-padrao><div class=\"content\"><div ui-view=\"financeiro-email-form\"></div></div><div \nui-view=\"financeiro-emails-tabela\" ng-if=\"vm.controleForm.listarTodasEntidades\"></div></div>");
$templateCache.put("app/main/financeiro/cadastro/email/views/financeiro-emails-tabela.html","<div layout=\"column\" flex><div class=\"md-padding md-background-bg md-whiteframe-1dp fullpage-datatable\" \nlayout=\"column\" flex><table class=\"dataTable row-border hover\" id=\"datatable-cadastro-financeiro-email\" width=\"100%\">\n<thead><tr><th>Ação</th><th>Assunto</th><th>Email</th></tr></thead></table></div></div>");
$templateCache.put("app/main/financeiro/relatorio/reajustes/views/reajuste-form.html","<div class=\"page-layout simple fullwidth doc-page\" layout=\"column\"><div layout=\"row\" class=\"mb-10\" flex><div \nlayout=\"row\" ng-show=\"vm.requisicaoSolicitada\" layout-align=\"center center\" flex><div layout=\"column\" \nlayout-align=\"center center\" class=\"mt-100\"><span class=\"font-weight-500\" style=\"font-size: 16px\">\n{{vm.mensagemPreloader}}</span><md-progress-circular md-mode=\"indeterminate\" md-diameter=\"100\" class=\"md-accent\">\n</md-progress-circular></div></div></div><div class=\"content\" layout=\"column\" ng-show=\"!vm.requisicaoSolicitada\"><form \nname=\"vm.form.geral\" ms-horizontal-stepper ng-submit=\"vm.metodos.gerarRelatorio(vm.filtrosreajustes)\" novalidate>\n<ms-horizontal-stepper-step ng-form=\"vm.form.tab.informacoesGeraisReajuste\" step=\"1\" \nstep-title=\"vm.translateTitulosSteps.informacoesGerais\"><div ui-view=\"relatorio-reajustes-steper-informacoes\"></div>\n</ms-horizontal-stepper-step><ms-horizontal-stepper-step ng-form=\"vm.form.tab.item\" step=\"2\" \nstep-title=\"vm.translateTitulosSteps.item\"><div ui-view=\"relatorio-reajustes-steper-produtos\"></div>\n</ms-horizontal-stepper-step><ms-horizontal-stepper-step ng-form=\"vm.form.tab.cliente\" step=\"3\" \nstep-title=\"vm.translateTitulosSteps.clientes\"><div ui-view=\"relatorio-reajustes-steper-reajuste-cliente\"></div>\n</ms-horizontal-stepper-step><ms-horizontal-stepper-step ng-form=\"vm.form.tab.caracteristicaContratoReajuste\" step=\"4\" \nstep-title=\"vm.translateTitulosSteps.caracteristicaContrato\"><div \nui-view=\"relatorio-reajustes-steper-caracteristica-contrato\"></div></ms-horizontal-stepper-step>\n<ms-horizontal-stepper-step ng-form=\"vm.form.tab.TipoLicencaController\" step=\"5\" \nstep-title=\"vm.translateTitulosSteps.licenca\"><div ui-view=\"tipo-licenca-steper\"></div></ms-horizontal-stepper-step>\n</form></div></div>");
$templateCache.put("app/main/financeiro/relatorio/reajustes/views/reajustes.html","<div layout=\"column\" id=\"relatorio-reajustes\" class=\"page-layout carded fullwidth\"><header-padrao \ntranslate-nome=\"RELATORIO_REAJUSTE.REAJUSTE\" icone=\"\" liberar-pesquisa-quando-datatable-ativo=\"false\" \npesquisar=\"vm.pesquisar\"></header-padrao><md-content class=\"content\" flex ms-scroll><div ui-view=\"relatorio-reajustes\">\n</div></md-content></div>");
$templateCache.put("app/main/financeiro/relatorio/contratos/views/contratos-form.html","<div class=\"page-layout simple fullwidth doc-page\" layout=\"column\"><div layout=\"row\" class=\"mb-10\" flex><div \nlayout=\"row\" ng-show=\"vm.requisicaoSolicitada\" layout-align=\"center center\" flex><div layout=\"column\" \nlayout-align=\"center center\" class=\"mt-100\"><span class=\"font-weight-500\" style=\"font-size: 16px\">\n{{vm.mensagemPreloader}}</span><md-progress-circular md-mode=\"indeterminate\" md-diameter=\"100\" class=\"md-accent\">\n</md-progress-circular></div></div></div><div class=\"content\" layout=\"column\" ng-show=\"!vm.requisicaoSolicitada\"><form \nname=\"vm.form.geral\" ms-horizontal-stepper ng-submit=\"vm.metodos.gerarRelatorio(vm.filtrosContratos)\" novalidate>\n<ms-horizontal-stepper-step ng-form=\"vm.form.tab.informacoesGerais\" step=\"1\" \nstep-title=\"vm.translateTitulosSteps.informacoesGerais\"><div ui-view=\"relatorio-contratos--steper-informacoes-gerais\">\n</div></ms-horizontal-stepper-step><ms-horizontal-stepper-step ng-form=\"vm.form.tab.cliente\" step=\"2\" \nstep-title=\"vm.translateTitulosSteps.clientes\"><div ui-view=\"relatorio-contratos--steper-cliente\"></div>\n</ms-horizontal-stepper-step><ms-horizontal-stepper-step ng-form=\"vm.form.tab.caracteristica\" step=\"3\" \nstep-title=\"vm.translateTitulosSteps.caracteristica\"><div ui-view=\"relatorio-contratos--steper-caracteristica\"></div>\n</ms-horizontal-stepper-step><ms-horizontal-stepper-step ng-form=\"vm.form.tab.caracteristicaContrato\" step=\"4\" \nstep-title=\"vm.translateTitulosSteps.caracteristicaContrato\"><div \nui-view=\"relatorio-contratos--steper-caracteristica-contrato\"></div></ms-horizontal-stepper-step>\n<ms-horizontal-stepper-step ng-form=\"vm.form.tab.itemSegmentacao\" step=\"5\" \nstep-title=\"vm.translateTitulosSteps.itemSegmentacao\"><div ui-view=\"relatorio-contratos--steper-produto-segmentacao\">\n</div></ms-horizontal-stepper-step><ms-horizontal-stepper-step ng-form=\"vm.form.tab.licenca\" step=\"6\" \nstep-title=\"vm.translateTitulosSteps.licenca\"><div ui-view=\"relatorio-contratos--steper-licenca\"></div>\n</ms-horizontal-stepper-step><input type=\"text\" ng-hide=\"true\" ng-disabled=\"true\" ng-model=\"vm.validador\" \nname=\"validador\" ng-required=\"vm.requisicaoSolicitada\"></form></div></div>");
$templateCache.put("app/main/financeiro/relatorio/contratos/views/contratos.html","<div layout=\"column\" id=\"relatorio-contratos\" class=\"page-layout carded fullwidth\"><header-padrao \ntranslate-nome=\"RELATORIO_CONTRATOS.CONTRATOS\" icone=\"\" liberar-pesquisa-quando-datatable-ativo=\"false\" \npesquisar=\"vm.pesquisar\"></header-padrao><md-content class=\"content\" flex ms-scroll><div \nui-view=\"relatorio-contratos-\"></div></md-content></div>");
$templateCache.put("app/main/financeiro/processamento/contratos/views/contratos-form.html","<div class=\"md-background-bg md-whiteframe-1dp\"><form name=\"vm.form\" class=\"md-inline-form\" novalidate><pg-toolbar \nentidades=\"vm.contratos\" entidade=\"vm.contrato\" entidade-de-envio=\"vm.entidadeDeEnvio\" \ncontrolador-toolbar=\"vm.controleForm\" controlador-pre-loader=\"vm.controlePreloader\" campo-pesquisar=\"vm.pesquisar\" \nacao-pesquisar=\"vm.metodos.pesquisar()\" acao-criar=\"vm.metodos.salvar(vm.contrato)\" \nacao-editar=\"vm.metodos.editar(vm.contrato)\" acao-excluir=\"vm.metodos.excluir(vm.contrato)\" \nmetodo-externo-acao-navegacao=\"vm.metodosGeral.preDefinirValoresQuandoNavegado()\" \nmetodos-externos=\"vm.metodosExternosPgToolbar\" \nmetodo-externo-acao-nova-pesquisa=\"vm.metodosGeral.tabSelecionada(vm.tabs.primeiraAba)\" \ndesabilitar-botao-nova-pesquisa=\"vm.desabilitarBotoes\" desabilitar-botao-pesquisar=\"vm.desabilitarBotoes\" \ndesabilitar-botao-listar-todas-entidades=\"true\" \ndesabilitar-botao-inserir=\"!vm.habilitarVisualizacao || (vm.tabSelecionada == vm.tabs.segundaAba || \r\n                                                vm.tabSelecionada == vm.tabs.terceiraAba) || vm.desabilitarBotoes\" \ndesabilitar-botao-editar=\"!vm.habilitarVisualizacao || (vm.tabSelecionada == vm.tabs.segundaAba || \r\n                                               vm.tabSelecionada == vm.tabs.terceiraAba) || vm.desabilitarBotoes\" \ndesabilitar-botao-excluir=\"!vm.habilitarVisualizacao || (vm.tabSelecionada == vm.tabs.segundaAba || \r\n                                                vm.tabSelecionada == vm.tabs.terceiraAba || vm.tabSelecionada == vm.tabs.quartaAba) ||\r\n                                                vm.desabilitarBotoes\" \niniciar-chamando-pesquisa=\"vm.iniciarChamandoPesquisa\" \npre-definir-campos-para-insercao=\"vm.metodos.preDefinirCamposParaInsercao()\"></pg-toolbar><md-content md-padding \nng-hide=\"vm.controleForm.listarTodasEntidades\" ng-disabled=\"vm.controleForm.emProgresso\"><md-tabs md-dynamic-height \nmd-border-bottom><md-tab label=\"Contrato\" md-active=\"vm.tabSelecionada === vm.tabs.primeiraAba\" \nmd-on-select=\"vm.metodosGeral.tabSelecionada(vm.tabs.primeiraAba)\"><md-tab-label><label translate=\"CONTRATOS.CONTRATO\">\n</label></md-tab-label><md-tab-body><div ng-include=\"vm.rotasHtml.tabs.tabContratos.templateUrl\"></div></md-tab-body>\n</md-tab><md-tab label=\"Itens\" md-active=\"vm.tabSelecionada === vm.tabs.segundaAba\" \nmd-on-select=\"vm.metodosGeral.tabSelecionada(vm.tabs.segundaAba)\" \nng-disabled=\"!vm.controleForm.pesquisaAtiva || (vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo)\">\n<md-tab-label><label translate=\"CONTRATOS.ITENS\"></label><md-icon \nng-if=\"vm.possuiRiscoRescisaoContratual && vm.tabSelecionada != vm.tabs.segundaAba\" \nclass=\"s12 icone-contrato-risco-tab-itens\" md-font-icon=\"icon-checkbox-blank-circle\" layout-align=\"end end\"></md-icon>\n</md-tab-label><md-tab-body><div \nng-if=\"(!vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo) || \r\n                                      vm.tabSelecionada == vm.tabs.segundaAba\" \nng-include=\"vm.rotasHtml.tabs.tabItens\"></div></md-tab-body></md-tab><md-tab label=\"Histórico\" \nmd-active=\"vm.tabSelecionada === vm.tabs.terceiraAba\" \nmd-on-select=\"vm.metodosGeral.tabSelecionada(vm.tabs.terceiraAba)\" ng-if=\"vm.habilitarVisualizacao\" \nng-disabled=\"!vm.controleForm.pesquisaAtiva || (vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo)\">\n<md-tab-label><label translate=\"CONTRATOS.HISTORICO\"></label></md-tab-label><md-tab-body><div \nng-include=\"vm.rotasHtml.tabs.tabHistorico.tab\" \nng-if=\"(!vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo) || \r\n                                      vm.tabSelecionada == vm.tabs.terceiraAba\">\n</div></md-tab-body></md-tab><md-tab label=\"Caracteristicas\" md-active=\"vm.tabSelecionada === vm.tabs.quartaAba\" \nmd-on-select=\"vm.metodosGeral.tabSelecionada(vm.tabs.quartaAba)\" \nng-disabled=\"!vm.controleForm.pesquisaAtiva || (vm.controleForm.inserirAtivo)\"><md-tab-label><label \ntranslate=\"CONTRATOS.CARACTERISTICAS\"></label></md-tab-label><md-tab-body><div \nng-if=\"(!vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo) ||  \r\n                                      vm.tabSelecionada == vm.tabs.quintaAba\" \nng-include=\"vm.rotasHtml.tabs.tabCaracteristicas\"></div></md-tab-body></md-tab></md-tabs><div \nclass=\"container-botao-inserir\"><md-button class=\"md-fab md-accent md-icon-button sample-show-hide botao-inserir\" \naria-label=\"Inserir Novo Item\" translate translate-attr-aria-label=\"CONTRATOS.INSERIR_ITEM\" \nng-disabled=\"vm.ngDisabled || !vm.habilitarVisualizacao\" ng-click=\"vm.metodos.abrirDialogItem(null, false)\" \nng-hide=\"vm.controladorAtivo\" ng-if=\"vm.tabSelecionada === vm.tabs.segundaAba\"><md-icon md-font-icon=\"icon-plus s26\">\n</md-icon><md-tooltip md-autohide><span translate=\"CONTRATOS.INSERIR_ITEM\"></span></md-tooltip></md-button><md-button \nclass=\"md-fab md-accent md-icon-button sample-show-hide botao-inserir\" aria-label=\"Inserir Histórico\" translate \ntranslate-attr-aria-label=\"CLIENTE.INSERIR_HISTORICO_CONTRATO\" \nng-click=\"vm.metodos.abrirDialogHistoricoContrato($event,item)\" \nng-disabled=\"vm.metodos.desabilitaBotaoInserirHistorico()\" ng-if=\"vm.tabSelecionada === vm.tabs.terceiraAba\"><md-icon \nmd-font-icon=\"icon-plus s26\"></md-icon><md-tooltip md-autohide><span translate=\"CLIENTE.INSERIR_HISTORICO_CONTRATO\">\n</span></md-tooltip></md-button></div></md-content></form></div>");
$templateCache.put("app/main/financeiro/processamento/contratos/views/contratos-tabela.html","<div layout=\"column\" flex><div class=\"md-padding md-background-bg md-whiteframe-1dp fullpage-datatable\" \nlayout=\"column\" flex><table id=\"datatable-financeiro-contratos\" class=\"dataTable row-border hover\" width=\"100%\"><thead>\n<tr><th>Ação</th><th>Cliente</th><th>Produto</th><th>Data Primeiro Contrato</th><th>Data Início Contrato Atual</th><th>\nData Vencimento Contrato Atual</th></tr></thead></table></div></div>");
$templateCache.put("app/main/financeiro/processamento/contratos/views/contratos.html","<div id=\"contratos\" class=\"page-layout simple tabbed\" layout=\"column\"><header-padrao \ntranslate-nome=\"CONTRATOS.CONTRATOS\" liberar-pesquisa-quando-datatable-ativo=\"vm.controleForm.listarTodasEntidades\" \npesquisar=\"vm.pesquisar\" ng-utiliza-pesquisa=\"false\"></header-padrao><div class=\"content\"><div \nui-view=\"contratos-form\"></div></div><div ui-view=\"contratos-tabela\" ng-if=\"vm.controleForm.listarTodasEntidades\">\n</div></div>");
$templateCache.put("app/main/financeiro/relatorio/risco-rescisao-contratual/views/risco-rescisao-contratual-form.html","<div id=\"form-relatorio-risco-rescisao-contratual\"><div style=\"width: 100%; min-width: 100%\" \nng-include=\"\'app/main/financeiro/relatorio/risco-rescisao-contratual/components/filtro/filtro-risco-rescisao-contratual.html\'\">\n</div></div>");
$templateCache.put("app/main/financeiro/relatorio/risco-rescisao-contratual/views/risco-rescisao-contratual.html","<div layout=\"column\" id=\"relatorio-risco-rescisao-contratual\" class=\"page-layout carded fullwidth\"><header-padrao \ntranslate-nome=\"Relatório de clientes em monitoramento\" icone=\"\" \nliberar-pesquisa-quando-datatable-ativo=\"vm.montandoDados && vm.dadosTabela.dadosClientes.length > 0\" \npesquisar=\"vm.pesquisar\"></header-padrao><md-content style=\"height: 100vh; padding: 15px; overflow-y: auto\"><div \nng-if=\"!vm.montandoDados\" ui-view=\"form\"></div><div ng-if=\"vm.montandoDados\" ui-view=\"tabela\"></div></md-content></div>");
$templateCache.put("app/main/financeiro/processamento/envio-de-emails/views/envio-de-emails-form.html","<div class=\"md-background-bg md-whiteframe-1dp\" layout=\"column\" flex><form name=\"vm.form\" novalidate layout=\"column\">\n<div layout=\"column\" layout-gt-sm=\"row\"><md-input-container flex class=\"md-block\" style=\"margin-top: 30px\"><label \ntranslate=\"ENVIO_DE_EMAILS.EMAIL\"></label><md-select ng-model=\"vm.filtroEnvioDeEmails.email\" ng-required=\"true\" \nname=\"financeiroEmail\"><md-option ng-value=\"financeiroEmail\" \nng-repeat=\"financeiroEmail in vm.financeiroEmails track by financeiroEmail.codigo\">\n{{financeiroEmail.descricaoCadastro}} - {{financeiroEmail.email}}</md-option></md-select><div \nng-messages=\"vm.form.financeiroEmail.$error\"><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container><div layout=\"row\" class=\"m-5\">\n<md-input-container><md-checkbox ng-model=\"vm.filtroEnvioDeEmails.solicitarConfirmacaoLeitura\" \naria-label=\"Solicitar confirmação de leitura\" name=\"solicitarConfirmacaoLeitura\"><span class=\"float-label-cor-default\" \ntranslate=\"ENVIO_DE_EMAILS.SOLICITAR_CONFIRMACAO_LEITURA\"></span></md-checkbox></md-input-container></div></div><div \nlayout-gt-xs=\"row\" class=\"ml-15\" ng-if=\"vm.filtroEnvioDeEmails.email.diretorioCertidoes\"><span layout=\"column\" \nlayout-align=\"center start\" class=\"ml-5\" flex>Pasta de certidões: {{ vm.filtroEnvioDeEmails.email.diretorioCertidoes}}\n</span></div><div layout-gt-xs=\"row\" class=\"mt-5\"><im-selecao-arquivos flex \narquivos-selecionados=\"vm.filtroEnvioDeEmails.arquivosSelecionados\" im-tamanho-maximo-arquivos=\"26Mb\" \nim-utiliza-button-enviar=\"true\" im-utiliza-tabela=\"true\" \nim-habilitar-tabela=\"vm.filtroEnvioDeEmails.arquivosSelecionados.length > 0\" \nim-preencher-mensagem-succes-no-controller=\"true\" im-pesquisar-na-tabela=\"vm.pesquisar\" \nim-metodo-enviar=\"vm.metodos.enviarEmails($event, vm.filtroEnvioDeEmails)\" \nim-desabilitar-butom-enviar=\"!vm.filtroEnvioDeEmails.email.codigo\r\n                                                          || vm.filtroEnvioDeEmails.arquivosSelecionados.length == 0\">\n</im-selecao-arquivos></div></form></div>");
$templateCache.put("app/main/financeiro/processamento/envio-de-emails/views/envio-de-emails.html","<div id=\"envio-de-emails\" class=\"page-layout simple tabbed\" layout=\"column\"><header-padrao \ntranslate-nome=\"ENVIO_DE_EMAILS.ENVIO_DE_EMAILS\" \nliberar-pesquisa-quando-datatable-ativo=\"vm.filtroEnvioDeEmails.arquivosSelecionados.length > 0\" \npesquisar=\"vm.pesquisar\"></header-padrao><div class=\"content\"><div ui-view=\"envio-de-emails-form\"></div></div></div>");
$templateCache.put("app/main/geral/relatorio/controle-horas/views/controle-horas.form.html","<div class=\"page-layout simple fullwidth doc-page\" layout-gt-xs=\"column\"><div class=\"content\" layout-gt-xs=\"column\">\n<div layout-gt-xs=\"row\" class=\"mb-10\" flex><div layout-gt-xs=\"row\" ng-show=\"vm.requisicaoSolicitada\" \nlayout-align=\"center center\" flex><div layout-gt-xs=\"column\" layout-align=\"center center\"><span \nclass=\"font-weight-500\" style=\"font-size: 16px\">{{vm.mensagemPreloader}}</span><md-progress-circular \nmd-mode=\"indeterminate\" md-diameter=\"30\" class=\"md-accent\"></md-progress-circular></div></div></div><form \nname=\"vm.form\" ms-horizontal-stepper ng-submit=\"vm.metodos.gerarRelatorio(vm.filtros)\" novalidate>\n<ms-horizontal-stepper-step ng-form=\"vm.form.tab.informacoesGerais\" \nstep-title=\"vm.translateTitulosSteps.informacoesGerais\"><div ui-view=\"steper-informacoes-gerais\"></div>\n</ms-horizontal-stepper-step></form></div></div>");
$templateCache.put("app/main/geral/relatorio/controle-horas/views/controle-horas.html","<div layout=\"column\" id=\"relatorio-contratos\" class=\"page-layout carded fullwidth\"><header-padrao \ntranslate-nome=\"RELATORIO_CLIENTE.RELATORIO_CONTROLE_HORAS\" ng-utiliza-pesquisa=\"false\" icone=\"\"></header-padrao>\n<md-content class=\"content\" flex ms-scroll><div ui-view=\"form\"></div></md-content></div>");
$templateCache.put("app/main/geral/consulta/log/views/consulta-log.html","<div id=\"consulta-log\" class=\"page-layout carded fullwidth\" layout=\"row\"><div layout=\"column\" flex><header-padrao \ntranslate-nome=\"CONSULTAS_LOG.LOGS_IMANAGER\" icone=\"\" liberar-pesquisa-quando-datatable-ativo=\"true\" \npesquisar=\"vm.pesquisar\"></header-padrao><form name=\"vm.form.consultaLog\" novalidate><md-content layout-gt-sm=\"row\" \nlayout-xs=\"column\"><div layout=\"column\" layout-padding flex ng-hide=\"vm.pesquisaAtiva\"><div layout=\"row\"><div \nlayout=\"row\" layout-align=\"center center\" flex><md-input-container class=\"md-block\" flex-gt-sm=\"15\"><label \ntranslate=\"CONSULTAS_LOG.USUARIO\"></label><md-select ng-model=\"vm.log.usuarioCodigo\" name=\"consultasLogUsuarioCodigo\" \nmd-on-open=\"vm.metodosLog.configuraMdSelectUsuarioLog()\"><md-select-header><input id=\"consultas-log-md-select-usuario\" \nclass=\"md-text\" ng-model=\"vm.filtrarUsuarioLog\" type=\"search\" placeholder=\"\" translate \ntranslate-attr-placeholder=\"CONSULTAS_LOG.PESQUISAR_USUARIO\"></md-select-header><md-option ng-value=\"usuario.codigo\" \nng-repeat=\"usuario in vm.usuarios | filter:vm.filtrarUsuarioLog\">{{usuario.nome}}</md-option><md-option ng-value=\"\">\nDesmarcar</md-option></md-select></md-input-container><md-input-container class=\"md-block\" flex-offset-gt-sm=\"10\" \nflex-gt-sm=\"15\"><label translate=\"CONSULTAS_LOG.ENTIDADE\"></label><md-select ng-model=\"vm.log.entidade\" \nname=\"consultasLogEntidade\" md-on-open=\"vm.metodosLog.configuraMdSelectEntidadeLog()\"><md-select-header><input \nid=\"consultas-log-md-select-entidade\" class=\"md-text\" ng-model=\"vm.filtrarEntidadeLog\" type=\"search\" placeholder=\"\" \ntranslate translate-attr-placeholder=\"CONSULTAS_LOG.PESQUISAR_ENTIDADE\"></md-select-header><md-option \nng-value=\"entidade.entidade\" ng-repeat=\"entidade in vm.entidades | filter:vm.filtrarEntidadeLog\">{{entidade.entidade}}\n</md-option><md-option ng-value=\"\">Desmarcar</md-option></md-select></md-input-container><md-input-container \nflex-offset-gt-sm=\"10\" class=\"mt-50\"><label translate=\"CONSULTAS_LOG.DATA_LOG\"></label><md-datepicker \nng-model=\"vm.log.data\" name=\"consultasLogData\" mascara-conversor-string-para-data ng-mask=\"3?9/1?9/9999\">\n</md-datepicker><div ng-messages=\"vm.form.consultaLog.consultasLogData.$error\"><div ng-message=\"valid\" \ntranslate=\"MENSAGEM_VALIDACAO.DATA_INVALIDA\"></div></div></md-input-container></div></div><div layout=\"row\" flex \nlayout-align=\"end end\"><md-button type=\"submit\" class=\"md-raised md-accent\" aria-label=\"Pesquisar\" translate \ntranslate-attr-aria-label=\"CONSULTAS_LOG.PESQUISAR\" ng-click=\"vm.metodosLog.pesquisar(vm.log, $event)\" \nng-disabled=\" vm.form.consultaLog.$invalid || vm.requisicaoSolicitada\"><span translate=\"CONSULTAS_LOG.PESQUISAR\">\n</span></md-button></div></div></md-content></form><md-divider></md-divider><div layout=\"column\" flex \nlayout-align=\"center center\" ng-show=\"vm.requisicaoSolicitada\"><md-progress-circular md-mode=\"indeterminate\" \nclass=\"md-accent\"></md-progress-circular></div><div layout=\"column\" flex ng-include=\"vm.rotasHtml.consultaTabelaLog\" \nng-show=\"vm.pesquisaAtiva && !vm.requisicaoSolicitada\"></div></div></div>");
$templateCache.put("app/main/geral/consulta/log/views/consulta-tabela-log.html","<div layout=\"row\" class=\"md-background-bg\" layout-align=\"end end\"><md-button class=\"md-raised md-accent\" \naria-label=\"Nova Consulta\" translate translate-attr-aria-label=\"CONSULTAS_LOG.NOVA_CONSULTA\" \nng-click=\"vm.metodosLog.novaConsulta();\"><span translate=\"CONSULTAS_LOG.NOVA_CONSULTA\"></span></md-button></div><div \nclass=\"md-background-bg md-whiteframe-1dp fullpage-datatable\" layout=\"column\" flex><table \nclass=\"dataTable row-border hover\" datatable=\"ng\" dt-options=\"vm.dtOptionsLog\"><thead><tr><th class=\"secondary-text\">\n<div class=\"table-header\"><span class=\"column-title\">Data</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Usuário</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Entidade</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Operação</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title text-center\">Chave Primária</span></div></th></tr></thead><tbody><tr \nng-repeat=\"log in vm.logs\"><td>{{log.data | date: \'dd/MM/yyyy - HH:mm:ss\'}}</td><td>{{log.usuario.login}}</td><td>\n{{log.entidade}}</td><td>{{log.operacao}}</td><td class=\"text-center\">{{log.campoChavePrimaria}}</td></tr></tbody>\n</table></div>");
$templateCache.put("app/main/geral/processamento/controle-horas-trabalhadas/views/controle-horas-trabalhadas-form.html","<div class=\"md-background-bg md-whiteframe-1dp\" flex><form name=\"vm.form\" novalidate><pg-toolbar \nentidades=\"vm.historicos\" entidade=\"vm.historico\" entidade-de-envio=\"vm.entidadeDeEnvio\" \ncontrolador-toolbar=\"vm.controleForm\" acao-pesquisar=\"vm.metodos.pesquisar()\" acao-criar=\"vm.metodos.salvar()\" \nacao-editar=\"vm.metodos.salvar()\" metodos-externos=\"vm.metodosExternosPgToolbar\" acao-excluir=\"vm.metodos.excluir()\" \nconstruir-dt-options=\"vm.metodos.construirDtOptions()\" \ndesabilitar-botao-inserir=\"vm.metodosGeral.desabilitaBotaoInserir()\" \ndesabilitar-botao-nova-pesquisa=\"vm.metodosGeral.desabilitarNovasPesquisas()\" \ndesabilitar-botao-pesquisar=\"vm.metodosGeral.desabilitarNovasPesquisas()\" \ndesabilitar-botoes-navegacao=\"vm.tabSelecionada == \'historicoViagem\'\" \ndesabilitar-botao-editar=\"vm.metodosGeral.desabilitaBotaoEditar()\" \npre-definir-campos-para-insercao=\"vm.metodosGeral.predefinirCamposParaInserir()\" \npre-definir-campos-para-edicao=\"vm.metodosGeral.predefinirCamposParaEdicao()\" \ndesabilitar-botao-excluir=\"vm.tabSelecionada == \'historicoViagem\'\" texto-exibido=\"vm.textoExibido\"></pg-toolbar>\n<md-content layout-padding ng-hide=\"vm.controleForm.listarTodasEntidades\" ng-disabled=\"vm.controleForm.emProgresso\">\n<md-tabs md-dynamic-height md-border-bottom><md-tab label=\"Geral\" md-active=\"vm.tabSelecionada === \'Geral\'\" \nmd-on-select=\"vm.metodosGeral.tabSelecionada(\'Geral\')\" ng-disabled=\"vm.controleForm.emProgresso\"><md-tab-label><label \ntranslate=\"PROCESSAMENTO.GERAL\"></label></md-tab-label><md-tab-body><div ui-view=\"aba-geral\"></div></md-tab-body>\n</md-tab><md-tab label=\"Histórico Viagem\" md-active=\"vm.tabSelecionada === \'historicoViagem\'\" \nmd-on-select=\"vm.metodosGeral.tabSelecionada(\'historicoViagem\')\" ng-disabled=\"vm.metodosGeral.desativaAbaViagem()\">\n<md-tab-label><label translate=\"PROCESSAMENTO.HISTORICO_VIAGEM\"></label></md-tab-label><md-tab-body><div \nui-view=\"aba-historico-viagem\"></div></md-tab-body></md-tab></md-tabs></md-content></form></div>");
$templateCache.put("app/main/geral/processamento/controle-horas-trabalhadas/views/controle-horas-trabalhadas-tabela.html","<div layout=\"column\" flex><div class=\"md-padding md-background-bg md-whiteframe-1dp fullpage-datatable\" \nlayout=\"column\" flex><table class=\"dataTable row-border hover\" id=\"datatable-controle-horas\" width=\"100%\"><thead><tr>\n<th>Editar</th><th>Período Inicial</th><th>Período Final</th><th>Técnicos</th></tr></thead></table></div></div>");
$templateCache.put("app/main/geral/processamento/controle-horas-trabalhadas/views/controle-horas-trabalhadas.html","<div id=\"controle-horas\" class=\"page-layout simple tabbed\" layout=\"column\"><header-padrao \ntranslate-nome=\"PROCESSAMENTO.CONTROLE_HORAS_TRABALHADAS\" icone=\"icon-cog\" \nliberar-pesquisa-quando-datatable-ativo=\"vm.controleForm.listarTodasEntidades\" pesquisar=\"vm.pesquisar\">\n</header-padrao><div class=\"content\"><div ui-view=\"controle-horas-form\"></div></div><div \nui-view=\"controle-horas-tabela\" ng-if=\"vm.controleForm.listarTodasEntidades\"></div></div>");
$templateCache.put("app/main/geral/brainstorming/visualizacao-ideias/views/visualizacao-ideias-form.html","<md-content id=\"tab-respostas\" class=\"md-padding\"><div class=\"md-background-bg md-whiteframe-1dp\"><md-button \nclass=\"array-buttons-visualizacao-ideias\" aria-label=\"{{item.descricao}}\" ng-repeat=\"item in vm.coresSituacoes\" \nng-class=\"{\'descricao-selecionada\': item.selecionada}\" ng-click=\"vm.metodosVisualizarIdeias.filtrarPorStatus(item)\" \nng-disabled=\"false\"><md-icon md-font-icon=\"icon-label\" class=\"s16\" ng-style=\"{\'color\' : item.cor}\"></md-icon><span \nclass=\"title\">{{item.descricao}}</span></md-button><md-button class=\"array-buttons-visualizacao-ideias\" \naria-label=\"Desmarcar filtros\" ng-click=\"vm.metodosVisualizarIdeias.desmarcarFiltros()\" ng-show=\"true\"><md-icon \nmd-font-icon=\"icon-label\" class=\"s16\" ng-style=\"{\'color\' : \'#323232\'}\"></md-icon><span class=\"title\">Desmarcar filtros\n</span></md-button><div layout=\"row\" layout-sm=\"row\" layout-align=\"center\" ng-show=\"vm.requisicaSolicitada\">\n<md-progress-circular md-mode=\"indeterminate\" class=\"md-accent\"></md-progress-circular></div><table \nclass=\"dataTable row-border hover\" datatable=\"ng\" dt-options=\"vm.dtOptionsIdeias\" dt-instance=\"vm.dtInstance\" \nwidth=\"100%\" ng-if=\"!vm.requisicaSolicitada && vm.ideias\"><thead><tr><th class=\"secondary-text none\"><div \nclass=\"table-header\"><span class=\"column-title\" style=\"font-size: 18px\">Código do status</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Ação</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Ideia</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Descrição</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Status</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Possui resposta?</span></div></th></tr>\n</thead><tbody><tr ng-repeat=\"ideia in vm.ideias\"><td><span>{{ideia.status}}</span></td><td \nclass=\"button-icone-cor-azul\"><i class=\"icon-open-in-new s16 icone-cor-padrao mr-10\" \nng-click=\"vm.controleForm.emProgresso || vm.metodosVisualizarIdeias.exibirIdeia($event, ideia)\" \nng-disabled=\"vm.controleForm.emProgresso\"></i></td><td style=\"text-align: center\" \nng-class=\"{\'solicitada\': ideia.status === 1,\r\n                                   \'analise\': ideia.status === 2,\r\n                                   \'cancelada\': ideia.status === 3,\r\n                                   \'aprovada\':ideia.status === 4,\r\n                                   \'executada\': ideia.status=== 5,\r\n                                   \'aguardando-resposta\': ideia.status === 6}\">\n<span>{{ideia.numero}}/{{ideia.ano}}</span></td><td class=\"descricao-ideia\"><span>\n{{vm.metodosVisualizarIdeias.retornarSubstringDescricao(ideia.descricao)}}</span></td><td class=\"font-size-14\" \nng-dblclick=\"vm.metodosVisualizarIdeias.abrirDialogEditarStatus(ideia)\"><div class=\"border-bottom-status\"><span>\n{{ideia.descricaoStatus}}</span></div></td><td layout-align=\"end center\" flex><div class=\"status-resposta\" \nng-class=\"{\'possui-respostas-sim\': vm.metodosVisualizarIdeias.retornaSituacao(ideia) === \'Sim\',\r\n                                        \'possui-respostas-nao\': vm.metodosVisualizarIdeias.retornaSituacao(ideia) === \'Não\'}\">\n<span>{{vm.metodosVisualizarIdeias.retornaSituacao(ideia)}}</span></div></td></tr></tbody></table></div></md-content>");
$templateCache.put("app/main/geral/brainstorming/visualizacao-ideias/views/visualizacao-ideias.html","<div id=\"visualizacao-ideias\" class=\"page-layout simple tabbed\" layout=\"column\"><header-padrao \ntranslate-nome=\"Visualização de ideias\" pesquisar=\"vm.pesquisar\" liberar-pesquisa-quando-datatable-ativo=\"true\">\n</header-padrao><div class=\"content\"><div ui-view=\"visualizacao-ideias-form\"></div></div></div>");
$templateCache.put("app/main/geral/relatorio/Clientes/views/listagem-simplificada-de-clientes.html","<div layout=\"column\" id=\"relatorio-contratos\" class=\"page-layout carded fullwidth\"><header-padrao \ntranslate-nome=\"RELATORIO_CLIENTE.RELATORIO_SIMPLIFICADO_DE_CLIENTES\" icone=\"\" \nliberar-pesquisa-quando-datatable-ativo=\"false\" pesquisar=\"vm.pesquisar\"></header-padrao><md-content class=\"content\" \nflex ms-scroll><div ui-view=\"relatorio-cliente-\"></div></md-content></div>");
$templateCache.put("app/main/geral/relatorio/Clientes/views/listagem-simplificada.form.html","<div class=\"page-layout simple fullwidth doc-page\" layout-gt-xs=\"column\"><div class=\"content\" layout-gt-xs=\"column\">\n<div layout-gt-xs=\"row\" class=\"mb-10\" flex><div layout-gt-xs=\"row\" ng-show=\"vm.requisicaoSolicitada\" \nlayout-align=\"center center\" flex><div layout-gt-xs=\"column\" layout-align=\"center center\"><span \nclass=\"font-weight-500\" style=\"font-size: 16px\">{{vm.mensagemPreloader}}</span><md-progress-circular \nmd-mode=\"indeterminate\" md-diameter=\"30\" class=\"md-accent\"></md-progress-circular></div></div></div><form \nname=\"vm.form.geral\" ms-horizontal-stepper ng-submit=\"vm.metodos.gerarRelatorio(vm.filtrosClientes)\" novalidate>\n<ms-horizontal-stepper-step ng-form=\"vm.form.tab.informacoesGerais\" step=\"1\" \nstep-title=\"vm.translateTitulosSteps.informacoesGerais\"><div ui-view=\"relatorio-clientes--steper-informacoes-gerais\">\n</div></ms-horizontal-stepper-step><ms-horizontal-stepper-step ng-form=\"vm.form.tab.produtoSegmentacao\" step=\"2\" \nstep-title=\"vm.translateTitulosSteps.produtoSegmentacao\"><div ui-view=\"relatorio-clientes--steper-produto-segmentacao\">\n</div></ms-horizontal-stepper-step><ms-horizontal-stepper-step ng-form=\"vm.form.tab.caracteristica\" step=\"3\" \nstep-title=\"vm.translateTitulosSteps.caracteristica\"><div ui-view=\"relatorio-contratos--steper-caracteristica\"></div>\n</ms-horizontal-stepper-step><ms-horizontal-stepper-step ng-form=\"vm.form.tab.licenca\" step=\"4\" \nstep-title=\"vm.translateTitulosSteps.licenca\"><div ui-view=\"relatorio-clientes--steper-licenca\"></div>\n</ms-horizontal-stepper-step><input type=\"text\" ng-hide=\"true\" ng-disabled=\"true\" ng-model=\"vm.validador\" \nname=\"validador\" ng-required=\"vm.requisicaoSolicitada\"></form></div></div>");
$templateCache.put("app/main/geral/brainstorming/visualizacao-ideias/dialog-status/visualizacao-ideias-dialog-status.html","<md-dialog id=\"sprint-dialog-backlog-colaboradores\" class=\"dialogo-padrao\" aria-label=\"Dialog\"><form \nname=\"vm.form.visualizacao-ideia-status-codigo\" class=\"md-inline-form\" novalidate><md-toolbar \nclass=\"md-accent md-tall\" layout=\"column\"><div class=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" \nlayout-align=\"space-between center\"><span class=\"title\">{{vm.titulo}}</span><md-button class=\"md-icon-button\" \nng-click=\"vm.metodosDialog.fecharDialog()\" aria-label=\"Fechar dialog\" translate translate-attr-aria-label=\"\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><div layout=\"row\" layout-sm=\"row\" \nlayout-align=\"center\" ng-show=\"vm.requisicaoSolicitada\"><md-progress-circular md-mode=\"indeterminate\" \nclass=\"md-accent\"></md-progress-circular></div><md-dialog-content ng-hide=\"vm.requisicaoSolicitada\"><div layout=\"row\" \nlayout-align=\"center center\"><md-input-container class=\"md-block\" flex-gt-sm=\"50\"><label translate=\"\">Status</label>\n<md-select ng-model=\"vm.ideia.status\" \nng-disabled=\"vm.usuarioLogado.clsPerfil.codigo != \'3\' && vm.usuarioLogado.clsPerfil.codigo != \'8\' && vm.usuarioLogado.clsPerfil.codigo != \'9\'\" \nname=\"status\" ng-required=\"true\"><md-option ng-value=\"status.codigo\" \nng-repeat=\"status in vm.status | orderBy:\'descricao\'\">{{status.descricao}}</md-option></md-select><div \nng-messages=\"historicoSituacaoForm.status.$error\"><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container></div></md-dialog-content>\n<md-dialog-actions layout=\"row\"><div layout=\"row\" layout-align=\"end center\" flex><md-button type=\"submit\" \nng-click=\"vm.metodosDialog.salvar(vm.ideia)\" class=\"send-button md-accent md-raised\" \nng-disabled=\"vm.usuarioLogado.clsPerfil.codigo != \'3\' && vm.usuarioLogado.clsPerfil.codigo != \'8\' && vm.usuarioLogado.clsPerfil.codigo != \'9\'\" \naria-label=\"SALVAR\" translate=\"SPRINT.SALVAR\" translate-attr-aria-label=\"SPRINT.SALVAR\">Salvar</md-button></div>\n</md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/geral/brainstorming/brainstorming/views/brainstorming-form.html","<div class=\"md-background-bg md-whiteframe-1dp\"><form name=\"vm.brainstormingForm\" novalidate><pg-toolbar \niniciar-chamando-pesquisa=\"vm.brainstorming.chamarPesquisa\" entidades=\"vm.listaBrainstorming\" \nentidade=\"vm.brainstorming\" entidade-de-envio=\"vm.entidadeDeEnvio\" controlador-toolbar=\"vm.controleForm\" \ncontrolador-pre-loader=\"vm.controlePreloader\" acao-pesquisar=\"vm.metodosBrainstorming.pesquisar()\" \nacao-criar=\"vm.metodosBrainstorming.salvar(vm.brainstorming)\" \nacao-editar=\"vm.metodosBrainstorming.editar(vm.brainstorming)\" \nacao-excluir=\"vm.metodosBrainstorming.excluir(vm.brainstorming)\" \nmetodo-externo-acao-navegacao=\"vm.metodosGeral.preDefinirValoresQuandoNavegado()\" \nmetodo-externo-acao-nova-pesquisa=\"vm.metodosGeral.novaPesquisa()\" \npre-definir-campos-para-insercao=\"vm.metodosGeral.preDefinirCamposParaInserir()\" \npre-definir-campos-para-edicao=\"vm.metodosGeral.PreDefinirCamposParaEdicao()\" \niniciar-chamando-pesquisa=\"vm.iniciarChamandoPesquisa\" iniciar-habilitando-insercao=\"vm.iniciarHabilitandoInsercao\" \nconstruir-dt-options=\"vm.metodosBrainstorming.construirDtOptions()\" metodos-externos=\"vm.metodosExternosPgToolbar\" \ncampo-pesquisar=\"vm.pesquisar\" metodo-externo-acao-reverter=\"vm.metodosGeral.reverter()\"></pg-toolbar><md-content \nlayout-padding ng-hide=\"vm.controleForm.listarTodasEntidades\" ng-disabled=\"vm.controleForm.emProgresso\"><md-tabs \nmd-dynamic-height md-border-bottom><md-tab label=\"Brainstorming\" md-active=\"vm.tabSelecionada === \'brainstorming\'\" \nmd-on-select=\"vm.metodosGeral.tabSelecionada(\'brainstorming\')\" ng-disabled=\"false\"><md-tab-label><label \ntranslate=\"BRAINSTORMING.BRAINSTORMING\">Brainstorming</label></md-tab-label><md-tab-body><div \nng-if=\"vm.tabSelecionada == \'brainstorming\'\" ng-include=\"vm.htmlRota.tabs.tabBrainstorming\"></div></md-tab-body>\n</md-tab><md-tab label=\"Respostas\" md-on-select=\"vm.metodosGeral.tabSelecionada(\'respostas\')\" \nng-disabled=\"!vm.controleForm.pesquisaAtiva || vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo\">\n<md-tab-label><label translate=\"BRAINSTORMING.RESPOSTAS\">Respostas</label></md-tab-label><md-tab-body><div \nng-if=\"vm.tabSelecionada == \'respostas\'\" ng-include=\"vm.htmlRota.tabs.tabRespostas.respostas\"></div></md-tab-body>\n</md-tab></md-tabs></md-content></form></div>");
$templateCache.put("app/main/geral/brainstorming/brainstorming/views/brainstorming-tabela.html","<div layout=\"column\" flex><div class=\"md-padding md-background-bg md-whiteframe-1dp fullpage-datatable\" \nlayout=\"column\" flex><table class=\"dataTable row-border hover\" id=\"datatable-brainstorming\" width=\"100%\"><thead><tr>\n<th>Ação</th><th>Número</th><th>Ano</th><th>Descrição</th></tr></thead></table></div></div>");
$templateCache.put("app/main/geral/brainstorming/brainstorming/views/brainstorming.html","<div id=\"brainstorming\" class=\"page-layout simple tabbed\" layout=\"column\"><header-padrao \ntranslate-nome=\"Brainstorming\" liberar-pesquisa-quando-datatable-ativo=\"vm.controleForm.listarTodasEntidades\" \npesquisar=\"vm.pesquisar\"></header-padrao><div class=\"content\"><div ui-view=\"brainstorming-form\"></div></div><div \nui-view=\"brainstorming-tabela\" ng-if=\"vm.controleForm.listarTodasEntidades\"></div></div>");
$templateCache.put("app/main/geral/cadastro/caracteristica/views/caracteristica-form.html","<div class=\"md-background-bg md-whiteframe-1dp\"><form name=\"vm.form.caracteristica\" novalidate><pg-toolbar \nentidades=\"vm.caracteristicas\" entidade=\"vm.caracteristica\" entidade-de-envio=\"vm.entidadeDeEnvio\" \ncontrolador-toolbar=\"vm.controleForm\" acao-pesquisar=\"vm.metodos.pesquisar()\" \nacao-criar=\"vm.metodos.salvar(vm.caracteristica)\" acao-editar=\"vm.metodos.editar(vm.caracteristica)\" \nacao-excluir=\"vm.metodos.excluir(vm.caracteristica)\" construir-dt-options=\"vm.metodos.construirDtOptions()\" \nmetodos-externos=\"vm.metodosExternosPgToolbar\" campo-pesquisar=\"vm.pesquisar\" \npre-definir-campos-para-insercao=\"vm.metodos.predefinirCamposInsercao()\" \ndesabilitar-botao-inserir=\"vm.tabSelecionada != \'caracteristica\'\" \ndesabilitar-botao-editar=\"vm.tabSelecionada != \'caracteristica\'\" \ndesabilitar-botao-excluir=\"vm.tabSelecionada != \'caracteristica\'\"></pg-toolbar><md-content layout-padding \nng-hide=\"vm.controleForm.listarTodasEntidades\" ng-disabled=\"vm.controleForm.emProgresso\"><md-tabs md-dynamic-height \nmd-border-bottom><md-tab label=\"Característica\" md-active=\"vm.tabSelecionada === \'caracteristica\'\" \nng-disabled=\"vm.controleAba.controladorCaracteristica\" md-on-select=\"vm.metodosGeral.tabSelecionada(\'caracteristica\')\">\n<md-tab-label><label translate=\"CARACTERISTICA.CARACTERISTICA\">Caracteristica</label></md-tab-label><md-tab-body><div \nng-include=\"vm.htmlRota.tabs.tabCaracteristica\"></div></md-tab-body></md-tab><md-tab label=\"Clientes\" \nmd-on-select=\"vm.metodosGeral.tabSelecionada(\'clientesCaracteristica\')\" \nng-if=\"!(vm.caracteristica.tipo === 2 || vm.caracteristica.tipo === 3)\" \nng-disabled=\"!vm.controleForm.pesquisaAtiva || vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo\">\n<md-tab-label><label translate=\"CARACTERISTICA.CLIENTES\"></label></md-tab-label><md-tab-body><div \nng-if=\"vm.tabSelecionada == \'clientesCaracteristica\'\" ng-include=\"vm.htmlRota.tabs.tabCliente\"></div></md-tab-body>\n</md-tab></md-tabs></md-content></form></div>");
$templateCache.put("app/main/geral/cadastro/caracteristica/views/caracteristica.html","<div id=\"caracteristica-cliente\" class=\"page-layout simple tabbed\" layout=\"column\"><header-padrao \ntranslate-nome=\"CARACTERISTICA.CARACTERISTICA\" \nliberar-pesquisa-quando-datatable-ativo=\"vm.controleForm.listarTodasEntidades\" pesquisar=\"vm.pesquisar\">\n</header-padrao><div class=\"content\"><div ui-view=\"caracteristica-form\"></div></div><div \nui-view=\"caracteristicas-tabela\" ng-if=\"vm.controleForm.listarTodasEntidades\"></div></div>");
$templateCache.put("app/main/geral/cadastro/caracteristica/views/caracteristicas-tabela.html","<div layout=\"column\" flex><div class=\"md-padding md-background-bg md-whiteframe-1dp fullpage-datatable\" \nlayout=\"column\" flex><table class=\"dataTable row-border hover\" id=\"datatable-cliente-caracteristica\" width=\"100%\">\n<thead><tr><th>Ação</th><th>Código</th><th>Descrição</th></tr></thead></table></div></div>");
$templateCache.put("app/main/geral/indicadores/gestao-iaguas/views/gestao-iaguas.form.html","<div id=\"gestao-iaguas-form\" class=\"pt-10 pb-10\"><div layout=\"column\" class=\"pr-20 pb-20 pl-20\" \nng-if=\"vm.dados.length\"><div class=\"button-float\"><md-button class=\"md-primary icon-filter-outline md-fab\" \naria-label=\"Abrir filtro\" ng-click=\"vm.metodos.abrirFiltro()\"></md-button></div><div class=\"pr-40 pl-40 pb-10\" \nflex=\"100\" layout-align=\"center center\" layout-gt-sm=\"row\" layout=\"column\" show-gt-sm><div class=\"container-datas\" \nlayout-gt-sm=\"row\" layout=\"column\" flex ng-if=\"vm.filtro.tipoFiltro == 2\"><ms-widget class=\"h-60\" \nstyle=\"padding: 4px!important\" layout=\"column\" flex=\"100\"><ms-widget-front class=\"p-8 md-blue-900-bg white-fg\" \nlayout=\"row\" flex=\"100\"><div class=\"pt-2 pb-2\" layout=\"column\" layout-align=\"center center\" flex=\"100\"><div flex=\"100\" \nlayout-align=\"center center\" class=\"font-weight-500 secondary-text\">Data inicial</div><div flex=\"100\" \nlayout-align=\"center center\" class=\"font-size-18\">{{vm.filtro.dataInicio | date: \"dd/MM/yyyy\" }}</div></div>\n</ms-widget-front></ms-widget><ms-widget class=\"h-60\" style=\"padding: 4px!important\" layout=\"column\" flex=\"100\">\n<ms-widget-front class=\"p-8 md-blue-900-bg white-fg\" layout=\"row\" flex=\"100\"><div class=\"pt-2 pb-2\" layout=\"column\" \nlayout-align=\"center center\" flex=\"100\"><div flex=\"100\" layout-align=\"center center\" \nclass=\"font-weight-500 secondary-text\">Data final</div><div flex=\"100\" layout-align=\"center center\" \nclass=\"font-size-18\">{{vm.filtro.dataFim | date: \"dd/MM/yyyy\" }}</div></div></ms-widget-front></ms-widget></div>\n<ms-widget class=\"h-60\" style=\"padding: 4px!important; max-width: 30%\" layout=\"column\" flex=\"30\" \nng-if=\"vm.filtro.tipoFiltro == 1\"><ms-widget-front class=\"p-8 md-blue-900-bg white-fg\" layout=\"row\" flex=\"100\"><div \nclass=\"pt-2 pb-2\" layout=\"column\" layout-align=\"center center\" flex=\"100\"><div flex=\"100\" layout-align=\"center center\" \nclass=\"font-weight-500 secondary-text\">Geral</div><div flex=\"100\" layout-align=\"center center\" class=\"font-size-18\">\nTodo o período</div></div></ms-widget-front></ms-widget></div><ms-widget style=\"padding:0!important\"><ms-widget-front>\n<div><table class=\"dataTable hover row-border\" dt-options=\"vm.dtOptions\" datatable=\"ng\"><thead><tr><th \nclass=\"secondary-text borda-esquerda borda-direita\" colspan=\"4\"><div class=\"table-header\"><span \nclass=\"column-title text-center\">Geral</span></div></th><th class=\"secondary-text\" colspan=\"4\"><div \nclass=\"table-header\"><span class=\"column-title text-center\">Equipamentos</span></div></th><th \nclass=\"secondary-text borda-direita\" colspan=\"1\"><div class=\"table-header\"><i \nclass=\"icon-information-outline s28 icone-cor-padrao\" ng-click=\"vm.metodos.abrirDialogInformativo()\"><md-tooltip><span>\nInformações de cálculo do progresso da meta</span></md-tooltip></i></div></th></tr><tr><th \nclass=\"secondary-text borda-esquerda borda-direita\"><div class=\"table-header\"><span class=\"column-title text-center\">\nCliente</span></div></th><th class=\"secondary-text borda-direita\"><div class=\"table-header\"><span \nclass=\"column-title text-center\">Número de ligações</span></div></th><th class=\"secondary-text borda-direita\"><div \nclass=\"table-header\"><span class=\"column-title text-center\">Usuários logados</span></div></th><th \nclass=\"secondary-text borda-direita\"><div class=\"table-header\"><span class=\"column-title text-center\">%</span></div>\n</th><th class=\"secondary-text borda-direita\"><div class=\"table-header\"><span class=\"column-title text-center\">\nEquipamentos logados</span></div></th><th class=\"secondary-text borda-direita\"><div class=\"table-header\"><span \nclass=\"column-title text-center\">iOS</span></div></th><th class=\"secondary-text borda-direita\"><div \nclass=\"table-header\"><span class=\"column-title text-center\">%</span></div></th><th \nclass=\"secondary-text borda-direita\"><div class=\"table-header\"><span class=\"column-title text-center\">Android</span>\n</div></th><th class=\"secondary-text borda-direita\"><div class=\"table-header\"><span class=\"column-title text-center\">%\n</span></div></th></tr></thead><tbody><tr ng-repeat=\"dado in vm.dados track by $index\" class=\"campo-tabela\"><td \nclass=\"text-left border-left border-right\" style=\"padding-left: 5px !important\"><span>{{ dado.cliente }}</span></td><td\n class=\"text-center border-right\"><span>{{ dado.numeroLigacoes || \"-\" }}</span></td><td \nclass=\"text-center border-right\"><span>{{ dado.usuariosLogados || \"-\" }}</span></td><td \nclass=\"text-center border-right\"><span>\n{{ vm.metodos.calcularPorcentagem(dado.numeroLigacoes, dado.usuariosLogados) || \"-\" }}</span></td><td \nclass=\"text-center border-right\"><span>{{ dado.equipamentosLogados || \"-\" }}</span></td><td \nclass=\"text-center border-right\"><span>{{ dado.ios || \"-\" }}</span></td><td class=\"text-center border-right\"><span>\n{{ vm.metodos.calcularPorcentagem(dado.equipamentosLogados, dado.ios) || \"-\" }}</span></td><td \nclass=\"text-center border-right\"><span>{{dado.android || \"-\"}}</span></td><td class=\"text-center border-right\"><span>\n{{ vm.metodos.calcularPorcentagem(dado.equipamentosLogados, dado.android) || \"-\" }}</span></td></tr></tbody><tfoot><tr>\n<th class=\"blue-bg white-fg borda-esquerda borda-direita\"><div class=\"table-header\" \nstyle=\"text-align: left !important\"><span class=\"column-title text-center\">Totalizadores</span></div></th><th \nclass=\"blue-bg white-fg borda-direita\"><div class=\"table-header\"><span class=\"column-title text-center\">\n{{ (vm.metodos.calcularTotal(\"numeroLigacoes\") | number) || \"-\" }}</span></div></th><th \nclass=\"blue-bg white-fg borda-direita\"><div class=\"table-header\"><span class=\"column-title text-center\">\n{{ (vm.metodos.calcularTotal(\"usuariosLogados\") | number) || \"-\" }}</span></div></th><th \nclass=\"blue-bg white-fg borda-direita\"><div class=\"table-header\"><span class=\"column-title text-center\">\n{{ vm.metodos.calcularPorcentagemTotal(\"numeroLigacoes\", \"usuariosLogados\") || \"-\" }}</span></div></th><th \nclass=\"blue-bg white-fg borda-direita\"><div class=\"table-header\"><span class=\"column-title text-center\">\n{{ (vm.metodos.calcularTotal(\"equipamentosLogados\") | number) || \"-\" }}</span></div></th><th \nclass=\"blue-bg white-fg borda-direita\"><div class=\"table-header\"><span class=\"column-title text-center\">\n{{ (vm.metodos.calcularTotal(\"ios\") | number) || \"-\" }}</span></div></th><th class=\"blue-bg white-fg borda-direita\">\n<div class=\"table-header\"><span class=\"column-title text-center\">\n{{ vm.metodos.calcularPorcentagemTotal(\"equipamentosLogados\", \"ios\") || \"-\" }}</span></div></th><th \nclass=\"blue-bg white-fg borda-direita\"><div class=\"table-header\"><span class=\"column-title text-center\">\n{{ (vm.metodos.calcularTotal(\"android\") | number) || \"-\" }}</span></div></th><th \nclass=\"blue-bg white-fg borda-direita\"><div class=\"table-header\"><span class=\"column-title text-center\">\n{{ vm.metodos.calcularPorcentagemTotal(\"equipamentosLogados\", \"android\") || \"-\" }}</span></div></th></tr></tfoot>\n</table></div></ms-widget-front></ms-widget><div layout=\"column\" flex=\"100\" class=\"pt-20\"><div layout-gt-sm=\"row\" \nlayout=\"column\" layout-align-gt-sm=\"center center\" flex-gt-sm=\"50\" flex=\"100\"><ms-widget class=\"h-60\" \nstyle=\"padding: 4px!important; width: 100%\" layout=\"column\" layout-align-gt-sm=\"center center\" flex-gt-sm=\"25\" \nflex=\"100\"><ms-widget-front class=\"p-8 md-blue-900-bg white-fg\" layout=\"row\" flex=\"100\"><div class=\"pt-2 pb-2\" \nlayout=\"column\" layout-align=\"center center\" flex=\"100\"><div flex=\"100\" layout-align=\"center center\" \nclass=\"font-weight-500 font-size-14 secondary-text\">Total de clientes</div><div flex=\"100\" \nlayout-align=\"center center\" class=\"font-size-20\">{{ vm.dados.length | number }}</div></div></ms-widget-front>\n</ms-widget></div></div></div></div>");
$templateCache.put("app/main/geral/indicadores/gestao-iaguas/views/gestao-iaguas.html","<div id=\"gestao-iaguas\" class=\"page-layout simple tabbed\" layout=\"column\"><carregamento-circular \nem-progresso=\"vm.emProgresso\" titulo=\"Aguarde...\" mensagem=\"Buscando dados...\"></carregamento-circular><md-sidenav \nclass=\"sidenav md-sidenav-right\" md-component-id=\"filtro-gestao-iaguas\" md-whiteframe=\"4\" \nui-view=\"filtro-gestao-iaguas@app.geral_indicadores_gestaoiaguas\" ms-scroll ms-sidenav-helper></md-sidenav>\n<header-padrao translate-nome=\"Gestão IÁguas\" icone=\"icon-chart-bar\" ng-utiliza-pesquisa=\"false\"></header-padrao><div \nclass=\"content-card\" layout=\"column\" flex><div class=\"content\" flex ms-scroll><div \nui-view=\"gestao-iaguas-form@app.geral_indicadores_gestaoiaguas\"></div></div></div></div>");
$templateCache.put("app/main/gerenciamento-custo/cadastro/custo/views/custo-form.html","<div class=\"md-background-bg md-whiteframe-1dp\"><form name=\"vm.form\" novalidate><pg-toolbar entidade=\"vm.custo\" \nentidades=\"vm.custos\" entidade-de-envio=\"vm.entidadeDeEnvio\" controlador-toolbar=\"vm.controleForm\" \nacao-pesquisar=\"vm.metodos.pesquisar()\" acao-criar=\"vm.metodos.salvar(vm.custo)\" \nacao-editar=\"vm.metodos.editar(vm.custo)\" acao-excluir=\"vm.metodos.excluir(vm.custo)\" \nconstruir-dt-options=\"vm.metodos.construirDtOptions()\" \npre-definir-campos-para-insercao=\"vm.metodos.predefinirCamposParaInsercao(vm.custo)\" \nmetodos-externos=\"vm.metodosExternosPgToolbar\" campo-pesquisar=\"vm.pesquisar\"></pg-toolbar><md-content layout-padding \nng-hide=\"vm.controleForm.listarTodasEntidades\" ng-disabled=\"vm.controleForm.emProgresso\"><div class=\"form-container\">\n<div layout-gt-xs=\"row\" layout-align=\"center center\" flex><md-input-container class=\"md-block\" flex><label \ntranslate=\"FATURAMENTO_SOFTWARE.DESCRICAO\"></label><input type=\"text\" ng-model=\"vm.custo.descricao\" name=\"descricao\" \nmascara-tamanho-campo=\"50\" ng-required=\"vm.controleForm.inserirAtivo || vm.controleForm.editarAtivo\" md-maxlength=\"50\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo \r\n                                            && !vm.controleForm.inserirAtivo\">\n<div ng-messages=\"vm.form.descricao.$error\"><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container><md-input-container class=\"md-block\" \nflex><label translate=\"FATURAMENTO_SOFTWARE.VALOR_CUSTO\"></label><input type=\"text\" ng-model=\"vm.custo.custo\" \nname=\"custo\" mascara-tamanho-campo=\"12\" ui-money-mask \nng-required=\"vm.controleForm.inserirAtivo || vm.controleForm.editarAtivo\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo\r\n                                && !vm.controleForm.inserirAtivo\">\n<div ng-messages=\"vm.form.custo.$error\"><div ng-message=\"required\" translate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\">\n</div></div></md-input-container></div><div layout-gt-xs=\"row\" flex><md-input-container class=\"md-block\" flex><label \ntranslate=\"FATURAMENTO_SOFTWARE.PRAZO\"></label><input type=\"text\" \nng-required=\"vm.controleForm.inserirAtivo || vm.controleForm.editarAtiv\" ng-model=\"vm.custo.prazo\" mascara-numeros=\"5\" \nname=\"prazo\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo\r\n                                && !vm.controleForm.inserirAtivo\">\n<div ng-messages=\"vm.form.prazo.$error\"><div ng-message=\"required\" translate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\">\n</div></div></md-input-container><md-input-container class=\"md-block\" flex-gt-sm=\"30\" \nng-if=\"vm.squadUsuarioLogado.length > 1\"><label>Squad</label><md-select ng-model=\"vm.custo.squadCodigo\" \nname=\"squadCodigo\" ng-required=\"vm.controleForm.inserirAtivo || vm.controleForm.editarAtivo\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo\r\n                        && !vm.controleForm.inserirAtivo\" \nng-change=\"vm.metodos.selectChangeSquads(vm.custo.squadCodigo)\" multiple=\"multiple\"><md-option ng-value=\"squad.codigo\" \nng-repeat=\"squad in vm.squads track by squad.codigo\">{{squad.descricao}}</md-option></md-select><div \nng-messages=\"vm.form.squadCodigo.$error\"><div ng-message=\"required\">Campo obrigatório</div></div></md-input-container>\n<md-input-container class=\"md-block select\" flex><label>Valor ponto</label><md-select \nng-model=\"vm.custo.historicoCusto\" name=\"historicoCusto\" md-on-open=\"vm.metodos.configurarSelect()\" \nng-model-options=\"{trackBy: \'$value.codigo\'}\" ng-required=\"vm.controleForm.inserirAtivo || vm.controleForm.editarAtiv\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo\r\n                                    && !vm.controleForm.inserirAtivo\">\n<md-select-header id=\"select\"><input name=\"vm.termoProcurado\" ng-model=\"vm.termoProcurado\" type=\"search\" \nplaceholder=\"Pesquisar...\" class=\"md-text\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo\r\n                                        && !vm.controleForm.inserirAtivo\">\n</md-select-header><md-option ng-value=\"item\" \nng-repeat=\"item in vm.listaHistoricoCusto\r\n                                                                | filter:vm.termoProcurado | orderBy:\'codigo\' track by item.codigo\">\nR$ {{item.valorPonto}} - {{vm.metodos.preparaDataParaString(item.periodoInicial)}} à {{vm.metodos.preparaDataParaString(item.periodoFinal)}}\n</md-option></md-select><div ng-messages=\"vm.form.historicoCusto.$error\"><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container></div></div></md-content></form>\n</div>");
$templateCache.put("app/main/gerenciamento-custo/cadastro/custo/views/custo-tabela.html","<div layout=\"column\" flex><div class=\"md-padding md-background-bg md-whiteframe-1dp fullpage-datatable\" \nlayout=\"column\" flex><table class=\"dataTable row-border hover\" id=\"datatable-conclusao-atendimento\" width=\"100%\">\n<thead><tr><th>Ação</th><th>Descricao</th><th>Valor</th><th>Prazo</th></tr></thead></table></div></div>");
$templateCache.put("app/main/gerenciamento-custo/cadastro/custo/views/custo.html","<div id=\"conclusao\" class=\"page-layout simple tabbed\" layout=\"column\"><header-padrao \ntranslate-nome=\"FATURAMENTO_SOFTWARE.CUSTO\" \nliberar-pesquisa-quando-datatable-ativo=\"vm.controleForm.listarTodasEntidades\" pesquisar=\"vm.pesquisar\">\n</header-padrao><div class=\"content\"><div ui-view=\"custo_software-form\"></div></div><div \nui-view=\"custo_software-tabela\" ng-if=\"vm.controleForm.listarTodasEntidades\"></div></div>");
$templateCache.put("app/main/gerenciamento-custo/processamento/analise-custo/views/analise-custo-form.html","<div id=\"analise-custo-form\" class=\"md-background-bg md-whiteframe-1dp\"><carregamento-circular \nem-progresso=\"vm.emProgresso\" titulo=\"Aguarde...\" mensagem=\"Buscando dados...\"></carregamento-circular>\n<md-fab-speed-dial class=\"md-scale\" md-direction=\"left\" ng-if=\"vm.todasHistoriasFiltradas.length > 0\" \nng-disabled=\"vm.emProgresso\" layout-align=\"end start\" flex><md-fab-trigger><md-button \nclass=\"md-fab md-accent md-icon-button\" aria-label=\"menu\"><md-icon md-font-icon=\"icon-menu s30\"></md-icon></md-button>\n</md-fab-trigger><md-fab-actions><md-button class=\"md-fab md-raised md-mini md-accent\" aria-label=\"Add\" \nng-click=\"vm.metodos.abrirDialogDashboard()\" ng-disabled=\"!vm.todasHistoriasFiltradas.length > 0\"><md-icon \nmd-font-icon=\"icon-currency-usd s20\"></md-icon><md-tooltip md-direction=\"top\"><span>Abrir dashboard</span></md-tooltip>\n</md-button><md-button class=\"md-fab md-raised md-mini md-accent\" aria-label=\"Add\" \nng-click=\"vm.metodos.abrirDialogConclusao()\" \nng-disabled=\"!vm.todasHistoriasFiltradas.length > 0 || (vm.dataInicialAberturaHistoria != undefined || vm.dataFinalAberturaHistoria != undefined)\">\n<md-icon md-font-icon=\"icon-checkbox-marked-circle-outline s20\"></md-icon><md-tooltip md-direction=\"top\"><span>\nConcluir projetos</span></md-tooltip></md-button></md-fab-actions></md-fab-speed-dial><form name=\"vm.form\" novalidate>\n<md-progress-linear class=\"md-accent\" ng-show=\"vm.enviando\" md-mode=\"indeterminate\"></md-progress-linear><md-content \nstyle=\"overflow-y: hidden\" layout-padding ng-hide=\"vm.controleForm.listarTodasEntidades\" \nng-disabled=\"vm.controleForm.emProgresso\"><div class=\"form-container\" layout-gt-xs=\"row\" layout-align=\"center center\" \nflex><div flex=\"20\"><md-input-container class=\"md-block input-periodo\"><label \ntranslate=\"FATURAMENTO_SOFTWARE.DATA_INICIAL\"></label><md-datepicker name=\"dataInicialAberturaHistoria\" \nmd-open-on-focus ng-model=\"vm.dataInicialAberturaHistoria\" ng-mask=\"3?9/1?9/9999\"></md-datepicker><div \nng-messages=\"vm.form.dataInicialAberturaHistoria.$error\"><div ng-message=\"valid\" \ntranslate=\"MENSAGEM_VALIDACAO.DATA_INVALIDA\"></div><div ng-message=\"mindate\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_DATA_FINAL\"></div></div></md-input-container></div><div flex=\"20\">\n<md-input-container class=\"md-block input-periodo data-final\"><label translate=\"FATURAMENTO_SOFTWARE.DATA_FINAL\" \nclass=\"alinhar-label-data\"></label><md-datepicker name=\"dataFinalAberturaHistoria\" md-open-on-focus \nng-model=\"vm.dataFinalAberturaHistoria\" ng-mask=\"3?9/1?9/9999\"></md-datepicker><div \nng-messages=\"vm.form.dataFinalAberturaHistoria.$error\"><div ng-message=\"valid\" \ntranslate=\"MENSAGEM_VALIDACAO.DATA_INVALIDA\"></div><div ng-message=\"mindate\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_DATA_FINAL\"></div></div></md-input-container></div></div><div layout-gt-xs=\"row\" \nlayout-sm=\"column\" layout-md=\"column\" flex><div layout-gt-xs=\"column\" flex=\"100\"><div layout-gt-xs=\"row\" flex-md \nflex-sm><div layout=\"row\" flex><md-input-container class=\"md-block\" ng-if=\"vm.squadUsuarioLogado.length > 1\" flex>\n<label>Squad</label><md-select ng-model=\"vm.squadCodigo\" name=\"squadCodigo\" ng-required=\"true\" \nng-change=\"vm.metodos.selectChangeSquad(vm.squadCodigo)\"><md-option ng-value=\"squad.codigo\" \nng-repeat=\"squad in vm.squads track by squad.codigo\">{{squad.descricao}}</md-option></md-select><div \nng-messages=\"vm.form.squadCodigo.$error\"><div ng-message=\"required\">Campo obrigatório</div></div></md-input-container>\n<md-input-container class=\"md-block\" flex><label>Projeto</label><md-select name=\"projetos\" \nmd-on-open=\"vm.metodos.configuraMdSelectProjetos()\" multiple=\"multiple\" ng-required=\"true\" ng-model=\"vm.projetos\">\n<md-select-header ng-if=\"vm.todosProjetos.length > 0\"><input id=\"analise-custo-projetos-md-select\" class=\"md-text\" \ntype=\"search\" ng-if=\"vm.todosProjetos && vm.todosProjetos.length > 0\" placeholder=\"Pesquisar projetos\" \nng-model=\"vm.filtrarProjetos\"></md-select-header><md-option ng-value=\"projeto.codigo\" \nng-repeat=\"projeto in vm.todosProjetos | filter:vm.filtrarProjetos track by projeto.codigo\">{{ projeto.descricao }}\n</md-option><div style=\"color: rgba(0, 0, 0, 0.38); padding: 8px\" \nng-if=\"(vm.squadUsuarioLogado.length > 1 && (vm.squadCodigo || vm.squadCodigos.length)) && \r\n                                        (vm.todosProjetos.length === 0) || \r\n                                        vm.filtrarProjetos && \r\n                                        (vm.todosProjetos | filter:vm.filtrarProjetos).length === 0\">\nNenhum projeto encontrado.</div><div style=\"color: rgba(0, 0, 0, 0.38); padding: 8px\" \nng-if=\"!(vm.squadCodigo || vm.squadCodigos.length) && vm.squadUsuarioLogado.length > 1\">\nÉ necessário informar uma squad.</div></md-select><div ng-messages=\"vm.form.projetos.$error\"><div \nng-message=\"required\">Campo obrigatório</div></div></md-input-container><md-input-container class=\"md-block\" flex>\n<label>Clientes</label><md-select name=\"clientes\" md-on-open=\"vm.metodos.configuraMdSelectClientes()\" \nmultiple=\"multiple\" ng-model=\"vm.clientes\" ng-change=\"vm.metodos.selectChangeCliente(vm.clientes)\"><md-select-header \nng-if=\"vm.todosClientes.length > 0\"><input id=\"analise-custo-clientes-md-select\" class=\"md-text\" type=\"search\" \nplaceholder=\"Filtrar clientes\" ng-model=\"vm.filtrarClientes\"></md-select-header><md-option ng-value=\"cliente.codigo\" \nng-repeat=\"cliente in vm.todosClientes | filter:vm.filtrarClientes track by cliente.codigo\">{{cliente.nome}}\n</md-option></md-select></md-input-container><md-input-container class=\"md-block\" flex><label>Solução</label><md-select\n name=\"solucoes\" md-on-open=\"vm.metodos.configuraMdSelectSolucoes()\" multiple=\"multiple\" ng-model=\"vm.solucoes\">\n<md-select-header ng-if=\"vm.todasSolucoes.length > 0\"><input id=\"analise-custo-solucoes-md-select\" class=\"md-text\" \ntype=\"search\" placeholder=\"Filtrar soluções\" ng-model=\"vm.filtrarSolucoes\"></md-select-header><md-option \nng-value=\"solucao.codigo\" ng-repeat=\"solucao in vm.todasSolucoes | filter:vm.filtrarSolucoes track by solucao.codigo\">\n{{solucao.descricao}}</md-option><div style=\"color: rgba(0, 0, 0, 0.38); padding: 8px\" \nng-if=\"(vm.squadUsuarioLogado.length > 1 && (vm.squadCodigo || vm.squadCodigos.length)) && \r\n                                        (vm.todasSolucoes.length === 0) || \r\n                                        vm.filtrarSolucoes && \r\n                                        (vm.todasSolucoes | filter:vm.filtrarSolucoes).length === 0\">\nNenhuma solução encontrada.</div><div style=\"color: rgba(0, 0, 0, 0.38); padding: 8px\" \nng-if=\"!(vm.squadCodigo || vm.squadCodigos.length) && vm.squadUsuarioLogado.length > 1\">\nÉ necessário informar uma squad.</div></md-select></md-input-container><div class=\"container-botao\"><md-button \nclass=\"md-raised md-accent\" aria-label=\"Pesquisar\" ng-click=\"vm.metodos.pesquisar()\" \nng-disabled=\"(vm.form.$invalid && !vm.projetos.length > 0) || vm.emProgresso\"><span \ntranslate=\"CONSULTAS_ESTORIAS.PESQUISAR\"></span></md-button></div></div></div><div layout-gt-xs=\"row\" \nng-show=\"vm.todasHistoriasFiltradas.length > 0\"><div class=\"linha-legenda\" \nng-class=\"{\'selecionado\':vm.filtroLegenda == leg.cod}\" layout=\"row\" ng-repeat=\"leg in vm.legenda\" \nng-click=\"vm.metodos.filtraPorLegenda(leg)\"><div layout-gt-xs=\"column\">{{leg.titulo}}</div><div layout-gt-sm=\"column\" \nng-class=\"{\r\n                                        \'legenda erro\':leg.cod == 13,\r\n                                        \'legenda desenvolvimento\':leg.cod == 6,\r\n                                        \'legenda melhoria\':leg.cod == 12,\r\n                                        \'legenda em-pausa\':leg.cod == 14,\r\n                                        \'legenda homologada\':leg.cod == 9,\r\n                                        \'legenda em-teste\':leg.cod == 8,\r\n                                        \'legenda liberada\':leg.cod == 7}\">\n</div></div></div><div layout-gt-xs=\"row\" class=\"tabela\" flex><table class=\"dataTable row-border hover\" datatable=\"ng\" \ndt-options=\"vm.dtOptions\" style=\"width: 100%\"><thead><tr><th class=\"secondary-text pl8\"><div class=\"table-header\"><span\n class=\"column-title text-left\">História</span></div></th><th class=\"secondary-text pl8\"><div class=\"table-header\">\n<span class=\"column-title text-left\">Cliente</span></div></th><th class=\"secondary-text\"><div class=\"table-header\">\n<span class=\"column-title text-left\">Descrição</span></div></th><th class=\"secondary-text\"><div class=\"table-header\">\n<span class=\"column-title text-left\">Projeto</span></div></th><th class=\"secondary-text\"><div class=\"table-header\">\n<span class=\"column-title text-left\">Pontos</span></div></th></tr></thead><tbody ng-if=\"vm.historias.length > 0\"><tr \nng-repeat=\"item in vm.historias | filter:vm.pesquisar track by $index\"><td class=\"text-center pl8\" \nng-class=\"{erro:item.situacao == 13,\r\n                                                        melhoria:item.situacao == 12,\r\n                                                        homologada:(item.situacao == 9 || item.situacao == 15),\r\n                                                        pausa:item.situacao == 11,\r\n                                                        \'pausa-teste\':item.situacao == 14,\r\n                                                        \'liberada-para-teste\':item.situacao == 7,\r\n                                                        desenvolvimento:item.situacao == 6,\r\n                                                        \'em-teste\':item.situacao == 8}\">\n{{ item.numero }}/{{ item.ano }}</td><td><span>{{item.clienteCodigo}} - {{item.clienteNome}}</span></td><td>\n{{item.descricao}}</td><td>{{item.projeto}}</td><td>{{vm.metodos.retornaPonto(item.totalPontos)}}</td></tr></tbody>\n</table></div></div></div></md-content></form></div>");
$templateCache.put("app/main/gerenciamento-custo/processamento/analise-custo/views/analise-custo-tabela.html","<div layout=\"column\" flex><div class=\"md-padding md-background-bg md-whiteframe-1dp fullpage-datatable\" \nlayout=\"column\" flex><table class=\"dataTable row-border hover\" id=\"datatable-conclusao-atendimento\" width=\"100%\">\n<thead><tr><th>Ação</th><th>Descricao</th><th>Valor</th><th>Prazo</th></tr></thead></table></div></div>");
$templateCache.put("app/main/gerenciamento-custo/processamento/analise-custo/views/analise-custo.html","<div id=\"conclusao\" class=\"page-layout simple tabbed\" layout=\"column\"><header-padrao \ntranslate-nome=\"FATURAMENTO_SOFTWARE.ANALISE_CUSTO\" \nliberar-pesquisa-quando-datatable-ativo=\"vm.todasHistoriasFiltradas || vm.todasHistoriasFiltradas.length\" \npesquisar=\"vm.pesquisar\"></header-padrao><div class=\"content\"><div ui-view=\"analise-custo-form\"></div></div><div \nui-view=\"analise-custo-tabela\" ng-if=\"vm.controleForm.listarTodasEntidades\"></div></div>");
$templateCache.put("app/main/geral/cadastro/segmentacao/views/segmentacao-form.html","<div class=\"md-background-bg md-whiteframe-1dp\"><form name=\"vm.form\" novalidate><pg-toolbar \nentidades=\"vm.seguimentacoes\" entidade=\"vm.seguimentacao\" entidade-de-envio=\"vm.entidadeDeEnvio\" \ncontrolador-toolbar=\"vm.controleForm\" acao-pesquisar=\"vm.metodos.pesquisar()\" \nacao-criar=\"vm.metodos.salvar(vm.seguimentacao)\" acao-editar=\"vm.metodos.editar(vm.seguimentacao)\" \nacao-excluir=\"vm.metodos.excluir(vm.seguimentacao)\" construir-dt-options=\"vm.metodos.construirDtOptions()\" \nmetodos-externos=\"vm.metodosExternosPgToolbar\" campo-pesquisar=\"vm.pesquisar\"></pg-toolbar><md-content layout-padding \nng-hide=\"vm.controleForm.listarTodasEntidades\" ng-disabled=\"vm.controleForm.emProgresso\"><div class=\"form-container\">\n<div layout-gt-xs=\"row\"><div layout=\"row\"><md-input-container class=\"md-block\" flex-gt-sm><label \ntranslate=\"SEGMENTACAO.CODIGO\"></label><input type=\"text\" ng-model=\"vm.seguimentacao.codigo\" name=\"codigo\" \nmascara-numero-generica=\"#####\" ng-required=\"vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.inserirAtivo\"><div \nng-messages=\"vm.form.colaborador.codigo.$error\"><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container><proximo-codigo \nng-show=\"vm.controleForm.inserirAtivo\" rota=\"vm.rotaProximoCodigo\" entidade-codigo=\"vm.seguimentacao.codigo\" \npre-loader-toolbar=\"vm.controleForm.preLoaderToolbar\"></proximo-codigo></div><md-input-container class=\"md-block\" \nflex-offset-gt-sm=\"5\" flex><label translate=\"SEGMENTACAO.DESCRICAO\"></label><input type=\"text\" \nng-model=\"vm.seguimentacao.descricao\" name=\"descricao\" mascara-tamanho-campo=\"100\" \nng-required=\"vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo\" md-maxlength=\"100\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\"><div \nng-messages=\"vm.form.descricao.$error\"><div ng-message=\"required\" translate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\">\n</div></div></md-input-container></div></div></md-content></form></div>");
$templateCache.put("app/main/geral/cadastro/segmentacao/views/segmentacao.html","<div id=\"segmentacao\" class=\"page-layout simple tabbed\" layout=\"column\"><header-padrao \ntranslate-nome=\"SEGMENTACAO.SEGMENTACAO\" \nliberar-pesquisa-quando-datatable-ativo=\"vm.controleForm.listarTodasEntidades\" pesquisar=\"vm.pesquisar\">\n</header-padrao><div class=\"content\"><div ui-view=\"segmentacao-form\"></div></div><div ui-view=\"segmentacoes-tabela\" \nng-if=\"vm.controleForm.listarTodasEntidades\"></div></div>");
$templateCache.put("app/main/geral/cadastro/segmentacao/views/segmentacoes-tabela.html","<div layout=\"column\" flex><div class=\"md-padding md-background-bg md-whiteframe-1dp fullpage-datatable\" \nlayout=\"column\" flex><table class=\"dataTable row-border hover\" id=\"datatable-seguimentacao\" width=\"100%\"><thead><tr>\n<th>Ação</th><th>Código</th><th>Descrição</th></tr></thead></table></div></div>");
$templateCache.put("app/main/implantacao-migracao/cadastro/processo/views/processo-form.html","<div class=\"md-background-bg md-whiteframe-1dp\"><form name=\"processoForm\" novalidate><pg-toolbar \nentidades=\"vm.pipelineFunis\" entidade=\"vm.processo\" entidade-de-envio=\"vm.entidadeDeEnvio\" \ncontrolador-toolbar=\"vm.controleForm\" controlador-pre-loader=\"vm.controlePreloader\" \nacao-pesquisar=\"vm.metodos.pesquisar()\" acao-criar=\"vm.metodos.salvar(vm.processo)\" \nacao-editar=\"vm.metodos.editar(vm.processo)\" acao-excluir=\"vm.metodos.excluir(vm.processo)\" \nconstruir-dt-options=\"vm.metodos.construirDtOptions()\" metodos-externos=\"vm.metodosExternosPgToolbar\" \ncampo-pesquisar=\"vm.pesquisar\" pre-definir-campos-para-insercao=\"vm.metodosGeral.PreDefinirCamposParaInserir()\">\n</pg-toolbar><md-content layout-padding ng-hide=\"vm.controleForm.listarTodasEntidades\" \nng-disabled=\"vm.controleForm.emProgresso\"><div class=\"form-container\"><div layout-gt-xs=\"row\"><md-input-container \nclass=\"md-block\" flex-gt-sm=\"20\"><label translate=\"PROCESSO.CODIGO\"></label><input type=\"text\" \nng-model=\"vm.processo.codigo\" name=\"processoCodigo\" mascara-numero-generica=\"#####\" \nng-required=\"vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo\" \nng-disabled=\"vm.controleForm.pesquisaAtiva || vm.controleForm.inserirAtivo\"><div \nng-messages=\"processoForm.pipelinefunilCodigo.$error\"><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container><md-input-container class=\"md-block\" \nflex-gt-sm><label translate=\"PROCESSO.DESCRICAO\"></label><input type=\"text\" ng-model=\"vm.processo.descricao\" \nname=\"processoDescricao\" mascara-tamanho-campo=\"60\" \nng-required=\"vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo\" md-maxlength=\"60\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\"><div \nng-messages=\"processoForm.pipelinefunilDescricao.$error\"><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container></div><div layout-gt-xs=\"row\" flex>\n<md-input-container class=\"md-block\" flex><label translate=\"PROCESSO.TAREFAS\"></label><md-select \nng-model=\"vm.processo.tarefas\" name=\"tarefas\" multiple=\"multiple\" ng-model-options=\"{trackBy: \'$value.codigo\'}\" \nmd-on-open=\"vm.metodosGeral.configuraMdSelectEtapa()\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo \r\n                                                || vm.controleForm.emProgresso\">\n<md-select-header><input id=\"processo-tarefas-md-select\" class=\"md-text\" ng-model=\"vm.filtrarTarefas\" type=\"search\" \ntranslate translate-attr-placeholder=\"PROCESSO.PESQUISAR_TAREFA\"></md-select-header><md-option ng-value=\"tarefa\" \nng-if=\"tarefa.permiteAlteracao == 1\" \nng-repeat=\"tarefa in vm.tarefas | filter:vm.filtrarTarefas track by tarefa.codigo\"><span>\n{{tarefa.nivel}} - {{tarefa.descricao}}</span></md-option></md-select><div ng-messages=\"processoForm.tarefas.$error\">\n<div ng-message=\"required\" translate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container></div>\n</div></md-content></form></div>");
$templateCache.put("app/main/implantacao-migracao/cadastro/processo/views/processo-tabela.html","<div layout=\"column\" flex><div class=\"md-padding md-background-bg md-whiteframe-1dp fullpage-datatable\" \nlayout=\"column\" flex><table class=\"dataTable row-border hover\" id=\"datatable-processo\" width=\"100%\"><thead><tr><th>Ação\n</th><th>Código</th><th>Descrição</th></tr></thead></table></div></div>");
$templateCache.put("app/main/implantacao-migracao/cadastro/processo/views/processo.html","<div id=\"processo\" class=\"page-layout simple tabbed\" layout=\"column\"><header-padrao translate-nome=\"PROCESSO.PROCESSO\" \nicone=\"icon-filter\" liberar-pesquisa-quando-datatable-ativo=\"vm.controleForm.listarTodasEntidades\" \npesquisar=\"vm.pesquisar\"></header-padrao><div class=\"content\"><div ui-view=\"processo-form\"></div></div><div \nui-view=\"processo-tabela\" ng-if=\"vm.controleForm.listarTodasEntidades\"></div></div>");
$templateCache.put("app/main/gerenciamento-custo/cadastro/historico-custo/views/historico-custo-form.html","<div id=\"historico-custo\" class=\"md-background-bg md-whiteframe-1dp\"><form name=\"vm.form\" novalidate><pg-toolbar \nentidade=\"vm.historico\" entidades=\"vm.historicos\" entidade-de-envio=\"vm.entidadeDeEnvio\" \ncontrolador-toolbar=\"vm.controleForm\" acao-pesquisar=\"vm.metodos.pesquisar()\" \nacao-criar=\"vm.metodos.salvar(vm.historico)\" \npre-definir-campos-para-edicao=\"vm.metodos.predefinirCamposParaEdicao(vm.historico)\" \nacao-editar=\"vm.metodos.editar(vm.historico)\" acao-excluir=\"vm.metodos.excluir(vm.historico)\" \nconstruir-dt-options=\"vm.metodos.construirDtOptions()\" metodos-externos=\"vm.metodosExternosPgToolbar\" \ncampo-pesquisar=\"vm.pesquisar\"></pg-toolbar><md-content layout-padding ng-hide=\"vm.controleForm.listarTodasEntidades\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo\r\n                    && !vm.controleForm.inserirAtivo\">\n<div class=\"form-container\"><div layout-gt-xs=\"row\" flex=\"70\"><md-input-container class=\"md-block\" flex-gt-sm=\"30\" \nng-if=\"vm.squadUsuarioLogado.length > 1\"><label>Squad</label><md-select ng-model=\"vm.historico.squadCodigo\" \nname=\"squadCodigo\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo\r\n                        && !vm.controleForm.inserirAtivo\" \nng-required=\"vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo\"><md-option ng-value=\"squad.codigo\" \nng-repeat=\"squad in vm.squads track by squad.codigo\">{{squad.descricao}}</md-option></md-select><div \nng-messages=\"vm.form.squadCodigo.$error\"><div ng-message=\"required\">Campo obrigatório</div></div></md-input-container>\n<md-input-container class=\"md-block\" flex=\"30\"><label>Período inicial</label><md-datepicker name=\"periodoInicial\" \nmd-open-on-focus md-max-date=\"vm.historico.periodoFinal\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo\r\n                                        && !vm.controleForm.inserirAtivo\" \nng-required=\"vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo\" ng-model=\"vm.historico.periodoInicial\" \nng-mask=\"3?9/1?9/9999\"></md-datepicker><div ng-messages=\"vm.form.periodoInicial.$error\"><div ng-message=\"valid\" \ntranslate=\"MENSAGEM_VALIDACAO.DATA_INVALIDA\"></div><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\">Período inicial obrigatório</div><div ng-message=\"maxdate\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_DATA_INICIAL\"></div></div></md-input-container><md-input-container \nclass=\"md-block\" flex=\"30\"><label>Período final</label><md-datepicker name=\"periodoFinal\" md-open-on-focus \nmd-min-date=\"vm.historico.periodoInicial\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo\r\n                                        && !vm.controleForm.inserirAtivo\" \nng-required=\"vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo\" ng-model=\"vm.historico.periodoFinal\" \nng-mask=\"3?9/1?9/9999\"></md-datepicker><div ng-messages=\"vm.form.periodoFinal.$error\"><div ng-message=\"valid\" \ntranslate=\"MENSAGEM_VALIDACAO.DATA_INVALIDA\"></div><div ng-message=\"mindate\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_DATA_FINAL\"></div><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\">Período final obrigatório</div></div></md-input-container>\n<md-input-container class=\"campo-valor\" flex=\"20\"><label translate=\"FATURAMENTO_SOFTWARE.VALOR_PONTO\"></label><input \nname=\"valorPonto\" type=\"text\" flex mascara-tamanho-campo=\"12\" ui-money-mask \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo\r\n                                && !vm.controleForm.inserirAtivo\" \nng-model=\"vm.historico.valorPonto\" ng-required=\"true\"><div ng-messages=\"vm.form.valorPonto.$error\"><div \nng-message=\"required\" translate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container></div></div>\n</md-content></form></div>");
$templateCache.put("app/main/gerenciamento-custo/cadastro/historico-custo/views/historico-custo-tabela.html","<div layout=\"column\" flex><div class=\"md-padding md-background-bg md-whiteframe-1dp fullpage-datatable\" \nlayout=\"column\" flex><table class=\"dataTable row-border hover\" id=\"datatable-conclusao-atendimento\" width=\"100%\">\n<thead><tr><th>Ação</th><th>Squad</th><th>Valor Do Ponto</th><th>Período Inicial</th><th>Período Final</th></tr>\n</thead></table></div></div>");
$templateCache.put("app/main/gerenciamento-custo/cadastro/historico-custo/views/historico-custo.html","<div id=\"conclusao\" class=\"page-layout simple tabbed\" layout=\"column\"><header-padrao \ntranslate-nome=\"FATURAMENTO_SOFTWARE.HISTORICO_CUSTO\" \nliberar-pesquisa-quando-datatable-ativo=\"vm.controleForm.listarTodasEntidades\" pesquisar=\"vm.pesquisar\">\n</header-padrao><div class=\"content\"><div ui-view=\"custo_software_historico-form\"></div></div><div \nui-view=\"custo_software_historico-tabela\" ng-if=\"vm.controleForm.listarTodasEntidades\"></div></div>");
$templateCache.put("app/main/implantacao-migracao/processamento/processos-finalizados-cancelados/views/processos-finalizados-cancelados-form.html","<div id=\"processos-finalizados-cancelados-form\" \nclass=\"md-padding md-background-bg md-whiteframe-1dp fullpage-datatable\" ms-scroll flex><div layout=\"column\" \nlayout-align=\"center center\" class=\"mt-40\" ng-if=\"vm.requisicaoSolicitada\"><span \nclass=\"font-weight-500 font-size-tamanho-form-padrao\">{{vm.mensagemPreloader}}</span><md-progress-circular \nmd-mode=\"indeterminate\" md-diameter=\"30\" class=\"md-accent mt-15\"></md-progress-circular></div><table \nid=\"datatable-subprocessos-finalizados-cancelados\" class=\"datatable row-border hover\" datatable=\"ng\" \ndt-options=\"vm.dtOptionsSubprocessosFinalizadosCancelados\" width=\"100%\" \nng-if=\"!vm.requisicaoSolicitada && vm.listaSubprocessosFinalizadosCancelados != 0\"><thead><tr><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"coluna-acao column-title\">Ação</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Processo</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Tarefa</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Cliente</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Data inicial</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Data final</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Status</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Solução</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Atendimento</span></div></th></tr></thead>\n<tbody><tr ng-repeat=\"subprocesso in vm.listaSubprocessosFinalizadosCancelados\"><td class=\"button-icone-cor-azul\"><i \nclass=\"icon-undo-variant s24 icone-cor-padrao\" ng-click=\"vm.metodos.retornaSubprocessoParaStatusAnterior(subprocesso)\" \nng-disabled=\"vm.controleForm.emProgresso\"></i></td><td>\n{{vm.metodos.retornaDescricaoProcesso(subprocesso.codigoProcesso)}}</td><td>\n{{vm.metodos.retornaDescricaoTarefa(subprocesso.codigoProcesso, subprocesso.codigoTarefaAtual)}}</td><td>\n{{subprocesso.cliente.nome}}</td><td><span ng-hide=\"true\">{{subprocesso.dataInicial}} </span>\n{{subprocesso.dataInicial | date: \'dd/MM/yyyy\'}}</td><td><span ng-hide=\"true\">{{subprocesso.dataFinalTarefa}} </span>\n{{subprocesso.dataFinalTarefa | date: \'dd/MM/yyyy\'}}</td><td>{{subprocesso.status == 2 ? \'Finalizado\': \'Cancelado\'}}\n</td><td>{{subprocesso.solucao.descricao}}</td><td>{{subprocesso.codigoAtendimento}}/{{subprocesso.anoAtendimento}}\n</td></tr></tbody></table></div>");
$templateCache.put("app/main/implantacao-migracao/processamento/processos-finalizados-cancelados/views/processos-finalizados-cancelados.html","<div id=\"processos-finalizados-cancelados\" class=\"page-layout simple tabbed\" layout=\"column\"><header-padrao \ntranslate-nome=\"FINALIZADOS_CANCELADOS.TITULO\" icone=\"icon-clipboard-text\" \nliberar-pesquisa-quando-datatable-ativo=\"true\" pesquisar=\"vm.pesquisar\"></header-padrao><div class=\"content\"><div \nui-view=\"processos-finalizados-cancelados-form\"></div></div></div>");
$templateCache.put("app/main/locacao/cadastro/empresa-ativa/views/empresa-ativa-form.html","<div class=\"md-background-bg md-whiteframe-1dp\"><form name=\"vm.form\" novalidate><pg-toolbar \nentidades=\"vm.empresaAtivas\" entidade=\"vm.empresaAtiva\" entidade-de-envio=\"vm.entidadeDeEnvio\" \ncontrolador-toolbar=\"vm.controleForm\" acao-pesquisar=\"vm.metodos.pesquisar()\" \nacao-criar=\"vm.metodos.salvar(vm.empresaAtiva)\" acao-editar=\"vm.metodos.editar(vm.empresaAtiva)\" \nacao-excluir=\"vm.metodos.excluir(vm.empresaAtiva)\" construir-dt-options=\"vm.metodos.construirDtOptions()\" \nmetodos-externos=\"vm.metodosExternosPgToolbar\" campo-pesquisar=\"vm.pesquisar\"></pg-toolbar><md-content layout-padding \nng-hide=\"vm.controleForm.listarTodasEntidades\" ng-disabled=\"vm.controleForm.emProgresso\"><div class=\"form-container\">\n<md-autocomplete flex=\"85\" md-input-name=\"cliente\" md-no-cache=\"true\" \nng-required=\"vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo\" \nng-blur=\"vm.metodos.configuraAutoCompleteClienteOnBlur()\" md-selected-item=\"vm.empresaAtiva\" \nmd-selected-item-change=\"vm.metodos.alterarItemSelecionadoAutoCompleteCliente(item)\" \nmd-search-text=\"vm.textoDePesquisaAutoCompleteCliente\" \nmd-items=\"item in vm.metodos.pesquisarAutoCompleteCliente(vm.textoDePesquisaAutoCompleteCliente)\" \nmd-item-text=\"item.codigo + \' - \' + item.nome\" md-autoselect md-floating-label=\"Cliente\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\">\n<md-item-template><span md-highlight-text=\"vm.textoDePesquisaAutoCompleteCliente\">{{item.codigo}} - {{item.nome}}\n</span></md-item-template><md-not-found><label>Não foi encontrado nenhum Cliente.</label></md-not-found><div \nng-messages=\"vm.form.cliente.$error\"><div ng-message=\"required\" translate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div>\n</div></md-autocomplete></div></md-content></form></div>");
$templateCache.put("app/main/locacao/cadastro/empresa-ativa/views/empresa-ativa-tabela.html","<div layout=\"column\" flex><div class=\"md-padding md-background-bg md-whiteframe-1dp fullpage-datatable\" \nlayout=\"column\" flex><table class=\"dataTable row-border hover\" id=\"datatable-empresa-ativo\" width=\"100%\"><thead><tr>\n<th>Ação</th><th>Nome</th></tr></thead></table></div></div>");
$templateCache.put("app/main/locacao/cadastro/empresa-ativa/views/empresa-ativa.html","<div id=\"empresa-ativa\" class=\"page-layout simple tabbed\" layout=\"column\"><header-padrao \ntranslate-nome=\"Empresa ativo\" liberar-pesquisa-quando-datatable-ativo=\"vm.controleForm.listarTodasEntidades\" \npesquisar=\"vm.pesquisar\"></header-padrao><div class=\"content\"><div ui-view=\"empresa-ativa-form\"></div></div><div \nui-view=\"empresa-ativa-tabela\" ng-if=\"vm.controleForm.listarTodasEntidades\"></div></div>");
$templateCache.put("app/main/implantacao-migracao/processamento/processos-funis/views/processos-funis.html","<div id=\"processos-funis\" class=\"page-layout simple fullwidth\" layout=\"column\"><header-padrao \ntranslate-nome=\"Processos\" ng-utiliza-pesquisa=\"false\" icone=\"icon-sitemap\"></header-padrao><div \nclass=\"page-layout simple tabbed\" layout=\"column\"><div id=\"processos-funis\" layout=\"column\" flex><div \nid=\"board-selector\" layout=\"column\" layout-align=\"start center\" flex><div class=\"board-list\" layout=\"row\" \nlayout-align=\"center center\" layout-wrap><div class=\"board-list-item funil\" ng-repeat=\"processo in vm.funis\" \nui-sref=\"app.implantacaomigracao_processamento_processosfunis_processofunil({processoCodigo: processo.codigo, processoDescricao: vm.metodos.retornarRotaDescricao(processo.descricao)})\" \nlayout=\"column\" layout-align=\"center center\"><md-icon md-font-icon=\"icon-sitemap\" color=\"white\" class=\"icon s64\">\n</md-icon><span class=\"board-name\">{{vm.metodos.exibirDescricao(processo.descricao)}} </span><span class=\"board-name\">\nEm aberto: <span ng-if=\"processo.quantidadeSubProcessoAberto\">{{ processo.quantidadeSubProcessoAberto }}</span> <span \nng-if=\"!processo.quantidadeSubProcessoAberto\">0</span></span></div></div></div></div></div></div>");
$templateCache.put("app/main/implantacao-migracao/cadastro/atividade/views/atividade-form.html","<div class=\"md-background-bg md-whiteframe-1dp\"><form name=\"atividadeForm\" novalidate><pg-toolbar \nentidades=\"vm.pipelineFunis\" entidade=\"vm.atividade\" entidade-de-envio=\"vm.entidadeDeEnvio\" \ncontrolador-toolbar=\"vm.controleForm\" controlador-pre-loader=\"vm.controlePreloader\" \nacao-pesquisar=\"vm.metodos.pesquisar()\" acao-criar=\"vm.metodos.salvar(vm.atividade)\" \nacao-editar=\"vm.metodos.editar(vm.atividade)\" acao-excluir=\"vm.metodos.excluir(vm.atividade)\" \nconstruir-dt-options=\"vm.metodos.construirDtOptions()\" metodos-externos=\"vm.metodosExternosPgToolbar\" \ncampo-pesquisar=\"vm.pesquisar\" pre-definir-campos-para-insercao=\"vm.metodos.preDefinirCamposParaInserir()\" \ndesabilitar-botao-listar-todas-entidades=\"true\"></pg-toolbar><md-content layout-padding \nng-hide=\"vm.controleForm.listarTodasEntidades\" ng-disabled=\"vm.controleForm.emProgresso\"><div class=\"form-container\">\n<div layout-gt-xs=\"row\"><md-input-container class=\"md-block\" flex><label translate=\"ATIVIDADE.CODIGO\"></label><input \ntype=\"text\" aria-label=\"Código\" name=\"atividadeCodigo\" mascara-numero-generica=\"#####\" ng-model=\"vm.atividade.codigo\" \nng-required=\"vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo\" \nng-disabled=\"vm.controleForm.pesquisaAtiva || vm.controleForm.inserirAtivo\"><div \nng-messages=\"atividadeForm.atividadeCodigo.$error\"><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container><md-input-container class=\"md-block\" \nflex=\"75\"><label translate=\"ATIVIDADE.DESCRICAO\"></label><input type=\"text\" aria-label=\"Descrição\" \nname=\"atividadeDescricao\" mascara-tamanho-campo=\"60\" md-maxlength=\"60\" ng-model=\"vm.atividade.descricao\" \nng-required=\"vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo &&\r\n                                           !vm.controleForm.inserirAtivo\">\n<div ng-messages=\"atividadeForm.atividadeDescricao.$error\"><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container><md-input-container class=\"md-block\" \nflex><md-switch name=\"ativo\" aria-label=\"Ativo\" ng-model=\"vm.atividade.ativo\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo &&\r\n                                               !vm.controleForm.inserirAtivo\">\n<span ng-if=\"vm.atividade.ativo\" translate=\"ATIVIDADE.ATIVO\"></span> <span ng-if=\"!vm.atividade.ativo\" \ntranslate=\"ATIVIDADE.INATIVO\"></span></md-switch></md-input-container></div></div></md-content></form></div>");
$templateCache.put("app/main/implantacao-migracao/cadastro/atividade/views/atividade-tabela.html","<div layout=\"column\" flex><div class=\"md-padding md-background-bg md-whiteframe-1dp fullpage-datatable\" \nlayout=\"column\" flex><table class=\"dataTable row-border hover\" id=\"datatable-atividade\" width=\"100%\"><thead><tr><th>\nAção</th><th>Código</th><th>Descrição</th><th>Ativo</th></tr></thead></table></div></div>");
$templateCache.put("app/main/implantacao-migracao/cadastro/atividade/views/atividade.html","<div id=\"atividade\" class=\"page-layout simple tabbed\" layout=\"column\"><header-padrao \ntranslate-nome=\"ATIVIDADE.ATIVIDADE\" icone=\"icon-clipboard-text\" \nliberar-pesquisa-quando-datatable-ativo=\"vm.controleForm.listarTodasEntidades\" pesquisar=\"vm.pesquisar\">\n</header-padrao><div class=\"content\"><div ui-view=\"atividade-form\"></div></div><div ui-view=\"atividade-tabela\" \nng-if=\"vm.controleForm.listarTodasEntidades\"></div></div>");
$templateCache.put("app/main/implantacao-migracao/cadastro/tarefa/views/tarefa-form.html","<div class=\"md-background-bg md-whiteframe-1dp\"><form name=\"vm.form\" novalidate><pg-toolbar entidades=\"\" \nentidade=\"vm.tarefa\" entidade-de-envio=\"vm.entidadeDeEnvio\" controlador-toolbar=\"vm.controleForm\" \ncontrolador-pre-loader=\"vm.controlePreloader\" acao-pesquisar=\"vm.metodos.pesquisar()\" \nacao-criar=\"vm.metodos.salvar(vm.tarefa)\" acao-editar=\"vm.metodos.editar(vm.tarefa)\" \nacao-excluir=\"vm.metodos.excluir(vm.tarefa)\" construir-dt-options=\"vm.metodos.construirDtOptions()\" \nmetodos-externos=\"vm.metodosExternosPgToolbar\" campo-pesquisar=\"vm.pesquisar\" \ndesabilitar-botao-listar-todas-entidades=\"true\" \npre-definir-campos-para-insercao=\"vm.metodos.preDefinirCamposParaInserir()\" \npre-definir-campos-para-edicao=\"vm.metodos.predefinirCamposParaEdicao()\"></pg-toolbar><md-content layout-padding \nng-hide=\"vm.controleForm.listarTodasEntidades\" ng-disabled=\"vm.controleForm.emProgresso\"><div class=\"form-container\">\n<div layout-gt-xs=\"row\"><md-input-container class=\"md-block\" flex-gt-sm=\"10\"><label translate=\"TAREFA.CODIGO\"></label>\n<input type=\"text\" name=\"codigo\" mascara-numero-generica=\"#####\" ng-model=\"vm.tarefa.codigo\" \nng-required=\"vm.controleForm.inserirAtivo\" \nng-disabled=\"vm.controleForm.pesquisaAtiva || vm.controleForm.inserirAtivo || vm.controleForm.emProgresso\"><div \nng-messages=\"vm.form.codigo.$error\"><div ng-message=\"required\" translate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div>\n</div></md-input-container><md-input-container class=\"md-block campo-descricao\"><label translate=\"TAREFA.DESCRICAO\">\n</label><input type=\"text\" name=\"descricao\" mascara-tamanho-campo=\"60\" md-maxlength=\"60\" \nng-model=\"vm.tarefa.descricao\" ng-required=\"vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo &&\r\n                                           !vm.controleForm.inserirAtivo || vm.controleForm.emProgresso\">\n<div ng-messages=\"vm.form.descricao.$error\"><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container><md-input-container class=\"md-block\" \nflex><md-checkbox name=\"exigirFinalizacaoTarefa\" aria-label=\"Exigir finalizacao de tarefa\" \nng-model=\"vm.tarefa.exigirFinalizacaoTarefa\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo &&\r\n                                                 !vm.controleForm.inserirAtivo || vm.controleForm.emProgresso\">\n<span class=\"float-label-cor-default\" translate=\"TAREFA.EXIGIR_FINALIZACAO_TAREFA\"></span></md-checkbox>\n</md-input-container></div><div layout-gt-xs=\"row\" flex><md-input-container class=\"md-block\" flex=\"10\"><label \ntranslate=\"TAREFA.NIVEL\"></label><input type=\"text\" name=\"nivel\" mascara-tamanho-campo=\"1\" mascara-formatar-nome \nng-change=\"vm.tarefa.nivel = vm.tarefa.nivel.toUpperCase()\" ng-model=\"vm.tarefa.nivel\" \nng-required=\"vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.inserirAtivo || vm.controleForm.emProgresso\"><div \nng-messages=\"vm.form.nivel.$error\"><div ng-message=\"required\" translate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div>\n</div></md-input-container><md-input-container class=\"md-block campo-periodo\"><label translate=\"TAREFA.PERIODO\">\n</label><input type=\"text\" name=\"periodo\" ng-model=\"vm.tarefa.periodo\" \nng-required=\"vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo &&\r\n                                           !vm.controleForm.inserirAtivo || vm.controleForm.emProgresso\">\n<div ng-messages=\"vm.form.periodo.$error\"><div ng-message=\"required\" translate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\">\n</div></div></md-input-container><md-input-container class=\"md-block\" flex=\"50\"><label translate=\"TAREFA.ATIVIDADES\">\n</label><md-select name=\"atividadeCodigo\" multiple=\"multiple\" md-on-open=\"vm.metodos.configuraMdSelectAtividades()\" \nng-model=\"vm.tarefa.atividades\" ng-required=\"vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo &&\r\n                                               !vm.controleForm.inserirAtivo || vm.controleForm.emProgresso\">\n<md-select-header><input id=\"tarefa-atividades-md-select\" class=\"md-text\" type=\"search\" \nng-model=\"vm.filtrarAtividades\" translate translate-attr-placeholder=\"TAREFA.PESQUISAR_ATIVIDADES\"></md-select-header>\n<md-option ng-value=\"atividade.codigo\" \nng-repeat=\"atividade in vm.atividades | filter:vm.filtrarAtividades track by atividade.codigo\">\n{{ atividade.descricao }}</md-option></md-select><div ng-messages=\"vm.form.atividadeCodigo.$error\"><div \nng-message=\"required\" translate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container></div></div>\n</md-content></form></div>");
$templateCache.put("app/main/implantacao-migracao/cadastro/tarefa/views/tarefa-tabela.html","<div layout=\"column\" flex><div class=\"md-padding md-background-bg md-whiteframe-1dp fullpage-datatable\" \nlayout=\"column\" flex><table class=\"dataTable row-border hover\" id=\"datatable-tarefas\" width=\"100%\"><thead><tr><th>\nCódigo</th><th>Descrição</th><th>Nível</th><th>Período</th></tr></thead></table></div></div>");
$templateCache.put("app/main/implantacao-migracao/cadastro/tarefa/views/tarefa.html","<div id=\"tarefa\" class=\"page-layout simple tabbed\" layout=\"column\"><header-padrao translate-nome=\"TAREFA.TAREFA\" \nicone=\"icon-format-list-numbers\" liberar-pesquisa-quando-datatable-ativo=\"vm.controleForm.listarTodasEntidades\" \npesquisar=\"vm.pesquisar\"></header-padrao><div class=\"content\"><div ui-view=\"tarefa-form\"></div></div><div \nui-view=\"tarefa-tabela\" ng-if=\"vm.controleForm.listarTodasEntidades\"></div></div>");
$templateCache.put("app/main/locacao/cadastro/tipo-locacao/views/tipo-locacao-form.html","<div class=\"md-background-bg md-whiteframe-1dp\"><form name=\"vm.form\" novalidate><pg-toolbar entidades=\"vm.tipoLocaoes\" \nentidade=\"vm.tipoLocacao\" entidade-de-envio=\"vm.entidadeDeEnvio\" controlador-toolbar=\"vm.controleForm\" \nacao-pesquisar=\"vm.metodos.pesquisar()\" acao-criar=\"vm.metodos.salvar(vm.tipoLocacao)\" \nacao-editar=\"vm.metodos.editar(vm.tipoLocacao)\" acao-excluir=\"vm.metodos.excluir(vm.tipoLocacao)\" \nconstruir-dt-options=\"vm.metodos.construirDtOptions()\" metodos-externos=\"vm.metodosExternosPgToolbar\" \ncampo-pesquisar=\"vm.pesquisar\"></pg-toolbar><md-content layout-padding ng-hide=\"vm.controleForm.listarTodasEntidades\" \nng-disabled=\"vm.controleForm.emProgresso\"><div class=\"form-container\"><div layout-gt-xs=\"row\"><md-input-container \nclass=\"md-block\" flex><label translate=\"Descrição\"></label><input type=\"text\" ng-model=\"vm.tipoLocacao.descricao\" \nname=\"descricao\" mascara-tamanho-campo=\"100\" ng-required=\"vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo\" \nmd-maxlength=\"100\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\"><div \nng-messages=\"vm.form.descricao.$error\"><div ng-message=\"required\" translate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\">\n</div></div></md-input-container></div></div></md-content></form></div>");
$templateCache.put("app/main/locacao/cadastro/tipo-locacao/views/tipo-locacao-tabela.html","<div layout=\"column\" flex><div class=\"md-padding md-background-bg md-whiteframe-1dp fullpage-datatable\" \nlayout=\"column\" flex><table class=\"dataTable row-border hover\" id=\"datatable-locacao\" width=\"100%\"><thead><tr><th>Ação\n</th><th>Descrição</th></tr></thead></table></div></div>");
$templateCache.put("app/main/locacao/cadastro/tipo-locacao/views/tipo-locacao.html","<div id=\"tipo-locacao\" class=\"page-layout simple tabbed\" layout=\"column\"><header-padrao translate-nome=\"Tipo\" \nliberar-pesquisa-quando-datatable-ativo=\"vm.controleForm.listarTodasEntidades\" pesquisar=\"vm.pesquisar\">\n</header-padrao><div class=\"content\"><div ui-view=\"tipo-locacao-form\"></div></div><div ui-view=\"tipo-locacao-tabela\" \nng-if=\"vm.controleForm.listarTodasEntidades\"></div></div>");
$templateCache.put("app/main/locacao/cadastro/retorno-locacao/views/retorno-locacao-form.html","<div class=\"md-background-bg md-whiteframe-1dp\"><form name=\"vm.form\" novalidate><pg-toolbar \nentidades=\"vm.retornolocacoes\" entidade=\"vm.retornoLocacao\" entidade-de-envio=\"vm.entidadeDeEnvio\" \ncontrolador-toolbar=\"vm.controleForm\" acao-pesquisar=\"vm.metodos.pesquisar()\" \nacao-criar=\"vm.metodos.salvar(vm.retornoLocacao)\" acao-editar=\"vm.metodos.editar(vm.retornoLocacao)\" \nacao-excluir=\"vm.metodos.excluir(vm.retornoLocacao)\" construir-dt-options=\"vm.metodos.construirDtOptions()\" \nmetodos-externos=\"vm.metodosExternosPgToolbar\" campo-pesquisar=\"vm.pesquisar\"></pg-toolbar><md-content layout-padding \nng-hide=\"vm.controleForm.listarTodasEntidades\" ng-disabled=\"vm.controleForm.emProgresso\"><div class=\"form-container\">\n<div layout-gt-xs=\"row\"><md-input-container class=\"md-block\" flex><label translate=\"Descrição\"></label><input \ntype=\"text\" ng-model=\"vm.retornoLocacao.descricao\" name=\"descricao\" mascara-tamanho-campo=\"100\" \nng-required=\"vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo\" md-maxlength=\"100\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\"><div \nng-messages=\"vm.form.descricao.$error\"><div ng-message=\"required\" translate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\">\n</div></div></md-input-container></div></div></md-content></form></div>");
$templateCache.put("app/main/locacao/cadastro/retorno-locacao/views/retorno-locacao-tabela.html","<div layout=\"column\" flex><div class=\"md-padding md-background-bg md-whiteframe-1dp fullpage-datatable\" \nlayout=\"column\" flex><table class=\"dataTable row-border hover\" id=\"datatable-retorno-locacao\" width=\"100%\"><thead><tr>\n<th>Ação</th><th>Descrição</th></tr></thead></table></div></div>");
$templateCache.put("app/main/locacao/cadastro/retorno-locacao/views/retorno-locacao.html","<div id=\"retorno-locacao\" class=\"page-layout simple tabbed\" layout=\"column\"><header-padrao translate-nome=\"Retorno\" \nliberar-pesquisa-quando-datatable-ativo=\"vm.controleForm.listarTodasEntidades\" pesquisar=\"vm.pesquisar\">\n</header-padrao><div class=\"content\"><div ui-view=\"retorno-locacao-form\"></div></div><div \nui-view=\"retorno-locacao-tabela\" ng-if=\"vm.controleForm.listarTodasEntidades\"></div></div>");
$templateCache.put("app/main/locacao/consulta/controle-equipamento/views/controle-equipamento.html","<div id=\"controle-equipamento\" class=\"div-pai\" layout=\"column\" flex><form name=\"vm.form\"><div \nclass=\"page-layout simple tabbed\" layout=\"column\" style=\"position: relative\"><header-padrao \ntranslate-nome=\"Controle de equipamentos\" liberar-pesquisa-quando-datatable-ativo=\"false\" ng-utiliza-pesquisa=\"false\" \npesquisar=\"vm.pesquisar\"></header-padrao><div flex layout=\"row\" style=\"justify-content: center\" class=\"mt-10\">\n<md-input-container class=\"md-block empresa-ativo\" flex=\"35\"><label>Empresa ativo</label><md-select \nname=\"empresaAtivo\" ng-model=\"vm.empresaAtivoId\" ng-required=\"true\"><md-option ng-repeat=\"empresa in vm.empresaAtivo\" \nng-value=\"empresa.id\">{{empresa.codigo}} - {{empresa.nome}}</md-option></md-select><div \nng-messages=\"vm.form.empresaAtivo.$error\"><div ng-message=\"required\" translate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\">\n</div></div></md-input-container><md-button ng-click=\"vm.metodos.pesquisar(vm.empresaAtivoId)\" \nclass=\"send-button md-accent md-raised botaoPesquisar\" aria-label=\"Pesquisar\" translate=\"Pesquisar\" \nng-disabled=\"vm.form.$invalid || vm.form.$pristine || vm.pesquisando\"></md-button></div><div layout=\"row\" \nng-show=\"vm.pesquisando\" layout-align=\"center center\" flex><div layout=\"column\" layout-align=\"center center\" \nclass=\"mt-100\"><span class=\"font-weight-500\" style=\"font-size: 16px\">{{vm.mensagemPreloader}}</span>\n<md-progress-circular md-mode=\"indeterminate\" md-diameter=\"100\" class=\"md-accent\"></md-progress-circular></div></div>\n<div ng-if=\"!vm.pesquisando\"><div layout=\"column\" layout-align=\"center center\" ng-if=\"vm.equipamentos.length > 0\" \nclass=\"div-total\"><div class=\"white-fg ng-binding tamanho-totalizador\"><span style=\"font-size: 1.5em\">\nTotal : {{vm.metodos.calcularTotalizadorGeral()}}</span></div></div></div><div ng-if=\"vm.mostrarFildSet\" \nclass=\"fildset-div\" style=\"margin: 0 auto; position: relative\"><fieldset class=\"standard\" flex \nstyle=\"max-width: 980px\"><legend class=\"grp-legend\" translate=\"Por tipo de equipamento\"></legend><div \nclass=\"container-equipamento\"><div class=\"track-equipamento\"><md-card ng-repeat=\"equipamento in vm.equipamentos\" \nclass=\"item\"><md-card-header class=\"header-botao\"><div layout=\"row\" layout-align=\"center center\" class=\"header-titulo\" \nflex><strong><span class=\"font-size-20 textos-span\" style=\"text-align: center\">{{equipamento[0].equipamentoDescricao}}\n</span></strong><md-button class=\"md-icon-button botao-flutuante\" \nng-click=\"vm.metodos.listarPorEstadoConservacaoEEmpresaAtivoId(equipamento)\" ng-disabled=\"vm.emProgresso\"><i \nclass=\"icon-book-multiple s24\" ng-class=\"{ \'icone-cor-padrao\': !vm.emProgresso }\"></i><md-tooltip><span>\nDetalhes por tipo de equipamento</span></md-tooltip></md-button></div><hr class=\"solid\"><md-card-header-text \nlayout=\"row\" class=\"card-cabecalho\" ng-repeat=\"item in equipamento\"><div layout=\"row\" style=\"display: flex\"><div \nstyle=\"width: 80px\"><span class=\"font-size-18 textos-span\" style=\"margin-right: 20px\">{{item.estadoConsDescricao}}:\n</span></div><div style=\"text-align: right; width: 118px\" class=\"quantidades\"><span class=\"font-size-18 textos-span\">\n{{item.quantidade}}</span></div></div></md-card-header-text><hr class=\"solid\"></md-card-header><md-card-title>\n<md-card-title-text><div ayout=\"row\" style=\"display: flex; position: absolute; bottom: 15px\"><div style=\"width: 80px\">\n<span class=\"font-size-18 textos-span\" style=\"margin-right: 20px\">Total:</span></div><div \nstyle=\"text-align: right; width: 118px\" class=\"quantidades\"><span class=\"font-size-18 textos-span\">\n{{vm.metodos.retornarQuantidadeItemEquipamento(equipamento)}}</span></div></div></md-card-title-text></md-card-title>\n</md-card></div></div><div class=\"btn-container-equipamento\"><md-button \nclass=\"add-event-button md-fab md-toolbar btn-prev1\" style=\"width: 35px; height: 35px\" aria-label=\"Consultar\"><md-icon \nmd-font-icon=\"icon-arrow-left\"></md-icon><md-tooltip><label>Anterior</label></md-tooltip></md-button><md-button \nclass=\"add-event-button md-fab md-toolbar btn-next1\" style=\"width: 35px; height: 35px\" \naria-label=\"Consultar-conservacao\"><md-icon md-font-icon=\"icon-arrow-right\"></md-icon><md-tooltip><label>Próximo\n</label></md-tooltip></md-button></div></fieldset><div ng-if=\"vm.mostrarFildSet\" class=\"fildset-div\" \nstyle=\"margin: 0 auto; position: relative\"><fieldset class=\"standard\" flex style=\"max-width: 980px\"><div \nclass=\"legendas\"><div><md-icon class=\"icone-legenda incluso-somatorio\" md-font-icon=\"icon-label\"></md-icon><span \nclass=\"legend-title ml-5 mr-5\">Equipamentos considerados no somatório</span></div><div><md-icon \nclass=\"icone-legenda nao-incluso-somatorio\" md-font-icon=\"icon-label\"></md-icon><span class=\"legend-title ml-5 mr-5\">\nEquipamentos não considerados no somatório</span></div></div><legend class=\"grp-legend\" translate=\"Por situação\">\n</legend><div class=\"container-situacao\"><div class=\"track-situacao\"><md-card \nng-repeat=\"situacao in vm.equipamentoSituacao\" class=\"item\"><md-card-header class=\"header-botao\"><div layout=\"row\" \nlayout-align=\"center center\" class=\"header-titulo\" flex><strong><span class=\"font-size-20 textos-span\" \nng-class=\"{ \'incluso-somatorio\': (situacao[0].equipamentoSituacaoCodigo != 3 && situacao[0].equipamentoSituacaoCodigo != 7 && situacao[0].equipamentoSituacaoCodigo != 9), \r\n                                                                \'nao-incluso-somatorio\': (situacao[0].equipamentoSituacaoCodigo == 3 || situacao[0].equipamentoSituacaoCodigo == 7 || situacao[0].equipamentoSituacaoCodigo == 9) }\" \nstyle=\"text-align: center\">{{situacao[0].equipamentoSituacaoDescricao}}</span></strong><md-button \nclass=\"md-icon-button botao-flutuante\" \nng-click=\"vm.metodos.pesquisarPorSituacaoFabricante(vm.empresaAtivoId, situacao[0].equipamentoSituacaoCodigo, situacao[0].equipamentoSituacaoDescricao)\" \nng-disabled=\"vm.emProgresso\"><i class=\"icon-book-multiple s24\" ng-class=\"{ \'icone-cor-padrao\': !vm.emProgresso }\"></i>\n<md-tooltip><span>Detalhes por fabricante</span></md-tooltip></md-button></div><hr class=\"solid\"><md-card-header-text \nlayout=\"row\" class=\"card-cabecalho\" ng-repeat=\"item in situacao\"><div layout=\"row\" style=\"display: flex\"><div \nstyle=\"width: 80px\"><span class=\"font-size-18 textos-span\" style=\"margin-right: 20px\">{{item.equipamentoDescricao}}:\n</span></div><div style=\"text-align: right; width: 118px\" class=\"quantidades\"><span class=\"font-size-18 textos-span\">\n{{item.quantidade}}</span></div></div></md-card-header-text><hr class=\"solid\"></md-card-header><md-card-title>\n<md-card-title-text><div ayout=\"row\" style=\"display: flex; position: absolute; bottom: 15px\"><div style=\"width: 80px\">\n<span class=\"font-size-18 textos-span\" style=\"margin-right: 20px\">Total:</span></div><div \nstyle=\"text-align: right; width: 118px\" class=\"quantidades\"><span class=\"font-size-18 textos-span\">\n{{vm.metodos.retornarQuantidadeItemEquipamentoSituacao(situacao)}}</span></div></div></md-card-title-text>\n</md-card-title></md-card></div></div><div class=\"btn-container\"><md-button \nclass=\"add-event-button md-fab md-toolbar btn-prev\" style=\"width: 35px; height: 35px\" aria-label=\"Consultar\"><md-icon \nmd-font-icon=\"icon-arrow-left\"></md-icon><md-tooltip><label>Anterior</label></md-tooltip></md-button><md-button \nclass=\"add-event-button md-fab md-toolbar btn-next\" style=\"width: 35px; height: 35px\" aria-label=\"Consultar\" \nng-click=\"vm.metodos.testeClick()\"><md-icon md-font-icon=\"icon-arrow-right\"></md-icon><md-tooltip><label>Próximo\n</label></md-tooltip></md-button><md-button class=\"add-event-button md-fab md-toolbar btn-dialog\" \nng-click=\"vm.metodos.dialogSituacao()\" style=\"width: 35px; height: 35px\"><md-icon \nmd-font-icon=\"icon-information-outline\"></md-icon><md-tooltip><label>Detalhes por situação</label></md-tooltip>\n</md-button></div></fieldset></div></div></div></form></div>");
$templateCache.put("app/main/locacao/consulta/contratos-a-encerrar/views/contratos-a-encerrar.html","<div id=\"controle-retorno\" class=\"page-layout simple tabbed\" layout=\"column\"><header-padrao \ntranslate-nome=\"Contratos a encerrar\" liberar-pesquisa-quando-datatable-ativo=\"false\" ng-utiliza-pesquisa=\"false\">\n</header-padrao><form name=\"vm.form\" novalidate><div layout=\"column\" layout-align=\"start center\"><fieldset \nclass=\"standard fieldset-container\" style=\"position: relative\"><legend class=\"grp-legend\" \ntranslate=\"Pesquisar contratos por data\"></legend><div layout-gt-sm=\"row\" layout-xs=\"column\"><div layout=\"column\" \nlayout-padding flex-gt-sm=\"30\" ng-hide=\"vm.filtroAtivo\"><div layout=\"row\" style=\"justify-content: space-between\"><div \nlayout=\"column\"><md-radio-group ng-model=\"vm.tipoPesquisa\" layout-gt-sm=\"column\" layout-xs=\"row\" layout-padding>\n<md-radio-button value=\"1\" aria-label=\"Período\"><label translate=\"Vigência máxima\"></label></md-radio-button>\n<md-radio-button value=\"2\" aria-label=\"Status\"><label translate=\"Encerramento contrato atual\"></label>\n</md-radio-button></md-radio-group></div></div></div><md-divider></md-divider><div layout=\"column\" layout-padding flex \nng-hide=\"vm.filtroAtivo\" style=\"justify-content: center; position: relative\"><div layout=\"row\" class=\"div-dados\"><div \nflex=\"30\" class=\"div-datas-responsiva\"><md-input-container class=\"md-block\"><label>Data Inicial</label><md-datepicker \nng-model=\"vm.filtro.dataInicial\" name=\"dataInicial\" ng-mask=\"3?9/1?9/9999\" ng-required=\"true\" \nmd-max-date=\"vm.filtro.dataFinal\" md-open-on-focus></md-datepicker><div ng-messages=\"vm.form.dataInicial.$error\"><div \nng-message=\"valid\" translate=\"MENSAGEM_VALIDACAO.DATA_INVALIDA\"></div><div ng-message=\"maxdate\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_DATA_FINAL\"></div><div ng-message=\"required\" \ntranslate=\"RELATORIO_CLIENTE.DATA_INICIAL_OBRIGATORIA\"></div></div></md-input-container></div><div flex=\"30\" \nclass=\"div-datas-responsiva\"><md-input-container class=\"md-block\"><label>Data Final</label><md-datepicker \nng-model=\"vm.filtro.dataFinal\" name=\"dataFinal\" ng-mask=\"3?9/1?9/9999\" ng-required=\"true\" \nmd-min-date=\"vm.filtro.dataInicial\" md-open-on-focus></md-datepicker><div ng-messages=\"vm.form.dataFinal.$error\"><div \nng-message=\"valid\" translate=\"MENSAGEM_VALIDACAO.DATA_INVALIDA\"></div><div ng-message=\"mindate\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_DATA_FINAL\"></div><div ng-message=\"required\" \ntranslate=\"RELATORIO_CLIENTE.DATA_FINAL_OBRIGATORIA\"></div></div></md-input-container></div><md-input-container \nclass=\"empresa-ativo\" flex=\"40\"><label>Empresa ativo</label><md-select name=\"empresaAtivo\" \nng-model=\"vm.empresaAtivoId\" ng-required=\"true\"><md-option ng-repeat=\"empresa in vm.empresaAtivo\" \nng-value=\"empresa.id\">{{empresa.codigo}} - {{empresa.nome}}</md-option></md-select><div \nng-messages=\"vm.form.empresaAtivo.$error\"><div ng-message=\"required\" translate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\">\n</div></div></md-input-container></div><div class=\"btn-pesquisar\" layout=\"row\" flex style=\"position: absolute\">\n<md-button id=\"botaoPesquisarLocacoes\" class=\"md-raised md-accent btn-pesquisa\" ng-click=\"vm.metodos.pesquisarDados()\" \nng-disabled=\"vm.pesquisando || vm.form.$invalid\">Pesquisar</md-button></div></div></div></fieldset></div></form><div \nlayout=\"row\" ng-show=\"vm.pesquisando\" layout-align=\"center center\" flex><div layout=\"column\" \nlayout-align=\"center center\" class=\"mt-100\"><span class=\"font-weight-500\" style=\"font-size: 16px\">\n{{vm.mensagemPreloader}}</span><md-progress-circular md-mode=\"indeterminate\" md-diameter=\"100\" class=\"md-accent\">\n</md-progress-circular></div></div><div class=\"container-totalizador\" layout-gt-sm=\"row\" layout-sm=\"column\" \nlayout-align-gt-sm=\"space-around start\" flex ng-if=\"vm.dados && !vm.pesquisando\"><div \nclass=\"white-fg ng-binding tamanho-totalizador\"><span style=\"font-size: 1.5em\">\nTotal equipamentos : {{ vm.totalEquipamentos }}</span></div></div><div class=\"container-equipamento\" \nng-if=\"vm.dados && !vm.pesquisando\"><div class=\"track-equipamento\"><md-card ng-repeat=\"dado in vm.dados\" \nclass=\"itemEquipamento\" flex=\"20\"><md-card-header style=\"display: block\"><div class=\"titulo-card\"><strong \nlayout=\"column\"><span class=\"font-size-14 textos-span\" style=\"text-align: center\">{{ dado.cabecalho.clienteNome }}\n</span> <span class=\"font-size-14 textos-span\" style=\"text-align: center\">{{ dado.cabecalho.tipoContrato }}</span> \n<span class=\"font-size-14 textos-span\" style=\"text-align: center\">{{ dado.cabecalho.produto}}</span></strong></div><hr \nclass=\"solid\"><div><strong class=\"encerramento\"><span class=\"font-size-14 textos-span\" style=\"text-align: left\">Início:\n</span> <span class=\"font-size-14 textos-span\" style=\"text-align: left\">\n{{ dado.cabecalho.dataInicioContratoAtual | date:\'dd/MM/yyyy\' }}</span></strong></div><div><strong \nclass=\"encerramento\"><span class=\"font-size-14 textos-span\" style=\"text-align: left\">Encerramento:</span> <span \nclass=\"font-size-14 textos-span\" style=\"text-align: left\">{{ dado.cabecalho.dataEncerramento | date:\'dd/MM/yyyy\' }}\n</span></strong></div><div><strong class=\"encerramento\"><span class=\"font-size-14 textos-span\" \nstyle=\"text-align: left\">Máxima:</span> <span class=\"font-size-14 textos-span\" style=\"text-align: left\">\n{{ dado.cabecalho.dataMaximaContrato | date:\'dd/MM/yyyy\' }}</span></strong></div><md-card-header-text \nng-repeat=\"equipamento in dado.equipamentos\" layout=\"row\" class=\"card-cabecalho\"><div><span \nclass=\"font-size-14 textos-span\">{{ equipamento.descricao }}:</span></div><div style=\"text-align: right\" \nclass=\"quantidades\"><span class=\"font-size-14 textos-span\">{{ equipamento.quantidade }}</span></div>\n</md-card-header-text><hr class=\"solid\"></md-card-header><md-card-title layout=\"row\" layout-align=\"start end\">\n<md-card-title-text><div layout=\"row\" class=\"card-totalizador\"><div><span class=\"font-size-18 textos-span\">Total:\n</span></div><div style=\"text-align: right\" class=\"quantidades textos-span\"><span class=\"font-size-18\">\n{{ dado.totalEquipamentos }}</span></div></div></md-card-title-text></md-card-title></md-card></div></div></div>");
$templateCache.put("app/main/locacao/consulta/locacao/views/locacao-form.html","");
$templateCache.put("app/main/locacao/consulta/locacao/views/locacao-table.html","");
$templateCache.put("app/main/locacao/consulta/locacao/views/locacao.html","<div id=\"locacao-detalhe\" class=\"page-layout simple tabbed\" layout=\"column\"><header-padrao translate-nome=\"Locação\" \nliberar-pesquisa-quando-datatable-ativo=\"false\" ng-utiliza-pesquisa=\"false\" pesquisar=\"vm.pesquisar\"></header-padrao>\n<fieldset class=\"standard\" layout=\"row\"><legend class=\"grp-legend\" translate=\"Pesquisar por\"></legend><div flex=\"80\" \nlayout=\"column\"><div flex=\"100\" layout=\"row\" layout-align=\"start center\"><md-input-container flex=\"40\"><md-radio-group \nng-model=\"vm.filtro.tipoPesquisa\" style=\"margin-bottom: 10px\" layout=\"row\"><md-radio-button value=\"1\">Envio\n</md-radio-button><md-radio-button value=\"2\">Retorno</md-radio-button><md-radio-button value=\"3\">Envio sem retorno\n</md-radio-button></md-radio-group></md-input-container><md-input-container flex><label>Data inicial</label>\n<md-datepicker ng-model=\"vm.filtro.dataInicial\" name=\"envioData\" ng-mask=\"3?9/1?9/9999\" ng-required=\"true\" \nmd-max-date=\"\"></md-datepicker></md-input-container><md-input-container flex><label>Data final</label><md-datepicker \nng-model=\"vm.filtro.dataFinal\" name=\"envioData\" ng-mask=\"3?9/1?9/9999\" ng-required=\"true\" md-max-date=\"\">\n</md-datepicker></md-input-container></div><div flex=\"100\" layout=\"row\" layout-align=\"space-between center\">\n<md-input-container flex=\"30\"><ms-selecinar-multi-valores tem-field-set=\"false\" dados=\"vm.clientesImanager\" \nname-placeholder=\"Clientes\" mensagem-de-erro-do-formulario=\"RELATORIO_REAJUSTE.STATUS_OBRIGATORIO\" \npropriedade-para-a-exibicao-da-repeticao=\"nome\" limitar-width=\"true\" model-dados=\"vm.filtro.clientesSelecionados\" \nobrigatorio=\"true\"></ms-selecinar-multi-valores></md-input-container><md-input-container flex=\"30\">\n<ms-selecinar-multi-valores tem-field-set=\"false\" dados=\"vm.equipamentos\" name-placeholder=\"Equipamentos\" \nmensagem-de-erro-do-formulario=\"RELATORIO_REAJUSTE.STATUS_OBRIGATORIO\" \npropriedade-para-a-exibicao-da-repeticao=\"descricao\" limitar-width=\"true\" model-dados=\"vm.filtro.equipamentos\" \nobrigatorio=\"true\"></ms-selecinar-multi-valores></md-input-container><md-input-container flex=\"30\">\n<ms-selecinar-multi-valores tem-field-set=\"false\" dados=\"vm.tiposLocacao\" name-placeholder=\"Tipos de locação\" \nmensagem-de-erro-do-formulario=\"RELATORIO_REAJUSTE.STATUS_OBRIGATORIO\" \npropriedade-para-a-exibicao-da-repeticao=\"descricao\" limitar-width=\"true\" model-dados=\"vm.filtro.tipoLocacao\" \nobrigatorio=\"true\"></ms-selecinar-multi-valores></md-input-container></div></div><div flex=\"20\" layout=\"row\" \nlayout-align=\"center center\"><md-button id=\"botaoPesquisarLocacoes\" class=\"md-raised md-accent btn-pesquisa\" \nng-click=\"vm.metodos.listarClientes($event, vm.filtro)\" \nng-disabled=\"vm.requisicaoProgress || vm.filtro.tipoPesquisa == undefined || vm.filtro.dataInicial == undefined || vm.filtro.dataFinal == undefined\">\nPesquisar</md-button></div></fieldset><div class=\"divtituloEnvioRetorno\" layout=\"row\" \nng-if=\"vm.clientesFiltrados != null\"><md-card flex class=\"blue-bg white-fg\" ng-if=\"vm.mostraTitulo != false\">\n<md-card-title class=\"tituloCardEnvioRetorno\"><md-card-title-text><span class=\"blue-bg white-fg texto-card-filtro\">\n{{vm.envioOuRetorno}}</span></md-card-title-text></md-card-title></md-card><md-card flex class=\"blue-bg white-fg\" \nng-if=\"vm.mostraTitulo != false\"><md-card-title class=\"tituloCardEnvioRetorno\"><md-card-title-text><span \nclass=\"blue-bg white-fg texto-card-filtro\">Total: {{vm.totais}}</span></md-card-title-text></md-card-title></md-card>\n</div><div layout=\"row\" ng-show=\"vm.requisicaoProgress\" layout-align=\"center center\" flex><div layout=\"column\" \nlayout-align=\"center center\" class=\"mt-100\"><span class=\"font-weight-500\" style=\"font-size: 16px\">\n{{vm.mensagemPreloader}}</span><md-progress-circular md-mode=\"indeterminate\" md-diameter=\"100\" class=\"md-accent\">\n</md-progress-circular></div></div><div layout=\"row\" class=\"divPaiCards\"><div id=\"locacao-retorno\" class=\"cards\" flex \nflex-gt-sm=\"25\" ng-if=\"vm.clientesFiltrados != null\" ng-repeat=\"item in vm.clientesFiltrados | orderBy:\'id\' :true\">\n<md-card flex layout=\" column\" style=\"height: 100%\"><md-card-title-text class=\"md-card-title\" layout=\"column\" \nlayout-align=\"center center\"><span class=\"md-headline\" style=\"font-size: 13px\">{{item.clienteNome}}</span> <span \nclass=\"md-headline\" style=\"font-size: 13px\">{{item.envios[0].tipoContrato}} - {{item.envios[0].produto}}</span>\n</md-card-title-text><div style=\"height: 61.5vh; overflow: scroll\"><md-content><md-list flex><md-list-item \nclass=\"md-3-line espacamento p-8\" ng-repeat=\"envio in item.envios\" ng-class=\"{\'zebra\' : $index %2 == 0}\"><div \nclass=\"md-list-item-text\" layout=\"column\"><h4><strong>Tipo de locação: </strong>{{envio.tipoLocacaoDescricao}}</h4><h4 \nng-if=\"vm.textoCardEnvio\"><strong>Último envio: </strong>{{envio.dataUltimoEnvio | date:\'dd/MM/yyyy\'}}</h4><h4 \nng-if=\"!vm.textoCardEnvio\"><strong>Último retorno: </strong>{{envio.dataUltimoRetorno | date:\'dd/MM/yyyy\'}}</h4><h4>\n<strong>Equipamento: </strong>{{envio.equipamentoDescricao}}</h4><h4><strong>Qtd. Equipamentos: </strong>\n{{envio.quantidadeEquipamentos}}</h4></div></md-list-item></md-list></md-content></div></md-card></div></div></div>");
$templateCache.put("app/main/locacao/cadastro/objetivo-nota/views/objetivo-nota-form.html","<div class=\"md-background-bg md-whiteframe-1dp\"><form name=\"vm.form\" novalidate><pg-toolbar \nentidades=\"vm.objetivoNotas\" entidade=\"vm.objetivoNota\" entidade-de-envio=\"vm.entidadeDeEnvio\" \ncontrolador-toolbar=\"vm.controleForm\" acao-pesquisar=\"vm.metodos.pesquisar()\" \nacao-criar=\"vm.metodos.salvar(vm.objetivoNota)\" acao-editar=\"vm.metodos.editar(vm.objetivoNota)\" \nacao-excluir=\"vm.metodos.excluir(vm.objetivoNota)\" construir-dt-options=\"vm.metodos.construirDtOptions()\" \nmetodos-externos=\"vm.metodosExternosPgToolbar\" campo-pesquisar=\"vm.pesquisar\"></pg-toolbar><md-content layout-padding \nng-hide=\"vm.controleForm.listarTodasEntidades\" ng-disabled=\"vm.controleForm.emProgresso\"><div class=\"form-container\">\n<div layout-gt-xs=\"row\"><md-input-container class=\"md-block\" flex><label translate=\"Descrição\"></label><input \ntype=\"text\" ng-model=\"vm.objetivoNota.descricao\" name=\"descricao\" mascara-tamanho-campo=\"100\" \nng-required=\"vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo\" md-maxlength=\"100\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\"><div \nng-messages=\"vm.form.descricao.$error\"><div ng-message=\"required\" translate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\">\n</div></div></md-input-container></div></div></md-content></form></div>");
$templateCache.put("app/main/locacao/cadastro/objetivo-nota/views/objetivo-nota-tabela.html","<div layout=\"column\" flex><div class=\"md-padding md-background-bg md-whiteframe-1dp fullpage-datatable\" \nlayout=\"column\" flex><table class=\"dataTable row-border hover\" id=\"datatable-objetivo\" width=\"100%\"><thead><tr><th>Ação\n</th><th>Descrição</th></tr></thead></table></div></div>");
$templateCache.put("app/main/locacao/cadastro/objetivo-nota/views/objetivo-nota.html","<div id=\"objetivo-nota\" class=\"page-layout simple tabbed\" layout=\"column\"><header-padrao \ntranslate-nome=\"Objetivo nota\" liberar-pesquisa-quando-datatable-ativo=\"vm.controleForm.listarTodasEntidades\" \npesquisar=\"vm.pesquisar\"></header-padrao><div class=\"content\"><div ui-view=\"objetivo-nota-form\"></div></div><div \nui-view=\"objetivo-nota-tabela\" ng-if=\"vm.controleForm.listarTodasEntidades\"></div></div>");
$templateCache.put("app/main/pipeline/cadastro/pipeline-etapa/views/pipeline-etapa-form.html","<div class=\"md-background-bg md-whiteframe-1dp\"><form name=\"vm.form\" novalidate><pg-toolbar \nentidades=\"vm.pipelineEtapas\" entidade=\"vm.pipelineEtapa\" entidade-de-envio=\"vm.entidadeDeEnvio\" \ncontrolador-toolbar=\"vm.controleForm\" controlador-pre-loader=\"vm.controlePreloader\" \nacao-pesquisar=\"vm.metodos.pesquisar()\" acao-criar=\"vm.metodos.salvar(vm.pipelineEtapa)\" \nacao-editar=\"vm.metodos.editar(vm.pipelineEtapa)\" acao-excluir=\"vm.metodos.excluir(vm.pipelineEtapa)\" \nconstruir-dt-options=\"vm.metodos.construirDtOptions()\" metodos-externos=\"vm.metodosExternosPgToolbar\" \ncampo-pesquisar=\"vm.pesquisar\" pre-definir-campos-para-insercao=\"vm.metodosGeral.preDefinirCamposParaInserir()\">\n</pg-toolbar><md-content layout-padding ng-hide=\"vm.controleForm.listarTodasEntidades\" \nng-disabled=\"vm.controleForm.emProgresso\"><div class=\"form-container\"><div layout-gt-xs=\"row\"><md-input-container \nclass=\"md-block\" flex-gt-sm=\"20\"><label translate=\"PIPELINE_ETAPA.CODIGO\"></label><input type=\"text\" \nng-model=\"vm.pipelineEtapa.codigo\" name=\"codigo\" mascara-numero-generica=\"#####\" \nng-required=\"vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.inserirAtivo\r\n                                            || vm.controleForm.emProgresso\">\n<div ng-messages=\"vm.form.codigo.$error\"><div ng-message=\"required\" translate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\">\n</div></div></md-input-container><md-input-container class=\"md-block\" flex-offset-gt-sm=\"5\" flex-gt-sm=\"75\"><label \ntranslate=\"PIPELINE_ETAPA.DESCRICAO\"></label><input type=\"text\" ng-model=\"vm.pipelineEtapa.descricao\" name=\"descricao\" \nmascara-tamanho-campo=\"50\" ng-required=\"vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo\" md-maxlength=\"50\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\r\n                                            || vm.controleForm.emProgresso\">\n<div ng-messages=\"vm.form.descricao.$error\"><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container><md-input-container class=\"md-block\" \nflex-gt-sm><md-switch ng-model=\"vm.pipelineEtapa.ativo\" aria-label=\"Ativo\" name=\"ativo\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\"><span \ntranslate=\"PIPELINE_ETAPA.ATIVO\"></span></md-switch></md-input-container></div><div layout-gt-xs=\"row\">\n<md-input-container class=\"md-block\" flex-gt-sm=\"5\"><label translate=\"PIPELINE_ETAPA.NIVEL\"></label><input type=\"text\" \nng-change=\"vm.pipelineEtapa.nivel = vm.pipelineEtapa.nivel.toUpperCase()\" ng-model=\"vm.pipelineEtapa.nivel\" \nname=\"nivel\" mascara-tamanho-campo=\"1\" mascara-formatar-nome \nng-required=\"vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo\" md-maxlength=\"1\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.inserirAtivo\r\n                                            || vm.controleForm.emProgresso\">\n<div ng-messages=\"vm.form.nivel.$error\"><div ng-message=\"required\" translate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\">\n</div></div></md-input-container><md-input-container class=\"md-block\" flex-gt-sm=\"10\"><label \ntranslate=\"PIPELINE_ETAPA.PERIODO\"></label><input type=\"text\" ng-model=\"vm.pipelineEtapa.periodo\" name=\"periodo\" \nmascara-numero-generica=\"###\" ng-required=\"vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\r\n                                             || vm.controleForm.emProgresso\">\n<div ng-messages=\"vm.form.periodo.$error\"><div ng-message=\"required\" translate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\">\n</div></div></md-input-container><md-input-container class=\"md-block\" flex-gt-sm=\"20\"><label \ntranslate=\"PIPELINE_ETAPA.PROBABILIDADE_FECHAMENTO\"></label><input type=\"text\" \nng-model=\"vm.pipelineEtapa.probabilidadeFechamento\" name=\"probabilidadeFechamento\" mascara-numero-generica=\"###\" \nng-required=\"vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\r\n                                            || vm.controleForm.emProgresso\">\n<div ng-messages=\"vm.form.probabilidadeFechamento.$error\"><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container><md-input-container class=\"md-block\" \nflex-gt-sm=\"20\"><label translate=\"PIPELINE_ETAPA.LIMITE_DIAS_SEM_CONTATO\"></label><input type=\"text\" \nng-model=\"vm.pipelineEtapa.limiteDiasSemContato\" name=\"limiteDiasSemContato\" mascara-numero-generica=\"###\" \nng-required=\"vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\r\n                                            || vm.controleForm.emProgresso\">\n<div ng-messages=\"vm.form.limiteDiasSemContato.$error\"><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container><md-input-container class=\"md-block\" \nflex-gt-sm=\"20\"><label translate=\"PIPELINE_ETAPA.DIAS_ALERTA_VENCIMENTO\"></label><input type=\"text\" \nng-model=\"vm.pipelineEtapa.diasAlertaVencimento\" name=\"diasAlertaVencimento\" mascara-numero-generica=\"###\" \nng-required=\"vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\r\n                                            || vm.controleForm.emProgresso\">\n<div ng-messages=\"vm.form.diasAlertaVencimento.$error\"><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container><md-input-container class=\"md-block\" \nflex-gt-sm=\"20\"><md-checkbox ng-model=\"vm.pipelineEtapa.permiteValoresZerados\" aria-label=\"Permite valores zerados\" \nname=\"permiteValoresZerados\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\"><span \nclass=\"float-label-cor-default\" translate=\"PIPELINE_ETAPA.PERMITE_VALORES_ZERADOS\"></span></md-checkbox>\n</md-input-container></div><div layout-gt-xs=\"row\"><md-input-container class=\"md-block\" flex><label \ntranslate=\"PIPELINE_ETAPA.ATIVIDADES\"></label><textarea ng-model=\"vm.pipelineEtapa.atividades\" name=\"atividades\" \nng-required=\"vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo \r\n                                                || vm.controleForm.emProgresso\" \nmd-no-resize=\"true\" rows=\"5\" max-rows=\"5\">\r\n                              <div ng-messages=\"vm.form.atividades.$error\">\n\r\n                                <div ng-message=\"required\" translate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div>\n\r\n                            </div>\r\n                        </textarea></md-input-container></div></div></md-content>\n</form></div>");
$templateCache.put("app/main/pipeline/cadastro/pipeline-etapa/views/pipeline-etapa.html","<div id=\"pipeline-etapa\" class=\"page-layout simple tabbed\" layout=\"column\"><header-padrao \ntranslate-nome=\"PIPELINE_ETAPA.ETAPA\" icone=\"icon-format-list-numbers\" \nliberar-pesquisa-quando-datatable-ativo=\"vm.controleForm.listarTodasEntidades\" pesquisar=\"vm.pesquisar\">\n</header-padrao><div class=\"content\"><div ui-view=\"pipeline-etapa-form\"></div></div><div \nui-view=\"pipeline-etapas-tabela\" ng-if=\"vm.controleForm.listarTodasEntidades\"></div></div>");
$templateCache.put("app/main/pipeline/cadastro/pipeline-etapa/views/pipeline-etapas-tabela.html","<div layout=\"column\" flex><div class=\"md-padding md-background-bg md-whiteframe-1dp fullpage-datatable\" \nlayout=\"column\" flex><table class=\"dataTable row-border hover\" id=\"datatable-pipeline-etapas\" width=\"100%\"><thead><tr>\n<th>Ação</th><th>Código</th><th>Descrição</th><th>Nível</th><th>Período</th><th>Probabilidade Fechamento</th><th>\nLimite Dias Sem Contato</th><th>Dias Alerta Vencimento</th></tr></thead></table></div></div>");
$templateCache.put("app/main/locacao/consulta/historico/views/historico-form.html","");
$templateCache.put("app/main/locacao/consulta/historico/views/historico.html","<div id=\"historico-detalhe\" class=\"page-layout simple tabbed\" layout=\"column\"><header-padrao \ntranslate-nome=\"Histórico\" liberar-pesquisa-quando-datatable-ativo=\"false\" ng-utiliza-pesquisa=\"false\" \npesquisar=\"vm.pesquisar\"></header-padrao><div layout=\"column\" class=\"content d-background-bg md-whiteframe-1dp\" \nstyle=\"min-height: 73.5vh;background-color: white\"><div flex layout=\"row\" \nstyle=\"justify-content: center;max-height: 15vh\" class=\"mt-10\"><fieldset class=\"standard\" style=\"max-height: 12vh\">\n<legend class=\"grp-legend\" translate=\"Pesquisar por\"></legend><div layout=\"column\"><md-radio-group \nng-model=\"vm.tipoPesquisa\" layout=\"row\"><md-radio-button value=\"1\">Série</md-radio-button><md-radio-button value=\"2\">\nIMEI</md-radio-button></md-radio-group></div></fieldset><md-input-container flex=\"30\" style=\"font-size: 16px\"><label>\nNúmero:</label><input ng-model=\"vm.numeroSerie\" maxlength=\"30\" md-maxlength=\"30\" ng-required=\"true\" \nid=\"inputBuscarHistorico\"></md-input-container><md-button id=\"botaoPesquisarHistorico\" \nclass=\"md-raised md-accent botao-historico\" ng-click=\"vm.metodos.pesquisarHistorico($event, vm.numeroSerie)\" \nng-disabled=\"vm.numeroSerie == undefined\">Pesquisar</md-button></div><div layout=\"column\" flex ng-if=\" vm.pesquisando\" \nlayout-align=\"center center\" class=\"mt-50\"><md-progress-circular class=\"md-accent\" md-mode=\"indeterminate\">\n</md-progress-circular></div><div layout=\"column\" flex ng-if=\" !vm.pesquisando && vm.iniciaTabela\"><div layout=\"row\" \nlayout-align=\"center center\"><md-card flex class=\"blue-bg white-fg\" md-theme-watch style=\"max-width: 30%\">\n<md-card-title style=\"padding: 0px\"><md-card-title-text><span style=\"font-size: large\" \nclass=\"blue-bg white-fg texto-card-filtro\">{{vm.detalhesHistoricos[0].equipamentoDescricao}}</span>\n</md-card-title-text></md-card-title></md-card><md-card class=\"blue-bg white-fg\" style=\"max-width: 30%\" \nng-if=\"vm.notaFiscalEntrada != null && vm.notaFiscalEntrada.length > 0\" md-theme-watch flex><md-card-title \nstyle=\"padding: 0px\"><md-card-title-text><span style=\"font-size: large\" class=\"blue-bg white-fg texto-card-filtro\">\nNF Entrada: {{vm.notaFiscalEntrada}}</span></md-card-title-text></md-card-title></md-card><md-card \nclass=\"blue-bg white-fg\" style=\"max-width: 30%\" \nng-if=\"vm.notaFiscalRevenda != null && vm.notaFiscalRevenda.length > 0\" md-theme-watch flex><md-card-title \nstyle=\"padding: 0px\"><md-card-title-text><span style=\"font-size: large\" class=\"blue-bg white-fg texto-card-filtro\">\nNF Revenda: {{vm.notaFiscalRevenda}}</span></md-card-title-text></md-card-title></md-card></div><div \nclass=\"md-padding md-background-bg md-whiteframe-1dp fullpage-datatable\"><table class=\"dataTable row-border hover\" \ndatatable=\"ng\" dt-options=\"vm.historicoDtOptions\"><thead><tr><th class=\"secondary-text\"><div class=\"table-header\"><span\n class=\"column-title\">Data</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Situação</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Tipo do contrato</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Item</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Cliente</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Usuário</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Estado conservação</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Fotos</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Empresa ativo</span></div></th></tr></thead><tbody><tr \nng-repeat=\"historico in vm.detalhesHistoricos | orderBy: \'id\'\"><td class=\"border-left border-right h3 text-center\" \nstyle=\"padding-left: 8px\"><span ng-hide=\"true\">{{historico.data}}</span> {{historico.data | date:\'dd/MM/yyyy\'}}</td><td\n class=\"border-right h3 text-center\">{{historico.situacaoDescricao}}</td><td class=\"border-right h3 text-center\">\n{{historico.tipoContrato }}</td><td class=\"border-right h3 text-center\">{{historico.produto}}</td><td \nclass=\"border-right h3 text-center\">{{historico.clienteNome}}</td><td class=\"border-right _expanded_ text-center h3\">\n{{historico.usuarioNome}}</td><td class=\"h3 text-center border-right\"><md-button \nclass=\"md-icon-button margenBotaoPonto\" style=\"margin-left: -30px\" \nng-click=\"vm.metodos.botaoDialogEstadoConservacao($event, historico)\"><i class=\"icon-pencil s16 icone-cor-padrao\" \nstyle=\"margin-left: 15px; padding: 0\" ng-click=\"\"></i><md-tooltip><span>Editar estado de conservação</span>\n</md-tooltip></md-button>{{historico.equipamentoEstadoConservacaoDescricao}}</td><td \nclass=\"button-icone-cor-azul text-center\"><i class=\"icon-picture s16 icone-cor-padrao\" \nng-click=\"vm.controleForm.emProgresso || vm.metodos.dialogFoto($event,historico)\" \nng-disabled=\"vm.controleForm.emProgresso\"></i></td><td class=\"border-left border-right text-center h3\">\n{{ vm.metodos.retornaDescricaoEmpresaAtivo(historico.empresaAtivoId) }}</td></tr></tbody></table></div></div></div>\n</div>");
$templateCache.put("app/main/pipeline/consulta/estatististica-negocios/views/estatistica-negocios-dashboard.html","<div class=\"widget-group\" layout=\"row\" flex=\"100\" layout-wrap><ms-widget flippable=\"false\" layout=\"column\" flex=\"100\" \nflex-gt-xs=\"50\" flex-gt-md=\"25\"><ms-widget-front class=\"md-accent-bg\"><div class=\"pl-16 pr-8 pv-16 h-55\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"h3 black-fg\">Em aberto</div></div><div class=\"pt-8 pb-32\" \nlayout=\"column\" layout-align=\"center center\" ng-click=\"vm.metodos.listarNegociosEmAndamento($event);\"><div \nclass=\"white-fg font-size-72 line-height-72\">{{vm.dados.negociosEmAndamento.quantidade}}</div><div \nclass=\"h3 secondary-text black-fg font-weight-500\">Negócios</div></div><div class=\"p-16 border-top\" layout=\"row\" \nlayout-align=\"start center\"><span class=\"h5 text-truncate black-fg\">Valor nominal total:</span> <span \nclass=\"h5 ml-8 white-fg\">{{vm.dados.negociosEmAndamento.valorTotal | currency:\"R$ \"}}</span></div><div \nclass=\"p-16 border-top\" layout=\"row\" layout-align=\"start center\"><span class=\"h5 text-truncate black-fg\">\nTotal de outros valores:</span> <span class=\"h5 ml-8 white-fg\">\n{{vm.dados.negociosEmAndamento.totalOutrosValores | currency:\"R$ \"}}</span></div><div class=\"p-16 border-top\" \nlayout=\"row\" layout-align=\"start center\"><span class=\"h5 text-truncate black-fg\">Valor projetado:</span> <span \nclass=\"h5 ml-8 white-fg\">{{vm.dados.valorProjetado | currency:\"R$ \"}}</span></div></ms-widget-front></ms-widget>\n<ms-widget flippable=\"false\" layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"25\"><ms-widget-front \nclass=\"white-bg\"><div class=\"ph-16 pv-16 h-55\" layout=\"row\" layout-align=\"space-between center\"><div class=\"h3\">\nNegócios criados no período</div></div><div class=\"pt-8 pb-32\" layout=\"column\" layout-align=\"center center\" \nng-click=\"vm.metodos.listarNegociosDoPeriodo($event);\"><div class=\"light-blue-fg font-size-72 line-height-72\">\n{{vm.dados.negociosNoPeriodo.quantidade}}</div><div class=\"h3 secondary-text font-weight-500\">Negócios</div></div><div \nclass=\"p-16 grey-50-bg border-top\" layout=\"row\" layout-align=\"start center\"><span \nclass=\"h5 secondary-text text-truncate\">Valor nominal total:</span> <span class=\"h5 ml-8 light-blue-fg\">\n{{vm.dados.negociosNoPeriodo.valorTotal | currency:\"R$ \"}}</span></div><div class=\"p-16 grey-50-bg border-top\" \nlayout=\"row\" layout-align=\"start center\"><span class=\"h5 secondary-text text-truncate\">Total de outros valores:</span> \n<span class=\"h5 ml-8 light-blue-fg\">{{vm.dados.negociosNoPeriodo.totalOutrosValores | currency:\"R$ \"}}</span></div><div\n class=\"p-16 grey-50-bg border-top\" layout=\"row\" layout-align=\"start center\"><span \nclass=\"h5 secondary-text text-truncate\">Valor projetado:</span> <span class=\"h5 ml-8 light-blue-fg\">\n{{vm.dados.valorProjetadoNoPeriodo | currency:\"R$ \"}}</span></div></ms-widget-front></ms-widget><ms-widget \nflippable=\"false\" layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"25\"><ms-widget-front class=\"white-bg\"><div \nclass=\"pl-16 pr-8 pv-16 h-55\" layout=\"row\" layout-align=\"space-between center\"><div class=\"h3\">Ganhos no período</div>\n</div><div class=\"pt-8\" layout=\"column\" layout-align=\"center center\" \nng-click=\"vm.metodos.listarNegociosGanhos($event);\"><div class=\"green-fg font-size-72 line-height-72\">\n{{vm.dados.negociosGanhos.quantidade}}</div><div class=\"h3 secondary-text font-weight-500\">Negócios</div><p \nclass=\"h5 mb-10 mt-3 secondary-text text-truncate\">Conversão em ganho: <span class=\"green-fg\">\n{{ vm.metodos.retornaConversao(vm.dados.negociosGanhos.quantidade, vm.dados.negociosPerdidos.quantidade) }}%</span></p>\n</div><div class=\"p-16 grey-50-bg border-top\" layout=\"row\" layout-align=\"start center\"><span \nclass=\"h5 secondary-text text-truncate\">Valor nominal total:</span> <span class=\"h5 ml-8 green-fg\">\n{{vm.dados.negociosGanhos.valorTotal | currency:\"R$ \"}}</span></div><div class=\"p-16 grey-50-bg border-top\" \nlayout=\"row\" layout-align=\"start center\"><span class=\"h5 secondary-text text-truncate\">Total de outros valores:</span> \n<span class=\"h5 ml-8 green-fg\">{{vm.dados.negociosGanhos.totalOutrosValores | currency:\"R$ \"}}</span></div><div \nclass=\"p-16 grey-50-bg border-top\" layout=\"row\" layout-align=\"start center\"><span \nclass=\"h5 secondary-text text-truncate\">Conversão em ganho:</span> <span class=\"h5 ml-8 green-fg\">\n{{ vm.metodos.retornaConversao(vm.dados.negociosGanhos.valorTotal, vm.dados.negociosPerdidos.valorTotal) }}%</span>\n</div></ms-widget-front></ms-widget><ms-widget flippable=\"false\" layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" \nflex-gt-md=\"25\"><ms-widget-front class=\"white-bg\"><div class=\"pl-16 pr-8 pv-16 h-55\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"h3\">Perdidos no período</div></div><div class=\"pt-8\" layout=\"column\" \nlayout-align=\"center center\" ng-click=\"vm.metodos.listarNegociosPerdidos($event);\"><div \nclass=\"red-fg font-size-72 line-height-72\">{{vm.dados.negociosPerdidos.quantidade}}</div><div \nclass=\"h3 secondary-text font-weight-500\">Negócios</div><p class=\"h5 mb-10 mt-3 secondary-text text-truncate\">\nConversão em perda: <span class=\"red-fg\">\n{{ vm.metodos.retornaConversao(vm.dados.negociosPerdidos.quantidade, vm.dados.negociosGanhos.quantidade) }}%</span></p>\n</div><div class=\"p-16 grey-50-bg border-top\" layout=\"row\" layout-align=\"start center\"><span \nclass=\"h5 secondary-text text-truncate\">Valor nominal total:</span> <span class=\"h5 ml-8 red-fg\">\n{{vm.dados.negociosPerdidos.valorTotal | currency:\"R$ \"}}</span></div><div class=\"p-16 grey-50-bg border-top\" \nlayout=\"row\" layout-align=\"start center\"><span class=\"h5 secondary-text text-truncate\">Total de outros valores:</span> \n<span class=\"h5 ml-8 red-fg\">{{vm.dados.negociosPerdidos.totalOutrosValores | currency:\"R$ \"}}</span></div><div \nclass=\"p-16 grey-50-bg border-top\" layout=\"row\" layout-align=\"start center\"><span \nclass=\"h5 secondary-text text-truncate\">Conversão em perda:</span> <span class=\"h5 ml-8 red-fg\">\n{{ vm.metodos.retornaConversao(vm.dados.negociosPerdidos.valorTotal, vm.dados.negociosGanhos.valorTotal) }}%</span>\n</div></ms-widget-front></ms-widget></div><div class=\"widget-group\" layout=\"row\" flex=\"100\" layout-wrap><ms-widget \nlayout=\"row\" flex=\"100\" \nng-if=\"vm.dados.dadosGraficoGanhosPerdidosGanhos.values.length > 0 && \r\n                      vm.dados.dadosGraficoGanhosPerdidosPerdidos.values.length > 0\">\n<ms-widget-front class=\"white-bg\"><div class=\"ph-16 pv-8 border-bottom\" layout=\"row\"><div class=\"pv-8 h3 text-center\" \nflex=\"100\">Negócios ganhos x perdidos</div></div><div layout=\"row\" layout-align=\"center center\" layout-wrap><div \nclass=\"p-16\" flex=\"100\" layout-align=\"center center\"><nvd3 class=\"h-420 remove-x-lines\" layout-align=\"center center\" \noptions=\"vm.graficoGanhosPerdidos.options\" data=\"vm.graficoGanhosPerdidos.data\"></nvd3></div></div></ms-widget-front>\n</ms-widget><ms-widget layout=\"row\" flex=\"100\" ng-if=\"vm.dados.dadosGraficoMotivosPerda.length > 0\"><ms-widget-front \nclass=\"white-bg\"><div class=\"ph-16 pv-8 border-bottom\" layout=\"row\"><div class=\"pv-8 h3 text-center\" flex=\"100\">\nMotivos de perda do negócio</div></div><div layout=\"row\" layout-align=\"center center\" layout-wrap><div class=\"p-16\" \nflex=\"100\" layout-align=\"center center\"><nvd3 class=\"h-420\" layout-align=\"center center\" \noptions=\"vm.graficoMotivosPerda.options\" data=\"vm.graficoMotivosPerda.data\"></nvd3></div></div></ms-widget-front>\n</ms-widget></div>");
$templateCache.put("app/main/pipeline/consulta/estatististica-negocios/views/estatistica-negocios.html","<div id=\"pipeline-consulta-estatistica\" class=\"page-layout simple tabbed\" layout=\"column\"><div class=\"center\">\n<header-padrao translate-nome=\"PIPELINE_CONSULTA_ESTATISTICA.TITULO\" icone=\"icon-format-list-numbers\" \nng-utiliza-pesquisa=\"false\"></header-padrao><div class=\"content\"><div class=\"button-float\" layout=\"row\" \nlayout-align=\"end center\"><md-button class=\"md-primary button-toogle icon-filter-outline md-fab\" \nng-click=\"vm.toggleRight()\" aria-label=\"Fitrar\"><md-tooltip md-autohide>Filtro</md-tooltip></md-button></div>\n<md-sidenav class=\"md-sidenav-right md-whiteframe-4dp\" md-component-id=\"right\"><md-toolbar \nstyle=\"background-color: #039BE5\"><h1 class=\"md-toolbar-tools\">Filtro</h1></md-toolbar><md-content layout-padding flex>\n<form name=\"estatistica\" layout=\"column\"><fieldset class=\"standard\" flex><legend class=\"grp-legend\">Funil</legend>\n<md-input-container class=\"md-block pv-8\"><label>Funil</label><md-select ng-model=\"vm.filtroEstatisticas.codigoFunil\" \nng-change=\"vm.metodos.carregarProdutosPorFunil()\"><md-option ng-value=\"funil.codigo\" ng-repeat=\"funil in vm.funis\">\n{{funil.descricao}}</md-option></md-select></md-input-container><md-progress-linear ng-hide=\"!vm.carregandoProdutos\" \nstyle=\"margin-top: -26px; width: 95.4%; margin-left: 17px; margin-bottom: 21px !important\" md-mode=\"indeterminate\" \nclass=\"md-accent\"></md-progress-linear></fieldset><fieldset class=\"standard\" flex ng-if=\"vm.produtos.length > 1\">\n<legend class=\"grp-legend\">Produtos</legend><multi-select-directive id=\"select-produtos-estatistica\" \nform-name=\"produtos\" data=\"vm.produtos\" model=\"vm.filtroEstatisticas.produtosFiltros\" obrigatorio=\"false\" \ndisabled=\"vm.carregandoProdutos\" descricao-exibicao=\"descricao\" texto-pesquisa-placeholder=\"Procurar produto...\" \ntexto-placeholder=\"Produtos\" flex></multi-select-directive></fieldset><fieldset class=\"standard\" flex><legend \nclass=\"grp-legend\">Período</legend><md-input-container class=\"md-block pv-8\"><label>Período</label><md-select \nng-model=\"vm.filtroEstatisticas.periodo\"><md-option ng-value=\"periodo.id\" ng-repeat=\"periodo in vm.periodos\">\n{{periodo.descricao}}</md-option></md-select></md-input-container><div flex layout=\"row\" \nng-if=\"vm.filtroEstatisticas.periodo == vm.EnumPeriodo.Customizado\"><md-input-container class=\"md-block\" flex><label>\nData inicial</label><md-datepicker ng-model=\"vm.filtroEstatisticas.dataInicial\" mascara-conversor-string-para-data \nng-required=\"true\" md-max-date=\"vm.filtroEstatisticas.dataFinal\" ng-mask=\"3?9/1?9/9999\" name=\"dataInicio\" \nmd-open-on-focus></md-datepicker><div ng-messages=\"estatistica.dataInicio.$error\"><div ng-message=\"valid\" \ntranslate=\"MENSAGEM_VALIDACAO.DATA_INVALIDA\"></div><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.DATA_OBRIGATORIA\"></div></div></md-input-container><md-input-container class=\"md-block\" \nflex><label>Data Final</label><md-datepicker ng-model=\"vm.filtroEstatisticas.dataFinal\" \nmascara-conversor-string-para-data md-min-date=\"vm.filtroEstatisticas.dataInicial\" md-max-date=\"vm.dataAtual\" \nng-required=\"true\" name=\"dataFinal\" ng-mask=\"3?9/1?9/9999\" md-open-on-focus></md-datepicker><div \nng-messages=\"estatistica.dataFinal.$error\"><div ng-message=\"valid\" translate=\"MENSAGEM_VALIDACAO.DATA_INVALIDA\"></div>\n<div ng-message=\"mindate\" translate=\"MENSAGEM_VALIDACAO.CAMPO_DATA_FINAL\"></div><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.DATA_OBRIGATORIA\"></div></div></md-input-container></div></fieldset><fieldset \nclass=\"standard\" flex><legend class=\"grp-legend\">Executivos de contas</legend><md-input-container \nclass=\"md-block pv-8\"><label translate=\"PIPELINE_CONSULTA_ESTATISTICA.EXECUTIVO_DE_CONTAS\"></label><md-select \nng-model=\"vm.filtroEstatisticas.codigoExecutivoDeContas\" name=\"executivoDeContas\"><md-option ng-value=\"Todos\">Todos\n</md-option><md-option ng-value=\"usuario.codigo\" ng-repeat=\"usuario in vm.usuarios track by usuario.codigo\">\n{{usuario.login}}</md-option></md-select></md-input-container></fieldset></form><div layout=\"row\" \nlayout-align=\"center center\"><md-button class=\"md-raised md-accent\" \nng-click=\"vm.metodos.filtrarDados($event, vm.filtroEstatisticas)\" ng-hide=\"vm.requisicaoSolicitada\" \nng-disabled=\"vm.requisicaoSolicitada || \r\n                                                vm.carregandoProdutos ||\r\n                                                vm.form.$invalid || \r\n                                                estatistica.$invalid\" \nlayout-align=\"center center\"><span>FILTRAR</span></md-button><div layout=\"row\" layout-align=\"center center\" \nng-if=\"vm.requisicaoSolicitada\" flex><md-progress-circular class=\"md-accent\" md-diameter=\"30\" md-mode=\"indeterminate\">\n</md-progress-circular></div></div></md-content></md-sidenav><div layout=\"column\" flex=\"100\" \nstyle=\"margin-top: 20px !important\" layout-align=\"center center\" ng-if=\"vm.requisicaoSolicitada\"><md-progress-circular \nmd-mode=\"indeterminate\" md-diameter=\"80\" class=\"md-accent\"></md-progress-circular><span class=\"font-weight-500\">\n{{vm.mensagemPreloader}}</span></div><div ui-view=\"dashboard-estatisticas\" ng-if=\"!vm.requisicaoSolicitada\"></div>\n</div></div></div>");
$templateCache.put("app/main/pipeline/cadastro/pipeline-funil/views/pipeline-funil-form.html","<div class=\"md-background-bg md-whiteframe-1dp\"><form name=\"pipelineFunilForm\" novalidate><pg-toolbar \nentidades=\"vm.pipelineFunis\" entidade=\"vm.pipelineFunil\" entidade-de-envio=\"vm.entidadeDeEnvio\" \ncontrolador-toolbar=\"vm.controleForm\" controlador-pre-loader=\"vm.controlePreloader\" \nacao-pesquisar=\"vm.metodosPipelineFunil.pesquisar()\" acao-criar=\"vm.metodosPipelineFunil.salvar(vm.pipelineFunil)\" \nacao-editar=\"vm.metodosPipelineFunil.editar(vm.pipelineFunil)\" \nacao-excluir=\"vm.metodosPipelineFunil.excluir(vm.pipelineFunil)\" \nconstruir-dt-options=\"vm.metodosPipelineFunil.construirDtOptions()\" metodos-externos=\"vm.metodosExternosPgToolbar\" \ncampo-pesquisar=\"vm.pesquisar\" pre-definir-campos-para-insercao=\"vm.metodosGeral.preDefinirCamposParaInserir()\">\n</pg-toolbar><md-content layout-padding ng-hide=\"vm.controleForm.listarTodasEntidades\" \nng-disabled=\"vm.controleForm.emProgresso\"><div class=\"form-container\"><div layout-gt-xs=\"row\"><md-input-container \nclass=\"md-block\" flex-gt-sm=\"20\"><label translate=\"PIPELINE_FUNIL.CODIGO\"></label><input type=\"text\" \nng-model=\"vm.pipelineFunil.codigo\" name=\"pipelinefunilCodigo\" mascara-numero-generica=\"#####\" \nng-required=\"vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.inserirAtivo\"><div \nng-messages=\"pipelineFunilForm.pipelinefunilCodigo.$error\"><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container><md-input-container class=\"md-block\" \nflex-offset-gt-sm=\"5\" flex-gt-sm><label translate=\"PIPELINE_FUNIL.DESCRICAO\"></label><input type=\"text\" \nng-model=\"vm.pipelineFunil.descricao\" name=\"pipelinefunilDescricao\" mascara-tamanho-campo=\"60\" \nng-required=\"vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo\" md-maxlength=\"60\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\"><div \nng-messages=\"pipelineFunilForm.pipelinefunilDescricao.$error\"><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container><md-input-container class=\"md-block\">\n<md-switch aria-label=\"Ativo\" class=\"mt-5\" ng-model=\"vm.pipelineFunil.ativo\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\">Ativo\n</md-switch></md-input-container></div><div layout-gt-xs=\"row\" flex><md-input-container class=\"md-block\" flex><label \ntranslate=\"PIPELINE_FUNIL.ETAPAS\"></label><md-select ng-model=\"vm.pipelineFunil.pipelineEtapas\" name=\"pipelineEtapas\" \nmultiple=\"multiple\" ng-model-options=\"{trackBy: \'$value.codigo\'}\" \nmd-on-open=\"vm.metodosGeral.configuraMdSelectEtapa()\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo \r\n                                                || vm.controleForm.emProgresso\">\n<md-select-header><input id=\"pipeline-funil-etapas-md-select\" class=\"md-text\" ng-model=\"vm.filtrarEtapas\" \ntype=\"search\" placeholder=\"\" translate translate-attr-placeholder=\"PIPELINE_FUNIL.PESQUISAR_ETAPA\"></md-select-header>\n<md-option ng-value=\"etapa\" ng-repeat=\"etapa in vm.etapas | filter:vm.filtrarEtapas track by etapa.codigo\">\n{{etapa.nivel}} - {{etapa.descricao}}</md-option></md-select><div \nng-messages=\"pipelineFunilForm.pipelineEtapas.$error\"><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container></div></div></md-content></form>\n</div>");
$templateCache.put("app/main/pipeline/cadastro/pipeline-funil/views/pipeline-funil-tabela.html","<div layout=\"column\" flex><div class=\"md-padding md-background-bg md-whiteframe-1dp fullpage-datatable\" \nlayout=\"column\" flex><table class=\"dataTable row-border hover\" id=\"datatable-pipeline-funil\" width=\"100%\"><thead><tr>\n<th>Ação</th><th>Código</th><th>Descrição</th></tr></thead></table></div></div>");
$templateCache.put("app/main/pipeline/cadastro/pipeline-funil/views/pipeline-funil.html","<div id=\"pipelinefunil\" class=\"page-layout simple tabbed\" layout=\"column\"><header-padrao \ntranslate-nome=\"PIPELINE_FUNIL.PIPELINE_FUNIL\" icone=\"icon-filter\" \nliberar-pesquisa-quando-datatable-ativo=\"vm.controleForm.listarTodasEntidades\" pesquisar=\"vm.pesquisar\">\n</header-padrao><div class=\"content\"><div ui-view=\"pipeline-funil-form\"></div></div><div \nui-view=\"pipeline-funil-tabela\" ng-if=\"vm.controleForm.listarTodasEntidades\"></div></div>");
$templateCache.put("app/main/pipeline/cadastro/pipeline-motivo-perda-negocio/views/pipeline-motivo-perda-negocio-form.html","<div class=\"md-background-bg md-whiteframe-1dp\"><form name=\"pipelinemotivoperdanegocioForm\" novalidate><pg-toolbar \nentidades=\"vm.pipeline_motivoperdanegocios\" entidade=\"vm.pipeline_motivoperdanegocio\" \nentidade-de-envio=\"vm.entidadeDeEnvio\" controlador-toolbar=\"vm.controleForm\" \ncontrolador-pre-loader=\"vm.controlePreloader\" acao-pesquisar=\"vm.metodosPipelineMotivoPerdaNegocio.pesquisar()\" \nacao-criar=\"vm.metodosPipelineMotivoPerdaNegocio.salvar(vm.pipeline_motivoperdanegocio)\" \nacao-editar=\"vm.metodosPipelineMotivoPerdaNegocio.editar(vm.pipeline_motivoperdanegocio)\" \nacao-excluir=\"vm.metodosPipelineMotivoPerdaNegocio.excluir(vm.pipeline_motivoperdanegocio)\" \nconstruir-dt-options=\"vm.metodosPipelineMotivoPerdaNegocio.construirDtOptions()\" \nmetodos-externos=\"vm.metodosExternosPgToolbar\" campo-pesquisar=\"vm.pesquisar\" \npre-definir-campos-para-insercao=\"vm.metodosGeral.PreDefinirCamposParaInserir()\"></pg-toolbar><md-content \nlayout-padding ng-hide=\"vm.controleForm.listarTodasEntidades\" ng-disabled=\"vm.controleForm.emProgresso\"><div \nclass=\"form-container\"><div layout-gt-xs=\"row\"><div layout=\"row\"><md-input-container class=\"md-block\" flex-gt-sm><label\n translate=\"PIPELINE-MOTIVO-PERDA-NEGOCIO.CODIGO\"></label><input type=\"text\" \nng-model=\"vm.pipeline_motivoperdanegocio.codigo\" name=\"pipelinemotivoperdanegocioCodigo\" \nmascara-numero-generica=\"#####\" ng-required=\"vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.inserirAtivo\"><div \nng-messages=\"pipelinemotivoperdanegocioForm.pipelinemotivoperdanegocioCodigo.$error\"><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container></div><md-input-container \nclass=\"md-block\" flex-offset-gt-sm=\"5\" flex><label translate=\"PIPELINE-MOTIVO-PERDA-NEGOCIO.DESCRICAO\"></label><input \nng-model=\"vm.pipeline_motivoperdanegocio.descricao\" name=\"pipelinemotivoperdanegocioDescricao\" \nmascara-tamanho-campo=\"50\" ng-required=\"vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo &&\r\n                                              !vm.controleForm.inserirAtivo || vm.controleForm.emProgresso\" \nmd-no-resize=\"true\" rows=\"1\" max-rows=\"3\"><div \nng-messages=\"pipelinemotivoperdanegocioForm.pipelinemotivoperdanegocioDescricao.$error\"><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container></div></div></md-content></form>\n</div>");
$templateCache.put("app/main/pipeline/cadastro/pipeline-motivo-perda-negocio/views/pipeline-motivo-perda-negocio-tabela.html","<div layout=\"column\" flex><div class=\"md-padding md-background-bg md-whiteframe-1dp fullpage-datatable\" \nlayout=\"column\" flex><table class=\"dataTable row-border hover\" id=\"datatable-pipeline-motivo-perda-negocio\" \nwidth=\"100%\"><thead><tr><th>Ação</th><th>Código</th><th>Descrição</th></tr></thead></table></div></div>");
$templateCache.put("app/main/pipeline/cadastro/pipeline-motivo-perda-negocio/views/pipeline-motivo-perda-negocio.html","<div id=\"pipelinemotivoperdanegocio\" class=\"page-layout simple tabbed\" layout=\"column\"><header-padrao \ntranslate-nome=\"PIPELINE-MOTIVO-PERDA-NEGOCIO.PIPELINE-MOTIVO-PERDA-NEGOCIO\" icone=\"icon-rename-box\" \nliberar-pesquisa-quando-datatable-ativo=\"vm.controleForm.listarTodasEntidades\" pesquisar=\"vm.pesquisar\">\n</header-padrao><div class=\"content\"><div ui-view=\"pipeline-motivo-perda-negocio-form\"></div></div><div \nui-view=\"pipeline-motivo-perda-negocio-tabela\" ng-if=\"vm.controleForm.listarTodasEntidades\"></div></div>");
$templateCache.put("app/main/pipeline/consulta/projecoes-negocios/views/projecoes-negocios-finalizacao-etapa.html","<div layout=\"row\" layout-align=\"center center\"><div ng-if=\"vm.dados.dadosProjecoes.length > 0\" \nid=\"chartdiv-pipeline-projecoes-finalizacao-etapa\"></div><div class=\"mt-20\" \nng-if=\"vm.dados.dadosProjecoes.length <= 0 && vm.exibirDetalhamentoProjecoes == 2\"><span \nstyle=\"font-size:18px; font-weight: bold\">Não existem dados a serem exibidos</span></div></div><div layout=\"row\" flex \nng-show=\"vm.exibirDetalhamentoProjecoes == 2\" ng-if=\"vm.dados.dadosProjecoes.length > 0\" layout-align=\"end center\">\n<md-input-container class=\"md-block\"><md-button type=\"submit\" ng-click=\"vm.metodos.abrirDialogProjecoesEtapa($event)\" \nclass=\"send-button md-accent md-raised\" aria-label=\"Exibir detalhamento projeção\">Exibir detalhamento projeção\n</md-button></md-input-container></div>");
$templateCache.put("app/main/pipeline/consulta/projecoes-negocios/views/projecoes-negocios-previsao-fechamento.html","<div layout=\"row\" layout-align=\"center center\"><div ng-if=\"vm.dados.dadosProjecoes.length > 0\" \nid=\"chartdiv-pipeline-projecoes-fechamento-comercial\"></div><div class=\"mt-20\" \nng-if=\"vm.dados.dadosProjecoes.length <= 0 && vm.exibirDetalhamentoProjecoes == 1\"><span \nstyle=\"font-size:18px; font-weight: bold\">Não existem dados a serem exibidos</span></div></div><div layout=\"row\" flex \nng-show=\"vm.exibirDetalhamentoProjecoes == 1\" ng-if=\"vm.dados.dadosProjecoes.length > 0\" layout-align=\"end center\">\n<md-input-container class=\"md-block\"><md-button type=\"submit\" ng-click=\"vm.metodos.abrirDialogProjecoesEtapa($event)\" \nclass=\"send-button md-accent md-raised\" aria-label=\"Exibir detalhamento projeção\">Exibir detalhamento projeção\n</md-button></md-input-container></div>");
$templateCache.put("app/main/pipeline/consulta/projecoes-negocios/views/projecoes-negocios.html","<div id=\"pipeline-consulta-projecoes-negocios\" class=\"page-layout simple tabbed\" layout=\"column\"><div class=\"center\">\n<header-padrao translate-nome=\"PIPELINE_CONSULTA_PROJECOES_NEGOCIOS.PROJECOES_NEGOCIOS\" \nicone=\"icon-format-list-numbers\" ng-utiliza-pesquisa=\"false\"></header-padrao><div id=\"conteudo\" class=\"content\"><div \nclass=\"button-float\" layout=\"row\" layout-align=\"end center\"><md-button \nclass=\"md-primary button-toogle icon-filter-outline md-fab\" ng-click=\"vm.alternaVisibilidadeSidnav()\" \naria-label=\"Fitrar\"><md-tooltip md-autohide>Filtro</md-tooltip></md-button></div><md-sidenav \nclass=\"md-sidenav-right md-whiteframe-4dp sidenav\" md-component-id=\"sidenav\" md-is-open=\"true\"><md-toolbar \nstyle=\"background-color: #039BE5\"><h1 class=\"md-toolbar-tools\">Filtro</h1></md-toolbar><md-content layout-padding flex>\n<form name=\"vm.form\" layout=\"column\"><fieldset><md-radio-group layout=\"row\" layout-padding \nng-model=\"vm.filtrosProjecoes.tipoPesquisa\"><md-radio-button value=\"1\" aria-label=\"Previsão fechamento comercial\" \nng-disabled=\"vm.requisicaoSolicitada\"><label>Previsão fechamento comercial</label></md-radio-button><md-radio-button \nvalue=\"2\" aria-label=\"Finalização da etapa\" ng-disabled=\"vm.requisicaoSolicitada\"><label>Finalização da etapa</label>\n</md-radio-button></md-radio-group></fieldset><fieldset class=\"standard\" flex><legend class=\"grp-legend\">Funil</legend>\n<md-input-container class=\"md-block pv-8\" flex=\"20\" flex-xs=\"50\" layout-align-gt-sm=\"center center\"><md-select \nng-model=\"vm.filtrosProjecoes.codigoFunil\" \nng-change=\"vm.metodos.changeFunil(vm.filtrosProjecoes.codigoFunil); preencherCampoProduto()\"><md-option \nng-value=\"funil.codigo\" ng-repeat=\"funil in vm.funis\">{{funil.descricao}}</md-option></md-select></md-input-container>\n</fieldset><fieldset class=\"standard\"><legend class=\"grp-legend\">Produtos</legend><multi-select-directive \nid=\"select-produtos\" form-name=\"produtos\" data=\"vm.produtosVinculados\" model=\"vm.filtrosProjecoes.produtos\" \ndescricao-exibicao=\"descricao\" obrigatorio=\"true\" texto-pesquisa-placeholder=\"Procurar produto...\" \ntexto-placeholder=\"Produtos\" disabled=\"vm.filtrosProjecoes.codigoFunil == undefined\"></multi-select-directive>\n</fieldset><fieldset class=\"standard\"><legend class=\"grp-legend\">Executivos de contas</legend><multi-select-directive \nid=\"select-usuario\" form-name=\"usuarios\" data=\"vm.usuarios\" model=\"vm.filtrosProjecoes.usuarios\" \ndescricao-exibicao=\"login\" obrigatorio=\"true\" texto-pesquisa-placeholder=\"Procurar executivo de contas...\" \ntexto-placeholder=\"Executivo de contas\"></multi-select-directive></fieldset><fieldset class=\"standard\"><legend \nclass=\"grp-legend\">Período</legend><md-input-container class=\"md-block pv-8\"><label>Período</label><md-select \nng-model=\"vm.filtrosProjecoes.periodo\"><md-option ng-value=\"periodo.id\" ng-repeat=\"periodo in vm.periodos\">\n{{periodo.descricao}}</md-option></md-select></md-input-container><div flex=\"100\" layout=\"row\" \nng-if=\"vm.filtrosProjecoes.periodo == vm.EnumPeriodo.Customizado\"><md-input-container class=\"md-block\" flex><label \ntranslate=\"RELATORIO_CLIENTE.DATA_INICIAL\"></label><md-datepicker mascara-conversor-string-para-data name=\"inicial\" \nmd-open-on-focus md-max-date=\"vm.filtrosProjecoes.dataFinal\" ng-model=\"vm.filtrosProjecoes.dataInicial\" \nng-required=\"true\" ng-mask=\"3?9/1?9/9999\"></md-datepicker><div ng-messages=\"vm.form.inicial.$error\"><div \nng-message=\"valid\" translate=\"MENSAGEM_VALIDACAO.DATA_INVALIDA\"></div><div ng-message=\"required\" \ntranslate=\"RELATORIO_CLIENTE.DATA_FINAL_OBRIGATORIA\"></div></div></md-input-container><md-input-container \nclass=\"md-block\" flex><label translate=\"RELATORIO_CLIENTE.DATA_FINAL\"></label><md-datepicker \nmascara-conversor-string-para-data name=\"final\" md-open-on-focus md-min-date=\"vm.filtrosProjecoes.dataInicial\" \nng-required=\"true\" ng-model=\"vm.filtrosProjecoes.dataFinal\" ng-mask=\"3?9/1?9/9999\"></md-datepicker><div \nng-messages=\"vm.form.final.$error\"><div ng-message=\"valid\" translate=\"MENSAGEM_VALIDACAO.DATA_INVALIDA\"></div><div \nng-message=\"mindate\" translate=\"MENSAGEM_VALIDACAO.CAMPO_DATA_FINAL\"></div><div ng-message=\"required\" \ntranslate=\"RELATORIO_CLIENTE.DATA_FINAL_OBRIGATORIA\"></div></div></md-input-container></div></fieldset></form><div \nlayout=\"row\" layout-align=\"center center\"><md-button class=\"md-raised md-accent botao-filtrar\" \nng-click=\"vm.metodos.filtrarDados($event, vm.filtrosProjecoes)\" \nng-disabled=\"vm.requisicaoSolicitada || vm.form.$invalid\" ng-hide=\"vm.requisicaoSolicitada\" \nlayout-align=\"center center\"><span>FILTRAR</span></md-button><div class=\"carregamento-circular\" layout=\"row\" \nlayout-align=\"center\" ng-if=\"vm.requisicaoSolicitada\"><md-progress-circular class=\"md-accent\" md-diameter=\"30\" \nmd-mode=\"indeterminate\"></md-progress-circular></div></div></md-content></md-sidenav><div layout=\"column\" flex=\"100\" \nstyle=\"margin-top: 20px !important\" layout-align=\"center center\" ng-if=\"vm.requisicaoSolicitada\"><md-progress-circular \nmd-mode=\"indeterminate\" md-diameter=\"80\" class=\"md-accent\"></md-progress-circular><span class=\"font-weight-500\">\n{{vm.mensagemPreloader}}</span></div><md-content layout-padding ng-if=\"!vm.requisicaoSolicitada\" \nng-show=\"vm.dados != undefined\"><ng-include ng-show=\"vm.filtrosProjecoes.tipoPesquisa == 1\" \nsrc=\"vm.rotasHtml.projecoesNegociosPrevisaoFechamento\"></ng-include><ng-include \nng-show=\"vm.filtrosProjecoes.tipoPesquisa == 2\" src=\"vm.rotasHtml.projecoesNegocioFinalizacaoEtapa\"></ng-include>\n</md-content></div></div></div>");
$templateCache.put("app/main/locacao/processamento/baixa-equipamento/views/baixa-equipamento.html","<div id=\"baixa-equipamento\" layout=\"column\"><header-padrao translate-nome=\"Baixa de Equipamentos\" \nng-utiliza-pesquisa=\"false\"></header-padrao><div><div layout=\"column\" \nclass=\"content d-background-bg md-whiteframe-1dp\"><div flex layout=\"row\" \nstyle=\"justify-content: center;max-height: 15vh\" class=\"mt-10\"><fieldset class=\"standard\" style=\"max-height: 12vh\">\n<legend class=\"grp-legend\" translate=\"Pesquisar por\"></legend><div layout=\"column\"><md-radio-group \nng-model=\"vm.tipoPesquisa\" layout=\"row\"><md-radio-button value=\"1\">Série</md-radio-button><md-radio-button value=\"2\">\nIMEI</md-radio-button></md-radio-group></div></fieldset><md-input-container flex=\"30\" style=\"font-size: 16px\"><label>\nNúmero:</label><input ng-model=\"vm.numeroSerieOuIMEI\" maxlength=\"30\" md-maxlength=\"30\" ng-required=\"true\" \nid=\"inputBuscarHistorico\"></md-input-container><md-button id=\"botaoPesquisarHistorico\" \nclass=\"md-raised md-accent botao-historico\" \nng-click=\"vm.metodos.listarEquipamentoNotaItemDetalhe($event, vm.numeroSerieOuIMEI)\" \nng-disabled=\"vm.numeroSerieOuIMEI == undefined\">Pesquisar</md-button></div><br></div></div><div layout=\"row\" \nclass=\"mb-10\" flex><div layout=\"row\" ng-if=\"vm.load\" layout-align=\"center center\" flex><div layout=\"column\" \nlayout-align=\"center center\" class=\"mt-100\"><span class=\"font-weight-500\" style=\"font-size: 16px\">\n{{vm.mensagemPreloader}}</span><md-progress-circular md-mode=\"indeterminate\" md-diameter=\"100\" class=\"md-accent\">\n</md-progress-circular></div></div></div><div layout=\"column\" ng-if=\"vm.exibirDados\"><div class=\"divCardsRespponsivos\" \nlayout=\"row\" style=\"justify-content: center\" ng-if=\"vm.mostrarCards\"><div flex flex-gt-sm=\"40\" style=\"height: 53vh\">\n<md-card flex layout=\"column\" class=\"cardHistorico\"><md-card-title-text><span class=\"md-headline\" \nlayout-align=\"center center\" style=\"font-size: 20px\">Histórico</span></md-card-title-text><div layout=\"row\" flex><div \nlayout=\"row\" ng-show=\"vm.loadBaixa\" layout-align=\"center center\" flex><div layout=\"column\" \nlayout-align=\"center center\"><span class=\"font-weight-500\" style=\"font-size: 16px\">{{vm.mensagemPreloader}}</span>\n<md-progress-circular md-mode=\"indeterminate\" md-diameter=\"100\" class=\"md-accent\"></md-progress-circular></div></div>\n</div><div style=\"height: 61.5vh; overflow: scroll\" layout=\"column\" ng-if=\"!vm.loadBaixa\"><md-content><md-list flex \nng-repeat=\"historico in vm.detalhesHistoricos\" style=\"padding: 0\"><md-list-item class=\"md-3-line\" \nstyle=\"padding: 0; border-top: 1px solid rgba(0,0,0,.12)\" ng-class=\"{\'zebra\' : $index %2 == 0}\"><div \nclass=\"md-list-item-text descricaoCard\" layout=\"column\"><h4><strong>Data</strong>\n: {{historico.data | date:\'dd/MM/yyyy\'}} | <strong>Situação</strong>: {{historico.situacaoDescricao}}</h4><h4><strong>\nContrato</strong>: {{historico.produto}} | <strong>Cliente</strong>: {{historico.clienteNome}}</h4></div>\n</md-list-item></md-list></md-content></div></md-card></div><div class=\"cardEquipamentoVh\" flex flex-gt-sm=\"40\" \nstyle=\"height: 53vh\"><md-card flex layout=\"column\" class=\"cardEquipamento\"><md-card-title-text \nclass=\"cabecalhoCardEquipamento\"><span class=\"md-headline\" layout-align=\"center center\" style=\"font-size: 20px\">\nEquipamento</span></md-card-title-text><div layout=\"row\" flex><div layout=\"row\" ng-show=\"vm.loadBaixa\" \nlayout-align=\"center center\" flex><div layout=\"column\" layout-align=\"center center\"><span class=\"font-weight-500\" \nstyle=\"font-size: 16px\">{{vm.mensagemPreloader}}</span><md-progress-circular md-mode=\"indeterminate\" md-diameter=\"100\" \nclass=\"md-accent\"></md-progress-circular></div></div></div><div style=\"height: 61.5vh; overflow: scroll\" \nlayout=\"column\" ng-if=\"!vm.loadBaixa\"><md-content><md-list flex><md-list-item class=\"md-3-line\" \nstyle=\"box-shadow: 10px 1px 0px lightgrey\"><div class=\"md-list-item-text descricaoCard\" layout=\"column\"><h4><strong>\nEquipamento</strong>: {{vm.resultado.equipamento.descricao}}</h4><h4><strong>IMEI</strong>: {{vm.resultado.imei}}</h4>\n<h4><strong>N° Série</strong>: {{vm.resultado.numeroSerie}}</h4></div></md-list-item></md-list><md-input-container \nclass=\"md-block select\" flex><label>Motivo baixa</label><md-select class=\"ms-select\" \nng-model=\"vm.baixa.equipamentoMotivoBaixaId\" name=\"select\" ng-change=\"vm.baixa.equipamentoMotivoBaixaId\" required>\n<md-option ng-value=\"item.id\" ng-repeat=\"item in vm.motivo\">{{item.descricao}}</md-option></md-select><div \nng-messages=\"!vm.modelDados && !vm.habilitarTodos && vm.obrigatorio \"><div \nng-show=\"vm.modelDados == null && !vm.habilitarTodos && vm.obrigatorio\">Campo obrigatório</div></div>\n</md-input-container><div layout-gt-xs=\"row\"><md-input-container class=\"md-block\" flex><label translate=\"Observação\">\n</label><textarea ng-model=\"vm.baixa.observacao\" name=\"assunto\" max-rows=\"5\" maxlength=\"100\" md-maxlength=\"100\">\n\r\n                               </textarea></md-input-container></div></md-content></div></md-card></div></div><div \nclass=\"botao-baixa\" ng-if=\"vm.mostrarCards\"><md-button class=\"md-raised md-accent btn-tamanho\" \nng-click=\"vm.metodos.salvarBaixa($event, vm.numeroSerieOuIMEI)\" \nng-disabled=\"vm.baixa.equipamentoMotivoBaixaId == null\">Baixar</md-button></div></div></div>");
$templateCache.put("app/main/locacao/processamento/revenda/views/revenda.html","<div id=\"revenda-equipamento\" class=\"page-layout simple tabbed\" layout=\"column\"><header-padrao \ntranslate-nome=\"Revenda\" liberar-pesquisa-quando-datatable-ativo=\"false\" ng-utiliza-pesquisa=\"false\" \npesquisar=\"vm.pesquisar\"></header-padrao><form name=\"vm.form\"><fieldset class=\"standard\"><legend class=\"grp-legend\" \ntranslate=\"Pesquisar por\"></legend><div layout=\"column\" flex=\"100\" layout-gt-sm=\"row\" class=\"div-pesquisa-fildset\"><div\n layout=\"column\" flex=\"100\" layout-gt-sm=\"row\"><md-input-container flex=\"6\" class=\"check-envio\"><md-radio-group \nng-model=\"vm.filtro.tipoPesquisaEnvio\" ng-change=\"vm.metodos.verificaEnvioClienteObrigatorio(vm.filtro)\" layout=\"row\">\n<md-radio-button value=\"1\">Locados</md-radio-button><md-radio-button value=\"2\">Situação</md-radio-button>\n</md-radio-group></md-input-container><md-input-container class=\"md-block equipamento-situacao\" flex-gt-sm=\"40\" \nng-if=\"vm.filtro.tipoPesquisaEnvio == 2\"><label>Situação</label><md-select name=\"situacao\" \nng-model=\"vm.filtro.codigoFiltro\" ng-required=\"vm.filtro.tipoPesquisaEnvio == 2\" \nng-disabled=\"vm.filtro.tipoPesquisaEnvio == 1 || !vm.filtro.tipoPesquisaEnvio\" multiple=\"multiple\"><md-option \nng-repeat=\"situacao in vm.situacoesFiltradas\" ng-value=\"situacao.id\">{{situacao.descricao}}</md-option></md-select><div\n ng-messages=\"vm.form.empresaAtivo.$error\"><div ng-message=\"required\" translate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\">\n</div></div></md-input-container><md-autocomplete ng-if=\"vm.filtro.tipoPesquisaEnvio == 1\" flex-gt-sm=\"40\" \nmd-input-name=\"cliente\" md-no-cache=\"true\" ng-model-options=\"{debounce: 200}\" md-selected-item=\"vm.filtro.item\" \nmd-search-text=\"vm.textoDePesquisaAutoCompleteCliente\" \nmd-items=\"item in vm.metodos.pesquisarAutoCompleteCliente(vm.textoDePesquisaAutoCompleteCliente)\" \nmd-item-text=\"item.nome\" md-autoselect md-floating-label=\"Cliente\" \nng-required=\"vm.clienteObrigatorio || vm.filtro.tipoPesquisaEnvio == 1\" \nng-disabled=\"vm.filtro.tipoPesquisaEnvio == 2 || !vm.filtro.tipoPesquisaEnvio\"><md-item-template><span \nmd-highlight-text=\"vm.textoDePesquisaAutoCompleteCliente\">{{item.nome}}</span></md-item-template><md-not-found><label>\nNão foi encontrado nenhum Cliente.</label></md-not-found></md-autocomplete></div><md-button layout-align=\"end end\" \nid=\"botaoPesquisarLocacoes\" class=\"md-raised md-accent btn-pesquisa\" \nng-click=\"vm.metodos.pesquisarEquipamentos($event, vm.filtro)\" \nng-disabled=\"vm.form.$invalid || vm.form.$pristine || vm.pesquisando || !vm.filtro.tipoPesquisaEnvio\">Pesquisar\n</md-button></div></fieldset></form><div layout=\"row\" class=\"mb-10 load\" ng-show=\"vm.pesquisando\" flex><div \nlayout=\"row\" layout-align=\"center center\" flex><div layout=\"column\" layout-align=\"center center\" class=\"mt-100\"><span \nclass=\"font-weight-500\" style=\"font-size: 16px\">{{vm.mensagemPreloader}}</span><md-progress-circular \nmd-mode=\"indeterminate\" md-diameter=\"100\" class=\"md-accent\"></md-progress-circular></div></div></div><div \nclass=\"div-cards-formulario\" layout=\"column\" layout-gt-sm=\"row\"><div layout-align=\"center center\" layout=\"column\" \nlayout-gt-sm=\"row\" class=\"div-equipamentos\" \nng-show=\"vm.equipamentosDispoiniveisOriginais.length > 0 && !vm.pesquisando\"><div flex flex-gt-sm=\"50\"><md-card flex \nlayout=\"column\" class=\"div-disponiveis-filho-1\"><md-card-title-text class=\"cabecalho-equipamentos\"><span \nclass=\"md-headline\" layout-align=\"center center\" class=\"texto-cabecalho-equipamentos\">\nDisponíveis - Total: {{vm.equipamentosDispoiniveis.length}}</span></md-card-title-text><div class=\"shortcut-loader\" \nlayout=\"row\" layout-align=\"center center\" ng-if=\"vm.requisicaoSolicitada || vm.filtrando\"><md-progress-circular \nclass=\"md-accent\" md-diameter=\"20\" md-mode=\"indeterminate\"></md-progress-circular></div><div \nng-if=\"!vm.requisicaoSolicitada && !vm.filtrando\" flex layout=\"row\" class=\"campo-pesquisa-cabecalho\">\n<md-input-container class=\"md-block m-0\" md-no-float flex><input ng-model=\"vm.pesquisa\" class=\"input-selecao\" \nname=\"pesquisa\" placeholder=\"Pesquisar\" id=\"inputPesquisa\" ng-change=\"vm.metodos.teclaEnter()\"></md-input-container>\n<md-button class=\"md-icon-button\" ng-click=\"vm.metodos.limparInputDisponiveis()\" flex=\"15\"><i \nclass=\"icon-filter-remove s24 icone-cor-padrao\"></i><md-tooltip><span>Limpar filtro</span></md-tooltip></md-button>\n</div><div class=\"div-itens\" ng-if=\"!vm.requisicaoSolicitada || $index <=0\"><div style=\"text-align: center\"><span \nlayout-align=\"center center\" ng-if=\"vm.equipamentosDispoiniveis.length <= 0 || filtrados.length <= 0\">Sem Registros.\n</span></div><md-content ng-if=\"vm.equipamentosDispoiniveis.length > 0\"><md-list flex><div flex \nstyle=\"box-shadow: 10px 1px 0px lightgrey\" ng-if=\"filtrados.length > 0\"><md-checkbox ng-model=\"vm.marcarTodos\" \nstyle=\"margin-left: 27px\" ng-change=\"vm.metodos.marcarTodosDisponiveis(vm.marcarTodos)\"><span \nstyle=\"margin-left: 22px\">Marcar todos</span></md-checkbox></div><md-list-item class=\"md-3-line espacamento p-8\" \nng-class=\"{\'zebra\' : $index %2 == 0}\" \nng-repeat=\"item in vm.equipamentosDispoiniveis | orderBy: \'item.equipamentoDescricao\' | filter:vm.pesquisa as filtrados track by $index\">\n<md-checkbox ng-model=\"item.marcado\" class=\"mr-10\"></md-checkbox><div class=\"md-list-item-text\" layout=\"column\" \nng-if=\"filtrados.length > 0\"><h4><strong>N° Série: </strong>{{item.numeroSerie}}</h4><h4><strong>N° IMEI: </strong>\n{{item.numeroImei}}</h4><h4><strong>Equipamento: </strong>{{item.equipamentoDescricao}}</h4></div></md-list-item><div \nng-if=\"filtrados.length <= 0\" style=\"text-align: center\"><span layout-align=\"center center\">Sem Registros.</span></div>\n</md-list></md-content></div></md-card></div><div layout=\"column\"><md-button \nng-disabled=\"vm.equipamentosDispoiniveis.length <= 0 || vm.pesquisando\" ng-click=\"vm.metodos.passarParaRevenda()\" \nlayout-align=\"end end\" class=\"md-fab md-accent md-icon-button\"><md-icon md-font-icon=\"icon-arrow-right s30\"></md-icon>\n</md-button><md-button ng-disabled=\"vm.equipamentosParaRevenda.length <= 0 || vm.pesquisando\" \nng-click=\"vm.metodos.passarParaDisponiveis()\" layout-align=\"end end\" class=\"md-fab md-accent md-icon-button btn-left\">\n<md-icon md-font-icon=\"icon-arrow-left s30\"></md-icon></md-button></div><div flex flex-gt-sm=\"60\" class=\"div-revenda\">\n<md-card flex layout=\"column\" class=\"div-disponiveis-filho-1\"><md-card-title-text class=\"cabecalho-equipamentos\"><span \nclass=\"md-headline\" layout-align=\"center center\" class=\"texto-cabecalho-equipamentos\">\nRevenda - Total: {{vm.equipamentosParaRevenda.length}}</span></md-card-title-text><div class=\"shortcut-loader\" \nlayout=\"row\" layout-align=\"center center\" ng-if=\"vm.requisicaoSolicitada || vm.filtrando\"><md-progress-circular \nclass=\"md-accent\" md-diameter=\"20\" md-mode=\"indeterminate\"></md-progress-circular></div><div \nng-if=\"!vm.requisicaoSolicitada && !vm.filtrando\" flex layout=\"row\" class=\"campo-pesquisa-cabecalho\">\n<md-input-container class=\"md-block m-0\" md-no-float flex><input ng-model=\"vm.pesquisaRevenda\" class=\"input-selecao\" \nname=\"pesquisa\" placeholder=\"Pesquisar\" id=\"inputPesquisaRevenda\" , ng-change=\"vm.metodos.teclaEnterRevenda()\">\n</md-input-container><md-button class=\"md-icon-button\" ng-click=\"vm.metodos.limparInputRevenda()\" flex=\"15\"><i \nclass=\"icon-filter-remove s24 icone-cor-padrao\"></i><md-tooltip><span>Limpar filtro</span></md-tooltip></md-button>\n</div><div class=\"div-itens\" ng-if=\"!vm.requisicaoSolicitada\"><div style=\"text-align: center\"><span \nlayout-align=\"center center\" ng-if=\"vm.equipamentosParaRevenda.length <= 0 || filtradosRevenda.length <= 0\">\nSem Registros.</span></div><md-content ng-if=\"vm.equipamentosParaRevenda.length > 0\"><md-list flex><div flex \nstyle=\"box-shadow: 10px 1px 0px lightgrey\" ng-if=\"filtradosRevenda.length > 0\"><md-checkbox \nng-model=\"vm.marcarTodosRevenda\" style=\"margin-left: 27px\" \nng-change=\"vm.metodos.marcarTodosRevenda(vm.marcarTodosRevenda)\"><span style=\"margin-left: 22px\">Marcar todos</span>\n</md-checkbox></div><md-list-item class=\"md-3-line espacamento p-8\" ng-class=\"{\'zebra\' : $index %2 == 0}\" \nng-repeat=\"item in vm.equipamentosParaRevenda | orderBy: \'item.equipamentoDescricao\' | filter:vm.pesquisaRevenda as filtradosRevenda track by $index\">\n<md-checkbox ng-model=\"item.marcado\" class=\"mr-10\" ng-click=\"vm.metodos.pesquisarItensNota(item,$index)\"></md-checkbox>\n<div class=\"md-list-item-text\" layout=\"column\"><h4><strong>N° Série: </strong>{{item.numeroSerie}}</h4><h4><strong>\nN° IMEI: </strong>{{item.numeroImei}}</h4><h4><strong>Equipamento: </strong>{{item.equipamentoDescricao}}</h4></div>\n</md-list-item><div ng-if=\"filtradosRevenda.length <= 0\" style=\"text-align: center\"><span layout-align=\"center center\">\nSem Registros.</span></div></md-list></md-content></div></md-card></div></div><form name=\"vm.formDetalhe\" \nclass=\"div-form-revenda\"><div class=\"div-detalhes\"><fieldset class=\"detalhes\" \nng-show=\"vm.equipamentosDispoiniveisOriginais.length > 0 && !vm.pesquisando\"><legend class=\"grp-legend\" \ntranslate=\"Revenda detalhes\"></legend><div layout=\"row\" class=\"div-cliente-detalhe\"><md-autocomplete flex-gt-sm=\"95\" \nflex-gt-xs md-input-name=\"cliente\" md-no-cache=\"true\" ng-model-options=\"{debounce: 200}\" \nmd-selected-item=\"vm.filtro.clienteDetalhe\" \nmd-selected-item-change=\"vm.metodos.alterarItemSelecionadoAutoCompleteCliente(item)\" \nmd-search-text=\"vm.textoDePesquisaAutoCompleteClienteDetalhe\" \nmd-items=\"item in vm.metodos.pesquisarAutoCompleteClienteDetalhe(vm.textoDePesquisaAutoCompleteClienteDetalhe)\" \nmd-item-text=\"item.nome\" md-autoselect md-floating-label=\"Cliente\" ng-required=\"true\" \nng-disabled=\"vm.equipamentosParaRevenda.length <= 0\"><md-item-template><span \nmd-highlight-text=\"vm.textoDePesquisaAutoCompleteClienteDetalhe\">{{item.nome}}</span></md-item-template><md-not-found>\n<label>Não foi encontrado nenhum Cliente.</label></md-not-found></md-autocomplete></div><div layout=\"row\" \nclass=\"div-detalhe-atendimento\"><md-input-container class=\"md-block equipamento-atendimento\" flex-gt-sm=\"95\"><label>\nAtendimento</label><md-select name=\"atendimento\" ng-model=\"vm.filtro.atendimentoCodigo\" \nng-disabled=\"vm.equipamentosParaRevenda.length <= 0\" \nng-required=\"vm.atendimentoObrigatorio || vm.filtro.clienteDetalhe\"><md-option \nng-repeat=\"atendimento in vm.atendimentos\" ng-value=\"atendimento.codigo\">{{atendimento.assunto}}</md-option>\n</md-select><div ng-messages=\"vm.form.empresaAtivo.$error\"><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container></div><div layout=\"row\" \nclass=\"detalhe-notafiscal-garantia\"><md-input-container class=\"md-block equipamento-atendimento\" flex-gt-sm=\"70\">\n<label>Nota fiscal</label><input ng-model=\"vm.filtro.notaFiscal\" class=\"input-selecao\" name=\"notaFiscal\" \nmaxlength=\"10\" md-maxlength=\"10\" ng-disabled=\"vm.equipamentosParaRevenda.length <= 0\"></md-input-container>\n<md-input-container class=\"md-block margem-cell\" flex-gt-sm=\"30\"><label>Garantia</label><input name=\"periodoGarantia\" \ntype=\"text\" ng-model=\"vm.filtro.periodoGarantia\" mascara-numero-generica=\"#####\" \nng-disabled=\"vm.equipamentosParaRevenda.length <= 0\"></md-input-container></div><div layout=\"row\" class=\"div-btn-data\">\n<md-input-container flex=\"60\"><label>Data</label><md-datepicker ng-model=\"vm.filtro.dataRevenda\" name=\"envioData\" \nng-mask=\"3?9/1?9/9999\" ng-required=\"true\" ng-disabled=\"vm.equipamentosParaRevenda.length <= 0\" \nmd-max-date=\"vm.metodos.verificarDataMaiorQueAtual(vm.filtro.dataRevenda)\"></md-datepicker><div \nng-if=\"vm.habilitarBtnSalvarRevenda\"><span style=\"font-size: small; color: red\">Data maior que a atual.</span></div>\n</md-input-container><div class=\"btn-salvar\" flex=\"40\"><md-button class=\"md-raised md-accent btn-pesquisa\" \nng-click=\"vm.metodos.criarRevenda($event, vm.filtro)\" \nng-disabled=\"vm.formDetalhe.$invalid || vm.formDetalhe.$pristine || vm.equipamentosParaRevenda.length <= 0 || vm.habilitarBtnSalvarRevenda\">\nSalvar</md-button></div></div></fieldset></div></form></div></div>");
$templateCache.put("app/main/locacao/processamento/nota/views/nota.html","<div id=\"NF\" class=\"page-layout simple tabbed\" layout=\"column\"><header-padrao translate-nome=\"Nota Fiscal\" \nliberar-pesquisa-quando-datatable-ativo=\"false\" ng-utiliza-pesquisa=\"false\" pesquisar=\"vm.pesquisar\"></header-padrao>\n<div layout=\"row\" class=\"mb-10\" ng-if=\"vm.requisicaoSolicitada && !vm.transicao\" flex><div layout=\"row\" \nlayout-align=\"center center\" flex><div layout=\"column\" layout-align=\"center center\" class=\"mt-50\"><span \nclass=\"font-weight-500\" style=\"font-size: 16px\">Carregando</span><md-progress-circular md-mode=\"indeterminate\" \nmd-diameter=\"100\" class=\"md-accent\"></md-progress-circular></div></div></div><div flex layout=\"column\" \nlayout-align=\"column\" layout-gt-sm=\"row\" class=\"divPai\" style=\"height: 100%\" id=\"Nota\" \nng-if=\"!vm.requisicaoSolicitada\"><div class=\"icone\" layout=\"column\" ng-if=\"vm.transicao\" flex=\"100\"><i \nclass=\"icon-clipboard-text s100\" layout-align=\"center center\" style=\"color: lightgray; align-self: center\"></i><h3 \nstyle=\"align-self: center;\r\n    color: lightslategrey\">Notas Fiscais</h3><md-button \nclass=\"md-raised-button botao-cadastro\" layout-align=\"center center\" ng-click=\"vm.metodos.cadastro()\">Cadastrar\n</md-button></div><div flex flex-gt-sm=\"40\" class=\"mt-10\" ng-show=\"!vm.transicao\" \nstyle=\"height: 71vh; position: relative\"><md-card flex layout=\"column\" style=\"height: 90%\"><md-card-title-text><span \nclass=\"md-headline\" layout-align=\"center center\">Nota</span></md-card-title-text><div style=\"height: 100%\" \nclass=\"scroll-nota\"><div flex><md-content><md-list flex><md-list-item class=\"md-3-line espacamento\" \nng-class=\"{\'selecionado\': vm.clicado == item.id,\'zebra\' : $index %2 == 0}\" \nng-repeat=\"item in vm.notas | orderBy:\'id\' :true\" ng-click=\"vm.metodos.pesquisarItensNota(item,$index)\"><div \nclass=\"md-list-item-text\" layout=\"column\"><h4><strong>N°</strong>: {{ item.numeroNota }} - <strong>Valor</strong>\n:{{item.valorTotalNota | currency:\"R$\":2}}</h4><h4><strong>Vencimento</strong>\n: {{ item.dataVencimento | date:\'dd/MM/yyyy\' }}</h4><h4><strong>Fornecedor</strong>\n: {{item.equipamentoFornecedorDescricao }}</h4><h4><strong>Empresa</strong>: {{item.empresaAtivoNome.slice(0,5)}} - \n<strong>Objetivo</strong>: {{item.objetivoNotaDescricao }}</h4></div><md-button class=\"md-secondary tamanho-botao\" \nng-click=\"vm.metodos.excluir(item,$index)\"><i class=\"icon-delete s16 icone-cor-padrao ml-1\"><md-tooltip><label>Deletar\n</label></md-tooltip></i></md-button><md-button class=\"md-secondary tamanho-botao\" \nng-click=\"vm.metodos.abrirDialogNotaEdicao($event, item,$index)\"><i class=\"icon-pencil s16 icone-cor-padrao ml-1\">\n<md-tooltip><label>Editar</label></md-tooltip></i></md-button><md-button class=\"md-secondary tamanho-botao\" \nng-click=\"vm.metodos.abrirDialogNotaVisualizacao($event, item)\"><i class=\"icon-open-in-new s16 icone-cor-padrao\">\n<md-tooltip><label>Visualizar</label></md-tooltip></i></md-button></md-list-item></md-list></md-content></div></div>\n<div class=\"conteudo\"><md-button class=\"add-event-button md-fab md-toolbar btn-flutuante\" \nng-click=\"vm.metodos.abrirDialogNota($event)\" aria-label=\"Inserir Histórico\"><md-icon md-font-icon=\"icon-plus\">\n</md-icon><md-tooltip><label>Adicionar nota</label></md-tooltip></md-button></div></md-card><div class=\"divTotal\"><p \nclass=\"total\">Total: {{vm.notas.length}}</p></div></div><div id=\"nota_item\" style=\"height: 71vh\" flex flex-gt-sm=\"30\" \nclass=\"mt-10\" ng-class=\"{\'card-Item\': vm.expandirItens}\" ng-show=\"vm.expandirItens && !vm.transicao\"><md-card flex \nlayout=\"column\" style=\"height: 90%\"><md-card-title-text><span class=\"md-headline\">Item</span> <i \nclass=\"icon-alert-circle s24\" style=\"color: yellow\" ng-if=\"vm.flagValor\"><md-tooltip>Valor da nota ainda não atingido.\n</md-tooltip></i></md-card-title-text><div class=\"shortcut-loader\" layout=\"row\" layout-align=\"center center\" \nng-if=\"vm.buscando\"><md-progress-circular class=\"md-accent\" md-diameter=\"20\" md-mode=\"indeterminate\">\n</md-progress-circular></div><div style=\"height: 100%; position: relative\" class=\"scroll-nota\" ng-if=\"!vm.buscando\">\n<div flex><md-content><md-list flex><md-list-item class=\"md-3-line\" \nng-repeat=\"item in vm.notaitens | orderBy:\'id\' :true\" \nng-class=\"{\'selecionado\': vm.itemClicado == item.id,\'zebra\' : $index %2 == 0}\" \nng-click=\"vm.metodosNotaItem.pesquisarDetalhesItensNota(item,$index)\"><div class=\"md-list-item-text\" layout=\"column\">\n<h4><strong>Equipamento</strong>: {{ item.equipamento.descricao }}</h4><h4><strong>Preço</strong>\n: {{ item.preco | currency:\"R$\":2 }}</h4><h4><strong>Quantidade</strong>: {{ item.quantidade }}</h4></div><md-button \nclass=\"md-secondary tamanho-botao\" ng-click=\"vm.metodosNotaItem.excluirItem(item)\"><i \nclass=\"icon-delete s16 icone-cor-padrao ml-1\"><md-tooltip><label>Deletar</label></md-tooltip></i></md-button><md-button\n class=\"md-secondary tamanho-botao\" ng-click=\"vm.metodosNotaItem.abrirDialogNotaItemEdicao($event,item,$index)\"><i \nclass=\"icon-pencil s16 icone-cor-padrao ml-1\"><md-tooltip><label>Editar</label></md-tooltip></i></md-button><md-button \nclass=\"md-secondary tamanho-botao\" ng-click=\"vm.metodosNotaItem.abrirDialogNotaItemVisualizacao($event, item)\"><i \nclass=\"icon-open-in-new s16 icone-cor-padrao\"><md-tooltip><label>Visualizar</label></md-tooltip></i></md-button>\n</md-list-item></md-list></md-content></div></div><div class=\"conteudo\"><md-button \nclass=\"add-event-button md-fab md-toolbar btn-flutuante\" ng-click=\"vm.metodosNotaItem.abrirDialogNotaItem($event)\" \naria-label=\"Inserir Histórico\"><md-icon md-font-icon=\"icon-plus\"></md-icon><md-tooltip><label>Adicionar item</label>\n</md-tooltip></md-button></div></md-card><div layout=\"row\" class=\"divValorTotal\"><p flex class=\"totalItem\">\nTotal: {{vm.notaitens.length}}</p><p flex class=\"totalValorItem\">Val. total: {{vm.precoTotalItens | currency:\"R$\":2}}\n</p></div></div><div flex flex-gt-sm=\"30\" style=\"height: 71vh\" class=\"mt-10\" \nng-class=\"{\'card-Item\': vm.expandirDetalhes}\" ng-show=\"vm.expandirDetalhes && !vm.transicao\"><md-card flex \nlayout=\"column\" style=\"height: 90%\"><md-card-title-text><span class=\"md-headline\">Equipamento</span> <i \nclass=\"icon-alert-circle s24\" style=\"color: yellow\" ng-if=\"vm.flagValorDetalhe\"><md-tooltip>\nValor/Quantidade do item ainda não atingido.</md-tooltip></i></md-card-title-text><div class=\"shortcut-loader\" \nlayout=\"row\" layout-align=\"center center\" ng-if=\"vm.buscandoDetalhe\"><md-progress-circular class=\"md-accent\" \nmd-diameter=\"20\" md-mode=\"indeterminate\"></md-progress-circular></div><div style=\"height: 100%; position: relative\" \nclass=\"scroll-nota\" ng-if=\"!vm.buscandoDetalhe\"><div flex><md-content><md-list flex><md-list-item class=\"md-3-line\" \nng-repeat=\"item in vm.notaitensDetalhes | orderBy:\'id\' :true\" ng-click=\"null\" ng-class=\"{\'zebra\' : $index %2 == 0}\">\n<div class=\"md-list-item-text\" layout=\"column\"><h4><strong>N° Série</strong>: {{item.numeroSerie}}</h4><h4><strong>\nPreço</strong>: {{item.precoUnitario | currency:\"R$\":2}}</h4><h4><strong>Situação</strong>\n: {{item.equipamentoSituacao.descricao}}</h4></div><md-button class=\"md-secondary tamanho-botao\" \nng-click=\"vm.metodosDetalhe.excluirDetalhe(item)\"><i class=\"icon-delete s16 icone-cor-padrao ml-1\"><md-tooltip><label>\nDeletar</label></md-tooltip></i></md-button><md-button class=\"md-secondary tamanho-botao\" \nng-click=\"vm.metodosDetalhe.abrirDialogDetalheEditar($event,item, $index)\"><i \nclass=\"icon-pencil s16 icone-cor-padrao ml-1\"><md-tooltip><label>Editar</label></md-tooltip></i></md-button><md-button \nclass=\"md-secondary tamanho-botao\" ng-click=\"vm.metodosDetalhe.abrirDialogDetalheVisualizacao($event,item)\"><i \nclass=\"icon-open-in-new s16 icone-cor-padrao\"><md-tooltip><label>Visualizar</label></md-tooltip></i></md-button>\n</md-list-item></md-list></md-content></div></div><div class=\"conteudo\"><md-button \nclass=\"add-event-button md-fab md-toolbar btn-flutuante\" ng-click=\"vm.metodosDetalhe.abrirDialogDetalhe($event)\" \naria-label=\"Inserir Histórico\"><md-icon md-font-icon=\"icon-plus\"></md-icon><md-tooltip><label>Adicionar equipamento\n</label></md-tooltip></md-button></div></md-card><div layout=\"row\" class=\"divValorTotalEquipamento\"><p flex \nclass=\"totalNotas\">Total: {{vm.notaitensDetalhes.length}}</p><p flex class=\"totalValor\">\nVal. total: {{vm.precoTotalItensDetalhe | currency:\"R$\":2}}</p></div></div><div class=\"button-float\"><md-button \nng-click=\"vm.toggleRight()\" ng-hide=\"vm.isOpenRight()\" class=\"md-primary button-toogle icon-filter-outline md-fab\" \naria-label=\"Gerar Backlog\"></md-button></div><md-sidenav class=\"md-sidenav-right md-whiteframe-4dp\" \nmd-component-id=\"right\"><md-toolbar style=\"background-color: #039BE5\"><h1 class=\"md-toolbar-tools\">Filtro</h1>\n</md-toolbar><md-content layout-padding flex><form name=\"vm.form.filtros\"><md-input-container flex-gt-sm=\"100\" \nclass=\"md-block\"><label>Numero Nota</label><input name=\"numero\" maxlength=\"10\" md-maxlength=\"10\" type=\"text\" \nng-model=\"vm.filtro.numeroNota\"></md-input-container><md-input-container flex-gt-sm=\"100\" class=\"md-block\"><label>\nFornecedor</label><md-select name=\"numeor\" ng-model=\"vm.filtro.fornecedorId\"><md-option \nng-repeat=\"fornecedor in vm.fornecedor\" ng-value=\"fornecedor.id\">{{ fornecedor.descricao }}</md-option></md-select>\n</md-input-container></form><div class=\"text-center\"><md-button ng-click=\"vm.metodos.filtrarNota(vm.filtro)\" \nstyle=\"background-color: #039BE5; color: white\" layout-align=\"center center\">Filtrar</md-button></div></md-content>\n</md-sidenav></div></div>");
$templateCache.put("app/main/locacao/processamento/troca-ativo/views/troca-ativo-form.html","<div id=\"troca-ativo-form\" class=\"etapa md-background-bg\"><form name=\"vm.form\" novalidate><div \nng-if=\"vm.etapa.estado == \'trocaEquipamento\'\" layout=\"row\" layout-align=\"center center\" flex><md-input-container \nclass=\"md-block empresa-ativo\" flex=\"35\"><label>Empresa ativo</label><md-select name=\"empresaAtivo\" \nng-model=\"vm.empresaAtivoId\" ng-required=\"true\"><md-option ng-repeat=\"empresa in vm.empresaAtivo\" \nng-value=\"empresa.id\">{{empresa.codigo}} - {{empresa.nome}}</md-option></md-select><div \nng-messages=\"vm.form.empresaAtivo.$error\"><div ng-message=\"required\" translate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\">\n</div></div></md-input-container><md-button ng-click=\"vm.metodos.pesquisar(vm.empresaAtivoId)\" \nclass=\"send-button md-accent md-raised botaoPesquisar\" aria-label=\"Pesquisar\" translate=\"Pesquisar\" \nng-disabled=\"vm.empresaAtivoId == 0 || vm.emProgresso\"></md-button></div><div layout=\"row\" ng-show=\"vm.emProgresso\" \nlayout-align=\"center center\" flex><div layout=\"column\" layout-align=\"center center\" class=\"mt-100\"><span \nclass=\"font-weight-500\" style=\"font-size: 16px\">{{vm.mensagemPreloader}}</span><md-progress-circular \nmd-mode=\"indeterminate\" md-diameter=\"100\" class=\"md-accent\"></md-progress-circular></div></div><div \nng-if=\"vm.etapa.estado == \'trocaEquipamento\' && vm.equipamentos.length > 0 && !vm.emProgresso\" \nng-include=\"vm.htmlRota.etapas.trocaEquipamento\"></div><div ng-if=\"vm.etapa.estado == \'notaFiscal\' && !vm.emProgresso\" \nng-include=\"vm.htmlRota.etapas.notaFiscal\"></div><div ng-if=\"vm.etapa.estado == \'resumoTroca\' && !vm.emProgresso\" \nng-include=\"vm.htmlRota.etapas.resumoTroca\"></div><div class=\"mt-10 mb-10\" \nng-if=\"vm.equipamentos.length > 0 && !vm.emProgresso\" layout=\"row\" layout-align=\"space-between center\" flex><md-button \nng-hide=\"vm.etapa.estado == \'trocaEquipamento\'\" ng-click=\"vm.metodos.voltarEtapa()\" layout-align=\"end end\" \nclass=\"md-fab md-accent md-icon-button\"><md-icon md-font-icon=\"icon-arrow-left s30\"></md-icon></md-button><md-button \nng-show=\"vm.etapa.estado == \'trocaEquipamento\'\"></md-button><md-button ng-if=\"vm.etapa.estado != \'resumoTroca\'\" \nng-disabled=\"vm.equipamentosTroca.length <= 0 || (vm.form.$invalid || vm.form.$pristine || vm.emProgresso)\" \nng-click=\"vm.metodos.proximaEtapa()\" layout-align=\"end end\" class=\"md-fab md-accent md-icon-button\"><md-icon \nmd-font-icon=\"icon-arrow-right s30\"></md-icon></md-button><md-button ng-if=\"vm.etapa.estado == \'resumoTroca\'\" \nng-disabled=\"vm.equipamentosTroca.length <= 0 || (vm.form.$invalid || vm.form.$pristine || vm.emProgresso)\" \nng-click=\"vm.metodos.salvarTroca()\" layout-align=\"end end\" class=\"md-fab md-accent md-icon-button\"><md-icon \nmd-font-icon=\"icon-content-save s30\"></md-icon></md-button></div></form></div>");
$templateCache.put("app/main/locacao/processamento/troca-ativo/views/troca-ativo.html","<div id=\"troca-ativo\" class=\"page-layout simple tabbed md-background-bg\" layout=\"column\"><header-padrao \ntranslate-nome=\"Troca de ativos {{ vm.etapa.descricao }}\" liberar-pesquisa-quando-datatable-ativo=\"false\" \nng-utiliza-pesquisa=\"false\" pesquisar=\"vm.pesquisar\"></header-padrao><div class=\"content\"><div \nui-view=\"troca-ativo-form\"></div></div></div>");
$templateCache.put("app/main/pipeline/processamento/pipeline-negocio/views/pipeline-negocio.html","<div id=\"pipeline-negocio\" class=\"page-layout simple fullwidth\" layout=\"column\"><div class=\"header md-accent-bg\" \nlayout=\"column\"><div class=\"header-content\" layout=\"row\" layout-wrap layout-align=\"space-between\" flex><div \nlayout=\"row\" layout-align=\"center center\" flex-order=\"1\" flex-order-xs=\"2\"><md-button \nclass=\"md-accent md-raised md-hue-2 header-boards-button\" ui-sref=\"app.pipeline_processamento_pipelinenegocio.funis()\" \naria-label=\"Voltar\" translate translate-attr-aria-label=\"PIPELINE_NEGOCIO.VOLTAR\"><md-icon \nmd-font-icon=\"icon-chevron-double-left\" class=\"icon\"></md-icon><span translate=\"PIPELINE_NEGOCIO.VOLTAR\"></span>\n</md-button></div><div class=\"header-board-name\" layout=\"row\" layout-align=\"center center\" flex-order=\"2\" \nflex-order-xs=\"1\" flex-xs=\"100\"><i ng-if=\"vm.board.settings.subscribed\" class=\"board-subscribe s16 icon-eye\"></i> <span\n style=\"font-size: 25px; font-weight: bold\">{{vm.descricaoFunil}}</span></div><div class=\"toolbar\" layout=\"row\" \nlayout-align=\"space-between center\" flex-order=\"3\"><div layout=\"row\" layout-align=\"center center\" flex-order=\"1\" \nflex-order-xs=\"2\"><md-button class=\"md-accent md-raised md-hue-2 header-boards-button\" \nng-click=\"vm.metodos.abrirDialogNegocio($event)\" aria-label=\"Adicionar negócio\" translate \ntranslate-attr-aria-label=\"PIPELINE_NEGOCIO.ADICIONAR_NEGOCIO\"><md-icon md-font-icon=\"icon-plus\" class=\"icon\">\n</md-icon><span translate=\"PIPELINE_NEGOCIO.ADICIONAR_NEGOCIO\"></span></md-button></div><md-button \nclass=\"md-icon-button\" ng-click=\"vm.metodos.toggleSidenav(\'filters-sidenav\')\" aria-label=\"Filtrar Cards\" translate \ntranslate-attr-aria-label=\"PIPELINE_NEGOCIO.FILTRAR_CARDS\"><md-icon md-font-icon=\"icon-filter-variant s26\" \nstyle=\"color: white !important\"></md-icon><md-tooltip><span translate=\"PIPELINE_NEGOCIO.FILTRAR_CARDS\">Filtrar Cards\n</span></md-tooltip></md-button><md-button ng-if=\"vm.metodosPipelineFactory.exibirButtonLimparFiltros()\" \nclass=\"md-icon-button\" ng-click=\"vm.metodosPipelineFactory.limparFiltrosCard()\" aria-label=\"Limpar Filtros\" translate \ntranslate-attr-aria-label=\"PIPELINE_NEGOCIO.LIMPAR_FILTROS\"><md-icon md-font-icon=\"icon-filter-remove s26\" \nstyle=\"color: white !important\"></md-icon><md-tooltip><span translate=\"PIPELINE_NEGOCIO.LIMPAR_FILTROS\">Limpar Filtros\n</span></md-tooltip></md-button></div></div></div><md-content class=\"content\" flex layout=\"column\" \nui-view=\"pipeline-negocios\"></md-content><md-sidenav class=\"filters-sidenav md-sidenav-right\" \nmd-component-id=\"filters-sidenav\" ng-controller=\"FiltrosNegocioSidenavController as vm\" ms-sidenav-helper \nng-include=\"\'app/main/pipeline/processamento/pipeline-negocio/views/pipeline-negocios/sidenavs/filtros/filtros-negocio-sidenav.html\'\">\n</md-sidenav></div>");
$templateCache.put("app/main/manutencao/cadastro/tipo-procedimento/views/tipo-procedimento-form.html","<div id=\"tipo-procedimento\" class=\"md-background-bg md-whiteframe-1dp\"><form name=\"vm.form\" novalidate><pg-toolbar \nentidades=\"vm.tipoProcedimentos\" entidade=\"vm.tipoProcedimento\" entidade-de-envio=\"vm.entidadeDeEnvio\" \ncontrolador-toolbar=\"vm.controleForm\" acao-pesquisar=\"vm.metodos.pesquisar()\" \nacao-criar=\"vm.metodos.salvar(vm.tipoProcedimento)\" acao-editar=\"vm.metodos.editar(vm.tipoProcedimento)\" \nacao-excluir=\"vm.metodos.excluir(vm.tipoProcedimento)\" construir-dt-options=\"vm.metodos.construirDtOptions()\" \nmetodos-externos=\"vm.metodosExternosPgToolbar\" campo-pesquisar=\"vm.pesquisar\"></pg-toolbar><md-content layout-padding \nng-hide=\"vm.controleForm.listarTodasEntidades\" ng-disabled=\"vm.controleForm.emProgresso\"><div class=\"form-container\" \nlayout=\"row\" layout-xs=\"column\"><div layout-gt-xs=\"row\" flex-gt-sm=\"50\"><md-input-container class=\"md-block\" \nflex-gt-sm=\"100\"><label translate=\"Descrição\"></label><input type=\"text\" ng-model=\"vm.tipoProcedimento.descricao\" \nname=\"descricao\" mascara-tamanho-campo=\"100\" ng-required=\"vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo\" \nmd-maxlength=\"100\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\"><div \nng-messages=\"vm.form.descricao.$error\"><div ng-message=\"required\" translate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\">\n</div></div></md-input-container></div><div><div layout=\"column\" layout-align=\"center center\" \nstyle=\"margin-left: 20px\" ng-cloak><div layout=\"column\" layout-align=\"center center\"><md-select \nplaceholder=\"Equipamento\" ng-model=\"vm.tipoProcedimento.equipamentoId\" style=\"min-width: 200px; margin: 0px 0 26px 0\" \nng-required=\"vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\" \nmd-on-open=\"vm.metodos.configuraMdSelectSolucao($event)\" md-on-close=\"vm.metodos.configuraMdSelectSolucao($event)\" \nrequired><md-select-header><input id=\"equipamento-form-solucao-md-select\" class=\"md-text\" \nng-model=\"vm.filtrarEquipamentos\" type=\"search\" placeholder=\"Pesquisar equipamento\" \ntranslate-attr-placeholder=\"Pesquisar equipamento\"></md-select-header><md-option ng-value=\"equipamento.id\" \nng-repeat=\"equipamento in vm.equipamentos | filter:vm.filtrarEquipamentos track by equipamento.id\">\n{{equipamento.descricao}}</md-option></md-select></div></div></div><div style=\"margin-left: -10px\"><md-checkbox \nng-model=\"vm.tipoProcedimento.obrigatorio\" style=\"margin-left: 27px\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\"><span>\nObrigatório</span></md-checkbox></div><div style=\"margin-left: -10px\"><md-checkbox \nng-model=\"vm.tipoProcedimento.necessitaPeca\" style=\"margin-left: 27px\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\"><span>\nNecessita peça</span></md-checkbox></div></div><div class=\"form-container\" layout=\"row\" layout-xs=\"column\"><div \nlayout-gt-xs=\"row\" style=\"align-items: center; margin-left: -10px\"><div layout-gt-xs=\"row\" flex-gt-sm=\"35\">\n<md-input-container class=\"md-block\" flex-gt-sm=\"100\"><label translate=\"Tempo gasto (Hs)\"></label><input type=\"text\" \nng-model=\"vm.tipoProcedimento.tempoTecnicoMinutos\" name=\"tempoTecnicoMinutos\" mascara-tamanho-campo=\"5\" \nmascara-numero-generica=\"##:##\" ng-pattern=\"vm.regexHora\" \nng-required=\"vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\"><div \nng-messages=\"vm.form.tempoTecnicoMinutos.$error\"><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container></div><div layout-gt-xs=\"row\" \nflex-gt-sm=\"35\"><md-input-container class=\"md-block\" flex-gt-sm=\"100\"><label translate=\"Garantia (Dias)\"></label><input\n type=\"number\" ng-model=\"vm.tipoProcedimento.garantiaDias\" name=\"garantiaDias\" mascara-tamanho-campo=\"5\" \nng-required=\"vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\"><div \nng-messages=\"vm.form.garantiaDias.$error\"><div ng-message=\"required\" translate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\">\n</div></div></md-input-container></div><div layout-gt-xs=\"row\" flex-gt-sm=\"35\"><md-input-container class=\"md-block\" \nflex-gt-sm=\"100\"><label translate=\"Valor (R$)\"></label><input type=\"text\" \nng-model=\"vm.tipoProcedimento.valorProcedimento\" name=\"valorProcedimento\" mascara-tamanho-campo=\"12\" ui-money-mask \nng-required=\"vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\"><div \nng-messages=\"vm.form.valorProcedimento.$error\"><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container></div></div></div></md-content>\n</form></div>");
$templateCache.put("app/main/manutencao/cadastro/tipo-procedimento/views/tipo-procedimento-tabela.html","<div layout=\"column\" flex><div class=\"md-padding md-background-bg md-whiteframe-1dp fullpage-datatable\" \nlayout=\"column\" flex><table class=\"dataTable row-border hover\" id=\"datatable-tipo-procedimento\" width=\"100%\"><thead>\n<tr><th>Ação</th><th>Descrição</th><th>Equipamento</th><th>Obrigatório</th><th>Necessita peça</th><th>Tempo gasto (Hs)\n</th><th>Garantia (dias)</th><th>Valor gasto (R$)</th></tr></thead></table></div></div>");
$templateCache.put("app/main/manutencao/cadastro/tipo-procedimento/views/tipo-procedimento.html","<div id=\"tipo-procedimento\" class=\"page-layout simple tabbed\" layout=\"column\"><header-padrao \ntranslate-nome=\"Tipo Procedimento\" ng-utiliza-pesquisa=\"false\" pesquisar=\"vm.pesquisar\"></header-padrao><div \nclass=\"content\"><div ui-view=\"tipo-procedimento-form\"></div></div><div ui-view=\"tipo-procedimento-tabela\" \nng-if=\"vm.controleForm.listarTodasEntidades\"></div></div>");
$templateCache.put("app/main/manutencao/cadastro/margem/views/margem-form.html","<div class=\"md-background-bg md-whiteframe-1dp\"><form name=\"vm.form\" novalidate><pg-toolbar entidades=\"vm.margens\" \nentidade=\"vm.manutencao\" entidade-de-envio=\"vm.entidadeDeEnvio\" controlador-toolbar=\"vm.controleForm\" \nacao-pesquisar=\"vm.metodos.pesquisar()\" acao-criar=\"vm.metodos.salvar(vm.manutencao)\" \nacao-editar=\"vm.metodos.editar(vm.manutencao)\" acao-excluir=\"vm.metodos.excluir(vm.manutencao)\" \nconstruir-dt-options=\"vm.metodos.construirDtOptions()\" metodos-externos=\"vm.metodosExternosPgToolbar\" \ncampo-pesquisar=\"vm.pesquisar\"></pg-toolbar><md-content layout-padding ng-hide=\"vm.controleForm.listarTodasEntidades\" \nng-disabled=\"vm.controleForm.emProgresso\"><div class=\"form-container\"><div layout-gt-xs=\"row\"><md-input-container \nclass=\"md-block\" flex-gt-sm=\"30\" flex><label translate=\"Margem (%)\"></label><input type=\"text\" \nng-model=\"vm.manutencao.margem\" name=\"manutencao\" max=\"1\" \nng-required=\"vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo\" ui-percentage-mask \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\" \nmascara-tamanho-campo=\"6\"><div ng-messages=\"vm.form.manutencao.$error\"><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div><div ng-message=\"max\" \ntranslate=\"Valor do campo não pode ser superior a 100%\"></div></div></md-input-container></div></div></md-content>\n</form></div>");
$templateCache.put("app/main/manutencao/cadastro/margem/views/margem-tabela.html","<div layout=\"column\" flex><div class=\"md-padding md-background-bg md-whiteframe-1dp fullpage-datatable\" \nlayout=\"column\" flex><table class=\"dataTable row-border hover\" id=\"datatable-margem\" width=\"100%\"><thead><tr><th>Ação\n</th><th>Margem</th></tr></thead></table></div></div>");
$templateCache.put("app/main/manutencao/cadastro/margem/views/margem.html","<div id=\"margem\" class=\"page-layout simple tabbed\" layout=\"column\"><header-padrao translate-nome=\"Margem\" \nng-utiliza-pesquisa=\"false\" pesquisar=\"vm.pesquisar\"></header-padrao><div class=\"content\"><div ui-view=\"margem-form\">\n</div></div><div ui-view=\"margem-tabela\" ng-if=\"vm.controleForm.listarTodasEntidades\"></div></div>");
$templateCache.put("app/main/pipeline/processamento/pipeline-negocios-ganhos-perdidos/views/pipeline-negocios-ganhos-perdidos.html","<div layout=\"column\" flex><header-padrao \ntranslate-nome=\"PIPELINE_NEGOCIOS_GANHOS_OU_PERDIDOS.NEGOCIOS_GANHOUS_OU_PERDIDOS\" icone=\"icon-clipboard-text\" \nliberar-pesquisa-quando-datatable-ativo=\"true\" pesquisar=\"vm.pesquisar\"></header-padrao><div layout=\"column\" flex><div \nclass=\"md-padding md-background-bg md-whiteframe-1dp fullpage-datatable\" layout=\"column\" flex><table \nclass=\"dataTable row-border hover\" id=\"datatable-pipeline-negocios-ganhos-perdidos\" width=\"100%\"><thead><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Ação</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Negócio</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Etapa</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Cliente</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Data Inicial</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Data Final</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Valor</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Outros Valores</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Funil</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Status</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Atendimento</span></div></th></thead>\n</table></div></div></div>");
$templateCache.put("app/main/pipeline/processamento/pipeline-negocios-vencidos-executivo-responsavel/views/pipeline-negocios-vencidos-executivo-responsavel.html","<div layout=\"column\" flex><header-padrao \ntranslate-nome=\"PIPELINE_NEGOCIO_VENCIDOS_EXECUTIVO_RESPONSAVEL.PIPELINE_NEGOCIO_VENCIDOS_EXECUTIVO_RESPONSAVEL\" \nicone=\"icon-clipboard-text\" liberar-pesquisa-quando-datatable-ativo=\"true\" pesquisar=\"vm.pesquisar\"></header-padrao>\n<div class=\"md-background-bg md-whiteframe-1dp fullpage-datatable\" layout=\"column\" flex><table \nclass=\"dataTable row-border hover md-background-bg md-whiteframe-1dp\" datatable=\"ng\" dt-options=\"vm.dtOptions\" \nwidth=\"100%\" flex><thead><tr><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Ação\n</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Etapa</span></div>\n</th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Cliente</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Data Inicial</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Data Final</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Valor</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Outros Valores</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Atendimentos</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Funil</span></div></th></tr></thead><tbody>\n<tr ng-repeat=\"negocio in vm.negociosVencidos track by $index\"><td><i class=\"icon-pencil s16 icone-cor-padrao\" \nng-click=\"vm.metodos.abrirDialogNegocio($event, negocio)\"></i></td><td>\n{{negocio.descricaoNivelEtapa}} - {{negocio.descricaoEtapa}}</td><td>{{negocio.nomeCliente}}</td><td>\n{{negocio.dataInicial | date:\'dd/MM/yyyy\'}}</td><td>{{negocio.dataFinalEtapa | date:\'dd/MM/yyyy\'}}</td><td>\n{{negocio.valor | currency:\"R$ \"}}</td><td>{{negocio.outrosValores | currency:\"R$ \"}}</td><td>\n{{negocio.codigoAtendimento}}/{{negocio.anoAtendimento}}</td><td>{{negocio.descricaoFunil}}</td></tr></tbody></table>\n</div></div>");
$templateCache.put("app/main/manutencao/cadastro/origem-peca/views/origem-peca-form.html","<div class=\"md-background-bg md-whiteframe-1dp\"><form name=\"vm.form\" novalidate><pg-toolbar entidades=\"vm.origemPecas\" \nentidade=\"vm.origemPeca\" entidade-de-envio=\"vm.entidadeDeEnvio\" controlador-toolbar=\"vm.controleForm\" \nacao-pesquisar=\"vm.metodos.pesquisar()\" acao-criar=\"vm.metodos.salvar(vm.origemPeca)\" \nacao-editar=\"vm.metodos.editar(vm.origemPeca)\" acao-excluir=\"vm.metodos.excluir(vm.origemPeca)\" \nconstruir-dt-options=\"vm.metodos.construirDtOptions()\" metodos-externos=\"vm.metodosExternosPgToolbar\" \ncampo-pesquisar=\"vm.pesquisar\" pre-definir-campos-para-insercao=\"vm.metodos.definirAtivo()\" \ndesabilitar-botao-listar-todas-entidades=\"true\" campo-pesquisar=\"vm.pesquisar\"></pg-toolbar><md-content layout-padding \nng-hide=\"vm.controleForm.listarTodasEntidades\" ng-disabled=\"vm.controleForm.emProgresso\"><div class=\"form-container\">\n<div layout-gt-xs=\"row\"><md-input-container class=\"md-block\" flex flex-gt-sm=\"80\"><label translate=\"Descrição\"></label>\n<input type=\"text\" ng-model=\"vm.origemPeca.descricao\" name=\"descricao\" mascara-tamanho-campo=\"100\" \nng-required=\"vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo\" md-maxlength=\"100\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\"><div \nng-messages=\"vm.form.descricao.$error\"><div ng-message=\"required\" translate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\">\n</div></div></md-input-container><md-input-container class=\"md-block\" flex><md-checkbox ng-model=\"vm.origemPeca.ativo\" \nname=\"ativo\" ng-disabled=\"!vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\"><span \nstyle=\"margin-left: 5px\">Ativo</span></md-checkbox></md-input-container></div><div layout-gt-xs=\"row\">\n<md-input-container class=\"md-block\" flex-gt-sm><label translate=\"Observação\"></label><textarea rows=\"2\" \nng-model=\"vm.origemPeca.observacao\" mascara-tamanho-campo=\"500\" \nng-disabled=\"!vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\" name=\"observacao\" md-maxlength=\"500\">\n</textarea></md-input-container></div></div></md-content></form></div>");
$templateCache.put("app/main/manutencao/cadastro/origem-peca/views/origem-peca-tabela.html","<div layout=\"column\" flex><div class=\"md-padding md-background-bg md-whiteframe-1dp fullpage-datatable\" \nlayout=\"column\" flex><table class=\"dataTable row-border hover\" id=\"datatable-origem-peca\" width=\"100%\"><thead><tr><th>\nAção</th><th>Descrição</th><th>Observação</th><th>Ativo</th></tr></thead></table></div></div>");
$templateCache.put("app/main/manutencao/cadastro/origem-peca/views/origem-peca.html","<div id=\"origem-peca\" class=\"page-layout simple tabbed\" layout=\"column\"><header-padrao translate-nome=\"Origem Peça\" \nng-utiliza-pesquisa=\"false\" pesquisar=\"vm.pesquisar\"></header-padrao><div class=\"content\"><div \nui-view=\"origem-peca-form\"></div></div><div ui-view=\"origem-peca-tabela\" ng-if=\"vm.controleForm.listarTodasEntidades\">\n</div></div>");
$templateCache.put("app/main/manutencao/cadastro/tipo-servico/views/tipo-servico-form.html","<div class=\"md-background-bg md-whiteframe-1dp\"><form name=\"vm.form\" novalidate><pg-toolbar \nentidades=\"vm.tipoServicos\" entidade=\"vm.tipoServico\" entidade-de-envio=\"vm.entidadeDeEnvio\" \ncontrolador-toolbar=\"vm.controleForm\" acao-pesquisar=\"vm.metodos.pesquisar()\" \nacao-criar=\"vm.metodos.salvar(vm.tipoServico)\" acao-editar=\"vm.metodos.editar(vm.tipoServico)\" \nacao-excluir=\"vm.metodos.excluir(vm.tipoServico)\" construir-dt-options=\"vm.metodos.construirDtOptions()\" \npre-definir-campos-para-insercao=\"vm.metodos.definirAtivo()\" metodos-externos=\"vm.metodosExternosPgToolbar\" \ndesabilitar-botao-listar-todas-entidades=\"true\" campo-pesquisar=\"vm.pesquisar\"></pg-toolbar><md-content layout-padding \nng-hide=\"vm.controleForm.listarTodasEntidades\" ng-disabled=\"vm.controleForm.emProgresso\"><div class=\"form-container\" \nlayout=\"column\"><div layout-gt-xs=\"row\"><md-input-container class=\"md-block\" flex-gt-sm=\"50\"><label \ntranslate=\"Descrição\"></label><input type=\"text\" ng-model=\"vm.tipoServico.descricao\" name=\"descricao\" \nmascara-tamanho-campo=\"100\" ng-required=\"vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo\" \nmd-maxlength=\"100\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\"><div \nng-messages=\"vm.form.descricao.$error\"><div ng-message=\"required\" translate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\">\n</div></div></md-input-container><div layout-gt-xs=\"row\" flex-gt-sm=\"50\" layout-align=\"space-around center\"><div>\n<md-checkbox ng-model=\"vm.tipoServico.faturar\" style=\"margin-left: 15px\" \nng-change=\"vm.metodos.onChangeFaturar(vm.tipoServico.faturar, vm.tipoServico.permiteObservacao)\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\"><span \nstyle=\"margin-left: 5px\">Faturar</span></md-checkbox></div><div><md-checkbox ng-model=\"vm.tipoServico.imprimir\" \nstyle=\"margin-left: 15px\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\"><span \nstyle=\"margin-left: 5px\">Imprimir</span></md-checkbox></div><div><md-checkbox ng-model=\"vm.tipoServico.enviarEmail\" \nstyle=\"margin-left: 15px\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\"><span \nstyle=\"margin-left: 5px\">Enviar E-mail</span></md-checkbox></div><div><md-checkbox \nng-model=\"vm.tipoServico.permiteObservacao\" style=\"margin-left: 15px\" \nng-disabled=\"(!vm.tipoServico.faturar || (vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo))\">\n<span style=\"margin-left: 5px\">Obrigar observação</span></md-checkbox></div></div></div><div layout-gt-xs=\"row\">\n<md-input-container class=\"md-block\" flex-gt-sm><label translate=\"Observação\"></label><textarea rows=\"2\" \nng-model=\"vm.tipoServico.observacao\" mascara-tamanho-campo=\"500\" \nng-disabled=\"!vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\" name=\"observacao\" md-maxlength=\"500\">\n</textarea></md-input-container></div></div></md-content></form></div>");
$templateCache.put("app/main/manutencao/cadastro/tipo-servico/views/tipo-servico-tabela.html","<div layout=\"column\" flex><div class=\"md-padding md-background-bg md-whiteframe-1dp fullpage-datatable\" \nlayout=\"column\" flex><table class=\"dataTable row-border hover\" id=\"datatable-tipo-servico\" width=\"100%\"><thead><tr><th>\nAção</th><th>Descrição</th><th>Observação</th><th>Faturar</th><th>Imprimir</th><th>Enviar e-mail</th></tr></thead>\n</table></div></div>");
$templateCache.put("app/main/manutencao/cadastro/tipo-servico/views/tipo-servico.html","<div id=\"tipo-servico\" class=\"page-layout simple tabbed\" layout=\"column\"><header-padrao translate-nome=\"Tipo Serviço\" \nng-utiliza-pesquisa=\"false\" pesquisar=\"vm.pesquisar\"></header-padrao><div class=\"content\"><div \nui-view=\"tipo-servico-form\"></div></div><div ui-view=\"tipo-servico-tabela\" \nng-if=\"vm.controleForm.listarTodasEntidades\"></div></div>");
$templateCache.put("app/main/manutencao/cadastro/tipo-envio/views/tipo-envio-form.html","<div class=\"md-background-bg md-whiteframe-1dp\"><form name=\"vm.form\" novalidate><pg-toolbar entidades=\"vm.tipoEnvios\" \nentidade=\"vm.tipoEnvio\" entidade-de-envio=\"vm.entidadeDeEnvio\" controlador-toolbar=\"vm.controleForm\" \nacao-pesquisar=\"vm.metodos.pesquisar()\" acao-criar=\"vm.metodos.salvar(vm.tipoEnvio)\" \nacao-editar=\"vm.metodos.editar(vm.tipoEnvio)\" acao-excluir=\"vm.metodos.excluir(vm.tipoEnvio)\" \nconstruir-dt-options=\"vm.metodos.construirDtOptions()\" metodos-externos=\"vm.metodosExternosPgToolbar\" \ncampo-pesquisar=\"vm.pesquisar\"></pg-toolbar><md-content layout-padding ng-hide=\"vm.controleForm.listarTodasEntidades\" \nng-disabled=\"vm.controleForm.emProgresso\"><div class=\"form-container\" layout=\"row\" layout-xs=\"column\"><div \nlayout-gt-xs=\"row\" flex-gt-sm=\"100\"><md-input-container class=\"md-block\" flex-gt-sm=\"85\"><label translate=\"Descrição\">\n</label><input type=\"text\" ng-model=\"vm.tipoEnvio.descricao\" name=\"descricao\" mascara-tamanho-campo=\"100\" \nng-required=\"vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo\" md-maxlength=\"100\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\"><div \nng-messages=\"vm.form.descricao.$error\"><div ng-message=\"required\" translate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\">\n</div></div></md-input-container><md-input-container class=\"md-block\" flex-gt-sm=\"15\"><md-checkbox \nng-model=\"vm.tipoEnvio.freteObrigatorio\" ng-true-value=\"1\" ng-false-value=\"0\" aria-label=\"Frete obrigatório\" \nname=\"freteObrigatorio\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\"><span \nclass=\"float-label-cor-default\" translate=\"Frete obrigatório\"></span></md-checkbox></md-input-container></div></div>\n</md-content></form></div>");
$templateCache.put("app/main/manutencao/cadastro/tipo-envio/views/tipo-envio-tabela.html","<div layout=\"column\" flex><div class=\"md-padding md-background-bg md-whiteframe-1dp fullpage-datatable\" \nlayout=\"column\" flex><table class=\"dataTable row-border hover\" id=\"datatable-tipo-envio\" width=\"100%\"><thead><tr><th>\nAção</th><th>Descrição</th></tr></thead></table></div></div>");
$templateCache.put("app/main/manutencao/cadastro/tipo-envio/views/tipo-envio.html","<div id=\"tipo-envio\" class=\"page-layout simple tabbed\" layout=\"column\"><header-padrao translate-nome=\"Tipo Envio\" \nng-utiliza-pesquisa=\"false\" pesquisar=\"vm.pesquisar\"></header-padrao><div class=\"content\"><div \nui-view=\"tipo-envio-form\"></div></div><div ui-view=\"tipo-envio-tabela\" ng-if=\"vm.controleForm.listarTodasEntidades\">\n</div></div>");
$templateCache.put("app/main/manutencao/consulta/ordem-servico/views/consulta-ordem-servico.html","<div id=\"consulta-ordem-servico\" class=\"page-layout carded fullwidth\" layout=\"row\"><div layout=\"column\" flex \nstyle=\"position: relative\"><header-padrao translate-nome=\"Consultar ordens de serviço\" icone=\"\" \nliberar-pesquisa-quando-datatable-ativo=\"true\" pesquisar=\"vm.pesquisar\"></header-padrao><md-content layout-gt-sm=\"row\" \nlayout-xs=\"column\" flex=\"100\" style=\"max-height: 195px\"><div layout=\"column\" layout-padding ng-hide=\"vm.filtroAtivo\" \nflex=\"30\"><div layout=\"row\" flex=\"100\" style=\"max-height: 40px\"><div class=\"md-subheader ml-5\" flex=\"70\"><label \ntranslate=\"Tipo filtro\"></label></div><div class=\"md-subheader mr-5\" flex=\"30\"><label translate=\"Legenda\"></label>\n</div></div><div layout=\"row\" flex=\"100\"><div layout=\"column\" flex=\"65\"><md-radio-group ng-model=\"vm.tipoFiltro\" \nng-change=\"vm.metodos.resetarFiltros()\" layout-gt-sm=\"column\" layout-xs=\"row\" style=\"padding-top: 0px\" layout-padding>\n<md-radio-button value=\"1\" aria-label=\"Período de abertura\" style=\"padding-top: 0px; padding-bottom: 0px\"><label \ntranslate=\"Período de abertura\"></label></md-radio-button><md-radio-button value=\"2\" aria-label=\"Período de execução\">\n<label translate=\"Período de execução\"></label></md-radio-button></md-radio-group></div><div layout=\"column\" flex=\"35\">\n<div class=\"mt-6\"><md-icon md-font-icon=\"icon-label\" class=\"s16 bt-legenda-branco\" ng-style=\"{\'color\' : \'#E6F0CD\'}\">\n</md-icon><span class=\"title\" translate=\"Aberta\">Aberta</span></div><div class=\"mt-6\"><md-icon \nmd-font-icon=\"icon-label\" class=\"s16\" ng-style=\"{\'color\' : \'#800080\'}\"></md-icon><span class=\"title\" \ntranslate=\"Em execução\">Em execução</span></div><div class=\"mt-6\"><md-icon md-font-icon=\"icon-label\" class=\"s16\" \nng-style=\"{\'color\' : \'#008000\'}\"></md-icon><span class=\"title\" translate=\"Executada\">Executadas</span></div><div \nclass=\"mt-6\"><md-icon md-font-icon=\"icon-label\" class=\"s16\" ng-style=\"{\'color\' : \'#FF0000\'}\"></md-icon><span \nclass=\"title\" translate=\"Cancelada\">Cancelada</span></div><div class=\"mt-6\"><md-icon md-font-icon=\"icon-label\" \nclass=\"s16\" ng-style=\"{\'color\' : \'#FF8000\'}\"></md-icon><span class=\"title\" translate=\"Reprovada\">Reprovada</span></div>\n</div></div></div><md-divider></md-divider><div layout=\"column\" layout-padding flex ng-hide=\"vm.filtroAtivo\"><div \nclass=\"periodo-consulta\" layout=\"row\" ng-if=\"vm.tipoFiltro == 2\"><div layout=\"row\" layout-align=\"start center\" \nclass=\"md-subheader\"><label translate=\"Período de execução\"></label><md-icon md-font-icon=\"icon-information-outline\" \nclass=\"cor-icone-padrao icone-informacao\"><md-tooltip md-autohide md-direction=\"right\"><span>\nO filtro de período de execução retorna apenas OS executadas.</span></md-tooltip></md-icon></div></div><div \nlayout=\"row\" ng-if=\"vm.tipoFiltro == 1\"><div layout=\"row\" layout-align=\"start center\" class=\"md-subheader\"><label \ntranslate=\"Período de abertura\"></label></div></div><div layout=\"column\"><div flex=\"100\" layout=\"row\"><div \nlayout=\"row\" layout-align=\"start start\" ng-if=\"vm.tipoFiltro == \'1\'\" flex=\"80\"><div layout-align=\"center center\" \nlayout=\"row\" style=\"margin-right: 5px\"><label>Inicial</label><md-datepicker ng-model=\"vm.consulta.dataInicial\" \nname=\"dataInicial\" ng-mask=\"3?9/1?9/9999\" md-max-date=\"vm.consulta.dataFinal\" \nng-change=\"vm.metodos.validarFiltro(vm.consulta)\"></md-datepicker></div><div layout-align=\"center center\" layout=\"row\">\n<label>Final</label><md-datepicker ng-model=\"vm.consulta.dataFinal\" name=\"dataFinal\" ng-mask=\"3?9/1?9/9999\" \nmd-min-date=\"vm.consulta.dataInicial\" ng-change=\"vm.metodos.validarFiltro(vm.consulta)\"></md-datepicker></div>\n<md-input-container class=\"md-block filtro-status\" flex=\"30\"><md-select aria-label=\"Filtros\" \nng-model=\"vm.consulta.statusOS\" name=\"Filtros\" multiple=\"multiple\" placeholder=\"Filtros\"><md-option \nng-value=\"filtro.codigo\" ng-repeat=\"filtro in vm.fases\">{{filtro.descricao}}</md-option></md-select>\n</md-input-container></div><div layout=\"row\" layout-align=\"start start\" ng-if=\"vm.tipoFiltro == \'2\'\" flex=\"80\"><div \nlayout-align=\"center center\" layout=\"row\" style=\"margin-right: 5px\"><label>Inicial</label><md-datepicker \nng-model=\"vm.consulta.dataInicial\" name=\"dataInicial\" ng-mask=\"3?9/1?9/9999\" md-max-date=\"vm.consulta.dataFinal\" \nng-change=\"vm.metodos.validarFiltro(vm.consulta)\"></md-datepicker></div><div layout-align=\"center center\" layout=\"row\">\n<label>Final</label><md-datepicker ng-model=\"vm.consulta.dataFinal\" name=\"dataFinal\" ng-mask=\"3?9/1?9/9999\" \nmd-min-date=\"vm.consulta.dataInicial\" ng-change=\"vm.metodos.validarFiltro(vm.consulta)\"></md-datepicker></div></div>\n<div layout=\"row\" layout-align=\"center center\" flex><md-button class=\"md-raised md-accent\" aria-label=\"Pesquisar\" \ntranslate translate-attr-aria-label=\"CONSULTAS_ESTORIAS.NOVA_CONSULTA\" \nng-disabled=\"vm.pesquisando || !vm.habilitarBotao\" ng-click=\"vm.metodos.listarOS(vm.consulta, vm.tipoFiltro, $event)\">\n<span translate=\"CONSULTAS_ESTORIAS.PESQUISAR\"></span></md-button></div></div><div flex=\"100\" layout=\"row\" \nclass=\"mt-10\"><md-autocomplete class=\"input-cliente\" md-input-name=\"cliente\" md-no-cache=\"true\" \nng-blur=\"vm.metodos.configuraAutoCompleteClienteOnBlur()\" md-selected-item=\"vm.consulta.cliente\" \nmd-selected-item-change=\"vm.metodos.alterarItemSelecionadoAutoCompleteCliente(item)\" \nmd-search-text=\"vm.textoDePesquisaAutoCompleteCliente\" \nmd-items=\"item in vm.metodos.pesquisarAutoCompleteCliente(vm.textoDePesquisaAutoCompleteCliente)\" \nmd-item-text=\"item.codigo + \' - \' + item.nome\" md-autoselect md-floating-label=\"Cliente\" flex=\"40\"><md-item-template>\n<span md-highlight-text=\"vm.textoDePesquisaAutoCompleteCliente\">{{item.codigo}} - {{item.nome}}</span>\n</md-item-template><md-not-found><label>Não foi encontrado nenhum Cliente.</label></md-not-found></md-autocomplete>\n<md-input-container class=\"md-block\" style=\"margin: 0px\" flex><label translate=\"Número série\"></label><input \ntype=\"text\" ng-model=\"vm.consulta.numeroSerie\" name=\"numeroSerie\"></md-input-container><md-input-container \nclass=\"md-block\" style=\"margin: 0px\" flex><label translate=\"IMEI\"></label><input type=\"text\" \nng-model=\"vm.consulta.imei\" name=\"imei\"></md-input-container></div></div></div></md-content><md-content><div \nlayout-align=\"start center\" layout=\"row\" ng-if=\"vm.filtroAtivo && !vm.requisicaoSolicitada\"><div layout=\"row\" \nlayout-align=\"start center\"><span class=\"ml-15 mr-5 text-uppercase\"><strong>Tipo Filtro</strong>: </span>\n{{vm.tipoFiltro | uppercase}}</div><div layout=\"row\" layout-align=\"start center\"><span \nclass=\"ml-10 mr-5 text-uppercase\"><strong>Filtro(s)</strong>: </span>{{vm.filtroUtilizado | uppercase}}</div></div>\n</md-content><md-divider></md-divider><div layout=\"row\" class=\"mb-10 load\" ng-show=\"vm.pesquisando\" flex><div \nlayout=\"row\" layout-align=\"center center\" flex><div layout=\"column\" layout-align=\"center center\" class=\"mt-100\"><span \nclass=\"font-weight-500\" style=\"font-size: 16px\">{{vm.mensagemPreloader}}</span><md-progress-circular \nmd-mode=\"indeterminate\" md-diameter=\"100\" class=\"md-accent\"></md-progress-circular></div></div></div><div \nlayout=\"column\" flex ng-if=\"vm.mostrarTabela\"><div \nclass=\"md-padding md-background-bg md-whiteframe-1dp fullpage-datatable\" ms-scroll flex><table id=\"datatable-backlog\" \nclass=\"dataTable row-border hover\" datatable=\"ng\" dt-instance=\"vm.dtInstance\" dt-options=\"vm.dtOptionsOrdemServico\" \nwidth=\"100%\"><thead><tr><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">OS</span></div>\n</th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Atendimento</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Cliente</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Prioridade</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Data abertura</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Data exec. inicial</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Data exec. final</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Empresa ativo</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Tipo serviço</span></div></th><th></th>\n</tr></thead><tbody><tr ng-repeat=\"os in vm.ordensServicos\"><td class=\"border-left h3 text-center\" \nng-class=\"{\r\n                                    \'aberta\': os.status == 1,\r\n                                    \'status-em-execucao\' : os.status == 2,\r\n                                    \'executada\': os.status == 3,\r\n                                    \'cancelada\': os.status == 4,\r\n                                    \'reprovada\': os.status == 5\r\n                                }\">\n{{os.ordemServicoNumero}}/{{os.ordemServicoAno}}</td><td class=\"border-left h3 text-center\"><div layout=\"row\" \nstyle=\"align-items: center\"><div ng-if=\"os.atendimentoId > 0\">{{os.atendimentoId}}/{{os.atendimentoAno}}</div><div \nng-if=\"os.atendimentoId <= 0\"><p>O.S sem atendimento</p></div><div><md-button class=\"md-icon-button\" \nng-click=\"vm.metodos.abrirAtendimento($event, os)\" ng-if=\"os.atendimentoId > 0\"><i \nclass=\"icon-pencil s16 icone-cor-padrao\"></i><md-tooltip><span>Abrir Atendimento</span></md-tooltip></md-button></div>\n</div></td><td class=\"border-left h3 text-center\">{{os.clienteDescricao}}</td><td class=\"border-left h3 text-center\">\n{{os.prioridadeDescricao}}</td><td id=\"td-consultas-oss{{$index}}\" class=\"border-left h3 text-center\"><div><span \nstyle=\"display: none\">{{vm.metodos.converterParaDataFormatada(os.dataEntrada)}}</span> <span>\n{{vm.metodos.converterParaDataFormatada(os.dataEntrada) | date:\'dd/MM/yyyy\'}}</span></div></td><td \nid=\"td-consultas-oss{{$index}}\" class=\"border-left h3 text-center\"><div><span style=\"display: none\">\n{{vm.metodos.converterParaDataFormatada(os.dataExecucaoInicial)}}</span> <span>\n{{vm.metodos.converterParaDataFormatada(os.dataExecucaoInicial) | date:\'dd/MM/yyyy\'}}</span></div></td><td \nid=\"td-consultas-oss{{$index}}\" class=\"border-left h3 text-center\"><div><span style=\"display: none\">\n{{vm.metodos.converterParaDataFormatada(os.dataExecucaoFinal)}}</span> <span>\n{{vm.metodos.converterParaDataFormatada(os.dataExecucaoFinal) | date:\'dd/MM/yyyy\'}}</span></div></td><td \nid=\"td-consultas-oss{{$index}}\" class=\"border-left h3 text-center\"><div>{{os.empresaAtivoDescricao[0]}}</div></td><td \nid=\"td-consultas-oss{{$index}}\" class=\"border-left h3 text-center\"><div>{{os.tipoServicoDescricao}}</div></td><td \nclass=\"border-left\"><div layout-gt-xs=\"column\" layout-align=\"center center\" flex class=\"ml-10 div-botoes\"><div \nlayout=\"row\"><md-button class=\"md-icon-button md-avatar siglas\">\n{{os.reponsavelNome[0] + os.reponsavelNome[1] | uppercase}}<md-tooltip><span>Abertura: {{os.reponsavelNome}}</span>\n</md-tooltip></md-button><md-button class=\"md-icon-button siglas\">\n{{os.responsavelExecucaoNome[0] + os.responsavelExecucaoNome[1] | uppercase}}<md-tooltip><span>\nExecução: {{os.responsavelExecucaoNome}}</span></md-tooltip></md-button></div><div layout=\"row\" class=\"mt-10\">\n<md-button class=\"md-icon-button siglas margenBotaoPonto\" ng-click=\"vm.metodos.abrirDialogItens($event, os)\"><i \nclass=\"icon-briefcase-checked s16 icone-cor-padrao\" ng-click=\"\"></i><md-tooltip><span>Abrir dialog de itens</span>\n</md-tooltip></md-button><md-button class=\"md-icon-button siglas margenBotaoPonto\" \nng-click=\"vm.metodos.abrirOS($event, os)\"><i class=\"icon-pencil s16 icone-cor-padrao\" ng-click=\"\"></i><md-tooltip>\n<span>Abrir Ordem Serviço</span></md-tooltip></md-button></div></div></td></tr></tbody></table></div></div></div></div>");
$templateCache.put("app/main/manutencao/cadastro/prioridade/views/prioridade-form.html","<div id=\"prioridadeId\" class=\"md-background-bg md-whiteframe-1dp\"><form name=\"vm.form\" novalidate><pg-toolbar \nentidades=\"vm.prioridades\" entidade=\"vm.prioridade\" entidade-de-envio=\"vm.entidadeDeEnvio\" \ncontrolador-toolbar=\"vm.controleForm\" acao-pesquisar=\"vm.metodos.pesquisar()\" \nacao-criar=\"vm.metodos.salvar(vm.prioridade)\" acao-editar=\"vm.metodos.editar(vm.prioridade)\" \nacao-excluir=\"vm.metodos.excluir(vm.prioridade)\" construir-dt-options=\"vm.metodos.construirDtOptions()\" \nmetodos-externos=\"vm.metodosExternosPgToolbar\" campo-pesquisar=\"vm.pesquisar\"></pg-toolbar><md-content layout-padding \nng-hide=\"vm.controleForm.listarTodasEntidades\" ng-disabled=\"vm.controleForm.emProgresso\"><div class=\"form-container\" \nlayout=\"row\" layout-xs=\"column\"><div layout-gt-xs=\"row\" flex-gt-sm=\"60\"><md-input-container class=\"md-block\" \nflex-gt-sm=\"100\"><label translate=\"Descrição\"></label><input type=\"text\" ng-model=\"vm.prioridade.descricao\" \nname=\"descricao\" mascara-tamanho-campo=\"100\" ng-required=\"vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo\" \nmd-maxlength=\"100\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\"><div \nng-messages=\"vm.form.descricao.$error\"><div ng-message=\"required\" translate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\">\n</div></div></md-input-container></div><div layout-gt-xs=\"row\"><div><div layout=\"column\" layout-align=\"center center\" \nstyle=\"margin-left: 20px\" ng-cloak><div layout=\"column\" layout-align=\"center center\"><md-select placeholder=\"Cor\" \nng-model=\"vm.prioridade.cor\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\" \nstyle=\"min-width: 200px\"><md-option ng-value=\"cor.nome\" ng-repeat=\"cor in vm.cores\">{{cor.nome}}</md-option>\n</md-select></div></div></div><div layout-gt-xs=\"row\" flex-gt-sm=\"30\"><md-input-container class=\"md-block\" \nflex-gt-sm=\"100\"><label translate=\"Prazo (Dias)\"></label><input type=\"number\" ng-model=\"vm.prioridade.prazo\" \nname=\"prazo\" mascara-tamanho-campo=\"5\" ng-required=\"vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\"><div \nng-messages=\"vm.form.prazo.$error\"><div ng-message=\"required\" translate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div>\n</div></md-input-container></div></div></div></md-content></form></div>");
$templateCache.put("app/main/manutencao/cadastro/prioridade/views/prioridade-tabela.html","<div layout=\"column\" flex><div class=\"md-padding md-background-bg md-whiteframe-1dp fullpage-datatable\" \nlayout=\"column\" flex><table class=\"dataTable row-border hover\" id=\"datatable-prioridade\" width=\"100%\"><thead><tr><th>\nAção</th><th>Descrição</th><th>Cor</th><th>Dias</th></tr></thead></table></div></div>");
$templateCache.put("app/main/manutencao/cadastro/prioridade/views/prioridade.html","<div id=\"prioridade\" class=\"page-layout simple tabbed\" layout=\"column\"><header-padrao translate-nome=\"Prioridade\" \nng-utiliza-pesquisa=\"false\" pesquisar=\"vm.pesquisar\"></header-padrao><div class=\"content\"><div \nui-view=\"prioridade-form\"></div></div><div ui-view=\"prioridade-tabela\" ng-if=\"vm.controleForm.listarTodasEntidades\">\n</div></div>");
$templateCache.put("app/main/mensageiro/views/classic/detail/detail.html","<div class=\"loading-mensagems\" layout=\"column\" layout-align=\"center center\" ng-show=\"vm.carregandoHistorico\">\n<md-progress-circular class=\"md-accent\" md-mode=\"indeterminate\" md-diameter=\"64\"></md-progress-circular><div>\nCarregando conversa...</div></div><div ng-if=\"!vm.mensagemSelecionada\" class=\"no-mensagem-selected\" layout=\"column\" \nlayout-align=\"center center\" flex><md-icon md-font-icon=\"icon-email\" class=\"s120 grey-400-fg\"></md-icon><span \nclass=\"hint-text\" translate=\"MAIL.SELECT_MESSAGE_TO_READ\">Selecione uma mensagem para ler</span></div><div \nng-if=\"vm.mensagemSelecionada\" ng-hide=\"vm.carregandoHistorico\"><div \nng-repeat=\"resposta in vm.mensagemSelecionada.respostas\"><md-content class=\"resposta\" \nng-if=\"vm.metodos.verificaDataEnvioResposta(resposta.dataEnvio,vm.mensagemSelecionada.respostas.indexOf(resposta))\" \nlayout=\"row\" layout-align=\"center center\"><span>{{vm.dataResposta}}</span></md-content><md-card><md-card-title>\n<md-card-title-text><div layout=\"row\" layout-align=\"end end\"><div layout=\"column\" \nng-show=\"vm.metodos.verificaSeultimaResposta(resposta)\" layout-align=\"end end\"><div \nng-hide=\"vm.menuSelecionado == \'sent\' || vm.menuSelecionado == \'trash\'\" class=\"actions\" layout=\"row\" \nlayout-align=\"start center\"><md-button class=\"md-icon-button\" \nng-click=\"vm.metodos.marcarComoImportante(vm.mensagemSelecionada, $event)\" aria-label=\"Toggle starred\" translate \ntranslate-attr-aria-label=\"MAIL.TOGGLE_STARRED\"><md-icon ng-if=\"vm.mensagemSelecionada.importante\" \nmd-font-icon=\"icon-star\" class=\"amber-fg\"></md-icon><md-icon ng-if=\"!vm.mensagemSelecionada.importante\" \nmd-font-icon=\"icon-star-outline\"></md-icon><md-tooltip><span translate=\"MAIL.MARCAR_COMO_IMPORTANTE\"></span>\n</md-tooltip></md-button></div></div><div layout=\"column\" layout-align=\"start start\"><md-menu \nng-if=\"vm.menuSelecionado == \'inbox\'\"><md-button aria-label=\"More\" class=\"md-icon-button\" \nng-click=\"$mdOpenMenu($event)\" translate translate-aria-label=\"MAIL.MORE\"><md-icon md-font-icon=\"icon-dots-vertical\">\n</md-icon></md-button><md-menu-content width=\"3\"><md-menu-item><md-button aria-label=\"Reply\" \ntranslate-aria-label=\"MAIL.RESPONDER\" ng-click=\"vm.replyDialog($event,resposta)\"><md-icon md-font-icon=\"icon-reply\">\n</md-icon><span translate=\"MAIL.RESPONDER\">Responder</span></md-button></md-menu-item><md-menu-item><md-button \naria-label=\"forward\" translate-aria-label=\"MAIL.ENCAMINHAR\" ng-click=\"vm.forwardDialog($event,resposta)\"><md-icon \nmd-font-icon=\"icon-forward\"></md-icon><span translate=\"MAIL.ENCAMINHAR\">Emcaminhar</span></md-button></md-menu-item>\n</md-menu-content></md-menu></div></div><div class=\"mensagem-content\"><div class=\"info\" layout=\"row\" \nlayout-align=\"space-between start\"><div layout=\"column\" layout-align=\"start start\"><div layout=\"row\" \nlayout-align=\"start start\"><div><img ng-if=\"resposta.from.avatar\" alt=\"{{resposta.from.name}}\" \nng-src=\"{{resposta.from.avatar}}\" class=\"avatar\"><div ng-if=\"!resposta.from.avatar\" class=\"avatar\" \nms-random-class=\"vm.colors\">{{resposta.remetente[0]}}</div></div><div layout=\"column\" layout-align=\"start start\"><div \nclass=\"name\">{{resposta.remetente}}</div><div class=\"to\" layout=\"row\" layout-align=\"start center\"><div class=\"to-text\" \ntranslate=\"MAIL.INFO.TO\">to</div><div>{{vm.metodos.retornaDestinatariosDaMensagem(resposta,true)}}</div></div></div>\n</div><a class=\"toggle-details md-accent-color\" ng-hide=\"vm.selectedMailShowDetails\" \nng-click=\"vm.selectedMailShowDetails = !vm.selectedMailShowDetails\" translate=\"MAIL.SHOW_DETAILS\">Show Details </a><a \nclass=\"toggle-details md-accent-color\" ng-show=\"vm.selectedMailShowDetails\" \nng-click=\"vm.selectedMailShowDetails = !vm.selectedMailShowDetails\" translate=\"MAIL.HIDE_DETAILS\">Hide Details</a><div \nng-show=\"vm.selectedMailShowDetails\" class=\"details\" layout=\"row\" layout-align=\"start start\"><div layout=\"column\"><span\n class=\"title\" translate=\"MAIL.DETAILS.FROM\">De:</span> <span class=\"title\" translate=\"MAIL.DETAILS.DATE\">Data:</span> \n<span class=\"title\" translate=\"MAIL.DETAILS.TO\">Para:</span></div><div layout=\"column\"><span class=\"detail\">\n{{resposta.remetente}}</span> <span class=\"detail\">\n{{resposta.dataEnvioCompleta | date : \'dd/MM/yyyy | HH:mm\' : timezone}}</span> <span class=\"detail\">\n{{vm.metodos.retornaDestinatariosDaMensagem(resposta,false)}}</span></div></div></div></div></div><div \nclass=\"mensagem-header\" layout=\"row\" layout-align=\"space-between center\"><div><p class=\"subject\"><span \nng-if=\"resposta.mensagemIdentificadorOrigem\">RE: </span>{{resposta.assunto}}</p><div class=\"labels\"><div class=\"label\" \nng-repeat=\"labelId in vm.mensagemSelecionada.labels\" ng-class=\"vm.getLabelColor(labelId)\">{{vm.getLabelTitle(labelId)}}\n</div></div></div></div></md-card-title-text></md-card-title><md-card-content><div class=\"quebra-linha\" \nng-bind-html=\"resposta.corpo\"></div></md-card-content></md-card></div></div>");
$templateCache.put("app/main/mensageiro/views/classic/list/list.html","<div class=\"no-mensagems\" ng-show=\"!vm.carregandoMensagens && vm.mensagens.dados.mensagens.length <= 0\" \nlayout=\"column\" layout-align=\"center center\" flex><md-icon md-font-icon=\"icon-emoticon-sad\" class=\"s120 grey-400-fg\">\n</md-icon><span class=\"no-mensagems\" translate=\"MAIL.NENHUMA_MENSAGEM_ENCONTRADA\">Nenhuma mensagem encontrada</span>\n</div><div class=\"loading-mensagems\" layout=\"column\" layout-align=\"center center\" \nng-if=\"!vm.mensagens || vm.carregandoMensagens\"><md-progress-circular class=\"md-accent\" md-mode=\"indeterminate\" \nmd-diameter=\"64\"></md-progress-circular><div>Carregando suas mensagens...</div></div><div \nclass=\"mensagem {{mensagem.status}}\" md-ink-ripple ng-if=\"!vm.carregandoMensagens\" \nng-repeat=\"mensagem in vm.mensagens.dados.mensagens\" ng-click=\"vm.abrirMensagem(mensagem)\" \nng-class=\"{\'unread\': vm.metodos.aplicaCssMensagemNaoLida(mensagem), \'current-mensagem\': vm.mensagemSelecionada === mensagem, \'selected\': vm.isSelected(mensagem)}\">\n<div layout=\"row\" layout-align=\"start center\"><md-checkbox class=\"no-label\" ng-checked=\"vm.isSelected(mensagem)\" \nng-click=\"vm.toggleSelectmensagem(mensagem, $event)\" aria-label=\"{{vm.isSelected(mensagem) ? \'Deselect\' : \'Select\'}}\">\n</md-checkbox><div class=\"info-time\" layout=\"column\" layout-gt-sm=\"row\" layout-align-gt-sm=\"center center\" flex><div \nclass=\"info\" layout=\"column\" flex><div class=\"name\" layout=\"row\" layout-align=\"start center\"><img class=\"avatar\" \nng-if=\"mensagem.from.avatar\" alt=\"{{mensagem.from.name}}\" ng-src=\"{{mensagem.from.avatar}}\"><div class=\"avatar\" \nng-if=\"!mensagem.from.avatar\" ms-random-class=\"vm.colors\">\n{{vm.metodos.retornaSeRemetenteOuDestinatarioListaEmail(mensagem)[0]}}</div><span class=\"text-truncate\">\n{{vm.metodos.retornaSeRemetenteOuDestinatarioListaEmail(mensagem)}}</span><md-icon md-font-icon=\"icon-paperclip\" \nclass=\"has-attachment s16\" ng-if=\"mensagem.hasAttachments\"></md-icon></div><div class=\"subject text-truncate\"><span \nng-if=\"mensagem.mensagemIdentificadorOrigem\">RE: </span>{{mensagem.assunto}}</div><div class=\"message text-truncate\">\n{{mensagem.corpo | htmlToPlaintext | limitTo:180}}{{mensagem.corpo.length > 180 ? \'...\' : \'\'}}</div></div><div \nclass=\"time\" layout=\"row\" layout-gt-sm=\"column\"><div ng-hide=\"vm.menuSelecionado != \'sent\'\" class=\"text-center\"><div \nng-class=\"{\'lido\': mensagem.status.id == 1, \'nao-lido\': mensagem.status.id == 2, \'marcado\':mensagem.status.id == 3}\">\n{{vm.metodos.retornaTituloStatusDeAcordoComOStatus(mensagem.status.id)}}</div></div><p class=\"data-envio\">\n{{mensagem.dataEnvioCompleta | date : \'dd/MM/yyyy | HH:mm\' : timezone}}</p><div class=\"labels text-center\"><div \nclass=\"label\" ng-class=\"mensagem.prioridade.cor\">{{mensagem.prioridade.titulo}}</div></div></div></div><div \nlayout=\"row\"><div ng-hide=\"vm.menuSelecionado == \'sent\' || vm.menuSelecionado == \'trash\'\" class=\"actions\" layout=\"row\" \nlayout-align=\"start center\"><md-button class=\"md-icon-button\" \nng-click=\"vm.metodos.marcarComoImportante(mensagem, $event)\" aria-label=\"Toggle starred\" translate \ntranslate-attr-aria-label=\"MAIL.TOGGLE_STARRED\"><md-icon ng-if=\"mensagem.importante\" md-font-icon=\"icon-star\" \nclass=\"amber-fg\"></md-icon><md-icon ng-if=\"!mensagem.importante\" md-font-icon=\"icon-star-outline\"></md-icon>\n<md-tooltip><span translate=\"MAIL.MARCAR_COMO_IMPORTANTE\"></span></md-tooltip></md-button></div></div></div></div>");
$templateCache.put("app/main/pesquisa/cadastro/tipo-pesquisa/views/tipo-pesquisa-form.html","<form name=\"vm.form\" novalidate><pg-toolbar entidade=\"vm.tipoPesquisa\" entidade-de-envio=\"vm.entidadeDeEnvio\" \ncontrolador-toolbar=\"vm.controleForm\" acao-pesquisar=\"vm.metodos.pesquisar()\" acao-criar=\"vm.metodos.criar()\" \nacao-editar=\"vm.metodos.atualizar()\" acao-excluir=\"vm.metodos.excluir()\" \nconstruir-dt-options=\"vm.metodos.construirDtOptions()\" metodos-externos=\"vm.metodosExternosPgToolbar\" \ncampo-pesquisar=\"vm.pesquisar\"></pg-toolbar><div class=\"content\"><md-content layout-padding \nng-hide=\"vm.controleForm.listarTodasEntidades\" ng-disabled=\"vm.controleForm.emProgresso\"><div layout=\"row\">\n<md-input-container flex=\"20\" \nng-hide=\"vm.controleForm.pesquisaAtiva && vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo\"><label>Código\n</label><input type=\"text\" ng-model=\"vm.tipoPesquisa.codigo\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo\">\n</md-input-container><md-input-container flex><label>Descrição</label><input type=\"text\" \nng-model=\"vm.tipoPesquisa.descricao\" name=\"descricao\" mascara-tamanho-campo=\"50\" md-maxlength=\"50\" \nng-required=\"vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\"><div \nng-messages=\"vm.form.descricao.$error\"><div ng-message=\"required\" translate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\">\n</div></div></md-input-container></div></md-content></div></form>");
$templateCache.put("app/main/pesquisa/cadastro/tipo-pesquisa/views/tipo-pesquisa-table.html","<div layout=\"column\" flex><div class=\"md-padding md-background-bg md-whiteframe-1dp fullpage-datatable\" \nlayout=\"column\" flex><table class=\"dataTable row-border hover\" id=\"datatable-tipo-pesquisa\" width=\"100%\"><thead><tr>\n<th>Ação</th><th>Código</th><th>Descrição</th></tr></thead></table></div></div>");
$templateCache.put("app/main/pesquisa/cadastro/tipo-pesquisa/views/tipo-pesquisa.html","<div id=\"cadastro_tipo_pesquisa\" layout=\"column\"><header-padrao translate-nome=\"Tipo de pesquisa\" \nng-utiliza-pesquisa=\"false\"></header-padrao><div class=\"content\"><div ui-view=\"tipo-pesquisa-form\"></div></div><div \nui-view=\"tipo-pesquisa-table\" ng-if=\"vm.controleForm.listarTodasEntidades\"></div></div>");
$templateCache.put("app/main/mensageiro/views/outlook/detail/detail.html","<div ng-if=\"!vm.mensagemSelecionada\" ng-hide=\"vm.carregandoHistorico\" class=\"no-mensagem-selected\" layout=\"column\" \nlayout-align=\"center center\" flex><md-icon md-font-icon=\"icon-email\" class=\"s120 grey-400-fg\"></md-icon><span \nclass=\"hint-text\" translate=\"MAIL.SELECT_MESSAGE_TO_READ\">Selecione uma mensagem para ler</span></div><div \nclass=\"loading-mensagems\" layout=\"column\" layout-align=\"center center\" ng-show=\"vm.carregandoHistorico\">\n<md-progress-circular class=\"md-accent\" md-mode=\"indeterminate\" md-diameter=\"64\"></md-progress-circular><div>\nCarregando conversa...</div></div><div ng-if=\"vm.mensagemSelecionada\" ng-hide=\"vm.carregandoHistorico\"><div \nng-repeat=\"resposta in vm.mensagemSelecionada.respostas \"><md-content class=\"resposta\" \nng-if=\"vm.metodos.verificaDataEnvioResposta(resposta.dataEnvio,vm.mensagemSelecionada.respostas.indexOf(resposta))\" \nlayout=\"row\" layout-align=\"center center\"><span>{{vm.dataResposta}}</span></md-content><md-card><md-card-title>\n<md-card-title-text><div layout=\"row\" layout-align=\"end end\"><div layout=\"column\" \nng-show=\"vm.metodos.verificaSeultimaResposta(resposta)\" layout-align=\"end end\"><div \nng-hide=\"vm.menuSelecionado == \'sent\' || vm.menuSelecionado == \'trash\'\" class=\"actions\" layout=\"row\" \nlayout-align=\"start center\"><md-button class=\"md-icon-button\" \nng-click=\"vm.metodos.marcarComoImportante(vm.mensagemSelecionada, $event)\" aria-label=\"Toggle starred\" translate \ntranslate-attr-aria-label=\"MAIL.TOGGLE_STARRED\"><md-icon ng-if=\"vm.mensagemSelecionada.importante\" \nmd-font-icon=\"icon-star\" class=\"amber-fg\"></md-icon><md-icon ng-if=\"!vm.mensagemSelecionada.importante\" \nmd-font-icon=\"icon-star-outline\"></md-icon><md-tooltip><span translate=\"MAIL.MARCAR_COMO_IMPORTANTE\"></span>\n</md-tooltip></md-button></div></div><div layout=\"column\" layout-align=\"start start\"><md-menu \nng-if=\"vm.menuSelecionado == \'inbox\'\"><md-button aria-label=\"More\" class=\"md-icon-button\" \nng-click=\"$mdOpenMenu($event)\" translate translate-aria-label=\"MAIL.MORE\"><md-icon md-font-icon=\"icon-dots-vertical\">\n</md-icon></md-button><md-menu-content width=\"3\"><md-menu-item><md-button aria-label=\"Reply\" \ntranslate-aria-label=\"MAIL.RESPONDER\" ng-click=\"vm.replyDialog($event,resposta)\"><md-icon md-font-icon=\"icon-reply\">\n</md-icon><span translate=\"MAIL.RESPONDER\">Responder</span></md-button></md-menu-item><md-menu-item><md-button \naria-label=\"forward\" translate-aria-label=\"MAIL.ENCAMINHAR\" ng-click=\"vm.forwardDialog($event,resposta)\"><md-icon \nmd-font-icon=\"icon-forward\"></md-icon><span translate=\"MAIL.ENCAMINHAR\">Emcaminhar</span></md-button></md-menu-item>\n</md-menu-content></md-menu></div></div><div class=\"mensagem-content\"><div class=\"info\" layout=\"row\" \nlayout-align=\"space-between start\"><div layout=\"column\" layout-align=\"start start\"><div layout=\"row\" \nlayout-align=\"start start\"><div><img ng-if=\"resposta.from.avatar\" alt=\"{{resposta.from.name}}\" \nng-src=\"{{resposta.from.avatar}}\" class=\"avatar\"><div ng-if=\"!resposta.from.avatar\" class=\"avatar\" \nms-random-class=\"vm.colors\">{{resposta.remetente[0]}}</div></div><div layout=\"column\" layout-align=\"start start\"><div \nclass=\"name\">{{resposta.remetente}}</div><div class=\"to\" layout=\"row\" layout-align=\"start center\"><div class=\"to-text\" \ntranslate=\"MAIL.INFO.TO\">to</div><div>{{vm.metodos.retornaDestinatariosDaMensagem(resposta,true)}}</div></div></div>\n</div><a class=\"toggle-details md-accent-color\" ng-hide=\"vm.selectedMailShowDetails\" \nng-click=\"vm.selectedMailShowDetails = !vm.selectedMailShowDetails\" translate=\"MAIL.SHOW_DETAILS\">Show Details </a><a \nclass=\"toggle-details md-accent-color\" ng-show=\"vm.selectedMailShowDetails\" \nng-click=\"vm.selectedMailShowDetails = !vm.selectedMailShowDetails\" translate=\"MAIL.HIDE_DETAILS\">Hide Details</a><div \nng-show=\"vm.selectedMailShowDetails\" class=\"details\" layout=\"row\" layout-align=\"start start\"><div layout=\"column\"><span\n class=\"title\" translate=\"MAIL.DETAILS.FROM\">De:</span> <span class=\"title\" translate=\"MAIL.DETAILS.DATE\">Data:</span> \n<span class=\"title\" translate=\"MAIL.DETAILS.TO\">Para:</span></div><div layout=\"column\"><span class=\"detail\">\n{{resposta.remetente}}</span> <span class=\"detail\">\n{{resposta.dataEnvioCompleta | date : \'dd/MM/yyyy | HH:mm\' : timezone}}</span> <span class=\"detail\">\n{{vm.metodos.retornaDestinatariosDaMensagem(resposta,false)}}</span></div></div></div></div></div><div \nclass=\"mensagem-header\" layout=\"row\" layout-align=\"space-between center\"><div><p class=\"subject\"><span \nng-if=\"resposta.mensagemIdentificadorOrigem\">RE: </span>{{resposta.assunto}}</p><div class=\"labels\"><div class=\"label\" \nng-repeat=\"labelId in vm.mensagemSelecionada.labels\" ng-class=\"vm.getLabelColor(labelId)\">{{vm.getLabelTitle(labelId)}}\n</div></div></div></div></md-card-title-text></md-card-title><md-card-content><div class=\"quebra-linha\" \nng-bind-html=\"resposta.corpo\"></div></md-card-content></md-card></div></div>");
$templateCache.put("app/main/mensageiro/views/outlook/list/list.html","<div class=\"no-mensagems\" ng-show=\"!vm.carregandoMensagens && vm.mensagens.dados.mensagens.length <= 0\">\nNenhuma mensagem encontrada!</div><div class=\"loading-mensagems\" layout=\"column\" layout-align=\"center center\" \nng-if=\"!vm.mensagens || vm.carregandoMensagens\"><md-progress-circular class=\"md-accent\" md-mode=\"indeterminate\" \nmd-diameter=\"64\"></md-progress-circular><div>Carregando suas mensagens...</div></div><div \nclass=\"mensagem {{mensagem.status}}\" md-ink-ripple ng-if=\"!vm.carregandoMensagens\" \nng-repeat=\"mensagem in vm.mensagens.dados.mensagens | filter: global.search \" ng-click=\"vm.abrirMensagem(mensagem)\" \nng-class=\"{unread: vm.metodos.aplicaCssMensagemNaoLida(mensagem), \'current-mensagem\': vm.currentmensagem === mensagem, \'selected\': vm.isSelected(mensagem)}\">\n<div layout=\"row\" layout-align=\"start center\"><md-checkbox class=\"no-label\" ng-checked=\"vm.isSelected(mensagem)\" \nng-click=\"vm.toggleSelectmensagem(mensagem, $event)\" aria-label=\"{{vm.isSelected(mensagem) ? \'Deselect\' : \'Select\'}}\">\n</md-checkbox><div class=\"info\" flex layout=\"column\"><div class=\"name\" layout=\"row\" layout-align=\"start center\"><img \nclass=\"avatar\" ng-if=\"mensagem.from.avatar\" alt=\"{{mensagem.from.name}}\" ng-src=\"{{mensagem.from.avatar}}\"><div \nclass=\"avatar\" ng-if=\"!mensagem.from.avatar\" ms-random-class=\"vm.colors\">\n{{vm.metodos.retornaSeRemetenteOuDestinatarioListaEmail(mensagem)[0]}}</div><span class=\"text-truncate\">\n{{vm.metodos.retornaSeRemetenteOuDestinatarioListaEmail(mensagem)}}</span><md-icon md-font-icon=\"icon-paperclip\" \nclass=\"has-attachment s16\" ng-if=\"mensagem.hasAttachments\"></md-icon></div><div class=\"subject text-truncate\"><span \nng-if=\"mensagem.mensagemIdentificadorOrigem\">RE: </span>{{mensagem.assunto}}</div><div class=\"message text-truncate\">\n{{mensagem.corpo | htmlToPlaintext | limitTo:90}}{{mensagem.corpo.length > 90 ? \'...\' : \'\'}}</div></div><div \nlayout=\"column\" layout-align=\"space-between end\"><md-button ng-hide=\"vm.menuSelecionado == \'sent\'\" \nclass=\"md-icon-button\" aria-label=\"Toggle sinalizado\" translate translate-attr-aria-label=\"MAIL.TOGGLE_SINALIZADO\">\n<md-icon ng-if=\"mensagem.status.id == 3\" md-font-icon=\"icon-clock\" class=\"amber-300-fg\"></md-icon></md-button><div \nclass=\"time\"><div class=\"text-rigth\" ng-hide=\"vm.menuSelecionado != \'sent\'\"><div \nng-class=\"{\'lido\': mensagem.status.id == 1, \'nao-lido\': mensagem.status.id == 2, \'marcado\':mensagem.status.id == 3}\">\n{{vm.metodos.retornaTituloStatusDeAcordoComOStatus(mensagem.status.id)}}</div></div>\n{{mensagem.dataEnvioCompleta | date : \'dd/MM/yyyy HH:mm\' : timezone}}<div class=\"labels text-center\"><div \nclass=\"label\" style=\"color: white!important\" ng-class=\"mensagem.prioridade.cor\">{{mensagem.prioridade.titulo}}</div>\n</div></div></div></div></div>");
$templateCache.put("app/main/pesquisa/processamento/pesquisa/views/pesquisa-form.html","<div class=\"md-background-bg md-whiteframe-1dp\"><form name=\"vm.form\" novalidate><pg-toolbar entidades=\"vm.pesquisa\" \nentidade=\"vm.pesquisa\" entidade-de-envio=\"vm.entidadeDeEnvio\" controlador-toolbar=\"vm.controleForm\" \ncontrolador-pre-loader=\"vm.controlePreloader\" acao-pesquisar=\"vm.metodos.pesquisar()\" \nacao-criar=\"vm.metodos.salvar(vm.pesquisa)\" acao-editar=\"vm.metodos.editar(vm.pesquisa)\" \nacao-excluir=\"vm.metodos.excluir(vm.pesquisa)\" acao-pos-pesquisar=\"vm.metodos.aoPesquisarConcluido()\" \nacao-pos-paginacao=\"vm.metodos.aoPaginarConcluido()\" pre-definir-campos-para-insercao=\"vm.metodos.preDefinirInserir()\" \ndesabilitar-botao-clonar=\"vm.metodos.desabilitaBotaoClonar()\" metodos-externos=\"vm.metodosExternosPgToolbar\" \nmetodo-externo-acao-nova-pesquisa=\"vm.metodos.novaPesquisa()\" \ndesabilitar-botao-salvar=\"(vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo) && !vm.pesquisa.perguntas.length\" \nutiliza-botao-clonar=\"true\" definir-campos-clonados=\"vm.metodos.definirCamposClonados()\" \ncampo-pesquisar=\"vm.pesquisar\" construir-dt-options=\"vm.metodos.construirDtOptions()\"></pg-toolbar><md-content \nlayout-padding ng-hide=\"vm.controleForm.listarTodasEntidades\" ng-disabled=\"vm.controleForm.emProgresso\"><md-tabs \nmd-dynamic-height md-border-bottom><md-tab label=\"Pesquisa\" md-active=\"vm.tabSelecionada === \'pesquisa\'\" \nmd-on-select=\"vm.metodos.tabSelecionada(\'pesquisa\')\"><md-tab-label><label>Pesquisa</label><md-icon \nmd-font-icon=\"icon-close-circle-outline s24\" style=\"color: rgb(244,67,54)\" \nng-if=\"(vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo) && vm.form.$invalid\"></md-icon><md-icon \nmd-font-icon=\"icon-checkbox-marked-circle-outline s24\" style=\"color: rgb(76,175,80)\" \nng-if=\"(vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo) && !vm.form.$invalid\"></md-icon></md-tab-label>\n<md-tab-body><div ng-include=\"vm.htmlRota.tabs.pesquisa\"></div></md-tab-body></md-tab><md-tab label=\"Perguntas\" \nmd-active=\"vm.tabSelecionada === \'perguntas\'\" \nng-disabled=\"!vm.controleForm.pesquisaAtiva && !(vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo)\" \nmd-on-select=\"vm.metodos.tabSelecionada(\'perguntas\')\"><md-tab-label><label>Perguntas</label><md-icon \nmd-font-icon=\"icon-close-circle-outline s24\" style=\"color: rgb(244,67,54)\" \nng-if=\"(vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo) && !vm.pesquisa.perguntas.length\"></md-icon>\n<md-icon md-font-icon=\"icon-checkbox-marked-circle-outline s24\" style=\"color: rgb(76,175,80)\" \nng-if=\"(vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo) && vm.pesquisa.perguntas.length\"></md-icon>\n</md-tab-label><md-tab-body><div ng-include=\"vm.htmlRota.tabs.perguntas\"></div></md-tab-body></md-tab><md-tab \nlabel=\"Respostas\" md-active=\"vm.tabSelecionada === \'respostas\'\" md-on-select=\"vm.metodos.tabSelecionada(\'respostas\')\" \nng-disabled=\"!vm.controleForm.pesquisaAtiva || (vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo) || vm.emProgresso\">\n<md-tab-label><label>Respostas</label></md-tab-label><md-tab-body><div \nng-include=\"vm.htmlRota.tabs.respostas.templateUrl\"></div></md-tab-body></md-tab></md-tabs></md-content></form></div>");
$templateCache.put("app/main/pesquisa/processamento/pesquisa/views/pesquisa-tabela.html","<div layout=\"column\" flex><div class=\"md-padding md-background-bg md-whiteframe-1dp fullpage-datatable\" \nlayout=\"column\" flex><table class=\"dataTable row-border hover\" id=\"datatable-pesquisa-satisfacao\" width=\"100%\"><thead>\n<tr><th>Ação</th><th>Código</th><th>Descrição</th><th>Data inicial</th><th>Data final</th><th>Status</th><th>Produto\n</th><th>Quantidade perguntas</th></tr></thead></table></div></div>");
$templateCache.put("app/main/pesquisa/processamento/pesquisa/views/pesquisa.html","<div id=\"pesquisa-processamento-pesquisa\"><header-padrao translate-nome=\"Pesquisa\" icone=\"icon-file-find\" \npesquisar=\"vm.pesquisar\"></header-padrao><div class=\"content\"><div ui-view=\"pesquisa-form\"></div></div><div \nui-view=\"pesquisa-tabela\" ng-if=\"vm.controleForm.listarTodasEntidades\"></div></div>");
$templateCache.put("app/main/planejamento-scrum/cadastro/motivo-estoria/views/motivo-estoria-form.html","<div class=\"md-background-bg md-whiteframe-1dp\"><form name=\"motivoForm\" novalidate><pg-toolbar entidades=\"vm.motivos\" \nentidade=\"vm.motivo\" entidade-de-envio=\"vm.entidadeDeEnvio\" controlador-toolbar=\"vm.controleForm\" \nacao-pesquisar=\"vm.metodosMotivo.pesquisar()\" acao-criar=\"vm.metodosMotivo.salvar(vm.motivo)\" \nacao-editar=\"vm.metodosMotivo.editar(vm.motivo)\" acao-excluir=\"vm.metodosMotivo.excluir(vm.motivo)\" \nconstruir-dt-options=\"vm.metodosMotivo.construirDtOptions()\" metodos-externos=\"vm.metodosExternosPgToolbar\" \ncampo-pesquisar=\"vm.pesquisar\"></pg-toolbar><md-content layout-padding ng-hide=\"vm.controleForm.listarTodasEntidades\" \nng-disabled=\"vm.controleForm.emProgresso\"><div class=\"form-container\"><div layout-gt-xs=\"row\"><div layout=\"row\">\n<md-input-container class=\"md-block\" flex-gt-sm><label translate=\"MOTIVO.CODIGO\"></label><input type=\"text\" \nng-model=\"vm.motivo.codigo\" name=\"motivoCodigo\" mascara-numero-generica=\"#####\" \nng-required=\"vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\"><div \nng-messages=\"motivoForm.motivoCodigo.$error\"><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container><proximo-codigo \nng-show=\"vm.controleForm.inserirAtivo\" rota=\"vm.rota\" entidade-codigo=\"vm.motivo.codigo\" \npre-loader-toolbar=\"vm.controleForm.preLoaderToolbar\"></proximo-codigo></div><md-input-container class=\"md-block\" \nflex-offset-gt-sm=\"5\" flex-gt-sm><label translate=\"MOTIVO.DESCRICAO\"></label><input type=\"text\" \nng-model=\"vm.motivo.descricao\" name=\"motivoDescricao\" mascara-tamanho-campo=\"100\" \nng-required=\"vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo\" md-maxlength=\"100\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\"><div \nng-messages=\"motivoForm.motivoDescricao.$error\"><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container></div></div></md-content></form>\n</div>");
$templateCache.put("app/main/planejamento-scrum/cadastro/motivo-estoria/views/motivo-estoria.html","<div id=\"motivo-estoria\" class=\"page-layout simple tabbed\" layout=\"column\"><header-padrao \ntranslate-nome=\"MOTIVO.MOTIVO\" icone=\"icon-equal-box\" \nliberar-pesquisa-quando-datatable-ativo=\"vm.controleForm.listarTodasEntidades\" pesquisar=\"vm.pesquisar\">\n</header-padrao><div class=\"content\"><div ui-view=\"motivo-estoria-form\"></div></div><div \nui-view=\"motivos-estoria-tabela\" ng-if=\"vm.controleForm.listarTodasEntidades\"></div></div>");
$templateCache.put("app/main/planejamento-scrum/cadastro/motivo-estoria/views/motivos-estoria-tabela.html","<div layout=\"column\" flex><div class=\"md-padding md-background-bg md-whiteframe-1dp fullpage-datatable\" \nlayout=\"column\" flex><table class=\"dataTable row-border hover\" id=\"datatable-motivo-estoria\" width=\"100%\"><thead><tr>\n<th>Ação</th><th>Código</th><th>Descrição</th></tr></thead></table></div></div>");
$templateCache.put("app/main/planejamento-scrum/cadastro/registro-situacao/views/registro-situacao-form.html","<div class=\"md-background-bg md-whiteframe-1dp\"><form name=\"registroSituacaoForm\" novalidate><pg-toolbar \nentidades=\"vm.registrosSituacoes\" entidade=\"vm.registroSituacao\" entidade-de-envio=\"vm.entidadeDeEnvio\" \ncontrolador-toolbar=\"vm.controleForm\" acao-pesquisar=\"vm.metodosRegistroSituacao.pesquisar()\" \nacao-criar=\"vm.metodosRegistroSituacao.salvar(vm.registroSituacao)\" \nacao-editar=\"vm.metodosRegistroSituacao.editar(vm.registroSituacao)\" \nacao-excluir=\"vm.metodosRegistroSituacao.excluir(vm.registroSituacao)\" \nconstruir-dt-options=\"vm.metodosRegistroSituacao.construirDtOptions()\" metodos-externos=\"vm.metodosExternosPgToolbar\" \ncampo-pesquisar=\"vm.pesquisar\"></pg-toolbar><md-content layout-padding ng-hide=\"vm.controleForm.listarTodasEntidades\" \nng-disabled=\"vm.controleForm.emProgresso\"><div class=\"form-container\"><md-input-container class=\"md-block\" flex-gt-sm>\n<label translate=\"REGISTRO_SITUACAO.DESCRICAO\"></label><input type=\"text\" ng-model=\"vm.registroSituacao.descricao\" \nname=\"registroSituacao\" mascara-tamanho-campo=\"50\" md-maxlength=\"50\" \nng-required=\"vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\"><div \nng-messages=\"registroSituacaoForm.registroSituacao.$error\"><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container></div></md-content></form></div>");
$templateCache.put("app/main/planejamento-scrum/cadastro/registro-situacao/views/registro-situacao.html","<div id=\"registro-situacao\" class=\"page-layout simple tabbed\" layout=\"column\"><header-padrao \ntranslate-nome=\"REGISTRO_SITUACAO.REGISTRO_SITUACAO\" icone=\"icon-book-multiple-variant\" \nliberar-pesquisa-quando-datatable-ativo=\"vm.controleForm.listarTodasEntidades\" pesquisar=\"vm.pesquisar\">\n</header-padrao><div class=\"content\"><div ui-view=\"registro-situacao-form\"></div></div><div \nui-view=\"registros-situacoes-tabela\" ng-if=\"vm.controleForm.listarTodasEntidades\"></div></div>");
$templateCache.put("app/main/planejamento-scrum/cadastro/registro-situacao/views/registros-situacoes-tabela.html","<div layout=\"column\" flex><div class=\"md-padding md-background-bg md-whiteframe-1dp fullpage-datatable\" \nlayout=\"column\" flex><table class=\"dataTable row-border hover\" id=\"datatable-registro-situacao\" width=\"100%\"><thead>\n<tr><th>Ação</th><th>Código</th><th>Descrição</th></tr></thead></table></div></div>");
$templateCache.put("app/main/planejamento-scrum/cadastro/feriado/views/feriado-form.html","<div class=\"md-background-bg md-whiteframe-1dp\"><form name=\"feriadoForm\" novalidate><pg-toolbar \nentidades=\"vm.feriados\" entidade=\"vm.feriado\" entidade-de-envio=\"vm.entidadeDeEnvio\" \ncontrolador-toolbar=\"vm.controleForm\" controlador-pre-loader=\"vm.controlePreloader\" \nacao-pesquisar=\"vm.metodosFeriado.pesquisar()\" acao-criar=\"vm.metodosFeriado.salvar(vm.feriado)\" \nacao-editar=\"vm.metodosFeriado.editar(vm.feriado)\" acao-excluir=\"vm.metodosFeriado.excluir(vm.feriado)\" \nconstruir-dt-options=\"vm.metodosFeriado.construirDtOptions()\" metodos-externos=\"vm.metodosExternosPgToolbar\" \ncampo-pesquisar=\"vm.pesquisar\" pre-definir-campos-para-insercao=\"vm.metodosGeral.PreDefinirCamposParaInserir()\">\n</pg-toolbar><md-content layout-padding ng-hide=\"vm.controleForm.listarTodasEntidades\" \nng-disabled=\"vm.controleForm.emProgresso\"><div class=\"form-container\"><div layout-gt-xs=\"row\"><div layout=\"row\">\n<md-input-container class=\"md-block\" flex-gt-sm><label translate=\"FERIADO.CODIGO\"></label><input type=\"text\" \nng-model=\"vm.feriado.codigo\" name=\"feriadoCodigo\" mascara-numero-generica=\"#####\" \nng-required=\"vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo\"><div \nng-messages=\"feriadoForm.feriadoCodigo.$error\"><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container></div><md-input-container \nclass=\"md-block\" flex-offset-gt-sm=\"5\" flex-gt-sm=\"40\"><label translate=\"FERIADO.DESCRICAO\"></label><input type=\"text\" \nng-model=\"vm.feriado.descricao\" name=\"feriadoDescricao\" mascara-tamanho-campo=\"50\" \nng-required=\"vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo\" md-maxlength=\"50\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\"><div \nng-messages=\"feriadoForm.feriadoDescricao.$error\"><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container><md-input-container class=\"md-block\" \nflex-offset-gt-sm=\"10\"><label translate=\"FERIADO.DATA\"></label><md-datepicker flex-offset-gt-sm=\"5\" \nng-model=\"vm.feriado.data\" name=\"feriadoData\" mascara-conversor-string-para-data ng-mask=\"3?9/1?9/9999\" \nng-required=\"vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\">\n</md-datepicker><div ng-messages=\"feriadoForm.feriadoData.$error\"><div ng-message=\"valid\" \ntranslate=\"MENSAGEM_VALIDACAO.DATA_INVALIDA\"></div><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.DATA_OBRIGATORIA\"></div></div></md-input-container></div></div></md-content></form></div>");
$templateCache.put("app/main/planejamento-scrum/cadastro/feriado/views/feriado.html","<div id=\"feriado\" class=\"page-layout simple tabbed\" layout=\"column\"><header-padrao translate-nome=\"FERIADO.FERIADO\" \nicone=\"icon-calendar\" liberar-pesquisa-quando-datatable-ativo=\"vm.controleForm.listarTodasEntidades\" \npesquisar=\"vm.pesquisar\"></header-padrao><div class=\"content\"><div ui-view=\"feriado-form\"></div></div><div \nui-view=\"feriados-tabela\" ng-if=\"vm.controleForm.listarTodasEntidades\"></div></div>");
$templateCache.put("app/main/planejamento-scrum/cadastro/feriado/views/feriados-tabela.html","<div layout=\"column\" flex><div class=\"md-padding md-background-bg md-whiteframe-1dp fullpage-datatable\" \nlayout=\"column\" flex><table class=\"dataTable row-border hover\" id=\"datatable-feriado\" width=\"100%\"><thead><tr><th>Ação\n</th><th>Descrição</th><th>Data</th></tr></thead></table></div></div>");
$templateCache.put("app/main/planejamento-scrum/cadastro/plataforma/views/plataforma-form.html","<div class=\"md-background-bg md-whiteframe-1dp\"><form name=\"sistemaOperacionalForm\" novalidate><pg-toolbar \nentidades=\"vm.plataformas\" entidade=\"vm.plataforma\" entidade-de-envio=\"vm.entidadeDeEnvio\" \ncontrolador-toolbar=\"vm.controleForm\" acao-pesquisar=\"vm.metodosPlataforma.pesquisar()\" \nacao-criar=\"vm.metodosPlataforma.salvar(vm.plataforma)\" acao-editar=\"vm.metodosPlataforma.editar(vm.plataforma)\" \nacao-excluir=\"vm.metodosPlataforma.excluir(vm.plataforma)\" \nconstruir-dt-options=\"vm.metodosPlataforma.construirDtOptions()\" metodos-externos=\"vm.metodosExternosPgToolbar\" \ncampo-pesquisar=\"vm.pesquisar\"></pg-toolbar><md-content layout-padding ng-hide=\"vm.controleForm.listarTodasEntidades\" \nng-disabled=\"vm.controleForm.emProgresso\"><div class=\"form-container\"><div layout-gt-xs=\"row\"><div layout=\"row\">\n<md-input-container class=\"md-block\" flex-gt-sm><label translate=\"PLATAFORMA.CODIGO\"></label><input type=\"text\" \nng-model=\"vm.plataforma.codigo\" name=\"sistemaOperacionalCodigo\" mascara-numero-generica=\"#####\" \nng-required=\"vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\"><div \nng-messages=\"sistemaOperacionalForm.sistemaOperacionalCodigo.$error\"><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container><proximo-codigo \nng-show=\"vm.controleForm.inserirAtivo\" rota=\"vm.rota\" entidade-codigo=\"vm.plataforma.codigo\" \npre-loader-toolbar=\"vm.controleForm.preLoaderToolbar\"></proximo-codigo></div><md-input-container class=\"md-block\" \nflex-offset-gt-sm=\"5\" flex-gt-sm><label translate=\"PLATAFORMA.DESCRICAO\"></label><input type=\"text\" \nng-model=\"vm.plataforma.descricao\" name=\"sistemaOperacionalDescricao\" mascara-tamanho-campo=\"50\" \nng-required=\"vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo\" md-maxlength=\"50\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\"><div \nng-messages=\"sistemaOperacionalForm.sistemaOperacionalDescricao.$error\"><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container></div></div></md-content></form>\n</div>");
$templateCache.put("app/main/planejamento-scrum/cadastro/plataforma/views/plataforma.html","<div id=\"sistema-operacional\" class=\"page-layout simple tabbed\" layout=\"column\"><header-padrao \ntranslate-nome=\"PLATAFORMA.PLATAFORMA\" icone=\"icon-cog\" \nliberar-pesquisa-quando-datatable-ativo=\"vm.controleForm.listarTodasEntidades\" pesquisar=\"vm.pesquisar\">\n</header-padrao><div class=\"content\"><div ui-view=\"plataforma-form\"></div></div><div ui-view=\"plataforma-tabela\" \nng-if=\"vm.controleForm.listarTodasEntidades\"></div></div>");
$templateCache.put("app/main/planejamento-scrum/cadastro/plataforma/views/plataformas-tabela.html","<div layout=\"column\" flex><div class=\"md-padding md-background-bg md-whiteframe-1dp fullpage-datatable\" \nlayout=\"column\" flex><table class=\"dataTable row-border hover\" id=\"datatable-plataforma\" width=\"100%\"><thead><tr><th>\nAção</th><th>Código</th><th>Descrição</th></tr></thead></table></div></div>");
$templateCache.put("app/main/planejamento-scrum/cadastro/situacao-estoria/views/situacao-estoria-form.html","<div class=\"md-background-bg md-whiteframe-1dp\"><form name=\"situacaoForm\" novalidate><pg-toolbar \nentidades=\"vm.situacoes\" entidade=\"vm.situacao\" entidade-de-envio=\"vm.entidadeDeEnvio\" \ncontrolador-toolbar=\"vm.controleForm\" acao-pesquisar=\"vm.metodosSituacao.pesquisar()\" \nacao-criar=\"vm.metodosSituacao.salvar(vm.situacao)\" acao-editar=\"vm.metodosSituacao.editar(vm.situacao)\" \nacao-excluir=\"vm.metodosSituacao.excluir(vm.situacao)\" construir-dt-options=\"vm.metodosSituacao.construirDtOptions()\" \nmetodos-externos=\"vm.metodosExternosPgToolbar\" campo-pesquisar=\"vm.pesquisar\"></pg-toolbar><md-content layout-padding \nng-hide=\"vm.controleForm.listarTodasEntidades\" ng-disabled=\"vm.controleForm.emProgresso\"><div class=\"form-container\">\n<div layout-gt-xs=\"row\"><div layout=\"row\"><md-input-container class=\"md-block\" flex-gt-sm><label \ntranslate=\"SITUACAO.CODIGO\"></label><input type=\"text\" ng-model=\"vm.situacao.codigo\" name=\"situacaoCodigo\" \nmascara-numero-generica=\"#####\" ng-required=\"vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\"><div \nng-messages=\"situacaoForm.situacaoCodigo.$error\"><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container><proximo-codigo \nng-show=\"vm.controleForm.inserirAtivo\" rota=\"vm.rota\" entidade-codigo=\"vm.situacao.codigo\" \npre-loader-toolbar=\"vm.controleForm.preLoaderToolbar\"></proximo-codigo></div><md-input-container class=\"md-block\" \nflex-offset-gt-sm=\"5\" flex-gt-sm><label translate=\"SITUACAO.DESCRICAO\"></label><input type=\"text\" \nng-model=\"vm.situacao.descricao\" name=\"situacaoDescricao\" mascara-tamanho-campo=\"50\" mascara-formatar-nome \nng-required=\"vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo\" md-maxlength=\"50\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\"><div \nng-messages=\"situacaoForm.situacaoDescricao.$error\"><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container></div><div layout-gt-sm=\"row\"><div \nlayout-gt-sm=\"row\"><md-input-container class=\"md-block\"><md-checkbox ng-model=\"vm.situacao.abatePontos\" \naria-label=\"Abate pontos\" name=\"abatePontos\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\">\nAbate pontos</md-checkbox></md-input-container><md-input-container class=\"md-block\"><md-checkbox \nng-model=\"vm.situacao.geraRetrabalho\" aria-label=\"Gera retrabalho\" name=\"geraRetrabalho\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\">\nGera retrabalho</md-checkbox></md-input-container><md-input-container class=\"md-block\"><md-checkbox \nng-model=\"vm.situacao.finalizaProcesso\" aria-label=\"Finaliza processo\" name=\"finalizaProcesso\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\">\nFinaliza processo</md-checkbox></md-input-container><md-input-container class=\"md-block\"><md-checkbox \nng-model=\"vm.situacao.exigeMotivo\" aria-label=\"Finaliza processo\" name=\"finalizaProcesso\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\">\nExige Motivo</md-checkbox></md-input-container></div></div></div></md-content></form></div>");
$templateCache.put("app/main/planejamento-scrum/cadastro/situacao-estoria/views/situacao-estoria.html","<div id=\"situacao-estoria\" class=\"page-layout simple tabbed\" layout=\"column\"><header-padrao \ntranslate-nome=\"SITUACAO.SITUACAO\" icone=\"icon-book-multiple-variant\" \nliberar-pesquisa-quando-datatable-ativo=\"vm.controleForm.listarTodasEntidades\" pesquisar=\"vm.pesquisar\">\n</header-padrao><div class=\"content\"><div ui-view=\"situacao-estoria-form\"></div></div><div \nui-view=\"situacoes-estoria-tabela\" ng-if=\"vm.controleForm.listarTodasEntidades\"></div></div>");
$templateCache.put("app/main/planejamento-scrum/cadastro/situacao-estoria/views/situacoes-estoria-tabela.html","<div layout=\"column\" flex><div class=\"md-padding md-background-bg md-whiteframe-1dp fullpage-datatable\" \nlayout=\"column\" flex><table class=\"dataTable row-border hover\" id=\"datatable-situacao-estoria\" width=\"100%\"><thead><tr>\n<th>Ação</th><th>Código</th><th>Descrição</th><th>Abate Pontos</th><th>Gera Retrabalho</th><th>Finaliza Processo</th>\n<th>Exige Motivo</th></tr></thead></table></div></div>");
$templateCache.put("app/main/planejamento-scrum/cadastro/tipo-historia/views/tipo-historia-form.html","<div class=\"md-background-bg md-whiteframe-1dp\"><form name=\"vm.form\" novalidate><pg-toolbar \nentidades=\"vm.tiposHistoria\" entidade=\"vm.tipoHistoria\" entidade-de-envio=\"vm.entidadeDeEnvio\" \ncontrolador-toolbar=\"vm.controleForm\" acao-pesquisar=\"vm.metodos.pesquisar()\" \nacao-criar=\"vm.metodos.salvar(vm.tipoHistoria)\" acao-editar=\"vm.metodos.editar(vm.tipoHistoria)\" \nacao-excluir=\"vm.metodos.excluir(vm.tipoHistoria)\" construir-dt-options=\"vm.metodos.construirDtOptions()\" \nmetodos-externos=\"vm.metodosExternosPgToolbar\" campo-pesquisar=\"vm.pesquisar\" \npre-definir-campos-para-insercao=\"vm.metodos.preDefinirParaInsercao()\"></pg-toolbar><md-content layout-padding \nng-hide=\"vm.controleForm.listarTodasEntidades\" ng-disabled=\"vm.controleForm.emProgresso\"><div class=\"form-container\">\n<div layout-gt-xs=\"row\"><md-input-container class=\"md-block\" flex><label translate=\"TIPO_HISTORIA.DESCRICAO\"></label>\n<input type=\"text\" name=\"tipoHistoriaDescricao\" mascara-tamanho-campo=\"50\" md-maxlength=\"50\" \nng-model=\"vm.tipoHistoria.descricao\" ng-required=\"vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && \r\n                                           !vm.controleForm.editarAtivo && \r\n                                           !vm.controleForm.inserirAtivo\">\n<div ng-messages=\"vm.form.tipoHistoriaDescricao.$error\"><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container><md-input-container class=\"md-block\" \nflex=\"10\"><md-switch class=\"mt-5\" aria-label=\"Ativo\" ng-model=\"vm.tipoHistoria.ativo\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && \r\n                                               !vm.controleForm.inserirAtivo && \r\n                                               !vm.controleForm.editarAtivo\">\n{{ vm.tipoHistoria.ativo ? \'Ativo\' : \'Inativo\' }}</md-switch></md-input-container></div></div></md-content></form>\n</div>");
$templateCache.put("app/main/planejamento-scrum/cadastro/tipo-historia/views/tipo-historia-tabela.html","<div layout=\"column\" flex><div class=\"md-padding md-background-bg md-whiteframe-1dp fullpage-datatable\" \nlayout=\"column\" flex><table class=\"dataTable row-border hover\" id=\"datatable-tipo-historia\" width=\"100%\"><thead><tr>\n<th>Ação</th><th>Descrição</th><th>Ativo</th></tr></thead></table></div></div>");
$templateCache.put("app/main/planejamento-scrum/cadastro/tipo-historia/views/tipo-historia.html","<div id=\"tipo-historia\" class=\"page-layout simple tabbed\" layout=\"column\"><header-padrao \ntranslate-nome=\"TIPO_HISTORIA.NAVEGACAO\" icone=\"icon-book-multiple-variant\" \nliberar-pesquisa-quando-datatable-ativo=\"vm.controleForm.listarTodasEntidades\" pesquisar=\"vm.pesquisar\">\n</header-padrao><div class=\"content\"><div ui-view=\"tipo-historia-form\"></div></div><div \nui-view=\"tipos-historia-tabela\" ng-if=\"vm.controleForm.listarTodasEntidades\"></div></div>");
$templateCache.put("app/main/planejamento-scrum/estatisticas/estatistica/views/consulta-estatistica.html","<div id=\"consulta-estatistica\" class=\"page-layout carded fullwidth\" layout=\"row\"><div layout=\"column\" flex>\n<header-padrao translate-nome=\"Estatísticas\" icone=\"\" liberar-pesquisa-quando-datatable-ativo=\"false\" \npesquisar=\"vm.pesquisar\"></header-padrao><div layout=\"column\" class=\"mb-135\" ng-cloak flex ms-scroll><div layout=\"row\" \nclass=\"mb-10\" ng-if=\"vm.requisicaoSolicitada\" flex><div layout=\"row\" layout-align=\"center center\" flex><div \nlayout=\"column\" layout-align=\"center center\" class=\"mt-50\"><span class=\"font-weight-500\" style=\"font-size: 16px\">\nCarregando estatísticas</span><md-progress-circular md-mode=\"indeterminate\" md-diameter=\"100\" class=\"md-accent\">\n</md-progress-circular></div></div></div><div class=\"fildset-width\" ng-if=\"!vm.requisicaoSolicitada\" \nlayout-gt-xs=\"row\" flex=\"100\"><ms-widget class=\"card-estatisticas\" ng-repeat=\"sprint in vm.estatistica\" \nflippable=\"false\" layout=\"column\" flex=\"100\" flex-gt-xs=\"25\"><ms-widget-front style=\"background-color: white\"><div \nclass=\"pl-16 pr-8 pv-16 h-55 alinha-texto\" layout=\"row\" layout-align=\"space-between center\" \nstyle=\"background-color: #039BE5\"><div class=\"h3 white-fg titulo-icone\">Sprint: {{sprint.sprintNumero}} <span \nclass=\"icon-checkbox-marked-circle font-size-22 p-8\" ng-if=\"sprint.metaConcluida\"></span> <span \nclass=\"icon-close-circle-outline font-size-22 p-8\" ng-if=\"!sprint.metaConcluida\"></span></div></div><div \nclass=\"pt-8 pb-32\" layout=\"column\" layout-align=\"space-between\"><div flex layout=\"column\"><div layout=\"row\" flex \nclass=\"alinharSprint\"><div layout=\"column\"><span class=\"font-size-14 blue-fg ml-10 espacoLinha font-ipad\" \nng-class=\"{\'nao-exibe-titulo\': card.valor == 8}\" ng-repeat=\"card in vm.cards\">{{card.titulo}}:</span></div><div \nlayout=\"column\"><span class=\"font-size-14 blue-fg ml-10 mr-10 espacoLinha font-ipad\">{{sprint.pontuacaoEntregue}}\n</span> <span class=\"font-size-14 blue-fg ml-10 mr-10 espacoLinha font-ipad\">{{sprint.historiasDesenvolvidas}}</span> \n<span class=\"font-size-14 green-fg ml-10 mr-10 espacoLinha font-ipad\">{{sprint.historiasHomologadas}}</span> <span \nclass=\"font-size-14 green-fg ml-10 mr-10 espacoLinha font-ipad\">{{sprint.pontuacaoHomologada}}</span> <span \nclass=\"font-size-14 orange-fg ml-10 mr-10 espacoLinha font-ipad\">{{sprint.totalMelhorias}}</span> <span \nclass=\"font-size-14 red-fg ml-10 mr-10 espacoLinha font-ipad\">{{sprint.totalErros}}</span> <span \nclass=\"font-size-14 red-fg ml-10 mr-10 espacoLinha font-ipad\">{{sprint.pontuacaoPerdida}}</span></div></div></div>\n</div></ms-widget-front></ms-widget></div><div class=\"totalizadores\" layout=\"row\" ng-if=\"!vm.requisicaoSolicitada\"><div\n class=\"card-estatisticas\" layout-gt-xs=\"row\" layout-align=\"center center\" flex><md-card class=\"card-tamanho\" \nng-class=\"{\'metas-alcancadas\': card.valor == 8}\" flex-gt-xs=\"20\" flex=\"100\" layout-align=\"center center\" \nng-repeat=\"card in vm.cards\" ng-click=\"vm.metodos.abrirDialogGrafico($event,card.titulo)\" \nng-if=\"(vm.exibeCardMetasConcluidas && card.valor == 8) || card.valor != 8\"><md-card-header class=\"header-texto\">\n<md-card-header-text layout=\"column\" class=\"header-texto\"><div layout=\"row\" flex layout-align=\"center\"><div flex=\"90\" \nlayout-align=\"center center\" style=\"display: flex\"><span class=\"font-size-14 font-ipad titulo-card-totalizador\">\n{{card.titulo}}</span></div></div></md-card-header-text></md-card-header><md-card-title class=\"titulo\" \nng-class=\"{\'alinhaTexto\':card.valor == 4 && vm.tresUltimas}\"><md-card-title-text><div \nclass=\"font-size-22 line-height-1 ng-binding card-totalizador\" ng-if=\"card.valor == 1\">\n{{vm.estatisticasGeral.pontuacaoEntregue}}</div><div class=\"font-size-22 line-height-1 ng-binding card-totalizador\" \nng-if=\"card.valor == 2\">{{vm.estatisticasGeral.historiasDesenvolvidas}}</div><div \nclass=\"font-size-22 line-height-1 ng-binding card-totalizador\" ng-if=\"card.valor == 3\">\n{{vm.estatisticasGeral.historiasHomologadasTotal}}</div><div \nclass=\"font-size-22 line-height-1 ng-binding card-totalizador\" ng-if=\"!vm.tresUltimas && card.valor == 4\">\n{{vm.estatisticasGeral.pontosHomologados}}</div><div class=\"font-size-22 line-height-1 ng-binding card-totalizador\" \nng-if=\"card.valor == 5\">{{vm.estatisticasGeral.retornoMelhorias}}</div><div \nclass=\"font-size-22 line-height-1 ng-binding card-totalizador\" ng-if=\"card.valor == 6\">\n{{vm.estatisticasGeral.retornoErro}}</div><div class=\"font-size-22 line-height-1 ng-binding card-totalizador\" \nng-if=\"card.valor == 7\">{{vm.estatisticasGeral.pontosPerdidos}}</div><div \nclass=\"font-size-22 line-height-1 ng-binding card-totalizador\" ng-if=\"card.valor == 8\">\n{{vm.estatisticasGeral.metaConcluida}}</div></md-card-title-text></md-card-title><md-card-content><p></p>\n</md-card-content></md-card></div></div><div class=\"button-float\"><md-button ng-click=\"vm.toggleRight()\" \nng-hide=\"vm.isOpenRight()\" class=\"md-primary button-toogle icon-filter-outline md-fab\" aria-label=\"Gerar Backlog\">\n</md-button></div></div><md-sidenav class=\"md-sidenav-right md-whiteframe-4dp\" md-component-id=\"right\"><md-toolbar \nstyle=\"background-color: #039BE5\"><h1 class=\"md-toolbar-tools\">Filtro</h1></md-toolbar><md-content layout-padding flex>\n<form name=\"vm.form.filtros\"><fieldset><legend class=\"grp-legend\">Por sprint</legend><md-input-container \nng-if=\"vm.squadUsuarioLogado.length > 1\" class=\"md-block\" flex-gt-sm=\"100\"><label>Squad</label><md-select \nng-model=\"vm.consultaEstatistica.squadCodigo\" name=\"squadCodigo\" ng-required=\"true\" \nng-change=\"vm.metodos.selectChangeSquad(vm.consultaEstatistica.squadCodigo)\"><md-option ng-value=\"squad.codigo\" \nng-repeat=\"squad in vm.squads track by squad.codigo\">{{squad.descricao}}</md-option></md-select><div \nng-messages=\"vm.form.filtros.squadCodigo.$error\"><div ng-message=\"required\">Campo obrigatório</div></div>\n</md-input-container><md-input-container flex-gt-sm=\"100\" class=\"md-block\"><label>Ano</label><md-select name=\"ano\" \nng-model=\"vm.sprintAno\" ng-change=\"vm.metodos.retornaSprintPorAno(vm.sprintAno, vm.consultaEstatistica.squadCodigo)\" \nrequired=\"true\"><md-option ng-repeat=\"item in vm.ano | orderBy:item:true\" ng-value=\"item\">{{ item }}</md-option>\n<md-option ng-if=\"!vm.ano.length\" disabled=\"disabled\">Nenhum ano encontrado.</md-option></md-select><div \nng-messages=\"vm.form.filtros.ano.$error\"><div ng-message=\"required\">Campo obrigatório</div></div></md-input-container>\n<multi-select-directive id=\"select-sprints\" form-name=\"numero\" data=\"vm.sprint\" model=\"vm.consultaEstatistica.sprints\" \nobrigatorio=\"true\" descricao-exibicao=\"descricao\" texto-pesquisa-placeholder=\"Procurar sprint...\" \ntexto-placeholder=\"Número\" disabled=\"!vm.sprint || !vm.sprint.length\" flex></multi-select-directive><div \nlayout=\"column\" flex><md-radio-group layout=\"column\" layout-padding ng-disbaled=\"vm.requisicaoSolicitada\" \nng-model=\"vm.consultaEstatistica.tipoFiltro\"><md-radio-button value=\"{{key}}\" \nng-repeat=\"(key, value) in vm.listarTipoFiltroEstatistica\" aria-label=\"{{value}}\"><label>{{value}}</label>\n</md-radio-button></md-radio-group></div></fieldset></form><div class=\"text-center\"><md-button \nclass=\"md-raised md-accent\" ng-disabled=\"!vm.sprint || !vm.sprint.length\" \nng-click=\"vm.metodos.buscarSprints(vm.consultaEstatistica)\">Filtrar</md-button></div></md-content></md-sidenav></div>\n</div>");
$templateCache.put("app/main/planejamento-scrum/consulta/estoria/views/consulta-estorias.html","<div id=\"consulta-estorias\" class=\"page-layout carded fullwidth\" layout=\"row\"><div layout=\"column\" flex><header-padrao \ntranslate-nome=\"CONSULTAS_ESTORIAS.ESTORIAS\" icone=\"\" liberar-pesquisa-quando-datatable-ativo=\"true\" \npesquisar=\"vm.pesquisar\"></header-padrao><md-content layout-gt-sm=\"row\" class=\"container-filtro\"><form name=\"vm.form\" \nflex-gt-sm=\"20\" ng-if=\"vm.squadUsuarioLogado.length > 1\" ng-hide=\"vm.filtroAtivo\" class=\"campo-squad\"><div><div \nlayout=\"row\" layout-align=\"center center\"><div class=\"md-subheader\"><label>Squad</label></div></div><md-input-container\n class=\"md-block\" flex-gt-sm=\"90\"><label>Squad</label><md-select ng-model=\"vm.squadCodigo\" name=\"squadCodigo\" \nng-required=\"vm.squadUsuarioLogado.length > 1\"><md-option ng-value=\"squad.codigo\" \nng-repeat=\"squad in vm.squads track by squad.codigo\">{{squad.descricao}}</md-option></md-select><div \nng-messages=\"vm.form.squadCodigo.$error\"><div ng-message=\"required\">Campo obrigatório</div></div></md-input-container>\n</div></form><md-divider ng-hide=\"vm.filtroAtivo\" ng-if=\"vm.squadUsuarioLogado.length> 1\"></md-divider><div \nlayout=\"column\" layout-padding flex-gt-sm=\"20\" ng-hide=\"vm.filtroAtivo\"><div layout=\"row\" layout-align=\"center center\">\n<div class=\"md-subheader\"><label translate=\"CONSULTAS_ESTORIAS.TIPO_FILTROS\"></label></div></div><md-radio-group \nng-model=\"vm.tipoFiltro\" ng-change=\"vm.metodos.resetarFiltros()\" layout=\"column\" class=\"container-tipo-filtro\">\n<md-radio-button value=\"geral\" aria-label=\"Geral\"><label translate=\"CONSULTAS_ESTORIAS.FILTRO_GERAL\"></label>\n</md-radio-button><md-radio-button value=\"especifico\" aria-label=\"especifico\"><label \ntranslate=\"CONSULTAS_ESTORIAS.FILTRO_ESPECIFICO\"></label></md-radio-button></md-radio-group></div><md-divider \nng-hide=\"vm.filtroAtivo\" class=\"divisor-tipo-filtro\"></md-divider><div layout=\"column\" layout-padding flex \nng-hide=\"vm.filtroAtivo\"><div layout=\"row\"><div layout=\"row\" layout-align=\"start center\" class=\"md-subheader\" \nng-hide=\"vm.tipoFiltro === \'geral\'\"><label translate=\"CONSULTAS_ESTORIAS.SUGESTAO\"></label></div><div layout=\"row\" \nlayout-align=\"center center\" flex class=\"md-subheader\"><label translate=\"CONSULTAS_ESTORIAS.FILTROS\"></label></div>\n</div><div layout-align=\"center center\" layout=\"row\" ng-show=\"vm.tipoFiltro === \'geral\'\"><md-radio-group \nng-model=\"vm.filtros\" layout=\"row\" layout-align=\"center center\"><md-radio-button value=\"Em Aberto\" \naria-label=\"Usuário Corrent\"><label translate=\"CONSULTAS_ESTORIAS.FILTRO_EM_ABERTO\"></label></md-radio-button>\n<md-radio-button value=\"Em Andamento\" aria-label=\"Em Andamento\"><label \ntranslate=\"CONSULTAS_ESTORIAS.FILTRO_EM_ANDAMENTO\"></label></md-radio-button><md-radio-button value=\"Concluidas\" \naria-label=\"Concluidas\"><label translate=\"CONSULTAS_ESTORIAS.FILTRO_CONCLUIDAS\"></label></md-radio-button>\n<md-radio-button value=\"Em Pausa\" aria-label=\"Em Pausa\"><label translate=\"CONSULTAS_ESTORIAS.FILTRO_EM_PAUSA\"></label>\n</md-radio-button><md-radio-button value=\"Todas\" aria-label=\"Todas\"><label translate=\"CONSULTAS_ESTORIAS.FILTRO_TODAS\">\n</label></md-radio-button></md-radio-group><md-button class=\"md-icon-button button-margin-bottom\" \nng-click=\"vm.metodos.abrirDialogInformativo($event)\"><md-icon md-font-icon=\"icon-information-outline s24\" \nclass=\"cor-icone-padrao icone-informativo\"></md-icon><md-tooltip md-delay=\"300\"><label>Informativo</label></md-tooltip>\n</md-button></div><div layout=\"row\" flex ng-hide=\"vm.tipoFiltro === \'geral\'\"><div layout=\"column\"><md-checkbox \nng-model=\"vm.sugestaoFiltro.concluidas.selecionado\" \nng-click=\"vm.metodos.sugestaoFiltroFiltrosConcluidos(vm.sugestaoFiltro.concluidas)\" aria-label=\"Concluídas\" translate \ntranslate-attr-aria-label=\"CONSULTAS_ESTORIAS.SUGESTAO_CONCLUIDAS\"><label \ntranslate=\"CONSULTAS_ESTORIAS.SUGESTAO_CONCLUIDAS\"></label></md-checkbox><md-checkbox \nng-model=\"vm.sugestaoFiltro.naoConcluidas.selecionado\" \nng-click=\"vm.metodos.sugestaoFiltroFiltrosNaoConcluidos(vm.sugestaoFiltro.naoConcluidas)\" aria-label=\"Não Concluídas\" \ntranslate translate-attr-aria-label=\"CONSULTAS_ESTORIAS.SUGESTAO_NAO_CONCLUIDAS\"><label \ntranslate=\"CONSULTAS_ESTORIAS.SUGESTAO_NAO_CONCLUIDAS\"></label></md-checkbox></div><div><md-input-container \nclass=\"md-block\" layout-align=\"end end\"><md-switch aria-label=\"Ativo\" name=\"ativo\" ng-model=\"vm.prazoAcordado\">\nPrazo acordado</md-switch></md-input-container></div><div layout=\"row\" flex layout-align=\"center center\">\n<md-input-container class=\"md-block\" flex=\"70\"><md-select aria-label=\"Filtros\" ng-model=\"vm.filtros\" name=\"Filtros\" \nmultiple=\"multiple\"><md-option ng-value=\"filtro.codigo\" ng-repeat=\"filtro in vm.filtrosEspecificos\">\n{{filtro.descricao}}</md-option></md-select></md-input-container></div></div><div layout=\"row\" flex \nlayout-align=\"end end\"><md-button class=\"md-raised md-accent\" aria-label=\"Pesquisar\" translate \ntranslate-attr-aria-label=\"CONSULTAS_ESTORIAS.NOVA_CONSULTA\" \nng-click=\"vm.metodos.filtrar(vm.filtros, vm.tipoFiltro, $event)\" \nng-disabled=\"(vm.squadUsuarioLogado.length > 1 && !vm.squadCodigo )|| !vm.filtros || vm.filtros.length === 0\"><span \ntranslate=\"CONSULTAS_ESTORIAS.PESQUISAR\"></span></md-button></div></div><div flex layout-align=\"start center\" \nlayout=\"row\" ng-if=\"vm.filtroAtivo && !vm.requisicaoSolicitada\"><md-button class=\"array-buttons-consultas-estorias\" \naria-label=\"{{item.descricao}}\" ng-repeat=\"item in vm.defineLegendasConsultasEstorias\" \nng-class=\"{\'descricao-selecionada\': vm.legendaSelecionada == $index}\" \nng-click=\"vm.metodos.filtrarTabela(item, $index)\"><md-icon md-font-icon=\"icon-label\" class=\"s16\" \nng-style=\"{\'color\' : item.cor}\"></md-icon><span class=\"title\">{{item.descricao}}</span></md-button></div><div \nlayout=\"row\" flex ng-if=\"vm.filtroAtivo && !vm.requisicaoSolicitada && vm.filtros === \'Usuario Corrente\'\" \nlayout-align=\"center center\"><md-checkbox id=\"consulta-estoria-checkbox-concluidas-usuario-corrente\" \nng-model=\"vm.usuarioCorrenteTodasEstorias\" aria-label=\"Concluídas\" translate \ntranslate-attr-aria-label=\"CONSULTAS_ESTORIAS.USUARIO_CORRENTE_TODAS_ESTORIAS\"><label \ntranslate=\"CONSULTAS_ESTORIAS.USUARIO_CORRENTE_TODAS_ESTORIAS\"></label></md-checkbox></div><div layout=\"row\" \nng-if=\"vm.filtroAtivo && !vm.requisicaoSolicitada\" layout-align=\"end end\"><md-button class=\"md-raised md-accent\" \naria-label=\"Nova Consulta\" translate translate-attr-aria-label=\"CONSULTAS_ESTORIAS.NOVA_CONSULTA\" \nng-click=\"vm.metodos.novaConsulta();\"><span translate=\"CONSULTAS_ESTORIAS.NOVA_CONSULTA\"></span></md-button></div>\n</md-content><md-content><div layout-align=\"start center\" layout=\"row\" \nng-if=\"vm.filtroAtivo && !vm.requisicaoSolicitada\"><div layout=\"row\" layout-align=\"start center\"><span \nclass=\"ml-15 mr-5 text-uppercase\"><strong>Tipo Filtro</strong>: </span>{{vm.tipoFiltro | uppercase}}</div><div \nng-if=\"vm.squadUsuarioLogado.length > 1\" layout=\"row\" layout-align=\"start center\"><span \nclass=\"ml-10 mr-5 text-uppercase\"><strong>Squad</strong>: </span>{{vm.squadCodigoUtilizado | uppercase}}</div><div \nlayout=\"row\" layout-align=\"start center\"><span ng-if=\"vm.prazoAcordado !== undefined\" class=\"ml-10 text-uppercase\">\n<strong>Prazo acordado:</strong> <span>{{vm.prazoAcordado ? \'Sim\' : \'Não\'}}</span> </span><span \nclass=\"ml-10 mr-5 text-uppercase\"><strong>Filtro(s)</strong>: </span>{{vm.filtroUtilizado | uppercase}}</div></div>\n</md-content><md-divider></md-divider><div layout=\"column\" flex layout-align=\"center center\" \nng-show=\"vm.requisicaoSolicitada\"><md-progress-circular md-mode=\"indeterminate\" class=\"md-accent\">\n</md-progress-circular></div><div layout=\"column\" flex ng-show=\"vm.filtroAtivo && !vm.requisicaoSolicitada\"><div \nclass=\"md-padding md-background-bg md-whiteframe-1dp fullpage-datatable\" layout=\"column\" flex><table \nid=\"datatables-consultas-estorias\" class=\"dataTable row-border hover\" datatable=\"ng\" dt-options=\"vm.dtOptions\"><thead>\n<tr><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">História</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Data Entrada</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Data Entrega</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Descrição</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Cliente</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Motivo</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Sistema</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Situação</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Sprint</span></div></th></tr></thead>\n<tbody><tr ng-repeat=\"estoria in vm.estorias\"><td class=\"border-left border-right h3 text-center\" \nng-class=\"{\'cosultas-estoria-vermelho\': estoria.diasRestantes <= 0, \'cosultas-estoria-amarelo\': estoria.diasRestantes <= 7 && estoria.diasRestantes > 0}\" \ndata-order=\"{{estoria.historiaOrdenacao}}\"><div \nstyle=\"display: flex; justify-content: center;\r\n                                    align-items: center; flex-direction: row; gap: 2px\">\n<span style=\"margin-left: -16px\">{{estoria.numero}}/{{estoria.ano}} </span><span style=\"margin-top: 2px\"><button \nng-click=\"vm.metodos.abrirDialogEstoria(estoria)\"><i class=\"icon-open-in-new s16\"></i></button></span></div></td><td>\n{{estoria.dataEntrada | date:\'dd/MM/yyyy\'}}</td><td id=\"td-consultas-estorias{{$index}}\" \nng-dblclick=\"vm.metodos.abrirDialogAlterarDataEstoria($index, estoria, $event)\"><div class=\"border-bottom-azul\">\n{{estoria.dataEntrega | date:\'dd/MM/yyyy\'}}</div></td><td style=\"max-width: 500px !important;\r\n  display: flex\">\n{{estoria.descricao}}</td><td>{{estoria.clienteNome}}</td><td>{{estoria.motivoDescricao}}</td><td>\n{{estoria.solucaoDescricao}}</td><td>{{estoria.situacaoDescricao}}</td><td class=\"text-center\">\n{{ estoria.sprintNumero ? estoria.sprintNumero : \'-\' }}</td></tr></tbody></table></div></div></div></div>");
$templateCache.put("app/main/planejamento-scrum/consulta/controle-versao/views/consulta-controle-versao.html","<div id=\"consulta-controle-versao\" class=\"page-layout carded fullwidth\" layout=\"row\"><div layout=\"column\" flex>\n<header-padrao translate-nome=\"CONSULTAS_CONTROLE_VERSAO.CONTROLE_VERSAO\" icone=\"\" \nliberar-pesquisa-quando-datatable-ativo=\"true\" pesquisar=\"vm.pesquisar\"></header-padrao><form \nname=\"vm.form.consultaControleVersao\" novalidate><md-content layout-padding ng-hide=\"vm.pesquisaAtiva\"><div \nlayout-gt-sm=\"row\" layout-align=\"center center\" flex><md-input-container class=\"md-block\" flex flex-gt-sm=\"30\" \nng-if=\"vm.squadUsuarioLogado.length > 1\"><label>Squad</label><md-select ng-model=\"vm.consultaVersao.squadCodigo\" \nname=\"squadCodigo\" ng-change=\"vm.metodosControleVersao.selectChangeSquad(vm.consultaVersao.squadCodigo)\" \nng-required=\"true\"><md-option ng-value=\"squad.codigo\" ng-repeat=\"squad in vm.squads track by squad.codigo\">\n{{squad.descricao}}</md-option></md-select></md-input-container><md-input-container class=\"md-block\" flex-gt-sm=\"25\" \nflex-offset-gt-sm=\"3\" flex-gt-xs><label translate=\"CONSULTAS_CONTROLE_VERSAO.SOLUCAO\">Solução</label><md-select \nng-model=\"vm.consultaVersao.solucaoCodigo\" name=\"consultaVersaoSolucaoCodigo\" ng-required=\"true\" \nmd-on-open=\"vm.metodosControleVersao.configuraMdSelectSolucao()\" \nng-change=\"vm.metodosControleVersao.redefineVersoesEReleases()\" \nng-disabled=\"!vm.consultaVersao.squadCodigo && vm.squadUsuarioLogado.length > 1\"><md-select-header><input \nid=\"consulta-controle-versao-solucao-md-select\" class=\"md-text\" ng-model=\"vm.filtrarSolucoes\" type=\"search\" \nplaceholder=\"\" translate translate-attr-placeholder=\"CONSULTAS_CONTROLE_VERSAO.PESQUISAR_SOLUCAO\"></md-select-header>\n<md-option ng-value=\"solucao.codigo\" \nng-repeat=\"solucao in vm.solucoes | filter:vm.filtrarSolucoes track by solucao.codigo\">{{solucao.descricao}}\n</md-option></md-select><div ng-messages=\"vm.form.consultaControleVersao.consultaVersaoSolucaoCodigo.$error\"><div \nng-message=\"required\" translate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container>\n<md-input-container class=\"md-block\" flex-gt-sm=\"25\" flex-offset-gt-sm=\"3\" flex-gt-xs><label \ntranslate=\"CONSULTAS_CONTROLE_VERSAO.VERSOES\">Versões</label><md-select ng-model=\"vm.consultaVersao.versoes\" \nname=\"consultaVersaoVersoes\" \nmd-on-open=\"vm.metodosControleVersao.configuraMdSelectVersoes(vm.consultaVersao.solucaoCodigo)\" \nng-change=\"vm.metodosControleVersao.redefineReleases()\" ng-disabled=\"!vm.consultaVersao.solucaoCodigo\" \nmultiple=\"multiple\"><div ng-if=\"vm.requisicaoPesquisaVersaoSolicitada\" layout-align=\"center center\">\n<md-progress-circular md-mode=\"indeterminate\" class=\"md-accent\"></md-progress-circular></div><md-option \nng-hide=\"vm.requisicaoPesquisaVersaoSolicitada\" ng-value=\"versao.numero\" \nng-repeat=\"versao in vm.versoes | filter:vm.filtrarVersoes\">{{versao.numero}}</md-option></md-select>\n</md-input-container><md-input-container class=\"md-block\" flex-gt-sm=\"25\" flex-offset-gt-sm=\"3\" flex-gt-xs><label \ntranslate=\"CONSULTAS_CONTROLE_VERSAO.RELEASES\">Releases</label><md-select ng-model=\"vm.consultaVersao.releases\" \nname=\"consultaVersaoVersoes\" md-on-open=\"vm.metodosControleVersao.configuraMdSelectReleases(vm.consultaVersao)\" \nng-disabled=\"!vm.consultaVersao.versoes ||vm.consultaVersao.versoes.length === 0\" multiple=\"multiple\"><div \nng-if=\"vm.requisicaoPesquisaReleaseSolicitada\" layout-align=\"center center\"><md-progress-circular \nmd-mode=\"indeterminate\" class=\"md-accent\"></md-progress-circular></div><md-option \nng-hide=\"vm.requisicaoPesquisaReleaseSolicitada\" ng-value=\"release.release\" ng-repeat=\"release in vm.releases\">\n{{release.release}}</md-option></md-select></md-input-container></div><div flex layout=\"row\" layout-align=\"end end\">\n<md-button type=\"submit\" class=\"md-raised md-accent\" aria-label=\"Pesquisar\" translate \ntranslate-attr-aria-label=\"CONSULTAS_CONTROLE_VERSAO.PESQUISAR\" \nng-click=\"vm.metodosControleVersao.pesquisar(vm.consultaVersao)\" \nng-disabled=\"vm.form.consultaControleVersao.$invalid || vm.requisicaoPesquisaReleaseSolicitada || vm.requisicaoPesquisaVersaoSolicitada\">\n<span translate=\"CONSULTAS_CONTROLE_VERSAO.PESQUISAR\"></span></md-button></div></md-content></form><div \nlayout=\"column\" flex layout-align=\"center center\" ng-show=\"vm.requisicaoSolicitada\"><md-progress-circular \nmd-mode=\"indeterminate\" class=\"md-accent\"></md-progress-circular></div><div layout=\"column\" flex \nng-include=\"vm.rotasHtml.tabelaControleVersao\" ng-show=\"vm.pesquisaAtiva && !vm.requisicaoSolicitada\"></div></div>\n</div>");
$templateCache.put("app/main/planejamento-scrum/consulta/controle-versao/views/consulta-tabela-controle-versao.html","<div layout=\"column\" class=\"md-background-bg\" id=\"consulta-controle-versao-tabela\"><div layout=\"row\" \nlayout-align=\"start center\"><span class=\"ml-15 mr-5 mt-15 text-uppercase\" ng-if=\"vm.squadUsuarioLogado.length > 1\">\n<strong>Squad</strong>: {{vm.squadUtilizada | uppercase}}</span> <span class=\"ml-15 mr-5 mt-15 text-uppercase\"><strong>\nSolução</strong>: {{vm.solucaoUtilizada | uppercase}}</span> <span class=\"ml-15 mr-5 mt-15 text-uppercase\"><strong>\nVersão(s)</strong>: {{vm.versoesUtilizadas | uppercase}}</span> <span class=\"ml-15 mr-5 mt-15 text-uppercase\"><strong>\nRelease(s)</strong>: {{vm.releasesUtilizadas | uppercase}}</span></div><div layout=\"row\" layout-align=\"end end\">\n<md-button class=\"md-raised md-accent\" aria-label=\"Nova Consulta\" translate \ntranslate-attr-aria-label=\"CONSULTAS_LOG.NOVA_CONSULTA\" ng-click=\"vm.metodosControleVersao.novaConsulta();\"><span \ntranslate=\"CONSULTAS_LOG.NOVA_CONSULTA\"></span></md-button></div></div><div \nclass=\"md-background-bg md-whiteframe-1dp fullpage-datatable\" layout=\"column\" flex><table \nclass=\"dataTable row-border hover\" datatable=\"ng\" dt-options=\"vm.dtOptionsLog\"><thead><tr><th class=\"secondary-text\">\n<div class=\"table-header\"><span class=\"column-title\">Versão</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Release</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">História</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title text-center\">Descrição</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title text-center\">Data entrada</span></div></th><th class=\"secondary-text\">\n<div class=\"table-header\"><span class=\"column-title text-center\">Data entrega</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title text-center\">Situação</span></div></th></tr>\n</thead><tbody><tr ng-repeat=\"estoria in vm.estoriasnasVersoesGeradasPelaPesquisa\"><td>{{estoria.versao}}</td><td>\n{{estoria.release}}</td><td>{{estoria.numero}}/{{estoria.ano}}</td><td>{{estoria.descricao}}</td><td>\n{{estoria.dataEntrada | date: \'dd/MM/yyyy\'}}</td><td>{{estoria.dataEntrega | date: \'dd/MM/yyyy\'}}</td><td \nstyle=\"margin-left: 20px\"><div class=\"text-center situacao-estoria\" ng-repeat=\"situacao in vm.coresSituacoes\" \nng-if=\"situacao.codigo == estoria.situacaoCodigo\" ng-style=\"{\'background-color\': situacao.cor}\"><span>\n{{situacao.descricao}}</span></div></td></tr></tbody></table></div>");
$templateCache.put("app/main/protecao/cadastro/tipo-licenca/views/protecao-tipo-licenca-form.html","<div class=\"md-background-bg md-whiteframe-1dp\"><form name=\"vm.form\" novalidate><pg-toolbar \nentidades=\"vm.tipoLicencas\" entidade=\"vm.tipoLicenca\" entidade-de-envio=\"vm.entidadeDeEnvio\" \ncontrolador-toolbar=\"vm.controleForm\" acao-pesquisar=\"vm.metodos.pesquisar()\" \nacao-criar=\"vm.metodos.salvar(vm.tipoLicenca)\" acao-editar=\"vm.metodos.editar(vm.tipoLicenca)\" \nacao-excluir=\"vm.metodos.excluir(vm.tipoLicenca)\" construir-dt-options=\"vm.metodos.construirDtOptions()\" \nmetodos-externos=\"vm.metodosExternosPgToolbar\" campo-pesquisar=\"vm.pesquisar\"></pg-toolbar><md-content layout-padding \nng-hide=\"vm.controleForm.listarTodasEntidades\" ng-disabled=\"vm.controleForm.emProgresso\"><div class=\"form-container\">\n<div layout-gt-xs=\"row\"><md-input-container class=\"md-block\" flex><label translate=\"PROTECAO_TIPO_LICENCA.DESCRICAO\">\n</label><input type=\"text\" ng-model=\"vm.tipoLicenca.descricao\" name=\"descricao\" mascara-tamanho-campo=\"150\" \nng-required=\"vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo\" md-maxlength=\"150\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\"><div \nng-messages=\"vm.form.descricao.$error\"><div ng-message=\"required\" translate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\">\n</div></div></md-input-container></div><div layout-gt-xs=\"row\" flex><md-input-container class=\"md-block\" flex><label \ntranslate=\"PROTECAO_TIPO_LICENCA.PRODUTO\"></label><md-select ng-model=\"vm.tipoLicenca.produtos\" name=\"produtos\" \nmultiple=\"multiple\" ng-model-options=\"{trackBy: \'$value.codigo\'}\" md-on-open=\"vm.metodos.configuraMdSelectProduto()\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo || vm.controleForm.emProgresso\">\n<md-select-header><input id=\"tipo-licenca-produto-md-select\" class=\"md-text\" ng-model=\"vm.filtrarProduto\" \ntype=\"search\" placeholder=\"\" translate translate-attr-placeholder=\"PROTECAO_TIPO_LICENCA.PESQUISAR_PRODUTO\">\n</md-select-header><md-option ng-value=\"produto\" \nng-repeat=\"produto in vm.produtos | filter:vm.filtrarProduto track by produto.codigo\">{{produto.descricao}}</md-option>\n</md-select></md-input-container></div></div></md-content></form></div>");
$templateCache.put("app/main/protecao/cadastro/tipo-licenca/views/protecao-tipo-licenca-tabela.html","<div layout=\"column\" flex><div class=\"md-padding md-background-bg md-whiteframe-1dp fullpage-datatable\" \nlayout=\"column\" flex><table class=\"dataTable row-border hover\" id=\"datatable-protecao-cadastro-tipolicenca\" \nwidth=\"100%\"><thead><tr><th>Ação</th><th>Descrição</th></tr></thead></table></div></div>");
$templateCache.put("app/main/protecao/cadastro/tipo-licenca/views/protecao-tipo-licenca.html","<div id=\"protecao-tipo-licenca\" class=\"page-layout simple tabbed\" layout=\"column\"><header-padrao \ntranslate-nome=\"PROTECAO_TIPO_LICENCA.TIPO_LICENCAS\" \nliberar-pesquisa-quando-datatable-ativo=\"vm.controleForm.listarTodasEntidades\" pesquisar=\"vm.pesquisar\">\n</header-padrao><div class=\"content\"><div ui-view=\"protecao-tipo-licenca-form\"></div></div><div \nui-view=\"protecao-tipo-licenca-tabela\" ng-if=\"vm.controleForm.listarTodasEntidades\"></div></div>");
$templateCache.put("app/main/planejamento-scrum/processamento/sprint/views/sprint-form.html","<div class=\"md-background-bg md-whiteframe-1dp\" flex><form name=\"vm.form.sprintForm\" novalidate><pg-toolbar \nentidades=\"vm.sprints\" entidade=\"vm.sprint\" entidade-de-envio=\"vm.entidadeDeEnvio\" \ncontrolador-toolbar=\"vm.controleForm\" controlador-pre-loader=\"vm.controlePreloader\" \nacao-pesquisar=\"vm.metodosSprint.pesquisar()\" acao-criar=\"vm.metodosSprint.salvar(vm.sprint)\" \nacao-editar=\"vm.metodosSprint.editar(vm.sprint)\" acao-excluir=\"vm.metodosSprint.excluir(vm.sprint)\" \nconstruir-dt-options=\"vm.metodosSprint.construirDtOptions()\" \nmetodo-externo-acao-navegacao=\"vm.metodosGeral.redefineConfiguracoesIniciaisNoFormulario()\" \nmetodo-externo-acao-nova-pesquisa=\"vm.metodosGeral.novaPesquisa()\" \nmetodo-externo-atualizar-entidade-externamente=\"vm.metodosGeral.atualizarNoController()\" \ncontrolador-atualizar-entidade-externamente=\"vm.tabSelecionada != \'sprint\'\" \npre-definir-campos-para-insercao=\"vm.metodosGeral.preDefinirCamposParaInserir()\" \npre-definir-campos-para-edicao=\"vm.metodosGeral.preDefinirCamposParaEdicao()\" \nmetodos-externos=\"vm.metodosExternosPgToolbar\" campo-pesquisar=\"vm.pesquisar\" \ndesabilitar-botao-pesquisar=\"(vm.squadUsuarioLogado.length > 1 && !vm.sprint.squadCodigo)\" \ndesabilitar-botao-listar-todas-entidades=\"vm.desabilitarModoTabela\" \niniciar-chamando-pesquisa=\"vm.iniciarChamandoPesquisa\" \ndesabilitar-botoes-navegacao=\"vm.templateSelecionadoSprintBacklog.view !== \'viewTabelaSprintBacklog\'\"></pg-toolbar>\n<md-content layout-padding ng-hide=\"vm.controleForm.listarTodasEntidades\" ng-disabled=\"vm.controleForm.emProgresso\">\n<md-tabs md-dynamic-height md-border-bottom><md-tab label=\"Sprint\" md-active=\"vm.tabSelecionada === \'sprint\'\" \nmd-on-select=\"vm.metodosGeral.tabSelecionada(\'sprint\')\" \nng-disabled=\"vm.templateSelecionadoSprintBacklog.cadastroAtivo || vm.controladorSprint.tabRecursos.editar\r\n                        || vm.controladorSprint.tabAbatimentos.editar || vm.controladorSprint.tabLimites.editar ||  vm.controleForm.emProgresso\">\n<md-tab-label><label translate=\"SPRINT.SPRINT\"></label></md-tab-label><md-tab-body><div \nng-include=\"vm.htmlRota.tabs.sprint\"></div></md-tab-body></md-tab><md-tab label=\"Backlog\" \nmd-active=\"vm.tabSelecionada === \'backlog\'\" md-on-select=\"vm.metodosGeral.tabSelecionada(\'backlog\')\" \nng-disabled=\"!vm.controleForm.pesquisaAtiva || vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo\r\n                            || vm.controladorSprint.tabRecursos.editar || vm.controladorSprint.tabAbatimentos.editar\r\n                            || vm.controladorSprint.tabLimites.editar || vm.controleForm.emProgresso\">\n<md-tab-label><label translate=\"SPRINT.BACKLOG\"></label></md-tab-label><md-tab-body><div \nng-if=\"vm.tabSelecionada == \'backlog\'\" ng-include=\"vm.htmlRota.tabs.backlog\"></div></md-tab-body></md-tab><md-tab \nlabel=\"Registros\" md-on-select=\"vm.metodosGeral.tabSelecionada(\'registros\')\" \nng-disabled=\"!vm.controleForm.pesquisaAtiva || vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo\r\n                        || vm.templateSelecionadoSprintBacklog.cadastroAtivo || vm.controladorSprint.tabRecursos.editar\r\n                        || vm.controladorSprint.tabAbatimentos.editar || vm.controladorSprint.tabLimites.editar || vm.controleForm.emProgresso\">\n<md-tab-label><label translate=\"SPRINT.REGISTROS\"></label></md-tab-label><md-tab-body><div \nng-if=\"vm.tabSelecionada == \'registros\'\" ng-include=\"vm.htmlRota.tabs.registros\"></div></md-tab-body></md-tab><md-tab \nlabel=\"Meta\" md-on-select=\"vm.metodosGeral.tabSelecionada(\'metas\')\" \nng-disabled=\"!vm.controleForm.pesquisaAtiva || vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo\r\n                        || vm.templateSelecionadoSprintBacklog.cadastroAtivo || vm.controladorSprint.tabRecursos.editar\r\n                        || vm.controladorSprint.tabAbatimentos.editar || vm.controladorSprint.tabLimites.editar || vm.controleForm.emProgresso\">\n<md-tab-label><label translate=\"SPRINT.METAS\"></label></md-tab-label><md-tab-body><div \nng-if=\"vm.tabSelecionada == \'metas\'\" ng-include=\"vm.htmlRota.tabs.metas\"></div></md-tab-body></md-tab><md-tab \nlabel=\"Estatísticas\" md-on-select=\"vm.metodosGeral.tabSelecionada(\'estatisticas\')\" \nng-disabled=\"!vm.controleForm.pesquisaAtiva || vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo\r\n                        || vm.templateSelecionadoSprintBacklog.cadastroAtivo || vm.controladorSprint.tabRecursos.editar\r\n                        || vm.controladorSprint.tabAbatimentos.editar || vm.controleForm.emProgresso\">\n<md-tab-label><label translate=\"SPRINT.ESTATISTICAS\"></label></md-tab-label><md-tab-body><div \nng-if=\"vm.tabSelecionada == \'estatisticas\'\" ng-include=\"vm.htmlRota.tabs.estatisticas\"></div></md-tab-body></md-tab>\n<md-tab label=\"Pontuação\" md-on-select=\"vm.metodosGeral.tabSelecionada(\'pontuacao\')\" \nng-disabled=\"!vm.controleForm.pesquisaAtiva || vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo\r\n                                        || vm.templateSelecionadoSprintBacklog.cadastroAtivo || vm.controladorSprint.tabRecursos.editar\r\n                                        || vm.controladorSprint.tabAbatimentos.editar || vm.controleForm.emProgresso\">\n<md-tab-label><label translate=\"SPRINT.PONTUACAO\"></label></md-tab-label><md-tab-body><div \nng-if=\"vm.tabSelecionada == \'pontuacao\'\" ng-include=\"vm.htmlRota.tabs.pontuacao\"></div></md-tab-body></md-tab><md-tab \nlabel=\"Cerimônia Detalhe\" md-on-select=\"vm.metodosGeral.tabSelecionada(\'cerimoniaDetalhe\')\" \nng-disabled=\"!vm.controleForm.pesquisaAtiva || vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo\r\n                        || vm.templateSelecionadoSprintBacklog.cadastroAtivo || vm.controladorSprint.tabRecursos.editar\r\n                        || vm.controladorSprint.tabAbatimentos.editar || vm.controladorSprint.tabLimites.editar || vm.controleForm.emProgresso\">\n<md-tab-label><label translate=\"SPRINT.CERIMONIA_DETALHE\"></label></md-tab-label><md-tab-body><div \nng-if=\"vm.tabSelecionada == \'cerimoniaDetalhe\'\" ng-include=\"vm.htmlRota.tabs.cerimoniaDetalhe\"></div></md-tab-body>\n</md-tab><md-tab label=\"Versão Entregue\" md-on-select=\"vm.metodosGeral.tabSelecionada(\'versaoEntregue\')\" \nng-disabled=\"!vm.controleForm.pesquisaAtiva || vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo\r\n                        || vm.templateSelecionadoSprintBacklog.cadastroAtivo || vm.controladorSprint.tabRecursos.editar\r\n                        || vm.controladorSprint.tabAbatimentos.editar || vm.controladorSprint.tabLimites.editar || vm.controleForm.emProgresso\">\n<md-tab-label><label translate=\"SPRINT.VERSAO_ENTREGUE\"></label></md-tab-label><md-tab-body><div \nng-if=\"vm.tabSelecionada == \'versaoEntregue\'\" ng-include=\"vm.htmlRota.tabs.versaoEntregue\"></div></md-tab-body>\n</md-tab></md-tabs></md-content></form></div>");
$templateCache.put("app/main/planejamento-scrum/processamento/sprint/views/sprint.html","<div id=\"sprint\" class=\"page-layout simple tabbed\" layout=\"column\" layout-fill><header-padrao \ntranslate-nome=\"SPRINT.SPRINT\" texto-auxiliar=\"vm.sprint.numero\" \ntexto-auxiliar-habilitado=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.inserirAtivo\" icone=\"icon-book-variant\" \nliberar-pesquisa-quando-datatable-ativo=\"vm.controleForm.pesquisarDatatable || !vm.controleForm.emProgresso\" \npesquisar=\"vm.pesquisar\"></header-padrao><div id=\"container-sprint\" class=\"content\" ms-scroll><div \nui-view=\"sprint-form\"></div></div><div ui-view=\"sprints-tabela\" ng-if=\"vm.controleForm.listarTodasEntidades\" ms-scroll>\n</div></div>");
$templateCache.put("app/main/planejamento-scrum/processamento/sprint/views/sprints-tabela.html","<div layout=\"column\" flex><div class=\"md-padding md-background-bg md-whiteframe-1dp fullpage-datatable\" \nlayout=\"column\" flex><table class=\"dataTable row-border hover\" id=\"datatable-sprint\" width=\"100%\"><thead><tr><th>Ação\n</th><th>Squad</th><th>Número</th><th>Data Inicial</th><th>Data Final</th><th>Descrição</th></tr></thead></table></div>\n</div>");
$templateCache.put("app/main/planejamento-scrum/estatisticas/estatistica-individual/views/estatistica-individual.form.html","<div id=\"estatistica-individual-form\" class=\"pt-10 pb-10\"><div class=\"button-float\"><md-button \nclass=\"md-primary icon-filter-outline md-fab\" aria-label=\"Abrir filtro\" ng-click=\"vm.metodos.abrirFiltro()\" \nng-hide=\"false\"></md-button></div><div ng-if=\"vm.dadosDashboard\" layout=\"column\" flex><div layout=\"column\" \nlayout-align=\"center center\"><h1 class=\"text-bold\">{{ vm.dadosDashboard.colaborador }}</h1><nvd3 \noptions=\"vm.multiBarChart.options\" data=\"vm.multiBarChart.data\"></nvd3></div><div layout=\"column\" layout-gt-sm=\"row\" \nlayout-align=\"start space-between\" flex=\"100\"><ms-widget class=\"h-100\" layout=\"column\" flex=\"100\"><ms-widget-front \nclass=\"p-4 blue-bg white-fg\" layout=\"column\" layout-align=\"center center\" flex=\"100\"><div \nclass=\"card-botao font-weight-500 font-size-16 h-45\" layout=\"row\" flex=\"100\">Histórias desenvolvidas<md-button \nclass=\"md-icon-button\" ng-disabled=\"!vm.dadosDashboard.totalizadores.totalHistoriasDesenvolvidos\" \nng-click=\"vm.metodos.abrirDialogVisualizarEstorias(6, vm.dadosDashboard.historiasDesenvolvidas)\"><i \nclass=\"icon-information-outline s20\"></i></md-button></div><div class=\"font-size-18 text-center\" layout=\"row\" \nflex=\"100\">{{ vm.dadosDashboard.totalizadores.totalHistoriasDesenvolvidos }}</div></ms-widget-front></ms-widget>\n<ms-widget class=\"h-100\" layout=\"column\" flex=\"100\"><ms-widget-front class=\"p-4 blue-bg white-fg\" layout=\"column\" \nlayout-align=\"center center\" flex=\"100\"><div class=\"font-weight-500 font-size-16 h-45 pt-5\">Pontos desenvolvidos</div>\n<div class=\"font-size-18 text-center\">{{ vm.dadosDashboard.totalizadores.totalPontosDesenvolvidos }}</div>\n</ms-widget-front></ms-widget><ms-widget class=\"h-100\" layout=\"column\" flex=\"100\"><ms-widget-front \nclass=\"p-4 blue-bg white-fg\" layout=\"column\" layout-align=\"center center\" flex=\"100\"><div \nclass=\"card-botao font-weight-500 font-size-16 h-45\" layout=\"row\" flex=\"100\">Retorno de melhoria<md-button \nclass=\"md-icon-button\" ng-disabled=\"!vm.dadosDashboard.totalizadores.totalRetornoMelhoria\" \nng-click=\"vm.metodos.abrirDialogVisualizarEstorias(3, vm.dadosDashboard.retornoMelhoria)\"><i \nclass=\"icon-information-outline s20\"></i></md-button></div><div class=\"font-size-18 text-center\" layout=\"row\" \nflex=\"100\">{{ vm.dadosDashboard.totalizadores.totalRetornoMelhoria }}</div></ms-widget-front></ms-widget><ms-widget \nclass=\"h-100\" layout=\"column\" flex=\"100\"><ms-widget-front class=\"p-4 blue-bg white-fg\" layout=\"column\" \nlayout-align=\"center center\" flex=\"100\"><div class=\"card-botao font-weight-500 font-size-16 h-45\" layout=\"row\" \nflex=\"100\">Retorno de erro<md-button class=\"md-icon-button\" \nng-disabled=\"!vm.dadosDashboard.totalizadores.totalRetornoErro\" \nng-click=\"vm.metodos.abrirDialogVisualizarEstorias(1, vm.dadosDashboard.retornoErro)\"><i \nclass=\"icon-information-outline s20\"></i></md-button></div><div class=\"font-size-18 text-center\" layout=\"row\" \nflex=\"100\">{{ vm.dadosDashboard.totalizadores.totalRetornoErro }}</div></ms-widget-front></ms-widget><ms-widget \nclass=\"h-100\" layout=\"column\" flex=\"100\"><ms-widget-front class=\"p-4 blue-bg white-fg\" layout=\"column\" \nlayout-align=\"center center\" flex=\"100\"><div class=\"font-weight-500 font-size-16 h-45 pt-5\">Pontos perdidos</div><div \nclass=\"font-size-18 text-center\">{{ vm.dadosDashboard.totalizadores.totalPontosPerdidos }}</div></ms-widget-front>\n</ms-widget></div></div></div>");
$templateCache.put("app/main/planejamento-scrum/estatisticas/estatistica-individual/views/estatistica-individual.html","<div id=\"estatistica-individual\" class=\"page-layout simple tabbed\" layout=\"column\"><carregamento-circular \nem-progresso=\"vm.emProgresso\" titulo=\"Aguarde...\" mensagem=\"Buscando dados...\"></carregamento-circular><md-sidenav \nclass=\"sidenav md-sidenav-right\" md-component-id=\"filtro-estatistica-individual\" md-whiteframe=\"4\" \nui-view=\"filtro-estatistica-individual@app.planejamentoscrum_estatistica_estatisticaindividual\" ms-scroll \nms-sidenav-helper></md-sidenav><header-padrao translate-nome=\"Estatística individual\" icone=\"icon-chart-bar\" \nng-utiliza-pesquisa=\"false\"></header-padrao><div class=\"content-card\" layout=\"column\" flex><div class=\"content\" flex \nms-scroll><div ui-view=\"estatistica-individual-form\"></div></div></div></div>");
$templateCache.put("app/main/planejamento-scrum/processamento/estoria/views/estoria-form.html","<div class=\"md-background-bg md-whiteframe-1dp\"><md-fab-speed-dial md-direction=\"left\" \nstyle=\"position: absolute; right: 0px; top: 170px; z-index: 999\" layout-align=\"end start\" ng-init=\"menuAberto = false\" \nng-if=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.inserirAtivo && vm.tabSelecionada == \'estoria\'\">\n<md-fab-trigger><md-button aria-label=\"menu\" class=\"md-fab md-accent md-icon-button botao-menu\" \nng-click=\"menuAberto = !menuAberto\"><md-icon ng-disabled=\"true\" md-font-icon=\"icon-menu s26\"></md-icon><md-icon \nclass=\"s12 icone-historia-vinculada-menu\" md-font-icon=\"icon-checkbox-blank-circle\" \nng-if=\"vm.estoria.possuiVinculo && !menuAberto\" layout-align=\"end end\"></md-icon></md-button></md-fab-trigger>\n<md-fab-actions ng-show=\"menuAberto\"><div layout=\"column\" style=\"position:relative\" flex-offset-xs=\"5\"><md-button \nclass=\"md-fab md-raised md-mini md-accent\" ng-click=\"vm.metodosEstoria.abrirDialogHistoriasVinculadas(vm.estoria)\" \nng-disabled=\"vm.controleForm.emProgresso\"><md-icon md-font-icon=\"icon-playlist-plus s24\"></md-icon><md-icon \nclass=\"s12 icone-historia-vinculada\" md-font-icon=\"icon-checkbox-blank-circle\" ng-if=\"vm.estoria.possuiVinculo\" \nlayout-align=\"end end\"></md-icon><md-tooltip md-autohide>Vincular histórias</md-tooltip></md-button></div><div \nlayout=\"column\" style=\"position:relative\" flex-offset-xs=\"5\"><md-button class=\"md-fab md-raised md-mini md-accent\" \nng-click=\"vm.metodosEstoria.abrirDialogHistoricoAlteracaoDataEntrega(vm.estoria)\" \nng-disabled=\"vm.controleForm.emProgresso || vm.buscandoHistoricoAlteracaoDataEntrega\r\n                    \"><md-icon \nmd-font-icon=\"icon-history s24\" ng-if=\"!vm.buscandoHistoricoAlteracaoDataEntrega\"></md-icon><div \nng-if=\"vm.buscandoHistoricoAlteracaoDataEntrega\" style=\"margin-left: 2px\"><md-progress-circular class=\"md-accent\" \nmd-diameter=\"24\" md-mode=\"indeterminate\"></md-progress-circular></div><md-tooltip md-autohide>\nHistórico de alteração de data de entrega</md-tooltip></md-button></div></md-fab-actions></md-fab-speed-dial><form \nname=\"vm.estoriaForm\" novalidate><pg-toolbar iniciar-chamando-pesquisa=\"vm.estoria.chamarPesquisa\" \nentidades=\"vm.estorias\" entidade=\"vm.estoria\" entidade-de-envio=\"vm.entidadeDeEnvio\" \ncontrolador-toolbar=\"vm.controleForm\" controlador-pre-loader=\"vm.controlePreloader\" \nacao-pesquisar=\"vm.metodosEstoria.pesquisar()\" acao-criar=\"vm.metodosEstoria.salvar(vm.estoria)\" \nacao-editar=\"vm.metodosEstoria.editar(vm.estoria)\" acao-pos-editar=\"vm.metodosEstoria.acaoPosEditar()\" \nacao-pos-criar=\"vm.metodosEstoria.aoSalvarConcluido()\" acao-excluir=\"vm.metodosEstoria.excluir(vm.estoria)\" \nmetodo-externo-acao-navegacao=\"vm.metodosGeral.preDefinirValoresQuandoNavegado()\" \nmetodo-externo-acao-nova-pesquisa=\"vm.metodosGeral.novaPesquisa()\" \npre-definir-campos-para-insercao=\"vm.metodosGeral.preDefinirCamposParaInserir()\" \npre-definir-campos-para-edicao=\"vm.metodosGeral.PreDefinirCamposParaEdicao()\" texto-exibido=\"vm.textoExibidoToolbar\" \niniciar-chamando-pesquisa=\"vm.iniciarChamandoPesquisa\" iniciar-habilitando-insercao=\"vm.iniciarHabilitandoInsercao\" \nconstruir-dt-options=\"vm.metodosEstoria.construirDtOptions()\" metodos-externos=\"vm.metodosExternosPgToolbar\" \ncampo-pesquisar=\"vm.pesquisar\" metodo-externo-acao-reverter=\"vm.metodosGeral.reverter()\" \ndesabilitar-botao-inserir=\"vm.metodosEstoria.desabilitaBotoesManipulacaoEstoria()\" utiliza-botao-clonar=\"true\" \ndefinir-campos-clonados=\"vm.metodosGeral.definirCamposClonados()\" \ndesabilitar-botao-editar=\"vm.metodosEstoria.desabilitaBotoesExcetoEdicaoManipulacaoEstoria()\" \ndesabilitar-botao-clonar=\"vm.metodosEstoria.desabilitaBotaoClonar()\" \ndesabilitar-botao-nova-pesquisa=\"vm.metodosEstoria.desabilitarBotaoEditandoRequisito()\" \ndesabilitar-botao-atualizar=\"vm.metodosEstoria.desabilitarBotaoEditandoRequisito()\" \ndesabilitar-botao-listar-todas-entidades=\"vm.metodosEstoria.desabilitarBotaoEditandoRequisito()\" \ndesabilitar-botao-excluir=\"vm.metodosEstoria.desabilitaBotoesManipulacaoEstoria()\" \ndesabilitar-botao-pesquisar=\"(vm.squadUsuarioLogado.length > 1 && !vm.estoria.squadCodigos.length)\"></pg-toolbar>\n<md-content layout-padding ng-hide=\"vm.controleForm.listarTodasEntidades\" ng-disabled=\"vm.controleForm.emProgresso\">\n<md-tabs md-dynamic-height md-border-bottom><md-tab label=\"Estória\" md-active=\"vm.tabSelecionada === \'estoria\'\" \nmd-on-select=\"vm.metodosGeral.tabSelecionada(\'estoria\')\" \nng-disabled=\"vm.controladorEstoria.editarEstimativa || vm.controladorEstoria.editarPriorizacao\r\n                || vm.controladorEstoria.editarTarefas || vm.controladorEstoria.editarRequisito || vm.controleForm.emProgresso\">\n<md-tab-label><label translate=\"ESTORIA.ESTORIA\">História</label></md-tab-label><md-tab-body><div \nng-if=\"vm.tabSelecionada == \'estoria\'\" ng-include=\"vm.htmlRota.tabs.estoria\"></div></md-tab-body></md-tab><md-tab \nlabel=\"Clientes\" md-on-select=\"vm.metodosGeral.tabSelecionada(\'clientes\')\" \nng-disabled=\"!vm.controleForm.pesquisaAtiva || vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo\r\n                ||vm.controladorEstoria.editarEstimativa || vm.controladorEstoria.editarPriorizacao\r\n                || vm.controladorEstoria.editarTarefas || vm.controleForm.emProgresso || vm.controladorEstoria.editarRequisito\">\n<md-tab-label><label>Clientes</label></md-tab-label><md-tab-body><div ng-if=\"vm.tabSelecionada == \'clientes\'\" \nng-include=\"vm.htmlRota.tabs.clientes\"></div></md-tab-body></md-tab><md-tab label=\"Estimativa\" \nmd-on-select=\"vm.metodosGeral.tabSelecionada(\'estimativa\')\" \nng-disabled=\"!vm.controleForm.pesquisaAtiva || vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo\r\n                || vm.controladorEstoria.editarPriorizacao || vm.controladorEstoria.editarTarefas || vm.controladorEstoria.editarRequisito || vm.controleForm.emProgresso\">\n<md-tab-label><label translate=\"ESTORIA.ESTIMATIVA\">Estimativa</label></md-tab-label><md-tab-body><div \nng-if=\"vm.tabSelecionada == \'estimativa\'\" ng-include=\"vm.htmlRota.tabs.estimativa\"></div></md-tab-body></md-tab><md-tab\n label=\"Priorização\" md-on-select=\"vm.metodosGeral.tabSelecionada(\'priorizacao\')\" \nng-disabled=\"!vm.controleForm.pesquisaAtiva || vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo\r\n                ||vm.controladorEstoria.editarEstimativa || vm.controladorEstoria.editarTarefas || vm.controladorEstoria.editarRequisito || vm.controleForm.emProgresso\">\n<md-tab-label><label translate=\"ESTORIA.PRIORIZACAO\">Priorização</label></md-tab-label><md-tab-body><div \nng-if=\"vm.tabSelecionada == \'priorizacao\'\" ng-include=\"vm.htmlRota.tabs.priorizacao\"></div></md-tab-body></md-tab>\n<md-tab label=\"Tarefas\" md-on-select=\"vm.metodosGeral.tabSelecionada(\'tarefas\')\" \nng-disabled=\"!vm.controleForm.pesquisaAtiva || vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo\r\n                ||vm.controladorEstoria.editarEstimativa || vm.controladorEstoria.editarPriorizacao\r\n                || vm.controladorEstoria.editarTarefas || vm.controladorEstoria.editarRequisito || vm.controleForm.emProgresso\">\n<md-tab-label><label translate=\"ESTORIA.TAREFAS\">Tarefas</label></md-tab-label><md-tab-body><div \nng-if=\"vm.tabSelecionada == \'tarefas\'\" ng-include=\"vm.htmlRota.tabs.tarefas\"></div></md-tab-body></md-tab><md-tab \nlabel=\"Histórico\" md-on-select=\"vm.metodosGeral.tabSelecionada(\'historico\')\" \nng-disabled=\"!vm.controleForm.pesquisaAtiva || vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo\r\n                                    ||vm.controladorEstoria.editarEstimativa || vm.controladorEstoria.editarPriorizacao\r\n                                    || vm.controladorEstoria.editarTarefas || vm.controladorEstoria.editarRequisito || vm.controleForm.emProgresso\">\n<md-tab-label><label translate=\"ESTORIA.HISTORICO\">Histórico</label></md-tab-label><md-tab-body><div \nng-if=\"vm.tabSelecionada == \'historico\'\" ng-include=\"vm.htmlRota.tabs.historico\"></div></md-tab-body></md-tab><md-tab \nlabel=\"Requisito\" md-on-select=\"vm.metodosGeral.tabSelecionada(\'requisito\')\" \nng-disabled=\"!vm.controleForm.pesquisaAtiva || vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo\r\n                                    ||vm.controladorEstoria.editarEstimativa || vm.controladorEstoria.editarPriorizacao\r\n                                    || vm.controladorEstoria.editarTarefas || vm.controleForm.emProgresso\">\n<md-tab-label><label translate=\"ESTORIA.REQUISITO\"></label></md-tab-label><md-tab-body><div \nng-if=\"vm.tabSelecionada == \'requisito\'\" ng-include=\"vm.htmlRota.tabs.requisito\"></div></md-tab-body></md-tab><md-tab \nlabel=\"Faturamento\" md-on-select=\"vm.metodosGeral.tabSelecionada(\'faturamento\')\" \nng-disabled=\"!vm.controleForm.pesquisaAtiva \r\n                                    ||vm.controladorEstoria.editarEstimativa \r\n                                    || vm.controladorEstoria.editarPriorizacao || vm.controladorEstoria.editarRequisito \r\n                                    || vm.controladorEstoria.editarTarefas || vm.controleForm.emProgresso || vm.controleForm.inserirAtivo\">\n<md-tab-label><label translate=\"ESTORIA.FATURAMENTO\"></label></md-tab-label><md-tab-body><div \nng-if=\"vm.tabSelecionada == \'faturamento\'\" ng-include=\"vm.htmlRota.tabs.faturamento\"></div></md-tab-body></md-tab>\n</md-tabs></md-content></form></div>");
$templateCache.put("app/main/planejamento-scrum/processamento/estoria/views/estoria.html","<div id=\"estoria\" class=\"page-layout simple fullwidth\" layout=\"column\"><header-padrao translate-nome=\"ESTORIA.ESTORIA\" \ntexto-auxiliar=\"vm.estoria.numero +  \'/\' +  vm.estoria.ano\" \ntexto-auxiliar-habilitado=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.inserirAtivo\" icone=\"icon-book-open\" \nliberar-pesquisa-quando-datatable-ativo=\"vm.controleForm.pesquisarDatatable\" pesquisar=\"vm.pesquisar\"></header-padrao>\n<div class=\"content\"><div ui-view=\"estoria-form\"></div></div><div ui-view=\"estorias-tabela\" \nng-if=\"vm.controleForm.listarTodasEntidades\"></div></div>");
$templateCache.put("app/main/planejamento-scrum/processamento/estoria/views/estorias-tabela.html","<div layout=\"column\" flex><div class=\"md-padding md-background-bg md-whiteframe-1dp fullpage-datatable\" \nlayout=\"column\" flex><table class=\"dataTable row-border hover\" id=\"datatable-estoria\" width=\"100%\"><thead><tr><th \nstyle=\"min-width: 66px; max-width: 100px\">Ação</th><th>Número</th><th>Ano</th><th>Descrição</th><th>Data entrada</th>\n<th>Data entrega</th><th>Status</th></tr></thead></table></div></div>");
$templateCache.put("app/main/planejamento-scrum/processamento/product-backlog/views/product-backlog.html","<form name=\"vm.form\"><div id=\"product-backlog\" class=\"page-layout carded fullwidth\" layout=\"row\"><div layout=\"column\" \nflex><header-padrao translate-nome=\"PRODUCT_BACKLOG.PRODUCT_BACKLOG\" icone=\"icon-book-multiple\" \nliberar-pesquisa-quando-datatable-ativo=\"true\" pesquisar=\"vm.pesquisar\"></header-padrao><div layout=\"column\" flex><div \nid=\"container-product-backlog\" class=\"md-padding md-background-bg md-whiteframe-1dp fullpage-datatable\" ms-scroll flex>\n<div layout=\"row\" layout-align=\"center center\" class=\"md-background-bg\"><div layout=\"row\" flex=\"80\"><div layout=\"row\" \nflex><md-autocomplete class=\"autocomplete-cliente\" flex md-input-name=\"cliente\" md-no-cache=\"true\" \nmd-selected-item=\"vm.cliente\" md-search-text=\"vm.textoDePesquisaAutoCompleteCliente\" \nmd-items=\"item in vm.metodosProductBacklog.pesquisarAutoCompleteCliente(vm.textoDePesquisaAutoCompleteCliente)\" \nmd-item-text=\"item.codigo + \' - \' + item.nome\" md-autoselect md-floating-label=\"Cliente\" \nng-required=\"vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && \r\n                                                     !vm.controleForm.inserirAtivo\">\n<md-item-template><span md-highlight-text=\"vm.textoDePesquisaAutoCompleteCliente\">{{item.codigo}} - {{item.nome}}\n</span></md-item-template></md-autocomplete></div><div layout=\"row\" flex ng-if=\"vm.squadUsuarioLogado.length > 1\">\n<md-input-container class=\"md-block font-size-tamanho-form-padrao\" flex><label>Squad</label><md-select \nng-model=\"vm.squadCodigo\" name=\"squadCodigo\" ng-required=\"true\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && \r\n                                                     !vm.controleForm.inserirAtivo\" \nng-change=\"vm.metodosProductBacklog.selectChangeSquad(vm.squadCodigo)\"><md-option ng-value=\"squad.codigo\" \nng-repeat=\"squad in vm.squads track by squad.codigo\">{{squad.descricao}}</md-option></md-select><div \nng-messages=\"vm.form.squadCodigo.$error\"><div ng-message=\"required\">Campo obrigatório</div></div></md-input-container>\n</div><div layout=\"row\" flex><md-input-container class=\"md-block font-size-tamanho-form-padrao\" flex><label \ntranslate=\"PRODUCT_BACKLOG.PRODUTO\"></label><md-select ng-model=\"vm.codigoProduto\" name=\"produto\" \nmd-on-open=\"vm.metodosProductBacklog.configuraMdSelectProduto()\"><md-select-header ng-if=\"vm.produtos.length > 0\">\n<input id=\"produto-md-select\" class=\"md-text\" type=\"search\" translate translate-attr-placeholder=\"Pesquisar produto\" \nng-model=\"vm.filtrarProdutos\"></md-select-header><md-option ng-value=\"produto.codigo\" \nng-repeat=\"produto in vm.produtos | filter:vm.filtrarProdutos track by produto.codigo\">{{produto.descricao}}\n</md-option><md-option \nng-if=\"(vm.produtos.length === 0) || \r\n                                          vm.filtrarProdutos && \r\n                                          (vm.produtos | filter:vm.filtrarProdutos).length === 0\" \ndisabled=\"disabled\">Nenhum produto encontrada.</md-option><md-option ng-value=\"\">Desmarcar</md-option></md-select><div \nng-messages=\"vm.form.produto.$error\"><div ng-message=\"required\" translate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div>\n</div></md-input-container></div><div layout=\"row\" flex><md-input-container \nclass=\"md-block font-size-tamanho-form-padrao\" flex><label translate=\"PRODUCT_BACKLOG.NECESSIDADE_CLIENTE\"></label>\n<md-select ng-model=\"vm.necessidadeCliente\" name=\"necessidadeCliente\"><md-option ng-value=\"key\" \nng-repeat=\"(key, value) in vm.necessidadesCliente\">{{value}}</md-option><md-option ng-value=\"\">Desmarcar</md-option>\n</md-select></md-input-container></div><div layout=\"row\" flex><md-input-container \nclass=\"md-block font-size-tamanho-form-padrao\" flex><label translate=\"PRODUCT_BACKLOG.STACK_RESPONSAVEL\"></label>\n<md-select name=\"stackResponsavel\" ng-model=\"vm.stackResponsavel\"><md-option ng-value=\"stack.codigo\" \nng-repeat=\"stack in vm.stacks track by stack.codigo\">{{stack.descricao}}</md-option><md-option ng-value=\"\">Desmarcar\n</md-option></md-select></md-input-container></div></div><div layout=\"row\" class=\"md-background-bg btn-pesquisar\" \nlayout-align=\"center center\"><md-button class=\"md-raised md-accent\" type=\"submit\" aria-label=\"Pesquisar\" translate \ntranslate-attr-aria-label=\"PRODUCT_BACKLOG.PESQUISAR\" \nng-click=\"vm.metodosProductBacklog.pesquisarProductBacklog(vm.codigoProduto, vm.necessidadeCliente, \r\n                                    vm.cliente,vm.stackResponsavel, vm.squadCodigo)\" \nng-disabled=\"vm.requisicaoSolicitada\"><span translate=\"PRODUCT_BACKLOG.PESQUISAR\"></span></md-button><md-button \nng-if=\"vm.estorias.length > 0 && !vm.gerandoBacklog\" class=\"md-raised md-accent\" type=\"submit\" \naria-label=\"Gerar backlog\" ng-click=\"vm.gerandoBacklog = true\" ng-disabled=\"vm.requisicaoSolicitada\"><span>\nGerar backlog</span></md-button><md-button ng-if=\"vm.gerandoBacklog\" class=\"md-raised md-accent\" type=\"submit\" \naria-label=\"Gerar backlog\" ng-click=\"vm.metodosProductBacklog.gerarBacklog()\" \nng-disabled=\"vm.requisicaoSolicitada || vm.historiasSelecionadas.length === 0\"><span>Gerar</span></md-button><md-button\n class=\"md-fab md-accent md-icon-button md-mini\" aria-label=\"Reverter ação gerar backlog\" ng-if=\"vm.gerandoBacklog\" \nng-click=\"vm.metodosProductBacklog.reverterGerarBacklog()\"><md-icon md-font-icon=\"icon-replay s26\"></md-icon>\n<md-tooltip md-autohide><span>Reverter</span></md-tooltip></md-button></div></div><div layout=\"row\" \nlayout-align=\"center center\" style=\"justify-content: space-between; align-items: center\"><div \nstyle=\"display: flex; justify-content: center; flex: 1\"><md-button class=\"array-buttons-product-backlog\" \naria-label=\"{{item.descricao}}\" ng-disabled=\"!vm.estorias || vm.estorias.length == 0 || vm.requisicaoSolicitada\" \nng-repeat=\"item in vm.defineLegendasProductBacklog\" \nng-class=\"{\'descricao-selecionada\': vm.defineLegendasProductBacklog[$index].situacaoSelecionada}\" \nng-click=\"vm.metodosProductBacklog.filtrarTabela(item)\"><md-icon md-font-icon=\"icon-label\" class=\"s16\" \nng-style=\"{\'color\' : item.cor}\"></md-icon><span class=\"title\">{{item.descricao}}</span></md-button><md-button \nclass=\"array-buttons-product-backlog\" aria-label=\"{{vm.desmarcarFiltro.descricao}}\" \nng-disabled=\"!vm.estorias || vm.estorias.length == 0 || vm.requisicaoSolicitada\" \nng-click=\"vm.metodosProductBacklog.resetarFiltros()\"><md-icon md-font-icon=\"icon-label\" class=\"s16\" \nng-style=\"{\'color\' : vm.desmarcarFiltro.cor}\"></md-icon><span class=\"title\">{{vm.desmarcarFiltro.descricao}}</span>\n</md-button></div><div style=\"display: flex; align-items: center; margin-left: 16px\"><md-button class=\"md-icon-button\" \naria-label=\"Legenda\" style=\"margin: 0\" ng-click=\"vm.metodosProductBacklog.abrirDialogLegendaTabela()\"><md-tooltip>\nLegenda</md-tooltip><i class=\"s26 icone-cor-padrao icon-information-outline\"></i></md-button></div></div><div \nlayout=\"column\" layout-align=\"center center\" class=\"mt-40\" ng-if=\"vm.requisicaoSolicitada\"><span \nclass=\"font-weight-500 font-size-tamanho-form-padrao\">{{vm.mensagemPreloader}}</span><md-progress-circular \nmd-mode=\"indeterminate\" md-diameter=\"30\" class=\"md-accent mt-15\"></md-progress-circular></div><table \nid=\"datatable-product-backlog\" class=\"datatable row-border hover\" datatable=\"ng\" \ndt-options=\"vm.dtOptionsProductBacklog\" width=\"100%\" ng-if=\"vm.mostrarTabela\"><thead><tr><th></th><th></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">História</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Data entrega</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header coluna-descricao\"><span class=\"column-title\">Descrição</span></div>\n</th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Solução</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Situação</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Cliente</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Necessidade</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Prioridade</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Stack:</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Motivo:</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Origem:</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Data entrada:</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Sprint</span></div></th><th></th></tr>\n</thead><tbody><tr ng-repeat=\"estoria in vm.estorias\"><td></td><td><md-checkbox ng-if=\"vm.gerandoBacklog\" \nstyle=\"margin-top: 17px\" aria-label=\"Selecionar história\" \nng-model=\"vm.checkboxSelecionado[estoria.numero + \'-\' + estoria.ano]\" \nng-change=\"vm.metodosProductBacklog.onChangeHistoriasSelecionadas(estoria)\"></md-checkbox></td><td \nclass=\"border-left h3 text-center\" \nng-class=\"{\'erro-cliente\': estoria.clienteCodigo !== 1 && estoria.motivoCodigo === 3,\r\n                             \'erro\': estoria.clienteCodigo === 1 && estoria.motivoCodigo === 3,\r\n                             \'solicitacao\': estoria.motivoCodigo === 1,\r\n                             \'visita\': estoria.motivoCodigo === 5}\">\n{{estoria.numero}}/{{estoria.ano}}</td><td class=\"border-left border-right\" \nng-dblclick=\"vm.metodosProductBacklog.abrirDialogAlterarDataEntregaBacklog($index, estoria, $event)\" \nng-class=\"{\r\n                                        \'data-entrega-atrasada\': vm.metodosProductBacklog.definirCoresDataEntrega(estoria.dataEntrega) === \'red\',\r\n                                        \'data-entrega-proxima\': vm.metodosProductBacklog.definirCoresDataEntrega(estoria.dataEntrega) === \'yellow\',\r\n                                        \'data-entrega-normal\': vm.metodosProductBacklog.definirCoresDataEntrega(estoria.dataEntrega) === \'#e0e0e0\'}\">\n<span style=\"display: flex; justify-content: center; align-items: center\" ng-mouseenter ng-mouseleave>\n{{estoria.dataEntrega | date:\'dd/MM/yyyy\'}}<md-tooltip><span \nng-if=\"vm.metodosProductBacklog.calcularDiasParaVencimento(estoria.dataEntrega) > 0\">\nFaltam {{vm.metodosProductBacklog.calcularDiasParaVencimento(estoria.dataEntrega)}} dia(s) para o vencimento </span>\n<span ng-if=\"vm.metodosProductBacklog.calcularDiasParaVencimento(estoria.dataEntrega) === 0\">Vence hoje </span><span \nng-if=\"vm.metodosProductBacklog.calcularDiasParaVencimento(estoria.dataEntrega) < 0\">\nVencido há {{-1 * vm.metodosProductBacklog.calcularDiasParaVencimento(estoria.dataEntrega)}} dia(s)</span></md-tooltip>\n</span></td><td>{{estoria.descricao}}</td><td>{{estoria.solucaoDescricao}}</td><td><div \nid=\"backlog-td-situacao{{$index}}\" class=\"font-size-14 border-bottom-situacao\" \nng-dblclick=\"vm.metodosProductBacklog.abrirDialogSituacao($index ,$event, \r\n                                                  estoria.situacaoDescricao, estoria)\">\n{{estoria.situacaoDescricao}}</div></td><td>{{estoria.clienteNome}}</td><td><span ng-show=\"false\">\n{{ estoria.necessidadeCliente }}</span><div class=\"font-size-14 border-bottom-situacao\" \nng-dblclick=\"vm.metodosProductBacklog.abrirDialogNecessidadeCliente(estoria, $event)\">\n{{estoria.necessidadeClienteDescricao}}</div></td><td><div class=\"coluna-prioridade\" \nstyle=\"display: flex; justify-content: center;\r\n                                    align-items: center\"><md-button \nclass=\"md-icon-button siglas\" \nng-click=\"vm.controleForm.emProgresso || \r\n                                           vm.metodosProductBacklog.abrirDialogAlterarPrioridadeBacklog(estoria, $event)\">\n{{estoria.prioridadeBacklog !== undefined && estoria.prioridadeBacklog !== null ? estoria.prioridadeBacklog : 0}}\n</md-button></div></td><td>{{estoria.stackResponsavelDescricao}}</td><td>{{estoria.motivoDescricao}}</td><td>\n{{estoria.origem}}</td><td>{{estoria.dataEntrada | date:\'dd/MM/yyyy\'}}</td><td><span \nstyle=\"display: flex; justify-content: center;\r\n                                                align-items: center\">\n{{estoria.sprintNumero || \'-\'}}</span></td><td><div layout=\"column\" layout-align=\"center center\"><button \nng-click=\"vm.metodosProductBacklog.abrirDialogEstoria(estoria)\"><i class=\"icon-open-in-new s20 icone-cor-padrao\"></i>\n</button> <button ng-click=\"vm.metodosProductBacklog.abrirDialogAdicionarSprintProductBacklog(estoria)\"><i \nclass=\"icon-playlist-plus s20 icone-cor-padrao\"></i></button></div></td></tr></tbody></table></div></div></div></div>\n</form>");
$templateCache.put("app/main/trabalhe-conosco/cadastro/categoria/views/trabalhe-conosco-categoria-form.html","<div class=\"md-background-bg md-whiteframe-1dp\"><form name=\"vm.form\" novalidate><pg-toolbar entidades=\"vm.categorias\" \nentidade=\"vm.categoria\" entidade-de-envio=\"vm.entidadeDeEnvio\" controlador-toolbar=\"vm.controleForm\" \ncontrolador-pre-loader=\"controladorPreLoader\" acao-pesquisar=\"vm.metodos.pesquisar()\" \nacao-criar=\"vm.metodos.salvar(vm.categoria)\" acao-editar=\"vm.metodos.editar(vm.categoria)\" \nacao-excluir=\"vm.metodos.excluir(vm.categoria)\" construir-dt-options=\"vm.metodos.construirDtOptions()\" \nmetodos-externos=\"vm.metodosExternosPgToolbar\" metodo-externo-acao-nova-pesquisa=\"vm.metodos.novaPesquisa()\" \npre-definir-campos-para-edicao=\"vm.metodos.preDefinirCamposParaEdicao()\" \npre-definir-campos-para-insercao=\"vm.metodos.preDefinirCamposParaInsercao()\" campo-pesquisar=\"vm.pesquisar\" \ndesabilitar-botao-inserir=\"vm.tabSelecionada != \'categoria\'\" \ndesabilitar-botao-editar=\"vm.tabSelecionada != \'categoria\'\" \ndesabilitar-botao-excluir=\"vm.tabSelecionada != \'categoria\'\" \ndesabilitar-botao-nova-pesquisa=\"vm.controleCategoria.controladorHabildadesCategoria\" \ndesabilitar-botao-atualizar=\"vm.controleCategoria.controladorHabilidadesCategoria\" \ndesabilitar-botao-listar-todas-entidades=\"vm.controleCategoria.controladorHabilidadesCategoria\" \ndesabilitar-botoes-navegacao=\"vm.controleCategoria.controladorHabilidadesCategoria\"></pg-toolbar><md-content \nlayout-padding ng-hide=\"vm.controleForm.listarTodasEntidades\" ng-disabled=\"vm.controleForm.emProgresso\"><md-tabs \nmd-dynamic-height md-border-bottom md-swipe-content><md-tab label=\"Categoria\" \nmd-active=\"vm.tabSelecionada === \'categoria\'\" ng-disabled=\"vm.controleCategoria.controladorHabilidadesCategoria\" \nmd-on-select=\"vm.metodosGeral.tabSelecionada(\'categoria\')\"><md-tab-label><label \ntranslate=\"TRABALHE_CONOSCO_CATEGORIA.CATEGORIA\">Categoria</label></md-tab-label><md-tab-body><div \nng-include=\"vm.htmlRota.tabs.categoria\"></div></md-tab-body></md-tab><md-tab label=\"Área de Atuação\" \nmd-on-select=\"vm.metodosGeral.tabSelecionada(\'habilidadesCategoria\')\" \nng-disabled=\"!vm.controleForm.pesquisaAtiva || \r\n                                      vm.controleForm.editarAtivo || \r\n                                      vm.controleForm.inserirAtivo\">\n<md-tab-label><label translate=\"TRABALHE_CONOSCO_CATEGORIA.HABILIDADE_CATEGORIA\"></label></md-tab-label><md-tab-body>\n<div ng-if=\"vm.tabSelecionada == \'habilidadesCategoria\'\" ng-include=\"vm.htmlRota.tabs.habilidadesCategoria\"></div>\n</md-tab-body></md-tab></md-tabs></md-content></form></div>");
$templateCache.put("app/main/trabalhe-conosco/cadastro/categoria/views/trabalhe-conosco-categoria.html","<div id=\"trabalhe-conosco-categoria\" class=\"page-layout simple tabbed\" layout=\"column\"><header-padrao \ntranslate-nome=\"TRABALHE_CONOSCO_CATEGORIA.CATEGORIA\" \nliberar-pesquisa-quando-datatable-ativo=\"vm.controleForm.listarTodasEntidades\" pesquisar=\"vm.pesquisar\">\n</header-padrao><div class=\"content\"><div ui-view=\"trabalhe-conosco-categoria-form\"></div></div><div \nui-view=\"trabalhe-conosco-categorias-tabela\" ng-if=\"vm.controleForm.listarTodasEntidades\"></div></div>");
$templateCache.put("app/main/trabalhe-conosco/cadastro/categoria/views/trabalhe-conosco-categorias-tabela.html","<div layout=\"column\" flex><div class=\"md-padding md-background-bg md-whiteframe-1dp fullpage-datatable\" \nlayout=\"column\" flex><table class=\"dataTable row-border hover\" id=\"datatable-trabalheconosco-cadastro-categoria\" \nwidth=\"100%\"><thead><tr><th>Ação</th><th>Titulo</th><th>Setor</th></tr></thead></table></div></div>");
$templateCache.put("app/main/trabalhe-conosco/cadastro/habilidade/views/trabalhe-conosco-habilidade-form.html","<div class=\"md-background-bg md-whiteframe-1dp\"><form name=\"vm.form\" novalidate><pg-toolbar entidades=\"vm.habilidades\" \nentidade=\"vm.habilidade\" entidade-de-envio=\"vm.entidadeDeEnvio\" controlador-toolbar=\"vm.controleForm\" \nacao-pesquisar=\"vm.metodos.pesquisar()\" acao-criar=\"vm.metodos.salvar(vm.habilidade)\" \nacao-editar=\"vm.metodos.editar(vm.habilidade)\" acao-excluir=\"vm.metodos.excluir(vm.habilidade)\" \nconstruir-dt-options=\"vm.metodos.construirDtOptions()\" metodos-externos=\"vm.metodosExternosPgToolbar\" \npre-definir-campos-para-insercao=\"vm.metodos.preDefinirCamposParaInsercao(vm.habilidade)\" \ncampo-pesquisar=\"vm.pesquisar\"></pg-toolbar><md-content layout-padding ng-hide=\"vm.controleForm.listarTodasEntidades\" \nng-disabled=\"vm.controleForm.emProgresso\"><div class=\"form-container\"><div layout-gt-xs=\"row\"><md-input-container \nclass=\"md-block\" flex><label translate=\"TRABALHE_CONOSCO_HABILIDADE.DESCRICAO\"></label><input type=\"text\" \nng-model=\"vm.habilidade.descricao\" name=\"descricao\" mascara-tamanho-campo=\"100\" \nng-required=\"vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo\" md-maxlength=\"100\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\"><div \nng-messages=\"vm.form.descricao.$error\"><div ng-message=\"required\" translate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\">\n</div></div></md-input-container></div><div layout-gt-xs=\"row\" flex><fieldset flex=\"30\"><legend><md-checkbox \nng-model=\"vm.habilidade.ehIdioma\" ng-change=\"vm.metodos.ngChangeIdioma(vm.habilidade.ehIdioma, vm.habilidade)\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\" \naria-label=\"ehIdioma\" name=\"ehIdioma\"><span class=\"float-label-cor-default\" \ntranslate=\"TRABALHE_CONOSCO_HABILIDADE.IDIOMA\"></span></md-checkbox></legend><div ng-if=\"vm.habilidade.ehIdioma\" \nlayout-gt-xs=\"row\" flex><md-input-container class=\"md-block\" flex-offset=\"5\" flex><label \ntranslate=\"TRABALHE_CONOSCO_HABILIDADE.NIVEL_IDIOMA\"></label><md-select ng-model=\"vm.habilidade.nivel\" \nname=\"nivelIdioma\" ng-required=\"vm.habilidade.ehIdioma\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\"><md-option\n ng-value=\"key\" ng-repeat=\"(key, value) in vm.nivelIdiomas\">{{value}}</md-option></md-select><div \nng-messages=\"vm.form.nivelIdioma.$error\"><div ng-message=\"required\" translate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\">\n</div></div></md-input-container></div></fieldset></div></div></md-content></form></div>");
$templateCache.put("app/main/trabalhe-conosco/cadastro/habilidade/views/trabalhe-conosco-habilidade.html","<div id=\"trabalhe-conosco-habilidade\" class=\"page-layout simple tabbed\" layout=\"column\"><header-padrao \ntranslate-nome=\"TRABALHE_CONOSCO_HABILIDADE.HABILIDADES\" \nliberar-pesquisa-quando-datatable-ativo=\"vm.controleForm.listarTodasEntidades\" pesquisar=\"vm.pesquisar\">\n</header-padrao><div class=\"content\"><div ui-view=\"trabalhe-conosco-habilidade-form\"></div></div><div \nui-view=\"trabalhe-conosco-habilidades-tabela\" ng-if=\"vm.controleForm.listarTodasEntidades\"></div></div>");
$templateCache.put("app/main/trabalhe-conosco/cadastro/habilidade/views/trabalhe-conosco-habilidades-tabela.html","<div layout=\"column\" flex><div class=\"md-padding md-background-bg md-whiteframe-1dp fullpage-datatable\" \nlayout=\"column\" flex><table class=\"dataTable row-border hover\" id=\"datatable-trabalheconosco-cadastro-habilidade\" \nwidth=\"100%\"><thead><tr><th>Ação</th><th>Descrição</th><th>Idioma</th></tr></thead></table></div></div>");
$templateCache.put("app/main/protecao/processamento/atualizacao-cliente/views/protecao-atualizacao-cliente-form.html","<div id=\"forms\" class=\"page-layout simple fullwidth doc-page\" layout=\"column\"><header-padrao \ntranslate-nome=\"ATUALIZACAO_CLIENTE.TITULO\" icone=\"\" liberar-pesquisa-quando-datatable-ativo=\"false\" \npesquisar=\"vm.pesquisar\"></header-padrao><div class=\"content\" layout=\"column\"><form name=\"form\" ms-vertical-stepper \nselect-step-click=\"vm.metodos.pesquisarClientes()\" disable-steps=\"vm.preLoader || vm.preLoaderEnvio\" \nng-submit=\"vm.metodos.atualizarDataExpiracao()\" ng-model=\"vm.filtro\" exibe-botao-next=\"vm.exibeBotaoAvancar\" \non-submit-value-step=\"1\" ng-disabled=\"vm.preLoader\" custom-button-submit-text=\"Atualizar\" novalidate><div \nlayout=\"column\" layout-align=\"center center\" ng-show=\"vm.preLoader || vm.preLoaderEnvio\"><span class=\"font-weight-500\">\nAguarde...</span><md-progress-circular md-mode=\"indeterminate\" md-diameter=\"30\" class=\"md-accent\">\n</md-progress-circular></div><ms-vertical-stepper-step ng-form=\"vm.form.step.produtos\" step=\"1\" \nstep-title=\"\'Informações dos produtos\'\"><div ui-view=\"protecao-atualizacao-cliente--steper-produto\"></div>\n</ms-vertical-stepper-step><ms-vertical-stepper-step ng-form=\"vm.form.step.clientes\" step=\"2\" \nstep-title=\"\'Informações contratuais\'\"><div ui-view=\"protecao-atualizacao-cliente--steper-contrato\"></div>\n</ms-vertical-stepper-step><ms-vertical-stepper-step ng-form=\"vm.form.step.data\" step=\"3\" \nhide-step=\"!vm.usuarioPermiteEdicao\" step-title=\"\'Atualização da data de expiração\'\"><div \nui-view=\"protecao-atualizacao-cliente--steper-data-expiracao\"></div></ms-vertical-stepper-step></form></div></div>");
$templateCache.put("app/main/trabalhe-conosco/cadastro/area-atuacao/views/trabalhe-conosco-areaatuacao-form.html","<div class=\"md-background-bg md-whiteframe-1dp\"><form name=\"vm.form.areaatuacao\" novalidate><pg-toolbar \nentidades=\"vm.areas\" entidade=\"vm.area\" entidade-de-envio=\"vm.entidadeDeEnvio\" controlador-toolbar=\"vm.controleForm\" \ncontrolador-pre-loader=\"controladorPreLoader\" acao-pesquisar=\"vm.metodosArea.pesquisar()\" \nacao-criar=\"vm.metodosArea.salvar(vm.area)\" acao-editar=\"vm.metodosArea.editar(vm.area)\" \nacao-excluir=\"vm.metodosArea.excluir(vm.area)\" construir-dt-options=\"vm.metodosArea.construirDtOptions()\" \nmetodos-externos=\"vm.metodosExternosPgToolbar\" campo-pesquisar=\"vm.pesquisar\" \ndesabilitar-botao-inserir=\"vm.tabSelecionada != \'areaAtuacao\'\" \ndesabilitar-botao-editar=\"vm.tabSelecionada != \'areaAtuacao\'\" \ndesabilitar-botao-excluir=\"vm.tabSelecionada != \'areaAtuacao\'\" \ndesabilitar-botao-nova-pesquisa=\"vm.controleArea.controladorHabildadesAreaAtuacao\" \ndesabilitar-botao-atualizar=\"vm.controleArea.controladorHabilidadesAreaAtuacao\" \ndesabilitar-botao-listar-todas-entidades=\"vm.controleArea.controladorHabilidadesAreaAtuacao\" \ndesabilitar-botoes-navegacao=\"vm.controleArea.controladorHabilidadesAreaAtuacao\"></pg-toolbar><md-content \nlayout-padding ng-hide=\"vm.controleForm.listarTodasEntidades\" ng-disabled=\"vm.controleForm.emProgresso\"><md-tabs \nmd-dynamic-height md-border-bottom><md-tab label=\"Área de Atuação\" md-active=\"vm.tabSelecionada === \'areaAtuacao\'\" \nng-disabled=\"vm.controleArea.controladorHabilidadesAreaAtuacao\" \nmd-on-select=\"vm.metodosGeral.tabSelecionada(\'areaAtuacao\')\"><md-tab-label><label \ntranslate=\"TRABALHE_CONOSCO_AREAS_ATUACAO.AREA\">Área de Atuação</label></md-tab-label><md-tab-body><div \nng-include=\"vm.htmlRota.tabs.areaAtuacao\"></div></md-tab-body></md-tab><md-tab label=\"Área de Atuação\" \nmd-on-select=\"vm.metodosGeral.tabSelecionada(\'responsabilidadesAreaAtuacao\')\" \nng-disabled=\"!vm.controleForm.pesquisaAtiva || vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo\">\n<md-tab-label><label translate=\"TRABALHE_CONOSCO_AREAS_ATUACAO.RESPONSABILIDADE_AREA_ATUACAO\"></label></md-tab-label>\n<md-tab-body><div ng-if=\"vm.tabSelecionada == \'responsabilidadesAreaAtuacao\'\" \nng-include=\"vm.htmlRota.tabs.responsabilidadesAreaAtuacao\"></div></md-tab-body></md-tab><md-tab \nlabel=\"Área de Atuação\" md-on-select=\"vm.metodosGeral.tabSelecionada(\'habilidadesAreaAtuacao\')\" \nng-disabled=\"!vm.controleForm.pesquisaAtiva || vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo\">\n<md-tab-label><label translate=\"TRABALHE_CONOSCO_AREAS_ATUACAO.HABILIDADE_AREA_ATUACAO\"></label></md-tab-label>\n<md-tab-body><div ng-if=\"vm.tabSelecionada == \'habilidadesAreaAtuacao\'\" \nng-include=\"vm.htmlRota.tabs.habilidadesAreaAtuacao\"></div></md-tab-body></md-tab></md-tabs></md-content></form></div>");
$templateCache.put("app/main/trabalhe-conosco/cadastro/area-atuacao/views/trabalhe-conosco-areaatuacao-tabela.html","<div layout=\"column\" flex><div class=\"md-padding md-background-bg md-whiteframe-1dp fullpage-datatable\" \nlayout=\"column\" flex><table class=\"dataTable row-border hover\" id=\"datatable-area\" width=\"100%\"><thead><tr><th>Ação\n</th><th>Título</th><th>Categoria</th><th>Cidade</th><th>UF</th><th>Ativo</th></tr></thead></table></div></div>");
$templateCache.put("app/main/trabalhe-conosco/cadastro/area-atuacao/views/trabalhe-conosco-areaatuacao.html","<div id=\"trabalhe-conosco-habilidade\" class=\"page-layout simple tabbed\" layout=\"column\"><header-padrao \ntranslate-nome=\"TRABALHE_CONOSCO_AREAS_ATUACAO.AREAS\" icone=\"icon-account\" \nliberar-pesquisa-quando-datatable-ativo=\"vm.controleForm.listarTodasEntidades\" pesquisar=\"vm.pesquisar\">\n</header-padrao><div class=\"content\"><div ui-view=\"trabalhe-conosco-areaatuacao-form\"></div></div><div \nui-view=\"trabalhe-conosco-areaatuacao-tabela\" ng-if=\"vm.controleForm.listarTodasEntidades\"></div></div>");
$templateCache.put("app/main/protecao/processamento/licenca/views/protecao-licenca-form.html","<div id=\"protecao-licenca-form\" class=\"md-background-bg md-whiteframe-1dp\"><form name=\"vm.form\" novalidate><pg-toolbar \nentidades=\"vm.licencas\" entidade=\"vm.licenca\" entidade-de-envio=\"vm.entidadeDeEnvio\" \ncontrolador-toolbar=\"vm.controleForm\" acao-pesquisar=\"vm.metodos.pesquisar()\" \nacao-criar=\"vm.metodos.salvar(vm.licenca)\" acao-editar=\"vm.metodos.editar(vm.licenca)\" \nacao-excluir=\"vm.metodos.excluir(vm.licenca)\" construir-dt-options=\"vm.metodos.construirDtOptions()\" \nmetodos-externos=\"vm.metodosExternosPgToolbar\" campo-pesquisar=\"vm.pesquisar\" \nmetodo-externo-acao-nova-pesquisa=\"vm.metodos.init()\" \ndefinir-status-toolbar-para-insercao-apos-insercao=\"vm.inserirNovaLicencaAposInsercao\" \npre-definir-campos-para-insercao=\"vm.metodos.preDefinirCamposParaInsercao()\"></pg-toolbar><md-content layout-padding \nng-hide=\"vm.controleForm.listarTodasEntidades\" ng-disabled=\"vm.controleForm.emProgresso\"><div class=\"form-container\">\n<div layout-gt-sm=\"row\" class=\"preenchimento-bottom\" flex><md-autocomplete flex-gt-sm=\"40\" flex-gt-xs \nmd-input-name=\"cliente\" md-no-cache=\"true\" ng-required=\"vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo\" \nng-blur=\"vm.metodos.configuraAutoCompleteClienteOnBlur()\" md-selected-item=\"vm.licenca.cliente\" \nmd-selected-item-change=\"vm.metodos.alterarItemSelecionadoAutoCompleteCliente(item)\" \nmd-search-text=\"vm.textoDePesquisaAutoCompleteCliente\" \nmd-items=\"item in vm.metodos.pesquisarAutoCompleteCliente(vm.textoDePesquisaAutoCompleteCliente)\" \nmd-item-text=\"item.codigo + \' - \' + item.nome\" md-autoselect md-floating-label=\"Cliente\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo||\r\n                                                  vm.controleForm.emProgresso\">\n<md-item-template><span md-highlight-text=\"vm.textoDePesquisaAutoCompleteCliente\">{{item.codigo}} - {{item.nome}}\n</span></md-item-template><md-not-found><label>Não foi encontrado nenhum Cliente.</label></md-not-found><div \nng-messages=\"vm.form.cliente.$error\"><div ng-message=\"required\" translate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div>\n</div></md-autocomplete><md-input-container class=\"md-block\" flex-gt-sm=\"40\" flex-gt-xs><label \ntranslate=\"PROTECAO_LICENCA.PRODUTO\"></label><md-select ng-model=\"vm.licenca.produto\" \nng-model-options=\"{trackBy: \'$value.codigo\'}\" name=\"produtoCodigo\" \nng-required=\"vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo\" \nmd-on-open=\"vm.metodos.configuraMdSelectProduto()\" \nng-change=\"vm.metodos.alterarItemSelecionadoProduto(vm.licenca.produto, true)\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo|| vm.controleForm.emProgresso\">\n<md-select-header ng-if=\"vm.produtos.length > 0\"><input id=\"protecao-licenca-produto-md-select\" class=\"md-text\" \nng-model=\"vm.filtrarProdutos\" type=\"search\" placeholder=\"\" translate \ntranslate-attr-placeholder=\"PROTECAO_LICENCA.PESQUISAR_PRODUTO\"></md-select-header><md-select-header \nng-if=\"vm.produtos.length <=0 && !vm.licenca.clienteCodigo\">Selecione um cliente primeiro ...</md-select-header>\n<md-select-header ng-if=\"vm.produtos.length <= 0 && vm.licenca.clienteCodigo\">\nCliente não possui produto de proteção ativo ...</md-select-header><md-select-header ng-if=\"vm.pesquisandoProdutos\">\nPesquisando produtos...</md-select-header><md-option ng-if=\"vm.produtos.length > 0\" ng-value=\"produto\" \nng-repeat=\"produto in vm.produtos | filter:vm.filtrarProdutos track by $index\">{{produto.descricao}}</md-option>\n</md-select><div ng-messages=\"vm.form.produtoCodigo.$error\"><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container><div \nng-if=\"(vm.licenca.produto.codigo == 2 || vm.licenca.produto.codigo == 3) && vm.controleForm.pesquisaAtiva\" \nlayout=\"row\" layout-align=\"center center\" flex=\"15\"><div class=\"licenca-permanente\" layout-align=\"center center\" flex \nng-if=\"!vm.licenca.licencaTemporaria\"><span class=\"texto-tipo-licenca\">Permanente</span></div><div \nclass=\"licenca-temporaria\" layout-align=\"center center\" flex ng-if=\"vm.licenca.licencaTemporaria\"><span \nclass=\"texto-tipo-licenca\">Temporária</span></div></div></div><div layout-gt-sm=\"row\" flex><md-input-container \nclass=\"md-block\" flex-gt-sm=\"25\" flex-gt-xs><label translate=\"PROTECAO_LICENCA.NUMERO\"></label><input type=\"text\" \nng-model=\"vm.licenca.numero\" name=\"numero\" ng-required=\"vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo\" \ntamanho-minimo-licenca=\"8\" mascara-numero-generica=\"########\" converte-mascara-para-numero \nvalidacao-numero-licenca=\"{{vm.codigoProtecao}}\" ng-required=\"vm.controleForm.inserirAtivo \" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo||\r\n                                            vm.controleForm.emProgresso\">\n<div ng-messages=\"vm.form.numero.$error\"><div ng-message=\"required\" translate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\">\n</div><div ng-message=\"validacaoNumeroLicenca\"><span>\nO número da licença deve iniciar com o código {{vm.codigoProtecao}}, que é o código de proteção do produto selecionado\n</span></div><div ng-message=\"validarTamanhoMinimoLicenca\" translate=\"PROTECAO_LICENCA.VALIDACAO_NUMERO_LICENCA\"></div>\n</div></md-input-container><md-input-container class=\"md-block\" flex-gt-sm=\"25\" flex-gt-xs><label \ntranslate=\"PROTECAO_LICENCA.LEITURISTA\"></label><input type=\"text\" name=\"leiturista\" ng-model=\"vm.licenca.leiturista\" \nng-disabled=\"true\"></md-input-container><md-input-container class=\"md-block\" flex-gt-sm=\"25\" flex-gt-xs><label \ntranslate=\"PROTECAO_LICENCA.DATA\"></label><input type=\"text\" name=\"dataUltimaCarga\" ng-model=\"vm.dataFormatada\" \nng-disabled=\"true\"></md-input-container><md-input-container class=\"md-block\" flex-gt-sm=\"25\" flex-gt-xs><label \ntranslate=\"PROTECAO_LICENCA.USUARIO\"></label><input type=\"text\" ng-model=\"vm.licenca.usuario\" name=\"usuario\" \nmascara-tamanho-campo=\"30\" md-maxlength=\"30\" ng-required=\"vm.controleForm.inserirAtivo || vm.controleForm.editarAtivo\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo ||\r\n                                            vm.controleForm.emProgresso\">\n<div ng-messages=\"vm.form.usuario.$error\"><div ng-message=\"required\" translate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\">\n</div></div></md-input-container></div><div layout-gt-sm=\"row\" flex><fieldset class=\"standard\" flex><legend \nclass=\"grp-legend\" translate=\"PROTECAO_LICENCA.TIPOS_LICENCA\"></legend><div layout=\"row\" flex><md-autocomplete flex \nmd-input-name=\"tipoLicenca\" md-no-cache=\"true\" ng-blur=\"vm.metodos.configuraAutoCompleteTiposLicencaOnBlur()\" \nmd-selected-item=\"vm.tipoLicencaSelecionado\" \nmd-selected-item-change=\"vm.metodos.alterarItemSelecionadoAutoCompleteTiposLicenca(item)\" \nmd-search-text=\"vm.textoDePesquisaAutoCompleteTiposLicenca\" \nmd-items=\"item in vm.metodos.pesquisarAutoCompleteTiposLicenca(vm.textoDePesquisaAutoCompleteTiposLicenca)\" \nmd-item-text=\"item.codigo + \' - \' + item.descricao + \' (Quantidade licenças disponíveis: \' + item.quantidadeLicencaDisponivel + \')\'\" \nmd-autoselect md-floating-label=\"Tipo de Licença\" md-min-length=\"0\" md-dropdown-items=\"5\" \nim-enter-pressionado=\"vm.metodos.adicionarLicenca(vm.tipoLicencaSelecionado)\" \nng-disabled=\"(!vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\r\n                                                            || vm.controleForm.emProgresso) || vm.tipoLicencas.length <= 0 || vm.licenca.todasLicencasSelecionadas\">\n<md-item-template><span md-highlight-text=\"vm.textoDePesquisaAutoCompleteTiposLicenca\">\n{{item.codigo}} - {{item.descricao}} (Quantidade licenças disponíveis:{{item.quantidadeLicencaDisponivel}})</span>\n</md-item-template><md-not-found><label>Não foi encontrado nenhuma licença.</label></md-not-found></md-autocomplete>\n<md-button class=\"md-fab md-mini\" ng-click=\"vm.metodos.adicionarLicenca(vm.tipoLicencaSelecionado)\" \naria-label=\"Adicionar licença\" \nng-disabled=\"(!vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\r\n                                                    || vm.controleForm.emProgresso) || vm.tipoLicencas.length <= 0 || vm.licenca.todasLicencasSelecionadas\">\n<md-icon md-font-icon=\"icon-playlist-plus s28\"></md-icon></md-button></div><div layout-gt-sm=\"row\" flex><div \nlayout-gt-sm=\"column\" flex-gt-sm=\"40\" flex-gt-xs><div layout-gt-sm=\"row\"><md-input-container class=\"md-block\">\n<md-checkbox ng-model=\"vm.licenca.todasLicencasSelecionadas\" aria-label=\"Ativo\" name=\"ativo\" \nng-click=\"vm.metodos.selecionarTodasLicencas()\" \nng-disabled=\"(!vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\r\n                                                              || vm.controleForm.emProgresso) || vm.tipoLicencas.length <= 0 || vm.licenca.todasLicencasSelecionadas\">\n<span translate=\"PROTECAO_LICENCA.SELECIONAR_TODOS\"></span></md-checkbox></md-input-container></div></div><div \nlayout-gt-sm=\"column\" flex><div class=\"fullpage-datatable scrollable\" flex ms-scroll \nstyle=\"max-height: 300px !important\"><table class=\"dataTable row-border hover\" dt-options=\"vm.dtOptions\" width=\"100%\">\n<thead><tr><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Código</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Descrição</span></div></th><th></th></tr>\n</thead><tbody ng-repeat=\"item in vm.licenca.tiposLicenca | orderBy: \'codigo\' track by item.codigo \"><tr><td>\n{{item.codigo}}</td><td>{{item.descricao}}</td><td class=\"button-icone-cor-azul\"><i \nclass=\"icon-delete s16 icone-cor-padrao\" \nng-click=\"((!vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\r\n                                                                    || vm.controleForm.emProgresso))\r\n                                                                 ||vm.metodos.removerLicenca(item)\" \nng-disabled=\"(!vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\r\n                                                                    || vm.controleForm.emProgresso)\">\n<md-tooltip><label translate=\"PROTECAO_LICENCA.REMOVER_LICENCA\"></label></md-tooltip></i></td></tr></tbody></table>\n</div></div></div></fieldset></div></div></md-content></form></div>");
$templateCache.put("app/main/protecao/processamento/licenca/views/protecao-licenca.html","<div id=\"protecao-licenca\" class=\"page-layout simple tabbed\" layout=\"column\"><header-padrao \ntranslate-nome=\"PROTECAO_LICENCA.LICENCA\" icone=\"\" \nliberar-pesquisa-quando-datatable-ativo=\"vm.controleForm.listarTodasEntidades\" pesquisar=\"vm.pesquisar\">\n</header-padrao><div class=\"content\"><div ui-view=\"protecao-licenca-form\"></div></div><div \nui-view=\"protecao-licencas-tabela\" ng-if=\"vm.controleForm.listarTodasEntidades\"></div></div>");
$templateCache.put("app/main/protecao/processamento/licenca/views/protecao-licencas-tabela.html","<div layout=\"column\" flex><div class=\"md-padding md-background-bg md-whiteframe-1dp fullpage-datatable\" \nlayout=\"column\" flex><table class=\"dataTable row-border hover\" id=\"datatable-protecao-processamento-licenca\" \nwidth=\"100%\"><thead><tr><th>Ação</th><th>Cliente</th><th>Produto</th><th>Número</th><th>Leiturista/Equipe</th><th>\nData da última carga</th><th>IMEI/Usuário</th></tr></thead></table></div></div>");
$templateCache.put("app/main/protecao/processamento/gerenciamento-protecao/views/gerenciamento-protecao-form.html","<div id=\"gerenciamento-protecao\" class=\"md-background-bg md-whiteframe-1dp\"><form name=\"vm.form\" novalidate>\n<md-progress-linear class=\"md-accent\" ng-show=\"vm.pesquisando\" md-mode=\"indeterminate\"></md-progress-linear><md-content\n layout-padding ng-hide=\"vm.controleForm.listarTodasEntidades\" ng-disabled=\"vm.controleForm.emProgresso\"><div \nclass=\"form-container\"><fieldset><legend><label translate=\"GERENCIAMENTO_PROTECAO.FILTRO\"></label></legend><div \nlayout-gt-xs=\"row\" flex><md-autocomplete flex-gt-sm=\"50\" flex-gt-xs md-input-name=\"cliente\" md-no-cache=\"true\" \nng-required=\"vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo\" \nng-blur=\"vm.metodos.configuraAutoCompleteClienteOnBlur()\" md-selected-item=\"vm.entidade.cliente\" \nmd-selected-item-change=\"vm.metodos.alterarItemSelecionadoAutoCompleteCliente(item)\" \nmd-search-text=\"vm.textoDePesquisaAutoCompleteCliente\" \nmd-items=\"item in vm.metodos.pesquisarAutoCompleteCliente(vm.textoDePesquisaAutoCompleteCliente)\" \nmd-item-text=\"item.codigo + \' - \' + item.nome\" md-autoselect md-floating-label=\"Cliente\" ng-disabled=\"vm.pesquisando\">\n<md-item-template><span md-highlight-text=\"vm.textoDePesquisaAutoCompleteCliente\">{{item.codigo}} - {{item.nome}}\n</span></md-item-template><md-not-found><label>Não foi encontrado nenhum Cliente.</label></md-not-found><div \nng-messages=\"vm.form.cliente.$error\"><div ng-message=\"required\" translate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div>\n</div></md-autocomplete><md-input-container class=\"md-block\" flex=\"50\"><label \ntranslate=\"GERENCIAMENTO_PROTECAO.CONTRATO\">Contrato</label><md-select name=\"contratoCodigo\" \nmd-on-open=\"vm.metodos.configuraMdSelectcontrato()\" ng-model=\"vm.entidade.contrato\" ng-blur=\"vm.filtrarcontratos = \'\'\" \nng-disabled=\"vm.pesquisando\"><md-select-header ng-if=\"vm.contratos.length > 0\"><input \nid=\"protecao-licenca-contrato-md-select\" class=\"md-text\" ng-model=\"vm.filtrarcontratos\" type=\"search\" placeholder=\"\" \ntranslate translate-attr-placeholder=\"GERENCIAMENTO_PROTECAO.PESQUISAR_CONTRATO\"></md-select-header><md-select-header \nng-if=\"!vm.entidade.cliente.codigo\">Selecione um cliente primeiro ...</md-select-header><md-select-header \nng-if=\"vm.contratos.length <= 0 && vm.entidade.cliente.codigo\">Cliente selecionado não possui contratos vinculados ...\n</md-select-header><md-select-header ng-if=\"vm.pesquisandoContratos\">Pesquisando contratos...</md-select-header>\n<md-option ng-if=\"vm.contratos.length > 0\" ng-value=\"contrato\" \nng-repeat=\"contrato in vm.contratos  | filter:vm.filtrarcontratos track by contrato.codigo\">\n{{contrato.contratoTipo.descricao}}</md-option></md-select><div ng-messages=\"vm.form.contratoCodigo.$error\"><div \nng-message=\"required\" translate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container>\n<md-input-container class=\"md-block\" flex=\"50\"><label translate=\"GERENCIAMENTO_PROTECAO.PRODUTO\">Produto</label>\n<md-select name=\"contratoItem\" md-on-open=\"vm.metodos.configuraMdSelectContratoItem()\" \nng-model=\"vm.entidade.contratoItem\" ng-blur=\"vm.filtrarContratoItem = \'\'\" \nng-change=\"vm.metodos.alterarItemSelecionadoContratoItem(vm.entidade.contratoItem)\" \nng-disabled=\"vm.pesquisando || !vm.entidade.contrato.contratoItens.length > 0\"><md-select-header \nng-if=\"vm.contratos.length > 0\"><input id=\"protecao-licenca-contratoItem-md-select\" class=\"md-text\" type=\"search\" \nplaceholder=\"\" translate-attr-placeholder=\"GERENCIAMENTO_PROTECAO.PESQUISAR_CONTRATO\" translate \nng-model=\"vm.filtrarcontratos\"></md-select-header><md-option ng-if=\"vm.entidade.contrato.contratoItens.length > 0\" \nng-value=\"contratoItem\" \nng-repeat=\"contratoItem in vm.entidade.contrato.contratoItens | filter:vm.filtrarContratoItens track by contratoItem.codigo\">\n{{contratoItem.produto.descricao}}</md-option></md-select><div ng-messages=\"vm.form.contratoCodigo.$error\"><div \nng-message=\"required\" translate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container></div>\n</fieldset><fieldset ng-hide=\"!vm.entidade.gerenciamento || !vm.entidade.contratoItem\" \nng-if=\"vm.entidade.gerenciamento.quantitativoLicencas.length > 0\"><legend><label \ntranslate=\"GERENCIAMENTO_PROTECAO.QUANTITATIVO_LICENCA\"></label></legend><div class=\"layout-wrap\" layout-gt-sm=\"row\" \nlayout-align=\"center center\"><div layout-gt-sm=\"column\" layout-align=\"center center\" \nng-if=\"vm.entidade.gerenciamento.quantitativoLicencas\" \nng-repeat=\"quantidadeLicenca in vm.entidade.gerenciamento.quantitativoLicencas | orderBy: \'descricao\'\">\n<card-quantidade-licenca-directive flex tamanho-titulo=\"20\" titulo=\"quantidadeLicenca.tipoLicenca.descricao\" \nquantidade=\"quantidadeLicenca.quantidadeTotal\" texto=\"TOTAL\" \nquantidade-utilizado=\"quantidadeLicenca.quantidadeUtilizadas\" \nquantidade-disponiveis=\"quantidadeLicenca.quantidadeDisponiveis\" \neditar=\"vm.metodos.editarQuantidadeLicenca(quantidadeLicenca)\"></card-quantidade-licenca-directive></div></div>\n</fieldset><fieldset ng-hide=\"!vm.entidade.gerenciamento || !vm.entidade.contrato\" \nng-if=\"vm.entidade.gerenciamento.quantitativoLicencas.length > 0\"><legend><label \ntranslate=\"GERENCIAMENTO_PROTECAO.LICENCAS\"></label></legend><div layout=\"row\" flex layout-align=\"end end\">\n<md-input-container flex=\"30\"><label>Pesquisar</label><input type=\"search\" maxlength=\"30\" md-maxlength=\"30\" \nng-model=\"vm.pesquisarLicenca\"></md-input-container></div><table class=\"dataTable row-border hover border\" \ndatatable=\"ng\" dt-options=\"vm.dtOptionsLicencas\"><thead><tr><th class=\"secondary-text licenca-especial\"><div \nclass=\"table-header\"><span class=\"column-title licencas-span\">Licenças especiais</span></div></th><th \nclass=\"secondary-text licenca\"><div class=\"table-header\"><span class=\"column-title\">Licença</span></div></th><th flex \nclass=\"secondary-text\" ng-if=\"vm.exibeLicencaTemporaria\"><div class=\"table-header\"><span class=\"column-title\">\nLicença temporária</span></div></th><th class=\"secondary-text usuario\"><div class=\"table-header\"><span \nclass=\"column-title\">IMEI/Usuário</span></div></th><th class=\"secondary-text leiturista\"><div class=\"table-header\">\n<span class=\"column-title\">Leiturista/Equipe</span></div></th><th class=\"secondary-text data-ultima-carga\"><div \nclass=\"table-header\"><span class=\"column-title\">Data da última carga</span></div></th><th \nclass=\"secondary-text protecao-avulsa\"><div class=\"table-header\"><span class=\"column-title licencas-span\">\nProteção Avulsa</span></div></th></tr></thead><tbody><tr \nng-repeat=\"licencas  in vm.entidade.gerenciamento.licencas | orderBy: \'licenca\' | filter:vm.pesquisarLicenca\"><td><i \nclass=\"icon-information s30 icone-cor-padrao ml-1\" ng-click=\"vm.metodos.abrirDetalhesLicenca(licencas,$event)\" \nng-disabled=\"vm.controleForm.emProgresso || vm.pesquisando\"><md-tooltip><label>Detalhes</label></md-tooltip></i></td>\n<td>{{licencas.numero}}</td><td ng-if=\"vm.exibeLicencaTemporaria\">{{licencas.licencaTemporariaExibicao}}</td><td>\n{{licencas.usuario}}</td><td>{{licencas.leiturista}}</td><td>{{licencas.dataHoraUltimaCarga | date:\'dd/MM/yyyy\'}}</td>\n<td><md-menu><md-button aria-label=\"Open phone interactions menu\" class=\"md-icon-button\" \nng-click=\"vm.metodos.abrirOpcoesLicencas($mdMenu, $event)\"><md-icon class=\"selecao-cor-icone\" \nmd-font-icon=\"icon-dots-vertical\"><md-tooltip><label>Proteção Avulsa</label></md-tooltip></md-icon></md-button>\n<md-menu-content width=\"2\"><md-menu-item><md-button ng-click=\"vm.metodosMenu.protecaoAvulsaLicenca(licencas)\">Licença\n</md-button></md-menu-item><md-menu-item><md-button ng-click=\"vm.metodosMenu.protecaoAvulsaDataExpiracao(licencas)\">\nData de expiração</md-button></md-menu-item></md-menu-content></md-menu></td></tr></tbody></table></fieldset><fieldset \nng-hide=\"!vm.entidade.gerenciamento || !vm.entidade.contrato\"><legend><label \ntranslate=\"GERENCIAMENTO_PROTECAO.DATA_EXPIRACAO\"></label></legend><div layout-gt-xs=\"row\"><div layout-gt-xs=\"column\" \nflex-gt-sm=\"30\"><md-input-container class=\"md-block aumentar-tamanho-campo-data-ultima-validacao\"><label \ntranslate=\"GERENCIAMENTO_PROTECAO.DATA_EXPIRACAO\"></label><md-datepicker \nng-model=\"vm.entidade.gerenciamento.dataExpiracao\" ng-required=\"true\" name=\"dataExpiracao\" \nmd-min-date=\"vm.dataMinimaExpiracao\" md-max-date=\"vm.entidade.gerenciamento.dataVencimentoContratoAtual\" \nmascara-conversor-string-para-data ng-mask=\"3?9/1?9/9999\" ng-disabled=\"!vm.controladorAtivo\"></md-datepicker><div \nng-messages=\"vm.form.dataExpiracao.$error\"><div ng-message=\"valid\" translate=\"MENSAGEM_VALIDACAO.DATA_INVALIDA\"></div>\n<div ng-message=\"mindate\" translate=\"MENSAGEM_VALIDACAO.CAMPO_DATA_ATUAL\"></div><div ng-message=\"maxdate\">\nA data máxima deve ser {{ vm.entidade.gerenciamento.dataVencimentoContratoAtual | date:\'dd/MM/yyyy\' }}.</div><div \nng-message=\"required\" translate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container></div><div \nlayout-gt-xs=\"column\" flex=\"25\" layout-align=\"start start\"><group-button ng-disabled=\"!vm.usuarioPermiteEdicao\" \nng-disabled-excluir=\"true\" entidade=\"vm.entidade.gerenciamento.dataExpiracao\" controlador-ativo=\"vm.controladorAtivo\" \nsalvar=\"vm.metodos.salvar()\" editar=\"vm.metodos.editar()\"></group-button></div></div></fieldset></div></md-content>\n</form></div>");
$templateCache.put("app/main/protecao/processamento/gerenciamento-protecao/views/gerenciamento-protecao.html","<div id=\"gerenciamento-protecao\" class=\"page-layout simple tabbed\" layout=\"column\"><header-padrao \ntranslate-nome=\"GERENCIAMENTO_PROTECAO.GERENCIAMENTO_PROTECAO\" ng-utiliza-pesquisa=\"false\" icone=\"\"></header-padrao>\n<div class=\"content\"><div ui-view=\"gerenciamento-protecao-form\"></div></div><div \nui-view=\"gerenciamento-protecao-tabela\" ng-if=\"vm.controleForm.listarTodasEntidades\"></div></div>");
$templateCache.put("app/main/protecao/processamento/atualizacao-licenca/views/protecao-atualizacao-licenca-form.html","<div id=\"forms\" class=\"page-layout simple fullwidth doc-page\" layout=\"column\"><header-padrao \ntranslate-nome=\"ATUALIZACAO_LICENCA.TITULO\" icone=\"\" liberar-pesquisa-quando-datatable-ativo=\"false\" \npesquisar=\"vm.pesquisar\"></header-padrao><div class=\"content\" layout=\"column\"><form name=\"vm.form\" ms-vertical-stepper \nng-submit=\"vm.metodos.executarRotina($event, vm.filtro)\" ng-model=\"vm.filtro\" on-submit-value-step=\"1\" \ncustom-button-submit-text=\"Atualizar\" novalidate><ms-vertical-stepper-step ng-form=\"vm.form.step.clientes\" step=\"1\" \nstep-title=\"\'Informações contratuais\'\"><div ui-view=\"protecao-atualizacao-licenca--steper-cliente\"></div>\n</ms-vertical-stepper-step><ms-vertical-stepper-step ng-form=\"vm.form.step.tiposLicenca\" step=\"2\" \nstep-title=\"\'Informações das licenças\'\"><div ui-view=\"protecao-atualizacao-licenca--steper-tipo-licenca\"></div>\n</ms-vertical-stepper-step></form></div></div>");
$templateCache.put("app/main/trabalhe-conosco/processamento/curriculo/dialogs/candidato-dialog-habilidade.html","<md-dialog id=\"candidato-dialog-habilidade\" class=\"dialogo-padrao\" aria-label=\"Dialog\"><form name=\"vm.form\" \nclass=\"md-inline-form\" novalidate><md-toolbar class=\"md-accent md-tall\" layout=\"column\"><div \nclass=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\">\n{{vm.titulo}}</span><md-button class=\"md-icon-button\" ng-click=\"vm.metodosDialog.fecharDialog()\" \naria-label=\"Fechar dialog\" translate translate-attr-aria-label=\"SPRINT.FECHAR_DIALOG\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><div layout=\"column\" class=\"mt-10\" \nlayout-align=\"center center\" ng-show=\"vm.preloader.requisicaoSolicitada && !vm.baixandoArquivos\"><span \nclass=\"font-weight-500\">{{vm.preloader.mensagemPreloader}}</span><md-progress-circular md-mode=\"indeterminate\" \nmd-diameter=\"30\" class=\"md-accent\"></md-progress-circular></div><md-dialog-content><div layout=\"row\" \nlayout-align=\"center center\"><md-input-container class=\"md-block\" flex=\"50\"><input type=\"text\" \nng-model=\"vm.habilidadeCandidato.nome\" name=\"candidatoNome\" ng-disabled=\"true\"></md-input-container></div><div \nlayout=\"row\" flex class=\"mt-20\" layout-wrap><table class=\"dataTable row-border hover\" datatable=\"ng\" \ndt-options=\"vm.dtOptions\" width=\"100%\"><thead><tr><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title text-center\" style=\"color: #039be5\">Habilidades principais</span></div></th></tr></thead><tbody><tr\n \nng-repeat=\"habilidadeCandidato in vm.habilidadesPrincipais | orderBy: \'descricao\' track by habilidadeCandidato.codigo\">\n<td class=\"text-center\">{{habilidadeCandidato.descricao}}</td></tr></tbody></table></div><div layout=\"row\" flex \nclass=\"mt-20\" layout-wrap><table class=\"dataTable row-border hover\" datatable=\"ng\" dt-options=\"vm.dtOptions\" \nwidth=\"100%\"><thead><tr><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title text-center\" \nstyle=\"color: #039be5\">Habilidades secundárias</span></div></th></tr></thead><tbody><tr \nng-repeat=\"habilidadeCandidato in vm.habilidadesSecundarias | orderBy: \'descricao\' track by habilidadeCandidato.codigo\">\n<td class=\"text-center\">{{habilidadeCandidato.descricao}}</td></tr></tbody></table></div></md-dialog-content></form>\n</md-dialog>");
$templateCache.put("app/main/trabalhe-conosco/processamento/curriculo/views/curriculo.html","<div layout=\"column\" class=\"page-layout carded fullwidth\"><header-padrao translate-nome=\"CURRICULO.CURRICULO\" icone=\"\" \nliberar-pesquisa-quando-datatable-ativo=\"vm.habilitarPesquisarHeaderPadrao || vm.pesquisaAtiva\" \npesquisar=\"vm.pesquisar\"></header-padrao><md-content class=\"content\" ng-if=\"!vm.pesquisaAtiva\" flex ms-scroll><div \nng-include=\"vm.rotasHtml.processamentoCurriculoForm\"></div></md-content><div layout=\"column\" flex \nng-include=\"vm.rotasHtml.tabelaProcessamentoCurriculo\" ng-show=\"vm.pesquisaAtiva && !vm.requisicaoSolicitada\"></div>\n</div>");
$templateCache.put("app/main/trabalhe-conosco/processamento/curriculo/views/processamento-curriculo-form.html","<div id=\"processamento-curriculo\" class=\"\" layout=\"row\"><div layout=\"column\" flex><form name=\"vm.form\" \nng-disabled=\"vm.requisicaoSolicitada\" novalidate><md-content layout-padding><div layout=\"row\" flex><div layout=\"row\" \nlayout-align=\"end center\" flex><md-button class=\"md-raised md-accent\" aria-label=\"Triagem\" translate \ntranslate-attr-aria-label=\"RELATORIO_ATENDIMENTO.GERAR_RELATORIO\" \nng-click=\"vm.metodos.BuscarCurriculos(vm.filtro, $event)\" ng-disabled=\"vm.form.$invalid || vm.requisicaoSolicitada\">\n<span translate=\"CURRICULO.BUSCAR\"></span></md-button></div></div><div layout-gt-xs=\"row\" class=\"border\" \nlayout-padding flex><div layout-gt-sm=\"column\" flex><div layout=\"column\" flex><ms-selecinar-multi-valores \ntexto-field-set=\"CURRICULO.CATEGORIA\" dados=\"vm.categorias\" name-placeholder=\"Categorias\" \nmodel-dados=\"vm.filtro.categorias\" mensagem-de-erro-do-formulario=\"Currículo Obrigatório\" \npropriedade-para-a-exibicao-da-repeticao=\"descricao\" limitar-width=\"true\"></ms-selecinar-multi-valores>\n{{vm.form.categorias}}</div><div layout=\"column\" flex><ms-selecinar-multi-valores texto-field-set=\"CURRICULO.CIDADE\" \ndados=\"vm.cidades\" name-placeholder=\"Cidades\" model-dados=\"vm.filtro.cidades\" \nmensagem-de-erro-do-formulario=\"CURRICULO.CIDADES_OBRIGATORIAS\" propriedade-para-a-exibicao-da-repeticao=\"descricao\" \nlimitar-width=\"true\"></ms-selecinar-multi-valores></div></div><div layout-gt-xs=\"column\" flex>\n<ms-selecinar-multi-valores texto-field-set=\"CURRICULO.AREA_ATUACAO\" dados=\"vm.areas\" limitar-width=\"true\" \nname-placeholder=\"Áreas de atuação\" model-dados=\"vm.filtro.areas\" \nmensagem-de-erro-do-formulario=\"CURRICULO.AREAS_OBRIGATORIAS\" propriedade-para-a-exibicao-da-repeticao=\"titulo\">\n</ms-selecinar-multi-valores></div></div></md-content></form></div></div>");
$templateCache.put("app/main/trabalhe-conosco/processamento/curriculo/views/tabela-processamento-curriculo.html","<div id=\"curriculo-tabela\" class=\"md-background-bg\" layout=\"column\"><div layout=\"row\" layout-align=\"end end\"><md-button\n class=\"md-raised md-accent\" aria-label=\"Nova Consulta\" translate translate-attr-aria-label=\"CURRICULO.NOVA_CONSULTA\" \nng-click=\"vm.metodos.novaConsulta();\"><span translate=\"CURRICULO.NOVA_CONSULTA\"></span></md-button></div></div><div \nclass=\"md-background-bg md-whiteframe-1dp fullpage-datatable\" layout=\"column\" flex><table \nclass=\"dataTable row-border hover\" datatable=\"ng\" id=\"datatable-curriuclo-triagem\" dt-options=\"vm.dtOptionsLog\"><thead>\n<tr><th class=\"secondary-text\"><div class=\"table-header\"><span \nng-click=\"vm.metodos.ordenarPor(\'areaAtuacaoTitulo\',vm.candidatosTriagem)\" class=\"column-title text-center\">\nÁrea de atuação</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nng-click=\"vm.metodos.ordenarPor(\'candidatoNome\',vm.candidatosTriagem)\" class=\"column-title text-center\">Candidato\n</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title text-center\">\nData de nascimento</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title text-center\">Contatos</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nng-click=\"vm.metodos.ordenarPor(\'candidatoCidade\',vm.candidatosTriagem)\" class=\"column-title text-center\">Cidade</span>\n</div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title text-center\">Pontuação</span>\n</div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title text-center\">\nInclusão do curriculum</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title text-center\">Currículo</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title text-center\">Habilidades</span></div></th></tr></thead><tbody><tr \nng-repeat=\"candidato in vm.candidatosTriagem | orderBy:\'-pontuacao\' \"><td class=\"text-center\"><span>\n{{candidato.areaAtuacaoTitulo}}</span></td><td class=\"text-center\">{{candidato.candidatoNome}}</td><td \nclass=\"text-center\">{{candidato.candidatoDataNascimento }}</td><td class=\"text-center\"><p>{{candidato.candidatoEmail}}\n</p><p>{{vm.metodos.formataTelefone(candidato.candidatoContato)}}</p><p><a href=\"\" \nng-if=\"candidato.candidatoLinkedin.length > 1\" ng-click=\"vm.metodos.abrirLinkedin(candidato.candidatoLinkedin)\">\nLinkedin</a></p></td><td class=\"text-center\">{{candidato.candidatoCidade}}</td><td class=\"text-center\">\n{{candidato.pontuacao}}</td><td class=\"text-center\">{{candidato.candidatoDataInclusaoCurriculo}}</td><td \nclass=\"text-center\"><md-button class=\"md-icon-button\" ng-disabled=\"candidato.diretorioCurriculo.length < 1\" \nng-click=\"vm.metodos.visualizarCurriculo(candidato.candidatoCodigo, $event)\"><md-icon class=\"icon s20\" \nng-style=\"(candidato.diretorioCurriculo.length > 1) && {\'color\':\'#279fda\'}\" md-font-icon=\"icon-cloud-download\">\n</md-icon></md-button></td><td class=\"text-center\"><i class=\"icon s20 icon-poll icone-cor-padrao\" \nng-click=\"vm.metodos.visualizarHabilidades(candidato, $event)\"></i></td></tr></tbody></table></div>");
$templateCache.put("app/main/solicitacao/consulta/solicitacao/views/consulta-solicitacao-filtro.html","<md-content layout-gt-sm=\"row\" class=\"p-10\" class=\"container-filtro\"><form name=\"vm.form\" flex-gt-sm=\"15\" \nng-if=\"vm.squadUsuarioLogado.length > 1\" ng-hide=\"vm.filtroAtivo\" class=\"campo-squad\"><div><div layout=\"row\" \nlayout-align=\"center center\"><div class=\"md-subheader\"><label>Squad</label></div></div><md-input-container \nclass=\"md-block\" flex-gt-sm=\"90\"><label>Squad</label><md-select ng-model=\"vm.squadCodigo\" name=\"squadCodigo\" \nng-required=\"vm.squadUsuarioLogado.length > 1\"><md-option ng-value=\"squad.codigo\" \nng-repeat=\"squad in vm.squads track by squad.codigo\">{{squad.descricao}}</md-option></md-select><div \nng-messages=\"vm.form.squadCodigo.$error\"><div ng-message=\"required\">Campo obrigatório</div></div></md-input-container>\n</div></form><md-divider ng-hide=\"vm.filtroAtivo\" class=\"divisor-filtro\" ng-if=\"vm.squadUsuarioLogado.length> 1\">\n</md-divider><div layout=\"column\" layout-padding ng-hide=\"vm.filtroAtivo\"><div layout=\"row\" \nlayout-align=\"center center\" class=\"md-subheader\"><label translate=\"CONSULTA_SOLICITACAO.SUGESTAO\"></label></div>\n<md-radio-group ng-model=\"vm.sugestaoFiltro.tipo\" ng-change=\"vm.metodos.defineFiltro(vm.sugestaoFiltro.tipo)\" \nlayout=\"row\" layout-padding><md-radio-button value=\"{{tipoSolicitacao.codigo}}\" \naria-label=\"{{tipoSolicitacao.descricao}}\" ng-disabled=\"vm.requisicaoSolicitada\" \nng-repeat=\"tipoSolicitacao in vm.tiposSolicitacao\"><label>{{tipoSolicitacao.descricao}}</label></md-radio-button>\n</md-radio-group></div><md-divider ng-hide=\"vm.filtroAtivo\" class=\"divisor-filtro\"></md-divider><div layout=\"column\" \nlayout-padding flex ng-hide=\"vm.filtroAtivo\"><div layout=\"row\" layout-align=\"center center\" class=\"md-subheader\"><label\n translate=\"CONSULTA_SOLICITACAO.FILTROS\"></label></div><div layout=\"row\" flex><div layout=\"row\" flex \nlayout-align=\"center center\"><md-input-container class=\"md-block\" flex-gt-sm=\"90\"><md-select aria-label=\"Filtros\" \nname=\"Filtros\" multiple=\"multiple\" ng-model=\"vm.filtros\" ng-disabled=\"vm.sugestaoFiltro.tipo == \'3\'\"><md-option \nng-value=\"filtro.codigo\" ng-repeat=\"filtro in vm.solicitacaoFases\">{{filtro.descricao}}</md-option></md-select>\n</md-input-container></div></div><div layout=\"row\" flex layout-align=\"end end\" class=\"pt-10\"><md-button \nclass=\"md-raised md-accent\" aria-label=\"Pesquisar\" translate \ntranslate-attr-aria-label=\"CONSULTAS_ESTORIAS.NOVA_CONSULTA\" \nng-click=\"vm.metodos.filtrar(vm.filtros, vm.tipoFiltro, $event)\" \nng-disabled=\"!vm.filtros || vm.filtros.length === 0 || vm.form.$invalid\"><span \ntranslate=\"CONSULTA_SOLICITACAO.FILTRAR\"></span></md-button></div></div></md-content><div layout=\"column\" flex \nlayout-align=\"center center\" ng-show=\"vm.requisicaoSolicitada\"><md-progress-circular md-mode=\"indeterminate\" \nclass=\"md-accent\"></md-progress-circular></div>");
$templateCache.put("app/main/solicitacao/consulta/solicitacao/views/consulta-solicitacao-resultado.html","<md-content><div class=\"mt-15\" layout-align=\"start center\" layout=\"column\" layout-gt-xs=\"row\"><div layout=\"row\"><span \nclass=\"ml-15 mr-5 text-uppercase\"></span><strong>SQUAD</strong>: {{ vm.metodos.retornarDescricaoSquad() | uppercase}}\n</div><div layout=\"row\"><span class=\"ml-10 mr-5 text-uppercase\"><strong>Tipo filtro</strong>: </span><span>\n{{vm.tipoFiltro | uppercase}}</span></div><div layout=\"row\" class=\"filtros\"><span class=\"ml-10 mr-5 text-uppercase\">\n<strong>Filtros(s)</strong>: </span><span class=\"truncated-text\">{{vm.descricaoFiltros | uppercase}}</span></div><div \nlayout=\"row\" flex layout-align=\"end center\"><div><md-button class=\"md-raised md-accent\" aria-label=\"Nova consulta\" \nng-click=\"vm.metodos.novaConsulta()\"><span translate=\"CONSULTA_SOLICITACAO.NOVA_CONSULTA\"></span></md-button></div>\n</div></div></md-content><div class=\"text-right\" style=\"margin: 20px 0px\"><i \nclass=\"icon-information-outline s50 cor-icone-padrao\" style=\"margin-right: 30px\" \nng-click=\"vm.metodos.abrirDialogLegenda()\"></i></div><md-content class=\"text-center\"><div layout=\"row\" \nlayout-xs=\"column\" flex><div layout=\"row\" layout-xs=\"column\" flex layout-align-gt-xs=\"center center\" layout-wrap>\n<ms-widget flippable=\"false\" flex-xs=\"50\" flex=\"25\" ng-repeat=\"card in vm.cards\" \nng-click=\"vm.metodos.abrirDialogDetalhes(card)\" ng-if=\"card.concluida == vm.controleForm.filtroConcluidas.concluidas\">\n<ms-widget-front class=\"pt-10\" flex ng-class=\"card.classe\"><div class=\"pl-8 pr-8 pt-8 pb-32\" layout=\"column\"><div \nclass=\"white-fg font-size-72 line-height-72\">{{card.quantidade}}</div><div class=\"pt-8 pb-8 pr-8 pl-8\" layout=\"column\">\n<div class=\"h3 white-fg font-weight-500\">{{card.titulo}}</div></div></div></ms-widget-front></ms-widget></div></div>\n</md-content>");
$templateCache.put("app/main/solicitacao/consulta/solicitacao/views/consulta-solicitacao.html","<div id=\"consulta-solicitacao\" class=\"page-layout carded fullwidth\" layout=\"row\"><div layout=\"column\" flex>\n<header-padrao translate-nome=\"SOLICITACAO.SOLICITACAO\" ng-utiliza-pesquisa=\"false\" pesquisar=\"vm.pesquisar\">\n</header-padrao><div class=\"content\" style=\"overflow: scroll\"><div layout=\"column\" flex ng-style=\"{\'padding\': \'80px\'}\" \nlayout-align=\"center center\" ng-show=\"vm.requisicaoSolicitada\"><md-progress-circular md-mode=\"indeterminate\" \nclass=\"md-accent\"></md-progress-circular></div><div ui-view=\"consulta-solicitacao-filtro\" \nng-if=\"vm.controleForm.filtroAtivo\"></div><div ui-view=\"consulta-solicitacao-resultado\" \nng-if=\"!vm.controleForm.filtroAtivo\"></div></div></div></div>");
$templateCache.put("app/main/solicitacao/processamento/solicitacao/views/solicitacao-form.html","<form name=\"vm.solicitacaoForm\" novalidate><pg-toolbar entidade=\"vm.solicitacao\" \nentidade-de-envio=\"vm.entidadeDeEnvio\" controlador-toolbar=\"vm.controleForm\" \nacao-pesquisar=\"vm.metodosSolicitacao.pesquisar()\" acao-criar=\"vm.metodosSolicitacao.criar(vm.solicitacao)\" \nacao-pos-criar=\"vm.metodosSolicitacao.aoSalvarConcluido()\" \nacao-editar=\"vm.metodosSolicitacao.atualizar(vm.solicitacao)\" \nacao-excluir=\"vm.metodosSolicitacao.excluir(vm.solicitacao)\" \nconstruir-dt-options=\"vm.metodosSolicitacao.construirDtOptions()\" metodos-externos=\"vm.metodosExternosPgToolbar\" \nmetodo-externo-acao-nova-pesquisa=\"vm.metodosGeral.novaPesquisa()\" \nmetodo-externo-acao-reverter=\"vm.metodosGeral.reverter()\" \npre-definir-campos-para-insercao=\"vm.metodosGeral.preDefinirCamposParaInserir()\" \npre-definir-campos-para-edicao=\"vm.metodosGeral.preDefinirCamposParaEdicao()\" campo-pesquisar=\"vm.pesquisar\" \ndesabilitar-botao-editar=\"vm.tabSelecionada !== \'solicitacao\'\" \ndesabilitar-botao-excluir=\"vm.tabSelecionada !== \'solicitacao\'\" \ndesabilitar-botao-pesquisar=\"(vm.squadUsuarioLogado.length > 1 && !vm.solicitacao.squadCodigo)\" \niniciar-chamando-pesquisa=\"vm.iniciarChamandoPesquisa\"></pg-toolbar><div class=\"content\"><md-content layout-padding \nng-hide=\"vm.controleForm.listarTodasEntidades\" ng-disabled=\"vm.controleForm.emProgresso\"><md-tabs md-dynamic-height \nmd-border-bottom><md-tab label=\"Solicitação\" md-active=\"vm.tabSelecionada === \'solicitacao\'\" \nmd-on-select=\"vm.metodosGeral.tabSelecionada(\'solicitacao\')\"><md-tab-label><label translate=\"SOLICITACAO.SOLICITACAO\">\n</label></md-tab-label><md-tab-body><div ng-if=\"vm.tabSelecionada == \'solicitacao\'\" \nng-include=\"vm.htmlRota.tabs.solicitacao\"></div></md-tab-body></md-tab><md-tab label=\"Estimativa\" \nmd-active=\"vm.tabSelecionada === \'estimativa\'\" md-on-select=\"vm.metodosGeral.tabSelecionada(\'estimativa\')\" \nng-disabled=\"!vm.controleForm.pesquisaAtiva || vm.controleForm.inserirAtivo || vm.controleForm.editarAtivo\">\n<md-tab-label><label translate=\"ESTIMATIVA.ESTIMATIVA\"></label></md-tab-label><md-tab-body><div \nng-if=\"vm.tabSelecionada == \'estimativa\' \" ng-include=\"vm.htmlRota.tabs.estimativa\"></div></md-tab-body></md-tab>\n<md-tab label=\"Historico\" md-active=\"vm.tabSelecionada === \'historico\'\" \nmd-on-select=\"vm.metodosGeral.tabSelecionada(\'historico\')\" \nng-disabled=\"!vm.controleForm.pesquisaAtiva || vm.controleForm.inserirAtivo || vm.controleForm.editarAtivo\">\n<md-tab-label><label translate=\"HISTORICO.HISTORICO\"></label></md-tab-label><md-tab-body><div \nng-if=\"vm.tabSelecionada == \'historico\' && !vm.controleForm.inserirAtivo\" ui-view=\"solicitacao--tab-historico\"></div>\n</md-tab-body></md-tab><md-tab label=\"Documentação\" md-active=\"vm.tabSelecionada === \'documentacao\'\" \nmd-on-select=\"vm.metodosGeral.tabSelecionada(\'documentacao\')\" \nng-disabled=\"!vm.controleForm.pesquisaAtiva || vm.controleForm.inserirAtivo || vm.controleForm.editarAtivo\">\n<md-tab-label><label translate=\"DOCUMENTACAO.DOCUMENTACAO\"></label></md-tab-label><md-tab-body><div \nng-if=\"vm.tabSelecionada == \'documentacao\' && !vm.controleForm.inserirAtivo\" ui-view=\"tab-documentacao\"></div>\n</md-tab-body></md-tab></md-tabs></md-content></div></form>");
$templateCache.put("app/main/solicitacao/processamento/solicitacao/views/solicitacao-table.html","<div layout=\"column\" flex><div class=\"md-padding md-background-bg md-whiteframe-1dp fullpage-datatable\" \nlayout=\"column\" flex><table class=\"dataTable row-border hover\" id=\"datatable-solicitacao\" width=\"100%\"><thead><tr><th \nclass=\"secondary-text\">Ação</th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Numero\n</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Ano</span></div></th>\n<th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Data abertura</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Cliente</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Solução</span></div></th></tr></thead>\n</table></div></div>");
$templateCache.put("app/main/solicitacao/processamento/solicitacao/views/solicitacao.html","<div id=\"cadastrar_solicitacao\" layout=\"column\">{{ vm.solicitacoes.length }}<header-padrao \ntranslate-nome=\"SOLICITACAO.SOLICITACAO\" texto-auxiliar=\"vm.solicitacao.numero +  \'/\' +  vm.solicitacao.ano\" \nicone=\"icon-book-open\" texto-auxiliar-habilitado=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.inserirAtivo\" \nng-utiliza-pesquisa=\"false\"></header-padrao><div class=\"content\"><div ui-view=\"solicitacao-form\"></div></div><div \nui-view=\"solicitacao-table\" ng-if=\"vm.controleForm.listarTodasEntidades\"></div></div>");
$templateCache.put("app/main/solicitacao/cadastro/fase/views/fase-form.html","<form name=\"vm.form.fase\" novalidate><pg-toolbar entidade=\"vm.fase\" entidade-de-envio=\"vm.entidadeDeEnvio\" \ncontrolador-toolbar=\"vm.controleForm\" acao-pesquisar=\"vm.metodos.pesquisar()\" acao-criar=\"vm.metodos.criar(vm.fase)\" \nacao-editar=\"vm.metodos.atualizar(vm.fase)\" acao-excluir=\"vm.metodos.excluir(vm.fase)\" \nconstruir-dt-options=\"vm.metodos.construirDtOptions()\" metodos-externos=\"vm.metodosExternosPgToolbar\" \ncampo-pesquisar=\"vm.pesquisar\"></pg-toolbar><div class=\"content\"><md-content layout-padding \nng-hide=\"vm.controleForm.listarTodasEntidades\" ng-disabled=\"vm.controleForm.emProgresso\"><div layout=\"row\">\n<md-input-container flex><label translate=\"FASE.DESCRICAO\"></label><input type=\"text\" ng-model=\"vm.fase.descricao\" \nname=\"descricao\" mascara-tamanho-campo=\"50\" md-maxlength=\"50\" metodos-externos=\"vm.metodosExternosPgToolbar\" \nng-required=\"vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\"><div \nng-messages=\"vm.form.fase.descricao.$error\"><div ng-message=\"required\" translate=\"FASE.CAMPO_OBRIGATORIO\"></div></div>\n</md-input-container></div><div layout-gt-sm=\"row\" layout-padding><div layout-gt-sm=\"row\" layout-padding flex=\"40\">\n<md-input-container class=\"md-block\" flex><md-checkbox name=\"exigirMotivo\" aria-label=\"Exigir motivo\" \nng-model=\"vm.fase.exige_Motivo\" \nng-disabled=\"vm.controleForm.pesquisaAtiva &&\r\n                                                 !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\">\n<span class=\"float-label-cor-default\" translate=\"FASE.EXIGIR_MOTIVO\"></span></md-checkbox></md-input-container>\n<md-input-container class=\"md-block\" flex><md-checkbox name=\"concluirSolicitacao\" aria-label=\"Concluir soliitação\" \nng-model=\"vm.fase.concluida\" \nng-disabled=\"vm.controleForm.pesquisaAtiva &&\r\n                                                 !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\">\n<span class=\"float-label-cor-default\" translate=\"FASE.CONCLUIR_SOLICITACAO\"></span></md-checkbox></md-input-container>\n</div></div></md-content></div></form>");
$templateCache.put("app/main/solicitacao/cadastro/fase/views/fase-table.html","<div layout=\"column\" flex><div class=\"md-padding md-background-bg md-whiteframe-1dp fullpage-datatable\" \nlayout=\"column\" flex><table class=\"dataTable row-border hover\" id=\"datatable-fase\" width=\"100%\"><thead><tr><th>Ação\n</th><th>Código</th><th>Descrição</th><th>Exigir motivo</th><th>Concluir solicitação</th></tr></thead></table></div>\n</div>");
$templateCache.put("app/main/solicitacao/cadastro/fase/views/fase.html","<div id=\"cadastrar_fase\" layout=\"column\"><header-padrao translate-nome=\"FASE.FASE\" ng-utiliza-pesquisa=\"false\">\n</header-padrao><div class=\"content\"><div ui-view=\"fase-form\"></div></div><div ui-view=\"fase-table\" \nng-if=\"vm.controleForm.listarTodasEntidades\"></div></div>");
$templateCache.put("app/core/directives/ms-stepper/templates/vertical/step/vertical-step.html","<md-button class=\"ms-stepper-navigation-item\" \nng-class=\"{\'current\': MsStepper.isStepCurrent(stepInfo.stepNumber), \'valid\': MsStepper.isStepValid(stepInfo.stepNumber), \'disabled\': MsStepper.isStepDisabled(stepInfo.stepNumber) || MsStepper.disableSteps, \'optional\': MsStepper.isStepOptional(stepInfo.stepNumber)}\" \nng-click=\"MsStepper.gotoStep(stepInfo.stepNumber)\" \nng-disabled=\"MsStepper.isStepDisabled(stepInfo.stepNumber) || MsStepper.disableSteps\" \nng-hide=\"MsStepper.isStepHidden(stepInfo.stepNumber)\" aria-label=\"Stepper navigation button\" layout=\"row\" \nlayout-align=\"start center\"><div class=\"step\" layout=\"row\" layout-align=\"center center\"><span \nng-if=\"!MsStepper.isStepValid(stepInfo.stepNumber) || MsStepper.isStepOptional(stepInfo.stepNumber)\"><i \nclass=\"icon icon-checkbox-blank-circle-outline s18 md-accent-fg\"></i> </span><span \nng-if=\"MsStepper.isStepValid(stepInfo.stepNumber) && !MsStepper.isStepOptional(stepInfo.stepNumber)\"><i \nclass=\"icon icon-check-circle s18 md-accent-fg\"></i></span></div><div layout=\"column\" layout-align=\"start start\"><div \nclass=\"title\" ng-if=\"stepInfo.stepTitleTranslate\">{{stepInfo.stepTitleTranslate | translate }}</div><div class=\"title\" \nng-if=\"!stepInfo.stepTitleTranslate\">{{stepInfo.stepTitle}}</div><div class=\"subtitle\" \nng-if=\"MsStepper.isStepOptional(stepInfo.stepNumber)\">Optional</div></div></md-button><div \nclass=\"ms-stepper-step-content\" ng-transclude></div><div class=\"ms-stepper-controls\" layout=\"row\" \nlayout-align=\"start center\" ng-show=\"MsStepper.isStepCurrent(stepInfo.stepNumber)\"><md-button \nclass=\"md-accent md-raised\" ng-disabled=\"MsStepper.isFirstStep() || MsStepper.disableSteps\" \nng-click=\"MsStepper.gotoPreviousStep()\">Voltar</md-button><md-button class=\"md-accent md-raised\" \nng-if=\"!MsStepper.isLastStep()\" ng-hide=\"MsStepper.exibeBotaoNext && !MsStepper.isFirstStep()\" \nng-disabled=\"!MsStepper.isStepValid(MsStepper.currentStepNumber) || MsStepper.disableSteps || MsStepper.desabilitaBotaoNext\" \nng-click=\"MsStepper.gotoNextStep()\">Avançar</md-button><md-button type=\"submit\" class=\"md-accent md-raised\" \nng-click=\"MsStepper.resetForm()\" ng-if=\"MsStepper.isLastStep()\" \nng-disabled=\"!MsStepper.isFormValid() || MsStepper.disableSteps\">{{MsStepper.customButtonSubmitText}}</md-button></div>");
$templateCache.put("app/main/agenda/processamento/visualizar-atividades/dialogs/atividade-dialog/atividade-dialog.html","<md-dialog id=\"cliente-dialog-atividade\" class=\"dialogo-padrao\" layout=\"column\" flex aria-label=\"Dialog\"><md-icon \nmd-font-icon=\"icon-close\" class=\"close\" ng-click=\"vm.metodos.fecharDialog()\"></md-icon><div \nng-include=\"\'app/main/agenda/processamento/visualizar-atividades/visualizar-atividades.html\'\"></div></md-dialog>");
$templateCache.put("app/main/agenda/processamento/visualizar-atividades/dialogs/detalhes-atividade/dialog-detalhes-atividades.html","<md-dialog class=\"event-detail-dialog\" aria-label=\"New Message\"><form name=\"form\"><md-toolbar \nng-style=\"vm.styleHeader\" class=\"md-hue-2\"><div layout=\"row\" class=\"md-toolbar-tools\"><span class=\"title\" flex \nlayout-align=\"center center\">Atividade {{vm.calendarEvent.numero}}/{{vm.calendarEvent.ano}}</span><md-icon \nlayout-align=\"end end\" \nng-hide=\"((vm.statusOriginal != vm.calendarEvent.status || vm.reagendamento) && vm.statusOriginal == 1) || vm.ocultarClonagem\" \nmd-font-icon=\"icon-content-duplicate\" ng-click=\"vm.metodos.clonarAtividade()\"><md-tooltip><label>Clonar atividade\n</label></md-tooltip></md-icon><md-icon layout-align=\"end end\" flex-offset=\"5\" \nng-hide=\"vm.emProgresso || ((vm.calendarEvent.dataHoraUltimoHistorico.toLocaleDateString() == vm.dataHoraUltimoHistoricoOriginal.toLocaleDateString()) && vm.calendarEvent.motivo.length)\" \nmd-font-icon=\"icon-arrow-right-bold-circle-outline\" ng-click=\"vm.metodos.irParaInterfaceDeAtividade()\"><md-tooltip>\n<label>Ir para a atividade {{vm.calendarEvent.numero}}/{{vm.calendarEvent.ano}}</label></md-tooltip></md-icon>\n<md-button class=\"edit-event-button md-fab md-info\" \nng-disabled=\"vm.emProgresso ||  vm.desabilitarCampos || form.$invalid\" \nng-show=\"(vm.statusOriginal != vm.calendarEvent.status || vm.reagendamento) && vm.statusOriginal == 1\" \nng-click=\"vm.metodos.salvar(vm.calendarEvent)\" aria-label=\"Edit event\" translate \ntranslate-attr-aria-label=\"CALENDAR.EDIT_EVENT\"><md-icon md-font-icon=\"icon-content-save\"></md-icon></md-button></div>\n</md-toolbar><md-progress-linear ng-show=\"vm.emProgresso\" md-mode=\"indeterminate\"></md-progress-linear>\n<md-dialog-content ms-scroll><div class=\"event-details\" layout=\"column\"><div class=\"event-detail-row\" layout=\"row\" \nng-if=\"vm.calendarEvent.totalReagendamentos\" layout-align=\"start start\"><md-icon md-font-icon=\"icon-calendar-clock\">\n</md-icon><div layout-gt-sm=\"row\" flex><span class=\"h4\">{{vm.calendarEvent.totalReagendamentos}} Reagendamento(s)\n</span></div></div><div class=\"event-detail-row\" layout=\"row\" ng-if=\"vm.calendarEvent.totalReagendamentos\" \nlayout-align=\"start start\"><md-icon md-font-icon=\"icon-clock\"></md-icon><div layout-gt-sm=\"row\" flex><span class=\"h4\">\nCriação: {{vm.calendarEvent.dataHoraCriacao | date:\'dd, MMMM yyyy - H:mm\' }}</span></div></div><div \nclass=\"event-detail-row\" layout=\"row\" layout-align=\"start start\"><md-icon md-font-icon=\"icon-clock\"></md-icon><div \nlayout-gt-sm=\"row\" flex><span class=\"h4\" ng-if=\"vm.calendarEvent.totalReagendamentos > 0\">\nReagendamento: {{vm.calendarEvent.start.format(\'DD, MMMM YYYY - H:mm\')}} </span><span class=\"h4\" \nng-if=\"!vm.calendarEvent.totalReagendamentos\">{{vm.calendarEvent.start.format(\'DD, MMMM YYYY - H:mm\')}}</span></div>\n</div><div class=\"event-detail-row event-link\" layout=\"row\" \nng-click=\"vm.metodos.redirecionarParaCliente(vm.calendarEvent.cliente)\" layout-align=\"start start\"><md-icon \nmd-font-icon=\"icon-person-box\"></md-icon><div layout=\"column\" flex><span class=\"h4\">{{vm.calendarEvent.cliente.nome}}\n</span></div></div><div class=\"event-detail-row\" layout=\"row\" layout-align=\"start start\" \nng-if=\"vm.calendarEvent.usuario\"><md-icon md-font-icon=\"icon-clipboard-account\"></md-icon><div layout=\"column\" flex>\n<span class=\"h4\">{{vm.calendarEvent.usuario.login}}</span></div></div><div class=\"event-detail-row event-link\" \nlayout=\"row\" ng-if=\"vm.calendarEvent.atividadeVinculadaAtendimento\" \nng-click=\"vm.metodos.redirecionarParaAtendimento()\" layout-align=\"start start\"><md-icon md-font-icon=\"icon-phone-log\">\n</md-icon><div layout=\"column\" flex><span class=\"h4\">\n{{vm.calendarEvent.numeroAtendimento}}/{{vm.calendarEvent.anoAtendimento}}</span></div></div><div \nclass=\"event-detail-row\" layout=\"row\" layout-align=\"start start\"><md-icon md-font-icon=\"icon-star-circle\"></md-icon>\n<div layout=\"column\" flex><span class=\"h4\">{{vm.calendarEvent.evento.descricao}}</span></div></div><div \nclass=\"event-detail-row\" layout=\"row\" ng-if=\"vm.calendarEvent.observacao\" layout-align=\"start start\"><md-icon \nmd-font-icon=\"icon-message-processing\"></md-icon><div layout=\"column\" flex><span class=\"h4 quebra-linha\">\n{{vm.calendarEvent.observacao}}</span></div></div><div layout-gt-sm=\"row\"><fieldset class=\"standard\" flex><legend \nclass=\"grp-legend\" translate=\"AGENDA.STATUS\"></legend><md-radio-group ng-model=\"vm.calendarEvent.status\" \nng-change=\"vm.metodos.selecionarStatus()\" ng-disabled=\"vm.statusOriginal != 1 ||  vm.desabilitarCampos\" \nlayout-gt-sm=\"row\" class=\"mb-5\" layout-align=\"center center\" flex><md-radio-button ng-value=\"status.value\" \nng-repeat=\"status in vm.status track by $index\" aria-label=\"{{status.key}}\">{{status.key}}</md-radio-button>\n</md-radio-group><div layout=\"column\" flex><md-input-container class=\"md-block\" ng-hide=\"vm.calendarEvent.status != 3\" \nflex><label translate=\"AGENDA.MOTIVO_CANCELAMENTO\">Motivo do cancelamento</label><textarea \nng-model=\"vm.calendarEvent.motivoCancelamento\" name=\"motivoCancelamento\" mascara-tamanho-campo=\"50\" \nng-disabled=\"vm.statusOriginal != 1 ||  vm.desabilitarCampos\" md-maxlength=\"50\" \nng-required=\"vm.calendarEvent.status == 3\" max-rows=\"4\">\r\n                                                    \n</textarea><div ng-messages=\"form.motivoCancelamento.$error\"><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container></div></fieldset></div><md-switch \naria-label=\"Disabled switch\" class=\"mt-5\" \nng-hide=\"vm.statusOriginal != 1 || vm.calendarEvent.status != 1 || vm.desabilitarCampos\" ng-model=\"vm.reagendamento\">\nReagendamento</md-switch><div ng-if=\"vm.reagendamento\"><div layout-gt-sm=\"row\" flex \nng-hide=\"vm.calendarEvent.status == 3\"><md-input-container class=\"md-block\"><label \ntranslate=\"CALENDARIO.DATA_REAGENDAMENTO\"></label><md-datepicker ng-model=\"vm.calendarEvent.dataHoraUltimoHistorico\" \nng-focus=\"true\" ng-if=\"vm.reagendamento\" ng-required=\"vm.reagendamento\" name=\"dataHoraUltimoHistorico\" \nmd-min-date=\"vm.mindate\" flex-gt-sm=\"30\" mascara-conversor-string-para-data ng-mask=\"3?9/1?9/9999\" \nng-disabled=\"vm.emProgresso ||  vm.desabilitarCampos\"></md-datepicker><div \nng-messages=\"form.dataHoraUltimoHistorico.$error\"><div ng-message=\"valid\" translate=\"MENSAGEM_VALIDACAO.DATA_INVALIDA\">\n</div><div ng-message=\"mindate\">Data inferior a hoje</div><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.DATA_OBRIGATORIA\"></div></div></md-input-container><md-input-container class=\"md-block\" \nflex-gt-sm ng-if=\"vm.reagendamento\"><label translate=\"AGENDA.HORA\"></label><input type=\"text\" \nng-model=\"vm.calendarEvent.hora\" name=\"hora\" ng-disabled=\"vm.desabilitarCampos\" mascara-numero-generica=\"##:##\" \npattern=\"^(([1]{1}[0-8]{1}){1}|([0]{1}[7-9]){1}){1}:[0-5]{1}[0-9]{1}$\"><div ng-messages=\"form.hora.$error\"><div \nng-message=\"pattern\" translate=\"AGENDA.HORA_INVALIDA\"></div></div></md-input-container></div><div layout-gt-xs=\"row\" \nng-if=\"vm.reagendamento\" flex><md-input-container class=\"md-block\" ng-hide=\"!vm.reagendamento\" flex><label \ntranslate=\"AGENDA.MOTIVO\">Motivo</label><textarea ng-model=\"vm.calendarEvent.motivo\" name=\"observacao\" \nmascara-tamanho-campo=\"50\" md-maxlength=\"50\" ng-disabled=\"vm.desabilitarCampos\" ng-required=\"vm.reagendamento\" \nmax-rows=\"4\">\r\n                            </textarea></md-input-container></div></div></div></md-dialog-content>\n</form></md-dialog>");
$templateCache.put("app/main/agenda/processamento/visualizar-atividades/dialogs/legenda/dialog-legenda.html","<md-dialog class=\"event-detail-dialog\" aria-label=\"New Message\"><form ng-submit=\"vm.metodos.enviarMensagem()\" \nname=\"vm.form\" class=\"md-inline-form\" novalidate><md-toolbar class=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" \nlayout=\"row\" layout-align=\"space-between center\"><span class=\"title\">Legenda</span></div></md-toolbar>\n<md-dialog-content ms-scroll class=\"responsividade\"><div layout-gt-sm=\"row\" flex layout-align=\"center center\"><div \nlayout=\"row\" flex-offset=\"5\" ng-repeat=\"legenda in vm.legendas\"><div class=\"legenda\" ng-class=\"legenda.descricao\">\n</div><span>{{legenda.descricao}}</span></div></div></md-dialog-content></form></md-dialog>");
$templateCache.put("app/main/agenda/processamento/visualizar-atividades/dialogs/dialog-cadastro-atividade/dialog-cadastro-atividades.html","<md-dialog class=\"event-detail-dialog\" aria-label=\"New Message\"><form name=\"form\"><md-toolbar \nclass=\"md-accent md-hue-2\"><div layout=\"row\" class=\"md-toolbar-tools\"><span class=\"title\" flex \nlayout-align=\"center center\">Cadastro de atividades</span><md-button class=\"edit-event-button md-fab md-info\" \nng-hide=\"vm.controleForm.emProgresso || form.$invalid\" ng-click=\"vm.metodos.salvarDialog(vm.atividade)\" \naria-label=\"Cadastrar\"><md-icon md-font-icon=\"icon-content-save\"></md-icon></md-button></div></md-toolbar>\n<md-progress-linear class=\"md-accent\" ng-show=\"vm.controleForm.emProgresso\" md-mode=\"indeterminate\">\n</md-progress-linear><md-dialog-content ms-scroll><div class=\"event-details\" layout=\"column\"><div layout-gt-sm=\"row\">\n<md-autocomplete flex ng-model-options=\"{debounce: 200}\" md-input-name=\"cliente\" ng-required=\"true\" \nng-disabled=\"vm.controleForm.emProgresso || vm.desabilitarCampos ||  vm.inicializouComCliente || vm.clonando\" \nmd-no-cache=\"true\" ng-blur=\"vm.metodos.configuraAutoCompleteClienteOnBlur()\" md-selected-item=\"vm.atividade.cliente\" \nmd-selected-item-change=\"vm.metodos.alterarItemSelecionadoAutoCompleteCliente(item)\" \nmd-search-text=\"vm.textoDePesquisaAutoCompleteCliente\" \nmd-items=\"item in vm.metodos.pesquisarAutoCompleteCliente(vm.textoDePesquisaAutoCompleteCliente)\" \nmd-item-text=\"item.codigo + \' - \' + item.nome\" md-autoselect md-floating-label=\"Cliente\"><md-item-template><span \nmd-highlight-text=\"vm.textoDePesquisaAutoCompleteCliente\">{{item.codigo}} - {{item.nome}}</span></md-item-template>\n<md-not-found><label>Não foi encontrado nenhum Cliente.</label></md-not-found></md-autocomplete></div><div><div \nlayout=\"row\" flex layout-align=\"end center\"><md-checkbox ng-model=\"vm.atividade.atividadeVinculadaAtendimento\" \nng-change=\"vm.metodos.removerAtendimento(vm.atividade.atividadeVinculadaAtendimento)\" \nng-disabled=\"vm.desabilitarCampos ||  vm.desabilitarAtendimento\"><span translate=\"AGENDA.VINCULAR_ATENDIMENTO\">\nVincular atendimento</span></md-checkbox></div><div layout=\"row\" flex \nng-if=\"vm.atividade.atividadeVinculadaAtendimento\"><md-input-container class=\"md-block\" flex=\"10\" \nng-hide=\"!vm.carregandoAtendimento\"><md-progress-circular class=\"md-accent\" md-diameter=\"30\" md-mode=\"indeterminate\">\n</md-progress-circular></md-input-container><md-input-container class=\"md-block\" flex><label \ntranslate=\"AGENDA.ATENDIMENTO\"></label><md-select ng-model=\"vm.atividade.atendimento\" flex name=\"atendimento\" \nng-model-options=\"{trackBy: \'$value.codigo\'}\" md-on-open=\"vm.metodos.configuraMdSelectAtendimento()\" \nmd-on-close=\"vm.metodos.configurarMdSelectAtendimentoOnClose()\" \nng-change=\"vm.metodos.selecionarAtendimento(vm.atividade.atendimento)\" \nng-disabled=\"!vm.atividade.cliente || vm.desabilitarCampos ||  vm.desabilitarAtendimento\" \nng-required=\"vm.atividade.atividadeVinculadaAtendimento\"><md-select-header><input id=\"atendimento-md-select\" \nng-if=\"vm.atendimentos && vm.atendimentos.length > 0\" class=\"md-text\" ng-model=\"vm.filtrarAtendimentos\" type=\"search\" \nplaceholder=\"\" translate translate-attr-placeholder=\"PIPELINE_NEGOCIO.PESQUISAR_ATENDIMENTOS\"> <span \nng-if=\"!vm.atendimentos || vm.atendimentos.length == 0\">Não existe atendimentos vinculados ao cliente</span>\n</md-select-header><md-option layout=\"row\" ng-value=\"atendimento\" \nng-if=\"vm.atendimentos && vm.atendimentos.length > 0\" \nng-repeat=\"atendimento in vm.atendimentos | filter:vm.filtrarAtendimentos\"><span hide-sm hide-xs>\n{{atendimento.codigo}}/{{atendimento.ano}} - {{vm.metodos.listarAssuntoAtendimento(atendimento.assunto)}} </span><span \nhide-gt-sm>\n{{atendimento.codigo}}/{{atendimento.ano}} - {{vm.metodos.listarAssuntoAtendimento(atendimento.assunto).substring(0,17)}}...\n</span></md-option></md-select><md-tooltip ng-if=\"!vm.atividade.cliente && !vm.codigoCliente\"><span \ntranslate=\"AGENDA.INFORMAR_CLIENTE\"></span></md-tooltip><div ng-messages=\"vm.form.atividade.atendimento.$error\"><div \nng-message=\"required\" translate=\"AGENDA.OBRIGATORIO\"></div></div></md-input-container></div></div><md-input-container \nclass=\"md-block\" flex-gt-sm><label translate=\"AGENDA.EVENTO\">Evento</label><md-select ng-model=\"vm.atividade.evento\" \nng-required=\"true\" ng-model-options=\"{trackBy: \'$value.codigo\'}\" name=\"codigoEvento\" \nmd-on-open=\"vm.metodos.configuraMdSelectEvento()\" md-on-close=\"vm.metodos.configurarMdSelectEventoOnClose()\" \nng-change=\"vm.metodos.selecionarEvento(vm.atividade.evento)\"><md-select-header><input id=\"evento-md-select\" \nclass=\"md-text\" ng-model=\"vm.filtrarEvento\" type=\"search\" placeholder=\"\" translate \ntranslate-attr-placeholder=\"AGENDA.PESQUISAR_EVENTO\"></md-select-header><md-option ng-value=\"evento\" \nng-repeat=\"evento in vm.eventos | filter:vm.filtrarEvento track by evento.codigo\"><span hide-sm hide-xs>\n{{evento.descricao}} </span><span hide-gt-sm>{{evento.descricao.substring(0,27)}}...</span></md-option></md-select><div\n ng-messages=\"vm.form.atividade.codigoEvento.$error\"><div ng-message=\"required\" translate=\"AGENDA.OBRIGATORIO\"></div>\n</div></md-input-container><div layout-gt-sm=\"column\" ng-hide=\"true\" flex><md-input-container class=\"md-block\" \nflex-gt-sm><label translate=\"AGENDA.NUMERO\"></label><input type=\"text\" ng-model=\"vm.atividade.numero\" \nname=\"agendaAtividadeNumero\" mascara-numero-generica=\"######\" ng-disabled=\"true\"></md-input-container></div><div \nlayout-gt-sm=\"row\" ng-hide=\"true\" flex><md-input-container class=\"md-block\" flex-gt-sm><label translate=\"AGENDA.ANO\">\n</label><input type=\"text\" ng-model=\"vm.atividade.ano\" name=\"agendaAtividadeAno\" mascara-numero-generica=\"######\" \nng-disabled=\"true\"></md-input-container></div><div layout-gt-sm=\"row\" flex><md-input-container class=\"md-block\" \nflex-gt-sm><label translate=\"AGENDA.DATA\"></label><md-datepicker ng-model=\"vm.atividade.ultimoHistorico.data\" \nname=\"historicoData\" flex-gt-sm md-min-date=\"vm.mindate\" mascara-conversor-string-para-data ng-mask=\"3?9/1?9/9999\" \nng-disabled=\"vm.controleForm.emProgresso\" ng-required=\"true\"></md-datepicker><div \nng-messages=\"form.historicoData.$error\"><div ng-message=\"valid\" translate=\"MENSAGEM_VALIDACAO.DATA_INVALIDA\"></div><div\n ng-message=\"mindate\" translate=\"MENSAGEM_VALIDACAO.CAMPO_DATA_ATUAL\"></div><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.DATA_OBRIGATORIA\"></div></div></md-input-container><md-input-container class=\"md-block\" \nflex-gt-sm><label translate=\"AGENDA.HORA\"></label><input type=\"text\" ng-model=\"vm.atividade.ultimoHistorico.hora\" \nname=\"historicoHora\" mascara-numero-generica=\"##:##\" ng-pattern=\"vm.regexHora\"><div class=\"message-error\" \nng-show=\"form.historicoHora.$error.pattern\" translate=\"AGENDA.HORA_INVALIDA\"></div></md-input-container></div><div \nlayout=\"row\" flex><md-input-container class=\"md-block input-observacao\" flex><label translate=\"AGENDA.OBSERVACAO\">\n</label><textarea type=\"text\" ng-model=\"vm.atividade.observacao\" \nng-required=\"!vm.atividade.atividadeVinculadaAtendimento\" md-maxlength=\"100\" rows=\"2\" mascara-tamanho-campo=\"100\" \nname=\"agendaAtividadeObservacao\">\r\n                        </textarea><div \nng-messages=\"form.agendaAtividadeObservacao.$error\"><div ng-message=\"required\" translate=\"AGENDA.OBRIGATORIO\"></div>\n</div></md-input-container></div></div></md-dialog-content></form></md-dialog>");
$templateCache.put("app/main/atendimento/processamento/atendimento/atendimentos-em-aberto/dialog-historias-vinculadas/dialog-historias-vinculadas.html","<md-dialog id=\"atendimento-dialog-historias-vinculadas\" class=\"dialogo-padrao\" aria-label=\"Dialog\"><md-toolbar \nclass=\"md-accent md-tall\" layout=\"column\"><div class=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" \nlayout-align=\"space-between center\"><span class=\"title\">Histórias vinculadas</span><md-button class=\"md-icon-button\" \nng-click=\"vm.metodos.fecharDialog()\" aria-label=\"Fechar dialog\" translate \ntranslate-attr-aria-label=\"SPRINT.FECHAR_DIALOG\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content flex><div layout-gt-xs=\"column\" layout-align=\"center center\" flex><table \nclass=\"dataTable row-border hover\" datatable=\"ng\" dt-options=\"vm.dtOptions\" style=\"width: 100%\"><thead><tr><th \nclass=\"secondary-text border-left border-right\"><div class=\"table-header\"><span class=\"column-title\">História</span>\n</div></th><th class=\"secondary-text border-right\"><div class=\"table-header\"><span class=\"column-title\">Descrição\n</span></div></th><th class=\"secondary-text border-right\"><div class=\"table-header\"><span class=\"column-title\">\nData de conclusão</span></div></th><th class=\"secondary-text border-right\"><div class=\"table-header\"><span \nclass=\"column-title\">Sprint</span></div></th><th class=\"secondary-text border-right\"><div class=\"table-header\"><span \nclass=\"column-title\">Status</span></div></th><th class=\"secondary-text border-right\"><div class=\"table-header\"><span \nclass=\"column-title\">Solução</span></div></th><th class=\"secondary-text\" \nstyle=\"border-right: 1px solid rgba(0, 0, 0, 0.12) !important\"><div class=\"table-header\"><span \nclass=\"column-title text\">Ação</span></div></th></tr></thead><tbody><tr ng-repeat=\"historia in vm.historias\"><td \nclass=\"border-left border-right text-center\">{{ historia.numero }}/{{ historia.ano }}</td><td class=\"border-right\">\n{{ historia.descricao }}</td><td class=\"border-right text-center\"><span ng-show=\"false\">{{ historia.dataEntrega}}\n</span> {{ historia.dataEntrega | date:\'dd/MM/yyyy\' }}</td><td class=\"border-right text-center\">{{ historia.sprint }}\n</td><td class=\"border-right text-center\"><div class=\"situacao-estoria\" ng-repeat=\"situacao in vm.coresSituacoes\" \nng-if=\"situacao.codigo == historia.situacaoCodigo\" ng-style=\"{\'background-color\': situacao.cor}\" \nng-class=\"{\'texto-fundo-claro\': situacao.codigo == 1 || situacao.codigo == 3}\" layout-align=\"center center\" flex><span \nclass=\"text-center\">{{ historia.situacaoDescricao }}</span></div></td><td class=\"border-right text-center\">\n{{ historia.solucao }}</td><td class=\"border-right button-icone-cor-azul text-center\"><i \nclass=\"icon-open-in-new s16 icone-cor-padrao\" ng-click=\"vm.metodos.abrirHistoriaNovaAba(historia)\"><md-tooltip \nmd-autohide><span>Abrir história em nova aba</span></md-tooltip></i></td></tr></tbody></table></div>\n</md-dialog-content></md-dialog>");
$templateCache.put("app/main/atendimento/processamento/atendimento/atendimentos-em-aberto/dialog-tendimentos-em-aberto/atendimento-em-aberto-dialog.html","<md-dialog id=\"atendimento-dialog-usuarios-com-atendimento-em-aberto-do-setor\" class=\"dialogo-padrao\" \naria-label=\"Dialog\"><form name=\"vm.form.dialogUsuariosComAtendimentoEmAbertoDoSetor\" class=\"md-inline-form\" novalidate>\n<md-toolbar class=\"md-accent md-tall\" layout=\"column\"><div class=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" \nlayout-align=\"space-between center\"><span class=\"title\">{{vm.titulo}}</span><md-button class=\"md-icon-button\" \nng-click=\"vm.metodosDialog.fecharDialog()\" aria-label=\"Fechar dialog\" translate \ntranslate-attr-aria-label=\"SPRINT.FECHAR_DIALOG\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div>\n</md-toolbar><div layout=\"row\" layout-sm=\"row\" layout-align=\"center\" ng-show=\"vm.requisicaoSolicitada\">\n<md-progress-circular md-mode=\"indeterminate\" class=\"md-accent\"></md-progress-circular></div><md-dialog-content \nng-hide=\"vm.requisicaoSolicitada\"><div layout-gt-xs=\"row\" layout-align=\"center center\" flex><md-input-container \nclass=\"md-block\" flex-gt-sm=\"20\" ng-if=\"vm.squadUsuarioLogado.length > 1\"><label>Squad</label><md-select \nng-model=\"vm.codigoSquads\" name=\"codigoSquads\" multiple=\"multiple\" ng-required=\"true\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\" \nng-change=\"vm.metodosDialog.selectChangeSquad(vm.codigoSquads)\"><md-option ng-value=\"squad.codigo\" \nng-repeat=\"squad in vm.squads track by squad.codigo\">{{squad.descricao}}</md-option></md-select><div \nng-messages=\"vm.form.dialogUsuariosComAtendimentoEmAbertoDoSetor.codigoSquads.$error\"><div ng-message=\"required\">\nCampo obrigatório</div></div></md-input-container><md-input-container class=\"md-block\" flex-gt-sm=\"50\" \nclass=\"select-colaborador\"><label translate=\"ATENDIMENTO.COLABORADOR\"></label><md-select \nng-model=\"vm.codigoUsuariosSelecionados\" multiple=\"multiple\" \nmd-on-close=\"vm.metodosDialog.verificaQuantidadeUsuariosSelecionado(vm.codigoUsuariosSelecionados)\" name=\"usuario\" \nng-disabled=\"vm.squadUsuarioLogado.length > 1 && !vm.codigoSquads.length\"><md-select-header \nng-if=\"vm.usuarios.length === 0\" class=\"container-header\" style=\"cursor: default!important\"><span \nstyle=\"color: #CCC !important\">Nenhum colaborador com atendimento em aberto encontrado.</span></md-select-header>\n<md-option ng-value=\"usuario.codigo\" ng-repeat=\"usuario in vm.usuarios track by usuario.codigo\">{{usuario.login}}\n</md-option></md-select><div ng-messages=\"vm.form.dialogUsuariosComAtendimentoEmAbertoDoSetor.usuario.$error\"><div \nng-message=\"required\">Campo obrigatório</div></div></md-input-container><md-input-container class=\"md-block\">\n<md-checkbox ng-model=\"vm.todosUsuarios\" \nng-change=\"vm.metodosDialog.alterarEstadoCheckboxTodosUsuarios(vm.todosUsuarios)\" \nng-disabled=\"vm.codigoUsuariosSelecionados.length <= 0 || !vm.codigoUsuariosSelecionados\" \naria-label=\"Todos Colaboradores\" name=\"todosColaboradores\"><span class=\"float-label-cor-default\">Todos colaboradores\n</span></md-checkbox></md-input-container></div></md-dialog-content><md-dialog-actions layout=\"row\" \nlayout-align=\"end center\" flex><div layout=\"row\" layout-align=\"end center\" flex><md-button type=\"submit\" \nng-click=\"vm.metodosDialog.pesquisar(vm.codigoUsuariosSelecionados, $event)\" class=\"send-button md-accent md-raised\" \nng-disabled=\"vm.requisicaoSolicitada || vm.form.dialogUsuariosComAtendimentoEmAbertoDoSetor.$invalid || vm.usuarios.length === 0\" \naria-label=\"Pesquisar\" translate=\"ATENDIMENTO.PESQUISAR\" translate-attr-aria-label=\"ATENDIMENTO.PESQUISAR\"></md-button>\n</div></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/atendimento/processamento/atendimento/diretivas/toolbar-historico-atendimento/toolbar-historico-atendimento.html","<md-toolbar class=\"md-menu-toolbar\"><div layout=\"row\" class=\"pt-10\" layout-align=\"center center\" flex><span \nclass=\"md-subheader cor-escrita-desabilitado\" translate=\"ATENDIMENTO.HISTORICO\">Histórico</span></div><div \nlayout=\"row\" layout-align=\"center\" flex ng-class=\"{\'container-botoes-toolbar\': vm.indexHistoricoAtendimento != 0}\">\n<md-button type=\"submit\" ng-if=\"vm.indexHistoricoAtendimento == 0\" class=\"md-icon-button\" aria-label=\"EDITAR\" \nng-click=\"vm.editarHistorico({\r\n                $event: $event,\r\n                historico: vm.historicoAtendimentos[vm.indexHistoricoAtendimento],\r\n                index: vm.indexHistoricoAtendimento\r\n            })\">\n<md-icon ng-style=\"{\'color\': \'rgb(3,155,229)\'}\" md-font-icon=\"icon-pencil s20\"></md-icon></md-button><md-button \nclass=\"md-icon-button\" aria-label=\"Expandir visualização\" \nng-click=\"vm.metodos.abrirDialogVisualizacaoHistorico($event)\"><md-icon md-font-icon=\"icon-open-in-new s22\" \nstyle=\"color: #039be5\"></md-icon></md-button><md-button type=\"submit\" \nng-disabled=\"vm.historicoAtendimentos.length == 0 || vm.historicoAtendimentos == null || vm.indexHistoricoAtendimento == 0\" \nng-click=\"vm.metodos.primeiro()\" class=\"md-icon-button\" aria-label=\"PRIMEIRO\"><md-icon \nng-class=\"{\'altera-cor-botao\': !(vm.historicoAtendimentos.length == 0 || vm.historicoAtendimentos == null || vm.indexHistoricoAtendimento == 0)}\" \nmd-font-icon=\"icon-chevron-double-left s24\"></md-icon></md-button><md-button type=\"submit\" \nng-click=\"vm.metodos.anterior()\" \nng-disabled=\"vm.historicoAtendimentos.length == 0 || vm.historicoAtendimentos == null || vm.indexHistoricoAtendimento == 0\" \nclass=\"md-icon-button\" aria-label=\"ANTERIOR\"><md-icon \nng-class=\"{\'altera-cor-botao\': !(vm.historicoAtendimentos.length == 0 || vm.historicoAtendimentos == null || vm.indexHistoricoAtendimento == 0)}\" \nmd-font-icon=\"icon-chevron-left s24\"></md-icon></md-button><div class=\"texto-secundario ml-10\" \nng-if=\"vm.historicoAtendimentos.length > 0\" layout=\"row\" layout-align=\"start center\"><span \nstyle=\"font-size: 1.3rem!important\">{{vm.indexHistoricoAtendimento+1}} de {{vm.historicoAtendimentos.length}}</span>\n</div><md-button type=\"submit\" ng-click=\"vm.metodos.proximo()\" \nng-disabled=\"vm.historicoAtendimentos.length == 0 || vm.historicoAtendimentos == null \r\n                   || vm.indexHistoricoAtendimento == vm.historicoAtendimentos.length-1\" \nclass=\"md-icon-button\" aria-label=\"PROXIMO\"><md-icon \nng-class=\"{\'altera-cor-botao\': !(vm.historicoAtendimentos.length == 0 || vm.historicoAtendimentos == null \r\n            || vm.indexHistoricoAtendimento == vm.historicoAtendimentos.length-1)}\" \nmd-font-icon=\"icon-chevron-right s24\"></md-icon></md-button><md-button type=\"submit\" ng-click=\"vm.metodos.ultimo()\" \nng-disabled=\"vm.historicoAtendimentos.length == 0 || vm.historicoAtendimentos == null \r\n                   || vm.indexHistoricoAtendimento == vm.historicoAtendimentos.length-1\" \nclass=\"md-icon-button\" aria-label=\"ULTIMO\"><md-icon md-font-icon=\"icon-chevron-double-right s24\" \nng-class=\"{\'altera-cor-botao\': !(vm.historicoAtendimentos.length == 0 || vm.historicoAtendimentos == null \r\n            || vm.indexHistoricoAtendimento == vm.historicoAtendimentos.length-1)}\">\n</md-icon></md-button><md-button class=\"md-icon-button\" type=\"submit\" id=\"pg-toolbar-botao-listartodasentidades-1\" \nng-click=\"vm.metodos.modoTabela()\" aria-label=\"Listar Todos\"><md-icon md-font-icon=\"icon-format-list-bulleted s24\" \nstyle=\"color: #039be5\"></md-icon></md-button></div><div layout-gt-sm=\"row\" flex class=\"row-historico\"><div \nlayout=\"row\" layout-align=\"start center\" flex><span class=\"md-subheader cor-escrita-desabilitado\">Data: </span><span \nclass=\"md-subheader cor-escrita-desabilitado ml-5\">\n{{vm.informacoesHistoricoAtendimento.data | date: \'dd/MM/yyyy HH:mm\'}}</span></div><div layout=\"row\" \nlayout-align=\"start center\" flex><span class=\"md-subheader cor-escrita-desabilitado\">Colaborador: </span><span \nclass=\"md-subheader cor-escrita-desabilitado ml-5\">{{vm.informacoesHistoricoAtendimento.usuario.login}}</span></div>\n</div><div layout-gt-sm=\"row\" flex class=\"row-historico\"><div layout=\"row\" layout-align=\"start center\" flex><span \nclass=\"md-subheader cor-escrita-desabilitado\">Contato: </span><span class=\"md-subheader cor-escrita-desabilitado ml-5\">\n{{vm.informacoesHistoricoAtendimento.contato}}</span></div></div></md-toolbar>");
$templateCache.put("app/main/atendimento/processamento/atualizacoes-pendentes/components/tabela/tabela-atualizacoes-pendentes.html","<div class=\"no-results text-center\" ng-if=\"vm.clientes.length == 0\"><div class=\"message\"><md-icon \nclass=\"message-icon s90\" md-font-icon=\"icon-information-outline\"></md-icon><div class=\"titulo-text\">\nNão existem atualizações pendentes no momento</div></div></div><div ng-if=\"vm.clientes.length > 0\" \nid=\"tabela-atualizacoes-pendentes\" class=\"fullpage-datatable scrollable\" ms-scroll style=\"width: 100%\"><table \nclass=\"dataTable row-border hover tabela-clientes\" dt-options=\"vm.dtOptions\" width=\"100%\"><thead><tr><th \nclass=\"secondary-text border-left codigo\"><div class=\"table-header\"><span class=\"column-title\">Código</span></div></th>\n<th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Nome</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title span-acao ml-10\">Ações</span></div></th><th \nclass=\"secondary-text titulo-acoes\"><div class=\"table-header\"><span class=\"column-title\">Quantidade de histórias</span>\n</div></th></tr></thead><tbody><tr ng-repeat-start=\"cliente in vm.clientes\"><td class=\"border-left codigo\">\n{{cliente.cliente.codigo}}</td><td>{{cliente.cliente.nome}}</td><td class=\"acoes\"><i \nclass=\"{{cliente.expandido ? \'icon-eye-off\' : \'icon-eye\'}} s18 icone-cor-padrao\" \nng-click=\"cliente.expandido = !cliente.expandido\"><md-tooltip><label>\n{{cliente.expandido ? \'Ocultar histórias\' : \'Ver histórias\'}}</label></md-tooltip></i><i \nclass=\"icon-open-in-new s18 icone-cor-padrao ml-5\" ng-click=\"vm.metodos.visualizarCliente(cliente.cliente)\">\n<md-tooltip><label>Visualizar {{cliente.cliente.nome}}</label></md-tooltip></i></td><td \nclass=\"border-right coluna-contador\"><span>{{cliente.historias.length}}</span></td></tr><tr ng-if=\"cliente.expandido\" \nng-repeat-end><td colspan=\"4\"><table class=\"dataTable row-border hover tabela-historias\" width=\"100%\"><thead><tr><th \nclass=\"border-left\">Solicitação</th><th>História</th><th>Squad</th><th>Solução</th><th>Situação da história</th><th>\nData homologação</th><th class=\"titulo-acoes acoes\">Previsão de atualização</th></tr></thead><tbody><tr \nng-repeat=\"historia in cliente.historias\"><td class=\"border-left\"><div \nstyle=\"display: flex; flex-direction: row; justify-content: center;\r\n                                    align-items: center\" \nng-if=\"historia.solicitacaoNumero && historia.solicitacaoAno\"><span>\n{{historia.solicitacaoNumero}}/{{historia.solicitacaoAno}}</span> <i \nclass=\"icon-open-in-new s18 icone-cor-padrao ml-5\" \nng-click=\"vm.metodos.visualizarSolicitacao(historia.solicitacaoNumero, historia.solicitacaoAno, historia.squadCodigo)\">\n<md-tooltip><label>Visualizar solicitação</label></md-tooltip></i></div><span \nng-if=\"!historia.solicitacaoNumero && !historia.solicitacaoAno\">-</span></td><td><div \nstyle=\"display: flex; flex-direction: row; justify-content: center;\r\n                                    align-items: center; margin-left: 5px\">\n<span>{{historia.numero}}/{{historia.ano}}</span> <i class=\"icon-open-in-new s18 icone-cor-padrao ml-5\" \nng-click=\"vm.metodos.visualizarHistoria(historia)\"><md-tooltip><label>Visualizar história</label></md-tooltip></i>\n</div></td><td>{{vm.squadService.descricaoSquad(historia.squadCodigo)}}</td><td>{{historia.solucao.descricao}}</td><td>\n<div class=\"situacao-estoria\" ng-repeat=\"situacao in vm.coresSituacoes\" \nng-if=\"situacao.codigo == historia.ultimoHistoricoSituacao.situacaoCodigo\" \nng-style=\"{\'background-color\': situacao.cor}\" \nng-class=\"{\'texto-fundo-claro\': situacao.codigo == 1 || situacao.codigo == 3}\" layout-align=\"center center\" flex><span \nclass=\"text-center\">{{ situacao.descricao }}</span></div></td><td>\n{{historia.ultimoHistoricoSituacao.data | date:\'dd/MM/yyyy\'}}</td><td class=\"border-right acoes\">\n{{(historia.dadosAtualizacao.dataPrevisaoAtualizacao | date:\'dd/MM/yyyy\') || \'-\'}}</td></tr></tbody></table></td></tr>\n</tbody></table></div>");
$templateCache.put("app/main/atendimento/estatisticas/tags/components/grafico-clientes/grafico-clientes.html","<div class=\"container-grafico-clientes\"><div class=\"titulo border-bottom\"><span>Clientes</span></div><div \nclass=\"container-grafico-total\" ng-if=\"vm.donutChartClientes.data.length >= 1\"><div class=\"grafico\"><nvd3 \noptions=\"vm.donutChartClientes.options\" data=\"vm.donutChartClientes.data\"></nvd3></div></div><div \nclass=\"no-results text-center\" ng-if=\"vm.donutChart.data.length == 0\"><div class=\"message\"><md-icon \nclass=\"message-icon s80\" md-font-icon=\"icon-information-outline\"></md-icon><div class=\"titulo-text\">\nNão existem atualizações pendentes no momento</div></div></div></div>");
$templateCache.put("app/main/atendimento/estatisticas/tags/components/grafico-tags/grafico-tags.html","<div layout=\"column\" class=\"container-grafico-tags\"><div class=\"titulo border-bottom\" layout=\"row\"><span>\nTags mais utilizadas</span></div><div ng-if=\"vm.donutChart.data.length >= 1\" style=\"position: relative\"><div \nclass=\"grafico\"><nvd3 options=\"vm.donutChart.options\" data=\"vm.donutChart.data\"></nvd3></div></div><div \nclass=\"no-results text-center\" ng-if=\"vm.donutChart.data.length == 0\"><div class=\"message\"><md-icon \nclass=\"message-icon s80\" md-font-icon=\"icon-information-outline\"></md-icon><div class=\"titulo-text\">\nNão existem atualizações pendentes no momento</div></div></div></div>");
$templateCache.put("app/main/atendimento/processamento/atualizacoes-pendentes/components/sidenav/sidenav-atualizacoes-pendentes.html","<div id=\"filtro-atualizacoes-pendentes\" layout=\"column\" style=\"height: 100%\"><md-toolbar class=\"toolbar md-accent\"><h1 \nclass=\"md-toolbar-tools\">Filtro</h1></md-toolbar><form name=\"vm.form\" flex layout=\"column\"><md-content layout-padding \nflex style=\"overflow-y: auto\"><fieldset><md-input-container ng-if=\"vm.squadUsuarioLogado.length > 1\" class=\"md-block\" \nflex-gt-sm=\"100\"><label>Squad</label><md-select ng-model=\"vm.filtro.squadCodigo\" name=\"squadCodigo\" ng-required=\"true\" \nmultiple=\"multiple\"><md-option ng-value=\"squad.codigo\" ng-repeat=\"squad in vm.squads track by squad.codigo\">\n{{squad.descricao}}</md-option></md-select><div ng-messages=\"vm.form.squadCodigo.$error\"><div ng-message=\"required\">\nCampo obrigatório</div></div></md-input-container></fieldset></md-content><md-content layout=\"row\" \nlayout-align=\"center center\" class=\"footer\"><md-button class=\"md-raised md-accent\" \nng-disabled=\"vm.form.$invalid || vm.emProgresso\" ng-click=\"vm.metodos.filtrarDados(vm.filtro)\"><span \nng-if=\"!vm.emProgresso\">Filtrar</span><div ng-if=\"vm.emProgresso\" layout=\"row\" layout-align=\"center center\" \nstyle=\"width: 100%\"><md-progress-circular class=\"md-accent\" md-mode=\"indeterminate\" md-diameter=\"32\">\n</md-progress-circular></div></md-button></md-content></form></div>");
$templateCache.put("app/main/atendimento/estatisticas/tags/components/totalizador-atendimentos/totalizador-atendimentos.html","<div class=\"container-totalizador-atendimentos\"><div class=\"titulo border-bottom\"><span>Totalizadores</span></div><div \nclass=\"totalizador-atendimentos\"><div class=\"valores\"><span class=\"finalizados\">{{ vm.totalizador.finalizados }}</span>\n <span>Atend. Finalizados</span></div><div class=\"bordas-laterais\"></div><div class=\"valores\"><span class=\"em-aberto\">\n{{ vm.totalizador.emAberto }}</span> <span>Atend. Em aberto</span></div><div class=\"bordas-laterais\"></div><div \nclass=\"valores\"><span class=\"total\">{{ vm.totalizador.total }}</span> <span>Atend. Total</span></div><div \nclass=\"bordas-laterais\"></div><div class=\"valores\"><span class=\"total\">{{ vm.totalTagsGeral }}</span> <span>\nTotal de tags</span></div><div class=\"bordas-laterais\"></div><div class=\"valores\"><span class=\"total\">\n{{ vm.ultimaBusca.estatistica.clientesRecorrentes.length}}</span> <span>Total de clientes</span></div></div></div>");
$templateCache.put("app/main/datamobil-ia/components/mensagens-recebidas/components/tabela-resposta/tabela-resposta.html","<div class=\"tabela-resposta-container\"><div class=\"container-input-pesquisa-tabela\" style=\"padding-top: 15px\">\n<md-input-container><input type=\"text\" class=\"search-input\" placeholder=\"Pesquisar...\" ng-model=\"vm.pesquisar\">\n</md-input-container></div><div class=\"no-results text-center\" ng-if=\"vm.paginacao.totalItens === 0\"><div \nclass=\"message\"><md-icon class=\"message-icon s40\" md-font-icon=\"icon-information-outline\"></md-icon><div \nclass=\"titulo-text\">Nenhum resultado encontrado!</div></div></div><div class=\"tabela-com-paginacao\" \nng-if=\"vm.paginacao.totalItens > 0\"><div class=\"tabela-scroll-wrapper\"><table class=\"simple\"><thead><tr class=\"border\">\n<th ng-repeat=\"header in vm.cabecalhos\" ng-click=\"vm.metodos.ordenarPor(header)\" style=\"cursor: pointer\">{{ header }}\n<md-icon ng-if=\"vm.ordenacao.coluna === header\" \nmd-font-icon=\"{{vm.ordenacao.direcao === \'asc\' ? \'icon-arrow-up\' : \'icon-arrow-down\'}}\" class=\"s12\" \nstyle=\"margin-top: -2px\"></md-icon></th></tr></thead><tbody><tr class=\"border\" ng-repeat=\"item in vm.dadosPaginados\">\n<td ng-repeat=\"header in vm.cabecalhos\">{{ item[header] }}</td></tr></tbody></table></div><div \nclass=\"pagination-controls\"><div class=\"items-per-page\"><label>Itens por página:</label><md-select \nng-model=\"vm.paginacao.itensPorPagina\" ng-change=\"vm.metodos.mudarItensPorPagina()\" aria-label=\"Itens por página\">\n<md-option ng-repeat=\"option in vm.paginacao.opcoesItensPorPagina\" ng-value=\"option\">{{option}}</md-option></md-select>\n</div><div class=\"pagination-info\"><span>\nExibindo {{vm.paginacao.itemInicial}} - {{vm.paginacao.itemFinal}} de {{vm.paginacao.totalItens}}</span></div><div \nclass=\"pagination-buttons\"><md-button class=\"md-icon-button\" ng-click=\"vm.metodos.primeiraPagina()\" \naria-label=\"Primeira página\" ng-disabled=\"vm.paginacao.paginaAtual === 1\"><md-icon \nmd-font-icon=\"icon-chevron-double-left s24\"></md-icon></md-button><md-button class=\"md-icon-button\" \nng-click=\"vm.metodos.paginaAnterior()\" aria-label=\"Página anterior\" ng-disabled=\"vm.paginacao.paginaAtual === 1\">\n<md-icon md-font-icon=\"icon-chevron-left s24\"></md-icon></md-button><md-button class=\"md-icon-button\" \nng-click=\"vm.metodos.proximaPagina()\" aria-label=\"Próxima página\" \nng-disabled=\"vm.paginacao.paginaAtual === vm.paginacao.totalPaginas\"><md-icon md-font-icon=\"icon-chevron-right s24\">\n</md-icon></md-button><md-button class=\"md-icon-button\" ng-click=\"vm.metodos.ultimaPagina()\" \naria-label=\"Última página\" ng-disabled=\"vm.paginacao.paginaAtual === vm.paginacao.totalPaginas\"><md-icon \nmd-font-icon=\"icon-chevron-double-right s24\"></md-icon></md-button></div></div></div></div>");
$templateCache.put("app/main/datamobil-ia/components/lista-favoritos/components/dialog-favoritos/dialog-favoritos.html","<md-dialog id=\"dialog-favoritos\" class=\"dialogo-padrao dialog-senha\" aria-label=\"Dialog\"><form name=\"favoritosForm\" \nclass=\"md-inline-form\" novalidate ng-submit=\"vm.metodos.salvar()\"><md-toolbar class=\"md-accent md-tall\" \nlayout=\"column\"><div class=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" layout-align=\"space-between center\">\n<span class=\"title\">{{vm.titulo}}</span><md-button class=\"md-icon-button\" ng-click=\"vm.metodos.fecharDialog()\" \naria-label=\"Fechar dialog\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar>\n<md-progress-linear style=\"width: 100%\" class=\"md-accent\" md-mode=\"indeterminate\" ng-show=\"vm.favoritando\">\n</md-progress-linear><md-dialog-content ms-scroll><div class=\"input-titulo\"><md-input-container><label>Título</label>\n<input type=\"text\" name=\"titulo\" ng-model=\"vm.favorito.titulo\" mascara-tamanho-campo=\"60\" md-maxlength=\"60\" \ncaracteres-permitidos></md-input-container></div><div class=\"input-container\" layout=\"row\" \nlayout-align=\"center center\" ng-class=\"{\'has-content\': vm.favorito.comando}\"><md-button class=\"md-icon-button\" \nng-click=\"vm.metodos.copiarComando()\" aria-label=\"Copiar Comando\" \nstyle=\"position: absolute; top: 0; right: 0; z-index: 99\"><md-icon ng-if=\"!vm.acaoCopiar\" \nstyle=\"color: rgba(0, 0, 0, 0.54)\" md-svg-src=\"assets/custom/copy.svg\"></md-icon><md-icon ng-if=\"vm.acaoCopiar\" \nstyle=\"color: rgba(0, 0, 0, 0.54)\" md-font-icon=\"icon-check-circle s16\"></md-icon><md-tooltip \nmd-autohidemd-delay=\"200\"><span>Copiar</span></md-tooltip></md-button><label class=\"legend\">Comando</label>\n<md-input-container md-no-float class=\"md-block\"><textarea ng-model=\"vm.favorito.comando\" \nplaceholder=\"Insira um comando...\" rows=\"5\" ng-disabled=\"true\"></textarea></md-input-container></div>\n</md-dialog-content><md-dialog-actions><md-button ng-if=\"vm.modoEdicao\" ng-click=\"vm.metodos.cancelar()\" \nclass=\"md-raised md-accent botao-cancelar\" ng-disabled=\"vm.favoritando\"><span>Cancelar</span></md-button><md-button \ntype=\"submit\" class=\"md-raised md-accent\" ng-disabled=\"favoritosForm.$invalid || vm.favoritando\"><span \nng-if=\"!vm.modoEdicao\">Criar</span> <span ng-if=\"vm.modoEdicao\">Salvar</span></md-button></md-dialog-actions></form>\n</md-dialog>");
$templateCache.put("app/main/financeiro/cadastro/faturamento/forma-faturamento/views/forma-faturamento-form.html","<div class=\"md-background-bg md-whiteframe-1dp\"><form name=\"vm.form\" novalidate><pg-toolbar \nentidades=\"vm.formasFaturamento\" entidade=\"vm.formaFaturamento\" entidade-de-envio=\"vm.entidadeDeEnvio\" \ncontrolador-toolbar=\"vm.controleForm\" acao-pesquisar=\"vm.metodos.pesquisar()\" \nacao-criar=\"vm.metodos.salvar(vm.formaFaturamento)\" acao-editar=\"vm.metodos.editar(vm.formaFaturamento)\" \nacao-excluir=\"vm.metodos.excluir(vm.formaFaturamento)\" construir-dt-options=\"vm.metodos.construirDtOptions()\" \nmetodos-externos=\"vm.metodosExternosPgToolbar\" campo-pesquisar=\"vm.pesquisar\"></pg-toolbar><md-content layout-padding \nng-hide=\"vm.controleForm.listarTodasEntidades\" ng-disabled=\"vm.controleForm.emProgresso\"><div class=\"form-container\">\n<div layout-gt-xs=\"row\"><div layout=\"row\"><md-input-container class=\"md-block\" flex-gt-sm><label \ntranslate=\"FORMA_FATURAMENTO.CODIGO\"></label><input type=\"text\" ng-model=\"vm.formaFaturamento.codigo\" name=\"codigo\" \nmascara-numero-generica=\"#####\" ng-required=\"vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.inserirAtivo\"><div \nng-messages=\"vm.form.colaborador.codigo.$error\"><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container><proximo-codigo \nng-show=\"vm.controleForm.inserirAtivo\" rota=\"vm.rota.proximoCodigo\" entidade-codigo=\"vm.formaFaturamento.codigo\" \npre-loader-toolbar=\"vm.controleForm.preLoaderToolbar\"></proximo-codigo></div><md-input-container class=\"md-block\" \nflex-offset-gt-sm=\"5\" flex><label translate=\"FORMA_FATURAMENTO.DESCRICAO\"></label><input type=\"text\" \nng-model=\"vm.formaFaturamento.descricao\" name=\"descricao\" mascara-tamanho-campo=\"100\" \nng-required=\"vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo\" md-maxlength=\"100\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\"><div \nng-messages=\"vm.form.descricao.$error\"><div ng-message=\"required\" translate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\">\n</div></div></md-input-container></div></div></md-content></form></div>");
$templateCache.put("app/main/financeiro/cadastro/faturamento/forma-faturamento/views/forma-faturamento.html","<div id=\"forma-faturamento\" class=\"page-layout simple tabbed\" layout=\"column\"><header-padrao \ntranslate-nome=\"FORMA_FATURAMENTO.FORMA_FATURAMENTO\" \nliberar-pesquisa-quando-datatable-ativo=\"vm.controleForm.listarTodasEntidades\" pesquisar=\"vm.pesquisar\">\n</header-padrao><div class=\"content\"><div ui-view=\"forma-faturamento-form\"></div></div><div \nui-view=\"formas-faturamentos-tabela\" ng-if=\"vm.controleForm.listarTodasEntidades\"></div></div>");
$templateCache.put("app/main/financeiro/cadastro/faturamento/forma-faturamento/views/formas-faturamentos-tabela.html","<div layout=\"column\" flex><div class=\"md-padding md-background-bg md-whiteframe-1dp fullpage-datatable\" \nlayout=\"column\" flex><table class=\"dataTable row-border hover\" id=\"datatable-forma-faturamento\" width=\"100%\"><thead>\n<tr><th>Ação</th><th>Código</th><th>Descrição</th></tr></thead></table></div></div>");
$templateCache.put("app/main/financeiro/cadastro/faturamento/forma-pagamento/views/forma-pagamento-form.html","<div class=\"md-background-bg md-whiteframe-1dp\"><form name=\"vm.form\" novalidate><pg-toolbar \nentidades=\"vm.formasPagamentos\" entidade=\"vm.formaPagamento\" entidade-de-envio=\"vm.entidadeDeEnvio\" \ncontrolador-toolbar=\"vm.controleForm\" acao-pesquisar=\"vm.metodos.pesquisar()\" \nacao-criar=\"vm.metodos.salvar(vm.formaPagamento)\" acao-editar=\"vm.metodos.editar(vm.formaPagamento)\" \nacao-excluir=\"vm.metodos.excluir(vm.formaPagamento)\" construir-dt-options=\"vm.metodos.construirDtOptions()\" \nmetodos-externos=\"vm.metodosExternosPgToolbar\" campo-pesquisar=\"vm.pesquisar\"></pg-toolbar><md-content layout-padding \nng-hide=\"vm.controleForm.listarTodasEntidades\" ng-disabled=\"vm.controleForm.emProgresso\"><div class=\"form-container\">\n<div layout-gt-xs=\"row\"><div layout=\"row\"><md-input-container class=\"md-block\" flex-gt-sm><label \ntranslate=\"FORMA_PAGAMENTO.CODIGO\"></label><input type=\"text\" ng-model=\"vm.formaPagamento.codigo\" name=\"codigo\" \nmascara-numero-generica=\"#####\" ng-required=\"vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.inserirAtivo\"><div \nng-messages=\"vm.form.colaborador.codigo.$error\"><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container><proximo-codigo \nng-show=\"vm.controleForm.inserirAtivo\" rota=\"vm.rota.proximoCodigo\" entidade-codigo=\"vm.formaPagamento.codigo\" \npre-loader-toolbar=\"vm.controleForm.preLoaderToolbar\"></proximo-codigo></div><md-input-container class=\"md-block\" \nflex-offset-gt-sm=\"5\" flex><label translate=\"FORMA_PAGAMENTO.DESCRICAO\"></label><input type=\"text\" \nng-model=\"vm.formaPagamento.descricao\" name=\"descricao\" mascara-tamanho-campo=\"100\" \nng-required=\"vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo\" md-maxlength=\"100\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\"><div \nng-messages=\"vm.form.descricao.$error\"><div ng-message=\"required\" translate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\">\n</div></div></md-input-container></div></div></md-content></form></div>");
$templateCache.put("app/main/financeiro/cadastro/faturamento/forma-pagamento/views/forma-pagamento.html","<div id=\"forma-pagamento\" class=\"page-layout simple tabbed\" layout=\"column\"><header-padrao \ntranslate-nome=\"FORMA_PAGAMENTO.FORMA_PAGAMENTO\" \nliberar-pesquisa-quando-datatable-ativo=\"vm.controleForm.listarTodasEntidades\" pesquisar=\"vm.pesquisar\">\n</header-padrao><div class=\"content\"><div ui-view=\"forma-pagamento-form\"></div></div><div \nui-view=\"formas-pagamentos-tabela\" ng-if=\"vm.controleForm.listarTodasEntidades\"></div></div>");
$templateCache.put("app/main/financeiro/cadastro/faturamento/forma-pagamento/views/formas-pagamentos-tabela.html","<div layout=\"column\" flex><div class=\"md-padding md-background-bg md-whiteframe-1dp fullpage-datatable\" \nlayout=\"column\" flex><table class=\"dataTable row-border hover\" id=\"datatable-forma-pagamento\" width=\"100%\"><thead><tr>\n<th>Ação</th><th>Código</th><th>Descrição</th></tr></thead></table></div></div>");
$templateCache.put("app/main/documentos-tecnicos/manuais-internos/Desenvolvimento/views/sidenav/sidenav-manual-desenvolvimento.html","<div class=\"demo-sidenav\"><md-list><md-subheader class=\"md-no-sticky\">{{vm.tituloSumario}}</md-subheader><md-list-item \nng-click=\"vm.metodos.goToAnchor(1)\"><p>Código Fonte</p></md-list-item><md-divider></md-divider><md-list-item \nng-click=\"vm.metodos.goToAnchor(2)\"><p>Banco de dados</p></md-list-item><md-divider></md-divider><md-list-item \nng-click=\"vm.metodos.goToAnchor(3)\"><p>Erros comuns</p></md-list-item><md-divider></md-divider><md-list-item \nng-click=\"vm.metodos.goToAnchor(4)\"><p>Materiais de estudos</p></md-list-item><md-divider></md-divider></md-list></div>");
$templateCache.put("app/main/financeiro/cadastro/faturamento/natureza/views/natureza-form.html","<div class=\"md-background-bg md-whitefram-1dp\"><form name=\"vm.form\" novalidate><pg-toolbar entidades=\"vm.naturezas\" \nentidade=\"vm.natureza\" entidade-de-envio=\"vm.entidadeDeEnvio\" controlador-toolbar=\"vm.controleForm\" \nacao-pesquisar=\"vm.metodos.pesquisar()\" acao-criar=\"vm.metodos.salvar(vm.natureza)\" \nacao-editar=\"vm.metodos.editar(vm.natureza)\" acao-excluir=\"vm.metodos.excluir(vm.natureza)\" \nconstruir-dt-options=\"vm.metodos.construirDtOptions()\" metodos-externos=\"vm.metodosExternosPgToolbar\" \ncampo-pesquisar=\"vm.pesquisar\" pre-definir-campos-para-insercao=\"vm.metodos.preDefinirParaInsercao()\" \nmetodo-externo-acao-reverter=\"vm.metodos.reverterCadastro()\"></pg-toolbar><md-content layout-padding \nng-hide=\"vm.controleForm.listarTodasEntidades\"><div class=\"form-container\"><div layout-gt-xs=\"column\"><div \nlayout=\"row\"><md-input-container class=\"md-block\" flex><label translate=\"NATUREZA.DESCRICAO\"></label><input \ntype=\"text\" ng-model=\"vm.natureza.descricao\" name=\"descricao\" mascara-tamanho-campo=\"50\" md-maxlength=\"50\" \nng-required=\"vm.controleForm.inserirAtivo || vm.controleForm.editarAtivo\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.inserirAtivo && !vm.controleForm.editarAtivo\"><div \nng-messages=\"vm.form.descricao.$error\"><div ng-message=\"required\" translate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\">\n</div></div></md-input-container><md-input-container class=\"md-block\" flex=\"20\"><label \ntranslate=\"NATUREZA.PERCENTUAL_DESCONTO\"></label><input type=\"text\" name=\"percentualImpostoDescontar\" \nmascara-tamanho-campo=\"6\" ui-percentage-mask ng-model=\"vm.natureza.percentualImpostoDescontar\" \nng-required=\"vm.controleForm.inserirAtivo || vm.controleForm.editarAtivo\" \nng-change=\"vm.metodos.onChangePercentualDescontar(vm.natureza.percentualImpostoDescontar)\" \nng-disabled=\"!vm.controleForm.inserirAtivo && !vm.controleForm.editarAtivo\"><div \nng-messages=\"vm.form.percentualImpostoDescontar.$error\"><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div><div ng-message=\"validaMaiorQueZero\"><span>\nO valor informado deve ser maior que zero.</span></div></div></md-input-container><md-input-container class=\"md-block\">\n<md-switch aria-label=\"Ativo\" class=\"mt-5\" ng-model=\"vm.natureza.ativo\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.inserirAtivo && !vm.controleForm.editarAtivo\">Ativo\n</md-switch></md-input-container></div></div></div></md-content></form></div>");
$templateCache.put("app/main/financeiro/cadastro/faturamento/natureza/views/natureza-tabela.html","<div layout=\"column\" flex><div class=\"md-padding md-background-bg md-whiteframe-1dp fullpage-datatable\" \nlayout=\"column\" flex><table id=\"datatable-natureza\" class=\"dataTable row-border hover\" width=\"100%\"><thead><tr><th>Ação\n</th><th>Descrição</th><th>Impostos a descontar</th><th>Ativo</th></tr></thead></table></div></div>");
$templateCache.put("app/main/financeiro/cadastro/faturamento/natureza/views/natureza.html","<div id=\"natureza\" class=\"page-layout simple tabbed\" layout=\"column\"><header-padrao translate-nome=\"NATUREZA.NATUREZA\">\n</header-padrao><div class=\"content\"><div ui-view=\"natureza-form\"></div></div><div class=\"content\"><div \nui-view=\"naturezas-tabela\" ng-if=\"vm.controleForm.listarTodasEntidades\"></div></div></div>");
$templateCache.put("app/main/financeiro/cadastro/contrato/indice-reajuste/views/indice-reajuste-form.html","<div class=\"md-background-bg md-whiteframe-1dp\"><form name=\"vm.form\" novalidate><pg-toolbar \nentidades=\"vm.indicesReajuste\" entidade=\"vm.indiceReajuste\" entidade-de-envio=\"vm.entidadeDeEnvio\" \ncontrolador-toolbar=\"vm.controleForm\" acao-pesquisar=\"vm.metodos.pesquisar()\" \nacao-criar=\"vm.metodos.salvar(vm.indiceReajuste)\" acao-editar=\"vm.metodos.editar(vm.indiceReajuste)\" \nacao-excluir=\"vm.metodos.excluir(vm.indiceReajuste)\" construir-dt-options=\"vm.metodos.construirDtOptions()\" \nmetodos-externos=\"vm.metodosExternosPgToolbar\" campo-pesquisar=\"vm.pesquisar\"></pg-toolbar><md-content layout-padding \nng-hide=\"vm.controleForm.listarTodasEntidades\" ng-disabled=\"vm.controleForm.emProgresso\"><div class=\"form-container\">\n<div layout-gt-xs=\"row\"><md-input-container class=\"md-block\" flex><label translate=\"INDICE_REAJUSTE.DESCRICAO\"></label>\n<input type=\"text\" ng-model=\"vm.indiceReajuste.descricao\" name=\"descricao\" mascara-tamanho-campo=\"100\" \nng-required=\"vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo\" md-maxlength=\"100\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\"><div \nng-messages=\"vm.form.descricao.$error\"><div ng-message=\"required\" translate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\">\n</div></div></md-input-container></div></div></md-content></form></div>");
$templateCache.put("app/main/financeiro/cadastro/contrato/indice-reajuste/views/indice-reajuste.html","<div id=\"indice-reajuste\" class=\"page-layout simple tabbed\" layout=\"column\"><header-padrao \ntranslate-nome=\"INDICE_REAJUSTE.INDICE_REAJUSTE\" \nliberar-pesquisa-quando-datatable-ativo=\"vm.controleForm.listarTodasEntidades\" pesquisar=\"vm.pesquisar\">\n</header-padrao><div class=\"content\"><div ui-view=\"indice-reajuste-form\"></div></div><div \nui-view=\"indices-reajuste-tabela\" ng-if=\"vm.controleForm.listarTodasEntidades\"></div></div>");
$templateCache.put("app/main/financeiro/cadastro/contrato/indice-reajuste/views/indices-reajuste-tabela.html","<div layout=\"column\" flex><div class=\"md-padding md-background-bg md-whiteframe-1dp fullpage-datatable\" \nlayout=\"column\" flex><table class=\"dataTable row-border hover\" id=\"datatable-indice-reajuste\" width=\"100%\"><thead><tr>\n<th>Ação</th><th>Descrição</th></tr></thead></table></div></div>");
$templateCache.put("app/main/financeiro/cadastro/contrato/motivo-aditivo/views/motivo-aditivo-form.html","<div class=\"md-background-bg md-whiteframe-1dp\"><form name=\"vm.form\" novalidate><pg-toolbar \nentidade=\"vm.motivoAditivo\" entidades=\"vm.motivoAditivos\" entidade-de-envio=\"vm.entidadeDeEnvio\" \ncontrolador-toolbar=\"vm.controleForm\" acao-pesquisar=\"vm.metodos.pesquisar()\" \nacao-criar=\"vm.metodos.salvar(vm.motivoAditivo)\" acao-editar=\"vm.metodos.editar(vm.motivoAditivo)\" \nacao-excluir=\"vm.metodos.excluir(vm.motivoAditivo)\" construir-dt-options=\"vm.metodos.construirDtOptions()\" \nmetodos-externos=\"vm.metodosExternosPgToolbar\" campo-pesquisar=\"vm.pesquisar\" \npre-definir-campos-para-insercao=\"vm.metodos.preDefinirCamposParaInserir()\"></pg-toolbar><md-content layout-padding \nng-hide=\"vm.controleForm.listarTodasEntidades\" ng-disabled=\"vm.controleForm.emProgresso\"><div class=\"form-container\">\n<div layout-gt-xs=\"row\"><md-input-container class=\"md-block\" flex=\"80\"><label translate=\"MOTIVO_ADITIVO.DESCRICAO\">\n</label><input type=\"text\" ng-model=\"vm.motivoAditivo.descricao\" name=\"descricao\" mascara-tamanho-campo=\"100\" \nng-required=\"vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo\" md-maxlength=\"100\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\"><div \nng-messages=\"vm.form.descricao.$error\"><div ng-message=\"required\" translate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\">\n</div></div></md-input-container><md-input-container class=\"md-block\" flex-offset=\"3\"><md-checkbox \nng-model=\"vm.motivoAditivo.permitirReajuste\" aria-label=\"Permitir reajsute\" name=\"permitirReajsute\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\"><span \nclass=\"float-label-cor-default\" translate=\"MOTIVO_ADITIVO.PERMITIR_REAJUSTE\"></span></md-checkbox></md-input-container>\n</div></div></md-content></form></div>");
$templateCache.put("app/main/financeiro/cadastro/contrato/motivo-aditivo/views/motivo-aditivo.html","<div id=\"motivo-aditivo\" class=\"page-layout simple tabbed\" layout=\"column\"><header-padrao \ntranslate-nome=\"MOTIVO_ADITIVO.MOTIVO_ADITIVO\" \nliberar-pesquisa-quando-datatable-ativo=\"vm.controleForm.listarTodasEntidades\" pesquisar=\"vm.pesquisar\">\n</header-padrao><div class=\"content\"><div ui-view=\"motivo-aditivo-form\"></div></div><div \nui-view=\"motivos-aditivo-tabela\" ng-if=\"vm.controleForm.listarTodasEntidades\"></div></div>");
$templateCache.put("app/main/financeiro/cadastro/contrato/motivo-aditivo/views/motivos-aditivo-tabela.html","<div layout=\"column\" flex><div class=\"md-padding md-background-bg md-whiteframe-1dp fullpage-datatable\" \nlayout=\"column\" flex><table id=\"datatable-motivo-aditivo\" class=\"dataTable row-border hover\" width=\"100%\"><thead><tr>\n<th>Ação</th><th>Código</th><th>Descrição</th><th>Permitir Reajuste</th></tr></thead></table></div></div>");
$templateCache.put("app/main/financeiro/cadastro/contrato/motivo-risco-contratual/views/motivo-risco-contratual-form.html","<div class=\"md-background-bg md-whiteframe-1dp\"><form name=\"vm.form\" novalidate><pg-toolbar \nentidades=\"vm.motivosRiscoContratual\" entidade=\"vm.motivoRiscoContratual\" entidade-de-envio=\"vm.entidadeDeEnvio\" \ncontrolador-toolbar=\"vm.controleForm\" acao-pesquisar=\"vm.metodos.pesquisar()\" \nacao-criar=\"vm.metodos.salvar(vm.motivoRiscoContratual)\" acao-editar=\"vm.metodos.editar(vm.motivoRiscoContratual)\" \nacao-excluir=\"vm.metodos.excluir(vm.motivoRiscoContratual)\" construir-dt-options=\"vm.metodos.construirDtOptions()\" \nmetodos-externos=\"vm.metodosExternosPgToolbar\" campo-pesquisar=\"vm.pesquisar\"></pg-toolbar><md-content layout-padding \nng-hide=\"vm.controleForm.listarTodasEntidades\" ng-disabled=\"vm.controleForm.emProgresso\"><div class=\"form-container\">\n<div layout-gt-xs=\"row\"><md-input-container class=\"md-block\" flex=\"15\" \nng-hide=\"vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo\"><label>Código</label><input type=\"text\" \nname=\"codigo\" ng-model=\"vm.motivoRiscoContratual.codigo\" ng-disabled=\"vm.controleForm.pesquisaAtiva\"><div \nng-messages=\"vm.form.codigo.$error\"><div ng-message=\"required\" translate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div>\n</div></md-input-container><md-input-container class=\"md-block\" flex><label>Descrição</label><input type=\"text\" \nname=\"descricao\" mascara-tamanho-campo=\"60\" md-maxlength=\"60\" \nng-minlength=\"{{ vm.controleForm.inserirAtivo ? 20 : 0 }}\" ng-model=\"vm.motivoRiscoContratual.descricao\" \nng-required=\"vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\"><div \nng-messages=\"vm.form.descricao.$error\"><div ng-message=\"required\" translate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\">\n</div><div ng-message=\"minlength\">O campo deve conter no mínimo 20 caracteres</div><div ng-message=\"maxlength\">\nO campo não pode conter mais do que 60 caracteres</div></div></md-input-container></div></div></md-content></form>\n</div>");
$templateCache.put("app/main/financeiro/cadastro/contrato/motivo-risco-contratual/views/motivo-risco-contratual-tabela.html","<div layout=\"column\" flex><div class=\"md-padding md-background-bg md-whiteframe-1dp fullpage-datatable\" \nlayout=\"column\" flex><table id=\"datatable-motivo-risco-contratual\" class=\"dataTable row-border hover\" width=\"100%\">\n<thead><tr><th>Ação</th><th>Código</th><th>Descrição</th></tr></thead></table></div></div>");
$templateCache.put("app/main/financeiro/cadastro/contrato/motivo-risco-contratual/views/motivo-risco-contratual.html","<div id=\"motivo-risco-contratual\" class=\"page-layout simple tabbed\" layout=\"column\"><header-padrao \ntranslate-nome=\"Motivo de risco contratual\" icone=\"icon-rename-box\" \nliberar-pesquisa-quando-datatable-ativo=\"vm.controleForm.listarTodasEntidades\" pesquisar=\"vm.pesquisar\">\n</header-padrao><div class=\"content\"><div ui-view=\"motivo-risco-contratual-form\"></div></div><div \nui-view=\"motivo-risco-contratual-tabela\" ng-if=\"vm.controleForm.listarTodasEntidades\"></div></div>");
$templateCache.put("app/main/financeiro/cadastro/contrato/status-contrato/views/status-contrato-form.html","<div class=\"md-background-bg md-whiteframe-1dp\"><form name=\"vm.form\" novalidate><pg-toolbar \nentidades=\"vm.statusContratos\" entidade=\"vm.statusContrato\" entidade-de-envio=\"vm.entidadeDeEnvio\" \ncontrolador-toolbar=\"vm.controleForm\" acao-pesquisar=\"vm.metodos.pesquisar()\" \nacao-criar=\"vm.metodos.salvar(vm.statusContrato)\" acao-editar=\"vm.metodos.editar(vm.statusContrato)\" \nacao-excluir=\"vm.metodos.excluir(vm.statusContrato)\" construir-dt-options=\"vm.metodos.construirDtOptions()\" \nmetodos-externos=\"vm.metodosExternosPgToolbar\" campo-pesquisar=\"vm.pesquisar\"></pg-toolbar><md-content layout-padding \nng-hide=\"vm.controleForm.listarTodasEntidades\" ng-disabled=\"vm.controleForm.emProgresso\"><div class=\"form-container\">\n<div layout-gt-xs=\"row\"><md-input-container class=\"md-block\" flex><label translate=\"STATUS_CONTRATO.DESCRICAO\"></label>\n<input type=\"text\" ng-model=\"vm.statusContrato.descricao\" name=\"descricao\" mascara-tamanho-campo=\"100\" \nng-required=\"vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo\" md-maxlength=\"100\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\"><div \nng-messages=\"vm.form.descricao.$error\"><div ng-message=\"required\" translate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\">\n</div></div></md-input-container></div></div></md-content></form></div>");
$templateCache.put("app/main/financeiro/cadastro/contrato/status-contrato/views/status-contrato.html","<div id=\"motivo-aditivo\" class=\"page-layout simple tabbed\" layout=\"column\"><header-padrao \ntranslate-nome=\"STATUS_CONTRATO.STATUS_CONTRATO\" \nliberar-pesquisa-quando-datatable-ativo=\"vm.controleForm.listarTodasEntidades\" pesquisar=\"vm.pesquisar\">\n</header-padrao><div class=\"content\"><div ui-view=\"status-contrato-form\"></div></div><div \nui-view=\"status-contratos-tabela\" ng-if=\"vm.controleForm.listarTodasEntidades\"></div></div>");
$templateCache.put("app/main/financeiro/cadastro/contrato/status-contrato/views/status-contratos-tabela.html","<div layout=\"column\" flex><div class=\"md-padding md-background-bg md-whiteframe-1dp fullpage-datatable\" \nlayout=\"column\" flex><table class=\"dataTable row-border hover\" id=\"datatable-status-contrato\" width=\"100%\"><thead><tr>\n<th>Ação</th><th>Descrição</th></tr></thead></table></div></div>");
$templateCache.put("app/main/financeiro/cadastro/contrato/tipo-contrato/views/tipo-contrato-form.html","<div class=\"md-background-bg md-whiteframe-1dp\"><form name=\"vm.form\" novalidate><pg-toolbar \nentidades=\"vm.tipoContratos\" entidade=\"vm.tipoContrato\" entidade-de-envio=\"vm.entidadeDeEnvio\" \ncontrolador-toolbar=\"vm.controleForm\" acao-pesquisar=\"vm.metodos.pesquisar()\" \nacao-criar=\"vm.metodos.salvar(vm.tipoContrato)\" acao-editar=\"vm.metodos.editar(vm.tipoContrato)\" \nacao-excluir=\"vm.metodos.excluir(vm.tipoContrato)\" construir-dt-options=\"vm.metodos.construirDtOptions()\" \nmetodos-externos=\"vm.metodosExternosPgToolbar\" campo-pesquisar=\"vm.pesquisar\"></pg-toolbar><md-content layout-padding \nng-hide=\"vm.controleForm.listarTodasEntidades\" ng-disabled=\"vm.controleForm.emProgresso\"><div class=\"form-container\">\n<div layout-gt-xs=\"row\"><md-input-container class=\"md-block\" flex><label translate=\"TIPO_CONTRATO.DESCRICAO\"></label>\n<input type=\"text\" name=\"descricao\" mascara-tamanho-campo=\"100\" md-maxlength=\"100\" \nng-model=\"vm.tipoContrato.descricao\" ng-required=\"vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\"><div \nng-messages=\"vm.form.descricao.$error\"><div ng-message=\"required\" translate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\">\n</div></div></md-input-container></div></div></md-content></form></div>");
$templateCache.put("app/main/financeiro/cadastro/contrato/tipo-contrato/views/tipo-contrato.html","<div id=\"tipo-contrato\" class=\"page-layout simple tabbed\" layout=\"column\"><header-padrao \ntranslate-nome=\"TIPO_CONTRATO.TIPO_CONTRATO\" \nliberar-pesquisa-quando-datatable-ativo=\"vm.controleForm.listarTodasEntidades\" pesquisar=\"vm.pesquisar\">\n</header-padrao><div class=\"content\"><div ui-view=\"tipo-contrato-form\"></div></div><div \nui-view=\"tipo-contratos-tabela\" ng-if=\"vm.controleForm.listarTodasEntidades\"></div></div>");
$templateCache.put("app/main/financeiro/cadastro/contrato/tipo-contrato/views/tipo-contratos-tabela.html","<div layout=\"column\" flex><div class=\"md-padding md-background-bg md-whiteframe-1dp fullpage-datatable\" \nlayout=\"column\" flex><table id=\"datatable-tipo-contrato\" class=\"dataTable row-border hover\" width=\"100%\"><thead><tr>\n<th>Ação</th><th>Descrição</th></tr></thead></table></div></div>");
$templateCache.put("app/main/financeiro/relatorio/risco-rescisao-contratual/components/card-filtro-utilizado/card-filtro-utilizado.html","<md-card id=\"card-filtro-utilizado\" class=\"container-filtro-utilizado\" style=\"margin: 0px; margin-bottom: 15px\">\n<md-card-header><md-card-header-text><span>Filtro utilizado</span></md-card-header-text></md-card-header>\n<md-card-content><div class=\"filtro-info\"><div ng-if=\"vm.filtroUtilizado.estados.length <= 3\"><div layout=\"row\"><div \nclass=\"filtro-item\" flex=\"50\"><span class=\"filtro-label\">Período:</span><div class=\"container-data-carga\"><span \nclass=\"filtro-label\" style=\"margin-top: -3px\">De</span> <span class=\"filtro-valor\">\n{{vm.filtroUtilizado.dataInicioRescisaoContratual | date:\'dd/MM/yyyy\'}}</span> <span class=\"filtro-label\" \nstyle=\"margin-top: -3px\">Até</span> <span class=\"filtro-valor\">\n{{vm.filtroUtilizado.dataFimRescisaoContratual | date:\'dd/MM/yyyy\'}}</span></div></div><div class=\"filtro-item\" \nflex=\"50\"><span class=\"filtro-label\">Estados:</span><div class=\"tags-container\"><span class=\"filtro-valor\" \nng-if=\"!vm.filtroUtilizado.estados.length\">Todos</span> <span class=\"filtro-valor\" \nng-repeat=\"estado in vm.filtroUtilizado.estados\">{{ estado }}</span></div></div></div></div><div \nng-if=\"vm.filtroUtilizado.estados.length > 3\"><div layout=\"row\"><div class=\"filtro-item\" flex=\"100\"><span \nclass=\"filtro-label\">Período:</span><div class=\"container-data-carga\"><span class=\"filtro-label\" \nstyle=\"margin-top: -3px\">De</span> <span class=\"filtro-valor\">\n{{vm.filtroUtilizado.dataInicioRescisaoContratual | date:\'dd/MM/yyyy\'}}</span> <span class=\"filtro-label\" \nstyle=\"margin-top: -3px\">Até</span> <span class=\"filtro-valor\">\n{{vm.filtroUtilizado.dataFimRescisaoContratual | date:\'dd/MM/yyyy\'}}</span></div></div></div><div layout=\"row\"><div \nclass=\"filtro-item\" flex=\"100\"><span class=\"filtro-label\">Estados:</span><div class=\"tags-container\"><span \nclass=\"filtro-valor\" ng-repeat=\"estado in vm.filtroUtilizado.estados\">{{ estado }}</span></div></div></div></div><div \nng-if=\"vm.filtroUtilizado.itensContratuais.length <= 5\"><div layout=\"row\"><div class=\"filtro-item\" flex=\"50\"><span \nclass=\"filtro-label\">Itens:</span><div class=\"tags-container\"><span class=\"filtro-valor\" \nng-if=\"!vm.filtroUtilizado.itensContratuais.length\">Todos</span> <span class=\"filtro-valor\" \nng-repeat=\"itemId in vm.filtroUtilizado.itensContratuais\">{{ vm.metodos.formatarItem(itemId) }}</span></div></div><div \nclass=\"filtro-item\" flex=\"50\"><span class=\"filtro-label\">Motivos:</span><div class=\"tags-container\"><span \nclass=\"filtro-valor\" ng-if=\"!vm.filtroUtilizado.motivos.length\">Todos</span> <span class=\"filtro-valor\" \nng-repeat=\"motivoId in vm.filtroUtilizado.motivos\">{{ vm.metodos.formatarMotivo(motivoId) }}<md-tooltip \nmd-direction=\"top\" ng-if=\"vm.metodos.obterDescricaoCompletaMotivo(motivoId).length > 20\">\n{{ vm.metodos.obterDescricaoCompletaMotivo(motivoId) }}</md-tooltip></span></div></div></div></div><div \nng-if=\"vm.filtroUtilizado.itensContratuais.length > 5\"><div layout=\"row\"><div class=\"filtro-item\" flex=\"100\"><span \nclass=\"filtro-label\">Itens:</span><div class=\"tags-container\"><span class=\"filtro-valor\" \nng-repeat=\"itemId in vm.filtroUtilizado.itensContratuais\">{{ vm.metodos.formatarItem(itemId) }}</span></div></div>\n</div><div layout=\"row\"><div class=\"filtro-item\" flex=\"100\"><span class=\"filtro-label\">Motivos:</span><div \nclass=\"tags-container\"><span class=\"filtro-valor\" ng-if=\"!vm.filtroUtilizado.motivos.length\">Todos</span> <span \nclass=\"filtro-valor\" ng-repeat=\"motivoId in vm.filtroUtilizado.motivos\">{{ vm.metodos.formatarMotivo(motivoId) }}\n<md-tooltip md-direction=\"top\" ng-if=\"vm.metodos.obterDescricaoCompletaMotivo(motivoId).length > 20\">\n{{ vm.metodos.obterDescricaoCompletaMotivo(motivoId) }}</md-tooltip></span></div></div></div></div></div>\n</md-card-content></md-card>");
$templateCache.put("app/main/financeiro/relatorio/risco-rescisao-contratual/components/tabela/tabela-risco-rescisao-contratual.html","<div ng-if=\"vm.filtroUtilizado\" ui-view=\"card-filtro-utilizado\"></div><div id=\"no-results\" class=\"text-center\" \nng-if=\"vm.resultadosVisiveis === 0\"><div class=\"message\"><md-icon class=\"message-icon s90\" \nmd-font-icon=\"icon-information-outline\"></md-icon><div class=\"titulo-text\">Não existem dados para a consulta realizada\n</div></div></div><div id=\"botoes-acoes-relatorio-rescisao-contratual\"><div layout=\"column\" style=\"position:relative\">\n<md-button class=\"md-fab md-raised md-mini md-accent\" ng-click=\"vm.metodos.voltar()\" ng-disabled=\"vm.gerandoRelatorio\">\n<md-icon md-font-icon=\"icon-replay s24\"></md-icon><md-tooltip md-autohide>Voltar</md-tooltip></md-button></div><div \nlayout=\"column\" style=\"position:relative\"><md-button class=\"md-fab md-raised md-mini md-accent\" \nng-click=\"vm.metodos.gerarRelatorio()\" ng-disabled=\"vm.gerandoRelatorio\"><md-icon ng-if=\"!vm.gerandoRelatorio\" \nmd-svg-src=\"assets/icons/invm/download.svg\"></md-icon><div ng-if=\"vm.gerandoRelatorio\"><md-progress-circular \nstyle=\"margin-left: 2px\" class=\"md-accent\" md-diameter=\"24\" md-mode=\"indeterminate\"></md-progress-circular></div>\n<md-tooltip md-autohide>Gerar relatório</md-tooltip></md-button></div></div><div \nng-if=\"vm.dadosTabela.dadosClientes.length > 0\" id=\"tabela-risco-rescisao-contratual\" \nclass=\"fullpage-datatable scrollable\" ms-scroll style=\"width: 100%; border-top: none; border-bottom:none\" \nng-show=\"vm.resultadosVisiveis > 0\"><table class=\"dataTable row-border hover tabela-dados-cliente\" datatable=\"ng\" \ndt-options=\"vm.dtOptions\" dt-column-defs=\"vm.dtColumnDefs\" dt-instance=\"vm.onDtInstance\" width=\"100%\"><thead><tr><th \nclass=\"secondary-text border-left codigo\"><div class=\"table-header\"><span class=\"column-title\">Código</span></div></th>\n<th class=\"secondary-text border-left nome\"><div class=\"table-header\"><span class=\"column-title\">Nome</span></div></th>\n<th class=\"secondary-text border-left cidade\"><div class=\"table-header\"><span class=\"column-title span-acao ml-10\">\nCidade</span></div></th><th class=\"secondary-text border-left item\"><div class=\"table-header\"><span \nclass=\"column-title\">Item</span></div></th><th class=\"secondary-text border-left valor\"><div class=\"table-header\"><span\n class=\"column-title\">Valor do item</span></div></th><th class=\"secondary-text border-left data\"><div \nclass=\"table-header\"><span class=\"column-title\">Data</span></div></th><th \nclass=\"secondary-text border-left ultima-coluna motivo\"><div class=\"table-header\"><span class=\"column-title\">Motivo\n</span></div></th></tr></thead><tbody><tr ng-repeat=\"dados in vm.dadosTabela.dadosClientes\"><td \nclass=\"border-left codigo\">{{dados.codigo}}</td><td class=\"border-left nome\">{{dados.nome}}</td><td \nclass=\"border-left cidade\"><span>{{dados.cidade}}</span></td><td class=\"border-left item\"><span>{{dados.item}}</span>\n</td><td class=\"border-left valor\" data-order=\"{{dados.valorItem}}\"><span>{{dados.valorItem | currency:\'R$\'}}</span>\n</td><td class=\"border-left data\"><span>{{dados.dataRiscoRescisao | date:\'dd/MM/yyyy\'}}</span></td><td \nclass=\"border-right border-left motivo\"><span>{{dados.motivo}}</span></td></tr></tbody></table></div><div \nid=\"totalizadores-tabela-risco\"><strong class=\"titulo\">Totalizadores:</strong><div class=\"total-clientes\"><strong>\nTotal de clientes:</strong> <span>{{vm.totalClientesVisiveis}}</span></div><div class=\"total-valor\"><strong>\nValor total:</strong> <span>{{vm.valorTotalClientesVisiveis | currency:\'R$\'}}</span></div></div>");
$templateCache.put("app/main/financeiro/relatorio/risco-rescisao-contratual/components/filtro/filtro-risco-rescisao-contratual.html","<div id=\"filtro-relatorio-risco-rescisao-contratual\" \nng-controller=\"FiltroRelatorioRiscoRescisaoContratualController as vm\"><form name=\"vm.form\"><div \nclass=\"container-filtros\"><div class=\"fieldset-campos\"><fieldset class=\"standard\"><legend class=\"grp-legend\">Período\n</legend><div class=\"datas\"><md-input-container md-block style=\"margin-left: -30px\"><label>Data inicial</label>\n<md-datepicker name=\"dataInicioRescisaoContratual\" mascara-conversor-string-para-data \nmd-max-date=\"vm.entidade.dataFimRescisaoContratual\" ng-model=\"vm.entidade.dataInicioRescisaoContratual\" \nng-mask=\"3?9/1?9/9999\" ng-required=\"true\" ng-disabled=\"vm.emProgresso\"></md-datepicker><div \nstyle=\"margin-bottom: -5px\" ng-messages=\"vm.form.dataInicioRescisaoContratual.$error\"><div style=\"margin-left: 55px\" \nng-message=\"valid\" translate=\"MENSAGEM_VALIDACAO.DATA_INVALIDA\"></div><div style=\"margin-left: 55px\" \nng-message=\"required\" translate=\"MENSAGEM_VALIDACAO.DATA_OBRIGATORIA\"></div><div style=\"margin-left: 55px\" \nng-message=\"maxdate\" translate=\"MENSAGEM_VALIDACAO.CAMPO_DATA_INICIAL\"></div></div></md-input-container>\n<md-input-container><label>Data final</label><md-datepicker name=\"dataFimRescisaoContratual\" \nmascara-conversor-string-para-data md-min-date=\"vm.entidade.dataInicioRescisaoContratual\" \nng-model=\"vm.entidade.dataFimRescisaoContratual\" ng-mask=\"3?9/1?9/9999\" ng-required=\"true\" \nng-disabled=\"vm.emProgresso\"></md-datepicker><div style=\"margin-bottom: -5px\" \nng-messages=\"vm.form.dataFimRescisaoContratual.$error\"><div style=\"margin-left: 55px\" ng-message=\"valid\" \ntranslate=\"MENSAGEM_VALIDACAO.DATA_INVALIDA\"></div><div style=\"margin-left: 55px; max-width: 160px\" \nng-message=\"mindate\" translate=\"MENSAGEM_VALIDACAO.CAMPO_DATA_FINAL\"></div><div style=\"margin-left: 55px\" \nng-message=\"required\" translate=\"MENSAGEM_VALIDACAO.DATA_OBRIGATORIA\"></div></div></md-input-container></div>\n</fieldset><fieldset class=\"standard\"><legend class=\"grp-legend\">Estados</legend><div class=\"field-estado\">\n<md-input-container style=\"max-width: 21vw\"><label>Estados</label><md-select ng-required=\"!vm.habilitarTodosEstados\" \nng-model=\"vm.entidade.estados\" name=\"selectEstados\" md-on-open=\"vm.metodos.configurarSelectEstados()\" \nng-model-options=\"{trackBy: \'$value\'}\" ng-disabled=\"vm.habilitarTodosEstados\" multiple=\"multiple\"><md-select-header \nid=\"select-estado\"><input ng-model=\"vm.termoProcuradoEstados\" type=\"search\" placeholder=\"Pesquisar...\" class=\"md-text\">\n</md-select-header><md-option ng-value=\"estado\" ng-disabled=\"vm.habilitarTodosEstados\" \nng-repeat=\"estado in vm.estados | filter:vm.termoProcuradoEstados track by estado\">{{estado}}</md-option></md-select>\n<div ng-messages=\"vm.form.selectEstados.$error\"><div ng-message=\"required\">Campo obrigatório</div></div>\n</md-input-container><md-input-container><md-checkbox ng-model=\"vm.habilitarTodosEstados\" \nng-change=\"vm.metodos.ngChangeHabilitarTodosEstados()\" aria-label=\"Todos\" name=\"todosEstados\"><span \nclass=\"float-label-cor-default\" translate=\"RELATORIO_CLIENTE.TODOS\"></span></md-checkbox></md-input-container></div>\n</fieldset></div><div class=\"fieldset-campos\"><fieldset class=\"standard\"><legend class=\"grp-legend\">Itens</legend><div \nclass=\"field-item\" style=\"margin-top: -10px; margin-bottom: 10px\"><md-input-container style=\"max-width: 21vw\"><label>\nItens</label><md-select ng-required=\"!vm.habilitarTodosProdutos\" ng-model=\"vm.entidade.itensContratuais\" \nname=\"selectProdutos\" md-on-open=\"vm.metodos.configurarSelectProdutos()\" ng-disabled=\"vm.habilitarTodosProdutos\" \nmultiple=\"multiple\"><md-select-header id=\"select-produto\"><input ng-model=\"vm.termoProcuradoProdutos\" type=\"search\" \nplaceholder=\"Pesquisar...\" class=\"md-text\"></md-select-header><md-option ng-value=\"produto.codigo\" \nng-disabled=\"vm.habilitarTodosProdutos\" \nng-repeat=\"produto in vm.produtos | filter:vm.termoProcuradoProdutos track by produto.codigo\">{{produto.descricao}}\n</md-option></md-select><div ng-messages=\"vm.form.selectProdutos.$error\"><div ng-message=\"required\">Campo obrigatório\n</div></div></md-input-container><md-input-container><md-checkbox ng-model=\"vm.habilitarTodosProdutos\" \nng-change=\"vm.metodos.ngChangeHabilitarTodosProdutos()\" aria-label=\"Todos\" name=\"todosProdutos\"><span \nclass=\"float-label-cor-default\" translate=\"RELATORIO_CLIENTE.TODOS\"></span></md-checkbox></md-input-container></div>\n</fieldset><fieldset class=\"standard\"><legend class=\"grp-legend\">Motivos</legend><div class=\"field-motivo\" \nstyle=\"margin-top: -10px; margin-bottom: 10px\"><md-input-container style=\"max-width: 21vw\"><label>Motivos</label>\n<md-select ng-required=\"!vm.habilitarTodosMotivos\" ng-model=\"vm.entidade.motivos\" name=\"selectMotivos\" \nmd-on-open=\"vm.metodos.configurarSelectMotivos()\" ng-disabled=\"vm.habilitarTodosMotivos\" multiple=\"multiple\">\n<md-select-header id=\"select-motivo\"><input ng-model=\"vm.termoProcuradoMotivos\" type=\"search\" \nplaceholder=\"Pesquisar motivos cadastrados...\" class=\"md-text\"></md-select-header><md-option ng-value=\"motivo.codigo\" \nng-disabled=\"vm.habilitarTodosMotivos\" \nng-repeat=\"motivo in vm.motivosRiscosContratuais | filter:vm.termoProcuradoMotivos track by motivo.codigo\">\n{{motivo.descricao}}</md-option></md-select><div ng-if=\"vm.motivosRiscosContratuais.length > 0\" \nng-messages=\"vm.form.selectMotivos.$error\"><div ng-message=\"required\">Campo obrigatório</div></div><div \nng-if=\"vm.motivosRiscosContratuais.length === 0\" style=\"color: #d32f2f; font-size: 12px; margin-top: 5px\">\nNenhum motivo de risco de rescisão cadastrado</div></md-input-container><md-input-container \nng-class=\"{\'container-todos-motivos\': vm.motivosRiscosContratuais.length === 0}\"><md-checkbox \nng-model=\"vm.habilitarTodosMotivos\" ng-disabled=\"vm.motivosRiscosContratuais.length === 0\" \nng-change=\"vm.metodos.ngChangeHabilitarTodosMotivos()\" aria-label=\"Todos\" name=\"todosMotivos\"><span \nclass=\"float-label-cor-default\" translate=\"RELATORIO_CLIENTE.TODOS\"></span></md-checkbox></md-input-container></div>\n</fieldset></div><div class=\"botao-gerar-relatorio\"><md-button class=\"md-raised md-accent\" \naria-label=\"Gerar relatório\" ng-click=\"vm.metodos.montarDados(vm.entidade)\" \nng-disabled=\"vm.form.$invalid || vm.emProgresso\" style=\"position: relative\"><md-progress-circular \nng-show=\"vm.emProgresso\" md-mode=\"indeterminate\" md-diameter=\"30\" class=\"md-accent\" \nstyle=\"position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%)\"></md-progress-circular><span \nng-show=\"!vm.emProgresso\">GERAR RELATÓRIO</span></md-button></div></div></form></div>");
$templateCache.put("app/main/geral/cadastro/cliente/cliente/views/cliente-form.html","<div class=\"md-background-bg md-whiteframe-1dp\"><form name=\"vm.form\" novalidate><pg-toolbar entidades=\"vm.clientes\" \nentidade=\"vm.cliente\" entidade-de-envio=\"vm.entidadeDeEnvio\" controlador-toolbar=\"vm.controleForm\" \ncontrolador-pre-loader=\"vm.controlePreloader\" acao-pesquisar=\"vm.metodosCliente.pesquisar()\" \nacao-criar=\"vm.metodosCliente.salvar(vm.cliente)\" acao-editar=\"vm.metodosCliente.editar(vm.cliente)\" \nacao-excluir=\"vm.metodosCliente.excluir(vm.cliente)\" metodos-externos=\"vm.metodosPgToolbar\" \nmetodo-externo-acao-navegacao=\"vm.metodosGeral.preDefinirValoresQuandoNavegado()\" \nmetodo-externo-acao-nova-pesquisa=\"vm.metodosGeral.novaPesquisa()\" \nmetodo-externo-atualizar-entidade-externamente=\"vm.metodosCliente.pesquisar()\" \npre-definir-campos-para-insercao=\"vm.metodosGeral.preDefinirCamposParaInserir()\" \niniciar-chamando-pesquisa=\"vm.iniciarChamandoPesquisa\" construir-dt-options=\"vm.metodosCliente.construirDtOptions()\" \nmetodos-externos=\"vm.metodosExternosPgToolbar\" campo-pesquisar=\"vm.pesquisar\" \ndesabilitar-botao-inserir=\"vm.tabSelecionada == \'equipamentos\' || vm.tabSelecionada == \'pessoalDeReferencia\' || vm.tabSelecionada === \'configuracoes\'\" \ndesabilitar-botao-editar=\"vm.tabSelecionada == \'equipamentos\' || vm.tabSelecionada == \'pessoalDeReferencia\'\" \ndesabilitar-botao-excluir=\"vm.tabSelecionada == \'equipamentos\' || vm.tabSelecionada == \'pessoalDeReferencia\'\">\n</pg-toolbar><md-content layout-padding ng-hide=\"vm.controleForm.listarTodasEntidades\" \nng-disabled=\"vm.controleForm.emProgresso\"><md-tabs md-dynamic-height md-border-bottom><md-tab label=\"Cliente\" \nmd-active=\"vm.tabSelecionada === \'cliente\'\" md-on-select=\"vm.metodosGeral.tabSelecionada(\'cliente\')\" ng-disabled=\"\">\n<md-tab-label><label translate=\"CLIENTE.CLIENTE\"></label><md-icon md-font-icon=\"icon-close-circle-outline s24\" \nstyle=\"color: rgb(244,67,54)\" \nng-if=\"(vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo) && vm.formCliente.$invalid\"></md-icon><md-icon \nmd-font-icon=\"icon-checkbox-marked-circle-outline s24\" style=\"color: rgb(76,175,80)\" \nng-if=\"(vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo) && !vm.formCliente.$invalid\"></md-icon>\n</md-tab-label><md-tab-body><div ng-include=\"vm.htmlRota.cliente.tabs.cliente\"></div></md-tab-body></md-tab><md-tab \nlabel=\"Dados Auxiliares\" md-active=\"vm.tabSelecionada === \'dadosAuxiliares\'\" \nmd-on-select=\"vm.metodosGeral.tabSelecionada(\'dadosAuxiliares\')\"><md-tab-label style=\"position: relative\"><label \ntranslate=\"CLIENTE.DADOS_AUXILIARES\"></label><md-icon md-font-icon=\"icon-close-circle-outline s24\" \nstyle=\"color: rgb(244,67,54)\" \nng-if=\"(vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo) && vm.formDadosAuxiliares.$invalid\"></md-icon>\n<md-icon md-font-icon=\"icon-checkbox-marked-circle-outline s24\" style=\"color: rgb(76,175,80)\" \nng-if=\"(vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo) && !vm.formDadosAuxiliares.$invalid\"></md-icon>\n</md-tab-label><md-tab-body><div ng-show=\"vm.tabSelecionada === \'dadosAuxiliares\'\" \nng-include=\"vm.htmlRota.cliente.tabs.dadosAuxiliares\"></div></md-tab-body></md-tab><md-tab label=\"Equipamentos\" \nmd-active=\"vm.tabSelecionada === \'equipamentos\'\" md-on-select=\"vm.metodosGeral.tabSelecionada(\'equipamentos\')\" \nng-disabled=\"!vm.controleForm.pesquisaAtiva || vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo\">\n<md-tab-label><label translate=\"CLIENTE.EQUIPAMENTOS\"></label></md-tab-label><md-tab-body><div \nng-if=\"vm.tabSelecionada == \'equipamentos\'\" ng-include=\"vm.htmlRota.cliente.tabs.equipamentos\"></div></md-tab-body>\n</md-tab><md-tab label=\"Pessoal de Referência\" md-active=\"vm.tabSelecionada === \'pessoalDeReferencia\'\" \nmd-on-select=\"vm.metodosGeral.tabSelecionada(\'pessoalDeReferencia\')\" \nng-disabled=\"!vm.controleForm.pesquisaAtiva || vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo\">\n<md-tab-label><label translate=\"CLIENTE.PESSOAL_DE_REFERENCIA\"></label></md-tab-label><md-tab-body><div \nng-if=\"vm.tabSelecionada == \'pessoalDeReferencia\'\" ng-include=\"vm.htmlRota.cliente.tabs.pessoalDeReferencia\"></div>\n</md-tab-body></md-tab><md-tab label=\"Configurações\" md-active=\"vm.tabSelecionada === \'configuracoes\'\" \nmd-on-select=\"vm.metodosGeral.tabSelecionada(\'configuracoes\')\" ng-disabled=\"!vm.controleForm.pesquisaAtiva\">\n<md-tab-label><label translate=\"CLIENTE.CONFIGURACOES\"></label><md-icon md-font-icon=\"icon-close-circle-outline s24\" \nstyle=\"color: rgb(244,67,54)\" ng-if=\"vm.controleForm.editarAtivo && vm.formConfiguracoes.$invalid\"></md-icon><md-icon \nmd-font-icon=\"icon-checkbox-marked-circle-outline s24\" style=\"color: rgb(76,175,80)\" \nng-if=\"vm.controleForm.editarAtivo && !vm.formConfiguracoes.$invalid\"></md-icon></md-tab-label><md-tab-body><div \nng-if=\"vm.tabSelecionada === \'configuracoes\'\" ng-include=\"vm.htmlRota.cliente.tabs.configuracoes\"></div></md-tab-body>\n</md-tab><md-tab label=\"Observações Técnicas\" md-active=\"vm.tabSelecionada === \'observacoesTecnicas\'\" \nmd-on-select=\"vm.metodosGeral.tabSelecionada(\'observacoesTecnicas\')\" ng-disabled=\"\"><md-tab-label><label \ntranslate=\"CLIENTE.OBSERVACOES_TECNICAS\"></label><md-icon md-font-icon=\"icon-close-circle-outline s24\" \nstyle=\"color: rgb(244,67,54)\" \nng-if=\"(vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo) && vm.formObservacoesTecnicas.$invalid\"></md-icon>\n<md-icon md-font-icon=\"icon-checkbox-marked-circle-outline s24\" style=\"color: rgb(76,175,80)\" \nng-if=\"(vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo) && !vm.formObservacoesTecnicas.$invalid\">\n</md-icon></md-tab-label><md-tab-body><div ng-if=\"vm.tabSelecionada === \'observacoesTecnicas\'\" \nng-include=\"vm.htmlRota.cliente.tabs.observacoesTecnicas\"></div></md-tab-body></md-tab></md-tabs><md-fab-speed-dial \nmd-direction=\"down\" class=\"md-scale botao-menu-cadastro-cliente\" style=\"right: 0\" layout-align=\"end start\" \nng-if=\"vm.tabSelecionada === \'cliente\'\" md-open=\"vm.menuAberto\"><md-fab-trigger><md-button aria-label=\"menu\" \nclass=\"md-fab md-accent md-icon-button botao-menu\"><md-icon ng-disabled=\"true\" md-font-icon=\"icon-menu s26\"></md-icon>\n<md-icon class=\"s12 icone-contrato-risco-menu\" md-font-icon=\"icon-checkbox-blank-circle\" \nng-if=\"vm.possuiRiscoRescisaoContratual && !vm.menuAberto\" layout-align=\"end end\"></md-icon></md-button>\n</md-fab-trigger><md-fab-actions><md-button class=\"md-fab md-raised md-mini md-accent\" aria-label=\"Atendimento\" \ntranslate translate-aria-label=\"CLIENTE.ATENDIMENTO\" ng-click=\"vm.metodosCliente.abrirDialogAtendimento($event)\" \nng-disabled=\"!vm.controleForm.pesquisaAtiva || vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo || vm.controleForm.emProgresso\">\n<md-icon md-font-icon=\"icon-phone s20\"></md-icon><md-tooltip md-direction=\"left\"><span translate=\"CLIENTE.ATENDIMENTO\">\n</span></md-tooltip></md-button><md-button class=\"md-fab md-raised md-mini md-accent\" aria-label=\"Atendimento\" \ntranslate translate-aria-label=\"CLIENTE.RELATORIO_ATENDIMENTO\" \nng-click=\"vm.metodosCliente.navegarParaRelatorioAtendimento($event)\" \nng-disabled=\"!vm.controleForm.pesquisaAtiva || vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo || vm.controleForm.emProgresso\">\n<md-icon md-font-icon=\"icon-phone-log s20\"></md-icon><md-tooltip md-direction=\"left\"><span \ntranslate=\"CLIENTE.RELATORIO_ATENDIMENTO\"></span></md-tooltip></md-button><md-button \nclass=\"md-fab md-raised md-mini md-accent\" aria-label=\"Característica\" translate \ntranslate-aria-label=\"CLIENTE.CARACTERISTICA_CLIENTE\" ng-click=\"vm.metodosCliente.abrirDialogCaracteristica($event)\" \nng-disabled=\"!vm.controleForm.pesquisaAtiva || vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo || vm.controleForm.emProgresso\">\n<md-icon md-font-icon=\"icon-clipboard-outline s20\"></md-icon><md-tooltip md-direction=\"left\"><span \ntranslate=\"CLIENTE.CARACTERISTICA_CLIENTE\"></span></md-tooltip></md-button><md-button \nclass=\"md-fab md-raised md-mini md-accent\" ng-click=\"vm.metodosCliente.abrirDialogContratos($event, vm.cliente)\" \ntranslate translate-aria-label=\"CLIENTE.CONTROLE_VALIDADES_DOS_SOFTWARES\" aria-label=\"Contratos\" \nng-disabled=\"!vm.controleForm.pesquisaAtiva || vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo || vm.controleForm.emProgresso\">\n<md-icon md-font-icon=\"icon-clipboard-text s20\"></md-icon><md-icon class=\"s12 icone-contrato-risco\" \nmd-font-icon=\"icon-checkbox-blank-circle\" ng-if=\"vm.possuiRiscoRescisaoContratual\" layout-align=\"end end\"></md-icon>\n<md-tooltip md-direction=\"left\"><span translate=\"CLIENTE.CONTROLE_VALIDADES_DOS_SOFTWARES\"></span></md-tooltip>\n</md-button><md-button class=\"md-fab md-raised md-mini md-accent\" aria-label=\"Negócios em andamento\" \nng-if=\"vm.exibirBotaoNegocios\" translate translate-aria-label=\"CLIENTE.NEGOCIOS_EM_ANDAMENTO\" \nng-click=\"vm.metodosCliente.abrirDialogNegociosEmAndamento($event, vm.cliente)\" \nng-disabled=\"!vm.controleForm.pesquisaAtiva || vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo || vm.controleForm.emProgresso\">\n<md-icon md-font-icon=\"icon-currency-usd s20\"></md-icon><md-tooltip md-direction=\"left\"><span \ntranslate=\"CLIENTE.NEGOCIOS_EM_ANDAMENTO\"></span></md-tooltip></md-button><md-button \nclass=\"md-fab md-raised md-mini md-accent\" aria-label=\"Agenda\" translate translate-aria-label=\"CLIENTE.AGENDA\" \nng-click=\"vm.metodosCliente.abrirDialogAgenda($event, vm.cliente)\" \nng-disabled=\"!vm.controleForm.pesquisaAtiva || vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo || vm.controleForm.emProgresso\">\n<md-icon md-font-icon=\"icon-calendar-clock s20\"></md-icon><md-tooltip md-direction=\"left\"><span \ntranslate=\"CLIENTE.AGENDA\"></span></md-tooltip></md-button><md-button class=\"md-fab md-raised md-mini md-accent\" \naria-label=\"Estatísticas\" translate translate-aria-label=\"CLIENTE.ESTATISTICAS\" \nng-click=\"vm.metodosCliente.abrirDialogEstatisticas($event, vm.cliente)\" \nng-disabled=\"!vm.controleForm.pesquisaAtiva || vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo || vm.controleForm.emProgresso\">\n<md-icon md-font-icon=\"icon-chart-bar s20\" class=\"icone\"></md-icon><md-tooltip md-direction=\"left\"><span>\nEstatísticas tags</span></md-tooltip></md-button></md-fab-actions></md-fab-speed-dial></md-content></form></div>");
$templateCache.put("app/main/geral/cadastro/cliente/cliente/views/cliente.html","<div id=\"cliente\" class=\"page-layout simple tabbed\" layout=\"column\"><header-padrao translate-nome=\"CLIENTE.CLIENTE\" \nicone=\"icon-account-box\" liberar-pesquisa-quando-datatable-ativo=\"vm.controleForm.listarTodasEntidades\" \npesquisar=\"vm.pesquisar\"></header-padrao><div class=\"content\"><div ui-view=\"cliente-form\"></div></div><div \nui-view=\"clientes-tabela\" ng-if=\"vm.controleForm.listarTodasEntidades\"></div></div>");
$templateCache.put("app/main/geral/cadastro/cliente/cliente/views/clientes-tabela.html","<div layout=\"column\" flex><div class=\"md-padding md-background-bg md-whiteframe-1dp fullpage-datatable\" \nlayout=\"column\" flex><table class=\"dataTable row-border hover\" id=\"datatable-cliente\" width=\"100%\"><thead><tr><th>Ação\n</th><th>Código</th><th>Nome</th><th>Cidade</th><th>Telefone</th></tr></thead></table></div></div>");
$templateCache.put("app/main/geral/cadastro/cliente/cargo-cliente/views/cargo-cliente-form.html","<div class=\"md-background-bg md-whiteframe-1dp\"><form name=\"vm.form.cargo\" novalidate><pg-toolbar \nentidades=\"vm.cargos\" entidade=\"vm.cargo\" entidade-de-envio=\"vm.entidadeDeEnvio\" controlador-toolbar=\"vm.controleForm\" \nacao-pesquisar=\"vm.metodos.pesquisar()\" acao-criar=\"vm.metodos.salvar(vm.cargo)\" \nacao-editar=\"vm.metodos.editar(vm.cargo)\" acao-excluir=\"vm.metodos.excluir(vm.cargo)\" \nconstruir-dt-options=\"vm.metodos.construirDtOptions()\" metodos-externos=\"vm.metodosExternosPgToolbar\" \ncampo-pesquisar=\"vm.pesquisar\"></pg-toolbar><md-content layout-padding ng-hide=\"vm.controleForm.listarTodasEntidades\" \nng-disabled=\"vm.controleForm.emProgresso\"><div class=\"form-container\"><div layout-gt-xs=\"row\"><div layout=\"row\">\n<md-input-container class=\"md-block\" flex-gt-sm><label translate=\"CARGO.CODIGO\"></label><input type=\"text\" \nng-model=\"vm.cargo.codigo\" name=\"codigo\" mascara-numero-generica=\"#####\" \nng-required=\"vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\"><div \nng-messages=\"vm.form.cargo.codigo.$error\"><div ng-message=\"required\" translate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\">\n</div></div></md-input-container><proximo-codigo ng-show=\"vm.controleForm.inserirAtivo\" rota=\"vm.rota\" \nentidade-codigo=\"vm.cargo.codigo\" pre-loader-toolbar=\"vm.controleForm.preLoaderToolbar\"></proximo-codigo></div>\n<md-input-container class=\"md-block\" flex flex-offset-gt-sm=\"5\"><label translate=\"CARGO.DESCRICAO\"></label><input \ntype=\"text\" ng-model=\"vm.cargo.descricao\" name=\"descricao\" mascara-tamanho-campo=\"60\" \nng-required=\"vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo\" md-maxlength=\"60\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\"><div \nng-messages=\"vm.form.cargo.descricao.$error\"><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container></div></div></md-content></form>\n</div>");
$templateCache.put("app/main/geral/cadastro/cliente/cargo-cliente/views/cargo-cliente.html","<div id=\"cargo-cliente\" class=\"page-layout simple tabbed\" layout=\"column\"><header-padrao translate-nome=\"CARGO.CARGO\" \nliberar-pesquisa-quando-datatable-ativo=\"vm.controleForm.listarTodasEntidades\" pesquisar=\"vm.pesquisar\">\n</header-padrao><div class=\"content\"><div ui-view=\"cargo-cliente-form\"></div></div><div \nui-view=\"cargos-cliente-tabela\" ng-if=\"vm.controleForm.listarTodasEntidades\"></div></div>");
$templateCache.put("app/main/geral/cadastro/cliente/cargo-cliente/views/cargos-cliente-tabela.html","<div layout=\"column\" flex><div class=\"md-padding md-background-bg md-whiteframe-1dp fullpage-datatable\" \nlayout=\"column\" flex><table class=\"dataTable row-border hover\" id=\"datatable-cargo-cliente\" width=\"100%\"><thead><tr>\n<th>Ação</th><th>Código</th><th>Descrição</th></tr></thead></table></div></div>");
$templateCache.put("app/main/geral/cadastro/cliente/pendencia-cliente/views/pendencia-cliente-form.html","<div class=\"md-background-bg md-whiteframe-1dp\"><form name=\"vm.form.pendencia\" novalidate><pg-toolbar \nentidades=\"vm.pendencias\" entidade=\"vm.pendencia\" entidade-de-envio=\"vm.entidadeDeEnvio\" \ncontrolador-toolbar=\"vm.controleForm\" acao-pesquisar=\"vm.metodos.pesquisar()\" \nacao-criar=\"vm.metodos.salvar(vm.pendencia)\" acao-editar=\"vm.metodos.editar(vm.pendencia)\" \nacao-excluir=\"vm.metodos.excluir(vm.pendencia)\" construir-dt-options=\"vm.metodos.construirDtOptions()\" \nmetodos-externos=\"vm.metodosExternosPgToolbar\" campo-pesquisar=\"vm.pesquisar\"></pg-toolbar><md-content layout-padding \nng-hide=\"vm.controleForm.listarTodasEntidades\" ng-disabled=\"vm.controleForm.emProgresso\"><div class=\"form-container\">\n<div layout-gt-xs=\"row\"><md-input-container class=\"md-block\" flex><label translate=\"PENDENCIA.DESCRICAO\"></label><input\n type=\"text\" ng-model=\"vm.pendencia.descricao\" name=\"descricao\" mascara-tamanho-campo=\"150\" md-maxlength=\"150\" \nng-required=\"vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo\" \nng-disabled=\"vm.controleForm.pesquisaAtiva \r\n                               && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\">\n<div ng-messages=\"vm.form.pendencia.descricao.$error\"><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container></div></div></md-content></form>\n</div>");
$templateCache.put("app/main/geral/cadastro/cliente/pendencia-cliente/views/pendencia-cliente.html","<div id=\"pendencia-cliente\" class=\"page-layout simple tabbed\" layout=\"column\"><header-padrao \ntranslate-nome=\"PENDENCIA.PENDENCIA\" liberar-pesquisa-quando-datatable-ativo=\"vm.controleForm.listarTodasEntidades\" \npesquisar=\"vm.pesquisar\"></header-padrao><div class=\"content\"><div ui-view=\"pendencia-cliente-form\"></div></div><div \nui-view=\"pendencias-cliente-tabela\" ng-if=\"vm.controleForm.listarTodasEntidades\"></div></div>");
$templateCache.put("app/main/geral/cadastro/cliente/pendencia-cliente/views/pendencias-cliente-tabela.html","<div layout=\"column\" flex><div class=\"md-padding md-background-bg md-whiteframe-1dp fullpage-datatable\" \nlayout=\"column\" flex><table class=\"dataTable row-border hover\" id=\"datatable-pendencia-cliente\" width=\"100%\"><thead>\n<tr><th>Ação</th><th>Descrição</th></tr></thead></table></div></div>");
$templateCache.put("app/main/geral/cadastro/cliente/pessoa/views/pessoa-form.html","<div class=\"md-background-bg md-whiteframe-1dp\"><form name=\"vm.form.pessoa\" novalidate><pg-toolbar \nentidades=\"vm.pessoas\" entidade=\"vm.pessoa\" entidade-de-envio=\"vm.entidadeDeEnvio\" \ncontrolador-toolbar=\"vm.controleForm\" acao-pesquisar=\"vm.metodos.pesquisar()\" \nacao-criar=\"vm.metodos.salvar(vm.pessoa)\" acao-editar=\"vm.metodos.editar(vm.pessoa)\" \nacao-excluir=\"vm.metodos.excluir(vm.pessoa)\" construir-dt-options=\"vm.metodos.construirDtOptions()\" \nmetodos-externos=\"vm.metodosExternosPgToolbar\" campo-pesquisar=\"vm.pesquisar\" \npre-definir-campos-para-insercao=\"vm.metodos.preDefinirCamposParaInsercao()\" \niniciar-chamando-pesquisa=\"vm.iniciarChamandoPesquisa\" iniciar-habilitando-insercao=\"vm.iniciarChamandoInsercao\">\n</pg-toolbar><md-content layout-padding ng-hide=\"vm.controleForm.listarTodasEntidades\" \nng-disabled=\"vm.controleForm.emProgresso\"><div class=\"form-container\"><div layout-gt-xs=\"row\"><div layout=\"row\" \nflex=\"20\"><md-input-container class=\"md-block\" flex-gt-sm><label translate=\"PESSOA.CODIGO\"></label><input type=\"text\" \nng-model=\"vm.pessoa.codigo\" name=\"codigo\" mascara-numero-generica=\"#####\" \nng-disabled=\"(vm.controleForm.pesquisaAtiva || vm.controleForm.editarAtivo) || vm.controleForm.inserirAtivo\"><div \nng-messages=\"vm.form.pessoa.codigo.$error\"><div ng-message=\"required\" translate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\">\n</div></div></md-input-container></div><div layout=\"row\" flex=\"60\" class=\"mr-10\"><md-input-container class=\"md-block\" \nflex flex-offset-gt-sm=\"5\"><label translate=\"PESSOA.NOME\"></label><input type=\"text\" ng-model=\"vm.pessoa.nome\" \nname=\"nome\" mascara-tamanho-campo=\"60\" ng-required=\"vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo\" \nmd-maxlength=\"60\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\"><div \nng-messages=\"vm.form.pessoa.nome.$error\"><div ng-message=\"required\" translate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\">\n</div></div></md-input-container></div><div layout=\"row\" flex=\"10\" class=\"ml-10\"><md-checkbox \nng-model=\"vm.pessoa.clienteInativo\" aria-label=\"Ativo\" name=\"clienteInativo\" style=\"align-self: center\" \nng-change=\"vm.metodos.habilitarDesabilitarUtilizaIntegracaoRdStation(vm.pessoa.clienteInativo)\"><span \nclass=\"float-label-cor-default\" translate=\"Inativo\"></span></md-checkbox></div><div layout=\"row\" flex=\"30\">\n<md-input-container class=\"md-block\"><md-switch aria-label=\"Utilizar integração com RD Station\" \nname=\"utilizarIntegracaoRDStation\" \nng-disabled=\"!vm.controleForm.inserirAtivo && !vm.controleForm.editarAtivo || vm.pessoa.clienteInativo\" \nng-model=\"vm.pessoa.utilizarIntegracaoRDStation\">Utilizar integração com RD Station</md-switch></md-input-container>\n</div></div><div layout-gt-xs=\"row\"><md-autocomplete flex flex-gt-sm=\"35\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo \r\n                                    && !vm.controleForm.inserirAtivo\" \nng-required=\"vm.pessoa.bairro && (vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo)\" \nng-blur=\"vm.metodos.configuraAutoCompleteCidadeOnBlur()\" md-input-name=\"cidade\" md-no-cache=\"true\" \nmd-selected-item=\"vm.pessoa.cidade\" \nmd-selected-item-change=\"vm.metodos.alterarItemSelecionadoAutoCompleteCidade(item)\" \nmd-search-text=\"vm.textoDePesquisaAutoCompleteCidade.descricao\" \nmd-items=\"item in vm.metodos.pesquisarAutoCompleteCidade(vm.textoDePesquisaAutoCompleteCidade)\" \nmd-item-text=\"item.descricao\" md-autoselect md-floating-label=\"Cidade\"><md-item-template><span \nmd-highlight-text=\"vm.textoDePesquisaAutoCompleteCliente\">{{item.descricao}}</span></md-item-template><md-not-found>\n<label>Não foi encontrado nenhuma Cidade.</label></md-not-found></md-autocomplete><md-autocomplete flex \nflex-gt-sm=\"35\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo \r\n                                    && !vm.controleForm.inserirAtivo\" \nng-blur=\"vm.metodos.configuraAutoCompleteBairroOnBlur()\" md-input-name=\"bairro\" md-no-cache=\"true\" \nmd-selected-item=\"vm.pessoa.bairro\" \nmd-selected-item-change=\"vm.metodos.alterarItemSelecionadoAutoCompleteBairro(item)\" \nmd-search-text=\"vm.textoDePesquisaAutoCompleteBairro.descricao\" \nmd-items=\"item in vm.metodos.pesquisarAutoCompleteBairro(vm.textoDePesquisaAutoCompleteBairro)\" \nmd-item-text=\"item.descricao\" md-autoselect md-floating-label=\"Bairro\"><md-item-template><span \nmd-highlight-text=\"vm.textoDePesquisaAutoCompleteCliente\">{{item.descricao}}</span></md-item-template><md-not-found>\n<label>Não foi encontrado nenhum Bairro.</label></md-not-found></md-autocomplete><md-input-container class=\"md-block\" \nflex><label translate=\"PESSOA.TELEFONE\"></label><input type=\"text\" name=\"telefone\" ng-model=\"vm.pessoa.telefone\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\" \nng-pattern=\"/^\\([1-9]{2}\\)(\\s)?[0-9]{4,5}-[0-9]{4}$/\" mascara-telefone><div \nng-messages=\"vm.form.pessoa.telefone.$error\"><div ng-message=\"pattern\" \ntranslate=\"MENSAGEM_VALIDACAO.PATTERN_PARA_TELEFONE\"></div></div></md-input-container></div><div layout-gt-xs=\"row\">\n<fieldset class=\"standard\" flex><legend class=\"grp-legend\" translate=\"PESSOA.CELULAR\">Whatsapp</legend><div \nlayout-gt-sm=\"row\"><md-input-container class=\"md-block\" flex><label translate=\"PESSOA.NUMERO\"></label><input \ntype=\"text\" name=\"celular\" ng-model=\"vm.pessoa.celular\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\" \nng-pattern=\"/^\\([1-9]{2}\\)[0-9]{4,5}-[0-9]{4}$/\" mascara-telefone><div ng-messages=\"vm.form.pessoa.celular.$error\"><div\n ng-message=\"pattern\" translate=\"MENSAGEM_VALIDACAO.PATTERN_PARA_TELEFONE\"></div></div></md-input-container>\n<md-input-container class=\"md-block\"><md-switch aria-label=\"Whatsapp\" \nng-disabled=\"( !vm.controleForm.inserirAtivo && !vm.controleForm.editarAtivo) ||\r\n                                                                                    ( !vm.pessoa.celular && !vm.controleForm.inserirAtivo) ||\r\n                                                                                    ( !vm.pessoa.celular && !vm.controleForm.editarAtivo)\" \nclass=\"mt-5\" ng-model=\"vm.pessoa.numeroEhWhatsapp\">É WhatsApp</md-switch></md-input-container><md-input-container \nclass=\"md-block\" ng-show=\"!vm.pessoa.numeroEhWhatsapp\" flex><label translate=\"PESSOA.WHATSAPP\"></label><input \ntype=\"text\" name=\"numeroWhatsapp\" ng-model=\"vm.pessoa.numeroWhatsapp\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\" \nng-pattern=\"/^\\([1-9]{2}\\)[0-9]{4,5}-[0-9]{4}$/\" mascara-telefone><div \nng-messages=\"vm.form.pessoa.numeroWhatsapp.$error\"><div ng-message=\"pattern\" \ntranslate=\"MENSAGEM_VALIDACAO.PATTERN_PARA_TELEFONE\"></div><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container><md-input-container class=\"md-block\">\n<md-switch aria-label=\"Permite mensagens para marketing\" \nng-disabled=\"!vm.controleForm.inserirAtivo && !vm.controleForm.editarAtivo\" class=\"mt-5\" \nng-model=\"vm.pessoa.permiteMensagensMarketing\"><span>Permite mensagens para marketing</span></md-switch>\n</md-input-container></div></fieldset></div><div layout-gt-xs=\"row\" class=\"mt-10\"><md-input-container class=\"md-block\" \nflex-gt-sm=\"50\"><label translate=\"PESSOA.EMAIL_PRINCIPAL\"></label><input type=\"email\" name=\"emailPrincipal\" \nng-model=\"vm.pessoa.emailPrincipal\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\" \nmascara-tamanho-campo=\"100\" md-maxlength=\"100\" \nng-required=\"vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo\"><div \nng-messages=\"vm.form.pessoa.emailPrincipal.$error\"><div ng-message=\"email\" \ntranslate=\"MENSAGEM_VALIDACAO.EMAIL_INVALIDO\"></div><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container><md-input-container class=\"md-block\" \nflex-gt-sm=\"50\"><label translate=\"PESSOA.EMAIL_ALTERNATIVO\"></label><input type=\"email\" name=\"emailAlternativo\" \nng-model=\"vm.pessoa.emailAlternativo\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\" \nmascara-tamanho-campo=\"100\" md-maxlength=\"100\"><div ng-messages=\"vm.form.pessoa.emailAlternativo.$error\"><div \nng-message=\"email\" translate=\"MENSAGEM_VALIDACAO.EMAIL_INVALIDO\"></div><div ng-message=\"igual\">E-mail já informado!\n</div></div></md-input-container></div><div layout-gt-xs=\"row\" flex><div layout-gt-xs=\"column\" flex><md-input-container\n class=\"md-block\" flex-gt-sm=\"75\" flex-gt-xs><label translate=\"PESSOA.SKYPE\"></label><input type=\"text\" \nng-model=\"vm.pessoa.skype\" name=\"skype\" mascara-tamanho-campo=\"60\" md-maxlength=\"60\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\">\n</md-input-container><md-input-container class=\"md-block\" flex-gt-sm=\"75\" flex-gt-xs><label translate=\"PESSOA.CARGO\">\n</label><md-select ng-model=\"vm.pessoa.cargoCodigo\" name=\"cargo\" md-on-open=\"vm.metodos.configuraMdSelectCargo()\" \nng-required=\"vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\">\n<md-select-header><input id=\"pessoa-form-cargo-md-select\" class=\"md-text\" ng-model=\"vm.filtrarCargos\" type=\"search\" \nplaceholder=\"\" translate translate-attr-placeholder=\"PESSOA.PESQUISAR_CARGO\"></md-select-header><md-option \nng-value=\"cargo.codigo\" ng-repeat=\"cargo in vm.cargos | filter:vm.filtrarCargos track by cargo.codigo\">\n{{cargo.descricao}}</md-option></md-select><div ng-messages=\"vm.form.pessoa.cargo.$error\"><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container></div><div layout-gt-xs=\"column\" \nflex><md-input-container class=\"md-block\"><label translate=\"PESSOA.OBSERVACAO\"></label><textarea \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\" \nng-model=\"vm.pessoa.observacao\" name=\"observacao\" md-no-resize=\"true\" rows=\"5\" max-rows=\"5\">\r\n\r\n\r\n\r\n              \n</textarea></md-input-container></div></div></div></md-content></form></div>");
$templateCache.put("app/main/geral/cadastro/cliente/pessoa/views/pessoa.html","<div id=\"pessoa\" class=\"page-layout simple tabbed\" layout=\"column\" flex><header-padrao translate-nome=\"PESSOA.PESSOA\" \nliberar-pesquisa-quando-datatable-ativo=\"vm.controleForm.listarTodasEntidades\" pesquisar=\"vm.pesquisar\">\n</header-padrao><div class=\"content\"><div ui-view=\"pessoa-form\"></div></div><div ui-view=\"pessoas-tabela\" \nng-if=\"vm.controleForm.listarTodasEntidades\"></div></div>");
$templateCache.put("app/main/geral/cadastro/cliente/pessoa/views/pessoas-tabela.html","<div layout=\"column\" flex><div class=\"md-padding md-background-bg md-whiteframe-1dp fullpage-datatable\" \nlayout=\"column\" flex><table class=\"dataTable row-border hover\" id=\"datatable-pessoa\" width=\"100%\"><thead><tr><th>Ação\n</th><th>Código</th><th>Nome</th><th>Cargo</th><th>Cidade</th><th>Telefone</th><th>Celular</th><th>Skype</th></tr>\n</thead></table></div></div>");
$templateCache.put("app/main/geral/cadastro/solucao/produto/views/produto-form.html","<div class=\"md-background-bg md-whiteframe-1dp\"><form name=\"vm.form\" novalidate><pg-toolbar entidades=\"vm.produtos\" \nentidade=\"vm.produto\" entidade-de-envio=\"vm.entidadeDeEnvio\" controlador-toolbar=\"vm.controleForm\" \nacao-pesquisar=\"vm.metodos.pesquisar()\" acao-criar=\"vm.metodos.salvar(vm.produto)\" \nacao-editar=\"vm.metodos.editar(vm.produto)\" acao-excluir=\"vm.metodos.excluir(vm.produto)\" \nconstruir-dt-options=\"vm.metodos.construirDtOptions()\" \npre-definir-campos-para-insercao=\"vm.metodosGeral.preDefinirCamposParaInserir()\" \npre-definir-campos-para-edicao=\"vm.metodosGeral.preDefinirCamposParaEdicao()\" \nmetodo-externo-acao-reverter=\"vm.metodosGeral.acaoReverter()\" metodos-externos=\"vm.metodosExternosPgToolbar\" \ncampo-pesquisar=\"vm.pesquisar\" iniciar-chamando-pesquisa=\"vm.iniciarChamandoPesquisa\"></pg-toolbar><md-content \nlayout-padding ng-hide=\"vm.controleForm.listarTodasEntidades\" ng-disabled=\"vm.controleForm.emProgresso\"><div \nclass=\"form-container\"><div layout=\"row\" layout-sm=\"column\" layout-align=\"start center\"><md-input-container \nclass=\"md-block\" flex flex-sm=\"100\"><label translate=\"PRODUTO.DESCRICAO\"></label><input type=\"text\" \nng-model=\"vm.produto.descricao\" name=\"descricao\" mascara-tamanho-campo=\"100\" \nng-required=\"vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo\" md-maxlength=\"100\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\"><div \nng-messages=\"vm.form.descricao.$error\"><div ng-message=\"required\" translate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\">\n</div></div></md-input-container><div flex=\"none\" flex-sm=\"100\" layout=\"row\" layout-align=\"end center\" \nlayout-align-sm=\"start center\" style=\"padding-left: 16px\"><md-input-container class=\"md-block\"><md-switch \naria-label=\"Ativo\" name=\"ativo\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\" \nng-model=\"vm.produto.ativo\">Ativo</md-switch></md-input-container></div></div><div layout-gt-xs=\"row\" \nlayout-sm=\"column\"><md-input-container class=\"md-block\" flex-gt-sm=\"25\" flex-sm=\"100\"><label translate=\"PRODUTO.FUNIL\">\nFunil</label><md-select ng-model=\"vm.produto.codigoPipelineFunil\" name=\"produtoFunil\" \nmd-on-open=\"vm.metodos.configuraMdSelectProduto()\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\">\n<md-select-header ng-if=\"vm.funis.length > 0\"><input id=\"produtos-funil-md-select\" class=\"md-text\" \nng-model=\"vm.filtrarFunis\" type=\"search\" placeholder=\"\" translate translate-attr-placeholder=\"PRODUTO.PESQUISARFUNIL\">\n</md-select-header><md-option ng-value=\"\"></md-option><md-option ng-value=\"funil.codigo\" \nng-repeat=\"funil in vm.funis | filter:vm.metodos.filtrarFunis\">{{funil.descricao}}</md-option></md-select>\n</md-input-container><md-input-container class=\"md-block\" flex=\"15\" flex-sm=\"100\"><label \ntranslate=\"PRODUTO.CODIGO_PROTECAO\"></label><input type=\"text\" ng-model=\"vm.produto.codigoProtecao\" \nname=\"codigoOperacao\" mascara-numero-generica=\"#####\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\">\n</md-input-container><md-input-container class=\"md-block\" flex-gt-sm=\"30\" flex-sm=\"100\" \nng-if=\"vm.squadUsuarioLogado.length > 1\"><label>Squad</label><md-select ng-model=\"vm.produto.codigoSquads\" \nname=\"codigoSquads\" \nng-required=\"vm.produto.softwareProprio && (vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo)\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\" \nmultiple=\"multiple\"><md-option ng-value=\"squad.codigo\" ng-repeat=\"squad in vm.squads track by squad.codigo\">\n{{squad.descricao}}</md-option></md-select><div ng-messages=\"vm.form.codigoSquads.$error\"><div ng-message=\"required\">\nCampo obrigatório</div></div></md-input-container></div><div layout-gt-xs=\"row\" layout-sm=\"column\" \nlayout-align=\"start start\"><fieldset class=\"configuracoes-fieldset\"><legend style=\"color: #039be5 !important\">\nConfigurações</legend><div layout=\"row\" layout-sm=\"column\" layout-wrap style=\"margin-bottom: 10px\"><md-input-container \nclass=\"md-block\" style=\"margin-left: -5px\"><md-checkbox ng-model=\"vm.produto.comercializavel\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\" \nng-change=\"vm.metodos.onChangeComercializavel()\" aria-label=\"Contratual\" name=\"comercializavel\"><span \nclass=\"float-label-cor-default\">Item contratual</span></md-checkbox></md-input-container><md-input-container \nclass=\"md-block\"><md-checkbox ng-model=\"vm.produto.subitemContratual\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\" \nng-change=\"vm.metodos.onChangeSubitemContratual()\" aria-label=\"Subitem contratual\" name=\"subitemContratual\"><span \nclass=\"float-label-cor-default\">Subitem contratual</span></md-checkbox></md-input-container><md-input-container \nclass=\"md-block\"><md-checkbox ng-model=\"vm.produto.permiteSubitens\" \nng-disabled=\"!vm.permiteSubitensHabilitado || (vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo)\" \naria-label=\"Permite vínculo de subitens\" name=\"permiteSubitens\"><span class=\"float-label-cor-default\">\nPermite vínculo de subitens</span></md-checkbox></md-input-container><md-input-container class=\"md-block\"><md-checkbox \nng-model=\"vm.produto.softwareProprio\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\" \naria-label=\"Software próprio\" name=\"softwareProprio\"><span class=\"float-label-cor-default\">Software próprio</span>\n</md-checkbox></md-input-container></div></fieldset></div></div></md-content></form></div>");
$templateCache.put("app/main/geral/cadastro/solucao/produto/views/produto.html","<div id=\"produto\" class=\"page-layout simple tabbed\" layout=\"column\"><header-padrao translate-nome=\"PRODUTO.PRODUTO\" \nliberar-pesquisa-quando-datatable-ativo=\"vm.controleForm.listarTodasEntidades\" pesquisar=\"vm.pesquisar\">\n</header-padrao><div class=\"content\"><div ui-view=\"produto-form\"></div></div><div ui-view=\"produtos-tabela\" \nng-if=\"vm.controleForm.listarTodasEntidades\"></div></div>");
$templateCache.put("app/main/geral/cadastro/solucao/produto/views/produtos-tabela.html","<div layout=\"column\" flex><div class=\"md-padding md-background-bg md-whiteframe-1dp fullpage-datatable\" \nlayout=\"column\" flex><table class=\"dataTable row-border hover\" id=\"datatable-produto\" width=\"100%\"><thead><tr><th>Ação\n</th><th>Código</th><th>Descrição</th><th>Funil</th><th>Código de Proteção</th><th>Status</th><th>Item contratual</th>\n<th>Subitem contratual</th><th>Permite subitens</th><th>Software próprio</th></tr></thead></table></div></div>");
$templateCache.put("app/main/geral/cadastro/solucao/solucao/views/solucao-form.html","<div class=\"md-background-bg md-whiteframe-1dp\"><form name=\"solucaoRotinasForm\" novalidate><pg-toolbar \nentidades=\"vm.solucoes\" entidade=\"vm.solucao\" entidade-de-envio=\"vm.entidadeDeEnvio\" \ncontrolador-toolbar=\"vm.controleForm\" controlador-pre-loader=\"vm.controlePreloader\" \nacao-pesquisar=\"vm.metodosSolucao.pesquisar()\" acao-criar=\"vm.metodosSolucao.salvar(vm.solucao)\" \nacao-editar=\"vm.metodosSolucao.editar(vm.solucao)\" acao-excluir=\"vm.metodosSolucao.excluir(vm.solucao)\" \nmetodo-externo-acao-navegacao=\"vm.metodosGeral.navegacao()\" \nmetodo-externo-acao-nova-pesquisa=\"vm.metodosGeral.novaPesquisa()\" \nconstruir-dt-options=\"vm.metodosSolucao.construirDtOptions()\" metodos-externos=\"vm.metodosExternosPgToolbar\" \ncampo-pesquisar=\"vm.pesquisar\" desabilitar-botao-inserir=\"vm.tabSelecionada != \'solucao\'\" \ndesabilitar-botao-editar=\"vm.tabSelecionada != \'solucao\'\" desabilitar-botao-excluir=\"vm.tabSelecionada != \'solucao\'\">\n</pg-toolbar><md-content layout-padding ng-hide=\"vm.controleForm.listarTodasEntidades\" \nng-disabled=\"vm.controleForm.emProgresso\"><md-tabs md-dynamic-height md-border-bottom><md-tab label=\"Solução\" \nmd-active=\"vm.tabSelecionada === \'solucao\'\" md-on-select=\"vm.metodosGeral.tabSelecionada(\'solucao\')\"><md-tab-label>\n<label translate=\"SOLUCAO_ROTINAS_TAREFAS.SOLUCAO\"></label></md-tab-label><md-tab-body><div \nng-include=\"vm.htmlRota.tabs.solucao\"></div></md-tab-body></md-tab><md-tab label=\"Rotinas\" \nmd-active=\"vm.tabSelecionada === \'rotinas\'\" md-on-select=\"vm.metodosGeral.tabSelecionada(\'rotinas\')\" \nng-disabled=\"!vm.controleForm.pesquisaAtiva || vm.controleForm.inserirAtivo || vm.controleForm.editarAtivo\">\n<md-tab-label><label translate=\"SOLUCAO_ROTINAS_TAREFAS.ROTINAS\"></label></md-tab-label><md-tab-body><div \nng-include=\"vm.htmlRota.tabs.rotinas\"></div></md-tab-body></md-tab><md-tab label=\"Tarefas\" \nmd-active=\"vm.tabSelecionada === \'tarefas\'\" md-on-select=\"vm.metodosGeral.tabSelecionada(\'tarefas\')\" \nng-disabled=\"!vm.controleForm.pesquisaAtiva || vm.controleForm.inserirAtivo || vm.controleForm.editarAtivo\">\n<md-tab-label><label translate=\"SOLUCAO_ROTINAS_TAREFAS.TAREFAS\"></label></md-tab-label><md-tab-body><div \nng-include=\"vm.htmlRota.tabs.tarefas\"></div></md-tab-body></md-tab></md-tabs></md-content></form></div>");
$templateCache.put("app/main/geral/cadastro/solucao/solucao/views/solucao.html","<div id=\"solucao\" class=\"page-layout simple fullwidth\" layout=\"column\"><header-padrao \ntranslate-nome=\"SOLUCAO_ROTINAS_TAREFAS.SOLUCAO_ROTINAS_TAREFAS\" icone=\"icon-apps\" \nliberar-pesquisa-quando-datatable-ativo=\"vm.controleForm.pesquisarDatatable\" pesquisar=\"vm.pesquisar\"></header-padrao>\n<div class=\"content\"><div ui-view=\"solucao-form\"></div></div><div ui-view=\"solucoes-tabela\" \nng-if=\"vm.controleForm.listarTodasEntidades\"></div></div>");
$templateCache.put("app/main/geral/cadastro/solucao/solucao/views/solucoes-tabela.html","<div layout=\"column\" flex><div class=\"md-padding md-background-bg md-whiteframe-1dp fullpage-datatable\" \nlayout=\"column\" flex><table class=\"dataTable row-border hover\" id=\"datatable-solucao\" width=\"100%\"><thead><tr><th>Ação\n</th><th>Código</th><th>Descrição</th><th>Produto</th><th>Plataforma</th></tr></thead></table></div></div>");
$templateCache.put("app/main/geral/cadastro/endereco/bairro/views/bairro-form.html","<div class=\"md-background-bg md-whiteframe-1dp\"><form name=\"vm.form.bairro\" novalidate><pg-toolbar \nentidades=\"vm.bairros\" entidade=\"vm.bairro\" entidade-de-envio=\"vm.entidadeDeEnvio\" \ncontrolador-toolbar=\"vm.controleForm\" acao-pesquisar=\"vm.metodos.pesquisar()\" \nacao-criar=\"vm.metodos.salvar(vm.bairro)\" acao-editar=\"vm.metodos.editar(vm.bairro)\" \nacao-excluir=\"vm.metodos.excluir(vm.bairro)\" construir-dt-options=\"vm.metodos.construirDtOptions()\" \nmetodos-externos=\"vm.metodosExternosPgToolbar\" campo-pesquisar=\"vm.pesquisar\"></pg-toolbar><md-content layout-padding \nng-hide=\"vm.controleForm.listarTodasEntidades\" ng-disabled=\"vm.controleForm.emProgresso\"><div class=\"form-container\">\n<div layout-gt-xs=\"row\"><div layout=\"row\"><md-input-container class=\"md-block\" flex-gt-sm><label \ntranslate=\"BAIRRO.CODIGO\"></label><input type=\"text\" ng-model=\"vm.bairro.codigo\" name=\"codigo\" \nmascara-numero-generica=\"#####\" ng-required=\"vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\"><div \nng-messages=\"vm.form.bairro.codigo.$error\"><div ng-message=\"required\" translate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\">\n</div></div></md-input-container><proximo-codigo ng-show=\"vm.controleForm.inserirAtivo\" rota=\"vm.rota\" \nentidade-codigo=\"vm.bairro.codigo\" pre-loader-toolbar=\"vm.controleForm.preLoaderToolbar\"></proximo-codigo></div>\n<md-input-container class=\"md-block\" flex flex-offset-gt-sm=\"5\"><label translate=\"BAIRRO.DESCRICAO\"></label><input \ntype=\"text\" ng-model=\"vm.bairro.descricao\" name=\"bairroDescricao\" mascara-tamanho-campo=\"60\" \nng-required=\"vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo\" md-maxlength=\"60\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\"><div \nng-messages=\"vm.form.bairro.bairroDescricao.$error\"><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container></div></div></md-content></form>\n</div>");
$templateCache.put("app/main/geral/cadastro/endereco/bairro/views/bairro.html","<div id=\"bairro\" class=\"page-layout simple tabbed\" layout=\"column\"><header-padrao translate-nome=\"BAIRRO.BAIRRO\" \nliberar-pesquisa-quando-datatable-ativo=\"vm.controleForm.listarTodasEntidades\" pesquisar=\"vm.pesquisar\">\n</header-padrao><div class=\"content\"><div ui-view=\"bairro-form\"></div></div><div ui-view=\"bairros-tabela\" \nng-if=\"vm.controleForm.listarTodasEntidades\"></div></div>");
$templateCache.put("app/main/geral/cadastro/endereco/bairro/views/bairros-tabela.html","<div layout=\"column\" flex><div class=\"md-padding md-background-bg md-whiteframe-1dp fullpage-datatable\" \nlayout=\"column\" flex><table class=\"dataTable row-border hover\" id=\"datatable-endereco-bairro\" width=\"100%\"><thead><tr>\n<th>Ação</th><th>Código</th><th>Descrição</th></tr></thead></table></div></div>");
$templateCache.put("app/main/geral/cadastro/equipamento/equipamento/views/equipamento-form.html","<div class=\"md-background-bg md-whiteframe-1dp\"><form name=\"vm.form\" novalidate><pg-toolbar \nentidades=\"vm.equipamentos\" entidade=\"vm.equipamento\" entidade-de-envio=\"vm.entidadeDeEnvio\" \ncontrolador-toolbar=\"vm.controleForm\" acao-pesquisar=\"vm.metodos.pesquisar()\" \nacao-criar=\"vm.metodos.salvar(vm.equipamento)\" acao-editar=\"vm.metodos.editar(vm.equipamento)\" \nacao-excluir=\"vm.metodos.excluir(vm.equipamento)\" construir-dt-options=\"vm.metodos.construirDtOptions()\" \nmetodos-externos=\"vm.metodosExternosPgToolbar\" campo-pesquisar=\"vm.pesquisar\"></pg-toolbar><md-content layout-padding \nng-hide=\"vm.controleForm.listarTodasEntidades\" ng-disabled=\"vm.controleForm.emProgresso\"><div class=\"form-container\">\n<div layout-gt-xs=\"row\"><md-input-container class=\"md-block\" flex=\"20\"><label translate=\"EQUIPAMENTO.FABRICANTE\">\nFabricante</label><md-select ng-model=\"vm.equipamento.codigoFabricante\" name=\"codigoFabricante\" \nng-required=\"vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo\" \nmd-on-open=\"vm.metodos.configuraMdSelectFabricante()\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\">\n<md-select-header ng-if=\"vm.fabricantes.length > 0\"><input id=\"equipamento-fabricante-md-select\" class=\"md-text\" \nng-model=\"vm.filtrarFabricantes\" type=\"search\" placeholder=\"\" translate \ntranslate-attr-placeholder=\"EQUIPAMENTO.PESQUISAR_FABRICANTE\"></md-select-header><md-option \nng-value=\"fabricante.codigo\" \nng-repeat=\"fabricante in vm.fabricantes | filter:vm.filtrarFabricantes track by fabricante.codigo\">\n{{fabricante.descricao}}</md-option></md-select><div ng-messages=\"vm.form.codigoFabricante.$error\"><div \nng-message=\"required\" translate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container>\n<md-input-container class=\"md-block\" flex-offset=\"5\" flex=\"20\"><label translate=\"EQUIPAMENTO.TIPO_EQUIPAMENTO\">\nTipo Equipamento</label><md-select ng-model=\"vm.equipamento.codigoTipoEquipamento\" name=\"codigoTipoEquipamento\" \nng-required=\"vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo\" \nmd-on-open=\"vm.metodos.configuraMdSelectTipoEquipamento()\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\">\n<md-select-header ng-if=\"vm.tiposEquipamento.length > 0\"><input id=\"equipamento-tipo-equipamento-md-select\" \nclass=\"md-text\" ng-model=\"vm.filtrarTiposEquipamento\" type=\"search\" placeholder=\"\" translate \ntranslate-attr-placeholder=\"EQUIPAMENTO.PESQUISAR_TIPO_EQUIPAMENTO\"></md-select-header><md-option \nng-value=\"tipoEquipamento.codigo\" \nng-repeat=\"tipoEquipamento in vm.tiposEquipamento | filter:vm.filtrarTiposEquipamento track by tipoEquipamento.codigo\">\n{{tipoEquipamento.descricao}}</md-option></md-select><div ng-messages=\"vm.form.codigoTipoEquipamento.$error\"><div \nng-message=\"required\" translate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container>\n<md-input-container class=\"md-block\" flex-offset=\"5\" flex><label translate=\"EQUIPAMENTO.DESCRICAO\"></label><input \ntype=\"text\" ng-model=\"vm.equipamento.descricao\" name=\"descricao\" mascara-tamanho-campo=\"100\" \nng-required=\"vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo\" md-maxlength=\"100\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\"><div \nng-messages=\"vm.form.descricao.$error\"><div ng-message=\"required\" translate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\">\n</div></div></md-input-container></div></div></md-content></form></div>");
$templateCache.put("app/main/geral/cadastro/equipamento/equipamento/views/equipamento.html","<div id=\"equipamento\" class=\"page-layout simple tabbed\" layout=\"column\"><header-padrao \ntranslate-nome=\"EQUIPAMENTO.EQUIPAMENTO\" \nliberar-pesquisa-quando-datatable-ativo=\"vm.controleForm.listarTodasEntidades\" pesquisar=\"vm.pesquisar\">\n</header-padrao><div class=\"content\"><div ui-view=\"equipamento-form\"></div></div><div ui-view=\"equipamentos-tabela\" \nng-if=\"vm.controleForm.listarTodasEntidades\"></div></div>");
$templateCache.put("app/main/geral/cadastro/equipamento/equipamento/views/equipamentos-tabela.html","<div layout=\"column\" flex><div class=\"md-padding md-background-bg md-whiteframe-1dp fullpage-datatable\" \nlayout=\"column\" flex><table class=\"dataTable row-border hover\" id=\"datatable-locacao\" width=\"100%\"><thead><tr><th>Ação\n</th><th>Fabricante</th><th>Tipo locacao</th><th>Descrição</th></tr></thead></table></div></div>");
$templateCache.put("app/main/geral/cadastro/endereco/cidade/views/cidade-form.html","<div class=\"md-background-bg md-whiteframe-1dp\"><form name=\"vm.form.cidade\" novalidate><pg-toolbar \nentidades=\"vm.cidades\" entidade=\"vm.cidade\" entidade-de-envio=\"vm.entidadeDeEnvio\" \ncontrolador-toolbar=\"vm.controleForm\" acao-pesquisar=\"vm.metodos.pesquisar()\" \nacao-criar=\"vm.metodos.salvar(vm.cidade)\" acao-editar=\"vm.metodos.editar(vm.cidade)\" \nacao-excluir=\"vm.metodos.excluir(vm.cidade)\" construir-dt-options=\"vm.metodos.construirDtOptions()\" \nmetodos-externos=\"vm.metodosExternosPgToolbar\" campo-pesquisar=\"vm.pesquisar\"></pg-toolbar><md-content layout-padding \nng-hide=\"vm.controleForm.listarTodasEntidades\" ng-disabled=\"vm.controleForm.emProgresso\"><div class=\"form-container\">\n<div layout-gt-xs=\"row\"><div layout=\"row\"><md-input-container class=\"md-block\" flex-gt-sm><label \ntranslate=\"CIDADE.CODIGO\"></label><input type=\"text\" ng-model=\"vm.cidade.codigo\" name=\"codigo\" \nmascara-numero-generica=\"#####\" ng-required=\"vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\"><div \nng-messages=\"vm.form.cidade.codigo.$error\"><div ng-message=\"required\" translate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\">\n</div></div></md-input-container><proximo-codigo ng-show=\"vm.controleForm.inserirAtivo\" rota=\"vm.rota\" \nentidade-codigo=\"vm.cidade.codigo\" pre-loader-toolbar=\"vm.controleForm.preLoaderToolbar\"></proximo-codigo></div>\n<md-input-container class=\"md-block\" flex flex-offset-gt-sm=\"5\"><label translate=\"CIDADE.DESCRICAO\"></label><input \ntype=\"text\" ng-model=\"vm.cidade.descricao\" name=\"cidadeDescricao\" mascara-tamanho-campo=\"60\" \nng-required=\"vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo\" md-maxlength=\"60\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\"><div \nng-messages=\"vm.form.cidade.cidadeDescricao.$error\"><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container><md-input-container class=\"md-block\">\n<label translate=\"CIDADE.UF\">UF</label><md-select ng-model=\"vm.cidade.uf\" name=\"cidadeUF\" \nng-required=\"vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\"><md-option\n ng-value=\"uf\" ng-repeat=\"uf in vm.ufs\">{{uf}}</md-option></md-select><div \nng-messages=\"vm.form.cidade.cidadeUF.$error\"><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container></div></div></md-content></form>\n</div>");
$templateCache.put("app/main/geral/cadastro/endereco/cidade/views/cidade.html","<div id=\"cidade\" class=\"page-layout simple tabbed\" layout=\"column\"><header-padrao translate-nome=\"CIDADE.CIDADE\" \nliberar-pesquisa-quando-datatable-ativo=\"vm.controleForm.listarTodasEntidades\" pesquisar=\"vm.pesquisar\">\n</header-padrao><div class=\"content\"><div ui-view=\"cidade-form\"></div></div><div ui-view=\"cidades-tabela\" \nng-if=\"vm.controleForm.listarTodasEntidades\"></div></div>");
$templateCache.put("app/main/geral/cadastro/endereco/cidade/views/cidades-tabela.html","<div layout=\"column\" flex><div class=\"md-padding md-background-bg md-whiteframe-1dp fullpage-datatable\" \nlayout=\"column\" flex><table class=\"dataTable row-border hover\" id=\"datatable-endereco-cidade\" width=\"100%\"><thead><tr>\n<th>Ação</th><th>Código</th><th>Descrição</th><th>UF</th></tr></thead></table></div></div>");
$templateCache.put("app/main/geral/cadastro/equipamento/equipamento-fabricante/views/equipamento-fabricante-form.html","<div class=\"md-background-bg md-whiteframe-1dp\"><form name=\"vm.form\" novalidate><pg-toolbar \nentidades=\"vm.equipamentoFabricantes\" entidade=\"vm.equipamentoFabricante\" entidade-de-envio=\"vm.entidadeDeEnvio\" \ncontrolador-toolbar=\"vm.controleForm\" acao-pesquisar=\"vm.metodos.pesquisar()\" \nacao-criar=\"vm.metodos.salvar(vm.equipamentoFabricante)\" acao-editar=\"vm.metodos.editar(vm.equipamentoFabricante)\" \nacao-excluir=\"vm.metodos.excluir(vm.equipamentoFabricante)\" construir-dt-options=\"vm.metodos.construirDtOptions()\" \nmetodos-externos=\"vm.metodosExternosPgToolbar\" campo-pesquisar=\"vm.pesquisar\"></pg-toolbar><md-content layout-padding \nng-hide=\"vm.controleForm.listarTodasEntidades\" ng-disabled=\"vm.controleForm.emProgresso\"><div class=\"form-container\">\n<div layout-gt-xs=\"row\"><md-input-container class=\"md-block\" flex><label translate=\"EQUIPAMENTO_FABRICANTE.DESCRICAO\">\n</label><input type=\"text\" ng-model=\"vm.equipamentoFabricante.descricao\" name=\"descricao\" mascara-tamanho-campo=\"100\" \nng-required=\"vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo\" md-maxlength=\"100\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\"><div \nng-messages=\"vm.form.descricao.$error\"><div ng-message=\"required\" translate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\">\n</div></div></md-input-container></div></div></md-content></form></div>");
$templateCache.put("app/main/geral/cadastro/equipamento/equipamento-fabricante/views/equipamento-fabricante.html","<div id=\"equipamento-fabricante\" class=\"page-layout simple tabbed\" layout=\"column\"><header-padrao \ntranslate-nome=\"EQUIPAMENTO_FABRICANTE.EQUIPAMENTO_FABRICANTE\" \nliberar-pesquisa-quando-datatable-ativo=\"vm.controleForm.listarTodasEntidades\" pesquisar=\"vm.pesquisar\">\n</header-padrao><div class=\"content\"><div ui-view=\"equipamento-fabricante-form\"></div></div><div \nui-view=\"equipamento-fabricantes-tabela\" ng-if=\"vm.controleForm.listarTodasEntidades\"></div></div>");
$templateCache.put("app/main/geral/cadastro/equipamento/equipamento-fabricante/views/equipamento-fabricantes-tabela.html","<div layout=\"column\" flex><div class=\"md-padding md-background-bg md-whiteframe-1dp fullpage-datatable\" \nlayout=\"column\" flex><table class=\"dataTable row-border hover\" id=\"datatable-equipamento-fabricante\" width=\"100%\">\n<thead><tr><th>Ação</th><th>Descrição</th></tr></thead></table></div></div>");
$templateCache.put("app/main/geral/cadastro/equipamento/fornecedor/views/fornecedor-form.html","<div class=\"md-background-bg md-whiteframe-1dp\"><form name=\"vm.form\" novalidate><pg-toolbar \nentidades=\"vm.fornecedores\" entidade=\"vm.fornecedor\" entidade-de-envio=\"vm.entidadeDeEnvio\" \ncontrolador-toolbar=\"vm.controleForm\" acao-pesquisar=\"vm.metodos.pesquisar()\" \nacao-criar=\"vm.metodos.salvar(vm.fornecedor)\" acao-editar=\"vm.metodos.editar(vm.fornecedor)\" \nacao-excluir=\"vm.metodos.excluir(vm.fornecedor)\" construir-dt-options=\"vm.metodos.construirDtOptions()\" \nmetodos-externos=\"vm.metodosExternosPgToolbar\" campo-pesquisar=\"vm.pesquisar\"></pg-toolbar><md-content layout-padding \nng-hide=\"vm.controleForm.listarTodasEntidades\" ng-disabled=\"vm.controleForm.emProgresso\"><div class=\"form-container\">\n<div layout-gt-xs=\"row\"><md-input-container class=\"md-block\" flex><label translate=\"FORNECEDOR.DESCRICAO\"></label>\n<input type=\"text\" ng-model=\"vm.fornecedor.descricao\" name=\"descricao\" mascara-tamanho-campo=\"100\" \nng-required=\"vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo\" md-maxlength=\"100\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\"><div \nng-messages=\"vm.form.descricao.$error\"><div ng-message=\"required\" translate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\">\n</div></div></md-input-container></div></div></md-content></form></div>");
$templateCache.put("app/main/geral/cadastro/equipamento/fornecedor/views/fornecedor.html","<div id=\"fornecedor\" class=\"page-layout simple tabbed\" layout=\"column\"><header-padrao \ntranslate-nome=\"FORNECEDOR.FORNECEDOR\" liberar-pesquisa-quando-datatable-ativo=\"vm.controleForm.listarTodasEntidades\" \npesquisar=\"vm.pesquisar\"></header-padrao><div class=\"content\"><div ui-view=\"fornecedor-form\"></div></div><div \nui-view=\"fornecedores-tabela\" ng-if=\"vm.controleForm.listarTodasEntidades\"></div></div>");
$templateCache.put("app/main/geral/cadastro/equipamento/fornecedor/views/fornecedores-tabela.html","<div layout=\"column\" flex><div class=\"md-padding md-background-bg md-whiteframe-1dp fullpage-datatable\" \nlayout=\"column\" flex><table class=\"dataTable row-border hover\" id=\"datatable-fornecedor\" width=\"100%\"><thead><tr><th>\nAção</th><th>Descrição</th></tr></thead></table></div></div>");
$templateCache.put("app/main/geral/cadastro/usuario/perfil/views/perfil-form.html","<div class=\"md-background-bg md-whiteframe-1dp\"><form name=\"perfilForm\" novalidate><pg-toolbar entidades=\"vm.perfis\" \nentidade=\"vm.perfil\" entidade-de-envio=\"vm.entidadeDeEnvio\" controlador-toolbar=\"vm.controleForm\" \nacao-pesquisar=\"vm.metodosPerfil.pesquisar()\" acao-criar=\"vm.metodosPerfil.salvar(vm.perfil)\" \nacao-editar=\"vm.metodosPerfil.editar(vm.perfil)\" acao-excluir=\"vm.metodosPerfil.excluir(vm.perfil)\" \nconstruir-dt-options=\"vm.metodosPerfil.construirDtOptions()\" metodos-externos=\"vm.metodosExternosPgToolbar\" \ncampo-pesquisar=\"vm.pesquisar\"></pg-toolbar><md-content layout-padding ng-hide=\"vm.controleForm.listarTodasEntidades\" \nng-disabled=\"vm.controleForm.emProgresso\"><div class=\"form-container\"><div layout-gt-xs=\"row\"><div layout=\"row\">\n<md-input-container class=\"md-block\" flex-gt-sm><label translate=\"PERFIL.CODIGO\"></label><input type=\"text\" \nng-model=\"vm.perfil.codigo\" name=\"perfilCodigo\" mascara-numero-generica=\"#####\" \nng-required=\"vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\"><div \nng-messages=\"perfilForm.perfilCodigo.$error\"><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container><proximo-codigo \nng-show=\"vm.controleForm.inserirAtivo\" rota=\"vm.rota\" entidade-codigo=\"vm.perfil.codigo\" \npre-loader-toolbar=\"vm.controleForm.preLoaderToolbar\"></proximo-codigo></div><md-input-container class=\"md-block\" \nflex-offset-gt-sm=\"5\" flex-gt-sm><label translate=\"PERFIL.DESCRICAO\"></label><input type=\"text\" \nng-model=\"vm.perfil.descricao\" name=\"perfilDescricao\" mascara-tamanho-campo=\"100\" \nng-required=\"vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo\" md-maxlength=\"100\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\"><div \nng-messages=\"perfilForm.perfilDescricao.$error\"><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container></div></div></md-content></form>\n</div>");
$templateCache.put("app/main/geral/cadastro/usuario/perfil/views/perfil.html","<div id=\"perfil\" class=\"page-layout simple tabbed\" layout=\"column\"><header-padrao translate-nome=\"PERFIL.PERFIL\" \nicone=\"icon-equal-box\" liberar-pesquisa-quando-datatable-ativo=\"vm.controleForm.listarTodasEntidades\" \npesquisar=\"vm.pesquisar\"></header-padrao><div class=\"content\"><div ui-view=\"perfil-form\"></div></div><div \nui-view=\"perfis-tabela\" ng-if=\"vm.controleForm.listarTodasEntidades\"></div></div>");
$templateCache.put("app/main/geral/cadastro/usuario/perfil/views/perfis-tabela.html","<div layout=\"column\" flex><div class=\"md-padding md-background-bg md-whiteframe-1dp fullpage-datatable\" \nlayout=\"column\" flex><table class=\"dataTable row-border hover\" id=\"datatable-perfil\" width=\"100%\"><thead><tr><th>Ação\n</th><th>Código</th><th>Descrição</th></tr></thead></table></div></div>");
$templateCache.put("app/main/geral/cadastro/usuario/setor/views/setor-form.html","<div class=\"md-background-bg md-whiteframe-1dp\"><form name=\"setorForm\" novalidate><pg-toolbar entidades=\"vm.setores\" \nentidade=\"vm.setor\" entidade-de-envio=\"vm.entidadeDeEnvio\" controlador-toolbar=\"vm.controleForm\" \nacao-pesquisar=\"vm.metodosSetor.pesquisar()\" acao-criar=\"vm.metodosSetor.salvar(vm.setor)\" \nacao-editar=\"vm.metodosSetor.editar(vm.setor)\" acao-excluir=\"vm.metodosSetor.excluir(vm.setor)\" \nconstruir-dt-options=\"vm.metodosSetor.construirDtOptions()\" metodos-externos=\"vm.metodosExternosPgToolbar\" \ncampo-pesquisar=\"vm.pesquisar\"></pg-toolbar><md-content layout-padding ng-hide=\"vm.controleForm.listarTodasEntidades\" \nng-disabled=\"vm.controleForm.emProgresso\"><div class=\"form-container\"><div layout-gt-xs=\"row\"><div layout=\"row\">\n<md-input-container class=\"md-block\" flex-gt-sm><label translate=\"SETOR.CODIGO\"></label><input type=\"text\" \nng-model=\"vm.setor.codigo\" name=\"setorCodigo\" mascara-numero-generica=\"#####\" \nng-required=\"vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\"><div \nng-messages=\"setorForm.setorCodigo.$error\"><div ng-message=\"required\" translate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\">\n</div></div></md-input-container><proximo-codigo ng-show=\"vm.controleForm.inserirAtivo\" rota=\"vm.rota\" \nentidade-codigo=\"vm.setor.codigo\" pre-loader-toolbar=\"vm.controleForm.preLoaderToolbar\"></proximo-codigo></div>\n<md-input-container class=\"md-block\" flex-offset-gt-sm=\"5\" flex-gt-sm><label translate=\"SETOR.DESCRICAO\"></label><input\n type=\"text\" ng-model=\"vm.setor.descricao\" name=\"setorDescricao\" mascara-tamanho-campo=\"50\" \nng-required=\"vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo\" md-maxlength=\"50\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\"><div \nng-messages=\"setorForm.setorDescricao.$error\"><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container><md-input-container class=\"md-block\" \nflex-offset-gt-sm=\"5\" flex><label translate=\"SETOR.USUARIOS\"></label><md-select ng-model=\"vm.setor.usuarios\" \nname=\"setorUsuarios\" multiple=\"multiple\" ng-model-options=\"{trackBy: \'$value.codigo\'}\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\"><md-option\n ng-value=\"usuario\" ng-repeat=\"usuario in vm.usuarios\">{{usuario.login}}</md-option></md-select></md-input-container>\n</div></div></md-content></form></div>");
$templateCache.put("app/main/geral/cadastro/usuario/setor/views/setor.html","<div id=\"setor\" class=\"page-layout simple tabbed\" layout=\"column\"><header-padrao translate-nome=\"SETOR.SETOR\" \nicone=\"icon-domain\" liberar-pesquisa-quando-datatable-ativo=\"vm.controleForm.listarTodasEntidades\" \npesquisar=\"vm.pesquisar\"></header-padrao><div class=\"content\"><div ui-view=\"setor-form\"></div></div><div \nui-view=\"setores-tabela\" ng-if=\"vm.controleForm.listarTodasEntidades\"></div></div>");
$templateCache.put("app/main/geral/cadastro/usuario/setor/views/setores-tabela.html","<div layout=\"column\" flex><div class=\"md-padding md-background-bg md-whiteframe-1dp fullpage-datatable\" \nlayout=\"column\" flex><table class=\"dataTable row-border hover\" id=\"datatable-setor\" width=\"100%\"><thead><tr><th>Ação\n</th><th>Código</th><th>Descrição</th></tr></thead></table></div></div>");
$templateCache.put("app/main/geral/cadastro/equipamento/equipamento-tipo/views/equipamento-tipo-form.html","<div class=\"md-background-bg md-whiteframe-1dp\"><form name=\"vm.form\" novalidate><pg-toolbar \nentidades=\"vm.equipamentoTipos\" entidade=\"vm.equipamentoTipo\" entidade-de-envio=\"vm.entidadeDeEnvio\" \ncontrolador-toolbar=\"vm.controleForm\" acao-pesquisar=\"vm.metodos.pesquisar()\" \nacao-criar=\"vm.metodos.salvar(vm.equipamentoTipo)\" acao-editar=\"vm.metodos.editar(vm.equipamentoTipo)\" \nacao-excluir=\"vm.metodos.excluir(vm.equipamentoTipo)\" construir-dt-options=\"vm.metodos.construirDtOptions()\" \nmetodos-externos=\"vm.metodosExternosPgToolbar\" campo-pesquisar=\"vm.pesquisar\"></pg-toolbar><md-content layout-padding \nng-hide=\"vm.controleForm.listarTodasEntidades\" ng-disabled=\"vm.controleForm.emProgresso\"><div class=\"form-container\">\n<div layout-gt-xs=\"row\"><md-input-container class=\"md-block\" flex><label translate=\"EQUIPAMENTO_TIPO.DESCRICAO\">\n</label><input type=\"text\" ng-model=\"vm.equipamentoTipo.descricao\" name=\"descricao\" mascara-tamanho-campo=\"100\" \nng-required=\"vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo\" md-maxlength=\"100\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\"><div \nng-messages=\"vm.form.descricao.$error\"><div ng-message=\"required\" translate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\">\n</div></div></md-input-container></div></div></md-content></form></div>");
$templateCache.put("app/main/geral/cadastro/equipamento/equipamento-tipo/views/equipamento-tipo.html","<div id=\"equipamento-tipo\" class=\"page-layout simple tabbed\" layout=\"column\"><header-padrao \ntranslate-nome=\"EQUIPAMENTO_TIPO.EQUIPAMENTO_TIPO\" \nliberar-pesquisa-quando-datatable-ativo=\"vm.controleForm.listarTodasEntidades\" pesquisar=\"vm.pesquisar\">\n</header-padrao><div class=\"content\"><div ui-view=\"equipamento-tipo-form\"></div></div><div \nui-view=\"equipamento-tipos-tabela\" ng-if=\"vm.controleForm.listarTodasEntidades\"></div></div>");
$templateCache.put("app/main/geral/cadastro/equipamento/equipamento-tipo/views/equipamento-tipos-tabela.html","<div layout=\"column\" flex><div class=\"md-padding md-background-bg md-whiteframe-1dp fullpage-datatable\" \nlayout=\"column\" flex><table class=\"dataTable row-border hover\" id=\"datatable-equipamento-tipo\" width=\"100%\"><thead><tr>\n<th>Ação</th><th>Descrição</th></tr></thead></table></div></div>");
$templateCache.put("app/main/geral/cadastro/usuario/usuario/views/usuario-form.html","<div class=\"md-background-bg md-whiteframe-1dp\"><form name=\"vm.form.colaborador\" validate><pg-toolbar \nentidades=\"vm.usuarios\" entidade=\"vm.usuario\" entidade-de-envio=\"vm.entidadeDeEnvio\" \ncontrolador-toolbar=\"vm.controleForm\" controlador-pre-loader=\"controladorPreLoader\" \nacao-pesquisar=\"vm.metodosUsuario.pesquisar()\" acao-criar=\"vm.metodosUsuario.salvar(vm.usuario)\" \nacao-editar=\"vm.metodosUsuario.editar(vm.usuario)\" construir-dt-options=\"vm.metodosUsuario.construirDtOptions()\" \nmetodos-externos=\"vm.metodosExternosPgToolbar\" campo-pesquisar=\"vm.pesquisar\" \npre-definir-campos-para-insercao=\"vm.metodosUsuario.preDefinirParaInsercao()\" \ndesabilitar-botao-salvar=\"vm.form.colaborador.horaFim.$error.hora \" \ndesabilitar-botao-inserir=\"vm.tabSelecionada != \'colaborador\'\" \ndesabilitar-botao-editar=\"vm.tabSelecionada != \'colaborador\' && vm.tabSelecionada != \'permissoes\'\" \nesconder-botao-excluir=\"true\" desabilitar-botao-nova-pesquisa=\"vm.controleUsuario.controladorDetalhesUsuario\" \ndesabilitar-botao-atualizar=\"vm.controleUsuario.controladorDetalhesUsuario\" \ndesabilitar-botao-listar-todas-entidades=\"vm.controleUsuario.controladorDetalhesUsuario\" \ndesabilitar-botoes-navegacao=\"vm.controleUsuario.controladorDetalhesUsuario\"></pg-toolbar><md-content layout-padding \nng-hide=\"vm.controleForm.listarTodasEntidades\" ng-disabled=\"vm.controleForm.emProgresso\"><md-tabs md-dynamic-height \nmd-border-bottom><md-tab label=\"Colaborador\" md-active=\"vm.tabSelecionada === \'colaborador\'\" \nng-disabled=\"vm.controleUsuario.controladorDetalhesUsuario\" \nmd-on-select=\"vm.metodosGeral.tabSelecionada(\'colaborador\')\"><md-tab-label><label translate=\"COLABORADOR.COLABORADOR\">\nColaborador</label></md-tab-label><md-tab-body><div ng-include=\"vm.htmlRota.tabs.tabUsuario.tab\"></div></md-tab-body>\n</md-tab><md-tab label=\"Colaborador\" md-on-select=\"vm.metodosGeral.tabSelecionada(\'detalhesColaborador\')\" \nng-disabled=\"!vm.controleForm.pesquisaAtiva || vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo\">\n<md-tab-label><label translate=\"COLABORADOR.DETALHES_COLABORADOR\"></label></md-tab-label><md-tab-body><div \nng-if=\"vm.tabSelecionada == \'detalhesColaborador\'\" ng-include=\"vm.htmlRota.tabs.detalhes_usuario\"></div></md-tab-body>\n</md-tab><md-tab label=\"Colaborador\" md-on-select=\"vm.metodosGeral.tabSelecionada(\'contatoColaborador\')\" \nng-disabled=\"!vm.controleForm.pesquisaAtiva || vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo\">\n<md-tab-label><label translate=\"COLABORADOR.CONTATO_COLABORADOR\"></label></md-tab-label><md-tab-body><div \nng-if=\"vm.tabSelecionada == \'contatoColaborador\'\" ng-include=\"vm.htmlRota.tabs.contato_usuario\"></div></md-tab-body>\n</md-tab><md-tab label=\"Colaborador\" md-on-select=\"vm.metodosGeral.tabSelecionada(\'enderecoColaborador\')\" \nng-disabled=\"!vm.controleForm.pesquisaAtiva || vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo\">\n<md-tab-label><label translate=\"COLABORADOR.ENDERECO_COLABORADOR\"></label></md-tab-label><md-tab-body><div \nng-if=\"vm.tabSelecionada == \'enderecoColaborador\'\" ng-include=\"vm.htmlRota.tabs.endereco_usuario\"></div></md-tab-body>\n</md-tab><md-tab label=\"Permissões de acesso\" md-on-select=\"vm.metodosGeral.tabSelecionada(\'permissoes\')\" \nng-disabled=\"!vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\">\n<md-tab-label><label translate=\"COLABORADOR.PERMISSOES_ACESSO\"></label></md-tab-label><md-tab-body><div \nng-if=\"vm.tabSelecionada == \'permissoes\'\" ng-include=\"vm.htmlRota.tabs.permissoes_acesso\"></div></md-tab-body></md-tab>\n</md-tabs></md-content></form></div>");
$templateCache.put("app/main/geral/cadastro/usuario/usuario/views/usuario.html","<div id=\"usuario\" class=\"page-layout simple tabbed\" layout=\"column\"><header-padrao \ntranslate-nome=\"COLABORADOR.COLABORADOR\" icone=\"icon-account\" \nliberar-pesquisa-quando-datatable-ativo=\"vm.controleForm.listarTodasEntidades\" pesquisar=\"vm.pesquisar\">\n</header-padrao><div class=\"content\"><div ui-view=\"usuario-form\"></div></div><div ui-view=\"usuarios-tabela\" \nng-if=\"vm.controleForm.listarTodasEntidades\"></div></div>");
$templateCache.put("app/main/geral/cadastro/usuario/usuario/views/usuarios-tabela.html","<div layout=\"column\" flex><div class=\"md-padding md-background-bg md-whiteframe-1dp fullpage-datatable\" \nlayout=\"column\" flex><table class=\"dataTable row-border hover\" id=\"datatable-usuario\" width=\"100%\"><thead><tr><th>Ação\n</th><th>Código</th><th>Nome</th><th>Setor</th><th>Perfil</th></tr></thead></table></div></div>");
$templateCache.put("app/main/implantacao-migracao/processamento/processos-funis/processo-funil/views/processo-funil-form.html","<div id=\"board\" class=\"board\" ng-model=\"vm.tarefasProcesso\" layout=\"row\" flex><div class=\"list-wrapper\" \nng-repeat=\"tarefa in vm.tarefasProcesso\"><div class=\"list md-whiteframe-1dp\" layout=\"column\"><div class=\"list-header\" \nlayout=\"row\" layout-align=\"center center\"><div class=\"list-header-name text-center\" ng-if=\"!tarefa.permiteAlteracao\" \nflex><span>{{tarefa.descricao}}</span></div><div class=\"list-header-name text-center\" ng-if=\"tarefa.permiteAlteracao\" \nflex><span>{{tarefa.nivel}} - {{tarefa.descricao}}</span></div></div><div class=\"list-content\" layout=\"column\"><div \nclass=\"list-cards\" ng-model=\"tarefa.subProcessos\" ui-sortable=\"vm.opcoesCardOrdenavel\" ms-scroll><div \nclass=\"list-card md-whiteframe-2dp\" ng-dblclick=\"vm.metodos.abrirDialogSubprocesso($event, subprocesso)\" \nng-repeat=\"subprocesso in tarefa.subProcessos\"><div class=\"list-card-details\"><div id=\"list-card-icon-handle\" \nclass=\"list-card-sort-handle\"><md-icon md-font-icon=\"icon-cursor-move\" class=\"icon s16\"></md-icon></div><div \nclass=\"list-card-name text-center\">{{subprocesso.cliente.nome | uppercase}}</div><div id=\"list-card-responsavel\" \nclass=\"list-card-badges mt-5\" layout=\"row\" layout-align=\"start center\" ng-if=\"true\"><span layout=\"row\" \nclass=\"list-card-name\" layout-align=\"start center\"><i class=\"icon-account s16\"></i> <span>\nExec. de Contas: {{subprocesso.executivoContasResponsavel.login}}</span></span></div><div id=\"list-card-responsavel\" \nclass=\"list-card-badges mt-5\" layout=\"row\" layout-align=\"start center\" ng-if=\"true\"><span layout=\"row\" \nclass=\"list-card-name\" layout-align=\"start center\"><i class=\"icon-account s16\"></i> <span>\nTécnico: {{subprocesso.tecnicoResponsavel.login}}</span></span></div><div id=\"list-card-datas\" \nclass=\"list-card-badges\" layout=\"row\" layout-align=\"start center\"><span class=\"badge due-date\" layout=\"row\" \nlayout-align=\"start center\"><i class=\"icon-clock s16\"></i> <span>\nInicio: {{subprocesso.dataInicial | date:\'dd/MM/yyyy\'}}</span> </span><span class=\"badge due-date\" \nng-class=\"{\'overdue\': vm.metodosImplantacaoMigracaoService.verificarData(subprocesso.dataFinalTarefa)}\" layout=\"row\" \nlayout-align=\"start center\"><i class=\"icon-clock s16\"></i> <span ng-if=\"subprocesso.codigoTarefaAtual != 1\">\nVencimento: {{subprocesso.dataFinalTarefa | date:\'dd/MM/yyyy\'}}</span> <span \nng-if=\"subprocesso.codigoTarefaAtual == 1\">PAUSA</span></span></div><div ng-if=\"subprocesso.codigoTarefaAtual != 1\" \nlayout=\"row\" layout-align=\"start center\" flex><md-input-container class=\"md-block m-0 p-0\"><md-checkbox \nng-model=\"subprocesso.tarefaFinalizada\" ng-change=\"vm.metodos.changeTarefaFinalizada(subprocesso.tarefaFinalizada)\" \naria-label=\"Tarefa finalizada\"><span class=\"text-bold\" translate=\"Tarefa finalizada\">Tarefa finalizada</span>\n</md-checkbox></md-input-container></div></div><div id=\"list-card-atendimento\" class=\"list-card-footer\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"list-card-badges\" layout=\"row\" layout-align=\"start center\" flex><span \nlayout=\"row\" class=\"list-card-name\" style=\"font-size:14px !important\" layout-align=\"start center\" \nng-if=\"subprocesso.codigoAtendimento && subprocesso.anoAtendimento\" flex><i class=\"icon-phone s16\"></i> <span \nclass=\"ml-5\">Atendimento: {{subprocesso.codigoAtendimento + \"/\" + subprocesso.anoAtendimento}}</span> </span><span \nlayout=\"row\" class=\"list-card-name\" style=\"font-size:14px !important\" layout-align=\"end center\" \nng-if=\"subprocesso.codigoAtendimento && subprocesso.anoAtendimento\" \nng-click=\"vm.metodosImplantacaoMigracaoService.navegarParaAtendimento(subprocesso.codigoAtendimento, subprocesso.anoAtendimento)\">\n<i class=\"icon-arrow-right-bold-hexagon-outline s22\"></i><md-tooltip><span \ntranslate=\"PIPELINE_NEGOCIO.NAVEGAR_PARA_ATENDIMENTO\"></span></md-tooltip></span></div></div></div></div></div></div>\n</div></div><div id=\"resultados\" class=\"board\" layout=\"row\" flex=\"30\" ng-show=\"vm.arrastandoSubprocesso\"><div \nclass=\"list-wrapper\" ng-repeat=\"resultado in vm.resultadosSubprocesso track by resultado.codigo\" layout=\"row\" \nflex=\"100\"><div class=\"list\" \nng-class=\"{\'subprocesso-finalizado\': (resultado.codigo == 2), \'subprocesso-cancelado\': (resultado.codigo == 3)}\" \nlayout=\"column\" flex=\"50\" layout-align=\"start center\"><span class=\"title-header\">{{resultado.descricao}}</span><div \nclass=\"list-content\" layout=\"column\"><div class=\"list-cards\" ng-model=\"resultado.subprocessos\" \nui-sortable=\"vm.resultadoSubprocesso\"><div class=\"list-card md-whiteframe-2dp\" \nng-repeat=\"subprocesso in resultado.subprocessos\"></div></div></div></div></div></div>");
$templateCache.put("app/main/implantacao-migracao/processamento/processos-funis/processo-funil/views/processo-funil.html","<div id=\"pipeline-negocio\" class=\"page-layout simple fullwidth\" layout=\"column\"><div class=\"header md-accent-bg\" \nlayout=\"column\"><div class=\"header-content\" layout=\"row\" layout-wrap layout-align=\"space-between\" flex><div \nlayout=\"row\" layout-align=\"center center\" flex-order=\"1\" flex-order-xs=\"2\"><md-button \nclass=\"md-accent md-raised md-hue-2 header-boards-button\" \nui-sref=\"app.implantacaomigracao_processamento_processosfunis\" aria-label=\"Voltar\" translate \ntranslate-attr-aria-label=\"Voltar\"><md-icon md-font-icon=\"icon-chevron-double-left\" class=\"icon\"></md-icon><span \ntranslate=\"Voltar\"></span></md-button></div><div class=\"header-board-name\" layout=\"row\" layout-align=\"center center\" \nflex-order=\"2\" flex-order-xs=\"1\" flex-xs=\"100\"><i ng-if=\"vm.board.settings.subscribed\" \nclass=\"board-subscribe s16 icon-eye\"></i> <span>{{vm.descricaoFunil | uppercase}}</span></div><div class=\"toolbar\" \nlayout=\"row\" layout-align=\"space-between center\" flex-order=\"3\"><div layout=\"row\" layout-align=\"center center\" \nflex-order=\"1\" flex-order-xs=\"2\"><md-button class=\"md-accent md-raised md-hue-2 header-boards-button\" \nng-click=\"vm.metodos.abrirDialogSubprocesso($event)\" aria-label=\"Adicionar subprocesso\" \ntranslate-attr-aria-label=\"ADICIONAR\"><md-icon md-font-icon=\"icon-plus\" class=\"icon\"></md-icon><span \ntranslate=\"ADICIONAR\"></span></md-button></div></div></div></div><md-content class=\"content\" flex layout=\"column\" \nui-view=\"processo-funil-form\"></md-content></div>");
$templateCache.put("app/main/locacao/cadastro/equipamentos/equipamento/views/equipamento-form.html","<div class=\"md-background-bg md-whiteframe-1dp\"><form name=\"vm.form\" novalidate><pg-toolbar \nentidades=\"vm.equipamentos\" entidade=\"vm.equipamento\" entidade-de-envio=\"vm.entidadeDeEnvio\" \ncontrolador-toolbar=\"vm.controleForm\" acao-pesquisar=\"vm.metodos.pesquisar()\" \nacao-criar=\"vm.metodos.salvar(vm.equipamento)\" acao-editar=\"vm.metodos.editar(vm.equipamento)\" \nacao-excluir=\"vm.metodos.excluir(vm.equipamento)\" construir-dt-options=\"vm.metodos.construirDtOptions()\" \nmetodos-externos=\"vm.metodosExternosPgToolbar\" campo-pesquisar=\"vm.pesquisar\"></pg-toolbar><md-content layout-padding \nng-hide=\"vm.controleForm.listarTodasEntidades\" ng-disabled=\"vm.controleForm.emProgresso\"><div class=\"form-container\">\n<div layout-gt-xs=\"row\"><md-input-container class=\"md-block\" flex flex-gt-sm=\"20\"><label \ntranslate=\"EQUIPAMENTO.FABRICANTE\">Fabricante</label><md-select ng-model=\"vm.equipamento.fabricanteId\" \nname=\"fabricanteId\" ng-required=\"vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo\" \nmd-on-open=\"vm.metodos.configuraMdSelectFabricante()\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\"><md-option\n ng-value=\"fabricante.id\" \nng-repeat=\"fabricante in vm.fabricantes | filter:vm.filtrarFabricantes track by fabricante.id\">{{fabricante.descricao}}\n</md-option></md-select><div ng-messages=\"vm.form.fabricanteId.$error\"><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container><md-input-container class=\"md-block\" \nflex-offset=\"5\" flex flex-gt-sm=\"20\"><label translate=\"EQUIPAMENTO.TIPO_EQUIPAMENTO\">Tipo Equipamento</label><md-select\n ng-model=\"vm.equipamento.equipamentoTipoId\" name=\"equipamentoTipoId\" \nng-required=\"vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo\" \nmd-on-open=\"vm.metodos.configuraMdSelectTipoEquipamento()\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\"><md-option\n ng-value=\"tipoEquipamento.id\" \nng-repeat=\"tipoEquipamento in vm.tiposEquipamento | filter:vm.filtrarTiposEquipamento track by tipoEquipamento.id\">\n{{tipoEquipamento.descricao}}</md-option></md-select><div ng-messages=\"vm.form.equipamentoTipoId.$error\"><div \nng-message=\"required\" translate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container>\n<md-input-container class=\"md-block\" flex-offset=\"5\" flex><label translate=\"EQUIPAMENTO.DESCRICAO\"></label><input \ntype=\"text\" ng-model=\"vm.equipamento.descricao\" name=\"descricao\" mascara-tamanho-campo=\"100\" \nng-required=\"vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo\" md-maxlength=\"100\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\"><div \nng-messages=\"vm.form.descricao.$error\"><div ng-message=\"required\" translate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\">\n</div></div></md-input-container></div></div></md-content></form></div>");
$templateCache.put("app/main/locacao/cadastro/equipamentos/equipamento/views/equipamento-tabela.html","<div layout=\"column\" flex><div class=\"md-padding md-background-bg md-whiteframe-1dp fullpage-datatable\" \nlayout=\"column\" flex><table class=\"dataTable row-border hover\" id=\"datatable-equipamento-locacao\" width=\"100%\"><thead>\n<tr><th>Ação</th><th>Fabricante</th><th>Tipo Equipamento</th><th>Descrição</th></tr></thead></table></div></div>");
$templateCache.put("app/main/locacao/cadastro/equipamentos/equipamento/views/equipamento.html","<div id=\"equipamento-locacao\" class=\"page-layout simple tabbed\" layout=\"column\"><header-padrao \ntranslate-nome=\"EQUIPAMENTO.EQUIPAMENTO\" \nliberar-pesquisa-quando-datatable-ativo=\"vm.controleForm.listarTodasEntidades\" pesquisar=\"vm.pesquisar\">\n</header-padrao><div class=\"content\"><div ui-view=\"equipamento-form\"></div></div><div ui-view=\"equipamento-tabela\" \nng-if=\"vm.controleForm.listarTodasEntidades\"></div></div>");
$templateCache.put("app/main/locacao/cadastro/equipamentos/equipamento-estado-conservacao/views/equipamento-estado-conservacao-form.html","<div class=\"md-background-bg md-whiteframe-1dp\"><form name=\"vm.form\" novalidate><pg-toolbar \nentidades=\"vm.equipamentoSituacoes\" entidade=\"vm.equipamentoEstadoConservacao\" entidade-de-envio=\"vm.entidadeDeEnvio\" \ncontrolador-toolbar=\"vm.controleForm\" acao-pesquisar=\"vm.metodos.pesquisar(vm.equipamentoEstadoConservacao)\" \nacao-criar=\"vm.metodos.salvar(vm.equipamentoEstadoConservacao)\" \nacao-editar=\"vm.metodos.editar(vm.equipamentoEstadoConservacao)\" \nacao-excluir=\"vm.metodos.excluir(vm.equipamentoEstadoConservacao)\" \nconstruir-dt-options=\"vm.metodos.construirDtOptions()\" \npre-definir-campos-para-insercao=\"vm.metodos.predefinirCamposInsercao()\" \nmetodos-externos=\"vm.metodosExternosPgToolbar\" campo-pesquisar=\"vm.pesquisar\"></pg-toolbar><md-content layout-padding \nng-hide=\"vm.controleForm.listarTodasEntidades\" ng-disabled=\"vm.controleForm.emProgresso\"><div class=\"form-container\" \nflex-gt-sm=\"100\"><div layout-gt-xs=\"row\"><md-input-container class=\"md-block\" flex-gt-sm=\"85\"><label \ntranslate=\"Descrição\" style=\"text-align: left\"></label><input type=\"text\" \nng-model=\"vm.equipamentoEstadoConservacao.descricao\" name=\"descricao\" mascara-tamanho-campo=\"100\" \nng-required=\"vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo\" md-maxlength=\"100\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\"><div \nng-messages=\"vm.form.descricao.$error\"><div ng-message=\"required\" translate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\">\n</div></div></md-input-container><div class=\"md-block ml-15 mt-20\" flex-gt-sm=\"15\"><md-checkbox \naria-label=\"Selecionado\" ng-model=\"vm.equipamentoEstadoConservacao.obrigaFoto\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\" flex>\n</md-checkbox><span class=\"float-label-cor-default\" translate=\"Obrigar foto\"></span></div></div></div></md-content>\n</form></div>");
$templateCache.put("app/main/locacao/cadastro/equipamentos/equipamento-estado-conservacao/views/equipamento-estado-conservacao-tabela.html","<div layout=\"column\" flex><div class=\"md-padding md-background-bg md-whiteframe-1dp fullpage-datatable\" \nlayout=\"column\" flex><table class=\"dataTable row-border hover\" id=\"datatable-estado-conservacao\" width=\"100%\"><thead>\n<tr><th>Ação</th><th>Descrição</th></tr></thead></table></div></div>");
$templateCache.put("app/main/locacao/cadastro/equipamentos/equipamento-estado-conservacao/views/equipamento-estado-conservacao.html","<div id=\"equipamento-tipo\" class=\"page-layout simple tabbed\" layout=\"column\"><header-padrao \ntranslate-nome=\"Estado conservação\" liberar-pesquisa-quando-datatable-ativo=\"vm.controleForm.listarTodasEntidades\" \npesquisar=\"vm.pesquisar\"></header-padrao><div class=\"content\"><div ui-view=\"equipamento-estado-conservacao-form\"></div>\n</div><div ui-view=\"equipamento-estado-conservacao-tabela\" ng-if=\"vm.controleForm.listarTodasEntidades\"></div></div>");
$templateCache.put("app/main/locacao/cadastro/equipamentos/equipamento-fornecedor/views/equipamento-fornecedor-form.html","<div class=\"md-background-bg md-whiteframe-1dp\"><form name=\"vm.form\" novalidate><pg-toolbar \nentidades=\"vm.equipamentoFornecedores\" entidade=\"vm.equipamentoFornecedor\" entidade-de-envio=\"vm.entidadeDeEnvio\" \ncontrolador-toolbar=\"vm.controleForm\" acao-pesquisar=\"vm.metodos.pesquisar()\" \nacao-criar=\"vm.metodos.salvar(vm.equipamentoFornecedor)\" acao-editar=\"vm.metodos.editar(vm.equipamentoFornecedor)\" \nacao-excluir=\"vm.metodos.excluir(vm.equipamentoFornecedor)\" construir-dt-options=\"vm.metodos.construirDtOptions()\" \nmetodos-externos=\"vm.metodosExternosPgToolbar\" campo-pesquisar=\"vm.pesquisar\"></pg-toolbar><md-content layout-padding \nng-hide=\"vm.controleForm.listarTodasEntidades\" ng-disabled=\"vm.controleForm.emProgresso\"><div class=\"form-container\">\n<div layout-gt-xs=\"row\"><md-input-container class=\"md-block\" flex><label translate=\"Descrição\"></label><input \ntype=\"text\" ng-model=\"vm.equipamentoFornecedor.descricao\" name=\"descricao\" mascara-tamanho-campo=\"100\" \nng-required=\"vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo\" md-maxlength=\"100\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\"><div \nng-messages=\"vm.form.descricao.$error\"><div ng-message=\"required\" translate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\">\n</div></div></md-input-container></div></div></md-content></form></div>");
$templateCache.put("app/main/locacao/cadastro/equipamentos/equipamento-fornecedor/views/equipamento-fornecedor-tabela.html","<div layout=\"column\" flex><div class=\"md-padding md-background-bg md-whiteframe-1dp fullpage-datatable\" \nlayout=\"column\" flex><table class=\"dataTable row-border hover\" id=\"datatable-fornecedor-locacao\" width=\"100%\"><thead>\n<tr><th>Ação</th><th>Descrição</th></tr></thead></table></div></div>");
$templateCache.put("app/main/locacao/cadastro/equipamentos/equipamento-fornecedor/views/equipamento-fornecedor.html","<div id=\"equipamento-fornecedor-locacao\" class=\"page-layout simple tabbed\" layout=\"column\"><header-padrao \ntranslate-nome=\"Fornecedor\" liberar-pesquisa-quando-datatable-ativo=\"vm.controleForm.listarTodasEntidades\" \npesquisar=\"vm.pesquisar\"></header-padrao><div class=\"content\"><div ui-view=\"equipamento-fornecedor-form\"></div></div>\n<div ui-view=\"equipamento-fornecedor-tabela\" ng-if=\"vm.controleForm.listarTodasEntidades\"></div></div>");
$templateCache.put("app/main/locacao/cadastro/equipamentos/equipamento-fabricante/views/equipamento-fabricante-form.html","<div class=\"md-background-bg md-whiteframe-1dp\"><form name=\"vm.form\" novalidate><pg-toolbar \nentidades=\"vm.equipamentoFabricantes\" entidade=\"vm.equipamentoFabricante\" entidade-de-envio=\"vm.entidadeDeEnvio\" \ncontrolador-toolbar=\"vm.controleForm\" acao-pesquisar=\"vm.metodos.pesquisar()\" \nacao-criar=\"vm.metodos.salvar(vm.equipamentoFabricante)\" acao-editar=\"vm.metodos.editar(vm.equipamentoFabricante)\" \nacao-excluir=\"vm.metodos.excluir(vm.equipamentoFabricante)\" construir-dt-options=\"vm.metodos.construirDtOptions()\" \nmetodos-externos=\"vm.metodosExternosPgToolbar\" campo-pesquisar=\"vm.pesquisar\"></pg-toolbar><md-content layout-padding \nng-hide=\"vm.controleForm.listarTodasEntidades\" ng-disabled=\"vm.controleForm.emProgresso\"><div class=\"form-container\">\n<div layout-gt-xs=\"row\"><md-input-container class=\"md-block\" flex><label translate=\"Descrição\"></label><input \ntype=\"text\" ng-model=\"vm.equipamentoFabricante.descricao\" name=\"descricao\" mascara-tamanho-campo=\"100\" \nng-required=\"vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo\" md-maxlength=\"100\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\"><div \nng-messages=\"vm.form.descricao.$error\"><div ng-message=\"required\" translate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\">\n</div></div></md-input-container></div></div></md-content></form></div>");
$templateCache.put("app/main/locacao/cadastro/equipamentos/equipamento-fabricante/views/equipamento-fabricante-tabela.html","<div layout=\"column\" flex><div class=\"md-padding md-background-bg md-whiteframe-1dp fullpage-datatable\" \nlayout=\"column\" flex><table class=\"dataTable row-border hover\" id=\"datatable-fabricante\" width=\"100%\"><thead><tr><th>\nAção</th><th>Descrição</th></tr></thead></table></div></div>");
$templateCache.put("app/main/locacao/cadastro/equipamentos/equipamento-fabricante/views/equipamento-fabricante.html","<div id=\"equipamento-fabricante\" class=\"page-layout simple tabbed\" layout=\"column\"><header-padrao \ntranslate-nome=\"Fabricante\" liberar-pesquisa-quando-datatable-ativo=\"vm.controleForm.listarTodasEntidades\" \npesquisar=\"vm.pesquisar\"></header-padrao><div class=\"content\"><div ui-view=\"equipamento-fabricante-form\"></div></div>\n<div ui-view=\"equipamento-fabricante-tabela\" ng-if=\"vm.controleForm.listarTodasEntidades\"></div></div>");
$templateCache.put("app/main/locacao/cadastro/equipamentos/equipamento-nota/views/equipamento-nota-form.html","");
$templateCache.put("app/main/locacao/cadastro/equipamentos/equipamento-nota/views/equipamento-nota-tabela.html","");
$templateCache.put("app/main/locacao/cadastro/equipamentos/equipamento-nota/views/equipamento-nota.html","");
$templateCache.put("app/main/locacao/cadastro/equipamentos/equipamento-situacao/views/equipamento-situacao-form.html","<div class=\"md-background-bg md-whiteframe-1dp\"><form name=\"vm.form\" novalidate><pg-toolbar \nentidades=\"vm.equipamentoSituacoes\" entidade=\"vm.equipamentoSituacao\" entidade-de-envio=\"vm.entidadeDeEnvio\" \ncontrolador-toolbar=\"vm.controleForm\" acao-pesquisar=\"vm.metodos.pesquisar()\" \nacao-criar=\"vm.metodos.salvar(vm.equipamentoSituacao)\" acao-editar=\"vm.metodos.editar(vm.equipamentoSituacao)\" \nacao-excluir=\"vm.metodos.excluir(vm.equipamentoSituacao)\" construir-dt-options=\"vm.metodos.construirDtOptions()\" \nmetodos-externos=\"vm.metodosExternosPgToolbar\" campo-pesquisar=\"vm.pesquisar\"></pg-toolbar><md-content layout-padding \nng-hide=\"vm.controleForm.listarTodasEntidades\" ng-disabled=\"vm.controleForm.emProgresso\"><div class=\"form-container\">\n<div layout-gt-xs=\"row\"><md-input-container class=\"md-block\" flex=\"60\"><label translate=\"Descrição\" \nstyle=\"text-align: left\"></label><input type=\"text\" ng-model=\"vm.equipamentoSituacao.descricao\" name=\"descricao\" \nmascara-tamanho-campo=\"100\" ng-required=\"vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo\" \nmd-maxlength=\"100\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\"><div \nng-messages=\"vm.form.descricao.$error\"><div ng-message=\"required\" translate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\">\n</div></div></md-input-container><div flex layout=\"row\"><md-input-container class=\"md-block\" flex><label>Peso</label>\n<input type=\"text\" ng-model=\"vm.equipamentoSituacao.peso\" name=\"peso\" mascara-numero-generica=\"#####\" maxlength=\"5\" \nng-disabled=\"!vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\"></md-input-container><md-icon \nmd-font-icon=\"icon-information-outline\" class=\"cor-icone-padrao\" style=\"margin-top: 25px\"><md-tooltip md-autohide \nmd-direction=\"top\"><span class=\"md-caption\">Utilizado para ordenação dos cards na rotina de \"Controle de equipamentos\"\n</span></md-tooltip></md-icon><md-input-container class=\"md-block\" flex=\"40\"><md-checkbox \nng-model=\"vm.equipamentoSituacao.finalizarProcesso\" aria-label=\"Finalizar processo\" name=\"finalizarProcesso\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\">\nFinalizar processo</md-checkbox></md-input-container></div></div></div></md-content></form></div>");
$templateCache.put("app/main/locacao/cadastro/equipamentos/equipamento-situacao/views/equipamento-situacao-tabela.html","<div layout=\"column\" flex><div class=\"md-padding md-background-bg md-whiteframe-1dp fullpage-datatable\" \nlayout=\"column\" flex><table class=\"dataTable row-border hover\" id=\"datatable-equipamento-situacao\" width=\"100%\"><thead>\n<tr><th>Ação</th><th>Descrição</th></tr></thead></table></div></div>");
$templateCache.put("app/main/locacao/cadastro/equipamentos/equipamento-situacao/views/equipamento-situacao.html","<div id=\"equipamento-tipo\" class=\"page-layout simple tabbed\" layout=\"column\"><header-padrao translate-nome=\"Situação\" \nliberar-pesquisa-quando-datatable-ativo=\"vm.controleForm.listarTodasEntidades\" pesquisar=\"vm.pesquisar\">\n</header-padrao><div class=\"content\"><div ui-view=\"equipamento-situacao-form\"></div></div><div \nui-view=\"equipamento-situacao-tabela\" ng-if=\"vm.controleForm.listarTodasEntidades\"></div></div>");
$templateCache.put("app/main/locacao/cadastro/equipamentos/equipamento-tipo/views/equipamento-tipo-form.html","<div class=\"md-background-bg md-whiteframe-1dp\"><form name=\"vm.form\" novalidate><pg-toolbar \nentidades=\"vm.equipamentoTipos\" entidade=\"vm.equipamentoTipo\" entidade-de-envio=\"vm.entidadeDeEnvio\" \ncontrolador-toolbar=\"vm.controleForm\" acao-pesquisar=\"vm.metodos.pesquisar()\" \nacao-criar=\"vm.metodos.salvar(vm.equipamentoTipo)\" acao-editar=\"vm.metodos.editar(vm.equipamentoTipo)\" \nacao-excluir=\"vm.metodos.excluir(vm.equipamentoTipo)\" construir-dt-options=\"vm.metodos.construirDtOptions()\" \nmetodos-externos=\"vm.metodosExternosPgToolbar\" campo-pesquisar=\"vm.pesquisar\"></pg-toolbar><md-content layout-padding \nng-hide=\"vm.controleForm.listarTodasEntidades\" ng-disabled=\"vm.controleForm.emProgresso\"><div class=\"form-container\">\n<div layout-gt-xs=\"row\"><md-input-container class=\"md-block\" flex><label translate=\"Descrição\" \nstyle=\"text-align: left\"></label><input type=\"text\" ng-model=\"vm.equipamentoTipo.descricao\" name=\"descricao\" \nmascara-tamanho-campo=\"100\" ng-required=\"vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo\" \nmd-maxlength=\"100\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\"><div \nng-messages=\"vm.form.descricao.$error\"><div ng-message=\"required\" translate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\">\n</div></div></md-input-container><md-input-container class=\"md-block\" flex-gt-sm=\"15\" flex><label \ntranslate=\"Depreciação (%)\"></label><input type=\"text\" ng-model=\"vm.equipamentoTipo.depreciacao\" \nname=\"equipamentoTipo\" max=\"1\" ng-required=\"vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo\" \nui-percentage-mask \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\" \nmascara-tamanho-campo=\"6\"><div ng-messages=\"vm.form.equipamentoTipo.$error\"><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div><div ng-message=\"max\" \ntranslate=\"Valor do campo não pode ser superior a 100%\"></div></div></md-input-container></div></div></md-content>\n</form></div>");
$templateCache.put("app/main/locacao/cadastro/equipamentos/equipamento-tipo/views/equipamento-tipo-tabela.html","<div layout=\"column\" flex><div class=\"md-padding md-background-bg md-whiteframe-1dp fullpage-datatable\" \nlayout=\"column\" flex><table class=\"dataTable row-border hover\" id=\"datatable-tipo\" width=\"100%\"><thead><tr><th>Ação\n</th><th>Descrição</th><th>Depreciação (%)</th></tr></thead></table></div></div>");
$templateCache.put("app/main/locacao/cadastro/equipamentos/equipamento-tipo/views/equipamento-tipo.html","<div id=\"equipamento-tipo\" class=\"page-layout simple tabbed\" layout=\"column\"><header-padrao translate-nome=\"Tipo\" \nliberar-pesquisa-quando-datatable-ativo=\"vm.controleForm.listarTodasEntidades\" pesquisar=\"vm.pesquisar\">\n</header-padrao><div class=\"content\"><div ui-view=\"equipamento-tipo-form\"></div></div><div \nui-view=\"equipamento-tipo-tabela\" ng-if=\"vm.controleForm.listarTodasEntidades\"></div></div>");
$templateCache.put("app/main/locacao/cadastro/equipamentos/equipamento-motivo-baixa/views/equipamento-motivo-baixa-form.html","<div class=\"md-background-bg md-whiteframe-1dp\"><form name=\"vm.form\" novalidate><pg-toolbar \nentidades=\"vm.equipamentoMotivoBaixas\" entidade=\"vm.equipamentoMotivoBaixa\" entidade-de-envio=\"vm.entidadeDeEnvio\" \ncontrolador-toolbar=\"vm.controleForm\" acao-pesquisar=\"vm.metodos.pesquisar()\" \nacao-criar=\"vm.metodos.salvar(vm.equipamentoMotivoBaixa)\" acao-editar=\"vm.metodos.editar(vm.equipamentoMotivoBaixa)\" \nacao-excluir=\"vm.metodos.excluir(vm.equipamentoMotivoBaixa)\" construir-dt-options=\"vm.metodos.construirDtOptions()\" \nmetodos-externos=\"vm.metodosExternosPgToolbar\" campo-pesquisar=\"vm.pesquisar\"></pg-toolbar><md-content layout-padding \nng-hide=\"vm.controleForm.listarTodasEntidades\" ng-disabled=\"vm.controleForm.emProgresso\"><div class=\"form-container\">\n<div layout-gt-xs=\"row\"><md-input-container class=\"md-block\" flex><label translate=\"Descrição\" \nstyle=\"text-align: left\"></label><input type=\"text\" ng-model=\"vm.equipamentoMotivoBaixa.descricao\" name=\"descricao\" \nmascara-tamanho-campo=\"100\" ng-required=\"vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo\" \nmd-maxlength=\"100\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\"><div \nng-messages=\"vm.form.descricao.$error\"><div ng-message=\"required\" translate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\">\n</div></div></md-input-container></div></div></md-content></form></div>");
$templateCache.put("app/main/locacao/cadastro/equipamentos/equipamento-motivo-baixa/views/equipamento-motivo-baixa-tabela.html","<div layout=\"column\" flex><div class=\"md-padding md-background-bg md-whiteframe-1dp fullpage-datatable\" \nlayout=\"column\" flex><table class=\"dataTable row-border hover\" id=\"datatable-motivo-baixa\" width=\"100%\"><thead><tr><th>\nAção</th><th>Descrição</th></tr></thead></table></div></div>");
$templateCache.put("app/main/locacao/cadastro/equipamentos/equipamento-motivo-baixa/views/equipamento-motivo-baixa.html","<div id=\"equipamento-tipo\" class=\"page-layout simple tabbed\" layout=\"column\"><header-padrao \ntranslate-nome=\"Motivo baixa\" liberar-pesquisa-quando-datatable-ativo=\"vm.controleForm.listarTodasEntidades\" \npesquisar=\"vm.pesquisar\"></header-padrao><div class=\"content\"><div ui-view=\"equipamento-motivo-baixa-form\"></div></div>\n<div ui-view=\"equipamento-motivo-baixa-tabela\" ng-if=\"vm.controleForm.listarTodasEntidades\"></div></div>");
$templateCache.put("app/main/locacao/consulta/controle-equipamento/views/dialog-situacao/dialog-situacao.html","<div class=\"dialog\" id=\"equipamento-tipo\"><form name=\"vm.form\" class=\"form-dialog\"><md-dialog style=\"max-width: 100%\">\n<md-toolbar><div class=\"md-toolbar-tools\" style=\"background-color: #039BE5\"><h2>Detalhes por situação</h2><span flex>\n</span><md-button class=\"md-icon-button\" ng-click=\"vm.metodos.fecharDialog()\" aria-label=\"Fechar dialog\" translate \ntranslate-attr-aria-label=\"CLIENTE.FECHAR_DIALOG\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content style=\"overflow-y: scroll;max-height: 80vh\" id=\"historico-detalhe\"><div \nlayout=\"column\" class=\"tabela\" ng-repeat=\"equipamento in vm.equipamentosRetorno\"><div layout=\"row\" \nstyle=\"align-items: center\"><span class=\"span\">Situação:</span><p class=\"estadoConservacao\">\n{{ equipamento[0].equipamentoSituacaoDescricao }}</p></div><table class=\"dataTable row-border hover\" datatable=\"ng\" \ndt-options=\"vm.dtOptions\" style=\"width: 100%\"><thead class=\"table-header\"><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Fabricante</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Descrição</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Quantidade</span></div></th></thead><tbody><tr \nng-repeat=\"item in equipamento\"><td>{{ item.equipamentoFabricanteDescricao }}</td><td>\n{{ item.equipamentoTipoDescricao }}</td><td>{{ item.quantidade }}</td></tr></tbody></table></div></md-dialog-content>\n</md-dialog></form></div>");
$templateCache.put("app/main/locacao/consulta/controle-equipamento/views/dialog-situacao-fabricante/dialog-situacao-fabricante.html","<div id=\"dialog-situacao-fabricante\" class=\"dialog\"><md-dialog style=\"max-width: 100%\"><md-toolbar><div \nclass=\"md-toolbar-tools\" style=\"background-color: #039BE5\"><h2>{{ vm.tituloDialog }}</h2><span flex></span><md-button \nclass=\"md-icon-button\" ng-click=\"vm.metodos.fecharDialog()\" aria-label=\"Fechar dialog\" translate \ntranslate-attr-aria-label=\"CLIENTE.FECHAR_DIALOG\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content><table class=\"dataTable row-border hover\" datatable=\"ng\" dt-options=\"vm.dtOptions\" \nstyle=\"width: 100%\"><thead class=\"table-header\"><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Fabricante</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Descrição</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Quantidade</span></div></th><th class=\"secondary-text none\"><div class=\"table-header\"><span \nclass=\"column-title\"></span></div></th></thead><tbody><tr ng-repeat=\"equipamento in vm.equipamentosFabricantes\"><td>\n{{ equipamento.fabricanteDescricao }}</td><td>{{ equipamento.tipoDescricao }}</td><td>{{ equipamento.quantidade }}</td>\n<td><table class=\"dataTable row-border hover\" style=\"width: 100%\"><thead class=\"table-header tabela-secundaria\"><th \nclass=\"secondary-text\" style=\"width: 30%\"><div class=\"table-header\"><span class=\"column-title\">Descrição</span></div>\n</th><th class=\"secondary-text\" style=\"width: 30%\"><div class=\"table-header\"><span class=\"column-title\">Número de série\n</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">IMEI</span></div>\n</th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Estado de conservação</span></div>\n</th></thead><tbody><tr ng-repeat=\"detalhe in equipamento.equipamentosDetalhes | orderBy: \'descricao\'\"><td \nstyle=\"width: 30%\">{{ detalhe.descricao }}</td><td style=\"width: 30%\">{{ detalhe.numeroSerie }}</td><td>\n{{ detalhe.imei }}</td><td>{{ detalhe.estadoConservacao }}</td></tr></tbody></table></td></tr></tbody></table>\n</md-dialog-content></md-dialog></div>");
$templateCache.put("app/main/locacao/consulta/controle-equipamento/views/dialog-tipo/dialog-tipo.html","<div class=\"dialog\" id=\"equipamento-tipo\"><form name=\"vm.form\" class=\"form-dialog\"><md-dialog style=\"max-width: 100%\">\n<md-toolbar><div class=\"md-toolbar-tools\" style=\"background-color: #039BE5\"><h2>Detalhes por tipo de equipamento</h2>\n<span flex></span><md-button class=\"md-icon-button\" ng-click=\"vm.metodos.fecharDialog()\" aria-label=\"Fechar dialog\" \ntranslate translate-attr-aria-label=\"CLIENTE.FECHAR_DIALOG\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button>\n</div></md-toolbar><md-dialog-content style=\"overflow-y: scroll;max-height: 80vh\" id=\"historico-detalhe\"><div \nlayout=\"column\" class=\"tabela\" ng-repeat=\"equipamento in vm.equipamento\"><div layout=\"row\" style=\"align-items: center\">\n<span class=\"span\">Estado de conservação:</span><p class=\"estadoConservacao\">{{ equipamento[0].conservacao }}</p></div>\n<table class=\"dataTable row-border hover\" id=\"tabela-equipamentos\"><thead><tr><div class=\"table-header\"><th \nclass=\"secondary-text column-title text-center tabelaCabecalho\">Equipamento</th><th \nclass=\"secondary-text column-title text-center tabelaCabecalho\">Situação</th><th \nclass=\"secondary-text column-title text-center tabelaCabecalho\">Número de série</th><th \nclass=\"secondary-text column-title text-center tabelaCabecalho\">IMEI</th></div></tr></thead><tbody><tr \nng-repeat=\"item in equipamento | orderBy:\'equipamentoDescricao\'\"><td>{{ item.equipamentoDescricao }}</td><td>\n{{ item.equipamentoSituacaoDescricao }}</td><td>{{ item.serie }}</td><td>{{ item.imei }}</td></tr></tbody></table>\n</div></md-dialog-content></md-dialog></form></div>");
$templateCache.put("app/main/pipeline/consulta/estatististica-negocios/dialogs/detalhamento-negocios/detalhamento-negocios-dialog.html","<md-dialog id=\"detalhamento-negocios-dialog\" class=\"dialogo-padrao\" aria-label=\"Dialog\"><md-toolbar \nclass=\"md-accent md-tall\" layout=\"column\"><div class=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" \nlayout-align=\"space-between center\"><span class=\"title\">{{vm.titulo}}</span><md-button class=\"md-icon-button\" \naria-label=\"Fechar dialog\" translate translate-attr-aria-label=\"SPRINT.FECHAR_DIALOG\" \nng-click=\"vm.metodosDialog.fecharDialog()\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar>\n<div layout=\"column\" layout-align=\"center center\" ng-show=\"vm.requisicaoSolicitada\"><span class=\"font-weight-500\">\n{{vm.mensagemPreloader}}</span><md-progress-circular class=\"md-accent\" md-mode=\"indeterminate\" md-diameter=\"30\">\n</md-progress-circular></div><md-dialog-content class=\"negocios-dialog-content\" layout=\"row\" \nlayout-align=\"center center\" flex><div class=\"tabela-negocios md-background-bg md-whiteframe-1dp fullpage-datatable\" \nlayout=\"column\" flex><table class=\"dataTable row-border hover\" datatable=\"ng\" dt-options=\"vm.dtOptions\" width=\"100%\" \nflex><thead><tr><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Ação</span></div></th>\n<th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Cliente</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Data</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Funil</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Produtos</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Valor nominal</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Outros valores</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Executivo de contas</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Atendimento</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Resultado</span></div></th><th \nclass=\"secondary-text none\"><div class=\"table-header\"><span class=\"column-title\">Observação:</span></div></th></tr>\n</thead><tfoot class=\"md-background-bg\"><tr style=\"background: white !important\"><th \nstyle=\"background: white !important; position: relative; z-index: 2\"><span \nstyle=\"background: white !important; position: relative; z-index: 2\">Total:</span></th><th></th><th></th><th></th><th>\n</th><th style=\"padding-left: 8px !important\"><span class=\"valor-total\">{{vm.valorTotal | currency:\"R$ \"}}</span></th>\n<th style=\"padding-left: 8px !important\"><span class=\"valor-total\">{{vm.totalOutrosValores | currency:\"R$ \"}}</span>\n</th><th></th><th></th><th></th><th></th></tr></tfoot><tbody><tr ng-repeat=\"negocio in vm.negocios\"><td><i \nng-hide=\"!vm.permiteEdicao\" class=\"icon-pencil s16 icone-cor-padrao\" \nng-click=\"vm.metodosDialog.abrirDialogNegocio($event, negocio, true)\"></i></td><td>{{negocio.cliente}}</td><td>\n{{negocio.data | date:\'dd/MM/yyyy\'}}</td><td>{{negocio.funil}}</td><td>{{negocio.produtos}}</td><td>{{negocio.valor}}\n</td><td>{{negocio.outrosValores}}</td><td>{{negocio.executivoContas}}</td><td>\n{{negocio.codigoAtendimento}}/{{negocio.anoAtendimento}} <button \nng-click=\"vm.metodosDialog.abrirAtendimeto(negocio.codigoAtendimento, negocio.anoAtendimento)\"><i \nclass=\"icon-open-in-new s18 icone-cor-padrao\"></i><md-tooltip md-autohide><span>Abrir atendimento em nova aba</span>\n</md-tooltip></button></td><td>{{negocio.resultado}}</td><td><div layout=\"row\"><div class=\"mr-5\">{{negocio.observacao}}\n</div></div></td></tr></tbody></table></div></md-dialog-content></md-dialog>");
$templateCache.put("app/main/pipeline/consulta/projecoes-negocios/dialogs/detalhamento-projecoes-etapa/detalhamento-etapa-dialog.html","<md-dialog id=\"detalhamento-etapa-dialog\" class=\"dialogo-padrao\" aria-label=\"Dialog\"><md-toolbar \nclass=\"md-accent md-tall\" layout=\"column\"><div class=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" \nlayout-align=\"space-between center\"><span class=\"title\">{{vm.titulo}}</span><md-button class=\"md-icon-button\" \naria-label=\"Fechar dialog\" translate translate-attr-aria-label=\"SPRINT.FECHAR_DIALOG\" \nng-click=\"vm.metodosDialog.fecharDialog()\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar>\n<div layout=\"column\" layout-align=\"center center\" ng-show=\"vm.requisicaoSolicitada\"><span class=\"font-weight-500\">\n{{vm.mensagemPreloader}}</span><md-progress-circular class=\"md-accent\" md-mode=\"indeterminate\" md-diameter=\"30\">\n</md-progress-circular></div><md-dialog-content class=\"conteudo-dialog-etapa\" layout=\"row\" \nlayout-align=\"center center\" flex=\"100\"><div class=\"tabela-detalhamento-etapa md-background-bg md-whiteframe-1dp\" \nlayout=\"column\" flex><table class=\"dataTable row-border hover\" datatable=\"ng\" dt-options=\"vm.dtOptions\" width=\"100%\" \nflex=\"100\"><thead><tr><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Nível</span>\n</div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Probabilidade fechamento\n</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Quantidade negócios\n</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Valor nominal</span>\n</div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Valor projetado</span></div>\n</th></tr></thead><tfoot><tr><th>Total:</th><th></th><th style=\"padding-left: 8px !important\"></th><th \nstyle=\"padding-left: 8px !important\"></th><th style=\"padding-left: 8px !important\"></th></tr></tfoot><tbody><tr \nng-repeat=\"projecao in vm.projecoes\"><td>{{projecao.etapaNivel}} - {{projecao.etapaDescricao}}</td><td>\n{{projecao.etapaProbabilidadeFechamento}}%</td><td>{{projecao.quantidadeNegocios}}</td><td>{{projecao.valorNominal}}\n</td><td>{{projecao.valorProjetado}}</td></tr></tbody></table></div></md-dialog-content><md-dialog-actions \nlayout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"end center\"><md-button \nclass=\"send-button md-accent md-raised\" type=\"submit\" aria-label=\"Imprimir PDF\" \ntranslate=\"PIPELINE_CONSULTA_PROJECOES_NEGOCIOS.IMPRIMIR_PDF\" \ntranslate-attr-aria-label=\"PIPELINE_CONSULTA_PROJECOES_NEGOCIOS.IMPRIMIR_PDF\" \nng-click=\"vm.metodosDialog.gerarRelatorioProjecoes($event)\" \nng-disabled=\"vm.form.$invalid || vm.form.$pristine || vm.requisicaoSolicitada || \r\n                       vm.tabSelecionada === \'dadosHistorico\' || (!vm.etapaAtual.permiteValoresZerados && vm.negocio.valor == 0)\">\nImprimir PDF</md-button></div></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/pipeline/consulta/projecoes-negocios/dialogs/detalhamento-projecoes-negocios/detalhamento-projecoes-negocios-dialog.html","<md-dialog id=\"detalhamento-projecoes-negocios\" class=\"dialogo-padrao\" aria-label=\"Dialog\"><md-toolbar \nclass=\"md-accent md-tall\" layout=\"column\"><div class=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" \nlayout-align=\"space-between center\"><span class=\"title\">{{vm.titulo}}</span><md-button class=\"md-icon-button\" \naria-label=\"Fechar dialog\" translate translate-attr-aria-label=\"SPRINT.FECHAR_DIALOG\" \nng-click=\"vm.metodosDialog.fecharDialog()\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar>\n<div layout=\"column\" layout-align=\"center center\" ng-show=\"vm.requisicaoSolicitada\"><span class=\"font-weight-500\">\n{{vm.mensagemPreloader}}</span><md-progress-circular class=\"md-accent\" md-mode=\"indeterminate\" md-diameter=\"30\">\n</md-progress-circular></div><md-dialog-content class=\"detalhamento-dialog-content\" layout=\"row\" \nlayout-align=\"center center\" flex><div class=\"tabela-detalhamento-projecao md-background-bg md-whiteframe-1dp\" \nlayout=\"column\" flex><table class=\"dataTable row-border hover\" datatable=\"ng\" dt-options=\"vm.dtOptions\" width=\"100%\" \nflex><thead><tr><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Cliente</span></div>\n</th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Executivo de contas responsável\n</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Data inicial</span>\n</div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Data vencimento</span></div>\n</th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Valor nominal</span></div></th><th\n class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Valor projetado</span></div></th></tr>\n</thead><tfoot><tr><th>Total:</th><th></th><th style=\"padding-left: 8px !important\"></th><th \nstyle=\"padding-left: 8px !important\"></th><th style=\"padding-left: 8px !important\"></th><th \nstyle=\"padding-left: 8px !important\"></th></tr></tfoot><tbody><tr ng-repeat=\"negocio in vm.negocios\"><td>\n{{negocio.clienteNome}}</td><td>{{negocio.executivoDeContasResponsavelNome}}</td><td>\n{{negocio.dataInicialNegocio | date:\'dd/MM/yyyy\'}}</td><td>{{negocio.vencimentoNegocio | date:\'dd/MM/yyyy\'}}</td><td>\n{{negocio.valorNominal}}</td><td>{{negocio.valorProjetado}}</td></tr></tbody></table></div></md-dialog-content>\n</md-dialog>");
$templateCache.put("app/main/locacao/processamento/locacao/dialogs/dialog-confirma-envio/dialog-confirma-envio.html","<form name=\"vm.form\" id=\"dialog-envio\" style=\"max-width: 50%;width: 50%\"><md-dialog class=\"dialog-locacao-envio\">\n<md-toolbar><div class=\"md-toolbar-tools\" style=\"background-color: #039BE5\"><h2>Envio</h2><span flex></span><md-button \nclass=\"md-icon-button\" ng-click=\"vm.metodos.cancel()\" aria-label=\"Fechar dialog\" translate \ntranslate-attr-aria-label=\"CLIENTE.FECHAR_DIALOG\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content class=\"dialog-locacao-envio\" layout=\"column\" style=\"overflow: scroll\"><div \nlayout=\"row\"><md-input-container class=\"md-block\"><label>Data envio</label><md-datepicker \nng-model=\"vm.locacaoEnvio.dataEnvio\" name=\"envioData\" ng-mask=\"3?9/1?9/9999\" ng-required=\"true\" md-max-date=\"\" \nmd-min-date=\"vm.locacaoEnvio.dataInicioLocacao\"></md-datepicker></md-input-container><md-input-container \nclass=\"md-block\" flex><label>Nota de saída</label><input ng-model=\"vm.locacaoEnvio.notaFiscalSaida\" \nclass=\"input-selecao\" name=\"notaFiscalSaida\" maxlength=\"10\" md-maxlength=\"10\" ng-required=\"true\"></md-input-container>\n</div><div flex layout=\"row\"><md-input-container class=\"md-block\" flex><label>Atendimento</label><md-select \nng-model=\"vm.atendimentoEnvio\" ng-required=\"true\"><md-option layout=\"row\" ng-repeat=\"item in vm.atendimentos\" \nng-value=\"item\">{{ item.codigo }}/{{ item.ano }} - {{item.assunto}}</md-option></md-select></md-input-container></div>\n<div style=\"text-align: center\" class=\"mt-8\"><md-button class=\"md-accent md-raised md-hue-2 header-boards-button\" \nlayout-align=\"center center\" ng-click=\"vm.metodos.dialog(vm.atendimentoEnvio)\" ng-disabled=\"vm.form.$invalid\"><span>\nSalvar</span></md-button></div></md-dialog-content></md-dialog></form>");
$templateCache.put("app/main/locacao/processamento/locacao/dialogs/dialog-estado-conservacao/dialog-estado-conservacao.html","<form name=\"vm.form\" style=\"min-width: 20%; max-width: 80%\"><md-dialog style=\"max-width: 100%\"><md-toolbar><div \nclass=\"md-toolbar-tools\" style=\"background-color: #039BE5\"><h2 ng-if=\"!vm.apenasFoto\">\nEstado de conservação - {{vm.detalhe.equipamento.descricao}} - Nº Serie: {{vm.detalhe.numeroSerie}}</h2><h2 \nng-if=\"vm.apenasFoto\">Foto - {{vm.detalhe.equipamento.descricao}} - Nº Serie: {{vm.detalhe.numeroSerie}}</h2><span \nflex></span><md-button class=\"md-icon-button\" ng-click=\"vm.metodos.cancel()\" aria-label=\"Fechar dialog\" translate \ntranslate-attr-aria-label=\"CLIENTE.FECHAR_DIALOG\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content><div layout=\"column\" flex style=\"padding: 1%\"><md-input-container class=\"md-block\" \nflex=\"20\" ng-if=\"!vm.apenasFoto\"><label>Conservação:</label><md-select \nng-model=\"vm.locacaoEnvio.equipamentoEstadoConservacao\"><md-option layout=\"row\" \nng-repeat=\"item in vm.equipamentoEstadoConservacao\" ng-value=\"item\" name=\"conservacao\" ng-required=\"true\">\n{{ item.descricao }}</md-option></md-select></md-input-container><input id=\"inputFoto\" hidden type=\"file\" \nim-file-change=\"vm.metodos.selecionarArquivoFotoDivulgacao($event, arquivos)\" name=\"fotoDivulgacao\" \naccept=\"image/jpeg, image/png\" multiple=\"multiple\" style=\"max-width: 100%;align-self: center\" ng-if=\"vm.apenasFoto\">\n<md-button ng-click=\"vm.metodos.inputFoto()\" ng-if=\"vm.apenasFoto\" \nstyle=\"max-width: 250px;align-self: center; background-color: #039BE5\" \nclass=\"md-accent md-raised md-hue-2 header-boards-button\"><i class=\"icon-folder s24\"></i> Selecionar</md-button>\n<fieldset class=\"standard\" flex style=\"width: 90%;align-self: center\" ng-if=\"!vm.carregandoFotos && (vm.apenasFoto)\" \nlayout=\"row\" flex-wrap><legend class=\"grp-legend\">Fotos: {{vm.locacaoEnvio.fotos.length}}</legend><div \nlayout-xs=\"column\" layout=\"row\" flex style=\"justify-content: space-around;overflow-x: scroll;max-height: 50vh\" \nlayout-wrap><div layout=\"column\" ng-repeat=\"foto in vm.locacaoEnvio.fotos track by $index\" flex \nstyle=\"min-width: 21%;max-width: 20%\"><img src=\"data:image/jpg;base64,{{foto}}\" style=\"width: 235;height: 250px\" \nng-click=\"vm.metodos.zoomFoto(foto)\"> <i class=\"icon-delete icone-cor-padrao\" style=\"align-self: center\" \nng-click=\"vm.metodos.excluirFoto($index,foto)\"><md-tooltip>Remover foto</md-tooltip></i></div></div></fieldset></div>\n<div style=\"text-align: center\" class=\"mt-8\"><md-button class=\"md-accent md-raised md-hue-2 header-boards-button\" \nlayout-align=\"center center\" ng-disabled=\"vm.desabilitarButtonSalvar\" \nng-click=\"vm.metodos.dialog(vm.locacaoEnvio, item)\"><span>Salvar</span></md-button></div></md-dialog-content>\n</md-dialog></form>");
$templateCache.put("app/main/locacao/processamento/locacao/dialogs/dialog-locacao-retorno/dialog-locacao-retorno.html","<form id=\"locacao-retorno\" name=\"vm.form\" style=\"max-width: 50%; \r\n             width: 50%\"><md-dialog \nstyle=\"max-width: 100%\"><md-toolbar><div class=\"md-toolbar-tools\" style=\"background-color: #039BE5\"><h2>Retorno</h2>\n<span flex></span><md-button class=\"md-icon-button\" aria-label=\"Fechar dialog\" translate \ntranslate-attr-aria-label=\"CLIENTE.FECHAR_DIALOG\" ng-click=\"vm.metodos.cancel()\"><md-icon md-font-icon=\"icon-close\">\n</md-icon></md-button></div></md-toolbar><md-dialog-content class=\"dialog-locacao-retorno\" layout=\"column\" \nstyle=\"overflow: scroll\"><div layout=\"row\"><md-input-container class=\"md-block\" flex><label>Tipo de retorno</label>\n<md-select name=\"tipoLocacaoId\" ng-model=\"vm.locacaoRetorno.retornoLocacaoId\" ng-required=\"true\"><md-option \nlayout=\"row\" ng-repeat=\"item in vm.tipoRetornos\" ng-value=\"item.id\">{{ item.descricao }}</md-option></md-select><div \nng-messages=\"vm.form.tipoLocacaoId.$error\"><div ng-message=\"required\" translate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\">\n</div></div></md-input-container><md-input-container class=\"md-block\"><label>Data</label><md-datepicker \nname=\"envioData\" md-max-date=\"\" md-min-date=\"vm.locacaoRetorno.dataInicioLocacao\" \nng-model=\"vm.locacaoRetorno.dataRetorno\" ng-mask=\"3?9/1?9/9999\" ng-required=\"true\"></md-datepicker><div \nng-messages=\"vm.form.envioData.$error\"><div ng-message=\"required\" translate=\"MENSAGEM_VALIDACAO.DATA_OBRIGATORIA\">\n</div></div></md-input-container><md-input-container class=\"md-block\" flex=\"35\"><label>Nota de saída</label><input \nclass=\"input-selecao\" name=\"notaFiscalDevolucao\" mascara-numero-generica=\"##########\" maxlength=\"10\" md-maxlength=\"10\" \nng-required=\"true\" ng-model=\"vm.locacaoRetorno.notaFiscalDevolucao\"><div \nng-messages=\"vm.form.notaFiscalDevolucao.$error\"><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container></div><div flex layout=\"row\">\n<md-input-container class=\"md-block\" flex><label>Atendimento</label><md-select name=\"atendimento\" \nng-model=\"vm.atendimentoRetorno\" ng-required=\"true\"><md-option layout=\"row\" ng-repeat=\"item in vm.atendimentos\" \nng-value=\"item\">{{ item.codigo }}/{{ item.ano }} - {{item.assunto}}</md-option></md-select><div \nng-messages=\"vm.form.atendimento.$error\"><div ng-message=\"required\" translate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\">\n</div></div></md-input-container><md-input-container class=\"md-block\" flex=\"35\"><label>Nota de entrada</label><input \nclass=\"input-selecao\" name=\"notaFiscalDEntrada\" mascara-numero-generica=\"##########\" maxlength=\"10\" md-maxlength=\"10\" \nng-model=\"vm.locacaoRetorno.notaFiscalEntrada\" ng-required=\"true\"><div ng-messages=\"vm.form.notaFiscalDEntrada.$error\">\n<div ng-message=\"required\" translate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container></div><div\n layout=\"column\"><md-input-container class=\"md-block\" flex><label>Observação</label><textarea \nname=\"motivoCancelamento\" mascara-tamanho-campo=\"300\" max-rows=\"4\" md-maxlength=\"300\" md-no-resize=\"true\" \nng-model=\"vm.locacaoRetorno.observacao\">\r\n            </textarea></md-input-container></div><div \nstyle=\"text-align: center\" class=\"mt-8\"><md-button class=\"md-accent md-raised md-hue-2 header-boards-button\" \nlayout-align=\"center center\" ng-click=\"vm.metodos.dialog(vm.atendimentoRetorno)\" \nng-disabled=\"vm.form.$invalid || vm.form.$pristine\"><span>Salvar</span></md-button></div></md-dialog-content>\n</md-dialog></form>");
$templateCache.put("app/main/locacao/processamento/locacao/dialogs/dialog-locacao-envio/dialog-locacao-envio.html","<form name=\"vm.form\" id=\"dialog-envio\"><md-dialog class=\"dialog-locacao-envio\"><md-toolbar><div \nclass=\"md-toolbar-tools\" style=\"background-color: #039BE5\"><h2>Envio</h2><span flex></span><md-button \nclass=\"md-icon-button\" ng-click=\"vm.metodos.cancel()\" aria-label=\"Fechar dialog\" translate \ntranslate-attr-aria-label=\"CLIENTE.FECHAR_DIALOG\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content class=\"dialog-locacao-envio\" layout=\"column\" style=\"overflow: scroll\"><div \nlayout=\"row\"><md-input-container class=\"md-block\" flex><label>Tipo Locação:</label><md-select \nng-model=\"vm.locacaoEnvio.tipoLocacao\"><md-option layout=\"row\" ng-repeat=\"item in vm.tipoLocacao\" ng-value=\"item\" \nname=\"tipoLocacaoId\" ng-required=\"true\">{{ item.descricao }}</md-option></md-select></md-input-container></div><div \nstyle=\"text-align: center\" class=\"mt-8\"><md-button class=\"md-accent md-raised md-hue-2 header-boards-button\" \nlayout-align=\"center center\" ng-click=\"vm.metodos.dialog()\" ng-disabled=\"vm.form.$invalid || vm.form.$pristine\"><span>\nContinuar</span></md-button></div></md-dialog-content></md-dialog></form>");
$templateCache.put("app/main/locacao/processamento/locacao/envio/view/locacao-envio-form.html","<div id=\"forms\" class=\"page-layout simple fullwidth doc-page\" layout=\"column\"><div class=\"content\" layout=\"column\">\n<form name=\"vm.form\" ms-vertical-stepper ng-submit=\"vm.metodos.validadorCadastroEnvio($event, vm.filtro)\" \nng-model=\"vm.filtro\" on-submit-value-step=\"1\" custom-button-submit-text=\"Avançar\" novalidate><ms-vertical-stepper-step \nng-form=\"vm.form.step.clientes\" step=\"1\" step-title=\"\'Cliente\'\"><div ui-view=\"contrato-step\"></div>\n</ms-vertical-stepper-step><ms-vertical-stepper-step ng-form=\"vm.form.step.tiposLicenca\" step=\"2\" \nstep-title=\"\'Contrato\'\"><div ui-view=\"envio-step\"></div></ms-vertical-stepper-step></form></div></div>");
$templateCache.put("app/main/locacao/processamento/locacao/envio/view/locacao-envio-tabela.html","<form id=\"locacao-envio\"><div flex layout=\"row\" style=\"justify-content: center\"><md-card flex class=\"blue-bg white-fg\" \nmd-theme-watch><md-card-title class=\"titulo-card-superior\"><strong><span class=\"blue-bg white-fg\">{{ vm.cliente.nome }}\n</span></strong></md-card-title></md-card><md-card flex class=\"blue-bg white-fg\" md-theme-watch><md-card-title \nclass=\"titulo-card-superior\" layout=\"column\"><strong><span class=\"blue-bg white-fg\">Contrato</span> </strong><span>\n{{ vm.contrato.contratoTipo.descricao }}</span></md-card-title></md-card><md-card flex class=\"blue-bg white-fg\" \nmd-theme-watch><md-card-title class=\"titulo-card-superior\" layout=\"column\"><strong><span class=\"blue-bg white-fg\">Item\n</span> </strong><span>{{ vm.contratoItem.produto.descricao }}</span></md-card-title></md-card><md-card flex \nclass=\"blue-bg white-fg\" md-theme-watch><md-card-title class=\"titulo-card-superior\" layout=\"column\"><strong><span \nclass=\"blue-bg white-fg\">Tipo de locação </span></strong><span>{{ vm.locacaoEnvio.tipoLocacao.descricao }}</span>\n</md-card-title></md-card></div><div flex layout-align=\"center center\" layout=\"column\" layout-gt-sm=\"row\" \nstyle=\"height: 100%; justify-content: space-between\"><div flex flex-gt-sm=\"40\" style=\"height: 62vh\"><md-card flex \nlayout=\" column\" style=\"height: 100%\"><md-card-title-text><span class=\"md-headline\" layout-align=\"center center\" \nstyle=\"font-size: 20px\">Disponíveis - Total: {{vm.detalhes.length}}</span></md-card-title-text><div \nclass=\"shortcut-loader\" layout=\"row\" layout-align=\"center center\" ng-if=\"vm.requisicaoSolicitada || vm.filtrando\">\n<md-progress-circular class=\"md-accent\" md-diameter=\"20\" md-mode=\"indeterminate\"></md-progress-circular></div><div \nng-if=\"!vm.requisicaoSolicitada && !vm.filtrando\" flex layout=\"row\" \nstyle=\"min-height: 6vh;justify-content: center;box-shadow: 0px 1px 0px lightgrey\"><md-input-container class=\"md-block\" \nmd-no-float flex style=\"margin: 0px\"><input ng-model=\"vm.pesquisa\" class=\"input-selecao\" name=\"pesquisa\" \nplaceholder=\"Pesquisar\" id=\"inputPesquisa\" , ng-change=\"vm.metodos.teclaEnter()\"></md-input-container><md-button \nclass=\"md-icon-button\" ng-click=\"vm.metodos.pesquisarDisponiveis(vm.pesquisa)\" flex=\"10\" id=\"botaoPesquisar\"><i \nclass=\"icon-magnify s28 icone-cor-padrao\" ng-disabled=\"vm.pesquisa <= 0\"></i><md-tooltip><span>Pesquisar</span>\n</md-tooltip></md-button><md-button class=\"md-icon-button\" ng-click=\"vm.metodos.pesquisarTodos()\" flex=\"10\"><i \nclass=\"icon-filter-remove s24 icone-cor-padrao\"></i><md-tooltip><span>Limpar filtro</span></md-tooltip></md-button>\n</div><div style=\"height: 61.5vh; overflow: scroll; margin-top: 1px\" ng-if=\"!vm.requisicaoSolicitada\"><span \nlayout-align=\"center center\" ng-if=\"vm.detalhes.length <= 0\" style=\"margin-left: 38%\">Sem Registros.</span><md-content \nng-if=\"vm.detalhes.length > 0\"><md-list flex><div flex style=\"box-shadow: 10px 1px 0px lightgrey\"><md-checkbox \nng-model=\"vm.marcarTodos\" style=\"margin-left: 27px\" ng-change=\"vm.metodos.marcarTodos(vm.marcarTodos)\"><span \nstyle=\"margin-left: 22px\">Marcar todos</span></md-checkbox></div><md-list-item class=\"md-3-line espacamento p-8\" \nstyle=\"box-shadow: 10px 1px 0px lightgrey\" ng-class=\"{\'selecionado\': vm.clicado == $index,\'zebra\' : $index %2 == 0}\" \nng-repeat=\"item in vm.detalhes | orderBy: \'equipamento.descricao\'\"><md-checkbox ng-model=\"item.marcado\" \nstyle=\"margin-right: 10px\" ng-click=\"vm.metodos.pesquisarItensNota(item,$index)\"></md-checkbox><div \nclass=\"md-list-item-text\" layout=\"column\"><h4><strong>N° Série: </strong>{{item.numeroSerie}}</h4><h4><strong>N° IMEI: \n</strong>{{item.imei}}</h4><h4><strong>Equipamento: </strong>{{item.equipamento.descricao}}</h4></div><div \nlayout=\"row\" class=\"md-secondary\"><md-button class=\"md-icon-button siglas\" \nng-click=\"vm.metodos.botaoDialogEstadoConservacao($index, item)\">\n{{item.equipamentoEstadoConservacao.descricao[0] + item.equipamentoEstadoConservacao.descricao[1]}}<md-tooltip><span>\nEstado de conservação: {{item.equipamentoEstadoConservacao.descricao}}</span></md-tooltip></md-button><md-button \nclass=\"md-icon-button siglas\" ng-click=\"vm.metodos.botaoDialogFoto($index, item)\"><i \nclass=\"icon-picture s16 icone-cor-padrao\" ng-disabled=\"vm.controleForm.emProgresso\"></i><md-tooltip><span>Fotos</span>\n</md-tooltip></md-button><md-button class=\"md-icon-button siglas\" ng-click=\"vm.metodos.dialogHistorico($index, item)\">H\n<md-tooltip><span>Histórico</span></md-tooltip></md-button></div></md-list-item></md-list></md-content></div></md-card>\n</div><md-button ng-disabled=\"vm.detalhes.length <= 0 || vm.requisicaoSolicitada\" \nng-click=\"vm.metodos.abrirDialogConfirmaLocacao(vm.locacaoEnvio)\" layout-align=\"end end\" \nclass=\"md-fab md-accent md-icon-button\"><md-icon md-font-icon=\"icon-arrow-right s30\"></md-icon></md-button><div flex \nflex-gt-sm=\"25\" style=\"height: 62vh\"><md-card flex layout=\"column\" style=\"height: 100%\"><md-card-title-text><span \nclass=\"md-headline\" layout-align=\"center center\" style=\"font-size: 20px\">Dados de envio</span></md-card-title-text><div\n class=\"shortcut-loader\" layout=\"row\" layout-align=\"center center\" ng-if=\"vm.requisicaoSolicitada\">\n<md-progress-circular class=\"md-accent\" md-diameter=\"20\" md-mode=\"indeterminate\"></md-progress-circular></div><div \nstyle=\"height: 61.5vh; overflow: scroll\" layout=\"column\" ng-if=\"(vm.envios[0] != null) && !vm.requisicaoSolicitada\">\n<md-content><md-list flex><div flex style=\"box-shadow: 10px 1px 0px lightgrey\"><md-checkbox ng-model=\"vm.todosEnvios\" \nstyle=\"margin-left: 27px\" ng-change=\"vm.metodos.listarLocados()\" ng-disabled=\"vm.todosEnvios\"><span \nstyle=\"margin-left: 22px\">Todos</span></md-checkbox></div><md-list-item class=\"md-3-line\" \nng-repeat=\"item in vm.envios | orderBy: \'dataEnvio\':true\" style=\"box-shadow: 10px 1px 0px lightgrey\" \nng-class=\"{\'zebra\' : $index %2 == 0}\" ng-click=\"vm.metodos.listarDetalhesPorNotaSaida(item.notaFiscalSaida)\"><div \nclass=\"md-list-item-text\" layout=\"column\"><h4><strong>Atendimento</strong>\n: {{item.atendimentoId}}/{{item.atendimentoAno}}</h4><h4><strong>Nota saída</strong>: {{item.notaFiscalSaida}}</h4><h4>\n<strong>Data envio:</strong>: {{item.dataEnvio | date:\'dd/MM/yyyy\'}}</h4></div><div layout=\"row\" class=\"md-secondary\">\n<md-button class=\"md-icon-button siglas\" ng-click=\"vm.metodos.dialogEditarEnvio(item)\"><i \nclass=\"icon-pencil s16 icone-cor-padrao\" ng-disabled=\"vm.controleForm.emProgresso\"></i><md-tooltip><span>Editar</span>\n</md-tooltip></md-button></div></md-list-item></md-list></md-content></div></md-card></div><div flex flex-gt-sm=\"33\" \nstyle=\"height: 62vh; max-width: 28%\"><md-card flex layout=\" column\" style=\"height: 100%\"><md-card-title-text><span \nclass=\"md-headline\" layout-align=\"center center\" style=\"font-size: 20px\">Locados - Total: {{vm.locados.length}}</span>\n</md-card-title-text><div class=\"shortcut-loader\" layout=\"row\" layout-align=\"center center\" \nng-if=\"vm.buscandoLocados || vm.requisicaoSolicitada\"><md-progress-circular class=\"md-accent\" md-diameter=\"20\" \nmd-mode=\"indeterminate\"></md-progress-circular></div><div style=\"height: 61.5vh; overflow: scroll\" \nng-if=\"!vm.buscandoLocados && !vm.requisicaoSolicitada\"><md-content><md-list flex><md-list-item \nclass=\"md-3-line espacamento p-8\" ng-repeat=\"item in vm.locados | orderBy:\'dataEnvio\':true\" \nstyle=\"box-shadow: 10px 1px 0px lightgrey\" ng-class=\"{\'zebra\' : $index %2 == 0}\"><div class=\"md-list-item-text\" \nlayout=\"column\" ng-required=\"true\"><h4><strong>N° Série: </strong>{{item.equipamentoNotaItemDetalhe.numeroSerie}}</h4>\n<h4><strong>IMEI: </strong>{{item.equipamentoNotaItemDetalhe.imei}}</h4><h4><strong>Equipamento: </strong>\n{{item.equipamentoNotaItemDetalhe.equipamento.descricao}}</h4></div><div layout=\"row\" class=\"md-secondary\"><md-button \nclass=\"md-icon-button siglas\">\n{{item.equipamentoEstadoConservacao.descricao[0] + item.equipamentoEstadoConservacao.descricao[1]}}<md-tooltip><span>\nEstado de conservação: {{item.equipamentoEstadoConservacao.descricao}}</span></md-tooltip></md-button><md-button \nclass=\"md-icon-button siglas\" ng-click=\"vm.metodos.dialogFoto($event, item.equipamentoNotaItemDetalhe)\"><i \nclass=\"icon-picture s16 icone-cor-padrao\" ng-disabled=\"vm.controleForm.emProgresso\"></i><md-tooltip><span>Fotos</span>\n</md-tooltip></md-button></div></md-list-item></md-list></md-content></div></md-card></div></div></form>");
$templateCache.put("app/main/locacao/processamento/locacao/envio/view/locacao-envio.html","<div id=\"locacao-envio\" layout=\"column\"><div class=\"header md-accent-bg\" layout=\"column\"><div class=\"header-content\" \nlayout=\"row\" layout-wrap flex><div layout=\"row\" layout-align=\"center center\" ng-if=\"vm.mostrarTabela == true\">\n<md-button class=\"md-accent md-raised md-hue-2 header-boards-button\" ng-click=\"vm.metodos.botaoVoltar()\" \naria-label=\"Voltar\" translate translate-attr-aria-label=\"VOLTAR\" ng-if=\"!vm.requisicaoSolicitada\"><md-icon \nmd-font-icon=\"icon-chevron-double-left\" class=\"icon\"></md-icon><span translate=\"VOLTAR\"></span></md-button></div><div \nflex style=\"align-self: center; text-align: center\"><h1 layout-align=\"center center\" \nstyle=\"font-size: 24px; text-align: left; margin-left: 40px\">Envio Locação</h1></div></div></div><div class=\"content\" \nng-if=\"!vm.mostrarTabela\"><div ui-view=\"locacao-envio-form\"></div></div><div ui-view=\"locacao-envio-tabela\" \nng-if=\"vm.mostrarTabela\"></div></div>");
$templateCache.put("app/main/pipeline/processamento/pipeline-negocio/dialogs/pipeline-negocio-negocios/pipeline-negocio-negocios-dialog.html","<md-dialog id=\"pipeline-negocio-negocios-dialog\" class=\"dialogo-padrao\" aria-label=\"Dialog\"><form name=\"vm.form\" \nclass=\"md-inline-form\" novalidate><md-toolbar class=\"md-accent md-tall\" layout=\"column\"><div \nclass=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" layout-align=\"space-between center\" flex><div layout=\"row\" \nlayout-align=\"start center\" flex><span class=\"title text-center\">{{vm.titulo}}</span></div><div layout=\"row\"><md-button\n class=\"md-icon-button\" ng-click=\"vm.metodos.fecharDialog()\" aria-label=\"Fechar dialog\" translate \ntranslate-attr-aria-label=\"PIPELINE_NEGOCIO.FECHAR_DIALOG\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button>\n</div></div></md-toolbar><div layout=\"column\" layout-align=\"center center\" ng-show=\"vm.requisicaoSolicitada\"><span \nclass=\"font-weight-500\">{{vm.mensagemPreloader}}</span><md-progress-circular md-mode=\"indeterminate\" md-diameter=\"30\" \nclass=\"md-accent\"></md-progress-circular></div><md-dialog-content class=\"conteudo-dialog\"><md-tabs md-dynamic-height \nmd-border-bottom ng-disabled=\"vm.requisicaoSolicitada\"><md-tab label=\"Dados do negócio\" \nmd-active=\"vm.tabSelecionada === \'negocio\'\" md-on-select=\"vm.metodos.tabSelecionada(\'negocio\')\" \nng-disabled=\"vm.requisicaoSolicitada\"><md-tab-label><label translate=\"PIPELINE_NEGOCIO.DADOS_NEGOCIO\"></label>\n</md-tab-label><md-tab-body><div ng-include=\"vm.htmlRota.dialogs.dialogPipelineNegocio.tabs.tabDadosNegocio\" \nclass=\"conteudo-tab\"></div></md-tab-body></md-tab><md-tab label=\"Dados de histórico\" \nmd-active=\"vm.tabSelecionada === \'dadosHistorico\'\" md-on-select=\"vm.metodos.tabSelecionada(\'dadosHistorico\')\" \nng-disabled=\"vm.requisicaoSolicitada || vm.novaEntidade\"><md-tab-label><label \ntranslate=\"PIPELINE_NEGOCIO.DADOS_HISTORICO\"></label></md-tab-label><md-tab-body><div \nng-include=\"vm.htmlRota.dialogs.dialogPipelineNegocio.tabs.tabDadosHistorico\"></div></md-tab-body></md-tab><md-tab \nlabel=\"Dados de histórico\" md-active=\"vm.tabSelecionada === \'dadosHistoricoFunil\'\" \nmd-on-select=\"vm.metodos.tabSelecionada(\'dadosHistoricoFunil\')\" \nng-disabled=\"vm.requisicaoSolicitada || vm.novaEntidade\"><md-tab-label><label \ntranslate=\"PIPELINE_NEGOCIO.DADOS_HISTORICO_FUNIL\"></label></md-tab-label><md-tab-body><div \nng-include=\"vm.htmlRota.dialogs.dialogPipelineNegocio.tabs.tabDadosHistoricoFunil\"></div></md-tab-body></md-tab>\n</md-tabs></md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" \nlayout-align=\"start center\"><md-button type=\"submit\" \nng-click=\"vm.metodos.verificarExecutivoContas($event, vm.negocio)\" class=\"send-button md-accent md-raised\" \nng-disabled=\"vm.form.$invalid || vm.form.$pristine || vm.requisicaoSolicitada || vm.tabSelecionada === \'dadosHistorico\' || (!vm.etapaAtual.permiteValoresZerados && vm.negocio.valor == 0)\" \naria-label=\"SALVAR\" translate=\"PIPELINE_NEGOCIO.SALVAR\" translate-attr-aria-label=\"PIPELINE_NEGOCIO.SALVAR\" \nng-if=\"vm.tipoEdicao < 3\">Salvar</md-button></div><div layout=\"row\" ng-if=\"vm.tipoEdicao == 1\"><md-button \nclass=\"md-icon-button\" ng-click=\"vm.metodos.excluir($event, vm.negocio)\" aria-label=\"Excluir\" \nng-hide=\"vm.novaEntidade\" ng-disabled=\"vm.requisicaoSolicitada || vm.tabSelecionada === \'dadosHistorico\'\" translate \ntranslate-attr-aria-label=\"PIPELINE_NEGOCIO.EXCLUIR\"><md-icon md-font-icon=\"icon-delete\"></md-icon></md-button></div>\n</md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/pipeline/processamento/pipeline-negocio/dialogs/informativo-atividades-etapa/pipeline-etapa-atividade-dialog.html","<md-dialog id=\"pipeline-etapa-atividade-dialog\" class=\"dialogo-padrao\" aria-label=\"Dialog\"><form \nname=\"vm.form.dialogBacklogColaboradores\" class=\"md-inline-form\" novalidate><md-toolbar class=\"md-accent md-tall\" \nlayout=\"column\"><div class=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" layout-align=\"space-between center\" \nflex><div layout=\"row\" layout-align=\"start center\" flex><span class=\"title text-center\">{{vm.titulo}}</span></div><div \nlayout=\"row\"><md-button class=\"md-icon-button\" ng-click=\"vm.metodos.fecharDialog()\" aria-label=\"Fechar dialog\" \ntranslate translate-attr-aria-label=\"PIPELINE_NEGOCIO.FECHAR_DIALOG\"><md-icon md-font-icon=\"icon-close\"></md-icon>\n</md-button></div></div></md-toolbar><md-dialog-content><div layout-gt-xs=\"row\" flex><md-input-container \nclass=\"md-block\" flex><label translate=\"PIPELINE_NEGOCIO.ATIVIDADES\"></label><textarea ng-model=\"vm.atividadesEtapa\" \nname=\"atividadesEtava\" ng-disabled=\"true\" md-no-resize=\"true\" rows=\"5\" max-rows=\"5\">\r\n                    </textarea>\n</md-input-container></div></md-dialog-content></form></md-dialog>");
$templateCache.put("app/main/pipeline/processamento/pipeline-negocio/dialogs/pipeline-negocio-resultado/pipeline-negocio-resultado-dialog.html","<md-dialog id=\"pipeline-negocio-resultado-dialog\" class=\"dialogo-padrao\" aria-label=\"Dialog\"><form name=\"vm.form\" \nclass=\"md-inline-form\" novalidate><md-toolbar class=\"md-accent md-tall\" layout=\"column\"><div \nclass=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" layout-align=\"space-between center\" flex><div layout=\"row\" \nlayout-align=\"center\" flex><span class=\"title text-center\">Finalização de negócio</span></div><div layout=\"row\">\n<md-button class=\"md-icon-button\" ng-click=\"vm.metodos.fecharDialog()\" aria-label=\"Fechar dialog\" translate \ntranslate-attr-aria-label=\"PIPELINE_NEGOCIO.FECHAR_DIALOG\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button>\n</div></div></md-toolbar><div layout=\"column\" layout-align=\"center center\" ng-show=\"vm.requisicaoSolicitada\"><span \nclass=\"font-weight-500\">{{vm.mensagemPreloader}}</span><md-progress-circular md-mode=\"indeterminate\" md-diameter=\"30\" \nclass=\"md-accent\"></md-progress-circular></div><md-dialog-content><div layout=\"row\" ng-if=\"vm.resultado.status == 2\" \nlayout-align=\"center center\"><md-input-container class=\"md-block\" flex-gt-sm=\"60\"><label \ntranslate=\"PIPELINE_NEGOCIO.MOTIVO_PERDA\"></label><md-select ng-model=\"vm.resultado.codigoPipelineMotivoPerdaNegocio\" \nname=\"motivoPerda\" ng-required=\"true\" ng-disabled=\"vm.requisicaoSolicitada\"><md-option ng-value=\"motivo.codigo\" \nng-repeat=\"motivo in vm.motivosPerda\">{{motivo.codigo}} - {{motivo.descricao}}</md-option></md-select><div \nng-messages=\"vm.form.motivoPerda.$error\"><div ng-message=\"required\" translate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\">\n</div></div></md-input-container></div><div layout=\"row\" flex layout-align=\"start center\"><md-input-container \nclass=\"md-block container-observacao\" flex><label translate=\"PIPELINE_NEGOCIO.OBSERVACAO\"></label><textarea \nname=\"observacao\" mascara-tamanho-campo=\"100\" md-maxlength=\"100\" md-no-resize=\"true\" \nng-model=\"vm.resultado.observacao\">\r\n                    </textarea></md-input-container><md-input-container \nclass=\"md-block container-data\" flex=\"30\"><label translate=\"PIPELINE_NEGOCIO.DATA_ENCERRAMENTO\"></label><md-datepicker \nname=\"dataEncerramento\" mascara-conversor-string-para-data md-min-date=\"vm.dataInicial\" md-max-date=\"vm.dataAtual\" \nng-required=\"true\" ng-mask=\"3?9/1?9/9999\" ng-model=\"vm.resultado.data\"></md-datepicker><div \nng-messages=\"vm.form.dataEncerramento.$error\"><div ng-message=\"valid\" translate=\"MENSAGEM_VALIDACAO.DATA_INVALIDA\">\n</div></div></md-input-container></div></md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"start center\">\n<div layout=\"row\" layout-align=\"start center\"><md-button type=\"submit\" ng-click=\"vm.metodos.salvar($event)\" \nclass=\"send-button md-accent md-raised\" ng-disabled=\"vm.form.$invalid || vm.requisicaoSolicitada\" aria-label=\"SALVAR\" \ntranslate=\"PIPELINE_NEGOCIO.SALVAR\" translate-attr-aria-label=\"PIPELINE_NEGOCIO.SALVAR\">Salvar</md-button><md-button \ntype=\"cancel\" ng-click=\"vm.metodos.cancelar($event)\" class=\"send-button md-accent md-raised\" \nng-disabled=\"vm.requisicaoSolicitada\" aria-label=\"CANCELAR\" translate=\"PIPELINE_NEGOCIO.CANCELAR\" \ntranslate-attr-aria-label=\"PIPELINE_NEGOCIO.CANCELAR\">Cancelar</md-button></div></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/locacao/processamento/locacao/retorno/view/locacao-retorno-form.html","<div id=\"forms\" class=\"page-layout simple fullwidth doc-page\" layout=\"column\"><div class=\"content\" layout=\"column\">\n<form name=\"vm.form\" ms-vertical-stepper ng-submit=\"vm.metodos.validadorCadastroRetorno($event, vm.filtro)\" \nng-model=\"vm.filtro\" on-submit-value-step=\"1\" custom-button-submit-text=\"Avançar\" novalidate><ms-vertical-stepper-step \nng-form=\"vm.form.step.clientes\" step=\"1\" step-title=\"\'Cliente\'\"><div ui-view=\"contrato-step\"></div>\n</ms-vertical-stepper-step><ms-vertical-stepper-step ng-form=\"vm.form.step.tiposLicenca\" step=\"2\" \nstep-title=\"\'Envios\'\"><div ui-view=\"retorno-step\"></div></ms-vertical-stepper-step></form></div></div>");
$templateCache.put("app/main/locacao/processamento/locacao/retorno/view/locacao-retorno-tabela.html","<form id=\"locacao-retorno\"><div flex layout=\"row\" layout-align=\"space-around center\"><md-card flex \nclass=\"blue-bg white-fg\" md-theme-watch style=\"max-width: 32%\"><md-card-title class=\"titulo-card-superior\"><strong>\n<span class=\"blue-bg white-fg texto-card-filtro\">{{ vm.cliente.nome }}</span></strong></md-card-title></md-card>\n<md-card flex class=\"blue-bg white-fg\" md-theme-watch style=\"max-width: 32%\"><md-card-title \nclass=\"titulo-card-superior\" layout=\"column\"><strong><span class=\"blue-bg white-fg texto-card-filtro\">Tipo de contrato \n</span></strong><span>{{ vm.contrato.contratoTipo.descricao }}</span></md-card-title></md-card><md-card flex \nclass=\"blue-bg white-fg\" md-theme-watch style=\"max-width: 32%\"><md-card-title class=\"titulo-card-superior\" \nlayout=\"column\"><strong><span class=\"blue-bg white-fg texto-card-filtro\">Item </span></strong><span>\n{{ vm.contratoItem.produto.descricao }}</span></md-card-title></md-card></div><div flex layout-align=\"center center\" \nlayout-gt-sm=\"row\" style=\"height: 100%\"><div flex flex-gt-sm=\"33\" style=\"height: 62vh\"><md-card flex layout=\"column\" \nstyle=\"height: 100%\"><md-card-title-text><span class=\"md-headline\" layout-align=\"center center\" \nstyle=\"font-size: 20px\">Dados do envio</span></md-card-title-text><div class=\"shortcut-loader\" layout=\"row\" \nlayout-align=\"center center\" ng-if=\"vm.requisicaoSolicitada\"><md-progress-circular class=\"md-accent\" md-diameter=\"20\" \nmd-mode=\"indeterminate\"></md-progress-circular></div><div \nstyle=\"height: 61.5vh; \r\n                            overflow: scroll\" layout=\"column\" \nng-if=\"!vm.requisicaoSolicitada\"><md-content><div layout=\"row\"><div layout=\"column\" flex=\"60\"><md-input-container flex \nstyle=\"margin: 20px 0px 0px 0px; \r\n                                                           width: 100%\"><label>\nData de envio</label><md-datepicker name=\"envioData\" md-max-date=\"\" ng-mask=\"3?9/1?9/9999\" ng-required=\"true\" \nng-model=\"vm.envio.dataEnvio\" disabled=\"disabled\"></md-datepicker></md-input-container><md-input-container flex \nstyle=\"margin: 0px 0px 0px 50px; \r\n                                                           max-width: 100%\"><label>\nNota de saída</label><input name=\"notaFiscalSaida\" md-max-date=\"\" ng-mask=\"3?9/1?9/9999\" ng-required=\"true\" \nng-model=\"vm.envio.notaFiscalSaida\" disabled=\"disabled\"></md-input-container></div><div layout=\"column\" flex>\n<md-input-container flex \nstyle=\"margin: 20px 0px 0px 0px; \r\n                                                           max-width: 100%\"><label>\nAtendimento</label><input name=\"atendimentos\" ng-model=\"vm.atendimentoDados\" ng-required=\"true\" disabled=\"disabled\">\n</md-input-container><md-input-container flex \nstyle=\"margin: 0px 0px 0px 0px; \r\n                                                           max-width: 100%\"><label>\nTipo de locação</label><input name=\"tipoLocacaoId\" ng-model=\"vm.envio.tipoLocacao.descricao\" ng-mask=\"3?9/1?9/9999\" \nng-required=\"true\" disabled=\"disabled\"></md-input-container></div></div></md-content></div></md-card></div><div \nid=\"locacao-retorno\" flex flex-gt-sm=\"33\" style=\"height: 62vh\"><md-card flex layout=\" column\" style=\"height: 100%\">\n<md-card-title-text><span class=\"md-headline\" layout-align=\"center center\" style=\"font-size: 20px\">Locados</span>\n</md-card-title-text><div class=\"shortcut-loader\" layout=\"row\" layout-align=\"center center\" \nng-if=\"vm.requisicaoSolicitada\"><md-progress-circular class=\"md-accent\" md-diameter=\"20\" md-mode=\"indeterminate\">\n</md-progress-circular></div><div style=\"height: 61.5vh; \r\n                            overflow: scroll\" \nng-if=\"!vm.requisicaoSolicitada\"><md-content><md-list flex><div flex style=\"box-shadow: 10px 1px 0px lightgrey\">\n<md-checkbox ng-model=\"vm.marcarTodos\" ng-change=\"vm.metodos.marcarTodos(vm.marcarTodos)\" style=\"margin-left: 26px\">\n<span style=\"margin-left: 22px\">Marcar todos</span></md-checkbox></div><md-list-item class=\"md-3-line espacamento p-8\" \nng-repeat=\"item in vm.locados | orderBy:\'id\' :true\" ng-class=\"{\'zebra\' : $index %2 == 0}\"><md-checkbox \nng-model=\"item.marcado\" style=\"margin-right: 10px\"></md-checkbox><div class=\"md-list-item-text\" layout=\"column\"><h4>\n<strong>N° Série: </strong>{{item.equipamentoNotaItemDetalhe.numeroSerie}}</h4><h4><strong>IMEI: </strong>\n{{item.equipamentoNotaItemDetalhe.imei}}</h4><h4><strong>Equipamento: </strong>\n{{item.equipamentoNotaItemDetalhe.equipamento.descricao}}</h4></div><div layout=\"row\" class=\"md-secondary\"><md-button \nclass=\"md-icon-button siglas\" ng-click=\"vm.metodos.botaoDialogEstadoConservacao($index, item)\">\n{{item.equipamentoNotaItemDetalhe.equipamentoEstadoConservacao.descricao[0] + item.equipamentoNotaItemDetalhe.equipamentoEstadoConservacao.descricao[1]}}\n<md-tooltip><span>Estado de conservação: {{item.equipamentoNotaItemDetalhe.equipamentoEstadoConservacao.descricao}}\n</span></md-tooltip></md-button><md-button class=\"md-icon-button siglas\" ng-disabled=\"vm.locados.length <= 0\" \nng-click=\"vm.metodos.botaoDialogFoto($index, item)\"><i class=\"icon-picture s16 icone-cor-padrao\" \nng-disabled=\"vm.controleForm.emProgresso\"></i><md-tooltip><span>Fotos</span></md-tooltip></md-button></div>\n</md-list-item></md-list></md-content></div><div layout-gt-xs=\"row\" layout-align=\"end end\" \nng-if=\"!vm.requisicaoSolicitada\" style=\"height: 0px\"><md-button class=\"md-fab md-accent md-icon-button\" \nng-click=\"vm.metodos.botaoDialog()\" style=\"margin: 0px 10px 10px 0px\"><i class=\"icon-arrow-right white-fg\"><md-tooltip>\n<span>Retornar equipamento</span></md-tooltip></i></md-button></div></md-card></div><div flex flex-gt-sm=\"33\" \nstyle=\"height: 62vh\"><md-card flex layout=\" column\" style=\"height: 100%\"><md-card-title-text><span class=\"md-headline\" \nlayout-align=\"center center\" style=\"font-size: 20px\">Dados do retorno</span></md-card-title-text><div \nclass=\"shortcut-loader\" layout=\"row\" layout-align=\"center center\" ng-if=\"vm.requisicaoSolicitada\"><md-progress-circular\n class=\"md-accent\" md-diameter=\"20\" md-mode=\"indeterminate\"></md-progress-circular></div><div \nstyle=\"height: 61.5vh; \r\n                            overflow: scroll\" ng-if=\"!vm.requisicaoSolicitada\"><md-content>\n<md-list flex><md-list-item class=\"md-3-line\" ng-repeat=\"item in vm.retornosPorEnvio | orderBy:\'id\' :true \" \nng-class=\"{\'zebra\' : $index %2 == 0}\" style=\"box-shadow: 10px 1px 0px lightgrey\"><div class=\"md-list-item-text\" \nlayout=\"column\"><h4><strong>Atendimento</strong>: {{item.atendimentoId}}/{{item.atendimentoAno}}</h4><h4><strong>\nNota de saída</strong>: {{item.notaFiscalDevolucao}}</h4><h4><strong>Data</strong>\n: {{item.dataRetorno | date:\'dd/MM/yyyy\'}}</h4></div><div layout=\"row\" class=\"md-secondary\"><md-button \nclass=\"md-icon-button siglas\" ng-click=\"vm.metodos.dialogEditarRetorno(item)\"><i \nclass=\"icon-pencil s16 icone-cor-padrao\" ng-disabled=\"vm.controleForm.emProgresso\"></i><md-tooltip><span>Editar</span>\n</md-tooltip></md-button></div></md-list-item></md-list></md-content></div></md-card></div></div></form>");
$templateCache.put("app/main/locacao/processamento/locacao/retorno/view/locacao-retorno.html","<div id=\"locacao-retorno\" layout=\"column\"><div class=\"header md-accent-bg\" layout=\"column\"><div class=\"header-content\" \nlayout=\"row\" layout-wrap flex><div layout=\"row\" layout-align=\"center center\" ng-if=\"vm.mostrarTabela == true\">\n<md-button class=\"md-accent md-raised md-hue-2 header-boards-button\" ng-click=\"vm.metodos.botaoVoltar()\" \naria-label=\"Voltar\" translate translate-attr-aria-label=\"VOLTAR\" ng-if=\"!vm.requisicaoSolicitada\"><md-icon \nmd-font-icon=\"icon-chevron-double-left\" class=\"icon\"></md-icon><span translate=\"VOLTAR\"></span></md-button></div><div \nflex style=\"align-self: center; text-align: center\"><h1 layout-align=\"center center\" \nstyle=\"font-size: 24px; text-align: left; margin-left: 40px\">Retorno Locação</h1></div></div></div><div \nclass=\"content\" ng-if=\"!vm.mostrarTabela\"><div ui-view=\"locacao-retorno-form\"></div></div><div \nui-view=\"locacao-retorno-tabela\" ng-if=\"vm.mostrarTabela\"></div></div>");
$templateCache.put("app/main/pipeline/processamento/pipeline-negocio/views/pipeline-funis/pipeline-funis.html","<div class=\"page-layout simple tabbed\" layout=\"column\"><header-padrao ng-utiliza-pesquisa=\"false\" \ntranslate-nome=\"PIPELINE_NEGOCIO.NEGOCIOS\"></header-padrao><div id=\"pipeline-funis\" layout=\"column\" flex><div \nid=\"board-selector\" layout=\"column\" layout-align=\"start center\" flex><div class=\"board-list\" layout=\"row\" \nlayout-align=\"center center\" layout-wrap><div class=\"board-list-item funil\" ng-repeat=\"funil in vm.funis\" \nui-sref=\"app.pipeline_processamento_pipelinenegocio.funis.negocios({ \r\n                                                                                codigoFunil:funil.codigo, \r\n                                                                                funilDescricao: funil.descricao\r\n                                                                              })\" \nlayout=\"column\" layout-align=\"center center\"><md-icon md-font-icon=\"icon-filter\" color=\"white\" class=\"icon s64\">\n</md-icon><span class=\"board-name\">{{ vm.metodos.exibirDescricao(funil.descricao) }}</span></div></div></div></div>\n</div>");
$templateCache.put("app/main/pipeline/processamento/pipeline-negocio/views/pipeline-negocios/pipeline-negocio-negocios.html","<div layout=\"column\" layout-align=\"center center\" class=\"pre-loader-full-width\" \nng-if=\"vm.etapasFunilFiltro.emProgresso\" flex><md-progress-circular md-mode=\"indeterminate\" class=\"md-accent\" \nmd-diameter=\"70\"></md-progress-circular></div><div id=\"board\" class=\"board\" ng-model=\"vm.etapasFiltradasPorProduto\" \nlayout=\"row\" flex><div class=\"list-wrapper\" ng-repeat=\"etapa in vm.etapasFiltradasPorProduto\"><div \nclass=\"list md-whiteframe-1dp\" layout=\"column\"><div class=\"list-header\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"list-header-name text-center\" flex><span>\n{{etapa.nivel}} - {{etapa.descricao}}</span></div><md-menu md-offset=\"0 48px\" \nclass=\"options list-header-option-button\"><md-button class=\"md-icon-button\" ng-click=\"$mdMenu.open($event)\" \naria-label=\"Options\" translate translate-attr-aria-label=\"PIPELINE_NEGOCIO.OPCOES\"><md-icon md-menu-origin \nmd-font-icon=\"icon-dots-vertical\"></md-icon></md-button><md-menu-content class=\"options-menu-content\" width=\"4\">\n<md-menu-item><md-button ng-click=\"vm.metodos.abrirDialogExibirAtividadesEtapa($event, etapa.atividades)\" \naria-label=\"Visualizar Atividades\" translate translate-attr-aria-label=\"PIPELINE_NEGOCIO.VISUALIZAR_ATIVIDADES\">\n<md-icon md-font-icon=\"icon-view-list\" md-menu-align-target></md-icon><span \ntranslate=\"PIPELINE_NEGOCIO.VISUALIZAR_ATIVIDADES\"></span></md-button></md-menu-item><md-menu-item \nng-if=\"etapa.totalNegocios > 0\"><md-button ng-disabled=\"true\"><span class=\"badge mr-5\" \nng-if=\"etapa.totalNegocios == 1\">{{etapa.totalNegocios}} negócio</span> <span class=\"badge mr-5\" \nng-if=\"etapa.totalNegocios > 1\">{{etapa.totalNegocios}} negócios</span> <span ng-if=\"etapa.valorTotalNegocios > 0\" \nclass=\"badge\">Total de {{etapa.valorTotalNegocios | currency:\"R$ \"}}</span></md-button></md-menu-item>\n</md-menu-content></md-menu></div><div class=\"list-content\" layout=\"column\"><div class=\"list-cards\" \nng-model=\"etapa.negocios\" ui-sortable=\"vm.sortableCardOptions\" ms-scroll><div class=\"list-card md-whiteframe-2dp\" \nng-dblclick=\"vm.metodos.abrirDialogNegocio($event, negocio, etapa)\" ng-repeat=\"negocio in etapa.negocios\"><div \nclass=\"list-card-details\"><div id=\"list-card-icon-handle\" class=\"list-card-sort-handle\"><md-icon \nmd-font-icon=\"icon-cursor-move\" class=\"icon s16\"></md-icon></div><div class=\"list-card-name text-center\">\n{{negocio.nomeCliente}}</div><div id=\"list-card-responsavel\" class=\"list-card-badges mt-5\" layout=\"row\" \nlayout-align=\"start center\" ng-if=\"negocio.nomeColaboradorResponsavel\"><span layout=\"row\" class=\"list-card-name\" \nlayout-align=\"start center\"><i class=\"icon-account s16\"></i> <span>\nExec. de Contas: {{negocio.nomeColaboradorResponsavel}}</span></span></div><div id=\"list-card-produtos\" \nclass=\"list-card-badges\" layout=\"row\" style=\"margin-top: -10px\" layout-align=\"start start\" \nng-if=\"negocio.produtos && negocio.produtos.length > 0\"><i class=\"icon-responsive s16\" style=\"margin-right: 2px\"></i> \n<span class=\"list-card-name\"><span ng-if=\"negocio.produtos.length == 1\">Produto: {{negocio.produtos[0].descricao}}\n</span> <span ng-if=\"negocio.produtos.length > 1\">Produtos: <span ng-repeat=\"produto in negocio.produtos\">\n{{produto.descricao}}<span ng-if=\"!$last\">,</span></span></span></span></div><div id=\"list-card-datas\" \nclass=\"list-card-badges\" layout=\"row\" layout-align=\"space-between center\"><div class=\"badge due-date\" layout=\"row\" \nlayout-align=\"start center\" flex=\"50\"><i class=\"icon-clock s16\"></i><div layout=\"column\" layout-align=\"center center\" \nclass=\"ml-5\"><span class=\"date-label\">Início</span> <span class=\"date-value\">\n{{negocio.dataInicial | date:\'dd/MM/yyyy\'}}</span></div></div><div class=\"badge due-date\" \nng-class=\"{\'overdue\': vm.metodosPipelineService.verificarData(negocio.dataFinalEtapa)}\" layout=\"row\" \nlayout-align=\"start center\" flex=\"50\"><i class=\"icon-clock s16\"></i><div layout=\"column\" layout-align=\"center start\" \nclass=\"ml-5\"><span class=\"date-label\">Vencimento</span> <span class=\"date-value\">\n{{negocio.dataFinalEtapa | date:\'dd/MM/yyyy\'}}</span></div></div></div><div id=\"list-card-valor\" \nclass=\"list-card-badges\" layout=\"row\" flex=\"100\" layout-align=\"start center\"><span layout=\"row\" class=\"list-card-name\" \nlayout-align=\"start center\"><span>Valor:&nbsp;&nbsp;</span> <span>{{negocio.valor | currency:\"R$ \"}}</span></span>\n</div></div><div id=\"list-card-atendimento\" class=\"list-card-footer\" layout=\"row\" layout-align=\"space-between center\">\n<div class=\"list-card-badges\" layout=\"row\" layout-align=\"center center\" flex><span layout=\"row\" class=\"list-card-name\" \nstyle=\"font-size:14px !important\" layout-align=\"center center\" \nng-if=\"negocio.codigoAtendimento && negocio.anoAtendimento\" flex><i class=\"icon-phone s16\"></i> <span class=\"ml-5\">\nAtendimento: {{negocio.codigoAtendimento + \"/\" + negocio.anoAtendimento}}</span> </span><span layout=\"row\" \nclass=\"list-card-name\" style=\"font-size:14px !important\" layout-align=\"center center\" \nng-if=\"negocio.codigoAtendimento && negocio.anoAtendimento\" \nng-click=\"vm.metodosPipelineService.navegarParaAtendimento(negocio.codigoAtendimento, negocio.anoAtendimento)\"><i \nclass=\"icon-open-in-new s18\"></i><md-tooltip><span translate=\"PIPELINE_NEGOCIO.NAVEGAR_PARA_ATENDIMENTO\"></span>\n</md-tooltip></span></div></div></div></div></div></div></div></div><div id=\"resultados\" class=\"board\" layout=\"row\" \nng-show=\"vm.arrastandoNegocio\"><div class=\"list-wrapper\" \nng-repeat=\"resultado in vm.resultadosNegocio track by resultado.codigo\" layout=\"row\" flex=\"50\"><div \nclass=\"list negocio-ganho-perdido\" \nng-class=\"{\'negocio-ganho\': (resultado.codigo == 0), \'negocio-perdido\': (resultado.codigo == 1)}\" layout=\"column\" \nflex=\"100\" layout-align=\"center center\"><span class=\"title-header\">{{resultado.descricao}}</span><div \nclass=\"list-content\" layout=\"column\"><div class=\"list-cards resultadoCards\" ng-model=\"resultado.negocios\" \nui-sortable=\"vm.sortableResultadoNegocio\"><div class=\"list-card md-whiteframe-2dp\" \nng-repeat=\"negocio in resultado.negocios\"></div></div></div></div></div></div>");
$templateCache.put("app/main/manutencao/dashboard/views/dialogs/dialog-equipamentos/dialog-equipamentos.html","<md-dialog id=\"dialog-ordens-servico-equipamentos\" class=\"dialogo-padrao\" aria-label=\"Dialog\"><md-toolbar \nclass=\"md-accent md-tall\" layout=\"column\"><div class=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" \nlayout-align=\"space-between center\"><span class=\"title\">Equipamentos</span><div layout=\"row\" layout-align=\"end center\">\n<md-button class=\"md-icon-button\" ng-click=\"vm.metodosDialog.fecharDialog()\" aria-label=\"Fechar dialog\" translate \ntranslate-attr-aria-label=\"SPRINT.FECHAR_DIALOG\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></div>\n</md-toolbar><md-dialog-content><table class=\"dataTable row-border hover\" datatable=\"ng\" \ndt-options=\"vm.dtOptionsOrdensServicoPeriodo\" width=\"100%\"><thead><tr><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title text-center\">Equipamento</span></div></th><th class=\"secondary-text\">\n<div class=\"table-header\"><span class=\"column-title text-center\">Manutenção por equipamento</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title text-center\">OS por equipamento</span></div>\n</th></tr></thead><tbody><tr ng-repeat=\"os in vm.equipamentos\"><td class=\"border-left border-right text-center\">\n{{os.equipamento}}</td><td class=\"border-right text-center\">{{os.quantidadeEquipamento}}</td><td \nclass=\"border-right text-center\">{{os.quantidadeOrdemServico}}</td></tr></tbody></table></md-dialog-content>\n</md-dialog>");
$templateCache.put("app/main/manutencao/dashboard/views/dialogs/dialog-ordens-servico-periodo/dialog-ordens-servico-periodo.html","<md-dialog id=\"dialog-ordens-servico-periodo\" class=\"dialogo-padrao\" aria-label=\"Dialog\"><md-toolbar \nclass=\"md-accent md-tall\" layout=\"column\"><div class=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" \nlayout-align=\"space-between center\"><span class=\"title\">Ordens de serviço</span><div layout=\"row\" \nlayout-align=\"end center\"><div class=\"pesquisar\" layout=\"row\" layout-align=\"start start\" flex><label><md-icon \nmd-font-icon=\"icon-magnify\" class=\"white-text icon search-icon\"></md-icon></label><input id=\"pesquisar\" \nclass=\"pesquisar-input\" type=\"text\" placeholder=\"Pesquisar\" translate \ntranslate-attr-placeholder=\"CABECALHO_PADRAO.PESQUISAR\" ng-model=\"vm.pesquisar\" ng-model-options=\"{debounce: 400}\" \nflex></div><md-button class=\"md-icon-button\" ng-click=\"vm.metodosDialog.fecharDialog()\" aria-label=\"Fechar dialog\" \ntranslate translate-attr-aria-label=\"SPRINT.FECHAR_DIALOG\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button>\n</div></div></md-toolbar><md-dialog-content flex><table class=\"dataTable row-border hover\" datatable=\"ng\" \ndt-options=\"vm.dtOptionsOrdensServicoPeriodo\" width=\"100%\"><thead><tr><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title text-center\">Nº da OS</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title text-center\">Tipo de Serviço</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title text-center\">Cliente</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title text-center\">Status</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title text-center\">VL. Peça</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title text-center\">VL. Mão de Obra</span></div>\n</th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title text-center\">VL. Frete</span></div>\n</th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title text-center\">VL. Faturado</span>\n</div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title text-center\">Téc. Resp.\n</span></div></th></tr></thead><tbody><tr ng-repeat=\"os in vm.ordensServico\"><td \nclass=\"border-left border-right text-center\"><div layout-align=\"center center\" layout=\"row\"><i \nclass=\"icon-open-in-new s16 icone-cor-padrao mr-10\" ng-click=\"vm.metodosDialog.abrirOS(os)\"></i><p style=\"margin: 0px\">\n{{os.ordemServicoNumero}}/{{os.ordemServicoAno}}</p></div></td><td class=\"border-right text-center\">\n{{os.ordemServicoTipoServico}}</td><td class=\"border-right text-center\">{{os.clienteDescricao}}</td><td \nclass=\"border-right text-center\">{{vm.metodosDialog.retornaStatus(os.status)}}</td><td \nclass=\"border-right text-center\"><span>{{vm.converteParaReal(os.valorPeca)}}</span></td><td \nclass=\"border-right text-center\"><span class=\"none\">{{os.valorMaoObra}}</span> <span>\n{{vm.converteParaReal(os.valorMaoObra)}}</span></td><td class=\"border-right text-center\"><span class=\"none\">\n{{os.valorFrete}}</span> <span>{{vm.converteParaReal(os.valorFrete)}}</span></td><td class=\"border-right text-center\">\n<span class=\"none\">{{os.valorFaturado}}</span> <span>{{vm.converteParaReal(os.valorFaturado)}}</span></td><td \nclass=\"border-right text-center\"><md-button class=\"md-icon-button md-avatar siglas\">\n{{vm.metodosDialog.retornaIniciasNomeUsuario(os.tecnicoResponsavel)}}<md-tooltip><span>\n{{vm.metodosDialog.retornaUsuario(os.tecnicoResponsavel) | uppercase}}</span></md-tooltip></md-button></td></tr>\n</tbody></table></md-dialog-content></md-dialog>");
$templateCache.put("app/main/manutencao/dashboard/views/dialogs/dialog-clientes/dialog-clientes.html","<md-dialog id=\"dialog-ordens-servico-clientes\" class=\"dialogo-padrao\" aria-label=\"Dialog\"><md-toolbar \nclass=\"md-accent md-tall\" layout=\"column\"><div class=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" \nlayout-align=\"space-between center\"><span class=\"title\">Clientes</span><md-button class=\"md-icon-button\" \nng-click=\"vm.metodosDialog.fecharDialog()\" aria-label=\"Fechar dialog\" translate \ntranslate-attr-aria-label=\"SPRINT.FECHAR_DIALOG\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content style=\"overflow-y: scroll;max-height: 80vh\"><div layout=\"column\" class=\"tabela\" \nng-if=\"statusOS.ordemServicoPorCliente.length > 0\" ng-repeat=\"statusOS in vm.ordensServicoCliente\"><div layout=\"row\" \nstyle=\"align-items: center\"><span class=\"span\">Status:</span><p class=\"status\">{{statusOS.descricaoStatus}}</p></div>\n<table class=\"dataTable row-border hover\" datatable=\"ng\" dt-options=\"vm.dtOptionsClientes\" width=\"100%\"><thead \nclass=\"table-header\"><th class=\"secondary-text\" style=\"width: 30%\"><div class=\"table-header\"><span \nclass=\"column-title text-center\">Cliente</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title text-center\">Quantidade de OS</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title text-center\">VL. Peça</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title text-center\">VL. Mão de Obra</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title text-center\">VL. Frete</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title text-center\">VL. Faturado</span></div></th>\n</thead><tbody><tr ng-repeat=\"os in statusOS.ordemServicoPorCliente\"><td class=\"text-center\" style=\"width: 30%\">\n{{os.clienteDescricao}}</td><td class=\"text-center\">{{os.quantidaDeOS}}</td><td class=\"text-center\">\n{{vm.converteParaReal(os.valorPeca)}}</td><td class=\"text-center\">{{vm.converteParaReal(os.valorMaoObra)}}</td><td \nclass=\"text-center\">{{vm.converteParaReal(os.valorFrete)}}</td><td class=\"text-center\">\n{{vm.converteParaReal(os.valorFaturado)}}</td></tr></tbody></table></div></md-dialog-content></md-dialog>");
$templateCache.put("app/main/manutencao/ordem-servico/views/dialogs/dialog-ordem-servico-envio/dialog-ordem-servico-envio.html","<md-dialog id=\"dialogEnvio\" aria-label=\"OS\" style=\"width: 60%\"><form class=\"md-inline-form\" name=\"vm.form\" novalidate>\n<md-toolbar><div class=\"md-toolbar-tools\" style=\"background-color: #039BE5\"><h2>Envio</h2><span flex></span><md-button \nclass=\"md-icon-button\" ng-click=\"vm.metodos.cancel()\" aria-label=\"Fechar dialog\" translate \ntranslate-attr-aria-label=\"CLIENTE.FECHAR_DIALOG\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content class=\"pt-5\" layout=\"column\"><div layout=\"column\"><div class=\"div-envio-1\" \nlayout=\"row\" layout-align=\"space-around\" flex><md-input-container flex-gt-sm=\"25\" flex><label>Envio</label>\n<md-datepicker name=\"data\" md-min-date=\"vm.dataExecFinalParaODialogDeEnvio\" ng-mask=\"3?9/1?9/9999\" \nng-model=\"vm.envio.dataEnvio\" ng-disabled=\"vm.apenasVisualizacao\" ng-required=\"true\"></md-datepicker><div \nng-messages=\"vm.form.data.$error\"><div ng-message=\"valid\" translate=\"MENSAGEM_VALIDACAO.DATA_INVALIDA\"></div><div \nng-message=\"required\" translate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container>\n<md-input-container flex-gt-sm=\"25\" flex><label>Recebimento</label><md-datepicker name=\"recebimento\" \nng-model=\"vm.envio.dataRecebimento\" ng-mask=\"3?9/1?9/9999\" ng-disabled=\"vm.apenasVisualizacao\"></md-datepicker><div \nng-messages=\"vm.form.recebimento.$error\"><div ng-message=\"valid\" translate=\"MENSAGEM_VALIDACAO.DATA_INVALIDA\"></div>\n<div ng-message=\"required\" translate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container>\n<md-input-container flex-gt-sm=\"20\" flex style=\"margin-bottom: 42px\"><label>Tipo envio</label><md-select name=\"envio\" \nng-model=\"vm.envio.ordemServicoTipoEnvioId\" ng-required=\"true\"><md-option ng-repeat=\"envio in vm.tiposEnvios\" \nng-value=\"envio.id\">{{envio.descricao}}</md-option></md-select><div ng-messages=\"vm.form.envio.$error\"><div \nng-message=\"required\" translate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container></div><div \nclass=\"div-envio-2\" layout=\"row\" layout-align=\"space-around\" flex><md-input-container flex-gt-sm=\"20\" flex><label \ntranslate=\"Código postagem\"></label><input type=\"text\" name=\"postagem\" ng-model=\"vm.envio.codigoPostagem\">\n</md-input-container><md-input-container flex-gt-sm=\"20\" flex><label translate=\"Nota saída\"></label><input type=\"text\" \nng-model=\"vm.envio.notaSaida\" name=\"notaSaida\"></md-input-container><md-input-container class=\"md-block\" \nflex-offset-gt-sm=\"5\" style=\"margin: 0px;\r\n                                               margin-left: 50px\">\n<md-checkbox aria-label=\"Ativo\" name=\"ativo\" ng-model=\"vm.envio.recebido\" \nng-change=\"vm.metodos.verificaCheckRecebido(vm.envio.recebido)\"><span class=\"float-label-cor-default\" \ntranslate=\"Recebido\"></span></md-checkbox></md-input-container><md-input-container flex-gt-sm=\"20\" flex><label \ntranslate=\"Recebido por\"></label><input type=\"text\" name=\"Recebido por\" md-maxlength=\"50\" mascara-tamanho-campo=\"50\" \nng-model=\"vm.envio.recebidoPor\" ng-disabled=\"!vm.envio.recebido\" ng-required=\"vm.envio.recebido\"></md-input-container>\n</div><div layout=\"row\" flex style=\"justify-content: center\"><md-button class=\"md-raised md-accent\" \nstyle=\"height: 20%\" ng-click=\"vm.metodos.salvar(vm.envio)\" ng-if=\"!vm.editando\" \nng-disabled=\"vm.form.$invalid || vm.form.$pristine\">Salvar</md-button><md-button class=\"md-raised md-accent\" \nstyle=\"height: 20%\" ng-click=\"vm.metodos.editar(vm.envio)\" ng-if=\"vm.editando\" \nng-disabled=\"vm.form.$invalid || vm.form.$pristine\">Editar</md-button></div></div></md-dialog-content></form>\n</md-dialog>");
$templateCache.put("app/main/manutencao/ordem-servico/views/dialogs/dialog-ordem-servico/dialog-ordem-servico.html","<md-dialog id=\"dialogOS\" aria-label=\"OS\" class=\"dialog-os\"><form name=\"vm.form\" class=\"md-inline-form\" novalidate>\n<md-toolbar><div class=\"md-toolbar-tools titulo\" style=\"background-color: #039BE5\"><h2 ng-if=\"vm.editando\">\nOrdem serviço - {{vm.ordemServico.numero}}/{{vm.ordemServico.ano}}</h2><h2 ng-if=\"!vm.editando\">Ordem serviço</h2><span\n flex></span><md-button class=\"md-icon-button\" ng-click=\"vm.metodos.cancel()\" aria-label=\"Fechar dialog\" translate \ntranslate-attr-aria-label=\"CLIENTE.FECHAR_DIALOG\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content layout=\"column\"><div layout=\"column\"><div class=\"dialog-os__mensagem-os-executada\" \nng-if=\"vm.ordemServico.status == 3 && !vm.apenasVisualizacao\"><span>Não é possível editar OS executada.</span></div>\n<div layout=\"column\" flex><div layout-gt-sm=\"row\" flex><md-input-container flex-gt-sm=\"10\" flex><label \ntranslate=\"Número\"></label><input type=\"text\" ng-model=\"vm.ordemServico.numero\" name=\"numero\" ng-disabled=\"true\">\n</md-input-container><md-input-container flex-gt-sm=\"10\" flex><label translate=\"Ano\"></label><input type=\"text\" \nng-model=\"vm.ordemServico.ano\" name=\"ano\" ng-disabled=\"true\"></md-input-container><md-input-container flex><label>\nAbertura</label><md-datepicker ng-model=\"vm.ordemServico.dataEntrada\" \nng-disabled=\"vm.apenasVisualizacao || vm.editando\" name=\"data\" ng-mask=\"3?9/1?9/9999\"></md-datepicker>\n</md-input-container><md-input-container flex><label>Entrega</label><md-datepicker \nng-model=\"vm.ordemServico.provavelDataEntrega\" name=\"data\" md-min-date=\"vm.ordemServico.dataEntrada\" \nng-mask=\"3?9/1?9/9999\" \nng-change=\"vm.metodos.validarProvavelDataEntrega(vm.ordemServico.provavelDataEntrega, vm.ordemServico.dataEntrada, vm.form)\" \nng-disabled=\"vm.apenasVisualizacao || vm.ordemServico.status == 3\" ng-required=\"true\"></md-datepicker><div \nng-messages=\"vm.form.data.$error\"><div ng-message=\"provavelDataEntrega\" translate=\"MENSAGEM_VALIDACAO.DATA_INVALIDA\">\n</div><div ng-message=\"valid\" translate=\"MENSAGEM_VALIDACAO.DATA_INVALIDA\"></div><div ng-message=\"mindate\" \ntranslate=\"MENSAGEM_VALIDACAO.DATA_INVALIDA\"></div><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container><md-input-container flex-gt-sm=\"15\" \nclass=\"responsavel\" flex><label>Responsável</label><md-select name=\"usuario\" ng-model=\"vm.ordemServico.usuarioId\" \nng-disabled=\"true\"><md-option ng-repeat=\"usuario in vm.usuarios\" ng-value=\"usuario.codigo\">{{usuario.login}}\n</md-option></md-select></md-input-container><md-input-container class=\"responsavel\" flex><label>Status</label>\n<md-select name=\"status\" ng-model=\"vm.ordemServico.status\" \nng-disabled=\"!vm.editando || vm.apenasVisualizacao || vm.ordemServico.status == 3\" \nng-change=\"vm.metodos.limparCampoMotivoCancelamentoReprovacao(vm.ordemServico)\"><md-option \nng-repeat=\"status in vm.fases\" \nng-hide=\"(vm.ordemServicoStatusAtual == 1 && (status.codigo != 1 && status.codigo != 4 && (status.codigo != 5 || vm.ordemServico.ordemServicoTipoServicoId != 2))) ||\r\n                                                    (vm.ordemServicoStatusAtual == 2 && (status.codigo != 2 && status.codigo != 4 && (status.codigo != 5 || vm.ordemServico.ordemServicoTipoServicoId != 2))) ||\r\n                                                    (vm.ordemServicoStatusAtual == 3 && status.codigo == 3) ||\r\n                                                    (vm.ordemServicoStatusAtual == 4 && (status.codigo != 2 && status.codigo != 4)) ||\r\n                                                    (vm.ordemServicoStatusAtual == 5 && (status.codigo != 2 && status.codigo != 4 && status.codigo != 5))\" \nng-value=\"status.codigo\">{{status.descricao}}</md-option></md-select></md-input-container></div><div layout=\"row\" \nng-if=\"vm.ordemServico.status == 4 || vm.ordemServico.status == 5\" flex><md-input-container class=\"md-block\" \nstyle=\"margin-top: 0px; margin-bottom: 0px\" flex><label translate=\"\">Motivo do cancelamento ou reprovação</label>\n<textarea ng-model=\"vm.ordemServico.motivoCancelamentoReprovacao\" name=\"motivoCancelamentoReprovacao\" \nmascara-tamanho-campo=\"100\" md-maxlength=\"100\" \nng-required=\"vm.ordemServico.status == 4 || vm.ordemServico.status == 5\" ng-disabled=\"vm.apenasVisualizacao\" \nmax-rows=\"4\"></textarea><div ng-messages=\"vm.form.motivoCancelamentoReprovacao.$error\"><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container></div></div><div layout=\"row\" \nclass=\"div-empresa-tipo-prioridade\"><md-input-container flex=\"50\" class=\"iputs\"><label>Tipo serviço</label><md-select \nng-disabled=\"vm.apenasVisualizacao || vm.editando\" name=\"servico\" ng-model=\"vm.ordemServico.ordemServicoTipoServicoId\" \nng-change=\"vm.metodos.verificarQualPesquisaDeClienteFazer(vm.ordemServico.ordemServicoTipoServicoId)\" \nng-required=\"!(vm.editando || vm.apenasVisualizacao)\"><md-option ng-repeat=\"servico in vm.tipoServicos\" \nng-value=\"servico.id\">{{servico.descricao}}</md-option></md-select><div ng-messages=\"vm.form.servico.$error\"><div \nng-message=\"required\" translate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container>\n<md-input-container flex=\"50\" class=\"iputs\"><label>Empresa ativo</label><md-select name=\"empresaAtivo\" \nng-model=\"vm.ordemServico.empresaAtivoId\" \nng-required=\"vm.ordemServico.ordemServicoTipoServicoId == 1 && !(vm.editando || vm.apenasVisualizacao)\" \nng-class=\"{\'desabilitar\' : vm.ordemServico.ordemServicoTipoServicoId != 1}\" \nng-disabled=\"vm.apenasVisualizacao || vm.editando || vm.ordemServico.ordemServicoTipoServicoId != 1\"><md-option \nng-repeat=\"empresa in vm.empresaAtivos\" ng-value=\"empresa.id\">{{empresa.codigo}} - {{empresa.nome}}</md-option>\n</md-select><div ng-messages=\"vm.form.empresaAtivo.$error\"><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container></div><div layout-gt-sm=\"row\" flex>\n<div layout=\"column\" flex-gt-sm=\"50\"><md-autocomplete flex-gt-sm=\"30\" flex-gt-xs md-input-name=\"cliente\" \nmd-no-cache=\"true\" md-selected-item=\"vm.cliente\" \nmd-selected-item-change=\"vm.metodos.alterarItemSelecionadoAutoCompleteCliente(item)\" \nmd-search-text=\"vm.textoDePesquisaAutoCompleteCliente\" \nmd-items=\"item in vm.metodos.pesquisarAutoCompleteCliente(vm.textoDePesquisaAutoCompleteCliente)\" \nmd-item-text=\"item.nome\" md-autoselect md-floating-label=\"Cliente\" \nng-required=\"vm.ordemServico.ordemServicoTipoServicoId == 1 && !(vm.editando || vm.apenasVisualizacao)\" \nng-disabled=\"vm.apenasVisualizacao || vm.editando\"><md-item-template><span \nmd-highlight-text=\"vm.textoDePesquisaAutoCompleteCliente\">{{item.nome}}</span></md-item-template><md-not-found><label>\nNão foi encontrado nenhum Cliente.</label></md-not-found></md-autocomplete></div><div layout=\"row\" flex>\n<md-input-container class=\"md-block\" flex><label translate=\"\">Tipo de Contrato</label><md-select name=\"contrato\" \nng-model=\"vm.ordemServico.contrato\" \nng-disabled=\"vm.filtro.cliente == null || vm.apenasVisualizacao || vm.editando || vm.ordemServico.ordemServicoTipoServicoId != 1\" \nng-required=\"vm.ordemServico.ordemServicoTipoServicoId == 1 && !(vm.editando || vm.apenasVisualizacao)\" \nng-class=\"{\'desabilitar\' : vm.ordemServico.ordemServicoTipoServicoId != 1}\" \nng-change=\"vm.metodos.changeTipoContrato(vm.ordemServico)\"><md-option ng-value=\"contrato.codigo\" \nng-repeat=\"contrato in vm.contratos\">{{ contrato.contratoTipo.descricao }}</md-option></md-select></md-input-container>\n<md-input-container class=\"md-block\" flex><label translate=\"\">Item do Contrato</label><md-select name=\"contratoItens\" \nng-model=\"vm.ordemServico.contratoItem\" \nng-disabled=\"vm.ordemServico.contrato == null || vm.apenasVisualizacao || vm.editando || vm.ordemServico.ordemServicoTipoServicoId != 1\" \nng-required=\"vm.ordemServico.ordemServicoTipoServicoId == 1 && !(vm.editando || vm.apenasVisualizacao)\"><md-option \nng-value=\"contratoItens.codigo\" ng-repeat=\"contratoItens in vm.contrato.contratoItens\">\n{{ contratoItens.produto.descricao }}</md-option></md-select></md-input-container></div></div><div layout=\"row\" flex>\n<md-input-container flex=\"70\"><label>Atendimento:</label><md-select ng-model=\"vm.atendimento\" name=\"atendimento\" \nng-required=\"vm.cliente.codigo && !(vm.editando || vm.apenasVisualizacao)\" \nng-disabled=\"vm.filtro.cliente == null || vm.apenasVisualizacao\" \nng-class=\"{\'desabilitar\' : vm.filtro.cliente == null}\"><md-option layout=\"row\" ng-repeat=\"item in vm.atendimentos\" \nng-value=\"item\">{{ item.codigo }}/{{ item.ano }} - {{item.assunto}}</md-option></md-select><div \nng-messages=\"vm.form.atendimento.$error\"><div ng-message=\"required\" translate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\">\n</div></div></md-input-container><md-input-container flex=\"30\" class=\"iputs\"><label>Prioridade</label><md-select \nng-disabled=\"vm.apenasVisualizacao || vm.ordemServico.status == 3\" name=\"prioridade\" \nng-model=\"vm.ordemServico.ordemServicoPrioridadeId\" ng-required=\"true\"><md-option \nng-repeat=\"prioridade in vm.prioridades\" ng-value=\"prioridade.id\">{{prioridade.descricao}}</md-option></md-select><div \nng-messages=\"vm.form.prioridade.$error\"><div ng-message=\"required\" translate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\">\n</div></div></md-input-container></div><div layout=\"row\" flex style=\"justify-content: center\"><div layout=\"row\" \nlayout-align=\"center center\" ng-if=\"vm.salvando\" flex><div layout=\"column\" layout-align=\"center center\">\n<md-progress-circular md-mode=\"indeterminate\" md-diameter=\"50\" class=\"md-accent\"></md-progress-circular></div></div>\n<md-button ng-click=\"vm.metodos.gravar(vm.ordemServico)\" class=\"send-button md-accent md-raised\" aria-label=\"Salvar\" \nng-if=\"!vm.apenasVisualizacao\" ng-hide=\"vm.salvando\" ng-disabled=\"vm.form.$invalid || vm.ordemServico.status == 3\" \ntranslate=\"GROUP_BUTTON_HORIZONTAL.SALVAR\"></md-button></div></div></md-dialog-content></form></md-dialog>");
$templateCache.put("app/main/manutencao/ordem-servico/views/dialogs/dialog-ordem-servico-execucao/dialog-ordem-servico-execucao.html","<md-dialog id=\"dialogExecucao\" class=\"dialog-pai\" aria-label=\"OS\"><form name=\"vm.form\" class=\"md-inline-form\" \nnovalidate><md-toolbar><div class=\"md-toolbar-tools titulo\" style=\"background-color: #039BE5\"><h2 \nng-if=\"vm.itemVinculado.equipamentoNotaItemDetalheDescricao != null\">\nExecução - OS: {{vm.ordemVinculada.numero}}/{{vm.ordemVinculada.ano}} - {{vm.itemVinculado.equipamentoNotaItemDetalheDescricao}} Série:{{vm.itemVinculado.equipamentoNotaItemDetalheSerie}}\n</h2><h2 ng-if=\"vm.itemVinculado.equipamentoNotaItemDetalheDescricao == null\">\nExecução - OS: {{vm.ordemVinculada.numero}}/{{vm.ordemVinculada.ano}} - {{vm.itemVinculado.ordemServicoEquipamentoItemDescricao}} Série:{{vm.itemVinculado.ordemServicoEquipamentoItemSerie}}\n</h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"vm.metodos.cancel()\" aria-label=\"Fechar dialog\" \ntranslate translate-attr-aria-label=\"CLIENTE.FECHAR_DIALOG\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button>\n</div></md-toolbar><md-dialog-content layout=\"column\" class=\"pt-5\"><div layout=\"column\"><div layout=\"row\" \nclass=\"div-dialog-execucao\"><md-input-container flex-gt-sm=\"30\" flex><label>Inicial</label><md-datepicker \nng-model=\"vm.execucao.dataInicio\" name=\"dataInicio\" md-max-date=\"vm.execucao.dataFim\" ng-mask=\"3?9/1?9/9999\" \nng-change=\"vm.metodos.validarDataExecucao(vm.form.dataInicio, vm.form)\" \nng-disabled=\"vm.apenasVisualizacao || vm.validaEquipamentos\" ng-required=\"true\"></md-datepicker><div \nng-messages=\"vm.form.dataInicio.$error\"><div ng-message=\"minDate\" class=\"mensagem-validacao\"><span>\nData de execução não pode ser menor que a data de abertura da OS - Data da abertura {{vm.dataEntrada | date:\'dd/MM/yyyy\'}}\n</span></div><div ng-message=\"valid\" translate=\"MENSAGEM_VALIDACAO.DATA_INVALIDA\" class=\"mensagem-validacao\"></div><div\n ng-message=\"maxdate\" translate=\"MENSAGEM_VALIDACAO.DATA_INVALIDA\" class=\"mensagem-validacao\"></div><div \nng-message=\"required\" translate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\" class=\"mensagem-validacao\"></div></div>\n</md-input-container><md-input-container flex-gt-sm=\"30\" flex><label>Final</label><md-datepicker \nng-model=\"vm.execucao.dataFim\" name=\"dataFim\" md-min-date=\"vm.execucao.dataInicio\" ng-mask=\"3?9/1?9/9999\" \nng-disabled=\"vm.apenasVisualizacao || vm.validaEquipamentos\"></md-datepicker><div ng-messages=\"vm.form.data.$error\">\n<div ng-message=\"valid\" translate=\"MENSAGEM_VALIDACAO.DATA_INVALIDA\" class=\"mensagem-validacao\"></div><div \nng-message=\"mindate\" translate=\"MENSAGEM_VALIDACAO.DATA_INVALIDA\" class=\"mensagem-validacao\"></div></div>\n</md-input-container><md-input-container flex-gt-sm=\"20\" flex style=\"margin-bottom: 42px\"><label>Responsável</label>\n<md-select name=\"usuario\" ng-model=\"vm.execucao.usuarioId\" ng-disabled=\"true\"><md-option \nng-repeat=\"usuario in vm.usuarios\" ng-value=\"usuario.codigo\">{{usuario.login}}</md-option></md-select>\n</md-input-container></div><div layout=\"row\" flex style=\"justify-content: center\"><md-button style=\"height: 20%\" \nclass=\"md-raised md-accent\" ng-click=\"vm.metodos.salvar(vm.execucao)\" ng-if=\"!vm.editando\" \nng-disabled=\"vm.form.$invalid || vm.form.$pristine\">Salvar</md-button><md-button style=\"height: 20%\" \nclass=\"md-raised md-accent\" ng-click=\"vm.metodos.editar(vm.execucao)\" ng-if=\"vm.editando\" \nng-disabled=\"vm.form.$invalid || vm.form.$pristine\">Editar</md-button></div></div></md-dialog-content></form>\n</md-dialog>");
$templateCache.put("app/main/manutencao/ordem-servico/views/dialogs/dialog-ordem-servico-procedimento/dialog-ordem-servico-procedimento.html","<md-dialog id=\"dialogOsIitem\" aria-label=\"OS\" style=\"width: 95%\"><form name=\"vm.form\" class=\"md-inline-form\" \nnovalidate><md-toolbar><div class=\"md-toolbar-tools\" style=\"background-color: #039BE5\"><h2>\nProcedimentos - OS: {{vm.itemVinculado.ordemServicoId}}/{{vm.ordemVinculada.ano}} - {{vm.itemVinculado.equipamentoNotaItemDetalheDescricao}} Série:{{vm.itemVinculado.equipamentoNotaItemDetalheSerie}}\n</h2><span flex></span><md-button class=\"md-icon-button\" aria-label=\"Fechar dialog\" ng-click=\"vm.metodos.cancel()\" \ntranslate translate-attr-aria-label=\"CLIENTE.FECHAR_DIALOG\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button>\n</div></md-toolbar><md-dialog-content layout=\"column\" class=\"pt-5 div-pai\"><div layout=\"column\"><div \nclass=\"div-procedimentos\" layout=\"row\"><md-input-container class=\"md-block\" flex-gt-sm=\"30\" flex><label translate=\"\">\nProcedimento</label><md-select name=\"procedimento\" ng-model=\"vm.procedimento.ordemServicoTipoProcedimentoId\" \nng-required=\"vm.pecaObrigatoria\" ng-disabled=\"vm.apenasVisualizacao || vm.validaEquipamentos\" \nng-change=\"vm.metodos.calculaValorProcedimento(vm.procedimento.ordemServicoTipoProcedimentoId)\"><md-option \nng-value=\"procedimento.id\" ng-repeat=\"procedimento in vm.procedimentosPorEquipamento\">{{ procedimento.descricao }}\n</md-option></md-select><div ng-messages=\"vm.form.$error\"><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container><md-input-container flex-gt-sm=\"15\" \nflex><label translate=\"Valor(R$)\"></label><input type=\"text\" name=\"valorProcedimento\" ui-money-mask maxlength=\"22\" \nng-model=\"vm.procedimento.valorProcedimento\" ng-disabled=\"true\"></md-input-container><div \nclass=\"procedimentos-obrigatorios-total\"><div class=\"procedimentos-obrigatorios-total-p\"><p class=\"totalServico\">\nValor total serviço: {{vm.valorTotalSevicoMaisPecaVezesQtd | currency:\"R$ \"}}</p></div><p></p></div></div><div \nclass=\"div-procedimentos-btn\" layout=\"row\"><md-input-container class=\"md-block\" flex-gt-sm=\"30\" flex><label \ntranslate=\"\">Peça</label><md-select name=\"peca\" ng-model=\"vm.procedimento.ordemServicoOrigemPecaId\" \nng-class=\"{\'desabilitar\' : !vm.pecaObrigatoria}\" ng-disabled=\"!vm.pecaObrigatoria || vm.validaEquipamentos\"><md-option \nng-value=\"peca.id\" ng-repeat=\"peca in vm.pecas\">{{ peca.descricao }}</md-option></md-select><div \nng-messages=\"vm.form.$error\"><div ng-message=\"required\" translate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div>\n</md-input-container><md-input-container class=\"tamanho-inputs-valores\" flex-gt-sm=\"15\" flex><label \ntranslate=\"Valor Peça(R$)\"></label><input type=\"text\" name=\"valorPeca\" ui-money-mask maxlength=\"22\" \nng-model=\"vm.procedimento.custoPeca\" ng-required=\"vm.procedimento.ordemServicoOrigemPecaId\" \nng-disabled=\"!vm.pecaObrigatoria || vm.validaEquipamentos\" ng-class=\"{\'desabilitar\' : !vm.pecaObrigatoria}\">\n</md-input-container><md-input-container flex-gt-sm=\"15\" class=\"tamanho-inputs-valores\" flex><label \ntranslate=\"Quantidade\"></label><input type=\"text\" name=\"quantidade\" mascara-numero-generica=\"####\" \nng-model=\"vm.procedimento.quantidade\" ng-disabled=\"!vm.pecaObrigatoria || vm.validaEquipamentos\" \nng-required=\"vm.procedimento.ordemServicoOrigemPecaId\" ng-class=\"{\'desabilitar\' : !vm.pecaObrigatoria}\">\n</md-input-container><md-button class=\"md-raised md-accent\" \nstyle=\"align-self: center;\r\n                                      height: 20%\" \nng-click=\"vm.metodos.salvar(vm.procedimento)\" \nng-disabled=\"vm.form.$invalid || vm.form.$pristine || \r\n                                            !vm.procedimento.ordemServicoTipoProcedimentoId || vm.validaEquipamentos || vm.emProgresso\">\nAdicionar</md-button></div><div class=\"md-background-bg md-whiteframe-1dp tabela\" ng-if=\"!vm.salvando\"><table \nclass=\"dataTable row-border hover\" style=\"max-width: 60%; \r\n                                  margin-left: 20%\" \ndatatable=\"ng\" dt-options=\"vm.dtOptionsProcedimentos\" width=\"100%\" flex><thead flex><tr><th class=\"secondary-text\"><div\n class=\"table-header\"><span class=\"column-title\">Ação</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Procedimento</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Val procedimento</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Peça</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Val peça</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Quantidade</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Val total peças</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Val total</span></div></th><th></th></tr></thead><tbody flex><tr \nng-repeat=\"procedimento in vm.ordensServicosProcedimentos\"><td class=\"button-icone-cor-azul\"><button \nng-click=\"vm.controleForm.emProgresso || \r\n                                                      vm.metodos.dialogEditarProcedimento($event, procedimento)\" \nng-disabled=\"vm.validaEquipamentos || vm.emProgresso\"><i class=\"icon-pencil s16 icone-cor-padrao\"></i></button> <button\n \nng-click=\"vm.controleForm.emProgresso || \r\n                                                      vm.metodos.excluirProcedimento($event, procedimento)\" \nng-disabled=\"vm.validaEquipamentos || vm.emProgresso\"><i class=\"icon-delete s16 icone-cor-padrao\"></i></button></td>\n<td>{{procedimento.ordemServicoTipoProcedimentoDescricao}}</td><td>{{procedimento.valorProcedimento | currency:\"R$ \"}}\n</td><td>{{procedimento.ordemServicoOrigemPecaDescricao}}</td><td>{{procedimento.custoPeca | currency:\"R$ \"}}</td><td>\n{{procedimento.quantidade}}</td><td>{{procedimento.valorTotalPecaXQuantidade | currency:\"R$ \"}}</td><td>\n{{procedimento.valorTotalPecaProcedimentoXQuantidade | currency:\"R$ \"}}</td><td><i \nclass=\"icon-information s16 icone-cor-padrao\" ng-if=\"procedimento.obrigatorio\" \nng-class=\"{\'possuiPreechimento\' : procedimento.custoPeca <= 0}\"></i><md-tooltip ng-if=\"procedimento.obrigatorio\"><span>\nProcedimento obrigatório</span></md-tooltip></td></tr></tbody></table></div></div></md-dialog-content></form>\n</md-dialog>");
$templateCache.put("app/main/manutencao/ordem-servico/views/dialogs/dialog-ordem-servico-item/dialog-ordem-servico-item.html","<md-dialog id=\"dialogOsIitem\" aria-label=\"OS\" style=\"width: 50%\"><form name=\"vm.form\" class=\"md-inline-form\" \nnovalidate><md-toolbar><div class=\"md-toolbar-tools titulo\" style=\"background-color: #039BE5\"><h2 \nng-if=\"vm.item == null\">Itens - OS: {{vm.ordemVinculada.numero}}/{{vm.ordemVinculada.ano}}</h2><h2 \nng-if=\" vm.item != null && vm.item.equipamentoNotaItemDetalheDescricao != null\">\nItens - OS: {{vm.ordemVinculada.numero}}/{{vm.ordemVinculada.ano}} - {{vm.item.equipamentoNotaItemDetalheDescricao}} - Série: {{vm.item.equipamentoNotaItemDetalheSerie}}\n</h2><h2 ng-if=\" vm.item != null && vm.item.equipamentoNotaItemDetalheDescricao == null\">\nItens - OS: {{vm.ordemVinculada.numero}}/{{vm.ordemVinculada.ano}} - {{vm.item.ordemServicoEquipamentoItemDescricao}} - Série: {{vm.item.ordemServicoEquipamentoItemSerie}}\n</h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"vm.metodos.cancel()\" aria-label=\"Fechar dialog\" \ntranslate translate-attr-aria-label=\"CLIENTE.FECHAR_DIALOG\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button>\n</div></md-toolbar><md-dialog-content layout=\"column\"><div layout=\"column\"><md-input-container class=\"md-block\" \nflex-gt-sm=\"30\" ng-if=\"vm.ordemVinculada.ordemServicoTipoServicoId != 2 && !vm.editando\"><label translate=\"\">\nEquipamento</label><md-select name=\"equipamento\" ng-model=\"vm.equipamentoItemGeral\" ng-required=\"true\" \nng-disabled=\"vm.apenasVisualizacao\" md-on-open=\"vm.metodos.configuraMdSelectSolucao($event)\" \nmd-on-close=\"vm.metodos.configuraMdSelectSolucao($event)\"><md-select-header><input \nid=\"equipamento-form-solucao-md-select\" class=\"md-text\" ng-model=\"vm.filtrarEquipamentos\" type=\"search\" placeholder=\"\" \ntranslate translate-attr-placeholder=\"Pesquisar equipamento\"></md-select-header><md-option ng-value=\"equipamento\" \nng-repeat=\"equipamento in vm.retornados | filter: vm.filtrarEquipamentos\">\n{{ equipamento.descricaoEquipamento }} - Série: {{ equipamento.numeroSerie }}</md-option></md-select><div \nng-messages=\" vm.form.equipamento.$error\"><div ng-message=\"required\" translate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\">\n</div></div></md-input-container><div layout=\"column\" layout-align=\"center center\" ng-show=\"vm.requisicaoSolicitada\">\n<span class=\"font-weight-500\">{{vm.preloader}}</span><md-progress-circular md-mode=\"indeterminate\" md-diameter=\"30\" \nclass=\"md-accent\"></md-progress-circular></div><md-input-container class=\"md-block\" flex-gt-sm=\"30\" \nng-if=\"vm.ordemVinculada.ordemServicoTipoServicoId == 2 && !vm.editando\"><label translate=\"\">Equipamento</label>\n<md-select name=\"equipamento\" ng-model=\"vm.ordemServicoItem.ordemServicoEquipamentoItemId\" ng-required=\"true\" \nng-disabled=\"vm.apenasVisualizacao || vm.preloader\"><md-option ng-value=\"equipamento.id\" \nng-repeat=\"equipamento in vm.equipamentosEntradas\">\n{{ equipamento.equipamentoDescricao }} - Série: {{ equipamento.numeroSerie }}</md-option></md-select><div \nng-messages=\"vm.form.equipamento.$error\"><div ng-message=\"required\" translate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\">\n</div></div></md-input-container><div layout=\"row\"><md-input-container class=\"md-block\" flex><label \ntranslate=\"CLIENTE.OBSERVACOES\"></label><textarea ng-model=\"vm.ordemServicoItem.observacao\" name=\"observacoes\" \nmd-no-resize=\"true\" rows=\"4\" max-rows=\"4\" md-maxlength=\"500\" maxlength=\"500\" \nng-disabled=\"vm.apenasVisualizacao || vm.preloader\">\r\n              </textarea></md-input-container></div><div \nlayout=\"row\" flex style=\"justify-content: center; position: relative\"><div layout=\"row\" layout-align=\"center center\" \nng-if=\"vm.salvando\" flex><div layout=\"column\" layout-align=\"center center\"><md-progress-circular \nmd-mode=\"indeterminate\" md-diameter=\"50\" class=\"md-accent\"></md-progress-circular></div></div><div><md-button \nng-click=\"vm.metodos.gravar(vm.ordemServicoItem)\" class=\"send-button md-accent md-raised\" aria-label=\"Salvar\" \nng-if=\"!vm.salvando\" ng-disabled=\"vm.form.$invalid || vm.form.$pristine\" translate=\"GROUP_BUTTON_HORIZONTAL.SALVAR\">\n</md-button><md-button ng-click=\"vm.metodos.habilitarCampos()\" class=\"send-button md-accent md-raised\" \naria-label=\"Editar\" translate=\"Editar\" ng-if=\"vm.apenasVisualizacao\"></md-button></div><div layout=\"row\" \nng-if=\"vm.apenasVisualizacao\" style=\"position: absolute; z-index: 99; right: 0\"><md-button class=\"md-icon-button\" \nng-click=\"vm.metodos.excluirItem(vm.ordemServicoItem)\" aria-label=\"Excluir\" translate \ntranslate-attr-aria-label=\"CLIENTE.EXCLUIR\" ng-disabled=\"!vm.desabilitarBotaoExcluir\"><md-icon \nmd-font-icon=\"icon-delete s30\" aria-hidden=\"true\" \nclass=\"ng-scope md-default-theme md-font material-icons icon-delete s30 icone-excluir\"></md-icon></md-button></div>\n</div></div></md-dialog-content></form></md-dialog>");
$templateCache.put("app/main/manutencao/ordem-servico/views/dialogs/dialog-ordem-servico-procedimento-editar/dialog-ordem-servico-procedimento-editar.html","<md-dialog id=\"dialogOsIitem\" aria-label=\"OS\" style=\"width: 60%\"><form name=\"vm.form\" class=\"md-inline-form\" \nnovalidate><md-toolbar><div class=\"md-toolbar-tools\" style=\"background-color: #039BE5\"><h2>Procedimentos</h2><span \nflex></span><md-button class=\"md-icon-button\" ng-click=\"vm.metodos.cancel()\" aria-label=\"Fechar dialog\" translate \ntranslate-attr-aria-label=\"CLIENTE.FECHAR_DIALOG\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content layout=\"column\" class=\"pt-5\"><div layout=\"column\"><div layout=\"row\"><md-input-container\n class=\"md-block\" flex-gt-sm=\"30\" flex><label translate=\"\">Tipo procedimento</label><md-select name=\"procedimento\" \nng-model=\"vm.procedimento.ordemServicoTipoProcedimentoId\" ng-required=\"vm.pecaObrigatoria\" \nng-change=\"vm.metodos.calculaValorProcedimento(vm.procedimento.ordemServicoTipoProcedimentoId)\" ng-disabled=\"true\">\n<md-option ng-value=\"procedimento.id\" ng-repeat=\"procedimento in vm.tiposProcedimentos\">{{ procedimento.descricao }}\n</md-option></md-select><div ng-messages=\"vm.form.$error\"><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container><md-input-container flex-gt-sm=\"30\" \nflex><label translate=\"Valor Procedimento(R$)\"></label><input type=\"text\" ng-model=\"vm.procedimento.valorProcedimento\" \nname=\"valorProcedimento\" ng-disabled=\"true\" ui-money-mask maxlength=\"22\"></md-input-container><md-card \nng-if=\"vm.procedimentosObrigatorios.length > 0\" class=\"regras\"><md-card-content class=\"texto\" flex><h3 \nstyle=\"margin: 0px\">Procedimentos obrigatórios:</h3><p ng-repeat=\"item in vm.procedimentosObrigatorios | orderBy:\'id\'\">\n{{item.descricao}}</p></md-card-content></md-card></div><div layout=\"row\"><md-input-container class=\"md-block\" \nflex-gt-sm=\"30\" flex><label translate=\"\">Peça</label><md-select name=\"peca\" \nng-model=\"vm.procedimento.ordemServicoOrigemPecaId\" ng-disabled=\"!vm.pecaObrigatoria\"><md-option ng-value=\"peca.id\" \nng-repeat=\"peca in vm.pecas\">{{ peca.descricao }}</md-option></md-select><div ng-messages=\"vm.form.$error\"><div \nng-message=\"required\" translate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container>\n<md-input-container flex-gt-sm=\"15\" flex><label translate=\"Valor Peça(R$)\"></label><input type=\"text\" \nng-model=\"vm.procedimento.custoPeca\" name=\"valorPeca\" ui-money-mask maxlength=\"22\" \nng-required=\"vm.procedimento.ordemServicoOrigemPecaId\" ng-disabled=\"!vm.pecaObrigatoria\"></md-input-container>\n<md-input-container flex-gt-sm=\"15\" flex><label translate=\"Quantidade\"></label><input type=\"text\" \nng-model=\"vm.procedimento.quantidade\" name=\"quantidade\" mascara-numero-generica=\"####\" \nng-disabled=\"!vm.pecaObrigatoria\" ng-required=\"vm.procedimento.ordemServicoOrigemPecaId\"></md-input-container>\n<md-button style=\"align-self: center;height: 20%\" class=\"md-raised md-accent\" \nng-click=\"vm.metodos.salvar(vm.procedimento)\">Salvar</md-button></div></div></md-dialog-content></form></md-dialog>");
$templateCache.put("app/main/manutencao/ordem-servico/views/dialogs/dialog-ordem-servico-valor/dialog-ordem-servico-valor.html","<md-dialog id=\"dialogEnvio\" aria-label=\"OS\" style=\"width: 60%\"><form name=\"vm.form\" class=\"md-inline-form\" novalidate>\n<md-toolbar><div class=\"md-toolbar-tools\" style=\"background-color: #039BE5; justify-content: space-between\"><h2>Valores\n</h2><div ng-if=\"!vm.servicoFaturado\" style=\"margin-left: 80%\"><i class=\"icon-alert-circle s24\" style=\"color: yellow\">\n<md-tooltip>O serviço selecionado não é faturado.</md-tooltip></i></div><md-button class=\"md-icon-button\" \nng-click=\"vm.metodos.cancel()\" aria-label=\"Fechar dialog\" translate translate-attr-aria-label=\"CLIENTE.FECHAR_DIALOG\">\n<md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content layout=\"column\" \nclass=\"pt-5\"><div layout=\"column\"><div layout=\"row\" class=\"div-envio-1\" style=\"margin-top: 20px\"><md-input-container \nflex-gt-sm=\"20\" class=\"input-container\" flex><label translate=\"Peças\"></label><input type=\"text\" \nng-model=\"vm.valorPeca\" name=\"valorPeca\" ng-required=\"true\" ng-disabled=\"true\" ui-money-mask></md-input-container>\n<md-input-container flex-gt-sm=\"20\" class=\"input-container\" flex><label translate=\"Procedimentos\"></label><input \ntype=\"text\" ng-model=\"vm.valorTotalProcedimentos\" \nng-change=\"vm.metodos.calculaValorFaturadoInicial(vm.valorTotalProcedimentos)\" name=\"valorCusto\" ng-required=\"true\" \nng-disabled=\"true\" ui-money-mask></md-input-container><md-input-container flex-gt-sm=\"20\" class=\"input-container\" flex>\n<label translate=\"Valor frete\"></label><input type=\"text\" \nng-change=\"vm.metodos.calculaValorFaturado(vm.valores, vm.form.valorFrete, vm.form)\" ng-model=\"vm.valores.valorFrete\" \nname=\"valorFrete\" ng-required=\"vm.envio.tipoEnvio[0].freteObrigatorio == 1\" ui-money-mask><div \nng-messages=\"vm.form.valorFrete.$error\"><div ng-message=\"required\" translate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\">\n</div><div ng-message=\"valorFrete\" translate=\"Valor não pode ser zerado\"></div></div></md-input-container>\n<md-input-container flex-gt-sm=\"20\" class=\"input-container\" flex><label translate=\"Valor custo\"></label><input \ntype=\"text\" ng-model=\"vm.valorReal\" name=\"valorReal\" ng-required=\"true\" ui-money-mask disabled=\"disabled\">\n</md-input-container><md-input-container flex-gt-sm=\"20\" class=\"input-container\" flex><label translate=\"Valor cobrado\">\n</label><input type=\"text\" ng-model=\"vm.valores.valorCobrado\" name=\"valorCobrado\" \nng-change=\"vm.metodos.onChangeValorCobrado(vm.form.valorCobrado, vm.form)\" ng-required=\"vm.servicoFaturado\" \nng-disabled=\"!vm.servicoFaturado\" ui-money-mask><div ng-messages=\"vm.form.valorCobrado.$error\"><div \nng-message=\"required\" translate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div><div ng-message=\"valorCobrado\" \ntranslate=\"Valor não pode ser zerado\"></div></div></md-input-container></div><div layout=\"row\" style=\"width: 100%\">\n<md-input-container class=\"md-block observacao\" flex><label translate=\"CLIENTE.OBSERVACOES\"></label><textarea \nng-model=\"vm.valores.observacao\" ng-required=\"vm.servicoObrigaObservacao && vm.valores.valorCobrado > 0\" \nname=\"observacoes\" md-no-resize=\"true\" rows=\"4\" max-rows=\"4\" md-maxlength=\"500\" maxlength=\"500\">\n\r\n                      </textarea><div ng-messages=\"vm.form.observacoes.$error\"><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container></div><div layout=\"row\" flex \nstyle=\"justify-content: center\"><md-button style=\"height: 20%\" class=\"md-raised md-accent\" \nng-click=\"vm.metodos.salvar(vm.valores)\" ng-if=\"!vm.editando\" ng-disabled=\"vm.form.$invalid\">Salvar</md-button>\n<md-button style=\"height: 20%\" class=\"md-raised md-accent\" ng-click=\"vm.metodos.editar(vm.valores)\" \nng-disabled=\"vm.form.$invalid\" ng-if=\"vm.editando\">Atualizar</md-button></div></div></md-dialog-content></form>\n</md-dialog>");
$templateCache.put("app/main/manutencao/entrada/views/dialogs/dialog-equipamento-item/dialog-equipamento-item.html","<md-dialog><form name=\"vm.form\" novalidate><md-toolbar><div class=\"md-toolbar-tools\" style=\"background-color: #039BE5\">\n<h2>Equipamento</h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"vm.metodos.cancel()\" \naria-label=\"Fechar dialog\" translate translate-attr-aria-label=\"CLIENTE.FECHAR_DIALOG\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-content layout-padding \nng-hide=\"vm.controleForm.listarTodasEntidades\" ng-disabled=\"vm.controleForm.emProgresso\"><div class=\"form-container\" \nlayout=\"column\"><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container class=\"md-block\" flex-gt-sm=\"30\" flex>\n<label translate=\"Número série\"></label><input type=\"text\" ng-model=\"vm.entrada.numeroSerie\" name=\"manutencao\" \nng-required=\"true\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\" \nmascara-tamanho-campo=\"30\" md-maxlength=\"30\"><div ng-messages=\"vm.form.manutencao.$error\"><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container><md-input-container class=\"md-block\" \nflex-gt-sm=\"30\" flex><label translate=\"IMEI\"></label><input type=\"text\" ng-model=\"vm.entrada.imei\" name=\"manutencao\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\" \nmascara-tamanho-campo=\"15\" md-maxlength=\"15\"><div ng-messages=\"vm.form.manutencao.$error\"><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container></div><div layout=\"column\" \nlayout-gt-xs=\"row\"><md-input-container class=\"md-block margem-cell\" flex=\"30\" flex-xs=\"100\"><label>Equipamento</label>\n<md-select name=\"equipamento\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\" \nng-model=\"vm.entrada.equipamentoId\" ng-required=\"true\"><md-option ng-repeat=\"equipamento in vm.equipamentos\" \nng-value=\"equipamento.id\">{{equipamento.descricao}}</md-option></md-select><div \nng-messages=\"vm.form.equipamento.$error\"><div ng-message=\"required\" translate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\">\n</div></div></md-input-container></div><div layout=\"column\" layout-gt-sm=\"row\"><md-input-container class=\"md-block\" \nflex><label translate=\"CLIENTE.OBSERVACOES\"></label><textarea ng-model=\"vm.entrada.observacao\" name=\"observacoes\" \nmd-no-resize=\"true\" rows=\"4\" max-rows=\"4\" md-maxlength=\"300\" maxlength=\"300\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\">\n\r\n                          </textarea></md-input-container></div><div layout=\"row\" \nstyle=\"justify-content: space-between\"><div></div><div></div><div layout=\"row\" ng-if=\"vm.salvando\" flex><div \nlayout=\"row\" layout-align=\"center center\" flex><div layout=\"column\" layout-align=\"center center\"><md-progress-circular \nmd-mode=\"indeterminate\" md-diameter=\"50\" class=\"md-accent\"></md-progress-circular></div></div></div><md-button \nng-click=\"vm.metodos.gravar(vm.entrada)\" class=\"send-button md-accent md-raised\" aria-label=\"Salvar\" \nng-if=\"!vm.salvando\" translate=\"GROUP_BUTTON_HORIZONTAL.SALVAR\" layout-align=\"end end\" \nng-disabled=\"vm.form.$invalid || vm.form.$pristine || vm.controladorDialog.requisicaoSolicitada\"></md-button></div>\n</div></md-content></form></md-dialog>");
$templateCache.put("app/main/manutencao/entrada/views/dialogs/dialog-editar-nota/dialog-editar-nota.html","<md-dialog style=\"width: 25%\"><form name=\"vm.form\" novalidate><md-toolbar><div class=\"md-toolbar-tools\" \nstyle=\"background-color: #039BE5\"><h2>Dados de entrada</h2><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"vm.metodos.cancel()\" aria-label=\"Fechar dialog\" translate translate-attr-aria-label=\"CLIENTE.FECHAR_DIALOG\">\n<md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-content layout-padding \nng-hide=\"vm.controleForm.listarTodasEntidades\" ng-disabled=\"vm.controleForm.emProgresso\"><div class=\"form-container\" \nlayout=\"column\"><md-input-container flex class=\"data-Nota\"><label>Data</label><md-datepicker \nng-model=\"vm.entrada.dataEntrada\" name=\"data\" mascara-conversor-string-para-data ng-mask=\"3?9/1?9/9999\" \nng-disabled=\"vm.adicionandoEquip\" ng-required=\"true\"></md-datepicker><div ng-messages=\"vm.form.data.$error\"><div \nng-message=\"required\" translate=\"MENSAGEM_VALIDACAO.DATA_OBRIGATORIA\"></div></div></md-input-container>\n<md-input-container class=\"md-block\" flex=\"90\"><label translate=\"Nota de entrada\"></label><input type=\"text\" \nng-model=\"vm.entrada.notaFiscalEntrada\" name=\"notaEntrada\" \nng-required=\"vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo\" ng-disabled=\"vm.adicionandoEquip\" \nmascara-tamanho-campo=\"30\" md-maxlength=\"30\"><div ng-messages=\"vm.form.notaEntrada.$error\"><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container><md-input-container class=\"md-block\" \nflex=\"90\"><label translate=\"Nota de saída\"></label><input type=\"text\" ng-model=\"vm.entrada.notaFiscalSaida\" \nname=\"notaEntrada\" ng-required=\"true\" ng-disabled=\"vm.adicionandoEquip\" mascara-tamanho-campo=\"30\" md-maxlength=\"30\">\n<div ng-messages=\"vm.form.notaEntrada.$error\"><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container><md-autocomplete flex-gt-sm=\"90\" \nflex-gt-xs md-input-name=\"cliente\" md-no-cache=\"true\" ng-blur=\"vm.metodos.configuraAutoCompleteClienteOnBlur()\" \nmd-selected-item=\"vm.clienteSelecionado\" \nmd-selected-item-change=\"vm.metodos.alterarItemSelecionadoAutoCompleteCliente(item)\" \nmd-search-text=\"vm.textoDePesquisaAutoCompleteCliente\" \nmd-items=\"item in vm.metodos.pesquisarAutoCompleteCliente(vm.textoDePesquisaAutoCompleteCliente)\" \nmd-item-text=\"item.nome\" md-autoselect md-floating-label=\"Cliente\" required \nng-disabled=\"vm.apenasVisualizacao || vm.editando\"><md-item-template><span \nmd-highlight-text=\"vm.textoDePesquisaAutoCompleteCliente\">{{item.nome}}</span></md-item-template><md-not-found><label>\nNão foi encontrado nenhum Cliente.</label></md-not-found></md-autocomplete><div layout=\"row\" \nstyle=\"justify-content: space-between\"><div></div><div></div><div layout=\"row\" ng-if=\"vm.salvando\" flex><div \nlayout=\"row\" layout-align=\"center center\" flex><div layout=\"column\" layout-align=\"center center\"><md-progress-circular \nmd-mode=\"indeterminate\" md-diameter=\"50\" class=\"md-accent\"></md-progress-circular></div></div></div><md-button \nng-click=\"vm.metodos.editar(vm.entrada)\" class=\"send-button md-accent md-raised\" aria-label=\"Salvar\" \nng-if=\"!vm.salvando\" translate=\"GROUP_BUTTON_HORIZONTAL.SALVAR\" layout-align=\"end end\" \nng-disabled=\"vm.form.$invalid || vm.form.$pristine\"></md-button></div></div></md-content></form></md-dialog>");
$templateCache.put("app/main/planejamento-scrum/estatisticas/estatistica/views/dialogs/consulta-estatistica-dialog.html","<md-dialog class=\"dialog-padrao\" style=\"min-height: 50%; min-width: 85%\" flex><md-toolbar class=\"md-accent\"><div \nclass=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\">\n{{vm.titulo}}</span><md-button class=\"md-icon-button\" ng-click=\"vm.metodos.fecharDialog()\" aria-label=\"Fechar dialog\" \ntranslate translate-attr-aria-label=\"SPRINT.FECHAR_DIALOG\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button>\n</div></md-toolbar><div flex><nvd3 options=\"vm.options\" data=\"vm.data\" class=\"mt-52\"></nvd3></div></md-dialog>");
$templateCache.put("app/main/planejamento-scrum/processamento/product-backlog/views/dialog-adicionar-sprint/product-backlog-dialog-adicionar-sprint-especifica.html","<md-dialog id=\"product-backlog-dialog-adicionar-sprint-especifica\" class=\"dialogo-padrao\" aria-label=\"Dialog\"><form \nname=\"vm.form.dialogProductBacklogSprintEspecifica\" class=\"md-inline-form\" novalidate><md-toolbar \nclass=\"md-accent md-tall\" layout=\"column\"><div class=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" \nlayout-align=\"space-between center\"><span class=\"title\">{{vm.titulo}}</span><md-button class=\"md-icon-button\" \naria-label=\"Fechar dialog\" translate translate-attr-aria-label=\"PRODUCT_BACKLOG.FECHAR_DIALOG\" \nng-click=\"vm.metodosDialog.fecharDialog()\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar>\n<div layout=\"row\" layout-sm=\"row\" layout-align=\"center\" ng-show=\"vm.requisicaoSolicitada\"><md-progress-circular \nclass=\"md-accent\" md-mode=\"indeterminate\"></md-progress-circular></div><md-dialog-content \nng-hide=\"vm.requisicaoSolicitada\"><div layout-gt-xs=\"row\" layout-align=\"center center\" flex><md-input-container \nclass=\"md-block\" flex-gt-sm=\"40\"><label translate=\"PRODUCT_BACKLOG.SPRINT\">Sprint</label><md-select \nname=\"dialogProductBacklogSprint\" required md-on-open=\"vm.metodosDialog.configurarMdSelectSprint()\" \nng-model=\"vm.sprint\"><md-select-header><input id=\"product-backlog-dialog-adicionar-sprints-especificas-md-select\" \nclass=\"md-text\" type=\"search\" placeholder=\"\" translate translate-attr-placeholder=\"PRODUCT_BACKLOG.PESQUISAR_SPRINT\" \nng-model=\"vm.filtrarSprints\"></md-select-header><md-optgroup label=\"Sprints\"><md-option ng-if=\"vm.sprint\" ng-value=\"\">\nDesmarcar</md-option><md-option ng-value=\"sprint\" ng-repeat=\"sprint in vm.sprints | filter:vm.filtrarSprints\">\n{{sprint.descricao}}</md-option></md-optgroup></md-select><div \nng-messages=\"vm.form.dialogProductBacklogSprintEspecifica.dialogBacklogEstoria.$error\"><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container></div></md-dialog-content>\n<md-dialog-actions layout=\"row\"><div layout=\"row\" layout-align=\"end center\" flex><md-button \nclass=\"send-button md-accent md-raised\" type=\"submit\" aria-label=\"ADICIONAR\" translate=\"PRODUCT_BACKLOG.ADICIONAR\" \nng-click=\"vm.metodosDialog.salvar($event, vm.sprint)\" \nng-disabled=\"vm.form.dialogProductBacklogSprintEspecifica.$invalid || \r\n                           vm.form.dialogProductBacklogSprintEspecifica.$pristine || vm.requisicaoSolicitada || !vm.sprint\">\nAdicionar</md-button></div></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/planejamento-scrum/processamento/product-backlog/views/dialog-alterar-data-entrega/product-backlog-dialog-alterar-data-entrega.html","<md-dialog id=\"product-backlog-dialog-alterar-data-entrega\" class=\"dialogo-padrao\" aria-label=\"Dialog\"><form \nname=\"vm.form.dialog\" class=\"md-inline-form\" novalidate><md-toolbar class=\"md-accent md-tall\" layout=\"column\"><div \nclass=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\">\n{{vm.titulo}}</span><md-button class=\"md-icon-button\" ng-click=\"vm.metodosDialog.fecharDialog()\" \naria-label=\"Fechar dialog\" translate translate-attr-aria-label=\"SOLUCAO_ROTINAS_TAREFAS.FECHAR_DIALOG\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><div layout=\"row\" layout-sm=\"row\" \nlayout-align=\"center\" ng-show=\"vm.requisicaSolicitada\"><md-progress-circular md-mode=\"indeterminate\" class=\"md-accent\">\n</md-progress-circular></div><md-dialog-content ng-hide=\"vm.requisicaSolicitada\"><div layout=\"row\" \nlayout-align=\"center center\" flex><md-input-container><label translate=\"ESTORIA.DATA_ENTREGA\"></label><md-datepicker \nng-model=\"vm.estoria.dataEntrega\" name=\"productBacklogDialogDataEntrega\" mascara-conversor-string-para-data \nng-mask=\"3?9/1?9/9999\" ng-required=\"true\"></md-datepicker><div \nng-messages=\"vm.form.dialog.productBacklogDialogDataEntrega.$error\"><div ng-message=\"valid\" \ntranslate=\"MENSAGEM_VALIDACAO.DATA_INVALIDA\"></div><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.DATA_OBRIGATORIA\"></div></div></md-input-container></div></md-dialog-content>\n<md-dialog-actions layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"end center\" flex>\n<md-button type=\"submit\" ng-click=\"vm.metodosDialog.salvar(vm.estoria, $event)\" \nclass=\"send-button md-accent md-raised\" ng-disabled=\"vm.form.dialog.$invalid || vm.requisicaoSolicitada\" \naria-label=\"SALVAR\" translate=\"SPRINT.SALVAR\" translate-attr-aria-label=\"PRODUCT_BACKLOG.SALVAR\">Salvar</md-button>\n</div></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/planejamento-scrum/processamento/product-backlog/views/dialog-alterar-prioridade/product-backlog-dialog-alterar-prioridade.html","<md-dialog id=\"product-backlog-dialog-alterar-prioridade\" class=\"dialogo-padrao\" aria-label=\"Dialog\"><form \nname=\"vm.form.dialogPrioridadeBacklog\" class=\"md-inline-form\" novalidate><md-toolbar class=\"md-accent md-tall\" \nlayout=\"column\"><div class=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" layout-align=\"space-between center\">\n<span class=\"title\">{{vm.titulo}}</span><md-button class=\"md-icon-button\" ng-click=\"vm.metodosDialog.fecharDialog()\" \naria-label=\"Fechar dialog\" translate translate-attr-aria-label=\"SOLUCAO_ROTINAS_TAREFAS.FECHAR_DIALOG\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><div layout=\"row\" layout-sm=\"row\" \nlayout-align=\"center\" ng-show=\"vm.requisicaSolicitada\"><md-progress-circular md-mode=\"indeterminate\" class=\"md-accent\">\n</md-progress-circular></div><md-dialog-content ng-hide=\"vm.requisicaSolicitada\"><div layout=\"row\" \nlayout-align=\"center center\"><md-input-container class=\"md-block\" flex-gt-sm=\"50\"><label \ntranslate=\"PRODUCT_BACKLOG.PRIORIDADE_BACKLOG\"></label><input define-focus type=\"text\" \nng-model=\"vm.estoria.prioridadeBacklog\" name=\"dialogPrioridadeBacklog\" mascara-numero-generica=\"###\">\n</md-input-container></div></md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"space-between center\"><div\n layout=\"row\" layout-align=\"end center\" flex><md-button type=\"submit\" \nng-click=\"vm.metodosDialog.salvar(vm.estoria, $event)\" class=\"send-button md-accent md-raised\" \nng-disabled=\"vm.form.dialogPrioridadeBacklog.$invalid || vm.form.dialogPrioridadeBacklog.$pristine || vm.requisicaoSolicitada\" \naria-label=\"SALVAR\" translate=\"SPRINT.SALVAR\" translate-attr-aria-label=\"PRODUCT_BACKLOG.SALVAR\">Salvar</md-button>\n</div></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/planejamento-scrum/processamento/product-backlog/views/dialog-legenda-tabela/dialog-legenda-tabela.html","<md-dialog id=\"dialog-legendas-tabela-product-backlog\" class=\"dialogo-padrao\" aria-label=\"Dialog\"><form \nname=\"vm.form.legendaTabela\" class=\"md-inline-form\" novalidate><md-toolbar class=\"md-accent md-tall\" layout=\"column\">\n<div class=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" layout-align=\"space-between center\"><span \nclass=\"title\">Legenda data de entrega</span><md-button class=\"md-icon-button\" ng-click=\"vm.metodosDialog.fechar()\" \naria-label=\"Fechar dialog\" translate translate-attr-aria-label=\"SOLUCAO_ROTINAS_TAREFAS.FECHAR_DIALOG\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content><div layout=\"column\"><md-card \nclass=\"legenda-tabela-card\" style=\"margin-bottom: -5px; margin-top: -15px\"><md-card-content><div \nng-repeat=\"item in vm.legendaTabelaDatas\" layout=\"row\" layout-align=\"start center\" style=\"margin-bottom: 8px\"><span \nng-style=\"{\'display\': \'inline-block\', \'width\': \'16px\', \'height\': \'16px\', \'border-radius\': \'50%\', \'background\': item.cor, \'margin-right\': \'12px\', \'border\': \'1px solid #ccc\'}\">\n</span> <span>{{item.descricao}}</span></div></md-card-content></md-card></div></md-dialog-content></form></md-dialog>");
$templateCache.put("app/main/planejamento-scrum/processamento/product-backlog/views/dialog-alterar-necessidade-cliente/product-backlog-dialog-alterar-necessidade-cliente.html","<md-dialog id=\"product-backlog-dialog-alterar-necessidade-cliente\" class=\"dialogo-padrao\" aria-label=\"Dialog\"><form \nname=\"vm.form\" class=\"md-inline-form\" novalidate><md-toolbar class=\"md-accent md-tall\" layout=\"column\"><div \nclass=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\">\n{{vm.titulo}}</span><md-button class=\"md-icon-button\" ng-click=\"vm.metodosDialog.fecharDialog()\" \naria-label=\"Fechar dialog\" translate translate-attr-aria-label=\"PRODUCT_BACKLOG.FECHAR_DIALOG\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><div layout=\"column\" layout-align=\"center center\" \nng-show=\"vm.requisicaoSolicitada\"><span class=\"font-weight-500\">{{vm.mensagemPreloader}}</span><md-progress-circular \nmd-mode=\"indeterminate\" md-diameter=\"30\" class=\"md-accent\"></md-progress-circular></div><md-dialog-content><div \nlayout=\"row\" layout-align=\"center center\"><md-input-container class=\"md-block\" flex=\"25\"><label \ntranslate=\"PRODUCT_BACKLOG.NECESSIDADE_CLIENTE\">Necessida Cliente</label><md-select \nng-model=\"vm.estoria.necessidadeCliente\" name=\"necessidadeCliente\" ng-disabled=\"vm.requisicaoSolicitada\"><md-option \nng-value=\"key\" ng-repeat=\"(key, value) in vm.necessidadesCliente\">{{value}}</md-option><md-option ng-value=\"\" \nng-if=\"vm.estoria && vm.estoria.necessidadeCliente\">Desmarcar</md-option></md-select></md-input-container></div>\n</md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" \nlayout-align=\"end center\" flex><md-button type=\"submit\" ng-click=\"vm.metodosDialog.salvar(vm.estoria, $event)\" \nclass=\"send-button md-accent md-raised\" ng-disabled=\"vm.form.$pristine || vm.requisicaoSolicitada\" aria-label=\"SALVAR\" \ntranslate=\"PRODUCT_BACKLOG.SALVAR\" translate-attr-aria-label=\"PRODUCT_BACKLOG.SALVAR\">Salvar</md-button></div>\n</md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/trabalhe-conosco/cadastro/categoria/views/tabs/tab-categoria.html","<md-content id=\"recurso\" class=\"md-padding\"><div class=\"form-container\"><div layout-gt-xs=\"row\" flex>\n<md-input-container class=\"md-block\" flex-gt-sm=\"50\"><label translate=\"TRABALHE_CONOSCO_CATEGORIA.TITULO\"></label>\n<input type=\"text\" ng-model=\"vm.categoria.titulo\" name=\"titulo\" mascara-tamanho-campo=\"50\" \nng-required=\"vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo\" md-maxlength=\"50\" \nng-disabled=\"(vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo) || vm.controleForm.emProgresso\">\n<div ng-messages=\"vm.form.descricao.$error\"><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container><md-input-container class=\"md-block\" \nflex-offset-gt-sm=\"5\" flex-gt-sm=\"40\"><label translate=\"TRABALHE_CONOSCO_CATEGORIA.SETOR\"></label><md-select \nng-model=\"vm.categoria.codigoSetor\" name=\"codigoSetor\" \nng-required=\"vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo\" \nng-disabled=\"(vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo) || vm.controleForm.emProgresso\">\n<md-option ng-value=\"setor.codigo\" ng-repeat=\"setor in vm.setores | orderBy:descricao track by setor.codigo\">\n{{setor.descricao}}</md-option></md-select><div ng-messages=\"vm.form.codigoSetor.$error\"><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container><md-input-container class=\"md-block\" \nflex-gt-sm><md-switch ng-model=\"vm.categoria.ativo\" aria-label=\"Ativo\" name=\"ativo\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\"><span \ntranslate=\"TRABALHE_CONOSCO_AREAS_ATUACAO.ATIVO\"></span></md-switch></md-input-container></div><div layout-gt-xs=\"row\" \nflex><md-input-container class=\"md-block\" flex-gt-sm><label translate=\"TRABALHE_CONOSCO_CATEGORIA.DESCRICAO\"></label>\n<textarea type=\"textarea\" ng-model=\"vm.categoria.descricao\" name=\"descricao\" md-no-resize=\"true\" \nmascara-tamanho-campo=\"500\" ng-required=\"vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo\" \nmd-maxlength=\"500\" \nng-disabled=\"(vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo) || vm.controleForm.emProgresso\">\n\r\n                    <div ng-messages=\"vm.form.descricao.$error\">\r\n                        <div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div>\r\n                    </div>\r\n                    </textarea>\n</md-input-container></div><div layout-gt-xs=\"row\" flex><md-input-container class=\"md-block\" flex-gt-sm><md-checkbox \nng-model=\"vm.categoria.likendinObrigatorio\" aria-label=\"Linkedin Obrigatório\" name=\"likendIn Obrigatório\"><span \nclass=\"float-label-cor-default\" translate=\"TRABALHE_CONOSCO_CATEGORIA.LINKEDIN_OBRIOGATORIO\"></span></md-checkbox>\n</md-input-container></div><div layout-gt-xs=\"row\" flex><div layout-gt-xs=\"column\" flex=\"30\"><div class=\"btn-arquivo\">\n<input type=\"file\" im-file-change=\"vm.metodos.selecionarArquivoFotoDivulgacao($event, arquivos)\" name=\"fotoDivulgacao\" \naccept=\"image/jpeg, image/png\" \nng-disabled=\"vm.controleForm.emProgresso || (!vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo)\" \nng-model=\"vm.categoria.imagemFotoDivulgacao\" ng-required=\"vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo\">\n<fieldset><legend><div><label>{{\'TRABALHE_CONOSCO_CATEGORIA.FOTO_DIVULGACAO\' | translate}} <span \nng-if=\"vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo\">*</span></label><i \nclass=\"icon-file-image-box s20 icone-cor-padrao\" \nng-disabled=\"vm.controleForm.emProgresso || (!vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo)\"></i></div>\n<div><span class=\"info\">* Resolução ideal 1368x400</span></div></legend><picture \nng-if=\"vm.categoria.imagemFotoDivulgacao.tipoArquivo && vm.categoria.imagemFotoDivulgacao.base64StringArquivo\"><img \nsrc=\"data:{{vm.categoria.imagemFotoDivulgacao.tipoArquivo}};base64,{{vm.categoria.imagemFotoDivulgacao.base64StringArquivo}}\" \nstyle=\"width: auto; max-width: 20em; height: auto; max-height: 20em\"></picture><picture \nng-if=\"!vm.categoria.imagemFotoDivulgacao.tipoArquivo || !vm.categoria.imagemFotoDivulgacao.base64StringArquivo\"><img \nsrc=\"./../../../../../../assets/images/etc/1368x800.jpg\" \nstyle=\"width: auto; max-width: 20em; height: auto; max-height: 20em\"></picture></fieldset><span class=\"info-warn\" \nng-show=\"(vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo) && vm.categoria.imagemFotoDivulgacao == null\">\nA Imagem é obrigatória</span></div></div><div layout-gt-xs=\"column\" flex-offset-gt-sm=\"10\" flex=\"30\"><div \nclass=\"btn-arquivo\"><input type=\"file\" im-file-change=\"vm.metodos.selecionarArquivoFotoIcone($event, arquivos)\" \nname=\"fotoIcone\" accept=\"image/jpeg, image/png\" \nng-disabled=\"vm.controleForm.emProgresso || (!vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo)\" \nng-model=\"vm.categoria.imagemFotoIcone\" ng-required=\"vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo\">\n<fieldset><legend><div><label>{{\'TRABALHE_CONOSCO_CATEGORIA.FOTO_ICONE\' | translate}}<span \nng-if=\"vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo\"> *</span></label><i \nclass=\"icon-file-image-box s20 icone-cor-padrao\" \nng-disabled=\"vm.controleForm.emProgresso || (!vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo)\"></i></div>\n<div><span class=\"info\">* Resolução ideal 300x300</span></div></legend><picture \nng-if=\"vm.categoria.imagemFotoIcone.tipoArquivo && vm.categoria.imagemFotoIcone.base64StringArquivo\"><img \nsrc=\"data:{{vm.categoria.imagemFotoIcone.tipoArquivo}};base64,{{vm.categoria.imagemFotoIcone.base64StringArquivo}}\" \nstyle=\"width: auto; max-width: 20em; height: auto; max-height: 20em\"></picture><picture \nng-if=\"!vm.categoria.imagemFotoIcone.tipoArquivo || !vm.categoria.imagemFotoIcone.base64StringArquivo\"><img \nsrc=\"./../../../../../../assets/images/etc/300x300.jpg\" \nstyle=\"width: auto; max-width: 20em; height: auto; max-height: 20em\"></picture></fieldset><span class=\"info-warn\" \nng-show=\"(vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo) && vm.categoria.imagemFotoIcone == null\">\nA Imagem é obrigatória</span></div></div></div></div></md-content>");
$templateCache.put("app/main/protecao/processamento/atualizacao-cliente/step/caracteristicas/caracteristicas-step.html","<div layout=\"column\" flex><div layout-gt-sm=\"row\" flex><ms-auto-complete-tabela flex \ntexto-fild-set=\"ATUALIZACAO_CLIENTE.CARACTERISTICA_A_NAO_ATUALIZAR\" \ninput-name=\"Características de contrato a não imprimir\" rota-da-pesquisa=\"{{vm.rotaDePesquisa}}\" \nitem-template=\"descricao\" mensagem-nao-encontrado=\"Não foi encontrado nenhuma característica\" \ntitulo-tabela=\"Descrição\" texto-icone-remover=\"ATUALIZACAO_CLIENTE.REMOVER_CARACTERISTICA\" \ntexto-floating-label=\"Características de contrato\" texto-icone-remover=\"Remover característica\" \nfiltros=\"vm.filtro.caracteristicasContratoANaoImprimir\" texto-floating-label=\"Características a não imprimir\" \nhabilita-check-limpar=\" vm.filtro.caracteristicasContratoANaoImprimir.length\" \nlabel-check-limpar=\"ATUALIZACAO_CLIENTE.LIMPAR_CARACTERISTICAS\"></ms-auto-complete-tabela></div></div>");
$templateCache.put("app/main/protecao/processamento/atualizacao-cliente/step/contrato/contrato-step.html","<div class=\"widget-group\" layout=\"row\" flex=\"100\" layout-wrap ng-hide=\"AtualizacaoClienteFactory.preLoader\"><ms-widget \nflippable=\"false\" layout=\"row\" flex=\"100\" flex-gt-sm=\"60\" ng-if=\"vm.filtro.clientes.length > 0\"><ms-widget-front \nclass=\"white-bg\"><div class=\"ph-16 pv-24 border-bottom\" layout=\"row\" layout-align=\"space-between center\" \nstyle=\"min-height: 105px\"><div layout=\"column\" layout-align=\"start start\"><span class=\"h3\">Seleção de clientes</span>\n<div style=\"margin: 7px 0px\"><span class=\"ml-16 text-boxed blue-bg white-fg\" style=\"margin: 0px\">\nQuantidade de clientes listados: {{vm.filtro.clientes.length}}</span> <span class=\"ml-16 text-boxed green-bg white-fg\">\nQuantidade de clientes selecionados: {{ vm.selecaoCliente.length }}</span></div></div><md-menu><md-button \naria-label=\"more\" class=\"md-icon-button\" ng-click=\"$mdOpenMenu($event)\" ng-disabled=\"!vm.usuarioPermiteEdicao\"><md-icon\n md-font-icon=\"icon-dots-vertical\"></md-icon></md-button><md-menu-content width=\"2\"><md-menu-item><md-button \nng-click=\"vm.metodosCliente.marcarTodos()\" aria-label=\"Refresh widget\">Marcar todos</md-button></md-menu-item>\n<md-menu-item><md-button ng-click=\"vm.metodosCliente.desmarcarTodos()\" aria-label=\"Refresh widget\">Desmarcar todos\n</md-button></md-menu-item></md-menu-content></md-menu></div><table class=\"dataTable row-border hover\" datatable=\"ng\" \ndt-options=\"vm.options\"><thead><tr><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title text-center\">Selecionar</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span\n class=\"column-title text-center\">Nome</span></div></th></tr></thead><tbody><tr \nng-repeat=\"cliente in vm.filtro.clientes track by $index\" ng-click=\"vm.metodosCliente.selecionarContratos(cliente)\"><td\n class=\"text-center\"><md-checkbox ng-model=\"cliente.selecionado\" ng-change=\"vm.metodosCliente.selecionar(cliente)\" \nng-disabled=\"!vm.usuarioPermiteEdicao || vm.preLoader\" aria-label=\"simples\" ng-required=\"!vm.existeClienteSelecionado\">\n</md-checkbox></td><td class=\"text-center\"><span>{{cliente.nome}}</span></td></tr></tbody></table></ms-widget-front>\n</ms-widget><ms-widget flippable=\"false\" layout=\"row\" flex=\"100\" flex-gt-sm=\"40\"><ms-widget-front class=\"white-bg\"><div\n class=\"ph-16 pv-24 border-bottom\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"column\" \nlayout-align=\"start start\"><span class=\"h3\">Seleção de contratos</span> <span \nclass=\"ml-16 text-boxed blue-bg white-fg\" style=\"margin: 5px 0px\">\nQuantidade de contratos listados: {{vm.clienteContratoItens.length}}</span></div><md-menu><md-button aria-label=\"more\" \nclass=\"md-icon-button\" ng-click=\"$mdOpenMenu($event)\" ng-disabled=\"!vm.usuarioPermiteEdicao\"><md-icon \nmd-font-icon=\"icon-dots-vertical\"></md-icon></md-button><md-menu-content width=\"2\"><md-menu-item><md-button \nng-click=\"vm.metodosContrato.adicionarTodos(vm.clienteContratoItens)\" aria-label=\"Refresh widget\">Adicionar todos\n</md-button></md-menu-item><md-menu-item><md-button \nng-click=\"vm.metodosContrato.removerTodos(vm.clienteContratoItens)\" aria-label=\"Refresh widget\">Remover todos\n</md-button></md-menu-item></md-menu-content></md-menu></div><div class=\"ph-16 pv-15 border-bottom\" layout=\"row\" \nlayout-align=\"start center\" ng-repeat=\"contrato in vm.clienteContratoItens track by $index\"><div><i \nng-click=\"vm.metodosContrato.selecaoContrato(contrato)\" ng-if=\"vm.usuarioPermiteEdicao\" \nclass=\"icon pr-16 mr-16 border-right\" \nng-class=\"{\'icon-delete red-fg\':contrato.selecionado === true,\r\n                                  \'icon-plus green-fg\':contrato.selecionado === false}\">\n</i> <i class=\"icon pr-16 mr-16 border-right\" ng-if=\"!vm.usuarioPermiteEdicao\" \nng-class=\"{\'icon-delete gray-fg\': vm.usuarioPermiteEdicao === false}\"></i></div><div class=\"h4 text-bold\" flex>\n{{contrato.produto}}</div><div class=\"h4 font-weight-500 secondary-text\">{{contrato.expiracao}}</div></div>\n</ms-widget-front></ms-widget></div>");
$templateCache.put("app/main/protecao/processamento/atualizacao-cliente/step/data-expiracao/data-expiracao-step.html","<div layout=\"column\" class=\"page-layout carded fullwidth\"><div layout=\"column\" flex flex-gt-sm=\"100\">\n<md-input-container class=\"md-block aumentar-tamanho-campo-data-ultima-validacao\"><label \ntranslate=\"ATUALIZACAO_CLIENTE.DATA\"></label><md-datepicker ng-model=\"vm.filtro.dataExpiracao\" name=\"dataExpiracao\" \nmd-min-date=\"vm.dataAtual\" md-open-on-focus=\"\" mascara-conversor-string-para-data ng-mask=\"3?9/1?9/9999\" \nng-required=\"true\"></md-datepicker><div ng-messages=\"vm.form.dataExpiracao.$error\"><div ng-message=\"valid\" \ntranslate=\"MENSAGEM_VALIDACAO.DATA_INVALIDA\"></div><div ng-message=\"mindate\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_DATA_ATUAL\"></div><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container></div></div>");
$templateCache.put("app/main/protecao/processamento/atualizacao-cliente/step/produto/produto-step.html","<div layout-gt-sm=\"row\" flex><div layout=\"column\" flex-gt-sm=\"50\"><md-input-container \nclass=\"md-block font-size-tamanho-form-padrao\" flex-gt-sm=\"30\"><label translate=\"ATUALIZACAO_CLIENTE.PRODUTO\">Produto\n</label><md-select name=\"produto\" ng-disabled=\"vm.preLoader\" ng-model=\"vm.filtro.produtoCodigo\" ng-required=\"true\">\n<md-option ng-value=\"produto.codigo\" ng-repeat=\"produto in vm.produtos track by $index\">{{produto.descricao}}\n</md-option></md-select><div ng-messages=\"vm.form.produto.$error\"><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container></div><div layout=\"column\" \nflex-offset-gt-sm=\"5\" flex-gt-sm=\"50\"><div layout=\"column\" layout-align=\"center center\" \nng-show=\"vm.requisicaoSolicitada\"><span class=\"font-weight-500\">Aguarde...</span><md-progress-circular \nmd-mode=\"indeterminate\" md-diameter=\"30\" class=\"md-accent\"></md-progress-circular></div></div></div>");
$templateCache.put("app/main/trabalhe-conosco/cadastro/area-atuacao/views/tabs/tab-area-atuacao.html","<md-content class=\"md-padding\" ms-scroll><div class=\"form-container\"><div layout-gt-xs=\"row\"><md-input-container \nclass=\"md-block\" flex-gt-sm=\"80\"><label translate=\"TRABALHE_CONOSCO_AREAS_ATUACAO.TITULO\"></label><input type=\"text\" \nng-model=\"vm.area.titulo\" name=\"titulo\" mascara-tamanho-campo=\"100\" \nng-required=\"vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo\" md-maxlength=\"100\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\"><div \nng-messages=\"vm.form.areaatuacao.titulo.$error\"><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container><md-input-container class=\"md-block\">\n<md-switch ng-model=\"vm.area.ativo\" aria-label=\"Ativo\" name=\"ativo\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\"><span \ntranslate=\"TRABALHE_CONOSCO_AREAS_ATUACAO.ATIVO\"></span></md-switch></md-input-container><md-input-container \nclass=\"md-block\"><md-switch ng-model=\"vm.area.disponivel\" aria-label=\"Disponível\" name=\"disponuivel\" \nng-disabled=\"!vm.area.ativo || vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\">\n<span translate=\"TRABALHE_CONOSCO_AREAS_ATUACAO.DISPONIVEL\"></span></md-switch></md-input-container></div><div \nlayout-gt-xs=\"row\"><md-input-container class=\"md-block\" flex-gt-sm=\"40\"><label \ntranslate=\"TRABALHE_CONOSCO_AREAS_ATUACAO.CATEGORIA\"></label><md-select ng-model=\"vm.area.categoriaCodigo\" \nname=\"categoria\" md-on-open=\"vm.metodos.configuraMdSelectCargo()\" \nng-required=\"vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\">\n<md-select-header><input id=\"area-form-categoria-md-select\" class=\"md-text\" ng-model=\"vm.filtrarCategoria\" \ntype=\"search\" placeholder=\"\" translate translate-attr-placeholder=\"TRABALHE_CONOSCO_AREAS_ATUACAO.PESQUISAR_CATEGORIA\">\n</md-select-header><md-option ng-value=\"categoria.codigo\" \nng-repeat=\"categoria in vm.categorias | filter:vm.filtrarCategoria track by categoria.codigo\">{{categoria.titulo}}\n</md-option></md-select><div ng-messages=\"vm.form.areaatuacao.categoria.$error\"><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container><md-autocomplete flex-gt-sm=\"30\" \nflex-offset-gt-sm=\"5\" flex-gt-xs md-input-name=\"cidade\" md-no-cache=\"true\" \nng-blur=\"vm.metodosArea.configuraAutoCompleteCidadeOnBlur()\" \nng-required=\"vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo\" md-selected-item=\"vm.area.cidade\" \nmd-selected-item-change=\"vm.metodosArea.alterarItemSelecionadoAutoCompleteCidade(item)\" \nmd-search-text=\"vm.textoDePesquisaAutoCompleteCidade\" \nmd-items=\"item in vm.metodosArea.pesquisarAutoCompleteCidade(vm.textoDePesquisaAutoCompleteCidade)\" \nmd-item-text=\"item.descricao\" md-autoselect md-floating-label=\"Cidade\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\">\n<md-item-template><span md-highlight-text=\"vm.textoDePesquisaAutoCompleteCidade\">{{item.descricao}}</span>\n</md-item-template><md-not-found><label>Não foi encontrado nenhuma Cidade.</label></md-not-found><div \nng-messages=\"vm.form.areaatuacao.cidade.$error\"><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-autocomplete><md-input-container class=\"md-block\" \nflex><label translate=\"TRABALHE_CONOSCO_AREAS_ATUACAO.UF\">UF</label><md-select ng-model=\"vm.area.cidade.uf\" name=\"uf\" \nng-disabled=\"true\"><md-option ng-value=\"uf\" ng-repeat=\"uf in vm.ufs\">{{uf}}</md-option><md-option ng-value=\"\" \nng-if=\"vm.area.cidade.uf\">Desmarcar</md-option></md-select></md-input-container></div><div layout-gt-xs=\"column\" flex>\n<md-input-container class=\"md-block\"><label translate=\"TRABALHE_CONOSCO_AREAS_ATUACAO.DESCRICAO\"></label><textarea \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\" \nng-model=\"vm.area.descricao\" ng-required=\"vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo\" \nname=\"descricao\" md-no-resize=\"true\" rows=\"5\" max-rows=\"5\">\r\n                        </textarea><div \nng-messages=\"vm.form.areaatuacao.descricao.$error\"><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container></div></div></md-content>");
$templateCache.put("app/main/protecao/processamento/atualizacao-licenca/step/cliente/cliente-step.html","<div layout-gt-sm=\"row\" flex><div layout=\"column\" flex-gt-sm=\"50\"><md-autocomplete flex-gt-sm=\"30\" flex-gt-xs \nmd-input-name=\"cliente\" md-no-cache=\"true\" ng-blur=\"vm.metodos.configuraAutoCompleteClienteOnBlur()\" \nmd-selected-item=\"vm.filtro.cliente\" \nmd-selected-item-change=\"vm.metodos.alterarItemSelecionadoAutoCompleteCliente(item)\" \nmd-search-text=\"vm.textoDePesquisaAutoCompleteCliente\" \nmd-items=\"item in vm.metodos.pesquisarAutoCompleteCliente(vm.textoDePesquisaAutoCompleteCliente)\" \nmd-item-text=\"item.nome\" md-autoselect md-floating-label=\"Cliente\" required><md-item-template><span \nmd-highlight-text=\"vm.textoDePesquisaAutoCompleteCliente\">{{item.nome}}</span></md-item-template><md-not-found><label>\nNão foi encontrado nenhum Cliente.</label></md-not-found></md-autocomplete></div><div layout=\"column\" \nflex-offset-gt-sm=\"5\" flex-gt-sm=\"50\"><md-input-container class=\"md-block font-size-tamanho-form-padrao\" \nflex-gt-sm=\"30\"><label translate=\"ATUALIZACAO_LICENCA.PRODUTO\">Produto</label><md-select name=\"produto\" \nng-model=\"vm.filtro.produto\" ng-disabled=\"vm.filtro.cliente == null\" ng-required=\"vm.filtro.cliente != null\"><md-option\n ng-value=\"produto\" ng-repeat=\"produto in vm.produtos\">{{produto.descricao}}</md-option></md-select>\n</md-input-container></div></div>");
$templateCache.put("app/main/protecao/processamento/atualizacao-licenca/step/tipo-licenca/tipo-licenca-step.html","<div layout=\"column\" class=\"page-layout carded fullwidth\"><p><span class=\"text-bold\">Informações contratuais: </span>\n{{vm.filtro.cliente.nome}} | {{vm.produtoDescricao}}</p><div layout-gt-sm=\"row\" flex><div layout=\"column\" \nflex-gt-sm=\"70\"><div layout=\"row\" layout-align=\"center start\" flex><md-input-container class=\"md-block\" flex><label \ntranslate=\"ATUALIZACAO_LICENCA.TIPO_LICENCA\"></label><md-select ng-model=\"vm.filtro.tiposLicenca\" name=\"tiposLicenca\" \nng-disabled=\"vm.licencas.length == 0\" multiple=\"multiple\" ng-model-options=\"{trackBy: \'$value.codigo\'}\" \nmd-on-open=\"vm.metodos.configuraMdSelectTipoLicenca()\" required><md-select-header><input \nid=\"atualizacao-form-tipo-licenca-md-select\" class=\"md-text\" ng-model=\"vm.filtrarTiposLicenca\" type=\"search\" \nplaceholder=\"\" translate translate-attr-placeholder=\"ATUALIZACAO_LICENCA.PESQUISAR_TIPO_LICENCA\"></md-select-header>\n<md-option ng-value=\"tipo\" ng-repeat=\"tipo in vm.tiposLicenca | filter:vm.filtrarTiposLicenca track by tipo.codigo\">\n{{tipo.descricao}}</md-option></md-select></md-input-container></div><md-input-container class=\"md-block\" \nflex-offset-gt-sm=\"1\"><md-checkbox ng-model=\"vm.filtro.marcarTodos\" aria-label=\"Ativo\" name=\"marcarTodos\" \nng-disabled=\"vm.licencas.length == 0\" ng-change=\"vm.metodos.onClickColumnSelecionar(vm.filtro.marcarTodos)\"><span \ntranslate=\"ATUALIZACAO_LICENCA.TODOS\"></span></md-checkbox></md-input-container></div><div layout=\"column\" \nflex-offset-gt-sm=\"2\" flex-gt-sm=\"30\"><div layout=\"row\" layout-align=\"center start\" flex><md-input-container \nclass=\"md-block\" flex><md-radio-group ng-model=\"vm.filtro.rotina\" ng-disabled=\"vm.licencas.length == 0\" \nlayout-gt-sm=\"row\" required flex><md-radio-button value=\"{{key}}\" aria-label=\"{{value}}\" \nng-repeat=\"(key, value) in vm.ordenacao\">{{value}}</md-radio-button></md-radio-group></md-input-container></div></div>\n</div><div layout=\"column\"><div layout=\"column\" flex><div \nclass=\"md-background-bg md-whiteframe-1dp fullpage-datatable\" layout=\"column\" flex><table class=\"row-border hover\" \ndatatable=\"ng\" id=\"datatable-product-backlog\" dt-options=\"vm.dtOptionsLicenca\"><thead><tr><th class=\"secondary-text\">\n<div class=\"table-header\"><span class=\"column-title text-center\">Selecionar</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title text-center\">Licença</span></div></th></tr>\n</thead><tbody><tr ng-repeat=\"licenca in vm.licencas\"><td class=\"text-center\"><md-checkbox ng-model=\"licenca.flag\" \naria-label=\"simples\"></md-checkbox></td><td>{{licenca.numero}}</td></tr></tbody></table></div></div></div></div>");
$templateCache.put("app/main/solicitacao/consulta/solicitacao/views/consulta-solicitacao-dialog/consulta-solicitacao-dialog.html","<md-dialog class=\"dialogo-padrao\" id=\"dialog-consulta-solicitacao\" aria-label=\"dialog\"><md-toolbar \nclass=\"md-accent md-tall\" layout=\"column\"><div class=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" \nlayout-align=\"space-between center\"><span class=\"title\">{{vm.titulo}}</span><md-button class=\"md-icon-button\" \nng-click=\"vm.metodosDialog.fecharDialog()\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar>\n<md-dialog-content><div class=\"md-padding md-background-bg md-whiteframe-1dp fullpage-datatable\" layout=\"column\" flex>\n<table id=\"datatables-consulta-solicitacao\" class=\"dataTable row-border hover\" datatable=\"ng\" \ndt-options=\"vm.dtOptions\"><thead><tr><th class=\"secondary-text\">Ação</th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Numero</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Ano</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Data abertura</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Descrição</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Cliente</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Origem</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Solução</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Fase</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Prioridade</span></div></th></tr></thead><tbody><tr \nng-repeat=\"solicitacao in vm.solicitacoes\"><td><i class=\"icon-pencil s16 icone-cor-padrao\" \nng-click=\"vm.controleForm.emProgresso || vm.metodosDialog.selecionarSolicitacao(solicitacao)\" \nng-disabled=\"vm.controleForm.emProgresso\"><md-tooltip><label translate=\"CONSULTA_SOLICITACAO.SELECIONAR_SOLICITACAO\">\n</label></md-tooltip></i></td><td>{{solicitacao.numero}}</td><td>{{solicitacao.ano}}</td><td>\n{{solicitacao.dataAbertura | date:\'dd/MM/yyyy\'}}</td><td class=\"descricao-historia\">{{solicitacao.descricao}}</td><td>\n{{solicitacao.clienteNome}}</td><td>{{solicitacao.descricaoOrigem}}</td><td>{{solicitacao.solucaoDescricao}}</td><td \nng-dblclick=\"vm.metodosDialog.abrirDialogInserirHistorico(solicitacao, $event, $index)\"><div \nclass=\"border-bottom-solicitacao-fase\">{{solicitacao.descricaoUltimaSolicitacaoFase}}</div></td><td>\n{{solicitacao.descricaoNecessidadeCliente}}</td></tr></tbody></table></div></md-dialog-content></md-dialog>");
$templateCache.put("app/main/solicitacao/consulta/solicitacao/views/legenda-dialog/legenda-dialog.html","<md-dialog class=\"dialogo-padrao\" id=\"dialog-consulta-solicitacao\" aria-label=\"dialog\" \nstyle=\"max-width: 35% !important\"><md-toolbar class=\"md-accent md-tall\" layout=\"column\"><div \nclass=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\">\nLegenda</span><md-button class=\"md-icon-button\" ng-click=\"vm.metodos.fecharDialog()\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content><div \nclass=\"md-padding md-background-bg md-whiteframe-1dp fullpage-datatable\" layout=\"row\" style=\"align-items: center\" flex>\n<span id=\"circulo-vermelho\"></span><p class=\"ml-5\" style=\"font-weight: bold; font-size: 16px; margin: 5px 5px\">\nSolicitações com prioridade \"Deve ter.\"</p></div><div \nclass=\"md-padding md-background-bg md-whiteframe-1dp fullpage-datatable\" layout=\"row\" style=\"align-items: center\" flex>\n<span id=\"circulo-amarelo\"></span><p class=\"ml-5\" style=\"font-weight: bold; font-size: 16px; margin: 5px 5px\">\nSolicitações com prioridade \"Deve ter\" e \"Deveria ter.\"</p></div><div \nclass=\"md-padding md-background-bg md-whiteframe-1dp fullpage-datatable\" layout=\"row\" style=\"align-items: center\" flex>\n<span id=\"circulo-preto\"></span><p class=\"ml-5\" style=\"font-weight: bold; font-size: 16px; margin: 5px 5px\">\nSolicitações com todas as prioridades.</p></div><div \nclass=\"md-padding md-background-bg md-whiteframe-1dp fullpage-datatable\" layout=\"row\" style=\"align-items: center\" flex>\n<span id=\"circulo-azul\"></span><p class=\"ml-5\" style=\"font-weight: bold; font-size: 16px; margin: 5px 5px\">\nSolicitações concluídas.</p></div></md-dialog-content></md-dialog>");
$templateCache.put("app/main/solicitacao/processamento/solicitacao/tabs/documentacao/tab-documentacao.html","<md-content id=\"tab-documentacao\"><div layout=\"column\" layout-gt-md=\"row\"><card-documentacao-solicitacao \nng-repeat=\"etapa in vm.etapas\" titulo=\"etapa.nome\" etapa=\"etapa\" \nabrir-dialog-visualizar=\"vm.metodos.abrirDialogDocumentacao(etapa, \'visualizar\')\" \nabrir-dialog-editar=\"vm.metodos.abrirDialogDocumentacao(etapa, \'editar\')\" flex=\"25\"></card-documentacao-solicitacao>\n</div></md-content>");
$templateCache.put("app/main/solicitacao/processamento/solicitacao/tabs/estimativa/tab-estimativa.html","<div class=\"text-center\" flex><ms-widget flippable=\"false\" layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"25\">\n<ms-widget-front class=\"md-accent-bg\"><div class=\"pl-16 pr-8 pv-16 h-55\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"h3 white-fg\">Estimativa de pontos</div><button \nng-click=\"vm.metodosEstimativa.abrirDialogEditarPontuacao()\"><i class=\"icon-pencil white-fg\"></i></button></div><div \nclass=\"pt-8 pb-32\" layout=\"column\" layout-align=\"center center\"><div class=\"white-fg font-size-72 line-height-72\">\n{{vm.solicitacao.estimativaPontos}}</div><div ng-if=\"vm.solicitacao.estimativaPontos != 1\" \nclass=\"h3 white-fg font-weight-500\">PONTOS</div><div ng-if=\"vm.solicitacao.estimativaPontos == 1\" \nclass=\"h3 white-fg font-weight-500\">PONTO</div></div></ms-widget-front></ms-widget></div>");
$templateCache.put("app/main/solicitacao/processamento/solicitacao/tabs/historico/tab-historico.html","<md-content><div class=\"inserir-button\" layout-gt-xs=\"row\" flex layout-align=\"end center\"><md-button \nclass=\"md-fab md-accent md-icon-button sample-show-hide\" \nng-click=\"vm.metodosHistorico.abrirDialogEditarHistorico($event)\" aria-label=\"Inserir Histórico Situação\" translate \ntranslate-attr-aria-label=\"HISTORICO.INSERIR_HISTORICO_SOLICITACAO\"><md-icon md-font-icon=\"icon-plus s30\"></md-icon>\n<md-tooltip md-autohide><span translate=\"HISTORICO.INSERIR_HISTORICO_SOLICITACAO\"></span></md-tooltip></md-button>\n</div><div class=\"md-background-bg md-whiteframe-1dp\"><table class=\"dataTable row-border hover\" datatable=\"ng\" \ndt-options=\"vm.dtOptionsSolicitacaoHistorico\" width=\"100%\"><thead><tr><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Ação</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Fase</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Usuário</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Data</span></div></th></tr></thead><tbody><tr \nng-repeat=\"solicitacaoHistorico in vm.solicitacao.solicitacaoHistoricos | orderBy: \'-data\' track by solicitacaoHistorico.codigo\">\n<td class=\"button-icone-cor-azul\"><i \nng-click=\"vm.metodosHistorico.abrirDialogEditarHistorico($event, $index, solicitacaoHistorico)\" \nclass=\"icon-pencil s16 icone-cor-padrao mr-10\"><md-tooltip md-autohide><span \ntranslate=\"HISTORICO.EDITAR_HISTORICO_SOLICITACAO\"></span></md-tooltip></i><i class=\"icon-delete s16 icone-cor-padrao\" \nng-click=\"vm.metodosHistorico.excluir($event, solicitacaoHistorico)\"><md-tooltip md-autohide><span \ntranslate=\"HISTORICO.EXCLUIR_HISTORICO_SOLICITACAO\"></span></md-tooltip></i></td><td>\n{{solicitacaoHistorico.solicitacaoFase.descricao}}</td><td>{{solicitacaoHistorico.usuarioAbertura.login}}</td><td>\n{{solicitacaoHistorico.data | date:\'dd/MM/yyyy\'}}</td></tr></tbody></table></div></md-content>");
$templateCache.put("app/main/solicitacao/processamento/solicitacao/tabs/solicitacao/tab-solicitacao.html","<md-content class=\"md-padding\" id=\"tab-solicitacao\" ms-scroll><md-fab-speed-dial md-direction=\"left\" class=\"md-scale\" \nstyle=\"right: 0\" layout-align=\"end start\"><md-fab-trigger><md-button aria-label=\"menu\" \nclass=\"md-fab md-accent md-icon-button\"><md-icon ng-disabled=\"true\" md-font-icon=\"icon-menu s30\"></md-icon></md-button>\n</md-fab-trigger><md-fab-actions><md-button class=\"md-fab md-raised md-mini md-accent\" aria-label=\"Add\" translate \ntranslate-aria-label=\"SOLICITACAO.CRIAR_HISTORIA\" \nng-click=\"vm.metodosSolicitacao.criarHistoriaAPartirDaSolicitacao(vm.solicitacao)\" \nng-disabled=\"(!vm.solicitacao.numero && !vm.solicitacao.ano) ||\r\n                 (!vm.controleForm.pesquisaAtiva || vm.controleForm.inserirAtivo || vm.controleForm.editarAtivo)\">\n<md-icon md-font-icon=\"icon-plus s30\"></md-icon><md-tooltip md-direction=\"top\"><span \ntranslate=\"SOLICITACAO.CRIAR_HISTORIA\"></span></md-tooltip></md-button></md-fab-actions></md-fab-speed-dial><div \nclass=\"form-container\"><div layout-gt-xs=\"row\"><md-input-container class=\"md-block\" flex-gt-sm=\"25\" \nng-if=\"vm.squadUsuarioLogado.length > 1\"><label>Squad</label><md-select ng-model=\"vm.solicitacao.squadCodigo\" \nng-change=\"vm.metodosSolicitacao.selectChangeSquad(vm.solicitacao.squadCodigo)\" name=\"squadCodigo\" \nng-required=\"!vm.controleForm.pesquisaAtiva || vm.controleForm.inserirAtivo\" \nng-disabled=\"(vm.controleForm.pesquisaAtiva || vm.controleForm.editarAtivo) && !vm.controleForm.inserirAtivo\">\n<md-option ng-value=\"squad.codigo\" ng-repeat=\"squad in vm.squads track by squad.codigo\">{{squad.descricao}}</md-option>\n</md-select><div ng-messages=\"vm.solicitacaoForm.squadCodigo.$error\"><div ng-message=\"required\">Campo obrigatório</div>\n</div></md-input-container><md-input-container class=\"md-block\" flex-gt-sm=\"30\"><label translate=\"SOLICITACAO.NUMERO\">\nNúmero</label><input define-focus model-focus=\"vm.solicitacao\" define-focus-no-campo-quando-nova-pesquisa=\"true\" \ntype=\"text\" ng-model=\"vm.solicitacao.numero\" name=\"solicitacaoNumero\" mascara-numero-generica=\"#####\" \nconverte-mascara-para-numero ng-required=\"vm.controleForm.inserirAtivo || vm.controleForm.editarAtivo\" \nng-disabled=\"vm.controleForm.pesquisaAtiva || vm.controleForm.inserirAtivo || vm.controleForm.editarAtivo\"><div \nng-messages=\"vm.solicitacaoForm.solicitacaoNumero.$error\"><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container><md-input-container class=\"md-block\" \nflex-gt-sm=\"30\"><label translate=\"SOLICITACAO.ANO\">Ano</label><input class=\"field-search\" type=\"text\" \nng-model=\"vm.solicitacao.ano\" name=\"solicitacaoAno\" mascara-numero-generica=\"####\" converte-mascara-para-numero \nng-required=\"vm.controleForm.inserirAtivo\" \nng-disabled=\"vm.controleForm.pesquisaAtiva || vm.controleForm.inserirAtivo || vm.controleForm.editarAtivo\"><div \nng-messages=\"vm.solicitacaoForm.solicitacaoAno.$error\"><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container><md-input-container flex-xs flex-sm \nflex-gt-sm=\"40\" id=\"tab-solicitacao-data-abertura\"><label translate=\"SOLICITACAO.DATA_ABERTURA\" \nclass=\"alinhar-label-data\"></label><md-datepicker flex-xs ng-model=\"vm.solicitacao.dataAbertura\" name=\"dataAbertura\" \nmd-max-date=\"vm.solicitacao.dataAbertura\" mascara-conversor-string-para-data ng-mask=\"3?9/1?9/9999\" \nng-required=\"vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo\" \nng-disabled=\"vm.controleForm.pesquisaAtiva || vm.controleForm.inserirAtivo || vm.controleForm.editarAtivo\">\n</md-datepicker><div ng-messages=\"vm.solicitacaoForm.dataAbertura.$error\"><div ng-message=\"valid\" \ntranslate=\"MENSAGEM_VALIDACAO.DATA_INVALIDA\"></div><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.DATA_OBRIGATORIA\"></div><div ng-message=\"maxdate\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_DATA_INICIAL\"></div></div></md-input-container></div><div layout-gt-xs=\"row\">\n<md-autocomplete flex-gt-sm=\"45\" flex-gt-xs ng-required=\"vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\" \nmd-input-name=\"solicitacaoCliente\" md-no-cache=\"true\" md-selected-item=\"vm.solicitacao.cliente\" \nmd-selected-item-change=\"vm.metodosSolicitacao.alterarItemSelecionadoAutoCompleteCliente(item)\" \nmd-search-text=\"vm.textoDePesquisaAutoCompleteCliente\" \nmd-items=\"item in vm.metodosSolicitacao.pesquisarAutoCompleteCliente(vm.textoDePesquisaAutoCompleteCliente)\" \nmd-item-text=\"item.codigo + \' - \' + item.nome\" md-autoselect md-floating-label=\"Cliente\"><md-item-template><span \nmd-highlight-text=\"vm.textoDePesquisaAutoCompleteCliente\">{{item.codigo}} - {{item.nome}}</span></md-item-template><div\n ng-messages=\"vm.solicitacaoForm.solicitacaoCliente.$error\"><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-autocomplete><md-input-container class=\"md-block\" \nflex-gt-sm=\"45\"><label translate=\"SOLICITACAO.SOLUCAO\">Solução</label><md-select \nng-model=\"vm.solicitacao.solucaoCodigo\" name=\"solicitacaoSolucaoCodigo\" \nmd-on-open=\"vm.metodosSolicitacao.configuraMdSelectSolucao()\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\" \nng-change=\"vm.metodosSolicitacao.selectChangeSolucao(vm.solicitacao.solucaoCodigo)\" \nng-required=\"vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo\"><md-select-header \nng-if=\"(vm.squadUsuarioLogado.length === 1 && vm.solucoes.length > 0 && !vm.buscandoSolucoes) ||\r\n                         (vm.squadUsuarioLogado.length > 1 && vm.solicitacao.squadCodigo && vm.solucoes.length > 0 && !vm.buscandoSolucoes)\">\n<input id=\"tab-solicitacao-solucao-md-select\" class=\"md-text\" ng-model=\"vm.filtrarSolucoes\" type=\"search\" \nplaceholder=\"\" translate translate-attr-placeholder=\"SOLICITACAO.PESQUISAR_SOLUCAO\"></md-select-header><md-option \nng-if=\"vm.buscandoSolucoes\" disabled=\"disabled\"><md-progress-circular md-mode=\"indeterminate\" class=\"md-accent\" \nmd-diameter=\"30\"></md-progress-circular></md-option><md-option md-option-empty \nng-if=\"vm.solucoes.length > 0 && vm.solicitacao.solucaoCodigo !== \'Nenhum\' && vm.solicitacao.solucaoCodigo != null\">\nNenhum</md-option><md-option \nng-if=\"(vm.solicitacao.squadCodigo || (vm.squadUsuarioLogado.length == 1 && !vm.solicitacao.squadCodigo)) && !vm.buscandoSolucoes\" \nng-value=\"solucao.codigo\" \nng-repeat=\"solucao in vm.solucoes | \r\n                                          filter:vm.filtrarSolucoes \r\n                                          track by solucao.codigo\">\n{{solucao.descricao}}</md-option><md-option \nng-if=\"(vm.solucoes.length === 0 && !vm.buscandoSolucoes) || \r\n                                      vm.filtrarSolucoes && \r\n                                      (vm.solucoes | filter:vm.filtrarSolucoes).length === 0\" \ndisabled=\"disabled\">Nenhuma solução encontrada.</md-option><md-option \nng-if=\"!vm.solicitacao.squadCodigo && vm.squadUsuarioLogado.length > 1\" disabled=\"disabled\">\nÉ necessário informar uma squad.</md-option></md-select><div \nng-messages=\"vm.solicitacaoForm.solicitacaoSolucaoCodigo.$error\"><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container></div><div layout-gt-xs=\"row\">\n<md-input-container class=\"md-block\" flex><label translate=\"SOLICITACAO.DESCRICAO\"></label><textarea \nng-model=\"vm.solicitacao.descricao\" name=\"solicitacaoDescricao\" \nng-required=\"vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo\" md-no-resize=\"true\" rows=\"2\" max-rows=\"3\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\">\n\r\n                 </textarea><div ng-messages=\"vm.solicitacaoForm.solicitacaoDescricao.$error\"><div \nng-message=\"required\" translate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container></div><div \nlayout-gt-xs=\"row\"><md-input-container class=\"md-block\" flex><label translate=\"SOLICITACAO.ORIGEM\">ORIGEM</label>\n<md-select ng-model=\"vm.solicitacao.origem\" name=\"solicitacaoOrigemCodigo\" \nng-required=\"vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\" \nng-change=\"vm.metodosSolicitacao.listarTodosAtendimentoCliente(vm.solicitacao.clienteCodigo)\"><md-option \nng-value=\"key\" ng-repeat=\"(key, value) in vm.origens\">{{value}}</md-option></md-select><div \nng-messages=\"vm.solicitacaoForm.solicitacaoOrigemCodigo.$error\"><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container><md-input-container class=\"md-block\" \nflex><label translate=\"SOLICITACAO.ATENDIMENTO\"></label><md-select ng-model=\"vm.atendimento\" name=\"atendimento\" \nmd-on-open=\"vm.metodosSolicitacao.configuraMdSelectAtendimento()\" \nng-model-options=\"{trackBy: \'($value.codigo+$value.ano)\'}\" \nmd-on-close=\"vm.metodosSolicitacao.configurarMdSelectAtendimentoOnClose()\" \nng-change=\"vm.metodosSolicitacao.selecionarAtendimento(vm.atendimento)\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo || vm.solicitacao.origem != 2\" \nng-required=\"vm.solicitacao.origem == 2 && (vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo)\">\n<md-select-header><input id=\"tab-solicitacao-atendimento-md-select\" \nng-if=\"vm.atendimentos && vm.atendimentos.length > 0\" class=\"md-text\" ng-model=\"vm.filtrarAtendimentos\" type=\"search\" \nplaceholder=\"\" translate translate-attr-placeholder=\"SOLICITACAO.PESQUISAR_ATENDIMENTO\"> <span \nng-if=\"!vm.atendimentos || vm.atendimentos.length == 0\">Não existem atendimentos vinculados ao cliente</span>\n</md-select-header><md-option ng-value=\"atendimento\" ng-if=\"vm.atendimentos && vm.atendimentos.length > 0\" \nng-repeat=\"atendimento in vm.atendimentos | filter: { descricao: vm.filtrarAtendimentos }\">{{atendimento.descricao}}\n</md-option></md-select><div ng-messages=\"vm.solicitacaoForm.atendimento.$error\"><div ng-message=\"sem_cliente\" \ntranslate=\"SOLICITACAO.SEM_CLIENTE\"></div><div ng-message=\"sem_atendimentos\" translate=\"SOLICITACAO.SEM_ATENDIMENTOS\">\n</div><div ng-message=\"required\" translate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container>\n<md-input-container class=\"md-block\" flex><label translate=\"SOLICITACAO.NECESSIDADE_CLIENTE\">Necessida Cliente</label>\n<md-select ng-model=\"vm.solicitacao.necessidadeCliente\" name=\"necessidadeCliente\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\"><md-option\n ng-value=\"key\" ng-repeat=\"(key, value) in vm.necessidadesCliente\">{{value}}</md-option><md-option ng-value=\"\" \nng-if=\"vm.solicitacao.necessidadeCliente\">Desmarcar</md-option></md-select></md-input-container></div><div \nlayout-gt-xs=\"row\"><md-input-container flex-sm flex-gt-sm=\"5\"><label hide-gt-sm \ntranslate=\"SOLICITACAO.PESQUISAR_USUARIO_POR_CODIGO\"></label><input text=\"text\" \nng-model=\"vm.usuarioAberturaAPesquisar\" aria-label=\"Diretiva Pesquisar por Codigo\" pesquisar-por-codigo \nname=\"solicitacaoUsuarioAbertura\" lista-a-pesquisar=\"vm.usuarios\" \nentidade-pesquisada=\"vm.solicitacao.codigoUsuarioAbertura\" mascara-numeros=\"5\" \nng-required=\"vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo\" \nng-disabled=\"vm.controleForm.pesquisaAtiva || vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo\"><div \nng-messages=\"vm.solicitacaoForm.solicitacaoUsuarioAbertura.$error\"><div ng-message=\"required\" \ntranslate=\"SOLICITACAO.USUARIO_ABERTURA_OBRIGATORIO\"></div></div></md-input-container><md-input-container flex-sm \nclass=\"md-block\" flex-gt-sm=\"40\"><label translate=\"SOLICITACAO.USUARIO_ABERTURA\"></label><md-select \nng-model=\"vm.solicitacao.codigoUsuarioAbertura\" name=\"solicitacaoCodigoUsuarioAbertura\" \nng-disabled=\"vm.controleForm.pesquisaAtiva || vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo\" \nng-required=\"vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo\"><md-option ng-value=\"usuario.codigo\" \nng-repeat=\"usuario in vm.usuarios track by usuario.codigo\">{{usuario.nome}}</md-option></md-select><div \nng-messages=\"vm.solicitacaoForm.solicitacaoCodigoUsuarioAbertura.$error\"><div ng-message=\"required\" \ntranslate=\"SOLICITACAO.USUARIO_ABERTURA_OBRIGATORIO\"></div></div></md-input-container><md-input-container \nclass=\"md-block\" flex-offset-gt-sm=\"5\"><md-checkbox ng-model=\"vm.solicitacao.permitirConsultaExterna\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\" \naria-label=\"PermitirConsultaExterna\" name=\"permitirConsultaExterna\" ,><span class=\"float-label-cor-default\" \ntranslate=\"SOLICITACAO.PERMITIR_CONSULTA_EXTERNA\"></span></md-checkbox></md-input-container></div></div></md-content>");
$templateCache.put("app/main/atendimento/processamento/atendimento/views/dialogs/acompanhantes-dialog/atendimento-dialog-acompanhantes.html","<md-dialog id=\"atendimento-dialog-acompanhantes\" class=\"dialogo-padrao\" aria-label=\"Dialog\"><form \nname=\"vm.form.acompanhanteDialog\" class=\"md-inline-form\" novalidate><md-toolbar class=\"md-accent md-tall\" \nlayout=\"column\"><div class=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" layout-align=\"space-between center\">\n<span class=\"title\">{{vm.titulo}}</span><md-button class=\"md-icon-button\" ng-click=\"vm.metodosDialog.fecharDialog()\" \naria-label=\"Fechar dialog\" translate translate-attr-aria-label=\"SPRINT.FECHAR_DIALOG\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><div layout=\"row\" layout-sm=\"row\" \nlayout-align=\"center\" ng-show=\"vm.requisicaoSolicitada\"><md-progress-circular md-mode=\"indeterminate\" \nclass=\"md-accent\"></md-progress-circular></div><md-dialog-content ng-hide=\"vm.requisicaoSolicitada\"><div \nlayout-gt-xs=\"row\" layout-align=\"center center\" flex><md-input-container class=\"md-block\" flex-gt-sm=\"50\"><label \ntranslate=\"ATENDIMENTO.COLABORADOR\">Colaborador</label><md-select ng-model=\"vm.acompanhante.colaborador\" \nname=\"colaboradorCodigo\" md-on-open=\"vm.metodosDialog.configuraMdSelectColaboradores()\"><md-select-header><input \nid=\"dialog-acompanhante-atendimento-colaborador-md-select\" class=\"md-text\" ng-model=\"vm.filtrarColaborador\" \ntype=\"search\" placeholder=\"\" translate translate-attr-placeholder=\"ATENDIMENTO.PESQUISAR_COLABORADOR\">\n</md-select-header><md-option ng-value=\"colaborador\" \nng-repeat=\"colaborador in vm.colaboradores | filter:vm.filtrarColaborador track by colaborador.codigo\">\n{{colaborador.login}}</md-option></md-select></md-input-container><md-button type=\"submit\" flex-offset-gt-sm=\"10\" \nng-click=\"vm.metodosDialog.salvar($event, vm.acompanhante)\" class=\"button-icone-cor-azul\" \nng-disabled=\"!vm.acompanhante.colaborador\" aria-label=\"Acompanhantes do Atendimento\"><md-icon \nmd-font-icon=\"icon-account-plus s36\"></md-icon><md-tooltip><span \ntranslate=\"ATENDIMENTO.VINCULA_COLABORADOR_ATENDIMENTO_ACOMPANHAMENTO\"></span></md-tooltip></md-button></div><table \nclass=\"dataTable row-border hover border\" datatable=\"ng\" dt-options=\"vm.dtOptions\" width=\"100%\"><thead><tr><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Ação</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Colaborador</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Visualizado</span></div></th></tr></thead>\n<tbody><tr ng-repeat=\"acompanhanteAtendimento  in vm.acompanhantesAtendimento | orderBy: \'codigoUsuario\'\"><td><i \nclass=\"icon-delete s16 icone-cor-padrao\" ng-click=\"vm.metodosDialog.excluir($event, acompanhanteAtendimento)\"></i></td>\n<td>{{acompanhanteAtendimento.usuario.login}}</td><td>{{acompanhanteAtendimento.visualizado}}</td></tr></tbody></table>\n</md-dialog-content></form></md-dialog>");
$templateCache.put("app/main/atendimento/processamento/atendimento/views/dialogs/anexos-arquivos-dialog/atendimento-dialog-anexo-arquivos.html","<md-dialog id=\"atendimento-dialog-anexo-arquivos\" class=\"dialogo-padrao\" aria-label=\"Dialog\"><form name=\"vm.form\" \nclass=\"md-inline-form\" novalidate><md-toolbar class=\"md-accent md-tall\" layout=\"column\"><div \nclass=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\">\n{{vm.titulo}}</span><md-button class=\"md-icon-button\" ng-click=\"vm.metodosDialog.fecharDialog()\" \naria-label=\"Fechar dialog\" translate translate-attr-aria-label=\"SPRINT.FECHAR_DIALOG\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content><div layout=\"row\" class=\"mb-20\" \nng-if=\"vm.habilitarComponente\" layout-align=\"center center\" flex><lf-ng-md-file-input flex=\"60\" name=\"selecaoArquivo\" \nng-disabled=\"vm.requisicaoSolicitada\" lf-files=\"vm.arquivosSelecionados\" aria-label=\"Selecionar Arquivos\" \nlf-totalsize=\"50MB\" lf-placeholder=\"Selecionar Arquivos (Limite Total de 50MB)\" lf-browse-label=\"Selecionar\" \nlf-remove-label=\"Excluir\" lf-caption=\"{{vm.mensagemCaption}} ({{vm.tamanhosArquivosSelecionados}})\" progress \nmultiple=\"multiple\"></lf-ng-md-file-input><md-button \nng-click=\"vm.metodosDialog.salvarArquivos(vm.arquivosSelecionados, $event)\" class=\"md-raised cor-button\" \nstyle=\"margin: 1px\" \nng-hide=\"vm.arquivosSelecionados.length == 0 || vm.form.$invalid \r\n                           || (vm.tamanhoArquivosSelecionadosEmBite > vm.tamanhoMaximoArquivosSelecionados) || vm.desabilitarButtonSalvar\" \naria-label=\"Salvar\"><md-icon class=\"atendimento-cor-icone-braco\" md-font-icon=\"icon-cloud-upload s24\"></md-icon><span \nclass=\"font-size-14\" translate=\"ATENDIMENTO.SALVAR\"></span></md-button></div><div layout=\"row\" \nlayout-align=\"center center\" ng-if=\"vm.form.$invalid\" \nng-messages=\"vm.form.selecaoArquivo.$error || (vm.tamanhoArquivosSelecionadosEmBite > vm.tamanhoMaximoArquivosSelecionados) \r\n                 || vm.desabilitarButtonSalvar\" \nstyle=\"color:red\"><div ng-message=\"totalsize\"><span translate=\"ATENDIMENTO.LIMITE_MAXIMO_ARQUIVO\"></span></div></div>\n<div layout=\"column\" layout-align=\"center center\" ng-show=\"vm.requisicaoSolicitada && !vm.baixandoArquivos\"><span \nclass=\"font-weight-500\">{{vm.mensagemPreloader}}</span><md-progress-circular md-mode=\"indeterminate\" md-diameter=\"30\" \nclass=\"md-accent\"></md-progress-circular></div><div layout=\"row\" flex><div layout=\"row\" layout-align=\"start center\" \nflex><md-button ng-click=\"vm.metodosDialog.listarTodosArquivos()\" class=\"send-button md-raised button-icone-cor-azul\" \naria-label=\"Atualizar Lista de Arquivos\"><md-icon class=\"cor-icone-azul\" md-font-icon=\"icon-refresh s24\"></md-icon>\n<span class=\"font-size-12 text-center\" translate=\"ATENDIMENTO.ATUALIZAR_LISTA_ARQUIVOS\"></span></md-button></div><div \nclass=\"mb-10\" layout=\"row\" layout-align=\"end center\" flex><i><md-icon class=\"cor-icone-padrao\" \nmd-font-icon=\"icon-magnify\"></md-icon></i><input class=\"pesquisar-input\" ng-disabled=\"vm.requisicaoSolicitada\" \ntype=\"text\" placeholder=\"Pesquisar\" ng-model=\"vm.pesquisarAnexos\"></div></div><table \nclass=\"dataTable row-border hover compact list-view\" datatable=\"ng\" dt-options=\"vm.dtOptionsAnexos\" whidth=\"100%\">\n<thead><tr><th class=\"secondary-text borda-cima borda-esquerda borda-baixo\"><div class=\"table-header\"><span \nclass=\"column-title text-center\">Ação</span></div></th><th class=\"secondary-text borda-cima\"><div class=\"table-header\">\n<span class=\"column-title text-center\">Nome</span></div></th><th class=\"secondary-text borda-cima\"><div \nclass=\"table-header\"><span class=\"column-title text-center\">Extensão</span></div></th><th \nclass=\"secondary-text borda-cima\"><div class=\"table-header\"><span class=\"column-title text-center\">Tamanho</span></div>\n</th><th class=\"secondary-text borda-cima borda-baixo borda-direita\"><div class=\"table-header\"><span \nclass=\"column-title text-center\">Data</span></div></th></tr></thead><tbody><tr \nng-repeat=\"arquivo in vm.arquivos | filter: vm.metodosDialog.pesquisarTabelaAnexos\"><td \nclass=\"borda-esquerda text-center\"><div layout=\"row\" flex layout-align=\"center center\" \nng-if=\"vm.indexArquivoASerBaixado == $index\"><md-progress-circular md-mode=\"indeterminate\" md-diameter=\"20\" \nclass=\"md-accent\"></md-progress-circular></div><i class=\"icon-cloud-download s20 icone-cor-padrao\" \nng-if=\"vm.indexArquivoASerBaixado != $index\" \nng-click=\"vm.baixandoArquivos || vm.requisicaoSolicitada || vm.metodosDialog.baixarArquivo($event, arquivo, $index)\" \nng-disabled=\"vm.baixandoArquivos || vm.requisicaoSolicitada\"></i><i class=\"icon-delete s20 icone-cor-padrao\" \nng-if=\"vm.indexArquivoASerBaixado != $index\" \nng-click=\"vm.baixandoArquivos || vm.requisicaoSolicitada || vm.metodosDialog.excluirArquivo($event, arquivo, $index)\" \nng-disabled=\"vm.baixandoArquivos || vm.requisicaoSolicitada\"></i></td><td class=\"text-center\" \nstyle=\"width: 300px !important\">{{arquivo.nome.substr(0, 30)}} <span ng-if=\"arquivo.nome.length > 30\">...</span>\n<md-tooltip ng-if=\"arquivo.nome.length > 30\">{{arquivo.nome}}</md-tooltip></td><td class=\"tipo text-center\">\n{{arquivo.extensao}}</td><td class=\"text-center\">{{arquivo.tamanho}}</td><td class=\"text-center\"><span \nstyle=\"display: none\">{{arquivo.dataCriacao}}</span> <span>{{arquivo.dataCriacao | date:\'dd/MM/yyyy - HH:mm\'}}</span>\n</td></tr></tbody></table></md-dialog-content></form></md-dialog>");
$templateCache.put("app/main/atendimento/processamento/atendimento/views/dialogs/contratos/contrato-clientes.html","<md-dialog id=\"cliente-dialog-pessoa-de-referencia\" class=\"dialogo-padrao\" aria-label=\"Dialog\"><md-button \nclass=\"md-icon-button button-flutuante\" ng-click=\"vm.metodosGeral.fecharDialog()\" aria-label=\"Fechar dialog\"><md-icon \nmd-font-icon=\"icon-close\" class=\"cor-icone-button-flutuante s26\"></md-icon><md-tooltip>Fechar Dialog</md-tooltip>\n</md-button><div class=\"scrollable\" ms-scroll ui-view=\"contratos@app.atendimento_processamento_atendimento\"></div>\n</md-dialog>");
$templateCache.put("app/main/atendimento/processamento/atendimento/views/dialogs/historico-dialog/atendimento-dialog-historico.html","<md-dialog id=\"atendimento-dialog-historico\" class=\"dialogo-padrao\" aria-label=\"Dialog\"><form \nname=\"vm.form.inserirHistoricoDialog\" class=\"md-inline-form\" novalidate><md-toolbar class=\"md-accent md-tall\" \nlayout=\"column\"><div class=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" layout-align=\"space-between center\">\n<span class=\"title\">{{vm.titulo}}</span><md-button class=\"md-icon-button\" \nng-click=\"vm.metodosDialog.fecharDialog(vm.historicoAtendimento)\" aria-label=\"Fechar dialog\" translate \ntranslate-attr-aria-label=\"SPRINT.FECHAR_DIALOG\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div>\n</md-toolbar><div layout=\"row\" layout-sm=\"row\" layout-align=\"center\" ng-show=\"vm.requisicaoSolicitada\">\n<md-progress-circular md-mode=\"indeterminate\" class=\"md-accent\"></md-progress-circular></div><md-dialog-content \nng-hide=\"vm.requisicaoSolicitada\"><div layout-gt-xs=\"row\" flex class=\"container-formulario\"><md-input-container \nclass=\"md-block\" flex-gt-sm=\"10\"><label translate=\"ATENDIMENTO.CODIGO\">Número</label><input type=\"text\" \nng-model=\"vm.historicoAtendimento.codigoAtendimento\" name=\"codigo\" mascara-numero-generica=\"######\" \nconverte-mascara-para-numero ng-disabled=\"true\"></md-input-container><md-input-container class=\"md-block\" \nflex-gt-sm=\"10\"><label translate=\"ATENDIMENTO.ANO\">Ano</label><input class=\"field-search\" type=\"text\" name=\"ano\" \nng-model=\"vm.historicoAtendimento.anoAtendimento\" mascara-numero-generica=\"####\" converte-mascara-para-numero \nng-disabled=\"true\"></md-input-container><md-input-container class=\"md-block\" flex-gt-sm=\"10\"><label \ntranslate=\"ATENDIMENTO.SEQUENCIA\">Sequência</label><input class=\"field-search\" type=\"text\" name=\"ano\" \nng-model=\"vm.historicoAtendimento.sequencia\" mascara-numero-generica=\"####\" converte-mascara-para-numero \nng-disabled=\"true\"></md-input-container><md-input-container><label translate=\"ATENDIMENTO.DATA\"></label><md-datepicker \nng-model=\"vm.historicoAtendimento.data\" name=\"data\" md-max-date=\"vm.dataAtual\" mascara-conversor-string-para-data \nng-required=\"true\" ng-mask=\"3?9/1?9/9999\" ng-disabled=\"vm.ehUltimoHistorico == false\"></md-datepicker><div \nng-messages=\"vm.form.inserirHistoricoDialog.data.$error\"><div ng-message=\"valid\" \ntranslate=\"MENSAGEM_VALIDACAO.DATA_INVALIDA\"></div><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.DATA_OBRIGATORIA\"></div></div></md-input-container><md-input-container class=\"md-block\" \nflex-gt-sm=\"15\"><label translate=\"ATENDIMENTO.HORAS\"></label><input type=\"text\" \nng-model=\"vm.horasHistoricoAtendimento\" name=\"horas\" placeholder=\"\" translate \ntranslate-attr-placeholder=\"ATENDIMENTO.EXEMPLO_HORAS\" mascara-numero-generica=\"##:##:##\" ng-minlength=\"8\" \nng-required=\"true\" ng-disabled=\"vm.ehUltimoHistorico == false\"><div \nng-messages=\"vm.form.inserirHistoricoDialog.horas.$error\"><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div><div ng-message=\"minlength\" \ntranslate=\"MENSAGEM_VALIDACAO.PATTERN_PARA_HORAS_SEGUNDOS\"></div></div></md-input-container><md-input-container \nclass=\"md-block\" flex-gt-sm=\"15\" ng-if=\"vm.controladorTempoTecnico\"><label translate=\"ATENDIMENTO.TEMPO_TECNICO_GASTO\">\n</label><input type=\"text\" ng-model=\"vm.historicoAtendimento.tempoTecnicoGasto\" name=\"tempoTecnicoGasto\" \nmascara-numero-generica=\"##:##:##\" \npattern=\"^(([2]{1}[0-3]{1}){1}|([0-1]{1}[0-9]){1}){1}:[0-5]{1}[0-9]{1}:[0-5]{1}[0-9]{1}$\" \nng-disabled=\"vm.ehUltimoHistorico == false\"><div ng-messages=\"vm.form.inserirHistoricoDialog.tempoTecnicoGasto.$error\">\n<div ng-message=\"pattern\" translate=\"ATENDIMENTO.TEMPO_INVALIDO\"></div></div></md-input-container></div><div \nlayout-gt-xs=\"row\" flex class=\"container-formulario\"><md-input-container flex-gt-sm=\"10\"><label hide-gt-sm \ntranslate=\"ATENDIMENTO.PESQUISAR_COLABORADOR_POR_CODIGO\"></label><input text=\"text\" \nng-model=\"vm.colaboradorAPesquisar\" aria-label=\"Diretiva Pesquisar por Codigo\" pesquisar-por-codigo \nlista-a-pesquisar=\"vm.colaboradores\" entidade-pesquisada=\"vm.historicoAtendimento.codigoUsuario\" mascara-numeros=\"5\" \nng-disabled=\"vm.ehUltimoHistorico == false\"><div ng-messages=\"vm.form.inserirHistoricoDialog.data.$error\"><div \nng-message=\"required\" translate=\"MENSAGEM_VALIDACAO.DATA_OBRIGATORIA\"></div></div></md-input-container>\n<md-input-container class=\"md-block\" flex-gt-sm=\"30\"><label translate=\"ATENDIMENTO.COLABORADOR\">Colaborador</label>\n<md-select ng-model=\"vm.historicoAtendimento.codigoUsuario\" name=\"colaboradorCodigo\" ng-required=\"true\" \nmd-on-open=\"vm.metodosDialog.configuraMdSelectColaboradores()\" ng-disabled=\"vm.ehUltimoHistorico == false\">\n<md-select-header><input id=\"dialog-historico-atendimento-colaborador-md-select\" class=\"md-text\" \nng-model=\"vm.filtrarColaborador\" type=\"search\" placeholder=\"\" translate \ntranslate-attr-placeholder=\"ATENDIMENTO.PESQUISAR_COLABORADOR\"></md-select-header><md-option \nng-value=\"colaborador.codigo\" \nng-repeat=\"colaborador in vm.colaboradores | filter:vm.filtrarColaborador track by colaborador.codigo\">\n{{colaborador.nome}}</md-option></md-select></md-input-container><md-input-container class=\"md-block\" flex><label \ntranslate=\"ATENDIMENTO.CONTATO\">Contato</label><input type=\"search\" ng-model=\"vm.historicoAtendimento.contato\" \nname=\"contato\" ng-keydown=\"vm.metodosDialog.pesquisarPessoaDeReferencia()\" mascara-tamanho-campo=\"100\" \nmd-maxlength=\"100\" ng-required=\"true\" ng-disabled=\"vm.ehUltimoHistorico == false\"><div \nng-messages=\"vm.form.inserirHistoricoDialog.contato.$error\"><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container><md-button \nclass=\"md-icon-button margin-top-15 button-icone-cor-azul\" \nng-class=\"{\'button-icone-cor-azul-selecionado\': vm.buttonSelecionadoPesquisarPessoasReferencia}\" \nng-click=\"vm.metodosDialog.controlarMdSelectPessoaReferencia()\" aria-label=\"Buscar Pesquisa\" \nng-disabled=\"vm.ehUltimoHistorico == false\"><md-icon md-font-icon=\"icon-magnify s15\"></md-icon></md-button></div><div \nlayout-gt-xs=\"row\" ng-if=\"vm.buttonSelecionadoPesquisarPessoasReferencia\" flex layout-align=\"center center\">\n<md-input-container class=\"md-block\" flex-gt-sm=\"50\"><label translate=\"ATENDIMENTO.PESSOA_REFERENCIA\">\nPessoa de Referência</label><md-select ng-model=\"vm.historicoAtendimento.contato\" name=\"pessoaReferencia\" \nmd-on-open=\"vm.metodosDialog.configuraMdSelectPessoaReferencia()\" \nmd-on-close=\"vm.metodosDialog.controlarMdSelectPessoaReferencia()\" ng-disabled=\"vm.ehUltimoHistorico == false\">\n<md-select-header><input id=\"dialog-historico-atendimento-pessoa-referencia-md-select\" class=\"md-text\" \nng-model=\"vm.filtrarPessoaReferencia\" type=\"search\" placeholder=\"\" translate \ntranslate-attr-placeholder=\"ATENDIMENTO.PESQUISAR_PESSOA_REFERENCIA\"></md-select-header><md-option \nng-value=\"pessoaReferencia.nome\" \nng-repeat=\"pessoaReferencia in vm.pessoasReferencia | filter:vm.filtrarPessoaReferencia track by pessoaReferencia.codigo\">\n{{pessoaReferencia.nome}}</md-option></md-select></md-input-container></div><div layout-gt-xs=\"row\"><label \nclass=\"color-mdinput-label-padrao tamanho-mdinput-label-padrao\" translate=\"ATENDIMENTO.DESCRICAO\"></label></div><div \nlayout-gt-xs=\"row\" flex><text-angular ta-disabled=\"vm.ehUltimoHistorico == false\" flex required \nta-toolbar=\"[[\'h1\', \'h2\', \'h3\', \'quote\', \'bold\', \'italics\', \'underline\', \'strikeThrough\', \'ul\', \'ol\', \'redo\', \'undo\', \'justifyLeft\', \'justifyCenter\', \'justifyRight\', \'indent\', \'outdent\']]\" \nng-model=\"vm.historicoAtendimento.descricao\"></text-angular></div></md-dialog-content><md-dialog-actions layout=\"row\" \nlayout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><md-button type=\"submit\" \nng-click=\"vm.metodosDialog.salvar($event, vm.historicoAtendimento, vm.horasHistoricoAtendimento)\" \nclass=\"send-button md-accent md-raised\" \nng-disabled=\"vm.form.inserirHistoricoDialog.$invalid ||\r\n                                        vm.form.inserirHistoricoDialog.$pristine ||\r\n                                        vm.requisicaoSolicitada ||\r\n                                        vm.ehUltimoHistorico == false\" \naria-label=\"SALVAR\" translate=\"ATENDIMENTO.SALVAR\" translate-attr-aria-label=\"ATENDIMENTO.SALVAR\">Salvar</md-button>\n</div><div layout=\"row\"><md-button class=\"md-icon-button\" \nng-click=\"vm.metodosDialog.excluir($event, vm.historicoAtendimento)\" ng-disabled=\"vm.requisicaoSolicitada\" \naria-label=\"Excluir\" translate-attr-aria-label=\"ATENDIMENTO.EXCLUIR\"><md-icon md-font-icon=\"icon-delete\"></md-icon>\n</md-button></div></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/atendimento/processamento/atendimento/views/dialogs/selecionar-os-dialog/atendimento-dialog-selecionar-os.html","<md-dialog id=\"atendimento-dialog-selecionar-os\" class=\"dialogo-padrao\" aria-label=\"Dialog\"><form name=\"vm.form\" \nclass=\"md-inline-form\" novalidate><md-toolbar class=\"md-accent md-tall\" layout=\"column\"><div \nclass=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\">\nOrdens de serviço vinculadas ao atendimento</span><md-button class=\"md-icon-button\" \nng-click=\"vm.metodosDialog.fecharDialog()\" aria-label=\"Fechar dialog\" translate \ntranslate-attr-aria-label=\"Fechar dialog\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar>\n<md-dialog-content><table class=\"dataTable row-border hover border\" datatable=\"ng\" \ndt-options=\"vm.dtOptionsOrdensDeServico\" width=\"100%\"><thead><tr><th class=\"secondary-text\"><div class=\"table-header\">\n<span class=\"column-title\">Número OS</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Ano OS</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Ação</span></div></th></tr></thead><tbody><tr ng-repeat=\"os in vm.ordensDeServicos\"><td>\n{{os.codigo}}</td><td>{{os.ano}}</td><td><i class=\"icon-arrow-right-bold-hexagon-outline s30 icone-cor-padrao\" \nng-click=\"vm.metodosDialog.abrirOS(os)\"><md-tooltip md-autohide><span translate=\"Ir para ordem de serviço\"></span>\n</md-tooltip></i></td></tr></tbody></table></md-dialog-content></form></md-dialog>");
$templateCache.put("app/main/atendimento/processamento/atendimento/views/dialogs/dialog-visualizacao-historico-atendimento/dialog-visualizacao-historico-atendimento.html","<md-dialog id=\"atendimento-dialog-visualizacao-historico\" class=\"dialogo-padrao dialogo-padrao-toolbar-grande\" \naria-label=\"Dialog\"><form name=\"vm.form.visualizacaoHistoricoAtendimento\" class=\"md-inline-form\" novalidate><md-toolbar\n class=\"md-accent md-tall\" layout=\"column\"><div layout=\"column\" layout-align=\"center center\" \nstyle=\"width: 100%; margin-top: 2px\"><span class=\"title\" style=\"font-size: 1em; text-align: center\">\nHistórico de atendimento</span><div layout=\"row\" layout-align=\"center center\"><md-button class=\"md-icon-button\" \nng-click=\"vm.metodosDialog.primeiro()\" ng-disabled=\"vm.indexHistoricoAtendimento == 0\"><md-icon \nmd-font-icon=\"icon-chevron-double-left s24\"></md-icon></md-button><md-button class=\"md-icon-button\" \nng-click=\"vm.metodosDialog.anterior()\" ng-disabled=\"vm.indexHistoricoAtendimento == 0\"><md-icon \nmd-font-icon=\"icon-chevron-left s24\"></md-icon></md-button><span style=\"margin: 0 12px; font-size: 1em\">\n{{vm.indexHistoricoAtendimento+1}} de {{vm.historicoAtendimentos.length}}</span><md-button class=\"md-icon-button\" \nng-click=\"vm.metodosDialog.proximo()\" ng-disabled=\"vm.indexHistoricoAtendimento == vm.historicoAtendimentos.length-1\">\n<md-icon md-font-icon=\"icon-chevron-right s24\"></md-icon></md-button><md-button class=\"md-icon-button\" \nng-click=\"vm.metodosDialog.ultimo()\" ng-disabled=\"vm.indexHistoricoAtendimento == vm.historicoAtendimentos.length-1\">\n<md-icon md-font-icon=\"icon-chevron-double-right s24\"></md-icon></md-button></div></div><md-button \nclass=\"md-icon-button\" ng-click=\"vm.metodosDialog.fecharDialog()\" style=\"position: absolute; right: 0px; top: 15px\">\n<md-icon md-font-icon=\"icon-close\"></md-icon></md-button></md-toolbar><md-dialog-content layout=\"column\" flex \nstyle=\"flex: 1 1 100%; height: 100%; min-height: 0; max-height: 100%\"><div layout=\"column\" layout-padding \nstyle=\"flex: 1 1 100%; min-height: 0; max-height: 100%; display: flex; flex-direction: column; height: 100%\"><div \nlayout=\"column\" style=\"width: 100%; margin-top: -10px\"><div layout=\"row\" layout-align=\"start center\" \nstyle=\"width: 100%\"><div layout=\"row\" layout-align=\"start center\" style=\"margin-right: 32px\"><span \nclass=\"md-subheader cor-escrita-desabilitado\">Data: </span><span class=\"md-subheader cor-escrita-desabilitado ml-5\">\n{{vm.historicoSelecionado.data | date:\'dd/MM/yyyy HH:mm\'}}</span></div><div layout=\"row\" layout-align=\"start center\">\n<span class=\"md-subheader cor-escrita-desabilitado\">Colaborador: </span><span \nclass=\"md-subheader cor-escrita-desabilitado ml-5\">{{vm.historicoSelecionado.usuario.login}}</span></div></div><div \nlayout=\"row\" layout-align=\"start start\" style=\"width: 100%; margin-top: 8px\"><span \nclass=\"md-subheader cor-escrita-desabilitado\" style=\"white-space: nowrap\">Contato: </span><span \nclass=\"md-subheader cor-escrita-desabilitado ml-5\" style=\"word-break: break-word; white-space: normal\">\n{{vm.historicoSelecionado.contato}}</span></div></div><div class=\"container-descricao-historico\" \nstyle=\"flex: 1 1 100%; min-height: 0; max-height: 100%; height: 100%\"><div \nng-bind-html=\"vm.historicoSelecionado.descricao\"></div></div></div></md-dialog-content></form></md-dialog>");
$templateCache.put("app/main/atendimento/processamento/atendimento/views/dialogs/usuarios-ha-visualizar-atendimento/atendimento-dialog-usuarios-ha-visualizar-atendimento.html","<md-dialog id=\"atendimento-dialog-usuarios-ha-visualizar-atendimento\" class=\"dialogo-padrao\" aria-label=\"Dialog\"><form \nname=\"vm.form.acompanhanteDialog\" class=\"md-inline-form\" novalidate><md-toolbar class=\"md-accent md-tall\" \nlayout=\"column\"><div class=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" layout-align=\"space-between center\">\n<span class=\"title\">Lista de colaboradores que podem visualizar este atendimento</span><md-button \nclass=\"md-icon-button\" ng-click=\"vm.metodosDialog.fecharDialog()\" aria-label=\"Fechar dialog\" translate \ntranslate-attr-aria-label=\"SPRINT.FECHAR_DIALOG\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div>\n</md-toolbar><div layout=\"row\" layout-sm=\"row\" layout-align=\"center\" ng-show=\"vm.requisicaoSolicitada\">\n<md-progress-circular md-mode=\"indeterminate\" class=\"md-accent\"></md-progress-circular></div><md-dialog-content \nng-hide=\"vm.requisicaoSolicitada\" layout=\"column\"><div ng-if=\"vm.squadUsuarioLogado.length > 1\" \nclass=\"container-checkbox\"><md-input-container class=\"md-block\" flex-gt-sm=\"50\"><label>Squads</label><md-select \nng-model=\"vm.codigoSquads\" name=\"codigoSquads\" ng-change=\"vm.metodosDialog.changeSquadsSelecionadas(vm.codigoSquads)\" \nmultiple=\"multiple\"><md-option ng-value=\"squad.codigo\" ng-repeat=\"squad in vm.squads track by squad.codigo\">\n{{squad.descricao}}</md-option></md-select></md-input-container><md-checkbox \nng-click=\"vm.metodosDialog.marcarDesmarcarTodasSquads()\" class=\"check-todas-squads\" ng-model=\"vm.todasSquads\" \naria-label=\"Todas squads\" name=\"todasSquads\"><span class=\"float-label-cor-default\">Todas squads</span></md-checkbox>\n</div><div layout-gt-xs=\"row\" layout-align=\"start center\" flex><md-input-container class=\"md-block\" flex-gt-sm=\"50\">\n<label translate=\"ATENDIMENTO.COLABORADOR\">Colaborador</label><md-select ng-model=\"vm.colaborador\" \nname=\"colaboradorCodigo\" md-on-open=\"vm.metodosDialog.configuraMdSelectColaboradores()\"><md-select-header><input \nid=\"dialog-colaboradores-ha-visualizar-atendimento-md-select\" class=\"md-text\" ng-model=\"vm.filtrarColaborador\" \ntype=\"search\" placeholder=\"\" translate translate-attr-placeholder=\"ATENDIMENTO.PESQUISAR_COLABORADOR\">\n</md-select-header><md-option ng-value=\"colaborador\" \nng-repeat=\"colaborador in vm.colaboradoresFiltrados | filter:vm.filtrarColaborador track by colaborador.codigo\">\n{{colaborador.nome}}</md-option></md-select></md-input-container><div layout-gt-xs=\"column\" flex-offset-gt-sm=\"10\">\n<md-checkbox ng-model=\"vm.todosUsuarios\" \nng-change=\"vm.metodosDialog.alterarEstadoCampoTodosUsuarios(vm.todosUsuarios)\" \nng-disabled=\"vm.colaboradoresFiltrados.length === 0\" aria-label=\"Todos Colaboradores\" name=\"todosColaboradores\"><span \nclass=\"float-label-cor-default\" translate=\"ATENDIMENTO.TODOS_COLABORADORES\">Todos Colaboradores</span></md-checkbox>\n<md-checkbox ng-model=\"vm.sigiloComercial\" aria-label=\"Sigilo Comercial\" \nng-show=\"vm.usuarioLogado.tipoAtendimento == 2\" \nng-change=\"vm.metodosDialog.alterarEstadoCampoSigiloComercial(vm.sigiloComercial)\" name=\"sigiloComercial\"><span \nclass=\"float-label-cor-default\" translate=\"ATENDIMENTO.SIGILO_COMERCIAL\">Sigilo Comercial</span></md-checkbox></div>\n<md-button type=\"submit\" flex-offset-gt-sm=\"10\" ng-click=\"vm.metodosDialog.incluirNaLista($event, vm.colaborador)\" \nclass=\"button-icone-cor-azul\" ng-disabled=\"!vm.colaborador\" aria-label=\"Acompanhantes do Atendimento\"><md-icon \nmd-font-icon=\"icon-account-plus s36\"></md-icon><md-tooltip><span \ntranslate=\"ATENDIMENTO.VINCULA_COLABORADOR_ATENDIMENTO_ACOMPANHAMENTO\"></span></md-tooltip></md-button></div><table \nclass=\"dataTable row-border hover border\" datatable=\"ng\" ng-hide=\"vm.usuariosHaVisualizarAtendimento.length == 0\" \ndt-options=\"vm.dtOptionsColaboradoresHaVisualizarAtendimento\" width=\"100%\"><thead><tr><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Ação</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Colaborador</span></div></th><th class=\"secondary-text\" \nng-if=\"vm.squadUsuarioLogado.length > 1\"><div class=\"table-header\"><span class=\"column-title\">Squad</span></div></th>\n</tr></thead><tbody><tr ng-repeat=\"usuarioHaVisualizar in vm.usuariosHaVisualizarAtendimento\"><td><i \nclass=\"icon-delete s16 icone-cor-padrao\" ng-click=\"vm.metodosDialog.excluir($event, usuarioHaVisualizar)\"></i></td><td>\n{{usuarioHaVisualizar.login}}</td><td ng-if=\"vm.squadUsuarioLogado.length > 1\"><span \nng-repeat=\"codigoSquad in usuarioHaVisualizar.codigoSquads | orderBy: []\"><span ng-if=\"codigoSquad == 1\">Alpha</span> \n<span ng-if=\"codigoSquad == 2\">Elite</span> <span ng-if=\"codigoSquad == 3\">Partners</span> <span ng-if=\"!$last\">-\n</span></span></td></tr></tbody></table></md-dialog-content><md-dialog-actions layout=\"row\" \nlayout-align=\"space-between center\" ng-if=\"!vm.controleForm.inserirAtivo\"><div layout=\"row\" \nlayout-align=\"start center\"></div><div layout=\"row\"><md-button type=\"submit\" \nng-click=\"vm.metodosDialog.salvar($event, vm.usuariosHaVisualizarAtendimento)\" class=\"send-button md-accent md-raised\" \nng-disabled=\"vm.usuariosHaVisualizarAtendimento.length === 0\" aria-label=\"SALVAR\" translate=\"ATENDIMENTO.SALVAR\" \ntranslate-attr-aria-label=\"ATENDIMENTO.SALVAR\">Salvar</md-button></div></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/atendimento/estatisticas/tags/components/dialogs/dialog-detalhes-atendimento/dialog-detalhes-atendimento.html","<md-dialog id=\"dialog-detalhes-atendimentos\" class=\"dialogo-padrao dialog-detalhes-atendimentos\" aria-label=\"Dialog\">\n<form class=\"md-inline-form\" novalidate><md-toolbar class=\"md-accent md-tall\" layout=\"column\"><div \nclass=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" layout-align=\"space-between center\"><div \nstyle=\"display: flex; gap: 5px; flex-direction: row\"><span>\n{{vm.detalhesAtendimento.numero}}/{{vm.detalhesAtendimento.ano}}</span><md-icon style=\"margin-bottom: 5px\" \nng-click=\"vm.metodosDialog.visualizarAtendimento(vm.detalhesAtendimento.numero, vm.detalhesAtendimento.ano)\" \nmd-font-icon=\"icon-open-in-new\"></md-icon></div><md-button class=\"md-icon-button\" \nng-click=\"vm.metodosDialog.fecharDialog()\" aria-label=\"Fechar dialog\" translate \ntranslate-attr-aria-label=\"SPRINT.FECHAR_DIALOG\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content><div layout=\"column\" class=\"campos-detalhes\" style=\"margin-top:  -10px\">\n<md-input-container class=\"campo-cliente\" flex><label>Cliente</label><input type=\"text\" name=\"cliente\" \nng-model=\"vm.detalhesAtendimento.cliente\" ng-disabled=\"true\"></md-input-container><div layout=\"row\" flex \nclass=\"campos-responsavel-dias\"><md-input-container flex-gt-xs=\"60\"><label>Colaborador responsável</label><input \ntype=\"text\" name=\"colaboradorResponsavel\" ng-model=\"vm.detalhesAtendimento.usuario\" ng-disabled=\"true\">\n</md-input-container><md-input-container flex-gt-xs=\"40\"><label>Dias sem contato</label><input type=\"text\" \nname=\"diasSemContato\" ng-model=\"vm.detalhesAtendimento.quantidadeDiasSemContato\" ng-disabled=\"true\">\n</md-input-container></div><div layout=\"column\" class=\"container-tags\"><span class=\"titulo-tags\">Tags</span><div \nclass=\"chip-list\"><div class=\"chip\" ng-repeat=\"tag in vm.detalhesAtendimento.tags track by tag.codigo\" \nng-style=\"{\'background-color\': vm.metodosDialog.retornaCodigoItemSelecionado(tag.codigo).corBackground, \r\n               \'color\': vm.metodosDialog.retornaCodigoItemSelecionado(tag.codigo).corTexto}\">\n<span>{{ vm.metodosDialog.retornaCodigoItemSelecionado(tag.codigo).descricao }}</span></div></div></div></div>\n</md-dialog-content></form></md-dialog>");
$templateCache.put("app/main/atendimento/estatisticas/tags/components/dialogs/dialog-outras-tags/dialog-outras-tags.html","<md-dialog id=\"estatisticas-tags-dialog-outras-tags\" class=\"dialogo-padrao\" aria-label=\"Dialog\"><form \nclass=\"md-inline-form\" novalidate><md-toolbar class=\"md-accent md-tall\" layout=\"column\"><div \nclass=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\">\nOutras tags</span><div class=\"container-pesquisa-botaofechar\" layout=\"row\" layout-align=\"end center\"><div \nclass=\"input-pesquisa\" layout=\"row\" layout-align=\"start center\"><label><md-icon md-font-icon=\"icon-magnify\" \nclass=\"white-text icon search-icon\"></md-icon></label><input id=\"filtrar\" type=\"search\" placeholder=\"Filtrar\" \nng-model=\"vm.pesquisar\" flex aria-label=\"Filtrar\"></div><md-button class=\"md-icon-button\" \nng-click=\"vm.metodosDialog.fecharDialog()\" aria-label=\"Fechar dialog\" translate \ntranslate-attr-aria-label=\"SPRINT.FECHAR_DIALOG\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></div>\n</md-toolbar><md-dialog-content layout=\"column\" flex><div id=\"tabela-outras-tags\" class=\"fullpage-datatable\" flex=\"90\">\n<table class=\"row-border hover tabela-outras-tags\" datatable=\"ng\" dt-options=\"vm.dtOptions\" \ndt-instance=\"vm.onDtInstance\"><thead><tr><th class=\"secondary-text border-left border-right\"><div class=\"table-header\">\n<span style=\"margin-left: -15px\" class=\"column-title\">Cliente</span></div></th><th class=\"secondary-text border-right\">\n<div class=\"table-header\"><span class=\"column-title\">Tag</span></div></th><th class=\"secondary-text border-right\"><div \nclass=\"table-header\"><span class=\"column-title\">Solução</span></div></th><th class=\"secondary-text border-right\"><div \nclass=\"table-header\"><span class=\"column-title\">Data abertura</span></div></th><th class=\"secondary-text border-right\">\n<div class=\"table-header\"><span class=\"column-title\">Data fechamento</span></div></th><th \nclass=\"secondary-text titulo-acoes\"><div class=\"table-header\"><span class=\"column-title\">Atendimento</span></div></th>\n</tr></thead><tbody><tr ng-repeat=\"outrasTags in vm.listaOutrasTags\"><td class=\"border-left border-right\"><span \nstyle=\"margin-left: -15px\">{{outrasTags.cliente}}</span></td><td class=\"border-right\"><div class=\"tag-atendimento\" \nng-style=\"{\'background-color\': outrasTags.corIdentificacao, \'color\': \'#333\'}\" layout-align=\"center center\" flex><span \nclass=\"text-center\">{{ outrasTags.tag }}</span></div></td><td class=\"border-right\">{{outrasTags.solucao}}</td><td \nclass=\"border-right\"><div style=\"display: flex; justify-content: center; align-items: center\"><span>\n{{outrasTags.dataAbertura | date:\'dd/MM/yyyy\'}}</span></div></td><td class=\"border-right\"><div \nstyle=\"display: flex; justify-content: center; align-items: center\"><span>\n{{outrasTags.dataFechamento | date:\'dd/MM/yyyy\'}}</span></div></td><td class=\"border-right\"><div \nstyle=\"display: flex; flex-direction: row; justify-content: center; align-items: center\"><span>\n{{outrasTags.numero}}/{{outrasTags.ano}}</span> <i class=\"icon-open-in-new s18 icone-cor-padrao ml-5\" \nng-click=\"vm.metodosDialog.visualizarAtendimento(outrasTags.numero, outrasTags.ano)\"><md-tooltip><label>\nVisualizar atendimento</label></md-tooltip></i></div></td></tr></tbody></table></div><div id=\"footer-outras-tags\" \nlayout=\"row\" layout-align=\"space-between center\"><span class=\"totalizador\">\nTotal de tags: {{ vm.listaOutrasTags.length }}</span></div></md-dialog-content></form></md-dialog>");
$templateCache.put("app/main/financeiro/relatorio/reajustes/views/step/caracteristicas-contrato/caracteristicas-contrato.html","<div layout=\"column\" flex><div layout-gt-sm=\"row\" flex><ms-auto-complete-tabela flex \ntexto-fild-set=\"RELATORIO_CONTRATOS.CARACTERISTICA_CONTRATO_IMPRIMIR\" input-name=\"Características\" \nrota-da-pesquisa=\"{{vm.rotaDePesquisa}}\" item-template=\"descricao\" \nmensagem-nao-encontrado=\"Não foi encontrada nenhuma característica\" \nlabel-check=\"RELATORIO_CONTRATOS.TODAS_CARACTERISTICAS\" titulo-tabela=\"Descrição\" \ntexto-icone-remover=\"RELATORIO_CONTRATOS.REMOVER_CARACTERISTICA\" texto-floating-label=\"Características de contrato\" \ntexto-icone-remover=\"Remover característica\" filtros=\"vm.filtrosreajustes.caracteristicasContrato\" \nnome-do-campo-flag-and-or=\"RELATORIO_CONTRATOS.TIPO_SELECAO\" model-campo-and-or=\"vm.filtrosreajustes.seletor\">\n</ms-auto-complete-tabela></div><div layout-gt-sm=\"row\" flex><ms-auto-complete-tabela flex \ntexto-fild-set=\"RELATORIO_CONTRATOS.CARACTERISTICA_CONTRATO_NAO_IMPRIMIR\" input-name=\"Características a não imprimir\" \nrota-da-pesquisa=\"{{vm.rotaDePesquisa}}\" item-template=\"descricao\" \nmensagem-nao-encontrado=\"Não foi encontrada nenhuma característica\" titulo-tabela=\"Descrição\" \ntexto-icone-remover=\"RELATORIO_CONTRATOS.REMOVER_CARACTERISTICA\" texto-floating-label=\"Características de contrato\" \ntexto-icone-remover=\"Remover característica\" filtros=\"vm.filtrosreajustes.caracteristicasContratoANaoImprimir\">\n</ms-auto-complete-tabela></div><div layout-gt-sm=\"row\" flex><ms-auto-complete-tabela flex \ntexto-fild-set=\"RELATORIO_CONTRATOS.CARACTERISTICA_ITEM_IMPRIMIR\" input-name=\"Características de item\" \nrota-da-pesquisa=\"{{vm.rotaDePesquisaCaracteristicasItem}}\" item-template=\"descricao\" \nmensagem-nao-encontrado=\"Não foi encontrada nenhuma característica\" \nlabel-check=\"RELATORIO_CONTRATOS.TODAS_CARACTERISTICAS\" titulo-tabela=\"Descrição\" \ntexto-icone-remover=\"RELATORIO_CONTRATOS.REMOVER_CARACTERISTICA\" texto-floating-label=\"Características de item\" \ntexto-icone-remover=\"Remover característica\" filtros=\"vm.filtrosreajustes.caracteristicasContratoItem\" \nnome-do-campo-flag-and-or=\"RELATORIO_CONTRATOS.TIPO_SELECAO\" model-campo-and-or=\"vm.filtrosreajustes.seletor\">\n</ms-auto-complete-tabela></div><div layout-gt-sm=\"row\" flex><ms-auto-complete-tabela flex \ntexto-fild-set=\"RELATORIO_CONTRATOS.CARACTERISTICA_ITEM_NAO_IMPRIMIR\" \ninput-name=\"Características de item a não imprimir\" rota-da-pesquisa=\"{{vm.rotaDePesquisaCaracteristicasItem}}\" \nitem-template=\"descricao\" mensagem-nao-encontrado=\"Não foi encontrada nenhuma característica\" \ntitulo-tabela=\"Descrição\" texto-icone-remover=\"RELATORIO_CONTRATOS.REMOVER_CARACTERISTICA\" \ntexto-floating-label=\"Características de item\" texto-icone-remover=\"Remover característica\" \nfiltros=\"vm.filtrosreajustes.caracteristicasContratoItemANaoImprimir\"></ms-auto-complete-tabela></div></div>");
$templateCache.put("app/main/financeiro/relatorio/reajustes/views/step/informacoes-gerais/informacoes-gerais.html","<div layout=\"column\" flex><div layout-gt-sm=\"row\" flex><fieldset class=\"standard\" flex><legend class=\"grp-legend\" \ntranslate=\"RELATORIO_CONTRATOS.PERIODO\"></legend><div layout-gt-xs=\"row\"><div flex-gt-xs><md-input-container \nclass=\"md-block\"><label translate=\"RELATORIO_REAJUSTE.DATA_INICIAL\"></label><md-datepicker name=\"datPicPeriodoInicial\" \nmd-max-date=\"vm.filtrosreajustes.periodoFinal\" ng-mask=\"3?9/1?9/9999\" ng-model=\"vm.filtrosreajustes.periodoInicial\" \nng-required=\"true\"></md-datepicker><div \nng-messages=\"vm.form.tab.informacoesGeraisReajuste.datPicPeriodoInicial.$error\"><div ng-message=\"valid\" \ntranslate=\"MENSAGEM_VALIDACAO.DATA_INVALIDA\"></div><div ng-message=\"required\" \ntranslate=\"RELATORIO_CONTRATOS.DATA_INICIAL_OBRIGATORIA\"></div><div ng-message=\"maxdate\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_DATA_INICIAL\"></div></div></md-input-container></div><div flex-gt-xs>\n<md-input-container class=\"md-block\"><label translate=\"RELATORIO_REAJUSTE.DATA_FINAL\"></label><md-datepicker \nname=\"datPicPeriodoFinal\" md-min-date=\"vm.filtrosreajustes.periodoInicial\" ng-mask=\"3?9/1?9/9999\" \nng-model=\"vm.filtrosreajustes.periodoFinal\" ng-required=\"true\"></md-datepicker><div \nng-messages=\"vm.form.tab.informacoesGeraisReajuste.datPicPeriodoFinal.$error\"><div ng-message=\"valid\" \ntranslate=\"MENSAGEM_VALIDACAO.DATA_INVALIDA\"></div><div ng-message=\"mindate\" \ntranslate=\"RELATORIO_REAJUSTE.CAMPO_DATA_FINAL\"></div><div ng-message=\"required\" \ntranslate=\"RELATORIO_CONTRATOS.DATA_FINAL_OBRIGATORIA\"></div></div></md-input-container></div></div></fieldset>\n<fieldset class=\"standard\" flex><legend class=\"grp-legend\" translate=\"RELATORIO_CONTRATOS.TIPO_DE_SITUACAO_ITEM\">\n</legend><div layout=\"column\" style=\"height: 70%\" layout-align=\"center center\"><md-radio-group \nng-model=\"vm.filtrosreajustes.tipoSituacaoContratual\" layout=\"row\"><md-radio-button value=\"{{key}}\" \naria-label=\"{{value}}\" ng-repeat=\"(key, value) in vm.situacoesContrato\">{{value}}</md-radio-button><md-radio-button \nvalue=\"\" aria-label=\"Todos\" translate-attr-aria-label=\"RELATORIO_CONTRATOS.TODOS\">\n{{\"RELATORIO_CONTRATOS.TODOS\" | translate}}</md-radio-button></md-radio-group></div></fieldset></div><div \nlayout-gt-sm=\"row\" flex><ms-selecinar-multi-valores texto-field-set=\"RELATORIO_CONTRATOS.MOTIVOS\" dados=\"vm.motivos\" \nname-placeholder=\"Motivos\" model-dados=\"vm.filtrosreajustes.motivos\" \nform=\"vm.form.tab.solucaoSegmentacao.selectMotivos\" \nmensagem-de-erro-do-formulario=\"RELATORIO_REAJUSTE.MOTIVO_OBRIGATORIO\" \npropriedade-para-a-exibicao-da-repeticao=\"descricao\" limitar-width=\"true\" flex></ms-selecinar-multi-valores>\n<ms-selecinar-multi-valores texto-field-set=\"RELATORIO_CONTRATOS.FILTRAR_POR_EXECUTIVOS\" dados=\"vm.executivos\" \nname-placeholder=\"Executivos\" model-dados=\"vm.filtrosreajustes.executivos\" \nform=\"vm.form.tab.solucaoSegmentacao.selectExecutivos\" \nmensagem-de-erro-do-formulario=\"RELATORIO_CONTRATOS.EXECUTIVOS_OBRIGATORIOS\" \npropriedade-para-a-exibicao-da-repeticao=\"login\" limitar-width=\"true\" flex></ms-selecinar-multi-valores></div><div \nlayout-gt-sm=\"row\" flex><ms-selecinar-multi-valores texto-field-set=\"Status contrato\" dados=\"vm.statusContrato\" \nname-placeholder=\"Status contrato\" model-dados=\"vm.filtrosreajustes.status\" \nform=\"vm.form.tab.solucaoSegmentacao.selectStatus\" \nmensagem-de-erro-do-formulario=\"RELATORIO_REAJUSTE.STATUS_OBRIGATORIO\" \npropriedade-para-a-exibicao-da-repeticao=\"descricao\" limitar-width=\"true\" flex></ms-selecinar-multi-valores>\n<ms-selecinar-multi-valores texto-field-set=\"RELATORIO_CONTRATOS.FILTRAR_POR_EMPRESAS\" dados=\"vm.empresasFaturamento\" \nname-placeholder=\"Empresas de faturamento\" model-dados=\"vm.filtrosreajustes.empresasFaturamento\" \nform=\"vm.form.tab.solucaoSegmentacao.selectEmpresasFaturamento\" \nmensagem-de-erro-do-formulario=\"RELATORIO_CONTRATOS.EMPRESAS_OBRIGATORIAS\" \npropriedade-para-a-exibicao-da-repeticao=\"nome\" limitar-width=\"true\" flex></ms-selecinar-multi-valores></div></div>");
$templateCache.put("app/main/financeiro/relatorio/reajustes/views/step/clientes/cliente-step-reajuste.html","<div><div layout-gt-sm=\"row\" flex><ms-auto-complete-tabela flex texto-fild-set=\"RELATORIO_CONTRATOS.CLIENTES\" \ninput-name=\"cliente\" rota-da-pesquisa=\"{{vm.rotaPesquisa}}\" item-template=\"nome\" \nmensagem-nao-encontrado=\"Não foi encontrado nenhum cliente\" label-check=\"RELATORIO_CONTRATOS.TODOS_CLIENTES\" \ntitulo-tabela=\"Nome\" texto-icone-remover=\"RELATORIO_CONTRATOS.REMOVER_CLIENTE\" texto-floating-label=\"Clientes\" \ntexto-icone-remover=\"Remover clientes\" filtros=\"vm.filtrosreajustes.clientes\" texto-floating-label=\"Clientes\">\n</ms-auto-complete-tabela></div></div>");
$templateCache.put("app/main/financeiro/relatorio/reajustes/views/step/produtos/produtos.html","<div layout=\"row\" layout-align=\"center start\" flex><fieldset flex=\"50\"><legend translate=\"RELATORIO_CONTRATOS.ITEM\" \nstyle=\"color: #3F51B5\">Itens</legend><multi-select-directive id=\"select-produtos\" form-name=\"produtos\" \ndata=\"vm.produtos\" model=\"vm.filtrosreajustes.produtos\" descricao-exibicao=\"descricao\" obrigatorio=\"true\" \ntexto-pesquisa-placeholder=\"Procurar itens...\" texto-placeholder=\"Itens\" flex=\"50\"></multi-select-directive></fieldset>\n</div>");
$templateCache.put("app/main/financeiro/relatorio/reajustes/views/step/tipos-licencas/tipo-licenca.html","<div layout=\"column\" flex><div layout-gt-sm=\"row\" flex><ms-auto-complete-tabela flex \ntexto-fild-set=\"RELATORIO_CONTRATOS.TIPO_LICENCA\" input-name=\"Tipos de licença\" \nrota-da-pesquisa=\"{{vm.rotaDePesquisa}}\" item-template=\"descricao\" \nmensagem-nao-encontrado=\"Não foi encontrado nenhum tipo de licença\" \nlabel-check=\"RELATORIO_CONTRATOS.TODOS_TIPOS_LICENCA\" titulo-tabela=\"Descrição\" \ntexto-icone-remover=\"RELATORIO_CONTRATOS.REMOVER_TIPO_LICENCA\" texto-floating-label=\"Tipos de licença\" \ntexto-icone-remover=\"Remover tipo de licença\" filtros=\"vm.filtrosreajustes.tiposLicenca\" \ntexto-floating-label=\"Tipos de licença\" nome-do-campo-flag-and-or=\"RELATORIO_CONTRATOS.TIPO_SELECAO\" \nmodel-campo-and-or=\"vm.filtrosreajustes.seletor\"></ms-auto-complete-tabela></div><div layout-gt-sm=\"row\" flex>\n<ms-auto-complete-tabela flex texto-fild-set=\"RELATORIO_CONTRATOS.TIPO_LICENCA_NAO_IMPRIMIR\" \ninput-name=\"Tipos de licença a não imprimir\" rota-da-pesquisa=\"{{vm.rotaDePesquisa}}\" item-template=\"descricao\" \nmensagem-nao-encontrado=\"Não foi encontrado nenhum tipo de licença\" titulo-tabela=\"Descrição\" \ntexto-icone-remover=\"RELATORIO_CONTRATOS.LIMPAR_TIPOS_LICNCA_A_NAO_IMPRIMIR\" texto-floating-label=\"Tipos de licença\" \ntexto-icone-remover=\"Remover tipos de licença\" filtros=\"vm.filtrosreajustes.tiposLicencaANaoImprimir\" \ntexto-floating-label=\"Tipos de licença a não imprimir\" \nhabilita-check-limpar=\"vm.filtrosreajustes.tiposLicencaANaoImprimir.length\" \nlabel-check-limpar=\"RELATORIO_CONTRATOS.REMOVER_TIPO_LICENCA\"></ms-auto-complete-tabela></div></div>");
$templateCache.put("app/main/financeiro/relatorio/contratos/views/step/caracteristica/caracteristica-step.html","<div layout=\"column\" flex><div layout-gt-sm=\"row\" flex><ms-auto-complete-tabela flex \ntexto-fild-set=\"RELATORIO_CONTRATOS.CARACTERISTICA_CLIENTE\" input-name=\"Características\" \nrota-da-pesquisa=\"{{vm.rotaDePesquisa}}\" item-template=\"descricao\" \nmensagem-nao-encontrado=\"Não foi encontrado nenhuma característica\" \nlabel-check=\"RELATORIO_CONTRATOS.TODAS_CARACTERISTICAS\" titulo-tabela=\"Descrição\" \ntexto-icone-remover=\"RELATORIO_CONTRATOS.REMOVER_CARACTERISTICA\" texto-floating-label=\"Características de cliente\" \ntexto-icone-remover=\"Remover característica\" filtros=\"vm.filtrosContratos.caracteristicas\" \ntexto-floating-label=\"Características\" nome-do-campo-flag-and-or=\"RELATORIO_CONTRATOS.TIPO_SELECAO\" \nmodel-campo-and-or=\"vm.filtrosContratos.seletor\"></ms-auto-complete-tabela></div><div layout-gt-sm=\"row\" flex>\n<ms-auto-complete-tabela flex texto-fild-set=\"RELATORIO_CONTRATOS.CARACTERISTICAS_CLIENTES_NAO_IMPRIMIR\" \ninput-name=\"Características a não imprimir\" rota-da-pesquisa=\"{{vm.rotaDePesquisa}}\" item-template=\"descricao\" \nmensagem-nao-encontrado=\"Não foi encontrado nenhuma característica\" titulo-tabela=\"Descrição\" \ntexto-icone-remover=\"RELATORIO_CONTRATOS.LIMPAR_CARACTERISTICAS_A_NAO_IMPRIMIR\" \ntexto-floating-label=\"Características de cliente\" texto-icone-remover=\"Remover característica\" \nfiltros=\"vm.filtrosContratos.caracteristicasANaoImprimir\" texto-floating-label=\"Características a não imprimir\" \nhabilita-check-limpar=\"vm.filtrosContratos.caracteristicasANaoImprimir.length\" \nlabel-check-limpar=\"RELATORIO_CONTRATOS.REMOVER_CARACTERISTICA\"></ms-auto-complete-tabela></div></div>");
$templateCache.put("app/main/financeiro/relatorio/contratos/views/step/cliente/cliente-step.html","<div><div layout-gt-sm=\"row\" flex><ms-auto-complete-tabela flex texto-fild-set=\"RELATORIO_CONTRATOS.CLIENTES\" \ninput-name=\"cliente\" rota-da-pesquisa=\"{{vm.rotaPesquisa}}\" item-template=\"nome\" \nmensagem-nao-encontrado=\"Não foi encontrado nenhum cliente\" label-check=\"RELATORIO_CONTRATOS.TODOS_CLIENTES\" \ntitulo-tabela=\"Nome\" texto-icone-remover=\"RELATORIO_CONTRATOS.REMOVER_CLIENTE\" texto-floating-label=\"Clientes\" \ntexto-icone-remover=\"Remover clientes\" filtros=\"vm.filtrosContratos.clientes\" texto-floating-label=\"Clientes\">\n</ms-auto-complete-tabela></div></div>");
$templateCache.put("app/main/financeiro/relatorio/contratos/views/step/informacoes-gerais/informacoes-gerais-step.html","<div><div layout-gt-sm=\"row\" flex><div layout=\"column\" flex-gt-sm=\"45\"><div layout=\"column\"><fieldset class=\"standard\">\n<legend class=\"grp-legend\" translate=\"RELATORIO_CONTRATOS.TIPO_DE_RELATORIO\"></legend><div layout=\"column\">\n<md-radio-group layout=\"row\" ng-model=\"vm.filtrosContratos.tipoRelatorio\" \nng-change=\"vm.metodos.onChangeTipoRelatorio(vm.filtrosContratos.tipoRelatorio)\"><md-radio-button value=\"1\" \naria-label=\"Dados de faturamento\">{{\"RELATORIO_CONTRATOS.DADOS_DE_FATURAMENTO\" | translate}}</md-radio-button>\n<md-radio-button value=\"2\" aria-label=\"Dados de comissão\">{{\"RELATORIO_CONTRATOS.DADOS_DE_COMISSAO\" | translate}}\n</md-radio-button><md-radio-button value=\"3\" aria-label=\"Dados de Subitens\">\n{{\"RELATORIO_CONTRATOS.DADOS_DE_SUBITENS\" | translate}}</md-radio-button></md-radio-group></div></fieldset></div><div \nlayout=\"column\"><fieldset class=\"standard\"><legend class=\"grp-legend\" \ntranslate=\"RELATORIO_CONTRATOS.TIPO_DE_SITUACAO_ITEM\"></legend><div layout=\"column\"><md-radio-group \nng-model=\"vm.filtrosContratos.tipoSituacaoContratual\" layout=\"row\"><md-radio-button value=\"{{key}}\" \naria-label=\"{{value}}\" ng-repeat=\"(key, value) in vm.situacoesContrato\">{{value}}</md-radio-button><md-radio-button \nvalue=\"\" aria-label=\"Todos\" translate-attr-aria-label=\"RELATORIO_CONTRATOS.TODOS\">\n{{\"RELATORIO_CONTRATOS.TODOS\" | translate}}</md-radio-button></md-radio-group></div></fieldset></div><div \nlayout=\"column\"><fieldset class=\"standard\"><legend class=\"grp-legend\" \ntranslate=\"RELATORIO_CONTRATOS.TIPO_DE_SITUACAO_FINANCEIRA_ITEM\"></legend><div layout=\"column\"><md-radio-group \nng-model=\"vm.filtrosContratos.tipoSituacaoFinanceira\" layout=\"row\"><md-radio-button value=\"{{key}}\" \naria-label=\"{{value}}\" ng-repeat=\"(key, value) in vm.situacoesFinanceirasContrato\">{{value}}</md-radio-button>\n<md-radio-button value=\"\" aria-label=\"Ambos\" translate-attr-aria-label=\"RELATORIO_CONTRATOS.AMBOS\">\n{{\"RELATORIO_CONTRATOS.AMBOS\" | translate}}</md-radio-button></md-radio-group></div></fieldset></div><div \nlayout=\"column\" flex><fieldset class=\"standard\"><legend class=\"grp-legend\" \ntranslate=\"RELATORIO_CONTRATOS.TIPO_DE_PAGAMENTO\"></legend><div layout=\"column\"><md-radio-group layout=\"row\" \nng-model=\"vm.filtrosContratos.tipoDePagamento\" ng-change=\"vm.metodos.ngChangeLimparFormaDePagamento()\" \nng-disabled=\"vm.filtrosContratos.tipoRelatorio == 3\"><md-radio-button value=\"{{key}}\" aria-label=\"{{value}}\" \nng-repeat=\"(key, value) in vm.tiposPagamento\">{{value}}</md-radio-button></md-radio-group><div layout-gt-sm=\"row\" \nng-hide=\"vm.filtrosContratos.tipoDePagamento != 2\"><md-input-container class=\"md-block tamanho-md-select\" flex><label \ntranslate=\"RELATORIO_CONTRATOS.FORMA_PAGAMENTO\"></label><md-select name=\"selectFormaDePagamento\" \ndata-md-container-class=\"selectdemoSelectHeader\" multiple=\"multiple\" \nmd-on-open=\"vm.metodos.configurarSelectFormaPagamento()\" ng-model-options=\"{trackBy: \'$value.codigo\'}\" \nng-required=\"!vm.habilitarTodasFormasDePagamento\" ng-disabled=\"vm.habilitarTodasFormasDePagamento\" \nng-model=\"vm.filtrosContratos.formasPagamento\"><md-select-header id=\"select-forma-pagamento\"><input class=\"md-text\" \ntype=\"search\" placeholder=\"Pesquisar...\" ng-model=\"vm.termoProcurado\"></md-select-header><md-option \nng-value=\"formaPagamento\" ng-disabled=\"vm.habilitarTodasFormasDePagamento\" \nng-repeat=\"formaPagamento in vm.formasPagamento\r\n                                                   | filter:vm.termoProcurado track by formaPagamento.codigo\">\n{{formaPagamento.descricao}}</md-option></md-select><div \nng-messages=\"vm.form.tab.informacoesGerais.selectFormaDePagamento.$error\"><div ng-message=\"required\" \ntranslate=\"RELATORIO_CONTRATOS.FORMA_PAGAMENTO_OBRIGATORIA\"></div></div></md-input-container><md-input-container \nclass=\"md-block\"><md-checkbox name=\"todasFormasPagamento\" aria-label=\"Todos\" \nng-model=\"vm.habilitarTodasFormasDePagamento\" ng-change=\"vm.metodos.ngChangehabilitarTodasFormasPagamento()\"><span \nclass=\"float-label-cor-default\" translate=\"RELATORIO_CONTRATOS.TODOS\"></span></md-checkbox></md-input-container></div>\n</div></fieldset></div><ms-selecinar-multi-valores texto-field-set=\"RELATORIO_CONTRATOS.FILTRAR_POR_ESTADOS\" \ndados=\"vm.estados\" name-placeholder=\"Estados\" model-dados=\"vm.filtrosContratos.estados\" \nform=\"vm.form.tab.informacoesGerais.selectEstados\" \nmensagem-de-erro-do-formulario=\"RELATORIO_CONTRATOS.ESTADOS_OBRIGATORIOS\" \npropriedade-para-a-exibicao-da-repeticao=\"descricao\" limitar-width=\"true\"></ms-selecinar-multi-valores><div \nlayout=\"column\"><fieldset class=\"standard\"><legend class=\"grp-legend\" translate=\"RELATORIO_CONTRATOS.VALOR_DO_ITEM\">\n</legend><div layout=\"column\"><md-radio-group layout=\"row\" ng-model=\"vm.filtrosContratos.valorItem\" \nng-disabled=\"vm.filtrosContratos.tipoRelatorio == 3\"><md-radio-button value=\"1\" aria-label=\"Com valor\">\n{{\"RELATORIO_CONTRATOS.COM_VALOR\" | translate}}</md-radio-button><md-radio-button value=\"2\" aria-label=\"Sem valor\">\n{{\"RELATORIO_CONTRATOS.SEM_VALOR\" | translate}}</md-radio-button></md-radio-group></div></fieldset></div></div><div \nlayout=\"column\" flex-offset-gt-sm=\"5\" flex-gt-sm><div layout=\"column\" flex><fieldset class=\"standard filedset-datas\">\n<legend class=\"grp-legend\" translate=\"RELATORIO_CONTRATOS.DATAS\"></legend><div layout=\"column\" flex><md-radio-group \nng-model=\"vm.filtrosContratos.datas\" ng-change=\"vm.metodos.ngChangeLimparDataContrato(vm.filtrosContratos.datas)\" \nng-disabled=\"vm.filtrosContratos.tipoRelatorio == 3\"><md-radio-button value=\"{{key}}\" aria-label=\"{{value}}\" \nng-repeat=\"(key, value) in vm.dataContrato\">{{value}}</md-radio-button></md-radio-group><fieldset class=\"standard\" \nng-hide=\"!vm.filtrosContratos.datas || vm.filtrosContratos.datas == 5\"><legend class=\"grp-legend\" \ntranslate=\"RELATORIO_CONTRATOS.PERIODO\"></legend><div layout-gt-xs=\"row\"><div flex-gt-xs><md-input-container \nclass=\"md-block\"><md-datepicker name=\"datPicPeriodoInicial\" md-open-on-focus md-placeholder=\"Data inicial*\" \nmd-max-date=\"vm.filtrosContratos.periodoFinal\" ng-required=\"vm.filtrosContratos.datas != 5\" ng-mask=\"3?9/1?9/9999\" \nng-model=\"vm.filtrosContratos.periodoInicial\" ng-disabled=\"vm.filtrosContratos.tipoRelatorio == 3\"></md-datepicker><div\n ng-messages=\"vm.form.tab.informacoesGerais.datPicPeriodoInicial.$error\"><div ng-message=\"valid\" \ntranslate=\"MENSAGEM_VALIDACAO.DATA_INVALIDA\"></div><div ng-message=\"required\" \ntranslate=\"RELATORIO_CONTRATOS.DATA_INICIAL_OBRIGATORIA\"></div><div ng-message=\"maxdate\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_DATA_INICIAL\"></div></div></md-input-container></div><div flex-gt-xs>\n<md-input-container class=\"md-block\"><md-datepicker name=\"datePeriodoFinal\" md-placeholder=\"Data final*\" \nmd-open-on-focus md-min-date=\"vm.filtrosContratos.periodoInicial\" ng-required=\"vm.filtrosContratos.datas !=5\" \nng-model=\"vm.filtrosContratos.periodoFinal\" ng-mask=\"3?9/1?9/9999\" \nng-disabled=\"vm.filtrosContratos.tipoRelatorio == 3\"></md-datepicker><div \nng-messages=\"vm.form.tab.informacoesGerais.datePeriodoFinal.$error\"><div ng-message=\"valid\" \ntranslate=\"MENSAGEM_VALIDACAO.DATA_INVALIDA\"></div><div ng-message=\"mindate\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_DATA_FINAL\"></div><div ng-message=\"required\" \ntranslate=\"RELATORIO_CONTRATOS.DATA_FINAL_OBRIGATORIA\"></div></div></md-input-container></div></div></fieldset></div>\n</fieldset></div><ms-selecinar-multi-valores texto-field-set=\"RELATORIO_CONTRATOS.FILTRAR_POR_EXECUTIVOS\" \ndados=\"vm.executivos\" name-placeholder=\"Executivos\" model-dados=\"vm.filtrosContratos.executivos\" \nform=\"vm.form.tab.informacoesGerais.selectExecutivos\" \nmensagem-de-erro-do-formulario=\"RELATORIO_CONTRATOS.EXECUTIVOS_OBRIGATORIOS\" \npropriedade-para-a-exibicao-da-repeticao=\"login\" limitar-width=\"true\"></ms-selecinar-multi-valores>\n<ms-selecinar-multi-valores texto-field-set=\"RELATORIO_CONTRATOS.FILTRAR_POR_EMPRESAS\" dados=\"vm.empresasFaturamento\" \nname-placeholder=\"Empresas de faturamento\" model-dados=\"vm.filtrosContratos.empresasFaturamento\" \nform=\"vm.form.tab.informacoesGerais.selectEmpresasFaturamento\" \nmensagem-de-erro-do-formulario=\"RELATORIO_CONTRATOS.EMPRESAS_OBRIGATORIAS\" \npropriedade-para-a-exibicao-da-repeticao=\"nome\" limitar-width=\"true\"></ms-selecinar-multi-valores></div></div></div>");
$templateCache.put("app/main/financeiro/relatorio/contratos/views/step/licenca/licenca-step.html","<div layout=\"column\" flex><div layout-gt-sm=\"row\" flex><ms-auto-complete-tabela flex \ntexto-fild-set=\"RELATORIO_CONTRATOS.TIPO_LICENCA\" input-name=\"Tipos de licença\" \nrota-da-pesquisa=\"{{vm.rotaDePesquisa}}\" item-template=\"descricao\" \nmensagem-nao-encontrado=\"Não foi encontrado nenhum tipo de licença\" \nlabel-check=\"RELATORIO_CONTRATOS.TODOS_TIPOS_LICENCA\" titulo-tabela=\"Descrição\" \ntexto-icone-remover=\"RELATORIO_CONTRATOS.REMOVER_TIPO_LICENCA\" texto-floating-label=\"Tipos de licença\" \ntexto-icone-remover=\"Remover tipo de licença\" filtros=\"vm.filtrosContratos.tiposLicenca\" \ntexto-floating-label=\"Tipos de licença\" nome-do-campo-flag-and-or=\"RELATORIO_CONTRATOS.TIPO_SELECAO\" \nmodel-campo-and-or=\"vm.filtrosContratos.seletor\"></ms-auto-complete-tabela></div><div layout-gt-sm=\"row\" flex>\n<ms-auto-complete-tabela flex texto-fild-set=\"RELATORIO_CONTRATOS.TIPO_LICENCA_NAO_IMPRIMIR\" \ninput-name=\"Tipos de licença a não imprimir\" rota-da-pesquisa=\"{{vm.rotaDePesquisa}}\" item-template=\"descricao\" \nmensagem-nao-encontrado=\"Não foi encontrado nenhuma característica\" titulo-tabela=\"Descrição\" \ntexto-icone-remover=\"RELATORIO_CONTRATOS.LIMPAR_TIPOS_LICNCA_A_NAO_IMPRIMIR\" texto-floating-label=\"Tipos de licença\" \ntexto-icone-remover=\"Remover tipos de licença\" filtros=\"vm.filtrosContratos.tiposLicencaANaoImprimir\" \ntexto-floating-label=\"Tipos de licença a não imprimir\" \nhabilita-check-limpar=\"vm.filtrosContratos.tiposLicencaANaoImprimir.length\" \nlabel-check-limpar=\"RELATORIO_CONTRATOS.REMOVER_TIPO_LICENCA\"></ms-auto-complete-tabela></div></div>");
$templateCache.put("app/main/financeiro/relatorio/contratos/views/step/produto-segmentacao/produto-segmentacao-step.html","<div layout=\"column\" flex><div layout-gt-sm=\"row\" flex><ms-auto-complete-tabela flex texto-fild-set=\"Itens a imprimir\" \ninput-name=\"Itens\" rota-da-pesquisa=\"{{vm.rotaDaPesquisaProdutos}}\" item-template=\"descricao\" \nmensagem-nao-encontrado=\"Não foi encontrada nenhum item\" label-check=\"Todos\" titulo-tabela=\"Descrição\" \ntexto-icone-remover=\"Remover item\" texto-floating-label=\"Itens\" texto-icone-remover=\"Remover item\" \nfiltros=\"vm.filtrosContratos.produtos\" filtros-excluir=\"vm.filtrosContratos.produtosANaoImprimir\">\n</ms-auto-complete-tabela></div><div layout-gt-sm=\"row\" flex><secao-itens-a-nao-imprimir flex \nrota-da-pesquisa=\"{{vm.rotaDaPesquisaProdutos}}\" filtros=\"vm.filtrosContratos.produtosANaoImprimir\" \nfiltros-excluir=\"vm.filtrosContratos.produtos\" model-tipo-filtro=\"vm.filtrosContratos.tipoProdutosANaoImprimir\">\n</secao-itens-a-nao-imprimir></div><div layout-gt-sm=\"row\" flex><ms-auto-complete-tabela flex \ntexto-fild-set=\"RELATORIO_CONTRATOS.SEGMENTACAO\" input-name=\"segmentacoes\" rota-da-pesquisa=\"{{vm.rotaDaPesquisa}}\" \nitem-template=\"descricao\" mensagem-nao-encontrado=\"Não foi encontrado nenhuma segmentção\" \nlabel-check=\"RELATORIO_CONTRATOS.TODAS_SEGMENTACOES\" titulo-tabela=\"Descrição\" \ntexto-icone-remover=\"RELATORIO_CONTRATOS.REMOVER_SEGMENTACAO\" texto-floating-label=\"Segmentações\" \ntexto-icone-remover=\"Remover segmentação\" filtros=\"vm.filtrosContratos.segmentacoes\" \ntexto-floating-label=\"Segmentações\"></ms-auto-complete-tabela></div><div layout-gt-sm=\"row\" flex><secao-subitens \nng-if=\"vm.filtrosContratos.tipoRelatorio == 3\" flex lista-completa=\"vm.subitens\" \nfiltros=\"vm.filtrosContratos.subitens\" filtros-excluir=\"vm.filtrosContratos.subitensANaoImprimir\"></secao-subitens>\n</div><div layout-gt-sm=\"row\" flex><secao-subitens-a-nao-imprimir ng-if=\"vm.filtrosContratos.tipoRelatorio == 3\" flex \nlista-completa=\"vm.subitens\" filtros=\"vm.filtrosContratos.subitensANaoImprimir\" \nfiltros-excluir=\"vm.filtrosContratos.subitens\"></secao-subitens-a-nao-imprimir></div></div>");
$templateCache.put("app/main/financeiro/processamento/contratos/views/tabs/tab-contratos/tab-contratos.html","<md-content id=\"tab-contratos\" layout-padding><div layout=\"row\"><md-autocomplete flex class=\"cliente\" \nmd-input-name=\"cliente\" md-no-cache=\"true\" md-selected-item=\"vm.contrato.cliente\" \nmd-selected-item-change=\"vm.metodos.alterarItemSelecionadoAutoCompleteCliente(item)\" \nmd-search-text=\"vm.textoDePesquisaAutoCompleteCliente\" \nmd-items=\"item in vm.metodos.pesquisarAutoCompleteCliente(vm.textoDePesquisaAutoCompleteCliente)\" \nmd-item-text=\"item.codigo + \' - \' + item.nome\" md-autoselect md-floating-label=\"Cliente\" \nng-required=\"(vm.controleForm.inserirAtivo) && (vm.tabSelecionada == vm.tabs.primeiraAba || \r\n                         vm.tabSelecionada == vm.tabs.quintaAba)\" \nng-selected=\"true\" \nng-disabled=\"(vm.controleForm.pesquisaAtiva && !vm.controleForm.inserirAtivo && !vm.controleForm.inserirAtivo) || vm.bloquearEdicaoCliente\" \nng-blur=\"vm.metodos.configurarAutoCompleteClienteOnBlur()\"><md-item-template><span \nmd-highlight-text=\"vm.textoDePesquisaAutoCompleteCliente\">{{item.codigo}} - {{item.nome}}</span></md-item-template>\n<md-not-found><label>Não foi encontrado nenhum Cliente.</label></md-not-found><div \nng-messages=\"vm.form.atendimento.cliente.$error\"><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-autocomplete><md-input-container \nclass=\"md-block tipo-contrato\" flex><label translate=\"CLIENTE.TIPO_CONTRATO\"></label><md-select name=\"tipoContrato\" \nmd-on-open=\"vm.metodos.configurarMdSelectTipoContrato()\" ng-model=\"vm.contrato.codigoTipoContrato\" \nng-required=\"(vm.controleForm.inserirAtivo) && (vm.tabSelecionada == vm.tabs.primeiraAba || vm.tabSelecionada == vm.tabs.quintaAba)\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && (!vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo)\">\n<md-select-header ng-if=\"vm.tiposContrato.length > 0\"><input id=\"contrato-form-tipo-contrato-md-select\" \nclass=\"md-text\" type=\"search\" translate translate-attr-placeholder=\"CLIENTE.TIPO_CONTRATO\" \nng-model=\"vm.filtrarTipoContrato\"></md-select-header><md-option ng-value=\"contrato.codigo\" \nng-repeat=\"contrato in vm.tiposContrato | filter:vm.filtrarTipoContrato track by contrato.codigo\">\n{{ contrato.descricao }}</md-option></md-select><div ng-messages=\"vm.form.tipoContrato.$error\"><div \nng-message=\"required\" translate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container>\n<md-input-container class=\"md-block\" flex><label>Número do contrato</label><input type=\"text\" name=\"numeroContrato\" \nmaxlength=\"30\" ng-model=\"vm.contrato.numeroContrato\" \nng-disabled=\"(vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo) || ((vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo) && !vm.habilitarVisualizacao)\">\n</md-input-container><md-input-container class=\"md-block\" flex><label translate=\"CLIENTE.CNPJ_FATURAMENTO\"></label>\n<input type=\"text\" name=\"contratoCnpjFaturamento\" mascara-numero-generica=\"##.###.###/####-##\" mascara-documento \nalterar-mascara-dinamicamente ng-model=\"vm.contrato.contratoCnpjFaturamento\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\" \nng-required=\"(vm.controleForm.inserirAtivo || vm.controleForm.editarAtivo) && \r\n                   (vm.tabSelecionada == vm.tabs.primeiraAba || vm.tabSelecionada == vm.tabs.segundaAba || \r\n                   vm.tabSelecionada == vm.tabs.quintaAba)\">\n<div ng-messages=\"vm.form.contratoCnpjFaturamento.$error\"><div ng-message=\"validacaoDocumento\">\nCNPJ digitádo inválido. Ex: ##.###.###/####-##</div><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container><md-input-container class=\"md-block\" \nflex><label translate=\"CLIENTE.CODIGO_FATURAMENTO\"></label><input type=\"text\" name=\"clienteCodigoFaturamento\" \nmascara-numero-generica=\"#####\" ng-model=\"vm.contrato.clienteCodigoFaturamento\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\" \nng-required=\"(vm.controleForm.inserirAtivo || vm.controleForm.editarAtivo) && \r\n                   (vm.tabSelecionada == vm.tabs.primeiraAba || vm.tabSelecionada == vm.tabs.segundaAba || \r\n                   vm.tabSelecionada == vm.tabs.quintaAba)\">\n<div ng-messages=\"vm.form.clienteCodigoFaturamento.$error\"><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container></div><div layout=\"row\">\n<md-input-container class=\"md-block\" flex><label translate=\"CLIENTE.SITUACAO_CONTRATO\"></label><input type=\"text\" \nname=\"situacaoContrato\" ng-model=\"vm.contrato.contratoSituacao\" ng-disabled=\"true\" \nng-required=\"(vm.controleForm.editarAtivo) && vm.tabSelecionada == vm.tabs.segundaAba\"></md-input-container>\n<md-input-container class=\"md-block\" ng-if=\"vm.habilitarVisualizacao\" flex><label \ntranslate=\"CLIENTE.SITUACAO_FINANCEIRA_CONTRATO\"></label><input text=\"text\" name=\"situacaoFinanceiraContrato\" \nng-model=\"vm.contrato.situacaoFinanceira\" ng-disabled=\"true\" \nng-required=\"(vm.controleForm.editarAtivo) && vm.tabSelecionada == vm.tabs.segundaAba\"></md-input-container>\n<md-input-container class=\"md-block\" flex><label translate=\"CLIENTE.RESPONSAVEL_NFE\"></label><input type=\"text\" \nname=\"nomeResponsavelNfe\" ng-model=\"vm.contrato.contratoContato.nomeResponsavelNfe\" \nng-disabled=\"!vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\"></md-input-container><md-input-container \nclass=\"md-block\" flex-gt-xs=\"30\"><label translate=\"CLIENTE.EMAIL_RESPONSAVEL_NFE\"></label><input type=\"text\" \nname=\"emailResponsavelNfe\" ng-model=\"vm.contrato.contratoContato.emailResponsavelNfe\" \nng-disabled=\"!vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\"></md-input-container></div><div \nlayout=\"row\"><md-input-container class=\"md-block\" ng-if=\"vm.habilitarVisualizacao\" flex><label \ntranslate=\"CLIENTE.VALOR_TOTAL_CONTRATO\"></label><input type=\"text\" name=\"valorMensal\" ui-money-mask \nmascara-tamanho-campo=\"12\" ng-model=\"vm.contrato.valorTotalContrato\" ng-disabled=\"true\"></md-input-container>\n<md-input-container class=\"md-block\" ng-if=\"vm.habilitarVisualizacao\" flex><label translate=\"CLIENTE.INDICE_REAJUSTE\">\n</label><md-select name=\"indiceReajuste\" ng-model=\"vm.contrato.contratoDadosSigiloso.codigoIndiceReajuste\" \nng-disabled=\"!vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\"><md-option \nng-value=\"indiceReajuste.codigo\" ng-repeat=\"indiceReajuste in vm.indicesReajuste track by indiceReajuste.codigo\">\n{{indiceReajuste.descricao}}</md-option><md-option ng-if=\"vm.contrato.contratoDadosSigiloso.codigoIndiceReajuste\" \nng-value=\"\">Desmarcar</md-option></md-select></md-input-container><md-input-container class=\"md-block\" flex><label \ntranslate=\"CLIENTE.RESPONSAVEL_CONTRATO\"></label><input type=\"text\" name=\"nomeResponsavelContrato\" \nng-model=\"vm.contrato.contratoContato.nomeResponsavelContrato\" \nng-disabled=\"!vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\"></md-input-container><md-input-container \nclass=\"md-block\" flex=\"30\"><label translate=\"CLIENTE.EMAIL_RESPONSAVEL_CONTRATO\"></label><input type=\"text\" \nname=\"emailResponsavelContrato\" ng-model=\"vm.contrato.contratoContato.emailResponsavelContrato\" \nng-disabled=\"!vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\"></md-input-container></div><div \nlayout=\"row\"><md-input-container class=\"md-block\" ng-if=\"vm.habilitarVisualizacao || vm.usuarioEhManutencao\" flex>\n<label translate=\"CLIENTE.EMPRESA_FATURAMENTO\"></label><md-select name=\"empresaFaturamento\" \nmd-on-open=\"vm.metodos.configurarMdSelectEmpresaFaturamento()\" ng-model=\"vm.contrato.codigoEmpresaFaturamento\" \nng-disabled=\"!vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\" \nng-required=\"(vm.controleForm.inserirAtivo || vm.controleForm.editarAtivo)  && (vm.tabSelecionada == vm.tabs.primeiraAba || vm.tabSelecionada == vm.tabs.quintaAba)\">\n<md-select-header><input id=\"contrato-cliente-empresa-faturamento-md-select\" class=\"md-text\" type=\"search\" \nplaceholder=\"\" translate translate-attr-placeholder=\"CLIENTE.PESQUISAR_EMPRESA_FATURAMENTO\" \nng-model=\"vm.filtrarEmpresaFaturamento\"></md-select-header><md-option ng-value=\"clienteEmpresaFaturamento.codigo\" \nng-repeat=\"clienteEmpresaFaturamento in vm.clientesEmpresaFaturamento\r\n                         | filter:vm.filtrarEmpresaFaturamento track by clienteEmpresaFaturamento.codigo\">\n{{clienteEmpresaFaturamento.nome}}</md-option></md-select><div ng-messages=\"vm.form.empresaFaturamento.$error\"><div \nng-message=\"required\" translate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container>\n<md-input-container class=\"md-block\" ng-if=\"vm.habilitarVisualizacao\" flex><label translate=\"CLIENTE.FORMA_PAGAMENTO\">\n</label><md-select name=\"formaPagamento\" md-on-open=\"vm.metodos.configurarMdSelectFormaPagamento()\" \nng-model=\"vm.contrato.contratoFaturamento.codigoFormaPagamento\" \nng-disabled=\"!vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\" \nng-required=\"(vm.controleForm.inserirAtivo || vm.controleForm.editarAtivo)  && (vm.tabSelecionada == vm.tabs.primeiraAba || vm.tabSelecionada == vm.tabs.quintaAba)\">\n<md-select-header><input id=\"contrato-forma-pagamento-md-select\" class=\"md-text\" type=\"search\" placeholder=\"\" \ntranslate translate-attr-placeholder=\"CLIENTE.PESQUISAR_FORMA_PAGAMENTO\" ng-model=\"vm.filtrarFormaPagamento\">\n</md-select-header><md-option ng-value=\"formaPagamento.codigo\" \nng-repeat=\"formaPagamento in vm.formasPagamento \r\n                                           | filter:vm.filtrarFormaPagamento track by formaPagamento.codigo\">\n{{formaPagamento.descricao}}</md-option></md-select><div ng-messages=\"vm.form.formaPagamento.$error\"><div \nng-message=\"required\" translate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container></div><div \nlayout=\"row\"><md-input-container class=\"md-block observacao-faturamento\" ng-if=\"vm.habilitarVisualizacao\" flex \nstyle=\"min-width: 45%; max-width: 45%\"><label translate=\"CLIENTE.OBSERVACOES_FATURAMENTO\"></label><textarea \nname=\"observacoes\" ng-model=\"vm.contrato.contratoFaturamento.observacaoFaturamento\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\">\n\r\n                      </textarea></md-input-container></div><fieldset class=\"standard\" flex><legend \nclass=\"grp-legend\"><label>Encargos para atrasos de pagamentos</label></legend><div layout=\"column\"><div layout=\"row\">\n<md-input-container class=\"md-block\" flex=\"25\"><label>Multa</label><md-select name=\"tipoMulta\" \nng-model=\"vm.contrato.contratoEncargo.multa\" \nng-change=\"vm.metodos.setCamposUndefined(vm.contrato.contratoEncargo.multa, vm.form.tipoMulta)\" \nng-required=\"vm.controleForm.inserirAtivo || vm.controleForm.editarAtivo\" \nng-disabled=\"!vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\"><md-option ng-value=\"tiposMulta.codigo\" \nng-repeat=\"tiposMulta in vm.tiposMulta\">{{ tiposMulta.descricao }}</md-option></md-select><div \nng-messages=\"vm.form.tipoMulta.$error\"><div ng-message=\"required\" translate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\">\n</div></div></md-input-container><md-input-container class=\"md-block\" flex=\"25\" \nng-if=\"vm.contrato.contratoEncargo.multa == 2\"><label>Cobrança multa</label><md-select name=\"cobrancaMulta\" \nng-change=\"vm.metodos.setUndefinedMultaJuros(true)\" ng-model=\"vm.contrato.contratoEncargo.cobrancaMulta\" \nng-disabled=\"!vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\" \nng-required=\"vm.contrato.contratoEncargo.multa == 2\"><md-option ng-value=\"cobranca.codigo\" \nng-repeat=\"cobranca in vm.cobrancaMultaJuros \">{{ cobranca.descricao }}</md-option></md-select><div \nng-messages=\"vm.form.cobrancaMulta.$error\"><div ng-message=\"required\" translate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\">\n</div></div></md-input-container><md-input-container class=\"md-block\" flex=\"15\" \nng-if=\"vm.contrato.contratoEncargo.cobrancaMulta == 1\"><label>Valor</label><input type=\"text\" \nng-model=\"vm.contrato.contratoEncargo.valorMulta\" name=\"valorMulta\" class=\"campo-valor-monetario-juros\" ui-money-mask \nplaceholder=\"R$ 0,00\" ng-disabled=\"!vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\" \nng-change=\"vm.metodos.onchangeValorZerado(vm.form.valorMulta, vm.contrato.contratoEncargo.valorMulta)\" \nng-required=\"vm.contrato.contratoEncargo.cobrancaMulta == 1\" mascara-tamanho-campo=\"12\"><div \nng-messages=\"vm.form.valorMulta.$error\"><div ng-message=\"required\" translate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\">\n</div><div ng-message=\"validaMaiorQueZero\"><span>O valor informado deve ser maior que zero.</span></div></div>\n</md-input-container><md-input-container class=\"md-block\" flex=\"15\" \nng-if=\"vm.contrato.contratoEncargo.cobrancaMulta == 2\"><label>Valor</label><input type=\"text\" name=\"valorMulta\" \nmascara-tamanho-campo=\"6\" ui-percentage-mask class=\"campo-valor-monetario-juros\" placeholder=\"0,00 %\" \nng-required=\"vm.contrato.contratoEncargo.cobrancaMulta == 2\" \nng-change=\"vm.metodos.onchangeValorZerado(vm.form.valorMulta, vm.contrato.contratoEncargo.valorMulta)\" \nng-disabled=\"!vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\" \nng-model=\"vm.contrato.contratoEncargo.valorMulta\"><div ng-messages=\"vm.form.valorMulta.$error\"><div \nng-message=\"required\" translate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div><div ng-message=\"validaMaiorQueZero\">\n<span>O valor informado deve ser maior que zero.</span></div></div></md-input-container></div><div layout=\"row\" \nflex=\"100\"><md-input-container class=\"md-block\" flex=\"25\"><label>Juros</label><md-select name=\"tipoJuros\" \nng-change=\"vm.metodos.setCamposUndefined(vm.contrato.contratoEncargo.juros, vm.form.tipoJuros)\" \nng-model=\"vm.contrato.contratoEncargo.juros\" ng-required=\"vm.controleForm.inserirAtivo || vm.controleForm.editarAtivo\" \nng-disabled=\"!vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\"><md-option ng-value=\"juros.codigo\" \nng-repeat=\"juros in vm.tiposJuros\">{{ juros.descricao }}</md-option></md-select><div \nng-messages=\"vm.form.tipoJuros.$error\"><div ng-message=\"required\" translate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\">\n</div></div></md-input-container><md-input-container class=\"md-block\" flex=\"25\" \nng-if=\"vm.contrato.contratoEncargo.juros == 2 || vm.contrato.contratoEncargo.juros == 3\"><label>Cobrança juros</label>\n<md-select name=\"cobrancaJuros\" ng-change=\"vm.metodos.setUndefinedMultaJuros(false)\" \nng-required=\"vm.contrato.contratoEncargo.juros != 1\" \nng-disabled=\"!vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\" \nng-model=\"vm.contrato.contratoEncargo.cobrancaJuros\"><md-option ng-value=\"cobranca.codigo\" \nng-repeat=\"cobranca in vm.cobrancaMultaJuros \">{{ cobranca.descricao }}</md-option></md-select><div \nng-messages=\"vm.form.cobrancaJuros.$error\"><div ng-message=\"required\" translate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\">\n</div></div></md-input-container><md-input-container class=\"md-block\" flex=\"15\" \nng-if=\"vm.contrato.contratoEncargo.cobrancaJuros == 1\"><label>Valor</label><input type=\"text\" \nng-model=\"vm.contrato.contratoEncargo.valorJuros\" name=\"valorJuros\" class=\"campo-valor-monetario-juros\" ui-money-mask \nmascara-tamanho-campo=\"12\" placeholder=\"R$ 0,00\" \nng-disabled=\"!vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\" \nng-required=\"vm.contrato.contratoEncargo.cobrancaJuros == 1\" \nng-change=\"vm.metodos.onchangeValorZerado(vm.form.valorJuros, vm.contrato.contratoEncargo.valorJuros)\"><div \nng-messages=\"vm.form.valorJuros.$error\"><div ng-message=\"required\" translate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\">\n</div><div ng-message=\"validaMaiorQueZero\"><span>O valor informado deve ser maior que zero.</span></div></div>\n</md-input-container><md-input-container class=\"md-block\" flex=\"15\" \nng-if=\"vm.contrato.contratoEncargo.cobrancaJuros == 2\"><label>Valor</label><input type=\"text\" name=\"valorJuros\" \nclass=\"campo-valor-monetario-juros\" mascara-tamanho-campo=\"6\" ui-percentage-mask placeholder=\"0,00 %\" \nng-disabled=\"!vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\" \nng-required=\"vm.contrato.contratoEncargo.cobrancaJuros == 2\" \nng-change=\"vm.metodos.onchangeValorZerado(vm.form.valorJuros, vm.contrato.contratoEncargo.valorJuros)\" \nng-model=\"vm.contrato.contratoEncargo.valorJuros\"><div ng-messages=\"vm.form.valorJuros.$error\"><div \nng-message=\"required\" translate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div><div ng-message=\"validaMaiorQueZero\">\n<span>O valor informado deve ser maior que zero.</span></div></div></md-input-container></div><div layout=\"row\">\n<md-input-container class=\"md-block\" flex=\"25\"><label>Índice de correção monetária</label><md-select \nname=\"correcaoMonetaria\" ng-model=\"vm.contrato.contratoEncargo.correcaoMonetaria\" \nng-change=\"vm.metodos.setCamposUndefined(vm.contrato.contratoEncargo.correcaoMonetaria, vm.form.correcaoMonetaria)\" \nng-required=\"vm.controleForm.inserirAtivo || vm.controleForm.editarAtivo\" \nng-disabled=\"!vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\"><md-option ng-value=\"correcao.codigo\" \nng-repeat=\"correcao in vm.tiposCorrecaoMonetaria\">{{ correcao.descricao }}</md-option></md-select><div \nng-messages=\"vm.form.correcaoMonetaria.$error\"><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container><md-input-container \nclass=\"md-block container-data data-correcao-monetaria\" flex=\"30\" \nng-if=\"vm.contrato.contratoEncargo.correcaoMonetaria != 1 && vm.contrato.contratoEncargo.correcaoMonetaria != undefined\">\n<label>Data base da correção monetária</label><md-datepicker name=\"dataBaseCorrecaoMonetaria\" \nmascara-conversor-string-para-data ng-disabled=\"!vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\" \nng-required=\"vm.contrato.contratoEncargo.correcaoMonetaria != 1 && vm.contrato.contratoEncargo.correcaoMonetaria != undefined\" \nng-model=\"vm.contrato.contratoEncargo.dataBaseCorrecaoMonetaria\" ng-mask=\"3?9/1?9/9999\"></md-datepicker><div \nng-messages=\"vm.form.dataBaseCorrecaoMonetaria.$error\"><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container></div></div></fieldset><fieldset \nng-if=\"vm.habilitarVisualizacao\"><legend><label>Informações de período/reajuste de contrato</label></legend><div \nlayout=\"row\"><md-input-container class=\"md-block container-data\" flex><label \ntranslate=\"CLIENTE.DATA_INICIO_CONTRATO_ATUAL\"></label><md-datepicker name=\"dataInicioContratoAtual\" \nmascara-conversor-string-para-data md-max-date=\"vm.contrato.contratoDadosSigiloso.dataVencimentoContratoAtual\" \nng-mask=\"3?9/1?9/9999\" ng-model=\"vm.contrato.contratoDadosSigiloso.dataInicioContratoAtual\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\" \nng-required=\"(vm.controleForm.inserirAtivo || vm.controleForm.editarAtivo) && (vm.tabSelecionada == vm.tabs.primeiraAba || vm.tabSelecionada == vm.tabs.quintaAba)\">\n</md-datepicker><div ng-messages=\"vm.form.dataInicioContratoAtual.$error\"><div ng-message=\"valid\" \ntranslate=\"MENSAGEM_VALIDACAO.DATA_INVALIDA\"></div><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container><md-input-container \nclass=\"md-block container-data\" flex><label translate=\"CLIENTE.DATA_VENCIMENTO_CONTRATO_ATUAL\"></label><md-datepicker \nname=\"dataVencimentoContratoAtual\" mascara-conversor-string-para-data \nmd-min-date=\"vm.contrato.contratoDadosSigiloso.dataInicioContratoAtual\" \nng-model=\"vm.contrato.contratoDadosSigiloso.dataVencimentoContratoAtual\" ng-mask=\"3?9/1?9/9999\" \nng-disabled=\"!vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\" \nng-required=\"(vm.controleForm.inserirAtivo || vm.controleForm.editarAtivo) && (vm.tabSelecionada == vm.tabs.primeiraAba || vm.tabSelecionada == vm.tabs.segundaAba)\">\n</md-datepicker><div ng-messages=\"vm.form.dataVencimentoContratoAtual.$error\"><div ng-message=\"valid\" \ntranslate=\"MENSAGEM_VALIDACAO.DATA_INVALIDA\"></div><div ng-message=\"mindate\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_DATA_FINAL\"></div><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container><md-input-container \nclass=\"md-block container-data\" flex><label translate=\"CLIENTE.DATA_REAJUSTE_CONTRATO\"></label><md-datepicker \nmascara-conversor-string-para-data name=\"dataReajusteContrato\" \nng-model=\"vm.contrato.contratoDadosSigiloso.dataReajusteContrato\" ng-mask=\"3?9/1?9/9999\" \nng-disabled=\"!vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\" \nng-required=\"vm.controleForm.inserirAtivo && vm.tabSelecionada == vm.tabs.primeiraAba\"></md-datepicker><div \nng-messages=\"vm.form.dataReajusteContrato.$error\"><div ng-message=\"valid\" translate=\"MENSAGEM_VALIDACAO.DATA_INVALIDA\">\n</div><div ng-message=\"required\" translate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container>\n<md-input-container class=\"md-block container-data\" flex><label translate=\"Data vigência máxima\"></label><md-datepicker\n name=\"dataMaximaEncerramento\" mascara-conversor-string-para-data \nmd-min-date=\"vm.contrato.contratoDadosSigiloso.dataVencimentoContratoAtual\" \nng-model=\"vm.contrato.contratoDadosSigiloso.dataMaximaEncerramento\" ng-mask=\"3?9/1?9/9999\" \nng-disabled=\"!vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\" \nng-required=\"(vm.controleForm.inserirAtivo || vm.controleForm.editarAtivo) && (vm.tabSelecionada == vm.tabs.primeiraAba || vm.tabSelecionada == vm.tabs.segundaAba)\">\n</md-datepicker><div ng-messages=\"vm.form.dataMaximaEncerramento.$error\"><div ng-message=\"valid\" \ntranslate=\"MENSAGEM_VALIDACAO.DATA_INVALIDA\"></div><div ng-message=\"mindate\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_DATA_FINAL\"></div><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container></div><div layout=\"row\">\n<md-input-container class=\"container-data data-primeiro-contrato\" flex><label \ntranslate=\"CLIENTE.DATA_INICIO_PRIMEIRO_CONTRATO\"></label><md-datepicker name=\"dataInicioPrimeiroContrato\" \nmascara-conversor-string-para-data ng-model=\"vm.contrato.contratoDadosSigiloso.dataInicioPrimeiroContrato\" \nng-mask=\"3?9/1?9/9999\" ng-disabled=\"!vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\" \nng-required=\"(vm.controleForm.inserirAtivo || vm.controleForm.editarAtivo) && (vm.tabSelecionada == vm.tabs.primeiraAba || vm.tabSelecionada == vm.tabs.segundaAba)\">\n</md-datepicker><div ng-messages=\"vm.form.dataMaximaEncerramento.$error\"><div ng-message=\"valid\" \ntranslate=\"MENSAGEM_VALIDACAO.DATA_INVALIDA\"></div><div ng-message=\"mindate\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_DATA_FINAL\"></div><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container><md-input-container \nclass=\"md-block obs-reajustes\" flex></md-input-container></div></fieldset><fieldset ng-if=\"vm.habilitarVisualizacao\">\n<legend><label translate=\"CLIENTE.RESCISAO\"></label></legend><div layout=\"row\"><md-input-container \nclass=\"md-block contrato-rescindido\" flex=\"10\"><md-checkbox aria-label=\"Rescindido\" name=\"rescindido\" \nng-model=\"vm.contrato.contratoRescisao.rescindido\" \nng-change=\"vm.metodos.ngChangeContratoRescindido(vm.contrato.contratoRescisao.rescindido)\" \nng-disabled=\"!vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\">Rescindido</md-checkbox>\n</md-input-container><md-input-container class=\"md-block container-data\" \nng-if=\"vm.contrato.contratoRescisao.rescindido\" flex=\"20\"><label translate=\"CLIENTE.DATA_RESCISAO\"></label>\n<md-datepicker name=\"dataRescisao\" mascara-conversor-string-para-data ng-mask=\"3?9/1?9/9999\" \nng-model=\"vm.contrato.contratoRescisao.dataRescisao\" \nng-disabled=\"(!vm.controleForm.editarAtivo || vm.controleForm.emProgresso) || (vm.controleForm.editarAtivo && !vm.contrato.contratoRescisao.rescindido)\" \nng-required=\"true\"></md-datepicker><div ng-messages=\"vm.form.dataRescisao.$error\"><div ng-message=\"valid\" \ntranslate=\"MENSAGEM_VALIDACAO.DATA_INVALIDA\"></div></div></md-input-container></div><md-input-container \nclass=\"md-block\" ng-if=\"vm.contrato.contratoRescisao.rescindido\"><label translate=\"CLIENTE.MOTIVO_RESCISAO\"></label>\n<textarea name=\"motivoRescisao\" ng-model=\"vm.contrato.contratoRescisao.motivoRescisao\" md-maxlength=\"500\" \nmaxlength=\"500\" rows=\"1\" md-max-rows=\"3\" \nng-disabled=\"(!vm.controleForm.editarAtivo || vm.controleForm.emProgresso) || (vm.controleForm.editarAtivo && !vm.contrato.contratoRescisao.rescindido)\" \nng-required=\"true\" style=\"resize: none\">\r\n            </textarea><div ng-messages=\"vm.form.motivoRescisao.$error\"><div \nng-message=\"required\" translate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container></fieldset>\n</md-content>");
$templateCache.put("app/main/financeiro/processamento/contratos/views/tabs/tab-historico-contratos/tab-historico-contratos.html","<md-content id=\"tab-historico\"><div class=\"mensagem-historico\" ng-if=\"vm.metodos.desabilitaBotaoInserirHistorico()\">\n<div class=\"toast-mensagem\"><span>Não é permitido inserir históricos, pois todos os itens do contrato estão inativos.\n</span></div></div><div layout=\"column\" ng-if=\"vm.exibirTabelaHistorico\" flex><div \nclass=\"md-padding md-background-bg md-whiteframe-1dp fullpage-datatable tabela\" layout=\"column\" flex><table \nclass=\"dataTable row-border hover\" datatable=\"ng\" dt-options=\"vm.dtOptionsContratoHistorico\" width=\"100%\"><thead><tr>\n<th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Ação</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Item</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Subitem</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Data</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Status contrato</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Valor</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Motivo aditivo</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Observações</span></div></th></tr></thead>\n<tbody><tr ng-repeat=\"item in vm.contratoHistoricos | orderBy: [\'-prioritario\', \'-data\'] track by $index\" \nng-class=\"{marcarPrioritario : item.prioritario, \r\n                                   historicoComDesconto : item.tipoReajuste == 2}\">\n<td class=\"button-icone-cor-azul\"><button ng-disabled=\"vm.controleForm.emProgresso\" \nng-click=\"vm.controleForm.emProgresso || vm.metodos.abrirDialogHistoricoContrato($event, item, true)\"><i \nclass=\"icon-open-in-new s14 icone-cor-padrao mr-10\" ng-disabled=\"vm.controleForm.emProgresso\"></i></button> <button \nng-disabled=\"vm.controleForm.emProgresso || item.permiteEditarHistorico\" \nng-click=\"vm.metodos.abrirDialogHistoricoContrato($event, item, false, true)\"><i \nclass=\"icon-pencil s14 icone-cor-padrao\" ng-disabled=\"item.permiteEditarHistorico\"></i></button> <button \nng-disabled=\"vm.controleForm.emProgresso \" \nng-click=\"vm.controleForm.emProgresso || vm.metodos.abrirDialogPrioritario($event, item)\"><i \nclass=\"s20 icone-cor-padrao ml-5\" ng-disabled=\"vm.controleForm.emProgresso\" \nstyle=\"font-family: serif; font-style: initial\">P</i></button></td><td>\n{{vm.metodos.retornarDescricaoItem(item.codigoContratoItem)}}</td><td>\n{{vm.metodos.truncarDescricaoSubitensHistorico(item)}}<md-tooltip md-direction=\"top\" \nng-if=\"vm.metodos.formatarDescricaoSubitensHistorico(item).length > 30\">\n{{vm.metodos.formatarDescricaoSubitensHistorico(item)}}</md-tooltip></td><td>{{item.data | date:\'dd/MM/yyyy\'}}</td><td>\n{{item.statusContrato.descricao}}</td><td>{{item.valor | currency:\"R$\"}}</td><td>{{item.motivoAditivo.descricao}}</td>\n<td>{{vm.metodos.formatarVisualizacaoCampoObservacao(item.observacoes)}}</td></tr></tbody></table></div></div>\n</md-content>");
$templateCache.put("app/main/financeiro/processamento/contratos/views/tabs/tab-itens/tab-itens.html","<md-content id=\"tab-itens\"><div class=\"md-background-bg md-whiteframe-1dp\" \nng-if=\"vm.contrato.contratoItens.length > 0\"><table class=\"dataTable row-border hover\" width=\"100%\"><thead><tr><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Ação</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Item</span></div></th><th \nclass=\"secondary-text\" ng-if=\"vm.habilitarVisualizacao\"><div class=\"table-header\"><span class=\"column-title\">\nValor do item</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">\nExpiração</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Situação\n</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Situação financeira\n</span></div></th><th class=\"secondary-text\" style=\"width: 20%\" \nng-if=\"(vm.contrato.contratoItens | filter:{riscoRescisaoContratual:true}).length > 0\"><div class=\"table-header\"><span \nclass=\"column-title\"></span></div></th></tr></thead><tbody><tr \nng-repeat=\"item in vm.contrato.contratoItens | filter:vm.filtrarProduto track by item.codigo\"><td \nclass=\"button-icone-cor-azul\"><i class=\"icon-open-in-new s16 icone-cor-padrao mr-10\" aria-label=\"Visualizar item\" \ntranslate translate-attr-aria-label=\"CONTRATOS.VISUALIZAR_ITEM\" \nng-click=\"vm.controleForm.emProgresso || vm.metodos.abrirDialogItem(item, true)\" \nng-disabled=\"vm.controleForm.emProgresso\"></i> <i class=\"icon-pencil s16 icone-cor-padrao mr-10\" \naria-label=\"Editar item\" translate translate-attr-aria-label=\"CONTRATOS.EDITAR_ITEM\" \nng-click=\"vm.controleForm.emProgresso || !vm.habilitarVisualizacao || vm.metodos.abrirDialogItem(item, false)\" \nng-disabled=\"vm.controleForm.emProgresso || !vm.habilitarVisualizacao\"></i></td><td>{{item.produto.descricao}}</td><td \nng-if=\"vm.habilitarVisualizacao\">{{item.contratoItemDadosSigiloso.valorMensal | currency:\"R$\"}}</td><td>\n{{item.dataExpiracao | date:\'dd/MM/yyyy\'}}</td><td>\n{{vm.metodos.retornarDescricaoSituacaoItem(item.contratoItemDadosSigiloso.situacaoItem)}}</td><td>\n{{vm.metodos.retornarDescricaoSituacaoFinanceiraItem(item.contratoItemDadosSigiloso.situacaoFinanceiraItem)}}</td><td \nng-if=\"(vm.contrato.contratoItens | filter:{riscoRescisaoContratual:true}).length > 0\"><card-risco-perda-contratual \nng-if=\"item.riscoRescisaoContratual\"></card-risco-perda-contratual></td></tr></tbody></table></div></md-content>");
$templateCache.put("app/main/financeiro/processamento/contratos/views/tabs/tab-caracteristicas/tab-caracteristicas.html","<md-content layout-padding><form name=\"vm.form\" class=\"md-inline-form\" novalidate><div layout=\"column\" class=\"mt-10\" \nlayout-align=\"center center\" ng-show=\"vm.preloader.requisicaoSolicitada && !vm.baixandoArquivos\"><span \nclass=\"font-weight-500\">{{vm.preloader.mensagemPreloader}}</span><md-progress-circular md-mode=\"indeterminate\" \nmd-diameter=\"30\" class=\"md-accent\"></md-progress-circular></div><div layout-gt-xs=\"row\"><div layout=\"row\" \nlayout-align=\"center center\" flex><md-input-container flex-gt-sm=\"5\" class=\"md-block\" flex=\"10\"><label ng-hide=\"true\" \ntranslate=\"CONTRATOS.PESQUISAR_CARACTERISTICA_POR_CODIGO\"></label><input text=\"text\" \nng-model=\"vm.caracteristicaAPesquisar\" aria-label=\"Diretiva Pesquisar por Codigo\" pesquisar-por-codigo \nlista-a-pesquisar=\"vm.caracteristicas\" ng-disabled=\"vm.preloader.requisicaoSolicitada\" \nentidade-pesquisada=\"vm.caracteristicaContrato.codigoCaracteristica\" mascara-numeros=\"5\"></md-input-container>\n<md-input-container class=\"md-block\" style=\"margin-top: -7px\" flex=\"50\"><label translate=\"CONTRATOS.CARACTERISTICA\">\n</label><md-select ng-model=\"vm.caracteristicaContrato.codigoCaracteristica\" name=\"codigoCaracteristica\" \nmd-on-open=\"vm.metodosDialog.configurarMdSelectCaracteristica()\" ng-disabled=\"vm.preloader.requisicaoSolicitada\">\n<md-select-header><input id=\"dialog-contrato-md-select-caracteristica\" class=\"md-text\" \nng-model=\"vm.filtrarCaracteristica\" type=\"search\" placeholder=\"\" translate \ntranslate-attr-placeholder=\"CONTRATOS.PESQUISAR_CARACTERISTICA_CADASTRO\"></md-select-header><md-option \nng-value=\"caracteristica.codigo\" \nng-repeat=\"caracteristica in vm.caracteristicas | filter:vm.filtrarCaracteristica track by caracteristica.codigo\">\n{{caracteristica.descricao}}</md-option><md-option ng-value=\"\" ng-if=\"vm.caracteristicaContrato.codigoCaracteristica\">\nDesmarcar</md-option></md-select><div ng-messages=\"vm.form.codigoCaracteristica.$error\"><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container></div><div layout=\"row\" \nlayout-align=\"start center\" layout-align-xs=\"end center\"><md-button type=\"submit\" style=\"margin-top: -10px\" \nng-click=\"vm.metodos.cadastrarCaracteristica(vm.caracteristicaContrato, $event)\" \nclass=\"send-button md-accent md-raised\" \nng-disabled=\"vm.form.$pristine || vm.preloader.requisicaSolicitada || !vm.caracteristicaContrato.codigoCaracteristica\" \naria-label=\"SALVAR\" translate=\"CONTRATOS.SALVAR\" translate-attr-aria-label=\"CONTRATOS.SALVAR\">Salvar</md-button></div>\n</div><md-divider></md-divider><div layout=\"column\" flex \nclass=\"md-padding md-background-bg md-whiteframe-1dp fullpage-datatable\"><table \nclass=\"dataTable row-border hover border\" datatable=\"ng\" dt-options=\"vm.dtOptionsCaracteristicas\" width=\"100%\"><thead>\n<tr><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Ação</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Código</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Descrição</span></div></th></tr></thead>\n<tbody><tr \nng-repeat=\"caracteristicaContrato in vm.caracteristicasContrato | orderBy: \'descricao\' track by caracteristicaContrato.codigo\">\n<td class=\"button-icone-cor-azul\"><i class=\"icon-delete s16 icone-cor-padrao\" \nng-click=\"vm.preloader.requisicaoSolicitada || vm.metodos.excluirCaracteristica(caracteristicaContrato, $event)\" \nng-disabled=\"vm.preloader.requisicaoSolicitada\"></i></td><td>{{caracteristicaContrato.codigo}}</td><td>\n{{caracteristicaContrato.descricao}}</td></tr></tbody></table></div></form></md-content>");
$templateCache.put("app/main/financeiro/relatorio/contratos/views/step/caracteristica-contrato/caracteristica-contrato-step.html","<div layout=\"column\" flex><div layout-gt-sm=\"row\" flex><ms-auto-complete-tabela flex \ntexto-fild-set=\"RELATORIO_CONTRATOS.CARACTERISTICA_CONTRATO_IMPRIMIR\" input-name=\"Características\" \nrota-da-pesquisa=\"{{vm.rotaDePesquisa}}\" item-template=\"descricao\" \nmensagem-nao-encontrado=\"Não foi encontrada nenhuma característica\" \nlabel-check=\"RELATORIO_CONTRATOS.TODAS_CARACTERISTICAS\" titulo-tabela=\"Descrição\" \ntexto-icone-remover=\"RELATORIO_CONTRATOS.REMOVER_CARACTERISTICA\" texto-floating-label=\"Características de contrato\" \ntexto-icone-remover=\"Remover característica\" filtros=\"vm.filtrosContratos.caracteristicasContrato\" \nnome-do-campo-flag-and-or=\"RELATORIO_CONTRATOS.TIPO_SELECAO\" model-campo-and-or=\"vm.filtrosContratos.seletor\">\n</ms-auto-complete-tabela></div><div layout-gt-sm=\"row\" flex><ms-auto-complete-tabela flex \ntexto-fild-set=\"RELATORIO_CONTRATOS.CARACTERISTICA_CONTRATO_NAO_IMPRIMIR\" input-name=\"Características a não imprimir\" \nrota-da-pesquisa=\"{{vm.rotaDePesquisa}}\" item-template=\"descricao\" \nmensagem-nao-encontrado=\"Não foi encontrada nenhuma característica\" titulo-tabela=\"Descrição\" \ntexto-icone-remover=\"RELATORIO_CONTRATOS.REMOVER_CARACTERISTICA\" texto-floating-label=\"Características de contrato\" \ntexto-icone-remover=\"Remover característica\" filtros=\"vm.filtrosContratos.caracteristicasContratoANaoImprimir\">\n</ms-auto-complete-tabela></div><div layout-gt-sm=\"row\" flex><ms-auto-complete-tabela flex \ntexto-fild-set=\"RELATORIO_CONTRATOS.CARACTERISTICA_ITEM_IMPRIMIR\" input-name=\"Características\" \nrota-da-pesquisa=\"{{vm.rotaDePesquisaCaracteristicasItem}}\" item-template=\"descricao\" \nmensagem-nao-encontrado=\"Não foi encontrada nenhuma característica\" \nlabel-check=\"RELATORIO_CONTRATOS.TODAS_CARACTERISTICAS\" titulo-tabela=\"Descrição\" \ntexto-icone-remover=\"RELATORIO_CONTRATOS.REMOVER_CARACTERISTICA\" texto-floating-label=\"Características de item\" \ntexto-icone-remover=\"Remover característica\" filtros=\"vm.filtrosContratos.caracteristicasContratoItem\" \nnome-do-campo-flag-and-or=\"RELATORIO_CONTRATOS.TIPO_SELECAO\" model-campo-and-or=\"vm.filtrosContratos.seletor\">\n</ms-auto-complete-tabela></div><div layout-gt-sm=\"row\" flex><ms-auto-complete-tabela flex \ntexto-fild-set=\"RELATORIO_CONTRATOS.CARACTERISTICA_ITEM_NAO_IMPRIMIR\" input-name=\"Características a não imprimir\" \nrota-da-pesquisa=\"{{vm.rotaDePesquisaCaracteristicasItem}}\" item-template=\"descricao\" \nmensagem-nao-encontrado=\"Não foi encontrada nenhuma característica\" titulo-tabela=\"Descrição\" \ntexto-icone-remover=\"RELATORIO_CONTRATOS.REMOVER_CARACTERISTICA\" texto-floating-label=\"Características de item\" \ntexto-icone-remover=\"Remover característica\" filtros=\"vm.filtrosContratos.caracteristicasContratoItemANaoImprimir\">\n</ms-auto-complete-tabela></div></div>");
$templateCache.put("app/main/geral/relatorio/controle-horas/views/step/geral/informacoes-gerais-steper.html","<div layout-gt-sm=\"row\" flex><div layout=\"column\" flex><div layout=\"row\" flex><fieldset class=\"standard\" flex><legend>\n<label translate=\"RELATORIO_CLIENTE.MES_ANO\"></label></legend><div layout-gt-sm=\"row\" flex><md-input-container \nclass=\"md-block\" flex><label translate=\"RELATORIO_CLIENTE.MES\"></label><md-select ng-model=\"vm.filtros.mes\" name=\"mes\" \nmd-on-open=\"vm.metodos.configuraMdSelect()\"><md-select-header><input id=\"md-select-mes\" class=\"md-text\" \nng-model=\"vm.filtrarMes\" type=\"search\" placeholder=\"Pesquisar\" translate></md-select-header><md-option ng-value=\"item\" \nng-repeat=\"item in vm.meses | filter:vm.filtrarMes track by item.codigo\">{{item.descricao}}</md-option></md-select>\n</md-input-container><md-input-container class=\"md-block\" flex-gt-sm=\"20\" flex-offset-gt-sm=\"5\"><label \ntranslate=\"ATENDIMENTO.ANO\">Ano</label><input class=\"field-search\" type=\"text\" name=\"ano\" ng-model=\"vm.filtros.ano\" \nmascara-numero-generica=\"####\" converte-mascara-para-numero></md-input-container></div></fieldset></div></div><div \nlayout=\"column\" flex-offset-gt-sm=\"5\" flex><div layout=\"column\"><fieldset class=\"standard\"><legend><label \ntranslate=\"RELATORIO_CLIENTE.COLABORADOR\"></label></legend><div layout-gt-sm=\"row\" flex><div flex-gt-xs>\n<ms-auto-complete-colaborador desabilitar-campo=\"vm.requisicaoSolicitada\" \nform=\"vm.form.tab.informacoesGerais.dadosUsuario\" bind-usuario=\"vm.filtros.dadosUsuario\" \nlista-todos-usuarios=\"vm.todosColaboradores\" limpar-usuarios=\"vm.limparUsuarios\"></ms-auto-complete-colaborador></div>\n</div></fieldset></div></div></div>");
$templateCache.put("app/main/geral/processamento/controle-horas-trabalhadas/views/tabs/geral/tab-geral.html","<md-content id=\"tab-geral\" class=\"margin-top md-padding\"><div class=\"form-container\"><div layout-gt-xs=\"row\" \nlayout-align=\"space-between center\"><div layout-gt-xs=\"row\" flex><div layout-gt-xs=\"row\" flex flex-gt-xs=\"20\">\n<md-input-container flex><label flex>Período Inicial</label><md-datepicker flex name=\"dataInicial\" \nmd-max-date=\"vm.historico.dataFinal\" md-open-on-focus ng-required=\"vm.metodos.obrigarInformarCampo()\" \nng-model=\"vm.historico.dataInicial\" \nng-disabled=\"(vm.controleForm.pesquisaAtiva && !vm.controleForm.inserirAtivo && !vm.controleForm.editarAtivo)\" \nng-mask=\"3?9/1?9/9999\"></md-datepicker><div ng-messages=\"vm.form.dataInicial.$error\"><div ng-message=\"valid\" \ntranslate=\"MENSAGEM_VALIDACAO.DATA_INVALIDA\"></div><div ng-message=\"required\" \ntranslate=\"RELATORIO_CONTRATOS.DATA_INICIAL_OBRIGATORIA\"></div><div ng-message=\"maxdate\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_DATA_INICIAL\"></div></div></md-input-container></div><div layout-gt-xs=\"row\" \nflex=\"100\" flex-gt-xs=\"30\"><md-input-container flex><label flex>Período Final</label><md-datepicker flex \nname=\"dataFinal\" md-min-date=\"vm.historico.dataInicial\" md-open-on-focus \nng-disabled=\"vm.controleForm.pesquisaAtiva && (!vm.controleForm.inserirAtivo &&  !vm.controleForm.editarAtivo)\" \nng-required=\"vm.metodos.obrigarInformarCampo()\" ng-model=\"vm.historico.dataFinal\" ng-mask=\"3?9/1?9/9999\">\n</md-datepicker><div ng-messages=\"vm.form.dataFinal.$error\"><div ng-message=\"valid\" \ntranslate=\"MENSAGEM_VALIDACAO.DATA_INVALIDA\"></div><div ng-message=\"mindate\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_DATA_FINAL\"></div><div ng-message=\"required\" \ntranslate=\"RELATORIO_CONTRATOS.DATA_FINAL_OBRIGATORIA\"></div></div></md-input-container></div></div></div><div \nlayout-gt-xs=\"row\" layout-align=\"space-between center\"><fieldset class=\"standard\" flex><legend class=\"grp-legend\">\nTécnicos</legend><div layout-gt-xs=\"row\" flex><md-input-container class=\"md-block\" flex><label \ntranslate=\"PROCESSAMENTO.SELECIONAR_TECNICO\"></label><md-select name=\"colaboradores\" multiple=\"multiple\" \nmd-on-open=\"vm.metodos.configuraMdSelectTecnico()\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && (!vm.controleForm.inserirAtivo && !vm.controleForm.editarAtivo)\" \nng-required=\"vm.metodos.obrigarInformarCampo()\" ng-model-options=\"{trackBy: \'$value.codigo\'}\" \nng-model=\"vm.historico.colaboradores\"><md-select-header><input id=\"md-select-tecnico\" class=\"md-text\" type=\"search\" \nplaceholder=\"\" translate translate-attr-placeholder=\"PROCESSAMENTO.PESQUISAR\" ng-model=\"vm.filtrarTecnicos\">\n</md-select-header><md-option ng-value=\"tecnico\" \nng-repeat=\"tecnico in vm.listaColaboradores | filter:vm.filtrarTecnicos track by tecnico.codigo\">{{tecnico.nome}}\n</md-option></md-select></md-input-container></div></fieldset></div></div></md-content>");
$templateCache.put("app/main/geral/relatorio/Clientes/views/step/cliente/informacoes-gerais-steper.html","<div layout-gt-sm=\"row\" flex><div layout=\"column\" flex-gt-sm=\"50\"><div layout=\"column\"><fieldset class=\"standard\">\n<legend class=\"grp-legend\"><md-input-container class=\"md-block no-margin\"><md-checkbox class=\"no-margin\" \nng-model=\"vm.listarNaoAtendidos\" ng-change=\"vm.metodos.ngChangeListarNaoAtendidos()\" aria-label=\"Listar não atendidos\" \nname=\"listarNaoAtendidos\"><span translate=\"RELATORIO_CLIENTE.LISTAR_NAO_ATENDIDOS\"></span></md-checkbox>\n</md-input-container></legend><div layout-gt-sm=\"row\"><div flex-gt-xs><md-input-container class=\"md-block\"><label \ntranslate=\"RELATORIO_CLIENTE.DATA_INICIAL\"></label><md-datepicker name=\"dataInicioNaoAtendidos\" \nng-required=\"vm.listarNaoAtendidos\" ng-disabled=\"!vm.listarNaoAtendidos\" \nng-model=\"vm.filtrosClientes.dataInicioNaoAtendidos\" ng-mask=\"3?9/1?9/9999\" \nmd-max-date=\"vm.filtrosClientes.dataFimNaoAtendidos\" md-open-on-focus></md-datepicker><div \nng-messages=\"vm.form.tab.informacoesGerais.dataInicioNaoAtendidos.$error\"><div ng-message=\"valid\" \ntranslate=\"MENSAGEM_VALIDACAO.DATA_INVALIDA\"></div><div ng-message=\"required\" \ntranslate=\"RELATORIO_CLIENTE.DATA_INICIAL_OBRIGATORIA\"></div></div></md-input-container></div><div flex-gt-xs>\n<md-input-container class=\"md-block\"><label translate=\"RELATORIO_CLIENTE.DATA_FINAL\"></label><md-datepicker \nng-required=\"vm.listarNaoAtendidos\" ng-disabled=\"!vm.listarNaoAtendidos\" name=\"dataFimNaoAtendidos\" \nng-model=\"vm.filtrosClientes.dataFimNaoAtendidos\" ng-mask=\"3?9/1?9/9999\" \nmd-min-date=\"vm.filtrosClientes.dataInicioNaoAtendidos\" md-open-on-focus></md-datepicker><div \nng-messages=\"vm.form.tab.informacoesGerais.dataFimNaoAtendidos.$error\"><div ng-message=\"valid\" \ntranslate=\"MENSAGEM_VALIDACAO.DATA_INVALIDA\"></div><div ng-message=\"mindate\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_DATA_FINAL\"></div><div ng-message=\"required\" \ntranslate=\"RELATORIO_CLIENTE.DATA_FINAL_OBRIGATORIA\"></div></div></md-input-container></div></div></fieldset></div><div\n layout-gt-sm=\"column\" flex><fieldset class=\"standard\"><legend class=\"grp-legend\" \ntranslate=\"RELATORIO_CLIENTE.ORDENACAO\"></legend><div layout=\"column\"><md-radio-group \nng-model=\"vm.filtrosClientes.ordem\" layout-gt-sm=\"row\" flex><md-radio-button value=\"{{key}}\" aria-label=\"{{value}}\" \nng-repeat=\"(key, value) in vm.ordenacao\">{{value}}</md-radio-button></md-radio-group></div></fieldset></div>\n<ms-selecinar-multi-valores texto-field-set=\"RELATORIO_CLIENTE.EXECUTIVO\" dados=\"vm.executivos\" \nname-placeholder=\"Executivos\" model-dados=\"vm.filtrosClientes.executivos\" \nform=\"vm.form.tab.informacoesGerais.selectExecutivos\" mensagem-de-erro-do-formulario=\"Campo Obrigatório\" \npropriedade-para-a-exibicao-da-repeticao=\"login\" limitar-width=\"true\"></ms-selecinar-multi-valores></div><div \nlayout=\"column\" flex-offset-gt-sm=\"5\" flex-gt-sm=\"50\"><div layout=\"column\"><fieldset class=\"standard\"><legend \nclass=\"grp-legend\"><md-input-container class=\"no-margin no-margin\"><md-checkbox class=\"no-margin\" \nng-model=\"vm.listarRescindidos\" ng-change=\"vm.metodos.ngChangeListarRescindidos()\" \naria-label=\"Listar somentes rescindidos\" name=\"todosExecutivos\"><span \ntranslate=\"RELATORIO_CLIENTE.LISTAR_SOMENTE_RESCINDIDOS\"></span></md-checkbox></md-input-container></legend><div \nlayout-gt-sm=\"row\"><div flex-gt-xs><md-input-container class=\"md-block\"><label \ntranslate=\"RELATORIO_CLIENTE.DATA_INICIAL\"></label><md-datepicker ng-required=\"vm.listarRescindidos\" \nng-disabled=\"!vm.listarRescindidos\" name=\"dataInicioRescindidos\" ng-model=\"vm.filtrosClientes.dataInicioRescindidos\" \nng-mask=\"3?9/1?9/9999\" md-max-date=\"vm.filtrosClientes.dataFimRescindidos\" md-open-on-focus></md-datepicker><div \nng-messages=\"vm.form.tab.informacoesGerais.dataInicioRescindidos.$error\"><div ng-message=\"valid\" \ntranslate=\"MENSAGEM_VALIDACAO.DATA_INVALIDA\"></div><div ng-message=\"required\" \ntranslate=\"RELATORIO_CLIENTE.DATA_INICIAL_OBRIGATORIA\"></div></div></md-input-container></div><div flex-gt-xs>\n<md-input-container class=\"md-block\"><label translate=\"RELATORIO_CLIENTE.DATA_FINAL\"></label><md-datepicker \nng-required=\"vm.listarRescindidos\" ng-disabled=\"!vm.listarRescindidos\" name=\"dataFimRescindidos\" \nng-model=\"vm.filtrosClientes.dataFimRescindidos\" ng-mask=\"3?9/1?9/9999\" \nmd-min-date=\"vm.filtrosClientes.dataInicioRescindidos\" md-open-on-focus></md-datepicker><div \nng-messages=\"vm.form.tab.informacoesGerais.dataFimRescindidos.$error\"><div ng-message=\"valid\" \ntranslate=\"MENSAGEM_VALIDACAO.DATA_INVALIDA\"></div><div ng-message=\"mindate\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_DATA_FINAL\"></div><div ng-message=\"required\" \ntranslate=\"RELATORIO_CLIENTE.DATA_FINAL_OBRIGATORIA\"></div></div></md-input-container></div></div></fieldset></div><div\n layout=\"column\"><fieldset class=\"standard\"><legend class=\"grp-legend\" \ntranslate=\"RELATORIO_CLIENTE.CLIENTE_CONTRATUAL\"></legend><div layout=\"column\"><md-radio-group \nng-model=\"vm.filtrosClientes.clienteContratual\" layout-gt-sm=\"row\" flex><md-radio-button value=\"1\" aria-label=\"Sim\">Sim\n</md-radio-button><md-radio-button value=\"0\" aria-label=\"Não\">Não</md-radio-button><md-radio-button value=\"3\" \naria-label=\"Ambos\">Ambos</md-radio-button></md-radio-group></div></fieldset></div><fieldset class=\"standard\" flex>\n<legend class=\"grp-legend\" translate=\"RELATORIO_CLIENTE.ESTADO\"></legend><div layout-gt-xs=\"row\" flex>\n<md-input-container class=\"md-block tamanho-md-select\" flex><label translate=\"RELATORIO_CLIENTE.ESTADOS\">\n{{RELATORIO_CLIENTE.ESTADOS}}</label><md-select ng-required=\"!vm.habilitarTodosEstados\" \nng-model=\"vm.filtrosClientes.estados\" name=\"selectEstados\" md-on-open=\"vm.metodos.configurarSelectEstados()\" \nng-model-options=\"{trackBy: \'$value\'}\" ng-disabled=\"vm.habilitarTodosEstados\" multiple=\"multiple\"><md-select-header \nid=\"select-estado\"><input ng-model=\"vm.termoProcuradoEstados\" type=\"search\" placeholder=\"Pesquisar...\" class=\"md-text\">\n</md-select-header><md-option ng-value=\"estado\" ng-disabled=\"vm.habilitarTodosEstados\" \nng-repeat=\"estado in vm.estados\r\n                                                                    | filter:vm.termoProcuradoEstados track by estado\">\n{{estado}}</md-option></md-select><div ng-messages=\"vm.form.tab.informacoesGerais.selectEstados.$error\"><div \nng-message=\"required\" translate=\"RELATORIO_CLIENTE.ESTADOS_OBRIGATORIOS\"></div></div></md-input-container>\n<md-input-container class=\"md-block\"><md-checkbox ng-model=\"vm.habilitarTodosEstados\" \nng-change=\"vm.metodos.ngChangeHabilitarTodosEstados()\" aria-label=\"Todos\" name=\"todosEstados\"><span \nclass=\"float-label-cor-default\" translate=\"RELATORIO_CLIENTE.TODOS\"></span></md-checkbox></md-input-container></div>\n</fieldset></div></div>");
$templateCache.put("app/main/geral/processamento/controle-horas-trabalhadas/views/tabs/historico-viagem/tab-historico-viagem.html","<md-content class=\"margin-top md-padding\"><div class=\"form-container\"><div layout-gt-xs=\"row\" style=\"margin: 5px\" \nlayout-align=\"end center\"><md-button style=\"max-width: 40px;max-height: 40px;text-align: center\" \nclass=\"md-fab md-accent md-icon-button sample-show-hide\" ng-click=\"vm.metodos.abrirDialogCadastro()\" \nng-disabled=\"vm.ngDisabled\" ng-hide=\"vm.controladorAtivo\"><md-icon md-font-icon=\"icon-plus s20\"></md-icon><md-tooltip \nmd-autohide><span translate=\"PROCESSAMENTO.INSERIR_HISTORICO_VIAGEM\"></span></md-tooltip></md-button></div><div \nlayout-gt-xs=\"row\" layout-align=\"center center\"><table class=\"dataTable row-border hover\" datatable=\"ng\" \ndt-options=\"vm.dtOptionsHistoricoViagem\"><thead><tr><th class=\"secondary-text\"><div class=\"table-header text-center\">\n<span class=\"column-title\">Ações</span></div></th><th class=\"secondary-text\"><div class=\"table-header text-center\">\n<span class=\"column-title\">Saída</span></div></th><th class=\"secondary-text\"><div class=\"table-header text-center\">\n<span class=\"column-title\">Cidade Origem</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header text-center\"><span class=\"column-title\">Chegada</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header text-center\"><span class=\"column-title\">Cliente | Empresa de destino</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header text-center\"><span class=\"column-title\">Cidade Destino</span></div>\n</th></tr></thead><tbody><tr ng-repeat=\"horasTrabalhadas in vm.historicoViagem | orderBy:\'dataSaida\'\"><td \nclass=\"text-center\" fxlayout=\"row\" class=\"button-icone-cor-azul\"><div fxlayout=\"row\"><i \nclass=\"icon-pencil s16 icone-cor-padrao\" \nng-click=\"vm.controleForm.emProgresso || vm.metodos.abrirDialogCadastro($event, horasTrabalhadas, true)\" \nng-disabled=\"vm.controleForm.emProgresso\"><md-tooltip md-autohide><span \ntranslate=\"PROCESSAMENTO.EDITAR_HISTORICO_VIAGEM\"></span></md-tooltip></i><i class=\"icon-delete s16 icone-cor-padrao\" \nng-click=\"vm.controleForm.emProgresso || vm.metodos.excluirHistoricoViagem($event, horasTrabalhadas)\" \nng-disabled=\"vm.controleForm.emProgresso\"><md-tooltip md-autohide><span \ntranslate=\"PROCESSAMENTO.REMOVER_HISTORICO_VIAGEM\"></span></md-tooltip></i><i \nclass=\"icon-timetable s16 icone-cor-padrao\" \nng-click=\"vm.controleForm.emProgresso || vm.metodos.abrirDialogRegistroHoraTrabalho($event, horasTrabalhadas)\" \nng-disabled=\"vm.controleForm.emProgresso\"><md-tooltip md-autohide><span \ntranslate=\"PROCESSAMENTO.REGISTRAR_HORAS_TRABALHO\"></span></md-tooltip></i></div></td><td class=\"text-center\"><div \nfx-offset=\"5\" fxlayout=\"row\"><div fxlayout=\"column\">{{vm.metodos.preparaData(horasTrabalhadas.dataSaida)}}</div><div \nfxlayout=\"column\">{{horasTrabalhadas.horaSaida}}</div></div></td><td class=\"text-center\">\n{{horasTrabalhadas.cidadeOrigem.descricao}}</td><td class=\"text-center\"><div fx-offset=\"5\" fxlayout=\"row\"><div \nfxlayout=\"column\">{{vm.metodos.preparaData(horasTrabalhadas.dataChegada)}}</div><div fxlayout=\"column\">\n{{horasTrabalhadas.horaChegada}}</div></div></td><td class=\"text-center\">{{horasTrabalhadas.cliente.nome}}</td><td \nclass=\"text-center\">{{horasTrabalhadas.cidadeDestino.descricao}}</td></tr></tbody></table></div></div></md-content>");
$templateCache.put("app/main/geral/relatorio/Clientes/views/step/caracteristica/caracteristica-step.html","<div layout=\"column\" flex><div layout-gt-sm=\"row\" flex><ms-auto-complete-tabela flex \ntexto-fild-set=\"RELATORIO_CLIENTE.CARACTERISTICA_CLIENTE\" input-name=\"Características\" \nrota-da-pesquisa=\"{{vm.rotaDaPesquisa}}\" item-template=\"descricao\" \nmensagem-nao-encontrado=\"Não foi encontrado nenhuma característica\" \nlabel-check=\"RELATORIO_CLIENTE.TODAS_CARACTERISTICAS\" titulo-tabela=\"Descrição\" \ntexto-icone-remover=\"RELATORIO_CLIENTE.REMOVER_CARACTERISTICA\" texto-floating-label=\"Características de cliente\" \ntexto-icone-remover=\"Remover característica\" filtros=\"vm.filtrosClientes.caracteristicas\" \ntexto-floating-label=\"Características\" nome-do-campo-flag-and-or=\"RELATORIO_CLIENTE.TIPO_SELECAO\" \nmodel-campo-and-or=\"vm.filtrosClientes.seletor\"></ms-auto-complete-tabela></div><div layout-gt-sm=\"row\" flex>\n<ms-auto-complete-tabela flex texto-fild-set=\"RELATORIO_CLIENTE.CARACTERISTICA_CLIENTE_NAO_IMPRIMIR\" \ninput-name=\"Características a não imprimir\" rota-da-pesquisa=\"{{vm.rotaDaPesquisa}}\" item-template=\"descricao\" \nmensagem-nao-encontrado=\"Não foi encontrado nenhuma característica\" titulo-tabela=\"Descrição\" \ntexto-icone-remover=\"RELATORIO_CLIENTE.REMOVER_CARACTERISTICA\" texto-floating-label=\"Características de cliente\" \ntexto-icone-remover=\"Remover característica\" filtros=\"vm.filtrosClientes.caracteristicasANaoImprimir\" \ntexto-floating-label=\"Características a não imprimir\" \nhabilita-check-limpar=\"vm.filtrosClientes.caracteristicasANaoImprimir.length\" \nlabel-check-limpar=\"RELATORIO_CLIENTE.LIMPAR_CARACTERISTICAS\"></ms-auto-complete-tabela></div></div>");
$templateCache.put("app/main/geral/relatorio/Clientes/views/step/licenca/licenca-step.html","<div layout=\"column\" flex><div layout-gt-sm=\"row\" flex><ms-auto-complete-tabela flex \ntexto-fild-set=\"RELATORIO_CLIENTE.TIPO_LICENCA\" input-name=\"Tipos de licença\" rota-da-pesquisa=\"{{vm.rotaDePesquisa}}\" \nitem-template=\"descricao\" mensagem-nao-encontrado=\"Não foi encontrado nenhum tipo de licença\" \nlabel-check=\"RELATORIO_CLIENTE.TODOS_TIPOS_LICENCA\" titulo-tabela=\"Descrição\" \ntexto-icone-remover=\"RELATORIO_CLIENTE.REMOVER_TIPO_LICENCA\" texto-floating-label=\"Tipos de licença\" \ntexto-icone-remover=\"Remover tipo de licença\" filtros=\"vm.filtrosClientes.tiposLicenca\" \ntexto-floating-label=\"Tipos de licença\" nome-do-campo-flag-and-or=\"RELATORIO_CLIENTE.TIPO_SELECAO\" \nmodel-campo-and-or=\"vm.filtrosClientes.seletor\"></ms-auto-complete-tabela></div><div layout-gt-sm=\"row\" flex>\n<ms-auto-complete-tabela flex texto-fild-set=\"RELATORIO_CLIENTE.TIPO_LICENCA_NAO_IMPRIMIR\" \ninput-name=\"Tipos de licença a não imprimir\" rota-da-pesquisa=\"{{vm.rotaDePesquisa}}\" item-template=\"descricao\" \nmensagem-nao-encontrado=\"Não foi encontrado nenhuma característica\" titulo-tabela=\"Descrição\" \ntexto-icone-remover=\"RELATORIO_CLIENTE.LIMPAR_TIPOS_LICENCA_A_NAO_IMPRIMIR\" texto-floating-label=\"Tipos de licença\" \ntexto-icone-remover=\"Remover tipos de licença\" filtros=\"vm.filtrosClientes.tiposLicencaANaoImprimir\" \ntexto-floating-label=\"Tipos de licença a não imprimir\" \nhabilita-check-limpar=\"vm.filtrosClientes.tiposLicencaANaoImprimir.length\" \nlabel-check-limpar=\"RELATORIO_CLIENTE.REMOVER_TIPO_LICENCA\"></ms-auto-complete-tabela></div></div>");
$templateCache.put("app/main/geral/relatorio/Clientes/views/step/produto-segmentacao/produto-segmentacao-step.html","<div layout=\"column\" flex><div layout-gt-sm=\"row\" flex><ms-selecinar-multi-valores flex \ntexto-field-set=\"RELATORIO_CLIENTE.PRODUTO\" dados=\"vm.produtos\" name-placeholder=\"produtos\" \nmodel-dados=\"vm.filtrosClientes.produtos\" form=\"vm.form.tab.solucaoSegmentacao.selectProdutos\" \nmensagem-de-erro-do-formulario=\"RELATORIO_CLIENTE.PRODUTO_OBRIGATORIO\" \npropriedade-para-a-exibicao-da-repeticao=\"descricao\"></ms-selecinar-multi-valores></div><div layout-gt-sm=\"row\" flex>\n<ms-auto-complete-tabela flex texto-fild-set=\"RELATORIO_CLIENTE.SEGMENTACAO\" input-name=\"segmentacoes\" \nrota-da-pesquisa=\"{{vm.rotaDaPesquisa}}\" item-template=\"descricao\" \nmensagem-nao-encontrado=\"Não foi encontrado nenhuma segmentção\" label-check=\"RELATORIO_CLIENTE.TODAS_SEGMENTACOES\" \ntitulo-tabela=\"Descrição\" texto-icone-remover=\"RELATORIO_CLIENTE.REMOVER_SEGMENTACAO\" \ntexto-floating-label=\"Segmentações\" texto-icone-remover=\"Remover segmentação\" \nfiltros=\"vm.filtrosClientes.segmentacoes\" texto-floating-label=\"Segmentações\"></ms-auto-complete-tabela></div></div>");
$templateCache.put("app/main/geral/brainstorming/brainstorming/views/tabs/brainstorming/tab-brainstorming.html","<md-content class=\"md-padding\"><div class=\"form-container\"><div layout-gt-xs=\"row\" flex=\"100\"><md-input-container \nclass=\"md-block\" flex-gt-sm=\"10\"><label translate=\"BRAINSTORMING.NUMERO\">Número</label><input type=\"text\" \nng-model=\"vm.brainstorming.numero\" name=\"brainstormingNumero\" mascara-numero-generica=\"#####\" \nconverte-mascara-para-numero ng-required=\"vm.controleForm.inserirAtivo || vm.controleForm.editarAtivo\" \nng-disabled=\"vm.controleForm.pesquisaAtiva || vm.controleForm.inserirAtivo || vm.controleForm.editarAtivo\"><div \nng-messages=\"vm.brainstormingForm.respostaForm.brainstormingNumero.$error\"><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container><md-input-container class=\"md-block\" \nflex-gt-sm=\"10\"><label translate=\"BRAINSTORMING.ANO\">Ano</label><input class=\"field-search\" type=\"text\" \nng-model=\"vm.brainstorming.ano\" name=\"brainstormingAno\" mascara-numero-generica=\"####\" converte-mascara-para-numero \nng-required=\"vm.controleForm.inserirAtivo\" \nng-disabled=\"vm.controleForm.pesquisaAtiva || vm.controleForm.inserirAtivo || vm.controleForm.editarAtivo\"><div \nng-messages=\"vm.brainstormingForm.brainstormingAno.$error\"><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container><md-input-container class=\"md-block\" \nflex-gt-sm=\"30\"><label translate=\"BRAINSTORMING.DATA_ABERTURA\" class=\"alinhar-label-data\">Data abertura</label>\n<md-datepicker ng-model=\"vm.brainstorming.dataAbertura\" name=\"brainstormingDataAbertura\" \nmascara-conversor-string-para-data ng-mask=\"3?9/1?9/9999\" \nng-required=\"vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo\" \nng-disabled=\"vm.controleForm.pesquisaAtiva || vm.controleForm.inserirAtivo || vm.controleForm.editarAtivo\">\n</md-datepicker><div ng-messages=\"vm.brainstormingForm.brainstormingDataAbertura.$error\"><div ng-message=\"valid\" \ntranslate=\"MENSAGEM_VALIDACAO.DATA_INVALIDA\"></div><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.DATA_OBRIGATORIA\"></div></div></md-input-container><md-input-container class=\"md-block\" \nflex-gt-sm=\"20\"><label translate=\"BRAINSTORMING.STATUS\">Status</label><md-select ng-model=\"vm.brainstorming.status\" \nname=\"brainstormingStatus\" ng-required=\"vm.controleForm.editarAtivo\" \nng-disabled=\"(vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo) || vm.controleForm.inserirAtivo || (vm.controleForm.editarAtivo && vm.usuarioLogado.clsPerfil.codigo != \'3\' && vm.usuarioLogado.clsPerfil.codigo != \'8\' && vm.usuarioLogado.clsPerfil.codigo != \'9\')\">\n<md-option ng-value=\"status.codigo\" ng-repeat=\"status in vm.status  | orderBy:\'descricao\'\">\n{{status.descricao | uppercase}}</md-option></md-select></md-input-container><md-input-container class=\"md-block\" \nflex-gt-sm=\"20\" ng-if=\"vm.controleForm.inserirAtivo\"><label translate=\"BRAINSTORMING.USUARIO\">Usuário</label><md-select\n ng-model=\"vm.brainstorming.codigoUsuario\" name=\"brainstormingCodigoUsuario\" \nng-required=\"vm.controleForm.inserirAtivo\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.inserirAtivo\"><md-option ng-value=\"0\">ANÔNIMO\n</md-option><md-option ng-value=\"vm.usuarioLogado.codigo\">{{vm.usuarioLogado.login}}</md-option></md-select>\n</md-input-container><md-input-container class=\"md-block\" flex-gt-sm=\"20\" ng-if=\"!vm.controleForm.inserirAtivo\"><label \ntranslate=\"BRAINSTORMING.USUARIO\">Usuário</label><md-select ng-model=\"vm.brainstorming.codigoUsuario\" \nname=\"brainstormingCodigoUsuario\" ng-required=\"vm.controleForm.inserirAtivo\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.inserirAtivo\"><md-option ng-value=\"0\">ANÔNIMO\n</md-option><md-option ng-value=\"usuario.codigo\" ng-repeat=\"usuario in vm.usuariosAtivos\">{{usuario.login}}</md-option>\n</md-select></md-input-container></div><div layout-gt-xs=\"row\" flex=\"100\"><md-input-container class=\"md-block\" \nflex-gt-sm=\"100\"><label translate=\"BRAINSTORMING.DESCRICAO\">Descrição</label><textarea type=\"text\" \nname=\"brainstormingDescricao\" ng-model=\"vm.brainstorming.descricao\" md-no-resize=\"false\" rows=\"2\" \nng-required=\"vm.controleForm.inserirAtivo\" \nng-disabled=\"(vm.controleForm.pesquisaAtiva && !vm.controleForm.inserirAtivo) || vm.controleForm.editarAtivo\">\n</textarea><div ng-messages=\"vm.brainstormingForm.brainstormingNumero.$error\"><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container></div></div></md-content>");
$templateCache.put("app/main/geral/brainstorming/brainstorming/views/tabs/respostas/tab-respostas.html","<md-content id=\"tab-respostas\" class=\"md-padding\"><div class=\"inserir-button\" layout-gt-xs=\"row\" \nlayout-align=\"end center\" flex><md-button class=\"md-fab md-accent md-icon-button sample-show-hide\" \nng-click=\"vm.metodosResposta.abrirDialogInserirResposta($event)\" \nng-disabled=\"vm.brainstorming.status != 6 && (vm.usuarioLogado.clsPerfil.codigo != \'3\' && vm.usuarioLogado.clsPerfil.codigo != \'8\' && vm.usuarioLogado.clsPerfil.codigo != \'9\')\" \nng-hide=\"vm.controladorAtivo\" aria-label=\"Inserir Histórico Situação\" translate-attr-aria-label=\"Inserir Resposta\">\n<md-icon md-font-icon=\"icon-plus s30\"></md-icon><md-tooltip md-autohide><span translate=\"Inserir Resposta\"></span>\n</md-tooltip></md-button></div><div class=\"md-background-bg md-whiteframe-1dp\"><table \nclass=\"dataTable row-border hover\" datatable=\"ng\" dt-options=\"vm.dtOptionsRespostas\" width=\"100%\" \nng-if=\"vm.brainstorming.respostas.length > 0\"><thead><tr><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Usuário</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Resposta</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Data resposta</span></div></th></tr></thead><tbody><tr \nng-repeat=\"resposta in vm.brainstorming.respostas\"><td><md-button class=\"md-icon-button md-avatar siglas\">\n{{vm.metodosGeral.retornaIniciasNomeUsuario(resposta.codigoUsuario)}}<md-tooltip><span>\n{{vm.metodosGeral.retornaUsuario(resposta.codigoUsuario) | uppercase}}</span></md-tooltip></md-button></td><td>\n{{resposta.descricao}}</td><td><span style=\"display: none\">{{resposta.dataResposta}}</span> <span>\n{{resposta.dataResposta | date:\'dd/MM/yyyy\'}}</span></td></tr></tbody></table></div></md-content>");
$templateCache.put("app/main/geral/cadastro/caracteristica/views/tabs/caracteristica/tab-caracteristica.html","<md-content class=\"md-padding\" ms-scroll><div class=\"form-container\"><div layout-gt-xs=\"row\"><div layout=\"row\">\n<md-input-container class=\"md-block\" flex-gt-sm><label translate=\"CARACTERISTICA.CODIGO\"></label><input type=\"text\" \nng-model=\"vm.caracteristica.codigo\" name=\"codigo\" mascara-numero-generica=\"#####\" \nng-required=\"vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo\" \nng-disabled=\"(vm.controleForm.pesquisaAtiva || vm.controleForm.editarAtivo) && !vm.controleForm.inserirAtivo\"><div \nng-messages=\"vm.form.caracteristica.codigo.$error\"><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container><proximo-codigo \nng-show=\"vm.controleForm.inserirAtivo\" rota=\"vm.rota\" entidade-codigo=\"vm.caracteristica.codigo\" \npre-loader-toolbar=\"vm.controleForm.preLoaderToolbar\"></proximo-codigo></div><md-input-container class=\"md-block\" flex \nflex-offset-gt-sm=\"5\"><label translate=\"CARACTERISTICA.DESCRICAO\"></label><input type=\"text\" \nng-model=\"vm.caracteristica.descricao\" name=\"descricao\" mascara-tamanho-campo=\"60\" \nng-required=\"vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo\" md-maxlength=\"60\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\"><div \nng-messages=\"vm.form.caracteristica.descricao.$error\"><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container><md-input-container class=\"md-block\" \nflex-offset-gt-sm=\"5\" ng-if=\"vm.caracteristica.tipo == 2 || vm.caracteristica.tipo == 3\"><md-checkbox \nng-model=\"vm.caracteristica.contratoViaParceiro\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\" \naria-label=\"contrato\" name=\"contratoViaParceiro\"><span class=\"float-label-cor-default\" \ntranslate=\"CARACTERISTICA.CONTRATO_VIA_PARCEIRO\"></span></md-checkbox></md-input-container></div><div \nlayout-gt-sm=\"row\" layout-align=\"center center\"><fieldset class=\"standard\" flex flex-gt-sm=\"50\"><legend \nclass=\"grp-legend\" translate=\"CARACTERISTICA.TIPO_CARACTERISTICA\"></legend><md-radio-group \nng-model=\"vm.caracteristica.tipo\" layout=\"row\" layout-align=\"center start\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\">\n<md-radio-button aria-label=\"Cliente\" ng-value=\"1\"><span translate=\"CARACTERISTICA.CLIENTE\"></span></md-radio-button>\n<md-radio-button aria-label=\"Contrato\" ng-value=\"2\"><span translate=\"CARACTERISTICA.CONTRATO\"></span></md-radio-button>\n<md-radio-button aria-label=\"Contrato\" ng-value=\"3\"><span translate=\"CARACTERISTICA.CONTRATO_ITEM\"></span>\n</md-radio-button></md-radio-group></fieldset></div></div></md-content>");
$templateCache.put("app/main/geral/cadastro/caracteristica/views/tabs/cliente/tab-cliente.html","<md-content class=\"md-padding\" ms-scroll><div class=\"form-container\"><div layout-gt-xs=\"row\"><div layout=\"row\" \nlayout-align=\"center center\" flex><md-autocomplete flex-gt-sm=\"50\" flex-gt-xs md-input-name=\"cliente\" \nmd-no-cache=\"true\" ng-blur=\"vm.metodosAbaCliente.configuraAutoCompleteClienteOnBlur()\" md-selected-item=\"vm.cliente\" \nmd-selected-item-change=\"vm.metodosAbaCliente.alterarItemSelecionadoAutoCompleteCliente(item)\" \nmd-search-text=\"vm.textoDePesquisaAutoCompleteCliente\" \nmd-items=\"item in vm.metodosAbaCliente.pesquisarAutoCompleteCliente(vm.textoDePesquisaAutoCompleteCliente)\" \nmd-item-text=\"item.nome\" md-autoselect md-floating-label=\"Cliente\" required><md-item-template><span \nmd-highlight-text=\"vm.textoDePesquisaAutoCompleteCliente\">{{item.nome}}</span></md-item-template><md-not-found><label>\nNão foi encontrado nenhum Cliente.</label></md-not-found></md-autocomplete><md-button type=\"submit\" \nstyle=\"margin-top: -20px\" ng-click=\"vm.metodosAbaCliente.inserirCliente(vm.cliente)\" \nclass=\"send-button md-accent md-raised\" \nng-disabled=\"vm.form.$pristine || vm.controleForm.emProgresso || !vm.cliente.codigo\" aria-label=\"SALVAR\" \ntranslate=\"CARACTERISTICA.ADICIONAR\" translate-attr-aria-label=\"CARACTERISTICA.ADICIONAR\"></md-button></div></div>\n<md-divider></md-divider></div><div layout=\"row\" flex class=\"mt-20\" layout-wrap><table \nclass=\"dataTable row-border hover border\" datatable=\"ng\" dt-options=\"vm.dtOptions\" width=\"100%\"><thead><tr><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title text-center\">Ação</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title text-center\">Código</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title text-center\">Nome</span></div></th></tr>\n</thead><tbody><tr \nng-repeat=\"clienteCaracteristica in vm.caracteristica.clientes | orderBy: \'nomeFantasia\' track by clienteCaracteristica.codigo\">\n<td class=\"button-icone-cor-azul text-center\"><i class=\"icon-delete s16 icone-cor-padrao\" \nng-click=\"vm.metodosAbaCliente.excluirCliente(clienteCaracteristica)\" ng-disabled=\"vm.controleForm.emProgresso\"></i>\n</td><td class=\"text-center\">{{clienteCaracteristica.codigo}}</td><td class=\"text-center\">\n{{clienteCaracteristica.nomeFantasia}}</td></tr></tbody></table></div></md-content>");
$templateCache.put("app/main/geral/indicadores/gestao-iaguas/dialogs/informativo-gestao-iaguas-dialog/views/informativo-gestao-iaguas-dialog.html","<md-dialog id=\"informativo-gestao-iaguas-dialog\" class=\"dialogo-padrao\" aria-label=\"Dialog\"><form name=\"vm.form\" \nclass=\"md-inline-form\" novalidate><md-toolbar class=\"md-accent md-tall\" layout=\"column\"><div \nclass=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\">\nInformações</span><md-button class=\"md-icon-button\" ng-click=\"vm.metodosDialog.fecharDialog()\" \naria-label=\"Fechar dialog\" translate-attr-aria-label=\"Fechar dialog\"><md-icon md-font-icon=\"icon-close\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content layout=\"column\" flex><fieldset class=\"standard\" flex><legend \nclass=\"grp-legend\">Usuários logados</legend><div layout-gt-sm=\"row\"><h3>\nQuantitativo de logins por ligação independente do número de equipamentos utilizados para acessar o aplicativo.</h3>\n</div></fieldset><fieldset class=\"standard\" flex><legend class=\"grp-legend\">Equipamentos logados</legend><div \nlayout-gt-sm=\"row\"><h3>\nQuantitativo de equipamentos logados, independente da ligação. Por exemplo, se em uma casa com 5 moradores, todos logarem no aplicativo pelos seus respectivos smartphones, no campo de usuários logados o valor será 1, porém no campo de equipamentos logados o valor será 5, pois uma ligação logou em 5 equipamentos diferentes.\n</h3></div></fieldset><fieldset class=\"standard\" flex><legend class=\"grp-legend\">iOS e Android</legend><div \nlayout-gt-sm=\"row\"><h3>Estas colunas e seus respectivos percentuais, são baseados no número de equipamentos logados.\n</h3></div></fieldset><fieldset class=\"standard\" flex><legend class=\"grp-legend\">Totalizadores percentuais</legend><div\n layout-gt-sm=\"row\"><h3>\nOs valores percentuais totais são determinados com base nos totais de seus cálculos correspondentes.</h3></div>\n</fieldset></md-dialog-content></form></md-dialog>");
$templateCache.put("app/main/gerenciamento-custo/processamento/analise-custo/views/dialogs/analise-custo-conclusao-dialog/analise-custo-conclusao-dialog.html","<md-dialog id=\"analise-custo-conclusao-dialog\" class=\"dialogo-padrao\" aria-label=\"Dialog\"><md-toolbar \nclass=\"md-accent md-tall\" layout=\"column\" flex><div class=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" \nlayout-align=\"space-between center\" flex><span class=\"title\">Conclusão de projetos</span><md-button \nclass=\"md-icon-button\" aria-label=\"Fechar dialog\" translate-attr-aria-label=\"Fechar dialog\" \nng-click=\"vm.metodos.fecharDialog()\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar>\n<md-dialog-content><div layout-gt-xs=\"column\" flex><md-input-container class=\"md-block container-projetos\" flex><label>\nProjetos</label><md-select name=\"projetos\" md-on-open=\"vm.metodos.configuraMdSelectProjeto()\" ng-model=\"vm.projeto\" \nng-change=\"vm.metodos.calcularSaldoProjeto()\"><md-select-header ng-if=\"vm.projetos.length > 0\"><input \nid=\"analise-custo-conclusao-projetos-md-select\" class=\"md-text\" type=\"search\" placeholder=\"Pesquisar projetos\" \nng-model=\"vm.filtrarProjetos\"></md-select-header><md-option ng-value=\"projeto\" \nng-repeat=\"projeto in vm.projetos | filter:vm.filtrarProjetos track by $index\">{{ projeto.projeto }}</md-option>\n</md-select></md-input-container><fieldset class=\"standard pb-0 pt-0\"><legend class=\"grp-legend\">Dados do projeto <i \nclass=\"icon-information-outline s20 icone-cor-padrao\"><md-tooltip class=\"tooltip-multiline-conclusao-projeto\">\nO custo total de um projeto é calculado com base no valor do ponto e como esse valor pode sofrer alterações durante o projeto, é possível ter uma pontuação com valores diferentes, portanto, o cálculo é realizado considerado todos eles.\n</md-tooltip></i></legend><div layout-gt-sm=\"column\" flex><div layout=\"row\" flex><md-input-container class=\"mt-0 mb-0\" \nflex><p><strong>Custo total do projeto: </strong>{{ vm.projeto.valorCusto | currency:\"R$ \" }}</p></md-input-container>\n</div><div layout=\"row\" flex><md-input-container class=\"md-block mb-0\" flex><label \ntranslate=\"FATURAMENTO_SOFTWARE.VALOR_PAGO\"></label><input type=\"text\" name=\"valorPago\" ui-money-mask \nmascara-tamanho-campo=\"12\" ng-model=\"vm.projeto.valorPago\" ng-change=\"vm.metodos.calcularSaldoProjeto()\" \nng-disabled=\"vm.emProgresso\"></md-input-container></div><div layout-gt-sm=\"row\" flex><md-input-container \nclass=\"mt-0 mb-0\" flex><p><strong>Período: </strong>\n{{ vm.projeto.dataInicialString }} à {{ vm.projeto.dataFinalString }}</p><p><strong>Total de histórias:</strong>\n {{ vm.projeto.totalHistorias }}</p><p><strong>Total de pontos:</strong> {{ vm.projeto.totalPontos }}</p><p \nng-class=\"{\'saldo-positivo\': vm.projeto.saldo > 0, \'saldo-negativo\': vm.projeto.saldo < 0}\"><strong>Resultado: \n</strong>{{ vm.projeto.saldo | currency:\"R$ \" }}</p></md-input-container></div></div></fieldset><fieldset \nclass=\"standard mt-2\"><legend class=\"grp-legend\">Conclusão</legend><md-input-container class=\"md-block mt-0 mb-0\">\n<md-checkbox ng-model=\"vm.projeto.encerrado\" ng-disabled=\"false\"><span \ntranslate=\"FATURAMENTO_SOFTWARE.ENCERRAR_PROJETO\">Encerrar projeto</span></md-checkbox></md-input-container></fieldset>\n<div layout=\"row\" layout-align=\"center center\" flex><md-button class=\"send-button md-accent md-raised mt-3\" \ntype=\"submit\" aria-label=\"SALVAR\" translate=\"FATURAMENTO_SOFTWARE.SALVAR\" \ntranslate-attr-aria-label=\"FATURAMENTO_SOFTWARE.SALVAR\" ng-disabled=\"vm.emProgresso\" \nng-click=\"vm.metodos.salvar($event)\" flex>Salvar</md-button></div></div></md-dialog-content></md-dialog>");
$templateCache.put("app/main/gerenciamento-custo/processamento/analise-custo/views/dialogs/analise-custo-dashboard-dialog/analise-custo-dashboard-dialog.html","<md-dialog id=\"analise-custo-dashboard-dialog\" class=\"dialogo-padrao\" aria-label=\"Dialog\"><md-toolbar \nclass=\"md-accent md-tall\" layout=\"column\" flex><div class=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" \nlayout-align=\"space-between center\" flex><span class=\"title\">Dashboard</span><md-button class=\"md-icon-button\" \naria-label=\"Fechar dialog\" translate-attr-aria-label=\"Fechar dialog\" ng-click=\"vm.metodos.fecharDialog()\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content class=\"grid-container\"><div \nlayout=\"column\" flex=\"100\"><div ng-if=\"vm.dadosDashboard.concluido.anos.length > 0\" flex=\"100\"><fieldset \nclass=\"standard\" layout=\"column\" layout-align=\"space-between center\" flex=\"100\"><legend class=\"grp-legend\">Concluído <i\n class=\"icon-information-outline s20 icone-cor-padrao\"><md-tooltip class=\"tooltip-multiline-textos\">\nHistórias que foram homologadas</md-tooltip></i></legend><div class=\"container-carousel\"><div \nclass=\"container-slide-carousel carousel-concluido\" \nng-class=\"{\'centralizado\':vm.dadosDashboard.concluido.anos.length <=2}\"><md-card \nng-repeat=\"detalheAno in vm.dadosDashboard.concluido.anos\" class=\"card-informacoes\" flex=\"25\"><md-card-header><div \nclass=\"card-informacoes-cabecalho\" layout=\"row\" layout-align=\"center center\" flex><span class=\"textos-span\">\n{{ detalheAno.ano }} - <span>Valor por ponto<md-tooltip class=\"tooltip-multiline\"><span \nng-repeat=\"detalhe in detalheAno.detalhamentoValoresPorAno\">{{ detalhe }}<br><br></span></md-tooltip></span></span>\n</div><div class=\"card-informacoes-corpo\"><div layout=\"row\" layout-align=\"center center\" flex><span \nclass=\"textos-span\">\nPont.: {{ vm.metodos.tratarValorNulo(detalheAno.totalPontosPorAno) }} Hist.: {{ vm.metodos.tratarValorNulo(detalheAno.totalHistorias) }}\n</span></div><hr class=\"solid\"><md-card-header-text layout=\"row\"><div layout=\"row\" layout-align=\"center center\" \nflex=\"100\"><span class=\"concluido\">{{ vm.metodos.tratarValorNulo(detalheAno.valorTotalCustoPorAno) | currency:\"R$ \" }}\n</span></div></md-card-header-text></div></md-card-header></md-card></div></div><div class=\"text-center\"><md-button \nclass=\"md-fab md-toolbar s20 btn-anterior\" \nng-click=\"vm.metodos.itemAnterior(vm.dadosDashboard.concluido.anos.length, vm.posicaoConcluidos, \'.carousel-concluido\')\" \nng-disabled=\"vm.desativarBotaoAnteriorConcluidos\"><md-icon md-font-icon=\"icon-arrow-left\"></md-icon><md-tooltip><label>\nAnterior</label></md-tooltip></md-button><md-button class=\"md-fab md-toolbar s20 btn-proximo\" \nng-click=\"vm.metodos.proximoItem(vm.dadosDashboard.concluido.anos.length, vm.posicaoConcluidos, \'.carousel-concluido\')\" \nng-disabled=\"vm.desativarBotaoProximoConcluidos || vm.dadosDashboard.concluido.anos.length <= 3\"><md-icon \nmd-font-icon=\"icon-arrow-right\"></md-icon><md-tooltip><label>Próximo</label></md-tooltip></md-button></div></fieldset>\n</div><div ng-if=\"vm.dadosDashboard.andamento.anos.length > 0\" flex=\"100\"><fieldset class=\"standard\" layout=\"column\" \nlayout-align=\"space-between center\" flex=\"100\"><legend class=\"grp-legend\">Em andamento <i \nclass=\"icon-information-outline s20 icone-cor-padrao\"><md-tooltip class=\"tooltip-multiline-textos\">\nHistórias que estão em desenvolvimento, retornadas, liberadas para teste e em pausa</md-tooltip></i></legend><div \nclass=\"container-carousel\"><div class=\"container-slide-carousel carousel-andamento\" \nng-class=\"{\'centralizado\':vm.dadosDashboard.andamento.anos.length <=2}\"><md-card \nng-repeat=\"detalheAno in vm.dadosDashboard.andamento.anos\" class=\"card-informacoes\" flex=\"25\"><md-card-header><div \nclass=\"card-informacoes-cabecalho\" layout=\"row\" layout-align=\"center center\" flex><span class=\"textos-span\">\n{{ detalheAno.ano }} - <span>Valor por ponto<md-tooltip class=\"tooltip-multiline\"><span \nng-repeat=\"detalhe in detalheAno.detalhamentoValoresPorAno\">{{ detalhe }}<br><br></span></md-tooltip></span></span>\n</div><div class=\"card-informacoes-corpo\"><div layout=\"row\" layout-align=\"center center\" flex><span \nclass=\"textos-span\">\nPont.: {{ vm.metodos.tratarValorNulo(detalheAno.totalPontosPorAno) }} Hist.: {{ vm.metodos.tratarValorNulo(detalheAno.totalHistorias) }}\n</span></div><hr class=\"solid\"><md-card-header-text layout=\"row\"><div layout=\"row\" layout-align=\"center center\" \nflex=\"100\"><span class=\"concluido\">{{ vm.metodos.tratarValorNulo(detalheAno.valorTotalCustoPorAno) | currency:\"R$ \" }}\n</span></div></md-card-header-text></div></md-card-header></md-card></div></div><div class=\"text-center\"><md-button \nclass=\"md-fab md-toolbar s20 btn-anterior\" \nng-click=\"vm.metodos.itemAnterior(vm.dadosDashboard.andamento.anos.length, vm.posicaoAndamento, \'.carousel-andamento\')\" \nng-disabled=\"vm.desativarBotaoAnteriorAndamento\"><md-icon md-font-icon=\"icon-arrow-left\"></md-icon><md-tooltip><label>\nAnterior</label></md-tooltip></md-button><md-button class=\"md-fab md-toolbar s20 btn-proximo\" \nng-click=\"vm.metodos.proximoItem(vm.dadosDashboard.andamento.anos.length, vm.posicaoAndamento, \'.carousel-andamento\')\" \nng-disabled=\"vm.desativarBotaoProximoAndamento || vm.dadosDashboard.andamento.anos.length <= 3\"><md-icon \nmd-font-icon=\"icon-arrow-right\"></md-icon><md-tooltip><label>Próximo</label></md-tooltip></md-button></div></fieldset>\n</div><div ng-if=\"vm.dadosDashboard.aguardando.anos.length > 0\" flex=\"100\"><fieldset class=\"standard\" layout=\"column\" \nlayout-align=\"space-between center\" flex=\"100\"><legend class=\"grp-legend\">Aguardando <i \nclass=\"icon-information-outline s20 icone-cor-padrao\"><md-tooltip class=\"tooltip-multiline-textos\">\nHistórias que estão solicitadas, refinadas, estimadas e em análise</md-tooltip></i></legend><div layout-gt-sm=\"row\">\n<div class=\"container-carousel\"><div class=\"container-slide-carousel carousel-aguardando\" \nng-class=\"{\'centralizado\':vm.dadosDashboard.aguardando.anos.length <=2}\"><md-card \nng-repeat=\"detalheAno in vm.dadosDashboard.aguardando.anos\" class=\"card-informacoes\" aguardando flex=\"25\">\n<md-card-header><div class=\"card-informacoes-cabecalho\" layout=\"row\" layout-align=\"center center\" flex><span \nclass=\"textos-span\">{{ detalheAno.ano }} - <span>Valor por ponto<md-tooltip class=\"tooltip-multiline\"><span \nng-repeat=\"detalhe in detalheAno.detalhamentoValoresPorAno\">{{ detalhe }}<br><br></span></md-tooltip></span></span>\n</div><div class=\"card-informacoes-corpo\"><div layout=\"row\" layout-align=\"center center\" flex><span \nclass=\"textos-span\">\nPont.: {{ vm.metodos.tratarValorNulo(detalheAno.totalPontosPorAno) }} Hist.: {{ vm.metodos.tratarValorNulo(detalheAno.totalHistorias) }}\n</span></div><hr class=\"solid\"><md-card-header-text layout=\"row\"><div layout=\"row\" layout-align=\"center center\" \nflex=\"100\"><span class=\"concluido\">{{ vm.metodos.tratarValorNulo(detalheAno.valorTotalCustoPorAno) | currency:\"R$ \" }}\n</span></div></md-card-header-text></div></md-card-header></md-card></div></div></div><div class=\"text-center\">\n<md-button class=\"md-fab md-toolbar s20 btn-anterior\" \nng-click=\"vm.metodos.itemAnterior(vm.dadosDashboard.aguardando.anos.length, vm.posicaoAguardando, \'.carousel-aguardando\')\" \nng-disabled=\"vm.desativarBotaoAnteriorAguardando\"><md-icon md-font-icon=\"icon-arrow-left\"></md-icon><md-tooltip><label>\nAnterior</label></md-tooltip></md-button><md-button class=\"md-fab md-toolbar s20 btn-proximo\" \nng-click=\"vm.metodos.proximoItem(vm.dadosDashboard.aguardando.anos.length, vm.posicaoAguardando, \'.carousel-aguardando\')\" \nng-disabled=\"vm.desativarBotaoProximoAguardando || vm.dadosDashboard.aguardando.anos.length <= 3\"><md-icon \nmd-font-icon=\"icon-arrow-right\"></md-icon><md-tooltip><label>Próximo</label></md-tooltip></md-button></div></fieldset>\n</div></div><div class=\"container-lateral\" layout=\"column\"><fieldset class=\"standard\" layout=\"column\" \nlayout-align=\"space-around center\" flex><div layout-gt-sm=\"row\" ng-if=\"vm.dadosDashboard.concluido.anos.length > 0\">\n<md-card class=\"card-informacoes\" flex><md-card-header><div class=\"card-informacoes-corpo\"><div layout=\"row\" \nlayout-align=\"center center\" flex><span class=\"titulo-card-total\">Custo total concluído</span></div><hr class=\"solid\">\n<md-card-header-text layout=\"row\"><div layout=\"row\" layout-align=\"center center\" flex=\"100\"><span class=\"concluido\">\n{{ vm.metodos.tratarValorNulo(vm.dadosDashboard.concluido.valorTotalCustoPorAno) | currency:\"R$ \" }}</span></div>\n</md-card-header-text></div></md-card-header></md-card></div><div layout-gt-sm=\"row\" \nng-if=\"vm.dadosDashboard.andamento.anos.length > 0\"><md-card class=\"card-informacoes\" flex><md-card-header><div \nclass=\"card-informacoes-corpo\"><div layout=\"row\" layout-align=\"center center\" flex><span class=\"titulo-card-total\">\nCusto total em andamento</span></div><hr class=\"solid\"><md-card-header-text layout=\"row\"><div layout=\"row\" \nlayout-align=\"center center\" flex=\"100\"><span class=\"andamento\">\n{{ vm.metodos.tratarValorNulo(vm.dadosDashboard.andamento.valorTotalCustoPorAno) | currency:\"R$ \" }}</span></div>\n</md-card-header-text></div></md-card-header></md-card></div><div layout-gt-sm=\"row\" \nng-if=\"vm.dadosDashboard.aguardando.anos.length > 0\"><md-card class=\"card-informacoes\" flex><md-card-header><div \nclass=\"card-informacoes-corpo\"><div layout=\"row\" layout-align=\"center center\" flex><span class=\"titulo-card-total\">\nCusto total aguardando</span></div><hr class=\"solid\"><md-card-header-text layout=\"row\"><div layout=\"row\" \nlayout-align=\"center center\" flex=\"100\"><span class=\"aguardando\">\n{{ vm.metodos.tratarValorNulo(vm.dadosDashboard.aguardando.valorTotalCustoPorAno) | currency:\"R$ \" }}</span></div>\n</md-card-header-text></div></md-card-header></md-card></div><div layout-gt-sm=\"row\"><md-card class=\"card-informacoes\" \nflex><md-card-header><div class=\"card-informacoes-corpo\"><div layout=\"row\" layout-align=\"center center\" flex><span \nclass=\"titulo-card-total\">Custo total do(s) projeto(s)</span></div><hr class=\"solid\"><md-card-header-text layout=\"row\">\n<div layout=\"row\" layout-align=\"center center\" flex=\"100\"><span class=\"concluido\">\n{{ vm.metodos.tratarValorNulo(vm.dadosDashboard.custoTotal) | currency:\"R$ \" }}</span></div></md-card-header-text>\n</div></md-card-header></md-card></div></fieldset></div></md-dialog-content></md-dialog>");
$templateCache.put("app/main/geral/indicadores/gestao-iaguas/sidenavs/filtro/views/filtro-gestao-iaguas.html","<div id=\"filtro-gestao-iaguas\"><md-toolbar class=\"toolbar md-accent\"><h1 class=\"md-toolbar-tools\">Filtro</h1>\n</md-toolbar><form name=\"vm.form\"><md-content layout-padding flex><fieldset><legend class=\"grp-legend\">Data</legend>\n<div flex layout=\"column\" flex-align=\"center center\"><md-radio-group class=\"p-10\" ng-model=\"vm.filtro.tipoFiltro\" flex \nlayout=\"row\" layout-align=\"start center\"><md-radio-button value=\"1\" aria-label=\"Geral\">Geral</md-radio-button>\n<md-radio-button value=\"2\" aria-label=\"Período\">Período</md-radio-button></md-radio-group><div flex layout=\"column\" \nng-if=\"vm.filtro.tipoFiltro == 2\"><div flex=\"100\"><md-input-container><label>Data inicial</label><md-datepicker \nname=\"dataInicio\" md-open-on-focus md-max-date=\"vm.filtro.dataFim\" ng-mask=\"3?9/1?9/9999\" \nng-model=\"vm.filtro.dataInicio\" ng-disabled=\"vm.emProgresso\" ng-required=\"true\"></md-datepicker><div \nng-messages=\"vm.form.dataInicio.$error\"><div ng-message=\"valid\" translate=\"MENSAGEM_VALIDACAO.DATA_INVALIDA\"></div><div\n ng-message=\"required\" translate=\"MENSAGEM_VALIDACAO.DATA_OBRIGATORIA\"></div><div ng-message=\"maxdate\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_DATA_INICIAL\"></div></div></md-input-container></div><div flex=\"100\">\n<md-input-container class=\"md-block\"><label>Data final</label><md-datepicker name=\"dataFim\" md-open-on-focus \nmd-min-date=\"vm.filtro.dataInicio\" ng-required=\"true\" ng-model=\"vm.filtro.dataFim\" ng-mask=\"3?9/1?9/9999\">\n</md-datepicker><div ng-messages=\"vm.form.dataFim.$error\"><div ng-message=\"valid\" \ntranslate=\"MENSAGEM_VALIDACAO.DATA_INVALIDA\"></div><div ng-message=\"mindate\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_DATA_FINAL\"></div><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.DATA_OBRIGATORIA\"></div><div ng-message=\"maxdate\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_DATA_INICIAL\"></div></div></md-input-container></div></div></div></fieldset>\n<fieldset><legend class=\"grp-legend\">Clientes</legend><multi-select-directive id=\"select-clientes\" \nform-name=\"clientes\" data=\"vm.clientes\" model=\"vm.filtro.clientes\" obrigatorio=\"true\" descricao-exibicao=\"nome\" \ntexto-pesquisa-placeholder=\"Procurar cliente...\" texto-placeholder=\"Clientes\" \ndisabled=\"!vm.clientes || !vm.clientes.length\" flex></multi-select-directive></fieldset><div class=\"text-center\">\n<md-button class=\"md-raised md-accent\" ng-disabled=\"vm.form.$invalid\" ng-click=\"vm.metodos.filtrarDados()\">Filtrar\n</md-button></div></md-content></form></div>");
$templateCache.put("app/main/locacao/consulta/historico/views/dialogs/dialog-estado-conservacao/dialog-estado-conservacao.html","<form name=\"vm.form\" style=\"min-width: 20%; max-width: 80%\"><md-dialog style=\"max-width: 100%\"><md-toolbar><div \nclass=\"md-toolbar-tools\" style=\"background-color: #039BE5\"><h2 ng-if=\"!vm.apenasFoto\">\nEstado de conservação - Nº Série: {{vm.detalhe.numeroSerie}}</h2><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"vm.metodos.cancel()\" aria-label=\"Fechar dialog\" translate translate-attr-aria-label=\"CLIENTE.FECHAR_DIALOG\">\n<md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content><div layout=\"column\" \nflex style=\"padding: 1%\"><md-input-container class=\"md-block\" flex=\"20\" ng-if=\"!vm.apenasFoto\"><label>Conservação:\n</label><md-select ng-model=\"vm.conservacao\"><md-option layout=\"row\" \nng-repeat=\"item in vm.equipamentoEstadoConservacao\" ng-value=\"item.id\" name=\"conservacao\" ng-required=\"true\">\n{{ item.descricao }}</md-option></md-select></md-input-container></div><div style=\"text-align: center\" class=\"mt-8\">\n<md-button class=\"md-accent md-raised md-hue-2 header-boards-button\" layout-align=\"center center\" \nng-disabled=\"vm.desabilitarButtonSalvar\" ng-click=\"vm.metodos.editarEstadoDeConservacao($event, vm.conservacao)\"><span>\nSalvar</span></md-button></div></md-dialog-content></md-dialog></form>");
$templateCache.put("app/main/locacao/consulta/historico/views/dialogs/dialog-foto/dialog-foto.html","<form name=\"vm.form\" style=\"max-width: 85%; width: 85%\" id=\"historico-detalhe\"><md-dialog style=\"max-width: 100%\">\n<md-toolbar><div class=\"md-toolbar-tools\" style=\"background-color: #039BE5\"><h2>\nFotos - {{vm.detalhe.equipamentoDescricao}} - N° Série: {{vm.detalhe.numeroSerie}} - IMEI: {{vm.detalhe.imei}}</h2>\n<span flex></span><md-button class=\"md-icon-button\" ng-click=\"vm.metodos.cancel()\" aria-label=\"Fechar dialog\" \ntranslate translate-attr-aria-label=\"CLIENTE.FECHAR_DIALOG\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button>\n</div></md-toolbar><div layout=\"column\" flex ng-if=\" vm.pesquisando\" layout-align=\"center center\"><md-progress-circular\n class=\"md-accent\" md-mode=\"indeterminate\"></md-progress-circular></div><md-dialog-content><div layout=\"row\" \nlayout-xs=\"column\" flex style=\"justify-content: space-around\" ng-if=\"!vm.pesquisando\" layout-wrap><div layout=\"column\" \nng-repeat=\"item in vm.foto track by $index\" flex-gt-sm=\"40\"><md-checkbox aria-label=\"Selecionado\" \nng-model=\"item.selecionado\" ng-if=\"vm.exibeBotoes\" layout=\"row\" layout-align=\"start center\" flex></md-checkbox><img \nclass=\"tamanho-foto\" ng-src=\"{{item.caminhoFoto}}\" ng-click=\"vm.metodos.zoomFoto(item.caminhoFoto)\"> <span \nclass=\"text-center md-accent\" style=\"color: #09a7f3;font-size: x-large\">{{$index + 1}}</span></div><div flex \nlayout=\"row\" ng-if=\"vm.foto.length <= 0\" layout-align=\"center center\"><h2>Este histórico não possui fotos</h2></div>\n</div><div class=\"layout-align-end-center layout-row flex\" ng-if=\"vm.exibeBotoes\" layout=\"row\" \nlayout-align=\"end center\" flex><input id=\"inputFotos\" type=\"file\" name=\"fotosHistorico\" accept=\"image/jpeg, image/png\" \nim-file-change=\"vm.metodos.selecionarArquivoFotos($event, arquivos)\" multiple=\"multiple\" hidden><md-button \nclass=\"md-fab md-raised md-mini md-accent\" aria-label=\"Inserir\" ng-click=\"vm.metodos.inputFoto()\"><md-icon \nmd-font-icon=\"icon-camera s26\"></md-icon></md-button><md-button class=\"md-fab md-raised md-mini md-accent\" \naria-label=\"Excluir\" ng-click=\"vm.metodos.excluirFotos()\" ng-disabled=\"!vm.metodos.existeFotoSelecionada()\"><md-icon \nmd-font-icon=\"icon-delete s26\"></md-icon></md-button></div></md-dialog-content></md-dialog></form>");
$templateCache.put("app/main/locacao/processamento/locacao/envio/step/contrato/contrato-step.html","<form name=\"vm.locacao-envio-form\" novalidate><div layout-gt-sm=\"row\" flex><div layout=\"column\" flex-gt-sm=\"50\">\n<md-autocomplete flex-gt-sm=\"30\" flex-gt-xs md-input-name=\"cliente\" md-no-cache=\"true\" \nng-blur=\"vm.metodos.configuraAutoCompleteClienteOnBlur()\" md-selected-item=\"vm.cliente\" \nmd-selected-item-change=\"vm.metodos.alterarItemSelecionadoAutoCompleteCliente(item)\" \nmd-search-text=\"vm.textoDePesquisaAutoCompleteCliente\" \nmd-items=\"item in vm.metodos.pesquisarAutoCompleteCliente(vm.textoDePesquisaAutoCompleteCliente)\" \nmd-item-text=\"item.nome\" md-autoselect md-floating-label=\"Cliente\" required><md-item-template><span \nmd-highlight-text=\"vm.textoDePesquisaAutoCompleteCliente\">{{item.nome}}</span></md-item-template><md-not-found><label>\nNão foi encontrado nenhum Cliente.</label></md-not-found></md-autocomplete></div><div layout=\"column\" \nflex-offset-gt-sm=\"5\" flex-gt-sm=\"50\"></div></div></form>");
$templateCache.put("app/main/locacao/processamento/locacao/envio/step/envio/envio-step.html","<div flex layout=\"column\" layout-xs=\"column\"><div layout=\"row\" flex-gt-sm=\"50\" flex=\"100\"><md-input-container \nclass=\"md-block\" flex=\"40\"><label translate=\"\">Tipo de contrato</label><md-select name=\"contrato\" \nng-model=\"vm.contrato\" ng-disabled=\"vm.filtro.cliente == null\" ng-required=\"vm.filtro.cliente != null\"><md-option \nng-value=\"contrato\" ng-repeat=\"contrato in vm.contratos\">{{ contrato.contratoTipo.descricao }}</md-option></md-select>\n</md-input-container><md-input-container class=\"md-block\" flex=\"40\"><label translate=\"\">Item do contrato</label>\n<md-select name=\"contratoItens\" ng-model=\"vm.contratoItem\" ng-disabled=\"vm.contrato == null\" ng-required=\"true\" \nng-change=\"vm.metodos.listarLocados()\"><md-option ng-value=\"contratoItens\" \nng-repeat=\"contratoItens in vm.contrato.contratoItens\">{{ contratoItens.produto.descricao }}</md-option></md-select>\n</md-input-container></div><div layout=\"row\" ng-if=\"vm.contrato != undefined && vm.contratoItem != undefined\" \nflex=\"50\"><md-input-container class=\"md-block\" flex=\"40\"><label>Tipo de locação</label><md-select \nng-model=\"vm.filtro.retornoContratos.tipoLocacao\" ng-required=\"true\"><md-option layout=\"row\" \nng-repeat=\"item in vm.tipoLocacao\" ng-value=\"item\" name=\"tipoLocacaoId\">{{ item.descricao }}</md-option></md-select>\n</md-input-container></div><div layout=\"row\"><md-input-container class=\"md-block\"><label>Data inicial</label>\n<md-datepicker ng-model=\"vm.filtro.retornoContratos.dataInicioLocacao\" name=\"inicialData\" ng-mask=\"3?9/1?9/9999\" \ndisabled=\"disabled\" md-max-date=\"\"></md-datepicker></md-input-container><md-input-container class=\"md-block\"><label>\nData final</label><md-datepicker ng-model=\"vm.filtro.retornoContratos.dataFinalLocacao\" name=\"finalData\" \nng-mask=\"3?9/1?9/9999\" disabled=\"disabled\" md-max-date=\"\"></md-datepicker></md-input-container></div></div>");
$templateCache.put("app/main/locacao/processamento/nota/views/dialogs/dialog-foto/dialog-foto-nota.html","<form name=\"vm.form\" style=\"min-width: 20%; max-width: 80%\"><md-dialog style=\"max-width: 100%\"><md-toolbar><div \nclass=\"md-toolbar-tools\" style=\"background-color: #039BE5\"><h2>Foto</h2><span flex></span><md-button \nclass=\"md-icon-button\" ng-click=\"vm.metodos.cancel()\" aria-label=\"Fechar dialog\" translate \ntranslate-attr-aria-label=\"CLIENTE.FECHAR_DIALOG\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div>\n</md-toolbar><div layout=\"column\" flex style=\"padding: 1%\"><input ng-if=\"!vm.editando && !vm.apenasVisualizacao\" \nid=\"inputFoto\" hidden type=\"file\" im-file-change=\"vm.metodos.selecionarArquivoFotoDivulgacao($event, arquivos)\" \nname=\"fotoDivulgacao\" accept=\"image/jpeg, image/png\" multiple=\"multiple\" style=\"max-width: 100%;align-self: center\">\n<md-button ng-click=\"vm.metodos.inputFoto()\" style=\"max-width: 250px;align-self: center; background-color: #039BE5\" \nclass=\"md-accent md-raised md-hue-2 header-boards-button\" ng-if=\"!vm.editando && !vm.apenasVisualizacao\"><i \nclass=\"icon-folder s24\"></i> Selecionar</md-button><fieldset class=\"standard\" flex \nstyle=\"width: 90%;align-self: center\" ng-if=\"!vm.carregandoFotos\" layout=\"row\" flex-wrap><legend class=\"grp-legend\" \ntranslate=\"Fotos\"></legend><div layout=\"row\" flex style=\"justify-content: space-around\"><div layout=\"column\" \nng-repeat=\"foto in vm.fotos track by $index\" flex><img ng-if=\"vm.editando || vm.apenasVisualizacao\" \nng-src=\"{{foto.caminhoFoto}}\" style=\"width: 235;height: 250px\" ng-click=\"vm.metodos.zoomFoto(foto.caminhoFoto)\"> <img \nng-if=\"!vm.editando && !vm.apenasVisualizacao\" src=\"data:image/jpg;base64,{{foto}}\" style=\"width: 235;height: 250px\" \nng-click=\"vm.metodos.zoomFoto(foto)\"> <i ng-if=\"!vm.editando && !vm.apenasVisualizacao\" \nclass=\"icon-delete icone-cor-padrao\" style=\"align-self: center\" ng-click=\"vm.metodos.excluirFoto($index,foto)\">\n<md-tooltip>Remover foto</md-tooltip></i></div></div></fieldset></div><div style=\"text-align: center\" class=\"mt-8\">\n<md-button class=\"md-accent md-raised md-hue-2 header-boards-button\" layout-align=\"center center\" \nng-disabled=\"vm.desabilitarButtonSalvar || (vm.fotos.length < 2 && vm.obrigaFoto)\" \nng-click=\"vm.metodos.dialog(vm.fotos, item)\" ng-if=\"!vm.editando && !vm.apenasVisualizacao\"><span>Salvar</span>\n</md-button></div><h5 style=\"color: red; text-align: center\" ng-if=\"vm.fotos.length < 2 && vm.obrigaFoto\">\nÉ necessário informar pelo menos 2 fotos</h5></md-dialog></form>");
$templateCache.put("app/main/locacao/processamento/nota/views/dialogs/dialog-item/dialog-item.html","<md-dialog id=\"dialogNota\" aria-label=\"iTEM\" class=\"dialog-nota-item\"><form name=\"vm.form.notaItem\" \nclass=\"md-inline-form\" novalidate><md-toolbar><div class=\"md-toolbar-tools\" style=\"background-color: #039BE5\"><h2>Item\n</h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"vm.metodos.cancel()\" aria-label=\"Fechar dialog\" \ntranslate translate-attr-aria-label=\"CLIENTE.FECHAR_DIALOG\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button>\n</div></md-toolbar><md-dialog-content layout=\"column\"><div layout=\"row\" style=\"justify-content: center\"><md-card flex \nclass=\"blue-bg white-fg\" md-theme-watch style=\"max-width: 31%\"><md-card-title style=\"padding: 0px\"><md-card-title-text>\n<span class=\"blue-bg white-fg texto-card-filtro\">NF: {{ vm.notaVinculada.numeroNota }}</span></md-card-title-text>\n</md-card-title></md-card></div><div layout=\"row\" layout-xs=\"column\" style=\"margin-top: 15px\"><md-input-container \nclass=\"md-block\" flex=\"15\" flex-xs=\"100\"><label>Quantidade</label><input name=\"quantidade\" type=\"text\" \nng-model=\"vm.notaItem.quantidade\" mascara-numero-generica=\"####\" ng-required=\"true\" \nng-disabled=\"vm.apenasVisualizacao\"><div ng-messages=\"vm.form.notaItem.quantidade.$error\"><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.QUANTIDADE_NAO_INFORMADA\"></div></div></md-input-container><md-input-container \nclass=\"md-block margem-cell\"><label>Garantia (Meses)</label><input name=\"garantia\" type=\"text\" \nng-model=\"vm.notaItem.garantia\" mascara-numero-generica=\"###\" ng-required=\"true\" ng-disabled=\"vm.apenasVisualizacao\">\n<div ng-messages=\"vm.form.notaItem.garantia.$error\"><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.GARANTIA_NAO_INFORMADA\"></div></div></md-input-container><md-input-container \nclass=\"margem-cell\"><label>Preço total (R$)</label><input name=\"preco\" type=\"text\" maxlength=\"22\" ng-required=\"true\" \nng-model=\"vm.notaItem.preco\" ui-money-mask ng-disabled=\"vm.apenasVisualizacao\"><div \nng-messages=\"vm.form.notaItem.preco.$error\"><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container><md-input-container \nclass=\"md-block margem-cell\" flex=\"30\" flex-xs=\"100\"><label>Equipamento</label><md-select name=\"equipamento\" \nng-disabled=\"vm.apenasVisualizacao\" ng-model=\"vm.notaItem.equipamentoId\" ng-required=\"true\"><md-option \nng-repeat=\"equipamento in vm.equipamentos\" ng-value=\"equipamento.id\">{{equipamento.descricao}}</md-option></md-select>\n<div ng-messages=\"vm.form.notaItem.equipamento.$error\"><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container></div><div layout=\"column\" \nlayout-gt-sm=\"row\"><md-input-container class=\"md-block\" flex><label translate=\"CLIENTE.OBSERVACOES\"></label><textarea \nng-model=\"vm.notaItem.observacao\" name=\"observacoes\" md-no-resize=\"true\" rows=\"4\" md-maxlength=\"300\" max-rows=\"4\" \nmaxlength=\"300\" ng-disabled=\"vm.apenasVisualizacao\">\r\n          </textarea></md-input-container></div><div \nlayout=\"row\" style=\"justify-content: space-between\"><div></div><div ng-if=\"!vm.editando\"></div><div layout=\"row\" \nng-if=\"vm.salvando\" flex><div layout=\"row\" layout-align=\"center center\" flex><div layout=\"column\" \nlayout-align=\"center center\"><md-progress-circular md-mode=\"indeterminate\" md-diameter=\"50\" class=\"md-accent\">\n</md-progress-circular></div></div></div><md-button ng-click=\"vm.metodos.salvar(vm.notaItem)\" ng-if=\"!vm.salvando\" \nclass=\"send-button md-accent md-raised\" aria-label=\"Salvar\" translate=\"GROUP_BUTTON_HORIZONTAL.SALVAR\" \nlayout-align=\"end end\" \nng-disabled=\"vm.form.notaItem.$invalid || vm.form.notaItem.$pristine || vm.controladorDialog.requisicaoSolicitada\">\n</md-button></div></md-dialog-content></form></md-dialog>");
$templateCache.put("app/main/locacao/processamento/nota/views/dialogs/dialog-nota/dialog-nota.html","<md-dialog id=\"dialogNota\" aria-label=\"Nota\" class=\"dialog-nota\"><form name=\"vm.form.nota\" class=\"md-inline-form\" \nnovalidate><md-toolbar><div class=\"md-toolbar-tools\" style=\"background-color: #039BE5\"><h2>Nota</h2><span flex></span>\n<md-button class=\"md-icon-button\" ng-click=\"vm.metodos.cancel()\" aria-label=\"Fechar dialog\" translate \ntranslate-attr-aria-label=\"CLIENTE.FECHAR_DIALOG\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content layout=\"column\"><div layout=\"column\" layout-gt-sm=\"row\"><md-input-container><label \ntranslate=\"Entrada\"></label><md-datepicker ng-model=\"vm.nota.dataNotaEntrada\" name=\"notaDataEntrada\" \nng-mask=\"3?9/1?9/9999\" mascara-conversor-string-para-data ng-required=\"true\" ng-disabled=\"vm.apenasVisualizacao\">\n</md-datepicker><div ng-messages=\"vm.form.nota.notaData.$error\"><div ng-message=\"maxdate\" \ntranslate=\"MENSAGEM_VALIDACAO.DATA_MAIOR_VENCIMENTO\"></div><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container><md-input-container><label \ntranslate=\"Emissão\"></label><md-datepicker ng-model=\"vm.nota.dataNota\" name=\"notaData\" ng-mask=\"3?9/1?9/9999\" \nmascara-conversor-string-para-data ng-required=\"true\" md-max-date=\"vm.nota.dataVencimento\" \nng-disabled=\"vm.apenasVisualizacao\"></md-datepicker><div ng-messages=\"vm.form.nota.notaData.$error\"><div \nng-message=\"maxdate\" translate=\"MENSAGEM_VALIDACAO.DATA_MAIOR_VENCIMENTO\"></div><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container><md-input-container><label \ntranslate=\"Vencimento\"></label><md-datepicker ng-model=\"vm.nota.dataVencimento\" name=\"notaVencimento\" \nmascara-conversor-string-para-data ng-mask=\"3?9/1?9/9999\" md-min-date=\"vm.nota.dataNota\" ng-required=\"true\" \nng-disabled=\"vm.apenasVisualizacao\"></md-datepicker><div ng-messages=\"vm.form.nota.notaVencimento.$error\"><div \nng-message=\"mindate\" translate=\"MENSAGEM_VALIDACAO.DATA_MENOR_EMISSAO\"></div><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container><md-input-container class=\"md-block\" \nflex><label>Número</label><input name=\"numero\" maxlength=\"10\" type=\"text\" ng-model=\"vm.nota.numeroNota\" \nng-required=\"true\" md-maxlength=\"10\" ng-disabled=\"vm.apenasVisualizacao\"><div ng-messages=\"vm.form.nota.numero.$error\">\n<div ng-message=\"required\" translate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container>\n<md-input-container class=\"md-block\" flex><label>Forma de pagamento</label><md-select name=\"formaPagamento\" \nng-model=\"vm.nota.formPagCodigo\" ng-required=\"true\" ng-disabled=\"vm.apenasVisualizacao\"><md-option \nng-repeat=\"forma in vm.formaPagamento\" ng-value=\"forma.codigo\">{{forma.descricao}}</md-option></md-select><div \nng-messages=\"vm.form.nota.formaPagamento.$error\"><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container><md-input-container><label>\nValor Total (R$)</label><input name=\"valorTotal\" type=\"text\" ng-required=\"true\" maxlength=\"22\" \nng-model=\"vm.nota.valorTotalNota\" ui-money-mask ng-disabled=\"vm.apenasVisualizacao\"><div \nng-messages=\"vm.form.nota.valorTotal.$error\"><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container></div><div layout=\"row\" \nlayout-xs=\"column\"><md-input-container class=\"md-block\" flex=\"20\" flex-xs=\"100\"><label>Fornecedor</label><md-select \nname=\"fornecedor\" ng-model=\"vm.nota.equipamentoFornecedorId\" ng-required=\"true\" ng-disabled=\"vm.apenasVisualizacao\">\n<md-option ng-repeat=\"forma in vm.fornecedor\" ng-value=\"forma.id\">{{forma.descricao}}</md-option></md-select><div \nng-messages=\"vm.form.nota.fornecedor.$error\"><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container><md-input-container class=\"md-block\" \nflex=\"20\" flex-xs=\"100\"><label>Objetivo nota</label><md-select name=\"objetivoNota\" ng-model=\"vm.nota.objetivoNotaId\" \nng-required=\"true\" ng-disabled=\"vm.apenasVisualizacao\"><md-option ng-repeat=\"objetivo in vm.objetivoNota\" \nng-value=\"objetivo.id\">{{objetivo.descricao}}</md-option></md-select><div \nng-messages=\"vm.form.nota.objetivoNota.$error\"><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container><md-input-container class=\"md-block\" \nflex><label>Empresa ativo</label><md-select name=\"empresaAtivo\" ng-model=\"vm.nota.empresaAtivoId\" ng-required=\"true\" \nng-disabled=\"vm.apenasVisualizacao\"><md-option ng-repeat=\"empresa in vm.empresaAtivo\" ng-value=\"empresa.id\">\n{{empresa.codigo}} - {{empresa.nome}}</md-option></md-select><div ng-messages=\"vm.form.nota.empresaAtivo.$error\"><div \nng-message=\"required\" translate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container></div><div \nlayout=\"row\"><md-input-container class=\"md-block\" flex><label translate=\"CLIENTE.OBSERVACOES\"></label><textarea \nng-model=\"vm.nota.observacao\" name=\"observacoes\" md-no-resize=\"true\" rows=\"4\" max-rows=\"4\" md-maxlength=\"300\" \nmaxlength=\"300\" ng-disabled=\"vm.apenasVisualizacao\">\r\n          </textarea></md-input-container></div><div \nlayout=\"row\" style=\"justify-content: space-between\" layout-xs=\"column\"><div></div><div layout=\"row\" \nng-if=\"vm.salvando\" flex><div layout=\"row\" layout-align=\"center center\" flex><div layout=\"column\" \nlayout-align=\"center center\"><md-progress-circular md-mode=\"indeterminate\" md-diameter=\"50\" class=\"md-accent\">\n</md-progress-circular></div></div></div><md-button ng-click=\"vm.metodos.salvar(vm.nota)\" \nclass=\"send-button md-accent md-raised\" aria-label=\"Salvar\" translate=\"GROUP_BUTTON_HORIZONTAL.SALVAR\" \nlayout-align=\"end end\" ng-if=\"!vm.apenasVisualizacao && !vm.salvando\" \nng-disabled=\"vm.form.nota.$invalid || vm.form.nota.$pristine || vm.controladorDialog.requisicaoSolicitada\"></md-button>\n</div></md-dialog-content></form></md-dialog>");
$templateCache.put("app/main/locacao/processamento/nota/views/dialogs/dialog-detalhe/dialog-detalhe.html","<md-dialog id=\"dialogNota\" aria-label=\"iTEM\" class=\"dialog-nota-item\"><form name=\"vm.form.detalhe\" \nclass=\"md-inline-form\" novalidate><md-toolbar><div class=\"md-toolbar-tools\" style=\"background-color: #039BE5\"><h2>\nEquipamento</h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"vm.metodos.cancel()\" \naria-label=\"Fechar dialog\" translate translate-attr-aria-label=\"CLIENTE.FECHAR_DIALOG\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content layout=\"column\" \nstyle=\"overflow: scroll; padding: 3%\"><div layout=\"row\" style=\"justify-content: center;max-height: 11%\"><md-card flex \nclass=\"blue-bg white-fg\" md-theme-watch style=\"max-width: 31%\"><md-card-title style=\"padding: 0px\"><md-card-title-text>\n<span class=\"blue-bg white-fg texto-card-filtro\">{{vm.itemVinculado.equipamento.descricao }}</span>\n</md-card-title-text></md-card-title></md-card></div><div layout=\"row\" layout-xs=\"column\" style=\"margin-top: 15px\">\n<md-input-container class=\"md-block\" flex><label>Número série</label><input name=\"numeroSerie\" type=\"text\" \nng-model=\"vm.detalhe.numeroSerie\" maxlength=\"30\" md-maxlength=\"30\" ng-required=\"true\" \nng-disabled=\"vm.apenasVisualizacao\" md-autofocus><div ng-messages=\"vm.form.detalhe.numeroSerie.$error\"><div \nng-message=\"required\" translate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container>\n<md-input-container class=\"md-block\" flex><label>IMEI</label><input name=\"imei\" type=\"text\" ng-model=\"vm.detalhe.imei\" \nmaxlength=\"30\" md-maxlength=\"30\" ng-disabled=\"vm.apenasVisualizacao\"><div ng-messages=\"vm.form.detalhe.imei.$error\">\n<div ng-message=\"required\" translate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container></div><div\n layout=\"row\"><md-input-container flex><label>Preço (R$)</label><input name=\"precoUnitario\" type=\"text\" \nng-required=\"true\" maxlength=\"22\" ng-model=\"vm.detalhe.precoUnitario\" ui-money-mask \nng-disabled=\"vm.apenasVisualizacao\"><div ng-messages=\"vm.form.detalhe.precoUnitario.$error\"><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container><md-input-container class=\"md-block\" \nflex><label>Conservação:</label><md-select ng-model=\"vm.detalhe.equipamentoEstadoConservacaoId\" \nng-disabled=\"vm.apenasVisualizacao || vm.editando\"><md-option layout=\"row\" name=\"conservacao\" \nng-repeat=\"item in vm.estadosConservacoes\" ng-value=\"item.id\" ng-required=\"true\">{{ item.descricao }}</md-option>\n</md-select></md-input-container></div><div layout=\"row\" flex class=\"fotosDetalhe\"><md-button \nng-click=\"vm.metodos.dialogFoto(vm.detalhe)\" style=\"max-width: 250px;align-self: center; background-color: #039BE5\" \nclass=\"md-accent md-raised md-hue-2 header-boards-button\"><i class=\"icon-picture s24\"></i> Fotos</md-button></div><div \nlayout=\"column\" layout-gt-sm=\"row\"><md-input-container class=\"md-block\" flex><label translate=\"CLIENTE.OBSERVACOES\">\n</label><textarea ng-model=\"vm.detalhe.observacao\" name=\"observacoes\" md-no-resize=\"true\" rows=\"4\" max-rows=\"4\" \nmd-maxlength=\"300\" maxlength=\"300\" ng-disabled=\"vm.apenasVisualizacao\">\r\n          </textarea></md-input-container>\n</div><div layout=\"row\" style=\"justify-content: space-between\"><div></div><div ng-if=\"!vm.editando\"></div><div \nlayout=\"row\" ng-if=\"vm.salvando\" flex><div layout=\"row\" layout-align=\"center center\" flex><div layout=\"column\" \nlayout-align=\"center center\"><md-progress-circular md-mode=\"indeterminate\" md-diameter=\"50\" class=\"md-accent\">\n</md-progress-circular></div></div></div><h5 style=\"color: red\" \nng-if=\"(vm.detalhe.fotos == undefined && vm.metodos.estadoConservacaoObrigaFoto(vm.detalhe.equipamentoEstadoConservacaoId)) && !vm.apenasVisualizacao && !vm.editando\">\nÉ necessário informar pelo menos 2 fotos</h5><md-button ng-click=\"vm.metodos.salvar(vm.detalhe)\" ng-if=\"!vm.salvando\" \nclass=\"send-button md-accent md-raised\" aria-label=\"Salvar\" translate=\"GROUP_BUTTON_HORIZONTAL.SALVAR\" \nlayout-align=\"end end\" \nng-disabled=\"vm.form.detalhe.$invalid\r\n                           || vm.form.detalhe.$pristine\r\n                            || vm.controladorDialog.requisicaoSolicitada\r\n                            || (vm.detalhe.fotos == undefined && vm.metodos.estadoConservacaoObrigaFoto(vm.detalhe.equipamentoEstadoConservacaoId)) && !vm.editando\">\n</md-button></div></md-dialog-content></form></md-dialog>");
$templateCache.put("app/main/locacao/processamento/troca-ativo/views/dialogs/dialog-detalhe-equipamento/dialog-detalhe-equipamento.html","<md-dialog id=\"dialog-locacao-detalhe-item\" flex><md-toolbar><div class=\"md-toolbar-tools\" \nstyle=\"background-color: #039BE5\"><h2>Equipamento</h2><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"vm.metodos.fechar()\" aria-label=\"Fechar dialog\" translate translate-attr-aria-label=\"CLIENTE.FECHAR_DIALOG\">\n<md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content flex><div \nlayout=\"column\" layout-align=\"center stretch\"><div class=\"container-dialog-card\" layout=\"row\" flex><md-card \nclass=\"blue-bg white-fg\" flex><md-card-title><md-card-title-text><span class=\"blue-bg white-fg text-center\">\n{{ vm.detalheEquipamento.descricao }}</span></md-card-title-text></md-card-title></md-card></div><div layout=\"row\">\n<md-input-container class=\"md-block\" flex><label>Número de série</label><input \nng-model=\"vm.detalheEquipamento.numeroSerie\" ng-disabled=\"true\"></md-input-container><md-input-container \nclass=\"md-block\" flex><label>IMEI</label><input ng-model=\"vm.detalheEquipamento.imei\" ng-disabled=\"true\">\n</md-input-container><md-input-container><label>Preço (R$)</label><input \nng-model=\"vm.detalheEquipamento.precoUnitario\" ui-money-mask ng-disabled=\"true\"></md-input-container>\n<md-input-container class=\"md-block\" flex><label>Conservação</label><input \nng-model=\"vm.detalheEquipamento.estadosConservacaoDescricao\" ng-disabled=\"true\"></md-input-container></div></div>\n</md-dialog-content></md-dialog>");
$templateCache.put("app/main/locacao/processamento/troca-ativo/views/etapas/resumo-troca/resumo-troca-etapa.html","<div id=\"resumo-troca-etapa\" layout=\"row\" layout-align=\"space-around stretch\" flex=\"100\"><div \nclass=\"container-card mt-10\" flex-gt-sm=\"45\" flex><md-card layout=\"column\" flex><md-card-title-text><span \nclass=\"md-headline\">Item</span></md-card-title-text><div class=\"card-body\"><md-content><md-list flex><md-list-item \nclass=\"md-3-line\" ng-class=\"{ \'equipamento-agrupamento-selecionado\':  item.selecionado }\" \nng-click=\"vm.metodos.selecionarAgrupamentoEquipamentos(item)\" ng-repeat=\"item in vm.resumoTroca\"><div \nclass=\"md-list-item-text\" layout=\"column\"><h4><strong>Equipamento</strong>: {{ item.descricao }}</h4><h4><strong>Preço\n</strong>: {{ item.preco | currency:\"R$\":2 }}</h4><h4><strong>Quantidade</strong>: {{ item.quantidade }}</h4></div>\n<md-button class=\"md-secondary\" ng-click=\"vm.metodos.abrirDialogDetalheItem(item)\"><i \nclass=\"icon-open-in-new s16 icone-cor-padrao\"><md-tooltip><label>Visualizar</label></md-tooltip></i></md-button>\n</md-list-item></md-list></md-content></div></md-card><div class=\"container-total\" layout=\"row\" flex><p flex=\"25\">\nTotal: {{ vm.resumoTroca.length }}</p><p>Valor total: {{ vm.valorTotalResumo | currency:\"R$\":2 }}</p></div></div><div \nclass=\"container-card mt-10\" flex-gt-sm=\"45\" flex><md-card layout=\"column\" flex><md-card-title-text><span \nclass=\"md-headline\">Equipamento</span></md-card-title-text><div class=\"card-body\"><md-content><md-list flex>\n<md-list-item class=\"md-3-line\" ng-repeat=\"equipamento in vm.resumoTrocaEquipamentos\"><div class=\"md-list-item-text\" \nlayout=\"column\"><h4><strong>N° Série</strong>: {{ equipamento.numeroSerie }}</h4><h4><strong>Preço</strong>\n: {{ equipamento.precoUnitario | currency:\"R$\":2 }}</h4><h4><strong>Situação</strong>\n: {{ vm.metodos.retornarDescricaoSituacao(equipamento.equipamentoSituacaoId) }}</h4></div><md-button \nclass=\"md-secondary\" ng-click=\"vm.metodos.abrirDialogDetalheEquipamento(equipamento)\"><i \nclass=\"icon-open-in-new s16 icone-cor-padrao\"><md-tooltip><label>Visualizar</label></md-tooltip></i></md-button>\n</md-list-item></md-list></md-content></div></md-card><div class=\"container-total\" layout=\"row\" flex><p flex=\"25\">\nTotal: {{ vm.resumoTrocaEquipamentos.length }}</p><p>\nValor total: {{ vm.valorTotalResumoEquipamentos | currency:\"R$\":2 }}</p></div></div></div>");
$templateCache.put("app/main/locacao/processamento/troca-ativo/views/etapas/nota-fiscal/nota-fiscal-etapa.html","<div id=\"notaFiscal\" aria-label=\"Nota\"><md-content layout=\"column\"><div layout=\"column\" layout-gt-sm=\"row\">\n<md-input-container><label translate=\"Entrada\"></label><md-datepicker ng-model=\"vm.nota.dataNotaEntrada\" \nname=\"notaDataEntrada\" ng-mask=\"3?9/1?9/9999\" mascara-conversor-string-para-data ng-required=\"true\" \nng-disabled=\"vm.apenasVisualizacao\"></md-datepicker><div ng-messages=\"vm.form.nota.notaData.$error\"><div \nng-message=\"maxdate\" translate=\"MENSAGEM_VALIDACAO.DATA_MAIOR_VENCIMENTO\"></div><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container><md-input-container><label \ntranslate=\"Emissão\"></label><md-datepicker ng-model=\"vm.nota.dataNota\" name=\"notaData\" ng-mask=\"3?9/1?9/9999\" \nmascara-conversor-string-para-data ng-required=\"true\" md-max-date=\"vm.nota.dataVencimento\" \nng-disabled=\"vm.apenasVisualizacao\"></md-datepicker><div ng-messages=\"vm.form.nota.notaData.$error\"><div \nng-message=\"maxdate\" translate=\"MENSAGEM_VALIDACAO.DATA_MAIOR_VENCIMENTO\"></div><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container><md-input-container><label \ntranslate=\"Vencimento\"></label><md-datepicker ng-model=\"vm.nota.dataVencimento\" name=\"notaVencimento\" \nmascara-conversor-string-para-data ng-mask=\"3?9/1?9/9999\" md-min-date=\"vm.nota.dataNota\" ng-required=\"true\" \nng-disabled=\"vm.apenasVisualizacao\"></md-datepicker><div ng-messages=\"vm.form.nota.notaVencimento.$error\"><div \nng-message=\"mindate\" translate=\"MENSAGEM_VALIDACAO.DATA_MENOR_EMISSAO\"></div><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container><md-input-container class=\"md-block\" \nflex><label>Número</label><input name=\"numero\" maxlength=\"10\" type=\"text\" ng-model=\"vm.nota.numeroNota\" \nng-required=\"true\" md-maxlength=\"10\" ng-disabled=\"vm.apenasVisualizacao\"><div ng-messages=\"vm.form.nota.numero.$error\">\n<div ng-message=\"required\" translate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container>\n<md-input-container class=\"md-block\" flex><label>Forma de pagamento</label><md-select name=\"formaPagamento\" \nng-model=\"vm.nota.formPagCodigo\" ng-required=\"true\" ng-disabled=\"vm.apenasVisualizacao\"><md-option \nng-repeat=\"forma in vm.formaPagamento\" ng-value=\"forma.codigo\">{{forma.descricao}}</md-option></md-select><div \nng-messages=\"vm.form.nota.formaPagamento.$error\"><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container><md-input-container><label>\nValor Total (R$)</label><input name=\"valorTotal\" type=\"text\" ng-required=\"true\" maxlength=\"22\" \nng-model=\"vm.nota.valorTotalNota\" ui-money-mask ng-disabled=\"true\"><div ng-messages=\"vm.form.nota.valorTotal.$error\">\n<div ng-message=\"required\" translate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container></div><div\n layout=\"row\" layout-xs=\"column\"><md-input-container class=\"md-block\" flex=\"20\" flex-xs=\"100\"><label>Fornecedor</label>\n<md-select name=\"fornecedor\" ng-model=\"vm.nota.equipamentoFornecedorId\" ng-required=\"true\" \nng-disabled=\"vm.apenasVisualizacao\"><md-option ng-repeat=\"forma in vm.fornecedor\" ng-value=\"forma.id\">\n{{forma.descricao}}</md-option></md-select><div ng-messages=\"vm.form.nota.fornecedor.$error\"><div \nng-message=\"required\" translate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container>\n<md-input-container class=\"md-block\" flex=\"20\" flex-xs=\"100\"><label>Objetivo nota</label><md-select \nname=\"objetivoNota\" ng-model=\"vm.nota.objetivoNotaId\" ng-required=\"true\" ng-disabled=\"vm.apenasVisualizacao\"><md-option\n ng-repeat=\"objetivo in vm.objetivoNota\" ng-value=\"objetivo.id\">{{objetivo.descricao}}</md-option></md-select><div \nng-messages=\"vm.form.nota.objetivoNota.$error\"><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container><md-input-container class=\"md-block\" \nflex><label>Empresa ativo destino</label><md-select name=\"empresaAtivo\" ng-model=\"vm.nota.empresaAtivoId\" \nng-required=\"true\" ng-disabled=\"vm.apenasVisualizacao\"><md-option ng-repeat=\"empresa in vm.empresaAtivo\" \nng-value=\"empresa.id\" ng-if=\"empresa.id != vm.empresaAtivoId\">{{empresa.codigo}} - {{empresa.nome}}</md-option>\n</md-select><div ng-messages=\"vm.form.nota.empresaAtivo.$error\"><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container></div><div layout=\"row\">\n<md-input-container class=\"md-block\" flex><label translate=\"CLIENTE.OBSERVACOES\"></label><textarea \nng-model=\"vm.nota.observacao\" name=\"observacoes\" md-no-resize=\"true\" rows=\"4\" max-rows=\"4\" md-maxlength=\"300\" \nmaxlength=\"300\" ng-disabled=\"vm.apenasVisualizacao\">\r\n          </textarea></md-input-container></div></md-content>\n</div>");
$templateCache.put("app/main/locacao/processamento/troca-ativo/views/etapas/troca-equipamento/troca-equipamento-etapa.html","<div layout=\"row\" layout-align=\"space-between stretch\" flex=\"100\"><fieldset class=\"standard\" flex=\"40\"><legend \nclass=\"grp-legend\">Empresa ativo origem</legend><table id=\"tabela-equipamentos-origem\" \nclass=\"dataTable row-border hover\" datatable=\"ng\" dt-options=\"vm.dtOptionsOrigem\" width=\"100%\"><thead><tr><th \nclass=\"secondary-text\"><div class=\"table-header\" layout-align=\"center center\"></div></th><th class=\"secondary-text\">\n<div class=\"table-header\"><span class=\"column-title\">Descrição</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">N° de série</span></div></th></tr></thead><tbody><tr \nng-repeat=\"equipamento in vm.equipamentos track by $index\"><td layout-align=\"center center\" class=\"text-center\">\n<md-checkbox ng-model=\"equipamento.selecionado\" ng-click=\"vm.metodos.selecionarEquipamento(equipamento)\" \nng-disabled=\"vm.emProgresso\"></md-checkbox></td><td>{{ equipamento.descricao }}</td><td>{{ equipamento.numeroSerie }}\n</td></tr></tbody></table></fieldset><div class=\"container-botoes\" layout=\"column\" layout-align=\"center center\" \nflex=\"5\"><md-button ng-disabled=\"vm.equipamentos.length <= 0\" ng-click=\"vm.metodos.adicionarEquipamento()\" \nlayout-align=\"end end\" class=\"md-fab md-accent md-icon-button\"><md-icon md-font-icon=\"icon-arrow-right s30\"></md-icon>\n</md-button><md-button ng-disabled=\"vm.equipamentosTroca.length <= 0\" ng-click=\"vm.metodos.removerEquipamento()\" \nlayout-align=\"end end\" class=\"md-fab md-accent md-icon-button\"><md-icon md-font-icon=\"icon-arrow-left s30\"></md-icon>\n</md-button></div><fieldset class=\"standard\" flex=\"50\"><legend class=\"grp-legend\">Empresa ativo destino</legend><table \nid=\"tabela-equipamentos-origem\" class=\"dataTable row-border hover\" datatable=\"ng\" dt-options=\"vm.dtOptionsDestino\" \ndt-instance=\"vm.dtInstance\" width=\"100%\"><thead><tr><th class=\"secondary-text\"><div class=\"table-header\" \nlayout-align=\"center center\"></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Descrição</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">N° de série</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Valor</span></div></th></tr></thead><tbody><tr \nng-repeat=\"equipamento in vm.equipamentosTroca track by $index\"><td layout-align=\"center center\" class=\"text-center\">\n<md-checkbox ng-model=\"equipamento.selecionado\" ng-click=\"vm.metodos.selecionarEquipamento(equipamento)\" \nng-disabled=\"vm.emProgresso\"></md-checkbox></td><td>{{ equipamento.descricao }}</td><td>{{ equipamento.numeroSerie }}\n</td><td><md-input-container class=\"margem-cell\"><label>Valor (R$)</label><input name=\"preco\" type=\"text\" \nmaxlength=\"22\" ng-model=\"equipamento.valor\" ng-required=\"true\" ui-money-mask></md-input-container></td></tr></tbody>\n</table></fieldset></div>");
$templateCache.put("app/main/locacao/processamento/troca-ativo/views/dialogs/dialog-detalhe-item/dialog-detalhe-item.html","<md-dialog id=\"dialog-locacao-detalhe-item\" flex><md-toolbar><div class=\"md-toolbar-tools\" \nstyle=\"background-color: #039BE5\"><h2>Item</h2><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"vm.metodos.fechar()\" aria-label=\"Fechar dialog\" translate translate-attr-aria-label=\"CLIENTE.FECHAR_DIALOG\">\n<md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content flex><div \nlayout=\"column\" layout-align=\"center stretch\"><div class=\"container-dialog-card\" layout=\"row\" flex><md-card \nclass=\"blue-bg white-fg\" flex><md-card-title><md-card-title-text><span class=\"blue-bg white-fg text-center\">\nNF: {{ vm.nota.numeroNota }}</span></md-card-title-text></md-card-title></md-card></div><div layout=\"row\">\n<md-input-container class=\"md-block\" flex><label>Quantidade</label><input ng-model=\"vm.itemDetalhes.quantidade\" \nng-disabled=\"true\"></md-input-container><md-input-container class=\"md-block\" flex><label>Garantia (Meses)</label><input\n ng-model=\"vm.itemDetalhes.garantia\" ng-disabled=\"true\"></md-input-container><md-input-container><label>\nValor Total (R$)</label><input ng-model=\"vm.itemDetalhes.preco\" ui-money-mask ng-disabled=\"true\"></md-input-container>\n<md-input-container class=\"md-block\" flex><label>Equipamento</label><input ng-model=\"vm.itemDetalhes.descricao\" \nng-disabled=\"true\"></md-input-container></div></div></md-dialog-content></md-dialog>");
$templateCache.put("app/main/pipeline/processamento/pipeline-negocio/dialogs/pipeline-negocio-negocios/tabs/tab-dados-historico.html","<div layout=\"column\" flex><div class=\"fullpage-datatable\" layout=\"column\" flex><table \nclass=\"dataTable row-border hover\" id=\"datatable-historico-negocio\" width=\"100%\"><thead><tr><th>Data</th><th>\nNível da etapa</th><th>Probabilidade</th></tr></thead><tbody><tr ng-repeat=\"historico in vm.historicoNegocio\"><td>\n{{historico.data | date:\'dd/MM/yyyy\'}}</td><td>{{historico.nivel}}</td><td>{{historico.probabilidadeFechamento + \" %\"}}\n</td></tr></tbody></table></div></div>");
$templateCache.put("app/main/pipeline/processamento/pipeline-negocio/dialogs/pipeline-negocio-negocios/tabs/tab-dados-negocio.html","<div layout=\"row\" flex><md-input-container class=\"md-block largura-campo\" flex><label \ntranslate=\"PIPELINE_NEGOCIO.FUNIL\"></label><input type=\"text\" name=\"funil\" ng-model=\"vm.funil\" ng-disabled=\"true\">\n</md-input-container><md-input-container class=\"md-block botao-funil\" ng-hide=\"vm.novaEntidade\" flex=\"5\" \nlayout-align=\"center start\" style=\"display: flex\"><md-button class=\"md-icon-button\" \nng-click=\"vm.metodos.alterarFunilNegocio($event)\" aria-label=\"Alterar o funil\" translate \ntranslate-attr-aria-label=\"PIPELINE_NEGOCIO.ALTERAR_FUNIL\" layout-align=\"center center\" style=\"display: flex\"><md-icon \nmd-font-icon=\"icon-filter s30\"></md-icon><md-tooltip><span translate=\"PIPELINE_NEGOCIO.ALTERAR_FUNIL\"></span>\n</md-tooltip></md-button></md-input-container><md-input-container class=\"md-block\" flex \nng-class=\"{\'margem-campo-produto\': !vm.novaEntidade}\"><label translate=\"PIPELINE_NEGOCIO.PRODUTO\"></label><md-select \nname=\"produtos\" multiple=\"multiple\" md-on-open=\"vm.metodos.configuraMdSelectProduto()\" ng-model=\"vm.negocio.produtos\" \nng-model-options=\"{trackBy: \'$value.codigo\'}\" ng-required=\"true\"><md-select-header><input \nid=\"pipeline-negocio-dialog-produto-md-select\" class=\"md-text\" ng-model=\"vm.filtrarProdutos\" type=\"search\" \nplaceholder=\"\" translate translate-attr-placeholder=\"PIPELINE_NEGOCIO.PESQUISAR_PRODUTO\"></md-select-header><md-option \nng-value=\"produto\" ng-repeat=\"produto in vm.produtos | filter:vm.filtrarProdutos track by produto.codigo\">\n{{produto.descricao}}</md-option></md-select><div ng-messages=\"vm.form.produtos.$error\"><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container></div><div layout=\"row\" flex>\n<md-autocomplete flex=\"50\" md-input-name=\"cliente\" md-no-cache=\"true\" ng-required=\"true\" \nng-blur=\"vm.metodos.configuraAutoCompleteClienteOnBlur()\" md-selected-item=\"vm.negocio.cliente\" \nmd-selected-item-change=\"vm.metodos.alterarItemSelecionadoAutoCompleteCliente(item)\" \nmd-search-text=\"vm.textoDePesquisaAutoCompleteCliente\" \nmd-items=\"item in vm.metodos.pesquisarAutoCompleteCliente(vm.textoDePesquisaAutoCompleteCliente)\" \nmd-item-text=\"item.codigo + \' - \' + item.nome\" md-autoselect md-floating-label=\"Cliente\" \nng-disabled=\"!vm.novaEntidade\"><md-item-template><span md-highlight-text=\"vm.textoDePesquisaAutoCompleteCliente\">\n{{item.codigo}} - {{item.nome}}</span></md-item-template><md-not-found><label>Não foi encontrado nenhum Cliente.\n</label></md-not-found><div ng-messages=\"vm.form.cliente.$error\"><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-autocomplete><md-input-container class=\"md-block\" \nflex-gt-sm=\"50\"><label translate=\"CLIENTE.EXECUTIVO_DE_CONTAS\"></label><md-select name=\"executivoContasResponsavel\" \nng-model=\"vm.negocio.codigoExecutivoContasResponsavel\" ng-required=\"true\" ng-disabled=\"vm.requisicaoSolicitada\">\n<md-option ng-value=\"usuario.codigo\" \nng-repeat=\"usuario in vm.executivosResponsaveis | orderBy: \'login\' track by usuario.codigo\">{{usuario.login}}\n</md-option></md-select><div ng-messages=\"vm.form.executivoContasResponsavel.$error\"><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container></div><div layout=\"row\" flex>\n<md-input-container class=\"md-block largura-campo\" flex><label translate=\"PIPELINE_NEGOCIO.ETAPA\"></label><md-select \nname=\"etapa\" ng-model=\"vm.etapaAtual\" ng-required=\"true\" ng-model-options=\"{trackBy: \'$value.codigo\'}\" \nng-change=\"vm.metodos.atualizarEtapaAtualNegocio($event, vm.etapaAtual)\" ng-disabled=\"vm.requisicaoSolicitada\">\n<md-option ng-value=\"etapa\" ng-repeat=\"etapa in vm.etapasFunil\">{{etapa.nivel}} - {{etapa.descricao}}</md-option>\n</md-select><div ng-messages=\"vm.form.etapa.$error\"><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container><md-input-container class=\"md-block\" \nflex=\"20\"><label translate=\"PIPELINE_NEGOCIO.DATA_INICIAL\"></label><md-datepicker name=\"dataInicial\" \nmascara-conversor-string-para-data ng-model=\"vm.negocio.dataInicial\" ng-mask=\"3?9/1?9/9999\" \nng-required=\"vm.novaEntidade && vm.etapaAtual || !vm.novaEntidade\" \nng-change=\"vm.metodos.atualizarDataFinalQuandoInserindo(vm.negocio.dataInicial)\" \nng-disabled=\"vm.requisicaoSolicitada || (vm.novaEntidade && !vm.etapaAtual)\"></md-datepicker><md-tooltip \nng-if=\"vm.novaEntidade && !vm.etapaAtual\"><span translate=\"PIPELINE_NEGOCIO.INFORME_A_ETAPA\"></span></md-tooltip><div \nng-messages=\"vm.form.dataInicial.$error\"><div ng-message=\"valid\" translate=\"MENSAGEM_VALIDACAO.DATA_INVALIDA\"></div>\n<div ng-message=\"required\" translate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container>\n<md-input-container class=\"md-block largura-campo-data-final\"><label translate=\"PIPELINE_NEGOCIO.DATA_FINAL_ETAPA\">\n</label><md-datepicker name=\"dataFinalEtapa\" mascara-conversor-string-para-data md-min-date=\"vm.negocio.dataInicial\" \nng-model=\"vm.negocio.dataFinalEtapa\" ng-mask=\"3?9/1?9/9999\" ng-disabled=\"true\" ng-required=\"true\"></md-datepicker><div \nng-messages=\"vm.form.dataFinalEtapa.$error\"><div ng-message=\"valid\" translate=\"MENSAGEM_VALIDACAO.DATA_INVALIDA\"></div>\n<div ng-message=\"mindate\" translate=\"MENSAGEM_VALIDACAO.CAMPO_DATA_FINAL\"></div><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container><md-input-container \nclass=\"md-block proximo-codigo\" ng-hide=\"vm.novaEntidade\"><md-button class=\"md-icon-button\" \nng-click=\"vm.metodos.reagendarDataFinalEtapa($event, vm.negocio.dataFinalEtapa)\" \naria-label=\"Reagendar Data Final Etapa\" translate \ntranslate-attr-aria-label=\"PIPELINE_NEGOCIO.REAGENDAR_DATA_FINAL_ETAPA\"><md-icon \nmd-font-icon=\"icon-arrow-right-bold-hexagon-outline s30\"></md-icon><md-tooltip><span \ntranslate=\"PIPELINE_NEGOCIO.REAGENDAR_DATA_FINAL_ETAPA\"></span></md-tooltip></md-button></md-input-container></div><div\n layout=\"row\" flex><md-input-container class=\"md-block largura-campo\" flex><label translate=\"PIPELINE_NEGOCIO.VALOR\">\n</label><input type=\"text\" name=\"valor\" maxlength=\"23\" ui-money-mask ng-model=\"vm.negocio.valor\" \nng-disabled=\"vm.requisicaoSolicitada\" ng-required=\"!vm.etapaAtual.permiteValoresZerados\"><div \nng-messages=\"vm.form.valor.$error\"><div ng-message=\"required\" translate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div>\n</div></md-input-container><md-input-container class=\"md-block\" flex><label \ntranslate=\"PIPELINE_NEGOCIO.OUTROS_VALORES\"></label><input type=\"text\" name=\"outrosValores\" maxlength=\"23\" \nui-money-mask ng-model=\"vm.negocio.outrosValores\" ng-disabled=\"vm.requisicaoSolicitada\"><div \nng-messages=\"vm.form.outrosValores.$error\"><div ng-message=\"required\" translate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\">\n</div></div></md-input-container></div><div layout=\"row\"><md-input-container class=\"md-block\" flex><label \ntranslate=\"PIPELINE_NEGOCIO.ATENDIMENTO\"></label><md-select name=\"atendimento\" \nmd-on-open=\"vm.metodos.configuraMdSelectAtendimento()\" md-on-close=\"vm.metodos.configurarMdSelectAtendimentoOnClose()\" \nng-model=\"vm.atendimento\" ng-change=\"vm.metodos.selecionarAtendimento(vm.atendimento)\" \nng-disabled=\"(!vm.negocio.cliente && !vm.negocio.codigoCliente) || vm.requisicaoSolicitada\" ng-required=\"true\">\n<md-select-header><input id=\"pipeline-negocios-atendimento-md-select\" class=\"md-text\" \nng-if=\"vm.atendimentos && vm.atendimentos.length > 0\" ng-model=\"vm.filtrarAtendimentos\" type=\"search\" placeholder=\"\" \ntranslate translate-attr-placeholder=\"PIPELINE_NEGOCIO.PESQUISAR_ATENDIMENTOS\"> <span \nng-if=\"!vm.atendimentos || vm.atendimentos.length == 0\">Não existem atendimentos vinculados ao cliente</span>\n</md-select-header><md-option ng-value=\"atendimento\" ng-if=\"vm.atendimentos && vm.atendimentos.length > 0\" \nng-repeat=\"atendimento in vm.atendimentos | filter:vm.filtrarAtendimentos\">\n{{atendimento.codigo}}/{{atendimento.ano}} - {{vm.metodos.listarAssuntoAtendimento(atendimento.assunto)}}</md-option>\n</md-select><md-tooltip ng-if=\"!vm.negocio.cliente && !vm.negocio.codigoCliente\"><span \ntranslate=\"PIPELINE_NEGOCIO.INFORMAR_CLIENTE\"></span></md-tooltip><div ng-messages=\"vm.form.atendimento.$error\"><div \nng-message=\"required\" translate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container></div><div \nlayout=\"row\"><md-input-container class=\"md-block\" flex><label translate=\"PIPELINE_NEGOCIO.OBSERVACAO\"></label><textarea\n name=\"observacao\" max-rows=\"5\" md-no-resize=\"true\" ng-model=\"vm.negocio.observacao\" \nng-disabled=\"vm.requisicaoSolicitada\">\r\n        </textarea></md-input-container></div>");
$templateCache.put("app/main/pipeline/processamento/pipeline-negocio/dialogs/pipeline-negocio-negocios/tabs/tab-historico-alteracao-funil.html","<div layout=\"column\" flex><div class=\"fullpage-datatable\" layout=\"column\" flex><table \nng-if=\"vm.historicoFunil.length > 0\" class=\"dataTable row-border hover\" id=\"datatable-historico-negocio\" width=\"100%\">\n<thead><tr><th>Data</th><th>Funil Anterior</th><th>Funil Atual</th><th>Usuário</th></tr></thead><tbody><tr \nng-repeat=\"historico in vm.historicoFunil\"><td>{{historico.data | date:\'dd/MM/yyyy\'}}</td><td>\n{{historico.funilAnterior}}</td><td>{{historico.funilAtual}}</td><td>{{historico.usuario}}</td></tr></tbody><div \nlayout=\"center center\" ng-if=\"0 >= vm.historicoFunil.length\" class=\"alerta-tabela-vazia\"><span>\nNão foi encontrado nenhuma alteração de funil!</span></div></table></div></div>");
$templateCache.put("app/main/locacao/processamento/locacao/retorno/step/retorno/retorno-step.html","<div flex ng-if=\"vm.filtro.retornoContratos == \'\'\"><h2 class=\"text-center\">Este contrato não possui locação.</h2></div>\n<div style=\"max-height: 61.5vh; overflow: scroll;max-width: 50%\" layout=\"column\" \nng-if=\"vm.filtro.retornoContratos != \'\'\" id=\"locacao-retorno\"><md-content><md-list flex><md-list-item \nclass=\"md-3-line\" ng-repeat=\"item in vm.filtro.retornoContratos | orderBy:\'dataEnvio\' :true\" \nstyle=\"box-shadow: 10px 1px 0px lightgrey\" ng-class=\"{\'zebra\' : $index %2 == 0}\"><md-checkbox ng-model=\"item.marcado\" \nng-click=\"vm.metodos.envioSelecionado(item)\"></md-checkbox><div class=\"md-list-item-text\" layout=\"column\"><h4><strong>\nAtendimento</strong>: {{item.atendimentoId}} / {{item.atendimentoAno}}</h4><h4><strong>Nota saída</strong>\n: {{item.notaFiscalSaida}}</h4><h4><strong>Data envio:</strong>: {{item.dataEnvio | date:\'dd/MM/yyyy\'}}</h4></div><div \nlayout=\"row\" class=\"md-secondary\"><md-button class=\"md-icon-button\"><i \nclass=\"icon-information-outline s28 icone-cor-padrao\" ng-disabled=\"vm.controleForm.emProgresso\" \nng-click=\"vm.metodos.dialogdetalhes(item.notaFiscalSaida)\"><md-tooltip><span>Prévia detalhes</span></md-tooltip></i>\n</md-button></div></md-list-item></md-list></md-content></div>");
$templateCache.put("app/main/locacao/processamento/locacao/retorno/step/contrato/contrato-step.html","<form name=\"vm.locacao-retono-form\" novalidate><div flex layout=\"column\"><div layout=\"row\" flex><md-autocomplete \nflex=\"40\" required md-input-name=\"cliente\" md-no-cache=\"true\" md-selected-item=\"vm.cliente\" \nmd-selected-item-change=\"vm.metodos.alterarItemSelecionadoAutoCompleteCliente(item)\" \nmd-search-text=\"vm.textoDePesquisaAutoCompleteCliente\" \nmd-items=\"item in vm.metodos.pesquisarAutoCompleteCliente(vm.textoDePesquisaAutoCompleteCliente)\" \nmd-item-text=\"item.nome\" md-autoselect md-floating-label=\"Cliente\" \nng-blur=\"vm.metodos.configuraAutoCompleteClienteOnBlur()\"><md-item-template><span \nmd-highlight-text=\"vm.textoDePesquisaAutoCompleteCliente\">{{item.nome}}</span></md-item-template><md-not-found><label>\nNão foi encontrado nenhum cliente.</label></md-not-found></md-autocomplete></div><div flex layout=\"row\" \nng-if=\"vm.cliente != undefined\"><md-input-container class=\"md-block\" flex=\"40\"><label translate=\"\">Tipo de contrato\n</label><md-select name=\"contrato\" ng-model=\"vm.contrato\" ng-disabled=\"vm.filtro.cliente == null\" \nng-required=\"vm.filtro.cliente != null\"><md-option ng-value=\"contrato\" ng-repeat=\"contrato in vm.contratos\">\n{{ contrato.contratoTipo.descricao }}</md-option></md-select></md-input-container><md-input-container class=\"md-block\" \nflex=\"40\"><label translate=\"\">Item do contrato</label><md-select name=\"contratoItens\" ng-model=\"vm.contratoItem\" \nng-disabled=\"vm.contrato == null\" ng-required=\"true\" ng-change=\"vm.metodos.listarLocados()\"><md-option \nng-value=\"contratoItens\" ng-repeat=\"contratoItens in vm.contrato.contratoItens\">{{ contratoItens.produto.descricao }}\n</md-option></md-select></md-input-container></div></div><div flex class=\"btn-retornarTodos\"><md-button \nng-click=\"vm.metodos.listarTodosLocadosPorContrato(vm.contrato.codigo)\" class=\"send-button md-accent md-raised\" \naria-label=\"Salvar\" translate=\"Retornar todos\" translate-attr-aria-label=\"GROUP_BUTTON_HORIZONTAL.SALVAR\" \nng-disabled=\"vm.formulario.$invalid || vm.formulario.$pristine || vm.requisicaSolicitada || !vm.contrato\"></md-button>\n</div></form>");
$templateCache.put("app/main/manutencao/consulta/ordem-servico/views/dialogs/dialog-item/dialog-item.html","<md-dialog id=\"dialog-item\" class=\"dialog-pai\" aria-label=\"OS\"><form name=\"vm.form\" class=\"md-inline-form\" novalidate>\n<md-toolbar><div class=\"md-toolbar-tools titulo\" style=\"background-color: #039BE5\"><h2>Itens Ordem Serviço</h2><span \nflex></span><md-button class=\"md-icon-button\" ng-click=\"vm.metodos.cancel()\" aria-label=\"Fechar dialog\" translate \ntranslate-attr-aria-label=\"CLIENTE.FECHAR_DIALOG\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div>\n</md-toolbar><table class=\"dataTable row-border hover\" id=\"tabela-equipamentos\"><thead><tr><div class=\"table-header\">\n<th class=\"secondary-text column-title text-center tabelaCabecalho\">Descrição</th><th \nclass=\"secondary-text column-title text-center tabelaCabecalho\">N° Série</th><th \nclass=\"secondary-text column-title text-center tabelaCabecalho\">IMEI</th></div></tr></thead><tbody><tr \nng-repeat=\"item in vm.itens\" ng-if=\"item.ordemServicoEquipamentoItemSerie == null\"><td>\n{{ item.equipamentoNotaItemDetalheDescricao }}</td><td>{{ item.equipamentoNotaItemDetalheSerie }}</td><td>\n{{ item.ordemServicoEquipamentoItemImei }}</td></tr><tr ng-repeat=\"item in vm.itens\" \nng-if=\"item.ordemServicoEquipamentoItemSerie != null\"><td>{{ item.ordemServicoEquipamentoItemDescricao }}</td><td>\n{{ item.ordemServicoEquipamentoItemSerie }}</td><td>{{ item.ordemServicoEquipamentoItemImei }}</td></tr></tbody>\n</table></form></md-dialog>");
$templateCache.put("app/main/pesquisa/processamento/pesquisa/views/tabs/pesquisa/tab-pesquisa.html","<md-content class=\"tab-pesquisa\"><div class=\"form-container\"><div layout-gt-xs=\"row\"><md-input-container \nclass=\"md-block\" flex-gt-sm=\"10\" \nng-if=\"!(vm.controleForm.pesquisaAtiva && vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo)\"><label>Código\n</label><input type=\"text\" ng-model=\"vm.pesquisa.codigo\" name=\"codigo\" mascara-numero-generica=\"#####\" \nng-required=\"vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\"><div \nng-messages=\"vm.form.codigo.$error\"><div ng-message=\"required\" translate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div>\n</div></md-input-container><md-input-container class=\"md-block\" flex-gt-sm=\"35\"><label>Descrição</label><input \ntype=\"text\" ng-model=\"vm.pesquisa.descricao\" name=\"descricao\" mascara-tamanho-campo=\"50\" \nng-required=\"vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo\" md-maxlength=\"50\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\"><div \nng-messages=\"vm.form.descricao.$error\"><div ng-message=\"required\" translate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\">\n</div></div></md-input-container><md-input-container flex-gt-sm=\"15\"><label flex>Data inicial</label><md-datepicker \nflex name=\"dataInicio\" md-max-date=\"vm.pesquisa.dataFim\" md-open-on-focus ng-model=\"vm.pesquisa.dataInicio\" \nng-required=\"vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\" \nng-mask=\"3?9/1?9/9999\"></md-datepicker><div ng-messages=\"vm.form.dataInicio.$error\"><div ng-message=\"valid\" \ntranslate=\"MENSAGEM_VALIDACAO.DATA_INVALIDA\"></div><div ng-message=\"required\" \ntranslate=\"RELATORIO_CONTRATOS.DATA_INICIAL_OBRIGATORIA\"></div><div ng-message=\"maxdate\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_DATA_INICIAL\"></div></div></md-input-container><md-input-container flex-gt-sm=\"15\">\n<label flex>Data final</label><md-datepicker flex name=\"dataFim\" md-min-date=\"vm.pesquisa.dataInicio\" md-open-on-focus \nng-required=\"vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\" \nng-model=\"vm.pesquisa.dataFim\" ng-mask=\"3?9/1?9/9999\"></md-datepicker><div ng-messages=\"vm.form.dataFim.$error\"><div \nng-message=\"valid\" translate=\"MENSAGEM_VALIDACAO.DATA_INVALIDA\"></div><div ng-message=\"mindate\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_DATA_FINAL\"></div><div ng-message=\"required\" \ntranslate=\"RELATORIO_CONTRATOS.DATA_FINAL_OBRIGATORIA\"></div></div></md-input-container><md-input-container \nclass=\"botao-ativo-pesquisa\" flex><md-switch aria-label=\"Ativa\" name=\"ativa\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\" \nng-model=\"vm.pesquisa.ativa\">Ativa</md-switch></md-input-container></div><div layout-gt-xs=\"row\"><md-input-container \nclass=\"md-block\" flex-gt-sm=\"30\"><label>Tipo</label><md-select ng-model=\"vm.pesquisa.codigoPesquisaTipo\" \nname=\"codigoPesquisaTipo\" ng-required=\"vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\"><md-option\n ng-value=\"tipo.codigo\" ng-repeat=\"tipo in vm.tiposPesquisa track by tipo.codigo\">{{tipo.descricao}}</md-option>\n</md-select><div ng-messages=\"vm.form.codigoPesquisaTipo.$error\"><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container><md-input-container class=\"md-block\" \nflex-gt-sm=\"30\"><label>Produto</label><md-select ng-model=\"vm.pesquisa.produtoCodigo\" name=\"produtoCodigo\" \nng-change=\"vm.metodos.changeProduto()\" ng-required=\"vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.inserirAtivo\"><md-select-header \nng-if=\"vm.produtos.length > 0\"><input id=\"produto-md-select\" class=\"md-text\" type=\"search\" placeholder=\"\" translate \ntranslate-attr-placeholder=\"Pesquisar produto\" ng-model=\"vm.filtrarProdutos\"></md-select-header><md-option \nng-value=\"produto.codigo\" ng-repeat=\"produto in vm.produtos | filter:vm.filtrarProdutos track by produto.codigo\">\n{{produto.descricao}}</md-option><md-option \nng-if=\"(vm.produtos.length === 0) || \r\n                                      vm.filtrarProdutos && \r\n                                      (vm.produtos | filter:vm.filtrarProdutos).length === 0\" \ndisabled=\"disabled\">Nenhum produto encontrada.</md-option></md-select><div ng-messages=\"vm.form.produtoCodigo.$error\">\n<div ng-message=\"required\" translate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container><div \nclass=\"campo-clientes-vinculados\"><md-autocomplete flex md-input-name=\"cliente\" \nng-required=\"vm.campoClienteObrigatorio\" \nng-disabled=\"(vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo)\r\n                 || (vm.controleForm.inserirAtivo && !vm.pesquisa.produtoCodigo)\" \nmd-no-cache=\"true\" ng-blur=\"vm.metodos.configuraAutoCompleteClienteOnBlur()\" md-selected-item=\"vm.pesquisa.cliente\" \nmd-selected-item-change=\"vm.metodos.alterarItemSelecionadoAutoCompleteCliente(item)\" \nmd-search-text=\"vm.textoDePesquisaAutoCompleteCliente\" \nmd-items=\"item in vm.metodos.pesquisarAutoCompleteCliente(vm.textoDePesquisaAutoCompleteCliente)\" \nmd-item-text=\"item.codigo + \' - \' + item.nome\" md-autoselect md-floating-label=\"Cliente\"><md-item-template><span \nmd-highlight-text=\"vm.textoDePesquisaAutoCompleteCliente\">{{item.codigo}} - {{item.nome}}</span></md-item-template>\n<md-not-found><label>Não foi encontrado nenhum Cliente.</label></md-not-found><div \nng-messages=\"vm.form.cliente.$error\"><div ng-message=\"required\" translate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div>\n</div></md-autocomplete><md-button class=\"md-raised md-accent m-10\" ng-disabled=\"!vm.pesquisa.cliente\" \nng-show=\"vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo || vm.controleForm.pesquisaAtiva\" \nng-click=\"vm.metodos.vincularCliente(vm.pesquisa.cliente)\">Vincular</md-button></div></div><div layout=\"column\" \nclass=\"container-tabela-clientes\" \nng-show=\"vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo || vm.controleForm.pesquisaAtiva\"><div \nng-if=\"vm.pesquisa.clientes.length > 0\" class=\"tabela-clientes-vinculadas\"><div class=\"fullpage-datatable scrollable\" \nms-scroll><table class=\"dataTable row-border hover\" dt-options=\"vm.dtOptions\" width=\"100%\" style=\"border-bottom: none\">\n<thead><tr><th class=\"secondary-text border-left titulo-acoes\" colspan=\"4\" \nstyle=\"background-color: #f5f5f5; text-align: center; font-weight: bold; padding: 12px\">Clientes</th></tr><tr><th \nclass=\"secondary-text border-left\" style=\"padding-left: 10px\"><div class=\"table-header\"><span class=\"column-title\">\nCódigo</span></div></th><th class=\"secondary-text border-left\"><div class=\"table-header\"><span class=\"column-title\">\nNome</span></div></th><th class=\"secondary-text border-left border-right titulo-acoes text-center\"><div \nclass=\"table-header\"><span class=\"column-title\">Ações</span></div></th></tr></thead><tbody><tr \nng-repeat=\"cliente in vm.pesquisa.clientes track by cliente.codigo\"><td class=\"border-left\" style=\"padding-left: 10px\" \nflex>{{cliente.codigo}}</td><td class=\"border-left\" flex>{{cliente.nome}}</td><td \nclass=\"coluna-acoes border-right border-left text-center\"><i class=\"icon-open-in-new s18 icone-cor-padrao ml-10\" \nng-click=\"vm.metodos.visualizarCliente(cliente)\"><md-tooltip><label>Visualizar {{cliente.nome}}</label></md-tooltip>\n</i><i class=\"icon-delete s18 icone-cor-padrao\" \nng-click=\"!(vm.controleForm.inserirAtivo || (vm.controleForm.editarAtivo && !cliente.respondido)) || vm.metodos.desvincularCliente(cliente, $index)\" \nng-disabled=\"!(vm.controleForm.inserirAtivo || (vm.controleForm.editarAtivo && !cliente.respondido))\"><md-tooltip>\n<label ng-if=\"!cliente.respondido\">Desvincular {{cliente.nome}}</label><label ng-if=\"cliente.respondido\">\nNão é possível desvincular {{cliente.nome}}, pois já existem respostas registradas na pesquisa</label></md-tooltip></i>\n</td></tr></tbody></table></div></div></div></div></md-content>");
$templateCache.put("app/main/pesquisa/processamento/pesquisa/views/tabs/respostas/tab-respostas.html","<div id=\"tab-respostas\"><div class=\"container-tabela-grafico\"><div \nclass=\"fullpage-datatable scrollable tabela-respostas-clientes-vinculadas\" ms-scroll \nng-if=\"vm.clienteRespostas.length > 0\"><table class=\"dataTable row-border hover\" dt-options=\"vm.dtOptions\" \nwidth=\"100%\" style=\"border-bottom: none\"><thead><tr><th class=\"secondary-text border-left ultima-coluna\" colspan=\"4\" \nstyle=\"background-color: #f5f5f5; text-align: center; font-weight: bold; padding: 12px\">Clientes</th></tr><tr><th \nclass=\"secondary-text border-left\" style=\"background-color: #f5f5f5; text-align: center; padding: 12px; width: 70px\">\n<div class=\"table-header\"><span class=\"column-title\">Código</span></div></th><th class=\"secondary-text border-left\" \nstyle=\"background-color: #f5f5f5; padding-left: 10px\"><div class=\"table-header\"><span class=\"column-title\">Nome</span>\n</div></th><th class=\"secondary-text border-left\" \nstyle=\"background-color: #f5f5f5; text-align: center; padding: 12px; width: 80px\"><div class=\"table-header\"><span \nclass=\"column-title\">Nota (Média)</span></div></th><th class=\"secondary-text border-left ultima-coluna\" \nstyle=\"background-color: #f5f5f5; text-align: center; padding: 12px; ; width: 80px\"><div class=\"table-header\"><span \nclass=\"column-title\">Respondido</span></div></th></tr></thead><tbody><tr \nng-repeat=\"cliente in vm.clienteRespostas track by cliente.codigo\" ng-click=\"vm.metodos.visualizarRepostas(cliente)\" \nng-disabled=\"!cliente.respondido\"><td class=\"border-left\" style=\"text-align: center; padding: 8px\">{{cliente.codigo}}\n</td><td class=\"border-left\">{{cliente.nome}}<md-tooltip><label>{{!cliente.respondido ? \'\' : \'Visualizar respostas\'}}\n</label></md-tooltip></td><td class=\"border-left\" style=\"text-align: center; padding: 8px\">\n{{ (cliente.notaMedia > 0) ? cliente.notaMedia : \'-\' }}</td><td class=\"border-left ultima-coluna\" \nstyle=\"text-align: center; padding: 8px\"><div style=\"display: inline-flex; align-items: center; gap: 8px\"><md-icon \nmd-font-icon=\"icon-close-circle-outline s20\" style=\"color: rgb(244,67,54)\" ng-if=\"!cliente.respondido\"></md-icon>\n<md-icon md-font-icon=\"icon-checkbox-marked-circle-outline s20\" style=\"color: rgb(76,175,80)\" \nng-if=\"cliente.respondido\"></md-icon></div></td></tr></tbody></table></div><div class=\"container-grafico\" \nng-if=\"vm.exibirGrafico\"><div><md-icon md-font-icon=\"icon-chart-bar s24\" \nstyle=\"color: #666; margin-right: 8px; vertical-align: middle\"></md-icon><span \nstyle=\"font-size: 16px; font-weight: bold; color: #333; vertical-align: middle\">Média geral de respostas</span></div>\n<nvd3 options=\"vm.barChart.options\" data=\"vm.barChart.data\" class=\"grafico-nvd3\"></nvd3></div></div><div \nclass=\"container-totalizador\" ng-if=\"vm.clienteRespostas.length > 0\"><ms-widget class=\"h-90\" layout=\"column\" \nflex=\"100\"><ms-widget-front class=\"p-4 card-total-uso-disponivel\" layout=\"row\" flex=\"100\"><div layout=\"column\" \nlayout-align=\"center center\" flex=\"100\" style=\"color:white; padding: 20px\"><div class=\"font-weight-500 font-size-15\" \nstyle=\"text-align: center\">Total de clientes</div><div class=\"font-size-16\" style=\"text-align: center\">\n{{vm.clienteRespostas.length}}</div></div></ms-widget-front></ms-widget><ms-widget class=\"h-90\" layout=\"column\" \nflex=\"100\"><ms-widget-front class=\"p-4 card-total-uso-disponivel\" layout=\"row\" flex=\"100\"><div layout=\"column\" \nlayout-align=\"center center\" flex=\"100\" style=\"color:white; padding: 20px\"><div class=\"font-weight-500 font-size-15\" \nstyle=\"text-align: center\">Status de conclusão</div><div class=\"font-size-16\" style=\"text-align: center\">\n{{vm.metodos.calcularPorcentagem()}}%</div></div></ms-widget-front></ms-widget></div></div>");
$templateCache.put("app/main/pesquisa/processamento/pesquisa/views/tabs/perguntas/tab-perguntas.html","<md-content ms-scroll class=\"tab-perguntas\"><div class=\"inserir-button\" layout-gt-xs=\"row\" flex \nlayout-align=\"space-between center\" \nng-if=\"!(vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo) && !vm.controleForm.editarAtivo\">\n<div><md-button class=\"md-fab md-accent md-icon-button sample-show-hide\" ng-click=\"vm.metodos.abrirDialogPerguntas()\" \naria-label=\"Inserir nova pergunta\" translate><md-icon md-font-icon=\"icon-plus s30\"></md-icon><md-tooltip md-autohide>\n<span>Inserir nova pergunta</span></md-tooltip></md-button></div></div><div class=\"md-background-bg md-whiteframe-1dp\">\n<table class=\"dataTable row-border hover\" datatable=\"ng\" dt-options=\"vm.dtOptions\" width=\"100%\"><thead><tr><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Ação</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Descrição</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Tipo</span></div></th></tr></thead><tbody>\n<tr ng-repeat=\"pergunta in vm.pesquisa.perguntas\"><td class=\"button-icone-cor-azul\"><i \nclass=\"icon-pencil s16 icone-cor-padrao mr-10\" \nng-click=\"!((vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo) || vm.controleForm.editarAtivo) && !vm.controleForm.emProgresso && vm.metodos.abrirDialogPerguntas(pergunta)\" \nng-disabled=\"(vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo) || vm.controleForm.editarAtivo\">\n</i> <i class=\"icon-delete s16 icone-cor-padrao mr-10\" \nng-click=\"!((vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo) || vm.controleForm.editarAtivo) && !vm.controleForm.emProgresso && vm.metodos.excluirPergunta(pergunta)\" \nng-disabled=\"(vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo) || vm.controleForm.editarAtivo\">\n</i></td><td>{{pergunta.pergunta}}</td><td>{{pergunta.permitirRespostaAberta ? \'Aberta\' : \'Fechada\'}}</td></tr></tbody>\n</table></div></md-content>");
$templateCache.put("app/main/planejamento-scrum/consulta/estoria/views/dialogs/alterar-data-estoria-dialog/consulta-estorias-dialog-alterar-data-estoria.html","<md-dialog id=\"consulta-estorias-dialog-alterar-data-estoria\" class=\"dialogo-padrao\" aria-label=\"Dialog\"><form \nname=\"vm.form.dialog\" class=\"md-inline-form\" novalidate><md-toolbar class=\"md-accent md-tall\" layout=\"column\"><div \nclass=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\">\n{{vm.titulo}}</span><md-button class=\"md-icon-button\" ng-click=\"vm.metodosDialog.fecharDialog()\" \naria-label=\"Fechar dialog\" translate translate-attr-aria-label=\"SOLUCAO_ROTINAS_TAREFAS.FECHAR_DIALOG\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><div layout=\"row\" layout-sm=\"row\" \nlayout-align=\"center\" ng-show=\"vm.requisicaSolicitada\"><md-progress-circular md-mode=\"indeterminate\" class=\"md-accent\">\n</md-progress-circular></div><md-dialog-content ng-hide=\"vm.requisicaSolicitada\"><div layout=\"row\" \nlayout-align=\"center center\" flex><md-input-container><label translate=\"ESTORIA.DATA_ENTREGA\"></label><md-datepicker \nng-model=\"vm.estoria.dataEntrega\" name=\"productBacklogDialogDataEntrega\" mascara-conversor-string-para-data \nng-mask=\"3?9/1?9/9999\" ng-required=\"true\"></md-datepicker><div \nng-messages=\"vm.form.dialog.productBacklogDialogDataEntrega.$error\"><div ng-message=\"valid\" \ntranslate=\"MENSAGEM_VALIDACAO.DATA_INVALIDA\"></div><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.DATA_OBRIGATORIA\"></div></div></md-input-container></div></md-dialog-content>\n<md-dialog-actions layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"end center\" flex>\n<md-button type=\"submit\" ng-click=\"vm.metodosDialog.salvar(vm.estoria, $event)\" \nclass=\"send-button md-accent md-raised\" \nng-disabled=\"vm.form.dialog.$invalid || vm.form.dialog.$pristine || vm.requisicaoSolicitada\" aria-label=\"SALVAR\" \ntranslate=\"SPRINT.SALVAR\" translate-attr-aria-label=\"PRODUCT_BACKLOG.SALVAR\">Salvar</md-button></div>\n</md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/planejamento-scrum/consulta/estoria/views/dialogs/informativo-dialog/consulta-estorias-dialog-informativo.html","<md-dialog id=\"consulta-estorias-dialog-informativo\" class=\"dialogo-padrao\" aria-label=\"Dialog\"><form \nname=\"vm.form.dialogBacklogColaboradores\" class=\"md-inline-form\" novalidate><md-toolbar class=\"md-accent md-tall\" \nlayout=\"column\"><div class=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" layout-align=\"space-between center\">\n<span class=\"title text-center\">Informativo</span><md-button class=\"md-icon-button\" \nng-click=\"vm.metodosDialog.fecharDialog()\" aria-label=\"Fechar dialog\" translate \ntranslate-attr-aria-label=\"SPRINT.FECHAR_DIALOG\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content><div class=\"cards-container\"><div class=\"card-informativo\"><div class=\"card-titulo\">\nEm Aberto</div><div class=\"card-itens\">Solicitação, Análise, Autorizada, Refinada, Estimada</div></div><div \nclass=\"card-informativo\"><div class=\"card-titulo\">Em Andamento</div><div class=\"card-itens\">\nRepassado, Desenvolvimento, Liberada para Testes, Retorno de Erro, Retorno de Melhoria</div></div><div \nclass=\"card-informativo\"><div class=\"card-titulo\">Concluídas</div><div class=\"card-itens\">\nEncerrada, Homologada, Cancelada, Atualizada no cliente</div></div><div class=\"card-informativo\"><div \nclass=\"card-titulo\">Em Pausa</div><div class=\"card-itens\">Pausa no desenvolvimento, Pausa no teste</div></div></div>\n</md-dialog-content></form></md-dialog>");
$templateCache.put("app/main/planejamento-scrum/processamento/sprint/views/tabs/abatimentos/tab-abatimentos.html","<md-content class=\"margin-top md-padding\"><div class=\"form-container\"><div layout-gt-xs=\"row\" \nlayout-align=\"space-between center\"><md-input-container class=\"md-block\" flex-gt-sm=\"70\"><label \ntranslate=\"SPRINT.DESCRICAO\"></label><input type=\"text\" ng-model=\"vm.abatimento.descricao\" \nname=\"sprintAbatimentoDescricao\" mascara-tamanho-campo=\"50\" md-maxlength=\"50\" \nng-required=\"vm.controladorSprint.tabAbatimentos.ativa\"><div \nng-messages=\"vm.form.sprintForm.sprintAbatimentoDescricao.$error\"><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container><md-input-container class=\"md-block\" \nflex-gt-sm=\"25\"><label translate=\"SPRINT.DURACAO\"></label><input type=\"text\" ng-model=\"vm.abatimento.horas\" \nname=\"sprintAbatimentoDuracao\" placeholder=\"\" translate translate-attr-placeholder=\"SPRINT.EXEMPLO_HORAS\" \nmascara-numero-generica=\"##:##\" ng-minlength=\"5\" ng-required=\"true\"><div \nng-messages=\"vm.form.sprintForm.sprintAbatimentoDuracao.$error\"><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div><div ng-message=\"minlength\" \ntranslate=\"MENSAGEM_VALIDACAO.PATTERN_PARA_HORAS\"></div></div></md-input-container><group-button-horizontal \nverifica-editar-ativo=\"vm.controladorSprint.tabAbatimentos.editar\" entidade=\"vm.abatimento\" \nentidades=\"vm.sprint.abatimentos\" nome-entidade=\"Abatimento\" \nsalvar=\"vm.metodosAbatimento.salvarAbatimento(vm.abatimento)\" \neditar=\"vm.metodosAbatimento.editarAbatimento(vm.abatimento)\" controle-form=\"vm.controleForm\">\n</group-button-horizontal></div></div><md-divider></md-divider><table class=\"dataTable row-border hover\" \ndatatable=\"ng\" dt-options=\"vm.dtOptionsSprintAbatimentos\" ng-if=\"vm.habilitarTabela\" width=\"100%\"><thead><tr><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Ação</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Descrição</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Duração</span></div></th></tr></thead>\n<tfoot><tr><th>Total Duração Abatimentos:</th><th></th><th></th></tr></tfoot><tbody><tr \nng-repeat=\"abatimento in vm.sprint.abatimentos track by abatimento.codigo\"><td><i \nclass=\"icon-pencil s16 icone-cor-padrao mr-10\" \nng-click=\"vm.controleForm.emProgresso || vm.metodosAbatimento.selecionarAbatimento(abatimento)\" \nng-disabled=\"vm.controleForm.emProgresso\"><md-tooltip><label translate=\"SPRINT.SELECIONAR_ABATIMENTO\"></label>\n</md-tooltip></i><i class=\"icon-delete s16 icone-cor-padrao\" \nng-click=\"vm.controleForm.emProgresso || vm.metodosAbatimento.excluirAbatimento($event, abatimento)\" \nng-disabled=\"vm.controleForm.emProgresso\"></i></td><td>{{abatimento.descricao}}</td><td>{{abatimento.horas}}</td></tr>\n</tbody></table></md-content>");
$templateCache.put("app/main/planejamento-scrum/processamento/sprint/views/tabs/backlog/tab-backlog.html","<md-content id=\"tab-backlog\" class=\"md-padding\"><md-fab-speed-dial md-direction=\"left\" \nng-if=\"vm.templateSelecionadoSprintBacklog.view == \'viewTabelaSprintBacklog\'\" class=\"md-scale md-fab-speed-dial-fixo\" \nflex layout-align=\"end start\"><md-fab-trigger><md-button aria-label=\"menu\" \nclass=\"md-fab md-accent md-icon-button sample-show-hide\" \nng-show=\"vm.templateSelecionadoSprintBacklog.view == \'viewTabelaSprintBacklog\'\"><md-icon md-font-icon=\"icon-menu s30\">\n</md-icon></md-button></md-fab-trigger><md-fab-actions><md-button class=\"md-fab md-raised md-mini md-accent\" \naria-label=\"Add\" translate translate-aria-label=\"SPRINT.EXIBIR_ESTORIA_COM_BACKLOG\" \nng-disabled=\"vm.controleForm.emProgresso\" \nng-click=\"vm.metodosBacklog.selecionarTemplate(\'viewParaCadastrarEstoriasNoBacklogListandoEstoriasSemBacklog\')\">\n<md-icon md-font-icon=\"icon-image-filter-none s20\"></md-icon><md-tooltip><span \ntranslate=\"SPRINT.EXIBIR_ESTORIA_COM_BACKLOG\"></span></md-tooltip></md-button><md-button \nclass=\"md-fab md-raised md-mini md-accent\" aria-label=\"Add\" translate \ntranslate-aria-label=\"SPRINT.ADICIONA_ESTORIA_ESPECIFICA_NO_BACKLOG\" ng-disabled=\"vm.controleForm.emProgresso\" \nng-click=\"vm.metodosBacklog.abrirDialogAdicionarEstoriaBacklog($event)\"><md-icon md-font-icon=\"icon-plus-one s20\">\n</md-icon><md-tooltip><span translate=\"SPRINT.ADICIONA_ESTORIA_ESPECIFICA_NO_BACKLOG\"></span></md-tooltip></md-button>\n</md-fab-actions></md-fab-speed-dial><div \nng-if=\"vm.templateSelecionadoSprintBacklog.view !== \'viewTabelaSprintBacklog\'\" layout=\"row\" layout-align=\"end center\" \nflex><div layout=\"row\"><md-button class=\"md-fab md-accent md-icon-button mt-10\" \nng-disabled=\"vm.controleForm.emProgresso\" aria-label=\"Voltar para tabela de Tarefas\" translate \ntranslate-attr-aria-label=\"SPRINT.VOLTAR_TABELA_SPRINT_BACKLOG\" \nng-click=\"vm.metodosBacklog.selecionarTemplate(\'viewTabelaSprintBacklog\')\"><md-icon md-font-icon=\"icon-replay s30\">\n</md-icon><md-tooltip md-autohide><span translate=\"SPRINT.VOLTAR_TABELA_SPRINT_BACKLOG\"></span></md-tooltip>\n</md-button></div><div layout=\"row\" class=\"button-gerar-backlog-fixo\"><md-button \nng-show=\"vm.templateSelecionadoSprintBacklog.cadastroAtivo\" ng-click=\"vm.metodosBacklog.salvarEstoriaBacklog($event)\" \nng-disabled=\"vm.controleForm.emProgresso || vm.estoriasSelecionadas.length == 0\" \nclass=\"send-button md-accent md-raised\" aria-label=\"Gerar Backlog\" translate=\"SPRINT.GERAR_BACKLOG\" \ntranslate-attr-aria-label=\"SPRINT.GERAR_BACKLOG\"></md-button></div></div><div><div \nng-include=\"vm.templateSelecionadoSprintBacklog.url\"></div></div></md-content>");
$templateCache.put("app/main/planejamento-scrum/processamento/sprint/views/tabs/estatisticas/tab-estatisticas.html","<div layout=\"column\" flex><div layout-gt-xs=\"row\" flex><div layout-gt-xs=\"row\" layout-align=\"center center\" flex \nclass=\"mt-15\"><md-card class=\"borda\" flex-gt-xs=\"20\" flex=\"100\" layout-align=\"center center\" \nng-repeat=\"card in vm.cards\"><md-card-header><md-card-header-text layout=\"row\"><strong><span class=\"font-size-16\" \nstyle=\"color: #039BE5\">{{card.titulo}}</span></strong> <i ng-if=\"card.valor == 4\" \nclass=\"icon-information-outline s20 icone-cor-padrao ml-10\" ng-click=\" vm.metodosPontuacao.tresUltimas()\"><md-tooltip \nmd-direction=\"top\"><span>Quatro últimas sprints</span></md-tooltip></i></md-card-header-text></md-card-header>\n<md-card-title ng-class=\"{\'alinhaTexto\':card.valor == 4 && vm.tresUltimas}\"><md-card-title-text><div \nclass=\"blue-fg font-size-40 line-height-40 ng-binding\" ng-if=\"card.valor == 1\">\n{{vm.sprint.estatisticas[0].totalHistoria}}</div><div class=\"purple-fg font-size-40 line-height-40 ng-binding\" \nng-if=\"card.valor == 2\">{{vm.sprint.estatisticas[0].pontuacao}}</div><div \nclass=\"green-fg font-size-40 line-height-40 ng-binding\" ng-if=\"card.valor == 3\">\n{{vm.sprint.estatisticas[0].historiasHomologadas}}</div><div class=\"green-fg font-size-40 line-height-40 ng-binding\" \nng-if=\"!vm.tresUltimas && card.valor == 4\">{{vm.sprint.estatisticas[0].pontuacaoHomologada}}</div><div \nng-repeat=\"estoria in vm.sprint.estatisticas\" ng-if=\"vm.tresUltimas && card.valor == 4\" flex layout=\"column\"><div \nlayout=\"row\" flex class=\"alinharSprint\"><span class=\"font-size-12 blue-fg\">Sprint {{estoria.sprintNumero}}:</span> \n<span class=\"font-size-12 green-fg\">{{estoria.pontuacaoHomologada}}</span></div></div></md-card-title-text>\n</md-card-title><md-card-content><p></p></md-card-content></md-card></div></div><div layout-gt-xs=\"row\" flex><div \nlayout-gt-xs=\"row\" layout-align=\"center center\" flex class=\"mt-15\"><md-card class=\"borda\" flex-gt-xs=\"20\" flex=\"100\" \nlayout-align=\"center center\" ng-repeat=\"cardAnterior in vm.cardsEstoriasAnteriores\"><md-card-header>\n<md-card-header-text layout=\"row\"><strong><span class=\"font-size-16\" \nng-class=\"{\'font-size-15\': cardAnterior.valor == 3}\" style=\"color: #039BE5\">{{cardAnterior.titulo}}</span> </strong>\n<button ng-if=\"cardAnterior.valor == 1 || cardAnterior.valor == 2 ||cardAnterior.valor == 3\" \nng-disabled=\"!((cardAnterior.valor == 1 && vm.sprint.estatisticas[0].totalErros > 0) || \r\n                                               (cardAnterior.valor == 2 && vm.sprint.estatisticas[0].pontuacaoPerdida > 0) ||\r\n                                               (cardAnterior.valor == 3 && vm.sprint.estatisticas[0].totalMelhorias > 0))\" \nng-click=\"vm.metodosPontuacao.abrirDialogVisualizarEstorias(vm.sprint.estatisticas[0], cardAnterior)\"><i \nclass=\"icon-information-outline s20 icone-cor-padrao ml-10\" \nng-disabled=\"!((cardAnterior.valor == 1 && vm.sprint.estatisticas[0].totalErros > 0) || \r\n                                              (cardAnterior.valor == 2 && vm.sprint.estatisticas[0].pontuacaoPerdida > 0) || \r\n                                              (cardAnterior.valor == 3 && vm.sprint.estatisticas[0].totalMelhorias > 0))\">\n<md-tooltip md-direction=\"top\"><span>Visualizar histórias</span></md-tooltip></i></button></md-card-header-text>\n</md-card-header><md-card-title flex><md-card-title-text><div class=\"red-fg font-size-40 line-height-40 ng-binding\" \nng-if=\"cardAnterior.valor == 1\">{{vm.sprint.estatisticas[0].totalErros}}</div><div \nclass=\"red-fg font-size-40 line-height-40 ng-binding\" ng-if=\"cardAnterior.valor == 2\">\n{{vm.sprint.estatisticas[0].pontuacaoPerdida}}</div><div class=\"orange-fg font-size-40 line-height-40 ng-binding\" \nng-if=\"cardAnterior.valor == 3\">{{vm.sprint.estatisticas[0].totalMelhorias}}</div><div \nclass=\"font-size-40 line-height-40 ng-binding\" style=\"color: gold\" ng-if=\"cardAnterior.valor == 4\">\n{{vm.sprint.estatisticas[0].pontuacaoEntregue}}</div></md-card-title-text></md-card-title><md-card-content><p></p>\n</md-card-content></md-card></div></div></div>");
$templateCache.put("app/main/planejamento-scrum/processamento/sprint/views/tabs/burndown/tab-burndown-grafico.html","<div class=\"md-title\">Burndown</div><div class=\"card md-whiteframe-4dp\"><nvd3 options=\"vm.lineChart.options\" \ndata=\"vm.lineChart.data\" class=\"with-3d-shadow with-transitions\"></nvd3></div>");
$templateCache.put("app/main/planejamento-scrum/processamento/sprint/views/tabs/burndown/tab-burndown.html","<div class=\"inserir-button\" layout-gt-xs=\"row\" flex layout-align=\"end center\"><md-button \nclass=\"md-fab md-accent md-icon-button sample-show-hide\" ng-click=\"vm.metodosBurndown.abrirDialogBurndown($event)\" \naria-label=\"Ver gráfico\" translate translate-attr-aria-label=\"SPRINT.INSERIR_REGISTRO\"><md-icon \nmd-font-icon=\"icon-chart-line s30\"></md-icon><md-tooltip md-autohide><span translate=\"SPRINT.VER_BURNDOWN\"></span>\n</md-tooltip></md-button></div><md-content id=\"controle-horas-recursos\" class=\"md-padding\"><table \nclass=\"dataTable row-border hover\" datatable=\"ng\" dt-options=\"vm.dtOptionsSprintRecursos\" width=\"100%\"><thead><tr><th \nclass=\"secondary-text\" ng-repeat=\"titulo in vm.dadosTabela.titulos\"><div class=\"table-header\"><span \nclass=\"column-title\">{{titulo.title}}</span></div></th></tr></thead><tbody><tr \nng-repeat=\"recurso in vm.dadosTabela.recursos\"><td>{{recurso.nome}}</td><td ng-repeat=\"data in recurso.dias\">\n{{data.horas}}</td></tr></tbody></table></md-content>");
$templateCache.put("app/main/planejamento-scrum/processamento/sprint/views/tabs/meta/tab-meta.html","<md-content id=\"tab-metas\" class=\"md-padding\"><div layout=\"row\" layout-align=\"end\" flex><div layout=\"row\" \nlayout-align=\"end center\" layout-align-xs=\"center center\" flex><div class=\"acompanhamento-meta\" layout=\"row\" \nlayout-align=\"end\"><md-button class=\"md-fab md-accent md-icon-button sample-show-hide botao-acompanhamento-meta\" \naria-label=\"Acompanhamento de meta\" translate translate-attr-aria-label=\"SPRINT.ACOMPANHAMENTO_META\" \nng-click=\"vm.metodosMeta.abrirDialogAcompanhamentoMeta()\" ng-disabled=\"vm.sprint.metas <= 0 || vm.desabilitarBotao\">\n<md-icon md-font-icon=\"icon-chart-bar s30\" class=\"icone\" ng-if=\"!vm.requisicaoSolicitada\"></md-icon><div layout=\"row\" \nlayout-align=\"center center\" ng-if=\"vm.requisicaoSolicitada\" flex><md-progress-circular class=\"md-accent\" \nmd-diameter=\"30\" md-mode=\"indeterminate\"></md-progress-circular></div><md-tooltip md-autohide><span \ntranslate=\"SPRINT.ACOMPANHAMENTO_META\"></span></md-tooltip></md-button></div><div class=\"inserir-button\" \nlayout-gt-xs=\"row\" layout-align=\"end\"><md-button class=\"md-fab md-accent md-icon-button sample-show-hide\" \nng-click=\"vm.metodosMeta.abrirDialogMeta($event)\" aria-label=\"Inserir Registro\" translate \ntranslate-attr-aria-label=\"SPRINT.INSERIR_REGISTRO\"><md-icon md-font-icon=\"icon-plus s30\"></md-icon><md-tooltip \nmd-autohide><span translate=\"SPRINT.INSERIR_REGISTRO\"></span></md-tooltip></md-button></div></div></div><div \nclass=\"md-background-bg md-whiteframe-1dp\"><table class=\"dataTable row-border hover\" datatable=\"ng\" \ndt-options=\"vm.dtOptionsMetas\" ng-if=\"vm.habilitarTabela\" width=\"100%\"><thead><tr><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Ação</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Solução</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Descrição</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Meta</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Meta Cumprida</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Quantitativa</span></div></th><th><i \nclass=\"icon-information-outline s28 icone-cor-padrao\" ng-disabled=\"vm.controleForm.emProgresso\" \nng-click=\"vm.metodosMeta.abrirDialogInformacaoCalculoMeta()\"><md-tooltip><span>\nInformações de cálculo do progresso da meta</span></md-tooltip></i></th><th class=\"secondary-text none\"><div \nclass=\"table-header\"><span class=\"column-title\">Histórias:</span></div></th></tr></thead><tbody><tr \nng-repeat=\"meta in vm.sprint.metas track by meta.codigo\" class=\"parent\">{{meta.metasEstorias}}<td class=\"coluna-acao\">\n<i ng-if=\"vm.exibeBotao\" class=\"icon-open-in-new s16 icone-cor-padrao mr-10\" \nng-click=\"vm.controleForm.emProgresso || vm.metodosMeta.abrirDialogMeta($event, meta, true)\" \nng-disabled=\"vm.controleForm.emProgresso\"><md-tooltip><span translate=\"SPRINT.VISUALIZAR_META\"></span></md-tooltip></i>\n<i class=\"icon-pencil s16 icone-cor-padrao mr-5\" \nng-click=\"vm.controleForm.emProgresso || vm.metodosMeta.abrirDialogMeta($event, meta)\" \nng-disabled=\"vm.controleForm.emProgresso\" ng-if=\"!vm.exibeBotao\"></i> <i class=\"icon-delete s16 icone-cor-padrao mr-5\" \nng-click=\"vm.controleForm.emProgresso || vm.metodosMeta.excluirMeta($event, meta)\" \nng-disabled=\"vm.controleForm.emProgresso\" ng-if=\"!vm.exibeBotao\"></i></td><td>{{ meta.solucao.descricao }}</td><td>\n{{ meta.descricao }}</td><td><div ng-repeat=\"tipo in vm.tiposMeta\" ng-if=\"meta.codigoTipoMeta == tipo.codigo\">\n{{ tipo.descricao }}</div><div ng-if=\"!meta.codigoTipoMeta\"></div></td><td style=\"padding: 6px 8px\"><div \nstyle=\"padding: 5px\" ng-hide=\"meta.metasEstorias == undefined || meta.metasEstorias.length <= 0\"><span \nstyle=\"padding: 5px\">{{vm.metodosGeral.calculaMeta(meta.metasEstorias)}}%</span><md-progress-linear \nclass=\"md-accent sombraProgress\" md-mode=\"determinate\" ng-value=\"vm.metodosGeral.calculaMeta(meta.metasEstorias)\">\n</md-progress-linear></div></td><td><p class=\"text-center\">\n{{vm.metodosGeral.calculaConcluidos(meta.metasEstorias)}}/{{meta.metasEstorias.length}}</p></td><td></td><td><div \nlayout=\"row\">{{ vm.metodosGeral.listarNumeroEAnoHistoria(meta.metasEstorias) }}<div class=\"mr-5\" \nng-repeat=\"meta in vm.metasHistorias\">({{ meta.numero }}/{{ meta.ano }})</div></div></td></tr></tbody></table></div>\n</md-content>");
$templateCache.put("app/main/planejamento-scrum/processamento/sprint/views/tabs/pontuacao/tab-pontuacao.html","<div layout=\"row\" flex id=\"tab-pontuacao\"><div layout-xs=\"row\" layout-md=\"column\" flex><md-content \nclass=\"margin-top md-padding\"><table class=\"dataTable row-border hover\" datatable=\"ng\" \ndt-options=\"vm.dtOptionsSprintEstatisticas\" ng-if=\"vm.sprint.colaboradores.pontuacaoDesenvolvida\" width=\"100%\"><thead>\n<tr><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Colaborador</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Pontos desenvolvidos</span></div></th></tr>\n</thead><tbody><tr \nng-repeat=\"colaborador in vm.sprint.colaboradores.pontuacaoDesenvolvida | orderBy:\'nomeDesenvolvedor\'\"><td>\n{{colaborador.nomeDesenvolvedor}}</td><td>{{colaborador.pontuacao.toFixed(2)}}</td></tr></tbody><tfoot><tr \nng-show=\"vm.sprint.colaboradores.pontuacaoDesenvolvida\"><td><strong>Total</strong></td><td><strong>\n{{ vm.metodosPontuacao.calcularTotalPontuacao(vm.sprint.colaboradores.pontuacaoDesenvolvida) }}</strong></td></tr>\n</tfoot></table></md-content></div><md-divider class=\"mt-65 mb-65\"></md-divider><div layout-xs=\"row\" \nlayout-md=\"column\" flex><md-content class=\"margin-top md-padding\"><table class=\"dataTable row-border hover\" \ndatatable=\"ng\" dt-options=\"vm.dtOptionsSprintEstatisticas\" ng-if=\"vm.sprint.colaboradores.pontuacaoHomologada\" \nwidth=\"100%\"><thead><tr><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Colaborador\n</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Pontos homologados\n</span></div></th></tr></thead><tbody><tr \nng-repeat=\"colaborador in vm.sprint.colaboradores.pontuacaoHomologada | orderBy:\'nomeDesenvolvedor\'\"><td>\n{{colaborador.nomeDesenvolvedor}}</td><td>{{colaborador.pontuacao.toFixed(2)}}</td></tr></tbody><tfoot><tr \nng-show=\"vm.sprint.colaboradores.pontuacaoHomologada\"><td><strong>Total</strong></td><td><strong>\n{{ vm.metodosPontuacao.calcularTotalPontuacao(vm.sprint.colaboradores.pontuacaoHomologada) }}</strong></td></tr>\n</tfoot></table></md-content></div></div>");
$templateCache.put("app/main/planejamento-scrum/processamento/sprint/views/tabs/limites/tab-limites.html","<md-content class=\"md-padding\"><div class=\"form-container\"><div layout-gt-xs=\"row\" layout-align=\"center center\">\n<md-input-container class=\"md-block remove-espacamento-top\" flex-gt-sm=\"20\"><label translate=\"SPRINT.SITUACAO\"></label>\n<md-select ng-model=\"vm.situacaoLimiteAceitavel.registroSituacaoCodigo\" \nng-disabled=\"vm.controladorSprint.tabLimites.editar\" name=\"sprintSituacaoLimiteAceitavelSituacaoCodigo\" \nng-required=\"vm.controladorSprint.tabLimites.ativa\"><md-option ng-value=\"situacao.codigo\" \nng-repeat=\"situacao in vm.registrosSituacoes\">{{situacao.descricao}}</md-option></md-select><div \nng-messages=\"vm.form.sprintForm.sprintSituacaoLimiteAceitavelSituacaoCodigo.$error\"><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container><md-input-container class=\"md-block\" \nflex-offset-gt-sm=\"5\" flex-gt-sm=\"10\"><label translate=\"SPRINT.PERCENTUAL\"></label><input type=\"text\" \nng-model=\"vm.situacaoLimiteAceitavel.percentual\" name=\"sprintSituacaoLimiteAceitavelPercentual\" mascara-numeros=\"3\" \nng-required=\"vm.controladorSprint.tabLimites.ativa\"><div \nng-messages=\"vm.form.sprintForm.sprintSituacaoLimiteAceitavelPercentual.$error\"><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container><group-button-horizontal \nclass=\"espacamento-bottom\" flex-offset-gt-sm=\"5\" entidade=\"vm.situacaoLimiteAceitavel\" \nverifica-editar-ativo=\"vm.controladorSprint.tabLimites.editar\" entidades=\"vm.sprint.situacoesLimitesAceitaveis\" \nnome-entidade=\"Limite\" salvar=\"vm.metodosLimite.salvarLimite(vm.situacaoLimiteAceitavel)\" \neditar=\"vm.metodosLimite.editarLimite(vm.situacaoLimiteAceitavel)\" controle-form=\"vm.controleForm\">\n</group-button-horizontal></div></div><md-divider></md-divider><table class=\"dataTable row-border hover\" \ndatatable=\"ng\" dt-options=\"vm.dtOptionsSprintLimites\" ng-if=\"vm.habilitarTabela\" width=\"100%\"><thead><tr><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Ação</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Situação</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Percentual %</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Horas</span></div></th></tr></thead><tbody>\n<tr \nng-repeat=\"situacaoLimiteAceitavel in vm.sprint.situacoesLimitesAceitaveis track by situacaoLimiteAceitavel.codigo\">\n<td><i class=\"icon-pencil s16 icone-cor-padrao mr-10\" \nng-click=\"vm.controleForm.emProgresso || vm.metodosLimite.selecionarLimite(situacaoLimiteAceitavel)\" \nng-disabled=\"vm.controleForm.emProgresso\"><md-tooltip><label translate=\"SPRINT.SELECIONAR_LIMITE\"></label></md-tooltip>\n</i><i class=\"icon-delete s16 icone-cor-padrao mr-10\" \nng-click=\"vm.controleForm.emProgresso || vm.metodosLimite.excluirLimite($event, situacaoLimiteAceitavel)\" \nng-disabled=\"vm.controleForm.emProgresso\"></i></td><td>{{situacaoLimiteAceitavel.sprintRegistroSituacao.descricao}}\n</td><td>{{situacaoLimiteAceitavel.percentual}}%</td><td>{{situacaoLimiteAceitavel.totalHorasLimiteAceitavel}}</td>\n</tr></tbody></table></md-content>");
$templateCache.put("app/main/planejamento-scrum/processamento/sprint/views/tabs/cerimonia-detalhe/tab-cerimonia-detalhe.html","<md-content id=\"tab-cerimonia-detalhes\" class=\"md-padding\"><div class=\"inserir-button\" layout-gt-xs=\"row\" flex \nlayout-align=\"end center\"><md-button class=\"md-fab md-accent md-icon-button sample-show-hide\" \nng-click=\"vm.metodosCerimoniaDetalhe.abrirDialogCerimoniaDetalhe($event)\" aria-label=\"Inserir Cerimonia Detalhe\" \ntranslate translate-attr-aria-label=\"SPRINT.INSERIR_CERIMONIA_DETALHE\"><md-icon md-font-icon=\"icon-plus s30\"></md-icon>\n<md-tooltip md-autohide><span translate=\"SPRINT.INSERIR_CERIMONIA_DETALHE\"></span></md-tooltip></md-button></div><div \nclass=\"md-background-bg md-whiteframe-1dp\"><table class=\"dataTable row-border hover\" datatable=\"ng\" \ndt-options=\"vm.dtOptionsCerimoniaDetalhe\" ng-if=\"vm.habilitarTabela\" width=\"100%\"><thead><tr><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Ação</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Cerimônia</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"texto-margin-left column-title\">Data</span></div></th><th\n class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Hora Início</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Hora Fim</span></div></th></tr></thead>\n<tbody><tr \nng-repeat=\"cerimoniaDetalhe in vm.sprint.detalhesDaCerimonia | orderBy:\'data\':true track by cerimoniaDetalhe.codigo\">\n<td class=\"button-icone-cor-azul\"><i ng-if=\"vm.sprint.numero < vm.sprintCorrenteBindado\" \nclass=\"icon-open-in-new s16 icone-cor-padrao mr-10\" \nng-click=\"vm.controleForm.emProgresso || vm.metodosCerimoniaDetalhe.abrirDialogCerimoniaDetalhe($event, cerimoniaDetalhe, true)\" \nng-disabled=\"vm.controleForm.emProgresso\"><md-tooltip><span translate=\"SPRINT.VISUALIZAR_CERIMONIA_DETALHE\"></span>\n</md-tooltip></i><i class=\"icon-pencil s16 icone-cor-padrao mr-10\" \nng-click=\"vm.controleForm.emProgresso || vm.metodosCerimoniaDetalhe.abrirDialogCerimoniaDetalhe($event, cerimoniaDetalhe)\" \nng-disabled=\"vm.controleForm.emProgresso\"></i> <i class=\"icon-delete s16 icone-cor-padrao\" \nng-click=\"vm.controleForm.emProgresso || vm.metodosCerimoniaDetalhe.excluirCerimoniaDetalhe($event, cerimoniaDetalhe)\" \nng-disabled=\"vm.controleForm.emProgresso\"></i></td><td>{{cerimoniaDetalhe.cerimonia}}</td><td>\n{{cerimoniaDetalhe.data | date:\'dd/MM/yyyy\'}}</td><td>{{cerimoniaDetalhe.horaInicial.substring(0,5)}}</td><td>\n{{cerimoniaDetalhe.horaFinal.substring(0,5)}}</td></tr></tbody></table></div></md-content>");
$templateCache.put("app/main/planejamento-scrum/processamento/sprint/views/tabs/recursos/tab-recursos.html","<md-content id=\"recurso\" class=\"md-padding\"><div class=\"form-container\"><div layout-gt-xs=\"row\" \nlayout-align=\"center center\"><md-input-container flex-gt-sm=\"5\" flex-gt-xs><label hide-gt-sm \ntranslate=\"SPRINT.PESQUISAR_COLABORADOR_POR_CODIGO\"></label><input text=\"text\" ng-model=\"vm.recursoAPesquisar\" \naria-label=\"Diretiva Pesquisar por Codigo\" pesquisar-por-codigo lista-a-pesquisar=\"vm.usuarios\" \nentidade-pesquisada=\"vm.recurso.usuarioCodigo\" mascara-numeros=\"5\"></md-input-container><md-input-container \nclass=\"md-block redefini-margin-top-md-select\" flex-gt-sm=\"20\"><label translate=\"SPRINT.COLABORADOR\"></label><md-select\n ng-model=\"vm.recurso.usuarioCodigo\" name=\"sprintRecursoUsuarioCodigo\" \nmd-on-open=\"vm.metodosRecursos.configuraMdSelectRecursos()\" ng-required=\"vm.controladorSprint.tabRecursos.ativa\">\n<md-select-header><input id=\"tab-recursos-usuario-md-select\" class=\"md-text\" ng-model=\"vm.filtrarRecursos\" \ntype=\"search\" placeholder=\"\" translate translate-attr-placeholder=\"SPRINT.PESQUISAR_COLABORADOR\"></md-select-header>\n<md-option ng-value=\"usuario.codigo\" \nng-repeat=\"usuario in vm.usuarios | filter:vm.filtrarRecursos track by usuario.codigo\">{{usuario.login}}</md-option>\n</md-select><div ng-messages=\"vm.form.sprintForm.sprintRecursoUsuarioCodigo.$error\"><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container><md-input-container class=\"md-block\" \nflex-offset-gt-sm=\"5\" flex-gt-sm=\"10\"><label translate=\"SPRINT.DIAS\"></label><input type=\"text\" \nng-model=\"vm.recurso.dias\" name=\"sprintRecursoDias\" mascara-numeros=\"3\" \nng-required=\"vm.controladorSprint.tabRecursos.ativa\"><div ng-messages=\"vm.form.sprintForm.sprintRecursoDias.$error\">\n<div ng-message=\"required\" translate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container>\n<md-input-container class=\"md-block\" flex-offset-gt-sm=\"5\" flex-gt-sm=\"10\"><label translate=\"SPRINT.HORAS\"></label>\n<input type=\"text\" ng-model=\"vm.recurso.horasFormatadas\" name=\"sprintRecursoHoras\" placeholder=\"\" translate \ntranslate-attr-placeholder=\"SPRINT.EXEMPLO_HORAS\" mascara-numero-generica=\"##:##\" ng-minlength=\"5\" \nng-required=\"vm.controladorSprint.tabRecursos.ativa\"><div ng-messages=\"vm.form.sprintForm.sprintRecursoHoras.$error\">\n<div ng-message=\"required\" translate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div><div ng-message=\"minlength\" \ntranslate=\"MENSAGEM_VALIDACAO.PATTERN_PARA_HORAS\"></div></div></md-input-container><group-button-horizontal \nflex-offset-gt-sm=\"5\" class=\"espacamento-bottom\" verifica-editar-ativo=\"vm.controladorSprint.tabRecursos.editar\" \nentidade=\"vm.recurso\" entidades=\"vm.sprint.recursos\" nome-entidade=\"Recurso\" \nsalvar=\"vm.metodosRecursos.salvarRecurso(vm.recurso)\" editar=\"vm.metodosRecursos.editarRecurso(vm.recurso)\" \ncontrole-form=\"vm.controleForm\"></group-button-horizontal></div><md-divider></md-divider></div><table \nclass=\"dataTable row-border hover\" datatable=\"ng\" dt-options=\"vm.dtOptionsSprintRecursos\" ng-if=\"vm.habilitarTabela\" \nwidth=\"100%\"><thead><tr><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Ação</span>\n</div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Colaborador</span></div>\n</th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Dias</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Valor Diário(Horas)</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Valor Total Sprint (Horas)</span></div>\n</th></tr></thead><tfoot><tr><th>Total:</th><th></th><th></th><th></th><th></th></tr></tfoot><tbody><tr \nng-repeat=\"recurso in vm.sprint.recursos track by recurso.codigo\"><td><i \nclass=\"icon-pencil s16 icone-cor-padrao mr-10\" \nng-click=\"vm.controleForm.emProgresso || vm.metodosRecursos.selecionarRecurso(recurso)\" \nng-disabled=\"vm.controleForm.emProgresso\"><md-tooltip><label translate=\"SPRINT.SELECIONAR_RECURSO\"></label>\n</md-tooltip></i><i class=\"icon-delete s16 icone-cor-padrao\" \nng-click=\"vm.controleForm.emProgresso || vm.metodosRecursos.excluirRecurso($event, recurso)\" \nng-disabled=\"vm.controleForm.emProgresso\"><md-tooltip><label translate=\"SPRINT.SELECIONAR_RECURSO\"></label>\n</md-tooltip></i></td><td>{{recurso.usuario.login}}</td><td>{{recurso.dias}}</td><td>{{recurso.horasFormatadas}}</td>\n<td>{{recurso.totalHoras}}</td></tr></tbody></table></md-content>");
$templateCache.put("app/main/planejamento-scrum/processamento/sprint/views/tabs/registros/tab-registros.html","<md-content class=\"md-padding\"><div class=\"inserir-button\" layout=\"row\" layout-align=\"end center\"><md-button \nclass=\"md-fab md-accent md-icon-button sample-show-hide\" ng-click=\"vm.metodosRegistro.abrirDialogRegistro($event)\" \naria-label=\"Inserir Registro\" translate translate-attr-aria-label=\"SPRINT.INSERIR_REGISTRO\"><md-icon \nmd-font-icon=\"icon-plus s30\"></md-icon><md-tooltip md-autohide><span translate=\"SPRINT.INSERIR_REGISTRO\"></span>\n</md-tooltip></md-button></div><div class=\"md-background-bg md-whiteframe-1dp\"><table \nclass=\"dataTable row-border hover\" datatable=\"ng\" dt-options=\"vm.dtOptionsRegistros\" ng-if=\"vm.habilitarTabela\" \nwidth=\"100%\"><thead><tr><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Ação</span>\n</div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">História</span></div></th>\n<th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Colaborador</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"texto-margin-left column-title\">Data</span></div></th><th\n class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Tempo</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Situação</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Descrição</span></div></th></tr></thead>\n<tfoot><tr><th>Total Tempo:</th><th></th><th></th><th></th><th></th><th></th><th></th></tr></tfoot><tbody><tr \nng-repeat=\"registro in vm.sprint.registros | orderBy:\'data\':true track by registro.codigo\"><td><i \nng-if=\"vm.sprint.numero < vm.sprintCorrenteBindado\" class=\"icon-open-in-new s16 icone-cor-padrao mr-10\" \nng-click=\"vm.controleForm.emProgresso || vm.metodosRegistro.abrirDialogRegistro($event, registro, true)\" \nng-disabled=\"vm.controleForm.emProgresso\"><md-tooltip><span translate=\"SPRINT.VISUALIZAR_REGISTRO\"></span></md-tooltip>\n</i><i class=\"icon-pencil s16 icone-cor-padrao mr-10\" \nng-click=\"vm.controleForm.emProgresso || vm.metodosRegistro.abrirDialogRegistro($event, registro)\" \nng-disabled=\"vm.controleForm.emProgresso\"></i> <i class=\"icon-delete s16 icone-cor-padrao\" \nng-click=\"vm.controleForm.emProgresso || vm.metodosRegistro.excluirRegistro($event, registro)\" \nng-disabled=\"vm.controleForm.emProgresso\"></i></td><td>\n{{registro.estoriaNumero ? registro.estoriaNumero + \"/\" + registro.estoriaAno : \"\"}}</td><td>{{registro.usuario.login}}\n</td><td>{{registro.data | date:\'dd/MM/yyyy\'}}</td><td>{{registro.horas}}</td><td>\n{{registro.registroSituacao.descricao}}</td><td>{{registro.descricao}}</td></tr></tbody></table></div></md-content>");
$templateCache.put("app/main/planejamento-scrum/processamento/sprint/views/tabs/sprint/tab-sprint.html","<md-content id=\"tab-sprint\" class=\"md-padding\"><div class=\"form-container\"><div layout-gt-sm=\"row\"><md-input-container \nng-if=\"vm.squadUsuarioLogado.length > 1\" class=\"md-block\" flex-gt-sm=\"15\" flex><label>Squad</label><md-select \nng-model=\"vm.sprint.squadCodigo\" name=\"squadCodigo\" ng-required=\"true\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.inserirAtivo\" \nng-change=\"vm.metodosSprint.selectChangeSquad(vm.sprint.squadCodigo)\"><md-option ng-value=\"squad.codigo\" \nng-repeat=\"squad in vm.squads track by squad.codigo\">{{squad.descricao}}</md-option></md-select><div \nng-messages=\"vm.form.sprintForm.squadCodigo.$error\"><div ng-message=\"required\">Campo obrigatório</div></div>\n</md-input-container><md-input-container class=\"md-block\" flex-gt-sm=\"15\"><label translate=\"SPRINT.NUMERO\">Número\n</label><input type=\"text\" ng-model=\"vm.sprint.numero\" name=\"sprintNumero\" mascara-numero-generica=\"###\" \nng-required=\"vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.inserirAtivo\"><div \nng-messages=\"vm.form.sprintForm.sprintNumero.$error\"><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container><md-input-container class=\"ml-20\" \nflex-gt-sm=\"20\"><label translate=\"SPRINT.DATAINICIAL\" class=\"alinhar-label-data\"></label><md-datepicker \nng-model=\"vm.sprint.dataInicial\" name=\"sprintDataInicial\" md-max-date=\"vm.sprint.dataFinal\" \nmascara-conversor-string-para-data ng-mask=\"3?9/1?9/9999\" \nng-required=\"vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo\" \nng-disabled=\"!vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\"></md-datepicker><div \nng-messages=\"vm.form.sprintForm.sprintDataInicial.$error\"><div ng-message=\"valid\" \ntranslate=\"MENSAGEM_VALIDACAO.DATA_INVALIDA\"></div><div ng-message=\"maxdate\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_DATA_INICIAL\"></div><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.DATA_OBRIGATORIA\"></div></div></md-input-container><md-input-container class=\"ml-20\" \nflex-gt-sm=\"20\"><label translate=\"SPRINT.DATAFINAL\" class=\"alinhar-label-data\"></label><md-datepicker \nng-model=\"vm.sprint.dataFinal\" name=\"sprintDataFinal\" mascara-conversor-string-para-data ng-mask=\"3?9/1?9/9999\" \nmd-min-date=\"vm.sprint.dataInicial\" ng-required=\"vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo\" \nng-disabled=\"!vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\"></md-datepicker><div \nng-messages=\"vm.form.sprintForm.sprintDataFinal.$error\"><div ng-message=\"valid\" \ntranslate=\"MENSAGEM_VALIDACAO.DATA_INVALIDA\"></div><div ng-message=\"mindate\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_DATA_FINAL\"></div><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.DATA_OBRIGATORIA\"></div></div></md-input-container><md-input-container \nclass=\"md-block ml-20\"><md-checkbox ria-label=\"Meta concluída\" name=\"metaConcluida\" \nng-model=\"vm.sprint.sprintMetaConcluida\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && \r\n                !vm.controleForm.inserirAtivo\">\n<span translate=\"SPRINT.META_CONCLUIDA\"></span></md-checkbox></md-input-container></div><md-input-container \nclass=\"md-block\" flex-gt-sm><label translate=\"SPRINT.DESCRICAO\">Descrição</label><input type=\"text\" \nng-model=\"vm.sprint.descricao\" name=\"sprintDescricao\" mascara-tamanho-campo=\"100\" md-maxlength=\"100\" \nng-required=\"vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\"><div \nng-messages=\"vm.form.sprintForm.sprintDescricao.$error\"><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container></div></md-content>");
$templateCache.put("app/main/planejamento-scrum/processamento/sprint/views/tabs/versao-entregue/tab-versao-entregue.html","<md-content class=\"md-padding\"><div class=\"inserir-button\" layout-gt-xs=\"row\" flex layout-align=\"end center\"><md-button\n class=\"md-fab md-accent md-icon-button sample-show-hide\" \nng-click=\"vm.metodosVersaoEntregue.abrirDialogVersaoEntregue($event)\" aria-label=\"Inserir Versão Entregue\" translate \ntranslate-attr-aria-label=\"SPRINT.INSERIR_VERSAO_ENTREGUE\"><md-icon md-font-icon=\"icon-plus s30\"></md-icon><md-tooltip \nmd-autohide><span translate=\"SPRINT.INSERIR_VERSAO_ENTREGUE\"></span></md-tooltip></md-button></div><div \nclass=\"md-background-bg md-whiteframe-1dp\"><table class=\"dataTable row-border hover\" datatable=\"ng\" \ndt-options=\"vm.dtOptionsVersaoEntregue\" ng-if=\"vm.habilitarTabela\" width=\"100%\"><thead><tr><th class=\"secondary-text\">\n<div class=\"table-header\"><span class=\"column-title\">Ação</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Solução</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Número</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Release</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Compatibilidade</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Data Versão Gerada</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Observação</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Usuário</span></div></th></tr></thead><tbody><tr \nng-repeat=\"versaoEntregue in vm.sprint.versoesEntregues | orderBy: \'dataVersaoGerada\':true track by versaoEntregue.codigo \">\n<td class=\"button-icone-cor-azul\"><i ng-if=\"vm.sprint.numero < vm.sprintCorrenteBindado\" \nclass=\"icon-open-in-new s16 icone-cor-padrao mr-10\" \nng-click=\"vm.controleForm.emProgresso || vm.metodosVersaoEntregue.abrirDialogVersaoEntregue($event, versaoEntregue, true)\" \nng-disabled=\"vm.controleForm.emProgresso\"><md-tooltip><span translate=\"SPRINT.VISUALIZAR_VERSAO_ENTREGUE\"></span>\n</md-tooltip></i><i class=\"icon-pencil s16 icone-cor-padrao mr-10\" \nng-click=\"vm.controleForm.emProgresso || vm.metodosVersaoEntregue.abrirDialogVersaoEntregue($event, versaoEntregue)\" \nng-disabled=\"vm.controleForm.emProgresso\"></i> <i class=\"icon-delete s16 icone-cor-padrao\" \nng-click=\"vm.controleForm.emProgresso || vm.metodosVersaoEntregue.excluirVersaoEntregue($event, versaoEntregue)\" \nng-disabled=\"vm.controleForm.emProgresso\"></i></td><td>{{versaoEntregue.solucao.descricao}}</td><td>\n{{versaoEntregue.numero}}</td><td>{{versaoEntregue.release}}</td><td>{{versaoEntregue.compatibilidade}}</td><td>\n{{versaoEntregue.dataVersaoGerada | date: \'dd/MM/yyyy\'}}</td><td>{{versaoEntregue.observacao}}</td><td>\n{{versaoEntregue.usuario.login}}</td></tr></tbody></table></div></md-content>");
$templateCache.put("app/main/planejamento-scrum/estatisticas/estatistica-individual/sidenavs/filtro/views/filtro-estatistica-individual.html","<div id=\"filtro-estatistica-individual\"><md-toolbar class=\"toolbar md-accent\"><h1 class=\"md-toolbar-tools\">Filtro</h1>\n</md-toolbar><form name=\"vm.form\"><md-content layout-padding flex><fieldset><legend class=\"grp-legend\">Por sprint\n</legend><md-input-container ng-if=\"vm.squadUsuarioLogado.length > 1\" class=\"md-block\" flex-gt-sm=\"100\"><label>Squad\n</label><md-select ng-model=\"vm.filtro.squadCodigo\" name=\"squadCodigo\" ng-required=\"true\" \nng-change=\"vm.metodos.selectChangeSquad(vm.filtro.squadCodigo)\"><md-option ng-value=\"squad.codigo\" \nng-repeat=\"squad in vm.squads track by squad.codigo\">{{squad.descricao}}</md-option></md-select><div \nng-messages=\"vm.form.squadCodigo.$error\"><div ng-message=\"required\">Campo obrigatório</div></div></md-input-container>\n<md-input-container class=\"md-block\" flex-gt-sm=\"100\"><label>Ano</label><md-select name=\"ano\" \nng-model=\"vm.filtro.sprintAno\" ng-change=\"vm.metodos.retornaSprintPorAno(vm.filtro.sprintAno, vm.filtro.squadCodigo)\" \nng-required=\"true\"><md-option ng-repeat=\"item in vm.ano | orderBy:item:true\" ng-value=\"item\">{{ item }}</md-option>\n<md-option ng-if=\"!vm.ano.length\" disabled=\"disabled\">Nenhum ano encontrado.</md-option></md-select><div \nng-messages=\"vm.form.ano.$error\"><div ng-message=\"required\">Campo obrigatório</div></div></md-input-container>\n<multi-select-directive id=\"select-sprints\" form-name=\"leituristas\" data=\"vm.sprint\" model=\"vm.filtro.sprints\" \nobrigatorio=\"true\" descricao-exibicao=\"descricao\" texto-pesquisa-placeholder=\"Procurar sprint...\" \ntexto-placeholder=\"Sprints\" disabled=\"!vm.sprint || !vm.sprint.length\" flex></multi-select-directive></fieldset><div \nclass=\"text-center\"><md-button class=\"md-raised md-accent\" \nng-disabled=\"vm.form.$invalid || !vm.sprint || !vm.sprint.length\" ng-click=\"vm.metodos.filtrarDados(vm.filtro)\">Filtrar\n</md-button></div></md-content></form></div>");
$templateCache.put("app/main/planejamento-scrum/processamento/estoria/views/tabs/clientes/tab-clientes-vinculados.html","<md-content class=\"md-padding container-clientes-vinculados\" ms-scroll><div class=\"form-container\"><div \nclass=\"campo-clientes-vinculados\"><md-autocomplete flex flex-gt-xs md-input-name=\"clienteVinculado\" md-no-cache=\"true\" \nmd-selected-item=\"vm.clienteSelecionado\" md-search-text=\"vm.textoDePesquisaAutoCompleteClienteVinculado\" \nmd-items=\"item in vm.metodosClientesVinculados.pesquisarAutoCompleteClienteVinculado(vm.textoDePesquisaAutoCompleteClienteVinculado)\" \nmd-item-text=\"item.codigo + \' - \' + item.nome\" md-autoselect md-floating-label=\"Cliente\"><md-item-template><span \nmd-highlight-text=\"vm.textoDePesquisaAutoCompleteClienteVinculado\">{{item.codigo}} - {{item.nome}}</span>\n</md-item-template></md-autocomplete><md-button class=\"md-raised md-accent m-10\" ng-disabled=\"!vm.clienteSelecionado\" \nng-click=\"vm.metodosClientesVinculados.vincularCliente(vm.clienteSelecionado)\">Vincular</md-button></div><div \nng-if=\"vm.estoria.clientesVinculados.length > 0\" class=\"tabela-clientes-vinculadas\"><div \nclass=\"fullpage-datatable scrollable\" ms-scroll><table class=\"dataTable row-border hover\" dt-options=\"vm.dtOptions\" \nwidth=\"100%\" style=\"border-bottom: none\"><thead><tr><th class=\"secondary-text border-left\" style=\"padding-left: 10px\">\n<div class=\"table-header\"><span class=\"column-title\">Código</span></div></th><th class=\"secondary-text border-left\">\n<div class=\"table-header\"><span class=\"column-title\">Nome</span></div></th><th class=\"secondary-text border-left\"><div \nclass=\"table-header\"><span class=\"column-title\">Previsão de atualização</span></div></th><th \nclass=\"secondary-text border-left\"><div class=\"table-header\"><span class=\"column-title\">Data da atualização</span>\n</div></th><th class=\"secondary-text border-left\"><div class=\"table-header\"><span class=\"column-title\">Versão</span>\n</div></th><th class=\"secondary-text border-left\"><div class=\"table-header\"><span class=\"column-title\">Responsável\n</span></div></th><th class=\"secondary-text border-left border-right titulo-acoes\"><div class=\"table-header\"><span \nclass=\"column-title\">Ações</span></div></th></tr></thead><tbody \nng-repeat=\"cliente in vm.estoria.clientesVinculados | orderBy: \'-principal\' track by $index\"><tr><td \nclass=\"border-left\" flex>{{cliente.cliente.codigo}}</td><td class=\"border-left\" flex>{{cliente.cliente.nome}}</td><td \nclass=\"border-left\" \nng-dblclick=\"vm.metodosClientesVinculados.abrirDialogEditarInformacoes($event, cliente, \'dataPrevisaoAtualizacao\')\" \nng-disabled=\"vm.controleForm.emProgresso\"><div class=\"border-bottom-azul\">\n{{cliente.dataPrevisaoAtualizacao | date:\'dd/MM/yyyy\'}}</div></td><td class=\"border-left\" \nng-dblclick=\"vm.metodosClientesVinculados.abrirDialogEditarInformacoes($event, cliente, \'dataAtualizacao\')\" \nng-disabled=\"vm.controleForm.emProgresso\"><div class=\"border-bottom-azul\">\n{{cliente.dataAtualizacao | date:\'dd/MM/yyyy\'}}</div></td><td class=\"border-left\" \nng-dblclick=\"vm.metodosClientesVinculados.abrirDialogEditarInformacoes($event, cliente, \'versao\')\" \nng-disabled=\"vm.controleForm.emProgresso\"><div class=\"border-bottom-azul\"><span ng-if=\"cliente.versao\">\n{{cliente.sprintVersaoEntrega.numero}} - {{cliente.sprintVersaoEntrega.release}}{{cliente.sprintVersaoEntrega.compatibilidade ? \' - \' + cliente.sprintVersaoEntrega.compatibilidade : \'\'}}\n</span></div></td><td class=\"border-left\"><div class=\"border-bottom-azul\">\n{{ vm.metodosClientesVinculados.getNomeUsuario(cliente.usuarioCodigo) }}</div></td><td \nclass=\"coluna-acoes border-right border-left text-center\"><i class=\"icon-open-in-new s18 icone-cor-padrao ml-10\" \nng-click=\"vm.metodosClientesVinculados.visualizarCliente(cliente.cliente)\"><md-tooltip><label>\nVisualizar {{cliente.cliente.nome}}</label></md-tooltip></i><i class=\"icon-delete s18 icone-cor-padrao\" \nng-disabled=\"$index === 0 || vm.controleForm.emProgresso\" \nng-click=\"vm.metodosClientesVinculados.desvincularCliente(cliente, $index)\"><md-tooltip ng-if=\"$index !== 0\"><label>\nDesvincular {{cliente.cliente.nome}}</label></md-tooltip></i><i class=\"icon-pencil s18 icone-cor-padrao\" \nng-disabled=\"vm.controleForm.emProgresso\" \nng-click=\"vm.controleForm.emProgresso || vm.metodosClientesVinculados.abrirDialogEditarInformacoes($event, cliente, \'observacao\')\">\n<md-tooltip><label>Editar/Inserir observação para o cliente {{cliente.cliente.nome}}</label></md-tooltip></i></td></tr>\n</tbody></table></div></div></div></md-content>");
$templateCache.put("app/main/planejamento-scrum/processamento/estoria/views/tabs/estimativa/tab-estimativa.html","<md-content><table class=\"dataTable row-border hover\" datatable=\"ng\" dt-options=\"vm.dtOptionsEstoriaEstimativa\" \nwidth=\"100%\"><thead><tr><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Sprint</span>\n</div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Pontuação Inicial</span>\n</div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Pontuação Atual</span></div>\n</th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Pontuação Entregue</span></div>\n</th></tr></thead><tbody><tr ng-repeat=\"estimativa in vm.estoria.estimativas\"><td>{{estimativa.sprintNumero}}</td><td>\n{{estimativa.pontuacaoInicial}}</td><td>{{estimativa.pontuacaoAtual}}</td><td>{{estimativa.pontuacaoEntregue}}</td>\n</tr></tbody></table></md-content>");
$templateCache.put("app/main/planejamento-scrum/processamento/estoria/views/tabs/estoria/tab-estoria.html","<md-content id=\"tab-historia\" class=\"md-padding\" ms-scroll><div class=\"form-container\"><div layout-gt-xs=\"row\" \nflex=\"100\"><md-input-container class=\"md-block\" flex-gt-sm=\"20\" \nng-if=\"vm.squadUsuarioLogado.length > 1 && !(vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo || vm.controleForm.pesquisaAtiva)\">\n<label>Squad</label><md-select ng-model=\"vm.estoria.squadCodigos\" name=\"squadCodigos\" ng-required=\"true\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.inserirAtivo\" \nng-change=\"vm.metodosEstoria.selectChangeMultiplasSquads(vm.estoria.squadCodigos)\" multiple=\"multiple\"><md-option \nng-value=\"squad.codigo\" ng-repeat=\"squad in vm.squads track by squad.codigo\">{{squad.descricao}}</md-option>\n</md-select><div ng-messages=\"vm.estoriaForm.squadCodigos.$error\"><div ng-message=\"required\">Campo obrigatório</div>\n</div></md-input-container><md-input-container class=\"md-block\" flex-gt-sm=\"20\" \nng-if=\"vm.squadUsuarioLogado.length > 1 && (vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo || vm.controleForm.pesquisaAtiva)\">\n<label>Squad</label><md-select ng-model=\"vm.estoria.squadCodigo\" name=\"squadCodigo\" ng-required=\"true\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.inserirAtivo\" \nng-change=\"vm.metodosEstoria.selectChangeSquad(vm.estoria.squadCodigo)\"><md-option ng-value=\"squad.codigo\" \nng-repeat=\"squad in vm.squads track by squad.codigo\">{{squad.descricao}}</md-option></md-select><div \nng-messages=\"vm.estoriaForm.squadCodigo.$error\"><div ng-message=\"required\">Campo obrigatório</div></div>\n</md-input-container><md-input-container class=\"md-block\" flex-gt-sm=\"20\"><label translate=\"ESTORIA.NUMERO\">Número\n</label><input type=\"text\" name=\"estoriaNumero\" define-focus model-focus=\"vm.estoria\" \ndefine-focus-no-campo-quando-nova-pesquisa=\"true\" ng-model=\"vm.estoria.numero\" mascara-numero-generica=\"#####\" \nconverte-mascara-para-numero ng-required=\"vm.controleForm.inserirAtivo \" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.inserirAtivo\"><div \nng-messages=\"vm.estoriaForm.estoriaNumero.$error\"><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container><md-input-container class=\"md-block\" \nflex-gt-sm=\"20\"><label translate=\"ESTORIA.ANO\">Ano</label><input class=\"field-search\" type=\"text\" name=\"estoriaAno\" \nmascara-numero-generica=\"####\" converte-mascara-para-numero ng-model=\"vm.estoria.ano\" \nng-required=\"vm.controleForm.inserirAtivo\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.inserirAtivo\"><div \nng-messages=\"vm.estoriaForm.estoriaAno.$error\"><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container><div \nng-if=\"vm.estoria.situacaoAtualHistoria\" layout=\"row\" layout-align=\"center start\" flex><div class=\"situacao-estoria\" \nng-repeat=\"situacao in vm.coresSituacoes\" ng-if=\"situacao.codigo == vm.estoria.situacaoAtualHistoria.codigo\" \nng-style=\"{\'background-color\': situacao.cor}\" \nng-class=\"{\'estilo-texto-quando-fundo-claro\': situacao.codigo == 1 || situacao.codigo == 3}\" \nlayout-align=\"center center\" flex><span class=\"text-center\">{{vm.estoria.situacaoAtualHistoria.descricao}}</span></div>\n</div></div><div class=\"divider\"></div><div layout-gt-xs=\"row\"><md-input-container md-block style=\"margin-left: -5px\">\n<label translate=\"ESTORIA.DATA_INICIO\" class=\"alinhar-label-data\"></label><md-datepicker name=\"estoriaDataEntrada\" \nmascara-conversor-string-para-data md-max-date=\"vm.estoria.dataEntrega\" ng-model=\"vm.estoria.dataEntrada\" \nng-mask=\"3?9/1?9/9999\" ng-required=\"vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo\" \nng-disabled=\"!vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\"></md-datepicker><div \nng-messages=\"vm.estoriaForm.estoriaDataEntrada.$error\" \nstyle=\"margin-left: -28px; word-wrap: break-word; white-space: normal; max-width: 200px; line-height: 1.2\"><div \nng-message=\"valid\" translate=\"MENSAGEM_VALIDACAO.DATA_INVALIDA\"></div><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.DATA_OBRIGATORIA\"></div><div ng-message=\"maxdate\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_DATA_INICIAL\"></div></div></md-input-container><md-input-container \nclass=\"data-entrega\" md-block style=\"position:relative\"><label translate=\"ESTORIA.DATA_ENTREGA\" \nclass=\"alinhar-label-data\"></label><md-datepicker name=\"estoriaDataEntrega\" mascara-conversor-string-para-data \nmd-min-date=\"vm.estoria.dataEntrada\" ng-model=\"vm.estoria.dataEntrega\" ng-mask=\"3?9/1?9/9999\" \nng-required=\"vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo\" ng-disabled=\"vm.desabilitarDataEntrega\">\n</md-datepicker><div ng-if=\"vm.estoria.prazoAcordado && vm.desabilitarDataEntrega\" \nstyle=\"position:absolute;top:0;left:0;width:100%;height:100%;z-index:2\" \nng-style=\"(vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo) ? {\'cursor\': \'default\'} : {\'cursor\': \'pointer\'}\" \nng-click=\"vm.metodosEstoria.abrirDialogAlterarDataEntrega(vm.estoria, $event)\"><md-tooltip \nng-if=\"!(vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo)\">Editar data de entrega</md-tooltip></div><div \nng-messages=\"vm.estoriaForm.estoriaDataEntrega.$error\" \nstyle=\"margin-left: -28px; word-wrap: break-word; white-space: normal; max-width: 200px; line-height: 1.2\"><div \nng-message=\"valid\" translate=\"MENSAGEM_VALIDACAO.DATA_INVALIDA\"></div><div ng-message=\"mindate\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_DATA_FINAL\"></div><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.DATA_OBRIGATORIA\"></div></div></md-input-container><md-input-container class=\"md-block\">\n<md-checkbox name=\"prazoAcordado\" aria-label=\"PrazoAcordado\" ng-model=\"vm.estoria.prazoAcordado\" \nng-disabled=\"(vm.controleForm.pesquisaAtiva && !((vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo) && vm.estoria.atendimento)) || (!vm.controleForm.pesquisaAtiva && (vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo) && !vm.estoria.atendimento)\">\n<span class=\"float-label-cor-default\">Prazo acordado</span><md-tooltip \nng-if=\"(vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo) && !vm.estoria.atendimento\">\nPara habilitar o campo vincule um atendimento a história</md-tooltip></md-checkbox></md-input-container>\n<md-autocomplete flex flex-gt-xs md-input-name=\"estoriaCliente\" md-no-cache=\"true\" \nmd-selected-item=\"vm.estoria.cliente\" \nmd-selected-item-change=\"vm.metodosEstoria.alterarItemSelecionadoAutoCompleteCliente(item)\" \nmd-search-text=\"vm.textoDePesquisaAutoCompleteCliente\" \nmd-items=\"item in vm.metodosEstoria.pesquisarAutoCompleteCliente(vm.textoDePesquisaAutoCompleteCliente)\" \nmd-item-text=\"item.codigo + \' - \' + item.nome\" md-autoselect md-floating-label=\"Cliente\" \nng-required=\"vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo &&\r\n                             !vm.controleForm.inserirAtivo\">\n<md-item-template><span md-highlight-text=\"vm.textoDePesquisaAutoCompleteCliente\">{{item.codigo}} - {{item.nome}}\n</span></md-item-template><div ng-messages=\"vm.estoriaForm.estoriaCliente.$error\"><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-autocomplete><md-input-container class=\"md-block\" \nflex-offset-gt-sm=\"3\" flex><label translate=\"ESTORIA.SOLUCAO\">Solução</label><md-select name=\"estoriaSolucaoCodigo\" \nmd-on-open=\"vm.metodosEstoria.configuraMdSelectSolucao()\" ng-model=\"vm.estoria.solucaoCodigo\" \nng-required=\"vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo &&\r\n                           !vm.controleForm.inserirAtivo\">\n<md-select-header ng-if=\"vm.solucoes.length > 0\"><input id=\"tab-estoria-solucao-md-select\" class=\"md-text\" \ntype=\"search\" placeholder=\"\" translate translate-attr-placeholder=\"ESTORIA.PESQUISAR_SOLUCAO\" \nng-model=\"vm.filtrarSolucoes\"></md-select-header><md-option \nng-if=\"(vm.estoria.squadCodigo || vm.estoria.squadCodigos.length || (vm.squadUsuarioLogado.length == 1 && !vm.estoria.squadCodigo))\" \nng-value=\"solucao.codigo\" ng-repeat=\"solucao in vm.solucoes | filter:vm.filtrarSolucoes track by solucao.codigo\">\n{{solucao.descricao}}</md-option><md-option \nng-if=\"vm.filtrarCustoSoftware \r\n                                     && vm.solucoes.length === 0\r\n                                     && ((vm.squadUsuarioLogado.length > 1 && (vm.estoria.squadCodigo || vm.estoria.squadCodigos.length))\r\n                                         || (vm.squadUsuarioLogado.length === 1) \r\n                                         || (vm.solucoes | filter:vm.filtrarSolucoes).length === 0)\" \ndisabled=\"disabled\">Nenhuma solução encontrada.</md-option><md-option \nng-if=\"!(vm.estoria.squadCodigo || vm.estoria.squadCodigos.length) && vm.squadUsuarioLogado.length > 1\" \ndisabled=\"disabled\">É necessário informar uma squad.</md-option></md-select><div \nng-messages=\"vm.estoriaForm.estoriaSolucaoCodigo.$error\"><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container></div><div class=\"divider\"></div><div\n layout-gt-xs=\"row\"><md-input-container class=\"md-block\" flex-offset-gt-sm=\"3\" flex-gt-xs><label \ntranslate=\"ESTORIA.CUSTO_SOFTWARE\">Custo por ponto</label><md-select name=\"codigoCustoSoftware\" \nmd-on-open=\"vm.metodosEstoria.configuraMdSelectCustoSoftware()\" ng-model=\"vm.estoria.codigoCustoSoftware\" \nng-required=\"vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo &&\r\n                           !vm.controleForm.inserirAtivo\">\n<md-select-header ng-if=\"vm.listaCustoSoftware.length > 0\"><input id=\"tab-estoria-custo-software-md-select\" \nclass=\"md-text\" type=\"search\" placeholder=\"\" translate translate-attr-placeholder=\"ESTORIA.PESQUISAR_CUSTO_SOFTWARE\" \nng-model=\"vm.filtrarCustoSoftware\" ng-if=\"vm.listaCustoSoftware && vm.listaCustoSoftware.length > 0\">\n</md-select-header><md-option ng-value=\"custo.codigo\" \nng-repeat=\"custo in vm.listaCustoSoftware | filter:vm.filtrarCustoSoftware track by custo.codigo\">{{custo.descricao}}\n</md-option><md-option \nng-if=\"(vm.squadUsuarioLogado.length > 1 && (vm.estoria.squadCodigo || vm.estoria.squadCodigos.length)) && \r\n                                      (vm.listaCustoSoftware.length === 0) || \r\n                                      vm.filtrarCustoSoftware && \r\n                                      (vm.listaCustoSoftware | filter:vm.filtrarCustoSoftware).length === 0\" \ndisabled=\"disabled\">Nenhum projeto encontrado.</md-option><md-option \nng-if=\"!(vm.estoria.squadCodigo || vm.estoria.squadCodigos.length) && vm.squadUsuarioLogado.length > 1\" \ndisabled=\"disabled\">É necessário informar uma squad.</md-option></md-select><div \nng-messages=\"vm.estoriaForm.codigoCustoSoftware.$error\"><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container><md-input-container class=\"md-block\" \nflex-offset-gt-sm=\"3\" flex-gt-xs><label translate=\"ESTORIA.STACK_RESPONSAVEL\">Stack responsável</label><md-select \nname=\"stackResponsavel\" md-on-open=\"vm.metodosEstoria.configuraMdSelectStackResponsavel()\" \nng-required=\"vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo\" ng-model=\"vm.estoria.stackResponsavel\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo &&\r\n                           !vm.controleForm.inserirAtivo\">\n<md-select-header ng-if=\"vm.stack.length > 0\"><input id=\"tab-estoria-stack-responsavel-md-select\" class=\"md-text\" \nng-model=\"vm.filtrarStackResponsavel\" type=\"search\" translate \ntranslate-attr-placeholder=\"ESTORIA.PESQUISAR_STACK_RESPONSAVEL\"></md-select-header><md-option ng-value=\"stack.codigo\" \nng-repeat=\"stack in vm.stack | filter:vm.filtrarStackResponsavel track by stack.codigo\">{{ stack.descricao }}\n</md-option></md-select><div ng-messages=\"vm.estoriaForm.stackResponsavel.$error\"><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container></div><div class=\"divider\"></div><div\n layout-gt-xs=\"row\"><md-input-container class=\"md-block\" flex><label translate=\"ESTORIA.DESCRICAO\"></label><textarea \nname=\"estoriaDescricao\" rows=\"2\" max-rows=\"3\" md-no-resize=\"true\" ng-model=\"vm.estoria.descricao\" \nng-required=\"vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo &&\r\n                          !vm.controleForm.inserirAtivo\">\n\r\n              </textarea><div ng-messages=\"vm.estoriaForm.estoriaDescricao.$error\"><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container></div><div class=\"divider\"></div><div\n layout-gt-xs=\"row\"><md-input-container class=\"md-block\" flex><label translate=\"ESTORIA.TIPO_HISTORIA\">Tipo</label>\n<md-select name=\"tipoHistoria\" ng-model=\"vm.estoria.tipoCodigo\" ng-required=\"vm.controleForm.inserirAtivo\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo &&\r\n                           !vm.controleForm.inserirAtivo\">\n<md-option ng-value=\"tipo.codigo\" ng-repeat=\"tipo in vm.tiposHistoria\">{{tipo.descricao}}</md-option></md-select><div \nng-messages=\"vm.estoriaForm.tipoHistoria.$error\"><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container><md-input-container class=\"md-block\" \nflex><label translate=\"ESTORIA.MOTIVO\">Motivo</label><md-select name=\"estoriaMotivoCodigo\" \nng-model=\"vm.estoria.motivoCodigo\" ng-required=\"vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo &&\r\n                           !vm.controleForm.inserirAtivo\">\n<md-option ng-value=\"motivo.codigo\" ng-repeat=\"motivo in vm.motivos\">{{motivo.descricao}}</md-option></md-select><div \nng-messages=\"vm.estoriaForm.estoriaMotivoCodigo.$error\"><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container><md-input-container class=\"md-block\" \nflex><label translate=\"ESTORIA.NECESSIDADE_CLIENTE\">Necessida Cliente</label><md-select name=\"necessidadeCliente\" \nng-model=\"vm.estoria.necessidadeCliente\" ng-required=\"vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo\" \nng-disabled=\"!vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\"><md-option ng-value=\"key\" \nng-repeat=\"(key, value) in vm.necessidadesCliente\">{{value}}</md-option></md-select><div \nng-messages=\"vm.estoriaForm.necessidadeCliente.$error\"><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container><md-input-container class=\"md-block\" \nflex><label translate=\"ESTORIA.SOLICITACAO\"></label><md-select name=\"solicitacao\" \nmd-on-open=\"vm.metodosEstoria.configuraMdSelectSolicitacao()\" \nmd-on-close=\"vm.metodosEstoria.configurarMdSelectSolicitacaoOnClose()\" ng-model=\"vm.solicitacao\" \nng-model-options=\"{trackBy: \'vm.metodosEstoria.trackSolicitacao($value)\'}\" \nng-change=\"vm.metodosEstoria.selecionarSolicitacao(vm.solicitacao)\" \nng-disabled=\"!vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\"><md-select-header><input \nid=\"tab-estoria-solicitacao-md-select\" class=\"md-text\" type=\"search\" placeholder=\"\" translate \ntranslate-attr-placeholder=\"ESTORIA.PESQUISAR_SOLICITACAO\" ng-model=\"vm.filtrarSolicitacoes\" \nng-if=\"vm.solicitacoes && vm.solicitacoes.length > 0 && vm.estoria.cliente && vm.estoria.squadCodigo\">\n</md-select-header><md-option md-option-empty ng-if=\"vm.solicitacao.ano && vm.solicitacao.numero\">Desmarcar</md-option>\n<md-option ng-value=\"solicitacao\" \nng-if=\"vm.estoria.cliente && vm.estoria.squadCodigo && solicitacao.squadCodigo == vm.estoria.squadCodigo\" \nng-repeat=\"solicitacao in vm.solicitacoes | filter: { descricao: vm.filtrarSolicitacoes }\">{{solicitacao.descricao}}\n</md-option><md-option \nng-if=\"vm.solicitacoes.length == 0 && vm.squadUsuarioLogado.length > 1 && !vm.estoria.cliente || !vm.estoria.squadCodigo\" \ndisabled=\"disabled\">É necessário informar o cliente e a squad.</md-option><md-option \nng-if=\"vm.solicitacoes.length == 0 && !vm.estoria.cliente && vm.squadUsuarioLogado.length === 1\" disabled=\"disabled\">\nÉ necessário informar o cliente.</md-option><md-option \nng-if=\"vm.estoria.cliente && (!vm.solicitacoes || vm.solicitacoes.length == 0)\" disabled=\"disabled\">\nNão existem solicitações vinculadas ao cliente e a squad.</md-option></md-select></md-input-container></div><div \nclass=\"divider\"></div><div layout-gt-sm=\"row\" flex><md-input-container class=\"md-block campo-origem\" flex><label \ntranslate=\"ESTORIA.ORIGEM\">ORIGEM</label><md-select name=\"estoriaOrigemCodigo\" \nmd-on-close=\"vm.metodosEstoria.limparCampoAtendimento(vm.estoria.origem)\" ng-model=\"vm.estoria.origem\" \nng-required=\"vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo\" \nng-disabled=\"!vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\"><md-option ng-value=\"key\" \nng-repeat=\"(key, value) in vm.origens\">{{value}}</md-option></md-select><div \nng-messages=\"vm.estoriaForm.estoriaOrigemCodigo.$error\"><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container><div layout=\"column\" flex=\"25\">\n<md-autocomplete md-input-name=\"atendimento\" md-floating-label=\"Atendimento\" md-no-cache=\"true\" \nmd-selected-item=\"vm.estoria.atendimento\" \nmd-selected-item-change=\"vm.metodosEstoria.alterarItemSelecionadoAutoCompleteAtendimento(item)\" \nmd-search-text=\"vm.textoDePesquisaAutoCompleteAtendimento\" \nmd-items=\"item in vm.metodosEstoria.pesquisarAutoCompleteAtendimento(vm.textoDePesquisaAutoCompleteAtendimento)\" \nmd-item-text=\"item\" md-autoselect ng-blur=\"vm.metodosEstoria.configuraAutoCompleteOnBlurAtendimento()\" \nng-required=\"vm.estoria.origem == 2\" \nng-disabled=\"!vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo || vm.estoria.clienteCodigo == null\" flex>\n<md-item-template><span md-highlight-text=\"vm.textoDePesquisaAutoCompleteAtendimento\">{{ item }}</span>\n</md-item-template><md-not-found><label>Não foi encontrado nenhum atendimento.</label></md-not-found><div \nng-messages=\"vm.estoriaForm.atendimento.$error\"><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-autocomplete></div><md-input-container \nclass=\"md-block\"><md-checkbox name=\"permitirConsultaExterna\" aria-label=\"PermitirConsultaExterna\" \nng-model=\"vm.estoria.permitirConsultaExterna\" \nng-disabled=\"!vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\"><span class=\"float-label-cor-default\" \ntranslate=\"SOLICITACAO.PERMITIR_CONSULTA_EXTERNA\"></span></md-checkbox></md-input-container></div><div class=\"divider\">\n</div><div layout-gt-xs=\"row\"><md-input-container flex-gt-sm=\"5\" flex-gt-xs><label hide-gt-sm \ntranslate=\"ESTORIA.PESQUISAR_USUARIO_POR_CODIGO\"></label><input text=\"text\" aria-label=\"Diretiva Pesquisar por Codigo\" \npesquisar-por-codigo lista-a-pesquisar=\"vm.usuariosSetorDesenvolvimento[0].usuarios\" \nentidade-pesquisada=\"vm.estoria.codigoDesenvolvedor\" mascara-numeros=\"5\" \nng-model=\"vm.usuarioSetorDesenvolvimentoAPesquisar\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo &&\r\n                                    !vm.controleForm.inserirAtivo\" \nng-change=\"vm.metodosEstoria.changeCodigoDesenvolvedor(vm.usuarioSetorDesenvolvimentoAPesquisar)\"></md-input-container>\n<md-input-container class=\"md-block\" flex-gt-sm=\"30\"><label translate=\"ESTORIA.USUARIO_DESENVOLVEDOR\">\nDesenvolvedor responsável pela história</label><md-select name=\"estoriaUsuarioCodigoDesenvolvedores\" \nmd-on-open=\"vm.metodosEstoria.configuraMdSelectDesenvolvedorResponsavel()\" ng-model=\"vm.estoria.codigoDesenvolvedor\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo &&\r\n                           !vm.controleForm.inserirAtivo\" \nng-required=\"vm.exigeInsercaoDesenvolvedor && vm.controleForm.editarAtivo\"><md-select-header><input \nid=\"tab-estoria-desenvolvedorResponsavel-md-select\" class=\"md-text\" type=\"search\" translate \ntranslate-attr-placeholder=\"ESTORIA.PESQUISAR_DESENVOLVEDOR\" ng-model=\"vm.filtrarDesenvolvedores\"></md-select-header>\n<md-option ng-value=\"usuario.codigo\" \nng-repeat=\"usuario in vm.usuariosSetorDesenvolvimento[0].usuarios | filter:vm.filtrarDesenvolvedores track by usuario.codigo\">\n{{usuario.login}}</md-option></md-select><div ng-messages=\"vm.estoriaForm.estoriaUsuarioCodigoDesenvolvedores.$error\">\n<div ng-message=\"required\" translate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container>\n<md-input-container flex-gt-sm=\"5\" flex-offset-gt-sm=\"20\" flex-gt-xs><label hide-gt-sm \ntranslate=\"ESTORIA.PESQUISAR_USUARIO_POR_CODIGO\"></label><input id=\"estoriaUsuarioCodigoTesters\" text=\"text\" \nname=\"estoriaUsuarioCodigoTesters\" aria-label=\"Diretiva Pesquisar por Codigo\" pesquisar-por-codigo \nlista-a-pesquisar=\"vm.usuariosSetorTestes[0].usuarios\" entidade-pesquisada=\"vm.estoria.codigoTester\" \nmascara-numeros=\"5\" ng-model=\"vm.usuarioSetorTesterAPesquisar\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo\r\n                       && !vm.controleForm.inserirAtivo\" \nng-change=\"vm.metodosEstoria.changeCodigoTester(vm.usuarioSetorTesterAPesquisar)\"><div \nng-messages=\"vm.estoriaForm.estoriaUsuarioCodigoTesters.$error\"><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container><md-input-container class=\"md-block\" \nflex-gt-sm=\"30\"><label translate=\"ESTORIA.USUARIO_TESTER\">Tester responsável pela história</label><md-select \nname=\"estoriaUsuarioDescricaoTesters\" md-on-open=\"vm.metodosEstoria.configuraMdTesterResponsavel()\" \nng-model=\"vm.estoria.codigoTester\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo &&\r\n                           !vm.controleForm.inserirAtivo\" \nng-required=\"vm.exigeInsercaoTester && vm.controleForm.editarAtivo\"><md-select-header><input \nid=\"tab-estoria-testerResponsavel-md-select\" class=\"md-text\" type=\"search\" placeholder=\"\" translate \ntranslate-attr-placeholder=\"ESTORIA.PESQUISAR_TESTER\" ng-model=\"vm.filtrarTesters\"></md-select-header><md-option \nng-value=\"usuario.codigo\" \nng-repeat=\"usuario in vm.usuariosSetorTestes[0].usuarios | filter:vm.filtrarTesters track by usuario.codigo\">\n{{usuario.login}}</md-option></md-select><div ng-messages=\"vm.estoriaForm.estoriaUsuarioDescricaoTesters.$error\"><div \nng-message=\"required\" translate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container></div><div \nlayout-gt-xs=\"row\"><md-input-container flex-gt-sm=\"5\" flex-gt-xs><label hide-gt-sm \ntranslate=\"ESTORIA.PESQUISAR_USUARIO_POR_CODIGO\"></label><input text=\"text\" aria-label=\"Diretiva Pesquisar por Codigo\" \npesquisar-por-codigo lista-a-pesquisar=\"vm.usuarios\" entidade-pesquisada=\"vm.estoria.usuarioCodigoAbertura\" \nmascara-numeros=\"5\" ng-model=\"vm.usuarioAberturaAPesquisar\" \nng-disabled=\"vm.controleForm.pesquisaAtiva || vm.controleForm.inserirAtivo ||\r\n                    vm.controleForm.editarAtivo\">\n</md-input-container><md-input-container class=\"md-block\" flex-gt-sm=\"30\"><label translate=\"ESTORIA.USUARIO_ABERTURA\">\nResponsável pela abertura da história</label><md-select name=\"usuarioResponsavelHistoria\" \nmd-on-open=\"vm.metodosEstoria.configuraMdSelectUsuarioResponsavelAbertura()\" \nng-model=\"vm.estoria.usuarioCodigoAbertura\" \nng-disabled=\"vm.controleForm.pesquisaAtiva || vm.controleForm.inserirAtivo ||\r\n                           vm.controleForm.editarAtivo\">\n<md-select-header><input id=\"tab-estoria-usuarioResponsavelHistoria-md-select\" class=\"md-text\" type=\"search\" \nplaceholder=\"\" translate translate-attr-placeholder=\"ESTORIA.PESQUISAR_USUARIO\" ng-model=\"vm.filtrarUsuarios\">\n</md-select-header><md-option ng-value=\"usuario.codigo\" \nng-repeat=\"usuario in vm.usuarios |\r\n                               filter:vm.filtrarUsuarios track by usuario.codigo\">\n{{usuario.login}}</md-option></md-select></md-input-container></div><div class=\"divider\"></div></div></md-content>");
$templateCache.put("app/main/planejamento-scrum/processamento/estoria/views/tabs/historico/tab-historico.html","<md-content><div class=\"inserir-button\" layout-gt-xs=\"row\" flex layout-align=\"end center\"><md-button \nclass=\"md-fab md-accent md-icon-button sample-show-hide\" \nng-click=\"vm.metodosHistorico.abrirDialogEditarHistorico($event)\" ng-disabled=\"vm.ngDisabled\" \nng-hide=\"vm.controladorAtivo\" aria-label=\"Inserir Histórico Situação\" translate \ntranslate-attr-aria-label=\"ESTORIA.INSERIR_HISTORICO_SITUACAO\"><md-icon md-font-icon=\"icon-plus s30\"></md-icon>\n<md-tooltip md-autohide><span translate=\"ESTORIA.INSERIR_HISTORICO_SITUACAO\"></span></md-tooltip></md-button></div><div\n ng-if=\"vm.tabSelecionada == \'historico\'\" class=\"md-background-bg md-whiteframe-1dp\"><table \nclass=\"dataTable row-border hover\" datatable=\"ng\" dt-options=\"vm.dtOptionsHistoricoSituacao\" width=\"100%\"><thead><tr>\n<th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Ação</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Situação</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Usuário</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Data</span></div></th></tr></thead><tbody>\n<tr ng-repeat=\"historicoSituacao in vm.estoria.historicoSituacao | orderBy: \'-data\' track by historicoSituacao.codigo\">\n<td class=\"button-icone-cor-azul\"><i class=\"icon-pencil s16 icone-cor-padrao mr-10\" \nng-click=\"vm.controleForm.emProgresso || vm.metodosHistorico.abrirDialogEditarHistorico($event, $index, historicoSituacao)\" \nng-disabled=\"vm.controleForm.emProgresso\"></i> <i class=\"icon-delete s16 icone-cor-padrao\" \nng-click=\"vm.controleForm.emProgresso || vm.metodosHistorico.excluir($event, historicoSituacao)\" \nng-disabled=\"vm.controleForm.emProgresso\"></i></td><td>{{historicoSituacao.situacao.descricao}}</td><td>\n{{historicoSituacao.usuario.login}}</td><td>{{historicoSituacao.data | date:\'dd/MM/yyyy\'}}</td></tr></tbody></table>\n</div></md-content>");
$templateCache.put("app/main/planejamento-scrum/processamento/estoria/views/tabs/priorizacao/tab-priorizacao.html","<md-content><div class=\"md-padding\" layout-gt-xs=\"row\" layout-align=\"center center\" flex><fieldset><p><strong>BV\n</strong> = Business Value - Visão do cliente (1 a 100), <strong>estimado pelo PO</strong>.</p><p><strong>DF</strong>\n = Dificuldade de implantação - Visão do Time (1.5 - Facil, 2 - Médio, 2.5 - Dificil, 3 - Muito dificil) <strong>\nestimado pelo Time</strong>.</p><p><strong>OR</strong>\n = Origem solicitação (1 - Melhoria/Ajuste, 1.5 - Implementação, 3 - Erro), <strong>estimado pelo PO</strong>.</p><p>\n<strong>CT</strong> = Criticidade (1 - Baixa, 3 - Normal, 5 - Alta, 7 - Urgência), <strong>estimado pelo PO</strong>.\n</p></fieldset></div><div class=\"md-background-bg md-whiteframe-1dp\"><table class=\"dataTable row-border hover\" \ndatatable=\"ng\" dt-options=\"vm.dtOptionsEstoriaPriorizacao\" width=\"100%\"><thead><tr><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Sprint</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Business Value</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Dificuldade</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Origem</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Criticidade</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Prioridade</span></div></th></tr></thead><tbody><tr \nng-repeat=\"priorizacao in vm.estoria.priorizacoes\"><td>{{priorizacao.sprintNumero}}</td><td>\n{{priorizacao.businessValue}}</td><td>{{priorizacao.dificuldadeDescricao}}</td><td>{{priorizacao.origemDescricao}}</td>\n<td>{{priorizacao.criticidadeDescricao}}</td><td>{{priorizacao.prioridade}}</td></tr></tbody></table></div>\n</md-content>");
$templateCache.put("app/main/planejamento-scrum/processamento/estoria/views/tabs/requisito/tab-requisito.html","<md-content class=\"md-padding\" ms-scroll><div class=\"form-container\"><md-tabs md-dynamic-height md-border-bottom>\n<md-tab label=\"Descrição da necessidade\" \nng-disabled=\"!vm.controleForm.pesquisaAtiva || vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo\r\n                    ||vm.controladorEstoria.editarEstimativa || vm.controladorEstoria.editarPriorizacao\r\n                    || vm.controladorEstoria.editarTarefas\">\n<md-tab-label><label translate=\"ESTORIA.DESCRICAO_NECESSIDADE\"></label></md-tab-label><md-tab-body><text-angular \nng-model=\"vm.estoria.estoriaRequisito.descricaoProblema\" \nta-toolbar=\"[[\'h1\', \'h2\', \'h3\', \'h4\', \'h5\', \'h6\', \'p\', \'pre\', \'quote\', \'bold\', \'italics\', \'underline\', \'ul\', \'ol\', \'redo\',                    \'undo\', \'justifyLeft\', \'justifyCenter\', \'justifyRight\', \'justifyFull\', \'indent\', \'outdent\', \'insertImage\', \'clear\']]\" \nta-disabled=\"!vm.controladorEstoria.editarRequisito\"></text-angular></md-tab-body></md-tab><md-tab \nlabel=\"Orientações do desenvolvimento\" \nng-disabled=\"!vm.controleForm.pesquisaAtiva || vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo\r\n                    ||vm.controladorEstoria.editarEstimativa || vm.controladorEstoria.editarPriorizacao\r\n                    || vm.controladorEstoria.editarTarefas\">\n<md-tab-label><label translate=\"ESTORIA.ORIENTACOES_DESENVOLVIMENTO\"></label></md-tab-label><md-tab-body><text-angular \nng-model=\"vm.estoria.estoriaRequisito.orientacoesDesenvolvimento\" \nta-toolbar=\"[[\'h1\', \'h2\', \'h3\', \'h4\', \'h5\', \'h6\', \'p\', \'pre\', \'quote\', \'bold\', \'italics\', \'underline\', \'ul\', \'ol\', \'redo\',                    \'undo\', \'justifyLeft\', \'justifyCenter\', \'justifyRight\', \'justifyFull\', \'indent\', \'outdent\', \'insertImage\', \'clear\']]\" \nta-disabled=\"!vm.controladorEstoria.editarRequisito\"></text-angular></md-tab-body></md-tab><md-tab \nlabel=\"Controle de teste\" \nng-disabled=\"!vm.controleForm.pesquisaAtiva || vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo\r\n                    ||vm.controladorEstoria.editarEstimativa || vm.controladorEstoria.editarPriorizacao\r\n                    || vm.controladorEstoria.editarTarefas\">\n<md-tab-label><label translate=\"ESTORIA.CONTROLE_TESTES\"></label></md-tab-label><md-tab-body><text-angular \nng-model=\"vm.estoria.estoriaRequisito.controleTestes\" \nta-toolbar=\"[[\'h1\', \'h2\', \'h3\', \'h4\', \'h5\', \'h6\', \'p\', \'pre\', \'quote\', \'bold\', \'italics\', \'underline\', \'ul\', \'ol\', \'redo\', \'undo\', \'justifyLeft\', \'justifyCenter\', \'justifyRight\', \'justifyFull\', \'indent\', \'outdent\', \'insertImage\', \'clear\']]\" \nta-disabled=\"!vm.controladorEstoria.editarRequisito\"></text-angular></md-tab-body></md-tab><md-tab label=\"Retorno\" \nng-disabled=\"!vm.controleForm.pesquisaAtiva || vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo\r\n                    ||vm.controladorEstoria.editarEstimativa || vm.controladorEstoria.editarPriorizacao\r\n                    || vm.controladorEstoria.editarTarefas\" \nng-if=\"vm.estoria.existeRetorno\"><md-tab-label><label translate=\"ESTORIA.RETORNO\"></label></md-tab-label><md-tab-body>\n<text-angular ng-model=\"vm.estoria.estoriaRequisito.retorno\" \nta-toolbar=\"[[\'h1\', \'h2\', \'h3\', \'h4\', \'h5\', \'h6\', \'p\', \'pre\', \'quote\', \'bold\', \'italics\', \'underline\', \'ul\', \'ol\', \'redo\', \'undo\', \'justifyLeft\', \'justifyCenter\', \'justifyRight\', \'justifyFull\', \'indent\', \'outdent\', \'insertImage\', \'clear\']]\" \nta-disabled=\"!vm.controladorEstoria.editarRequisito\"></text-angular></md-tab-body></md-tab></md-tabs><div \nlayout-gt-xs=\"row\" layout-align=\"end end\"><group-button ng-disabled=\"\" ng-disabled-excluir=\"true\" \ntoolbar-pre-loader=\"vm.controleForm.preLoaderToolbar\" entidade=\"vm.estoria.estoriaRequisito\" \nregistro-existente=\"vm.estoria.estoriaRequisito.estoriaNumero && vm.estoria.estoriaRequisito.estoriaAno ? true : false\" \ncontrolador-ativo=\"vm.controladorEstoria.editarRequisito\" \nsalvar=\"vm.metodosRequisito.salvarRequisito(vm.estoria.estoriaRequisito)\" \neditar=\"vm.metodosRequisito.editarRequisito(vm.estoria.estoriaRequisito)\"></group-button></div></div></md-content>");
$templateCache.put("app/main/planejamento-scrum/processamento/estoria/views/tabs/tarefas/tab-tarefas.html","<md-content id=\"estoria-tab-tarefas\" ms-scroll><div class=\"inserir-button\" layout=\"row\" flex><md-fab-speed-dial \nmd-direction=\"left\" class=\"md-scale\" flex layout-align=\"end center\"><md-fab-trigger><md-button \nclass=\"md-fab md-accent md-icon-button sample-show-hide\" \nng-hide=\"vm.templateSelecionadoEstoriaTarefa.view == \'viewTabelaTarefasDaEstoria\'\" \naria-label=\"Voltar para tabela de Tarefas\" translate translate-attr-aria-label=\"ESTORIA.VOLTAR_TABELA_TAREFAS\" \nng-click=\"vm.metodosTarefa.selecionarTemplate()\"><md-icon md-font-icon=\"icon-replay s30\"></md-icon><md-tooltip \nmd-autohide><span translate=\"ESTORIA.VOLTAR_TABELA_TAREFAS\"></span></md-tooltip></md-button><md-button \naria-label=\"menu\" class=\"md-fab md-accent md-icon-button sample-show-hide\" \nng-show=\"vm.templateSelecionadoEstoriaTarefa.view == \'viewTabelaTarefasDaEstoria\'\"><md-icon \nmd-font-icon=\"icon-menu s30\"></md-icon></md-button></md-fab-trigger><md-fab-actions><md-button \nclass=\"md-fab md-raised md-mini md-accent\" aria-label=\"Add\" translate \ntranslate-aria-label=\"ESTORIA.INSERIR_TAREFAS_NA_ESTORIA_ESTORIA\" \nng-click=\"vm.metodosTarefa.abrirDialogTarefas($event)\"><md-icon md-font-icon=\"icon-plus s30\"></md-icon><md-tooltip>\n<span translate=\"ESTORIA.INSERIR_TAREFAS_NA_ESTORIA_ESTORIA\"></span></md-tooltip></md-button><md-button \nclass=\"md-fab md-raised md-mini md-accent\" aria-label=\"Inserir tarefas cadastradas na rotina\" translate \ntranslate-attr-aria-label=\"ESTORIA.SELECIONAR_TAREFAS_A_INSERIR_NA_ESTORIA\" \nng-click=\"vm.metodosTarefa.selecionarTemplate()\"><md-icon md-font-icon=\"icon-playlist-plus s30\"></md-icon><md-tooltip \nmd-autohide><span translate=\"ESTORIA.SELECIONAR_TAREFAS_A_INSERIR_NA_ESTORIA\"></span></md-tooltip></md-button>\n</md-fab-actions></md-fab-speed-dial></div><div><div ng-if=\"vm.tabSelecionada == \'tarefas\'\" \nng-include=\"vm.templateSelecionadoEstoriaTarefa.url\"></div></div></md-content>");
$templateCache.put("app/main/planejamento-scrum/processamento/estoria/views/tabs/faturamento/tab-faturamento.html","<md-content class=\"md-padding\" ms-scroll><div class=\"form-container\"><div layout-gt-xs=\"row\"><md-input-container \nclass=\"md-block\"><md-checkbox ng-model=\"vm.estoria.faturarAParte\" ng-change=\"vm.metodos.ngChangeFaturarAParte()\" \naria-label=\"Faturar a parte\" name=\"faturarAParte\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\"><span \nclass=\"float-label-cor-default\" translate=\"ESTORIA.FATURAR_A_PARTE\"></span></md-checkbox></md-input-container></div>\n<fieldset ng-show=\"vm.estoria.faturarAParte\"><legend><label translate=\"ESTORIA.FATURAMENTO\"></label></legend><div \nlayout=\"column\" flex><md-radio-group ng-model=\"vm.estoria.faturamentoRealizado\"><md-radio-button ng-value=\"true\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\" \naria-label=\"Realizado\">Realizado</md-radio-button><md-radio-button ng-value=\"false\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\" \naria-label=\"Não Realizado\">Não Realizado</md-radio-button></md-radio-group><div layout-gt-xs=\"row\" \nng-show=\"!vm.estoria.faturamentoRealizado\"><md-input-container class=\"md-block\" flex><label \ntranslate=\"ESTORIA.MOTIVO_NAO_FATURAMENTO\"></label><textarea ng-model=\"vm.estoria.motivoNaoFaturamento\" \nname=\"motivoNaoFaturamento\" ng-required=\"!vm.estoria.faturamentoRealizado\" md-no-resize=\"true\" md-maxlength=\"100\" \nmaxlength=\"100\" \nng-disabled=\"(vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo)\">\n\r\n\r\n                                  </textarea><div \nng-messages=\"\r\n                                  vm.estoriaForm.motivoNaoFaturamento.$error\"><div \nng-message=\"required\" translate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container></div></div>\n</fieldset></div></md-content>");
$templateCache.put("app/main/trabalhe-conosco/cadastro/categoria/views/tabs/habilidades-categoria/tab-habilidades-categoria.html","<md-content id=\"recurso\" class=\"md-padding\"><div class=\"form-container\"><div layout-gt-xs=\"row\" \nlayout-align=\"center center\"><md-autocomplete flex-gt-sm=\"30\" flex-offset-gt-sm=\"5\" flex-gt-xs \nmd-input-name=\"habilidade\" md-no-cache=\"true\" ng-blur=\"vm.metodosHabilidade.configuraAutoCompleteHabilidadeOnBlur()\" \nng-required=\"true\" md-selected-item=\"vm.habilidadeAdicionada.descricao\" \nmd-selected-item-change=\"vm.metodosHabilidade.alterarItemSelecionadoAutoCompleteHabilidade(item)\" \nmd-search-text=\"vm.textoDePesquisaAutoCompleteHabilidade\" \nmd-items=\"item in vm.metodosHabilidade.pesquisarAutoCompleteHabilidade(vm.textoDePesquisaAutoCompleteHabilidade)\" \nmd-item-text=\"item.descricao\" md-autoselect md-floating-label=\"Habilidade\" ng-disabled=\"\"><md-item-template><span \nmd-highlight-text=\"vm.textoDePesquisaAutoCompleteHabilidade\">{{item.descricao}}</span></md-item-template><md-not-found>\n<label>Não foi encontrado nenhuma Habilidade.</label></md-not-found><div ng-messages=\"vm.form.habilidade.$error\"><div \nng-message=\"required\" translate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-autocomplete><md-button \nclass=\"md-raised md-accent\" style=\"margin-bottom: 34px\" flex-offset-gt-sm=\"5\" flex-gt-sm=\"10\" aria-label=\"Adicionar\" \ntranslate translate-attr-aria-label=\"TRABALHE_CONOSCO_AREAS_ATUACAO.ADICIONAR\" \nng-click=\"vm.metodosHabilidade.adicionarHabilidadeCategoria()\" ng-disabled=\"!vm.controladorBotaoAdicionar\"><span \ntranslate=\"TRABALHE_CONOSCO_AREAS_ATUACAO.ADICIONAR\"></span></md-button></div><md-divider></md-divider></div><table \nclass=\"dataTable row-border hover\" datatable=\"ng\" dt-options=\"vm.dtOptionsLog\"><thead><tr><th class=\"secondary-text\">\n<div class=\"table-header\"><span class=\"column-title\">Ação</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title text-center\">Habilidade</span></div></th></tr></thead><tbody><tr \nng-repeat=\"habilidade in vm.categoria.habilidades\"><td><i class=\"icon-delete s16 icone-cor-padrao\" \nng-click=\"vm.controleForm.emProgresso || \r\n                                     vm.metodosHabilidade.excluirHabilidade(habilidade)\" \nng-disabled=\"vm.controleForm.emProgresso\"><md-tooltip><label \ntranslate=\"TRABALHE_CONOSCO_AREAS_ATUACAO.EXCLUIR_HABILIDADE\"></label></md-tooltip></i></td><td class=\"text-center\">\n{{habilidade.descricao}}</td></tr></tbody></table></md-content>");
$templateCache.put("app/main/trabalhe-conosco/cadastro/area-atuacao/views/tabs/habilidades-area/tab-habilidades-area-atuacao.html","<md-content id=\"recurso\" class=\"md-padding\"><div class=\"form-container\"><div layout-gt-xs=\"row\" \nlayout-align=\"center center\"><md-autocomplete flex-gt-sm=\"30\" flex-offset-gt-sm=\"5\" flex-gt-xs \nmd-input-name=\"habilidade\" md-no-cache=\"true\" ng-blur=\"vm.metodosHabilidade.configuraAutoCompleteHabilidadeOnBlur()\" \nng-required=\"true\" md-selected-item=\"vm.habilidadeAdicionada.descricao\" \nmd-selected-item-change=\"vm.metodosHabilidade.alterarItemSelecionadoAutoCompleteHabilidade(item)\" \nmd-search-text=\"vm.textoDePesquisaAutoCompleteHabilidade\" \nmd-items=\"item in vm.metodosHabilidade.pesquisarAutoCompleteHabilidade(vm.textoDePesquisaAutoCompleteHabilidade)\" \nmd-item-text=\"item.descricao\" md-autoselect md-floating-label=\"Habilidade\" ng-disabled=\"vm.EditandoHabilidade\">\n<md-item-template><span md-highlight-text=\"vm.textoDePesquisaAutoCompleteHabilidade\">{{item.descricao}}</span>\n</md-item-template><md-not-found><label>Não foi encontrado nenhuma Habilidade.</label></md-not-found><div \nng-messages=\"vm.form.areaatuacao.habilidade.$error\"><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-autocomplete><md-input-container class=\"md-block\" \nflex-offset-gt-sm=\"5\" flex-gt-sm=\"10\"><label translate=\"TRABALHE_CONOSCO_AREAS_ATUACAO.PESO\"></label><input \ntype=\"text\" ng-model=\"vm.habilidadeAdicionada.peso\" name=\"pesoHabilidadeAreaAtuacao\" mascara-numeros=\"2\" \nng-required=\"true\" ng-change=\"vm.metodosHabilidade.onChangePeso()\"><div \nng-messages=\"vm.form.areaatuacao.pesoHabilidadeAreaAtuacao.$error\"><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container><md-button \nclass=\"md-raised md-accent\" style=\"margin-bottom: 34px\" flex-offset-gt-sm=\"5\" flex-gt-sm=\"10\" \naria-label=\"vm.TextoBotao\" \nng-click=\"vm.metodosHabilidade.verificaOperacaoHabilidade(vm.TextoBotao, vm.habilidadeAdicionada)\" \nng-disabled=\"!vm.controladorBotaoAdicionar\"><span>{{vm.TextoBotao}}</span></md-button><md-button \nclass=\"md-raised md-accent\" style=\"margin-bottom: 34px\" flex-offset-gt-sm=\"2\" flex-gt-sm=\"10\" aria-label=\"Cancelar\" \nng-show=\"vm.EditandoHabilidade\" \nng-click=\"vm.metodosHabilidade.cancelaEdicaoHabilidade(vm.TextoBotao, vm.habilidadeAdicionada)\"><span>Cancelar</span>\n</md-button></div><md-divider></md-divider></div><table class=\"dataTable row-border hover\" datatable=\"ng\" \ndt-options=\"vm.dtOptionsLog\"><thead><tr><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Ação</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title text-center\">Habilidade</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span\n class=\"column-title text-center\">Peso</span></div></th></tr></thead><tbody><tr \nng-repeat=\"habilidade in vm.area.exigencias\"><td><i class=\"icon-pencil s16 icone-cor-padrao mr-10\" \nng-click=\"vm.controleForm.emProgresso || vm.metodosHabilidade.selecionarHabilidade($index, habilidade)\" \nng-disabled=\"vm.controleForm.emProgresso\"><md-tooltip><label \ntranslate=\"TRABALHE_CONOSCO_AREAS_ATUACAO.EDITAR_HABILIDADE\"></label></md-tooltip></i><i \nclass=\"icon-delete s16 icone-cor-padrao\" \nng-click=\"vm.controleForm.emProgresso || vm.metodosHabilidade.excluirHabilidade(habilidade)\" \nng-disabled=\"vm.controleForm.emProgresso\"><md-tooltip><label \ntranslate=\"TRABALHE_CONOSCO_AREAS_ATUACAO.EXCLUIR_HABILIDADE\"></label></md-tooltip></i></td><td class=\"text-center\">\n{{habilidade.descricao}}</td><td class=\"text-center\"><input type=\"text\" \nstyle=\"background: transparent;text-align: center\" id=\"peso_{{habilidade.codigoHabilidade}}\" \nname=\"peso_{{habilidade.codigoHabilidade}}\" ng-model=\"habilidade.peso\" \nng-change=\"vm.metodosHabilidade.onChangePesoTabela(habilidade)\" maxlength=\"2\" \nng-disabled=\"vm.habilidadeIndexSelecionada != $index\"></td></tr></tbody></table></md-content>");
$templateCache.put("app/main/protecao/processamento/gerenciamento-protecao/views/dialog/protecao/protecao-dialog.html","<md-dialog id=\"quantidade-licenca-dialog\" class=\"dialogo-padrao\" aria-label=\"Dialog\" style=\"max-width: 450px\"><form \nname=\"quantidadeLicencaForm\" class=\"md-inline-form\" novalidate><md-toolbar class=\"md-accent md-tall\" layout=\"column\">\n<div class=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" layout-align=\"space-between center\"><span \nclass=\"title\">Número licença: {{vm.numeroLicenca}}</span><md-button class=\"md-icon-button\" \nng-click=\"vm.metodosDialog.fecharDialog()\" aria-label=\"Fechar dialog\" translate \ntranslate-attr-aria-label=\"ESTORIA.FECHAR_DIALOG\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div>\n</md-toolbar><md-progress-linear class=\"md-accent\" ng-show=\"vm.requisicaSolicitada\" md-mode=\"indeterminate\">\n</md-progress-linear><md-dialog-content style=\"width: 450px\"><md-input-container class=\"md-block\" \nlayout-align=\"center center\" flex-offset=\"5\" flex><label translate=\"GERENCIAMENTO_PROTECAO.CHAVE_PROTECAO\"></label>\n<input type=\"text\" ng-required=\"true\" ng-model=\"vm.protecaoLicenca\" name=\"protecaoLicenca\" ng-disabled=\"true\" \nmascara-numero-generica=\"###\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\">\n</md-input-container></md-dialog-content></form></md-dialog>");
$templateCache.put("app/main/trabalhe-conosco/cadastro/area-atuacao/views/tabs/responsabilidades-area/tab-responsabilidades-area-atuacao.html","<md-content class=\"md-padding\" ms-scroll><div class=\"form-container\"><md-tabs md-dynamic-height md-border-bottom>\n<md-tab label=\"Descrição da responsabilidade\" \nng-disabled=\"!vm.controleForm.pesquisaAtiva || \r\n                                  vm.controleForm.editarAtivo || \r\n                                  vm.controleForm.inserirAtivo || \r\n                                  vm.controladorArea.editarResposabilidade\">\n<md-tab-label><label translate=\"TRABALHE_CONOSCO_AREAS_ATUACAO.DESCRICAO_RESPONSABILIDADE\"></label></md-tab-label>\n<md-tab-body><text-angular ng-model=\"vm.area.responsabilidades\" \nta-toolbar=\"[[\'h1\', \'h2\', \'h3\', \'h4\', \'h5\', \'h6\', \'p\', \'pre\', \'quote\', \'bold\', \'italics\', \'underline\', \'ul\', \'ol\', \'redo\',                    \'undo\', \'justifyLeft\', \'justifyCenter\', \'justifyRight\', \'justifyFull\', \'indent\', \'outdent\', \'insertImage\', \'clear\']]\" \nta-disabled=\"!vm.controladorArea.editarResposabilidade\"></text-angular></md-tab-body></md-tab></md-tabs><div \nlayout-gt-xs=\"row\" layout-align=\"end end\"><group-button ng-disabled=\"\" ng-disabled-excluir=\"true\" \ntoolbar-pre-loader=\"vm.controleForm.preLoaderToolbar\" entidade=\"vm.area\" \nregistro-existente=\"vm.area.codigo ? true : false\" controlador-ativo=\"vm.controladorArea.editarResposabilidade\" \nsalvar=\"vm.metodosResponsabilidade.salvarResponsabilidade(vm.area)\" \neditar=\"vm.metodosResponsabilidade.editarResponsabilidade(vm.area)\"></group-button></div></div></md-content>");
$templateCache.put("app/main/protecao/processamento/gerenciamento-protecao/views/dialog/quantidade-licenca/quantidade-licenca-dialog.html","<md-dialog id=\"quantidade-licenca-dialog\" class=\"dialogo-padrao\" aria-label=\"Dialog\" style=\"max-width: 450px\"><form \nname=\"quantidadeLicencaForm\" class=\"md-inline-form\" novalidate><md-toolbar class=\"md-accent md-tall\" layout=\"column\">\n<div class=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" layout-align=\"space-between center\"><span \nclass=\"title\">{{vm.licenca.tipoLicenca.descricao}}</span><md-button class=\"md-icon-button\" \nng-click=\"vm.metodosDialog.fecharDialog()\" aria-label=\"Fechar dialog\" translate \ntranslate-attr-aria-label=\"ESTORIA.FECHAR_DIALOG\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div>\n</md-toolbar><md-progress-linear class=\"md-accent\" ng-show=\"vm.requisicaSolicitada\" md-mode=\"indeterminate\">\n</md-progress-linear><md-dialog-content style=\"width: 450px\"><md-input-container class=\"md-block\" \nlayout-align=\"cneter center\" flex-offset=\"5\" flex><label translate=\"GERENCIAMENTO_PROTECAO.QUANTITATIVO_LICENCA\">\n</label><input type=\"text\" ng-required=\"true\" ng-model=\"vm.licenca.quantidadeTotal\" name=\"quantidadeLicenca\" \nmascara-numero-generica=\"###\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\">\n</md-input-container></md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"space-between center\"><div \nlayout=\"row\" layout-align=\"start center\"><md-button type=\"submit\" ng-click=\"vm.metodosDialog.salvar($event)\" \nclass=\"send-button md-accent md-raised\" \nng-disabled=\"quantidadeLicencaForm.$invalid || quantidadeLicencaForm.$pristine || vm.requisicaSolicitada \" \naria-label=\"SALVAR\" translate=\"ESTORIA.SALVAR\" translate-attr-aria-label=\"ESTORIA.SALVAR\">Salvar</md-button></div>\n</md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/protecao/processamento/gerenciamento-protecao/views/dialog/detalhes/detalhes-dialog.html","<md-dialog id=\"quantidade-licenca-dialog\" class=\"dialogo-padrao\" aria-label=\"Dialog\" style=\"max-width: 450px\"><form \nname=\"quantidadeLicencaForm\" class=\"md-inline-form\" novalidate><md-toolbar class=\"md-accent md-tall\" layout=\"column\">\n<div class=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" layout-align=\"space-between center\"><span \nclass=\"title\">Número licença: {{vm.licencaSelecionada.numero}}</span><md-button class=\"md-icon-button\" \nng-click=\"vm.metodosDialog.fecharDialog()\" aria-label=\"Fechar dialog\" translate \ntranslate-attr-aria-label=\"ESTORIA.FECHAR_DIALOG\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div>\n<md-progress-linear class=\"md-accent\" ng-show=\"vm.requisicaSolicitada\" md-mode=\"indeterminate\"></md-progress-linear>\n</md-toolbar><md-progress-linear class=\"md-accent\" ng-show=\"vm.requisicaSolicitada\" md-mode=\"indeterminate\">\n</md-progress-linear><md-dialog-content style=\"width: 450px\"><div \nng-repeat=\"item in vm.licencaSelecionada.tiposLicencas\"><div flex layout-gt-sm=\"row\"><div flex \nlayout-align=\"end center\" layout-gt-sm=\"row\"><span>{{item.descricao}}:</span></div><div flex \nlayout-align=\"start center\" layout-gt-sm=\"row\"><md-icon style=\"color:green\" md-font-icon=\"icon-checkbox-marked-circle\" \nclass=\"s30\"></md-icon></div></div></div></md-dialog-content></form></md-dialog>");
$templateCache.put("app/main/atendimento/estatisticas/tags/components/sidenavs/filtro/views/filtro-estatisticas-tags.html","<div id=\"filtro-estatisticas-tags\"><md-toolbar class=\"toolbar md-accent\" layout=\"row\" \nlayout-align=\"space-between center\"><h1 class=\"md-toolbar-tools\">Filtro</h1><md-button class=\"md-icon-button\" \nng-click=\"vm.metodos.fecharSidenav()\" aria-label=\"Fechar dialog\"><md-icon md-font-icon=\"icon-close\" \nclass=\"cor-icone-button-flutuante s26\"></md-icon><md-tooltip>Fechar sidenav</md-tooltip></md-button></md-toolbar><form \nname=\"vm.form\"><md-content layout-padding flex><fieldset class=\"standard referencia-fieldset\"><legend \nclass=\"grp-legend\">Referência</legend><div layout=\"row\" layout-align=\"center center\" flex class=\"container-referencia\">\n<md-input-container class=\"md-block\" flex-gt-sm=\"15\"><label>Mês</label><input type=\"text\" ui-number-mask=\"0\" \nng-required=\"true\" ng-blur=\"vm.metodos.setDefaultMes()\" name=\"mes\" min-value=\"1\" max-value=\"12\" ng-required=\"true\" \nng-model=\"vm.filtroTags.mes\"></md-input-container><md-input-container class=\"md-block\" flex-gt-sm=\"20\"><label>Ano\n</label><input type=\"text\" name=\"ano\" ng-blur=\"vm.metodos.setDefaultAno()\" ui-number-mask=\"0\" ui-hide-group-sep \nng-required=\"true\" ng-model=\"vm.filtroTags.ano\"></md-input-container></div></fieldset><fieldset class=\"standard\" \nng-if=\"!vm.desabilitarSidenav\"><legend class=\"grp-legend\">Cliente</legend><div layout=\"row\" \nlayout-align=\"center center\" flex><md-autocomplete flex md-input-name=\"cliente\" md-no-cache=\"true\" \nng-blur=\"vm.metodos.configuraAutoCompleteClienteOnBlur()\" md-selected-item=\"vm.pesquisa.cliente\" \nmd-selected-item-change=\"vm.metodos.alterarItemSelecionadoAutoCompleteCliente(item)\" \nmd-search-text=\"vm.textoDePesquisaAutoCompleteCliente\" \nmd-items=\"item in vm.metodos.pesquisarAutoCompleteCliente(vm.textoDePesquisaAutoCompleteCliente)\" \nmd-item-text=\"item.codigo + \' - \' + item.nome\" md-autoselect md-floating-label=\"Cliente\"><md-item-template><span \nmd-highlight-text=\"vm.textoDePesquisaAutoCompleteCliente\">{{item.codigo}} - {{item.nome}}</span></md-item-template>\n<md-not-found><label>Não foi encontrado nenhum Cliente.</label></md-not-found><div \nng-messages=\"vm.form.cliente.$error\"><div ng-message=\"required\" translate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div>\n</div></md-autocomplete></div></fieldset><fieldset class=\"standard\"><legend class=\"grp-legend\">Tags</legend><div \nlayout=\"row\" layout-align=\"center center\" flex style=\"width: 415px!important\"><md-input-container flex><label>Tags\n</label><md-select ng-model=\"vm.filtroTags.tags\" name=\"tags\" multiple=\"multiple\" \nmd-on-open=\"vm.metodos.configuraMdSelectTags()\"><md-select-header ng-if=\"vm.todasTagsCadastradas.length > 0\"><input \nid=\"card-tags-atendimento-md-select\" class=\"md-text\" ng-model=\"vm.filtrarTags\" type=\"search\" \nplaceholder=\"Pesquisar Tags\"></md-select-header><md-option ng-value=\"tag.codigo\" \nng-repeat=\"tag in vm.todasTagsCadastradas | filter:vm.filtrarTags | orderBy:\'descricao\' track by tag.codigo\">\n{{tag.descricao}}</md-option></md-select></md-input-container></div></fieldset><div layout=\"column\" \nlayout-align=\"center center\" flex><md-progress-circular md-mode=\"indeterminate\" class=\"md-accent\" md-diameter=\"40\" \nng-if=\"vm.emProgresso\"></md-progress-circular><md-button class=\"md-raised md-accent\" \nng-disabled=\"vm.form.$invalid || vm.emProgresso\" ng-click=\"vm.metodos.pesquisarBotao(vm.filtroTags)\" \nng-if=\"!vm.emProgresso\"><span>Pesquisar</span></md-button></div></md-content></form></div>");
$templateCache.put("app/main/financeiro/processamento/contratos/views/tabs/tab-historico-contratos/dialog-prioritario/dialog-prioritario.html","<md-dialog id=\"dialog-contrato-historico\" class=\"dialogo-padrao\" aria-label=\"Dialog\" style=\"width: 10%\"><form \nname=\"vm.form\" class=\"md-inline-form\" novalidate><md-toolbar class=\"md-accent md-tall\" layout=\"column\"><div \nclass=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\">\n{{vm.titulo}}</span><md-button class=\"md-icon-button\" ng-click=\"vm.metodos.fecharDialog()\" aria-label=\"Fechar dialog\" \ntranslate translate-attr-aria-label=\"CLIENTE.FECHAR_DIALOG\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button>\n</div></md-toolbar><div class=\"mt-10\" layout=\"column\" layout-align=\"center center\" \nng-if=\"vm.controladorDialog.requisicaoSolicitada\"><span class=\"font-weight-500\">\n{{vm.controladorDialog.mensagemPreloader}}</span><md-progress-circular class=\"md-accent\" md-mode=\"indeterminate\" \nmd-diameter=\"30\"></md-progress-circular></div><md-dialog-content><div layout=\"column\" layout-gt-sm=\"row\">\n<md-input-container class=\"md-block\" flex-offset=\"5\"><md-checkbox aria-label=\"Prioritario\" name=\"prioritario\" \nng-model=\"vm.contratoHistorico.prioritario\" ng-disabled=\"vm.apenasVisualizacao\"><span class=\"float-label-cor-default\">\nPrioritário</span></md-checkbox></md-input-container></div></md-dialog-content><md-dialog-actions layout=\"column\" \nlayout-gt-sm=\"row\" layout-align=\"space-between center\" style=\"justify-content: center; padding: 0px\"><div layout=\"row\" \nlayout-align=\"start center\"><md-button class=\"send-button md-accent md-raised\" type=\"submit\" aria-label=\"SALVAR\" \ntranslate=\"CLIENTE.SALVAR\" translate-attr-aria-label=\"CLIENTE.SALVAR\" \nng-click=\"vm.metodos.atualizarPrioritario(vm.contratoHistorico)\" \nng-disabled=\"vm.form.$invalid || vm.form.$pristine || vm.controladorDialog.requisicaoSolicitada\">Salvar</md-button>\n</div></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/financeiro/processamento/contratos/views/tabs/tab-historico-contratos/dialog-historico-contratos/dialog-contratos-historico.html","<md-dialog id=\"dialog-contrato-historico\" class=\"dialogo-padrao\" aria-label=\"Dialog\" \nng-class=\"{\'tamanho-dialog-prioritario\':vm.apenasPrioritario}\"><form name=\"vm.form\" class=\"md-inline-form\" novalidate>\n<md-toolbar class=\"md-accent md-tall\" layout=\"column\"><div class=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" \nlayout-align=\"space-between center\"><span class=\"title\">Histórico contrato</span><md-button class=\"md-icon-button\" \naria-label=\"Fechar dialog\" translate translate-attr-aria-label=\"CLIENTE.FECHAR_DIALOG\" \nng-click=\"vm.metodos.fecharDialog()\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><div \nclass=\"mt-10\" layout=\"column\" layout-align=\"center center\" ng-if=\"vm.controladorDialog.requisicaoSolicitada\"><span \nclass=\"font-weight-500\">{{vm.controladorDialog.mensagemPreloader}}</span><md-progress-circular md-mode=\"indeterminate\" \nmd-diameter=\"30\" class=\"md-accent\"></md-progress-circular></div><md-dialog-content><div layout=\"column\" \nlayout-gt-sm=\"row\"><md-input-container class=\"md-block\" flex><label translate=\"CLIENTE.CONTRATO_ITEM\"></label>\n<md-select name=\"item\" md-on-open=\"vm.metodos.configuraMdSelectItem()\" \nng-model=\"vm.contratoHistorico.codigoContratoItem\" \nng-change=\"vm.metodos.changeContratoItem(vm.itensContrato, vm.contratoHistorico.codigoContratoItem)\" \nng-disabled=\"vm.emProgresso || vm.apenasVisualizacao || vm.editarAtivo\" \nng-required=\"vm.motivoAditivo.permitirReajuste || vm.editarAtivo\"><md-select-header><input \nid=\"cliente-dialog-historico-item-md-select\" class=\"md-text\" type=\"search\" translate \ntranslate-attr-placeholder=\"CLIENTE.CONTRATO_ITEM\" ng-model=\"vm.filtrarItem\"></md-select-header><md-option \nng-value=\"0\">Contrato</md-option><md-option ng-value=\"item.codigo\" \nng-repeat=\"item in vm.itensContrato | filter:vm.filtrarItem track by $index\">{{item.produto.descricao}}</md-option>\n</md-select><div ng-messages=\"vm.form.item.$error\"><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container><md-input-container class=\"md-block\" \nflex ng-if=\"!vm.apenasPrioritario\"><label translate=\"CLIENTE.COLABORADOR\"></label><input type=\"text\" \nname=\"usuarioLogado\" ng-model=\"vm.usuarioLogado.nome\" ng-disabled=\"true\"></md-input-container><md-input-container \nclass=\"md-block\" flex-offset=\"5\" ng-if=\"!vm.apenasPrioritario\"><label translate=\"CLIENTE.DATA\"></label><md-datepicker \nname=\"data\" ng-model=\"vm.contratoHistorico.data\" ng-required=\"!vm.editarAtivo\" ng-mask=\"3?9/1?9/9999\" \nmd-min-date=\"vm.dataMinimaHistorico\" \nng-disabled=\"vm.apenasVisualizacao || vm.contratoHistorico.codigoContratoItem == undefined || vm.editarAtivo\">\n</md-datepicker><div ng-messages=\"vm.form.data.$error\"><div ng-message=\"valid\" \ntranslate=\"MENSAGEM_VALIDACAO.DATA_INVALIDA\"></div><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div><div ng-message=\"mindate\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_DATA_ATUAL\"></div></div></md-input-container><md-input-container class=\"md-block\" \nflex-offset=\"5\"><md-checkbox aria-label=\"Prioritario\" name=\"prioritario\" ng-model=\"vm.contratoHistorico.prioritario\" \nng-disabled=\"vm.apenasVisualizacao || vm.editarAtivo || vm.contratoHistorico.codigoContratoItem == undefined\"><span \nclass=\"float-label-cor-default\">Prioritário</span></md-checkbox></md-input-container></div><div layout=\"column\" \nlayout-gt-sm=\"row\" ng-if=\"!vm.apenasPrioritario\"><md-input-container class=\"md-block\" flex \nng-if=\"vm.subitensDoItemSelecionado.length > 0\"><label>Subitem</label><md-select name=\"subitem\" \nng-model=\"vm.subitemSelecionadoUi\" ng-change=\"vm.metodos.changeSubitem(vm.subitemSelecionadoUi)\" \nng-disabled=\"vm.apenasVisualizacao || vm.editarAtivo\" ng-required=\"true\"><md-option ng-value=\"\'todos\'\" \nng-if=\"vm.subitensDoItemSelecionado.length > 1\">Todos</md-option><md-option ng-value=\"subitem.codigo\" \nng-repeat=\"subitem in vm.subitensDoItemSelecionado track by subitem.codigo\">{{subitem.descricaoProduto}}</md-option>\n</md-select><div ng-messages=\"vm.form.subitem.$error\"><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container><md-input-container class=\"md-block\" \nflex><label translate=\"CLIENTE.STATUS_CONTRATO\"></label><md-select name=\"statusContrato\" \nng-model=\"vm.contratoHistorico.codigoStatusContrato\" ng-required=\"!vm.editar\" \nng-disabled=\"vm.apenasVisualizacao || vm.contratoHistorico.codigoContratoItem == undefined || vm.editarAtivo\" \nng-if=\"!vm.apenasPrioritario\"><md-option ng-value=\"statusContrato.codigo\" \nng-repeat=\"statusContrato in vm.statusContratos track by statusContrato.codigo\">{{statusContrato.descricao}}\n</md-option></md-select><div ng-messages=\"vm.form.statusContrato.$error\"><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container><md-input-container class=\"md-block\" \nflex-offset=\"5\" flex><label translate=\"CLIENTE.MOTIVO_ADITIVO\"></label><md-select name=\"motivoAditivo\" \nng-required=\"!vm.editarAtivo\" ng-model=\"vm.contratoHistorico.codigoMotivoAditivo\" \nng-change=\"vm.metodos.changeMotivoAditivo(vm.contratoHistorico.codigoMotivoAditivo)\" \nng-disabled=\"vm.apenasVisualizacao || vm.contratoHistorico.codigoContratoItem == undefined || vm.editarAtivo\" \nng-if=\"!vm.apenasPrioritario\"><md-option ng-value=\"motivoAditivo.codigo\" \nng-repeat=\"motivoAditivo in vm.motivosAditivos track by motivoAditivo.codigo\">{{motivoAditivo.descricao}}</md-option>\n</md-select><div ng-messages=\"vm.form.motivoAditivo.$error\"><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container><md-input-container class=\"md-block\" \nflex-offset=\"5\" flex \nng-if=\"vm.exibirValorMensal || (!vm.exibirValorMensal && vm.apenasVisualizacao && vm.contratoHistorico.valorReajuste == null)\">\n<label translate=\"CONTRATOS.VALOR_INICIAL\"></label><input type=\"text\" ng-model=\"vm.contratoHistorico.valor\" \nname=\"valor\" mascara-tamanho-campo=\"12\" ui-money-mask ng-required=\"true\" \nng-disabled=\"vm.apenasVisualizacao || vm.contratoHistorico.codigoContratoItem == undefined || vm.editarAtivo\" \nng-if=\"!vm.apenasPrioritario\"><div ng-messages=\"vm.form.valor.$error\"><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container></div><div layout=\"column\" \nlayout-gt-sm=\"row\" ng-if=\"!vm.exibirValorMensal && (vm.contratoHistorico.valorReajuste != null || vm.inserirAtivo)\" \nflex style=\"align-items: flex-start\"><md-input-container class=\"md-block\" flex ng-if=\"!vm.apenasPrioritario\"><label \ntranslate=\"CONTRATOS.TIPO_AJUSTE\"></label><md-select ng-model=\"vm.contratoHistorico.tipoReajuste\" name=\"tipoReajuste\" \nng-change=\"vm.contratoHistorico.valorReajuste && vm.metodos.resultadoValorAjustado() \" \nng-disabled=\"vm.apenasVisualizacao || !vm.motivoAditivo.permitirReajuste || vm.editarAtivo\" \nng-if=\"!vm.apenasPrioritario\"><md-option ng-value=\"1\">Acréscimo</md-option><md-option ng-value=\"2\">Desconto</md-option>\n</md-select></md-input-container><md-input-container class=\"md-block\" flex-offset=\"5\" flex \nng-if=\"!vm.apenasPrioritario\" ng-hide=\"vm.contratoHistorico.codigoContratoItem == 0\"><label translate=\"CONTRATOS.TIPO\">\n</label><md-select ng-model=\"vm.contratoHistorico.tipoReajusteValor\" name=\"tipoReajusteValor\" \nng-required=\"!vm.exibirValorMensal && vm.motivoAditivo.permitirReajuste\" ng-change=\"vm.metodos.zeraValorAjuste()\" \nng-disabled=\"vm.apenasVisualizacao || !vm.motivoAditivo.permitirReajuste || vm.contratoHistorico.codigoContratoItem == 0 || vm.editarAtivo\" \nng-if=\"!vm.apenasPrioritario\"><md-option ng-value=\"1\">%</md-option><md-option ng-value=\"2\">R$</md-option></md-select>\n<div ng-messages=\"vm.form.tipoReajusteValor.$error\"><div ng-message=\"required\" \nng-hide=\"!vm.motivoAditivo.permitirReajuste\" translate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div>\n</md-input-container><md-input-container class=\"md-block\" flex-offset=\"5\" flex \nng-if=\"vm.contratoHistorico.tipoReajusteValor == 2 && !vm.apenasPrioritario\"><label translate=\"CONTRATOS.VALOR_AJUSTE\">\n</label><input type=\"text\" ng-model=\"vm.contratoHistorico.valorReajuste\" name=\"valorReajuste\" ui-money-mask \nng-change=\"vm.metodos.resultadoValorAjustado()\" mascara-tamanho-campo=\"12\" ng-required=\"!vm.exibirValorMensal\" \nng-disabled=\"vm.contratoHistorico.tipoReajusteValor == null || vm.apenasVisualizacao || !vm.motivoAditivo.permitirReajuste || vm.editarAtivo\" \nng-if=\"!vm.apenasPrioritario\"><div ng-messages=\"vm.form.valorReajuste.$error\"><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div><div ng-message=\"descontoMaximo\">\nO desconto não pode ser superior ao valor atual</div></div></md-input-container><md-input-container class=\"md-block\" \nflex-offset=\"5\" flex ng-if=\"vm.contratoHistorico.tipoReajusteValor == 1 && !vm.apenasPrioritario\"><label \ntranslate=\"CONTRATOS.VALOR_AJUSTE\"><i class=\"icon-information-outline s20 icone-cor-padrao\" \nng-if=\"vm.contratoHistorico.codigoContratoItem == 0\" style=\"font-size: 16px; vertical-align: middle; margin-left: 5px\">\n<md-tooltip class=\"tooltip-multiline-textos\">O valor deve ser referente ao percentual de reajuste do contrato.\n</md-tooltip></i></label><input type=\"text\" name=\"valorReajuste\" mascara-tamanho-campo=\"10\" ui-percentage-mask=\"6\" \nng-model=\"vm.contratoHistorico.valorReajuste\" ng-change=\"vm.metodos.resultadoValorAjustado()\" \nng-required=\"!vm.exibirValorMensal\" \nng-disabled=\"vm.contratoHistorico.tipoReajusteValor == null || vm.apenasVisualizacao || !vm.motivoAditivo.permitirReajuste || vm.editarAtivo\" \nng-if=\"!vm.apenasPrioritario\"><div ng-messages=\"vm.form.valorReajuste.$error\"><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div><div ng-message=\"descontoMaximo\">\nO desconto não pode ser superior a 100%</div></div></md-input-container><md-input-container class=\"md-block\" \nflex-offset=\"5\" flex ng-if=\"vm.contratoHistorico.tipoReajusteValor == 1 && !vm.apenasPrioritario\"><label \ntranslate=\"CONTRATOS.VALOR_APOS_AJUSTE\"></label><input type=\"text\" name=\"valorContratoAposReajuste\" \nmascara-tamanho-campo=\"12\" ui-money-mask ng-model=\"vm.diferencaValor\" ng-disabled=\"true\"></md-input-container><div \nlayout-gt-sm=\"row\" layout=\"column\" flex-offset=\"5\" flex-gt-sm=\"25\" flex style=\"align-items: center\" \nng-if=\"!vm.apenasPrioritario\"><ms-widget class=\"md-accent-bg card-alinhar\" flex><div class=\"card-valor-total\"><div \nlayout-align=\"center center\" ng-if=\"vm.contratoHistorico.codigoContratoItem > 0\"><label class=\"h3\">\n{{vm.subitensDoItemSelecionado.length > 0 ? (vm.subitemSelecionadoUi === \'todos\' ? \'Valor atual dos subitens\' : \'Valor atual do subitem\') : \'Valor atual do item\'}}\n</label><div class=\"h3 white-fg card-valor\" \nng-if=\"vm.contratoHistorico.valorContratoAposReajuste >=0 && !vm.apenasPrioritario\">\n{{vm.contratoHistorico.valorContratoAposReajuste | currency}}</div></div><div \nng-if=\"vm.contratoHistorico.codigoContratoItem == undefined || vm.contratoHistorico.codigoContratoItem == 0\"><div \nclass=\"texto-contrato\"><label class=\"h3\">Valor atual do contrato</label><md-icon \nmd-font-icon=\"icon-information-outline s20\" style=\"color: white\"><md-tooltip md-direction=\"top\"><span>\nAtenção! Pode haver diferença de centavos entre os valores exibidos na tabela, do valor total do contrato devido a questões de arredondamento.\n</span></md-tooltip></md-icon></div><div class=\"h3 white-fg card-valor\">{{vm.valorContrato | currency}}</div></div>\n</div><div class=\"pt-8 pb-32\" layout=\"column\" layout-align=\"center center\"><div \nclass=\"white-fg font-size-72 line-height-72\"></div></div></ms-widget></div></div><div layout=\"column\" \nlayout-gt-sm=\"row\" ng-if=\"!vm.apenasPrioritario\"><md-input-container class=\"md-block\" flex><label \ntranslate=\"CLIENTE.OBSERVACOES\"></label><textarea name=\"observacoes\" max-rows=\"4\" md-maxlength=\"500\" \nmascara-tamanho-campo=\"500\" md-no-resize=\"true\" ng-required=\"vm.editarAtivo\" \nng-model=\"vm.contratoHistorico.observacoes\" ng-disabled=\"vm.apenasVisualizacao\">\r\n                    </textarea><div \nng-messages=\"vm.form.observacoes.$error\"><div ng-message=\"required\" translate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\">\n</div></div></md-input-container></div></md-dialog-content><md-dialog-actions layout=\"column\" layout-gt-sm=\"row\" \nlayout-align=\"space-between center\" ng-if=\"!vm.apenasVisualizacao\"><div layout=\"row\" layout-align=\"start center\">\n<md-button class=\"send-button md-accent md-raised\" type=\"submit\" aria-label=\"SALVAR\" translate=\"CLIENTE.SALVAR\" \ntranslate-attr-aria-label=\"CLIENTE.SALVAR\" ng-click=\"vm.metodos.salvar($event, vm.contratoHistorico)\" \nng-disabled=\"vm.form.$invalid || vm.form.$pristine || vm.controladorDialog.requisicaoSolicitada\">Salvar</md-button>\n</div></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/geral/brainstorming/brainstorming/views/tabs/respostas/dialog-resposta/brainstorming-dialog-cadastro-resposta.html","<md-dialog class=\"dialogo-padrao\" aria-label=\"Dialog\"><form name=\"respostaForm\" class=\"md-inline-form\" novalidate>\n<md-toolbar class=\"md-accent md-tall\" layout=\"column\"><div class=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" \nlayout-align=\"space-between center\"><span class=\"title\">Resposta</span><md-button class=\"md-icon-button\" \nng-click=\"vm.metodosDialog.fecharDialog()\" aria-label=\"Fechar dialog\" translate \ntranslate-attr-aria-label=\"Fechar dialog\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar>\n<div layout=\"row\" layout-sm=\"row\" layout-align=\"center\" ng-show=\"vm.requisicaSolicitada || vm.preloader.habilitar\">\n<md-progress-circular md-mode=\"indeterminate\" class=\"md-accent\"></md-progress-circular></div><md-dialog-content \nng-hide=\"vm.requisicaSolicitada || vm.preloader.habilitar\"><div layout=\"row\" flex><md-input-container class=\"md-block\" \nflex-gt-sm=\"80\"><label translate=\"BRAINSTORMING.RESPOSTA\">Resposta</label><textarea type=\"text\" \nname=\"respostaDescricao\" ng-model=\"vm.resposta.descricao\" md-no-resize=\"false\" rows=\"1\" ng-required=\"true\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo\"></textarea><div \nng-messages=\"vm.respostaForm.respostaDescricao.$error\"><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container><md-input-container class=\"md-block\" \nflex-gt-sm=\"20\"><label translate=\"BRAINSTORMING.USUARIO\">Usuário</label><md-select \nng-model=\"vm.resposta.codigoUsuario\" name=\"respostaCodigoUsuario\" ng-required=\"vm.controleForm.inserirAtivo\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.inserirAtivo\"><md-option \nng-value=\"vm.usuarioLogado.codigo\">{{vm.usuarioLogado.login}}</md-option><md-option ng-value=\"0\">ANÔNIMO</md-option>\n</md-select></md-input-container></div></md-dialog-content><md-dialog-actions layout=\"row\" \nlayout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><md-button type=\"submit\" \nng-click=\"vm.metodosDialog.salvar(vm.resposta)\" class=\"send-button md-accent md-raised\" \nng-disabled=\"!vm.resposta.descricao\" aria-label=\"SALVAR\" translate-attr-aria-label=\"BRAINSTORMING.SALVAR\">Salvar\n</md-button></div></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/geral/cadastro/cliente/cliente/views/tabs/configuracoes/configuracoes-form.html","<md-content id=\"tab-configuracoes\" ng-form=\"vm.formConfiguracoes\"><div class=\"form-container\"><md-tabs \nmd-dynamic-height md-border-bottom><md-tab label=\"Reader\" md-active=\"vm.tabSelecionada === \'reader\'\" \nmd-on-select=\"vm.metodosTab.tabSelecionada(\'reader\')\" ng-disabled=\"!vm.utilizaReader\"><md-tab-label><label \ntranslate=\"CLIENTE.READER\"></label></md-tab-label><md-tab-body><div ng-if=\"vm.utilizaReader\" \nng-include=\"vm.htmlRota.cliente.tabs.tabConfiguracaoReader\"></div></md-tab-body></md-tab><md-tab label=\"IService\" \nmd-active=\"vm.tabSelecionada === \'iService\'\" md-on-select=\"vm.metodosTab.tabSelecionada(\'iService\')\" \nng-disabled=\"!vm.utilizaIService\"><md-tab-label><label translate=\"CLIENTE.ISERVICE\"></label></md-tab-label>\n<md-tab-body><div ng-if=\"vm.utilizaIService\" ng-include=\"vm.htmlRota.cliente.tabs.tabConfiguracaoiService\"></div>\n</md-tab-body></md-tab><md-tab label=\"IAguas\" md-active=\"vm.tabSelecionada === \'iAguas\'\" \nmd-on-select=\"vm.metodosTab.tabSelecionada(\'iAguas\')\" ng-disabled=\"!vm.utilizaIAguas\"><md-tab-label><label \ntranslate=\"CLIENTE.IAGUAS\"></label></md-tab-label><md-tab-body><div ng-if=\"vm.utilizaIAguas\" \nng-include=\"vm.htmlRota.cliente.tabs.tabConfiguracaoiAguas\"></div></md-tab-body></md-tab></md-tabs></div></md-content>");
$templateCache.put("app/main/geral/cadastro/cliente/cliente/views/tabs/dados-auxiliares/tab-cliente-dados-auxiliares.html","<md-content class=\"mt-10\" ng-form=\"vm.formDadosAuxiliares\"><fieldset class=\"standard\" flex=\"100\"><legend \nclass=\"grp-legend\" translate=\"CLIENTE.DADOS_AUXILIARES\"></legend><div layout-gt-xs=\"row\" flex><md-input-container \nclass=\"md-block\" flex=\"25\"><label translate=\"CLIENTE.NUMERO_LIGACOES\"></label><input type=\"text\" \nng-model=\"vm.cliente.numeroLigacoes\" name=\"numeroLigacoes\" mascara-numero-generica=\"##########\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\">\n</md-input-container><md-input-container class=\"md-block\" flex-offset=\"5\" flex=\"25\"><label \ntranslate=\"CLIENTE.QUANTIDADE_AGENTES\"></label><input type=\"text\" ng-model=\"vm.cliente.quantidadeAgentes\" \nname=\"quantidadeAgentes\" mascara-numero-generica=\"##########\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\">\n</md-input-container><md-input-container class=\"md-block\" flex-offset=\"5\" flex-gt-sm=\"50\"><label \ntranslate=\"CLIENTE.SEGMENTACAO\"></label><md-select name=\"codigoSegmentacao\" ng-model=\"vm.cliente.codigoSegmentacao\" \nng-required=\"vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\"><md-option\n ng-value=\"segmentacao.codigo\" ng-repeat=\"segmentacao in vm.segmentacoes\">{{segmentacao.descricao}}</md-option>\n</md-select></md-input-container></div></fieldset></md-content>");
$templateCache.put("app/main/geral/cadastro/cliente/cliente/views/tabs/faturamento/tab-cliente-faturamento.html","<md-content class=\"mt-10\"><div layout-gt-xs=\"row\"><md-input-container class=\"md-block\" flex=\"50\"><label \ntranslate=\"CLIENTE.FORMA_PAGAMENTO\"></label><md-select ng-model=\"vm.cliente.codigoFormaPagamento\" \nname=\"formaPagamento\" md-on-open=\"vm.metodosCliente.configuraMdSelectFormaPagamento()\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\">\n<md-select-header><input id=\"cliente-form-forma-pagamento-md-select\" class=\"md-text\" \nng-model=\"vm.filtrarFormaPagamento\" type=\"search\" placeholder=\"\" translate \ntranslate-attr-placeholder=\"CLIENTE.PESQUISAR_FORMA_PAGAMENTO\"></md-select-header><md-option></md-option><md-option \nng-value=\"formaPagamento.codigo\" \nng-repeat=\"formaPagamento in vm.formasPagamento \r\n                                           | filter:vm.filtrarFormaPagamento track by formaPagamento.codigo\">\n{{formaPagamento.descricao}}</md-option></md-select></md-input-container><md-input-container class=\"md-block\" \nflex-offset-gt-sm=\"5\" flex=\"50\"><label translate=\"CLIENTE.FORMA_FATURAMENTO\"></label><md-select \nng-model=\"vm.cliente.codigoFormaFaturamento\" name=\"formaFaturamento\" \nmd-on-open=\"vm.metodosCliente.configuraMdSelectFormaFaturamento()\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\">\n<md-select-header><input id=\"cliente-form-forma-faturamento-md-select\" class=\"md-text\" \nng-model=\"vm.filtrarFormaFaturamento\" type=\"search\" placeholder=\"\" translate \ntranslate-attr-placeholder=\"CLIENTE.PESQUISAR_FORMA_FATURAMENTO\"></md-select-header><md-option></md-option><md-option \nng-value=\"formaFaturamento.codigo\" \nng-repeat=\"formaFaturamento in vm.formasFaturamento \r\n                                   | filter:vm.filtrarFormaFaturamento track by formaFaturamento.codigo\">\n{{formaFaturamento.descricao}}</md-option></md-select></md-input-container></div><div layout-gt-xs=\"row\">\n<md-input-container class=\"md-block\" flex><label translate=\"CLIENTE.OBSERVACOES_FATURAMENTO\"></label><textarea \nng-model=\"vm.cliente.obsercaoFaturamento\" name=\"observacoes\" md-no-resize=\"true\" rows=\"4\" max-rows=\"4\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\">\n\r\n                      </textarea></md-input-container></div></md-content>");
$templateCache.put("app/main/geral/cadastro/cliente/cliente/views/tabs/cliente/tab-cliente.html","<md-content id=\"cadastro-cliente\" ng-form=\"vm.formCliente\"><div class=\"form-container\"><div layout-gt-xs=\"row\" flex \nclass=\"mt-10\"><div layout=\"row\"><md-input-container class=\"md-block\" flex-gt-sm><label translate=\"CLIENTE.CODIGO\">\n</label><input type=\"text\" ng-model=\"vm.cliente.codigo\" name=\"clienteCodigo\" mascara-numero-generica=\"#####\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.inserirAtivo\"><div \nng-messages=\"clienteForm.clienteCodigo.$error\"><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container><proximo-codigo \nng-show=\"vm.controleForm.inserirAtivo\" rota=\"vm.rota\" entidade-codigo=\"vm.cliente.codigo\" \npre-loader-toolbar=\"vm.controleForm.preLoaderToolbar\"></proximo-codigo></div><md-input-container class=\"md-block\" flex>\n<label translate=\"CLIENTE.CODIGO_OPERACAO\"></label><input type=\"text\" ng-model=\"vm.cliente.codigoOperacao\" \nname=\"codigoOperacao\" mascara-numero-generica=\"#####\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\">\n</md-input-container><md-input-container class=\"md-block\" flex><label translate=\"CLIENTE.FICHA_ARQUIVO\"></label><input \ntype=\"text\" ng-model=\"vm.cliente.fichaArquivamento\" name=\"fichaArquivo\" mascara-tamanho-campo=\"10\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\">\n</md-input-container><md-input-container class=\"md-block\"><label translate=\"CLIENTE.DATA_CADASTRO\" \nflex-offset-gt-sm=\"5\" class=\"font-size-12\"></label><md-datepicker ng-model=\"vm.cliente.dataCadastro\" \nname=\"dataCadastro\" mascara-conversor-string-para-data ng-mask=\"3?9/1?9/9999\" \nng-required=\"vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo\" \nng-disabled=\"vm.controleForm.pesquisaAtiva || vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo\">\n</md-datepicker><div ng-messages=\"clienteForm.dataCadastro.$error\"><div ng-message=\"valid\" \ntranslate=\"MENSAGEM_VALIDACAO.DATA_INVALIDA\"></div><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.DATA_OBRIGATORIA\"></div></div></md-input-container><div \nstyle=\"padding: 15px 10px 0px 20px\" ng-if=\"vm.possuiRiscoRescisaoContratual\" \nng-disabled=\"!vm.controleForm.pesquisaAtiva || vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo || vm.controleForm.emProgresso\">\n<card-risco-perda-contratual ng-click=\"vm.metodosCliente.abrirDialogContratos($event, vm.cliente)\" exibir-icone=\"true\">\n</card-risco-perda-contratual></div></div><div layout-gt-xs=\"row\" flex><md-input-container class=\"md-block\" flex=\"50\">\n<label translate=\"CLIENTE.NOME\"></label><input type=\"text\" ng-model=\"vm.cliente.nome\" name=\"clienteNome\" \nmascara-tamanho-campo=\"100\" ng-required=\"vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo\" \nmd-maxlength=\"100\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\"><div \nng-messages=\"clienteForm.clienteNome.$error\"><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container><md-input-container class=\"md-block\" \nflex=\"50\"><label translate=\"CLIENTE.NOME_FANTASIA\"></label><input type=\"text\" ng-model=\"vm.cliente.nomeFantasia\" \nname=\"nomeFantasia\" mascara-tamanho-campo=\"100\" \nng-required=\"vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo\" md-maxlength=\"100\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\"><div \nng-messages=\"clienteForm.nomeFantasia.$error\"><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container></div><div layout-gt-xs=\"row\" flex>\n<md-input-container class=\"md-block\" flex><label translate=\"CLIENTE.SOLUCAO\"></label><md-select \nng-model=\"vm.cliente.solucoes\" name=\"clienteSolucoes\" multiple=\"multiple\" \nng-model-options=\"{trackBy: \'$value.codigo\'}\" md-on-open=\"vm.metodosCliente.configuraMdSelectSolucao()\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\">\n<md-select-header><input id=\"cliente-form-solucao-md-select\" class=\"md-text\" ng-model=\"vm.filtrarSolucoes\" \ntype=\"search\" placeholder=\"\" translate translate-attr-placeholder=\"CLIENTE.PESQUISAR_SOLUCAO\"></md-select-header>\n<md-option ng-value=\"solucao\" ng-repeat=\"solucao in vm.solucoes | filter:vm.filtrarSolucoes track by solucao.codigo\">\n{{solucao.descricao}}</md-option></md-select></md-input-container></div><div layout-gt-xs=\"row\" flex><md-autocomplete \nflex-gt-sm=\"30\" flex-gt-xs md-input-name=\"cidade\" md-no-cache=\"true\" \nng-blur=\"vm.metodosCliente.configuraAutoCompleteCidadeOnBlur()\" \nng-required=\"vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo\" md-selected-item=\"vm.cliente.cidade\" \nmd-selected-item-change=\"vm.metodosCliente.alterarItemSelecionadoAutoCompleteCidade(item)\" \nmd-search-text=\"vm.textoDePesquisaAutoCompleteCidade\" \nmd-items=\"item in vm.metodosCliente.pesquisarAutoCompleteCidade(vm.textoDePesquisaAutoCompleteCidade)\" \nmd-item-text=\"item.descricao\" md-autoselect md-floating-label=\"Cidade\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\">\n<md-item-template><span md-highlight-text=\"vm.textoDePesquisaAutoCompleteCidade\">{{item.descricao}}</span>\n</md-item-template><md-not-found><label>Não foi encontrado nenhuma Cidade.</label></md-not-found><div \nng-messages=\"clienteForm.cidade.$error\"><div ng-message=\"required\" translate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\">\n</div></div></md-autocomplete><md-input-container class=\"md-block\"><label translate=\"CLIENTE.UF\">UF</label><md-select \nng-model=\"vm.cliente.uf\" name=\"uf\" \nng-disabled=\"vm.controleForm.pesquisaAtiva || vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo\"><md-option \nng-value=\"uf\" ng-repeat=\"uf in vm.ufs\">{{uf}}</md-option><md-option ng-value=\"\" ng-if=\"vm.cliente.uf\">Desmarcar\n</md-option></md-select></md-input-container><md-autocomplete flex-gt-sm=\"30\" flex-offset=\"5\" flex-gt-xs \nmd-input-name=\"bairro\" md-no-cache=\"true\" ng-blur=\"vm.metodosCliente.configuraAutoCompleteBairroOnBlur()\" \nng-required=\"vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo\" md-selected-item=\"vm.cliente.bairro\" \nmd-selected-item-change=\"vm.metodosCliente.alterarItemSelecionadoAutoCompleteBairro(item)\" \nmd-search-text=\"vm.textoDePesquisaAutoCompleteBairro\" \nmd-items=\"item in vm.metodosCliente.pesquisarAutoCompleteBairro(vm.textoDePesquisaAutoCompleteBairro)\" \nmd-item-text=\"item.descricao\" md-autoselect md-floating-label=\"Bairro\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\">\n<md-item-template><span md-highlight-text=\"vm.textoDePesquisaAutoCompleteBairro\">{{item.descricao}}</span>\n</md-item-template><md-not-found><label>Não foi encontrado nenhuma Cidade.</label></md-not-found><div \nng-messages=\"clienteForm.bairro.$error\"><div ng-message=\"required\" translate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\">\n</div></div></md-autocomplete><md-input-container class=\"md-block\" flex-offset=\"5\" flex=\"15\"><label \ntranslate=\"CLIENTE.CEP\"></label><input type=\"text\" ng-model=\"vm.cliente.cep\" name=\"cep\" \nmascara-numero-generica=\"#####-###\" \nng-minlength=\"(vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo) ? 9 : 0\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\"><div \nng-messages=\"clienteForm.cep.$error\"><div ng-message=\"minlength\">CEP digitado inválido Ex: #####-###</div></div>\n</md-input-container></div><div layout-gt-xs=\"row\" flex><md-input-container class=\"md-block\" flex=\"50\"><label \ntranslate=\"CLIENTE.ENDERECO\"></label><input type=\"text\" ng-model=\"vm.cliente.endereco\" name=\"endereco\" \nmascara-tamanho-campo=\"100\" md-maxlength=\"100\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\">\n</md-input-container><md-input-container class=\"md-block\" flex=\"15\"><label translate=\"CLIENTE.NUMERO_CASA\"></label>\n<input type=\"text\" ng-model=\"vm.cliente.numeroCasa\" name=\"numeroCasa\" mascara-numero-generica=\"#####\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\">\n</md-input-container><md-input-container class=\"md-block\" flex><label translate=\"CLIENTE.COMPLEMENTO\"></label><input \ntype=\"text\" ng-model=\"vm.cliente.complemento\" name=\"complemento\" mascara-tamanho-campo=\"100\" md-maxlength=\"100\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\">\n</md-input-container></div><div layout-gt-xs=\"row\"><md-input-container class=\"md-block\" flex=\"30\"><label \ntranslate=\"CLIENTE.TELEFONE\"></label><input type=\"text\" ng-model=\"vm.cliente.telefone\" name=\"telefone\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\">\n</md-input-container><md-input-container class=\"md-block\" flex-offset=\"10\" flex=\"30\"><label translate=\"CLIENTE.FAX\">\n</label><input type=\"text\" ng-model=\"vm.cliente.fax\" name=\"fax\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\">\n</md-input-container><md-input-container class=\"md-block campo-executivo-contas\" flex-gt-sm=\"30\" flex-offset=\"5\" \nng-if=\"!(vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo || vm.controleForm.pesquisaAtiva)\"><label \ntranslate=\"CLIENTE.EXECUTIVO_DE_CONTAS\"></label><md-select ng-model=\"vm.cliente.codigosUsuario\" \nname=\"usuariosComercial\" multiple=\"multiple\" md-on-open=\"vm.metodosCliente.configuraMdSelectUsuarioComercial()\" \nng-change=\"vm.metodosCliente.onChangeExecutivos()\"><md-select-header ng-if=\"vm.usuarios.length > 0\"><input \nid=\"tab-cliente-usuario-comercial-md-select\" class=\"md-text\" type=\"search\" placeholder=\"Pesquisar\" \nng-model=\"vm.filtrarUsuarios\"></md-select-header><md-option ng-value=\"usuario.codigo\" \nng-repeat=\"usuario in vm.usuarios | filter:{login: vm.filtrarUsuarios} track by usuario.codigo\">{{usuario.login}}\n</md-option></md-select></md-input-container><md-input-container class=\"md-block\" style=\"margin-left: 10px\" \nng-if=\"!(vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo || vm.controleForm.pesquisaAtiva)\"><md-checkbox \nng-model=\"vm.todosExecutivosSelecionados\" ng-change=\"vm.metodosCliente.toggleTodosExecutivos()\" \naria-label=\"Selecionar todos executivos\">Todos</md-checkbox></md-input-container><md-input-container flex=\"5\" \nflex-offset=\"5\" ng-if=\"vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo || vm.controleForm.pesquisaAtiva\">\n<label hide-gt-sm translate=\"CLIENTE.PESQUISAR_USUARIO_POR_CODIGO\"></label><input text=\"text\" \nng-disabled=\"!vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\" ng-model=\"vm.cliente.codigoUsuario\" \naria-label=\"Diretiva Pesquisar por Codigo\" pesquisar-por-codigo lista-a-pesquisar=\"vm.usuarios\" \nentidade-pesquisada=\"vm.cliente.codigoUsuario\" mascara-numeros=\"5\"></md-input-container><md-input-container \nclass=\"md-block\" flex-gt-sm=\"30\" \nng-if=\"vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo || vm.controleForm.pesquisaAtiva\"><label \ntranslate=\"CLIENTE.EXECUTIVO_DE_CONTAS\"></label><md-select ng-model=\"vm.cliente.codigoUsuario\" name=\"usuarioComercial\" \nng-disabled=\"(!vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo)\"><md-option ng-value=\"usuario.codigo\" \nng-repeat=\"usuario in vm.usuarios track by usuario.codigo\">{{usuario.login}}</md-option></md-select>\n</md-input-container></div><div layout-gt-xs=\"row\" flex><md-input-container class=\"md-block\" flex><label \ntranslate=\"CLIENTE.TIPO_CLASSIFICACAO\"></label><md-select name=\"tipoClassificacao\" \nng-model=\"vm.cliente.tipoClassificacao\" ng-required=\"vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo\" \nng-change=\"vm.metodosCliente.ngChangeTipoClassificacao(vm.cliente.tipoClassificacao)\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\"><md-option\n ng-value=\"{{key}}\" ng-repeat=\"(key, value) in vm.tipoClassificacoes\">{{value}}</md-option></md-select><div \nng-messages=\"clienteForm.tipoClassificacao.$error\"><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container><md-input-container class=\"md-block\" \nflex><label translate=\"CLIENTE.DOCUMENTO\"></label><input type=\"text\" ng-model=\"vm.cliente.documento\" name=\"documento\" \nmascara-documento alterar-mascara-dinamicamente mascara-a-utilizar=\"{{vm.mascaraCampoDocumento.mascara}}\" \ndesabilitar-mascara=\"!vm.cliente.tipoClassificacao || vm.cliente.tipoClassificacao == 3 ? true : false\" \nlimitar-tamanho-campo-quando-desabilitar-mascara-ativo=\"18\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\"><div \nng-messages=\"clienteForm.documento.$error\"><div ng-if=\"vm.cliente.tipoClassificacao == 1\" \nng-message=\"validacaoDocumento\">CNPJ digitádo inválido Ex: ##.###.###/####-##</div><div \nng-if=\"vm.cliente.tipoClassificacao == 2\" ng-message=\"validacaoDocumento\">CPF digitádo inválido Ex: ###.###.###-##\n</div></div></md-input-container><md-input-container class=\"md-block\" flex><label \ntranslate=\"CLIENTE.INSCRICAO_ESTADUAL\"></label><input type=\"text\" ng-model=\"vm.cliente.inscricaoEstadual\" validacao-ie \nnao-habilitar-validacao=\"!vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\" uf=\"vm.cliente.uf\" \nname=\"inscricaoEstadual\" mascara-tamanho-campo=\"15\" md-maxlength=\"15\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\"><div \nng-messages=\"clienteForm.inscricaoEstadual.$error\"><div ng-message=\"validacaoIE\" \ntranslate=\"MENSAGEM_VALIDACAO.INSCRICAO_ESTADUAL\"></div></div></md-input-container><md-input-container \nclass=\"md-block\"><md-checkbox ng-model=\"vm.cliente.ativo\" aria-label=\"Ativo\" name=\"ativo\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\"><span \ntranslate=\"CLIENTE.ATIVO\"></span></md-checkbox></md-input-container><md-input-container class=\"md-block\"><md-checkbox \nng-model=\"vm.cliente.clienteContratual\" aria-label=\"Cliente Contratual\" name=\"clienteContratual\" \nng-disabled=\"vm.controleForm.pesquisaAtiva || vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo\"><span \ntranslate=\"CLIENTE.CONTRATUAL\"></span></md-checkbox></md-input-container><md-input-container class=\"md-block\">\n<md-checkbox ng-model=\"vm.cliente.clienteEmpresaFaturamento\" aria-label=\"Empresa Faturamento\" \nname=\"empresaFaturamento\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\"><span \ntranslate=\"CLIENTE.EMPRESA_FATURAMENTO\"></span></md-checkbox></md-input-container><md-input-container class=\"md-block\" \nflex><label translate=\"CLIENTE.PENDENCIA\"></label><md-select ng-model=\"vm.cliente.codigoPendencia\" \nname=\"clientePendencia\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\"><md-option\n ng-value=\"pendencia.codigo\" ng-repeat=\"pendencia in vm.pendencias track by pendencia.codigo\">{{pendencia.descricao}}\n</md-option><md-option ng-value=\"\" ng-if=\"vm.cliente.codigoPendencia\">Desmarcar</md-option></md-select>\n</md-input-container></div><div layout-gt-xs=\"row\" flex><md-input-container class=\"md-block\" flex=\"50\"><label \ntranslate=\"CLIENTE.CONTATO\"></label><input type=\"text\" ng-model=\"vm.cliente.contato\" name=\"contato\" \nmascara-tamanho-campo=\"100\" md-maxlength=\"100\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\">\n</md-input-container><md-input-container class=\"md-block\" flex=\"50\"><label translate=\"CLIENTE.SITE\"></label><input \ntype=\"text\" ng-model=\"vm.cliente.site\" name=\"site\" mascara-tamanho-campo=\"100\" md-maxlength=\"100\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\">\n</md-input-container></div><div layout-gt-xs=\"row\" flex><md-input-container class=\"md-block\" flex><label \ntranslate=\"CLIENTE.OBSERVACOES\"></label><textarea ng-model=\"vm.cliente.observacoes\" name=\"observacoes\" \nmd-no-resize=\"true\" rows=\"4\" max-rows=\"4\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\">\n\r\n\r\n\r\n\r\n              </textarea></md-input-container></div></div></md-content>");
$templateCache.put("app/main/geral/cadastro/cliente/cliente/views/tabs/observacoes-tecnicas/tab-cliente-observacoes-tecnicas.html","<md-content ng-form=\"vm.formObservacoesTecnicas\"><div class=\"form-container\"><div layout-gt-xs=\"row\" flex><text-angular\n flex ng-model=\"vm.cliente.observacoesTecnicas\" \nta-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\">\n</text-angular></div></div></md-content>");
$templateCache.put("app/main/geral/cadastro/cliente/cliente/views/tabs/pessoal-de-referencia/tab-cliente-pessoal-de-referencia.html","<md-content class=\"md-padding\"><div class=\"form-container\"><div layout-gt-xs=\"row\" flex layout-align=\"center center\">\n<md-autocomplete flex-gt-sm=\"50\" md-input-name=\"pessoa\" md-selected-item=\"vm.pessoa\" \nmd-search-text=\"vm.textoDePesquisaAutoCompletePessoa\" \nmd-items=\"item in vm.metodosPessoalDeReferencia.pesquisarAutoCompletepessoa(vm.textoDePesquisaAutoCompletePessoa)\" \nmd-item-text=\"item.codigo + \' - \' + item.nome\" md-autoselect md-floating-label=\"Pessoa\"><md-item-template><span \nmd-highlight-text=\"vm.textoDePesquisaAutoCompleteCliente\">{{item.codigo}} - {{item.nome}}</span></md-item-template>\n<md-not-found><label>Não foi encontrado nenhuma pessoa.</label></md-not-found><div \nng-messages=\"estoriaForm.estoriaCliente.$error\"><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-autocomplete><i \nclass=\"icon-account-plus s16 ml-10 icone-cor-padrao\" \nng-click=\"vm.metodosPessoalDeReferencia.criarOuEditarPessoaDeReferencia($event)\"></i><md-input-container \nclass=\"md-block\" flex-offset-gt-sm=\"5\"><md-button type=\"submit\" \nng-click=\"vm.metodosPessoalDeReferencia.criarPessoaDeReferencia(vm.pessoa)\" class=\"send-button md-accent md-raised\" \naria-label=\"Salvar\" translate=\"CLIENTE.SALVAR\" translate-attr-aria-label=\"CLIENTE.SALVAR\" \nng-disabled=\"vm.controleForm.emProgresso || !vm.pessoa\"></md-button></md-input-container></div></div><table \nclass=\"dataTable row-border hover md-whiteframe-2dp compact\" datatable=\"ng\" \ndt-options=\"vm.dtOptionsClientePessoalDeReferencia\" width=\"100%\"><thead><tr><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Ação</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Nome</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Cargo</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Telefone</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Celular</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Email Principal</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Email Alternativo</span></div></th></tr></thead><tbody><tr \nng-repeat=\"pessoasDeReferencia in vm.cliente.pessoasDeReferencia | orderBy:\'nome\'\"><td><i \nclass=\"icon-pencil s16 icone-cor-padrao mr-10\" \nng-click=\"vm.controleForm.emProgresso || vm.metodosPessoalDeReferencia.criarOuEditarPessoaDeReferencia($event, pessoasDeReferencia)\" \nng-disabled=\"vm.controleForm.emProgresso\"></i> <i class=\"icon-delete s16 icone-cor-padrao\" \nng-click=\"vm.controleForm.emProgresso || vm.metodosPessoalDeReferencia.excluirPessoaDeReferencia($event, pessoasDeReferencia)\" \nng-disabled=\"vm.controleForm.emProgresso\"></i></td><td>{{pessoasDeReferencia.nome}}</td><td>\n{{pessoasDeReferencia.cargoDescricao}}</td><td>{{pessoasDeReferencia.telefone}}</td><td><span \nstyle=\"display: inline-flex; align-items: center\">{{pessoasDeReferencia.celular}} <i \nstyle=\"color: #4FCE5D; margin-left: 5px; margin-bottom: 4px\" class=\"fab fa-whatsapp s18\" \nng-if=\"pessoasDeReferencia.numeroEhWhatsapp\" \nng-click=\"vm.metodosPessoalDeReferencia.abrirWhatsappNovaAba(pessoasDeReferencia.celular)\"><md-tooltip \nmd-direction=\"bottom\">Conversar pelo WhatsApp</md-tooltip></i></span></td><td>{{pessoasDeReferencia.emailPrincipal}}\n</td><td>{{pessoasDeReferencia.emailAlternativo}}</td></tr></tbody></table></md-content>");
$templateCache.put("app/main/geral/cadastro/cliente/cliente/views/tabs/equipamentos/tab-cliente-equipamentos.html","<md-content><div layout=\"row\" id=\"cliente-equipamento\" flex><div ng-if=\"true\" class=\"fildset-div\" \nstyle=\"margin: 0 auto; position: relative\"><fieldset class=\"standard\" flex style=\"max-width: 980px\"><legend \nclass=\"grp-legend\" translate=\"Por locação\"></legend><div class=\"container-equipamento\"><div class=\"track-equipamento\">\n<div ng-if=\"vm.equipamentosPorContrato.length <= 0\" style=\"text-align: center; width: 100%\"><h4 \nstyle=\"font-size: 1.7em\">Não existem dados para essa consulta.</h4></div><md-card \nng-repeat=\"equipamento in vm.equipamentosPorContrato\" class=\"itemEquipamento\"><md-card-header style=\"display: block\">\n<div class=\"titulo-card\"><strong><span class=\"font-size-20 textos-span\" style=\"text-align: center\">\nTipo: {{equipamento.equipamentoTipo}}</span></strong></div><hr class=\"solid\"><md-card-header-text layout=\"row\" \nclass=\"card-cabecalho\"><div ayout=\"row\" style=\"display: flex\"><div style=\"width: 80px\"><span \nclass=\"font-size-18 textos-span\">{{equipamento.equipamentoDescricao}}:</span></div><div \nstyle=\"text-align: right; width: 118px\" class=\"quantidades\"><span class=\"font-size-18 textos-span\">\n{{equipamento.quantidade}}</span></div></div></md-card-header-text><hr class=\"solid\"></md-card-header></md-card></div>\n</div><div class=\"btn-container-equipamento\"><md-button class=\"add-event-button md-fab md-toolbar btn-prev1\" \nstyle=\"width: 35px; height: 35px\" aria-label=\"Consultar\" ng-disabled=\"vm.desabilitarBtnMover1\"><md-icon \nmd-font-icon=\"icon-arrow-left\"></md-icon><md-tooltip><label>Anterior</label></md-tooltip></md-button><md-button \nclass=\"add-event-button md-fab md-toolbar btn-next1\" style=\"width: 35px; height: 35px\" \naria-label=\"Consultar-conservacao\" ng-disabled=\"vm.desabilitarBtnMover1\"><md-icon md-font-icon=\"icon-arrow-right\">\n</md-icon><md-tooltip><label>Próximo</label></md-tooltip></md-button></div></fieldset><div ng-if=\"true\" \nclass=\"fildset-div\" style=\"margin: 0 auto; position: relative\"><fieldset class=\"standard\" flex \nstyle=\"max-width: 980px\"><legend class=\"grp-legend\" translate=\"Outros\"></legend><div class=\"container-terceiros\"><div \nclass=\"track-terceiros\"><div ng-if=\"vm.equipamentosPorTerceiros.length <= 0\" style=\"text-align: center; width: 100%\">\n<h4 style=\"font-size: 1.7em\">Não existem dados para essa consulta.</h4></div><md-card \nng-repeat=\"equipamento in vm.equipamentosPorTerceiros\" class=\"itemEquipamento\"><md-card-header \nstyle=\"display: block; position: relative\"><div class=\"titulo-card\"><strong><span class=\"font-size-20 textos-span\" \nstyle=\"text-align: center\">Tipo: {{equipamento.equipamentoTipo}}</span></strong></div><hr class=\"solid\">\n<md-card-header-text layout=\"row\" class=\"card-cabecalho\"><div ayout=\"row\" style=\"display: flex\"><div \nstyle=\"width: 80px\"><span class=\"font-size-18 textos-span\">{{equipamento.equipamentoDescricao}}:</span></div><div \nstyle=\"text-align: right; width: 118px\" class=\"quantidades\"><span class=\"font-size-18 textos-span\">\n{{equipamento.quantidade}}</span></div></div></md-card-header-text><hr class=\"solid\"></md-card-header><button \nclass=\"add-event-button md-fab md-toolbar md-button md-default-theme md-ink-ripple btn-card\" \nng-click=\"(vm.controleForm.emProgresso || vm.pesquisandoDetalhesEquipamento) || vm.metodosClienteEquipamentos.selecionarDetalhesEquipamento(equipamento, $index)\" \nng-disabled=\"vm.controleForm.emProgresso || vm.pesquisandoDetalhesEquipamento\" \naria-label=\"Inserir Detalhes Equipamento\" translate translate-attr-aria-label=\"CLIENTE.INSERIR_DETALHE_EQUIPAMENTO\">\n<md-icon md-font-icon=\"icon-plus s20\"></md-icon><md-tooltip md-autohide><span \ntranslate=\"CLIENTE.INSERIR_DETALHE_EQUIPAMENTO\"></span></md-tooltip></button> <button \nclass=\"add-event-button md-fab md-toolbar md-button md-default-theme md-ink-ripple btn-card-editar\" \nng-click=\"vm.metodosClienteEquipamentos.abrirDialogClienteEquipamentos($event, equipamento)\" \nng-disabled=\"vm.controleForm.emProgresso || vm.pesquisandoDetalhesEquipamento\" \naria-label=\"Inserir Detalhes Equipamento\" translate translate-attr-aria-label=\"CLIENTE.INSERIR_DETALHE_EQUIPAMENTO\">\n<md-icon md-font-icon=\"icon-pencil s20\"></md-icon><md-tooltip md-autohide><span translate=\"Editar detalhe equipamento\">\n</span></md-tooltip></button> <button \nclass=\"add-event-button md-fab md-toolbar md-button md-default-theme md-ink-ripple btn-card-excluir\" \nng-click=\"vm.metodosClienteEquipamentos.excluirClienteEquipamento($event, equipamento)\" \nng-disabled=\"vm.controleForm.emProgresso || vm.pesquisandoDetalhesEquipamento\" \naria-label=\"Inserir Detalhes Equipamento\" translate translate-attr-aria-label=\"CLIENTE.INSERIR_DETALHE_EQUIPAMENTO\">\n<md-icon md-font-icon=\"icon-delete s20\"></md-icon><md-tooltip md-autohide><span \ntranslate=\"Remover detalhe equipamento\"></span></md-tooltip></button></md-card></div></div><div \nclass=\"btn-container-equipamento\"><md-button class=\"md-fab md-accent md-icon-button sample-show-hide\" \nstyle=\"position: absolute;\r\n                            left: 0; margin-left: 20px\" \nng-click=\"vm.metodosClienteEquipamentos.abrirDialogClienteEquipamentos($event)\" \nng-disabled=\"vm.controleForm.emProgresso || vm.pesquisandoDetalhesEquipamento\" aria-label=\"Inserir Equipamento\" \ntranslate translate-attr-aria-label=\"ESTORIA.INSERIR_EQUIPAMENTO\"><md-icon md-font-icon=\"icon-plus s30\"></md-icon>\n<md-tooltip md-autohide><span translate=\"CLIENTE.INSERIR_EQUIPAMENTO\"></span></md-tooltip></md-button><md-button \nclass=\"add-event-button md-fab md-toolbar btn-prev-terceiros\" style=\"width: 35px; height: 35px\" aria-label=\"Consultar\" \nng-disabled=\"vm.desabilitarBtnMover2\"><md-icon md-font-icon=\"icon-arrow-left\"></md-icon><md-tooltip><label>Anterior\n</label></md-tooltip></md-button><md-button class=\"add-event-button md-fab md-toolbar btn-next-terceiros\" \nstyle=\"width: 35px; height: 35px\" aria-label=\"Consultar-conservacao\" ng-disabled=\"vm.desabilitarBtnMover2\"><md-icon \nmd-font-icon=\"icon-arrow-right\"></md-icon><md-tooltip><label>Próximo</label></md-tooltip></md-button></div></fieldset>\n</div></div></div></md-content>");
$templateCache.put("app/main/geral/cadastro/solucao/solucao/views/tabs/rotinas/tab-rotinas.html","<md-content ms-scroll><div class=\"inserir-button\" layout-gt-xs=\"row\" flex layout-align=\"space-between center\"><div \nclass=\"informativo\"><span>Solução: {{vm.solucao.descricao}} - {{vm.solucao.sistemaOperacional.descricao}}</span></div>\n<div><md-button class=\"md-fab md-accent md-icon-button sample-show-hide\" \nng-click=\"vm.metodosRotinas.abrirDialogRotinas($event)\" aria-label=\"Inserir Rotinas\" translate \ntranslate-attr-aria-label=\"SOLUCAO_ROTINAS_TAREFAS.INSERIR_ROTINAS\"><md-icon md-font-icon=\"icon-plus s30\"></md-icon>\n<md-tooltip md-autohide><span translate=\"SOLUCAO_ROTINAS_TAREFAS.INSERIR_ROTINAS\"></span></md-tooltip></md-button>\n</div></div><div class=\"md-background-bg md-whiteframe-1dp\"><table class=\"dataTable row-border hover\" datatable=\"ng\" \ndt-options=\"vm.dtOptionsRotinas\" width=\"100%\"><thead><tr><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Ação</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Descrição</span></div></th></tr></thead><tbody><tr \nng-repeat=\"rotina in vm.solucao.rotinas track by rotina.codigo\"><td class=\"button-icone-cor-azul\"><i \nclass=\"icon-pencil s16 icone-cor-padrao mr-10\" \nng-click=\"vm.controleForm.emProgresso || vm.metodosRotinas.abrirDialogRotinas($event, rotina)\" \nng-disabled=\"vm.controleForm.emProgresso\"></i> <i class=\"icon-delete s16 icone-cor-padrao mr-10\" \nng-click=\"vm.controleForm.emProgresso || vm.metodosRotinas.excluirRotina(rotina, event)\" \nng-disabled=\"vm.controleForm.emProgresso\"></i></td><td>{{rotina.descricao}}</td></tr></tbody></table></div>\n</md-content>");
$templateCache.put("app/main/geral/cadastro/solucao/solucao/views/tabs/solucao/tab-solucao.html","<md-content><div class=\"form-container\"><div layout-gt-xs=\"row\"><div layout=\"row\"><md-input-container class=\"md-block\" \nflex-gt-sm><label translate=\"SOLUCAO_ROTINAS_TAREFAS.CODIGO\"></label><input type=\"text\" ng-model=\"vm.solucao.codigo\" \nname=\"solucaoCodigo\" mascara-numero-generica=\"#####\" \nng-required=\"vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\"><div \nng-messages=\"solucaoForm.solucaoCodigo.$error\"><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container><proximo-codigo \nng-show=\"vm.controleForm.inserirAtivo\" rota=\"vm.rota\" entidade-codigo=\"vm.solucao.codigo\" \npre-loader-toolbar=\"vm.controleForm.preLoaderToolbar\"></proximo-codigo></div><md-input-container class=\"md-block\" \nflex-offset-gt-sm=\"5\" flex-gt-sm><label translate=\"SOLUCAO_ROTINAS_TAREFAS.DESCRICAO\"></label><input type=\"text\" \nng-model=\"vm.solucao.descricao\" name=\"solucaoDescricao\" mascara-tamanho-campo=\"50\" \nng-required=\"vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo\" md-maxlength=\"50\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\"><div \nng-messages=\"solucaoForm.solucaoDescricao.$error\"><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container></div><div layout-gt-xs=\"row\" \nlayout-md=\"column\"><md-input-container class=\"md-block\" flex-gt-sm=\"20\" ng-if=\"vm.squadUsuarioLogado.length > 1\">\n<label>Squad</label><md-select ng-model=\"vm.solucao.codigoSquads\" name=\"codigoSquads\" multiple=\"multiple\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\" \nng-change=\"vm.metodosSolucao.selectChangeSquad(vm.solucao.codigoSquads)\"><md-option ng-value=\"squad.codigo\" \nng-repeat=\"squad in vm.squads track by squad.codigo\">{{squad.descricao}}</md-option></md-select><div \nng-messages=\"solucaoForm.codigoSquads.$error\"><div ng-message=\"required\">Campo obrigatório</div></div>\n</md-input-container><md-input-container class=\"md-block\" flex-gt-sm=\"20\"><label \ntranslate=\"SOLUCAO_ROTINAS_TAREFAS.PRODUTO\"></label><md-select ng-model=\"vm.solucao.codigoProduto\" name=\"produto\" \nmd-on-open=\"vm.metodosSolucao.configuraMdSelectProduto()\" \nng-required=\"vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\">\n<md-select-header ng-if=\"vm.produtos.length > 0\"><input id=\"produto-md-select\" class=\"md-text\" type=\"search\" \nplaceholder=\"\" translate translate-attr-placeholder=\"Pesquisar produto\" ng-model=\"vm.filtrarProdutos\">\n</md-select-header><md-option ng-value=\"produto.codigo\" \nng-repeat=\"produto in vm.produtos | filter:vm.filtrarProdutos track by produto.codigo\">{{produto.descricao}}\n</md-option><md-option \nng-if=\"(vm.produtos.length === 0) || \r\n                                      vm.filtrarProdutos && \r\n                                      (vm.produtos | filter:vm.filtrarProdutos).length === 0\" \ndisabled=\"disabled\">Nenhum produto encontrada.</md-option></md-select><div \nng-messages=\"solucaoForm.solucaoSistemaOperacionalCodigo.$error\"><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_MULTIPLO_OBRIGATORIO\"></div></div></md-input-container><md-input-container \nclass=\"md-block\" flex-gt-sm=\"20\"><label translate=\"SOLUCAO_ROTINAS_TAREFAS.PLATAFORMA\"></label><md-select \nng-model=\"vm.solucao.sistemaOperacionalCodigo\" name=\"solucaoSistemaOperacionalCodigo\" \nng-required=\"vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\"><md-option\n ng-value=\"sistemaOperacional.codigo\" \nng-repeat=\"sistemaOperacional in vm.sistemasOperacionais track by sistemaOperacional.codigo\">\n{{sistemaOperacional.descricao}}</md-option></md-select><div \nng-messages=\"solucaoForm.solucaoSistemaOperacionalCodigo.$error\"><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_MULTIPLO_OBRIGATORIO\"></div></div></md-input-container></div></div></md-content>");
$templateCache.put("app/main/geral/cadastro/solucao/solucao/views/tabs/tarefas/tab-tarefas.html","<md-content><div class=\"inserir-button\" layout-gt-xs=\"row\" flex layout-align=\"space-between center\"><div \nclass=\"informativo\"><span>Solução: {{vm.solucao.descricao}} - {{vm.solucao.sistema_Operacional.descricao}}</span></div>\n<div><md-button class=\"md-fab md-accent md-icon-button sample-show-hide\" \nng-click=\"vm.metodosTarefas.abrirDialogTarefas($event)\" ng-disabled=\"vm.rotinaSelecionada === null\" \naria-label=\"Inserir Tarefas\" translate translate-attr-aria-label=\"SOLUCAO_ROTINAS_TAREFAS.INSERIR_TAREFAS\"><md-icon \nmd-font-icon=\"icon-plus s30\"></md-icon><md-tooltip md-autohide><span \ntranslate=\"SOLUCAO_ROTINAS_TAREFAS.INSERIR_TAREFAS\"></span></md-tooltip></md-button><md-tooltip \nng-if=\"vm.rotinaSelecionada === null\"><span translate=\"SOLUCAO_ROTINAS_TAREFAS.INFORMACAO_TAREFAS\"></span></md-tooltip>\n</div></div><div layout-gt-sm=\"row\" layout-gt-xs=\"column\" flex><div layout-gt-sm=\"column\" layout-gt-xs=\"row\" \nflex-gt-sm=\"50\" flex-gt-xs><div class=\"md-background-bg md-whiteframe-1dp\"><table class=\"dataTable row-border hover\" \ndatatable=\"ng\" dt-options=\"vm.dtOptionsTarefasRotinas\" width=\"100%\"><thead><tr><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Descrição</span></div></th></tr></thead><tbody><tr \nng-repeat=\"rotina in vm.solucao.rotinas track by rotina.codigo\" \nng-click=\"vm.metodosTarefas.selecionarRotina(rotina, $index)\" \nng-class=\"{\'linha-selecionada\': $index == vm.tabelaLinhaSelecionada}\"><td>{{rotina.descricao}}</td></tr></tbody>\n</table></div></div><div layout-gt-sm=\"column\" layout-gt-xs=\"row\" flex-gt-sm=\"50\" flex-offset-gt-sm=\"5\" flex-gt-xs><div\n class=\"main md-whiteframe-1dp\" ms-scroll><table class=\"dataTable row-border hover\" datatable=\"ng\" \ndt-options=\"vm.dtOptionsTarefas\" width=\"100%\"><thead><tr><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Ação</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Descrição</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Pontos</span></div></th></tr></thead><tbody><tr \nng-repeat=\"tarefa in vm.rotinaSelecionada.tarefas track by tarefa.codigo\"><td><i \nclass=\"icon-pencil s16 icone-cor-padrao mr-10\" \nng-click=\"vm.controleForm.emProgresso || vm.metodosTarefas.abrirDialogTarefas($event, tarefa, $index)\" \nng-disabled=\"vm.controleForm.emProgresso\"></i> <i class=\"icon-delete s16 icone-cor-padrao\" \nng-click=\"vm.controleForm.emProgresso || vm.metodosTarefas.excluirTarefa(tarefa)\" \nng-disabled=\"vm.controleForm.emProgresso\"></i></td><td>{{tarefa.descricao}}</td><td>{{tarefa.pontos}}</td></tr></tbody>\n</table></div></div></div></md-content>");
$templateCache.put("app/main/geral/cadastro/usuario/usuario/views/tabs/contato-usuario/tab-contato-usuario.html","<md-content class=\"md-padding\" ms-scroll><div class=\"form-container\"><div layout-gt-xs=\"row\"><md-input-container \nclass=\"md-block\" flex-gt-sm><label translate=\"COLABORADOR.EMAIL\"></label><input type=\"email\" \nng-disabled=\"!vm.controleUsuario.controladorDetalhesUsuario\" ng-model=\"vm.usuario.detalhes.email\" name=\"email\" \nmascara-tamanho-campo=\"50\" md-maxlength=\"50\"><div ng-messages=\"vm.form.colaborador.email.$error\"><div \nng-message=\"required\" translate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div><div ng-message=\"email\" \ntranslate=\"MENSAGEM_VALIDACAO.EMAIL_INVALIDO\"></div></div></md-input-container></div><div layout-gt-xs=\"row\" flex>\n<md-input-container class=\"md-block\" flex-gt-sm><label translate=\"COLABORADOR.TELEFONE_RESIDENCIAL\"></label><input \ntype=\"text\" mascara-telefone ng-model=\"vm.usuario.detalhes.telefoneResidencial\" name=\"telefoneResidencial\" \nminlength=\"13\" mascara-tamanho-campo=\"13\" ng-disabled=\"!vm.controleUsuario.controladorDetalhesUsuario\" \nmd-maxlength=\"13\"><div ng-messages=\"vm.form.colaborador.telefoneResidencial.$error\"><div ng-message=\"minlength\" \ntranslate=\"MENSAGEM_VALIDACAO.TELEFONE_INVALIDO\"></div></div></md-input-container><md-input-container class=\"md-block\" \nflex-gt-sm><label translate=\"COLABORADOR.CELULAR\"></label><input type=\"text\" mascara-telefone \nng-model=\"vm.usuario.detalhes.celular\" name=\"celular\" minlength=\"14\" \nng-disabled=\"!vm.controleUsuario.controladorDetalhesUsuario\" mascara-tamanho-campo=\"14\" md-maxlength=\"14\"><div \nng-messages=\"vm.form.colaborador.celular.$error\"><div ng-message=\"minlength\" \ntranslate=\"MENSAGEM_VALIDACAO.TELEFONE_INVALIDO\"></div></div></md-input-container><md-input-container class=\"md-block\" \nflex-gt-sm><label translate=\"COLABORADOR.TELEFONE_OUTROS\"></label><input type=\"text\" mascara-telefone \nng-model=\"vm.usuario.detalhes.telefoneOutros\" name=\"telefoneOutros\" minlength=\"14\" \nng-disabled=\"!vm.controleUsuario.controladorDetalhesUsuario\" mascara-tamanho-campo=\"14\" md-maxlength=\"14\"><div \nng-messages=\"vm.form.colaborador.telefoneOutros.$error\"><div ng-message=\"minlength\" \ntranslate=\"MENSAGEM_VALIDACAO.TELEFONE_INVALIDO\"></div></div></md-input-container></div><div layout-gt-xs=\"row\" \nlayout-align=\"end end\"><group-button ng-disabled=\"\" ng-disabled-excluir=\"true\" \ntoolbar-pre-loader=\"vm.controleForm.preLoaderToolbar\" entidade=\"vm.usuario.detalhes\" \ncontrolador-ativo=\"vm.controleUsuario.controladorDetalhesUsuario\" \nsalvar=\"vm.metodosDetalhesColaborador.salvarDetalhes(vm.usuario.detalhes)\" \neditar=\"vm.metodosDetalhesColaborador.editarDetalhes(vm.usuario.detalhes)\"></group-button></div></div></md-content>");
$templateCache.put("app/main/geral/cadastro/usuario/usuario/views/tabs/endereco-usuario/tab-endereco-usuario.html","<md-content class=\"md-padding\" ms-scroll><div class=\"form-container\"><div layout-gt-xs=\"row\" flex><md-input-container \nclass=\"md-block\" flex-gt-sm><label translate=\"COLABORADOR.RUA\"></label><input type=\"text\" \nng-model=\"vm.usuario.detalhes.rua\" name=\"rua\" ng-disabled=\"!vm.controleUsuario.controladorDetalhesUsuario\" \nmascara-tamanho-campo=\"50\" md-maxlength=\"50\"><div ng-messages=\"vm.form.colaborador.rua.$error\"><div \nng-message=\"required\" translate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container>\n<md-input-container class=\"md-block\" flex-gt-sm=\"15\"><label translate=\"COLABORADOR.NUMERO\"></label><input type=\"text\" \nmascara-numeros ng-model=\"vm.usuario.detalhes.numero\" name=\"numero\" \nng-disabled=\"!vm.controleUsuario.controladorDetalhesUsuario\" maxlength=\"10\"><div \nng-messages=\"vm.form.colaborador.numero.$error\"><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container><md-input-container class=\"md-block\" \nflex-gt-sm><label translate=\"COLABORADOR.COMPLEMENTO\"></label><input type=\"text\" \nng-model=\"vm.usuario.detalhes.complemento\" name=\"complemento\" \nng-disabled=\"!vm.controleUsuario.controladorDetalhesUsuario\" maxlength=\"30\"><div \nng-messages=\"vm.form.colaborador.complemento.$error\"><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container></div><div layout-gt-xs=\"row\" flex>\n<div layout-gt-xs=\"row\" flex><md-autocomplete flex ng-disabled=\"!vm.controleUsuario.controladorDetalhesUsuario\" \nng-blur=\"vm.metodos.configuraAutoCompleteBairroOnBlur()\" md-input-name=\"cidade\" md-no-cache=\"true\" \nmd-selected-item=\"vm.usuario.detalhes.bairro\" \nmd-selected-item-change=\"vm.metodosDetalhesColaborador.alterarItemSelecionadoAutoCompleteBairro(item)\" \nmd-search-text=\"vm.textoDePesquisaAutoCompleteBairro.descricao\" \nmd-items=\"item in vm.metodosDetalhesColaborador.pesquisarAutoCompleteBairro(vm.textoDePesquisaAutoCompleteBairro)\" \nmd-item-text=\"item.descricao\" md-autoselect md-floating-label=\"Bairro\"><md-item-template><span \nmd-highlight-text=\"vm.textoDePesquisaAutoCompleteCliente\">{{item.descricao}}</span></md-item-template><md-not-found>\n<label>Não foi encontrado nenhum Bairro.</label></md-not-found></md-autocomplete><md-input-container class=\"md-block\" \nflex-gt-sm=\"25\"><label translate=\"COLABORADOR.CEP\"></label><input type=\"text\" mascara-numero-generica=\"#####-###\" \nng-model=\"vm.usuario.detalhes.cep\" name=\"cep\" minlength=\"8\" \nng-disabled=\"!vm.controleUsuario.controladorDetalhesUsuario\"><div ng-messages=\"vm.form.colaborador.cep.$error\"><div \nng-message=\"minlength\" translate=\"COLABORADOR.CEP_INVALIDO\"></div></div></md-input-container><md-autocomplete flex \nng-disabled=\"!vm.controleUsuario.controladorDetalhesUsuario\" \nng-blur=\"vm.metodosDetalhesColaborador.configuraAutoCompleteCidadeOnBlur()\" md-input-name=\"cidade\" md-no-cache=\"true\" \nmd-selected-item=\"vm.usuario.detalhes.cidade\" \nmd-selected-item-change=\"vm.metodosDetalhesColaborador.alterarItemSelecionadoAutoCompleteCidade(item)\" \nmd-search-text=\"vm.textoDePesquisaAutoCompleteCidade.descricao\" \nmd-items=\"item in vm.metodosDetalhesColaborador.pesquisarAutoCompleteCidade(vm.textoDePesquisaAutoCompleteCidade)\" \nmd-item-text=\"item.descricao\" md-autoselect md-floating-label=\"Cidade\"><md-item-template><span \nmd-highlight-text=\"vm.textoDePesquisaAutoCompleteCliente\">{{item.descricao}}</span></md-item-template><md-not-found>\n<label>Não foi encontrado nenhuma Cidade.</label></md-not-found></md-autocomplete></div></div><div layout-gt-xs=\"row\" \nlayout-align=\"end end\"><group-button ng-disabled=\"\" ng-disabled-excluir=\"true\" \ntoolbar-pre-loader=\"vm.controleForm.preLoaderToolbar\" entidade=\"vm.usuario.detalhes\" \ncontrolador-ativo=\"vm.controleUsuario.controladorDetalhesUsuario\" \nsalvar=\"vm.metodosDetalhesColaborador.salvarDetalhes(vm.usuario.detalhes)\" \neditar=\"vm.metodosDetalhesColaborador.editarDetalhes(vm.usuario.detalhes)\"></group-button></div></div></md-content>");
$templateCache.put("app/main/geral/cadastro/usuario/usuario/views/tabs/detalhes-usuario/tab-detalhes-usuario.html","<md-content class=\"md-padding\" ms-scroll><div class=\"form-container\"><div layout-gt-xs=\"column\"><div layout=\"row\" flex>\n<md-input-container class=\"md-block\"><md-checkbox ng-model=\"vm.usuario.detalhes.administradorSistema\" \nng-disabled=\"!vm.controleUsuario.controladorDetalhesUsuario\" aria-label=\"Administrador Sistema\" \nname=\"administradorSistema\"><span class=\"float-label-cor-default\" translate=\"COLABORADOR.ADMINISTRADOR_SISTEMA\"></span>\n</md-checkbox></md-input-container><md-input-container class=\"md-block\" flex-offset-gt-sm=\"5\"><md-checkbox \nng-model=\"vm.usuario.detalhes.visualizarAtendimentosEmAbertoSetor\" \nng-change=\"vm.metodosDetalhesColaborador\r\n                                         .alterarEstadoCampoVisualizarAtendimentosEmAbertoSetor(vm.usuario.detalhes.visualizarAtendimentosEmAbertoSetor)\" \nng-disabled=\"!vm.controleUsuario.controladorDetalhesUsuario\" aria-label=\"Visualizar Atendimentos em aberto do Setor\" \nname=\"visualizarAtendimentosEmAbertoSetor\"><span class=\"float-label-cor-default\" \ntranslate=\"COLABORADOR.VISUALIZAR_ATENDIMENTOS_EM_ABERTO_SETOR\"></span></md-checkbox></md-input-container>\n<md-input-container class=\"md-block\" flex-offset-gt-sm=\"5\"><md-checkbox \nng-model=\"vm.usuario.detalhes.visualizarCurriculo\" ng-disabled=\"!vm.controleUsuario.controladorDetalhesUsuario\" \nng-change=\"vm.metodosDetalhesColaborador.onChangeVizualizarCurriculos()\" aria-label=\"Visualiza Currículo\" \nname=\"visualizarCurriculo\"><span class=\"float-label-cor-default\" translate=\"COLABORADOR.VISUALIZAR_CURRICULO\"></span>\n</md-checkbox></md-input-container><md-input-container class=\"md-block\" flex-offset-gt-sm=\"5\"><md-checkbox \nng-model=\"vm.usuario.detalhes.visualizarTempoTecnico\" ng-disabled=\"!vm.controleUsuario.controladorDetalhesUsuario\" \naria-label=\"Visualiza Tempo Técnico\" name=\"visualizarCurriculo\"><span class=\"float-label-cor-default\" \ntranslate=\"COLABORADOR.VISUALIZAR_TEMPO_TECNICO\"></span></md-checkbox></md-input-container></div><div layout=\"row\" \nflex><md-input-container class=\"md-block\"><md-checkbox ng-disabled=\"!vm.controleUsuario.controladorDetalhesUsuario\" \naria-label=\"Permitir atualizar expiração de licenças\" name=\"permitirAtualizarExpiracaoLicencas\" \nng-model=\"vm.usuario.detalhes.permitirAtualizarExpiracaoLicenca\"><span class=\"float-label-cor-default\" \ntranslate=\"COLABORADOR.PERMITIR_ATUALIZAR_EXPIRACAO_LICENCAS\"></span></md-checkbox></md-input-container>\n<md-input-container class=\"md-block\" flex-offset-gt-sm=\"5\"><md-checkbox \nng-model=\"vm.usuario.detalhes.notificarAtendimentosEmAbertoSetor\" \nng-change=\"vm.metodosDetalhesColaborador\r\n                                         .alterarEstadoCampoNotificarAtendimentosEmAbertoSetor(vm.usuario.detalhes.notificarAtendimentosEmAbertoSetor)\" \nng-disabled=\"!vm.controleUsuario.controladorDetalhesUsuario\" aria-label=\"Notificar Atendimentos em aberto do Setor\" \nname=\"notificarAtendimentosEmAbertoSetor\"><span class=\"float-label-cor-default\" \ntranslate=\"COLABORADOR.NOTIFICAR_ATENDIMENTOS_EM_ABERTO_SETOR\"></span></md-checkbox></md-input-container>\n<md-input-container class=\"md-block\" flex-offset-gt-sm=\"5\"><md-checkbox \nng-disabled=\"!vm.controleUsuario.controladorDetalhesUsuario\" \naria-label=\"Permitir edição de reajustes do item contratual\" name=\"permitirEditarReajusteItemContratual\" \nng-model=\"vm.usuario.detalhes.editarReajusteItemContratual\"><span class=\"float-label-cor-default\" \ntranslate=\"COLABORADOR.PERMITE_EDITAR-REAJUSTE\"></span></md-checkbox></md-input-container><md-input-container \nclass=\"md-block\" flex-offset-gt-sm=\"5\"><md-checkbox ng-model=\"vm.usuario.detalhes.validacaoDiasParaRedefinirSenha\" \nng-disabled=\"!vm.controleUsuario.controladorDetalhesUsuario\" aria-label=\"Redefinir senha\" name=\"Redefinir\"><span \nclass=\"float-label-cor-default\" translate=\"COLABORADOR.REDEFINIR_SENHA\"></span></md-checkbox></md-input-container>\n</div></div><div layout-gt-xs=\"row\" flex><div layout-gt-xs=\"column\" class=\"meu-date-picker\"><md-input-container \nstyle=\"width: 20em!important\" class=\"md-block\"><label translate=\"COLABORADOR.DATA_NASCIMENTO\"></label><md-datepicker \nname=\"dataNascimento\" ng-model=\"vm.usuario.detalhes.dataNascimento\" ng-mask=\"3?9/1?9/9999\" \nng-disabled=\"!vm.controleUsuario.controladorDetalhesUsuario\" md-open-on-focus></md-datepicker><div \nng-messages=\"vm.form.colaborador.dataNascimento.$error\"><div ng-message=\"valid\" \ntranslate=\"MENSAGEM_VALIDACAO.DATA_INVALIDA\"></div></div></md-input-container></div><md-input-container \nclass=\"md-block\" flex-gt-sm=\"10\"><label translate=\"COLABORADOR.TIPO_SANGUINEO\"></label><md-select \nng-model=\"vm.usuario.detalhes.tipoSanguineo\" name=\"tipoSanguineo\" \nng-disabled=\"!vm.controleUsuario.controladorDetalhesUsuario\" id=\"tipo-sanguineo\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\"><md-option\n ng-value=\"value\" id=\"tipo-sanguineo-{{$index}}\" ng-repeat=\"(key,value) in vm.tipoSanguineo track by key\">{{value}}\n</md-option></md-select></md-input-container><md-input-container class=\"md-block\" flex-gt-sm=\"20\"><label \ntranslate=\"COLABORADOR.TIPO_ATENDIMENTO\"></label><md-select name=\"tipoAtendimento\" \nng-required=\"vm.controleUsuario.controladorDetalhesUsuario\" \nng-disabled=\"!vm.controleUsuario.controladorDetalhesUsuario\" ng-model=\"vm.usuario.detalhes.tipoAtendimento\"><md-option \nng-value=\"key\" ng-repeat=\"(key, value) in vm.tiposAtendimento\">{{value}}</md-option></md-select><div \nng-messages=\"vm.form.colaborador.tipoAtendimento.$error\"><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container><div layout-gt-xs=\"row\" flex \nng-hide=\"!vm.usuario.detalhes.visualizarCurriculo\"><md-input-container class=\"md-block\" flex><label \ntranslate=\"COLABORADOR.CATEGORIA\"></label><md-select ng-model=\"vm.categoria\" name=\"usuariosDetalheCategorias\" \nmultiple=\"multiple\" ng-model-options=\"{trackBy: \'$value.codigo\'}\" \nmd-on-open=\"vm.metodosDetalhesColaborador.configuraMdSelectCategoria()\" \nng-required=\"vm.usuario.detalhes.visualizarCurriculo\" ng-disabled=\"!vm.controleUsuario.controladorDetalhesUsuario\">\n<md-select-header><input id=\"usuario-detalhe-form-categoria-md-select\" class=\"md-text\" ng-model=\"vm.filtrarCategorias\" \ntype=\"search\" placeholder=\"\" translate translate-attr-placeholder=\"COLABORADOR.PESQUISAR_CATEGORIA\"></md-select-header>\n<md-option ng-value=\"categoria\" \nng-repeat=\"categoria in vm.categorias | filter:vm.filtrarCategorias track by categoria.codigo\">{{categoria.titulo}}\n</md-option></md-select><div ng-messages=\"vm.form.colaborador.categoria.$error\"><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container></div></div><div layout-gt-xs=\"row\">\n<md-input-container class=\"md-block\" flex><label translate=\"COLABORADOR.OBSERVACOES\">Assunto</label><textarea \nng-model=\"vm.usuario.detalhes.observacoes\" name=\"observações\" \nng-disabled=\"!vm.controleUsuario.controladorDetalhesUsuario\" md-no-resize=\"true\" maxlength=\"500\" md-maxlength=\"500\" \nmax-rows=\"5\">\r\n                </textarea></md-input-container></div><div layout-gt-xs=\"row\" layout-align=\"end end\">\n<group-button ng-disabled=\"\" ng-disabled-excluir=\"true\" toolbar-pre-loader=\"vm.controleForm.preLoaderToolbar\" \nentidade=\"vm.usuario.detalhes\" controlador-ativo=\"vm.controleUsuario.controladorDetalhesUsuario\" \nsalvar=\"vm.metodosDetalhesColaborador.salvarDetalhes(vm.usuario.detalhes)\" \neditar=\"vm.metodosDetalhesColaborador.editarDetalhes(vm.usuario.detalhes, true)\"></group-button></div></div>\n</md-content>");
$templateCache.put("app/main/geral/cadastro/usuario/usuario/views/tabs/permissoes-acesso/tab-permissoes-acesso.html","<div class=\"form-container\"><div layout-gt-xs=\"row\" flex><fieldset class=\"standard\" flex><legend class=\"grp-legend\">\nPermissões</legend><md-input-container flex-gt-sm=\"50\" class=\"md-block\"><label>Dias da semana</label><md-select \nng-model=\"vm.usuario.dias\" multiple=\"multiple\" name=\"dias\" \nng-required=\"vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\"><md-option\n ng-value=\"semana.valor\" ng-repeat=\"semana in vm.diasSemana\">{{semana.dia}}</md-option></md-select><div \nng-messages=\"vm.form.colaborador.dias.$error\"><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container><md-input-container flex-gt-sm=\"50\">\n<label>Hora Início</label><input type=\"text\" mascara-numero-generica=\"##:##\" ng-pattern=\"vm.regexHora\" \nng-change=\"vm.metodosInternos.verificaHora()\" ng-model=\"vm.usuario.horaInicio\" name=\"horaInicio\" \nng-required=\"vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\"><div \nng-messages=\"vm.form.colaborador.horaInicio.$error\"><div ng-message=\"pattern\" \ntranslate=\"MENSAGEM_VALIDACAO.HORA_INVALIDA\"></div><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container><md-input-container flex-gt-sm=\"50\">\n<label>Hora Final</label><input type=\"text\" mascara-numero-generica=\"##:##\" ng-pattern=\"vm.regexHora\" \nng-model=\"vm.usuario.horaFim\" name=\"horaFim\" ng-change=\"vm.metodosInternos.verificaHora()\" \nng-required=\"vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\"><div \nng-messages=\"vm.form.colaborador.horaFim.$error\"><div ng-message=\"hora\" translate=\"MENSAGEM_VALIDACAO.HORA_MENOR\" \nng-if=\"vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo\"></div><div ng-message=\"pattern\" \ntranslate=\"MENSAGEM_VALIDACAO.HORA_INVALIDA\"></div><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container></fieldset></div></div>");
$templateCache.put("app/main/geral/cadastro/usuario/usuario/views/tabs/usuario/tab-usuario.html","<md-content class=\"md-padding\" ms-scroll><div class=\"form-container\"><div layout-gt-xs=\"row\" \nclass=\"container-codigo-ativo\"><div layout=\"row\" layout-align=\"start end\"><md-input-container class=\"md-block\" \nflex-gt-sm><label translate=\"COLABORADOR.CODIGO\"></label><input type=\"text\" ng-model=\"vm.usuario.codigo\" name=\"codigo\" \nmascara-numero-generica=\"#####\" ng-required=\"vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.inserirAtivo\"><div \nng-messages=\"vm.form.colaborador.codigo.$error\"><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container><proximo-codigo \nng-show=\"vm.controleForm.inserirAtivo\" rota=\"vm.rota\" entidade-codigo=\"vm.usuario.codigo\" \npre-loader-toolbar=\"vm.controleForm.preLoaderToolbar\" class=\"mb-40\"></proximo-codigo></div><div layout=\"row\" \nlayout-align=\"start end\"><md-input-container class=\"md-block\" layout-align=\"end end\"><md-switch aria-label=\"Ativo\" \nname=\"ativo\" ng-model=\"vm.usuario.detalhesUsuario.ativo\" \nng-disabled=\"!vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\">Ativo</md-switch></md-input-container>\n</div></div><div layout-gt-xs=\"row\"><md-input-container class=\"md-block\" flex-gt-sm=\"50\"><label \ntranslate=\"COLABORADOR.NOME\"></label><input type=\"text\" ng-model=\"vm.usuario.nome\" name=\"nome\" \nmascara-tamanho-campo=\"50\" mascara-formatar-nome \nng-required=\"vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo\" md-maxlength=\"50\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\"><div \nng-messages=\"vm.form.colaborador.nome.$error\"><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container><md-input-container class=\"md-block\" \nflex-offset-gt-sm=\"5\" flex-gt-sm=\"20\"><label translate=\"COLABORADOR.LOGIN\"></label><input type=\"text\" name=\"login\" \nonkeydown=\"var a = this; setTimeout(function(){a.value = a.value.toUpperCase();}, 1)\" md-maxlength=\"20\" \nmascara-tamanho-campo=\"20\" mascara-formatar-nome ng-model=\"vm.usuario.login\" \nng-change=\"vm.metodosUsuario.onChangeUsuarioLogin(vm.form.colaborador.login, vm.form, vm.controleForm)\" \nng-required=\"vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\"><div \nng-messages=\"vm.form.colaborador.login.$error\"><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div><div ng-message=\"usuarioExistente\"><span>\nLogin já cadastrado para outro usuário</span></div></div></md-input-container><div class=\"md-block\" flex-gt-sm=\"15\" \nstyle=\"margin: 15px 0px 0px 25px\"><div layout=\"row\"><md-button class=\"md-raised md-accent\" \nng-click=\"vm.metodosUsuario.rotinaSenha($event);\" \nng-disabled=\"!vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\" flex><span>\n{{vm.usuario.possuiSenha ? \"Alterar\" : \"Incluir\"}} Senha</span></md-button></div><div layout=\"row\" \nlayout-align=\"center center\" class=\"erroSenha\" ng-if=\"vm.controleForm.inserirAtivo && !vm.usuario.senha\">\nA senha deve ser informada.</div></div><md-input-container class=\"md-block\" flex><input type=\"hidden\" \nng-model=\"vm.usuario.senha\" ng-required=\"vm.controleForm.inserirAtivo\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\">\n</md-input-container></div><div layout-gt-xs=\"row\"><md-input-container class=\"md-block\" flex-gt-sm=\"50\"><label \ntranslate=\"COLABORADOR.SETOR\"></label><md-select ng-model=\"vm.usuario.codigoSetor\" name=\"setorCodigo\" \nng-required=\"vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\"><md-option\n ng-value=\"setor.codigo\" ng-repeat=\"setor in vm.setores track by setor.codigo\">{{setor.descricao}}</md-option>\n</md-select><div ng-messages=\"vm.form.colaborador.setorCodigo.$error\"><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container><md-input-container class=\"md-block\" \nflex-gt-sm=\"50\"><label translate=\"COLABORADOR.PERFIL\"></label><md-select ng-model=\"vm.usuario.codigoPerfil\" \nname=\"perfilCodigo\" ng-required=\"vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\"><md-option\n ng-value=\"perfil.codigo\" ng-repeat=\"perfil in vm.perfis track by perfil.codigo\">{{perfil.descricao}}</md-option>\n</md-select><div ng-messages=\"vm.form.colaborador.perfilCodigo.$error\"><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_MULTIPLO_OBRIGATORIO\"></div></div></md-input-container><md-input-container \nclass=\"md-block\" flex-gt-sm=\"50\"><label translate=\"COLABORADOR.SQUAD\"></label><md-select \nng-model=\"vm.usuario.detalhesUsuario.codigoSquads\" name=\"codigoSquads\" multiple=\"multiple\" \nng-required=\"vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo\" \nng-disabled=\"!vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\"><md-option ng-value=\"squad.codigo\" \nng-repeat=\"squad in vm.squads track by squad.codigo\">{{squad.descricao}}</md-option></md-select><div \nng-messages=\"vm.form.colaborador.codigoSquads.$error\"><div ng-message=\"required\">Campo obrigatório</div></div>\n</md-input-container></div></div></md-content>");
$templateCache.put("app/main/implantacao-migracao/processamento/processos-funis/processo-funil/views/dialogs/dialog-observacao-subprocesso/dialog-observacao-subprocesso.html","<md-dialog id=\"dialog-observacao-subprocesso\" class=\"dialogo-padrao\" aria-label=\"Dialog\"><form name=\"vm.form\" \nclass=\"md-inline-form\" novalidate><md-toolbar class=\"md-accent md-tall\" layout=\"column\"><div \nclass=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" layout-align=\"space-between center\" flex><div layout=\"row\" \nlayout-align=\"center\" flex><span class=\"title text-center\">Insira um motivo</span></div></div></md-toolbar>\n<md-dialog-content class=\"conteudo-dialog\"><div layout=\"row\"><md-input-container class=\"md-block\" flex><label \ntranslate=\"\">Motivo</label><textarea name=\"observacao\" md-no-resize=\"true\" rows=\"3\" max-rows=\"5\" \nng-disabled=\"vm.requisicaoSolicitada\" ng-required=\"true\" ng-model=\"vm.subProcessoHistorico.observacao\">\n\r\n                    </textarea></md-input-container></div><div layout=\"column\" layout-align=\"center center\" \nng-show=\"vm.requisicaoSolicitada\"><span class=\"font-weight-500\">{{vm.mensagemPreloader}}</span><md-progress-circular \nclass=\"md-accent\" md-mode=\"indeterminate\" md-diameter=\"30\"></md-progress-circular></div></md-dialog-content>\n<md-dialog-actions layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\">\n<md-button class=\"send-button md-accent md-raised\" type=\"submit\" \nng-disabled=\"vm.form.$invalid || vm.form.$pristine || vm.requisicaoSolicitada || vm.tabSelecionada === \'dadosHistorico\' || (!vm.etapaAtual.permiteValoresZerados && vm.negocio.valor == 0)\" \nng-click=\"vm.metodos.salvar()\" aria-label=\"SALVAR\" translate=\"SALVAR\" translate-attr-aria-label=\"SALVAR\">Salvar\n</md-button><md-button class=\"send-button md-accent md-raised\" type=\"cancel\" ng-disabled=\"vm.requisicaoSolicitada\" \nng-click=\"vm.metodos.cancelar()\" aria-label=\"CANCELAR\" translate=\"CANCELAR\" translate-attr-aria-label=\"CANCELAR\">\nCancelar</md-button></div></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/implantacao-migracao/processamento/processos-funis/processo-funil/views/dialogs/dialog-processo/dialog-processo.html","<md-dialog id=\"implantacao-migracao-dialog-subprocesso\" class=\"dialogo-padrao\" aria-label=\"Dialog\"><form \nname=\"vm.form\" class=\"md-inline-form\" novalidate><md-toolbar class=\"md-accent md-tall\" layout=\"column\"><div \nclass=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" layout-align=\"space-between center\" flex><div layout=\"row\" \nlayout-align=\"start center\" flex><span class=\"title text-center texto-titulo\">{{vm.descricaoProcesso}}</span></div><div\n layout=\"row\"><md-button class=\"md-icon-button\" ng-click=\"vm.metodos.fecharDialog()\" aria-label=\"Fechar dialog\" \ntranslate translate-attr-aria-label=\"PIPELINE_NEGOCIO.FECHAR_DIALOG\"><md-icon md-font-icon=\"icon-close\"></md-icon>\n</md-button></div></div></md-toolbar><div layout=\"column\" layout-align=\"center center\" \nng-show=\"vm.requisicaoSolicitada\"><span class=\"font-weight-500\">{{vm.mensagemPreloader}}</span><md-progress-circular \nmd-mode=\"indeterminate\" md-diameter=\"30\" class=\"md-accent\"></md-progress-circular></div><md-dialog-content \nclass=\"conteudo-dialog\"><md-tabs md-dynamic-height md-border-bottom ng-disabled=\"vm.requisicaoSolicitada\"><md-tab \nlabel=\"Dados do negócio\" md-active=\"vm.tabSelecionada === \'processo\'\" \nmd-on-select=\"vm.metodos.tabSelecionada(\'processo\')\" ng-disabled=\"vm.requisicaoSolicitada\"><md-tab-label><label>DADOS\n</label></md-tab-label><md-tab-body><div ng-include=\"vm.htmlRota.dialogProcesso.tabs.tabDadosProcesso\" \nclass=\"conteudo-tab\"></div></md-tab-body></md-tab><md-tab label=\"Atividades do processo\" \nmd-active=\"vm.tabSelecionada === \'atividadesProcesso\'\" md-on-select=\"vm.metodos.tabSelecionada(\'atividadesProcesso\')\" \nng-disabled=\"vm.requisicaoSolicitada || vm.novaEntidade || vm.atividadesTarefa.length <= 0\"><md-tab-label><label>\nATIVIDADES</label></md-tab-label><md-tab-body><div ng-include=\"vm.htmlRota.dialogProcesso.tabs.tabAtividadesProcesso\">\n</div></md-tab-body></md-tab><md-tab label=\"Dados de histórico\" md-active=\"vm.tabSelecionada === \'dadosHistorico\'\" \nmd-on-select=\"vm.metodos.tabSelecionada(\'dadosHistorico\')\" ng-disabled=\"vm.requisicaoSolicitada || vm.novaEntidade\">\n<md-tab-label><label>HISTÓRICO</label></md-tab-label><md-tab-body><div \nng-include=\"vm.htmlRota.dialogProcesso.tabs.tabDadosHistorico\"></div></md-tab-body></md-tab></md-tabs>\n</md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" \nlayout-align=\"start center\"><md-button type=\"submit\" ng-click=\"vm.metodos.salvar(vm.subprocesso)\" \nclass=\"send-button md-accent md-raised\" \nng-disabled=\"vm.form.$invalid || vm.form.$pristine || vm.requisicaoSolicitada || vm.tabSelecionada === \'dadosHistorico\' || (!vm.etapaAtual.permiteValoresZerados && vm.negocio.valor == 0)\" \naria-label=\"Salvar\" translate=\"Salvar\" translate-attr-aria-label=\"Salvar\">Salvar</md-button></div></md-dialog-actions>\n</form></md-dialog>");
$templateCache.put("app/main/locacao/processamento/locacao/envio/view/dialogs/dialog-editar-envio/dialog-editar-envio.html","");
$templateCache.put("app/main/locacao/processamento/locacao/envio/view/dialogs/dialog-historico/dialog-historico.html","<md-dialog style=\"min-width: 80%\"><md-toolbar><div class=\"md-toolbar-tools\" style=\"background-color: #039BE5\"><h2>\nHistórico - {{vm.detalhesHistoricos[0].equipamentoDescricao}} - Número de série: {{vm.detalhesHistoricos[0].numeroSerie}}\n</h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"vm.metodos.cancel()\" aria-label=\"Fechar dialog\" \ntranslate translate-attr-aria-label=\"CLIENTE.FECHAR_DIALOG\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button>\n</div></md-toolbar><md-dialog-content layout=\"column\" style=\"overflow: scroll\"><div layout=\"column\" flex \nng-if=\" !vm.pesquisando && vm.iniciaTabela\"><div \nclass=\"md-padding md-background-bg md-whiteframe-1dp fullpage-datatable\"><table class=\"dataTable row-border hover\" \ndatatable=\"ng\" dt-options=\"vm.historicoDtOptions\"><thead><tr><th class=\"secondary-text\"><div class=\"table-header\"><span\n class=\"column-title\">Data</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Situação</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Tipo do contrato</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Item</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Cliente</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Usuário</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Estado conservação</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Fotos</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Empresa ativo</span></div></th></tr></thead><tbody><tr \nng-repeat=\"historico in vm.detalhesHistoricos | orderBy:\'id\':true\"><td class=\"border-left border-right h3 text-center\">\n<span ng-hide=\"true\">{{historico.data}}</span> {{historico.data | date:\'dd/MM/yyyy\'}}</td><td \nclass=\"border-right h3 text-center\">{{historico.situacaoDescricao}}</td><td class=\"border-right h3 text-center\">\n{{historico.tipoContrato }}</td><td class=\"border-right h3 text-center\">{{historico.produto}}</td><td \nclass=\"border-right h3 text-center\">{{historico.clienteNome}}</td><td class=\"border-right _expanded_ text-center h3\">\n{{historico.usuarioNome}}</td><td class=\"h3 text-center border-right\">\n{{historico.equipamentoEstadoConservacaoDescricao}}</td><td class=\"button-icone-cor-azul text-center\"><i \nclass=\"icon-picture s16 icone-cor-padrao\" \nng-click=\"vm.controleForm.emProgresso || vm.metodos.dialogFoto($event,historico)\" \nng-disabled=\"vm.controleForm.emProgresso\"></i></td><td class=\"border-left border-right text-center h3\">\n{{ vm.metodos.retornaDescricaoEmpresaAtivo(historico.empresaAtivoId) }}</td></tr></tbody></table></div></div>\n</md-dialog-content></md-dialog>");
$templateCache.put("app/main/locacao/processamento/locacao/envio/view/dialogs/dialog-zoom-foto/dialog-zoom-foto.html","<md-dialog style=\"min-width: 90%;min-height: 100% !important\"><md-toolbar><div class=\"md-toolbar-tools\" \nstyle=\"background-color: #039BE5;justify-content: flex-end\"><h2>Foto ampliada</h2><span flex></span><md-button \nclass=\"md-icon-button\" ng-click=\"vm.metodos.cancel()\" aria-label=\"Fechar dialog\" translate \ntranslate-attr-aria-label=\"CLIENTE.FECHAR_DIALOG\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content flex><img ng-if=\"vm.servidor\" ng-src=\"{{vm.foto}}\" flex style=\"width: 100%\"> <img \nng-if=\"!vm.servidor\" src=\"data:image/jpg;base64,{{vm.foto}}\" flex style=\"width: 100%\"></md-dialog-content></md-dialog>");
$templateCache.put("app/main/locacao/processamento/locacao/retorno/view/dialogs/dialog-detalhes-envio/dialog-detalhes-envio.html","<md-dialog style=\"width: 30%; max-height: 80%\" id=\"locacao-retorno\"><md-toolbar><div class=\"md-toolbar-tools\" \nstyle=\"background-color: #039BE5\"><h2>Prévia detalhes</h2><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"vm.metodos.cancel()\" aria-label=\"Fechar dialog\" translate translate-attr-aria-label=\"CLIENTE.FECHAR_DIALOG\">\n<md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content layout=\"column\" \nstyle=\"overflow: scroll; max-height: 80%;padding-top: 0px\"><div layout=\"column\" flex><h1 layout-align=\"center center\">\n<strong>Equipamentos</strong></h1><div layout=\"row\" class=\"mb-10\" ng-if=\"vm.requisicaoSolicitada\" flex><div \nlayout=\"row\" layout-align=\"center center\" flex><div layout=\"column\" layout-align=\"center center\" class=\"mt-50\"><span \nclass=\"font-weight-250\" style=\"font-size: 16px\">Carregando</span><md-progress-circular md-mode=\"indeterminate\" \nmd-diameter=\"100\" class=\"md-accent\"></md-progress-circular></div></div></div><div \nng-class=\"{\'zebra\' : $index %2 == 0}\" layout=\"column\" ng-if=\"!vm.requisicaoSolicitada\" ng-repeat=\"item in vm.detalhes\" \nstyle=\"box-shadow: 0px 1px 0px lightgrey;border: groove\"><h3 class=\"texto-espaco\"><strong>Equipamento:</strong>\n{{item.equipamentoNotaItemDetalhe.equipamento.descricao}}</h3><h3 class=\"texto-espaco\"><strong>Número de série:\n</strong>{{item.equipamentoNotaItemDetalhe.numeroSerie}}</h3></div></div></md-dialog-content></md-dialog>");
$templateCache.put("app/main/locacao/processamento/locacao/retorno/view/dialogs/dialog-estado-conservacao-retorno/dialog-conservacao.html","<form name=\"vm.form\" style=\"min-width: 20%; max-width: 80%\"><md-dialog style=\"max-width: 100%\"><md-toolbar><div \nclass=\"md-toolbar-tools\" style=\"background-color: #039BE5\"><h2 ng-if=\"!vm.apenasFoto\">\nEstado de conservação - {{vm.detalhe.equipamento.descricao}} - Nº Serie: {{vm.detalhe.numeroSerie}}</h2><h2 \nng-if=\"vm.apenasFoto\">Foto - {{vm.detalhe.equipamento.descricao}} - Nº Serie: {{vm.detalhe.numeroSerie}}</h2><span \nflex></span><md-button class=\"md-icon-button\" ng-click=\"vm.metodos.cancel()\" aria-label=\"Fechar dialog\" translate \ntranslate-attr-aria-label=\"CLIENTE.FECHAR_DIALOG\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content><div layout=\"column\" flex style=\"padding: 1%\"><md-input-container class=\"md-block\" \nflex=\"20\" ng-if=\"!vm.apenasFoto\"><label>Conservação:</label><md-select \nng-model=\"vm.locacaoEnvio.equipamentoEstadoConservacao\"><md-option layout=\"row\" \nng-repeat=\"item in vm.equipamentoEstadoConservacao\" ng-value=\"item.id\" name=\"conservacao\" ng-required=\"true\">\n{{ item.descricao }}</md-option></md-select></md-input-container><input id=\"inputFoto\" hidden type=\"file\" \nim-file-change=\"vm.metodos.selecionarArquivoFotoDivulgacao($event, arquivos)\" name=\"fotoDivulgacao\" \naccept=\"image/jpeg, image/png\" multiple=\"multiple\" style=\"max-width: 100%;align-self: center\" ng-if=\"vm.apenasFoto\">\n<md-button ng-click=\"vm.metodos.inputFoto()\" ng-if=\"vm.apenasFoto\" \nstyle=\"max-width: 250px;align-self: center; background-color: #039BE5\" \nclass=\"md-accent md-raised md-hue-2 header-boards-button\"><i class=\"icon-folder s24\"></i> Selecionar</md-button></div>\n<div style=\"text-align: center\" class=\"mt-8\"><md-button class=\"md-accent md-raised md-hue-2 header-boards-button\" \nlayout-align=\"center center\" ng-disabled=\"vm.desabilitarButtonSalvar\" \nng-click=\"vm.metodos.dialog(vm.locacaoEnvio, item)\"><span>Salvar</span></md-button></div></md-dialog-content>\n</md-dialog></form>");
$templateCache.put("app/main/locacao/processamento/locacao/retorno/view/dialogs/dialog-retornar-todos/dialog-retornar-todos.html","<md-dialog style=\"width: 40%; max-height: 80%\"><md-toolbar><div class=\"md-toolbar-tools\" \nstyle=\"background-color: #039BE5\"><h2>Retorno de equipamentos</h2><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"vm.metodos.cancel()\" aria-label=\"Fechar dialog\" translate translate-attr-aria-label=\"CLIENTE.FECHAR_DIALOG\">\n<md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><div flex flex-gt-sm=\"33\" \nstyle=\"height: 62vh\" id=\"locacao-retorno\"><md-card flex layout=\" column\" style=\"height: 100%\"><div \nclass=\"shortcut-loader\" layout=\"row\" layout-align=\"center center\" ng-if=\"vm.requisicaoSolicitada\"><md-progress-circular\n class=\"md-accent\" md-diameter=\"20\" md-mode=\"indeterminate\"></md-progress-circular></div><div \nstyle=\"height: 61.5vh; overflow: scroll\" ng-if=\"!vm.requisicaoSolicitada\"><md-content><md-list flex><md-list-item \nclass=\"md-3-line espacamento p-8\" ng-repeat=\"item in vm.locados\" ng-class=\"{\'zebra\' : $index %2 == 0}\"><div \nclass=\"md-list-item-text\" layout=\"column\"><h4><strong>N° Série: </strong>\n{{item.equipamentoNotaItemDetalhe.numeroSerie}}</h4><h4><strong>IMEI: </strong>{{item.equipamentoNotaItemDetalhe.imei}}\n</h4><h4><strong>Equipamento: </strong>{{item.equipamentoNotaItemDetalhe.equipamento.descricao}}</h4></div><div \nlayout=\"row\" class=\"md-secondary\"><md-button class=\"md-icon-button siglas\" \nng-class=\"{\'bordaEstadoConservacao\' : item.equipamentoEstadoConservacao.descricao != \'NV\'}\" \nng-click=\"vm.metodos.botaoDialogEstadoConservacao($index, item)\">\n{{item.equipamentoEstadoConservacao.descricao[0] + item.equipamentoEstadoConservacao.descricao[1]}}<md-tooltip><span>\nEstado de conservação: {{item.equipamentoEstadoConservacao.descricao}}</span></md-tooltip></md-button><md-button \nclass=\"md-icon-button siglas\" ng-disabled=\"vm.locados.length <= 0\" ng-click=\"vm.metodos.botaoDialogFoto($index, item)\" \nng-class=\"{\'bordaEstadoConservacao\' : item.equipamentoNotaItemDetalhe.fotos.length > 0}\"><i \nclass=\"icon-picture s16 icone-cor-padrao\" ng-disabled=\"vm.controleForm.emProgresso\"></i><md-tooltip><span>Fotos</span>\n</md-tooltip></md-button></div></md-list-item></md-list></md-content></div><div layout-gt-xs=\"row\" \nlayout-align=\"end end\" ng-if=\"!vm.requisicaoSolicitada\" style=\"height: 0px\"><md-button \nng-disabled=\"vm.desabilitaBotao\" ng-click=\"vm.metodos.retornarTodos()\" class=\"md-fab md-accent md-icon-button\" \nstyle=\"margin: 0px 10px 10px 0px\"><i class=\"icon-content-save white-fg\"><md-tooltip><span>Retornar Equipamentos</span>\n</md-tooltip></i></md-button></div></md-card></div></md-dialog>");
$templateCache.put("app/main/pipeline/processamento/pipeline-negocio/views/pipeline-negocios/sidenavs/filtros/filtros-negocio-sidenav.html","<md-toolbar class=\"md-accent\"><div class=\"md-toolbar-tools\"><span flex class=\"menu-title\" \ntranslate=\"PIPELINE_NEGOCIO.FILTROS\">Filtros</span><md-button ng-if=\"vm.exibirButtonLimparFiltros()\" \nng-click=\"vm.limparFiltrosCard()\" class=\"md-icon-button\" aria-label=\"clear filters\"><md-icon \nmd-font-icon=\"icon-filter-remove\"></md-icon><md-tooltip></md-tooltip></md-button></div></md-toolbar><md-content \nclass=\"\" ms-scroll><md-list><div class=\"p-10\"><multi-select-directive id=\"select-clientes\" form-name=\"clientes\" \ndata=\"vm.filtrarCards.clientes\" model=\"vm.filtrarCards.clientesFiltros\" obrigatorio=\"false\" \ndescricao-exibicao=\"nomeCliente\" texto-pesquisa-placeholder=\"Procurar cliente...\" texto-placeholder=\"Cliente\" \non-change=\"vm.filtrarClientesChange()\" flex></multi-select-directive></div><md-divider></md-divider><div class=\"p-10\">\n<multi-select-directive id=\"select-executivos\" form-name=\"executivos\" data=\"vm.filtrarCards.colaboradoresResponsaveis\" \nmodel=\"vm.filtrarCards.colaboradoresResponsaveisFiltrados\" obrigatorio=\"false\" \ndescricao-exibicao=\"nomeColaboradorResponsavel\" texto-pesquisa-placeholder=\"Procurar executivo...\" \ntexto-placeholder=\"Executivo de Contas\" on-change=\"vm.filtrarColaboradoresResponsaveisChange()\" flex>\n</multi-select-directive></div><md-divider></md-divider><div class=\"p-10\"><multi-select-directive id=\"select-produtos\" \nform-name=\"produtos\" data=\"vm.filtrarCards.produtos\" model=\"vm.filtrarCards.produtosFiltros\" obrigatorio=\"false\" \ndescricao-exibicao=\"descricao\" texto-pesquisa-placeholder=\"Procurar produto...\" texto-placeholder=\"Produto\" \non-change=\"vm.filtrarProdutosChange()\" flex></multi-select-directive></div><md-divider></md-divider><div class=\"p-10\">\n<fieldset style=\"border:1px solid #ccc; border-radius:4px; padding:10px\"><legend class=\"grp-legend\">Valor</legend><div \nlayout=\"row\" layout-align=\"start center\"><md-input-container flex=\"50\" style=\"margin-right:10px\"><label>De</label>\n<input type=\"text\" mascara-tamanho-campo=\"12\" ui-money-mask ng-model=\"vm.filtrarCards.valorDe\" \nng-change=\"vm.filtrarValorChange()\"></md-input-container><md-input-container flex=\"50\"><label>Até</label><input \ntype=\"text\" mascara-tamanho-campo=\"12\" ui-money-mask ng-model=\"vm.filtrarCards.valorAte\" \nng-change=\"vm.filtrarValorChange()\"></md-input-container></div></fieldset></div></md-list></md-content>");
$templateCache.put("app/main/pesquisa/processamento/pesquisa/views/tabs/perguntas/dialog-perguntas/dialog-perguntas.html","<md-dialog id=\"dialog-pesquisa-perguntas\" class=\"dialogo-padrao\" aria-label=\"Dialog\"><form name=\"vm.form\" \nclass=\"md-inline-form\" novalidate><md-toolbar class=\"md-accent md-tall\" layout=\"column\"><div \nclass=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\">\n{{vm.titulo}}</span><md-button class=\"md-icon-button\" ng-click=\"vm.metodos.fecharDialog()\" aria-label=\"Fechar dialog\">\n<md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><div layout=\"row\" layout-sm=\"row\" \nlayout-align=\"center\" ng-if=\"vm.emProgresso || vm.preloader.habilitar\"><md-progress-circular md-mode=\"indeterminate\" \nclass=\"md-accent\"></md-progress-circular></div><md-dialog-content ng-hide=\"vm.emProgresso || vm.preloader.habilitar\">\n<div layout-gt-xs=\"row\"><md-input-container class=\"md-block\" flex-gt-sm><label>Descrição</label><input type=\"text\" \nng-model=\"vm.pergunta.pergunta\" name=\"pergunta\" mascara-tamanho-campo=\"200\" ng-required=\"true\" md-maxlength=\"200\"><div \nng-messages=\"vm.form.pergunta.$error\"><div ng-message=\"required\" translate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\">\n</div></div></md-input-container></div><div layout-gt-xs=\"row\" layout-align=\"start end\"><md-input-container \nclass=\"md-block\" flex-gt-sm=\"25\"><md-switch aria-label=\"Permitir resposta aberta\" name=\"permitirRespostaAberta\" \nng-model=\"vm.pergunta.permitirRespostaAberta\" \nng-change=\"vm.metodos.changePermitirRespostaAberta(vm.pergunta.permitirRespostaAberta)\">Permitir resposta aberta\n</md-switch></md-input-container><md-input-container class=\"md-block\" flex-gt-sm=\"25\" \nng-if=\"!vm.pergunta.permitirRespostaAberta\"><label>Nota mínima</label><input type=\"text\" \nng-model=\"vm.pergunta.notaMinima\" name=\"notaMinima\" ng-required=\"true\" converte-mascara-para-numero \nmascara-numero-generica=\"###\"><div ng-messages=\"vm.form.notaMinima.$error\"><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container><md-input-container class=\"md-block\" \nflex-gt-sm=\"25\" ng-if=\"!vm.pergunta.permitirRespostaAberta\"><label>Nota máxima</label><input type=\"text\" \nng-model=\"vm.pergunta.notaMaxima\" name=\"notaMaxima\" ng-required=\"true\" converte-mascara-para-numero \nng-change=\"vm.metodos.changeNotaMaxima(vm.form)\" mascara-numero-generica=\"###\"><div \nng-messages=\"vm.form.notaMaxima.$error\"><div ng-message=\"required\" translate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\">\n</div><div ng-message=\"tamanhoMinimo\">Deve ser maior que a nota mínima</div></div></md-input-container>\n<md-input-container class=\"md-block\" flex-gt-sm=\"25\" ng-if=\"vm.pergunta.permitirRespostaAberta\"><label>Tamanho máximo\n</label><input type=\"text\" ng-model=\"vm.pergunta.tamanhoMaximoResposta\" name=\"tamanhoMaximoResposta\" \nng-required=\"true\" converte-mascara-para-numero mascara-numero-generica=\"#####\"><div \nng-messages=\"vm.form.tamanhoMaximoResposta.$error\"><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container></div></md-dialog-content>\n<md-dialog-actions layout=\"row\" layout-align=\"end center\"><div layout=\"row\" layout-align=\"start center\"><md-button \ntype=\"submit\" ng-click=\"vm.metodos.salvar(vm.rotina)\" class=\"send-button md-accent md-raised\" \nng-disabled=\"vm.form.$invalid || vm.form.$pristine || vm.emProgresso\" aria-label=\"SALVAR\" \ntranslate=\"SOLUCAO_ROTINAS_TAREFAS.SALVAR\" translate-attr-aria-label=\"SOLUCAO_ROTINAS_TAREFAS.SALVAR\"></md-button>\n</div></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/planejamento-scrum/processamento/sprint/views/tabs/backlog/views/tabela-backlog.html","<div class=\"md-padding\" layout-gt-sm=\"row\" layout-gt-xs=\"column\" flex><div \nclass=\"margin-top md-background-bg md-whiteframe-1dp\" flex><md-button class=\"array-buttons-backlog\" \naria-label=\"Filtrar Tabela de Registros\" ng-repeat=\"item in vm.coresSituacoes\" \nng-class=\"{\'descricao-selecionada\': item.legendaSelecionada}\" \nng-click=\"vm.metodosBacklog.filtrarTabelaPorSituacao($index, item)\" \nng-disabled=\"((vm.positivaSelecionada == true) && (!item.situacaoPositiva)) || \r\n                   ((vm.positivaSelecionada == false) && (item.situacaoPositiva))\" \nng-hide=\"{{item.descricao == \'Atualizada no cliente\'}}\"><md-icon class=\"s16\" md-font-icon=\"icon-label\" \nng-style=\"{\'color\' : item.cor}\"></md-icon><span class=\"title\">{{item.descricao}}</span></md-button><md-button \nclass=\"array-buttons-backlog\" aria-label=\"Desmarcar filtros\" ng-click=\"vm.metodosBacklog.desmarcarFiltrosBacklog()\" \nng-show=\"situacoesSelecionadasDescricoes.length > 0\"><md-icon class=\"s16\" md-font-icon=\"icon-label\" \nng-style=\"{\'color\' : \'#323232\'}\"></md-icon><span class=\"title\">Desmarcar filtros</span></md-button><table \nid=\"datatable-backlog\" class=\"dataTable row-border hover\" datatable=\"ng\" dt-options=\"vm.dtOptionsSprintBacklog\" \nng-if=\"vm.habilitarTabela\" width=\"100%\"><thead><tr><th class=\"secondary-text border-left border-top\"><div \nclass=\"table-header\"><span class=\"column-title\">Ação</span></div></th><th class=\"secondary-text border-top\"><div \nclass=\"table-header\"><span class=\"column-title\">História</span></div></th><th class=\"secondary-text border-top\"><div \nclass=\"table-header\"><span class=\"column-title\">Descrição</span></div></th><th class=\"secondary-text border-top\"><div \nclass=\"table-header\"><span class=\"column-title\">Solução</span></div></th><th class=\"secondary-text border-top\"><div \nclass=\"table-header\"><span class=\"column-title\">Situação</span></div></th><th class=\"secondary-text border-top\"><div \nclass=\"table-header\"><span class=\"column-title\">Cliente</span></div></th><th class=\"secondary-text border-top\"><div \nclass=\"table-header\"><span class=\"column-title\">Stack</span></div></th><th></th><th ng-hide=\"true\"></th><th \nng-hide=\"true\"></th></tr></thead><tbody><tr flex ng-repeat=\"estoriaBacklog in vm.sprint.backlogEstorias\"><td \nclass=\"coluna-acao border-left\"><button ng-disabled=\"vm.controleForm.emProgresso\" \nng-click=\"vm.controleForm.emProgresso || \r\n                                vm.metodosBacklog.excluirEstoriaBacklog($event, estoriaBacklog)\">\n<i class=\"icon-delete s16 icone-cor-padrao mr-10\" ng-disabled=\"vm.controleForm.emProgresso\"></i></button> <button \nng-disabled=\"vm.controleForm.emProgresso\" \nng-click=\"vm.controleForm.emProgresso || \r\n                                vm.metodosBacklog.editarEstoriaBacklog($event,estoriaBacklog)\" \noffset=\"5\"><i class=\"icon-open-in-new s16 icone-cor-padrao mr-10\" ng-disabled=\"vm.controleForm.emProgresso\"></i>\n</button> <button class=\"botao-historias-vinculadas\" \nng-click=\"vm.metodosBacklog.abrirDialogHistoriasVinculadasBacklog(estoriaBacklog)\" \nng-disabled=\"vm.controleForm.emProgresso\" offset=\"5\"><i class=\"icon-playlist-plus s18 icone-cor-padrao\" \nng-disabled=\"vm.controleForm.emProgresso\"></i><md-icon class=\"s8 icone-historia-vinculada\" \nmd-font-icon=\"icon-checkbox-blank-circle\" ng-if=\"estoriaBacklog.estoria.possuiVinculo\" layout-align=\"end end\">\n</md-icon></button></td><td flex class=\"border-left border-right h3 font-weight-400 text-center\" \nng-class=\"{\'homologada\': estoriaBacklog.estoria.ultimoHistoricoSituacao.situacaoCodigo == vm.coresSituacoes[0].codigo,\r\n                                    \'retorno-erro\': estoriaBacklog.estoria.ultimoHistoricoSituacao.situacaoCodigo == vm.coresSituacoes[1].codigo,\r\n                                    \'retorno-melhoria\': estoriaBacklog.estoria.ultimoHistoricoSituacao.situacaoCodigo == vm.coresSituacoes[2].codigo,\r\n                                    \'em-pausa\': estoriaBacklog.estoria.ultimoHistoricoSituacao.situacaoCodigo == vm.coresSituacoes[3].codigo[0]\r\n                                    || estoriaBacklog.estoria.ultimoHistoricoSituacao.situacaoCodigo == vm.coresSituacoes[3].codigo[1],\r\n                                    \'em-testes\': estoriaBacklog.estoria.ultimoHistoricoSituacao.situacaoCodigo == vm.coresSituacoes[4].codigo,\r\n                                    \'liberada-para-teste\': estoriaBacklog.estoria.ultimoHistoricoSituacao.situacaoCodigo == vm.coresSituacoes[5].codigo,\r\n                                    \'em-desenvolvimento\': estoriaBacklog.estoria.ultimoHistoricoSituacao.situacaoCodigo == vm.coresSituacoes[6].codigo,\r\n                                    \'refinada\': estoriaBacklog.estoria.ultimoHistoricoSituacao.situacaoCodigo == vm.coresSituacoes[7].codigo,\r\n                                    \'estimada\': estoriaBacklog.estoria.ultimoHistoricoSituacao.situacaoCodigo == vm.coresSituacoes[8].codigo,\r\n                                    \'backlog\': estoriaBacklog.estoria.ultimoHistoricoSituacao.situacaoCodigo == vm.coresSituacoes.backlog.codigo,\r\n                                    \'atualizada-no-cliente\': estoriaBacklog.estoria.ultimoHistoricoSituacao.situacaoCodigo == vm.coresSituacoes[10].codigo,\r\n                                    \'analise\': estoriaBacklog.estoria.ultimoHistoricoSituacao.situacaoCodigo == vm.coresSituacoes[11].codigo}\">\n{{estoriaBacklog.estoria.numero}}/{{estoriaBacklog.estoria.ano}}</td><td class=\"font-size-14\">\n{{estoriaBacklog.estoria.descricao}}</td><td class=\"font-size-14\">{{estoriaBacklog.estoria.solucaoDescricao}}</td><td \nid=\"backlog-td-situacao{{$index}}\" class=\"font-size-14\" \nng-dblclick=\"vm.metodosBacklog.abrirDialogEstoriaBacklogSituacao($index ,$event, \r\n                        estoriaBacklog.estoria.ultimoHistoricoSituacao, estoriaBacklog.estoria,estoriaBacklog)\">\n<div class=\"border-bottom-historico\">{{estoriaBacklog.estoria.ultimoHistoricoSituacao.situacao.descricao}}</div></td>\n<td class=\"font-size-14\">{{estoriaBacklog.estoria.clienteNome}}</td><td class=\"font-size-14\"><div \nng-repeat=\"stack in vm.stack\" ng-if=\"estoriaBacklog.estoria.stackResponsavel == stack.codigo\">{{ stack.descricao }}\n</div><div ng-if=\"!estoriaBacklog.estoria.stackResponsavel\"></div></td><td class=\"border-left\"><div class=\"ml-10\" \nlayout-gt-xs=\"column\" layout-align=\"center center\" flex><div layout=\"row\"><md-button \nclass=\"md-icon-button md-avatar siglas\" \nng-click=\"vm.controleForm.emProgresso || \r\n                                           vm.metodosBacklog.abrirDialogEstoriaBacklogColaboradores($event, estoriaBacklog.estoria)\">\n{{estoriaBacklog.estoria.desenvolvedorNome[0] + estoriaBacklog.estoria.desenvolvedorNome[1] | uppercase}}<md-tooltip>\n<span>{{estoriaBacklog.estoria.desenvolvedorNome}}</span></md-tooltip></md-button><md-button \nclass=\"md-icon-button siglas\" \nng-click=\"vm.controleForm.emProgresso || \r\n                                           vm.metodosBacklog.abrirDialogEstoriaBacklogColaboradores($event, estoriaBacklog.estoria)\">\n{{vm.metodosBacklog.retornaSigla($event,estoriaBacklog.estoria.testerNome) | uppercase}}<md-tooltip><span>\n{{estoriaBacklog.estoria.testerNome}}</span></md-tooltip></md-button></div><div layout=\"row\" class=\"mt-10\"><md-button \nclass=\"md-icon-button siglas margenBotaoPonto\" \nng-click=\"vm.controleForm.emProgresso || \r\n                                           vm.metodosBacklog.abrirDialogEstoriaBacklogPontuacao($event, estoriaBacklog)\">\n{{estoriaBacklog.pontuacaoInicial}}<md-tooltip \nng-if=\"!vm.metodosBacklog.verificaPontuacao(estoriaBacklog,estoriaBacklog.pontuacaoEntregue)\"><span>Pontuação Estimada\n</span></md-tooltip><md-tooltip \nng-if=\"vm.metodosBacklog.verificaPontuacao(estoriaBacklog,estoriaBacklog.pontuacaoEntregue)\"><span>\nPontuação entregue só pode ser informada em fase Homologada e não pode ser maior que pontuação inicial</span>\n</md-tooltip><md-icon class=\"s16 tipo\" md-font-icon=\"icon-checkbox-blank-circle\" \nng-if=\"vm.metodosBacklog.verificaPontuacao(estoriaBacklog,estoriaBacklog.pontuacaoEntregue)\" layout-align=\"end end\" \nstyle=\"color: red\"></md-icon></md-button><md-button class=\"md-icon-button siglas\" \nng-click=\"vm.controleForm.emProgresso || \r\n                                           vm.metodosBacklog.abrirDialogEstoriaBacklogPriorizacao($event, estoriaBacklog)\">\n{{estoriaBacklog.prioridade}}<md-tooltip><span>Prioridade</span></md-tooltip></md-button></div></div></td><td \nng-hide=\"true\">{{estoriaBacklog.estoria.desenvolvedorNome}}</td><td ng-hide=\"true\">\n{{estoriaBacklog.estoria.testerNome}}</td></tr></tbody></table></div></div>");
$templateCache.put("app/main/planejamento-scrum/processamento/sprint/views/tabs/backlog/views/tabela-cadastro-backlog.html","<div layout-gt-sm=\"row\" layout-gt-xs=\"column\" flex><div class=\"mt-15\" ms-scroll flex><table class=\"row-border hover\" \ndatatable=\"ng\" dt-options=\"vm.dtOptionsSprintCadastroBacklog\" width=\"100%\"><thead><tr><th \nclass=\"secondary-text border-top\"><div class=\"table-header\"><span class=\"column-title\">Selecionar</span></div></th><th \nclass=\"secondary-text border-top\"><div class=\"table-header\"><span class=\"column-title\">História</span></div></th><th \nclass=\"secondary-text border-top\"><div class=\"table-header\"><span class=\"column-title\">Descrição</span></div></th><th \nclass=\"secondary-text border-top\"><div class=\"table-header\"><span class=\"column-title\">Cliente</span></div></th><th \nclass=\"secondary-text border-top\"><div class=\"table-header\"><span class=\"column-title\">Solução</span></div></th><th \nclass=\"secondary-text border-top\"><div class=\"table-header\"><span class=\"column-title\">Motivo</span></div></th><th \nclass=\"secondary-text border-top\"><div class=\"table-header\"><span class=\"column-title\">Situação</span></div></th><th \nclass=\"secondary-text border-top\"><div class=\"table-header\"><span class=\"column-title\">Necessidade</span></div></th><th\n class=\"secondary-text border-top\"><div class=\"table-header\"><span class=\"column-title\">Data Entrega</span></div></th>\n<th class=\"secondary-text border-top\"><div class=\"table-header\"><span class=\"column-title\">Data Entrada</span></div>\n</th><th class=\"secondary-text border-top\"><div class=\"table-header\"><span class=\"column-title\">Usuário Responsável\n</span></div></th><th class=\"secondary-text border-top\"><div class=\"table-header\"><span class=\"column-title\">\nUsuário Responsável pela abertura</span></div></th></tr></thead><tbody><tr ng-repeat=\"estoria in vm.estorias\"><td>\n<md-checkbox ng-click=\"vm.metodosBacklog.selecionarEstorias(estoria, $event)\" class=\"check\" \naria-label=\"Marcar CheckBox\" translate translate-aria-label=\"SPRINT.MARCARCHECKBOX\"></md-checkbox></td><td>\n{{estoria.numero}}/{{estoria.ano}}</td><td>{{estoria.descricao}}</td><td>{{estoria.clienteNome}}</td><td>\n{{estoria.solucaoDescricao}}</td><td>{{estoria.motivoDescricao}}</td><td>{{estoria.situacaoDescricao}}</td><td><span \nng-show=\"false\">{{ estoria.necessidadeCliente }}</span> {{estoria.necessidadeClienteDescricao}}</td><td>\n{{estoria.dataEntrega | date:\'dd/MM/yyyy\'}}</td><td>{{estoria.dataEntrada | date:\'dd/MM/yyyy\'}}</td><td>\n{{estoria.usuarioAberturaNome}}</td><td>{{estoria.usuarioResponsavelNome}}</td></tr></tbody></table></div></div>");
$templateCache.put("app/main/planejamento-scrum/processamento/sprint/views/tabs/meta/dialogs/sprint-dialog-meta.html","<md-dialog id=\"sprint-dialog-meta\" class=\"dialogTable\" aria-label=\"Dialog\"><form name=\"vm.form.dialogMetaForm\" \nclass=\"md-inline-form\" novalidate><md-toolbar class=\"md-accent md-tall\" layout=\"column\"><div \nclass=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\">\n{{vm.titulo}}</span><md-button class=\"md-icon-button\" aria-label=\"Fechar dialog\" translate \ntranslate-attr-aria-label=\"SPRINT.FECHAR_DIALOG\" ng-click=\"vm.metodosDialog.fecharDialog()\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><div layout=\"row\" layout-sm=\"row\" \nlayout-align=\"center\" ng-show=\"vm.requisicaSolicitada || vm.prelaoder.habilitar\"><md-progress-circular \nmd-mode=\"indeterminate\" class=\"md-accent\"></md-progress-circular></div><md-dialog-content \nng-hide=\"vm.requisicaSolicitada|| vm.prelaoder.habilitar\"><div layout-gt-xs=\"row\"><md-input-container class=\"md-block\" \nflex-gt-sm><label translate=\"SPRINT.DESCRICAO\">Descrição</label><input type=\"text\" name=\"sprintMetaDescricao\" \nmascara-tamanho-campo=\"100\" md-maxlength=\"100\" ng-disabled=\"vm.apenasVisualizacao\" \nng-model=\"vm.metaConcluida.descricao\"><div ng-messages=\"vm.form.dialogMetaForm.sprintMetaDescricao.$error\"><div \nng-message=\"required\" translate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container></div><div \nclass=\"mb-20\" layout-gt-xs=\"row\"><md-input-container class=\"md-block\" flex-gt-sm><label translate=\"SPRINT.SOLUCAO\">\nSolução</label><md-select name=\"sprintMetaSolucao\" md-on-open=\"vm.metodosDialog.configuraMdSelectSolucao()\" \nng-model=\"vm.metaConcluida.codigoSolucao\" ng-disabled=\"vm.apenasVisualizacao\" ng-required=\"true\"><md-select-header>\n<input id=\"tab-meta-solucao-md-select\" class=\"md-text\" type=\"search\" placeholder=\"\" translate \ntranslate-attr-placeholder=\"SPRINT.PESQUISAR_SOLUCAO\" ng-model=\"vm.filtrarSolucoes\"></md-select-header><md-option \nng-value=\"solucao.codigo\" ng-repeat=\"solucao in vm.solucoes | filter:vm.filtrarSolucoes track by solucao.codigo\">\n{{solucao.descricao}}</md-option></md-select><div ng-messages=\"vm.form.dialogMetaForm.sprintMetaSolucao.$error\"><div \nng-message=\"required\" translate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container>\n<md-input-container class=\"md-block\" flex-gt-sm flex-offset=\"5\"><label translate=\"SPRINT.META\">Meta</label><md-select \nname=\"sprintMetaTipoMeta\" ng-disabled=\"vm.apenasVisualizacao\" ng-model=\"vm.metaConcluida.codigoTipoMeta\" \nng-required=\"true\"><md-option ng-value=\"meta.codigo\" ng-repeat=\"meta in vm.tiposMeta track by meta.codigo\" \nng-if=\"meta.codigo != 4\">{{meta.descricao}}</md-option></md-select><div \nng-messages=\"vm.form.dialogMetaForm.sprintMetaTipoMeta.$error\"><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container></div><div layout-gt-xs=\"row\">\n<md-input-container class=\"md-block\" flex><label translate=\"SPRINT.ESTORIAS\">Histórias</label><md-select \nname=\"sprintMetaEstorias\" multiple=\"multiple\" md-on-open=\"vm.metodosDialog.configuraMdSelectEstoriasMetas()\" \nng-disabled=\"vm.apenasVisualizacao\" ng-required=\"true\" ng-model=\"vm.metaConcluida.metasEstorias\" \nng-model-options=\"{trackBy: \'$value.numero * $value.ano\'}\"><md-select-header><input \nid=\"dialog-metas-estorias-md-select\" class=\"md-text\" type=\"search\" translate \ntranslate-attr-placeholder=\"SPRINT.PESQUISAR_ESTORIAS\" ng-model=\"vm.filtrarEstoriasMetas\"></md-select-header><md-option\n \nng-value=\"{\r\n                                numero: estoriaBacklog.numero,\r\n                                ano: estoriaBacklog.ano,\r\n                                descricao: estoriaBacklog.descricao,\r\n                                concluido: estoriaBacklog.concluido,\r\n                                pontos: estoriaBacklog.pontos,\r\n                                historicoDescricao: estoriaBacklog.historicoDescricao,\r\n                                historicoCodigo: estoriaBacklog.historicoCodigo\r\n                                }\" \nng-repeat=\"estoriaBacklog in vm.estoriasBacklog | filter: vm.filtrarEstoriasMetas\">\n{{estoriaBacklog.numero}}/{{estoriaBacklog.ano}}</md-option></md-select><div \nng-messages=\"vm.form.dialogMetaForm.sprintMetaEstorias.$error\"><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container></div><div \nclass=\"md-background-bg md-whiteframe-1dp\"><table class=\"dataTable row-border hover\" dt-options=\"vm.dtOptionsMetas\" \nwidth=\"100%\"><thead><tr><th class=\"secondary-text\" style=\"padding: 16px 45px 16px 8px\"><div class=\"table-header\"><span \nclass=\"column-title\">História</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Descrição</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Situação</span></div></th><th class=\"secondary-text\"><div class=\"table-header text-center\"><span \nclass=\"column-title\">Concluído</span></div></th></tr></thead><tbody><tr \nng-repeat=\"meta in vm.metaConcluida.metasEstorias\"><td class=\"coluna-historia\"><div><span>{{meta.numero}}/{{meta.ano}}\n</span> <button ng-click=\"vm.metodosDialog.abrirEstoria(meta)\"><i class=\"icon-open-in-new s20 icone-cor-padrao\"></i>\n<md-tooltip md-autohide><span>Abrir história em nova aba</span></md-tooltip></button></div></td><td \nstyle=\"padding: 16px 24px 16px 12px\">{{meta.descricao}}</td><td style=\"margin-left: 20px\"><div \nclass=\"text-center situacao-estoria\" ng-repeat=\"situacao in vm.coresSituacoes\" \nng-if=\"situacao.codigo == meta.historicoCodigo\" ng-style=\"{\'background-color\': situacao.cor}\" \nng-class=\"{\'estilo-texto-quando-fundo-claro\': situacao.codigo == 1 || situacao.codigo == 3}\"><span>\n{{meta.historicoDescricao}}</span></div></td><td style=\"margin-left: 20px\"><div class=\"text-center\"><md-checkbox \nng-model=\"meta.concluido\" ng-disabled=\"vm.apenasVisualizacao\"></md-checkbox></div></td></tr></tbody></table></div>\n</md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"space-between center\" \nng-hide=\"vm.apenasVisualizacao\"><div layout=\"row\" layout-align=\"start center\"><md-button type=\"submit\" typ \nclass=\"send-button md-accent md-raised\" aria-label=\"SALVAR\" translate=\"SPRINT.SALVAR\" \ntranslate-attr-aria-label=\"SPRINT.SALVAR\" ng-click=\"vm.metodosDialog.salvar($event, vm.metaConcluida)\" \nng-disabled=\"vm.form.dialogMetaForm.$invalid ||\r\n                            vm.form.dialogMetaForm.$pristine || vm.requisicaSolicitada\">\nSalvar</md-button></div><div layout=\"row\"><md-button class=\"md-icon-button\" aria-label=\"Excluir\" translate \ntranslate-attr-aria-label=\"SPRINT.EXCLUIR\" ng-click=\"vm.metodosDialog.excluir($event, vm.meta)\" \nng-disabled=\"vm.requisicaSolicitada\" ng-hide=\"vm.inserirAtivo\"><md-icon md-font-icon=\"icon-delete\"></md-icon>\n</md-button></div></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/planejamento-scrum/processamento/sprint/views/tabs/burndown/controle-horas-recursos/tab-controle-horas-recursos.html","<md-content id=\"controle-horas-recursos\" class=\"md-padding\"><table class=\"dataTable row-border hover\" datatable=\"ng\" \ndt-options=\"vm.dtOptionsSprintRecursos\" width=\"100%\"><thead><tr><th class=\"secondary-text\" \nng-repeat=\"titulo in vm.dadosTabela.titulos\"><div class=\"table-header\"><span class=\"column-title\">{{titulo.title}}\n</span></div></th></tr></thead><tbody><tr ng-repeat=\"recurso in vm.dadosTabela.recursos\"><td>{{recurso.nome}}</td><td \nng-repeat=\"data in recurso.dias\">{{data.horas}}</td></tr></tbody></table></md-content>");
$templateCache.put("app/main/planejamento-scrum/processamento/sprint/views/tabs/cerimonia-detalhe/dialogs/sprint-dialog-cerimonia-detalhe.html","<md-dialog id=\"sprint-dialog-cerimonia-detalhe\" class=\"dialogo-padrao\" aria-label=\"Dialog\"><form \nname=\"vm.form.dialogCerimoniaDetalhe\" class=\"md-inline-form\" novalidate><md-toolbar class=\"md-accent md-tall\" \nlayout=\"column\"><div class=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" layout-align=\"space-between center\">\n<span class=\"title\">{{vm.titulo}}</span><md-button class=\"md-icon-button\" ng-click=\"vm.metodosDialog.fecharDialog()\" \naria-label=\"Fechar dialog\" translate translate-attr-aria-label=\"SPRINT.FECHAR_DIALOG\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><div layout=\"row\" layout-sm=\"row\" \nlayout-align=\"center\" ng-show=\"vm.requisicaSolicitada || vm.preloader.habilitar\"><md-progress-circular \nmd-mode=\"indeterminate\" class=\"md-accent\"></md-progress-circular></div><md-dialog-content \nng-hide=\"vm.requisicaSolicitada || vm.preloader.habilitar\"><div layout-gt-xs=\"row\"><md-input-container \nclass=\"md-block\" flex-gt-sm=\"30\"><label translate=\"SPRINT.CERIMONIA\">Cerimônia</label><md-select \nng-disabled=\"vm.apenasVisualizacao\" ng-model=\"vm.cerimoniaDetalhe.cerimonia\" \nname=\"sprintCerimoniaDetalheCerimoniaCodigo\" ng-required=\"vm.inserirAtivo\"><md-option ng-value=\"key\" \nng-repeat=\"(key, value) in vm.cerimonias\">{{value}}</md-option></md-select><div \nng-messages=\"vm.form.dialogCerimoniaDetalhe.sprintCerimoniaDetalheCerimoniaCodigo.$error\"><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container><md-input-container><label \ntranslate=\"SPRINT.DATA\"></label><md-datepicker ng-disabled=\"vm.apenasVisualizacao\" flex-offset-gt-sm=\"5\" \nng-model=\"vm.cerimoniaDetalhe.data\" name=\"sprintCerimoniaDetalheData\" mascara-conversor-string-para-data \nng-mask=\"3?9/1?9/9999\" ng-required=\"true\"></md-datepicker><div \nng-messages=\"vm.form.dialogCerimoniaDetalhe.sprintCerimoniaDetalheData.$error\"><div ng-message=\"valid\" \ntranslate=\"MENSAGEM_VALIDACAO.DATA_INVALIDA\"></div><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container><md-input-container class=\"md-block\" \nflex-offset-gt-sm=\"10\" flex-gt-sm=\"15\"><label translate=\"SPRINT.HORA_INICIAL\"></label><input type=\"text\" \nng-disabled=\"vm.apenasVisualizacao\" ng-model=\"vm.cerimoniaDetalhe.horaInicial\" \nname=\"sprintCerimoniaDetalheHoraInicial\" placeholder=\"\" translate \ntranslate-attr-placeholder=\"SPRINT.DURACAO_PLACEHOLDER\" mascara-numero-generica=\"##:##\" ng-minlength=\"5\" \nng-required=\"true\"><div ng-messages=\"vm.form.dialogCerimoniaDetalhe.sprintCerimoniaDetalheHoraInicial.$error\"><div \nng-message=\"required\" translate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div><div ng-message=\"minlength\" \ntranslate=\"MENSAGEM_VALIDACAO.PATTERN_PARA_HORAS\"></div></div></md-input-container><md-input-container \nclass=\"md-block\" flex-gt-sm=\"15\"><label translate=\"SPRINT.HORA_FINAL\"></label><input type=\"text\" \nng-disabled=\"vm.apenasVisualizacao\" ng-model=\"vm.cerimoniaDetalhe.horaFinal\" name=\"sprintCerimoniaDetalheHoraFinal\" \nplaceholder=\"\" translate translate-attr-placeholder=\"SPRINT.DURACAO_PLACEHOLDER\" mascara-numero-generica=\"##:##\" \nng-minlength=\"5\" ng-required=\"true\"><div \nng-messages=\"vm.form.dialogCerimoniaDetalhe.sprintCerimoniaDetalheHoraFinal.$error\"><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div><div ng-message=\"minlength\" \ntranslate=\"MENSAGEM_VALIDACAO.PATTERN_PARA_HORAS\"></div></div></md-input-container></div><label \nclass=\"color-mdinput-label-padrao tamanho-mdinput-label-padrao\" translate=\"SPRINT.COMENTARIO_POSITIVO\"></label>\n<text-angular ng-disabled=\"vm.apenasVisualizacao\" ng-model=\"vm.cerimoniaDetalhe.comentarioPositivo\" required>\n</text-angular><div class=\"divider\"></div><label class=\"color-mdinput-label-padrao tamanho-mdinput-label-padrao\" \ntranslate=\"SPRINT.COMENTARIO_NEGATIVO\"></label><text-angular ng-disabled=\"vm.apenasVisualizacao\" \nng-model=\"vm.cerimoniaDetalhe.comentarioNegativo\" required></text-angular></md-dialog-content><md-dialog-actions \nlayout=\"row\" layout-align=\"space-between center\" ng-hide=\"vm.apenasVisualizacao\"><div layout=\"row\" \nlayout-align=\"start center\"><md-button type=\"submit\" \nng-click=\"vm.metodosDialog.persistirCerimoniaDetalhe($event, vm.cerimoniaDetalhe)\" \nclass=\"send-button md-accent md-raised\" \nng-disabled=\"vm.form.dialogCerimoniaDetalhe.$invalid || vm.form.dialogCerimoniaDetalhe.$pristine || vm.requisicaSolicitada\" \naria-label=\"SALVAR\" translate=\"SPRINT.SALVAR\" translate-attr-aria-label=\"SPRINT.SALVAR\">Salvar</md-button></div><div \nlayout=\"row\"><md-button class=\"md-icon-button\" ng-click=\"vm.metodosDialog.excluir($event, vm.cerimoniaDetalhe)\" \nng-hide=\"vm.inserirAtivo\" ng-disabled=\"vm.requisicaSolicitada\" aria-label=\"Excluir\" translate \ntranslate-attr-aria-label=\"SPRINT.EXCLUIR\"><md-icon md-font-icon=\"icon-delete\"></md-icon></md-button></div>\n</md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/planejamento-scrum/processamento/sprint/views/tabs/versao-entregue/dialogs/sprint-dialog-versao-entregue.html","<md-dialog id=\"sprint-dialog-versao-entregue\" class=\"dialogo-padrao\" aria-label=\"Dialog\"><form \nname=\"vm.form.dialogVersaoEntregue\" class=\"md-inline-form\" novalidate><md-toolbar class=\"md-accent md-tall\" \nlayout=\"column\"><div class=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" layout-align=\"space-between center\">\n<span class=\"title\">{{vm.titulo}}</span><md-button class=\"md-icon-button\" ng-click=\"vm.metodosDialog.fecharDialog()\" \naria-label=\"Fechar dialog\" translate translate-attr-aria-label=\"SPRINT.FECHAR_DIALOG\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><div layout=\"row\" layout-sm=\"row\" \nlayout-align=\"center\" ng-show=\"vm.requisicaSolicitada || vm.preloader.habilitar\"><md-progress-circular \nmd-mode=\"indeterminate\" class=\"md-accent\"></md-progress-circular></div><md-dialog-content \nng-hide=\"vm.requisicaSolicitada || vm.preloader.habilitar\"><div layout-gt-xs=\"row\"><md-input-container \nclass=\"md-block\" flex-gt-sm=\"20\" ng-if=\"vm.inserirAtivo\"><label translate=\"SPRINT.SOLUCOES\">Soluções</label><md-select \nng-disabled=\"vm.apenasVisualizacao\" ng-model=\"vm.versaoEntregue.solucoesCodigos\" multiple=\"multiple\" \nmd-on-open=\"vm.metodosDialog.configuraMdSelectVersaoEntregueSolucoes()\" name=\"sprintVersaoEntregueSolucoesMulti\" \nng-required=\"vm.inserirAtivo\"><md-select-header><input id=\"dialog-versao-entregue-solucoes-md-select\" class=\"md-text\" \nng-model=\"vm.filtrarSolucoesVersaoEntregue\" type=\"search\" placeholder=\"\" translate \ntranslate-attr-placeholder=\"SPRINT.PESQUISAR_SOLUCOES\"></md-select-header><md-option ng-value=\"solucao.codigo\" \nng-repeat=\"solucao in vm.solucoes | filter:vm.filtrarSolucoesVersaoEntregue track by solucao.codigo\">\n{{solucao.descricao}}</md-option></md-select><div \nng-messages=\"vm.form.dialogVersaoEntregue.sprintVersaoEntregueSolucoesMulti.$error\"><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container><md-input-container class=\"md-block\" \nflex-gt-sm=\"20\" ng-if=\"!vm.inserirAtivo\"><label translate=\"SPRINT.SOLUCOES\">Soluções</label><md-select \nng-disabled=\"vm.apenasVisualizacao\" ng-model=\"vm.versaoEntregue.solucaoCodigo\" \nmd-on-open=\"vm.metodosDialog.configuraMdSelectVersaoEntregueSolucoes()\" name=\"sprintVersaoEntregueSolucoes\" \nng-required=\"!vm.inserirAtivo\"><md-select-header><input id=\"dialog-versao-entregue-solucoes-md-select\" class=\"md-text\" \nng-model=\"vm.filtrarSolucoesVersaoEntregue\" type=\"search\" placeholder=\"\" translate \ntranslate-attr-placeholder=\"SPRINT.PESQUISAR_SOLUCOES\"></md-select-header><md-option ng-value=\"solucao.codigo\" \nng-repeat=\"solucao in vm.solucoes | filter:vm.filtrarSolucoesVersaoEntregue track by solucao.codigo\">\n{{solucao.descricao}}</md-option></md-select><div ng-messages=\"vm.form.dialogVersaoEntregue.solucaoCodigo.$error\"><div \nng-message=\"required\" translate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container>\n<md-input-container class=\"md-block\" flex-offset-gt-sm=\"5\" flex-gt-sm=\"10\"><label translate=\"SPRINT.NUMERO\">Número\n</label><input type=\"text\" ng-disabled=\"vm.apenasVisualizacao\" ng-model=\"vm.versaoEntregue.numero\" \nname=\"sprintVersaoEntregueNumero\" mascara-tamanho-campo=\"6\" ng-required=\"true\" mascara-numero-versao><div \nng-messages=\"vm.form.dialogVersaoEntregue.sprintVersaoEntregueNumero.$error\"><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container><md-input-container class=\"md-block\" \nflex-offset-gt-sm=\"5\" flex-gt-sm=\"15\"><label translate=\"SPRINT.RELEASE\">Release</label><input type=\"text\" \nmascara-release ng-disabled=\"vm.apenasVisualizacao\" ng-model=\"vm.versaoEntregue.release\" \nname=\"sprintVersaoEntregueRelease\" ng-required=\"true\" mascara-tamanho-campo=\"10\"><div \nng-messages=\"vm.form.dialogVersaoEntregue.sprintVersaoEntregueRelease.$error\"><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div><div ng-message=\"formatoRelease\">\nFormato inválido. Exemplo: 1/A ou 10/A</div></div></md-input-container></div><div layout-gt-xs=\"row\">\n<md-input-container class=\"md-block\" flex-gt-sm=\"25\"><label translate=\"SPRINT.COMPATIBILIDADE\">Compatibilidade</label>\n<input type=\"text\" ng-disabled=\"vm.apenasVisualizacao\" ng-model=\"vm.versaoEntregue.compatibilidade\" \nname=\"sprintVersaoEntregueCompatibilidade\" mascara-numeros=\"6\" ng-required=\"true\"><div \nng-messages=\"vm.form.dialogVersaoEntregue.sprintVersaoEntregueCompatibilidade.$error\"><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container><md-input-container \nflex-offset-gt-sm=\"5\"><label translate=\"SPRINT.DATA_VERSAO_GERADA\"></label><md-datepicker \nng-model=\"vm.versaoEntregue.dataVersaoGerada\" ng-disabled=\"vm.apenasVisualizacao\" \nname=\"sprintVersaoEntregueDataVersaoGerada\" ng-required=\"true\" md-max-date=\"vm.sprint.dataFinal\" \nmascara-conversor-string-para-data ng-mask=\"3?9/1?9/9999\" \nng-required=\"vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo\"></md-datepicker><div \nng-messages=\"vm.form.dialogVersaoEntregue.sprintVersaoEntregueDataVersaoGerada.$error\"><div ng-message=\"valid\" \ntranslate=\"MENSAGEM_VALIDACAO.DATA_INVALIDA\"></div><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.DATA_OBRIGATORIA\"></div></div></md-input-container><md-input-container class=\"md-block\" \nflex-offset-gt-sm=\"10\" flex-gt-sm=\"25\"><label translate=\"SPRINT.COLABORADOR\"></label><md-select \nng-model=\"vm.versaoEntregue.usuarioCodigo\" name=\"dialogVersaoEntregueUsuario\" ng-required=\"vm.inserirAtivo\" \nng-disabled=\"vm.apenasVisualizacao\"><md-option \nng-if=\"!vm.inserirAtivo && vm.versaoEntregue.usuario.codigo != vm.usuarioLogado.codigo\" \nng-value=\"vm.versaoEntregue.usuario.codigo\" selected=\"selected\">{{vm.versaoEntregue.usuario.login}}</md-option>\n<md-option ng-value=\"vm.usuarioLogado.codigo\" selected=\"selected\">{{vm.usuarioLogado.nome}}</md-option></md-select><div\n ng-messages=\"vm.form.dialogVersaoEntregue.dialogVersaoEntregueUsuario.$error\"><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container></div><div layout-gt-xs=\"row\">\n<md-input-container class=\"md-block\" flex-gt-sm><label translate=\"SPRINT.OBSERVACAO\">Observação</label><input \ntype=\"text\" ng-disabled=\"vm.apenasVisualizacao\" ng-model=\"vm.versaoEntregue.observacao\" \nname=\"sprintVersaoEntregueObservacao\" mascara-tamanho-campo=\"150\" md-maxlength=\"150\" ng-required=\"true\"><div \nng-messages=\"vm.form.dialogVersaoEntregue.sprintVersaoEntregueObservacao.$error\"><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container></div></md-dialog-content>\n<md-dialog-actions layout=\"row\" layout-align=\"space-between center\" ng-hide=\"vm.apenasVisualizacao\"><div layout=\"row\" \nlayout-align=\"start center\"><md-button type=\"submit\" \nng-click=\"vm.metodosDialog.persistirVersaoEntregue($event, vm.versaoEntregue)\" class=\"send-button md-accent md-raised\" \nng-disabled=\"vm.form.dialogVersaoEntregue.$invalid\r\n                   || vm.form.dialogVersaoEntregue.$pristine || vm.requisicaSolicitada\" \naria-label=\"SALVAR\" translate=\"SPRINT.SALVAR\" translate-attr-aria-label=\"SPRINT.SALVAR\">Salvar</md-button></div><div \nlayout=\"row\"><md-button class=\"md-icon-button\" ng-click=\"vm.metodosDialog.excluir($event, vm.versaoEntregue)\" \nng-disabled=\"vm.requisicaSolicitada\" ng-hide=\"vm.inserirAtivo\" aria-label=\"Excluir\" translate \ntranslate-attr-aria-label=\"SPRINT.EXCLUIR\"><md-icon md-font-icon=\"icon-delete\"></md-icon></md-button></div>\n</md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/planejamento-scrum/processamento/sprint/views/tabs/registros/dialogs/sprint-dialog-registros.html","<md-dialog id=\"sprint-dialog-registros\" class=\"dialogo-padrao\" aria-label=\"Dialog\"><form \nname=\"vm.form.dialogRegistroForm\" class=\"md-inline-form\" novalidate><md-toolbar class=\"md-accent md-tall\" \nlayout=\"column\"><div class=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" layout-align=\"space-between center\">\n<span class=\"title\">{{vm.titulo}}</span><md-button class=\"md-icon-button\" ng-click=\"vm.metodosDialog.fecharDialog()\" \naria-label=\"Fechar dialog\" translate translate-attr-aria-label=\"SPRINT.FECHAR_DIALOG\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><div layout=\"row\" layout-sm=\"row\" \nlayout-align=\"center\" ng-show=\"vm.requisicaoSolicitada || vm.preloader.habilitar\"><md-progress-circular \nmd-mode=\"indeterminate\" class=\"md-accent\"></md-progress-circular></div><md-dialog-content \nng-hide=\"vm.requisicaoSolicitada || vm.preloader.habilitar\"><div layout-gt-xs=\"row\"><md-input-container \nclass=\"md-block\" flex-gt-sm=\"20\"><label translate=\"SPRINT.ESTORIA\">Estória</label><md-select \nng-disabled=\"vm.apenasVisualizacao\" ng-model=\"vm.registro.estoria\" name=\"sprintRegistroEstoriaBacklog\" \nng-model-options=\"{trackBy: \'$value.numero + $value.ano\'}\" md-on-open=\"vm.metodosDialog.configurarMdSelectEstoria()\">\n<md-select-header><input id=\"sprint-dialog-registros-md-select-estorias\" class=\"md-text\" ng-model=\"vm.filtrarEstorias\" \ntype=\"search\" placeholder=\"\" translate translate-attr-placeholder=\"SPRINT.PESQUISAR_ESTORIA\"></md-select-header>\n<md-optgroup label=\"Estorias\"><md-option ng-if=\"vm.registro.estoria\" ng-value=\"\">Desmarcar</md-option><md-option \nng-value=\"{numero: estoriaBacklog.numero,\r\n                                                  ano: estoriaBacklog.ano}\" \nng-repeat=\"estoriaBacklog in vm.estoriasBacklog | filter:vm.filtrarEstorias\">\n{{estoriaBacklog.numero}}/{{estoriaBacklog.ano}}</md-option></md-optgroup></md-select></md-input-container>\n<md-input-container flex-gt-sm=\"5\" flex-gt-xs flex-offset-gt-sm=\"10\"><label hide-gt-sm \ntranslate=\"ESTORIA.PESQUISAR_COLABORADOR_POR_CODIGO\"></label><input text=\"text\" ng-disabled=\"vm.apenasVisualizacao\" \nng-model=\"vm.colaboradorRegistroAPesquisar\" aria-label=\"Diretiva Pesquisar por Codigo\" pesquisar-por-codigo \nlista-a-pesquisar=\"vm.colaboradores\" entidade-pesquisada=\"vm.registro.usuarioCodigo\" mascara-numeros=\"5\">\n</md-input-container><md-input-container class=\"md-block\" flex-gt-sm=\"20\"><label translate=\"SPRINT.COLABORADOR\">\nColaborador</label><md-select ng-disabled=\"vm.apenasVisualizacao\" ng-model=\"vm.registro.usuarioCodigo\" \nname=\"sprintRegistroColaborador\" md-on-open=\"vm.metodosDialog.configuraMdSelectColaboradoresRegistro()\">\n<md-select-header><input id=\"dialog-registros-usuario-md-select\" class=\"md-text\" \nng-model=\"vm.filtrarColaboradorRegistro\" type=\"search\" placeholder=\"\" translate \ntranslate-attr-placeholder=\"SPRINT.PESQUISAR_COLABORADOR\"></md-select-header><md-option ng-value=\"colaborador.codigo\" \nng-repeat=\"colaborador in vm.colaboradores | filter:vm.filtrarColaboradorRegistro track by colaborador.codigo\">\n{{colaborador.nome}}</md-option></md-select></md-input-container></div><div class=\"divider\"></div><div \nlayout-gt-xs=\"row\"><md-input-container><label translate=\"SPRINT.DATA\"></label><md-datepicker \nng-disabled=\"vm.apenasVisualizacao\" flex-offset-gt-sm=\"5\" ng-model=\"vm.registro.data\" name=\"sprintRegistroData\" \nmascara-conversor-string-para-data ng-mask=\"3?9/1?9/9999\" ng-required=\"true\" \nmd-date-filter=\"vm.diasDaSemanaMdDatePicker\"></md-datepicker><div \nng-messages=\"vm.form.dialogRegistroForm.sprintRegistroData.$error\"><div ng-message=\"valid\" \ntranslate=\"MENSAGEM_VALIDACAO.DATA_INVALIDA\"></div><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.DATA_OBRIGATORIA\"></div></div></md-input-container><md-input-container class=\"md-block\" \nflex-gt-sm=\"15\"><label translate=\"SPRINT.DURACAO\"></label><input type=\"text\" ng-disabled=\"vm.apenasVisualizacao\" \nng-model=\"vm.registro.horas\" name=\"sprintRegistroDuracao\" flex-offset-gt-sm=\"5\" placeholder=\"\" translate \ntranslate-attr-placeholder=\"SPRINT.DURACAO_PLACEHOLDER\" mascara-numero-generica=\"##:##\" ng-minlength=\"5\" \nng-required=\"true\"><div ng-messages=\"vm.form.dialogRegistroForm.sprintRegistroDuracao.$error\"><div \nng-message=\"required\" translate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div><div ng-message=\"minlength\" \ntranslate=\"MENSAGEM_VALIDACAO.PATTERN_PARA_HORAS\"></div></div></md-input-container></div><div layout-gt-xs=\"row\">\n<md-input-container class=\"md-block\" flex-gt-sm=\"20\"><label translate=\"SPRINT.SITUACAO_REGISTRO\">Situação Registro\n</label><md-select ng-disabled=\"vm.apenasVisualizacao\" ng-model=\"vm.registro.registroSituacaoCodigo\" \nname=\"sprintRegistroSituacao\" ng-required=\"vm.inserirAtivo\"><md-option ng-value=\"registroSituacao.codigo\" \nng-repeat=\"registroSituacao in vm.registrosSituacoes track by registroSituacao.codigo\">{{registroSituacao.descricao}}\n</md-option></md-select><div ng-messages=\"vm.form.dialogRegistroForm.sprintRegistroSituacao.$error\"><div \nng-message=\"required\" translate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container></div><div \nlayout-gt-xs=\"row\"><md-input-container class=\"md-block\" flex><label translate=\"SPRINT.DESCRICAO\">Descrição</label>\n<textarea ng-disabled=\"vm.apenasVisualizacao\" ng-model=\"vm.registro.descricao\" name=\"sprintRegistroDescricao\" required \nmd-no-resize=\"true\" max-rows=\"5\">\r\n          </textarea><div \nng-messages=\"vm.form.dialogRegistroForm.sprintRegistroDescricao.$error\"><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container></div></md-dialog-content>\n<md-dialog-actions layout=\"row\" layout-align=\"space-between center\" ng-hide=\"vm.apenasVisualizacao\"><div layout=\"row\" \nlayout-align=\"start center\"><md-button type=\"submit\" ng-click=\"vm.metodosDialog.salvar($event, vm.registro)\" \nclass=\"send-button md-accent md-raised\" \nng-disabled=\"vm.form.dialogRegistroForm.$invalid || vm.form.dialogRegistroForm.$pristine || vm.requisicaoSolicitada\" \naria-label=\"SALVAR\" translate=\"SPRINT.SALVAR\" translate-attr-aria-label=\"SPRINT.SALVAR\">Salvar</md-button></div><div \nlayout=\"row\"><md-button class=\"md-icon-button\" ng-click=\"vm.metodosDialog.excluir($event, vm.registro)\" \nng-disabled=\"vm.requisicaoSolicitada\" ng-hide=\"vm.inserirAtivo\" aria-label=\"Excluir\" translate \ntranslate-attr-aria-label=\"SPRINT.EXCLUIR\"><md-icon md-font-icon=\"icon-delete\"></md-icon></md-button></div>\n</md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/planejamento-scrum/processamento/estoria/views/tabs/clientes/edicao-clientes-vinculados-dialog/edicao-clientes-vinculados-dialog.html","<md-dialog id=\"clientes-vinculados-dialog\" class=\"dialogo-padrao\" aria-label=\"Dialog\"><form name=\"clientesVinculados\" \nclass=\"md-inline-form\" novalidate><md-toolbar class=\"md-accent md-tall\" layout=\"column\"><div \nclass=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\">\n{{vm.titulo}}</span><md-button class=\"md-icon-button\" aria-label=\"Fechar dialog\" translate \nng-click=\"vm.metodos.closeDialog()\" translate-attr-aria-label=\"ESTORIA.FECHAR_DIALOG\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><div layout=\"row\" layout-sm=\"row\" \nlayout-align=\"center\" ng-show=\"vm.requisicaSolicitada\"><md-progress-circular md-mode=\"indeterminate\" class=\"md-accent\">\n</md-progress-circular></div><md-dialog-content style=\"padding: 20px\"><div layout=\"row\" layout-align=\"center center\" \nng-hide=\"vm.requisicaSolicitada\"><div \nstyle=\"width: 100%; display: flex;\r\n                align-items: center; justify-content: center\" \nng-if=\"vm.campoClienteASerEditado === \'dataPrevisaoAtualizacao\'\"><md-input-container \nclass=\"campo-previsao-atualizacao\" style=\"margin-right: -280px\" flex-gt-sm=\"50\"><label>Data</label><md-datepicker \nng-model=\"vm.cliente.dataPrevisaoAtualizacao\" id=\"clientes-vinculados-dialog-data-previsao-atualizacao\" \nname=\"dataPrevisaoAtualizacao\" mascara-conversor-string-para-data ng-mask=\"3?9/1?9/9999\" \nmd-max-date=\"vm.dataMaximaPermitida\"></md-datepicker><div \nng-messages=\"clientesVinculados.dataPrevisaoAtualizacao.$error\"><div ng-message=\"valid\" \ntranslate=\"MENSAGEM_VALIDACAO.DATA_INVALIDA\"></div><div ng-message=\"maxdate\" \ntranslate=\"MENSAGEM_VALIDACAO.DATA_MAIOR_QUE_TRINTA_DIAS\"></div></div></md-input-container></div><div \nstyle=\"width: 100%; display: flex; flex-direction: row;\r\n                align-items: center; justify-content: center\" \nng-if=\"vm.campoClienteASerEditado === \'dataAtualizacao\' || vm.campoClienteASerEditado === \'versao\'\"><md-input-container\n style=\"margin-right: -280px\" flex-gt-sm=\"50\"><label>Data</label><md-datepicker ng-model=\"vm.cliente.dataAtualizacao\" \nng-required=\"vm.cliente.versao\" id=\"clientes-vinculados-dialog-data-atualizacao\" name=\"dataAtualizacao\" \nmascara-conversor-string-para-data ng-mask=\"3?9/1?9/9999\" md-max-date=\"vm.dataAtualizacaoMaxima\"></md-datepicker><div \nng-messages=\"clientesVinculados.dataAtualizacao.$error\"><div ng-message=\"valid\" \ntranslate=\"MENSAGEM_VALIDACAO.DATA_INVALIDA\"></div><div ng-message=\"maxdate\" \ntranslate=\"MENSAGEM_VALIDACAO.DATA_MAIOR_QUE_ATUAL\"></div><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.DATA_OBRIGATORIA\"></div></div></md-input-container><md-autocomplete \nng-required=\"vm.cliente.dataAtualizacao\" md-input-name=\"versao\" md-no-cache=\"true\" \nmd-selected-item=\"vm.cliente.versao\" \nmd-selected-item-change=\"vm.metodos.alterarItemSelecionadoAutoCompleteVersao(item)\" \nmd-search-text=\"vm.textoDePesquisaAutoCompleteVersao\" \nmd-items=\"item in vm.metodos.pesquisarAutoCompleteClienteVinculado(vm.textoDePesquisaAutoCompleteVersao)\" \nmd-item-text=\"item.numero + \' - \' + item.release + (item.compatibilidade ? \' - \' + item.compatibilidade : \'\')\" \nng-blur=\"vm.metodos.configuraAutoCompleteVersaoOnBlur()\" md-autoselect md-floating-label=\"Versão\"><md-item-template>\n<span md-highlight-text=\"vm.textoDePesquisaAutoCompleteVersao\">\n{{item.numero}} - {{item.release}}{{item.compatibilidade ? \' - \' + item.compatibilidade : \'\'}}</span>\n</md-item-template><md-not-found><label>Versão inexistente.</label></md-not-found><div \nng-messages=\"clientesVinculados.versao.$error\"><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-autocomplete></div><md-input-container \nclass=\"md-block\" flex-gt-sm=\"50\" ng-if=\"vm.campoClienteASerEditado === \'responsavel\'\"><label>Responsável</label>\n<md-select ng-model=\"vm.cliente.usuarioCodigo\" name=\"usuarioCodigo\" ng-disabled=\"vm.desabilitaCamposDialoTarefa\">\n<md-option ng-value=\"vm.cliente.usuarioCodigo\" \nng-if=\"vm.cliente.usuarioCodigo && vm.cliente.usuarioCodigo != vm.usuarioEstoriaLogado.codigo\">\n{{ vm.cliente.usuario.login }}</md-option><md-option ng-value=\"vm.usuarioEstoriaLogado.codigo\">\n{{vm.usuarioEstoriaLogado.login}}</md-option><md-option ng-if=\"vm.cliente.usuarioCodigo\" ng-value=\"null\">Desmarcar\n</md-option></md-select></md-input-container><div ng-if=\"vm.campoClienteASerEditado === \'observacao\'\"><text-angular \nng-model=\"vm.cliente.observacao\" \nta-toolbar=\"[[\'h1\', \'h2\', \'h3\', \'h4\', \'h5\', \'h6\', \'p\', \'pre\', \'quote\', \'bold\', \'italics\', \'underline\', \'ul\', \'ol\', \'redo\', \'undo\', \'justifyLeft\', \'justifyCenter\', \'justifyRight\', \'justifyFull\', \'indent\', \'outdent\', \'clear\']]\">\n</text-angular></div></div></md-dialog-content><md-dialog-actions layout=\"row\"><div layout=\"row\" \nlayout-align=\"end center\" flex><md-button type=\"submit\" class=\"send-button md-accent md-raised\" \nng-click=\"vm.metodos.salvar(vm.cliente)\" ng-disabled=\"clientesVinculados.$invalid || vm.requisicaSolicitada\">Salvar\n</md-button></div></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/planejamento-scrum/processamento/estoria/views/tabs/historico/dialogs/estoria-dialog-historico-situacao.html","<md-dialog class=\"dialogo-padrao\" aria-label=\"Dialog\"><form name=\"historicoSituacaoForm\" class=\"md-inline-form\" \nnovalidate><md-toolbar class=\"md-accent md-tall\" layout=\"column\"><div class=\"md-toolbar-tools md-toolbar-tools-top\" \nlayout=\"row\" layout-align=\"space-between center\"><span class=\"title\">{{vm.titulo}}</span><md-button \nclass=\"md-icon-button\" ng-click=\"vm.metodosDialog.fecharDialog()\" aria-label=\"Fechar dialog\" translate \ntranslate-attr-aria-label=\"ESTORIA.FECHAR_DIALOG\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div>\n</md-toolbar><div layout=\"row\" layout-sm=\"row\" layout-align=\"center\" \nng-show=\"vm.requisicaSolicitada || vm.preloader.habilitar\"><md-progress-circular md-mode=\"indeterminate\" \nclass=\"md-accent\"></md-progress-circular></div><md-dialog-content \nng-hide=\"vm.requisicaSolicitada || vm.preloader.habilitar\"><div layout-gt-sm=\"row\" layout-xs=\"row\"><md-input-container \nclass=\"md-block\" flex-gt-sm=\"25\" flex-xs=\"25\"><label translate=\"ESTORIA.NUMERO\">Número</label><input type=\"number\" \nng-model=\"vm.historicoSituacao.estoriaNumero\" name=\"numero\" ng-disabled=\"true\"></md-input-container><md-input-container\n class=\"md-block\" flex-gt-sm=\"25\" flex-gt-xs><label translate=\"ESTORIA.ANO\">Ano</label><input type=\"number\" name=\"ano\" \nng-model=\"vm.historicoSituacao.estoriaAno\" ng-disabled=\"true\"></md-input-container></div><div layout=\"row\">\n<md-input-container class=\"md-block\" flex-gt-sm=\"50\"><label translate=\"ESTORIA.SITUACAO\">Situação</label><md-select \nng-model=\"vm.historicoSituacao.situacao\" ng-model-options=\"{trackBy: \'$value.codigo\'}\" \nname=\"estoriaHistoricoSituacaoSituacaoCodigo\" md-on-open=\"vm.metodosDialog.configuraMdSelectSituacao()\" \nng-required=\"vm.novoHistoricoSituacao\" \nng-change=\"vm.metodosDialog.buscaPontosInicias(vm.historicoSituacao.situacao.descricao,vm.historicoSituacao.estoriaNumero,vm.historicoSituacao.estoriaAno)\">\n<md-select-header><input id=\"estoria-dialog-historico-situacao-md-select\" class=\"md-text\" \nng-model=\"vm.filtrarSituacoes\" type=\"search\" placeholder=\"\" translate \ntranslate-attr-placeholder=\"ESTORIA.PESQUISAR_SITUACAO\" md-autofocus></md-select-header><md-option ng-value=\"situacao\" \nng-repeat=\"situacao in vm.situacoes | filter:vm.filtrarSituacoes track by situacao.codigo\">{{situacao.descricao}}\n</md-option></md-select><div ng-messages=\"historicoSituacaoForm.estoriaHistoricoSituacaoSituacaoCodigo.$error\"><div \nng-message=\"required\" translate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container>\n<md-input-container><label translate=\"ESTORIA.DATA\">Data Entrega</label><md-datepicker flex-offset-gt-sm=\"5\" \nng-model=\"vm.historicoSituacao.data\" name=\"dialogHistoricoSituacaoData\" mascara-conversor-string-para- \nng-mask=\"3?9/1?9/9999\" ng-required=\"true\"></md-datepicker><div \nng-messages=\"historicoSituacaoForm.dialogHistoricoSituacaoData.$error\"><div ng-message=\"valid\" \ntranslate=\"MENSAGEM_VALIDACAO.DATA_INVALIDA\"></div><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.DATA_OBRIGATORIA\"></div></div></md-input-container></div><div layout-gt-sm=\"row\">\n<md-input-container class=\"md-block\" flex-gt-sm=\"50\"><label translate=\"ESTORIA.USUARIO\">Usuário</label><md-select \nng-model=\"vm.historicoSituacao.usuarioCodigo\" name=\"estoriaHistoricoSituacaoUsuario\" \nng-required=\"vm.novoHistoricoSituacao\"><md-option ng-value=\"vm.usuarioEstoriaLogado.codigo\" selected=\"selected\">\n{{vm.usuarioEstoriaLogado.login}}</md-option></md-select><div \nng-messages=\"historicoSituacaoForm.estoriaHistoricoSituacaoUsuario.$error\"><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container></div><div layout-gt-xs=\"row\" \nng-if=\"vm.historicoSituacao.situacao.exigeMotivo\"><md-input-container class=\"md-block\" flex><label \ntranslate=\"ESTORIA.MOTIVO\">Motivo</label><textarea ng-model=\"vm.historicoSituacao.observacaoMotivoPausa\" \nname=\"estoriaHistoricoSituacaoMotivoPausa\" ng-required=\"vm.historicoSituacao.situacao.exigeMotivo\" md-no-resize=\"true\" \nrows=\"3\" max-rows=\"5\">\r\n              </textarea><div \nng-messages=\"historicoSituacaoForm.estoriaHistoricoSituacaoMotivoPausa.$error\"><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container></div><div layout-gt-xs=\"row\" \nng-if=\"vm.historicoSituacao.situacao.descricao == \'Homologada\'\"><md-input-container class=\"md-block\" flex-gt-sm=\"40\">\n<label translate=\"SPRINT.PONTUACAO_TOTAL\">Pontuação Total</label><input type=\"text\" mascara-numero-generica=\"#####\" \nname=\"sprintBacklogEstimativaPontosPontuacaoInicial\" ng-disabled=\"true\" ng-model=\"vm.pontos\"></md-input-container>\n<md-input-container class=\"md-block\" flex-gt-sm=\"40\"><label translate=\"SPRINT.PONTUACAO_ENTREGUE\">Pontuação Entregue\n</label><input type=\"text\" name=\"pontoEntregue\" mascara-numeros=\"6\" numero-casas-decimais=\"2\" aceita-negativo \nng-required=\"true\" name=\"sprintBacklogEstimativaPontosPontuacaoEntregue\" \nng-model=\"vm.historicoSituacao.pontosEntregue\" ng-disabled=\"true\"></md-input-container></div></md-dialog-content>\n<md-dialog-actions layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\">\n<md-button type=\"submit\" ng-click=\"vm.metodosDialog.salvar($event, vm.historicoSituacao)\" \nclass=\"send-button md-accent md-raised\" \nng-disabled=\"historicoSituacaoForm.$invalid || historicoSituacaoForm.$pristine || vm.requisicaSolicitada || (vm.historicoSituacao.pontosEntregue > vm.pontos)\" \naria-label=\"SALVAR\" translate=\"ESTORIA.SALVAR\" translate-attr-aria-label=\"ESTORIA.SALVAR\">Salvar</md-button></div><div \nlayout=\"row\"><md-button class=\"md-icon-button\" ng-click=\"vm.metodosDialog.excluir(vm.historicoSituacao, $event)\" \naria-label=\"Excluir\" ng-hide=\"vm.novoHistoricoSituacao\" ng-disabled=\"vm.requisicaSolicitada\" translate \ntranslate-attr-aria-label=\"ESTORIA.EXCLUIR\"><md-icon md-font-icon=\"icon-delete\"></md-icon></md-button></div>\n</md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/planejamento-scrum/processamento/estoria/views/tabs/tarefas/views/processar-estoria-tarefa-por-rotinas.html","<div id=\"estoria-tab-tarefas\" layout-gt-sm=\"row\" layout-gt-xs=\"column\" flex><div layout-gt-sm=\"column\" \nlayout-gt-xs=\"row\" flex-gt-sm=\"30\" flex-gt-xs><div class=\"md-background-bg md-whiteframe-1dp\"><table \nclass=\"row-border\" datatable=\"ng\" dt-options=\"vm.dtOptionsEstoriaTarefasPorRotinas_Rotinas\" width=\"100%\"><thead><tr><th\n class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Selecionar Rotinas</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Descrição</span></div></th></tr></thead>\n<tbody><tr ng-repeat=\"rotina in vm.rotinas track by rotina.codigo\"><td><md-checkbox \nng-click=\"vm.metodosTarefa.\r\n                                   metodosParaGerarTarefasEstoriaPorRotinas.metodosRotina.\r\n                                   selecionarTarefasDasRotinas(rotina.tarefas, $event)\" \naria-label=\"Marcar CheckBox\" translate translate-aria-label=\"ESTORIA.MARCARCHECKBOX\"></md-checkbox></td><td>\n{{rotina.descricao}}</td></tr></tbody></table><div layout=\"row\" layout-align=\"end center\"><md-button \nng-disabled=\"vm.rotinasSelecionadas.length == 0\" \nng-click=\"vm.metodosTarefa.metodosParaGerarTarefasEstoriaPorRotinas.\r\n                             metodosRotina.gerarListaDeTarefas(vm.rotinasSelecionadas)\" \nclass=\"send-button md-accent md-raised\" aria-label=\"Gerar Tabela de Tarefas\" translate=\"ESTORIA.GERAR_TABELA_TAREFAS\" \ntranslate-attr-aria-label=\"ESTORIA.GERAR_TABELA_TAREFAS\"></md-button></div></div></div><div layout-gt-sm=\"column\" \nlayout-gt-xs=\"row\" flex-gt-sm=\"70\" flex-gt-xs><div class=\"main md-whiteframe-1dp\" ms-scroll><table class=\"row-border\" \ndatatable=\"ng\" dt-options=\"vm.dtOptionsEstoriaTarefasPorRotinas_Tarefas\" width=\"100%\"><thead><tr><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Selecionar Tarefas</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Código Rotina</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Descrição</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Horas</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Pontos</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Tarefa Aprovada</span></div></th></tr>\n</thead><tbody><tr ng-repeat=\"tarefa in vm.listaDeTarefas\"><td><md-checkbox \nng-click=\"vm.metodosTarefa.\r\n                                   metodosParaGerarTarefasEstoriaPorRotinas.metodosTarefas.\r\n                                   selecionarTarefas(tarefa, $event)\" \naria-label=\"Marcar CheckBox\" translate translate-aria-label=\"ESTORIA.MARCARCHECKBOX\"></md-checkbox></td><td>\n{{tarefa.rotinaCodigo}}</td><td>{{tarefa.descricao}}</td><td>{{tarefa.horas}}</td><td>{{tarefa.pontos}}</td><td>\n{{tarefa.aprovada}}</td></tr></tbody></table><div layout=\"row\" layout-align=\"end center\"><md-button \nng-click=\"vm.metodosTarefa.metodosParaGerarTarefasEstoriaPorRotinas.\r\n                               metodosTarefas.cancelar()\" \nclass=\"send-button md-accent md-raised\" aria-label=\"Cancelar\" translate=\"ESTORIA.CANCELAR\" \ntranslate-attr-aria-label=\"ESTORIA.CANCELAR\"></md-button><md-button \nng-click=\"vm.metodosTarefa.metodosParaGerarTarefasEstoriaPorRotinas.\r\n                             metodosTarefas.salvar(vm.tarefasSelecionadas, $event)\" \nng-disabled=\"vm.tarefasSelecionadas.length == 0\" class=\"send-button md-accent md-raised\" aria-label=\"SALVAR\" \ntranslate=\"ESTORIA.SALVAR\" translate-attr-aria-label=\"ESTORIA.SALVAR\"></md-button></div></div></div></div>");
$templateCache.put("app/main/planejamento-scrum/processamento/estoria/views/tabs/tarefas/views/tabela-estoria-tarefas.html","<div class=\"md-background-bg md-whiteframe-1dp\"><table class=\"dataTable row-border hover\" datatable=\"ng\" \ndt-options=\"vm.dtOptionsTabTarefas\" width=\"100%\"><thead><tr><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Ação</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Descrição</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Tipo Tarefa</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Pontos</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Data Início</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Data Fim</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Usuário</span></div></th></tr></thead><tfoot><tr><th>Total:</th><th></th><th></th><th \nstyle=\"text-align: center !important\"></th><th></th><th></th><th></th></tr></tfoot><tbody><tr \nng-repeat=\"tarefa in vm.estoria.tarefas\"><td class=\"button-icone-cor-azul\"><i \nclass=\"icon-pencil s16 icone-cor-padrao mr-10\" \nng-click=\"vm.controleForm.emProgresso || vm.metodosTarefa.abrirDialogTarefas($event, $index, tarefa)\" \nng-disabled=\"vm.controleForm.emProgresso\"></i> <i class=\"icon-delete s16 icone-cor-padrao\" \nng-click=\"vm.controleForm.emProgresso || vm.metodosTarefa.excluir($event, tarefa)\" \nng-disabled=\"vm.controleForm.emProgresso\"></i></td><td>{{tarefa.descricao}}</td><td>\n{{vm.metodosTarefa.converteIdParaTipo(tarefa.tipo)}}</td><td class=\"text-center\">{{tarefa.pontos}}</td><td \nng-dblclick=\"vm.controleForm.emProgresso || \r\n                (\r\n                    (tarefa.tipo === 1 || tarefa.tipo === 2) &&                \r\n                    (vm.usuarioEstoriaLogado.clsSetor.descricao.toLowerCase() != \'desenvolvimento\' &&\r\n                    vm.usuarioEstoriaLogado.clsSetor.descricao.toLowerCase() != \'análise\')\r\n                ) || \r\n                (tarefa.tipo === 3 && \r\n                (\r\n                    vm.usuarioEstoriaLogado.clsSetor.descricao.toLowerCase() !== \'testes\' &&\r\n                    vm.usuarioEstoriaLogado.clsSetor.descricao.toLowerCase() !== \'análise\'\r\n                    \r\n                    )) || \r\n                vm.metodosTarefa.abrirDialogEditarCampoTarefa($event, tarefa, \'dataHoraInicio\')\" \nng-disabled=\"vm.controleForm.emProgresso || \r\n                    (\r\n                        (tarefa.tipo === 1 || tarefa.tipo === 2) && \r\n                        (vm.usuarioEstoriaLogado.clsSetor.descricao.toLowerCase() != \'desenvolvimento\' &&\r\n                        vm.usuarioEstoriaLogado.clsSetor.descricao.toLowerCase() != \'análise\')\r\n                        ) || \r\n                        (tarefa.tipo === 3 && \r\n                        (\r\n                            vm.usuarioEstoriaLogado.clsSetor.descricao.toLowerCase() !== \'testes\' &&\r\n                            vm.usuarioEstoriaLogado.clsSetor.descricao.toLowerCase() !== \'análise\'\r\n                            \r\n                            ))\">\n<div class=\"border-bottom-azul\"><md-tooltip md-delay=\"500\" \nng-if=\"vm.controleForm.emProgresso || \r\n                                    (\r\n                                        (tarefa.tipo === 1 || tarefa.tipo === 2) && \r\n                                        (vm.usuarioEstoriaLogado.clsSetor.descricao.toLowerCase() != \'desenvolvimento\' &&\r\n                                        vm.usuarioEstoriaLogado.clsSetor.descricao.toLowerCase() != \'análise\')\r\n                                        ) || \r\n                                        (tarefa.tipo === 3 && \r\n                                        (\r\n                                            vm.usuarioEstoriaLogado.clsSetor.descricao.toLowerCase() !== \'testes\' &&\r\n                                            vm.usuarioEstoriaLogado.clsSetor.descricao.toLowerCase() !== \'análise\'\r\n                                            \r\n                                            ))\">\n<span translate=\"ESTORIA.EDICAO_CAMPO_DA_TAREFA_INVALIDO\"></span></md-tooltip>\n{{tarefa.dataHoraInicio | date:\'dd/MM/yyyy\'}}</div></td><td \nng-dblclick=\"vm.controleForm.emProgresso || \r\n                (\r\n                    (tarefa.tipo === 1 || tarefa.tipo === 2) && \r\n                    (vm.usuarioEstoriaLogado.clsSetor.descricao.toLowerCase() != \'desenvolvimento\' && vm.usuarioEstoriaLogado.clsSetor.descricao.toLowerCase() != \'análise\')) || (tarefa.tipo === 3 && vm.usuarioEstoriaLogado.clsSetor.descricao.toLowerCase() !== \'testes\' && vm.usuarioEstoriaLogado.clsSetor.descricao.toLowerCase() !== \'análise\') || vm.metodosTarefa.abrirDialogEditarCampoTarefa($event, tarefa, \'dataHoraFim\')\" \nng-disabled=\"vm.controleForm.emProgresso || ((tarefa.tipo === 1 || tarefa.tipo === 2) && (vm.usuarioEstoriaLogado.clsSetor.descricao.toLowerCase() != \'desenvolvimento\' && vm.usuarioEstoriaLogado.clsSetor.descricao.toLowerCase() != \'análise\')) || (tarefa.tipo === 3 && vm.usuarioEstoriaLogado.clsSetor.descricao.toLowerCase() !== \'testes\' && vm.usuarioEstoriaLogado.clsSetor.descricao.toLowerCase() != \'análise\')\">\n<md-tooltip md-delay=\"500\" \nng-if=\"vm.controleForm.emProgresso || ((tarefa.tipo === 1 || tarefa.tipo === 2) && (vm.usuarioEstoriaLogado.clsSetor.descricao.toLowerCase() != \'desenvolvimento\' && vm.usuarioEstoriaLogado.clsSetor.descricao.toLowerCase() != \'análise\')) || (tarefa.tipo === 3 && vm.usuarioEstoriaLogado.clsSetor.descricao.toLowerCase() !== \'testes\' && vm.usuarioEstoriaLogado.clsSetor.descricao.toLowerCase() != \'análise\')\">\n<span translate=\"ESTORIA.EDICAO_CAMPO_DA_TAREFA_INVALIDO\"></span></md-tooltip><div class=\"border-bottom-azul\">\n{{tarefa.dataHoraFim | date:\'dd/MM/yyyy\'}}</div></td><td \nng-dblclick=\"vm.controleForm.emProgresso || ((tarefa.tipo === 1 || tarefa.tipo === 2) && (vm.usuarioEstoriaLogado.clsSetor.descricao.toLowerCase() != \'desenvolvimento\' && vm.usuarioEstoriaLogado.clsSetor.descricao.toLowerCase() != \'análise\')) || (tarefa.tipo === 3 && vm.usuarioEstoriaLogado.clsSetor.descricao.toLowerCase() !== \'testes\' && vm.usuarioEstoriaLogado.clsSetor.descricao.toLowerCase() != \'análise\') || vm.metodosTarefa.abrirDialogEditarCampoTarefa($event, tarefa, \'usuario\')\" \nng-disabled=\"vm.controleForm.emProgresso || ((tarefa.tipo === 1 || tarefa.tipo === 2) && (vm.usuarioEstoriaLogado.clsSetor.descricao.toLowerCase() != \'desenvolvimento\' && vm.usuarioEstoriaLogado.clsSetor.descricao.toLowerCase() != \'análise\')) || (tarefa.tipo === 3 && vm.usuarioEstoriaLogado.clsSetor.descricao.toLowerCase() !== \'testes\' && vm.usuarioEstoriaLogado.clsSetor.descricao.toLowerCase() != \'análise\')\">\n<md-tooltip md-delay=\"500\" \nng-if=\"vm.controleForm.emProgresso || ((tarefa.tipo === 1 || tarefa.tipo === 2) && (vm.usuarioEstoriaLogado.clsSetor.descricao.toLowerCase() != \'desenvolvimento\' && vm.usuarioEstoriaLogado.clsSetor.descricao.toLowerCase() != \'análise\')) || (tarefa.tipo === 3 && vm.usuarioEstoriaLogado.clsSetor.descricao.toLowerCase() !== \'testes\' && vm.usuarioEstoriaLogado.clsSetor.descricao.toLowerCase() != \'análise\')\">\n<span translate=\"ESTORIA.EDICAO_CAMPO_DA_TAREFA_INVALIDO\"></span></md-tooltip><div class=\"border-bottom-azul\">\n{{tarefa.usuario.login}}</div></td></tr></tbody></table></div>");
$templateCache.put("app/main/solicitacao/processamento/solicitacao/tabs/documentacao/dialogs/documentacao-dialog/documentacao-dialog.html","<md-dialog class=\"dialogo-padrao\" id=\"dialog-solicitacao-documentacao\" aria-label=\"dialog\"><form \nname=\"vm.form.documentacaoForm\" class=\"md-inline-form\" novalidate><md-toolbar class=\"md-accent md-tall titulo-dialog\" \nlayout=\"column\"><div class=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" layout-align=\"space-between center\">\n<span class=\"title\">{{vm.titulo}}</span><md-button class=\"md-icon-button\" ng-click=\"vm.metodosDialog.fecharDialog()\">\n<md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content style=\"padding: 10px\">\n<div class=\"container-content\"><div ng-if=\"vm.tipoEtapa == 4\" class=\"container-historias-vinculadas\"><div \nclass=\"campo-vincula-historias\" ng-if=\"vm.action != \'visualizar\'\"><md-autocomplete md-input-name=\"historias\" \nmd-floating-label=\"Histórias\" md-no-cache=\"true\" md-selected-item=\"vm.historia\" \nmd-selected-item-change=\"vm.metodosDialog.alterarItemSelecionadoAutoComplete(item)\" \nmd-search-text=\"vm.textoDePesquisaAutoComplete\" \nmd-items=\"item in vm.metodosDialog.pesquisarAutoComplete(vm.textoDePesquisaAutoComplete)\" md-item-text=\"item.numero\" \nmd-autoselect ng-blur=\"vm.metodosDialog.configuraAutoCompleteOnBlur()\" flex><md-item-template><span \nmd-highlight-text=\"vm.textoDePesquisaAutoComplete\">{{ item.numero }}/{{ item.ano }}</span></md-item-template>\n<md-not-found><label>Não foi encontrada nenhuma história.</label></md-not-found></md-autocomplete></div><div \nng-if=\"vm.solicitacao.historiasVinculadas.length\" class=\"tabela-historias-vinculadas\"><div \nclass=\"fullpage-datatable scrollable\" ms-scroll style=\"width: 100%\"><table class=\"dataTable row-border hover\" \ndt-options=\"vm.dtOptions\" width=\"100%\"><thead><tr><th class=\"secondary-text border-left\"><div class=\"table-header\">\n<span class=\"column-title\">Número</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Ano</span></div></th><th class=\"secondary-text titulo-acoes\"><div class=\"table-header\"><span \nclass=\"column-title span-acao\">Ação</span></div></th></tr></thead><tbody><tr \nng-repeat=\"historia in vm.solicitacao.historiasVinculadas\"><td class=\"border-left\">{{historia.estoriaNumero}}</td><td>\n{{historia.estoriaAno}}</td><td class=\"border-right\"><i class=\"icon-open-in-new s18 icone-cor-padrao\" \nng-click=\"vm.metodosDialog.visualizarHistoria(historia)\"><md-tooltip><label>\nIr para história {{historia.estoriaNumero}}/{{historia.estoriaAno}}</label></md-tooltip></i><i \nclass=\"icon-delete s18 icone-cor-padrao\" ng-if=\"vm.action != \'visualizar\'\" \nng-click=\"vm.metodosDialog.removerHistoriaVinculada(historia)\"><md-tooltip><label>\nRemover {{historia.estoriaNumero}}/{{historia.estoriaAno}}</label></md-tooltip></i></td></tr></tbody></table></div>\n</div></div><div class=\"container-documentacao\" ng-class=\"{\'documentacao-ajustada\': vm.tipoEtapa == 4}\">\n<text-angular-toolbar flex name=\"toolbar\" ng-if=\"vm.action != \'visualizar\'\" style=\"width: 100%\" \nta-toolbar=\"[[\'h1\', \'h2\', \'h3\', \'h4\', \'h5\', \'p\', \'pre\', \'quote\', \'bold\', \'italics\', \'underline\', \'ul\', \'ol\', \'redo\',             \'undo\', \'justifyLeft\', \'justifyCenter\', \'justifyRight\', \'justifyFull\', \'indent\', \'outdent\', \'clear\']]\">\n</text-angular-toolbar><text-angular flex ta-target-toolbars=\"toolbar\" ng-model=\"vm.docTemp\" style=\"width: 100%\" \nng-class=\"{\'text-angular-editor\': vm.tipoEtapa == 4}\" id=\"documentacao-dialog-documentacao\" \nname=\"documentacao-dialog-documentacao\" ta-disabled=\"vm.action == \'visualizar\'\" md-autofocus \nta-toolbar=\"[[\'h1\', \'h2\', \'h3\', \'h4\', \'h5\', \'p\', \'pre\', \'quote\', \'bold\', \'italics\', \'underline\', \'ul\', \'ol\', \'redo\',\'undo\', \'justifyLeft\', \'justifyCenter\', \'justifyRight\', \'justifyFull\', \'indent\', \'outdent\', \'clear\']]\" \nng-required=\"vm.tipoEtapa !== 4\"></text-angular></div></div></md-dialog-content><md-dialog-actions \nng-hide=\"vm.action == \'visualizar\'\" layout=\"row\"><div layout=\"row\" layout-align=\"end center\" flex><md-button \ntype=\"button\" ng-click=\"vm.metodosDialog.salvarAlteracoes()\" class=\"send-button md-accent md-raised\" \nng-disabled=\"vm.form.documentacaoForm.$invalid\" ng-hide=\"vm.action == \'visualizar\'\" aria-label=\"SALVAR\" \ntranslate=\"ESTIMATIVA.SALVAR\" translate-attr-aria-label=\"ESTIMATIVA.SALVAR\"></md-button></div></md-dialog-actions>\n</form></md-dialog>");
$templateCache.put("app/main/solicitacao/processamento/solicitacao/tabs/estimativa/dialogs/editar-pontuacao-dialog/editar-pontuacao-dialog.html","<md-dialog id=\"estoria-dialog-alterar-campo-tarefa\" class=\"dialogo-padrao\" aria-label=\"Dialog\"><form \nname=\"vm.form.editarPontuacaoForm\" class=\"md-inline-form\" novalidate><md-toolbar class=\"md-accent md-tall\" \nlayout=\"column\"><div class=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" layout-align=\"space-between center\">\n<span class=\"title\">{{vm.titulo}}</span><md-button class=\"md-icon-button\" ng-click=\"vm.metodosDialog.fecharDialog()\" \naria-label=\"Fechar dialog\" translate translate-attr-aria-label=\"SPRINT.FECHAR_DIALOG\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><div layout=\"row\" layout-sm=\"row\" \nlayout-align=\"center\" ng-show=\"vm.requisicaSolicitada || vm.preloader.habilitar\"><md-progress-circular \nmd-mode=\"indeterminate\" class=\"md-accent\"></md-progress-circular></div><md-dialog-content><div layout=\"row\" \nlayout-align=\"center center\"><md-input-container class=\"md-block\" flex-gt-sm=\"30\"><label \ntranslate=\"ESTIMATIVA.PONTUACAO\"></label><input type=\"text\" ng-model=\"vm.solicitacao.estimativaPontos\" \nname=\"solicitacaoPontuacao\" mascara-numero-generica=\"###\" converte-mascara-para-numero ng-required=\"vm.editarAtivo\">\n<div ng-messages=\"vm.form.editarPontuacaoForm.solicitacaoPontuacao.$error\"><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container></div></md-dialog-content>\n<md-dialog-actions layout=\"row\"><div layout=\"row\" layout-align=\"end center\" flex><md-button type=\"submit\" \nng-click=\"vm.metodosDialog.salvarAlteracoes()\" class=\"send-button md-accent md-raised\" \nng-disabled=\"vm.form.editarPontuacaoForm.$invalid\" aria-label=\"SALVAR\" translate=\"ESTIMATIVA.SALVAR\" \ntranslate-attr-aria-label=\"ESTIMATIVA.SALVAR\"></md-button></div></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/financeiro/relatorio/contratos/views/step/produto-segmentacao/diretivas/secao-itens-a-nao-imprimir/secao-itens-a-nao-imprimir.html","<fieldset class=\"standard\" flex><legend class=\"grp-legend\">Itens a não imprimir</legend><div layout-gt-sm=\"row\" flex>\n<div layout=\"column\" flex flex-gt-sm=\"30\"><div layout-gt-sm=\"row\"><md-input-container class=\"md-block\" flex>\n<md-radio-group class=\"pb-20 pl-15\" layout=\"row\" ng-model=\"vm.modelTipoFiltro\"><md-radio-button value=\"1\" \naria-label=\"Por item\">Por item</md-radio-button><md-radio-button value=\"2\" aria-label=\"Por cliente\">Por cliente\n</md-radio-button></md-radio-group><md-autocomplete id=\"select\" md-input-name=\"itensANaoImprimir\" md-no-cache=\"true\" \nng-blur=\"vm.metodos.configuraAutoCompleteOnBlur()\" md-selected-item=\"vm.item\" \nmd-selected-item-change=\"vm.metodos.alterarItemSelecionadoAutoComplete(item)\" \nmd-search-text=\"vm.textoDePesquisaAutoComplete\" \nmd-items=\"item in vm.metodos.pesquisarAutoComplete(vm.textoDePesquisaAutoComplete)\" \nmd-item-text=\"item.codigo + \' - \' + item.descricao\" md-autoselect md-delay=\"300\" md-floating-label=\"Itens\">\n<md-item-template><span md-highlight-text=\"vm.textoDePesquisaAutoComplete\">{{item.codigo}} - {{item.descricao}}</span>\n</md-item-template><md-not-found><label>Não foi encontrada nenhum item</label></md-not-found></md-autocomplete>\n</md-input-container></div></div><md-divider flex-offset=\"5\"></md-divider><div layout=\"column\" flex-offset=\"5\" flex>\n<div class=\"fullpage-datatable scrollable\" ms-scroll flex style=\"height:200px\"><table \nclass=\"dataTable row-border hover\" dt-options=\"vm.dtOptions\" flex><thead><tr><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Código</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Descrição</span></div></th><th></th></tr></thead><tbody \nng-repeat=\"item in vm.filtros\"><tr><td style=\"width:15%\"><span class=\"text-responsive\">{{item.codigo}}</span></td><td \nstyle=\"width:70%;text-align:left\"><span class=\"text-responsive\">{{item.descricao}}</span></td><td \nclass=\"button-icone-cor-azul\" style=\"width:15%;text-align:right\"><i class=\"icon-delete s16 icone-cor-padrao\" \nng-click=\"vm.metodos.removerItem(item)\"><md-tooltip><label>Remover item</label></md-tooltip></i></td></tr></tbody>\n</table></div></div></div></fieldset>");
$templateCache.put("app/main/financeiro/relatorio/contratos/views/step/produto-segmentacao/diretivas/secao-subitens/secao-subitens.html","<fieldset class=\"standard\" flex><legend class=\"grp-legend\">Subitens a imprimir</legend><div layout-gt-sm=\"row\" flex>\n<div layout=\"column\" flex flex-gt-sm=\"30\"><div layout-gt-sm=\"row\"><md-input-container class=\"md-block\" flex>\n<md-autocomplete id=\"select\" md-input-name=\"subItens\" md-no-cache=\"true\" \nng-blur=\"vm.metodos.configuraAutoCompleteOnBlur()\" md-selected-item=\"vm.item\" \nmd-selected-item-change=\"vm.metodos.alterarItemSelecionadoAutoComplete(item)\" \nmd-search-text=\"vm.textoDePesquisaAutoComplete\" \nmd-items=\"item in vm.metodos.pesquisarAutoComplete(vm.textoDePesquisaAutoComplete)\" \nmd-item-text=\"item.codigo + \' - \' + item.descricao\" md-autoselect md-delay=\"300\" md-floating-label=\"Subitens\">\n<md-item-template><span md-highlight-text=\"vm.textoDePesquisaAutoComplete\">{{item.codigo}} - {{item.descricao}}</span>\n</md-item-template><md-not-found><label>Não foi encontrado nenhum subitem</label></md-not-found></md-autocomplete>\n</md-input-container></div><div layout-gt-sm=\"row\"><md-input-container class=\"md-block ml-30\"><md-checkbox \nng-model=\"vm.habilitarTodos\" ng-disabled=\"vm.filtros.length == 0\" ng-change=\"vm.metodos.ngChangehabilitarTodos()\" \naria-label=\"todos\"><span class=\"float-label-cor-default\">Todos</span></md-checkbox></md-input-container></div></div>\n<md-divider flex-offset=\"5\"></md-divider><div layout=\"column\" flex-offset=\"5\" flex><div \nclass=\"fullpage-datatable scrollable\" ms-scroll flex style=\"height:200px\"><table class=\"dataTable row-border hover\" \ndt-options=\"vm.dtOptions\" flex><thead><tr><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Código</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Descrição</span></div></th><th></th></tr></thead><tbody ng-repeat=\"item in vm.filtros\"><tr><td \nstyle=\"width:15%\"><span class=\"text-responsive\">{{item.codigo}}</span></td><td style=\"width:70%;text-align:left\"><span \nclass=\"text-responsive\">{{item.descricao}}</span></td><td class=\"button-icone-cor-azul\" \nstyle=\"width:15%;text-align:right\"><i class=\"icon-delete s16 icone-cor-padrao\" ng-click=\"vm.metodos.removerItem(item)\">\n<md-tooltip><label>Remover subitem</label></md-tooltip></i></td></tr></tbody></table></div></div></div></fieldset>");
$templateCache.put("app/main/financeiro/relatorio/contratos/views/step/produto-segmentacao/diretivas/secao-subitens-a-nao-imprimir/secao-subitens-a-nao-imprimir.html","<fieldset class=\"standard\" flex><legend class=\"grp-legend\">Subitens a não imprimir</legend><div layout-gt-sm=\"row\" \nflex><div layout=\"column\" flex flex-gt-sm=\"30\"><div layout-gt-sm=\"row\"><md-input-container class=\"md-block\" flex>\n<md-autocomplete id=\"select\" md-input-name=\"subItensANaoImprimir\" md-no-cache=\"true\" \nng-blur=\"vm.metodos.configuraAutoCompleteOnBlur()\" md-selected-item=\"vm.item\" \nmd-selected-item-change=\"vm.metodos.alterarItemSelecionadoAutoComplete(item)\" \nmd-search-text=\"vm.textoDePesquisaAutoComplete\" \nmd-items=\"item in vm.metodos.pesquisarAutoComplete(vm.textoDePesquisaAutoComplete)\" \nmd-item-text=\"item.codigo + \' - \' + item.descricao\" md-autoselect md-delay=\"300\" md-floating-label=\"Subitens\">\n<md-item-template><span md-highlight-text=\"vm.textoDePesquisaAutoComplete\">{{item.codigo}} - {{item.descricao}}</span>\n</md-item-template><md-not-found><label>Não foi encontrado nenhum subitem</label></md-not-found></md-autocomplete>\n</md-input-container></div></div><md-divider flex-offset=\"5\"></md-divider><div layout=\"column\" flex-offset=\"5\" flex>\n<div class=\"fullpage-datatable scrollable\" ms-scroll flex style=\"height:200px\"><table \nclass=\"dataTable row-border hover\" dt-options=\"vm.dtOptions\" flex><thead><tr><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Código</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Descrição</span></div></th><th></th></tr></thead><tbody \nng-repeat=\"item in vm.filtros\"><tr><td style=\"width:15%\"><span class=\"text-responsive\">{{item.codigo}}</span></td><td \nstyle=\"width:70%;text-align:left\"><span class=\"text-responsive\">{{item.descricao}}</span></td><td \nclass=\"button-icone-cor-azul\" style=\"width:15%;text-align:right\"><i class=\"icon-delete s16 icone-cor-padrao\" \nng-click=\"vm.metodos.removerItem(item)\"><md-tooltip><label>Remover subitem</label></md-tooltip></i></td></tr></tbody>\n</table></div></div></div></fieldset>");
$templateCache.put("app/main/financeiro/processamento/contratos/views/tabs/tab-itens/dialogs/itens-dialog/itens-dialog.html","<md-dialog id=\"dialog-itens\" class=\"dialogo-padrao\" aria-label=\"Dialog\"><carregamento-circular \nem-progresso=\"vm.emProgresso\" titulo=\"Aguarde...\" mensagem=\"{{vm.mensagem}}\"></carregamento-circular><form \nclass=\"md-inline-form\" name=\"vm.form\" novalidate><md-toolbar class=\"md-accent md-tall\" layout=\"column\"><div \nclass=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\">\n{{vm.titulo}}</span><md-button class=\"md-icon-button\" aria-label=\"Fechar dialog\" translate \ntranslate-attr-aria-label=\"CLIENTE.FECHAR_DIALOG\" ng-click=\"vm.metodos.fecharDialog()\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><div class=\"mt-10\" \nng-if=\"vm.controladorDialog.requisicaoSolicitada\" layout=\"column\" layout-align=\"center center\"><span \nclass=\"font-weight-500\">{{vm.controladorDialog.mensagemPreloader}}</span><md-progress-circular class=\"md-accent\" \nmd-mode=\"indeterminate\" md-diameter=\"30\"></md-progress-circular></div><md-dialog-content><div class=\"primeira-linha\" \nlayout=\"row\"><md-input-container class=\"md-block\" flex><label>Item</label><md-select name=\"produto\" \nmd-on-open=\"vm.metodos.configuraMdSelectProduto()\" ng-change=\"vm.metodos.changeProduto(vm.contratoItem.produtoCodigo)\" \nng-model=\"vm.contratoItem.produtoCodigo\" ng-required=\"true\" \nng-disabled=\"vm.editar || vm.emProgresso || vm.apenasVisualizacao\"><md-select-header><input \nid=\"cliente-dialog-contrato-produto-md-select\" class=\"md-text\" type=\"search\" translate \ntranslate-attr-placeholder=\"CLIENTE.PESQUISAR_ITEM\" ng-model=\"vm.filtrarProduto\"></md-select-header><md-option \nng-value=\"produto.codigo\" ng-repeat=\"produto in vm.produtos | filter:vm.filtrarProduto track by produto.codigo\">\n{{produto.descricao}}</md-option></md-select><div ng-messages=\"vm.form.produto.$error\"><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container><md-input-container class=\"md-block\" \nflex><label translate=\"CLIENTE.SITUACAO_ITEM\"></label><md-select name=\"situacaoContrato\" \nng-model=\"vm.contratoItem.contratoItemDadosSigiloso.situacaoItem\" \nng-disabled=\"vm.emProgresso || vm.apenasVisualizacao\" \nng-change=\"vm.metodos.onChangeSituacaoItem(vm.contratoItem.contratoItemDadosSigiloso.situacaoItem)\"><md-option \nng-value=\"key\" ng-repeat=\"(key, value) in vm.situacoesContrato\">{{value}}</md-option></md-select><div \nng-messages=\"vm.form.situacaoContrato.$error\"><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container><md-input-container class=\"md-block\" \nng-if=\"vm.habilitarVisualizacao\" flex><label translate=\"CLIENTE.SITUACAO_FINANCEIRA_ITEM\"></label><md-select \nname=\"SituacaoFinanceiraItem\" ng-model=\"vm.contratoItem.contratoItemDadosSigiloso.situacaoFinanceiraItem\" \nng-disabled=\"vm.emProgresso || vm.apenasVisualizacao\"><md-option ng-value=\"key\" \nng-repeat=\"(key, value) in vm.situacoesFinanceirasContrato\">{{value}}</md-option></md-select><div \nng-messages=\"vm.form.SituacaoFinanceiraItem.$error\"><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container></div><div layout=\"row\" \nng-if=\"vm.contratoItem.contratoItemDadosSigiloso.situacaoItem == 3\"><md-input-container \nclass=\"md-block container-data data-supressao\" flex><label translate=\"CLIENTE.DATA_SUPRESSAO\"></label><md-datepicker \nname=\"dataSupressao\" mascara-conversor-string-para-data \nng-model=\"vm.contratoItem.contratoItemDadosSigiloso.dataSupressao\" ng-mask=\"3?9/1?9/9999\" \nng-disabled=\" vm.apenasVisualizacao\" ng-required=\"true\"></md-datepicker><div \nng-messages=\"vm.form.dataSupressao.$error\"><div ng-message=\"valid\" translate=\"MENSAGEM_VALIDACAO.DATA_INVALIDA\"></div>\n</div></md-input-container><md-input-container class=\"md-block motivo-supressao\" flex=\"30\"><label \ntranslate=\"CLIENTE.MOTIVO_SUPRESSAO\"></label><input type=\"text\" name=\"motivoSupressao\" md-maxlength=\"100\" \nmascara-tamanho-campo=\"100\" ng-model=\"vm.contratoItem.contratoItemDadosSigiloso.motivoSupressao\" \nng-disabled=\"vm.apenasVisualizacao\" ng-required=\"true\"><div ng-messages=\"vm.form.motivoSupressao.$error\"><div \nng-message=\"required\" translate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container></div><div \nlayout=\"row\"><md-input-container class=\"md-block\" flex ng-if=\"vm.habilitarVisualizacao\"><label>Natureza do faturamento\n</label><md-select name=\"naturezaFaturamento\" md-on-open=\"vm.metodos.configuraMdSelectNaturezaFaturamento()\" \nng-model=\"vm.contratoItem.contratoItemDadosSigiloso.codigoNaturezaFaturamento\" \nng-disabled=\"!(vm.editar && vm.usuarioPermiteEdicao || vm.inserirAtivo) || vm.emProgresso || vm.apenasVisualizacao\" \nng-required=\"true\"><md-select-header><input id=\"cliente-dialog-contrato-natureza-md-select\" class=\"md-text\" \ntype=\"search\" translate translate-attr-placeholder=\"Pesquisar natureza do faturamento\" \nng-model=\"vm.filtrarNaturezaFaturamento\"></md-select-header><md-option ng-value=\"natureza.codigo\" \nng-repeat=\"natureza in vm.naturezaFaturamento | filter:vm.filtrarNaturezaFaturamento track by natureza.codigo\">\n{{natureza.descricao}}: {{natureza.percentualImpostoDescontar}}</md-option></md-select><div \nng-messages=\"vm.form.naturezaFaturamento.$error\"><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container><md-input-container class=\"md-block\" \nflex ng-if=\"vm.habilitarVisualizacao\"><label translate=\"Código faturamento item\"></label><input type=\"text\" \nname=\"codigoFaturamento\" mascara-numeros=\"3\" ng-model=\"vm.contratoItem.codigoFaturamento\" \nng-disabled=\"vm.emProgresso || vm.apenasVisualizacao\" ng-required=\"!vm.editar\"><div \nng-messages=\"vm.form.codigoFaturamento.$error\"><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container><md-input-container class=\"md-block\" \nng-if=\"vm.habilitarVisualizacao\" flex><label translate=\"CLIENTE.FORMA_FATURAMENTO\"></label><md-select \nname=\"formaFaturamento\" md-on-open=\"vm.metodos.configuraMdSelectFormaFaturamento()\" \nng-model=\"vm.contratoItem.contratoItemDadosSigiloso.codigoFormaFaturamento\" \nng-disabled=\"vm.emProgresso || vm.apenasVisualizacao\" ng-required=\"true\"><md-select-header><input \nid=\"contrato-form-forma-faturamento-md-select\" class=\"md-text\" type=\"search\" placeholder=\"\" translate \ntranslate-attr-placeholder=\"CLIENTE.PESQUISAR_FORMA_FATURAMENTO\" ng-model=\"vm.filtrarFormaFaturamento\">\n</md-select-header><md-option ng-value=\"formaFaturamento.codigo\" \nng-repeat=\"formaFaturamento in vm.formasFaturamento  \r\n                                               | filter:vm.filtrarFormaFaturamento track by formaFaturamento.codigo\">\n{{formaFaturamento.descricao}}</md-option></md-select><div ng-messages=\"vm.form.formaFaturamento.$error\"><div \nng-message=\"required\" translate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container></div><div \nlayout=\"row\"><md-input-container class=\"md-block\" ng-if=\"vm.habilitarVisualizacao\" flex><label \ntranslate=\"CLIENTE.VALOR_MENSAL_ITEM\"></label><input type=\"text\" name=\"valorMensal\" ui-money-mask \nmascara-tamanho-campo=\"12\" ng-model=\"vm.contratoItem.contratoItemDadosSigiloso.valorMensal\" ng-required=\"true\" \nng-disabled=\"vm.emProgresso || vm.apenasVisualizacao || vm.editar || vm.metodos.possuiSubitens()\"><div \nng-messages=\"vm.form.valorMensal.$error\"><div ng-message=\"required\" translate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\">\n</div></div></md-input-container><md-input-container class=\"md-block\" ng-if=\"vm.habilitarVisualizacao\" flex><label \ntranslate=\"CLIENTE.TIPO_BLOQUEIO\"></label><md-select name=\"tipoBloqueio\" \nng-model=\"vm.contratoItem.contratoItemDadosSigiloso.tipoBloqueio\" \nng-disabled=\"vm.emProgresso || vm.apenasVisualizacao\"><md-option ng-value=\"key\" \nng-repeat=\"(key, value) in vm.tiposBloqueio\">{{value}}</md-option></md-select><div \nng-messages=\"vm.form.tipoBloqueio.$error\"><div ng-message=\"required\" translate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\">\n</div></div></md-input-container><md-input-container class=\"md-block\" ng-if=\"vm.habilitarVisualizacao\" flex><label \ntranslate=\"CLIENTE.VALOR_COMISSIONAVEL\"></label><input type=\"text\" name=\"valorComissionavel\" \nmascara-tamanho-campo=\"12\" ui-money-mask readonly=\"readonly\" \nng-model=\"vm.contratoItem.contratoItemDadosSigiloso.valorComissionavel\" \nng-disabled=\"vm.emProgresso || vm.apenasVisualizacao\"></md-input-container></div><div layout=\"row\"><md-input-container \nclass=\"md-block\" ng-if=\"vm.habilitarVisualizacao\" flex><label translate=\"CLIENTE.PERCENTUAL_COMISSAO_APLICADO\"></label>\n<input type=\"text\" name=\"percentualComissaoAplicado\" mascara-tamanho-campo=\"6\" ui-percentage-mask \nng-model=\"vm.contratoItem.contratoItemDadosSigiloso.percentualComissaoAplicada\" \nng-disabled=\"!(vm.editar && vm.usuarioPermiteEdicao || vm.inserirAtivo) ||  vm.emProgresso || vm.apenasVisualizacao\">\n</md-input-container><md-input-container class=\"md-block\" ng-if=\"vm.habilitarVisualizacao\" flex><label \ntranslate=\"CLIENTE.PERCENTUAL_COMISSIONAVEL\"></label><input type=\"text\" name=\"percentualComissionavel\" \nmascara-tamanho-campo=\"6\" ui-percentage-mask \nng-model=\"vm.contratoItem.contratoItemDadosSigiloso.percentualComissionavel\" \nng-disabled=\"!(vm.editar && vm.usuarioPermiteEdicao || vm.inserirAtivo) ||  vm.emProgresso || vm.apenasVisualizacao\">\n</md-input-container><md-input-container class=\"md-block\" flex><label translate=\"CLIENTE.EXECUTIVO_DE_CONTAS\"></label>\n<md-select ng-model=\"vm.contratoItem.codigoExecutivoContasResponsavel\" name=\"codigoExecutivoContasResponsavel\" \nng-required=\"true\" md-on-open=\"vm.metodos.configuraMdSelectExecutivoContasResponsavel()\" \nng-disabled=\"vm.emProgresso || vm.apenasVisualizacao\"><md-select-header><input \nid=\"dialog-contrato-item-executivo-contas-responsavel-md-select\" class=\"md-text\" \nng-model=\"vm.filtroExecutivoContasResponsavel\" type=\"search\" placeholder=\"Pesquisar executivo de contas\" translate \ntranslate-attr-placeholder=\"Pesquisar executivo de contas\"></md-select-header><md-option ng-value=\"usuario.codigo\" \nng-repeat=\"usuario in vm.usuarios | filter: vm.metodos.filtrarExecutivoContasResponsavel track by usuario.codigo\">\n{{usuario.login}}</md-option></md-select></md-input-container></div><div layout=\"row\"><md-input-container \nclass=\"md-block\" flex><label translate=\"CLIENTE.RESPONSAVEL_VALIDACAO\"></label><input type=\"text\" \nname=\"nomeResponsavelValidacao\" ng-model=\"vm.contratoItem.responsavelValidacao\" \nng-disabled=\"vm.emProgresso || vm.apenasVisualizacao\"></md-input-container><md-input-container class=\"md-block\" flex>\n<label translate=\"CLIENTE.EMAIL_RESPONSAVEL_VALIDACAO\"></label><input type=\"text\" name=\"emailResponsavelValidacao\" \nng-model=\"vm.contratoItem.emailResponsavelValidacao\" ng-disabled=\"vm.emProgresso || vm.apenasVisualizacao\">\n</md-input-container><md-input-container class=\"md-block\" flex><label translate=\"CLIENTE.CARACTERISTICA\"></label>\n<md-select name=\"codigoCaracteristica\" multiple=\"multiple\" md-on-open=\"vm.metodos.configurarMdSelectCaracteristica()\" \nng-model=\"vm.contratoItem.itemCaracteristicas\" ng-disabled=\"vm.emProgresso || vm.apenasVisualizacao\"><md-select-header>\n<input id=\"dialog-contrato-item-caracteristica-md-select-caracteristica\" class=\"md-text\" type=\"search\" placeholder=\"\" \ntranslate translate-attr-placeholder=\"CONTRATOS.PESQUISAR_CARACTERISTICA_ITEM\" ng-model=\"vm.filtrarCaracteristica\">\n</md-select-header><md-option ng-value=\"caracteristica.codigo\" \nng-repeat=\"caracteristica in vm.caracteristicas | filter:vm.filtrarCaracteristica track by caracteristica.codigo\">\n{{caracteristica.descricao}}</md-option></md-select><div ng-messages=\"vm.form.codigoCaracteristica.$error\"><div \nng-message=\"required\" translate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container></div><div \nlayout=\"row\"><md-input-container class=\"md-block\" flex><label translate=\"N° Licenças/Itens/Conjuntos\"></label><input \ntype=\"text\" name=\"numeroLicencas\" mascara-numeros=\"5\" ng-model=\"vm.contratoItem.numeroLicencas\" \nng-disabled=\"vm.emProgresso || vm.apenasVisualizacao\" \nng-change=\"vm.metodos.onChangeNumeroLicencas(vm.contratoItem.numeroLicencas)\" ng-required=\"true\"> <span \nclass=\"mensagem-erro\" ng-show=\"vm.mensagemErro\">O valor informado deve ser maior que zero.</span><div \nng-messages=\"vm.form.numeroLicencas.$error\"><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container><md-input-container \nclass=\"md-block qntd-licenca-temporaria\" flex ng-if=\"vm.exibeLicencaTemporaria\"><label>Quantidade licenças temporárias\n</label><input type=\"text\" mascara-numeros=\"3\" name=\"quantidadeLicencasTemporaria\" \nng-model=\"vm.contratoItem.quantidadeLicencaTemporaria\" \nng-change=\"vm.metodos.onChangeQuantidadeLicencaTemporaria(vm.contratoItem.quantidadeLicencaTemporaria)\" \nng-disabled=\"vm.emProgresso || vm.apenasVisualizacao\"></md-input-container><div class=\"md-block\" flex layout=\"row\">\n<md-input-container class=\"md-block tempo-licenca-temporaria\" flex ng-if=\"vm.exibeLicencaTemporaria\"><label>\nTempo máximo licença temporária</label><input type=\"text\" mascara-numeros=\"2\" name=\"tempoLicencaTemporaria\" \nng-change=\"vm.metodos.onChangeTempoLicencaTemporaria(vm.contratoItem.tempoMaximoLicencaTemporaria)\" \nng-model=\"vm.contratoItem.tempoMaximoLicencaTemporaria\" ng-required=\"vm.contratoItem.quantidadeLicencaTemporaria > 0\" \nng-disabled=\"vm.emProgresso || vm.apenasVisualizacao || (vm.contratoItem.quantidadeLicencaTemporaria == undefined || vm.contratoItem.quantidadeLicencaTemporaria == 0)\">\n <span class=\"mensagem-erro\" ng-show=\"vm.mensagemAvisoLicencaTemporaria\">O valor informado deve ser maior que zero.\n</span><div ng-messages=\"vm.form.tempoLicencaTemporaria.$error\"><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div><md-icon class=\"cor-icone-padrao\" \nmd-font-icon=\"icon-information-outline\" \nng-hide=\"vm.contratoItem.produtoCodigo == 2 || vm.contratoItem.produtoCodigo == 3\"><md-tooltip md-autohide \nmd-direction=\"top\"><span class=\"md-caption\">\nO campo se refere a quantidade de dias que a licença ficará disponível após cadastro.</span></md-tooltip></md-icon>\n</md-input-container></div></div><fieldset flex ng-if=\"vm.metodos.exibirFieldsetSubitens()\" \nstyle=\"padding-bottom: 0px; margin-top: -20px\"><legend><label>Subitens vinculados</label></legend><div layout=\"column\" \nstyle=\"margin-top: -10px\"><div layout=\"row\" layout-align=\"end center\" style=\"margin-bottom: 10px\" \nng-if=\"!vm.apenasVisualizacao && (!vm.editar || vm.edicaoSubitensHabilitada)\"><md-button class=\"md-raised md-accent\" \nstyle=\"border-radius: 8px; text-transform: none\" ng-click=\"vm.metodos.adicionarSubitem()\" \nng-disabled=\"!vm.metodos.validarSubitens()\" aria-label=\"Adicionar Subitens\">Adicionar Subitens</md-button></div><div \nlayout=\"row\" layout-align=\"start start\" ng-repeat=\"subitem in vm.contratoItem.contratoSubItens track by $index\" \nstyle=\"margin-bottom: -10px\"><div flex=\"5\" layout=\"row\" layout-align=\"center start\" style=\"padding-top: 24px\" \nng-if=\"!vm.apenasVisualizacao && (!vm.editar || vm.edicaoSubitensHabilitada)\"><button ng-disabled=\"vm.emProgresso\" \nng-click=\"vm.metodos.removerSubitem($index)\"><i class=\"icon-delete s22 icone-cor-padrao\"></i></button></div>\n<md-input-container class=\"md-block\" flex=\"30\"><label>Subitem</label><md-select name=\"subitem_{{$index}}\" \nmd-on-open=\"vm.metodos.configuraMdSelectSubitem($index)\" ng-model=\"subitem.codigoProduto\" ng-required=\"true\" \nng-disabled=\"vm.emProgresso || vm.apenasVisualizacao || (vm.editar && !vm.edicaoSubitensHabilitada)\"><md-select-header>\n<input id=\"dialog-contrato-item-subitem-md-select-{{$index}}\" class=\"md-text\" type=\"search\" \nplaceholder=\"Pesquisar subitem\" ng-model=\"vm[\'filtrarSubitem\' + $index]\"></md-select-header><md-option \nng-value=\"produto.codigo\" \nng-repeat=\"produto in vm.metodos.filtrarSubitensDisponiveis($index) | filter: vm[\'filtrarSubitem\' + $index] track by produto.codigo\">\n{{produto.descricao}}</md-option></md-select><div ng-messages=\"vm.form[\'subitem_\' + $index].$error\"><div \nng-message=\"required\">Campo obrigatório</div></div></md-input-container><md-input-container class=\"md-block\" flex=\"20\">\n<label>Quantidade</label><input type=\"text\" name=\"quantidade_{{$index}}\" mascara-numeros=\"11\" \nnumero-casas-decimais=\"5\" ng-model=\"subitem.quantidade\" ng-change=\"vm.metodos.onChangeSubitemQuantidade(subitem)\" \nng-required=\"subitem.codigoProduto\" \nng-disabled=\"vm.emProgresso || vm.apenasVisualizacao || (vm.editar && !vm.edicaoSubitensHabilitada)\"> <span \nclass=\"mensagem-erro\" ng-show=\"subitem.quantidadeInvalida\">A quantidade informada deve ser maior que zero.</span><div \nng-messages=\"vm.form[\'quantidade_\' + $index].$error\"><div ng-message=\"required\">Campo obrigatório</div></div>\n</md-input-container><md-input-container class=\"md-block\" flex=\"25\"><label>Valor unitário</label><input type=\"text\" \nname=\"valorUnitario_{{$index}}\" ui-money-mask=\"5\" mascara-tamanho-campo=\"20\" ng-model=\"subitem.valorUnitario\" \nng-change=\"vm.metodos.calcularValorTotalSubitem(subitem)\" ng-required=\"subitem.codigoProduto\" \nng-disabled=\"vm.emProgresso || vm.apenasVisualizacao || (vm.editar && !vm.edicaoSubitensHabilitada)\"><div \nng-messages=\"vm.form[\'valorUnitario_\' + $index].$error\"><div ng-message=\"required\">Campo obrigatório</div></div>\n</md-input-container><md-input-container class=\"md-block\" flex=\"15\"><label>Valor total</label><input type=\"text\" \nui-money-mask readonly=\"readonly\" ng-model=\"subitem.valorTotal\" ng-disabled=\"true\"></md-input-container><div flex=\"5\" \nlayout=\"row\" layout-align=\"center start\" style=\"padding-top: 24px\"><i \nng-class=\"vm.apenasVisualizacao || (vm.editar && !vm.edicaoSubitensHabilitada) ? \'icon-open-in-new\' : \'icon-pencil\'\" \nclass=\"s22 icone-cor-padrao\" ng-click=\"vm.metodos.editarObservacaoSubitem(subitem, $index)\" style=\"cursor: pointer\">\n</i></div></div></div></fieldset><fieldset flex><legend><label>Risco de perda</label></legend><div layout=\"column\"><div\n layout=\"row\"><md-input-container class=\"md-block\"><md-checkbox ng-model=\"vm.contratoItem.riscoRescisaoContratual\" \nname=\"riscoRescisaoContratual\" \nng-change=\"vm.metodos.onChangeRiscoRescisaoContratual(vm.contratoItem.riscoRescisaoContratual)\" \nng-disabled=\"vm.emProgresso \r\n                                 || vm.apenasVisualizacao \r\n                                 || vm.contratoItem.contratoItemDadosSigiloso.situacaoItem != 1\">\n<span class=\"float-label-cor-default\">Item contratual com risco de perda</span></md-checkbox></md-input-container>\n<md-input-container class=\"md-block container-data\" flex=\"20\" style=\"margin-top: 1px\"><label>Data</label><md-datepicker\n name=\"dataRiscoRescisaoContratual\" mascara-conversor-string-para-data \nng-model=\"vm.contratoItem.dataRiscoRescisaoContratual\" ng-mask=\"3?9/1?9/9999\" ng-disabled=\"true\"></md-datepicker>\n</md-input-container></div><div layout=\"row\" style=\"margin-top: -35px\"><md-input-container flex><label>Motivo do risco\n</label><md-select ng-model=\"vm.contratoItem.motivoRiscoContratualCodigo\" name=\"motivoRiscoContratualCodigo\" \nng-required=\"vm.contratoItem.riscoRescisaoContratual\" \nng-disabled=\"!vm.contratoItem.riscoRescisaoContratual && vm.emProgresso \r\n                                 || vm.apenasVisualizacao \r\n                                 || vm.contratoItem.contratoItemDadosSigiloso.situacaoItem != 1\" \nmd-on-open=\"vm.metodos.configuraMdSelectMotivoRiscoContratualCodigo()\"><md-select-header><input \nid=\"dialog-contrato-item-motivo-risco-contratual-md-select\" class=\"md-text\" \nng-model=\"vm.filtroMotivoRiscoContratualCodigo\" type=\"search\" placeholder=\"Pesquisar motivo de risco\" translate \ntranslate-attr-placeholder=\"Pesquisar motivo de risco\"></md-select-header><md-option ng-value=\"motivo.codigo\" \nng-repeat=\"motivo in vm.listaMotivosRiscoContratual | filter: vm.metodos.filtrarMotivoRiscoContratualCodigo track by motivo.codigo\">\n{{motivo.descricao}}</md-option></md-select><div ng-messages=\"vm.form.motivoRiscoContratualCodigo.$error\"><div \nng-message=\"required\" translate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container>\n<md-autocomplete md-input-name=\"atendimento\" md-floating-label=\"Atendimento\" md-no-cache=\"true\" \nmd-selected-item=\"vm.contratoItem.atendimento\" \nmd-selected-item-change=\"vm.metodos.alterarItemSelecionadoAutoCompleteAtendimento(item)\" \nmd-search-text=\"vm.textoDePesquisaAutoCompleteAtendimento\" \nmd-items=\"item in vm.metodos.pesquisarAutoCompleteAtendimento(vm.textoDePesquisaAutoCompleteAtendimento)\" \nmd-item-text=\"item\" md-autoselect \nng-disabled=\"(!vm.contratoItem.riscoRescisaoContratual && vm.acaoPosRescisao) && vm.emProgresso \r\n                             || vm.apenasVisualizacao \r\n                             || vm.contratoItem.contratoItemDadosSigiloso.situacaoItem != 1\" \nflex><md-item-template><span md-highlight-text=\"vm.textoDePesquisaAutoCompleteAtendimento\">{{ item }}</span>\n</md-item-template><md-not-found><label>Não foi encontrado nenhum atendimento.</label></md-not-found><div \nng-messages=\"vm.form.atendimento.$error\"><div ng-message=\"required\" translate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\">\n</div></div></md-autocomplete><div style=\"display: flex; align-items: center; justify-content: center\"><i \nclass=\"icon-open-in-new s18 icone-cor-padrao ml-5\" \nng-click=\"vm.metodos.visualizarAtendimento(vm.contratoItem.atendimento)\" ng-if=\"vm.contratoItem.atendimento\" \nstyle=\"margin-bottom: 5px\"><md-tooltip><label>Visualizar atendimento</label></md-tooltip></i></div></div></div>\n</fieldset><fieldset flex><legend><label>Validação</label></legend><div class=\"altura-fildset\" layout=\"row\">\n<md-input-container class=\"md-block\" flex><label translate=\"CLIENTE.ULTIMA_CHAVE_VALIDACAO\"></label><input type=\"text\" \nname=\"ultimaChaveValidacao\" mascara-campo-generica=\"##.##.##.##.##.##\" ng-model=\"vm.contratoItem.ultimaChaveValidacao\" \nng-minlength=\"17\" ng-disabled=\"vm.emProgresso || vm.apenasVisualizacao\"><div \nng-messages=\"vm.form.ultimaChaveValidacao.$error\"><div ng-message=\"minlength\" \ntranslate=\"CLIENTE.ULTIMA_CHAVE_VALIDACAO_INVALIDO\"></div></div></md-input-container><md-input-container \nclass=\"md-block container-data\" flex><label translate=\"CLIENTE.DATA_ULTIMA_VALIDACAO\"></label><md-datepicker \nname=\"dataUltimaValidacao\" mascara-conversor-string-para-data ng-model=\"vm.contratoItem.dataUltimaValidacao\" \nng-mask=\"3?9/1?9/9999\" ng-disabled=\"vm.emProgresso || vm.apenasVisualizacao\"></md-datepicker><div \nng-messages=\"vm.form.dataUltimaValidacao.$error\"><div ng-message=\"valid\" translate=\"MENSAGEM_VALIDACAO.DATA_INVALIDA\">\n</div></div></md-input-container><md-input-container class=\"md-block container-data\" flex><label \ntranslate=\"CLIENTE.DATA_EXPIRACAO\"></label><md-datepicker name=\"dataExpiracao\" mascara-conversor-string-para-data \nng-model=\"vm.contratoItem.dataExpiracao\" ng-mask=\"3?9/1?9/9999\" \nng-disabled=\"vm.emProgresso || vm.apenasVisualizacao || !vm.usuarioPermiteEdicaoExpiracaoLicenca\"></md-datepicker><div \nng-messages=\"vm.form.dataExpiracao.$error\"><div ng-message=\"valid\" translate=\"MENSAGEM_VALIDACAO.DATA_INVALIDA\"></div>\n</div></md-input-container></div></fieldset><fieldset><legend><label>Controle de versão</label></legend><div \nclass=\"altura-fildset\" layout=\"row\"><md-input-container class=\"md-block controle-versao\"><label \ntranslate=\"CLIENTE.VERSAO\"></label><input type=\"text\" name=\"versao\" mascara-tamanho-campo=\"15\" \nng-model=\"vm.contratoItem.versao\" ng-disabled=\"vm.emProgresso || vm.apenasVisualizacao\"></md-input-container>\n<md-input-container class=\"md-block container-data\"><label translate=\"CLIENTE.DATA_ATUALIZACAO\"></label><md-datepicker \nclass=\"data-atualizacao\" name=\"dataAtualizacao\" mascara-conversor-string-para-data \nng-model=\"vm.contratoItem.dataAtualizacao\" ng-mask=\"3?9/1?9/9999\" \nng-disabled=\"vm.emProgresso || vm.apenasVisualizacao\"></md-datepicker><div \nng-messages=\"vm.form.dataAtualizacao.$error\"><div ng-message=\"valid\" translate=\"MENSAGEM_VALIDACAO.DATA_INVALIDA\">\n</div></div></md-input-container></div></fieldset><div id=\"cliente-equipamentos-locados\" class=\"fildset-div\" \nlayout-align=\"center center\" flex><fieldset class=\"standard\" flex \nng-if=\"!vm.resumoEquipamentosPorContrato.length <= 0\" ng-show=\"vm.editar || vm.apenasVisualizar\"><legend><label>\nEquipamentos</label></legend><div class=\"container-equipamento\" layout=\"row\" layout-align=\"space-around center\" flex>\n<md-card class=\"itemEquipamento\" ng-repeat=\"resumo in vm.resumoEquipamentosPorContrato\"><md-card-header \nlayout=\"column\" flex><div class=\"header-titulo\" layout=\"row\" layout-align=\"center center\" flex><strong><span \nclass=\"font-size-20 textos-span\">{{ resumo.equipamentoTipo }}</span></strong><md-button \nclass=\"md-icon-button botao-flutuante\" ng-click=\"vm.metodos.abrirDialogDetalhes(resumo.equipamentos)\" \nng-disabled=\"vm.emProgresso\"><i class=\"icon-book-multiple s24\" ng-class=\"{ \'icone-cor-padrao\': !vm.emProgresso }\"></i>\n<md-tooltip><span>Detalhamento dos equipamentos</span></md-tooltip></md-button></div><hr class=\"solid\"><div \nclass=\"text-center container-quantidade\" layout=\"column\" layout-align=\"center center\" flex><span class=\"textos-span\">\nQUANTIDADE</span> <strong><span class=\"font-size-30 textos-span\">{{resumo.quantidade}}</span></strong></div>\n</md-card-header></md-card></div></fieldset></div></md-dialog-content><md-dialog-actions layout=\"column\" \nlayout-gt-sm=\"row\" layout-align=\"space-between center\" ng-if=\"!vm.apenasVisualizacao\"><div layout=\"row\" \nlayout-align=\"start center\"><md-button class=\"send-button md-accent md-raised\" type=\"submit\" aria-label=\"SALVAR\" \ntranslate=\"CLIENTE.SALVAR\" translate-attr-aria-label=\"CLIENTE.SALVAR\" ng-click=\"vm.metodos.salvar(vm.contratoItem)\" \nng-disabled=\"vm.emProgresso || vm.form.$invalid\">Salvar</md-button></div></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/geral/processamento/controle-horas-trabalhadas/views/tabs/historico-viagem/dialogs/adicionar-historico-viagem/adicionar-historico-viagem-dialog.html","<md-dialog class=\"compose-dialog\" aria-label=\"New Message\"><form ng-submit=\"vm.metodos.enviarMensagem()\" \nname=\"vm.form\" class=\"md-inline-form\" novalidate><md-toolbar class=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" \nlayout=\"row\" layout-align=\"space-between center\"><span class=\"title\">{{vm.tituloDialog}}</span><md-button \nclass=\"md-icon-button\" ng-click=\"vm.metodos.closeDialog()\" aria-label=\"Close dialog\" tranlate \ntranslate-aria-label=\"MAIL.CLOSE_DIALOG\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar>\n<md-progress-linear class=\"md-accent\" ng-show=\"vm.enviando\" md-mode=\"indeterminate\"></md-progress-linear>\n<md-dialog-content ms-scroll><div layout-gt-xs=\"row\" style=\"margin-left: 20px\"><md-autocomplete flex \nmd-input-name=\"cliente\" md-no-cache=\"true\" ng-required=\"true\" \nng-blur=\"vm.metodos.configuraAutoCompleteClienteOnBlur()\" md-selected-item=\"vm.entidade.cliente\" \nmd-selected-item-change=\"vm.metodos.alterarItemSelecionadoAutoCompleteCliente(item)\" \nmd-search-text=\"vm.textoDePesquisaAutoCompleteCliente\" \nmd-items=\"item in vm.metodos.pesquisarAutoCompleteCliente(vm.textoDePesquisaAutoCompleteCliente)\" \nmd-item-text=\"item.codigo + \' - \' + item.nome\" md-autoselect md-floating-label=\"Cliente | Empresa de destino\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.inserirAtivo\r\n                                                                                     || vm.controleForm.emProgresso\">\n<md-item-template><span md-highlight-text=\"vm.textoDePesquisaAutoCompleteCliente\">{{item.codigo}} - {{item.nome}}\n</span></md-item-template><md-not-found><label>Não foi encontrado nenhum Cliente.</label></md-not-found><div \nng-messages=\"vm.form.cliente.$error\"><div ng-message=\"required\" translate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div>\n</div></md-autocomplete></div><div layout-gt-xs=\"row\"><md-input-container flex-gt-sm=\"25\"><label \ntranslate=\"PROCESSAMENTO.DATA_SAIDA\"></label><md-datepicker ng-model=\"vm.entidade.dataSaida\" \nng-change=\"vm.metodos.verificaDataSaida()\" flex md-min-date=\"vm.dataMinima\" md-max-date=\"vm.dataMaxima\" \nng-required=\"true\" name=\"dataSaida\" mascara-conversor-string-para-data ng-mask=\"3?9/1?9/9999\"></md-datepicker><div \nng-messages=\"vm.form.dataSaida.$error\"><div ng-message=\"valid\" translate=\"MENSAGEM_VALIDACAO.DATA_INVALIDA\"></div><div \nng-message=\"mindate\" translate=\"MENSAGEM_VALIDACAO.CAMPO_DATA_FINAL\"></div><div ng-message=\"required\" \ntranslate=\"PROCESSAMENTO.CAMPO_OBRIGATORIO\"></div></div></md-input-container><md-input-container flex-gt-sm=\"30\"><label\n translate=\"PROCESSAMENTO.HORA_SAIDA\"></label><input type=\"text\" ng-model=\"vm.entidade.horaSaida\" name=\"horaSaida\" \nng-required=\"true\" mascara-numero-generica=\"##:##:##\" \npattern=\"^(([2]{1}[0-3]{1}){1}|([0-1]{1}[0-9]){1}){1}:[0-5]{1}[0-9]{1}:[0-5]{1}[0-9]{1}$\"><div \nng-messages=\"vm.form.horaSaida.$error\"><div ng-message=\"required\" translate=\"PROCESSAMENTO.CAMPO_OBRIGATORIO\"></div>\n<div ng-message=\"pattern\" translate=\"PROCESSAMENTO.TEMPO_INVALIDO\"></div></div></md-input-container><md-autocomplete \nflex md-input-name=\"cidadeOrigem\" md-no-cache=\"true\" ng-blur=\"vm.metodos.configuraAutoCompleteCidadeOnBlurOrigem()\" \nng-required=\"true\" md-selected-item=\"vm.entidade.cidadeOrigem\" \nmd-selected-item-change=\"vm.metodos.alterarItemSelecionadoAutoCompleteCidadeOrigem(item)\" \nmd-search-text=\"vm.textoDePesquisaAutoCompleteCidadeOrigem\" \nmd-items=\"item in vm.metodos.pesquisarAutoCompleteCidade(vm.textoDePesquisaAutoCompleteCidadeOrigem)\" \nmd-item-text=\"item.descricao\" md-autoselect md-floating-label=\"Cidade Origem\"><md-item-template><span \nmd-highlight-text=\"vm.textoDePesquisaAutoCompleteCidadeOrigem\">{{item.descricao}}</span></md-item-template>\n<md-not-found><label>Não foi encontrado nenhuma Cidade.</label></md-not-found><div \nng-messages=\"vm.form.cidadeOrigem.$error\"><div ng-message=\"required\" translate=\"PROCESSAMENTO.CAMPO_OBRIGATORIO\"></div>\n</div></md-autocomplete></div><div layout-gt-xs=\"row\"><md-input-container flex-gt-sm=\"25\"><label \ntranslate=\"PROCESSAMENTO.DATA_ENTRADA\"></label><md-datepicker ng-change=\"vm.metodos.verificaDataChegada()\" \nng-model=\"vm.entidade.dataChegada\" ng-required=\"true\" md-max-date=\"vm.dataMaxima\" md-min-date=\"vm.entidade.dataSaida\" \nname=\"dataChegada\" mascara-conversor-string-para-data ng-mask=\"3?9/1?9/9999\"></md-datepicker><div \nng-messages=\"vm.form.dataChegada.$error\"><div ng-message=\"valid\" translate=\"MENSAGEM_VALIDACAO.DATA_INVALIDA\"></div>\n<div ng-message=\"required\" translate=\"PROCESSAMENTO.CAMPO_OBRIGATORIO\"></div></div></md-input-container>\n<md-input-container flex-gt-sm=\"30\"><label translate=\"PROCESSAMENTO.HORA_CHEGADA\"></label><input type=\"text\" \nng-model=\"vm.entidade.horaChegada\" name=\"horaChegada\" ng-required=\"true\" mascara-numero-generica=\"##:##:##\" \npattern=\"^(([2]{1}[0-3]{1}){1}|([0-1]{1}[0-9]){1}){1}:[0-5]{1}[0-9]{1}:[0-5]{1}[0-9]{1}$\"><div \nng-messages=\"vm.form.horaChegada.$error\"><div ng-message=\"pattern\" translate=\"PROCESSAMENTO.TEMPO_INVALIDO\"></div><div \nng-message=\"required\" translate=\"PROCESSAMENTO.CAMPO_OBRIGATORIO\"></div></div></md-input-container><md-autocomplete \nflex md-input-name=\"cidadeDestino\" md-no-cache=\"true\" ng-blur=\"vm.metodos.configuraAutoCompleteCidadeOnBlurDestino()\" \nng-required=\"true\" md-selected-item=\"vm.entidade.cidadeDestino\" \nmd-selected-item-change=\"vm.metodos.alterarItemSelecionadoAutoCompleteCidadeDestino(item)\" \nmd-search-text=\"vm.textoDePesquisaAutoCompleteCidadeDestino\" \nmd-items=\"item in vm.metodos.pesquisarAutoCompleteCidade(vm.textoDePesquisaAutoCompleteCidadeDestino)\" \nmd-item-text=\"item.descricao\" md-autoselect md-floating-label=\"Cidade Destino\"><md-item-template><span \nmd-highlight-text=\"vm.textoDePesquisaAutoCompleteCidadeDestino\">{{item.descricao}}</span></md-item-template>\n<md-not-found><label>Não foi encontrado nenhuma Cidade.</label></md-not-found><div \nng-messages=\"vm.form.cidadeDestino.$error\"><div ng-message=\"required\" translate=\"PROCESSAMENTO.CAMPO_OBRIGATORIO\">\n</div></div></md-autocomplete></div></md-dialog-content><md-dialog-actions layout=\"column\" layout-align=\"end end\">\n<md-button type=\"submit\" ng-click=\"vm.metodos.salvar($event)\" class=\"send-button md-accent md-raised\" \nng-disabled=\"vm.form.$invalid\r\n                                    || vm.enviando\" aria-label=\"SALVAR\" \ntranslate=\"PROCESSAMENTO.SALVAR\" translate-attr-aria-label=\"PROCESSAMENTO.SALVAR\">Salvar</md-button>\n</md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/geral/processamento/controle-horas-trabalhadas/views/tabs/historico-viagem/dialogs/registro-ponto-dialog/registro-ponto-dialog.html","<md-dialog class=\"compose-dialog\" aria-label=\"New Message\"><form ng-submit=\"vm.metodos.enviarMensagem()\" \nname=\"vm.form\" class=\"md-inline-form\" novalidate><md-toolbar class=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" \nlayout=\"row\" layout-align=\"space-between center\"><span class=\"title\">{{vm.tituloDialog}}</span><md-button \nclass=\"md-icon-button\" ng-click=\"vm.metodos.closeDialog()\" aria-label=\"Close dialog\" tranlate \ntranslate-aria-label=\"MAIL.CLOSE_DIALOG\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar>\n<md-progress-linear class=\"md-accent\" ng-show=\"vm.controleForm.emProgresso\" md-mode=\"indeterminate\">\n</md-progress-linear><md-dialog-content ms-scroll><div layout=\"row\" layout-align=\"center center\" id=\"target\" flex><h3>\n{{vm.cliente.nome}}</h3></div><div layout=\"column\" id=\"target\" flex><fieldset flex><legend><label \ntranslate=\"PROCESSAMENTO.REGISTRO_PONTO\"></label></legend><div layout=\"row\"><md-input-container><label \ntranslate=\"CLIENTE.DATA\"></label><md-datepicker ng-model=\"vm.ponto.data\" name=\"data\" ng-required=\"true\" \nng-mask=\"3?9/1?9/9999\" md-min-date=\"vm.intervaloData.minimo\" md-max-date=\"vm.intervaloData.maximo\"></md-datepicker><div\n ng-messages=\"vm.form.data.$error\"><div ng-message=\"valid\" translate=\"MENSAGEM_VALIDACAO.DATA_INVALIDA\"></div><div \nng-message=\"required\" translate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container></div><div \nlayout-gt-xs=\"row\" flex><md-input-container class=\"md-block select tamanho-md-select\" flex><label \ntranslate=\"PROCESSAMENTO.TECNICOS\"></label><md-select ng-model=\"vm.colaboradores\" name=\"colaboradores\" \nmultiple=\"multiple\" ng-required=\"true\" ng-model-options=\"{trackBy: \'$value.codigo\'}\" \nmd-on-open=\"vm.metodos.configuraMdSelectTecnico()\"><md-select-header><input id=\"md-select-tecnico\" class=\"md-text\" \nng-model=\"vm.filtrarTecnicos\" type=\"search\" placeholder=\"\" translate \ntranslate-attr-placeholder=\"PROCESSAMENTO.PESQUISAR\"></md-select-header><md-option ng-value=\"tecnico\" \nng-repeat=\"tecnico in vm.listaColaboradores | filter:vm.filtrarTecnicos track by tecnico.codigo\">{{tecnico.nome}}\n</md-option></md-select><div ng-messages=\"vm.form.colaboradores.$error\"><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container></div><div layout=\"row\"><div \nlayout=\"column\" flex><div fx-offset=\"5\" layout=\"row\"><fieldset flex><legend><label translate=\"PROCESSAMENTO.MANHA\">\n</label></legend><div layout=\"column\" flex><div layout=\"row\" flex><div layout=\"column\" flex><md-input-container \nflex-offset-gt-sm=\"5\"><label translate=\"PROCESSAMENTO.ENTRADA\"></label><input type=\"text\" \nng-model=\"vm.ponto.entradaManha\" name=\"entradaManha\" ng-required=\"(!vm.ponto.entradaTarde || !vm.ponto.saidaTarde)\" \nmascara-numero-generica=\"##:##:##\" \npattern=\"^(([0]{1}[0-9]{1})|([1]{1}[0-1]{1}){1}){1}:[0-5]{1}[0-9]{1}:[0-5]{1}[0-9]{1}$\"><div \nng-messages=\"vm.form.entradaManha.$error\"><div ng-message=\"pattern\" \ntranslate=\"PROCESSAMENTO.TEMPO_ENTRADA_MANHA_INVALIDO\"></div><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container></div><div layout=\"column\" flex>\n<md-input-container class=\"md-block\" flex-offset-gt-sm=\"5\"><label translate=\"PROCESSAMENTO.SAIDA\"></label><input \ntype=\"text\" ng-model=\"vm.ponto.saidaManha\" name=\"saidaManha\" ng-required=\"vm.ponto.entradaManha\" \nmascara-numero-generica=\"##:##:##\" \npattern=\"^(([2]{1}[0-3]{1}){1}|([0-1]{1}[0-9]){1}){1}:[0-5]{1}[0-9]{1}:[0-5]{1}[0-9]{1}$\"><div \nng-messages=\"vm.form.saidaManha.$error\"><div ng-message=\"pattern\" translate=\"PROCESSAMENTO.TEMPO_MANHA_INVALIDO\"></div>\n<div ng-message=\"required\" translate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container></div>\n</div></div></fieldset><fieldset flex><legend><label translate=\"PROCESSAMENTO.TARDE\"></label></legend><div \nlayout=\"column\" flex><div layout=\"row\" flex><div layout=\"column\" flex><md-input-container flex-offset-gt-sm=\"5\"><label \ntranslate=\"PROCESSAMENTO.ENTRADA\"></label><input type=\"text\" ng-model=\"vm.ponto.entradaTarde\" name=\"entradaTarde\" \nng-required=\"(!vm.ponto.entradaManha || !vm.ponto.saidaManha)\" mascara-numero-generica=\"##:##:##\" \npattern=\"^(([2]{1}[0-3]{1}){1}|([1]{1}[2-9]){1}){1}:[0-5]{1}[0-9]{1}:[0-5]{1}[0-9]{1}$\"><div \nng-messages=\"vm.form.entradaTarde.$error\"><div ng-message=\"pattern\" translate=\"PROCESSAMENTO.TEMPO_TARDE_INVALIDO\">\n</div><div ng-message=\"required\" translate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container>\n</div><div layout=\"column\" flex><md-input-container class=\"md-block\" flex-offset-gt-sm=\"5\"><label \ntranslate=\"PROCESSAMENTO.SAIDA\"></label><input type=\"text\" ng-model=\"vm.ponto.saidaTarde\" name=\"saidaTarde\" \nng-required=\"vm.ponto.entradaTarde\" mascara-numero-generica=\"##:##:##\" \npattern=\"^(([2]{1}[0-3]{1}){1}|([1]{1}[2-9]){1}){1}:[0-5]{1}[0-9]{1}:[0-5]{1}[0-9]{1}$\"><div \nng-messages=\"vm.form.saidaTarde.$error\"><div ng-message=\"pattern\" translate=\"PROCESSAMENTO.TEMPO_TARDE_INVALIDO\"></div>\n<div ng-message=\"required\" translate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container></div>\n</div></div></fieldset></div></div></div><div layout=\"row\" flex><md-input-container class=\"md-block\" flex><label \ntranslate=\"PROCESSAMENTO.OBSERVACAO\"></label><input type=\"text\" name=\"observacao\" ng-model=\"vm.ponto.observacao\" \nmascara-tamanho-campo=\"100\" md-maxlength=\"100\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\"><div \nng-messages=\"vm.form.observacao.$error\"><div ng-message=\"required\" translate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\">\n</div></div></md-input-container></div></fieldset></div><div layout=\"row\" flex layout-align=\"end center\"><md-button \nflex=\"20\" type=\"submit\" ng-click=\"vm.metodos.salvar($event)\" class=\"send-button md-accent md-raised\" \nng-disabled=\"vm.form.$invalid || vm.form.$pristine || vm.controleForm.emProgresso\" aria-label=\"SALVAR\" \ntranslate=\"PROCESSAMENTO.SALVAR\" translate-attr-aria-label=\"PROCESSAMENTO.SALVAR\">Salvar</md-button></div><md-divider \nstyle=\"margin-top: 1em\"></md-divider><div layout-gt-xs=\"row\"><table class=\"dataTable row-border hover\" datatable=\"ng\" \ndt-options=\"vm.dtOptionsHistoricoPonto\"><thead><tr><th class=\"secondary-text text-center\"><div \nclass=\"table-header text-center\"><span class=\"column-title\">Ações</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header text-center\"><span class=\"column-title\">Data</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header text-center\"><span class=\"column-title\">Manhã</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header text-center\"><span class=\"column-title\">Tarde</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header text-center\"><span class=\"column-title\">Técnicos</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header text-center\"><span class=\"column-title\">Observação</span></div></th></tr></thead><tbody><tr \nng-repeat=\"ponto in vm.pontos  track by $index\"><td class=\"text-center\" fxlayout=\"row\" class=\"button-icone-cor-azul\">\n<div fxlayout=\"row\"><i class=\"icon-pencil s16 icone-cor-padrao\" ng-click=\"vm.metodos.editar($event, ponto)\" \nng-disabled=\"vm.controleForm.emProgresso\"><md-tooltip md-autohide><span \ntranslate=\"PROCESSAMENTO.EDITAR_HISTORICO_VIAGEM\"></span></md-tooltip></i><i class=\"icon-delete s16 icone-cor-padrao\" \nng-click=\"vm.metodos.excluir($event, ponto)\" ng-disabled=\"vm.controleForm.emProgresso\"><md-tooltip md-autohide><span \ntranslate=\"PROCESSAMENTO.REMOVER_HISTORICO_VIAGEM\"></span></md-tooltip></i><i \nclass=\"icon-account-multiple s16 icone-cor-padrao\" \nng-click=\"vm.metodos.exibirColaboradores($event, ponto.colaboradores)\" ng-disabled=\"vm.controleForm.emProgresso\">\n<md-tooltip md-autohide><span translate=\"PROCESSAMENTO.TECNICOS_VINCULADOS\"></span></md-tooltip></i></div></td><td \nclass=\"text-center\">{{vm.metodos.formataData(ponto.data)}}</td><td class=\"text-center\"><div layout=\"column\"><div \nlayout=\"column\"><div layout=\"row\" layout-align=\"center center\"><span class=\"text-center\"><span class=\"texto-destaque\">\nEntrada:</span> {{ponto.entradaManha}}</span></div></div><div layout=\"column\" layout-align=\"center center\"><div \nlayout=\"row\"><span class=\"text-center\"><span class=\"texto-destaque\"></span>Saída:</span> {{ponto.saidaManha}}</div>\n</div></div></td><td class=\"text-center\"><div layout=\"column\"><div layout=\"row\" layout-align=\"center center\"><span \nclass=\"text-center\"><span class=\"texto-destaque\">Entrada:</span> {{ponto.entradaTarde}}</span></div><div layout=\"row\" \nlayout-align=\"center center\"><span class=\"text-center\"><span class=\"texto-destaque\">Saída:</span> {{ponto.saidaTarde}}\n</span></div></div></td><td class=\"text-center\"><div \nng-bind-html=\"vm.metodos.preparaColaboradoresNaTabela(ponto.colaboradores)\"></div></td><td class=\"text-center\"><p \nstyle=\"width: 15em; max-width: 100%;text-align: justify; word-wrap: break-word\">{{ponto.observacao}}</p></td></tr>\n</tbody></table></div></md-dialog-content></form></md-dialog>");
$templateCache.put("app/main/geral/cadastro/cliente/cliente/views/tabs/pessoal-de-referencia/dialog/cliente-dialog-pessoa-de-referencia.html","<md-dialog id=\"cliente-dialog-pessoa-de-referencia\" class=\"dialogo-padrao\" aria-label=\"Dialog\"><md-button \nclass=\"md-icon-button button-flutuante\" ng-click=\"vm.metodosDialog.fecharDialog()\" aria-label=\"Fechar dialog\"><md-icon \nmd-font-icon=\"icon-close\" class=\"cor-icone-button-flutuante s26\"></md-icon><md-tooltip>Fechar Dialog</md-tooltip>\n</md-button><div class=\"scrollable\" ms-scroll ui-view=\"pessoa@app.geral_cadastro_cliente_cliente\"></div></md-dialog>");
$templateCache.put("app/main/geral/cadastro/solucao/solucao/views/tabs/rotinas/dialog-editar-inserir/solucao-rotinas-tarefas-dialog-rotinas.html","<md-dialog class=\"dialogo-padrao\" aria-label=\"Dialog\"><form name=\"rotinasForm\" class=\"md-inline-form\" novalidate>\n<md-toolbar class=\"md-accent md-tall\" layout=\"column\"><div class=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" \nlayout-align=\"space-between center\"><span class=\"title\">{{vm.titulo}}</span><md-button class=\"md-icon-button\" \nng-click=\"vm.metodosDialogRotinas.fecharDialog()\" aria-label=\"Fechar dialog\" translate \ntranslate-attr-aria-label=\"SOLUCAO_ROTINAS_TAREFAS.FECHAR_DIALOG\"><md-icon md-font-icon=\"icon-close\"></md-icon>\n</md-button></div></md-toolbar><div layout=\"row\" layout-sm=\"row\" layout-align=\"center\" \nng-show=\"vm.requisicaSolicitada || vm.preloader.habilitar\"><md-progress-circular md-mode=\"indeterminate\" \nclass=\"md-accent\"></md-progress-circular></div><md-dialog-content \nng-hide=\"vm.requisicaSolicitada || vm.preloader.habilitar\"><div layout-gt-xs=\"row\"><md-input-container \nclass=\"md-block\" flex-gt-sm><label translate=\"SOLUCAO_ROTINAS_TAREFAS.DESCRICAO\"></label><input type=\"text\" \nng-model=\"vm.rotina.descricao\" name=\"rotinaDescricao\" mascara-tamanho-campo=\"50\" ng-required=\"true\" md-maxlength=\"50\">\n<div ng-messages=\"rotinasForm.rotinaDescricao.$error\"><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container></div></md-dialog-content>\n<md-dialog-actions layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\">\n<md-button type=\"submit\" ng-click=\"vm.metodosDialogRotinas.salvar(vm.rotina)\" class=\"send-button md-accent md-raised\" \nng-disabled=\"rotinasForm.$invalid || rotinasForm.$pristine || vm.requisicaSolicitada\" aria-label=\"SALVAR\" \ntranslate=\"SOLUCAO_ROTINAS_TAREFAS.SALVAR\" translate-attr-aria-label=\"SOLUCAO_ROTINAS_TAREFAS.SALVAR\"></md-button>\n</div><div layout=\"row\"><md-button class=\"md-icon-button\" \nng-click=\"vm.metodosDialogRotinas.excluir(vm.rotina, $event)\" aria-label=\"Excluir\" ng-hide=\"vm.inserirAtivo\" \nng-disabled=\"vm.requisicaSolicitada\" translate translate-attr-aria-label=\"SOLUCAO_ROTINAS_TAREFAS.EXCLUIR\"><md-icon \nmd-font-icon=\"icon-delete\"></md-icon></md-button></div></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/geral/cadastro/solucao/solucao/views/tabs/tarefas/dialog-editar-inserir/solucao-rotinas-tarefas-dialog-tarefas.html","<md-dialog class=\"dialogo-padrao\" aria-label=\"Dialog\"><form name=\"tarefasForm\" class=\"md-inline-form\" novalidate>\n<md-toolbar class=\"md-accent md-tall\" layout=\"column\"><div class=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" \nlayout-align=\"space-between center\"><span class=\"title\">{{vm.titulo}}</span><md-button class=\"md-icon-button\" \nng-click=\"vm.metodosDialogTarefas.fecharDialog()\" aria-label=\"Fechar dialog\" translate \ntranslate-attr-aria-label=\"SOLUCAO_ROTINAS_TAREFAS.FECHAR_DIALOG\"><md-icon md-font-icon=\"icon-close\"></md-icon>\n</md-button></div></md-toolbar><div layout=\"row\" layout-sm=\"row\" layout-align=\"center\" \nng-show=\"vm.requisicaSolicitada || vm.preloader.habilitar\"><md-progress-circular md-mode=\"indeterminate\" \nclass=\"md-accent\"></md-progress-circular></div><md-dialog-content \nng-hide=\"vm.requisicaSolicitada || vm.preloader.habilitar\"><div layout-gt-xs=\"row\"><md-input-container \nclass=\"md-block\" flex-gt-sm=\"30\"><label translate=\"SOLUCAO_ROTINAS_TAREFAS.TIPO_TAREFA\">Tipo Tarefa</label><md-select \nng-model=\"vm.tarefa.tipo\" name=\"tarefaTipoTarefa\" ng-required=\"vm.inserirAtivo\"><md-option ng-value=\"key\" \nng-repeat=\"(key, value) in vm.tiposTarefa\">{{value}}</md-option></md-select><div \nng-messages=\"tarefasForm.tarefaTipoTarefa.$error\"><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container><md-input-container class=\"md-block\" \nflex-offset=\"10\" flex-gt-sm=\"20\"><label translate=\"SOLUCAO_ROTINAS_TAREFAS.TAREFA_PONTOS\"></label><input type=\"text\" \nng-model=\"vm.tarefa.pontos\" name=\"tarefaPontos\" mascara-numeros=\"3\"><div ng-messages=\"tarefasForm.tarefaPontos.$error\">\n<div ng-message=\"required\" translate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container>\n<md-input-container class=\"md-block\" flex-offset=\"5\"><md-checkbox ng-model=\"vm.tarefa.aprovada\" \naria-label=\"Tarefa Aprovada\" name=\"tarefaAprovada\"><span translate=\"SOLUCAO_ROTINAS_TAREFAS.TAREFA_APROVADA\">\nTarefa Aprovada</span></md-checkbox></md-input-container></div><div layout-gt-xs=\"row\"><md-input-container \nclass=\"md-block\" flex-gt-sm><label translate=\"SOLUCAO_ROTINAS_TAREFAS.DESCRICAO\"></label><input type=\"text\" \nng-model=\"vm.tarefa.descricao\" name=\"tarefaDescricao\" mascara-tamanho-campo=\"150\" ng-required=\"true\" \nmd-maxlength=\"150\"><div ng-messages=\"tarefasForm.tarefaDescricao.$error\"><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container></div><div layout-gt-xs=\"row\"></div>\n</md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" \nlayout-align=\"start center\"><md-button type=\"submit\" ng-click=\"vm.metodosDialogTarefas.salvar(vm.tarefa, $event)\" \nclass=\"send-button md-accent md-raised\" \nng-disabled=\"tarefasForm.$invalid || tarefasForm.$pristine || vm.requisicaSolicitada\" aria-label=\"SALVAR\" \ntranslate=\"SOLUCAO_ROTINAS_TAREFAS.SALVAR\" translate-attr-aria-label=\"SOLUCAO_ROTINAS_TAREFAS.SALVAR\"></md-button>\n</div><div layout=\"row\"><md-button type=\"submit\" class=\"md-icon-button\" \nng-click=\"vm.metodosDialogTarefas.excluir(vm.tarefa, $event)\" aria-label=\"Excluir\" ng-hide=\"vm.inserirAtivo\" \nng-disabled=\"vm.requisicaSolicitada\" translate translate-attr-aria-label=\"SOLUCAO_ROTINAS_TAREFAS.EXCLUIR\"><md-icon \nmd-font-icon=\"icon-delete\"></md-icon></md-button></div></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/implantacao-migracao/processamento/processos-funis/processo-funil/views/dialogs/dialog-processo/tabs/tab-atividades-processo.html","<div id=\"tab-atividades\" layout=\"column\" flex><div layout=\"row\" flex \nng-repeat=\"atividade in  vm.subprocesso.atividadesTarefas\" \nng-if=\"atividade.codigoTarefa == vm.subprocesso.codigoTarefaAtual\"><fieldset class=\"container-fieldset\">\n<md-input-container class=\"m-0\" layout-align=\"center center\"><md-checkbox ng-model=\"atividade.atividadeFinalizada\">\n<span>{{atividade.atividade.descricao}}</span><md-tooltip md-autohide ng-if=\"!atividade.atividadeFinalizada\">\nFinalizar atividade</md-tooltip></md-checkbox></md-input-container></fieldset></div></div>");
$templateCache.put("app/main/implantacao-migracao/processamento/processos-funis/processo-funil/views/dialogs/dialog-processo/tabs/tab-dados-processo.html","<div layout=\"column\" flex><div layout=\"row\" flex><md-autocomplete flex=\"50\" md-input-name=\"cliente\" md-no-cache=\"true\" \nng-required=\"true\" ng-blur=\"vm.metodos.configuraAutoCompleteClienteOnBlur()\" md-selected-item=\"vm.subprocesso.cliente\" \nmd-selected-item-change=\"vm.metodos.alterarItemSelecionadoAutoCompleteCliente(item)\" \nmd-search-text=\"vm.textoDePesquisaAutoCompleteCliente\" \nmd-items=\"item in vm.metodos.pesquisarAutoCompleteCliente(vm.textoDePesquisaAutoCompleteCliente)\" \nmd-item-text=\"item.codigo + \' - \' + item.nome\" md-autoselect md-floating-label=\"Cliente\" \nng-disabled=\"!vm.novaEntidade\"><md-item-template><span md-highlight-text=\"vm.textoDePesquisaAutoCompleteCliente\">\n{{item.codigo}} - {{item.nome}}</span></md-item-template><md-not-found><label>Não foi encontrado nenhum Cliente.\n</label></md-not-found><div ng-messages=\"vm.form.cliente.$error\"><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-autocomplete><md-input-container class=\"md-block\" \nflex-gt-sm=\"50\"><label translate=\"Solução\"></label><md-select ng-model=\"vm.subprocesso.codigoSolucao\" \nmd-on-open=\"vm.metodos.configuraMdSelectSolucao()\" name=\"solucao\" ng-required=\"true\" \nng-disabled=\"vm.requisicaoSolicitada\"><md-select-header><input id=\"implantacao-migracao-dialog-solucao-md-select\" \nclass=\"md-text\" ng-model=\"vm.filtrarSolucoes\" type=\"search\" placeholder=\"Solução\"></md-select-header><md-option \nng-value=\"solucao.codigo\" ng-repeat=\"solucao in vm.solucoes | filter:vm.filtrarSolucoes track by solucao.codigo\">\n{{solucao.descricao}}</md-option></md-select><div ng-messages=\"vm.form.solucao.$error\"><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container></div><div layout=\"row\">\n<md-input-container class=\"md-block\" flex-gt-sm=\"50\"><label translate=\"CLIENTE.EXECUTIVO_DE_CONTAS\"></label><md-select \nng-model=\"vm.subprocesso.codigoExecutivoContasResponsavel\" name=\"executivoContasResponsavel\" ng-required=\"true\" \nng-disabled=\"vm.requisicaoSolicitada\"><md-option ng-value=\"usuario.codigo\" \nng-repeat=\"usuario in vm.executivosResponsaveis | orderBy: \'login\' track by usuario.codigo\">{{usuario.login}}\n</md-option></md-select></md-input-container><md-input-container class=\"md-block\" flex-gt-sm=\"50\"><label \ntranslate=\"Técnico Responsável\"></label><md-select ng-model=\"vm.subprocesso.codigoTecnicoResponsavel\" \nname=\"tecnicoResponsavel\" ng-required=\"false\" ng-disabled=\"vm.requisicaoSolicitada\"><md-option></md-option><md-option \nng-value=\"usuario.codigo\" ng-repeat=\"usuario in vm.tecnicos | orderBy: \'login\' track by usuario.codigo\">\n{{usuario.login}}</md-option></md-select></md-input-container></div><div layout=\"row\"><md-input-container \nclass=\"md-block campo-tarefa\" flex><label translate=\"Tarefa\"></label><md-select ng-model=\"vm.tarefaAtual\" \nname=\"tarefa\" ng-required=\"true\" ng-model-options=\"{trackBy: \'$value.codigo\'}\" \nng-change=\"vm.metodos.atualizarTarefaAtualSubprocesso(vm.tarefaAtual)\" ng-disabled=\"vm.requisicaoSolicitada\"><md-option\n ng-value=\"tarefa\" ng-repeat=\"tarefa in vm.tarefasFunil\"><span ng-if=\"!tarefa.permiteAlteracao\">{{tarefa.descricao}}\n</span> <span ng-if=\"tarefa.permiteAlteracao\">{{tarefa.nivel}} - {{tarefa.descricao}}</span></md-option></md-select>\n<div ng-messages=\"vm.form.tarefa.$error\"><div ng-message=\"required\" translate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\">\n</div></div></md-input-container><md-input-container class=\"md-block\" flex=\"20\"><label translate=\"Data inicial\">\n</label><md-datepicker ng-model=\"vm.subprocesso.dataInicial\" name=\"dataInicial\" mascara-conversor-string-para-data \nng-mask=\"3?9/1?9/9999\" ng-required=\"true\" \nng-change=\"vm.metodos.atualizarDataFinalQuandoInserindo(vm.subprocesso.dataInicial)\" \nng-disabled=\"vm.requisicaoSolicitada || !(vm.novaEntidade && vm.tarefaAtual)\"></md-datepicker><md-tooltip \nng-if=\"vm.novaEntidade && !vm.tarefaAtual\"><span translate=\"Informe a tarefa\"></span></md-tooltip><div \nng-messages=\"vm.form.dataInicial.$error\"><div ng-message=\"valid\" translate=\"MENSAGEM_VALIDACAO.DATA_INVALIDA\"></div>\n<div ng-message=\"required\" translate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container>\n<md-input-container class=\"md-block largura-campo-data-final\" flex=\"25\"><label translate=\"Vencimento tarefa\"></label>\n<md-datepicker ng-model=\"vm.subprocesso.dataFinalTarefa\" name=\"dataFinal\" mascara-conversor-string-para-data \nmd-min-date=\"vm.subprocesso.dataInicial\" ng-mask=\"3?9/1?9/9999\" ng-disabled=\"true\" ng-required=\"true\"></md-datepicker>\n<div ng-messages=\"vm.form.dataFinal.$error\"><div ng-message=\"valid\" translate=\"MENSAGEM_VALIDACAO.DATA_INVALIDA\"></div>\n<div ng-message=\"mindate\" translate=\"MENSAGEM_VALIDACAO.CAMPO_DATA_FINAL\"></div><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container><md-input-container \nclass=\"md-block proximo-codigo\" style=\"margin-left: -15px\"><md-button class=\"md-icon-button\" \nng-click=\"vm.metodos.reagendarDataFinalEtapa($event, vm.subprocesso.dataFinalTarefa)\" \naria-label=\"Reagendar data vencimento\"><md-icon md-font-icon=\"icon-arrow-right-bold-hexagon-outline s30\"></md-icon>\n<md-tooltip><span>Reagendar data vencimento</span></md-tooltip></md-button></md-input-container></div><div \nlayout=\"row\"><md-input-container class=\"md-block\" ng-disabled=\"vm.requisicaoSolicitada\" flex><label \ntranslate=\"Atendimento\"></label><md-select ng-model=\"vm.atendimento\" name=\"atendimento\" \nmd-on-open=\"vm.metodos.configuraMdSelectAtendimento()\" md-on-close=\"vm.metodos.configurarMdSelectAtendimentoOnClose()\" \nng-change=\"vm.metodos.selecionarAtendimento(vm.atendimento)\" \nng-disabled=\"(!vm.subprocesso.cliente && !vm.subprocesso.codigoCliente) || vm.requisicaoSolicitada\" ng-required=\"true\">\n<md-select-header><input id=\"implantacao-migracao-subprocesso-atendimento-md-select\" \nng-if=\"vm.atendimentos && vm.atendimentos.length > 0\" class=\"md-text\" ng-model=\"vm.filtrarAtendimentos\" type=\"search\" \nplaceholder=\"\" translate translate-attr-placeholder=\"PIPELINE_NEGOCIO.PESQUISAR_ATENDIMENTOS\"> <span \nng-if=\"(!vm.atendimentos || vm.atendimentos.length == 0) && !vm.requisicaoSolicitada\">\nNão existe atendimentos vinculados ao cliente</span></md-select-header><md-option ng-value=\"atendimento\" \nng-if=\"vm.atendimentos && vm.atendimentos.length > 0\" \nng-repeat=\"atendimento in vm.atendimentos | filter:vm.filtrarAtendimentos\">\n{{atendimento.codigo}}/{{atendimento.ano}} - {{vm.metodos.listarAssuntoAtendimento(atendimento.assunto)}}</md-option>\n</md-select><md-tooltip ng-if=\"!vm.subprocesso.cliente && !vm.subprocesso.codigoCliente\"><span \ntranslate=\"PIPELINE_NEGOCIO.INFORMAR_CLIENTE\"></span></md-tooltip><div ng-messages=\"vm.form.atendimento.$error\"><div \nng-message=\"required\" translate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container></div><div \nlayout=\"row\"><md-input-container class=\"md-block\" flex><label translate=\"PIPELINE_NEGOCIO.OBSERVACAO\"></label><textarea\n ng-model=\"vm.subprocesso.observacao\" name=\"observacao\" ng-disabled=\"vm.requisicaoSolicitada\" md-no-resize=\"true\" \nrows=\"3\" max-rows=\"5\">\r\n            </textarea></md-input-container></div></div>");
$templateCache.put("app/main/implantacao-migracao/processamento/processos-funis/processo-funil/views/dialogs/dialog-processo/tabs/tab-historico-processo.html","<div layout=\"column\" flex><div class=\"fullpage-datatable\" layout=\"column\" flex><table \nclass=\"dataTable row-border hover\" datatable=\"ng\" dt-options=\"vm.dtOptions\" style=\"width: 100%\"><thead><tr><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Data</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Tarefa anterior</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Usuário</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Motivo</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Finalizada</span></div></th></tr></thead>\n<tbody><tr ng-repeat=\"historico in vm.subprocesso.subProcessoHistoricos\"><td><span ng-hide=\"true\">{{ historico.data }}\n</span> {{historico.data | date:\'dd/MM/yyyy HH:mm:ss\'}}</td><td>\n{{vm.metodos.retornarDescricaoTarefa(historico.codigoTarefa)}}</td><td>\n{{vm.metodos.retornarNomeUsuario(historico.codigoUsuario)}}</td><td class=\"historico-observacao\">\n{{historico.observacao}}</td><td><span ng-if=\"historico.tarefaFinalizada\">SIM</span> <span \nng-if=\"!historico.tarefaFinalizada\">NÃO</span></td></tr></tbody></table></div></div>");
$templateCache.put("app/main/pipeline/processamento/pipeline-negocio/dialogs/pipeline-negocio-negocios/tabs/dialogs/edicao-funil/dialog-edicao-funil.html","<md-dialog id=\"pipeline-negocio-negocios-dialog\" class=\"dialogo-padrao\" style=\"width: 35%\" aria-label=\"Dialog\"><form \nname=\"vm.form\" class=\"md-inline-form\" novalidate><md-toolbar class=\"md-accent md-tall\" layout=\"column\"><div \nclass=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" layout-align=\"space-between center\" flex><div layout=\"row\" \nlayout-align=\"start center\" flex><span class=\"title text-center\">{{vm.titulo}}</span></div><div layout=\"row\"><md-button\n class=\"md-icon-button\" ng-click=\"vm.metodos.fecharDialog()\" aria-label=\"Fechar dialog\" translate \ntranslate-attr-aria-label=\"PIPELINE_NEGOCIO.FECHAR_DIALOG\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button>\n</div></div></md-toolbar><div layout=\"column\" layout-align=\"center center\" ng-show=\"vm.requisicaoSolicitada\"><span \nclass=\"font-weight-500\">{{vm.mensagemPreloader}}</span><md-progress-circular md-mode=\"indeterminate\" md-diameter=\"30\" \nclass=\"md-accent\"></md-progress-circular></div><md-dialog-content class=\"conteudo-dialog\"><div layout=\"row\" \nstyle=\"margin-top: 1em\"><md-input-container class=\"md-block\" flex><label translate=\"PIPELINE_NEGOCIO.FUNIL\"></label>\n<md-select ng-model=\"vm.funil\" name=\"funil\" ng-model-options=\"{trackBy: \'$value.codigo\'}\" \nng-change=\"vm.metodos.alterarItemSelecionadoSelectFunil()\" md-on-open=\"vm.metodos.configuraMdSelectFunil()\" \nng-required=\"true\"><md-select-header><input id=\"pipeline-negocio-dialog-funil-md-select\" class=\"md-text\" \nng-model=\"vm.filtrarFunil\" type=\"search\" placeholder=\"\" translate \ntranslate-attr-placeholder=\"PIPELINE_NEGOCIO.PESQUISAR_FUNIL\"></md-select-header><md-option ng-value=\"funil\" \nng-repeat=\"funil in vm.funis | filter:vm.filtrarFunil track by funil.codigo\">{{funil.descricao}}</md-option>\n</md-select><div ng-messages=\"vm.form.funil.$error\"><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container></div></md-dialog-content>\n<md-dialog-actions layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\">\n<md-button type=\"submit\" ng-click=\"vm.metodos.salvar($event)\" class=\"send-button md-accent md-raised\" \nng-disabled=\"vm.form.$invalid || vm.form.$pristine || vm.requisicaoSolicitada || vm.tabSelecionada === \'dadosHistorico\' || (!vm.etapaAtual.permiteValoresZerados && vm.negocio.valor == 0)\" \naria-label=\"SALVAR\" translate=\"PIPELINE_NEGOCIO.SALVAR\" translate-attr-aria-label=\"PIPELINE_NEGOCIO.SALVAR\" \nng-show=\"vm.funil\">Salvar</md-button></div></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/planejamento-scrum/processamento/sprint/views/tabs/backlog/dialogs/adicionar-estoria-especifica-dialog/sprint-dialog-backlog-adicionar-estoria-especifica.html","<md-dialog id=\"sprint-dialog-backlog-adicionar-estoria-especifica\" class=\"dialogo-padrao\" aria-label=\"Dialog\"><form \nname=\"vm.form.dialogBacklogEstoriaEspecifica\" class=\"md-inline-form\" novalidate><md-toolbar class=\"md-accent md-tall\" \nlayout=\"column\"><div class=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" layout-align=\"space-between center\">\n<span class=\"title\">{{vm.titulo}}</span><md-button class=\"md-icon-button\" ng-click=\"vm.metodosDialog.fecharDialog()\" \naria-label=\"Fechar dialog\" translate translate-attr-aria-label=\"SPRINT.FECHAR_DIALOG\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><div layout=\"row\" layout-sm=\"row\" \nlayout-align=\"center\" ng-show=\"vm.requisicaoSolicitada\"><md-progress-circular md-mode=\"indeterminate\" \nclass=\"md-accent\"></md-progress-circular></div><md-dialog-content ng-hide=\"vm.requisicaoSolicitada\"><div \nlayout-gt-xs=\"row\" layout-align=\"center center\" flex><md-input-container class=\"md-block\" flex-gt-sm=\"40\"><label \ntranslate=\"SPRINT.ESTORIA\">Estória</label><md-select ng-model=\"vm.estoria\" name=\"dialogBacklogEstoria\" \nmd-on-open=\"vm.metodosDialog.configurarMdSelectEstoria()\" required><md-select-header><input \nid=\"sprint-dialog-backlog-adicionar-estorias-especificas-md-select\" class=\"md-text\" ng-model=\"vm.filtrarEstorias\" \ntype=\"search\" placeholder=\"\" translate translate-attr-placeholder=\"SPRINT.PESQUISAR_ESTORIA\"></md-select-header>\n<md-optgroup label=\"Estorias\"><md-option ng-if=\"vm.estoria\" ng-value=\"\">Desmarcar</md-option><md-option \nng-value=\"estoriaBacklog\" ng-repeat=\"estoriaBacklog in vm.estorias | filter:vm.filtrarEstorias\">{{estoriaBacklog}}\n</md-option></md-optgroup></md-select><div \nng-messages=\"vm.form.dialogBacklogEstoriaEspecifica.dialogBacklogEstoria.$error\"><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container></div></md-dialog-content>\n<md-dialog-actions layout=\"row\"><div layout=\"row\" layout-align=\"end center\" flex><md-button type=\"submit\" \nng-click=\"vm.metodosDialog.salvar($event, vm.estoria)\" class=\"send-button md-accent md-raised\" \nng-disabled=\"vm.form.dialogBacklogEstoriaEspecifica.$invalid\r\n        || vm.form.dialogBacklogEstoriaEspecifica.$pristine || vm.requisicaoSolicitada || !vm.estoria\" \naria-label=\"SALVAR\" translate=\"SPRINT.SALVAR\" translate-attr-aria-label=\"SPRINT.SALVAR\">Salvar</md-button></div>\n</md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/planejamento-scrum/processamento/sprint/views/tabs/backlog/dialogs/colaboradores-dialog/sprint-dialog-backlog-colaboradores.html","<md-dialog id=\"sprint-dialog-backlog-colaboradores\" class=\"dialogo-padrao\" aria-label=\"Dialog\"><form \nname=\"vm.form.colaboradores\" class=\"md-inline-form\" novalidate><md-toolbar class=\"md-accent md-tall\" layout=\"column\">\n<div class=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" layout-align=\"space-between center\"><span \nclass=\"title\">{{vm.titulo}}</span><md-button class=\"md-icon-button\" ng-click=\"vm.metodosDialog.fecharDialog()\" \naria-label=\"Fechar dialog\" translate translate-attr-aria-label=\"SPRINT.FECHAR_DIALOG\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><div layout=\"row\" layout-sm=\"row\" \nlayout-align=\"center\" ng-show=\"vm.requisicaoSolicitada\"><md-progress-circular md-mode=\"indeterminate\" \nclass=\"md-accent\"></md-progress-circular></div><md-dialog-content ng-hide=\"vm.requisicaoSolicitada\"><div \nlayout-gt-xs=\"row\" layout-align=\"center start\" flex><md-input-container class=\"md-block\" flex-gt-sm=\"5\" flex-gt-xs>\n<label hide-gt-sm translate=\"SPRINT.PESQUISAR_COLABORADOR_POR_CODIGO\"></label><input text=\"text\" \nng-model=\"vm.colaboradorDesenvolvedorAPesquisar\" aria-label=\"Diretiva Pesquisar por Codigo\" pesquisar-por-codigo \nlista-a-pesquisar=\"vm.usuariosSetorDesenvolvimento[0].usuarios\" entidade-pesquisada=\"vm.estoria.codigoDesenvolvedor\" \nng-required=\"vm.exigeInsercaoDesenvolvedor\" mascara-numeros=\"5\" \nng-change=\"vm.metodosDialog.changeCodigoDesenvolvedor(vm.colaboradorDesenvolvedorAPesquisar)\"></md-input-container>\n<md-input-container class=\"md-block\" flex-gt-sm=\"40\"><label translate=\"SPRINT.USUARIO_DESENVOLVEDOR\">\nDesenvolvedores responsável pela estória</label><md-select ng-model=\"vm.estoria.codigoDesenvolvedor\" \nname=\"dialogBacklogColaboradoresDesenvolvedor\" ng-required=\"vm.exigeInsercaoDesenvolvedor\"><md-option \nng-value=\"usuario.codigo\" ng-repeat=\"usuario in vm.usuariosSetorDesenvolvimento[0].usuarios track by usuario.codigo\">\n{{usuario.login}}</md-option></md-select><div \nng-messages=\"vm.form.colaboradores.dialogBacklogColaboradoresDesenvolvedor.$error\" \nng-if=\"vm.exigeInsercaoDesenvolvedor && vm.estoria.codigoDesenvolvedor == null\"><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container><md-input-container class=\"md-block\" \nflex-gt-sm=\"5\" flex-gt-xs flex-offset-gt-sm=\"10\"><label hide-gt-sm translate=\"SPRINT.PESQUISAR_COLABORADOR_POR_CODIGO\">\n</label><input text=\"text\" ng-model=\"vm.colaboradorTesterAPesquisar\" aria-label=\"Diretiva Pesquisar por Codigo\" \npesquisar-por-codigo lista-a-pesquisar=\"vm.usuariosSetorTestes[0].usuarios\" \nentidade-pesquisada=\"vm.estoria.codigoTester\" mascara-numeros=\"5\" \nng-change=\"vm.metodosDialog.changeCodigoTester(vm.colaboradorTesterAPesquisar)\"></md-input-container>\n<md-input-container class=\"md-block\" flex-gt-sm=\"40\"><label translate=\"SPRINT.USUARIO_TESTER\">\nTester responsável pela estória</label><md-select ng-model=\"vm.estoria.codigoTester\" \nname=\"dialogBacklogColaboradoresTester\" ng-required=\"vm.exigeInsercaoTester\"><md-option ng-value=\"usuario.codigo\" \nng-repeat=\"usuario in vm.usuariosSetorTestes[0].usuarios track by usuario.codigo\">{{usuario.login}}</md-option>\n</md-select><div ng-messages=\"vm.form.colaboradores.dialogBacklogColaboradoresTester.$error\" \nng-if=\"vm.exigeInsercaoTester && vm.estoria.codigoTester == null\"><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container></div></md-dialog-content>\n<md-dialog-actions layout=\"row\"><div layout=\"row\" layout-align=\"end center\" flex><md-button type=\"submit\" \nng-click=\"vm.metodosDialog.salvar($event, vm.estoria)\" class=\"send-button md-accent md-raised\" \nng-disabled=\"vm.form.colaboradores.$invalid ||\r\n                                        vm.form.colaboradores.$pristine ||\r\n                                        vm.requisicaoSolicitada\" \naria-label=\"SALVAR\" translate=\"SPRINT.SALVAR\" translate-attr-aria-label=\"SPRINT.SALVAR\">Salvar</md-button></div>\n</md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/planejamento-scrum/processamento/sprint/views/tabs/backlog/dialogs/estimativa-horas-dialog/sprint-dialog-backlog-estimativa-horas.html","<md-dialog id=\"sprint-dialog-backlog-estimativa-horas\" class=\"dialogo-padrao\" aria-label=\"Dialog\"><form \nname=\"vm.form.dialogBacklogEstimativaHoras\" class=\"md-inline-form\" novalidate><md-toolbar class=\"md-accent md-tall\" \nlayout=\"column\"><div class=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" layout-align=\"space-between center\">\n<span class=\"title\">{{vm.titulo}}</span><md-button class=\"md-icon-button\" ng-click=\"vm.metodosDialog.fecharDialog()\" \naria-label=\"Fechar dialog\" translate translate-attr-aria-label=\"SPRINT.FECHAR_DIALOG\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><div layout=\"row\" layout-sm=\"row\" \nlayout-align=\"center\" ng-show=\"vm.requisicaoSolicitada\"><md-progress-circular md-mode=\"indeterminate\" \nclass=\"md-accent\"></md-progress-circular></div><md-dialog-content ng-hide=\"vm.requisicaoSolicitada\"><fieldset><legend \ntranslate=\"SPRINT.HORAS_TOTAIS\"></legend><div layout-gt-xs=\"row\" layout-align=\"center center\" flex><md-input-container \nclass=\"md-block\"><label translate=\"SPRINT.HORAS_DESENVOLVIMENTO\">Desenvolvimento</label><input type=\"text\" \nng-model=\"vm.estoria.horasDesenvolvimento\" name=\"dialogBacklogEstimativaHorasHorasDesenvolvimento\" readonly=\"readonly\">\n</md-input-container><md-input-container class=\"md-block\"><label translate=\"SPRINT.HORAS_TESTES_DESENVOLVIMENTO\">\nTestes(Desenvolvimento)</label><input type=\"text\" ng-model=\"vm.estoria.horasTesteDesenvolvimento\" \nname=\"dialogBacklogEstimativaHorasHorasDesenvolvimentoTestes\" readonly=\"readonly\"></md-input-container>\n<md-input-container class=\"md-block\"><label translate=\"SPRINT.HORAS_TESTES_TESTER\">Testes(Tester)</label><input \ntype=\"text\" ng-model=\"vm.estoria.horasTestes\" name=\"dialogBacklogEstimativaHorasHorasTester\" readonly=\"readonly\">\n</md-input-container><md-input-container class=\"md-block\"><label translate=\"SPRINT.HORAS_TOTAIS\">Totais</label><input \ntype=\"text\" ng-model=\"vm.estoria.horasTotais\" name=\"dialogBacklogEstimativaHorasTotais\" readonly=\"readonly\">\n</md-input-container></div></fieldset><fieldset><legend translate=\"SPRINT.HORAS_RESTANTES\"></legend><div \nlayout-gt-xs=\"row\" layout-align=\"center center\" flex><md-input-container class=\"md-block\"><label \ntranslate=\"SPRINT.HORAS_DESENVOLVIMENTO\">Desenvolvimento</label><input type=\"text\" \nng-model=\"vm.estoria.horasRestanteDesenvolvimento\" name=\"dialogBacklogEstimativaHorasHorasDesenvolvimento\" \nreadonly=\"readonly\"></md-input-container><md-input-container class=\"md-block\"><label \ntranslate=\"SPRINT.HORAS_TESTES_DESENVOLVIMENTO\">Testes(Desenvolvimento)</label><input type=\"text\" \nng-model=\"vm.estoria.horasRestanteTesteDesenvolvimento\" name=\"dialogBacklogEstimativaHorasHorasDesenvolvimentoTestes\" \nreadonly=\"readonly\"></md-input-container><md-input-container class=\"md-block\"><label \ntranslate=\"SPRINT.HORAS_TESTES_TESTER\">Testes(Tester)</label><input type=\"text\" \nng-model=\"vm.estoria.horasRestantesTestes\" name=\"dialogBacklogEstimativaHorasHorasTester\" readonly=\"readonly\">\n</md-input-container><md-input-container class=\"md-block\"><label translate=\"SPRINT.HORAS_TOTAIS\">Totais</label><input \ntype=\"text\" ng-model=\"vm.estoria.horasRestanteTotais\" name=\"dialogBacklogEstimativaHorasTotais\" readonly=\"readonly\">\n</md-input-container></div></fieldset></md-dialog-content></form></md-dialog>");
$templateCache.put("app/main/planejamento-scrum/processamento/sprint/views/tabs/backlog/dialogs/estimativa-pontos-dialog/sprint-dialog-backlog-estimativa-pontos.html","<md-dialog id=\"sprint-dialog-backlog-estimativa-pontos\" class=\"dialogo-padrao\" aria-label=\"Dialog\"><form \nname=\"vm.form.dialogBacklogEstimativaPontos\" class=\"md-inline-form\" novalidate><md-toolbar class=\"md-accent md-tall\" \nlayout=\"column\"><div class=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" layout-align=\"space-between center\">\n<span class=\"title\">{{vm.titulo}}</span><md-button class=\"md-icon-button\" ng-click=\"vm.metodosDialog.fecharDialog()\" \naria-label=\"Fechar dialog\" translate translate-attr-aria-label=\"SPRINT.FECHAR_DIALOG\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><div layout=\"column\" layout-align=\"center center\" \nng-show=\"vm.requisicaoSolicitada\"><span class=\"font-weight-500\">{{vm.mensagemPreloader}}</span><md-progress-circular \nmd-mode=\"indeterminate\" md-diameter=\"30\" class=\"md-accent\"></md-progress-circular></div><md-dialog-content><div \nlayout-gt-xs=\"row\" layout-align=\"space-around center\"><md-input-container class=\"md-block\" flex-gt-sm=\"40\"><label \ntranslate=\"SPRINT.PONTUACAO_TOTAL\">Pontuação Total</label><input type=\"text\" mascara-numero-generica=\"#####\" \nname=\"sprintBacklogEstimativaPontosPontuacaoInicial\" ng-disabled=\"true\" ng-model=\"vm.backlogItem.pontuacaoInicial\">\n</md-input-container><md-input-container class=\"md-block\" flex-gt-sm=\"40\"><label translate=\"SPRINT.PONTUACAO_ENTREGUE\">\nPontuação Entregue</label><input type=\"text\" mascara-numeros=\"6\" numero-casas-decimais=\"2\" aceita-negativo \nname=\"sprintBacklogEstimativaPontosPontuacaoEntregue\" ng-disabled=\"true\" ng-model=\"vm.backlogItem.pontuacaoEntregue\">\n</md-input-container></div><div layout=\"row\" layout-align=\"center center\" ng-if=\"!vm.requisicaoSolicitada\"><div \nclass=\"md-background-bg md-whiteframe-1dp\"><table class=\"dataTable row-border hover compactr\" datatable=\"ng\" \ndt-options=\"vm.dtOptions\" width=\"100%\"><thead><tr><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Ação</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Descrição</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Tipo Tarefa</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Pontos</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Data Início</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Data Fim</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Usuário</span></div></th></tr></thead><tfoot><tr><th>Total:</th><th \nstyle=\"text-align: center !important\"></th><th style=\"text-align: center !important\"></th><th \nstyle=\"text-align: center !important\"></th><th></th><th></th><th></th></tr></tfoot><tbody><tr \nng-repeat=\"tarefa in vm.tarefas | orderBy: \'tiposTarefa\'\"><td><md-button class=\"md-icon-button\" \nid=\"pg-tarefa-tooltip-editar\" ng-click=\"vm.abrirDialoEditarTarefa(tarefa)\" ng-disabled=\"vm.requisicaoSolicitada\" \naria-label=\"Editar Tarefa\"><md-icon class=\"icon-active\" md-font-icon=\"icon-pencil\"></md-icon><md-tooltip md-autohide \nid=\"pg-tarefa-tooltip-editar\" md-delay=\"vm.tempoDelay\"><span translate=\"SPRINT.EDITAR_TAREFA\"></span></md-tooltip>\n</md-button></td><td>{{tarefa.descricao}}</td><td>{{tarefa.tipoTarefaDescricao}}</td><td class=\"text-center\">\n{{tarefa.pontos}}</td><td>{{tarefa.dataHoraInicio | date:\'dd/MM/yyyy\'}}</td><td>\n{{tarefa.dataHoraFim | date:\'dd/MM/yyyy\'}}</td><td>{{tarefa.usuario.login}}</td></tr></tbody></table></div></div>\n</md-dialog-content><md-dialog-actions layout=\"row\"><div layout=\"row\" layout-align=\"end center\" flex><md-button \ntype=\"submit\" ng-click=\"vm.metodosInterno.editar($event)\" class=\"send-button md-accent md-raised\" \nng-disabled=\"vm.form.dialogBacklogEstimativaPontos.$invalid\r\n                                        || vm.form.dialogBacklogEstimativaPontos.$pristine || vm.requisicaoSolicitada\" \naria-label=\"SALVAR\" translate=\"SPRINT.SALVAR\" translate-attr-aria-label=\"SPRINT.SALVAR\">Salvar</md-button></div>\n</md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/planejamento-scrum/processamento/sprint/views/tabs/backlog/dialogs/priorizacao-dialog/sprint-dialog-backlog-priorizacao.html","<md-dialog id=\"sprint-dialog-backlog-priorizacao\" class=\"dialogo-padrao\" aria-label=\"Dialog\"><form \nname=\"vm.form.dialogBacklogPriorizacao\" class=\"md-inline-form\" novalidate><md-toolbar class=\"md-accent md-tall\" \nlayout=\"column\"><div class=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" layout-align=\"space-between center\">\n<span class=\"title\">{{vm.titulo}}</span><md-button class=\"md-icon-button\" ng-click=\"vm.metodosDialog.fecharDialog()\" \naria-label=\"Fechar dialog\" translate translate-attr-aria-label=\"SPRINT.FECHAR_DIALOG\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><div layout=\"row\" layout-sm=\"row\" \nlayout-align=\"center\" ng-show=\"vm.requisicaoSolicitada\"><md-progress-circular md-mode=\"indeterminate\" \nclass=\"md-accent\"></md-progress-circular></div><md-dialog-content ng-hide=\"vm.requisicaoSolicitada\"><div \nlayout-gt-xs=\"row\" layout-align=\"center center\" flex><fieldset><p><strong>BV</strong>\n = Business Value - Visão do cliente (1 a 100), <strong>estimado pelo PO</strong>.</p><p><strong>DF</strong>\n = Complexidade de implantação - Visão do Time (1.5 - Facil, 2 - Médio, 2.5 - Desafiador, 3 - Muito Desafiador) \n<strong>estimado pelo Time</strong>.</p><p><strong>OR</strong>\n = Origem solicitação (1 - Melhoria/Ajuste, 1.5 - Implementação, 3 - Erro), <strong>estimado pelo PO</strong>.</p><p>\n<strong>CT</strong> = Criticidade (1 - Baixa, 3 - Normal, 5 - Alta, 7 - Urgência), <strong>estimado pelo PO</strong>.\n</p></fieldset></div><div class=\"divider\"></div><div layout-gt-xs=\"row\" layout-align=\"center center\">\n<md-input-container class=\"md-block\" flex=\"30\"><label translate=\"SPRINT.BUSINESS_VALUE\">Business value</label><input \ntype=\"number\" ng-model=\"vm.backlogItem.businessValue\" min=\"1\" max=\"100\" \nname=\"sprintBacklogPriorizacaoOrigemBusinessValue\" ng-required=\"true\" mascara-numeros=\"3\"><div \nng-messages=\"vm.form.dialogBacklogPriorizacao.sprintBacklogPriorizacaoOrigemBusinessValue.$error\"><div \nng-message=\"required\" translate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div><div ng-message=\"max\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_VALOR_MAXIMO_100\"></div><div ng-message=\"min\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_VALOR_MINIMO_1\"></div></div></md-input-container><md-input-container \nclass=\"md-block zera-margin-top\" flex-gt-sm=\"20\"><label translate=\"SPRINT.COMPLEXIDADE\">Dificuldade</label><md-select \nng-model=\"vm.backlogItem.dificuldade\" name=\"sprintBacklogPriorizacaoDificuldade\" ng-required=\"true\"><md-option \nng-value=\"{{value}}\" ng-repeat=\"(key, value) in vm.dificuldades\">{{key}}</md-option></md-select><div \nng-messages=\"vm.form.dialogBacklogPriorizacao.sprintBacklogPriorizacaoDificuldade.$error\"><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container><md-input-container \nclass=\"md-block zera-margin-top\" flex-gt-sm=\"20\"><label translate=\"SPRINT.ORIGEM\">Origem</label><md-select \nng-model=\"vm.backlogItem.origem\" name=\"sprintBacklogPriorizacaoOrigem\" ng-required=\"true\"><md-option \nng-value=\"{{value}}\" ng-repeat=\"(key, value) in vm.origens\">{{key}}</md-option></md-select><div \nng-messages=\"vm.form.dialogBacklogPriorizacao.sprintBacklogPriorizacaoOrigem.$error\"><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container><md-input-container \nclass=\"md-block zera-margin-top\" flex-gt-sm=\"15\"><label translate=\"SPRINT.CRITICIDADE\">Criticidade</label><md-select \nng-model=\"vm.backlogItem.criticidade\" name=\"sprintBacklogPriorizacaoCriticidade\" ng-required=\"true\"><md-option \nng-value=\"{{value}}\" ng-repeat=\"(key, value) in vm.criticidades\">{{key}}</md-option></md-select><div \nng-messages=\"vm.form.dialogBacklogPriorizacao.sprintBacklogPriorizacaoCriticidade.$error\"><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container><md-input-container class=\"md-block\" \nflex-gt-sm=\"40\"><label translate=\"SPRINT.PRIORIDADE\">Prioridade</label><input type=\"text\" \nvalue=\"{{vm.parseInt((vm.backlogItem.businessValue / vm.backlogItem.dificuldade * (vm.backlogItem.origem * vm.backlogItem.criticidade))) ? vm.parseInt((vm.backlogItem.businessValue / vm.backlogItem.dificuldade * (vm.backlogItem.origem * vm.backlogItem.criticidade))) : 0}}\" \nreadonly=\"readonly\"></md-input-container></div></md-dialog-content><md-dialog-actions layout=\"row\"><div layout=\"row\" \nlayout-align=\"end center\" flex><md-button type=\"submit\" ng-click=\"vm.metodosDialog.editar($event)\" \nclass=\"send-button md-accent md-raised\" \nng-disabled=\"vm.form.dialogBacklogPriorizacao.$invalid \r\n                                        || vm.form.dialogBacklogPriorizacao.$pristine || vm.requisicaSolicitada\" \naria-label=\"SALVAR\" translate=\"SPRINT.SALVAR\" translate-attr-aria-label=\"SPRINT.SALVAR\">Salvar</md-button></div>\n</md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/planejamento-scrum/processamento/sprint/views/tabs/backlog/dialogs/estoria-dialog/estoria-dialog.html","<md-dialog id=\"dialog-estoria\" class=\"dialogo-padrao\" aria-label=\"Dialog\"><header-padrao \ntranslate-nome=\"ESTORIA.ESTORIA\" texto-auxiliar=\"vm.estoria.numero\" \ntexto-auxiliar-habilitado=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.inserirAtivo\" icone=\"icon-book-variant\" \nliberar-pesquisa-quando-datatable-ativo=\"vm.controleForm.pesquisarDatatable || !vm.controleForm.emProgresso\" \npesquisar=\"vm.pesquisar\"></header-padrao><md-button class=\"md-icon-button button-flutuante\" \nng-click=\"vm.metodosGeral.fecharDialog()\" aria-label=\"Fechar dialog\" translate \ntranslate-attr-aria-label=\"CLIENTE.FECHAR_DIALOG\"><md-icon md-font-icon=\"icon-close\" \nclass=\"cor-icone-button-flutuante\"></md-icon></md-button><div class=\"content\"><div \nui-view=\"estoria-form@app.planejamento_processamento_estoria\"></div></div></md-dialog>");
$templateCache.put("app/main/planejamento-scrum/processamento/sprint/views/tabs/backlog/dialogs/situacao-dialog/sprint-dialog-backlog-situacao.html","<md-dialog id=\"sprint-dialog-backlog-colaboradores\" class=\"dialogo-padrao\" aria-label=\"Dialog\"><form \nname=\"vm.form.dialogBacklogSituacao\" class=\"md-inline-form\" novalidate><md-toolbar class=\"md-accent md-tall\" \nlayout=\"column\"><div class=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" layout-align=\"space-between center\">\n<span class=\"title\">{{vm.titulo}}</span><md-button class=\"md-icon-button\" ng-click=\"vm.metodosDialog.fecharDialog()\" \naria-label=\"Fechar dialog\" translate translate-attr-aria-label=\"SPRINT.FECHAR_DIALOG\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><div layout=\"row\" layout-sm=\"row\" \nlayout-align=\"center\" ng-show=\"vm.requisicaoSolicitada\"><md-progress-circular md-mode=\"indeterminate\" \nclass=\"md-accent\"></md-progress-circular></div><md-dialog-content ng-hide=\"vm.requisicaoSolicitada\"><div layout=\"row\" \nlayout-align=\"center center\"><md-input-container class=\"md-block\" flex-gt-sm=\"50\"><label translate=\"SPRINT.SITUACAO\">\nSituação</label><md-select \nng-change=\"vm.metodosDialog.buscaPontosInicias(vm.historicoSituacao.situacao.descricao,vm.historicoSituacao.estoriaNumero,vm.historicoSituacao.estoriaAno)\" \nng-model=\"vm.historicoSituacao.situacao\" name=\"estoriaHistoricoSituacaoSituacaoCodigo\" \nng-model-options=\"{trackBy: \'$value.codigo\'}\" ng-required=\"vm.novoHistoricoSituacao\"><md-option ng-value=\"situacao\" \nng-repeat=\"situacao in vm.situacoes track by situacao.codigo\">{{situacao.descricao}}</md-option></md-select><div \nng-messages=\"historicoSituacaoForm.estoriaHistoricoSituacaoSituacaoCodigo.$error\"><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container></div><div layout-gt-xs=\"row\" \nng-if=\"vm.historicoSituacao.situacao.descricao == \'Homologada\'\" layout-align=\"space-around center\"><md-input-container \nclass=\"md-block\" flex-gt-sm=\"40\"><label translate=\"SPRINT.PONTUACAO_TOTAL\">Pontuação Total</label><input type=\"text\" \nmascara-numero-generica=\"#####\" name=\"sprintBacklogEstimativaPontosPontuacaoInicial\" ng-disabled=\"true\" \nng-model=\"vm.pontos\"></md-input-container><md-input-container class=\"md-block\" flex-gt-sm=\"40\"><label \ntranslate=\"SPRINT.PONTUACAO_ENTREGUE\">Pontuação Entregue</label><input type=\"text\" name=\"pontoEntregue\" \nmascara-numeros=\"6\" numero-casas-decimais=\"2\" aceita-negativo name=\"sprintBacklogEstimativaPontosPontuacaoEntregue\" \nng-required=\"true\" ng-disabled=\"true\" ng-model=\"vm.historicoSituacao.pontosEntregue\"></md-input-container></div><div \nlayout-gt-xs=\"row\" ng-if=\"vm.historicoSituacao.situacao.exigeMotivo\"><md-input-container class=\"md-block\" flex><label \ntranslate=\"SPRINT.MOTIVO\">Motivo</label><textarea ng-model=\"vm.historicoSituacao.observacaoMotivoPausa\" \nname=\"sprintDialogBacklogHistoricoMotivoPausa\" ng-required=\"vm.historicoSituacao.situacao.exigeMotivo\" \nmd-no-resize=\"true\">\r\n                     </textarea><div \nng-messages=\"vm.form.dialogBacklogSituacao.sprintDialogBacklogHistoricoMotivoPausa.$error\"><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container></div><div \nclass=\"md-background-bg md-whiteframe-1dp\"><table class=\"dataTable row-border hover\" datatable=\"ng\" \ndt-options=\"vm.dtOptionsHistoricoSituacao\" width=\"100%\" flex><thead flex><tr><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Situação</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Usuário</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Data</span></div></th></tr></thead><tbody flex><tr \nng-repeat=\"historicoSituacao in vm.listaEstoriaHistoricoSituacao | orderBy: \'-data\' track by historicoSituacao.codigo\">\n<td>{{historicoSituacao.situacao.descricao}}</td><td>{{historicoSituacao.usuario.login}}</td><td>\n{{historicoSituacao.data | date:\'dd/MM/yyyy\'}}</td></tr></tbody></table></div></md-dialog-content><md-dialog-actions \nlayout=\"row\"><div layout=\"row\" layout-align=\"end center\" flex><md-button type=\"submit\" \nng-click=\"vm.metodosDialog.salvar($event, vm.historicoSituacao)\" class=\"send-button md-accent md-raised\" \nng-disabled=\"vm.form.dialogBacklogSituacao.$invalid\r\n        || vm.form.dialogBacklogSituacao.$pristine || vm.requisicaoSolicitada || (vm.historicoSituacao.pontosEntregue > vm.pontos)\" \naria-label=\"SALVAR\" translate=\"SPRINT.SALVAR\" translate-attr-aria-label=\"SPRINT.SALVAR\">Salvar</md-button></div>\n</md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/planejamento-scrum/processamento/sprint/views/tabs/estatisticas/dialogs/visualizar-estorias-dialog/sprint-dialog-estatisticas-visualizar-estorias.html","<md-dialog id=\"sprint-dialog-estatistica-visualizar-estorias\" class=\"dialogo-padrao\" aria-label=\"Dialog\"><form \nname=\"vm.form\" class=\"md-inline-form\" novalidate><md-toolbar class=\"md-accent md-tall\" layout=\"column\"><div \nclass=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\">\n{{vm.titulo}}</span><md-button class=\"md-icon-button\" ng-click=\"vm.metodosDialog.fecharDialog()\" \naria-label=\"Fechar dialog\" translate-attr-aria-label=\"Fechar dialog\"><md-icon md-font-icon=\"icon-close\"></md-icon>\n</md-button></div></md-toolbar><div layout=\"row\" layout-sm=\"row\" layout-align=\"center\" \nng-show=\"vm.requisicaoSolicitada\"><md-progress-circular md-mode=\"indeterminate\" class=\"md-accent\">\n</md-progress-circular></div><md-dialog-content><table class=\"dataTable row-border hover border\" \nng-if=\"!vm.requisicaoSolicitada\" datatable=\"ng\" dt-options=\"vm.dtOptionsVisualizarEstorias\" width=\"100%\"><thead><tr><th\n class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Número</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Ano</span></div></th><th \nclass=\"secondary-text\" ng-if=\"vm.tipoRetorno == 2\"><div class=\"table-header\"><span class=\"column-title\">Motivo</span>\n</div></th><th class=\"secondary-text\" ng-if=\"vm.tipoRetorno == 2\"><div class=\"table-header\"><span class=\"column-title\">\nPontos perdidos</span></div></th><th class=\"secondary-text\" ng-if=\"vm.historiasDesenvolvidas\"><div \nclass=\"table-header\"><span class=\"column-title\">Situação</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Ação</span></div></th></tr></thead><tbody><tr \nng-repeat=\"historia in vm.historiasEstatistica\" \nng-if=\"!vm.tipoRetorno == 1 || !vm.tipoRetorno == 3 || (vm.tipoRetorno == 2 && historia.pontosPerdidos> 0)\"><td>\n{{historia.numeroHistoria}}</td><td>{{historia.anoHistoria}}</td><td ng-if=\"vm.tipoRetorno == 2\">{{historia.motivo}}\n</td><td ng-if=\"vm.tipoRetorno == 2\">{{historia.pontosPerdidos}}</td><td class=\"text-center\" \nng-if=\"vm.historiasDesenvolvidas\"><div class=\"situacao-estoria\" ng-repeat=\"situacao in vm.coresSituacoes\" \nng-if=\"situacao.codigo == historia.situacaoCodigo\" ng-style=\"{\'background-color\': situacao.cor}\" \nng-class=\"{\'texto-fundo-claro\': situacao.codigo == 1 || situacao.codigo == 3}\" layout-align=\"center center\" flex><span \nclass=\"text-center\">{{ historia.situacaoHistoria }}</span></div></td><td><i \nclass=\"icon-open-in-new s24 icone-cor-padrao\" ng-click=\"vm.metodosDialog.abrirEstoria(historia)\"></i></td></tr></tbody>\n</table><div ng-if=\"vm.tipoRetorno == 2\"><span><strong style=\"color: red\">Atenção! </strong>\nAs histórias em que a origem for erro, não terão sua pontuação contabilizada no quantitativo de pontuação homologada, contudo, caso tenha algum retorno de erro, a pontuação perdida, será considerada.\n</span></div></md-dialog-content></form></md-dialog>");
$templateCache.put("app/main/planejamento-scrum/processamento/sprint/views/tabs/meta/dialogs/acompanhamento-meta-dialog/acompanhamento-meta-dialog.html","<md-dialog id=\"sprint-acompanhamento-meta-dialog\" class=\"dialogTable\" aria-label=\"Dialog\"><md-toolbar \nclass=\"md-accent md-tall toolbar-acompanhamento-meta\" flex><div \nclass=\"md-toolbar-tools md-toolbar-tools-top container-header\" layout-gt-xs=\"row\" layout=\"column\" \nlayout-align=\"space-between center\"><span class=\"title\">Acompanhamento de meta</span><div \nclass=\"container-input-fechar\"><div class=\"input-pesquisa\" layout=\"row\" layout-align=\"start start\"><label><md-icon \nmd-font-icon=\"icon-magnify\" class=\"white-text icon search-icon\"></md-icon></label><input id=\"pesquisarHistoriasMeta\" \ntype=\"search\" placeholder=\"Pesquisar\" ng-model=\"vm.pesquisarHistorias\" flex></div><md-button class=\"md-icon-button\" \naria-label=\"Fechar dialog\" translate translate-attr-aria-label=\"SPRINT.FECHAR_DIALOG\" \nng-click=\"vm.metodosDialog.fecharDialog()\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></div>\n</md-toolbar><md-dialog-content class=\"dialog-acompanhamento-metas\"><div class=\"atualiza-meta\"><md-button \nclass=\"md-fab md-accent md-icon-button sample-show-hide botao-atualizar-meta\" aria-label=\"Atualizar meta\" \nng-click=\"vm.metodosDialog.atualizarTabela()\" ng-disabled=\"vm.requisicaoSolicitada\"><md-icon \nmd-font-icon=\"icon-refresh s30\" class=\"icone\" ng-if=\"!vm.requisicaoSolicitada\"></md-icon><div layout=\"row\" \nlayout-align=\"center center\" ng-if=\"vm.requisicaoSolicitada\" flex><md-progress-circular class=\"md-accent\" \nmd-diameter=\"30\" md-mode=\"indeterminate\"></md-progress-circular></div><md-tooltip md-autohide><span>Atualizar meta\n</span></md-tooltip></md-button></div><div layout=\"column\" flex class=\"container-tabela-totalizadores\"><div \nclass=\"container-tabela\"><div class=\"margin-top md-background-bg md-whiteframe-1dp filtros-metas\" flex \nlayout-gt-xs=\"row\" layout=\"column\"><md-button class=\"array-buttons-metas\" \naria-label=\"Filtrar tabela de historias de meta\" ng-repeat=\"metas in vm.tiposMeta track by metas.codigo\" \nng-click=\"vm.metodosDialog.filtrarMetasHistorias(metas)\" \nng-class=\"{\'descricao-selecionada\': vm.filtroSelecionado(metas.codigo)}\"><span class=\"title\">{{metas.descricao}}</span>\n</md-button></div><div class=\"tabela-acompanhamento-metas\"><table id=\"datatable-acompanhamento-metas\" \nclass=\"dataTable row-border hover\" datatable=\"ng\" dt-options=\"vm.dtOptions\" width=\"100%\"><thead><tr><th \nclass=\"secondary-text border-left border-top\"><div class=\"table-header\"><span class=\"column-title\">Ação</span></div>\n</th><th class=\"secondary-text border-top\"><div class=\"table-header\"><span class=\"column-title\">História</span></div>\n</th><th class=\"secondary-text border-top\"><div class=\"table-header\"><span class=\"column-title\">Descrição</span></div>\n</th><th class=\"secondary-text border-top\"><div class=\"table-header\"><span class=\"column-title\">Solução</span></div>\n</th><th class=\"secondary-text border-top\"><div class=\"table-header\"><span class=\"column-title\">Situação</span></div>\n</th><th class=\"secondary-text border-top\"><div class=\"table-header\"><span class=\"column-title\">Cliente</span></div>\n</th><th class=\"secondary-text border-top\"><div class=\"table-header\"><span class=\"column-title\">Stack</span></div></th>\n<th class=\"secondary-text border-top border-right\"></th><th class=\"secondary-text coluna-oculta\" ng-hide=\"true\"></th>\n<th class=\"secondary-text coluna-oculta\" ng-hide=\"true\"></th><th class=\"secondary-text coluna-oculta\" ng-hide=\"true\">\n</th><th class=\"secondary-text coluna-oculta\" ng-hide=\"true\"></th></tr></thead><tbody><tr flex \nng-repeat=\"historiasMeta in vm.historiasMetasFiltradas | filter: vm.filtroPesquisa\"><td \nclass=\"coluna-acao border-left\"><div class=\"botoes-acoes\"><button \nng-click=\"vm.metodosDialog.abrirHistoria($event, historiasMeta)\"><i \nclass=\"icon-open-in-new s16 icone-cor-padrao mr-10\"></i></button> <button class=\"botao-historias-vinculadas\" \nng-click=\"vm.metodosDialog.abrirDialogHistoriasVinculadas(historiasMeta)\"><i \nclass=\"icon-playlist-plus s22 icone-cor-padrao\"></i><md-icon class=\"s8 icone-historia-vinculada\" \nmd-font-icon=\"icon-checkbox-blank-circle\" ng-if=\"historiasMeta.estoria.possuiVinculo\" layout-align=\"end end\"></md-icon>\n</button></div></td><td flex class=\"border-left border-right h3 font-weight-400 text-center\" \nng-class=\"{\'homologada\': historiasMeta.estoria.ultimoHistoricoSituacao.situacaoCodigo == vm.coresSituacoes[0].codigo,\r\n                                     \'retorno-erro\': historiasMeta.estoria.ultimoHistoricoSituacao.situacaoCodigo == vm.coresSituacoes[1].codigo,\r\n                                     \'retorno-melhoria\': historiasMeta.estoria.ultimoHistoricoSituacao.situacaoCodigo == vm.coresSituacoes[2].codigo,\r\n                                     \'em-pausa\': historiasMeta.estoria.ultimoHistoricoSituacao.situacaoCodigo == vm.coresSituacoes[3].codigo[0]\r\n                                     || historiasMeta.estoria.ultimoHistoricoSituacao.situacaoCodigo == vm.coresSituacoes[3].codigo[1],\r\n                                     \'em-testes\': historiasMeta.estoria.ultimoHistoricoSituacao.situacaoCodigo == vm.coresSituacoes[4].codigo,\r\n                                     \'liberada-para-teste\': historiasMeta.estoria.ultimoHistoricoSituacao.situacaoCodigo == vm.coresSituacoes[5].codigo,\r\n                                     \'em-desenvolvimento\': historiasMeta.estoria.ultimoHistoricoSituacao.situacaoCodigo == vm.coresSituacoes[6].codigo,\r\n                                     \'refinada\': historiasMeta.estoria.ultimoHistoricoSituacao.situacaoCodigo == vm.coresSituacoes[7].codigo,\r\n                                     \'estimada\': historiasMeta.estoria.ultimoHistoricoSituacao.situacaoCodigo == vm.coresSituacoes[8].codigo,\r\n                                     \'backlog\': historiasMeta.estoria.ultimoHistoricoSituacao.situacaoCodigo == vm.coresSituacoes.backlog.codigo,\r\n                                     \'atualizada-no-cliente\': historiasMeta.estoria.ultimoHistoricoSituacao.situacaoCodigo == vm.coresSituacoes[10].codigo,\r\n                                     \'analise\': historiasMeta.estoria.ultimoHistoricoSituacao.situacaoCodigo == vm.coresSituacoes[11].codigo}\">\n{{historiasMeta.estoria.numero}}/{{historiasMeta.estoria.ano}}</td><td class=\"font-size-14\">\n{{historiasMeta.estoria.descricao}}</td><td class=\"font-size-14\">{{historiasMeta.estoria.solucaoDescricao}}</td><td \nid=\"acompanhamento-meta-situacao{{$index}}\" class=\"font-size-14\" \nng-dblclick=\"vm.metodosDialog.abrirDialogEstoriaSituacao($index ,$event,\r\n                                                  historiasMeta.estoria.ultimoHistoricoSituacao, historiasMeta.estoria, historiasMeta)\">\n<div class=\"border-bottom-historico\">{{historiasMeta.estoria.ultimoHistoricoSituacao.situacao.descricao}}</div></td><td\n class=\"font-size-14\">{{historiasMeta.estoria.clienteNome}}</td><td class=\"font-size-14\"><div \nng-repeat=\"stack in vm.stack\" ng-if=\"historiasMeta.estoria.stackResponsavel == stack.codigo\">{{ stack.descricao }}\n</div><div ng-if=\"!historiasMeta.estoria.stackResponsavel == stack.codigo\"></div></td><td \nclass=\"border-left border-right\"><div class=\"ml-10\" layout-gt-xs=\"column\" layout-align=\"center center\" flex><div \nlayout=\"column\" layout-gt-xs=\"row\"><md-button class=\"md-icon-button md-avatar siglas\" \nng-click=\"vm.metodosDialog.abrirDialogEstoriaColaboradores($event, historiasMeta.estoria)\">\n{{historiasMeta.estoria.desenvolvedorNome[0] + historiasMeta.estoria.desenvolvedorNome[1] | uppercase}}<md-tooltip \nmd-direction=\"top\"><span>{{historiasMeta.estoria.desenvolvedorNome}}</span></md-tooltip></md-button><md-button \nclass=\"md-icon-button md-avatar siglas\" \nng-click=\"vm.metodosDialog.abrirDialogEstoriaColaboradores($event, historiasMeta.estoria)\">\n{{historiasMeta.estoria.testerNome[0] + historiasMeta.estoria.testerNome[1] | uppercase}}<md-tooltip \nmd-direction=\"top\"><span>{{historiasMeta.estoria.testerNome}}</span></md-tooltip></md-button></div><div \nlayout=\"column\" layout-gt-xs=\"row\"><div class=\"botao-pontuacao\"><md-button class=\"md-icon-button siglas\" \nng-click=\"vm.metodosDialog.abrirDialogEstoriaPontuacao($event, historiasMeta)\">{{historiasMeta.pontuacaoInicial}}\n<md-tooltip ng-if=\"!vm.metodosDialog.verificaPontuacao(historiasMeta,historiasMeta.pontuacaoEntregue)\"><span>\nPontuação Estimada</span></md-tooltip><md-tooltip \nng-if=\"vm.metodosDialog.verificaPontuacao(historiasMeta,historiasMeta.pontuacaoEntregue)\"><span>\nPontuação entregue só pode ser informada em fase Homologada e não pode ser maior que pontuação inicial</span>\n</md-tooltip></md-button><md-icon class=\"s16 tipo\" md-font-icon=\"icon-checkbox-blank-circle\" \nng-if=\"vm.metodosDialog.verificaPontuacao(historiasMeta,historiasMeta.pontuacaoEntregue)\"></md-icon></div><md-button \nclass=\"md-icon-button siglas\" ng-click=\"vm.metodosDialog.abrirDialogEstoriaPriorizacao($event, historiasMeta)\">\n{{historiasMeta.prioridade}}<md-tooltip><span>Prioridade</span></md-tooltip></md-button></div></div></td><td \nclass=\"coluna-oculta\" ng-hide=\"true\">{{historiasMeta.estoria.codigoTipoMeta}}</td><td class=\"coluna-oculta\" \nng-hide=\"true\">{{historiasMeta.codigo}}</td><td class=\"coluna-oculta\" ng-hide=\"true\">\n{{historiasMeta.estoria.desenvolvedorNome}}</td><td class=\"coluna-oculta\" ng-hide=\"true\">\n{{historiasMeta.estoria.testerNome}}</td></tr></tbody></table></div></div><div layout-gt-xs=\"row\" layout=\"column\" \nlayout-align=\"center center\" flex class=\"mt-15 container-totalizadores\"><md-card class=\"card card-stacks\" \nflex-gt-xs=\"20\" flex=\"60\" ng-repeat=\"totalizador in vm.totalizadoresPontosStack\"><md-card-header><md-card-header-text \nlayout=\"column\" layout-align=\"center center\"><strong style=\"color: white\" class=\"font-size-20\">\n{{totalizador.descricao}}</strong><p style=\"color: white\">{{totalizador.totalPontos}}</p></md-card-header-text>\n</md-card-header></md-card><md-card class=\"card card-total-historias\" flex-gt-xs=\"20\" flex=\"60\"><md-card-header>\n<md-card-header-text layout=\"column\" layout-align=\"center center\"><strong style=\"color: white\" class=\"font-size-20\">\nTotal de histórias</strong><p style=\"color: white\">{{vm.totalHistoriasFiltradas}}</p></md-card-header-text>\n</md-card-header></md-card><md-card class=\"card card-total-pontos\" flex-gt-xs=\"20\" flex=\"60\" \nng-click=\"vm.metodosDialog.abrirDialogPontosDesenvolvedor()\"><md-card-header><md-card-header-text layout=\"column\" \nlayout-align=\"center center\"><strong style=\"color: white\" class=\"font-size-20\">Total de pontos</strong><p \nstyle=\"color: white\">{{vm.totalPontos}}</p></md-card-header-text></md-card-header><md-tooltip md-autohide \nmd-direction=\"top\"><span>Pontos por desenvolvedor</span></md-tooltip></md-card></div></div></md-dialog-content>\n</md-dialog>");
$templateCache.put("app/main/planejamento-scrum/processamento/sprint/views/tabs/meta/dialogs/informacao-calculo-meta-dialog/sprint-dialog-informacao-calculo-meta.html","<md-dialog id=\"sprint-dialog-informacao-calculo-meta\" class=\"dialogo-padrao\" aria-label=\"Dialog\"><form name=\"vm.form\" \nclass=\"md-inline-form\" novalidate><md-toolbar class=\"md-accent md-tall\" layout=\"column\"><div \nclass=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\">\nInformações de cálculo do progresso da meta</span><md-button class=\"md-icon-button\" \nng-click=\"vm.metodosDialog.fecharDialog()\" aria-label=\"Fechar dialog\" translate-attr-aria-label=\"Fechar dialog\">\n<md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content layout=\"column\" flex>\n<fieldset class=\"standard\" flex><legend class=\"grp-legend\" translate=\"Meta com todas as histórias pontuadas\"></legend>\n<div layout-gt-sm=\"row\"><h3>\nSoma-se os pontos de todas as histórias entregues (check-box concluído marcado), e divide pelo número total de pontos da meta.\n</h3></div></fieldset><fieldset class=\"standard\" flex><legend class=\"grp-legend\" \ntranslate=\"Meta com todas as histórias não pontuadas\"></legend><div layout-gt-sm=\"row\"><h3>\nHistórias não pontuadas, para fins de cálculo da porcentagem, terão sua pontuação (zero) convertida para 1 ponto. EX: Caso tenha duas histórias zeradas na meta, soma-se a pontuação delas, onde 1+1 = 2 totalizando a pontuação que deverá ser entregue. Ao concluir apenas uma história, divide-se a pontuação concluída pela pontuação total que deverá ser entregue: 1/2 = 0,5 * 100, sendo assim, temos 50% da meta atingida.\n</h3></div></fieldset><fieldset class=\"standard\" flex><legend class=\"grp-legend\" \ntranslate=\"Meta com histórias pontuadas e não pontuadas\"></legend><div layout-gt-sm=\"row\"><h3>\nBaseando-se nos exemplos acima, soma-se todos os pontos das histórias, lembrando que histórias não pontuadas equivale à 1 ponto e divide pelo número de pontos das histórias que foram entregues. EX: Se a meta possuir 3 histórias de 5 pontos cada e 1 história zerada, temos: 5+5+5+1 = 16 pontos. Ao entregar somente uma história de 5 pontos, chegamos a um percentual de 31,25% da meta concluída. Cálculo: divide-se a pontuação entregue pela pontuação total da meta (5/16 = 0,3125 * 100 = 31,25%).\n</h3></div></fieldset></md-dialog-content></form></md-dialog>");
$templateCache.put("app/main/planejamento-scrum/processamento/estoria/views/tabs/estoria/dialogs/dialog-alterar-data-entrega/estoria-dialog-alterar-data-entrega.html","<md-dialog id=\"estoria-dialog-alterar-data-entrega\" class=\"dialogo-padrao\" aria-label=\"Dialog\"><form \nname=\"vm.form.dialog\" class=\"md-inline-form\" novalidate><md-toolbar class=\"md-accent md-tall\" layout=\"column\"><div \nclass=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\">\n{{vm.titulo}}</span><md-button class=\"md-icon-button\" ng-click=\"vm.metodosDialog.fecharDialog()\" \naria-label=\"Fechar dialog\" translate translate-attr-aria-label=\"SOLUCAO_ROTINAS_TAREFAS.FECHAR_DIALOG\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><div layout=\"row\" layout-sm=\"row\" \nlayout-align=\"center\" ng-show=\"vm.requisicaSolicitada\"><md-progress-circular md-mode=\"indeterminate\" class=\"md-accent\">\n</md-progress-circular></div><md-dialog-content ng-hide=\"vm.requisicaSolicitada\"><div layout=\"column\" \nlayout-align=\"center center\" flex><md-input-container><label translate=\"ESTORIA.DATA_ENTREGA\"></label><md-datepicker \nng-model=\"vm.novaDataEntrega\" name=\"productBacklogDialogDataEntrega\" mascara-conversor-string-para-data \nng-mask=\"3?9/1?9/9999\" ng-required=\"true\"></md-datepicker><div \nng-messages=\"vm.form.dialog.productBacklogDialogDataEntrega.$error\"><div ng-message=\"valid\" \ntranslate=\"MENSAGEM_VALIDACAO.DATA_INVALIDA\"></div><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.DATA_OBRIGATORIA\"></div></div></md-input-container><md-input-container class=\"md-block\" \nflex style=\"margin-top: -10px;width: 100%\"><label>Motivo</label><textarea ng-model=\"vm.motivoAlteracao\" \nname=\"motivoAlteracaoDataEntrega\" ng-required=\"true\" ng-minlength=\"10\" max-rows=\"4\"></textarea><div \nng-messages=\"vm.form.dialog.motivo.$error\" ng-if=\"vm.form.dialog.motivo.$touched\"><div ng-message=\"required\">\nCampo obrigatório</div><div ng-message=\"minlength\">Mínimo 10 caracteres</div></div></md-input-container></div>\n</md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" \nlayout-align=\"end center\" flex><md-button type=\"submit\" ng-click=\"vm.metodosDialog.salvar(vm.estoria, $event)\" \nclass=\"send-button md-accent md-raised\" \nng-disabled=\"!vm.estoria.dataEntrega || !vm.motivoAlteracao || vm.motivoAlteracao.length < 10 || vm.form.dialog.$invalid || vm.requisicaoSolicitada\" \naria-label=\"SALVAR\" translate=\"SPRINT.SALVAR\" translate-attr-aria-label=\"PRODUCT_BACKLOG.SALVAR\">Salvar</md-button>\n</div></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/planejamento-scrum/processamento/estoria/views/tabs/estoria/dialogs/historias-vinculadas-dialog/historias-vinculadas-dialog.html","<md-dialog id=\"historias-vinculadas-dialog\" aria-label=\"Dialog\"><form class=\"md-inline-form\" \nname=\"vm.form.dialogHistoriasVinculadas\" novalidate><md-toolbar class=\"md-accent md-tall\" layout=\"column\"><div \nclass=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\" \nlayout=\"row\">Histórias vinculadas<div ng-if=\"vm.exibeHistoriaPrincipal\">\n&nbsp - História principal: {{ vm.dados.estoriaNumero }}/{{ vm.dados.estoriaAno }}</div></span><md-button \nclass=\"md-icon-button\" aria-label=\"Fechar dialog\" ng-click=\"vm.metodos.fecharDialog()\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content><div layout=\"row\" \nlayout-align=\"center\" ng-if=\"vm.emProgresso\"><md-progress-circular class=\"md-accent\" md-mode=\"indeterminate\" \nmd-diameter=\"75\"></md-progress-circular></div><div layout=\"column\" ng-if=\"!vm.emProgresso\" flex><div layout=\"column\">\n<md-autocomplete md-input-name=\"historias\" md-floating-label=\"Histórias\" md-no-cache=\"true\" \nmd-selected-item=\"vm.historia\" md-selected-item-change=\"vm.metodos.alterarItemSelecionadoAutoComplete(item)\" \nmd-search-text=\"vm.textoDePesquisaAutoComplete\" \nmd-items=\"item in vm.metodos.pesquisarAutoComplete(vm.textoDePesquisaAutoComplete)\" md-item-text=\"item.numero\" \nmd-autoselect ng-blur=\"vm.metodos.configuraAutoCompleteOnBlur()\" flex><md-item-template><span \nmd-highlight-text=\"vm.textoDePesquisaAutoComplete\">{{ item.numero }}/{{ item.ano }}</span></md-item-template>\n<md-not-found><label>Não foi encontrada nenhuma história.</label></md-not-found></md-autocomplete></div><div \nclass=\"md-background-bg md-whiteframe-1dp container-tabela\"><table class=\"dataTable row-border hover\" \ndt-options=\"vm.dtOptions\" width=\"100%\"><thead><tr><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">História</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Descrição</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Stack</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Desenvolvedor</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Tester</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Sprint</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Situação</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\"></span></div></th></tr></thead><tbody><tr ng-if=\"vm.historiaPai != undefined\"><td>\n{{ vm.historiaPai.numero }}/{{ vm.historiaPai.ano }}</td><td>{{ vm.historiaPai.descricao }}</td><td><span \nng-if=\"vm.stacks && vm.historiaPai.stackResponsavel\">\n{{ (vm.stacks | filter:{codigo: vm.historiaPai.stackResponsavel})[0].descricao }}</span></td><td>\n{{ vm.historiaPai.desenvolvedorNome || \'-\' }}</td><td>{{ vm.historiaPai.testerNome || \'-\' }}</td><td><span \nng-if=\"vm.historiaPai.sprint > 0\">{{ vm.historiaPai.sprint }}</span></td><td><div class=\"text-center situacao-estoria\" \nng-repeat=\"situacao in vm.coresSituacoes\" ng-if=\"situacao.codigo ==  vm.historiaPai.situacao\" \nng-style=\"{\'background-color\': situacao.cor}\" \nng-class=\"{\'texto-escuro\': situacao.codigo == 1 || situacao.codigo == 3}\">{{ situacao.descricao }}</div></td><td \nclass=\"text-center\" style=\"min-width: 80px; padding-right: 8px\"><button \nng-click=\"vm.metodos.abrirHistoria(vm.historiaPai)\" ng-if=\"vm.habilitaBotao\"><i \nclass=\"icon-open-in-new s20 icone-cor-padrao mr-10\"></i></button> <i class=\"icon-pin s20\" ng-disabled=\"true\">\n<md-tooltip><span style=\"font-size:12px\">Esta é a história principal.</span></md-tooltip></i></td></tr><tr \nng-repeat=\"historia in vm.dados.historiasVinculadas\"><td>{{ historia.numero }}/{{ historia.ano }}</td><td>\n{{ historia.descricao }}</td><td><span ng-if=\"vm.stacks && historia.stackResponsavel\">\n{{ (vm.stacks | filter:{codigo: historia.stackResponsavel})[0].descricao }}</span></td><td>\n{{ historia.desenvolvedorNome || \'-\' }}</td><td>{{ historia.testerNome || \'-\' }}</td><td><span \nng-if=\"historia.sprint > 0\">{{ historia.sprint }}</span></td><td><div class=\"text-center situacao-estoria\" \nng-repeat=\"situacao in vm.coresSituacoes\" ng-if=\"situacao.codigo == historia.situacao\" \nng-style=\"{\'background-color\': situacao.cor}\" \nng-class=\"{\'texto-escuro\': situacao.codigo == 1 || situacao.codigo == 3}\">{{ situacao.descricao }}</div></td><td \nclass=\"text-center\" style=\"min-width: 80px; padding-right: 8px\"><button ng-click=\"vm.metodos.abrirHistoria(historia)\">\n<i class=\"icon-open-in-new s20 icone-cor-padrao mr-10\"></i></button> <button \nng-click=\"vm.metodos.excluirHistoria(historia)\" offset=\"5\"><i class=\"icon-delete s20 icone-cor-padrao\"></i></button>\n</td></tr></tbody></table></div><md-dialog-actions layout=\"row\" layout-align=\"end center\"><md-button \nclass=\"send-button md-accent md-raised\" type=\"submit\" ng-click=\"vm.metodos.salvarHistoriasVinculadas()\">Salvar\n</md-button></md-dialog-actions></div></md-dialog-content></form></md-dialog>");
$templateCache.put("app/main/planejamento-scrum/processamento/estoria/views/tabs/estoria/dialogs/historico-alteracoes-data-entrega-dialog/historico-alteracoes-data-entrega-dialog.html","<md-dialog id=\"historico-data-alteracao-dialog\" aria-label=\"Dialog\"><form class=\"md-inline-form\" \nname=\"vm.form.dialogHistoriasVinculadas\" novalidate><md-toolbar class=\"md-accent md-tall\" layout=\"column\" \nstyle=\"max-height: 60px; min-height: 60px\"><div class=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" \nlayout-align=\"space-between center\"><span class=\"title\" layout=\"row\">Histórico de alterações da data de entrega</span>\n<md-button class=\"md-icon-button\" aria-label=\"Fechar dialog\" ng-click=\"vm.metodos.fecharDialog()\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content><div \nclass=\"no-results text-center\" ng-if=\"vm.listaHistoricoAlteracoes.length == 0\"><div class=\"message\"><md-icon \nclass=\"message-icon s80\" md-font-icon=\"icon-information-outline\"></md-icon><div class=\"titulo-text\">\nNão foram encontrados registros de alteração na data de entrega.</div></div></div><div \nng-if=\"vm.listaHistoricoAlteracoes.length > 0\" id=\"tabela-historico-alteracao-data-entrega\" \nclass=\"fullpage-datatable scrollable\" ms-scroll style=\"width: 100%\"><table class=\"dataTable row-border hover\" \ndt-options=\"vm.dtOptions\" width=\"100%\"><thead><tr><th class=\"secondary-text border-left\"><div class=\"table-header\">\n<span class=\"column-title\" style=\"margin-left: -14px\">Data da alteração</span></div></th><th \nclass=\"secondary-text border-left\"><div class=\"table-header\"><span class=\"column-title\">Usuário</span></div></th><th \nclass=\"secondary-text border-left\"><div class=\"table-header\"><span class=\"column-title span-acao\">Data anterior</span>\n</div></th><th class=\"secondary-text border-left\"><div class=\"table-header\"><span style=\"margin-left: 5px\" \nclass=\"column-title\">Nova data</span></div></th><th class=\"secondary-text border-left titulo-acoes\"><div \nclass=\"table-header\"><span class=\"column-title\">Motivo</span></div></th></tr></thead><tbody><tr \nng-repeat=\"historico in vm.listaHistoricoAlteracoes\"><td class=\"border-left text-center\">\n{{historico.dataAlteracao ? (historico.dataAlteracao | date:\'dd/MM/yyyy HH:mm:ss\') : \'-\'}}</td><td class=\"border-left\">\n{{historico.nomeUsuario}}</td><td class=\"border-left text-center\">\n{{historico.antigaDataEntrega ? (historico.antigaDataEntrega | date:\'dd/MM/yyyy\') : \'-\'}}</td><td \nclass=\"border-left text-center\">{{historico.novaDataEntrega ? (historico.novaDataEntrega | date:\'dd/MM/yyyy\') : \'-\'}}\n</td><td class=\"titulo-acoes border-left\">{{historico.motivo}}</td></tr></tbody></table></div></md-dialog-content>\n</form></md-dialog>");
$templateCache.put("app/main/planejamento-scrum/processamento/estoria/views/tabs/tarefas/dialogs/alterar-campo-tarefa-dialog/estoria-dialog-alterar-campo-tarefa.html","<md-dialog id=\"estoria-dialog-alterar-campo-tarefa\" class=\"dialogo-padrao\" aria-label=\"Dialog\"><form \nname=\"vm.form.tarefaEditarCamposForm\" class=\"md-inline-form\" novalidate><md-toolbar class=\"md-accent md-tall\" \nlayout=\"column\"><div class=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" layout-align=\"space-between center\">\n<span class=\"title\">{{vm.titulo}}</span><md-button class=\"md-icon-button\" ng-click=\"vm.metodosDialog.fecharDialog()\" \naria-label=\"Fechar dialog\" translate translate-attr-aria-label=\"SPRINT.FECHAR_DIALOG\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><div layout=\"row\" layout-sm=\"row\" \nlayout-align=\"center\" ng-show=\"vm.requisicaSolicitada\"><md-progress-circular md-mode=\"indeterminate\" class=\"md-accent\">\n</md-progress-circular></div><md-dialog-content ng-hide=\"vm.requisicaSolicitada\"><div layout=\"row\" \nlayout-align=\"center center\"><md-input-container ng-if=\"vm.campoTarefaASerEditado === \'dataHoraInicio\'\"><label \ntranslate=\"ESTORIA.DATA_INICIO\"></label><md-datepicker ng-model=\"vm.tarefa.dataHoraInicio\" \nng-disabled=\"vm.desabilitaCamposDialoTarefa\" name=\"estoriaTarefaDataHoraInicio\" ng-mask=\"3?9/1?9/9999\" \nmd-max-date=\"vm.tarefa.dataHoraFim\"></md-datepicker><div \nng-messages=\"vm.form.tarefaEditarCamposForm.estoriaTarefaDataHoraInicio.$error\"><div ng-message=\"valid\" \ntranslate=\"MENSAGEM_VALIDACAO.DATA_INVALIDA\"></div><div ng-message=\"maxdate\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_DATA_INICIAL\"></div></div></md-input-container><md-input-container \nng-if=\"vm.campoTarefaASerEditado === \'dataHoraFim\'\"><label translate=\"ESTORIA.DATA_ENTREGA\"></label><md-datepicker \nng-model=\"vm.tarefa.dataHoraFim\" ng-disabled=\"vm.desabilitaCamposDialoTarefa\" name=\"estoriaTarefaDataHoraFim\" \nng-mask=\"3?9/1?9/9999\" md-min-date=\"vm.tarefa.dataHoraInicio\"></md-datepicker><div \nng-messages=\"vm.form.tarefaEditarCamposForm.estoriaTarefaDataHoraFim.$error\"><div ng-message=\"valid\" \ntranslate=\"MENSAGEM_VALIDACAO.DATA_INVALIDA\"></div><div ng-message=\"mindate\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_DATA_INICIAL\"></div></div></md-input-container><md-input-container \nclass=\"md-block\" flex-gt-sm=\"50\" ng-if=\"vm.campoTarefaASerEditado === \'usuario\'\"><label translate=\"ESTORIA.USUARIO\">\n</label><md-select ng-model=\"vm.tarefa.usuarioCodigo\" name=\"estoriaTarefaUsuarioCodigo\" \nng-disabled=\"vm.desabilitaCamposDialoTarefa\"><md-option ng-value=\"vm.tarefa.usuario.codigo\" \nng-if=\"vm.tarefa.usuario.codigo && vm.tarefa.usuario.codigo != vm.usuarioEstoriaLogado.codigo\">\n{{vm.tarefa.usuario.login}}</md-option><md-option ng-value=\"vm.usuarioEstoriaLogado.codigo\">\n{{vm.usuarioEstoriaLogado.login}}</md-option><md-option ng-if=\"vm.tarefa.usuarioCodigo\" ng-value=\" \">Desmarcar\n</md-option></md-select></md-input-container></div></md-dialog-content><md-dialog-actions layout=\"row\"><div \nlayout=\"row\" layout-align=\"end center\" flex><md-button type=\"submit\" \nng-click=\"vm.metodosDialog.salvarAlteracoes($event, vm.tarefa)\" class=\"send-button md-accent md-raised\" \nng-disabled=\"vm.form.tarefaEditarCamposForm.$invalid || vm.requisicaoSolicitada\" aria-label=\"SALVAR\" \ntranslate=\"ESTORIA.SALVAR\" translate-attr-aria-label=\"ESTORIA.SALVAR\">Salvar</md-button></div></md-dialog-actions>\n</form></md-dialog>");
$templateCache.put("app/main/planejamento-scrum/processamento/estoria/views/tabs/tarefas/dialogs/tarefa-dialog/estoria-dialog-tarefas.html","<md-dialog id=\"estoria-dialog-tarefas\" class=\"dialogo-padrao\" aria-label=\"Dialog\"><form name=\"tarefaForm\" \nclass=\"md-inline-form\" novalidate><md-toolbar class=\"md-accent md-tall\" layout=\"column\"><div \nclass=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\">\n{{vm.titulo}}</span><md-button class=\"md-icon-button\" ng-click=\"vm.metodosDialog.fecharDialog()\" \naria-label=\"Fechar dialog\" translate translate-attr-aria-label=\"ESTORIA.FECHAR_DIALOG\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><div layout=\"row\" layout-sm=\"row\" \nlayout-align=\"center\" ng-show=\"vm.requisicaSolicitada || vm.preloader.habilitar\"><md-progress-circular \nmd-mode=\"indeterminate\" class=\"md-accent\"></md-progress-circular></div><md-dialog-content \nng-hide=\"vm.requisicaSolicitada || vm.preloader.habilitar\"><div layout-gt-sm=\"row\" layout-xs=\"row\"><md-input-container \nclass=\"md-block\" flex-gt-sm=\"25\"><label translate=\"ESTORIA.NUMERO\"></label><input type=\"number\" \nng-model=\"vm.tarefa.estoriaNumero\" name=\"estoriaTarefaNumero\" ng-disabled=\"true\"></md-input-container>\n<md-input-container class=\"md-block\" flex-gt-sm=\"25\"><label translate=\"ESTORIA.ANO\"></label><input type=\"number\" \nng-model=\"vm.tarefa.estoriaAno\" name=\"estoriaTarefaNumero\" ng-disabled=\"true\"></md-input-container></div><div \nlayout-gt-xs=\"row\" layout-xs=\"row\"><md-input-container ng-if=\"vm.tarefa.rotinaCodigo\" class=\"md-block\" flex-gt-sm=\"10\">\n<label translate=\"ESTORIA.CODIGO_ROTINA\"></label><input type=\"text\" ng-model=\"vm.tarefa.rotinaCodigo\" \nname=\"estoriaTarefaCodigoRotina\" ng-disabled=\"true\"></md-input-container><md-input-container class=\"md-block\" \nflex-gt-sm=\"30\"><label translate=\"ESTORIA.TIPO_TAREFA\">Tipo Tarefa</label><md-select ng-model=\"vm.tarefa.tipo\" \nname=\"estoriaTarefaTipoTarefa\" \nng-disabled=\"vm.desabilitaCamposDialoTarefa || !vm.inserirAtivo && vm.tarefa.rotinaCodigo\" \nng-required=\"vm.inserirAtivo\"><md-option ng-value=\"key\" ng-repeat=\"(key, value) in vm.tiposTarefa track by key\">\n{{value}}</md-option></md-select><div ng-messages=\"tarefasForm.estoriaTarefaTipoTarefa.$error\"><div \nng-message=\"required\" translate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container>\n<md-input-container class=\"md-block\" flex-gt-sm=\"20\"><label translate=\"ESTORIA.USUARIO\"></label><md-select \nng-model=\"vm.tarefa.usuarioCodigo\" name=\"estoriaTarefaUsuarioCodigo\" ng-disabled=\"vm.desabilitaCamposDialoTarefa\">\n<md-option></md-option><md-option ng-value=\"vm.tarefa.usuario.codigo\" \nng-if=\"vm.tarefa.usuario.codigo && vm.tarefa.usuario.codigo != vm.usuarioEstoriaLogado.codigo\">\n{{vm.tarefa.usuario.login}}</md-option><md-option ng-value=\"vm.usuarioEstoriaLogado.codigo\">\n{{vm.usuarioEstoriaLogado.login}}</md-option></md-select></md-input-container></div><div layout-gt-xs=\"row\">\n<md-input-container class=\"md-block\" flex-gt-sm><label translate=\"ESTORIA.DESCRICAO\"></label><input type=\"text\" \nng-model=\"vm.tarefa.descricao\" name=\"estoriaTarefaDescricao\" mascara-tamanho-campo=\"150\" \nng-disabled=\"vm.desabilitaCamposDialoTarefa\" ng-required=\"true\" md-maxlength=\"150\"><div \nng-messages=\"tarefaForm.estoriaTarefaDescricao.$error\"><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container></div><div layout-gt-xs=\"row\" flex>\n<md-input-container class=\"md-block\" flex-gt-sm=\"10\"><label translate=\"ESTORIA.PONTOS\"></label><input type=\"text\" \nng-model=\"vm.tarefa.pontos\" ng-disabled=\"vm.desabilitaCamposDialoTarefa\" name=\"estoriaTarefaPontos\" \nmascara-numeros=\"3\"></md-input-container><md-input-container class=\"md-block\" flex-offset-gt-sm=\"10\"><label \ntranslate=\"ESTORIA.DATA_INICIO\"></label><md-datepicker ng-model=\"vm.tarefa.dataHoraInicio\" \nng-disabled=\"vm.desabilitaCamposDialoTarefa\" id=\"estoria-dialog-tarefas-md-datepicker-data-inicio\" \nname=\"estoriaTarefaDataHoraInicio\" mascara-conversor-string-para-data ng-mask=\"3?9/1?9/9999\" \nmd-max-date=\"vm.tarefa.dataHoraFim\"></md-datepicker><div ng-messages=\"tarefaForm.estoriaTarefaDataHoraInicio.$error\">\n<div ng-message=\"valid\" translate=\"MENSAGEM_VALIDACAO.DATA_INVALIDA\"></div><div ng-message=\"maxdate\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_DATA_INICIAL\"></div></div></md-input-container><md-input-container \nclass=\"md-block\"><label translate=\"ESTORIA.DATA_ENTREGA\"></label><md-datepicker flex=\"20\" \nng-model=\"vm.tarefa.dataHoraFim\" ng-disabled=\"vm.desabilitaCamposDialoTarefa\" name=\"estoriaTarefaDataHoraFim\" \nmascara-conversor-string-para-data ng-mask=\"3?9/1?9/9999\" md-min-date=\"vm.tarefa.dataHoraInicio\"></md-datepicker><div \nng-messages=\"tarefaForm.estoriaTarefaDataHoraFim.$error\"><div ng-message=\"valid\" \ntranslate=\"MENSAGEM_VALIDACAO.DATA_INVALIDA\"></div><div ng-message=\"mindate\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_DATA_INICIAL\"></div></div></md-input-container></div><fieldset \nng-if=\"!vm.inserirAtivo || !vm.desabilitaCamposDialoTarefa\" \nng-class=\"{\'border-color-fieldset-transparent\': !vm.inserirRegistro}\"><legend><md-input-container class=\"md-block\">\n<md-checkbox ng-hide=\"vm.inserirAtivo || vm.desabilitaCamposDialoTarefa\" ng-model=\"vm.inserirRegistro\" \nng-click=\"vm.metodosDialog.inserirRegistroNaSprint()\" aria-label=\"Adicionar Registro na Sprint\" translate \ntranslate-attr-aria-label=\"ESTORIA.ADICIONAR_REGISTRO_NA_SPRINT\"><span \ntranslate=\"ESTORIA.ADICIONAR_REGISTRO_NA_SPRINT\"></span></md-checkbox></md-input-container></legend><div layout=\"row\" \nlayout-sm=\"row\" layout-align=\"center center\" ng-show=\"vm.requisicaInserirRegistroSolicitada\"><md-progress-circular \nmd-mode=\"indeterminate\" class=\"md-accent\"></md-progress-circular></div><md-content flex \nng-show=\"vm.inserirRegistro && !vm.requisicaInserirRegistroSolicitada\"><div layout-gt-xs=\"row\"><md-input-container \nclass=\"md-block\" flex-gt-sm=\"15\"><label translate=\"ESTORIA.DURACAO\"></label><input type=\"text\" \nng-model=\"vm.tarefa.registro.horas\" name=\"estoriaDialogTarefaDuracao\" flex-offset-gt-sm=\"5\" placeholder=\"\" translate \ntranslate-attr-placeholder=\"ESTORIA.DURACAO_PLACEHOLDER\" mascara-numero-generica=\"##:##\" ng-minlength=\"5\" \nng-required=\"vm.inserirRegistro\"><div ng-messages=\"tarefaForm.estoriaDialogTarefaDuracao.$error\"><div \nng-message=\"required\" translate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div><div ng-message=\"minlength\" \ntranslate=\"MENSAGEM_VALIDACAO.PATTERN_PARA_HORAS\"></div></div></md-input-container><md-input-container \nclass=\"md-block\" flex-gt-sm=\"20\"><label translate=\"ESTORIA.SITUACAO_REGISTRO\">Situação Registro</label><md-select \nng-model=\"vm.tarefa.registro.registroSituacaoCodigo\" name=\"estoriaDialogTarefaSituacao\" \nng-required=\"vm.inserirRegistro\"><md-option ng-value=\"registroSituacao.codigo\" \nng-repeat=\"registroSituacao in vm.registrosSituacoes track by registroSituacao.codigo\">{{registroSituacao.descricao}}\n</md-option></md-select><div ng-messages=\"tarefaForm.estoriaDialogTarefaSituacao.$error\"><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container></div><div layout-gt-xs=\"row\">\n<md-input-container class=\"md-block\" flex><label translate=\"ESTORIA.DESCRICAO\">Descrição</label><textarea \nng-model=\"vm.tarefa.registro.descricao\" name=\"estoriaDialogTarefaDescricao\" ng-required=\"vm.inserirRegistro\" \nmd-no-resize=\"true\" rows=\"3\" max-rows=\"5\">\r\n              </textarea><div \nng-messages=\"tarefaForm.estoriaDialogTarefaDescricao.$error\"><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container></div></md-content></fieldset>\n</md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" \nlayout-align=\"start center\"><md-button type=\"submit\" ng-click=\"vm.metodosDialog.salvar(vm.tarefa, $event)\" \nclass=\"send-button md-accent md-raised\" \nng-disabled=\"tarefaForm.$invalid || tarefaForm.$pristine || vm.requisicaSolicitada || vm.desabilitaCamposDialoTarefa\" \naria-label=\"SALVAR\" translate=\"ESTORIA.SALVAR\" translate-attr-aria-label=\"ESTORIA.SALVAR\">Salvar</md-button></div><div \nlayout=\"row\"><md-button class=\"md-icon-button\" ng-click=\"vm.metodosDialog.excluir(vm.tarefa, $event)\" \nng-hide=\"vm.novaTarefa\" ng-disabled=\"vm.requisicaSolicitada || vm.desabilitaCamposDialoTarefa\" aria-label=\"Excluir\" \ntranslate translate-attr-aria-label=\"ESTORIA.EXCLUIR\"><md-icon md-font-icon=\"icon-delete\"></md-icon></md-button></div>\n</md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/financeiro/processamento/contratos/views/tabs/tab-itens/dialogs/itens-dialog/detalhes-equipamentos-dialog/detalhes-equipamentos-dialog.html","<div id=\"contratos-dialog-detalhes-equipamentos\" class=\"dialog\"><md-dialog style=\"max-width: 100%\"><md-toolbar><div \nclass=\"md-toolbar-tools\" style=\"background-color: #039BE5\"><h2>Detalhes por tipo de equipamento</h2><span flex></span>\n<md-button class=\"md-icon-button\" ng-click=\"vm.metodos.fecharDialog()\" aria-label=\"Fechar dialog\" translate \ntranslate-attr-aria-label=\"CLIENTE.FECHAR_DIALOG\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content class=\"dialog-detalhes-equipamentos\"><table class=\"dataTable row-border hover\" \ndatatable=\"ng\" dt-options=\"vm.dtOptions\" style=\"width: 100%\"><thead class=\"table-header\"><th class=\"secondary-text\">\n<div class=\"table-header\"><span class=\"column-title text-center\">Equipamento</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title text-center\">N° de série</span></div></th>\n<th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title text-center\">Fornecedor</span></div>\n</th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title text-center\">Nota compra</span>\n</div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title text-center\">Data compra\n</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title text-center\">Garantia\n</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title text-center\">\nNota saída</span></div></th></thead><tbody><tr ng-repeat=\"equipamento in vm.equipamentos\"><td>\n{{ equipamento.equipamento }}</td><td>{{ equipamento.numeroSerie }}</td><td>{{ equipamento.fornecedor }}</td><td>\n{{ equipamento.notaCompra }}</td><td><span ng-hide=\"true\">{{ equipamento.dataCompra }}</span>\n {{ equipamento.dataCompra | date: \'dd/MM/yyyy\' }}</td><td class=\"text-center\">{{ equipamento.garantia }}</td><td>\n{{ equipamento.notaSaida }}</td></tr></tbody></table></md-dialog-content></md-dialog></div>");
$templateCache.put("app/main/financeiro/processamento/contratos/views/tabs/tab-itens/dialogs/itens-dialog/observacao-data-inicial-dialog/observacao-data-inicial-dialog.html","<md-dialog id=\"observacao-data-inicial-dialog\" class=\"dialogo-padrao\" aria-label=\"Dialog\"><form name=\"vm.form\" \nclass=\"md-inline-form\" novalidate><md-toolbar class=\"md-accent md-tall\" layout=\"column\"><div \nclass=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" layout-align=\"space-between center\" flex><div layout=\"row\" \nlayout-align=\"center\" flex><span class=\"title text-center\">Observação do item</span></div></div></md-toolbar><div \nlayout=\"column\" layout-align=\"center center\" ng-show=\"vm.requisicaoSolicitada\"><span class=\"font-weight-500\">\n{{vm.mensagemPreloader}}</span><md-progress-circular md-mode=\"indeterminate\" md-diameter=\"30\" class=\"md-accent\">\n</md-progress-circular></div><md-dialog-content><div layout=\"row\" flex layout-align=\"start center\"><md-input-container \nclass=\"md-block\" flex=\"100\"><label translate=\"CONTRATOS.OBSERVACAO\"></label><textarea name=\"observacao\" max-rows=\"8\" \nmascara-tamanho-campo=\"500\" md-maxlength=\"500\" md-no-resize=\"true\" \nng-model=\"vm.contratoItem.observacaoContratoHistorico\">\r\n                    </textarea></md-input-container>\n<md-input-container class=\"md-block container-data\" flex=\"25\"><label>Data inicial do item</label><md-datepicker \nname=\"dataInicialContrato\" mascara-conversor-string-para-data ng-required=\"true\" md-min-date=\"vm.dataMinimaContrato\" \nng-mask=\"3?9/1?9/9999\" ng-model=\"vm.contratoItem.dataContratoHistorico\"></md-datepicker><div \nng-messages=\"vm.form.dataInicialContrato.$error\"><div ng-message=\"valid\" translate=\"MENSAGEM_VALIDACAO.DATA_INVALIDA\">\n</div><div ng-message=\"required\" translate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div><div ng-message=\"mindate\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_DATA_FINAL\"></div></div></md-input-container></div></md-dialog-content>\n<md-dialog-actions layout=\"row\" layout-align=\"start center\"><div layout=\"row\" layout-align=\"start center\"><md-button \ntype=\"submit\" ng-click=\"vm.metodos.salvar(vm.contratoItem)\" class=\"send-button md-accent md-raised\" \nng-disabled=\"vm.form.$invalid || vm.requisicaoSolicitada\" aria-label=\"SALVAR\" translate=\"CONTRATOS.SALVAR\" \ntranslate-attr-aria-label=\"CONTRATOS.SALVAR\">Salvar</md-button></div></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/financeiro/processamento/contratos/views/tabs/tab-itens/dialogs/itens-dialog/observacao-subitem-dialog/observacao-subitem-dialog.html","<md-dialog id=\"dialog-observacao-subitem\" class=\"dialogo-padrao\" aria-label=\"Dialog\"><form class=\"md-inline-form\" \nname=\"vm.form\" novalidate><md-toolbar class=\"md-accent md-tall\" layout=\"column\"><div \nclass=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\">\n{{vm.titulo}}</span><md-button class=\"md-icon-button\" aria-label=\"Fechar dialog\" translate \ntranslate-attr-aria-label=\"CLIENTE.FECHAR_DIALOG\" ng-click=\"vm.metodos.fecharDialog()\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content><div layout=\"column\">\n<text-angular ng-model=\"vm.subitem.observacao\" \nta-toolbar=\"[[\'h1\', \'h2\', \'h3\', \'h4\', \'h5\', \'p\', \'pre\', \'quote\', \'bold\', \'italics\', \'underline\', \'ul\', \'ol\', \'redo\', \'undo\', \'justifyLeft\', \'justifyCenter\', \'justifyRight\', \'justifyFull\', \'indent\', \'outdent\', \'clear\']]\" \nta-disabled=\"vm.apenasVisualizacao\"></text-angular></div></md-dialog-content><md-dialog-actions layout=\"column\" \nlayout-gt-sm=\"row\" layout-align=\"space-between center\" ng-if=\"!vm.apenasVisualizacao\"><div layout=\"row\" \nlayout-align=\"start center\"><md-button class=\"send-button md-accent md-raised\" type=\"submit\" aria-label=\"SALVAR\" \ntranslate=\"CLIENTE.SALVAR\" translate-attr-aria-label=\"CLIENTE.SALVAR\" ng-click=\"vm.metodos.salvar()\" \nng-disabled=\"vm.form.$invalid\">Salvar</md-button></div></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/geral/cadastro/cliente/cliente/views/tabs/cliente/dialogs/caracteristica-dialog/cliente-dialog-caracteristica.html","<md-dialog id=\"cliente-dialog-caracteristica\" class=\"dialogo-padrao\" aria-label=\"Dialog\"><form name=\"vm.form\" \nclass=\"md-inline-form\" novalidate><md-toolbar class=\"md-accent md-tall\" layout=\"column\"><div \nclass=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\">\n{{vm.titulo}}</span><md-button class=\"md-icon-button\" ng-click=\"vm.metodosDialog.fecharDialog()\" \naria-label=\"Fechar dialog\" translate translate-attr-aria-label=\"SPRINT.FECHAR_DIALOG\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><div layout=\"column\" class=\"mt-10\" \nlayout-align=\"center center\" ng-show=\"vm.preloader.requisicaoSolicitada && !vm.baixandoArquivos\"><span \nclass=\"font-weight-500\">{{vm.preloader.mensagemPreloader}}</span><md-progress-circular md-mode=\"indeterminate\" \nmd-diameter=\"30\" class=\"md-accent\"></md-progress-circular></div><md-dialog-content><div layout-gt-xs=\"row\"><div \nlayout=\"row\" layout-align=\"center center\" flex><md-input-container flex-gt-sm=\"5\" class=\"md-block\" flex-gt-xs><label \nhide-gt-sm translate=\"CLIENTE.PESQUISAR_CARACTERISTICA_POR_CODIGO\"></label><input text=\"text\" \nng-model=\"vm.caracteristicaAPesquisar\" aria-label=\"Diretiva Pesquisar por Codigo\" pesquisar-por-codigo \nlista-a-pesquisar=\"vm.caracteristicas\" ng-disabled=\"vm.preloader.requisicaoSolicitada\" \nentidade-pesquisada=\"vm.caracteristicaCliente.codigoCaracteristica\" mascara-numeros=\"5\"></md-input-container>\n<md-input-container class=\"md-block\" style=\"margin-top: -7px\" flex-gt-sm=\"50\"><label \ntranslate=\"CLIENTE.CARACTERISTICA\"></label><md-select ng-model=\"vm.caracteristicaCliente.codigoCaracteristica\" \nname=\"codigoCaracteristica\" md-on-open=\"vm.metodosDialog.configurarMdSelectCaracteristica()\" \nng-disabled=\"vm.preloader.requisicaoSolicitada\"><md-select-header><input \nid=\"dialog-cliente-caracteristica-md-select-caracteristica\" class=\"md-text\" ng-model=\"vm.filtrarCaracteristica\" \ntype=\"search\" placeholder=\"\" translate translate-attr-placeholder=\"CLIENTE.PESQUISAR_CARACTERISTICA\">\n</md-select-header><md-option ng-value=\"caracteristica.codigo\" \nng-repeat=\"caracteristica in vm.caracteristicas | filter:vm.filtrarCaracteristica track by caracteristica.codigo\">\n{{caracteristica.descricao}}</md-option><md-option ng-value=\"\" ng-if=\"vm.caracteristicaCliente.codigoCaracteristica\">\nDesmarcar</md-option></md-select><div ng-messages=\"vm.form.codigoCaracteristica.$error\"><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container></div><div layout=\"row\" \nlayout-align=\"start center\"><md-button type=\"submit\" style=\"margin-top: -10px\" \nng-click=\"vm.metodosDialog.cadastrarCaracteristica(vm.caracteristicaCliente, $event)\" \nclass=\"send-button md-accent md-raised\" \nng-disabled=\"vm.form.$pristine || vm.preloader.requisicaSolicitada || !vm.caracteristicaCliente.codigoCaracteristica\" \naria-label=\"SALVAR\" translate=\"CLIENTE.SALVAR\" translate-attr-aria-label=\"CLIENTE.SALVAR\">Salvar</md-button></div>\n</div><md-divider></md-divider><div layout=\"row\" flex class=\"mt-20\" layout-wrap><table \nclass=\"dataTable row-border hover border\" datatable=\"ng\" dt-options=\"vm.dtOptions\" width=\"100%\"><thead><tr><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Ação</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Código</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Descrição</span></div></th></tr></thead>\n<tbody><tr \nng-repeat=\"caracteristicaCliente in vm.caracteristicasCliente | orderBy: \'descricao\' track by caracteristicaCliente.codigo\">\n<td class=\"button-icone-cor-azul\"><i class=\"icon-delete s16 icone-cor-padrao\" \nng-click=\"vm.preloader.requisicaoSolicitada || vm.metodosDialog.excluirCaracteristica(caracteristicaCliente, $event)\" \nng-disabled=\"vm.preloader.requisicaoSolicitada\"></i></td><td>{{caracteristicaCliente.codigo}}</td><td>\n{{caracteristicaCliente.descricao}}</td></tr></tbody></table></div></md-dialog-content></form></md-dialog>");
$templateCache.put("app/main/geral/cadastro/cliente/cliente/views/tabs/cliente/dialogs/atendimento-dialog/cliente-dialog-atendimento.html","<md-dialog id=\"cliente-dialog-atendimento\" class=\"dialogo-padrao\" aria-label=\"Dialog\"><form name=\"vm.form\" \nclass=\"md-inline-form\" novalidate><md-toolbar class=\"md-accent md-tall\" layout=\"column\"><div \nclass=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\">\n{{vm.titulo}}</span><md-button class=\"md-icon-button\" ng-click=\"vm.metodosDialog.fecharDialog()\" \naria-label=\"Fechar dialog\" translate translate-attr-aria-label=\"SPRINT.FECHAR_DIALOG\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><div layout=\"column\" layout-align=\"center center\" \nng-show=\"vm.requisicaoSolicitada && !vm.baixandoArquivos\"><span class=\"font-weight-500\">{{vm.mensagemPreloader}}</span>\n<md-progress-circular md-mode=\"indeterminate\" md-diameter=\"30\" class=\"md-accent\"></md-progress-circular></div>\n<md-dialog-content><div layout=\"row\" layout-align=\"center center\"><fieldset><legend translate=\"CLIENTE.ATENDIMENTO\">\nAtendimento</legend><md-radio-group ng-model=\"vm.tipoAtendimento\" ng-change=\"vm.metodosDialog.ngChangeRadioGroup()\" \nlayout-padding><md-radio-button value=\"1\" class=\"mr-10\" ng-disabled=\"vm.requisicaoSolicitada\" \naria-label=\"Novo Atendimento\"><label>Novo Atendimento</label></md-radio-button><md-radio-button value=\"2\" \nng-disabled=\"vm.requisicaoSolicitada\" aria-label=\"Continuar Atendimento\"><label>Continuar Atendimento</label>\n</md-radio-button></md-radio-group></fieldset></div><md-tabs md-dynamic-height md-border-bottom layout-padding><md-tab \nlabel=\"Cliente\" md-active=\"vm.tabSelecionada === \'atendimentosEmAberto\'\" \nmd-on-select=\"vm.metodosDialog.tabSelecionada(\'atendimentosEmAberto\')\" ng-disabled=\"vm.requisicaoSolicitada\">\n<md-tab-label><label translate=\"CLIENTE.ATENDIMENTOS_EM_ABERTO\"></label></md-tab-label><md-tab-body><div \nng-include=\"vm.htmlRota.tabs.tabAtendimentosEmAberto\"></div></md-tab-body></md-tab><md-tab label=\"Dados Auxiliares\" \nmd-active=\"vm.tabSelecionada === \'todosAtendimentos\'\" \nmd-on-select=\"vm.metodosDialog.tabSelecionada(\'todosAtendimentos\')\" ng-disabled=\"vm.requisicaoSolicitada\">\n<md-tab-label><label translate=\"CLIENTE.TODOS_ATENDIMENTOS\"></label></md-tab-label><md-tab-body><div \nng-include=\"vm.htmlRota.tabs.todosAtendimentos\"></div></md-tab-body></md-tab></md-tabs></md-dialog-content>\n<md-dialog-actions layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\">\n<md-button type=\"submit\" \nng-click=\"vm.metodosDialog.continuarParaAtendimento(vm.atendimentoSelecionado, vm.tipoAtendimento, $event)\" \nclass=\"send-button md-accent md-raised\" \nng-disabled=\"vm.requisicaoSolicitada || (vm.tipoAtendimento == 2 && vm.indexAtendimentoSelecionado == null)\" \naria-label=\"Continuar\" translate=\"CLIENTE.CONFIRMAR\" translate-attr-aria-label=\"CLIENTE.CONFIRMAR\">Confirmar\n</md-button></div><div layout=\"row\" layout-align=\"end center\" style=\"margin-right: 8px\"><md-button \nng-click=\"vm.metodosDialog.fecharDialog()\" class=\"send-button md-accent md-raised\" aria-label=\"Cancelar\" \ntranslate=\"CLIENTE.CANCELAR\" translate-attr-aria-label=\"CLIENTE.CANCELAR\">Cancelar</md-button></div>\n</md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/geral/cadastro/cliente/cliente/views/tabs/cliente/dialogs/contrato-dialog/cliente-dialog-contrato.html","<md-dialog id=\"cliente-dialog-pessoa-de-referencia\" class=\"dialogo-padrao\" aria-label=\"Dialog\"><md-button \nclass=\"md-icon-button button-flutuante\" ng-click=\"vm.metodosGeral.fecharDialog()\" aria-label=\"Fechar dialog\"><md-icon \nmd-font-icon=\"icon-close\" class=\"cor-icone-button-flutuante s26\"></md-icon><md-tooltip>Fechar Dialog</md-tooltip>\n</md-button><div class=\"scrollable\" ms-scroll ui-view=\"contratos@app.geral_cadastro_cliente_cliente\"></div></md-dialog>");
$templateCache.put("app/main/geral/cadastro/cliente/cliente/views/tabs/configuracoes/tabs/tab-iservice/tab-iservice-configuracoes.html","<md-content><div layout-gt-xs=\"row\" flex><fieldset class=\"standard\" flex=\"100\"><legend class=\"grp-legend\" \ntranslate=\"CLIENTE.CONFIGURACOES\"></legend><div layout=\"row\" flex><md-input-container class=\"md-block\" flex><label \ntranslate=\"CLIENTE.API\"></label><input type=\"text\" name=\"api\" mascara-tamanho-campo=\"100\" md-maxlength=\"100\" \nng-model=\"vm.cliente.clienteConfiguracao.configIserviceApi\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && \r\n                           !vm.controleForm.inserirAtivo\">\n</md-input-container><div layout=\"row\" flex><md-input-container class=\"md-block\" flex flex-offset=\"5\"><label \ntranslate=\"CLIENTE.FRONT\"></label><input type=\"text\" name=\"front\" mascara-tamanho-campo=\"100\" md-maxlength=\"100\" \nng-model=\"vm.cliente.clienteConfiguracao.configIserviceFront\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && \r\n                               !vm.controleForm.inserirAtivo\">\n<md-icon class=\"icon-open-in-new icone-abrir-nova-aba\" ng-if=\"vm.cliente.clienteConfiguracao.configIserviceFront\" \nng-click=\"vm.metodosGeral.abrirSolucao(vm.cliente.clienteConfiguracao.configIserviceFront)\"><md-tooltip md-autohide>\n<span>Abrir IService em nova aba</span></md-tooltip></md-icon></md-input-container></div></div><div layout=\"row\" flex>\n<md-input-container class=\"md-block\" flex><label translate=\"CLIENTE.CONFIG\"></label><input type=\"text\" name=\"config\" \nng-model=\"vm.cliente.clienteConfiguracao.configIserviceConfig\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && \r\n       !vm.controleForm.inserirAtivo\">\n</md-input-container><md-input-container class=\"md-block\" flex flex-offset=\"5\"><label \ntranslate=\"CLIENTE.TIPO_PROCESSO\"></label><input type=\"text\" name=\"tipoProcesso\" mascara-numero-generica=\"#\" \nng-model=\"vm.cliente.clienteConfiguracao.configIserviceTipoProcesso\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && \r\n                           !vm.controleForm.inserirAtivo\">\n</md-input-container><md-input-container class=\"md-block\" flex flex-offset=\"5\"><label translate=\"CLIENTE.USUARIO\">\n</label><input type=\"text\" name=\"usuario\" ng-model=\"vm.cliente.clienteConfiguracao.configIserviceUsuario\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && \r\n                           !vm.controleForm.inserirAtivo\">\n</md-input-container><md-input-container class=\"md-block\" flex flex-offset=\"5\"><label translate=\"CLIENTE.SENHA\">\n</label><input type=\"text\" name=\"senha\" ng-model=\"vm.cliente.clienteConfiguracao.configIserviceSenha\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && \r\n                           !vm.controleForm.inserirAtivo\">\n<md-icon class=\"icon-content-copy icone-abrir-nova-aba\" ng-if=\"vm.cliente.clienteConfiguracao.configIserviceSenha\" \nng-click=\"vm.metodosGeral.copiarParaClipboard(vm.cliente.clienteConfiguracao.configIserviceSenha)\"><md-tooltip \nmd-autohide><span>Copiar senha</span></md-tooltip></md-icon></md-input-container></div></fieldset></div></md-content>");
$templateCache.put("app/main/geral/cadastro/cliente/cliente/views/tabs/configuracoes/tabs/tab-iaguas/tab-iaguas-configuracoes.html","<md-content><div layout-gt-xs=\"row\" flex><fieldset class=\"standard\" flex=\"100\"><legend class=\"grp-legend\" \ntranslate=\"CLIENTE.CONFIGURACOES\"></legend><div layout=\"row\" flex><md-input-container class=\"md-block\" flex><label \ntranslate=\"CLIENTE.API\"></label><input type=\"text\" name=\"api\" mascara-tamanho-campo=\"100\" md-maxlength=\"100\" \nng-model=\"vm.cliente.clienteConfiguracao.configIaguasApi\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && \r\n                           !vm.controleForm.inserirAtivo\">\n</md-input-container><md-input-container class=\"md-block\" flex flex-offset=\"5\"><label translate=\"CLIENTE.FRONT\">\n</label><input type=\"text\" name=\"front\" mascara-tamanho-campo=\"100\" md-maxlength=\"100\" \nng-model=\"vm.cliente.clienteConfiguracao.configIaguasFront\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && \r\n                           !vm.controleForm.inserirAtivo\">\n<md-icon ng-if=\"vm.cliente.clienteConfiguracao.configIaguasFront\" class=\"icon-open-in-new icone-abrir-nova-aba\" \nng-click=\"vm.metodosGeral.abrirSolucao(vm.cliente.clienteConfiguracao.configIaguasFront)\"><md-tooltip md-autohide>\n<span>Abrir IÁguas em nova aba</span></md-tooltip></md-icon></md-input-container></div></fieldset></div></md-content>");
$templateCache.put("app/main/geral/cadastro/cliente/cliente/views/tabs/cliente/dialogs/dialog-estatisticas-tags/dialog-estatisticas-tags.html","<md-dialog id=\"cliente-dialog-pessoa-de-referencia\" class=\"dialogo-padrao\" aria-label=\"Dialog\"><md-button \nclass=\"md-icon-button button-flutuante\" ng-click=\"vm.metodos.fecharDialog()\" aria-label=\"Fechar dialog\"><md-icon \nmd-font-icon=\"icon-close\" class=\"cor-icone-button-flutuante s26\"></md-icon><md-tooltip>Fechar Dialog</md-tooltip>\n</md-button><div class=\"scrollable\" ms-scroll ui-view=\"estatisticas-tags@app.geral_cadastro_cliente_cliente\"></div>\n</md-dialog>");
$templateCache.put("app/main/geral/cadastro/cliente/cliente/views/tabs/configuracoes/tabs/tab-reader/tab-reader-configuracoes.html","<md-content><div layout-gt-xs=\"row\" flex><fieldset class=\"standard\" flex=\"100\"><legend class=\"grp-legend\" \ntranslate=\"CLIENTE.CONFIGURACOES\"></legend><div layout=\"row\" flex><md-input-container class=\"md-block\" flex><label \ntranslate=\"CLIENTE.API\"></label><input type=\"text\" name=\"api\" mascara-tamanho-campo=\"100\" md-maxlength=\"100\" \nng-model=\"vm.cliente.clienteConfiguracao.configReaderApi\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && \r\n                           !vm.controleForm.inserirAtivo\">\n</md-input-container><md-input-container class=\"md-block\" flex flex-offset=\"5\"><label translate=\"CLIENTE.FRONT\">\n</label><input type=\"text\" name=\"front\" mascara-tamanho-campo=\"100\" md-maxlength=\"100\" \nng-model=\"vm.cliente.clienteConfiguracao.configReaderFront\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && \r\n                           !vm.controleForm.inserirAtivo\">\n<md-icon ng-if=\"vm.cliente.clienteConfiguracao.configReaderFront\" class=\"icon-open-in-new icone-abrir-nova-aba\" \nng-click=\"vm.metodosGeral.abrirSolucao(vm.cliente.clienteConfiguracao.configReaderFront)\"><md-tooltip md-autohide>\n<span>Abrir Reader em nova aba</span></md-tooltip></md-icon></md-input-container></div><div layout=\"row\" flex>\n<md-input-container class=\"md-block\" flex><label translate=\"CLIENTE.USUARIO\"></label><input type=\"text\" name=\"usuario\" \nng-model=\"vm.cliente.clienteConfiguracao.configReaderUsuario\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && \r\n                           !vm.controleForm.inserirAtivo\">\n</md-input-container><md-input-container class=\"md-block\" flex flex-offset=\"5\"><label translate=\"CLIENTE.SENHA\">\n</label><input type=\"text\" name=\"senha\" ng-model=\"vm.cliente.clienteConfiguracao.configReaderSenha\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && \r\n                           !vm.controleForm.inserirAtivo\">\n<md-icon class=\"icon-content-copy icone-abrir-nova-aba\" ng-if=\"vm.cliente.clienteConfiguracao.configReaderSenha\" \nng-click=\"vm.metodosGeral.copiarParaClipboard(vm.cliente.clienteConfiguracao.configReaderSenha)\"><md-tooltip \nmd-autohide><span>Copiar senha</span></md-tooltip></md-icon></md-input-container><md-input-container class=\"md-block\" \nflex flex-offset=\"5\"><label translate=\"CLIENTE.CONFIG\"></label><input type=\"text\" name=\"config\" \nng-model=\"vm.cliente.clienteConfiguracao.configReaderConfig\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && \r\n                           !vm.controleForm.inserirAtivo\">\n</md-input-container></div><div layout=\"row\" flex><md-input-container class=\"md-block\" flex=\"30\"><label \ntranslate=\"CLIENTE.TIPO_CALCULO\"></label><input type=\"text\" name=\"tipoCalculo\" mascara-numero-generica=\"#########\" \nng-model=\"vm.cliente.clienteConfiguracao.tipoCalculo\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && \r\n                           !vm.controleForm.inserirAtivo\">\n</md-input-container><md-input-container class=\"md-block\" flex-offset=\"5\" flex=\"30\"><label \ntranslate=\"CLIENTE.TIPO_PROCESSO\"></label><input type=\"text\" name=\"tipoProcesso\" mascara-numero-generica=\"#\" \nng-model=\"vm.cliente.clienteConfiguracao.tipoProcesso\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && \r\n                           !vm.controleForm.inserirAtivo\">\n</md-input-container><md-input-container class=\"md-block\" flex-offset=\"5\" flex=\"30\"><label \ntranslate=\"CLIENTE.TIPO_EMPRESA\"></label><input type=\"text\" name=\"tipoEmpresa\" mascara-numero-generica=\"#####\" \nng-model=\"vm.cliente.clienteConfiguracao.tipoEmpresa\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && \r\n                           !vm.controleForm.inserirAtivo\">\n</md-input-container></div></fieldset></div><div layout-gt-xs=\"row\" flex><fieldset class=\"standard\" flex=\"100\"><legend \nclass=\"grp-legend\" translate=\"CLIENTE.IMPRESSAO\"></legend><div layout=\"row\" flex><md-input-container class=\"md-block\" \nflex-gt-sm=\"20\"><label translate=\"CLIENTE.FORMULARIO_IMPRESSAO\"></label><md-select name=\"formularioImpressao\" \nng-model=\"vm.cliente.clienteConfiguracao.formularioImpressao\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && \r\n                               !vm.controleForm.inserirAtivo\">\n<md-option ng-value=\"key\" ng-repeat=\"(key, value) in vm.formulariosImpressao\">{{value}}</md-option></md-select>\n</md-input-container><md-input-container class=\"md-block\" flex-offset=\"5\" flex-gt-sm=\"20\"><label \ntranslate=\"CLIENTE.METODO_IMPRESSAO\"></label><md-select name=\"metodoImpressao\" \nng-model=\"vm.cliente.clienteConfiguracao.metodoImpressao\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && \r\n                               !vm.controleForm.inserirAtivo\">\n<md-option ng-value=\"key\" ng-repeat=\"(key, value) in vm.listarMetodosImpressao\">{{value}}</md-option></md-select>\n</md-input-container><md-input-container class=\"md-block\" flex-offset=\"5\" flex=\"20\"><label \ntranslate=\"CLIENTE.MODELO_IMPRESSAO\"></label><input type=\"text\" name=\"modeloImpressao\" mascara-numero-generica=\"###\" \nng-model=\"vm.cliente.clienteConfiguracao.modeloImpressao\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && \r\n                           !vm.controleForm.inserirAtivo\">\n</md-input-container><md-input-container class=\"md-block\" flex-offset=\"5\" flex=\"20\"><label translate=\"CLIENTE.DETALHE\">\n</label><input type=\"text\" name=\"detalhe\" mascara-numero-generica=\"###\" \nng-model=\"vm.cliente.clienteConfiguracao.detalhe\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && \r\n                           !vm.controleForm.inserirAtivo\">\n</md-input-container></div><div layout=\"row\" flex><md-input-container class=\"md-block\" flex-gt-sm=\"20\"><label \ntranslate=\"CLIENTE.TAMANHO_FORMULARIO\"></label><input type=\"text\" name=\"tamanhoFormulario\" \nmascara-numero-generica=\"####\" ng-model=\"vm.cliente.clienteConfiguracao.tamanhoFormulario\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && \r\n                           !vm.controleForm.inserirAtivo\">\n</md-input-container><md-input-container class=\"md-block\" flex-offset=\"5\" flex-gt-sm=\"20\"><label \ntranslate=\"CLIENTE.CONFIG\"></label><input type=\"text\" name=\"config\" mascara-tamanho-campo=\"10\" md-maxlength=\"10\" \nng-model=\"vm.cliente.clienteConfiguracao.config\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && \r\n                           !vm.controleForm.inserirAtivo\">\n</md-input-container></div></fieldset></div><div layout-gt-xs=\"row\" flex><fieldset class=\"standard\" flex=\"100\"><legend \nclass=\"grp-legend\" translate=\"CLIENTE.STRING_PARAMETRIZACAO\"></legend><div layout=\"row\"><md-input-container \nclass=\"md-block\" flex><label translate=\"CLIENTE.STRING_PARAMETRIZACAO\"></label><textarea name=\"stringParametrizacao\" \nrows=\"1\" max-rows=\"3\" md-no-resize=\"true\" ng-model=\"vm.cliente.clienteConfiguracao.stringParametrizacao\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && \r\n                          !vm.controleForm.inserirAtivo\">\n\r\n                              </textarea></md-input-container></div></fieldset></div><div layout-gt-xs=\"row\" flex>\n<fieldset class=\"standard\" flex=\"100\"><legend class=\"grp-legend\" translate=\"CLIENTE.SERVIDOR\"></legend><div \nlayout=\"row\" flex><md-input-container class=\"md-block\" flex=\"50\"><label translate=\"CLIENTE.SERVIDOR_INSTANCIA\"></label>\n<input type=\"text\" name=\"servidorInstancia\" mascara-tamanho-campo=\"100\" md-maxlength=\"100\" \nng-model=\"vm.cliente.clienteConfiguracao.servidorInstancia\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && \r\n                           !vm.controleForm.inserirAtivo\">\n</md-input-container><md-input-container class=\"md-block\" flex-offset=\"5\" flex=\"15\"><label \ntranslate=\"CLIENTE.USUARIO_INSTANCIA\"></label><input type=\"text\" name=\"usuarioInstancia\" mascara-tamanho-campo=\"20\" \nmd-maxlength=\"20\" ng-model=\"vm.cliente.clienteConfiguracao.usuarioInstancia\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && \r\n                           !vm.controleForm.inserirAtivo\">\n</md-input-container><md-input-container class=\"md-block\" flex-offset=\"5\" flex=\"15\"><label \ntranslate=\"CLIENTE.SENHA_INSTANCIA\"></label><input type=\"text\" name=\"senhaInstancia\" mascara-tamanho-campo=\"20\" \nmd-maxlength=\"20\" ng-model=\"vm.cliente.clienteConfiguracao.senhaInstancia\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && \r\n                           !vm.controleForm.inserirAtivo\">\n</md-input-container></div><div layout=\"row\" flex><md-input-container class=\"md-block\" flex><label \ntranslate=\"CLIENTE.DIRETORIO_BANCO_DE_DADOS\"></label><input type=\"text\" name=\"diretorioBancoDados\" \nmascara-tamanho-campo=\"100\" md-maxlength=\"100\" ng-model=\"vm.cliente.clienteConfiguracao.diretorioBancoDados\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && \r\n                           !vm.controleForm.inserirAtivo\">\n</md-input-container></div><div layout=\"row\" flex><md-input-container class=\"md-block\" flex=\"50\"><label \ntranslate=\"CLIENTE.SERVIDOR\"></label><input type=\"text\" name=\"servidor\" mascara-tamanho-campo=\"100\" md-maxlength=\"100\" \nng-model=\"vm.cliente.clienteConfiguracao.servidor\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && \r\n                           !vm.controleForm.inserirAtivo\">\n</md-input-container><md-input-container class=\"md-block\" flex-offset=\"5\" flex=\"15\"><label \ntranslate=\"CLIENTE.NOME_USUARIO_SERVIDOR\"></label><input type=\"text\" name=\"nomeUsuarioServidor\" \nmascara-tamanho-campo=\"20\" md-maxlength=\"20\" ng-model=\"vm.cliente.clienteConfiguracao.nomeUsuarioServidor\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && \r\n                           !vm.controleForm.inserirAtivo\">\n</md-input-container><md-input-container class=\"md-block\" flex-offset=\"5\" flex=\"15\"><label \ntranslate=\"CLIENTE.SENHA_USUARIO_SERVIDOR\"></label><input type=\"text\" name=\"senhaUsuarioServidor\" \nmascara-tamanho-campo=\"20\" md-maxlength=\"20\" ng-model=\"vm.cliente.clienteConfiguracao.senhaUsuarioServidor\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && \r\n                           !vm.controleForm.inserirAtivo\">\n</md-input-container></div></fieldset></div><div layout-gt-xs=\"row\" flex><fieldset class=\"standard\" flex=\"100\"><legend \nclass=\"grp-legend\" translate=\"CLIENTE.INFORMACOES_ADICIONAIS\"></legend><div layout=\"row\" flex \nstyle=\"justify-content: space-between\"><md-input-container class=\"md-block\"><md-checkbox \naria-label=\"Utilizar marca especial\" name=\"utilizarMarcaEspecial\" \nng-model=\"vm.cliente.clienteConfiguracao.utilizaMarcaEspecial\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && \r\n                                 !vm.controleForm.inserirAtivo\">\n<span class=\"float-label-cor-default\" translate=\"CLIENTE.UTILIZAR_MARCA_ESPECIAL\"></span></md-checkbox>\n</md-input-container><md-input-container class=\"md-block\"><md-checkbox aria-label=\"Utilizar fotos\" \nname=\"utilizarFotos\" ng-model=\"vm.cliente.clienteConfiguracao.utilizaFotos\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && \r\n                                 !vm.controleForm.inserirAtivo\">\n<span class=\"float-label-cor-default\" translate=\"CLIENTE.UTILIZAR_FOTOS\"></span></md-checkbox></md-input-container>\n<md-input-container class=\"md-block\"><md-checkbox aria-label=\"Utilizar recadastramento\" name=\"utilizarRecadastramento\" \nng-model=\"vm.cliente.clienteConfiguracao.utilizaRecadastramento\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && \r\n                                 !vm.controleForm.inserirAtivo\">\n<span class=\"float-label-cor-default\" translate=\"CLIENTE.UTILIZAR_RECADASTRAMENTO\"></span></md-checkbox>\n</md-input-container><md-input-container class=\"md-block\"><md-checkbox aria-label=\"Utilizar importação online\" \nname=\"utilizarImportacaoOnline\" ng-model=\"vm.cliente.clienteConfiguracao.utilizaImportacaoOnline\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && \r\n                                 !vm.controleForm.inserirAtivo\">\n<span class=\"float-label-cor-default\" translate=\"CLIENTE.UTILIZAR_IMPORTACAO_ONLINE\"></span></md-checkbox>\n</md-input-container><md-input-container class=\"md-block\"><md-checkbox aria-label=\"Utilizar comunicado de débito\" \nname=\"UtilizarComunicadoDeDebito\" ng-model=\"vm.cliente.clienteConfiguracao.utilizaComunicadoDeDebito\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && \r\n                                 !vm.controleForm.inserirAtivo\">\n<span class=\"float-label-cor-default\" translate=\"CLIENTE.UTILIZAR_COMUNICADO_DEBITO\"></span></md-checkbox>\n</md-input-container></div><div layout=\"row\" flex style=\"justify-content: space-between\"><md-input-container \nclass=\"md-block\"><md-checkbox aria-label=\"Utilizar comunicado de quitação anual\" \nname=\"utilizarComunicadoDeQuitacaoAnual\" ng-model=\"vm.cliente.clienteConfiguracao.utilizaComunicadoDeQuitacaoAnual\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo &&\r\n                                 !vm.controleForm.inserirAtivo\">\n<span class=\"float-label-cor-default\" translate=\"CLIENTE.UTILIZAR_COMUNIDADE_QUITACAO_ANUAL\"></span></md-checkbox>\n</md-input-container><md-input-container class=\"md-block\"><md-checkbox aria-label=\"Utilizar comunicado de ocorrência\" \nname=\"utilizarComunicadoDeOcorrencia\" ng-model=\"vm.cliente.clienteConfiguracao.utilizaComunicadoDeOcorrencia\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && \r\n                                 !vm.controleForm.inserirAtivo\">\n<span class=\"float-label-cor-default\" translate=\"CLIENTE.UTILIZAR_COMUNICADO_OCORRENCIA\"></span></md-checkbox>\n</md-input-container><md-input-container class=\"md-block\"><md-checkbox aria-label=\"Utilizar comunicado de ocorrência\" \nname=\"utilizarComunicadoAlternativo\" ng-model=\"vm.cliente.clienteConfiguracao.utilizaComunicadoAlternativo\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && \r\n                                 !vm.controleForm.inserirAtivo\">\n<span class=\"float-label-cor-default\" translate=\"CLIENTE.UTILIZAR_COMUNICADO_ALTERNATIVO\"></span></md-checkbox>\n</md-input-container><md-input-container class=\"md-block\"><md-checkbox \naria-label=\"Utilizar Comunicado de consumo alterado\" name=\"utilizarComunicadoConsumoAlterado\" \nng-model=\"vm.cliente.clienteConfiguracao.utilizaComunicadoConsumoAlterado\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && \r\n                                 !vm.controleForm.inserirAtivo\">\n<span class=\"float-label-cor-default\" translate=\"CLIENTE.UTILIZAR_COMUNICADO_CONSUMO_ALTERADO\"></span></md-checkbox>\n</md-input-container></div><div layout=\"row\"><md-input-container class=\"md-block\"><md-checkbox \naria-label=\"Enviar certidões em anexo\" name=\"enviarCertidoesEmAnexo\" \nng-model=\"vm.cliente.clienteConfiguracao.enviaCertidoesEmAnexo\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && \r\n                                 !vm.controleForm.inserirAtivo\">\n<span class=\"float-label-cor-default\" translate=\"CLIENTE.ENVIAR_CERTIDOES_EM_ANEXO\"></span></md-checkbox>\n</md-input-container><md-input-container class=\"md-block\" flex-offset=\"5\"><md-checkbox \naria-label=\"Utilizar comunicado de cobrança avulsa\" name=\"utilizarComunicadoCobrancaAvulsa\" \nng-model=\"vm.cliente.clienteConfiguracao.configReaderUtilizaComunicadoServicosCobrancaAvulsa \" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && \r\n                                 !vm.controleForm.inserirAtivo\">\n<span class=\"float-label-cor-default\" translate=\"CLIENTE.UTILIZAR_COMUNICADO_COBRANCA_AVULSA\"></span></md-checkbox>\n</md-input-container></div></fieldset></div></md-content>");
$templateCache.put("app/main/geral/cadastro/cliente/cliente/views/tabs/equipamentos/dialogs/detalhes-equipamento-dialog/cliente-equipamento-detalhes.html","<md-dialog id=\"cliente-equipamento-detalhes\" class=\"dialogo-padrao\" aria-label=\"Dialog\"><form name=\"vm.form\" \nclass=\"md-inline-form\" novalidate><md-toolbar class=\"md-accent md-tall\" layout=\"column\"><div \nclass=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\">\n{{vm.titulo}}</span><md-button class=\"md-icon-button\" ng-click=\"vm.metodosDialog.fecharDialog()\" \naria-label=\"Fechar dialog\" translate translate-attr-aria-label=\"SPRINT.FECHAR_DIALOG\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><div layout=\"column\" layout-align=\"center center\" \nng-show=\"vm.requisicaoSolicitada || vm.preloader.habilitar\"><span class=\"font-weight-500\">\n{{vm.preloader.habilitar ? vm.preloader.mensagem : vm.mensagemPreloader}}</span><md-progress-circular \nmd-mode=\"indeterminate\" md-diameter=\"30\" class=\"md-accent\"></md-progress-circular></div><md-dialog-content><div \nlayout=\"row\" style=\"align-items: center; height: 50px\"><md-input-container class=\"md-block\" flex=\"20\"><label \ntranslate=\"CLIENTE.NUMERO_LICENCA\"></label><input type=\"text\" ng-model=\"vm.clienteEquipamentoDetalhe.numeroLicenca\" \nname=\"licenca\" mascara-numero-generica=\"########\" ng-disabled=\"vm.requisicaoSolicitada\" required></md-input-container>\n<md-input-container class=\"md-block\" flex=\"25\"><label translate=\"CLIENTE.NUMERO_SERIE\"></label><input type=\"text\" \nng-model=\"vm.clienteEquipamentoDetalhe.numeroSerie\" name=\"serie\" mascara-tamanho-campo=\"15\" \nng-disabled=\"vm.requisicaoSolicitada\" required></md-input-container><md-input-container class=\"md-block\" flex=\"25\">\n<label translate=\"CLIENTE.NUMERO_IMEI\"></label><input type=\"text\" ng-model=\"vm.clienteEquipamentoDetalhe.numeroImei\" \nname=\"imei\" mascara-tamanho-campo=\"15\" ng-disabled=\"vm.requisicaoSolicitada\"></md-input-container><md-button \ntype=\"submit\" ng-click=\"vm.metodosDialog.salvar($event, vm.clienteEquipamentoDetalhe)\" \nclass=\"send-button md-accent md-raised\" aria-label=\"SALVAR\" translate=\"ESTORIA.SALVAR\" \ntranslate-attr-aria-label=\"CLIENTE.SALVAR\" \nng-disabled=\"vm.form.$invalid || vm.form.$pristine || vm.requisicaoSolicitada || vm.clienteEquipamentoDetalhe == null\">\nSalvar</md-button></div><div style=\"height: 0px\"><p>Total: {{vm.equipamentosDetalhes.length}}</p></div>\n</md-dialog-content></form><div layout=\"row\" flex><div layout=\"column\" flex-offset=\"20\" layout-align=\"center center\" \nng-if=\"vm.pesquisandoDetalhesEquipamento\"><span class=\"font-weight-500\">Pesquisando detalhes ...</span>\n<md-progress-circular md-mode=\"indeterminate\" md-diameter=\"30\" class=\"md-accent\"></md-progress-circular></div><div \nclass=\"md-background-bg md-whiteframe-1dp tabela\" ng-if=\"!vm.pesquisandoDetalhesEquipamento\" style=\"height: 42vh\" flex>\n<table class=\"dataTable row-border compact hover\" datatable=\"ng\" dt-options=\"vm.dtOptionsClienteEquipamentosDetalhes\" \nwidth=\"95%\"><thead><tr><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Ação</span>\n</div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">N° Série</span></div></th>\n<th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">N° Licença</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">N° IMEI</span></div></th></tr></thead>\n<tbody><tr ng-repeat=\"detalheEquipamento in vm.equipamentosDetalhes\"><td class=\"button-icone-cor-azul\"><i \nclass=\"icon-pencil s16 icone-cor-padrao mr-10\" ng-disabled=\"vm.controleForm.emProgresso\" \nng-click=\"vm.controleForm.emProgresso\r\n                                               || vm.metodosDialog.editar($event, detalheEquipamento)\">\n</i> <i class=\"icon-delete s16 icone-cor-padrao\" ng-disabled=\"vm.controleForm.emProgresso\" \nng-click=\"vm.controleForm.emProgresso\r\n                                               || vm.metodosDialog.excluir($event, detalheEquipamento)\">\n</i></td><td>{{detalheEquipamento.numeroSerie}}</td><td>{{detalheEquipamento.numeroLicenca}}</td><td>\n{{detalheEquipamento.numeroImei}}</td></tr></tbody></table></div></div></md-dialog>");
$templateCache.put("app/main/geral/cadastro/cliente/cliente/views/tabs/equipamentos/dialogs/equipamento-dialog/cliente-equipamento-dialog.html","<md-dialog id=\"cliente-equipamento-dialog\" class=\"dialogo-padrao\" aria-label=\"Dialog\"><form name=\"vm.form\" \nclass=\"md-inline-form\" novalidate><md-toolbar class=\"md-accent md-tall\" layout=\"column\"><div \nclass=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\">\n{{vm.titulo}}</span><md-button class=\"md-icon-button\" ng-click=\"vm.metodosDialog.fecharDialog()\" \naria-label=\"Fechar dialog\" translate translate-attr-aria-label=\"SPRINT.FECHAR_DIALOG\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><div layout=\"column\" layout-align=\"center center\" \nng-show=\"vm.requisicaoSolicitada || (vm.prealoder && vm.preloader.habilitar)\"><span class=\"font-weight-500\">\n{{vm.preloader.habilitar ? vm.preloader.mensagem : vm.mensagemPreloader}}</span><md-progress-circular \nmd-mode=\"indeterminate\" md-diameter=\"30\" class=\"md-accent\"></md-progress-circular></div><md-dialog-content><div \nlayout=\"row\" flex><md-input-container class=\"md-block\" flex=\"30\"><label translate=\"CLIENTE.EQUIPAMENTO\">Equipamento\n</label><md-select ng-model=\"vm.clienteEquipamento.codigoEquipamento\" name=\"equipamento\" \nmd-on-open=\"vm.metodosDialog.configuraMdSelectEquipamento()\" ng-required=\"true\" \nng-disabled=\"vm.requisicaoSolicitada || vm.editandoEquip\"><md-select-header><input \nid=\"dialog-cliente-equipamento-equipamento-md-select\" class=\"md-text\" ng-model=\"vm.filtrarEquipamentos\" type=\"search\" \nplaceholder=\"\" translate translate-attr-placeholder=\"CLIENTE.PESQUISAR_EQUIPAMENTO\"></md-select-header><md-option \nng-value=\"equipamento.id\" \nng-repeat=\"equipamento in vm.equipamentos | filter:vm.filtrarEquipamentos track by equipamento.id\">\n{{equipamento.descricao}}</md-option></md-select><div ng-messages=\"vm.form.equipamento.$error\"><div \nng-message=\"required\" translate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container>\n<md-input-container class=\"md-block\" flex=\"30\"><label translate=\"CLIENTE.QUANTIDADE_EQUIPAMENTOS\"></label><input \ntype=\"text\" ng-model=\"vm.clienteEquipamento.quantidadeEquipamentos\" name=\"quantidadeEquipamentos\" \nmascara-numero-generica=\"#####\" ng-required=\"true\" ng-disabled=\"vm.requisicaoSolicitada\"><div \nng-messages=\"vm.form.quantidadeEquipamentos.$error\"><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container></div></md-dialog-content>\n<md-dialog-actions layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\" \nng-show=\"!vm.editandoEquip\"><md-button type=\"submit\" ng-click=\"vm.metodosDialog.salvar($event, vm.clienteEquipamento)\" \nclass=\"send-button md-accent md-raised\" aria-label=\"SALVAR\" translate=\"ESTORIA.SALVAR\" \ntranslate-attr-aria-label=\"CLIENTE.SALVAR\" \nng-disabled=\"vm.form.$invalid || vm.form.$pristine || vm.requisicaoSolicitada\">Salvar</md-button></div><div \nlayout=\"row\" layout-align=\"start center\" ng-show=\"vm.editandoEquip\"><md-button type=\"submit\" \nng-click=\"vm.metodosDialog.salvar($event, vm.clienteEquipamento)\" class=\"send-button md-accent md-raised\" \naria-label=\"SALVAR\" translate=\"ESTORIA.SALVAR\" translate-attr-aria-label=\"CLIENTE.SALVAR\" \nng-disabled=\"vm.form.$invalid || vm.form.$pristine || vm.requisicaoSolicitada\">Editar</md-button></div>\n</md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/geral/cadastro/usuario/usuario/views/tabs/usuario/dialogs/senha-usuario/senha-usuario.html","<md-dialog id=\"dialog-alteracao-senha\" class=\"dialogo-padrao dialog-senha\" aria-label=\"Dialog\"><form \nname=\"alteracaoSenhaForm\" class=\"md-inline-form\" novalidate><md-toolbar class=\"md-accent md-tall\" layout=\"column\"><div \nclass=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\">\n{{vm.titulo}}</span><md-button class=\"md-icon-button\" ng-click=\"vm.metodosDialog.fecharDialog()\" \naria-label=\"Fechar dialog\" translate translate-attr-aria-label=\"COLABORADOR.FECHAR_DIALOG\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll><div \nlayout-gt-xs=\"row\" layout-align=\"center center\"><md-input-container class=\"md-block\"><label \ntranslate=\"COLABORADOR.SENHA_NOVA\"></label><input type=\"password\" ng-model=\"vm.senhaNova\" mascara-tamanho-campo=\"32\" \nng-required=\"true\" ng-disabled=\"vm.emProgresso\" md-maxlength=\"32\"></md-input-container></div><div layout-gt-xs=\"row\" \nlayout-align=\"center center\"><md-input-container class=\"md-block\"><label translate=\"COLABORADOR.CONFIRM_SENHA\"></label>\n<input type=\"password\" ng-model=\"vm.confirmacaoSenhaNova\" name=\"confirmacaoSenhaNova\" ng-disabled=\"vm.emProgresso\" \nmascara-tamanho-campo=\"32\" ng-required=\"true\" md-maxlength=\"32\"></md-input-container></div><div layout=\"row\" \nlayout-align=\"center center\" class=\"erroSenha\" ng-if=\"(vm.senhaNova != vm.confirmacaoSenhaNova)\">\nAs senhas devem ser iguais.</div><div layout-gt-xs=\"row\" layout-align=\"center center\"><md-progress-circular \nid=\"toolbar-progress\" ng-if=\"vm.emProgresso\" class=\"md-accent\" md-mode=\"indeterminate\" md-diameter=\"32\">\n</md-progress-circular><md-button class=\"md-raised md-accent\" ng-if=\"!vm.emProgresso\" \nng-click=\"vm.metodosDialog.salvar();\" \nng-disabled=\"alteracaoSenhaForm.$invalid || (vm.senhaNova != vm.confirmacaoSenhaNova)\" flex><span>Salvar</span>\n</md-button></div></md-dialog-content></form></md-dialog>");
$templateCache.put("app/main/pesquisa/processamento/pesquisa/views/tabs/respostas/components/dialogs/repostas-clientes-dialog/repostas-clientes-dialog.html","<md-dialog id=\"repostas-clientes-dialog\" aria-label=\"Dialog\" style=\"width: 50%\"><form class=\"md-inline-form\" \nname=\"vm.form.dialogRepostasClientes\" novalidate><md-toolbar style=\"height: 65px; min-height: 65px; max-height: 65px\" \nclass=\"md-accent md-tall\" layout=\"column\"><div class=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" \nlayout-align=\"space-between center\"><span class=\"title\" layout=\"row\">{{vm.cliente.codigo}} - {{vm.cliente.nome}}</span>\n<md-button class=\"md-icon-button\" aria-label=\"Fechar dialog\" ng-click=\"vm.metodos.fecharDialog()\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content \nstyle=\"padding: 0px; height: auto; min-height: 300px; max-height:500px; display: flex; flex-direction: column\"><div \nclass=\"navegacao-perguntas\" layout=\"row\" layout-align=\"space-between center\" \nstyle=\"padding: 15px; background: white; border-bottom: 1px solid #e0e0e0; flex-shrink: 0\"><md-button \nclass=\"md-icon-button\" ng-click=\"vm.metodos.perguntaAnterior()\" ng-disabled=\"vm.perguntaAtual === 0\"><md-icon \nmd-font-icon=\"icon-chevron-left\"></md-icon><md-tooltip><label>{{vm.perguntaAtual === 0 ? \'\' : \'Pergunta anterior\'}}\n</label></md-tooltip></md-button><div flex layout=\"column\" layout-align=\"center center\"><h2 \nstyle=\"margin: 0; text-align: center\">{{vm.perguntaAtualData.pergunta}}</h2><span class=\"md-caption\" \nstyle=\"margin-top: 5px\">Pergunta {{vm.perguntaAtual + 1}} de {{vm.repostas.length}}</span></div><md-button \nclass=\"md-icon-button\" ng-click=\"vm.metodos.proximaPergunta()\" \nng-disabled=\"vm.perguntaAtual === vm.repostas.length - 1\"><md-tooltip><label>\n{{vm.perguntaAtual === vm.repostas.length - 1 ? \'\' : \'Próxima pergunta\'}}</label></md-tooltip><md-icon \nmd-font-icon=\"icon-chevron-right\"></md-icon></md-button></div><div class=\"conteudo-scrollable\" \nstyle=\"flex: 1; overflow-y: auto; padding: 20px\"><div ng-if=\"!vm.perguntaAtualData.perguntaAberta\"><div \nclass=\"tabela-respostas-clientes\"><table class=\"dataTable row-border hover\" style=\"border-bottom: none\"><thead><tr><th \nclass=\"secondary-text border-left\" style=\"background-color: #f5f5f5\"><div class=\"table-header\"><span \nclass=\"column-title\">Usuário</span></div></th><th class=\"secondary-text border-left ultima-coluna\" \nstyle=\"background-color: #f5f5f5; text-align: center; padding: 12px; width: 80px\"><div class=\"table-header\"><span \nclass=\"column-title\">Nota</span></div></th></tr></thead><tbody><tr \nng-repeat=\"usuario in vm.perguntaAtualData.usuarios track by $index\"><td class=\"border-left\">\n{{usuario.codigo}} - {{usuario.usuario}}</td><td class=\"border-left ultima-coluna\" \nstyle=\"text-align: center; padding: 8px\">{{usuario.respostaFechada}}</td></tr></tbody></table></div></div><div \nng-if=\"vm.perguntaAtualData.perguntaAberta\" style=\"margin-top: -10px\"><div layout=\"column\"><md-card \nng-repeat=\"usuario in vm.perguntaAtualData.usuarios\" style=\"margin-bottom: 5px; background-color: #f5f5f5\">\n<md-card-header style=\"background-color: #f5f5f5; margin-bottom: -20px\"><md-card-header-text><span class=\"md-title\">\n{{usuario.codigo}} - {{usuario.usuario}}</span></md-card-header-text></md-card-header><md-card-content><p>\n{{usuario.respostaAberta}}</p></md-card-content></md-card></div></div></div></md-dialog-content></form></md-dialog>");
$templateCache.put("app/main/pesquisa/processamento/pesquisa/views/tabs/respostas/components/dialogs/repostas-grafico-dialog/repostas-grafico-dialog.html","<md-dialog id=\"repostas-clientes-grafico-dialog\" aria-label=\"Dialog\" style=\"width: 50%\"><form class=\"md-inline-form\" \nname=\"vm.form.dialogRepostasClientesGrafico\" novalidate><md-toolbar \nstyle=\"height: 65px; min-height: 65px; max-height: 65px\" class=\"md-accent md-tall\" layout=\"column\"><div \nclass=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\" \nlayout=\"row\">Perguntas fechadas</span><md-button class=\"md-icon-button\" aria-label=\"Fechar dialog\" \nng-click=\"vm.metodos.fecharDialog()\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar>\n<md-progress-linear ng-show=\"vm.emProgresso\" md-mode=\"indeterminate\" class=\"md-accent\"></md-progress-linear>\n<md-dialog-content \nstyle=\"padding: 0px; height: auto; min-height: 300px; max-height:500px; display: flex; flex-direction: column\"><div \nclass=\"navegacao-perguntas\" layout=\"row\" layout-align=\"space-between center\" \nstyle=\"padding: 15px; background: white; border-bottom: 1px solid #e0e0e0; flex-shrink: 0\"><md-button \nclass=\"md-icon-button\" ng-click=\"vm.metodos.perguntaAnterior()\" ng-disabled=\"vm.perguntaAtual === 0 || vm.emProgresso\">\n<md-icon md-font-icon=\"icon-chevron-left\"></md-icon><md-tooltip><label>\n{{vm.perguntaAtual === 0 || vm.emProgresso ? \'\' : \'Pergunta anterior\'}}</label></md-tooltip></md-button><div flex \nlayout=\"column\" layout-align=\"center center\"><h2 style=\"margin: 0; text-align: center\">\n{{vm.perguntaAtualData.pergunta}}</h2><span class=\"md-caption\" style=\"margin-top: 5px\">\nPergunta {{vm.perguntaAtual + 1}} de {{vm.perguntasFechadas.length}}</span></div><md-button class=\"md-icon-button\" \nng-click=\"vm.metodos.proximaPergunta()\" \nng-disabled=\"vm.perguntaAtual === vm.perguntasFechadas.length - 1 || vm.emProgresso\"><md-tooltip><label>\n{{ vm.perguntaAtual === vm.perguntasFechadas.length - 1 || vm.emProgresso ? \'\' : \'Próxima pergunta\' }}</label>\n</md-tooltip><md-icon md-font-icon=\"icon-chevron-right\"></md-icon></md-button></div><div class=\"conteudo-scrollable\" \nstyle=\"flex: 1; overflow-y: auto; padding: 20px\"><div class=\"tabela-respostas-clientes-graficos\"><table \nclass=\"dataTable row-border hover\" style=\"border-bottom: none; width: 100%\"><thead><tr><th \nclass=\"secondary-text border-left\" style=\"background-color: #f5f5f5; text-align: center; padding: 12px; width: 70px\">\n<div class=\"table-header\"><span class=\"column-title\">Código</span></div></th><th class=\"secondary-text border-left\" \nstyle=\"background-color: #f5f5f5; padding-left: 10px\"><div class=\"table-header\"><span class=\"column-title\">Nome</span>\n</div></th><th class=\"secondary-text border-left ultima-coluna\" \nstyle=\"background-color: #f5f5f5; text-align: center; padding: 12px; width: 80px\"><div class=\"table-header\"><span \nclass=\"column-title\">Nota</span></div></th></tr></thead><tbody><tr \nng-repeat=\"cliente in vm.perguntaAtualData.clientes track by $index\"><td class=\"border-left\" \nstyle=\"text-align: center; padding: 8px\">{{cliente.codigo}}</td><td class=\"border-left\">{{cliente.nome}}</td><td \nclass=\"border-left ultima-coluna\" style=\"text-align: center; padding: 8px\">\n{{ (cliente.nota > 0) ? cliente.nota : \'-\' }}</td></tr><tr \nng-if=\"!vm.perguntaAtualData.clientes || vm.perguntaAtualData.clientes.length === 0\"><td colspan=\"3\" \nstyle=\"text-align: center; color: #888\">Nenhuma resposta encontrada.</td></tr></tbody></table></div></div>\n</md-dialog-content></form></md-dialog>");
$templateCache.put("app/main/planejamento-scrum/processamento/sprint/views/tabs/meta/dialogs/acompanhamento-meta-dialog/dialog-desenvolvedores/dialog-pontos-desenvolvedor.html","<md-dialog id=\"sprint-pontos-desenvolvedores-dialog\" class=\"dialogTable\" aria-label=\"Dialog\"><md-toolbar \nclass=\"md-accent md-tall toolbar-pontos-desenvolvedor\" flex><div \nclass=\"md-toolbar-tools md-toolbar-tools-top container-header\" layout-gt-xs=\"row\" layout=\"row\" \nlayout-align=\"space-between center\"><span class=\"title\">Pontos por desenvolvedor</span><md-button \nclass=\"md-icon-button\" aria-label=\"Fechar dialog\" ng-click=\"vm.metodosDialog.fecharDialog()\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content \nclass=\"dialog-pontos-desenvolvedor\"><div class=\"tabela-pontos-desenvolvedor\"><table \nid=\"datatable-pontos-desenvolvedor\" class=\"dataTable row-border hover\" datatable=\"ng\" dt-options=\"vm.dtOptions\" \nwidth=\"100%\"><thead><tr><th class=\"secondary-text border-right border-left\"><div class=\"table-header\"><span \nclass=\"column-title itens-tabela\">Colaborador</span></div></th><th class=\"secondary-text th-tabela\"><div \nclass=\"table-header\"><span class=\"column-title itens-tabela\">Pontos para desenvolver</span></div></th></tr></thead>\n<tbody><tr ng-repeat=\"colaborador in vm.totalizadoresPontosDesenvolvedor | orderBy:\'nomeDesenvolvedor\'\"><td \nclass=\"border-right border-left itens-tabela\">{{colaborador.nomeDesenvolvedor}}</td><td \nclass=\"border-right itens-tabela\">{{colaborador.totalPontos}}</td></tr></tbody></table></div></md-dialog-content>\n</md-dialog>");
$templateCache.put("app/main/geral/cadastro/cliente/cliente/views/tabs/cliente/dialogs/atendimento-dialog/tabs/atendimentos-em-aberto/cliente-dialog-atendimento-tab-atendimentos-em-aberto.html","<md-dialog-content layout=\"row\" flex><table class=\"dataTable row-border hover border\" datatable=\"ng\" \ndt-options=\"vm.dtOptions\" width=\"100%\"><thead><tr><th></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Código</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Ano</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Descrição</span></div></th></tr></thead><tbody><tr \nng-repeat=\"atendimento in vm.atendimentosClientesEmAberto\" \nng-click=\"vm.tipoAtendimento == 1 || vm.metodosDialog.selecionarAtendimento(atendimento, $index)\" \nng-class=\"{\'linha-selecionada\': $index == vm.indexAtendimentoSelecionado}\" ng-disabled=\"vm.tipoAtendimento == 1\"><td>\n<md-icon ng-style=\"{\'color\': \'rgb(3,155,229)\'}\" ng-if=\"$index == vm.indexAtendimentoSelecionado\" \nmd-font-icon=\"icon-chevron-right s22\"></md-icon></td><td>{{atendimento.codigo}}</td><td>{{atendimento.ano}}</td><td>\n{{vm.metodosDialog.retornarSubstringAssunto(atendimento.assunto)}}</td></tr></tbody></table></md-dialog-content>");
$templateCache.put("app/main/geral/cadastro/cliente/cliente/views/tabs/cliente/dialogs/atendimento-dialog/tabs/todos-atendimentos/cliente-dialog-atendimento-tab-todos-atendimentos.html","<md-dialog-content layout=\"row\" flex><table class=\"dataTable row-border hover border\" datatable=\"ng\" \ndt-options=\"vm.dtOptions\" width=\"100%\"><thead><tr><th></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Código</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Ano</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Status</span></div></th><th class=\"secondary-text\"><div class=\"table-header none\"><span \nclass=\"column-title\">Assunto</span></div></th></tr></thead><tbody><tr \nng-repeat=\"atendimento in vm.todosAtendimentosClientes\" \nng-click=\"vm.tipoAtendimento == 1 || vm.metodosDialog.selecionarAtendimento(atendimento, $index)\" \nng-class=\"{\'linha-selecionada\': $index == vm.indexAtendimentoSelecionado}\" ng-disabled=\"vm.tipoAtendimento == 1\"><td>\n<md-icon ng-style=\"{\'color\': \'rgb(3,155,229)\'}\" ng-if=\"$index == vm.indexAtendimentoSelecionado\" \nmd-font-icon=\"icon-chevron-right s22\"></md-icon></td><td>{{atendimento.codigo}}</td><td>{{atendimento.ano}}</td><td>\n{{vm.metodosDialog.retornarDescricaoDisplay(atendimento.status)}}</td><td>\n{{vm.metodosDialog.retornarSubstringAssunto(atendimento.assunto)}}</td></tr></tbody></table></md-dialog-content>");}]);